(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebb54"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebb54"] = parcelRequire;
}
parcelRequire.register("a58XM", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $757152ee82640ba0$export$ffb0004e005737fa; }, function (v) { return $757152ee82640ba0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $757152ee82640ba0$export$34b9dba7ce09269b; }, function (v) { return $757152ee82640ba0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $757152ee82640ba0$export$25062201e9e25d76; }, function (v) { return $757152ee82640ba0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $757152ee82640ba0$export$ffb0004e005737fa;
var $757152ee82640ba0$export$34b9dba7ce09269b;
var $757152ee82640ba0$export$25062201e9e25d76;
"use strict";

var $6cds3 = parcelRequire("6cds3");
var $757152ee82640ba0$var$k = Symbol.for("react.element"), $757152ee82640ba0$var$l = Symbol.for("react.fragment"), $757152ee82640ba0$var$m = Object.prototype.hasOwnProperty, $757152ee82640ba0$var$n = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $757152ee82640ba0$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $757152ee82640ba0$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$757152ee82640ba0$var$m.call(a, b) && !$757152ee82640ba0$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $757152ee82640ba0$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $757152ee82640ba0$var$n.current
    };
}
$757152ee82640ba0$export$ffb0004e005737fa = $757152ee82640ba0$var$l;
$757152ee82640ba0$export$34b9dba7ce09269b = $757152ee82640ba0$var$q;
$757152ee82640ba0$export$25062201e9e25d76 = $757152ee82640ba0$var$q;

});
parcelRequire.register("6cds3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gx6CV"));

});
parcelRequire.register("gx6CV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $c094de5bd35107a3$export$dca3b0875bd9a954; }, function (v) { return $c094de5bd35107a3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c094de5bd35107a3$export$16fa2f45be04daa8; }, function (v) { return $c094de5bd35107a3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c094de5bd35107a3$export$ffb0004e005737fa; }, function (v) { return $c094de5bd35107a3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $c094de5bd35107a3$export$e2c29f18771995cb; }, function (v) { return $c094de5bd35107a3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c094de5bd35107a3$export$221d75b3f55bb0bd; }, function (v) { return $c094de5bd35107a3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c094de5bd35107a3$export$5f8d39834fd61797; }, function (v) { return $c094de5bd35107a3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c094de5bd35107a3$export$74bf444e3cd11ea5; }, function (v) { return $c094de5bd35107a3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c094de5bd35107a3$export$ae55be85d98224ed; }, function (v) { return $c094de5bd35107a3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c094de5bd35107a3$export$e530037191fcd5d7; }, function (v) { return $c094de5bd35107a3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c094de5bd35107a3$export$fd42f52fd3ae1109; }, function (v) { return $c094de5bd35107a3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c094de5bd35107a3$export$c8a8987d4410bf2d; }, function (v) { return $c094de5bd35107a3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c094de5bd35107a3$export$d38cd72104c1f0e9; }, function (v) { return $c094de5bd35107a3$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c094de5bd35107a3$export$7d1e3a5e95ceca43; }, function (v) { return $c094de5bd35107a3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c094de5bd35107a3$export$257a8862b851cb5b; }, function (v) { return $c094de5bd35107a3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c094de5bd35107a3$export$a8257692ac88316c; }, function (v) { return $c094de5bd35107a3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c094de5bd35107a3$export$488013bae63b21da; }, function (v) { return $c094de5bd35107a3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c094de5bd35107a3$export$7c73462e0d25e514; }, function (v) { return $c094de5bd35107a3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $c094de5bd35107a3$export$7568632d0d33d16d; }, function (v) { return $c094de5bd35107a3$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $c094de5bd35107a3$export$88948ce120ea2619; }, function (v) { return $c094de5bd35107a3$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c094de5bd35107a3$export$35808ee640e87ca7; }, function (v) { return $c094de5bd35107a3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c094de5bd35107a3$export$fae74005e78b1a27; }, function (v) { return $c094de5bd35107a3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e; }, function (v) { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $c094de5bd35107a3$export$6a7bc4e911dc01cf; }, function (v) { return $c094de5bd35107a3$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $c094de5bd35107a3$export$6d9c69b0de29b591; }, function (v) { return $c094de5bd35107a3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $c094de5bd35107a3$export$f680877a34711e37; }, function (v) { return $c094de5bd35107a3$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c094de5bd35107a3$export$d5a552a76deda3c2; }, function (v) { return $c094de5bd35107a3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $c094de5bd35107a3$export$aaabe4eda9ed9969; }, function (v) { return $c094de5bd35107a3$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c094de5bd35107a3$export$e5c5a5f917a5871c; }, function (v) { return $c094de5bd35107a3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c094de5bd35107a3$export$1538c33de8887b59; }, function (v) { return $c094de5bd35107a3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c094de5bd35107a3$export$13e3392192263954; }, function (v) { return $c094de5bd35107a3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c094de5bd35107a3$export$b8f5890fc79d6aca; }, function (v) { return $c094de5bd35107a3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c094de5bd35107a3$export$60241385465d0a34; }, function (v) { return $c094de5bd35107a3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $c094de5bd35107a3$export$306c0aa65ff9ec16; }, function (v) { return $c094de5bd35107a3$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $c094de5bd35107a3$export$7b286972b8d8ccbf; }, function (v) { return $c094de5bd35107a3$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $c094de5bd35107a3$export$83d89fbfd8236492; }, function (v) { return $c094de5bd35107a3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $1ObTH = parcelRequire("1ObTH");
var $c094de5bd35107a3$export$dca3b0875bd9a954;
var $c094de5bd35107a3$export$16fa2f45be04daa8;
var $c094de5bd35107a3$export$ffb0004e005737fa;
var $c094de5bd35107a3$export$e2c29f18771995cb;
var $c094de5bd35107a3$export$221d75b3f55bb0bd;
var $c094de5bd35107a3$export$5f8d39834fd61797;
var $c094de5bd35107a3$export$74bf444e3cd11ea5;
var $c094de5bd35107a3$export$ae55be85d98224ed;
var $c094de5bd35107a3$export$e530037191fcd5d7;
var $c094de5bd35107a3$export$fd42f52fd3ae1109;
var $c094de5bd35107a3$export$c8a8987d4410bf2d;
var $c094de5bd35107a3$export$d38cd72104c1f0e9;
var $c094de5bd35107a3$export$7d1e3a5e95ceca43;
var $c094de5bd35107a3$export$257a8862b851cb5b;
var $c094de5bd35107a3$export$a8257692ac88316c;
var $c094de5bd35107a3$export$488013bae63b21da;
var $c094de5bd35107a3$export$7c73462e0d25e514;
var $c094de5bd35107a3$export$7568632d0d33d16d;
var $c094de5bd35107a3$export$88948ce120ea2619;
var $c094de5bd35107a3$export$35808ee640e87ca7;
var $c094de5bd35107a3$export$fae74005e78b1a27;
var $c094de5bd35107a3$export$dc8fbce3eb94dc1e;
var $c094de5bd35107a3$export$6a7bc4e911dc01cf;
var $c094de5bd35107a3$export$6d9c69b0de29b591;
var $c094de5bd35107a3$export$f680877a34711e37;
var $c094de5bd35107a3$export$d5a552a76deda3c2;
var $c094de5bd35107a3$export$aaabe4eda9ed9969;
var $c094de5bd35107a3$export$e5c5a5f917a5871c;
var $c094de5bd35107a3$export$1538c33de8887b59;
var $c094de5bd35107a3$export$13e3392192263954;
var $c094de5bd35107a3$export$b8f5890fc79d6aca;
var $c094de5bd35107a3$export$60241385465d0a34;
var $c094de5bd35107a3$export$306c0aa65ff9ec16;
var $c094de5bd35107a3$export$7b286972b8d8ccbf;
var $c094de5bd35107a3$export$83d89fbfd8236492;
"use strict";
var $c094de5bd35107a3$var$l = Symbol.for("react.element"), $c094de5bd35107a3$var$n = Symbol.for("react.portal"), $c094de5bd35107a3$var$p = Symbol.for("react.fragment"), $c094de5bd35107a3$var$q = Symbol.for("react.strict_mode"), $c094de5bd35107a3$var$r = Symbol.for("react.profiler"), $c094de5bd35107a3$var$t = Symbol.for("react.provider"), $c094de5bd35107a3$var$u = Symbol.for("react.context"), $c094de5bd35107a3$var$v = Symbol.for("react.forward_ref"), $c094de5bd35107a3$var$w = Symbol.for("react.suspense"), $c094de5bd35107a3$var$x = Symbol.for("react.memo"), $c094de5bd35107a3$var$y = Symbol.for("react.lazy"), $c094de5bd35107a3$var$z = Symbol.iterator;
function $c094de5bd35107a3$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c094de5bd35107a3$var$z && a[$c094de5bd35107a3$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c094de5bd35107a3$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $c094de5bd35107a3$var$C = Object.assign, $c094de5bd35107a3$var$D = {};
function $c094de5bd35107a3$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
$c094de5bd35107a3$var$E.prototype.isReactComponent = {};
$c094de5bd35107a3$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c094de5bd35107a3$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c094de5bd35107a3$var$F() {}
$c094de5bd35107a3$var$F.prototype = $c094de5bd35107a3$var$E.prototype;
function $c094de5bd35107a3$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
var $c094de5bd35107a3$var$H = $c094de5bd35107a3$var$G.prototype = new $c094de5bd35107a3$var$F;
$c094de5bd35107a3$var$H.constructor = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$var$C($c094de5bd35107a3$var$H, $c094de5bd35107a3$var$E.prototype);
$c094de5bd35107a3$var$H.isPureReactComponent = !0;
var $c094de5bd35107a3$var$I = Array.isArray, $c094de5bd35107a3$var$J = Object.prototype.hasOwnProperty, $c094de5bd35107a3$var$K = {
    current: null
}, $c094de5bd35107a3$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c094de5bd35107a3$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c094de5bd35107a3$var$J.call(b, d) && !$c094de5bd35107a3$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c094de5bd35107a3$var$K.current
    };
}
function $c094de5bd35107a3$var$N(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c094de5bd35107a3$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c094de5bd35107a3$var$l;
}
function $c094de5bd35107a3$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c094de5bd35107a3$var$P = /\/+/g;
function $c094de5bd35107a3$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c094de5bd35107a3$var$escape("" + a.key) : b.toString(36);
}
function $c094de5bd35107a3$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $1ObTH._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c094de5bd35107a3$var$l:
                case $c094de5bd35107a3$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c094de5bd35107a3$var$Q(h, 0) : d, $c094de5bd35107a3$var$I(c) ? (e = "", null != a && (e = a.replace($c094de5bd35107a3$var$P, "$&/") + "/"), $c094de5bd35107a3$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c094de5bd35107a3$var$O(c) && (c = $c094de5bd35107a3$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c094de5bd35107a3$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c094de5bd35107a3$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c094de5bd35107a3$var$Q(k, g);
        h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    }
    else if (f = $c094de5bd35107a3$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c094de5bd35107a3$var$Q(k, g++), h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c094de5bd35107a3$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c094de5bd35107a3$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c094de5bd35107a3$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c094de5bd35107a3$var$U = {
    current: null
}, $c094de5bd35107a3$var$V = {
    transition: null
}, $c094de5bd35107a3$var$W = {
    ReactCurrentDispatcher: $c094de5bd35107a3$var$U,
    ReactCurrentBatchConfig: $c094de5bd35107a3$var$V,
    ReactCurrentOwner: $c094de5bd35107a3$var$K
};
$c094de5bd35107a3$export$dca3b0875bd9a954 = {
    map: $c094de5bd35107a3$var$S,
    forEach: function forEach(a, b, e) {
        $c094de5bd35107a3$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $c094de5bd35107a3$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $c094de5bd35107a3$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$c094de5bd35107a3$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c094de5bd35107a3$export$16fa2f45be04daa8 = $c094de5bd35107a3$var$E;
$c094de5bd35107a3$export$ffb0004e005737fa = $c094de5bd35107a3$var$p;
$c094de5bd35107a3$export$e2c29f18771995cb = $c094de5bd35107a3$var$r;
$c094de5bd35107a3$export$221d75b3f55bb0bd = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$export$5f8d39834fd61797 = $c094de5bd35107a3$var$q;
$c094de5bd35107a3$export$74bf444e3cd11ea5 = $c094de5bd35107a3$var$w;
$c094de5bd35107a3$export$ae55be85d98224ed = $c094de5bd35107a3$var$W;
$c094de5bd35107a3$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c094de5bd35107a3$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c094de5bd35107a3$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c094de5bd35107a3$var$J.call(b, f) && !$c094de5bd35107a3$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c094de5bd35107a3$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c094de5bd35107a3$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c094de5bd35107a3$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c094de5bd35107a3$export$c8a8987d4410bf2d = $c094de5bd35107a3$var$M;
$c094de5bd35107a3$export$d38cd72104c1f0e9 = function(a) {
    var b = $c094de5bd35107a3$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c094de5bd35107a3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c094de5bd35107a3$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$v,
        render: a
    };
};
$c094de5bd35107a3$export$a8257692ac88316c = $c094de5bd35107a3$var$O;
$c094de5bd35107a3$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c094de5bd35107a3$var$T
    };
};
$c094de5bd35107a3$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c094de5bd35107a3$export$7568632d0d33d16d = function(a) {
    var b = $c094de5bd35107a3$var$V.transition;
    $c094de5bd35107a3$var$V.transition = {};
    try {
        a();
    } finally{
        $c094de5bd35107a3$var$V.transition = b;
    }
};
$c094de5bd35107a3$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$c094de5bd35107a3$export$35808ee640e87ca7 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useCallback(a, b);
};
$c094de5bd35107a3$export$fae74005e78b1a27 = function(a) {
    return $c094de5bd35107a3$var$U.current.useContext(a);
};
$c094de5bd35107a3$export$dc8fbce3eb94dc1e = function() {};
$c094de5bd35107a3$export$6a7bc4e911dc01cf = function(a) {
    return $c094de5bd35107a3$var$U.current.useDeferredValue(a);
};
$c094de5bd35107a3$export$6d9c69b0de29b591 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useEffect(a, b);
};
$c094de5bd35107a3$export$f680877a34711e37 = function() {
    return $c094de5bd35107a3$var$U.current.useId();
};
$c094de5bd35107a3$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useImperativeHandle(a, b, e);
};
$c094de5bd35107a3$export$aaabe4eda9ed9969 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useInsertionEffect(a, b);
};
$c094de5bd35107a3$export$e5c5a5f917a5871c = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useLayoutEffect(a, b);
};
$c094de5bd35107a3$export$1538c33de8887b59 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useMemo(a, b);
};
$c094de5bd35107a3$export$13e3392192263954 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useReducer(a, b, e);
};
$c094de5bd35107a3$export$b8f5890fc79d6aca = function(a) {
    return $c094de5bd35107a3$var$U.current.useRef(a);
};
$c094de5bd35107a3$export$60241385465d0a34 = function(a) {
    return $c094de5bd35107a3$var$U.current.useState(a);
};
$c094de5bd35107a3$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useSyncExternalStore(a, b, e);
};
$c094de5bd35107a3$export$7b286972b8d8ccbf = function() {
    return $c094de5bd35107a3$var$U.current.useTransition();
};
$c094de5bd35107a3$export$83d89fbfd8236492 = "18.2.0";

});
parcelRequire.register("1ObTH", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $1513b08bb76c1101$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $1513b08bb76c1101$export$5f0017c582d45a2d; });
function $1513b08bb76c1101$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});




parcelRequire.register("jZA9I", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed; }, function (v) { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389; }, function (v) { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $e8dfc29dafb3bbd7$export$882461b6382ed46c; }, function (v) { return $e8dfc29dafb3bbd7$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e8dfc29dafb3bbd7$export$466bfc07425424d5; }, function (v) { return $e8dfc29dafb3bbd7$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4; }, function (v) { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db; }, function (v) { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e; }, function (v) { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99; }, function (v) { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e8dfc29dafb3bbd7$export$502457920280e6be; }, function (v) { return $e8dfc29dafb3bbd7$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1; }, function (v) { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18; }, function (v) { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492; }, function (v) { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $1ObTH = parcelRequire("1ObTH");
var $e8dfc29dafb3bbd7$export$ae55be85d98224ed;
var $e8dfc29dafb3bbd7$export$d39a5bbd09211389;
var $e8dfc29dafb3bbd7$export$882461b6382ed46c;
var $e8dfc29dafb3bbd7$export$466bfc07425424d5;
var $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4;
var $e8dfc29dafb3bbd7$export$fa8d919ba61d84db;
var $e8dfc29dafb3bbd7$export$757ceba2d55c277e;
var $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99;
var $e8dfc29dafb3bbd7$export$502457920280e6be;
var $e8dfc29dafb3bbd7$export$c78a37762a8d58e1;
var $e8dfc29dafb3bbd7$export$dc54d992c10e8a18;
var $e8dfc29dafb3bbd7$export$83d89fbfd8236492;
"use strict";

var $6cds3 = parcelRequire("6cds3");

var $1c9zD = parcelRequire("1c9zD");
function $e8dfc29dafb3bbd7$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e8dfc29dafb3bbd7$var$da = new Set, $e8dfc29dafb3bbd7$var$ea = {};
function $e8dfc29dafb3bbd7$var$fa(a, b) {
    $e8dfc29dafb3bbd7$var$ha(a, b);
    $e8dfc29dafb3bbd7$var$ha(a + "Capture", b);
}
function $e8dfc29dafb3bbd7$var$ha(a, b) {
    $e8dfc29dafb3bbd7$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$da.add(b[a]);
}
var $e8dfc29dafb3bbd7$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e8dfc29dafb3bbd7$var$ja = Object.prototype.hasOwnProperty, $e8dfc29dafb3bbd7$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e8dfc29dafb3bbd7$var$la = {}, $e8dfc29dafb3bbd7$var$ma = {};
function $e8dfc29dafb3bbd7$var$oa(a) {
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$ma, a)) return !0;
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$la, a)) return !1;
    if ($e8dfc29dafb3bbd7$var$ka.test(a)) return $e8dfc29dafb3bbd7$var$ma[a] = !0;
    $e8dfc29dafb3bbd7$var$la[a] = !0;
    return !1;
}
function $e8dfc29dafb3bbd7$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $1ObTH._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e8dfc29dafb3bbd7$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e8dfc29dafb3bbd7$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e8dfc29dafb3bbd7$var$ra = /[\-:]([a-z])/g;
function $e8dfc29dafb3bbd7$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e8dfc29dafb3bbd7$var$z.xlinkHref = new $e8dfc29dafb3bbd7$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e8dfc29dafb3bbd7$var$ta(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$z.hasOwnProperty(b) ? $e8dfc29dafb3bbd7$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e8dfc29dafb3bbd7$var$qa(b, c, e, d) && (c = null), d || null === e ? $e8dfc29dafb3bbd7$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e8dfc29dafb3bbd7$var$ua = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e8dfc29dafb3bbd7$var$va = Symbol.for("react.element"), $e8dfc29dafb3bbd7$var$wa = Symbol.for("react.portal"), $e8dfc29dafb3bbd7$var$ya = Symbol.for("react.fragment"), $e8dfc29dafb3bbd7$var$za = Symbol.for("react.strict_mode"), $e8dfc29dafb3bbd7$var$Aa = Symbol.for("react.profiler"), $e8dfc29dafb3bbd7$var$Ba = Symbol.for("react.provider"), $e8dfc29dafb3bbd7$var$Ca = Symbol.for("react.context"), $e8dfc29dafb3bbd7$var$Da = Symbol.for("react.forward_ref"), $e8dfc29dafb3bbd7$var$Ea = Symbol.for("react.suspense"), $e8dfc29dafb3bbd7$var$Fa = Symbol.for("react.suspense_list"), $e8dfc29dafb3bbd7$var$Ga = Symbol.for("react.memo"), $e8dfc29dafb3bbd7$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e8dfc29dafb3bbd7$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e8dfc29dafb3bbd7$var$Ja = Symbol.iterator;
function $e8dfc29dafb3bbd7$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e8dfc29dafb3bbd7$var$Ja && a[$e8dfc29dafb3bbd7$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e8dfc29dafb3bbd7$var$A = Object.assign, $e8dfc29dafb3bbd7$var$La;
function $e8dfc29dafb3bbd7$var$Ma(a) {
    if (void 0 === $e8dfc29dafb3bbd7$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e8dfc29dafb3bbd7$var$La = b && b[1] || "";
    }
    return "\n" + $e8dfc29dafb3bbd7$var$La + a;
}
var $e8dfc29dafb3bbd7$var$Na = !1;
function $e8dfc29dafb3bbd7$var$Oa(a, b) {
    if (!a || $e8dfc29dafb3bbd7$var$Na) return "";
    $e8dfc29dafb3bbd7$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e8dfc29dafb3bbd7$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e8dfc29dafb3bbd7$var$Ma(a) : "";
}
function $e8dfc29dafb3bbd7$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e8dfc29dafb3bbd7$var$Ma(a.type);
        case 16:
            return $e8dfc29dafb3bbd7$var$Ma("Lazy");
        case 13:
            return $e8dfc29dafb3bbd7$var$Ma("Suspense");
        case 19:
            return $e8dfc29dafb3bbd7$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !1), a;
        case 11:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return "Fragment";
        case $e8dfc29dafb3bbd7$var$wa:
            return "Portal";
        case $e8dfc29dafb3bbd7$var$Aa:
            return "Profiler";
        case $e8dfc29dafb3bbd7$var$za:
            return "StrictMode";
        case $e8dfc29dafb3bbd7$var$Ea:
            return "Suspense";
        case $e8dfc29dafb3bbd7$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e8dfc29dafb3bbd7$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e8dfc29dafb3bbd7$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e8dfc29dafb3bbd7$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e8dfc29dafb3bbd7$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e8dfc29dafb3bbd7$var$Qa(a.type) || "Memo";
        case $e8dfc29dafb3bbd7$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e8dfc29dafb3bbd7$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e8dfc29dafb3bbd7$var$Qa(b);
        case 8:
            return b === $e8dfc29dafb3bbd7$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $1ObTH._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e8dfc29dafb3bbd7$var$Ua(a) {
    var b = $e8dfc29dafb3bbd7$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e8dfc29dafb3bbd7$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e8dfc29dafb3bbd7$var$Ua(a));
}
function $e8dfc29dafb3bbd7$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e8dfc29dafb3bbd7$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e8dfc29dafb3bbd7$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e8dfc29dafb3bbd7$var$Ya(a, b) {
    var c = b.checked;
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e8dfc29dafb3bbd7$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e8dfc29dafb3bbd7$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e8dfc29dafb3bbd7$var$ab(a, b) {
    b = b.checked;
    null != b && $e8dfc29dafb3bbd7$var$ta(a, "checked", b, !1);
}
function $e8dfc29dafb3bbd7$var$bb(a, b) {
    $e8dfc29dafb3bbd7$var$ab(a, b);
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e8dfc29dafb3bbd7$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e8dfc29dafb3bbd7$var$cb(a, b.type, $e8dfc29dafb3bbd7$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e8dfc29dafb3bbd7$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e8dfc29dafb3bbd7$var$cb(a, b, c) {
    if ("number" !== b || $e8dfc29dafb3bbd7$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e8dfc29dafb3bbd7$var$eb = Array.isArray;
function $e8dfc29dafb3bbd7$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e8dfc29dafb3bbd7$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e8dfc29dafb3bbd7$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e8dfc29dafb3bbd7$var$p(91));
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e8dfc29dafb3bbd7$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e8dfc29dafb3bbd7$var$p(92));
            if ($e8dfc29dafb3bbd7$var$eb(c)) {
                if (1 < c.length) throw Error($e8dfc29dafb3bbd7$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e8dfc29dafb3bbd7$var$Sa(c)
    };
}
function $e8dfc29dafb3bbd7$var$ib(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = $e8dfc29dafb3bbd7$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e8dfc29dafb3bbd7$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e8dfc29dafb3bbd7$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e8dfc29dafb3bbd7$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e8dfc29dafb3bbd7$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e8dfc29dafb3bbd7$var$mb, $e8dfc29dafb3bbd7$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e8dfc29dafb3bbd7$var$mb = $e8dfc29dafb3bbd7$var$mb || document.createElement("div");
        $e8dfc29dafb3bbd7$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e8dfc29dafb3bbd7$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e8dfc29dafb3bbd7$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e8dfc29dafb3bbd7$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e8dfc29dafb3bbd7$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e8dfc29dafb3bbd7$var$pb).forEach(function(a) {
    $e8dfc29dafb3bbd7$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e8dfc29dafb3bbd7$var$pb[b] = $e8dfc29dafb3bbd7$var$pb[a];
    });
});
function $e8dfc29dafb3bbd7$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e8dfc29dafb3bbd7$var$pb.hasOwnProperty(a) && $e8dfc29dafb3bbd7$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e8dfc29dafb3bbd7$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e8dfc29dafb3bbd7$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e8dfc29dafb3bbd7$var$tb = $e8dfc29dafb3bbd7$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e8dfc29dafb3bbd7$var$ub(a, b) {
    if (b) {
        if ($e8dfc29dafb3bbd7$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e8dfc29dafb3bbd7$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e8dfc29dafb3bbd7$var$p(62));
    }
}
function $e8dfc29dafb3bbd7$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e8dfc29dafb3bbd7$var$wb = null;
function $e8dfc29dafb3bbd7$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e8dfc29dafb3bbd7$var$yb = null, $e8dfc29dafb3bbd7$var$zb = null, $e8dfc29dafb3bbd7$var$Ab = null;
function $e8dfc29dafb3bbd7$var$Bb(a) {
    if (a = $e8dfc29dafb3bbd7$var$Cb(a)) {
        if ("function" !== typeof $e8dfc29dafb3bbd7$var$yb) throw Error($e8dfc29dafb3bbd7$var$p(280));
        var b = a.stateNode;
        b && (b = $e8dfc29dafb3bbd7$var$Db(b), $e8dfc29dafb3bbd7$var$yb(a.stateNode, a.type, b));
    }
}
function $e8dfc29dafb3bbd7$var$Eb(a) {
    $e8dfc29dafb3bbd7$var$zb ? $e8dfc29dafb3bbd7$var$Ab ? $e8dfc29dafb3bbd7$var$Ab.push(a) : $e8dfc29dafb3bbd7$var$Ab = [
        a
    ] : $e8dfc29dafb3bbd7$var$zb = a;
}
function $e8dfc29dafb3bbd7$var$Fb() {
    if ($e8dfc29dafb3bbd7$var$zb) {
        var a = $e8dfc29dafb3bbd7$var$zb, b = $e8dfc29dafb3bbd7$var$Ab;
        $e8dfc29dafb3bbd7$var$Ab = $e8dfc29dafb3bbd7$var$zb = null;
        $e8dfc29dafb3bbd7$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$Bb(b[a]);
    }
}
function $e8dfc29dafb3bbd7$var$Gb(a, b) {
    return a(b);
}
function $e8dfc29dafb3bbd7$var$Hb() {}
var $e8dfc29dafb3bbd7$var$Ib = !1;
function $e8dfc29dafb3bbd7$var$Jb(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$Ib) return a(b, c);
    $e8dfc29dafb3bbd7$var$Ib = !0;
    try {
        return $e8dfc29dafb3bbd7$var$Gb(a, b, c);
    } finally{
        if ($e8dfc29dafb3bbd7$var$Ib = !1, null !== $e8dfc29dafb3bbd7$var$zb || null !== $e8dfc29dafb3bbd7$var$Ab) $e8dfc29dafb3bbd7$var$Hb(), $e8dfc29dafb3bbd7$var$Fb();
    }
}
function $e8dfc29dafb3bbd7$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e8dfc29dafb3bbd7$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e8dfc29dafb3bbd7$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $1ObTH._)(c)));
    return c;
}
var $e8dfc29dafb3bbd7$var$Lb = !1;
if ($e8dfc29dafb3bbd7$var$ia) try {
    var $e8dfc29dafb3bbd7$var$Mb = {};
    Object.defineProperty($e8dfc29dafb3bbd7$var$Mb, "passive", {
        get: function get() {
            $e8dfc29dafb3bbd7$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
    window.removeEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
} catch (a) {
    $e8dfc29dafb3bbd7$var$Lb = !1;
}
function $e8dfc29dafb3bbd7$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e8dfc29dafb3bbd7$var$Ob = !1, $e8dfc29dafb3bbd7$var$Pb = null, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, $e8dfc29dafb3bbd7$var$Sb = {
    onError: function onError(a) {
        $e8dfc29dafb3bbd7$var$Ob = !0;
        $e8dfc29dafb3bbd7$var$Pb = a;
    }
};
function $e8dfc29dafb3bbd7$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Ob = !1;
    $e8dfc29dafb3bbd7$var$Pb = null;
    $e8dfc29dafb3bbd7$var$Nb.apply($e8dfc29dafb3bbd7$var$Sb, arguments);
}
function $e8dfc29dafb3bbd7$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Tb.apply(this, arguments);
    if ($e8dfc29dafb3bbd7$var$Ob) {
        if ($e8dfc29dafb3bbd7$var$Ob) {
            var l = $e8dfc29dafb3bbd7$var$Pb;
            $e8dfc29dafb3bbd7$var$Ob = !1;
            $e8dfc29dafb3bbd7$var$Pb = null;
        } else throw Error($e8dfc29dafb3bbd7$var$p(198));
        $e8dfc29dafb3bbd7$var$Qb || ($e8dfc29dafb3bbd7$var$Qb = !0, $e8dfc29dafb3bbd7$var$Rb = l);
    }
}
function $e8dfc29dafb3bbd7$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e8dfc29dafb3bbd7$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xb(a) {
    if ($e8dfc29dafb3bbd7$var$Vb(a) !== a) throw Error($e8dfc29dafb3bbd7$var$p(188));
}
function $e8dfc29dafb3bbd7$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e8dfc29dafb3bbd7$var$Vb(a);
        if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e8dfc29dafb3bbd7$var$Xb(e), a;
                if (f === d) return $e8dfc29dafb3bbd7$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e8dfc29dafb3bbd7$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e8dfc29dafb3bbd7$var$p(190));
    }
    if (3 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e8dfc29dafb3bbd7$var$Zb(a) {
    a = $e8dfc29dafb3bbd7$var$Yb(a);
    return null !== a ? $e8dfc29dafb3bbd7$var$$b(a) : null;
}
function $e8dfc29dafb3bbd7$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e8dfc29dafb3bbd7$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$ac = $1c9zD.unstable_scheduleCallback, $e8dfc29dafb3bbd7$var$bc = $1c9zD.unstable_cancelCallback, $e8dfc29dafb3bbd7$var$cc = $1c9zD.unstable_shouldYield, $e8dfc29dafb3bbd7$var$dc = $1c9zD.unstable_requestPaint, $e8dfc29dafb3bbd7$var$B = $1c9zD.unstable_now, $e8dfc29dafb3bbd7$var$ec = $1c9zD.unstable_getCurrentPriorityLevel, $e8dfc29dafb3bbd7$var$fc = $1c9zD.unstable_ImmediatePriority, $e8dfc29dafb3bbd7$var$gc = $1c9zD.unstable_UserBlockingPriority, $e8dfc29dafb3bbd7$var$hc = $1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$ic = $1c9zD.unstable_LowPriority, $e8dfc29dafb3bbd7$var$jc = $1c9zD.unstable_IdlePriority, $e8dfc29dafb3bbd7$var$kc = null, $e8dfc29dafb3bbd7$var$lc = null;
function $e8dfc29dafb3bbd7$var$mc(a) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e8dfc29dafb3bbd7$var$oc = Math.clz32 ? Math.clz32 : $e8dfc29dafb3bbd7$var$nc, $e8dfc29dafb3bbd7$var$pc = Math.log, $e8dfc29dafb3bbd7$var$qc = Math.LN2;
function $e8dfc29dafb3bbd7$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e8dfc29dafb3bbd7$var$pc(a) / $e8dfc29dafb3bbd7$var$qc | 0) | 0;
}
var $e8dfc29dafb3bbd7$var$rc = 64, $e8dfc29dafb3bbd7$var$sc = 4194304;
function $e8dfc29dafb3bbd7$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e8dfc29dafb3bbd7$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e8dfc29dafb3bbd7$var$tc(h) : (f &= g, 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e8dfc29dafb3bbd7$var$tc(g) : 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e8dfc29dafb3bbd7$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e8dfc29dafb3bbd7$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e8dfc29dafb3bbd7$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e8dfc29dafb3bbd7$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e8dfc29dafb3bbd7$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e8dfc29dafb3bbd7$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e8dfc29dafb3bbd7$var$yc() {
    var a = $e8dfc29dafb3bbd7$var$rc;
    $e8dfc29dafb3bbd7$var$rc <<= 1;
    0 === ($e8dfc29dafb3bbd7$var$rc & 4194240) && ($e8dfc29dafb3bbd7$var$rc = 64);
    return a;
}
function $e8dfc29dafb3bbd7$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e8dfc29dafb3bbd7$var$oc(b);
    a[b] = c;
}
function $e8dfc29dafb3bbd7$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e8dfc29dafb3bbd7$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e8dfc29dafb3bbd7$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e8dfc29dafb3bbd7$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e8dfc29dafb3bbd7$var$C = 0;
function $e8dfc29dafb3bbd7$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e8dfc29dafb3bbd7$var$Ec, $e8dfc29dafb3bbd7$var$Fc, $e8dfc29dafb3bbd7$var$Gc, $e8dfc29dafb3bbd7$var$Hc, $e8dfc29dafb3bbd7$var$Ic, $e8dfc29dafb3bbd7$var$Jc = !1, $e8dfc29dafb3bbd7$var$Kc = [], $e8dfc29dafb3bbd7$var$Lc = null, $e8dfc29dafb3bbd7$var$Mc = null, $e8dfc29dafb3bbd7$var$Nc = null, $e8dfc29dafb3bbd7$var$Oc = new Map, $e8dfc29dafb3bbd7$var$Pc = new Map, $e8dfc29dafb3bbd7$var$Qc = [], $e8dfc29dafb3bbd7$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e8dfc29dafb3bbd7$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e8dfc29dafb3bbd7$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e8dfc29dafb3bbd7$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e8dfc29dafb3bbd7$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e8dfc29dafb3bbd7$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e8dfc29dafb3bbd7$var$Pc.delete(b.pointerId);
    }
}
function $e8dfc29dafb3bbd7$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e8dfc29dafb3bbd7$var$Cb(b), null !== b && $e8dfc29dafb3bbd7$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e8dfc29dafb3bbd7$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e8dfc29dafb3bbd7$var$Lc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e8dfc29dafb3bbd7$var$Mc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e8dfc29dafb3bbd7$var$Nc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e8dfc29dafb3bbd7$var$Oc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e8dfc29dafb3bbd7$var$Pc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Vc(a) {
    var b = $e8dfc29dafb3bbd7$var$Wc(a.target);
    if (null !== b) {
        var c = $e8dfc29dafb3bbd7$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e8dfc29dafb3bbd7$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e8dfc29dafb3bbd7$var$Ic(a.priority, function() {
                        $e8dfc29dafb3bbd7$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e8dfc29dafb3bbd7$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e8dfc29dafb3bbd7$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e8dfc29dafb3bbd7$var$wb = d;
            c.target.dispatchEvent(d);
            $e8dfc29dafb3bbd7$var$wb = null;
        } else return b = $e8dfc29dafb3bbd7$var$Cb(c), null !== b && $e8dfc29dafb3bbd7$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Zc(a, b, c) {
    $e8dfc29dafb3bbd7$var$Xc(a) && c.delete(b);
}
function $e8dfc29dafb3bbd7$var$$c() {
    $e8dfc29dafb3bbd7$var$Jc = !1;
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Lc) && ($e8dfc29dafb3bbd7$var$Lc = null);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Mc) && ($e8dfc29dafb3bbd7$var$Mc = null);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Nc) && ($e8dfc29dafb3bbd7$var$Nc = null);
    $e8dfc29dafb3bbd7$var$Oc.forEach($e8dfc29dafb3bbd7$var$Zc);
    $e8dfc29dafb3bbd7$var$Pc.forEach($e8dfc29dafb3bbd7$var$Zc);
}
function $e8dfc29dafb3bbd7$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e8dfc29dafb3bbd7$var$Jc || ($e8dfc29dafb3bbd7$var$Jc = !0, $1c9zD.unstable_scheduleCallback($1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$$c)));
}
function $e8dfc29dafb3bbd7$var$bd(a) {
    var b = function b(_b) {
        return $e8dfc29dafb3bbd7$var$ad(_b, a);
    };
    if (0 < $e8dfc29dafb3bbd7$var$Kc.length) {
        $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Kc[0], a);
        for(var c = 1; c < $e8dfc29dafb3bbd7$var$Kc.length; c++){
            var d = $e8dfc29dafb3bbd7$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Lc, a);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Mc, a);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Nc, a);
    $e8dfc29dafb3bbd7$var$Oc.forEach(b);
    $e8dfc29dafb3bbd7$var$Pc.forEach(b);
    for(c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length; c++)d = $e8dfc29dafb3bbd7$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e8dfc29dafb3bbd7$var$Qc.length && (c = $e8dfc29dafb3bbd7$var$Qc[0], null === c.blockedOn);)$e8dfc29dafb3bbd7$var$Vc(c), null === c.blockedOn && $e8dfc29dafb3bbd7$var$Qc.shift();
}
var $e8dfc29dafb3bbd7$var$cd = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$dd = !0;
function $e8dfc29dafb3bbd7$var$ed(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$gd(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 4, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$fd(a, b, c, d) {
    if ($e8dfc29dafb3bbd7$var$dd) {
        var e = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
        if (null === e) $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c), $e8dfc29dafb3bbd7$var$Sc(a, d);
        else if ($e8dfc29dafb3bbd7$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e8dfc29dafb3bbd7$var$Sc(a, d), b & 4 && -1 < $e8dfc29dafb3bbd7$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e8dfc29dafb3bbd7$var$Cb(e);
                null !== f && $e8dfc29dafb3bbd7$var$Ec(f);
                f = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
                null === f && $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e8dfc29dafb3bbd7$var$hd(a, b, d, null, c);
    }
}
var $e8dfc29dafb3bbd7$var$id = null;
function $e8dfc29dafb3bbd7$var$Yc(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$id = null;
    a = $e8dfc29dafb3bbd7$var$xb(d);
    a = $e8dfc29dafb3bbd7$var$Wc(a);
    if (null !== a) {
        if (b = $e8dfc29dafb3bbd7$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e8dfc29dafb3bbd7$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e8dfc29dafb3bbd7$var$id = a;
    return null;
}
function $e8dfc29dafb3bbd7$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e8dfc29dafb3bbd7$var$ec()){
                case $e8dfc29dafb3bbd7$var$fc:
                    return 1;
                case $e8dfc29dafb3bbd7$var$gc:
                    return 4;
                case $e8dfc29dafb3bbd7$var$hc:
                case $e8dfc29dafb3bbd7$var$ic:
                    return 16;
                case $e8dfc29dafb3bbd7$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ld = null, $e8dfc29dafb3bbd7$var$md = null;
function $e8dfc29dafb3bbd7$var$nd() {
    if ($e8dfc29dafb3bbd7$var$md) return $e8dfc29dafb3bbd7$var$md;
    var a, b = $e8dfc29dafb3bbd7$var$ld, c = b.length, d, e = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e8dfc29dafb3bbd7$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e8dfc29dafb3bbd7$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e8dfc29dafb3bbd7$var$pd() {
    return !0;
}
function $e8dfc29dafb3bbd7$var$qd() {
    return !1;
}
function $e8dfc29dafb3bbd7$var$rd(a) {
    var b = function b(_b, d, e, f, g) {
        this._reactName = _b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (_b = a[c], this[c] = _b ? _b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e8dfc29dafb3bbd7$var$pd : $e8dfc29dafb3bbd7$var$qd;
        this.isPropagationStopped = $e8dfc29dafb3bbd7$var$qd;
        return this;
    };
    $e8dfc29dafb3bbd7$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $1ObTH._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $e8dfc29dafb3bbd7$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $1ObTH._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $e8dfc29dafb3bbd7$var$pd);
        },
        persist: function persist() {},
        isPersistent: $e8dfc29dafb3bbd7$var$pd
    });
    return b;
}
var $e8dfc29dafb3bbd7$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e8dfc29dafb3bbd7$var$td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$sd), $e8dfc29dafb3bbd7$var$ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    view: 0,
    detail: 0
}), $e8dfc29dafb3bbd7$var$vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$ud), $e8dfc29dafb3bbd7$var$wd, $e8dfc29dafb3bbd7$var$xd, $e8dfc29dafb3bbd7$var$yd, $e8dfc29dafb3bbd7$var$Ad = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e8dfc29dafb3bbd7$var$yd && ($e8dfc29dafb3bbd7$var$yd && "mousemove" === a.type ? ($e8dfc29dafb3bbd7$var$wd = a.screenX - $e8dfc29dafb3bbd7$var$yd.screenX, $e8dfc29dafb3bbd7$var$xd = a.screenY - $e8dfc29dafb3bbd7$var$yd.screenY) : $e8dfc29dafb3bbd7$var$xd = $e8dfc29dafb3bbd7$var$wd = 0, $e8dfc29dafb3bbd7$var$yd = a);
        return $e8dfc29dafb3bbd7$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $e8dfc29dafb3bbd7$var$xd;
    }
}), $e8dfc29dafb3bbd7$var$Bd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ad), $e8dfc29dafb3bbd7$var$Cd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    dataTransfer: 0
}), $e8dfc29dafb3bbd7$var$Dd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Cd), $e8dfc29dafb3bbd7$var$Ed = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    relatedTarget: 0
}), $e8dfc29dafb3bbd7$var$Fd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ed), $e8dfc29dafb3bbd7$var$Gd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Hd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Gd), $e8dfc29dafb3bbd7$var$Id = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e8dfc29dafb3bbd7$var$Jd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Id), $e8dfc29dafb3bbd7$var$Kd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    data: 0
}), $e8dfc29dafb3bbd7$var$Ld = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Kd), $e8dfc29dafb3bbd7$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e8dfc29dafb3bbd7$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e8dfc29dafb3bbd7$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e8dfc29dafb3bbd7$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e8dfc29dafb3bbd7$var$Od[a]) ? !!b[a] : !1;
}
function $e8dfc29dafb3bbd7$var$zd() {
    return $e8dfc29dafb3bbd7$var$Pd;
}
var $e8dfc29dafb3bbd7$var$Qd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $e8dfc29dafb3bbd7$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e8dfc29dafb3bbd7$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e8dfc29dafb3bbd7$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e8dfc29dafb3bbd7$var$Rd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Qd), $e8dfc29dafb3bbd7$var$Sd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e8dfc29dafb3bbd7$var$Td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Sd), $e8dfc29dafb3bbd7$var$Ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd
}), $e8dfc29dafb3bbd7$var$Vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ud), $e8dfc29dafb3bbd7$var$Wd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Xd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Wd), $e8dfc29dafb3bbd7$var$Yd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e8dfc29dafb3bbd7$var$Zd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Yd), $e8dfc29dafb3bbd7$var$$d = [
    9,
    13,
    27,
    32
], $e8dfc29dafb3bbd7$var$ae = $e8dfc29dafb3bbd7$var$ia && "CompositionEvent" in window, $e8dfc29dafb3bbd7$var$be = null;
$e8dfc29dafb3bbd7$var$ia && "documentMode" in document && ($e8dfc29dafb3bbd7$var$be = document.documentMode);
var $e8dfc29dafb3bbd7$var$ce = $e8dfc29dafb3bbd7$var$ia && "TextEvent" in window && !$e8dfc29dafb3bbd7$var$be, $e8dfc29dafb3bbd7$var$de = $e8dfc29dafb3bbd7$var$ia && (!$e8dfc29dafb3bbd7$var$ae || $e8dfc29dafb3bbd7$var$be && 8 < $e8dfc29dafb3bbd7$var$be && 11 >= $e8dfc29dafb3bbd7$var$be), $e8dfc29dafb3bbd7$var$ee = String.fromCharCode(32), $e8dfc29dafb3bbd7$var$fe = !1;
function $e8dfc29dafb3bbd7$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e8dfc29dafb3bbd7$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e8dfc29dafb3bbd7$var$ie = !1;
function $e8dfc29dafb3bbd7$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e8dfc29dafb3bbd7$var$fe = !0;
            return $e8dfc29dafb3bbd7$var$ee;
        case "textInput":
            return a = b.data, a === $e8dfc29dafb3bbd7$var$ee && $e8dfc29dafb3bbd7$var$fe ? null : a;
        default:
            return null;
    }
}
function $e8dfc29dafb3bbd7$var$ke(a, b) {
    if ($e8dfc29dafb3bbd7$var$ie) return "compositionend" === a || !$e8dfc29dafb3bbd7$var$ae && $e8dfc29dafb3bbd7$var$ge(a, b) ? (a = $e8dfc29dafb3bbd7$var$nd(), $e8dfc29dafb3bbd7$var$md = $e8dfc29dafb3bbd7$var$ld = $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e8dfc29dafb3bbd7$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e8dfc29dafb3bbd7$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e8dfc29dafb3bbd7$var$ne(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$Eb(d);
    b = $e8dfc29dafb3bbd7$var$oe(b, "onChange");
    0 < b.length && (c = new $e8dfc29dafb3bbd7$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e8dfc29dafb3bbd7$var$pe = null, $e8dfc29dafb3bbd7$var$qe = null;
function $e8dfc29dafb3bbd7$var$re(a) {
    $e8dfc29dafb3bbd7$var$se(a, 0);
}
function $e8dfc29dafb3bbd7$var$te(a) {
    var b = $e8dfc29dafb3bbd7$var$ue(a);
    if ($e8dfc29dafb3bbd7$var$Wa(b)) return a;
}
function $e8dfc29dafb3bbd7$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e8dfc29dafb3bbd7$var$we = !1;
if ($e8dfc29dafb3bbd7$var$ia) {
    var $e8dfc29dafb3bbd7$var$xe;
    if ($e8dfc29dafb3bbd7$var$ia) {
        var $e8dfc29dafb3bbd7$var$ye = "oninput" in document;
        if (!$e8dfc29dafb3bbd7$var$ye) {
            var $e8dfc29dafb3bbd7$var$ze = document.createElement("div");
            $e8dfc29dafb3bbd7$var$ze.setAttribute("oninput", "return;");
            $e8dfc29dafb3bbd7$var$ye = "function" === typeof $e8dfc29dafb3bbd7$var$ze.oninput;
        }
        $e8dfc29dafb3bbd7$var$xe = $e8dfc29dafb3bbd7$var$ye;
    } else $e8dfc29dafb3bbd7$var$xe = !1;
    $e8dfc29dafb3bbd7$var$we = $e8dfc29dafb3bbd7$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e8dfc29dafb3bbd7$var$Ae() {
    $e8dfc29dafb3bbd7$var$pe && ($e8dfc29dafb3bbd7$var$pe.detachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be), $e8dfc29dafb3bbd7$var$qe = $e8dfc29dafb3bbd7$var$pe = null);
}
function $e8dfc29dafb3bbd7$var$Be(a) {
    if ("value" === a.propertyName && $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe)) {
        var b = [];
        $e8dfc29dafb3bbd7$var$ne(b, $e8dfc29dafb3bbd7$var$qe, a, $e8dfc29dafb3bbd7$var$xb(a));
        $e8dfc29dafb3bbd7$var$Jb($e8dfc29dafb3bbd7$var$re, b);
    }
}
function $e8dfc29dafb3bbd7$var$Ce(a, b, c) {
    "focusin" === a ? ($e8dfc29dafb3bbd7$var$Ae(), $e8dfc29dafb3bbd7$var$pe = b, $e8dfc29dafb3bbd7$var$qe = c, $e8dfc29dafb3bbd7$var$pe.attachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be)) : "focusout" === a && $e8dfc29dafb3bbd7$var$Ae();
}
function $e8dfc29dafb3bbd7$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe);
}
function $e8dfc29dafb3bbd7$var$Ee(a, b) {
    if ("click" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e8dfc29dafb3bbd7$var$He = "function" === typeof Object.is ? Object.is : $e8dfc29dafb3bbd7$var$Ge;
function $e8dfc29dafb3bbd7$var$Ie(a, b) {
    if ($e8dfc29dafb3bbd7$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e8dfc29dafb3bbd7$var$ja.call(b, e) || !$e8dfc29dafb3bbd7$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e8dfc29dafb3bbd7$var$Ke(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e8dfc29dafb3bbd7$var$Je(c);
    }
}
function $e8dfc29dafb3bbd7$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e8dfc29dafb3bbd7$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e8dfc29dafb3bbd7$var$Me() {
    for(var a = window, b = $e8dfc29dafb3bbd7$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e8dfc29dafb3bbd7$var$Xa(a.document);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e8dfc29dafb3bbd7$var$Oe(a) {
    var b = $e8dfc29dafb3bbd7$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e8dfc29dafb3bbd7$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e8dfc29dafb3bbd7$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e8dfc29dafb3bbd7$var$Ke(c, f);
                var g = $e8dfc29dafb3bbd7$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e8dfc29dafb3bbd7$var$Pe = $e8dfc29dafb3bbd7$var$ia && "documentMode" in document && 11 >= document.documentMode, $e8dfc29dafb3bbd7$var$Qe = null, $e8dfc29dafb3bbd7$var$Re = null, $e8dfc29dafb3bbd7$var$Se = null, $e8dfc29dafb3bbd7$var$Te = !1;
function $e8dfc29dafb3bbd7$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e8dfc29dafb3bbd7$var$Te || null == $e8dfc29dafb3bbd7$var$Qe || $e8dfc29dafb3bbd7$var$Qe !== $e8dfc29dafb3bbd7$var$Xa(d) || (d = $e8dfc29dafb3bbd7$var$Qe, "selectionStart" in d && $e8dfc29dafb3bbd7$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e8dfc29dafb3bbd7$var$Se && $e8dfc29dafb3bbd7$var$Ie($e8dfc29dafb3bbd7$var$Se, d) || ($e8dfc29dafb3bbd7$var$Se = d, d = $e8dfc29dafb3bbd7$var$oe($e8dfc29dafb3bbd7$var$Re, "onSelect"), 0 < d.length && (b = new $e8dfc29dafb3bbd7$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e8dfc29dafb3bbd7$var$Qe)));
}
function $e8dfc29dafb3bbd7$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e8dfc29dafb3bbd7$var$We = {
    animationend: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationStart"),
    transitionend: $e8dfc29dafb3bbd7$var$Ve("Transition", "TransitionEnd")
}, $e8dfc29dafb3bbd7$var$Xe = {}, $e8dfc29dafb3bbd7$var$Ye = {};
$e8dfc29dafb3bbd7$var$ia && ($e8dfc29dafb3bbd7$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e8dfc29dafb3bbd7$var$We.animationend.animation, delete $e8dfc29dafb3bbd7$var$We.animationiteration.animation, delete $e8dfc29dafb3bbd7$var$We.animationstart.animation), "TransitionEvent" in window || delete $e8dfc29dafb3bbd7$var$We.transitionend.transition);
function $e8dfc29dafb3bbd7$var$Ze(a) {
    if ($e8dfc29dafb3bbd7$var$Xe[a]) return $e8dfc29dafb3bbd7$var$Xe[a];
    if (!$e8dfc29dafb3bbd7$var$We[a]) return a;
    var b = $e8dfc29dafb3bbd7$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e8dfc29dafb3bbd7$var$Ye) return $e8dfc29dafb3bbd7$var$Xe[a] = b[c];
    return a;
}
var $e8dfc29dafb3bbd7$var$$e = $e8dfc29dafb3bbd7$var$Ze("animationend"), $e8dfc29dafb3bbd7$var$af = $e8dfc29dafb3bbd7$var$Ze("animationiteration"), $e8dfc29dafb3bbd7$var$bf = $e8dfc29dafb3bbd7$var$Ze("animationstart"), $e8dfc29dafb3bbd7$var$cf = $e8dfc29dafb3bbd7$var$Ze("transitionend"), $e8dfc29dafb3bbd7$var$df = new Map, $e8dfc29dafb3bbd7$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e8dfc29dafb3bbd7$var$ff(a, b) {
    $e8dfc29dafb3bbd7$var$df.set(a, b);
    $e8dfc29dafb3bbd7$var$fa(b, [
        a
    ]);
}
for(var $e8dfc29dafb3bbd7$var$gf = 0; $e8dfc29dafb3bbd7$var$gf < $e8dfc29dafb3bbd7$var$ef.length; $e8dfc29dafb3bbd7$var$gf++){
    var $e8dfc29dafb3bbd7$var$hf = $e8dfc29dafb3bbd7$var$ef[$e8dfc29dafb3bbd7$var$gf], $e8dfc29dafb3bbd7$var$jf = $e8dfc29dafb3bbd7$var$hf.toLowerCase(), $e8dfc29dafb3bbd7$var$kf = $e8dfc29dafb3bbd7$var$hf[0].toUpperCase() + $e8dfc29dafb3bbd7$var$hf.slice(1);
    $e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$jf, "on" + $e8dfc29dafb3bbd7$var$kf);
}
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$$e, "onAnimationEnd");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$af, "onAnimationIteration");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$bf, "onAnimationStart");
$e8dfc29dafb3bbd7$var$ff("dblclick", "onDoubleClick");
$e8dfc29dafb3bbd7$var$ff("focusin", "onFocus");
$e8dfc29dafb3bbd7$var$ff("focusout", "onBlur");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$cf, "onTransitionEnd");
$e8dfc29dafb3bbd7$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e8dfc29dafb3bbd7$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e8dfc29dafb3bbd7$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e8dfc29dafb3bbd7$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e8dfc29dafb3bbd7$var$lf));
function $e8dfc29dafb3bbd7$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e8dfc29dafb3bbd7$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e8dfc29dafb3bbd7$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e8dfc29dafb3bbd7$var$Qb) throw a = $e8dfc29dafb3bbd7$var$Rb, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, a;
}
function $e8dfc29dafb3bbd7$var$D(a, b) {
    var c = b[$e8dfc29dafb3bbd7$var$of];
    void 0 === c && (c = b[$e8dfc29dafb3bbd7$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e8dfc29dafb3bbd7$var$pf(b, a, 2, !1), c.add(d));
}
function $e8dfc29dafb3bbd7$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e8dfc29dafb3bbd7$var$pf(c, a, d, b);
}
var $e8dfc29dafb3bbd7$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e8dfc29dafb3bbd7$var$sf(a) {
    if (!a[$e8dfc29dafb3bbd7$var$rf]) {
        a[$e8dfc29dafb3bbd7$var$rf] = !0;
        $e8dfc29dafb3bbd7$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e8dfc29dafb3bbd7$var$mf.has(b) || $e8dfc29dafb3bbd7$var$qf(b, !1, a), $e8dfc29dafb3bbd7$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e8dfc29dafb3bbd7$var$rf] || (b[$e8dfc29dafb3bbd7$var$rf] = !0, $e8dfc29dafb3bbd7$var$qf("selectionchange", !1, b));
    }
}
function $e8dfc29dafb3bbd7$var$pf(a, b, c, d) {
    switch($e8dfc29dafb3bbd7$var$jd(b)){
        case 1:
            var e = $e8dfc29dafb3bbd7$var$ed;
            break;
        case 4:
            e = $e8dfc29dafb3bbd7$var$gd;
            break;
        default:
            e = $e8dfc29dafb3bbd7$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e8dfc29dafb3bbd7$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e8dfc29dafb3bbd7$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e8dfc29dafb3bbd7$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e8dfc29dafb3bbd7$var$Jb(function() {
        var _$d = f, _$e = $e8dfc29dafb3bbd7$var$xb(c), g = [];
        a: {
            var h = $e8dfc29dafb3bbd7$var$df.get(a);
            if (void 0 !== h) {
                var k = $e8dfc29dafb3bbd7$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e8dfc29dafb3bbd7$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e8dfc29dafb3bbd7$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e8dfc29dafb3bbd7$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e8dfc29dafb3bbd7$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e8dfc29dafb3bbd7$var$Vd;
                        break;
                    case $e8dfc29dafb3bbd7$var$$e:
                    case $e8dfc29dafb3bbd7$var$af:
                    case $e8dfc29dafb3bbd7$var$bf:
                        k = $e8dfc29dafb3bbd7$var$Hd;
                        break;
                    case $e8dfc29dafb3bbd7$var$cf:
                        k = $e8dfc29dafb3bbd7$var$Xd;
                        break;
                    case "scroll":
                        k = $e8dfc29dafb3bbd7$var$vd;
                        break;
                    case "wheel":
                        k = $e8dfc29dafb3bbd7$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e8dfc29dafb3bbd7$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e8dfc29dafb3bbd7$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e8dfc29dafb3bbd7$var$Kb(w, x), null != F && t.push($e8dfc29dafb3bbd7$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e8dfc29dafb3bbd7$var$wb && (n = c.relatedTarget || c.fromElement) && ($e8dfc29dafb3bbd7$var$Wc(n) || n[$e8dfc29dafb3bbd7$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $e8dfc29dafb3bbd7$var$Wc(n) : null, null !== n && (J = $e8dfc29dafb3bbd7$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $e8dfc29dafb3bbd7$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e8dfc29dafb3bbd7$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e8dfc29dafb3bbd7$var$ue(k);
                        u = null == n ? h : $e8dfc29dafb3bbd7$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e8dfc29dafb3bbd7$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e8dfc29dafb3bbd7$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e8dfc29dafb3bbd7$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e8dfc29dafb3bbd7$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e8dfc29dafb3bbd7$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e8dfc29dafb3bbd7$var$vf(t);
                                x = $e8dfc29dafb3bbd7$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e8dfc29dafb3bbd7$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e8dfc29dafb3bbd7$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $e8dfc29dafb3bbd7$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e8dfc29dafb3bbd7$var$ve;
                else if ($e8dfc29dafb3bbd7$var$me(h)) {
                    if ($e8dfc29dafb3bbd7$var$we) na = $e8dfc29dafb3bbd7$var$Fe;
                    else {
                        na = $e8dfc29dafb3bbd7$var$De;
                        var xa = $e8dfc29dafb3bbd7$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e8dfc29dafb3bbd7$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $e8dfc29dafb3bbd7$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e8dfc29dafb3bbd7$var$cb(h, "number", h.value);
            }
            xa = _$d ? $e8dfc29dafb3bbd7$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($e8dfc29dafb3bbd7$var$me(xa) || "true" === xa.contentEditable) $e8dfc29dafb3bbd7$var$Qe = xa, $e8dfc29dafb3bbd7$var$Re = _$d, $e8dfc29dafb3bbd7$var$Se = null;
                    break;
                case "focusout":
                    $e8dfc29dafb3bbd7$var$Se = $e8dfc29dafb3bbd7$var$Re = $e8dfc29dafb3bbd7$var$Qe = null;
                    break;
                case "mousedown":
                    $e8dfc29dafb3bbd7$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e8dfc29dafb3bbd7$var$Te = !1;
                    $e8dfc29dafb3bbd7$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($e8dfc29dafb3bbd7$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e8dfc29dafb3bbd7$var$Ue(g, c, _$e);
            }
            var $a;
            if ($e8dfc29dafb3bbd7$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e8dfc29dafb3bbd7$var$ie ? $e8dfc29dafb3bbd7$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e8dfc29dafb3bbd7$var$de && "ko" !== c.locale && ($e8dfc29dafb3bbd7$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e8dfc29dafb3bbd7$var$ie && ($a = $e8dfc29dafb3bbd7$var$nd()) : ($e8dfc29dafb3bbd7$var$kd = _$e, $e8dfc29dafb3bbd7$var$ld = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, $e8dfc29dafb3bbd7$var$ie = !0)), xa = $e8dfc29dafb3bbd7$var$oe(_$d, ba), 0 < xa.length && (ba = new $e8dfc29dafb3bbd7$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e8dfc29dafb3bbd7$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e8dfc29dafb3bbd7$var$ce ? $e8dfc29dafb3bbd7$var$je(a, c) : $e8dfc29dafb3bbd7$var$ke(a, c)) _$d = $e8dfc29dafb3bbd7$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $e8dfc29dafb3bbd7$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $e8dfc29dafb3bbd7$var$se(g, b);
    });
}
function $e8dfc29dafb3bbd7$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e8dfc29dafb3bbd7$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e8dfc29dafb3bbd7$var$Kb(a, c), null != f && d.unshift($e8dfc29dafb3bbd7$var$tf(a, f, e)), f = $e8dfc29dafb3bbd7$var$Kb(a, b), null != f && d.push($e8dfc29dafb3bbd7$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e8dfc29dafb3bbd7$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e8dfc29dafb3bbd7$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.unshift($e8dfc29dafb3bbd7$var$tf(c, k, h))) : e || (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.push($e8dfc29dafb3bbd7$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e8dfc29dafb3bbd7$var$xf = /\r\n?/g, $e8dfc29dafb3bbd7$var$yf = /\u0000|\uFFFD/g;
function $e8dfc29dafb3bbd7$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e8dfc29dafb3bbd7$var$xf, "\n").replace($e8dfc29dafb3bbd7$var$yf, "");
}
function $e8dfc29dafb3bbd7$var$Af(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$zf(b);
    if ($e8dfc29dafb3bbd7$var$zf(a) !== b && c) throw Error($e8dfc29dafb3bbd7$var$p(425));
}
function $e8dfc29dafb3bbd7$var$Bf() {}
var $e8dfc29dafb3bbd7$var$Cf = null, $e8dfc29dafb3bbd7$var$Df = null;
function $e8dfc29dafb3bbd7$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e8dfc29dafb3bbd7$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e8dfc29dafb3bbd7$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e8dfc29dafb3bbd7$var$Hf = "function" === typeof Promise ? Promise : void 0, $e8dfc29dafb3bbd7$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e8dfc29dafb3bbd7$var$Hf ? function Jf(a) {
    return $e8dfc29dafb3bbd7$var$Hf.resolve(null).then(a).catch($e8dfc29dafb3bbd7$var$If);
} : $e8dfc29dafb3bbd7$var$Ff;
function $e8dfc29dafb3bbd7$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e8dfc29dafb3bbd7$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e8dfc29dafb3bbd7$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e8dfc29dafb3bbd7$var$bd(b);
}
function $e8dfc29dafb3bbd7$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nf = Math.random().toString(36).slice(2), $e8dfc29dafb3bbd7$var$Of = "__reactFiber$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Pf = "__reactProps$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$uf = "__reactContainer$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$of = "__reactEvents$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Qf = "__reactListeners$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Rf = "__reactHandles$" + $e8dfc29dafb3bbd7$var$Nf;
function $e8dfc29dafb3bbd7$var$Wc(a) {
    var b = a[$e8dfc29dafb3bbd7$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e8dfc29dafb3bbd7$var$uf] || c[$e8dfc29dafb3bbd7$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e8dfc29dafb3bbd7$var$Mf(a); null !== a;){
                if (c = a[$e8dfc29dafb3bbd7$var$Of]) return c;
                a = $e8dfc29dafb3bbd7$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Cb(a) {
    a = a[$e8dfc29dafb3bbd7$var$Of] || a[$e8dfc29dafb3bbd7$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e8dfc29dafb3bbd7$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e8dfc29dafb3bbd7$var$p(33));
}
function $e8dfc29dafb3bbd7$var$Db(a) {
    return a[$e8dfc29dafb3bbd7$var$Pf] || null;
}
var $e8dfc29dafb3bbd7$var$Sf = [], $e8dfc29dafb3bbd7$var$Tf = -1;
function $e8dfc29dafb3bbd7$var$Uf(a) {
    return {
        current: a
    };
}
function $e8dfc29dafb3bbd7$var$E(a) {
    0 > $e8dfc29dafb3bbd7$var$Tf || (a.current = $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf], $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = null, $e8dfc29dafb3bbd7$var$Tf--);
}
function $e8dfc29dafb3bbd7$var$G(a, b) {
    $e8dfc29dafb3bbd7$var$Tf++;
    $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = a.current;
    a.current = b;
}
var $e8dfc29dafb3bbd7$var$Vf = {}, $e8dfc29dafb3bbd7$var$H = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Vf), $e8dfc29dafb3bbd7$var$Wf = $e8dfc29dafb3bbd7$var$Uf(!1), $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$Vf;
function $e8dfc29dafb3bbd7$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e8dfc29dafb3bbd7$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e8dfc29dafb3bbd7$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e8dfc29dafb3bbd7$var$$f() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
}
function $e8dfc29dafb3bbd7$var$ag(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$H.current !== $e8dfc29dafb3bbd7$var$Vf) throw Error($e8dfc29dafb3bbd7$var$p(168));
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
function $e8dfc29dafb3bbd7$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e8dfc29dafb3bbd7$var$p(108, $e8dfc29dafb3bbd7$var$Ra(a) || "Unknown", e));
    return $e8dfc29dafb3bbd7$var$A({}, c, d);
}
function $e8dfc29dafb3bbd7$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e8dfc29dafb3bbd7$var$Vf;
    $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$H.current;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, $e8dfc29dafb3bbd7$var$Wf.current);
    return !0;
}
function $e8dfc29dafb3bbd7$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e8dfc29dafb3bbd7$var$p(169));
    c ? (a = $e8dfc29dafb3bbd7$var$bg(a, b, $e8dfc29dafb3bbd7$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a)) : $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
var $e8dfc29dafb3bbd7$var$eg = null, $e8dfc29dafb3bbd7$var$fg = !1, $e8dfc29dafb3bbd7$var$gg = !1;
function $e8dfc29dafb3bbd7$var$hg(a) {
    null === $e8dfc29dafb3bbd7$var$eg ? $e8dfc29dafb3bbd7$var$eg = [
        a
    ] : $e8dfc29dafb3bbd7$var$eg.push(a);
}
function $e8dfc29dafb3bbd7$var$ig(a) {
    $e8dfc29dafb3bbd7$var$fg = !0;
    $e8dfc29dafb3bbd7$var$hg(a);
}
function $e8dfc29dafb3bbd7$var$jg() {
    if (!$e8dfc29dafb3bbd7$var$gg && null !== $e8dfc29dafb3bbd7$var$eg) {
        $e8dfc29dafb3bbd7$var$gg = !0;
        var a = 0, b = $e8dfc29dafb3bbd7$var$C;
        try {
            var c = $e8dfc29dafb3bbd7$var$eg;
            for($e8dfc29dafb3bbd7$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e8dfc29dafb3bbd7$var$eg = null;
            $e8dfc29dafb3bbd7$var$fg = !1;
        } catch (e) {
            throw null !== $e8dfc29dafb3bbd7$var$eg && ($e8dfc29dafb3bbd7$var$eg = $e8dfc29dafb3bbd7$var$eg.slice(a + 1)), $e8dfc29dafb3bbd7$var$ac($e8dfc29dafb3bbd7$var$fc, $e8dfc29dafb3bbd7$var$jg), e;
        } finally{
            $e8dfc29dafb3bbd7$var$C = b, $e8dfc29dafb3bbd7$var$gg = !1;
        }
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$kg = [], $e8dfc29dafb3bbd7$var$lg = 0, $e8dfc29dafb3bbd7$var$mg = null, $e8dfc29dafb3bbd7$var$ng = 0, $e8dfc29dafb3bbd7$var$og = [], $e8dfc29dafb3bbd7$var$pg = 0, $e8dfc29dafb3bbd7$var$qg = null, $e8dfc29dafb3bbd7$var$rg = 1, $e8dfc29dafb3bbd7$var$sg = "";
function $e8dfc29dafb3bbd7$var$tg(a, b) {
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$ng;
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$mg;
    $e8dfc29dafb3bbd7$var$mg = a;
    $e8dfc29dafb3bbd7$var$ng = b;
}
function $e8dfc29dafb3bbd7$var$ug(a, b, c) {
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg;
    $e8dfc29dafb3bbd7$var$qg = a;
    var d = $e8dfc29dafb3bbd7$var$rg;
    a = $e8dfc29dafb3bbd7$var$sg;
    var e = 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e8dfc29dafb3bbd7$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e8dfc29dafb3bbd7$var$rg = 1 << 32 - $e8dfc29dafb3bbd7$var$oc(b) + e | c << e | d;
        $e8dfc29dafb3bbd7$var$sg = f + a;
    } else $e8dfc29dafb3bbd7$var$rg = 1 << f | c << e | d, $e8dfc29dafb3bbd7$var$sg = a;
}
function $e8dfc29dafb3bbd7$var$vg(a) {
    null !== a.return && ($e8dfc29dafb3bbd7$var$tg(a, 1), $e8dfc29dafb3bbd7$var$ug(a, 1, 0));
}
function $e8dfc29dafb3bbd7$var$wg(a) {
    for(; a === $e8dfc29dafb3bbd7$var$mg;)$e8dfc29dafb3bbd7$var$mg = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null, $e8dfc29dafb3bbd7$var$ng = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null;
    for(; a === $e8dfc29dafb3bbd7$var$qg;)$e8dfc29dafb3bbd7$var$qg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$sg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$rg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null;
}
var $e8dfc29dafb3bbd7$var$xg = null, $e8dfc29dafb3bbd7$var$yg = null, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$zg = null;
function $e8dfc29dafb3bbd7$var$Ag(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e8dfc29dafb3bbd7$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e8dfc29dafb3bbd7$var$qg ? {
                id: $e8dfc29dafb3bbd7$var$rg,
                overflow: $e8dfc29dafb3bbd7$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e8dfc29dafb3bbd7$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e8dfc29dafb3bbd7$var$Eg(a) {
    if ($e8dfc29dafb3bbd7$var$I) {
        var b = $e8dfc29dafb3bbd7$var$yg;
        if (b) {
            var c = b;
            if (!$e8dfc29dafb3bbd7$var$Cg(a, b)) {
                if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
                b = $e8dfc29dafb3bbd7$var$Lf(c.nextSibling);
                var d = $e8dfc29dafb3bbd7$var$xg;
                b && $e8dfc29dafb3bbd7$var$Cg(a, b) ? $e8dfc29dafb3bbd7$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$xg = a);
            }
        } else {
            if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e8dfc29dafb3bbd7$var$I = !1;
            $e8dfc29dafb3bbd7$var$xg = a;
        }
    }
}
function $e8dfc29dafb3bbd7$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e8dfc29dafb3bbd7$var$xg = a;
}
function $e8dfc29dafb3bbd7$var$Gg(a) {
    if (a !== $e8dfc29dafb3bbd7$var$xg) return !1;
    if (!$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$Fg(a), $e8dfc29dafb3bbd7$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e8dfc29dafb3bbd7$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e8dfc29dafb3bbd7$var$yg)) {
        if ($e8dfc29dafb3bbd7$var$Dg(a)) throw $e8dfc29dafb3bbd7$var$Hg(), Error($e8dfc29dafb3bbd7$var$p(418));
        for(; b;)$e8dfc29dafb3bbd7$var$Ag(a, b), b = $e8dfc29dafb3bbd7$var$Lf(b.nextSibling);
    }
    $e8dfc29dafb3bbd7$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e8dfc29dafb3bbd7$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e8dfc29dafb3bbd7$var$yg = null;
        }
    } else $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg ? $e8dfc29dafb3bbd7$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Hg() {
    for(var a = $e8dfc29dafb3bbd7$var$yg; a;)a = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
}
function $e8dfc29dafb3bbd7$var$Ig() {
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg = null;
    $e8dfc29dafb3bbd7$var$I = !1;
}
function $e8dfc29dafb3bbd7$var$Jg(a) {
    null === $e8dfc29dafb3bbd7$var$zg ? $e8dfc29dafb3bbd7$var$zg = [
        a
    ] : $e8dfc29dafb3bbd7$var$zg.push(a);
}
var $e8dfc29dafb3bbd7$var$Kg = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig;
function $e8dfc29dafb3bbd7$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $e8dfc29dafb3bbd7$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Mg = $e8dfc29dafb3bbd7$var$Uf(null), $e8dfc29dafb3bbd7$var$Ng = null, $e8dfc29dafb3bbd7$var$Og = null, $e8dfc29dafb3bbd7$var$Pg = null;
function $e8dfc29dafb3bbd7$var$Qg() {
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Ng = null;
}
function $e8dfc29dafb3bbd7$var$Rg(a) {
    var b = $e8dfc29dafb3bbd7$var$Mg.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Mg);
    a._currentValue = b;
}
function $e8dfc29dafb3bbd7$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e8dfc29dafb3bbd7$var$Tg(a, b) {
    $e8dfc29dafb3bbd7$var$Ng = a;
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e8dfc29dafb3bbd7$var$Ug = !0), a.firstContext = null);
}
function $e8dfc29dafb3bbd7$var$Vg(a) {
    var b = a._currentValue;
    if ($e8dfc29dafb3bbd7$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e8dfc29dafb3bbd7$var$Og) {
            if (null === $e8dfc29dafb3bbd7$var$Ng) throw Error($e8dfc29dafb3bbd7$var$p(308));
            $e8dfc29dafb3bbd7$var$Og = a;
            $e8dfc29dafb3bbd7$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Og.next = a;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Wg = null;
function $e8dfc29dafb3bbd7$var$Xg(a) {
    null === $e8dfc29dafb3bbd7$var$Wg ? $e8dfc29dafb3bbd7$var$Wg = [
        a
    ] : $e8dfc29dafb3bbd7$var$Wg.push(a);
}
function $e8dfc29dafb3bbd7$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e8dfc29dafb3bbd7$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e8dfc29dafb3bbd7$var$Zg(a, d);
}
function $e8dfc29dafb3bbd7$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e8dfc29dafb3bbd7$var$$g = !1;
function $e8dfc29dafb3bbd7$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e8dfc29dafb3bbd7$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e8dfc29dafb3bbd7$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e8dfc29dafb3bbd7$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e8dfc29dafb3bbd7$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e8dfc29dafb3bbd7$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e8dfc29dafb3bbd7$var$Zg(a, c);
}
function $e8dfc29dafb3bbd7$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
function $e8dfc29dafb3bbd7$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e8dfc29dafb3bbd7$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $e8dfc29dafb3bbd7$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e8dfc29dafb3bbd7$var$A({}, q, r);
                            break a;
                        case 2:
                            $e8dfc29dafb3bbd7$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e8dfc29dafb3bbd7$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e8dfc29dafb3bbd7$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e8dfc29dafb3bbd7$var$p(191, e));
            e.call(d);
        }
    }
}
var $e8dfc29dafb3bbd7$var$jh = (new $6cds3.Component).refs;
function $e8dfc29dafb3bbd7$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e8dfc29dafb3bbd7$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e8dfc29dafb3bbd7$var$nh = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $e8dfc29dafb3bbd7$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $e8dfc29dafb3bbd7$var$L(), d = $e8dfc29dafb3bbd7$var$lh(a), e = $e8dfc29dafb3bbd7$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e8dfc29dafb3bbd7$var$dh(a, e, d);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, d, c), $e8dfc29dafb3bbd7$var$eh(b, a, d));
    }
};
function $e8dfc29dafb3bbd7$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e8dfc29dafb3bbd7$var$Ie(c, d) || !$e8dfc29dafb3bbd7$var$Ie(e, f) : !0;
}
function $e8dfc29dafb3bbd7$var$ph(a, b, c) {
    var d = !1, e = $e8dfc29dafb3bbd7$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e8dfc29dafb3bbd7$var$Vg(f) : (e = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e8dfc29dafb3bbd7$var$Yf(a, e) : $e8dfc29dafb3bbd7$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e8dfc29dafb3bbd7$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e8dfc29dafb3bbd7$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(b, b.state, null);
}
function $e8dfc29dafb3bbd7$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $e8dfc29dafb3bbd7$var$jh;
    $e8dfc29dafb3bbd7$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e8dfc29dafb3bbd7$var$Vg(f) : (f = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, e.context = $e8dfc29dafb3bbd7$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e8dfc29dafb3bbd7$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(e, e.state, null), $e8dfc29dafb3bbd7$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e8dfc29dafb3bbd7$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e8dfc29dafb3bbd7$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                _$b === $e8dfc29dafb3bbd7$var$jh && (_$b = e.refs = {});
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e8dfc29dafb3bbd7$var$p(284));
        if (!c._owner) throw Error($e8dfc29dafb3bbd7$var$p(290, a));
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e8dfc29dafb3bbd7$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e8dfc29dafb3bbd7$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $e8dfc29dafb3bbd7$var$vh(a) {
    var b = function b(_b, c) {
        if (a) {
            var d = _b.deletions;
            null === d ? (_b.deletions = [
                c
            ], _b.flags |= 16) : d.push(c);
        }
    };
    var c = function c(_c, d) {
        if (!a) return null;
        for(; null !== d;)b(_c, d), d = d.sibling;
        return null;
    };
    var d = function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    };
    var e = function e(a, b) {
        a = $e8dfc29dafb3bbd7$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    };
    var f = function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    };
    var g = function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    };
    var h = function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e8dfc29dafb3bbd7$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    };
    var k = function k(a, b, c, d) {
        var f = c.type;
        if (f === $e8dfc29dafb3bbd7$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c), d.return = a, d;
        d = $e8dfc29dafb3bbd7$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c);
        d.return = a;
        return d;
    };
    var l = function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e8dfc29dafb3bbd7$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    };
    var m = function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e8dfc29dafb3bbd7$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    };
    var n = function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    };
    var t = function t(e, g, h, k) {
        var l = $e8dfc29dafb3bbd7$var$Ka(h);
        if ("function" !== typeof l) throw Error($e8dfc29dafb3bbd7$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e8dfc29dafb3bbd7$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    };
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e8dfc29dafb3bbd7$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c = $e8dfc29dafb3bbd7$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $e8dfc29dafb3bbd7$var$sh(a, null, b), c.return = a, c;
                case $e8dfc29dafb3bbd7$var$wa:
                    return b = $e8dfc29dafb3bbd7$var$zh(b, a.mode, c), b.return = a, b;
                case $e8dfc29dafb3bbd7$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e8dfc29dafb3bbd7$var$eb(b) || $e8dfc29dafb3bbd7$var$Ka(b)) return b = $e8dfc29dafb3bbd7$var$Ah(b, a.mode, c, null), b.return = a, b;
            $e8dfc29dafb3bbd7$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e8dfc29dafb3bbd7$var$eb(c) || $e8dfc29dafb3bbd7$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e8dfc29dafb3bbd7$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e8dfc29dafb3bbd7$var$eb(d) || $e8dfc29dafb3bbd7$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e8dfc29dafb3bbd7$var$th(b, d);
        }
        return null;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e8dfc29dafb3bbd7$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e8dfc29dafb3bbd7$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e8dfc29dafb3bbd7$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e8dfc29dafb3bbd7$var$ya ? (d = $e8dfc29dafb3bbd7$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e8dfc29dafb3bbd7$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $e8dfc29dafb3bbd7$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e8dfc29dafb3bbd7$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e8dfc29dafb3bbd7$var$eb(f)) return n(a, d, f, h);
            if ($e8dfc29dafb3bbd7$var$Ka(f)) return t(a, d, f, h);
            $e8dfc29dafb3bbd7$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e8dfc29dafb3bbd7$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e8dfc29dafb3bbd7$var$Bh = $e8dfc29dafb3bbd7$var$vh(!0), $e8dfc29dafb3bbd7$var$Ch = $e8dfc29dafb3bbd7$var$vh(!1), $e8dfc29dafb3bbd7$var$Dh = {}, $e8dfc29dafb3bbd7$var$Eh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Fh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Gh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh);
function $e8dfc29dafb3bbd7$var$Hh(a) {
    if (a === $e8dfc29dafb3bbd7$var$Dh) throw Error($e8dfc29dafb3bbd7$var$p(174));
    return a;
}
function $e8dfc29dafb3bbd7$var$Ih(a, b) {
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Gh, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, $e8dfc29dafb3bbd7$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e8dfc29dafb3bbd7$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e8dfc29dafb3bbd7$var$lb(b, a);
    }
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, b);
}
function $e8dfc29dafb3bbd7$var$Jh() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Gh);
}
function $e8dfc29dafb3bbd7$var$Kh(a) {
    $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
    var b = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
    var c = $e8dfc29dafb3bbd7$var$lb(b, a.type);
    b !== c && ($e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, c));
}
function $e8dfc29dafb3bbd7$var$Lh(a) {
    $e8dfc29dafb3bbd7$var$Fh.current === a && ($e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh));
}
var $e8dfc29dafb3bbd7$var$M = $e8dfc29dafb3bbd7$var$Uf(0);
function $e8dfc29dafb3bbd7$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nh = [];
function $e8dfc29dafb3bbd7$var$Oh() {
    for(var a = 0; a < $e8dfc29dafb3bbd7$var$Nh.length; a++)$e8dfc29dafb3bbd7$var$Nh[a]._workInProgressVersionPrimary = null;
    $e8dfc29dafb3bbd7$var$Nh.length = 0;
}
var $e8dfc29dafb3bbd7$var$Ph = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$Qh = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$Rh = 0, $e8dfc29dafb3bbd7$var$N = null, $e8dfc29dafb3bbd7$var$O = null, $e8dfc29dafb3bbd7$var$P = null, $e8dfc29dafb3bbd7$var$Sh = !1, $e8dfc29dafb3bbd7$var$Th = !1, $e8dfc29dafb3bbd7$var$Uh = 0, $e8dfc29dafb3bbd7$var$Vh = 0;
function $e8dfc29dafb3bbd7$var$Q() {
    throw Error($e8dfc29dafb3bbd7$var$p(321));
}
function $e8dfc29dafb3bbd7$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e8dfc29dafb3bbd7$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$Rh = f;
    $e8dfc29dafb3bbd7$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e8dfc29dafb3bbd7$var$Ph.current = null === a || null === a.memoizedState ? $e8dfc29dafb3bbd7$var$Yh : $e8dfc29dafb3bbd7$var$Zh;
    a = c(d, e);
    if ($e8dfc29dafb3bbd7$var$Th) {
        f = 0;
        do {
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            if (25 <= f) throw Error($e8dfc29dafb3bbd7$var$p(301));
            f += 1;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = null;
            b.updateQueue = null;
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$$h;
            a = c(d, e);
        }while ($e8dfc29dafb3bbd7$var$Th);
    }
    $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
    b = null !== $e8dfc29dafb3bbd7$var$O && null !== $e8dfc29dafb3bbd7$var$O.next;
    $e8dfc29dafb3bbd7$var$Rh = 0;
    $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
    $e8dfc29dafb3bbd7$var$Sh = !1;
    if (b) throw Error($e8dfc29dafb3bbd7$var$p(300));
    return a;
}
function $e8dfc29dafb3bbd7$var$bi() {
    var a = 0 !== $e8dfc29dafb3bbd7$var$Uh;
    $e8dfc29dafb3bbd7$var$Uh = 0;
    return a;
}
function $e8dfc29dafb3bbd7$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$di() {
    if (null === $e8dfc29dafb3bbd7$var$O) {
        var a = $e8dfc29dafb3bbd7$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e8dfc29dafb3bbd7$var$O.next;
    var b = null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState : $e8dfc29dafb3bbd7$var$P.next;
    if (null !== b) $e8dfc29dafb3bbd7$var$P = b, $e8dfc29dafb3bbd7$var$O = a;
    else {
        if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(310));
        $e8dfc29dafb3bbd7$var$O = a;
        a = {
            memoizedState: $e8dfc29dafb3bbd7$var$O.memoizedState,
            baseState: $e8dfc29dafb3bbd7$var$O.baseState,
            baseQueue: $e8dfc29dafb3bbd7$var$O.baseQueue,
            queue: $e8dfc29dafb3bbd7$var$O.queue,
            next: null
        };
        null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    }
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e8dfc29dafb3bbd7$var$fi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e8dfc29dafb3bbd7$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e8dfc29dafb3bbd7$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e8dfc29dafb3bbd7$var$N.lanes |= m;
                $e8dfc29dafb3bbd7$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e8dfc29dafb3bbd7$var$He(d, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e8dfc29dafb3bbd7$var$N.lanes |= f, $e8dfc29dafb3bbd7$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e8dfc29dafb3bbd7$var$gi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e8dfc29dafb3bbd7$var$He(f, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e8dfc29dafb3bbd7$var$hi() {}
function $e8dfc29dafb3bbd7$var$ii(a, b) {
    var c = $e8dfc29dafb3bbd7$var$N, d = $e8dfc29dafb3bbd7$var$di(), e = b(), f = !$e8dfc29dafb3bbd7$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e8dfc29dafb3bbd7$var$Ug = !0);
    d = d.queue;
    $e8dfc29dafb3bbd7$var$ji($e8dfc29dafb3bbd7$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e8dfc29dafb3bbd7$var$P && $e8dfc29dafb3bbd7$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
        0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(c, b, e);
    }
    return e;
}
function $e8dfc29dafb3bbd7$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e8dfc29dafb3bbd7$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
}
function $e8dfc29dafb3bbd7$var$ki(a, b, c) {
    return c(function() {
        $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
    });
}
function $e8dfc29dafb3bbd7$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e8dfc29dafb3bbd7$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e8dfc29dafb3bbd7$var$pi(a) {
    var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
    null !== b && $e8dfc29dafb3bbd7$var$mh(b, a, 1, -1);
}
function $e8dfc29dafb3bbd7$var$qi(a) {
    var b = $e8dfc29dafb3bbd7$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e8dfc29dafb3bbd7$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e8dfc29dafb3bbd7$var$ri.bind(null, $e8dfc29dafb3bbd7$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e8dfc29dafb3bbd7$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e8dfc29dafb3bbd7$var$si() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$ti(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$ci();
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e8dfc29dafb3bbd7$var$ui(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e8dfc29dafb3bbd7$var$O) {
        var g = $e8dfc29dafb3bbd7$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $e8dfc29dafb3bbd7$var$Wh(d, g.deps)) {
            e.memoizedState = $e8dfc29dafb3bbd7$var$li(b, c, f, d);
            return;
        }
    }
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, f, d);
}
function $e8dfc29dafb3bbd7$var$vi(a, b) {
    return $e8dfc29dafb3bbd7$var$ti(8390656, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$ji(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(2048, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$wi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 2, a, b);
}
function $e8dfc29dafb3bbd7$var$xi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 4, a, b);
}
function $e8dfc29dafb3bbd7$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e8dfc29dafb3bbd7$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e8dfc29dafb3bbd7$var$ui(4, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
}
function $e8dfc29dafb3bbd7$var$Ai() {}
function $e8dfc29dafb3bbd7$var$Bi(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Ci(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Di(a, b, c) {
    if (0 === ($e8dfc29dafb3bbd7$var$Rh & 21)) return a.baseState && (a.baseState = !1, $e8dfc29dafb3bbd7$var$Ug = !0), a.memoizedState = c;
    $e8dfc29dafb3bbd7$var$He(c, b) || (c = $e8dfc29dafb3bbd7$var$yc(), $e8dfc29dafb3bbd7$var$N.lanes |= c, $e8dfc29dafb3bbd7$var$hh |= c, a.baseState = !0);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ei(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    $e8dfc29dafb3bbd7$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e8dfc29dafb3bbd7$var$Qh.transition;
    $e8dfc29dafb3bbd7$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$Qh.transition = d;
    }
}
function $e8dfc29dafb3bbd7$var$Fi() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$Gi(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, c);
    else if (c = $e8dfc29dafb3bbd7$var$Yg(a, b, c, d), null !== c) {
        var e = $e8dfc29dafb3bbd7$var$L();
        $e8dfc29dafb3bbd7$var$mh(c, a, d, e);
        $e8dfc29dafb3bbd7$var$Ji(c, b, d);
    }
}
function $e8dfc29dafb3bbd7$var$ri(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e8dfc29dafb3bbd7$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e8dfc29dafb3bbd7$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e8dfc29dafb3bbd7$var$Yg(a, b, e, d);
        null !== c && (e = $e8dfc29dafb3bbd7$var$L(), $e8dfc29dafb3bbd7$var$mh(c, a, d, e), $e8dfc29dafb3bbd7$var$Ji(c, b, d));
    }
}
function $e8dfc29dafb3bbd7$var$Hi(a) {
    var b = a.alternate;
    return a === $e8dfc29dafb3bbd7$var$N || null !== b && b === $e8dfc29dafb3bbd7$var$N;
}
function $e8dfc29dafb3bbd7$var$Ii(a, b) {
    $e8dfc29dafb3bbd7$var$Th = $e8dfc29dafb3bbd7$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e8dfc29dafb3bbd7$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
var $e8dfc29dafb3bbd7$var$ai = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Q,
    useContext: $e8dfc29dafb3bbd7$var$Q,
    useEffect: $e8dfc29dafb3bbd7$var$Q,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$Q,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$Q,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$Q,
    useMemo: $e8dfc29dafb3bbd7$var$Q,
    useReducer: $e8dfc29dafb3bbd7$var$Q,
    useRef: $e8dfc29dafb3bbd7$var$Q,
    useState: $e8dfc29dafb3bbd7$var$Q,
    useDebugValue: $e8dfc29dafb3bbd7$var$Q,
    useDeferredValue: $e8dfc29dafb3bbd7$var$Q,
    useTransition: $e8dfc29dafb3bbd7$var$Q,
    useMutableSource: $e8dfc29dafb3bbd7$var$Q,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$Q,
    useId: $e8dfc29dafb3bbd7$var$Q,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Yh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: function useCallback(a, b) {
        $e8dfc29dafb3bbd7$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$vi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e8dfc29dafb3bbd7$var$Gi.bind(null, $e8dfc29dafb3bbd7$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $e8dfc29dafb3bbd7$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e8dfc29dafb3bbd7$var$qi,
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        return $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $e8dfc29dafb3bbd7$var$qi(!1), b = a[0];
        a = $e8dfc29dafb3bbd7$var$Ei.bind(null, a[1]);
        $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$N, e = $e8dfc29dafb3bbd7$var$ci();
        if ($e8dfc29dafb3bbd7$var$I) {
            if (void 0 === c) throw Error($e8dfc29dafb3bbd7$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
            0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e8dfc29dafb3bbd7$var$vi($e8dfc29dafb3bbd7$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $e8dfc29dafb3bbd7$var$ci(), b = $e8dfc29dafb3bbd7$var$R.identifierPrefix;
        if ($e8dfc29dafb3bbd7$var$I) {
            var c = $e8dfc29dafb3bbd7$var$sg;
            var d = $e8dfc29dafb3bbd7$var$rg;
            c = (d & ~(1 << 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e8dfc29dafb3bbd7$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e8dfc29dafb3bbd7$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Zh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$fi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function useState() {
        return $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$$h = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$gi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function useState() {
        return $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return null === $e8dfc29dafb3bbd7$var$O ? b.memoizedState = a : $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
};
function $e8dfc29dafb3bbd7$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $e8dfc29dafb3bbd7$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e8dfc29dafb3bbd7$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e8dfc29dafb3bbd7$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e8dfc29dafb3bbd7$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $e8dfc29dafb3bbd7$var$Oi(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e8dfc29dafb3bbd7$var$Pi || ($e8dfc29dafb3bbd7$var$Pi = !0, $e8dfc29dafb3bbd7$var$Qi = d);
        $e8dfc29dafb3bbd7$var$Mi(a, b);
    };
    return c;
}
function $e8dfc29dafb3bbd7$var$Ri(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e8dfc29dafb3bbd7$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e8dfc29dafb3bbd7$var$Mi(a, b);
        "function" !== typeof d && (null === $e8dfc29dafb3bbd7$var$Si ? $e8dfc29dafb3bbd7$var$Si = new Set([
            this
        ]) : $e8dfc29dafb3bbd7$var$Si.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $e8dfc29dafb3bbd7$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e8dfc29dafb3bbd7$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e8dfc29dafb3bbd7$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $e8dfc29dafb3bbd7$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e8dfc29dafb3bbd7$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e8dfc29dafb3bbd7$var$ch(-1, 1), b.tag = 2, $e8dfc29dafb3bbd7$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e8dfc29dafb3bbd7$var$Xi = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$Ug = !1;
function $e8dfc29dafb3bbd7$var$Yi(a, b, c, d) {
    b.child = null === a ? $e8dfc29dafb3bbd7$var$Ch(b, null, c, d) : $e8dfc29dafb3bbd7$var$Bh(b, a.child, c, d);
}
function $e8dfc29dafb3bbd7$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    d = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    c = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && c && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e8dfc29dafb3bbd7$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e8dfc29dafb3bbd7$var$cj(a, b, f, d, e);
        a = $e8dfc29dafb3bbd7$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e8dfc29dafb3bbd7$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e8dfc29dafb3bbd7$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $e8dfc29dafb3bbd7$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e8dfc29dafb3bbd7$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e8dfc29dafb3bbd7$var$Ie(f, d) && a.ref === b.ref) {
            if ($e8dfc29dafb3bbd7$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e8dfc29dafb3bbd7$var$Ug = !0);
            else return b.lanes = a.lanes, $e8dfc29dafb3bbd7$var$$i(a, b, e);
        }
    }
    return $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e);
}
function $e8dfc29dafb3bbd7$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj);
            $e8dfc29dafb3bbd7$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= d;
    $e8dfc29dafb3bbd7$var$Yi(a, b, e, c);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e) {
    var f = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current;
    f = $e8dfc29dafb3bbd7$var$Yf(b, f);
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    c = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    d = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && d && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$ij(a, b, c, d, e) {
    if ($e8dfc29dafb3bbd7$var$Zf(c)) {
        var f = !0;
        $e8dfc29dafb3bbd7$var$cg(b);
    } else f = !1;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    if (null === b.stateNode) $e8dfc29dafb3bbd7$var$jj(a, b), $e8dfc29dafb3bbd7$var$ph(b, c, d), $e8dfc29dafb3bbd7$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e8dfc29dafb3bbd7$var$Vg(l) : (l = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, l = $e8dfc29dafb3bbd7$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e8dfc29dafb3bbd7$var$qh(b, g, d, l);
        $e8dfc29dafb3bbd7$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof m && ($e8dfc29dafb3bbd7$var$kh(b, c, m, d), k = b.memoizedState), (h = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e8dfc29dafb3bbd7$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e8dfc29dafb3bbd7$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e8dfc29dafb3bbd7$var$Vg(k) : (k = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, k = $e8dfc29dafb3bbd7$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e8dfc29dafb3bbd7$var$qh(b, g, d, k);
        $e8dfc29dafb3bbd7$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof y && ($e8dfc29dafb3bbd7$var$kh(b, c, y, d), n = b.memoizedState), (l = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e8dfc29dafb3bbd7$var$kj(a, b, c, d, f, e);
}
function $e8dfc29dafb3bbd7$var$kj(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e8dfc29dafb3bbd7$var$dg(b, c, !1), $e8dfc29dafb3bbd7$var$$i(a, b, f);
    d = b.stateNode;
    $e8dfc29dafb3bbd7$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, f), b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, h, f)) : $e8dfc29dafb3bbd7$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e8dfc29dafb3bbd7$var$dg(b, c, !0);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e8dfc29dafb3bbd7$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e8dfc29dafb3bbd7$var$ag(a, b.context, !1);
    $e8dfc29dafb3bbd7$var$Ih(a, b.containerInfo);
}
function $e8dfc29dafb3bbd7$var$mj(a, b, c, d, e) {
    $e8dfc29dafb3bbd7$var$Ig();
    $e8dfc29dafb3bbd7$var$Jg(e);
    b.flags |= 256;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, d);
    return b.child;
}
var $e8dfc29dafb3bbd7$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e8dfc29dafb3bbd7$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e8dfc29dafb3bbd7$var$pj(a, b, c) {
    var d = b.pendingProps, e = $e8dfc29dafb3bbd7$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, e & 1);
    if (null === a) {
        $e8dfc29dafb3bbd7$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e8dfc29dafb3bbd7$var$qj(g, d, 0, null), a = $e8dfc29dafb3bbd7$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(c), b.memoizedState = $e8dfc29dafb3bbd7$var$nj, a) : $e8dfc29dafb3bbd7$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e8dfc29dafb3bbd7$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e8dfc29dafb3bbd7$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e8dfc29dafb3bbd7$var$wh(h, f) : (f = $e8dfc29dafb3bbd7$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e8dfc29dafb3bbd7$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e8dfc29dafb3bbd7$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e8dfc29dafb3bbd7$var$rj(a, b) {
    b = $e8dfc29dafb3bbd7$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e8dfc29dafb3bbd7$var$tj(a, b, c, d) {
    null !== d && $e8dfc29dafb3bbd7$var$Jg(d);
    $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, c);
    a = $e8dfc29dafb3bbd7$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e8dfc29dafb3bbd7$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(422))), $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e8dfc29dafb3bbd7$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e8dfc29dafb3bbd7$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(g);
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e8dfc29dafb3bbd7$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e8dfc29dafb3bbd7$var$p(419));
        d = $e8dfc29dafb3bbd7$var$Li(f, d, void 0);
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e8dfc29dafb3bbd7$var$Ug || h) {
        d = $e8dfc29dafb3bbd7$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e8dfc29dafb3bbd7$var$Zg(a, e), $e8dfc29dafb3bbd7$var$mh(d, a, e, -1));
        }
        $e8dfc29dafb3bbd7$var$uj();
        d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(421)));
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e8dfc29dafb3bbd7$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(e.nextSibling);
    $e8dfc29dafb3bbd7$var$xg = b;
    $e8dfc29dafb3bbd7$var$I = !0;
    $e8dfc29dafb3bbd7$var$zg = null;
    null !== a && ($e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg, $e8dfc29dafb3bbd7$var$rg = a.id, $e8dfc29dafb3bbd7$var$sg = a.overflow, $e8dfc29dafb3bbd7$var$qg = b);
    b = $e8dfc29dafb3bbd7$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e8dfc29dafb3bbd7$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e8dfc29dafb3bbd7$var$Sg(a.return, b, c);
}
function $e8dfc29dafb3bbd7$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e8dfc29dafb3bbd7$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d.children, c);
    d = $e8dfc29dafb3bbd7$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (19 === a.tag) $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e8dfc29dafb3bbd7$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e8dfc29dafb3bbd7$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $e8dfc29dafb3bbd7$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e8dfc29dafb3bbd7$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e8dfc29dafb3bbd7$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e8dfc29dafb3bbd7$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $e8dfc29dafb3bbd7$var$lj(b);
            $e8dfc29dafb3bbd7$var$Ig();
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$Kh(b);
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$cg(b);
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e8dfc29dafb3bbd7$var$pj(a, b, c);
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
                a = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e8dfc29dafb3bbd7$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    return $e8dfc29dafb3bbd7$var$$i(a, b, c);
}
var $e8dfc29dafb3bbd7$var$Aj, $e8dfc29dafb3bbd7$var$Bj, $e8dfc29dafb3bbd7$var$Cj, $e8dfc29dafb3bbd7$var$Dj;
$e8dfc29dafb3bbd7$var$Aj = function Aj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e8dfc29dafb3bbd7$var$Bj = function Bj() {};
$e8dfc29dafb3bbd7$var$Cj = function Cj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e8dfc29dafb3bbd7$var$Ya(a, e);
                d = $e8dfc29dafb3bbd7$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e8dfc29dafb3bbd7$var$A({}, e, {
                    value: void 0
                });
                d = $e8dfc29dafb3bbd7$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e8dfc29dafb3bbd7$var$gb(a, e);
                d = $e8dfc29dafb3bbd7$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
        }
        $e8dfc29dafb3bbd7$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e8dfc29dafb3bbd7$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e8dfc29dafb3bbd7$var$Dj = function Dj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e8dfc29dafb3bbd7$var$Ej(a, b) {
    if (!$e8dfc29dafb3bbd7$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e8dfc29dafb3bbd7$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e8dfc29dafb3bbd7$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e8dfc29dafb3bbd7$var$S(b), null;
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e8dfc29dafb3bbd7$var$Jh();
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
            $e8dfc29dafb3bbd7$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e8dfc29dafb3bbd7$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null));
            $e8dfc29dafb3bbd7$var$Bj(a, b);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 5:
            $e8dfc29dafb3bbd7$var$Lh(b);
            var e = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                    $e8dfc29dafb3bbd7$var$S(b);
                    return null;
                }
                a = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    d[$e8dfc29dafb3bbd7$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e8dfc29dafb3bbd7$var$D("cancel", d);
                            $e8dfc29dafb3bbd7$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], d);
                            break;
                        case "source":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "details":
                            $e8dfc29dafb3bbd7$var$D("toggle", d);
                            break;
                        case "input":
                            $e8dfc29dafb3bbd7$var$Za(d, f);
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$hb(d, f), $e8dfc29dafb3bbd7$var$D("invalid", d);
                    }
                    $e8dfc29dafb3bbd7$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e8dfc29dafb3bbd7$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e8dfc29dafb3bbd7$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e8dfc29dafb3bbd7$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e8dfc29dafb3bbd7$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e8dfc29dafb3bbd7$var$Of] = b;
                    a[$e8dfc29dafb3bbd7$var$Pf] = d;
                    $e8dfc29dafb3bbd7$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e8dfc29dafb3bbd7$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e8dfc29dafb3bbd7$var$D("cancel", a);
                                $e8dfc29dafb3bbd7$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e8dfc29dafb3bbd7$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e8dfc29dafb3bbd7$var$Za(a, d);
                                e = $e8dfc29dafb3bbd7$var$Ya(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e8dfc29dafb3bbd7$var$A({}, d, {
                                    value: void 0
                                });
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$hb(a, d);
                                e = $e8dfc29dafb3bbd7$var$gb(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e8dfc29dafb3bbd7$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e8dfc29dafb3bbd7$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e8dfc29dafb3bbd7$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e8dfc29dafb3bbd7$var$ob(a, k) : "number" === typeof k && $e8dfc29dafb3bbd7$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e8dfc29dafb3bbd7$var$D("scroll", a) : null != k && $e8dfc29dafb3bbd7$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e8dfc29dafb3bbd7$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                c = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
                $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e8dfc29dafb3bbd7$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e8dfc29dafb3bbd7$var$Of] = b, b.stateNode = d;
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e8dfc29dafb3bbd7$var$I && null !== $e8dfc29dafb3bbd7$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e8dfc29dafb3bbd7$var$Hg(), $e8dfc29dafb3bbd7$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e8dfc29dafb3bbd7$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(317));
                        f[$e8dfc29dafb3bbd7$var$Of] = b;
                    } else $e8dfc29dafb3bbd7$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e8dfc29dafb3bbd7$var$S(b);
                    f = !1;
                } else null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e8dfc29dafb3bbd7$var$M.current & 1) ? 0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 3) : $e8dfc29dafb3bbd7$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$Bj(a, b), null === a && $e8dfc29dafb3bbd7$var$sf(b.stateNode.containerInfo), $e8dfc29dafb3bbd7$var$S(b), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), $e8dfc29dafb3bbd7$var$S(b), null;
        case 17:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 19:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            f = b.memoizedState;
            if (null === f) return $e8dfc29dafb3bbd7$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e8dfc29dafb3bbd7$var$Ej(f, !1);
                else {
                    if (0 !== $e8dfc29dafb3bbd7$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e8dfc29dafb3bbd7$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e8dfc29dafb3bbd7$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e8dfc29dafb3bbd7$var$B() > $e8dfc29dafb3bbd7$var$Hj && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e8dfc29dafb3bbd7$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e8dfc29dafb3bbd7$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$S(b), null;
                    } else 2 * $e8dfc29dafb3bbd7$var$B() - f.renderingStartTime > $e8dfc29dafb3bbd7$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e8dfc29dafb3bbd7$var$B(), b.sibling = null, c = $e8dfc29dafb3bbd7$var$M.current, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d ? c & 1 | 2 : c & 1), b;
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e8dfc29dafb3bbd7$var$gj & 1073741824) && ($e8dfc29dafb3bbd7$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e8dfc29dafb3bbd7$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
}
function $e8dfc29dafb3bbd7$var$Jj(a, b) {
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e8dfc29dafb3bbd7$var$Lh(b), null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e8dfc29dafb3bbd7$var$p(340));
                $e8dfc29dafb3bbd7$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M), null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$Kj = !1, $e8dfc29dafb3bbd7$var$U = !1, $e8dfc29dafb3bbd7$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $e8dfc29dafb3bbd7$var$V = null;
function $e8dfc29dafb3bbd7$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e8dfc29dafb3bbd7$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e8dfc29dafb3bbd7$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e8dfc29dafb3bbd7$var$W(a, b, d);
    }
}
var $e8dfc29dafb3bbd7$var$Oj = !1;
function $e8dfc29dafb3bbd7$var$Pj(a, b) {
    $e8dfc29dafb3bbd7$var$Cf = $e8dfc29dafb3bbd7$var$dd;
    a = $e8dfc29dafb3bbd7$var$Me();
    if ($e8dfc29dafb3bbd7$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e8dfc29dafb3bbd7$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e8dfc29dafb3bbd7$var$dd = !1;
    for($e8dfc29dafb3bbd7$var$V = b; null !== $e8dfc29dafb3bbd7$var$V;)if (b = $e8dfc29dafb3bbd7$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e8dfc29dafb3bbd7$var$V = a;
    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
        b = $e8dfc29dafb3bbd7$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e8dfc29dafb3bbd7$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(163));
            }
        } catch (F) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e8dfc29dafb3bbd7$var$V = a;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
    n = $e8dfc29dafb3bbd7$var$Oj;
    $e8dfc29dafb3bbd7$var$Oj = !1;
    return n;
}
function $e8dfc29dafb3bbd7$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e8dfc29dafb3bbd7$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e8dfc29dafb3bbd7$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e8dfc29dafb3bbd7$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e8dfc29dafb3bbd7$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e8dfc29dafb3bbd7$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e8dfc29dafb3bbd7$var$Of], delete b[$e8dfc29dafb3bbd7$var$Pf], delete b[$e8dfc29dafb3bbd7$var$of], delete b[$e8dfc29dafb3bbd7$var$Qf], delete b[$e8dfc29dafb3bbd7$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e8dfc29dafb3bbd7$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e8dfc29dafb3bbd7$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e8dfc29dafb3bbd7$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e8dfc29dafb3bbd7$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling;
}
function $e8dfc29dafb3bbd7$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling;
}
var $e8dfc29dafb3bbd7$var$X = null, $e8dfc29dafb3bbd7$var$Yj = !1;
function $e8dfc29dafb3bbd7$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$e8dfc29dafb3bbd7$var$ak(a, b, c), c = c.sibling;
}
function $e8dfc29dafb3bbd7$var$ak(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount($e8dfc29dafb3bbd7$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Mj(c, b);
        case 6:
            var d = $e8dfc29dafb3bbd7$var$X, e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e8dfc29dafb3bbd7$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? $e8dfc29dafb3bbd7$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e8dfc29dafb3bbd7$var$Kf(a, c), $e8dfc29dafb3bbd7$var$bd(a)) : $e8dfc29dafb3bbd7$var$Kf($e8dfc29dafb3bbd7$var$X, c.stateNode));
            break;
        case 4:
            d = $e8dfc29dafb3bbd7$var$X;
            e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = c.stateNode.containerInfo;
            $e8dfc29dafb3bbd7$var$Yj = !0;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e8dfc29dafb3bbd7$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e8dfc29dafb3bbd7$var$Nj(c, b, g) : 0 !== (f & 4) && $e8dfc29dafb3bbd7$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 1:
            if (!$e8dfc29dafb3bbd7$var$U && ($e8dfc29dafb3bbd7$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e8dfc29dafb3bbd7$var$W(c, b, h);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 21:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (d = $e8dfc29dafb3bbd7$var$U) || null !== c.memoizedState, $e8dfc29dafb3bbd7$var$Zj(a, b, c), $e8dfc29dafb3bbd7$var$U = d) : $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        default:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e8dfc29dafb3bbd7$var$Lj);
        b.forEach(function(b) {
            var d = $e8dfc29dafb3bbd7$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e8dfc29dafb3bbd7$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode;
                        $e8dfc29dafb3bbd7$var$Yj = !1;
                        break a;
                    case 3:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                    case 4:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e8dfc29dafb3bbd7$var$X) throw Error($e8dfc29dafb3bbd7$var$p(160));
            $e8dfc29dafb3bbd7$var$ak(f, g, e);
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e8dfc29dafb3bbd7$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e8dfc29dafb3bbd7$var$ek(b, a), b = b.sibling;
}
function $e8dfc29dafb3bbd7$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                try {
                    $e8dfc29dafb3bbd7$var$Qj(3, a, a.return), $e8dfc29dafb3bbd7$var$Rj(3, a);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
                try {
                    $e8dfc29dafb3bbd7$var$Qj(5, a, a.return);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e8dfc29dafb3bbd7$var$ob(e, "");
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e8dfc29dafb3bbd7$var$ab(e, f);
                    $e8dfc29dafb3bbd7$var$vb(h, g);
                    var l = $e8dfc29dafb3bbd7$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e8dfc29dafb3bbd7$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e8dfc29dafb3bbd7$var$nb(e, q) : "children" === m ? $e8dfc29dafb3bbd7$var$ob(e, q) : $e8dfc29dafb3bbd7$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e8dfc29dafb3bbd7$var$bb(e, f);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e8dfc29dafb3bbd7$var$Pf] = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e8dfc29dafb3bbd7$var$bd(b.containerInfo);
            } catch (t) {
                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e8dfc29dafb3bbd7$var$gk = $e8dfc29dafb3bbd7$var$B()));
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (l = $e8dfc29dafb3bbd7$var$U) || m, $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$U = l) : $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e8dfc29dafb3bbd7$var$V = a, m = a.child; null !== m;){
                    for(q = $e8dfc29dafb3bbd7$var$V = m; null !== $e8dfc29dafb3bbd7$var$V;){
                        r = $e8dfc29dafb3bbd7$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e8dfc29dafb3bbd7$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e8dfc29dafb3bbd7$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e8dfc29dafb3bbd7$var$V = y) : $e8dfc29dafb3bbd7$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e8dfc29dafb3bbd7$var$rb("display", g));
                            } catch (t) {
                                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 21:
            break;
        default:
            $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$fk(a);
    }
}
function $e8dfc29dafb3bbd7$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e8dfc29dafb3bbd7$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e8dfc29dafb3bbd7$var$ob(e, ""), d.flags &= -33);
                    var f = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(161));
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e8dfc29dafb3bbd7$var$ik(a, b, c) {
    $e8dfc29dafb3bbd7$var$V = a;
    $e8dfc29dafb3bbd7$var$jk(a, b, c);
}
function $e8dfc29dafb3bbd7$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e8dfc29dafb3bbd7$var$V;){
        var e = $e8dfc29dafb3bbd7$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e8dfc29dafb3bbd7$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e8dfc29dafb3bbd7$var$U;
                h = $e8dfc29dafb3bbd7$var$Kj;
                var l = $e8dfc29dafb3bbd7$var$U;
                $e8dfc29dafb3bbd7$var$Kj = g;
                if (($e8dfc29dafb3bbd7$var$U = k) && !l) for($e8dfc29dafb3bbd7$var$V = e; null !== $e8dfc29dafb3bbd7$var$V;)g = $e8dfc29dafb3bbd7$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e8dfc29dafb3bbd7$var$kk(e) : null !== k ? (k.return = g, $e8dfc29dafb3bbd7$var$V = k) : $e8dfc29dafb3bbd7$var$kk(e);
                for(; null !== f;)$e8dfc29dafb3bbd7$var$V = f, $e8dfc29dafb3bbd7$var$jk(f, b, c), f = f.sibling;
                $e8dfc29dafb3bbd7$var$V = e;
                $e8dfc29dafb3bbd7$var$Kj = h;
                $e8dfc29dafb3bbd7$var$U = l;
            }
            $e8dfc29dafb3bbd7$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e8dfc29dafb3bbd7$var$V = f) : $e8dfc29dafb3bbd7$var$lk(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$lk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e8dfc29dafb3bbd7$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e8dfc29dafb3bbd7$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e8dfc29dafb3bbd7$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e8dfc29dafb3bbd7$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e8dfc29dafb3bbd7$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e8dfc29dafb3bbd7$var$p(163));
                }
                $e8dfc29dafb3bbd7$var$U || b.flags & 512 && $e8dfc29dafb3bbd7$var$Sj(b);
            } catch (r) {
                $e8dfc29dafb3bbd7$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$hk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$kk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Rj(4, b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e8dfc29dafb3bbd7$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, k);
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e8dfc29dafb3bbd7$var$V = h;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
var $e8dfc29dafb3bbd7$var$mk = Math.ceil, $e8dfc29dafb3bbd7$var$nk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$ok = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$pk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$K = 0, $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Y = null, $e8dfc29dafb3bbd7$var$Z = 0, $e8dfc29dafb3bbd7$var$gj = 0, $e8dfc29dafb3bbd7$var$fj = $e8dfc29dafb3bbd7$var$Uf(0), $e8dfc29dafb3bbd7$var$T = 0, $e8dfc29dafb3bbd7$var$qk = null, $e8dfc29dafb3bbd7$var$hh = 0, $e8dfc29dafb3bbd7$var$rk = 0, $e8dfc29dafb3bbd7$var$sk = 0, $e8dfc29dafb3bbd7$var$tk = null, $e8dfc29dafb3bbd7$var$uk = null, $e8dfc29dafb3bbd7$var$gk = 0, $e8dfc29dafb3bbd7$var$Hj = Infinity, $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Pi = !1, $e8dfc29dafb3bbd7$var$Qi = null, $e8dfc29dafb3bbd7$var$Si = null, $e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = null, $e8dfc29dafb3bbd7$var$yk = 0, $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, $e8dfc29dafb3bbd7$var$Bk = -1, $e8dfc29dafb3bbd7$var$Ck = 0;
function $e8dfc29dafb3bbd7$var$L() {
    return 0 !== ($e8dfc29dafb3bbd7$var$K & 6) ? $e8dfc29dafb3bbd7$var$B() : -1 !== $e8dfc29dafb3bbd7$var$Bk ? $e8dfc29dafb3bbd7$var$Bk : $e8dfc29dafb3bbd7$var$Bk = $e8dfc29dafb3bbd7$var$B();
}
function $e8dfc29dafb3bbd7$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2) && 0 !== $e8dfc29dafb3bbd7$var$Z) return $e8dfc29dafb3bbd7$var$Z & -$e8dfc29dafb3bbd7$var$Z;
    if (null !== $e8dfc29dafb3bbd7$var$Kg.transition) return 0 === $e8dfc29dafb3bbd7$var$Ck && ($e8dfc29dafb3bbd7$var$Ck = $e8dfc29dafb3bbd7$var$yc()), $e8dfc29dafb3bbd7$var$Ck;
    a = $e8dfc29dafb3bbd7$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e8dfc29dafb3bbd7$var$jd(a.type);
    return a;
}
function $e8dfc29dafb3bbd7$var$mh(a, b, c, d) {
    if (50 < $e8dfc29dafb3bbd7$var$zk) throw $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, Error($e8dfc29dafb3bbd7$var$p(185));
    $e8dfc29dafb3bbd7$var$Ac(a, c, d);
    if (0 === ($e8dfc29dafb3bbd7$var$K & 2) || a !== $e8dfc29dafb3bbd7$var$R) a === $e8dfc29dafb3bbd7$var$R && (0 === ($e8dfc29dafb3bbd7$var$K & 2) && ($e8dfc29dafb3bbd7$var$rk |= c), 4 === $e8dfc29dafb3bbd7$var$T && $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$Z)), $e8dfc29dafb3bbd7$var$Ek(a, d), 1 === c && 0 === $e8dfc29dafb3bbd7$var$K && 0 === (b.mode & 1) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
}
function $e8dfc29dafb3bbd7$var$Ek(a, b) {
    var c = a.callbackNode;
    $e8dfc29dafb3bbd7$var$wc(a, b);
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) null !== c && $e8dfc29dafb3bbd7$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e8dfc29dafb3bbd7$var$bc(c);
        if (1 === b) 0 === a.tag ? $e8dfc29dafb3bbd7$var$ig($e8dfc29dafb3bbd7$var$Fk.bind(null, a)) : $e8dfc29dafb3bbd7$var$hg($e8dfc29dafb3bbd7$var$Fk.bind(null, a)), $e8dfc29dafb3bbd7$var$Jf(function() {
            0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
        }), c = null;
        else {
            switch($e8dfc29dafb3bbd7$var$Dc(d)){
                case 1:
                    c = $e8dfc29dafb3bbd7$var$fc;
                    break;
                case 4:
                    c = $e8dfc29dafb3bbd7$var$gc;
                    break;
                case 16:
                    c = $e8dfc29dafb3bbd7$var$hc;
                    break;
                case 536870912:
                    c = $e8dfc29dafb3bbd7$var$jc;
                    break;
                default:
                    c = $e8dfc29dafb3bbd7$var$hc;
            }
            c = $e8dfc29dafb3bbd7$var$Gk(c, $e8dfc29dafb3bbd7$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e8dfc29dafb3bbd7$var$Hk(a, b) {
    $e8dfc29dafb3bbd7$var$Bk = -1;
    $e8dfc29dafb3bbd7$var$Ck = 0;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    var c = a.callbackNode;
    if ($e8dfc29dafb3bbd7$var$Ik() && a.callbackNode !== c) return null;
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e8dfc29dafb3bbd7$var$Jk(a, d);
    else {
        b = d;
        var e = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 2;
        var f = $e8dfc29dafb3bbd7$var$Kk();
        if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$Lk(a, b);
        for(;;)try {
            $e8dfc29dafb3bbd7$var$Mk();
            break;
        } catch (h) {
            $e8dfc29dafb3bbd7$var$Nk(a, h);
        }
        $e8dfc29dafb3bbd7$var$Qg();
        $e8dfc29dafb3bbd7$var$nk.current = f;
        $e8dfc29dafb3bbd7$var$K = e;
        null !== $e8dfc29dafb3bbd7$var$Y ? b = 0 : ($e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0, b = $e8dfc29dafb3bbd7$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e8dfc29dafb3bbd7$var$xc(a), 0 !== e && (d = e, b = $e8dfc29dafb3bbd7$var$Ok(a, e)));
        if (1 === b) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
        if (6 === b) $e8dfc29dafb3bbd7$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e8dfc29dafb3bbd7$var$Pk(e) && (b = $e8dfc29dafb3bbd7$var$Jk(a, d), 2 === b && (f = $e8dfc29dafb3bbd7$var$xc(a), 0 !== f && (d = f, b = $e8dfc29dafb3bbd7$var$Ok(a, f))), 1 === b)) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e8dfc29dafb3bbd7$var$p(345));
                case 2:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 3:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $e8dfc29dafb3bbd7$var$gk + 500 - $e8dfc29dafb3bbd7$var$B(), 10 < b)) {
                        if (0 !== $e8dfc29dafb3bbd7$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e8dfc29dafb3bbd7$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), b);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 4:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e8dfc29dafb3bbd7$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e8dfc29dafb3bbd7$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e8dfc29dafb3bbd7$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), d);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 5:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(329));
            }
        }
    }
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return a.callbackNode === c ? $e8dfc29dafb3bbd7$var$Hk.bind(null, a) : null;
}
function $e8dfc29dafb3bbd7$var$Ok(a, b) {
    var c = $e8dfc29dafb3bbd7$var$tk;
    a.current.memoizedState.isDehydrated && ($e8dfc29dafb3bbd7$var$Lk(a, b).flags |= 256);
    a = $e8dfc29dafb3bbd7$var$Jk(a, b);
    2 !== a && (b = $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$uk = c, null !== b && $e8dfc29dafb3bbd7$var$Gj(b));
    return a;
}
function $e8dfc29dafb3bbd7$var$Gj(a) {
    null === $e8dfc29dafb3bbd7$var$uk ? $e8dfc29dafb3bbd7$var$uk = a : $e8dfc29dafb3bbd7$var$uk.push.apply($e8dfc29dafb3bbd7$var$uk, a);
}
function $e8dfc29dafb3bbd7$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e8dfc29dafb3bbd7$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Dk(a, b) {
    b &= ~$e8dfc29dafb3bbd7$var$sk;
    b &= ~$e8dfc29dafb3bbd7$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e8dfc29dafb3bbd7$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e8dfc29dafb3bbd7$var$Fk(a) {
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$uc(a, 0);
    if (0 === (b & 1)) return $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), null;
    var c = $e8dfc29dafb3bbd7$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e8dfc29dafb3bbd7$var$xc(a);
        0 !== d && (b = d, c = $e8dfc29dafb3bbd7$var$Ok(a, d));
    }
    if (1 === c) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, b), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
    if (6 === c) throw Error($e8dfc29dafb3bbd7$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return null;
}
function $e8dfc29dafb3bbd7$var$Rk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e8dfc29dafb3bbd7$var$K = c, 0 === $e8dfc29dafb3bbd7$var$K && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
    }
}
function $e8dfc29dafb3bbd7$var$Sk(a) {
    null !== $e8dfc29dafb3bbd7$var$xk && 0 === $e8dfc29dafb3bbd7$var$xk.tag && 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    var c = $e8dfc29dafb3bbd7$var$pk.transition, d = $e8dfc29dafb3bbd7$var$C;
    try {
        if ($e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, a) return a();
    } finally{
        $e8dfc29dafb3bbd7$var$C = d, $e8dfc29dafb3bbd7$var$pk.transition = c, $e8dfc29dafb3bbd7$var$K = b, 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
    }
}
function $e8dfc29dafb3bbd7$var$Ij() {
    $e8dfc29dafb3bbd7$var$gj = $e8dfc29dafb3bbd7$var$fj.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$fj);
}
function $e8dfc29dafb3bbd7$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e8dfc29dafb3bbd7$var$Gf(c));
    if (null !== $e8dfc29dafb3bbd7$var$Y) for(c = $e8dfc29dafb3bbd7$var$Y.return; null !== c;){
        var d = c;
        $e8dfc29dafb3bbd7$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e8dfc29dafb3bbd7$var$$f();
                break;
            case 3:
                $e8dfc29dafb3bbd7$var$Jh();
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
                $e8dfc29dafb3bbd7$var$Oh();
                break;
            case 5:
                $e8dfc29dafb3bbd7$var$Lh(d);
                break;
            case 4:
                $e8dfc29dafb3bbd7$var$Jh();
                break;
            case 13:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 19:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 10:
                $e8dfc29dafb3bbd7$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $e8dfc29dafb3bbd7$var$Ij();
        }
        c = c.return;
    }
    $e8dfc29dafb3bbd7$var$R = a;
    $e8dfc29dafb3bbd7$var$Y = a = $e8dfc29dafb3bbd7$var$wh(a.current, null);
    $e8dfc29dafb3bbd7$var$Z = $e8dfc29dafb3bbd7$var$gj = b;
    $e8dfc29dafb3bbd7$var$T = 0;
    $e8dfc29dafb3bbd7$var$qk = null;
    $e8dfc29dafb3bbd7$var$sk = $e8dfc29dafb3bbd7$var$rk = $e8dfc29dafb3bbd7$var$hh = 0;
    $e8dfc29dafb3bbd7$var$uk = $e8dfc29dafb3bbd7$var$tk = null;
    if (null !== $e8dfc29dafb3bbd7$var$Wg) {
        for(b = 0; b < $e8dfc29dafb3bbd7$var$Wg.length; b++)if (c = $e8dfc29dafb3bbd7$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e8dfc29dafb3bbd7$var$Wg = null;
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Nk(a, b) {
    do {
        var c = $e8dfc29dafb3bbd7$var$Y;
        try {
            $e8dfc29dafb3bbd7$var$Qg();
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
            if ($e8dfc29dafb3bbd7$var$Sh) {
                for(var d = $e8dfc29dafb3bbd7$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e8dfc29dafb3bbd7$var$Sh = !1;
            }
            $e8dfc29dafb3bbd7$var$Rh = 0;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            $e8dfc29dafb3bbd7$var$ok.current = null;
            if (null === c || null === c.return) {
                $e8dfc29dafb3bbd7$var$T = 1;
                $e8dfc29dafb3bbd7$var$qk = b;
                $e8dfc29dafb3bbd7$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e8dfc29dafb3bbd7$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e8dfc29dafb3bbd7$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                            $e8dfc29dafb3bbd7$var$uj();
                            break a;
                        }
                        k = Error($e8dfc29dafb3bbd7$var$p(426));
                    }
                } else if ($e8dfc29dafb3bbd7$var$I && h.mode & 1) {
                    var J = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e8dfc29dafb3bbd7$var$Wi(J, g, h, f, b);
                        $e8dfc29dafb3bbd7$var$Jg($e8dfc29dafb3bbd7$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $e8dfc29dafb3bbd7$var$Ki(k, h);
                4 !== $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 2);
                null === $e8dfc29dafb3bbd7$var$tk ? $e8dfc29dafb3bbd7$var$tk = [
                    f
                ] : $e8dfc29dafb3bbd7$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e8dfc29dafb3bbd7$var$Oi(f, k, b);
                            $e8dfc29dafb3bbd7$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e8dfc29dafb3bbd7$var$Ri(f, h, b);
                                $e8dfc29dafb3bbd7$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e8dfc29dafb3bbd7$var$Tk(c);
        } catch (na) {
            b = na;
            $e8dfc29dafb3bbd7$var$Y === c && null !== c && ($e8dfc29dafb3bbd7$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e8dfc29dafb3bbd7$var$Kk() {
    var a = $e8dfc29dafb3bbd7$var$nk.current;
    $e8dfc29dafb3bbd7$var$nk.current = $e8dfc29dafb3bbd7$var$ai;
    return null === a ? $e8dfc29dafb3bbd7$var$ai : a;
}
function $e8dfc29dafb3bbd7$var$uj() {
    if (0 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T || 2 === $e8dfc29dafb3bbd7$var$T) $e8dfc29dafb3bbd7$var$T = 4;
    null === $e8dfc29dafb3bbd7$var$R || 0 === ($e8dfc29dafb3bbd7$var$hh & 268435455) && 0 === ($e8dfc29dafb3bbd7$var$rk & 268435455) || $e8dfc29dafb3bbd7$var$Dk($e8dfc29dafb3bbd7$var$R, $e8dfc29dafb3bbd7$var$Z);
}
function $e8dfc29dafb3bbd7$var$Jk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 2;
    var d = $e8dfc29dafb3bbd7$var$Kk();
    if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Lk(a, b);
    for(;;)try {
        $e8dfc29dafb3bbd7$var$Uk();
        break;
    } catch (e) {
        $e8dfc29dafb3bbd7$var$Nk(a, e);
    }
    $e8dfc29dafb3bbd7$var$Qg();
    $e8dfc29dafb3bbd7$var$K = c;
    $e8dfc29dafb3bbd7$var$nk.current = d;
    if (null !== $e8dfc29dafb3bbd7$var$Y) throw Error($e8dfc29dafb3bbd7$var$p(261));
    $e8dfc29dafb3bbd7$var$R = null;
    $e8dfc29dafb3bbd7$var$Z = 0;
    return $e8dfc29dafb3bbd7$var$T;
}
function $e8dfc29dafb3bbd7$var$Uk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y;)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Mk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y && !$e8dfc29dafb3bbd7$var$cc();)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Vk(a) {
    var b = $e8dfc29dafb3bbd7$var$Wk(a.alternate, a, $e8dfc29dafb3bbd7$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e8dfc29dafb3bbd7$var$Tk(a) : $e8dfc29dafb3bbd7$var$Y = b;
    $e8dfc29dafb3bbd7$var$ok.current = null;
}
function $e8dfc29dafb3bbd7$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e8dfc29dafb3bbd7$var$Fj(c, b, $e8dfc29dafb3bbd7$var$gj), null !== c) {
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
        } else {
            c = $e8dfc29dafb3bbd7$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e8dfc29dafb3bbd7$var$T = 6;
                $e8dfc29dafb3bbd7$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e8dfc29dafb3bbd7$var$Y = b;
            return;
        }
        $e8dfc29dafb3bbd7$var$Y = b = a;
    }while (null !== b);
    0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 5);
}
function $e8dfc29dafb3bbd7$var$Qk(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$C, e = $e8dfc29dafb3bbd7$var$pk.transition;
    try {
        $e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$Xk(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$pk.transition = e, $e8dfc29dafb3bbd7$var$C = d;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xk(a, b, c, d) {
    do $e8dfc29dafb3bbd7$var$Ik();
    while (null !== $e8dfc29dafb3bbd7$var$xk);
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e8dfc29dafb3bbd7$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e8dfc29dafb3bbd7$var$Bc(a, f);
    a === $e8dfc29dafb3bbd7$var$R && ($e8dfc29dafb3bbd7$var$Y = $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e8dfc29dafb3bbd7$var$wk || ($e8dfc29dafb3bbd7$var$wk = !0, $e8dfc29dafb3bbd7$var$Gk($e8dfc29dafb3bbd7$var$hc, function() {
        $e8dfc29dafb3bbd7$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e8dfc29dafb3bbd7$var$pk.transition;
        $e8dfc29dafb3bbd7$var$pk.transition = null;
        var g = $e8dfc29dafb3bbd7$var$C;
        $e8dfc29dafb3bbd7$var$C = 1;
        var h = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 4;
        $e8dfc29dafb3bbd7$var$ok.current = null;
        $e8dfc29dafb3bbd7$var$Pj(a, c);
        $e8dfc29dafb3bbd7$var$ek(c, a);
        $e8dfc29dafb3bbd7$var$Oe($e8dfc29dafb3bbd7$var$Df);
        $e8dfc29dafb3bbd7$var$dd = !!$e8dfc29dafb3bbd7$var$Cf;
        $e8dfc29dafb3bbd7$var$Df = $e8dfc29dafb3bbd7$var$Cf = null;
        a.current = c;
        $e8dfc29dafb3bbd7$var$ik(c, a, e);
        $e8dfc29dafb3bbd7$var$dc();
        $e8dfc29dafb3bbd7$var$K = h;
        $e8dfc29dafb3bbd7$var$C = g;
        $e8dfc29dafb3bbd7$var$pk.transition = f;
    } else a.current = c;
    $e8dfc29dafb3bbd7$var$wk && ($e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = a, $e8dfc29dafb3bbd7$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($e8dfc29dafb3bbd7$var$Si = null);
    $e8dfc29dafb3bbd7$var$mc(c.stateNode, d);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e8dfc29dafb3bbd7$var$Pi) throw $e8dfc29dafb3bbd7$var$Pi = !1, a = $e8dfc29dafb3bbd7$var$Qi, $e8dfc29dafb3bbd7$var$Qi = null, a;
    0 !== ($e8dfc29dafb3bbd7$var$yk & 1) && 0 !== a.tag && $e8dfc29dafb3bbd7$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e8dfc29dafb3bbd7$var$Ak ? $e8dfc29dafb3bbd7$var$zk++ : ($e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = a) : $e8dfc29dafb3bbd7$var$zk = 0;
    $e8dfc29dafb3bbd7$var$jg();
    return null;
}
function $e8dfc29dafb3bbd7$var$Ik() {
    if (null !== $e8dfc29dafb3bbd7$var$xk) {
        var a = $e8dfc29dafb3bbd7$var$Dc($e8dfc29dafb3bbd7$var$yk), b = $e8dfc29dafb3bbd7$var$pk.transition, c = $e8dfc29dafb3bbd7$var$C;
        try {
            $e8dfc29dafb3bbd7$var$pk.transition = null;
            $e8dfc29dafb3bbd7$var$C = 16 > a ? 16 : a;
            if (null === $e8dfc29dafb3bbd7$var$xk) var d = !1;
            else {
                a = $e8dfc29dafb3bbd7$var$xk;
                $e8dfc29dafb3bbd7$var$xk = null;
                $e8dfc29dafb3bbd7$var$yk = 0;
                if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(331));
                var e = $e8dfc29dafb3bbd7$var$K;
                $e8dfc29dafb3bbd7$var$K |= 4;
                for($e8dfc29dafb3bbd7$var$V = a.current; null !== $e8dfc29dafb3bbd7$var$V;){
                    var f = $e8dfc29dafb3bbd7$var$V, g = f.child;
                    if (0 !== ($e8dfc29dafb3bbd7$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e8dfc29dafb3bbd7$var$V = l; null !== $e8dfc29dafb3bbd7$var$V;){
                                    var m = $e8dfc29dafb3bbd7$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e8dfc29dafb3bbd7$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e8dfc29dafb3bbd7$var$V = q;
                                    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
                                        m = $e8dfc29dafb3bbd7$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e8dfc29dafb3bbd7$var$Tj(m);
                                        if (m === l) {
                                            $e8dfc29dafb3bbd7$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e8dfc29dafb3bbd7$var$V = r;
                                            break;
                                        }
                                        $e8dfc29dafb3bbd7$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e8dfc29dafb3bbd7$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e8dfc29dafb3bbd7$var$V = g;
                    else b: for(; null !== $e8dfc29dafb3bbd7$var$V;){
                        f = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e8dfc29dafb3bbd7$var$V = x;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e8dfc29dafb3bbd7$var$V = w; null !== $e8dfc29dafb3bbd7$var$V;){
                    g = $e8dfc29dafb3bbd7$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e8dfc29dafb3bbd7$var$V = u;
                    else b: for(g = w; null !== $e8dfc29dafb3bbd7$var$V;){
                        h = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e8dfc29dafb3bbd7$var$Rj(9, h);
                            }
                        } catch (na) {
                            $e8dfc29dafb3bbd7$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e8dfc29dafb3bbd7$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e8dfc29dafb3bbd7$var$V = F;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = h.return;
                    }
                }
                $e8dfc29dafb3bbd7$var$K = e;
                $e8dfc29dafb3bbd7$var$jg();
                if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot) try {
                    $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$pk.transition = b;
        }
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Yk(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Ki(c, b);
    b = $e8dfc29dafb3bbd7$var$Oi(a, b, 1);
    a = $e8dfc29dafb3bbd7$var$dh(a, b, 1);
    b = $e8dfc29dafb3bbd7$var$L();
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, 1, b), $e8dfc29dafb3bbd7$var$Ek(a, b));
}
function $e8dfc29dafb3bbd7$var$W(a, b, c) {
    if (3 === a.tag) $e8dfc29dafb3bbd7$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e8dfc29dafb3bbd7$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(d))) {
                a = $e8dfc29dafb3bbd7$var$Ki(c, a);
                a = $e8dfc29dafb3bbd7$var$Ri(b, a, 1);
                b = $e8dfc29dafb3bbd7$var$dh(b, a, 1);
                a = $e8dfc29dafb3bbd7$var$L();
                null !== b && ($e8dfc29dafb3bbd7$var$Ac(b, 1, a), $e8dfc29dafb3bbd7$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e8dfc29dafb3bbd7$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $e8dfc29dafb3bbd7$var$R === a && ($e8dfc29dafb3bbd7$var$Z & c) === c && (4 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$Z & 130023424) === $e8dfc29dafb3bbd7$var$Z && 500 > $e8dfc29dafb3bbd7$var$B() - $e8dfc29dafb3bbd7$var$gk ? $e8dfc29dafb3bbd7$var$Lk(a, 0) : $e8dfc29dafb3bbd7$var$sk |= c);
    $e8dfc29dafb3bbd7$var$Ek(a, b);
}
function $e8dfc29dafb3bbd7$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e8dfc29dafb3bbd7$var$sc, $e8dfc29dafb3bbd7$var$sc <<= 1, 0 === ($e8dfc29dafb3bbd7$var$sc & 130023424) && ($e8dfc29dafb3bbd7$var$sc = 4194304)));
    var c = $e8dfc29dafb3bbd7$var$L();
    a = $e8dfc29dafb3bbd7$var$Zg(a, b);
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, b, c), $e8dfc29dafb3bbd7$var$Ek(a, c));
}
function $e8dfc29dafb3bbd7$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
function $e8dfc29dafb3bbd7$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e8dfc29dafb3bbd7$var$p(314));
    }
    null !== d && d.delete(b);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
var $e8dfc29dafb3bbd7$var$Wk;
$e8dfc29dafb3bbd7$var$Wk = function Wk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e8dfc29dafb3bbd7$var$Wf.current) $e8dfc29dafb3bbd7$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$zj(a, b, c);
            $e8dfc29dafb3bbd7$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$I && 0 !== (b.flags & 1048576) && $e8dfc29dafb3bbd7$var$ug(b, $e8dfc29dafb3bbd7$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e8dfc29dafb3bbd7$var$jj(a, b);
            a = b.pendingProps;
            var e = $e8dfc29dafb3bbd7$var$Yf(b, $e8dfc29dafb3bbd7$var$H.current);
            $e8dfc29dafb3bbd7$var$Tg(b, c);
            e = $e8dfc29dafb3bbd7$var$Xh(null, b, d, a, e, c);
            var f = $e8dfc29dafb3bbd7$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e8dfc29dafb3bbd7$var$Zf(d) ? (f = !0, $e8dfc29dafb3bbd7$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e8dfc29dafb3bbd7$var$ah(b), e.updater = $e8dfc29dafb3bbd7$var$nh, b.stateNode = e, e._reactInternals = b, $e8dfc29dafb3bbd7$var$rh(b, d, a, c), b = $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $e8dfc29dafb3bbd7$var$I && f && $e8dfc29dafb3bbd7$var$vg(b), $e8dfc29dafb3bbd7$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e8dfc29dafb3bbd7$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e8dfc29dafb3bbd7$var$$k(d);
                a = $e8dfc29dafb3bbd7$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $e8dfc29dafb3bbd7$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e8dfc29dafb3bbd7$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e8dfc29dafb3bbd7$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e8dfc29dafb3bbd7$var$aj(null, b, d, $e8dfc29dafb3bbd7$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $e8dfc29dafb3bbd7$var$lj(b);
                if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e8dfc29dafb3bbd7$var$bh(a, b);
                $e8dfc29dafb3bbd7$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(423)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(424)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else for($e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.stateNode.containerInfo.firstChild), $e8dfc29dafb3bbd7$var$xg = b, $e8dfc29dafb3bbd7$var$I = !0, $e8dfc29dafb3bbd7$var$zg = null, c = $e8dfc29dafb3bbd7$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e8dfc29dafb3bbd7$var$Ig();
                    if (d === e) {
                        b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                        break a;
                    }
                    $e8dfc29dafb3bbd7$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e8dfc29dafb3bbd7$var$Kh(b), null === a && $e8dfc29dafb3bbd7$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e8dfc29dafb3bbd7$var$Ef(d, e) ? g = null : null !== f && $e8dfc29dafb3bbd7$var$Ef(d, f) && (b.flags |= 32), $e8dfc29dafb3bbd7$var$hj(a, b), $e8dfc29dafb3bbd7$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $e8dfc29dafb3bbd7$var$Eg(b), null;
        case 13:
            return $e8dfc29dafb3bbd7$var$pj(a, b, c);
        case 4:
            return $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, d, c) : $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$Zi(a, b, d, e, c);
        case 7:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e8dfc29dafb3bbd7$var$He(f.value, g)) {
                        if (f.children === e.children && !$e8dfc29dafb3bbd7$var$Wf.current) {
                            b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e8dfc29dafb3bbd7$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e8dfc29dafb3bbd7$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e8dfc29dafb3bbd7$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e8dfc29dafb3bbd7$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e8dfc29dafb3bbd7$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e8dfc29dafb3bbd7$var$Tg(b, c), e = $e8dfc29dafb3bbd7$var$Vg(e), d = d(e), b.flags |= 1, $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e8dfc29dafb3bbd7$var$Lg(d, b.pendingProps), e = $e8dfc29dafb3bbd7$var$Lg(d.type, e), $e8dfc29dafb3bbd7$var$aj(a, b, d, e, c);
        case 15:
            return $e8dfc29dafb3bbd7$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$jj(a, b), b.tag = 1, $e8dfc29dafb3bbd7$var$Zf(d) ? (a = !0, $e8dfc29dafb3bbd7$var$cg(b)) : a = !1, $e8dfc29dafb3bbd7$var$Tg(b, c), $e8dfc29dafb3bbd7$var$ph(b, d, e), $e8dfc29dafb3bbd7$var$rh(b, d, e, c), $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, a, c);
        case 19:
            return $e8dfc29dafb3bbd7$var$yj(a, b, c);
        case 22:
            return $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
};
function $e8dfc29dafb3bbd7$var$Gk(a, b) {
    return $e8dfc29dafb3bbd7$var$ac(a, b);
}
function $e8dfc29dafb3bbd7$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e8dfc29dafb3bbd7$var$Bg(a, b, c, d) {
    return new $e8dfc29dafb3bbd7$var$al(a, b, c, d);
}
function $e8dfc29dafb3bbd7$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e8dfc29dafb3bbd7$var$$k(a) {
    if ("function" === typeof a) return $e8dfc29dafb3bbd7$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e8dfc29dafb3bbd7$var$Da) return 11;
        if (a === $e8dfc29dafb3bbd7$var$Ga) return 14;
    }
    return 2;
}
function $e8dfc29dafb3bbd7$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $e8dfc29dafb3bbd7$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e8dfc29dafb3bbd7$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e8dfc29dafb3bbd7$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return $e8dfc29dafb3bbd7$var$Ah(c.children, e, f, b);
        case $e8dfc29dafb3bbd7$var$za:
            g = 8;
            e |= 8;
            break;
        case $e8dfc29dafb3bbd7$var$Aa:
            return a = $e8dfc29dafb3bbd7$var$Bg(12, c, b, e | 2), a.elementType = $e8dfc29dafb3bbd7$var$Aa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ea:
            return a = $e8dfc29dafb3bbd7$var$Bg(13, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Ea, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Fa:
            return a = $e8dfc29dafb3bbd7$var$Bg(19, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Fa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ia:
            return $e8dfc29dafb3bbd7$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e8dfc29dafb3bbd7$var$Ba:
                    g = 10;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ca:
                    g = 9;
                    break a;
                case $e8dfc29dafb3bbd7$var$Da:
                    g = 11;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ga:
                    g = 14;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $1ObTH._)(a), ""));
    }
    b = $e8dfc29dafb3bbd7$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e8dfc29dafb3bbd7$var$Ah(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$qj(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(22, a, d, b);
    a.elementType = $e8dfc29dafb3bbd7$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e8dfc29dafb3bbd7$var$xh(a, b, c) {
    a = $e8dfc29dafb3bbd7$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$zh(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e8dfc29dafb3bbd7$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e8dfc29dafb3bbd7$var$zc(0);
    this.expirationTimes = $e8dfc29dafb3bbd7$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e8dfc29dafb3bbd7$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e8dfc29dafb3bbd7$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $e8dfc29dafb3bbd7$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e8dfc29dafb3bbd7$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e8dfc29dafb3bbd7$var$ah(f);
    return a;
}
function $e8dfc29dafb3bbd7$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e8dfc29dafb3bbd7$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e8dfc29dafb3bbd7$var$el(a) {
    if (!a) return $e8dfc29dafb3bbd7$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e8dfc29dafb3bbd7$var$Vb(a) !== a || 1 !== a.tag) throw Error($e8dfc29dafb3bbd7$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e8dfc29dafb3bbd7$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e8dfc29dafb3bbd7$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e8dfc29dafb3bbd7$var$Zf(c)) return $e8dfc29dafb3bbd7$var$bg(a, c, b);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $e8dfc29dafb3bbd7$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $e8dfc29dafb3bbd7$var$el(null);
    c = a.current;
    d = $e8dfc29dafb3bbd7$var$L();
    e = $e8dfc29dafb3bbd7$var$lh(c);
    f = $e8dfc29dafb3bbd7$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e8dfc29dafb3bbd7$var$dh(c, f, e);
    a.current.lanes = e;
    $e8dfc29dafb3bbd7$var$Ac(a, e, d);
    $e8dfc29dafb3bbd7$var$Ek(a, d);
    return a;
}
function $e8dfc29dafb3bbd7$var$gl(a, b, c, d) {
    var e = b.current, f = $e8dfc29dafb3bbd7$var$L(), g = $e8dfc29dafb3bbd7$var$lh(e);
    c = $e8dfc29dafb3bbd7$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e8dfc29dafb3bbd7$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e8dfc29dafb3bbd7$var$dh(e, b, g);
    null !== a && ($e8dfc29dafb3bbd7$var$mh(a, e, g, f), $e8dfc29dafb3bbd7$var$eh(a, e, g));
    return g;
}
function $e8dfc29dafb3bbd7$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e8dfc29dafb3bbd7$var$jl(a, b) {
    $e8dfc29dafb3bbd7$var$il(a, b);
    (a = a.alternate) && $e8dfc29dafb3bbd7$var$il(a, b);
}
function $e8dfc29dafb3bbd7$var$kl() {
    return null;
}
var $e8dfc29dafb3bbd7$var$ll = "function" === typeof reportError ? reportError : function ll(a) {
    console.error(a);
};
function $e8dfc29dafb3bbd7$var$ml(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.render = $e8dfc29dafb3bbd7$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(409));
    $e8dfc29dafb3bbd7$var$gl(a, b, null, null);
};
$e8dfc29dafb3bbd7$var$nl.prototype.unmount = $e8dfc29dafb3bbd7$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e8dfc29dafb3bbd7$var$Sk(function() {
            $e8dfc29dafb3bbd7$var$gl(null, a, null, null);
        });
        b[$e8dfc29dafb3bbd7$var$uf] = null;
    }
};
function $e8dfc29dafb3bbd7$var$nl(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e8dfc29dafb3bbd7$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length && 0 !== b && b < $e8dfc29dafb3bbd7$var$Qc[c].priority; c++);
        $e8dfc29dafb3bbd7$var$Qc.splice(c, 0, a);
        0 === c && $e8dfc29dafb3bbd7$var$Vc(a);
    }
};
function $e8dfc29dafb3bbd7$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e8dfc29dafb3bbd7$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e8dfc29dafb3bbd7$var$ql() {}
function $e8dfc29dafb3bbd7$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $e8dfc29dafb3bbd7$var$hl(g);
                f.call(_$a);
            };
        }
        var g = $e8dfc29dafb3bbd7$var$fl(b, d, a, 0, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
        a._reactRootContainer = g;
        a[$e8dfc29dafb3bbd7$var$uf] = g.current;
        $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e8dfc29dafb3bbd7$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $e8dfc29dafb3bbd7$var$hl(k);
            h.call(_$a);
        };
    }
    var k = $e8dfc29dafb3bbd7$var$cl(a, 0, !1, null, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
    a._reactRootContainer = k;
    a[$e8dfc29dafb3bbd7$var$uf] = k.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$gl(b, k, c, d);
    });
    return k;
}
function $e8dfc29dafb3bbd7$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $e8dfc29dafb3bbd7$var$hl(g);
                h.call(_$a);
            };
        }
        $e8dfc29dafb3bbd7$var$gl(b, g, a, e);
    } else g = $e8dfc29dafb3bbd7$var$rl(c, b, a, e, d);
    return $e8dfc29dafb3bbd7$var$hl(g);
}
$e8dfc29dafb3bbd7$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e8dfc29dafb3bbd7$var$tc(b.pendingLanes);
                0 !== c && ($e8dfc29dafb3bbd7$var$Cc(b, c | 1), $e8dfc29dafb3bbd7$var$Ek(b, $e8dfc29dafb3bbd7$var$B()), 0 === ($e8dfc29dafb3bbd7$var$K & 6) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$jg()));
            }
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$Sk(function() {
                var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
                if (null !== b) {
                    var c = $e8dfc29dafb3bbd7$var$L();
                    $e8dfc29dafb3bbd7$var$mh(b, a, 1, c);
                }
            }), $e8dfc29dafb3bbd7$var$jl(a, 1);
    }
};
$e8dfc29dafb3bbd7$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(b, a, 134217728, c);
        }
        $e8dfc29dafb3bbd7$var$jl(a, 134217728);
    }
};
$e8dfc29dafb3bbd7$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$lh(a), c = $e8dfc29dafb3bbd7$var$Zg(a, b);
        if (null !== c) {
            var d = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(c, a, b, d);
        }
        $e8dfc29dafb3bbd7$var$jl(a, b);
    }
};
$e8dfc29dafb3bbd7$var$Hc = function Hc() {
    return $e8dfc29dafb3bbd7$var$C;
};
$e8dfc29dafb3bbd7$var$Ic = function Ic(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    try {
        return $e8dfc29dafb3bbd7$var$C = a, b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c;
    }
};
$e8dfc29dafb3bbd7$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $e8dfc29dafb3bbd7$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e8dfc29dafb3bbd7$var$Db(d);
                        if (!e) throw Error($e8dfc29dafb3bbd7$var$p(90));
                        $e8dfc29dafb3bbd7$var$Wa(d);
                        $e8dfc29dafb3bbd7$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e8dfc29dafb3bbd7$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e8dfc29dafb3bbd7$var$fb(a, !!c.multiple, b, !1);
    }
};
$e8dfc29dafb3bbd7$var$Gb = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$var$Hb = $e8dfc29dafb3bbd7$var$Sk;
var $e8dfc29dafb3bbd7$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $e8dfc29dafb3bbd7$var$Cb,
        $e8dfc29dafb3bbd7$var$ue,
        $e8dfc29dafb3bbd7$var$Db,
        $e8dfc29dafb3bbd7$var$Eb,
        $e8dfc29dafb3bbd7$var$Fb,
        $e8dfc29dafb3bbd7$var$Rk
    ]
}, $e8dfc29dafb3bbd7$var$ul = {
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $e8dfc29dafb3bbd7$var$vl = {
    bundleType: $e8dfc29dafb3bbd7$var$ul.bundleType,
    version: $e8dfc29dafb3bbd7$var$ul.version,
    rendererPackageName: $e8dfc29dafb3bbd7$var$ul.rendererPackageName,
    rendererConfig: $e8dfc29dafb3bbd7$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $e8dfc29dafb3bbd7$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$ul.findFiberByHostInstance || $e8dfc29dafb3bbd7$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e8dfc29dafb3bbd7$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e8dfc29dafb3bbd7$var$wl.isDisabled && $e8dfc29dafb3bbd7$var$wl.supportsFiber) try {
        $e8dfc29dafb3bbd7$var$kc = $e8dfc29dafb3bbd7$var$wl.inject($e8dfc29dafb3bbd7$var$vl), $e8dfc29dafb3bbd7$var$lc = $e8dfc29dafb3bbd7$var$wl;
    } catch (a) {}
}
$e8dfc29dafb3bbd7$export$ae55be85d98224ed = $e8dfc29dafb3bbd7$var$tl;
$e8dfc29dafb3bbd7$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e8dfc29dafb3bbd7$var$ol(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$dl(a, b, null, c);
};
$e8dfc29dafb3bbd7$export$882461b6382ed46c = function(a, b) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(299));
    var c = !1, d = "", e = $e8dfc29dafb3bbd7$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e8dfc29dafb3bbd7$var$ml(b);
};
$e8dfc29dafb3bbd7$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e8dfc29dafb3bbd7$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e8dfc29dafb3bbd7$var$p(268, a));
    }
    a = $e8dfc29dafb3bbd7$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = function(a) {
    return $e8dfc29dafb3bbd7$var$Sk(a);
};
$e8dfc29dafb3bbd7$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !0, c);
};
$e8dfc29dafb3bbd7$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e8dfc29dafb3bbd7$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e8dfc29dafb3bbd7$var$nl(b);
};
$e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !1, c);
};
$e8dfc29dafb3bbd7$export$502457920280e6be = function(a) {
    if (!$e8dfc29dafb3bbd7$var$pl(a)) throw Error($e8dfc29dafb3bbd7$var$p(40));
    return a._reactRootContainer ? ($e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e8dfc29dafb3bbd7$var$uf] = null;
        });
    }), !0) : !1;
};
$e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e8dfc29dafb3bbd7$var$pl(c)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e8dfc29dafb3bbd7$var$p(38));
    return $e8dfc29dafb3bbd7$var$sl(a, b, c, !1, d);
};
$e8dfc29dafb3bbd7$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("1c9zD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lffg4"));

});
parcelRequire.register("lffg4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f776d5a8b0cafef3$export$c4744153514ff05d; }, function (v) { return $f776d5a8b0cafef3$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7; }, function (v) { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875; }, function (v) { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f776d5a8b0cafef3$export$502329bbf4b505b1; }, function (v) { return $f776d5a8b0cafef3$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f776d5a8b0cafef3$export$6e3807111c4874c4; }, function (v) { return $f776d5a8b0cafef3$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f776d5a8b0cafef3$export$c27134553091fb3a; }, function (v) { return $f776d5a8b0cafef3$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2; }, function (v) { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f776d5a8b0cafef3$export$b00a404bbd5edef2; }, function (v) { return $f776d5a8b0cafef3$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f776d5a8b0cafef3$export$8352ce38b91d0c62; }, function (v) { return $f776d5a8b0cafef3$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b; }, function (v) { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555; }, function (v) { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f776d5a8b0cafef3$export$839f9183b0465a69; }, function (v) { return $f776d5a8b0cafef3$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f776d5a8b0cafef3$export$72fdf0e06517287b; }, function (v) { return $f776d5a8b0cafef3$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f776d5a8b0cafef3$export$4b844e58a3e414b4; }, function (v) { return $f776d5a8b0cafef3$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f776d5a8b0cafef3$export$816d2913ae6b83b1; }, function (v) { return $f776d5a8b0cafef3$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f776d5a8b0cafef3$export$61bcfe829111a1d0; }, function (v) { return $f776d5a8b0cafef3$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f; }, function (v) { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f776d5a8b0cafef3$export$b5836b71941fa3ed; }, function (v) { return $f776d5a8b0cafef3$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f776d5a8b0cafef3$export$cf845f2c119da08a; }, function (v) { return $f776d5a8b0cafef3$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f776d5a8b0cafef3$export$c4744153514ff05d;
var $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7;
var $f776d5a8b0cafef3$export$e26fe2ed2fa76875;
var $f776d5a8b0cafef3$export$502329bbf4b505b1;
var $f776d5a8b0cafef3$export$6e3807111c4874c4;
var $f776d5a8b0cafef3$export$c27134553091fb3a;
var $f776d5a8b0cafef3$export$33ee1acdc04fd2a2;
var $f776d5a8b0cafef3$export$b00a404bbd5edef2;
var $f776d5a8b0cafef3$export$8352ce38b91d0c62;
var $f776d5a8b0cafef3$export$d66a1c1c77bd778b;
var $f776d5a8b0cafef3$export$d3dfb8e4810cb555;
var $f776d5a8b0cafef3$export$839f9183b0465a69;
var $f776d5a8b0cafef3$export$72fdf0e06517287b;
var $f776d5a8b0cafef3$export$4b844e58a3e414b4;
var $f776d5a8b0cafef3$export$816d2913ae6b83b1;
var $f776d5a8b0cafef3$export$61bcfe829111a1d0;
var $f776d5a8b0cafef3$export$7ee8c9beb337bc3f;
var $f776d5a8b0cafef3$export$b5836b71941fa3ed;
var $f776d5a8b0cafef3$export$cf845f2c119da08a;
"use strict";
function $f776d5a8b0cafef3$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f776d5a8b0cafef3$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f776d5a8b0cafef3$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f776d5a8b0cafef3$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f776d5a8b0cafef3$var$g(C, c)) n < e && 0 > $f776d5a8b0cafef3$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f776d5a8b0cafef3$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f776d5a8b0cafef3$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f776d5a8b0cafef3$var$l = performance;
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$l.now();
    };
} else {
    var $f776d5a8b0cafef3$var$p = Date, $f776d5a8b0cafef3$var$q = $f776d5a8b0cafef3$var$p.now();
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$p.now() - $f776d5a8b0cafef3$var$q;
    };
}
var $f776d5a8b0cafef3$var$r = [], $f776d5a8b0cafef3$var$t = [], $f776d5a8b0cafef3$var$u = 1, $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = 3, $f776d5a8b0cafef3$var$z = !1, $f776d5a8b0cafef3$var$A = !1, $f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$D = "function" === typeof setTimeout ? setTimeout : null, $f776d5a8b0cafef3$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f776d5a8b0cafef3$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f776d5a8b0cafef3$var$G(a) {
    for(var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t); null !== b;){
        if (null === b.callback) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t);
        else if (b.startTime <= a) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t), b.sortIndex = b.expirationTime, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, b);
        else break;
        b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
    }
}
function $f776d5a8b0cafef3$var$H(a) {
    $f776d5a8b0cafef3$var$B = !1;
    $f776d5a8b0cafef3$var$G(a);
    if (!$f776d5a8b0cafef3$var$A) {
        if (null !== $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r)) $f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J);
        else {
            var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== b && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, b.startTime - a);
        }
    }
}
function $f776d5a8b0cafef3$var$J(a, b) {
    $f776d5a8b0cafef3$var$A = !1;
    $f776d5a8b0cafef3$var$B && ($f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1);
    $f776d5a8b0cafef3$var$z = !0;
    var c = $f776d5a8b0cafef3$var$y;
    try {
        $f776d5a8b0cafef3$var$G(b);
        for($f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r); null !== $f776d5a8b0cafef3$var$v && (!($f776d5a8b0cafef3$var$v.expirationTime > b) || a && !$f776d5a8b0cafef3$var$M());){
            var d = $f776d5a8b0cafef3$var$v.callback;
            if ("function" === typeof d) {
                $f776d5a8b0cafef3$var$v.callback = null;
                $f776d5a8b0cafef3$var$y = $f776d5a8b0cafef3$var$v.priorityLevel;
                var e = d($f776d5a8b0cafef3$var$v.expirationTime <= b);
                b = $f776d5a8b0cafef3$export$c4744153514ff05d();
                "function" === typeof e ? $f776d5a8b0cafef3$var$v.callback = e : $f776d5a8b0cafef3$var$v === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
                $f776d5a8b0cafef3$var$G(b);
            } else $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
            $f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
        }
        if (null !== $f776d5a8b0cafef3$var$v) var w = !0;
        else {
            var m = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== m && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = c, $f776d5a8b0cafef3$var$z = !1;
    }
}
var $f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null, $f776d5a8b0cafef3$var$L = -1, $f776d5a8b0cafef3$var$P = 5, $f776d5a8b0cafef3$var$Q = -1;
function $f776d5a8b0cafef3$var$M() {
    return $f776d5a8b0cafef3$export$c4744153514ff05d() - $f776d5a8b0cafef3$var$Q < $f776d5a8b0cafef3$var$P ? !1 : !0;
}
function $f776d5a8b0cafef3$var$R() {
    if (null !== $f776d5a8b0cafef3$var$O) {
        var a = $f776d5a8b0cafef3$export$c4744153514ff05d();
        $f776d5a8b0cafef3$var$Q = a;
        var b = !0;
        try {
            b = $f776d5a8b0cafef3$var$O(!0, a);
        } finally{
            b ? $f776d5a8b0cafef3$var$S() : ($f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null);
        }
    } else $f776d5a8b0cafef3$var$N = !1;
}
var $f776d5a8b0cafef3$var$S;
if ("function" === typeof $f776d5a8b0cafef3$var$F) $f776d5a8b0cafef3$var$S = function S() {
    $f776d5a8b0cafef3$var$F($f776d5a8b0cafef3$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f776d5a8b0cafef3$var$T = new MessageChannel, $f776d5a8b0cafef3$var$U = $f776d5a8b0cafef3$var$T.port2;
    $f776d5a8b0cafef3$var$T.port1.onmessage = $f776d5a8b0cafef3$var$R;
    $f776d5a8b0cafef3$var$S = function S() {
        $f776d5a8b0cafef3$var$U.postMessage(null);
    };
} else $f776d5a8b0cafef3$var$S = function S() {
    $f776d5a8b0cafef3$var$D($f776d5a8b0cafef3$var$R, 0);
};
function $f776d5a8b0cafef3$var$I(a) {
    $f776d5a8b0cafef3$var$O = a;
    $f776d5a8b0cafef3$var$N || ($f776d5a8b0cafef3$var$N = !0, $f776d5a8b0cafef3$var$S());
}
function $f776d5a8b0cafef3$var$K(a, b) {
    $f776d5a8b0cafef3$var$L = $f776d5a8b0cafef3$var$D(function() {
        a($f776d5a8b0cafef3$export$c4744153514ff05d());
    }, b);
}
$f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = 5;
$f776d5a8b0cafef3$export$e26fe2ed2fa76875 = 1;
$f776d5a8b0cafef3$export$502329bbf4b505b1 = 4;
$f776d5a8b0cafef3$export$6e3807111c4874c4 = 3;
$f776d5a8b0cafef3$export$c27134553091fb3a = null;
$f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = 2;
$f776d5a8b0cafef3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f776d5a8b0cafef3$export$8352ce38b91d0c62 = function() {
    $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J));
};
$f776d5a8b0cafef3$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f776d5a8b0cafef3$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f776d5a8b0cafef3$export$d3dfb8e4810cb555 = function() {
    return $f776d5a8b0cafef3$var$y;
};
$f776d5a8b0cafef3$export$839f9183b0465a69 = function() {
    return $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
};
$f776d5a8b0cafef3$export$72fdf0e06517287b = function(a) {
    switch($f776d5a8b0cafef3$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f776d5a8b0cafef3$var$y;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = b;
    try {
        return a();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$4b844e58a3e414b4 = function() {};
$f776d5a8b0cafef3$export$816d2913ae6b83b1 = function() {};
$f776d5a8b0cafef3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = a;
    try {
        return b();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f776d5a8b0cafef3$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f776d5a8b0cafef3$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$t, a), null === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && a === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t) && ($f776d5a8b0cafef3$var$B ? ($f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1) : $f776d5a8b0cafef3$var$B = !0, $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, c - d))) : (a.sortIndex = e, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, a), $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J)));
    return a;
};
$f776d5a8b0cafef3$export$b5836b71941fa3ed = $f776d5a8b0cafef3$var$M;
$f776d5a8b0cafef3$export$cf845f2c119da08a = function(a) {
    var b = $f776d5a8b0cafef3$var$y;
    return function() {
        var c = $f776d5a8b0cafef3$var$y;
        $f776d5a8b0cafef3$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f776d5a8b0cafef3$var$y = c;
        }
    };
};

});



parcelRequire.register("17QCl", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $0d1f42a1cefd465e$export$bdfd709ae4826697; }, function (v) { return $0d1f42a1cefd465e$export$bdfd709ae4826697 = v; });
var $0d1f42a1cefd465e$export$bdfd709ae4826697;
var $0d1f42a1cefd465e$export$c9e73fbda7da57b6;
var $0d1f42a1cefd465e$export$5a759dc7a1cfb72a;
"use strict";
var $0d1f42a1cefd465e$var$bundleURL = {};
function $0d1f42a1cefd465e$var$getBundleURLCached(id) {
    var value = $0d1f42a1cefd465e$var$bundleURL[id];
    if (!value) {
        value = $0d1f42a1cefd465e$var$getBundleURL();
        $0d1f42a1cefd465e$var$bundleURL[id] = value;
    }
    return value;
}
function $0d1f42a1cefd465e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $0d1f42a1cefd465e$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $0d1f42a1cefd465e$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $0d1f42a1cefd465e$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$0d1f42a1cefd465e$export$bdfd709ae4826697 = $0d1f42a1cefd465e$var$getBundleURLCached;
$0d1f42a1cefd465e$export$c9e73fbda7da57b6 = $0d1f42a1cefd465e$var$getBaseURL;
$0d1f42a1cefd465e$export$5a759dc7a1cfb72a = $0d1f42a1cefd465e$var$getOrigin;

});

parcelRequire.register("jlWHo", function(module, exports) {

(function(module1, exports) {
    "use strict";
    var assert = // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    };
    var inherits = // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    };
    var parseHex4Bits = function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    };
    var parseHexByte = function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    };
    var parseBase = function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    };
    var move = function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    };
    var inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var toBitArray = function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    };
    var smallMulTo = function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    };
    var bigMulTo = function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    };
    var jumboMulTo = function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    };
    var FFTM = // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    };
    var MPrime = // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    };
    var K256 = function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    };
    var P224 = function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    };
    var P192 = function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    };
    var P25519 = function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    };
    var Red = //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    };
    var Mont = function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    };
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    inherits(P224, MPrime);
    inherits(P192, MPrime);
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRequire.register("aqbQf", function(module, exports) {
"use strict";

});


parcelRequire.register("cYl7t", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $971b7885424ac20e$export$69f1b2dcda23c5f8; }, function (v) { return $971b7885424ac20e$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $971b7885424ac20e$export$45b10814cc054894; }, function (v) { return $971b7885424ac20e$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $971b7885424ac20e$export$7ea66e3774a60b67; }, function (v) { return $971b7885424ac20e$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $971b7885424ac20e$export$34a52f00f601f6f1; }, function (v) { return $971b7885424ac20e$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $971b7885424ac20e$export$812b0cbd5e8a72ab; }, function (v) { return $971b7885424ac20e$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $971b7885424ac20e$export$f24f9e11d63bb314; }, function (v) { return $971b7885424ac20e$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $971b7885424ac20e$export$b71357c7e07ca1f1; }, function (v) { return $971b7885424ac20e$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $971b7885424ac20e$export$2e58a4b541fdcbe8; }, function (v) { return $971b7885424ac20e$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $971b7885424ac20e$export$183b950bde9faab8; }, function (v) { return $971b7885424ac20e$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $971b7885424ac20e$export$4785c77169fea59e; }, function (v) { return $971b7885424ac20e$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $971b7885424ac20e$export$242a185dfcffac5b; }, function (v) { return $971b7885424ac20e$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $971b7885424ac20e$export$58c04ae0ae31877d; }, function (v) { return $971b7885424ac20e$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $971b7885424ac20e$export$d058ca695f8c6f11; }, function (v) { return $971b7885424ac20e$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $971b7885424ac20e$export$a1efd7fc3e986367; }, function (v) { return $971b7885424ac20e$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $971b7885424ac20e$export$bbfea4a2b5abaab4; }, function (v) { return $971b7885424ac20e$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $971b7885424ac20e$export$97ad4afc7de86152; }, function (v) { return $971b7885424ac20e$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $971b7885424ac20e$export$ce4673d9a79f6a4b; }, function (v) { return $971b7885424ac20e$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $971b7885424ac20e$export$786cc99fc6eedc0b; }, function (v) { return $971b7885424ac20e$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $971b7885424ac20e$export$45c59b9a1848dd0; }, function (v) { return $971b7885424ac20e$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $971b7885424ac20e$export$50d8f613e76d3034; }, function (v) { return $971b7885424ac20e$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $971b7885424ac20e$export$b8e83683c60ee162; }, function (v) { return $971b7885424ac20e$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $971b7885424ac20e$export$aeeb51790d1bcc4a; }, function (v) { return $971b7885424ac20e$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $971b7885424ac20e$export$bb7c616f719ad9c; }, function (v) { return $971b7885424ac20e$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $971b7885424ac20e$export$4d63290824f9d7df; }, function (v) { return $971b7885424ac20e$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $971b7885424ac20e$export$2f64ceb90ef28ea1; }, function (v) { return $971b7885424ac20e$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $971b7885424ac20e$export$8d2089d465f6d10d; }, function (v) { return $971b7885424ac20e$export$8d2089d465f6d10d = v; });
var $971b7885424ac20e$export$69f1b2dcda23c5f8;
var $971b7885424ac20e$export$45b10814cc054894;
var $971b7885424ac20e$export$7ea66e3774a60b67;
var $971b7885424ac20e$export$34a52f00f601f6f1;
var $971b7885424ac20e$export$812b0cbd5e8a72ab;
var $971b7885424ac20e$export$f24f9e11d63bb314;
var $971b7885424ac20e$export$b71357c7e07ca1f1;
var $971b7885424ac20e$export$2e58a4b541fdcbe8;
var $971b7885424ac20e$export$183b950bde9faab8;
var $971b7885424ac20e$export$4785c77169fea59e;
var $971b7885424ac20e$export$242a185dfcffac5b;
var $971b7885424ac20e$export$58c04ae0ae31877d;
var $971b7885424ac20e$export$d058ca695f8c6f11;
var $971b7885424ac20e$export$a1efd7fc3e986367;
var $971b7885424ac20e$export$bbfea4a2b5abaab4;
var $971b7885424ac20e$export$97ad4afc7de86152;
var $971b7885424ac20e$export$ce4673d9a79f6a4b;
var $971b7885424ac20e$export$786cc99fc6eedc0b;
var $971b7885424ac20e$export$45c59b9a1848dd0;
var $971b7885424ac20e$export$50d8f613e76d3034;
var $971b7885424ac20e$export$b8e83683c60ee162;
var $971b7885424ac20e$export$aeeb51790d1bcc4a;
var $971b7885424ac20e$export$bb7c616f719ad9c;
var $971b7885424ac20e$export$4d63290824f9d7df;
var $971b7885424ac20e$export$2f64ceb90ef28ea1;
var $971b7885424ac20e$export$8d2089d465f6d10d;
"use strict";

var $3210N = parcelRequire("3210N");

var $kvFQ5 = parcelRequire("kvFQ5");
$971b7885424ac20e$export$69f1b2dcda23c5f8 = $kvFQ5;
function $971b7885424ac20e$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $971b7885424ac20e$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($971b7885424ac20e$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$971b7885424ac20e$export$45b10814cc054894 = $971b7885424ac20e$var$toArray;
function $971b7885424ac20e$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $971b7885424ac20e$var$zero2(msg[i].toString(16));
    return res;
}
$971b7885424ac20e$export$7ea66e3774a60b67 = $971b7885424ac20e$var$toHex;
function $971b7885424ac20e$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$971b7885424ac20e$export$34a52f00f601f6f1 = $971b7885424ac20e$var$htonl;
function $971b7885424ac20e$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $971b7885424ac20e$var$htonl(w);
        res += $971b7885424ac20e$var$zero8(w.toString(16));
    }
    return res;
}
$971b7885424ac20e$export$812b0cbd5e8a72ab = $971b7885424ac20e$var$toHex32;
function $971b7885424ac20e$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$971b7885424ac20e$export$f24f9e11d63bb314 = $971b7885424ac20e$var$zero2;
function $971b7885424ac20e$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$971b7885424ac20e$export$b71357c7e07ca1f1 = $971b7885424ac20e$var$zero8;
function $971b7885424ac20e$var$join32(msg, start, end, endian) {
    var len = end - start;
    $3210N(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$971b7885424ac20e$export$2e58a4b541fdcbe8 = $971b7885424ac20e$var$join32;
function $971b7885424ac20e$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$971b7885424ac20e$export$183b950bde9faab8 = $971b7885424ac20e$var$split32;
function $971b7885424ac20e$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$971b7885424ac20e$export$4785c77169fea59e = $971b7885424ac20e$var$rotr32;
function $971b7885424ac20e$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$971b7885424ac20e$export$242a185dfcffac5b = $971b7885424ac20e$var$rotl32;
function $971b7885424ac20e$var$sum32(a, b) {
    return a + b >>> 0;
}
$971b7885424ac20e$export$58c04ae0ae31877d = $971b7885424ac20e$var$sum32;
function $971b7885424ac20e$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$971b7885424ac20e$export$d058ca695f8c6f11 = $971b7885424ac20e$var$sum32_3;
function $971b7885424ac20e$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$971b7885424ac20e$export$a1efd7fc3e986367 = $971b7885424ac20e$var$sum32_4;
function $971b7885424ac20e$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$971b7885424ac20e$export$bbfea4a2b5abaab4 = $971b7885424ac20e$var$sum32_5;
function $971b7885424ac20e$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$971b7885424ac20e$export$97ad4afc7de86152 = $971b7885424ac20e$var$sum64;
function $971b7885424ac20e$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$971b7885424ac20e$export$ce4673d9a79f6a4b = $971b7885424ac20e$var$sum64_hi;
function $971b7885424ac20e$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$971b7885424ac20e$export$786cc99fc6eedc0b = $971b7885424ac20e$var$sum64_lo;
function $971b7885424ac20e$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$971b7885424ac20e$export$45c59b9a1848dd0 = $971b7885424ac20e$var$sum64_4_hi;
function $971b7885424ac20e$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$971b7885424ac20e$export$50d8f613e76d3034 = $971b7885424ac20e$var$sum64_4_lo;
function $971b7885424ac20e$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$971b7885424ac20e$export$b8e83683c60ee162 = $971b7885424ac20e$var$sum64_5_hi;
function $971b7885424ac20e$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$971b7885424ac20e$export$aeeb51790d1bcc4a = $971b7885424ac20e$var$sum64_5_lo;
function $971b7885424ac20e$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$971b7885424ac20e$export$bb7c616f719ad9c = $971b7885424ac20e$var$rotr64_hi;
function $971b7885424ac20e$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$971b7885424ac20e$export$4d63290824f9d7df = $971b7885424ac20e$var$rotr64_lo;
function $971b7885424ac20e$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$971b7885424ac20e$export$2f64ceb90ef28ea1 = $971b7885424ac20e$var$shr64_hi;
function $971b7885424ac20e$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$971b7885424ac20e$export$8d2089d465f6d10d = $971b7885424ac20e$var$shr64_lo;

});
parcelRequire.register("3210N", function(module, exports) {
module.exports = $235257eb35d12727$var$assert;
function $235257eb35d12727$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$235257eb35d12727$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRequire.register("kvFQ5", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRequire.register("1pS1U", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $10820970b61d1a41$export$8687658379b577e6; }, function (v) { return $10820970b61d1a41$export$8687658379b577e6 = v; });
var $10820970b61d1a41$export$8687658379b577e6;
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $3210N = parcelRequire("3210N");
function $10820970b61d1a41$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$10820970b61d1a41$export$8687658379b577e6 = $10820970b61d1a41$var$BlockHash;
$10820970b61d1a41$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $cYl7t.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $cYl7t.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$10820970b61d1a41$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $3210N(this.pending === null);
    return this._digest(enc);
};
$10820970b61d1a41$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRequire.register("imuzp", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $d5e1fea904e0f988$export$5091bdda49ba90f5; }, function (v) { return $d5e1fea904e0f988$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $d5e1fea904e0f988$export$97b70509d4e397ea; }, function (v) { return $d5e1fea904e0f988$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $d5e1fea904e0f988$export$bced8d2aada2d1c9; }, function (v) { return $d5e1fea904e0f988$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $d5e1fea904e0f988$export$612d47d55dedde45; }, function (v) { return $d5e1fea904e0f988$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $d5e1fea904e0f988$export$a888d2532e6dc7bb; }, function (v) { return $d5e1fea904e0f988$export$a888d2532e6dc7bb = v; });
var $d5e1fea904e0f988$export$5091bdda49ba90f5;
var $d5e1fea904e0f988$export$97b70509d4e397ea;
var $d5e1fea904e0f988$export$bced8d2aada2d1c9;
var $d5e1fea904e0f988$export$612d47d55dedde45;
var $d5e1fea904e0f988$export$a888d2532e6dc7bb;
"use strict";

$d5e1fea904e0f988$export$5091bdda49ba90f5 = (parcelRequire("2cerY"));

$d5e1fea904e0f988$export$97b70509d4e397ea = (parcelRequire("i5Q5x"));

$d5e1fea904e0f988$export$bced8d2aada2d1c9 = (parcelRequire("3HSKF"));

$d5e1fea904e0f988$export$612d47d55dedde45 = (parcelRequire("aWFyw"));

$d5e1fea904e0f988$export$a888d2532e6dc7bb = (parcelRequire("6bcDP"));

});
parcelRequire.register("2cerY", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $1pS1U = parcelRequire("1pS1U");

var $bznKp = parcelRequire("bznKp");
var $1997e941b78c78de$var$rotl32 = $cYl7t.rotl32;
var $1997e941b78c78de$var$sum32 = $cYl7t.sum32;
var $1997e941b78c78de$var$sum32_5 = $cYl7t.sum32_5;
var $1997e941b78c78de$var$ft_1 = $bznKp.ft_1;
var $1997e941b78c78de$var$BlockHash = $1pS1U.BlockHash;
var $1997e941b78c78de$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $1997e941b78c78de$var$SHA1() {
    if (!(this instanceof $1997e941b78c78de$var$SHA1)) return new $1997e941b78c78de$var$SHA1();
    $1997e941b78c78de$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$cYl7t.inherits($1997e941b78c78de$var$SHA1, $1997e941b78c78de$var$BlockHash);
module.exports = $1997e941b78c78de$var$SHA1;
$1997e941b78c78de$var$SHA1.blockSize = 512;
$1997e941b78c78de$var$SHA1.outSize = 160;
$1997e941b78c78de$var$SHA1.hmacStrength = 80;
$1997e941b78c78de$var$SHA1.padLength = 64;
$1997e941b78c78de$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $1997e941b78c78de$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $1997e941b78c78de$var$sum32_5($1997e941b78c78de$var$rotl32(a, 5), $1997e941b78c78de$var$ft_1(s, b, c, d), e, W[i], $1997e941b78c78de$var$sha1_K[s]);
        e = d;
        d = c;
        c = $1997e941b78c78de$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $1997e941b78c78de$var$sum32(this.h[0], a);
    this.h[1] = $1997e941b78c78de$var$sum32(this.h[1], b);
    this.h[2] = $1997e941b78c78de$var$sum32(this.h[2], c);
    this.h[3] = $1997e941b78c78de$var$sum32(this.h[3], d);
    this.h[4] = $1997e941b78c78de$var$sum32(this.h[4], e);
};
$1997e941b78c78de$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h, "big");
    else return $cYl7t.split32(this.h, "big");
};

});
parcelRequire.register("bznKp", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $86c562611187daa4$export$5a92649d7ddb9f63; }, function (v) { return $86c562611187daa4$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $86c562611187daa4$export$c6d0d020c3a6269; }, function (v) { return $86c562611187daa4$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $86c562611187daa4$export$eb90c27fca05f956; }, function (v) { return $86c562611187daa4$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $86c562611187daa4$export$14a4a98e063b1999; }, function (v) { return $86c562611187daa4$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $86c562611187daa4$export$d20cecfa1564c686; }, function (v) { return $86c562611187daa4$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $86c562611187daa4$export$44fd472a12fc6db; }, function (v) { return $86c562611187daa4$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $86c562611187daa4$export$1ed238bb6ea1dd47; }, function (v) { return $86c562611187daa4$export$1ed238bb6ea1dd47 = v; });
var $86c562611187daa4$export$5a92649d7ddb9f63;
var $86c562611187daa4$export$c6d0d020c3a6269;
var $86c562611187daa4$export$eb90c27fca05f956;
var $86c562611187daa4$export$cc992891a14496a1;
var $86c562611187daa4$export$14a4a98e063b1999;
var $86c562611187daa4$export$d20cecfa1564c686;
var $86c562611187daa4$export$44fd472a12fc6db;
var $86c562611187daa4$export$1ed238bb6ea1dd47;
"use strict";

var $cYl7t = parcelRequire("cYl7t");
var $86c562611187daa4$var$rotr32 = $cYl7t.rotr32;
function $86c562611187daa4$var$ft_1(s, x, y, z) {
    if (s === 0) return $86c562611187daa4$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $86c562611187daa4$var$p32(x, y, z);
    if (s === 2) return $86c562611187daa4$var$maj32(x, y, z);
}
$86c562611187daa4$export$5a92649d7ddb9f63 = $86c562611187daa4$var$ft_1;
function $86c562611187daa4$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$86c562611187daa4$export$c6d0d020c3a6269 = $86c562611187daa4$var$ch32;
function $86c562611187daa4$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$86c562611187daa4$export$eb90c27fca05f956 = $86c562611187daa4$var$maj32;
function $86c562611187daa4$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$86c562611187daa4$export$cc992891a14496a1 = $86c562611187daa4$var$p32;
function $86c562611187daa4$var$s0_256(x) {
    return $86c562611187daa4$var$rotr32(x, 2) ^ $86c562611187daa4$var$rotr32(x, 13) ^ $86c562611187daa4$var$rotr32(x, 22);
}
$86c562611187daa4$export$14a4a98e063b1999 = $86c562611187daa4$var$s0_256;
function $86c562611187daa4$var$s1_256(x) {
    return $86c562611187daa4$var$rotr32(x, 6) ^ $86c562611187daa4$var$rotr32(x, 11) ^ $86c562611187daa4$var$rotr32(x, 25);
}
$86c562611187daa4$export$d20cecfa1564c686 = $86c562611187daa4$var$s1_256;
function $86c562611187daa4$var$g0_256(x) {
    return $86c562611187daa4$var$rotr32(x, 7) ^ $86c562611187daa4$var$rotr32(x, 18) ^ x >>> 3;
}
$86c562611187daa4$export$44fd472a12fc6db = $86c562611187daa4$var$g0_256;
function $86c562611187daa4$var$g1_256(x) {
    return $86c562611187daa4$var$rotr32(x, 17) ^ $86c562611187daa4$var$rotr32(x, 19) ^ x >>> 10;
}
$86c562611187daa4$export$1ed238bb6ea1dd47 = $86c562611187daa4$var$g1_256;

});


parcelRequire.register("i5Q5x", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $3HSKF = parcelRequire("3HSKF");
function $d2c1194d6901331b$var$SHA224() {
    if (!(this instanceof $d2c1194d6901331b$var$SHA224)) return new $d2c1194d6901331b$var$SHA224();
    $3HSKF.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$cYl7t.inherits($d2c1194d6901331b$var$SHA224, $3HSKF);
module.exports = $d2c1194d6901331b$var$SHA224;
$d2c1194d6901331b$var$SHA224.blockSize = 512;
$d2c1194d6901331b$var$SHA224.outSize = 224;
$d2c1194d6901331b$var$SHA224.hmacStrength = 192;
$d2c1194d6901331b$var$SHA224.padLength = 64;
$d2c1194d6901331b$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $cYl7t.toHex32(this.h.slice(0, 7), "big");
    else return $cYl7t.split32(this.h.slice(0, 7), "big");
};

});
parcelRequire.register("3HSKF", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $1pS1U = parcelRequire("1pS1U");

var $bznKp = parcelRequire("bznKp");

var $3210N = parcelRequire("3210N");
var $2b2fdbcd8fab6652$var$sum32 = $cYl7t.sum32;
var $2b2fdbcd8fab6652$var$sum32_4 = $cYl7t.sum32_4;
var $2b2fdbcd8fab6652$var$sum32_5 = $cYl7t.sum32_5;
var $2b2fdbcd8fab6652$var$ch32 = $bznKp.ch32;
var $2b2fdbcd8fab6652$var$maj32 = $bznKp.maj32;
var $2b2fdbcd8fab6652$var$s0_256 = $bznKp.s0_256;
var $2b2fdbcd8fab6652$var$s1_256 = $bznKp.s1_256;
var $2b2fdbcd8fab6652$var$g0_256 = $bznKp.g0_256;
var $2b2fdbcd8fab6652$var$g1_256 = $bznKp.g1_256;
var $2b2fdbcd8fab6652$var$BlockHash = $1pS1U.BlockHash;
var $2b2fdbcd8fab6652$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $2b2fdbcd8fab6652$var$SHA256() {
    if (!(this instanceof $2b2fdbcd8fab6652$var$SHA256)) return new $2b2fdbcd8fab6652$var$SHA256();
    $2b2fdbcd8fab6652$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $2b2fdbcd8fab6652$var$sha256_K;
    this.W = new Array(64);
}
$cYl7t.inherits($2b2fdbcd8fab6652$var$SHA256, $2b2fdbcd8fab6652$var$BlockHash);
module.exports = $2b2fdbcd8fab6652$var$SHA256;
$2b2fdbcd8fab6652$var$SHA256.blockSize = 512;
$2b2fdbcd8fab6652$var$SHA256.outSize = 256;
$2b2fdbcd8fab6652$var$SHA256.hmacStrength = 192;
$2b2fdbcd8fab6652$var$SHA256.padLength = 64;
$2b2fdbcd8fab6652$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $2b2fdbcd8fab6652$var$sum32_4($2b2fdbcd8fab6652$var$g1_256(W[i - 2]), W[i - 7], $2b2fdbcd8fab6652$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $3210N(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $2b2fdbcd8fab6652$var$sum32_5(h, $2b2fdbcd8fab6652$var$s1_256(e), $2b2fdbcd8fab6652$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $2b2fdbcd8fab6652$var$sum32($2b2fdbcd8fab6652$var$s0_256(a), $2b2fdbcd8fab6652$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $2b2fdbcd8fab6652$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $2b2fdbcd8fab6652$var$sum32(T1, T2);
    }
    this.h[0] = $2b2fdbcd8fab6652$var$sum32(this.h[0], a);
    this.h[1] = $2b2fdbcd8fab6652$var$sum32(this.h[1], b);
    this.h[2] = $2b2fdbcd8fab6652$var$sum32(this.h[2], c);
    this.h[3] = $2b2fdbcd8fab6652$var$sum32(this.h[3], d);
    this.h[4] = $2b2fdbcd8fab6652$var$sum32(this.h[4], e);
    this.h[5] = $2b2fdbcd8fab6652$var$sum32(this.h[5], f);
    this.h[6] = $2b2fdbcd8fab6652$var$sum32(this.h[6], g);
    this.h[7] = $2b2fdbcd8fab6652$var$sum32(this.h[7], h);
};
$2b2fdbcd8fab6652$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h, "big");
    else return $cYl7t.split32(this.h, "big");
};

});


parcelRequire.register("aWFyw", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $6bcDP = parcelRequire("6bcDP");
function $7f7f8e474b2a977d$var$SHA384() {
    if (!(this instanceof $7f7f8e474b2a977d$var$SHA384)) return new $7f7f8e474b2a977d$var$SHA384();
    $6bcDP.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$cYl7t.inherits($7f7f8e474b2a977d$var$SHA384, $6bcDP);
module.exports = $7f7f8e474b2a977d$var$SHA384;
$7f7f8e474b2a977d$var$SHA384.blockSize = 1024;
$7f7f8e474b2a977d$var$SHA384.outSize = 384;
$7f7f8e474b2a977d$var$SHA384.hmacStrength = 192;
$7f7f8e474b2a977d$var$SHA384.padLength = 128;
$7f7f8e474b2a977d$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h.slice(0, 12), "big");
    else return $cYl7t.split32(this.h.slice(0, 12), "big");
};

});
parcelRequire.register("6bcDP", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $1pS1U = parcelRequire("1pS1U");

var $3210N = parcelRequire("3210N");
var $47fd937a71a2450c$var$rotr64_hi = $cYl7t.rotr64_hi;
var $47fd937a71a2450c$var$rotr64_lo = $cYl7t.rotr64_lo;
var $47fd937a71a2450c$var$shr64_hi = $cYl7t.shr64_hi;
var $47fd937a71a2450c$var$shr64_lo = $cYl7t.shr64_lo;
var $47fd937a71a2450c$var$sum64 = $cYl7t.sum64;
var $47fd937a71a2450c$var$sum64_hi = $cYl7t.sum64_hi;
var $47fd937a71a2450c$var$sum64_lo = $cYl7t.sum64_lo;
var $47fd937a71a2450c$var$sum64_4_hi = $cYl7t.sum64_4_hi;
var $47fd937a71a2450c$var$sum64_4_lo = $cYl7t.sum64_4_lo;
var $47fd937a71a2450c$var$sum64_5_hi = $cYl7t.sum64_5_hi;
var $47fd937a71a2450c$var$sum64_5_lo = $cYl7t.sum64_5_lo;
var $47fd937a71a2450c$var$BlockHash = $1pS1U.BlockHash;
var $47fd937a71a2450c$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $47fd937a71a2450c$var$SHA512() {
    if (!(this instanceof $47fd937a71a2450c$var$SHA512)) return new $47fd937a71a2450c$var$SHA512();
    $47fd937a71a2450c$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $47fd937a71a2450c$var$sha512_K;
    this.W = new Array(160);
}
$cYl7t.inherits($47fd937a71a2450c$var$SHA512, $47fd937a71a2450c$var$BlockHash);
module.exports = $47fd937a71a2450c$var$SHA512;
$47fd937a71a2450c$var$SHA512.blockSize = 1024;
$47fd937a71a2450c$var$SHA512.outSize = 512;
$47fd937a71a2450c$var$SHA512.hmacStrength = 192;
$47fd937a71a2450c$var$SHA512.padLength = 128;
$47fd937a71a2450c$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $47fd937a71a2450c$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $47fd937a71a2450c$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $47fd937a71a2450c$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $47fd937a71a2450c$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $47fd937a71a2450c$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $47fd937a71a2450c$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$47fd937a71a2450c$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $3210N(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $47fd937a71a2450c$var$s1_512_hi(eh, el);
        var c1_lo = $47fd937a71a2450c$var$s1_512_lo(eh, el);
        var c2_hi = $47fd937a71a2450c$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $47fd937a71a2450c$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $47fd937a71a2450c$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $47fd937a71a2450c$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $47fd937a71a2450c$var$s0_512_hi(ah, al);
        c0_lo = $47fd937a71a2450c$var$s0_512_lo(ah, al);
        c1_hi = $47fd937a71a2450c$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $47fd937a71a2450c$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $47fd937a71a2450c$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $47fd937a71a2450c$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $47fd937a71a2450c$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $47fd937a71a2450c$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $47fd937a71a2450c$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $47fd937a71a2450c$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $47fd937a71a2450c$var$sum64(this.h, 0, ah, al);
    $47fd937a71a2450c$var$sum64(this.h, 2, bh, bl);
    $47fd937a71a2450c$var$sum64(this.h, 4, ch, cl);
    $47fd937a71a2450c$var$sum64(this.h, 6, dh, dl);
    $47fd937a71a2450c$var$sum64(this.h, 8, eh, el);
    $47fd937a71a2450c$var$sum64(this.h, 10, fh, fl);
    $47fd937a71a2450c$var$sum64(this.h, 12, gh, gl);
    $47fd937a71a2450c$var$sum64(this.h, 14, hh, hl);
};
$47fd937a71a2450c$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h, "big");
    else return $cYl7t.split32(this.h, "big");
};
function $47fd937a71a2450c$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$s0_512_hi(xh, xl) {
    var c0_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $47fd937a71a2450c$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $47fd937a71a2450c$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$s0_512_lo(xh, xl) {
    var c0_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $47fd937a71a2450c$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $47fd937a71a2450c$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$s1_512_hi(xh, xl) {
    var c0_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $47fd937a71a2450c$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$s1_512_lo(xh, xl) {
    var c0_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $47fd937a71a2450c$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$g0_512_hi(xh, xl) {
    var c0_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $47fd937a71a2450c$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$g0_512_lo(xh, xl) {
    var c0_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $47fd937a71a2450c$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$g1_512_hi(xh, xl) {
    var c0_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $47fd937a71a2450c$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $47fd937a71a2450c$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$g1_512_lo(xh, xl) {
    var c0_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $47fd937a71a2450c$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $47fd937a71a2450c$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRequire.register("jAZNy", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $e44150fbd2160137$export$d1cea0ee4e3f0d3e; }, function (v) { return $e44150fbd2160137$export$d1cea0ee4e3f0d3e = v; });
var $e44150fbd2160137$export$d1cea0ee4e3f0d3e;
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $1pS1U = parcelRequire("1pS1U");
var $e44150fbd2160137$var$rotl32 = $cYl7t.rotl32;
var $e44150fbd2160137$var$sum32 = $cYl7t.sum32;
var $e44150fbd2160137$var$sum32_3 = $cYl7t.sum32_3;
var $e44150fbd2160137$var$sum32_4 = $cYl7t.sum32_4;
var $e44150fbd2160137$var$BlockHash = $1pS1U.BlockHash;
function $e44150fbd2160137$var$RIPEMD160() {
    if (!(this instanceof $e44150fbd2160137$var$RIPEMD160)) return new $e44150fbd2160137$var$RIPEMD160();
    $e44150fbd2160137$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$cYl7t.inherits($e44150fbd2160137$var$RIPEMD160, $e44150fbd2160137$var$BlockHash);
$e44150fbd2160137$export$d1cea0ee4e3f0d3e = $e44150fbd2160137$var$RIPEMD160;
$e44150fbd2160137$var$RIPEMD160.blockSize = 512;
$e44150fbd2160137$var$RIPEMD160.outSize = 160;
$e44150fbd2160137$var$RIPEMD160.hmacStrength = 192;
$e44150fbd2160137$var$RIPEMD160.padLength = 64;
$e44150fbd2160137$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $e44150fbd2160137$var$sum32($e44150fbd2160137$var$rotl32($e44150fbd2160137$var$sum32_4(A, $e44150fbd2160137$var$f(j, B, C, D), msg[$e44150fbd2160137$var$r[j] + start], $e44150fbd2160137$var$K(j)), $e44150fbd2160137$var$s[j]), E);
        A = E;
        E = D;
        D = $e44150fbd2160137$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $e44150fbd2160137$var$sum32($e44150fbd2160137$var$rotl32($e44150fbd2160137$var$sum32_4(Ah, $e44150fbd2160137$var$f(79 - j, Bh, Ch, Dh), msg[$e44150fbd2160137$var$rh[j] + start], $e44150fbd2160137$var$Kh(j)), $e44150fbd2160137$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $e44150fbd2160137$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $e44150fbd2160137$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $e44150fbd2160137$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $e44150fbd2160137$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $e44150fbd2160137$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $e44150fbd2160137$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$e44150fbd2160137$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h, "little");
    else return $cYl7t.split32(this.h, "little");
};
function $e44150fbd2160137$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $e44150fbd2160137$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $e44150fbd2160137$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $e44150fbd2160137$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $e44150fbd2160137$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $e44150fbd2160137$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $e44150fbd2160137$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRequire.register("hC4jp", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $3210N = parcelRequire("3210N");
function $cd29549494435068$var$Hmac(hash, key, enc) {
    if (!(this instanceof $cd29549494435068$var$Hmac)) return new $cd29549494435068$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($cYl7t.toArray(key, enc));
}
module.exports = $cd29549494435068$var$Hmac;
$cd29549494435068$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $3210N(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$cd29549494435068$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$cd29549494435068$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});

parcelRequire.register("dQcqA", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $a139c5939e084c8c$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $a139c5939e084c8c$export$2f872c0f2117be69; });

var $j2rU8 = parcelRequire("j2rU8");

var $6M65e = parcelRequire("6M65e");

var $j3HdL = parcelRequire("j3HdL");
"use strict";
var $a139c5939e084c8c$var$logger = new (0, $6M65e.Logger)((0, $j3HdL.version));
function $a139c5939e084c8c$var$arrayifyInteger(value) {
    var result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $a139c5939e084c8c$var$unarrayifyInteger(data, offset, length) {
    var result = 0;
    for(var i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $a139c5939e084c8c$var$_encode(object) {
    if (Array.isArray(object)) {
        var payload = [];
        object.forEach(function(child) {
            payload = payload.concat($a139c5939e084c8c$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        var length = $a139c5939e084c8c$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $j2rU8.isBytesLike)(object)) $a139c5939e084c8c$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    var data = Array.prototype.slice.call((0, $j2rU8.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    var length1 = $a139c5939e084c8c$var$arrayifyInteger(data.length);
    length1.unshift(0xb7 + length1.length);
    return length1.concat(data);
}
function $a139c5939e084c8c$export$c564cdbbe6da493(object) {
    return (0, $j2rU8.hexlify)($a139c5939e084c8c$var$_encode(object));
}
function $a139c5939e084c8c$var$_decodeChildren(data, offset, childOffset, length) {
    var result = [];
    while(childOffset < offset + 1 + length){
        var decoded = $a139c5939e084c8c$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $a139c5939e084c8c$var$logger.throwError("child data too short", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $a139c5939e084c8c$var$_decode(data, offset) {
    if (data.length === 0) $a139c5939e084c8c$var$logger.throwError("data too short", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        var lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $a139c5939e084c8c$var$logger.throwError("data short segment too short", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {});
        var length = $a139c5939e084c8c$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $a139c5939e084c8c$var$logger.throwError("data long segment too short", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {});
        return $a139c5939e084c8c$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        var length1 = data[offset] - 0xc0;
        if (offset + 1 + length1 > data.length) $a139c5939e084c8c$var$logger.throwError("data array too short", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {});
        return $a139c5939e084c8c$var$_decodeChildren(data, offset, offset + 1, length1);
    } else if (data[offset] >= 0xb8) {
        var lengthLength1 = data[offset] - 0xb7;
        if (offset + 1 + lengthLength1 > data.length) $a139c5939e084c8c$var$logger.throwError("data array too short", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {});
        var length2 = $a139c5939e084c8c$var$unarrayifyInteger(data, offset + 1, lengthLength1);
        if (offset + 1 + lengthLength1 + length2 > data.length) $a139c5939e084c8c$var$logger.throwError("data array too short", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {});
        var result = (0, $j2rU8.hexlify)(data.slice(offset + 1 + lengthLength1, offset + 1 + lengthLength1 + length2));
        return {
            consumed: 1 + lengthLength1 + length2,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        var length3 = data[offset] - 0x80;
        if (offset + 1 + length3 > data.length) $a139c5939e084c8c$var$logger.throwError("data too short", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {});
        var result1 = (0, $j2rU8.hexlify)(data.slice(offset + 1, offset + 1 + length3));
        return {
            consumed: 1 + length3,
            result: result1
        };
    }
    return {
        consumed: 1,
        result: (0, $j2rU8.hexlify)(data[offset])
    };
}
function $a139c5939e084c8c$export$2f872c0f2117be69(data) {
    var bytes = (0, $j2rU8.arrayify)(data);
    var decoded = $a139c5939e084c8c$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $a139c5939e084c8c$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}

});
parcelRequire.register("j2rU8", function(module, exports) {

$parcel$export(module.exports, "isBytesLike", function () { return $ddc3d9704a40b613$export$9a14abb1a440cd5e; });
$parcel$export(module.exports, "isHexString", function () { return $ddc3d9704a40b613$export$b02a40aff8e4ad18; });
$parcel$export(module.exports, "isBytes", function () { return $ddc3d9704a40b613$export$c6fabfbfd097fc30; });
$parcel$export(module.exports, "arrayify", function () { return $ddc3d9704a40b613$export$3131421a7d01b4fb; });
$parcel$export(module.exports, "concat", function () { return $ddc3d9704a40b613$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "stripZeros", function () { return $ddc3d9704a40b613$export$a8f4574d0e56446c; });
$parcel$export(module.exports, "zeroPad", function () { return $ddc3d9704a40b613$export$3cdc770bf8b2ed3d; });
$parcel$export(module.exports, "hexlify", function () { return $ddc3d9704a40b613$export$2b0d6b5fbe698c70; });
$parcel$export(module.exports, "hexDataLength", function () { return $ddc3d9704a40b613$export$13882f896d3c0683; });
$parcel$export(module.exports, "hexDataSlice", function () { return $ddc3d9704a40b613$export$15da666eba198c18; });
$parcel$export(module.exports, "hexConcat", function () { return $ddc3d9704a40b613$export$6d4b99629b38754a; });
$parcel$export(module.exports, "hexValue", function () { return $ddc3d9704a40b613$export$6916af760a341dd3; });
$parcel$export(module.exports, "hexStripZeros", function () { return $ddc3d9704a40b613$export$967bc0082a978949; });
$parcel$export(module.exports, "hexZeroPad", function () { return $ddc3d9704a40b613$export$e9c46a54370b47e8; });
$parcel$export(module.exports, "splitSignature", function () { return $ddc3d9704a40b613$export$7fb170f1e457988f; });
$parcel$export(module.exports, "joinSignature", function () { return $ddc3d9704a40b613$export$71bb9d78a59bbe25; });

var $1ObTH = parcelRequire("1ObTH");

var $6M65e = parcelRequire("6M65e");

var $eraBF = parcelRequire("eraBF");
"use strict";
var $ddc3d9704a40b613$var$logger = new (0, $6M65e.Logger)((0, $eraBF.version));
///////////////////////////////
function $ddc3d9704a40b613$var$isHexable(value) {
    return !!value.toHexString;
}
function $ddc3d9704a40b613$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        var args = Array.prototype.slice.call(arguments);
        return $ddc3d9704a40b613$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $ddc3d9704a40b613$export$9a14abb1a440cd5e(value) {
    return $ddc3d9704a40b613$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $ddc3d9704a40b613$export$c6fabfbfd097fc30(value);
}
function $ddc3d9704a40b613$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $ddc3d9704a40b613$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$ddc3d9704a40b613$var$isInteger(value.length) || value.length < 0) return false;
    for(var i = 0; i < value.length; i++){
        var v = value[i];
        if (!$ddc3d9704a40b613$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $ddc3d9704a40b613$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $ddc3d9704a40b613$var$logger.checkSafeUint53(value, "invalid arrayify value");
        var result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $ddc3d9704a40b613$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($ddc3d9704a40b613$var$isHexable(value)) value = value.toHexString();
    if ($ddc3d9704a40b613$export$b02a40aff8e4ad18(value)) {
        var hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $ddc3d9704a40b613$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        var result1 = [];
        for(var i = 0; i < hex.length; i += 2)result1.push(parseInt(hex.substring(i, i + 2), 16));
        return $ddc3d9704a40b613$var$addSlice(new Uint8Array(result1));
    }
    if ($ddc3d9704a40b613$export$c6fabfbfd097fc30(value)) return $ddc3d9704a40b613$var$addSlice(new Uint8Array(value));
    return $ddc3d9704a40b613$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $ddc3d9704a40b613$export$ee1b3e54f0441b22(items) {
    var objects = items.map(function(item) {
        return $ddc3d9704a40b613$export$3131421a7d01b4fb(item);
    });
    var length = objects.reduce(function(accum, item) {
        return accum + item.length;
    }, 0);
    var result = new Uint8Array(length);
    objects.reduce(function(offset, object) {
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $ddc3d9704a40b613$var$addSlice(result);
}
function $ddc3d9704a40b613$export$a8f4574d0e56446c(value) {
    var result = $ddc3d9704a40b613$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    var start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $ddc3d9704a40b613$export$3cdc770bf8b2ed3d(value, length) {
    value = $ddc3d9704a40b613$export$3131421a7d01b4fb(value);
    if (value.length > length) $ddc3d9704a40b613$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    var result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $ddc3d9704a40b613$var$addSlice(result);
}
function $ddc3d9704a40b613$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
var $ddc3d9704a40b613$var$HexCharacters = "0123456789abcdef";
function $ddc3d9704a40b613$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $ddc3d9704a40b613$var$logger.checkSafeUint53(value, "invalid hexlify value");
        var hex = "";
        while(value){
            hex = $ddc3d9704a40b613$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if ((typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value)) === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($ddc3d9704a40b613$var$isHexable(value)) return value.toHexString();
    if ($ddc3d9704a40b613$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $ddc3d9704a40b613$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($ddc3d9704a40b613$export$c6fabfbfd097fc30(value)) {
        var result = "0x";
        for(var i = 0; i < value.length; i++){
            var v = value[i];
            result += $ddc3d9704a40b613$var$HexCharacters[(v & 0xf0) >> 4] + $ddc3d9704a40b613$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $ddc3d9704a40b613$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $ddc3d9704a40b613$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(data);
    else if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $ddc3d9704a40b613$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(data);
    else if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(data) || data.length % 2) $ddc3d9704a40b613$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $ddc3d9704a40b613$export$6d4b99629b38754a(items) {
    var result = "0x";
    items.forEach(function(item) {
        result += $ddc3d9704a40b613$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $ddc3d9704a40b613$export$6916af760a341dd3(value) {
    var trimmed = $ddc3d9704a40b613$export$967bc0082a978949($ddc3d9704a40b613$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $ddc3d9704a40b613$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(value);
    if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(value)) $ddc3d9704a40b613$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    var offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $ddc3d9704a40b613$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(value);
    else if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(value)) $ddc3d9704a40b613$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $ddc3d9704a40b613$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $ddc3d9704a40b613$export$7fb170f1e457988f(signature) {
    var result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($ddc3d9704a40b613$export$9a14abb1a440cd5e(signature)) {
        var bytes = $ddc3d9704a40b613$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $ddc3d9704a40b613$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $ddc3d9704a40b613$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            var vs = $ddc3d9704a40b613$export$3cdc770bf8b2ed3d($ddc3d9704a40b613$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            var recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $ddc3d9704a40b613$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            var s = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $ddc3d9704a40b613$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $ddc3d9704a40b613$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            var recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $ddc3d9704a40b613$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$ddc3d9704a40b613$export$b02a40aff8e4ad18(result.r)) $ddc3d9704a40b613$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $ddc3d9704a40b613$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$ddc3d9704a40b613$export$b02a40aff8e4ad18(result.s)) $ddc3d9704a40b613$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $ddc3d9704a40b613$export$e9c46a54370b47e8(result.s, 32);
        var vs1 = $ddc3d9704a40b613$export$3131421a7d01b4fb(result.s);
        if (vs1[0] >= 128) $ddc3d9704a40b613$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs1[0] |= 0x80;
        var _vs = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(vs1);
        if (result._vs) {
            if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(result._vs)) $ddc3d9704a40b613$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $ddc3d9704a40b613$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $ddc3d9704a40b613$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $ddc3d9704a40b613$export$71bb9d78a59bbe25(signature) {
    signature = $ddc3d9704a40b613$export$7fb170f1e457988f(signature);
    return $ddc3d9704a40b613$export$2b0d6b5fbe698c70($ddc3d9704a40b613$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRequire.register("6M65e", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "Logger", function () { return $4eebf1ca9f327f54$export$efa9a398d6368992; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $3uyfT = parcelRequire("3uyfT");
"use strict";
var $4eebf1ca9f327f54$var$_permanentCensorErrors = false;
var $4eebf1ca9f327f54$var$_censorErrors = false;
var $4eebf1ca9f327f54$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
var $4eebf1ca9f327f54$var$_logLevel = $4eebf1ca9f327f54$var$LogLevels["default"];
var $4eebf1ca9f327f54$var$_globalLogger = null;
function $4eebf1ca9f327f54$var$_checkNormalize() {
    try {
        var missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach(function(form) {
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
var $4eebf1ca9f327f54$var$_normalizeError = $4eebf1ca9f327f54$var$_checkNormalize();
var $4eebf1ca9f327f54$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($4eebf1ca9f327f54$export$243e62d78d3b544d || ($4eebf1ca9f327f54$export$243e62d78d3b544d = {}));
var $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($4eebf1ca9f327f54$export$d4e71bc0b80dc0fb || ($4eebf1ca9f327f54$export$d4e71bc0b80dc0fb = {}));
var $4eebf1ca9f327f54$var$HEX = "0123456789abcdef";
var $4eebf1ca9f327f54$export$efa9a398d6368992 = /*#__PURE__*/ function() {
    function Logger(version) {
        (0, $978gY._)(this, Logger);
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    (0, $kry2a._)(Logger, [
        {
            key: "_log",
            value: function _log(logLevel, args) {
                var level = logLevel.toLowerCase();
                if ($4eebf1ca9f327f54$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
                if ($4eebf1ca9f327f54$var$_logLevel > $4eebf1ca9f327f54$var$LogLevels[level]) return;
                console.log.apply(console, args);
            }
        },
        {
            key: "debug",
            value: function debug() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._log(Logger.levels.DEBUG, args);
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._log(Logger.levels.INFO, args);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._log(Logger.levels.WARNING, args);
            }
        },
        {
            key: "makeError",
            value: function makeError(message, code, params) {
                // Errors are being censored
                if ($4eebf1ca9f327f54$var$_censorErrors) return this.makeError("censored error", code, {});
                if (!code) code = Logger.errors.UNKNOWN_ERROR;
                if (!params) params = {};
                var messageDetails = [];
                Object.keys(params).forEach(function(key) {
                    var value = params[key];
                    try {
                        if (value instanceof Uint8Array) {
                            var hex = "";
                            for(var i = 0; i < value.length; i++){
                                hex += $4eebf1ca9f327f54$var$HEX[value[i] >> 4];
                                hex += $4eebf1ca9f327f54$var$HEX[value[i] & 0x0f];
                            }
                            messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                        } else messageDetails.push(key + "=" + JSON.stringify(value));
                    } catch (error) {
                        messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
                    }
                });
                messageDetails.push("code=".concat(code));
                messageDetails.push("version=".concat(this.version));
                var reason = message;
                var url = "";
                switch(code){
                    case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                        {
                            url = "NUMERIC_FAULT";
                            var fault = message;
                            switch(fault){
                                case "overflow":
                                case "underflow":
                                case "division-by-zero":
                                    url += "-" + fault;
                                    break;
                                case "negative-power":
                                case "negative-width":
                                    url += "-unsupported";
                                    break;
                                case "unbound-bitwise-result":
                                    url += "-unbound-result";
                                    break;
                            }
                            break;
                        }
                    case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
                    case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
                    case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.MISSING_NEW:
                    case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
                    case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
                    case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
                    case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                        url = code;
                        break;
                }
                if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
                if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
                // @TODO: Any??
                var error = new Error(message);
                error.reason = reason;
                error.code = code;
                Object.keys(params).forEach(function(key) {
                    error[key] = params[key];
                });
                return error;
            }
        },
        {
            key: "throwError",
            value: function throwError(message, code, params) {
                throw this.makeError(message, code, params);
            }
        },
        {
            key: "throwArgumentError",
            value: function throwArgumentError(message, name, value) {
                return this.throwError(message, Logger.errors.INVALID_ARGUMENT, {
                    argument: name,
                    value: value
                });
            }
        },
        {
            key: "assert",
            value: function assert(condition, message, code, params) {
                if (!!condition) return;
                this.throwError(message, code, params);
            }
        },
        {
            key: "assertArgument",
            value: function assertArgument(condition, message, name, value) {
                if (!!condition) return;
                this.throwArgumentError(message, name, value);
            }
        },
        {
            key: "checkNormalize",
            value: function checkNormalize(message) {
                if (message == null) message = "platform missing String.prototype.normalize";
                if ($4eebf1ca9f327f54$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "String.prototype.normalize",
                    form: $4eebf1ca9f327f54$var$_normalizeError
                });
            }
        },
        {
            key: "checkSafeUint53",
            value: function checkSafeUint53(value, message) {
                if (typeof value !== "number") return;
                if (message == null) message = "value not safe";
                if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, Logger.errors.NUMERIC_FAULT, {
                    operation: "checkSafeInteger",
                    fault: "out-of-safe-range",
                    value: value
                });
                if (value % 1) this.throwError(message, Logger.errors.NUMERIC_FAULT, {
                    operation: "checkSafeInteger",
                    fault: "non-integer",
                    value: value
                });
            }
        },
        {
            key: "checkArgumentCount",
            value: function checkArgumentCount(count, expectedCount, message) {
                if (message) message = ": " + message;
                else message = "";
                if (count < expectedCount) this.throwError("missing argument" + message, Logger.errors.MISSING_ARGUMENT, {
                    count: count,
                    expectedCount: expectedCount
                });
                if (count > expectedCount) this.throwError("too many arguments" + message, Logger.errors.UNEXPECTED_ARGUMENT, {
                    count: count,
                    expectedCount: expectedCount
                });
            }
        },
        {
            key: "checkNew",
            value: function checkNew(target, kind) {
                if (target === Object || target == null) this.throwError("missing new", Logger.errors.MISSING_NEW, {
                    name: kind.name
                });
            }
        },
        {
            key: "checkAbstract",
            value: function checkAbstract(target, kind) {
                if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", Logger.errors.UNSUPPORTED_OPERATION, {
                    name: target.name,
                    operation: "new"
                });
                else if (target === Object || target == null) this.throwError("missing new", Logger.errors.MISSING_NEW, {
                    name: kind.name
                });
            }
        }
    ], [
        {
            key: "globalLogger",
            value: function globalLogger() {
                if (!$4eebf1ca9f327f54$var$_globalLogger) $4eebf1ca9f327f54$var$_globalLogger = new Logger((0, $3uyfT.version));
                return $4eebf1ca9f327f54$var$_globalLogger;
            }
        },
        {
            key: "setCensorship",
            value: function setCensorship(censorship, permanent) {
                if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "setCensorship"
                });
                if ($4eebf1ca9f327f54$var$_permanentCensorErrors) {
                    if (!censorship) return;
                    this.globalLogger().throwError("error censorship permanent", Logger.errors.UNSUPPORTED_OPERATION, {
                        operation: "setCensorship"
                    });
                }
                $4eebf1ca9f327f54$var$_censorErrors = !!censorship;
                $4eebf1ca9f327f54$var$_permanentCensorErrors = !!permanent;
            }
        },
        {
            key: "setLogLevel",
            value: function setLogLevel(logLevel) {
                var level = $4eebf1ca9f327f54$var$LogLevels[logLevel.toLowerCase()];
                if (level == null) {
                    Logger.globalLogger().warn("invalid log level - " + logLevel);
                    return;
                }
                $4eebf1ca9f327f54$var$_logLevel = level;
            }
        },
        {
            key: "from",
            value: function from(version) {
                return new Logger(version);
            }
        }
    ]);
    return Logger;
}();
$4eebf1ca9f327f54$export$efa9a398d6368992.errors = $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb;
$4eebf1ca9f327f54$export$efa9a398d6368992.levels = $4eebf1ca9f327f54$export$243e62d78d3b544d;

});
parcelRequire.register("978gY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6a2b2f5024d4ec83$export$2996f80ef42b8419; });
function $6a2b2f5024d4ec83$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRequire.register("kry2a", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ee20bab046a9ef96$export$d60067ff2358eee8; });
function $ee20bab046a9ef96$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ee20bab046a9ef96$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $ee20bab046a9ef96$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ee20bab046a9ef96$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRequire.register("3uyfT", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $28aebedb0958c5ea$export$83d89fbfd8236492; });
var $28aebedb0958c5ea$export$83d89fbfd8236492 = "logger/5.7.0";

});


parcelRequire.register("eraBF", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $a82bd087aad0b6d2$export$83d89fbfd8236492; });
var $a82bd087aad0b6d2$export$83d89fbfd8236492 = "bytes/5.7.0";

});


parcelRequire.register("j3HdL", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $ddffd2eacde14166$export$83d89fbfd8236492; });
var $ddffd2eacde14166$export$83d89fbfd8236492 = "rlp/5.7.0";

});


parcelRequire.register("hk1je", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return (parcelRequire("70PIu")).decode; });
$parcel$export(module.exports, "encode", function () { return (parcelRequire("70PIu")).encode; });

var $70PIu = parcelRequire("70PIu");
"use strict";

});
parcelRequire.register("70PIu", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $51b0a655b2efccfa$export$2f872c0f2117be69; });
$parcel$export(module.exports, "encode", function () { return $51b0a655b2efccfa$export$c564cdbbe6da493; });

var $j2rU8 = parcelRequire("j2rU8");
"use strict";
function $51b0a655b2efccfa$export$2f872c0f2117be69(textData) {
    textData = atob(textData);
    var data = [];
    for(var i = 0; i < textData.length; i++)data.push(textData.charCodeAt(i));
    return (0, $j2rU8.arrayify)(data);
}
function $51b0a655b2efccfa$export$c564cdbbe6da493(data) {
    data = (0, $j2rU8.arrayify)(data);
    var textData = "";
    for(var i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}

});


parcelRequire.register("98ZRp", function(module, exports) {
"use strict";
var $6a84d8981263b8da$var$__assign = module.exports && module.exports.__assign || function() {
    $6a84d8981263b8da$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6a84d8981263b8da$var$__assign.apply(this, arguments);
};
var $6a84d8981263b8da$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6a84d8981263b8da$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};
var $6a84d8981263b8da$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6a84d8981263b8da$var$lodash_1 = $6a84d8981263b8da$var$__importDefault((parcelRequire("c9wMV")));

var $6a84d8981263b8da$var$arweave_proxy_1 = $6a84d8981263b8da$var$__importDefault((parcelRequire("dsDoQ")));

var $6a84d8981263b8da$var$cache_proxy_1 = $6a84d8981263b8da$var$__importDefault((parcelRequire("hxn3s")));

var $6a84d8981263b8da$var$signature_verifier_1 = $6a84d8981263b8da$var$__importDefault((parcelRequire("6Logc")));

var $6a84d8981263b8da$var$price_not_found_1 = $6a84d8981263b8da$var$__importDefault((parcelRequire("cjX9b")));

var $6a84d8981263b8da$var$index_1 = $6a84d8981263b8da$var$__importDefault((parcelRequire("4DZj3")));
var $6a84d8981263b8da$var$REDSTONE_API_DEFAULTS = {
    defaultProvider: "redstone",
    useCache: true,
    verifySignature: false
};
// Providers list is sorted by priority (redstone-rapid has the highest priority)
var $6a84d8981263b8da$var$PROVIDERS_SORTED_BY_PRIORITY = [
    "redstone-rapid",
    "redstone-stocks",
    "redstone"
];
var $6a84d8981263b8da$var$RedstoneApi = /** @class */ function() {
    var RedstoneApi = function RedstoneApi(redstoneConfig) {
        if (redstoneConfig === void 0) redstoneConfig = {};
        this.arweaveProxy = new $6a84d8981263b8da$var$arweave_proxy_1.default();
        this.cacheProxy = new $6a84d8981263b8da$var$cache_proxy_1.default($6a84d8981263b8da$var$lodash_1.default.defaultTo(redstoneConfig.cacheApiUrl, $6a84d8981263b8da$var$index_1.default.cacheApiUrl));
        this.signatureVerifier = new $6a84d8981263b8da$var$signature_verifier_1.default(this.arweaveProxy);
        this.version = $6a84d8981263b8da$var$lodash_1.default.defaultTo(redstoneConfig.version, $6a84d8981263b8da$var$index_1.default.version);
        this.verifySignature = $6a84d8981263b8da$var$lodash_1.default.defaultTo(redstoneConfig.verifySignature, $6a84d8981263b8da$var$REDSTONE_API_DEFAULTS.verifySignature);
        this.defaultProvider = $6a84d8981263b8da$var$lodash_1.default.defaultTo(redstoneConfig.defaultProvider, $6a84d8981263b8da$var$REDSTONE_API_DEFAULTS.defaultProvider);
        this.useCache = $6a84d8981263b8da$var$lodash_1.default.defaultTo(redstoneConfig.useCache, $6a84d8981263b8da$var$REDSTONE_API_DEFAULTS.useCache);
    };
    RedstoneApi.prototype.setCacheApiUrl = function(cacheApiUrl) {
        this.cacheProxy.setCacheApiUrl(cacheApiUrl);
    };
    RedstoneApi.prototype.getPrice = function(symbolOrSymbols, opts) {
        if (opts === void 0) opts = {};
        return $6a84d8981263b8da$var$__awaiter(this, void 0, void 0, function() {
            var shouldVerifySignature, symbols, provider, symbol, provider;
            return $6a84d8981263b8da$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        shouldVerifySignature = $6a84d8981263b8da$var$lodash_1.default.defaultTo(opts.verifySignature, this.verifySignature);
                        if (!$6a84d8981263b8da$var$lodash_1.default.isArray(symbolOrSymbols)) return [
                            3 /*break*/ ,
                            2
                        ];
                        symbols = symbolOrSymbols;
                        provider = this.getProviderForSymbols(symbols, opts.provider);
                        return [
                            4 /*yield*/ ,
                            this.getPriceForManyTokens({
                                symbols: symbols,
                                provider: provider,
                                shouldVerifySignature: shouldVerifySignature
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 2:
                        if (!(typeof symbolOrSymbols === "string")) return [
                            3 /*break*/ ,
                            4
                        ];
                        symbol = symbolOrSymbols;
                        provider = this.getProviderForSymbol(symbol, opts.provider);
                        return [
                            4 /*yield*/ ,
                            this.getLatestPriceForOneToken({
                                symbol: symbol,
                                provider: provider,
                                shouldVerifySignature: shouldVerifySignature
                            })
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RedstoneApi.prototype.getHistoricalPrice = function(symbolOrSymbols, opts) {
        return $6a84d8981263b8da$var$__awaiter(this, void 0, void 0, function() {
            var shouldVerifySignature, symbols, provider, symbol, provider;
            return $6a84d8981263b8da$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        shouldVerifySignature = $6a84d8981263b8da$var$lodash_1.default.defaultTo(opts.verifySignature, this.verifySignature);
                        if (!$6a84d8981263b8da$var$lodash_1.default.isArray(symbolOrSymbols)) return [
                            3 /*break*/ ,
                            2
                        ];
                        symbols = symbolOrSymbols;
                        provider = this.getProviderForSymbols(symbols, opts.provider);
                        return [
                            4 /*yield*/ ,
                            this.getPriceForManyTokens({
                                symbols: symbols,
                                timestamp: $6a84d8981263b8da$var$getTimestamp(opts.date),
                                provider: provider,
                                shouldVerifySignature: shouldVerifySignature
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 2:
                        if (!(typeof symbolOrSymbols === "string")) return [
                            3 /*break*/ ,
                            6
                        ];
                        symbol = symbolOrSymbols;
                        provider = this.getProviderForSymbol(symbol, opts.provider);
                        if (!(opts.interval !== undefined || opts.limit !== undefined)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getHistoricalPricesForOneSymbol({
                                symbol: symbol,
                                fromTimestamp: $6a84d8981263b8da$var$getTimestamp(opts.startDate),
                                toTimestamp: $6a84d8981263b8da$var$getTimestamp(opts.endDate),
                                interval: opts.interval,
                                offset: opts.offset,
                                limit: opts.limit,
                                provider: provider,
                                shouldVerifySignature: shouldVerifySignature
                            })
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            this.getHistoricalPriceForOneSymbol({
                                symbol: symbol,
                                timestamp: $6a84d8981263b8da$var$getTimestamp(opts.date),
                                provider: provider,
                                shouldVerifySignature: shouldVerifySignature
                            })
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Returns the latest price for all the supported symbols
     *
     * @param opts - Optioanl options object.
     * * opts.provider: provider name (string)
     * * opts.verifySignature: enable signature verification (boolean)
     * @returns The latest price for all the supported tokens
     *
     */ RedstoneApi.prototype.getAllPrices = function(opts) {
        if (opts === void 0) opts = {};
        return $6a84d8981263b8da$var$__awaiter(this, void 0, void 0, function() {
            var provider, pricesObj, _i, _a, symbol;
            return $6a84d8981263b8da$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        provider = $6a84d8981263b8da$var$lodash_1.default.defaultTo(opts.provider, this.defaultProvider);
                        if (!this.useCache) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cacheProxy.getPriceForManyTokens({
                                provider: provider
                            })
                        ];
                    case 1:
                        pricesObj = _b.sent();
                        // Signature verification
                        if ($6a84d8981263b8da$var$lodash_1.default.defaultTo(opts.verifySignature, this.verifySignature)) for(_i = 0, _a = $6a84d8981263b8da$var$lodash_1.default.keys(pricesObj); _i < _a.length; _i++){
                            symbol = _a[_i];
                            this.signatureVerifier.assertValidSignature(pricesObj[symbol]);
                        }
                        return [
                            2 /*return*/ ,
                            $6a84d8981263b8da$var$convertPricesToUserFacingFormat(pricesObj)
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.getPricesFromArweave(provider)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    RedstoneApi.prototype.getLatestPriceForOneToken = function(args) {
        return $6a84d8981263b8da$var$__awaiter(this, void 0, void 0, function() {
            var price, price, prices, priceForSymbol;
            return $6a84d8981263b8da$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.useCache) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cacheProxy.getPrice($6a84d8981263b8da$var$lodash_1.default.pick(args, [
                                "symbol",
                                "provider"
                            ]))
                        ];
                    case 1:
                        price = _a.sent();
                        if (!(args.shouldVerifySignature && price !== undefined)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.signatureVerifier.assertValidSignature(price)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (price === undefined) throw new $6a84d8981263b8da$var$price_not_found_1.default(args.symbol);
                        return [
                            2 /*return*/ ,
                            $6a84d8981263b8da$var$convertToUserFacingFormat(price)
                        ];
                    case 4:
                        if (!(args.symbol === "AR")) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            this.tryToGetPriceFromGQL($6a84d8981263b8da$var$lodash_1.default.pick(args, [
                                "provider",
                                "symbol"
                            ]))
                        ];
                    case 5:
                        price = _a.sent();
                        if (price !== undefined) return [
                            2 /*return*/ ,
                            $6a84d8981263b8da$var$convertToUserFacingFormat(price)
                        ];
                        _a.label = 6;
                    case 6:
                        return [
                            4 /*yield*/ ,
                            this.getPricesFromArweave(args.provider)
                        ];
                    case 7:
                        prices = _a.sent();
                        priceForSymbol = prices[args.symbol];
                        return [
                            2 /*return*/ ,
                            $6a84d8981263b8da$var$convertToUserFacingFormat(priceForSymbol)
                        ];
                }
            });
        });
    };
    RedstoneApi.prototype.getPriceForManyTokens = function(args) {
        return $6a84d8981263b8da$var$__awaiter(this, void 0, void 0, function() {
            var pricesObj, _i, _a, symbol, allPrices, pricesObj;
            return $6a84d8981263b8da$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.useCache) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cacheProxy.getPriceForManyTokens($6a84d8981263b8da$var$lodash_1.default.pick(args, [
                                "symbols",
                                "provider",
                                "timestamp"
                            ]))
                        ];
                    case 1:
                        pricesObj = _b.sent();
                        // Signature verification
                        if (args.shouldVerifySignature) for(_i = 0, _a = $6a84d8981263b8da$var$lodash_1.default.keys(pricesObj); _i < _a.length; _i++){
                            symbol = _a[_i];
                            this.signatureVerifier.assertValidSignature(pricesObj[symbol]);
                        }
                        return [
                            2 /*return*/ ,
                            $6a84d8981263b8da$var$convertPricesToUserFacingFormat(pricesObj)
                        ];
                    case 2:
                        if (args.timestamp !== undefined) throw new Error("Getting historical prices from arweave is not supported");
                        return [
                            4 /*yield*/ ,
                            this.getPricesFromArweave(args.provider)
                        ];
                    case 3:
                        allPrices = _b.sent();
                        pricesObj = $6a84d8981263b8da$var$lodash_1.default.pick(allPrices, args.symbols);
                        return [
                            2 /*return*/ ,
                            $6a84d8981263b8da$var$convertPricesToUserFacingFormat(pricesObj)
                        ];
                }
            });
        });
    };
    RedstoneApi.prototype.getPricesFromArweave = function(provider) {
        return $6a84d8981263b8da$var$__awaiter(this, void 0, void 0, function() {
            var address, gqlResponse, prices, pricesObj, _i, prices_1, price;
            return $6a84d8981263b8da$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.arweaveProxy.getProviderDetails(provider)
                        ];
                    case 1:
                        address = _a.sent().address;
                        return [
                            4 /*yield*/ ,
                            this.arweaveProxy.findPricesInGraphQL({
                                type: "data",
                                providerAddress: address,
                                version: this.version
                            })
                        ];
                    case 2:
                        gqlResponse = _a.sent();
                        if (gqlResponse === undefined) return [
                            2 /*return*/ ,
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this.arweaveProxy.getTxDataById(gqlResponse.permawebTx, {
                                parseJSON: true
                            })
                        ];
                    case 3:
                        prices = _a.sent();
                        pricesObj = {};
                        for(_i = 0, prices_1 = prices; _i < prices_1.length; _i++){
                            price = prices_1[_i];
                            pricesObj[price.symbol] = $6a84d8981263b8da$var$__assign($6a84d8981263b8da$var$__assign({}, price), {
                                provider: address,
                                permawebTx: gqlResponse.permawebTx
                            });
                        }
                        return [
                            2 /*return*/ ,
                            $6a84d8981263b8da$var$convertPricesToUserFacingFormat(pricesObj)
                        ];
                }
            });
        });
    };
    RedstoneApi.prototype.getHistoricalPriceForOneSymbol = function(args) {
        return $6a84d8981263b8da$var$__awaiter(this, void 0, void 0, function() {
            var price;
            return $6a84d8981263b8da$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.useCache) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cacheProxy.getPrice($6a84d8981263b8da$var$lodash_1.default.pick(args, [
                                "symbol",
                                "provider",
                                "timestamp"
                            ]))
                        ];
                    case 1:
                        price = _a.sent();
                        if (!(args.shouldVerifySignature && price !== undefined)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.signatureVerifier.assertValidSignature(price)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (price === undefined) throw new $6a84d8981263b8da$var$price_not_found_1.default(args.symbol);
                        return [
                            2 /*return*/ ,
                            $6a84d8981263b8da$var$convertToUserFacingFormat(price)
                        ];
                    case 4:
                        // TODO: we cannot query ArGQL with timestamp comparators like timestamp_gt
                        // But in future we can think of querying based on block numbers
                        throw new Error("Fetching historical price from arweave is not supported");
                }
            });
        });
    };
    RedstoneApi.prototype.tryToGetPriceFromGQL = function(args) {
        return $6a84d8981263b8da$var$__awaiter(this, void 0, void 0, function() {
            var address, response;
            return $6a84d8981263b8da$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.arweaveProxy.getProviderDetails(args.provider)
                        ];
                    case 1:
                        address = _a.sent().address;
                        return [
                            4 /*yield*/ ,
                            this.arweaveProxy.findPricesInGraphQL({
                                type: "data",
                                providerAddress: address,
                                version: this.version
                            })
                        ];
                    case 2:
                        response = _a.sent();
                        if (response === undefined || response.tags[args.symbol] === undefined) throw new $6a84d8981263b8da$var$price_not_found_1.default(args.symbol);
                        else return [
                            2 /*return*/ ,
                            {
                                symbol: args.symbol,
                                value: Number(response.tags[args.symbol]),
                                permawebTx: response.permawebTx,
                                timestamp: Number(response.tags.timestamp),
                                provider: address
                            }
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RedstoneApi.prototype.getHistoricalPricesForOneSymbol = function(args) {
        return $6a84d8981263b8da$var$__awaiter(this, void 0, void 0, function() {
            var prices, _i, prices_2, price;
            return $6a84d8981263b8da$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.useCache) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cacheProxy.getManyPrices($6a84d8981263b8da$var$lodash_1.default.pick(args, [
                                "symbol",
                                "provider",
                                "fromTimestamp",
                                "toTimestamp",
                                "interval",
                                "offset",
                                "limit"
                            ]))
                        ];
                    case 1:
                        prices = _a.sent();
                        if (!args.shouldVerifySignature) return [
                            3 /*break*/ ,
                            5
                        ];
                        _i = 0, prices_2 = prices;
                        _a.label = 2;
                    case 2:
                        if (!(_i < prices_2.length)) return [
                            3 /*break*/ ,
                            5
                        ];
                        price = prices_2[_i];
                        return [
                            4 /*yield*/ ,
                            this.signatureVerifier.assertValidSignature(price)
                        ];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            prices.map($6a84d8981263b8da$var$convertToUserFacingFormat)
                        ];
                    case 6:
                        // TODO: we cannot query ArGQL with timestamp comparators like timestamp_gt
                        // But in future we can think of querying based on block numbers
                        throw new Error("Fetching historical prices from arweave is not supported");
                }
            });
        });
    };
    RedstoneApi.prototype.getProviderForSymbol = function(symbol, provider) {
        return this.getProviderForSymbols([
            symbol
        ], provider);
    };
    RedstoneApi.prototype.getProviderForSymbols = function(symbols, passedProvider) {
        if (passedProvider !== undefined) return passedProvider;
        else {
            // Calculating a list of providers which support all symbols in the list
            var possibleProviders = Array.from($6a84d8981263b8da$var$PROVIDERS_SORTED_BY_PRIORITY);
            for(var _i = 0, symbols_1 = symbols; _i < symbols_1.length; _i++){
                var symbol = symbols_1[_i];
                var providersForToken = $6a84d8981263b8da$var$index_1.default.tokens[symbol];
                if (providersForToken && Array.isArray(providersForToken)) {
                    var _loop_1 = function _loop_1(provider) {
                        // If any of symbols doesn't support the provider
                        // it can not be used
                        if (!providersForToken.includes(provider)) possibleProviders = possibleProviders.filter(function(p) {
                            return p !== provider;
                        });
                    };
                    for(var _a = 0, possibleProviders_1 = possibleProviders; _a < possibleProviders_1.length; _a++){
                        var provider = possibleProviders_1[_a];
                        _loop_1(provider);
                    }
                } else {
                    // If any symbol has no supported providers in redstone-node config
                    // we break the loop and return the default provider
                    possibleProviders = [];
                    break;
                }
            }
            // Returning the best possible provider
            if (possibleProviders.length > 0) return possibleProviders[0];
            else return this.defaultProvider;
        }
    };
    return RedstoneApi;
}();
module.exports.default = $6a84d8981263b8da$var$RedstoneApi;
function $6a84d8981263b8da$var$getTimestamp(date) {
    if ($6a84d8981263b8da$var$lodash_1.default.isUndefined(date)) return undefined;
    return new Date(date).getTime();
}
function $6a84d8981263b8da$var$convertToUserFacingFormat(price) {
    var result = $6a84d8981263b8da$var$lodash_1.default.omit(price, [
        "version",
        "signature",
        "providerPublicKey"
    ]);
    return result;
}
function $6a84d8981263b8da$var$convertPricesToUserFacingFormat(prices) {
    var userFacingPricesObj = {};
    for(var _i = 0, _a = $6a84d8981263b8da$var$lodash_1.default.keys(prices); _i < _a.length; _i++){
        var symbol = _a[_i];
        userFacingPricesObj[symbol] = $6a84d8981263b8da$var$convertToUserFacingFormat(prices[symbol]);
    }
    return userFacingPricesObj;
}

});
parcelRequire.register("c9wMV", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
(function() {
    var apply = /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    };
    var arrayAggregator = /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    };
    var arrayEach = /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    };
    var arrayEachRight = /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    };
    var arrayEvery = /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    };
    var arrayFilter = /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    };
    var arrayIncludes = /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    };
    var arrayIncludesWith = /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    };
    var arrayMap = /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    };
    var arrayPush = /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    };
    var arrayReduce = /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    };
    var arrayReduceRight = /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    };
    var arraySome = /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    };
    var asciiToArray = /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    };
    var asciiWords = /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    };
    var baseFindKey = /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    };
    var baseFindIndex = /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    };
    var baseIndexOf = /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    };
    var baseIndexOfWith = /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    };
    var baseIsNaN = /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    };
    var baseMean = /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    };
    var baseProperty = /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined1 : object[key];
        };
    };
    var basePropertyOf = /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined1 : object[key];
        };
    };
    var baseReduce = /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    };
    var baseSortBy = /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    };
    var baseSum = /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined1) result = result === undefined1 ? current : result + current;
        }
        return result;
    };
    var baseTimes = /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    };
    var baseToPairs = /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    };
    var baseTrim = /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    };
    var baseUnary = /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    };
    var baseValues = /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    };
    var cacheHas = /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    };
    var charsStartIndex = /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    };
    var charsEndIndex = /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    };
    var countHolders = /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    };
    var escapeStringChar = /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    };
    var getValue = /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined1 : object[key];
    };
    var hasUnicode = /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    };
    var hasUnicodeWord = /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    };
    var iteratorToArray = /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    };
    var mapToArray = /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    };
    var overArg = /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    };
    var replaceHolders = /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    };
    var setToArray = /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    };
    var setToPairs = /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    };
    var strictIndexOf = /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    };
    var strictLastIndexOf = /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    };
    var stringSize = /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    };
    var stringToArray = /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    };
    var trimmedEndIndex = /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    };
    var unicodeSize = /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    };
    var unicodeToArray = /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    };
    var unicodeWords = /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    };
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined1;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        var lodash = /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        };
        var baseLodash = /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        };
        var LodashWrapper = /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined1;
        };
        var LazyWrapper = /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        };
        var lazyClone = /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        };
        var lazyReverse = /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        };
        var lazyValue = /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        };
        var Hash = /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        };
        var hashClear = /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        };
        var hashDelete = /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        };
        var hashGet = /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined1 : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined1;
        };
        var hashHas = /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined1 : hasOwnProperty.call(data, key);
        };
        var hashSet = /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined1 ? HASH_UNDEFINED : value;
            return this;
        };
        var ListCache = /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        };
        var listCacheClear = /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        };
        var listCacheDelete = /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        };
        var listCacheGet = /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined1 : data[index][1];
        };
        var listCacheHas = /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        };
        var listCacheSet = /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        };
        var MapCache = /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        };
        var mapCacheClear = /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        };
        var mapCacheDelete = /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        };
        var mapCacheGet = /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        };
        var mapCacheHas = /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        };
        var mapCacheSet = /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        };
        var SetCache = /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        };
        var setCacheAdd = /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        };
        var setCacheHas = /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        };
        var Stack = /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        };
        var stackClear = /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        };
        var stackDelete = /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        };
        var stackGet = /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        };
        var stackHas = /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        };
        var stackSet = /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        };
        var arrayLikeKeys = /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        };
        var arraySample = /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined1;
        };
        var arraySampleSize = /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        };
        var arrayShuffle = /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        };
        var assignMergeValue = /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined1 && !eq(object[key], value) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        };
        var assignValue = /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        };
        var assocIndexOf = /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        };
        var baseAggregator = /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        };
        var baseAssign = /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        };
        var baseAssignIn = /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        };
        var baseAssignValue = /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        };
        var baseAt = /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined1 : get(object, paths[index]);
            return result;
        };
        var baseClamp = /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined1) number = number <= upper ? number : upper;
                if (lower !== undefined1) number = number >= lower ? number : lower;
            }
            return number;
        };
        var baseConforms = /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        };
        var baseConformsTo = /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = _$Object(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined1 && !(key in object) || !predicate(value)) return false;
            }
            return true;
        };
        var baseDelay = /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined1, args);
            }, wait);
        };
        var baseDifference = /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        };
        var baseEvery = /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        };
        var baseExtremum = /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined1 ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        };
        var baseFill = /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined1 || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        };
        var baseFilter = /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        };
        var baseForOwn = /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        };
        var baseForOwnRight = /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        };
        var baseFunctions = /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        };
        var baseGet = /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined1;
        };
        var baseGetAllKeys = /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        };
        var baseGetTag = /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined1 ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in _$Object(value) ? getRawTag(value) : objectToString(value);
        };
        var baseGt = /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        };
        var baseHas = /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        };
        var baseHasIn = /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in _$Object(object);
        };
        var baseInRange = /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        };
        var baseIntersection = /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined1;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        };
        var baseInverter = /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        };
        var baseInvoke = /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined1 : apply(func, object, args);
        };
        var baseIsArguments = /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        };
        var baseIsArrayBuffer = /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        };
        var baseIsDate = /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        };
        var baseIsEqualDeep = /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        };
        var baseIsMap = /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        };
        var baseIsMatch = /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = _$Object(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined1 && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        };
        var baseIsNative = /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        };
        var baseIsRegExp = /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        };
        var baseIsSet = /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        };
        var baseIsTypedArray = /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        };
        var baseIteratee = /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        };
        var baseKeys = /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in _$Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        };
        var baseKeysIn = /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        };
        var baseLt = /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        };
        var baseMap = /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        };
        var baseMatches = /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        };
        var baseMatchesProperty = /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        };
        var baseMergeDeep = /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined1;
            var isCommon = newValue === undefined1;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        };
        var baseNth = /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined1;
        };
        var baseOrderBy = /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        };
        var basePick = /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        };
        var basePickBy = /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        };
        var basePropertyDeep = /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        };
        var basePullAll = /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        };
        var basePullAt = /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        };
        var baseRandom = /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        };
        var baseRange = /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        };
        var baseRepeat = /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        };
        var baseRest = /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        };
        var baseSample = /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        };
        var baseSampleSize = /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        };
        var baseSet = /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined1;
                    if (newValue === undefined1) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        };
        var baseShuffle = /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        };
        var baseSlice = /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        };
        var baseSome = /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        };
        var baseSortedIndex = /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        };
        var baseSortedIndexBy = /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined1;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        };
        var baseSortedUniq = /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        };
        var baseToNumber = /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        };
        var baseUniq = /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        };
        var baseUnset = /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        };
        var baseUpdate = /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        };
        var baseWhile = /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        };
        var baseWrapperValue = /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        };
        var baseXor = /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        };
        var baseZipObject = /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined1;
                assignFunc(result, props[index], value);
            }
            return result;
        };
        var castArrayLikeObject = /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        };
        var castFunction = /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        };
        var castPath = /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        };
        var castSlice = /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined1 ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        };
        var cloneBuffer = /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        };
        var cloneArrayBuffer = /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        };
        var cloneDataView = /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        };
        var cloneRegExp = /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        };
        var cloneSymbol = /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? _$Object(symbolValueOf.call(symbol)) : {};
        };
        var cloneTypedArray = /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        };
        var compareAscending = /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        };
        var compareMultiple = /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        };
        var composeArgs = /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        };
        var composeArgsRight = /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        };
        var copyArray = /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        };
        var copyObject = /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined1;
                if (newValue === undefined1) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        };
        var copySymbols = /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        };
        var copySymbolsIn = /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        };
        var createAggregator = /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        };
        var createAssigner = /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined1, guard = length > 2 ? sources[2] : undefined1;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined1;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined1 : customizer;
                    length = 1;
                }
                object = _$Object(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        };
        var createBaseEach = /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = _$Object(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        };
        var createBaseFor = /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = _$Object(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        };
        var createBind = /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        };
        var createCaseFirst = /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined1;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        };
        var createCompounder = /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        };
        var createCtor = /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        };
        var createCurry = /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined1, args, holders, undefined1, undefined1, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        };
        var createFind = /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = _$Object(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function predicate(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined1;
            };
        };
        var createFlow = /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined1;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        };
        var createInverter = /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        };
        var createMathOperation = /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined1 && other === undefined1) return defaultValue;
                if (value !== undefined1) result = value;
                if (other !== undefined1) {
                    if (result === undefined1) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        };
        var createOver = /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        };
        var createPadding = /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined1 ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        };
        var createPartial = /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        };
        var createRange = /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined1;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined1) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined1 ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        };
        var createRelationalOperation = /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        };
        var createRecurry = /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined1, newHoldersRight = isCurry ? undefined1 : holders, newPartials = isCurry ? partials : undefined1, newPartialsRight = isCurry ? undefined1 : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined1, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        };
        var createRound = /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        };
        var createToPairs = /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        };
        var createWrap = /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined1;
            }
            ary = ary === undefined1 ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined1 ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined1;
            }
            var data = isBindKey ? undefined1 : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined1, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        };
        var customDefaultsAssignIn = /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        };
        var customOmitClone = /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined1 : value;
        };
        var equalArrays = /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined1;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined1) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        };
        var equalByTag = /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        };
        var equalObjects = /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        };
        var flatRest = /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined1, flatten), func + "");
        };
        var getAllKeys = /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        };
        var getAllKeysIn = /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        };
        var getFuncName = /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        };
        var getHolder = /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        };
        var getIteratee = /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        };
        var getMapData = /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        };
        var getMatchData = /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        };
        var getNative = /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined1;
        };
        var getRawTag = /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined1;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        };
        var getView = /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        };
        var getWrapDetails = /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        };
        var hasPath = /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        };
        var initCloneArray = /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        };
        var initCloneObject = /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        };
        var initCloneByTag = /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        };
        var insertWrapDetails = /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        };
        var isFlattenable = /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        };
        var isIndex = /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value);
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        };
        var isIterateeCall = /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index === "undefined" ? "undefined" : (0, $1ObTH._)(index);
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        };
        var isKey = /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value);
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in _$Object(object);
        };
        var isKeyable = /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value);
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        };
        var isLaziable = /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        };
        var isMasked = /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        };
        var isPrototype = /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        };
        var isStrictComparable = /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        };
        var matchesStrictComparable = /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined1 || key in _$Object(object));
            };
        };
        var memoizeCapped = /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        };
        var mergeData = /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        };
        var nativeKeysIn = /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in _$Object(object))result.push(key);
            return result;
        };
        var objectToString = /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        };
        var overRest = /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined1 ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        };
        var parent = /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        };
        var reorder = /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined1;
            }
            return array;
        };
        var safeGet = /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        };
        var setWrapToString = /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        };
        var shortOut = /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined1, arguments);
            };
        };
        var shuffleSelf = /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined1 ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        };
        var toKey = /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        };
        var toSource = /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        };
        var updateWrapDetails = /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        };
        var wrapperClone = /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        };
        var chunk = /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined1) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        };
        var compact = /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        };
        var concat = /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        };
        var drop = /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        };
        var dropRight = /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        };
        var dropRightWhile = /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        };
        var dropWhile = /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        };
        var fill = /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        };
        var findIndex = /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        };
        var findLastIndex = /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        };
        var flatten = /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        };
        var flattenDeep = /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        };
        var flattenDepth = /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        };
        var fromPairs = /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        };
        var head = /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined1;
        };
        var indexOf = /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        };
        var initial = /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        };
        var join = /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        };
        var last = /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined1;
        };
        var lastIndexOf = /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        };
        var nth = /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined1;
        };
        var pullAll = /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        };
        var pullAllBy = /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        };
        var pullAllWith = /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined1, comparator) : array;
        };
        var remove = /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        };
        var reverse = /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        };
        var slice = /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined1 ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        };
        var sortedIndex = /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        };
        var sortedIndexBy = /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        };
        var sortedIndexOf = /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        };
        var sortedLastIndex = /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        };
        var sortedLastIndexBy = /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        };
        var sortedLastIndexOf = /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        };
        var sortedUniq = /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        };
        var sortedUniqBy = /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        };
        var tail = /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        };
        var take = /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        };
        var takeRight = /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        };
        var takeRightWhile = /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        };
        var takeWhile = /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        };
        var uniq = /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        };
        var uniqBy = /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        };
        var uniqWith = /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return array && array.length ? baseUniq(array, undefined1, comparator) : [];
        };
        var unzip = /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        };
        var unzipWith = /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined1, group);
            });
        };
        var zipObject = /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        };
        var zipObjectDeep = /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        };
        var chain = /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        };
        var tap = /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        };
        var thru = /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        };
        var wrapperChain = /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        };
        var wrapperCommit = /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        };
        var wrapperNext = /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined1) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined1 : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        };
        var wrapperToIterator = /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        };
        var wrapperPlant = /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined1;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        };
        var wrapperReverse = /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined1
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        };
        var wrapperValue = /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        };
        var every = /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        };
        var filter = /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        };
        var flatMap = /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        };
        var flatMapDeep = /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        };
        var flatMapDepth = /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        };
        var forEach = /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        };
        var forEachRight = /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        };
        var includes = /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        };
        var map = /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        };
        var orderBy = /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined1 : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        };
        var reduce = /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        };
        var reduceRight = /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        };
        var reject = /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        };
        var sample = /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        };
        var sampleSize = /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        };
        var shuffle = /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        };
        var size = /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        };
        var some = /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        };
        var after = /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        };
        var ary = /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined1 : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined1, undefined1, undefined1, undefined1, n);
        };
        var before = /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined1;
                return result;
            };
        };
        var debounce = /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined1;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined1;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined1;
                return result;
            }
            function cancel() {
                if (timerId !== undefined1) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined1;
            }
            function flush() {
                return timerId === undefined1 ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined1) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined1) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        };
        var flip = /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        };
        var negate = /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        };
        var once = /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        };
        var rest = /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined1 ? start : toInteger(start);
            return baseRest(func, start);
        };
        var spread = /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        };
        var throttle = /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        };
        var unary = /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        };
        var wrap = /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        };
        var castArray = /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        };
        var clone = /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        };
        var cloneWith = /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        };
        var cloneDeep = /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        };
        var cloneDeepWith = /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        };
        var conformsTo = /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        };
        var eq = /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        };
        var isArrayLike = /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        };
        var isArrayLikeObject = /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        };
        var isBoolean = /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        };
        var isElement = /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        };
        var isEmpty = /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        };
        var isEqual = /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        };
        var isEqualWith = /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            var result = customizer ? customizer(value, other) : undefined1;
            return result === undefined1 ? baseIsEqual(value, other, undefined1, customizer) : !!result;
        };
        var isError = /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        };
        var isFinite = /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        };
        var isFunction = /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        };
        var isInteger = /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        };
        var isLength = /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        };
        var isObject = /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value);
            return value != null && (type == "object" || type == "function");
        };
        var isObjectLike = /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        };
        var isMatch = /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        };
        var isMatchWith = /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        };
        var isNaN = /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        };
        var isNative = /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        };
        var isNull = /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        };
        var isNil = /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        };
        var isNumber = /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        };
        var isPlainObject = /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        };
        var isSafeInteger = /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        };
        var isString = /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        };
        var isSymbol = /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return (typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value)) == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        };
        var isUndefined = /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined1;
        };
        var isWeakMap = /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        };
        var isWeakSet = /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        };
        var toArray = /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        };
        var toFinite = /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        };
        var toInteger = /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        };
        var toLength = /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        };
        var toNumber = /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        };
        var toPlainObject = /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        };
        var toSafeInteger = /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        };
        var toString = /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        };
        var create = /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        };
        var findKey = /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        };
        var findLastKey = /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        };
        var forIn = /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        };
        var forInRight = /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        };
        var forOwn = /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        };
        var forOwnRight = /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        };
        var functions = /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        };
        var functionsIn = /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        };
        var get = /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined1 : baseGet(object, path);
            return result === undefined1 ? defaultValue : result;
        };
        var has = /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        };
        var hasIn = /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        };
        var keys = /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        };
        var keysIn = /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        };
        var mapKeys = /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        };
        var mapValues = /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        };
        var omitBy = /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        };
        var pickBy = /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        };
        var result = /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined1;
            }
            while(++index < length){
                var value = object == null ? undefined1 : object[toKey(path[index])];
                if (value === undefined1) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        };
        var set = /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        };
        var setWith = /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return object == null ? object : baseSet(object, path, value, customizer);
        };
        var transform = /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        };
        var unset = /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        };
        var update = /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        };
        var updateWith = /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        };
        var values = /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        };
        var valuesIn = /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        };
        var clamp = /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined1) {
                upper = lower;
                lower = undefined1;
            }
            if (upper !== undefined1) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined1) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        };
        var inRange = /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined1) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        };
        var random = /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined1;
            if (floating === undefined1) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined1;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined1;
                }
            }
            if (lower === undefined1 && upper === undefined1) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined1) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        };
        var capitalize = /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        };
        var deburr = /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        };
        var endsWith = /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined1 ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        };
        var escape = /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        };
        var escapeRegExp = /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        };
        var pad = /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        };
        var padEnd = /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        };
        var padStart = /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        };
        var _$parseInt = /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function _$parseInt(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        };
        var repeat = /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        };
        var replace = /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        };
        var split = /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined1;
            limit = limit === undefined1 ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        };
        var startsWith = /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        };
        var template = /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined1;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = _$RegExp((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return _$Function(importsKeys, sourceURL + "return " + source).apply(undefined1, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        };
        var toLower = /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        };
        var toUpper = /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        };
        var trim = /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        };
        var trimEnd = /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        };
        var trimStart = /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        };
        var truncate = /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined1) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = _$RegExp(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined1 ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        };
        var unescape = /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        };
        var words = /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined1 : pattern;
            if (pattern === undefined1) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        };
        var cond = /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        };
        var conforms = /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        };
        var constant = /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        };
        var defaultTo = /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        };
        var identity = /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        };
        var iteratee = /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        };
        var matches = /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        };
        var matchesProperty = /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        };
        var mixin = /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        };
        var noConflict = /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        };
        var noop = /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        };
        var nthArg = /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        };
        var property = /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        };
        var propertyOf = /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined1 : baseGet(object, path);
            };
        };
        var stubArray = /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        };
        var stubFalse = /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        };
        var stubObject = /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        };
        var stubString = /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        };
        var stubTrue = /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        };
        var times = /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        };
        var toPath = /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        };
        var uniqueId = /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        };
        var max = /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined1;
        };
        var maxBy = /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined1;
        };
        var mean = /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        };
        var meanBy = /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        };
        var min = /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined1;
        };
        var minBy = /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined1;
        };
        var sum = /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        };
        var sumBy = /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        };
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, _$Function = context.Function, Math = context.Math, _$Object = context.Object, _$RegExp = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = _$Function.prototype, objectProto = _$Object.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(_$Object);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = _$RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined1, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined1, getPrototype = overArg(_$Object.getPrototypeOf, _$Object), objectCreate = _$Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined1, symIterator = Symbol ? Symbol.iterator : undefined1, symToStringTag = Symbol ? Symbol.toStringTag : undefined1;
        var defineProperty = function() {
            try {
                var func = getNative(_$Object, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = _$Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(_$Object.keys, _$Object), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(_$Object, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined1, symbolToString = symbolProto ? symbolProto.toString : undefined1;
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            var object = function object() {};
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined1;
                return result;
            };
        }();
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined1) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined1 : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined1;
                    if (newValue === undefined1) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function baseSetData(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function baseSetToString(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined1 : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function createSet(values) {
            return new Set(values);
        };
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined1, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function getData(func) {
            return metaMap.get(func);
        };
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function getSymbols(object) {
            if (object == null) return [];
            object = _$Object(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function getSymbolsIn(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined1, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined1, comparator) : [];
        });
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined1;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined1, comparator) : [];
        });
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined1, comparator);
        });
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined1, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined1;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined1;
            return unzipWith(arrays, iteratee);
        });
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function interceptor(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined1
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined1);
                return array;
            });
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function memoized1() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined1, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined1, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined1, undefined1, undefined1, indexes);
        });
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function isArguments(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = _$Object(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined1;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined1, customDefaultsMerge);
            return apply(mergeWith, undefined1, args);
        });
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined1, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = _$parseInt;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined1 ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined1) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function interceptor(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined1
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined1, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined1
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(undefined);

});

parcelRequire.register("dsDoQ", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $9ccc73df0df154d7$require$Buffer = $gzLuY.Buffer;
"use strict";
var $9ccc73df0df154d7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9ccc73df0df154d7$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};
var $9ccc73df0df154d7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9ccc73df0df154d7$var$arweave_multihost_1 = $9ccc73df0df154d7$var$__importDefault((parcelRequire("7jrQ0")));

var $9ccc73df0df154d7$var$arweave_1 = $9ccc73df0df154d7$var$__importDefault((parcelRequire("arqgF")));

var $6BxW3 = parcelRequire("6BxW3");

var $9ccc73df0df154d7$var$pako_1 = $9ccc73df0df154d7$var$__importDefault((parcelRequire("kGJ2Q")));

var $9ccc73df0df154d7$var$config_1 = $9ccc73df0df154d7$var$__importDefault((parcelRequire("1hVk2")));
// TODO: revert LAST_BLOCKS_TO_CHECK to 50
var $9ccc73df0df154d7$var$LAST_BLOCKS_TO_CHECK = 5000;
var $9ccc73df0df154d7$var$ArweaveProxy = /** @class */ function() {
    var ArweaveProxy = function ArweaveProxy() {
        this.arweaveClient = $9ccc73df0df154d7$var$arweave_multihost_1.default.initWithDefaultHosts({
            timeout: 10000,
            logging: false
        });
    };
    ArweaveProxy.prototype.findPricesInGraphQL = function(parameters) {
        return $9ccc73df0df154d7$var$__awaiter(this, void 0, void 0, function() {
            var networkInfo, minBlock, query, res, node, tags, _i, _a, _b, name_1, value;
            return $9ccc73df0df154d7$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.arweaveClient.network.getInfo()
                        ];
                    case 1:
                        networkInfo = _c.sent();
                        minBlock = networkInfo.height - $9ccc73df0df154d7$var$LAST_BLOCKS_TO_CHECK;
                        query = '\n        {\n          transactions(\n            tags: [\n              { name: "app", values: "Redstone" }\n              { name: "type", values: "' + parameters.type + '" }\n              { name: "version", values: "' + parameters.version + '" }\n            ]\n            block: { min: ' + minBlock + ' }\n            owners: ["' + parameters.providerAddress + '"]\n            first: 1\n          ) {\n            edges {\n              node {\n                tags {\n                  name\n                  value\n                }\n                id\n              }\n            }\n          }\n        }';
                        return [
                            4 /*yield*/ ,
                            $6BxW3.run(query)
                        ];
                    case 2:
                        res = _c.sent().data.transactions.edges;
                        if (res.length > 0) {
                            node = res[0].node;
                            tags = {};
                            for(_i = 0, _a = node.tags; _i < _a.length; _i++){
                                _b = _a[_i], name_1 = _b.name, value = _b.value;
                                tags[name_1] = value;
                            }
                            return [
                                2 /*return*/ ,
                                {
                                    permawebTx: node.id,
                                    tags: tags
                                }
                            ];
                        } else return [
                            2 /*return*/ ,
                            undefined
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ArweaveProxy.prototype.getTxDataById = function(txId, opts) {
        return $9ccc73df0df154d7$var$__awaiter(this, void 0, void 0, function() {
            var data, gunzippedData, strData;
            return $9ccc73df0df154d7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.arweaveClient.transactions.getData(txId, {
                                decode: true
                            })
                        ];
                    case 1:
                        data = _a.sent();
                        gunzippedData = $9ccc73df0df154d7$var$pako_1.default.ungzip($9ccc73df0df154d7$require$Buffer.from(data));
                        strData = $9ccc73df0df154d7$var$arweave_1.default.utils.bufferToString(gunzippedData);
                        if (opts !== undefined && opts.parseJSON) return [
                            2 /*return*/ ,
                            JSON.parse(strData)
                        ];
                        else return [
                            2 /*return*/ ,
                            strData
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ArweaveProxy.prototype.getProviderDetails = function(providerName) {
        return $9ccc73df0df154d7$var$__awaiter(this, void 0, void 0, function() {
            var mapping;
            return $9ccc73df0df154d7$var$__generator(this, function(_a) {
                mapping = $9ccc73df0df154d7$var$config_1.default.providers;
                if (mapping[providerName] === undefined) throw new Error("Provider details not found: " + providerName);
                else return [
                    2 /*return*/ ,
                    mapping[providerName]
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    ArweaveProxy.prototype.verifySignature = function(args) {
        return $9ccc73df0df154d7$var$__awaiter(this, void 0, void 0, function() {
            var signedBytes, signatureBytes;
            return $9ccc73df0df154d7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        signedBytes = new TextEncoder().encode(args.signedData);
                        signatureBytes = Uint8Array.from($9ccc73df0df154d7$require$Buffer.from(args.signature, "base64"));
                        return [
                            4 /*yield*/ ,
                            this.arweaveClient.crypto.verify(args.signerPublicKey, signedBytes, signatureBytes)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return ArweaveProxy;
}();
module.exports.default = $9ccc73df0df154d7$var$ArweaveProxy;

});
parcelRequire.register("gzLuY", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $c114c26e12685207$export$a143d493d941bafc; }, function (v) { return $c114c26e12685207$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $c114c26e12685207$export$f99ded8fe4b79145; }, function (v) { return $c114c26e12685207$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $1ObTH = parcelRequire("1ObTH");
var $c114c26e12685207$export$a143d493d941bafc;
var $c114c26e12685207$export$e4cf37d7f6fb9e0a;
var $c114c26e12685207$export$f99ded8fe4b79145;
var $c114c26e12685207$export$599f31c3813fae4d;
"use strict";

var $7LFKz = parcelRequire("7LFKz");

var $69U7b = parcelRequire("69U7b");
var $c114c26e12685207$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$c114c26e12685207$export$a143d493d941bafc = $c114c26e12685207$var$Buffer;
$c114c26e12685207$export$e4cf37d7f6fb9e0a = $c114c26e12685207$var$SlowBuffer;
$c114c26e12685207$export$f99ded8fe4b79145 = 50;
var $c114c26e12685207$var$K_MAX_LENGTH = 0x7fffffff;
$c114c26e12685207$export$599f31c3813fae4d = $c114c26e12685207$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT = $c114c26e12685207$var$typedArraySupport();
if (!$c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c114c26e12685207$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function get() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function get() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c114c26e12685207$var$createBuffer(length) {
    if (length > $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c114c26e12685207$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c114c26e12685207$var$allocUnsafe(arg);
    }
    return $c114c26e12685207$var$from(arg, encodingOrOffset, length);
}
$c114c26e12685207$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c114c26e12685207$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $c114c26e12685207$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c114c26e12685207$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value)));
    if ($c114c26e12685207$var$isInstance(value, ArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, ArrayBuffer)) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($c114c26e12685207$var$isInstance(value, SharedArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, SharedArrayBuffer))) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c114c26e12685207$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $c114c26e12685207$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $c114c26e12685207$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c114c26e12685207$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c114c26e12685207$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c114c26e12685207$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c114c26e12685207$var$Buffer, Uint8Array);
function $c114c26e12685207$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c114c26e12685207$var$alloc(size, fill, encoding) {
    $c114c26e12685207$var$assertSize(size);
    if (size <= 0) return $c114c26e12685207$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $c114c26e12685207$var$createBuffer(size).fill(fill, encoding) : $c114c26e12685207$var$createBuffer(size).fill(fill);
    return $c114c26e12685207$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c114c26e12685207$var$Buffer.alloc = function(size, fill, encoding) {
    return $c114c26e12685207$var$alloc(size, fill, encoding);
};
function $c114c26e12685207$var$allocUnsafe(size) {
    $c114c26e12685207$var$assertSize(size);
    return $c114c26e12685207$var$createBuffer(size < 0 ? 0 : $c114c26e12685207$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c114c26e12685207$var$Buffer.allocUnsafe = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c114c26e12685207$var$Buffer.allocUnsafeSlow = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
function $c114c26e12685207$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $c114c26e12685207$var$byteLength(string, encoding) | 0;
    var buf = $c114c26e12685207$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c114c26e12685207$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $c114c26e12685207$var$checked(array.length) | 0;
    var buf = $c114c26e12685207$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c114c26e12685207$var$fromArrayView(arrayView) {
    if ($c114c26e12685207$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $c114c26e12685207$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c114c26e12685207$var$fromArrayLike(arrayView);
}
function $c114c26e12685207$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
function $c114c26e12685207$var$fromObject(obj) {
    if ($c114c26e12685207$var$Buffer.isBuffer(obj)) {
        var len = $c114c26e12685207$var$checked(obj.length) | 0;
        var buf = $c114c26e12685207$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $c114c26e12685207$var$numberIsNaN(obj.length)) return $c114c26e12685207$var$createBuffer(0);
        return $c114c26e12685207$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $c114c26e12685207$var$fromArrayLike(obj.data);
}
function $c114c26e12685207$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c114c26e12685207$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $c114c26e12685207$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c114c26e12685207$var$Buffer.alloc(+length);
}
$c114c26e12685207$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c114c26e12685207$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c114c26e12685207$var$Buffer.compare = function compare(a, b) {
    if ($c114c26e12685207$var$isInstance(a, Uint8Array)) a = $c114c26e12685207$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c114c26e12685207$var$isInstance(b, Uint8Array)) b = $c114c26e12685207$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(a) || !$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c114c26e12685207$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$c114c26e12685207$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c114c26e12685207$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $c114c26e12685207$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($c114c26e12685207$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $c114c26e12685207$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c114c26e12685207$var$byteLength(string, encoding) {
    if ($c114c26e12685207$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c114c26e12685207$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $1ObTH._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $c114c26e12685207$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c114c26e12685207$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c114c26e12685207$var$Buffer.byteLength = $c114c26e12685207$var$byteLength;
function $c114c26e12685207$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $c114c26e12685207$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8Slice(this, start, end);
        case "ascii":
            return $c114c26e12685207$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $c114c26e12685207$var$latin1Slice(this, start, end);
        case "base64":
            return $c114c26e12685207$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c114c26e12685207$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c114c26e12685207$var$Buffer.prototype._isBuffer = true;
function $c114c26e12685207$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c114c26e12685207$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$c114c26e12685207$var$swap(this, i, i + 1);
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $c114c26e12685207$var$swap(this, i, i + 3);
        $c114c26e12685207$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $c114c26e12685207$var$swap(this, i, i + 7);
        $c114c26e12685207$var$swap(this, i + 1, i + 6);
        $c114c26e12685207$var$swap(this, i + 2, i + 5);
        $c114c26e12685207$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $c114c26e12685207$var$utf8Slice(this, 0, length);
    return $c114c26e12685207$var$slowToString.apply(this, arguments);
};
$c114c26e12685207$var$Buffer.prototype.toLocaleString = $c114c26e12685207$var$Buffer.prototype.toString;
$c114c26e12685207$var$Buffer.prototype.equals = function equals(b) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $c114c26e12685207$var$Buffer.compare(this, b) === 0;
};
$c114c26e12685207$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $c114c26e12685207$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($c114c26e12685207$var$customInspectSymbol) $c114c26e12685207$var$Buffer.prototype[$c114c26e12685207$var$customInspectSymbol] = $c114c26e12685207$var$Buffer.prototype.inspect;
$c114c26e12685207$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c114c26e12685207$var$isInstance(target, Uint8Array)) target = $c114c26e12685207$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $1ObTH._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c114c26e12685207$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c114c26e12685207$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $c114c26e12685207$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c114c26e12685207$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c114c26e12685207$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c114c26e12685207$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $c114c26e12685207$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var read = function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    };
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c114c26e12685207$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c114c26e12685207$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c114c26e12685207$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c114c26e12685207$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c114c26e12685207$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c114c26e12685207$var$utf8Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c114c26e12685207$var$asciiWrite(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$asciiToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$base64Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$base64ToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$ucs2Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c114c26e12685207$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $c114c26e12685207$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $c114c26e12685207$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $c114c26e12685207$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c114c26e12685207$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c114c26e12685207$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c114c26e12685207$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7LFKz.fromByteArray(buf);
    else return $7LFKz.fromByteArray(buf.slice(start, end));
}
function $c114c26e12685207$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c114c26e12685207$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c114c26e12685207$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c114c26e12685207$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c114c26e12685207$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c114c26e12685207$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $c114c26e12685207$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c114c26e12685207$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c114c26e12685207$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c114c26e12685207$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c114c26e12685207$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$c114c26e12685207$var$Buffer.prototype.readUintLE = $c114c26e12685207$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUintBE = $c114c26e12685207$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUint8 = $c114c26e12685207$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c114c26e12685207$var$Buffer.prototype.readUint16LE = $c114c26e12685207$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c114c26e12685207$var$Buffer.prototype.readUint16BE = $c114c26e12685207$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c114c26e12685207$var$Buffer.prototype.readUint32LE = $c114c26e12685207$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c114c26e12685207$var$Buffer.prototype.readUint32BE = $c114c26e12685207$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c114c26e12685207$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c114c26e12685207$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c114c26e12685207$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c114c26e12685207$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $69U7b.read(this, offset, true, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $69U7b.read(this, offset, false, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $69U7b.read(this, offset, true, 52, 8);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $69U7b.read(this, offset, false, 52, 8);
};
function $c114c26e12685207$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$c114c26e12685207$var$Buffer.prototype.writeUintLE = $c114c26e12685207$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUintBE = $c114c26e12685207$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUint8 = $c114c26e12685207$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16LE = $c114c26e12685207$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16BE = $c114c26e12685207$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32LE = $c114c26e12685207$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32BE = $c114c26e12685207$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c114c26e12685207$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $c114c26e12685207$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $69U7b.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c114c26e12685207$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, false, noAssert);
};
function $c114c26e12685207$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $69U7b.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c114c26e12685207$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c114c26e12685207$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $c114c26e12685207$var$Buffer.isBuffer(val) ? val : $c114c26e12685207$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $c114c26e12685207$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c114c26e12685207$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c114c26e12685207$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $c114c26e12685207$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $c114c26e12685207$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c114c26e12685207$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c114c26e12685207$var$base64ToBytes(str) {
    return $7LFKz.toByteArray($c114c26e12685207$var$base64clean(str));
}
function $c114c26e12685207$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c114c26e12685207$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c114c26e12685207$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $c114c26e12685207$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRequire.register("7LFKz", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $5a7d4ee62d502cb1$export$d622b2ad8d90c771; }, function (v) { return $5a7d4ee62d502cb1$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $5a7d4ee62d502cb1$export$6100ba28696e12de; }, function (v) { return $5a7d4ee62d502cb1$export$6100ba28696e12de = v; });
var $5a7d4ee62d502cb1$export$a48f0734ac7c2329;
var $5a7d4ee62d502cb1$export$d622b2ad8d90c771;
var $5a7d4ee62d502cb1$export$6100ba28696e12de;
"use strict";
$5a7d4ee62d502cb1$export$a48f0734ac7c2329 = $5a7d4ee62d502cb1$var$byteLength;
$5a7d4ee62d502cb1$export$d622b2ad8d90c771 = $5a7d4ee62d502cb1$var$toByteArray;
$5a7d4ee62d502cb1$export$6100ba28696e12de = $5a7d4ee62d502cb1$var$fromByteArray;
var $5a7d4ee62d502cb1$var$lookup = [];
var $5a7d4ee62d502cb1$var$revLookup = [];
var $5a7d4ee62d502cb1$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $5a7d4ee62d502cb1$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $5a7d4ee62d502cb1$var$i = 0, $5a7d4ee62d502cb1$var$len = $5a7d4ee62d502cb1$var$code.length; $5a7d4ee62d502cb1$var$i < $5a7d4ee62d502cb1$var$len; ++$5a7d4ee62d502cb1$var$i){
    $5a7d4ee62d502cb1$var$lookup[$5a7d4ee62d502cb1$var$i] = $5a7d4ee62d502cb1$var$code[$5a7d4ee62d502cb1$var$i];
    $5a7d4ee62d502cb1$var$revLookup[$5a7d4ee62d502cb1$var$code.charCodeAt($5a7d4ee62d502cb1$var$i)] = $5a7d4ee62d502cb1$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5a7d4ee62d502cb1$var$revLookup["-".charCodeAt(0)] = 62;
$5a7d4ee62d502cb1$var$revLookup["_".charCodeAt(0)] = 63;
function $5a7d4ee62d502cb1$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5a7d4ee62d502cb1$var$byteLength(b64) {
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$toByteArray(b64) {
    var tmp;
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5a7d4ee62d502cb1$var$Arr($5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 18 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 2 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 10 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5a7d4ee62d502cb1$var$tripletToBase64(num) {
    return $5a7d4ee62d502cb1$var$lookup[num >> 18 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 12 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 6 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num & 0x3F];
}
function $5a7d4ee62d502cb1$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5a7d4ee62d502cb1$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $5a7d4ee62d502cb1$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5a7d4ee62d502cb1$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 2] + $5a7d4ee62d502cb1$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 10] + $5a7d4ee62d502cb1$var$lookup[tmp >> 4 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("69U7b", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942; }, function (v) { return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $47bf1c92b6d3ec4f$export$68d8715fc104d294; }, function (v) { return $47bf1c92b6d3ec4f$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $47bf1c92b6d3ec4f$export$aafa59e2e03f2942;
var $47bf1c92b6d3ec4f$export$68d8715fc104d294;
$47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$47bf1c92b6d3ec4f$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("7jrQ0", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $552fe6c79202b394$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};

var $552fe6c79202b394$var$arweave_1 = $552fe6c79202b394$var$__importDefault((parcelRequire("arqgF")));
var $552fe6c79202b394$var$DEFAULT_HOSTS = [
    {
        host: "arweave.net",
        protocol: "https",
        port: 443
    },
    {
        host: "gateway.amplify.host",
        protocol: "https",
        port: 443
    },
    {
        host: "arweave.dev",
        protocol: "https",
        port: 443
    }
];
var $552fe6c79202b394$var$defaultArweaveConfig = {
    timeout: 10000,
    logging: false,
    onError: console.error
};
/**
   * Returns overrriden arweave instance
   * @param hosts - Array of hosts
   * @param config - Other configuration options
   * (timeout, logging, logger, onError callback)
   * @returns arweave instance
   */ function $552fe6c79202b394$var$init(hosts) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $552fe6c79202b394$var$defaultArweaveConfig;
    var updateHostParams = function updateHostParams(hostConfig) {
        arweave.api.config.host = hostConfig.host;
        arweave.api.config.port = hostConfig.port;
        arweave.api.config.protocol = hostConfig.protocol;
    };
    var switchHost = function switchHost() {
        var oldHost = getCurrentHost();
        currentHostIndex = (currentHostIndex + 1) % hosts.length;
        var newHost = hosts[currentHostIndex];
        if (config.logging && config.logger !== undefined) config.logger("Request failed. Switching host and retrying. " + "Old host: ".concat(JSON.stringify(oldHost), ". ") + "New host: ".concat(JSON.stringify(newHost), "."));
        updateHostParams(newHost);
    };
    var getCurrentHost = function getCurrentHost() {
        return hosts[currentHostIndex];
    };
    var isHostActive = function isHostActive(host) {
        var currentHost = getCurrentHost();
        return JSON.stringify(host) === JSON.stringify(currentHost);
    };
    if (hosts.length === 0) throw new Error("Multihost config should have at least one host");
    var arweave = $552fe6c79202b394$var$arweave_1.default.init(Object.assign(Object.assign({}, hosts[0]), config));
    var currentHostIndex = 0, lastFailedHost = 0;
    var originalApiRequestMethods = {
        get: arweave.api.get.bind(arweave.api),
        post: arweave.api.post.bind(arweave.api)
    };
    function overridenRequestMethod(sendOriginalRequest) {
        return _overridenRequestMethod.apply(this, arguments);
    }
    function _overridenRequestMethod() {
        _overridenRequestMethod = (0, $byzP8._)(function(sendOriginalRequest) {
            var i, hostUsedForRequest, response, err;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i < hosts.length)) return [
                            3,
                            6
                        ];
                        hostUsedForRequest = getCurrentHost();
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            sendOriginalRequest()
                        ];
                    case 3:
                        response = _state.sent();
                        if (response.status >= 500 && response.status < 600) throw new Error("Error while sending http request: " + "Status: ".concat(response.status, ". ") + "Data: ".concat(JSON.stringify(response.data)));
                        return [
                            2,
                            response
                        ];
                    case 4:
                        err = _state.sent();
                        // config.onError callback may be used for error logging
                        if (config.onError) config.onError(err);
                        if (i === hosts.length - 1) throw err;
                        else // We switch host only if it's still active.
                        // If it's not active it means that it was switched by
                        // another concurrent request
                        if (isHostActive(hostUsedForRequest)) switchHost();
                        return [
                            3,
                            5
                        ];
                    case 5:
                        i++;
                        return [
                            3,
                            1
                        ];
                    case 6:
                        throw new Error("Should never reach this");
                }
            });
        });
        return _overridenRequestMethod.apply(this, arguments);
    }
    arweave.api.get = function() {
        var _ref = (0, $byzP8._)(function(endpoint, axiosConfig) {
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            overridenRequestMethod(function() {
                                return originalApiRequestMethods.get(endpoint, axiosConfig);
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(endpoint, axiosConfig) {
            return _ref.apply(this, arguments);
        };
    }();
    arweave.api.post = function() {
        var _ref = (0, $byzP8._)(function(endpoint, body, axiosConfig) {
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            overridenRequestMethod(function() {
                                return originalApiRequestMethods.post(endpoint, body, axiosConfig);
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(endpoint, body, axiosConfig) {
            return _ref.apply(this, arguments);
        };
    }();
    return arweave;
}
/**
   * Returns overrriden arweave instance with default hosts
   * (arweave.net, gateway.amplify.host, arweave.dev)
   * @param config - Other configuration options
   * (timeout, logging, logger, onError callback)
   * @returns arweave instance
   */ function $552fe6c79202b394$var$initWithDefaultHosts(config) {
    return $552fe6c79202b394$var$init($552fe6c79202b394$var$DEFAULT_HOSTS, config);
}
module.exports = {
    init: $552fe6c79202b394$var$init,
    initWithDefaultHosts: $552fe6c79202b394$var$initWithDefaultHosts
};

});
parcelRequire.register("byzP8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $869ea882f885334a$export$7c398597f8905a1; });
function $869ea882f885334a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $869ea882f885334a$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $869ea882f885334a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $869ea882f885334a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRequire.register("7UAGh", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $5c2a37736a53c5f6$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__generator", function () { return $5c2a37736a53c5f6$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $5c2a37736a53c5f6$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $1ObTH = parcelRequire("1ObTH");
var $5c2a37736a53c5f6$var$extendStatics = function extendStatics1(d, b) {
    $5c2a37736a53c5f6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c2a37736a53c5f6$var$extendStatics(d, b);
};
function $5c2a37736a53c5f6$export$a8ba968b8961cb8a(d, b) {
    var __ = function __() {
        this.constructor = d;
    };
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c2a37736a53c5f6$var$extendStatics(d, b);
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c2a37736a53c5f6$export$18ce0697a983be9b = function __assign1() {
    $5c2a37736a53c5f6$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c2a37736a53c5f6$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c2a37736a53c5f6$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c2a37736a53c5f6$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c2a37736a53c5f6$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c2a37736a53c5f6$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    var accept = function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    };
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c2a37736a53c5f6$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c2a37736a53c5f6$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $1ObTH._)(x)) === "symbol" ? x : "".concat(x);
}
function $5c2a37736a53c5f6$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $1ObTH._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c2a37736a53c5f6$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c2a37736a53c5f6$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c2a37736a53c5f6$export$67ebef60e6f28a6(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
}
var $5c2a37736a53c5f6$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c2a37736a53c5f6$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c2a37736a53c5f6$export$45d3717a4c69092e(o, m, p);
}
function $5c2a37736a53c5f6$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c2a37736a53c5f6$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c2a37736a53c5f6$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c2a37736a53c5f6$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c2a37736a53c5f6$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c2a37736a53c5f6$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c2a37736a53c5f6$export$10c90e4f7922046c(v) {
    return this instanceof $5c2a37736a53c5f6$export$10c90e4f7922046c ? (this.v = v, this) : new $5c2a37736a53c5f6$export$10c90e4f7922046c(v);
}
function $5c2a37736a53c5f6$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    var verb = function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    };
    var resume = function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    };
    var step = function step(r) {
        r.value instanceof $5c2a37736a53c5f6$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    };
    var fulfill = function fulfill(value) {
        resume("next", value);
    };
    var reject = function reject(value) {
        resume("throw", value);
    };
    var settle = function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
}
function $5c2a37736a53c5f6$export$bbd80228419bb833(o) {
    var verb = function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c2a37736a53c5f6$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    };
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
}
function $5c2a37736a53c5f6$export$e3b29a3d6162315f(o) {
    var verb = function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    };
    var settle = function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c2a37736a53c5f6$export$19a8beecd37a4c45 === "function" ? $5c2a37736a53c5f6$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
}
function $5c2a37736a53c5f6$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c2a37736a53c5f6$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c2a37736a53c5f6$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c2a37736a53c5f6$export$45d3717a4c69092e(result, mod, k);
    }
    $5c2a37736a53c5f6$var$__setModuleDefault(result, mod);
    return result;
}
function $5c2a37736a53c5f6$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c2a37736a53c5f6$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c2a37736a53c5f6$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c2a37736a53c5f6$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c2a37736a53c5f6$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c2a37736a53c5f6$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c2a37736a53c5f6$export$8f076105dc360e92(env) {
    var fail = function fail(e) {
        env.error = env.hasError ? new $5c2a37736a53c5f6$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    };
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c2a37736a53c5f6$export$2e2bcd8739ae039 = {
    __extends: $5c2a37736a53c5f6$export$a8ba968b8961cb8a,
    __assign: $5c2a37736a53c5f6$export$18ce0697a983be9b,
    __rest: $5c2a37736a53c5f6$export$3c9a16f847548506,
    __decorate: $5c2a37736a53c5f6$export$29e00dfd3077644b,
    __param: $5c2a37736a53c5f6$export$d5ad3fd78186038f,
    __metadata: $5c2a37736a53c5f6$export$f1db080c865becb9,
    __awaiter: $5c2a37736a53c5f6$export$1050f835b63b671e,
    __generator: $5c2a37736a53c5f6$export$67ebef60e6f28a6,
    __createBinding: $5c2a37736a53c5f6$export$45d3717a4c69092e,
    __exportStar: $5c2a37736a53c5f6$export$f33643c0debef087,
    __values: $5c2a37736a53c5f6$export$19a8beecd37a4c45,
    __read: $5c2a37736a53c5f6$export$8d051b38c9118094,
    __spread: $5c2a37736a53c5f6$export$afc72e2116322959,
    __spreadArrays: $5c2a37736a53c5f6$export$6388937ca91ccae8,
    __spreadArray: $5c2a37736a53c5f6$export$1216008129fb82ed,
    __await: $5c2a37736a53c5f6$export$10c90e4f7922046c,
    __asyncGenerator: $5c2a37736a53c5f6$export$e427f37a30a4de9b,
    __asyncDelegator: $5c2a37736a53c5f6$export$bbd80228419bb833,
    __asyncValues: $5c2a37736a53c5f6$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c2a37736a53c5f6$export$4fb47efe1390b86f,
    __importStar: $5c2a37736a53c5f6$export$c21735bcef00d192,
    __importDefault: $5c2a37736a53c5f6$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c2a37736a53c5f6$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c2a37736a53c5f6$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c2a37736a53c5f6$export$81fdc39f203e4e04,
    __addDisposableResource: $5c2a37736a53c5f6$export$88ac25d8e944e405,
    __disposeResources: $5c2a37736a53c5f6$export$8f076105dc360e92
};

});

parcelRequire.register("arqgF", function(module, exports) {

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");
"use strict";
var $79a0cd438e42a0d9$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $79a0cd438e42a0d9$var$__exportStar = undefined && undefined.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $79a0cd438e42a0d9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});


var $1R9a4 = parcelRequire("1R9a4");
(parcelRequire("aIAvL")).default.init = function() {
    var apiConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var defaults = {
        host: "arweave.net",
        port: 443,
        protocol: "https"
    };
    if (typeof location !== "object" || !location.protocol || !location.hostname) return new (parcelRequire("aIAvL")).default((0, $8OnJk._)({}, apiConfig, defaults));
    // window.location.protocol has a trailing colon (http:, https:, file: etc)
    var locationProtocol = location.protocol.replace(":", "");
    var locationHost = location.hostname;
    var locationPort = location.port ? parseInt(location.port) : locationProtocol == "https" ? 443 : 80;
    var defaultConfig = (0, $1R9a4.getDefaultConfig)(locationProtocol, locationHost);
    var protocol = apiConfig.protocol || defaultConfig.protocol;
    var host = apiConfig.host || defaultConfig.host;
    var port = apiConfig.port || defaultConfig.port || locationPort;
    return new (parcelRequire("aIAvL")).default((0, $8E768._)((0, $8OnJk._)({}, apiConfig), {
        host: host,
        protocol: protocol,
        port: port
    }));
};
if (typeof globalThis === "object") globalThis.Arweave = (parcelRequire("aIAvL")).default;
else if (typeof self === "object") self.Arweave = (parcelRequire("aIAvL")).default;

$79a0cd438e42a0d9$var$__exportStar((parcelRequire("aIAvL")), module.exports);
module.exports.default = (parcelRequire("aIAvL")).default;

});
parcelRequire.register("8OnJk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $66a5668b38a29be4$export$581ff339ea0ba762; });

var $dxWQo = parcelRequire("dxWQo");
function $66a5668b38a29be4$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $dxWQo._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRequire.register("dxWQo", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $9dcc00a39e7f7954$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $9dcc00a39e7f7954$export$1e71eb4bef00f6b0; });
function $9dcc00a39e7f7954$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRequire.register("8E768", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $64b790ae24ac5be1$export$4fa2f4023c9cbda5; });
function $64b790ae24ac5be1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $64b790ae24ac5be1$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $64b790ae24ac5be1$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRequire.register("aIAvL", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3UwyO = parcelRequire("3UwyO");

var $dBEbD = parcelRequire("dBEbD");

var $hvOUF = parcelRequire("hvOUF");

var $5xI54 = parcelRequire("5xI54");

var $5JpNe = parcelRequire("5JpNe");

var $7fv7J = parcelRequire("7fv7J");

var $ap7ys = parcelRequire("ap7ys");

var $dsrYt = parcelRequire("dsrYt");

var $lVA0N = parcelRequire("lVA0N");

var $jJfLo = parcelRequire("jJfLo");

var $3E2mQ = parcelRequire("3E2mQ");
var $7cda55d8afb88cd1$var$Arweave = /*#__PURE__*/ function() {
    function Arweave(apiConfig) {
        (0, $978gY._)(this, Arweave);
        (0, $dxWQo._)(this, "api", void 0);
        (0, $dxWQo._)(this, "wallets", void 0);
        (0, $dxWQo._)(this, "transactions", void 0);
        (0, $dxWQo._)(this, "network", void 0);
        (0, $dxWQo._)(this, "blocks", void 0);
        (0, $dxWQo._)(this, "ar", void 0);
        (0, $dxWQo._)(this, "silo", void 0);
        (0, $dxWQo._)(this, "chunks", void 0);
        this.api = new $dBEbD.default(apiConfig);
        this.wallets = new $7fv7J.default(this.api, Arweave.crypto);
        this.chunks = new $jJfLo.default(this.api);
        this.transactions = new $5JpNe.default(this.api, Arweave.crypto, this.chunks);
        this.silo = new $lVA0N.default(this.api, this.crypto, this.transactions);
        this.network = new $5xI54.default(this.api);
        this.blocks = new $3E2mQ.default(this.api, this.network);
        this.ar = new $3UwyO.default();
    }
    (0, $kry2a._)(Arweave, [
        {
            key: "crypto",
            get: /** @deprecated */ function get() {
                return Arweave.crypto;
            }
        },
        {
            key: "utils",
            get: /** @deprecated */ function get() {
                return Arweave.utils;
            }
        },
        {
            key: "getConfig",
            value: function getConfig() {
                return {
                    api: this.api.getConfig(),
                    crypto: null
                };
            }
        },
        {
            key: "createTransaction",
            value: function createTransaction(attributes, jwk) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var transaction, length, createdTransaction;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                transaction = {};
                                Object.assign(transaction, attributes);
                                if (!attributes.data && !(attributes.target && attributes.quantity)) throw new Error("A new Arweave transaction must have a 'data' value, or 'target' and 'quantity' values.");
                                if (attributes.owner == undefined) {
                                    if (jwk && jwk !== "use_wallet") transaction.owner = jwk.n;
                                }
                                if (!(attributes.last_tx == undefined)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.transactions.getTransactionAnchor()
                                ];
                            case 1:
                                transaction.last_tx = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (typeof attributes.data === "string") attributes.data = $dsrYt.stringToBuffer(attributes.data);
                                if (attributes.data instanceof ArrayBuffer) attributes.data = new Uint8Array(attributes.data);
                                if (attributes.data && !(attributes.data instanceof Uint8Array)) throw new Error("Expected data to be a string, Uint8Array or ArrayBuffer");
                                if (!(attributes.reward == undefined)) return [
                                    3,
                                    4
                                ];
                                length = attributes.data ? attributes.data.byteLength : 0;
                                return [
                                    4,
                                    _this.transactions.getPrice(length, transaction.target)
                                ];
                            case 3:
                                transaction.reward = _state.sent();
                                _state.label = 4;
                            case 4:
                                // here we should call prepare chunk
                                transaction.data_root = "";
                                transaction.data_size = attributes.data ? attributes.data.byteLength.toString() : "0";
                                transaction.data = attributes.data || new Uint8Array(0);
                                createdTransaction = new $ap7ys.default(transaction);
                                return [
                                    4,
                                    createdTransaction.getSignatureData()
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    2,
                                    createdTransaction
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createSiloTransaction",
            value: function createSiloTransaction(attributes, jwk, siloUri) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var transaction, siloResource, encrypted, encrypted1, siloTransaction;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                transaction = {};
                                Object.assign(transaction, attributes);
                                if (!attributes.data) throw new Error("Silo transactions must have a 'data' value");
                                if (!siloUri) throw new Error("No Silo URI specified.");
                                if (attributes.target || attributes.quantity) throw new Error("Silo transactions can only be used for storing data, sending AR to other wallets isn't supported.");
                                if (attributes.owner == undefined) {
                                    if (!jwk || !jwk.n) throw new Error("A new Arweave transaction must either have an 'owner' attribute, or you must provide the jwk parameter.");
                                    transaction.owner = jwk.n;
                                }
                                if (!(attributes.last_tx == undefined)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.transactions.getTransactionAnchor()
                                ];
                            case 1:
                                transaction.last_tx = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _this.silo.parseUri(siloUri)
                                ];
                            case 3:
                                siloResource = _state.sent();
                                if (!(typeof attributes.data == "string")) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    _this.crypto.encrypt($dsrYt.stringToBuffer(attributes.data), siloResource.getEncryptionKey())
                                ];
                            case 4:
                                encrypted = _state.sent();
                                return [
                                    4,
                                    _this.transactions.getPrice(encrypted.byteLength)
                                ];
                            case 5:
                                transaction.reward = _state.sent();
                                transaction.data = $dsrYt.bufferTob64Url(encrypted);
                                _state.label = 6;
                            case 6:
                                if (!(attributes.data instanceof Uint8Array)) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    _this.crypto.encrypt(attributes.data, siloResource.getEncryptionKey())
                                ];
                            case 7:
                                encrypted1 = _state.sent();
                                return [
                                    4,
                                    _this.transactions.getPrice(encrypted1.byteLength)
                                ];
                            case 8:
                                transaction.reward = _state.sent();
                                transaction.data = $dsrYt.bufferTob64Url(encrypted1);
                                _state.label = 9;
                            case 9:
                                siloTransaction = new $ap7ys.default(transaction);
                                siloTransaction.addTag("Silo-Name", siloResource.getAccessKey());
                                siloTransaction.addTag("Silo-Version", "0.1.0");
                                return [
                                    2,
                                    siloTransaction
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "arql",
            value: function arql(query) {
                return this.api.post("/arql", query).then(function(response) {
                    return response.data || [];
                });
            }
        }
    ]);
    return Arweave;
}();
(0, $dxWQo._)($7cda55d8afb88cd1$var$Arweave, "init", void 0);
(0, $dxWQo._)($7cda55d8afb88cd1$var$Arweave, "crypto", new $hvOUF.default());
(0, $dxWQo._)($7cda55d8afb88cd1$var$Arweave, "utils", $dsrYt);
module.exports.default = $7cda55d8afb88cd1$var$Arweave;

});
parcelRequire.register("3UwyO", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ivmGH = parcelRequire("ivmGH");
var $2d8fdbe1d77e4d74$var$Ar = /*#__PURE__*/ function() {
    function Ar() {
        (0, $978gY._)(this, Ar);
        /**
     * Method to take a string value and return a bignumber object.
     *
     * @protected
     * @type {Function}
     * @memberof Arweave
     */ (0, $dxWQo._)(this, "BigNum", void 0);
        // Configure and assign the constructor function for the bignumber library.
        this.BigNum = function(value, decimals) {
            var instance = $ivmGH.BigNumber.clone({
                DECIMAL_PLACES: decimals
            });
            return new instance(value);
        };
    }
    (0, $kry2a._)(Ar, [
        {
            key: "winstonToAr",
            value: function winstonToAr(winstonString) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_formatted = _ref.formatted, formatted = _ref_formatted === void 0 ? false : _ref_formatted, _ref_decimals = _ref.decimals, decimals = _ref_decimals === void 0 ? 12 : _ref_decimals, _ref_trim = _ref.trim, trim = _ref_trim === void 0 ? true : _ref_trim;
                var number = this.stringToBigNum(winstonString, decimals).shiftedBy(-12);
                return formatted ? number.toFormat(decimals) : number.toFixed(decimals);
            }
        },
        {
            key: "arToWinston",
            value: function arToWinston(arString) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_formatted = _ref.formatted, formatted = _ref_formatted === void 0 ? false : _ref_formatted;
                var number = this.stringToBigNum(arString).shiftedBy(12);
                return formatted ? number.toFormat() : number.toFixed(0);
            }
        },
        {
            key: "compare",
            value: function compare(winstonStringA, winstonStringB) {
                var a = this.stringToBigNum(winstonStringA);
                var b = this.stringToBigNum(winstonStringB);
                return a.comparedTo(b);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(winstonStringA, winstonStringB) {
                return this.compare(winstonStringA, winstonStringB) === 0;
            }
        },
        {
            key: "isLessThan",
            value: function isLessThan(winstonStringA, winstonStringB) {
                var a = this.stringToBigNum(winstonStringA);
                var b = this.stringToBigNum(winstonStringB);
                return a.isLessThan(b);
            }
        },
        {
            key: "isGreaterThan",
            value: function isGreaterThan(winstonStringA, winstonStringB) {
                var a = this.stringToBigNum(winstonStringA);
                var b = this.stringToBigNum(winstonStringB);
                return a.isGreaterThan(b);
            }
        },
        {
            key: "add",
            value: function add(winstonStringA, winstonStringB) {
                var a = this.stringToBigNum(winstonStringA);
                var b = this.stringToBigNum(winstonStringB);
                return a.plus(winstonStringB).toFixed(0);
            }
        },
        {
            key: "sub",
            value: function sub(winstonStringA, winstonStringB) {
                var a = this.stringToBigNum(winstonStringA);
                var b = this.stringToBigNum(winstonStringB);
                return a.minus(winstonStringB).toFixed(0);
            }
        },
        {
            key: "stringToBigNum",
            value: function stringToBigNum(stringValue) {
                var decimalPlaces = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 12;
                return this.BigNum(stringValue, decimalPlaces);
            }
        }
    ]);
    return Ar;
}();
module.exports.default = $2d8fdbe1d77e4d74$var$Ar;

});
parcelRequire.register("ivmGH", function(module, exports) {
(function(globalObject) {
    "use strict";
    var bitFloor = // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    };
    var coeffToString = // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    };
    var compare = // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    };
    var intCheck = /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
    };
    var isOdd = // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    };
    var toExponential = function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    };
    var toFixedPoint = function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    };
    /*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            suffix: ""
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == "number") && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == "number") {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == "[object Array]") {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + "Invalid BigNumber: " + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function random53bitInt() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "5e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == "object") {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == "object") {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != "object") throw Error(bignumberError + "Argument not an object: " + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
            }
            return (format.prefix || "") + str + (format.suffix || "");
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, "0");
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, "0");
                } else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(module.exports);

});


parcelRequire.register("dBEbD", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $aqO2F = parcelRequire("aqO2F");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $6ncFv = parcelRequire("6ncFv");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9e7de74ed6a31a96$var$Api = /*#__PURE__*/ function() {
    function Api(config) {
        (0, $978gY._)(this, Api);
        (0, $dxWQo._)(this, "METHOD_GET", "GET");
        (0, $dxWQo._)(this, "METHOD_POST", "POST");
        (0, $dxWQo._)(this, "config", void 0);
        this.applyConfig(config);
    }
    (0, $kry2a._)(Api, [
        {
            key: "applyConfig",
            value: function applyConfig(config) {
                this.config = this.mergeDefaults(config);
            }
        },
        {
            key: "getConfig",
            value: function getConfig() {
                return this.config;
            }
        },
        {
            key: "mergeDefaults",
            value: function mergeDefaults(config) {
                var protocol = config.protocol || "http";
                var port = config.port || (protocol === "https" ? 443 : 80);
                return {
                    host: config.host || "127.0.0.1",
                    protocol: protocol,
                    port: port,
                    timeout: config.timeout || 20000,
                    logging: config.logging || false,
                    logger: config.logger || console.log,
                    network: config.network
                };
            }
        },
        {
            key: "get",
            value: function get(endpoint, config) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.request(endpoint, (0, $8E768._)((0, $8OnJk._)({}, config), {
                                        method: _this.METHOD_GET
                                    }))
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "post",
            value: function post(endpoint, body, config) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _headers_get, headers;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = new Headers((config === null || config === void 0 ? void 0 : config.headers) || {});
                                if (!((_headers_get = headers.get("content-type")) === null || _headers_get === void 0 ? void 0 : _headers_get.includes("application/json"))) headers.append("content-type", "application/json");
                                headers.append("accept", "application/json, text/plain, */*");
                                return [
                                    4,
                                    _this.request(endpoint, (0, $8E768._)((0, $8OnJk._)({}, config), {
                                        method: _this.METHOD_POST,
                                        body: typeof body !== "string" ? JSON.stringify(body) : body,
                                        headers: headers
                                    }))
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "request",
            value: function request(endpoint, init) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _contentType_match, headers, baseURL, responseType, res, contentType, charset, response, decodeText, test, e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = new Headers((init === null || init === void 0 ? void 0 : init.headers) || {});
                                baseURL = "".concat(_this.config.protocol, "://").concat(_this.config.host, ":").concat(_this.config.port);
                                responseType = init === null || init === void 0 ? void 0 : init.responseType;
                                init === null || init === void 0 ? void 0 : delete init.responseType;
                                if (endpoint.startsWith("/")) endpoint = endpoint.slice(1);
                                if (_this.config.network) headers.append("x-network", _this.config.network);
                                if (_this.config.logging) _this.config.logger("Requesting: ".concat(baseURL, "/").concat(endpoint));
                                return [
                                    4,
                                    fetch("".concat(baseURL, "/").concat(endpoint), (0, $8E768._)((0, $8OnJk._)({}, init || {}), {
                                        headers: headers
                                    }))
                                ];
                            case 1:
                                res = _state.sent();
                                if (_this.config.logging) _this.config.logger("Response:   ".concat(res.url, " - ").concat(res.status));
                                contentType = res.headers.get("content-type");
                                charset = (_contentType_match = contentType === null || contentType === void 0 ? void 0 : contentType.match(/charset=([^()<>@,;:\"/[\]?.=\s]*)/i)) === null || _contentType_match === void 0 ? void 0 : _contentType_match[1];
                                response = res;
                                decodeText = function() {
                                    var _ref = (0, $byzP8._)(function() {
                                        var _, _1, e;
                                        return (0, $7UAGh.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!charset) return [
                                                        3,
                                                        6
                                                    ];
                                                    _state.label = 1;
                                                case 1:
                                                    _state.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        5
                                                    ]);
                                                    _1 = (_ = new TextDecoder(charset)).decode;
                                                    return [
                                                        4,
                                                        res.arrayBuffer()
                                                    ];
                                                case 2:
                                                    response.data = _1.apply(_, [
                                                        _state.sent()
                                                    ]);
                                                    return [
                                                        3,
                                                        5
                                                    ];
                                                case 3:
                                                    e = _state.sent();
                                                    return [
                                                        4,
                                                        res.text()
                                                    ];
                                                case 4:
                                                    response.data = _state.sent();
                                                    return [
                                                        3,
                                                        5
                                                    ];
                                                case 5:
                                                    return [
                                                        3,
                                                        8
                                                    ];
                                                case 6:
                                                    return [
                                                        4,
                                                        res.text()
                                                    ];
                                                case 7:
                                                    response.data = _state.sent();
                                                    _state.label = 8;
                                                case 8:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function decodeText() {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                if (!(responseType === "arraybuffer")) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    res.arrayBuffer()
                                ];
                            case 2:
                                response.data = _state.sent();
                                return [
                                    3,
                                    14
                                ];
                            case 3:
                                if (!(responseType === "text")) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    decodeText()
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    14
                                ];
                            case 5:
                                if (!(responseType === "webstream")) return [
                                    3,
                                    6
                                ];
                                response.data = $9e7de74ed6a31a96$var$addAsyncIterator(res.body);
                                return [
                                    3,
                                    14
                                ];
                            case 6:
                                _state.trys.push([
                                    6,
                                    12,
                                    ,
                                    14
                                ]);
                                return [
                                    4,
                                    res.clone().json()
                                ];
                            case 7:
                                test = _state.sent();
                                if (!(typeof test !== "object")) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    decodeText()
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                return [
                                    4,
                                    res.json()
                                ];
                            case 10:
                                response.data = _state.sent();
                                _state.label = 11;
                            case 11:
                                test = null;
                                return [
                                    3,
                                    14
                                ];
                            case 12:
                                e = _state.sent();
                                return [
                                    4,
                                    decodeText()
                                ];
                            case 13:
                                _state.sent();
                                return [
                                    3,
                                    14
                                ];
                            case 14:
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Api;
}();
module.exports.default = $9e7de74ed6a31a96$var$Api;
/**
 * *** To be removed when browsers catch up with the whatwg standard. ***
 * [Symbol.AsyncIterator] is needed to use `for-await` on the returned ReadableStream (web stream).
 * Feature is available in nodejs, and should be available in browsers eventually.
 */ var $9e7de74ed6a31a96$var$addAsyncIterator = function(body) {
    var bodyWithIter = body;
    if (typeof bodyWithIter[Symbol.asyncIterator] === "undefined") {
        bodyWithIter[Symbol.asyncIterator] = $9e7de74ed6a31a96$var$webIiterator(body);
        return bodyWithIter;
    }
    return body;
};
var $9e7de74ed6a31a96$var$webIiterator = function webIiterator(stream) {
    return function() {
        var _iteratorGenerator = (0, $6ncFv._)(function() {
            var reader, _ref, done, value;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        reader = stream.getReader(); //lock
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            6,
                            7
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!true) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            (0, $aqO2F._)(reader.read())
                        ];
                    case 3:
                        _ref = _state.sent(), done = _ref.done, value = _ref.value;
                        if (done) return [
                            2
                        ];
                        return [
                            4,
                            value
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        reader.releaseLock(); //unlock
                        return [
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        function iteratorGenerator() {
            return _iteratorGenerator.apply(this, arguments);
        }
        return iteratorGenerator;
    }();
};

});
parcelRequire.register("aqO2F", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $798326692fabb465$export$491e832825b6666e; });

var $gHNJN = parcelRequire("gHNJN");
function $798326692fabb465$export$491e832825b6666e(value) {
    return new (0, $gHNJN._await_value)(value);
}

});
parcelRequire.register("gHNJN", function(module, exports) {

$parcel$export(module.exports, "_await_value", function () { return $c2973e5763cf5972$export$14d68ad33f8c0242; });
function $c2973e5763cf5972$export$14d68ad33f8c0242(value) {
    this.wrapped = value;
}

});


parcelRequire.register("6ncFv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4a3eb7c4ab40830d$export$a1b373fcf543ed3a; });

var $gyPRT = parcelRequire("gyPRT");
function $4a3eb7c4ab40830d$export$a1b373fcf543ed3a(fn) {
    return function() {
        return new (0, $gyPRT._async_generator)(fn.apply(this, arguments));
    };
}

});
parcelRequire.register("gyPRT", function(module, exports) {

$parcel$export(module.exports, "_async_generator", function () { return $c0e80e413a4b8ffa$export$f6ee6a12e55075bb; });

var $gHNJN = parcelRequire("gHNJN");
function $c0e80e413a4b8ffa$export$f6ee6a12e55075bb(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var wrappedAwait = value instanceof (0, $gHNJN._await_value);
            Promise.resolve(wrappedAwait ? value.wrapped : value).then(function(arg) {
                if (wrappedAwait) {
                    resume("next", arg);
                    return;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
if (typeof Symbol === "function" && Symbol.asyncIterator) $c0e80e413a4b8ffa$export$f6ee6a12e55075bb.prototype[Symbol.asyncIterator] = function() {
    return this;
};
$c0e80e413a4b8ffa$export$f6ee6a12e55075bb.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$c0e80e413a4b8ffa$export$f6ee6a12e55075bb.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$c0e80e413a4b8ffa$export$f6ee6a12e55075bb.prototype.return = function(arg) {
    return this._invoke("return", arg);
};

});



parcelRequire.register("hvOUF", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dsrYt = parcelRequire("dsrYt");
var $cbfcd32ed3d2fd1b$var$WebCryptoDriver = /*#__PURE__*/ function() {
    function WebCryptoDriver() {
        (0, $978gY._)(this, WebCryptoDriver);
        (0, $dxWQo._)(this, "keyLength", 4096);
        (0, $dxWQo._)(this, "publicExponent", 0x10001);
        (0, $dxWQo._)(this, "hashAlgorithm", "sha256");
        (0, $dxWQo._)(this, "driver", void 0);
        if (!this.detectWebCrypto()) throw new Error("SubtleCrypto not available!");
        this.driver = crypto.subtle;
    }
    (0, $kry2a._)(WebCryptoDriver, [
        {
            key: "generateJWK",
            value: function generateJWK() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var cryptoKey, jwk;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.driver.generateKey({
                                        name: "RSA-PSS",
                                        modulusLength: 4096,
                                        publicExponent: new Uint8Array([
                                            0x01,
                                            0x00,
                                            0x01
                                        ]),
                                        hash: {
                                            name: "SHA-256"
                                        }
                                    }, true, [
                                        "sign"
                                    ])
                                ];
                            case 1:
                                cryptoKey = _state.sent();
                                return [
                                    4,
                                    _this.driver.exportKey("jwk", cryptoKey.privateKey)
                                ];
                            case 2:
                                jwk = _state.sent();
                                return [
                                    2,
                                    {
                                        kty: jwk.kty,
                                        e: jwk.e,
                                        n: jwk.n,
                                        d: jwk.d,
                                        p: jwk.p,
                                        q: jwk.q,
                                        dp: jwk.dp,
                                        dq: jwk.dq,
                                        qi: jwk.qi
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sign",
            value: function sign(jwk, data) {
                var saltLength = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).saltLength;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var signature, _, _1, _tmp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _1 = (_ = _this.driver).sign;
                                _tmp = [
                                    {
                                        name: "RSA-PSS",
                                        saltLength: 32
                                    }
                                ];
                                return [
                                    4,
                                    _this.jwkToCryptoKey(jwk)
                                ];
                            case 1:
                                return [
                                    4,
                                    _1.apply(_, _tmp.concat([
                                        _state.sent(),
                                        data
                                    ]))
                                ];
                            case 2:
                                signature = _state.sent();
                                return [
                                    2,
                                    new Uint8Array(signature)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "hash",
            value: function hash(data) {
                var algorithm = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "SHA-256";
                var _this = this;
                return (0, $byzP8._)(function() {
                    var digest;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.driver.digest(algorithm, data)
                                ];
                            case 1:
                                digest = _state.sent();
                                return [
                                    2,
                                    new Uint8Array(digest)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "verify",
            value: function verify(publicModulus, data, signature) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var publicKey, key, digest, salt0, salt32, saltN;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                publicKey = {
                                    kty: "RSA",
                                    e: "AQAB",
                                    n: publicModulus
                                };
                                return [
                                    4,
                                    _this.jwkToPublicCryptoKey(publicKey)
                                ];
                            case 1:
                                key = _state.sent();
                                return [
                                    4,
                                    _this.driver.digest("SHA-256", data)
                                ];
                            case 2:
                                digest = _state.sent();
                                return [
                                    4,
                                    _this.driver.verify({
                                        name: "RSA-PSS",
                                        saltLength: 0
                                    }, key, signature, data)
                                ];
                            case 3:
                                salt0 = _state.sent();
                                return [
                                    4,
                                    _this.driver.verify({
                                        name: "RSA-PSS",
                                        saltLength: 32
                                    }, key, signature, data)
                                ];
                            case 4:
                                salt32 = _state.sent();
                                return [
                                    4,
                                    _this.driver.verify({
                                        name: "RSA-PSS",
                                        saltLength: Math.ceil((key.algorithm.modulusLength - 1) / 8) - digest.byteLength - 2
                                    }, key, signature, data)
                                ];
                            case 5:
                                saltN = _state.sent();
                                return [
                                    2,
                                    salt0 || salt32 || saltN
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "jwkToCryptoKey",
            value: function jwkToCryptoKey(jwk) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.driver.importKey("jwk", jwk, {
                                name: "RSA-PSS",
                                hash: {
                                    name: "SHA-256"
                                }
                            }, false, [
                                "sign"
                            ])
                        ];
                    });
                })();
            }
        },
        {
            key: "jwkToPublicCryptoKey",
            value: function jwkToPublicCryptoKey(publicJwk) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.driver.importKey("jwk", publicJwk, {
                                name: "RSA-PSS",
                                hash: {
                                    name: "SHA-256"
                                }
                            }, false, [
                                "verify"
                            ])
                        ];
                    });
                })();
            }
        },
        {
            key: "detectWebCrypto",
            value: function detectWebCrypto() {
                if (typeof crypto === "undefined") return false;
                var subtle = crypto === null || crypto === void 0 ? void 0 : crypto.subtle;
                if (subtle === undefined) return false;
                var names = [
                    "generateKey",
                    "importKey",
                    "exportKey",
                    "digest",
                    "sign"
                ];
                return names.every(function(name) {
                    return typeof subtle[name] === "function";
                });
            }
        },
        {
            key: "encrypt",
            value: function encrypt(data, key, salt) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var initialKey, derivedkey, iv, encryptedData;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.driver.importKey("raw", typeof key == "string" ? $dsrYt.stringToBuffer(key) : key, {
                                        name: "PBKDF2",
                                        length: 32
                                    }, false, [
                                        "deriveKey"
                                    ])
                                ];
                            case 1:
                                initialKey = _state.sent();
                                return [
                                    4,
                                    _this.driver.deriveKey({
                                        name: "PBKDF2",
                                        salt: salt ? $dsrYt.stringToBuffer(salt) : $dsrYt.stringToBuffer("salt"),
                                        iterations: 100000,
                                        hash: "SHA-256"
                                    }, initialKey, {
                                        name: "AES-CBC",
                                        length: 256
                                    }, false, [
                                        "encrypt",
                                        "decrypt"
                                    ])
                                ];
                            case 2:
                                derivedkey = _state.sent();
                                iv = new Uint8Array(16);
                                crypto.getRandomValues(iv);
                                return [
                                    4,
                                    _this.driver.encrypt({
                                        name: "AES-CBC",
                                        iv: iv
                                    }, derivedkey, data)
                                ];
                            case 3:
                                encryptedData = _state.sent();
                                return [
                                    2,
                                    $dsrYt.concatBuffers([
                                        iv,
                                        encryptedData
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "decrypt",
            value: function decrypt(encrypted, key, salt) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var initialKey, derivedkey, iv, data;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.driver.importKey("raw", typeof key == "string" ? $dsrYt.stringToBuffer(key) : key, {
                                        name: "PBKDF2",
                                        length: 32
                                    }, false, [
                                        "deriveKey"
                                    ])
                                ];
                            case 1:
                                initialKey = _state.sent();
                                return [
                                    4,
                                    _this.driver.deriveKey({
                                        name: "PBKDF2",
                                        salt: salt ? $dsrYt.stringToBuffer(salt) : $dsrYt.stringToBuffer("salt"),
                                        iterations: 100000,
                                        hash: "SHA-256"
                                    }, initialKey, {
                                        name: "AES-CBC",
                                        length: 256
                                    }, false, [
                                        "encrypt",
                                        "decrypt"
                                    ])
                                ];
                            case 2:
                                derivedkey = _state.sent();
                                iv = encrypted.slice(0, 16);
                                return [
                                    4,
                                    _this.driver.decrypt({
                                        name: "AES-CBC",
                                        iv: iv
                                    }, derivedkey, encrypted.slice(16))
                                ];
                            case 3:
                                data = _state.sent();
                                // We're just using concat to convert from an array buffer to uint8array
                                return [
                                    2,
                                    $dsrYt.concatBuffers([
                                        data
                                    ])
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return WebCryptoDriver;
}();
module.exports.default = $cbfcd32ed3d2fd1b$var$WebCryptoDriver;

});
parcelRequire.register("dsrYt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.b64UrlDecode = module.exports.b64UrlEncode = module.exports.bufferTob64Url = module.exports.bufferTob64 = module.exports.b64UrlToBuffer = module.exports.stringToB64Url = module.exports.stringToBuffer = module.exports.bufferToString = module.exports.b64UrlToString = module.exports.concatBuffers = void 0;

var $7LFKz = parcelRequire("7LFKz");
function $9cc396ffb6355eed$var$concatBuffers(buffers) {
    var total_length = 0;
    for(var i = 0; i < buffers.length; i++)total_length += buffers[i].byteLength;
    var temp = new Uint8Array(total_length);
    var offset = 0;
    temp.set(new Uint8Array(buffers[0]), offset);
    offset += buffers[0].byteLength;
    for(var i1 = 1; i1 < buffers.length; i1++){
        temp.set(new Uint8Array(buffers[i1]), offset);
        offset += buffers[i1].byteLength;
    }
    return temp;
}
module.exports.concatBuffers = $9cc396ffb6355eed$var$concatBuffers;
function $9cc396ffb6355eed$var$b64UrlToString(b64UrlString) {
    var buffer = $9cc396ffb6355eed$var$b64UrlToBuffer(b64UrlString);
    return $9cc396ffb6355eed$var$bufferToString(buffer);
}
module.exports.b64UrlToString = $9cc396ffb6355eed$var$b64UrlToString;
function $9cc396ffb6355eed$var$bufferToString(buffer) {
    return new TextDecoder("utf-8", {
        fatal: true
    }).decode(buffer);
}
module.exports.bufferToString = $9cc396ffb6355eed$var$bufferToString;
function $9cc396ffb6355eed$var$stringToBuffer(string) {
    return new TextEncoder().encode(string);
}
module.exports.stringToBuffer = $9cc396ffb6355eed$var$stringToBuffer;
function $9cc396ffb6355eed$var$stringToB64Url(string) {
    return $9cc396ffb6355eed$var$bufferTob64Url($9cc396ffb6355eed$var$stringToBuffer(string));
}
module.exports.stringToB64Url = $9cc396ffb6355eed$var$stringToB64Url;
function $9cc396ffb6355eed$var$b64UrlToBuffer(b64UrlString) {
    return new Uint8Array($7LFKz.toByteArray($9cc396ffb6355eed$var$b64UrlDecode(b64UrlString)));
}
module.exports.b64UrlToBuffer = $9cc396ffb6355eed$var$b64UrlToBuffer;
function $9cc396ffb6355eed$var$bufferTob64(buffer) {
    return $7LFKz.fromByteArray(new Uint8Array(buffer));
}
module.exports.bufferTob64 = $9cc396ffb6355eed$var$bufferTob64;
function $9cc396ffb6355eed$var$bufferTob64Url(buffer) {
    return $9cc396ffb6355eed$var$b64UrlEncode($9cc396ffb6355eed$var$bufferTob64(buffer));
}
module.exports.bufferTob64Url = $9cc396ffb6355eed$var$bufferTob64Url;
function $9cc396ffb6355eed$var$b64UrlEncode(b64UrlString) {
    return b64UrlString.replace(/\+/g, "-").replace(/\//g, "_").replace(/\=/g, "");
}
module.exports.b64UrlEncode = $9cc396ffb6355eed$var$b64UrlEncode;
function $9cc396ffb6355eed$var$b64UrlDecode(b64UrlString) {
    b64UrlString = b64UrlString.replace(/\-/g, "+").replace(/\_/g, "/");
    var padding;
    b64UrlString.length % 4 == 0 ? padding = 0 : padding = 4 - b64UrlString.length % 4;
    return b64UrlString.concat("=".repeat(padding));
}
module.exports.b64UrlDecode = $9cc396ffb6355eed$var$b64UrlDecode;

});


parcelRequire.register("5xI54", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $40923a5324fad830$var$Network = /*#__PURE__*/ function() {
    function Network(api) {
        (0, $978gY._)(this, Network);
        (0, $dxWQo._)(this, "api", void 0);
        this.api = api;
    }
    (0, $kry2a._)(Network, [
        {
            key: "getInfo",
            value: function getInfo() {
                return this.api.get("info").then(function(response) {
                    return response.data;
                });
            }
        },
        {
            key: "getPeers",
            value: function getPeers() {
                return this.api.get("peers").then(function(response) {
                    return response.data;
                });
            }
        }
    ]);
    return Network;
}();
module.exports.default = $40923a5324fad830$var$Network;

});

parcelRequire.register("5JpNe", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $aqO2F = parcelRequire("aqO2F");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $6ncFv = parcelRequire("6ncFv");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gSbNG = parcelRequire("gSbNG");

var $ap7ys = parcelRequire("ap7ys");

var $dsrYt = parcelRequire("dsrYt");

var $6xSlJ = parcelRequire("6xSlJ");
parcelRequire("94j2z");
var $42c529aaddeedcfa$var$Transactions = /*#__PURE__*/ function() {
    function Transactions(api, crypto, chunks) {
        (0, $978gY._)(this, Transactions);
        (0, $dxWQo._)(this, "api", void 0);
        (0, $dxWQo._)(this, "crypto", void 0);
        (0, $dxWQo._)(this, "chunks", void 0);
        this.api = api;
        this.crypto = crypto;
        this.chunks = chunks;
    }
    (0, $kry2a._)(Transactions, [
        {
            key: "getTransactionAnchor",
            value: function getTransactionAnchor() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.api.get("tx_anchor")
                                ];
                            case 1:
                                res = _state.sent();
                                if (!res.data.match(/^[a-z0-9_-]{43,}/i) || !res.ok) throw new Error("Could not getTransactionAnchor. Received: ".concat(res.data, ". Status: ").concat(res.status, ", ").concat(res.statusText));
                                return [
                                    2,
                                    res.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPrice",
            value: function getPrice(byteSize, targetAddress) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var endpoint, res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                endpoint = targetAddress ? "price/".concat(byteSize, "/").concat(targetAddress) : "price/".concat(byteSize);
                                return [
                                    4,
                                    _this.api.get(endpoint)
                                ];
                            case 1:
                                res = _state.sent();
                                if (!/^\d+$/.test(res.data) || !res.ok) throw new Error("Could not getPrice. Received: ".concat(res.data, ". Status: ").concat(res.status, ", ").concat(res.statusText));
                                return [
                                    2,
                                    res.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "get",
            value: function get(id) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var response, data_size, data;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.api.get("tx/".concat(id))
                                ];
                            case 1:
                                response = _state.sent();
                                if (!(response.status == 200)) return [
                                    3,
                                    4
                                ];
                                data_size = parseInt(response.data.data_size);
                                if (!(response.data.format >= 2 && data_size > 0 && data_size <= 12582912)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.getData(id)
                                ];
                            case 2:
                                data = _state.sent();
                                return [
                                    2,
                                    new $ap7ys.default((0, $8E768._)((0, $8OnJk._)({}, response.data), {
                                        data: data
                                    }))
                                ];
                            case 3:
                                return [
                                    2,
                                    new $ap7ys.default((0, $8E768._)((0, $8OnJk._)({}, response.data), {
                                        format: response.data.format || 1
                                    }))
                                ];
                            case 4:
                                if (response.status == 404) throw new $gSbNG.default("TX_NOT_FOUND" /* ArweaveErrorType.TX_NOT_FOUND */ );
                                if (response.status == 410) throw new $gSbNG.default("TX_FAILED" /* ArweaveErrorType.TX_FAILED */ );
                                throw new $gSbNG.default("TX_INVALID" /* ArweaveErrorType.TX_INVALID */ );
                        }
                    });
                })();
            }
        },
        {
            key: "fromRaw",
            value: function fromRaw(attributes) {
                return new $ap7ys.default(attributes);
            }
        },
        {
            key: "search",
            value: function search(tagName, tagValue) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.api.post("arql", {
                                op: "equals",
                                expr1: tagName,
                                expr2: tagValue
                            }).then(function(response) {
                                if (!response.data) return [];
                                return response.data;
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getStatus",
            value: function getStatus(id) {
                return this.api.get("tx/".concat(id, "/status")).then(function(response) {
                    if (response.status == 200) return {
                        status: 200,
                        confirmed: response.data
                    };
                    return {
                        status: response.status,
                        confirmed: null
                    };
                });
            }
        },
        {
            key: "getData",
            value: function getData(id, options) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var data, error, _ref, resData, ok, status, statusText, error1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                data = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.chunks.downloadChunkedData(id)
                                ];
                            case 2:
                                data = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                console.error("Error while trying to download chunked data for ".concat(id));
                                console.error(error);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                if (!!data) return [
                                    3,
                                    8
                                ];
                                console.warn("Falling back to gateway cache for ".concat(id));
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    _this.api.get("/".concat(id), {
                                        responseType: "arraybuffer"
                                    })
                                ];
                            case 6:
                                _ref = _state.sent(), resData = _ref.data, ok = _ref.ok, status = _ref.status, statusText = _ref.statusText;
                                if (!ok) throw new Error("Bad http status code", {
                                    cause: {
                                        status: status,
                                        statusText: statusText
                                    }
                                });
                                data = resData;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                error1 = _state.sent();
                                console.error("Error while trying to download contiguous data from gateway cache for ".concat(id));
                                console.error(error1);
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                if (!data) throw new Error("".concat(id, " data was not found!"));
                                if (options && options.decode && !options.string) return [
                                    2,
                                    data
                                ];
                                if (options && options.decode && options.string) return [
                                    2,
                                    $dsrYt.bufferToString(data)
                                ];
                                // Since decode wasn't requested, caller expects b64url encoded data.
                                return [
                                    2,
                                    $dsrYt.bufferTob64Url(data)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sign",
            value: function sign(transaction, jwk, options) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var isJwk, validJwk, externalWallet, dataToSign, rawSignature, id, existingPermissions, e, signedTransaction;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                isJwk = function(obj) {
                                    var valid = true;
                                    [
                                        "n",
                                        "e",
                                        "d",
                                        "p",
                                        "q",
                                        "dp",
                                        "dq",
                                        "qi"
                                    ].map(function(key) {
                                        return !(key in obj) && (valid = false);
                                    });
                                    return valid;
                                };
                                validJwk = typeof jwk === "object" && isJwk(jwk);
                                externalWallet = typeof arweaveWallet === "object";
                                if (!(!validJwk && !externalWallet)) return [
                                    3,
                                    1
                                ];
                                throw new Error("No valid JWK or external wallet found to sign transaction.");
                            case 1:
                                if (!validJwk) return [
                                    3,
                                    5
                                ];
                                transaction.setOwner(jwk.n);
                                return [
                                    4,
                                    transaction.getSignatureData()
                                ];
                            case 2:
                                dataToSign = _state.sent();
                                return [
                                    4,
                                    _this.crypto.sign(jwk, dataToSign, options)
                                ];
                            case 3:
                                rawSignature = _state.sent();
                                return [
                                    4,
                                    _this.crypto.hash(rawSignature)
                                ];
                            case 4:
                                id = _state.sent();
                                transaction.setSignature({
                                    id: $dsrYt.bufferTob64Url(id),
                                    owner: jwk.n,
                                    signature: $dsrYt.bufferTob64Url(rawSignature)
                                });
                                return [
                                    3,
                                    14
                                ];
                            case 5:
                                if (!externalWallet) return [
                                    3,
                                    13
                                ];
                                _state.label = 6;
                            case 6:
                                _state.trys.push([
                                    6,
                                    10,
                                    ,
                                    11
                                ]);
                                return [
                                    4,
                                    arweaveWallet.getPermissions()
                                ];
                            case 7:
                                existingPermissions = _state.sent();
                                if (!!existingPermissions.includes("SIGN_TRANSACTION")) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    arweaveWallet.connect([
                                        "SIGN_TRANSACTION"
                                    ])
                                ];
                            case 8:
                                _state.sent();
                                _state.label = 9;
                            case 9:
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                e = _state.sent();
                                return [
                                    3,
                                    11
                                ];
                            case 11:
                                return [
                                    4,
                                    arweaveWallet.sign(transaction, options)
                                ];
                            case 12:
                                signedTransaction = _state.sent();
                                transaction.setSignature({
                                    id: signedTransaction.id,
                                    owner: signedTransaction.owner,
                                    reward: signedTransaction.reward,
                                    tags: signedTransaction.tags,
                                    signature: signedTransaction.signature
                                });
                                return [
                                    3,
                                    14
                                ];
                            case 13:
                                //can't get here, but for sanity we'll throw an error.
                                throw new Error("An error occurred while signing. Check wallet is valid");
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "verify",
            value: function verify(transaction) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var signaturePayload, rawSignature, expectedId, _;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    transaction.getSignatureData()
                                ];
                            case 1:
                                signaturePayload = _state.sent();
                                rawSignature = transaction.get("signature", {
                                    decode: true,
                                    string: false
                                });
                                _ = $dsrYt.bufferTob64Url;
                                return [
                                    4,
                                    _this.crypto.hash(rawSignature)
                                ];
                            case 2:
                                expectedId = _.apply($dsrYt, [
                                    _state.sent()
                                ]);
                                if (transaction.id !== expectedId) throw new Error("Invalid transaction signature or ID! The transaction ID doesn't match the expected SHA-256 hash of the signature.");
                                /**
         * Now verify the signature is valid and signed by the owner wallet (owner field = originating wallet public key).
         */ return [
                                    2,
                                    _this.crypto.verify(transaction.owner, signaturePayload, rawSignature)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "post",
            value: function post(transaction) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var uploader, e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (typeof transaction === "string") transaction = new $ap7ys.default(JSON.parse(transaction));
                                else if (typeof transaction.readInt32BE === "function") transaction = new $ap7ys.default(JSON.parse(transaction.toString()));
                                else if (typeof transaction === "object" && !(transaction instanceof $ap7ys.default)) transaction = new $ap7ys.default(transaction);
                                if (!(transaction instanceof $ap7ys.default)) throw new Error("Must be Transaction object");
                                if (!!transaction.chunks) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    transaction.prepareChunks(transaction.data)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _this.getUploader(transaction, transaction.data)
                                ];
                            case 3:
                                uploader = _state.sent();
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    8,
                                    ,
                                    9
                                ]);
                                _state.label = 5;
                            case 5:
                                if (!!uploader.isComplete) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    uploader.uploadChunk()
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 7:
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                e = _state.sent();
                                if (uploader.lastResponseStatus > 0) return [
                                    2,
                                    {
                                        status: uploader.lastResponseStatus,
                                        statusText: uploader.lastResponseError,
                                        data: {
                                            error: uploader.lastResponseError
                                        }
                                    }
                                ];
                                throw e;
                            case 9:
                                return [
                                    2,
                                    {
                                        status: 200,
                                        statusText: "OK",
                                        data: {}
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getUploader",
            value: /**
     * Gets an uploader than can be used to upload a transaction chunk by chunk, giving progress
     * and the ability to resume.
     *
     * Usage example:
     *
     * ```
     * const uploader = arweave.transactions.getUploader(transaction);
     * while (!uploader.isComplete) {
     *   await uploader.uploadChunk();
     *   console.log(`${uploader.pctComplete}%`);
     * }
     * ```
     *
     * @param upload a Transaction object, a previously save progress object, or a transaction id.
     * @param data the data of the transaction. Required when resuming an upload.
     */ function getUploader(upload, data) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var uploader;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (data instanceof ArrayBuffer) data = new Uint8Array(data);
                                if (!(upload instanceof $ap7ys.default)) return [
                                    3,
                                    3
                                ];
                                if (!data) data = upload.data;
                                if (!(data instanceof Uint8Array)) throw new Error("Data format is invalid");
                                if (!!upload.chunks) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    upload.prepareChunks(data)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                uploader = new $6xSlJ.TransactionUploader(_this.api, upload);
                                if (!uploader.data || uploader.data.length === 0) uploader.data = data;
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                if (!(typeof upload === "string")) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    $6xSlJ.TransactionUploader.fromTransactionId(_this.api, upload)
                                ];
                            case 4:
                                upload = _state.sent();
                                _state.label = 5;
                            case 5:
                                if (!data || !(data instanceof Uint8Array)) throw new Error("Must provide data when resuming upload");
                                return [
                                    4,
                                    $6xSlJ.TransactionUploader.fromSerialized(_this.api, upload, data)
                                ];
                            case 6:
                                // upload should be a serialized upload.
                                uploader = _state.sent();
                                _state.label = 7;
                            case 7:
                                return [
                                    2,
                                    uploader
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "upload",
            value: /**
     * Async generator version of uploader
     *
     * Usage example:
     *
     * ```
     * for await (const uploader of arweave.transactions.upload(tx)) {
     *  console.log(`${uploader.pctComplete}%`);
     * }
     * ```
     *
     * @param upload a Transaction object, a previously save uploader, or a transaction id.
     * @param data the data of the transaction. Required when resuming an upload.
     */ function upload(upload, data) {
                var _this = this;
                return (0, $6ncFv._)(function() {
                    var uploader;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $aqO2F._)(_this.getUploader(upload, data))
                                ];
                            case 1:
                                uploader = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (!!uploader.isComplete) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    (0, $aqO2F._)(uploader.uploadChunk())
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    uploader
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    2,
                                    uploader
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Transactions;
}();
module.exports.default = $42c529aaddeedcfa$var$Transactions;

});
parcelRequire.register("gSbNG", function(module, exports) {

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $ftJVG = parcelRequire("ftJVG");

var $ho5gk = parcelRequire("ho5gk");

var $2TMdq = parcelRequire("2TMdq");

var $6OZAO = parcelRequire("6OZAO");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getError = void 0;
var $c48ad7cbe8289009$var$ArweaveError = /*#__PURE__*/ function(Error1) {
    (0, $ftJVG._)(ArweaveError, Error1);
    var _super = (0, $6OZAO._)(ArweaveError);
    function ArweaveError(type) {
        var optional = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $978gY._)(this, ArweaveError);
        var _this;
        var _temp;
        if (optional.message) _temp = _this = _super.call(this, optional.message), (0, $dxWQo._)((0, $3vWwE._)(_this), "type", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "response", void 0), _temp;
        else _temp = _this = _super.call(this), (0, $dxWQo._)((0, $3vWwE._)(_this), "type", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "response", void 0), _temp;
        _this.type = type;
        _this.response = optional.response;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(ArweaveError, [
        {
            key: "getType",
            value: function getType() {
                return this.type;
            }
        }
    ]);
    return ArweaveError;
}((0, $2TMdq._)(Error));
module.exports.default = $c48ad7cbe8289009$var$ArweaveError;
// Safely get error string
// from a response, falling back to
// resp.data, statusText or 'unknown'.
// Note: a wrongly set content-type can
// cause what is a json response to be interepted
// as a string or Buffer, so we handle that too.
function $c48ad7cbe8289009$var$getError(resp) {
    var data = resp.data;
    if (typeof resp.data === "string") try {
        data = JSON.parse(resp.data);
    } catch (e) {}
    if (resp.data instanceof ArrayBuffer || resp.data instanceof Uint8Array) try {
        data = JSON.parse(data.toString());
    } catch (e) {}
    return data ? data.error || data : resp.statusText || "unknown";
}
module.exports.getError = $c48ad7cbe8289009$var$getError;

});
parcelRequire.register("3vWwE", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $28f1aa4c4240ff0b$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $28f1aa4c4240ff0b$export$f3b8ed2e4a5d10b8; });
function $28f1aa4c4240ff0b$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRequire.register("ftJVG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b44d311756de33f4$export$7e4530ad35d3bb8; });

var $azwGX = parcelRequire("azwGX");
function $b44d311756de33f4$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $azwGX._set_prototype_of)(subClass, superClass);
}

});
parcelRequire.register("azwGX", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $7b26882fd1cd0ac2$export$c2c98ac76e997b63; });
function $7b26882fd1cd0ac2$export$c2c98ac76e997b63(o, p) {
    $7b26882fd1cd0ac2$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7b26882fd1cd0ac2$export$c2c98ac76e997b63(o, p);
}

});


parcelRequire.register("ho5gk", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $ca88c28e2dc74ceb$export$ef97c660ca164e52; });
$parcel$export(module.exports, "_", function () { return $ca88c28e2dc74ceb$export$ef97c660ca164e52; });

var $3vWwE = parcelRequire("3vWwE");

var $1ObTH = parcelRequire("1ObTH");
function $ca88c28e2dc74ceb$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $1ObTH._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $3vWwE._assert_this_initialized)(self);
}

});

parcelRequire.register("2TMdq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $21c61e66a13e7076$export$2466d533fda16e33; });

var $34cAK = parcelRequire("34cAK");

var $g3d7z = parcelRequire("g3d7z");

var $cM94G = parcelRequire("cM94G");

var $azwGX = parcelRequire("azwGX");
function $21c61e66a13e7076$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $21c61e66a13e7076$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $cM94G._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $34cAK._construct)(Class, arguments, (0, $g3d7z._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $azwGX._set_prototype_of)(Wrapper, Class);
    };
    return $21c61e66a13e7076$export$2466d533fda16e33(Class);
}

});
parcelRequire.register("34cAK", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $23bb83417b6a52ec$export$2d841144c5f8c4ab; });

var $1vcmW = parcelRequire("1vcmW");

var $azwGX = parcelRequire("azwGX");
function $23bb83417b6a52ec$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $1vcmW._is_native_reflect_construct)()) $23bb83417b6a52ec$export$2d841144c5f8c4ab = Reflect.construct;
    else $23bb83417b6a52ec$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $azwGX._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $23bb83417b6a52ec$export$2d841144c5f8c4ab.apply(null, arguments);
}

});
parcelRequire.register("1vcmW", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $118247e7c3dd6008$export$685354647fba1516; });
function $118247e7c3dd6008$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRequire.register("g3d7z", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $baf71ab6cd4d51b1$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $baf71ab6cd4d51b1$export$f09211a7d3c496a1; });
function $baf71ab6cd4d51b1$export$f09211a7d3c496a1(o) {
    $baf71ab6cd4d51b1$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $baf71ab6cd4d51b1$export$f09211a7d3c496a1(o);
}

});

parcelRequire.register("cM94G", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $94d101b80d8606f0$export$514eda94019f4334; });
function $94d101b80d8606f0$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRequire.register("6OZAO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4f7730a4a64324ea$export$8dd05c13f5255580; });

var $g3d7z = parcelRequire("g3d7z");

var $1vcmW = parcelRequire("1vcmW");

var $ho5gk = parcelRequire("ho5gk");
function $4f7730a4a64324ea$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $1vcmW._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $g3d7z._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $g3d7z._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $ho5gk._possible_constructor_return)(this, result);
    };
}

});


parcelRequire.register("ap7ys", function(module, exports) {

var $3vWwE = parcelRequire("3vWwE");

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tag = void 0;

var $dsrYt = parcelRequire("dsrYt");

var $fiJyz = parcelRequire("fiJyz");

var $6uGA3 = parcelRequire("6uGA3");
var $793219672dd83616$var$BaseObject = /*#__PURE__*/ function() {
    function BaseObject() {
        (0, $978gY._)(this, BaseObject);
    }
    (0, $kry2a._)(BaseObject, [
        {
            key: "get",
            value: function get(field, options) {
                if (!Object.getOwnPropertyNames(this).includes(field)) throw new Error('Field "'.concat(field, '" is not a property of the Arweave Transaction class.'));
                // Handle fields that are Uint8Arrays.
                // To maintain compat we encode them to b64url
                // if decode option is not specificed.
                if (this[field] instanceof Uint8Array) {
                    if (options && options.decode && options.string) return $dsrYt.bufferToString(this[field]);
                    if (options && options.decode && !options.string) return this[field];
                    return $dsrYt.bufferTob64Url(this[field]);
                }
                if (this[field] instanceof Array) {
                    if ((options === null || options === void 0 ? void 0 : options.decode) !== undefined || (options === null || options === void 0 ? void 0 : options.string) !== undefined) {
                        if (field === "tags") console.warn("Did you mean to use 'transaction[\"tags\"]' ?");
                        throw new Error("Cannot decode or stringify an array.");
                    }
                    return this[field];
                }
                if (options && options.decode == true) {
                    if (options && options.string) return $dsrYt.b64UrlToString(this[field]);
                    return $dsrYt.b64UrlToBuffer(this[field]);
                }
                return this[field];
            }
        }
    ]);
    return BaseObject;
}();
var $793219672dd83616$var$Tag = /*#__PURE__*/ function(BaseObject) {
    (0, $ftJVG._)(Tag, BaseObject);
    var _super = (0, $6OZAO._)(Tag);
    function Tag(name, value) {
        var decode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        (0, $978gY._)(this, Tag);
        var _this;
        _this = _super.call(this);
        (0, $dxWQo._)((0, $3vWwE._)(_this), "name", void 0);
        (0, $dxWQo._)((0, $3vWwE._)(_this), "value", void 0);
        _this.name = name;
        _this.value = value;
        return _this;
    }
    return Tag;
}($793219672dd83616$var$BaseObject);
module.exports.Tag = $793219672dd83616$var$Tag;
var $793219672dd83616$var$Transaction = /*#__PURE__*/ function(BaseObject) {
    (0, $ftJVG._)(Transaction, BaseObject);
    var _super = (0, $6OZAO._)(Transaction);
    function Transaction() {
        var attributes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $978gY._)(this, Transaction);
        var _this;
        _this = _super.call(this);
        (0, $dxWQo._)((0, $3vWwE._)(_this), "format", 2);
        (0, $dxWQo._)((0, $3vWwE._)(_this), "id", "");
        (0, $dxWQo._)((0, $3vWwE._)(_this), "last_tx", "");
        (0, $dxWQo._)((0, $3vWwE._)(_this), "owner", "");
        (0, $dxWQo._)((0, $3vWwE._)(_this), "tags", []);
        (0, $dxWQo._)((0, $3vWwE._)(_this), "target", "");
        (0, $dxWQo._)((0, $3vWwE._)(_this), "quantity", "0");
        (0, $dxWQo._)((0, $3vWwE._)(_this), "data_size", "0");
        (0, $dxWQo._)((0, $3vWwE._)(_this), "data", new Uint8Array());
        (0, $dxWQo._)((0, $3vWwE._)(_this), "data_root", "");
        (0, $dxWQo._)((0, $3vWwE._)(_this), "reward", "0");
        (0, $dxWQo._)((0, $3vWwE._)(_this), "signature", "");
        // Computed when needed.
        (0, $dxWQo._)((0, $3vWwE._)(_this), "chunks", void 0);
        Object.assign((0, $3vWwE._)(_this), attributes);
        // If something passes in a Tx that has been toJSON'ed and back,
        // or where the data was filled in from /tx/data endpoint.
        // data will be b64url encoded, so decode it.
        if (typeof _this.data === "string") _this.data = $dsrYt.b64UrlToBuffer(_this.data);
        if (attributes.tags) _this.tags = attributes.tags.map(function(tag) {
            return new $793219672dd83616$var$Tag(tag.name, tag.value);
        });
        return _this;
    }
    (0, $kry2a._)(Transaction, [
        {
            key: "addTag",
            value: function addTag(name, value) {
                this.tags.push(new $793219672dd83616$var$Tag($dsrYt.stringToB64Url(name), $dsrYt.stringToB64Url(value)));
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    format: this.format,
                    id: this.id,
                    last_tx: this.last_tx,
                    owner: this.owner,
                    tags: this.tags,
                    target: this.target,
                    quantity: this.quantity,
                    data: $dsrYt.bufferTob64Url(this.data),
                    data_size: this.data_size,
                    data_root: this.data_root,
                    data_tree: this.data_tree,
                    reward: this.reward,
                    signature: this.signature
                };
            }
        },
        {
            key: "setOwner",
            value: function setOwner(owner) {
                this.owner = owner;
            }
        },
        {
            key: "setSignature",
            value: function setSignature(param) {
                var id = param.id, owner = param.owner, reward = param.reward, tags = param.tags, signature = param.signature;
                this.id = id;
                this.owner = owner;
                if (reward) this.reward = reward;
                if (tags) this.tags = tags;
                this.signature = signature;
            }
        },
        {
            key: "prepareChunks",
            value: function prepareChunks(data) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(!_this.chunks && data.byteLength > 0)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $6uGA3.generateTransactionChunks)(data)
                                ];
                            case 1:
                                _this.chunks = _state.sent();
                                _this.data_root = $dsrYt.bufferTob64Url(_this.chunks.data_root);
                                _state.label = 2;
                            case 2:
                                if (!_this.chunks && data.byteLength === 0) {
                                    _this.chunks = {
                                        chunks: [],
                                        data_root: new Uint8Array(),
                                        proofs: []
                                    };
                                    _this.data_root = "";
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            // Returns a chunk in a format suitable for posting to /chunk.
            // Similar to `prepareChunks()` this does not operate `this.data`,
            // instead using the data passed in.
            key: "getChunk",
            value: function getChunk(idx, data) {
                if (!this.chunks) throw new Error("Chunks have not been prepared");
                var proof = this.chunks.proofs[idx];
                var chunk = this.chunks.chunks[idx];
                return {
                    data_root: this.data_root,
                    data_size: this.data_size,
                    data_path: $dsrYt.bufferTob64Url(proof.proof),
                    offset: proof.offset.toString(),
                    chunk: $dsrYt.bufferTob64Url(data.slice(chunk.minByteRange, chunk.maxByteRange))
                };
            }
        },
        {
            key: "getSignatureData",
            value: function getSignatureData() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _, tags, tagList;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = _this.format;
                                switch(_){
                                    case 1:
                                        return [
                                            3,
                                            1
                                        ];
                                    case 2:
                                        return [
                                            3,
                                            2
                                        ];
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 1:
                                tags = _this.tags.reduce(function(accumulator, tag) {
                                    return $dsrYt.concatBuffers([
                                        accumulator,
                                        tag.get("name", {
                                            decode: true,
                                            string: false
                                        }),
                                        tag.get("value", {
                                            decode: true,
                                            string: false
                                        })
                                    ]);
                                }, new Uint8Array());
                                return [
                                    2,
                                    $dsrYt.concatBuffers([
                                        _this.get("owner", {
                                            decode: true,
                                            string: false
                                        }),
                                        _this.get("target", {
                                            decode: true,
                                            string: false
                                        }),
                                        _this.get("data", {
                                            decode: true,
                                            string: false
                                        }),
                                        $dsrYt.stringToBuffer(_this.quantity),
                                        $dsrYt.stringToBuffer(_this.reward),
                                        _this.get("last_tx", {
                                            decode: true,
                                            string: false
                                        }),
                                        tags
                                    ])
                                ];
                            case 2:
                                if (!!_this.data_root) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.prepareChunks(_this.data)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                tagList = _this.tags.map(function(tag) {
                                    return [
                                        tag.get("name", {
                                            decode: true,
                                            string: false
                                        }),
                                        tag.get("value", {
                                            decode: true,
                                            string: false
                                        })
                                    ];
                                });
                                return [
                                    4,
                                    (0, $fiJyz.default)([
                                        $dsrYt.stringToBuffer(_this.format.toString()),
                                        _this.get("owner", {
                                            decode: true,
                                            string: false
                                        }),
                                        _this.get("target", {
                                            decode: true,
                                            string: false
                                        }),
                                        $dsrYt.stringToBuffer(_this.quantity),
                                        $dsrYt.stringToBuffer(_this.reward),
                                        _this.get("last_tx", {
                                            decode: true,
                                            string: false
                                        }),
                                        tagList,
                                        $dsrYt.stringToBuffer(_this.data_size),
                                        _this.get("data_root", {
                                            decode: true,
                                            string: false
                                        })
                                    ])
                                ];
                            case 5:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 6:
                                throw new Error("Unexpected transaction format: ".concat(_this.format));
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Transaction;
}($793219672dd83616$var$BaseObject);
module.exports.default = $793219672dd83616$var$Transaction;

});
parcelRequire.register("fiJyz", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aIAvL = parcelRequire("aIAvL");
function $b23be007d0f1c350$var$deepHash(data) {
    return $b23be007d0f1c350$var$_deepHash.apply(this, arguments);
}
function $b23be007d0f1c350$var$_deepHash() {
    $b23be007d0f1c350$var$_deepHash = (0, $byzP8._)(function(data) {
        var tag, _tmp, tag1, taggedHash, _, _1, _tmp1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!Array.isArray(data)) return [
                        3,
                        3
                    ];
                    tag = $aIAvL.default.utils.concatBuffers([
                        $aIAvL.default.utils.stringToBuffer("list"),
                        $aIAvL.default.utils.stringToBuffer(data.length.toString())
                    ]);
                    _tmp = [
                        data
                    ];
                    return [
                        4,
                        $aIAvL.default.crypto.hash(tag, "SHA-384")
                    ];
                case 1:
                    return [
                        4,
                        $b23be007d0f1c350$var$deepHashChunks.apply(void 0, _tmp.concat([
                            _state.sent()
                        ]))
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    tag1 = $aIAvL.default.utils.concatBuffers([
                        $aIAvL.default.utils.stringToBuffer("blob"),
                        $aIAvL.default.utils.stringToBuffer(data.byteLength.toString())
                    ]);
                    _1 = (_ = $aIAvL.default.utils).concatBuffers;
                    return [
                        4,
                        $aIAvL.default.crypto.hash(tag1, "SHA-384")
                    ];
                case 4:
                    _tmp1 = [
                        _state.sent()
                    ];
                    return [
                        4,
                        $aIAvL.default.crypto.hash(data, "SHA-384")
                    ];
                case 5:
                    taggedHash = _1.apply(_, [
                        _tmp1.concat([
                            _state.sent()
                        ])
                    ]);
                    return [
                        4,
                        $aIAvL.default.crypto.hash(taggedHash, "SHA-384")
                    ];
                case 6:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $b23be007d0f1c350$var$_deepHash.apply(this, arguments);
}
module.exports.default = $b23be007d0f1c350$var$deepHash;
function $b23be007d0f1c350$var$deepHashChunks(chunks, acc) {
    return $b23be007d0f1c350$var$_deepHashChunks.apply(this, arguments);
}
function $b23be007d0f1c350$var$_deepHashChunks() {
    $b23be007d0f1c350$var$_deepHashChunks = (0, $byzP8._)(function(chunks, acc) {
        var hashPair, _, _1, _tmp, newAcc;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (chunks.length < 1) return [
                        2,
                        acc
                    ];
                    _1 = (_ = $aIAvL.default.utils).concatBuffers;
                    _tmp = [
                        acc
                    ];
                    return [
                        4,
                        $b23be007d0f1c350$var$deepHash(chunks[0])
                    ];
                case 1:
                    hashPair = _1.apply(_, [
                        _tmp.concat([
                            _state.sent()
                        ])
                    ]);
                    return [
                        4,
                        $aIAvL.default.crypto.hash(hashPair, "SHA-384")
                    ];
                case 2:
                    newAcc = _state.sent();
                    return [
                        4,
                        $b23be007d0f1c350$var$deepHashChunks(chunks.slice(1), newAcc)
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $b23be007d0f1c350$var$_deepHashChunks.apply(this, arguments);
}

});

parcelRequire.register("6uGA3", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $4ba6930c2d9eb0cd$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.debug = module.exports.validatePath = module.exports.arrayCompare = module.exports.bufferToInt = module.exports.intToBuffer = module.exports.arrayFlatten = module.exports.generateProofs = module.exports.buildLayers = module.exports.generateTransactionChunks = module.exports.generateTree = module.exports.computeRootHash = module.exports.generateLeaves = module.exports.chunkData = module.exports.MIN_CHUNK_SIZE = module.exports.MAX_CHUNK_SIZE = void 0;

var $aIAvL = parcelRequire("aIAvL");

var $dsrYt = parcelRequire("dsrYt");
module.exports.MAX_CHUNK_SIZE = 262144;
module.exports.MIN_CHUNK_SIZE = 32768;
var $4ba6930c2d9eb0cd$var$NOTE_SIZE = 32;
var $4ba6930c2d9eb0cd$var$HASH_SIZE = 32;
function $4ba6930c2d9eb0cd$var$chunkData(data) {
    return $4ba6930c2d9eb0cd$var$_chunkData.apply(this, arguments);
}
function $4ba6930c2d9eb0cd$var$_chunkData() {
    $4ba6930c2d9eb0cd$var$_chunkData = /**
 * Takes the input data and chunks it into (mostly) equal sized chunks.
 * The last chunk will be a bit smaller as it contains the remainder
 * from the chunking process.
 */ (0, $byzP8._)(function(data) {
        var chunks, rest, cursor, chunkSize, nextChunkSize, chunk, dataHash, _, _tmp;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    chunks = [];
                    rest = data;
                    cursor = 0;
                    _state.label = 1;
                case 1:
                    if (!(rest.byteLength >= module.exports.MAX_CHUNK_SIZE)) return [
                        3,
                        3
                    ];
                    chunkSize = module.exports.MAX_CHUNK_SIZE;
                    nextChunkSize = rest.byteLength - module.exports.MAX_CHUNK_SIZE;
                    if (nextChunkSize > 0 && nextChunkSize < module.exports.MIN_CHUNK_SIZE) chunkSize = Math.ceil(rest.byteLength / 2);
                    chunk = rest.slice(0, chunkSize);
                    return [
                        4,
                        $aIAvL.default.crypto.hash(chunk)
                    ];
                case 2:
                    dataHash = _state.sent();
                    cursor += chunk.byteLength;
                    chunks.push({
                        dataHash: dataHash,
                        minByteRange: cursor - chunk.byteLength,
                        maxByteRange: cursor
                    });
                    rest = rest.slice(chunkSize);
                    return [
                        3,
                        1
                    ];
                case 3:
                    _ = chunks.push;
                    _tmp = {};
                    return [
                        4,
                        $aIAvL.default.crypto.hash(rest)
                    ];
                case 4:
                    _.apply(chunks, [
                        (_tmp.dataHash = _state.sent(), _tmp.minByteRange = cursor, _tmp.maxByteRange = cursor + rest.byteLength, _tmp)
                    ]);
                    return [
                        2,
                        chunks
                    ];
            }
        });
    });
    return $4ba6930c2d9eb0cd$var$_chunkData.apply(this, arguments);
}
module.exports.chunkData = $4ba6930c2d9eb0cd$var$chunkData;
function $4ba6930c2d9eb0cd$var$generateLeaves(chunks) {
    return $4ba6930c2d9eb0cd$var$_generateLeaves.apply(this, arguments);
}
function $4ba6930c2d9eb0cd$var$_generateLeaves() {
    $4ba6930c2d9eb0cd$var$_generateLeaves = (0, $byzP8._)(function(chunks) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                Promise.all(chunks.map(function() {
                    var _ref = (0, $byzP8._)(function(param) {
                        var dataHash, minByteRange, maxByteRange, _tmp;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    dataHash = param.dataHash, minByteRange = param.minByteRange, maxByteRange = param.maxByteRange;
                                    _tmp = {
                                        type: "leaf"
                                    };
                                    return [
                                        4,
                                        Promise.all([
                                            $4ba6930c2d9eb0cd$var$hash(dataHash),
                                            $4ba6930c2d9eb0cd$var$hash($4ba6930c2d9eb0cd$var$intToBuffer(maxByteRange))
                                        ])
                                    ];
                                case 1:
                                    return [
                                        4,
                                        $4ba6930c2d9eb0cd$var$hash.apply(void 0, [
                                            _state.sent()
                                        ])
                                    ];
                                case 2:
                                    return [
                                        2,
                                        (_tmp.id = _state.sent(), _tmp.dataHash = dataHash, _tmp.minByteRange = minByteRange, _tmp.maxByteRange = maxByteRange, _tmp)
                                    ];
                            }
                        });
                    });
                    return function(_) {
                        return _ref.apply(this, arguments);
                    };
                }()))
            ];
        });
    });
    return $4ba6930c2d9eb0cd$var$_generateLeaves.apply(this, arguments);
}
module.exports.generateLeaves = $4ba6930c2d9eb0cd$var$generateLeaves;
function $4ba6930c2d9eb0cd$var$computeRootHash(data) {
    return $4ba6930c2d9eb0cd$var$_computeRootHash.apply(this, arguments);
}
function $4ba6930c2d9eb0cd$var$_computeRootHash() {
    $4ba6930c2d9eb0cd$var$_computeRootHash = /**
 * Builds an arweave merkle tree and gets the root hash for the given input.
 */ (0, $byzP8._)(function(data) {
        var rootNode;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$generateTree(data)
                    ];
                case 1:
                    rootNode = _state.sent();
                    return [
                        2,
                        rootNode.id
                    ];
            }
        });
    });
    return $4ba6930c2d9eb0cd$var$_computeRootHash.apply(this, arguments);
}
module.exports.computeRootHash = $4ba6930c2d9eb0cd$var$computeRootHash;
function $4ba6930c2d9eb0cd$var$generateTree(data) {
    return $4ba6930c2d9eb0cd$var$_generateTree.apply(this, arguments);
}
function $4ba6930c2d9eb0cd$var$_generateTree() {
    $4ba6930c2d9eb0cd$var$_generateTree = (0, $byzP8._)(function(data) {
        var rootNode;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$chunkData(data)
                    ];
                case 1:
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$generateLeaves.apply(void 0, [
                            _state.sent()
                        ])
                    ];
                case 2:
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$buildLayers.apply(void 0, [
                            _state.sent()
                        ])
                    ];
                case 3:
                    rootNode = _state.sent();
                    return [
                        2,
                        rootNode
                    ];
            }
        });
    });
    return $4ba6930c2d9eb0cd$var$_generateTree.apply(this, arguments);
}
module.exports.generateTree = $4ba6930c2d9eb0cd$var$generateTree;
function $4ba6930c2d9eb0cd$var$generateTransactionChunks(data) {
    return $4ba6930c2d9eb0cd$var$_generateTransactionChunks.apply(this, arguments);
}
function $4ba6930c2d9eb0cd$var$_generateTransactionChunks() {
    $4ba6930c2d9eb0cd$var$_generateTransactionChunks = /**
 * Generates the data_root, chunks & proofs
 * needed for a transaction.
 *
 * This also checks if the last chunk is a zero-length
 * chunk and discards that chunk and proof if so.
 * (we do not need to upload this zero length chunk)
 *
 * @param data
 */ (0, $byzP8._)(function(data) {
        var chunks, leaves, root, proofs, lastChunk;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$chunkData(data)
                    ];
                case 1:
                    chunks = _state.sent();
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$generateLeaves(chunks)
                    ];
                case 2:
                    leaves = _state.sent();
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$buildLayers(leaves)
                    ];
                case 3:
                    root = _state.sent();
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$generateProofs(root)
                    ];
                case 4:
                    proofs = _state.sent();
                    lastChunk = chunks.slice(-1)[0];
                    if (lastChunk.maxByteRange - lastChunk.minByteRange === 0) {
                        chunks.splice(chunks.length - 1, 1);
                        proofs.splice(proofs.length - 1, 1);
                    }
                    return [
                        2,
                        {
                            data_root: root.id,
                            chunks: chunks,
                            proofs: proofs
                        }
                    ];
            }
        });
    });
    return $4ba6930c2d9eb0cd$var$_generateTransactionChunks.apply(this, arguments);
}
module.exports.generateTransactionChunks = $4ba6930c2d9eb0cd$var$generateTransactionChunks;
function $4ba6930c2d9eb0cd$var$buildLayers(nodes) {
    return $4ba6930c2d9eb0cd$var$_buildLayers.apply(this, arguments);
}
function $4ba6930c2d9eb0cd$var$_buildLayers() {
    $4ba6930c2d9eb0cd$var$_buildLayers = /**
 * Starting with the bottom layer of leaf nodes, hash every second pair
 * into a new branch node, push those branch nodes onto a new layer,
 * and then recurse, building up the tree to it's root, where the
 * layer only consists of two items.
 */ (0, $byzP8._)(function(nodes) {
        var level, root, nextLayer, i, _;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    level = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 0;
                    // If there is only 1 node left, this is going to be the root node
                    if (nodes.length < 2) {
                        root = nodes[0];
                        // console.log("Root layer", root);
                        return [
                            2,
                            root
                        ];
                    }
                    nextLayer = [];
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < nodes.length)) return [
                        3,
                        4
                    ];
                    _ = nextLayer.push;
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$hashBranch(nodes[i], nodes[i + 1])
                    ];
                case 2:
                    _.apply(nextLayer, [
                        _state.sent()
                    ]);
                    _state.label = 3;
                case 3:
                    i += 2;
                    return [
                        3,
                        1
                    ];
                case 4:
                    // console.log("Layer", nextLayer);
                    return [
                        2,
                        $4ba6930c2d9eb0cd$var$buildLayers(nextLayer, level + 1)
                    ];
            }
        });
    });
    return $4ba6930c2d9eb0cd$var$_buildLayers.apply(this, arguments);
}
module.exports.buildLayers = $4ba6930c2d9eb0cd$var$buildLayers;
/**
 * Recursively search through all branches of the tree,
 * and generate a proof for each leaf node.
 */ function $4ba6930c2d9eb0cd$var$generateProofs(root) {
    var proofs = $4ba6930c2d9eb0cd$var$resolveBranchProofs(root);
    if (!Array.isArray(proofs)) return [
        proofs
    ];
    return $4ba6930c2d9eb0cd$var$arrayFlatten(proofs);
}
module.exports.generateProofs = $4ba6930c2d9eb0cd$var$generateProofs;
function $4ba6930c2d9eb0cd$var$resolveBranchProofs(node) {
    var proof = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Uint8Array(), depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (node.type == "leaf") return {
        offset: node.maxByteRange - 1,
        proof: (0, $dsrYt.concatBuffers)([
            proof,
            node.dataHash,
            $4ba6930c2d9eb0cd$var$intToBuffer(node.maxByteRange)
        ])
    };
    if (node.type == "branch") {
        var partialProof = (0, $dsrYt.concatBuffers)([
            proof,
            node.leftChild.id,
            node.rightChild.id,
            $4ba6930c2d9eb0cd$var$intToBuffer(node.byteRange)
        ]);
        return [
            $4ba6930c2d9eb0cd$var$resolveBranchProofs(node.leftChild, partialProof, depth + 1),
            $4ba6930c2d9eb0cd$var$resolveBranchProofs(node.rightChild, partialProof, depth + 1)
        ];
    }
    throw new Error("Unexpected node type");
}
function $4ba6930c2d9eb0cd$var$arrayFlatten(input) {
    var flat = [];
    input.forEach(function(item) {
        var _flat;
        if (Array.isArray(item)) (_flat = flat).push.apply(_flat, (0, $fLnyw._)($4ba6930c2d9eb0cd$var$arrayFlatten(item)));
        else flat.push(item);
    });
    return flat;
}
module.exports.arrayFlatten = $4ba6930c2d9eb0cd$var$arrayFlatten;
function $4ba6930c2d9eb0cd$var$hashBranch(left, right) {
    return $4ba6930c2d9eb0cd$var$_hashBranch.apply(this, arguments);
}
function $4ba6930c2d9eb0cd$var$_hashBranch() {
    $4ba6930c2d9eb0cd$var$_hashBranch = (0, $byzP8._)(function(left, right) {
        var branch, _tmp, _tmp1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!right) return [
                        2,
                        left
                    ];
                    _tmp = {
                        type: "branch"
                    };
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$hash(left.id)
                    ];
                case 1:
                    _tmp1 = [
                        _state.sent()
                    ];
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$hash(right.id)
                    ];
                case 2:
                    _tmp1 = _tmp1.concat(_state.sent());
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$hash($4ba6930c2d9eb0cd$var$intToBuffer(left.maxByteRange))
                    ];
                case 3:
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$hash.apply(void 0, [
                            _tmp1.concat([
                                _state.sent()
                            ])
                        ])
                    ];
                case 4:
                    branch = (_tmp.id = _state.sent(), _tmp.byteRange = left.maxByteRange, _tmp.maxByteRange = right.maxByteRange, _tmp.leftChild = left, _tmp.rightChild = right, _tmp);
                    return [
                        2,
                        branch
                    ];
            }
        });
    });
    return $4ba6930c2d9eb0cd$var$_hashBranch.apply(this, arguments);
}
function $4ba6930c2d9eb0cd$var$hash(data) {
    return $4ba6930c2d9eb0cd$var$_hash.apply(this, arguments);
}
function $4ba6930c2d9eb0cd$var$_hash() {
    $4ba6930c2d9eb0cd$var$_hash = (0, $byzP8._)(function(data) {
        var _;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (Array.isArray(data)) data = $aIAvL.default.utils.concatBuffers(data);
                    _ = Uint8Array.bind;
                    return [
                        4,
                        $aIAvL.default.crypto.hash(data)
                    ];
                case 1:
                    return [
                        2,
                        new (_.apply(Uint8Array, [
                            void 0,
                            _state.sent()
                        ]))
                    ];
            }
        });
    });
    return $4ba6930c2d9eb0cd$var$_hash.apply(this, arguments);
}
function $4ba6930c2d9eb0cd$var$intToBuffer(note) {
    var buffer = new Uint8Array($4ba6930c2d9eb0cd$var$NOTE_SIZE);
    for(var i = buffer.length - 1; i >= 0; i--){
        var byte = note % 256;
        buffer[i] = byte;
        note = (note - byte) / 256;
    }
    return buffer;
}
module.exports.intToBuffer = $4ba6930c2d9eb0cd$var$intToBuffer;
function $4ba6930c2d9eb0cd$var$bufferToInt(buffer) {
    var value = 0;
    for(var i = 0; i < buffer.length; i++){
        value *= 256;
        value += buffer[i];
    }
    return value;
}
module.exports.bufferToInt = $4ba6930c2d9eb0cd$var$bufferToInt;
var $4ba6930c2d9eb0cd$var$arrayCompare = function(a, b) {
    return a.every(function(value, index) {
        return b[index] === value;
    });
};
module.exports.arrayCompare = $4ba6930c2d9eb0cd$var$arrayCompare;
function $4ba6930c2d9eb0cd$var$validatePath(id, dest, leftBound, rightBound, path) {
    return $4ba6930c2d9eb0cd$var$_validatePath.apply(this, arguments);
}
function $4ba6930c2d9eb0cd$var$_validatePath() {
    $4ba6930c2d9eb0cd$var$_validatePath = (0, $byzP8._)(function(id, dest, leftBound, rightBound, path) {
        var pathData, endOffsetBuffer, pathDataHash, _tmp, result, left, right, offsetBuffer, offset, remainder, pathHash, _tmp1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (rightBound <= 0) return [
                        2,
                        false
                    ];
                    if (dest >= rightBound) return [
                        2,
                        $4ba6930c2d9eb0cd$var$validatePath(id, 0, rightBound - 1, rightBound, path)
                    ];
                    if (dest < 0) return [
                        2,
                        $4ba6930c2d9eb0cd$var$validatePath(id, 0, 0, rightBound, path)
                    ];
                    if (!(path.length == $4ba6930c2d9eb0cd$var$HASH_SIZE + $4ba6930c2d9eb0cd$var$NOTE_SIZE)) return [
                        3,
                        4
                    ];
                    pathData = path.slice(0, $4ba6930c2d9eb0cd$var$HASH_SIZE);
                    endOffsetBuffer = path.slice(pathData.length, pathData.length + $4ba6930c2d9eb0cd$var$NOTE_SIZE);
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$hash(pathData)
                    ];
                case 1:
                    _tmp = [
                        _state.sent()
                    ];
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$hash(endOffsetBuffer)
                    ];
                case 2:
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$hash.apply(void 0, [
                            _tmp.concat([
                                _state.sent()
                            ])
                        ])
                    ];
                case 3:
                    pathDataHash = _state.sent();
                    result = (0, module.exports.arrayCompare)(id, pathDataHash);
                    if (result) return [
                        2,
                        {
                            offset: rightBound - 1,
                            leftBound: leftBound,
                            rightBound: rightBound,
                            chunkSize: rightBound - leftBound
                        }
                    ];
                    return [
                        2,
                        false
                    ];
                case 4:
                    left = path.slice(0, $4ba6930c2d9eb0cd$var$HASH_SIZE);
                    right = path.slice(left.length, left.length + $4ba6930c2d9eb0cd$var$HASH_SIZE);
                    offsetBuffer = path.slice(left.length + right.length, left.length + right.length + $4ba6930c2d9eb0cd$var$NOTE_SIZE);
                    offset = $4ba6930c2d9eb0cd$var$bufferToInt(offsetBuffer);
                    remainder = path.slice(left.length + right.length + offsetBuffer.length);
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$hash(left)
                    ];
                case 5:
                    _tmp1 = [
                        _state.sent()
                    ];
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$hash(right)
                    ];
                case 6:
                    _tmp1 = _tmp1.concat(_state.sent());
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$hash(offsetBuffer)
                    ];
                case 7:
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$hash.apply(void 0, [
                            _tmp1.concat([
                                _state.sent()
                            ])
                        ])
                    ];
                case 8:
                    pathHash = _state.sent();
                    if (!(0, module.exports.arrayCompare)(id, pathHash)) return [
                        3,
                        12
                    ];
                    if (!(dest < offset)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$validatePath(left, dest, leftBound, Math.min(rightBound, offset), remainder)
                    ];
                case 9:
                    return [
                        2,
                        _state.sent()
                    ];
                case 10:
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$validatePath(right, dest, Math.max(leftBound, offset), rightBound, remainder)
                    ];
                case 11:
                    return [
                        2,
                        _state.sent()
                    ];
                case 12:
                    return [
                        2,
                        false
                    ];
            }
        });
    });
    return $4ba6930c2d9eb0cd$var$_validatePath.apply(this, arguments);
}
module.exports.validatePath = $4ba6930c2d9eb0cd$var$validatePath;
function $4ba6930c2d9eb0cd$var$debug(proof) {
    return $4ba6930c2d9eb0cd$var$_debug.apply(this, arguments);
}
function $4ba6930c2d9eb0cd$var$_debug() {
    $4ba6930c2d9eb0cd$var$_debug = /**
 * Inspect an arweave chunk proof.
 * Takes proof, parses, reads and displays the values for console logging.
 * One proof section per line
 * Format: left,right,offset => hash
 */ (0, $byzP8._)(function(proof) {
        var output, left, right, offsetBuffer, offset, remainder, pathHash, _tmp, updatedOutput;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    output = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "";
                    if (proof.byteLength < 1) return [
                        2,
                        output
                    ];
                    left = proof.slice(0, $4ba6930c2d9eb0cd$var$HASH_SIZE);
                    right = proof.slice(left.length, left.length + $4ba6930c2d9eb0cd$var$HASH_SIZE);
                    offsetBuffer = proof.slice(left.length + right.length, left.length + right.length + $4ba6930c2d9eb0cd$var$NOTE_SIZE);
                    offset = $4ba6930c2d9eb0cd$var$bufferToInt(offsetBuffer);
                    remainder = proof.slice(left.length + right.length + offsetBuffer.length);
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$hash(left)
                    ];
                case 1:
                    _tmp = [
                        _state.sent()
                    ];
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$hash(right)
                    ];
                case 2:
                    _tmp = _tmp.concat(_state.sent());
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$hash(offsetBuffer)
                    ];
                case 3:
                    return [
                        4,
                        $4ba6930c2d9eb0cd$var$hash.apply(void 0, [
                            _tmp.concat([
                                _state.sent()
                            ])
                        ])
                    ];
                case 4:
                    pathHash = _state.sent();
                    updatedOutput = "".concat(output, "\n").concat(JSON.stringify($4ba6930c2d9eb0cd$require$Buffer.from(left)), ",").concat(JSON.stringify($4ba6930c2d9eb0cd$require$Buffer.from(right)), ",").concat(offset, " => ").concat(JSON.stringify(pathHash));
                    return [
                        2,
                        $4ba6930c2d9eb0cd$var$debug(remainder, updatedOutput)
                    ];
            }
        });
    });
    return $4ba6930c2d9eb0cd$var$_debug.apply(this, arguments);
}
module.exports.debug = $4ba6930c2d9eb0cd$var$debug;

});
parcelRequire.register("fLnyw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b79d847807e3ac29$export$1b5e630bc3aea29f; });

var $c1J0v = parcelRequire("c1J0v");

var $2uHzb = parcelRequire("2uHzb");

var $cKglA = parcelRequire("cKglA");

var $imR8K = parcelRequire("imR8K");
function $b79d847807e3ac29$export$1b5e630bc3aea29f(arr) {
    return (0, $c1J0v._array_without_holes)(arr) || (0, $2uHzb._iterable_to_array)(arr) || (0, $imR8K._unsupported_iterable_to_array)(arr) || (0, $cKglA._non_iterable_spread)();
}

});
parcelRequire.register("c1J0v", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $8c187d86836ebd16$export$7e0947b5ad3404e2; });

var $dkOJL = parcelRequire("dkOJL");
function $8c187d86836ebd16$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $dkOJL._array_like_to_array)(arr);
}

});
parcelRequire.register("dkOJL", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $9b547ff733c97a35$export$79e617b1955a2616; });
function $9b547ff733c97a35$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRequire.register("2uHzb", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $1d102d83300b551e$export$1eb58a6e75231000; });
function $1d102d83300b551e$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRequire.register("cKglA", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $9476761b01b79dcb$export$e6f3c4780d19eb2b; });
function $9476761b01b79dcb$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRequire.register("imR8K", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $d5f380987878722e$export$a5be06335b3a083c; });

var $dkOJL = parcelRequire("dkOJL");
function $d5f380987878722e$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $dkOJL._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $dkOJL._array_like_to_array)(o, minLen);
}

});




parcelRequire.register("6xSlJ", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TransactionUploader = void 0;

var $ap7ys = parcelRequire("ap7ys");

var $dsrYt = parcelRequire("dsrYt");

var $gSbNG = parcelRequire("gSbNG");

var $6uGA3 = parcelRequire("6uGA3");
// Maximum amount of chunks we will upload in the body.
var $4c3ffbd005f45f53$var$MAX_CHUNKS_IN_BODY = 1;
// We assume these errors are intermitment and we can try again after a delay:
// - not_joined
// - timeout
// - data_root_not_found (we may have hit a node that just hasn't seen it yet)
// - exceeds_disk_pool_size_limit
// We also try again after any kind of unexpected network errors
// Errors from /chunk we should never try and continue on.
var $4c3ffbd005f45f53$var$FATAL_CHUNK_UPLOAD_ERRORS = [
    "invalid_json",
    "chunk_too_big",
    "data_path_too_big",
    "offset_too_big",
    "data_size_too_big",
    "chunk_proof_ratio_not_attractive",
    "invalid_proof"
];
// Amount we will delay on receiving an error response but do want to continue.
var $4c3ffbd005f45f53$var$ERROR_DELAY = 40000;
var $4c3ffbd005f45f53$var$TransactionUploader = /*#__PURE__*/ function() {
    function TransactionUploader(api, transaction) {
        (0, $978gY._)(this, TransactionUploader);
        (0, $dxWQo._)(this, "api", void 0);
        (0, $dxWQo._)(this, "chunkIndex", 0);
        (0, $dxWQo._)(this, "txPosted", false);
        (0, $dxWQo._)(this, "transaction", void 0);
        (0, $dxWQo._)(this, "lastRequestTimeEnd", 0);
        (0, $dxWQo._)(this, "totalErrors", 0) // Not serialized.
        ;
        (0, $dxWQo._)(this, "data", void 0);
        (0, $dxWQo._)(this, "lastResponseStatus", 0);
        (0, $dxWQo._)(this, "lastResponseError", "");
        this.api = api;
        if (!transaction.id) throw new Error("Transaction is not signed");
        if (!transaction.chunks) throw new Error("Transaction chunks not prepared");
        // Make a copy of transaction, zeroing the data so we can serialize.
        this.data = transaction.data;
        this.transaction = new $ap7ys.default(Object.assign({}, transaction, {
            data: new Uint8Array(0)
        }));
    }
    (0, $kry2a._)(TransactionUploader, [
        {
            key: "isComplete",
            get: function get() {
                return this.txPosted && this.chunkIndex === this.transaction.chunks.chunks.length;
            }
        },
        {
            key: "totalChunks",
            get: function get() {
                return this.transaction.chunks.chunks.length;
            }
        },
        {
            key: "uploadedChunks",
            get: function get() {
                return this.chunkIndex;
            }
        },
        {
            key: "pctComplete",
            get: function get() {
                return Math.trunc(this.uploadedChunks / this.totalChunks * 100);
            }
        },
        {
            key: "uploadChunk",
            value: /**
     * Uploads the next part of the transaction.
     * On the first call this posts the transaction
     * itself and on any subsequent calls uploads the
     * next chunk until it completes.
     */ function uploadChunk(chunkIndex_) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var delay, chunk, chunkOk, resp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.isComplete) throw new Error("Upload is already complete");
                                if (_this.lastResponseError !== "") _this.totalErrors++;
                                else _this.totalErrors = 0;
                                // We have been trying for about an hour receiving an
                                // error every time, so eventually bail.
                                if (_this.totalErrors === 100) throw new Error("Unable to complete upload: ".concat(_this.lastResponseStatus, ": ").concat(_this.lastResponseError));
                                delay = _this.lastResponseError === "" ? 0 : Math.max(_this.lastRequestTimeEnd + $4c3ffbd005f45f53$var$ERROR_DELAY - Date.now(), $4c3ffbd005f45f53$var$ERROR_DELAY);
                                if (!(delay > 0)) return [
                                    3,
                                    2
                                ];
                                // Jitter delay bcoz networks, subtract up to 30% from 40 seconds
                                delay = delay - delay * Math.random() * 0.3;
                                return [
                                    4,
                                    new Promise(function(res) {
                                        return setTimeout(res, delay);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                _this.lastResponseError = "";
                                if (!!_this.txPosted) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.postTransaction()
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                if (chunkIndex_) _this.chunkIndex = chunkIndex_;
                                chunk = _this.transaction.getChunk(chunkIndex_ || _this.chunkIndex, _this.data);
                                return [
                                    4,
                                    (0, $6uGA3.validatePath)(_this.transaction.chunks.data_root, parseInt(chunk.offset), 0, parseInt(chunk.data_size), $dsrYt.b64UrlToBuffer(chunk.data_path))
                                ];
                            case 5:
                                chunkOk = _state.sent();
                                if (!chunkOk) throw new Error("Unable to validate chunk ".concat(_this.chunkIndex));
                                return [
                                    4,
                                    _this.api.post("chunk", _this.transaction.getChunk(_this.chunkIndex, _this.data)).catch(function(e) {
                                        console.error(e.message);
                                        return {
                                            status: -1,
                                            data: {
                                                error: e.message
                                            }
                                        };
                                    })
                                ];
                            case 6:
                                resp = _state.sent();
                                _this.lastRequestTimeEnd = Date.now();
                                _this.lastResponseStatus = resp.status;
                                if (_this.lastResponseStatus == 200) _this.chunkIndex++;
                                else {
                                    _this.lastResponseError = (0, $gSbNG.getError)(resp);
                                    if ($4c3ffbd005f45f53$var$FATAL_CHUNK_UPLOAD_ERRORS.includes(_this.lastResponseError)) throw new Error("Fatal error uploading chunk ".concat(_this.chunkIndex, ": ").concat(_this.lastResponseError));
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    chunkIndex: this.chunkIndex,
                    transaction: this.transaction,
                    lastRequestTimeEnd: this.lastRequestTimeEnd,
                    lastResponseStatus: this.lastResponseStatus,
                    lastResponseError: this.lastResponseError,
                    txPosted: this.txPosted
                };
            }
        },
        {
            key: "postTransaction",
            value: // POST to /tx
            function postTransaction() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var uploadInBody, resp, resp1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                uploadInBody = _this.totalChunks <= $4c3ffbd005f45f53$var$MAX_CHUNKS_IN_BODY;
                                if (!uploadInBody) return [
                                    3,
                                    2
                                ];
                                // Post the transaction with data.
                                _this.transaction.data = _this.data;
                                return [
                                    4,
                                    _this.api.post("tx", _this.transaction).catch(function(e) {
                                        console.error(e);
                                        return {
                                            status: -1,
                                            data: {
                                                error: e.message
                                            }
                                        };
                                    })
                                ];
                            case 1:
                                resp = _state.sent();
                                _this.lastRequestTimeEnd = Date.now();
                                _this.lastResponseStatus = resp.status;
                                _this.transaction.data = new Uint8Array(0);
                                if (resp.status >= 200 && resp.status < 300) {
                                    // We are complete.
                                    _this.txPosted = true;
                                    _this.chunkIndex = $4c3ffbd005f45f53$var$MAX_CHUNKS_IN_BODY;
                                    return [
                                        2
                                    ];
                                }
                                _this.lastResponseError = (0, $gSbNG.getError)(resp);
                                throw new Error("Unable to upload transaction: ".concat(resp.status, ", ").concat(_this.lastResponseError));
                            case 2:
                                return [
                                    4,
                                    _this.api.post("tx", _this.transaction)
                                ];
                            case 3:
                                resp1 = _state.sent();
                                _this.lastRequestTimeEnd = Date.now();
                                _this.lastResponseStatus = resp1.status;
                                if (!(resp1.status >= 200 && resp1.status < 300)) {
                                    _this.lastResponseError = (0, $gSbNG.getError)(resp1);
                                    throw new Error("Unable to upload transaction: ".concat(resp1.status, ", ").concat(_this.lastResponseError));
                                }
                                _this.txPosted = true;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "fromSerialized",
            value: /**
     * Reconstructs an upload from its serialized state and data.
     * Checks if data matches the expected data_root.
     *
     * @param serialized
     * @param data
     */ function fromSerialized(api, serialized, data) {
                return (0, $byzP8._)(function() {
                    var transaction, upload;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!serialized || typeof serialized.chunkIndex !== "number" || typeof serialized.transaction !== "object") throw new Error("Serialized object does not match expected format.");
                                transaction = new $ap7ys.default(serialized.transaction);
                                if (!!transaction.chunks) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    transaction.prepareChunks(data)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                upload = new TransactionUploader(api, transaction);
                                // Copy the serialized upload information, and data passed in.
                                upload.chunkIndex = serialized.chunkIndex;
                                upload.lastRequestTimeEnd = serialized.lastRequestTimeEnd;
                                upload.lastResponseError = serialized.lastResponseError;
                                upload.lastResponseStatus = serialized.lastResponseStatus;
                                upload.txPosted = serialized.txPosted;
                                upload.data = data;
                                if (upload.transaction.data_root !== serialized.transaction.data_root) throw new Error("Data mismatch: Uploader doesn't match provided data.");
                                return [
                                    2,
                                    upload
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fromTransactionId",
            value: /**
     * Reconstruct an upload from the tx metadata, ie /tx/<id>.
     *
     * @param api
     * @param id
     * @param data
     */ function fromTransactionId(api, id) {
                return (0, $byzP8._)(function() {
                    var resp, transaction, serialized;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    api.get("tx/".concat(id))
                                ];
                            case 1:
                                resp = _state.sent();
                                if (resp.status !== 200) throw new Error("Tx ".concat(id, " not found: ").concat(resp.status));
                                transaction = resp.data;
                                transaction.data = new Uint8Array(0);
                                serialized = {
                                    txPosted: true,
                                    chunkIndex: 0,
                                    lastResponseError: "",
                                    lastRequestTimeEnd: 0,
                                    lastResponseStatus: 0,
                                    transaction: transaction
                                };
                                return [
                                    2,
                                    serialized
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return TransactionUploader;
}();
module.exports.TransactionUploader = $4c3ffbd005f45f53$var$TransactionUploader;

});

parcelRequire.register("94j2z", function(module, exports) {
var $69a341d181fbab07$export$2e2bcd8739ae039 = {};

});


parcelRequire.register("7fv7J", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dsrYt = parcelRequire("dsrYt");
parcelRequire("94j2z");
var $5472139d1bf59f8d$var$Wallets = /*#__PURE__*/ function() {
    function Wallets(api, crypto) {
        (0, $978gY._)(this, Wallets);
        (0, $dxWQo._)(this, "api", void 0);
        (0, $dxWQo._)(this, "crypto", void 0);
        this.api = api;
        this.crypto = crypto;
    }
    (0, $kry2a._)(Wallets, [
        {
            /**
     * Get the wallet balance for the given address.
     *
     * @param {string} address - The arweave address to get the balance for.
     *
     * @returns {Promise<string>} - Promise which resolves with a winston string balance.
     */ key: "getBalance",
            value: function getBalance(address) {
                return this.api.get("wallet/".concat(address, "/balance")).then(function(response) {
                    return response.data;
                });
            }
        },
        {
            /**
     * Get the last transaction ID for the given wallet address.
     *
     * @param {string} address - The arweave address to get the transaction for.
     *
     * @returns {Promise<string>} - Promise which resolves with a transaction ID.
     */ key: "getLastTransactionID",
            value: function getLastTransactionID(address) {
                return this.api.get("wallet/".concat(address, "/last_tx")).then(function(response) {
                    return response.data;
                });
            }
        },
        {
            key: "generate",
            value: function generate() {
                return this.crypto.generateJWK();
            }
        },
        {
            key: "jwkToAddress",
            value: function jwkToAddress(jwk) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        if (!jwk || jwk === "use_wallet") return [
                            2,
                            _this.getAddress()
                        ];
                        else return [
                            2,
                            _this.getAddress(jwk)
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "getAddress",
            value: function getAddress(jwk) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(!jwk || jwk === "use_wallet")) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                // @ts-ignore
                                return [
                                    4,
                                    arweaveWallet.connect([
                                        "ACCESS_ADDRESS"
                                    ])
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                // @ts-ignore
                                return [
                                    2,
                                    arweaveWallet.getActiveAddress()
                                ];
                            case 5:
                                return [
                                    2,
                                    _this.ownerToAddress(jwk.n)
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "ownerToAddress",
            value: function ownerToAddress(owner) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = $dsrYt.bufferTob64Url;
                                return [
                                    4,
                                    _this.crypto.hash($dsrYt.b64UrlToBuffer(owner))
                                ];
                            case 1:
                                return [
                                    2,
                                    _.apply($dsrYt, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Wallets;
}();
module.exports.default = $5472139d1bf59f8d$var$Wallets;

});

parcelRequire.register("lVA0N", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SiloResource = void 0;

var $dsrYt = parcelRequire("dsrYt");
var $ff6adb08199bd657$var$Silo = /*#__PURE__*/ function() {
    function Silo(api, crypto, transactions) {
        (0, $978gY._)(this, Silo);
        (0, $dxWQo._)(this, "api", void 0);
        (0, $dxWQo._)(this, "crypto", void 0);
        (0, $dxWQo._)(this, "transactions", void 0);
        this.api = api;
        this.crypto = crypto;
        this.transactions = transactions;
    }
    (0, $kry2a._)(Silo, [
        {
            key: "get",
            value: function get(siloURI) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var resource, ids, transaction, encrypted;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!siloURI) throw new Error("No Silo URI specified");
                                return [
                                    4,
                                    _this.parseUri(siloURI)
                                ];
                            case 1:
                                resource = _state.sent();
                                return [
                                    4,
                                    _this.transactions.search("Silo-Name", resource.getAccessKey())
                                ];
                            case 2:
                                ids = _state.sent();
                                if (ids.length == 0) throw new Error("No data could be found for the Silo URI: ".concat(siloURI));
                                return [
                                    4,
                                    _this.transactions.get(ids[0])
                                ];
                            case 3:
                                transaction = _state.sent();
                                if (!transaction) throw new Error("No data could be found for the Silo URI: ".concat(siloURI));
                                encrypted = transaction.get("data", {
                                    decode: true,
                                    string: false
                                });
                                return [
                                    2,
                                    _this.crypto.decrypt(encrypted, resource.getEncryptionKey())
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "readTransactionData",
            value: function readTransactionData(transaction, siloURI) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var resource, encrypted;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!siloURI) throw new Error("No Silo URI specified");
                                return [
                                    4,
                                    _this.parseUri(siloURI)
                                ];
                            case 1:
                                resource = _state.sent();
                                encrypted = transaction.get("data", {
                                    decode: true,
                                    string: false
                                });
                                return [
                                    2,
                                    _this.crypto.decrypt(encrypted, resource.getEncryptionKey())
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "parseUri",
            value: function parseUri(siloURI) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var parsed, siloName, hashIterations, digest, accessKey, encryptionkey;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                parsed = siloURI.match(/^([a-z0-9-_]+)\.([0-9]+)/i);
                                if (!parsed) throw new Error("Invalid Silo name, must be a name in the format of [a-z0-9]+.[0-9]+, e.g. 'bubble.7'");
                                siloName = parsed[1];
                                hashIterations = Math.pow(2, parseInt(parsed[2]));
                                return [
                                    4,
                                    _this.hash($dsrYt.stringToBuffer(siloName), hashIterations)
                                ];
                            case 1:
                                digest = _state.sent();
                                accessKey = $dsrYt.bufferTob64(digest.slice(0, 15));
                                return [
                                    4,
                                    _this.hash(digest.slice(16, 31), 1)
                                ];
                            case 2:
                                encryptionkey = _state.sent();
                                return [
                                    2,
                                    new $ff6adb08199bd657$var$SiloResource(siloURI, accessKey, encryptionkey)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "hash",
            value: function hash(input, iterations) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var digest, count;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.crypto.hash(input)
                                ];
                            case 1:
                                digest = _state.sent();
                                count = 0;
                                _state.label = 2;
                            case 2:
                                if (!(count < iterations - 1)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    _this.crypto.hash(digest)
                                ];
                            case 3:
                                digest = _state.sent();
                                _state.label = 4;
                            case 4:
                                count++;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    2,
                                    digest
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Silo;
}();
module.exports.default = $ff6adb08199bd657$var$Silo;
var $ff6adb08199bd657$var$SiloResource = /*#__PURE__*/ function() {
    function SiloResource(uri, accessKey, encryptionKey) {
        (0, $978gY._)(this, SiloResource);
        (0, $dxWQo._)(this, "uri", void 0);
        (0, $dxWQo._)(this, "accessKey", void 0);
        (0, $dxWQo._)(this, "encryptionKey", void 0);
        this.uri = uri;
        this.accessKey = accessKey;
        this.encryptionKey = encryptionKey;
    }
    (0, $kry2a._)(SiloResource, [
        {
            key: "getUri",
            value: function getUri() {
                return this.uri;
            }
        },
        {
            key: "getAccessKey",
            value: function getAccessKey() {
                return this.accessKey;
            }
        },
        {
            key: "getEncryptionKey",
            value: function getEncryptionKey() {
                return this.encryptionKey;
            }
        }
    ]);
    return SiloResource;
}();
module.exports.SiloResource = $ff6adb08199bd657$var$SiloResource;

});

parcelRequire.register("jJfLo", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gSbNG = parcelRequire("gSbNG");

var $dsrYt = parcelRequire("dsrYt");
var $e5ce728eb5dbeb24$var$Chunks = /*#__PURE__*/ function() {
    function Chunks(api) {
        (0, $978gY._)(this, Chunks);
        (0, $dxWQo._)(this, "api", void 0);
        this.api = api;
    }
    (0, $kry2a._)(Chunks, [
        {
            key: "getTransactionOffset",
            value: function getTransactionOffset(id) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var resp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.api.get("tx/".concat(id, "/offset"))
                                ];
                            case 1:
                                resp = _state.sent();
                                if (resp.status === 200) return [
                                    2,
                                    resp.data
                                ];
                                throw new Error("Unable to get transaction offset: ".concat((0, $gSbNG.getError)(resp)));
                        }
                    });
                })();
            }
        },
        {
            key: "getChunk",
            value: function getChunk(offset) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var resp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.api.get("chunk/".concat(offset))
                                ];
                            case 1:
                                resp = _state.sent();
                                if (resp.status === 200) return [
                                    2,
                                    resp.data
                                ];
                                throw new Error("Unable to get chunk: ".concat((0, $gSbNG.getError)(resp)));
                        }
                    });
                })();
            }
        },
        {
            key: "getChunkData",
            value: function getChunkData(offset) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var chunk, buf;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getChunk(offset)
                                ];
                            case 1:
                                chunk = _state.sent();
                                buf = $dsrYt.b64UrlToBuffer(chunk.chunk);
                                return [
                                    2,
                                    buf
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "firstChunkOffset",
            value: function firstChunkOffset(offsetResponse) {
                return parseInt(offsetResponse.offset) - parseInt(offsetResponse.size) + 1;
            }
        },
        {
            key: "downloadChunkedData",
            value: function downloadChunkedData(id) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var offsetResponse, size, endOffset, startOffset, data, byte, chunkData, error;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getTransactionOffset(id)
                                ];
                            case 1:
                                offsetResponse = _state.sent();
                                size = parseInt(offsetResponse.size);
                                endOffset = parseInt(offsetResponse.offset);
                                startOffset = endOffset - size + 1;
                                data = new Uint8Array(size);
                                byte = 0;
                                _state.label = 2;
                            case 2:
                                if (!(byte < size)) return [
                                    3,
                                    7
                                ];
                                if (_this.api.config.logging) console.log("[chunk] ".concat(byte, "/").concat(size));
                                chunkData = void 0;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    _this.getChunkData(startOffset + byte)
                                ];
                            case 4:
                                chunkData = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                console.error("[chunk] Failed to fetch chunk at offset ".concat(startOffset + byte));
                                console.error("[chunk] This could indicate that the chunk wasn't uploaded or hasn't yet seeded properly to a particular gateway/node");
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                if (chunkData) {
                                    data.set(chunkData, byte);
                                    byte += chunkData.length;
                                } else throw new Error("Couldn't complete data download at ".concat(byte, "/").concat(size));
                                return [
                                    3,
                                    2
                                ];
                            case 7:
                                return [
                                    2,
                                    data
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Chunks;
}();
module.exports.default = $e5ce728eb5dbeb24$var$Chunks;

});

parcelRequire.register("3E2mQ", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gSbNG = parcelRequire("gSbNG");
parcelRequire("94j2z");
var $2a76f1a2da680a73$var$Blocks = /*#__PURE__*/ function() {
    function Blocks(api, network) {
        (0, $978gY._)(this, Blocks);
        (0, $dxWQo._)(this, "api", void 0);
        (0, $dxWQo._)(this, "network", void 0);
        this.api = api;
        this.network = network;
    }
    (0, $kry2a._)(Blocks, [
        {
            key: "get",
            value: /**
     * Gets a block by its "indep_hash"
     */ function get(indepHash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var response;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.api.get("".concat(Blocks.HASH_ENDPOINT).concat(indepHash))
                                ];
                            case 1:
                                response = _state.sent();
                                if (response.status === 200) return [
                                    2,
                                    response.data
                                ];
                                else {
                                    if (response.status === 404) throw new $gSbNG.default("BLOCK_NOT_FOUND" /* ArweaveErrorType.BLOCK_NOT_FOUND */ );
                                    else throw new Error("Error while loading block data: ".concat(response));
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getByHeight",
            value: /**
     * Gets a block by its "height"
     */ function getByHeight(height) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var response;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.api.get("".concat(Blocks.HEIGHT_ENDPOINT).concat(height))
                                ];
                            case 1:
                                response = _state.sent();
                                if (response.status === 200) return [
                                    2,
                                    response.data
                                ];
                                else {
                                    if (response.status === 404) throw new $gSbNG.default("BLOCK_NOT_FOUND" /* ArweaveErrorType.BLOCK_NOT_FOUND */ );
                                    else throw new Error("Error while loading block data: ".concat(response));
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCurrent",
            value: /**
     * Gets current block data (ie. block with indep_hash = Network.getInfo().current)
     */ function getCurrent() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var current;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.network.getInfo()
                                ];
                            case 1:
                                current = _state.sent().current;
                                return [
                                    4,
                                    _this.get(current)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Blocks;
}();
(0, $dxWQo._)($2a76f1a2da680a73$var$Blocks, "HASH_ENDPOINT", "block/hash/");
(0, $dxWQo._)($2a76f1a2da680a73$var$Blocks, "HEIGHT_ENDPOINT", "block/height/");
module.exports.default = $2a76f1a2da680a73$var$Blocks;

});


parcelRequire.register("1R9a4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultConfig = void 0;
/** exhaustive localhost testing */ var $15a1d8f3d3a5b787$var$isLocal = function(protocol, hostname) {
    var regexLocalIp = /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/;
    var split = hostname.split(".");
    var tld = split[split.length - 1]; // check if subdomain on the localhost
    var localStrings = [
        "localhost",
        "[::1]"
    ];
    return localStrings.includes(hostname) || protocol == "file" || localStrings.includes(tld) || !!hostname.match(regexLocalIp) || !!tld.match(regexLocalIp);
};
/** simplified tests for ip addresses */ var $15a1d8f3d3a5b787$var$isIpAdress = function(host) {
    // an IPv6 location.hostname (and only IPv6 hostnames) must be surrounded by square brackets
    var isIpv6 = host.charAt(0) === "[";
    // Potential speed-up for IPv4 detection:
    // the tld of a domain name cannot be a number (IDN location.hostnames appear to be converted, needs further clarification)
    var regexMatchIpv4 = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
    return !!host.match(regexMatchIpv4) || isIpv6;
};
var $15a1d8f3d3a5b787$var$getDefaultConfig = function(protocol, host) {
    // If we're running in what looks like a local dev environment
    // then default to using arweave.net
    if ($15a1d8f3d3a5b787$var$isLocal(protocol, host)) return {
        protocol: "https",
        host: "arweave.net",
        port: 443
    };
    //check if hostname is an IP address before removing first subdomain
    if (!$15a1d8f3d3a5b787$var$isIpAdress(host)) {
        var split = host.split(".");
        if (split.length >= 3) {
            split.shift();
            var parentDomain = split.join(".");
            return {
                protocol: protocol,
                host: parentDomain
            };
        }
    }
    // there are 2 potential garbage returns here:
    // a non-GW ip address & a non-GW hostname without ArNS. garbage in, garbage out.
    // they should be overridden with user inputs in apiConfig.
    // otherwise we have a valid ip based GW address.
    return {
        protocol: protocol,
        host: host
    };
};
module.exports.getDefaultConfig = $15a1d8f3d3a5b787$var$getDefaultConfig;

});



parcelRequire.register("6BxW3", function(module, exports) {
"use strict";
var $013daf9335952f8a$var$__assign = module.exports && module.exports.__assign || function() {
    $013daf9335952f8a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $013daf9335952f8a$var$__assign.apply(this, arguments);
};
var $013daf9335952f8a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $013daf9335952f8a$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};
module.exports.__esModule = true;
module.exports.fetchTxTag = module.exports.tx = module.exports.all = module.exports.run = void 0;

var $eE6ul = parcelRequire("eE6ul");

var $lenWP = parcelRequire("lenWP");
var $013daf9335952f8a$var$run = function run(query, variables) {
    return $013daf9335952f8a$var$__awaiter(void 0, void 0, void 0, function() {
        var graphql, res;
        return $013daf9335952f8a$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    graphql = JSON.stringify({
                        query: query,
                        variables: variables
                    });
                    return [
                        4 /*yield*/ ,
                        $eE6ul.default.post("https://arweave.net/graphql", graphql, {
                            headers: {
                                "content-type": "application/json"
                            }
                        })
                    ];
                case 1:
                    res = _a.sent().data;
                    return [
                        2 /*return*/ ,
                        res
                    ];
            }
        });
    });
};
module.exports.run = $013daf9335952f8a$var$run;
var $013daf9335952f8a$var$all = function all(query, variables) {
    return $013daf9335952f8a$var$__awaiter(void 0, void 0, void 0, function() {
        var hasNextPage, edges, cursor, res;
        return $013daf9335952f8a$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    hasNextPage = true;
                    edges = [];
                    cursor = "";
                    _a.label = 1;
                case 1:
                    if (!hasNextPage) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        module.exports.run(query, $013daf9335952f8a$var$__assign($013daf9335952f8a$var$__assign({}, variables), {
                            cursor: cursor
                        }))
                    ];
                case 2:
                    res = _a.sent().data.transactions;
                    if (res.edges && res.edges.length) {
                        edges = edges.concat(res.edges);
                        cursor = res.edges[res.edges.length - 1].cursor;
                    }
                    hasNextPage = res.pageInfo.hasNextPage;
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        edges
                    ];
            }
        });
    });
};
module.exports.all = $013daf9335952f8a$var$all;
var $013daf9335952f8a$var$tx = function tx(id) {
    return $013daf9335952f8a$var$__awaiter(void 0, void 0, void 0, function() {
        var isBrowser, cache, res, cache;
        return $013daf9335952f8a$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    isBrowser = typeof window !== "undefined";
                    if (isBrowser) {
                        cache = JSON.parse(localStorage.getItem("gqlCache") || "{}");
                        if (id in cache) return [
                            2 /*return*/ ,
                            JSON.parse(cache[id])
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        module.exports.run($lenWP.default, {
                            id: id
                        })
                    ];
                case 1:
                    res = _a.sent();
                    if (isBrowser && res.data.transaction.block) {
                        cache = JSON.parse(localStorage.getItem("gqlCache") || "{}");
                        cache[id] = res.data.transaction;
                        localStorage.setItem("gqlCache", JSON.stringify(cache));
                    }
                    return [
                        2 /*return*/ ,
                        res.data.transaction
                    ];
            }
        });
    });
};
module.exports.tx = $013daf9335952f8a$var$tx;
var $013daf9335952f8a$var$fetchTxTag = function fetchTxTag(id, name) {
    return $013daf9335952f8a$var$__awaiter(void 0, void 0, void 0, function() {
        var res, tag;
        return $013daf9335952f8a$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        module.exports.tx(id)
                    ];
                case 1:
                    res = _a.sent();
                    tag = res.tags.find(function(tag) {
                        return tag.name === name;
                    });
                    if (tag) return [
                        2 /*return*/ ,
                        tag.value
                    ];
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
module.exports.fetchTxTag = $013daf9335952f8a$var$fetchTxTag;

});
parcelRequire.register("eE6ul", function(module, exports) {

module.exports = (parcelRequire("cAdOu"));

});
parcelRequire.register("cAdOu", function(module, exports) {
"use strict";

var $eN39g = parcelRequire("eN39g");

var $24HFo = parcelRequire("24HFo");

var $f4dPr = parcelRequire("f4dPr");

var $j4T6k = parcelRequire("j4T6k");

var $6vgZO = parcelRequire("6vgZO");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $92938fdb7b0544e2$var$createInstance(defaultConfig) {
    var context = new $f4dPr(defaultConfig);
    var instance = $24HFo($f4dPr.prototype.request, context);
    // Copy axios.prototype to instance
    $eN39g.extend(instance, $f4dPr.prototype, context);
    // Copy context to instance
    $eN39g.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $92938fdb7b0544e2$var$axios = $92938fdb7b0544e2$var$createInstance($6vgZO);
// Expose Axios class to allow class inheritance
$92938fdb7b0544e2$var$axios.Axios = $f4dPr;
// Factory for creating new instances
$92938fdb7b0544e2$var$axios.create = function create(instanceConfig) {
    return $92938fdb7b0544e2$var$createInstance($j4T6k($92938fdb7b0544e2$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$92938fdb7b0544e2$var$axios.Cancel = (parcelRequire("6GdPl"));

$92938fdb7b0544e2$var$axios.CancelToken = (parcelRequire("hV8k8"));

$92938fdb7b0544e2$var$axios.isCancel = (parcelRequire("dre6V"));
// Expose all/spread
$92938fdb7b0544e2$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$92938fdb7b0544e2$var$axios.spread = (parcelRequire("9D2Ce"));

// Expose isAxiosError
$92938fdb7b0544e2$var$axios.isAxiosError = (parcelRequire("bIbGX"));
module.exports = $92938fdb7b0544e2$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $92938fdb7b0544e2$var$axios;

});
parcelRequire.register("eN39g", function(module, exports) {
"use strict";

var $24HFo = parcelRequire("24HFo");
// utils is a library of generic helper functions non-specific to axios
var $ac48157e5f64e683$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $ac48157e5f64e683$var$isArray(val) {
    return $ac48157e5f64e683$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $ac48157e5f64e683$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $ac48157e5f64e683$var$isBuffer(val) {
    return val !== null && !$ac48157e5f64e683$var$isUndefined(val) && val.constructor !== null && !$ac48157e5f64e683$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $ac48157e5f64e683$var$isArrayBuffer(val) {
    return $ac48157e5f64e683$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $ac48157e5f64e683$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $ac48157e5f64e683$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $ac48157e5f64e683$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $ac48157e5f64e683$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $ac48157e5f64e683$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $ac48157e5f64e683$var$isPlainObject(val) {
    if ($ac48157e5f64e683$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $ac48157e5f64e683$var$isDate(val) {
    return $ac48157e5f64e683$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $ac48157e5f64e683$var$isFile(val) {
    return $ac48157e5f64e683$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $ac48157e5f64e683$var$isBlob(val) {
    return $ac48157e5f64e683$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $ac48157e5f64e683$var$isFunction(val) {
    return $ac48157e5f64e683$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $ac48157e5f64e683$var$isStream(val) {
    return $ac48157e5f64e683$var$isObject(val) && $ac48157e5f64e683$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $ac48157e5f64e683$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $ac48157e5f64e683$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $ac48157e5f64e683$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $ac48157e5f64e683$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($ac48157e5f64e683$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $ac48157e5f64e683$var$merge() {
    var assignValue = function assignValue(val, key) {
        if ($ac48157e5f64e683$var$isPlainObject(result[key]) && $ac48157e5f64e683$var$isPlainObject(val)) result[key] = $ac48157e5f64e683$var$merge(result[key], val);
        else if ($ac48157e5f64e683$var$isPlainObject(val)) result[key] = $ac48157e5f64e683$var$merge({}, val);
        else if ($ac48157e5f64e683$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    };
    var result = {};
    for(var i = 0, l = arguments.length; i < l; i++)$ac48157e5f64e683$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $ac48157e5f64e683$var$extend(a, b, thisArg) {
    $ac48157e5f64e683$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $24HFo(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $ac48157e5f64e683$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $ac48157e5f64e683$var$isArray,
    isArrayBuffer: $ac48157e5f64e683$var$isArrayBuffer,
    isBuffer: $ac48157e5f64e683$var$isBuffer,
    isFormData: $ac48157e5f64e683$var$isFormData,
    isArrayBufferView: $ac48157e5f64e683$var$isArrayBufferView,
    isString: $ac48157e5f64e683$var$isString,
    isNumber: $ac48157e5f64e683$var$isNumber,
    isObject: $ac48157e5f64e683$var$isObject,
    isPlainObject: $ac48157e5f64e683$var$isPlainObject,
    isUndefined: $ac48157e5f64e683$var$isUndefined,
    isDate: $ac48157e5f64e683$var$isDate,
    isFile: $ac48157e5f64e683$var$isFile,
    isBlob: $ac48157e5f64e683$var$isBlob,
    isFunction: $ac48157e5f64e683$var$isFunction,
    isStream: $ac48157e5f64e683$var$isStream,
    isURLSearchParams: $ac48157e5f64e683$var$isURLSearchParams,
    isStandardBrowserEnv: $ac48157e5f64e683$var$isStandardBrowserEnv,
    forEach: $ac48157e5f64e683$var$forEach,
    merge: $ac48157e5f64e683$var$merge,
    extend: $ac48157e5f64e683$var$extend,
    trim: $ac48157e5f64e683$var$trim,
    stripBOM: $ac48157e5f64e683$var$stripBOM
};

});
parcelRequire.register("24HFo", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRequire.register("f4dPr", function(module, exports) {
"use strict";

var $eN39g = parcelRequire("eN39g");

var $b4EjJ = parcelRequire("b4EjJ");

var $g53IY = parcelRequire("g53IY");

var $8evHy = parcelRequire("8evHy");

var $j4T6k = parcelRequire("j4T6k");

var $hluHE = parcelRequire("hluHE");
var $af81f4cd91939737$var$validators = $hluHE.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $af81f4cd91939737$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $g53IY(),
        response: new $g53IY()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $af81f4cd91939737$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $j4T6k(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $hluHE.assertOptions(transitional, {
        silentJSONParsing: $af81f4cd91939737$var$validators.transitional($af81f4cd91939737$var$validators.boolean, "1.0.0"),
        forcedJSONParsing: $af81f4cd91939737$var$validators.transitional($af81f4cd91939737$var$validators.boolean, "1.0.0"),
        clarifyTimeoutError: $af81f4cd91939737$var$validators.transitional($af81f4cd91939737$var$validators.boolean, "1.0.0")
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $8evHy,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $8evHy(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$af81f4cd91939737$var$Axios.prototype.getUri = function getUri(config) {
    config = $j4T6k(this.defaults, config);
    return $b4EjJ(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$eN39g.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $af81f4cd91939737$var$Axios.prototype[method] = function(url, config) {
        return this.request($j4T6k(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$eN39g.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $af81f4cd91939737$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($j4T6k(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $af81f4cd91939737$var$Axios;

});
parcelRequire.register("b4EjJ", function(module, exports) {
"use strict";

var $eN39g = parcelRequire("eN39g");
function $80ff579544383909$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($eN39g.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $eN39g.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($eN39g.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $eN39g.forEach(val, function parseValue(v) {
                if ($eN39g.isDate(v)) v = v.toISOString();
                else if ($eN39g.isObject(v)) v = JSON.stringify(v);
                parts.push($80ff579544383909$var$encode(key) + "=" + $80ff579544383909$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRequire.register("g53IY", function(module, exports) {
"use strict";

var $eN39g = parcelRequire("eN39g");
function $bb50008a77e8e280$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $bb50008a77e8e280$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $bb50008a77e8e280$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $bb50008a77e8e280$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $eN39g.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $bb50008a77e8e280$var$InterceptorManager;

});

parcelRequire.register("8evHy", function(module, exports) {
"use strict";

var $eN39g = parcelRequire("eN39g");

var $bWaTs = parcelRequire("bWaTs");

var $dre6V = parcelRequire("dre6V");

var $6vgZO = parcelRequire("6vgZO");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $5fe838ceeb069b0e$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $5fe838ceeb069b0e$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $bWaTs.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $eN39g.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $eN39g.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $6vgZO.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $5fe838ceeb069b0e$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $bWaTs.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$dre6V(reason)) {
            $5fe838ceeb069b0e$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $bWaTs.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRequire.register("bWaTs", function(module, exports) {
"use strict";

var $eN39g = parcelRequire("eN39g");

var $6vgZO = parcelRequire("6vgZO");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $6vgZO;
    /*eslint no-param-reassign:0*/ $eN39g.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRequire.register("6vgZO", function(module, exports) {

var $aqbQf = parcelRequire("aqbQf");
"use strict";

var $eN39g = parcelRequire("eN39g");

var $lyStj = parcelRequire("lyStj");

var $jnTaS = parcelRequire("jnTaS");
var $4bc2d264429048af$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $4bc2d264429048af$var$setContentTypeIfUnset(headers, value) {
    if (!$eN39g.isUndefined(headers) && $eN39g.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $4bc2d264429048af$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("aNSvO"));
    else if (typeof $aqbQf !== "undefined" && Object.prototype.toString.call($aqbQf) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("aNSvO"));
    return adapter;
}
function $4bc2d264429048af$var$stringifySafely(rawValue, parser, encoder) {
    if ($eN39g.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $eN39g.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $4bc2d264429048af$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $4bc2d264429048af$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $lyStj(headers, "Accept");
            $lyStj(headers, "Content-Type");
            if ($eN39g.isFormData(data) || $eN39g.isArrayBuffer(data) || $eN39g.isBuffer(data) || $eN39g.isStream(data) || $eN39g.isFile(data) || $eN39g.isBlob(data)) return data;
            if ($eN39g.isArrayBufferView(data)) return data.buffer;
            if ($eN39g.isURLSearchParams(data)) {
                $4bc2d264429048af$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($eN39g.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $4bc2d264429048af$var$setContentTypeIfUnset(headers, "application/json");
                return $4bc2d264429048af$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $eN39g.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $jnTaS(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$4bc2d264429048af$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$eN39g.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $4bc2d264429048af$var$defaults.headers[method] = {};
});
$eN39g.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $4bc2d264429048af$var$defaults.headers[method] = $eN39g.merge($4bc2d264429048af$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $4bc2d264429048af$var$defaults;

});
parcelRequire.register("lyStj", function(module, exports) {
"use strict";

var $eN39g = parcelRequire("eN39g");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $eN39g.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRequire.register("jnTaS", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRequire.register("aNSvO", function(module, exports) {
"use strict";

var $eN39g = parcelRequire("eN39g");

var $fs4MX = parcelRequire("fs4MX");

var $e8NFJ = parcelRequire("e8NFJ");

var $b4EjJ = parcelRequire("b4EjJ");

var $e6eAO = parcelRequire("e6eAO");

var $aR0nz = parcelRequire("aR0nz");

var $6jyny = parcelRequire("6jyny");

var $24O5L = parcelRequire("24O5L");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var onloadend = function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $aR0nz(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $fs4MX(resolve, reject, response);
            // Clean up request
            request = null;
        };
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($eN39g.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $e6eAO(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $b4EjJ(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($24O5L("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($24O5L("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($24O5L(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($eN39g.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $6jyny(fullPath)) && config.xsrfCookieName ? $e8NFJ.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $eN39g.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$eN39g.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRequire.register("fs4MX", function(module, exports) {
"use strict";

var $24O5L = parcelRequire("24O5L");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($24O5L("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRequire.register("24O5L", function(module, exports) {
"use strict";

var $jnTaS = parcelRequire("jnTaS");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $jnTaS(error, config, code, request, response);
};

});


parcelRequire.register("e8NFJ", function(module, exports) {
"use strict";

var $eN39g = parcelRequire("eN39g");
module.exports = $eN39g.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($eN39g.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($eN39g.isString(path)) cookie.push("path=" + path);
            if ($eN39g.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRequire.register("e6eAO", function(module, exports) {
"use strict";

var $gBHu9 = parcelRequire("gBHu9");

var $53JcI = parcelRequire("53JcI");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$gBHu9(requestedURL)) return $53JcI(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRequire.register("gBHu9", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRequire.register("53JcI", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRequire.register("aR0nz", function(module, exports) {
"use strict";

var $eN39g = parcelRequire("eN39g");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $7e6f25e62341b9ca$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $eN39g.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $eN39g.trim(line.substr(0, i)).toLowerCase();
        val = $eN39g.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $7e6f25e62341b9ca$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRequire.register("6jyny", function(module, exports) {
"use strict";

var $eN39g = parcelRequire("eN39g");
module.exports = $eN39g.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var resolveURL = /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    };
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $eN39g.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRequire.register("dre6V", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRequire.register("j4T6k", function(module, exports) {
"use strict";

var $eN39g = parcelRequire("eN39g");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    var getMergedValue = function getMergedValue(target, source) {
        if ($eN39g.isPlainObject(target) && $eN39g.isPlainObject(source)) return $eN39g.merge(target, source);
        else if ($eN39g.isPlainObject(source)) return $eN39g.merge({}, source);
        else if ($eN39g.isArray(source)) return source.slice();
        return source;
    };
    var mergeDeepProperties = function mergeDeepProperties(prop) {
        if (!$eN39g.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$eN39g.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    };
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    $eN39g.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$eN39g.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $eN39g.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $eN39g.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$eN39g.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$eN39g.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $eN39g.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $eN39g.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRequire.register("hluHE", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
"use strict";

var $lPvdv = parcelRequire("lPvdv");
var $ca0c36d01b49ef57$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $ca0c36d01b49ef57$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $1ObTH._)(thing)) === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $ca0c36d01b49ef57$var$deprecatedWarnings = {};
var $ca0c36d01b49ef57$var$currentVerArr = $lPvdv.version.split(".");
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $ca0c36d01b49ef57$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split(".") : $ca0c36d01b49ef57$var$currentVerArr;
    var destVer = version.split(".");
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $ca0c36d01b49ef57$var$validators.transitional = function transitional(validator, version, message) {
    var formatMessage = function formatMessage(opt, desc) {
        return "[Axios v" + $lPvdv.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    };
    var isDeprecated = version && $ca0c36d01b49ef57$var$isOlderVersion(version);
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed in " + version));
        if (isDeprecated && !$ca0c36d01b49ef57$var$deprecatedWarnings[opt]) {
            $ca0c36d01b49ef57$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $ca0c36d01b49ef57$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    isOlderVersion: $ca0c36d01b49ef57$var$isOlderVersion,
    assertOptions: $ca0c36d01b49ef57$var$assertOptions,
    validators: $ca0c36d01b49ef57$var$validators
};

});
parcelRequire.register("lPvdv", function(module, exports) {
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

});



parcelRequire.register("6GdPl", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $4dd16414a0be0e24$var$Cancel(message) {
    this.message = message;
}
$4dd16414a0be0e24$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$4dd16414a0be0e24$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $4dd16414a0be0e24$var$Cancel;

});

parcelRequire.register("hV8k8", function(module, exports) {
"use strict";

var $6GdPl = parcelRequire("6GdPl");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $d0be37799b4d4afb$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $6GdPl(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $d0be37799b4d4afb$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $d0be37799b4d4afb$var$CancelToken.source = function source() {
    var cancel;
    var token = new $d0be37799b4d4afb$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $d0be37799b4d4afb$var$CancelToken;

});

parcelRequire.register("9D2Ce", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRequire.register("bIbGX", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});



parcelRequire.register("lenWP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f74d7b562fb5dd0b$export$2e2bcd8739ae039; }, function (v) { return $f74d7b562fb5dd0b$export$2e2bcd8739ae039 = v; });
var $f74d7b562fb5dd0b$export$1e511d4a378977f5;
var $f74d7b562fb5dd0b$export$2e2bcd8739ae039;
"use strict";
$f74d7b562fb5dd0b$export$1e511d4a378977f5 = true;
$f74d7b562fb5dd0b$export$2e2bcd8739ae039 = "\nquery($id: ID!) {\n  transaction(id: $id) {\n    id\n    anchor\n    signature\n    recipient\n    owner {\n      address\n      key\n    }\n    fee {\n      winston\n      ar\n    }\n    quantity {\n      winston\n      ar\n    }\n    data {\n      size\n      type\n    }\n    tags {\n      name\n      value\n    }\n    block {\n      id\n      timestamp\n      height\n      previous\n    }\n    parent {\n      id\n    }\n  }\n}\n";

});


parcelRequire.register("kGJ2Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Deflate", function () { return $ae290cc08e298ace$export$ae157b6234afe138; });
$parcel$export(module.exports, "deflate", function () { return $ae290cc08e298ace$export$2316623ecd1285ab; });
$parcel$export(module.exports, "deflateRaw", function () { return $ae290cc08e298ace$export$e95d6a8f69fb340a; });
$parcel$export(module.exports, "gzip", function () { return $ae290cc08e298ace$export$69f0ea7cf3a331a8; });
$parcel$export(module.exports, "Inflate", function () { return $ae290cc08e298ace$export$d1de70a877d6e43c; });
$parcel$export(module.exports, "inflate", function () { return $ae290cc08e298ace$export$cae1ce83fe4a1782; });
$parcel$export(module.exports, "inflateRaw", function () { return $ae290cc08e298ace$export$d0f0aa2d05c905c5; });
$parcel$export(module.exports, "ungzip", function () { return $ae290cc08e298ace$export$95adf9d270383091; });
$parcel$export(module.exports, "constants", function () { return $ae290cc08e298ace$export$1a988e7317c65621; });
$parcel$export(module.exports, "default", function () { return $ae290cc08e298ace$export$2e2bcd8739ae039; });
/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
var $ae290cc08e298ace$var$Z_FIXED$1 = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $ae290cc08e298ace$var$Z_BINARY = 0;
var $ae290cc08e298ace$var$Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
var $ae290cc08e298ace$var$Z_UNKNOWN$1 = 2;
/*============================================================================*/ function $ae290cc08e298ace$var$zero$1(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $ae290cc08e298ace$var$STORED_BLOCK = 0;
var $ae290cc08e298ace$var$STATIC_TREES = 1;
var $ae290cc08e298ace$var$DYN_TREES = 2;
/* The three kinds of block type */ var $ae290cc08e298ace$var$MIN_MATCH$1 = 3;
var $ae290cc08e298ace$var$MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $ae290cc08e298ace$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $ae290cc08e298ace$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ var $ae290cc08e298ace$var$L_CODES$1 = $ae290cc08e298ace$var$LITERALS$1 + 1 + $ae290cc08e298ace$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ var $ae290cc08e298ace$var$D_CODES$1 = 30;
/* number of distance codes */ var $ae290cc08e298ace$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ var $ae290cc08e298ace$var$HEAP_SIZE$1 = 2 * $ae290cc08e298ace$var$L_CODES$1 + 1;
/* maximum heap size */ var $ae290cc08e298ace$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ var $ae290cc08e298ace$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $ae290cc08e298ace$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $ae290cc08e298ace$var$END_BLOCK = 256;
/* end of block literal code */ var $ae290cc08e298ace$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $ae290cc08e298ace$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $ae290cc08e298ace$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $ae290cc08e298ace$var$extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
var $ae290cc08e298ace$var$extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
var $ae290cc08e298ace$var$extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
var $ae290cc08e298ace$var$bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $ae290cc08e298ace$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $ae290cc08e298ace$var$static_ltree = new Array(($ae290cc08e298ace$var$L_CODES$1 + 2) * 2);
$ae290cc08e298ace$var$zero$1($ae290cc08e298ace$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $ae290cc08e298ace$var$static_dtree = new Array($ae290cc08e298ace$var$D_CODES$1 * 2);
$ae290cc08e298ace$var$zero$1($ae290cc08e298ace$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $ae290cc08e298ace$var$_dist_code = new Array($ae290cc08e298ace$var$DIST_CODE_LEN);
$ae290cc08e298ace$var$zero$1($ae290cc08e298ace$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $ae290cc08e298ace$var$_length_code = new Array($ae290cc08e298ace$var$MAX_MATCH$1 - $ae290cc08e298ace$var$MIN_MATCH$1 + 1);
$ae290cc08e298ace$var$zero$1($ae290cc08e298ace$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $ae290cc08e298ace$var$base_length = new Array($ae290cc08e298ace$var$LENGTH_CODES$1);
$ae290cc08e298ace$var$zero$1($ae290cc08e298ace$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $ae290cc08e298ace$var$base_dist = new Array($ae290cc08e298ace$var$D_CODES$1);
$ae290cc08e298ace$var$zero$1($ae290cc08e298ace$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $ae290cc08e298ace$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $ae290cc08e298ace$var$static_l_desc;
var $ae290cc08e298ace$var$static_d_desc;
var $ae290cc08e298ace$var$static_bl_desc;
function $ae290cc08e298ace$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
var $ae290cc08e298ace$var$d_code = function(dist) {
    return dist < 256 ? $ae290cc08e298ace$var$_dist_code[dist] : $ae290cc08e298ace$var$_dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ var $ae290cc08e298ace$var$put_short = function(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ var $ae290cc08e298ace$var$send_bits = function(s, value, length) {
    if (s.bi_valid > $ae290cc08e298ace$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $ae290cc08e298ace$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $ae290cc08e298ace$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $ae290cc08e298ace$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
var $ae290cc08e298ace$var$send_code = function(s, c, tree) {
    $ae290cc08e298ace$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ var $ae290cc08e298ace$var$bi_reverse = function(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ var $ae290cc08e298ace$var$bi_flush = function(s) {
    if (s.bi_valid === 16) {
        $ae290cc08e298ace$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ var $ae290cc08e298ace$var$gen_bitlen = function(s, desc) {
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $ae290cc08e298ace$var$MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $ae290cc08e298ace$var$HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Tracev((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ var $ae290cc08e298ace$var$gen_codes = function(tree, max_code, bl_count) {
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    var next_code = new Array($ae290cc08e298ace$var$MAX_BITS$1 + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $ae290cc08e298ace$var$MAX_BITS$1; bits++){
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $ae290cc08e298ace$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ var $ae290cc08e298ace$var$tr_static_init = function() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($ae290cc08e298ace$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $ae290cc08e298ace$var$LENGTH_CODES$1 - 1; code++){
        $ae290cc08e298ace$var$base_length[code] = length;
        for(n = 0; n < 1 << $ae290cc08e298ace$var$extra_lbits[code]; n++)$ae290cc08e298ace$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $ae290cc08e298ace$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $ae290cc08e298ace$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $ae290cc08e298ace$var$extra_dbits[code]; n++)$ae290cc08e298ace$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $ae290cc08e298ace$var$D_CODES$1; code++){
        $ae290cc08e298ace$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $ae290cc08e298ace$var$extra_dbits[code] - 7; n++)$ae290cc08e298ace$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $ae290cc08e298ace$var$MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $ae290cc08e298ace$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $ae290cc08e298ace$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $ae290cc08e298ace$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $ae290cc08e298ace$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $ae290cc08e298ace$var$gen_codes($ae290cc08e298ace$var$static_ltree, $ae290cc08e298ace$var$L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $ae290cc08e298ace$var$D_CODES$1; n++){
        $ae290cc08e298ace$var$static_dtree[n * 2 + 1] = 5;
        $ae290cc08e298ace$var$static_dtree[n * 2] = $ae290cc08e298ace$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $ae290cc08e298ace$var$static_l_desc = new $ae290cc08e298ace$var$StaticTreeDesc($ae290cc08e298ace$var$static_ltree, $ae290cc08e298ace$var$extra_lbits, $ae290cc08e298ace$var$LITERALS$1 + 1, $ae290cc08e298ace$var$L_CODES$1, $ae290cc08e298ace$var$MAX_BITS$1);
    $ae290cc08e298ace$var$static_d_desc = new $ae290cc08e298ace$var$StaticTreeDesc($ae290cc08e298ace$var$static_dtree, $ae290cc08e298ace$var$extra_dbits, 0, $ae290cc08e298ace$var$D_CODES$1, $ae290cc08e298ace$var$MAX_BITS$1);
    $ae290cc08e298ace$var$static_bl_desc = new $ae290cc08e298ace$var$StaticTreeDesc(new Array(0), $ae290cc08e298ace$var$extra_blbits, 0, $ae290cc08e298ace$var$BL_CODES$1, $ae290cc08e298ace$var$MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ var $ae290cc08e298ace$var$init_block = function(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $ae290cc08e298ace$var$L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $ae290cc08e298ace$var$D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $ae290cc08e298ace$var$BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$ae290cc08e298ace$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.sym_next = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ var $ae290cc08e298ace$var$bi_windup = function(s) {
    if (s.bi_valid > 8) $ae290cc08e298ace$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ var $ae290cc08e298ace$var$smaller = function(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ var $ae290cc08e298ace$var$pqdownheap = function(s, tree, k) {
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $ae290cc08e298ace$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($ae290cc08e298ace$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ var $ae290cc08e298ace$var$compress_block = function(s, ltree, dtree) {
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var sx = 0; /* running index in sym_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) $ae290cc08e298ace$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $ae290cc08e298ace$var$_length_code[lc];
            $ae290cc08e298ace$var$send_code(s, code + $ae290cc08e298ace$var$LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = $ae290cc08e298ace$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $ae290cc08e298ace$var$base_length[code];
                $ae290cc08e298ace$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $ae290cc08e298ace$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $ae290cc08e298ace$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $ae290cc08e298ace$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $ae290cc08e298ace$var$base_dist[code];
                $ae290cc08e298ace$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
    }while (sx < s.sym_next);
    $ae290cc08e298ace$var$send_code(s, $ae290cc08e298ace$var$END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ var $ae290cc08e298ace$var$build_tree = function(s, desc) {
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $ae290cc08e298ace$var$HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$ae290cc08e298ace$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $ae290cc08e298ace$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $ae290cc08e298ace$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $ae290cc08e298ace$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $ae290cc08e298ace$var$gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ var $ae290cc08e298ace$var$scan_tree = function(s, tree, max_code) {
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$ae290cc08e298ace$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$ae290cc08e298ace$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$ae290cc08e298ace$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ var $ae290cc08e298ace$var$send_tree = function(s, tree, max_code) {
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $ae290cc08e298ace$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $ae290cc08e298ace$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $ae290cc08e298ace$var$send_code(s, $ae290cc08e298ace$var$REP_3_6, s.bl_tree);
            $ae290cc08e298ace$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $ae290cc08e298ace$var$send_code(s, $ae290cc08e298ace$var$REPZ_3_10, s.bl_tree);
            $ae290cc08e298ace$var$send_bits(s, count - 3, 3);
        } else {
            $ae290cc08e298ace$var$send_code(s, $ae290cc08e298ace$var$REPZ_11_138, s.bl_tree);
            $ae290cc08e298ace$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ var $ae290cc08e298ace$var$build_bl_tree = function(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $ae290cc08e298ace$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $ae290cc08e298ace$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $ae290cc08e298ace$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $ae290cc08e298ace$var$BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$ae290cc08e298ace$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ var $ae290cc08e298ace$var$send_all_trees = function(s, lcodes, dcodes, blcodes) {
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $ae290cc08e298ace$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $ae290cc08e298ace$var$send_bits(s, dcodes - 1, 5);
    $ae290cc08e298ace$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $ae290cc08e298ace$var$send_bits(s, s.bl_tree[$ae290cc08e298ace$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $ae290cc08e298ace$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $ae290cc08e298ace$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ var $ae290cc08e298ace$var$detect_data_type = function(s) {
    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var block_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $ae290cc08e298ace$var$Z_BINARY;
    }
    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $ae290cc08e298ace$var$Z_TEXT;
    for(n = 32; n < $ae290cc08e298ace$var$LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $ae290cc08e298ace$var$Z_TEXT;
    }
    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $ae290cc08e298ace$var$Z_BINARY;
};
var $ae290cc08e298ace$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ var $ae290cc08e298ace$var$_tr_init$1 = function(s) {
    if (!$ae290cc08e298ace$var$static_init_done) {
        $ae290cc08e298ace$var$tr_static_init();
        $ae290cc08e298ace$var$static_init_done = true;
    }
    s.l_desc = new $ae290cc08e298ace$var$TreeDesc(s.dyn_ltree, $ae290cc08e298ace$var$static_l_desc);
    s.d_desc = new $ae290cc08e298ace$var$TreeDesc(s.dyn_dtree, $ae290cc08e298ace$var$static_d_desc);
    s.bl_desc = new $ae290cc08e298ace$var$TreeDesc(s.bl_tree, $ae290cc08e298ace$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $ae290cc08e298ace$var$init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ var $ae290cc08e298ace$var$_tr_stored_block$1 = function(s, buf, stored_len, last) {
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    $ae290cc08e298ace$var$send_bits(s, ($ae290cc08e298ace$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $ae290cc08e298ace$var$bi_windup(s); /* align on byte boundary */ 
    $ae290cc08e298ace$var$put_short(s, stored_len);
    $ae290cc08e298ace$var$put_short(s, ~stored_len);
    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
    s.pending += stored_len;
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ var $ae290cc08e298ace$var$_tr_align$1 = function(s) {
    $ae290cc08e298ace$var$send_bits(s, $ae290cc08e298ace$var$STATIC_TREES << 1, 3);
    $ae290cc08e298ace$var$send_code(s, $ae290cc08e298ace$var$END_BLOCK, $ae290cc08e298ace$var$static_ltree);
    $ae290cc08e298ace$var$bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ var $ae290cc08e298ace$var$_tr_flush_block$1 = function(s, buf, stored_len, last) {
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $ae290cc08e298ace$var$Z_UNKNOWN$1) s.strm.data_type = $ae290cc08e298ace$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $ae290cc08e298ace$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $ae290cc08e298ace$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $ae290cc08e298ace$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $ae290cc08e298ace$var$_tr_stored_block$1(s, buf, stored_len, last);
    else if (s.strategy === $ae290cc08e298ace$var$Z_FIXED$1 || static_lenb === opt_lenb) {
        $ae290cc08e298ace$var$send_bits(s, ($ae290cc08e298ace$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $ae290cc08e298ace$var$compress_block(s, $ae290cc08e298ace$var$static_ltree, $ae290cc08e298ace$var$static_dtree);
    } else {
        $ae290cc08e298ace$var$send_bits(s, ($ae290cc08e298ace$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $ae290cc08e298ace$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $ae290cc08e298ace$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $ae290cc08e298ace$var$init_block(s);
    if (last) $ae290cc08e298ace$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ var $ae290cc08e298ace$var$_tr_tally$1 = function(s, dist, lc) {
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($ae290cc08e298ace$var$_length_code[lc] + $ae290cc08e298ace$var$LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[$ae290cc08e298ace$var$d_code(dist) * 2]++;
    }
    return s.sym_next === s.sym_end;
};
var $ae290cc08e298ace$var$_tr_init_1 = $ae290cc08e298ace$var$_tr_init$1;
var $ae290cc08e298ace$var$_tr_stored_block_1 = $ae290cc08e298ace$var$_tr_stored_block$1;
var $ae290cc08e298ace$var$_tr_flush_block_1 = $ae290cc08e298ace$var$_tr_flush_block$1;
var $ae290cc08e298ace$var$_tr_tally_1 = $ae290cc08e298ace$var$_tr_tally$1;
var $ae290cc08e298ace$var$_tr_align_1 = $ae290cc08e298ace$var$_tr_align$1;
var $ae290cc08e298ace$var$trees = {
    _tr_init: $ae290cc08e298ace$var$_tr_init_1,
    _tr_stored_block: $ae290cc08e298ace$var$_tr_stored_block_1,
    _tr_flush_block: $ae290cc08e298ace$var$_tr_flush_block_1,
    _tr_tally: $ae290cc08e298ace$var$_tr_tally_1,
    _tr_align: $ae290cc08e298ace$var$_tr_align_1
};
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $ae290cc08e298ace$var$adler32 = function(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
var $ae290cc08e298ace$var$adler32_1 = $ae290cc08e298ace$var$adler32;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
var $ae290cc08e298ace$var$makeTable = function() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
var $ae290cc08e298ace$var$crcTable = new Uint32Array($ae290cc08e298ace$var$makeTable());
var $ae290cc08e298ace$var$crc32 = function(crc, buf, len, pos) {
    var t = $ae290cc08e298ace$var$crcTable;
    var end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
var $ae290cc08e298ace$var$crc32_1 = $ae290cc08e298ace$var$crc32;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $ae290cc08e298ace$var$messages = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $ae290cc08e298ace$var$constants$2 = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $ae290cc08e298ace$var$_tr_init = $ae290cc08e298ace$var$trees._tr_init, $ae290cc08e298ace$var$_tr_stored_block = $ae290cc08e298ace$var$trees._tr_stored_block, $ae290cc08e298ace$var$_tr_flush_block = $ae290cc08e298ace$var$trees._tr_flush_block, $ae290cc08e298ace$var$_tr_tally = $ae290cc08e298ace$var$trees._tr_tally, $ae290cc08e298ace$var$_tr_align = $ae290cc08e298ace$var$trees._tr_align;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $ae290cc08e298ace$var$Z_NO_FLUSH$2 = $ae290cc08e298ace$var$constants$2.Z_NO_FLUSH, $ae290cc08e298ace$var$Z_PARTIAL_FLUSH = $ae290cc08e298ace$var$constants$2.Z_PARTIAL_FLUSH, $ae290cc08e298ace$var$Z_FULL_FLUSH$1 = $ae290cc08e298ace$var$constants$2.Z_FULL_FLUSH, $ae290cc08e298ace$var$Z_FINISH$3 = $ae290cc08e298ace$var$constants$2.Z_FINISH, $ae290cc08e298ace$var$Z_BLOCK$1 = $ae290cc08e298ace$var$constants$2.Z_BLOCK, $ae290cc08e298ace$var$Z_OK$3 = $ae290cc08e298ace$var$constants$2.Z_OK, $ae290cc08e298ace$var$Z_STREAM_END$3 = $ae290cc08e298ace$var$constants$2.Z_STREAM_END, $ae290cc08e298ace$var$Z_STREAM_ERROR$2 = $ae290cc08e298ace$var$constants$2.Z_STREAM_ERROR, $ae290cc08e298ace$var$Z_DATA_ERROR$2 = $ae290cc08e298ace$var$constants$2.Z_DATA_ERROR, $ae290cc08e298ace$var$Z_BUF_ERROR$1 = $ae290cc08e298ace$var$constants$2.Z_BUF_ERROR, $ae290cc08e298ace$var$Z_DEFAULT_COMPRESSION$1 = $ae290cc08e298ace$var$constants$2.Z_DEFAULT_COMPRESSION, $ae290cc08e298ace$var$Z_FILTERED = $ae290cc08e298ace$var$constants$2.Z_FILTERED, $ae290cc08e298ace$var$Z_HUFFMAN_ONLY = $ae290cc08e298ace$var$constants$2.Z_HUFFMAN_ONLY, $ae290cc08e298ace$var$Z_RLE = $ae290cc08e298ace$var$constants$2.Z_RLE, $ae290cc08e298ace$var$Z_FIXED = $ae290cc08e298ace$var$constants$2.Z_FIXED, $ae290cc08e298ace$var$Z_DEFAULT_STRATEGY$1 = $ae290cc08e298ace$var$constants$2.Z_DEFAULT_STRATEGY, $ae290cc08e298ace$var$Z_UNKNOWN = $ae290cc08e298ace$var$constants$2.Z_UNKNOWN, $ae290cc08e298ace$var$Z_DEFLATED$2 = $ae290cc08e298ace$var$constants$2.Z_DEFLATED;
/*============================================================================*/ var $ae290cc08e298ace$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $ae290cc08e298ace$var$MAX_WBITS$1 = 15;
/* 32K LZ77 window */ var $ae290cc08e298ace$var$DEF_MEM_LEVEL = 8;
var $ae290cc08e298ace$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $ae290cc08e298ace$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $ae290cc08e298ace$var$L_CODES = $ae290cc08e298ace$var$LITERALS + 1 + $ae290cc08e298ace$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $ae290cc08e298ace$var$D_CODES = 30;
/* number of distance codes */ var $ae290cc08e298ace$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $ae290cc08e298ace$var$HEAP_SIZE = 2 * $ae290cc08e298ace$var$L_CODES + 1;
/* maximum heap size */ var $ae290cc08e298ace$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $ae290cc08e298ace$var$MIN_MATCH = 3;
var $ae290cc08e298ace$var$MAX_MATCH = 258;
var $ae290cc08e298ace$var$MIN_LOOKAHEAD = $ae290cc08e298ace$var$MAX_MATCH + $ae290cc08e298ace$var$MIN_MATCH + 1;
var $ae290cc08e298ace$var$PRESET_DICT = 0x20;
var $ae290cc08e298ace$var$INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
//#ifdef GZIP
var $ae290cc08e298ace$var$GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
//#endif
var $ae290cc08e298ace$var$EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
var $ae290cc08e298ace$var$NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
var $ae290cc08e298ace$var$COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
var $ae290cc08e298ace$var$HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
var $ae290cc08e298ace$var$BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
var $ae290cc08e298ace$var$FINISH_STATE = 666; /* stream complete */ 
var $ae290cc08e298ace$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $ae290cc08e298ace$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $ae290cc08e298ace$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $ae290cc08e298ace$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $ae290cc08e298ace$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
var $ae290cc08e298ace$var$err = function(strm, errorCode) {
    strm.msg = $ae290cc08e298ace$var$messages[errorCode];
    return errorCode;
};
var $ae290cc08e298ace$var$rank = function(f) {
    return f * 2 - (f > 4 ? 9 : 0);
};
var $ae290cc08e298ace$var$zero = function(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ var $ae290cc08e298ace$var$slide_hash = function(s) {
    var n, m;
    var p;
    var wsize = s.w_size;
    n = s.hash_size;
    p = n;
    do {
        m = s.head[--p];
        s.head[p] = m >= wsize ? m - wsize : 0;
    }while (--n);
    n = wsize;
    //#ifndef FASTEST
    p = n;
    do {
        m = s.prev[--p];
        s.prev[p] = m >= wsize ? m - wsize : 0;
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
//#endif
};
/* eslint-disable new-cap */ var $ae290cc08e298ace$var$HASH_ZLIB = function(s, prev, data) {
    return (prev << s.hash_shift ^ data) & s.hash_mask;
};
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
var $ae290cc08e298ace$var$HASH = $ae290cc08e298ace$var$HASH_ZLIB;
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ var $ae290cc08e298ace$var$flush_pending = function(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
var $ae290cc08e298ace$var$flush_block_only = function(s, last) {
    $ae290cc08e298ace$var$_tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $ae290cc08e298ace$var$flush_pending(s.strm);
};
var $ae290cc08e298ace$var$put_byte = function(s, b) {
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ var $ae290cc08e298ace$var$putShortMSB = function(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ var $ae290cc08e298ace$var$read_buf = function(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = $ae290cc08e298ace$var$adler32_1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $ae290cc08e298ace$var$crc32_1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ var $ae290cc08e298ace$var$longest_match = function(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $ae290cc08e298ace$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $ae290cc08e298ace$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $ae290cc08e298ace$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $ae290cc08e298ace$var$MAX_MATCH - (strend - scan);
        scan = strend - $ae290cc08e298ace$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ var $ae290cc08e298ace$var$fill_window = function(s) {
    var _w_size = s.w_size;
    var n, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $ae290cc08e298ace$var$MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            if (s.insert > s.strstart) s.insert = s.strstart;
            $ae290cc08e298ace$var$slide_hash(s);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $ae290cc08e298ace$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $ae290cc08e298ace$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = $ae290cc08e298ace$var$HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $ae290cc08e298ace$var$HASH(s, s.ins_h, s.window[str + $ae290cc08e298ace$var$MIN_MATCH - 1]);
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $ae290cc08e298ace$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $ae290cc08e298ace$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ var $ae290cc08e298ace$var$deflate_stored = function(s, flush) {
    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ var min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ var len, left, have, last = 0;
    var used = s.strm.avail_in;
    do {
        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
        if (s.strm.avail_out < have) break;
        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
        left = s.strstart - s.block_start; /* bytes left in window */ 
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
        if (len > have) len = have; /* limit len to the output */ 
        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== $ae290cc08e298ace$var$Z_FINISH$3 || flush === $ae290cc08e298ace$var$Z_NO_FLUSH$2 || len !== left + s.strm.avail_in)) break;
        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === $ae290cc08e298ace$var$Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
        $ae290cc08e298ace$var$_tr_stored_block(s, 0, 0, last);
        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        /* Write the stored block header bytes. */ $ae290cc08e298ace$var$flush_pending(s.strm);
        //#ifdef ZLIB_DEBUG
        //    /* Update debugging counts for the data about to be copied. */
        //    s->compressed_len += len << 3;
        //    s->bits_sent += len << 3;
        //#endif
        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
            if (left > len) left = len;
            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
            s.strm.next_out += left;
            s.strm.avail_out -= left;
            s.strm.total_out += left;
            s.block_start += left;
            len -= left;
        }
        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
            $ae290cc08e298ace$var$read_buf(s.strm, s.strm.output, s.strm.next_out, len);
            s.strm.next_out += len;
            s.strm.avail_out -= len;
            s.strm.total_out += len;
        }
    }while (last === 0);
    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
    if (used) {
        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
            s.matches = 2; /* clear hash */ 
            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
            s.strstart = s.w_size;
            s.insert = s.strstart;
        } else {
            if (s.window_size - s.strstart <= used) {
                /* Slide the window down. */ s.strstart -= s.w_size;
                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                if (s.insert > s.strstart) s.insert = s.strstart;
            }
            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
            s.strstart += used;
            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* If the last block was written to next_out, then done. */ if (last) return $ae290cc08e298ace$var$BS_FINISH_DONE;
    /* If flushing and all input has been consumed, then done. */ if (flush !== $ae290cc08e298ace$var$Z_NO_FLUSH$2 && flush !== $ae290cc08e298ace$var$Z_FINISH$3 && s.strm.avail_in === 0 && s.strstart === s.block_start) return $ae290cc08e298ace$var$BS_BLOCK_DONE;
    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */ s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
        have += s.w_size; /* more space now */ 
        if (s.insert > s.strstart) s.insert = s.strstart;
    }
    if (have > s.strm.avail_in) have = s.strm.avail_in;
    if (have) {
        $ae290cc08e298ace$var$read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
    min_block = have > s.w_size ? s.w_size : have;
    left = s.strstart - s.block_start;
    if (left >= min_block || (left || flush === $ae290cc08e298ace$var$Z_FINISH$3) && flush !== $ae290cc08e298ace$var$Z_NO_FLUSH$2 && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === $ae290cc08e298ace$var$Z_FINISH$3 && s.strm.avail_in === 0 && len === left ? 1 : 0;
        $ae290cc08e298ace$var$_tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        $ae290cc08e298ace$var$flush_pending(s.strm);
    }
    /* We've done all we can with the available input and output. */ return last ? $ae290cc08e298ace$var$BS_FINISH_STARTED : $ae290cc08e298ace$var$BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ var $ae290cc08e298ace$var$deflate_fast = function(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $ae290cc08e298ace$var$MIN_LOOKAHEAD) {
            $ae290cc08e298ace$var$fill_window(s);
            if (s.lookahead < $ae290cc08e298ace$var$MIN_LOOKAHEAD && flush === $ae290cc08e298ace$var$Z_NO_FLUSH$2) return $ae290cc08e298ace$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $ae290cc08e298ace$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $ae290cc08e298ace$var$HASH(s, s.ins_h, s.window[s.strstart + $ae290cc08e298ace$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $ae290cc08e298ace$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $ae290cc08e298ace$var$longest_match(s, hash_head);
        if (s.match_length >= $ae290cc08e298ace$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $ae290cc08e298ace$var$_tr_tally(s, s.strstart - s.match_start, s.match_length - $ae290cc08e298ace$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $ae290cc08e298ace$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $ae290cc08e298ace$var$HASH(s, s.ins_h, s.window[s.strstart + $ae290cc08e298ace$var$MIN_MATCH - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = $ae290cc08e298ace$var$HASH(s, s.ins_h, s.window[s.strstart + 1]);
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $ae290cc08e298ace$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $ae290cc08e298ace$var$MIN_MATCH - 1 ? s.strstart : $ae290cc08e298ace$var$MIN_MATCH - 1;
    if (flush === $ae290cc08e298ace$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $ae290cc08e298ace$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_FINISH_STARTED;
        /***/ return $ae290cc08e298ace$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
    /***/ }
    return $ae290cc08e298ace$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ var $ae290cc08e298ace$var$deflate_slow = function(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $ae290cc08e298ace$var$MIN_LOOKAHEAD) {
            $ae290cc08e298ace$var$fill_window(s);
            if (s.lookahead < $ae290cc08e298ace$var$MIN_LOOKAHEAD && flush === $ae290cc08e298ace$var$Z_NO_FLUSH$2) return $ae290cc08e298ace$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $ae290cc08e298ace$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $ae290cc08e298ace$var$HASH(s, s.ins_h, s.window[s.strstart + $ae290cc08e298ace$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $ae290cc08e298ace$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $ae290cc08e298ace$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $ae290cc08e298ace$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $ae290cc08e298ace$var$Z_FILTERED || s.match_length === $ae290cc08e298ace$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $ae290cc08e298ace$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $ae290cc08e298ace$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $ae290cc08e298ace$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $ae290cc08e298ace$var$_tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $ae290cc08e298ace$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $ae290cc08e298ace$var$HASH(s, s.ins_h, s.window[s.strstart + $ae290cc08e298ace$var$MIN_MATCH - 1]);
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $ae290cc08e298ace$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $ae290cc08e298ace$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $ae290cc08e298ace$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $ae290cc08e298ace$var$MIN_MATCH - 1 ? s.strstart : $ae290cc08e298ace$var$MIN_MATCH - 1;
    if (flush === $ae290cc08e298ace$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $ae290cc08e298ace$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_FINISH_STARTED;
        /***/ return $ae290cc08e298ace$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
    /***/ }
    return $ae290cc08e298ace$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ var $ae290cc08e298ace$var$deflate_rle = function(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $ae290cc08e298ace$var$MAX_MATCH) {
            $ae290cc08e298ace$var$fill_window(s);
            if (s.lookahead <= $ae290cc08e298ace$var$MAX_MATCH && flush === $ae290cc08e298ace$var$Z_NO_FLUSH$2) return $ae290cc08e298ace$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $ae290cc08e298ace$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $ae290cc08e298ace$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $ae290cc08e298ace$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $ae290cc08e298ace$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $ae290cc08e298ace$var$_tr_tally(s, 1, s.match_length - $ae290cc08e298ace$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $ae290cc08e298ace$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $ae290cc08e298ace$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $ae290cc08e298ace$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_FINISH_STARTED;
        /***/ return $ae290cc08e298ace$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
    /***/ }
    return $ae290cc08e298ace$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ var $ae290cc08e298ace$var$deflate_huff = function(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $ae290cc08e298ace$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $ae290cc08e298ace$var$Z_NO_FLUSH$2) return $ae290cc08e298ace$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $ae290cc08e298ace$var$_tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $ae290cc08e298ace$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $ae290cc08e298ace$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_FINISH_STARTED;
        /***/ return $ae290cc08e298ace$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
    /***/ }
    return $ae290cc08e298ace$var$BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $ae290cc08e298ace$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $ae290cc08e298ace$var$configuration_table = [
    /*      good lazy nice chain */ new $ae290cc08e298ace$var$Config(0, 0, 0, 0, $ae290cc08e298ace$var$deflate_stored),
    /* 0 store only */ new $ae290cc08e298ace$var$Config(4, 4, 8, 4, $ae290cc08e298ace$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $ae290cc08e298ace$var$Config(4, 5, 16, 8, $ae290cc08e298ace$var$deflate_fast),
    /* 2 */ new $ae290cc08e298ace$var$Config(4, 6, 32, 32, $ae290cc08e298ace$var$deflate_fast),
    /* 3 */ new $ae290cc08e298ace$var$Config(4, 4, 16, 16, $ae290cc08e298ace$var$deflate_slow),
    /* 4 lazy matches */ new $ae290cc08e298ace$var$Config(8, 16, 32, 32, $ae290cc08e298ace$var$deflate_slow),
    /* 5 */ new $ae290cc08e298ace$var$Config(8, 16, 128, 128, $ae290cc08e298ace$var$deflate_slow),
    /* 6 */ new $ae290cc08e298ace$var$Config(8, 32, 128, 256, $ae290cc08e298ace$var$deflate_slow),
    /* 7 */ new $ae290cc08e298ace$var$Config(32, 128, 258, 1024, $ae290cc08e298ace$var$deflate_slow),
    /* 8 */ new $ae290cc08e298ace$var$Config(32, 258, 258, 4096, $ae290cc08e298ace$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ var $ae290cc08e298ace$var$lm_init = function(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $ae290cc08e298ace$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $ae290cc08e298ace$var$configuration_table[s.level].max_lazy;
    s.good_match = $ae290cc08e298ace$var$configuration_table[s.level].good_length;
    s.nice_match = $ae290cc08e298ace$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $ae290cc08e298ace$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $ae290cc08e298ace$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function $ae290cc08e298ace$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $ae290cc08e298ace$var$Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array($ae290cc08e298ace$var$HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * $ae290cc08e298ace$var$D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * $ae290cc08e298ace$var$BL_CODES + 1) * 2);
    $ae290cc08e298ace$var$zero(this.dyn_ltree);
    $ae290cc08e298ace$var$zero(this.dyn_dtree);
    $ae290cc08e298ace$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array($ae290cc08e298ace$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * $ae290cc08e298ace$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $ae290cc08e298ace$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * $ae290cc08e298ace$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $ae290cc08e298ace$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
    this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ var $ae290cc08e298ace$var$deflateStateCheck = function(strm) {
    if (!strm) return 1;
    var s = strm.state;
    if (!s || s.strm !== strm || s.status !== $ae290cc08e298ace$var$INIT_STATE && //#ifdef GZIP
    s.status !== $ae290cc08e298ace$var$GZIP_STATE && //#endif
    s.status !== $ae290cc08e298ace$var$EXTRA_STATE && s.status !== $ae290cc08e298ace$var$NAME_STATE && s.status !== $ae290cc08e298ace$var$COMMENT_STATE && s.status !== $ae290cc08e298ace$var$HCRC_STATE && s.status !== $ae290cc08e298ace$var$BUSY_STATE && s.status !== $ae290cc08e298ace$var$FINISH_STATE) return 1;
    return 0;
};
var $ae290cc08e298ace$var$deflateResetKeep = function(strm) {
    if ($ae290cc08e298ace$var$deflateStateCheck(strm)) return $ae290cc08e298ace$var$err(strm, $ae290cc08e298ace$var$Z_STREAM_ERROR$2);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $ae290cc08e298ace$var$Z_UNKNOWN;
    var s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = //#ifdef GZIP
    s.wrap === 2 ? $ae290cc08e298ace$var$GZIP_STATE : //#endif
    s.wrap ? $ae290cc08e298ace$var$INIT_STATE : $ae290cc08e298ace$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = -2;
    $ae290cc08e298ace$var$_tr_init(s);
    return $ae290cc08e298ace$var$Z_OK$3;
};
var $ae290cc08e298ace$var$deflateReset = function(strm) {
    var ret = $ae290cc08e298ace$var$deflateResetKeep(strm);
    if (ret === $ae290cc08e298ace$var$Z_OK$3) $ae290cc08e298ace$var$lm_init(strm.state);
    return ret;
};
var $ae290cc08e298ace$var$deflateSetHeader = function(strm, head) {
    if ($ae290cc08e298ace$var$deflateStateCheck(strm) || strm.state.wrap !== 2) return $ae290cc08e298ace$var$Z_STREAM_ERROR$2;
    strm.state.gzhead = head;
    return $ae290cc08e298ace$var$Z_OK$3;
};
var $ae290cc08e298ace$var$deflateInit2 = function(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $ae290cc08e298ace$var$Z_STREAM_ERROR$2;
    var wrap = 1;
    if (level === $ae290cc08e298ace$var$Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $ae290cc08e298ace$var$MAX_MEM_LEVEL || method !== $ae290cc08e298ace$var$Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $ae290cc08e298ace$var$Z_FIXED || windowBits === 8 && wrap !== 1) return $ae290cc08e298ace$var$err(strm, $ae290cc08e298ace$var$Z_STREAM_ERROR$2);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $ae290cc08e298ace$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.status = $ae290cc08e298ace$var$INIT_STATE; /* to pass state test in deflateReset() */ 
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $ae290cc08e298ace$var$MIN_MATCH - 1) / $ae290cc08e298ace$var$MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->sym_buf = s->pending_buf + s->lit_bufsize;
    s.sym_buf = s.lit_bufsize;
    //s->sym_end = (s->lit_bufsize - 1) * 3;
    s.sym_end = (s.lit_bufsize - 1) * 3;
    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $ae290cc08e298ace$var$deflateReset(strm);
};
var $ae290cc08e298ace$var$deflateInit = function(strm, level) {
    return $ae290cc08e298ace$var$deflateInit2(strm, level, $ae290cc08e298ace$var$Z_DEFLATED$2, $ae290cc08e298ace$var$MAX_WBITS$1, $ae290cc08e298ace$var$DEF_MEM_LEVEL, $ae290cc08e298ace$var$Z_DEFAULT_STRATEGY$1);
};
/* ========================================================================= */ var $ae290cc08e298ace$var$deflate$2 = function(strm, flush) {
    if ($ae290cc08e298ace$var$deflateStateCheck(strm) || flush > $ae290cc08e298ace$var$Z_BLOCK$1 || flush < 0) return strm ? $ae290cc08e298ace$var$err(strm, $ae290cc08e298ace$var$Z_STREAM_ERROR$2) : $ae290cc08e298ace$var$Z_STREAM_ERROR$2;
    var s = strm.state;
    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === $ae290cc08e298ace$var$FINISH_STATE && flush !== $ae290cc08e298ace$var$Z_FINISH$3) return $ae290cc08e298ace$var$err(strm, strm.avail_out === 0 ? $ae290cc08e298ace$var$Z_BUF_ERROR$1 : $ae290cc08e298ace$var$Z_STREAM_ERROR$2);
    var old_flush = s.last_flush;
    s.last_flush = flush;
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $ae290cc08e298ace$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $ae290cc08e298ace$var$Z_OK$3;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $ae290cc08e298ace$var$rank(flush) <= $ae290cc08e298ace$var$rank(old_flush) && flush !== $ae290cc08e298ace$var$Z_FINISH$3) return $ae290cc08e298ace$var$err(strm, $ae290cc08e298ace$var$Z_BUF_ERROR$1);
    /* User must not provide more input after the first FINISH: */ if (s.status === $ae290cc08e298ace$var$FINISH_STATE && strm.avail_in !== 0) return $ae290cc08e298ace$var$err(strm, $ae290cc08e298ace$var$Z_BUF_ERROR$1);
    /* Write the header */ if (s.status === $ae290cc08e298ace$var$INIT_STATE && s.wrap === 0) s.status = $ae290cc08e298ace$var$BUSY_STATE;
    if (s.status === $ae290cc08e298ace$var$INIT_STATE) {
        /* zlib header */ var header = $ae290cc08e298ace$var$Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
        var level_flags = -1;
        if (s.strategy >= $ae290cc08e298ace$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header |= level_flags << 6;
        if (s.strstart !== 0) header |= $ae290cc08e298ace$var$PRESET_DICT;
        header += 31 - header % 31;
        $ae290cc08e298ace$var$putShortMSB(s, header);
        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
            $ae290cc08e298ace$var$putShortMSB(s, strm.adler >>> 16);
            $ae290cc08e298ace$var$putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = $ae290cc08e298ace$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $ae290cc08e298ace$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $ae290cc08e298ace$var$Z_OK$3;
        }
    }
    //#ifdef GZIP
    if (s.status === $ae290cc08e298ace$var$GZIP_STATE) {
        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
        $ae290cc08e298ace$var$put_byte(s, 31);
        $ae290cc08e298ace$var$put_byte(s, 139);
        $ae290cc08e298ace$var$put_byte(s, 8);
        if (!s.gzhead) {
            $ae290cc08e298ace$var$put_byte(s, 0);
            $ae290cc08e298ace$var$put_byte(s, 0);
            $ae290cc08e298ace$var$put_byte(s, 0);
            $ae290cc08e298ace$var$put_byte(s, 0);
            $ae290cc08e298ace$var$put_byte(s, 0);
            $ae290cc08e298ace$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $ae290cc08e298ace$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $ae290cc08e298ace$var$put_byte(s, $ae290cc08e298ace$var$OS_CODE);
            s.status = $ae290cc08e298ace$var$BUSY_STATE;
            /* Compression must start with an empty pending buffer */ $ae290cc08e298ace$var$flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return $ae290cc08e298ace$var$Z_OK$3;
            }
        } else {
            $ae290cc08e298ace$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            $ae290cc08e298ace$var$put_byte(s, s.gzhead.time & 0xff);
            $ae290cc08e298ace$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
            $ae290cc08e298ace$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
            $ae290cc08e298ace$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
            $ae290cc08e298ace$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $ae290cc08e298ace$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $ae290cc08e298ace$var$put_byte(s, s.gzhead.os & 0xff);
            if (s.gzhead.extra && s.gzhead.extra.length) {
                $ae290cc08e298ace$var$put_byte(s, s.gzhead.extra.length & 0xff);
                $ae290cc08e298ace$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }
            if (s.gzhead.hcrc) strm.adler = $ae290cc08e298ace$var$crc32_1(strm.adler, s.pending_buf, s.pending, 0);
            s.gzindex = 0;
            s.status = $ae290cc08e298ace$var$EXTRA_STATE;
        }
    }
    if (s.status === $ae290cc08e298ace$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            var beg = s.pending; /* start of bytes to update crc */ 
            var left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
            while(s.pending + left > s.pending_buf_size){
                var copy = s.pending_buf_size - s.pending;
                // zmemcpy(s.pending_buf + s.pending,
                //    s.gzhead.extra + s.gzindex, copy);
                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                s.pending = s.pending_buf_size;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) strm.adler = $ae290cc08e298ace$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                //---//
                s.gzindex += copy;
                $ae290cc08e298ace$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $ae290cc08e298ace$var$Z_OK$3;
                }
                beg = 0;
                left -= copy;
            }
            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
            var gzhead_extra = new Uint8Array(s.gzhead.extra);
            // zmemcpy(s->pending_buf + s->pending,
            //     s->gzhead->extra + s->gzindex, left);
            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
            s.pending += left;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $ae290cc08e298ace$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $ae290cc08e298ace$var$NAME_STATE;
    }
    if (s.status === $ae290cc08e298ace$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            var beg1 = s.pending; /* start of bytes to update crc */ 
            var val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg1) strm.adler = $ae290cc08e298ace$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg1, beg1);
                    //---//
                    $ae290cc08e298ace$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $ae290cc08e298ace$var$Z_OK$3;
                    }
                    beg1 = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $ae290cc08e298ace$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg1) strm.adler = $ae290cc08e298ace$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg1, beg1);
            //---//
            s.gzindex = 0;
        }
        s.status = $ae290cc08e298ace$var$COMMENT_STATE;
    }
    if (s.status === $ae290cc08e298ace$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            var beg2 = s.pending; /* start of bytes to update crc */ 
            var val1;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg2) strm.adler = $ae290cc08e298ace$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg2, beg2);
                    //---//
                    $ae290cc08e298ace$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $ae290cc08e298ace$var$Z_OK$3;
                    }
                    beg2 = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val1 = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val1 = 0;
                $ae290cc08e298ace$var$put_byte(s, val1);
            }while (val1 !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg2) strm.adler = $ae290cc08e298ace$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg2, beg2);
        //---//
        }
        s.status = $ae290cc08e298ace$var$HCRC_STATE;
    }
    if (s.status === $ae290cc08e298ace$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
                $ae290cc08e298ace$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $ae290cc08e298ace$var$Z_OK$3;
                }
            }
            $ae290cc08e298ace$var$put_byte(s, strm.adler & 0xff);
            $ae290cc08e298ace$var$put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = $ae290cc08e298ace$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $ae290cc08e298ace$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $ae290cc08e298ace$var$Z_OK$3;
        }
    }
    //#endif
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $ae290cc08e298ace$var$Z_NO_FLUSH$2 && s.status !== $ae290cc08e298ace$var$FINISH_STATE) {
        var bstate = s.level === 0 ? $ae290cc08e298ace$var$deflate_stored(s, flush) : s.strategy === $ae290cc08e298ace$var$Z_HUFFMAN_ONLY ? $ae290cc08e298ace$var$deflate_huff(s, flush) : s.strategy === $ae290cc08e298ace$var$Z_RLE ? $ae290cc08e298ace$var$deflate_rle(s, flush) : $ae290cc08e298ace$var$configuration_table[s.level].func(s, flush);
        if (bstate === $ae290cc08e298ace$var$BS_FINISH_STARTED || bstate === $ae290cc08e298ace$var$BS_FINISH_DONE) s.status = $ae290cc08e298ace$var$FINISH_STATE;
        if (bstate === $ae290cc08e298ace$var$BS_NEED_MORE || bstate === $ae290cc08e298ace$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $ae290cc08e298ace$var$Z_OK$3;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $ae290cc08e298ace$var$BS_BLOCK_DONE) {
            if (flush === $ae290cc08e298ace$var$Z_PARTIAL_FLUSH) $ae290cc08e298ace$var$_tr_align(s);
            else if (flush !== $ae290cc08e298ace$var$Z_BLOCK$1) {
                $ae290cc08e298ace$var$_tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $ae290cc08e298ace$var$Z_FULL_FLUSH$1) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $ae290cc08e298ace$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $ae290cc08e298ace$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $ae290cc08e298ace$var$Z_OK$3;
            }
        }
    }
    if (flush !== $ae290cc08e298ace$var$Z_FINISH$3) return $ae290cc08e298ace$var$Z_OK$3;
    if (s.wrap <= 0) return $ae290cc08e298ace$var$Z_STREAM_END$3;
    /* Write the trailer */ if (s.wrap === 2) {
        $ae290cc08e298ace$var$put_byte(s, strm.adler & 0xff);
        $ae290cc08e298ace$var$put_byte(s, strm.adler >> 8 & 0xff);
        $ae290cc08e298ace$var$put_byte(s, strm.adler >> 16 & 0xff);
        $ae290cc08e298ace$var$put_byte(s, strm.adler >> 24 & 0xff);
        $ae290cc08e298ace$var$put_byte(s, strm.total_in & 0xff);
        $ae290cc08e298ace$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $ae290cc08e298ace$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $ae290cc08e298ace$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $ae290cc08e298ace$var$putShortMSB(s, strm.adler >>> 16);
        $ae290cc08e298ace$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $ae290cc08e298ace$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $ae290cc08e298ace$var$Z_OK$3 : $ae290cc08e298ace$var$Z_STREAM_END$3;
};
var $ae290cc08e298ace$var$deflateEnd = function(strm) {
    if ($ae290cc08e298ace$var$deflateStateCheck(strm)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$2;
    var status = strm.state.status;
    strm.state = null;
    return status === $ae290cc08e298ace$var$BUSY_STATE ? $ae290cc08e298ace$var$err(strm, $ae290cc08e298ace$var$Z_DATA_ERROR$2) : $ae290cc08e298ace$var$Z_OK$3;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ var $ae290cc08e298ace$var$deflateSetDictionary = function(strm, dictionary) {
    var dictLength = dictionary.length;
    if ($ae290cc08e298ace$var$deflateStateCheck(strm)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$2;
    var s = strm.state;
    var wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $ae290cc08e298ace$var$INIT_STATE || s.lookahead) return $ae290cc08e298ace$var$Z_STREAM_ERROR$2;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $ae290cc08e298ace$var$adler32_1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $ae290cc08e298ace$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        var tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ var avail = strm.avail_in;
    var next = strm.next_in;
    var input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $ae290cc08e298ace$var$fill_window(s);
    while(s.lookahead >= $ae290cc08e298ace$var$MIN_MATCH){
        var str = s.strstart;
        var n = s.lookahead - ($ae290cc08e298ace$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $ae290cc08e298ace$var$HASH(s, s.ins_h, s.window[str + $ae290cc08e298ace$var$MIN_MATCH - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $ae290cc08e298ace$var$MIN_MATCH - 1;
        $ae290cc08e298ace$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $ae290cc08e298ace$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $ae290cc08e298ace$var$Z_OK$3;
};
var $ae290cc08e298ace$var$deflateInit_1 = $ae290cc08e298ace$var$deflateInit;
var $ae290cc08e298ace$var$deflateInit2_1 = $ae290cc08e298ace$var$deflateInit2;
var $ae290cc08e298ace$var$deflateReset_1 = $ae290cc08e298ace$var$deflateReset;
var $ae290cc08e298ace$var$deflateResetKeep_1 = $ae290cc08e298ace$var$deflateResetKeep;
var $ae290cc08e298ace$var$deflateSetHeader_1 = $ae290cc08e298ace$var$deflateSetHeader;
var $ae290cc08e298ace$var$deflate_2$1 = $ae290cc08e298ace$var$deflate$2;
var $ae290cc08e298ace$var$deflateEnd_1 = $ae290cc08e298ace$var$deflateEnd;
var $ae290cc08e298ace$var$deflateSetDictionary_1 = $ae290cc08e298ace$var$deflateSetDictionary;
var $ae290cc08e298ace$var$deflateInfo = "pako deflate (from Nodeca project)";
/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var $ae290cc08e298ace$var$deflate_1$2 = {
    deflateInit: $ae290cc08e298ace$var$deflateInit_1,
    deflateInit2: $ae290cc08e298ace$var$deflateInit2_1,
    deflateReset: $ae290cc08e298ace$var$deflateReset_1,
    deflateResetKeep: $ae290cc08e298ace$var$deflateResetKeep_1,
    deflateSetHeader: $ae290cc08e298ace$var$deflateSetHeader_1,
    deflate: $ae290cc08e298ace$var$deflate_2$1,
    deflateEnd: $ae290cc08e298ace$var$deflateEnd_1,
    deflateSetDictionary: $ae290cc08e298ace$var$deflateSetDictionary_1,
    deflateInfo: $ae290cc08e298ace$var$deflateInfo
};
var $ae290cc08e298ace$var$_has = function(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var $ae290cc08e298ace$var$assign = function assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(var p in source)if ($ae290cc08e298ace$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// Join array of chunks to single array.
var $ae290cc08e298ace$var$flattenChunks = function(chunks) {
    // calculate data length
    var len = 0;
    for(var i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    var result = new Uint8Array(len);
    for(var i1 = 0, pos = 0, l1 = chunks.length; i1 < l1; i1++){
        var chunk = chunks[i1];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};
var $ae290cc08e298ace$var$common = {
    assign: $ae290cc08e298ace$var$assign,
    flattenChunks: $ae290cc08e298ace$var$flattenChunks
};
// String encode/decode helpers
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $ae290cc08e298ace$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $ae290cc08e298ace$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $ae290cc08e298ace$var$_utf8len = new Uint8Array(256);
for(var $ae290cc08e298ace$var$q = 0; $ae290cc08e298ace$var$q < 256; $ae290cc08e298ace$var$q++)$ae290cc08e298ace$var$_utf8len[$ae290cc08e298ace$var$q] = $ae290cc08e298ace$var$q >= 252 ? 6 : $ae290cc08e298ace$var$q >= 248 ? 5 : $ae290cc08e298ace$var$q >= 240 ? 4 : $ae290cc08e298ace$var$q >= 224 ? 3 : $ae290cc08e298ace$var$q >= 192 ? 2 : 1;
$ae290cc08e298ace$var$_utf8len[254] = $ae290cc08e298ace$var$_utf8len[254] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var $ae290cc08e298ace$var$string2buf = function(str) {
    if (typeof TextEncoder === "function" && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
var $ae290cc08e298ace$var$buf2binstring = function(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $ae290cc08e298ace$var$STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    var result = "";
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
// convert array to string
var $ae290cc08e298ace$var$buf2string = function(buf, max) {
    var len = max || buf.length;
    if (typeof TextDecoder === "function" && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
    var i, out;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        var c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        var c_len = $ae290cc08e298ace$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $ae290cc08e298ace$var$buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $ae290cc08e298ace$var$utf8border = function(buf, max) {
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    var pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $ae290cc08e298ace$var$_utf8len[buf[pos]] > max ? pos : max;
};
var $ae290cc08e298ace$var$strings = {
    string2buf: $ae290cc08e298ace$var$string2buf,
    buf2string: $ae290cc08e298ace$var$buf2string,
    utf8border: $ae290cc08e298ace$var$utf8border
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $ae290cc08e298ace$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var $ae290cc08e298ace$var$zstream = $ae290cc08e298ace$var$ZStream;
var $ae290cc08e298ace$var$toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $ae290cc08e298ace$var$Z_NO_FLUSH$1 = $ae290cc08e298ace$var$constants$2.Z_NO_FLUSH, $ae290cc08e298ace$var$Z_SYNC_FLUSH = $ae290cc08e298ace$var$constants$2.Z_SYNC_FLUSH, $ae290cc08e298ace$var$Z_FULL_FLUSH = $ae290cc08e298ace$var$constants$2.Z_FULL_FLUSH, $ae290cc08e298ace$var$Z_FINISH$2 = $ae290cc08e298ace$var$constants$2.Z_FINISH, $ae290cc08e298ace$var$Z_OK$2 = $ae290cc08e298ace$var$constants$2.Z_OK, $ae290cc08e298ace$var$Z_STREAM_END$2 = $ae290cc08e298ace$var$constants$2.Z_STREAM_END, $ae290cc08e298ace$var$Z_DEFAULT_COMPRESSION = $ae290cc08e298ace$var$constants$2.Z_DEFAULT_COMPRESSION, $ae290cc08e298ace$var$Z_DEFAULT_STRATEGY = $ae290cc08e298ace$var$constants$2.Z_DEFAULT_STRATEGY, $ae290cc08e298ace$var$Z_DEFLATED$1 = $ae290cc08e298ace$var$constants$2.Z_DEFLATED;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $ae290cc08e298ace$var$Deflate$1(options) {
    this.options = $ae290cc08e298ace$var$common.assign({
        level: $ae290cc08e298ace$var$Z_DEFAULT_COMPRESSION,
        method: $ae290cc08e298ace$var$Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $ae290cc08e298ace$var$Z_DEFAULT_STRATEGY
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $ae290cc08e298ace$var$zstream();
    this.strm.avail_out = 0;
    var status = $ae290cc08e298ace$var$deflate_1$2.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $ae290cc08e298ace$var$Z_OK$2) throw new Error($ae290cc08e298ace$var$messages[status]);
    if (opt.header) $ae290cc08e298ace$var$deflate_1$2.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === "string") // If we need to compress text, change encoding to utf8.
        dict = $ae290cc08e298ace$var$strings.string2buf(opt.dictionary);
        else if ($ae290cc08e298ace$var$toString$1.call(opt.dictionary) === "[object ArrayBuffer]") dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $ae290cc08e298ace$var$deflate_1$2.deflateSetDictionary(this.strm, dict);
        if (status !== $ae290cc08e298ace$var$Z_OK$2) throw new Error($ae290cc08e298ace$var$messages[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $ae290cc08e298ace$var$Deflate$1.prototype.push = function(data, flush_mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $ae290cc08e298ace$var$Z_FINISH$2 : $ae290cc08e298ace$var$Z_NO_FLUSH$1;
    // Convert data if needed
    if (typeof data === "string") // If we need to compress text, change encoding to utf8.
    strm.input = $ae290cc08e298ace$var$strings.string2buf(data);
    else if ($ae290cc08e298ace$var$toString$1.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === $ae290cc08e298ace$var$Z_SYNC_FLUSH || _flush_mode === $ae290cc08e298ace$var$Z_FULL_FLUSH) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = $ae290cc08e298ace$var$deflate_1$2.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === $ae290cc08e298ace$var$Z_STREAM_END$2) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = $ae290cc08e298ace$var$deflate_1$2.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === $ae290cc08e298ace$var$Z_OK$2;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $ae290cc08e298ace$var$Deflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $ae290cc08e298ace$var$Deflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $ae290cc08e298ace$var$Z_OK$2) this.result = $ae290cc08e298ace$var$common.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $ae290cc08e298ace$var$deflate$1(input, options) {
    var deflator = new $ae290cc08e298ace$var$Deflate$1(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $ae290cc08e298ace$var$messages[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $ae290cc08e298ace$var$deflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $ae290cc08e298ace$var$deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $ae290cc08e298ace$var$gzip$1(input, options) {
    options = options || {};
    options.gzip = true;
    return $ae290cc08e298ace$var$deflate$1(input, options);
}
var $ae290cc08e298ace$var$Deflate_1$1 = $ae290cc08e298ace$var$Deflate$1;
var $ae290cc08e298ace$var$deflate_2 = $ae290cc08e298ace$var$deflate$1;
var $ae290cc08e298ace$var$deflateRaw_1$1 = $ae290cc08e298ace$var$deflateRaw$1;
var $ae290cc08e298ace$var$gzip_1$1 = $ae290cc08e298ace$var$gzip$1;
var $ae290cc08e298ace$var$constants$1 = $ae290cc08e298ace$var$constants$2;
var $ae290cc08e298ace$var$deflate_1$1 = {
    Deflate: $ae290cc08e298ace$var$Deflate_1$1,
    deflate: $ae290cc08e298ace$var$deflate_2,
    deflateRaw: $ae290cc08e298ace$var$deflateRaw_1$1,
    gzip: $ae290cc08e298ace$var$gzip_1$1,
    constants: $ae290cc08e298ace$var$constants$1
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $ae290cc08e298ace$var$BAD$1 = 16209; /* got a data error -- remain here until reset */ 
var $ae290cc08e298ace$var$TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var $ae290cc08e298ace$var$inffast = function inflate_fast(strm, start) {
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ var state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = $ae290cc08e298ace$var$BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = $ae290cc08e298ace$var$BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = $ae290cc08e298ace$var$BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $ae290cc08e298ace$var$TYPE$1;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = $ae290cc08e298ace$var$BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $ae290cc08e298ace$var$MAXBITS = 15;
var $ae290cc08e298ace$var$ENOUGH_LENS$1 = 852;
var $ae290cc08e298ace$var$ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $ae290cc08e298ace$var$CODES$1 = 0;
var $ae290cc08e298ace$var$LENS$1 = 1;
var $ae290cc08e298ace$var$DISTS$1 = 2;
var $ae290cc08e298ace$var$lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
var $ae290cc08e298ace$var$lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
]);
var $ae290cc08e298ace$var$dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
var $ae290cc08e298ace$var$dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
var $ae290cc08e298ace$var$inflate_table = function(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    //  let shoextra;    /* extra bits table to use */
    var match; /* use base and extra for symbol >= match */ 
    var count = new Uint16Array($ae290cc08e298ace$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new Uint16Array($ae290cc08e298ace$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $ae290cc08e298ace$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $ae290cc08e298ace$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $ae290cc08e298ace$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $ae290cc08e298ace$var$CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $ae290cc08e298ace$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $ae290cc08e298ace$var$CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        match = 20;
    } else if (type === $ae290cc08e298ace$var$LENS$1) {
        base = $ae290cc08e298ace$var$lbase;
        extra = $ae290cc08e298ace$var$lext;
        match = 257;
    } else {
        base = $ae290cc08e298ace$var$dbase;
        extra = $ae290cc08e298ace$var$dext;
        match = 0;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $ae290cc08e298ace$var$LENS$1 && used > $ae290cc08e298ace$var$ENOUGH_LENS$1 || type === $ae290cc08e298ace$var$DISTS$1 && used > $ae290cc08e298ace$var$ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] + 1 < match) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] >= match) {
            here_op = extra[work[sym] - match];
            here_val = base[work[sym] - match];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $ae290cc08e298ace$var$LENS$1 && used > $ae290cc08e298ace$var$ENOUGH_LENS$1 || type === $ae290cc08e298ace$var$DISTS$1 && used > $ae290cc08e298ace$var$ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
var $ae290cc08e298ace$var$inftrees = $ae290cc08e298ace$var$inflate_table;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $ae290cc08e298ace$var$CODES = 0;
var $ae290cc08e298ace$var$LENS = 1;
var $ae290cc08e298ace$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $ae290cc08e298ace$var$Z_FINISH$1 = $ae290cc08e298ace$var$constants$2.Z_FINISH, $ae290cc08e298ace$var$Z_BLOCK = $ae290cc08e298ace$var$constants$2.Z_BLOCK, $ae290cc08e298ace$var$Z_TREES = $ae290cc08e298ace$var$constants$2.Z_TREES, $ae290cc08e298ace$var$Z_OK$1 = $ae290cc08e298ace$var$constants$2.Z_OK, $ae290cc08e298ace$var$Z_STREAM_END$1 = $ae290cc08e298ace$var$constants$2.Z_STREAM_END, $ae290cc08e298ace$var$Z_NEED_DICT$1 = $ae290cc08e298ace$var$constants$2.Z_NEED_DICT, $ae290cc08e298ace$var$Z_STREAM_ERROR$1 = $ae290cc08e298ace$var$constants$2.Z_STREAM_ERROR, $ae290cc08e298ace$var$Z_DATA_ERROR$1 = $ae290cc08e298ace$var$constants$2.Z_DATA_ERROR, $ae290cc08e298ace$var$Z_MEM_ERROR$1 = $ae290cc08e298ace$var$constants$2.Z_MEM_ERROR, $ae290cc08e298ace$var$Z_BUF_ERROR = $ae290cc08e298ace$var$constants$2.Z_BUF_ERROR, $ae290cc08e298ace$var$Z_DEFLATED = $ae290cc08e298ace$var$constants$2.Z_DEFLATED;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $ae290cc08e298ace$var$HEAD = 16180; /* i: waiting for magic header */ 
var $ae290cc08e298ace$var$FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
var $ae290cc08e298ace$var$TIME = 16182; /* i: waiting for modification time (gzip) */ 
var $ae290cc08e298ace$var$OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
var $ae290cc08e298ace$var$EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
var $ae290cc08e298ace$var$EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
var $ae290cc08e298ace$var$NAME = 16186; /* i: waiting for end of file name (gzip) */ 
var $ae290cc08e298ace$var$COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
var $ae290cc08e298ace$var$HCRC = 16188; /* i: waiting for header crc (gzip) */ 
var $ae290cc08e298ace$var$DICTID = 16189; /* i: waiting for dictionary check value */ 
var $ae290cc08e298ace$var$DICT = 16190; /* waiting for inflateSetDictionary() call */ 
var $ae290cc08e298ace$var$TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
var $ae290cc08e298ace$var$TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
var $ae290cc08e298ace$var$STORED = 16193; /* i: waiting for stored size (length and complement) */ 
var $ae290cc08e298ace$var$COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
var $ae290cc08e298ace$var$COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
var $ae290cc08e298ace$var$TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
var $ae290cc08e298ace$var$LENLENS = 16197; /* i: waiting for code length code lengths */ 
var $ae290cc08e298ace$var$CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
var $ae290cc08e298ace$var$LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
var $ae290cc08e298ace$var$LEN = 16200; /* i: waiting for length/lit/eob code */ 
var $ae290cc08e298ace$var$LENEXT = 16201; /* i: waiting for length extra bits */ 
var $ae290cc08e298ace$var$DIST = 16202; /* i: waiting for distance code */ 
var $ae290cc08e298ace$var$DISTEXT = 16203; /* i: waiting for distance extra bits */ 
var $ae290cc08e298ace$var$MATCH = 16204; /* o: waiting for output space to copy string */ 
var $ae290cc08e298ace$var$LIT = 16205; /* o: waiting for output space to write literal */ 
var $ae290cc08e298ace$var$CHECK = 16206; /* i: waiting for 32-bit check value */ 
var $ae290cc08e298ace$var$LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
var $ae290cc08e298ace$var$DONE = 16208; /* finished check, done -- remain here until reset */ 
var $ae290cc08e298ace$var$BAD = 16209; /* got a data error -- remain here until reset */ 
var $ae290cc08e298ace$var$MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
var $ae290cc08e298ace$var$SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $ae290cc08e298ace$var$ENOUGH_LENS = 852;
var $ae290cc08e298ace$var$ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $ae290cc08e298ace$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $ae290cc08e298ace$var$DEF_WBITS = $ae290cc08e298ace$var$MAX_WBITS;
var $ae290cc08e298ace$var$zswap32 = function(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function $ae290cc08e298ace$var$InflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
var $ae290cc08e298ace$var$inflateStateCheck = function(strm) {
    if (!strm) return 1;
    var state = strm.state;
    if (!state || state.strm !== strm || state.mode < $ae290cc08e298ace$var$HEAD || state.mode > $ae290cc08e298ace$var$SYNC) return 1;
    return 0;
};
var $ae290cc08e298ace$var$inflateResetKeep = function(strm) {
    if ($ae290cc08e298ace$var$inflateStateCheck(strm)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    var state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $ae290cc08e298ace$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.flags = -1;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array($ae290cc08e298ace$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array($ae290cc08e298ace$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $ae290cc08e298ace$var$Z_OK$1;
};
var $ae290cc08e298ace$var$inflateReset = function(strm) {
    if ($ae290cc08e298ace$var$inflateStateCheck(strm)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    var state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $ae290cc08e298ace$var$inflateResetKeep(strm);
};
var $ae290cc08e298ace$var$inflateReset2 = function(strm, windowBits) {
    var wrap;
    /* get the state */ if ($ae290cc08e298ace$var$inflateStateCheck(strm)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    var state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $ae290cc08e298ace$var$inflateReset(strm);
};
var $ae290cc08e298ace$var$inflateInit2 = function(strm, windowBits) {
    if (!strm) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    var state = new $ae290cc08e298ace$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.strm = strm;
    state.window = null /*Z_NULL*/ ;
    state.mode = $ae290cc08e298ace$var$HEAD; /* to pass state test in inflateReset2() */ 
    var ret = $ae290cc08e298ace$var$inflateReset2(strm, windowBits);
    if (ret !== $ae290cc08e298ace$var$Z_OK$1) strm.state = null /*Z_NULL*/ ;
    return ret;
};
var $ae290cc08e298ace$var$inflateInit = function(strm) {
    return $ae290cc08e298ace$var$inflateInit2(strm, $ae290cc08e298ace$var$DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $ae290cc08e298ace$var$virgin = true;
var $ae290cc08e298ace$var$lenfix, $ae290cc08e298ace$var$distfix; // We have no pointers in JS, so keep tables separate
var $ae290cc08e298ace$var$fixedtables = function(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($ae290cc08e298ace$var$virgin) {
        $ae290cc08e298ace$var$lenfix = new Int32Array(512);
        $ae290cc08e298ace$var$distfix = new Int32Array(32);
        /* literal/length table */ var sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $ae290cc08e298ace$var$inftrees($ae290cc08e298ace$var$LENS, state.lens, 0, 288, $ae290cc08e298ace$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $ae290cc08e298ace$var$inftrees($ae290cc08e298ace$var$DISTS, state.lens, 0, 32, $ae290cc08e298ace$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $ae290cc08e298ace$var$virgin = false;
    }
    state.lencode = $ae290cc08e298ace$var$lenfix;
    state.lenbits = 9;
    state.distcode = $ae290cc08e298ace$var$distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ var $ae290cc08e298ace$var$updatewindow = function(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
var $ae290cc08e298ace$var$inflate$2 = function(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary variable for NEED_BITS
    var order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if ($ae290cc08e298ace$var$inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === $ae290cc08e298ace$var$TYPE) state.mode = $ae290cc08e298ace$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $ae290cc08e298ace$var$Z_OK$1;
    inf_leave: for(;;)switch(state.mode){
        case $ae290cc08e298ace$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $ae290cc08e298ace$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                if (state.wbits === 0) state.wbits = 15;
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $ae290cc08e298ace$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $ae290cc08e298ace$var$FLAGS;
                break;
            }
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $ae290cc08e298ace$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            if (len > 15 || len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            state.flags = 0; /* indicate zlib header */ 
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $ae290cc08e298ace$var$DICTID : $ae290cc08e298ace$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $ae290cc08e298ace$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $ae290cc08e298ace$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $ae290cc08e298ace$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ae290cc08e298ace$var$TIME;
        /* falls through */ case $ae290cc08e298ace$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $ae290cc08e298ace$var$crc32_1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ae290cc08e298ace$var$OS;
        /* falls through */ case $ae290cc08e298ace$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $ae290cc08e298ace$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ae290cc08e298ace$var$EXLEN;
        /* falls through */ case $ae290cc08e298ace$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200 && state.wrap & 4) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $ae290cc08e298ace$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $ae290cc08e298ace$var$EXTRA;
        /* falls through */ case $ae290cc08e298ace$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) state.check = $ae290cc08e298ace$var$crc32_1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $ae290cc08e298ace$var$NAME;
        /* falls through */ case $ae290cc08e298ace$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $ae290cc08e298ace$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $ae290cc08e298ace$var$COMMENT;
        /* falls through */ case $ae290cc08e298ace$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $ae290cc08e298ace$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $ae290cc08e298ace$var$HCRC;
        /* falls through */ case $ae290cc08e298ace$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = $ae290cc08e298ace$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $ae290cc08e298ace$var$TYPE;
            break;
        case $ae290cc08e298ace$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $ae290cc08e298ace$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ae290cc08e298ace$var$DICT;
        /* falls through */ case $ae290cc08e298ace$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $ae290cc08e298ace$var$Z_NEED_DICT$1;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $ae290cc08e298ace$var$TYPE;
        /* falls through */ case $ae290cc08e298ace$var$TYPE:
            if (flush === $ae290cc08e298ace$var$Z_BLOCK || flush === $ae290cc08e298ace$var$Z_TREES) break inf_leave;
        /* falls through */ case $ae290cc08e298ace$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $ae290cc08e298ace$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $ae290cc08e298ace$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $ae290cc08e298ace$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $ae290cc08e298ace$var$LEN_; /* decode codes */ 
                    if (flush === $ae290cc08e298ace$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $ae290cc08e298ace$var$TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = $ae290cc08e298ace$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $ae290cc08e298ace$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ae290cc08e298ace$var$COPY_;
            if (flush === $ae290cc08e298ace$var$Z_TREES) break inf_leave;
        /* falls through */ case $ae290cc08e298ace$var$COPY_:
            state.mode = $ae290cc08e298ace$var$COPY;
        /* falls through */ case $ae290cc08e298ace$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $ae290cc08e298ace$var$TYPE;
            break;
        case $ae290cc08e298ace$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $ae290cc08e298ace$var$LENLENS;
        /* falls through */ case $ae290cc08e298ace$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $ae290cc08e298ace$var$inftrees($ae290cc08e298ace$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $ae290cc08e298ace$var$CODELENS;
        /* falls through */ case $ae290cc08e298ace$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = $ae290cc08e298ace$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = $ae290cc08e298ace$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $ae290cc08e298ace$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $ae290cc08e298ace$var$inftrees($ae290cc08e298ace$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $ae290cc08e298ace$var$inftrees($ae290cc08e298ace$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $ae290cc08e298ace$var$LEN_;
            if (flush === $ae290cc08e298ace$var$Z_TREES) break inf_leave;
        /* falls through */ case $ae290cc08e298ace$var$LEN_:
            state.mode = $ae290cc08e298ace$var$LEN;
        /* falls through */ case $ae290cc08e298ace$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $ae290cc08e298ace$var$inffast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $ae290cc08e298ace$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $ae290cc08e298ace$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $ae290cc08e298ace$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $ae290cc08e298ace$var$LENEXT;
        /* falls through */ case $ae290cc08e298ace$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $ae290cc08e298ace$var$DIST;
        /* falls through */ case $ae290cc08e298ace$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $ae290cc08e298ace$var$DISTEXT;
        /* falls through */ case $ae290cc08e298ace$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $ae290cc08e298ace$var$MATCH;
        /* falls through */ case $ae290cc08e298ace$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = $ae290cc08e298ace$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $ae290cc08e298ace$var$LEN;
            break;
        case $ae290cc08e298ace$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $ae290cc08e298ace$var$LEN;
            break;
        case $ae290cc08e298ace$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? $ae290cc08e298ace$var$crc32_1(state.check, output, _out, put - _out) : $ae290cc08e298ace$var$adler32_1(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if (state.wrap & 4 && (state.flags ? hold : $ae290cc08e298ace$var$zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = $ae290cc08e298ace$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $ae290cc08e298ace$var$LENGTH;
        /* falls through */ case $ae290cc08e298ace$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = $ae290cc08e298ace$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $ae290cc08e298ace$var$DONE;
        /* falls through */ case $ae290cc08e298ace$var$DONE:
            ret = $ae290cc08e298ace$var$Z_STREAM_END$1;
            break inf_leave;
        case $ae290cc08e298ace$var$BAD:
            ret = $ae290cc08e298ace$var$Z_DATA_ERROR$1;
            break inf_leave;
        case $ae290cc08e298ace$var$MEM:
            return $ae290cc08e298ace$var$Z_MEM_ERROR$1;
        case $ae290cc08e298ace$var$SYNC:
        /* falls through */ default:
            return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $ae290cc08e298ace$var$BAD && (state.mode < $ae290cc08e298ace$var$CHECK || flush !== $ae290cc08e298ace$var$Z_FINISH$1)) $ae290cc08e298ace$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? $ae290cc08e298ace$var$crc32_1(state.check, output, _out, strm.next_out - _out) : $ae290cc08e298ace$var$adler32_1(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $ae290cc08e298ace$var$TYPE ? 128 : 0) + (state.mode === $ae290cc08e298ace$var$LEN_ || state.mode === $ae290cc08e298ace$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $ae290cc08e298ace$var$Z_FINISH$1) && ret === $ae290cc08e298ace$var$Z_OK$1) ret = $ae290cc08e298ace$var$Z_BUF_ERROR;
    return ret;
};
var $ae290cc08e298ace$var$inflateEnd = function(strm) {
    if ($ae290cc08e298ace$var$inflateStateCheck(strm)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $ae290cc08e298ace$var$Z_OK$1;
};
var $ae290cc08e298ace$var$inflateGetHeader = function(strm, head) {
    /* check state */ if ($ae290cc08e298ace$var$inflateStateCheck(strm)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    var state = strm.state;
    if ((state.wrap & 2) === 0) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    /* save header structure */ state.head = head;
    head.done = false;
    return $ae290cc08e298ace$var$Z_OK$1;
};
var $ae290cc08e298ace$var$inflateSetDictionary = function(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if ($ae290cc08e298ace$var$inflateStateCheck(strm)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $ae290cc08e298ace$var$DICT) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    /* check for correct dictionary identifier */ if (state.mode === $ae290cc08e298ace$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $ae290cc08e298ace$var$adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $ae290cc08e298ace$var$Z_DATA_ERROR$1;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $ae290cc08e298ace$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $ae290cc08e298ace$var$MEM;
        return $ae290cc08e298ace$var$Z_MEM_ERROR$1;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $ae290cc08e298ace$var$Z_OK$1;
};
var $ae290cc08e298ace$var$inflateReset_1 = $ae290cc08e298ace$var$inflateReset;
var $ae290cc08e298ace$var$inflateReset2_1 = $ae290cc08e298ace$var$inflateReset2;
var $ae290cc08e298ace$var$inflateResetKeep_1 = $ae290cc08e298ace$var$inflateResetKeep;
var $ae290cc08e298ace$var$inflateInit_1 = $ae290cc08e298ace$var$inflateInit;
var $ae290cc08e298ace$var$inflateInit2_1 = $ae290cc08e298ace$var$inflateInit2;
var $ae290cc08e298ace$var$inflate_2$1 = $ae290cc08e298ace$var$inflate$2;
var $ae290cc08e298ace$var$inflateEnd_1 = $ae290cc08e298ace$var$inflateEnd;
var $ae290cc08e298ace$var$inflateGetHeader_1 = $ae290cc08e298ace$var$inflateGetHeader;
var $ae290cc08e298ace$var$inflateSetDictionary_1 = $ae290cc08e298ace$var$inflateSetDictionary;
var $ae290cc08e298ace$var$inflateInfo = "pako inflate (from Nodeca project)";
/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ var $ae290cc08e298ace$var$inflate_1$2 = {
    inflateReset: $ae290cc08e298ace$var$inflateReset_1,
    inflateReset2: $ae290cc08e298ace$var$inflateReset2_1,
    inflateResetKeep: $ae290cc08e298ace$var$inflateResetKeep_1,
    inflateInit: $ae290cc08e298ace$var$inflateInit_1,
    inflateInit2: $ae290cc08e298ace$var$inflateInit2_1,
    inflate: $ae290cc08e298ace$var$inflate_2$1,
    inflateEnd: $ae290cc08e298ace$var$inflateEnd_1,
    inflateGetHeader: $ae290cc08e298ace$var$inflateGetHeader_1,
    inflateSetDictionary: $ae290cc08e298ace$var$inflateSetDictionary_1,
    inflateInfo: $ae290cc08e298ace$var$inflateInfo
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $ae290cc08e298ace$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = "";
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = "";
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var $ae290cc08e298ace$var$gzheader = $ae290cc08e298ace$var$GZheader;
var $ae290cc08e298ace$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $ae290cc08e298ace$var$Z_NO_FLUSH = $ae290cc08e298ace$var$constants$2.Z_NO_FLUSH, $ae290cc08e298ace$var$Z_FINISH = $ae290cc08e298ace$var$constants$2.Z_FINISH, $ae290cc08e298ace$var$Z_OK = $ae290cc08e298ace$var$constants$2.Z_OK, $ae290cc08e298ace$var$Z_STREAM_END = $ae290cc08e298ace$var$constants$2.Z_STREAM_END, $ae290cc08e298ace$var$Z_NEED_DICT = $ae290cc08e298ace$var$constants$2.Z_NEED_DICT, $ae290cc08e298ace$var$Z_STREAM_ERROR = $ae290cc08e298ace$var$constants$2.Z_STREAM_ERROR, $ae290cc08e298ace$var$Z_DATA_ERROR = $ae290cc08e298ace$var$constants$2.Z_DATA_ERROR, $ae290cc08e298ace$var$Z_MEM_ERROR = $ae290cc08e298ace$var$constants$2.Z_MEM_ERROR;
/* ===========================================================================*/ /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $ae290cc08e298ace$var$Inflate$1(options) {
    this.options = $ae290cc08e298ace$var$common.assign({
        chunkSize: 65536,
        windowBits: 15,
        to: ""
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $ae290cc08e298ace$var$zstream();
    this.strm.avail_out = 0;
    var status = $ae290cc08e298ace$var$inflate_1$2.inflateInit2(this.strm, opt.windowBits);
    if (status !== $ae290cc08e298ace$var$Z_OK) throw new Error($ae290cc08e298ace$var$messages[status]);
    this.header = new $ae290cc08e298ace$var$gzheader();
    $ae290cc08e298ace$var$inflate_1$2.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === "string") opt.dictionary = $ae290cc08e298ace$var$strings.string2buf(opt.dictionary);
        else if ($ae290cc08e298ace$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $ae290cc08e298ace$var$inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $ae290cc08e298ace$var$Z_OK) throw new Error($ae290cc08e298ace$var$messages[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $ae290cc08e298ace$var$Inflate$1.prototype.push = function(data, flush_mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $ae290cc08e298ace$var$Z_FINISH : $ae290cc08e298ace$var$Z_NO_FLUSH;
    // Convert data if needed
    if ($ae290cc08e298ace$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $ae290cc08e298ace$var$inflate_1$2.inflate(strm, _flush_mode);
        if (status === $ae290cc08e298ace$var$Z_NEED_DICT && dictionary) {
            status = $ae290cc08e298ace$var$inflate_1$2.inflateSetDictionary(strm, dictionary);
            if (status === $ae290cc08e298ace$var$Z_OK) status = $ae290cc08e298ace$var$inflate_1$2.inflate(strm, _flush_mode);
            else if (status === $ae290cc08e298ace$var$Z_DATA_ERROR) // Replace code with more verbose
            status = $ae290cc08e298ace$var$Z_NEED_DICT;
        }
        // Skip snyc markers if more data follows and not raw mode
        while(strm.avail_in > 0 && status === $ae290cc08e298ace$var$Z_STREAM_END && strm.state.wrap > 0 && data[strm.next_in] !== 0){
            $ae290cc08e298ace$var$inflate_1$2.inflateReset(strm);
            status = $ae290cc08e298ace$var$inflate_1$2.inflate(strm, _flush_mode);
        }
        switch(status){
            case $ae290cc08e298ace$var$Z_STREAM_ERROR:
            case $ae290cc08e298ace$var$Z_DATA_ERROR:
            case $ae290cc08e298ace$var$Z_NEED_DICT:
            case $ae290cc08e298ace$var$Z_MEM_ERROR:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $ae290cc08e298ace$var$Z_STREAM_END) {
                if (this.options.to === "string") {
                    var next_out_utf8 = $ae290cc08e298ace$var$strings.utf8border(strm.output, strm.next_out);
                    var tail = strm.next_out - next_out_utf8;
                    var utf8str = $ae290cc08e298ace$var$strings.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
        }
        // Must repeat iteration if out buffer is full
        if (status === $ae290cc08e298ace$var$Z_OK && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === $ae290cc08e298ace$var$Z_STREAM_END) {
            status = $ae290cc08e298ace$var$inflate_1$2.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $ae290cc08e298ace$var$Inflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $ae290cc08e298ace$var$Inflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $ae290cc08e298ace$var$Z_OK) {
        if (this.options.to === "string") this.result = this.chunks.join("");
        else this.result = $ae290cc08e298ace$var$common.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function $ae290cc08e298ace$var$inflate$1(input, options) {
    var inflator = new $ae290cc08e298ace$var$Inflate$1(options);
    inflator.push(input);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $ae290cc08e298ace$var$messages[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $ae290cc08e298ace$var$inflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $ae290cc08e298ace$var$inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $ae290cc08e298ace$var$Inflate_1$1 = $ae290cc08e298ace$var$Inflate$1;
var $ae290cc08e298ace$var$inflate_2 = $ae290cc08e298ace$var$inflate$1;
var $ae290cc08e298ace$var$inflateRaw_1$1 = $ae290cc08e298ace$var$inflateRaw$1;
var $ae290cc08e298ace$var$ungzip$1 = $ae290cc08e298ace$var$inflate$1;
var $ae290cc08e298ace$var$constants = $ae290cc08e298ace$var$constants$2;
var $ae290cc08e298ace$var$inflate_1$1 = {
    Inflate: $ae290cc08e298ace$var$Inflate_1$1,
    inflate: $ae290cc08e298ace$var$inflate_2,
    inflateRaw: $ae290cc08e298ace$var$inflateRaw_1$1,
    ungzip: $ae290cc08e298ace$var$ungzip$1,
    constants: $ae290cc08e298ace$var$constants
};
var $ae290cc08e298ace$var$Deflate = $ae290cc08e298ace$var$deflate_1$1.Deflate, $ae290cc08e298ace$var$deflate = $ae290cc08e298ace$var$deflate_1$1.deflate, $ae290cc08e298ace$var$deflateRaw = $ae290cc08e298ace$var$deflate_1$1.deflateRaw, $ae290cc08e298ace$var$gzip = $ae290cc08e298ace$var$deflate_1$1.gzip;
var $ae290cc08e298ace$var$Inflate = $ae290cc08e298ace$var$inflate_1$1.Inflate, $ae290cc08e298ace$var$inflate = $ae290cc08e298ace$var$inflate_1$1.inflate, $ae290cc08e298ace$var$inflateRaw = $ae290cc08e298ace$var$inflate_1$1.inflateRaw, $ae290cc08e298ace$var$ungzip = $ae290cc08e298ace$var$inflate_1$1.ungzip;
var $ae290cc08e298ace$export$ae157b6234afe138 = $ae290cc08e298ace$var$Deflate;
var $ae290cc08e298ace$export$2316623ecd1285ab = $ae290cc08e298ace$var$deflate;
var $ae290cc08e298ace$export$e95d6a8f69fb340a = $ae290cc08e298ace$var$deflateRaw;
var $ae290cc08e298ace$export$69f0ea7cf3a331a8 = $ae290cc08e298ace$var$gzip;
var $ae290cc08e298ace$export$d1de70a877d6e43c = $ae290cc08e298ace$var$Inflate;
var $ae290cc08e298ace$export$cae1ce83fe4a1782 = $ae290cc08e298ace$var$inflate;
var $ae290cc08e298ace$export$d0f0aa2d05c905c5 = $ae290cc08e298ace$var$inflateRaw;
var $ae290cc08e298ace$export$95adf9d270383091 = $ae290cc08e298ace$var$ungzip;
var $ae290cc08e298ace$export$1a988e7317c65621 = $ae290cc08e298ace$var$constants$2;
var $ae290cc08e298ace$export$2e2bcd8739ae039 = {
    Deflate: $ae290cc08e298ace$export$ae157b6234afe138,
    deflate: $ae290cc08e298ace$export$2316623ecd1285ab,
    deflateRaw: $ae290cc08e298ace$export$e95d6a8f69fb340a,
    gzip: $ae290cc08e298ace$export$69f0ea7cf3a331a8,
    Inflate: $ae290cc08e298ace$export$d1de70a877d6e43c,
    inflate: $ae290cc08e298ace$export$cae1ce83fe4a1782,
    inflateRaw: $ae290cc08e298ace$export$d0f0aa2d05c905c5,
    ungzip: $ae290cc08e298ace$export$95adf9d270383091,
    constants: $ae290cc08e298ace$export$1a988e7317c65621
};

});

parcelRequire.register("1hVk2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    version: "0.4",
    cacheApiUrl: "https://api.redstone.finance/prices"
};

});


parcelRequire.register("hxn3s", function(module, exports) {
"use strict";
var $cc4766f34932b7f5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cc4766f34932b7f5$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};
var $cc4766f34932b7f5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cc4766f34932b7f5$var$axios_1 = $cc4766f34932b7f5$var$__importDefault((parcelRequire("beWf2")));

var $cc4766f34932b7f5$var$lodash_1 = $cc4766f34932b7f5$var$__importDefault((parcelRequire("c9wMV")));
var $cc4766f34932b7f5$var$CacheProxy = /** @class */ function() {
    var CacheProxy = function CacheProxy(cacheApiUrl) {
        this.cacheApiUrl = cacheApiUrl;
    };
    CacheProxy.prototype.setCacheApiUrl = function(cacheApiUrl) {
        this.cacheApiUrl = cacheApiUrl;
    };
    CacheProxy.prototype.getPrice = function(args) {
        return $cc4766f34932b7f5$var$__awaiter(this, void 0, void 0, function() {
            var params, data;
            return $cc4766f34932b7f5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        params = {
                            symbol: args.symbol,
                            provider: args.provider,
                            limit: 1
                        };
                        // If timestamp is passed we fetch the latest price
                        // with timestamp which is less or equal to the passed one
                        if (args.timestamp !== undefined) params.toTimestamp = args.timestamp;
                        return [
                            4 /*yield*/ ,
                            $cc4766f34932b7f5$var$axios_1.default.get(this.cacheApiUrl, {
                                params: params
                            })
                        ];
                    case 1:
                        data = _a.sent().data;
                        if (Array.isArray(data) && data.length === 1) return [
                            2 /*return*/ ,
                            data[0]
                        ];
                        else return [
                            2 /*return*/ ,
                            undefined
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // If 'symbols' is not passed it will fetch prices for all tokens
    CacheProxy.prototype.getPriceForManyTokens = function(args) {
        return $cc4766f34932b7f5$var$__awaiter(this, void 0, void 0, function() {
            var params, data;
            return $cc4766f34932b7f5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        params = {
                            provider: args.provider,
                            toTimestamp: args.timestamp
                        };
                        if (args.symbols !== undefined) params.symbols = args.symbols.join(",");
                        return [
                            4 /*yield*/ ,
                            $cc4766f34932b7f5$var$axios_1.default.get(this.cacheApiUrl, {
                                params: params
                            })
                        ];
                    case 1:
                        data = _a.sent().data;
                        return [
                            2 /*return*/ ,
                            data
                        ];
                }
            });
        });
    };
    CacheProxy.prototype.getManyPrices = function(args) {
        return $cc4766f34932b7f5$var$__awaiter(this, void 0, void 0, function() {
            var params, data;
            return $cc4766f34932b7f5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        params = $cc4766f34932b7f5$var$lodash_1.default.pickBy(args, function(prop) {
                            return !$cc4766f34932b7f5$var$lodash_1.default.isUndefined(prop);
                        });
                        return [
                            4 /*yield*/ ,
                            $cc4766f34932b7f5$var$axios_1.default.get(this.cacheApiUrl, {
                                params: params
                            })
                        ];
                    case 1:
                        data = _a.sent().data;
                        return [
                            2 /*return*/ ,
                            data
                        ];
                }
            });
        });
    };
    return CacheProxy;
}();
module.exports.default = $cc4766f34932b7f5$var$CacheProxy;

});
parcelRequire.register("beWf2", function(module, exports) {

module.exports = (parcelRequire("guR8Q"));

});
parcelRequire.register("guR8Q", function(module, exports) {
"use strict";

var $6M2NN = parcelRequire("6M2NN");

var $8W916 = parcelRequire("8W916");

var $9NdVB = parcelRequire("9NdVB");

var $eYwfa = parcelRequire("eYwfa");

var $fJJjN = parcelRequire("fJJjN");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $c028ab87eadabd9f$var$createInstance(defaultConfig) {
    var context = new $9NdVB(defaultConfig);
    var instance = $8W916($9NdVB.prototype.request, context);
    // Copy axios.prototype to instance
    $6M2NN.extend(instance, $9NdVB.prototype, context);
    // Copy context to instance
    $6M2NN.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $c028ab87eadabd9f$var$axios = $c028ab87eadabd9f$var$createInstance($fJJjN);
// Expose Axios class to allow class inheritance
$c028ab87eadabd9f$var$axios.Axios = $9NdVB;
// Factory for creating new instances
$c028ab87eadabd9f$var$axios.create = function create(instanceConfig) {
    return $c028ab87eadabd9f$var$createInstance($eYwfa($c028ab87eadabd9f$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$c028ab87eadabd9f$var$axios.Cancel = (parcelRequire("mdl0Z"));

$c028ab87eadabd9f$var$axios.CancelToken = (parcelRequire("fddxN"));

$c028ab87eadabd9f$var$axios.isCancel = (parcelRequire("e6Vmb"));
// Expose all/spread
$c028ab87eadabd9f$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$c028ab87eadabd9f$var$axios.spread = (parcelRequire("hTUrd"));

// Expose isAxiosError
$c028ab87eadabd9f$var$axios.isAxiosError = (parcelRequire("1ykJp"));
module.exports = $c028ab87eadabd9f$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $c028ab87eadabd9f$var$axios;

});
parcelRequire.register("6M2NN", function(module, exports) {
"use strict";

var $8W916 = parcelRequire("8W916");
// utils is a library of generic helper functions non-specific to axios
var $4ee9663eb1966d03$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $4ee9663eb1966d03$var$isArray(val) {
    return $4ee9663eb1966d03$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $4ee9663eb1966d03$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $4ee9663eb1966d03$var$isBuffer(val) {
    return val !== null && !$4ee9663eb1966d03$var$isUndefined(val) && val.constructor !== null && !$4ee9663eb1966d03$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $4ee9663eb1966d03$var$isArrayBuffer(val) {
    return $4ee9663eb1966d03$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $4ee9663eb1966d03$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $4ee9663eb1966d03$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $4ee9663eb1966d03$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $4ee9663eb1966d03$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $4ee9663eb1966d03$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $4ee9663eb1966d03$var$isPlainObject(val) {
    if ($4ee9663eb1966d03$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $4ee9663eb1966d03$var$isDate(val) {
    return $4ee9663eb1966d03$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $4ee9663eb1966d03$var$isFile(val) {
    return $4ee9663eb1966d03$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $4ee9663eb1966d03$var$isBlob(val) {
    return $4ee9663eb1966d03$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $4ee9663eb1966d03$var$isFunction(val) {
    return $4ee9663eb1966d03$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $4ee9663eb1966d03$var$isStream(val) {
    return $4ee9663eb1966d03$var$isObject(val) && $4ee9663eb1966d03$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $4ee9663eb1966d03$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $4ee9663eb1966d03$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $4ee9663eb1966d03$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $4ee9663eb1966d03$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($4ee9663eb1966d03$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $4ee9663eb1966d03$var$merge() {
    var assignValue = function assignValue(val, key) {
        if ($4ee9663eb1966d03$var$isPlainObject(result[key]) && $4ee9663eb1966d03$var$isPlainObject(val)) result[key] = $4ee9663eb1966d03$var$merge(result[key], val);
        else if ($4ee9663eb1966d03$var$isPlainObject(val)) result[key] = $4ee9663eb1966d03$var$merge({}, val);
        else if ($4ee9663eb1966d03$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    };
    var result = {};
    for(var i = 0, l = arguments.length; i < l; i++)$4ee9663eb1966d03$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $4ee9663eb1966d03$var$extend(a, b, thisArg) {
    $4ee9663eb1966d03$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $8W916(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $4ee9663eb1966d03$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $4ee9663eb1966d03$var$isArray,
    isArrayBuffer: $4ee9663eb1966d03$var$isArrayBuffer,
    isBuffer: $4ee9663eb1966d03$var$isBuffer,
    isFormData: $4ee9663eb1966d03$var$isFormData,
    isArrayBufferView: $4ee9663eb1966d03$var$isArrayBufferView,
    isString: $4ee9663eb1966d03$var$isString,
    isNumber: $4ee9663eb1966d03$var$isNumber,
    isObject: $4ee9663eb1966d03$var$isObject,
    isPlainObject: $4ee9663eb1966d03$var$isPlainObject,
    isUndefined: $4ee9663eb1966d03$var$isUndefined,
    isDate: $4ee9663eb1966d03$var$isDate,
    isFile: $4ee9663eb1966d03$var$isFile,
    isBlob: $4ee9663eb1966d03$var$isBlob,
    isFunction: $4ee9663eb1966d03$var$isFunction,
    isStream: $4ee9663eb1966d03$var$isStream,
    isURLSearchParams: $4ee9663eb1966d03$var$isURLSearchParams,
    isStandardBrowserEnv: $4ee9663eb1966d03$var$isStandardBrowserEnv,
    forEach: $4ee9663eb1966d03$var$forEach,
    merge: $4ee9663eb1966d03$var$merge,
    extend: $4ee9663eb1966d03$var$extend,
    trim: $4ee9663eb1966d03$var$trim,
    stripBOM: $4ee9663eb1966d03$var$stripBOM
};

});
parcelRequire.register("8W916", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRequire.register("9NdVB", function(module, exports) {
"use strict";

var $6M2NN = parcelRequire("6M2NN");

var $cR4lP = parcelRequire("cR4lP");

var $8Up3k = parcelRequire("8Up3k");

var $jVmdK = parcelRequire("jVmdK");

var $eYwfa = parcelRequire("eYwfa");

var $3xf9R = parcelRequire("3xf9R");
var $72137e7fcce22d21$var$validators = $3xf9R.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $72137e7fcce22d21$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $8Up3k(),
        response: new $8Up3k()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $72137e7fcce22d21$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $eYwfa(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $3xf9R.assertOptions(transitional, {
        silentJSONParsing: $72137e7fcce22d21$var$validators.transitional($72137e7fcce22d21$var$validators.boolean, "1.0.0"),
        forcedJSONParsing: $72137e7fcce22d21$var$validators.transitional($72137e7fcce22d21$var$validators.boolean, "1.0.0"),
        clarifyTimeoutError: $72137e7fcce22d21$var$validators.transitional($72137e7fcce22d21$var$validators.boolean, "1.0.0")
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $jVmdK,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $jVmdK(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$72137e7fcce22d21$var$Axios.prototype.getUri = function getUri(config) {
    config = $eYwfa(this.defaults, config);
    return $cR4lP(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$6M2NN.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $72137e7fcce22d21$var$Axios.prototype[method] = function(url, config) {
        return this.request($eYwfa(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$6M2NN.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $72137e7fcce22d21$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($eYwfa(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $72137e7fcce22d21$var$Axios;

});
parcelRequire.register("cR4lP", function(module, exports) {
"use strict";

var $6M2NN = parcelRequire("6M2NN");
function $95bdcf47ba86ee44$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($6M2NN.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $6M2NN.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($6M2NN.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $6M2NN.forEach(val, function parseValue(v) {
                if ($6M2NN.isDate(v)) v = v.toISOString();
                else if ($6M2NN.isObject(v)) v = JSON.stringify(v);
                parts.push($95bdcf47ba86ee44$var$encode(key) + "=" + $95bdcf47ba86ee44$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRequire.register("8Up3k", function(module, exports) {
"use strict";

var $6M2NN = parcelRequire("6M2NN");
function $67c6fc9c35e80c75$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $67c6fc9c35e80c75$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $67c6fc9c35e80c75$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $67c6fc9c35e80c75$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $6M2NN.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $67c6fc9c35e80c75$var$InterceptorManager;

});

parcelRequire.register("jVmdK", function(module, exports) {
"use strict";

var $6M2NN = parcelRequire("6M2NN");

var $hgcK5 = parcelRequire("hgcK5");

var $e6Vmb = parcelRequire("e6Vmb");

var $fJJjN = parcelRequire("fJJjN");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $e81493c5bd025cca$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $e81493c5bd025cca$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $hgcK5.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $6M2NN.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $6M2NN.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $fJJjN.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $e81493c5bd025cca$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $hgcK5.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$e6Vmb(reason)) {
            $e81493c5bd025cca$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $hgcK5.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRequire.register("hgcK5", function(module, exports) {
"use strict";

var $6M2NN = parcelRequire("6M2NN");

var $fJJjN = parcelRequire("fJJjN");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $fJJjN;
    /*eslint no-param-reassign:0*/ $6M2NN.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRequire.register("fJJjN", function(module, exports) {

var $aqbQf = parcelRequire("aqbQf");
"use strict";

var $6M2NN = parcelRequire("6M2NN");

var $9zMLP = parcelRequire("9zMLP");

var $37cEJ = parcelRequire("37cEJ");
var $b74e363d9f233881$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $b74e363d9f233881$var$setContentTypeIfUnset(headers, value) {
    if (!$6M2NN.isUndefined(headers) && $6M2NN.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $b74e363d9f233881$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("frpE3"));
    else if (typeof $aqbQf !== "undefined" && Object.prototype.toString.call($aqbQf) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("frpE3"));
    return adapter;
}
function $b74e363d9f233881$var$stringifySafely(rawValue, parser, encoder) {
    if ($6M2NN.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $6M2NN.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $b74e363d9f233881$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $b74e363d9f233881$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $9zMLP(headers, "Accept");
            $9zMLP(headers, "Content-Type");
            if ($6M2NN.isFormData(data) || $6M2NN.isArrayBuffer(data) || $6M2NN.isBuffer(data) || $6M2NN.isStream(data) || $6M2NN.isFile(data) || $6M2NN.isBlob(data)) return data;
            if ($6M2NN.isArrayBufferView(data)) return data.buffer;
            if ($6M2NN.isURLSearchParams(data)) {
                $b74e363d9f233881$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($6M2NN.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $b74e363d9f233881$var$setContentTypeIfUnset(headers, "application/json");
                return $b74e363d9f233881$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $6M2NN.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $37cEJ(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$b74e363d9f233881$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$6M2NN.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $b74e363d9f233881$var$defaults.headers[method] = {};
});
$6M2NN.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $b74e363d9f233881$var$defaults.headers[method] = $6M2NN.merge($b74e363d9f233881$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $b74e363d9f233881$var$defaults;

});
parcelRequire.register("9zMLP", function(module, exports) {
"use strict";

var $6M2NN = parcelRequire("6M2NN");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $6M2NN.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRequire.register("37cEJ", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRequire.register("frpE3", function(module, exports) {
"use strict";

var $6M2NN = parcelRequire("6M2NN");

var $fRdSR = parcelRequire("fRdSR");

var $dKDGP = parcelRequire("dKDGP");

var $cR4lP = parcelRequire("cR4lP");

var $2hDOH = parcelRequire("2hDOH");

var $bWkQ7 = parcelRequire("bWkQ7");

var $anhPo = parcelRequire("anhPo");

var $8fiCk = parcelRequire("8fiCk");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var onloadend = function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $bWkQ7(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $fRdSR(resolve, reject, response);
            // Clean up request
            request = null;
        };
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($6M2NN.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $2hDOH(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $cR4lP(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($8fiCk("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($8fiCk("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($8fiCk(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($6M2NN.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $anhPo(fullPath)) && config.xsrfCookieName ? $dKDGP.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $6M2NN.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$6M2NN.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRequire.register("fRdSR", function(module, exports) {
"use strict";

var $8fiCk = parcelRequire("8fiCk");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($8fiCk("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRequire.register("8fiCk", function(module, exports) {
"use strict";

var $37cEJ = parcelRequire("37cEJ");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $37cEJ(error, config, code, request, response);
};

});


parcelRequire.register("dKDGP", function(module, exports) {
"use strict";

var $6M2NN = parcelRequire("6M2NN");
module.exports = $6M2NN.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($6M2NN.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($6M2NN.isString(path)) cookie.push("path=" + path);
            if ($6M2NN.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRequire.register("2hDOH", function(module, exports) {
"use strict";

var $jQtqM = parcelRequire("jQtqM");

var $6seP4 = parcelRequire("6seP4");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$jQtqM(requestedURL)) return $6seP4(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRequire.register("jQtqM", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRequire.register("6seP4", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRequire.register("bWkQ7", function(module, exports) {
"use strict";

var $6M2NN = parcelRequire("6M2NN");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $8b1546d2a561e088$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $6M2NN.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $6M2NN.trim(line.substr(0, i)).toLowerCase();
        val = $6M2NN.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $8b1546d2a561e088$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRequire.register("anhPo", function(module, exports) {
"use strict";

var $6M2NN = parcelRequire("6M2NN");
module.exports = $6M2NN.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var resolveURL = /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    };
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $6M2NN.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRequire.register("e6Vmb", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRequire.register("eYwfa", function(module, exports) {
"use strict";

var $6M2NN = parcelRequire("6M2NN");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    var getMergedValue = function getMergedValue(target, source) {
        if ($6M2NN.isPlainObject(target) && $6M2NN.isPlainObject(source)) return $6M2NN.merge(target, source);
        else if ($6M2NN.isPlainObject(source)) return $6M2NN.merge({}, source);
        else if ($6M2NN.isArray(source)) return source.slice();
        return source;
    };
    var mergeDeepProperties = function mergeDeepProperties(prop) {
        if (!$6M2NN.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$6M2NN.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    };
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    $6M2NN.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$6M2NN.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $6M2NN.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $6M2NN.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$6M2NN.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$6M2NN.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $6M2NN.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $6M2NN.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRequire.register("3xf9R", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
"use strict";

var $bEv1Y = parcelRequire("bEv1Y");
var $293036394f43293a$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $293036394f43293a$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $1ObTH._)(thing)) === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $293036394f43293a$var$deprecatedWarnings = {};
var $293036394f43293a$var$currentVerArr = $bEv1Y.version.split(".");
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $293036394f43293a$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split(".") : $293036394f43293a$var$currentVerArr;
    var destVer = version.split(".");
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $293036394f43293a$var$validators.transitional = function transitional(validator, version, message) {
    var formatMessage = function formatMessage(opt, desc) {
        return "[Axios v" + $bEv1Y.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    };
    var isDeprecated = version && $293036394f43293a$var$isOlderVersion(version);
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed in " + version));
        if (isDeprecated && !$293036394f43293a$var$deprecatedWarnings[opt]) {
            $293036394f43293a$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $293036394f43293a$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    isOlderVersion: $293036394f43293a$var$isOlderVersion,
    assertOptions: $293036394f43293a$var$assertOptions,
    validators: $293036394f43293a$var$validators
};

});
parcelRequire.register("bEv1Y", function(module, exports) {
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

});



parcelRequire.register("mdl0Z", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $042c66d3f307a620$var$Cancel(message) {
    this.message = message;
}
$042c66d3f307a620$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$042c66d3f307a620$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $042c66d3f307a620$var$Cancel;

});

parcelRequire.register("fddxN", function(module, exports) {
"use strict";

var $mdl0Z = parcelRequire("mdl0Z");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $b1329379d13270fa$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $mdl0Z(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $b1329379d13270fa$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $b1329379d13270fa$var$CancelToken.source = function source() {
    var cancel;
    var token = new $b1329379d13270fa$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $b1329379d13270fa$var$CancelToken;

});

parcelRequire.register("hTUrd", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRequire.register("1ykJp", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});




parcelRequire.register("6Logc", function(module, exports) {
"use strict";
var $4ec9f37979ce8f98$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4ec9f37979ce8f98$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};
var $4ec9f37979ce8f98$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4ec9f37979ce8f98$var$deep_sort_object_1 = $4ec9f37979ce8f98$var$__importDefault((parcelRequire("8No3X")));

var $4ec9f37979ce8f98$var$lodash_1 = $4ec9f37979ce8f98$var$__importDefault((parcelRequire("c9wMV")));
var $4ec9f37979ce8f98$var$SignatureVerifier = /** @class */ function() {
    var SignatureVerifier = function SignatureVerifier(arweaveProxy) {
        this.arweaveProxy = arweaveProxy;
    };
    SignatureVerifier.prototype.assertValidSignature = function(_price) {
        return $4ec9f37979ce8f98$var$__awaiter(this, void 0, void 0, function() {
            return $4ec9f37979ce8f98$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    SignatureVerifier.prototype.getPriceSignedData = function(price) {
        var _a;
        var priceWithPickedProps = $4ec9f37979ce8f98$var$lodash_1.default.pick(price, [
            "id",
            "source",
            "symbol",
            "timestamp",
            "version",
            "value",
            "permawebTx",
            "provider"
        ]);
        if (price.version === "3" || ((_a = price.version) === null || _a === void 0 ? void 0 : _a.includes("."))) return JSON.stringify($4ec9f37979ce8f98$var$deep_sort_object_1.default(priceWithPickedProps));
        else return JSON.stringify(priceWithPickedProps);
    };
    return SignatureVerifier;
}();
module.exports.default = $4ec9f37979ce8f98$var$SignatureVerifier;

});
parcelRequire.register("8No3X", function(module, exports) {
"use strict";

var $gSStC = parcelRequire("gSStC");
function $667590b77e175978$var$defaultSortFn(a, b) {
    return a.localeCompare(b);
}
function $667590b77e175978$var$sort(src, comparator) {
    var out;
    if (Array.isArray(src)) return src.map(function(item) {
        return $667590b77e175978$var$sort(item, comparator);
    });
    if ($gSStC(src)) {
        out = {};
        Object.keys(src).sort(comparator || $667590b77e175978$var$defaultSortFn).forEach(function(key) {
            out[key] = $667590b77e175978$var$sort(src[key], comparator);
        });
        return out;
    }
    return src;
}
module.exports = $667590b77e175978$var$sort;

});
parcelRequire.register("gSStC", function(module, exports) {
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ "use strict";

var $2dkRZ = parcelRequire("2dkRZ");
function $c4abf2736f9c43b3$var$isObjectObject(o) {
    return $2dkRZ(o) === true && Object.prototype.toString.call(o) === "[object Object]";
}
module.exports = function isPlainObject(o) {
    var ctor, prot;
    if ($c4abf2736f9c43b3$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (typeof ctor !== "function") return false;
    // If has modified prototype
    prot = ctor.prototype;
    if ($c4abf2736f9c43b3$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty("isPrototypeOf") === false) return false;
    // Most likely a plain Object
    return true;
};

});
parcelRequire.register("2dkRZ", function(module, exports) {
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ "use strict";
module.exports = function isObject(val) {
    return val != null && typeof val === "object" && Array.isArray(val) === false;
};

});




parcelRequire.register("cjX9b", function(module, exports) {
"use strict";
var $8f8523c25daed189$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        var __ = function __() {
            this.constructor = d;
        };
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8f8523c25daed189$var$PriceNotFoundError = /** @class */ function(_super) {
    var PriceNotFoundError = function PriceNotFoundError(symbol) {
        return _super.call(this, "Price not found for symbol: " + symbol) || this;
    };
    $8f8523c25daed189$var$__extends(PriceNotFoundError, _super);
    return PriceNotFoundError;
}(Error);
module.exports.default = $8f8523c25daed189$var$PriceNotFoundError;

});

parcelRequire.register("4DZj3", function(module, exports) {
"use strict";
var $361a5c1db0fadff8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $361a5c1db0fadff8$var$providers_1 = $361a5c1db0fadff8$var$__importDefault((parcelRequire("5wTMG")));

var $361a5c1db0fadff8$var$tokens_1 = $361a5c1db0fadff8$var$__importDefault((parcelRequire("2HgVY")));
module.exports.default = {
    version: "0.4",
    cacheApiUrl: "https://api.redstone.finance/prices",
    providers: $361a5c1db0fadff8$var$providers_1.default,
    tokens: $361a5c1db0fadff8$var$tokens_1.default
};

});
parcelRequire.register("5wTMG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    "redstone": {
        "address": "I-5rWUehEv-MjdK9gFw09RxfSLQX9DIHxG614Wf8qo0",
        "publicKey": "xyTvKiCST8bAT6sxrgkLh8UCX2N1eKvawODuxwq4qOHIdDAZFU_3N2m59rkZ0E7m77GsJuf1I8u0oEJEbxAdT7uD2JTwoYEHauXSxyJYvF0RCcZOhl5P1PJwImd44SJYa_9My7L84D5KXB9SKs8_VThe7ZyOb5HSGLNvMIK6A8IJ4Hr_tg9GYm65CRmtcu18S9mhun8vgw2wi7Gw6oR6mc4vU1I-hrU66Fi7YlXwFieP6YSy01JqoLPhU84EunPQzXPouVSbXjgRU5kFVxtdRy4GK2fzEBFYsQwCQgFrySCrFKHV8AInu9jerfof_DxNKiXkBzlB8nc22CrYnvvio_BWyh-gN0hQHZT0gwMR-A7sbXNCQJfReaIZzX_jP6XoB82PnpzmL_j1mJ2lnv2Rn001flBAx9AYxtGXd9s07pA-FggTbEG3Y2UnlWW6l3EJ93E0IfxL0PqGEUlp217mxUHvmTw9fkGDWa8rT9RPmsTyji-kMFSefclw80cBm_iOsIEutGP4S3LDbP-ZVJWDeJOBQQpSgwbisl8qbjl2sMQLQihoG2TQyNbmLwfyq-XSULkXjUi1_6BH36wnDBLWBKF-bS2bLKcGtn3Vjet72lNHxJJilcj8vpauwJG0078S_lO5uGt6oicdGR6eh_NSn6_8za_tXg0G_fohz4Yb1z8",
        "evmAddress": "0x0C39486f770B26F5527BBBf942726537986Cd7eb"
    },
    "redstone-rapid": {
        "address": "zYqPZuALSPa_f5Agvf8g2JHv94cqMn9aBtnH7GFHbuA",
        "publicKey": "tfkkt6lHR3lSEBNvjistpdGb8pR9UJoOVO-IuXRXD9PckAqY7TAVuDVhrcQDM56GZ_EUh6Eg_NRYd-EGW8SEQLHXtY_CM4P8563xUpw0XcZJbpOeScFcN5JdN47gq8vllOheO6-v4nRPLVabRVJqkXEqzdEwxQNYDkmPL-gxE0ziZcQRQZdJUzL5mI9DzwpPC86JBVwsBK71iuRlstABciIu8u77qyArkNu0pPig9OFQvT3Vg4OPuWXd83EhqEuN5gqVufyomkmL8X7agiEjDf-UQIfZrSYqgiJsWiVJ2aKHRhLZN17wdX51L21Cg2Sbyb3B1Roy5EgUUTdJ2MY7LnI-CTbBBJLKUHSvN67MDhj1OSBwUULc8bgVCzmfVQryIFmb4tucKvz7TRAWseXNO2MtMlggXa42Hx0sOTopbFTmT_r9glRLYw3QLzyJVH7Ltqr8QldoU-VMWtpo5cmOGh8jwVknSHqWNURbRCoDfAuwh8lpWXBjL_V8haaY0OKFT9Lpi1VW8o4Kfx7ED1VAnLcpVIoV5CkPs_L0Qy_G7XpgA02OAbJH2KvwxZPeSSymdupmr1KMc8iGz5B4a1HEcKggk5ETFfeGz5r0hDha3dwDj-dOv1jbADcdgk7e2xaLgw1CpS1XEHhAnhBJgAzJDJpcHKrxPkD6cUc7FbnsBCE",
        "evmAddress": "0xf786a909D559F5Dee2dc6706d8e5A81728a39aE9"
    },
    "redstone-stocks": {
        "address": "Yba8IVc_01bFxutKNJAZ7CmTD5AVi2GcWXf1NajPAsc",
        "publicKey": "wOoClMPZ_maAoE6OhCC8svn_9gu8rjuWPi3Grf05zpQnCzeFjzUocJUr0ta-muJDqfiTd4t5KR2qNxn3nkN2_kXsn5AcXnlI4UgnRdcEvsDh6yPMoMlAiAD6c0_CIgdiMFku5OTijNMtFYOybPKrd9Xdf_7_lnRZhU9qQXeBclVjmIzftwNaTFYI1sgApWKMxJ6301CY7VN9SOD9KBrFQJ3QjWqLrLwAyAu_Q6aBeQF_L-cZSFCiTfwyDptiMCdLAjzU9s55LNAg65pZ_OfFsvqylwiXEVIEDLUI3nmcM6OUHfyAG2TxoeXeem9nCpA96MiM8MyTWtOApGA3GW__j3fxutD0wt3_uGnVRZoypPqNuPjb5BraF0owTDYJQNML9Ddx1Hy6gMXjvjxn-MbAV7tI4KnDynrbtXPSZYjRpTpxcH9Rlr-bQAZWGpYF7OWpsZlPuE4MdxpQYhqLj6wfGCxTyzIjyt_t4zR28gWIGT5SfM-etcuXyy_chspsIqisSj781AP7YMTIxzyrY_LAAm-u5gz5VwnD8xDKIrYcsxLpC4V30HFWRc5vYtBQ0cAZYnp9AGGFD-6A7PnqQ1EYSSEHzSAqoYHaqxuAvxJEhG5AECdXBS3-FpgbGgVFEeQxIH7v9Js6-Uk85t23MjRUJFNo2JIlvyolmtkd3mf88qc",
        "evmAddress": "0x926E370fD53c23f8B71ad2B3217b227E41A92b12"
    },
    "redstone-avalanche": {
        "address": "f1Ipos2fVPbxPVO65GBygkMyW0tkAhp2hdprRPPBBN8",
        "publicKey": "nehHT9-CMWscteR3COOU455AmDI8VihUPG05kDryVl8wjv4iE_7MttV2rz3MTIicL1BNDQ246EnyIL_4qsqu8a_B3dZT8sVdfOtHqh48pDgA0MJ8ifFVUtyabr3D2ZSc2M4re79wm2SQ_S74ZNHV7zBIBS8pUHB20TfrKhrOWi-W0hfkxrqz4jIngXIPmE1ycYbaj9OHSVRFIB-EZN-1LmLZuy2EAAN0nOqJ-aYoblcGOu4WfZDpTXTfj-6-GRRBgeHen3MYnQuDneEYYrtzoCnimWGYrqRnpM654mJTW7gp_NIqLnXn3yG2aS2pbhn1_I0CavtKuE4PSACoP0UwZaGXEtanIaSuMDkeRdu-zhrr8yXZSW1inWdC0lhWPxAhzTYWQ00_OD6oj2FUtbXbAk_F-aPnT1Teb-LcNn6q-HbHSeZ_VV0ge5nn3zvBCc77z-Qfbgyd_a7dNwfy8sVkQc4-gvDJIftzxVXbUWnc3ipvL-PHfLsajg5Jkhteuvf8bIS0cNFS5u9pu3qnutskQxSymPzhkVmSyMWNe48Xp3ok4mUA9SuWTb6AskyoDVR9APh7JNDgeYINctgduqawzJQFxcVDuoW-1b8Gy79EYXW8yHowpAaDm6eYGTPQjnMpttThZwFiC_81JTXHXmDneKm677F2kO-1f6o4UWTBOEk",
        "evmAddress": "0x3a7d971De367FE15D164CDD952F64205F2D9f10c"
    },
    "redstone-dev": {
        "address": "33F0QHcb22W7LwWR1iRC8Az1ntZG09XQ03YWuw2ABqA",
        "publicKey": "omNGUhh5ar4WnqNxSjDDHBfhK5nMshxyRXUW8uObuxxKELKQjUeEsUdtg5UNuGnUh4AYb5rmGsx_KrLmuqbxl4-OLQrDNnj_LYcP78RLCA7wwonzi5HZVi6vXZ765JKQ-f5SJtFR7hhjj8W8f6PFQ_F2AjtNBkC6basAP4RM3GYIKQGUdVfvAJECZYcjtkZBGZtBxTzSm3SsvcdyVZkiEnvFzg1xLgwsGNuq8dHFciUHaa_ItNzM8GZ_Esjx77qgRLUwKNGvpU8nbao07YxcC7vj-opQQTAWNt1spxLLPqRTRJM_JGDgOEhEN_Tr0qWmjz61LhFW15NJiY1D5sBpOUM29IEpqhMUjj2r2TWp8-gjus_1u3g-KCB6ydfWbjsW9W5oZUfXE8lBKpmQFQ7jOzfev94-uVkxvnK4lY-FeP0fOD6hL_3EPAWLR1oWUqwXPs38A_vvys_ySTgQ11VWEtW-F8s3BRdeHFNZ4XalWAF-BM81HoyC2TwcbLJx3pLJS4FjqbQXcjPCzGE-eUztwKH73luqYXyG-S6sfBWRlqwcwsB9vNp7SnIDs2VLNUmxXG5PpwWG7GlO3HHj-WSchVfFqge0jHlDQeukIIy6fYIqnXaR6cSpiAfqHyzazOnOGgjBUBYDky5LlnrO8bctggYDlAyzJAn997AjeLTlmLM"
    },
    "redstone-avalanche-prod-1": {
        "address": "TEHhCDWy-vGmPSZsYJyM0aP_MM4xESgyIZdf5mVODzg",
        "publicKey": "01vc-Uxo9LabpCzQBGLdtlsaoJh9ee5rl-AcOG6dwmXoUDHRUzwexCmIItDOJ7yqus-XMxHeTlks8Re_q7oiKvKAU9KGoYnhoP5hiymeqFMwCIta0Qne92Za9Nm2R2tBW5cUqFHeXJuEutDnU0PUkBF5W7Ut3x3gd0xyVe9j69Sqd-kIQL_E47_ost0-pwHd76z6MZm_u7zmxbnTq0OsZTP4OQrvsnlRLpjyRsNzQomsKjuakM4RcYwfpueLKLwQa4OOJ9uWxsrSmtwdwdHZzQY9F2-l2LOllu5L-dOeDYCw4q9KZ0gmkKM6333pPo8DB-r5qe-gKY4_vNgOLRmBJqCF-G_ifWNptM3fhbkGwokfGw0ELCDqXwZ9Ka2QbqM11xViRhUiVPUJLiYwdhydPv9z0Mu5hPOR13GU-sNCf8Zt6GRyZ3ZMIo40GWrGbowJgTvSxU-mAxXwZ3hs3HRxA8wKkgUwUzTJ9UD6tYhctrG-SLUJfDVdEOGmih3FUbayt6OXN4p_I0WP_8OB8FEMV1Y7Ln-fxhErNonO3HDco4sgRiJvCP-Rcey94fK7fOQXAJ2ZLBh00uEjOWPsf0QjWpDp1qjKFkLAGlMoGDCa_SrTikOZtLAf8QKWap2wye3FeBp5UVwedi2vlF1HJuV8u_C-hoMxI1n0FKoyGJEyLrM",
        "evmAddress": "0x981bdA8276ae93F567922497153de7A5683708d3"
    },
    "redstone-avalanche-prod-2": {
        "address": "ll8DlO4xMwHK7gIMsbnOnN7Jg8Sl674Ls4G0aBfHCyk",
        "publicKey": "s0H0bHuIK0X-FptNPBvZGBHDbTLj0y-P6PV33sE2xW8WLx0DUtYz7jzlqc1brQ76SiO7ER-B9v80uLkaf5RwRQG-NL3Cm79FOxksz1oA0_wvK5oI-uZRWHDH4uTjhsnc3K2rg6N1X5J0GrSmB-puwiVt-1_fYrCyyzv2rE135bG61IA0i_4_cREr9t84WAYIkSbH003vbuI1KssDJtzqwVidC-DtYuzSnp1oqd4WPBDWSRSM_AswYFCk4A0xROhSmRf--140th5soz7FEJ92QRd3UYGgZ7HpPnedz-xCDgRi1-h12eMzCQM-HtipEJDl2DeTjekcTqPk_2BfnclpeDHO8myd49ikqwlHpkv0rerB3kJgDWYXcP499cZfXetEOrAiVlbPsmkJvpT7u1swaWyG5m78AjBAjZ1RrlSMLXuEHEPb1H31w16oPO6W-cqsZLZXjnxom5GXCbBOZ2Sdo7eIoTt7WMW653yzwZ97tjyMTbM5IqJZLyAFJgq6CFFnwAiKZlrtnCNHWFpfCm4uxsAzAyoW2l0FMZ4lgp7cUCHnl7IEWKSpkfsZy5FLQ0kInfeabZXPs12d5ufnL3upRSlL3pbi0OGrRQyojhOwIkasuVe0MiSSJW1QoD7oK07GWQhSke40vg3GrKW8V57IKSd1pU8owj1k7R9lADYAWLk",
        "evmAddress": "0x3BEFDd935b50F172e696A5187DBaCfEf0D208e48"
    }
};

});

parcelRequire.register("2HgVY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    "TSLA": [
        "redstone-stocks",
        "redstone"
    ],
    "AAPL": [
        "redstone-stocks",
        "redstone"
    ],
    "IBM": [
        "redstone-stocks"
    ],
    "AMZN": [
        "redstone-stocks",
        "redstone"
    ],
    "GOOG": [
        "redstone-stocks"
    ],
    "COST": [
        "redstone-stocks"
    ],
    "DIS": [
        "redstone-stocks"
    ],
    "FB": [
        "redstone-stocks",
        "redstone"
    ],
    "MA": [
        "redstone-stocks"
    ],
    "MSFT": [
        "redstone-stocks"
    ],
    "NFLX": [
        "redstone-stocks",
        "redstone"
    ],
    "NKE": [
        "redstone-stocks"
    ],
    "PINS": [
        "redstone-stocks"
    ],
    "SHOP": [
        "redstone-stocks"
    ],
    "SPOT": [
        "redstone-stocks"
    ],
    "TDOC": [
        "redstone-stocks"
    ],
    "SPY": [
        "redstone-stocks",
        "redstone"
    ],
    "QQQ": [
        "redstone-stocks"
    ],
    "ONEQ": [
        "redstone-stocks"
    ],
    "IWM": [
        "redstone-stocks"
    ],
    "EFA": [
        "redstone-stocks"
    ],
    "VGK": [
        "redstone-stocks"
    ],
    "INDA": [
        "redstone-stocks"
    ],
    "RSX": [
        "redstone-stocks"
    ],
    "ZC=F": [
        "redstone-stocks"
    ],
    "ZS=F": [
        "redstone-stocks"
    ],
    "ZM=F": [
        "redstone-stocks"
    ],
    "ZW=F": [
        "redstone-stocks"
    ],
    "KE=F": [
        "redstone-stocks"
    ],
    "ZO=F": [
        "redstone-stocks"
    ],
    "ZR=F": [
        "redstone-stocks"
    ],
    "CL=F": [
        "redstone-stocks"
    ],
    "RB=F": [
        "redstone-stocks"
    ],
    "NG=F": [
        "redstone-stocks"
    ],
    "QA=F": [
        "redstone-stocks"
    ],
    "EH=F": [
        "redstone-stocks"
    ],
    "GC=F": [
        "redstone-stocks"
    ],
    "SI=F": [
        "redstone-stocks"
    ],
    "HG=F": [
        "redstone-stocks"
    ],
    "PL=F": [
        "redstone-stocks"
    ],
    "PA=F": [
        "redstone-stocks"
    ],
    "LE=F": [
        "redstone-stocks"
    ],
    "GF=F": [
        "redstone-stocks"
    ],
    "HE=F": [
        "redstone-stocks"
    ],
    "PRK=F": [
        "redstone-stocks"
    ],
    "DC=F": [
        "redstone-stocks"
    ],
    "GNF=F": [
        "redstone-stocks"
    ],
    "CB=F": [
        "redstone-stocks"
    ],
    "CSC=F": [
        "redstone-stocks"
    ],
    "BTC": [
        "redstone-rapid",
        "redstone",
        "redstone-avalanche"
    ],
    "ETH": [
        "redstone-rapid",
        "redstone",
        "redstone-avalanche"
    ],
    "BNB": [
        "redstone-rapid",
        "redstone"
    ],
    "ADA": [
        "redstone-rapid",
        "redstone"
    ],
    "USDT": [
        "redstone-rapid",
        "redstone",
        "redstone-avalanche"
    ],
    "DOT": [
        "redstone-rapid",
        "redstone"
    ],
    "XRP": [
        "redstone-rapid",
        "redstone"
    ],
    "LTC": [
        "redstone"
    ],
    "LINK": [
        "redstone",
        "redstone-avalanche"
    ],
    "BCH": [
        "redstone"
    ],
    "XLM": [
        "redstone-rapid",
        "redstone"
    ],
    "USDC": [
        "redstone"
    ],
    "UNI": [
        "redstone"
    ],
    "DOGE": [
        "redstone-rapid",
        "redstone"
    ],
    "WBTC": [
        "redstone"
    ],
    "OKB": [
        "redstone"
    ],
    "XEM": [
        "redstone"
    ],
    "ATOM": [
        "redstone"
    ],
    "AAVE": [
        "redstone"
    ],
    "SOL": [
        "redstone"
    ],
    "CRO": [
        "redstone"
    ],
    "EOS": [
        "redstone"
    ],
    "XMR": [
        "redstone"
    ],
    "BSV": [
        "redstone"
    ],
    "TRX": [
        "redstone"
    ],
    "HT": [
        "redstone"
    ],
    "MIOTA": [
        "redstone"
    ],
    "THETA": [
        "redstone"
    ],
    "SNX": [
        "redstone"
    ],
    "NEO": [
        "redstone"
    ],
    "XTZ": [
        "redstone"
    ],
    "VET": [
        "redstone"
    ],
    "LUNA": [
        "redstone"
    ],
    "FTT": [
        "redstone"
    ],
    "DASH": [
        "redstone"
    ],
    "DAI": [
        "redstone"
    ],
    "GRT": [
        "redstone"
    ],
    "BUSD": [
        "redstone"
    ],
    "AVAX": [
        "redstone",
        "redstone-avalanche"
    ],
    "KSM": [
        "redstone"
    ],
    "EGLD": [
        "redstone"
    ],
    "SUSHI": [
        "redstone"
    ],
    "LEO": [
        "redstone"
    ],
    "MKR": [
        "redstone"
    ],
    "FIL": [
        "redstone"
    ],
    "CEL": [
        "redstone"
    ],
    "COMP": [
        "redstone"
    ],
    "DCR": [
        "redstone"
    ],
    "FTM": [
        "redstone"
    ],
    "CAKE": [
        "redstone"
    ],
    "VGX": [
        "redstone"
    ],
    "RVN": [
        "redstone"
    ],
    "ZEC": [
        "redstone"
    ],
    "ZIL": [
        "redstone"
    ],
    "NEAR": [
        "redstone"
    ],
    "ETC": [
        "redstone"
    ],
    "UMA": [
        "redstone"
    ],
    "NEXO": [
        "redstone"
    ],
    "YFI": [
        "redstone"
    ],
    "RUNE": [
        "redstone"
    ],
    "ZRX": [
        "redstone"
    ],
    "REN": [
        "redstone"
    ],
    "WAVES": [
        "redstone"
    ],
    "MATIC": [
        "redstone"
    ],
    "ICX": [
        "redstone"
    ],
    "HBAR": [
        "redstone"
    ],
    "STX": [
        "redstone"
    ],
    "AMP": [
        "redstone"
    ],
    "BTT": [
        "redstone"
    ],
    "RENBTC": [
        "redstone"
    ],
    "MDX": [
        "redstone"
    ],
    "CHSB": [
        "redstone"
    ],
    "ALGO": [
        "redstone"
    ],
    "PAX": [
        "redstone"
    ],
    "IOST": [
        "redstone"
    ],
    "DGB": [
        "redstone"
    ],
    "ONT": [
        "redstone"
    ],
    "ZKS": [
        "redstone"
    ],
    "BAT": [
        "redstone"
    ],
    "NANO": [
        "redstone"
    ],
    "LRC": [
        "redstone"
    ],
    "OMG": [
        "redstone"
    ],
    "UST": [
        "redstone"
    ],
    "BNT": [
        "redstone"
    ],
    "ZEN": [
        "redstone"
    ],
    "ENJ": [
        "redstone"
    ],
    "QTUM": [
        "redstone"
    ],
    "HOT": [
        "redstone"
    ],
    "XVS": [
        "redstone"
    ],
    "SC": [
        "redstone"
    ],
    "CRV": [
        "redstone"
    ],
    "BTG": [
        "redstone"
    ],
    "FLOW": [
        "redstone"
    ],
    "EWT": [
        "redstone"
    ],
    "LSK": [
        "redstone"
    ],
    "DODO": [
        "redstone"
    ],
    "QNT": [
        "redstone"
    ],
    "AR": [
        "redstone-rapid",
        "redstone"
    ],
    "RSR": [
        "redstone"
    ],
    "1INCH": [
        "redstone"
    ],
    "KCS": [
        "redstone"
    ],
    "CELO": [
        "redstone"
    ],
    "BAL": [
        "redstone"
    ],
    "ALPHA": [
        "redstone"
    ],
    "OCEAN": [
        "redstone"
    ],
    "GLM": [
        "redstone"
    ],
    "CKB": [
        "redstone"
    ],
    "KNC": [
        "redstone"
    ],
    "AMPL": [
        "redstone"
    ],
    "SRM": [
        "redstone"
    ],
    "MANA": [
        "redstone"
    ],
    "TUSD": [
        "redstone"
    ],
    "CUSDT": [
        "redstone"
    ],
    "SNT": [
        "redstone"
    ],
    "XVG": [
        "redstone"
    ],
    "BAND": [
        "redstone"
    ],
    "XDC": [
        "redstone"
    ],
    "HNT": [
        "redstone"
    ],
    "CHZ": [
        "redstone"
    ],
    "ORN": [
        "redstone"
    ],
    "BADGER": [
        "redstone"
    ],
    "NU": [
        "redstone"
    ],
    "POLS": [
        "redstone"
    ],
    "GT": [
        "redstone"
    ],
    "SWAP": [
        "redstone"
    ],
    "SCRT": [
        "redstone"
    ],
    "POLY": [
        "redstone"
    ],
    "CVC": [
        "redstone"
    ],
    "BTCST": [
        "redstone"
    ],
    "AKT": [
        "redstone"
    ],
    "ONE": [
        "redstone"
    ],
    "SUSD": [
        "redstone"
    ],
    "SFP": [
        "redstone"
    ],
    "SFI": [
        "redstone"
    ],
    "MIR": [
        "redstone"
    ],
    "KAVA": [
        "redstone"
    ],
    "UBT": [
        "redstone"
    ],
    "SXP": [
        "redstone"
    ],
    "NMR": [
        "redstone"
    ],
    "GALA": [
        "redstone"
    ],
    "GNO": [
        "redstone"
    ],
    "BCD": [
        "redstone"
    ],
    "DNT": [
        "redstone"
    ],
    "RFOX": [
        "redstone"
    ],
    "FUN": [
        "redstone"
    ],
    "ARK": [
        "redstone"
    ],
    "ANKR": [
        "redstone"
    ],
    "MATH": [
        "redstone"
    ],
    "RIF": [
        "redstone"
    ],
    "INJ": [
        "redstone"
    ],
    "DENT": [
        "redstone"
    ],
    "TOMO": [
        "redstone"
    ],
    "GAS": [
        "redstone"
    ],
    "FET": [
        "redstone"
    ],
    "ETN": [
        "redstone"
    ],
    "KMD": [
        "redstone"
    ],
    "SAND": [
        "redstone"
    ],
    "ARDR": [
        "redstone"
    ],
    "LIT": [
        "redstone"
    ],
    "USDN": [
        "redstone"
    ],
    "UTK": [
        "redstone"
    ],
    "REP": [
        "redstone"
    ],
    "ANT": [
        "redstone"
    ],
    "WIN": [
        "redstone"
    ],
    "VTHO": [
        "redstone"
    ],
    "XOR": [
        "redstone"
    ],
    "UOS": [
        "redstone"
    ],
    "MONA": [
        "redstone"
    ],
    "MASK": [
        "redstone"
    ],
    "STEEM": [
        "redstone"
    ],
    "BTM": [
        "redstone"
    ],
    "ROSE": [
        "redstone"
    ],
    "COTI": [
        "redstone"
    ],
    "HTR": [
        "redstone"
    ],
    "PRQ": [
        "redstone"
    ],
    "WAN": [
        "redstone"
    ],
    "PROM": [
        "redstone"
    ],
    "ROOK": [
        "redstone"
    ],
    "IOTX": [
        "redstone"
    ],
    "EDG": [
        "redstone"
    ],
    "SKL": [
        "redstone"
    ],
    "MFT": [
        "redstone"
    ],
    "RDD": [
        "redstone"
    ],
    "XAUT": [
        "redstone"
    ],
    "LON": [
        "redstone"
    ],
    "KEEP": [
        "redstone"
    ],
    "SUPER": [
        "redstone"
    ],
    "WOO": [
        "redstone"
    ],
    "BTS": [
        "redstone"
    ],
    "PERP": [
        "redstone"
    ],
    "PAXG": [
        "redstone"
    ],
    "WAXP": [
        "redstone"
    ],
    "FARM": [
        "redstone"
    ],
    "AVA": [
        "redstone"
    ],
    "GUSD": [
        "redstone"
    ],
    "PHA": [
        "redstone"
    ],
    "HNS": [
        "redstone"
    ],
    "DPI": [
        "redstone"
    ],
    "IRIS": [
        "redstone"
    ],
    "STAKE": [
        "redstone"
    ],
    "ELF": [
        "redstone"
    ],
    "RAY": [
        "redstone"
    ],
    "HEGIC": [
        "redstone"
    ],
    "RLC": [
        "redstone"
    ],
    "ERG": [
        "redstone"
    ],
    "PIVX": [
        "redstone"
    ],
    "LOOM": [
        "redstone"
    ],
    "JULD": [
        "redstone"
    ],
    "API3": [
        "redstone"
    ],
    "EXRD": [
        "redstone"
    ],
    "HIVE": [
        "redstone"
    ],
    "MX": [
        "redstone"
    ],
    "SYS": [
        "redstone"
    ],
    "AKRO": [
        "redstone"
    ],
    "SHR": [
        "redstone"
    ],
    "YFII": [
        "redstone"
    ],
    "TORN": [
        "redstone"
    ],
    "STORJ": [
        "redstone"
    ],
    "AION": [
        "redstone"
    ],
    "UQC": [
        "redstone"
    ],
    "ANY": [
        "redstone"
    ],
    "DUSK": [
        "redstone"
    ],
    "WHALE": [
        "redstone"
    ],
    "BIFI": [
        "redstone"
    ],
    "CREAM": [
        "redstone"
    ],
    "LTO": [
        "redstone"
    ],
    "UNFI": [
        "redstone"
    ],
    "LBC": [
        "redstone"
    ],
    "AXS": [
        "redstone"
    ],
    "LINA": [
        "redstone"
    ],
    "ALBT": [
        "redstone"
    ],
    "BCN": [
        "redstone"
    ],
    "HARD": [
        "redstone"
    ],
    "LPT": [
        "redstone"
    ],
    "SWINGBY": [
        "redstone"
    ],
    "FRAX": [
        "redstone",
        "redstone-avalanche"
    ],
    "STMX": [
        "redstone"
    ],
    "HXRO": [
        "redstone"
    ],
    "WNXM": [
        "redstone"
    ],
    "NEST": [
        "redstone"
    ],
    "AUTO": [
        "redstone"
    ],
    "OM": [
        "redstone"
    ],
    "TRU": [
        "redstone"
    ],
    "AUDIO": [
        "redstone"
    ],
    "WRX": [
        "redstone"
    ],
    "REQ": [
        "redstone"
    ],
    "FRONT": [
        "redstone"
    ],
    "DF": [
        "redstone"
    ],
    "PPT": [
        "redstone"
    ],
    "DAO": [
        "redstone"
    ],
    "CELR": [
        "redstone"
    ],
    "WICC": [
        "redstone"
    ],
    "ESD": [
        "redstone"
    ],
    "JST": [
        "redstone"
    ],
    "TRB": [
        "redstone"
    ],
    "KAI": [
        "redstone"
    ],
    "DIVI": [
        "redstone"
    ],
    "MAPS": [
        "redstone"
    ],
    "OGN": [
        "redstone"
    ],
    "KP3R": [
        "redstone"
    ],
    "ORBS": [
        "redstone"
    ],
    "BOND": [
        "redstone"
    ],
    "CTK": [
        "redstone"
    ],
    "COVER": [
        "redstone"
    ],
    "BZRX": [
        "redstone"
    ],
    "FIRO": [
        "redstone"
    ],
    "SKEY": [
        "redstone"
    ],
    "BAO": [
        "redstone"
    ],
    "ELA": [
        "redstone"
    ],
    "GHST": [
        "redstone"
    ],
    "TT": [
        "redstone"
    ],
    "AE": [
        "redstone"
    ],
    "ARRR": [
        "redstone"
    ],
    "RING": [
        "redstone"
    ],
    "DATA": [
        "redstone"
    ],
    "CTSI": [
        "redstone"
    ],
    "DIA": [
        "redstone"
    ],
    "FRM": [
        "redstone"
    ],
    "IGNIS": [
        "redstone"
    ],
    "NULS": [
        "redstone"
    ],
    "FSN": [
        "redstone"
    ],
    "AUCTION": [
        "redstone"
    ],
    "TON": [
        "redstone"
    ],
    "ZB": [
        "redstone"
    ],
    "POND": [
        "redstone"
    ],
    "LAMB": [
        "redstone"
    ],
    "MTL": [
        "redstone"
    ],
    "VLX": [
        "redstone"
    ],
    "CRE": [
        "redstone"
    ],
    "NIM": [
        "redstone"
    ],
    "MXC": [
        "redstone"
    ],
    "ZAP": [
        "redstone"
    ],
    "FXS": [
        "redstone"
    ],
    "PNT": [
        "redstone"
    ],
    "BLZ": [
        "redstone"
    ],
    "MLN": [
        "redstone"
    ],
    "APY": [
        "redstone"
    ],
    "BEL": [
        "redstone"
    ],
    "BEAM": [
        "redstone"
    ],
    "VSYS": [
        "redstone"
    ],
    "YAM": [
        "redstone"
    ],
    "RARI": [
        "redstone"
    ],
    "FIDA": [
        "redstone"
    ],
    "CORE": [
        "redstone"
    ],
    "TVK": [
        "redstone"
    ],
    "HC": [
        "redstone"
    ],
    "MTA": [
        "redstone"
    ],
    "KDA": [
        "redstone"
    ],
    "RNDR": [
        "redstone"
    ],
    "CUSD": [
        "redstone"
    ],
    "EURS": [
        "redstone"
    ],
    "MEME": [
        "redstone"
    ],
    "STPT": [
        "redstone"
    ],
    "TLOS": [
        "redstone"
    ],
    "DHT": [
        "redstone"
    ],
    "GXC": [
        "redstone"
    ],
    "BOR": [
        "redstone"
    ],
    "ARPA": [
        "redstone"
    ],
    "AST": [
        "redstone"
    ],
    "XSN": [
        "redstone"
    ],
    "VALUE": [
        "redstone"
    ],
    "FILDA": [
        "redstone"
    ],
    "PNK": [
        "redstone"
    ],
    "RAMP": [
        "redstone"
    ],
    "SPI": [
        "redstone"
    ],
    "NXT": [
        "redstone"
    ],
    "HEZ": [
        "redstone"
    ],
    "FIS": [
        "redstone"
    ],
    "COMBO": [
        "redstone"
    ],
    "NWC": [
        "redstone"
    ],
    "MPH": [
        "redstone"
    ],
    "RFUEL": [
        "redstone"
    ],
    "ALEPH": [
        "redstone"
    ],
    "XRT": [
        "redstone"
    ],
    "SERO": [
        "redstone"
    ],
    "NKN": [
        "redstone"
    ],
    "FOR": [
        "redstone"
    ],
    "FIO": [
        "redstone"
    ],
    "REVV": [
        "redstone"
    ],
    "RFR": [
        "redstone"
    ],
    "AERGO": [
        "redstone"
    ],
    "TRYB": [
        "redstone"
    ],
    "NEC": [
        "redstone"
    ],
    "ZEE": [
        "redstone"
    ],
    "UNN": [
        "redstone"
    ],
    "ZCN": [
        "redstone"
    ],
    "BAC": [
        "redstone"
    ],
    "UMB": [
        "redstone"
    ],
    "DERO": [
        "redstone"
    ],
    "PEAK": [
        "redstone"
    ],
    "CRU": [
        "redstone"
    ],
    "APL": [
        "redstone"
    ],
    "PHX": [
        "redstone"
    ],
    "BMI": [
        "redstone"
    ],
    "WTC": [
        "redstone"
    ],
    "MDT": [
        "redstone"
    ],
    "KEY": [
        "redstone"
    ],
    "WHITE": [
        "redstone"
    ],
    "CVP": [
        "redstone"
    ],
    "CHR": [
        "redstone"
    ],
    "ULT": [
        "redstone"
    ],
    "PRE": [
        "redstone"
    ],
    "WING": [
        "redstone"
    ],
    "NAS": [
        "redstone"
    ],
    "WXT": [
        "redstone"
    ],
    "XDB": [
        "redstone"
    ],
    "CRPT": [
        "redstone"
    ],
    "RLY": [
        "redstone"
    ],
    "DEC": [
        "redstone"
    ],
    "QASH": [
        "redstone"
    ],
    "SDT": [
        "redstone"
    ],
    "DEGO": [
        "redstone"
    ],
    "RUFF": [
        "redstone"
    ],
    "MDA": [
        "redstone"
    ],
    "DOCK": [
        "redstone"
    ],
    "CUDOS": [
        "redstone"
    ],
    "SUKU": [
        "redstone"
    ],
    "LOC": [
        "redstone"
    ],
    "AITRA": [
        "redstone"
    ],
    "PAY": [
        "redstone"
    ],
    "VITE": [
        "redstone"
    ],
    "CBC": [
        "redstone"
    ],
    "MITX": [
        "redstone"
    ],
    "ERSDL": [
        "redstone"
    ],
    "SMART": [
        "redstone"
    ],
    "KAN": [
        "redstone"
    ],
    "UBQ": [
        "redstone"
    ],
    "SHA": [
        "redstone"
    ],
    "COIN": [
        "redstone"
    ],
    "JRT": [
        "redstone"
    ],
    "HAKKA": [
        "redstone"
    ],
    "PROPS": [
        "redstone"
    ],
    "TROY": [
        "redstone"
    ],
    "DSLA": [
        "redstone"
    ],
    "PNG": [
        "redstone",
        "redstone-avalanche"
    ],
    "CLO": [
        "redstone"
    ],
    "TOP": [
        "redstone"
    ],
    "ETP": [
        "redstone"
    ],
    "HGET": [
        "redstone"
    ],
    "DOS": [
        "redstone"
    ],
    "YFL": [
        "redstone"
    ],
    "MHC": [
        "redstone"
    ],
    "IQN": [
        "redstone"
    ],
    "BTSE": [
        "redstone"
    ],
    "ABT": [
        "redstone"
    ],
    "GTO": [
        "redstone"
    ],
    "LAYER": [
        "redstone"
    ],
    "ACH": [
        "redstone"
    ],
    "NSURE": [
        "redstone"
    ],
    "PICKLE": [
        "redstone"
    ],
    "BIX": [
        "redstone"
    ],
    "SWRV": [
        "redstone"
    ],
    "NGM": [
        "redstone"
    ],
    "HYDRA": [
        "redstone"
    ],
    "DCN": [
        "redstone"
    ],
    "PLU": [
        "redstone"
    ],
    "EGT": [
        "redstone"
    ],
    "ESS": [
        "redstone"
    ],
    "TCT": [
        "redstone"
    ],
    "MITH": [
        "redstone"
    ],
    "VEE": [
        "redstone"
    ],
    "DYP": [
        "redstone"
    ],
    "SAN": [
        "redstone"
    ],
    "MBL": [
        "redstone"
    ],
    "CMT": [
        "redstone"
    ],
    "SLP": [
        "redstone"
    ],
    "EMC": [
        "redstone"
    ],
    "MAHA": [
        "redstone"
    ],
    "HYDRO": [
        "redstone"
    ],
    "DTA": [
        "redstone"
    ],
    "SWFTC": [
        "redstone"
    ],
    "TRADE": [
        "redstone"
    ],
    "BFT": [
        "redstone"
    ],
    "CHI": [
        "redstone"
    ],
    "SNGLS": [
        "redstone"
    ],
    "ACT": [
        "redstone"
    ],
    "UBXT": [
        "redstone"
    ],
    "DFD": [
        "redstone"
    ],
    "DLT": [
        "redstone"
    ],
    "VIB": [
        "redstone"
    ],
    "LIKE": [
        "redstone"
    ],
    "LYM": [
        "redstone"
    ],
    "APM": [
        "redstone"
    ],
    "GNX": [
        "redstone"
    ],
    "AGA": [
        "redstone"
    ],
    "SMT": [
        "redstone"
    ],
    "GEEQ": [
        "redstone"
    ],
    "SATT": [
        "redstone"
    ],
    "MDS": [
        "redstone"
    ],
    "YOU": [
        "redstone"
    ],
    "XDN": [
        "redstone"
    ],
    "ANJ": [
        "redstone"
    ],
    "BOLT": [
        "redstone"
    ],
    "CNNS": [
        "redstone"
    ],
    "VEO": [
        "redstone"
    ],
    "XCUR": [
        "redstone"
    ],
    "BEPRO": [
        "redstone"
    ],
    "ENQ": [
        "redstone"
    ],
    "FLEX": [
        "redstone"
    ],
    "LTX": [
        "redstone"
    ],
    "STA": [
        "redstone"
    ],
    "BULL": [
        "redstone"
    ],
    "DMD": [
        "redstone"
    ],
    "SKM": [
        "redstone"
    ],
    "OCN": [
        "redstone"
    ],
    "ODE": [
        "redstone"
    ],
    "NCT": [
        "redstone"
    ],
    "NORD": [
        "redstone"
    ],
    "ITC": [
        "redstone"
    ],
    "RIO": [
        "redstone"
    ],
    "YEE": [
        "redstone"
    ],
    "REV": [
        "redstone"
    ],
    "AMB": [
        "redstone"
    ],
    "NFT": [
        "redstone"
    ],
    "SOC": [
        "redstone"
    ],
    "VEX": [
        "redstone"
    ],
    "EOSDT": [
        "redstone"
    ],
    "ASP": [
        "redstone"
    ],
    "TERN": [
        "redstone"
    ],
    "$ANRX": [
        "redstone"
    ],
    "TRUE": [
        "redstone"
    ],
    "HPB": [
        "redstone"
    ],
    "INT": [
        "redstone"
    ],
    "RNT": [
        "redstone"
    ],
    "XLQ": [
        "redstone"
    ],
    "FAIR": [
        "redstone"
    ],
    "DMG": [
        "redstone"
    ],
    "UOP": [
        "redstone"
    ],
    "YOYOW": [
        "redstone"
    ],
    "DGTX": [
        "redstone"
    ],
    "ALPA": [
        "redstone"
    ],
    "IDEA": [
        "redstone"
    ],
    "AMN": [
        "redstone"
    ],
    "VRA": [
        "redstone"
    ],
    "AXIS": [
        "redstone"
    ],
    "ABL": [
        "redstone"
    ],
    "BASE": [
        "redstone"
    ],
    "PHNX": [
        "redstone"
    ],
    "BNF": [
        "redstone"
    ],
    "HYC": [
        "redstone"
    ],
    "TRIO": [
        "redstone"
    ],
    "UCT": [
        "redstone"
    ],
    "EOSC": [
        "redstone"
    ],
    "AIT": [
        "redstone"
    ],
    "ETHO": [
        "redstone"
    ],
    "QUN": [
        "redstone"
    ],
    "LBA": [
        "redstone"
    ],
    "CAN": [
        "redstone"
    ],
    "BAX": [
        "redstone"
    ],
    "AVS": [
        "redstone"
    ],
    "BEAR": [
        "redstone"
    ],
    "XPR": [
        "redstone"
    ],
    "ADEL": [
        "redstone"
    ],
    "CHAT": [
        "redstone"
    ],
    "OLT": [
        "redstone"
    ],
    "OGO": [
        "redstone"
    ],
    "PVT": [
        "redstone"
    ],
    "RSV": [
        "redstone"
    ],
    "CTXC": [
        "redstone"
    ],
    "PST": [
        "redstone"
    ],
    "ONG": [
        "redstone"
    ],
    "ACAT": [
        "redstone"
    ],
    "NTK": [
        "redstone"
    ],
    "CUR": [
        "redstone"
    ],
    "ROCKS": [
        "redstone"
    ],
    "XDNA": [
        "redstone"
    ],
    "AID": [
        "redstone"
    ],
    "AIDOC": [
        "redstone"
    ],
    "ACM": [
        "redstone"
    ],
    "ALEX": [
        "redstone"
    ],
    "ORS": [
        "redstone"
    ],
    "SDS": [
        "redstone"
    ],
    "CORX": [
        "redstone"
    ],
    "ASAFE": [
        "redstone"
    ],
    "ALI": [
        "redstone"
    ],
    "TNC": [
        "redstone"
    ],
    "ALLBI": [
        "redstone"
    ],
    "AG8": [
        "redstone"
    ],
    "ATM": [
        "redstone"
    ],
    "AGS": [
        "redstone"
    ],
    "CNS": [
        "redstone"
    ],
    "IQ": [
        "redstone"
    ],
    "ETZ": [
        "redstone"
    ],
    "ALMX": [
        "redstone"
    ],
    "ALT": [
        "redstone"
    ],
    "FLIXX": [
        "redstone"
    ],
    "FESS": [
        "redstone"
    ],
    "ALV": [
        "redstone"
    ],
    "FLUX": [
        "redstone"
    ],
    "ETM": [
        "redstone"
    ],
    "DEX": [
        "redstone"
    ],
    "GOT": [
        "redstone"
    ],
    "BLOC": [
        "redstone"
    ],
    "INX": [
        "redstone"
    ],
    "A": [
        "redstone"
    ],
    "MXT": [
        "redstone"
    ],
    "ANON": [
        "redstone"
    ],
    "XSR": [
        "redstone"
    ],
    "UCM": [
        "redstone"
    ],
    "GTX": [
        "redstone"
    ],
    "WBT": [
        "redstone"
    ],
    "STAK": [
        "redstone"
    ],
    "SMC": [
        "redstone"
    ],
    "ABET": [
        "redstone"
    ],
    "AMS": [
        "redstone"
    ],
    "BUNNY": [
        "redstone"
    ],
    "APC": [
        "redstone"
    ],
    "AGU": [
        "redstone"
    ],
    "AET": [
        "redstone"
    ],
    "AIAS": [
        "redstone"
    ],
    "SSX": [
        "redstone"
    ],
    "NIO": [
        "redstone"
    ],
    "FCL": [
        "redstone"
    ],
    "LBY": [
        "redstone"
    ],
    "HOPR": [
        "redstone"
    ],
    "ALOHA": [
        "redstone"
    ],
    "QTF": [
        "redstone"
    ],
    "SPORE": [
        "redstone"
    ],
    "RAD": [
        "redstone"
    ],
    "QUICK": [
        "redstone"
    ],
    "ZUSD": [
        "redstone"
    ],
    "LHB": [
        "redstone"
    ],
    "ELCASH": [
        "redstone"
    ],
    "ALL": [
        "redstone"
    ],
    "A5T": [
        "redstone"
    ],
    "CWS": [
        "redstone"
    ],
    "DFM": [
        "redstone"
    ],
    "CVT": [
        "redstone"
    ],
    "GME": [
        "redstone"
    ],
    "BETH": [
        "redstone"
    ],
    "GLCH": [
        "redstone"
    ],
    "ROUTE": [
        "redstone"
    ],
    "OKT": [
        "redstone"
    ],
    "GOLD": [
        "redstone"
    ],
    "BAGS": [
        "redstone"
    ],
    "GERA": [
        "redstone"
    ],
    "HGOLD": [
        "redstone"
    ],
    "UCOIN": [
        "redstone"
    ],
    "AIM": [
        "redstone"
    ],
    "EC": [
        "redstone"
    ],
    "XEP": [
        "redstone"
    ],
    "AME": [
        "redstone"
    ],
    "REEF": [
        "redstone"
    ],
    "GUSDT": [
        "redstone"
    ],
    "G999": [
        "redstone"
    ],
    "BANANA": [
        "redstone"
    ],
    "CTC": [
        "redstone"
    ],
    "PLEX": [
        "redstone"
    ],
    "TBCC": [
        "redstone"
    ],
    "HUB": [
        "redstone"
    ],
    "CAMP": [
        "redstone"
    ],
    "XLMBEAR": [
        "redstone"
    ],
    "XLMBULL": [
        "redstone"
    ],
    "MOB": [
        "redstone"
    ],
    "AIN": [
        "redstone"
    ],
    "CLT": [
        "redstone"
    ],
    "AKN": [
        "redstone"
    ],
    "CFX": [
        "redstone"
    ],
    "LONG": [
        "redstone"
    ],
    "TRA": [
        "redstone"
    ],
    "GASP": [
        "redstone"
    ],
    "UBX": [
        "redstone"
    ],
    "PASS": [
        "redstone"
    ],
    "CHESS": [
        "redstone"
    ],
    "AICO": [
        "redstone"
    ],
    "CLV": [
        "redstone"
    ],
    "AGT": [
        "redstone"
    ],
    "JGN": [
        "redstone"
    ],
    "AWX": [
        "redstone"
    ],
    "APE": [
        "redstone"
    ],
    "AHF": [
        "redstone"
    ],
    "ECELL": [
        "redstone"
    ],
    "FLM": [
        "redstone"
    ],
    "ZOMB": [
        "redstone"
    ],
    "SFG": [
        "redstone"
    ],
    "BID": [
        "redstone"
    ],
    "BAKE": [
        "redstone"
    ],
    "BURGER": [
        "redstone"
    ],
    "VELO": [
        "redstone"
    ],
    "NBS": [
        "redstone"
    ],
    "SAM": [
        "redstone"
    ],
    "HBC": [
        "redstone"
    ],
    "ZYRO": [
        "redstone"
    ],
    "GOF": [
        "redstone"
    ],
    "SUN": [
        "redstone"
    ],
    "JFI": [
        "redstone"
    ],
    "GBP": [
        "redstone"
    ],
    "USDU": [
        "redstone"
    ],
    "ALA": [
        "redstone"
    ],
    "TAI": [
        "redstone"
    ],
    "PEARL": [
        "redstone"
    ],
    "EPS": [
        "redstone"
    ],
    "EFK": [
        "redstone"
    ],
    "ANC": [
        "redstone"
    ],
    "KLV": [
        "redstone"
    ],
    "BUY": [
        "redstone"
    ],
    "BSY": [
        "redstone"
    ],
    "AHT": [
        "redstone"
    ],
    "AMIX": [
        "redstone"
    ],
    "WGRT": [
        "redstone"
    ],
    "BNTX": [
        "redstone"
    ],
    "ALD": [
        "redstone"
    ],
    "CGC": [
        "redstone"
    ],
    "SHIB": [
        "redstone"
    ],
    "XAMP": [
        "redstone"
    ],
    "KTON": [
        "redstone"
    ],
    "NVT": [
        "redstone"
    ],
    "BBT": [
        "redstone"
    ],
    "RINGX": [
        "redstone"
    ],
    "RWN": [
        "redstone"
    ],
    "DFI": [
        "redstone"
    ],
    "POL": [
        "redstone"
    ],
    "BAR": [
        "redstone"
    ],
    "LOON": [
        "redstone"
    ],
    "AKC": [
        "redstone"
    ],
    "GATOR": [
        "redstone"
    ],
    "ALC": [
        "redstone"
    ],
    "AWG": [
        "redstone"
    ],
    "GAL": [
        "redstone"
    ],
    "NDN": [
        "redstone"
    ],
    "ZLW": [
        "redstone"
    ],
    "AXT": [
        "redstone"
    ],
    "ANW": [
        "redstone"
    ],
    "AOS": [
        "redstone"
    ],
    "TTT": [
        "redstone"
    ],
    "AAB": [
        "redstone"
    ],
    "SENSO": [
        "redstone"
    ],
    "IBVOL": [
        "redstone"
    ],
    "BVOL": [
        "redstone"
    ],
    "HMR": [
        "redstone"
    ],
    "MASS": [
        "redstone"
    ],
    "RBTC": [
        "redstone"
    ],
    "AMA": [
        "redstone"
    ],
    "USDJ": [
        "redstone"
    ],
    "DEP": [
        "redstone"
    ],
    "BLCT": [
        "redstone"
    ],
    "HDAO": [
        "redstone"
    ],
    "SOLO": [
        "redstone"
    ],
    "BEER": [
        "redstone"
    ],
    "DNA": [
        "redstone"
    ],
    "KOK": [
        "redstone"
    ],
    "WEST": [
        "redstone"
    ],
    "EXCHBULL": [
        "redstone"
    ],
    "HTDF": [
        "redstone"
    ],
    "DDRT": [
        "redstone"
    ],
    "NODE": [
        "redstone"
    ],
    "GOLDR": [
        "redstone"
    ],
    "CHEX": [
        "redstone"
    ],
    "BSVBEAR": [
        "redstone"
    ],
    "EXCHBEAR": [
        "redstone"
    ],
    "PLF": [
        "redstone"
    ],
    "BCHBULL": [
        "redstone"
    ],
    "BNA": [
        "redstone"
    ],
    "DOGEBULL": [
        "redstone"
    ],
    "BCHBEAR": [
        "redstone"
    ],
    "BSVBULL": [
        "redstone"
    ],
    "TRXBULL": [
        "redstone"
    ],
    "AAT": [
        "redstone"
    ],
    "BNBBEAR": [
        "redstone"
    ],
    "LINKBULL": [
        "redstone"
    ],
    "ADABEAR": [
        "redstone"
    ],
    "TRXBEAR": [
        "redstone"
    ],
    "LINKBEAR": [
        "redstone"
    ],
    "LTCBULL": [
        "redstone"
    ],
    "LTCBEAR": [
        "redstone"
    ],
    "BNBBULL": [
        "redstone"
    ],
    "XRPBULL": [
        "redstone"
    ],
    "XRPBEAR": [
        "redstone"
    ],
    "ALTBULL": [
        "redstone"
    ],
    "ADABULL": [
        "redstone"
    ],
    "ALTBEAR": [
        "redstone"
    ],
    "EOSBEAR": [
        "redstone"
    ],
    "ETHBULL": [
        "redstone"
    ],
    "APIX": [
        "redstone"
    ],
    "ROAD": [
        "redstone"
    ],
    "JUV": [
        "redstone"
    ],
    "AMC": [
        "redstone"
    ],
    "ANCT": [
        "redstone"
    ],
    "SUTER": [
        "redstone"
    ],
    "BYND": [
        "redstone"
    ],
    "DEXA": [
        "redstone"
    ],
    "XPO": [
        "redstone"
    ],
    "ALP": [
        "redstone"
    ],
    "KLAY": [
        "redstone"
    ],
    "NDAU": [
        "redstone"
    ],
    "ALY": [
        "redstone"
    ],
    "RRB": [
        "redstone"
    ],
    "TORI": [
        "redstone"
    ],
    "NUT": [
        "redstone"
    ],
    "EXE": [
        "redstone"
    ],
    "AXA": [
        "redstone"
    ],
    "ARDX": [
        "redstone"
    ],
    "XYZ": [
        "redstone"
    ],
    "JOB": [
        "redstone"
    ],
    "LOL": [
        "redstone"
    ],
    "TRIBE": [
        "redstone"
    ],
    "AIRX": [
        "redstone"
    ],
    "ANTR": [
        "redstone"
    ],
    "ZIK": [
        "redstone"
    ],
    "ERK": [
        "redstone"
    ],
    "AMON": [
        "redstone"
    ],
    "SLV": [
        "redstone"
    ],
    "TOKO": [
        "redstone"
    ],
    "BEST": [
        "redstone"
    ],
    "AMIO": [
        "redstone"
    ],
    "ANDES": [
        "redstone"
    ],
    "AFO": [
        "redstone"
    ],
    "CNTM": [
        "redstone"
    ],
    "BRZ": [
        "redstone"
    ],
    "XCHF": [
        "redstone"
    ],
    "AMIS": [
        "redstone"
    ],
    "SRK": [
        "redstone"
    ],
    "AIPE": [
        "redstone"
    ],
    "TFUEL": [
        "redstone"
    ],
    "ALTM": [
        "redstone"
    ],
    "GTC": [
        "redstone"
    ],
    "BKK": [
        "redstone"
    ],
    "ACD": [
        "redstone"
    ],
    "ALB": [
        "redstone"
    ],
    "BHP": [
        "redstone"
    ],
    "BWB": [
        "redstone"
    ],
    "AIDUS": [
        "redstone"
    ],
    "SONO": [
        "redstone"
    ],
    "HEDG": [
        "redstone"
    ],
    "PLG": [
        "redstone"
    ],
    "ABAO": [
        "redstone"
    ],
    "AGVC": [
        "redstone"
    ],
    "BHD": [
        "redstone"
    ],
    "HPT": [
        "redstone"
    ],
    "RRT": [
        "redstone"
    ],
    "ANTY": [
        "redstone"
    ],
    "STC": [
        "redstone"
    ],
    "TMTG": [
        "redstone"
    ],
    "MARX": [
        "redstone"
    ],
    "ADK": [
        "redstone"
    ],
    "XRA": [
        "redstone"
    ],
    "EVY": [
        "redstone"
    ],
    "ME": [
        "redstone"
    ],
    "VIDY": [
        "redstone"
    ],
    "FKX": [
        "redstone"
    ],
    "ATP": [
        "redstone"
    ],
    "PAI": [
        "redstone"
    ],
    "CET": [
        "redstone"
    ],
    "PERL": [
        "redstone"
    ],
    "DREP": [
        "redstone"
    ],
    "AGLT": [
        "redstone"
    ],
    "AKA": [
        "redstone"
    ],
    "NEW": [
        "redstone"
    ],
    "CRON": [
        "redstone"
    ],
    "AGN": [
        "redstone"
    ],
    "INNBC": [
        "redstone"
    ],
    "AGET": [
        "redstone"
    ],
    "SG": [
        "redstone"
    ],
    "OXT": [
        "redstone"
    ],
    "XAO": [
        "redstone"
    ],
    "MVL": [
        "redstone"
    ],
    "CENNZ": [
        "redstone"
    ],
    "SEELE": [
        "redstone"
    ],
    "ICP": [
        "redstone"
    ],
    "ABBC": [
        "redstone"
    ],
    "MOF": [
        "redstone"
    ],
    "EKT": [
        "redstone"
    ],
    "AAC": [
        "redstone"
    ],
    "KCASH": [
        "redstone"
    ],
    "TOPC": [
        "redstone"
    ],
    "AMR": [
        "redstone"
    ],
    "UBTC": [
        "redstone"
    ],
    "XUC": [
        "redstone"
    ],
    "ALTOM": [
        "redstone"
    ],
    "ALIS": [
        "redstone"
    ],
    "KICK": [
        "redstone"
    ],
    "KIN": [
        "redstone"
    ],
    "AGRS": [
        "redstone"
    ],
    "XWC": [
        "redstone"
    ],
    "AGVE": [
        "redstone"
    ],
    "AIOZ": [
        "redstone"
    ],
    "AWT": [
        "redstone"
    ],
    "AKITA": [
        "redstone"
    ],
    "ALR": [
        "redstone"
    ],
    "ALCX": [
        "redstone"
    ],
    "ALUSD": [
        "redstone"
    ],
    "ALCH": [
        "redstone"
    ],
    "AGOL": [
        "redstone"
    ],
    "TLM": [
        "redstone"
    ],
    "ALH": [
        "redstone"
    ],
    "ALPACA": [
        "redstone"
    ],
    "ALPHR": [
        "redstone"
    ],
    "ALN": [
        "redstone"
    ],
    "AMI": [
        "redstone"
    ],
    "FORTH": [
        "redstone"
    ],
    "AAPX": [
        "redstone"
    ],
    "ANS": [
        "redstone"
    ],
    "AGOV": [
        "redstone"
    ],
    "MATTER": [
        "redstone"
    ],
    "ABLOCK": [
        "redstone"
    ],
    "AP3": [
        "redstone"
    ],
    "APE$": [
        "redstone"
    ],
    "NANA": [
        "redstone"
    ],
    "APN": [
        "redstone"
    ],
    "BCVT": [
        "redstone"
    ],
    "BSBT": [
        "redstone"
    ],
    "BOSON": [
        "redstone"
    ],
    "CARR": [
        "redstone"
    ],
    "CONV": [
        "redstone"
    ],
    "CQT": [
        "redstone"
    ],
    "DPR": [
        "redstone"
    ],
    "ELON": [
        "redstone"
    ],
    "DORA": [
        "redstone"
    ],
    "ELONGATE": [
        "redstone"
    ],
    "ETHA": [
        "redstone"
    ],
    "ERN": [
        "redstone"
    ],
    "FEI": [
        "redstone"
    ],
    "FLY": [
        "redstone"
    ],
    "GMT": [
        "redstone"
    ],
    "GMEE": [
        "redstone"
    ],
    "HAPI": [
        "redstone"
    ],
    "HOKK": [
        "redstone"
    ],
    "ICE": [
        "redstone"
    ],
    "ILV": [
        "redstone"
    ],
    "INSUR": [
        "redstone"
    ],
    "IQQ": [
        "redstone"
    ],
    "KINE": [
        "redstone"
    ],
    "KISHU": [
        "redstone"
    ],
    "KONO": [
        "redstone"
    ],
    "LABS": [
        "redstone"
    ],
    "LQTY": [
        "redstone"
    ],
    "LUSD": [
        "redstone"
    ],
    "MINA": [
        "redstone"
    ],
    "MMAON": [
        "redstone"
    ],
    "ALICE": [
        "redstone"
    ],
    "OCC": [
        "redstone"
    ],
    "OXY": [
        "redstone"
    ],
    "PANDO": [
        "redstone"
    ],
    "PSL": [
        "redstone"
    ],
    "PIG": [
        "redstone"
    ],
    "PUNDIX": [
        "redstone"
    ],
    "FINE": [
        "redstone"
    ],
    "ROC": [
        "redstone"
    ],
    "SAFEMOON": [
        "redstone"
    ],
    "SATOZ": [
        "redstone"
    ],
    "SHFT": [
        "redstone"
    ],
    "SMTY": [
        "redstone"
    ],
    "SNOB": [
        "redstone"
    ],
    "SHOPX": [
        "redstone"
    ],
    "STEP": [
        "redstone"
    ],
    "STRK": [
        "redstone"
    ],
    "SUPERBID": [
        "redstone"
    ],
    "XYM": [
        "redstone"
    ],
    "TARA": [
        "redstone"
    ],
    "TKO": [
        "redstone"
    ],
    "HVE2": [
        "redstone"
    ],
    "MARSH": [
        "redstone"
    ],
    "PYR": [
        "redstone"
    ],
    "WSB": [
        "redstone"
    ],
    "XELS": [
        "redstone"
    ],
    "sUSD": [
        "redstone"
    ],
    "wNXM": [
        "redstone"
    ],
    "AMD": [
        "redstone"
    ],
    "AUD": [
        "redstone"
    ],
    "CHF": [
        "redstone"
    ],
    "EUR": [
        "redstone"
    ],
    "JPY": [
        "redstone"
    ],
    "NOK": [
        "redstone"
    ],
    "CSPR": [
        "redstone"
    ],
    "YFV": [
        "redstone"
    ],
    "ARDRIVE": [
        "redstone"
    ],
    "ARGO": [
        "redstone"
    ],
    "ARVERIFY": [
        "redstone"
    ],
    "EDST": [
        "redstone"
    ],
    "EMD_PST_TOKEN": [
        "redstone"
    ],
    "OPENBITS": [
        "redstone"
    ],
    "PBT": [
        "redstone"
    ],
    "QUAD": [
        "redstone"
    ],
    "SUNNY": [
        "redstone"
    ],
    "VRT": [
        "redstone"
    ],
    "IOTA": [
        "redstone"
    ],
    "XCH": [
        "redstone"
    ],
    "LAT": [
        "redstone"
    ],
    "DOGGY": [
        "redstone"
    ],
    "BZZ": [
        "redstone"
    ],
    "O3": [
        "redstone"
    ],
    "DOM": [
        "redstone"
    ],
    "ATA": [
        "redstone"
    ],
    "BABYDOGE": [
        "redstone"
    ],
    "HF": [
        "redstone"
    ],
    "FEAR": [
        "redstone"
    ],
    "DPET": [
        "redstone"
    ],
    "C98": [
        "redstone"
    ],
    "SKILL": [
        "redstone"
    ],
    "XCAD": [
        "redstone"
    ],
    "ASD": [
        "redstone"
    ],
    "YFDAI": [
        "redstone"
    ],
    "COOP": [
        "redstone"
    ],
    "SAFELIGHT": [
        "redstone"
    ],
    "DS": [
        "redstone"
    ],
    "ETL": [
        "redstone"
    ],
    "XEC": [
        "redstone"
    ],
    "BTCUP": [
        "redstone"
    ],
    "BTCDOWN": [
        "redstone"
    ],
    "ETHUP": [
        "redstone"
    ],
    "ETHDOWN": [
        "redstone"
    ],
    "DOTUP": [
        "redstone"
    ],
    "CCE": [
        "redstone"
    ],
    "Cube": [
        "redstone"
    ],
    "GNT": [
        "redstone"
    ],
    "ORS Group": [
        "redstone"
    ],
    "OMN": [
        "redstone"
    ],
    "EURT": [
        "redstone"
    ],
    "MDOGE": [
        "redstone"
    ],
    "B21X": [
        "redstone"
    ],
    "ETH2X": [
        "redstone"
    ],
    "PLANETS": [
        "redstone"
    ],
    "ABNB": [
        "redstone"
    ],
    "ACB": [
        "redstone"
    ],
    "ARKK": [
        "redstone"
    ],
    "BABA": [
        "redstone"
    ],
    "BB": [
        "redstone"
    ],
    "BILI": [
        "redstone"
    ],
    "BITW": [
        "redstone"
    ],
    "GDXJ": [
        "redstone"
    ],
    "GLD": [
        "redstone"
    ],
    "GLXY": [
        "redstone"
    ],
    "GOOGL": [
        "redstone"
    ],
    "MRNA": [
        "redstone"
    ],
    "PENN": [
        "redstone"
    ],
    "PFE": [
        "redstone"
    ],
    "PYPL": [
        "redstone"
    ],
    "SMBSWAP": [
        "redstone"
    ],
    "SQ": [
        "redstone"
    ],
    "TSM": [
        "redstone"
    ],
    "TWTR": [
        "redstone"
    ],
    "UBER": [
        "redstone"
    ],
    "USO": [
        "redstone"
    ],
    "ZM": [
        "redstone"
    ],
    "YFX": [
        "redstone"
    ],
    "CFG": [
        "redstone"
    ],
    "OOE": [
        "redstone"
    ],
    "DRS": [
        "redstone"
    ],
    "NVDA": [
        "redstone"
    ],
    "GDX": [
        "redstone"
    ],
    "TLRY": [
        "redstone"
    ],
    "DKNG": [
        "redstone"
    ],
    "XHT": [
        "redstone"
    ],
    "KAR": [
        "redstone"
    ],
    "AXC": [
        "redstone"
    ],
    "HERO": [
        "redstone"
    ],
    "AQUAGOAT": [
        "redstone"
    ],
    "PORNROCKET": [
        "redstone"
    ],
    "TOKAU": [
        "redstone"
    ],
    "SRM3L": [
        "redstone"
    ],
    "ALICE3L": [
        "redstone"
    ],
    "YFI3S": [
        "redstone"
    ],
    "ZEC3S": [
        "redstone"
    ],
    "DUKE": [
        "redstone"
    ],
    "DefiBox": [
        "redstone"
    ],
    "ARTEX": [
        "redstone"
    ],
    "CBY": [
        "redstone"
    ],
    "STRI": [
        "redstone"
    ],
    "SCONEX": [
        "redstone"
    ],
    "PNIXS": [
        "redstone"
    ],
    "PYE": [
        "redstone"
    ],
    "TRR": [
        "redstone"
    ],
    "WACO": [
        "redstone"
    ],
    "INVESTEL": [
        "redstone"
    ],
    "KABOSU": [
        "redstone"
    ],
    "GNBT": [
        "redstone"
    ],
    "MW=F": [
        "redstone-stocks"
    ],
    "DLM21": [
        "redstone-stocks"
    ],
    "DFQ21": [
        "redstone-stocks"
    ],
    "BD=F": [
        "redstone-stocks"
    ],
    "BJ=F": [
        "redstone-stocks"
    ],
    "CTZ21": [
        "redstone-stocks"
    ],
    "KC=F": [
        "redstone-stocks"
    ],
    "SB=F": [
        "redstone-stocks"
    ],
    "CC=F": [
        "redstone-stocks"
    ],
    "LS=F": [
        "redstone-stocks"
    ],
    "OJ=F": [
        "redstone-stocks"
    ],
    "XAVA": [
        "redstone",
        "redstone-avalanche"
    ],
    "SHERPA": [
        "redstone"
    ],
    "AVME": [
        "redstone"
    ],
    "WAVAX": [
        "redstone"
    ],
    "JOE": [
        "redstone"
    ],
    "YAK": [
        "redstone",
        "redstone-avalanche"
    ],
    "QI": [
        "redstone",
        "redstone-avalanche"
    ],
    "MXNUSD=X": [
        "redstone",
        "redstone-stocks"
    ],
    "BRLUSD=X": [
        "redstone",
        "redstone-stocks"
    ],
    "COPUSD=X": [
        "redstone",
        "redstone-stocks"
    ],
    "ARSUSD=X": [
        "redstone",
        "redstone-stocks"
    ],
    "PENUSD=X": [
        "redstone",
        "redstone-stocks"
    ],
    "SOS": [
        "redstone"
    ]
};

});



parcelRequire.register("9bWqa", function(module, exports) {
"use strict";
var $6b12755dc29eaaa7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        var __ = function __() {
            this.constructor = d;
        };
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6b12755dc29eaaa7$var$__assign = module.exports && module.exports.__assign || function() {
    $6b12755dc29eaaa7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6b12755dc29eaaa7$var$__assign.apply(this, arguments);
};
var $6b12755dc29eaaa7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6b12755dc29eaaa7$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};
var $6b12755dc29eaaa7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RedstoneQueryExecutable = module.exports.RedstoneQueryForSeveralSymbols = module.exports.RedstoneQueryForSingleSymbol = module.exports.RedstoneQueryForSingleOrSeveralSymbols = module.exports.RedstoneQuery = void 0;

var $6b12755dc29eaaa7$var$api_1 = $6b12755dc29eaaa7$var$__importDefault((parcelRequire("98ZRp")));
var $6b12755dc29eaaa7$var$RedstoneQuery = /** @class */ function() {
    var RedstoneQuery = function RedstoneQuery(params) {
        if (params === void 0) params = {};
        this.params = $6b12755dc29eaaa7$var$__assign({
            symbols: []
        }, params);
    };
    /**
     * Sets a token symbol to fetch
     * @param symbol - Token symbol string
     * @returns query object
     */ RedstoneQuery.prototype.symbol = function(symbol) {
        return new $6b12755dc29eaaa7$var$RedstoneQueryForSingleSymbol({
            symbols: [
                symbol
            ]
        });
    };
    /**
     * Sets token symbols to fetch
     * @param symbols - Array of strings (token symbols)
     * @returns query object
     */ RedstoneQuery.prototype.symbols = function(symbols) {
        return new $6b12755dc29eaaa7$var$RedstoneQueryForSeveralSymbols({
            symbols: symbols
        });
    };
    /**
     * Configures query to fetch prices for all supported tokens.
     * It doesn't support any params
     * @returns query object
     */ RedstoneQuery.prototype.allSymbols = function() {
        // return this.getQueryWithUpdatedSymbols<{ [symbol: string]: PriceData }>([]);
        return new $6b12755dc29eaaa7$var$RedstoneQueryForSeveralSymbols({
            symbols: []
        });
    };
    return RedstoneQuery;
}();
module.exports.RedstoneQuery = $6b12755dc29eaaa7$var$RedstoneQuery;
var $6b12755dc29eaaa7$var$RedstoneQueryForSingleOrSeveralSymbols = /** @class */ function() {
    var RedstoneQueryForSingleOrSeveralSymbols = function RedstoneQueryForSingleOrSeveralSymbols(params) {
        this.params = params;
    };
    // TODO: Maybe improve the type later (replace any with more detailed one)
    RedstoneQueryForSingleOrSeveralSymbols.prototype.getExecutableQuery = function(update) {
        return new $6b12755dc29eaaa7$var$RedstoneQueryExecutable($6b12755dc29eaaa7$var$__assign($6b12755dc29eaaa7$var$__assign({}, this.params), update));
    };
    /**
     * Configures query to fetch the latest price/prices
     * It doesn't support any params
     * @returns query object
     */ RedstoneQueryForSingleOrSeveralSymbols.prototype.latest = function() {
        return this.getExecutableQuery({});
    };
    /**
     * Configures query to fetch the price for X hours ago.
     * @param hoursCount - Number of hours ago
     * @returns query object
     */ RedstoneQueryForSingleOrSeveralSymbols.prototype.hoursAgo = function(hoursCount) {
        return this.getExecutableQuery({
            date: Date.now() - hoursCount * 3600000
        });
    };
    /**
     * Configures query to fetch the price for a specific date.
     * @param date - Date for the historical price (date | timestamp | string)
     * @returns query object
     */ RedstoneQueryForSingleOrSeveralSymbols.prototype.atDate = function(date) {
        return this.getExecutableQuery({
            date: date
        });
    };
    return RedstoneQueryForSingleOrSeveralSymbols;
}();
module.exports.RedstoneQueryForSingleOrSeveralSymbols = $6b12755dc29eaaa7$var$RedstoneQueryForSingleOrSeveralSymbols;
var $6b12755dc29eaaa7$var$RedstoneQueryForSingleSymbol = /** @class */ function(_super) {
    var RedstoneQueryForSingleSymbol = function RedstoneQueryForSingleSymbol(params) {
        return _super.call(this, params) || this;
    };
    $6b12755dc29eaaa7$var$__extends(RedstoneQueryForSingleSymbol, _super);
    /**
     * Configures query to fetch the price in a time range. It is important to use fromDate with toDate query methods
     * @param date - Start date/time for the time range
     *
     * @returns query object
     */ RedstoneQueryForSingleSymbol.prototype.fromDate = function(date) {
        return new RedstoneQueryForSingleSymbol($6b12755dc29eaaa7$var$__assign($6b12755dc29eaaa7$var$__assign({}, this.params), {
            startDate: date
        }));
    };
    /**
     * Configures query to fetch the price in a time range. toDate method should go after the fromDate
     * @param date - End date/time for the time range
     *
     * @returns query object
     */ RedstoneQueryForSingleSymbol.prototype.toDate = function(date) {
        if (this.params.startDate === undefined) throw new Error("Please specify fromDate before using toDate");
        return this.getExecutableQuery({
            endDate: date
        });
    };
    /**
     * Configures query to fetch the price for the last few hours
     * @param hoursCount - Number of hours in the time range
     *
     * @returns query object
     */ RedstoneQueryForSingleSymbol.prototype.forLastHours = function(hoursCount) {
        var endDate = Date.now();
        return this.getExecutableQuery({
            endDate: endDate,
            startDate: endDate - hoursCount * 3600000,
            interval: 600000
        });
    };
    /**
     * Configures query to fetch the price for the last few days
     * @param daysCount - Number of days in the time range
     *
     * @returns query object
     */ RedstoneQueryForSingleSymbol.prototype.forLastDays = function(daysCount) {
        var endDate = Date.now();
        return this.getExecutableQuery({
            endDate: endDate,
            startDate: endDate - daysCount * 86400000,
            interval: 3600000
        });
    };
    return RedstoneQueryForSingleSymbol;
}($6b12755dc29eaaa7$var$RedstoneQueryForSingleOrSeveralSymbols);
module.exports.RedstoneQueryForSingleSymbol = $6b12755dc29eaaa7$var$RedstoneQueryForSingleSymbol;
var $6b12755dc29eaaa7$var$RedstoneQueryForSeveralSymbols = /** @class */ function(_super) {
    var RedstoneQueryForSeveralSymbols = function RedstoneQueryForSeveralSymbols(params) {
        return _super.call(this, params) || this;
    };
    $6b12755dc29eaaa7$var$__extends(RedstoneQueryForSeveralSymbols, _super);
    return RedstoneQueryForSeveralSymbols;
}($6b12755dc29eaaa7$var$RedstoneQueryForSingleOrSeveralSymbols);
module.exports.RedstoneQueryForSeveralSymbols = $6b12755dc29eaaa7$var$RedstoneQueryForSeveralSymbols;
var $6b12755dc29eaaa7$var$RedstoneQueryExecutable = /** @class */ function() {
    var RedstoneQueryExecutable = function RedstoneQueryExecutable(params) {
        if (params === void 0) params = {};
        this.params = $6b12755dc29eaaa7$var$__assign({
            symbols: []
        }, params);
    };
    /**
     * Executes the query
     *
     * @returns Promise resolving the query result (result type depends on the query)
     */ RedstoneQueryExecutable.prototype.exec = function(redstoneApiConfig) {
        return $6b12755dc29eaaa7$var$__awaiter(this, void 0, void 0, function() {
            var redstone, symbols, symbolOrSymbols, _a, startDate, endDate, date, interval, diff;
            return $6b12755dc29eaaa7$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        redstone = new $6b12755dc29eaaa7$var$api_1.default($6b12755dc29eaaa7$var$__assign($6b12755dc29eaaa7$var$__assign({}, redstoneApiConfig), {
                            defaultProvider: redstoneApiConfig === null || redstoneApiConfig === void 0 ? void 0 : redstoneApiConfig.provider
                        }));
                        symbols = this.params.symbols;
                        if (!(symbols.length > 0)) return [
                            3 /*break*/ ,
                            5
                        ];
                        symbolOrSymbols = symbols.length === 1 ? symbols[0] : symbols;
                        _a = this.params, startDate = _a.startDate, endDate = _a.endDate, date = _a.date, interval = _a.interval;
                        if (![
                            startDate,
                            endDate,
                            date
                        ].every(function(el) {
                            return el === undefined;
                        })) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            redstone.getPrice(symbolOrSymbols, this.params)
                        ];
                    case 1:
                        // Fetch the latest price
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 2:
                        // Fetch the historical price
                        if (startDate !== undefined && endDate !== undefined && interval === undefined) {
                            diff = $6b12755dc29eaaa7$var$getTimeDiff(startDate, endDate);
                            if (diff >= 86400000) this.params.interval = 3600000;
                            else this.params.interval = 1;
                        }
                        return [
                            4 /*yield*/ ,
                            redstone.getHistoricalPrice(symbolOrSymbols, this.params)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            redstone.getAllPrices(this.params)
                        ];
                    case 6:
                        // Fetch prices for all tokens
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return RedstoneQueryExecutable;
}();
module.exports.RedstoneQueryExecutable = $6b12755dc29eaaa7$var$RedstoneQueryExecutable;
function $6b12755dc29eaaa7$var$getTimeDiff(date1, date2) {
    var timestamp1 = new Date(date1).getTime();
    var timestamp2 = new Date(date2).getTime();
    return Math.abs(timestamp2 - timestamp1);
}
/**
 * Initializes and returns an empty query.
 * It doesn't support any params
 * @returns query object
 */ var $6b12755dc29eaaa7$var$query = function query() {
    return new $6b12755dc29eaaa7$var$RedstoneQuery();
};
module.exports.default = $6b12755dc29eaaa7$var$query;

});

parcelRequire.register("ilAYG", function(module, exports) {

module.exports = (parcelRequire("6Yo70"));

});
parcelRequire.register("6Yo70", function(module, exports) {
"use strict";

var $hFwA2 = parcelRequire("hFwA2");

var $3rALo = parcelRequire("3rALo");

var $bc3GF = parcelRequire("bc3GF");

var $3GlO3 = parcelRequire("3GlO3");

var $i9Kir = parcelRequire("i9Kir");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $513b0cd2876c99ce$var$createInstance(defaultConfig) {
    var context = new $bc3GF(defaultConfig);
    var instance = $3rALo($bc3GF.prototype.request, context);
    // Copy axios.prototype to instance
    $hFwA2.extend(instance, $bc3GF.prototype, context);
    // Copy context to instance
    $hFwA2.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $513b0cd2876c99ce$var$createInstance($3GlO3(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $513b0cd2876c99ce$var$axios = $513b0cd2876c99ce$var$createInstance($i9Kir);
// Expose Axios class to allow class inheritance
$513b0cd2876c99ce$var$axios.Axios = $bc3GF;

// Expose Cancel & CancelToken
$513b0cd2876c99ce$var$axios.CanceledError = (parcelRequire("4ZTza"));

$513b0cd2876c99ce$var$axios.CancelToken = (parcelRequire("f9odA"));

$513b0cd2876c99ce$var$axios.isCancel = (parcelRequire("bjwjm"));

$513b0cd2876c99ce$var$axios.VERSION = (parcelRequire("69Hns")).version;

$513b0cd2876c99ce$var$axios.toFormData = (parcelRequire("boUxR"));

// Expose AxiosError class
$513b0cd2876c99ce$var$axios.AxiosError = (parcelRequire("81Ggh"));
// alias for CanceledError for backward compatibility
$513b0cd2876c99ce$var$axios.Cancel = $513b0cd2876c99ce$var$axios.CanceledError;
// Expose all/spread
$513b0cd2876c99ce$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$513b0cd2876c99ce$var$axios.spread = (parcelRequire("4SVdl"));

// Expose isAxiosError
$513b0cd2876c99ce$var$axios.isAxiosError = (parcelRequire("eDOgc"));
module.exports = $513b0cd2876c99ce$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $513b0cd2876c99ce$var$axios;

});
parcelRequire.register("hFwA2", function(module, exports) {
"use strict";

var $3rALo = parcelRequire("3rALo");
// utils is a library of generic helper functions non-specific to axios
var $cdcf89c9ba67a019$var$toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var $cdcf89c9ba67a019$var$kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = $cdcf89c9ba67a019$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function $cdcf89c9ba67a019$var$kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return $cdcf89c9ba67a019$var$kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $cdcf89c9ba67a019$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $cdcf89c9ba67a019$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $cdcf89c9ba67a019$var$isBuffer(val) {
    return val !== null && !$cdcf89c9ba67a019$var$isUndefined(val) && val.constructor !== null && !$cdcf89c9ba67a019$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $cdcf89c9ba67a019$var$isArrayBuffer = $cdcf89c9ba67a019$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $cdcf89c9ba67a019$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $cdcf89c9ba67a019$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $cdcf89c9ba67a019$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $cdcf89c9ba67a019$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $cdcf89c9ba67a019$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $cdcf89c9ba67a019$var$isPlainObject(val) {
    if ($cdcf89c9ba67a019$var$kindOf(val) !== "object") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $cdcf89c9ba67a019$var$isDate = $cdcf89c9ba67a019$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $cdcf89c9ba67a019$var$isFile = $cdcf89c9ba67a019$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $cdcf89c9ba67a019$var$isBlob = $cdcf89c9ba67a019$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $cdcf89c9ba67a019$var$isFileList = $cdcf89c9ba67a019$var$kindOfTest("FileList");
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $cdcf89c9ba67a019$var$isFunction(val) {
    return $cdcf89c9ba67a019$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $cdcf89c9ba67a019$var$isStream(val) {
    return $cdcf89c9ba67a019$var$isObject(val) && $cdcf89c9ba67a019$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $cdcf89c9ba67a019$var$isFormData(thing) {
    var pattern = "[object FormData]";
    return thing && (typeof FormData === "function" && thing instanceof FormData || $cdcf89c9ba67a019$var$toString.call(thing) === pattern || $cdcf89c9ba67a019$var$isFunction(thing.toString) && thing.toString() === pattern);
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $cdcf89c9ba67a019$var$isURLSearchParams = $cdcf89c9ba67a019$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $cdcf89c9ba67a019$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $cdcf89c9ba67a019$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $cdcf89c9ba67a019$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($cdcf89c9ba67a019$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $cdcf89c9ba67a019$var$merge() {
    var assignValue = function assignValue(val, key) {
        if ($cdcf89c9ba67a019$var$isPlainObject(result[key]) && $cdcf89c9ba67a019$var$isPlainObject(val)) result[key] = $cdcf89c9ba67a019$var$merge(result[key], val);
        else if ($cdcf89c9ba67a019$var$isPlainObject(val)) result[key] = $cdcf89c9ba67a019$var$merge({}, val);
        else if ($cdcf89c9ba67a019$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    };
    var result = {};
    for(var i = 0, l = arguments.length; i < l; i++)$cdcf89c9ba67a019$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $cdcf89c9ba67a019$var$extend(a, b, thisArg) {
    $cdcf89c9ba67a019$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $3rALo(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $cdcf89c9ba67a019$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function $cdcf89c9ba67a019$var$inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */ function $cdcf89c9ba67a019$var$toFlatObject(sourceObj, destObj, filter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if (!merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function $cdcf89c9ba67a019$var$endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */ function $cdcf89c9ba67a019$var$toArray(thing) {
    if (!thing) return null;
    var i = thing.length;
    if ($cdcf89c9ba67a019$var$isUndefined(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var $cdcf89c9ba67a019$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
module.exports = {
    isArray: $cdcf89c9ba67a019$var$isArray,
    isArrayBuffer: $cdcf89c9ba67a019$var$isArrayBuffer,
    isBuffer: $cdcf89c9ba67a019$var$isBuffer,
    isFormData: $cdcf89c9ba67a019$var$isFormData,
    isArrayBufferView: $cdcf89c9ba67a019$var$isArrayBufferView,
    isString: $cdcf89c9ba67a019$var$isString,
    isNumber: $cdcf89c9ba67a019$var$isNumber,
    isObject: $cdcf89c9ba67a019$var$isObject,
    isPlainObject: $cdcf89c9ba67a019$var$isPlainObject,
    isUndefined: $cdcf89c9ba67a019$var$isUndefined,
    isDate: $cdcf89c9ba67a019$var$isDate,
    isFile: $cdcf89c9ba67a019$var$isFile,
    isBlob: $cdcf89c9ba67a019$var$isBlob,
    isFunction: $cdcf89c9ba67a019$var$isFunction,
    isStream: $cdcf89c9ba67a019$var$isStream,
    isURLSearchParams: $cdcf89c9ba67a019$var$isURLSearchParams,
    isStandardBrowserEnv: $cdcf89c9ba67a019$var$isStandardBrowserEnv,
    forEach: $cdcf89c9ba67a019$var$forEach,
    merge: $cdcf89c9ba67a019$var$merge,
    extend: $cdcf89c9ba67a019$var$extend,
    trim: $cdcf89c9ba67a019$var$trim,
    stripBOM: $cdcf89c9ba67a019$var$stripBOM,
    inherits: $cdcf89c9ba67a019$var$inherits,
    toFlatObject: $cdcf89c9ba67a019$var$toFlatObject,
    kindOf: $cdcf89c9ba67a019$var$kindOf,
    kindOfTest: $cdcf89c9ba67a019$var$kindOfTest,
    endsWith: $cdcf89c9ba67a019$var$endsWith,
    toArray: $cdcf89c9ba67a019$var$toArray,
    isTypedArray: $cdcf89c9ba67a019$var$isTypedArray,
    isFileList: $cdcf89c9ba67a019$var$isFileList
};

});
parcelRequire.register("3rALo", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRequire.register("bc3GF", function(module, exports) {
"use strict";

var $hFwA2 = parcelRequire("hFwA2");

var $5rDFz = parcelRequire("5rDFz");

var $eQAd2 = parcelRequire("eQAd2");

var $deOoF = parcelRequire("deOoF");

var $3GlO3 = parcelRequire("3GlO3");

var $4dh3t = parcelRequire("4dh3t");

var $jKFKv = parcelRequire("jKFKv");
var $8263ace96ff453f6$var$validators = $jKFKv.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $8263ace96ff453f6$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $eQAd2(),
        response: new $eQAd2()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $8263ace96ff453f6$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $3GlO3(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $jKFKv.assertOptions(transitional, {
        silentJSONParsing: $8263ace96ff453f6$var$validators.transitional($8263ace96ff453f6$var$validators.boolean),
        forcedJSONParsing: $8263ace96ff453f6$var$validators.transitional($8263ace96ff453f6$var$validators.boolean),
        clarifyTimeoutError: $8263ace96ff453f6$var$validators.transitional($8263ace96ff453f6$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $deOoF,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $deOoF(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$8263ace96ff453f6$var$Axios.prototype.getUri = function getUri(config) {
    config = $3GlO3(this.defaults, config);
    var fullPath = $4dh3t(config.baseURL, config.url);
    return $5rDFz(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
$hFwA2.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $8263ace96ff453f6$var$Axios.prototype[method] = function(url, config) {
        return this.request($3GlO3(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$hFwA2.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    var generateHTTPMethod = /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($3GlO3(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    };
    $8263ace96ff453f6$var$Axios.prototype[method] = generateHTTPMethod();
    $8263ace96ff453f6$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
module.exports = $8263ace96ff453f6$var$Axios;

});
parcelRequire.register("5rDFz", function(module, exports) {
"use strict";

var $hFwA2 = parcelRequire("hFwA2");
function $3f6e3ee4e347133e$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($hFwA2.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $hFwA2.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($hFwA2.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $hFwA2.forEach(val, function parseValue(v) {
                if ($hFwA2.isDate(v)) v = v.toISOString();
                else if ($hFwA2.isObject(v)) v = JSON.stringify(v);
                parts.push($3f6e3ee4e347133e$var$encode(key) + "=" + $3f6e3ee4e347133e$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRequire.register("eQAd2", function(module, exports) {
"use strict";

var $hFwA2 = parcelRequire("hFwA2");
function $acf2026e0e02f061$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $acf2026e0e02f061$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $acf2026e0e02f061$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $acf2026e0e02f061$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $hFwA2.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $acf2026e0e02f061$var$InterceptorManager;

});

parcelRequire.register("deOoF", function(module, exports) {
"use strict";

var $hFwA2 = parcelRequire("hFwA2");

var $5XBN7 = parcelRequire("5XBN7");

var $bjwjm = parcelRequire("bjwjm");

var $i9Kir = parcelRequire("i9Kir");

var $4ZTza = parcelRequire("4ZTza");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function $9a33acf408161d5d$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $4ZTza();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $9a33acf408161d5d$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $5XBN7.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $hFwA2.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $hFwA2.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $i9Kir.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $9a33acf408161d5d$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $5XBN7.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$bjwjm(reason)) {
            $9a33acf408161d5d$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $5XBN7.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRequire.register("5XBN7", function(module, exports) {
"use strict";

var $hFwA2 = parcelRequire("hFwA2");

var $i9Kir = parcelRequire("i9Kir");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $i9Kir;
    /*eslint no-param-reassign:0*/ $hFwA2.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRequire.register("i9Kir", function(module, exports) {

var $aqbQf = parcelRequire("aqbQf");
"use strict";

var $hFwA2 = parcelRequire("hFwA2");

var $4Pbbj = parcelRequire("4Pbbj");

var $81Ggh = parcelRequire("81Ggh");

var $cPIyE = parcelRequire("cPIyE");

var $boUxR = parcelRequire("boUxR");
var $d37cfac17826c772$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $d37cfac17826c772$var$setContentTypeIfUnset(headers, value) {
    if (!$hFwA2.isUndefined(headers) && $hFwA2.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $d37cfac17826c772$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("6d5h4"));
    else if (typeof $aqbQf !== "undefined" && Object.prototype.toString.call($aqbQf) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("6d5h4"));
    return adapter;
}
function $d37cfac17826c772$var$stringifySafely(rawValue, parser, encoder) {
    if ($hFwA2.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $hFwA2.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}

var $d37cfac17826c772$var$defaults = {
    transitional: $cPIyE,
    adapter: $d37cfac17826c772$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $4Pbbj(headers, "Accept");
            $4Pbbj(headers, "Content-Type");
            if ($hFwA2.isFormData(data) || $hFwA2.isArrayBuffer(data) || $hFwA2.isBuffer(data) || $hFwA2.isStream(data) || $hFwA2.isFile(data) || $hFwA2.isBlob(data)) return data;
            if ($hFwA2.isArrayBufferView(data)) return data.buffer;
            if ($hFwA2.isURLSearchParams(data)) {
                $d37cfac17826c772$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            var isObjectPayload = $hFwA2.isObject(data);
            var contentType = headers && headers["Content-Type"];
            var isFileList;
            if ((isFileList = $hFwA2.isFileList(data)) || isObjectPayload && contentType === "multipart/form-data") {
                var _FormData = this.env && this.env.FormData;
                return $boUxR(isFileList ? {
                    "files[]": data
                } : data, _FormData && new _FormData());
            } else if (isObjectPayload || contentType === "application/json") {
                $d37cfac17826c772$var$setContentTypeIfUnset(headers, "application/json");
                return $d37cfac17826c772$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $d37cfac17826c772$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $hFwA2.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $81Ggh.from(e, $81Ggh.ERR_BAD_RESPONSE, this, null, this.response);
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (parcelRequire("oPMKT"))
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$hFwA2.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $d37cfac17826c772$var$defaults.headers[method] = {};
});
$hFwA2.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $d37cfac17826c772$var$defaults.headers[method] = $hFwA2.merge($d37cfac17826c772$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $d37cfac17826c772$var$defaults;

});
parcelRequire.register("4Pbbj", function(module, exports) {
"use strict";

var $hFwA2 = parcelRequire("hFwA2");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $hFwA2.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRequire.register("81Ggh", function(module, exports) {
"use strict";

var $hFwA2 = parcelRequire("hFwA2");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function $5d7f32f8de5e950e$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$hFwA2.inherits($5d7f32f8de5e950e$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $5d7f32f8de5e950e$var$prototype = $5d7f32f8de5e950e$var$AxiosError.prototype;
var $5d7f32f8de5e950e$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED"
].forEach(function(code) {
    $5d7f32f8de5e950e$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($5d7f32f8de5e950e$var$AxiosError, $5d7f32f8de5e950e$var$descriptors);
Object.defineProperty($5d7f32f8de5e950e$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$5d7f32f8de5e950e$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($5d7f32f8de5e950e$var$prototype);
    $hFwA2.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    $5d7f32f8de5e950e$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = $5d7f32f8de5e950e$var$AxiosError;

});

parcelRequire.register("cPIyE", function(module, exports) {
"use strict";
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRequire.register("boUxR", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $84cdcc4b8f87512b$require$Buffer = $gzLuY.Buffer;
"use strict";

var $hFwA2 = parcelRequire("hFwA2");
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/ function $84cdcc4b8f87512b$var$toFormData(obj, formData) {
    var convertValue = function convertValue(value) {
        if (value === null) return "";
        if ($hFwA2.isDate(value)) return value.toISOString();
        if ($hFwA2.isArrayBuffer(value) || $hFwA2.isTypedArray(value)) return typeof Blob === "function" ? new Blob([
            value
        ]) : $84cdcc4b8f87512b$require$Buffer.from(value);
        return value;
    };
    // eslint-disable-next-line no-param-reassign
    formData = formData || new FormData();
    var stack = [];
    function build(data, parentKey) {
        if ($hFwA2.isPlainObject(data) || $hFwA2.isArray(data)) {
            if (stack.indexOf(data) !== -1) throw Error("Circular reference detected in " + parentKey);
            stack.push(data);
            $hFwA2.forEach(data, function each(value, key) {
                if ($hFwA2.isUndefined(value)) return;
                var fullKey = parentKey ? parentKey + "." + key : key;
                var arr;
                if (value && !parentKey && typeof value === "object") {
                    if ($hFwA2.endsWith(key, "{}")) // eslint-disable-next-line no-param-reassign
                    value = JSON.stringify(value);
                    else if ($hFwA2.endsWith(key, "[]") && (arr = $hFwA2.toArray(value))) {
                        // eslint-disable-next-line func-names
                        arr.forEach(function(el) {
                            !$hFwA2.isUndefined(el) && formData.append(fullKey, convertValue(el));
                        });
                        return;
                    }
                }
                build(value, fullKey);
            });
            stack.pop();
        } else formData.append(parentKey, convertValue(data));
    }
    build(obj);
    return formData;
}
module.exports = $84cdcc4b8f87512b$var$toFormData;

});

parcelRequire.register("6d5h4", function(module, exports) {
"use strict";

var $hFwA2 = parcelRequire("hFwA2");

var $bzzQP = parcelRequire("bzzQP");

var $hAQlm = parcelRequire("hAQlm");

var $5rDFz = parcelRequire("5rDFz");

var $4dh3t = parcelRequire("4dh3t");

var $hYLRx = parcelRequire("hYLRx");

var $g0jqv = parcelRequire("g0jqv");

var $cPIyE = parcelRequire("cPIyE");

var $81Ggh = parcelRequire("81Ggh");

var $4ZTza = parcelRequire("4ZTza");

var $3FSth = parcelRequire("3FSth");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var done = function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        };
        var onloadend = function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $hYLRx(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $bzzQP(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        };
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        if ($hFwA2.isFormData(requestData) && $hFwA2.isStandardBrowserEnv()) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $4dh3t(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $5rDFz(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $81Ggh("Request aborted", $81Ggh.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $81Ggh("Network Error", $81Ggh.ERR_NETWORK, config, request, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $cPIyE;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $81Ggh(timeoutErrorMessage, transitional.clarifyTimeoutError ? $81Ggh.ETIMEDOUT : $81Ggh.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($hFwA2.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $g0jqv(fullPath)) && config.xsrfCookieName ? $hAQlm.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $hFwA2.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$hFwA2.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function onCanceled(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $4ZTza() : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        var protocol = $3FSth(fullPath);
        if (protocol && [
            "http",
            "https",
            "file"
        ].indexOf(protocol) === -1) {
            reject(new $81Ggh("Unsupported protocol " + protocol + ":", $81Ggh.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

});
parcelRequire.register("bzzQP", function(module, exports) {
"use strict";

var $81Ggh = parcelRequire("81Ggh");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $81Ggh("Request failed with status code " + response.status, [
        $81Ggh.ERR_BAD_REQUEST,
        $81Ggh.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

});

parcelRequire.register("hAQlm", function(module, exports) {
"use strict";

var $hFwA2 = parcelRequire("hFwA2");
module.exports = $hFwA2.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($hFwA2.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($hFwA2.isString(path)) cookie.push("path=" + path);
            if ($hFwA2.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRequire.register("4dh3t", function(module, exports) {
"use strict";

var $8FzWJ = parcelRequire("8FzWJ");

var $lvQM8 = parcelRequire("lvQM8");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$8FzWJ(requestedURL)) return $lvQM8(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRequire.register("8FzWJ", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRequire.register("lvQM8", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRequire.register("hYLRx", function(module, exports) {
"use strict";

var $hFwA2 = parcelRequire("hFwA2");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $d16d2ac6f996294c$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $hFwA2.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $hFwA2.trim(line.substr(0, i)).toLowerCase();
        val = $hFwA2.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $d16d2ac6f996294c$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRequire.register("g0jqv", function(module, exports) {
"use strict";

var $hFwA2 = parcelRequire("hFwA2");
module.exports = $hFwA2.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var resolveURL = /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    };
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $hFwA2.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRequire.register("4ZTza", function(module, exports) {
"use strict";

var $81Ggh = parcelRequire("81Ggh");

var $hFwA2 = parcelRequire("hFwA2");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $3a37f63a4700b9aa$var$CanceledError(message) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $81Ggh.call(this, message == null ? "canceled" : message, $81Ggh.ERR_CANCELED);
    this.name = "CanceledError";
}
$hFwA2.inherits($3a37f63a4700b9aa$var$CanceledError, $81Ggh, {
    __CANCEL__: true
});
module.exports = $3a37f63a4700b9aa$var$CanceledError;

});

parcelRequire.register("3FSth", function(module, exports) {
"use strict";
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
};

});


parcelRequire.register("oPMKT", function(module, exports) {
// eslint-disable-next-line strict
module.exports = null;

});



parcelRequire.register("bjwjm", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRequire.register("3GlO3", function(module, exports) {
"use strict";

var $hFwA2 = parcelRequire("hFwA2");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    var getMergedValue = function getMergedValue(target, source) {
        if ($hFwA2.isPlainObject(target) && $hFwA2.isPlainObject(source)) return $hFwA2.merge(target, source);
        else if ($hFwA2.isPlainObject(source)) return $hFwA2.merge({}, source);
        else if ($hFwA2.isArray(source)) return source.slice();
        return source;
    };
    var mergeDeepProperties = // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$hFwA2.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$hFwA2.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    };
    var valueFromConfig2 = // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$hFwA2.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    };
    var defaultToConfig2 = // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$hFwA2.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$hFwA2.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    };
    var mergeDirectKeys = // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    };
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "beforeRedirect": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $hFwA2.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $hFwA2.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRequire.register("jKFKv", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
"use strict";

var $69Hns = parcelRequire("69Hns");
var $e612b2af2fb589c3$require$VERSION = $69Hns.version;

var $81Ggh = parcelRequire("81Ggh");
var $e612b2af2fb589c3$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $e612b2af2fb589c3$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $1ObTH._)(thing)) === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $e612b2af2fb589c3$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $e612b2af2fb589c3$var$validators.transitional = function transitional(validator, version, message) {
    var formatMessage = function formatMessage(opt, desc) {
        return "[Axios v" + $e612b2af2fb589c3$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    };
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new $81Ggh(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), $81Ggh.ERR_DEPRECATED);
        if (version && !$e612b2af2fb589c3$var$deprecatedWarnings[opt]) {
            $e612b2af2fb589c3$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $e612b2af2fb589c3$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new $81Ggh("options must be an object", $81Ggh.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $81Ggh("option " + opt + " must be " + result, $81Ggh.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $81Ggh("Unknown option " + opt, $81Ggh.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: $e612b2af2fb589c3$var$assertOptions,
    validators: $e612b2af2fb589c3$var$validators
};

});
parcelRequire.register("69Hns", function(module, exports) {
module.exports = {
    "version": "0.27.2"
};

});



parcelRequire.register("f9odA", function(module, exports) {
"use strict";

var $4ZTza = parcelRequire("4ZTza");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $b07a7b7a781da398$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $4ZTza(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ $b07a7b7a781da398$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $b07a7b7a781da398$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $b07a7b7a781da398$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $b07a7b7a781da398$var$CancelToken.source = function source() {
    var cancel;
    var token = new $b07a7b7a781da398$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $b07a7b7a781da398$var$CancelToken;

});

parcelRequire.register("4SVdl", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRequire.register("eDOgc", function(module, exports) {
"use strict";

var $hFwA2 = parcelRequire("hFwA2");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $hFwA2.isObject(payload) && payload.isAxiosError === true;
};

});



parcelRequire.register("3Yim8", function(module, exports) {
module.exports = JSON.parse('{"nodes":{"I-5rWUehEv-MjdK9gFw09RxfSLQX9DIHxG614Wf8qo0":{"url":"https://redstone.finance","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"redstone","ipAddress":"0.0.0.0","dataServiceId":"redstone-main-demo","evmAddress":"0x0C39486f770B26F5527BBBf942726537986Cd7eb","description":"Main RedStone Provider with all available tokens.","arweavePublicKey":"xyTvKiCST8bAT6sxrgkLh8UCX2N1eKvawODuxwq4qOHIdDAZFU_3N2m59rkZ0E7m77GsJuf1I8u0oEJEbxAdT7uD2JTwoYEHauXSxyJYvF0RCcZOhl5P1PJwImd44SJYa_9My7L84D5KXB9SKs8_VThe7ZyOb5HSGLNvMIK6A8IJ4Hr_tg9GYm65CRmtcu18S9mhun8vgw2wi7Gw6oR6mc4vU1I-hrU66Fi7YlXwFieP6YSy01JqoLPhU84EunPQzXPouVSbXjgRU5kFVxtdRy4GK2fzEBFYsQwCQgFrySCrFKHV8AInu9jerfof_DxNKiXkBzlB8nc22CrYnvvio_BWyh-gN0hQHZT0gwMR-A7sbXNCQJfReaIZzX_jP6XoB82PnpzmL_j1mJ2lnv2Rn001flBAx9AYxtGXd9s07pA-FggTbEG3Y2UnlWW6l3EJ93E0IfxL0PqGEUlp217mxUHvmTw9fkGDWa8rT9RPmsTyji-kMFSefclw80cBm_iOsIEutGP4S3LDbP-ZVJWDeJOBQQpSgwbisl8qbjl2sMQLQihoG2TQyNbmLwfyq-XSULkXjUi1_6BH36wnDBLWBKF-bS2bLKcGtn3Vjet72lNHxJJilcj8vpauwJG0078S_lO5uGt6oicdGR6eh_NSn6_8za_tXg0G_fohz4Yb1z8","ecdsaPublicKey":"0x04009dd87eb41d96ce8ad94aa22ea8b0ba4ac20c45e42f71726d6b180f93c3f298e333ae7591fe1c9d88234575639be9e81e35ba2fe5ad2c2260f07db49ccb9d0d"},"Yba8IVc_01bFxutKNJAZ7CmTD5AVi2GcWXf1NajPAsc":{"url":"https://redstone.finance","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"redstone-stocks","ipAddress":"0.0.0.0","dataServiceId":"redstone-stocks-demo","evmAddress":"0x926E370fD53c23f8B71ad2B3217b227E41A92b12","description":"Stocks, ETFs, Livestocks, Metals, Energies...","arweavePublicKey":"wOoClMPZ_maAoE6OhCC8svn_9gu8rjuWPi3Grf05zpQnCzeFjzUocJUr0ta-muJDqfiTd4t5KR2qNxn3nkN2_kXsn5AcXnlI4UgnRdcEvsDh6yPMoMlAiAD6c0_CIgdiMFku5OTijNMtFYOybPKrd9Xdf_7_lnRZhU9qQXeBclVjmIzftwNaTFYI1sgApWKMxJ6301CY7VN9SOD9KBrFQJ3QjWqLrLwAyAu_Q6aBeQF_L-cZSFCiTfwyDptiMCdLAjzU9s55LNAg65pZ_OfFsvqylwiXEVIEDLUI3nmcM6OUHfyAG2TxoeXeem9nCpA96MiM8MyTWtOApGA3GW__j3fxutD0wt3_uGnVRZoypPqNuPjb5BraF0owTDYJQNML9Ddx1Hy6gMXjvjxn-MbAV7tI4KnDynrbtXPSZYjRpTpxcH9Rlr-bQAZWGpYF7OWpsZlPuE4MdxpQYhqLj6wfGCxTyzIjyt_t4zR28gWIGT5SfM-etcuXyy_chspsIqisSj781AP7YMTIxzyrY_LAAm-u5gz5VwnD8xDKIrYcsxLpC4V30HFWRc5vYtBQ0cAZYnp9AGGFD-6A7PnqQ1EYSSEHzSAqoYHaqxuAvxJEhG5AECdXBS3-FpgbGgVFEeQxIH7v9Js6-Uk85t23MjRUJFNo2JIlvyolmtkd3mf88qc","ecdsaPublicKey":"0x04a628e8c2ef7d3b768b75404a48adcd667d0d59ae457bf19552ff670d2c95630480752e90b0c9fe8127feeb9e8f9e694919c730327bd368c985f1a5b26c2d60ba"},"zYqPZuALSPa_f5Agvf8g2JHv94cqMn9aBtnH7GFHbuA":{"url":"https://redstone.finance","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"redstone-rapid","ipAddress":"0.0.0.0","dataServiceId":"redstone-rapid-demo","evmAddress":"0xf786a909D559F5Dee2dc6706d8e5A81728a39aE9","description":"Most popular tokens with frequent updates","arweavePublicKey":"tfkkt6lHR3lSEBNvjistpdGb8pR9UJoOVO-IuXRXD9PckAqY7TAVuDVhrcQDM56GZ_EUh6Eg_NRYd-EGW8SEQLHXtY_CM4P8563xUpw0XcZJbpOeScFcN5JdN47gq8vllOheO6-v4nRPLVabRVJqkXEqzdEwxQNYDkmPL-gxE0ziZcQRQZdJUzL5mI9DzwpPC86JBVwsBK71iuRlstABciIu8u77qyArkNu0pPig9OFQvT3Vg4OPuWXd83EhqEuN5gqVufyomkmL8X7agiEjDf-UQIfZrSYqgiJsWiVJ2aKHRhLZN17wdX51L21Cg2Sbyb3B1Roy5EgUUTdJ2MY7LnI-CTbBBJLKUHSvN67MDhj1OSBwUULc8bgVCzmfVQryIFmb4tucKvz7TRAWseXNO2MtMlggXa42Hx0sOTopbFTmT_r9glRLYw3QLzyJVH7Ltqr8QldoU-VMWtpo5cmOGh8jwVknSHqWNURbRCoDfAuwh8lpWXBjL_V8haaY0OKFT9Lpi1VW8o4Kfx7ED1VAnLcpVIoV5CkPs_L0Qy_G7XpgA02OAbJH2KvwxZPeSSymdupmr1KMc8iGz5B4a1HEcKggk5ETFfeGz5r0hDha3dwDj-dOv1jbADcdgk7e2xaLgw1CpS1XEHhAnhBJgAzJDJpcHKrxPkD6cUc7FbnsBCE","ecdsaPublicKey":"0x041d45589c5055c867e857d8437e7d5745027d0a455801bc78cc856840510e76d8ffe578296a11a03e744d7a953e0f1e36c3a93f74268859e480203ab4d2f5718e"},"f1Ipos2fVPbxPVO65GBygkMyW0tkAhp2hdprRPPBBN8":{"url":"https://redstone.finance","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"redstone-avalanche-node-1","ipAddress":"0.0.0.0","dataServiceId":"redstone-avalanche-demo","evmAddress":"0x3a7d971De367FE15D164CDD952F64205F2D9f10c","description":"Most popular tokens from the Avalanche ecosystem - demo node 1","arweavePublicKey":"nehHT9-CMWscteR3COOU455AmDI8VihUPG05kDryVl8wjv4iE_7MttV2rz3MTIicL1BNDQ246EnyIL_4qsqu8a_B3dZT8sVdfOtHqh48pDgA0MJ8ifFVUtyabr3D2ZSc2M4re79wm2SQ_S74ZNHV7zBIBS8pUHB20TfrKhrOWi-W0hfkxrqz4jIngXIPmE1ycYbaj9OHSVRFIB-EZN-1LmLZuy2EAAN0nOqJ-aYoblcGOu4WfZDpTXTfj-6-GRRBgeHen3MYnQuDneEYYrtzoCnimWGYrqRnpM654mJTW7gp_NIqLnXn3yG2aS2pbhn1_I0CavtKuE4PSACoP0UwZaGXEtanIaSuMDkeRdu-zhrr8yXZSW1inWdC0lhWPxAhzTYWQ00_OD6oj2FUtbXbAk_F-aPnT1Teb-LcNn6q-HbHSeZ_VV0ge5nn3zvBCc77z-Qfbgyd_a7dNwfy8sVkQc4-gvDJIftzxVXbUWnc3ipvL-PHfLsajg5Jkhteuvf8bIS0cNFS5u9pu3qnutskQxSymPzhkVmSyMWNe48Xp3ok4mUA9SuWTb6AskyoDVR9APh7JNDgeYINctgduqawzJQFxcVDuoW-1b8Gy79EYXW8yHowpAaDm6eYGTPQjnMpttThZwFiC_81JTXHXmDneKm677F2kO-1f6o4UWTBOEk","ecdsaPublicKey":"0x0455e7c699a153e02de0e6d3c3dcdb34d1e57a9456205b0e124e2cac29b58be83c4faa2081d39b38aa3c41fa3350f50dcf87d40ab695c9c86709040d39d5ba9be3"},"6bZ3yxPYy0LHPqo7MNqw0PHTeIM2PR-RmfTPYLltsfw":{"url":"https://redstone.finance","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"redstone-avalanche-node-2","ipAddress":"0.0.0.0","dataServiceId":"redstone-avalanche-demo","evmAddress":"0x3a7d971De367FE15D164CDD952F64205F2D9f10c","description":"Most popular tokens from the Avalanche ecosystem - demo node 2","arweavePublicKey":"TODO: find and add","ecdsaPublicKey":"TODO: find and add"},"aw9F_2R2ogYPnM66TDsW1qtiiRflRcgZQG6OLySOSZE":{"name":"redstone-twaps-1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"RedStone TWAPs - node 1","dataServiceId":"redstone-twaps-demo","evmAddress":"0xAAb9568f7165E66AcaFF50B705C3f3e964cbD24f","ipAddress":"0.0.0.0","url":"https://redstone.finance","arweavePublicKey":"sa1_cjxXdrIZgZaxY_L_UkZVf7eL1Q9WTTFrvc9FuRES1ZXwZxXO1QTspji_KboxN54Z8-qFAFXqlun-dgYgGEoLOv57RgWchinlmMHb0QVp2WREe71cSOdioaYfmBhW7eQS8YbvrnFB8cUumdZMOI8UJ6qsBrWOFSDuhPXTdUd2hNZ7mQ9PQR2MMPglZAJnwl36mAb-kaa0cK5s6raeR8_MT0aSSPHQrwyIuM4kOBMvLGEH9XE4LVuNB581Y3h0gXEE_Os7rlhl8BpowkjZM-ZIKK-hUuco9VkjfooQC5CgBHAwivm1--PlIpNa7vtk48cEOkvNoEd0ixN80wfQ2YNgpNFIOV6InnRYyrdPuHBRqE9pCQE48e8VWSxlpgjCiT-bveww42RhRsw_cjVBFHHwMljNQ4bNzjPZLvAaADvSF_ViV4EBpCiqrgj71eyTb0xpUMDSNP7Ae3HcUYPEVC9-n3GjJCCz2akc2zBRxS3zVl13bfApg9JCKzS349Dyaeq9bW9f46CN2U87zLDjUUTJFu3904UumkePlUQjAyMO5YIooChmdoujNla3e_EN6j-SwwjnM3LjDJwNCESETZUrkgZ0Arj6qbENCuEbQLDYqwT7pCJMhXIepolfbloLNnTPTbdCpzyh9pmXwAHokF3hxwSdAzBH11vDSp6ZYvc","ecdsaPublicKey":"0x046199ad0bf504566f88ddae9910277a3cd4989284bd0f2e3bd5bb8907faf86c6306773953fed32bc604aaf0cf36df56acaee285c83f242bc149ef5006b5290692"},"5ktkAKcy_tou22r4eijcn_Xue3j6Rn9e8JckXRtHe8o":{"name":"redstone-custom-urls-1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"RedStone custom urls demo - node 1","dataServiceId":"redstone-custom-urls-demo","evmAddress":"0x11fFFc9970c41B9bFB9Aa35Be838d39bce918CfF","ipAddress":"0.0.0.0","url":"https://redstone.finance/","arweavePublicKey":"wgOVFdnHwJVzj7sfoD0F6ndB3Z5HW14LGre-ovDmvAiZtSGcb0y34qbpDZwDMXDV85kxPvTS8xB9gwuJxkkC8e__1wSDZeB63NyMgTYyx4lx4147XSb4dSnMSakgCbFjwD-0SBLFDYBZUusieGGlinx3l-OMAcQOAPiyPgJiVt6ZCBavY7UR4sA8dA4Ghp_m1zrTC7SAYTZlVat_ZLzs9lgTRmJoAlKxjWtGRmtOQz2_ndnxY_5qP59-GdWu_ZOrYBDhv50eeBNbYibiAMZpJ3UiqAt_p77EUJRdLTIHQc6WI5cD5RNzphD3XMRaC9S1iHIUo4fEh5HFbt1V7OLbTMtAtjyXF_gAtCbPIcCMz1bH1Qcw827QO_jOMFgv42m5VzC4YqPf-M0-6KoZ3AM2b9Ifkaeg_rqBCm14jHjPiwGTzdojjNBzG45Jhw8lmybWtp3JdHa37bbKzmazQnD4zTp_hh1aQRvbXYfbaFsVINPdW66uqICKfbRr_krjEyx_Q9FX4nPe4Gg0Or1gn5bgEFgykxCbN9G6ol59pdT_YMyuWPvrR7tH8SqGISLJWI61dSqg4Ook9EdLUmFP1JMOJCWF3o0EqQw61dFcJnawGEkt7ilT3UVmq75uX1cjFQ3nTro6h7ck96PFXQfXMVWV10KVyWpQh9KybZqmY4i6Vxc","ecdsaPublicKey":"0x04c8487327833fd187c99aa2686097f25f97e0e7856e152c8be66a1e13f8fdaac482da9375191ebef1ee5787ee36d8618dc78bdb8504608d1d5cf79aa7e01a33ee"},"0Eu1WDQA61S98CB7XEQ_9SHpy9Ux06rd79u8jFuesjQ":{"name":"redstone-custom-urls-2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Redstone custom URLs demo - node 2","dataServiceId":"redstone-custom-urls-demo","evmAddress":"0xdBcC2C6c892C8d3e3Fe4D325fEc810B7376A5Ed6","ipAddress":"0.0.0.0","url":"https://redstone.finance/","arweavePublicKey":"9sOhBBp6cfHzKoFWzbErLf1s_7VtNVW3MNcKb_9gAwOdBJKplP1pv0VKyQOQw-e2e1Y8kZSN1rTRvs-4lrINJh8a0MrruHRD1lZBhuleykiz8KeDEJux7WQZ6G-2i8MC3RcGjKtUKeGJgwzZFB8GkT8OkXAhqWc3kRdbQzvLR7R1qp4usn5LSoKBO2pChQs-K_ruqh7wwLCr996XXbYIPkGpQaaVf00IXX2ItAvYd4emKKVnKnYOc18TN6T19ur6-KCz-23w1-QuLzK4MbvBeHJ-Y4FkahPRLeAeZmhjdNjMAXRcWkQMETmex0Tvg5qDELo-8BXYbuZgPQO3ea4TjPixHaAdaYach6fwAfG4pDboxkzoNrQdHjuPUnEhlOGRRGPNcqZPxVZQ2nVVnnoLcYq1pcCL6cPM1-licGeG1P2EV8Uo9P85UALn71wSdvdE2C3bWnmI-BCMiN4xkdX7_kcv80D7ZSWQni4d6_7l7JgXTvXs6GISvjpXqUcoUBohabzMixUFG8I3rqsVxuWJXQtmLko3kuP-CoeRyQOZk4dAovhlJ2MM5L6Yi2FjM5we2ApGSaC8v9dhyVWIrN87s8lQdgeOTycFZL9UoAi2uK57pkVlkgkYkD139ERUlRBtZ0XVenQO6lAXhYjxK7AaW08ZfkfS4PrLWzjNQ8BBIZE","ecdsaPublicKey":"0x04feeab427d82702f95c9d1727e47c823c5841ea8b0864607ecb637ff4377604b8213dfd06628d01e624c30dfb20cfa0296be7c1481ce994adb6424d1a391493cf"},"OxQ-vLXcwTZdcdlCziC95duFylo8Aj9xBJ4XsC3xlGk":{"name":"redstone-arbitrum-dev-node-1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Data feeds from arbitrum redstone nodes - dev 1","dataServiceId":"redstone-arbitrum-demo","evmAddress":"0x16883583647260AB2e2BA63c4c38D9807Fd7296e","ipAddress":"0.0.0.0","url":"https://redstone.finance/","ecdsaPublicKey":"0x041aea25f013dee918d88063daca2d0113fa41a95b66440d8d8edf09a3d397045f5b9d391c1e50e6998d3b2f95918899e382f444714e64d9fd689c92d4a2535ea1"},"LtVolyIqpjhCr8fw_ue_-Y9xaH5IURpKZclyJbsu4SE":{"name":"redstone-arbitrum-dev-node-2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Data feeds from arbitrum redstone nodes - dev 2","dataServiceId":"redstone-arbitrum-demo","evmAddress":"0x1053d519Cc8C8cd7e53FecbFb13B6F0ffbD4c8C5","ipAddress":"0.0.0.0","url":"https://redstone.finance/","ecdsaPublicKey":"0x04d0f2bb463dfe89778fc6fe68ed6945bbf13f1391369942d78607cc4eac906aa63d082caf6c81c3c191daf4bbb7cfabbf5fca1ca762e02529cf700a15ac0cd828"},"tTTthGBknPG4MWH5y-zDKO2dEF3Fxo0gPbzV6PLNlNQ":{"name":"redstone-avalanche-prod-node-1","description":"Most popular tokens from the Avalanche ecosystem - prod node 1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-avalanche-prod","evmAddress":"0x1eA62d73EdF8AC05DfceA1A34b9796E937a29EfF","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04ea48ca25db5d352ec62c4f92e8c115068e92a327f3536479a0185ec6e0f8d26db4409bffdc8c6ea898743f908861a47fdb4a52e44d129a56418a1c08008fd425","arweavePublicKey":"26hxzuODmUGbc3c52ZFz1zLeKdasZdcd2EmcLBl1PNGD75S9F5J4a0WDLeklG0YZEIU25besIa5bvinF8vCp_ebdJZUnhvheQBv_0-aoR2DBBoxe5Og942NMLEDzQl9mSP3y4_qGKnf3XQc4tzP5C6HRDI3b8L9Is4sAckEVaR5NXVAoOsg-YST-2g-Uoqkw1-ZavjL30ABSDejQLNRyZ36uzxRe5PzXtG9Oy8-t_Tz5SafMnzb68dbyBTCD2172fjxP8pXsIS-a6fNvMdjIR9BKcGHXh2_xvC0-TeR_48HOw0UHLIRqW6C6XkgWLz_DDJdVuv91f6RA_-BJPmST89tlI2S-Nma4XOZrBAB7A9X6OMoiHZfxKH1b5qs3UuTWBJgx5A9GEJ-urxYAfC41-WvfadlRFOPkgtS-4rwnq1u2pWj2Q2jxyY7O-Pj4pZSNjJe4yNhHR8mbgm58zeI_mZU_Y7RcH8W9IU5RClfuaBSSJ48GfkTU2cXYIr263heAblt8pcRfNbtEw58iWtJ7wFeEgkcsyi7A-1B1o3a61xqbH3wZ42qAMe133AGXrdYHoJpVXuxk8Ei0QUYFdrlkwCCzkALG-GYavaG_0HAg74KIHsNEvmbeLpl-SDqQFk3t4_DAsTEKNbjhGX58SRFgQ15oyp_lEIC6JydNHwDNjq8"},"azkge6PQ_40JzMdcgkpj21jxhl0JaQg1o6yPSCekJ4Q":{"name":"redstone-avalanche-prod-node-2","description":"Most popular tokens from the Avalanche ecosystem - prod node 2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-avalanche-prod","evmAddress":"0x2c59617248994D12816EE1Fa77CE0a64eEB456BF","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04f5f035588502146774d0ccfd62ee5bf1d7f1dbb96aae33a79765c636b8ec75a36f5121931b5cc37215a7d4280c5700ca92daaaf93c32b06ca9f98b1f4ece624e","arweavePublicKey":"uw79mR1O15fps5uWLsvMTiE65cAzRJs1T3uvdmEksGINCsZ1yxJJhu9PYY_OniQEl-Z3JZ1cF42Vpwxaz2JF_lY1kPXO72prefyF4ew-Q2c3WgHg75nODMZ6Xq1xlIYKfEetDvEX-MhIvm454TnHOgbvmZNyi54XT5SNnmjvtQoEfKeJ1RRRXcOubt0NgDDpWbEmvQTSFlUT_m14-H0gM7yHT5C2UjS_wCM41THFs-Aw6Uce8ROKy1rAznAI2eS3O7t3evI4f3qHQxQXuTOOUqGUn6A2Oeys0CJqnb5bJrhk3j30VxBpotDwAyOLfaLB4NEjAkuBxHWIzI-34RmIgTOQEmZ3e4cOu7ymYSx2R92z-59bOleIpfzzmagTYw7nMxbvEyb75U1B3Mz3iK-YjY7EHOb953l_QcQwqhlSqFNTXjbZgchDD1GrMULolGh1DFeUflTHg-s6XGi273Ri4hhTyLDFQTUw18J39ON6D5IAg9z6PoyTOW1MjvdLoeY3zVXH7NGq-bmwFup_9v3gd-h7ZCnnu0qWQzxDepBySA7fIo5FFAwL7KoUOC1wnc62rocwlFJ3J9vp1mvFUpkSJxCOtYR7xLEZhcMBxnrewcbx5iImdPx8N3M_94D6osrKxxmH8GwE5RScsW2ws2jfruNhIxgQkY00d_q5HZ4XLws"},"WMUjPDhwoYvDqw5BNAaCt6-iLs8fhzwC0L_rT4lTxFg":{"name":"redstone-avalanche-prod-node-3","description":"Most popular tokens from the Avalanche ecosystem - prod node 3","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-avalanche-prod","evmAddress":"0x12470f7aBA85c8b81D63137DD5925D6EE114952b","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04626f2ad2cfb0b41a24276d78de8959bcf45fc5e80804416e660aab2089d15e98206526e639ee19d17c8f9ae0ce3a6ff1a8ea4ab773d0fb4214e08aad7ba978c8","arweavePublicKey":"5f6on6vYsq3Qgp-c-yuV0SRzfjKHaRTcfKNCsXnB1dkfKHCncr5gFTIT7244Nco413xRMtKxmU7-05Z4cRhVgq-zlzdRFj-7VedtH0WlJpxILSevGILdAcklt6K6q2DDZWmvNlbCIXfXYum_ajNo41toc1FXq-f5AXc3FJEU1sWLxwAfDjrPvEdj67QlFAIvviM_uwATmjWyVTk48CLec-53_nsf-cGA3euLkhozLswTSEs_Mn9T7RSRVZ3VlpwGFhvzwidKclRsoSTUJGV_c3AsRfu_zRsURxMz_p6UDF1MaSo7RP-NgupW9EQ2itGVTMcNHKalT3dKeMUHiCjnxldAkZCjOzfL9t053R_Zi6pXJ_fCD2I9ysZgp1yL3yJyfbGg6uxgNIAeSo8epMZQzXJpFxKB-VEVWEFic4loMX-wCYpulMp--azq7NBAt5UPcFtqs688Ox9CmeCNrMuo82w-1qZCUtwU_orLo8K7QSwPOmitd1pUVuCZMyFL05zRmJB3cxu-PCncpiqVN0g9v3MOpGa5WVCNHNKAXtuM_y-6s3XmraBsV21o0Dpc_sxX2BU-4WHmkToH9jfHGVozMiNCM26F9cEdFy4ptz8eOIuYgqhfksgfw0zB3jJwBwPJuDqhH6n-5SqysyzOkzWAzm3reVAEXuj1MAUx3C5qScc"},"POU2msUaCzhDq32_hSsKrCH37hHlUvbqfK0-Wjuz3Is":{"name":"redstone-avalanche-prod-node-4","description":"Most popular tokens from the Avalanche ecosystem - prod node 4","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-avalanche-prod","evmAddress":"0x109B4a318A4F5ddcbCA6349B45f881B4137deaFB","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x047cea60b650ac5e72ca9991cd3c365c17db58cc6c0f385af0b05056a2d6068480093b603efcb47410e8092d60c5b85d27a3e43dc6ddc4077994e6eabd9a8ab9cb","arweavePublicKey":"2IQy3vmXQDDGJRXK7Pock02VBxtoVR7HNXMAv7QugQkZJhEYqIq4n4TANbSo0JsMVDg0NsqtPjaRSbStr-guSlvi9behNVOj6HEzcri6YMXq80MIOw8FrCWTp9M3co1mcZS8nGE82MCK9PYa8JAlVQTnZ8ahovGT39Qc3K0q5hgyR0a6auliDMAALtaPYfH60Kt2IwDlYv67UkTjarKdbQG7LZDMwdG_0PIFpfbgzW41cxcLymPmnHO1UY14UD-HuyeMclx215MhtH9RcfCIaTZZAxpGcTU06nCxyqNiff7EufaahBg5e1D4tl_3nBzUOs4OOvfk6nDts1t4_lDO_KtdxeLSp0ADLBTMZ68TKqx53Z5Rlo8PZzO85CEAQVsKb3JX-dMl0BvoRzq7lvkxo0916YQUJQgbl7ryO6m5kuekk3j6xu3ccLDdfeHmLbnfacHBoRnPbJRXM1Yx11ovsywdixyAqLCf_Gr_gGP_Sb4TunN_-_M2JVvXKsK70TtO0AUWp6nXUiN_I9dCNS3f2Asu4yWxw61dXpAiBnJEHBEKY4ctflsg1JhV1abLOuAW7xd4v7mt_XBkEmz9zNodRQux23aj_m_79wucbxkq04s3WsL6NmkoRPJ02vDdUKYUHZ7x4JkkLFmdC5kI0P9NzOMkl1s5dKAF-TD_PFVT6R8"},"9QvwJVg8PapGD6VaGPffcYajExbnJWG3HH5hG76-5xM":{"name":"redstone-avalanche-prod-node-5","description":"Most popular tokens from the Avalanche ecosystem - prod node 5","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-avalanche-prod","evmAddress":"0x83cbA8c619fb629b81A65C2e67fE15cf3E3C9747","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04a66e3eb25f4110aa9f9cae8864b39b249568c094123737541e897d924253c84279bfd0f500e85f75a0943c41ca03c95fe0c3c7339e0499b5d6993a3f580aef85","arweavePublicKey":"7RqQRi3ft2uHow196B23oBCy8og5BEe_I-VEJ3vb21hTHy_ayICIrc3FOcrjJ32i9ExWlLy9EuqsqWCczk2G34OS-N6mn9U7TlxE9BiqNydGCC7nEZ_fYj8DHPCwr6IEEWe-47uY5wHQZPstzIoAN4_zEKQT5douEctfZCaT_SN5-I9soj5Qe7iirpijQmSMfRVLvFQtVNqM_GxJWE48uYzZ9owUrYwUUvxgGFB9EfQi1dVjxThpuImughyB7KWc_Qv226TSMCLPLD3nbtAmWBxIM5SCF2nWSScB_-rGNiugXil3QZKa2CJ6zgXgdigGlufdJkOfN7DT9DocfutUtjN4Z3Z_FeliiWs-6klhYUP5RdEAZrF7Kf7E2fvpijEfsDbeFK2ZjpNrNND1F6gLIzfC7kT-bBpRqpkRQuP2Bu7O3fgnsYG5EF94KwCBeCwB3MYVW5v0S26SGRtvN_qU6knkIxiOBMsTDJaFeEKfRtW7tnLdMCyM5xIJ3Lzk566TeiOq4ivmtMRs6PT_8cN6B1crqYstuRhoYPTggIiO0WJdIKfbOMHRXbfSwgyXsvADfoEu7SywQtWnKAG7K8tOwIdEl4GJb-6yZD__Z_jpO-oLFLSszDxz_Fbba_gU7U93MwEbtMfq9Sekfqq9Syl98D4KR8ZtJdgkQTatUCc4Oj0"},"HebMpM4xI07ev3jbEWamFNmRxu2ojflQfh0b2lpjFoM":{"name":"redstone-primary-demo-node-1","description":"Data feeds from primary redstone nodes - demo node 1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-demo","evmAddress":"0xdE13FdEE7a9B483129a81794d02FCB4021069f0C","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x041c320fdaca2d381101d85f2e0fcf9c6d6ebb88f2a3b71a20ecf229c1cd0e81b541d6960b58666fce5abba84a460590c72f4e871d87b451f0b7823f98d0c41970","arweavePublicKey":"sfTEXB9ljPagrv7XodJlTs0fM1pQdsCZ5iHC6mWsFpYgNUIPX6vkA4yoEjGh3naoLz5qKYtML3RIyI6z-syI2JV7TFUyEGunSDyzWg7ZZDxeG16RwpUhsPSJ7z7eSA91YAVAYJOqzgcOI_RsdgAHrtH64apLp_8uJcndJ_oXpEuoKRO2SjE2wSnwkHodHK6F-koov8rNY6edBLfmfjtKzzS-8X8g0oKSVzNdiov_WZ0UlUelsVhd-KoC6S65QT1yg7TbVRQP0ZBhfMvtpoZh8y8ftj9VaTsIaZcu77LR1tc6zCLThZAbclGYPM1EWxJ8vUDp5XYSxF6AvTFAj2NpvHDW94Mln3ZYTv2a4UobOruO9rA4npduHlo-5klgFxJGVjGsK-w18pk13KozmW5P_DZPwK_5rcKwvUakUYY2OCF_lismG7UiIPRGtQkoWffaZDfuMI2ONidtGskqFBjgySFsdMt07Wt10h5WbLI5xmUoBpdrxQarfzECCyQ4QT--GOmtaS8G7PUbYMtpgGk4nxZnqqzNidRez_0bQLQbsIMMej9HTNvkiwW9w5e374Ek8JjiCw77yUcE2e1vUAr-IqrHD5LFSmB-H5JM_GoIGhTEjYU_-v3RkeiklwmuWBPzLdyL2mMZPANacW6cOWt4g6DyXTjRKSLY0UiPuGsJT1c"},"-qrcZLkqrgS9cNhLvy0c7gzpkGlAgwbZ6C3_hk2vvJQ":{"name":"redstone-primary-demo-node-2","description":"Data feeds from primary redstone nodes - demo node 2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-demo","evmAddress":"0xad05Ce43E0bCD11345f08a28995951DEc30D5226","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04440a1d2f497db99d7282bf6ccaf133995ed05f992c177c1eaf7b861a9e64261d1da123bcefa6bed232755197fc5082d42696e72aaf42b45771eba336d693b9b3","arweavePublicKey":"1OgIYqYOFlYr-Yo_cFdnWisxRv8B-2x2zroc0Kcn6_f8yiD7yZBVFQOBOh-kVfcmVrCuBYPywvJevmMgIkg2t4xOsoG0y_liTYAYKjhT2tiV8xta1ykq0xvLiOVOQY4g7GCzcCV-ZPE9xc4bI9ozYnpS4NRjJM8_mOnS9I1lrefx7pjHsrTyrB3YGmmW2WJm9o1MS225PFzDmPSEghw3jlVsf-KtDXqxCCpRZGTI1kKZJ-Snm9k_19tK9MHGfVGsmT8pZJjsJmLJXHrLl1KVgDXsjxxcU2f6ZycSj5imP024Dc5w65aV1JXEey9a0wLz4y1DpxPbrUN617zL1-6xA3PyQBbbI2tpM808UILlYAYWZPBeS9-87j9Abn7wDtBuqGGribdYH-KT61lF14xozCWj8SwKk9ZiMsuk8XhTlmzWa2_xwMpDFX_GVwyueZWR4lx1PK3AMWOVfITj8xU9iPHA2msL9AZ9Hj1R12k0DXGn7pjHwUgSNXCe46nIBbjEoUVtihDGAddwXAyhBVSFriDsfqWDftYEigGbNccQh8JVfRJraP20saJLlwnFL5rYhd1nSFzEwi3yIFA2X-PjudxWHa2mTGwZYCtTMkOa2E5ucQUp8eA-N-fQJF1YNNeznv5IA-yN4e35zuVUC7dNq364bUogDAqTMojRFMzhpas"},"R4ih95AvybIzz3uKuEmpBee17J73CGkSk4bvzU_IZ_I":{"name":"redstone-primary-prod-node-1","description":"Data feeds from primary redstone nodes - prod node 1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-prod","evmAddress":"0x8BB8F32Df04c8b654987DAaeD53D6B6091e3B774","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x049a0e6cada7938a0fc616578aff2b11337d90ec4e99e9fee95e57e9d8371562b31698225fb73c666ba586842b913e67ad289f374f7a46fc873342f805a8683d4e","arweavePublicKey":"nLzSke0nHxv_kp-NVMrjlXQtVZpNlFyUybEIVZx17IAwIBRrqNJBJ5pR0_nbgtJTwXg32YiLs_1ETBaazj1HL22au_kSxa5zkHsomEi7wmioAYGN2LGcaeUWlrPq8zwDk5IniSHkGdJ7wuCLig2OyVoYpINGvRchy9NOpWylAyJjHdcOkEDTAFHKeKWAs0SeAo-VSr_V53yyRSQ-ecOpcSAMWtx-jOkxgNoMPHAX-79arV206Q-sFjGNobceNl-NhCKOEOy4BjHCQm0XVUApXQx_hVrej_j-DE3QbCGCcgskrvpYFrB7ZGfCVYToH3GDe-orbCH_Qa9Q88uIR9-hIRWnTcES3RDdb-72bvVdJVyvMqKWXdtjB-3aYS6Klyx6H7l2hYdesQzEv4IqOFctoyUqq3ECZkW5ZTZzo-vg2QatwquY12kkOB7PAkZRYjc6HEoWnZy2qv4M4RnpMiYpgjww4kcryXBBZqy4X-xAkJAjWt-XDTpIWmLBtgu9plZiOhmqgARyMtuF0NspFZCu7g5PfeQVo5lzv16CPXimXpPLhxiVoOxjSKHTeuv0xIPA9cNO_6K0XTSdUYlzkDdcnQIg5SKI3b9kE3JSkiVjjk0EfhZdrBaWolS__NNEBzqjMU5TR4bk9BQ5CTOaqXDIbCEK2_GMaJ6pzjGPfRZaMu0"},"WM9CHZ6CKf95z47krdOFFKX6kuOusBlyIVSJmcjdrEQ":{"name":"redstone-primary-prod-node-2","description":"Data feeds from primary redstone nodes - prod node 2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-prod","evmAddress":"0xdEB22f54738d54976C4c0fe5ce6d408E40d88499","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04683f7100d67fbaccae68db4d146f7bc3090c5cbcb1351e333efd58d42f609ceeada12b0af28a6e789d6edfe25fe784dd1e86798240d4cee9f60e56848cb55965","arweavePublicKey":"yE4SZn6OcwBG0Zb4Awm9bS6rqJMcy3ldVosxCiI7bwCYsRjA_fArgtuDG9b-B6xxEC1pY0TBAJSN3HKo8XIDGJNh_xHoA__Yi_Q4OGmtFqGWbQmP78piaJ3vn9nR-vwFGPnZPLzKinzKxHKNGH16gkhblszX59oUlUQP1o2slFmD6UsJX-K3LqWSN5u_1snW4eNpyPY0UbtuNvVvSNJeaT4D7zPYhZhpt5WrYZBzmTq8HoK290wb1L-Okik072aw9XMrFNBiyyQd0thAAobferTm8Ch-lcfigwkaHDEtwD2GoJIJZ69oTX810OFz-m4JomEBck4B1dSou3aPJhjK_bnsgLztiG6N7DHps7XOyD6vVo2rJpYWMPmxLtWeXIgmNSDjypUuDH4hJOT_kp3FO5YvHBhL__RY__wNBvJ5XizilD6Rrom3PQMKmu4QWY84JDE7L1QHrwsEo7UKYpT3aNF-rrFiYYTn77fLN6iKkzouLf21etNoTqRAo-ftzTiiUtJ9ubBnYd4ne7AKRzZTS-dEOImA8w6MGjN0rkqaI78ihgIO9Zu_BClOZdWqRg3j-nwyzGcOcQeKjOU3HAWiotuioLBy603utiC7lRl8g-0VprAZfWOpJhfTX1EHyoI3AAY92joj4U_Cig8-9tCRh06BN3HaNobdQgkLeEk5KpU"},"9syjTFZp0__CsqnMjKEo6sjl6_yRWYm7TQjcD0hFEN8":{"name":"redstone-primary-prod-node-3","description":"Data feeds from primary redstone nodes - prod node 3","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-prod","evmAddress":"0x51Ce04Be4b3E32572C4Ec9135221d0691Ba7d202","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04490f08821dea02d23683f170459aa6317dd65b544aac1df514f2e657f87ac00b81757edce3e78785e00dcd92e2dc8ddd9a680dc929a0c91062d87ae000a217ce","arweavePublicKey":"uFmwr5_2RAokGbqABO6edwcbsVhctDmKWG-velfxBvqjGU9YUc3QIentdWPBEaA4xcXlQC1fz8-woXEqqUjTjYyDpZ_1FEaftIVgQFyxzT2OW--8Mnox7uwqvmtAZLejxRibj4YYyqxO81tF4m5MVpgewoBBep0p_nCsBtN50iV4VtG6oPOOiFa9p1Hk-h2ja8K57qfn3Pxh6g2jmk2FVCo9JAgHCoSat8IT_QQ9BRw4pOTyZbTzM-7K28FjKHJqaQ8fRK0bZkMmzt8LhXUZVQCqHWeaLaMoNFikDTWZ_ia-SEr6_T_QlybPoj07TIwkMpVNDMAFcmltHBoLtNDfXG3fyDAQe9fZPp4H4ER5VLi_MoEB0UM2feLZNIpiwSCWEtOUvamBaCbtRBObdQZPphbP3Iof2VZvavnwHRE5FHnLFuXpnwMPmJADDwIdetUxNKW42QGl5nG43IC18ufYBH-hV6rEdlxd5hHPqw7wknGQ9fW_686Z_qE2U7Lc37OO0a1tT6877IuOYpO8GGm5YOS0lc0A7jP5RBO5EWsS_8xZyKKo2aUP5f39-WZid6lRAtwseSvr9oJbRLS5jfCGb9WTJ0VzQEgCpcp1eVaMSDBvXb-4p6lOr1Z7OD0loSHiAsNZWUdAqmRLAZROZsXI6r_z5J_vrW82ZkFTRIeNdeE"},"4dRTLZeJPaDMhGE2jUndt-3KIOQxO6Y_BCV-3KIiPhI":{"name":"redstone-primary-prod-node-4","description":"Data feeds from primary redstone nodes - prod node 4","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-prod","evmAddress":"0xDD682daEC5A90dD295d14DA4b0bec9281017b5bE","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04a221496ff2436da121796c11f888cc4e2155da7e36bd1148c9466fb54627f15e42d4cfed06b1570b7ebe0c589acf91fd314cfd95303c9894c0be43432aba619f","arweavePublicKey":"3gACwmU3yQTUU4eHYWvWYzXh96royDi3Uce7shiBk0TeK2aaKGqR0pswjbWLUF1A22JmfuD-ItrkKKAfX5Mhj7GgFrDcPA0D2soA0hRQGh5qkLi4iSxXb8BdD4suG-dN2y2_Zn1zMmcoWHHxgxmr-mtD5t4H1CrIxFF4dLQWJ44ydFwTmIxvVaZzSYA8sC5z2Q_hIzr90Z1DdEJUcJomXbKPeymeuVeKxCfPab93czr5-wm11I_sNx9dTTzRW90_jiZ99aSbSVY_R6jWQ2vAfbCqoHIqsHEk7Yc4WNjXlh7aZMBi5hPW3zrnN-ZnDDLXgBu4KrBqAFH-8jL4sfwe51ifKkosRu0DLx0kItpp3mgkKVUcsR513kQE49bxmFhhy3dbyUoJktetrWqg6iMPHMMB4ybXHsoqOHXou1vPtLTCxtNvTZJvUes3v47fs-04ThebpyAPPEDrVqt4mNCYzapvDE-RgWrnQrKLAIbXJspcggro5u_rdNl4hSDGgmFJhXTu2AIVoAjNTk9ARXtgo4K8RWcQKjZ8qotq30NNwqNE9GVk2EEJDnj-Jj_1_Dtkd0jozE0VyjaA9eT5NyZ2s1tfVS2pbNCC18sezte0PGeAwD7EqoJoYxgbmX6MPQhfyanSc3KSYi9fi_YYYmHT0n_uCUy9QR2Zvz5895QETB0"},"wZv_gFZgozLm2xjUaMZPzvgr6E4VcUlRZMXZOILfBXw":{"name":"redstone-primary-prod-node-5","description":"Data feeds from primary redstone nodes - prod node 5","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-prod","evmAddress":"0x9c5AE89C4Af6aA32cE58588DBaF90d18a855B6de","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04f23aa199aeda6e55628e0ec88194c47713ba260898aae4483fb2f166c7e29b1664f817922059736358de71bdf374b3354db58d15f928a6fac9d1f61e284019b7","arweavePublicKey":"2p14sG942MfNwRQnPPF78vdxXovnz0hSTUYiSmCvPlQHojPQyDdfX2fbML09kbkeq8TNQel7BzShDVDpfhM21lXDQhvW8kQTSk6I2qilZIbYRi4i0omgHLw6QnUOGPBdxUdbRSq63gH5A0aR_ATPgzKNwSZpViG3CODgOVRUWtzWlaHKGx3D5oloKnS9nnJJlZSh2sbDfq7MIOlZEHDpunERLByLlsxi33oj1YsrcV2rP_tUUDbuDNLWhwHorAjZqDKmPP0FEy38oABrB-NbDNihPs06V2wMNb4U6tlLiEcsfNTagWpQ8re6K3WpK5XKBOcaOhVqcmo2axP1go35pjV6RuISCQWGGqvnyeAsKdGjDANtSk5RYqjqy6cQTJfEKrHZbv2MaiLr5EUsnzP_9u4ZCo8vcVXj4BLLDIYNvm4b_Ik2j8ZoA432u2hAMtQYZNqfencj9kiKzBRoeDQF4nsJOQ5YUHkyS_a1Vnq0KPslPbACApJZntCz3LR2Te_ZxJePM_v9O6jtX2bTsRgkjGF5dWD4OFda89mFSKn9ZBzgysMTWiJsLYnnqPVW8zIP2PjG7VgfkpEIDzWFbCJiX2aevGT94P5pTuI9AF1cyKMX0kxeDibbqg6m9LixPqY0Kdm6pOwGa1RWP2tprPoQuS9uepP1vyzJEzk6jAyaQqU"},"ckah_Yc4ZhzQbx27Lgo1Ad1yePneQdkusER_c49KVK0":{"name":"redstone-arbitrum-prod-node-1","description":"Data feeds from arbitrum redstone nodes - prod 1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-arbitrum-prod","evmAddress":"0x345Efd26098e173F811e3B9Af1B0e0a11872B38b","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x0437026448b1a69e4be9bcee0789199c50e93446c75eb697efbeb732fa3b51d130f92d6597de811106511ba39f712f8cf025b82e0003a611b9f78804e66caf46d8"},"3HHevuTyFGYJJ-nBPonvDaB5oGIZbCbZtF0CAeFB13s":{"name":"redstone-arbitrum-prod-node-2","description":"Data feeds from arbitrum redstone nodes - prod 2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-arbitrum-prod","evmAddress":"0xbD0c5ccd85D5831B10E3e49527B8Cd67e2EFAf39","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x046ecbc2bcca15fb4a44b88e85e1433b22ad09b7960370c9dba379e09f37ebea0cbc3fb9a60f39df2c4b7cd8b885717ca1dafeac35e9edc5b550d0b61c4a7e581f"},"AkT1al4MbVqV8w9LXIvdsE-2xm_moP1ARaImUlqgDZA":{"name":"redstone-arbitrum-prod-node-3","description":"Data feeds from arbitrum redstone nodes - prod 3","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-arbitrum-prod","evmAddress":"0x2F3E8EC88C01593d10ca9461c807660fF2D8DB28","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x047f0ac528b5b5f306b6488965bcd86cce263487320caaab7703171c8cf461eb692cd35837ff91d243d2972fc4c4598d08d8e1f5795ecbb1cb974087970a5783d8"},"k9ke_oPBAy4bt-Vu0_kwRcSx4HwcQl3Jd8h7dmomfrc":{"name":"redstone-arbitrum-prod-node-4","description":"Data feeds from arbitrum redstone nodes - prod 4","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-arbitrum-prod","evmAddress":"0xb7f154bB5491565D215F4EB1c3fe3e84960627aF","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04e051f36116b6bc953f2a94825a4931f6fe6e3a3f218e1dab2712a2a31fff450d1e8f82dcb3cba9dce6dd382d6b0e259d2a896f8a10947a234c08e6f424d272c9"},"7zqOor2CATpcOq_DduEAsJ_8us4FJ0BTZbMjLAH4MsU":{"name":"redstone-arbitrum-prod-node-5","description":"Data feeds from arbitrum redstone nodes - prod 5","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-arbitrum-prod","evmAddress":"0xE6b0De8F4B31F137d3c59b5a0A71e66e7D504Ef9","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04b41ed2eaf2b8b15232ab7d25458d1b2cc1ef02200ab50f912307cf832f619aadf89800ac17b1c3e40c4bebc7b4305bbec558ca5e60acb034dbb6c09273e29fbe"}},"evolve":null,"canEvolve":true,"dataServices":{"redstone-main-demo":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Main Demo","admin":"I-5rWUehEv-MjdK9gFw09RxfSLQX9DIHxG614Wf8qo0","description":"Main RedStone Provider with all available tokens.","manifestTxId":"kXYM3AezlROPoEDCt_802-k9ZxeceAWzHtrERmR2zEg"},"redstone-rapid-demo":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Rapid Demo","admin":"zYqPZuALSPa_f5Agvf8g2JHv94cqMn9aBtnH7GFHbuA","description":"Most popular tokens with frequent updates","manifestTxId":"5iQ5tPebRcdB4OjLZvaCMftREpP_P-V-F0J0WAgyLFI"},"redstone-stocks-demo":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Stocks Demo","admin":"Yba8IVc_01bFxutKNJAZ7CmTD5AVi2GcWXf1NajPAsc","description":"Stocks, ETFs, Livestocks, Metals, Energies...","manifestTxId":"MmWSoOPdKoyRlJ7Qhrvp3odBu0881Ou379e19SxDxKg"},"redstone-avalanche-demo":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Avalanche Demo","admin":"f1Ipos2fVPbxPVO65GBygkMyW0tkAhp2hdprRPPBBN8","description":"Most popular tokens from the Avalanche ecosystem - demo","manifestTxId":"erTjNqoLYB9Jw9zZXJPYxmijE5ElEhDM_52quvK83ws"},"redstone-avalanche-prod":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Avalanche Prod","admin":"TEHhCDWy-vGmPSZsYJyM0aP_MM4xESgyIZdf5mVODzg","description":"Most popular tokens from the Avalanche ecosystem - prod","manifestTxId":"y7ppr6m9MuP65Fiivd9CX84qcPLoYBMifUrFK3jXw2k"},"redstone-primary-demo":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Primary Demo","admin":"TEHhCDWy-vGmPSZsYJyM0aP_MM4xESgyIZdf5mVODzg","description":"Data feeds from primary RedStone nodes - demo","manifestTxId":""},"redstone-primary-prod":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Primary Prod","admin":"TEHhCDWy-vGmPSZsYJyM0aP_MM4xESgyIZdf5mVODzg","description":"Data feeds from primary RedStone nodes - prod","manifestTxId":""},"redstone-custom-urls-demo":{"name":"Redstone custom URLs demo","manifestTxId":"vcxshh2A0m4SF16Y4_Xv0B-NHfdeEyn-9XbkHvmxckc","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Redstone custom URLs demo","admin":"BitVOfTwSSod-tUSla4nM77sUuHC4XFcT0Zlg-RZ-tI"},"redstone-twaps-demo":{"name":"RedStone TWAPs demo","manifestTxId":"ETNFHbaIXCIXSb2mvkY6QWbfcITsFsSDd4h48PhuHYs","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Time-weighted average prices for most popular tokens","admin":"aw9F_2R2ogYPnM66TDsW1qtiiRflRcgZQG6OLySOSZE"},"redstone-arbitrum-demo":{"name":"Redstone arbitrum demo","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Data feeds from dev arbitrum redstone nodes"},"redstone-arbitrum-prod":{"name":"Redstone arbitrum prod","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Data feeds from arbitrum prod redstone nodes"}},"contractAdmins":["I-5rWUehEv-MjdK9gFw09RxfSLQX9DIHxG614Wf8qo0","zYqPZuALSPa_f5Agvf8g2JHv94cqMn9aBtnH7GFHbuA","Yba8IVc_01bFxutKNJAZ7CmTD5AVi2GcWXf1NajPAsc","33F0QHcb22W7LwWR1iRC8Az1ntZG09XQ03YWuw2ABqA","BitVOfTwSSod-tUSla4nM77sUuHC4XFcT0Zlg-RZ-tI"]}');

});

parcelRequire.register("azEtj", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataPackage = void 0;

var $hbWVX = parcelRequire("hbWVX");

var $fTHW5 = parcelRequire("fTHW5");

var $1t7fG = parcelRequire("1t7fG");

var $6d3tJ = parcelRequire("6d3tJ");

var $2NujM = parcelRequire("2NujM");

var $43ZHe = parcelRequire("43ZHe");
var $7b2c91221a0a1ff6$var$DataPackage = /*#__PURE__*/ function(_Serializable_1_Serializable) {
    (0, $ftJVG._)(DataPackage, _Serializable_1_Serializable);
    var _super = (0, $6OZAO._)(DataPackage);
    function DataPackage(dataPoints, timestampMilliseconds) {
        (0, $978gY._)(this, DataPackage);
        var _this;
        _this = _super.call(this);
        _this.dataPoints = dataPoints;
        _this.timestampMilliseconds = timestampMilliseconds;
        if (dataPoints.length === 0) throw new Error("Can not create a data package with no data points");
        var expectedDataPointByteSize = dataPoints[0].getValueByteSize();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = dataPoints[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var dataPoint = _step.value;
                (0, $6d3tJ.assert)(dataPoint.getValueByteSize() === expectedDataPointByteSize, "Values of all data points in a DataPackage must have the same number of bytes");
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    (0, $kry2a._)(DataPackage, [
        {
            // Each data point in this data package can have a different byte size
            // So we set the default byte size to 0
            key: "getEachDataPointByteSize",
            value: function getEachDataPointByteSize() {
                return this.dataPoints[0].getValueByteSize();
            }
        },
        {
            key: "toBytes",
            value: function toBytes() {
                return (0, $hbWVX.concat)([
                    this.serializeDataPoints(),
                    this.serializeTimestamp(),
                    this.serializeDefaultDataPointByteSize(),
                    this.serializeDataPointsCount()
                ]);
            }
        },
        {
            key: "toObj",
            value: function toObj() {
                return {
                    dataPoints: this.dataPoints.map(function(dataPoint) {
                        return dataPoint.toObj();
                    }),
                    timestampMilliseconds: this.timestampMilliseconds
                };
            }
        },
        {
            key: "getSignableHash",
            value: function getSignableHash() {
                var serializedDataPackage = this.toBytes();
                var signableHashHex = (0, $hbWVX.keccak256)(serializedDataPackage);
                return (0, $hbWVX.arrayify)(signableHashHex);
            }
        },
        {
            key: "sign",
            value: function sign(privateKey) {
                // Prepare hash for signing
                var signableHashBytes = this.getSignableHash();
                // Generating a signature
                var signingKey = new $hbWVX.SigningKey(privateKey);
                var fullSignature = signingKey.signDigest(signableHashBytes);
                // Return a signed data package
                return new $43ZHe.SignedDataPackage(this, fullSignature);
            }
        },
        {
            key: "serializeDataPoints",
            value: function serializeDataPoints() {
                // Sorting datapoints by bytes32 representation of dataFeedIds lexicographically
                this.dataPoints.sort(function(dp1, dp2) {
                    var bytes32dataFeedId1Hexlified = (0, $hbWVX.hexlify)(dp1.serializeDataFeedId());
                    var bytes32dataFeedId2Hexlified = (0, $hbWVX.hexlify)(dp2.serializeDataFeedId());
                    var comparisonResult = bytes32dataFeedId1Hexlified.localeCompare(bytes32dataFeedId2Hexlified);
                    (0, $6d3tJ.assert)(comparisonResult !== 0, "Duplicated dataFeedId found: ".concat(dp1.dataFeedId));
                    return comparisonResult;
                });
                return (0, $hbWVX.concat)(this.dataPoints.map(function(dp) {
                    return dp.toBytes();
                }));
            }
        },
        {
            key: "serializeTimestamp",
            value: function serializeTimestamp() {
                return (0, $6d3tJ.convertIntegerNumberToBytes)(this.timestampMilliseconds, $fTHW5.TIMESTAMP_BS);
            }
        },
        {
            key: "serializeDataPointsCount",
            value: function serializeDataPointsCount() {
                return (0, $6d3tJ.convertIntegerNumberToBytes)(this.dataPoints.length, $fTHW5.DATA_POINTS_COUNT_BS);
            }
        },
        {
            key: "serializeDefaultDataPointByteSize",
            value: function serializeDefaultDataPointByteSize() {
                return (0, $6d3tJ.convertIntegerNumberToBytes)(this.getEachDataPointByteSize(), $fTHW5.DATA_POINT_VALUE_BYTE_SIZE_BS);
            }
        }
    ], [
        {
            key: "fromObj",
            value: function fromObj(plainObject) {
                var dataPoints = plainObject.dataPoints.map($2NujM.deserializeDataPointFromObj);
                return new DataPackage(dataPoints, plainObject.timestampMilliseconds);
            }
        }
    ]);
    return DataPackage;
}($1t7fG.Serializable);
module.exports.DataPackage = $7b2c91221a0a1ff6$var$DataPackage;

});
parcelRequire.register("hbWVX", function(module, exports) {
"use strict";
var $c8412dc6d1edfef6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c8412dc6d1edfef6$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c8412dc6d1edfef6$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c8412dc6d1edfef6$var$__createBinding(result, mod, k);
    }
    $c8412dc6d1edfef6$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatBytes32String = module.exports.Utf8ErrorFuncs = module.exports.toUtf8String = module.exports.toUtf8CodePoints = module.exports.toUtf8Bytes = module.exports._toEscapedUtf8String = module.exports.nameprep = module.exports.hexDataSlice = module.exports.hexDataLength = module.exports.hexZeroPad = module.exports.hexValue = module.exports.hexStripZeros = module.exports.hexConcat = module.exports.isHexString = module.exports.hexlify = module.exports.base64 = module.exports.base58 = module.exports.TransactionDescription = module.exports.LogDescription = module.exports.Interface = module.exports.SigningKey = module.exports.HDNode = module.exports.defaultPath = module.exports.isBytesLike = module.exports.isBytes = module.exports.zeroPad = module.exports.stripZeros = module.exports.concat = module.exports.arrayify = module.exports.shallowCopy = module.exports.resolveProperties = module.exports.getStatic = module.exports.defineReadOnly = module.exports.deepCopy = module.exports.checkProperties = module.exports.poll = module.exports.fetchJson = module.exports._fetchData = module.exports.RLP = module.exports.Logger = module.exports.checkResultErrors = module.exports.FormatTypes = module.exports.ParamType = module.exports.FunctionFragment = module.exports.EventFragment = module.exports.ErrorFragment = module.exports.ConstructorFragment = module.exports.Fragment = module.exports.defaultAbiCoder = module.exports.AbiCoder = void 0;
module.exports.Indexed = module.exports.Utf8ErrorReason = module.exports.UnicodeNormalizationForm = module.exports.SupportedAlgorithm = module.exports.mnemonicToSeed = module.exports.isValidMnemonic = module.exports.entropyToMnemonic = module.exports.mnemonicToEntropy = module.exports.getAccountPath = module.exports.verifyTypedData = module.exports.verifyMessage = module.exports.recoverPublicKey = module.exports.computePublicKey = module.exports.recoverAddress = module.exports.computeAddress = module.exports.getJsonWalletAddress = module.exports.TransactionTypes = module.exports.serializeTransaction = module.exports.parseTransaction = module.exports.accessListify = module.exports.joinSignature = module.exports.splitSignature = module.exports.soliditySha256 = module.exports.solidityKeccak256 = module.exports.solidityPack = module.exports.shuffled = module.exports.randomBytes = module.exports.sha512 = module.exports.sha256 = module.exports.ripemd160 = module.exports.keccak256 = module.exports.computeHmac = module.exports.commify = module.exports.parseUnits = module.exports.formatUnits = module.exports.parseEther = module.exports.formatEther = module.exports.isAddress = module.exports.getCreate2Address = module.exports.getContractAddress = module.exports.getIcapAddress = module.exports.getAddress = module.exports._TypedDataEncoder = module.exports.id = module.exports.isValidName = module.exports.namehash = module.exports.hashMessage = module.exports.dnsEncode = module.exports.parseBytes32String = void 0;

var $yKVLS = parcelRequire("yKVLS");
var $ggjPf = parcelRequire("ggjPf");
var $6CFiK = parcelRequire("6CFiK");
var $9rkfU = parcelRequire("9rkfU");
Object.defineProperty(module.exports, "AbiCoder", {
    enumerable: true,
    get: function get() {
        return $yKVLS.AbiCoder;
    }
});
Object.defineProperty(module.exports, "checkResultErrors", {
    enumerable: true,
    get: function get() {
        return $ggjPf.checkResultErrors;
    }
});
Object.defineProperty(module.exports, "ConstructorFragment", {
    enumerable: true,
    get: function get() {
        return $6CFiK.ConstructorFragment;
    }
});
Object.defineProperty(module.exports, "defaultAbiCoder", {
    enumerable: true,
    get: function get() {
        return $yKVLS.defaultAbiCoder;
    }
});
Object.defineProperty(module.exports, "ErrorFragment", {
    enumerable: true,
    get: function get() {
        return $6CFiK.ErrorFragment;
    }
});
Object.defineProperty(module.exports, "EventFragment", {
    enumerable: true,
    get: function get() {
        return $6CFiK.EventFragment;
    }
});
Object.defineProperty(module.exports, "FormatTypes", {
    enumerable: true,
    get: function get() {
        return $6CFiK.FormatTypes;
    }
});
Object.defineProperty(module.exports, "Fragment", {
    enumerable: true,
    get: function get() {
        return $6CFiK.Fragment;
    }
});
Object.defineProperty(module.exports, "FunctionFragment", {
    enumerable: true,
    get: function get() {
        return $6CFiK.FunctionFragment;
    }
});
Object.defineProperty(module.exports, "Indexed", {
    enumerable: true,
    get: function get() {
        return $9rkfU.Indexed;
    }
});
Object.defineProperty(module.exports, "Interface", {
    enumerable: true,
    get: function get() {
        return $9rkfU.Interface;
    }
});
Object.defineProperty(module.exports, "LogDescription", {
    enumerable: true,
    get: function get() {
        return $9rkfU.LogDescription;
    }
});
Object.defineProperty(module.exports, "ParamType", {
    enumerable: true,
    get: function get() {
        return $6CFiK.ParamType;
    }
});
Object.defineProperty(module.exports, "TransactionDescription", {
    enumerable: true,
    get: function get() {
        return $9rkfU.TransactionDescription;
    }
});

var $e8NrM = parcelRequire("e8NrM");
Object.defineProperty(module.exports, "getAddress", {
    enumerable: true,
    get: function get() {
        return $e8NrM.getAddress;
    }
});
Object.defineProperty(module.exports, "getCreate2Address", {
    enumerable: true,
    get: function get() {
        return $e8NrM.getCreate2Address;
    }
});
Object.defineProperty(module.exports, "getContractAddress", {
    enumerable: true,
    get: function get() {
        return $e8NrM.getContractAddress;
    }
});
Object.defineProperty(module.exports, "getIcapAddress", {
    enumerable: true,
    get: function get() {
        return $e8NrM.getIcapAddress;
    }
});
Object.defineProperty(module.exports, "isAddress", {
    enumerable: true,
    get: function get() {
        return $e8NrM.isAddress;
    }
});

var $c8412dc6d1edfef6$var$base64 = $c8412dc6d1edfef6$var$__importStar((parcelRequire("hk1je")));
module.exports.base64 = $c8412dc6d1edfef6$var$base64;

var $ebtr5 = parcelRequire("ebtr5");
Object.defineProperty(module.exports, "base58", {
    enumerable: true,
    get: function get() {
        return $ebtr5.Base58;
    }
});

var $j2rU8 = parcelRequire("j2rU8");
Object.defineProperty(module.exports, "arrayify", {
    enumerable: true,
    get: function get() {
        return $j2rU8.arrayify;
    }
});
Object.defineProperty(module.exports, "concat", {
    enumerable: true,
    get: function get() {
        return $j2rU8.concat;
    }
});
Object.defineProperty(module.exports, "hexConcat", {
    enumerable: true,
    get: function get() {
        return $j2rU8.hexConcat;
    }
});
Object.defineProperty(module.exports, "hexDataSlice", {
    enumerable: true,
    get: function get() {
        return $j2rU8.hexDataSlice;
    }
});
Object.defineProperty(module.exports, "hexDataLength", {
    enumerable: true,
    get: function get() {
        return $j2rU8.hexDataLength;
    }
});
Object.defineProperty(module.exports, "hexlify", {
    enumerable: true,
    get: function get() {
        return $j2rU8.hexlify;
    }
});
Object.defineProperty(module.exports, "hexStripZeros", {
    enumerable: true,
    get: function get() {
        return $j2rU8.hexStripZeros;
    }
});
Object.defineProperty(module.exports, "hexValue", {
    enumerable: true,
    get: function get() {
        return $j2rU8.hexValue;
    }
});
Object.defineProperty(module.exports, "hexZeroPad", {
    enumerable: true,
    get: function get() {
        return $j2rU8.hexZeroPad;
    }
});
Object.defineProperty(module.exports, "isBytes", {
    enumerable: true,
    get: function get() {
        return $j2rU8.isBytes;
    }
});
Object.defineProperty(module.exports, "isBytesLike", {
    enumerable: true,
    get: function get() {
        return $j2rU8.isBytesLike;
    }
});
Object.defineProperty(module.exports, "isHexString", {
    enumerable: true,
    get: function get() {
        return $j2rU8.isHexString;
    }
});
Object.defineProperty(module.exports, "joinSignature", {
    enumerable: true,
    get: function get() {
        return $j2rU8.joinSignature;
    }
});
Object.defineProperty(module.exports, "zeroPad", {
    enumerable: true,
    get: function get() {
        return $j2rU8.zeroPad;
    }
});
Object.defineProperty(module.exports, "splitSignature", {
    enumerable: true,
    get: function get() {
        return $j2rU8.splitSignature;
    }
});
Object.defineProperty(module.exports, "stripZeros", {
    enumerable: true,
    get: function get() {
        return $j2rU8.stripZeros;
    }
});

var $kdj79 = parcelRequire("kdj79");
var $4JdI5 = parcelRequire("4JdI5");
var $7vZoR = parcelRequire("7vZoR");
var $4q6En = parcelRequire("4q6En");
Object.defineProperty(module.exports, "_TypedDataEncoder", {
    enumerable: true,
    get: function get() {
        return $kdj79.TypedDataEncoder;
    }
});
Object.defineProperty(module.exports, "dnsEncode", {
    enumerable: true,
    get: function get() {
        return $4JdI5.dnsEncode;
    }
});
Object.defineProperty(module.exports, "hashMessage", {
    enumerable: true,
    get: function get() {
        return $7vZoR.hashMessage;
    }
});
Object.defineProperty(module.exports, "id", {
    enumerable: true,
    get: function get() {
        return $4q6En.id;
    }
});
Object.defineProperty(module.exports, "isValidName", {
    enumerable: true,
    get: function get() {
        return $4JdI5.isValidName;
    }
});
Object.defineProperty(module.exports, "namehash", {
    enumerable: true,
    get: function get() {
        return $4JdI5.namehash;
    }
});

var $5iEGT = parcelRequire("5iEGT");
Object.defineProperty(module.exports, "defaultPath", {
    enumerable: true,
    get: function get() {
        return $5iEGT.defaultPath;
    }
});
Object.defineProperty(module.exports, "entropyToMnemonic", {
    enumerable: true,
    get: function get() {
        return $5iEGT.entropyToMnemonic;
    }
});
Object.defineProperty(module.exports, "getAccountPath", {
    enumerable: true,
    get: function get() {
        return $5iEGT.getAccountPath;
    }
});
Object.defineProperty(module.exports, "HDNode", {
    enumerable: true,
    get: function get() {
        return $5iEGT.HDNode;
    }
});
Object.defineProperty(module.exports, "isValidMnemonic", {
    enumerable: true,
    get: function get() {
        return $5iEGT.isValidMnemonic;
    }
});
Object.defineProperty(module.exports, "mnemonicToEntropy", {
    enumerable: true,
    get: function get() {
        return $5iEGT.mnemonicToEntropy;
    }
});
Object.defineProperty(module.exports, "mnemonicToSeed", {
    enumerable: true,
    get: function get() {
        return $5iEGT.mnemonicToSeed;
    }
});

var $6jMeD = parcelRequire("6jMeD");
Object.defineProperty(module.exports, "getJsonWalletAddress", {
    enumerable: true,
    get: function get() {
        return $6jMeD.getJsonWalletAddress;
    }
});

var $4ujqV = parcelRequire("4ujqV");
Object.defineProperty(module.exports, "keccak256", {
    enumerable: true,
    get: function get() {
        return $4ujqV.keccak256;
    }
});

var $6M65e = parcelRequire("6M65e");
Object.defineProperty(module.exports, "Logger", {
    enumerable: true,
    get: function get() {
        return $6M65e.Logger;
    }
});

var $7WUQV = parcelRequire("7WUQV");
var $aCF4U = parcelRequire("aCF4U");
Object.defineProperty(module.exports, "computeHmac", {
    enumerable: true,
    get: function get() {
        return $7WUQV.computeHmac;
    }
});
Object.defineProperty(module.exports, "ripemd160", {
    enumerable: true,
    get: function get() {
        return $7WUQV.ripemd160;
    }
});
Object.defineProperty(module.exports, "sha256", {
    enumerable: true,
    get: function get() {
        return $7WUQV.sha256;
    }
});
Object.defineProperty(module.exports, "sha512", {
    enumerable: true,
    get: function get() {
        return $7WUQV.sha512;
    }
});

var $ihTqz = parcelRequire("ihTqz");
Object.defineProperty(module.exports, "solidityKeccak256", {
    enumerable: true,
    get: function get() {
        return $ihTqz.keccak256;
    }
});
Object.defineProperty(module.exports, "solidityPack", {
    enumerable: true,
    get: function get() {
        return $ihTqz.pack;
    }
});
Object.defineProperty(module.exports, "soliditySha256", {
    enumerable: true,
    get: function get() {
        return $ihTqz.sha256;
    }
});

var $4kSyQ = parcelRequire("4kSyQ");
var $5aKt1 = parcelRequire("5aKt1");
Object.defineProperty(module.exports, "randomBytes", {
    enumerable: true,
    get: function get() {
        return $4kSyQ.randomBytes;
    }
});
Object.defineProperty(module.exports, "shuffled", {
    enumerable: true,
    get: function get() {
        return $5aKt1.shuffled;
    }
});

var $2ax4w = parcelRequire("2ax4w");
Object.defineProperty(module.exports, "checkProperties", {
    enumerable: true,
    get: function get() {
        return $2ax4w.checkProperties;
    }
});
Object.defineProperty(module.exports, "deepCopy", {
    enumerable: true,
    get: function get() {
        return $2ax4w.deepCopy;
    }
});
Object.defineProperty(module.exports, "defineReadOnly", {
    enumerable: true,
    get: function get() {
        return $2ax4w.defineReadOnly;
    }
});
Object.defineProperty(module.exports, "getStatic", {
    enumerable: true,
    get: function get() {
        return $2ax4w.getStatic;
    }
});
Object.defineProperty(module.exports, "resolveProperties", {
    enumerable: true,
    get: function get() {
        return $2ax4w.resolveProperties;
    }
});
Object.defineProperty(module.exports, "shallowCopy", {
    enumerable: true,
    get: function get() {
        return $2ax4w.shallowCopy;
    }
});

var $c8412dc6d1edfef6$var$RLP = $c8412dc6d1edfef6$var$__importStar((parcelRequire("dQcqA")));
module.exports.RLP = $c8412dc6d1edfef6$var$RLP;

var $4LuuL = parcelRequire("4LuuL");
Object.defineProperty(module.exports, "computePublicKey", {
    enumerable: true,
    get: function get() {
        return $4LuuL.computePublicKey;
    }
});
Object.defineProperty(module.exports, "recoverPublicKey", {
    enumerable: true,
    get: function get() {
        return $4LuuL.recoverPublicKey;
    }
});
Object.defineProperty(module.exports, "SigningKey", {
    enumerable: true,
    get: function get() {
        return $4LuuL.SigningKey;
    }
});

var $1Wmc7 = parcelRequire("1Wmc7");
var $9osRb = parcelRequire("9osRb");
var $eHcVC = parcelRequire("eHcVC");
Object.defineProperty(module.exports, "formatBytes32String", {
    enumerable: true,
    get: function get() {
        return $9osRb.formatBytes32String;
    }
});
Object.defineProperty(module.exports, "nameprep", {
    enumerable: true,
    get: function get() {
        return $eHcVC.nameprep;
    }
});
Object.defineProperty(module.exports, "parseBytes32String", {
    enumerable: true,
    get: function get() {
        return $9osRb.parseBytes32String;
    }
});
Object.defineProperty(module.exports, "_toEscapedUtf8String", {
    enumerable: true,
    get: function get() {
        return $1Wmc7._toEscapedUtf8String;
    }
});
Object.defineProperty(module.exports, "toUtf8Bytes", {
    enumerable: true,
    get: function get() {
        return $1Wmc7.toUtf8Bytes;
    }
});
Object.defineProperty(module.exports, "toUtf8CodePoints", {
    enumerable: true,
    get: function get() {
        return $1Wmc7.toUtf8CodePoints;
    }
});
Object.defineProperty(module.exports, "toUtf8String", {
    enumerable: true,
    get: function get() {
        return $1Wmc7.toUtf8String;
    }
});
Object.defineProperty(module.exports, "Utf8ErrorFuncs", {
    enumerable: true,
    get: function get() {
        return $1Wmc7.Utf8ErrorFuncs;
    }
});

var $hDQeE = parcelRequire("hDQeE");
Object.defineProperty(module.exports, "accessListify", {
    enumerable: true,
    get: function get() {
        return $hDQeE.accessListify;
    }
});
Object.defineProperty(module.exports, "computeAddress", {
    enumerable: true,
    get: function get() {
        return $hDQeE.computeAddress;
    }
});
Object.defineProperty(module.exports, "parseTransaction", {
    enumerable: true,
    get: function get() {
        return $hDQeE.parse;
    }
});
Object.defineProperty(module.exports, "recoverAddress", {
    enumerable: true,
    get: function get() {
        return $hDQeE.recoverAddress;
    }
});
Object.defineProperty(module.exports, "serializeTransaction", {
    enumerable: true,
    get: function get() {
        return $hDQeE.serialize;
    }
});
Object.defineProperty(module.exports, "TransactionTypes", {
    enumerable: true,
    get: function get() {
        return $hDQeE.TransactionTypes;
    }
});

var $41JdS = parcelRequire("41JdS");
Object.defineProperty(module.exports, "commify", {
    enumerable: true,
    get: function get() {
        return $41JdS.commify;
    }
});
Object.defineProperty(module.exports, "formatEther", {
    enumerable: true,
    get: function get() {
        return $41JdS.formatEther;
    }
});
Object.defineProperty(module.exports, "parseEther", {
    enumerable: true,
    get: function get() {
        return $41JdS.parseEther;
    }
});
Object.defineProperty(module.exports, "formatUnits", {
    enumerable: true,
    get: function get() {
        return $41JdS.formatUnits;
    }
});
Object.defineProperty(module.exports, "parseUnits", {
    enumerable: true,
    get: function get() {
        return $41JdS.parseUnits;
    }
});

var $54wuV = parcelRequire("54wuV");
Object.defineProperty(module.exports, "verifyMessage", {
    enumerable: true,
    get: function get() {
        return $54wuV.verifyMessage;
    }
});
Object.defineProperty(module.exports, "verifyTypedData", {
    enumerable: true,
    get: function get() {
        return $54wuV.verifyTypedData;
    }
});

var $gqL7R = parcelRequire("gqL7R");
Object.defineProperty(module.exports, "_fetchData", {
    enumerable: true,
    get: function get() {
        return $gqL7R._fetchData;
    }
});
Object.defineProperty(module.exports, "fetchJson", {
    enumerable: true,
    get: function get() {
        return $gqL7R.fetchJson;
    }
});
Object.defineProperty(module.exports, "poll", {
    enumerable: true,
    get: function get() {
        return $gqL7R.poll;
    }
});

var $7WUQV = parcelRequire("7WUQV");
var $aCF4U = parcelRequire("aCF4U");
Object.defineProperty(module.exports, "SupportedAlgorithm", {
    enumerable: true,
    get: function get() {
        return $aCF4U.SupportedAlgorithm;
    }
});

var $1Wmc7 = parcelRequire("1Wmc7");
var $9osRb = parcelRequire("9osRb");
var $eHcVC = parcelRequire("eHcVC");
Object.defineProperty(module.exports, "UnicodeNormalizationForm", {
    enumerable: true,
    get: function get() {
        return $1Wmc7.UnicodeNormalizationForm;
    }
});
Object.defineProperty(module.exports, "Utf8ErrorReason", {
    enumerable: true,
    get: function get() {
        return $1Wmc7.Utf8ErrorReason;
    }
});

});
parcelRequire.register("yKVLS", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", function () { return $068794918994f80d$export$fe041e1a83d3efc6; });
$parcel$export(module.exports, "defaultAbiCoder", function () { return $068794918994f80d$export$51d1cfcdb913adff; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $j2rU8 = parcelRequire("j2rU8");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $ij6uS = parcelRequire("ij6uS");

var $ggjPf = parcelRequire("ggjPf");

var $3X3hC = parcelRequire("3X3hC");

var $6qcrc = parcelRequire("6qcrc");

var $2NwrY = parcelRequire("2NwrY");

var $fMSbI = parcelRequire("fMSbI");

var $jbYON = parcelRequire("jbYON");

var $3Sede = parcelRequire("3Sede");

var $ggBgc = parcelRequire("ggBgc");

var $4pr0F = parcelRequire("4pr0F");

var $i57uN = parcelRequire("i57uN");

var $6CFiK = parcelRequire("6CFiK");
"use strict";
var $068794918994f80d$var$logger = new (0, $6M65e.Logger)((0, $ij6uS.version));
var $068794918994f80d$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
var $068794918994f80d$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
var $068794918994f80d$export$fe041e1a83d3efc6 = /*#__PURE__*/ function() {
    function AbiCoder(coerceFunc) {
        (0, $978gY._)(this, AbiCoder);
        (0, $2ax4w.defineReadOnly)(this, "coerceFunc", coerceFunc || null);
    }
    (0, $kry2a._)(AbiCoder, [
        {
            key: "_getCoder",
            value: function _getCoder(param) {
                var _this = this;
                switch(param.baseType){
                    case "address":
                        return new (0, $3X3hC.AddressCoder)(param.name);
                    case "bool":
                        return new (0, $2NwrY.BooleanCoder)(param.name);
                    case "string":
                        return new (0, $4pr0F.StringCoder)(param.name);
                    case "bytes":
                        return new (0, $fMSbI.BytesCoder)(param.name);
                    case "array":
                        return new (0, $6qcrc.ArrayCoder)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
                    case "tuple":
                        return new (0, $i57uN.TupleCoder)((param.components || []).map(function(component) {
                            return _this._getCoder(component);
                        }), param.name);
                    case "":
                        return new (0, $3Sede.NullCoder)(param.name);
                }
                // u?int[0-9]*
                var match = param.type.match($068794918994f80d$var$paramTypeNumber);
                if (match) {
                    var size = parseInt(match[2] || "256");
                    if (size === 0 || size > 256 || size % 8 !== 0) $068794918994f80d$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
                    return new (0, $ggBgc.NumberCoder)(size / 8, match[1] === "int", param.name);
                }
                // bytes[0-9]+
                match = param.type.match($068794918994f80d$var$paramTypeBytes);
                if (match) {
                    var size1 = parseInt(match[1]);
                    if (size1 === 0 || size1 > 32) $068794918994f80d$var$logger.throwArgumentError("invalid bytes length", "param", param);
                    return new (0, $jbYON.FixedBytesCoder)(size1, param.name);
                }
                return $068794918994f80d$var$logger.throwArgumentError("invalid type", "type", param.type);
            }
        },
        {
            key: "_getWordSize",
            value: function _getWordSize() {
                return 32;
            }
        },
        {
            key: "_getReader",
            value: function _getReader(data, allowLoose) {
                return new (0, $ggjPf.Reader)(data, this._getWordSize(), this.coerceFunc, allowLoose);
            }
        },
        {
            key: "_getWriter",
            value: function _getWriter() {
                return new (0, $ggjPf.Writer)(this._getWordSize());
            }
        },
        {
            key: "getDefaultValue",
            value: function getDefaultValue(types) {
                var _this = this;
                var coders = types.map(function(type) {
                    return _this._getCoder((0, $6CFiK.ParamType).from(type));
                });
                var coder = new (0, $i57uN.TupleCoder)(coders, "_");
                return coder.defaultValue();
            }
        },
        {
            key: "encode",
            value: function encode(types, values) {
                var _this = this;
                if (types.length !== values.length) $068794918994f80d$var$logger.throwError("types/values length mismatch", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                    count: {
                        types: types.length,
                        values: values.length
                    },
                    value: {
                        types: types,
                        values: values
                    }
                });
                var coders = types.map(function(type) {
                    return _this._getCoder((0, $6CFiK.ParamType).from(type));
                });
                var coder = new (0, $i57uN.TupleCoder)(coders, "_");
                var writer = this._getWriter();
                coder.encode(writer, values);
                return writer.data;
            }
        },
        {
            key: "decode",
            value: function decode(types, data, loose) {
                var _this = this;
                var coders = types.map(function(type) {
                    return _this._getCoder((0, $6CFiK.ParamType).from(type));
                });
                var coder = new (0, $i57uN.TupleCoder)(coders, "_");
                return coder.decode(this._getReader((0, $j2rU8.arrayify)(data), loose));
            }
        }
    ]);
    return AbiCoder;
}();
var $068794918994f80d$export$51d1cfcdb913adff = new $068794918994f80d$export$fe041e1a83d3efc6();

});
parcelRequire.register("2ax4w", function(module, exports) {

$parcel$export(module.exports, "defineReadOnly", function () { return $19462b55124983f4$export$104236534534f9be; });
$parcel$export(module.exports, "getStatic", function () { return $19462b55124983f4$export$f695fbbf3cdaaf47; });
$parcel$export(module.exports, "resolveProperties", function () { return $19462b55124983f4$export$d503dd157d963b60; });
$parcel$export(module.exports, "checkProperties", function () { return $19462b55124983f4$export$ae5a316ba623b73a; });
$parcel$export(module.exports, "shallowCopy", function () { return $19462b55124983f4$export$9c13236873b118a5; });
$parcel$export(module.exports, "deepCopy", function () { return $19462b55124983f4$export$6c40052bed430212; });
$parcel$export(module.exports, "Description", function () { return $19462b55124983f4$export$393edc798c47379d; });

var $978gY = parcelRequire("978gY");

var $1ObTH = parcelRequire("1ObTH");

var $7UAGh = parcelRequire("7UAGh");

var $6M65e = parcelRequire("6M65e");

var $2laPa = parcelRequire("2laPa");
"use strict";
var $19462b55124983f4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $19462b55124983f4$var$logger = new (0, $6M65e.Logger)((0, $2laPa.version));
function $19462b55124983f4$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $19462b55124983f4$export$f695fbbf3cdaaf47(ctor, key) {
    for(var i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $19462b55124983f4$export$d503dd157d963b60(object) {
    return $19462b55124983f4$var$__awaiter(this, void 0, void 0, function() {
        var promises, results;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    promises = Object.keys(object).map(function(key) {
                        var value = object[key];
                        return Promise.resolve(value).then(function(v) {
                            return {
                                key: key,
                                value: v
                            };
                        });
                    });
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 1:
                    results = _state.sent();
                    return [
                        2,
                        results.reduce(function(accum, result) {
                            accum[result.key] = result.value;
                            return accum;
                        }, {})
                    ];
            }
        });
    });
}
function $19462b55124983f4$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $19462b55124983f4$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach(function(key) {
        if (!properties[key]) $19462b55124983f4$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $19462b55124983f4$export$9c13236873b118a5(object) {
    var result = {};
    for(var key in object)result[key] = object[key];
    return result;
}
var $19462b55124983f4$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $19462b55124983f4$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $19462b55124983f4$var$opaque[typeof object === "undefined" ? "undefined" : (0, $1ObTH._)(object)]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        var keys = Object.keys(object);
        for(var i = 0; i < keys.length; i++){
            var value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$19462b55124983f4$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $19462b55124983f4$var$logger.throwArgumentError("Cannot deepCopy ".concat(typeof object === "undefined" ? "undefined" : (0, $1ObTH._)(object)), "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $19462b55124983f4$var$_deepCopy(object) {
    if ($19462b55124983f4$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map(function(item) {
        return $19462b55124983f4$export$6c40052bed430212(item);
    }));
    if (typeof object === "object") {
        var result = {};
        for(var key in object){
            var value = object[key];
            if (value === undefined) continue;
            $19462b55124983f4$export$104236534534f9be(result, key, $19462b55124983f4$export$6c40052bed430212(value));
        }
        return result;
    }
    return $19462b55124983f4$var$logger.throwArgumentError("Cannot deepCopy ".concat(typeof object === "undefined" ? "undefined" : (0, $1ObTH._)(object)), "object", object);
}
function $19462b55124983f4$export$6c40052bed430212(object) {
    return $19462b55124983f4$var$_deepCopy(object);
}
var $19462b55124983f4$export$393edc798c47379d = function Description(info) {
    (0, $978gY._)(this, Description);
    for(var key in info)this[key] = $19462b55124983f4$export$6c40052bed430212(info[key]);
};

});
parcelRequire.register("2laPa", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $1b45f0663293159e$export$83d89fbfd8236492; });
var $1b45f0663293159e$export$83d89fbfd8236492 = "properties/5.7.0";

});


parcelRequire.register("ij6uS", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $d53f0a8655f612f5$export$83d89fbfd8236492; });
var $d53f0a8655f612f5$export$83d89fbfd8236492 = "abi/5.7.0";

});

parcelRequire.register("ggjPf", function(module, exports) {

$parcel$export(module.exports, "checkResultErrors", function () { return $bd6d84ecef385088$export$5546b9ec21157cc2; });
$parcel$export(module.exports, "Coder", function () { return $bd6d84ecef385088$export$2c0c39526f8bad46; });
$parcel$export(module.exports, "Writer", function () { return $bd6d84ecef385088$export$d7a960146e1a269e; });
$parcel$export(module.exports, "Reader", function () { return $bd6d84ecef385088$export$2f7a2f0e90c07dc4; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $j2rU8 = parcelRequire("j2rU8");

var $gMArf = parcelRequire("gMArf");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $ij6uS = parcelRequire("ij6uS");
"use strict";
var $bd6d84ecef385088$var$logger = new (0, $6M65e.Logger)((0, $ij6uS.version));
function $bd6d84ecef385088$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    var errors = [];
    var checkErrors = function checkErrors1(path, object) {
        if (!Array.isArray(object)) return;
        for(var key in object){
            var childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
var $bd6d84ecef385088$export$2c0c39526f8bad46 = /*#__PURE__*/ function() {
    function Coder(name, type, localName, dynamic) {
        (0, $978gY._)(this, Coder);
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    (0, $kry2a._)(Coder, [
        {
            key: "_throwError",
            value: function _throwError(message, value) {
                $bd6d84ecef385088$var$logger.throwArgumentError(message, this.localName, value);
            }
        }
    ]);
    return Coder;
}();
var $bd6d84ecef385088$export$d7a960146e1a269e = /*#__PURE__*/ function() {
    function Writer(wordSize) {
        (0, $978gY._)(this, Writer);
        (0, $2ax4w.defineReadOnly)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    (0, $kry2a._)(Writer, [
        {
            key: "data",
            get: function get() {
                return (0, $j2rU8.hexConcat)(this._data);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._dataLength;
            }
        },
        {
            key: "_writeData",
            value: function _writeData(data) {
                this._data.push(data);
                this._dataLength += data.length;
                return data.length;
            }
        },
        {
            key: "appendWriter",
            value: function appendWriter(writer) {
                return this._writeData((0, $j2rU8.concat)(writer._data));
            }
        },
        {
            // Arrayish items; padded on the right to wordSize
            key: "writeBytes",
            value: function writeBytes(value) {
                var bytes = (0, $j2rU8.arrayify)(value);
                var paddingOffset = bytes.length % this.wordSize;
                if (paddingOffset) bytes = (0, $j2rU8.concat)([
                    bytes,
                    this._padding.slice(paddingOffset)
                ]);
                return this._writeData(bytes);
            }
        },
        {
            key: "_getValue",
            value: function _getValue(value) {
                var bytes = (0, $j2rU8.arrayify)((0, $gMArf.BigNumber).from(value));
                if (bytes.length > this.wordSize) $bd6d84ecef385088$var$logger.throwError("value out-of-bounds", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {
                    length: this.wordSize,
                    offset: bytes.length
                });
                if (bytes.length % this.wordSize) bytes = (0, $j2rU8.concat)([
                    this._padding.slice(bytes.length % this.wordSize),
                    bytes
                ]);
                return bytes;
            }
        },
        {
            // BigNumberish items; padded on the left to wordSize
            key: "writeValue",
            value: function writeValue(value) {
                return this._writeData(this._getValue(value));
            }
        },
        {
            key: "writeUpdatableValue",
            value: function writeUpdatableValue() {
                var _this = this;
                var offset = this._data.length;
                this._data.push(this._padding);
                this._dataLength += this.wordSize;
                return function(value) {
                    _this._data[offset] = _this._getValue(value);
                };
            }
        }
    ]);
    return Writer;
}();
var $bd6d84ecef385088$export$2f7a2f0e90c07dc4 = /*#__PURE__*/ function() {
    function Reader(data, wordSize, coerceFunc, allowLoose) {
        (0, $978gY._)(this, Reader);
        (0, $2ax4w.defineReadOnly)(this, "_data", (0, $j2rU8.arrayify)(data));
        (0, $2ax4w.defineReadOnly)(this, "wordSize", wordSize || 32);
        (0, $2ax4w.defineReadOnly)(this, "_coerceFunc", coerceFunc);
        (0, $2ax4w.defineReadOnly)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    (0, $kry2a._)(Reader, [
        {
            key: "data",
            get: function get() {
                return (0, $j2rU8.hexlify)(this._data);
            }
        },
        {
            key: "consumed",
            get: function get() {
                return this._offset;
            }
        },
        {
            key: "coerce",
            value: function coerce(name, value) {
                if (this._coerceFunc) return this._coerceFunc(name, value);
                return Reader.coerce(name, value);
            }
        },
        {
            key: "_peekBytes",
            value: function _peekBytes(offset, length, loose) {
                var alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
                if (this._offset + alignedLength > this._data.length) {
                    if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
                    else $bd6d84ecef385088$var$logger.throwError("data out-of-bounds", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {
                        length: this._data.length,
                        offset: this._offset + alignedLength
                    });
                }
                return this._data.slice(this._offset, this._offset + alignedLength);
            }
        },
        {
            key: "subReader",
            value: function subReader(offset) {
                return new Reader(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
            }
        },
        {
            key: "readBytes",
            value: function readBytes(length, loose) {
                var bytes = this._peekBytes(0, length, !!loose);
                this._offset += bytes.length;
                // @TODO: Make sure the length..end bytes are all 0?
                return bytes.slice(0, length);
            }
        },
        {
            key: "readValue",
            value: function readValue() {
                return (0, $gMArf.BigNumber).from(this.readBytes(this.wordSize));
            }
        }
    ], [
        {
            key: "coerce",
            value: // The default Coerce function
            function coerce(name, value) {
                var match = name.match("^u?int([0-9]+)$");
                if (match && parseInt(match[1]) <= 48) value = value.toNumber();
                return value;
            }
        }
    ]);
    return Reader;
}();

});
parcelRequire.register("gMArf", function(module, exports) {

$parcel$export(module.exports, "isBigNumberish", function () { return $c37d64fad2cf3dce$export$a3d0a7fa9b65683b; });
$parcel$export(module.exports, "BigNumber", function () { return $c37d64fad2cf3dce$export$d97aa349ed20696; });
$parcel$export(module.exports, "_base36To16", function () { return $c37d64fad2cf3dce$export$51e4a08295f7770f; });
$parcel$export(module.exports, "_base16To36", function () { return $c37d64fad2cf3dce$export$1293db5d29c264ff; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $1ObTH = parcelRequire("1ObTH");

var $jlWHo = parcelRequire("jlWHo");

var $j2rU8 = parcelRequire("j2rU8");

var $6M65e = parcelRequire("6M65e");

var $aLv3y = parcelRequire("aLv3y");
"use strict";
var $c37d64fad2cf3dce$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo))).BN;
var $c37d64fad2cf3dce$var$logger = new (0, $6M65e.Logger)((0, $aLv3y.version));
var $c37d64fad2cf3dce$var$_constructorGuard = {};
var $c37d64fad2cf3dce$var$MAX_SAFE = 0x1fffffffffffff;
function $c37d64fad2cf3dce$export$a3d0a7fa9b65683b(value) {
    return value != null && ($c37d64fad2cf3dce$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $j2rU8.isHexString)(value) || (typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value)) === "bigint" || (0, $j2rU8.isBytes)(value));
}
// Only warn about passing 10 into radix once
var $c37d64fad2cf3dce$var$_warnedToStringRadix = false;
var $c37d64fad2cf3dce$export$d97aa349ed20696 = /*#__PURE__*/ function() {
    function BigNumber(constructorGuard, hex) {
        (0, $978gY._)(this, BigNumber);
        if (constructorGuard !== $c37d64fad2cf3dce$var$_constructorGuard) $c37d64fad2cf3dce$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    (0, $kry2a._)(BigNumber, [
        {
            key: "fromTwos",
            value: function fromTwos(value) {
                return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).fromTwos(value));
            }
        },
        {
            key: "toTwos",
            value: function toTwos(value) {
                return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).toTwos(value));
            }
        },
        {
            key: "abs",
            value: function abs() {
                if (this._hex[0] === "-") return BigNumber.from(this._hex.substring(1));
                return this;
            }
        },
        {
            key: "add",
            value: function add(other) {
                return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).add($c37d64fad2cf3dce$var$toBN(other)));
            }
        },
        {
            key: "sub",
            value: function sub(other) {
                return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).sub($c37d64fad2cf3dce$var$toBN(other)));
            }
        },
        {
            key: "div",
            value: function div(other) {
                var o = BigNumber.from(other);
                if (o.isZero()) $c37d64fad2cf3dce$var$throwFault("division-by-zero", "div");
                return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).div($c37d64fad2cf3dce$var$toBN(other)));
            }
        },
        {
            key: "mul",
            value: function mul(other) {
                return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).mul($c37d64fad2cf3dce$var$toBN(other)));
            }
        },
        {
            key: "mod",
            value: function mod(other) {
                var value = $c37d64fad2cf3dce$var$toBN(other);
                if (value.isNeg()) $c37d64fad2cf3dce$var$throwFault("division-by-zero", "mod");
                return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).umod(value));
            }
        },
        {
            key: "pow",
            value: function pow(other) {
                var value = $c37d64fad2cf3dce$var$toBN(other);
                if (value.isNeg()) $c37d64fad2cf3dce$var$throwFault("negative-power", "pow");
                return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).pow(value));
            }
        },
        {
            key: "and",
            value: function and(other) {
                var value = $c37d64fad2cf3dce$var$toBN(other);
                if (this.isNegative() || value.isNeg()) $c37d64fad2cf3dce$var$throwFault("unbound-bitwise-result", "and");
                return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).and(value));
            }
        },
        {
            key: "or",
            value: function or(other) {
                var value = $c37d64fad2cf3dce$var$toBN(other);
                if (this.isNegative() || value.isNeg()) $c37d64fad2cf3dce$var$throwFault("unbound-bitwise-result", "or");
                return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).or(value));
            }
        },
        {
            key: "xor",
            value: function xor(other) {
                var value = $c37d64fad2cf3dce$var$toBN(other);
                if (this.isNegative() || value.isNeg()) $c37d64fad2cf3dce$var$throwFault("unbound-bitwise-result", "xor");
                return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).xor(value));
            }
        },
        {
            key: "mask",
            value: function mask(value) {
                if (this.isNegative() || value < 0) $c37d64fad2cf3dce$var$throwFault("negative-width", "mask");
                return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).maskn(value));
            }
        },
        {
            key: "shl",
            value: function shl(value) {
                if (this.isNegative() || value < 0) $c37d64fad2cf3dce$var$throwFault("negative-width", "shl");
                return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).shln(value));
            }
        },
        {
            key: "shr",
            value: function shr(value) {
                if (this.isNegative() || value < 0) $c37d64fad2cf3dce$var$throwFault("negative-width", "shr");
                return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).shrn(value));
            }
        },
        {
            key: "eq",
            value: function eq(other) {
                return $c37d64fad2cf3dce$var$toBN(this).eq($c37d64fad2cf3dce$var$toBN(other));
            }
        },
        {
            key: "lt",
            value: function lt(other) {
                return $c37d64fad2cf3dce$var$toBN(this).lt($c37d64fad2cf3dce$var$toBN(other));
            }
        },
        {
            key: "lte",
            value: function lte(other) {
                return $c37d64fad2cf3dce$var$toBN(this).lte($c37d64fad2cf3dce$var$toBN(other));
            }
        },
        {
            key: "gt",
            value: function gt(other) {
                return $c37d64fad2cf3dce$var$toBN(this).gt($c37d64fad2cf3dce$var$toBN(other));
            }
        },
        {
            key: "gte",
            value: function gte(other) {
                return $c37d64fad2cf3dce$var$toBN(this).gte($c37d64fad2cf3dce$var$toBN(other));
            }
        },
        {
            key: "isNegative",
            value: function isNegative() {
                return this._hex[0] === "-";
            }
        },
        {
            key: "isZero",
            value: function isZero() {
                return $c37d64fad2cf3dce$var$toBN(this).isZero();
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                try {
                    return $c37d64fad2cf3dce$var$toBN(this).toNumber();
                } catch (error) {
                    $c37d64fad2cf3dce$var$throwFault("overflow", "toNumber", this.toString());
                }
                return null;
            }
        },
        {
            key: "toBigInt",
            value: function toBigInt() {
                try {
                    return BigInt(this.toString());
                } catch (e) {}
                return $c37d64fad2cf3dce$var$logger.throwError("this platform does not support BigInt", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                    value: this.toString()
                });
            }
        },
        {
            key: "toString",
            value: function toString() {
                // Lots of people expect this, which we do not support, so check (See: #889)
                if (arguments.length > 0) {
                    if (arguments[0] === 10) {
                        if (!$c37d64fad2cf3dce$var$_warnedToStringRadix) {
                            $c37d64fad2cf3dce$var$_warnedToStringRadix = true;
                            $c37d64fad2cf3dce$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                        }
                    } else if (arguments[0] === 16) $c37d64fad2cf3dce$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $6M65e.Logger).errors.UNEXPECTED_ARGUMENT, {});
                    else $c37d64fad2cf3dce$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $6M65e.Logger).errors.UNEXPECTED_ARGUMENT, {});
                }
                return $c37d64fad2cf3dce$var$toBN(this).toString(10);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this._hex;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(key) {
                return {
                    type: "BigNumber",
                    hex: this.toHexString()
                };
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (value instanceof BigNumber) return value;
                if (typeof value === "string") {
                    if (value.match(/^-?0x[0-9a-f]+$/i)) return new BigNumber($c37d64fad2cf3dce$var$_constructorGuard, $c37d64fad2cf3dce$var$toHex(value));
                    if (value.match(/^-?[0-9]+$/)) return new BigNumber($c37d64fad2cf3dce$var$_constructorGuard, $c37d64fad2cf3dce$var$toHex(new $c37d64fad2cf3dce$var$BN(value)));
                    return $c37d64fad2cf3dce$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
                }
                if (typeof value === "number") {
                    if (value % 1) $c37d64fad2cf3dce$var$throwFault("underflow", "BigNumber.from", value);
                    if (value >= $c37d64fad2cf3dce$var$MAX_SAFE || value <= -$c37d64fad2cf3dce$var$MAX_SAFE) $c37d64fad2cf3dce$var$throwFault("overflow", "BigNumber.from", value);
                    return BigNumber.from(String(value));
                }
                var anyValue = value;
                if ((typeof anyValue === "undefined" ? "undefined" : (0, $1ObTH._)(anyValue)) === "bigint") return BigNumber.from(anyValue.toString());
                if ((0, $j2rU8.isBytes)(anyValue)) return BigNumber.from((0, $j2rU8.hexlify)(anyValue));
                if (anyValue) {
                    // Hexable interface (takes priority)
                    if (anyValue.toHexString) {
                        var hex = anyValue.toHexString();
                        if (typeof hex === "string") return BigNumber.from(hex);
                    } else {
                        // For now, handle legacy JSON-ified values (goes away in v6)
                        var hex1 = anyValue._hex;
                        // New-form JSON
                        if (hex1 == null && anyValue.type === "BigNumber") hex1 = anyValue.hex;
                        if (typeof hex1 === "string") {
                            if ((0, $j2rU8.isHexString)(hex1) || hex1[0] === "-" && (0, $j2rU8.isHexString)(hex1.substring(1))) return BigNumber.from(hex1);
                        }
                    }
                }
                return $c37d64fad2cf3dce$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
            }
        },
        {
            key: "isBigNumber",
            value: function isBigNumber(value) {
                return !!(value && value._isBigNumber);
            }
        }
    ]);
    return BigNumber;
}();
// Normalize the hex string
function $c37d64fad2cf3dce$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $c37d64fad2cf3dce$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $c37d64fad2cf3dce$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $c37d64fad2cf3dce$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $c37d64fad2cf3dce$var$toBigNumber(value) {
    return $c37d64fad2cf3dce$export$d97aa349ed20696.from($c37d64fad2cf3dce$var$toHex(value));
}
function $c37d64fad2cf3dce$var$toBN(value) {
    var hex = $c37d64fad2cf3dce$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $c37d64fad2cf3dce$var$BN("-" + hex.substring(3), 16);
    return new $c37d64fad2cf3dce$var$BN(hex.substring(2), 16);
}
function $c37d64fad2cf3dce$var$throwFault(fault, operation, value) {
    var params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $c37d64fad2cf3dce$var$logger.throwError(fault, (0, $6M65e.Logger).errors.NUMERIC_FAULT, params);
}
function $c37d64fad2cf3dce$export$51e4a08295f7770f(value) {
    return new $c37d64fad2cf3dce$var$BN(value, 36).toString(16);
}
function $c37d64fad2cf3dce$export$1293db5d29c264ff(value) {
    return new $c37d64fad2cf3dce$var$BN(value, 16).toString(36);
}

});
parcelRequire.register("aLv3y", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $7d66624d621f023f$export$83d89fbfd8236492; });
var $7d66624d621f023f$export$83d89fbfd8236492 = "bignumber/5.7.0";

});



parcelRequire.register("3X3hC", function(module, exports) {

$parcel$export(module.exports, "AddressCoder", function () { return $2e096dc236f9984b$export$59dbbded7775bfe7; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $e8NrM = parcelRequire("e8NrM");

var $j2rU8 = parcelRequire("j2rU8");

var $ggjPf = parcelRequire("ggjPf");
"use strict";
var $2e096dc236f9984b$export$59dbbded7775bfe7 = /*#__PURE__*/ function(Coder) {
    (0, $ftJVG._)(AddressCoder, Coder);
    var _super = (0, $6OZAO._)(AddressCoder);
    function AddressCoder(localName) {
        (0, $978gY._)(this, AddressCoder);
        return _super.call(this, "address", "address", localName, false);
    }
    (0, $kry2a._)(AddressCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return "0x0000000000000000000000000000000000000000";
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                try {
                    value = (0, $e8NrM.getAddress)(value);
                } catch (error) {
                    this._throwError(error.message, value);
                }
                return writer.writeValue(value);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return (0, $e8NrM.getAddress)((0, $j2rU8.hexZeroPad)(reader.readValue().toHexString(), 20));
            }
        }
    ]);
    return AddressCoder;
}((0, $ggjPf.Coder));

});
parcelRequire.register("e8NrM", function(module, exports) {

$parcel$export(module.exports, "getAddress", function () { return $a4b82b374f356b4b$export$88411125f012957a; });
$parcel$export(module.exports, "isAddress", function () { return $a4b82b374f356b4b$export$977e255126d763d6; });
$parcel$export(module.exports, "getIcapAddress", function () { return $a4b82b374f356b4b$export$962c4ddada9f668f; });
$parcel$export(module.exports, "getContractAddress", function () { return $a4b82b374f356b4b$export$b7fbffef12272e40; });
$parcel$export(module.exports, "getCreate2Address", function () { return $a4b82b374f356b4b$export$e0b22d96621f73a2; });

var $j2rU8 = parcelRequire("j2rU8");

var $gMArf = parcelRequire("gMArf");

var $4ujqV = parcelRequire("4ujqV");

var $dQcqA = parcelRequire("dQcqA");

var $6M65e = parcelRequire("6M65e");

var $jZSk5 = parcelRequire("jZSk5");
"use strict";
var $a4b82b374f356b4b$var$logger = new (0, $6M65e.Logger)((0, $jZSk5.version));
function $a4b82b374f356b4b$var$getChecksumAddress(address) {
    if (!(0, $j2rU8.isHexString)(address, 20)) $a4b82b374f356b4b$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    var chars = address.substring(2).split("");
    var expanded = new Uint8Array(40);
    for(var i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    var hashed = (0, $j2rU8.arrayify)((0, $4ujqV.keccak256)(expanded));
    for(var i1 = 0; i1 < 40; i1 += 2){
        if (hashed[i1 >> 1] >> 4 >= 8) chars[i1] = chars[i1].toUpperCase();
        if ((hashed[i1 >> 1] & 0x0f) >= 8) chars[i1 + 1] = chars[i1 + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
var $a4b82b374f356b4b$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $a4b82b374f356b4b$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
var $a4b82b374f356b4b$var$ibanLookup = {};
for(var $a4b82b374f356b4b$var$i = 0; $a4b82b374f356b4b$var$i < 10; $a4b82b374f356b4b$var$i++)$a4b82b374f356b4b$var$ibanLookup[String($a4b82b374f356b4b$var$i)] = String($a4b82b374f356b4b$var$i);
for(var $a4b82b374f356b4b$var$i1 = 0; $a4b82b374f356b4b$var$i1 < 26; $a4b82b374f356b4b$var$i1++)$a4b82b374f356b4b$var$ibanLookup[String.fromCharCode(65 + $a4b82b374f356b4b$var$i1)] = String(10 + $a4b82b374f356b4b$var$i1);
// How many decimal digits can we process? (for 64-bit float, this is 15)
var $a4b82b374f356b4b$var$safeDigits = Math.floor($a4b82b374f356b4b$var$log10($a4b82b374f356b4b$var$MAX_SAFE_INTEGER));
function $a4b82b374f356b4b$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    var expanded = address.split("").map(function(c) {
        return $a4b82b374f356b4b$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $a4b82b374f356b4b$var$safeDigits){
        var block = expanded.substring(0, $a4b82b374f356b4b$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    var checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $a4b82b374f356b4b$export$88411125f012957a(address) {
    var result = null;
    if (typeof address !== "string") $a4b82b374f356b4b$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $a4b82b374f356b4b$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $a4b82b374f356b4b$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $a4b82b374f356b4b$var$ibanChecksum(address)) $a4b82b374f356b4b$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $gMArf._base36To16)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $a4b82b374f356b4b$var$getChecksumAddress("0x" + result);
    } else $a4b82b374f356b4b$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $a4b82b374f356b4b$export$977e255126d763d6(address) {
    try {
        $a4b82b374f356b4b$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $a4b82b374f356b4b$export$962c4ddada9f668f(address) {
    var base36 = (0, $gMArf._base16To36)($a4b82b374f356b4b$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $a4b82b374f356b4b$var$ibanChecksum("XE00" + base36) + base36;
}
function $a4b82b374f356b4b$export$b7fbffef12272e40(transaction) {
    var from = null;
    try {
        from = $a4b82b374f356b4b$export$88411125f012957a(transaction.from);
    } catch (error) {
        $a4b82b374f356b4b$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    var nonce = (0, $j2rU8.stripZeros)((0, $j2rU8.arrayify)((0, $gMArf.BigNumber).from(transaction.nonce).toHexString()));
    return $a4b82b374f356b4b$export$88411125f012957a((0, $j2rU8.hexDataSlice)((0, $4ujqV.keccak256)((0, $dQcqA.encode)([
        from,
        nonce
    ])), 12));
}
function $a4b82b374f356b4b$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $j2rU8.hexDataLength)(salt) !== 32) $a4b82b374f356b4b$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $j2rU8.hexDataLength)(initCodeHash) !== 32) $a4b82b374f356b4b$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $a4b82b374f356b4b$export$88411125f012957a((0, $j2rU8.hexDataSlice)((0, $4ujqV.keccak256)((0, $j2rU8.concat)([
        "0xff",
        $a4b82b374f356b4b$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}

});
parcelRequire.register("4ujqV", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $344909d1f36347b2$export$f8151fce47ad1c35; });

var $cCjFr = parcelRequire("cCjFr");

var $j2rU8 = parcelRequire("j2rU8");
"use strict";
function $344909d1f36347b2$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($cCjFr))).keccak_256((0, $j2rU8.arrayify)(data));
}

});
parcelRequire.register("cCjFr", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");

var $aqbQf = parcelRequire("aqbQf");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var Keccak = function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    };
    var Kmac = function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    };
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $aqbQf === "object" && $aqbQf.versions && $aqbQf.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function createOutputMethod(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function createShakeOutputMethod(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function createCshakeOutputMethod(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function createKmacOutputMethod(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function createOutputMethods(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function createMethod(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function createShakeMethod(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function createCshakeMethod(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function createKmacMethod(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message === "undefined" ? "undefined" : (0, $1ObTH._)(message);
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str === "undefined" ? "undefined" : (0, $1ObTH._)(str);
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function f(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});


parcelRequire.register("jZSk5", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $03c1c59590656f19$export$83d89fbfd8236492; });
var $03c1c59590656f19$export$83d89fbfd8236492 = "address/5.7.0";

});



parcelRequire.register("6qcrc", function(module, exports) {

$parcel$export(module.exports, "pack", function () { return $4aced1a0cbed513e$export$2a703dbb0cb35339; });
$parcel$export(module.exports, "unpack", function () { return $4aced1a0cbed513e$export$417857010dc9287f; });
$parcel$export(module.exports, "ArrayCoder", function () { return $4aced1a0cbed513e$export$88bc419d2df11f54; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $6M65e = parcelRequire("6M65e");

var $ij6uS = parcelRequire("ij6uS");

var $ggjPf = parcelRequire("ggjPf");

var $ke4Rj = parcelRequire("ke4Rj");
"use strict";
var $4aced1a0cbed513e$var$logger = new (0, $6M65e.Logger)((0, $ij6uS.version));
function $4aced1a0cbed513e$export$2a703dbb0cb35339(writer, coders, values) {
    var arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        var unique = {};
        arrayValues = coders.map(function(coder) {
            var name = coder.localName;
            if (!name) $4aced1a0cbed513e$var$logger.throwError("cannot encode object for signature with missing names", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $4aced1a0cbed513e$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $4aced1a0cbed513e$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $4aced1a0cbed513e$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    var staticWriter = new (0, $ggjPf.Writer)(writer.wordSize);
    var dynamicWriter = new (0, $ggjPf.Writer)(writer.wordSize);
    var updateFuncs = [];
    coders.forEach(function(coder, index) {
        var value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            var dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            var updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push(function(baseOffset) {
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach(function(func) {
        func(staticWriter.length);
    });
    var length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $4aced1a0cbed513e$export$417857010dc9287f(reader, coders) {
    var _loop = function(i) {
        var value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: function() {
                throw value;
            }
        });
    };
    var values = [];
    // A reader anchored to this base
    var baseReader = reader.subReader(0);
    coders.forEach(function(coder) {
        var value = null;
        if (coder.dynamic) {
            var offset = reader.readValue();
            var offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $6M65e.Logger).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $6M65e.Logger).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    var uniqueNames = coders.reduce(function(accum, coder) {
        var name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach(function(coder, index) {
        var name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        var value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: function() {
                throw value;
            }
        });
        else values[name] = value;
    });
    for(var i = 0; i < values.length; i++)_loop(i);
    return Object.freeze(values);
}
var $4aced1a0cbed513e$export$88bc419d2df11f54 = /*#__PURE__*/ function(Coder) {
    (0, $ftJVG._)(ArrayCoder, Coder);
    var _super = (0, $6OZAO._)(ArrayCoder);
    function ArrayCoder(coder, length, localName) {
        (0, $978gY._)(this, ArrayCoder);
        var _this;
        var type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        var dynamic = length === -1 || coder.dynamic;
        _this = _super.call(this, "array", type, localName, dynamic);
        _this.coder = coder;
        _this.length = length;
        return _this;
    }
    (0, $kry2a._)(ArrayCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                // Verifies the child coder is valid (even if the array is dynamic or 0-length)
                var defaultChild = this.coder.defaultValue();
                var result = [];
                for(var i = 0; i < this.length; i++)result.push(defaultChild);
                return result;
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                if (!Array.isArray(value)) this._throwError("expected array value", value);
                var count = this.length;
                if (count === -1) {
                    count = value.length;
                    writer.writeValue(value.length);
                }
                $4aced1a0cbed513e$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
                var coders = [];
                for(var i = 0; i < value.length; i++)coders.push(this.coder);
                return $4aced1a0cbed513e$export$2a703dbb0cb35339(writer, coders, value);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                var count = this.length;
                if (count === -1) {
                    count = reader.readValue().toNumber();
                    // Check that there is *roughly* enough data to ensure
                    // stray random data is not being read as a length. Each
                    // slot requires at least 32 bytes for their value (or 32
                    // bytes as a link to the data). This could use a much
                    // tighter bound, but we are erroring on the side of safety.
                    if (count * 32 > reader._data.length) $4aced1a0cbed513e$var$logger.throwError("insufficient data length", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {
                        length: reader._data.length,
                        count: count
                    });
                }
                var coders = [];
                for(var i = 0; i < count; i++)coders.push(new (0, $ke4Rj.AnonymousCoder)(this.coder));
                return reader.coerce(this.name, $4aced1a0cbed513e$export$417857010dc9287f(reader, coders));
            }
        }
    ]);
    return ArrayCoder;
}((0, $ggjPf.Coder));

});
parcelRequire.register("ke4Rj", function(module, exports) {

$parcel$export(module.exports, "AnonymousCoder", function () { return $eb98e254fcc8743b$export$87c41d1139a03fa2; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $ggjPf = parcelRequire("ggjPf");
"use strict";
var $eb98e254fcc8743b$export$87c41d1139a03fa2 = /*#__PURE__*/ function(Coder) {
    (0, $ftJVG._)(AnonymousCoder, Coder);
    var _super = (0, $6OZAO._)(AnonymousCoder);
    function AnonymousCoder(coder) {
        (0, $978gY._)(this, AnonymousCoder);
        var _this;
        _this = _super.call(this, coder.name, coder.type, undefined, coder.dynamic);
        _this.coder = coder;
        return _this;
    }
    (0, $kry2a._)(AnonymousCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return this.coder.defaultValue();
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                return this.coder.encode(writer, value);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return this.coder.decode(reader);
            }
        }
    ]);
    return AnonymousCoder;
}((0, $ggjPf.Coder));

});


parcelRequire.register("2NwrY", function(module, exports) {

$parcel$export(module.exports, "BooleanCoder", function () { return $209954548c523c50$export$fe9118d6c093150c; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $ggjPf = parcelRequire("ggjPf");
"use strict";
var $209954548c523c50$export$fe9118d6c093150c = /*#__PURE__*/ function(Coder) {
    (0, $ftJVG._)(BooleanCoder, Coder);
    var _super = (0, $6OZAO._)(BooleanCoder);
    function BooleanCoder(localName) {
        (0, $978gY._)(this, BooleanCoder);
        return _super.call(this, "bool", "bool", localName, false);
    }
    (0, $kry2a._)(BooleanCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return false;
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                return writer.writeValue(value ? 1 : 0);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return reader.coerce(this.type, !reader.readValue().isZero());
            }
        }
    ]);
    return BooleanCoder;
}((0, $ggjPf.Coder));

});

parcelRequire.register("fMSbI", function(module, exports) {

$parcel$export(module.exports, "DynamicBytesCoder", function () { return $b7e55f4d821202a8$export$db9eadd8df12ad2e; });
$parcel$export(module.exports, "BytesCoder", function () { return $b7e55f4d821202a8$export$e5823e9574df18d2; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $j2rU8 = parcelRequire("j2rU8");

var $ggjPf = parcelRequire("ggjPf");
"use strict";
var $b7e55f4d821202a8$export$db9eadd8df12ad2e = /*#__PURE__*/ function(Coder) {
    (0, $ftJVG._)(DynamicBytesCoder, Coder);
    var _super = (0, $6OZAO._)(DynamicBytesCoder);
    function DynamicBytesCoder(type, localName) {
        (0, $978gY._)(this, DynamicBytesCoder);
        return _super.call(this, type, type, localName, true);
    }
    (0, $kry2a._)(DynamicBytesCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return "0x";
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                value = (0, $j2rU8.arrayify)(value);
                var length = writer.writeValue(value.length);
                length += writer.writeBytes(value);
                return length;
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return reader.readBytes(reader.readValue().toNumber(), true);
            }
        }
    ]);
    return DynamicBytesCoder;
}((0, $ggjPf.Coder));
var $b7e55f4d821202a8$export$e5823e9574df18d2 = /*#__PURE__*/ function(DynamicBytesCoder) {
    (0, $ftJVG._)(BytesCoder, DynamicBytesCoder);
    var _super = (0, $6OZAO._)(BytesCoder);
    function BytesCoder(localName) {
        (0, $978gY._)(this, BytesCoder);
        return _super.call(this, "bytes", localName);
    }
    (0, $kry2a._)(BytesCoder, [
        {
            key: "decode",
            value: function decode(reader) {
                return reader.coerce(this.name, (0, $j2rU8.hexlify)((0, $3cct3._)((0, $g3d7z._)(BytesCoder.prototype), "decode", this).call(this, reader)));
            }
        }
    ]);
    return BytesCoder;
}($b7e55f4d821202a8$export$db9eadd8df12ad2e);

});
parcelRequire.register("3cct3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $253c29e4a8bc609b$export$afb3516d9d608401; });

var $i8pJC = parcelRequire("i8pJC");
function $253c29e4a8bc609b$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $253c29e4a8bc609b$export$afb3516d9d608401 = Reflect.get;
    else $253c29e4a8bc609b$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $i8pJC._super_prop_base)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $253c29e4a8bc609b$export$afb3516d9d608401(target, property, receiver || target);
}

});
parcelRequire.register("i8pJC", function(module, exports) {

$parcel$export(module.exports, "_super_prop_base", function () { return $d33cefbe4adc536f$export$e4187255aefbc259; });

var $g3d7z = parcelRequire("g3d7z");
function $d33cefbe4adc536f$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $g3d7z._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}

});



parcelRequire.register("jbYON", function(module, exports) {

$parcel$export(module.exports, "FixedBytesCoder", function () { return $df8e38a8c8e0bc75$export$7dec9db68e6bcf5a; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $j2rU8 = parcelRequire("j2rU8");

var $ggjPf = parcelRequire("ggjPf");
"use strict";
var $df8e38a8c8e0bc75$export$7dec9db68e6bcf5a = /*#__PURE__*/ function(Coder) {
    (0, $ftJVG._)(FixedBytesCoder, Coder);
    var _super = (0, $6OZAO._)(FixedBytesCoder);
    function FixedBytesCoder(size, localName) {
        (0, $978gY._)(this, FixedBytesCoder);
        var _this;
        var name = "bytes" + String(size);
        _this = _super.call(this, name, name, localName, false);
        _this.size = size;
        return _this;
    }
    (0, $kry2a._)(FixedBytesCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                var data = (0, $j2rU8.arrayify)(value);
                if (data.length !== this.size) this._throwError("incorrect data length", value);
                return writer.writeBytes(data);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return reader.coerce(this.name, (0, $j2rU8.hexlify)(reader.readBytes(this.size)));
            }
        }
    ]);
    return FixedBytesCoder;
}((0, $ggjPf.Coder));

});

parcelRequire.register("3Sede", function(module, exports) {

$parcel$export(module.exports, "NullCoder", function () { return $2d21708e754b0ab4$export$70982cadf2d6b4ec; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $ggjPf = parcelRequire("ggjPf");
"use strict";
var $2d21708e754b0ab4$export$70982cadf2d6b4ec = /*#__PURE__*/ function(Coder) {
    (0, $ftJVG._)(NullCoder, Coder);
    var _super = (0, $6OZAO._)(NullCoder);
    function NullCoder(localName) {
        (0, $978gY._)(this, NullCoder);
        return _super.call(this, "null", "", localName, false);
    }
    (0, $kry2a._)(NullCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return null;
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                if (value != null) this._throwError("not null", value);
                return writer.writeBytes([]);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                reader.readBytes(0);
                return reader.coerce(this.name, null);
            }
        }
    ]);
    return NullCoder;
}((0, $ggjPf.Coder));

});

parcelRequire.register("ggBgc", function(module, exports) {

$parcel$export(module.exports, "NumberCoder", function () { return $bd7b0b14ce22a0d4$export$b934dc8cfe13938c; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $gMArf = parcelRequire("gMArf");

var $f2VSc = parcelRequire("f2VSc");

var $ggjPf = parcelRequire("ggjPf");
"use strict";
var $bd7b0b14ce22a0d4$export$b934dc8cfe13938c = /*#__PURE__*/ function(Coder) {
    (0, $ftJVG._)(NumberCoder, Coder);
    var _super = (0, $6OZAO._)(NumberCoder);
    function NumberCoder(size, signed, localName) {
        (0, $978gY._)(this, NumberCoder);
        var _this;
        var name = (signed ? "int" : "uint") + size * 8;
        _this = _super.call(this, name, name, localName, false);
        _this.size = size;
        _this.signed = signed;
        return _this;
    }
    (0, $kry2a._)(NumberCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return 0;
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                var v = (0, $gMArf.BigNumber).from(value);
                // Check bounds are safe for encoding
                var maxUintValue = (0, $f2VSc.MaxUint256).mask(writer.wordSize * 8);
                if (this.signed) {
                    var bounds = maxUintValue.mask(this.size * 8 - 1);
                    if (v.gt(bounds) || v.lt(bounds.add((0, $f2VSc.One)).mul((0, $f2VSc.NegativeOne)))) this._throwError("value out-of-bounds", value);
                } else if (v.lt((0, $f2VSc.Zero)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
                v = v.toTwos(this.size * 8).mask(this.size * 8);
                if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
                return writer.writeValue(v);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                var value = reader.readValue().mask(this.size * 8);
                if (this.signed) value = value.fromTwos(this.size * 8);
                return reader.coerce(this.name, value);
            }
        }
    ]);
    return NumberCoder;
}((0, $ggjPf.Coder));

});
parcelRequire.register("f2VSc", function(module, exports) {

$parcel$export(module.exports, "NegativeOne", function () { return $af43ef4e381177e0$export$c83ef0909a6ddeec; });
$parcel$export(module.exports, "Zero", function () { return $af43ef4e381177e0$export$aaef8a3eae948f03; });
$parcel$export(module.exports, "One", function () { return $af43ef4e381177e0$export$9aa05a5866350bcf; });
$parcel$export(module.exports, "Two", function () { return $af43ef4e381177e0$export$9276dd97bf62cc8d; });
$parcel$export(module.exports, "WeiPerEther", function () { return $af43ef4e381177e0$export$c8db55bd7405209e; });
$parcel$export(module.exports, "MaxUint256", function () { return $af43ef4e381177e0$export$1b53890de5aabdd0; });
$parcel$export(module.exports, "MinInt256", function () { return $af43ef4e381177e0$export$963c9b9317b80aaf; });
$parcel$export(module.exports, "MaxInt256", function () { return $af43ef4e381177e0$export$6f8dbb07ebe6d738; });

var $gMArf = parcelRequire("gMArf");
var $af43ef4e381177e0$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $gMArf.BigNumber).from(-1);
var $af43ef4e381177e0$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $gMArf.BigNumber).from(0);
var $af43ef4e381177e0$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $gMArf.BigNumber).from(1);
var $af43ef4e381177e0$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $gMArf.BigNumber).from(2);
var $af43ef4e381177e0$export$c8db55bd7405209e = /*#__PURE__*/ (0, $gMArf.BigNumber).from("1000000000000000000");
var $af43ef4e381177e0$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $gMArf.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
var $af43ef4e381177e0$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $gMArf.BigNumber).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
var $af43ef4e381177e0$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $gMArf.BigNumber).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");

});


parcelRequire.register("4pr0F", function(module, exports) {

$parcel$export(module.exports, "StringCoder", function () { return $335e72c6451b9b9a$export$2d1b854518731426; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $1Wmc7 = parcelRequire("1Wmc7");

var $fMSbI = parcelRequire("fMSbI");
"use strict";
var $335e72c6451b9b9a$export$2d1b854518731426 = /*#__PURE__*/ function(DynamicBytesCoder) {
    (0, $ftJVG._)(StringCoder, DynamicBytesCoder);
    var _super = (0, $6OZAO._)(StringCoder);
    function StringCoder(localName) {
        (0, $978gY._)(this, StringCoder);
        return _super.call(this, "string", localName);
    }
    (0, $kry2a._)(StringCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return "";
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                return (0, $3cct3._)((0, $g3d7z._)(StringCoder.prototype), "encode", this).call(this, writer, (0, $1Wmc7.toUtf8Bytes)(value));
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return (0, $1Wmc7.toUtf8String)((0, $3cct3._)((0, $g3d7z._)(StringCoder.prototype), "decode", this).call(this, reader));
            }
        }
    ]);
    return StringCoder;
}((0, $fMSbI.DynamicBytesCoder));

});
parcelRequire.register("1Wmc7", function(module, exports) {

$parcel$export(module.exports, "UnicodeNormalizationForm", function () { return $169c6c93221d2e48$export$c6986442964129f5; });
$parcel$export(module.exports, "Utf8ErrorReason", function () { return $169c6c93221d2e48$export$c285fa6ac15ff6a6; });
$parcel$export(module.exports, "Utf8ErrorFuncs", function () { return $169c6c93221d2e48$export$c6e2180c5bb5bc05; });
$parcel$export(module.exports, "toUtf8Bytes", function () { return $169c6c93221d2e48$export$8feeb310b4b4752f; });
$parcel$export(module.exports, "_toEscapedUtf8String", function () { return $169c6c93221d2e48$export$a7a0ec15960b9055; });
$parcel$export(module.exports, "_toUtf8String", function () { return $169c6c93221d2e48$export$232e1dab03132235; });
$parcel$export(module.exports, "toUtf8String", function () { return $169c6c93221d2e48$export$7643a1dc2c38d5eb; });
$parcel$export(module.exports, "toUtf8CodePoints", function () { return $169c6c93221d2e48$export$ae470a36a31b28c2; });

var $j2rU8 = parcelRequire("j2rU8");

var $6M65e = parcelRequire("6M65e");

var $ed1KV = parcelRequire("ed1KV");
"use strict";
var $169c6c93221d2e48$var$logger = new (0, $6M65e.Logger)((0, $ed1KV.version));
var $169c6c93221d2e48$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($169c6c93221d2e48$export$c6986442964129f5 || ($169c6c93221d2e48$export$c6986442964129f5 = {}));
var $169c6c93221d2e48$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($169c6c93221d2e48$export$c285fa6ac15ff6a6 || ($169c6c93221d2e48$export$c285fa6ac15ff6a6 = {}));
function $169c6c93221d2e48$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $169c6c93221d2e48$var$logger.throwArgumentError("invalid codepoint at offset ".concat(offset, "; ").concat(reason), "bytes", bytes);
}
function $169c6c93221d2e48$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $169c6c93221d2e48$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $169c6c93221d2e48$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        var i = 0;
        for(var o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $169c6c93221d2e48$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $169c6c93221d2e48$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $169c6c93221d2e48$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $169c6c93221d2e48$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
var $169c6c93221d2e48$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $169c6c93221d2e48$var$errorFunc,
    ignore: $169c6c93221d2e48$var$ignoreFunc,
    replace: $169c6c93221d2e48$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $169c6c93221d2e48$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $169c6c93221d2e48$export$c6e2180c5bb5bc05.error;
    bytes = (0, $j2rU8.arrayify)(bytes);
    var result = [];
    var i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        var c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        var extraLength = null;
        var overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        var res = c & (1 << 8 - extraLength - 1) - 1;
        for(var j = 0; j < extraLength; j++){
            var nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $169c6c93221d2e48$export$8feeb310b4b4752f(str) {
    var form = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $169c6c93221d2e48$export$c6986442964129f5.current;
    if (form != $169c6c93221d2e48$export$c6986442964129f5.current) {
        $169c6c93221d2e48$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    var result = [];
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            var c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            var pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $j2rU8.arrayify)(result);
}
function $169c6c93221d2e48$var$escapeChar(value) {
    var hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $169c6c93221d2e48$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $169c6c93221d2e48$var$getUtf8CodePoints(bytes, onError).map(function(codePoint) {
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $169c6c93221d2e48$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $169c6c93221d2e48$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $169c6c93221d2e48$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $169c6c93221d2e48$export$232e1dab03132235(codePoints) {
    return codePoints.map(function(codePoint) {
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $169c6c93221d2e48$export$7643a1dc2c38d5eb(bytes, onError) {
    return $169c6c93221d2e48$export$232e1dab03132235($169c6c93221d2e48$var$getUtf8CodePoints(bytes, onError));
}
function $169c6c93221d2e48$export$ae470a36a31b28c2(str) {
    var form = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $169c6c93221d2e48$export$c6986442964129f5.current;
    return $169c6c93221d2e48$var$getUtf8CodePoints($169c6c93221d2e48$export$8feeb310b4b4752f(str, form));
}

});
parcelRequire.register("ed1KV", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $a583a447fefad3f0$export$83d89fbfd8236492; });
var $a583a447fefad3f0$export$83d89fbfd8236492 = "strings/5.7.0";

});



parcelRequire.register("i57uN", function(module, exports) {

$parcel$export(module.exports, "TupleCoder", function () { return $d29e821f1f0ced09$export$e9fceba8f110fea6; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $ggjPf = parcelRequire("ggjPf");

var $6qcrc = parcelRequire("6qcrc");
"use strict";
var $d29e821f1f0ced09$export$e9fceba8f110fea6 = /*#__PURE__*/ function(Coder) {
    (0, $ftJVG._)(TupleCoder, Coder);
    var _super = (0, $6OZAO._)(TupleCoder);
    function TupleCoder(coders, localName) {
        (0, $978gY._)(this, TupleCoder);
        var _this;
        var dynamic = false;
        var types = [];
        coders.forEach(function(coder) {
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        var type = "tuple(" + types.join(",") + ")";
        _this = _super.call(this, "tuple", type, localName, dynamic);
        _this.coders = coders;
        return _this;
    }
    (0, $kry2a._)(TupleCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                var values = [];
                this.coders.forEach(function(coder) {
                    values.push(coder.defaultValue());
                });
                // We only output named properties for uniquely named coders
                var uniqueNames = this.coders.reduce(function(accum, coder) {
                    var name = coder.localName;
                    if (name) {
                        if (!accum[name]) accum[name] = 0;
                        accum[name]++;
                    }
                    return accum;
                }, {});
                // Add named values
                this.coders.forEach(function(coder, index) {
                    var name = coder.localName;
                    if (!name || uniqueNames[name] !== 1) return;
                    if (name === "length") name = "_length";
                    if (values[name] != null) return;
                    values[name] = values[index];
                });
                return Object.freeze(values);
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                return (0, $6qcrc.pack)(writer, this.coders, value);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return reader.coerce(this.name, (0, $6qcrc.unpack)(reader, this.coders));
            }
        }
    ]);
    return TupleCoder;
}((0, $ggjPf.Coder));

});

parcelRequire.register("6CFiK", function(module, exports) {

$parcel$export(module.exports, "FormatTypes", function () { return $4d2654448f804eaa$export$f010f239efc4d445; });
$parcel$export(module.exports, "ParamType", function () { return $4d2654448f804eaa$export$426dc07f493a4c47; });
$parcel$export(module.exports, "Fragment", function () { return $4d2654448f804eaa$export$ffb0004e005737fa; });
$parcel$export(module.exports, "FunctionFragment", function () { return $4d2654448f804eaa$export$8d576c928b93668f; });
$parcel$export(module.exports, "EventFragment", function () { return $4d2654448f804eaa$export$958548f08bac2833; });
$parcel$export(module.exports, "ConstructorFragment", function () { return $4d2654448f804eaa$export$3ac5c9504f801ea4; });
$parcel$export(module.exports, "ErrorFragment", function () { return $4d2654448f804eaa$export$2c42c6d543aa9b59; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $gMArf = parcelRequire("gMArf");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $ij6uS = parcelRequire("ij6uS");
"use strict";
var $4d2654448f804eaa$var$logger = new (0, $6M65e.Logger)((0, $ij6uS.version));
var $4d2654448f804eaa$var$_constructorGuard = {};
var $4d2654448f804eaa$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
var $4d2654448f804eaa$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $4d2654448f804eaa$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($4d2654448f804eaa$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($4d2654448f804eaa$var$ModifiersNest[name]) return true;
    }
    if ($4d2654448f804eaa$var$ModifiersBytes[name] || name === "payable") $4d2654448f804eaa$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $4d2654448f804eaa$var$parseParamType(param, allowIndexed) {
    var throwError = function throwError(i) {
        $4d2654448f804eaa$var$logger.throwArgumentError("unexpected character at position ".concat(i), "param", param);
    };
    var newNode = function newNode(parent) {
        var node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    };
    var originalParam = param;
    param = param.replace(/\s/g, " ");
    var parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    var node = parent;
    for(var i = 0; i < param.length; i++){
        var c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $4d2654448f804eaa$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($4d2654448f804eaa$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $4d2654448f804eaa$var$verifyType(node.type);
                var child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($4d2654448f804eaa$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $4d2654448f804eaa$var$verifyType(node.type);
                var sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $4d2654448f804eaa$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($4d2654448f804eaa$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $4d2654448f804eaa$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($4d2654448f804eaa$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $4d2654448f804eaa$var$verifyType(parent.type);
    return parent;
}
function $4d2654448f804eaa$var$populate(object, params) {
    for(var key in params)(0, $2ax4w.defineReadOnly)(object, key, params[key]);
}
var $4d2654448f804eaa$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
var $4d2654448f804eaa$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
var $4d2654448f804eaa$export$426dc07f493a4c47 = /*#__PURE__*/ function() {
    function ParamType(constructorGuard, params) {
        (0, $978gY._)(this, ParamType);
        if (constructorGuard !== $4d2654448f804eaa$var$_constructorGuard) $4d2654448f804eaa$var$logger.throwError("use fromString", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $4d2654448f804eaa$var$populate(this, params);
        var match = this.type.match($4d2654448f804eaa$var$paramTypeArray);
        if (match) $4d2654448f804eaa$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: ParamType.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $4d2654448f804eaa$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    (0, $kry2a._)(ParamType, [
        {
            // Format the parameter fragment
            //   - sighash: "(uint256,address)"
            //   - minimal: "tuple(uint256,address) indexed"
            //   - full:    "tuple(uint256 foo, address bar) indexed baz"
            key: "format",
            value: function format(format) {
                if (!format) format = $4d2654448f804eaa$export$f010f239efc4d445.sighash;
                if (!$4d2654448f804eaa$export$f010f239efc4d445[format]) $4d2654448f804eaa$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $4d2654448f804eaa$export$f010f239efc4d445.json) {
                    var result = {
                        type: this.baseType === "tuple" ? "tuple" : this.type,
                        name: this.name || undefined
                    };
                    if (typeof this.indexed === "boolean") result.indexed = this.indexed;
                    if (this.components) result.components = this.components.map(function(comp) {
                        return JSON.parse(comp.format(format));
                    });
                    return JSON.stringify(result);
                }
                var result1 = "";
                // Array
                if (this.baseType === "array") {
                    result1 += this.arrayChildren.format(format);
                    result1 += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
                } else if (this.baseType === "tuple") {
                    if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) result1 += this.type;
                    result1 += "(" + this.components.map(function(comp) {
                        return comp.format(format);
                    }).join(format === $4d2654448f804eaa$export$f010f239efc4d445.full ? ", " : ",") + ")";
                } else result1 += this.type;
                if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) {
                    if (this.indexed === true) result1 += " indexed";
                    if (format === $4d2654448f804eaa$export$f010f239efc4d445.full && this.name) result1 += " " + this.name;
                }
                return result1;
            }
        }
    ], [
        {
            key: "from",
            value: function from(value, allowIndexed) {
                if (typeof value === "string") return ParamType.fromString(value, allowIndexed);
                return ParamType.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (ParamType.isParamType(value)) return value;
                return new ParamType($4d2654448f804eaa$var$_constructorGuard, {
                    name: value.name || null,
                    type: $4d2654448f804eaa$var$verifyType(value.type),
                    indexed: value.indexed == null ? null : !!value.indexed,
                    components: value.components ? value.components.map(ParamType.fromObject) : null
                });
            }
        },
        {
            key: "fromString",
            value: function fromString(value, allowIndexed) {
                var ParamTypify = function ParamTypify(node) {
                    return ParamType.fromObject({
                        name: node.name,
                        type: node.type,
                        indexed: node.indexed,
                        components: node.components
                    });
                };
                return ParamTypify($4d2654448f804eaa$var$parseParamType(value, !!allowIndexed));
            }
        },
        {
            key: "isParamType",
            value: function isParamType(value) {
                return !!(value != null && value._isParamType);
            }
        }
    ]);
    return ParamType;
}();
function $4d2654448f804eaa$var$parseParams(value, allowIndex) {
    return $4d2654448f804eaa$var$splitNesting(value).map(function(param) {
        return $4d2654448f804eaa$export$426dc07f493a4c47.fromString(param, allowIndex);
    });
}
var $4d2654448f804eaa$export$ffb0004e005737fa = /*#__PURE__*/ function() {
    function Fragment(constructorGuard, params) {
        (0, $978gY._)(this, Fragment);
        if (constructorGuard !== $4d2654448f804eaa$var$_constructorGuard) $4d2654448f804eaa$var$logger.throwError("use a static from method", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $4d2654448f804eaa$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    (0, $kry2a._)(Fragment, null, [
        {
            key: "from",
            value: function from(value) {
                if (Fragment.isFragment(value)) return value;
                if (typeof value === "string") return Fragment.fromString(value);
                return Fragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (Fragment.isFragment(value)) return value;
                switch(value.type){
                    case "function":
                        return $4d2654448f804eaa$export$8d576c928b93668f.fromObject(value);
                    case "event":
                        return $4d2654448f804eaa$export$958548f08bac2833.fromObject(value);
                    case "constructor":
                        return $4d2654448f804eaa$export$3ac5c9504f801ea4.fromObject(value);
                    case "error":
                        return $4d2654448f804eaa$export$2c42c6d543aa9b59.fromObject(value);
                    case "fallback":
                    case "receive":
                        // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                        return null;
                }
                return $4d2654448f804eaa$var$logger.throwArgumentError("invalid fragment object", "value", value);
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
                value = value.replace(/\s/g, " ");
                value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
                value = value.trim();
                if (value.split(" ")[0] === "event") return $4d2654448f804eaa$export$958548f08bac2833.fromString(value.substring(5).trim());
                else if (value.split(" ")[0] === "function") return $4d2654448f804eaa$export$8d576c928b93668f.fromString(value.substring(8).trim());
                else if (value.split("(")[0].trim() === "constructor") return $4d2654448f804eaa$export$3ac5c9504f801ea4.fromString(value.trim());
                else if (value.split(" ")[0] === "error") return $4d2654448f804eaa$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
                return $4d2654448f804eaa$var$logger.throwArgumentError("unsupported fragment", "value", value);
            }
        },
        {
            key: "isFragment",
            value: function isFragment(value) {
                return !!(value && value._isFragment);
            }
        }
    ]);
    return Fragment;
}();
var $4d2654448f804eaa$export$958548f08bac2833 = /*#__PURE__*/ function(Fragment) {
    (0, $ftJVG._)(EventFragment, Fragment);
    var _super = (0, $6OZAO._)(EventFragment);
    function EventFragment() {
        (0, $978gY._)(this, EventFragment);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(EventFragment, [
        {
            key: "format",
            value: function format(format) {
                if (!format) format = $4d2654448f804eaa$export$f010f239efc4d445.sighash;
                if (!$4d2654448f804eaa$export$f010f239efc4d445[format]) $4d2654448f804eaa$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $4d2654448f804eaa$export$f010f239efc4d445.json) return JSON.stringify({
                    type: "event",
                    anonymous: this.anonymous,
                    name: this.name,
                    inputs: this.inputs.map(function(input) {
                        return JSON.parse(input.format(format));
                    })
                });
                var result = "";
                if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) result += "event ";
                result += this.name + "(" + this.inputs.map(function(input) {
                    return input.format(format);
                }).join(format === $4d2654448f804eaa$export$f010f239efc4d445.full ? ", " : ",") + ") ";
                if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) {
                    if (this.anonymous) result += "anonymous ";
                }
                return result.trim();
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return EventFragment.fromString(value);
                return EventFragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (EventFragment.isEventFragment(value)) return value;
                if (value.type !== "event") $4d2654448f804eaa$var$logger.throwArgumentError("invalid event object", "value", value);
                var params = {
                    name: $4d2654448f804eaa$var$verifyIdentifier(value.name),
                    anonymous: value.anonymous,
                    inputs: value.inputs ? value.inputs.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : [],
                    type: "event"
                };
                return new EventFragment($4d2654448f804eaa$var$_constructorGuard, params);
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                var match = value.match($4d2654448f804eaa$var$regexParen);
                if (!match) $4d2654448f804eaa$var$logger.throwArgumentError("invalid event string", "value", value);
                var anonymous = false;
                match[3].split(" ").forEach(function(modifier) {
                    switch(modifier.trim()){
                        case "anonymous":
                            anonymous = true;
                            break;
                        case "":
                            break;
                        default:
                            $4d2654448f804eaa$var$logger.warn("unknown modifier: " + modifier);
                    }
                });
                return EventFragment.fromObject({
                    name: match[1].trim(),
                    anonymous: anonymous,
                    inputs: $4d2654448f804eaa$var$parseParams(match[2], true),
                    type: "event"
                });
            }
        },
        {
            key: "isEventFragment",
            value: function isEventFragment(value) {
                return value && value._isFragment && value.type === "event";
            }
        }
    ]);
    return EventFragment;
}($4d2654448f804eaa$export$ffb0004e005737fa);
function $4d2654448f804eaa$var$parseGas(value, params) {
    params.gas = null;
    var comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $4d2654448f804eaa$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $4d2654448f804eaa$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $gMArf.BigNumber).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $4d2654448f804eaa$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach(function(modifier) {
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $4d2654448f804eaa$var$verifyState(value) {
    var result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $4d2654448f804eaa$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $4d2654448f804eaa$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $4d2654448f804eaa$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $4d2654448f804eaa$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $4d2654448f804eaa$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
var $4d2654448f804eaa$export$3ac5c9504f801ea4 = /*#__PURE__*/ function(Fragment) {
    (0, $ftJVG._)(ConstructorFragment, Fragment);
    var _super = (0, $6OZAO._)(ConstructorFragment);
    function ConstructorFragment() {
        (0, $978gY._)(this, ConstructorFragment);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ConstructorFragment, [
        {
            key: "format",
            value: function format(format) {
                if (!format) format = $4d2654448f804eaa$export$f010f239efc4d445.sighash;
                if (!$4d2654448f804eaa$export$f010f239efc4d445[format]) $4d2654448f804eaa$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $4d2654448f804eaa$export$f010f239efc4d445.json) return JSON.stringify({
                    type: "constructor",
                    stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
                    payable: this.payable,
                    gas: this.gas ? this.gas.toNumber() : undefined,
                    inputs: this.inputs.map(function(input) {
                        return JSON.parse(input.format(format));
                    })
                });
                if (format === $4d2654448f804eaa$export$f010f239efc4d445.sighash) $4d2654448f804eaa$var$logger.throwError("cannot format a constructor for sighash", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "format(sighash)"
                });
                var result = "constructor(" + this.inputs.map(function(input) {
                    return input.format(format);
                }).join(format === $4d2654448f804eaa$export$f010f239efc4d445.full ? ", " : ",") + ") ";
                if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
                return result.trim();
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return ConstructorFragment.fromString(value);
                return ConstructorFragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (ConstructorFragment.isConstructorFragment(value)) return value;
                if (value.type !== "constructor") $4d2654448f804eaa$var$logger.throwArgumentError("invalid constructor object", "value", value);
                var state = $4d2654448f804eaa$var$verifyState(value);
                if (state.constant) $4d2654448f804eaa$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
                var params = {
                    name: null,
                    type: value.type,
                    inputs: value.inputs ? value.inputs.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : [],
                    payable: state.payable,
                    stateMutability: state.stateMutability,
                    gas: value.gas ? (0, $gMArf.BigNumber).from(value.gas) : null
                };
                return new ConstructorFragment($4d2654448f804eaa$var$_constructorGuard, params);
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                var params = {
                    type: "constructor"
                };
                value = $4d2654448f804eaa$var$parseGas(value, params);
                var parens = value.match($4d2654448f804eaa$var$regexParen);
                if (!parens || parens[1].trim() !== "constructor") $4d2654448f804eaa$var$logger.throwArgumentError("invalid constructor string", "value", value);
                params.inputs = $4d2654448f804eaa$var$parseParams(parens[2].trim(), false);
                $4d2654448f804eaa$var$parseModifiers(parens[3].trim(), params);
                return ConstructorFragment.fromObject(params);
            }
        },
        {
            key: "isConstructorFragment",
            value: function isConstructorFragment(value) {
                return value && value._isFragment && value.type === "constructor";
            }
        }
    ]);
    return ConstructorFragment;
}($4d2654448f804eaa$export$ffb0004e005737fa);
var $4d2654448f804eaa$export$8d576c928b93668f = /*#__PURE__*/ function(ConstructorFragment) {
    (0, $ftJVG._)(FunctionFragment, ConstructorFragment);
    var _super = (0, $6OZAO._)(FunctionFragment);
    function FunctionFragment() {
        (0, $978gY._)(this, FunctionFragment);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(FunctionFragment, [
        {
            key: "format",
            value: function format(format) {
                if (!format) format = $4d2654448f804eaa$export$f010f239efc4d445.sighash;
                if (!$4d2654448f804eaa$export$f010f239efc4d445[format]) $4d2654448f804eaa$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $4d2654448f804eaa$export$f010f239efc4d445.json) return JSON.stringify({
                    type: "function",
                    name: this.name,
                    constant: this.constant,
                    stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
                    payable: this.payable,
                    gas: this.gas ? this.gas.toNumber() : undefined,
                    inputs: this.inputs.map(function(input) {
                        return JSON.parse(input.format(format));
                    }),
                    outputs: this.outputs.map(function(output) {
                        return JSON.parse(output.format(format));
                    })
                });
                var result = "";
                if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) result += "function ";
                result += this.name + "(" + this.inputs.map(function(input) {
                    return input.format(format);
                }).join(format === $4d2654448f804eaa$export$f010f239efc4d445.full ? ", " : ",") + ") ";
                if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) {
                    if (this.stateMutability) {
                        if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
                    } else if (this.constant) result += "view ";
                    if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map(function(output) {
                        return output.format(format);
                    }).join(", ") + ") ";
                    if (this.gas != null) result += "@" + this.gas.toString() + " ";
                }
                return result.trim();
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return FunctionFragment.fromString(value);
                return FunctionFragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (FunctionFragment.isFunctionFragment(value)) return value;
                if (value.type !== "function") $4d2654448f804eaa$var$logger.throwArgumentError("invalid function object", "value", value);
                var state = $4d2654448f804eaa$var$verifyState(value);
                var params = {
                    type: value.type,
                    name: $4d2654448f804eaa$var$verifyIdentifier(value.name),
                    constant: state.constant,
                    inputs: value.inputs ? value.inputs.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : [],
                    outputs: value.outputs ? value.outputs.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : [],
                    payable: state.payable,
                    stateMutability: state.stateMutability,
                    gas: value.gas ? (0, $gMArf.BigNumber).from(value.gas) : null
                };
                return new FunctionFragment($4d2654448f804eaa$var$_constructorGuard, params);
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                var params = {
                    type: "function"
                };
                value = $4d2654448f804eaa$var$parseGas(value, params);
                var comps = value.split(" returns ");
                if (comps.length > 2) $4d2654448f804eaa$var$logger.throwArgumentError("invalid function string", "value", value);
                var parens = comps[0].match($4d2654448f804eaa$var$regexParen);
                if (!parens) $4d2654448f804eaa$var$logger.throwArgumentError("invalid function signature", "value", value);
                params.name = parens[1].trim();
                if (params.name) $4d2654448f804eaa$var$verifyIdentifier(params.name);
                params.inputs = $4d2654448f804eaa$var$parseParams(parens[2], false);
                $4d2654448f804eaa$var$parseModifiers(parens[3].trim(), params);
                // We have outputs
                if (comps.length > 1) {
                    var returns = comps[1].match($4d2654448f804eaa$var$regexParen);
                    if (returns[1].trim() != "" || returns[3].trim() != "") $4d2654448f804eaa$var$logger.throwArgumentError("unexpected tokens", "value", value);
                    params.outputs = $4d2654448f804eaa$var$parseParams(returns[2], false);
                } else params.outputs = [];
                return FunctionFragment.fromObject(params);
            }
        },
        {
            key: "isFunctionFragment",
            value: function isFunctionFragment(value) {
                return value && value._isFragment && value.type === "function";
            }
        }
    ]);
    return FunctionFragment;
}($4d2654448f804eaa$export$3ac5c9504f801ea4);
//export class StructFragment extends Fragment {
//}
function $4d2654448f804eaa$var$checkForbidden(fragment) {
    var sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $4d2654448f804eaa$var$logger.throwArgumentError("cannot specify user defined ".concat(sig, " error"), "fragment", fragment);
    return fragment;
}
var $4d2654448f804eaa$export$2c42c6d543aa9b59 = /*#__PURE__*/ function(Fragment) {
    (0, $ftJVG._)(ErrorFragment, Fragment);
    var _super = (0, $6OZAO._)(ErrorFragment);
    function ErrorFragment() {
        (0, $978gY._)(this, ErrorFragment);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ErrorFragment, [
        {
            key: "format",
            value: function format(format) {
                if (!format) format = $4d2654448f804eaa$export$f010f239efc4d445.sighash;
                if (!$4d2654448f804eaa$export$f010f239efc4d445[format]) $4d2654448f804eaa$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $4d2654448f804eaa$export$f010f239efc4d445.json) return JSON.stringify({
                    type: "error",
                    name: this.name,
                    inputs: this.inputs.map(function(input) {
                        return JSON.parse(input.format(format));
                    })
                });
                var result = "";
                if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) result += "error ";
                result += this.name + "(" + this.inputs.map(function(input) {
                    return input.format(format);
                }).join(format === $4d2654448f804eaa$export$f010f239efc4d445.full ? ", " : ",") + ") ";
                return result.trim();
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return ErrorFragment.fromString(value);
                return ErrorFragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (ErrorFragment.isErrorFragment(value)) return value;
                if (value.type !== "error") $4d2654448f804eaa$var$logger.throwArgumentError("invalid error object", "value", value);
                var params = {
                    type: value.type,
                    name: $4d2654448f804eaa$var$verifyIdentifier(value.name),
                    inputs: value.inputs ? value.inputs.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : []
                };
                return $4d2654448f804eaa$var$checkForbidden(new ErrorFragment($4d2654448f804eaa$var$_constructorGuard, params));
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                var params = {
                    type: "error"
                };
                var parens = value.match($4d2654448f804eaa$var$regexParen);
                if (!parens) $4d2654448f804eaa$var$logger.throwArgumentError("invalid error signature", "value", value);
                params.name = parens[1].trim();
                if (params.name) $4d2654448f804eaa$var$verifyIdentifier(params.name);
                params.inputs = $4d2654448f804eaa$var$parseParams(parens[2], false);
                return $4d2654448f804eaa$var$checkForbidden(ErrorFragment.fromObject(params));
            }
        },
        {
            key: "isErrorFragment",
            value: function isErrorFragment(value) {
                return value && value._isFragment && value.type === "error";
            }
        }
    ]);
    return ErrorFragment;
}($4d2654448f804eaa$export$ffb0004e005737fa);
function $4d2654448f804eaa$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
var $4d2654448f804eaa$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $4d2654448f804eaa$var$verifyIdentifier(value) {
    if (!value || !value.match($4d2654448f804eaa$var$regexIdentifier)) $4d2654448f804eaa$var$logger.throwArgumentError('invalid identifier "'.concat(value, '"'), "value", value);
    return value;
}
var $4d2654448f804eaa$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $4d2654448f804eaa$var$splitNesting(value) {
    value = value.trim();
    var result = [];
    var accum = "";
    var depth = 0;
    for(var offset = 0; offset < value.length; offset++){
        var c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $4d2654448f804eaa$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}

});


parcelRequire.register("9rkfU", function(module, exports) {

$parcel$export(module.exports, "LogDescription", function () { return $6df659078ac9448c$export$c2ab6499be98b3c5; });
$parcel$export(module.exports, "TransactionDescription", function () { return $6df659078ac9448c$export$7a3223b0fadb690b; });
$parcel$export(module.exports, "Indexed", function () { return $6df659078ac9448c$export$8ef99100a3c56f8c; });
$parcel$export(module.exports, "Interface", function () { return $6df659078ac9448c$export$48cefb51a4e315b2; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $e8NrM = parcelRequire("e8NrM");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $4q6En = parcelRequire("4q6En");

var $4ujqV = parcelRequire("4ujqV");

var $2ax4w = parcelRequire("2ax4w");

var $yKVLS = parcelRequire("yKVLS");

var $ggjPf = parcelRequire("ggjPf");

var $6CFiK = parcelRequire("6CFiK");

var $6M65e = parcelRequire("6M65e");

var $ij6uS = parcelRequire("ij6uS");
"use strict";
var $6df659078ac9448c$var$logger = new (0, $6M65e.Logger)((0, $ij6uS.version));
var $6df659078ac9448c$export$c2ab6499be98b3c5 = /*#__PURE__*/ function(Description) {
    (0, $ftJVG._)(LogDescription, Description);
    var _super = (0, $6OZAO._)(LogDescription);
    function LogDescription() {
        (0, $978gY._)(this, LogDescription);
        return _super.apply(this, arguments);
    }
    return LogDescription;
}((0, $2ax4w.Description));
var $6df659078ac9448c$export$7a3223b0fadb690b = /*#__PURE__*/ function(Description) {
    (0, $ftJVG._)(TransactionDescription, Description);
    var _super = (0, $6OZAO._)(TransactionDescription);
    function TransactionDescription() {
        (0, $978gY._)(this, TransactionDescription);
        return _super.apply(this, arguments);
    }
    return TransactionDescription;
}((0, $2ax4w.Description));
var $6df659078ac9448c$export$cfba08fc0e40e2ab = /*#__PURE__*/ function(Description) {
    (0, $ftJVG._)(ErrorDescription, Description);
    var _super = (0, $6OZAO._)(ErrorDescription);
    function ErrorDescription() {
        (0, $978gY._)(this, ErrorDescription);
        return _super.apply(this, arguments);
    }
    return ErrorDescription;
}((0, $2ax4w.Description));
var $6df659078ac9448c$export$8ef99100a3c56f8c = /*#__PURE__*/ function(Description) {
    (0, $ftJVG._)(Indexed, Description);
    var _super = (0, $6OZAO._)(Indexed);
    function Indexed() {
        (0, $978gY._)(this, Indexed);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(Indexed, null, [
        {
            key: "isIndexed",
            value: function isIndexed(value) {
                return !!(value && value._isIndexed);
            }
        }
    ]);
    return Indexed;
}((0, $2ax4w.Description));
var $6df659078ac9448c$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $6df659078ac9448c$var$wrapAccessError(property, error) {
    var wrap = new Error("deferred error during ABI decoding triggered accessing ".concat(property));
    wrap.error = error;
    return wrap;
}
var $6df659078ac9448c$export$48cefb51a4e315b2 = /*#__PURE__*/ function _target() {
    function Interface(fragments) {
        var _this = this;
        (0, $978gY._)(this, Interface);
        var abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $2ax4w.defineReadOnly)(this, "fragments", abi.map(function(fragment) {
            return (0, $6CFiK.Fragment).from(fragment);
        }).filter(function(fragment) {
            return fragment != null;
        }));
        (0, $2ax4w.defineReadOnly)(this, "_abiCoder", (0, $2ax4w.getStatic)(this instanceof Interface ? this.constructor : void 0, "getAbiCoder")());
        (0, $2ax4w.defineReadOnly)(this, "functions", {});
        (0, $2ax4w.defineReadOnly)(this, "errors", {});
        (0, $2ax4w.defineReadOnly)(this, "events", {});
        (0, $2ax4w.defineReadOnly)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach(function(fragment) {
            var bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (_this.deploy) {
                        $6df659078ac9448c$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $2ax4w.defineReadOnly)(_this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = _this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = _this.events;
                    break;
                case "error":
                    bucket = _this.errors;
                    break;
                default:
                    return;
            }
            var signature = fragment.format();
            if (bucket[signature]) {
                $6df659078ac9448c$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $2ax4w.defineReadOnly)(this, "deploy", (0, $6CFiK.ConstructorFragment).from({
            payable: false,
            type: "constructor"
        }));
        (0, $2ax4w.defineReadOnly)(this, "_isInterface", true);
    }
    (0, $kry2a._)(Interface, [
        {
            key: "format",
            value: function format(_format) {
                if (!_format) _format = (0, $6CFiK.FormatTypes).full;
                if (_format === (0, $6CFiK.FormatTypes).sighash) $6df659078ac9448c$var$logger.throwArgumentError("interface does not support formatting sighash", "format", _format);
                var abi = this.fragments.map(function(fragment) {
                    return fragment.format(_format);
                });
                // We need to re-bundle the JSON fragments a bit
                if (_format === (0, $6CFiK.FormatTypes).json) return JSON.stringify(abi.map(function(j) {
                    return JSON.parse(j);
                }));
                return abi;
            }
        },
        {
            // Find a function definition by any means necessary (unless it is ambiguous)
            key: "getFunction",
            value: function getFunction(nameOrSignatureOrSighash) {
                if ((0, $j2rU8.isHexString)(nameOrSignatureOrSighash)) {
                    for(var name in this.functions){
                        if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
                    }
                    $6df659078ac9448c$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
                }
                // It is a bare name, look up the function (will return null if ambiguous)
                if (nameOrSignatureOrSighash.indexOf("(") === -1) {
                    var name1 = nameOrSignatureOrSighash.trim();
                    var matching = Object.keys(this.functions).filter(function(f) {
                        return f.split("(" /* fix:) */ )[0] === name1;
                    });
                    if (matching.length === 0) $6df659078ac9448c$var$logger.throwArgumentError("no matching function", "name", name1);
                    else if (matching.length > 1) $6df659078ac9448c$var$logger.throwArgumentError("multiple matching functions", "name", name1);
                    return this.functions[matching[0]];
                }
                // Normalize the signature and lookup the function
                var result = this.functions[(0, $6CFiK.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
                if (!result) $6df659078ac9448c$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
                return result;
            }
        },
        {
            // Find an event definition by any means necessary (unless it is ambiguous)
            key: "getEvent",
            value: function getEvent(nameOrSignatureOrTopic) {
                if ((0, $j2rU8.isHexString)(nameOrSignatureOrTopic)) {
                    var topichash = nameOrSignatureOrTopic.toLowerCase();
                    for(var name in this.events){
                        if (topichash === this.getEventTopic(name)) return this.events[name];
                    }
                    $6df659078ac9448c$var$logger.throwArgumentError("no matching event", "topichash", topichash);
                }
                // It is a bare name, look up the function (will return null if ambiguous)
                if (nameOrSignatureOrTopic.indexOf("(") === -1) {
                    var name1 = nameOrSignatureOrTopic.trim();
                    var matching = Object.keys(this.events).filter(function(f) {
                        return f.split("(" /* fix:) */ )[0] === name1;
                    });
                    if (matching.length === 0) $6df659078ac9448c$var$logger.throwArgumentError("no matching event", "name", name1);
                    else if (matching.length > 1) $6df659078ac9448c$var$logger.throwArgumentError("multiple matching events", "name", name1);
                    return this.events[matching[0]];
                }
                // Normalize the signature and lookup the function
                var result = this.events[(0, $6CFiK.EventFragment).fromString(nameOrSignatureOrTopic).format()];
                if (!result) $6df659078ac9448c$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
                return result;
            }
        },
        {
            // Find a function definition by any means necessary (unless it is ambiguous)
            key: "getError",
            value: function getError(nameOrSignatureOrSighash) {
                if ((0, $j2rU8.isHexString)(nameOrSignatureOrSighash)) {
                    var getSighash = (0, $2ax4w.getStatic)(this.constructor, "getSighash");
                    for(var name in this.errors){
                        var error = this.errors[name];
                        if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
                    }
                    $6df659078ac9448c$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
                }
                // It is a bare name, look up the function (will return null if ambiguous)
                if (nameOrSignatureOrSighash.indexOf("(") === -1) {
                    var name1 = nameOrSignatureOrSighash.trim();
                    var matching = Object.keys(this.errors).filter(function(f) {
                        return f.split("(" /* fix:) */ )[0] === name1;
                    });
                    if (matching.length === 0) $6df659078ac9448c$var$logger.throwArgumentError("no matching error", "name", name1);
                    else if (matching.length > 1) $6df659078ac9448c$var$logger.throwArgumentError("multiple matching errors", "name", name1);
                    return this.errors[matching[0]];
                }
                // Normalize the signature and lookup the function
                var result = this.errors[(0, $6CFiK.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
                if (!result) $6df659078ac9448c$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
                return result;
            }
        },
        {
            // Get the sighash (the bytes4 selector) used by Solidity to identify a function
            key: "getSighash",
            value: function getSighash(fragment) {
                if (typeof fragment === "string") try {
                    fragment = this.getFunction(fragment);
                } catch (error) {
                    try {
                        fragment = this.getError(fragment);
                    } catch (_) {
                        throw error;
                    }
                }
                return (0, $2ax4w.getStatic)(this.constructor, "getSighash")(fragment);
            }
        },
        {
            // Get the topic (the bytes32 hash) used by Solidity to identify an event
            key: "getEventTopic",
            value: function getEventTopic(eventFragment) {
                if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
                return (0, $2ax4w.getStatic)(this.constructor, "getEventTopic")(eventFragment);
            }
        },
        {
            key: "_decodeParams",
            value: function _decodeParams(params, data) {
                return this._abiCoder.decode(params, data);
            }
        },
        {
            key: "_encodeParams",
            value: function _encodeParams(params, values) {
                return this._abiCoder.encode(params, values);
            }
        },
        {
            key: "encodeDeploy",
            value: function encodeDeploy(values) {
                return this._encodeParams(this.deploy.inputs, values || []);
            }
        },
        {
            key: "decodeErrorResult",
            value: function decodeErrorResult(fragment, data) {
                if (typeof fragment === "string") fragment = this.getError(fragment);
                var bytes = (0, $j2rU8.arrayify)(data);
                if ((0, $j2rU8.hexlify)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $6df659078ac9448c$var$logger.throwArgumentError("data signature does not match error ".concat(fragment.name, "."), "data", (0, $j2rU8.hexlify)(bytes));
                return this._decodeParams(fragment.inputs, bytes.slice(4));
            }
        },
        {
            key: "encodeErrorResult",
            value: function encodeErrorResult(fragment, values) {
                if (typeof fragment === "string") fragment = this.getError(fragment);
                return (0, $j2rU8.hexlify)((0, $j2rU8.concat)([
                    this.getSighash(fragment),
                    this._encodeParams(fragment.inputs, values || [])
                ]));
            }
        },
        {
            // Decode the data for a function call (e.g. tx.data)
            key: "decodeFunctionData",
            value: function decodeFunctionData(functionFragment, data) {
                if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
                var bytes = (0, $j2rU8.arrayify)(data);
                if ((0, $j2rU8.hexlify)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $6df659078ac9448c$var$logger.throwArgumentError("data signature does not match function ".concat(functionFragment.name, "."), "data", (0, $j2rU8.hexlify)(bytes));
                return this._decodeParams(functionFragment.inputs, bytes.slice(4));
            }
        },
        {
            // Encode the data for a function call (e.g. tx.data)
            key: "encodeFunctionData",
            value: function encodeFunctionData(functionFragment, values) {
                if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
                return (0, $j2rU8.hexlify)((0, $j2rU8.concat)([
                    this.getSighash(functionFragment),
                    this._encodeParams(functionFragment.inputs, values || [])
                ]));
            }
        },
        {
            // Decode the result from a function call (e.g. from eth_call)
            key: "decodeFunctionResult",
            value: function decodeFunctionResult(functionFragment, data) {
                if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
                var bytes = (0, $j2rU8.arrayify)(data);
                var reason = null;
                var message = "";
                var errorArgs = null;
                var errorName = null;
                var errorSignature = null;
                switch(bytes.length % this._abiCoder._getWordSize()){
                    case 0:
                        try {
                            return this._abiCoder.decode(functionFragment.outputs, bytes);
                        } catch (error) {}
                        break;
                    case 4:
                        {
                            var selector = (0, $j2rU8.hexlify)(bytes.slice(0, 4));
                            var builtin = $6df659078ac9448c$var$BuiltinErrors[selector];
                            if (builtin) {
                                errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                                errorName = builtin.name;
                                errorSignature = builtin.signature;
                                if (builtin.reason) reason = errorArgs[0];
                                if (errorName === "Error") message = "; VM Exception while processing transaction: reverted with reason string ".concat(JSON.stringify(errorArgs[0]));
                                else if (errorName === "Panic") message = "; VM Exception while processing transaction: reverted with panic code ".concat(errorArgs[0]);
                            } else try {
                                var error = this.getError(selector);
                                errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                                errorName = error.name;
                                errorSignature = error.format();
                            } catch (error) {}
                            break;
                        }
                }
                return $6df659078ac9448c$var$logger.throwError("call revert exception" + message, (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
                    method: functionFragment.format(),
                    data: (0, $j2rU8.hexlify)(data),
                    errorArgs: errorArgs,
                    errorName: errorName,
                    errorSignature: errorSignature,
                    reason: reason
                });
            }
        },
        {
            // Encode the result for a function call (e.g. for eth_call)
            key: "encodeFunctionResult",
            value: function encodeFunctionResult(functionFragment, values) {
                if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
                return (0, $j2rU8.hexlify)(this._abiCoder.encode(functionFragment.outputs, values || []));
            }
        },
        {
            // Create the filter for the event with search criteria (e.g. for eth_filterLog)
            key: "encodeFilterTopics",
            value: function encodeFilterTopics(eventFragment, values) {
                var _this = this;
                if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
                if (values.length > eventFragment.inputs.length) $6df659078ac9448c$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $6M65e.Logger).errors.UNEXPECTED_ARGUMENT, {
                    argument: "values",
                    value: values
                });
                var topics = [];
                if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
                var encodeTopic = function(param, value) {
                    if (param.type === "string") return (0, $4q6En.id)(value);
                    else if (param.type === "bytes") return (0, $4ujqV.keccak256)((0, $j2rU8.hexlify)(value));
                    if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
                    if (param.type.match(/^u?int/)) value = (0, $gMArf.BigNumber).from(value).toHexString();
                    // Check addresses are valid
                    if (param.type === "address") _this._abiCoder.encode([
                        "address"
                    ], [
                        value
                    ]);
                    return (0, $j2rU8.hexZeroPad)((0, $j2rU8.hexlify)(value), 32);
                };
                values.forEach(function(value, index) {
                    var param = eventFragment.inputs[index];
                    if (!param.indexed) {
                        if (value != null) $6df659078ac9448c$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                        return;
                    }
                    if (value == null) topics.push(null);
                    else if (param.baseType === "array" || param.baseType === "tuple") $6df659078ac9448c$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
                    else if (Array.isArray(value)) topics.push(value.map(function(value) {
                        return encodeTopic(param, value);
                    }));
                    else topics.push(encodeTopic(param, value));
                });
                // Trim off trailing nulls
                while(topics.length && topics[topics.length - 1] === null)topics.pop();
                return topics;
            }
        },
        {
            key: "encodeEventLog",
            value: function encodeEventLog(eventFragment, values) {
                var _this = this;
                if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
                var topics = [];
                var dataTypes = [];
                var dataValues = [];
                if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
                if (values.length !== eventFragment.inputs.length) $6df659078ac9448c$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
                eventFragment.inputs.forEach(function(param, index) {
                    var value = values[index];
                    if (param.indexed) {
                        if (param.type === "string") topics.push((0, $4q6En.id)(value));
                        else if (param.type === "bytes") topics.push((0, $4ujqV.keccak256)(value));
                        else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                        throw new Error("not implemented");
                        else topics.push(_this._abiCoder.encode([
                            param.type
                        ], [
                            value
                        ]));
                    } else {
                        dataTypes.push(param);
                        dataValues.push(value);
                    }
                });
                return {
                    data: this._abiCoder.encode(dataTypes, dataValues),
                    topics: topics
                };
            }
        },
        {
            // Decode a filter for the event and the search criteria
            key: "decodeEventLog",
            value: function decodeEventLog(eventFragment, data, topics) {
                var _loop = function(i) {
                    var value = result[i];
                    if (value instanceof Error) Object.defineProperty(result, i, {
                        enumerable: true,
                        get: function() {
                            throw $6df659078ac9448c$var$wrapAccessError("index ".concat(i), value);
                        }
                    });
                };
                if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
                if (topics != null && !eventFragment.anonymous) {
                    var topicHash = this.getEventTopic(eventFragment);
                    if (!(0, $j2rU8.isHexString)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $6df659078ac9448c$var$logger.throwError("fragment/topic mismatch", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                        argument: "topics[0]",
                        expected: topicHash,
                        value: topics[0]
                    });
                    topics = topics.slice(1);
                }
                var indexed = [];
                var nonIndexed = [];
                var dynamic = [];
                eventFragment.inputs.forEach(function(param, index) {
                    if (param.indexed) {
                        if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                            indexed.push((0, $6CFiK.ParamType).fromObject({
                                type: "bytes32",
                                name: param.name
                            }));
                            dynamic.push(true);
                        } else {
                            indexed.push(param);
                            dynamic.push(false);
                        }
                    } else {
                        nonIndexed.push(param);
                        dynamic.push(false);
                    }
                });
                var resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $j2rU8.concat)(topics)) : null;
                var resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
                var result = [];
                var nonIndexedIndex = 0, indexedIndex = 0;
                eventFragment.inputs.forEach(function(param, index) {
                    if (param.indexed) {
                        if (resultIndexed == null) result[index] = new $6df659078ac9448c$export$8ef99100a3c56f8c({
                            _isIndexed: true,
                            hash: null
                        });
                        else if (dynamic[index]) result[index] = new $6df659078ac9448c$export$8ef99100a3c56f8c({
                            _isIndexed: true,
                            hash: resultIndexed[indexedIndex++]
                        });
                        else try {
                            result[index] = resultIndexed[indexedIndex++];
                        } catch (error) {
                            result[index] = error;
                        }
                    } else try {
                        result[index] = resultNonIndexed[nonIndexedIndex++];
                    } catch (error) {
                        result[index] = error;
                    }
                    // Add the keyword argument if named and safe
                    if (param.name && result[param.name] == null) {
                        var value = result[index];
                        // Make error named values throw on access
                        if (value instanceof Error) Object.defineProperty(result, param.name, {
                            enumerable: true,
                            get: function() {
                                throw $6df659078ac9448c$var$wrapAccessError("property ".concat(JSON.stringify(param.name)), value);
                            }
                        });
                        else result[param.name] = value;
                    }
                });
                // Make all error indexed values throw on access
                for(var i = 0; i < result.length; i++)_loop(i);
                return Object.freeze(result);
            }
        },
        {
            // Given a transaction, find the matching function fragment (if any) and
            // determine all its properties and call parameters
            key: "parseTransaction",
            value: function parseTransaction(tx) {
                var fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
                if (!fragment) return null;
                return new $6df659078ac9448c$export$7a3223b0fadb690b({
                    args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
                    functionFragment: fragment,
                    name: fragment.name,
                    signature: fragment.format(),
                    sighash: this.getSighash(fragment),
                    value: (0, $gMArf.BigNumber).from(tx.value || "0")
                });
            }
        },
        {
            // @TODO
            //parseCallResult(data: BytesLike): ??
            // Given an event log, find the matching event fragment (if any) and
            // determine all its properties and values
            key: "parseLog",
            value: function parseLog(log) {
                var fragment = this.getEvent(log.topics[0]);
                if (!fragment || fragment.anonymous) return null;
                // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
                //        Probably not, because just because it is the only event in the ABI does
                //        not mean we have the full ABI; maybe just a fragment?
                return new $6df659078ac9448c$export$c2ab6499be98b3c5({
                    eventFragment: fragment,
                    name: fragment.name,
                    signature: fragment.format(),
                    topic: this.getEventTopic(fragment),
                    args: this.decodeEventLog(fragment, log.data, log.topics)
                });
            }
        },
        {
            key: "parseError",
            value: function parseError(data) {
                var hexData = (0, $j2rU8.hexlify)(data);
                var fragment = this.getError(hexData.substring(0, 10).toLowerCase());
                if (!fragment) return null;
                return new $6df659078ac9448c$export$cfba08fc0e40e2ab({
                    args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
                    errorFragment: fragment,
                    name: fragment.name,
                    signature: fragment.format(),
                    sighash: this.getSighash(fragment)
                });
            }
        }
    ], [
        {
            key: "getAbiCoder",
            value: // Sub-classes can override these to handle other blockchains
            function getAbiCoder() {
                return 0, $yKVLS.defaultAbiCoder;
            }
        },
        {
            key: "getAddress",
            value: function getAddress1(address) {
                return (0, $e8NrM.getAddress)(address);
            }
        },
        {
            key: "getSighash",
            value: function getSighash(fragment) {
                return (0, $j2rU8.hexDataSlice)((0, $4q6En.id)(fragment.format()), 0, 4);
            }
        },
        {
            key: "getEventTopic",
            value: function getEventTopic(eventFragment) {
                return (0, $4q6En.id)(eventFragment.format());
            }
        },
        {
            key: "isInterface",
            value: /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ function isInterface(value) {
                return !!(value && value._isInterface);
            }
        }
    ]);
    return Interface;
}();

});
parcelRequire.register("4q6En", function(module, exports) {

$parcel$export(module.exports, "id", function () { return $337ebfbf1ce1b46f$export$d560c7e4a29451c2; });

var $4ujqV = parcelRequire("4ujqV");

var $1Wmc7 = parcelRequire("1Wmc7");
function $337ebfbf1ce1b46f$export$d560c7e4a29451c2(text) {
    return (0, $4ujqV.keccak256)((0, $1Wmc7.toUtf8Bytes)(text));
}

});


parcelRequire.register("ebtr5", function(module, exports) {

$parcel$export(module.exports, "Base58", function () { return $a538ed25248fff2d$export$45a587635c9954b2; });
/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ 
var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $j2rU8 = parcelRequire("j2rU8");

var $2ax4w = parcelRequire("2ax4w");
var $a538ed25248fff2d$export$240043ab8e806ec7 = /*#__PURE__*/ function() {
    "use strict";
    function BaseX(alphabet) {
        (0, $978gY._)(this, BaseX);
        (0, $2ax4w.defineReadOnly)(this, "alphabet", alphabet);
        (0, $2ax4w.defineReadOnly)(this, "base", alphabet.length);
        (0, $2ax4w.defineReadOnly)(this, "_alphabetMap", {});
        (0, $2ax4w.defineReadOnly)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(var i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
    (0, $kry2a._)(BaseX, [
        {
            key: "encode",
            value: function encode(value) {
                var source = (0, $j2rU8.arrayify)(value);
                if (source.length === 0) return "";
                var digits = [
                    0
                ];
                for(var i = 0; i < source.length; ++i){
                    var carry = source[i];
                    for(var j = 0; j < digits.length; ++j){
                        carry += digits[j] << 8;
                        digits[j] = carry % this.base;
                        carry = carry / this.base | 0;
                    }
                    while(carry > 0){
                        digits.push(carry % this.base);
                        carry = carry / this.base | 0;
                    }
                }
                var string = "";
                // deal with leading zeros
                for(var k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
                // convert digits to a string
                for(var q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
                return string;
            }
        },
        {
            key: "decode",
            value: function decode(value) {
                if (typeof value !== "string") throw new TypeError("Expected String");
                var bytes = [];
                if (value.length === 0) return new Uint8Array(bytes);
                bytes.push(0);
                for(var i = 0; i < value.length; i++){
                    var byte = this._alphabetMap[value[i]];
                    if (byte === undefined) throw new Error("Non-base" + this.base + " character");
                    var carry = byte;
                    for(var j = 0; j < bytes.length; ++j){
                        carry += bytes[j] * this.base;
                        bytes[j] = carry & 0xff;
                        carry >>= 8;
                    }
                    while(carry > 0){
                        bytes.push(carry & 0xff);
                        carry >>= 8;
                    }
                }
                // deal with leading zeros
                for(var k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
                return (0, $j2rU8.arrayify)(new Uint8Array(bytes.reverse()));
            }
        }
    ]);
    return BaseX;
}();
var $a538ed25248fff2d$export$cfabb2852920f5ec = new $a538ed25248fff2d$export$240043ab8e806ec7("abcdefghijklmnopqrstuvwxyz234567");
var $a538ed25248fff2d$export$45a587635c9954b2 = new $a538ed25248fff2d$export$240043ab8e806ec7("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
 //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))

});

parcelRequire.register("kdj79", function(module, exports) {

$parcel$export(module.exports, "TypedDataEncoder", function () { return $eb73d9441da70c0d$export$458ab927ae635c3; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");

var $e8NrM = parcelRequire("e8NrM");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $4ujqV = parcelRequire("4ujqV");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $jFZZp = parcelRequire("jFZZp");

var $4q6En = parcelRequire("4q6En");
var $eb73d9441da70c0d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $eb73d9441da70c0d$var$logger = new (0, $6M65e.Logger)((0, $jFZZp.version));
var $eb73d9441da70c0d$var$padding = new Uint8Array(32);
$eb73d9441da70c0d$var$padding.fill(0);
var $eb73d9441da70c0d$var$NegativeOne = (0, $gMArf.BigNumber).from(-1);
var $eb73d9441da70c0d$var$Zero = (0, $gMArf.BigNumber).from(0);
var $eb73d9441da70c0d$var$One = (0, $gMArf.BigNumber).from(1);
var $eb73d9441da70c0d$var$MaxUint256 = (0, $gMArf.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $eb73d9441da70c0d$var$hexPadRight(value) {
    var bytes = (0, $j2rU8.arrayify)(value);
    var padOffset = bytes.length % 32;
    if (padOffset) return (0, $j2rU8.hexConcat)([
        bytes,
        $eb73d9441da70c0d$var$padding.slice(padOffset)
    ]);
    return (0, $j2rU8.hexlify)(bytes);
}
var $eb73d9441da70c0d$var$hexTrue = (0, $j2rU8.hexZeroPad)($eb73d9441da70c0d$var$One.toHexString(), 32);
var $eb73d9441da70c0d$var$hexFalse = (0, $j2rU8.hexZeroPad)($eb73d9441da70c0d$var$Zero.toHexString(), 32);
var $eb73d9441da70c0d$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
var $eb73d9441da70c0d$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $eb73d9441da70c0d$var$checkString(key) {
    return function(value) {
        if (typeof value !== "string") $eb73d9441da70c0d$var$logger.throwArgumentError("invalid domain value for ".concat(JSON.stringify(key)), "domain.".concat(key), value);
        return value;
    };
}
var $eb73d9441da70c0d$var$domainChecks = {
    name: $eb73d9441da70c0d$var$checkString("name"),
    version: $eb73d9441da70c0d$var$checkString("version"),
    chainId: function chainId(value) {
        try {
            return (0, $gMArf.BigNumber).from(value).toString();
        } catch (error) {}
        return $eb73d9441da70c0d$var$logger.throwArgumentError('invalid domain value for "chainId"', "domain.chainId", value);
    },
    verifyingContract: function verifyingContract(value) {
        try {
            return (0, $e8NrM.getAddress)(value).toLowerCase();
        } catch (error) {}
        return $eb73d9441da70c0d$var$logger.throwArgumentError('invalid domain value "verifyingContract"', "domain.verifyingContract", value);
    },
    salt: function salt(value) {
        try {
            var bytes = (0, $j2rU8.arrayify)(value);
            if (bytes.length !== 32) throw new Error("bad length");
            return (0, $j2rU8.hexlify)(bytes);
        } catch (error) {}
        return $eb73d9441da70c0d$var$logger.throwArgumentError('invalid domain value "salt"', "domain.salt", value);
    }
};
function $eb73d9441da70c0d$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        var match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            var signed = match[1] === "";
            var width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || match[2] && match[2] !== String(width)) $eb73d9441da70c0d$var$logger.throwArgumentError("invalid numeric width", "type", type);
            var boundsUpper = $eb73d9441da70c0d$var$MaxUint256.mask(signed ? width - 1 : width);
            var boundsLower = signed ? boundsUpper.add($eb73d9441da70c0d$var$One).mul($eb73d9441da70c0d$var$NegativeOne) : $eb73d9441da70c0d$var$Zero;
            return function(value) {
                var v = (0, $gMArf.BigNumber).from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) $eb73d9441da70c0d$var$logger.throwArgumentError("value out-of-bounds for ".concat(type), "value", value);
                return (0, $j2rU8.hexZeroPad)(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        var match1 = type.match(/^bytes(\d+)$/);
        if (match1) {
            var width1 = parseInt(match1[1]);
            if (width1 === 0 || width1 > 32 || match1[1] !== String(width1)) $eb73d9441da70c0d$var$logger.throwArgumentError("invalid bytes width", "type", type);
            return function(value) {
                var bytes = (0, $j2rU8.arrayify)(value);
                if (bytes.length !== width1) $eb73d9441da70c0d$var$logger.throwArgumentError("invalid length for ".concat(type), "value", value);
                return $eb73d9441da70c0d$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $j2rU8.hexZeroPad)((0, $e8NrM.getAddress)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $eb73d9441da70c0d$var$hexFalse : $eb73d9441da70c0d$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $4ujqV.keccak256)(value);
            };
        case "string":
            return function(value) {
                return (0, $4q6En.id)(value);
            };
    }
    return null;
}
function $eb73d9441da70c0d$var$encodeType(name, fields) {
    return "".concat(name, "(").concat(fields.map(function(param) {
        var _$name = param.name, type = param.type;
        return type + " " + _$name;
    }).join(","), ")");
}
var $eb73d9441da70c0d$export$458ab927ae635c3 = /*#__PURE__*/ function() {
    "use strict";
    function TypedDataEncoder(types) {
        var _loop = function(name) {
            var uniqueNames = {};
            types[name].forEach(function(field) {
                // Check each field has a unique name
                if (uniqueNames[field.name]) $eb73d9441da70c0d$var$logger.throwArgumentError("duplicate variable name ".concat(JSON.stringify(field.name), " in ").concat(JSON.stringify(name)), "types", types);
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                var baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) $eb73d9441da70c0d$var$logger.throwArgumentError("circular type reference to ".concat(JSON.stringify(baseType)), "types", types);
                // Is this a base encoding type?
                var encoder = $eb73d9441da70c0d$var$getBaseEncoder(baseType);
                if (encoder) return;
                if (!parents[baseType]) $eb73d9441da70c0d$var$logger.throwArgumentError("unknown type ".concat(JSON.stringify(baseType)), "types", types);
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        };
        (0, $978gY._)(this, TypedDataEncoder);
        (0, $2ax4w.defineReadOnly)(this, "types", Object.freeze((0, $2ax4w.deepCopy)(types)));
        (0, $2ax4w.defineReadOnly)(this, "_encoderCache", {});
        (0, $2ax4w.defineReadOnly)(this, "_types", {});
        // Link struct types to their direct child structs
        var links = {};
        // Link structs to structs which contain them as a child
        var parents = {};
        // Link all subtypes within a given struct
        var subtypes = {};
        Object.keys(types).forEach(function(type) {
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for(var name in types)_loop(name);
        // Deduce the primary type
        var primaryTypes = Object.keys(parents).filter(function(n) {
            return parents[n].length === 0;
        });
        if (primaryTypes.length === 0) $eb73d9441da70c0d$var$logger.throwArgumentError("missing primary type", "types", types);
        else if (primaryTypes.length > 1) $eb73d9441da70c0d$var$logger.throwArgumentError("ambiguous primary types or unused types: ".concat(primaryTypes.map(function(t) {
            return JSON.stringify(t);
        }).join(", ")), "types", types);
        (0, $2ax4w.defineReadOnly)(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) $eb73d9441da70c0d$var$logger.throwArgumentError("circular type reference to ".concat(JSON.stringify(type)), "types", types);
            found[type] = true;
            Object.keys(links[type]).forEach(function(child) {
                if (!parents[child]) return;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach(function(subtype) {
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for(var name1 in subtypes){
            var st = Object.keys(subtypes[name1]);
            st.sort();
            this._types[name1] = $eb73d9441da70c0d$var$encodeType(name1, types[name1]) + st.map(function(t) {
                return $eb73d9441da70c0d$var$encodeType(t, types[t]);
            }).join("");
        }
    }
    (0, $kry2a._)(TypedDataEncoder, [
        {
            key: "getEncoder",
            value: function getEncoder(type) {
                var encoder = this._encoderCache[type];
                if (!encoder) encoder = this._encoderCache[type] = this._getEncoder(type);
                return encoder;
            }
        },
        {
            key: "_getEncoder",
            value: function _getEncoder(type) {
                var _this = this;
                // Basic encoder type (address, bool, uint256, etc)
                {
                    var encoder = $eb73d9441da70c0d$var$getBaseEncoder(type);
                    if (encoder) return encoder;
                }
                // Array
                var match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
                if (match) {
                    var subtype = match[1];
                    var subEncoder = this.getEncoder(subtype);
                    var length = parseInt(match[3]);
                    return function(value) {
                        if (length >= 0 && value.length !== length) $eb73d9441da70c0d$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                        var result = value.map(subEncoder);
                        if (_this._types[subtype]) result = result.map((0, $4ujqV.keccak256));
                        return (0, $4ujqV.keccak256)((0, $j2rU8.hexConcat)(result));
                    };
                }
                // Struct
                var fields = this.types[type];
                if (fields) {
                    var encodedType = (0, $4q6En.id)(this._types[type]);
                    return function(value) {
                        var values = fields.map(function(param) {
                            var name = param.name, _$type = param.type;
                            var result = _this.getEncoder(_$type)(value[name]);
                            if (_this._types[_$type]) return (0, $4ujqV.keccak256)(result);
                            return result;
                        });
                        values.unshift(encodedType);
                        return (0, $j2rU8.hexConcat)(values);
                    };
                }
                return $eb73d9441da70c0d$var$logger.throwArgumentError("unknown type: ".concat(type), "type", type);
            }
        },
        {
            key: "encodeType",
            value: function encodeType(name) {
                var result = this._types[name];
                if (!result) $eb73d9441da70c0d$var$logger.throwArgumentError("unknown type: ".concat(JSON.stringify(name)), "name", name);
                return result;
            }
        },
        {
            key: "encodeData",
            value: function encodeData(type, value) {
                return this.getEncoder(type)(value);
            }
        },
        {
            key: "hashStruct",
            value: function hashStruct(name, value) {
                return (0, $4ujqV.keccak256)(this.encodeData(name, value));
            }
        },
        {
            key: "encode",
            value: function encode(value) {
                return this.encodeData(this.primaryType, value);
            }
        },
        {
            key: "hash",
            value: function hash(value) {
                return this.hashStruct(this.primaryType, value);
            }
        },
        {
            key: "_visit",
            value: function _visit(type, value, callback) {
                var _this = this;
                // Basic encoder type (address, bool, uint256, etc)
                {
                    var encoder = $eb73d9441da70c0d$var$getBaseEncoder(type);
                    if (encoder) return callback(type, value);
                }
                // Array
                var match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
                if (match) {
                    var subtype = match[1];
                    var length = parseInt(match[3]);
                    if (length >= 0 && value.length !== length) $eb73d9441da70c0d$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                    return value.map(function(v) {
                        return _this._visit(subtype, v, callback);
                    });
                }
                // Struct
                var fields = this.types[type];
                if (fields) return fields.reduce(function(accum, param) {
                    var name = param.name, _$type = param.type;
                    accum[name] = _this._visit(_$type, value[name], callback);
                    return accum;
                }, {});
                return $eb73d9441da70c0d$var$logger.throwArgumentError("unknown type: ".concat(type), "type", type);
            }
        },
        {
            key: "visit",
            value: function visit(value, callback) {
                return this._visit(this.primaryType, value, callback);
            }
        }
    ], [
        {
            key: "from",
            value: function from(types) {
                return new TypedDataEncoder(types);
            }
        },
        {
            key: "getPrimaryType",
            value: function getPrimaryType(types) {
                return TypedDataEncoder.from(types).primaryType;
            }
        },
        {
            key: "hashStruct",
            value: function hashStruct(name, types, value) {
                return TypedDataEncoder.from(types).hashStruct(name, value);
            }
        },
        {
            key: "hashDomain",
            value: function hashDomain(domain) {
                var domainFields = [];
                for(var name in domain){
                    var type = $eb73d9441da70c0d$var$domainFieldTypes[name];
                    if (!type) $eb73d9441da70c0d$var$logger.throwArgumentError("invalid typed-data domain key: ".concat(JSON.stringify(name)), "domain", domain);
                    domainFields.push({
                        name: name,
                        type: type
                    });
                }
                domainFields.sort(function(a, b) {
                    return $eb73d9441da70c0d$var$domainFieldNames.indexOf(a.name) - $eb73d9441da70c0d$var$domainFieldNames.indexOf(b.name);
                });
                return TypedDataEncoder.hashStruct("EIP712Domain", {
                    EIP712Domain: domainFields
                }, domain);
            }
        },
        {
            key: "encode",
            value: function encode(domain, types, value) {
                return (0, $j2rU8.hexConcat)([
                    "0x1901",
                    TypedDataEncoder.hashDomain(domain),
                    TypedDataEncoder.from(types).hash(value)
                ]);
            }
        },
        {
            key: "hash",
            value: function hash(domain, types, value) {
                return (0, $4ujqV.keccak256)(TypedDataEncoder.encode(domain, types, value));
            }
        },
        {
            key: "resolveNames",
            value: // Replaces all address types with ENS names with their looked up address
            function resolveNames(domain, types, value, resolveName) {
                return $eb73d9441da70c0d$var$__awaiter(this, void 0, void 0, function() {
                    var ensCache, encoder, _tmp, _tmp1, _i, name;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Make a copy to isolate it from the object passed in
                                domain = (0, $2ax4w.shallowCopy)(domain);
                                ensCache = {};
                                // Do we need to look up the domain's verifyingContract?
                                if (domain.verifyingContract && !(0, $j2rU8.isHexString)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
                                encoder = TypedDataEncoder.from(types);
                                // Get a list of all the addresses
                                encoder.visit(value, function(type, value) {
                                    if (type === "address" && !(0, $j2rU8.isHexString)(value, 20)) ensCache[value] = "0x";
                                    return value;
                                });
                                _tmp = [];
                                for(_tmp1 in ensCache)_tmp.push(_tmp1);
                                _i = 0;
                                _state.label = 1;
                            case 1:
                                if (!(_i < _tmp.length)) return [
                                    3,
                                    4
                                ];
                                name = _tmp[_i];
                                return [
                                    4,
                                    resolveName(name)
                                ];
                            case 2:
                                ensCache[name] = _state.sent();
                                _state.label = 3;
                            case 3:
                                _i++;
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                // Replace the domain verifyingContract if needed
                                if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
                                // Replace all ENS names with their address
                                value = encoder.visit(value, function(type, value) {
                                    if (type === "address" && ensCache[value]) return ensCache[value];
                                    return value;
                                });
                                return [
                                    2,
                                    {
                                        domain: domain,
                                        value: value
                                    }
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getPayload",
            value: function getPayload(domain, types, value) {
                // Validate the domain fields
                TypedDataEncoder.hashDomain(domain);
                // Derive the EIP712Domain Struct reference type
                var domainValues = {};
                var domainTypes = [];
                $eb73d9441da70c0d$var$domainFieldNames.forEach(function(name) {
                    var _$value = domain[name];
                    if (_$value == null) return;
                    domainValues[name] = $eb73d9441da70c0d$var$domainChecks[name](_$value);
                    domainTypes.push({
                        name: name,
                        type: $eb73d9441da70c0d$var$domainFieldTypes[name]
                    });
                });
                var encoder = TypedDataEncoder.from(types);
                var typesWithDomain = (0, $2ax4w.shallowCopy)(types);
                if (typesWithDomain.EIP712Domain) $eb73d9441da70c0d$var$logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
                else typesWithDomain.EIP712Domain = domainTypes;
                // Validate the data structures and types
                encoder.encode(value);
                return {
                    types: typesWithDomain,
                    domain: domainValues,
                    primaryType: encoder.primaryType,
                    message: encoder.visit(value, function(type, value) {
                        // bytes
                        if (type.match(/^bytes(\d*)/)) return (0, $j2rU8.hexlify)((0, $j2rU8.arrayify)(value));
                        // uint or int
                        if (type.match(/^u?int/)) return (0, $gMArf.BigNumber).from(value).toString();
                        switch(type){
                            case "address":
                                return value.toLowerCase();
                            case "bool":
                                return !!value;
                            case "string":
                                if (typeof value !== "string") $eb73d9441da70c0d$var$logger.throwArgumentError("invalid string", "value", value);
                                return value;
                        }
                        return $eb73d9441da70c0d$var$logger.throwArgumentError("unsupported type", "type", type);
                    })
                };
            }
        }
    ]);
    return TypedDataEncoder;
}();

});
parcelRequire.register("jFZZp", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $e531ee7873f6488e$export$83d89fbfd8236492; });
var $e531ee7873f6488e$export$83d89fbfd8236492 = "hash/5.7.0";

});


parcelRequire.register("4JdI5", function(module, exports) {

$parcel$export(module.exports, "isValidName", function () { return $3715ffed660cd02c$export$cce2300886e7ace6; });
$parcel$export(module.exports, "namehash", function () { return $3715ffed660cd02c$export$91d651ee363e1209; });
$parcel$export(module.exports, "dnsEncode", function () { return $3715ffed660cd02c$export$6c0a8cdae51cb512; });

var $j2rU8 = parcelRequire("j2rU8");

var $1Wmc7 = parcelRequire("1Wmc7");

var $4ujqV = parcelRequire("4ujqV");

var $6M65e = parcelRequire("6M65e");

var $jFZZp = parcelRequire("jFZZp");

var $kYWKf = parcelRequire("kYWKf");
var $3715ffed660cd02c$var$logger = new (0, $6M65e.Logger)((0, $jFZZp.version));
var $3715ffed660cd02c$var$Zeros = new Uint8Array(32);
$3715ffed660cd02c$var$Zeros.fill(0);
function $3715ffed660cd02c$var$checkComponent(comp) {
    if (comp.length === 0) throw new Error("invalid ENS name; empty component");
    return comp;
}
function $3715ffed660cd02c$var$ensNameSplit(name) {
    var bytes = (0, $1Wmc7.toUtf8Bytes)((0, $kYWKf.ens_normalize)(name));
    var comps = [];
    if (name.length === 0) return comps;
    var last = 0;
    for(var i = 0; i < bytes.length; i++){
        var d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($3715ffed660cd02c$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    if (last >= bytes.length) throw new Error("invalid ENS name; empty component");
    comps.push($3715ffed660cd02c$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $3715ffed660cd02c$export$5f232fd2f1a1e8ac(name) {
    return $3715ffed660cd02c$var$ensNameSplit(name).map(function(comp) {
        return (0, $1Wmc7.toUtf8String)(comp);
    }).join(".");
}
function $3715ffed660cd02c$export$cce2300886e7ace6(name) {
    try {
        return $3715ffed660cd02c$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $3715ffed660cd02c$export$91d651ee363e1209(name) {
    /* istanbul ignore if */ if (typeof name !== "string") $3715ffed660cd02c$var$logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    var result = $3715ffed660cd02c$var$Zeros;
    var comps = $3715ffed660cd02c$var$ensNameSplit(name);
    while(comps.length)result = (0, $4ujqV.keccak256)((0, $j2rU8.concat)([
        result,
        (0, $4ujqV.keccak256)(comps.pop())
    ]));
    return (0, $j2rU8.hexlify)(result);
}
function $3715ffed660cd02c$export$6c0a8cdae51cb512(name) {
    return (0, $j2rU8.hexlify)((0, $j2rU8.concat)($3715ffed660cd02c$var$ensNameSplit(name).map(function(comp) {
        // DNS does not allow components over 63 bytes in length
        if (comp.length > 63) throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
        var bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}

});
parcelRequire.register("kYWKf", function(module, exports) {

$parcel$export(module.exports, "ens_normalize", function () { return $f466fac178eacead$export$499f715881831a51; });
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
var $fLnyw = parcelRequire("fLnyw");

var $1Wmc7 = parcelRequire("1Wmc7");

var $dgWym = parcelRequire("dgWym");

var $25x8z = parcelRequire("25x8z");
var $f466fac178eacead$var$r = (0, $dgWym.getData)();
// @TODO: This should be lazily loaded
var $f466fac178eacead$var$VALID = new Set((0, $25x8z.read_member_array)($f466fac178eacead$var$r));
var $f466fac178eacead$var$IGNORED = new Set((0, $25x8z.read_member_array)($f466fac178eacead$var$r));
var $f466fac178eacead$var$MAPPED = (0, $25x8z.read_mapped_map)($f466fac178eacead$var$r);
var $f466fac178eacead$var$EMOJI_ROOT = (0, $25x8z.read_emoji_trie)($f466fac178eacead$var$r);
//const NFC_CHECK = new Set(read_member_array(r, Array.from(VALID.values()).sort((a, b) => a - b)));
//const STOP = 0x2E;
var $f466fac178eacead$var$HYPHEN = 0x2D;
var $f466fac178eacead$var$UNDERSCORE = 0x5F;
function $f466fac178eacead$var$explode_cp(name) {
    return (0, $1Wmc7.toUtf8CodePoints)(name);
}
function $f466fac178eacead$var$filter_fe0f(cps) {
    return cps.filter(function(cp) {
        return cp != 0xFE0F;
    });
}
function $f466fac178eacead$export$5252e54b57fcf4fd(name) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var label = _step.value;
            var cps = $f466fac178eacead$var$explode_cp(label);
            try {
                for(var i = cps.lastIndexOf($f466fac178eacead$var$UNDERSCORE) - 1; i >= 0; i--){
                    if (cps[i] !== $f466fac178eacead$var$UNDERSCORE) throw new Error("underscore only allowed at start");
                }
                if (cps.length >= 4 && cps.every(function(cp) {
                    return cp < 0x80;
                }) && cps[2] === $f466fac178eacead$var$HYPHEN && cps[3] === $f466fac178eacead$var$HYPHEN) throw new Error("invalid label extension");
            } catch (err) {
                throw new Error('Invalid label "'.concat(label, '": ').concat(err.message));
            }
        };
        for(var _iterator = name.split(".")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return name;
}
function $f466fac178eacead$export$499f715881831a51(name) {
    return $f466fac178eacead$export$5252e54b57fcf4fd($f466fac178eacead$var$normalize(name, $f466fac178eacead$var$filter_fe0f));
}
function $f466fac178eacead$var$normalize(name, emoji_filter) {
    var _String;
    var input = $f466fac178eacead$var$explode_cp(name).reverse(); // flip for pop
    var output = [];
    while(input.length){
        var emoji = $f466fac178eacead$var$consume_emoji_reversed(input);
        if (emoji) {
            var _output;
            (_output = output).push.apply(_output, (0, $fLnyw._)(emoji_filter(emoji)));
            continue;
        }
        var cp = input.pop();
        if ($f466fac178eacead$var$VALID.has(cp)) {
            output.push(cp);
            continue;
        }
        if ($f466fac178eacead$var$IGNORED.has(cp)) continue;
        var cps = $f466fac178eacead$var$MAPPED[cp];
        if (cps) {
            var _output1;
            (_output1 = output).push.apply(_output1, (0, $fLnyw._)(cps));
            continue;
        }
        throw new Error("Disallowed codepoint: 0x".concat(cp.toString(16).toUpperCase()));
    }
    return $f466fac178eacead$export$5252e54b57fcf4fd($f466fac178eacead$var$nfc((_String = String).fromCodePoint.apply(_String, (0, $fLnyw._)(output))));
}
function $f466fac178eacead$var$nfc(s) {
    return s.normalize("NFC");
}
function $f466fac178eacead$var$consume_emoji_reversed(cps, eaten) {
    var _loop = function() {
        var cp = cps[--pos];
        node = (_a = node.branches.find(function(x) {
            return x.set.has(cp);
        })) === null || _a === void 0 ? void 0 : _a.node;
        if (!node) return "break";
        if (node.save) saved = cp;
        else if (node.check) {
            if (cp === saved) return "break";
        }
        stack.push(cp);
        if (node.fe0f) {
            stack.push(0xFE0F);
            if (pos > 0 && cps[pos - 1] == 0xFE0F) pos--; // consume optional FE0F
        }
        if (node.valid) {
            var _eaten;
            emoji = stack.slice(); // copy stack
            if (node.valid == 2) emoji.splice(1, 1); // delete FE0F at position 1 (RGI ZWJ don't follow spec!)
            if (eaten) (_eaten = eaten).push.apply(_eaten, (0, $fLnyw._)(cps.slice(pos).reverse())); // copy input (if needed)
            cps.length = pos; // truncate
        }
    };
    var _a;
    var node = $f466fac178eacead$var$EMOJI_ROOT;
    var emoji;
    var saved;
    var stack = [];
    var pos = cps.length;
    if (eaten) eaten.length = 0; // clear input buffer (if needed)
    while(pos){
        var _ret = _loop();
        if (_ret === "break") break;
    }
    return emoji;
}

});
parcelRequire.register("dgWym", function(module, exports) {

$parcel$export(module.exports, "getData", function () { return $9a9a30743d5267a8$export$7a171f172be0782e; });
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
var $70PIu = parcelRequire("70PIu");

var $25x8z = parcelRequire("25x8z");
function $9a9a30743d5267a8$export$7a171f172be0782e() {
    return (0, $25x8z.read_compressed_payload)((0, $70PIu.decode)("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"));
}

});
parcelRequire.register("25x8z", function(module, exports) {

$parcel$export(module.exports, "read_compressed_payload", function () { return $1855c0be68a16a45$export$671d8b4ebc0c42ad; });
$parcel$export(module.exports, "read_member_array", function () { return $1855c0be68a16a45$export$9303bf4e1ede4914; });
$parcel$export(module.exports, "read_mapped_map", function () { return $1855c0be68a16a45$export$824d00fb01c38bd9; });
$parcel$export(module.exports, "read_emoji_trie", function () { return $1855c0be68a16a45$export$d7b24c6ce369e1b7; });
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ // https://github.com/behnammodi/polyfill/blob/master/array.polyfill.js
function $1855c0be68a16a45$var$flat(array, depth) {
    if (depth == null) depth = 1;
    var result = [];
    var forEach = result.forEach;
    var flatDeep = function flatDeep1(arr, depth) {
        forEach.call(arr, function(val) {
            if (depth > 0 && Array.isArray(val)) flatDeep(val, depth - 1);
            else result.push(val);
        });
    };
    flatDeep(array, depth);
    return result;
}
function $1855c0be68a16a45$var$fromEntries(array) {
    var result = {};
    for(var i = 0; i < array.length; i++){
        var value = array[i];
        result[value[0]] = value[1];
    }
    return result;
}
function $1855c0be68a16a45$export$956eeed0f8f2ceff(bytes) {
    var u16 = function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    };
    var read_bit = function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    };
    var pos = 0;
    // decode the frequency table
    var symbol_count = u16();
    var total = 1;
    var acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(var i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    var skip = u16();
    var pos_payload = pos;
    pos += skip;
    var read_width = 0;
    var read_buffer = 0;
    var N = 31;
    var FULL = Math.pow(2, N);
    var HALF = FULL >>> 1;
    var QRTR = HALF >> 1;
    var MASK = FULL - 1;
    // fill register
    var register = 0;
    for(var i1 = 0; i1 < N; i1++)register = register << 1 | read_bit();
    var symbols = [];
    var low = 0;
    var range = FULL; // treat like a float
    while(true){
        var value = Math.floor(((register - low + 1) * total - 1) / range);
        var start = 0;
        var end = symbol_count;
        while(end - start > 1){
            var mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        var a = low + Math.floor(range * acc[start] / total);
        var b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    var offset = symbol_count - 4;
    return symbols.map(function(x) {
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
function $1855c0be68a16a45$export$2cda812f22276871(v) {
    var pos = 0;
    return function() {
        return v[pos++];
    };
}
function $1855c0be68a16a45$export$671d8b4ebc0c42ad(bytes) {
    return $1855c0be68a16a45$export$2cda812f22276871($1855c0be68a16a45$export$956eeed0f8f2ceff(bytes));
}
function $1855c0be68a16a45$export$a785de3a2a8dd1aa(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $1855c0be68a16a45$var$read_counts(n, next) {
    var v = Array(n);
    for(var i = 0; i < n; i++)v[i] = 1 + next();
    return v;
}
function $1855c0be68a16a45$var$read_ascending(n, next) {
    var v = Array(n);
    for(var i = 0, x = -1; i < n; i++)v[i] = x += 1 + next();
    return v;
}
function $1855c0be68a16a45$var$read_deltas(n, next) {
    var v = Array(n);
    for(var i = 0, x = 0; i < n; i++)v[i] = x += $1855c0be68a16a45$export$a785de3a2a8dd1aa(next());
    return v;
}
function $1855c0be68a16a45$export$9303bf4e1ede4914(next, lookup) {
    var v = $1855c0be68a16a45$var$read_ascending(next(), next);
    var n = next();
    var vX = $1855c0be68a16a45$var$read_ascending(n, next);
    var vN = $1855c0be68a16a45$var$read_counts(n, next);
    for(var i = 0; i < n; i++)for(var j = 0; j < vN[i]; j++)v.push(vX[i] + j);
    return lookup ? v.map(function(x) {
        return lookup[x];
    }) : v;
}
function $1855c0be68a16a45$export$824d00fb01c38bd9(next) {
    var ret = [];
    while(true){
        var w = next();
        if (w == 0) break;
        ret.push($1855c0be68a16a45$var$read_linear_table(w, next));
    }
    while(true){
        var w1 = next() - 1;
        if (w1 < 0) break;
        ret.push($1855c0be68a16a45$var$read_replacement_table(w1, next));
    }
    return $1855c0be68a16a45$var$fromEntries($1855c0be68a16a45$var$flat(ret));
}
function $1855c0be68a16a45$export$e9011071590ab431(next) {
    var v = [];
    while(true){
        var i = next();
        if (i == 0) break;
        v.push(i);
    }
    return v;
}
function $1855c0be68a16a45$var$read_transposed(n, w, next) {
    var m = Array(n).fill(undefined).map(function() {
        return [];
    });
    for(var i = 0; i < w; i++)$1855c0be68a16a45$var$read_deltas(n, next).forEach(function(x, j) {
        return m[j].push(x);
    });
    return m;
}
function $1855c0be68a16a45$var$read_linear_table(w, next) {
    var dx = 1 + next();
    var dy = next();
    var vN = $1855c0be68a16a45$export$e9011071590ab431(next);
    var m = $1855c0be68a16a45$var$read_transposed(vN.length, 1 + w, next);
    return $1855c0be68a16a45$var$flat(m.map(function(v, i) {
        var x = v[0], ys = v.slice(1);
        //let [x, ...ys] = v;
        //return Array(vN[i]).fill().map((_, j) => {
        return Array(vN[i]).fill(undefined).map(function(_, j) {
            var j_dy = j * dy;
            return [
                x + j * dx,
                ys.map(function(y) {
                    return y + j_dy;
                })
            ];
        });
    }));
}
function $1855c0be68a16a45$var$read_replacement_table(w, next) {
    var n = 1 + next();
    var m = $1855c0be68a16a45$var$read_transposed(n, 1 + w, next);
    return m.map(function(v) {
        return [
            v[0],
            v.slice(1)
        ];
    });
}
function $1855c0be68a16a45$export$d7b24c6ce369e1b7(next) {
    var sorted = $1855c0be68a16a45$export$9303bf4e1ede4914(next).sort(function(a, b) {
        return a - b;
    });
    return read();
    function read() {
        var branches = [];
        while(true){
            var keys = $1855c0be68a16a45$export$9303bf4e1ede4914(next, sorted);
            if (keys.length == 0) break;
            branches.push({
                set: new Set(keys),
                node: read()
            });
        }
        branches.sort(function(a, b) {
            return b.set.size - a.set.size;
        }); // sort by likelihood
        var temp = next();
        var valid = temp % 3;
        temp = temp / 3 | 0;
        var fe0f = !!(temp & 1);
        temp >>= 1;
        var save = temp == 1;
        var check = temp == 2;
        return {
            branches: branches,
            valid: valid,
            fe0f: fe0f,
            save: save,
            check: check
        };
    }
}

});




parcelRequire.register("7vZoR", function(module, exports) {

$parcel$export(module.exports, "hashMessage", function () { return $578b0e6ea1b3b477$export$d4c241cec96564c1; });

var $j2rU8 = parcelRequire("j2rU8");

var $4ujqV = parcelRequire("4ujqV");

var $1Wmc7 = parcelRequire("1Wmc7");
var $578b0e6ea1b3b477$export$1ff3fdc4802a2ba6 = "\x19Ethereum Signed Message:\n";
function $578b0e6ea1b3b477$export$d4c241cec96564c1(message) {
    if (typeof message === "string") message = (0, $1Wmc7.toUtf8Bytes)(message);
    return (0, $4ujqV.keccak256)((0, $j2rU8.concat)([
        (0, $1Wmc7.toUtf8Bytes)($578b0e6ea1b3b477$export$1ff3fdc4802a2ba6),
        (0, $1Wmc7.toUtf8Bytes)(String(message.length)),
        message
    ]));
}

});

parcelRequire.register("5iEGT", function(module, exports) {

$parcel$export(module.exports, "defaultPath", function () { return $3dbe328f09720d4a$export$d48ad89f7e11a603; });
$parcel$export(module.exports, "HDNode", function () { return $3dbe328f09720d4a$export$b68640c53e22b952; });
$parcel$export(module.exports, "entropyToMnemonic", function () { return $3dbe328f09720d4a$export$4becd65eb23312e6; });
$parcel$export(module.exports, "mnemonicToEntropy", function () { return $3dbe328f09720d4a$export$135e090d58b310ca; });
$parcel$export(module.exports, "mnemonicToSeed", function () { return $3dbe328f09720d4a$export$3dee74f1204ab09f; });
$parcel$export(module.exports, "isValidMnemonic", function () { return $3dbe328f09720d4a$export$5eea3393c6119c80; });
$parcel$export(module.exports, "getAccountPath", function () { return $3dbe328f09720d4a$export$22b80e4f9eff636d; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ebtr5 = parcelRequire("ebtr5");

var $j2rU8 = parcelRequire("j2rU8");

var $gMArf = parcelRequire("gMArf");

var $1Wmc7 = parcelRequire("1Wmc7");

var $eIQbV = parcelRequire("eIQbV");

var $2ax4w = parcelRequire("2ax4w");

var $4LuuL = parcelRequire("4LuuL");

var $7WUQV = parcelRequire("7WUQV");
var $aCF4U = parcelRequire("aCF4U");

var $hDQeE = parcelRequire("hDQeE");

var $1cpDB = parcelRequire("1cpDB");

var $6M65e = parcelRequire("6M65e");

var $4pr5p = parcelRequire("4pr5p");
"use strict";
var $3dbe328f09720d4a$var$logger = new (0, $6M65e.Logger)((0, $4pr5p.version));
var $3dbe328f09720d4a$var$N = (0, $gMArf.BigNumber).from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
var $3dbe328f09720d4a$var$MasterSecret = (0, $1Wmc7.toUtf8Bytes)("Bitcoin seed");
var $3dbe328f09720d4a$var$HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function $3dbe328f09720d4a$var$getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits;
}
// Returns a byte with the LSB bits set
function $3dbe328f09720d4a$var$getLowerMask(bits) {
    return (1 << bits) - 1;
}
function $3dbe328f09720d4a$var$bytes32(value) {
    return (0, $j2rU8.hexZeroPad)((0, $j2rU8.hexlify)(value), 32);
}
function $3dbe328f09720d4a$var$base58check(data) {
    return (0, $ebtr5.Base58).encode((0, $j2rU8.concat)([
        data,
        (0, $j2rU8.hexDataSlice)((0, $7WUQV.sha256)((0, $7WUQV.sha256)(data)), 0, 4)
    ]));
}
function $3dbe328f09720d4a$var$getWordlist(wordlist) {
    if (wordlist == null) return (0, $1cpDB.wordlists)["en"];
    if (typeof wordlist === "string") {
        var words = (0, $1cpDB.wordlists)[wordlist];
        if (words == null) $3dbe328f09720d4a$var$logger.throwArgumentError("unknown locale", "wordlist", wordlist);
        return words;
    }
    return wordlist;
}
var $3dbe328f09720d4a$var$_constructorGuard = {};
var $3dbe328f09720d4a$export$d48ad89f7e11a603 = "m/44'/60'/0'/0/0";
var $3dbe328f09720d4a$export$b68640c53e22b952 = /*#__PURE__*/ function() {
    function HDNode(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonicOrPath) {
        (0, $978gY._)(this, HDNode);
        /* istanbul ignore if */ if (constructorGuard !== $3dbe328f09720d4a$var$_constructorGuard) throw new Error("HDNode constructor cannot be called directly");
        if (privateKey) {
            var signingKey = new (0, $4LuuL.SigningKey)(privateKey);
            (0, $2ax4w.defineReadOnly)(this, "privateKey", signingKey.privateKey);
            (0, $2ax4w.defineReadOnly)(this, "publicKey", signingKey.compressedPublicKey);
        } else {
            (0, $2ax4w.defineReadOnly)(this, "privateKey", null);
            (0, $2ax4w.defineReadOnly)(this, "publicKey", (0, $j2rU8.hexlify)(publicKey));
        }
        (0, $2ax4w.defineReadOnly)(this, "parentFingerprint", parentFingerprint);
        (0, $2ax4w.defineReadOnly)(this, "fingerprint", (0, $j2rU8.hexDataSlice)((0, $7WUQV.ripemd160)((0, $7WUQV.sha256)(this.publicKey)), 0, 4));
        (0, $2ax4w.defineReadOnly)(this, "address", (0, $hDQeE.computeAddress)(this.publicKey));
        (0, $2ax4w.defineReadOnly)(this, "chainCode", chainCode);
        (0, $2ax4w.defineReadOnly)(this, "index", index);
        (0, $2ax4w.defineReadOnly)(this, "depth", depth);
        if (mnemonicOrPath == null) {
            // From a source that does not preserve the path (e.g. extended keys)
            (0, $2ax4w.defineReadOnly)(this, "mnemonic", null);
            (0, $2ax4w.defineReadOnly)(this, "path", null);
        } else if (typeof mnemonicOrPath === "string") {
            // From a source that does not preserve the mnemonic (e.g. neutered)
            (0, $2ax4w.defineReadOnly)(this, "mnemonic", null);
            (0, $2ax4w.defineReadOnly)(this, "path", mnemonicOrPath);
        } else {
            // From a fully qualified source
            (0, $2ax4w.defineReadOnly)(this, "mnemonic", mnemonicOrPath);
            (0, $2ax4w.defineReadOnly)(this, "path", mnemonicOrPath.path);
        }
    }
    (0, $kry2a._)(HDNode, [
        {
            key: "extendedKey",
            get: function get() {
                // We only support the mainnet values for now, but if anyone needs
                // testnet values, let me know. I believe current sentiment is that
                // we should always use mainnet, and use BIP-44 to derive the network
                //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
                //   - Testnet: public=0x043587CF, private=0x04358394
                if (this.depth >= 256) throw new Error("Depth too large!");
                return $3dbe328f09720d4a$var$base58check((0, $j2rU8.concat)([
                    this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
                    (0, $j2rU8.hexlify)(this.depth),
                    this.parentFingerprint,
                    (0, $j2rU8.hexZeroPad)((0, $j2rU8.hexlify)(this.index), 4),
                    this.chainCode,
                    this.privateKey != null ? (0, $j2rU8.concat)([
                        "0x00",
                        this.privateKey
                    ]) : this.publicKey
                ]));
            }
        },
        {
            key: "neuter",
            value: function neuter() {
                return new HDNode($3dbe328f09720d4a$var$_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
            }
        },
        {
            key: "_derive",
            value: function _derive(index) {
                if (index > 0xffffffff) throw new Error("invalid index - " + String(index));
                // Base path
                var path = this.path;
                if (path) path += "/" + (index & ~$3dbe328f09720d4a$var$HardenedBit);
                var data = new Uint8Array(37);
                if (index & $3dbe328f09720d4a$var$HardenedBit) {
                    if (!this.privateKey) throw new Error("cannot derive child of neutered node");
                    // Data = 0x00 || ser_256(k_par)
                    data.set((0, $j2rU8.arrayify)(this.privateKey), 1);
                    // Hardened path
                    if (path) path += "'";
                } else // Data = ser_p(point(k_par))
                data.set((0, $j2rU8.arrayify)(this.publicKey));
                // Data += ser_32(i)
                for(var i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
                var I = (0, $j2rU8.arrayify)((0, $7WUQV.computeHmac)((0, $aCF4U.SupportedAlgorithm).sha512, this.chainCode, data));
                var IL = I.slice(0, 32);
                var IR = I.slice(32);
                // The private key
                var ki = null;
                // The public key
                var Ki = null;
                if (this.privateKey) ki = $3dbe328f09720d4a$var$bytes32((0, $gMArf.BigNumber).from(IL).add(this.privateKey).mod($3dbe328f09720d4a$var$N));
                else {
                    var ek = new (0, $4LuuL.SigningKey)((0, $j2rU8.hexlify)(IL));
                    Ki = ek._addPoint(this.publicKey);
                }
                var mnemonicOrPath = path;
                var srcMnemonic = this.mnemonic;
                if (srcMnemonic) mnemonicOrPath = Object.freeze({
                    phrase: srcMnemonic.phrase,
                    path: path,
                    locale: srcMnemonic.locale || "en"
                });
                return new HDNode($3dbe328f09720d4a$var$_constructorGuard, ki, Ki, this.fingerprint, $3dbe328f09720d4a$var$bytes32(IR), index, this.depth + 1, mnemonicOrPath);
            }
        },
        {
            key: "derivePath",
            value: function derivePath(path) {
                var components = path.split("/");
                if (components.length === 0 || components[0] === "m" && this.depth !== 0) throw new Error("invalid path - " + path);
                if (components[0] === "m") components.shift();
                var result = this;
                for(var i = 0; i < components.length; i++){
                    var component = components[i];
                    if (component.match(/^[0-9]+'$/)) {
                        var index = parseInt(component.substring(0, component.length - 1));
                        if (index >= $3dbe328f09720d4a$var$HardenedBit) throw new Error("invalid path index - " + component);
                        result = result._derive($3dbe328f09720d4a$var$HardenedBit + index);
                    } else if (component.match(/^[0-9]+$/)) {
                        var index1 = parseInt(component);
                        if (index1 >= $3dbe328f09720d4a$var$HardenedBit) throw new Error("invalid path index - " + component);
                        result = result._derive(index1);
                    } else throw new Error("invalid path component - " + component);
                }
                return result;
            }
        }
    ], [
        {
            key: "_fromSeed",
            value: function _fromSeed(seed, mnemonic) {
                var seedArray = (0, $j2rU8.arrayify)(seed);
                if (seedArray.length < 16 || seedArray.length > 64) throw new Error("invalid seed");
                var I = (0, $j2rU8.arrayify)((0, $7WUQV.computeHmac)((0, $aCF4U.SupportedAlgorithm).sha512, $3dbe328f09720d4a$var$MasterSecret, seedArray));
                return new HDNode($3dbe328f09720d4a$var$_constructorGuard, $3dbe328f09720d4a$var$bytes32(I.slice(0, 32)), null, "0x00000000", $3dbe328f09720d4a$var$bytes32(I.slice(32)), 0, 0, mnemonic);
            }
        },
        {
            key: "fromMnemonic",
            value: function fromMnemonic(mnemonic, password, wordlist) {
                // If a locale name was passed in, find the associated wordlist
                wordlist = $3dbe328f09720d4a$var$getWordlist(wordlist);
                // Normalize the case and spacing in the mnemonic (throws if the mnemonic is invalid)
                mnemonic = $3dbe328f09720d4a$export$4becd65eb23312e6($3dbe328f09720d4a$export$135e090d58b310ca(mnemonic, wordlist), wordlist);
                return HDNode._fromSeed($3dbe328f09720d4a$export$3dee74f1204ab09f(mnemonic, password), {
                    phrase: mnemonic,
                    path: "m",
                    locale: wordlist.locale
                });
            }
        },
        {
            key: "fromSeed",
            value: function fromSeed(seed) {
                return HDNode._fromSeed(seed, null);
            }
        },
        {
            key: "fromExtendedKey",
            value: function fromExtendedKey(extendedKey) {
                var bytes = (0, $ebtr5.Base58).decode(extendedKey);
                if (bytes.length !== 82 || $3dbe328f09720d4a$var$base58check(bytes.slice(0, 78)) !== extendedKey) $3dbe328f09720d4a$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
                var depth = bytes[4];
                var parentFingerprint = (0, $j2rU8.hexlify)(bytes.slice(5, 9));
                var index = parseInt((0, $j2rU8.hexlify)(bytes.slice(9, 13)).substring(2), 16);
                var chainCode = (0, $j2rU8.hexlify)(bytes.slice(13, 45));
                var key = bytes.slice(45, 78);
                switch((0, $j2rU8.hexlify)(bytes.slice(0, 4))){
                    // Public Key
                    case "0x0488b21e":
                    case "0x043587cf":
                        return new HDNode($3dbe328f09720d4a$var$_constructorGuard, null, (0, $j2rU8.hexlify)(key), parentFingerprint, chainCode, index, depth, null);
                    // Private Key
                    case "0x0488ade4":
                    case "0x04358394 ":
                        if (key[0] !== 0) break;
                        return new HDNode($3dbe328f09720d4a$var$_constructorGuard, (0, $j2rU8.hexlify)(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null);
                }
                return $3dbe328f09720d4a$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
            }
        }
    ]);
    return HDNode;
}();
function $3dbe328f09720d4a$export$3dee74f1204ab09f(mnemonic, password) {
    if (!password) password = "";
    var salt = (0, $1Wmc7.toUtf8Bytes)("mnemonic" + password, (0, $1Wmc7.UnicodeNormalizationForm).NFKD);
    return (0, $eIQbV.pbkdf2)((0, $1Wmc7.toUtf8Bytes)(mnemonic, (0, $1Wmc7.UnicodeNormalizationForm).NFKD), salt, 2048, 64, "sha512");
}
function $3dbe328f09720d4a$export$135e090d58b310ca(mnemonic, wordlist) {
    wordlist = $3dbe328f09720d4a$var$getWordlist(wordlist);
    $3dbe328f09720d4a$var$logger.checkNormalize();
    var words = wordlist.split(mnemonic);
    if (words.length % 3 !== 0) throw new Error("invalid mnemonic");
    var entropy = (0, $j2rU8.arrayify)(new Uint8Array(Math.ceil(11 * words.length / 8)));
    var offset = 0;
    for(var i = 0; i < words.length; i++){
        var index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) throw new Error("invalid mnemonic");
        for(var bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    var entropyBits = 32 * words.length / 3;
    var checksumBits = words.length / 3;
    var checksumMask = $3dbe328f09720d4a$var$getUpperMask(checksumBits);
    var checksum = (0, $j2rU8.arrayify)((0, $7WUQV.sha256)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) throw new Error("invalid checksum");
    return (0, $j2rU8.hexlify)(entropy.slice(0, entropyBits / 8));
}
function $3dbe328f09720d4a$export$4becd65eb23312e6(entropy, wordlist) {
    wordlist = $3dbe328f09720d4a$var$getWordlist(wordlist);
    entropy = (0, $j2rU8.arrayify)(entropy);
    if (entropy.length % 4 !== 0 || entropy.length < 16 || entropy.length > 32) throw new Error("invalid entropy");
    var indices = [
        0
    ];
    var remainingBits = 11;
    for(var i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & $3dbe328f09720d4a$var$getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    var checksumBits = entropy.length / 4;
    var checksum = (0, $j2rU8.arrayify)((0, $7WUQV.sha256)(entropy))[0] & $3dbe328f09720d4a$var$getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    return wordlist.join(indices.map(function(index) {
        return wordlist.getWord(index);
    }));
}
function $3dbe328f09720d4a$export$5eea3393c6119c80(mnemonic, wordlist) {
    try {
        $3dbe328f09720d4a$export$135e090d58b310ca(mnemonic, wordlist);
        return true;
    } catch (error) {}
    return false;
}
function $3dbe328f09720d4a$export$22b80e4f9eff636d(index) {
    if (typeof index !== "number" || index < 0 || index >= $3dbe328f09720d4a$var$HardenedBit || index % 1) $3dbe328f09720d4a$var$logger.throwArgumentError("invalid account index", "index", index);
    return "m/44'/60'/".concat(index, "'/0/0");
}

});
parcelRequire.register("eIQbV", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $ab7da8db31000bcc$export$448fa22aedc9dbca; });

var $j2rU8 = parcelRequire("j2rU8");

var $7WUQV = parcelRequire("7WUQV");
"use strict";
function $ab7da8db31000bcc$export$448fa22aedc9dbca(password, salt, iterations, keylen, hashAlgorithm) {
    password = (0, $j2rU8.arrayify)(password);
    salt = (0, $j2rU8.arrayify)(salt);
    var hLen;
    var l = 1;
    var DK = new Uint8Array(keylen);
    var block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    var r;
    var T;
    for(var i = 1; i <= l; i++){
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = i >> 24 & 0xff;
        block1[salt.length + 1] = i >> 16 & 0xff;
        block1[salt.length + 2] = i >> 8 & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        var U = (0, $j2rU8.arrayify)((0, $7WUQV.computeHmac)(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for(var j = 1; j < iterations; j++){
            //U = createHmac(password).update(U).digest();
            U = (0, $j2rU8.arrayify)((0, $7WUQV.computeHmac)(hashAlgorithm, password, U));
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        var destPos = (i - 1) * hLen;
        var len = i === l ? r : hLen;
        //T.copy(DK, destPos, 0, len)
        DK.set((0, $j2rU8.arrayify)(T).slice(0, len), destPos);
    }
    return (0, $j2rU8.hexlify)(DK);
}

});
parcelRequire.register("7WUQV", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $5c9a0ceac3511c58$export$d1cea0ee4e3f0d3e; });
$parcel$export(module.exports, "sha256", function () { return $5c9a0ceac3511c58$export$bced8d2aada2d1c9; });
$parcel$export(module.exports, "sha512", function () { return $5c9a0ceac3511c58$export$a888d2532e6dc7bb; });
$parcel$export(module.exports, "computeHmac", function () { return $5c9a0ceac3511c58$export$967075d2f3b8e7ff; });

var $dMFrt = parcelRequire("dMFrt");

var $j2rU8 = parcelRequire("j2rU8");

var $aCF4U = parcelRequire("aCF4U");

var $6M65e = parcelRequire("6M65e");

var $ao76v = parcelRequire("ao76v");
"use strict";
var $5c9a0ceac3511c58$var$logger = new (0, $6M65e.Logger)((0, $ao76v.version));
function $5c9a0ceac3511c58$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).ripemd160().update((0, $j2rU8.arrayify)(data)).digest("hex");
}
function $5c9a0ceac3511c58$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256().update((0, $j2rU8.arrayify)(data)).digest("hex");
}
function $5c9a0ceac3511c58$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha512().update((0, $j2rU8.arrayify)(data)).digest("hex");
}
function $5c9a0ceac3511c58$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $aCF4U.SupportedAlgorithm)[algorithm]) $5c9a0ceac3511c58$var$logger.throwError("unsupported algorithm " + algorithm, (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($dMFrt)))[algorithm], (0, $j2rU8.arrayify)(key)).update((0, $j2rU8.arrayify)(data)).digest("hex");
}

});
parcelRequire.register("dMFrt", function(module, exports) {
var $a08fe79466179a86$var$hash = module.exports;

$a08fe79466179a86$var$hash.utils = (parcelRequire("cYl7t"));

$a08fe79466179a86$var$hash.common = (parcelRequire("1pS1U"));

$a08fe79466179a86$var$hash.sha = (parcelRequire("imuzp"));

$a08fe79466179a86$var$hash.ripemd = (parcelRequire("jAZNy"));

$a08fe79466179a86$var$hash.hmac = (parcelRequire("hC4jp"));
// Proxy hash functions to the main object
$a08fe79466179a86$var$hash.sha1 = $a08fe79466179a86$var$hash.sha.sha1;
$a08fe79466179a86$var$hash.sha256 = $a08fe79466179a86$var$hash.sha.sha256;
$a08fe79466179a86$var$hash.sha224 = $a08fe79466179a86$var$hash.sha.sha224;
$a08fe79466179a86$var$hash.sha384 = $a08fe79466179a86$var$hash.sha.sha384;
$a08fe79466179a86$var$hash.sha512 = $a08fe79466179a86$var$hash.sha.sha512;
$a08fe79466179a86$var$hash.ripemd160 = $a08fe79466179a86$var$hash.ripemd.ripemd160;

});

parcelRequire.register("aCF4U", function(module, exports) {

$parcel$export(module.exports, "SupportedAlgorithm", function () { return $7bbd5149c083ead5$export$d2a8849cfb277c; });
var $7bbd5149c083ead5$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($7bbd5149c083ead5$export$d2a8849cfb277c || ($7bbd5149c083ead5$export$d2a8849cfb277c = {}));

});

parcelRequire.register("ao76v", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $7901a7f807ca448e$export$83d89fbfd8236492; });
var $7901a7f807ca448e$export$83d89fbfd8236492 = "sha2/5.7.0";

});



parcelRequire.register("4LuuL", function(module, exports) {

$parcel$export(module.exports, "SigningKey", function () { return $378334ead6ec6b6e$export$21643ca94aed3e83; });
$parcel$export(module.exports, "computePublicKey", function () { return $378334ead6ec6b6e$export$4a89473d39301224; });
$parcel$export(module.exports, "recoverPublicKey", function () { return $378334ead6ec6b6e$export$952dd09fbe0232b7; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $4wU5f = parcelRequire("4wU5f");

var $j2rU8 = parcelRequire("j2rU8");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $LonJE = parcelRequire("LonJE");
"use strict";
var $378334ead6ec6b6e$var$logger = new (0, $6M65e.Logger)((0, $LonJE.version));
var $378334ead6ec6b6e$var$_curve = null;
function $378334ead6ec6b6e$var$getCurve() {
    if (!$378334ead6ec6b6e$var$_curve) $378334ead6ec6b6e$var$_curve = new (0, $4wU5f.EC)("secp256k1");
    return $378334ead6ec6b6e$var$_curve;
}
var $378334ead6ec6b6e$export$21643ca94aed3e83 = /*#__PURE__*/ function() {
    function SigningKey(privateKey) {
        (0, $978gY._)(this, SigningKey);
        (0, $2ax4w.defineReadOnly)(this, "curve", "secp256k1");
        (0, $2ax4w.defineReadOnly)(this, "privateKey", (0, $j2rU8.hexlify)(privateKey));
        if ((0, $j2rU8.hexDataLength)(this.privateKey) !== 32) $378334ead6ec6b6e$var$logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        var keyPair = $378334ead6ec6b6e$var$getCurve().keyFromPrivate((0, $j2rU8.arrayify)(this.privateKey));
        (0, $2ax4w.defineReadOnly)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $2ax4w.defineReadOnly)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $2ax4w.defineReadOnly)(this, "_isSigningKey", true);
    }
    (0, $kry2a._)(SigningKey, [
        {
            key: "_addPoint",
            value: function _addPoint(other) {
                var p0 = $378334ead6ec6b6e$var$getCurve().keyFromPublic((0, $j2rU8.arrayify)(this.publicKey));
                var p1 = $378334ead6ec6b6e$var$getCurve().keyFromPublic((0, $j2rU8.arrayify)(other));
                return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
            }
        },
        {
            key: "signDigest",
            value: function signDigest(digest) {
                var keyPair = $378334ead6ec6b6e$var$getCurve().keyFromPrivate((0, $j2rU8.arrayify)(this.privateKey));
                var digestBytes = (0, $j2rU8.arrayify)(digest);
                if (digestBytes.length !== 32) $378334ead6ec6b6e$var$logger.throwArgumentError("bad digest length", "digest", digest);
                var signature = keyPair.sign(digestBytes, {
                    canonical: true
                });
                return (0, $j2rU8.splitSignature)({
                    recoveryParam: signature.recoveryParam,
                    r: (0, $j2rU8.hexZeroPad)("0x" + signature.r.toString(16), 32),
                    s: (0, $j2rU8.hexZeroPad)("0x" + signature.s.toString(16), 32)
                });
            }
        },
        {
            key: "computeSharedSecret",
            value: function computeSharedSecret(otherKey) {
                var keyPair = $378334ead6ec6b6e$var$getCurve().keyFromPrivate((0, $j2rU8.arrayify)(this.privateKey));
                var otherKeyPair = $378334ead6ec6b6e$var$getCurve().keyFromPublic((0, $j2rU8.arrayify)($378334ead6ec6b6e$export$4a89473d39301224(otherKey)));
                return (0, $j2rU8.hexZeroPad)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
            }
        }
    ], [
        {
            key: "isSigningKey",
            value: function isSigningKey(value) {
                return !!(value && value._isSigningKey);
            }
        }
    ]);
    return SigningKey;
}();
function $378334ead6ec6b6e$export$952dd09fbe0232b7(digest, signature) {
    var sig = (0, $j2rU8.splitSignature)(signature);
    var rs = {
        r: (0, $j2rU8.arrayify)(sig.r),
        s: (0, $j2rU8.arrayify)(sig.s)
    };
    return "0x" + $378334ead6ec6b6e$var$getCurve().recoverPubKey((0, $j2rU8.arrayify)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $378334ead6ec6b6e$export$4a89473d39301224(key, compressed) {
    var bytes = (0, $j2rU8.arrayify)(key);
    if (bytes.length === 32) {
        var signingKey = new $378334ead6ec6b6e$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $378334ead6ec6b6e$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $j2rU8.hexlify)(bytes);
        return "0x" + $378334ead6ec6b6e$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $j2rU8.hexlify)(bytes);
        return "0x" + $378334ead6ec6b6e$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $378334ead6ec6b6e$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}

});
parcelRequire.register("4wU5f", function(module, exports) {

$parcel$export(module.exports, "EC", function () { return $34c5a7a115bc641e$export$129fe12d32abc311; });

var $jlWHo = parcelRequire("jlWHo");

var $dMFrt = parcelRequire("dMFrt");
var $34c5a7a115bc641e$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $34c5a7a115bc641e$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $34c5a7a115bc641e$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function require(path, base) {
            return $34c5a7a115bc641e$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $34c5a7a115bc641e$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $34c5a7a115bc641e$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $34c5a7a115bc641e$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function get() {
                return n[k];
            }
        });
    });
    return a;
}
function $34c5a7a115bc641e$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $34c5a7a115bc641e$var$minimalisticAssert = $34c5a7a115bc641e$var$assert;
function $34c5a7a115bc641e$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$34c5a7a115bc641e$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $34c5a7a115bc641e$var$utils_1 = $34c5a7a115bc641e$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var toArray = function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    };
    var zero2 = function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    };
    var toHex = function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    };
    var utils = exports;
    utils.toArray = toArray;
    utils.zero2 = zero2;
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $34c5a7a115bc641e$var$utils_1$1 = $34c5a7a115bc641e$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var getNAF = // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    };
    var getJSF = // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    };
    var cachedProperty = function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    };
    var parseBytes = function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    };
    var intFromLE = function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(bytes, "hex", "le");
    };
    var utils = exports;
    utils.assert = $34c5a7a115bc641e$var$minimalisticAssert;
    utils.toArray = $34c5a7a115bc641e$var$utils_1.toArray;
    utils.zero2 = $34c5a7a115bc641e$var$utils_1.zero2;
    utils.toHex = $34c5a7a115bc641e$var$utils_1.toHex;
    utils.encode = $34c5a7a115bc641e$var$utils_1.encode;
    utils.getNAF = getNAF;
    utils.getJSF = getJSF;
    utils.cachedProperty = cachedProperty;
    utils.parseBytes = parseBytes;
    utils.intFromLE = intFromLE;
});
"use strict";
var $34c5a7a115bc641e$var$getNAF = $34c5a7a115bc641e$var$utils_1$1.getNAF;
var $34c5a7a115bc641e$var$getJSF = $34c5a7a115bc641e$var$utils_1$1.getJSF;
var $34c5a7a115bc641e$var$assert$1 = $34c5a7a115bc641e$var$utils_1$1.assert;
function $34c5a7a115bc641e$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $34c5a7a115bc641e$var$base = $34c5a7a115bc641e$var$BaseCurve;
$34c5a7a115bc641e$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$34c5a7a115bc641e$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$34c5a7a115bc641e$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $34c5a7a115bc641e$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $34c5a7a115bc641e$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$34c5a7a115bc641e$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $34c5a7a115bc641e$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $34c5a7a115bc641e$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$34c5a7a115bc641e$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $34c5a7a115bc641e$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $34c5a7a115bc641e$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $34c5a7a115bc641e$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $34c5a7a115bc641e$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$34c5a7a115bc641e$var$BaseCurve.BasePoint = $34c5a7a115bc641e$var$BasePoint;
$34c5a7a115bc641e$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$34c5a7a115bc641e$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$34c5a7a115bc641e$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $34c5a7a115bc641e$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $34c5a7a115bc641e$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $34c5a7a115bc641e$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$34c5a7a115bc641e$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$34c5a7a115bc641e$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$34c5a7a115bc641e$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $34c5a7a115bc641e$var$utils_1$1.encode(this._encode(compact), enc);
};
$34c5a7a115bc641e$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$34c5a7a115bc641e$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$34c5a7a115bc641e$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$34c5a7a115bc641e$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$34c5a7a115bc641e$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$34c5a7a115bc641e$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $34c5a7a115bc641e$var$inherits_browser = $34c5a7a115bc641e$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function TempCtor() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $34c5a7a115bc641e$var$assert$2 = $34c5a7a115bc641e$var$utils_1$1.assert;
function $34c5a7a115bc641e$var$ShortCurve(conf) {
    $34c5a7a115bc641e$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$34c5a7a115bc641e$var$inherits_browser($34c5a7a115bc641e$var$ShortCurve, $34c5a7a115bc641e$var$base);
var $34c5a7a115bc641e$var$short_1 = $34c5a7a115bc641e$var$ShortCurve;
$34c5a7a115bc641e$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $34c5a7a115bc641e$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$34c5a7a115bc641e$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$34c5a7a115bc641e$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$34c5a7a115bc641e$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$34c5a7a115bc641e$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$34c5a7a115bc641e$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$34c5a7a115bc641e$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $34c5a7a115bc641e$var$Point(curve, x, y, isRed) {
    $34c5a7a115bc641e$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$34c5a7a115bc641e$var$inherits_browser($34c5a7a115bc641e$var$Point, $34c5a7a115bc641e$var$base.BasePoint);
$34c5a7a115bc641e$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $34c5a7a115bc641e$var$Point(this, x, y, isRed);
};
$34c5a7a115bc641e$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $34c5a7a115bc641e$var$Point.fromJSON(this, obj, red);
};
$34c5a7a115bc641e$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function endoMul(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$34c5a7a115bc641e$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$34c5a7a115bc641e$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    var obj2point = function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    };
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$34c5a7a115bc641e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$34c5a7a115bc641e$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$34c5a7a115bc641e$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$34c5a7a115bc641e$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$34c5a7a115bc641e$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$34c5a7a115bc641e$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$34c5a7a115bc641e$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$34c5a7a115bc641e$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$34c5a7a115bc641e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$34c5a7a115bc641e$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$34c5a7a115bc641e$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function negate(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$34c5a7a115bc641e$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $34c5a7a115bc641e$var$JPoint(curve, x, y, z) {
    $34c5a7a115bc641e$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$34c5a7a115bc641e$var$inherits_browser($34c5a7a115bc641e$var$JPoint, $34c5a7a115bc641e$var$base.BasePoint);
$34c5a7a115bc641e$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $34c5a7a115bc641e$var$JPoint(this, x, y, z);
};
$34c5a7a115bc641e$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$34c5a7a115bc641e$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$34c5a7a115bc641e$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$34c5a7a115bc641e$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$34c5a7a115bc641e$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$34c5a7a115bc641e$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$34c5a7a115bc641e$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$34c5a7a115bc641e$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$34c5a7a115bc641e$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $34c5a7a115bc641e$var$curve_1 = $34c5a7a115bc641e$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $34c5a7a115bc641e$var$base;
    curve.short = $34c5a7a115bc641e$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $34c5a7a115bc641e$var$curves_1 = $34c5a7a115bc641e$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var PresetCurve = function PresetCurve(options) {
        if (options.type === "short") this.curve = new $34c5a7a115bc641e$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $34c5a7a115bc641e$var$curve_1.edwards(options);
        else this.curve = new $34c5a7a115bc641e$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        _$assert(this.g.validate(), "Invalid curve");
        _$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    };
    var defineCurve = function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function get() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    };
    var curves = exports;
    var _$assert = $34c5a7a115bc641e$var$utils_1$1.assert;
    curves.PresetCurve = PresetCurve;
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $34c5a7a115bc641e$var$HmacDRBG(options) {
    if (!(this instanceof $34c5a7a115bc641e$var$HmacDRBG)) return new $34c5a7a115bc641e$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $34c5a7a115bc641e$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $34c5a7a115bc641e$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $34c5a7a115bc641e$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $34c5a7a115bc641e$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $34c5a7a115bc641e$var$hmacDrbg = $34c5a7a115bc641e$var$HmacDRBG;
$34c5a7a115bc641e$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$34c5a7a115bc641e$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).hmac(this.hash, this.K);
};
$34c5a7a115bc641e$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$34c5a7a115bc641e$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $34c5a7a115bc641e$var$utils_1.toArray(entropy, entropyEnc);
    add = $34c5a7a115bc641e$var$utils_1.toArray(add, addEnc);
    $34c5a7a115bc641e$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$34c5a7a115bc641e$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $34c5a7a115bc641e$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $34c5a7a115bc641e$var$utils_1.encode(res, enc);
};
"use strict";
var $34c5a7a115bc641e$var$assert$3 = $34c5a7a115bc641e$var$utils_1$1.assert;
function $34c5a7a115bc641e$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $34c5a7a115bc641e$var$key = $34c5a7a115bc641e$var$KeyPair;
$34c5a7a115bc641e$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $34c5a7a115bc641e$var$KeyPair) return pub;
    return new $34c5a7a115bc641e$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$34c5a7a115bc641e$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $34c5a7a115bc641e$var$KeyPair) return priv;
    return new $34c5a7a115bc641e$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$34c5a7a115bc641e$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$34c5a7a115bc641e$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$34c5a7a115bc641e$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$34c5a7a115bc641e$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$34c5a7a115bc641e$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $34c5a7a115bc641e$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $34c5a7a115bc641e$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$34c5a7a115bc641e$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $34c5a7a115bc641e$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$34c5a7a115bc641e$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$34c5a7a115bc641e$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$34c5a7a115bc641e$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $34c5a7a115bc641e$var$assert$4 = $34c5a7a115bc641e$var$utils_1$1.assert;
function $34c5a7a115bc641e$var$Signature(options, enc) {
    if (options instanceof $34c5a7a115bc641e$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $34c5a7a115bc641e$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $34c5a7a115bc641e$var$signature = $34c5a7a115bc641e$var$Signature;
function $34c5a7a115bc641e$var$Position() {
    this.place = 0;
}
function $34c5a7a115bc641e$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $34c5a7a115bc641e$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$34c5a7a115bc641e$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $34c5a7a115bc641e$var$utils_1$1.toArray(data, enc);
    var p = new $34c5a7a115bc641e$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $34c5a7a115bc641e$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $34c5a7a115bc641e$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $34c5a7a115bc641e$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(s);
    this.recoveryParam = null;
    return true;
};
function $34c5a7a115bc641e$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$34c5a7a115bc641e$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $34c5a7a115bc641e$var$rmPadding(r);
    s = $34c5a7a115bc641e$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $34c5a7a115bc641e$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $34c5a7a115bc641e$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $34c5a7a115bc641e$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $34c5a7a115bc641e$var$utils_1$1.encode(res, enc);
};
"use strict";
var $34c5a7a115bc641e$var$rand = /*RicMoo:ethers:require(brorand)*/ function rand() {
    throw new Error("unsupported");
};
var $34c5a7a115bc641e$var$assert$5 = $34c5a7a115bc641e$var$utils_1$1.assert;
function $34c5a7a115bc641e$var$EC(options) {
    if (!(this instanceof $34c5a7a115bc641e$var$EC)) return new $34c5a7a115bc641e$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $34c5a7a115bc641e$var$assert$5(Object.prototype.hasOwnProperty.call($34c5a7a115bc641e$var$curves_1, options), "Unknown curve " + options);
        options = $34c5a7a115bc641e$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $34c5a7a115bc641e$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $34c5a7a115bc641e$var$ec = $34c5a7a115bc641e$var$EC;
$34c5a7a115bc641e$var$EC.prototype.keyPair = function keyPair(options) {
    return new $34c5a7a115bc641e$var$key(this, options);
};
$34c5a7a115bc641e$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $34c5a7a115bc641e$var$key.fromPrivate(this, priv, enc);
};
$34c5a7a115bc641e$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $34c5a7a115bc641e$var$key.fromPublic(this, pub, enc);
};
$34c5a7a115bc641e$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $34c5a7a115bc641e$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $34c5a7a115bc641e$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$34c5a7a115bc641e$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$34c5a7a115bc641e$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $34c5a7a115bc641e$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $34c5a7a115bc641e$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$34c5a7a115bc641e$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $34c5a7a115bc641e$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$34c5a7a115bc641e$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $34c5a7a115bc641e$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $34c5a7a115bc641e$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$34c5a7a115bc641e$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $34c5a7a115bc641e$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $34c5a7a115bc641e$var$elliptic_1 = $34c5a7a115bc641e$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $34c5a7a115bc641e$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $34c5a7a115bc641e$var$curve_1;
    elliptic.curves = $34c5a7a115bc641e$var$curves_1;
    // Protocols
    elliptic.ec = $34c5a7a115bc641e$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $34c5a7a115bc641e$export$129fe12d32abc311 = $34c5a7a115bc641e$var$elliptic_1.ec;

});

parcelRequire.register("LonJE", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $08e74d9fa9766383$export$83d89fbfd8236492; });
var $08e74d9fa9766383$export$83d89fbfd8236492 = "signing-key/5.7.0";

});


parcelRequire.register("hDQeE", function(module, exports) {

$parcel$export(module.exports, "TransactionTypes", function () { return $cd7e99036b8e7d03$export$80349e05e0724e11; });
$parcel$export(module.exports, "computeAddress", function () { return $cd7e99036b8e7d03$export$e67e2732ba9803f9; });
$parcel$export(module.exports, "recoverAddress", function () { return $cd7e99036b8e7d03$export$23cc18f96d8510e2; });
$parcel$export(module.exports, "accessListify", function () { return $cd7e99036b8e7d03$export$6c8662b1600dce2; });
$parcel$export(module.exports, "serialize", function () { return $cd7e99036b8e7d03$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "parse", function () { return $cd7e99036b8e7d03$export$98e6a39c04603d36; });

var $e8NrM = parcelRequire("e8NrM");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $f2VSc = parcelRequire("f2VSc");

var $4ujqV = parcelRequire("4ujqV");

var $2ax4w = parcelRequire("2ax4w");

var $dQcqA = parcelRequire("dQcqA");

var $4LuuL = parcelRequire("4LuuL");

var $6M65e = parcelRequire("6M65e");

var $gKSLq = parcelRequire("gKSLq");
"use strict";
var $cd7e99036b8e7d03$var$logger = new (0, $6M65e.Logger)((0, $gKSLq.version));
var $cd7e99036b8e7d03$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($cd7e99036b8e7d03$export$80349e05e0724e11 || ($cd7e99036b8e7d03$export$80349e05e0724e11 = {}));
///////////////////////////////
function $cd7e99036b8e7d03$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $e8NrM.getAddress)(value);
}
function $cd7e99036b8e7d03$var$handleNumber(value) {
    if (value === "0x") return 0, $f2VSc.Zero;
    return (0, $gMArf.BigNumber).from(value);
}
// Legacy Transaction Fields
var $cd7e99036b8e7d03$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
var $cd7e99036b8e7d03$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $cd7e99036b8e7d03$export$e67e2732ba9803f9(key) {
    var publicKey = (0, $4LuuL.computePublicKey)(key);
    return (0, $e8NrM.getAddress)((0, $j2rU8.hexDataSlice)((0, $4ujqV.keccak256)((0, $j2rU8.hexDataSlice)(publicKey, 1)), 12));
}
function $cd7e99036b8e7d03$export$23cc18f96d8510e2(digest, signature) {
    return $cd7e99036b8e7d03$export$e67e2732ba9803f9((0, $4LuuL.recoverPublicKey)((0, $j2rU8.arrayify)(digest), signature));
}
function $cd7e99036b8e7d03$var$formatNumber(value, name) {
    var result = (0, $j2rU8.stripZeros)((0, $gMArf.BigNumber).from(value).toHexString());
    if (result.length > 32) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $cd7e99036b8e7d03$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $e8NrM.getAddress)(addr),
        storageKeys: (storageKeys || []).map(function(storageKey, index) {
            if ((0, $j2rU8.hexDataLength)(storageKey) !== 32) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid access list storageKey", "accessList[".concat(addr, ":").concat(index, "]"), storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $cd7e99036b8e7d03$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map(function(set, index) {
        if (Array.isArray(set)) {
            if (set.length > 2) $cd7e99036b8e7d03$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", "value[".concat(index, "]"), set);
            return $cd7e99036b8e7d03$var$accessSetify(set[0], set[1]);
        }
        return $cd7e99036b8e7d03$var$accessSetify(set.address, set.storageKeys);
    });
    var result = Object.keys(value).map(function(addr) {
        var storageKeys = value[addr].reduce(function(accum, storageKey) {
            accum[storageKey] = true;
            return accum;
        }, {});
        return $cd7e99036b8e7d03$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort(function(a, b) {
        return a.address.localeCompare(b.address);
    });
    return result;
}
function $cd7e99036b8e7d03$var$formatAccessList(value) {
    return $cd7e99036b8e7d03$export$6c8662b1600dce2(value).map(function(set) {
        return [
            set.address,
            set.storageKeys
        ];
    });
}
function $cd7e99036b8e7d03$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        var gasPrice = (0, $gMArf.BigNumber).from(transaction.gasPrice);
        var maxFeePerGas = (0, $gMArf.BigNumber).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $cd7e99036b8e7d03$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    var fields = [
        $cd7e99036b8e7d03$var$formatNumber(transaction.chainId || 0, "chainId"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.nonce || 0, "nonce"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $e8NrM.getAddress)(transaction.to) : "0x",
        $cd7e99036b8e7d03$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $cd7e99036b8e7d03$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        var sig = (0, $j2rU8.splitSignature)(signature);
        fields.push($cd7e99036b8e7d03$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $j2rU8.stripZeros)(sig.r));
        fields.push((0, $j2rU8.stripZeros)(sig.s));
    }
    return (0, $j2rU8.hexConcat)([
        "0x02",
        $dQcqA.encode(fields)
    ]);
}
function $cd7e99036b8e7d03$var$_serializeEip2930(transaction, signature) {
    var fields = [
        $cd7e99036b8e7d03$var$formatNumber(transaction.chainId || 0, "chainId"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.nonce || 0, "nonce"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $e8NrM.getAddress)(transaction.to) : "0x",
        $cd7e99036b8e7d03$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $cd7e99036b8e7d03$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        var sig = (0, $j2rU8.splitSignature)(signature);
        fields.push($cd7e99036b8e7d03$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $j2rU8.stripZeros)(sig.r));
        fields.push((0, $j2rU8.stripZeros)(sig.s));
    }
    return (0, $j2rU8.hexConcat)([
        "0x01",
        $dQcqA.encode(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $cd7e99036b8e7d03$var$_serialize(transaction, signature) {
    (0, $2ax4w.checkProperties)(transaction, $cd7e99036b8e7d03$var$allowedTransactionKeys);
    var raw = [];
    $cd7e99036b8e7d03$var$transactionFields.forEach(function(fieldInfo) {
        var value = transaction[fieldInfo.name] || [];
        var options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $j2rU8.arrayify)((0, $j2rU8.hexlify)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $j2rU8.stripZeros)(value);
            if (value.length > fieldInfo.maxLength) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $j2rU8.hexlify)(value));
    });
    var chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $j2rU8.isBytesLike)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $j2rU8.hexlify)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $dQcqA.encode(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    var sig = (0, $j2rU8.splitSignature)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    var v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $cd7e99036b8e7d03$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $cd7e99036b8e7d03$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $j2rU8.hexlify)(v));
    raw.push((0, $j2rU8.stripZeros)((0, $j2rU8.arrayify)(sig.r)));
    raw.push((0, $j2rU8.stripZeros)((0, $j2rU8.arrayify)(sig.s)));
    return $dQcqA.encode(raw);
}
function $cd7e99036b8e7d03$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $cd7e99036b8e7d03$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $cd7e99036b8e7d03$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $cd7e99036b8e7d03$var$_serializeEip2930(transaction, signature);
        case 2:
            return $cd7e99036b8e7d03$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $cd7e99036b8e7d03$var$logger.throwError("unsupported transaction type: ".concat(transaction.type), (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $cd7e99036b8e7d03$var$_parseEipSignature(tx, fields, serialize) {
    try {
        var recid = $cd7e99036b8e7d03$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $j2rU8.hexZeroPad)(fields[1], 32);
    tx.s = (0, $j2rU8.hexZeroPad)(fields[2], 32);
    try {
        var digest = (0, $4ujqV.keccak256)(serialize(tx));
        tx.from = $cd7e99036b8e7d03$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {}
}
function $cd7e99036b8e7d03$var$_parseEip1559(payload) {
    var transaction = $dQcqA.decode(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $j2rU8.hexlify)(payload));
    var maxPriorityFeePerGas = $cd7e99036b8e7d03$var$handleNumber(transaction[2]);
    var maxFeePerGas = $cd7e99036b8e7d03$var$handleNumber(transaction[3]);
    var tx = {
        type: 2,
        chainId: $cd7e99036b8e7d03$var$handleNumber(transaction[0]).toNumber(),
        nonce: $cd7e99036b8e7d03$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $cd7e99036b8e7d03$var$handleNumber(transaction[4]),
        to: $cd7e99036b8e7d03$var$handleAddress(transaction[5]),
        value: $cd7e99036b8e7d03$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $cd7e99036b8e7d03$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $4ujqV.keccak256)(payload);
    $cd7e99036b8e7d03$var$_parseEipSignature(tx, transaction.slice(9), $cd7e99036b8e7d03$var$_serializeEip1559);
    return tx;
}
function $cd7e99036b8e7d03$var$_parseEip2930(payload) {
    var transaction = $dQcqA.decode(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $j2rU8.hexlify)(payload));
    var tx = {
        type: 1,
        chainId: $cd7e99036b8e7d03$var$handleNumber(transaction[0]).toNumber(),
        nonce: $cd7e99036b8e7d03$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $cd7e99036b8e7d03$var$handleNumber(transaction[2]),
        gasLimit: $cd7e99036b8e7d03$var$handleNumber(transaction[3]),
        to: $cd7e99036b8e7d03$var$handleAddress(transaction[4]),
        value: $cd7e99036b8e7d03$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $cd7e99036b8e7d03$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $4ujqV.keccak256)(payload);
    $cd7e99036b8e7d03$var$_parseEipSignature(tx, transaction.slice(8), $cd7e99036b8e7d03$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $cd7e99036b8e7d03$var$_parse(rawTransaction) {
    var transaction = $dQcqA.decode(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    var tx = {
        nonce: $cd7e99036b8e7d03$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $cd7e99036b8e7d03$var$handleNumber(transaction[1]),
        gasLimit: $cd7e99036b8e7d03$var$handleNumber(transaction[2]),
        to: $cd7e99036b8e7d03$var$handleAddress(transaction[3]),
        value: $cd7e99036b8e7d03$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $gMArf.BigNumber).from(transaction[6]).toNumber();
    } catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0, $j2rU8.hexZeroPad)(transaction[7], 32);
    tx.s = (0, $j2rU8.hexZeroPad)(transaction[8], 32);
    if ((0, $gMArf.BigNumber).from(tx.r).isZero() && (0, $gMArf.BigNumber).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        var recoveryParam = tx.v - 27;
        var raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $j2rU8.hexlify)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        var digest = (0, $4ujqV.keccak256)($dQcqA.encode(raw));
        try {
            tx.from = $cd7e99036b8e7d03$export$23cc18f96d8510e2(digest, {
                r: (0, $j2rU8.hexlify)(tx.r),
                s: (0, $j2rU8.hexlify)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {}
        tx.hash = (0, $4ujqV.keccak256)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $cd7e99036b8e7d03$export$98e6a39c04603d36(rawTransaction) {
    var payload = (0, $j2rU8.arrayify)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $cd7e99036b8e7d03$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $cd7e99036b8e7d03$var$_parseEip2930(payload);
        case 2:
            return $cd7e99036b8e7d03$var$_parseEip1559(payload);
        default:
            break;
    }
    return $cd7e99036b8e7d03$var$logger.throwError("unsupported transaction type: ".concat(payload[0]), (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}

});
parcelRequire.register("gKSLq", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $c32b6c36440c9df1$export$83d89fbfd8236492; });
var $c32b6c36440c9df1$export$83d89fbfd8236492 = "transactions/5.7.0";

});


parcelRequire.register("1cpDB", function(module, exports) {

$parcel$export(module.exports, "wordlists", function () { return $0dfacc88dba7f7bc$export$e8e1b4711c2d1939; });

var $d1qbV = parcelRequire("d1qbV");
"use strict";
var $0dfacc88dba7f7bc$export$e8e1b4711c2d1939 = {
    en: (0, $d1qbV.langEn)
};

});
parcelRequire.register("d1qbV", function(module, exports) {

$parcel$export(module.exports, "langEn", function () { return $97afaf669a13bce7$export$a2c9518710cf1f49; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $hj32o = parcelRequire("hj32o");
"use strict";
var $97afaf669a13bce7$var$words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
var $97afaf669a13bce7$var$wordlist = null;
function $97afaf669a13bce7$var$loadWords(lang) {
    if ($97afaf669a13bce7$var$wordlist != null) return;
    $97afaf669a13bce7$var$wordlist = $97afaf669a13bce7$var$words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    // Verify the computed list matches the official list
    /* istanbul ignore if */ if ((0, $hj32o.Wordlist).check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        $97afaf669a13bce7$var$wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
var $97afaf669a13bce7$var$LangEn = /*#__PURE__*/ function(Wordlist) {
    (0, $ftJVG._)(LangEn, Wordlist);
    var _super = (0, $6OZAO._)(LangEn);
    function LangEn() {
        (0, $978gY._)(this, LangEn);
        return _super.call(this, "en");
    }
    (0, $kry2a._)(LangEn, [
        {
            key: "getWord",
            value: function getWord(index) {
                $97afaf669a13bce7$var$loadWords(this);
                return $97afaf669a13bce7$var$wordlist[index];
            }
        },
        {
            key: "getWordIndex",
            value: function getWordIndex(word) {
                $97afaf669a13bce7$var$loadWords(this);
                return $97afaf669a13bce7$var$wordlist.indexOf(word);
            }
        }
    ]);
    return LangEn;
}((0, $hj32o.Wordlist));
var $97afaf669a13bce7$export$a2c9518710cf1f49 = new $97afaf669a13bce7$var$LangEn();
(0, $hj32o.Wordlist).register($97afaf669a13bce7$export$a2c9518710cf1f49);

});
parcelRequire.register("hj32o", function(module, exports) {

$parcel$export(module.exports, "Wordlist", function () { return $c996913613c064e5$export$4d9531a8ddb0ebca; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $4q6En = parcelRequire("4q6En");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $gRERe = parcelRequire("gRERe");
"use strict";
// This gets overridden by rollup
var $c996913613c064e5$var$exportWordlist = false;
var $c996913613c064e5$export$af88d00dbe7f521 = new (0, $6M65e.Logger)((0, $gRERe.version));
var $c996913613c064e5$export$4d9531a8ddb0ebca = /*#__PURE__*/ function _target() {
    function Wordlist(locale) {
        (0, $978gY._)(this, Wordlist);
        $c996913613c064e5$export$af88d00dbe7f521.checkAbstract(this instanceof Wordlist ? this.constructor : void 0, Wordlist);
        (0, $2ax4w.defineReadOnly)(this, "locale", locale);
    }
    (0, $kry2a._)(Wordlist, [
        {
            // Subclasses may override this
            key: "split",
            value: function split(mnemonic) {
                return mnemonic.toLowerCase().split(/ +/g);
            }
        },
        {
            // Subclasses may override this
            key: "join",
            value: function join(words) {
                return words.join(" ");
            }
        }
    ], [
        {
            key: "check",
            value: function check(wordlist) {
                var words = [];
                for(var i = 0; i < 2048; i++){
                    var word = wordlist.getWord(i);
                    /* istanbul ignore if */ if (i !== wordlist.getWordIndex(word)) return "0x";
                    words.push(word);
                }
                return (0, $4q6En.id)(words.join("\n") + "\n");
            }
        },
        {
            key: "register",
            value: function register(lang, name) {
                if (!name) name = lang.locale;
                /* istanbul ignore if */ if ($c996913613c064e5$var$exportWordlist) try {
                    var anyGlobal = window;
                    if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
                        if (!anyGlobal._ethers.wordlists[name]) (0, $2ax4w.defineReadOnly)(anyGlobal._ethers.wordlists, name, lang);
                    }
                } catch (error) {}
            }
        }
    ]);
    return Wordlist;
}();

});
parcelRequire.register("gRERe", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $c4714a102efec208$export$83d89fbfd8236492; });
var $c4714a102efec208$export$83d89fbfd8236492 = "wordlists/5.7.0";

});




parcelRequire.register("4pr5p", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $335e81f973d32d11$export$83d89fbfd8236492; });
var $335e81f973d32d11$export$83d89fbfd8236492 = "hdnode/5.7.0";

});


parcelRequire.register("6jMeD", function(module, exports) {

$parcel$export(module.exports, "isCrowdsaleWallet", function () { return $4999eee0db3e68cf$export$724d6cf6b9fd8578; });
$parcel$export(module.exports, "isKeystoreWallet", function () { return $4999eee0db3e68cf$export$67dc926b8e68b2d8; });
$parcel$export(module.exports, "getJsonWalletAddress", function () { return $4999eee0db3e68cf$export$9a68ee9f8f3afd38; });

var $e8NrM = parcelRequire("e8NrM");
"use strict";
function $4999eee0db3e68cf$export$724d6cf6b9fd8578(json) {
    var data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    return data.encseed && data.ethaddr;
}
function $4999eee0db3e68cf$export$67dc926b8e68b2d8(json) {
    var data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    if (!data.version || parseInt(data.version) !== data.version || parseInt(data.version) !== 3) return false;
    // @TODO: Put more checks to make sure it has kdf, iv and all that good stuff
    return true;
}
function $4999eee0db3e68cf$export$9a68ee9f8f3afd38(json) {
    if ($4999eee0db3e68cf$export$724d6cf6b9fd8578(json)) try {
        return (0, $e8NrM.getAddress)(JSON.parse(json).ethaddr);
    } catch (error) {
        return null;
    }
    if ($4999eee0db3e68cf$export$67dc926b8e68b2d8(json)) try {
        return (0, $e8NrM.getAddress)(JSON.parse(json).address);
    } catch (error) {
        return null;
    }
    return null;
}

});

parcelRequire.register("ihTqz", function(module, exports) {

$parcel$export(module.exports, "pack", function () { return $d504cf4938ca3d9c$export$2a703dbb0cb35339; });
$parcel$export(module.exports, "keccak256", function () { return $d504cf4938ca3d9c$export$f8151fce47ad1c35; });
$parcel$export(module.exports, "sha256", function () { return $d504cf4938ca3d9c$export$bced8d2aada2d1c9; });

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $4ujqV = parcelRequire("4ujqV");

var $7WUQV = parcelRequire("7WUQV");

var $1Wmc7 = parcelRequire("1Wmc7");

var $6M65e = parcelRequire("6M65e");

var $5fA2u = parcelRequire("5fA2u");
"use strict";
var $d504cf4938ca3d9c$var$regexBytes = new RegExp("^bytes([0-9]+)$");
var $d504cf4938ca3d9c$var$regexNumber = new RegExp("^(u?int)([0-9]*)$");
var $d504cf4938ca3d9c$var$regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
var $d504cf4938ca3d9c$var$Zeros = "0000000000000000000000000000000000000000000000000000000000000000";
var $d504cf4938ca3d9c$var$logger = new (0, $6M65e.Logger)((0, $5fA2u.version));
function $d504cf4938ca3d9c$var$_pack(type, value, isArray) {
    switch(type){
        case "address":
            if (isArray) return (0, $j2rU8.zeroPad)(value, 32);
            return (0, $j2rU8.arrayify)(value);
        case "string":
            return (0, $1Wmc7.toUtf8Bytes)(value);
        case "bytes":
            return (0, $j2rU8.arrayify)(value);
        case "bool":
            value = value ? "0x01" : "0x00";
            if (isArray) return (0, $j2rU8.zeroPad)(value, 32);
            return (0, $j2rU8.arrayify)(value);
    }
    var match = type.match($d504cf4938ca3d9c$var$regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        var size = parseInt(match[2] || "256");
        if (match[2] && String(size) !== match[2] || size % 8 !== 0 || size === 0 || size > 256) $d504cf4938ca3d9c$var$logger.throwArgumentError("invalid number type", "type", type);
        if (isArray) size = 256;
        value = (0, $gMArf.BigNumber).from(value).toTwos(size);
        return (0, $j2rU8.zeroPad)(value, size / 8);
    }
    match = type.match($d504cf4938ca3d9c$var$regexBytes);
    if (match) {
        var size1 = parseInt(match[1]);
        if (String(size1) !== match[1] || size1 === 0 || size1 > 32) $d504cf4938ca3d9c$var$logger.throwArgumentError("invalid bytes type", "type", type);
        if ((0, $j2rU8.arrayify)(value).byteLength !== size1) $d504cf4938ca3d9c$var$logger.throwArgumentError("invalid value for ".concat(type), "value", value);
        if (isArray) return (0, $j2rU8.arrayify)((value + $d504cf4938ca3d9c$var$Zeros).substring(0, 66));
        return value;
    }
    match = type.match($d504cf4938ca3d9c$var$regexArray);
    if (match && Array.isArray(value)) {
        var baseType = match[1];
        var count = parseInt(match[2] || String(value.length));
        if (count != value.length) $d504cf4938ca3d9c$var$logger.throwArgumentError("invalid array length for ".concat(type), "value", value);
        var result = [];
        value.forEach(function(value) {
            result.push($d504cf4938ca3d9c$var$_pack(baseType, value, true));
        });
        return (0, $j2rU8.concat)(result);
    }
    return $d504cf4938ca3d9c$var$logger.throwArgumentError("invalid type", "type", type);
}
function $d504cf4938ca3d9c$export$2a703dbb0cb35339(types, values) {
    if (types.length != values.length) $d504cf4938ca3d9c$var$logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    var tight = [];
    types.forEach(function(type, index) {
        tight.push($d504cf4938ca3d9c$var$_pack(type, values[index]));
    });
    return (0, $j2rU8.hexlify)((0, $j2rU8.concat)(tight));
}
function $d504cf4938ca3d9c$export$f8151fce47ad1c35(types, values) {
    return (0, $4ujqV.keccak256)($d504cf4938ca3d9c$export$2a703dbb0cb35339(types, values));
}
function $d504cf4938ca3d9c$export$bced8d2aada2d1c9(types, values) {
    return (0, $7WUQV.sha256)($d504cf4938ca3d9c$export$2a703dbb0cb35339(types, values));
}

});
parcelRequire.register("5fA2u", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $3d2a4f1744e3e1a9$export$83d89fbfd8236492; });
var $3d2a4f1744e3e1a9$export$83d89fbfd8236492 = "solidity/5.7.0";

});


parcelRequire.register("4kSyQ", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $32835a60ff995f3a$export$5f828d93ff035aa8; });

var $j2rU8 = parcelRequire("j2rU8");

var $6M65e = parcelRequire("6M65e");

var $ftmT9 = parcelRequire("ftmT9");
"use strict";
var $32835a60ff995f3a$var$logger = new (0, $6M65e.Logger)((0, $ftmT9.version));
// Debugging line for testing browser lib in node
//const window = { crypto: { getRandomValues: () => { } } };
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $32835a60ff995f3a$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
var $32835a60ff995f3a$var$anyGlobal = $32835a60ff995f3a$var$getGlobal();
var $32835a60ff995f3a$var$crypto = $32835a60ff995f3a$var$anyGlobal.crypto || $32835a60ff995f3a$var$anyGlobal.msCrypto;
if (!$32835a60ff995f3a$var$crypto || !$32835a60ff995f3a$var$crypto.getRandomValues) {
    $32835a60ff995f3a$var$logger.warn("WARNING: Missing strong random number source");
    $32835a60ff995f3a$var$crypto = {
        getRandomValues: function getRandomValues(buffer) {
            return $32835a60ff995f3a$var$logger.throwError("no secure random source avaialble", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "crypto.getRandomValues"
            });
        }
    };
}
function $32835a60ff995f3a$export$5f828d93ff035aa8(length) {
    if (length <= 0 || length > 1024 || length % 1 || length != length) $32835a60ff995f3a$var$logger.throwArgumentError("invalid length", "length", length);
    var result = new Uint8Array(length);
    $32835a60ff995f3a$var$crypto.getRandomValues(result);
    return (0, $j2rU8.arrayify)(result);
}

});
parcelRequire.register("ftmT9", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $b43b519c9c02dc79$export$83d89fbfd8236492; });
var $b43b519c9c02dc79$export$83d89fbfd8236492 = "random/5.7.0";

});


parcelRequire.register("5aKt1", function(module, exports) {

$parcel$export(module.exports, "shuffled", function () { return $3c41ee55241bf87e$export$e6c7296801b9b341; });
"use strict";
function $3c41ee55241bf87e$export$e6c7296801b9b341(array) {
    array = array.slice();
    for(var i = array.length - 1; i > 0; i--){
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
    return array;
}

});

parcelRequire.register("9osRb", function(module, exports) {

$parcel$export(module.exports, "formatBytes32String", function () { return $6d6cbd4d8329f5fa$export$b97e949c0076e971; });
$parcel$export(module.exports, "parseBytes32String", function () { return $6d6cbd4d8329f5fa$export$49340cb8f3954db8; });

var $5OvKP = parcelRequire("5OvKP");

var $j2rU8 = parcelRequire("j2rU8");

var $1Wmc7 = parcelRequire("1Wmc7");
"use strict";
function $6d6cbd4d8329f5fa$export$b97e949c0076e971(text) {
    // Get the bytes
    var bytes = (0, $1Wmc7.toUtf8Bytes)(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return (0, $j2rU8.hexlify)((0, $j2rU8.concat)([
        bytes,
        (0, $5OvKP.HashZero)
    ]).slice(0, 32));
}
function $6d6cbd4d8329f5fa$export$49340cb8f3954db8(bytes) {
    var data = (0, $j2rU8.arrayify)(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 string - no null terminator");
    // Find the null termination
    var length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return (0, $1Wmc7.toUtf8String)(data.slice(0, length));
}

});
parcelRequire.register("5OvKP", function(module, exports) {

$parcel$export(module.exports, "HashZero", function () { return $43ba40ff64f1a63e$export$71c2e4e213dcb7f2; });
var $43ba40ff64f1a63e$export$71c2e4e213dcb7f2 = "0x0000000000000000000000000000000000000000000000000000000000000000";

});


parcelRequire.register("eHcVC", function(module, exports) {

$parcel$export(module.exports, "nameprep", function () { return $ab2f1c24fdde7ddc$export$94f0b6f93c619bc; });

var $1Wmc7 = parcelRequire("1Wmc7");
"use strict";
function $ab2f1c24fdde7ddc$var$bytes2(data) {
    if (data.length % 4 !== 0) throw new Error("bad data");
    var result = [];
    for(var i = 0; i < data.length; i += 4)result.push(parseInt(data.substring(i, i + 4), 16));
    return result;
}
function $ab2f1c24fdde7ddc$var$createTable(data, func) {
    if (!func) func = function func(value) {
        return [
            parseInt(value, 16)
        ];
    };
    var lo = 0;
    var result = {};
    data.split(",").forEach(function(pair) {
        var comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function $ab2f1c24fdde7ddc$var$createRangeTable(data) {
    var hi = 0;
    return data.split(",").map(function(v) {
        var comps = v.split("-");
        if (comps.length === 1) comps[1] = "0";
        else if (comps[1] === "") comps[1] = "1";
        var lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return {
            l: lo,
            h: hi
        };
    });
}
function $ab2f1c24fdde7ddc$var$matchMap(value, ranges) {
    var lo = 0;
    for(var i = 0; i < ranges.length; i++){
        var range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && (value - lo) % (range.d || 1) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) continue;
            return range;
        }
    }
    return null;
}
var $ab2f1c24fdde7ddc$var$Table_A_1_ranges = $ab2f1c24fdde7ddc$var$createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
var $ab2f1c24fdde7ddc$var$Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map(function(v) {
    return parseInt(v, 16);
});
var $ab2f1c24fdde7ddc$var$Table_B_2_ranges = [
    {
        h: 25,
        s: 32,
        l: 65
    },
    {
        h: 30,
        s: 32,
        e: [
            23
        ],
        l: 127
    },
    {
        h: 54,
        s: 1,
        e: [
            48
        ],
        l: 64,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 57,
        d: 2
    },
    {
        h: 44,
        s: 1,
        l: 17,
        d: 2
    },
    {
        h: 10,
        s: 1,
        e: [
            2,
            6,
            8
        ],
        l: 61,
        d: 2
    },
    {
        h: 16,
        s: 1,
        l: 68,
        d: 2
    },
    {
        h: 84,
        s: 1,
        e: [
            18,
            24,
            66
        ],
        l: 19,
        d: 2
    },
    {
        h: 26,
        s: 32,
        e: [
            17
        ],
        l: 435
    },
    {
        h: 22,
        s: 1,
        l: 71,
        d: 2
    },
    {
        h: 15,
        s: 80,
        l: 40
    },
    {
        h: 31,
        s: 32,
        l: 16
    },
    {
        h: 32,
        s: 1,
        l: 80,
        d: 2
    },
    {
        h: 52,
        s: 1,
        l: 42,
        d: 2
    },
    {
        h: 12,
        s: 1,
        l: 55,
        d: 2
    },
    {
        h: 40,
        s: 1,
        e: [
            38
        ],
        l: 15,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 48,
        d: 2
    },
    {
        h: 37,
        s: 48,
        l: 49
    },
    {
        h: 148,
        s: 1,
        l: 6351,
        d: 2
    },
    {
        h: 88,
        s: 1,
        l: 160,
        d: 2
    },
    {
        h: 15,
        s: 16,
        l: 704
    },
    {
        h: 25,
        s: 26,
        l: 854
    },
    {
        h: 25,
        s: 32,
        l: 55915
    },
    {
        h: 37,
        s: 40,
        l: 1247
    },
    {
        h: 25,
        s: -119711,
        l: 53248
    },
    {
        h: 25,
        s: -119763,
        l: 52
    },
    {
        h: 25,
        s: -119815,
        l: 52
    },
    {
        h: 25,
        s: -119867,
        e: [
            1,
            4,
            5,
            7,
            8,
            11,
            12,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -119919,
        l: 52
    },
    {
        h: 24,
        s: -119971,
        e: [
            2,
            7,
            8,
            17
        ],
        l: 52
    },
    {
        h: 24,
        s: -120023,
        e: [
            2,
            7,
            13,
            15,
            16,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -120075,
        l: 52
    },
    {
        h: 25,
        s: -120127,
        l: 52
    },
    {
        h: 25,
        s: -120179,
        l: 52
    },
    {
        h: 25,
        s: -120231,
        l: 52
    },
    {
        h: 25,
        s: -120283,
        l: 52
    },
    {
        h: 25,
        s: -120335,
        l: 52
    },
    {
        h: 24,
        s: -119543,
        e: [
            17
        ],
        l: 56
    },
    {
        h: 24,
        s: -119601,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119659,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119717,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119775,
        e: [
            17
        ],
        l: 58
    }
];
var $ab2f1c24fdde7ddc$var$Table_B_2_lut_abs = $ab2f1c24fdde7ddc$var$createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
var $ab2f1c24fdde7ddc$var$Table_B_2_lut_rel = $ab2f1c24fdde7ddc$var$createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
var $ab2f1c24fdde7ddc$var$Table_B_2_complex = $ab2f1c24fdde7ddc$var$createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $ab2f1c24fdde7ddc$var$bytes2);
var $ab2f1c24fdde7ddc$var$Table_C_ranges = $ab2f1c24fdde7ddc$var$createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function $ab2f1c24fdde7ddc$var$flatten(values) {
    return values.reduce(function(accum, value) {
        value.forEach(function(value) {
            accum.push(value);
        });
        return accum;
    }, []);
}
function $ab2f1c24fdde7ddc$export$d1ae0d802533bef0(codepoint) {
    return !!$ab2f1c24fdde7ddc$var$matchMap(codepoint, $ab2f1c24fdde7ddc$var$Table_A_1_ranges);
}
function $ab2f1c24fdde7ddc$export$9630a1f26a43b76c(codepoint) {
    var range = $ab2f1c24fdde7ddc$var$matchMap(codepoint, $ab2f1c24fdde7ddc$var$Table_B_2_ranges);
    if (range) return [
        codepoint + range.s
    ];
    var codes = $ab2f1c24fdde7ddc$var$Table_B_2_lut_abs[codepoint];
    if (codes) return codes;
    var shift = $ab2f1c24fdde7ddc$var$Table_B_2_lut_rel[codepoint];
    if (shift) return [
        codepoint + shift[0]
    ];
    var complex = $ab2f1c24fdde7ddc$var$Table_B_2_complex[codepoint];
    if (complex) return complex;
    return null;
}
function $ab2f1c24fdde7ddc$export$e07a548cae6d1553(codepoint) {
    return !!$ab2f1c24fdde7ddc$var$matchMap(codepoint, $ab2f1c24fdde7ddc$var$Table_C_ranges);
}
function $ab2f1c24fdde7ddc$export$94f0b6f93c619bc(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) return value.toLowerCase();
    // Get the code points (keeping the current normalization)
    var codes = (0, $1Wmc7.toUtf8CodePoints)(value);
    codes = $ab2f1c24fdde7ddc$var$flatten(codes.map(function(code) {
        // Substitute Table B.1 (Maps to Nothing)
        if ($ab2f1c24fdde7ddc$var$Table_B_1_flags.indexOf(code) >= 0) return [];
        if (code >= 0xfe00 && code <= 0xfe0f) return [];
        // Substitute Table B.2 (Case Folding)
        var codesTableB2 = $ab2f1c24fdde7ddc$export$9630a1f26a43b76c(code);
        if (codesTableB2) return codesTableB2;
        // No Substitution
        return [
            code
        ];
    }));
    // Normalize using form KC
    codes = (0, $1Wmc7.toUtf8CodePoints)((0, $1Wmc7._toUtf8String)(codes), (0, $1Wmc7.UnicodeNormalizationForm).NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach(function(code) {
        if ($ab2f1c24fdde7ddc$export$e07a548cae6d1553(code)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach(function(code) {
        if ($ab2f1c24fdde7ddc$export$d1ae0d802533bef0(code)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
    });
    // IDNA extras
    var name = (0, $1Wmc7._toUtf8String)(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") throw new Error("invalid hyphen");
    return name;
}

});

parcelRequire.register("41JdS", function(module, exports) {

$parcel$export(module.exports, "commify", function () { return $2eea55bfa3f06576$export$de1294767e6ef661; });
$parcel$export(module.exports, "formatUnits", function () { return $2eea55bfa3f06576$export$bd39b96f71da1885; });
$parcel$export(module.exports, "parseUnits", function () { return $2eea55bfa3f06576$export$203ae30b4f6490b3; });
$parcel$export(module.exports, "formatEther", function () { return $2eea55bfa3f06576$export$11bc63b4c03ea518; });
$parcel$export(module.exports, "parseEther", function () { return $2eea55bfa3f06576$export$642c4e67bbdc0bc7; });

var $15mVR = parcelRequire("15mVR");

var $6M65e = parcelRequire("6M65e");

var $149Bx = parcelRequire("149Bx");
"use strict";
var $2eea55bfa3f06576$var$logger = new (0, $6M65e.Logger)((0, $149Bx.version));
var $2eea55bfa3f06576$var$names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function $2eea55bfa3f06576$export$de1294767e6ef661(value) {
    var comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || comps[1] && !comps[1].match(/^[0-9]*$/) || value === "." || value === "-.") $2eea55bfa3f06576$var$logger.throwArgumentError("invalid value", "value", value);
    // Make sure we have at least one whole digit (0 if none)
    var whole = comps[0];
    var negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while(whole.substring(0, 1) === "0")whole = whole.substring(1);
    if (whole === "") whole = "0";
    var suffix = "";
    if (comps.length === 2) suffix = "." + (comps[1] || "0");
    while(suffix.length > 2 && suffix[suffix.length - 1] === "0")suffix = suffix.substring(0, suffix.length - 1);
    var formatted = [];
    while(whole.length)if (whole.length <= 3) {
        formatted.unshift(whole);
        break;
    } else {
        var index = whole.length - 3;
        formatted.unshift(whole.substring(index));
        whole = whole.substring(0, index);
    }
    return negative + formatted.join(",") + suffix;
}
function $2eea55bfa3f06576$export$bd39b96f71da1885(value, unitName) {
    if (typeof unitName === "string") {
        var index = $2eea55bfa3f06576$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $15mVR.formatFixed)(value, unitName != null ? unitName : 18);
}
function $2eea55bfa3f06576$export$203ae30b4f6490b3(value, unitName) {
    if (typeof value !== "string") $2eea55bfa3f06576$var$logger.throwArgumentError("value must be a string", "value", value);
    if (typeof unitName === "string") {
        var index = $2eea55bfa3f06576$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $15mVR.parseFixed)(value, unitName != null ? unitName : 18);
}
function $2eea55bfa3f06576$export$11bc63b4c03ea518(wei) {
    return $2eea55bfa3f06576$export$bd39b96f71da1885(wei, 18);
}
function $2eea55bfa3f06576$export$642c4e67bbdc0bc7(ether) {
    return $2eea55bfa3f06576$export$203ae30b4f6490b3(ether, 18);
}

});
parcelRequire.register("15mVR", function(module, exports) {

$parcel$export(module.exports, "formatFixed", function () { return $0ca80bf34c50fe44$export$cc011b843b5d69f2; });
$parcel$export(module.exports, "parseFixed", function () { return $0ca80bf34c50fe44$export$1b039987e86d7269; });
$parcel$export(module.exports, "FixedNumber", function () { return $0ca80bf34c50fe44$export$d4693c66c2213e45; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $1ObTH = parcelRequire("1ObTH");

var $j2rU8 = parcelRequire("j2rU8");

var $6M65e = parcelRequire("6M65e");

var $aLv3y = parcelRequire("aLv3y");

var $gMArf = parcelRequire("gMArf");
"use strict";
var $0ca80bf34c50fe44$var$logger = new (0, $6M65e.Logger)((0, $aLv3y.version));
var $0ca80bf34c50fe44$var$_constructorGuard = {};
var $0ca80bf34c50fe44$var$Zero = (0, $gMArf.BigNumber).from(0);
var $0ca80bf34c50fe44$var$NegativeOne = (0, $gMArf.BigNumber).from(-1);
function $0ca80bf34c50fe44$var$throwFault(message, fault, operation, value) {
    var params = {
        fault: fault,
        operation: operation
    };
    if (value !== undefined) params.value = value;
    return $0ca80bf34c50fe44$var$logger.throwError(message, (0, $6M65e.Logger).errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
var $0ca80bf34c50fe44$var$zeros = "0";
while($0ca80bf34c50fe44$var$zeros.length < 256)$0ca80bf34c50fe44$var$zeros += $0ca80bf34c50fe44$var$zeros;
// Returns a string "1" followed by decimal "0"s
function $0ca80bf34c50fe44$var$getMultiplier(decimals) {
    if (typeof decimals !== "number") try {
        decimals = (0, $gMArf.BigNumber).from(decimals).toNumber();
    } catch (e) {}
    if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) return "1" + $0ca80bf34c50fe44$var$zeros.substring(0, decimals);
    return $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function $0ca80bf34c50fe44$export$cc011b843b5d69f2(value, decimals) {
    if (decimals == null) decimals = 0;
    var multiplier = $0ca80bf34c50fe44$var$getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = (0, $gMArf.BigNumber).from(value);
    var negative = value.lt($0ca80bf34c50fe44$var$Zero);
    if (negative) value = value.mul($0ca80bf34c50fe44$var$NegativeOne);
    var fraction = value.mod(multiplier).toString();
    while(fraction.length < multiplier.length - 1)fraction = "0" + fraction;
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    var whole = value.div(multiplier).toString();
    if (multiplier.length === 1) value = whole;
    else value = whole + "." + fraction;
    if (negative) value = "-" + value;
    return value;
}
function $0ca80bf34c50fe44$export$1b039987e86d7269(value, decimals) {
    if (decimals == null) decimals = 0;
    var multiplier = $0ca80bf34c50fe44$var$getMultiplier(decimals);
    if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid decimal value", "value", value);
    // Is it negative?
    var negative = value.substring(0, 1) === "-";
    if (negative) value = value.substring(1);
    if (value === ".") $0ca80bf34c50fe44$var$logger.throwArgumentError("missing value", "value", value);
    // Split it into a whole and fractional part
    var comps = value.split(".");
    if (comps.length > 2) $0ca80bf34c50fe44$var$logger.throwArgumentError("too many decimal points", "value", value);
    var whole = comps[0], fraction = comps[1];
    if (!whole) whole = "0";
    if (!fraction) fraction = "0";
    // Trim trailing zeros
    while(fraction[fraction.length - 1] === "0")fraction = fraction.substring(0, fraction.length - 1);
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) $0ca80bf34c50fe44$var$throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") fraction = "0";
    // Fully pad the string with zeros to get to wei
    while(fraction.length < multiplier.length - 1)fraction += "0";
    var wholeValue = (0, $gMArf.BigNumber).from(whole);
    var fractionValue = (0, $gMArf.BigNumber).from(fraction);
    var wei = wholeValue.mul(multiplier).add(fractionValue);
    if (negative) wei = wei.mul($0ca80bf34c50fe44$var$NegativeOne);
    return wei;
}
var $0ca80bf34c50fe44$export$1f3ec5b8f47ebd4d = /*#__PURE__*/ function() {
    function FixedFormat(constructorGuard, signed, width, decimals) {
        (0, $978gY._)(this, FixedFormat);
        if (constructorGuard !== $0ca80bf34c50fe44$var$_constructorGuard) $0ca80bf34c50fe44$var$logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = $0ca80bf34c50fe44$var$getMultiplier(decimals);
        Object.freeze(this);
    }
    (0, $kry2a._)(FixedFormat, null, [
        {
            key: "from",
            value: function from(value) {
                if (value instanceof FixedFormat) return value;
                if (typeof value === "number") value = "fixed128x".concat(value);
                var signed = true;
                var width = 128;
                var decimals = 18;
                if (typeof value === "string") {
                    if (value === "fixed") ;
                    else if (value === "ufixed") signed = false;
                    else {
                        var match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                        if (!match) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid fixed format", "format", value);
                        signed = match[1] !== "u";
                        width = parseInt(match[2]);
                        decimals = parseInt(match[3]);
                    }
                } else if (value) {
                    var check = function(key, type, defaultValue) {
                        if (value[key] == null) return defaultValue;
                        if ((0, $1ObTH._)(value[key]) !== type) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                        return value[key];
                    };
                    signed = check("signed", "boolean", signed);
                    width = check("width", "number", width);
                    decimals = check("decimals", "number", decimals);
                }
                if (width % 8) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
                if (decimals > 80) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
                return new FixedFormat($0ca80bf34c50fe44$var$_constructorGuard, signed, width, decimals);
            }
        }
    ]);
    return FixedFormat;
}();
var $0ca80bf34c50fe44$export$d4693c66c2213e45 = /*#__PURE__*/ function() {
    function FixedNumber(constructorGuard, hex, value, format) {
        (0, $978gY._)(this, FixedNumber);
        if (constructorGuard !== $0ca80bf34c50fe44$var$_constructorGuard) $0ca80bf34c50fe44$var$logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
    (0, $kry2a._)(FixedNumber, [
        {
            key: "_checkFormat",
            value: function _checkFormat(other) {
                if (this.format.name !== other.format.name) $0ca80bf34c50fe44$var$logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
            }
        },
        {
            key: "addUnsafe",
            value: function addUnsafe(other) {
                this._checkFormat(other);
                var a = $0ca80bf34c50fe44$export$1b039987e86d7269(this._value, this.format.decimals);
                var b = $0ca80bf34c50fe44$export$1b039987e86d7269(other._value, other.format.decimals);
                return FixedNumber.fromValue(a.add(b), this.format.decimals, this.format);
            }
        },
        {
            key: "subUnsafe",
            value: function subUnsafe(other) {
                this._checkFormat(other);
                var a = $0ca80bf34c50fe44$export$1b039987e86d7269(this._value, this.format.decimals);
                var b = $0ca80bf34c50fe44$export$1b039987e86d7269(other._value, other.format.decimals);
                return FixedNumber.fromValue(a.sub(b), this.format.decimals, this.format);
            }
        },
        {
            key: "mulUnsafe",
            value: function mulUnsafe(other) {
                this._checkFormat(other);
                var a = $0ca80bf34c50fe44$export$1b039987e86d7269(this._value, this.format.decimals);
                var b = $0ca80bf34c50fe44$export$1b039987e86d7269(other._value, other.format.decimals);
                return FixedNumber.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
            }
        },
        {
            key: "divUnsafe",
            value: function divUnsafe(other) {
                this._checkFormat(other);
                var a = $0ca80bf34c50fe44$export$1b039987e86d7269(this._value, this.format.decimals);
                var b = $0ca80bf34c50fe44$export$1b039987e86d7269(other._value, other.format.decimals);
                return FixedNumber.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
            }
        },
        {
            key: "floor",
            value: function floor() {
                var comps = this.toString().split(".");
                if (comps.length === 1) comps.push("0");
                var result = FixedNumber.from(comps[0], this.format);
                var hasFraction = !comps[1].match(/^(0*)$/);
                if (this.isNegative() && hasFraction) result = result.subUnsafe($0ca80bf34c50fe44$var$ONE.toFormat(result.format));
                return result;
            }
        },
        {
            key: "ceiling",
            value: function ceiling() {
                var comps = this.toString().split(".");
                if (comps.length === 1) comps.push("0");
                var result = FixedNumber.from(comps[0], this.format);
                var hasFraction = !comps[1].match(/^(0*)$/);
                if (!this.isNegative() && hasFraction) result = result.addUnsafe($0ca80bf34c50fe44$var$ONE.toFormat(result.format));
                return result;
            }
        },
        {
            // @TODO: Support other rounding algorithms
            key: "round",
            value: function round(decimals) {
                if (decimals == null) decimals = 0;
                // If we are already in range, we're done
                var comps = this.toString().split(".");
                if (comps.length === 1) comps.push("0");
                if (decimals < 0 || decimals > 80 || decimals % 1) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid decimal count", "decimals", decimals);
                if (comps[1].length <= decimals) return this;
                var factor = FixedNumber.from("1" + $0ca80bf34c50fe44$var$zeros.substring(0, decimals), this.format);
                var bump = $0ca80bf34c50fe44$var$BUMP.toFormat(this.format);
                return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
            }
        },
        {
            key: "isZero",
            value: function isZero() {
                return this._value === "0.0" || this._value === "0";
            }
        },
        {
            key: "isNegative",
            value: function isNegative() {
                return this._value[0] === "-";
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this._value;
            }
        },
        {
            key: "toHexString",
            value: function toHexString(width) {
                if (width == null) return this._hex;
                if (width % 8) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid byte width", "width", width);
                var hex = (0, $gMArf.BigNumber).from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
                return (0, $j2rU8.hexZeroPad)(hex, width / 8);
            }
        },
        {
            key: "toUnsafeFloat",
            value: function toUnsafeFloat() {
                return parseFloat(this.toString());
            }
        },
        {
            key: "toFormat",
            value: function toFormat(format) {
                return FixedNumber.fromString(this._value, format);
            }
        }
    ], [
        {
            key: "fromValue",
            value: function fromValue(value, decimals, format) {
                // If decimals looks more like a format, and there is no format, shift the parameters
                if (format == null && decimals != null && !(0, $gMArf.isBigNumberish)(decimals)) {
                    format = decimals;
                    decimals = null;
                }
                if (decimals == null) decimals = 0;
                if (format == null) format = "fixed";
                return FixedNumber.fromString($0ca80bf34c50fe44$export$cc011b843b5d69f2(value, decimals), $0ca80bf34c50fe44$export$1f3ec5b8f47ebd4d.from(format));
            }
        },
        {
            key: "fromString",
            value: function fromString(value, format) {
                if (format == null) format = "fixed";
                var fixedFormat = $0ca80bf34c50fe44$export$1f3ec5b8f47ebd4d.from(format);
                var numeric = $0ca80bf34c50fe44$export$1b039987e86d7269(value, fixedFormat.decimals);
                if (!fixedFormat.signed && numeric.lt($0ca80bf34c50fe44$var$Zero)) $0ca80bf34c50fe44$var$throwFault("unsigned value cannot be negative", "overflow", "value", value);
                var hex = null;
                if (fixedFormat.signed) hex = numeric.toTwos(fixedFormat.width).toHexString();
                else {
                    hex = numeric.toHexString();
                    hex = (0, $j2rU8.hexZeroPad)(hex, fixedFormat.width / 8);
                }
                var decimal = $0ca80bf34c50fe44$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
                return new FixedNumber($0ca80bf34c50fe44$var$_constructorGuard, hex, decimal, fixedFormat);
            }
        },
        {
            key: "fromBytes",
            value: function fromBytes(value, format) {
                if (format == null) format = "fixed";
                var fixedFormat = $0ca80bf34c50fe44$export$1f3ec5b8f47ebd4d.from(format);
                if ((0, $j2rU8.arrayify)(value).length > fixedFormat.width / 8) throw new Error("overflow");
                var numeric = (0, $gMArf.BigNumber).from(value);
                if (fixedFormat.signed) numeric = numeric.fromTwos(fixedFormat.width);
                var hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
                var decimal = $0ca80bf34c50fe44$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
                return new FixedNumber($0ca80bf34c50fe44$var$_constructorGuard, hex, decimal, fixedFormat);
            }
        },
        {
            key: "from",
            value: function from(value, format) {
                if (typeof value === "string") return FixedNumber.fromString(value, format);
                if ((0, $j2rU8.isBytes)(value)) return FixedNumber.fromBytes(value, format);
                try {
                    return FixedNumber.fromValue(value, 0, format);
                } catch (error) {
                    // Allow NUMERIC_FAULT to bubble up
                    if (error.code !== (0, $6M65e.Logger).errors.INVALID_ARGUMENT) throw error;
                }
                return $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid FixedNumber value", "value", value);
            }
        },
        {
            key: "isFixedNumber",
            value: function isFixedNumber(value) {
                return !!(value && value._isFixedNumber);
            }
        }
    ]);
    return FixedNumber;
}();
var $0ca80bf34c50fe44$var$ONE = $0ca80bf34c50fe44$export$d4693c66c2213e45.from(1);
var $0ca80bf34c50fe44$var$BUMP = $0ca80bf34c50fe44$export$d4693c66c2213e45.from("0.5");

});

parcelRequire.register("149Bx", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $0c6d9d62ef0f8aae$export$83d89fbfd8236492; });
var $0c6d9d62ef0f8aae$export$83d89fbfd8236492 = "units/5.7.0";

});


parcelRequire.register("54wuV", function(module, exports) {

$parcel$export(module.exports, "Wallet", function () { return $3b1688dbad3fbfea$export$bcca3ea514774656; });
$parcel$export(module.exports, "verifyMessage", function () { return $3b1688dbad3fbfea$export$228d0e772cc158cb; });
$parcel$export(module.exports, "verifyTypedData", function () { return $3b1688dbad3fbfea$export$3603b1c1bcd76798; });

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $e8NrM = parcelRequire("e8NrM");

var $lLovk = parcelRequire("lLovk");

var $iGUqv = parcelRequire("iGUqv");

var $j2rU8 = parcelRequire("j2rU8");

var $kdj79 = parcelRequire("kdj79");
var $7vZoR = parcelRequire("7vZoR");

var $5iEGT = parcelRequire("5iEGT");

var $4ujqV = parcelRequire("4ujqV");

var $2ax4w = parcelRequire("2ax4w");

var $4kSyQ = parcelRequire("4kSyQ");

var $4LuuL = parcelRequire("4LuuL");

var $fuKNC = parcelRequire("fuKNC");
var $7Ybyv = parcelRequire("7Ybyv");

var $hDQeE = parcelRequire("hDQeE");

var $6M65e = parcelRequire("6M65e");

var $eIckK = parcelRequire("eIckK");
"use strict";
var $3b1688dbad3fbfea$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3b1688dbad3fbfea$var$logger = new (0, $6M65e.Logger)((0, $eIckK.version));
function $3b1688dbad3fbfea$var$isAccount(value) {
    return value != null && (0, $j2rU8.isHexString)(value.privateKey, 32) && value.address != null;
}
function $3b1688dbad3fbfea$var$hasMnemonic(value) {
    var mnemonic = value.mnemonic;
    return mnemonic && mnemonic.phrase;
}
var $3b1688dbad3fbfea$export$bcca3ea514774656 = /*#__PURE__*/ function(Signer) {
    (0, $ftJVG._)(Wallet, Signer);
    var _super = (0, $6OZAO._)(Wallet);
    function Wallet(privateKey, provider) {
        (0, $978gY._)(this, Wallet);
        var _this;
        _this = _super.call(this);
        if ($3b1688dbad3fbfea$var$isAccount(privateKey)) {
            var signingKey = new (0, $4LuuL.SigningKey)(privateKey.privateKey);
            (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_signingKey", function() {
                return signingKey;
            });
            (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "address", (0, $hDQeE.computeAddress)(_this.publicKey));
            if (_this.address !== (0, $e8NrM.getAddress)(privateKey.address)) $3b1688dbad3fbfea$var$logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
            if ($3b1688dbad3fbfea$var$hasMnemonic(privateKey)) {
                var srcMnemonic = privateKey.mnemonic;
                (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_mnemonic", function() {
                    return {
                        phrase: srcMnemonic.phrase,
                        path: srcMnemonic.path || (0, $5iEGT.defaultPath),
                        locale: srcMnemonic.locale || "en"
                    };
                });
                var mnemonic = _this.mnemonic;
                var node = (0, $5iEGT.HDNode).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);
                if ((0, $hDQeE.computeAddress)(node.privateKey) !== _this.address) $3b1688dbad3fbfea$var$logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
            } else (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_mnemonic", function() {
                return null;
            });
        } else {
            if ((0, $4LuuL.SigningKey).isSigningKey(privateKey)) {
                /* istanbul ignore if */ if (privateKey.curve !== "secp256k1") $3b1688dbad3fbfea$var$logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
                (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_signingKey", function() {
                    return privateKey;
                });
            } else {
                // A lot of common tools do not prefix private keys with a 0x (see: #1166)
                if (typeof privateKey === "string") {
                    if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) privateKey = "0x" + privateKey;
                }
                var signingKey1 = new (0, $4LuuL.SigningKey)(privateKey);
                (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_signingKey", function() {
                    return signingKey1;
                });
            }
            (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_mnemonic", function() {
                return null;
            });
            (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "address", (0, $hDQeE.computeAddress)(_this.publicKey));
        }
        /* istanbul ignore if */ if (provider && !(0, $lLovk.Provider).isProvider(provider)) $3b1688dbad3fbfea$var$logger.throwArgumentError("invalid provider", "provider", provider);
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "provider", provider || null);
        return _this;
    }
    (0, $kry2a._)(Wallet, [
        {
            key: "mnemonic",
            get: function get() {
                return this._mnemonic();
            }
        },
        {
            key: "privateKey",
            get: function get() {
                return this._signingKey().privateKey;
            }
        },
        {
            key: "publicKey",
            get: function get() {
                return this._signingKey().publicKey;
            }
        },
        {
            key: "getAddress",
            value: function getAddress() {
                return Promise.resolve(this.address);
            }
        },
        {
            key: "connect",
            value: function connect(provider) {
                return new Wallet(this, provider);
            }
        },
        {
            key: "signTransaction",
            value: function signTransaction(transaction) {
                var _this = this;
                return (0, $2ax4w.resolveProperties)(transaction).then(function(tx) {
                    if (tx.from != null) {
                        if ((0, $e8NrM.getAddress)(tx.from) !== _this.address) $3b1688dbad3fbfea$var$logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                        delete tx.from;
                    }
                    var signature = _this._signingKey().signDigest((0, $4ujqV.keccak256)((0, $hDQeE.serialize)(tx)));
                    return (0, $hDQeE.serialize)(tx, signature);
                });
            }
        },
        {
            key: "signMessage",
            value: function signMessage(message) {
                return $3b1688dbad3fbfea$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $j2rU8.joinSignature)(this._signingKey().signDigest((0, $7vZoR.hashMessage)(message)))
                        ];
                    });
                });
            }
        },
        {
            key: "_signTypedData",
            value: function _signTypedData(domain, types, value) {
                return $3b1688dbad3fbfea$var$__awaiter(this, void 0, void 0, function() {
                    var _this, populated;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    (0, $kdj79.TypedDataEncoder).resolveNames(domain, types, value, function(name) {
                                        if (_this.provider == null) $3b1688dbad3fbfea$var$logger.throwError("cannot resolve ENS names without a provider", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                                            operation: "resolveName",
                                            value: name
                                        });
                                        return _this.provider.resolveName(name);
                                    })
                                ];
                            case 1:
                                populated = _state.sent();
                                return [
                                    2,
                                    (0, $j2rU8.joinSignature)(this._signingKey().signDigest((0, $kdj79.TypedDataEncoder).hash(populated.domain, types, populated.value)))
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "encrypt",
            value: function encrypt(password, options, progressCallback) {
                if (typeof options === "function" && !progressCallback) {
                    progressCallback = options;
                    options = {};
                }
                if (progressCallback && typeof progressCallback !== "function") throw new Error("invalid callback");
                if (!options) options = {};
                return (0, $7Ybyv.encrypt)(this, password, options, progressCallback);
            }
        }
    ], [
        {
            key: "createRandom",
            value: /**
     *  Static methods to create Wallet instances.
     */ function createRandom(options) {
                var entropy = (0, $4kSyQ.randomBytes)(16);
                if (!options) options = {};
                if (options.extraEntropy) entropy = (0, $j2rU8.arrayify)((0, $j2rU8.hexDataSlice)((0, $4ujqV.keccak256)((0, $j2rU8.concat)([
                    entropy,
                    options.extraEntropy
                ])), 0, 16));
                var mnemonic = (0, $5iEGT.entropyToMnemonic)(entropy, options.locale);
                return Wallet.fromMnemonic(mnemonic, options.path, options.locale);
            }
        },
        {
            key: "fromEncryptedJson",
            value: function fromEncryptedJson(json, password, progressCallback) {
                return (0, $fuKNC.decryptJsonWallet)(json, password, progressCallback).then(function(account) {
                    return new Wallet(account);
                });
            }
        },
        {
            key: "fromEncryptedJsonSync",
            value: function fromEncryptedJsonSync(json, password) {
                return new Wallet((0, $fuKNC.decryptJsonWalletSync)(json, password));
            }
        },
        {
            key: "fromMnemonic",
            value: function fromMnemonic(mnemonic, path, wordlist) {
                if (!path) path = (0, $5iEGT.defaultPath);
                return new Wallet((0, $5iEGT.HDNode).fromMnemonic(mnemonic, null, wordlist).derivePath(path));
            }
        }
    ]);
    return Wallet;
}((0, $iGUqv.Signer));
function $3b1688dbad3fbfea$export$228d0e772cc158cb(message, signature) {
    return (0, $hDQeE.recoverAddress)((0, $7vZoR.hashMessage)(message), signature);
}
function $3b1688dbad3fbfea$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $hDQeE.recoverAddress)((0, $kdj79.TypedDataEncoder).hash(domain, types, value), signature);
}

});
parcelRequire.register("lLovk", function(module, exports) {

$parcel$export(module.exports, "ForkEvent", function () { return $fd80fed41b6901ec$export$406ece1549ccd00e; });
$parcel$export(module.exports, "Provider", function () { return $fd80fed41b6901ec$export$2881499e37b75b9a; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $bxoXJ = parcelRequire("bxoXJ");
"use strict";
var $fd80fed41b6901ec$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fd80fed41b6901ec$var$logger = new (0, $6M65e.Logger)((0, $bxoXJ.version));
var $fd80fed41b6901ec$export$406ece1549ccd00e = /*#__PURE__*/ function(Description) {
    (0, $ftJVG._)(ForkEvent, Description);
    var _super = (0, $6OZAO._)(ForkEvent);
    function ForkEvent() {
        (0, $978gY._)(this, ForkEvent);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ForkEvent, null, [
        {
            key: "isForkEvent",
            value: function isForkEvent(value) {
                return !!(value && value._isForkEvent);
            }
        }
    ]);
    return ForkEvent;
}((0, $2ax4w.Description));
var $fd80fed41b6901ec$export$5b2cada8494f9d99 = /*#__PURE__*/ function(ForkEvent) {
    (0, $ftJVG._)(BlockForkEvent, ForkEvent);
    var _super = (0, $6OZAO._)(BlockForkEvent);
    function BlockForkEvent(blockHash, expiry) {
        (0, $978gY._)(this, BlockForkEvent);
        if (!(0, $j2rU8.isHexString)(blockHash, 32)) $fd80fed41b6901ec$var$logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        return _super.call(this, {
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: expiry || 0,
            blockHash: blockHash
        });
    }
    return BlockForkEvent;
}($fd80fed41b6901ec$export$406ece1549ccd00e);
var $fd80fed41b6901ec$export$26bcd61a55716c98 = /*#__PURE__*/ function(ForkEvent) {
    (0, $ftJVG._)(TransactionForkEvent, ForkEvent);
    var _super = (0, $6OZAO._)(TransactionForkEvent);
    function TransactionForkEvent(hash, expiry) {
        (0, $978gY._)(this, TransactionForkEvent);
        if (!(0, $j2rU8.isHexString)(hash, 32)) $fd80fed41b6901ec$var$logger.throwArgumentError("invalid transaction hash", "hash", hash);
        return _super.call(this, {
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: expiry || 0,
            hash: hash
        });
    }
    return TransactionForkEvent;
}($fd80fed41b6901ec$export$406ece1549ccd00e);
var $fd80fed41b6901ec$export$8f8609bfee47c93 = /*#__PURE__*/ function(ForkEvent) {
    (0, $ftJVG._)(TransactionOrderForkEvent, ForkEvent);
    var _super = (0, $6OZAO._)(TransactionOrderForkEvent);
    function TransactionOrderForkEvent(beforeHash, afterHash, expiry) {
        (0, $978gY._)(this, TransactionOrderForkEvent);
        if (!(0, $j2rU8.isHexString)(beforeHash, 32)) $fd80fed41b6901ec$var$logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        if (!(0, $j2rU8.isHexString)(afterHash, 32)) $fd80fed41b6901ec$var$logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        return _super.call(this, {
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: expiry || 0,
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
    return TransactionOrderForkEvent;
}($fd80fed41b6901ec$export$406ece1549ccd00e);
var $fd80fed41b6901ec$export$2881499e37b75b9a = /*#__PURE__*/ function _target() {
    function Provider() {
        (0, $978gY._)(this, Provider);
        $fd80fed41b6901ec$var$logger.checkAbstract(this instanceof Provider ? this.constructor : void 0, Provider);
        (0, $2ax4w.defineReadOnly)(this, "_isProvider", true);
    }
    (0, $kry2a._)(Provider, [
        {
            key: "getFeeData",
            value: function getFeeData() {
                return $fd80fed41b6901ec$var$__awaiter(this, void 0, void 0, function() {
                    var _ref, block, gasPrice, lastBaseFeePerGas, maxFeePerGas, maxPriorityFeePerGas;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $2ax4w.resolveProperties)({
                                        block: this.getBlock("latest"),
                                        gasPrice: this.getGasPrice().catch(function(error) {
                                            // @TODO: Why is this now failing on Calaveras?
                                            //console.log(error);
                                            return null;
                                        })
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), block = _ref.block, gasPrice = _ref.gasPrice;
                                lastBaseFeePerGas = null, maxFeePerGas = null, maxPriorityFeePerGas = null;
                                if (block && block.baseFeePerGas) {
                                    // We may want to compute this more accurately in the future,
                                    // using the formula "check if the base fee is correct".
                                    // See: https://eips.ethereum.org/EIPS/eip-1559
                                    lastBaseFeePerGas = block.baseFeePerGas;
                                    maxPriorityFeePerGas = (0, $gMArf.BigNumber).from("1500000000");
                                    maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
                                }
                                return [
                                    2,
                                    {
                                        lastBaseFeePerGas: lastBaseFeePerGas,
                                        maxFeePerGas: maxFeePerGas,
                                        maxPriorityFeePerGas: maxPriorityFeePerGas,
                                        gasPrice: gasPrice
                                    }
                                ];
                        }
                    });
                });
            }
        },
        {
            // Alias for "on"
            key: "addListener",
            value: function addListener(eventName, listener) {
                return this.on(eventName, listener);
            }
        },
        {
            // Alias for "off"
            key: "removeListener",
            value: function removeListener(eventName, listener) {
                return this.off(eventName, listener);
            }
        }
    ], [
        {
            key: "isProvider",
            value: function isProvider(value) {
                return !!(value && value._isProvider);
            }
        }
    ]);
    return Provider;
}();

});
parcelRequire.register("bxoXJ", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $866623cc4d757217$export$83d89fbfd8236492; });
var $866623cc4d757217$export$83d89fbfd8236492 = "abstract-provider/5.7.0";

});


parcelRequire.register("iGUqv", function(module, exports) {

$parcel$export(module.exports, "Signer", function () { return $d9b7eb644de5bd3c$export$fdf54fdde81cc9f0; });
$parcel$export(module.exports, "VoidSigner", function () { return $d9b7eb644de5bd3c$export$7dbc56d9b9612bad; });

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $kAaop = parcelRequire("kAaop");
"use strict";
var $d9b7eb644de5bd3c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d9b7eb644de5bd3c$var$logger = new (0, $6M65e.Logger)((0, $kAaop.version));
var $d9b7eb644de5bd3c$var$allowedTransactionKeys = [
    "accessList",
    "ccipReadEnabled",
    "chainId",
    "customData",
    "data",
    "from",
    "gasLimit",
    "gasPrice",
    "maxFeePerGas",
    "maxPriorityFeePerGas",
    "nonce",
    "to",
    "type",
    "value"
];
var $d9b7eb644de5bd3c$var$forwardErrors = [
    (0, $6M65e.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $6M65e.Logger).errors.NONCE_EXPIRED,
    (0, $6M65e.Logger).errors.REPLACEMENT_UNDERPRICED
];
var $d9b7eb644de5bd3c$export$fdf54fdde81cc9f0 = /*#__PURE__*/ function _target() {
    function Signer() {
        (0, $978gY._)(this, Signer);
        $d9b7eb644de5bd3c$var$logger.checkAbstract(this instanceof Signer ? this.constructor : void 0, Signer);
        (0, $2ax4w.defineReadOnly)(this, "_isSigner", true);
    }
    (0, $kry2a._)(Signer, [
        {
            ///////////////////
            // Sub-classes MAY override these
            key: "getBalance",
            value: function getBalance(blockTag) {
                return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("getBalance");
                                return [
                                    4,
                                    this.provider.getBalance(this.getAddress(), blockTag)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getTransactionCount",
            value: function getTransactionCount(blockTag) {
                return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("getTransactionCount");
                                return [
                                    4,
                                    this.provider.getTransactionCount(this.getAddress(), blockTag)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            // Populates "from" if unspecified, and estimates the gas for the transaction
            key: "estimateGas",
            value: function estimateGas(transaction) {
                return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function() {
                    var tx;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("estimateGas");
                                return [
                                    4,
                                    (0, $2ax4w.resolveProperties)(this.checkTransaction(transaction))
                                ];
                            case 1:
                                tx = _state.sent();
                                return [
                                    4,
                                    this.provider.estimateGas(tx)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            // Populates "from" if unspecified, and calls with the transaction
            key: "call",
            value: function call(transaction, blockTag) {
                return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function() {
                    var tx;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("call");
                                return [
                                    4,
                                    (0, $2ax4w.resolveProperties)(this.checkTransaction(transaction))
                                ];
                            case 1:
                                tx = _state.sent();
                                return [
                                    4,
                                    this.provider.call(tx, blockTag)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            // Populates all fields in a transaction, signs it and sends it to the network
            key: "sendTransaction",
            value: function sendTransaction(transaction) {
                return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function() {
                    var tx, signedTx;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("sendTransaction");
                                return [
                                    4,
                                    this.populateTransaction(transaction)
                                ];
                            case 1:
                                tx = _state.sent();
                                return [
                                    4,
                                    this.signTransaction(tx)
                                ];
                            case 2:
                                signedTx = _state.sent();
                                return [
                                    4,
                                    this.provider.sendTransaction(signedTx)
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getChainId",
            value: function getChainId() {
                return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function() {
                    var network;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("getChainId");
                                return [
                                    4,
                                    this.provider.getNetwork()
                                ];
                            case 1:
                                network = _state.sent();
                                return [
                                    2,
                                    network.chainId
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getGasPrice",
            value: function getGasPrice() {
                return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("getGasPrice");
                                return [
                                    4,
                                    this.provider.getGasPrice()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getFeeData",
            value: function getFeeData() {
                return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("getFeeData");
                                return [
                                    4,
                                    this.provider.getFeeData()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "resolveName",
            value: function resolveName(name) {
                return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("resolveName");
                                return [
                                    4,
                                    this.provider.resolveName(name)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            // Checks a transaction does not contain invalid keys and if
            // no "from" is provided, populates it.
            // - does NOT require a provider
            // - adds "from" is not present
            // - returns a COPY (safe to mutate the result)
            // By default called from: (overriding these prevents it)
            //   - call
            //   - estimateGas
            //   - populateTransaction (and therefor sendTransaction)
            key: "checkTransaction",
            value: function checkTransaction(transaction) {
                for(var key in transaction)if ($d9b7eb644de5bd3c$var$allowedTransactionKeys.indexOf(key) === -1) $d9b7eb644de5bd3c$var$logger.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
                var tx = (0, $2ax4w.shallowCopy)(transaction);
                if (tx.from == null) tx.from = this.getAddress();
                else // Make sure any provided address matches this signer
                tx.from = Promise.all([
                    Promise.resolve(tx.from),
                    this.getAddress()
                ]).then(function(result) {
                    if (result[0].toLowerCase() !== result[1].toLowerCase()) $d9b7eb644de5bd3c$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
                    return result[0];
                });
                return tx;
            }
        },
        {
            // Populates ALL keys for a transaction and checks that "from" matches
            // this Signer. Should be used by sendTransaction but NOT by signTransaction.
            // By default called from: (overriding these prevents it)
            //   - sendTransaction
            //
            // Notes:
            //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
            key: "populateTransaction",
            value: function populateTransaction(transaction) {
                return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function() {
                    var _this, tx, hasEip1559, feeData, gasPrice;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    (0, $2ax4w.resolveProperties)(this.checkTransaction(transaction))
                                ];
                            case 1:
                                tx = _state.sent();
                                if (tx.to != null) {
                                    tx.to = Promise.resolve(tx.to).then(function(to) {
                                        return $d9b7eb644de5bd3c$var$__awaiter(_this, void 0, void 0, function() {
                                            var address;
                                            return (0, $7UAGh.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (to == null) return [
                                                            2,
                                                            null
                                                        ];
                                                        return [
                                                            4,
                                                            this.resolveName(to)
                                                        ];
                                                    case 1:
                                                        address = _state.sent();
                                                        if (address == null) $d9b7eb644de5bd3c$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                                                        return [
                                                            2,
                                                            address
                                                        ];
                                                }
                                            });
                                        });
                                    });
                                    // Prevent this error from causing an UnhandledPromiseException
                                    tx.to.catch(function(error) {});
                                }
                                hasEip1559 = tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;
                                if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) $d9b7eb644de5bd3c$var$logger.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
                                else if ((tx.type === 0 || tx.type === 1) && hasEip1559) $d9b7eb644de5bd3c$var$logger.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
                                if (!((tx.type === 2 || tx.type == null) && tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null)) return [
                                    3,
                                    2
                                ];
                                // Fully-formed EIP-1559 transaction (skip getFeeData)
                                tx.type = 2;
                                return [
                                    3,
                                    5
                                ];
                            case 2:
                                if (!(tx.type === 0 || tx.type === 1)) return [
                                    3,
                                    3
                                ];
                                // Explicit Legacy or EIP-2930 transaction
                                // Populate missing gasPrice
                                if (tx.gasPrice == null) tx.gasPrice = this.getGasPrice();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                return [
                                    4,
                                    this.getFeeData()
                                ];
                            case 4:
                                feeData = _state.sent();
                                if (tx.type == null) {
                                    // We need to auto-detect the intended type of this transaction...
                                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                                        // The network supports EIP-1559!
                                        // Upgrade transaction from null to eip-1559
                                        tx.type = 2;
                                        if (tx.gasPrice != null) {
                                            gasPrice = tx.gasPrice;
                                            delete tx.gasPrice;
                                            tx.maxFeePerGas = gasPrice;
                                            tx.maxPriorityFeePerGas = gasPrice;
                                        } else {
                                            // Populate missing fee data
                                            if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                                            if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                                        }
                                    } else if (feeData.gasPrice != null) {
                                        // Network doesn't support EIP-1559...
                                        // ...but they are trying to use EIP-1559 properties
                                        if (hasEip1559) $d9b7eb644de5bd3c$var$logger.throwError("network does not support EIP-1559", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                                            operation: "populateTransaction"
                                        });
                                        // Populate missing fee data
                                        if (tx.gasPrice == null) tx.gasPrice = feeData.gasPrice;
                                        // Explicitly set untyped transaction to legacy
                                        tx.type = 0;
                                    } else // getFeeData has failed us.
                                    $d9b7eb644de5bd3c$var$logger.throwError("failed to get consistent fee data", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                                        operation: "signer.getFeeData"
                                    });
                                } else if (tx.type === 2) {
                                    // Explicitly using EIP-1559
                                    // Populate missing fee data
                                    if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                                    if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                                }
                                _state.label = 5;
                            case 5:
                                if (tx.nonce == null) tx.nonce = this.getTransactionCount("pending");
                                if (tx.gasLimit == null) tx.gasLimit = this.estimateGas(tx).catch(function(error) {
                                    if ($d9b7eb644de5bd3c$var$forwardErrors.indexOf(error.code) >= 0) throw error;
                                    return $d9b7eb644de5bd3c$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $6M65e.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
                                        error: error,
                                        tx: tx
                                    });
                                });
                                if (tx.chainId == null) tx.chainId = this.getChainId();
                                else tx.chainId = Promise.all([
                                    Promise.resolve(tx.chainId),
                                    this.getChainId()
                                ]).then(function(results) {
                                    if (results[1] !== 0 && results[0] !== results[1]) $d9b7eb644de5bd3c$var$logger.throwArgumentError("chainId address mismatch", "transaction", transaction);
                                    return results[0];
                                });
                                return [
                                    4,
                                    (0, $2ax4w.resolveProperties)(tx)
                                ];
                            case 6:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            ///////////////////
            // Sub-classes SHOULD leave these alone
            key: "_checkProvider",
            value: function _checkProvider(operation) {
                if (!this.provider) $d9b7eb644de5bd3c$var$logger.throwError("missing provider", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: operation || "_checkProvider"
                });
            }
        }
    ], [
        {
            key: "isSigner",
            value: function isSigner(value) {
                return !!(value && value._isSigner);
            }
        }
    ]);
    return Signer;
}();
var $d9b7eb644de5bd3c$export$7dbc56d9b9612bad = /*#__PURE__*/ function(Signer) {
    (0, $ftJVG._)(VoidSigner, Signer);
    var _super = (0, $6OZAO._)(VoidSigner);
    function VoidSigner(address, provider) {
        (0, $978gY._)(this, VoidSigner);
        var _this;
        _this = _super.call(this);
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "address", address);
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "provider", provider || null);
        return _this;
    }
    (0, $kry2a._)(VoidSigner, [
        {
            key: "getAddress",
            value: function getAddress() {
                return Promise.resolve(this.address);
            }
        },
        {
            key: "_fail",
            value: function _fail(message, operation) {
                return Promise.resolve().then(function() {
                    $d9b7eb644de5bd3c$var$logger.throwError(message, (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: operation
                    });
                });
            }
        },
        {
            key: "signMessage",
            value: function signMessage(message) {
                return this._fail("VoidSigner cannot sign messages", "signMessage");
            }
        },
        {
            key: "signTransaction",
            value: function signTransaction(transaction) {
                return this._fail("VoidSigner cannot sign transactions", "signTransaction");
            }
        },
        {
            key: "_signTypedData",
            value: function _signTypedData(domain, types, value) {
                return this._fail("VoidSigner cannot sign typed data", "signTypedData");
            }
        },
        {
            key: "connect",
            value: function connect(provider) {
                return new VoidSigner(this.address, provider);
            }
        }
    ]);
    return VoidSigner;
}($d9b7eb644de5bd3c$export$fdf54fdde81cc9f0);

});
parcelRequire.register("kAaop", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $efbf3b320c61292d$export$83d89fbfd8236492; });
var $efbf3b320c61292d$export$83d89fbfd8236492 = "abstract-signer/5.7.0";

});


parcelRequire.register("fuKNC", function(module, exports) {

$parcel$export(module.exports, "decryptJsonWallet", function () { return $b47df5b3ead53646$export$e74fcde37488267a; });
$parcel$export(module.exports, "decryptJsonWalletSync", function () { return $b47df5b3ead53646$export$7a81c437a678891a; });

var $hnVpJ = parcelRequire("hnVpJ");

var $6jMeD = parcelRequire("6jMeD");

var $7Ybyv = parcelRequire("7Ybyv");
"use strict";
function $b47df5b3ead53646$export$e74fcde37488267a(json, password, progressCallback) {
    if ((0, $6jMeD.isCrowdsaleWallet)(json)) {
        if (progressCallback) progressCallback(0);
        var account = (0, $hnVpJ.decrypt)(json, password);
        if (progressCallback) progressCallback(1);
        return Promise.resolve(account);
    }
    if ((0, $6jMeD.isKeystoreWallet)(json)) return (0, $7Ybyv.decrypt)(json, password, progressCallback);
    return Promise.reject(new Error("invalid JSON wallet"));
}
function $b47df5b3ead53646$export$7a81c437a678891a(json, password) {
    if ((0, $6jMeD.isCrowdsaleWallet)(json)) return (0, $hnVpJ.decrypt)(json, password);
    if ((0, $6jMeD.isKeystoreWallet)(json)) return (0, $7Ybyv.decryptSync)(json, password);
    throw new Error("invalid JSON wallet");
}

});
parcelRequire.register("hnVpJ", function(module, exports) {

$parcel$export(module.exports, "decrypt", function () { return $ca811ee56d4e2b01$export$e85a0c9a1067c5d3; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7MQUh = parcelRequire("7MQUh");

var $e8NrM = parcelRequire("e8NrM");

var $j2rU8 = parcelRequire("j2rU8");

var $4ujqV = parcelRequire("4ujqV");

var $eIQbV = parcelRequire("eIQbV");

var $1Wmc7 = parcelRequire("1Wmc7");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $e8Zvl = parcelRequire("e8Zvl");

var $btS5Y = parcelRequire("btS5Y");
"use strict";
var $ca811ee56d4e2b01$var$logger = new (0, $6M65e.Logger)((0, $e8Zvl.version));
var $ca811ee56d4e2b01$export$93a76d16f88f2b3 = /*#__PURE__*/ function(Description) {
    (0, $ftJVG._)(CrowdsaleAccount, Description);
    var _super = (0, $6OZAO._)(CrowdsaleAccount);
    function CrowdsaleAccount() {
        (0, $978gY._)(this, CrowdsaleAccount);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(CrowdsaleAccount, [
        {
            key: "isCrowdsaleAccount",
            value: function isCrowdsaleAccount(value) {
                return !!(value && value._isCrowdsaleAccount);
            }
        }
    ]);
    return CrowdsaleAccount;
}((0, $2ax4w.Description));
function $ca811ee56d4e2b01$export$e85a0c9a1067c5d3(json, password) {
    var data = JSON.parse(json);
    password = (0, $btS5Y.getPassword)(password);
    // Ethereum Address
    var ethaddr = (0, $e8NrM.getAddress)((0, $btS5Y.searchPath)(data, "ethaddr"));
    // Encrypted Seed
    var encseed = (0, $btS5Y.looseArrayify)((0, $btS5Y.searchPath)(data, "encseed"));
    if (!encseed || encseed.length % 16 !== 0) $ca811ee56d4e2b01$var$logger.throwArgumentError("invalid encseed", "json", json);
    var key = (0, $j2rU8.arrayify)((0, $eIQbV.pbkdf2)(password, password, 2000, 32, "sha256")).slice(0, 16);
    var iv = encseed.slice(0, 16);
    var encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    var aesCbc = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).ModeOfOperation.cbc(key, iv);
    var seed = (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).padding.pkcs7.strip((0, $j2rU8.arrayify)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    var seedHex = "";
    for(var i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    var seedHexBytes = (0, $1Wmc7.toUtf8Bytes)(seedHex);
    var privateKey = (0, $4ujqV.keccak256)(seedHexBytes);
    return new $ca811ee56d4e2b01$export$93a76d16f88f2b3({
        _isCrowdsaleAccount: true,
        address: ethaddr,
        privateKey: privateKey
    });
}

});
parcelRequire.register("7MQUh", function(module, exports) {
"use strict";
(function(root) {
    var checkInt = function checkInt(value) {
        return parseInt(value) === value;
    };
    var checkInts = function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) return false;
        for(var i = 0; i < arrayish.length; i++){
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) return false;
        }
        return true;
    };
    var coerceArray = function coerceArray(arg, copy) {
        // ArrayBuffer view
        if (arg.buffer && ArrayBuffer.isView(arg) && arg.name === "Uint8Array") {
            if (copy) {
                if (arg.slice) arg = arg.slice();
                else arg = Array.prototype.slice.call(arg);
            }
            return arg;
        }
        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) throw new Error("Array contains invalid value: " + arg);
            return new Uint8Array(arg);
        }
        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) return new Uint8Array(arg);
        throw new Error("unsupported array-like object");
    };
    var createArray = function createArray(length) {
        return new Uint8Array(length);
    };
    var copyArray = function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            else sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
        }
        targetArray.set(sourceArray, targetStart);
    };
    var convertToInt32 = function convertToInt32(bytes) {
        var result = [];
        for(var i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
        return result;
    };
    var pkcs7pad = ///////////////////////
    // Padding
    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - data.length % 16;
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for(var i = data.length; i < result.length; i++)result[i] = padder;
        return result;
    };
    var pkcs7strip = function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) throw new Error("PKCS#7 invalid length");
        var padder = data[data.length - 1];
        if (padder > 16) throw new Error("PKCS#7 padding byte out of range");
        var length = data.length - padder;
        for(var i = 0; i < padder; i++){
            if (data[length + i] !== padder) throw new Error("PKCS#7 invalid padding byte");
        }
        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    };
    var convertUtf8 = function() {
        var toBytes = function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while(i < text.length){
                var c = text.charCodeAt(i++);
                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16));
                    i += 2;
                // otherwise, just the actual byte
                } else result.push(c);
            }
            return coerceArray(result);
        };
        var fromBytes = function fromBytes(bytes) {
            var result = [], i = 0;
            while(i < bytes.length){
                var c = bytes[i];
                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode((c & 0x1f) << 6 | bytes[i + 1] & 0x3f));
                    i += 2;
                } else {
                    result.push(String.fromCharCode((c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f));
                    i += 3;
                }
            }
            return result.join("");
        };
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    var convertHex = function() {
        var toBytes = function toBytes(text) {
            var result = [];
            for(var i = 0; i < text.length; i += 2)result.push(parseInt(text.substr(i, 2), 16));
            return result;
        };
        var fromBytes = function fromBytes(bytes) {
            var result = [];
            for(var i = 0; i < bytes.length; i++){
                var v = bytes[i];
                result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
            }
            return result.join("");
        };
        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = "0123456789abcdef";
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    // Number of rounds by keysize
    var numberOfRounds = {
        16: 10,
        24: 12,
        32: 14
    };
    // Round constant words
    var rcon = [
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36,
        0x6c,
        0xd8,
        0xab,
        0x4d,
        0x9a,
        0x2f,
        0x5e,
        0xbc,
        0x63,
        0xc6,
        0x97,
        0x35,
        0x6a,
        0xd4,
        0xb3,
        0x7d,
        0xfa,
        0xef,
        0xc5,
        0x91
    ];
    // S-box and Inverse S-box (S is for Substitution)
    var S = [
        0x63,
        0x7c,
        0x77,
        0x7b,
        0xf2,
        0x6b,
        0x6f,
        0xc5,
        0x30,
        0x01,
        0x67,
        0x2b,
        0xfe,
        0xd7,
        0xab,
        0x76,
        0xca,
        0x82,
        0xc9,
        0x7d,
        0xfa,
        0x59,
        0x47,
        0xf0,
        0xad,
        0xd4,
        0xa2,
        0xaf,
        0x9c,
        0xa4,
        0x72,
        0xc0,
        0xb7,
        0xfd,
        0x93,
        0x26,
        0x36,
        0x3f,
        0xf7,
        0xcc,
        0x34,
        0xa5,
        0xe5,
        0xf1,
        0x71,
        0xd8,
        0x31,
        0x15,
        0x04,
        0xc7,
        0x23,
        0xc3,
        0x18,
        0x96,
        0x05,
        0x9a,
        0x07,
        0x12,
        0x80,
        0xe2,
        0xeb,
        0x27,
        0xb2,
        0x75,
        0x09,
        0x83,
        0x2c,
        0x1a,
        0x1b,
        0x6e,
        0x5a,
        0xa0,
        0x52,
        0x3b,
        0xd6,
        0xb3,
        0x29,
        0xe3,
        0x2f,
        0x84,
        0x53,
        0xd1,
        0x00,
        0xed,
        0x20,
        0xfc,
        0xb1,
        0x5b,
        0x6a,
        0xcb,
        0xbe,
        0x39,
        0x4a,
        0x4c,
        0x58,
        0xcf,
        0xd0,
        0xef,
        0xaa,
        0xfb,
        0x43,
        0x4d,
        0x33,
        0x85,
        0x45,
        0xf9,
        0x02,
        0x7f,
        0x50,
        0x3c,
        0x9f,
        0xa8,
        0x51,
        0xa3,
        0x40,
        0x8f,
        0x92,
        0x9d,
        0x38,
        0xf5,
        0xbc,
        0xb6,
        0xda,
        0x21,
        0x10,
        0xff,
        0xf3,
        0xd2,
        0xcd,
        0x0c,
        0x13,
        0xec,
        0x5f,
        0x97,
        0x44,
        0x17,
        0xc4,
        0xa7,
        0x7e,
        0x3d,
        0x64,
        0x5d,
        0x19,
        0x73,
        0x60,
        0x81,
        0x4f,
        0xdc,
        0x22,
        0x2a,
        0x90,
        0x88,
        0x46,
        0xee,
        0xb8,
        0x14,
        0xde,
        0x5e,
        0x0b,
        0xdb,
        0xe0,
        0x32,
        0x3a,
        0x0a,
        0x49,
        0x06,
        0x24,
        0x5c,
        0xc2,
        0xd3,
        0xac,
        0x62,
        0x91,
        0x95,
        0xe4,
        0x79,
        0xe7,
        0xc8,
        0x37,
        0x6d,
        0x8d,
        0xd5,
        0x4e,
        0xa9,
        0x6c,
        0x56,
        0xf4,
        0xea,
        0x65,
        0x7a,
        0xae,
        0x08,
        0xba,
        0x78,
        0x25,
        0x2e,
        0x1c,
        0xa6,
        0xb4,
        0xc6,
        0xe8,
        0xdd,
        0x74,
        0x1f,
        0x4b,
        0xbd,
        0x8b,
        0x8a,
        0x70,
        0x3e,
        0xb5,
        0x66,
        0x48,
        0x03,
        0xf6,
        0x0e,
        0x61,
        0x35,
        0x57,
        0xb9,
        0x86,
        0xc1,
        0x1d,
        0x9e,
        0xe1,
        0xf8,
        0x98,
        0x11,
        0x69,
        0xd9,
        0x8e,
        0x94,
        0x9b,
        0x1e,
        0x87,
        0xe9,
        0xce,
        0x55,
        0x28,
        0xdf,
        0x8c,
        0xa1,
        0x89,
        0x0d,
        0xbf,
        0xe6,
        0x42,
        0x68,
        0x41,
        0x99,
        0x2d,
        0x0f,
        0xb0,
        0x54,
        0xbb,
        0x16
    ];
    var Si = [
        0x52,
        0x09,
        0x6a,
        0xd5,
        0x30,
        0x36,
        0xa5,
        0x38,
        0xbf,
        0x40,
        0xa3,
        0x9e,
        0x81,
        0xf3,
        0xd7,
        0xfb,
        0x7c,
        0xe3,
        0x39,
        0x82,
        0x9b,
        0x2f,
        0xff,
        0x87,
        0x34,
        0x8e,
        0x43,
        0x44,
        0xc4,
        0xde,
        0xe9,
        0xcb,
        0x54,
        0x7b,
        0x94,
        0x32,
        0xa6,
        0xc2,
        0x23,
        0x3d,
        0xee,
        0x4c,
        0x95,
        0x0b,
        0x42,
        0xfa,
        0xc3,
        0x4e,
        0x08,
        0x2e,
        0xa1,
        0x66,
        0x28,
        0xd9,
        0x24,
        0xb2,
        0x76,
        0x5b,
        0xa2,
        0x49,
        0x6d,
        0x8b,
        0xd1,
        0x25,
        0x72,
        0xf8,
        0xf6,
        0x64,
        0x86,
        0x68,
        0x98,
        0x16,
        0xd4,
        0xa4,
        0x5c,
        0xcc,
        0x5d,
        0x65,
        0xb6,
        0x92,
        0x6c,
        0x70,
        0x48,
        0x50,
        0xfd,
        0xed,
        0xb9,
        0xda,
        0x5e,
        0x15,
        0x46,
        0x57,
        0xa7,
        0x8d,
        0x9d,
        0x84,
        0x90,
        0xd8,
        0xab,
        0x00,
        0x8c,
        0xbc,
        0xd3,
        0x0a,
        0xf7,
        0xe4,
        0x58,
        0x05,
        0xb8,
        0xb3,
        0x45,
        0x06,
        0xd0,
        0x2c,
        0x1e,
        0x8f,
        0xca,
        0x3f,
        0x0f,
        0x02,
        0xc1,
        0xaf,
        0xbd,
        0x03,
        0x01,
        0x13,
        0x8a,
        0x6b,
        0x3a,
        0x91,
        0x11,
        0x41,
        0x4f,
        0x67,
        0xdc,
        0xea,
        0x97,
        0xf2,
        0xcf,
        0xce,
        0xf0,
        0xb4,
        0xe6,
        0x73,
        0x96,
        0xac,
        0x74,
        0x22,
        0xe7,
        0xad,
        0x35,
        0x85,
        0xe2,
        0xf9,
        0x37,
        0xe8,
        0x1c,
        0x75,
        0xdf,
        0x6e,
        0x47,
        0xf1,
        0x1a,
        0x71,
        0x1d,
        0x29,
        0xc5,
        0x89,
        0x6f,
        0xb7,
        0x62,
        0x0e,
        0xaa,
        0x18,
        0xbe,
        0x1b,
        0xfc,
        0x56,
        0x3e,
        0x4b,
        0xc6,
        0xd2,
        0x79,
        0x20,
        0x9a,
        0xdb,
        0xc0,
        0xfe,
        0x78,
        0xcd,
        0x5a,
        0xf4,
        0x1f,
        0xdd,
        0xa8,
        0x33,
        0x88,
        0x07,
        0xc7,
        0x31,
        0xb1,
        0x12,
        0x10,
        0x59,
        0x27,
        0x80,
        0xec,
        0x5f,
        0x60,
        0x51,
        0x7f,
        0xa9,
        0x19,
        0xb5,
        0x4a,
        0x0d,
        0x2d,
        0xe5,
        0x7a,
        0x9f,
        0x93,
        0xc9,
        0x9c,
        0xef,
        0xa0,
        0xe0,
        0x3b,
        0x4d,
        0xae,
        0x2a,
        0xf5,
        0xb0,
        0xc8,
        0xeb,
        0xbb,
        0x3c,
        0x83,
        0x53,
        0x99,
        0x61,
        0x17,
        0x2b,
        0x04,
        0x7e,
        0xba,
        0x77,
        0xd6,
        0x26,
        0xe1,
        0x69,
        0x14,
        0x63,
        0x55,
        0x21,
        0x0c,
        0x7d
    ];
    // Transformations for encryption
    var T1 = [
        0xc66363a5,
        0xf87c7c84,
        0xee777799,
        0xf67b7b8d,
        0xfff2f20d,
        0xd66b6bbd,
        0xde6f6fb1,
        0x91c5c554,
        0x60303050,
        0x02010103,
        0xce6767a9,
        0x562b2b7d,
        0xe7fefe19,
        0xb5d7d762,
        0x4dababe6,
        0xec76769a,
        0x8fcaca45,
        0x1f82829d,
        0x89c9c940,
        0xfa7d7d87,
        0xeffafa15,
        0xb25959eb,
        0x8e4747c9,
        0xfbf0f00b,
        0x41adadec,
        0xb3d4d467,
        0x5fa2a2fd,
        0x45afafea,
        0x239c9cbf,
        0x53a4a4f7,
        0xe4727296,
        0x9bc0c05b,
        0x75b7b7c2,
        0xe1fdfd1c,
        0x3d9393ae,
        0x4c26266a,
        0x6c36365a,
        0x7e3f3f41,
        0xf5f7f702,
        0x83cccc4f,
        0x6834345c,
        0x51a5a5f4,
        0xd1e5e534,
        0xf9f1f108,
        0xe2717193,
        0xabd8d873,
        0x62313153,
        0x2a15153f,
        0x0804040c,
        0x95c7c752,
        0x46232365,
        0x9dc3c35e,
        0x30181828,
        0x379696a1,
        0x0a05050f,
        0x2f9a9ab5,
        0x0e070709,
        0x24121236,
        0x1b80809b,
        0xdfe2e23d,
        0xcdebeb26,
        0x4e272769,
        0x7fb2b2cd,
        0xea75759f,
        0x1209091b,
        0x1d83839e,
        0x582c2c74,
        0x341a1a2e,
        0x361b1b2d,
        0xdc6e6eb2,
        0xb45a5aee,
        0x5ba0a0fb,
        0xa45252f6,
        0x763b3b4d,
        0xb7d6d661,
        0x7db3b3ce,
        0x5229297b,
        0xdde3e33e,
        0x5e2f2f71,
        0x13848497,
        0xa65353f5,
        0xb9d1d168,
        0x00000000,
        0xc1eded2c,
        0x40202060,
        0xe3fcfc1f,
        0x79b1b1c8,
        0xb65b5bed,
        0xd46a6abe,
        0x8dcbcb46,
        0x67bebed9,
        0x7239394b,
        0x944a4ade,
        0x984c4cd4,
        0xb05858e8,
        0x85cfcf4a,
        0xbbd0d06b,
        0xc5efef2a,
        0x4faaaae5,
        0xedfbfb16,
        0x864343c5,
        0x9a4d4dd7,
        0x66333355,
        0x11858594,
        0x8a4545cf,
        0xe9f9f910,
        0x04020206,
        0xfe7f7f81,
        0xa05050f0,
        0x783c3c44,
        0x259f9fba,
        0x4ba8a8e3,
        0xa25151f3,
        0x5da3a3fe,
        0x804040c0,
        0x058f8f8a,
        0x3f9292ad,
        0x219d9dbc,
        0x70383848,
        0xf1f5f504,
        0x63bcbcdf,
        0x77b6b6c1,
        0xafdada75,
        0x42212163,
        0x20101030,
        0xe5ffff1a,
        0xfdf3f30e,
        0xbfd2d26d,
        0x81cdcd4c,
        0x180c0c14,
        0x26131335,
        0xc3ecec2f,
        0xbe5f5fe1,
        0x359797a2,
        0x884444cc,
        0x2e171739,
        0x93c4c457,
        0x55a7a7f2,
        0xfc7e7e82,
        0x7a3d3d47,
        0xc86464ac,
        0xba5d5de7,
        0x3219192b,
        0xe6737395,
        0xc06060a0,
        0x19818198,
        0x9e4f4fd1,
        0xa3dcdc7f,
        0x44222266,
        0x542a2a7e,
        0x3b9090ab,
        0x0b888883,
        0x8c4646ca,
        0xc7eeee29,
        0x6bb8b8d3,
        0x2814143c,
        0xa7dede79,
        0xbc5e5ee2,
        0x160b0b1d,
        0xaddbdb76,
        0xdbe0e03b,
        0x64323256,
        0x743a3a4e,
        0x140a0a1e,
        0x924949db,
        0x0c06060a,
        0x4824246c,
        0xb85c5ce4,
        0x9fc2c25d,
        0xbdd3d36e,
        0x43acacef,
        0xc46262a6,
        0x399191a8,
        0x319595a4,
        0xd3e4e437,
        0xf279798b,
        0xd5e7e732,
        0x8bc8c843,
        0x6e373759,
        0xda6d6db7,
        0x018d8d8c,
        0xb1d5d564,
        0x9c4e4ed2,
        0x49a9a9e0,
        0xd86c6cb4,
        0xac5656fa,
        0xf3f4f407,
        0xcfeaea25,
        0xca6565af,
        0xf47a7a8e,
        0x47aeaee9,
        0x10080818,
        0x6fbabad5,
        0xf0787888,
        0x4a25256f,
        0x5c2e2e72,
        0x381c1c24,
        0x57a6a6f1,
        0x73b4b4c7,
        0x97c6c651,
        0xcbe8e823,
        0xa1dddd7c,
        0xe874749c,
        0x3e1f1f21,
        0x964b4bdd,
        0x61bdbddc,
        0x0d8b8b86,
        0x0f8a8a85,
        0xe0707090,
        0x7c3e3e42,
        0x71b5b5c4,
        0xcc6666aa,
        0x904848d8,
        0x06030305,
        0xf7f6f601,
        0x1c0e0e12,
        0xc26161a3,
        0x6a35355f,
        0xae5757f9,
        0x69b9b9d0,
        0x17868691,
        0x99c1c158,
        0x3a1d1d27,
        0x279e9eb9,
        0xd9e1e138,
        0xebf8f813,
        0x2b9898b3,
        0x22111133,
        0xd26969bb,
        0xa9d9d970,
        0x078e8e89,
        0x339494a7,
        0x2d9b9bb6,
        0x3c1e1e22,
        0x15878792,
        0xc9e9e920,
        0x87cece49,
        0xaa5555ff,
        0x50282878,
        0xa5dfdf7a,
        0x038c8c8f,
        0x59a1a1f8,
        0x09898980,
        0x1a0d0d17,
        0x65bfbfda,
        0xd7e6e631,
        0x844242c6,
        0xd06868b8,
        0x824141c3,
        0x299999b0,
        0x5a2d2d77,
        0x1e0f0f11,
        0x7bb0b0cb,
        0xa85454fc,
        0x6dbbbbd6,
        0x2c16163a
    ];
    var T2 = [
        0xa5c66363,
        0x84f87c7c,
        0x99ee7777,
        0x8df67b7b,
        0x0dfff2f2,
        0xbdd66b6b,
        0xb1de6f6f,
        0x5491c5c5,
        0x50603030,
        0x03020101,
        0xa9ce6767,
        0x7d562b2b,
        0x19e7fefe,
        0x62b5d7d7,
        0xe64dabab,
        0x9aec7676,
        0x458fcaca,
        0x9d1f8282,
        0x4089c9c9,
        0x87fa7d7d,
        0x15effafa,
        0xebb25959,
        0xc98e4747,
        0x0bfbf0f0,
        0xec41adad,
        0x67b3d4d4,
        0xfd5fa2a2,
        0xea45afaf,
        0xbf239c9c,
        0xf753a4a4,
        0x96e47272,
        0x5b9bc0c0,
        0xc275b7b7,
        0x1ce1fdfd,
        0xae3d9393,
        0x6a4c2626,
        0x5a6c3636,
        0x417e3f3f,
        0x02f5f7f7,
        0x4f83cccc,
        0x5c683434,
        0xf451a5a5,
        0x34d1e5e5,
        0x08f9f1f1,
        0x93e27171,
        0x73abd8d8,
        0x53623131,
        0x3f2a1515,
        0x0c080404,
        0x5295c7c7,
        0x65462323,
        0x5e9dc3c3,
        0x28301818,
        0xa1379696,
        0x0f0a0505,
        0xb52f9a9a,
        0x090e0707,
        0x36241212,
        0x9b1b8080,
        0x3ddfe2e2,
        0x26cdebeb,
        0x694e2727,
        0xcd7fb2b2,
        0x9fea7575,
        0x1b120909,
        0x9e1d8383,
        0x74582c2c,
        0x2e341a1a,
        0x2d361b1b,
        0xb2dc6e6e,
        0xeeb45a5a,
        0xfb5ba0a0,
        0xf6a45252,
        0x4d763b3b,
        0x61b7d6d6,
        0xce7db3b3,
        0x7b522929,
        0x3edde3e3,
        0x715e2f2f,
        0x97138484,
        0xf5a65353,
        0x68b9d1d1,
        0x00000000,
        0x2cc1eded,
        0x60402020,
        0x1fe3fcfc,
        0xc879b1b1,
        0xedb65b5b,
        0xbed46a6a,
        0x468dcbcb,
        0xd967bebe,
        0x4b723939,
        0xde944a4a,
        0xd4984c4c,
        0xe8b05858,
        0x4a85cfcf,
        0x6bbbd0d0,
        0x2ac5efef,
        0xe54faaaa,
        0x16edfbfb,
        0xc5864343,
        0xd79a4d4d,
        0x55663333,
        0x94118585,
        0xcf8a4545,
        0x10e9f9f9,
        0x06040202,
        0x81fe7f7f,
        0xf0a05050,
        0x44783c3c,
        0xba259f9f,
        0xe34ba8a8,
        0xf3a25151,
        0xfe5da3a3,
        0xc0804040,
        0x8a058f8f,
        0xad3f9292,
        0xbc219d9d,
        0x48703838,
        0x04f1f5f5,
        0xdf63bcbc,
        0xc177b6b6,
        0x75afdada,
        0x63422121,
        0x30201010,
        0x1ae5ffff,
        0x0efdf3f3,
        0x6dbfd2d2,
        0x4c81cdcd,
        0x14180c0c,
        0x35261313,
        0x2fc3ecec,
        0xe1be5f5f,
        0xa2359797,
        0xcc884444,
        0x392e1717,
        0x5793c4c4,
        0xf255a7a7,
        0x82fc7e7e,
        0x477a3d3d,
        0xacc86464,
        0xe7ba5d5d,
        0x2b321919,
        0x95e67373,
        0xa0c06060,
        0x98198181,
        0xd19e4f4f,
        0x7fa3dcdc,
        0x66442222,
        0x7e542a2a,
        0xab3b9090,
        0x830b8888,
        0xca8c4646,
        0x29c7eeee,
        0xd36bb8b8,
        0x3c281414,
        0x79a7dede,
        0xe2bc5e5e,
        0x1d160b0b,
        0x76addbdb,
        0x3bdbe0e0,
        0x56643232,
        0x4e743a3a,
        0x1e140a0a,
        0xdb924949,
        0x0a0c0606,
        0x6c482424,
        0xe4b85c5c,
        0x5d9fc2c2,
        0x6ebdd3d3,
        0xef43acac,
        0xa6c46262,
        0xa8399191,
        0xa4319595,
        0x37d3e4e4,
        0x8bf27979,
        0x32d5e7e7,
        0x438bc8c8,
        0x596e3737,
        0xb7da6d6d,
        0x8c018d8d,
        0x64b1d5d5,
        0xd29c4e4e,
        0xe049a9a9,
        0xb4d86c6c,
        0xfaac5656,
        0x07f3f4f4,
        0x25cfeaea,
        0xafca6565,
        0x8ef47a7a,
        0xe947aeae,
        0x18100808,
        0xd56fbaba,
        0x88f07878,
        0x6f4a2525,
        0x725c2e2e,
        0x24381c1c,
        0xf157a6a6,
        0xc773b4b4,
        0x5197c6c6,
        0x23cbe8e8,
        0x7ca1dddd,
        0x9ce87474,
        0x213e1f1f,
        0xdd964b4b,
        0xdc61bdbd,
        0x860d8b8b,
        0x850f8a8a,
        0x90e07070,
        0x427c3e3e,
        0xc471b5b5,
        0xaacc6666,
        0xd8904848,
        0x05060303,
        0x01f7f6f6,
        0x121c0e0e,
        0xa3c26161,
        0x5f6a3535,
        0xf9ae5757,
        0xd069b9b9,
        0x91178686,
        0x5899c1c1,
        0x273a1d1d,
        0xb9279e9e,
        0x38d9e1e1,
        0x13ebf8f8,
        0xb32b9898,
        0x33221111,
        0xbbd26969,
        0x70a9d9d9,
        0x89078e8e,
        0xa7339494,
        0xb62d9b9b,
        0x223c1e1e,
        0x92158787,
        0x20c9e9e9,
        0x4987cece,
        0xffaa5555,
        0x78502828,
        0x7aa5dfdf,
        0x8f038c8c,
        0xf859a1a1,
        0x80098989,
        0x171a0d0d,
        0xda65bfbf,
        0x31d7e6e6,
        0xc6844242,
        0xb8d06868,
        0xc3824141,
        0xb0299999,
        0x775a2d2d,
        0x111e0f0f,
        0xcb7bb0b0,
        0xfca85454,
        0xd66dbbbb,
        0x3a2c1616
    ];
    var T3 = [
        0x63a5c663,
        0x7c84f87c,
        0x7799ee77,
        0x7b8df67b,
        0xf20dfff2,
        0x6bbdd66b,
        0x6fb1de6f,
        0xc55491c5,
        0x30506030,
        0x01030201,
        0x67a9ce67,
        0x2b7d562b,
        0xfe19e7fe,
        0xd762b5d7,
        0xabe64dab,
        0x769aec76,
        0xca458fca,
        0x829d1f82,
        0xc94089c9,
        0x7d87fa7d,
        0xfa15effa,
        0x59ebb259,
        0x47c98e47,
        0xf00bfbf0,
        0xadec41ad,
        0xd467b3d4,
        0xa2fd5fa2,
        0xafea45af,
        0x9cbf239c,
        0xa4f753a4,
        0x7296e472,
        0xc05b9bc0,
        0xb7c275b7,
        0xfd1ce1fd,
        0x93ae3d93,
        0x266a4c26,
        0x365a6c36,
        0x3f417e3f,
        0xf702f5f7,
        0xcc4f83cc,
        0x345c6834,
        0xa5f451a5,
        0xe534d1e5,
        0xf108f9f1,
        0x7193e271,
        0xd873abd8,
        0x31536231,
        0x153f2a15,
        0x040c0804,
        0xc75295c7,
        0x23654623,
        0xc35e9dc3,
        0x18283018,
        0x96a13796,
        0x050f0a05,
        0x9ab52f9a,
        0x07090e07,
        0x12362412,
        0x809b1b80,
        0xe23ddfe2,
        0xeb26cdeb,
        0x27694e27,
        0xb2cd7fb2,
        0x759fea75,
        0x091b1209,
        0x839e1d83,
        0x2c74582c,
        0x1a2e341a,
        0x1b2d361b,
        0x6eb2dc6e,
        0x5aeeb45a,
        0xa0fb5ba0,
        0x52f6a452,
        0x3b4d763b,
        0xd661b7d6,
        0xb3ce7db3,
        0x297b5229,
        0xe33edde3,
        0x2f715e2f,
        0x84971384,
        0x53f5a653,
        0xd168b9d1,
        0x00000000,
        0xed2cc1ed,
        0x20604020,
        0xfc1fe3fc,
        0xb1c879b1,
        0x5bedb65b,
        0x6abed46a,
        0xcb468dcb,
        0xbed967be,
        0x394b7239,
        0x4ade944a,
        0x4cd4984c,
        0x58e8b058,
        0xcf4a85cf,
        0xd06bbbd0,
        0xef2ac5ef,
        0xaae54faa,
        0xfb16edfb,
        0x43c58643,
        0x4dd79a4d,
        0x33556633,
        0x85941185,
        0x45cf8a45,
        0xf910e9f9,
        0x02060402,
        0x7f81fe7f,
        0x50f0a050,
        0x3c44783c,
        0x9fba259f,
        0xa8e34ba8,
        0x51f3a251,
        0xa3fe5da3,
        0x40c08040,
        0x8f8a058f,
        0x92ad3f92,
        0x9dbc219d,
        0x38487038,
        0xf504f1f5,
        0xbcdf63bc,
        0xb6c177b6,
        0xda75afda,
        0x21634221,
        0x10302010,
        0xff1ae5ff,
        0xf30efdf3,
        0xd26dbfd2,
        0xcd4c81cd,
        0x0c14180c,
        0x13352613,
        0xec2fc3ec,
        0x5fe1be5f,
        0x97a23597,
        0x44cc8844,
        0x17392e17,
        0xc45793c4,
        0xa7f255a7,
        0x7e82fc7e,
        0x3d477a3d,
        0x64acc864,
        0x5de7ba5d,
        0x192b3219,
        0x7395e673,
        0x60a0c060,
        0x81981981,
        0x4fd19e4f,
        0xdc7fa3dc,
        0x22664422,
        0x2a7e542a,
        0x90ab3b90,
        0x88830b88,
        0x46ca8c46,
        0xee29c7ee,
        0xb8d36bb8,
        0x143c2814,
        0xde79a7de,
        0x5ee2bc5e,
        0x0b1d160b,
        0xdb76addb,
        0xe03bdbe0,
        0x32566432,
        0x3a4e743a,
        0x0a1e140a,
        0x49db9249,
        0x060a0c06,
        0x246c4824,
        0x5ce4b85c,
        0xc25d9fc2,
        0xd36ebdd3,
        0xacef43ac,
        0x62a6c462,
        0x91a83991,
        0x95a43195,
        0xe437d3e4,
        0x798bf279,
        0xe732d5e7,
        0xc8438bc8,
        0x37596e37,
        0x6db7da6d,
        0x8d8c018d,
        0xd564b1d5,
        0x4ed29c4e,
        0xa9e049a9,
        0x6cb4d86c,
        0x56faac56,
        0xf407f3f4,
        0xea25cfea,
        0x65afca65,
        0x7a8ef47a,
        0xaee947ae,
        0x08181008,
        0xbad56fba,
        0x7888f078,
        0x256f4a25,
        0x2e725c2e,
        0x1c24381c,
        0xa6f157a6,
        0xb4c773b4,
        0xc65197c6,
        0xe823cbe8,
        0xdd7ca1dd,
        0x749ce874,
        0x1f213e1f,
        0x4bdd964b,
        0xbddc61bd,
        0x8b860d8b,
        0x8a850f8a,
        0x7090e070,
        0x3e427c3e,
        0xb5c471b5,
        0x66aacc66,
        0x48d89048,
        0x03050603,
        0xf601f7f6,
        0x0e121c0e,
        0x61a3c261,
        0x355f6a35,
        0x57f9ae57,
        0xb9d069b9,
        0x86911786,
        0xc15899c1,
        0x1d273a1d,
        0x9eb9279e,
        0xe138d9e1,
        0xf813ebf8,
        0x98b32b98,
        0x11332211,
        0x69bbd269,
        0xd970a9d9,
        0x8e89078e,
        0x94a73394,
        0x9bb62d9b,
        0x1e223c1e,
        0x87921587,
        0xe920c9e9,
        0xce4987ce,
        0x55ffaa55,
        0x28785028,
        0xdf7aa5df,
        0x8c8f038c,
        0xa1f859a1,
        0x89800989,
        0x0d171a0d,
        0xbfda65bf,
        0xe631d7e6,
        0x42c68442,
        0x68b8d068,
        0x41c38241,
        0x99b02999,
        0x2d775a2d,
        0x0f111e0f,
        0xb0cb7bb0,
        0x54fca854,
        0xbbd66dbb,
        0x163a2c16
    ];
    var T4 = [
        0x6363a5c6,
        0x7c7c84f8,
        0x777799ee,
        0x7b7b8df6,
        0xf2f20dff,
        0x6b6bbdd6,
        0x6f6fb1de,
        0xc5c55491,
        0x30305060,
        0x01010302,
        0x6767a9ce,
        0x2b2b7d56,
        0xfefe19e7,
        0xd7d762b5,
        0xababe64d,
        0x76769aec,
        0xcaca458f,
        0x82829d1f,
        0xc9c94089,
        0x7d7d87fa,
        0xfafa15ef,
        0x5959ebb2,
        0x4747c98e,
        0xf0f00bfb,
        0xadadec41,
        0xd4d467b3,
        0xa2a2fd5f,
        0xafafea45,
        0x9c9cbf23,
        0xa4a4f753,
        0x727296e4,
        0xc0c05b9b,
        0xb7b7c275,
        0xfdfd1ce1,
        0x9393ae3d,
        0x26266a4c,
        0x36365a6c,
        0x3f3f417e,
        0xf7f702f5,
        0xcccc4f83,
        0x34345c68,
        0xa5a5f451,
        0xe5e534d1,
        0xf1f108f9,
        0x717193e2,
        0xd8d873ab,
        0x31315362,
        0x15153f2a,
        0x04040c08,
        0xc7c75295,
        0x23236546,
        0xc3c35e9d,
        0x18182830,
        0x9696a137,
        0x05050f0a,
        0x9a9ab52f,
        0x0707090e,
        0x12123624,
        0x80809b1b,
        0xe2e23ddf,
        0xebeb26cd,
        0x2727694e,
        0xb2b2cd7f,
        0x75759fea,
        0x09091b12,
        0x83839e1d,
        0x2c2c7458,
        0x1a1a2e34,
        0x1b1b2d36,
        0x6e6eb2dc,
        0x5a5aeeb4,
        0xa0a0fb5b,
        0x5252f6a4,
        0x3b3b4d76,
        0xd6d661b7,
        0xb3b3ce7d,
        0x29297b52,
        0xe3e33edd,
        0x2f2f715e,
        0x84849713,
        0x5353f5a6,
        0xd1d168b9,
        0x00000000,
        0xeded2cc1,
        0x20206040,
        0xfcfc1fe3,
        0xb1b1c879,
        0x5b5bedb6,
        0x6a6abed4,
        0xcbcb468d,
        0xbebed967,
        0x39394b72,
        0x4a4ade94,
        0x4c4cd498,
        0x5858e8b0,
        0xcfcf4a85,
        0xd0d06bbb,
        0xefef2ac5,
        0xaaaae54f,
        0xfbfb16ed,
        0x4343c586,
        0x4d4dd79a,
        0x33335566,
        0x85859411,
        0x4545cf8a,
        0xf9f910e9,
        0x02020604,
        0x7f7f81fe,
        0x5050f0a0,
        0x3c3c4478,
        0x9f9fba25,
        0xa8a8e34b,
        0x5151f3a2,
        0xa3a3fe5d,
        0x4040c080,
        0x8f8f8a05,
        0x9292ad3f,
        0x9d9dbc21,
        0x38384870,
        0xf5f504f1,
        0xbcbcdf63,
        0xb6b6c177,
        0xdada75af,
        0x21216342,
        0x10103020,
        0xffff1ae5,
        0xf3f30efd,
        0xd2d26dbf,
        0xcdcd4c81,
        0x0c0c1418,
        0x13133526,
        0xecec2fc3,
        0x5f5fe1be,
        0x9797a235,
        0x4444cc88,
        0x1717392e,
        0xc4c45793,
        0xa7a7f255,
        0x7e7e82fc,
        0x3d3d477a,
        0x6464acc8,
        0x5d5de7ba,
        0x19192b32,
        0x737395e6,
        0x6060a0c0,
        0x81819819,
        0x4f4fd19e,
        0xdcdc7fa3,
        0x22226644,
        0x2a2a7e54,
        0x9090ab3b,
        0x8888830b,
        0x4646ca8c,
        0xeeee29c7,
        0xb8b8d36b,
        0x14143c28,
        0xdede79a7,
        0x5e5ee2bc,
        0x0b0b1d16,
        0xdbdb76ad,
        0xe0e03bdb,
        0x32325664,
        0x3a3a4e74,
        0x0a0a1e14,
        0x4949db92,
        0x06060a0c,
        0x24246c48,
        0x5c5ce4b8,
        0xc2c25d9f,
        0xd3d36ebd,
        0xacacef43,
        0x6262a6c4,
        0x9191a839,
        0x9595a431,
        0xe4e437d3,
        0x79798bf2,
        0xe7e732d5,
        0xc8c8438b,
        0x3737596e,
        0x6d6db7da,
        0x8d8d8c01,
        0xd5d564b1,
        0x4e4ed29c,
        0xa9a9e049,
        0x6c6cb4d8,
        0x5656faac,
        0xf4f407f3,
        0xeaea25cf,
        0x6565afca,
        0x7a7a8ef4,
        0xaeaee947,
        0x08081810,
        0xbabad56f,
        0x787888f0,
        0x25256f4a,
        0x2e2e725c,
        0x1c1c2438,
        0xa6a6f157,
        0xb4b4c773,
        0xc6c65197,
        0xe8e823cb,
        0xdddd7ca1,
        0x74749ce8,
        0x1f1f213e,
        0x4b4bdd96,
        0xbdbddc61,
        0x8b8b860d,
        0x8a8a850f,
        0x707090e0,
        0x3e3e427c,
        0xb5b5c471,
        0x6666aacc,
        0x4848d890,
        0x03030506,
        0xf6f601f7,
        0x0e0e121c,
        0x6161a3c2,
        0x35355f6a,
        0x5757f9ae,
        0xb9b9d069,
        0x86869117,
        0xc1c15899,
        0x1d1d273a,
        0x9e9eb927,
        0xe1e138d9,
        0xf8f813eb,
        0x9898b32b,
        0x11113322,
        0x6969bbd2,
        0xd9d970a9,
        0x8e8e8907,
        0x9494a733,
        0x9b9bb62d,
        0x1e1e223c,
        0x87879215,
        0xe9e920c9,
        0xcece4987,
        0x5555ffaa,
        0x28287850,
        0xdfdf7aa5,
        0x8c8c8f03,
        0xa1a1f859,
        0x89898009,
        0x0d0d171a,
        0xbfbfda65,
        0xe6e631d7,
        0x4242c684,
        0x6868b8d0,
        0x4141c382,
        0x9999b029,
        0x2d2d775a,
        0x0f0f111e,
        0xb0b0cb7b,
        0x5454fca8,
        0xbbbbd66d,
        0x16163a2c
    ];
    // Transformations for decryption
    var T5 = [
        0x51f4a750,
        0x7e416553,
        0x1a17a4c3,
        0x3a275e96,
        0x3bab6bcb,
        0x1f9d45f1,
        0xacfa58ab,
        0x4be30393,
        0x2030fa55,
        0xad766df6,
        0x88cc7691,
        0xf5024c25,
        0x4fe5d7fc,
        0xc52acbd7,
        0x26354480,
        0xb562a38f,
        0xdeb15a49,
        0x25ba1b67,
        0x45ea0e98,
        0x5dfec0e1,
        0xc32f7502,
        0x814cf012,
        0x8d4697a3,
        0x6bd3f9c6,
        0x038f5fe7,
        0x15929c95,
        0xbf6d7aeb,
        0x955259da,
        0xd4be832d,
        0x587421d3,
        0x49e06929,
        0x8ec9c844,
        0x75c2896a,
        0xf48e7978,
        0x99583e6b,
        0x27b971dd,
        0xbee14fb6,
        0xf088ad17,
        0xc920ac66,
        0x7dce3ab4,
        0x63df4a18,
        0xe51a3182,
        0x97513360,
        0x62537f45,
        0xb16477e0,
        0xbb6bae84,
        0xfe81a01c,
        0xf9082b94,
        0x70486858,
        0x8f45fd19,
        0x94de6c87,
        0x527bf8b7,
        0xab73d323,
        0x724b02e2,
        0xe31f8f57,
        0x6655ab2a,
        0xb2eb2807,
        0x2fb5c203,
        0x86c57b9a,
        0xd33708a5,
        0x302887f2,
        0x23bfa5b2,
        0x02036aba,
        0xed16825c,
        0x8acf1c2b,
        0xa779b492,
        0xf307f2f0,
        0x4e69e2a1,
        0x65daf4cd,
        0x0605bed5,
        0xd134621f,
        0xc4a6fe8a,
        0x342e539d,
        0xa2f355a0,
        0x058ae132,
        0xa4f6eb75,
        0x0b83ec39,
        0x4060efaa,
        0x5e719f06,
        0xbd6e1051,
        0x3e218af9,
        0x96dd063d,
        0xdd3e05ae,
        0x4de6bd46,
        0x91548db5,
        0x71c45d05,
        0x0406d46f,
        0x605015ff,
        0x1998fb24,
        0xd6bde997,
        0x894043cc,
        0x67d99e77,
        0xb0e842bd,
        0x07898b88,
        0xe7195b38,
        0x79c8eedb,
        0xa17c0a47,
        0x7c420fe9,
        0xf8841ec9,
        0x00000000,
        0x09808683,
        0x322bed48,
        0x1e1170ac,
        0x6c5a724e,
        0xfd0efffb,
        0x0f853856,
        0x3daed51e,
        0x362d3927,
        0x0a0fd964,
        0x685ca621,
        0x9b5b54d1,
        0x24362e3a,
        0x0c0a67b1,
        0x9357e70f,
        0xb4ee96d2,
        0x1b9b919e,
        0x80c0c54f,
        0x61dc20a2,
        0x5a774b69,
        0x1c121a16,
        0xe293ba0a,
        0xc0a02ae5,
        0x3c22e043,
        0x121b171d,
        0x0e090d0b,
        0xf28bc7ad,
        0x2db6a8b9,
        0x141ea9c8,
        0x57f11985,
        0xaf75074c,
        0xee99ddbb,
        0xa37f60fd,
        0xf701269f,
        0x5c72f5bc,
        0x44663bc5,
        0x5bfb7e34,
        0x8b432976,
        0xcb23c6dc,
        0xb6edfc68,
        0xb8e4f163,
        0xd731dcca,
        0x42638510,
        0x13972240,
        0x84c61120,
        0x854a247d,
        0xd2bb3df8,
        0xaef93211,
        0xc729a16d,
        0x1d9e2f4b,
        0xdcb230f3,
        0x0d8652ec,
        0x77c1e3d0,
        0x2bb3166c,
        0xa970b999,
        0x119448fa,
        0x47e96422,
        0xa8fc8cc4,
        0xa0f03f1a,
        0x567d2cd8,
        0x223390ef,
        0x87494ec7,
        0xd938d1c1,
        0x8ccaa2fe,
        0x98d40b36,
        0xa6f581cf,
        0xa57ade28,
        0xdab78e26,
        0x3fadbfa4,
        0x2c3a9de4,
        0x5078920d,
        0x6a5fcc9b,
        0x547e4662,
        0xf68d13c2,
        0x90d8b8e8,
        0x2e39f75e,
        0x82c3aff5,
        0x9f5d80be,
        0x69d0937c,
        0x6fd52da9,
        0xcf2512b3,
        0xc8ac993b,
        0x10187da7,
        0xe89c636e,
        0xdb3bbb7b,
        0xcd267809,
        0x6e5918f4,
        0xec9ab701,
        0x834f9aa8,
        0xe6956e65,
        0xaaffe67e,
        0x21bccf08,
        0xef15e8e6,
        0xbae79bd9,
        0x4a6f36ce,
        0xea9f09d4,
        0x29b07cd6,
        0x31a4b2af,
        0x2a3f2331,
        0xc6a59430,
        0x35a266c0,
        0x744ebc37,
        0xfc82caa6,
        0xe090d0b0,
        0x33a7d815,
        0xf104984a,
        0x41ecdaf7,
        0x7fcd500e,
        0x1791f62f,
        0x764dd68d,
        0x43efb04d,
        0xccaa4d54,
        0xe49604df,
        0x9ed1b5e3,
        0x4c6a881b,
        0xc12c1fb8,
        0x4665517f,
        0x9d5eea04,
        0x018c355d,
        0xfa877473,
        0xfb0b412e,
        0xb3671d5a,
        0x92dbd252,
        0xe9105633,
        0x6dd64713,
        0x9ad7618c,
        0x37a10c7a,
        0x59f8148e,
        0xeb133c89,
        0xcea927ee,
        0xb761c935,
        0xe11ce5ed,
        0x7a47b13c,
        0x9cd2df59,
        0x55f2733f,
        0x1814ce79,
        0x73c737bf,
        0x53f7cdea,
        0x5ffdaa5b,
        0xdf3d6f14,
        0x7844db86,
        0xcaaff381,
        0xb968c43e,
        0x3824342c,
        0xc2a3405f,
        0x161dc372,
        0xbce2250c,
        0x283c498b,
        0xff0d9541,
        0x39a80171,
        0x080cb3de,
        0xd8b4e49c,
        0x6456c190,
        0x7bcb8461,
        0xd532b670,
        0x486c5c74,
        0xd0b85742
    ];
    var T6 = [
        0x5051f4a7,
        0x537e4165,
        0xc31a17a4,
        0x963a275e,
        0xcb3bab6b,
        0xf11f9d45,
        0xabacfa58,
        0x934be303,
        0x552030fa,
        0xf6ad766d,
        0x9188cc76,
        0x25f5024c,
        0xfc4fe5d7,
        0xd7c52acb,
        0x80263544,
        0x8fb562a3,
        0x49deb15a,
        0x6725ba1b,
        0x9845ea0e,
        0xe15dfec0,
        0x02c32f75,
        0x12814cf0,
        0xa38d4697,
        0xc66bd3f9,
        0xe7038f5f,
        0x9515929c,
        0xebbf6d7a,
        0xda955259,
        0x2dd4be83,
        0xd3587421,
        0x2949e069,
        0x448ec9c8,
        0x6a75c289,
        0x78f48e79,
        0x6b99583e,
        0xdd27b971,
        0xb6bee14f,
        0x17f088ad,
        0x66c920ac,
        0xb47dce3a,
        0x1863df4a,
        0x82e51a31,
        0x60975133,
        0x4562537f,
        0xe0b16477,
        0x84bb6bae,
        0x1cfe81a0,
        0x94f9082b,
        0x58704868,
        0x198f45fd,
        0x8794de6c,
        0xb7527bf8,
        0x23ab73d3,
        0xe2724b02,
        0x57e31f8f,
        0x2a6655ab,
        0x07b2eb28,
        0x032fb5c2,
        0x9a86c57b,
        0xa5d33708,
        0xf2302887,
        0xb223bfa5,
        0xba02036a,
        0x5ced1682,
        0x2b8acf1c,
        0x92a779b4,
        0xf0f307f2,
        0xa14e69e2,
        0xcd65daf4,
        0xd50605be,
        0x1fd13462,
        0x8ac4a6fe,
        0x9d342e53,
        0xa0a2f355,
        0x32058ae1,
        0x75a4f6eb,
        0x390b83ec,
        0xaa4060ef,
        0x065e719f,
        0x51bd6e10,
        0xf93e218a,
        0x3d96dd06,
        0xaedd3e05,
        0x464de6bd,
        0xb591548d,
        0x0571c45d,
        0x6f0406d4,
        0xff605015,
        0x241998fb,
        0x97d6bde9,
        0xcc894043,
        0x7767d99e,
        0xbdb0e842,
        0x8807898b,
        0x38e7195b,
        0xdb79c8ee,
        0x47a17c0a,
        0xe97c420f,
        0xc9f8841e,
        0x00000000,
        0x83098086,
        0x48322bed,
        0xac1e1170,
        0x4e6c5a72,
        0xfbfd0eff,
        0x560f8538,
        0x1e3daed5,
        0x27362d39,
        0x640a0fd9,
        0x21685ca6,
        0xd19b5b54,
        0x3a24362e,
        0xb10c0a67,
        0x0f9357e7,
        0xd2b4ee96,
        0x9e1b9b91,
        0x4f80c0c5,
        0xa261dc20,
        0x695a774b,
        0x161c121a,
        0x0ae293ba,
        0xe5c0a02a,
        0x433c22e0,
        0x1d121b17,
        0x0b0e090d,
        0xadf28bc7,
        0xb92db6a8,
        0xc8141ea9,
        0x8557f119,
        0x4caf7507,
        0xbbee99dd,
        0xfda37f60,
        0x9ff70126,
        0xbc5c72f5,
        0xc544663b,
        0x345bfb7e,
        0x768b4329,
        0xdccb23c6,
        0x68b6edfc,
        0x63b8e4f1,
        0xcad731dc,
        0x10426385,
        0x40139722,
        0x2084c611,
        0x7d854a24,
        0xf8d2bb3d,
        0x11aef932,
        0x6dc729a1,
        0x4b1d9e2f,
        0xf3dcb230,
        0xec0d8652,
        0xd077c1e3,
        0x6c2bb316,
        0x99a970b9,
        0xfa119448,
        0x2247e964,
        0xc4a8fc8c,
        0x1aa0f03f,
        0xd8567d2c,
        0xef223390,
        0xc787494e,
        0xc1d938d1,
        0xfe8ccaa2,
        0x3698d40b,
        0xcfa6f581,
        0x28a57ade,
        0x26dab78e,
        0xa43fadbf,
        0xe42c3a9d,
        0x0d507892,
        0x9b6a5fcc,
        0x62547e46,
        0xc2f68d13,
        0xe890d8b8,
        0x5e2e39f7,
        0xf582c3af,
        0xbe9f5d80,
        0x7c69d093,
        0xa96fd52d,
        0xb3cf2512,
        0x3bc8ac99,
        0xa710187d,
        0x6ee89c63,
        0x7bdb3bbb,
        0x09cd2678,
        0xf46e5918,
        0x01ec9ab7,
        0xa8834f9a,
        0x65e6956e,
        0x7eaaffe6,
        0x0821bccf,
        0xe6ef15e8,
        0xd9bae79b,
        0xce4a6f36,
        0xd4ea9f09,
        0xd629b07c,
        0xaf31a4b2,
        0x312a3f23,
        0x30c6a594,
        0xc035a266,
        0x37744ebc,
        0xa6fc82ca,
        0xb0e090d0,
        0x1533a7d8,
        0x4af10498,
        0xf741ecda,
        0x0e7fcd50,
        0x2f1791f6,
        0x8d764dd6,
        0x4d43efb0,
        0x54ccaa4d,
        0xdfe49604,
        0xe39ed1b5,
        0x1b4c6a88,
        0xb8c12c1f,
        0x7f466551,
        0x049d5eea,
        0x5d018c35,
        0x73fa8774,
        0x2efb0b41,
        0x5ab3671d,
        0x5292dbd2,
        0x33e91056,
        0x136dd647,
        0x8c9ad761,
        0x7a37a10c,
        0x8e59f814,
        0x89eb133c,
        0xeecea927,
        0x35b761c9,
        0xede11ce5,
        0x3c7a47b1,
        0x599cd2df,
        0x3f55f273,
        0x791814ce,
        0xbf73c737,
        0xea53f7cd,
        0x5b5ffdaa,
        0x14df3d6f,
        0x867844db,
        0x81caaff3,
        0x3eb968c4,
        0x2c382434,
        0x5fc2a340,
        0x72161dc3,
        0x0cbce225,
        0x8b283c49,
        0x41ff0d95,
        0x7139a801,
        0xde080cb3,
        0x9cd8b4e4,
        0x906456c1,
        0x617bcb84,
        0x70d532b6,
        0x74486c5c,
        0x42d0b857
    ];
    var T7 = [
        0xa75051f4,
        0x65537e41,
        0xa4c31a17,
        0x5e963a27,
        0x6bcb3bab,
        0x45f11f9d,
        0x58abacfa,
        0x03934be3,
        0xfa552030,
        0x6df6ad76,
        0x769188cc,
        0x4c25f502,
        0xd7fc4fe5,
        0xcbd7c52a,
        0x44802635,
        0xa38fb562,
        0x5a49deb1,
        0x1b6725ba,
        0x0e9845ea,
        0xc0e15dfe,
        0x7502c32f,
        0xf012814c,
        0x97a38d46,
        0xf9c66bd3,
        0x5fe7038f,
        0x9c951592,
        0x7aebbf6d,
        0x59da9552,
        0x832dd4be,
        0x21d35874,
        0x692949e0,
        0xc8448ec9,
        0x896a75c2,
        0x7978f48e,
        0x3e6b9958,
        0x71dd27b9,
        0x4fb6bee1,
        0xad17f088,
        0xac66c920,
        0x3ab47dce,
        0x4a1863df,
        0x3182e51a,
        0x33609751,
        0x7f456253,
        0x77e0b164,
        0xae84bb6b,
        0xa01cfe81,
        0x2b94f908,
        0x68587048,
        0xfd198f45,
        0x6c8794de,
        0xf8b7527b,
        0xd323ab73,
        0x02e2724b,
        0x8f57e31f,
        0xab2a6655,
        0x2807b2eb,
        0xc2032fb5,
        0x7b9a86c5,
        0x08a5d337,
        0x87f23028,
        0xa5b223bf,
        0x6aba0203,
        0x825ced16,
        0x1c2b8acf,
        0xb492a779,
        0xf2f0f307,
        0xe2a14e69,
        0xf4cd65da,
        0xbed50605,
        0x621fd134,
        0xfe8ac4a6,
        0x539d342e,
        0x55a0a2f3,
        0xe132058a,
        0xeb75a4f6,
        0xec390b83,
        0xefaa4060,
        0x9f065e71,
        0x1051bd6e,
        0x8af93e21,
        0x063d96dd,
        0x05aedd3e,
        0xbd464de6,
        0x8db59154,
        0x5d0571c4,
        0xd46f0406,
        0x15ff6050,
        0xfb241998,
        0xe997d6bd,
        0x43cc8940,
        0x9e7767d9,
        0x42bdb0e8,
        0x8b880789,
        0x5b38e719,
        0xeedb79c8,
        0x0a47a17c,
        0x0fe97c42,
        0x1ec9f884,
        0x00000000,
        0x86830980,
        0xed48322b,
        0x70ac1e11,
        0x724e6c5a,
        0xfffbfd0e,
        0x38560f85,
        0xd51e3dae,
        0x3927362d,
        0xd9640a0f,
        0xa621685c,
        0x54d19b5b,
        0x2e3a2436,
        0x67b10c0a,
        0xe70f9357,
        0x96d2b4ee,
        0x919e1b9b,
        0xc54f80c0,
        0x20a261dc,
        0x4b695a77,
        0x1a161c12,
        0xba0ae293,
        0x2ae5c0a0,
        0xe0433c22,
        0x171d121b,
        0x0d0b0e09,
        0xc7adf28b,
        0xa8b92db6,
        0xa9c8141e,
        0x198557f1,
        0x074caf75,
        0xddbbee99,
        0x60fda37f,
        0x269ff701,
        0xf5bc5c72,
        0x3bc54466,
        0x7e345bfb,
        0x29768b43,
        0xc6dccb23,
        0xfc68b6ed,
        0xf163b8e4,
        0xdccad731,
        0x85104263,
        0x22401397,
        0x112084c6,
        0x247d854a,
        0x3df8d2bb,
        0x3211aef9,
        0xa16dc729,
        0x2f4b1d9e,
        0x30f3dcb2,
        0x52ec0d86,
        0xe3d077c1,
        0x166c2bb3,
        0xb999a970,
        0x48fa1194,
        0x642247e9,
        0x8cc4a8fc,
        0x3f1aa0f0,
        0x2cd8567d,
        0x90ef2233,
        0x4ec78749,
        0xd1c1d938,
        0xa2fe8cca,
        0x0b3698d4,
        0x81cfa6f5,
        0xde28a57a,
        0x8e26dab7,
        0xbfa43fad,
        0x9de42c3a,
        0x920d5078,
        0xcc9b6a5f,
        0x4662547e,
        0x13c2f68d,
        0xb8e890d8,
        0xf75e2e39,
        0xaff582c3,
        0x80be9f5d,
        0x937c69d0,
        0x2da96fd5,
        0x12b3cf25,
        0x993bc8ac,
        0x7da71018,
        0x636ee89c,
        0xbb7bdb3b,
        0x7809cd26,
        0x18f46e59,
        0xb701ec9a,
        0x9aa8834f,
        0x6e65e695,
        0xe67eaaff,
        0xcf0821bc,
        0xe8e6ef15,
        0x9bd9bae7,
        0x36ce4a6f,
        0x09d4ea9f,
        0x7cd629b0,
        0xb2af31a4,
        0x23312a3f,
        0x9430c6a5,
        0x66c035a2,
        0xbc37744e,
        0xcaa6fc82,
        0xd0b0e090,
        0xd81533a7,
        0x984af104,
        0xdaf741ec,
        0x500e7fcd,
        0xf62f1791,
        0xd68d764d,
        0xb04d43ef,
        0x4d54ccaa,
        0x04dfe496,
        0xb5e39ed1,
        0x881b4c6a,
        0x1fb8c12c,
        0x517f4665,
        0xea049d5e,
        0x355d018c,
        0x7473fa87,
        0x412efb0b,
        0x1d5ab367,
        0xd25292db,
        0x5633e910,
        0x47136dd6,
        0x618c9ad7,
        0x0c7a37a1,
        0x148e59f8,
        0x3c89eb13,
        0x27eecea9,
        0xc935b761,
        0xe5ede11c,
        0xb13c7a47,
        0xdf599cd2,
        0x733f55f2,
        0xce791814,
        0x37bf73c7,
        0xcdea53f7,
        0xaa5b5ffd,
        0x6f14df3d,
        0xdb867844,
        0xf381caaf,
        0xc43eb968,
        0x342c3824,
        0x405fc2a3,
        0xc372161d,
        0x250cbce2,
        0x498b283c,
        0x9541ff0d,
        0x017139a8,
        0xb3de080c,
        0xe49cd8b4,
        0xc1906456,
        0x84617bcb,
        0xb670d532,
        0x5c74486c,
        0x5742d0b8
    ];
    var T8 = [
        0xf4a75051,
        0x4165537e,
        0x17a4c31a,
        0x275e963a,
        0xab6bcb3b,
        0x9d45f11f,
        0xfa58abac,
        0xe303934b,
        0x30fa5520,
        0x766df6ad,
        0xcc769188,
        0x024c25f5,
        0xe5d7fc4f,
        0x2acbd7c5,
        0x35448026,
        0x62a38fb5,
        0xb15a49de,
        0xba1b6725,
        0xea0e9845,
        0xfec0e15d,
        0x2f7502c3,
        0x4cf01281,
        0x4697a38d,
        0xd3f9c66b,
        0x8f5fe703,
        0x929c9515,
        0x6d7aebbf,
        0x5259da95,
        0xbe832dd4,
        0x7421d358,
        0xe0692949,
        0xc9c8448e,
        0xc2896a75,
        0x8e7978f4,
        0x583e6b99,
        0xb971dd27,
        0xe14fb6be,
        0x88ad17f0,
        0x20ac66c9,
        0xce3ab47d,
        0xdf4a1863,
        0x1a3182e5,
        0x51336097,
        0x537f4562,
        0x6477e0b1,
        0x6bae84bb,
        0x81a01cfe,
        0x082b94f9,
        0x48685870,
        0x45fd198f,
        0xde6c8794,
        0x7bf8b752,
        0x73d323ab,
        0x4b02e272,
        0x1f8f57e3,
        0x55ab2a66,
        0xeb2807b2,
        0xb5c2032f,
        0xc57b9a86,
        0x3708a5d3,
        0x2887f230,
        0xbfa5b223,
        0x036aba02,
        0x16825ced,
        0xcf1c2b8a,
        0x79b492a7,
        0x07f2f0f3,
        0x69e2a14e,
        0xdaf4cd65,
        0x05bed506,
        0x34621fd1,
        0xa6fe8ac4,
        0x2e539d34,
        0xf355a0a2,
        0x8ae13205,
        0xf6eb75a4,
        0x83ec390b,
        0x60efaa40,
        0x719f065e,
        0x6e1051bd,
        0x218af93e,
        0xdd063d96,
        0x3e05aedd,
        0xe6bd464d,
        0x548db591,
        0xc45d0571,
        0x06d46f04,
        0x5015ff60,
        0x98fb2419,
        0xbde997d6,
        0x4043cc89,
        0xd99e7767,
        0xe842bdb0,
        0x898b8807,
        0x195b38e7,
        0xc8eedb79,
        0x7c0a47a1,
        0x420fe97c,
        0x841ec9f8,
        0x00000000,
        0x80868309,
        0x2bed4832,
        0x1170ac1e,
        0x5a724e6c,
        0x0efffbfd,
        0x8538560f,
        0xaed51e3d,
        0x2d392736,
        0x0fd9640a,
        0x5ca62168,
        0x5b54d19b,
        0x362e3a24,
        0x0a67b10c,
        0x57e70f93,
        0xee96d2b4,
        0x9b919e1b,
        0xc0c54f80,
        0xdc20a261,
        0x774b695a,
        0x121a161c,
        0x93ba0ae2,
        0xa02ae5c0,
        0x22e0433c,
        0x1b171d12,
        0x090d0b0e,
        0x8bc7adf2,
        0xb6a8b92d,
        0x1ea9c814,
        0xf1198557,
        0x75074caf,
        0x99ddbbee,
        0x7f60fda3,
        0x01269ff7,
        0x72f5bc5c,
        0x663bc544,
        0xfb7e345b,
        0x4329768b,
        0x23c6dccb,
        0xedfc68b6,
        0xe4f163b8,
        0x31dccad7,
        0x63851042,
        0x97224013,
        0xc6112084,
        0x4a247d85,
        0xbb3df8d2,
        0xf93211ae,
        0x29a16dc7,
        0x9e2f4b1d,
        0xb230f3dc,
        0x8652ec0d,
        0xc1e3d077,
        0xb3166c2b,
        0x70b999a9,
        0x9448fa11,
        0xe9642247,
        0xfc8cc4a8,
        0xf03f1aa0,
        0x7d2cd856,
        0x3390ef22,
        0x494ec787,
        0x38d1c1d9,
        0xcaa2fe8c,
        0xd40b3698,
        0xf581cfa6,
        0x7ade28a5,
        0xb78e26da,
        0xadbfa43f,
        0x3a9de42c,
        0x78920d50,
        0x5fcc9b6a,
        0x7e466254,
        0x8d13c2f6,
        0xd8b8e890,
        0x39f75e2e,
        0xc3aff582,
        0x5d80be9f,
        0xd0937c69,
        0xd52da96f,
        0x2512b3cf,
        0xac993bc8,
        0x187da710,
        0x9c636ee8,
        0x3bbb7bdb,
        0x267809cd,
        0x5918f46e,
        0x9ab701ec,
        0x4f9aa883,
        0x956e65e6,
        0xffe67eaa,
        0xbccf0821,
        0x15e8e6ef,
        0xe79bd9ba,
        0x6f36ce4a,
        0x9f09d4ea,
        0xb07cd629,
        0xa4b2af31,
        0x3f23312a,
        0xa59430c6,
        0xa266c035,
        0x4ebc3774,
        0x82caa6fc,
        0x90d0b0e0,
        0xa7d81533,
        0x04984af1,
        0xecdaf741,
        0xcd500e7f,
        0x91f62f17,
        0x4dd68d76,
        0xefb04d43,
        0xaa4d54cc,
        0x9604dfe4,
        0xd1b5e39e,
        0x6a881b4c,
        0x2c1fb8c1,
        0x65517f46,
        0x5eea049d,
        0x8c355d01,
        0x877473fa,
        0x0b412efb,
        0x671d5ab3,
        0xdbd25292,
        0x105633e9,
        0xd647136d,
        0xd7618c9a,
        0xa10c7a37,
        0xf8148e59,
        0x133c89eb,
        0xa927eece,
        0x61c935b7,
        0x1ce5ede1,
        0x47b13c7a,
        0xd2df599c,
        0xf2733f55,
        0x14ce7918,
        0xc737bf73,
        0xf7cdea53,
        0xfdaa5b5f,
        0x3d6f14df,
        0x44db8678,
        0xaff381ca,
        0x68c43eb9,
        0x24342c38,
        0xa3405fc2,
        0x1dc37216,
        0xe2250cbc,
        0x3c498b28,
        0x0d9541ff,
        0xa8017139,
        0x0cb3de08,
        0xb4e49cd8,
        0x56c19064,
        0xcb84617b,
        0x32b670d5,
        0x6c5c7448,
        0xb85742d0
    ];
    // Transformations for decryption key expansion
    var U1 = [
        0x00000000,
        0x0e090d0b,
        0x1c121a16,
        0x121b171d,
        0x3824342c,
        0x362d3927,
        0x24362e3a,
        0x2a3f2331,
        0x70486858,
        0x7e416553,
        0x6c5a724e,
        0x62537f45,
        0x486c5c74,
        0x4665517f,
        0x547e4662,
        0x5a774b69,
        0xe090d0b0,
        0xee99ddbb,
        0xfc82caa6,
        0xf28bc7ad,
        0xd8b4e49c,
        0xd6bde997,
        0xc4a6fe8a,
        0xcaaff381,
        0x90d8b8e8,
        0x9ed1b5e3,
        0x8ccaa2fe,
        0x82c3aff5,
        0xa8fc8cc4,
        0xa6f581cf,
        0xb4ee96d2,
        0xbae79bd9,
        0xdb3bbb7b,
        0xd532b670,
        0xc729a16d,
        0xc920ac66,
        0xe31f8f57,
        0xed16825c,
        0xff0d9541,
        0xf104984a,
        0xab73d323,
        0xa57ade28,
        0xb761c935,
        0xb968c43e,
        0x9357e70f,
        0x9d5eea04,
        0x8f45fd19,
        0x814cf012,
        0x3bab6bcb,
        0x35a266c0,
        0x27b971dd,
        0x29b07cd6,
        0x038f5fe7,
        0x0d8652ec,
        0x1f9d45f1,
        0x119448fa,
        0x4be30393,
        0x45ea0e98,
        0x57f11985,
        0x59f8148e,
        0x73c737bf,
        0x7dce3ab4,
        0x6fd52da9,
        0x61dc20a2,
        0xad766df6,
        0xa37f60fd,
        0xb16477e0,
        0xbf6d7aeb,
        0x955259da,
        0x9b5b54d1,
        0x894043cc,
        0x87494ec7,
        0xdd3e05ae,
        0xd33708a5,
        0xc12c1fb8,
        0xcf2512b3,
        0xe51a3182,
        0xeb133c89,
        0xf9082b94,
        0xf701269f,
        0x4de6bd46,
        0x43efb04d,
        0x51f4a750,
        0x5ffdaa5b,
        0x75c2896a,
        0x7bcb8461,
        0x69d0937c,
        0x67d99e77,
        0x3daed51e,
        0x33a7d815,
        0x21bccf08,
        0x2fb5c203,
        0x058ae132,
        0x0b83ec39,
        0x1998fb24,
        0x1791f62f,
        0x764dd68d,
        0x7844db86,
        0x6a5fcc9b,
        0x6456c190,
        0x4e69e2a1,
        0x4060efaa,
        0x527bf8b7,
        0x5c72f5bc,
        0x0605bed5,
        0x080cb3de,
        0x1a17a4c3,
        0x141ea9c8,
        0x3e218af9,
        0x302887f2,
        0x223390ef,
        0x2c3a9de4,
        0x96dd063d,
        0x98d40b36,
        0x8acf1c2b,
        0x84c61120,
        0xaef93211,
        0xa0f03f1a,
        0xb2eb2807,
        0xbce2250c,
        0xe6956e65,
        0xe89c636e,
        0xfa877473,
        0xf48e7978,
        0xdeb15a49,
        0xd0b85742,
        0xc2a3405f,
        0xccaa4d54,
        0x41ecdaf7,
        0x4fe5d7fc,
        0x5dfec0e1,
        0x53f7cdea,
        0x79c8eedb,
        0x77c1e3d0,
        0x65daf4cd,
        0x6bd3f9c6,
        0x31a4b2af,
        0x3fadbfa4,
        0x2db6a8b9,
        0x23bfa5b2,
        0x09808683,
        0x07898b88,
        0x15929c95,
        0x1b9b919e,
        0xa17c0a47,
        0xaf75074c,
        0xbd6e1051,
        0xb3671d5a,
        0x99583e6b,
        0x97513360,
        0x854a247d,
        0x8b432976,
        0xd134621f,
        0xdf3d6f14,
        0xcd267809,
        0xc32f7502,
        0xe9105633,
        0xe7195b38,
        0xf5024c25,
        0xfb0b412e,
        0x9ad7618c,
        0x94de6c87,
        0x86c57b9a,
        0x88cc7691,
        0xa2f355a0,
        0xacfa58ab,
        0xbee14fb6,
        0xb0e842bd,
        0xea9f09d4,
        0xe49604df,
        0xf68d13c2,
        0xf8841ec9,
        0xd2bb3df8,
        0xdcb230f3,
        0xcea927ee,
        0xc0a02ae5,
        0x7a47b13c,
        0x744ebc37,
        0x6655ab2a,
        0x685ca621,
        0x42638510,
        0x4c6a881b,
        0x5e719f06,
        0x5078920d,
        0x0a0fd964,
        0x0406d46f,
        0x161dc372,
        0x1814ce79,
        0x322bed48,
        0x3c22e043,
        0x2e39f75e,
        0x2030fa55,
        0xec9ab701,
        0xe293ba0a,
        0xf088ad17,
        0xfe81a01c,
        0xd4be832d,
        0xdab78e26,
        0xc8ac993b,
        0xc6a59430,
        0x9cd2df59,
        0x92dbd252,
        0x80c0c54f,
        0x8ec9c844,
        0xa4f6eb75,
        0xaaffe67e,
        0xb8e4f163,
        0xb6edfc68,
        0x0c0a67b1,
        0x02036aba,
        0x10187da7,
        0x1e1170ac,
        0x342e539d,
        0x3a275e96,
        0x283c498b,
        0x26354480,
        0x7c420fe9,
        0x724b02e2,
        0x605015ff,
        0x6e5918f4,
        0x44663bc5,
        0x4a6f36ce,
        0x587421d3,
        0x567d2cd8,
        0x37a10c7a,
        0x39a80171,
        0x2bb3166c,
        0x25ba1b67,
        0x0f853856,
        0x018c355d,
        0x13972240,
        0x1d9e2f4b,
        0x47e96422,
        0x49e06929,
        0x5bfb7e34,
        0x55f2733f,
        0x7fcd500e,
        0x71c45d05,
        0x63df4a18,
        0x6dd64713,
        0xd731dcca,
        0xd938d1c1,
        0xcb23c6dc,
        0xc52acbd7,
        0xef15e8e6,
        0xe11ce5ed,
        0xf307f2f0,
        0xfd0efffb,
        0xa779b492,
        0xa970b999,
        0xbb6bae84,
        0xb562a38f,
        0x9f5d80be,
        0x91548db5,
        0x834f9aa8,
        0x8d4697a3
    ];
    var U2 = [
        0x00000000,
        0x0b0e090d,
        0x161c121a,
        0x1d121b17,
        0x2c382434,
        0x27362d39,
        0x3a24362e,
        0x312a3f23,
        0x58704868,
        0x537e4165,
        0x4e6c5a72,
        0x4562537f,
        0x74486c5c,
        0x7f466551,
        0x62547e46,
        0x695a774b,
        0xb0e090d0,
        0xbbee99dd,
        0xa6fc82ca,
        0xadf28bc7,
        0x9cd8b4e4,
        0x97d6bde9,
        0x8ac4a6fe,
        0x81caaff3,
        0xe890d8b8,
        0xe39ed1b5,
        0xfe8ccaa2,
        0xf582c3af,
        0xc4a8fc8c,
        0xcfa6f581,
        0xd2b4ee96,
        0xd9bae79b,
        0x7bdb3bbb,
        0x70d532b6,
        0x6dc729a1,
        0x66c920ac,
        0x57e31f8f,
        0x5ced1682,
        0x41ff0d95,
        0x4af10498,
        0x23ab73d3,
        0x28a57ade,
        0x35b761c9,
        0x3eb968c4,
        0x0f9357e7,
        0x049d5eea,
        0x198f45fd,
        0x12814cf0,
        0xcb3bab6b,
        0xc035a266,
        0xdd27b971,
        0xd629b07c,
        0xe7038f5f,
        0xec0d8652,
        0xf11f9d45,
        0xfa119448,
        0x934be303,
        0x9845ea0e,
        0x8557f119,
        0x8e59f814,
        0xbf73c737,
        0xb47dce3a,
        0xa96fd52d,
        0xa261dc20,
        0xf6ad766d,
        0xfda37f60,
        0xe0b16477,
        0xebbf6d7a,
        0xda955259,
        0xd19b5b54,
        0xcc894043,
        0xc787494e,
        0xaedd3e05,
        0xa5d33708,
        0xb8c12c1f,
        0xb3cf2512,
        0x82e51a31,
        0x89eb133c,
        0x94f9082b,
        0x9ff70126,
        0x464de6bd,
        0x4d43efb0,
        0x5051f4a7,
        0x5b5ffdaa,
        0x6a75c289,
        0x617bcb84,
        0x7c69d093,
        0x7767d99e,
        0x1e3daed5,
        0x1533a7d8,
        0x0821bccf,
        0x032fb5c2,
        0x32058ae1,
        0x390b83ec,
        0x241998fb,
        0x2f1791f6,
        0x8d764dd6,
        0x867844db,
        0x9b6a5fcc,
        0x906456c1,
        0xa14e69e2,
        0xaa4060ef,
        0xb7527bf8,
        0xbc5c72f5,
        0xd50605be,
        0xde080cb3,
        0xc31a17a4,
        0xc8141ea9,
        0xf93e218a,
        0xf2302887,
        0xef223390,
        0xe42c3a9d,
        0x3d96dd06,
        0x3698d40b,
        0x2b8acf1c,
        0x2084c611,
        0x11aef932,
        0x1aa0f03f,
        0x07b2eb28,
        0x0cbce225,
        0x65e6956e,
        0x6ee89c63,
        0x73fa8774,
        0x78f48e79,
        0x49deb15a,
        0x42d0b857,
        0x5fc2a340,
        0x54ccaa4d,
        0xf741ecda,
        0xfc4fe5d7,
        0xe15dfec0,
        0xea53f7cd,
        0xdb79c8ee,
        0xd077c1e3,
        0xcd65daf4,
        0xc66bd3f9,
        0xaf31a4b2,
        0xa43fadbf,
        0xb92db6a8,
        0xb223bfa5,
        0x83098086,
        0x8807898b,
        0x9515929c,
        0x9e1b9b91,
        0x47a17c0a,
        0x4caf7507,
        0x51bd6e10,
        0x5ab3671d,
        0x6b99583e,
        0x60975133,
        0x7d854a24,
        0x768b4329,
        0x1fd13462,
        0x14df3d6f,
        0x09cd2678,
        0x02c32f75,
        0x33e91056,
        0x38e7195b,
        0x25f5024c,
        0x2efb0b41,
        0x8c9ad761,
        0x8794de6c,
        0x9a86c57b,
        0x9188cc76,
        0xa0a2f355,
        0xabacfa58,
        0xb6bee14f,
        0xbdb0e842,
        0xd4ea9f09,
        0xdfe49604,
        0xc2f68d13,
        0xc9f8841e,
        0xf8d2bb3d,
        0xf3dcb230,
        0xeecea927,
        0xe5c0a02a,
        0x3c7a47b1,
        0x37744ebc,
        0x2a6655ab,
        0x21685ca6,
        0x10426385,
        0x1b4c6a88,
        0x065e719f,
        0x0d507892,
        0x640a0fd9,
        0x6f0406d4,
        0x72161dc3,
        0x791814ce,
        0x48322bed,
        0x433c22e0,
        0x5e2e39f7,
        0x552030fa,
        0x01ec9ab7,
        0x0ae293ba,
        0x17f088ad,
        0x1cfe81a0,
        0x2dd4be83,
        0x26dab78e,
        0x3bc8ac99,
        0x30c6a594,
        0x599cd2df,
        0x5292dbd2,
        0x4f80c0c5,
        0x448ec9c8,
        0x75a4f6eb,
        0x7eaaffe6,
        0x63b8e4f1,
        0x68b6edfc,
        0xb10c0a67,
        0xba02036a,
        0xa710187d,
        0xac1e1170,
        0x9d342e53,
        0x963a275e,
        0x8b283c49,
        0x80263544,
        0xe97c420f,
        0xe2724b02,
        0xff605015,
        0xf46e5918,
        0xc544663b,
        0xce4a6f36,
        0xd3587421,
        0xd8567d2c,
        0x7a37a10c,
        0x7139a801,
        0x6c2bb316,
        0x6725ba1b,
        0x560f8538,
        0x5d018c35,
        0x40139722,
        0x4b1d9e2f,
        0x2247e964,
        0x2949e069,
        0x345bfb7e,
        0x3f55f273,
        0x0e7fcd50,
        0x0571c45d,
        0x1863df4a,
        0x136dd647,
        0xcad731dc,
        0xc1d938d1,
        0xdccb23c6,
        0xd7c52acb,
        0xe6ef15e8,
        0xede11ce5,
        0xf0f307f2,
        0xfbfd0eff,
        0x92a779b4,
        0x99a970b9,
        0x84bb6bae,
        0x8fb562a3,
        0xbe9f5d80,
        0xb591548d,
        0xa8834f9a,
        0xa38d4697
    ];
    var U3 = [
        0x00000000,
        0x0d0b0e09,
        0x1a161c12,
        0x171d121b,
        0x342c3824,
        0x3927362d,
        0x2e3a2436,
        0x23312a3f,
        0x68587048,
        0x65537e41,
        0x724e6c5a,
        0x7f456253,
        0x5c74486c,
        0x517f4665,
        0x4662547e,
        0x4b695a77,
        0xd0b0e090,
        0xddbbee99,
        0xcaa6fc82,
        0xc7adf28b,
        0xe49cd8b4,
        0xe997d6bd,
        0xfe8ac4a6,
        0xf381caaf,
        0xb8e890d8,
        0xb5e39ed1,
        0xa2fe8cca,
        0xaff582c3,
        0x8cc4a8fc,
        0x81cfa6f5,
        0x96d2b4ee,
        0x9bd9bae7,
        0xbb7bdb3b,
        0xb670d532,
        0xa16dc729,
        0xac66c920,
        0x8f57e31f,
        0x825ced16,
        0x9541ff0d,
        0x984af104,
        0xd323ab73,
        0xde28a57a,
        0xc935b761,
        0xc43eb968,
        0xe70f9357,
        0xea049d5e,
        0xfd198f45,
        0xf012814c,
        0x6bcb3bab,
        0x66c035a2,
        0x71dd27b9,
        0x7cd629b0,
        0x5fe7038f,
        0x52ec0d86,
        0x45f11f9d,
        0x48fa1194,
        0x03934be3,
        0x0e9845ea,
        0x198557f1,
        0x148e59f8,
        0x37bf73c7,
        0x3ab47dce,
        0x2da96fd5,
        0x20a261dc,
        0x6df6ad76,
        0x60fda37f,
        0x77e0b164,
        0x7aebbf6d,
        0x59da9552,
        0x54d19b5b,
        0x43cc8940,
        0x4ec78749,
        0x05aedd3e,
        0x08a5d337,
        0x1fb8c12c,
        0x12b3cf25,
        0x3182e51a,
        0x3c89eb13,
        0x2b94f908,
        0x269ff701,
        0xbd464de6,
        0xb04d43ef,
        0xa75051f4,
        0xaa5b5ffd,
        0x896a75c2,
        0x84617bcb,
        0x937c69d0,
        0x9e7767d9,
        0xd51e3dae,
        0xd81533a7,
        0xcf0821bc,
        0xc2032fb5,
        0xe132058a,
        0xec390b83,
        0xfb241998,
        0xf62f1791,
        0xd68d764d,
        0xdb867844,
        0xcc9b6a5f,
        0xc1906456,
        0xe2a14e69,
        0xefaa4060,
        0xf8b7527b,
        0xf5bc5c72,
        0xbed50605,
        0xb3de080c,
        0xa4c31a17,
        0xa9c8141e,
        0x8af93e21,
        0x87f23028,
        0x90ef2233,
        0x9de42c3a,
        0x063d96dd,
        0x0b3698d4,
        0x1c2b8acf,
        0x112084c6,
        0x3211aef9,
        0x3f1aa0f0,
        0x2807b2eb,
        0x250cbce2,
        0x6e65e695,
        0x636ee89c,
        0x7473fa87,
        0x7978f48e,
        0x5a49deb1,
        0x5742d0b8,
        0x405fc2a3,
        0x4d54ccaa,
        0xdaf741ec,
        0xd7fc4fe5,
        0xc0e15dfe,
        0xcdea53f7,
        0xeedb79c8,
        0xe3d077c1,
        0xf4cd65da,
        0xf9c66bd3,
        0xb2af31a4,
        0xbfa43fad,
        0xa8b92db6,
        0xa5b223bf,
        0x86830980,
        0x8b880789,
        0x9c951592,
        0x919e1b9b,
        0x0a47a17c,
        0x074caf75,
        0x1051bd6e,
        0x1d5ab367,
        0x3e6b9958,
        0x33609751,
        0x247d854a,
        0x29768b43,
        0x621fd134,
        0x6f14df3d,
        0x7809cd26,
        0x7502c32f,
        0x5633e910,
        0x5b38e719,
        0x4c25f502,
        0x412efb0b,
        0x618c9ad7,
        0x6c8794de,
        0x7b9a86c5,
        0x769188cc,
        0x55a0a2f3,
        0x58abacfa,
        0x4fb6bee1,
        0x42bdb0e8,
        0x09d4ea9f,
        0x04dfe496,
        0x13c2f68d,
        0x1ec9f884,
        0x3df8d2bb,
        0x30f3dcb2,
        0x27eecea9,
        0x2ae5c0a0,
        0xb13c7a47,
        0xbc37744e,
        0xab2a6655,
        0xa621685c,
        0x85104263,
        0x881b4c6a,
        0x9f065e71,
        0x920d5078,
        0xd9640a0f,
        0xd46f0406,
        0xc372161d,
        0xce791814,
        0xed48322b,
        0xe0433c22,
        0xf75e2e39,
        0xfa552030,
        0xb701ec9a,
        0xba0ae293,
        0xad17f088,
        0xa01cfe81,
        0x832dd4be,
        0x8e26dab7,
        0x993bc8ac,
        0x9430c6a5,
        0xdf599cd2,
        0xd25292db,
        0xc54f80c0,
        0xc8448ec9,
        0xeb75a4f6,
        0xe67eaaff,
        0xf163b8e4,
        0xfc68b6ed,
        0x67b10c0a,
        0x6aba0203,
        0x7da71018,
        0x70ac1e11,
        0x539d342e,
        0x5e963a27,
        0x498b283c,
        0x44802635,
        0x0fe97c42,
        0x02e2724b,
        0x15ff6050,
        0x18f46e59,
        0x3bc54466,
        0x36ce4a6f,
        0x21d35874,
        0x2cd8567d,
        0x0c7a37a1,
        0x017139a8,
        0x166c2bb3,
        0x1b6725ba,
        0x38560f85,
        0x355d018c,
        0x22401397,
        0x2f4b1d9e,
        0x642247e9,
        0x692949e0,
        0x7e345bfb,
        0x733f55f2,
        0x500e7fcd,
        0x5d0571c4,
        0x4a1863df,
        0x47136dd6,
        0xdccad731,
        0xd1c1d938,
        0xc6dccb23,
        0xcbd7c52a,
        0xe8e6ef15,
        0xe5ede11c,
        0xf2f0f307,
        0xfffbfd0e,
        0xb492a779,
        0xb999a970,
        0xae84bb6b,
        0xa38fb562,
        0x80be9f5d,
        0x8db59154,
        0x9aa8834f,
        0x97a38d46
    ];
    var U4 = [
        0x00000000,
        0x090d0b0e,
        0x121a161c,
        0x1b171d12,
        0x24342c38,
        0x2d392736,
        0x362e3a24,
        0x3f23312a,
        0x48685870,
        0x4165537e,
        0x5a724e6c,
        0x537f4562,
        0x6c5c7448,
        0x65517f46,
        0x7e466254,
        0x774b695a,
        0x90d0b0e0,
        0x99ddbbee,
        0x82caa6fc,
        0x8bc7adf2,
        0xb4e49cd8,
        0xbde997d6,
        0xa6fe8ac4,
        0xaff381ca,
        0xd8b8e890,
        0xd1b5e39e,
        0xcaa2fe8c,
        0xc3aff582,
        0xfc8cc4a8,
        0xf581cfa6,
        0xee96d2b4,
        0xe79bd9ba,
        0x3bbb7bdb,
        0x32b670d5,
        0x29a16dc7,
        0x20ac66c9,
        0x1f8f57e3,
        0x16825ced,
        0x0d9541ff,
        0x04984af1,
        0x73d323ab,
        0x7ade28a5,
        0x61c935b7,
        0x68c43eb9,
        0x57e70f93,
        0x5eea049d,
        0x45fd198f,
        0x4cf01281,
        0xab6bcb3b,
        0xa266c035,
        0xb971dd27,
        0xb07cd629,
        0x8f5fe703,
        0x8652ec0d,
        0x9d45f11f,
        0x9448fa11,
        0xe303934b,
        0xea0e9845,
        0xf1198557,
        0xf8148e59,
        0xc737bf73,
        0xce3ab47d,
        0xd52da96f,
        0xdc20a261,
        0x766df6ad,
        0x7f60fda3,
        0x6477e0b1,
        0x6d7aebbf,
        0x5259da95,
        0x5b54d19b,
        0x4043cc89,
        0x494ec787,
        0x3e05aedd,
        0x3708a5d3,
        0x2c1fb8c1,
        0x2512b3cf,
        0x1a3182e5,
        0x133c89eb,
        0x082b94f9,
        0x01269ff7,
        0xe6bd464d,
        0xefb04d43,
        0xf4a75051,
        0xfdaa5b5f,
        0xc2896a75,
        0xcb84617b,
        0xd0937c69,
        0xd99e7767,
        0xaed51e3d,
        0xa7d81533,
        0xbccf0821,
        0xb5c2032f,
        0x8ae13205,
        0x83ec390b,
        0x98fb2419,
        0x91f62f17,
        0x4dd68d76,
        0x44db8678,
        0x5fcc9b6a,
        0x56c19064,
        0x69e2a14e,
        0x60efaa40,
        0x7bf8b752,
        0x72f5bc5c,
        0x05bed506,
        0x0cb3de08,
        0x17a4c31a,
        0x1ea9c814,
        0x218af93e,
        0x2887f230,
        0x3390ef22,
        0x3a9de42c,
        0xdd063d96,
        0xd40b3698,
        0xcf1c2b8a,
        0xc6112084,
        0xf93211ae,
        0xf03f1aa0,
        0xeb2807b2,
        0xe2250cbc,
        0x956e65e6,
        0x9c636ee8,
        0x877473fa,
        0x8e7978f4,
        0xb15a49de,
        0xb85742d0,
        0xa3405fc2,
        0xaa4d54cc,
        0xecdaf741,
        0xe5d7fc4f,
        0xfec0e15d,
        0xf7cdea53,
        0xc8eedb79,
        0xc1e3d077,
        0xdaf4cd65,
        0xd3f9c66b,
        0xa4b2af31,
        0xadbfa43f,
        0xb6a8b92d,
        0xbfa5b223,
        0x80868309,
        0x898b8807,
        0x929c9515,
        0x9b919e1b,
        0x7c0a47a1,
        0x75074caf,
        0x6e1051bd,
        0x671d5ab3,
        0x583e6b99,
        0x51336097,
        0x4a247d85,
        0x4329768b,
        0x34621fd1,
        0x3d6f14df,
        0x267809cd,
        0x2f7502c3,
        0x105633e9,
        0x195b38e7,
        0x024c25f5,
        0x0b412efb,
        0xd7618c9a,
        0xde6c8794,
        0xc57b9a86,
        0xcc769188,
        0xf355a0a2,
        0xfa58abac,
        0xe14fb6be,
        0xe842bdb0,
        0x9f09d4ea,
        0x9604dfe4,
        0x8d13c2f6,
        0x841ec9f8,
        0xbb3df8d2,
        0xb230f3dc,
        0xa927eece,
        0xa02ae5c0,
        0x47b13c7a,
        0x4ebc3774,
        0x55ab2a66,
        0x5ca62168,
        0x63851042,
        0x6a881b4c,
        0x719f065e,
        0x78920d50,
        0x0fd9640a,
        0x06d46f04,
        0x1dc37216,
        0x14ce7918,
        0x2bed4832,
        0x22e0433c,
        0x39f75e2e,
        0x30fa5520,
        0x9ab701ec,
        0x93ba0ae2,
        0x88ad17f0,
        0x81a01cfe,
        0xbe832dd4,
        0xb78e26da,
        0xac993bc8,
        0xa59430c6,
        0xd2df599c,
        0xdbd25292,
        0xc0c54f80,
        0xc9c8448e,
        0xf6eb75a4,
        0xffe67eaa,
        0xe4f163b8,
        0xedfc68b6,
        0x0a67b10c,
        0x036aba02,
        0x187da710,
        0x1170ac1e,
        0x2e539d34,
        0x275e963a,
        0x3c498b28,
        0x35448026,
        0x420fe97c,
        0x4b02e272,
        0x5015ff60,
        0x5918f46e,
        0x663bc544,
        0x6f36ce4a,
        0x7421d358,
        0x7d2cd856,
        0xa10c7a37,
        0xa8017139,
        0xb3166c2b,
        0xba1b6725,
        0x8538560f,
        0x8c355d01,
        0x97224013,
        0x9e2f4b1d,
        0xe9642247,
        0xe0692949,
        0xfb7e345b,
        0xf2733f55,
        0xcd500e7f,
        0xc45d0571,
        0xdf4a1863,
        0xd647136d,
        0x31dccad7,
        0x38d1c1d9,
        0x23c6dccb,
        0x2acbd7c5,
        0x15e8e6ef,
        0x1ce5ede1,
        0x07f2f0f3,
        0x0efffbfd,
        0x79b492a7,
        0x70b999a9,
        0x6bae84bb,
        0x62a38fb5,
        0x5d80be9f,
        0x548db591,
        0x4f9aa883,
        0x4697a38d
    ];
    var AES = function AES1(key) {
        if (!(this instanceof AES)) throw Error("AES must be instanitated with `new`");
        Object.defineProperty(this, "key", {
            value: coerceArray(key, true)
        });
        this._prepare();
    };
    AES.prototype._prepare = function() {
        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
        // encryption round keys
        this._Ke = [];
        // decryption round keys
        this._Kd = [];
        for(var i = 0; i <= rounds; i++){
            this._Ke.push([
                0,
                0,
                0,
                0
            ]);
            this._Kd.push([
                0,
                0,
                0,
                0
            ]);
        }
        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;
        // convert the key into ints
        var tk = convertToInt32(this.key);
        // copy values into round key arrays
        var index;
        for(var i = 0; i < KC; i++){
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= S[tt >> 16 & 0xFF] << 24 ^ S[tt >> 8 & 0xFF] << 16 ^ S[tt & 0xFF] << 8 ^ S[tt >> 24 & 0xFF] ^ rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(var i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(var i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= S[tt & 0xFF] ^ S[tt >> 8 & 0xFF] << 8 ^ S[tt >> 16 & 0xFF] << 16 ^ S[tt >> 24 & 0xFF] << 24;
                for(var i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            var i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(var r = 1; r < rounds; r++)for(var c = 0; c < 4; c++){
            tt = this._Kd[r][c];
            this._Kd[r][c] = U1[tt >> 24 & 0xFF] ^ U2[tt >> 16 & 0xFF] ^ U3[tt >> 8 & 0xFF] ^ U4[tt & 0xFF];
        }
    };
    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) throw new Error("invalid plaintext size (must be 16 bytes)");
        var rounds = this._Ke.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Ke[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T1[t[i] >> 24 & 0xff] ^ T2[t[(i + 1) % 4] >> 16 & 0xff] ^ T3[t[(i + 2) % 4] >> 8 & 0xff] ^ T4[t[(i + 3) % 4] & 0xff] ^ this._Ke[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Ke[rounds][i];
            result[4 * i] = (S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) throw new Error("invalid ciphertext size (must be 16 bytes)");
        var rounds = this._Kd.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Kd[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T5[t[i] >> 24 & 0xff] ^ T6[t[(i + 3) % 4] >> 16 & 0xff] ^ T7[t[(i + 2) % 4] >> 8 & 0xff] ^ T8[t[(i + 1) % 4] & 0xff] ^ this._Kd[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Kd[rounds][i];
            result[4 * i] = (Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */ var ModeOfOperationECB = function ModeOfOperationECB1(key) {
        if (!(this instanceof ModeOfOperationECB)) throw Error("AES must be instanitated with `new`");
        this.description = "Electronic Code Block";
        this.name = "ecb";
        this._aes = new AES(key);
    };
    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */ var ModeOfOperationCBC = function ModeOfOperationCBC1(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Block Chaining";
        this.name = "cbc";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastCipherblock = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            for(var j = 0; j < 16; j++)block[j] ^= this._lastCipherblock[j];
            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            for(var j = 0; j < 16; j++)plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */ var ModeOfOperationCFB = function ModeOfOperationCFB1(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Feedback";
        this.name = "cfb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 size)");
        if (!segmentSize) segmentSize = 1;
        this.segmentSize = segmentSize;
        this._shiftRegister = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if (plaintext.length % this.segmentSize != 0) throw new Error("invalid plaintext size (must be segmentSize bytes)");
        var encrypted = coerceArray(plaintext, true);
        var xorSegment;
        for(var i = 0; i < encrypted.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)encrypted[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return encrypted;
    };
    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length % this.segmentSize != 0) throw new Error("invalid ciphertext size (must be segmentSize bytes)");
        var plaintext = coerceArray(ciphertext, true);
        var xorSegment;
        for(var i = 0; i < plaintext.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */ var ModeOfOperationOFB = function ModeOfOperationOFB1(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Output Feedback";
        this.name = "ofb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;
    /**
     *  Counter object for CTR common mode of operation
     */ var Counter = function Counter1(initialValue) {
        if (!(this instanceof Counter)) throw Error("Counter must be instanitated with `new`");
        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) initialValue = 1;
        if (typeof initialValue === "number") {
            this._counter = createArray(16);
            this.setValue(initialValue);
        } else this.setBytes(initialValue);
    };
    Counter.prototype.setValue = function(value) {
        if (typeof value !== "number" || parseInt(value) != value) throw new Error("invalid counter value (must be an integer)");
        for(var index = 15; index >= 0; --index){
            this._counter[index] = value % 256;
            value = value >> 8;
        }
    };
    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);
        if (bytes.length != 16) throw new Error("invalid counter bytes size (must be 16 bytes)");
        this._counter = bytes;
    };
    Counter.prototype.increment = function() {
        for(var i = 15; i >= 0; i--)if (this._counter[i] === 255) this._counter[i] = 0;
        else {
            this._counter[i]++;
            break;
        }
    };
    /**
     *  Mode Of Operation - Counter (CTR)
     */ var ModeOfOperationCTR = function ModeOfOperationCTR1(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) throw Error("AES must be instanitated with `new`");
        this.description = "Counter";
        this.name = "ctr";
        if (!(counter instanceof Counter)) counter = new Counter(counter);
        this._counter = counter;
        this._remainingCounter = null;
        this._remainingCounterIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;
    ///////////////////////
    // Exporting
    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,
        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },
        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },
        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },
        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray
        }
    };
    module.exports = aesjs;
})(module.exports);

});

parcelRequire.register("e8Zvl", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $a4c18596bcdbd717$export$83d89fbfd8236492; });
var $a4c18596bcdbd717$export$83d89fbfd8236492 = "json-wallets/5.7.0";

});

parcelRequire.register("btS5Y", function(module, exports) {

$parcel$export(module.exports, "looseArrayify", function () { return $85bc5d60031db318$export$2cde08bde0cfd932; });
$parcel$export(module.exports, "zpad", function () { return $85bc5d60031db318$export$67752b99d3bc61c6; });
$parcel$export(module.exports, "getPassword", function () { return $85bc5d60031db318$export$350bd33120f7413e; });
$parcel$export(module.exports, "searchPath", function () { return $85bc5d60031db318$export$5a5c1dbd910e2c32; });
$parcel$export(module.exports, "uuidV4", function () { return $85bc5d60031db318$export$ec7b18ebad55a3a9; });

var $j2rU8 = parcelRequire("j2rU8");

var $1Wmc7 = parcelRequire("1Wmc7");
"use strict";
function $85bc5d60031db318$export$2cde08bde0cfd932(hexString) {
    if (typeof hexString === "string" && hexString.substring(0, 2) !== "0x") hexString = "0x" + hexString;
    return (0, $j2rU8.arrayify)(hexString);
}
function $85bc5d60031db318$export$67752b99d3bc61c6(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function $85bc5d60031db318$export$350bd33120f7413e(password) {
    if (typeof password === "string") return (0, $1Wmc7.toUtf8Bytes)(password, (0, $1Wmc7.UnicodeNormalizationForm).NFKC);
    return (0, $j2rU8.arrayify)(password);
}
function $85bc5d60031db318$export$5a5c1dbd910e2c32(object, path) {
    var currentChild = object;
    var comps = path.toLowerCase().split("/");
    for(var i = 0; i < comps.length; i++){
        // Search for a child object with a case-insensitive matching key
        var matchingChild = null;
        for(var key in currentChild)if (key.toLowerCase() === comps[i]) {
            matchingChild = currentChild[key];
            break;
        }
        // Didn't find one. :'(
        if (matchingChild === null) return null;
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
function $85bc5d60031db318$export$ec7b18ebad55a3a9(randomBytes) {
    var bytes = (0, $j2rU8.arrayify)(randomBytes);
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = bytes[6] & 0x0f | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = bytes[8] & 0x3f | 0x80;
    var value = (0, $j2rU8.hexlify)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34)
    ].join("-");
}

});


parcelRequire.register("7Ybyv", function(module, exports) {

$parcel$export(module.exports, "decryptSync", function () { return $5cd719aa79671b4c$export$9bd2c37889ee5e36; });
$parcel$export(module.exports, "decrypt", function () { return $5cd719aa79671b4c$export$e85a0c9a1067c5d3; });
$parcel$export(module.exports, "encrypt", function () { return $5cd719aa79671b4c$export$5b0f6292f11d1d18; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $7MQUh = parcelRequire("7MQUh");

var $e9e3c = parcelRequire("e9e3c");

var $e8NrM = parcelRequire("e8NrM");

var $j2rU8 = parcelRequire("j2rU8");

var $5iEGT = parcelRequire("5iEGT");

var $4ujqV = parcelRequire("4ujqV");

var $eIQbV = parcelRequire("eIQbV");

var $4kSyQ = parcelRequire("4kSyQ");

var $2ax4w = parcelRequire("2ax4w");

var $hDQeE = parcelRequire("hDQeE");

var $btS5Y = parcelRequire("btS5Y");

var $6M65e = parcelRequire("6M65e");

var $e8Zvl = parcelRequire("e8Zvl");
"use strict";
var $5cd719aa79671b4c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5cd719aa79671b4c$var$logger = new (0, $6M65e.Logger)((0, $e8Zvl.version));
// Exported Types
function $5cd719aa79671b4c$var$hasMnemonic(value) {
    return value != null && value.mnemonic && value.mnemonic.phrase;
}
var $5cd719aa79671b4c$export$cf9dc4fd6dde0315 = /*#__PURE__*/ function(Description) {
    (0, $ftJVG._)(KeystoreAccount, Description);
    var _super = (0, $6OZAO._)(KeystoreAccount);
    function KeystoreAccount() {
        (0, $978gY._)(this, KeystoreAccount);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(KeystoreAccount, [
        {
            key: "isKeystoreAccount",
            value: function isKeystoreAccount(value) {
                return !!(value && value._isKeystoreAccount);
            }
        }
    ]);
    return KeystoreAccount;
}((0, $2ax4w.Description));
function $5cd719aa79671b4c$var$_decrypt(data, key, ciphertext) {
    var cipher = (0, $btS5Y.searchPath)(data, "crypto/cipher");
    if (cipher === "aes-128-ctr") {
        var iv = (0, $btS5Y.looseArrayify)((0, $btS5Y.searchPath)(data, "crypto/cipherparams/iv"));
        var counter = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).Counter(iv);
        var aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).ModeOfOperation.ctr(key, counter);
        return (0, $j2rU8.arrayify)(aesCtr.decrypt(ciphertext));
    }
    return null;
}
function $5cd719aa79671b4c$var$_getAccount(data, key) {
    var ciphertext = (0, $btS5Y.looseArrayify)((0, $btS5Y.searchPath)(data, "crypto/ciphertext"));
    var computedMAC = (0, $j2rU8.hexlify)((0, $4ujqV.keccak256)((0, $j2rU8.concat)([
        key.slice(16, 32),
        ciphertext
    ]))).substring(2);
    if (computedMAC !== (0, $btS5Y.searchPath)(data, "crypto/mac").toLowerCase()) throw new Error("invalid password");
    var privateKey = $5cd719aa79671b4c$var$_decrypt(data, key.slice(0, 16), ciphertext);
    if (!privateKey) $5cd719aa79671b4c$var$logger.throwError("unsupported cipher", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "decrypt"
    });
    var mnemonicKey = key.slice(32, 64);
    var address = (0, $hDQeE.computeAddress)(privateKey);
    if (data.address) {
        var check = data.address.toLowerCase();
        if (check.substring(0, 2) !== "0x") check = "0x" + check;
        if ((0, $e8NrM.getAddress)(check) !== address) throw new Error("address mismatch");
    }
    var account = {
        _isKeystoreAccount: true,
        address: address,
        privateKey: (0, $j2rU8.hexlify)(privateKey)
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    if ((0, $btS5Y.searchPath)(data, "x-ethers/version") === "0.1") {
        var mnemonicCiphertext = (0, $btS5Y.looseArrayify)((0, $btS5Y.searchPath)(data, "x-ethers/mnemonicCiphertext"));
        var mnemonicIv = (0, $btS5Y.looseArrayify)((0, $btS5Y.searchPath)(data, "x-ethers/mnemonicCounter"));
        var mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).Counter(mnemonicIv);
        var mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
        var path = (0, $btS5Y.searchPath)(data, "x-ethers/path") || (0, $5iEGT.defaultPath);
        var locale = (0, $btS5Y.searchPath)(data, "x-ethers/locale") || "en";
        var entropy = (0, $j2rU8.arrayify)(mnemonicAesCtr.decrypt(mnemonicCiphertext));
        try {
            var mnemonic = (0, $5iEGT.entropyToMnemonic)(entropy, locale);
            var node = (0, $5iEGT.HDNode).fromMnemonic(mnemonic, null, locale).derivePath(path);
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
            account.mnemonic = node.mnemonic;
        } catch (error) {
            // If we don't have the locale wordlist installed to
            // read this mnemonic, just bail and don't set the
            // mnemonic
            if (error.code !== (0, $6M65e.Logger).errors.INVALID_ARGUMENT || error.argument !== "wordlist") throw error;
        }
    }
    return new $5cd719aa79671b4c$export$cf9dc4fd6dde0315(account);
}
function $5cd719aa79671b4c$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc) {
    return (0, $j2rU8.arrayify)((0, $eIQbV.pbkdf2)(passwordBytes, salt, count, dkLen, prfFunc));
}
function $5cd719aa79671b4c$var$pbkdf2(passwordBytes, salt, count, dkLen, prfFunc) {
    return Promise.resolve($5cd719aa79671b4c$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc));
}
function $5cd719aa79671b4c$var$_computeKdfKey(data, password, pbkdf2Func, scryptFunc, progressCallback) {
    var passwordBytes = (0, $btS5Y.getPassword)(password);
    var kdf = (0, $btS5Y.searchPath)(data, "crypto/kdf");
    if (kdf && typeof kdf === "string") {
        var throwError = function throwError(name, value) {
            return $5cd719aa79671b4c$var$logger.throwArgumentError("invalid key-derivation function parameters", name, value);
        };
        if (kdf.toLowerCase() === "scrypt") {
            var salt = (0, $btS5Y.looseArrayify)((0, $btS5Y.searchPath)(data, "crypto/kdfparams/salt"));
            var N = parseInt((0, $btS5Y.searchPath)(data, "crypto/kdfparams/n"));
            var r = parseInt((0, $btS5Y.searchPath)(data, "crypto/kdfparams/r"));
            var p = parseInt((0, $btS5Y.searchPath)(data, "crypto/kdfparams/p"));
            // Check for all required parameters
            if (!N || !r || !p) throwError("kdf", kdf);
            // Make sure N is a power of 2
            if ((N & N - 1) !== 0) throwError("N", N);
            var dkLen = parseInt((0, $btS5Y.searchPath)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return scryptFunc(passwordBytes, salt, N, r, p, 64, progressCallback);
        } else if (kdf.toLowerCase() === "pbkdf2") {
            var salt1 = (0, $btS5Y.looseArrayify)((0, $btS5Y.searchPath)(data, "crypto/kdfparams/salt"));
            var prfFunc = null;
            var prf = (0, $btS5Y.searchPath)(data, "crypto/kdfparams/prf");
            if (prf === "hmac-sha256") prfFunc = "sha256";
            else if (prf === "hmac-sha512") prfFunc = "sha512";
            else throwError("prf", prf);
            var count = parseInt((0, $btS5Y.searchPath)(data, "crypto/kdfparams/c"));
            var dkLen1 = parseInt((0, $btS5Y.searchPath)(data, "crypto/kdfparams/dklen"));
            if (dkLen1 !== 32) throwError("dklen", dkLen1);
            return pbkdf2Func(passwordBytes, salt1, count, dkLen1, prfFunc);
        }
    }
    return $5cd719aa79671b4c$var$logger.throwArgumentError("unsupported key-derivation function", "kdf", kdf);
}
function $5cd719aa79671b4c$export$9bd2c37889ee5e36(json, password) {
    var data = JSON.parse(json);
    var key = $5cd719aa79671b4c$var$_computeKdfKey(data, password, $5cd719aa79671b4c$var$pbkdf2Sync, (0, (/*@__PURE__*/$parcel$interopDefault($e9e3c))).syncScrypt);
    return $5cd719aa79671b4c$var$_getAccount(data, key);
}
function $5cd719aa79671b4c$export$e85a0c9a1067c5d3(json, password, progressCallback) {
    return $5cd719aa79671b4c$var$__awaiter(this, void 0, void 0, function() {
        var data, key;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = JSON.parse(json);
                    return [
                        4,
                        $5cd719aa79671b4c$var$_computeKdfKey(data, password, $5cd719aa79671b4c$var$pbkdf2, (0, (/*@__PURE__*/$parcel$interopDefault($e9e3c))).scrypt, progressCallback)
                    ];
                case 1:
                    key = _state.sent();
                    return [
                        2,
                        $5cd719aa79671b4c$var$_getAccount(data, key)
                    ];
            }
        });
    });
}
function $5cd719aa79671b4c$export$5b0f6292f11d1d18(account, password, options, progressCallback) {
    try {
        // Check the address matches the private key
        if ((0, $e8NrM.getAddress)(account.address) !== (0, $hDQeE.computeAddress)(account.privateKey)) throw new Error("address/privateKey mismatch");
        // Check the mnemonic (if any) matches the private key
        if ($5cd719aa79671b4c$var$hasMnemonic(account)) {
            var mnemonic = account.mnemonic;
            var node = (0, $5iEGT.HDNode).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path || (0, $5iEGT.defaultPath));
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
        }
    } catch (e) {
        return Promise.reject(e);
    }
    // The options are optional, so adjust the call as needed
    if (typeof options === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) options = {};
    var privateKey = (0, $j2rU8.arrayify)(account.privateKey);
    var passwordBytes = (0, $btS5Y.getPassword)(password);
    var entropy = null;
    var path = null;
    var locale = null;
    if ($5cd719aa79671b4c$var$hasMnemonic(account)) {
        var srcMnemonic = account.mnemonic;
        entropy = (0, $j2rU8.arrayify)((0, $5iEGT.mnemonicToEntropy)(srcMnemonic.phrase, srcMnemonic.locale || "en"));
        path = srcMnemonic.path || (0, $5iEGT.defaultPath);
        locale = srcMnemonic.locale || "en";
    }
    var client = options.client;
    if (!client) client = "ethers.js";
    // Check/generate the salt
    var salt = null;
    if (options.salt) salt = (0, $j2rU8.arrayify)(options.salt);
    else salt = (0, $4kSyQ.randomBytes)(32);
    // Override initialization vector
    var iv = null;
    if (options.iv) {
        iv = (0, $j2rU8.arrayify)(options.iv);
        if (iv.length !== 16) throw new Error("invalid iv");
    } else iv = (0, $4kSyQ.randomBytes)(16);
    // Override the uuid
    var uuidRandom = null;
    if (options.uuid) {
        uuidRandom = (0, $j2rU8.arrayify)(options.uuid);
        if (uuidRandom.length !== 16) throw new Error("invalid uuid");
    } else uuidRandom = (0, $4kSyQ.randomBytes)(16);
    // Override the scrypt password-based key derivation function parameters
    var N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    // We take 64 bytes:
    //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    return (0, (/*@__PURE__*/$parcel$interopDefault($e9e3c))).scrypt(passwordBytes, salt, N, r, p, 64, progressCallback).then(function(key) {
        key = (0, $j2rU8.arrayify)(key);
        // This will be used to encrypt the wallet (as per Web3 secret storage)
        var derivedKey = key.slice(0, 16);
        var macPrefix = key.slice(16, 32);
        // This will be used to encrypt the mnemonic phrase (if any)
        var mnemonicKey = key.slice(32, 64);
        // Encrypt the private key
        var counter = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).Counter(iv);
        var aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).ModeOfOperation.ctr(derivedKey, counter);
        var ciphertext = (0, $j2rU8.arrayify)(aesCtr.encrypt(privateKey));
        // Compute the message authentication code, used to check the password
        var mac = (0, $4ujqV.keccak256)((0, $j2rU8.concat)([
            macPrefix,
            ciphertext
        ]));
        // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
        var data = {
            address: account.address.substring(2).toLowerCase(),
            id: (0, $btS5Y.uuidV4)(uuidRandom),
            version: 3,
            crypto: {
                cipher: "aes-128-ctr",
                cipherparams: {
                    iv: (0, $j2rU8.hexlify)(iv).substring(2)
                },
                ciphertext: (0, $j2rU8.hexlify)(ciphertext).substring(2),
                kdf: "scrypt",
                kdfparams: {
                    salt: (0, $j2rU8.hexlify)(salt).substring(2),
                    n: N,
                    dklen: 32,
                    p: p,
                    r: r
                },
                mac: mac.substring(2)
            }
        };
        // If we have a mnemonic, encrypt it into the JSON wallet
        if (entropy) {
            var mnemonicIv = (0, $4kSyQ.randomBytes)(16);
            var mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).Counter(mnemonicIv);
            var mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
            var mnemonicCiphertext = (0, $j2rU8.arrayify)(mnemonicAesCtr.encrypt(entropy));
            var now = new Date();
            var timestamp = now.getUTCFullYear() + "-" + (0, $btS5Y.zpad)(now.getUTCMonth() + 1, 2) + "-" + (0, $btS5Y.zpad)(now.getUTCDate(), 2) + "T" + (0, $btS5Y.zpad)(now.getUTCHours(), 2) + "-" + (0, $btS5Y.zpad)(now.getUTCMinutes(), 2) + "-" + (0, $btS5Y.zpad)(now.getUTCSeconds(), 2) + ".0Z";
            data["x-ethers"] = {
                client: client,
                gethFilename: "UTC--" + timestamp + "--" + data.address,
                mnemonicCounter: (0, $j2rU8.hexlify)(mnemonicIv).substring(2),
                mnemonicCiphertext: (0, $j2rU8.hexlify)(mnemonicCiphertext).substring(2),
                path: path,
                locale: locale,
                version: "0.1"
            };
        }
        return JSON.stringify(data);
    });
}

});
parcelRequire.register("e9e3c", function(module, exports) {
"use strict";
(function(root) {
    var SHA256 = // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        var K = new Uint32Array([
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ]);
        var h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        var h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        var w = new Uint32Array(64);
        function blocks(p) {
            var off = 0, len = p.length;
            while(len >= 64){
                var a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u = void 0, i = void 0, j = void 0, t1 = void 0, t2 = void 0;
                for(i = 0; i < 16; i++){
                    j = off + i * 4;
                    w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
                }
                for(i = 16; i < 64; i++){
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0) | 0;
                }
                for(i = 0; i < 64; i++){
                    t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                    t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                h0 = h0 + a | 0;
                h1 = h1 + b | 0;
                h2 = h2 + c | 0;
                h3 = h3 + d | 0;
                h4 = h4 + e | 0;
                h5 = h5 + f | 0;
                h6 = h6 + g | 0;
                h7 = h7 + h | 0;
                off += 64;
                len -= 64;
            }
        }
        blocks(m);
        var i, bytesLeft = m.length % 64, bitLenHi = m.length / 0x20000000 | 0, bitLenLo = m.length << 3, numZeros = bytesLeft < 56 ? 56 : 120, p = m.slice(m.length - bytesLeft, m.length);
        p.push(0x80);
        for(i = bytesLeft + 1; i < numZeros; i++)p.push(0);
        p.push(bitLenHi >>> 24 & 0xff);
        p.push(bitLenHi >>> 16 & 0xff);
        p.push(bitLenHi >>> 8 & 0xff);
        p.push(bitLenHi >>> 0 & 0xff);
        p.push(bitLenLo >>> 24 & 0xff);
        p.push(bitLenLo >>> 16 & 0xff);
        p.push(bitLenLo >>> 8 & 0xff);
        p.push(bitLenLo >>> 0 & 0xff);
        blocks(p);
        return [
            h0 >>> 24 & 0xff,
            h0 >>> 16 & 0xff,
            h0 >>> 8 & 0xff,
            h0 >>> 0 & 0xff,
            h1 >>> 24 & 0xff,
            h1 >>> 16 & 0xff,
            h1 >>> 8 & 0xff,
            h1 >>> 0 & 0xff,
            h2 >>> 24 & 0xff,
            h2 >>> 16 & 0xff,
            h2 >>> 8 & 0xff,
            h2 >>> 0 & 0xff,
            h3 >>> 24 & 0xff,
            h3 >>> 16 & 0xff,
            h3 >>> 8 & 0xff,
            h3 >>> 0 & 0xff,
            h4 >>> 24 & 0xff,
            h4 >>> 16 & 0xff,
            h4 >>> 8 & 0xff,
            h4 >>> 0 & 0xff,
            h5 >>> 24 & 0xff,
            h5 >>> 16 & 0xff,
            h5 >>> 8 & 0xff,
            h5 >>> 0 & 0xff,
            h6 >>> 24 & 0xff,
            h6 >>> 16 & 0xff,
            h6 >>> 8 & 0xff,
            h6 >>> 0 & 0xff,
            h7 >>> 24 & 0xff,
            h7 >>> 16 & 0xff,
            h7 >>> 8 & 0xff,
            h7 >>> 0 & 0xff
        ];
    };
    var PBKDF2_HMAC_SHA256_OneIter = function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = password.length <= 64 ? password : SHA256(password);
        var innerLen = 64 + salt.length + 4;
        var inner = new Array(innerLen);
        var outerKey = new Array(64);
        var i;
        var dk = [];
        // inner = (password ^ ipad) || salt || counter
        for(i = 0; i < 64; i++)inner[i] = 0x36;
        for(i = 0; i < password.length; i++)inner[i] ^= password[i];
        for(i = 0; i < salt.length; i++)inner[64 + i] = salt[i];
        for(i = innerLen - 4; i < innerLen; i++)inner[i] = 0;
        // outerKey = password ^ opad
        for(i = 0; i < 64; i++)outerKey[i] = 0x5c;
        for(i = 0; i < password.length; i++)outerKey[i] ^= password[i];
        // increments counter inside inner
        function incrementCounter() {
            for(var i = innerLen - 1; i >= innerLen - 4; i--){
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }
        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while(dkLen >= 32){
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }
        return dk;
    };
    var blockmix_salsa8 = // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        var i;
        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for(i = 0; i < 2 * r; i++){
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + i * 16, 16);
        }
        for(i = 0; i < r; i++)arraycopy(BY, Yi + i * 32, BY, i * 16, 16);
        for(i = 0; i < r; i++)arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
    };
    var R = function R(a, b) {
        return a << b | a >>> 32 - b;
    };
    var salsa20_8 = function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);
        for(var i = 8; i > 0; i -= 2){
            x[4] ^= R(x[0] + x[12], 7);
            x[8] ^= R(x[4] + x[0], 9);
            x[12] ^= R(x[8] + x[4], 13);
            x[0] ^= R(x[12] + x[8], 18);
            x[9] ^= R(x[5] + x[1], 7);
            x[13] ^= R(x[9] + x[5], 9);
            x[1] ^= R(x[13] + x[9], 13);
            x[5] ^= R(x[1] + x[13], 18);
            x[14] ^= R(x[10] + x[6], 7);
            x[2] ^= R(x[14] + x[10], 9);
            x[6] ^= R(x[2] + x[14], 13);
            x[10] ^= R(x[6] + x[2], 18);
            x[3] ^= R(x[15] + x[11], 7);
            x[7] ^= R(x[3] + x[15], 9);
            x[11] ^= R(x[7] + x[3], 13);
            x[15] ^= R(x[11] + x[7], 18);
            x[1] ^= R(x[0] + x[3], 7);
            x[2] ^= R(x[1] + x[0], 9);
            x[3] ^= R(x[2] + x[1], 13);
            x[0] ^= R(x[3] + x[2], 18);
            x[6] ^= R(x[5] + x[4], 7);
            x[7] ^= R(x[6] + x[5], 9);
            x[4] ^= R(x[7] + x[6], 13);
            x[5] ^= R(x[4] + x[7], 18);
            x[11] ^= R(x[10] + x[9], 7);
            x[8] ^= R(x[11] + x[10], 9);
            x[9] ^= R(x[8] + x[11], 13);
            x[10] ^= R(x[9] + x[8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }
        for(var i1 = 0; i1 < 16; ++i1)B[i1] += x[i1];
    };
    var blockxor = // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for(var i = 0; i < len; i++)D[i] ^= S[Si + i];
    };
    var arraycopy = function arraycopy(src, srcPos, dest, destPos, length) {
        while(length--)dest[destPos++] = src[srcPos++];
    };
    var checkBufferish = function checkBufferish(o) {
        if (!o || typeof o.length !== "number") return false;
        for(var i = 0; i < o.length; i++){
            var v = o[i];
            if (typeof v !== "number" || v % 1 || v < 0 || v >= 256) return false;
        }
        return true;
    };
    var ensureInteger = function ensureInteger(value, name) {
        if (typeof value !== "number" || value % 1) throw new Error("invalid " + name);
        return value;
    };
    var _scrypt = // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function _scrypt(password, salt, N, r, p, dkLen, callback) {
        N = ensureInteger(N, "N");
        r = ensureInteger(r, "r");
        p = ensureInteger(p, "p");
        dkLen = ensureInteger(dkLen, "dkLen");
        if (N === 0 || (N & N - 1) !== 0) throw new Error("N must be power of 2");
        if (N > MAX_VALUE / 128 / r) throw new Error("N too large");
        if (r > MAX_VALUE / 128 / p) throw new Error("r too large");
        if (!checkBufferish(password)) throw new Error("password must be an array or buffer");
        password = Array.prototype.slice.call(password);
        if (!checkBufferish(salt)) throw new Error("salt must be an array or buffer");
        salt = Array.prototype.slice.call(salt);
        var b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        var B = new Uint32Array(p * 32 * r);
        for(var i = 0; i < B.length; i++){
            var j = i * 4;
            B[i] = (b[j + 3] & 0xff) << 24 | (b[j + 2] & 0xff) << 16 | (b[j + 1] & 0xff) << 8 | (b[j + 0] & 0xff) << 0;
        }
        var XY = new Uint32Array(64 * r);
        var V = new Uint32Array(32 * r * N);
        var Yi = 32 * r;
        // scratch space
        var x = new Uint32Array(16); // salsa20_8
        var _X = new Uint32Array(16); // blockmix_salsa8
        var totalOps = p * N * 2;
        var currentOp = 0;
        var lastPercent10 = null;
        // Set this to true to abandon the scrypt on the next step
        var stop = false;
        // State information
        var state = 0;
        var i0 = 0, i1;
        var Bi;
        // How many blockmix_salsa8 can we do per step?
        var limit = callback ? parseInt(1000 / r) : 0xffffffff;
        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        var nextTick = typeof setImmediate !== "undefined" ? setImmediate : setTimeout;
        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        var incrementalSMix = function incrementalSMix1() {
            if (stop) return callback(new Error("cancelled"), currentOp / totalOps);
            var steps;
            switch(state){
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;
                    arraycopy(B, Bi, XY, 0, Yi); // ROMix - 1
                    state = 1; // Move to ROMix 2
                    i1 = 0;
                // Fall through
                case 1:
                    // Run up to 1000 steps of the first inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(var i = 0; i < steps; i++){
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi) // ROMix - 3
                        ;
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 4
                    }
                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;
                    if (callback) {
                        // Call the callback with the progress (optionally stopping us)
                        var percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    i1 = 0; // Move to ROMix 6
                    state = 2;
                // Fall through
                case 2:
                    // Run up to 1000 steps of the second inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(var i2 = 0; i2 < steps; i2++){
                        var offset = (2 * r - 1) * 16; // ROMix - 7
                        var j = XY[offset] & N - 1;
                        blockxor(V, j * Yi, XY, Yi); // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 9 (outer)
                    }
                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;
                    // Call the callback with the progress (optionally stopping us)
                    if (callback) {
                        var percent101 = parseInt(1000 * currentOp / totalOps);
                        if (percent101 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent101;
                        }
                    }
                    if (i1 < N) break;
                    arraycopy(XY, 0, B, Bi, Yi); // ROMix - 10
                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }
                    b = [];
                    for(var i3 = 0; i3 < B.length; i3++){
                        b.push(B[i3] >> 0 & 0xff);
                        b.push(B[i3] >> 8 & 0xff);
                        b.push(B[i3] >> 16 & 0xff);
                        b.push(B[i3] >> 24 & 0xff);
                    }
                    var derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);
                    // Send the result to the callback
                    if (callback) callback(null, 1.0, derivedKey);
                    // Done; don't break (which would reschedule)
                    return derivedKey;
            }
            // Schedule the next steps
            if (callback) nextTick(incrementalSMix);
        };
        // Run the smix state machine until completion
        if (!callback) while(true){
            var derivedKey = incrementalSMix();
            if (derivedKey != undefined) return derivedKey;
        }
        // Bootstrap the async incremental smix
        incrementalSMix();
    };
    var MAX_VALUE = 0x7fffffff;
    var lib = {
        scrypt: function scrypt(password, salt, N, r, p, dkLen, progressCallback) {
            return new Promise(function(resolve, reject) {
                var lastProgress = 0;
                if (progressCallback) progressCallback(0);
                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
                    if (error) reject(error);
                    else if (key) {
                        if (progressCallback && lastProgress !== 1) progressCallback(1);
                        resolve(new Uint8Array(key));
                    } else if (progressCallback && progress !== lastProgress) {
                        lastProgress = progress;
                        return progressCallback(progress);
                    }
                });
            });
        },
        syncScrypt: function syncScrypt(password, salt, N, r, p, dkLen) {
            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
        }
    };
    // node.js
    if (typeof module.exports !== "undefined") module.exports = lib;
    else if (typeof define === "function" && define.amd) define(lib);
    else if (root) {
        // If there was an existing library "scrypt", make sure it is still available
        if (root.scrypt) root._scrypt = root.scrypt;
        root.scrypt = lib;
    }
})(module.exports);

});



parcelRequire.register("eIckK", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $ab5ebdfa7aaeb9e4$export$83d89fbfd8236492; });
var $ab5ebdfa7aaeb9e4$export$83d89fbfd8236492 = "wallet/5.7.0";

});


parcelRequire.register("gqL7R", function(module, exports) {

$parcel$export(module.exports, "_fetchData", function () { return $bf63a14489d0132f$export$e37fa27017c6c012; });
$parcel$export(module.exports, "fetchJson", function () { return $bf63a14489d0132f$export$6d71b655afe1638d; });
$parcel$export(module.exports, "poll", function () { return $bf63a14489d0132f$export$e0c10349b2c5e1d4; });

var $7UAGh = parcelRequire("7UAGh");

var $70PIu = parcelRequire("70PIu");

var $j2rU8 = parcelRequire("j2rU8");

var $2ax4w = parcelRequire("2ax4w");

var $1Wmc7 = parcelRequire("1Wmc7");

var $6M65e = parcelRequire("6M65e");

var $ePgwe = parcelRequire("ePgwe");

var $fPoRB = parcelRequire("fPoRB");
"use strict";
var $bf63a14489d0132f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bf63a14489d0132f$var$logger = new (0, $6M65e.Logger)((0, $ePgwe.version));
function $bf63a14489d0132f$var$staller(duration) {
    return new Promise(function(resolve) {
        setTimeout(resolve, duration);
    });
}
function $bf63a14489d0132f$var$bodyify(value, type) {
    if (value == null) return null;
    if (typeof value === "string") return value;
    if ((0, $j2rU8.isBytesLike)(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) try {
            return (0, $1Wmc7.toUtf8String)(value);
        } catch (error) {}
        return (0, $j2rU8.hexlify)(value);
    }
    return value;
}
function $bf63a14489d0132f$var$unpercent(value) {
    return (0, $1Wmc7.toUtf8Bytes)(value.replace(/%([0-9a-f][0-9a-f])/gi, function(all, code) {
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $bf63a14489d0132f$export$e37fa27017c6c012(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    var attemptLimit = typeof connection === "object" && connection.throttleLimit != null ? connection.throttleLimit : 12;
    $bf63a14489d0132f$var$logger.assertArgument(attemptLimit > 0 && attemptLimit % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    var throttleCallback = typeof connection === "object" ? connection.throttleCallback : null;
    var throttleSlotInterval = typeof connection === "object" && typeof connection.throttleSlotInterval === "number" ? connection.throttleSlotInterval : 100;
    $bf63a14489d0132f$var$logger.assertArgument(throttleSlotInterval > 0 && throttleSlotInterval % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    var errorPassThrough = typeof connection === "object" ? !!connection.errorPassThrough : false;
    var headers = {};
    var url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    var options = {
        method: "GET"
    };
    var allow304 = false;
    var timeout = 120000;
    if (typeof connection === "string") url = connection;
    else if (typeof connection === "object") {
        if (connection == null || connection.url == null) $bf63a14489d0132f$var$logger.throwArgumentError("missing URL", "connection.url", connection);
        url = connection.url;
        if (typeof connection.timeout === "number" && connection.timeout > 0) timeout = connection.timeout;
        if (connection.headers) for(var key in connection.headers){
            headers[key.toLowerCase()] = {
                key: key,
                value: String(connection.headers[key])
            };
            if ([
                "if-none-match",
                "if-modified-since"
            ].indexOf(key.toLowerCase()) >= 0) allow304 = true;
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) $bf63a14489d0132f$var$logger.throwError("basic authentication requires a secure https url", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                argument: "url",
                url: url,
                user: connection.user,
                password: "[REDACTED]"
            });
            var authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + (0, $70PIu.encode)((0, $1Wmc7.toUtf8Bytes)(authorization))
            };
        }
        if (connection.skipFetchSetup != null) options.skipFetchSetup = !!connection.skipFetchSetup;
        if (connection.fetchOptions != null) options.fetchOptions = (0, $2ax4w.shallowCopy)(connection.fetchOptions);
    }
    var reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
    var dataMatch = url ? url.match(reData) : null;
    if (dataMatch) try {
        var response = {
            statusCode: 200,
            statusMessage: "OK",
            headers: {
                "content-type": dataMatch[1] || "text/plain"
            },
            body: dataMatch[2] ? (0, $70PIu.decode)(dataMatch[3]) : $bf63a14489d0132f$var$unpercent(dataMatch[3])
        };
        var result = response.body;
        if (processFunc) result = processFunc(response.body, response);
        return Promise.resolve(result);
    } catch (error) {
        $bf63a14489d0132f$var$logger.throwError("processing response error", (0, $6M65e.Logger).errors.SERVER_ERROR, {
            body: $bf63a14489d0132f$var$bodyify(dataMatch[1], dataMatch[2]),
            error: error,
            requestBody: null,
            requestMethod: "GET",
            url: url
        });
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) headers["content-type"] = {
            key: "Content-Type",
            value: "application/octet-stream"
        };
        if (headers["content-length"] == null) headers["content-length"] = {
            key: "Content-Length",
            value: String(body.length)
        };
    }
    var flatHeaders = {};
    Object.keys(headers).forEach(function(key) {
        var header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    var runningTimeout = function() {
        var timer = null;
        var promise = new Promise(function(resolve, reject) {
            if (timeout) timer = setTimeout(function() {
                if (timer == null) return;
                timer = null;
                reject($bf63a14489d0132f$var$logger.makeError("timeout", (0, $6M65e.Logger).errors.TIMEOUT, {
                    requestBody: $bf63a14489d0132f$var$bodyify(options.body, flatHeaders["content-type"]),
                    requestMethod: options.method,
                    timeout: timeout,
                    url: url
                }));
            }, timeout);
        });
        var cancel = function cancel() {
            if (timer == null) return;
            clearTimeout(timer);
            timer = null;
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }();
    var runningFetch = function() {
        return $bf63a14489d0132f$var$__awaiter(this, void 0, void 0, function() {
            var attempt, response, location, tryAgain, stall, retryAfter, error, _$body, result, error1, tryAgain1, timeout;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        attempt = 0;
                        _state.label = 1;
                    case 1:
                        if (!(attempt < attemptLimit)) return [
                            3,
                            20
                        ];
                        response = null;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            9,
                            ,
                            10
                        ]);
                        return [
                            4,
                            (0, $fPoRB.getUrl)(url, options)
                        ];
                    case 3:
                        response = _state.sent();
                        if (!(attempt < attemptLimit)) return [
                            3,
                            8
                        ];
                        if (!(response.statusCode === 301 || response.statusCode === 302)) return [
                            3,
                            4
                        ];
                        location = response.headers.location || "";
                        if (options.method === "GET" && location.match(/^https:/)) {
                            url = response.headers.location;
                            return [
                                3,
                                19
                            ];
                        }
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(response.statusCode === 429)) return [
                            3,
                            8
                        ];
                        tryAgain = true;
                        if (!throttleCallback) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            throttleCallback(attempt, url)
                        ];
                    case 5:
                        tryAgain = _state.sent();
                        _state.label = 6;
                    case 6:
                        if (!tryAgain) return [
                            3,
                            8
                        ];
                        stall = 0;
                        retryAfter = response.headers["retry-after"];
                        if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) stall = parseInt(retryAfter) * 1000;
                        else stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                        //console.log("Stalling 429");
                        return [
                            4,
                            $bf63a14489d0132f$var$staller(stall)
                        ];
                    case 7:
                        _state.sent();
                        return [
                            3,
                            19
                        ];
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        error = _state.sent();
                        response = error.response;
                        if (response == null) {
                            runningTimeout.cancel();
                            $bf63a14489d0132f$var$logger.throwError("missing response", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                                requestBody: $bf63a14489d0132f$var$bodyify(options.body, flatHeaders["content-type"]),
                                requestMethod: options.method,
                                serverError: error,
                                url: url
                            });
                        }
                        return [
                            3,
                            10
                        ];
                    case 10:
                        _$body = response.body;
                        if (allow304 && response.statusCode === 304) _$body = null;
                        else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
                            runningTimeout.cancel();
                            $bf63a14489d0132f$var$logger.throwError("bad response", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                                status: response.statusCode,
                                headers: response.headers,
                                body: $bf63a14489d0132f$var$bodyify(_$body, response.headers ? response.headers["content-type"] : null),
                                requestBody: $bf63a14489d0132f$var$bodyify(options.body, flatHeaders["content-type"]),
                                requestMethod: options.method,
                                url: url
                            });
                        }
                        if (!processFunc) return [
                            3,
                            18
                        ];
                        _state.label = 11;
                    case 11:
                        _state.trys.push([
                            11,
                            13,
                            ,
                            18
                        ]);
                        return [
                            4,
                            processFunc(_$body, response)
                        ];
                    case 12:
                        result = _state.sent();
                        runningTimeout.cancel();
                        return [
                            2,
                            result
                        ];
                    case 13:
                        error1 = _state.sent();
                        if (!(error1.throttleRetry && attempt < attemptLimit)) return [
                            3,
                            17
                        ];
                        tryAgain1 = true;
                        if (!throttleCallback) return [
                            3,
                            15
                        ];
                        return [
                            4,
                            throttleCallback(attempt, url)
                        ];
                    case 14:
                        tryAgain1 = _state.sent();
                        _state.label = 15;
                    case 15:
                        if (!tryAgain1) return [
                            3,
                            17
                        ];
                        timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                        //console.log("Stalling callback");
                        return [
                            4,
                            $bf63a14489d0132f$var$staller(timeout)
                        ];
                    case 16:
                        _state.sent();
                        return [
                            3,
                            19
                        ];
                    case 17:
                        runningTimeout.cancel();
                        $bf63a14489d0132f$var$logger.throwError("processing response error", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                            body: $bf63a14489d0132f$var$bodyify(_$body, response.headers ? response.headers["content-type"] : null),
                            error: error1,
                            requestBody: $bf63a14489d0132f$var$bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            url: url
                        });
                        return [
                            3,
                            18
                        ];
                    case 18:
                        runningTimeout.cancel();
                        // If we had a processFunc, it either returned a T or threw above.
                        // The "body" is now a Uint8Array.
                        return [
                            2,
                            _$body
                        ];
                    case 19:
                        attempt++;
                        return [
                            3,
                            1
                        ];
                    case 20:
                        return [
                            2,
                            $bf63a14489d0132f$var$logger.throwError("failed response", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                                requestBody: $bf63a14489d0132f$var$bodyify(options.body, flatHeaders["content-type"]),
                                requestMethod: options.method,
                                url: url
                            })
                        ];
                }
            });
        });
    }();
    return Promise.race([
        runningTimeout.promise,
        runningFetch
    ]);
}
function $bf63a14489d0132f$export$6d71b655afe1638d(connection, json, processFunc) {
    var processJsonFunc = function(value, response) {
        var result = null;
        if (value != null) try {
            result = JSON.parse((0, $1Wmc7.toUtf8String)(value));
        } catch (error) {
            $bf63a14489d0132f$var$logger.throwError("invalid JSON", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                body: value,
                error: error
            });
        }
        if (processFunc) result = processFunc(result, response);
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    var body = null;
    if (json != null) {
        body = (0, $1Wmc7.toUtf8Bytes)(json);
        // Create a connection with the content-type set for JSON
        var updated = typeof connection === "string" ? {
            url: connection
        } : (0, $2ax4w.shallowCopy)(connection);
        if (updated.headers) {
            var hasContentType = Object.keys(updated.headers).filter(function(k) {
                return k.toLowerCase() === "content-type";
            }).length !== 0;
            if (!hasContentType) {
                updated.headers = (0, $2ax4w.shallowCopy)(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        } else updated.headers = {
            "content-type": "application/json"
        };
        connection = updated;
    }
    return $bf63a14489d0132f$export$e37fa27017c6c012(connection, body, processJsonFunc);
}
function $bf63a14489d0132f$export$e0c10349b2c5e1d4(func, options) {
    if (!options) options = {};
    options = (0, $2ax4w.shallowCopy)(options);
    if (options.floor == null) options.floor = 0;
    if (options.ceiling == null) options.ceiling = 10000;
    if (options.interval == null) options.interval = 250;
    return new Promise(function(resolve, reject) {
        var timer = null;
        var done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        var cancel = function() {
            if (done) return false;
            done = true;
            if (timer) clearTimeout(timer);
            return true;
        };
        if (options.timeout) timer = setTimeout(function() {
            if (cancel()) reject(new Error("timeout"));
        }, options.timeout);
        var retryLimit = options.retryLimit;
        var attempt = 0;
        function check() {
            return func().then(function(result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) resolve(result);
                } else if (options.oncePoll) options.oncePoll.once("poll", check);
                else if (options.onceBlock) options.onceBlock.once("block", check);
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) reject(new Error("retry limit reached"));
                        return;
                    }
                    var timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) timeout = options.floor;
                    if (timeout > options.ceiling) timeout = options.ceiling;
                    setTimeout(check, timeout);
                }
                return null;
            }, function(error) {
                if (cancel()) reject(error);
            });
        }
        check();
    });
}

});
parcelRequire.register("ePgwe", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $acb2a463b6dabef3$export$83d89fbfd8236492; });
var $acb2a463b6dabef3$export$83d89fbfd8236492 = "web/5.7.1";

});

parcelRequire.register("fPoRB", function(module, exports) {

$parcel$export(module.exports, "getUrl", function () { return $b85ee7d721e8a835$export$94df0e59ebebf4a7; });

var $7UAGh = parcelRequire("7UAGh");

var $j2rU8 = parcelRequire("j2rU8");
"use strict";
var $b85ee7d721e8a835$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $b85ee7d721e8a835$export$94df0e59ebebf4a7(href, options) {
    return $b85ee7d721e8a835$var$__awaiter(this, void 0, void 0, function() {
        var request, opts, response, body, headers;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options == null) options = {};
                    request = {
                        method: options.method || "GET",
                        headers: options.headers || {},
                        body: options.body || undefined
                    };
                    if (options.skipFetchSetup !== true) {
                        request.mode = "cors"; // no-cors, cors, *same-origin
                        request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
                        request.credentials = "same-origin"; // include, *same-origin, omit
                        request.redirect = "follow"; // manual, *follow, error
                        request.referrer = "client"; // no-referrer, *client
                    }
                    if (options.fetchOptions != null) {
                        opts = options.fetchOptions;
                        if (opts.mode) request.mode = opts.mode;
                        if (opts.cache) request.cache = opts.cache;
                        if (opts.credentials) request.credentials = opts.credentials;
                        if (opts.redirect) request.redirect = opts.redirect;
                        if (opts.referrer) request.referrer = opts.referrer;
                    }
                    return [
                        4,
                        fetch(href, request)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.arrayBuffer()
                    ];
                case 2:
                    body = _state.sent();
                    headers = {};
                    if (response.headers.forEach) response.headers.forEach(function(value, key) {
                        headers[key.toLowerCase()] = value;
                    });
                    else response.headers.keys().forEach(function(key) {
                        headers[key.toLowerCase()] = response.headers.get(key);
                    });
                    return [
                        2,
                        {
                            headers: headers,
                            statusCode: response.status,
                            statusMessage: response.statusText,
                            body: (0, $j2rU8.arrayify)(new Uint8Array(body))
                        }
                    ];
            }
        });
    });
}

});



parcelRequire.register("fTHW5", function(module, exports) {
"use strict";
// Abbreviations:
// * BS = Byte size
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DATA_FEED_ID_BS = module.exports.SIGNATURE_BS = module.exports.REDSTONE_MARKER_BS = module.exports.REDSTONE_MARKER_HEX = module.exports.UNSGINED_METADATA_BYTE_SIZE_BS = module.exports.DATA_PACKAGES_COUNT_BS = module.exports.DEFAULT_NUM_VALUE_DECIMALS = module.exports.DEFAULT_NUM_VALUE_BS = module.exports.DATA_POINT_VALUE_BYTE_SIZE_BS = module.exports.DATA_POINTS_COUNT_BS = module.exports.TIMESTAMP_BS = void 0;
// Number of bytes reserved to store timestamp
module.exports.TIMESTAMP_BS = 6;
// Number of bytes reserved to store the number of data points
module.exports.DATA_POINTS_COUNT_BS = 3;
// Number of bytes reserved to store datapoints byte size
module.exports.DATA_POINT_VALUE_BYTE_SIZE_BS = 4;
// Default value byte size for numeric values
module.exports.DEFAULT_NUM_VALUE_BS = 32;
// Default precision for numeric values
module.exports.DEFAULT_NUM_VALUE_DECIMALS = 8;
// Number of bytes reserved for data packages count
module.exports.DATA_PACKAGES_COUNT_BS = 2;
// Number of bytes reserved for unsigned metadata byte size
module.exports.UNSGINED_METADATA_BYTE_SIZE_BS = 3;
// RedStone marker, which will be appended in the end of each transaction
module.exports.REDSTONE_MARKER_HEX = "0x000002ed57011e0000";
// Byte size of RedStone marker
// we subtract 1 because of the 0x prefix
module.exports.REDSTONE_MARKER_BS = module.exports.REDSTONE_MARKER_HEX.length / 2 - 1;
// Byte size of signatures
module.exports.SIGNATURE_BS = 65;
// Byte size of data feed id
module.exports.DATA_FEED_ID_BS = 32;

});

parcelRequire.register("1t7fG", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Serializable = void 0;
parcelRequire("blIpd");
var $3A3Dv = parcelRequire("3A3Dv");

var $6d3tJ = parcelRequire("6d3tJ");
var $111e1ff192da8f19$var$Serializable = /*#__PURE__*/ function() {
    function Serializable() {
        (0, $978gY._)(this, Serializable);
    }
    (0, $kry2a._)(Serializable, [
        {
            key: "toBytesHex",
            value: function toBytesHex() {
                var serializedBytes = this.toBytes();
                return $3A3Dv.utils.hexlify(serializedBytes);
            }
        },
        {
            key: "toBytesHexWithout0xPrefix",
            value: function toBytesHexWithout0xPrefix() {
                var serializedBytes = this.toBytes();
                return (0, $6d3tJ.hexlifyWithout0xPrefix)(serializedBytes);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var serializedPlainObj = this.toObj();
                return JSON.stringify(serializedPlainObj);
            }
        }
    ]);
    return Serializable;
}();
module.exports.Serializable = $111e1ff192da8f19$var$Serializable;

});
parcelRequire.register("blIpd", function(module, exports) {

$parcel$export(module.exports, "ethers", function () { return (parcelRequire("3A3Dv")); });

var $3A3Dv = parcelRequire("3A3Dv");
var $iGUqv = parcelRequire("iGUqv");
var $54wuV = parcelRequire("54wuV");
var $ldxXU = parcelRequire("ldxXU");
var $lHP19 = parcelRequire("lHP19");
var $gMArf = parcelRequire("gMArf");
var $15mVR = parcelRequire("15mVR");
var $3mObr = parcelRequire("3mObr");
var $6M65e = parcelRequire("6M65e");
var $e5s6c = parcelRequire("e5s6c");
var $1cpDB = parcelRequire("1cpDB");
var $d7X94 = parcelRequire("d7X94");
var $hj32o = parcelRequire("hj32o");
"use strict";
try {
    var $843419ec67ab8c10$var$anyGlobal = window;
    if ($843419ec67ab8c10$var$anyGlobal._ethers == null) $843419ec67ab8c10$var$anyGlobal._ethers = $3A3Dv;
} catch (error) {}

});
parcelRequire.register("3A3Dv", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $29b78df16cc81472$export$af88d00dbe7f521; });
$parcel$export(module.exports, "Signer", function () { return (parcelRequire("iGUqv")).Signer; });
$parcel$export(module.exports, "Wallet", function () { return (parcelRequire("54wuV")).Wallet; });
$parcel$export(module.exports, "VoidSigner", function () { return (parcelRequire("iGUqv")).VoidSigner; });
$parcel$export(module.exports, "getDefaultProvider", function () { return (parcelRequire("ldxXU")).getDefaultProvider; });
$parcel$export(module.exports, "providers", function () { return (parcelRequire("ldxXU")); });
$parcel$export(module.exports, "BaseContract", function () { return (parcelRequire("lHP19")).BaseContract; });
$parcel$export(module.exports, "Contract", function () { return (parcelRequire("lHP19")).Contract; });
$parcel$export(module.exports, "ContractFactory", function () { return (parcelRequire("lHP19")).ContractFactory; });
$parcel$export(module.exports, "BigNumber", function () { return (parcelRequire("gMArf")).BigNumber; });
$parcel$export(module.exports, "FixedNumber", function () { return (parcelRequire("15mVR")).FixedNumber; });
$parcel$export(module.exports, "constants", function () { return (parcelRequire("3mObr")); });
$parcel$export(module.exports, "errors", function () { return (parcelRequire("6M65e")).ErrorCode; });
$parcel$export(module.exports, "utils", function () { return (parcelRequire("e5s6c")); });
$parcel$export(module.exports, "wordlists", function () { return (parcelRequire("1cpDB")).wordlists; });
$parcel$export(module.exports, "version", function () { return (parcelRequire("d7X94")).version; });
$parcel$export(module.exports, "Wordlist", function () { return (parcelRequire("hj32o")).Wordlist; });

var $lHP19 = parcelRequire("lHP19");

var $gMArf = parcelRequire("gMArf");
var $15mVR = parcelRequire("15mVR");

var $iGUqv = parcelRequire("iGUqv");

var $54wuV = parcelRequire("54wuV");

var $3mObr = parcelRequire("3mObr");

var $ldxXU = parcelRequire("ldxXU");

var $hj32o = parcelRequire("hj32o");
var $1cpDB = parcelRequire("1cpDB");

var $e5s6c = parcelRequire("e5s6c");

var $6M65e = parcelRequire("6M65e");

var $d7X94 = parcelRequire("d7X94");
"use strict";
var $29b78df16cc81472$export$af88d00dbe7f521 = new (0, $6M65e.Logger)((0, $d7X94.version));

});
parcelRequire.register("lHP19", function(module, exports) {

$parcel$export(module.exports, "BaseContract", function () { return $fcd53023be51494b$export$304faa4fc17528db; });
$parcel$export(module.exports, "Contract", function () { return $fcd53023be51494b$export$8517d80acf00e19a; });
$parcel$export(module.exports, "ContractFactory", function () { return $fcd53023be51494b$export$505569a6bf584fd9; });

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $fLnyw = parcelRequire("fLnyw");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $ggjPf = parcelRequire("ggjPf");
var $9rkfU = parcelRequire("9rkfU");

var $lLovk = parcelRequire("lLovk");

var $iGUqv = parcelRequire("iGUqv");

var $e8NrM = parcelRequire("e8NrM");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $2ax4w = parcelRequire("2ax4w");

var $hDQeE = parcelRequire("hDQeE");

var $6M65e = parcelRequire("6M65e");

var $hLRMu = parcelRequire("hLRMu");
"use strict";
var $fcd53023be51494b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fcd53023be51494b$var$logger = new (0, $6M65e.Logger)((0, $hLRMu.version));
///////////////////////////////
var $fcd53023be51494b$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    from: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true,
    customData: true,
    ccipReadEnabled: true
};
function $fcd53023be51494b$var$resolveName(resolver, nameOrPromise) {
    return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function() {
        var name, address;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        nameOrPromise
                    ];
                case 1:
                    name = _state.sent();
                    if (typeof name !== "string") $fcd53023be51494b$var$logger.throwArgumentError("invalid address or ENS name", "name", name);
                    // If it is already an address, just use it (after adding checksum)
                    try {
                        return [
                            2,
                            (0, $e8NrM.getAddress)(name)
                        ];
                    } catch (error) {}
                    if (!resolver) $fcd53023be51494b$var$logger.throwError("a provider or signer is needed to resolve ENS names", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "resolveName"
                    });
                    return [
                        4,
                        resolver.resolveName(name)
                    ];
                case 2:
                    address = _state.sent();
                    if (address == null) $fcd53023be51494b$var$logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
                    return [
                        2,
                        address
                    ];
            }
        });
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function $fcd53023be51494b$var$resolveAddresses(resolver, value, paramType) {
    return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function() {
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!Array.isArray(paramType)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        Promise.all(paramType.map(function(paramType, index) {
                            return $fcd53023be51494b$var$resolveAddresses(resolver, Array.isArray(value) ? value[index] : value[paramType.name], paramType);
                        }))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    if (!(paramType.type === "address")) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $fcd53023be51494b$var$resolveName(resolver, value)
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    if (!(paramType.type === "tuple")) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        $fcd53023be51494b$var$resolveAddresses(resolver, value, paramType.components)
                    ];
                case 5:
                    return [
                        2,
                        _state.sent()
                    ];
                case 6:
                    if (!(paramType.baseType === "array")) return [
                        3,
                        8
                    ];
                    if (!Array.isArray(value)) return [
                        2,
                        Promise.reject($fcd53023be51494b$var$logger.makeError("invalid value for array", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                            argument: "value",
                            value: value
                        }))
                    ];
                    return [
                        4,
                        Promise.all(value.map(function(v) {
                            return $fcd53023be51494b$var$resolveAddresses(resolver, v, paramType.arrayChildren);
                        }))
                    ];
                case 7:
                    return [
                        2,
                        _state.sent()
                    ];
                case 8:
                    return [
                        2,
                        value
                    ];
            }
        });
    });
}
function $fcd53023be51494b$var$populateTransaction(contract, fragment, args) {
    return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function() {
        var _this, overrides, resolved, data, tx, ro, intrinsic, bytes, i, roValue, leftovers;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _this = this;
                    overrides = {};
                    if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") overrides = (0, $2ax4w.shallowCopy)(args.pop());
                    // Make sure the parameter count matches
                    $fcd53023be51494b$var$logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
                    // Populate "from" override (allow promises)
                    if (contract.signer) {
                        if (overrides.from) // Contracts with a Signer are from the Signer's frame-of-reference;
                        // but we allow overriding "from" if it matches the signer
                        overrides.from = (0, $2ax4w.resolveProperties)({
                            override: $fcd53023be51494b$var$resolveName(contract.signer, overrides.from),
                            signer: contract.signer.getAddress()
                        }).then(function(check) {
                            return $fcd53023be51494b$var$__awaiter(_this, void 0, void 0, function() {
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    if ((0, $e8NrM.getAddress)(check.signer) !== check.override) $fcd53023be51494b$var$logger.throwError("Contract with a Signer cannot override from", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                                        operation: "overrides.from"
                                    });
                                    return [
                                        2,
                                        check.override
                                    ];
                                });
                            });
                        });
                        else overrides.from = contract.signer.getAddress();
                    } else if (overrides.from) overrides.from = $fcd53023be51494b$var$resolveName(contract.provider, overrides.from);
                    return [
                        4,
                        (0, $2ax4w.resolveProperties)({
                            args: $fcd53023be51494b$var$resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
                            address: contract.resolvedAddress,
                            overrides: (0, $2ax4w.resolveProperties)(overrides) || {}
                        })
                    ];
                case 1:
                    resolved = _state.sent();
                    data = contract.interface.encodeFunctionData(fragment, resolved.args);
                    tx = {
                        data: data,
                        to: resolved.address
                    };
                    ro = resolved.overrides;
                    // Populate simple overrides
                    if (ro.nonce != null) tx.nonce = (0, $gMArf.BigNumber).from(ro.nonce).toNumber();
                    if (ro.gasLimit != null) tx.gasLimit = (0, $gMArf.BigNumber).from(ro.gasLimit);
                    if (ro.gasPrice != null) tx.gasPrice = (0, $gMArf.BigNumber).from(ro.gasPrice);
                    if (ro.maxFeePerGas != null) tx.maxFeePerGas = (0, $gMArf.BigNumber).from(ro.maxFeePerGas);
                    if (ro.maxPriorityFeePerGas != null) tx.maxPriorityFeePerGas = (0, $gMArf.BigNumber).from(ro.maxPriorityFeePerGas);
                    if (ro.from != null) tx.from = ro.from;
                    if (ro.type != null) tx.type = ro.type;
                    if (ro.accessList != null) tx.accessList = (0, $hDQeE.accessListify)(ro.accessList);
                    // If there was no "gasLimit" override, but the ABI specifies a default, use it
                    if (tx.gasLimit == null && fragment.gas != null) {
                        intrinsic = 21000;
                        bytes = (0, $j2rU8.arrayify)(data);
                        for(i = 0; i < bytes.length; i++){
                            intrinsic += 4;
                            if (bytes[i]) intrinsic += 64;
                        }
                        tx.gasLimit = (0, $gMArf.BigNumber).from(fragment.gas).add(intrinsic);
                    }
                    // Populate "value" override
                    if (ro.value) {
                        roValue = (0, $gMArf.BigNumber).from(ro.value);
                        if (!roValue.isZero() && !fragment.payable) $fcd53023be51494b$var$logger.throwError("non-payable method cannot override value", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                            operation: "overrides.value",
                            value: overrides.value
                        });
                        tx.value = roValue;
                    }
                    if (ro.customData) tx.customData = (0, $2ax4w.shallowCopy)(ro.customData);
                    if (ro.ccipReadEnabled) tx.ccipReadEnabled = !!ro.ccipReadEnabled;
                    // Remove the overrides
                    delete overrides.nonce;
                    delete overrides.gasLimit;
                    delete overrides.gasPrice;
                    delete overrides.from;
                    delete overrides.value;
                    delete overrides.type;
                    delete overrides.accessList;
                    delete overrides.maxFeePerGas;
                    delete overrides.maxPriorityFeePerGas;
                    delete overrides.customData;
                    delete overrides.ccipReadEnabled;
                    leftovers = Object.keys(overrides).filter(function(key) {
                        return overrides[key] != null;
                    });
                    if (leftovers.length) $fcd53023be51494b$var$logger.throwError("cannot override ".concat(leftovers.map(function(l) {
                        return JSON.stringify(l);
                    }).join(",")), (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides",
                        overrides: leftovers
                    });
                    return [
                        2,
                        tx
                    ];
            }
        });
    });
}
function $fcd53023be51494b$var$buildPopulate(contract, fragment) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $fcd53023be51494b$var$populateTransaction(contract, fragment, args);
    };
}
function $fcd53023be51494b$var$buildEstimate(contract, fragment) {
    var signerOrProvider = contract.signer || contract.provider;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function() {
            var tx;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!signerOrProvider) $fcd53023be51494b$var$logger.throwError("estimate require a provider or signer", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                            operation: "estimateGas"
                        });
                        return [
                            4,
                            $fcd53023be51494b$var$populateTransaction(contract, fragment, args)
                        ];
                    case 1:
                        tx = _state.sent();
                        return [
                            4,
                            signerOrProvider.estimateGas(tx)
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
    };
}
function $fcd53023be51494b$var$addContractWait(contract, tx) {
    var wait = tx.wait.bind(tx);
    tx.wait = function(confirmations) {
        return wait(confirmations).then(function(receipt) {
            receipt.events = receipt.logs.map(function(log) {
                var event = (0, $2ax4w.deepCopy)(log);
                var parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                } catch (e) {}
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = function(data, topics) {
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = function() {
                    return contract.provider;
                };
                event.getBlock = function() {
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = function() {
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = function() {
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function $fcd53023be51494b$var$buildCall(contract, fragment, collapseSimple) {
    var signerOrProvider = contract.signer || contract.provider;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function() {
            var blockTag, overrides, tx, result, value;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        blockTag = undefined;
                        if (!(args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object")) return [
                            3,
                            3
                        ];
                        overrides = (0, $2ax4w.shallowCopy)(args.pop());
                        if (!(overrides.blockTag != null)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            overrides.blockTag
                        ];
                    case 1:
                        blockTag = _state.sent();
                        _state.label = 2;
                    case 2:
                        delete overrides.blockTag;
                        args.push(overrides);
                        _state.label = 3;
                    case 3:
                        if (!(contract.deployTransaction != null)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            contract._deployed(blockTag)
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            4,
                            $fcd53023be51494b$var$populateTransaction(contract, fragment, args)
                        ];
                    case 6:
                        tx = _state.sent();
                        return [
                            4,
                            signerOrProvider.call(tx, blockTag)
                        ];
                    case 7:
                        result = _state.sent();
                        try {
                            value = contract.interface.decodeFunctionResult(fragment, result);
                            if (collapseSimple && fragment.outputs.length === 1) value = value[0];
                            return [
                                2,
                                value
                            ];
                        } catch (error) {
                            if (error.code === (0, $6M65e.Logger).errors.CALL_EXCEPTION) {
                                error.address = contract.address;
                                error.args = args;
                                error.transaction = tx;
                            }
                            throw error;
                        }
                        return [
                            2
                        ];
                }
            });
        });
    };
}
function $fcd53023be51494b$var$buildSend(contract, fragment) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function() {
            var txRequest, tx;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!contract.signer) $fcd53023be51494b$var$logger.throwError("sending a transaction requires a signer", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                            operation: "sendTransaction"
                        });
                        if (!(contract.deployTransaction != null)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            contract._deployed()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            $fcd53023be51494b$var$populateTransaction(contract, fragment, args)
                        ];
                    case 3:
                        txRequest = _state.sent();
                        return [
                            4,
                            contract.signer.sendTransaction(txRequest)
                        ];
                    case 4:
                        tx = _state.sent();
                        // Tweak the tx.wait so the receipt has extra properties
                        $fcd53023be51494b$var$addContractWait(contract, tx);
                        return [
                            2,
                            tx
                        ];
                }
            });
        });
    };
}
function $fcd53023be51494b$var$buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) return $fcd53023be51494b$var$buildCall(contract, fragment, collapseSimple);
    return $fcd53023be51494b$var$buildSend(contract, fragment);
}
function $fcd53023be51494b$var$getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) return "*";
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map(function(topic) {
        if (Array.isArray(topic)) return topic.join("|");
        return topic;
    }).join(":") : "");
}
var $fcd53023be51494b$var$RunningEvent = /*#__PURE__*/ function() {
    function RunningEvent(tag, filter) {
        (0, $978gY._)(this, RunningEvent);
        (0, $2ax4w.defineReadOnly)(this, "tag", tag);
        (0, $2ax4w.defineReadOnly)(this, "filter", filter);
        this._listeners = [];
    }
    (0, $kry2a._)(RunningEvent, [
        {
            key: "addListener",
            value: function addListener(listener, once) {
                this._listeners.push({
                    listener: listener,
                    once: once
                });
            }
        },
        {
            key: "removeListener",
            value: function removeListener(listener) {
                var done = false;
                this._listeners = this._listeners.filter(function(item) {
                    if (done || item.listener !== listener) return true;
                    done = true;
                    return false;
                });
            }
        },
        {
            key: "removeAllListeners",
            value: function removeAllListeners() {
                this._listeners = [];
            }
        },
        {
            key: "listeners",
            value: function listeners() {
                return this._listeners.map(function(i) {
                    return i.listener;
                });
            }
        },
        {
            key: "listenerCount",
            value: function listenerCount() {
                return this._listeners.length;
            }
        },
        {
            key: "run",
            value: function run(args) {
                var _this = this;
                var listenerCount = this.listenerCount();
                this._listeners = this._listeners.filter(function(item) {
                    var argsCopy = args.slice();
                    // Call the callback in the next event loop
                    setTimeout(function() {
                        item.listener.apply(_this, argsCopy);
                    }, 0);
                    // Reschedule it if it not "once"
                    return !item.once;
                });
                return listenerCount;
            }
        },
        {
            key: "prepareEvent",
            value: function prepareEvent(event) {}
        },
        {
            // Returns the array that will be applied to an emit
            key: "getEmit",
            value: function getEmit(event) {
                return [
                    event
                ];
            }
        }
    ]);
    return RunningEvent;
}();
var $fcd53023be51494b$var$ErrorRunningEvent = /*#__PURE__*/ function(RunningEvent) {
    (0, $ftJVG._)(ErrorRunningEvent, RunningEvent);
    var _super = (0, $6OZAO._)(ErrorRunningEvent);
    function ErrorRunningEvent() {
        (0, $978gY._)(this, ErrorRunningEvent);
        return _super.call(this, "error", null);
    }
    return ErrorRunningEvent;
}($fcd53023be51494b$var$RunningEvent);
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
var $fcd53023be51494b$var$FragmentRunningEvent = /*#__PURE__*/ function(RunningEvent) {
    (0, $ftJVG._)(FragmentRunningEvent, RunningEvent);
    var _super = (0, $6OZAO._)(FragmentRunningEvent);
    function FragmentRunningEvent(address, contractInterface, fragment, topics) {
        (0, $978gY._)(this, FragmentRunningEvent);
        var _this;
        var filter = {
            address: address
        };
        var topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) $fcd53023be51494b$var$logger.throwArgumentError("topic mismatch", "topics", topics);
            filter.topics = topics.slice();
        } else filter.topics = [
            topic
        ];
        _this = _super.call(this, $fcd53023be51494b$var$getEventTag(filter), filter);
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "address", address);
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "interface", contractInterface);
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "fragment", fragment);
        return _this;
    }
    (0, $kry2a._)(FragmentRunningEvent, [
        {
            key: "prepareEvent",
            value: function prepareEvent(event) {
                var _this = this;
                (0, $3cct3._)((0, $g3d7z._)(FragmentRunningEvent.prototype), "prepareEvent", this).call(this, event);
                event.event = this.fragment.name;
                event.eventSignature = this.fragment.format();
                event.decode = function(data, topics) {
                    return _this.interface.decodeEventLog(_this.fragment, data, topics);
                };
                try {
                    event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
                } catch (error) {
                    event.args = null;
                    event.decodeError = error;
                }
            }
        },
        {
            key: "getEmit",
            value: function getEmit(event) {
                var errors = (0, $ggjPf.checkResultErrors)(event.args);
                if (errors.length) throw errors[0].error;
                var args = (event.args || []).slice();
                args.push(event);
                return args;
            }
        }
    ]);
    return FragmentRunningEvent;
}($fcd53023be51494b$var$RunningEvent);
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
var $fcd53023be51494b$var$WildcardRunningEvent = /*#__PURE__*/ function(RunningEvent) {
    (0, $ftJVG._)(WildcardRunningEvent, RunningEvent);
    var _super = (0, $6OZAO._)(WildcardRunningEvent);
    function WildcardRunningEvent(address, contractInterface) {
        (0, $978gY._)(this, WildcardRunningEvent);
        var _this;
        _this = _super.call(this, "*", {
            address: address
        });
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "address", address);
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "interface", contractInterface);
        return _this;
    }
    (0, $kry2a._)(WildcardRunningEvent, [
        {
            key: "prepareEvent",
            value: function prepareEvent(event) {
                var _this = this;
                (0, $3cct3._)((0, $g3d7z._)(WildcardRunningEvent.prototype), "prepareEvent", this).call(this, event);
                try {
                    var parsed = this.interface.parseLog(event);
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                    event.decode = function(data, topics) {
                        return _this.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.args = parsed.args;
                } catch (error) {
                // No matching event
                }
            }
        }
    ]);
    return WildcardRunningEvent;
}($fcd53023be51494b$var$RunningEvent);
var $fcd53023be51494b$export$304faa4fc17528db = /*#__PURE__*/ function _target() {
    function BaseContract(addressOrName, contractInterface, signerOrProvider) {
        var _this = this;
        (0, $978gY._)(this, BaseContract);
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        (0, $2ax4w.defineReadOnly)(this, "interface", (0, $2ax4w.getStatic)(this instanceof BaseContract ? this.constructor : void 0, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            (0, $2ax4w.defineReadOnly)(this, "provider", null);
            (0, $2ax4w.defineReadOnly)(this, "signer", null);
        } else if ((0, $iGUqv.Signer).isSigner(signerOrProvider)) {
            (0, $2ax4w.defineReadOnly)(this, "provider", signerOrProvider.provider || null);
            (0, $2ax4w.defineReadOnly)(this, "signer", signerOrProvider);
        } else if ((0, $lLovk.Provider).isProvider(signerOrProvider)) {
            (0, $2ax4w.defineReadOnly)(this, "provider", signerOrProvider);
            (0, $2ax4w.defineReadOnly)(this, "signer", null);
        } else $fcd53023be51494b$var$logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        (0, $2ax4w.defineReadOnly)(this, "callStatic", {});
        (0, $2ax4w.defineReadOnly)(this, "estimateGas", {});
        (0, $2ax4w.defineReadOnly)(this, "functions", {});
        (0, $2ax4w.defineReadOnly)(this, "populateTransaction", {});
        (0, $2ax4w.defineReadOnly)(this, "filters", {});
        {
            var uniqueFilters = {};
            Object.keys(this.interface.events).forEach(function(eventSignature) {
                var event = _this.interface.events[eventSignature];
                (0, $2ax4w.defineReadOnly)(_this.filters, eventSignature, function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return {
                        address: _this.address,
                        topics: _this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) uniqueFilters[event.name] = [];
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach(function(name) {
                var filters = uniqueFilters[name];
                if (filters.length === 1) (0, $2ax4w.defineReadOnly)(_this.filters, name, _this.filters[filters[0]]);
                else $fcd53023be51494b$var$logger.warn("Duplicate definition of ".concat(name, " (").concat(filters.join(", "), ")"));
            });
        }
        (0, $2ax4w.defineReadOnly)(this, "_runningEvents", {});
        (0, $2ax4w.defineReadOnly)(this, "_wrappedEmits", {});
        if (addressOrName == null) $fcd53023be51494b$var$logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        (0, $2ax4w.defineReadOnly)(this, "address", addressOrName);
        if (this.provider) (0, $2ax4w.defineReadOnly)(this, "resolvedAddress", $fcd53023be51494b$var$resolveName(this.provider, addressOrName));
        else try {
            (0, $2ax4w.defineReadOnly)(this, "resolvedAddress", Promise.resolve((0, $e8NrM.getAddress)(addressOrName)));
        } catch (error) {
            // Without a provider, we cannot use ENS names
            $fcd53023be51494b$var$logger.throwError("provider is required to use ENS name as contract address", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "new Contract"
            });
        }
        // Swallow bad ENS names to prevent Unhandled Exceptions
        this.resolvedAddress.catch(function(e) {});
        var uniqueNames = {};
        var uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach(function(signature) {
            var fragment = _this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                $fcd53023be51494b$var$logger.warn("Duplicate ABI entry for ".concat(JSON.stringify(signature)));
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                var name = fragment.name;
                if (!uniqueNames["%".concat(name)]) uniqueNames["%".concat(name)] = [];
                uniqueNames["%".concat(name)].push(signature);
            }
            if (_this[signature] == null) (0, $2ax4w.defineReadOnly)(_this, signature, $fcd53023be51494b$var$buildDefault(_this, fragment, true));
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (_this.functions[signature] == null) (0, $2ax4w.defineReadOnly)(_this.functions, signature, $fcd53023be51494b$var$buildDefault(_this, fragment, false));
            if (_this.callStatic[signature] == null) (0, $2ax4w.defineReadOnly)(_this.callStatic, signature, $fcd53023be51494b$var$buildCall(_this, fragment, true));
            if (_this.populateTransaction[signature] == null) (0, $2ax4w.defineReadOnly)(_this.populateTransaction, signature, $fcd53023be51494b$var$buildPopulate(_this, fragment));
            if (_this.estimateGas[signature] == null) (0, $2ax4w.defineReadOnly)(_this.estimateGas, signature, $fcd53023be51494b$var$buildEstimate(_this, fragment));
        });
        Object.keys(uniqueNames).forEach(function(name) {
            // Ambiguous names to not get attached as bare names
            var signatures = uniqueNames[name];
            if (signatures.length > 1) return;
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            var signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (_this[name] == null) (0, $2ax4w.defineReadOnly)(_this, name, _this[signature]);
            } catch (e) {}
            if (_this.functions[name] == null) (0, $2ax4w.defineReadOnly)(_this.functions, name, _this.functions[signature]);
            if (_this.callStatic[name] == null) (0, $2ax4w.defineReadOnly)(_this.callStatic, name, _this.callStatic[signature]);
            if (_this.populateTransaction[name] == null) (0, $2ax4w.defineReadOnly)(_this.populateTransaction, name, _this.populateTransaction[signature]);
            if (_this.estimateGas[name] == null) (0, $2ax4w.defineReadOnly)(_this.estimateGas, name, _this.estimateGas[signature]);
        });
    }
    (0, $kry2a._)(BaseContract, [
        {
            // @TODO: Allow timeout?
            key: "deployed",
            value: function deployed() {
                return this._deployed();
            }
        },
        {
            key: "_deployed",
            value: function _deployed(blockTag) {
                var _this = this;
                if (!this._deployedPromise) {
                    // If we were just deployed, we know the transaction we should occur in
                    if (this.deployTransaction) this._deployedPromise = this.deployTransaction.wait().then(function() {
                        return _this;
                    });
                    else // @TODO: Once we allow a timeout to be passed in, we will wait
                    // up to that many blocks for getCode
                    // Otherwise, poll for our code to be deployed
                    this._deployedPromise = this.provider.getCode(this.address, blockTag).then(function(code) {
                        if (code === "0x") $fcd53023be51494b$var$logger.throwError("contract not deployed", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                            contractAddress: _this.address,
                            operation: "getDeployed"
                        });
                        return _this;
                    });
                }
                return this._deployedPromise;
            }
        },
        {
            // @TODO:
            // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
            // @TODO:
            // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
            key: "fallback",
            value: function fallback(overrides) {
                var _this = this;
                if (!this.signer) $fcd53023be51494b$var$logger.throwError("sending a transactions require a signer", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "sendTransaction(fallback)"
                });
                var tx = (0, $2ax4w.shallowCopy)(overrides || {});
                [
                    "from",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == null) return;
                    $fcd53023be51494b$var$logger.throwError("cannot override " + key, (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: key
                    });
                });
                tx.to = this.resolvedAddress;
                return this.deployed().then(function() {
                    return _this.signer.sendTransaction(tx);
                });
            }
        },
        {
            // Reconnect to a different signer or provider
            key: "connect",
            value: function connect(signerOrProvider) {
                if (typeof signerOrProvider === "string") signerOrProvider = new (0, $iGUqv.VoidSigner)(signerOrProvider, this.provider);
                var contract = new this.constructor(this.address, this.interface, signerOrProvider);
                if (this.deployTransaction) (0, $2ax4w.defineReadOnly)(contract, "deployTransaction", this.deployTransaction);
                return contract;
            }
        },
        {
            // Re-attach to a different on-chain instance of this contract
            key: "attach",
            value: function attach(addressOrName) {
                return new this.constructor(addressOrName, this.interface, this.signer || this.provider);
            }
        },
        {
            key: "_normalizeRunningEvent",
            value: function _normalizeRunningEvent(runningEvent) {
                // Already have an instance of this event running; we can re-use it
                if (this._runningEvents[runningEvent.tag]) return this._runningEvents[runningEvent.tag];
                return runningEvent;
            }
        },
        {
            key: "_getRunningEvent",
            value: function _getRunningEvent(eventName) {
                if (typeof eventName === "string") {
                    // Listen for "error" events (if your contract has an error event, include
                    // the full signature to bypass this special event keyword)
                    if (eventName === "error") return this._normalizeRunningEvent(new $fcd53023be51494b$var$ErrorRunningEvent());
                    // Listen for any event that is registered
                    if (eventName === "event") return this._normalizeRunningEvent(new $fcd53023be51494b$var$RunningEvent("event", null));
                    // Listen for any event
                    if (eventName === "*") return this._normalizeRunningEvent(new $fcd53023be51494b$var$WildcardRunningEvent(this.address, this.interface));
                    // Get the event Fragment (throws if ambiguous/unknown event)
                    var fragment = this.interface.getEvent(eventName);
                    return this._normalizeRunningEvent(new $fcd53023be51494b$var$FragmentRunningEvent(this.address, this.interface, fragment));
                }
                // We have topics to filter by...
                if (eventName.topics && eventName.topics.length > 0) {
                    // Is it a known topichash? (throws if no matching topichash)
                    try {
                        var topic = eventName.topics[0];
                        if (typeof topic !== "string") throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                        var fragment1 = this.interface.getEvent(topic);
                        return this._normalizeRunningEvent(new $fcd53023be51494b$var$FragmentRunningEvent(this.address, this.interface, fragment1, eventName.topics));
                    } catch (error) {}
                    // Filter by the unknown topichash
                    var filter = {
                        address: this.address,
                        topics: eventName.topics
                    };
                    return this._normalizeRunningEvent(new $fcd53023be51494b$var$RunningEvent($fcd53023be51494b$var$getEventTag(filter), filter));
                }
                return this._normalizeRunningEvent(new $fcd53023be51494b$var$WildcardRunningEvent(this.address, this.interface));
            }
        },
        {
            key: "_checkRunningEvents",
            value: function _checkRunningEvents(runningEvent) {
                if (runningEvent.listenerCount() === 0) {
                    delete this._runningEvents[runningEvent.tag];
                    // If we have a poller for this, remove it
                    var emit = this._wrappedEmits[runningEvent.tag];
                    if (emit && runningEvent.filter) {
                        this.provider.off(runningEvent.filter, emit);
                        delete this._wrappedEmits[runningEvent.tag];
                    }
                }
            }
        },
        {
            // Subclasses can override this to gracefully recover
            // from parse errors if they wish
            key: "_wrapEvent",
            value: function _wrapEvent(runningEvent, log, listener) {
                var _this = this;
                var event = (0, $2ax4w.deepCopy)(log);
                event.removeListener = function() {
                    if (!listener) return;
                    runningEvent.removeListener(listener);
                    _this._checkRunningEvents(runningEvent);
                };
                event.getBlock = function() {
                    return _this.provider.getBlock(log.blockHash);
                };
                event.getTransaction = function() {
                    return _this.provider.getTransaction(log.transactionHash);
                };
                event.getTransactionReceipt = function() {
                    return _this.provider.getTransactionReceipt(log.transactionHash);
                };
                // This may throw if the topics and data mismatch the signature
                runningEvent.prepareEvent(event);
                return event;
            }
        },
        {
            key: "_addEventListener",
            value: function _addEventListener(runningEvent, listener, once) {
                var _this = this;
                if (!this.provider) $fcd53023be51494b$var$logger.throwError("events require a provider or a signer with a provider", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "once"
                });
                runningEvent.addListener(listener, once);
                // Track this running event and its listeners (may already be there; but no hard in updating)
                this._runningEvents[runningEvent.tag] = runningEvent;
                // If we are not polling the provider, start polling
                if (!this._wrappedEmits[runningEvent.tag]) {
                    var wrappedEmit = function(log) {
                        var event = _this._wrapEvent(runningEvent, log, listener);
                        // Try to emit the result for the parameterized event...
                        if (event.decodeError == null) try {
                            var args = runningEvent.getEmit(event);
                            _this.emit.apply(_this, [
                                runningEvent.filter
                            ].concat((0, $fLnyw._)(args)));
                        } catch (error) {
                            event.decodeError = error.error;
                        }
                        // Always emit "event" for fragment-base events
                        if (runningEvent.filter != null) _this.emit("event", event);
                        // Emit "error" if there was an error
                        if (event.decodeError != null) _this.emit("error", event.decodeError, event);
                    };
                    this._wrappedEmits[runningEvent.tag] = wrappedEmit;
                    // Special events, like "error" do not have a filter
                    if (runningEvent.filter != null) this.provider.on(runningEvent.filter, wrappedEmit);
                }
            }
        },
        {
            key: "queryFilter",
            value: function queryFilter(event, fromBlockOrBlockhash, toBlock) {
                var _this = this;
                var runningEvent = this._getRunningEvent(event);
                var filter = (0, $2ax4w.shallowCopy)(runningEvent.filter);
                if (typeof fromBlockOrBlockhash === "string" && (0, $j2rU8.isHexString)(fromBlockOrBlockhash, 32)) {
                    if (toBlock != null) $fcd53023be51494b$var$logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
                    filter.blockHash = fromBlockOrBlockhash;
                } else {
                    filter.fromBlock = fromBlockOrBlockhash != null ? fromBlockOrBlockhash : 0;
                    filter.toBlock = toBlock != null ? toBlock : "latest";
                }
                return this.provider.getLogs(filter).then(function(logs) {
                    return logs.map(function(log) {
                        return _this._wrapEvent(runningEvent, log, null);
                    });
                });
            }
        },
        {
            key: "on",
            value: function on(event, listener) {
                this._addEventListener(this._getRunningEvent(event), listener, false);
                return this;
            }
        },
        {
            key: "once",
            value: function once(event, listener) {
                this._addEventListener(this._getRunningEvent(event), listener, true);
                return this;
            }
        },
        {
            key: "emit",
            value: function emit(eventName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (!this.provider) return false;
                var runningEvent = this._getRunningEvent(eventName);
                var result = runningEvent.run(args) > 0;
                // May have drained all the "once" events; check for living events
                this._checkRunningEvents(runningEvent);
                return result;
            }
        },
        {
            key: "listenerCount",
            value: function listenerCount(eventName) {
                var _this = this;
                if (!this.provider) return 0;
                if (eventName == null) return Object.keys(this._runningEvents).reduce(function(accum, key) {
                    return accum + _this._runningEvents[key].listenerCount();
                }, 0);
                return this._getRunningEvent(eventName).listenerCount();
            }
        },
        {
            key: "listeners",
            value: function listeners(eventName) {
                if (!this.provider) return [];
                if (eventName == null) {
                    var result = [];
                    for(var tag in this._runningEvents)this._runningEvents[tag].listeners().forEach(function(listener) {
                        result.push(listener);
                    });
                    return result;
                }
                return this._getRunningEvent(eventName).listeners();
            }
        },
        {
            key: "removeAllListeners",
            value: function removeAllListeners(eventName) {
                if (!this.provider) return this;
                if (eventName == null) {
                    for(var tag in this._runningEvents){
                        var runningEvent = this._runningEvents[tag];
                        runningEvent.removeAllListeners();
                        this._checkRunningEvents(runningEvent);
                    }
                    return this;
                }
                // Delete any listeners
                var runningEvent1 = this._getRunningEvent(eventName);
                runningEvent1.removeAllListeners();
                this._checkRunningEvents(runningEvent1);
                return this;
            }
        },
        {
            key: "off",
            value: function off(eventName, listener) {
                if (!this.provider) return this;
                var runningEvent = this._getRunningEvent(eventName);
                runningEvent.removeListener(listener);
                this._checkRunningEvents(runningEvent);
                return this;
            }
        },
        {
            key: "removeListener",
            value: function removeListener(eventName, listener) {
                return this.off(eventName, listener);
            }
        }
    ], [
        {
            key: "getContractAddress",
            value: function getContractAddress1(transaction) {
                return (0, $e8NrM.getContractAddress)(transaction);
            }
        },
        {
            key: "getInterface",
            value: function getInterface(contractInterface) {
                if ((0, $9rkfU.Interface).isInterface(contractInterface)) return contractInterface;
                return new (0, $9rkfU.Interface)(contractInterface);
            }
        },
        {
            key: "isIndexed",
            value: function isIndexed(value) {
                return (0, $9rkfU.Indexed).isIndexed(value);
            }
        }
    ]);
    return BaseContract;
}();
var $fcd53023be51494b$export$8517d80acf00e19a = /*#__PURE__*/ function(BaseContract) {
    (0, $ftJVG._)(Contract, BaseContract);
    var _super = (0, $6OZAO._)(Contract);
    function Contract() {
        (0, $978gY._)(this, Contract);
        return _super.apply(this, arguments);
    }
    return Contract;
}($fcd53023be51494b$export$304faa4fc17528db);
var $fcd53023be51494b$export$505569a6bf584fd9 = /*#__PURE__*/ function _target() {
    function ContractFactory(contractInterface, bytecode, signer) {
        (0, $978gY._)(this, ContractFactory);
        var bytecodeHex = null;
        if (typeof bytecode === "string") bytecodeHex = bytecode;
        else if ((0, $j2rU8.isBytes)(bytecode)) bytecodeHex = (0, $j2rU8.hexlify)(bytecode);
        else if (bytecode && typeof bytecode.object === "string") // Allow the bytecode object from the Solidity compiler
        bytecodeHex = bytecode.object;
        else // Crash in the next verification step
        bytecodeHex = "!";
        // Make sure it is 0x prefixed
        if (bytecodeHex.substring(0, 2) !== "0x") bytecodeHex = "0x" + bytecodeHex;
        // Make sure the final result is valid bytecode
        if (!(0, $j2rU8.isHexString)(bytecodeHex) || bytecodeHex.length % 2) $fcd53023be51494b$var$logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
        // If we have a signer, make sure it is valid
        if (signer && !(0, $iGUqv.Signer).isSigner(signer)) $fcd53023be51494b$var$logger.throwArgumentError("invalid signer", "signer", signer);
        (0, $2ax4w.defineReadOnly)(this, "bytecode", bytecodeHex);
        (0, $2ax4w.defineReadOnly)(this, "interface", (0, $2ax4w.getStatic)(this instanceof ContractFactory ? this.constructor : void 0, "getInterface")(contractInterface));
        (0, $2ax4w.defineReadOnly)(this, "signer", signer || null);
    }
    (0, $kry2a._)(ContractFactory, [
        {
            // @TODO: Future; rename to populateTransaction?
            key: "getDeployTransaction",
            value: function getDeployTransaction() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var tx = {};
                // If we have 1 additional argument, we allow transaction overrides
                if (args.length === this.interface.deploy.inputs.length + 1 && typeof args[args.length - 1] === "object") {
                    tx = (0, $2ax4w.shallowCopy)(args.pop());
                    for(var key in tx){
                        if (!$fcd53023be51494b$var$allowedTransactionKeys[key]) throw new Error("unknown transaction override " + key);
                    }
                }
                // Do not allow these to be overridden in a deployment transaction
                [
                    "data",
                    "from",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == null) return;
                    $fcd53023be51494b$var$logger.throwError("cannot override " + key, (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: key
                    });
                });
                if (tx.value) {
                    var value = (0, $gMArf.BigNumber).from(tx.value);
                    if (!value.isZero() && !this.interface.deploy.payable) $fcd53023be51494b$var$logger.throwError("non-payable constructor cannot override value", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides.value",
                        value: tx.value
                    });
                }
                // Make sure the call matches the constructor signature
                $fcd53023be51494b$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
                // Set the data to the bytecode + the encoded constructor arguments
                tx.data = (0, $j2rU8.hexlify)((0, $j2rU8.concat)([
                    this.bytecode,
                    this.interface.encodeDeploy(args)
                ]));
                return tx;
            }
        },
        {
            key: "deploy",
            value: function deploy() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function() {
                    var overrides, params, unsignedTx, tx, address, contract;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                overrides = {};
                                // If 1 extra parameter was passed in, it contains overrides
                                if (args.length === this.interface.deploy.inputs.length + 1) overrides = args.pop();
                                // Make sure the call matches the constructor signature
                                $fcd53023be51494b$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
                                return [
                                    4,
                                    $fcd53023be51494b$var$resolveAddresses(this.signer, args, this.interface.deploy.inputs)
                                ];
                            case 1:
                                params = _state.sent();
                                params.push(overrides);
                                unsignedTx = this.getDeployTransaction.apply(this, (0, $fLnyw._)(params));
                                return [
                                    4,
                                    this.signer.sendTransaction(unsignedTx)
                                ];
                            case 2:
                                tx = _state.sent();
                                address = (0, $2ax4w.getStatic)(this.constructor, "getContractAddress")(tx);
                                contract = (0, $2ax4w.getStatic)(this.constructor, "getContract")(address, this.interface, this.signer);
                                // Add the modified wait that wraps events
                                $fcd53023be51494b$var$addContractWait(contract, tx);
                                (0, $2ax4w.defineReadOnly)(contract, "deployTransaction", tx);
                                return [
                                    2,
                                    contract
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "attach",
            value: function attach(address) {
                return this.constructor.getContract(address, this.interface, this.signer);
            }
        },
        {
            key: "connect",
            value: function connect(signer) {
                return new this.constructor(this.interface, this.bytecode, signer);
            }
        }
    ], [
        {
            key: "fromSolidity",
            value: function fromSolidity(compilerOutput, signer) {
                if (compilerOutput == null) $fcd53023be51494b$var$logger.throwError("missing compiler output", (0, $6M65e.Logger).errors.MISSING_ARGUMENT, {
                    argument: "compilerOutput"
                });
                if (typeof compilerOutput === "string") compilerOutput = JSON.parse(compilerOutput);
                var abi = compilerOutput.abi;
                var bytecode = null;
                if (compilerOutput.bytecode) bytecode = compilerOutput.bytecode;
                else if (compilerOutput.evm && compilerOutput.evm.bytecode) bytecode = compilerOutput.evm.bytecode;
                return new this(abi, bytecode, signer);
            }
        },
        {
            key: "getInterface",
            value: function getInterface(contractInterface) {
                return $fcd53023be51494b$export$8517d80acf00e19a.getInterface(contractInterface);
            }
        },
        {
            key: "getContractAddress",
            value: function getContractAddress1(tx) {
                return (0, $e8NrM.getContractAddress)(tx);
            }
        },
        {
            key: "getContract",
            value: function getContract(address, contractInterface, signer) {
                return new $fcd53023be51494b$export$8517d80acf00e19a(address, contractInterface, signer);
            }
        }
    ]);
    return ContractFactory;
}();

});
parcelRequire.register("hLRMu", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $cf008b3f8bbab545$export$83d89fbfd8236492; });
var $cf008b3f8bbab545$export$83d89fbfd8236492 = "contracts/5.7.0";

});


parcelRequire.register("3mObr", function(module, exports) {

$parcel$export(module.exports, "AddressZero", function () { return (parcelRequire("5f6Sj")).AddressZero; });
$parcel$export(module.exports, "NegativeOne", function () { return (parcelRequire("f2VSc")).NegativeOne; });
$parcel$export(module.exports, "Zero", function () { return (parcelRequire("f2VSc")).Zero; });
$parcel$export(module.exports, "One", function () { return (parcelRequire("f2VSc")).One; });
$parcel$export(module.exports, "Two", function () { return (parcelRequire("f2VSc")).Two; });
$parcel$export(module.exports, "WeiPerEther", function () { return (parcelRequire("f2VSc")).WeiPerEther; });
$parcel$export(module.exports, "MaxUint256", function () { return (parcelRequire("f2VSc")).MaxUint256; });
$parcel$export(module.exports, "MinInt256", function () { return (parcelRequire("f2VSc")).MinInt256; });
$parcel$export(module.exports, "MaxInt256", function () { return (parcelRequire("f2VSc")).MaxInt256; });
$parcel$export(module.exports, "HashZero", function () { return (parcelRequire("5OvKP")).HashZero; });
$parcel$export(module.exports, "EtherSymbol", function () { return (parcelRequire("kvJKj")).EtherSymbol; });

var $5f6Sj = parcelRequire("5f6Sj");

var $f2VSc = parcelRequire("f2VSc");

var $5OvKP = parcelRequire("5OvKP");

var $kvJKj = parcelRequire("kvJKj");
"use strict";

});
parcelRequire.register("5f6Sj", function(module, exports) {

$parcel$export(module.exports, "AddressZero", function () { return $3d13afb7ba7a6bb7$export$badd13187c087617; });
var $3d13afb7ba7a6bb7$export$badd13187c087617 = "0x0000000000000000000000000000000000000000";

});

parcelRequire.register("kvJKj", function(module, exports) {

$parcel$export(module.exports, "EtherSymbol", function () { return $eeea301a94b49b51$export$c7e79fcb6f8ac048; });
// NFKC (composed)             // (decomposed)
var $eeea301a94b49b51$export$c7e79fcb6f8ac048 = "Ξ"; // "\uD835\uDF63";

});


parcelRequire.register("ldxXU", function(module, exports) {

$parcel$export(module.exports, "getDefaultProvider", function () { return $f72528ab54eeaef8$export$4f77a1d3c1ac6642; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("lLovk")).Provider; });
$parcel$export(module.exports, "BaseProvider", function () { return (parcelRequire("96Por")).BaseProvider; });
$parcel$export(module.exports, "Resolver", function () { return (parcelRequire("96Por")).Resolver; });
$parcel$export(module.exports, "UrlJsonRpcProvider", function () { return (parcelRequire("jLiNX")).UrlJsonRpcProvider; });
$parcel$export(module.exports, "FallbackProvider", function () { return (parcelRequire("h5Sdm")).FallbackProvider; });
$parcel$export(module.exports, "AlchemyProvider", function () { return (parcelRequire("d8HAg")).AlchemyProvider; });
$parcel$export(module.exports, "AlchemyWebSocketProvider", function () { return (parcelRequire("d8HAg")).AlchemyWebSocketProvider; });
$parcel$export(module.exports, "AnkrProvider", function () { return (parcelRequire("4xYP9")).AnkrProvider; });
$parcel$export(module.exports, "CloudflareProvider", function () { return (parcelRequire("cHe68")).CloudflareProvider; });
$parcel$export(module.exports, "EtherscanProvider", function () { return (parcelRequire("8c6ML")).EtherscanProvider; });
$parcel$export(module.exports, "InfuraProvider", function () { return (parcelRequire("eGbhc")).InfuraProvider; });
$parcel$export(module.exports, "InfuraWebSocketProvider", function () { return (parcelRequire("eGbhc")).InfuraWebSocketProvider; });
$parcel$export(module.exports, "JsonRpcProvider", function () { return (parcelRequire("aDPpa")).JsonRpcProvider; });
$parcel$export(module.exports, "JsonRpcBatchProvider", function () { return (parcelRequire("fcnNv")).JsonRpcBatchProvider; });
$parcel$export(module.exports, "NodesmithProvider", function () { return (parcelRequire("7bZQB")).NodesmithProvider; });
$parcel$export(module.exports, "PocketProvider", function () { return (parcelRequire("lc6pB")).PocketProvider; });
$parcel$export(module.exports, "StaticJsonRpcProvider", function () { return (parcelRequire("jLiNX")).StaticJsonRpcProvider; });
$parcel$export(module.exports, "Web3Provider", function () { return (parcelRequire("lh9ZS")).Web3Provider; });
$parcel$export(module.exports, "WebSocketProvider", function () { return (parcelRequire("dCAfX")).WebSocketProvider; });
$parcel$export(module.exports, "IpcProvider", function () { return (parcelRequire("9FSRo")).IpcProvider; });
$parcel$export(module.exports, "JsonRpcSigner", function () { return (parcelRequire("aDPpa")).JsonRpcSigner; });
$parcel$export(module.exports, "getNetwork", function () { return (parcelRequire("1TEfp")).getNetwork; });
$parcel$export(module.exports, "isCommunityResource", function () { return (parcelRequire("f1MgE")).isCommunityResource; });
$parcel$export(module.exports, "isCommunityResourcable", function () { return (parcelRequire("f1MgE")).isCommunityResourcable; });
$parcel$export(module.exports, "showThrottleMessage", function () { return (parcelRequire("f1MgE")).showThrottleMessage; });
$parcel$export(module.exports, "Formatter", function () { return (parcelRequire("f1MgE")).Formatter; });

var $lLovk = parcelRequire("lLovk");

var $1TEfp = parcelRequire("1TEfp");

var $96Por = parcelRequire("96Por");

var $d8HAg = parcelRequire("d8HAg");

var $4xYP9 = parcelRequire("4xYP9");

var $cHe68 = parcelRequire("cHe68");

var $8c6ML = parcelRequire("8c6ML");

var $h5Sdm = parcelRequire("h5Sdm");

var $9FSRo = parcelRequire("9FSRo");

var $eGbhc = parcelRequire("eGbhc");

var $aDPpa = parcelRequire("aDPpa");

var $fcnNv = parcelRequire("fcnNv");

var $7bZQB = parcelRequire("7bZQB");

var $lc6pB = parcelRequire("lc6pB");

var $jLiNX = parcelRequire("jLiNX");

var $lh9ZS = parcelRequire("lh9ZS");

var $dCAfX = parcelRequire("dCAfX");

var $f1MgE = parcelRequire("f1MgE");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");
"use strict";
var $f72528ab54eeaef8$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
////////////////////////
// Helper Functions
function $f72528ab54eeaef8$export$4f77a1d3c1ac6642(network, options) {
    if (network == null) network = "homestead";
    // If passed a URL, figure out the right type of provider based on the scheme
    if (typeof network === "string") {
        // @TODO: Add support for IpcProvider; maybe if it ends in ".ipc"?
        // Handle http and ws (and their secure variants)
        var match = network.match(/^(ws|http)s?:/i);
        if (match) switch(match[1].toLowerCase()){
            case "http":
            case "https":
                return new (0, $aDPpa.JsonRpcProvider)(network);
            case "ws":
            case "wss":
                return new (0, $dCAfX.WebSocketProvider)(network);
            default:
                $f72528ab54eeaef8$var$logger.throwArgumentError("unsupported URL scheme", "network", network);
        }
    }
    var n = (0, $1TEfp.getNetwork)(network);
    if (!n || !n._defaultProvider) $f72528ab54eeaef8$var$logger.throwError("unsupported getDefaultProvider network", (0, $6M65e.Logger).errors.NETWORK_ERROR, {
        operation: "getDefaultProvider",
        network: network
    });
    return n._defaultProvider({
        FallbackProvider: (0, $h5Sdm.FallbackProvider),
        AlchemyProvider: (0, $d8HAg.AlchemyProvider),
        AnkrProvider: (0, $4xYP9.AnkrProvider),
        CloudflareProvider: (0, $cHe68.CloudflareProvider),
        EtherscanProvider: (0, $8c6ML.EtherscanProvider),
        InfuraProvider: (0, $eGbhc.InfuraProvider),
        JsonRpcProvider: (0, $aDPpa.JsonRpcProvider),
        NodesmithProvider: (0, $7bZQB.NodesmithProvider),
        PocketProvider: (0, $lc6pB.PocketProvider),
        Web3Provider: (0, $lh9ZS.Web3Provider),
        IpcProvider: (0, $9FSRo.IpcProvider)
    }, options);
}

});
parcelRequire.register("1TEfp", function(module, exports) {

$parcel$export(module.exports, "getNetwork", function () { return $161a25d62c52de9c$export$7de4970ebfd8206d; });

var $6M65e = parcelRequire("6M65e");

var $aql2M = parcelRequire("aql2M");
"use strict";
var $161a25d62c52de9c$var$logger = new (0, $6M65e.Logger)((0, $aql2M.version));
function $161a25d62c52de9c$var$isRenetworkable(value) {
    return value && typeof value.renetwork === "function";
}
function $161a25d62c52de9c$var$ethDefaultProvider(network) {
    var func = function func(providers, options) {
        if (options == null) options = {};
        var providerList = [];
        if (providers.InfuraProvider && options.infura !== "-") try {
            providerList.push(new providers.InfuraProvider(network, options.infura));
        } catch (error) {}
        if (providers.EtherscanProvider && options.etherscan !== "-") try {
            providerList.push(new providers.EtherscanProvider(network, options.etherscan));
        } catch (error) {}
        if (providers.AlchemyProvider && options.alchemy !== "-") try {
            providerList.push(new providers.AlchemyProvider(network, options.alchemy));
        } catch (error) {}
        if (providers.PocketProvider && options.pocket !== "-") {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            var skip = [
                "goerli",
                "ropsten",
                "rinkeby",
                "sepolia"
            ];
            try {
                var provider = new providers.PocketProvider(network, options.pocket);
                if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
            } catch (error) {}
        }
        if (providers.CloudflareProvider && options.cloudflare !== "-") try {
            providerList.push(new providers.CloudflareProvider(network));
        } catch (error) {}
        if (providers.AnkrProvider && options.ankr !== "-") try {
            var skip1 = [
                "ropsten"
            ];
            var provider1 = new providers.AnkrProvider(network, options.ankr);
            if (provider1.network && skip1.indexOf(provider1.network.name) === -1) providerList.push(provider1);
        } catch (error) {}
        if (providerList.length === 0) return null;
        if (providers.FallbackProvider) {
            var quorum = 1;
            if (options.quorum != null) quorum = options.quorum;
            else if (network === "homestead") quorum = 2;
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function(network) {
        return $161a25d62c52de9c$var$ethDefaultProvider(network);
    };
    return func;
}
function $161a25d62c52de9c$var$etcDefaultProvider(url, network) {
    var func = function func(providers, options) {
        if (providers.JsonRpcProvider) return new providers.JsonRpcProvider(url, network);
        return null;
    };
    func.renetwork = function(network) {
        return $161a25d62c52de9c$var$etcDefaultProvider(url, network);
    };
    return func;
}
var $161a25d62c52de9c$var$homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("homestead")
};
var $161a25d62c52de9c$var$ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("ropsten")
};
var $161a25d62c52de9c$var$classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: $161a25d62c52de9c$var$etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
// See: https://chainlist.org
var $161a25d62c52de9c$var$networks = {
    unspecified: {
        chainId: 0,
        name: "unspecified"
    },
    homestead: $161a25d62c52de9c$var$homestead,
    mainnet: $161a25d62c52de9c$var$homestead,
    morden: {
        chainId: 2,
        name: "morden"
    },
    ropsten: $161a25d62c52de9c$var$ropsten,
    testnet: $161a25d62c52de9c$var$ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("goerli")
    },
    kintsugi: {
        chainId: 1337702,
        name: "kintsugi"
    },
    sepolia: {
        chainId: 11155111,
        name: "sepolia",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("sepolia")
    },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: $161a25d62c52de9c$var$etcDefaultProvider("https://www.ethercluster.com/etc", "classic")
    },
    classicMorden: {
        chainId: 62,
        name: "classicMorden"
    },
    classicMordor: $161a25d62c52de9c$var$classicMordor,
    classicTestnet: $161a25d62c52de9c$var$classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: $161a25d62c52de9c$var$etcDefaultProvider("https://www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: {
        chainId: 100,
        name: "xdai"
    },
    matic: {
        chainId: 137,
        name: "matic",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("matic")
    },
    maticmum: {
        chainId: 80001,
        name: "maticmum"
    },
    optimism: {
        chainId: 10,
        name: "optimism",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("optimism")
    },
    "optimism-kovan": {
        chainId: 69,
        name: "optimism-kovan"
    },
    "optimism-goerli": {
        chainId: 420,
        name: "optimism-goerli"
    },
    arbitrum: {
        chainId: 42161,
        name: "arbitrum"
    },
    "arbitrum-rinkeby": {
        chainId: 421611,
        name: "arbitrum-rinkeby"
    },
    "arbitrum-goerli": {
        chainId: 421613,
        name: "arbitrum-goerli"
    },
    bnb: {
        chainId: 56,
        name: "bnb"
    },
    bnbt: {
        chainId: 97,
        name: "bnbt"
    }
};
function $161a25d62c52de9c$export$7de4970ebfd8206d(network) {
    // No network (null)
    if (network == null) return null;
    if (typeof network === "number") {
        for(var name in $161a25d62c52de9c$var$networks){
            var standard = $161a25d62c52de9c$var$networks[name];
            if (standard.chainId === network) return {
                name: standard.name,
                chainId: standard.chainId,
                ensAddress: standard.ensAddress || null,
                _defaultProvider: standard._defaultProvider || null
            };
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof network === "string") {
        var standard1 = $161a25d62c52de9c$var$networks[network];
        if (standard1 == null) return null;
        return {
            name: standard1.name,
            chainId: standard1.chainId,
            ensAddress: standard1.ensAddress,
            _defaultProvider: standard1._defaultProvider || null
        };
    }
    var standard2 = $161a25d62c52de9c$var$networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard2) {
        if (typeof network.chainId !== "number") $161a25d62c52de9c$var$logger.throwArgumentError("invalid network chainId", "network", network);
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard2.chainId) $161a25d62c52de9c$var$logger.throwArgumentError("network chainId mismatch", "network", network);
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    var defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard2._defaultProvider) {
        if ($161a25d62c52de9c$var$isRenetworkable(standard2._defaultProvider)) defaultProvider = standard2._defaultProvider.renetwork(network);
        else defaultProvider = standard2._defaultProvider;
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard2.chainId,
        ensAddress: network.ensAddress || standard2.ensAddress || null,
        _defaultProvider: defaultProvider
    };
}

});
parcelRequire.register("aql2M", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $796ca7f59363f800$export$83d89fbfd8236492; });
var $796ca7f59363f800$export$83d89fbfd8236492 = "networks/5.7.1";

});


parcelRequire.register("96Por", function(module, exports) {

$parcel$export(module.exports, "Resolver", function () { return $6a1c8a35900dd937$export$8b4c839865b08288; });
$parcel$export(module.exports, "BaseProvider", function () { return $6a1c8a35900dd937$export$ff3f6dd83125ac45; });

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $lLovk = parcelRequire("lLovk");

var $70PIu = parcelRequire("70PIu");

var $ebtr5 = parcelRequire("ebtr5");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $5OvKP = parcelRequire("5OvKP");

var $4JdI5 = parcelRequire("4JdI5");

var $1TEfp = parcelRequire("1TEfp");

var $2ax4w = parcelRequire("2ax4w");

var $7WUQV = parcelRequire("7WUQV");

var $1Wmc7 = parcelRequire("1Wmc7");

var $gqL7R = parcelRequire("gqL7R");

var $guCs7 = parcelRequire("guCs7");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");

var $f1MgE = parcelRequire("f1MgE");
"use strict";
var $6a1c8a35900dd937$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6a1c8a35900dd937$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
var $6a1c8a35900dd937$var$MAX_CCIP_REDIRECTS = 10;
//////////////////////////////
// Event Serializeing
function $6a1c8a35900dd937$var$checkTopic(topic) {
    if (topic == null) return "null";
    if ((0, $j2rU8.hexDataLength)(topic) !== 32) $6a1c8a35900dd937$var$logger.throwArgumentError("invalid topic", "topic", topic);
    return topic.toLowerCase();
}
function $6a1c8a35900dd937$var$serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while(topics.length > 0 && topics[topics.length - 1] == null)topics.pop();
    return topics.map(function(topic) {
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            var unique = {};
            topic.forEach(function(topic) {
                unique[$6a1c8a35900dd937$var$checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            var sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        } else return $6a1c8a35900dd937$var$checkTopic(topic);
    }).join("&");
}
function $6a1c8a35900dd937$var$deserializeTopics(data) {
    if (data === "") return [];
    return data.split(/&/g).map(function(topic) {
        if (topic === "") return [];
        var comps = topic.split("|").map(function(topic) {
            return topic === "null" ? null : topic;
        });
        return comps.length === 1 ? comps[0] : comps;
    });
}
function $6a1c8a35900dd937$var$getEventTag(eventName) {
    if (typeof eventName === "string") {
        eventName = eventName.toLowerCase();
        if ((0, $j2rU8.hexDataLength)(eventName) === 32) return "tx:" + eventName;
        if (eventName.indexOf(":") === -1) return eventName;
    } else if (Array.isArray(eventName)) return "filter:*:" + $6a1c8a35900dd937$var$serializeTopics(eventName);
    else if ((0, $lLovk.ForkEvent).isForkEvent(eventName)) {
        $6a1c8a35900dd937$var$logger.warn("not implemented");
        throw new Error("not implemented");
    } else if (eventName && typeof eventName === "object") return "filter:" + (eventName.address || "*") + ":" + $6a1c8a35900dd937$var$serializeTopics(eventName.topics || []);
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function $6a1c8a35900dd937$var$getTime() {
    return new Date().getTime();
}
function $6a1c8a35900dd937$var$stall(duration) {
    return new Promise(function(resolve) {
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */ var $6a1c8a35900dd937$var$PollableEvents = [
    "block",
    "network",
    "pending",
    "poll"
];
var $6a1c8a35900dd937$export$d61e24a684f9e51 = /*#__PURE__*/ function() {
    function Event(tag, listener, once) {
        (0, $978gY._)(this, Event);
        (0, $2ax4w.defineReadOnly)(this, "tag", tag);
        (0, $2ax4w.defineReadOnly)(this, "listener", listener);
        (0, $2ax4w.defineReadOnly)(this, "once", once);
        this._lastBlockNumber = -2;
        this._inflight = false;
    }
    (0, $kry2a._)(Event, [
        {
            key: "event",
            get: function get() {
                switch(this.type){
                    case "tx":
                        return this.hash;
                    case "filter":
                        return this.filter;
                }
                return this.tag;
            }
        },
        {
            key: "type",
            get: function get() {
                return this.tag.split(":")[0];
            }
        },
        {
            key: "hash",
            get: function get() {
                var comps = this.tag.split(":");
                if (comps[0] !== "tx") return null;
                return comps[1];
            }
        },
        {
            key: "filter",
            get: function get() {
                var comps = this.tag.split(":");
                if (comps[0] !== "filter") return null;
                var address = comps[1];
                var topics = $6a1c8a35900dd937$var$deserializeTopics(comps[2]);
                var filter = {};
                if (topics.length > 0) filter.topics = topics;
                if (address && address !== "*") filter.address = address;
                return filter;
            }
        },
        {
            key: "pollable",
            value: function pollable() {
                return this.tag.indexOf(":") >= 0 || $6a1c8a35900dd937$var$PollableEvents.indexOf(this.tag) >= 0;
            }
        }
    ]);
    return Event;
}();
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
var $6a1c8a35900dd937$var$coinInfos = {
    "0": {
        symbol: "btc",
        p2pkh: 0x00,
        p2sh: 0x05,
        prefix: "bc"
    },
    "2": {
        symbol: "ltc",
        p2pkh: 0x30,
        p2sh: 0x32,
        prefix: "ltc"
    },
    "3": {
        symbol: "doge",
        p2pkh: 0x1e,
        p2sh: 0x16
    },
    "60": {
        symbol: "eth",
        ilk: "eth"
    },
    "61": {
        symbol: "etc",
        ilk: "eth"
    },
    "700": {
        symbol: "xdai",
        ilk: "eth"
    }
};
function $6a1c8a35900dd937$var$bytes32ify(value) {
    return (0, $j2rU8.hexZeroPad)((0, $gMArf.BigNumber).from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function $6a1c8a35900dd937$var$base58Encode(data) {
    return (0, $ebtr5.Base58).encode((0, $j2rU8.concat)([
        data,
        (0, $j2rU8.hexDataSlice)((0, $7WUQV.sha256)((0, $7WUQV.sha256)(data)), 0, 4)
    ]));
}
var $6a1c8a35900dd937$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
var $6a1c8a35900dd937$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $6a1c8a35900dd937$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function $6a1c8a35900dd937$var$_parseString(result, start) {
    try {
        return (0, $1Wmc7.toUtf8String)($6a1c8a35900dd937$var$_parseBytes(result, start));
    } catch (error) {}
    return null;
}
function $6a1c8a35900dd937$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    var offset = (0, $gMArf.BigNumber).from((0, $j2rU8.hexDataSlice)(result, start, start + 32)).toNumber();
    var length = (0, $gMArf.BigNumber).from((0, $j2rU8.hexDataSlice)(result, offset, offset + 32)).toNumber();
    return (0, $j2rU8.hexDataSlice)(result, offset + 32, offset + 32 + length);
}
// Trim off the ipfs:// prefix and return the default gateway URL
function $6a1c8a35900dd937$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else $6a1c8a35900dd937$var$logger.throwArgumentError("unsupported IPFS format", "link", link);
    return "https://gateway.ipfs.io/ipfs/".concat(link);
}
function $6a1c8a35900dd937$var$numPad(value) {
    var result = (0, $j2rU8.arrayify)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    var padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $6a1c8a35900dd937$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    var result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
// ABI Encodes a series of (bytes, bytes, ...)
function $6a1c8a35900dd937$var$encodeBytes(datas) {
    var result = [];
    var byteCount = 0;
    // Add place-holders for pointers as we add items
    for(var i = 0; i < datas.length; i++){
        result.push(null);
        byteCount += 32;
    }
    for(var i1 = 0; i1 < datas.length; i1++){
        var data = (0, $j2rU8.arrayify)(datas[i1]);
        // Update the bytes offset
        result[i1] = $6a1c8a35900dd937$var$numPad(byteCount);
        // The length and padded value of data
        result.push($6a1c8a35900dd937$var$numPad(data.length));
        result.push($6a1c8a35900dd937$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $j2rU8.hexConcat)(result);
}
var $6a1c8a35900dd937$export$8b4c839865b08288 = /*#__PURE__*/ function() {
    function Resolver(provider, address, name, resolvedAddress) {
        (0, $978gY._)(this, Resolver);
        (0, $2ax4w.defineReadOnly)(this, "provider", provider);
        (0, $2ax4w.defineReadOnly)(this, "name", name);
        (0, $2ax4w.defineReadOnly)(this, "address", provider.formatter.address(address));
        (0, $2ax4w.defineReadOnly)(this, "_resolvedAddress", resolvedAddress);
    }
    (0, $kry2a._)(Resolver, [
        {
            key: "supportsWildcard",
            value: function supportsWildcard() {
                var _this = this;
                if (!this._supportsEip2544) // supportsInterface(bytes4 = selector("resolve(bytes,bytes)"))
                this._supportsEip2544 = this.provider.call({
                    to: this.address,
                    data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
                }).then(function(result) {
                    return (0, $gMArf.BigNumber).from(result).eq(1);
                }).catch(function(error) {
                    if (error.code === (0, $6M65e.Logger).errors.CALL_EXCEPTION) return false;
                    // Rethrow the error: link is down, etc. Let future attempts retry.
                    _this._supportsEip2544 = null;
                    throw error;
                });
                return this._supportsEip2544;
            }
        },
        {
            key: "_fetch",
            value: function _fetch(selector, parameters) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var tx, parseBytes, result, error;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                tx = {
                                    to: this.address,
                                    ccipReadEnabled: true,
                                    data: (0, $j2rU8.hexConcat)([
                                        selector,
                                        (0, $4JdI5.namehash)(this.name),
                                        parameters || "0x"
                                    ])
                                };
                                parseBytes = false;
                                return [
                                    4,
                                    this.supportsWildcard()
                                ];
                            case 1:
                                if (_state.sent()) {
                                    parseBytes = true;
                                    // selector("resolve(bytes,bytes)")
                                    tx.data = (0, $j2rU8.hexConcat)([
                                        "0x9061b923",
                                        $6a1c8a35900dd937$var$encodeBytes([
                                            (0, $4JdI5.dnsEncode)(this.name),
                                            tx.data
                                        ])
                                    ]);
                                }
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    this.provider.call(tx)
                                ];
                            case 3:
                                result = _state.sent();
                                if ((0, $j2rU8.arrayify)(result).length % 32 === 4) $6a1c8a35900dd937$var$logger.throwError("resolver threw error", (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
                                    transaction: tx,
                                    data: result
                                });
                                if (parseBytes) result = $6a1c8a35900dd937$var$_parseBytes(result, 0);
                                return [
                                    2,
                                    result
                                ];
                            case 4:
                                error = _state.sent();
                                if (error.code === (0, $6M65e.Logger).errors.CALL_EXCEPTION) return [
                                    2,
                                    null
                                ];
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_fetchBytes",
            value: function _fetchBytes(selector, parameters) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._fetch(selector, parameters)
                                ];
                            case 1:
                                result = _state.sent();
                                if (result != null) return [
                                    2,
                                    $6a1c8a35900dd937$var$_parseBytes(result, 0)
                                ];
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getAddress",
            value: function _getAddress(coinType, hexBytes) {
                var coinInfo = $6a1c8a35900dd937$var$coinInfos[String(coinType)];
                if (coinInfo == null) $6a1c8a35900dd937$var$logger.throwError("unsupported coin type: ".concat(coinType), (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "getAddress(".concat(coinType, ")")
                });
                if (coinInfo.ilk === "eth") return this.provider.formatter.address(hexBytes);
                var bytes = (0, $j2rU8.arrayify)(hexBytes);
                // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
                if (coinInfo.p2pkh != null) {
                    var p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
                    if (p2pkh) {
                        var length = parseInt(p2pkh[1], 16);
                        if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) return $6a1c8a35900dd937$var$base58Encode((0, $j2rU8.concat)([
                            [
                                coinInfo.p2pkh
                            ],
                            "0x" + p2pkh[2]
                        ]));
                    }
                }
                // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
                if (coinInfo.p2sh != null) {
                    var p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
                    if (p2sh) {
                        var length1 = parseInt(p2sh[1], 16);
                        if (p2sh[2].length === length1 * 2 && length1 >= 1 && length1 <= 75) return $6a1c8a35900dd937$var$base58Encode((0, $j2rU8.concat)([
                            [
                                coinInfo.p2sh
                            ],
                            "0x" + p2sh[2]
                        ]));
                    }
                }
                // Bech32
                if (coinInfo.prefix != null) {
                    var length2 = bytes[1];
                    // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
                    var _$version = bytes[0];
                    if (_$version === 0x00) {
                        if (length2 !== 20 && length2 !== 32) _$version = -1;
                    } else _$version = -1;
                    if (_$version >= 0 && bytes.length === 2 + length2 && length2 >= 1 && length2 <= 75) {
                        var words = (0, (/*@__PURE__*/$parcel$interopDefault($guCs7))).toWords(bytes.slice(2));
                        words.unshift(_$version);
                        return (0, (/*@__PURE__*/$parcel$interopDefault($guCs7))).encode(coinInfo.prefix, words);
                    }
                }
                return null;
            }
        },
        {
            key: "getAddress",
            value: function getAddress(coinType) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var result, error, hexBytes, address;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (coinType == null) coinType = 60;
                                if (!(coinType === 60)) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this._fetch("0x3b3b57de")
                                ];
                            case 2:
                                result = _state.sent();
                                // No address
                                if (result === "0x" || result === (0, $5OvKP.HashZero)) return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    this.provider.formatter.callAddress(result)
                                ];
                            case 3:
                                error = _state.sent();
                                if (error.code === (0, $6M65e.Logger).errors.CALL_EXCEPTION) return [
                                    2,
                                    null
                                ];
                                throw error;
                            case 4:
                                return [
                                    4,
                                    this._fetchBytes("0xf1cb7e06", $6a1c8a35900dd937$var$bytes32ify(coinType))
                                ];
                            case 5:
                                hexBytes = _state.sent();
                                // No address
                                if (hexBytes == null || hexBytes === "0x") return [
                                    2,
                                    null
                                ];
                                address = this._getAddress(coinType, hexBytes);
                                if (address == null) $6a1c8a35900dd937$var$logger.throwError("invalid or unsupported coin data", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                                    operation: "getAddress(".concat(coinType, ")"),
                                    coinType: coinType,
                                    data: hexBytes
                                });
                                return [
                                    2,
                                    address
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getAvatar",
            value: function getAvatar() {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var linkage, avatar, i, match, scheme, selector, owner, _tmp, comps, addr, tokenId, tokenOwner, _, _1, balance, _2, tx, metadataUrl, metadata, imageUrl, ipfs, error;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                linkage = [
                                    {
                                        type: "name",
                                        content: this.name
                                    }
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    19,
                                    ,
                                    20
                                ]);
                                return [
                                    4,
                                    this.getText("avatar")
                                ];
                            case 2:
                                avatar = _state.sent();
                                if (avatar == null) return [
                                    2,
                                    null
                                ];
                                i = 0;
                                _state.label = 3;
                            case 3:
                                if (!(i < $6a1c8a35900dd937$var$matchers.length)) return [
                                    3,
                                    18
                                ];
                                match = avatar.match($6a1c8a35900dd937$var$matchers[i]);
                                if (match == null) return [
                                    3,
                                    17
                                ];
                                scheme = match[1].toLowerCase();
                                switch(scheme){
                                    case "https":
                                        return [
                                            3,
                                            4
                                        ];
                                    case "data":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "ipfs":
                                        return [
                                            3,
                                            6
                                        ];
                                    case "erc721":
                                        return [
                                            3,
                                            7
                                        ];
                                    case "erc1155":
                                        return [
                                            3,
                                            7
                                        ];
                                }
                                return [
                                    3,
                                    17
                                ];
                            case 4:
                                linkage.push({
                                    type: "url",
                                    content: avatar
                                });
                                return [
                                    2,
                                    {
                                        linkage: linkage,
                                        url: avatar
                                    }
                                ];
                            case 5:
                                linkage.push({
                                    type: "data",
                                    content: avatar
                                });
                                return [
                                    2,
                                    {
                                        linkage: linkage,
                                        url: avatar
                                    }
                                ];
                            case 6:
                                linkage.push({
                                    type: "ipfs",
                                    content: avatar
                                });
                                return [
                                    2,
                                    {
                                        linkage: linkage,
                                        url: $6a1c8a35900dd937$var$getIpfsLink(avatar)
                                    }
                                ];
                            case 7:
                                selector = scheme === "erc721" ? "0xc87b56dd" : "0x0e89341c";
                                linkage.push({
                                    type: scheme,
                                    content: avatar
                                });
                                _tmp = this._resolvedAddress;
                                if (_tmp) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    this.getAddress()
                                ];
                            case 8:
                                _tmp = _state.sent();
                                _state.label = 9;
                            case 9:
                                owner = _tmp;
                                comps = (match[2] || "").split("/");
                                if (comps.length !== 2) return [
                                    2,
                                    null
                                ];
                                return [
                                    4,
                                    this.provider.formatter.address(comps[0])
                                ];
                            case 10:
                                addr = _state.sent();
                                tokenId = (0, $j2rU8.hexZeroPad)((0, $gMArf.BigNumber).from(comps[1]).toHexString(), 32);
                                if (!(scheme === "erc721")) return [
                                    3,
                                    12
                                ];
                                _1 = (_ = this.provider.formatter).callAddress;
                                return [
                                    4,
                                    this.provider.call({
                                        to: addr,
                                        data: (0, $j2rU8.hexConcat)([
                                            "0x6352211e",
                                            tokenId
                                        ])
                                    })
                                ];
                            case 11:
                                tokenOwner = _1.apply(_, [
                                    _state.sent()
                                ]);
                                if (owner !== tokenOwner) return [
                                    2,
                                    null
                                ];
                                linkage.push({
                                    type: "owner",
                                    content: tokenOwner
                                });
                                return [
                                    3,
                                    14
                                ];
                            case 12:
                                if (!(scheme === "erc1155")) return [
                                    3,
                                    14
                                ];
                                _2 = (0, $gMArf.BigNumber).from;
                                return [
                                    4,
                                    this.provider.call({
                                        to: addr,
                                        data: (0, $j2rU8.hexConcat)([
                                            "0x00fdd58e",
                                            (0, $j2rU8.hexZeroPad)(owner, 32),
                                            tokenId
                                        ])
                                    })
                                ];
                            case 13:
                                balance = _2.apply((0, $gMArf.BigNumber), [
                                    _state.sent()
                                ]);
                                if (balance.isZero()) return [
                                    2,
                                    null
                                ];
                                linkage.push({
                                    type: "balance",
                                    content: balance.toString()
                                });
                                _state.label = 14;
                            case 14:
                                tx = {
                                    to: this.provider.formatter.address(comps[0]),
                                    data: (0, $j2rU8.hexConcat)([
                                        selector,
                                        tokenId
                                    ])
                                };
                                return [
                                    4,
                                    this.provider.call(tx)
                                ];
                            case 15:
                                metadataUrl = $6a1c8a35900dd937$var$_parseString.apply(void 0, [
                                    _state.sent(),
                                    0
                                ]);
                                if (metadataUrl == null) return [
                                    2,
                                    null
                                ];
                                linkage.push({
                                    type: "metadata-url-base",
                                    content: metadataUrl
                                });
                                // ERC-1155 allows a generic {id} in the URL
                                if (scheme === "erc1155") {
                                    metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                    linkage.push({
                                        type: "metadata-url-expanded",
                                        content: metadataUrl
                                    });
                                }
                                // Transform IPFS metadata links
                                if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $6a1c8a35900dd937$var$getIpfsLink(metadataUrl);
                                linkage.push({
                                    type: "metadata-url",
                                    content: metadataUrl
                                });
                                return [
                                    4,
                                    (0, $gqL7R.fetchJson)(metadataUrl)
                                ];
                            case 16:
                                metadata = _state.sent();
                                if (!metadata) return [
                                    2,
                                    null
                                ];
                                linkage.push({
                                    type: "metadata",
                                    content: JSON.stringify(metadata)
                                });
                                imageUrl = metadata.image;
                                if (typeof imageUrl !== "string") return [
                                    2,
                                    null
                                ];
                                if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                                else {
                                    ipfs = imageUrl.match($6a1c8a35900dd937$var$matcherIpfs);
                                    if (ipfs == null) return [
                                        2,
                                        null
                                    ];
                                    linkage.push({
                                        type: "url-ipfs",
                                        content: imageUrl
                                    });
                                    imageUrl = $6a1c8a35900dd937$var$getIpfsLink(imageUrl);
                                }
                                linkage.push({
                                    type: "url",
                                    content: imageUrl
                                });
                                return [
                                    2,
                                    {
                                        linkage: linkage,
                                        url: imageUrl
                                    }
                                ];
                            case 17:
                                i++;
                                return [
                                    3,
                                    3
                                ];
                            case 18:
                                return [
                                    3,
                                    20
                                ];
                            case 19:
                                error = _state.sent();
                                return [
                                    3,
                                    20
                                ];
                            case 20:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getContentHash",
            value: function getContentHash() {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var hexBytes, ipfs, length, ipns, length1, swarm, skynet, urlSafe, hash;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._fetchBytes("0xbc1c58d1")
                                ];
                            case 1:
                                hexBytes = _state.sent();
                                // No contenthash
                                if (hexBytes == null || hexBytes === "0x") return [
                                    2,
                                    null
                                ];
                                ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
                                if (ipfs) {
                                    length = parseInt(ipfs[3], 16);
                                    if (ipfs[4].length === length * 2) return [
                                        2,
                                        "ipfs://" + (0, $ebtr5.Base58).encode("0x" + ipfs[1])
                                    ];
                                }
                                ipns = hexBytes.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
                                if (ipns) {
                                    length1 = parseInt(ipns[3], 16);
                                    if (ipns[4].length === length1 * 2) return [
                                        2,
                                        "ipns://" + (0, $ebtr5.Base58).encode("0x" + ipns[1])
                                    ];
                                }
                                swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
                                if (swarm) {
                                    if (swarm[1].length === 64) return [
                                        2,
                                        "bzz://" + swarm[1]
                                    ];
                                }
                                skynet = hexBytes.match(/^0x90b2c605([0-9a-f]*)$/);
                                if (skynet) {
                                    if (skynet[1].length === 68) {
                                        urlSafe = {
                                            "=": "",
                                            "+": "-",
                                            "/": "_"
                                        };
                                        hash = (0, $70PIu.encode)("0x" + skynet[1]).replace(/[=+\/]/g, function(a) {
                                            return urlSafe[a];
                                        });
                                        return [
                                            2,
                                            "sia://" + hash
                                        ];
                                    }
                                }
                                return [
                                    2,
                                    $6a1c8a35900dd937$var$logger.throwError("invalid or unsupported content hash data", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                                        operation: "getContentHash()",
                                        data: hexBytes
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getText",
            value: function getText(key) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var keyBytes, hexBytes;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                keyBytes = (0, $1Wmc7.toUtf8Bytes)(key);
                                // The nodehash consumes the first slot, so the string pointer targets
                                // offset 64, with the length at offset 64 and data starting at offset 96
                                keyBytes = (0, $j2rU8.concat)([
                                    $6a1c8a35900dd937$var$bytes32ify(64),
                                    $6a1c8a35900dd937$var$bytes32ify(keyBytes.length),
                                    keyBytes
                                ]);
                                // Pad to word-size (32 bytes)
                                if (keyBytes.length % 32 !== 0) keyBytes = (0, $j2rU8.concat)([
                                    keyBytes,
                                    (0, $j2rU8.hexZeroPad)("0x", 32 - key.length % 32)
                                ]);
                                return [
                                    4,
                                    this._fetchBytes("0x59d1d43c", (0, $j2rU8.hexlify)(keyBytes))
                                ];
                            case 1:
                                hexBytes = _state.sent();
                                if (hexBytes == null || hexBytes === "0x") return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    (0, $1Wmc7.toUtf8String)(hexBytes)
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return Resolver;
}();
var $6a1c8a35900dd937$var$defaultFormatter = null;
var $6a1c8a35900dd937$var$nextPollId = 1;
var $6a1c8a35900dd937$export$ff3f6dd83125ac45 = /*#__PURE__*/ function _target(Provider) {
    (0, $ftJVG._)(BaseProvider, Provider);
    var _super = (0, $6OZAO._)(BaseProvider);
    function BaseProvider(network) {
        (0, $978gY._)(this, BaseProvider);
        var _this;
        _this = _super.call(this);
        // Events being listened to
        _this._events = [];
        _this._emitted = {
            block: -2
        };
        _this.disableCcipRead = false;
        _this.formatter = (this instanceof BaseProvider ? this.constructor : void 0).getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "anyNetwork", network === "any");
        if (_this.anyNetwork) network = _this.detectNetwork();
        if (network instanceof Promise) {
            _this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch(function(error) {});
            // Trigger initial network setting (async)
            _this._ready().catch(function(error) {});
        } else {
            var knownNetwork = (0, $2ax4w.getStatic)(this instanceof BaseProvider ? this.constructor : void 0, "getNetwork")(network);
            if (knownNetwork) {
                (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_network", knownNetwork);
                _this.emit("network", knownNetwork, null);
            } else $6a1c8a35900dd937$var$logger.throwArgumentError("invalid network", "network", network);
        }
        _this._maxInternalBlockNumber = -1024;
        _this._lastBlockNumber = -2;
        _this._maxFilterBlockRange = 10;
        _this._pollingInterval = 4000;
        _this._fastQueryDate = 0;
        return _this;
    }
    (0, $kry2a._)(BaseProvider, [
        {
            key: "_ready",
            value: function _ready() {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var network, error;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(this._network == null)) return [
                                    3,
                                    7
                                ];
                                network = null;
                                if (!this._networkPromise) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this._networkPromise
                                ];
                            case 2:
                                network = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                if (!(network == null)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    this.detectNetwork()
                                ];
                            case 5:
                                network = _state.sent();
                                _state.label = 6;
                            case 6:
                                // This should never happen; every Provider sub-class should have
                                // suggested a network by here (or have thrown).
                                if (!network) $6a1c8a35900dd937$var$logger.throwError("no network detected", (0, $6M65e.Logger).errors.UNKNOWN_ERROR, {});
                                // Possible this call stacked so do not call defineReadOnly again
                                if (this._network == null) {
                                    if (this.anyNetwork) this._network = network;
                                    else (0, $2ax4w.defineReadOnly)(this, "_network", network);
                                    this.emit("network", network, null);
                                }
                                _state.label = 7;
                            case 7:
                                return [
                                    2,
                                    this._network
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "ready",
            get: // This will always return the most recently established network.
            // For "any", this can change (a "network" event is emitted before
            // any change is reflected); otherwise this cannot change
            function get() {
                var _this = this;
                return (0, $gqL7R.poll)(function() {
                    return _this._ready().then(function(network) {
                        return network;
                    }, function(error) {
                        // If the network isn't running yet, we will wait
                        if (error.code === (0, $6M65e.Logger).errors.NETWORK_ERROR && error.event === "noNetwork") return undefined;
                        throw error;
                    });
                });
            }
        },
        {
            key: "ccipReadFetch",
            value: function ccipReadFetch(tx, calldata, urls) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var sender, data, errorMessages, i, url, href, json, result, errorMessage;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (this.disableCcipRead || urls.length === 0) return [
                                    2,
                                    null
                                ];
                                sender = tx.to.toLowerCase();
                                data = calldata.toLowerCase();
                                errorMessages = [];
                                i = 0;
                                _state.label = 1;
                            case 1:
                                if (!(i < urls.length)) return [
                                    3,
                                    4
                                ];
                                url = urls[i];
                                href = url.replace("{sender}", sender).replace("{data}", data);
                                json = url.indexOf("{data}") >= 0 ? null : JSON.stringify({
                                    data: data,
                                    sender: sender
                                });
                                return [
                                    4,
                                    (0, $gqL7R.fetchJson)({
                                        url: href,
                                        errorPassThrough: true
                                    }, json, function(value, response) {
                                        value.status = response.statusCode;
                                        return value;
                                    })
                                ];
                            case 2:
                                result = _state.sent();
                                if (result.data) return [
                                    2,
                                    result.data
                                ];
                                errorMessage = result.message || "unknown error";
                                // 4xx indicates the result is not present; stop
                                if (result.status >= 400 && result.status < 500) return [
                                    2,
                                    $6a1c8a35900dd937$var$logger.throwError("response not found during CCIP fetch: ".concat(errorMessage), (0, $6M65e.Logger).errors.SERVER_ERROR, {
                                        url: url,
                                        errorMessage: errorMessage
                                    })
                                ];
                                // 5xx indicates server issue; try the next url
                                errorMessages.push(errorMessage);
                                _state.label = 3;
                            case 3:
                                i++;
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                return [
                                    2,
                                    $6a1c8a35900dd937$var$logger.throwError("error encountered during CCIP fetch: ".concat(errorMessages.map(function(m) {
                                        return JSON.stringify(m);
                                    }).join(", ")), (0, $6M65e.Logger).errors.SERVER_ERROR, {
                                        urls: urls,
                                        errorMessages: errorMessages
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            // Fetches the blockNumber, but will reuse any result that is less
            // than maxAge old or has been requested since the last request
            key: "_getInternalBlockNumber",
            value: function _getInternalBlockNumber(maxAge) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var _this, internalBlockNumber, result, error, reqTime, checkInternalBlockNumber;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this._ready()
                                ];
                            case 1:
                                _state.sent();
                                if (!(maxAge > 0)) return [
                                    3,
                                    7
                                ];
                                _state.label = 2;
                            case 2:
                                if (!this._internalBlockNumber) return [
                                    3,
                                    7
                                ];
                                internalBlockNumber = this._internalBlockNumber;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    internalBlockNumber
                                ];
                            case 4:
                                result = _state.sent();
                                if ($6a1c8a35900dd937$var$getTime() - result.respTime <= maxAge) return [
                                    2,
                                    result.blockNumber
                                ];
                                // Too old; fetch a new value
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                error = _state.sent();
                                // The fetch rejected; if we are the first to get the
                                // rejection, drop through so we replace it with a new
                                // fetch; all others blocked will then get that fetch
                                // which won't match the one they "remembered" and loop
                                if (this._internalBlockNumber === internalBlockNumber) return [
                                    3,
                                    7
                                ];
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    3,
                                    2
                                ];
                            case 7:
                                reqTime = $6a1c8a35900dd937$var$getTime();
                                checkInternalBlockNumber = (0, $2ax4w.resolveProperties)({
                                    blockNumber: this.perform("getBlockNumber", {}),
                                    networkError: this.getNetwork().then(function(network) {
                                        return null;
                                    }, function(error) {
                                        return error;
                                    })
                                }).then(function(param) {
                                    var blockNumber = param.blockNumber, networkError = param.networkError;
                                    if (networkError) {
                                        // Unremember this bad internal block number
                                        if (_this._internalBlockNumber === checkInternalBlockNumber) _this._internalBlockNumber = null;
                                        throw networkError;
                                    }
                                    var respTime = $6a1c8a35900dd937$var$getTime();
                                    blockNumber = (0, $gMArf.BigNumber).from(blockNumber).toNumber();
                                    if (blockNumber < _this._maxInternalBlockNumber) blockNumber = _this._maxInternalBlockNumber;
                                    _this._maxInternalBlockNumber = blockNumber;
                                    _this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                                    return {
                                        blockNumber: blockNumber,
                                        reqTime: reqTime,
                                        respTime: respTime
                                    };
                                });
                                this._internalBlockNumber = checkInternalBlockNumber;
                                // Swallow unhandled exceptions; if needed they are handled else where
                                checkInternalBlockNumber.catch(function(error) {
                                    // Don't null the dead (rejected) fetch, if it has already been updated
                                    if (_this._internalBlockNumber === checkInternalBlockNumber) _this._internalBlockNumber = null;
                                });
                                return [
                                    4,
                                    checkInternalBlockNumber
                                ];
                            case 8:
                                return [
                                    2,
                                    _state.sent().blockNumber
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "poll",
            value: function poll() {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var _this, pollId, runners, blockNumber, error, i;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                pollId = $6a1c8a35900dd937$var$nextPollId++;
                                runners = [];
                                blockNumber = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this._getInternalBlockNumber(100 + this.pollingInterval / 2)
                                ];
                            case 2:
                                blockNumber = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                this.emit("error", error);
                                return [
                                    2
                                ];
                            case 4:
                                this._setFastBlockNumber(blockNumber);
                                // Emit a poll event after we have the latest (fast) block number
                                this.emit("poll", pollId, blockNumber);
                                // If the block has not changed, meh.
                                if (blockNumber === this._lastBlockNumber) {
                                    this.emit("didPoll", pollId);
                                    return [
                                        2
                                    ];
                                }
                                // First polling cycle, trigger a "block" events
                                if (this._emitted.block === -2) this._emitted.block = blockNumber - 1;
                                if (Math.abs(this._emitted.block - blockNumber) > 1000) {
                                    $6a1c8a35900dd937$var$logger.warn("network block skew detected; skipping block events (emitted=".concat(this._emitted.block, " blockNumber").concat(blockNumber, ")"));
                                    this.emit("error", $6a1c8a35900dd937$var$logger.makeError("network block skew detected", (0, $6M65e.Logger).errors.NETWORK_ERROR, {
                                        blockNumber: blockNumber,
                                        event: "blockSkew",
                                        previousBlockNumber: this._emitted.block
                                    }));
                                    this.emit("block", blockNumber);
                                } else // Notify all listener for each block that has passed
                                for(i = this._emitted.block + 1; i <= blockNumber; i++)this.emit("block", i);
                                // The emitted block was updated, check for obsolete events
                                if (this._emitted.block !== blockNumber) {
                                    this._emitted.block = blockNumber;
                                    Object.keys(this._emitted).forEach(function(key) {
                                        // The block event does not expire
                                        if (key === "block") return;
                                        // The block we were at when we emitted this event
                                        var eventBlockNumber = _this._emitted[key];
                                        // We cannot garbage collect pending transactions or blocks here
                                        // They should be garbage collected by the Provider when setting
                                        // "pending" events
                                        if (eventBlockNumber === "pending") return;
                                        // Evict any transaction hashes or block hashes over 12 blocks
                                        // old, since they should not return null anyways
                                        if (blockNumber - eventBlockNumber > 12) delete _this._emitted[key];
                                    });
                                }
                                // First polling cycle
                                if (this._lastBlockNumber === -2) this._lastBlockNumber = blockNumber - 1;
                                // Find all transaction hashes we are waiting on
                                this._events.forEach(function(event) {
                                    switch(event.type){
                                        case "tx":
                                            {
                                                var hash = event.hash;
                                                var runner = _this.getTransactionReceipt(hash).then(function(receipt) {
                                                    if (!receipt || receipt.blockNumber == null) return null;
                                                    _this._emitted["t:" + hash] = receipt.blockNumber;
                                                    _this.emit(hash, receipt);
                                                    return null;
                                                }).catch(function(error) {
                                                    _this.emit("error", error);
                                                });
                                                runners.push(runner);
                                                break;
                                            }
                                        case "filter":
                                            // We only allow a single getLogs to be in-flight at a time
                                            if (!event._inflight) {
                                                event._inflight = true;
                                                // This is the first filter for this event, so we want to
                                                // restrict events to events that happened no earlier than now
                                                if (event._lastBlockNumber === -2) event._lastBlockNumber = blockNumber - 1;
                                                // Filter from the last *known* event; due to load-balancing
                                                // and some nodes returning updated block numbers before
                                                // indexing events, a logs result with 0 entries cannot be
                                                // trusted and we must retry a range which includes it again
                                                var filter = event.filter;
                                                filter.fromBlock = event._lastBlockNumber + 1;
                                                filter.toBlock = blockNumber;
                                                // Prevent fitler ranges from growing too wild, since it is quite
                                                // likely there just haven't been any events to move the lastBlockNumber.
                                                var minFromBlock = filter.toBlock - _this._maxFilterBlockRange;
                                                if (minFromBlock > filter.fromBlock) filter.fromBlock = minFromBlock;
                                                if (filter.fromBlock < 0) filter.fromBlock = 0;
                                                var runner1 = _this.getLogs(filter).then(function(logs) {
                                                    // Allow the next getLogs
                                                    event._inflight = false;
                                                    if (logs.length === 0) return;
                                                    logs.forEach(function(log) {
                                                        // Only when we get an event for a given block number
                                                        // can we trust the events are indexed
                                                        if (log.blockNumber > event._lastBlockNumber) event._lastBlockNumber = log.blockNumber;
                                                        // Make sure we stall requests to fetch blocks and txs
                                                        _this._emitted["b:" + log.blockHash] = log.blockNumber;
                                                        _this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                                        _this.emit(filter, log);
                                                    });
                                                }).catch(function(error) {
                                                    _this.emit("error", error);
                                                    // Allow another getLogs (the range was not updated)
                                                    event._inflight = false;
                                                });
                                                runners.push(runner1);
                                            }
                                            break;
                                    }
                                });
                                this._lastBlockNumber = blockNumber;
                                // Once all events for this loop have been processed, emit "didPoll"
                                Promise.all(runners).then(function() {
                                    _this.emit("didPoll", pollId);
                                }).catch(function(error) {
                                    _this.emit("error", error);
                                });
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            // Deprecated; do not use this
            key: "resetEventsBlock",
            value: function resetEventsBlock(blockNumber) {
                this._lastBlockNumber = blockNumber - 1;
                if (this.polling) this.poll();
            }
        },
        {
            key: "network",
            get: function get() {
                return this._network;
            }
        },
        {
            // This method should query the network if the underlying network
            // can change, such as when connected to a JSON-RPC backend
            key: "detectNetwork",
            value: function detectNetwork() {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            $6a1c8a35900dd937$var$logger.throwError("provider does not support network detection", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                                operation: "provider.detectNetwork"
                            })
                        ];
                    });
                });
            }
        },
        {
            key: "getNetwork",
            value: function getNetwork() {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var network, currentNetwork, error;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._ready()
                                ];
                            case 1:
                                network = _state.sent();
                                return [
                                    4,
                                    this.detectNetwork()
                                ];
                            case 2:
                                currentNetwork = _state.sent();
                                if (!(network.chainId !== currentNetwork.chainId)) return [
                                    3,
                                    5
                                ];
                                if (!this.anyNetwork) return [
                                    3,
                                    4
                                ];
                                this._network = currentNetwork;
                                // Reset all internal block number guards and caches
                                this._lastBlockNumber = -2;
                                this._fastBlockNumber = null;
                                this._fastBlockNumberPromise = null;
                                this._fastQueryDate = 0;
                                this._emitted.block = -2;
                                this._maxInternalBlockNumber = -1024;
                                this._internalBlockNumber = null;
                                // The "network" event MUST happen before this method resolves
                                // so any events have a chance to unregister, so we stall an
                                // additional event loop before returning from /this/ call
                                this.emit("network", currentNetwork, network);
                                return [
                                    4,
                                    $6a1c8a35900dd937$var$stall(0)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    this._network
                                ];
                            case 4:
                                error = $6a1c8a35900dd937$var$logger.makeError("underlying network changed", (0, $6M65e.Logger).errors.NETWORK_ERROR, {
                                    event: "changed",
                                    network: network,
                                    detectedNetwork: currentNetwork
                                });
                                this.emit("error", error);
                                throw error;
                            case 5:
                                return [
                                    2,
                                    network
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "blockNumber",
            get: function get() {
                var _this = this;
                this._getInternalBlockNumber(100 + this.pollingInterval / 2).then(function(blockNumber) {
                    _this._setFastBlockNumber(blockNumber);
                }, function(error) {});
                return this._fastBlockNumber != null ? this._fastBlockNumber : -1;
            }
        },
        {
            key: "polling",
            get: function get() {
                return this._poller != null;
            },
            set: function set(value) {
                var _this = this;
                if (value && !this._poller) {
                    this._poller = setInterval(function() {
                        _this.poll();
                    }, this.pollingInterval);
                    if (!this._bootstrapPoll) this._bootstrapPoll = setTimeout(function() {
                        _this.poll();
                        // We block additional polls until the polling interval
                        // is done, to prevent overwhelming the poll function
                        _this._bootstrapPoll = setTimeout(function() {
                            // If polling was disabled, something may require a poke
                            // since starting the bootstrap poll and it was disabled
                            if (!_this._poller) _this.poll();
                            // Clear out the bootstrap so we can do another
                            _this._bootstrapPoll = null;
                        }, _this.pollingInterval);
                    }, 0);
                } else if (!value && this._poller) {
                    clearInterval(this._poller);
                    this._poller = null;
                }
            }
        },
        {
            key: "pollingInterval",
            get: function get() {
                return this._pollingInterval;
            },
            set: function set(value) {
                var _this = this;
                if (typeof value !== "number" || value <= 0 || parseInt(String(value)) != value) throw new Error("invalid polling interval");
                this._pollingInterval = value;
                if (this._poller) {
                    clearInterval(this._poller);
                    this._poller = setInterval(function() {
                        _this.poll();
                    }, this._pollingInterval);
                }
            }
        },
        {
            key: "_getFastBlockNumber",
            value: function _getFastBlockNumber() {
                var _this = this;
                var now = $6a1c8a35900dd937$var$getTime();
                // Stale block number, request a newer value
                if (now - this._fastQueryDate > 2 * this._pollingInterval) {
                    this._fastQueryDate = now;
                    this._fastBlockNumberPromise = this.getBlockNumber().then(function(blockNumber) {
                        if (_this._fastBlockNumber == null || blockNumber > _this._fastBlockNumber) _this._fastBlockNumber = blockNumber;
                        return _this._fastBlockNumber;
                    });
                }
                return this._fastBlockNumberPromise;
            }
        },
        {
            key: "_setFastBlockNumber",
            value: function _setFastBlockNumber(blockNumber) {
                // Older block, maybe a stale request
                if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) return;
                // Update the time we updated the blocknumber
                this._fastQueryDate = $6a1c8a35900dd937$var$getTime();
                // Newer block number, use  it
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
                    this._fastBlockNumber = blockNumber;
                    this._fastBlockNumberPromise = Promise.resolve(blockNumber);
                }
            }
        },
        {
            key: "waitForTransaction",
            value: function waitForTransaction(transactionHash, confirmations, timeout) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            this._waitForTransaction(transactionHash, confirmations == null ? 1 : confirmations, timeout || 0, null)
                        ];
                    });
                });
            }
        },
        {
            key: "_waitForTransaction",
            value: function _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var _this, receipt;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.getTransactionReceipt(transactionHash)
                                ];
                            case 1:
                                receipt = _state.sent();
                                // Receipt is already good
                                if ((receipt ? receipt.confirmations : 0) >= confirmations) return [
                                    2,
                                    receipt
                                ];
                                // Poll until the receipt is good...
                                return [
                                    2,
                                    new Promise(function(resolve, reject) {
                                        var cancelFuncs = [];
                                        var done = false;
                                        var alreadyDone = function alreadyDone() {
                                            if (done) return true;
                                            done = true;
                                            cancelFuncs.forEach(function(func) {
                                                func();
                                            });
                                            return false;
                                        };
                                        var minedHandler = function(receipt) {
                                            if (receipt.confirmations < confirmations) return;
                                            if (alreadyDone()) return;
                                            resolve(receipt);
                                        };
                                        _this.on(transactionHash, minedHandler);
                                        cancelFuncs.push(function() {
                                            _this.removeListener(transactionHash, minedHandler);
                                        });
                                        if (replaceable) {
                                            var lastBlockNumber = replaceable.startBlock;
                                            var scannedBlock = null;
                                            var replaceHandler = function(blockNumber) {
                                                return $6a1c8a35900dd937$var$__awaiter(_this, void 0, void 0, function() {
                                                    var _this;
                                                    return (0, $7UAGh.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                _this = this;
                                                                if (done) return [
                                                                    2
                                                                ];
                                                                // Wait 1 second; this is only used in the case of a fault, so
                                                                // we will trade off a little bit of latency for more consistent
                                                                // results and fewer JSON-RPC calls
                                                                return [
                                                                    4,
                                                                    $6a1c8a35900dd937$var$stall(1000)
                                                                ];
                                                            case 1:
                                                                _state.sent();
                                                                this.getTransactionCount(replaceable.from).then(function(nonce) {
                                                                    return $6a1c8a35900dd937$var$__awaiter(_this, void 0, void 0, function() {
                                                                        var mined, block, ti, tx, receipt, reason;
                                                                        return (0, $7UAGh.__generator)(this, function(_state) {
                                                                            switch(_state.label){
                                                                                case 0:
                                                                                    if (done) return [
                                                                                        2
                                                                                    ];
                                                                                    if (!(nonce <= replaceable.nonce)) return [
                                                                                        3,
                                                                                        1
                                                                                    ];
                                                                                    lastBlockNumber = blockNumber;
                                                                                    return [
                                                                                        3,
                                                                                        9
                                                                                    ];
                                                                                case 1:
                                                                                    return [
                                                                                        4,
                                                                                        this.getTransaction(transactionHash)
                                                                                    ];
                                                                                case 2:
                                                                                    mined = _state.sent();
                                                                                    if (mined && mined.blockNumber != null) return [
                                                                                        2
                                                                                    ];
                                                                                    // First time scanning. We start a little earlier for some
                                                                                    // wiggle room here to handle the eventually consistent nature
                                                                                    // of blockchain (e.g. the getTransactionCount was for a
                                                                                    // different block)
                                                                                    if (scannedBlock == null) {
                                                                                        scannedBlock = lastBlockNumber - 3;
                                                                                        if (scannedBlock < replaceable.startBlock) scannedBlock = replaceable.startBlock;
                                                                                    }
                                                                                    _state.label = 3;
                                                                                case 3:
                                                                                    if (!(scannedBlock <= blockNumber)) return [
                                                                                        3,
                                                                                        9
                                                                                    ];
                                                                                    if (done) return [
                                                                                        2
                                                                                    ];
                                                                                    return [
                                                                                        4,
                                                                                        this.getBlockWithTransactions(scannedBlock)
                                                                                    ];
                                                                                case 4:
                                                                                    block = _state.sent();
                                                                                    ti = 0;
                                                                                    _state.label = 5;
                                                                                case 5:
                                                                                    if (!(ti < block.transactions.length)) return [
                                                                                        3,
                                                                                        8
                                                                                    ];
                                                                                    tx = block.transactions[ti];
                                                                                    // Successfully mined!
                                                                                    if (tx.hash === transactionHash) return [
                                                                                        2
                                                                                    ];
                                                                                    if (!(tx.from === replaceable.from && tx.nonce === replaceable.nonce)) return [
                                                                                        3,
                                                                                        7
                                                                                    ];
                                                                                    if (done) return [
                                                                                        2
                                                                                    ];
                                                                                    return [
                                                                                        4,
                                                                                        this.waitForTransaction(tx.hash, confirmations)
                                                                                    ];
                                                                                case 6:
                                                                                    receipt = _state.sent();
                                                                                    // Already resolved or rejected (prolly a timeout)
                                                                                    if (alreadyDone()) return [
                                                                                        2
                                                                                    ];
                                                                                    reason = "replaced";
                                                                                    if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) reason = "repriced";
                                                                                    else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) reason = "cancelled";
                                                                                    // Explain why we were replaced
                                                                                    reject($6a1c8a35900dd937$var$logger.makeError("transaction was replaced", (0, $6M65e.Logger).errors.TRANSACTION_REPLACED, {
                                                                                        cancelled: reason === "replaced" || reason === "cancelled",
                                                                                        reason: reason,
                                                                                        replacement: this._wrapTransaction(tx),
                                                                                        hash: transactionHash,
                                                                                        receipt: receipt
                                                                                    }));
                                                                                    return [
                                                                                        2
                                                                                    ];
                                                                                case 7:
                                                                                    ti++;
                                                                                    return [
                                                                                        3,
                                                                                        5
                                                                                    ];
                                                                                case 8:
                                                                                    scannedBlock++;
                                                                                    return [
                                                                                        3,
                                                                                        3
                                                                                    ];
                                                                                case 9:
                                                                                    if (done) return [
                                                                                        2
                                                                                    ];
                                                                                    this.once("block", replaceHandler);
                                                                                    return [
                                                                                        2
                                                                                    ];
                                                                            }
                                                                        });
                                                                    });
                                                                }, function(error) {
                                                                    if (done) return;
                                                                    _this.once("block", replaceHandler);
                                                                });
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                });
                                            };
                                            if (done) return;
                                            _this.once("block", replaceHandler);
                                            cancelFuncs.push(function() {
                                                _this.removeListener("block", replaceHandler);
                                            });
                                        }
                                        if (typeof timeout === "number" && timeout > 0) {
                                            var timer = setTimeout(function() {
                                                if (alreadyDone()) return;
                                                reject($6a1c8a35900dd937$var$logger.makeError("timeout exceeded", (0, $6M65e.Logger).errors.TIMEOUT, {
                                                    timeout: timeout
                                                }));
                                            }, timeout);
                                            if (timer.unref) timer.unref();
                                            cancelFuncs.push(function() {
                                                clearTimeout(timer);
                                            });
                                        }
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getBlockNumber",
            value: function getBlockNumber() {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            this._getInternalBlockNumber(0)
                        ];
                    });
                });
            }
        },
        {
            key: "getGasPrice",
            value: function getGasPrice() {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this.perform("getGasPrice", {})
                                ];
                            case 2:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $gMArf.BigNumber).from(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                                            method: "getGasPrice",
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getBalance",
            value: function getBalance(addressOrName, blockTag) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var params, result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $2ax4w.resolveProperties)({
                                        address: this._getAddress(addressOrName),
                                        blockTag: this._getBlockTag(blockTag)
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("getBalance", params)
                                ];
                            case 3:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $gMArf.BigNumber).from(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                                            method: "getBalance",
                                            params: params,
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getTransactionCount",
            value: function getTransactionCount(addressOrName, blockTag) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var params, result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $2ax4w.resolveProperties)({
                                        address: this._getAddress(addressOrName),
                                        blockTag: this._getBlockTag(blockTag)
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("getTransactionCount", params)
                                ];
                            case 3:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $gMArf.BigNumber).from(result).toNumber()
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                                            method: "getTransactionCount",
                                            params: params,
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getCode",
            value: function getCode(addressOrName, blockTag) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var params, result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $2ax4w.resolveProperties)({
                                        address: this._getAddress(addressOrName),
                                        blockTag: this._getBlockTag(blockTag)
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("getCode", params)
                                ];
                            case 3:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $j2rU8.hexlify)(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                                            method: "getCode",
                                            params: params,
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getStorageAt",
            value: function getStorageAt(addressOrName, position, blockTag) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var params, result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $2ax4w.resolveProperties)({
                                        address: this._getAddress(addressOrName),
                                        blockTag: this._getBlockTag(blockTag),
                                        position: Promise.resolve(position).then(function(p) {
                                            return (0, $j2rU8.hexValue)(p);
                                        })
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("getStorageAt", params)
                                ];
                            case 3:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $j2rU8.hexlify)(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                                            method: "getStorageAt",
                                            params: params,
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            // This should be called by any subclass wrapping a TransactionResponse
            key: "_wrapTransaction",
            value: function _wrapTransaction(tx, hash, startBlock) {
                var _this = this;
                if (hash != null && (0, $j2rU8.hexDataLength)(hash) !== 32) throw new Error("invalid response - sendTransaction");
                var result = tx;
                // Check the hash we expect is the same as the hash the server reported
                if (hash != null && tx.hash !== hash) $6a1c8a35900dd937$var$logger.throwError("Transaction hash mismatch from Provider.sendTransaction.", (0, $6M65e.Logger).errors.UNKNOWN_ERROR, {
                    expectedHash: tx.hash,
                    returnedHash: hash
                });
                result.wait = function(confirms, timeout) {
                    return $6a1c8a35900dd937$var$__awaiter(_this, void 0, void 0, function() {
                        var replacement, receipt;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (confirms == null) confirms = 1;
                                    if (timeout == null) timeout = 0;
                                    replacement = undefined;
                                    if (confirms !== 0 && startBlock != null) replacement = {
                                        data: tx.data,
                                        from: tx.from,
                                        nonce: tx.nonce,
                                        to: tx.to,
                                        value: tx.value,
                                        startBlock: startBlock
                                    };
                                    return [
                                        4,
                                        this._waitForTransaction(tx.hash, confirms, timeout, replacement)
                                    ];
                                case 1:
                                    receipt = _state.sent();
                                    if (receipt == null && confirms === 0) return [
                                        2,
                                        null
                                    ];
                                    // No longer pending, allow the polling loop to garbage collect this
                                    this._emitted["t:" + tx.hash] = receipt.blockNumber;
                                    if (receipt.status === 0) $6a1c8a35900dd937$var$logger.throwError("transaction failed", (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
                                        transactionHash: tx.hash,
                                        transaction: tx,
                                        receipt: receipt
                                    });
                                    return [
                                        2,
                                        receipt
                                    ];
                            }
                        });
                    });
                };
                return result;
            }
        },
        {
            key: "sendTransaction",
            value: function sendTransaction(signedTransaction) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var hexTx, tx, blockNumber, hash, error;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    Promise.resolve(signedTransaction).then(function(t) {
                                        return (0, $j2rU8.hexlify)(t);
                                    })
                                ];
                            case 2:
                                hexTx = _state.sent();
                                tx = this.formatter.transaction(signedTransaction);
                                if (tx.confirmations == null) tx.confirmations = 0;
                                return [
                                    4,
                                    this._getInternalBlockNumber(100 + 2 * this.pollingInterval)
                                ];
                            case 3:
                                blockNumber = _state.sent();
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    this.perform("sendTransaction", {
                                        signedTransaction: hexTx
                                    })
                                ];
                            case 5:
                                hash = _state.sent();
                                return [
                                    2,
                                    this._wrapTransaction(tx, hash, blockNumber)
                                ];
                            case 6:
                                error = _state.sent();
                                error.transaction = tx;
                                error.transactionHash = tx.hash;
                                throw error;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getTransactionRequest",
            value: function _getTransactionRequest(transaction) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var _this, values, tx, _, _1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    transaction
                                ];
                            case 1:
                                values = _state.sent();
                                tx = {};
                                [
                                    "from",
                                    "to"
                                ].forEach(function(key) {
                                    if (values[key] == null) return;
                                    tx[key] = Promise.resolve(values[key]).then(function(v) {
                                        return v ? _this._getAddress(v) : null;
                                    });
                                });
                                [
                                    "gasLimit",
                                    "gasPrice",
                                    "maxFeePerGas",
                                    "maxPriorityFeePerGas",
                                    "value"
                                ].forEach(function(key) {
                                    if (values[key] == null) return;
                                    tx[key] = Promise.resolve(values[key]).then(function(v) {
                                        return v ? (0, $gMArf.BigNumber).from(v) : null;
                                    });
                                });
                                [
                                    "type"
                                ].forEach(function(key) {
                                    if (values[key] == null) return;
                                    tx[key] = Promise.resolve(values[key]).then(function(v) {
                                        return v != null ? v : null;
                                    });
                                });
                                if (values.accessList) tx.accessList = this.formatter.accessList(values.accessList);
                                [
                                    "data"
                                ].forEach(function(key) {
                                    if (values[key] == null) return;
                                    tx[key] = Promise.resolve(values[key]).then(function(v) {
                                        return v ? (0, $j2rU8.hexlify)(v) : null;
                                    });
                                });
                                _1 = (_ = this.formatter).transactionRequest;
                                return [
                                    4,
                                    (0, $2ax4w.resolveProperties)(tx)
                                ];
                            case 2:
                                return [
                                    2,
                                    _1.apply(_, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getFilter",
            value: function _getFilter(filter) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var _this, result, _, _1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    filter
                                ];
                            case 1:
                                filter = _state.sent();
                                result = {};
                                if (filter.address != null) result.address = this._getAddress(filter.address);
                                [
                                    "blockHash",
                                    "topics"
                                ].forEach(function(key) {
                                    if (filter[key] == null) return;
                                    result[key] = filter[key];
                                });
                                [
                                    "fromBlock",
                                    "toBlock"
                                ].forEach(function(key) {
                                    if (filter[key] == null) return;
                                    result[key] = _this._getBlockTag(filter[key]);
                                });
                                _1 = (_ = this.formatter).filter;
                                return [
                                    4,
                                    (0, $2ax4w.resolveProperties)(result)
                                ];
                            case 2:
                                return [
                                    2,
                                    _1.apply(_, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_call",
            value: function _call(transaction, blockTag, attempt) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var txSender, result, data, sender, urls, urlsOffset, urlsLength, urlsData, u, url, calldata, callbackSelector, extraData, ccipResult, tx, error;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (attempt >= $6a1c8a35900dd937$var$MAX_CCIP_REDIRECTS) $6a1c8a35900dd937$var$logger.throwError("CCIP read exceeded maximum redirections", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                                    redirects: attempt,
                                    transaction: transaction
                                });
                                txSender = transaction.to;
                                return [
                                    4,
                                    this.perform("call", {
                                        transaction: transaction,
                                        blockTag: blockTag
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                if (!(attempt >= 0 && blockTag === "latest" && txSender != null && result.substring(0, 10) === "0x556f1830" && (0, $j2rU8.hexDataLength)(result) % 32 === 4)) return [
                                    3,
                                    5
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                data = (0, $j2rU8.hexDataSlice)(result, 4);
                                sender = (0, $j2rU8.hexDataSlice)(data, 0, 32);
                                if (!(0, $gMArf.BigNumber).from(sender).eq(txSender)) $6a1c8a35900dd937$var$logger.throwError("CCIP Read sender did not match", (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
                                    name: "OffchainLookup",
                                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                                    transaction: transaction,
                                    data: result
                                });
                                urls = [];
                                urlsOffset = (0, $gMArf.BigNumber).from((0, $j2rU8.hexDataSlice)(data, 32, 64)).toNumber();
                                urlsLength = (0, $gMArf.BigNumber).from((0, $j2rU8.hexDataSlice)(data, urlsOffset, urlsOffset + 32)).toNumber();
                                urlsData = (0, $j2rU8.hexDataSlice)(data, urlsOffset + 32);
                                for(u = 0; u < urlsLength; u++){
                                    url = $6a1c8a35900dd937$var$_parseString(urlsData, u * 32);
                                    if (url == null) $6a1c8a35900dd937$var$logger.throwError("CCIP Read contained corrupt URL string", (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
                                        name: "OffchainLookup",
                                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                                        transaction: transaction,
                                        data: result
                                    });
                                    urls.push(url);
                                }
                                calldata = $6a1c8a35900dd937$var$_parseBytes(data, 64);
                                // Get the callbackSelector (bytes4)
                                if (!(0, $gMArf.BigNumber).from((0, $j2rU8.hexDataSlice)(data, 100, 128)).isZero()) $6a1c8a35900dd937$var$logger.throwError("CCIP Read callback selector included junk", (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
                                    name: "OffchainLookup",
                                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                                    transaction: transaction,
                                    data: result
                                });
                                callbackSelector = (0, $j2rU8.hexDataSlice)(data, 96, 100);
                                extraData = $6a1c8a35900dd937$var$_parseBytes(data, 128);
                                return [
                                    4,
                                    this.ccipReadFetch(transaction, calldata, urls)
                                ];
                            case 3:
                                ccipResult = _state.sent();
                                if (ccipResult == null) $6a1c8a35900dd937$var$logger.throwError("CCIP Read disabled or provided no URLs", (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
                                    name: "OffchainLookup",
                                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                                    transaction: transaction,
                                    data: result
                                });
                                tx = {
                                    to: txSender,
                                    data: (0, $j2rU8.hexConcat)([
                                        callbackSelector,
                                        $6a1c8a35900dd937$var$encodeBytes([
                                            ccipResult,
                                            extraData
                                        ])
                                    ])
                                };
                                return [
                                    2,
                                    this._call(tx, blockTag, attempt + 1)
                                ];
                            case 4:
                                error = _state.sent();
                                if (error.code === (0, $6M65e.Logger).errors.SERVER_ERROR) throw error;
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                try {
                                    return [
                                        2,
                                        (0, $j2rU8.hexlify)(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                                            method: "call",
                                            params: {
                                                transaction: transaction,
                                                blockTag: blockTag
                                            },
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "call",
            value: function call(transaction, blockTag) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var resolved;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $2ax4w.resolveProperties)({
                                        transaction: this._getTransactionRequest(transaction),
                                        blockTag: this._getBlockTag(blockTag),
                                        ccipReadEnabled: Promise.resolve(transaction.ccipReadEnabled)
                                    })
                                ];
                            case 2:
                                resolved = _state.sent();
                                return [
                                    2,
                                    this._call(resolved.transaction, resolved.blockTag, resolved.ccipReadEnabled ? 0 : -1)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "estimateGas",
            value: function estimateGas(transaction) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var params, result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $2ax4w.resolveProperties)({
                                        transaction: this._getTransactionRequest(transaction)
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("estimateGas", params)
                                ];
                            case 3:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $gMArf.BigNumber).from(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                                            method: "estimateGas",
                                            params: params,
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getAddress",
            value: function _getAddress(addressOrName) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var address;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    addressOrName
                                ];
                            case 1:
                                addressOrName = _state.sent();
                                if (typeof addressOrName !== "string") $6a1c8a35900dd937$var$logger.throwArgumentError("invalid address or ENS name", "name", addressOrName);
                                return [
                                    4,
                                    this.resolveName(addressOrName)
                                ];
                            case 2:
                                address = _state.sent();
                                if (address == null) $6a1c8a35900dd937$var$logger.throwError("ENS name not configured", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                                    operation: "resolveName(".concat(JSON.stringify(addressOrName), ")")
                                });
                                return [
                                    2,
                                    address
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getBlock",
            value: function _getBlock(blockHashOrBlockTag, includeTransactions) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var _this, blockNumber, params, error;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    blockHashOrBlockTag
                                ];
                            case 2:
                                blockHashOrBlockTag = _state.sent();
                                blockNumber = -128;
                                params = {
                                    includeTransactions: !!includeTransactions
                                };
                                if (!(0, $j2rU8.isHexString)(blockHashOrBlockTag, 32)) return [
                                    3,
                                    3
                                ];
                                params.blockHash = blockHashOrBlockTag;
                                return [
                                    3,
                                    6
                                ];
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    this._getBlockTag(blockHashOrBlockTag)
                                ];
                            case 4:
                                params.blockTag = _state.sent();
                                if ((0, $j2rU8.isHexString)(params.blockTag)) blockNumber = parseInt(params.blockTag.substring(2), 16);
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                $6a1c8a35900dd937$var$logger.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    2,
                                    (0, $gqL7R.poll)(function() {
                                        return $6a1c8a35900dd937$var$__awaiter(_this, void 0, void 0, function() {
                                            var _this, block, blockNumber1, i, tx, confirmations, blockWithTxs;
                                            return (0, $7UAGh.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _this = this;
                                                        return [
                                                            4,
                                                            this.perform("getBlock", params)
                                                        ];
                                                    case 1:
                                                        block = _state.sent();
                                                        // Block was not found
                                                        if (block == null) {
                                                            // For blockhashes, if we didn't say it existed, that blockhash may
                                                            // not exist. If we did see it though, perhaps from a log, we know
                                                            // it exists, and this node is just not caught up yet.
                                                            if (params.blockHash != null) {
                                                                if (this._emitted["b:" + params.blockHash] == null) return [
                                                                    2,
                                                                    null
                                                                ];
                                                            }
                                                            // For block tags, if we are asking for a future block, we return null
                                                            if (params.blockTag != null) {
                                                                if (blockNumber > this._emitted.block) return [
                                                                    2,
                                                                    null
                                                                ];
                                                            }
                                                            // Retry on the next block
                                                            return [
                                                                2,
                                                                undefined
                                                            ];
                                                        }
                                                        if (!includeTransactions) return [
                                                            3,
                                                            8
                                                        ];
                                                        blockNumber1 = null;
                                                        i = 0;
                                                        _state.label = 2;
                                                    case 2:
                                                        if (!(i < block.transactions.length)) return [
                                                            3,
                                                            7
                                                        ];
                                                        tx = block.transactions[i];
                                                        if (!(tx.blockNumber == null)) return [
                                                            3,
                                                            3
                                                        ];
                                                        tx.confirmations = 0;
                                                        return [
                                                            3,
                                                            6
                                                        ];
                                                    case 3:
                                                        if (!(tx.confirmations == null)) return [
                                                            3,
                                                            6
                                                        ];
                                                        if (!(blockNumber1 == null)) return [
                                                            3,
                                                            5
                                                        ];
                                                        return [
                                                            4,
                                                            this._getInternalBlockNumber(100 + 2 * this.pollingInterval)
                                                        ];
                                                    case 4:
                                                        blockNumber1 = _state.sent();
                                                        _state.label = 5;
                                                    case 5:
                                                        confirmations = blockNumber1 - tx.blockNumber + 1;
                                                        if (confirmations <= 0) confirmations = 1;
                                                        tx.confirmations = confirmations;
                                                        _state.label = 6;
                                                    case 6:
                                                        i++;
                                                        return [
                                                            3,
                                                            2
                                                        ];
                                                    case 7:
                                                        blockWithTxs = this.formatter.blockWithTransactions(block);
                                                        blockWithTxs.transactions = blockWithTxs.transactions.map(function(tx) {
                                                            return _this._wrapTransaction(tx);
                                                        });
                                                        return [
                                                            2,
                                                            blockWithTxs
                                                        ];
                                                    case 8:
                                                        return [
                                                            2,
                                                            this.formatter.block(block)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        oncePoll: this
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getBlock",
            value: function getBlock(blockHashOrBlockTag) {
                return this._getBlock(blockHashOrBlockTag, false);
            }
        },
        {
            key: "getBlockWithTransactions",
            value: function getBlockWithTransactions(blockHashOrBlockTag) {
                return this._getBlock(blockHashOrBlockTag, true);
            }
        },
        {
            key: "getTransaction",
            value: function getTransaction(transactionHash) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var _this, params;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    transactionHash
                                ];
                            case 2:
                                transactionHash = _state.sent();
                                params = {
                                    transactionHash: this.formatter.hash(transactionHash, true)
                                };
                                return [
                                    2,
                                    (0, $gqL7R.poll)(function() {
                                        return $6a1c8a35900dd937$var$__awaiter(_this, void 0, void 0, function() {
                                            var result, tx, blockNumber, confirmations;
                                            return (0, $7UAGh.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.perform("getTransaction", params)
                                                        ];
                                                    case 1:
                                                        result = _state.sent();
                                                        if (result == null) {
                                                            if (this._emitted["t:" + transactionHash] == null) return [
                                                                2,
                                                                null
                                                            ];
                                                            return [
                                                                2,
                                                                undefined
                                                            ];
                                                        }
                                                        tx = this.formatter.transactionResponse(result);
                                                        if (!(tx.blockNumber == null)) return [
                                                            3,
                                                            2
                                                        ];
                                                        tx.confirmations = 0;
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 2:
                                                        if (!(tx.confirmations == null)) return [
                                                            3,
                                                            4
                                                        ];
                                                        return [
                                                            4,
                                                            this._getInternalBlockNumber(100 + 2 * this.pollingInterval)
                                                        ];
                                                    case 3:
                                                        blockNumber = _state.sent();
                                                        confirmations = blockNumber - tx.blockNumber + 1;
                                                        if (confirmations <= 0) confirmations = 1;
                                                        tx.confirmations = confirmations;
                                                        _state.label = 4;
                                                    case 4:
                                                        return [
                                                            2,
                                                            this._wrapTransaction(tx)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        oncePoll: this
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getTransactionReceipt",
            value: function getTransactionReceipt(transactionHash) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var _this, params;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    transactionHash
                                ];
                            case 2:
                                transactionHash = _state.sent();
                                params = {
                                    transactionHash: this.formatter.hash(transactionHash, true)
                                };
                                return [
                                    2,
                                    (0, $gqL7R.poll)(function() {
                                        return $6a1c8a35900dd937$var$__awaiter(_this, void 0, void 0, function() {
                                            var result, receipt, blockNumber, confirmations;
                                            return (0, $7UAGh.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.perform("getTransactionReceipt", params)
                                                        ];
                                                    case 1:
                                                        result = _state.sent();
                                                        if (result == null) {
                                                            if (this._emitted["t:" + transactionHash] == null) return [
                                                                2,
                                                                null
                                                            ];
                                                            return [
                                                                2,
                                                                undefined
                                                            ];
                                                        }
                                                        // "geth-etc" returns receipts before they are ready
                                                        if (result.blockHash == null) return [
                                                            2,
                                                            undefined
                                                        ];
                                                        receipt = this.formatter.receipt(result);
                                                        if (!(receipt.blockNumber == null)) return [
                                                            3,
                                                            2
                                                        ];
                                                        receipt.confirmations = 0;
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 2:
                                                        if (!(receipt.confirmations == null)) return [
                                                            3,
                                                            4
                                                        ];
                                                        return [
                                                            4,
                                                            this._getInternalBlockNumber(100 + 2 * this.pollingInterval)
                                                        ];
                                                    case 3:
                                                        blockNumber = _state.sent();
                                                        confirmations = blockNumber - receipt.blockNumber + 1;
                                                        if (confirmations <= 0) confirmations = 1;
                                                        receipt.confirmations = confirmations;
                                                        _state.label = 4;
                                                    case 4:
                                                        return [
                                                            2,
                                                            receipt
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        oncePoll: this
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getLogs",
            value: function getLogs(filter) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var params, logs;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $2ax4w.resolveProperties)({
                                        filter: this._getFilter(filter)
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("getLogs", params)
                                ];
                            case 3:
                                logs = _state.sent();
                                logs.forEach(function(log) {
                                    if (log.removed == null) log.removed = false;
                                });
                                return [
                                    2,
                                    (0, $f1MgE.Formatter).arrayOf(this.formatter.filterLog.bind(this.formatter))(logs)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getEtherPrice",
            value: function getEtherPrice() {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    this.perform("getEtherPrice", {})
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getBlockTag",
            value: function _getBlockTag(blockTag) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var blockNumber;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    blockTag
                                ];
                            case 1:
                                blockTag = _state.sent();
                                if (!(typeof blockTag === "number" && blockTag < 0)) return [
                                    3,
                                    3
                                ];
                                if (blockTag % 1) $6a1c8a35900dd937$var$logger.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                                return [
                                    4,
                                    this._getInternalBlockNumber(100 + 2 * this.pollingInterval)
                                ];
                            case 2:
                                blockNumber = _state.sent();
                                blockNumber += blockTag;
                                if (blockNumber < 0) blockNumber = 0;
                                return [
                                    2,
                                    this.formatter.blockTag(blockNumber)
                                ];
                            case 3:
                                return [
                                    2,
                                    this.formatter.blockTag(blockTag)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getResolver",
            value: function getResolver(name) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var currentName, addr, resolver, _tmp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                currentName = name;
                                _state.label = 1;
                            case 1:
                                if (!true) return [
                                    3,
                                    6
                                ];
                                if (currentName === "" || currentName === ".") return [
                                    2,
                                    null
                                ];
                                // Optimization since the eth node cannot change and does
                                // not have a wildcard resolver
                                if (name !== "eth" && currentName === "eth") return [
                                    2,
                                    null
                                ];
                                return [
                                    4,
                                    this._getResolver(currentName, "getResolver")
                                ];
                            case 2:
                                addr = _state.sent();
                                if (!(addr != null)) return [
                                    3,
                                    5
                                ];
                                resolver = new $6a1c8a35900dd937$export$8b4c839865b08288(this, addr, name);
                                _tmp = currentName !== name;
                                if (!_tmp) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    resolver.supportsWildcard()
                                ];
                            case 3:
                                _tmp = !_state.sent();
                                _state.label = 4;
                            case 4:
                                // Legacy resolver found, using EIP-2544 so it isn't safe to use
                                if (_tmp) return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    resolver
                                ];
                            case 5:
                                // Get the parent node
                                currentName = currentName.split(".").slice(1).join(".");
                                return [
                                    3,
                                    1
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getResolver",
            value: function _getResolver(name, operation) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var network, addrData, error;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (operation == null) operation = "ENS";
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                network = _state.sent();
                                // No ENS...
                                if (!network.ensAddress) $6a1c8a35900dd937$var$logger.throwError("network does not support ENS", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                                    operation: operation,
                                    network: network.name
                                });
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    this.call({
                                        to: network.ensAddress,
                                        data: "0x0178b8bf" + (0, $4JdI5.namehash)(name).substring(2)
                                    })
                                ];
                            case 3:
                                addrData = _state.sent();
                                return [
                                    2,
                                    this.formatter.callAddress(addrData)
                                ];
                            case 4:
                                error = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "resolveName",
            value: function resolveName(name) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var resolver;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    name
                                ];
                            case 1:
                                name = _state.sent();
                                // If it is already an address, nothing to resolve
                                try {
                                    return [
                                        2,
                                        Promise.resolve(this.formatter.address(name))
                                    ];
                                } catch (error) {
                                    // If is is a hexstring, the address is bad (See #694)
                                    if ((0, $j2rU8.isHexString)(name)) throw error;
                                }
                                if (typeof name !== "string") $6a1c8a35900dd937$var$logger.throwArgumentError("invalid ENS name", "name", name);
                                return [
                                    4,
                                    this.getResolver(name)
                                ];
                            case 2:
                                resolver = _state.sent();
                                if (!resolver) return [
                                    2,
                                    null
                                ];
                                return [
                                    4,
                                    resolver.getAddress()
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "lookupAddress",
            value: function lookupAddress(address) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var node, resolverAddr, name, addr;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    address
                                ];
                            case 1:
                                address = _state.sent();
                                address = this.formatter.address(address);
                                node = address.substring(2).toLowerCase() + ".addr.reverse";
                                return [
                                    4,
                                    this._getResolver(node, "lookupAddress")
                                ];
                            case 2:
                                resolverAddr = _state.sent();
                                if (resolverAddr == null) return [
                                    2,
                                    null
                                ];
                                return [
                                    4,
                                    this.call({
                                        to: resolverAddr,
                                        data: "0x691f3431" + (0, $4JdI5.namehash)(node).substring(2)
                                    })
                                ];
                            case 3:
                                name = $6a1c8a35900dd937$var$_parseString.apply(void 0, [
                                    _state.sent(),
                                    0
                                ]);
                                return [
                                    4,
                                    this.resolveName(name)
                                ];
                            case 4:
                                addr = _state.sent();
                                if (addr != address) return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    name
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getAvatar",
            value: function getAvatar(nameOrAddress) {
                return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function() {
                    var resolver, address, node, resolverAddress, avatar, error, name, error1, avatar1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                resolver = null;
                                if (!(0, $j2rU8.isHexString)(nameOrAddress)) return [
                                    3,
                                    10
                                ];
                                address = this.formatter.address(nameOrAddress);
                                node = address.substring(2).toLowerCase() + ".addr.reverse";
                                return [
                                    4,
                                    this._getResolver(node, "getAvatar")
                                ];
                            case 1:
                                resolverAddress = _state.sent();
                                if (!resolverAddress) return [
                                    2,
                                    null
                                ];
                                // Try resolving the avatar against the addr.reverse resolver
                                resolver = new $6a1c8a35900dd937$export$8b4c839865b08288(this, resolverAddress, node);
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    resolver.getAvatar()
                                ];
                            case 3:
                                avatar = _state.sent();
                                if (avatar) return [
                                    2,
                                    avatar.url
                                ];
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                if (error.code !== (0, $6M65e.Logger).errors.CALL_EXCEPTION) throw error;
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                _state.trys.push([
                                    5,
                                    8,
                                    ,
                                    9
                                ]);
                                return [
                                    4,
                                    this.call({
                                        to: resolverAddress,
                                        data: "0x691f3431" + (0, $4JdI5.namehash)(node).substring(2)
                                    })
                                ];
                            case 6:
                                name = $6a1c8a35900dd937$var$_parseString.apply(void 0, [
                                    _state.sent(),
                                    0
                                ]);
                                return [
                                    4,
                                    this.getResolver(name)
                                ];
                            case 7:
                                resolver = _state.sent();
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                error1 = _state.sent();
                                if (error1.code !== (0, $6M65e.Logger).errors.CALL_EXCEPTION) throw error1;
                                return [
                                    2,
                                    null
                                ];
                            case 9:
                                return [
                                    3,
                                    12
                                ];
                            case 10:
                                return [
                                    4,
                                    this.getResolver(nameOrAddress)
                                ];
                            case 11:
                                // ENS name; forward lookup with wildcard
                                resolver = _state.sent();
                                if (!resolver) return [
                                    2,
                                    null
                                ];
                                _state.label = 12;
                            case 12:
                                return [
                                    4,
                                    resolver.getAvatar()
                                ];
                            case 13:
                                avatar1 = _state.sent();
                                if (avatar1 == null) return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    avatar1.url
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "perform",
            value: function perform(method, params) {
                return $6a1c8a35900dd937$var$logger.throwError(method + " not implemented", (0, $6M65e.Logger).errors.NOT_IMPLEMENTED, {
                    operation: method
                });
            }
        },
        {
            key: "_startEvent",
            value: function _startEvent(event) {
                this.polling = this._events.filter(function(e) {
                    return e.pollable();
                }).length > 0;
            }
        },
        {
            key: "_stopEvent",
            value: function _stopEvent(event) {
                this.polling = this._events.filter(function(e) {
                    return e.pollable();
                }).length > 0;
            }
        },
        {
            key: "_addEventListener",
            value: function _addEventListener(eventName, listener, once) {
                var event = new $6a1c8a35900dd937$export$d61e24a684f9e51($6a1c8a35900dd937$var$getEventTag(eventName), listener, once);
                this._events.push(event);
                this._startEvent(event);
                return this;
            }
        },
        {
            key: "on",
            value: function on(eventName, listener) {
                return this._addEventListener(eventName, listener, false);
            }
        },
        {
            key: "once",
            value: function once(eventName, listener) {
                return this._addEventListener(eventName, listener, true);
            }
        },
        {
            key: "emit",
            value: function emit(eventName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _this = this;
                var result = false;
                var stopped = [];
                var eventTag = $6a1c8a35900dd937$var$getEventTag(eventName);
                this._events = this._events.filter(function(event) {
                    if (event.tag !== eventTag) return true;
                    setTimeout(function() {
                        event.listener.apply(_this, args);
                    }, 0);
                    result = true;
                    if (event.once) {
                        stopped.push(event);
                        return false;
                    }
                    return true;
                });
                stopped.forEach(function(event) {
                    _this._stopEvent(event);
                });
                return result;
            }
        },
        {
            key: "listenerCount",
            value: function listenerCount(eventName) {
                if (!eventName) return this._events.length;
                var eventTag = $6a1c8a35900dd937$var$getEventTag(eventName);
                return this._events.filter(function(event) {
                    return event.tag === eventTag;
                }).length;
            }
        },
        {
            key: "listeners",
            value: function listeners(eventName) {
                if (eventName == null) return this._events.map(function(event) {
                    return event.listener;
                });
                var eventTag = $6a1c8a35900dd937$var$getEventTag(eventName);
                return this._events.filter(function(event) {
                    return event.tag === eventTag;
                }).map(function(event) {
                    return event.listener;
                });
            }
        },
        {
            key: "off",
            value: function off(eventName, listener) {
                var _this = this;
                if (listener == null) return this.removeAllListeners(eventName);
                var stopped = [];
                var found = false;
                var eventTag = $6a1c8a35900dd937$var$getEventTag(eventName);
                this._events = this._events.filter(function(event) {
                    if (event.tag !== eventTag || event.listener != listener) return true;
                    if (found) return true;
                    found = true;
                    stopped.push(event);
                    return false;
                });
                stopped.forEach(function(event) {
                    _this._stopEvent(event);
                });
                return this;
            }
        },
        {
            key: "removeAllListeners",
            value: function removeAllListeners(eventName) {
                var _this = this;
                var stopped = [];
                if (eventName == null) {
                    stopped = this._events;
                    this._events = [];
                } else {
                    var eventTag = $6a1c8a35900dd937$var$getEventTag(eventName);
                    this._events = this._events.filter(function(event) {
                        if (event.tag !== eventTag) return true;
                        stopped.push(event);
                        return false;
                    });
                }
                stopped.forEach(function(event) {
                    _this._stopEvent(event);
                });
                return this;
            }
        }
    ], [
        {
            key: "getFormatter",
            value: // @TODO: Remove this and just create a singleton formatter
            function getFormatter() {
                if ($6a1c8a35900dd937$var$defaultFormatter == null) $6a1c8a35900dd937$var$defaultFormatter = new (0, $f1MgE.Formatter)();
                return $6a1c8a35900dd937$var$defaultFormatter;
            }
        },
        {
            key: "getNetwork",
            value: // @TODO: Remove this and just use getNetwork
            function getNetwork1(network) {
                return (0, $1TEfp.getNetwork)(network == null ? "homestead" : network);
            }
        }
    ]);
    return BaseProvider;
}((0, $lLovk.Provider));

});
parcelRequire.register("guCs7", function(module, exports) {
"use strict";
var $c01d4687d4f4d3ac$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $c01d4687d4f4d3ac$var$ALPHABET_MAP = {};
for(var $c01d4687d4f4d3ac$var$z = 0; $c01d4687d4f4d3ac$var$z < $c01d4687d4f4d3ac$var$ALPHABET.length; $c01d4687d4f4d3ac$var$z++){
    var $c01d4687d4f4d3ac$var$x = $c01d4687d4f4d3ac$var$ALPHABET.charAt($c01d4687d4f4d3ac$var$z);
    if ($c01d4687d4f4d3ac$var$ALPHABET_MAP[$c01d4687d4f4d3ac$var$x] !== undefined) throw new TypeError($c01d4687d4f4d3ac$var$x + " is ambiguous");
    $c01d4687d4f4d3ac$var$ALPHABET_MAP[$c01d4687d4f4d3ac$var$x] = $c01d4687d4f4d3ac$var$z;
}
function $c01d4687d4f4d3ac$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $c01d4687d4f4d3ac$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $c01d4687d4f4d3ac$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $c01d4687d4f4d3ac$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $c01d4687d4f4d3ac$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $c01d4687d4f4d3ac$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $c01d4687d4f4d3ac$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $c01d4687d4f4d3ac$var$polymodStep(chk) ^ x;
        result += $c01d4687d4f4d3ac$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $c01d4687d4f4d3ac$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $c01d4687d4f4d3ac$var$ALPHABET.charAt(v);
    }
    return result;
}
function $c01d4687d4f4d3ac$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $c01d4687d4f4d3ac$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $c01d4687d4f4d3ac$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $c01d4687d4f4d3ac$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $c01d4687d4f4d3ac$var$decodeUnsafe() {
    var res = $c01d4687d4f4d3ac$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $c01d4687d4f4d3ac$var$decode(str) {
    var res = $c01d4687d4f4d3ac$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $c01d4687d4f4d3ac$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $c01d4687d4f4d3ac$var$toWordsUnsafe(bytes) {
    var res = $c01d4687d4f4d3ac$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $c01d4687d4f4d3ac$var$toWords(bytes) {
    var res = $c01d4687d4f4d3ac$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $c01d4687d4f4d3ac$var$fromWordsUnsafe(words) {
    var res = $c01d4687d4f4d3ac$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $c01d4687d4f4d3ac$var$fromWords(words) {
    var res = $c01d4687d4f4d3ac$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
module.exports = {
    decodeUnsafe: $c01d4687d4f4d3ac$var$decodeUnsafe,
    decode: $c01d4687d4f4d3ac$var$decode,
    encode: $c01d4687d4f4d3ac$var$encode,
    toWordsUnsafe: $c01d4687d4f4d3ac$var$toWordsUnsafe,
    toWords: $c01d4687d4f4d3ac$var$toWords,
    fromWordsUnsafe: $c01d4687d4f4d3ac$var$fromWordsUnsafe,
    fromWords: $c01d4687d4f4d3ac$var$fromWords
};

});

parcelRequire.register("iEaZ1", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $d9347b79faa289ba$export$83d89fbfd8236492; });
var $d9347b79faa289ba$export$83d89fbfd8236492 = "providers/5.7.2";

});

parcelRequire.register("f1MgE", function(module, exports) {

$parcel$export(module.exports, "Formatter", function () { return $af0c63f6ba6ab466$export$a06636add2a09fd8; });
$parcel$export(module.exports, "isCommunityResourcable", function () { return $af0c63f6ba6ab466$export$3091239f5b20b896; });
$parcel$export(module.exports, "isCommunityResource", function () { return $af0c63f6ba6ab466$export$d93d5f61c2498b6; });
$parcel$export(module.exports, "showThrottleMessage", function () { return $af0c63f6ba6ab466$export$4c41bd49e82e82ab; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $e8NrM = parcelRequire("e8NrM");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $5f6Sj = parcelRequire("5f6Sj");

var $2ax4w = parcelRequire("2ax4w");

var $hDQeE = parcelRequire("hDQeE");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");
"use strict";
var $af0c63f6ba6ab466$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
var $af0c63f6ba6ab466$export$a06636add2a09fd8 = /*#__PURE__*/ function() {
    function Formatter() {
        (0, $978gY._)(this, Formatter);
        this.formats = this.getDefaultFormats();
    }
    (0, $kry2a._)(Formatter, [
        {
            key: "getDefaultFormats",
            value: function getDefaultFormats() {
                var _this = this;
                var formats = {};
                var address = this.address.bind(this);
                var bigNumber = this.bigNumber.bind(this);
                var blockTag = this.blockTag.bind(this);
                var data = this.data.bind(this);
                var hash = this.hash.bind(this);
                var hex = this.hex.bind(this);
                var number = this.number.bind(this);
                var type = this.type.bind(this);
                var strictData = function(v) {
                    return _this.data(v, true);
                };
                formats.transaction = {
                    hash: hash,
                    type: type,
                    accessList: Formatter.allowNull(this.accessList.bind(this), null),
                    blockHash: Formatter.allowNull(hash, null),
                    blockNumber: Formatter.allowNull(number, null),
                    transactionIndex: Formatter.allowNull(number, null),
                    confirmations: Formatter.allowNull(number, null),
                    from: address,
                    // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
                    // must be set
                    gasPrice: Formatter.allowNull(bigNumber),
                    maxPriorityFeePerGas: Formatter.allowNull(bigNumber),
                    maxFeePerGas: Formatter.allowNull(bigNumber),
                    gasLimit: bigNumber,
                    to: Formatter.allowNull(address, null),
                    value: bigNumber,
                    nonce: number,
                    data: data,
                    r: Formatter.allowNull(this.uint256),
                    s: Formatter.allowNull(this.uint256),
                    v: Formatter.allowNull(number),
                    creates: Formatter.allowNull(address, null),
                    raw: Formatter.allowNull(data)
                };
                formats.transactionRequest = {
                    from: Formatter.allowNull(address),
                    nonce: Formatter.allowNull(number),
                    gasLimit: Formatter.allowNull(bigNumber),
                    gasPrice: Formatter.allowNull(bigNumber),
                    maxPriorityFeePerGas: Formatter.allowNull(bigNumber),
                    maxFeePerGas: Formatter.allowNull(bigNumber),
                    to: Formatter.allowNull(address),
                    value: Formatter.allowNull(bigNumber),
                    data: Formatter.allowNull(strictData),
                    type: Formatter.allowNull(number),
                    accessList: Formatter.allowNull(this.accessList.bind(this), null)
                };
                formats.receiptLog = {
                    transactionIndex: number,
                    blockNumber: number,
                    transactionHash: hash,
                    address: address,
                    topics: Formatter.arrayOf(hash),
                    data: data,
                    logIndex: number,
                    blockHash: hash
                };
                formats.receipt = {
                    to: Formatter.allowNull(this.address, null),
                    from: Formatter.allowNull(this.address, null),
                    contractAddress: Formatter.allowNull(address, null),
                    transactionIndex: number,
                    // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
                    root: Formatter.allowNull(hex),
                    gasUsed: bigNumber,
                    logsBloom: Formatter.allowNull(data),
                    blockHash: hash,
                    transactionHash: hash,
                    logs: Formatter.arrayOf(this.receiptLog.bind(this)),
                    blockNumber: number,
                    confirmations: Formatter.allowNull(number, null),
                    cumulativeGasUsed: bigNumber,
                    effectiveGasPrice: Formatter.allowNull(bigNumber),
                    status: Formatter.allowNull(number),
                    type: type
                };
                formats.block = {
                    hash: Formatter.allowNull(hash),
                    parentHash: hash,
                    number: number,
                    timestamp: number,
                    nonce: Formatter.allowNull(hex),
                    difficulty: this.difficulty.bind(this),
                    gasLimit: bigNumber,
                    gasUsed: bigNumber,
                    miner: Formatter.allowNull(address),
                    extraData: data,
                    transactions: Formatter.allowNull(Formatter.arrayOf(hash)),
                    baseFeePerGas: Formatter.allowNull(bigNumber)
                };
                formats.blockWithTransactions = (0, $2ax4w.shallowCopy)(formats.block);
                formats.blockWithTransactions.transactions = Formatter.allowNull(Formatter.arrayOf(this.transactionResponse.bind(this)));
                formats.filter = {
                    fromBlock: Formatter.allowNull(blockTag, undefined),
                    toBlock: Formatter.allowNull(blockTag, undefined),
                    blockHash: Formatter.allowNull(hash, undefined),
                    address: Formatter.allowNull(address, undefined),
                    topics: Formatter.allowNull(this.topics.bind(this), undefined)
                };
                formats.filterLog = {
                    blockNumber: Formatter.allowNull(number),
                    blockHash: Formatter.allowNull(hash),
                    transactionIndex: number,
                    removed: Formatter.allowNull(this.boolean.bind(this)),
                    address: address,
                    data: Formatter.allowFalsish(data, "0x"),
                    topics: Formatter.arrayOf(hash),
                    transactionHash: hash,
                    logIndex: number
                };
                return formats;
            }
        },
        {
            key: "accessList",
            value: function accessList(accessList) {
                return (0, $hDQeE.accessListify)(accessList || []);
            }
        },
        {
            // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
            // Strict! Used on input.
            key: "number",
            value: function number(number) {
                if (number === "0x") return 0;
                return (0, $gMArf.BigNumber).from(number).toNumber();
            }
        },
        {
            key: "type",
            value: function type(number) {
                if (number === "0x" || number == null) return 0;
                return (0, $gMArf.BigNumber).from(number).toNumber();
            }
        },
        {
            // Strict! Used on input.
            key: "bigNumber",
            value: function bigNumber(value) {
                return (0, $gMArf.BigNumber).from(value);
            }
        },
        {
            // Requires a boolean, "true" or  "false"; returns a boolean
            key: "boolean",
            value: function boolean(value) {
                if (typeof value === "boolean") return value;
                if (typeof value === "string") {
                    value = value.toLowerCase();
                    if (value === "true") return true;
                    if (value === "false") return false;
                }
                throw new Error("invalid boolean - " + value);
            }
        },
        {
            key: "hex",
            value: function hex(value, strict) {
                if (typeof value === "string") {
                    if (!strict && value.substring(0, 2) !== "0x") value = "0x" + value;
                    if ((0, $j2rU8.isHexString)(value)) return value.toLowerCase();
                }
                return $af0c63f6ba6ab466$var$logger.throwArgumentError("invalid hash", "value", value);
            }
        },
        {
            key: "data",
            value: function data(value, strict) {
                var result = this.hex(value, strict);
                if (result.length % 2 !== 0) throw new Error("invalid data; odd-length - " + value);
                return result;
            }
        },
        {
            // Requires an address
            // Strict! Used on input.
            key: "address",
            value: function address(value) {
                return (0, $e8NrM.getAddress)(value);
            }
        },
        {
            key: "callAddress",
            value: function callAddress(value) {
                if (!(0, $j2rU8.isHexString)(value, 32)) return null;
                var address = (0, $e8NrM.getAddress)((0, $j2rU8.hexDataSlice)(value, 12));
                return address === (0, $5f6Sj.AddressZero) ? null : address;
            }
        },
        {
            key: "contractAddress",
            value: function contractAddress(value) {
                return (0, $e8NrM.getContractAddress)(value);
            }
        },
        {
            // Strict! Used on input.
            key: "blockTag",
            value: function blockTag(blockTag) {
                if (blockTag == null) return "latest";
                if (blockTag === "earliest") return "0x0";
                switch(blockTag){
                    case "earliest":
                        return "0x0";
                    case "latest":
                    case "pending":
                    case "safe":
                    case "finalized":
                        return blockTag;
                }
                if (typeof blockTag === "number" || (0, $j2rU8.isHexString)(blockTag)) return (0, $j2rU8.hexValue)(blockTag);
                throw new Error("invalid blockTag");
            }
        },
        {
            // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
            key: "hash",
            value: function hash(value, strict) {
                var result = this.hex(value, strict);
                if ((0, $j2rU8.hexDataLength)(result) !== 32) return $af0c63f6ba6ab466$var$logger.throwArgumentError("invalid hash", "value", value);
                return result;
            }
        },
        {
            // Returns the difficulty as a number, or if too large (i.e. PoA network) null
            key: "difficulty",
            value: function difficulty(value) {
                if (value == null) return null;
                var v = (0, $gMArf.BigNumber).from(value);
                try {
                    return v.toNumber();
                } catch (error) {}
                return null;
            }
        },
        {
            key: "uint256",
            value: function uint256(value) {
                if (!(0, $j2rU8.isHexString)(value)) throw new Error("invalid uint256");
                return (0, $j2rU8.hexZeroPad)(value, 32);
            }
        },
        {
            key: "_block",
            value: function _block(value, format) {
                if (value.author != null && value.miner == null) value.miner = value.author;
                // The difficulty may need to come from _difficulty in recursed blocks
                var difficulty = value._difficulty != null ? value._difficulty : value.difficulty;
                var result = Formatter.check(format, value);
                result._difficulty = difficulty == null ? null : (0, $gMArf.BigNumber).from(difficulty);
                return result;
            }
        },
        {
            key: "block",
            value: function block(value) {
                return this._block(value, this.formats.block);
            }
        },
        {
            key: "blockWithTransactions",
            value: function blockWithTransactions(value) {
                return this._block(value, this.formats.blockWithTransactions);
            }
        },
        {
            // Strict! Used on input.
            key: "transactionRequest",
            value: function transactionRequest(value) {
                return Formatter.check(this.formats.transactionRequest, value);
            }
        },
        {
            key: "transactionResponse",
            value: function transactionResponse(transaction) {
                // Rename gas to gasLimit
                if (transaction.gas != null && transaction.gasLimit == null) transaction.gasLimit = transaction.gas;
                // Some clients (TestRPC) do strange things like return 0x0 for the
                // 0 address; correct this to be a real address
                if (transaction.to && (0, $gMArf.BigNumber).from(transaction.to).isZero()) transaction.to = "0x0000000000000000000000000000000000000000";
                // Rename input to data
                if (transaction.input != null && transaction.data == null) transaction.data = transaction.input;
                // If to and creates are empty, populate the creates from the transaction
                if (transaction.to == null && transaction.creates == null) transaction.creates = this.contractAddress(transaction);
                if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) transaction.accessList = [];
                var result = Formatter.check(this.formats.transaction, transaction);
                if (transaction.chainId != null) {
                    var chainId = transaction.chainId;
                    if ((0, $j2rU8.isHexString)(chainId)) chainId = (0, $gMArf.BigNumber).from(chainId).toNumber();
                    result.chainId = chainId;
                } else {
                    var chainId1 = transaction.networkId;
                    // geth-etc returns chainId
                    if (chainId1 == null && result.v == null) chainId1 = transaction.chainId;
                    if ((0, $j2rU8.isHexString)(chainId1)) chainId1 = (0, $gMArf.BigNumber).from(chainId1).toNumber();
                    if (typeof chainId1 !== "number" && result.v != null) {
                        chainId1 = (result.v - 35) / 2;
                        if (chainId1 < 0) chainId1 = 0;
                        chainId1 = parseInt(chainId1);
                    }
                    if (typeof chainId1 !== "number") chainId1 = 0;
                    result.chainId = chainId1;
                }
                // 0x0000... should actually be null
                if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") result.blockHash = null;
                return result;
            }
        },
        {
            key: "transaction",
            value: function transaction(value) {
                return (0, $hDQeE.parse)(value);
            }
        },
        {
            key: "receiptLog",
            value: function receiptLog(value) {
                return Formatter.check(this.formats.receiptLog, value);
            }
        },
        {
            key: "receipt",
            value: function receipt(value) {
                var result = Formatter.check(this.formats.receipt, value);
                // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
                if (result.root != null) {
                    if (result.root.length <= 4) {
                        // Could be 0x00, 0x0, 0x01 or 0x1
                        var _$value = (0, $gMArf.BigNumber).from(result.root).toNumber();
                        if (_$value === 0 || _$value === 1) {
                            // Make sure if both are specified, they match
                            if (result.status != null && result.status !== _$value) $af0c63f6ba6ab466$var$logger.throwArgumentError("alt-root-status/status mismatch", "value", {
                                root: result.root,
                                status: result.status
                            });
                            result.status = _$value;
                            delete result.root;
                        } else $af0c63f6ba6ab466$var$logger.throwArgumentError("invalid alt-root-status", "value.root", result.root);
                    } else if (result.root.length !== 66) // Must be a valid bytes32
                    $af0c63f6ba6ab466$var$logger.throwArgumentError("invalid root hash", "value.root", result.root);
                }
                if (result.status != null) result.byzantium = true;
                return result;
            }
        },
        {
            key: "topics",
            value: function topics(value) {
                var _this = this;
                if (Array.isArray(value)) return value.map(function(v) {
                    return _this.topics(v);
                });
                else if (value != null) return this.hash(value, true);
                return null;
            }
        },
        {
            key: "filter",
            value: function filter(value) {
                return Formatter.check(this.formats.filter, value);
            }
        },
        {
            key: "filterLog",
            value: function filterLog(value) {
                return Formatter.check(this.formats.filterLog, value);
            }
        }
    ], [
        {
            key: "check",
            value: function check(format, object) {
                var result = {};
                for(var key in format)try {
                    var value = format[key](object[key]);
                    if (value !== undefined) result[key] = value;
                } catch (error) {
                    error.checkKey = key;
                    error.checkValue = object[key];
                    throw error;
                }
                return result;
            }
        },
        {
            key: "allowNull",
            value: // if value is null-ish, nullValue is returned
            function allowNull(format, nullValue) {
                return function(value) {
                    if (value == null) return nullValue;
                    return format(value);
                };
            }
        },
        {
            key: "allowFalsish",
            value: // If value is false-ish, replaceValue is returned
            function allowFalsish(format, replaceValue) {
                return function(value) {
                    if (!value) return replaceValue;
                    return format(value);
                };
            }
        },
        {
            key: "arrayOf",
            value: // Requires an Array satisfying check
            function arrayOf(format) {
                return function(array) {
                    if (!Array.isArray(array)) throw new Error("not an array");
                    var result = [];
                    array.forEach(function(value) {
                        result.push(format(value));
                    });
                    return result;
                };
            }
        }
    ]);
    return Formatter;
}();
function $af0c63f6ba6ab466$export$3091239f5b20b896(value) {
    return value && typeof value.isCommunityResource === "function";
}
function $af0c63f6ba6ab466$export$d93d5f61c2498b6(value) {
    return $af0c63f6ba6ab466$export$3091239f5b20b896(value) && value.isCommunityResource();
}
// Show the throttle message only once
var $af0c63f6ba6ab466$var$throttleMessage = false;
function $af0c63f6ba6ab466$export$4c41bd49e82e82ab() {
    if ($af0c63f6ba6ab466$var$throttleMessage) return;
    $af0c63f6ba6ab466$var$throttleMessage = true;
    console.log("========= NOTICE =========");
    console.log("Request-Rate Exceeded  (this message will not be repeated)");
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.io/api-keys/");
    console.log("==========================");
}

});


parcelRequire.register("d8HAg", function(module, exports) {

$parcel$export(module.exports, "AlchemyWebSocketProvider", function () { return $990dd48e125b1d3c$export$f6c13301c7b76371; });
$parcel$export(module.exports, "AlchemyProvider", function () { return $990dd48e125b1d3c$export$999cc40da3fbc6f; });

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $2ax4w = parcelRequire("2ax4w");

var $f1MgE = parcelRequire("f1MgE");

var $dCAfX = parcelRequire("dCAfX");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");

var $jLiNX = parcelRequire("jLiNX");
"use strict";
var $990dd48e125b1d3c$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
// This key was provided to ethers.js by Alchemy to be used by the
// default provider, but it is recommended that for your own
// production environments, that you acquire your own API key at:
//   https://dashboard.alchemyapi.io
var $990dd48e125b1d3c$var$defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
var $990dd48e125b1d3c$export$f6c13301c7b76371 = /*#__PURE__*/ function(WebSocketProvider) {
    (0, $ftJVG._)(AlchemyWebSocketProvider, WebSocketProvider);
    var _super = (0, $6OZAO._)(AlchemyWebSocketProvider);
    function AlchemyWebSocketProvider(network, apiKey) {
        (0, $978gY._)(this, AlchemyWebSocketProvider);
        var _this;
        var provider = new $990dd48e125b1d3c$export$999cc40da3fbc6f(network, apiKey);
        var url = provider.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
        _this = _super.call(this, url, provider.network);
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "apiKey", provider.apiKey);
        return _this;
    }
    (0, $kry2a._)(AlchemyWebSocketProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.apiKey === $990dd48e125b1d3c$var$defaultApiKey;
            }
        }
    ]);
    return AlchemyWebSocketProvider;
}((0, $dCAfX.WebSocketProvider));
var $990dd48e125b1d3c$export$999cc40da3fbc6f = /*#__PURE__*/ function(UrlJsonRpcProvider) {
    (0, $ftJVG._)(AlchemyProvider, UrlJsonRpcProvider);
    var _super = (0, $6OZAO._)(AlchemyProvider);
    function AlchemyProvider() {
        (0, $978gY._)(this, AlchemyProvider);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(AlchemyProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.apiKey === $990dd48e125b1d3c$var$defaultApiKey;
            }
        }
    ], [
        {
            key: "getWebSocketProvider",
            value: function getWebSocketProvider(network, apiKey) {
                return new $990dd48e125b1d3c$export$f6c13301c7b76371(network, apiKey);
            }
        },
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                if (apiKey == null) return $990dd48e125b1d3c$var$defaultApiKey;
                if (apiKey && typeof apiKey !== "string") $990dd48e125b1d3c$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
                return apiKey;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                var host = null;
                switch(network.name){
                    case "homestead":
                        host = "eth-mainnet.alchemyapi.io/v2/";
                        break;
                    case "goerli":
                        host = "eth-goerli.g.alchemy.com/v2/";
                        break;
                    case "matic":
                        host = "polygon-mainnet.g.alchemy.com/v2/";
                        break;
                    case "maticmum":
                        host = "polygon-mumbai.g.alchemy.com/v2/";
                        break;
                    case "arbitrum":
                        host = "arb-mainnet.g.alchemy.com/v2/";
                        break;
                    case "arbitrum-goerli":
                        host = "arb-goerli.g.alchemy.com/v2/";
                        break;
                    case "optimism":
                        host = "opt-mainnet.g.alchemy.com/v2/";
                        break;
                    case "optimism-goerli":
                        host = "opt-goerli.g.alchemy.com/v2/";
                        break;
                    default:
                        $990dd48e125b1d3c$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
                }
                return {
                    allowGzip: true,
                    url: "https://" + host + apiKey,
                    throttleCallback: function(attempt, url) {
                        if (apiKey === $990dd48e125b1d3c$var$defaultApiKey) (0, $f1MgE.showThrottleMessage)();
                        return Promise.resolve(true);
                    }
                };
            }
        }
    ]);
    return AlchemyProvider;
}((0, $jLiNX.UrlJsonRpcProvider));

});
parcelRequire.register("dCAfX", function(module, exports) {

$parcel$export(module.exports, "WebSocketProvider", function () { return $9eaaf2b70511b007$export$bfafe629242f30bd; });

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $ho5gk = parcelRequire("ho5gk");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $gMArf = parcelRequire("gMArf");

var $2ax4w = parcelRequire("2ax4w");

var $aDPpa = parcelRequire("aDPpa");

var $hiXBj = parcelRequire("hiXBj");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");
"use strict";
var $9eaaf2b70511b007$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9eaaf2b70511b007$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
/**
 *  Notes:
 *
 *  This provider differs a bit from the polling providers. One main
 *  difference is how it handles consistency. The polling providers
 *  will stall responses to ensure a consistent state, while this
 *  WebSocket provider assumes the connected backend will manage this.
 *
 *  For example, if a polling provider emits an event which indicates
 *  the event occurred in blockhash XXX, a call to fetch that block by
 *  its hash XXX, if not present will retry until it is present. This
 *  can occur when querying a pool of nodes that are mildly out of sync
 *  with each other.
 */ var $9eaaf2b70511b007$var$NextId = 1;
var $9eaaf2b70511b007$export$bfafe629242f30bd = /*#__PURE__*/ function(JsonRpcProvider) {
    (0, $ftJVG._)(WebSocketProvider, JsonRpcProvider);
    var _super = (0, $6OZAO._)(WebSocketProvider);
    function WebSocketProvider(url, network) {
        (0, $978gY._)(this, WebSocketProvider);
        var _this;
        // This will be added in the future; please open an issue to expedite
        if (network === "any") $9eaaf2b70511b007$var$logger.throwError("WebSocketProvider does not support 'any' network yet", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "network:any"
        });
        if (typeof url === "string") _this = _super.call(this, url, network);
        else _this = _super.call(this, "_websocket", network);
        _this._pollingInterval = -1;
        _this._wsReady = false;
        if (typeof url === "string") (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_websocket", new (0, $hiXBj.WebSocket)(_this.connection.url));
        else (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_websocket", url);
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_requests", {});
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_subs", {});
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_subIds", {});
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_detectNetwork", (0, $3cct3._)(((0, $3vWwE._)(_this), (0, $g3d7z._)(WebSocketProvider.prototype)), "detectNetwork", _this).call(_this));
        // Stall sending requests until the socket is open...
        _this.websocket.onopen = function() {
            _this._wsReady = true;
            Object.keys(_this._requests).forEach(function(id) {
                _this.websocket.send(_this._requests[id].payload);
            });
        };
        _this.websocket.onmessage = function(messageEvent) {
            var data = messageEvent.data;
            var result = JSON.parse(data);
            if (result.id != null) {
                var id = String(result.id);
                var request = _this._requests[id];
                delete _this._requests[id];
                if (result.result !== undefined) {
                    request.callback(null, result.result);
                    _this.emit("debug", {
                        action: "response",
                        request: JSON.parse(request.payload),
                        response: result.result,
                        provider: (0, $3vWwE._)(_this)
                    });
                } else {
                    var error = null;
                    if (result.error) {
                        error = new Error(result.error.message || "unknown error");
                        (0, $2ax4w.defineReadOnly)(error, "code", result.error.code || null);
                        (0, $2ax4w.defineReadOnly)(error, "response", data);
                    } else error = new Error("unknown error");
                    request.callback(error, undefined);
                    _this.emit("debug", {
                        action: "response",
                        error: error,
                        request: JSON.parse(request.payload),
                        provider: (0, $3vWwE._)(_this)
                    });
                }
            } else if (result.method === "eth_subscription") {
                // Subscription...
                var sub = _this._subs[result.params.subscription];
                if (sub) //this.emit.apply(this,                  );
                sub.processFunc(result.params.result);
            } else console.warn("this should not happen");
        };
        // This Provider does not actually poll, but we want to trigger
        // poll events for things that depend on them (like stalling for
        // block and transaction lookups)
        var fauxPoll = setInterval(function() {
            _this.emit("poll");
        }, 1000);
        if (fauxPoll.unref) fauxPoll.unref();
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(WebSocketProvider, [
        {
            key: "websocket",
            get: // Cannot narrow the type of _websocket, as that is not backwards compatible
            // so we add a getter and let the WebSocket be a public API.
            function get() {
                return this._websocket;
            }
        },
        {
            key: "detectNetwork",
            value: function detectNetwork() {
                return this._detectNetwork;
            }
        },
        {
            key: "pollingInterval",
            get: function get() {
                return 0;
            },
            set: function set(value) {
                $9eaaf2b70511b007$var$logger.throwError("cannot set polling interval on WebSocketProvider", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "setPollingInterval"
                });
            }
        },
        {
            key: "resetEventsBlock",
            value: function resetEventsBlock(blockNumber) {
                $9eaaf2b70511b007$var$logger.throwError("cannot reset events block on WebSocketProvider", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "resetEventBlock"
                });
            }
        },
        {
            key: "poll",
            value: function poll() {
                return $9eaaf2b70511b007$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            null
                        ];
                    });
                });
            }
        },
        {
            key: "polling",
            set: function set(value) {
                if (!value) return;
                $9eaaf2b70511b007$var$logger.throwError("cannot set polling on WebSocketProvider", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "setPolling"
                });
            }
        },
        {
            key: "send",
            value: function send(method, params) {
                var _this = this;
                var rid = $9eaaf2b70511b007$var$NextId++;
                return new Promise(function(resolve, reject) {
                    var callback = function callback(error, result) {
                        if (error) return reject(error);
                        return resolve(result);
                    };
                    var payload = JSON.stringify({
                        method: method,
                        params: params,
                        id: rid,
                        jsonrpc: "2.0"
                    });
                    _this.emit("debug", {
                        action: "request",
                        request: JSON.parse(payload),
                        provider: _this
                    });
                    _this._requests[String(rid)] = {
                        callback: callback,
                        payload: payload
                    };
                    if (_this._wsReady) _this.websocket.send(payload);
                });
            }
        },
        {
            key: "_subscribe",
            value: function _subscribe(tag, param, processFunc) {
                return $9eaaf2b70511b007$var$__awaiter(this, void 0, void 0, function() {
                    var _this, subIdPromise, subId;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                subIdPromise = this._subIds[tag];
                                if (subIdPromise == null) {
                                    subIdPromise = Promise.all(param).then(function(param) {
                                        return _this.send("eth_subscribe", param);
                                    });
                                    this._subIds[tag] = subIdPromise;
                                }
                                return [
                                    4,
                                    subIdPromise
                                ];
                            case 1:
                                subId = _state.sent();
                                this._subs[subId] = {
                                    tag: tag,
                                    processFunc: processFunc
                                };
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_startEvent",
            value: function _startEvent(event) {
                var _this = this;
                switch(event.type){
                    case "block":
                        this._subscribe("block", [
                            "newHeads"
                        ], function(result) {
                            var blockNumber = (0, $gMArf.BigNumber).from(result.number).toNumber();
                            _this._emitted.block = blockNumber;
                            _this.emit("block", blockNumber);
                        });
                        break;
                    case "pending":
                        this._subscribe("pending", [
                            "newPendingTransactions"
                        ], function(result) {
                            _this.emit("pending", result);
                        });
                        break;
                    case "filter":
                        this._subscribe(event.tag, [
                            "logs",
                            this._getFilter(event.filter)
                        ], function(result) {
                            if (result.removed == null) result.removed = false;
                            _this.emit(event.filter, _this.formatter.filterLog(result));
                        });
                        break;
                    case "tx":
                        {
                            var emitReceipt = function(event) {
                                var hash = event.hash;
                                _this.getTransactionReceipt(hash).then(function(receipt) {
                                    if (!receipt) return;
                                    _this.emit(hash, receipt);
                                });
                            };
                            // In case it is already mined
                            emitReceipt(event);
                            // To keep things simple, we start up a single newHeads subscription
                            // to keep an eye out for transactions we are watching for.
                            // Starting a subscription for an event (i.e. "tx") that is already
                            // running is (basically) a nop.
                            this._subscribe("tx", [
                                "newHeads"
                            ], function(result) {
                                _this._events.filter(function(e) {
                                    return e.type === "tx";
                                }).forEach(emitReceipt);
                            });
                            break;
                        }
                    // Nothing is needed
                    case "debug":
                    case "poll":
                    case "willPoll":
                    case "didPoll":
                    case "error":
                        break;
                    default:
                        console.log("unhandled:", event);
                        break;
                }
            }
        },
        {
            key: "_stopEvent",
            value: function _stopEvent(event) {
                var _this = this;
                var tag = event.tag;
                if (event.type === "tx") {
                    // There are remaining transaction event listeners
                    if (this._events.filter(function(e) {
                        return e.type === "tx";
                    }).length) return;
                    tag = "tx";
                } else if (this.listenerCount(event.event)) // There are remaining event listeners
                return;
                var subId = this._subIds[tag];
                if (!subId) return;
                delete this._subIds[tag];
                subId.then(function(subId) {
                    if (!_this._subs[subId]) return;
                    delete _this._subs[subId];
                    _this.send("eth_unsubscribe", [
                        subId
                    ]);
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                return $9eaaf2b70511b007$var$__awaiter(this, void 0, void 0, function() {
                    var _this;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (!(this.websocket.readyState === (0, $hiXBj.WebSocket).CONNECTING)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.websocket.onopen = function() {
                                            resolve(true);
                                        };
                                        _this.websocket.onerror = function() {
                                            resolve(false);
                                        };
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                // Hangup
                                // See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
                                this.websocket.close(1000);
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ], [
        {
            key: "defaultUrl",
            value: function defaultUrl() {
                return "ws://localhost:8546";
            }
        }
    ]);
    return WebSocketProvider;
}((0, $aDPpa.JsonRpcProvider));

});
parcelRequire.register("aDPpa", function(module, exports) {

$parcel$export(module.exports, "JsonRpcSigner", function () { return $7bf56bd7b17e0046$export$5f7b5fca3508545a; });
$parcel$export(module.exports, "JsonRpcProvider", function () { return $7bf56bd7b17e0046$export$da28308012bf6748; });

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $iGUqv = parcelRequire("iGUqv");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $kdj79 = parcelRequire("kdj79");

var $2ax4w = parcelRequire("2ax4w");

var $1Wmc7 = parcelRequire("1Wmc7");

var $hDQeE = parcelRequire("hDQeE");

var $gqL7R = parcelRequire("gqL7R");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");

var $96Por = parcelRequire("96Por");
"use strict";
var $7bf56bd7b17e0046$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7bf56bd7b17e0046$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
var $7bf56bd7b17e0046$var$errorGas = [
    "call",
    "estimateGas"
];
function $7bf56bd7b17e0046$var$spelunk(value, requireData) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match("reverted")) {
        var data = (0, $j2rU8.isHexString)(value.data) ? value.data : null;
        if (!requireData || data) return {
            message: value.message,
            data: data
        };
    }
    // Spelunk further...
    if (typeof value === "object") {
        for(var key in value){
            var result = $7bf56bd7b17e0046$var$spelunk(value[key], requireData);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $7bf56bd7b17e0046$var$spelunk(JSON.parse(value), requireData);
    } catch (error) {}
    return null;
}
function $7bf56bd7b17e0046$var$checkError(method, error, params) {
    var transaction = params.transaction || params.signedTransaction;
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call") {
        var result = $7bf56bd7b17e0046$var$spelunk(error, true);
        if (result) return result.data;
        // Nothing descriptive..
        $7bf56bd7b17e0046$var$logger.throwError("missing revert data in call exception; Transaction reverted without a reason string", (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
            data: "0x",
            transaction: transaction,
            error: error
        });
    }
    if (method === "estimateGas") {
        // Try to find something, with a preference on SERVER_ERROR body
        var result1 = $7bf56bd7b17e0046$var$spelunk(error.body, false);
        if (result1 == null) result1 = $7bf56bd7b17e0046$var$spelunk(error, false);
        // Found "reverted", this is a CALL_EXCEPTION
        if (result1) $7bf56bd7b17e0046$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $6M65e.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
            reason: result1.message,
            method: method,
            transaction: transaction,
            error: error
        });
    }
    // @TODO: Should we spelunk for message too?
    var message = error.message;
    if (error.code === (0, $6M65e.Logger).errors.SERVER_ERROR && error.error && typeof error.error.message === "string") message = error.error.message;
    else if (typeof error.body === "string") message = error.body;
    else if (typeof error.responseText === "string") message = error.responseText;
    message = (message || "").toLowerCase();
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit|InsufficientFunds/i)) $7bf56bd7b17e0046$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $6M65e.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "nonce too low"
    if (message.match(/nonce (is )?too low/i)) $7bf56bd7b17e0046$var$logger.throwError("nonce has already been used", (0, $6M65e.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced|transaction gas price.*too low/i)) $7bf56bd7b17e0046$var$logger.throwError("replacement fee too low", (0, $6M65e.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/i)) $7bf56bd7b17e0046$var$logger.throwError("legacy pre-eip-155 transactions not supported", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
        error: error,
        method: method,
        transaction: transaction
    });
    if ($7bf56bd7b17e0046$var$errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted|revert/)) $7bf56bd7b17e0046$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $6M65e.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
function $7bf56bd7b17e0046$var$timer(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $7bf56bd7b17e0046$var$getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        var error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function $7bf56bd7b17e0046$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
var $7bf56bd7b17e0046$var$_constructorGuard = {};
var $7bf56bd7b17e0046$export$5f7b5fca3508545a = /*#__PURE__*/ function(Signer) {
    (0, $ftJVG._)(JsonRpcSigner, Signer);
    var _super = (0, $6OZAO._)(JsonRpcSigner);
    function JsonRpcSigner(constructorGuard, provider, addressOrIndex) {
        (0, $978gY._)(this, JsonRpcSigner);
        var _this;
        _this = _super.call(this);
        if (constructorGuard !== $7bf56bd7b17e0046$var$_constructorGuard) throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "provider", provider);
        if (addressOrIndex == null) addressOrIndex = 0;
        if (typeof addressOrIndex === "string") {
            (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_address", _this.provider.formatter.address(addressOrIndex));
            (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_index", null);
        } else if (typeof addressOrIndex === "number") {
            (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_index", addressOrIndex);
            (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "_address", null);
        } else $7bf56bd7b17e0046$var$logger.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
        return _this;
    }
    (0, $kry2a._)(JsonRpcSigner, [
        {
            key: "connect",
            value: function connect(provider) {
                return $7bf56bd7b17e0046$var$logger.throwError("cannot alter JSON-RPC Signer connection", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "connect"
                });
            }
        },
        {
            key: "connectUnchecked",
            value: function connectUnchecked() {
                return new $7bf56bd7b17e0046$var$UncheckedJsonRpcSigner($7bf56bd7b17e0046$var$_constructorGuard, this.provider, this._address || this._index);
            }
        },
        {
            key: "getAddress",
            value: function getAddress() {
                var _this = this;
                if (this._address) return Promise.resolve(this._address);
                return this.provider.send("eth_accounts", []).then(function(accounts) {
                    if (accounts.length <= _this._index) $7bf56bd7b17e0046$var$logger.throwError("unknown account #" + _this._index, (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "getAddress"
                    });
                    return _this.provider.formatter.address(accounts[_this._index]);
                });
            }
        },
        {
            key: "sendUncheckedTransaction",
            value: function sendUncheckedTransaction(transaction) {
                var _this = this;
                transaction = (0, $2ax4w.shallowCopy)(transaction);
                var fromAddress = this.getAddress().then(function(address) {
                    if (address) address = address.toLowerCase();
                    return address;
                });
                // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
                // wishes to use this, it is easy to specify explicitly, otherwise
                // we look it up for them.
                if (transaction.gasLimit == null) {
                    var estimate = (0, $2ax4w.shallowCopy)(transaction);
                    estimate.from = fromAddress;
                    transaction.gasLimit = this.provider.estimateGas(estimate);
                }
                if (transaction.to != null) transaction.to = Promise.resolve(transaction.to).then(function(to) {
                    return $7bf56bd7b17e0046$var$__awaiter(_this, void 0, void 0, function() {
                        var address;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (to == null) return [
                                        2,
                                        null
                                    ];
                                    return [
                                        4,
                                        this.provider.resolveName(to)
                                    ];
                                case 1:
                                    address = _state.sent();
                                    if (address == null) $7bf56bd7b17e0046$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                                    return [
                                        2,
                                        address
                                    ];
                            }
                        });
                    });
                });
                return (0, $2ax4w.resolveProperties)({
                    tx: (0, $2ax4w.resolveProperties)(transaction),
                    sender: fromAddress
                }).then(function(param) {
                    var tx = param.tx, sender = param.sender;
                    if (tx.from != null) {
                        if (tx.from.toLowerCase() !== sender) $7bf56bd7b17e0046$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
                    } else tx.from = sender;
                    var hexTx = _this.provider.constructor.hexlifyTransaction(tx, {
                        from: true
                    });
                    return _this.provider.send("eth_sendTransaction", [
                        hexTx
                    ]).then(function(hash) {
                        return hash;
                    }, function(error) {
                        if (typeof error.message === "string" && error.message.match(/user denied/i)) $7bf56bd7b17e0046$var$logger.throwError("user rejected transaction", (0, $6M65e.Logger).errors.ACTION_REJECTED, {
                            action: "sendTransaction",
                            transaction: tx
                        });
                        return $7bf56bd7b17e0046$var$checkError("sendTransaction", error, hexTx);
                    });
                });
            }
        },
        {
            key: "signTransaction",
            value: function signTransaction(transaction) {
                return $7bf56bd7b17e0046$var$logger.throwError("signing transactions is unsupported", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "signTransaction"
                });
            }
        },
        {
            key: "sendTransaction",
            value: function sendTransaction(transaction) {
                return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function() {
                    var _this, blockNumber, hash, error;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval)
                                ];
                            case 1:
                                blockNumber = _state.sent();
                                return [
                                    4,
                                    this.sendUncheckedTransaction(transaction)
                                ];
                            case 2:
                                hash = _state.sent();
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    (0, $gqL7R.poll)(function() {
                                        return $7bf56bd7b17e0046$var$__awaiter(_this, void 0, void 0, function() {
                                            var tx;
                                            return (0, $7UAGh.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.provider.getTransaction(hash)
                                                        ];
                                                    case 1:
                                                        tx = _state.sent();
                                                        if (tx === null) return [
                                                            2,
                                                            undefined
                                                        ];
                                                        return [
                                                            2,
                                                            this.provider._wrapTransaction(tx, hash, blockNumber)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        oncePoll: this.provider
                                    })
                                ];
                            case 4:
                                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                                // for a response, and we need the actual transaction, so we poll
                                // for it; it should show up very quickly
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                error = _state.sent();
                                error.transactionHash = hash;
                                throw error;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "signMessage",
            value: function signMessage(message) {
                return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function() {
                    var data, address, error;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                data = typeof message === "string" ? (0, $1Wmc7.toUtf8Bytes)(message) : message;
                                return [
                                    4,
                                    this.getAddress()
                                ];
                            case 1:
                                address = _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    this.provider.send("personal_sign", [
                                        (0, $j2rU8.hexlify)(data),
                                        address.toLowerCase()
                                    ])
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                error = _state.sent();
                                if (typeof error.message === "string" && error.message.match(/user denied/i)) $7bf56bd7b17e0046$var$logger.throwError("user rejected signing", (0, $6M65e.Logger).errors.ACTION_REJECTED, {
                                    action: "signMessage",
                                    from: address,
                                    messageData: message
                                });
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_legacySignMessage",
            value: function _legacySignMessage(message) {
                return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function() {
                    var data, address, error;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                data = typeof message === "string" ? (0, $1Wmc7.toUtf8Bytes)(message) : message;
                                return [
                                    4,
                                    this.getAddress()
                                ];
                            case 1:
                                address = _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    this.provider.send("eth_sign", [
                                        address.toLowerCase(),
                                        (0, $j2rU8.hexlify)(data)
                                    ])
                                ];
                            case 3:
                                // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                error = _state.sent();
                                if (typeof error.message === "string" && error.message.match(/user denied/i)) $7bf56bd7b17e0046$var$logger.throwError("user rejected signing", (0, $6M65e.Logger).errors.ACTION_REJECTED, {
                                    action: "_legacySignMessage",
                                    from: address,
                                    messageData: message
                                });
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_signTypedData",
            value: function _signTypedData(domain, types, value) {
                return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function() {
                    var _this, populated, address, error;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    (0, $kdj79.TypedDataEncoder).resolveNames(domain, types, value, function(name) {
                                        return _this.provider.resolveName(name);
                                    })
                                ];
                            case 1:
                                populated = _state.sent();
                                return [
                                    4,
                                    this.getAddress()
                                ];
                            case 2:
                                address = _state.sent();
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    this.provider.send("eth_signTypedData_v4", [
                                        address.toLowerCase(),
                                        JSON.stringify((0, $kdj79.TypedDataEncoder).getPayload(populated.domain, types, populated.value))
                                    ])
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                error = _state.sent();
                                if (typeof error.message === "string" && error.message.match(/user denied/i)) $7bf56bd7b17e0046$var$logger.throwError("user rejected signing", (0, $6M65e.Logger).errors.ACTION_REJECTED, {
                                    action: "_signTypedData",
                                    from: address,
                                    messageData: {
                                        domain: populated.domain,
                                        types: types,
                                        value: populated.value
                                    }
                                });
                                throw error;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "unlock",
            value: function unlock(password) {
                return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function() {
                    var provider, address;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                provider = this.provider;
                                return [
                                    4,
                                    this.getAddress()
                                ];
                            case 1:
                                address = _state.sent();
                                return [
                                    2,
                                    provider.send("personal_unlockAccount", [
                                        address.toLowerCase(),
                                        password,
                                        null
                                    ])
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return JsonRpcSigner;
}((0, $iGUqv.Signer));
var $7bf56bd7b17e0046$var$UncheckedJsonRpcSigner = /*#__PURE__*/ function(JsonRpcSigner) {
    (0, $ftJVG._)(UncheckedJsonRpcSigner, JsonRpcSigner);
    var _super = (0, $6OZAO._)(UncheckedJsonRpcSigner);
    function UncheckedJsonRpcSigner() {
        (0, $978gY._)(this, UncheckedJsonRpcSigner);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(UncheckedJsonRpcSigner, [
        {
            key: "sendTransaction",
            value: function sendTransaction(transaction) {
                var _this = this;
                return this.sendUncheckedTransaction(transaction).then(function(hash) {
                    return {
                        hash: hash,
                        nonce: null,
                        gasLimit: null,
                        gasPrice: null,
                        data: null,
                        value: null,
                        chainId: null,
                        confirmations: 0,
                        from: null,
                        wait: function(confirmations) {
                            return _this.provider.waitForTransaction(hash, confirmations);
                        }
                    };
                });
            }
        }
    ]);
    return UncheckedJsonRpcSigner;
}($7bf56bd7b17e0046$export$5f7b5fca3508545a);
var $7bf56bd7b17e0046$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true
};
var $7bf56bd7b17e0046$export$da28308012bf6748 = /*#__PURE__*/ function(BaseProvider) {
    (0, $ftJVG._)(JsonRpcProvider, BaseProvider);
    var _super = (0, $6OZAO._)(JsonRpcProvider);
    function JsonRpcProvider(url, network) {
        (0, $978gY._)(this, JsonRpcProvider);
        var _this;
        var networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) networkOrReady = new Promise(function(resolve, reject) {
            setTimeout(function() {
                _this.detectNetwork().then(function(network) {
                    resolve(network);
                }, function(error) {
                    reject(error);
                });
            }, 0);
        });
        _this = _super.call(this, networkOrReady);
        // Default URL
        if (!url) url = (0, $2ax4w.getStatic)(_this.constructor, "defaultUrl")();
        if (typeof url === "string") (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "connection", Object.freeze({
            url: url
        }));
        else (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "connection", Object.freeze((0, $2ax4w.shallowCopy)(url)));
        _this._nextId = 42;
        return _this;
    }
    (0, $kry2a._)(JsonRpcProvider, [
        {
            key: "_cache",
            get: function get() {
                if (this._eventLoopCache == null) this._eventLoopCache = {};
                return this._eventLoopCache;
            }
        },
        {
            key: "detectNetwork",
            value: function detectNetwork() {
                var _this = this;
                if (!this._cache["detectNetwork"]) {
                    this._cache["detectNetwork"] = this._uncachedDetectNetwork();
                    // Clear this cache at the beginning of the next event loop
                    setTimeout(function() {
                        _this._cache["detectNetwork"] = null;
                    }, 0);
                }
                return this._cache["detectNetwork"];
            }
        },
        {
            key: "_uncachedDetectNetwork",
            value: function _uncachedDetectNetwork() {
                return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function() {
                    var chainId, error, error1, getNetwork;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $7bf56bd7b17e0046$var$timer(0)
                                ];
                            case 1:
                                _state.sent();
                                chainId = null;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    9
                                ]);
                                return [
                                    4,
                                    this.send("eth_chainId", [])
                                ];
                            case 3:
                                chainId = _state.sent();
                                return [
                                    3,
                                    9
                                ];
                            case 4:
                                error = _state.sent();
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    this.send("net_version", [])
                                ];
                            case 6:
                                chainId = _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                error1 = _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                return [
                                    3,
                                    9
                                ];
                            case 9:
                                if (chainId != null) {
                                    getNetwork = (0, $2ax4w.getStatic)(this.constructor, "getNetwork");
                                    try {
                                        return [
                                            2,
                                            getNetwork((0, $gMArf.BigNumber).from(chainId).toNumber())
                                        ];
                                    } catch (error) {
                                        return [
                                            2,
                                            $7bf56bd7b17e0046$var$logger.throwError("could not detect network", (0, $6M65e.Logger).errors.NETWORK_ERROR, {
                                                chainId: chainId,
                                                event: "invalidNetwork",
                                                serverError: error
                                            })
                                        ];
                                    }
                                }
                                return [
                                    2,
                                    $7bf56bd7b17e0046$var$logger.throwError("could not detect network", (0, $6M65e.Logger).errors.NETWORK_ERROR, {
                                        event: "noNetwork"
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getSigner",
            value: function getSigner(addressOrIndex) {
                return new $7bf56bd7b17e0046$export$5f7b5fca3508545a($7bf56bd7b17e0046$var$_constructorGuard, this, addressOrIndex);
            }
        },
        {
            key: "getUncheckedSigner",
            value: function getUncheckedSigner(addressOrIndex) {
                return this.getSigner(addressOrIndex).connectUnchecked();
            }
        },
        {
            key: "listAccounts",
            value: function listAccounts() {
                var _this = this;
                return this.send("eth_accounts", []).then(function(accounts) {
                    return accounts.map(function(a) {
                        return _this.formatter.address(a);
                    });
                });
            }
        },
        {
            key: "send",
            value: function send(method, params) {
                var _this = this;
                var request = {
                    method: method,
                    params: params,
                    id: this._nextId++,
                    jsonrpc: "2.0"
                };
                this.emit("debug", {
                    action: "request",
                    request: (0, $2ax4w.deepCopy)(request),
                    provider: this
                });
                // We can expand this in the future to any call, but for now these
                // are the biggest wins and do not require any serializing parameters.
                var cache = [
                    "eth_chainId",
                    "eth_blockNumber"
                ].indexOf(method) >= 0;
                if (cache && this._cache[method]) return this._cache[method];
                var result = (0, $gqL7R.fetchJson)(this.connection, JSON.stringify(request), $7bf56bd7b17e0046$var$getResult).then(function(result) {
                    _this.emit("debug", {
                        action: "response",
                        request: request,
                        response: result,
                        provider: _this
                    });
                    return result;
                }, function(error) {
                    _this.emit("debug", {
                        action: "response",
                        error: error,
                        request: request,
                        provider: _this
                    });
                    throw error;
                });
                // Cache the fetch, but clear it on the next event loop
                if (cache) {
                    this._cache[method] = result;
                    setTimeout(function() {
                        _this._cache[method] = null;
                    }, 0);
                }
                return result;
            }
        },
        {
            key: "prepareRequest",
            value: function prepareRequest(method, params) {
                switch(method){
                    case "getBlockNumber":
                        return [
                            "eth_blockNumber",
                            []
                        ];
                    case "getGasPrice":
                        return [
                            "eth_gasPrice",
                            []
                        ];
                    case "getBalance":
                        return [
                            "eth_getBalance",
                            [
                                $7bf56bd7b17e0046$var$getLowerCase(params.address),
                                params.blockTag
                            ]
                        ];
                    case "getTransactionCount":
                        return [
                            "eth_getTransactionCount",
                            [
                                $7bf56bd7b17e0046$var$getLowerCase(params.address),
                                params.blockTag
                            ]
                        ];
                    case "getCode":
                        return [
                            "eth_getCode",
                            [
                                $7bf56bd7b17e0046$var$getLowerCase(params.address),
                                params.blockTag
                            ]
                        ];
                    case "getStorageAt":
                        return [
                            "eth_getStorageAt",
                            [
                                $7bf56bd7b17e0046$var$getLowerCase(params.address),
                                (0, $j2rU8.hexZeroPad)(params.position, 32),
                                params.blockTag
                            ]
                        ];
                    case "sendTransaction":
                        return [
                            "eth_sendRawTransaction",
                            [
                                params.signedTransaction
                            ]
                        ];
                    case "getBlock":
                        if (params.blockTag) return [
                            "eth_getBlockByNumber",
                            [
                                params.blockTag,
                                !!params.includeTransactions
                            ]
                        ];
                        else if (params.blockHash) return [
                            "eth_getBlockByHash",
                            [
                                params.blockHash,
                                !!params.includeTransactions
                            ]
                        ];
                        return null;
                    case "getTransaction":
                        return [
                            "eth_getTransactionByHash",
                            [
                                params.transactionHash
                            ]
                        ];
                    case "getTransactionReceipt":
                        return [
                            "eth_getTransactionReceipt",
                            [
                                params.transactionHash
                            ]
                        ];
                    case "call":
                        {
                            var hexlifyTransaction = (0, $2ax4w.getStatic)(this.constructor, "hexlifyTransaction");
                            return [
                                "eth_call",
                                [
                                    hexlifyTransaction(params.transaction, {
                                        from: true
                                    }),
                                    params.blockTag
                                ]
                            ];
                        }
                    case "estimateGas":
                        {
                            var hexlifyTransaction1 = (0, $2ax4w.getStatic)(this.constructor, "hexlifyTransaction");
                            return [
                                "eth_estimateGas",
                                [
                                    hexlifyTransaction1(params.transaction, {
                                        from: true
                                    })
                                ]
                            ];
                        }
                    case "getLogs":
                        if (params.filter && params.filter.address != null) params.filter.address = $7bf56bd7b17e0046$var$getLowerCase(params.filter.address);
                        return [
                            "eth_getLogs",
                            [
                                params.filter
                            ]
                        ];
                    default:
                        break;
                }
                return null;
            }
        },
        {
            key: "perform",
            value: function perform(method, params) {
                return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function() {
                    var tx, feeData, args, error;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(method === "call" || method === "estimateGas")) return [
                                    3,
                                    2
                                ];
                                tx = params.transaction;
                                if (!(tx && tx.type != null && (0, $gMArf.BigNumber).from(tx.type).isZero())) return [
                                    3,
                                    2
                                ];
                                if (!(tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.getFeeData()
                                ];
                            case 1:
                                feeData = _state.sent();
                                if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                                    // Network doesn't know about EIP-1559 (and hence type)
                                    params = (0, $2ax4w.shallowCopy)(params);
                                    params.transaction = (0, $2ax4w.shallowCopy)(tx);
                                    delete params.transaction.type;
                                }
                                _state.label = 2;
                            case 2:
                                args = this.prepareRequest(method, params);
                                if (args == null) $7bf56bd7b17e0046$var$logger.throwError(method + " not implemented", (0, $6M65e.Logger).errors.NOT_IMPLEMENTED, {
                                    operation: method
                                });
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    this.send(args[0], args[1])
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                error = _state.sent();
                                return [
                                    2,
                                    $7bf56bd7b17e0046$var$checkError(method, error, params)
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_startEvent",
            value: function _startEvent(event) {
                if (event.tag === "pending") this._startPending();
                (0, $3cct3._)((0, $g3d7z._)(JsonRpcProvider.prototype), "_startEvent", this).call(this, event);
            }
        },
        {
            key: "_startPending",
            value: function _startPending() {
                if (this._pendingFilter != null) return;
                var self = this;
                var pendingFilter = this.send("eth_newPendingTransactionFilter", []);
                this._pendingFilter = pendingFilter;
                pendingFilter.then(function(filterId) {
                    function poll() {
                        self.send("eth_getFilterChanges", [
                            filterId
                        ]).then(function(hashes) {
                            if (self._pendingFilter != pendingFilter) return null;
                            var seq = Promise.resolve();
                            hashes.forEach(function(hash) {
                                // @TODO: This should be garbage collected at some point... How? When?
                                self._emitted["t:" + hash.toLowerCase()] = "pending";
                                seq = seq.then(function() {
                                    return self.getTransaction(hash).then(function(tx) {
                                        self.emit("pending", tx);
                                        return null;
                                    });
                                });
                            });
                            return seq.then(function() {
                                return $7bf56bd7b17e0046$var$timer(1000);
                            });
                        }).then(function() {
                            if (self._pendingFilter != pendingFilter) {
                                self.send("eth_uninstallFilter", [
                                    filterId
                                ]);
                                return;
                            }
                            setTimeout(function() {
                                poll();
                            }, 0);
                            return null;
                        }).catch(function(error) {});
                    }
                    poll();
                    return filterId;
                }).catch(function(error) {});
            }
        },
        {
            key: "_stopEvent",
            value: function _stopEvent(event) {
                if (event.tag === "pending" && this.listenerCount("pending") === 0) this._pendingFilter = null;
                (0, $3cct3._)((0, $g3d7z._)(JsonRpcProvider.prototype), "_stopEvent", this).call(this, event);
            }
        }
    ], [
        {
            key: "defaultUrl",
            value: function defaultUrl() {
                return "http://localhost:8545";
            }
        },
        {
            key: "hexlifyTransaction",
            value: // Convert an ethers.js transaction into a JSON-RPC transaction
            //  - gasLimit => gas
            //  - All values hexlified
            //  - All numeric values zero-striped
            //  - All addresses are lowercased
            // NOTE: This allows a TransactionRequest, but all values should be resolved
            //       before this is called
            // @TODO: This will likely be removed in future versions and prepareRequest
            //        will be the preferred method for this.
            function hexlifyTransaction(transaction, allowExtra) {
                // Check only allowed properties are given
                var allowed = (0, $2ax4w.shallowCopy)($7bf56bd7b17e0046$var$allowedTransactionKeys);
                if (allowExtra) {
                    for(var key in allowExtra)if (allowExtra[key]) allowed[key] = true;
                }
                (0, $2ax4w.checkProperties)(transaction, allowed);
                var result = {};
                // JSON-RPC now requires numeric values to be "quantity" values
                [
                    "chainId",
                    "gasLimit",
                    "gasPrice",
                    "type",
                    "maxFeePerGas",
                    "maxPriorityFeePerGas",
                    "nonce",
                    "value"
                ].forEach(function(key) {
                    if (transaction[key] == null) return;
                    var value = (0, $j2rU8.hexValue)((0, $gMArf.BigNumber).from(transaction[key]));
                    if (key === "gasLimit") key = "gas";
                    result[key] = value;
                });
                [
                    "from",
                    "to",
                    "data"
                ].forEach(function(key) {
                    if (transaction[key] == null) return;
                    result[key] = (0, $j2rU8.hexlify)(transaction[key]);
                });
                if (transaction.accessList) result["accessList"] = (0, $hDQeE.accessListify)(transaction.accessList);
                return result;
            }
        }
    ]);
    return JsonRpcProvider;
}((0, $96Por.BaseProvider));

});

parcelRequire.register("hiXBj", function(module, exports) {

$parcel$export(module.exports, "WebSocket", function () { return $c9925991f78188b7$export$3909fb301d3dc8c9; });

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");
"use strict";
var $c9925991f78188b7$export$3909fb301d3dc8c9 = null;
try {
    $c9925991f78188b7$export$3909fb301d3dc8c9 = WebSocket;
    if ($c9925991f78188b7$export$3909fb301d3dc8c9 == null) throw new Error("inject please");
} catch (error) {
    var $c9925991f78188b7$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
    $c9925991f78188b7$export$3909fb301d3dc8c9 = function WS() {
        $c9925991f78188b7$var$logger.throwError("WebSockets not supported in this environment", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new WebSocket()"
        });
    };
}

});


parcelRequire.register("jLiNX", function(module, exports) {

$parcel$export(module.exports, "StaticJsonRpcProvider", function () { return $e630fe5b56031581$export$b3d647c1c29df44d; });
$parcel$export(module.exports, "UrlJsonRpcProvider", function () { return $e630fe5b56031581$export$664128d6239ccf96; });

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");

var $aDPpa = parcelRequire("aDPpa");
"use strict";
var $e630fe5b56031581$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e630fe5b56031581$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
var $e630fe5b56031581$export$b3d647c1c29df44d = /*#__PURE__*/ function(JsonRpcProvider) {
    (0, $ftJVG._)(StaticJsonRpcProvider, JsonRpcProvider);
    var _super = (0, $6OZAO._)(StaticJsonRpcProvider);
    function StaticJsonRpcProvider() {
        (0, $978gY._)(this, StaticJsonRpcProvider);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(StaticJsonRpcProvider, [
        {
            key: "detectNetwork",
            value: function detectNetwork() {
                var _this = this;
                var _super = Object.create(null, {
                    detectNetwork: {
                        get: function() {
                            return (0, $3cct3._)((0, $g3d7z._)(StaticJsonRpcProvider.prototype), "detectNetwork", _this);
                        }
                    }
                });
                return $e630fe5b56031581$var$__awaiter(this, void 0, void 0, function() {
                    var network;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                network = this.network;
                                if (!(network == null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _super.detectNetwork.call(this)
                                ];
                            case 1:
                                network = _state.sent();
                                if (!network) $e630fe5b56031581$var$logger.throwError("no network detected", (0, $6M65e.Logger).errors.UNKNOWN_ERROR, {});
                                // If still not set, set it
                                if (this._network == null) {
                                    // A static network does not support "any"
                                    (0, $2ax4w.defineReadOnly)(this, "_network", network);
                                    this.emit("network", network, null);
                                }
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    network
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return StaticJsonRpcProvider;
}((0, $aDPpa.JsonRpcProvider));
var $e630fe5b56031581$export$664128d6239ccf96 = /*#__PURE__*/ function _target(StaticJsonRpcProvider) {
    (0, $ftJVG._)(UrlJsonRpcProvider, StaticJsonRpcProvider);
    var _super = (0, $6OZAO._)(UrlJsonRpcProvider);
    function UrlJsonRpcProvider(network, apiKey) {
        (0, $978gY._)(this, UrlJsonRpcProvider);
        var _this;
        $e630fe5b56031581$var$logger.checkAbstract(this instanceof UrlJsonRpcProvider ? this.constructor : void 0, UrlJsonRpcProvider);
        // Normalize the Network and API Key
        network = (0, $2ax4w.getStatic)(this instanceof UrlJsonRpcProvider ? this.constructor : void 0, "getNetwork")(network);
        apiKey = (0, $2ax4w.getStatic)(this instanceof UrlJsonRpcProvider ? this.constructor : void 0, "getApiKey")(apiKey);
        var connection = (0, $2ax4w.getStatic)(this instanceof UrlJsonRpcProvider ? this.constructor : void 0, "getUrl")(network, apiKey);
        _this = _super.call(this, connection, network);
        if (typeof apiKey === "string") (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "apiKey", apiKey);
        else if (apiKey != null) Object.keys(apiKey).forEach(function(key) {
            (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), key, apiKey[key]);
        });
        return _this;
    }
    (0, $kry2a._)(UrlJsonRpcProvider, [
        {
            key: "_startPending",
            value: function _startPending() {
                $e630fe5b56031581$var$logger.warn("WARNING: API provider does not support pending filters");
            }
        },
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return false;
            }
        },
        {
            key: "getSigner",
            value: function getSigner(address) {
                return $e630fe5b56031581$var$logger.throwError("API provider does not support signing", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "getSigner"
                });
            }
        },
        {
            key: "listAccounts",
            value: function listAccounts() {
                return Promise.resolve([]);
            }
        }
    ], [
        {
            key: "getApiKey",
            value: // Return a defaultApiKey if null, otherwise validate the API key
            function getApiKey(apiKey) {
                return apiKey;
            }
        },
        {
            key: "getUrl",
            value: // Returns the url or connection for the given network and API key. The
            // API key will have been sanitized by the getApiKey first, so any validation
            // or transformations can be done there.
            function getUrl(network, apiKey) {
                return $e630fe5b56031581$var$logger.throwError("not implemented; sub-classes must override getUrl", (0, $6M65e.Logger).errors.NOT_IMPLEMENTED, {
                    operation: "getUrl"
                });
            }
        }
    ]);
    return UrlJsonRpcProvider;
}($e630fe5b56031581$export$b3d647c1c29df44d);

});


parcelRequire.register("4xYP9", function(module, exports) {

$parcel$export(module.exports, "AnkrProvider", function () { return $34f96cdeb0f3f720$export$72783b2aefa72a45; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $f1MgE = parcelRequire("f1MgE");

var $jLiNX = parcelRequire("jLiNX");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");
var $34f96cdeb0f3f720$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
var $34f96cdeb0f3f720$var$defaultApiKey = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function $34f96cdeb0f3f720$var$getHost(name) {
    switch(name){
        case "homestead":
            return "rpc.ankr.com/eth/";
        case "ropsten":
            return "rpc.ankr.com/eth_ropsten/";
        case "rinkeby":
            return "rpc.ankr.com/eth_rinkeby/";
        case "goerli":
            return "rpc.ankr.com/eth_goerli/";
        case "matic":
            return "rpc.ankr.com/polygon/";
        case "arbitrum":
            return "rpc.ankr.com/arbitrum/";
    }
    return $34f96cdeb0f3f720$var$logger.throwArgumentError("unsupported network", "name", name);
}
var $34f96cdeb0f3f720$export$72783b2aefa72a45 = /*#__PURE__*/ function(UrlJsonRpcProvider) {
    "use strict";
    (0, $ftJVG._)(AnkrProvider, UrlJsonRpcProvider);
    var _super = (0, $6OZAO._)(AnkrProvider);
    function AnkrProvider() {
        (0, $978gY._)(this, AnkrProvider);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(AnkrProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.apiKey === $34f96cdeb0f3f720$var$defaultApiKey;
            }
        }
    ], [
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                if (apiKey == null) return $34f96cdeb0f3f720$var$defaultApiKey;
                return apiKey;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                if (apiKey == null) apiKey = $34f96cdeb0f3f720$var$defaultApiKey;
                var connection = {
                    allowGzip: true,
                    url: "https://" + $34f96cdeb0f3f720$var$getHost(network.name) + apiKey,
                    throttleCallback: function(attempt, url) {
                        if (apiKey.apiKey === $34f96cdeb0f3f720$var$defaultApiKey) (0, $f1MgE.showThrottleMessage)();
                        return Promise.resolve(true);
                    }
                };
                if (apiKey.projectSecret != null) {
                    connection.user = "";
                    connection.password = apiKey.projectSecret;
                }
                return connection;
            }
        }
    ]);
    return AnkrProvider;
}((0, $jLiNX.UrlJsonRpcProvider));

});

parcelRequire.register("cHe68", function(module, exports) {

$parcel$export(module.exports, "CloudflareProvider", function () { return $93e46fc4025aa2f3$export$7113381f8f264fc0; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $jLiNX = parcelRequire("jLiNX");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");
"use strict";
var $93e46fc4025aa2f3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $93e46fc4025aa2f3$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
var $93e46fc4025aa2f3$export$7113381f8f264fc0 = /*#__PURE__*/ function(UrlJsonRpcProvider) {
    (0, $ftJVG._)(CloudflareProvider, UrlJsonRpcProvider);
    var _super = (0, $6OZAO._)(CloudflareProvider);
    function CloudflareProvider() {
        (0, $978gY._)(this, CloudflareProvider);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(CloudflareProvider, [
        {
            key: "perform",
            value: function perform(method, params) {
                var _this = this;
                var _super = Object.create(null, {
                    perform: {
                        get: function() {
                            return (0, $3cct3._)((0, $g3d7z._)(CloudflareProvider.prototype), "perform", _this);
                        }
                    }
                });
                return $93e46fc4025aa2f3$var$__awaiter(this, void 0, void 0, function() {
                    var block;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(method === "getBlockNumber")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _super.perform.call(this, "getBlock", {
                                        blockTag: "latest"
                                    })
                                ];
                            case 1:
                                block = _state.sent();
                                return [
                                    2,
                                    block.number
                                ];
                            case 2:
                                return [
                                    2,
                                    _super.perform.call(this, method, params)
                                ];
                        }
                    });
                });
            }
        }
    ], [
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                if (apiKey != null) $93e46fc4025aa2f3$var$logger.throwArgumentError("apiKey not supported for cloudflare", "apiKey", apiKey);
                return null;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                var host = null;
                switch(network.name){
                    case "homestead":
                        host = "https://cloudflare-eth.com/";
                        break;
                    default:
                        $93e46fc4025aa2f3$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
                }
                return host;
            }
        }
    ]);
    return CloudflareProvider;
}((0, $jLiNX.UrlJsonRpcProvider));

});

parcelRequire.register("8c6ML", function(module, exports) {

$parcel$export(module.exports, "EtherscanProvider", function () { return $5f74b530f183cf41$export$dd1d942a536c7912; });

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $j2rU8 = parcelRequire("j2rU8");

var $2ax4w = parcelRequire("2ax4w");

var $hDQeE = parcelRequire("hDQeE");

var $gqL7R = parcelRequire("gqL7R");

var $f1MgE = parcelRequire("f1MgE");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");

var $96Por = parcelRequire("96Por");
"use strict";
var $5f74b530f183cf41$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5f74b530f183cf41$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
// The transaction has already been sanitized by the calls in Provider
function $5f74b530f183cf41$var$getTransactionPostData(transaction) {
    var result = {};
    for(var key in transaction){
        if (transaction[key] == null) continue;
        var value = transaction[key];
        if (key === "type" && value === 0) continue;
        // Quantity-types require no leading zero, unless 0
        if (({
            type: true,
            gasLimit: true,
            gasPrice: true,
            maxFeePerGs: true,
            maxPriorityFeePerGas: true,
            nonce: true,
            value: true
        })[key]) value = (0, $j2rU8.hexValue)((0, $j2rU8.hexlify)(value));
        else if (key === "accessList") value = "[" + (0, $hDQeE.accessListify)(value).map(function(set) {
            return '{address:"'.concat(set.address, '",storageKeys:["').concat(set.storageKeys.join('","'), '"]}');
        }).join(",") + "]";
        else value = (0, $j2rU8.hexlify)(value);
        result[key] = value;
    }
    return result;
}
function $5f74b530f183cf41$var$getResult(result) {
    // getLogs, getHistory have weird success responses
    if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) return result.result;
    if (result.status != 1 || typeof result.message !== "string" || !result.message.match(/^OK/)) {
        var error = new Error("invalid response");
        error.result = JSON.stringify(result);
        if ((result.result || "").toLowerCase().indexOf("rate limit") >= 0) error.throttleRetry = true;
        throw error;
    }
    return result.result;
}
function $5f74b530f183cf41$var$getJsonResult(result) {
    // This response indicates we are being throttled
    if (result && result.status == 0 && result.message == "NOTOK" && (result.result || "").toLowerCase().indexOf("rate limit") >= 0) {
        var error = new Error("throttled response");
        error.result = JSON.stringify(result);
        error.throttleRetry = true;
        throw error;
    }
    if (result.jsonrpc != "2.0") {
        // @TODO: not any
        var error1 = new Error("invalid response");
        error1.result = JSON.stringify(result);
        throw error1;
    }
    if (result.error) {
        // @TODO: not any
        var error2 = new Error(result.error.message || "unknown error");
        if (result.error.code) error2.code = result.error.code;
        if (result.error.data) error2.data = result.error.data;
        throw error2;
    }
    return result.result;
}
// The blockTag was normalized as a string by the Provider pre-perform operations
function $5f74b530f183cf41$var$checkLogTag(blockTag) {
    if (blockTag === "pending") throw new Error("pending not supported");
    if (blockTag === "latest") return blockTag;
    return parseInt(blockTag.substring(2), 16);
}
function $5f74b530f183cf41$var$checkError(method, error, transaction) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === (0, $6M65e.Logger).errors.SERVER_ERROR) {
        var e = error.error;
        // Etherscan keeps changing their string
        if (e && (e.message.match(/reverted/i) || e.message.match(/VM execution error/i))) {
            // Etherscan prefixes the data like "Reverted 0x1234"
            var data = e.data;
            if (data) data = "0x" + data.replace(/^.*0x/i, "");
            if ((0, $j2rU8.isHexString)(data)) return data;
            $5f74b530f183cf41$var$logger.throwError("missing revert data in call exception", (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
                error: error,
                data: "0x"
            });
        }
    }
    // Get the message from any nested error structure
    var message = error.message;
    if (error.code === (0, $6M65e.Logger).errors.SERVER_ERROR) {
        if (error.error && typeof error.error.message === "string") message = error.error.message;
        else if (typeof error.body === "string") message = error.body;
        else if (typeof error.responseText === "string") message = error.responseText;
    }
    message = (message || "").toLowerCase();
    // "Insufficient funds. The account you tried to send transaction from does not have enough funds. Required 21464000000000 and got: 0"
    if (message.match(/insufficient funds/)) $5f74b530f183cf41$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $6M65e.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction with the same hash was already imported."
    if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) $5f74b530f183cf41$var$logger.throwError("nonce has already been used", (0, $6M65e.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction gas price is too low. There is another transaction with same nonce in the queue. Try increasing the gas price or incrementing the nonce."
    if (message.match(/another transaction with same nonce/)) $5f74b530f183cf41$var$logger.throwError("replacement fee too low", (0, $6M65e.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    if (message.match(/execution failed due to an exception|execution reverted/)) $5f74b530f183cf41$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $6M65e.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
var $5f74b530f183cf41$export$dd1d942a536c7912 = /*#__PURE__*/ function(BaseProvider) {
    (0, $ftJVG._)(EtherscanProvider, BaseProvider);
    var _super = (0, $6OZAO._)(EtherscanProvider);
    function EtherscanProvider(network, apiKey) {
        (0, $978gY._)(this, EtherscanProvider);
        var _this;
        _this = _super.call(this, network);
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "baseUrl", _this.getBaseUrl());
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "apiKey", apiKey || null);
        return _this;
    }
    (0, $kry2a._)(EtherscanProvider, [
        {
            key: "getBaseUrl",
            value: function getBaseUrl() {
                switch(this.network ? this.network.name : "invalid"){
                    case "homestead":
                        return "https://api.etherscan.io";
                    case "goerli":
                        return "https://api-goerli.etherscan.io";
                    case "sepolia":
                        return "https://api-sepolia.etherscan.io";
                    case "matic":
                        return "https://api.polygonscan.com";
                    case "maticmum":
                        return "https://api-testnet.polygonscan.com";
                    case "arbitrum":
                        return "https://api.arbiscan.io";
                    case "arbitrum-goerli":
                        return "https://api-goerli.arbiscan.io";
                    case "optimism":
                        return "https://api-optimistic.etherscan.io";
                    case "optimism-goerli":
                        return "https://api-goerli-optimistic.etherscan.io";
                    default:
                }
                return $5f74b530f183cf41$var$logger.throwArgumentError("unsupported network", "network", this.network.name);
            }
        },
        {
            key: "getUrl",
            value: function getUrl(module, params) {
                var query = Object.keys(params).reduce(function(accum, key) {
                    var value = params[key];
                    if (value != null) accum += "&".concat(key, "=").concat(value);
                    return accum;
                }, "");
                var apiKey = this.apiKey ? "&apikey=".concat(this.apiKey) : "";
                return "".concat(this.baseUrl, "/api?module=").concat(module).concat(query).concat(apiKey);
            }
        },
        {
            key: "getPostUrl",
            value: function getPostUrl() {
                return "".concat(this.baseUrl, "/api");
            }
        },
        {
            key: "getPostData",
            value: function getPostData(module, params) {
                params.module = module;
                params.apikey = this.apiKey;
                return params;
            }
        },
        {
            key: "fetch",
            value: function fetch(module, params, post) {
                return $5f74b530f183cf41$var$__awaiter(this, void 0, void 0, function() {
                    var _this, url, payload, procFunc, connection, payloadStr, result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                url = post ? this.getPostUrl() : this.getUrl(module, params);
                                payload = post ? this.getPostData(module, params) : null;
                                procFunc = module === "proxy" ? $5f74b530f183cf41$var$getJsonResult : $5f74b530f183cf41$var$getResult;
                                this.emit("debug", {
                                    action: "request",
                                    request: url,
                                    provider: this
                                });
                                connection = {
                                    url: url,
                                    throttleSlotInterval: 1000,
                                    throttleCallback: function(attempt, url) {
                                        if (_this.isCommunityResource()) (0, $f1MgE.showThrottleMessage)();
                                        return Promise.resolve(true);
                                    }
                                };
                                payloadStr = null;
                                if (payload) {
                                    connection.headers = {
                                        "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                                    };
                                    payloadStr = Object.keys(payload).map(function(key) {
                                        return "".concat(key, "=").concat(payload[key]);
                                    }).join("&");
                                }
                                return [
                                    4,
                                    (0, $gqL7R.fetchJson)(connection, payloadStr, procFunc || $5f74b530f183cf41$var$getJsonResult)
                                ];
                            case 1:
                                result = _state.sent();
                                this.emit("debug", {
                                    action: "response",
                                    request: url,
                                    response: (0, $2ax4w.deepCopy)(result),
                                    provider: this
                                });
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "detectNetwork",
            value: function detectNetwork() {
                return $5f74b530f183cf41$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            this.network
                        ];
                    });
                });
            }
        },
        {
            key: "perform",
            value: function perform(method, params) {
                var _this = this;
                var _super = Object.create(null, {
                    perform: {
                        get: function() {
                            return (0, $3cct3._)((0, $g3d7z._)(EtherscanProvider.prototype), "perform", _this);
                        }
                    }
                });
                return $5f74b530f183cf41$var$__awaiter(this, void 0, void 0, function() {
                    var postData, error, postData1, error1, args, topic0, logs, blocks, i, log, block;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                switch(method){
                                    case "getBlockNumber":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "getGasPrice":
                                        return [
                                            3,
                                            2
                                        ];
                                    case "getBalance":
                                        return [
                                            3,
                                            3
                                        ];
                                    case "getTransactionCount":
                                        return [
                                            3,
                                            4
                                        ];
                                    case "getCode":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "getStorageAt":
                                        return [
                                            3,
                                            6
                                        ];
                                    case "sendTransaction":
                                        return [
                                            3,
                                            7
                                        ];
                                    case "getBlock":
                                        return [
                                            3,
                                            8
                                        ];
                                    case "getTransaction":
                                        return [
                                            3,
                                            9
                                        ];
                                    case "getTransactionReceipt":
                                        return [
                                            3,
                                            10
                                        ];
                                    case "call":
                                        return [
                                            3,
                                            11
                                        ];
                                    case "estimateGas":
                                        return [
                                            3,
                                            15
                                        ];
                                    case "getLogs":
                                        return [
                                            3,
                                            19
                                        ];
                                    case "getEtherPrice":
                                        return [
                                            3,
                                            26
                                        ];
                                }
                                return [
                                    3,
                                    28
                                ];
                            case 1:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_blockNumber"
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_gasPrice"
                                    })
                                ];
                            case 3:
                                // Returns base-10 result
                                return [
                                    2,
                                    this.fetch("account", {
                                        action: "balance",
                                        address: params.address,
                                        tag: params.blockTag
                                    })
                                ];
                            case 4:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getTransactionCount",
                                        address: params.address,
                                        tag: params.blockTag
                                    })
                                ];
                            case 5:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getCode",
                                        address: params.address,
                                        tag: params.blockTag
                                    })
                                ];
                            case 6:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getStorageAt",
                                        address: params.address,
                                        position: params.position,
                                        tag: params.blockTag
                                    })
                                ];
                            case 7:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_sendRawTransaction",
                                        hex: params.signedTransaction
                                    }, true).catch(function(error) {
                                        return $5f74b530f183cf41$var$checkError("sendTransaction", error, params.signedTransaction);
                                    })
                                ];
                            case 8:
                                if (params.blockTag) return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getBlockByNumber",
                                        tag: params.blockTag,
                                        boolean: params.includeTransactions ? "true" : "false"
                                    })
                                ];
                                throw new Error("getBlock by blockHash not implemented");
                            case 9:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getTransactionByHash",
                                        txhash: params.transactionHash
                                    })
                                ];
                            case 10:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getTransactionReceipt",
                                        txhash: params.transactionHash
                                    })
                                ];
                            case 11:
                                if (params.blockTag !== "latest") throw new Error("EtherscanProvider does not support blockTag for call");
                                postData = $5f74b530f183cf41$var$getTransactionPostData(params.transaction);
                                postData.module = "proxy";
                                postData.action = "eth_call";
                                _state.label = 12;
                            case 12:
                                _state.trys.push([
                                    12,
                                    14,
                                    ,
                                    15
                                ]);
                                return [
                                    4,
                                    this.fetch("proxy", postData, true)
                                ];
                            case 13:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 14:
                                error = _state.sent();
                                return [
                                    2,
                                    $5f74b530f183cf41$var$checkError("call", error, params.transaction)
                                ];
                            case 15:
                                postData1 = $5f74b530f183cf41$var$getTransactionPostData(params.transaction);
                                postData1.module = "proxy";
                                postData1.action = "eth_estimateGas";
                                _state.label = 16;
                            case 16:
                                _state.trys.push([
                                    16,
                                    18,
                                    ,
                                    19
                                ]);
                                return [
                                    4,
                                    this.fetch("proxy", postData1, true)
                                ];
                            case 17:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 18:
                                error1 = _state.sent();
                                return [
                                    2,
                                    $5f74b530f183cf41$var$checkError("estimateGas", error1, params.transaction)
                                ];
                            case 19:
                                args = {
                                    action: "getLogs"
                                };
                                if (params.filter.fromBlock) args.fromBlock = $5f74b530f183cf41$var$checkLogTag(params.filter.fromBlock);
                                if (params.filter.toBlock) args.toBlock = $5f74b530f183cf41$var$checkLogTag(params.filter.toBlock);
                                if (params.filter.address) args.address = params.filter.address;
                                // @TODO: We can handle slightly more complicated logs using the logs API
                                if (params.filter.topics && params.filter.topics.length > 0) {
                                    if (params.filter.topics.length > 1) $5f74b530f183cf41$var$logger.throwError("unsupported topic count", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                                        topics: params.filter.topics
                                    });
                                    if (params.filter.topics.length === 1) {
                                        topic0 = params.filter.topics[0];
                                        if (typeof topic0 !== "string" || topic0.length !== 66) $5f74b530f183cf41$var$logger.throwError("unsupported topic format", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                                            topic0: topic0
                                        });
                                        args.topic0 = topic0;
                                    }
                                }
                                return [
                                    4,
                                    this.fetch("logs", args)
                                ];
                            case 20:
                                logs = _state.sent();
                                blocks = {};
                                i = 0;
                                _state.label = 21;
                            case 21:
                                if (!(i < logs.length)) return [
                                    3,
                                    25
                                ];
                                log = logs[i];
                                if (log.blockHash != null) return [
                                    3,
                                    24
                                ];
                                if (!(blocks[log.blockNumber] == null)) return [
                                    3,
                                    23
                                ];
                                return [
                                    4,
                                    this.getBlock(log.blockNumber)
                                ];
                            case 22:
                                block = _state.sent();
                                if (block) blocks[log.blockNumber] = block.hash;
                                _state.label = 23;
                            case 23:
                                log.blockHash = blocks[log.blockNumber];
                                _state.label = 24;
                            case 24:
                                i++;
                                return [
                                    3,
                                    21
                                ];
                            case 25:
                                return [
                                    2,
                                    logs
                                ];
                            case 26:
                                if (this.network.name !== "homestead") return [
                                    2,
                                    0.0
                                ];
                                return [
                                    4,
                                    this.fetch("stats", {
                                        action: "ethprice"
                                    })
                                ];
                            case 27:
                                return [
                                    2,
                                    parseFloat.apply(void 0, [
                                        _state.sent().ethusd
                                    ])
                                ];
                            case 28:
                                return [
                                    3,
                                    29
                                ];
                            case 29:
                                return [
                                    2,
                                    _super.perform.call(this, method, params)
                                ];
                        }
                    });
                });
            }
        },
        {
            // Note: The `page` page parameter only allows pagination within the
            //       10,000 window available without a page and offset parameter
            //       Error: Result window is too large, PageNo x Offset size must
            //              be less than or equal to 10000
            key: "getHistory",
            value: function getHistory(addressOrName, startBlock, endBlock) {
                return $5f74b530f183cf41$var$__awaiter(this, void 0, void 0, function() {
                    var _this, params, _tmp, result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _tmp = {
                                    action: "txlist"
                                };
                                return [
                                    4,
                                    this.resolveName(addressOrName)
                                ];
                            case 1:
                                params = (_tmp.address = _state.sent(), _tmp.startblock = startBlock == null ? 0 : startBlock, _tmp.endblock = endBlock == null ? 99999999 : endBlock, _tmp.sort = "asc", _tmp);
                                return [
                                    4,
                                    this.fetch("account", params)
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result.map(function(tx) {
                                        [
                                            "contractAddress",
                                            "to"
                                        ].forEach(function(key) {
                                            if (tx[key] == "") delete tx[key];
                                        });
                                        if (tx.creates == null && tx.contractAddress != null) tx.creates = tx.contractAddress;
                                        var item = _this.formatter.transactionResponse(tx);
                                        if (tx.timeStamp) item.timestamp = parseInt(tx.timeStamp);
                                        return item;
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.apiKey == null;
            }
        }
    ]);
    return EtherscanProvider;
}((0, $96Por.BaseProvider));

});

parcelRequire.register("h5Sdm", function(module, exports) {

$parcel$export(module.exports, "FallbackProvider", function () { return $c71cf52c680b1470$export$cb1d0beacb55feb7; });

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $1ObTH = parcelRequire("1ObTH");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $7UAGh = parcelRequire("7UAGh");

var $lLovk = parcelRequire("lLovk");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $2ax4w = parcelRequire("2ax4w");

var $5aKt1 = parcelRequire("5aKt1");

var $gqL7R = parcelRequire("gqL7R");

var $96Por = parcelRequire("96Por");

var $f1MgE = parcelRequire("f1MgE");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");
"use strict";
var $c71cf52c680b1470$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c71cf52c680b1470$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
function $c71cf52c680b1470$var$now() {
    return new Date().getTime();
}
// Returns to network as long as all agree, or null if any is null.
// Throws an error if any two networks do not match.
function $c71cf52c680b1470$var$checkNetworks(networks) {
    var result = null;
    for(var i = 0; i < networks.length; i++){
        var network = networks[i];
        // Null! We do not know our network; bail.
        if (network == null) return null;
        if (result) // Make sure the network matches the previous networks
        {
            if (!(result.name === network.name && result.chainId === network.chainId && (result.ensAddress === network.ensAddress || result.ensAddress == null && network.ensAddress == null))) $c71cf52c680b1470$var$logger.throwArgumentError("provider mismatch", "networks", networks);
        } else result = network;
    }
    return result;
}
function $c71cf52c680b1470$var$median(values, maxDelta) {
    values = values.slice().sort();
    var middle = Math.floor(values.length / 2);
    // Odd length; take the middle
    if (values.length % 2) return values[middle];
    // Even length; take the average of the two middle
    var a = values[middle - 1], b = values[middle];
    if (maxDelta != null && Math.abs(a - b) > maxDelta) return null;
    return (a + b) / 2;
}
function $c71cf52c680b1470$var$serialize(value) {
    if (value === null) return "null";
    else if (typeof value === "number" || typeof value === "boolean") return JSON.stringify(value);
    else if (typeof value === "string") return value;
    else if ((0, $gMArf.BigNumber).isBigNumber(value)) return value.toString();
    else if (Array.isArray(value)) return JSON.stringify(value.map(function(i) {
        return $c71cf52c680b1470$var$serialize(i);
    }));
    else if (typeof value === "object") {
        var keys = Object.keys(value);
        keys.sort();
        return "{" + keys.map(function(key) {
            var v = value[key];
            if (typeof v === "function") v = "[function]";
            else v = $c71cf52c680b1470$var$serialize(v);
            return JSON.stringify(key) + ":" + v;
        }).join(",") + "}";
    }
    throw new Error("unknown value type: " + (typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value)));
}
// Next request ID to use for emitting debug info
var $c71cf52c680b1470$var$nextRid = 1;
function $c71cf52c680b1470$var$stall(duration) {
    var getPromise = function getPromise() {
        return promise;
    };
    var cancel = null;
    var timer = null;
    var promise = new Promise(function(resolve) {
        cancel = function cancel() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            resolve();
        };
        timer = setTimeout(cancel, duration);
    });
    var wait = function(func) {
        promise = promise.then(func);
        return promise;
    };
    return {
        cancel: cancel,
        getPromise: getPromise,
        wait: wait
    };
}
var $c71cf52c680b1470$var$ForwardErrors = [
    (0, $6M65e.Logger).errors.CALL_EXCEPTION,
    (0, $6M65e.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $6M65e.Logger).errors.NONCE_EXPIRED,
    (0, $6M65e.Logger).errors.REPLACEMENT_UNDERPRICED,
    (0, $6M65e.Logger).errors.UNPREDICTABLE_GAS_LIMIT
];
var $c71cf52c680b1470$var$ForwardProperties = [
    "address",
    "args",
    "errorArgs",
    "errorSignature",
    "method",
    "transaction"
];
function $c71cf52c680b1470$var$exposeDebugConfig(config, now) {
    var result = {
        weight: config.weight
    };
    Object.defineProperty(result, "provider", {
        get: function() {
            return config.provider;
        }
    });
    if (config.start) result.start = config.start;
    if (now) result.duration = now - config.start;
    if (config.done) {
        if (config.error) result.error = config.error;
        else result.result = config.result || null;
    }
    return result;
}
function $c71cf52c680b1470$var$normalizedTally(normalize, quorum) {
    return function(configs) {
        // Count the votes for each result
        var tally = {};
        configs.forEach(function(c) {
            var value = normalize(c.result);
            if (!tally[value]) tally[value] = {
                count: 0,
                result: c.result
            };
            tally[value].count++;
        });
        // Check for a quorum on any given result
        var keys = Object.keys(tally);
        for(var i = 0; i < keys.length; i++){
            var check = tally[keys[i]];
            if (check.count >= quorum) return check.result;
        }
        // No quroum
        return undefined;
    };
}
function $c71cf52c680b1470$var$getProcessFunc(provider, method, params) {
    var normalize = $c71cf52c680b1470$var$serialize;
    switch(method){
        case "getBlockNumber":
            // Return the median value, unless there is (median + 1) is also
            // present, in which case that is probably true and the median
            // is going to be stale soon. In the event of a malicious node,
            // the lie will be true soon enough.
            return function(configs) {
                var values = configs.map(function(c) {
                    return c.result;
                });
                // Get the median block number
                var blockNumber = $c71cf52c680b1470$var$median(configs.map(function(c) {
                    return c.result;
                }), 2);
                if (blockNumber == null) return undefined;
                blockNumber = Math.ceil(blockNumber);
                // If the next block height is present, its prolly safe to use
                if (values.indexOf(blockNumber + 1) >= 0) blockNumber++;
                // Don't ever roll back the blockNumber
                if (blockNumber >= provider._highestBlockNumber) provider._highestBlockNumber = blockNumber;
                return provider._highestBlockNumber;
            };
        case "getGasPrice":
            // Return the middle (round index up) value, similar to median
            // but do not average even entries and choose the higher.
            // Malicious actors must compromise 50% of the nodes to lie.
            return function(configs) {
                var values = configs.map(function(c) {
                    return c.result;
                });
                values.sort();
                return values[Math.floor(values.length / 2)];
            };
        case "getEtherPrice":
            // Returns the median price. Malicious actors must compromise at
            // least 50% of the nodes to lie (in a meaningful way).
            return function(configs) {
                return $c71cf52c680b1470$var$median(configs.map(function(c) {
                    return c.result;
                }));
            };
        // No additional normalizing required; serialize is enough
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorageAt":
        case "call":
        case "estimateGas":
        case "getLogs":
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getTransaction":
        case "getTransactionReceipt":
            normalize = function normalize(tx) {
                if (tx == null) return null;
                tx = (0, $2ax4w.shallowCopy)(tx);
                tx.confirmations = -1;
                return $c71cf52c680b1470$var$serialize(tx);
            };
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getBlock":
            // We drop the confirmations from transactions as it is approximate
            if (params.includeTransactions) normalize = function normalize(block) {
                if (block == null) return null;
                block = (0, $2ax4w.shallowCopy)(block);
                block.transactions = block.transactions.map(function(tx) {
                    tx = (0, $2ax4w.shallowCopy)(tx);
                    tx.confirmations = -1;
                    return tx;
                });
                return $c71cf52c680b1470$var$serialize(block);
            };
            else normalize = function normalize(block) {
                if (block == null) return null;
                return $c71cf52c680b1470$var$serialize(block);
            };
            break;
        default:
            throw new Error("unknown method: " + method);
    }
    // Return the result if and only if the expected quorum is
    // satisfied and agreed upon for the final result.
    return $c71cf52c680b1470$var$normalizedTally(normalize, provider.quorum);
}
// If we are doing a blockTag query, we need to make sure the backend is
// caught up to the FallbackProvider, before sending a request to it.
function $c71cf52c680b1470$var$waitForSync(config, blockNumber) {
    return $c71cf52c680b1470$var$__awaiter(this, void 0, void 0, function() {
        var provider;
        return (0, $7UAGh.__generator)(this, function(_state) {
            provider = config.provider;
            if (provider.blockNumber != null && provider.blockNumber >= blockNumber || blockNumber === -1) return [
                2,
                provider
            ];
            return [
                2,
                (0, $gqL7R.poll)(function() {
                    return new Promise(function(resolve, reject) {
                        setTimeout(function() {
                            // We are synced
                            if (provider.blockNumber >= blockNumber) return resolve(provider);
                            // We're done; just quit
                            if (config.cancelled) return resolve(null);
                            // Try again, next block
                            return resolve(undefined);
                        }, 0);
                    });
                }, {
                    oncePoll: provider
                })
            ];
        });
    });
}
function $c71cf52c680b1470$var$getRunner(config, currentBlockNumber, method, params) {
    return $c71cf52c680b1470$var$__awaiter(this, void 0, void 0, function() {
        var provider, filter;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    provider = config.provider;
                    switch(method){
                        case "getBlockNumber":
                            return [
                                3,
                                1
                            ];
                        case "getGasPrice":
                            return [
                                3,
                                1
                            ];
                        case "getEtherPrice":
                            return [
                                3,
                                2
                            ];
                        case "getBalance":
                            return [
                                3,
                                3
                            ];
                        case "getTransactionCount":
                            return [
                                3,
                                3
                            ];
                        case "getCode":
                            return [
                                3,
                                3
                            ];
                        case "getStorageAt":
                            return [
                                3,
                                6
                            ];
                        case "getBlock":
                            return [
                                3,
                                9
                            ];
                        case "call":
                            return [
                                3,
                                12
                            ];
                        case "estimateGas":
                            return [
                                3,
                                12
                            ];
                        case "getTransaction":
                            return [
                                3,
                                15
                            ];
                        case "getTransactionReceipt":
                            return [
                                3,
                                15
                            ];
                        case "getLogs":
                            return [
                                3,
                                16
                            ];
                    }
                    return [
                        3,
                        19
                    ];
                case 1:
                    return [
                        2,
                        provider[method]()
                    ];
                case 2:
                    if (provider.getEtherPrice) return [
                        2,
                        provider.getEtherPrice()
                    ];
                    return [
                        3,
                        19
                    ];
                case 3:
                    if (!(params.blockTag && (0, $j2rU8.isHexString)(params.blockTag))) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        $c71cf52c680b1470$var$waitForSync(config, currentBlockNumber)
                    ];
                case 4:
                    provider = _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        2,
                        provider[method](params.address, params.blockTag || "latest")
                    ];
                case 6:
                    if (!(params.blockTag && (0, $j2rU8.isHexString)(params.blockTag))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        $c71cf52c680b1470$var$waitForSync(config, currentBlockNumber)
                    ];
                case 7:
                    provider = _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2,
                        provider.getStorageAt(params.address, params.position, params.blockTag || "latest")
                    ];
                case 9:
                    if (!(params.blockTag && (0, $j2rU8.isHexString)(params.blockTag))) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        $c71cf52c680b1470$var$waitForSync(config, currentBlockNumber)
                    ];
                case 10:
                    provider = _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        2,
                        provider[params.includeTransactions ? "getBlockWithTransactions" : "getBlock"](params.blockTag || params.blockHash)
                    ];
                case 12:
                    if (!(params.blockTag && (0, $j2rU8.isHexString)(params.blockTag))) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        $c71cf52c680b1470$var$waitForSync(config, currentBlockNumber)
                    ];
                case 13:
                    provider = _state.sent();
                    _state.label = 14;
                case 14:
                    if (method === "call" && params.blockTag) return [
                        2,
                        provider[method](params.transaction, params.blockTag)
                    ];
                    return [
                        2,
                        provider[method](params.transaction)
                    ];
                case 15:
                    return [
                        2,
                        provider[method](params.transactionHash)
                    ];
                case 16:
                    filter = params.filter;
                    if (!(filter.fromBlock && (0, $j2rU8.isHexString)(filter.fromBlock) || filter.toBlock && (0, $j2rU8.isHexString)(filter.toBlock))) return [
                        3,
                        18
                    ];
                    return [
                        4,
                        $c71cf52c680b1470$var$waitForSync(config, currentBlockNumber)
                    ];
                case 17:
                    provider = _state.sent();
                    _state.label = 18;
                case 18:
                    return [
                        2,
                        provider.getLogs(filter)
                    ];
                case 19:
                    return [
                        2,
                        $c71cf52c680b1470$var$logger.throwError("unknown method error", (0, $6M65e.Logger).errors.UNKNOWN_ERROR, {
                            method: method,
                            params: params
                        })
                    ];
            }
        });
    });
}
var $c71cf52c680b1470$export$cb1d0beacb55feb7 = /*#__PURE__*/ function(BaseProvider) {
    (0, $ftJVG._)(FallbackProvider, BaseProvider);
    var _super = (0, $6OZAO._)(FallbackProvider);
    function FallbackProvider(providers, quorum) {
        (0, $978gY._)(this, FallbackProvider);
        var _this;
        if (providers.length === 0) $c71cf52c680b1470$var$logger.throwArgumentError("missing providers", "providers", providers);
        var providerConfigs = providers.map(function(configOrProvider, index) {
            if ((0, $lLovk.Provider).isProvider(configOrProvider)) {
                var stallTimeout = (0, $f1MgE.isCommunityResource)(configOrProvider) ? 2000 : 750;
                var priority = 1;
                return Object.freeze({
                    provider: configOrProvider,
                    weight: 1,
                    stallTimeout: stallTimeout,
                    priority: priority
                });
            }
            var config = (0, $2ax4w.shallowCopy)(configOrProvider);
            if (config.priority == null) config.priority = 1;
            if (config.stallTimeout == null) config.stallTimeout = (0, $f1MgE.isCommunityResource)(configOrProvider) ? 2000 : 750;
            if (config.weight == null) config.weight = 1;
            var weight = config.weight;
            if (weight % 1 || weight > 512 || weight < 1) $c71cf52c680b1470$var$logger.throwArgumentError("invalid weight; must be integer in [1, 512]", "providers[".concat(index, "].weight"), weight);
            return Object.freeze(config);
        });
        var total = providerConfigs.reduce(function(accum, c) {
            return accum + c.weight;
        }, 0);
        if (quorum == null) quorum = total / 2;
        else if (quorum > total) $c71cf52c680b1470$var$logger.throwArgumentError("quorum will always fail; larger than total weight", "quorum", quorum);
        // Are all providers' networks are known
        var networkOrReady = $c71cf52c680b1470$var$checkNetworks(providerConfigs.map(function(c) {
            return c.provider.network;
        }));
        // Not all networks are known; we must stall
        if (networkOrReady == null) networkOrReady = new Promise(function(resolve, reject) {
            setTimeout(function() {
                _this.detectNetwork().then(resolve, reject);
            }, 0);
        });
        _this = _super.call(this, networkOrReady);
        // Preserve a copy, so we do not get mutated
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "providerConfigs", Object.freeze(providerConfigs));
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "quorum", quorum);
        _this._highestBlockNumber = -1;
        return _this;
    }
    (0, $kry2a._)(FallbackProvider, [
        {
            key: "detectNetwork",
            value: function detectNetwork() {
                return $c71cf52c680b1470$var$__awaiter(this, void 0, void 0, function() {
                    var networks;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(this.providerConfigs.map(function(c) {
                                        return c.provider.getNetwork();
                                    }))
                                ];
                            case 1:
                                networks = _state.sent();
                                return [
                                    2,
                                    $c71cf52c680b1470$var$checkNetworks(networks)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "perform",
            value: function perform(method, params) {
                return $c71cf52c680b1470$var$__awaiter(this, void 0, void 0, function() {
                    var _this, _loop, _this1, results, i, result, processFunc, configs, currentBlockNumber, i1, first, _ret;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this, _loop = function() {
                                    var _this2, _loop, t0, inflightWeight, waiting, results, result, errors;
                                    return (0, $7UAGh.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _this2 = _this, _loop = function() {
                                                    var config = configs[i1++];
                                                    var rid = $c71cf52c680b1470$var$nextRid++;
                                                    config.start = $c71cf52c680b1470$var$now();
                                                    config.staller = $c71cf52c680b1470$var$stall(config.stallTimeout);
                                                    config.staller.wait(function() {
                                                        config.staller = null;
                                                    });
                                                    config.runner = $c71cf52c680b1470$var$getRunner(config, currentBlockNumber, method, params).then(function(result) {
                                                        config.done = true;
                                                        config.result = result;
                                                        if (_this1.listenerCount("debug")) _this1.emit("debug", {
                                                            action: "request",
                                                            rid: rid,
                                                            backend: $c71cf52c680b1470$var$exposeDebugConfig(config, $c71cf52c680b1470$var$now()),
                                                            request: {
                                                                method: method,
                                                                params: (0, $2ax4w.deepCopy)(params)
                                                            },
                                                            provider: _this1
                                                        });
                                                    }, function(error) {
                                                        config.done = true;
                                                        config.error = error;
                                                        if (_this1.listenerCount("debug")) _this1.emit("debug", {
                                                            action: "request",
                                                            rid: rid,
                                                            backend: $c71cf52c680b1470$var$exposeDebugConfig(config, $c71cf52c680b1470$var$now()),
                                                            request: {
                                                                method: method,
                                                                params: (0, $2ax4w.deepCopy)(params)
                                                            },
                                                            provider: _this1
                                                        });
                                                    });
                                                    if (_this2.listenerCount("debug")) _this2.emit("debug", {
                                                        action: "request",
                                                        rid: rid,
                                                        backend: $c71cf52c680b1470$var$exposeDebugConfig(config, null),
                                                        request: {
                                                            method: method,
                                                            params: (0, $2ax4w.deepCopy)(params)
                                                        },
                                                        provider: _this2
                                                    });
                                                    inflightWeight += config.weight;
                                                };
                                                t0 = $c71cf52c680b1470$var$now();
                                                inflightWeight = configs.filter(function(c) {
                                                    return c.runner && t0 - c.start < c.stallTimeout;
                                                }).reduce(function(accum, c) {
                                                    return accum + c.weight;
                                                }, 0);
                                                // Start running enough to meet quorum
                                                while(inflightWeight < _this.quorum && i1 < configs.length)_loop();
                                                waiting = [];
                                                configs.forEach(function(c) {
                                                    if (c.done || !c.runner) return;
                                                    waiting.push(c.runner);
                                                    if (c.staller) waiting.push(c.staller.getPromise());
                                                });
                                                if (!waiting.length) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    Promise.race(waiting)
                                                ];
                                            case 1:
                                                _state.sent();
                                                _state.label = 2;
                                            case 2:
                                                results = configs.filter(function(c) {
                                                    return c.done && c.error == null;
                                                });
                                                if (!(results.length >= _this.quorum)) return [
                                                    3,
                                                    5
                                                ];
                                                result = processFunc(results);
                                                if (result !== undefined) {
                                                    // Shut down any stallers
                                                    configs.forEach(function(c) {
                                                        if (c.staller) c.staller.cancel();
                                                        c.cancelled = true;
                                                    });
                                                    return [
                                                        2,
                                                        {
                                                            v: result
                                                        }
                                                    ];
                                                }
                                                if (!!first) return [
                                                    3,
                                                    4
                                                ];
                                                return [
                                                    4,
                                                    $c71cf52c680b1470$var$stall(100).getPromise()
                                                ];
                                            case 3:
                                                _state.sent();
                                                _state.label = 4;
                                            case 4:
                                                first = false;
                                                _state.label = 5;
                                            case 5:
                                                errors = configs.reduce(function(accum, c) {
                                                    if (!c.done || c.error == null) return accum;
                                                    var code = c.error.code;
                                                    if ($c71cf52c680b1470$var$ForwardErrors.indexOf(code) >= 0) {
                                                        if (!accum[code]) accum[code] = {
                                                            error: c.error,
                                                            weight: 0
                                                        };
                                                        accum[code].weight += c.weight;
                                                    }
                                                    return accum;
                                                }, {});
                                                Object.keys(errors).forEach(function(errorCode) {
                                                    var tally = errors[errorCode];
                                                    if (tally.weight < _this1.quorum) return;
                                                    // Shut down any stallers
                                                    configs.forEach(function(c) {
                                                        if (c.staller) c.staller.cancel();
                                                        c.cancelled = true;
                                                    });
                                                    var e = tally.error;
                                                    var props = {};
                                                    $c71cf52c680b1470$var$ForwardProperties.forEach(function(name) {
                                                        if (e[name] == null) return;
                                                        props[name] = e[name];
                                                    });
                                                    $c71cf52c680b1470$var$logger.throwError(e.reason || e.message, errorCode, props);
                                                });
                                                // All configs have run to completion; we will never get more data
                                                if (configs.filter(function(c) {
                                                    return !c.done;
                                                }).length === 0) return [
                                                    2,
                                                    "break"
                                                ];
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                _this1 = this;
                                if (!(method === "sendTransaction")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    Promise.all(this.providerConfigs.map(function(c) {
                                        return c.provider.sendTransaction(params.signedTransaction).then(function(result) {
                                            return result.hash;
                                        }, function(error) {
                                            return error;
                                        });
                                    }))
                                ];
                            case 1:
                                results = _state.sent();
                                // Any success is good enough (other errors are likely "already seen" errors
                                for(i = 0; i < results.length; i++){
                                    result = results[i];
                                    if (typeof result === "string") return [
                                        2,
                                        result
                                    ];
                                }
                                // They were all an error; pick the first error
                                throw results[0];
                            case 2:
                                if (!(this._highestBlockNumber === -1 && method !== "getBlockNumber")) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.getBlockNumber()
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                processFunc = $c71cf52c680b1470$var$getProcessFunc(this, method, params);
                                configs = (0, $5aKt1.shuffled)(this.providerConfigs.map((0, $2ax4w.shallowCopy)));
                                configs.sort(function(a, b) {
                                    return a.priority - b.priority;
                                });
                                currentBlockNumber = this._highestBlockNumber;
                                i1 = 0;
                                first = true;
                                _state.label = 5;
                            case 5:
                                if (!true) return [
                                    3,
                                    7
                                ];
                                return [
                                    5,
                                    (0, $7UAGh.__values)(_loop())
                                ];
                            case 6:
                                _ret = _state.sent();
                                if ((0, $1ObTH._)(_ret) === "object") return [
                                    2,
                                    _ret.v
                                ];
                                if (_ret === "break") return [
                                    3,
                                    7
                                ];
                                return [
                                    3,
                                    5
                                ];
                            case 7:
                                // Shut down any stallers; shouldn't be any
                                configs.forEach(function(c) {
                                    if (c.staller) c.staller.cancel();
                                    c.cancelled = true;
                                });
                                return [
                                    2,
                                    $c71cf52c680b1470$var$logger.throwError("failed to meet quorum", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                                        method: method,
                                        params: params,
                                        //results: configs.map((c) => c.result),
                                        //errors: configs.map((c) => c.error),
                                        results: configs.map(function(c) {
                                            return $c71cf52c680b1470$var$exposeDebugConfig(c);
                                        }),
                                        provider: this
                                    })
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return FallbackProvider;
}((0, $96Por.BaseProvider));

});

parcelRequire.register("9FSRo", function(module, exports) {

$parcel$export(module.exports, "IpcProvider", function () { return $70b27f74974a2dd3$export$fbe151f90a1ece01; });
"use strict";
var $70b27f74974a2dd3$export$fbe151f90a1ece01 = null;

});

parcelRequire.register("eGbhc", function(module, exports) {

$parcel$export(module.exports, "InfuraWebSocketProvider", function () { return $aafdbc33abd5222f$export$dd168a807d60da4f; });
$parcel$export(module.exports, "InfuraProvider", function () { return $aafdbc33abd5222f$export$60ff1a559b5c6ebd; });

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $2ax4w = parcelRequire("2ax4w");

var $dCAfX = parcelRequire("dCAfX");

var $f1MgE = parcelRequire("f1MgE");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");

var $jLiNX = parcelRequire("jLiNX");
"use strict";
var $aafdbc33abd5222f$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
var $aafdbc33abd5222f$var$defaultProjectId = "84842078b09946638c03157f83405213";
var $aafdbc33abd5222f$export$dd168a807d60da4f = /*#__PURE__*/ function(WebSocketProvider) {
    (0, $ftJVG._)(InfuraWebSocketProvider, WebSocketProvider);
    var _super = (0, $6OZAO._)(InfuraWebSocketProvider);
    function InfuraWebSocketProvider(network, apiKey) {
        (0, $978gY._)(this, InfuraWebSocketProvider);
        var _this;
        var provider = new $aafdbc33abd5222f$export$60ff1a559b5c6ebd(network, apiKey);
        var connection = provider.connection;
        if (connection.password) $aafdbc33abd5222f$var$logger.throwError("INFURA WebSocket project secrets unsupported", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "InfuraProvider.getWebSocketProvider()"
        });
        var url = connection.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        _this = _super.call(this, url, network);
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "apiKey", provider.projectId);
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "projectId", provider.projectId);
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "projectSecret", provider.projectSecret);
        return _this;
    }
    (0, $kry2a._)(InfuraWebSocketProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.projectId === $aafdbc33abd5222f$var$defaultProjectId;
            }
        }
    ]);
    return InfuraWebSocketProvider;
}((0, $dCAfX.WebSocketProvider));
var $aafdbc33abd5222f$export$60ff1a559b5c6ebd = /*#__PURE__*/ function(UrlJsonRpcProvider) {
    (0, $ftJVG._)(InfuraProvider, UrlJsonRpcProvider);
    var _super = (0, $6OZAO._)(InfuraProvider);
    function InfuraProvider() {
        (0, $978gY._)(this, InfuraProvider);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(InfuraProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.projectId === $aafdbc33abd5222f$var$defaultProjectId;
            }
        }
    ], [
        {
            key: "getWebSocketProvider",
            value: function getWebSocketProvider(network, apiKey) {
                return new $aafdbc33abd5222f$export$dd168a807d60da4f(network, apiKey);
            }
        },
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                var apiKeyObj = {
                    apiKey: $aafdbc33abd5222f$var$defaultProjectId,
                    projectId: $aafdbc33abd5222f$var$defaultProjectId,
                    projectSecret: null
                };
                if (apiKey == null) return apiKeyObj;
                if (typeof apiKey === "string") apiKeyObj.projectId = apiKey;
                else if (apiKey.projectSecret != null) {
                    $aafdbc33abd5222f$var$logger.assertArgument(typeof apiKey.projectId === "string", "projectSecret requires a projectId", "projectId", apiKey.projectId);
                    $aafdbc33abd5222f$var$logger.assertArgument(typeof apiKey.projectSecret === "string", "invalid projectSecret", "projectSecret", "[REDACTED]");
                    apiKeyObj.projectId = apiKey.projectId;
                    apiKeyObj.projectSecret = apiKey.projectSecret;
                } else if (apiKey.projectId) apiKeyObj.projectId = apiKey.projectId;
                apiKeyObj.apiKey = apiKeyObj.projectId;
                return apiKeyObj;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                var host = null;
                switch(network ? network.name : "unknown"){
                    case "homestead":
                        host = "mainnet.infura.io";
                        break;
                    case "goerli":
                        host = "goerli.infura.io";
                        break;
                    case "sepolia":
                        host = "sepolia.infura.io";
                        break;
                    case "matic":
                        host = "polygon-mainnet.infura.io";
                        break;
                    case "maticmum":
                        host = "polygon-mumbai.infura.io";
                        break;
                    case "optimism":
                        host = "optimism-mainnet.infura.io";
                        break;
                    case "optimism-goerli":
                        host = "optimism-goerli.infura.io";
                        break;
                    case "arbitrum":
                        host = "arbitrum-mainnet.infura.io";
                        break;
                    case "arbitrum-goerli":
                        host = "arbitrum-goerli.infura.io";
                        break;
                    default:
                        $aafdbc33abd5222f$var$logger.throwError("unsupported network", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                            argument: "network",
                            value: network
                        });
                }
                var connection = {
                    allowGzip: true,
                    url: "https://" + host + "/v3/" + apiKey.projectId,
                    throttleCallback: function(attempt, url) {
                        if (apiKey.projectId === $aafdbc33abd5222f$var$defaultProjectId) (0, $f1MgE.showThrottleMessage)();
                        return Promise.resolve(true);
                    }
                };
                if (apiKey.projectSecret != null) {
                    connection.user = "";
                    connection.password = apiKey.projectSecret;
                }
                return connection;
            }
        }
    ]);
    return InfuraProvider;
}((0, $jLiNX.UrlJsonRpcProvider));

});

parcelRequire.register("fcnNv", function(module, exports) {

$parcel$export(module.exports, "JsonRpcBatchProvider", function () { return $b10a6faa86d631b8$export$5a16092bf20edf97; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $2ax4w = parcelRequire("2ax4w");

var $gqL7R = parcelRequire("gqL7R");

var $aDPpa = parcelRequire("aDPpa");
var $b10a6faa86d631b8$export$5a16092bf20edf97 = /*#__PURE__*/ function(JsonRpcProvider) {
    "use strict";
    (0, $ftJVG._)(JsonRpcBatchProvider, JsonRpcProvider);
    var _super = (0, $6OZAO._)(JsonRpcBatchProvider);
    function JsonRpcBatchProvider() {
        (0, $978gY._)(this, JsonRpcBatchProvider);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(JsonRpcBatchProvider, [
        {
            key: "send",
            value: function send(method, params) {
                var _this = this;
                var request = {
                    method: method,
                    params: params,
                    id: this._nextId++,
                    jsonrpc: "2.0"
                };
                if (this._pendingBatch == null) this._pendingBatch = [];
                var inflightRequest = {
                    request: request,
                    resolve: null,
                    reject: null
                };
                var promise = new Promise(function(resolve, reject) {
                    inflightRequest.resolve = resolve;
                    inflightRequest.reject = reject;
                });
                this._pendingBatch.push(inflightRequest);
                if (!this._pendingBatchAggregator) // Schedule batch for next event loop + short duration
                this._pendingBatchAggregator = setTimeout(function() {
                    // Get teh current batch and clear it, so new requests
                    // go into the next batch
                    var batch = _this._pendingBatch;
                    _this._pendingBatch = null;
                    _this._pendingBatchAggregator = null;
                    // Get the request as an array of requests
                    var request = batch.map(function(inflight) {
                        return inflight.request;
                    });
                    _this.emit("debug", {
                        action: "requestBatch",
                        request: (0, $2ax4w.deepCopy)(request),
                        provider: _this
                    });
                    return (0, $gqL7R.fetchJson)(_this.connection, JSON.stringify(request)).then(function(result) {
                        _this.emit("debug", {
                            action: "response",
                            request: request,
                            response: result,
                            provider: _this
                        });
                        // For each result, feed it to the correct Promise, depending
                        // on whether it was a success or error
                        batch.forEach(function(inflightRequest, index) {
                            var payload = result[index];
                            if (payload.error) {
                                var error = new Error(payload.error.message);
                                error.code = payload.error.code;
                                error.data = payload.error.data;
                                inflightRequest.reject(error);
                            } else inflightRequest.resolve(payload.result);
                        });
                    }, function(error) {
                        _this.emit("debug", {
                            action: "response",
                            error: error,
                            request: request,
                            provider: _this
                        });
                        batch.forEach(function(inflightRequest) {
                            inflightRequest.reject(error);
                        });
                    });
                }, 10);
                return promise;
            }
        }
    ]);
    return JsonRpcBatchProvider;
}((0, $aDPpa.JsonRpcProvider));

});

parcelRequire.register("7bZQB", function(module, exports) {

$parcel$export(module.exports, "NodesmithProvider", function () { return $53c9891537aa720d$export$8235cbce3ce273bd; });
/* istanbul ignore file */ 
var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $jLiNX = parcelRequire("jLiNX");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");
"use strict";
var $53c9891537aa720d$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
// Special API key provided by Nodesmith for ethers.js
var $53c9891537aa720d$var$defaultApiKey = "ETHERS_JS_SHARED";
var $53c9891537aa720d$export$8235cbce3ce273bd = /*#__PURE__*/ function(UrlJsonRpcProvider) {
    (0, $ftJVG._)(NodesmithProvider, UrlJsonRpcProvider);
    var _super = (0, $6OZAO._)(NodesmithProvider);
    function NodesmithProvider() {
        (0, $978gY._)(this, NodesmithProvider);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(NodesmithProvider, null, [
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                if (apiKey && typeof apiKey !== "string") $53c9891537aa720d$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
                return apiKey || $53c9891537aa720d$var$defaultApiKey;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                $53c9891537aa720d$var$logger.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
                var host = null;
                switch(network.name){
                    case "homestead":
                        host = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
                        break;
                    case "ropsten":
                        host = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
                        break;
                    case "rinkeby":
                        host = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
                        break;
                    case "goerli":
                        host = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
                        break;
                    case "kovan":
                        host = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
                        break;
                    default:
                        $53c9891537aa720d$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
                }
                return host + "?apiKey=" + apiKey;
            }
        }
    ]);
    return NodesmithProvider;
}((0, $jLiNX.UrlJsonRpcProvider));

});

parcelRequire.register("lc6pB", function(module, exports) {

$parcel$export(module.exports, "PocketProvider", function () { return $f6dfb138e1bee94a$export$58bb47e42f6b092e; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");

var $jLiNX = parcelRequire("jLiNX");
"use strict";
var $f6dfb138e1bee94a$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
var $f6dfb138e1bee94a$var$defaultApplicationId = "62e1ad51b37b8e00394bda3b";
var $f6dfb138e1bee94a$export$58bb47e42f6b092e = /*#__PURE__*/ function(UrlJsonRpcProvider) {
    (0, $ftJVG._)(PocketProvider, UrlJsonRpcProvider);
    var _super = (0, $6OZAO._)(PocketProvider);
    function PocketProvider() {
        (0, $978gY._)(this, PocketProvider);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(PocketProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.applicationId === $f6dfb138e1bee94a$var$defaultApplicationId;
            }
        }
    ], [
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                var apiKeyObj = {
                    applicationId: null,
                    loadBalancer: true,
                    applicationSecretKey: null
                };
                // Parse applicationId and applicationSecretKey
                if (apiKey == null) apiKeyObj.applicationId = $f6dfb138e1bee94a$var$defaultApplicationId;
                else if (typeof apiKey === "string") apiKeyObj.applicationId = apiKey;
                else if (apiKey.applicationSecretKey != null) {
                    apiKeyObj.applicationId = apiKey.applicationId;
                    apiKeyObj.applicationSecretKey = apiKey.applicationSecretKey;
                } else if (apiKey.applicationId) apiKeyObj.applicationId = apiKey.applicationId;
                else $f6dfb138e1bee94a$var$logger.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", apiKey);
                return apiKeyObj;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                var host = null;
                switch(network ? network.name : "unknown"){
                    case "goerli":
                        host = "eth-goerli.gateway.pokt.network";
                        break;
                    case "homestead":
                        host = "eth-mainnet.gateway.pokt.network";
                        break;
                    case "kovan":
                        host = "poa-kovan.gateway.pokt.network";
                        break;
                    case "matic":
                        host = "poly-mainnet.gateway.pokt.network";
                        break;
                    case "maticmum":
                        host = "polygon-mumbai-rpc.gateway.pokt.network";
                        break;
                    case "rinkeby":
                        host = "eth-rinkeby.gateway.pokt.network";
                        break;
                    case "ropsten":
                        host = "eth-ropsten.gateway.pokt.network";
                        break;
                    default:
                        $f6dfb138e1bee94a$var$logger.throwError("unsupported network", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                            argument: "network",
                            value: network
                        });
                }
                var url = "https://".concat(host, "/v1/lb/").concat(apiKey.applicationId);
                var connection = {
                    headers: {},
                    url: url
                };
                if (apiKey.applicationSecretKey != null) {
                    connection.user = "";
                    connection.password = apiKey.applicationSecretKey;
                }
                return connection;
            }
        }
    ]);
    return PocketProvider;
}((0, $jLiNX.UrlJsonRpcProvider));

});

parcelRequire.register("lh9ZS", function(module, exports) {

$parcel$export(module.exports, "Web3Provider", function () { return $f7d2f0b1fa262e29$export$d05096c9fd9d936d; });

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");

var $aDPpa = parcelRequire("aDPpa");
"use strict";
var $f7d2f0b1fa262e29$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
var $f7d2f0b1fa262e29$var$_nextId = 1;
function $f7d2f0b1fa262e29$var$buildWeb3LegacyFetcher(provider, sendFunc) {
    var fetcher = "Web3LegacyFetcher";
    return function(method, params) {
        var _this = this;
        var request = {
            method: method,
            params: params,
            id: $f7d2f0b1fa262e29$var$_nextId++,
            jsonrpc: "2.0"
        };
        return new Promise(function(resolve, reject) {
            _this.emit("debug", {
                action: "request",
                fetcher: fetcher,
                request: (0, $2ax4w.deepCopy)(request),
                provider: _this
            });
            sendFunc(request, function(error, response) {
                if (error) {
                    _this.emit("debug", {
                        action: "response",
                        fetcher: fetcher,
                        error: error,
                        request: request,
                        provider: _this
                    });
                    return reject(error);
                }
                _this.emit("debug", {
                    action: "response",
                    fetcher: fetcher,
                    request: request,
                    response: response,
                    provider: _this
                });
                if (response.error) {
                    var _$error = new Error(response.error.message);
                    _$error.code = response.error.code;
                    _$error.data = response.error.data;
                    return reject(_$error);
                }
                resolve(response.result);
            });
        });
    };
}
function $f7d2f0b1fa262e29$var$buildEip1193Fetcher(provider) {
    return function(method, params) {
        var _this = this;
        if (params == null) params = [];
        var request = {
            method: method,
            params: params
        };
        this.emit("debug", {
            action: "request",
            fetcher: "Eip1193Fetcher",
            request: (0, $2ax4w.deepCopy)(request),
            provider: this
        });
        return provider.request(request).then(function(response) {
            _this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                response: response,
                provider: _this
            });
            return response;
        }, function(error) {
            _this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                error: error,
                provider: _this
            });
            throw error;
        });
    };
}
var $f7d2f0b1fa262e29$export$d05096c9fd9d936d = /*#__PURE__*/ function(JsonRpcProvider) {
    (0, $ftJVG._)(Web3Provider, JsonRpcProvider);
    var _super = (0, $6OZAO._)(Web3Provider);
    function Web3Provider(provider, network) {
        (0, $978gY._)(this, Web3Provider);
        var _this;
        if (provider == null) $f7d2f0b1fa262e29$var$logger.throwArgumentError("missing provider", "provider", provider);
        var path = null;
        var jsonRpcFetchFunc = null;
        var subprovider = null;
        if (typeof provider === "function") {
            path = "unknown:";
            jsonRpcFetchFunc = provider;
        } else {
            path = provider.host || provider.path || "";
            if (!path && provider.isMetaMask) path = "metamask";
            subprovider = provider;
            if (provider.request) {
                if (path === "") path = "eip-1193:";
                jsonRpcFetchFunc = $f7d2f0b1fa262e29$var$buildEip1193Fetcher(provider);
            } else if (provider.sendAsync) jsonRpcFetchFunc = $f7d2f0b1fa262e29$var$buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
            else if (provider.send) jsonRpcFetchFunc = $f7d2f0b1fa262e29$var$buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
            else $f7d2f0b1fa262e29$var$logger.throwArgumentError("unsupported provider", "provider", provider);
            if (!path) path = "unknown:";
        }
        _this = _super.call(this, path, network);
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "jsonRpcFetchFunc", jsonRpcFetchFunc);
        (0, $2ax4w.defineReadOnly)((0, $3vWwE._)(_this), "provider", subprovider);
        return _this;
    }
    (0, $kry2a._)(Web3Provider, [
        {
            key: "send",
            value: function send(method, params) {
                return this.jsonRpcFetchFunc(method, params);
            }
        }
    ]);
    return Web3Provider;
}((0, $aDPpa.JsonRpcProvider));

});


parcelRequire.register("e5s6c", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", function () { return (parcelRequire("yKVLS")).AbiCoder; });
$parcel$export(module.exports, "defaultAbiCoder", function () { return (parcelRequire("yKVLS")).defaultAbiCoder; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("6CFiK")).Fragment; });
$parcel$export(module.exports, "ConstructorFragment", function () { return (parcelRequire("6CFiK")).ConstructorFragment; });
$parcel$export(module.exports, "ErrorFragment", function () { return (parcelRequire("6CFiK")).ErrorFragment; });
$parcel$export(module.exports, "EventFragment", function () { return (parcelRequire("6CFiK")).EventFragment; });
$parcel$export(module.exports, "FunctionFragment", function () { return (parcelRequire("6CFiK")).FunctionFragment; });
$parcel$export(module.exports, "ParamType", function () { return (parcelRequire("6CFiK")).ParamType; });
$parcel$export(module.exports, "FormatTypes", function () { return (parcelRequire("6CFiK")).FormatTypes; });
$parcel$export(module.exports, "checkResultErrors", function () { return (parcelRequire("ggjPf")).checkResultErrors; });
$parcel$export(module.exports, "Logger", function () { return (parcelRequire("6M65e")).Logger; });
$parcel$export(module.exports, "RLP", function () { return (parcelRequire("dQcqA")); });
$parcel$export(module.exports, "_fetchData", function () { return (parcelRequire("gqL7R"))._fetchData; });
$parcel$export(module.exports, "fetchJson", function () { return (parcelRequire("gqL7R")).fetchJson; });
$parcel$export(module.exports, "poll", function () { return (parcelRequire("gqL7R")).poll; });
$parcel$export(module.exports, "checkProperties", function () { return (parcelRequire("2ax4w")).checkProperties; });
$parcel$export(module.exports, "deepCopy", function () { return (parcelRequire("2ax4w")).deepCopy; });
$parcel$export(module.exports, "defineReadOnly", function () { return (parcelRequire("2ax4w")).defineReadOnly; });
$parcel$export(module.exports, "getStatic", function () { return (parcelRequire("2ax4w")).getStatic; });
$parcel$export(module.exports, "resolveProperties", function () { return (parcelRequire("2ax4w")).resolveProperties; });
$parcel$export(module.exports, "shallowCopy", function () { return (parcelRequire("2ax4w")).shallowCopy; });
$parcel$export(module.exports, "arrayify", function () { return (parcelRequire("j2rU8")).arrayify; });
$parcel$export(module.exports, "concat", function () { return (parcelRequire("j2rU8")).concat; });
$parcel$export(module.exports, "stripZeros", function () { return (parcelRequire("j2rU8")).stripZeros; });
$parcel$export(module.exports, "zeroPad", function () { return (parcelRequire("j2rU8")).zeroPad; });
$parcel$export(module.exports, "isBytes", function () { return (parcelRequire("j2rU8")).isBytes; });
$parcel$export(module.exports, "isBytesLike", function () { return (parcelRequire("j2rU8")).isBytesLike; });
$parcel$export(module.exports, "defaultPath", function () { return (parcelRequire("5iEGT")).defaultPath; });
$parcel$export(module.exports, "HDNode", function () { return (parcelRequire("5iEGT")).HDNode; });
$parcel$export(module.exports, "SigningKey", function () { return (parcelRequire("4LuuL")).SigningKey; });
$parcel$export(module.exports, "Interface", function () { return (parcelRequire("9rkfU")).Interface; });
$parcel$export(module.exports, "LogDescription", function () { return (parcelRequire("9rkfU")).LogDescription; });
$parcel$export(module.exports, "TransactionDescription", function () { return (parcelRequire("9rkfU")).TransactionDescription; });
$parcel$export(module.exports, "base58", function () { return (parcelRequire("ebtr5")).Base58; });
$parcel$export(module.exports, "base64", function () { return (parcelRequire("hk1je")); });
$parcel$export(module.exports, "hexlify", function () { return (parcelRequire("j2rU8")).hexlify; });
$parcel$export(module.exports, "isHexString", function () { return (parcelRequire("j2rU8")).isHexString; });
$parcel$export(module.exports, "hexConcat", function () { return (parcelRequire("j2rU8")).hexConcat; });
$parcel$export(module.exports, "hexStripZeros", function () { return (parcelRequire("j2rU8")).hexStripZeros; });
$parcel$export(module.exports, "hexValue", function () { return (parcelRequire("j2rU8")).hexValue; });
$parcel$export(module.exports, "hexZeroPad", function () { return (parcelRequire("j2rU8")).hexZeroPad; });
$parcel$export(module.exports, "hexDataLength", function () { return (parcelRequire("j2rU8")).hexDataLength; });
$parcel$export(module.exports, "hexDataSlice", function () { return (parcelRequire("j2rU8")).hexDataSlice; });
$parcel$export(module.exports, "nameprep", function () { return (parcelRequire("eHcVC")).nameprep; });
$parcel$export(module.exports, "_toEscapedUtf8String", function () { return (parcelRequire("1Wmc7"))._toEscapedUtf8String; });
$parcel$export(module.exports, "toUtf8Bytes", function () { return (parcelRequire("1Wmc7")).toUtf8Bytes; });
$parcel$export(module.exports, "toUtf8CodePoints", function () { return (parcelRequire("1Wmc7")).toUtf8CodePoints; });
$parcel$export(module.exports, "toUtf8String", function () { return (parcelRequire("1Wmc7")).toUtf8String; });
$parcel$export(module.exports, "Utf8ErrorFuncs", function () { return (parcelRequire("1Wmc7")).Utf8ErrorFuncs; });
$parcel$export(module.exports, "formatBytes32String", function () { return (parcelRequire("9osRb")).formatBytes32String; });
$parcel$export(module.exports, "parseBytes32String", function () { return (parcelRequire("9osRb")).parseBytes32String; });
$parcel$export(module.exports, "dnsEncode", function () { return (parcelRequire("4JdI5")).dnsEncode; });
$parcel$export(module.exports, "hashMessage", function () { return (parcelRequire("7vZoR")).hashMessage; });
$parcel$export(module.exports, "namehash", function () { return (parcelRequire("4JdI5")).namehash; });
$parcel$export(module.exports, "isValidName", function () { return (parcelRequire("4JdI5")).isValidName; });
$parcel$export(module.exports, "id", function () { return (parcelRequire("4q6En")).id; });
$parcel$export(module.exports, "_TypedDataEncoder", function () { return (parcelRequire("kdj79")).TypedDataEncoder; });
$parcel$export(module.exports, "getAddress", function () { return (parcelRequire("e8NrM")).getAddress; });
$parcel$export(module.exports, "getIcapAddress", function () { return (parcelRequire("e8NrM")).getIcapAddress; });
$parcel$export(module.exports, "getContractAddress", function () { return (parcelRequire("e8NrM")).getContractAddress; });
$parcel$export(module.exports, "getCreate2Address", function () { return (parcelRequire("e8NrM")).getCreate2Address; });
$parcel$export(module.exports, "isAddress", function () { return (parcelRequire("e8NrM")).isAddress; });
$parcel$export(module.exports, "formatEther", function () { return (parcelRequire("41JdS")).formatEther; });
$parcel$export(module.exports, "parseEther", function () { return (parcelRequire("41JdS")).parseEther; });
$parcel$export(module.exports, "formatUnits", function () { return (parcelRequire("41JdS")).formatUnits; });
$parcel$export(module.exports, "parseUnits", function () { return (parcelRequire("41JdS")).parseUnits; });
$parcel$export(module.exports, "commify", function () { return (parcelRequire("41JdS")).commify; });
$parcel$export(module.exports, "computeHmac", function () { return (parcelRequire("7WUQV")).computeHmac; });
$parcel$export(module.exports, "keccak256", function () { return (parcelRequire("4ujqV")).keccak256; });
$parcel$export(module.exports, "ripemd160", function () { return (parcelRequire("7WUQV")).ripemd160; });
$parcel$export(module.exports, "sha256", function () { return (parcelRequire("7WUQV")).sha256; });
$parcel$export(module.exports, "sha512", function () { return (parcelRequire("7WUQV")).sha512; });
$parcel$export(module.exports, "randomBytes", function () { return (parcelRequire("4kSyQ")).randomBytes; });
$parcel$export(module.exports, "shuffled", function () { return (parcelRequire("5aKt1")).shuffled; });
$parcel$export(module.exports, "solidityPack", function () { return (parcelRequire("ihTqz")).pack; });
$parcel$export(module.exports, "solidityKeccak256", function () { return (parcelRequire("ihTqz")).keccak256; });
$parcel$export(module.exports, "soliditySha256", function () { return (parcelRequire("ihTqz")).sha256; });
$parcel$export(module.exports, "splitSignature", function () { return (parcelRequire("j2rU8")).splitSignature; });
$parcel$export(module.exports, "joinSignature", function () { return (parcelRequire("j2rU8")).joinSignature; });
$parcel$export(module.exports, "accessListify", function () { return (parcelRequire("hDQeE")).accessListify; });
$parcel$export(module.exports, "parseTransaction", function () { return (parcelRequire("hDQeE")).parse; });
$parcel$export(module.exports, "serializeTransaction", function () { return (parcelRequire("hDQeE")).serialize; });
$parcel$export(module.exports, "TransactionTypes", function () { return (parcelRequire("hDQeE")).TransactionTypes; });
$parcel$export(module.exports, "getJsonWalletAddress", function () { return (parcelRequire("6jMeD")).getJsonWalletAddress; });
$parcel$export(module.exports, "computeAddress", function () { return (parcelRequire("hDQeE")).computeAddress; });
$parcel$export(module.exports, "recoverAddress", function () { return (parcelRequire("hDQeE")).recoverAddress; });
$parcel$export(module.exports, "computePublicKey", function () { return (parcelRequire("4LuuL")).computePublicKey; });
$parcel$export(module.exports, "recoverPublicKey", function () { return (parcelRequire("4LuuL")).recoverPublicKey; });
$parcel$export(module.exports, "verifyMessage", function () { return (parcelRequire("54wuV")).verifyMessage; });
$parcel$export(module.exports, "verifyTypedData", function () { return (parcelRequire("54wuV")).verifyTypedData; });
$parcel$export(module.exports, "getAccountPath", function () { return (parcelRequire("5iEGT")).getAccountPath; });
$parcel$export(module.exports, "mnemonicToEntropy", function () { return (parcelRequire("5iEGT")).mnemonicToEntropy; });
$parcel$export(module.exports, "entropyToMnemonic", function () { return (parcelRequire("5iEGT")).entropyToMnemonic; });
$parcel$export(module.exports, "isValidMnemonic", function () { return (parcelRequire("5iEGT")).isValidMnemonic; });
$parcel$export(module.exports, "mnemonicToSeed", function () { return (parcelRequire("5iEGT")).mnemonicToSeed; });
$parcel$export(module.exports, "SupportedAlgorithm", function () { return (parcelRequire("aCF4U")).SupportedAlgorithm; });
$parcel$export(module.exports, "UnicodeNormalizationForm", function () { return (parcelRequire("1Wmc7")).UnicodeNormalizationForm; });
$parcel$export(module.exports, "Utf8ErrorReason", function () { return (parcelRequire("1Wmc7")).Utf8ErrorReason; });
$parcel$export(module.exports, "Indexed", function () { return (parcelRequire("9rkfU")).Indexed; });

var $yKVLS = parcelRequire("yKVLS");
var $ggjPf = parcelRequire("ggjPf");
var $6CFiK = parcelRequire("6CFiK");
var $9rkfU = parcelRequire("9rkfU");

var $e8NrM = parcelRequire("e8NrM");

var $hk1je = parcelRequire("hk1je");

var $ebtr5 = parcelRequire("ebtr5");

var $j2rU8 = parcelRequire("j2rU8");

var $kdj79 = parcelRequire("kdj79");
var $4JdI5 = parcelRequire("4JdI5");
var $7vZoR = parcelRequire("7vZoR");
var $4q6En = parcelRequire("4q6En");

var $5iEGT = parcelRequire("5iEGT");

var $6jMeD = parcelRequire("6jMeD");

var $4ujqV = parcelRequire("4ujqV");

var $6M65e = parcelRequire("6M65e");

var $7WUQV = parcelRequire("7WUQV");
var $aCF4U = parcelRequire("aCF4U");

var $ihTqz = parcelRequire("ihTqz");

var $4kSyQ = parcelRequire("4kSyQ");
var $5aKt1 = parcelRequire("5aKt1");

var $2ax4w = parcelRequire("2ax4w");

var $dQcqA = parcelRequire("dQcqA");

var $4LuuL = parcelRequire("4LuuL");

var $1Wmc7 = parcelRequire("1Wmc7");
var $9osRb = parcelRequire("9osRb");
var $eHcVC = parcelRequire("eHcVC");

var $hDQeE = parcelRequire("hDQeE");

var $41JdS = parcelRequire("41JdS");

var $54wuV = parcelRequire("54wuV");

var $gqL7R = parcelRequire("gqL7R");
"use strict";

});

parcelRequire.register("d7X94", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $98e9ced0691461ae$export$83d89fbfd8236492; });
var $98e9ced0691461ae$export$83d89fbfd8236492 = "ethers/5.7.2";

});



parcelRequire.register("6d3tJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDefaultIfUndefined = module.exports.hexlifyWithout0xPrefix = module.exports.convertBytesToNumber = module.exports.convertIntegerNumberToBytes = module.exports.convertNumberToBytes = module.exports.convertStringToBytes32 = module.exports.assert = void 0;

var $gMArf = parcelRequire("gMArf");

var $hbWVX = parcelRequire("hbWVX");
var $4856a7b9b537fbe1$var$ZERO_EX_PREFIX_LENGTH = 2; // length of string "0x"
var $4856a7b9b537fbe1$var$assert = function(condition, errMsg) {
    if (!condition) {
        var errText = "Assertion failed" + (errMsg ? ": ".concat(errMsg) : "");
        throw new Error(errText);
    }
};
module.exports.assert = $4856a7b9b537fbe1$var$assert;
var $4856a7b9b537fbe1$var$convertStringToBytes32 = function(str) {
    var bytes32Str;
    if (str.length > 31) bytes32Str = (0, $hbWVX.keccak256)((0, $hbWVX.isHexString)(str) ? str : (0, $hbWVX.toUtf8Bytes)(str));
    else bytes32Str = (0, $hbWVX.formatBytes32String)(str);
    return (0, $hbWVX.arrayify)(bytes32Str);
};
module.exports.convertStringToBytes32 = $4856a7b9b537fbe1$var$convertStringToBytes32;
var $4856a7b9b537fbe1$var$convertNumberToBytes = function(value, decimals, byteSize) {
    var roundFractionalComponentIfExceedsDecimals = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var stringifiedNumber = roundFractionalComponentIfExceedsDecimals ? Number(value).toFixed(decimals) : String(value);
    var bigNumberValue = (0, $hbWVX.parseUnits)(stringifiedNumber, decimals);
    var bytesValue = (0, $hbWVX.arrayify)(bigNumberValue.toHexString());
    if (byteSize < bytesValue.length) throw new Error("Overflow: " + "value: ".concat(value, ", ") + "decimals: ".concat(decimals, ", ") + "byteSize: ".concat(byteSize));
    else return (0, $hbWVX.zeroPad)(bytesValue, byteSize);
};
module.exports.convertNumberToBytes = $4856a7b9b537fbe1$var$convertNumberToBytes;
var $4856a7b9b537fbe1$var$convertIntegerNumberToBytes = function(value, byteSize) {
    var decimals = 0; // 0 digits after comma
    return (0, module.exports.convertNumberToBytes)(value, decimals, byteSize);
};
module.exports.convertIntegerNumberToBytes = $4856a7b9b537fbe1$var$convertIntegerNumberToBytes;
var $4856a7b9b537fbe1$var$convertBytesToNumber = function(bytes) {
    return $gMArf.BigNumber.from(bytes).toNumber();
};
module.exports.convertBytesToNumber = $4856a7b9b537fbe1$var$convertBytesToNumber;
var $4856a7b9b537fbe1$var$hexlifyWithout0xPrefix = function(value) {
    return (0, $hbWVX.hexlify)(value).slice($4856a7b9b537fbe1$var$ZERO_EX_PREFIX_LENGTH);
};
module.exports.hexlifyWithout0xPrefix = $4856a7b9b537fbe1$var$hexlifyWithout0xPrefix;
function $4856a7b9b537fbe1$var$useDefaultIfUndefined(value, defaultValue) {
    return value === undefined ? defaultValue : value;
}
module.exports.useDefaultIfUndefined = $4856a7b9b537fbe1$var$useDefaultIfUndefined;

});


parcelRequire.register("2NujM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deserializeDataPointFromObj = void 0;

var $hbWVX = parcelRequire("hbWVX");

var $fhsfN = parcelRequire("fhsfN");

var $7RTBm = parcelRequire("7RTBm");
// This function was moved to a separate file, because it was not
// possible to make it as a static method in the DataPoint class.
// It would cause circularly importing classes, which is not supported
// More info here: https://stackoverflow.com/a/44727578
var $2097ace6f92c2ebf$var$deserializeDataPointFromObj = function(plainObject) {
    if (typeof plainObject.value == "number") return new $7RTBm.NumericDataPoint(plainObject);
    else return new $fhsfN.DataPoint(plainObject.dataFeedId, $hbWVX.base64.decode(plainObject.value));
};
module.exports.deserializeDataPointFromObj = $2097ace6f92c2ebf$var$deserializeDataPointFromObj;

});
parcelRequire.register("fhsfN", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataPoint = void 0;

var $hbWVX = parcelRequire("hbWVX");

var $1t7fG = parcelRequire("1t7fG");

var $6d3tJ = parcelRequire("6d3tJ");
var $b1fe5c2bed251b89$var$DataPoint = /*#__PURE__*/ function(_Serializable_1_Serializable) {
    (0, $ftJVG._)(DataPoint, _Serializable_1_Serializable);
    var _super = (0, $6OZAO._)(DataPoint);
    function DataPoint(dataFeedId, value) {
        (0, $978gY._)(this, DataPoint);
        var _this;
        _this = _super.call(this);
        _this.dataFeedId = dataFeedId;
        _this.value = value;
        return _this;
    }
    (0, $kry2a._)(DataPoint, [
        {
            key: "serializeDataFeedId",
            value: function serializeDataFeedId() {
                return (0, $6d3tJ.convertStringToBytes32)(this.dataFeedId);
            }
        },
        {
            key: "toObj",
            value: function toObj() {
                return {
                    dataFeedId: this.dataFeedId,
                    value: $hbWVX.base64.encode(this.value)
                };
            }
        },
        {
            key: "getValueByteSize",
            value: function getValueByteSize() {
                return this.value.length;
            }
        },
        {
            key: "toBytes",
            value: function toBytes() {
                var serializeddataFeedId = this.serializeDataFeedId();
                return (0, $hbWVX.concat)([
                    serializeddataFeedId,
                    this.value
                ]);
            }
        }
    ]);
    return DataPoint;
}($1t7fG.Serializable);
module.exports.DataPoint = $b1fe5c2bed251b89$var$DataPoint;

});

parcelRequire.register("7RTBm", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $8OnJk = parcelRequire("8OnJk");

var $6OZAO = parcelRequire("6OZAO");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NumericDataPoint = void 0;

var $6d3tJ = parcelRequire("6d3tJ");

var $fTHW5 = parcelRequire("fTHW5");

var $fhsfN = parcelRequire("fhsfN");
// This data point does not store information about data size in its serialized value
var $5ba89cf97fdcd27d$var$NumericDataPoint = /*#__PURE__*/ function(_DataPoint_1_DataPoint) {
    (0, $ftJVG._)(NumericDataPoint, _DataPoint_1_DataPoint);
    var _super = (0, $6OZAO._)(NumericDataPoint);
    function NumericDataPoint(numericDataPointArgs) {
        (0, $978gY._)(this, NumericDataPoint);
        var _this;
        var decimals = (0, $6d3tJ.useDefaultIfUndefined)(numericDataPointArgs.decimals, $fTHW5.DEFAULT_NUM_VALUE_DECIMALS);
        var valueByteSize = (0, $6d3tJ.useDefaultIfUndefined)(numericDataPointArgs.valueByteSize, $fTHW5.DEFAULT_NUM_VALUE_BS);
        var valueBytes = (0, $6d3tJ.convertNumberToBytes)(numericDataPointArgs.value, decimals, valueByteSize);
        _this = _super.call(this, numericDataPointArgs.dataFeedId, valueBytes);
        _this.numericDataPointArgs = numericDataPointArgs;
        return _this;
    }
    (0, $kry2a._)(NumericDataPoint, [
        {
            key: "toObj",
            value: function toObj() {
                return (0, $8OnJk._)({}, this.numericDataPointArgs);
            }
        }
    ]);
    return NumericDataPoint;
}($fhsfN.DataPoint);
module.exports.NumericDataPoint = $5ba89cf97fdcd27d$var$NumericDataPoint;

});


parcelRequire.register("43ZHe", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $gPjjc = parcelRequire("gPjjc");

var $6OZAO = parcelRequire("6OZAO");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignedDataPackage = void 0;

var $hbWVX = parcelRequire("hbWVX");

var $1t7fG = parcelRequire("1t7fG");

var $azEtj = parcelRequire("azEtj");
var $2f574cd51e47e664$var$SignedDataPackage = /*#__PURE__*/ function(_Serializable_1_Serializable) {
    (0, $ftJVG._)(SignedDataPackage, _Serializable_1_Serializable);
    var _super = (0, $6OZAO._)(SignedDataPackage);
    function SignedDataPackage(dataPackage, signature) {
        (0, $978gY._)(this, SignedDataPackage);
        var _this;
        _this = _super.call(this);
        _this.dataPackage = dataPackage;
        if (typeof signature === "string") _this.signature = (0, $hbWVX.splitSignature)(signature);
        else _this.signature = signature;
        return _this;
    }
    (0, $kry2a._)(SignedDataPackage, [
        {
            key: "serializeSignatureToBytes",
            value: function serializeSignatureToBytes() {
                return (0, $hbWVX.arrayify)(this.serializeSignatureToHex());
            }
        },
        {
            key: "serializeSignatureToHex",
            value: function serializeSignatureToHex() {
                return (0, $hbWVX.joinSignature)(this.signature);
            }
        },
        {
            key: "recoverSignerPublicKey",
            value: function recoverSignerPublicKey() {
                var digest = this.dataPackage.getSignableHash();
                var publicKeyHex = (0, $hbWVX.recoverPublicKey)(digest, this.signature);
                return (0, $hbWVX.arrayify)(publicKeyHex);
            }
        },
        {
            key: "recoverSignerAddress",
            value: function recoverSignerAddress() {
                var signerPublicKeyBytes = this.recoverSignerPublicKey();
                return (0, $hbWVX.computeAddress)(signerPublicKeyBytes);
            }
        },
        {
            key: "toBytes",
            value: function toBytes() {
                return (0, $hbWVX.concat)([
                    this.dataPackage.toBytes(),
                    this.serializeSignatureToBytes()
                ]);
            }
        },
        {
            key: "toObj",
            value: function toObj() {
                var signatureHex = this.serializeSignatureToHex();
                return (0, $8E768._)((0, $8OnJk._)({}, this.dataPackage.toObj()), {
                    signature: $hbWVX.base64.encode(signatureHex)
                });
            }
        }
    ], [
        {
            key: "fromObj",
            value: function fromObj(plainObject) {
                var signatureBase64 = plainObject.signature;
                if (!signatureBase64) throw new Error("Signature can not be empty");
                var signatureBytes = $hbWVX.base64.decode(signatureBase64);
                var parsedSignature = (0, $hbWVX.splitSignature)(signatureBytes);
                var signature = plainObject.signature, unsignedDataPackagePlainObj = (0, $gPjjc._)(plainObject, [
                    "signature"
                ]);
                var unsignedDataPackage = $azEtj.DataPackage.fromObj(unsignedDataPackagePlainObj);
                return new SignedDataPackage(unsignedDataPackage, parsedSignature);
            }
        }
    ]);
    return SignedDataPackage;
}($1t7fG.Serializable);
module.exports.SignedDataPackage = $2f574cd51e47e664$var$SignedDataPackage;

});
parcelRequire.register("gPjjc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c4006311849aa271$export$69fdd232f62cde60; });

var $eiqFq = parcelRequire("eiqFq");
function $c4006311849aa271$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $eiqFq._object_without_properties_loose)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRequire.register("eiqFq", function(module, exports) {

$parcel$export(module.exports, "_object_without_properties_loose", function () { return $a6876eae976b1234$export$7a4a7e38737aceb4; });
function $a6876eae976b1234$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});




parcelRequire.register("jbuKm", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StringDataPoint = void 0;

var $hbWVX = parcelRequire("hbWVX");

var $fhsfN = parcelRequire("fhsfN");
var $df76e50bf99d585a$var$StringDataPoint = /*#__PURE__*/ function(_DataPoint_1_DataPoint) {
    (0, $ftJVG._)(StringDataPoint, _DataPoint_1_DataPoint);
    var _super = (0, $6OZAO._)(StringDataPoint);
    function StringDataPoint(stringDataPointArgs) {
        (0, $978gY._)(this, StringDataPoint);
        var valueBytes = (0, $hbWVX.toUtf8Bytes)(stringDataPointArgs.value);
        return _super.call(this, stringDataPointArgs.dataFeedId, valueBytes);
    }
    return StringDataPoint;
}($fhsfN.DataPoint);
module.exports.StringDataPoint = $df76e50bf99d585a$var$StringDataPoint;

});

parcelRequire.register("kfRJk", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $fLnyw = parcelRequire("fLnyw");

var $6OZAO = parcelRequire("6OZAO");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RedstonePayload = void 0;

var $hbWVX = parcelRequire("hbWVX");

var $fTHW5 = parcelRequire("fTHW5");

var $1t7fG = parcelRequire("1t7fG");

var $6d3tJ = parcelRequire("6d3tJ");

var $hXb1S = parcelRequire("hXb1S");
var $ebeee308ff3f38af$var$RedstonePayload = /*#__PURE__*/ function(_Serializable_1_Serializable) {
    (0, $ftJVG._)(RedstonePayload, _Serializable_1_Serializable);
    var _super = (0, $6OZAO._)(RedstonePayload);
    function RedstonePayload(signedDataPackages, unsignedMetadata) {
        (0, $978gY._)(this, RedstonePayload);
        var _this;
        _this = _super.call(this);
        _this.signedDataPackages = signedDataPackages;
        _this.unsignedMetadata = unsignedMetadata;
        return _this;
    }
    (0, $kry2a._)(RedstonePayload, [
        {
            key: "toObj",
            value: function toObj() {
                return {
                    signedDataPackages: this.signedDataPackages.map(function(signedDataPackage) {
                        return signedDataPackage.toObj();
                    }),
                    unsignedMetadata: this.unsignedMetadata
                };
            }
        },
        {
            key: "toBytes",
            value: function toBytes() {
                return (0, $hbWVX.concat)([
                    this.serializeSignedDataPackages(),
                    this.serializeUnsignedMetadata(),
                    $fTHW5.REDSTONE_MARKER_HEX
                ]);
            }
        },
        {
            key: "serializeUnsignedMetadata",
            value: function serializeUnsignedMetadata() {
                var unsignedMetadataBytes = (0, $hbWVX.toUtf8Bytes)(this.unsignedMetadata);
                var unsignedMetadataByteSizeBytes = (0, $6d3tJ.convertIntegerNumberToBytes)(unsignedMetadataBytes.length, $fTHW5.UNSGINED_METADATA_BYTE_SIZE_BS);
                return (0, $hbWVX.concat)([
                    unsignedMetadataBytes,
                    unsignedMetadataByteSizeBytes
                ]);
            }
        },
        {
            key: "serializeSignedDataPackages",
            value: function serializeSignedDataPackages() {
                return (0, $hbWVX.concat)((0, $fLnyw._)(this.signedDataPackages.map(function(signedDataPackage) {
                    return signedDataPackage.toBytes();
                })).concat([
                    (0, $6d3tJ.convertIntegerNumberToBytes)(this.signedDataPackages.length, $fTHW5.DATA_PACKAGES_COUNT_BS)
                ]));
            }
        }
    ], [
        {
            key: "prepare",
            value: function prepare(signedDataPackages, unsignedMetadata) {
                return new RedstonePayload(signedDataPackages, unsignedMetadata).toBytesHexWithout0xPrefix();
            }
        },
        {
            key: "parse",
            value: function parse(bytesWithRedstonePayloadInTheEnd) {
                return new $hXb1S.RedstonePayloadParser(bytesWithRedstonePayloadInTheEnd).parse();
            }
        }
    ]);
    return RedstonePayload;
}($1t7fG.Serializable);
module.exports.RedstonePayload = $ebeee308ff3f38af$var$RedstonePayload;

});
parcelRequire.register("hXb1S", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RedstonePayloadParser = void 0;

var $gMArf = parcelRequire("gMArf");

var $hbWVX = parcelRequire("hbWVX");

var $fTHW5 = parcelRequire("fTHW5");

var $6d3tJ = parcelRequire("6d3tJ");

var $azEtj = parcelRequire("azEtj");

var $43ZHe = parcelRequire("43ZHe");

var $7RTBm = parcelRequire("7RTBm");
var $d120808a881d1153$var$RedstonePayloadParser = /*#__PURE__*/ function() {
    function RedstonePayloadParser(bytesData) {
        (0, $978gY._)(this, RedstonePayloadParser);
        this.bytesData = bytesData;
    }
    (0, $kry2a._)(RedstonePayloadParser, [
        {
            key: "parse",
            value: function parse() {
                this.assertValidRedstoneMarker();
                var unsignedMetadata = this.extractUnsignedMetadata();
                var negativeOffset = unsignedMetadata.length + $fTHW5.UNSGINED_METADATA_BYTE_SIZE_BS + $fTHW5.REDSTONE_MARKER_BS;
                var numberOfDataPackages = this.extractNumber({
                    negativeOffset: negativeOffset,
                    length: $fTHW5.DATA_PACKAGES_COUNT_BS
                });
                negativeOffset += $fTHW5.DATA_PACKAGES_COUNT_BS;
                // Extracting all data packages
                var signedDataPackages = [];
                for(var i = 0; i < numberOfDataPackages; i++){
                    var signedDataPackage = this.extractSignedDataPackage(negativeOffset);
                    signedDataPackages.push(signedDataPackage);
                    negativeOffset += signedDataPackage.toBytes().length;
                }
                // Preparing remainder prefix bytes
                var remainderPrefix = this.slice({
                    negativeOffset: negativeOffset,
                    length: this.bytesData.length - negativeOffset
                });
                return {
                    signedDataPackages: signedDataPackages.reverse(),
                    unsignedMetadata: unsignedMetadata,
                    remainderPrefix: remainderPrefix
                };
            }
        },
        {
            key: "extractUnsignedMetadata",
            value: function extractUnsignedMetadata() {
                var unsignedMetadataSize = this.extractNumber({
                    negativeOffset: $fTHW5.REDSTONE_MARKER_BS,
                    length: $fTHW5.UNSGINED_METADATA_BYTE_SIZE_BS
                });
                return this.slice({
                    negativeOffset: $fTHW5.REDSTONE_MARKER_BS + $fTHW5.UNSGINED_METADATA_BYTE_SIZE_BS,
                    length: unsignedMetadataSize
                });
            }
        },
        {
            key: "assertValidRedstoneMarker",
            value: function assertValidRedstoneMarker() {
                var redstoneMarker = this.slice({
                    negativeOffset: 0,
                    length: $fTHW5.REDSTONE_MARKER_BS
                });
                var redstoneMarkerHex = (0, $hbWVX.hexlify)(redstoneMarker);
                if (redstoneMarkerHex !== $fTHW5.REDSTONE_MARKER_HEX) throw new Error("Received invalid redstone marker: ".concat(redstoneMarkerHex));
            }
        },
        {
            key: "extractSignedDataPackage",
            value: function extractSignedDataPackage(initialNegativeOffset) {
                // Extracting signature
                var negativeOffset = initialNegativeOffset;
                var signature = this.slice({
                    negativeOffset: negativeOffset,
                    length: $fTHW5.SIGNATURE_BS
                });
                // Extracting number of data points
                negativeOffset += $fTHW5.SIGNATURE_BS;
                var dataPointsCount = this.extractNumber({
                    negativeOffset: negativeOffset,
                    length: $fTHW5.DATA_POINTS_COUNT_BS
                });
                // Extracting data points value byte size
                negativeOffset += $fTHW5.DATA_POINTS_COUNT_BS;
                var dataPointsValueSize = this.extractNumber({
                    negativeOffset: negativeOffset,
                    length: $fTHW5.DATA_POINT_VALUE_BYTE_SIZE_BS
                });
                // Extracting timestamp
                negativeOffset += $fTHW5.DATA_POINT_VALUE_BYTE_SIZE_BS;
                var timestamp = this.extractNumber({
                    negativeOffset: negativeOffset,
                    length: $fTHW5.TIMESTAMP_BS
                });
                // Extracting all data points
                negativeOffset += $fTHW5.TIMESTAMP_BS;
                var dataPoints = [];
                for(var i = 0; i < dataPointsCount; i++){
                    // Extracting data point value
                    var dataPointValue = this.slice({
                        negativeOffset: negativeOffset,
                        length: dataPointsValueSize
                    });
                    // Extracting data feed id for data point
                    negativeOffset += dataPointsValueSize;
                    var dataFeedId = this.slice({
                        negativeOffset: negativeOffset,
                        length: $fTHW5.DATA_FEED_ID_BS
                    });
                    // Shifting negative offset
                    negativeOffset += $fTHW5.DATA_FEED_ID_BS;
                    // Building a data point
                    var dataPoint = this.createDataPoint(dataFeedId, dataPointValue);
                    // Collecting data point
                    // Using `unshift` instead of `push` because we read from the end
                    dataPoints.unshift(dataPoint);
                }
                return new $43ZHe.SignedDataPackage(new $azEtj.DataPackage(dataPoints, timestamp), (0, $hbWVX.hexlify)(signature));
            }
        },
        {
            // This is a bit hacky, but should be enough for us at this point
            key: "createDataPoint",
            value: function createDataPoint(dataFeedId, dataPointValue) {
                return new $7RTBm.NumericDataPoint({
                    dataFeedId: (0, $hbWVX.toUtf8String)(dataFeedId).replaceAll("\x00", ""),
                    value: $gMArf.BigNumber.from(dataPointValue).toNumber() / Math.pow(10, 8)
                });
            }
        },
        {
            key: "extractNumber",
            value: function extractNumber(sliceConfig) {
                var bytesArr = this.slice(sliceConfig);
                return (0, $6d3tJ.convertBytesToNumber)(bytesArr);
            }
        },
        {
            key: "slice",
            value: function slice(sliceConfig) {
                var negativeOffset = sliceConfig.negativeOffset, length = sliceConfig.length;
                var end = this.bytesData.length - negativeOffset;
                var start = end - length;
                return this.bytesData.slice(start, end);
            }
        }
    ]);
    return RedstonePayloadParser;
}();
module.exports.RedstonePayloadParser = $d120808a881d1153$var$RedstonePayloadParser;

});


parcelRequire.register("7G1XU", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UniversalSigner = void 0;

var $hbWVX = parcelRequire("hbWVX");
var $596dfae42088bd9e$var$UniversalSigner = /*#__PURE__*/ function() {
    function UniversalSigner() {
        (0, $978gY._)(this, UniversalSigner);
    }
    (0, $kry2a._)(UniversalSigner, null, [
        {
            key: "getDigestForData",
            value: function getDigestForData(data) {
                var message = JSON.stringify(data);
                var digest = (0, $hbWVX.keccak256)((0, $hbWVX.toUtf8Bytes)(message));
                return digest;
            }
        },
        {
            key: "signStringifiableData",
            value: function signStringifiableData(data, privateKey) {
                var digest = UniversalSigner.getDigestForData(data);
                var signingKey = new $hbWVX.SigningKey(privateKey);
                var fullSignature = signingKey.signDigest(digest);
                return (0, $hbWVX.joinSignature)(fullSignature);
            }
        },
        {
            key: "recoverSigner",
            value: function recoverSigner(data, signature) {
                var digest = UniversalSigner.getDigestForData(data);
                var publicKey = (0, $hbWVX.recoverPublicKey)(digest, signature);
                return (0, $hbWVX.computeAddress)(publicKey);
            }
        },
        {
            key: "signWithEthereumHashMessage",
            value: function signWithEthereumHashMessage(signerOrWallet, message) {
                return signerOrWallet.signMessage(message);
            }
        },
        {
            key: "recoverAddressFromEthereumHashMessage",
            value: function recoverAddressFromEthereumHashMessage(message, signature) {
                return (0, $hbWVX.verifyMessage)(message, signature);
            }
        }
    ]);
    return UniversalSigner;
}();
module.exports.UniversalSigner = $596dfae42088bd9e$var$UniversalSigner;

});

parcelRequire.register("lGxEn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ScoreType = void 0;
var $fc979f75205b72ab$var$ScoreType;
(function(ScoreType) {
    ScoreType["coinbaseKYD"] = "coinbase-kyd";
})($fc979f75205b72ab$var$ScoreType = module.exports.ScoreType || (module.exports.ScoreType = {}));

});

parcelRequire.register("3GP0A", function(module, exports) {
"use strict";
var $2afcdc92573cd361$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2afcdc92573cd361$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2afcdc92573cd361$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2afcdc92573cd361$var$__exportStar((parcelRequire("a0G0n")), module.exports);

});
parcelRequire.register("a0G0n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.prepareMessageToSign = module.exports.signOnDemandDataPackage = void 0;

var $azEtj = parcelRequire("azEtj");

var $7RTBm = parcelRequire("7RTBm");
var $749a7cd073f21233$var$signOnDemandDataPackage = function(address, score, timestamp, privateKey) {
    var dataPoint = new $7RTBm.NumericDataPoint({
        dataFeedId: address,
        value: score,
        decimals: 0
    });
    var dataPackage = new $azEtj.DataPackage([
        dataPoint
    ], timestamp);
    return dataPackage.sign(privateKey);
};
module.exports.signOnDemandDataPackage = $749a7cd073f21233$var$signOnDemandDataPackage;
var $749a7cd073f21233$var$prepareMessageToSign = function(timestamp) {
    var utcDate = new Date(timestamp).toUTCString();
    return "Allow verification of my account on ".concat(utcDate);
};
module.exports.prepareMessageToSign = $749a7cd073f21233$var$prepareMessageToSign;

});


parcelRequire.register("a568B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveDataServiceUrls = module.exports.REDSTONE_DATA_SERVICES_URLS = void 0;
var $756f21d39961bf87$var$DEMO_URL = "https://d33trozg86ya9x.cloudfront.net";
module.exports.REDSTONE_DATA_SERVICES_URLS = {
    "redstone-primary-prod": [
        "https://oracle-gateway-1.a.redstone.finance",
        "https://oracle-gateway-2.a.redstone.finance"
    ],
    // TODO: NOT DEPLOYED YET "redstone-primary-demo": [],
    "redstone-avalanche-prod": [
        "https://oracle-gateway-1.a.redstone.finance",
        "https://oracle-gateway-2.a.redstone.finance"
    ],
    "redstone-custom-urls-demo": [
        "https://d1zm8lxy9v2ddd.cloudfront.net"
    ],
    "redstone-main-demo": [
        $756f21d39961bf87$var$DEMO_URL
    ],
    "redstone-rapid-demo": [
        $756f21d39961bf87$var$DEMO_URL
    ],
    "redstone-stocks-demo": [
        $756f21d39961bf87$var$DEMO_URL
    ],
    "redstone-twaps-demo": [
        $756f21d39961bf87$var$DEMO_URL
    ],
    "mock-data-service": [
        "http://localhost:3000"
    ],
    "mock-data-service-tests": [
        "http://valid-cache.com"
    ]
};
var $756f21d39961bf87$var$resolveDataServiceUrls = function(dataServiceId) {
    var urls = module.exports.REDSTONE_DATA_SERVICES_URLS[dataServiceId];
    if (!urls) throw Error("Data service ".concat(dataServiceId, " is not configured by Redstone protocol"));
    return urls;
};
module.exports.resolveDataServiceUrls = $756f21d39961bf87$var$resolveDataServiceUrls;

});

parcelRequire.register("3UmfN", function(module, exports) {
"use strict";
var $2d87dd31b7eb341c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2d87dd31b7eb341c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2d87dd31b7eb341c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2d87dd31b7eb341c$var$__exportStar((parcelRequire("1PbLP")), module.exports);

$2d87dd31b7eb341c$var$__exportStar((parcelRequire("hB2ex")), module.exports);

$2d87dd31b7eb341c$var$__exportStar((parcelRequire("hy6GB")), module.exports);

$2d87dd31b7eb341c$var$__exportStar((parcelRequire("1PghR")), module.exports);

});
parcelRequire.register("1PbLP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("hB2ex", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafeZero = module.exports.createSafeNumber = void 0;

var $1PghR = parcelRequire("1PghR");
/** Factory for SafeNumber */ var $ccf79fdfa01925ac$var$createSafeNumber = function(numberLike) {
    return $1PghR.JsNativeSafeNumber.from(numberLike);
};
module.exports.createSafeNumber = $ccf79fdfa01925ac$var$createSafeNumber;
module.exports.SafeZero = (0, module.exports.createSafeNumber)(0);

});
parcelRequire.register("1PghR", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsNativeSafeNumber = module.exports.JsNativeSafeNumberConfig = module.exports.NumberValidationResult = void 0;
var $15473027336b677a$var$NumberValidationResult;
(function(NumberValidationResult) {
    NumberValidationResult[NumberValidationResult["isOk"] = 0] = "isOk";
    NumberValidationResult[NumberValidationResult["isNaN"] = 1] = "isNaN";
    NumberValidationResult[NumberValidationResult["isNotFinite"] = 2] = "isNotFinite";
    NumberValidationResult[NumberValidationResult["isOverflow"] = 3] = "isOverflow";
    NumberValidationResult[NumberValidationResult["isUnderflow"] = 4] = "isUnderflow";
})($15473027336b677a$var$NumberValidationResult || (module.exports.NumberValidationResult = $15473027336b677a$var$NumberValidationResult = {}));
var $15473027336b677a$var$_obj;
module.exports.JsNativeSafeNumberConfig = {
    MAX_NUMBER: Number.MAX_SAFE_INTEGER,
    MIN_NUMBER: 1e-14,
    MAX_DECIMALS: 14,
    DIGIT_REGEXP: /^[-+]?(\d+(\.\d{1,63})?|\.\d{1,63})([eE][-+]?\d+)?$/,
    ON_NUMBER_VALIDATION_ERROR: ($15473027336b677a$var$_obj = {}, (0, $dxWQo._)($15473027336b677a$var$_obj, $15473027336b677a$var$NumberValidationResult.isNaN, function(msg) {
        throw new Error(msg);
    }), (0, $dxWQo._)($15473027336b677a$var$_obj, $15473027336b677a$var$NumberValidationResult.isNotFinite, function(msg) {
        throw new Error(msg);
    }), (0, $dxWQo._)($15473027336b677a$var$_obj, $15473027336b677a$var$NumberValidationResult.isOverflow, console.error), (0, $dxWQo._)($15473027336b677a$var$_obj, $15473027336b677a$var$NumberValidationResult.isUnderflow, console.error), $15473027336b677a$var$_obj),
    EPSILON: 1e-14
};
var $15473027336b677a$var$JsNativeSafeNumber = /*#__PURE__*/ function() {
    function JsNativeSafeNumber(value) {
        (0, $978gY._)(this, JsNativeSafeNumber);
        this._value = value;
    }
    (0, $kry2a._)(JsNativeSafeNumber, [
        {
            key: "decimals",
            value: function decimals() {
                return module.exports.JsNativeSafeNumberConfig.MAX_DECIMALS;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this._value.toString();
            }
        },
        {
            key: "isSafeNumber",
            value: function isSafeNumber() {
                return true;
            }
        },
        {
            key: "abs",
            value: function abs() {
                var result = Math.abs(this._value);
                return this.produceNewSafeNumber(result);
            }
        },
        {
            key: "add",
            value: function add(numberLike) {
                var result = this._value + JsNativeSafeNumber.from(numberLike).unsafeToNumber();
                return this.produceNewSafeNumber(result);
            }
        },
        {
            key: "sub",
            value: function sub(numberLike) {
                var result = this._value - JsNativeSafeNumber.from(numberLike).unsafeToNumber();
                return this.produceNewSafeNumber(result);
            }
        },
        {
            key: "div",
            value: function div(numberLike) {
                var result = this._value / JsNativeSafeNumber.from(numberLike).unsafeToNumber();
                return this.produceNewSafeNumber(result);
            }
        },
        {
            key: "mul",
            value: function mul(numberLike) {
                var result = this._value * JsNativeSafeNumber.from(numberLike).unsafeToNumber();
                return this.produceNewSafeNumber(result);
            }
        },
        {
            key: "assertNonNegative",
            value: function assertNonNegative() {
                if (this._value < 0) throw new Error("Assert non negative failed");
            }
        },
        {
            /** In the case of this implementation it is actually safe. */ key: "unsafeToNumber",
            value: function unsafeToNumber() {
                return this._value;
            }
        },
        {
            key: "eq",
            value: function eq(numberArg) {
                var number = JsNativeSafeNumber.from(numberArg);
                return Math.abs(number.unsafeToNumber() - this._value) < module.exports.JsNativeSafeNumberConfig.EPSILON;
            }
        },
        {
            key: "lt",
            value: function lt(numberArg) {
                return this._value < JsNativeSafeNumber.from(numberArg).unsafeToNumber();
            }
        },
        {
            key: "lte",
            value: function lte(numberArg) {
                return this.lt(numberArg) || this.eq(numberArg);
            }
        },
        {
            key: "gt",
            value: function gt(numberArg) {
                return this._value > JsNativeSafeNumber.from(numberArg).unsafeToNumber();
            }
        },
        {
            key: "gte",
            value: function gte(numberArg) {
                return this.gt(numberArg) || this.eq(numberArg);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.unsafeToNumber();
            }
        },
        {
            key: "produceNewSafeNumber",
            value: function produceNewSafeNumber(result) {
                var newNumber = new JsNativeSafeNumber(result);
                newNumber.assertValidAndRound();
                return newNumber;
            }
        },
        {
            key: "assertValidAndRound",
            value: function assertValidAndRound() {
                var _validateNumber = $15473027336b677a$var$validateNumber(this._value), validationResult = _validateNumber.result, message = _validateNumber.message;
                if (validationResult !== $15473027336b677a$var$NumberValidationResult.isOk) module.exports.JsNativeSafeNumberConfig.ON_NUMBER_VALIDATION_ERROR[validationResult](message);
                this._value = Number(this._value.toFixed(module.exports.JsNativeSafeNumberConfig.MAX_DECIMALS));
            }
        }
    ], [
        {
            key: "from",
            value: /** This method should only be called by factory {N} */ function from(numberLike) {
                if (numberLike instanceof JsNativeSafeNumber) return new JsNativeSafeNumber(numberLike.unsafeToNumber());
                else if (typeof numberLike === "number" || typeof numberLike === "string") return new JsNativeSafeNumber($15473027336b677a$var$parseToSafeNumber(numberLike));
                else throw new Error("Invalid number format: Tried to create JsNativeSafeNumber from ".concat(numberLike));
            }
        }
    ]);
    return JsNativeSafeNumber;
}();
module.exports.JsNativeSafeNumber = $15473027336b677a$var$JsNativeSafeNumber;
var $15473027336b677a$var$validateNumber = function(number) {
    if (Number.isNaN(number)) return {
        result: $15473027336b677a$var$NumberValidationResult.isNaN,
        message: "Invalid number format: number is NaN"
    };
    else if (!Number.isFinite(number)) return {
        result: $15473027336b677a$var$NumberValidationResult.isNotFinite,
        message: "Invalid number format: number is not finite"
    };
    if (Math.abs(number) > module.exports.JsNativeSafeNumberConfig.MAX_NUMBER) return {
        result: $15473027336b677a$var$NumberValidationResult.isOverflow,
        message: "Invalid number format: Number is bigger than max number acceptable by REDSTONE ".concat(number)
    };
    if (Math.abs(number) < module.exports.JsNativeSafeNumberConfig.MIN_NUMBER && number !== 0) return {
        result: $15473027336b677a$var$NumberValidationResult.isUnderflow,
        message: "Invalid number format: Number is smaller than min number acceptable by REDSTONE ".concat(number)
    };
    return {
        result: $15473027336b677a$var$NumberValidationResult.isOk,
        message: ""
    };
};
var $15473027336b677a$var$parseToSafeNumber = function(value) {
    var number;
    if (typeof value === "string") {
        if (!module.exports.JsNativeSafeNumberConfig.DIGIT_REGEXP.test(value)) throw new Error("Invalid number format: ".concat(value, ", not matching regexp: ").concat(module.exports.JsNativeSafeNumberConfig.DIGIT_REGEXP));
        number = Number(value);
    } else if (typeof value === "number") number = Number(value);
    else throw new Error("Invalid number format, expected: string or number");
    var _validateNumber = $15473027336b677a$var$validateNumber(number), validationResult = _validateNumber.result, message = _validateNumber.message;
    if (validationResult !== $15473027336b677a$var$NumberValidationResult.isOk) module.exports.JsNativeSafeNumberConfig.ON_NUMBER_VALIDATION_ERROR[validationResult](message);
    return number;
};

});


parcelRequire.register("hy6GB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMedian = module.exports.calculateDeviationPercent = module.exports.calculateAverageValue = module.exports.calculateSum = void 0;

var $hB2ex = parcelRequire("hB2ex");
var $cc6acc62a2c07ad2$var$calculateSum = function(numbers) {
    return numbers.reduce(function(prev, curr) {
        return prev.add(curr);
    }, (0, $hB2ex.createSafeNumber)(0));
};
module.exports.calculateSum = $cc6acc62a2c07ad2$var$calculateSum;
var $cc6acc62a2c07ad2$var$calculateAverageValue = function(numbers) {
    if (numbers.length === 0) throw new Error("Can not calculate an average value for an empty array");
    var result = (0, module.exports.calculateSum)(numbers).div(numbers.length);
    return result;
};
module.exports.calculateAverageValue = $cc6acc62a2c07ad2$var$calculateAverageValue;
var $cc6acc62a2c07ad2$var$calculateDeviationPercent = function(args) {
    var prevValue = args.prevValue, currValue = args.currValue;
    if (currValue.eq(0)) return (0, $hB2ex.createSafeNumber)(Number.MAX_SAFE_INTEGER);
    var result = prevValue.sub(currValue).div(currValue).abs().mul(100);
    return result;
};
module.exports.calculateDeviationPercent = $cc6acc62a2c07ad2$var$calculateDeviationPercent;
function $cc6acc62a2c07ad2$var$getMedian(numbers) {
    if (numbers.length === 0) throw new Error("Cannot get median value of an empty array");
    numbers = numbers.sort(function(a, b) {
        return a.lt(b) ? -1 : 1;
    });
    var middle = Math.floor(numbers.length / 2);
    if (numbers.length % 2 === 0) return numbers[middle].add(numbers[middle - 1]).div(2);
    else return numbers[middle];
}
module.exports.getMedian = $cc6acc62a2c07ad2$var$getMedian;

});


parcelRequire.register("fXzVi", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");
"use strict";
var $b9e83b4af3b61131$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b9e83b4af3b61131$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b9e83b4af3b61131$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b9e83b4af3b61131$var$__createBinding(result, mod, k);
    }
    $b9e83b4af3b61131$var$__setModuleDefault(result, mod);
    return result;
};
var $b9e83b4af3b61131$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecisionScaler = module.exports.getMedian = module.exports.calculateDeviationPercent = module.exports.calculateSum = module.exports.castToISafeNumber = void 0;

var $b9e83b4af3b61131$var$decimal_js_1 = $b9e83b4af3b61131$var$__importDefault((parcelRequire("4qPUL")));

var $b9e83b4af3b61131$var$ISafeNumberMath = $b9e83b4af3b61131$var$__importStar((parcelRequire("3UmfN")));

var $b9e83b4af3b61131$var$castToISafeNumber = function(numberLike) {
    if (typeof numberLike === "string" || typeof numberLike === "number") return (0, (parcelRequire("3UmfN")).createSafeNumber)(numberLike.toString());
    else if (numberLike instanceof $b9e83b4af3b61131$var$decimal_js_1.default) return (0, (parcelRequire("3UmfN")).createSafeNumber)(numberLike.toString());
    else if (numberLike.isSafeNumber()) return numberLike;
    else throw new Error("Can not cast ".concat(numberLike, " to ISafeNumber"));
};
module.exports.castToISafeNumber = $b9e83b4af3b61131$var$castToISafeNumber;
var $b9e83b4af3b61131$var$calculateSum = function(numbers) {
    return $b9e83b4af3b61131$var$ISafeNumberMath.calculateSum(numbers.map(module.exports.castToISafeNumber)).unsafeToNumber();
};
module.exports.calculateSum = $b9e83b4af3b61131$var$calculateSum;
var $b9e83b4af3b61131$var$calculateDeviationPercent = function(args) {
    return $b9e83b4af3b61131$var$ISafeNumberMath.calculateDeviationPercent({
        prevValue: (0, module.exports.castToISafeNumber)(args.prevValue),
        currValue: (0, module.exports.castToISafeNumber)(args.newValue)
    }).unsafeToNumber();
};
module.exports.calculateDeviationPercent = $b9e83b4af3b61131$var$calculateDeviationPercent;
var $b9e83b4af3b61131$var$getMedian = function(numbers) {
    return $b9e83b4af3b61131$var$ISafeNumberMath.getMedian(numbers.map(module.exports.castToISafeNumber)).unsafeToNumber();
};
module.exports.getMedian = $b9e83b4af3b61131$var$getMedian;
var $b9e83b4af3b61131$var$PrecisionScaler = /*#__PURE__*/ function() {
    function PrecisionScaler(tokenDecimals) {
        (0, $978gY._)(this, PrecisionScaler);
        this.tokenDecimals = tokenDecimals;
        this.tokenDecimalsScaler = new $b9e83b4af3b61131$var$decimal_js_1.default(10).pow(tokenDecimals);
    }
    (0, $kry2a._)(PrecisionScaler, [
        {
            key: "toSolidityValue",
            value: function toSolidityValue(floatNumber) {
                return new $b9e83b4af3b61131$var$decimal_js_1.default(floatNumber).mul(this.tokenDecimalsScaler).toString();
            }
        },
        {
            key: "fromSolidityValue",
            value: function fromSolidityValue(contractValue) {
                return new $b9e83b4af3b61131$var$decimal_js_1.default(contractValue.toString()).div(this.tokenDecimalsScaler);
            }
        }
    ]);
    return PrecisionScaler;
}();
module.exports.PrecisionScaler = $b9e83b4af3b61131$var$PrecisionScaler;

});
parcelRequire.register("4qPUL", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
(function(globalScope) {
    "use strict";
    var digitsToString = // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
   *                           finiteToString, naturalExponential, naturalLogarithm
   *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
   *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
   *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
   *  convertBase              toStringBinary, parseOther
   *  cos                      P.cos
   *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
   *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
   *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
   *                           taylorSeries, atan2, parseOther
   *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
   *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
   *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
   *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
   *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
   *                           P.truncated, divide, getLn10, getPi, naturalExponential,
   *                           naturalLogarithm, ceil, floor, round, trunc
   *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
   *                           toStringBinary
   *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
   *  getLn10                  P.logarithm, naturalLogarithm
   *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
   *  getPrecision             P.precision, P.toFraction
   *  getZeroString            digitsToString, finiteToString
   *  intPow                   P.toPower, parseOther
   *  isOdd                    toLessThanHalfPi
   *  maxOrMin                 max, min
   *  naturalExponential       P.naturalExponential, P.toPower
   *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
   *                           P.toPower, naturalExponential
   *  nonFiniteToString        finiteToString, toStringBinary
   *  parseDecimal             Decimal
   *  parseOther               Decimal
   *  sin                      P.sin
   *  taylorSeries             P.cosh, P.sinh, cos, sin
   *  toLessThanHalfPi         P.cos, P.sin
   *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
   *  truncate                 intPow
   *
   *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
   *                           naturalLogarithm, config, parseOther, random, Decimal
   */ function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    };
    var checkInt32 = function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    };
    var checkRoundingDigits = /*
   * Check 5 rounding digits if `repeating` is null, 4 otherwise.
   * `repeating == null` if caller is `log` or `pow`,
   * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
   */ function checkRoundingDigits(d, i, rm, repeating) {
        var di, k, r, rd;
        // Get the length of the first word of the array d.
        for(k = d[0]; k >= 10; k /= 10)--i;
        // Is the rounding digit in the first word of d?
        if (--i < 0) {
            i += LOG_BASE;
            di = 0;
        } else {
            di = Math.ceil((i + 1) / LOG_BASE);
            i %= LOG_BASE;
        }
        // i is the index (0 - 6) of the rounding digit.
        // E.g. if within the word 3487563 the first rounding digit is 5,
        // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
        k = mathpow(10, LOG_BASE - i);
        rd = d[di] % k | 0;
        if (repeating == null) {
            if (i < 3) {
                if (i == 0) rd = rd / 100 | 0;
                else if (i == 1) rd = rd / 10 | 0;
                r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
            } else r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 || (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
        } else if (i < 4) {
            if (i == 0) rd = rd / 1000 | 0;
            else if (i == 1) rd = rd / 100 | 0;
            else if (i == 2) rd = rd / 10 | 0;
            r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
        } else r = ((repeating || rm < 4) && rd + 1 == k || !repeating && rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 1000 | 0) == mathpow(10, i - 3) - 1;
        return r;
    };
    var convertBase = // Convert string of `baseIn` to an array of numbers of `baseOut`.
    // Eg. convertBase('255', 10, 16) returns [15, 15].
    // Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
    function convertBase(str, baseIn, baseOut) {
        var j, arr = [
            0
        ], arrL, i = 0, strL = str.length;
        for(; i < strL;){
            for(arrL = arr.length; arrL--;)arr[arrL] *= baseIn;
            arr[0] += NUMERALS.indexOf(str.charAt(i++));
            for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                if (arr[j + 1] === void 0) arr[j + 1] = 0;
                arr[j + 1] += arr[j] / baseOut | 0;
                arr[j] %= baseOut;
            }
        }
        return arr.reverse();
    };
    var cosine = /*
   * cos(x) = 1 - x^2/2! + x^4/4! - ...
   * |x| < pi/2
   *
   */ function cosine(Ctor, x) {
        var k, len, y;
        if (x.isZero()) return x;
        // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
        // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1
        // Estimate the optimum number of times to use the argument reduction.
        len = x.d.length;
        if (len < 32) {
            k = Math.ceil(len / 3);
            y = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            y = "2.3283064365386962890625e-10";
        }
        Ctor.precision += k;
        x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));
        // Reverse argument reduction
        for(var i = k; i--;){
            var cos2x = x.times(x);
            x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
        }
        Ctor.precision -= k;
        return x;
    };
    var finalise = /*
   * Round `x` to `sd` significant digits using rounding mode `rm`.
   * Check for over/under-flow.
   */ function finalise(x, sd, rm, isTruncated) {
        var digits, i, j, k, rd, roundUp, w, xd, xdi, Ctor = x.constructor;
        // Don't round if sd is null or undefined.
        out: if (sd != null) {
            xd = x.d;
            // Infinity/NaN.
            if (!xd) return x;
            // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
            // w: the word of xd containing rd, a base 1e7 number.
            // xdi: the index of w within xd.
            // digits: the number of digits of w.
            // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
            // they had leading zeros)
            // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
            // Get the length of the first word of the digits array xd.
            for(digits = 1, k = xd[0]; k >= 10; k /= 10)digits++;
            i = sd - digits;
            // Is the rounding digit in the first word of xd?
            if (i < 0) {
                i += LOG_BASE;
                j = sd;
                w = xd[xdi = 0];
                // Get the rounding digit at index j of w.
                rd = w / mathpow(10, digits - j - 1) % 10 | 0;
            } else {
                xdi = Math.ceil((i + 1) / LOG_BASE);
                k = xd.length;
                if (xdi >= k) {
                    if (isTruncated) {
                        // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
                        for(; k++ <= xdi;)xd.push(0);
                        w = rd = 0;
                        digits = 1;
                        i %= LOG_BASE;
                        j = i - LOG_BASE + 1;
                    } else break out;
                } else {
                    w = k = xd[xdi];
                    // Get the number of digits of w.
                    for(digits = 1; k >= 10; k /= 10)digits++;
                    // Get the index of rd within w.
                    i %= LOG_BASE;
                    // Get the index of rd within w, adjusted for leading zeros.
                    // The number of leading zeros of w is given by LOG_BASE - digits.
                    j = i - LOG_BASE + digits;
                    // Get the rounding digit at index j of w.
                    rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
                }
            }
            // Are there any non-zero digits after the rounding digit?
            isTruncated = isTruncated || sd < 0 || xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));
            // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
            // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
            // will give 714.
            roundUp = rm < 4 ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
            if (sd < 1 || !xd[0]) {
                xd.length = 0;
                if (roundUp) {
                    // Convert sd to decimal places.
                    sd -= x.e + 1;
                    // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                    xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                    x.e = -sd || 0;
                } else // Zero.
                xd[0] = x.e = 0;
                return x;
            }
            // Remove excess digits.
            if (i == 0) {
                xd.length = xdi;
                k = 1;
                xdi--;
            } else {
                xd.length = xdi + 1;
                k = mathpow(10, LOG_BASE - i);
                // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                // j > 0 means i > number of leading zeros of w.
                xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
            }
            if (roundUp) {
                for(;;)// Is the digit to be rounded up in the first word of xd?
                if (xdi == 0) {
                    // i will be the length of xd[0] before k is added.
                    for(i = 1, j = xd[0]; j >= 10; j /= 10)i++;
                    j = xd[0] += k;
                    for(k = 1; j >= 10; j /= 10)k++;
                    // if i != k the length has increased.
                    if (i != k) {
                        x.e++;
                        if (xd[0] == BASE) xd[0] = 1;
                    }
                    break;
                } else {
                    xd[xdi] += k;
                    if (xd[xdi] != BASE) break;
                    xd[xdi--] = 0;
                    k = 1;
                }
            }
            // Remove trailing zeros.
            for(i = xd.length; xd[--i] === 0;)xd.pop();
        }
        if (external) {
            // Overflow?
            if (x.e > Ctor.maxE) {
                // Infinity.
                x.d = null;
                x.e = NaN;
            // Underflow?
            } else if (x.e < Ctor.minE) {
                // Zero.
                x.e = 0;
                x.d = [
                    0
                ];
            // Ctor.underflow = true;
            } // else Ctor.underflow = false;
        }
        return x;
    };
    var finiteToString = function finiteToString(x, isExp, sd) {
        if (!x.isFinite()) return nonFiniteToString(x);
        var k, e = x.e, str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (x.e < 0 ? "e" : "e+") + x.e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return str;
    };
    var getBase10Exponent = // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(digits, e) {
        var w = digits[0];
        // Add the number of digits of the first word of the digits array.
        for(e *= LOG_BASE; w >= 10; w /= 10)e++;
        return e;
    };
    var getLn10 = function getLn10(Ctor, sd, pr) {
        if (sd > LN10_PRECISION) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(precisionLimitExceeded);
        }
        return finalise(new Ctor(LN10), sd, 1, true);
    };
    var getPi = function getPi(Ctor, sd, rm) {
        if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
        return finalise(new Ctor(PI), sd, rm, true);
    };
    var getPrecision = function getPrecision(digits) {
        var w = digits.length - 1, len = w * LOG_BASE + 1;
        w = digits[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)len--;
            // Add the number of digits of the first word.
            for(w = digits[0]; w >= 10; w /= 10)len++;
        }
        return len;
    };
    var getZeroString = function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    };
    var intPow = /*
   * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
   * integer of type number.
   *
   * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
   *
   */ function intPow(Ctor, x, n, pr) {
        var isTruncated, r = new Ctor(1), // Max n of 9007199254740991 takes 53 loop iterations.
        // Maximum digits array length; leaves [28, 34] guard digits.
        k = Math.ceil(pr / LOG_BASE + 4);
        external = false;
        for(;;){
            if (n % 2) {
                r = r.times(x);
                if (truncate(r.d, k)) isTruncated = true;
            }
            n = mathfloor(n / 2);
            if (n === 0) {
                // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
                n = r.d.length - 1;
                if (isTruncated && r.d[n] === 0) ++r.d[n];
                break;
            }
            x = x.times(x);
            truncate(x.d, k);
        }
        external = true;
        return r;
    };
    var isOdd = function isOdd(n) {
        return n.d[n.d.length - 1] & 1;
    };
    var maxOrMin = /*
   * Handle `max` and `min`. `ltgt` is 'lt' or 'gt'.
   */ function maxOrMin(Ctor, args, ltgt) {
        var y, x = new Ctor(args[0]), i = 0;
        for(; ++i < args.length;){
            y = new Ctor(args[i]);
            if (!y.s) {
                x = y;
                break;
            } else if (x[ltgt](y)) x = y;
        }
        return x;
    };
    var naturalExponential = /*
   * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
   * digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
   * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(Infinity)  = Infinity
   *  exp(-Infinity) = 0
   *  exp(NaN)       = NaN
   *  exp(±0)        = 1
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   *  The result will always be correctly rounded.
   *
   */ function naturalExponential(x, sd) {
        var denominator, guard, j, pow, sum, t, wpr, rep = 0, i = 0, k = 0, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // 0/NaN/Infinity?
        if (!x.d || !x.d[0] || x.e > 17) return new Ctor(x.d ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0 : x.s ? x.s < 0 ? 0 : x : 0 / 0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        // while abs(x) >= 0.1
        while(x.e > -2){
            // x = x / 2^5
            x = x.times(t);
            k += 5;
        }
        // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
        // necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(1);
        Ctor.precision = wpr;
        for(;;){
            pow = finalise(pow.times(x), wpr, 1);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                j = k;
                while(j--)sum = finalise(sum.times(sum), wpr, 1);
                // Check to see if the first 4 rounding digits are [49]999.
                // If so, repeat the summation with a higher precision, otherwise
                // e.g. with precision: 18, rounding: 1
                // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (rep < 3 && checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += 10;
                        denominator = pow = t = new Ctor(1);
                        i = 0;
                        rep++;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
        }
    };
    var nonFiniteToString = // ±Infinity, NaN.
    function nonFiniteToString(x) {
        // Unsigned.
        return String(x.s * x.s / 0);
    };
    var parseDecimal = /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48; --len);
        str = str.slice(i, len);
        if (str) {
            len -= i;
            x.e = e = e - i - 1;
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external) {
                // Overflow?
                if (x.e > x.constructor.maxE) {
                    // Infinity.
                    x.d = null;
                    x.e = NaN;
                // Underflow?
                } else if (x.e < x.constructor.minE) {
                    // Zero.
                    x.e = 0;
                    x.d = [
                        0
                    ];
                // x.constructor.underflow = true;
                } // else x.constructor.underflow = false;
            }
        } else {
            // Zero.
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    };
    var parseOther = /*
   * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
   */ function parseOther(x, str) {
        var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
        if (str.indexOf("_") > -1) {
            str = str.replace(/(\d)_(?=\d)/g, "$1");
            if (isDecimal.test(str)) return parseDecimal(x, str);
        } else if (str === "Infinity" || str === "NaN") {
            if (!+str) x.s = NaN;
            x.e = NaN;
            x.d = null;
            return x;
        }
        if (isHex.test(str)) {
            base = 16;
            str = str.toLowerCase();
        } else if (isBinary.test(str)) base = 2;
        else if (isOctal.test(str)) base = 8;
        else throw Error(invalidArgument + str);
        // Is there a binary exponent part?
        i = str.search(/p/i);
        if (i > 0) {
            p = +str.slice(i + 1);
            str = str.substring(2, i);
        } else str = str.slice(2);
        // Convert `str` as an integer then divide the result by `base` raised to a power such that the
        // fraction part will be restored.
        i = str.indexOf(".");
        isFloat = i >= 0;
        Ctor = x.constructor;
        if (isFloat) {
            str = str.replace(".", "");
            len = str.length;
            i = len - i;
            // log[10](16) = 1.2041... , log[10](88) = 1.9444....
            divisor = intPow(Ctor, new Ctor(base), i, i * 2);
        }
        xd = convertBase(str, base, BASE);
        xe = xd.length - 1;
        // Remove trailing zeros.
        for(i = xe; xd[i] === 0; --i)xd.pop();
        if (i < 0) return new Ctor(x.s * 0);
        x.e = getBase10Exponent(xd, xe);
        x.d = xd;
        external = false;
        // At what precision to perform the division to ensure exact conversion?
        // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
        // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
        // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
        // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
        // Therefore using 4 * the number of digits of str will always be enough.
        if (isFloat) x = divide(x, divisor, len * 4);
        // Multiply by the binary exponent part if present.
        if (p) x = x.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal.pow(2, p));
        external = true;
        return x;
    };
    var sine = /*
   * sin(x) = x - x^3/3! + x^5/5! - ...
   * |x| < pi/2
   *
   */ function sine(Ctor, x) {
        var k, len = x.d.length;
        if (len < 3) return x.isZero() ? x : taylorSeries(Ctor, 2, x, x);
        // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
        // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
        // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))
        // Estimate the optimum number of times to use the argument reduction.
        k = 1.4 * Math.sqrt(len);
        k = k > 16 ? 16 : k | 0;
        x = x.times(1 / tinyPow(5, k));
        x = taylorSeries(Ctor, 2, x, x);
        // Reverse argument reduction
        var sin2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
        for(; k--;){
            sin2_x = x.times(x);
            x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
        }
        return x;
    };
    var taylorSeries = // Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
    function taylorSeries(Ctor, n, x, y, isHyperbolic) {
        var j, t, u, x2, i = 1, pr = Ctor.precision, k = Math.ceil(pr / LOG_BASE);
        external = false;
        x2 = x.times(x);
        u = new Ctor(y);
        for(;;){
            t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
            u = isHyperbolic ? y.plus(t) : y.minus(t);
            y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
            t = u.plus(y);
            if (t.d[k] !== void 0) {
                for(j = k; t.d[j] === u.d[j] && j--;);
                if (j == -1) break;
            }
            j = u;
            u = y;
            y = t;
            t = j;
            i++;
        }
        external = true;
        t.d.length = k + 1;
        return t;
    };
    var tinyPow = // Exponent e must be positive and non-zero.
    function tinyPow(b, e) {
        var n = b;
        while(--e)n *= b;
        return n;
    };
    var toLessThanHalfPi = // Return the absolute value of `x` reduced to less than or equal to half pi.
    function toLessThanHalfPi(Ctor, x) {
        var t, isNeg = x.s < 0, pi = getPi(Ctor, Ctor.precision, 1), halfPi = pi.times(0.5);
        x = x.abs();
        if (x.lte(halfPi)) {
            quadrant = isNeg ? 4 : 1;
            return x;
        }
        t = x.divToInt(pi);
        if (t.isZero()) quadrant = isNeg ? 3 : 2;
        else {
            x = x.minus(t.times(pi));
            // 0 <= x < pi
            if (x.lte(halfPi)) {
                quadrant = isOdd(t) ? isNeg ? 2 : 3 : isNeg ? 4 : 1;
                return x;
            }
            quadrant = isOdd(t) ? isNeg ? 1 : 4 : isNeg ? 3 : 2;
        }
        return x.minus(pi).abs();
    };
    var toStringBinary = /*
   * Return the value of Decimal `x` as a string in base `baseOut`.
   *
   * If the optional `sd` argument is present include a binary exponent suffix.
   */ function toStringBinary(x, baseOut, sd, rm) {
        var base, e, i, k, len, roundUp, str, xd, y, Ctor = x.constructor, isExp = sd !== void 0;
        if (isExp) {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        } else {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        }
        if (!x.isFinite()) str = nonFiniteToString(x);
        else {
            str = finiteToString(x);
            i = str.indexOf(".");
            // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
            // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
            // minBinaryExponent = floor(decimalExponent * log[2](10))
            // log[2](10) = 3.321928094887362347870319429489390175864
            if (isExp) {
                base = 2;
                if (baseOut == 16) sd = sd * 4 - 3;
                else if (baseOut == 8) sd = sd * 3 - 2;
            } else base = baseOut;
            // Convert the number as an integer then divide the result by its base raised to a power such
            // that the fraction part will be restored.
            // Non-integer.
            if (i >= 0) {
                str = str.replace(".", "");
                y = new Ctor(1);
                y.e = str.length - i;
                y.d = convertBase(finiteToString(y), 10, base);
                y.e = y.d.length;
            }
            xd = convertBase(str, 10, base);
            e = len = xd.length;
            // Remove trailing zeros.
            for(; xd[--len] == 0;)xd.pop();
            if (!xd[0]) str = isExp ? "0p+0" : "0";
            else {
                if (i < 0) e--;
                else {
                    x = new Ctor(x);
                    x.d = xd;
                    x.e = e;
                    x = divide(x, y, sd, rm, 0, base);
                    xd = x.d;
                    e = x.e;
                    roundUp = inexact;
                }
                // The rounding digit, i.e. the digit after the digit that may be rounded up.
                i = xd[sd];
                k = base / 2;
                roundUp = roundUp || xd[sd + 1] !== void 0;
                roundUp = rm < 4 ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2)) : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 || rm === (x.s < 0 ? 8 : 7));
                xd.length = sd;
                if (roundUp) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(; ++xd[--sd] > base - 1;){
                    xd[sd] = 0;
                    if (!sd) {
                        ++e;
                        xd.unshift(1);
                    }
                }
                // Determine trailing zeros.
                for(len = xd.length; !xd[len - 1]; --len);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ""; i < len; i++)str += NUMERALS.charAt(xd[i]);
                // Add binary exponent suffix?
                if (isExp) {
                    if (len > 1) {
                        if (baseOut == 16 || baseOut == 8) {
                            i = baseOut == 16 ? 4 : 3;
                            for(--len; len % i; len++)str += "0";
                            xd = convertBase(str, base, baseOut);
                            for(len = xd.length; !xd[len - 1]; --len);
                            // xd[0] will always be be 1
                            for(i = 1, str = "1."; i < len; i++)str += NUMERALS.charAt(xd[i]);
                        } else str = str.charAt(0) + "." + str.slice(1);
                    }
                    str = str + (e < 0 ? "p" : "p+") + e;
                } else if (e < 0) {
                    for(; ++e;)str = "0" + str;
                    str = "0." + str;
                } else {
                    if (++e > len) for(e -= len; e--;)str += "0";
                    else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
                }
            }
            str = (baseOut == 16 ? "0x" : baseOut == 2 ? "0b" : baseOut == 8 ? "0o" : "") + str;
        }
        return x.s < 0 ? "-" + str : str;
    };
    var truncate = // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    };
    var abs = // Decimal methods
    /*
   *  abs
   *  acos
   *  acosh
   *  add
   *  asin
   *  asinh
   *  atan
   *  atanh
   *  atan2
   *  cbrt
   *  ceil
   *  clamp
   *  clone
   *  config
   *  cos
   *  cosh
   *  div
   *  exp
   *  floor
   *  hypot
   *  ln
   *  log
   *  log2
   *  log10
   *  max
   *  min
   *  mod
   *  mul
   *  pow
   *  random
   *  round
   *  set
   *  sign
   *  sin
   *  sinh
   *  sqrt
   *  sub
   *  sum
   *  tan
   *  tanh
   *  trunc
   */ /*
   * Return a new Decimal whose value is the absolute value of `x`.
   *
   * x {number|string|Decimal}
   *
   */ function abs(x) {
        return new this(x).abs();
    };
    var acos = /*
   * Return a new Decimal whose value is the arccosine in radians of `x`.
   *
   * x {number|string|Decimal}
   *
   */ function acos(x) {
        return new this(x).acos();
    };
    var acosh = /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function acosh(x) {
        return new this(x).acosh();
    };
    var add = /*
   * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function add(x, y) {
        return new this(x).plus(y);
    };
    var asin = /*
   * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function asin(x) {
        return new this(x).asin();
    };
    var asinh = /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function asinh(x) {
        return new this(x).asinh();
    };
    var atan = /*
   * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function atan(x) {
        return new this(x).atan();
    };
    var atanh = /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function atanh(x) {
        return new this(x).atanh();
    };
    var atan2 = /*
   * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
   * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi, pi]
   *
   * y {number|string|Decimal} The y-coordinate.
   * x {number|string|Decimal} The x-coordinate.
   *
   * atan2(±0, -0)               = ±pi
   * atan2(±0, +0)               = ±0
   * atan2(±0, -x)               = ±pi for x > 0
   * atan2(±0, x)                = ±0 for x > 0
   * atan2(-y, ±0)               = -pi/2 for y > 0
   * atan2(y, ±0)                = pi/2 for y > 0
   * atan2(±y, -Infinity)        = ±pi for finite y > 0
   * atan2(±y, +Infinity)        = ±0 for finite y > 0
   * atan2(±Infinity, x)         = ±pi/2 for finite x
   * atan2(±Infinity, -Infinity) = ±3*pi/4
   * atan2(±Infinity, +Infinity) = ±pi/4
   * atan2(NaN, x) = NaN
   * atan2(y, NaN) = NaN
   *
   */ function atan2(y, x) {
        y = new this(y);
        x = new this(x);
        var r, pr = this.precision, rm = this.rounding, wpr = pr + 4;
        // Either NaN
        if (!y.s || !x.s) r = new this(NaN);
        else if (!y.d && !x.d) {
            r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
            r.s = y.s;
        // x is ±Infinity or y is ±0
        } else if (!x.d || y.isZero()) {
            r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
            r.s = y.s;
        // y is ±Infinity or x is ±0
        } else if (!y.d || x.isZero()) {
            r = getPi(this, wpr, 1).times(0.5);
            r.s = y.s;
        // Both non-zero and finite
        } else if (x.s < 0) {
            this.precision = wpr;
            this.rounding = 1;
            r = this.atan(divide(y, x, wpr, 1));
            x = getPi(this, wpr, 1);
            this.precision = pr;
            this.rounding = rm;
            r = y.s < 0 ? r.minus(x) : r.plus(x);
        } else r = this.atan(divide(y, x, wpr, 1));
        return r;
    };
    var cbrt = /*
   * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function cbrt(x) {
        return new this(x).cbrt();
    };
    var ceil = /*
   * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
   *
   * x {number|string|Decimal}
   *
   */ function ceil(x) {
        return finalise(x = new this(x), x.e + 1, 2);
    };
    var clamp = /*
   * Return a new Decimal whose value is `x` clamped to the range delineated by `min` and `max`.
   *
   * x {number|string|Decimal}
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */ function clamp(x, min, max) {
        return new this(x).clamp(min, max);
    };
    var config = /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *   maxE       {number}
   *   minE       {number}
   *   modulo     {number}
   *   crypto     {boolean|number}
   *   defaults   {true}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, useDefaults = obj.defaults === true, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -EXP_LIMIT,
            0,
            "toExpPos",
            0,
            EXP_LIMIT,
            "maxE",
            0,
            EXP_LIMIT,
            "minE",
            -EXP_LIMIT,
            0,
            "modulo",
            0,
            9
        ];
        for(i = 0; i < ps.length; i += 3){
            if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
            if ((v = obj[p]) !== void 0) {
                if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
                else throw Error(invalidArgument + p + ": " + v);
            }
        }
        if (p = "crypto", useDefaults) this[p] = DEFAULTS[p];
        if ((v = obj[p]) !== void 0) {
            if (v === true || v === false || v === 0 || v === 1) {
                if (v) {
                    if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[p] = true;
                    else throw Error(cryptoUnavailable);
                } else this[p] = false;
            } else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    };
    var cos = /*
   * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function cos(x) {
        return new this(x).cos();
    };
    var cosh = /*
   * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function cosh(x) {
        return new this(x).cosh();
    };
    var div = /*
   * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function div(x, y) {
        return new this(x).div(y);
    };
    var exp = /*
   * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The power to which to raise the base of the natural log.
   *
   */ function exp(x) {
        return new this(x).exp();
    };
    var floor = /*
   * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
   *
   * x {number|string|Decimal}
   *
   */ function floor(x) {
        return finalise(x = new this(x), x.e + 1, 3);
    };
    var hypot = /*
   * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
   *
   * arguments {number|string|Decimal}
   *
   */ function hypot() {
        var i, n, t = new this(0);
        external = false;
        for(i = 0; i < arguments.length;){
            n = new this(arguments[i++]);
            if (!n.d) {
                if (n.s) {
                    external = true;
                    return new this(1 / 0);
                }
                t = n;
            } else if (t.d) t = t.plus(n.times(n));
        }
        external = true;
        return t.sqrt();
    };
    var isDecimalInstance = /*
   * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
   * otherwise return false.
   *
   */ function isDecimalInstance(obj) {
        return obj instanceof Decimal || obj && obj.toStringTag === tag || false;
    };
    var ln = /*
   * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function ln(x) {
        return new this(x).ln();
    };
    var log = /*
   * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
   * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * log[y](x)
   *
   * x {number|string|Decimal} The argument of the logarithm.
   * y {number|string|Decimal} The base of the logarithm.
   *
   */ function log(x, y) {
        return new this(x).log(y);
    };
    var log2 = /*
   * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function log2(x) {
        return new this(x).log(2);
    };
    var log10 = /*
   * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function log10(x) {
        return new this(x).log(10);
    };
    var max = /*
   * Return a new Decimal whose value is the maximum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */ function max() {
        return maxOrMin(this, arguments, "lt");
    };
    var min = /*
   * Return a new Decimal whose value is the minimum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */ function min() {
        return maxOrMin(this, arguments, "gt");
    };
    var mod = /*
   * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function mod(x, y) {
        return new this(x).mod(y);
    };
    var mul = /*
   * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function mul(x, y) {
        return new this(x).mul(y);
    };
    var pow = /*
   * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The base.
   * y {number|string|Decimal} The exponent.
   *
   */ function pow(x, y) {
        return new this(x).pow(y);
    };
    var random = /*
   * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
   * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
   * are produced).
   *
   * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
   *
   */ function random(sd) {
        var d, e, k, n, i = 0, r = new this(1), rd = [];
        if (sd === void 0) sd = this.precision;
        else checkInt32(sd, 1, MAX_DIGITS);
        k = Math.ceil(sd / LOG_BASE);
        if (!this.crypto) for(; i < k;)rd[i++] = Math.random() * 1e7 | 0;
        else if (crypto.getRandomValues) {
            d = crypto.getRandomValues(new Uint32Array(k));
            for(; i < k;){
                n = d[i];
                // 0 <= n < 4294967296
                // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
                if (n >= 4.29e9) d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
                else // 0 <= n <= 4289999999
                // 0 <= (n % 1e7) <= 9999999
                rd[i++] = n % 1e7;
            }
        // Node.js supporting crypto.randomBytes.
        } else if (crypto.randomBytes) {
            // buffer
            d = crypto.randomBytes(k *= 4);
            for(; i < k;){
                // 0 <= n < 2147483648
                n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);
                // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
                if (n >= 2.14e9) crypto.randomBytes(4).copy(d, i);
                else {
                    // 0 <= n <= 2139999999
                    // 0 <= (n % 1e7) <= 9999999
                    rd.push(n % 1e7);
                    i += 4;
                }
            }
            i = k / 4;
        } else throw Error(cryptoUnavailable);
        k = rd[--i];
        sd %= LOG_BASE;
        // Convert trailing digits to zeros according to sd.
        if (k && sd) {
            n = mathpow(10, LOG_BASE - sd);
            rd[i] = (k / n | 0) * n;
        }
        // Remove trailing words which are zero.
        for(; rd[i] === 0; i--)rd.pop();
        // Zero?
        if (i < 0) {
            e = 0;
            rd = [
                0
            ];
        } else {
            e = -1;
            // Remove leading words which are zero and adjust exponent accordingly.
            for(; rd[0] === 0; e -= LOG_BASE)rd.shift();
            // Count the digits of the first word of rd to determine leading zeros.
            for(k = 1, n = rd[0]; n >= 10; n /= 10)k++;
            // Adjust the exponent for leading zeros of the first word of rd.
            if (k < LOG_BASE) e -= LOG_BASE - k;
        }
        r.e = e;
        r.d = rd;
        return r;
    };
    var round = /*
   * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
   *
   * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
   *
   * x {number|string|Decimal}
   *
   */ function round(x) {
        return finalise(x = new this(x), x.e + 1, this.rounding);
    };
    var sign = /*
   * Return
   *   1    if x > 0,
   *  -1    if x < 0,
   *   0    if x is 0,
   *  -0    if x is -0,
   *   NaN  otherwise
   *
   * x {number|string|Decimal}
   *
   */ function sign(x) {
        x = new this(x);
        return x.d ? x.d[0] ? x.s : 0 * x.s : x.s || NaN;
    };
    var sin = /*
   * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function sin(x) {
        return new this(x).sin();
    };
    var sinh = /*
   * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function sinh(x) {
        return new this(x).sinh();
    };
    var sqrt = /*
   * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function sqrt(x) {
        return new this(x).sqrt();
    };
    var sub = /*
   * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function sub(x, y) {
        return new this(x).sub(y);
    };
    var sum = /*
   * Return a new Decimal whose value is the sum of the arguments, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * Only the result is rounded, not the intermediate calculations.
   *
   * arguments {number|string|Decimal}
   *
   */ function sum() {
        var i = 0, args = arguments, x = new this(args[i]);
        external = false;
        for(; x.s && ++i < args.length;)x = x.plus(args[i]);
        external = true;
        return finalise(x, this.precision, this.rounding);
    };
    var tan = /*
   * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function tan(x) {
        return new this(x).tan();
    };
    var tanh = /*
   * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function tanh(x) {
        return new this(x).tanh();
    };
    var trunc = /*
   * Return a new Decimal whose value is `x` truncated to an integer.
   *
   * x {number|string|Decimal}
   *
   */ function trunc(x) {
        return finalise(x = new this(x), x.e + 1, 1);
    };
    /*!
   *  decimal.js v10.4.3
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js
   *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The maximum exponent magnitude.
    // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
    var EXP_LIMIT = 9e15, // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    MAX_DIGITS = 1e9, // Base conversion alphabet.
    NUMERALS = "0123456789abcdef", // The natural logarithm of 10 (1025 digits).
    LN10 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", // Pi (1025 digits).
    PI = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", // The initial configuration properties of the Decimal constructor.
    DEFAULTS = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed at run-time using the `Decimal.config` method.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used when rounding to `precision`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP         0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
        // FLOOR      3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN  6 The IEEE 754 remainder function.
        // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
        //
        // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
        // division (9) are commonly used for the modulus operation. The other rounding modes can also
        // be used, but they may not give useful results.
        modulo: 1,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The minimum exponent value, beneath which underflow to zero occurs.
        // JavaScript numbers: -324  (5e-324)
        minE: -EXP_LIMIT,
        // The maximum exponent value, above which overflow to Infinity occurs.
        // JavaScript numbers: 308  (1.7976931348623157e+308)
        maxE: EXP_LIMIT,
        // Whether to use cryptographically-secure random number generation, if available.
        crypto: false // true/false
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    Decimal, inexact, noConflict, quadrant, external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", precisionLimitExceeded = decimalError + "Precision limit exceeded", cryptoUnavailable = decimalError + "crypto unavailable", tag = "[object Decimal]", mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, // Decimal.prototype object
    P = {
        toStringTag: tag
    };
    // Decimal prototype methods
    /*
   *  absoluteValue             abs
   *  ceil
   *  clampedTo                 clamp
   *  comparedTo                cmp
   *  cosine                    cos
   *  cubeRoot                  cbrt
   *  decimalPlaces             dp
   *  dividedBy                 div
   *  dividedToIntegerBy        divToInt
   *  equals                    eq
   *  floor
   *  greaterThan               gt
   *  greaterThanOrEqualTo      gte
   *  hyperbolicCosine          cosh
   *  hyperbolicSine            sinh
   *  hyperbolicTangent         tanh
   *  inverseCosine             acos
   *  inverseHyperbolicCosine   acosh
   *  inverseHyperbolicSine     asinh
   *  inverseHyperbolicTangent  atanh
   *  inverseSine               asin
   *  inverseTangent            atan
   *  isFinite
   *  isInteger                 isInt
   *  isNaN
   *  isNegative                isNeg
   *  isPositive                isPos
   *  isZero
   *  lessThan                  lt
   *  lessThanOrEqualTo         lte
   *  logarithm                 log
   *  [maximum]                 [max]
   *  [minimum]                 [min]
   *  minus                     sub
   *  modulo                    mod
   *  naturalExponential        exp
   *  naturalLogarithm          ln
   *  negated                   neg
   *  plus                      add
   *  precision                 sd
   *  round
   *  sine                      sin
   *  squareRoot                sqrt
   *  tangent                   tan
   *  times                     mul
   *  toBinary
   *  toDecimalPlaces           toDP
   *  toExponential
   *  toFixed
   *  toFraction
   *  toHexadecimal             toHex
   *  toNearest
   *  toNumber
   *  toOctal
   *  toPower                   pow
   *  toPrecision
   *  toSignificantDigits       toSD
   *  toString
   *  truncated                 trunc
   *  valueOf                   toJSON
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s < 0) x.s = 1;
        return finalise(x);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of positive Infinity.
   *
   */ P.ceil = function() {
        return finalise(new this.constructor(this), this.e + 1, 2);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal clamped to the range
   * delineated by `min` and `max`.
   *
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */ P.clampedTo = P.clamp = function(min, max) {
        var k, x = this, Ctor = x.constructor;
        min = new Ctor(min);
        max = new Ctor(max);
        if (!min.s || !max.s) return new Ctor(NaN);
        if (min.gt(max)) throw Error(invalidArgument + max);
        k = x.cmp(min);
        return k < 0 ? min : x.cmp(max) > 0 ? max : new Ctor(x);
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value,
   *   NaN  if the value of either Decimal is NaN.
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this, xd = x.d, yd = (y = new x.constructor(y)).d, xs = x.s, ys = y.s;
        // Either NaN or ±Infinity?
        if (!xd || !yd) return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
        // Either zero?
        if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
        // Signs differ?
        if (xs !== ys) return xs;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;
        xdL = xd.length;
        ydL = yd.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
    };
    /*
   * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * cos(0)         = 1
   * cos(-0)        = 1
   * cos(Infinity)  = NaN
   * cos(-Infinity) = NaN
   * cos(NaN)       = NaN
   *
   */ P.cosine = P.cos = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.d) return new Ctor(NaN);
        // cos(0) = cos(-0) = 1
        if (!x.d[0]) return new Ctor(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = cosine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
    };
    /*
   *
   * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   *  cbrt(0)  =  0
   *  cbrt(-0) = -0
   *  cbrt(1)  =  1
   *  cbrt(-1) = -1
   *  cbrt(N)  =  N
   *  cbrt(-I) = -I
   *  cbrt(I)  =  I
   *
   * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
   *
   */ P.cubeRoot = P.cbrt = function() {
        var e, m, n, r, rep, s, sd, t, t3, t3plusx, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        external = false;
        // Initial estimate.
        s = x.s * mathpow(x.s * x, 1 / 3);
        // Math.cbrt underflow/overflow?
        // Pass x to Math.pow as integer, then adjust the exponent of the result.
        if (!s || Math.abs(s) == 1 / 0) {
            n = digitsToString(x.d);
            e = x.e;
            // Adjust n exponent so it is a multiple of 3 away from x exponent.
            if (s = (e - n.length + 1) % 3) n += s == 1 || s == -2 ? "0" : "00";
            s = mathpow(n, 1 / 3);
            // Rarely, e may be one less than the result exponent value.
            e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
            r.s = x.s;
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Halley's method.
        // TODO? Compare Newton's method.
        for(;;){
            t = r;
            t3 = t.times(t).times(t);
            t3plusx = t3.plus(x);
            r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
                // , i.e. approaching a rounding boundary, continue the iteration.
                if (n == "9999" || !rep && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var w, d = this.d, n = NaN;
        if (d) {
            w = d.length - 1;
            n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last word.
            w = d[w];
            if (w) for(; w % 10 == 0; w /= 10)n--;
            if (n < 0) n = 0;
        }
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedToIntegerBy = P.divToInt = function(y) {
        var x = this, Ctor = x.constructor;
        return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return this.cmp(y) === 0;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of negative Infinity.
   *
   */ P.floor = function() {
        return finalise(new this.constructor(this), this.e + 1, 3);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        var k = this.cmp(y);
        return k == 1 || k === 0;
    };
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [1, Infinity]
   *
   * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
   *
   * cosh(0)         = 1
   * cosh(-0)        = 1
   * cosh(Infinity)  = Infinity
   * cosh(-Infinity) = Infinity
   * cosh(NaN)       = NaN
   *
   *  x        time taken (ms)   result
   * 1000      9                 9.8503555700852349694e+433
   * 10000     25                4.4034091128314607936e+4342
   * 100000    171               1.4033316802130615897e+43429
   * 1000000   3817              1.5166076984010437725e+434294
   * 10000000  abandoned after 2 minute wait
   *
   * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
   *
   */ P.hyperbolicCosine = P.cosh = function() {
        var k, n, pr, rm, len, x = this, Ctor = x.constructor, one = new Ctor(1);
        if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
        if (x.isZero()) return one;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
        // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))
        // Estimate the optimum number of times to use the argument reduction.
        // TODO? Estimation reused from cosine() and may not be optimal here.
        if (len < 32) {
            k = Math.ceil(len / 3);
            n = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            n = "2.3283064365386962890625e-10";
        }
        x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);
        // Reverse argument reduction
        var cosh2_x, i = k, d8 = new Ctor(8);
        for(; i--;){
            cosh2_x = x.times(x);
            x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
        }
        return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
   *
   * sinh(0)         = 0
   * sinh(-0)        = -0
   * sinh(Infinity)  = Infinity
   * sinh(-Infinity) = -Infinity
   * sinh(NaN)       = NaN
   *
   * x        time taken (ms)
   * 10       2 ms
   * 100      5 ms
   * 1000     14 ms
   * 10000    82 ms
   * 100000   886 ms            1.4033316802130615897e+43429
   * 200000   2613 ms
   * 300000   5407 ms
   * 400000   8824 ms
   * 500000   13026 ms          8.7080643612718084129e+217146
   * 1000000  48543 ms
   *
   * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
   *
   */ P.hyperbolicSine = P.sinh = function() {
        var k, pr, rm, len, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        if (len < 3) x = taylorSeries(Ctor, 2, x, x, true);
        else {
            // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
            // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
            // 3 multiplications and 1 addition
            // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
            // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
            // 4 multiplications and 2 additions
            // Estimate the optimum number of times to use the argument reduction.
            k = 1.4 * Math.sqrt(len);
            k = k > 16 ? 16 : k | 0;
            x = x.times(1 / tinyPow(5, k));
            x = taylorSeries(Ctor, 2, x, x, true);
            // Reverse argument reduction
            var sinh2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
            for(; k--;){
                sinh2_x = x.times(x);
                x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
            }
        }
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * tanh(x) = sinh(x) / cosh(x)
   *
   * tanh(0)         = 0
   * tanh(-0)        = -0
   * tanh(Infinity)  = 1
   * tanh(-Infinity) = -1
   * tanh(NaN)       = NaN
   *
   */ P.hyperbolicTangent = P.tanh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(x.s);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 7;
        Ctor.rounding = 1;
        return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
    };
    /*
   * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
   * this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [0, pi]
   *
   * acos(x) = pi/2 - asin(x)
   *
   * acos(0)       = pi/2
   * acos(-0)      = pi/2
   * acos(1)       = 0
   * acos(-1)      = pi
   * acos(1/2)     = pi/3
   * acos(-1/2)    = 2*pi/3
   * acos(|x| > 1) = NaN
   * acos(NaN)     = NaN
   *
   */ P.inverseCosine = P.acos = function() {
        var halfPi, x = this, Ctor = x.constructor, k = x.abs().cmp(1), pr = Ctor.precision, rm = Ctor.rounding;
        if (k !== -1) return k === 0 ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0) : new Ctor(NaN);
        if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);
        // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.asin();
        halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return halfPi.minus(x);
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
   * value of this Decimal.
   *
   * Domain: [1, Infinity]
   * Range: [0, Infinity]
   *
   * acosh(x) = ln(x + sqrt(x^2 - 1))
   *
   * acosh(x < 1)     = NaN
   * acosh(NaN)       = NaN
   * acosh(Infinity)  = Infinity
   * acosh(-Infinity) = NaN
   * acosh(0)         = NaN
   * acosh(-0)        = NaN
   * acosh(1)         = 0
   * acosh(-1)        = NaN
   *
   */ P.inverseHyperbolicCosine = P.acosh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
        if (!x.isFinite()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).minus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * asinh(x) = ln(x + sqrt(x^2 + 1))
   *
   * asinh(NaN)       = NaN
   * asinh(Infinity)  = Infinity
   * asinh(-Infinity) = -Infinity
   * asinh(0)         = 0
   * asinh(-0)        = -0
   *
   */ P.inverseHyperbolicSine = P.asinh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).plus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
   * value of this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [-Infinity, Infinity]
   *
   * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
   *
   * atanh(|x| > 1)   = NaN
   * atanh(NaN)       = NaN
   * atanh(Infinity)  = NaN
   * atanh(-Infinity) = NaN
   * atanh(0)         = 0
   * atanh(-0)        = -0
   * atanh(1)         = Infinity
   * atanh(-1)        = -Infinity
   *
   */ P.inverseHyperbolicTangent = P.atanh = function() {
        var pr, rm, wpr, xsd, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        xsd = x.sd();
        if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);
        Ctor.precision = wpr = xsd - x.e;
        x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
        Ctor.precision = pr + 4;
        Ctor.rounding = 1;
        x = x.ln();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(0.5);
    };
    /*
   * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
   *
   * asin(0)       = 0
   * asin(-0)      = -0
   * asin(1/2)     = pi/6
   * asin(-1/2)    = -pi/6
   * asin(1)       = pi/2
   * asin(-1)      = -pi/2
   * asin(|x| > 1) = NaN
   * asin(NaN)     = NaN
   *
   * TODO? Compare performance of Taylor series.
   *
   */ P.inverseSine = P.asin = function() {
        var halfPi, k, pr, rm, x = this, Ctor = x.constructor;
        if (x.isZero()) return new Ctor(x);
        k = x.abs().cmp(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (k !== -1) {
            // |x| is 1
            if (k === 0) {
                halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
                halfPi.s = x.s;
                return halfPi;
            }
            // |x| > 1 or x is NaN
            return new Ctor(NaN);
        }
        // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(2);
    };
    /*
   * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
   *
   * atan(0)         = 0
   * atan(-0)        = -0
   * atan(1)         = pi/4
   * atan(-1)        = -pi/4
   * atan(Infinity)  = pi/2
   * atan(-Infinity) = -pi/2
   * atan(NaN)       = NaN
   *
   */ P.inverseTangent = P.atan = function() {
        var i, j, k, n, px, t, r, wpr, x2, x = this, Ctor = x.constructor, pr = Ctor.precision, rm = Ctor.rounding;
        if (!x.isFinite()) {
            if (!x.s) return new Ctor(NaN);
            if (pr + 4 <= PI_PRECISION) {
                r = getPi(Ctor, pr + 4, rm).times(0.5);
                r.s = x.s;
                return r;
            }
        } else if (x.isZero()) return new Ctor(x);
        else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
            r = getPi(Ctor, pr + 4, rm).times(0.25);
            r.s = x.s;
            return r;
        }
        Ctor.precision = wpr = pr + 10;
        Ctor.rounding = 1;
        // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);
        // Argument reduction
        // Ensure |x| < 0.42
        // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))
        k = Math.min(28, wpr / LOG_BASE + 2 | 0);
        for(i = k; i; --i)x = x.div(x.times(x).plus(1).sqrt().plus(1));
        external = false;
        j = Math.ceil(wpr / LOG_BASE);
        n = 1;
        x2 = x.times(x);
        r = new Ctor(x);
        px = x;
        // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
        for(; i !== -1;){
            px = px.times(x2);
            t = r.minus(px.div(n += 2));
            px = px.times(x2);
            r = t.plus(px.div(n += 2));
            if (r.d[j] !== void 0) for(i = j; r.d[i] === t.d[i] && i--;);
        }
        if (k) r = r.times(2 << k - 1);
        external = true;
        return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return true if the value of this Decimal is a finite number, otherwise return false.
   *
   */ P.isFinite = function() {
        return !!this.d;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isInt = function() {
        return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is NaN, otherwise return false.
   *
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isNeg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.isPos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0 or -0, otherwise return false.
   *
   */ P.isZero = function() {
        return !!this.d && this.d[0] === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * If no base is specified, return log[10](arg).
   *
   * log[base](arg) = ln(arg) / ln(base)
   *
   * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
   * otherwise:
   *
   * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
   * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
   * between the result and the correctly rounded result will be one ulp (unit in the last place).
   *
   * log[-b](a)       = NaN
   * log[0](a)        = NaN
   * log[1](a)        = NaN
   * log[NaN](a)      = NaN
   * log[Infinity](a) = NaN
   * log[b](0)        = -Infinity
   * log[b](-0)       = -Infinity
   * log[b](-a)       = NaN
   * log[b](1)        = 0
   * log[b](Infinity) = Infinity
   * log[b](NaN)      = NaN
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var isBase10, d, denominator, k, inf, num, sd, r, arg = this, Ctor = arg.constructor, pr = Ctor.precision, rm = Ctor.rounding, guard = 5;
        // Default base is 10.
        if (base == null) {
            base = new Ctor(10);
            isBase10 = true;
        } else {
            base = new Ctor(base);
            d = base.d;
            // Return NaN if base is negative, or non-finite, or is 0 or 1.
            if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
            isBase10 = base.eq(10);
        }
        d = arg.d;
        // Is arg negative, non-finite, 0 or 1?
        if (arg.s < 0 || !d || !d[0] || arg.eq(1)) return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
        // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
        // integer power of 10.
        if (isBase10) {
            if (d.length > 1) inf = true;
            else {
                for(k = d[0]; k % 10 === 0;)k /= 10;
                inf = k !== 1;
            }
        }
        external = false;
        sd = pr + guard;
        num = naturalLogarithm(arg, sd);
        denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
        // The result will have 5 rounding digits.
        r = divide(num, denominator, sd, 1);
        // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
        // calculate 10 further digits.
        //
        // If the result is known to have an infinite decimal expansion, repeat this until it is clear
        // that the result is above or below the boundary. Otherwise, if after calculating the 10
        // further digits, the last 14 are nines, round up and assume the result is exact.
        // Also assume the result is exact if the last 14 are zero.
        //
        // Example of a result that will be incorrectly rounded:
        // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
        // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
        // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
        // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
        // place is still 2.6.
        if (checkRoundingDigits(r.d, k = pr, rm)) do {
            sd += 10;
            num = naturalLogarithm(arg, sd);
            denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
            r = divide(num, denominator, sd, 1);
            if (!inf) {
                // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
                if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
                break;
            }
        }while (checkRoundingDigits(r.d, k += 10, rm));
        external = true;
        return finalise(r, pr, rm);
    };
    /*
   * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.max = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'lt');
  };
   */ /*
   * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.min = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'gt');
  };
   */ /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.minus = P.sub = function(y) {
        var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (x.d) y.s = -y.s;
            else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.plus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return y negated if x is zero and y is non-zero.
            if (yd[0]) y.s = -y.s;
            else if (xd[0]) y = new Ctor(x);
            else return new Ctor(rm === 3 ? -0 : 0);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        e = mathfloor(y.e / LOG_BASE);
        xe = mathfloor(x.e / LOG_BASE);
        xd = xd.slice();
        k = xe - e;
        // If base 1e7 exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of
            // zeros needing to be prepended, but this can be avoided while still ensuring correct
            // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to `xd` if shorter.
        // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * The result depends on the modulo mode.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
        if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);
        // Return x if y is ±Infinity or x is ±0.
        if (!y.d || x.d && !x.d[0]) return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
        // Prevent rounding of intermediate calculations.
        external = false;
        if (Ctor.modulo == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // result = x - q * y    where  0 <= result < abs(y)
            q = divide(x, y.abs(), 0, 3, 1);
            q.s *= y.s;
        } else q = divide(x, y, 0, Ctor.modulo, 1);
        q = q.times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.naturalExponential = P.exp = function() {
        return naturalExponential(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return naturalLogarithm(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s;
        return finalise(x);
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.plus = P.add = function(y) {
        var carry, d, e, i, k, len, pr, rm, xd, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.minus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!yd[0]) y = new Ctor(x);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        k = mathfloor(x.e / LOG_BASE);
        e = mathfloor(y.e / LOG_BASE);
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var k, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        if (x.d) {
            k = getPrecision(x.d);
            if (z && x.e + 1 > k) k = x.e + 1;
        } else k = NaN;
        return k;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.round = function() {
        var x = this, Ctor = x.constructor;
        return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
    };
    /*
   * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * sin(x) = x - x^3/3! + x^5/5! - ...
   *
   * sin(0)         = 0
   * sin(-0)        = -0
   * sin(Infinity)  = NaN
   * sin(-Infinity) = NaN
   * sin(NaN)       = NaN
   *
   */ P.sine = P.sin = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = sine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   *  sqrt(-n) =  N
   *  sqrt(N)  =  N
   *  sqrt(-I) =  N
   *  sqrt(I)  =  I
   *  sqrt(0)  =  0
   *  sqrt(-0) = -0
   *
   */ P.squareRoot = P.sqrt = function() {
        var m, n, sd, r, rep, t, x = this, d = x.d, e = x.e, s = x.s, Ctor = x.constructor;
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !d || !d[0]) return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (n == "9999" || !rep && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * tan(0)         = 0
   * tan(-0)        = -0
   * tan(Infinity)  = NaN
   * tan(-Infinity) = NaN
   * tan(NaN)       = NaN
   *
   */ P.tangent = P.tan = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 10;
        Ctor.rounding = 1;
        x = x.sin();
        x.s = 1;
        x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        y.s *= x.s;
        // If either is NaN, ±Infinity or ±0...
        if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd ? NaN : !xd || !yd ? y.s / 0 : y.s * 0);
        e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = getBase10Exponent(r, e);
        return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
    };
    /*
   * Return a string representing the value of this Decimal in base 2, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toBinary = function(sd, rm) {
        return toStringBinary(this, 2, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.toDP = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return finalise(x, dp + x.e + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), dp + 1, rm);
            str = finiteToString(x, true, dp + 1);
        }
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            y = finalise(new Ctor(x), dp + x.e + 1, rm);
            str = finiteToString(y, false, dp + y.e + 1);
        }
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return an array representing the value of this Decimal as a simple fraction with an integer
   * numerator and an integer denominator.
   *
   * The denominator will be a positive non-zero value less than or equal to the specified maximum
   * denominator. If a maximum denominator is not specified, the denominator will be the lowest
   * value necessary to represent the number exactly.
   *
   * [maxD] {number|string|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
   *
   */ P.toFraction = function(maxD) {
        var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r, x = this, xd = x.d, Ctor = x.constructor;
        if (!xd) return new Ctor(x);
        n1 = d0 = new Ctor(1);
        d1 = n0 = new Ctor(0);
        d = new Ctor(d1);
        e = d.e = getPrecision(xd) - x.e - 1;
        k = e % LOG_BASE;
        d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);
        if (maxD == null) // d is 10**e, the minimum max-denominator needed.
        maxD = e > 0 ? d : n1;
        else {
            n = new Ctor(maxD);
            if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
            maxD = n.gt(d) ? e > 0 ? d : n1 : n;
        }
        external = false;
        n = new Ctor(digitsToString(xd));
        pr = Ctor.precision;
        Ctor.precision = e = xd.length * LOG_BASE * 2;
        for(;;){
            q = divide(n, d, 0, 1, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.cmp(maxD) == 1) break;
            d0 = d1;
            d1 = d2;
            d2 = n1;
            n1 = n0.plus(q.times(d2));
            n0 = d2;
            d2 = d;
            d = n.minus(q.times(d2));
            n = d2;
        }
        d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        // Determine which fraction is closer to x, n0/d0 or n1/d1?
        r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        Ctor.precision = pr;
        external = true;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal in base 16, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toHexadecimal = P.toHex = function(sd, rm) {
        return toStringBinary(this, 16, sd, rm);
    };
    /*
   * Returns a new Decimal whose value is the nearest multiple of `y` in the direction of rounding
   * mode `rm`, or `Decimal.rounding` if `rm` is omitted, to the value of this Decimal.
   *
   * The return value will always have the same sign as this Decimal, unless either this Decimal
   * or `y` is NaN, in which case the return value will be also be NaN.
   *
   * The return value is not affected by the value of `precision`.
   *
   * y {number|string|Decimal} The magnitude to round to a multiple of.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toNearest() rounding mode not an integer: {rm}'
   * 'toNearest() rounding mode out of range: {rm}'
   *
   */ P.toNearest = function(y, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (y == null) {
            // If x is not finite, return x.
            if (!x.d) return x;
            y = new Ctor(1);
            rm = Ctor.rounding;
        } else {
            y = new Ctor(y);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            // If x is not finite, return x if y is not NaN, else NaN.
            if (!x.d) return y.s ? x : y;
            // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
            if (!y.d) {
                if (y.s) y.s = x.s;
                return y;
            }
        }
        // If y is not zero, calculate the nearest multiple of y to x.
        if (y.d[0]) {
            external = false;
            x = divide(x, y, 0, rm, 1).times(y);
            external = true;
            finalise(x);
        // If y is zero, return zero with the sign of x.
        } else {
            y.s = x.s;
            x = y;
        }
        return x;
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   * Zero keeps its sign.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a string representing the value of this Decimal in base 8, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toOctal = function(sd, rm) {
        return toStringBinary(this, 8, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
   * to `precision` significant digits using rounding mode `rounding`.
   *
   * ECMAScript compliant.
   *
   *   pow(x, NaN)                           = NaN
   *   pow(x, ±0)                            = 1

   *   pow(NaN, non-zero)                    = NaN
   *   pow(abs(x) > 1, +Infinity)            = +Infinity
   *   pow(abs(x) > 1, -Infinity)            = +0
   *   pow(abs(x) == 1, ±Infinity)           = NaN
   *   pow(abs(x) < 1, +Infinity)            = +0
   *   pow(abs(x) < 1, -Infinity)            = +Infinity
   *   pow(+Infinity, y > 0)                 = +Infinity
   *   pow(+Infinity, y < 0)                 = +0
   *   pow(-Infinity, odd integer > 0)       = -Infinity
   *   pow(-Infinity, even integer > 0)      = +Infinity
   *   pow(-Infinity, odd integer < 0)       = -0
   *   pow(-Infinity, even integer < 0)      = +0
   *   pow(+0, y > 0)                        = +0
   *   pow(+0, y < 0)                        = +Infinity
   *   pow(-0, odd integer > 0)              = -0
   *   pow(-0, even integer > 0)             = +0
   *   pow(-0, odd integer < 0)              = -Infinity
   *   pow(-0, even integer < 0)             = +Infinity
   *   pow(finite x < 0, finite non-integer) = NaN
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
   * probability of an incorrectly rounded result
   * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
   * i.e. 1 in 250,000,000,000,000
   *
   * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, rm, s, x = this, Ctor = x.constructor, yn = +(y = new Ctor(y));
        // Either ±Infinity, NaN or ±0?
        if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));
        x = new Ctor(x);
        if (x.eq(1)) return x;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (y.eq(1)) return finalise(x, pr, rm);
        // y exponent
        e = mathfloor(y.e / LOG_BASE);
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = intPow(Ctor, x, k, pr);
            return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
        }
        s = x.s;
        // if x is negative
        if (s < 0) {
            // if y is not an integer
            if (e < y.d.length - 1) return new Ctor(NaN);
            // Result is positive if x is negative and the last digit of integer y is even.
            if ((y.d[e] & 1) == 0) s = 1;
            // if x.eq(-1)
            if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
                x.s = s;
                return x;
            }
        }
        // Estimate result exponent.
        // x^y = 10^e,  where e = y * log10(x)
        // log10(x) = log10(x_significand) + x_exponent
        // log10(x_significand) = ln(x_significand) / ln(10)
        k = mathpow(+x, yn);
        e = k == 0 || !isFinite(k) ? mathfloor(yn * (Math.log("0." + digitsToString(x.d)) / Math.LN10 + x.e + 1)) : new Ctor(k + "").e;
        // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.
        // Overflow/underflow?
        if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);
        external = false;
        Ctor.rounding = x.s = 1;
        // Estimate the extra guard digits needed to ensure five correct rounding digits from
        // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
        // new Decimal(2.32456).pow('2087987436534566.46411')
        // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
        k = Math.min(12, (e + "").length);
        // r = x^y = exp(y*ln(x))
        r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);
        // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
        if (r.d) {
            // Truncate to the required precision plus five rounding digits.
            r = finalise(r, pr + 5, 1);
            // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
            // the result.
            if (checkRoundingDigits(r.d, pr, rm)) {
                e = pr + 10;
                // Truncate to the increased precision plus five rounding digits.
                r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);
                // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
                if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
            }
        }
        r.s = s;
        external = true;
        Ctor.rounding = rm;
        return finalise(r, pr, rm);
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var str, x = this, Ctor = x.constructor;
        if (sd === void 0) str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), sd, rm);
            str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
        }
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toSD() digits out of range: {sd}'
   * 'toSD() digits not an integer: {sd}'
   * 'toSD() rounding mode not an integer: {rm}'
   * 'toSD() rounding mode out of range: {rm}'
   *
   */ P.toSignificantDigits = P.toSD = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return finalise(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
   *
   */ P.truncated = P.trunc = function() {
        return finalise(new this.constructor(this), this.e + 1, 1);
    };
    /*
   * Return a string representing the value of this Decimal.
   * Unlike `toString`, negative zero will include the minus sign.
   *
   */ P.valueOf = P.toJSON = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() ? "-" + str : str;
    };
    /*
   * Perform division in the specified base.
   */ var divide = function() {
        var multiplyInteger = // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k, base) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % base | 0;
                carry = temp / base | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        };
        var compare = function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        };
        var subtract = function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        };
        return function(x, y, pr, rm, dp, base) {
            var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either NaN, Infinity or 0?
            if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN : // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
            xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
            if (base) {
                logBase = 1;
                e = x.e - y.e;
            } else {
                base = BASE;
                logBase = LOG_BASE;
                e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
            }
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            // The digit array of a Decimal from toStringBinary may have trailing zeros.
            for(i = 0; yd[i] == (xd[i] || 0); i++);
            if (yd[i] > (xd[i] || 0)) e--;
            if (pr == null) {
                sd = pr = Ctor.precision;
                rm = Ctor.rounding;
            } else if (dp) sd = pr + (x.e - y.e) + 1;
            else sd = pr;
            if (sd < 0) {
                qd.push(1);
                more = true;
            } else {
                // Convert precision in number of base 10 digits to base 1e7 digits.
                sd = sd / logBase + 2 | 0;
                i = 0;
                // divisor < 1e7
                if (yL == 1) {
                    k = 0;
                    yd = yd[0];
                    sd++;
                    // k is the carry.
                    for(; (i < xL || k) && sd--; i++){
                        t = k * base + (xd[i] || 0);
                        qd[i] = t / yd | 0;
                        k = t % yd | 0;
                    }
                    more = k || i < xL;
                // divisor >= 1e7
                } else {
                    // Normalise xd and yd so highest order digit of yd is >= base/2
                    k = base / (yd[0] + 1) | 0;
                    if (k > 1) {
                        yd = multiplyInteger(yd, k, base);
                        xd = multiplyInteger(xd, k, base);
                        yL = yd.length;
                        xL = xd.length;
                    }
                    xi = yL;
                    rem = xd.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL;)rem[remL++] = 0;
                    yz = yd.slice();
                    yz.unshift(0);
                    yd0 = yd[0];
                    if (yd[1] >= base / 2) ++yd0;
                    do {
                        k = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yd, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, k.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // k will be how many times the divisor goes into the current remainder.
                            k = rem0 / yd0 | 0;
                            //  Algorithm:
                            //  1. product = divisor * trial digit (k)
                            //  2. if product > remainder: product -= divisor, k--
                            //  3. remainder -= product
                            //  4. if product was < remainder at 2:
                            //    5. compare new remainder and divisor
                            //    6. If remainder > divisor: remainder -= divisor, k++
                            if (k > 1) {
                                if (k >= base) k = base - 1;
                                // product = divisor * trial digit.
                                prod = multiplyInteger(yd, k, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                cmp = compare(prod, rem, prodL, remL);
                                // product > remainder.
                                if (cmp == 1) {
                                    k--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yd, prodL, base);
                                }
                            } else {
                                // cmp is -1.
                                // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                                // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                                if (k == 0) cmp = k = 1;
                                prod = yd.slice();
                            }
                            prodL = prod.length;
                            if (prodL < remL) prod.unshift(0);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            // If product was < previous remainder.
                            if (cmp == -1) {
                                remL = rem.length;
                                // Compare divisor and new remainder.
                                cmp = compare(yd, rem, yL, remL);
                                // If divisor < new remainder, subtract divisor from remainder.
                                if (cmp < 1) {
                                    k++;
                                    // Subtract divisor from remainder.
                                    subtract(rem, yL < remL ? yz : yd, remL, base);
                                }
                            }
                            remL = rem.length;
                        } else if (cmp === 0) {
                            k++;
                            rem = [
                                0
                            ];
                        } // if cmp === 1, k will be 0
                        // Add the next digit, k, to the result array.
                        qd[i++] = k;
                        // Update the remainder.
                        if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                        else {
                            rem = [
                                xd[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] !== void 0) && sd--);
                    more = rem[0] !== void 0;
                }
                // Leading zero?
                if (!qd[0]) qd.shift();
            }
            // logBase is 1 when divide is being used for base conversion.
            if (logBase == 1) {
                q.e = e;
                inexact = more;
            } else {
                // To calculate q.e, first get the number of digits of qd[0].
                for(i = 1, k = qd[0]; k >= 10; k /= 10)i++;
                q.e = i + e * logBase - 1;
                finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
            }
            return q;
        };
    }();
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
   * digits.
   *
   *  ln(-n)        = NaN
   *  ln(0)         = -Infinity
   *  ln(-0)        = -Infinity
   *  ln(1)         = 0
   *  ln(Infinity)  = Infinity
   *  ln(-Infinity) = NaN
   *  ln(NaN)       = NaN
   *
   *  ln(n) (n != 1) is non-terminating.
   *
   */ function naturalLogarithm(y, sd) {
        var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // Is x negative or Infinity, NaN, 0 or 1?
        if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        Ctor.precision = wpr += guard;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        if (Math.abs(e = x.e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = x.e;
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = naturalLogarithm(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? finalise(x, pr, rm, external = true) : x;
        }
        // x1 is x reduced to a value near 1.
        x1 = x;
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
        x2 = finalise(x.times(x), wpr, 1);
        denominator = 3;
        for(;;){
            numerator = finalise(numerator.times(x2), wpr, 1);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
                // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr, 1);
                // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
                // been repeated previously) and the first 4 rounding digits 9999?
                // If so, restart the summation with a higher precision, otherwise
                // e.g. with precision: 12, rounding: 1
                // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += guard;
                        t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
                        x2 = finalise(x.times(x), wpr, 1);
                        denominator = rep = 1;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * v {number|string|Decimal} A numeric value.
     *
     */ function Decimal(v) {
            var e, i, t, x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(v);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (isDecimalInstance(v)) {
                x.s = v.s;
                if (external) {
                    if (!v.d || v.e > Decimal.maxE) {
                        // Infinity.
                        x.e = NaN;
                        x.d = null;
                    } else if (v.e < Decimal.minE) {
                        // Zero.
                        x.e = 0;
                        x.d = [
                            0
                        ];
                    } else {
                        x.e = v.e;
                        x.d = v.d.slice();
                    }
                } else {
                    x.e = v.e;
                    x.d = v.d ? v.d.slice() : v.d;
                }
                return;
            }
            t = typeof v === "undefined" ? "undefined" : (0, $1ObTH._)(v);
            if (t === "number") {
                if (v === 0) {
                    x.s = 1 / v < 0 ? -1 : 1;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                if (v < 0) {
                    v = -v;
                    x.s = -1;
                } else x.s = 1;
                // Fast path for small integers.
                if (v === ~~v && v < 1e7) {
                    for(e = 0, i = v; i >= 10; i /= 10)e++;
                    if (external) {
                        if (e > Decimal.maxE) {
                            x.e = NaN;
                            x.d = null;
                        } else if (e < Decimal.minE) {
                            x.e = 0;
                            x.d = [
                                0
                            ];
                        } else {
                            x.e = e;
                            x.d = [
                                v
                            ];
                        }
                    } else {
                        x.e = e;
                        x.d = [
                            v
                        ];
                    }
                    return;
                // Infinity, NaN.
                } else if (v * 0 !== 0) {
                    if (!v) x.s = NaN;
                    x.e = NaN;
                    x.d = null;
                    return;
                }
                return parseDecimal(x, v.toString());
            } else if (t !== "string") throw Error(invalidArgument + v);
            // Minus sign?
            if ((i = v.charCodeAt(0)) === 45) {
                v = v.slice(1);
                x.s = -1;
            } else {
                // Plus sign?
                if (i === 43) v = v.slice(1);
                x.s = 1;
            }
            return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.EUCLID = 9;
        Decimal.config = Decimal.set = config;
        Decimal.clone = clone;
        Decimal.isDecimal = isDecimalInstance;
        Decimal.abs = abs;
        Decimal.acos = acos;
        Decimal.acosh = acosh; // ES6
        Decimal.add = add;
        Decimal.asin = asin;
        Decimal.asinh = asinh; // ES6
        Decimal.atan = atan;
        Decimal.atanh = atanh; // ES6
        Decimal.atan2 = atan2;
        Decimal.cbrt = cbrt; // ES6
        Decimal.ceil = ceil;
        Decimal.clamp = clamp;
        Decimal.cos = cos;
        Decimal.cosh = cosh; // ES6
        Decimal.div = div;
        Decimal.exp = exp;
        Decimal.floor = floor;
        Decimal.hypot = hypot; // ES6
        Decimal.ln = ln;
        Decimal.log = log;
        Decimal.log10 = log10; // ES6
        Decimal.log2 = log2; // ES6
        Decimal.max = max;
        Decimal.min = min;
        Decimal.mod = mod;
        Decimal.mul = mul;
        Decimal.pow = pow;
        Decimal.random = random;
        Decimal.round = round;
        Decimal.sign = sign; // ES6
        Decimal.sin = sin;
        Decimal.sinh = sinh; // ES6
        Decimal.sqrt = sqrt;
        Decimal.sub = sub;
        Decimal.sum = sum;
        Decimal.tan = tan;
        Decimal.tanh = tanh; // ES6
        Decimal.trunc = trunc; // ES6
        if (obj === void 0) obj = {};
        if (obj) {
            if (obj.defaults !== true) {
                ps = [
                    "precision",
                    "rounding",
                    "toExpNeg",
                    "toExpPos",
                    "maxE",
                    "minE",
                    "modulo",
                    "crypto"
                ];
                for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
            }
        }
        Decimal.config(obj);
        return Decimal;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(DEFAULTS);
    Decimal.prototype.constructor = Decimal;
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Create the internal constants from their string values.
    LN10 = new Decimal(LN10);
    PI = new Decimal(PI);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, module.exports) {
        if (typeof Symbol == "function" && (0, $1ObTH._)(Symbol.iterator) == "symbol") {
            P[Symbol["for"]("nodejs.util.inspect.custom")] = P.toString;
            P[Symbol.toStringTag] = "Decimal";
        }
        module.exports = Decimal;
    // Browser.
    } else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : window;
        noConflict = globalScope.Decimal;
        Decimal.noConflict = function() {
            globalScope.Decimal = noConflict;
            return Decimal;
        };
        globalScope.Decimal = Decimal;
    }
})(undefined);

});


parcelRequire.register("dINQQ", function(module, exports) {
"use strict";
var $9fd60dd74ee2ca8c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9fd60dd74ee2ca8c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9fd60dd74ee2ca8c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9fd60dd74ee2ca8c$var$__exportStar((parcelRequire("kUPEg")), module.exports);

$9fd60dd74ee2ca8c$var$__exportStar((parcelRequire("4EWCX")), module.exports);

});
parcelRequire.register("kUPEg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("4EWCX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRequire.register("ashcf", function(module, exports) {
"use strict";
var $79c9dbc6d13fa978$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $79c9dbc6d13fa978$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $79c9dbc6d13fa978$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$79c9dbc6d13fa978$var$__exportStar((parcelRequire("ghqAp")), module.exports);

$79c9dbc6d13fa978$var$__exportStar((parcelRequire("aZFB2")), module.exports);

$79c9dbc6d13fa978$var$__exportStar((parcelRequire("bGmSz")), module.exports);

$79c9dbc6d13fa978$var$__exportStar((parcelRequire("avQnq")), module.exports);

});
parcelRequire.register("ghqAp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assert = void 0;
var $bda2db57920cfddc$var$assert = function(condition, errMsg) {
    if (!condition) {
        var errText = "Assertion failed" + (errMsg ? ": ".concat(errMsg) : "");
        throw new Error(errText);
    }
};
module.exports.assert = $bda2db57920cfddc$var$assert;

});

parcelRequire.register("aZFB2", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $dxWQo = parcelRequire("dxWQo");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.multiCallOneContract = module.exports.overrideMulticallAddress = void 0;
parcelRequire("8cUXm");
var $9EjnS = parcelRequire("9EjnS");

var $hbWVX = parcelRequire("hbWVX");
var $800fde1271256675$var$multicallAddress = undefined;
function $800fde1271256675$var$overrideMulticallAddress(address) {
    $800fde1271256675$var$multicallAddress = address;
}
module.exports.overrideMulticallAddress = $800fde1271256675$var$overrideMulticallAddress;
function $800fde1271256675$var$multiCallOneContract(contract, calls, blockNumber) {
    return $800fde1271256675$var$_multiCallOneContract.apply(this, arguments);
}
function $800fde1271256675$var$_multiCallOneContract() {
    $800fde1271256675$var$_multiCallOneContract = (0, $byzP8._)(function(contract, calls, blockNumber) {
        var functionToIndex, callContexts, multiCallContext, multicall, results, resultsInOrder, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, result, index;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    functionToIndex = calls.reduce(function(prev, current, index) {
                        return (0, $8E768._)((0, $8OnJk._)({}, prev), (0, $dxWQo._)({}, "".concat(current.function, "_").concat(index), index));
                    }, {});
                    callContexts = calls.map(function(call, index) {
                        return {
                            reference: "".concat(call.function, "_").concat(index),
                            methodName: call.function,
                            methodParameters: call.params
                        };
                    });
                    multiCallContext = {
                        reference: "this",
                        contractAddress: contract.address,
                        abi: contract.interface.fragments.map(function(fragment) {
                            return fragment.format($hbWVX.FormatTypes.full);
                        }),
                        calls: callContexts
                    };
                    multicall = new $9EjnS.Multicall({
                        tryAggregate: true,
                        ethersProvider: contract.provider,
                        multicallCustomContractAddress: $800fde1271256675$var$multicallAddress
                    });
                    return [
                        4,
                        multicall.call(multiCallContext, {
                            blockNumber: blockNumber
                        })
                    ];
                case 1:
                    results = _state.sent();
                    resultsInOrder = new Array(calls.length);
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = results.results["this"].callsReturnContext[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            result = _step.value;
                            if (!result.success) throw new Error("Failed to execute method of multicall contract: ".concat(contract.address, " method name: ").concat(result.methodName));
                            index = functionToIndex[result.reference];
                            if (result.decoded) {
                                if (result.returnValues.length > 1) throw new Error("ethereum-multicall returned more then one decoded response, which was unexpected. Fix code.");
                                resultsInOrder[index] = result.returnValues[0];
                            } else resultsInOrder[index] = contract.interface.decodeFunctionResult(result.methodName, result.returnValues);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        2,
                        resultsInOrder
                    ];
            }
        });
    });
    return $800fde1271256675$var$_multiCallOneContract.apply(this, arguments);
}
module.exports.multiCallOneContract = $800fde1271256675$var$multiCallOneContract;

});
parcelRequire.register("8cUXm", function(module, exports) {

$parcel$export(module.exports, "Multicall", function () { return (parcelRequire("9EjnS")).Multicall; });
parcelRequire("2ZCLV");

var $9EjnS = parcelRequire("9EjnS");

});
parcelRequire.register("2ZCLV", function(module, exports) {

});

parcelRequire.register("9EjnS", function(module, exports) {

$parcel$export(module.exports, "Multicall", function () { return $7066e2bed176dc45$export$74fd984ae9c44cf0; });

var $gMArf = parcelRequire("gMArf");parcelRequire("blIpd");
var $3A3Dv = parcelRequire("3A3Dv");

var $hbWVX = parcelRequire("hbWVX");
parcelRequire("9l9I4");
var $fstZD = parcelRequire("fstZD");
var $9S7b8 = parcelRequire("9S7b8");

var $eEduL = parcelRequire("eEduL");
var $7066e2bed176dc45$var$__assign = undefined && undefined.__assign || function() {
    $7066e2bed176dc45$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7066e2bed176dc45$var$__assign.apply(this, arguments);
};
var $7066e2bed176dc45$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7066e2bed176dc45$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};
var $7066e2bed176dc45$export$74fd984ae9c44cf0 = /** @class */ function() {
    var Multicall = function Multicall(_options) {
        this._options = _options;
        if (this._options.web3Instance) {
            this._executionType = (0, $fstZD.ExecutionType).web3;
            return;
        }
        if (this._options.ethersProvider) {
            this._executionType = (0, $fstZD.ExecutionType).ethers;
            return;
        }
        if (this._options.nodeUrl) {
            this._executionType = (0, $fstZD.ExecutionType).customHttp;
            return;
        }
        throw new Error(// tslint:disable-next-line: max-line-length
        "Your options passed in our incorrect they need to match either `MulticallOptionsEthers`, `MulticallOptionsWeb3` or `MulticallOptionsCustomJsonRpcProvider` interfaces");
    };
    /**
     * Call all the contract calls in 1
     * @param calls The calls
     */ Multicall.prototype.call = function(contractCallContexts, contractCallOptions) {
        if (contractCallOptions === void 0) contractCallOptions = {};
        return $7066e2bed176dc45$var$__awaiter(this, void 0, void 0, function() {
            var aggregateResponse, returnObject, response, contractCallsResults, originalContractCallContext, returnObjectResult, method, methodContext, originalContractCallMethodContext, outputTypes, decodedReturnValues;
            return $7066e2bed176dc45$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!Array.isArray(contractCallContexts)) contractCallContexts = [
                            contractCallContexts
                        ];
                        return [
                            4 /*yield*/ ,
                            this.execute(this.buildAggregateCallContext(contractCallContexts), contractCallOptions)
                        ];
                    case 1:
                        aggregateResponse = _a.sent();
                        returnObject = {
                            results: {},
                            blockNumber: aggregateResponse.blockNumber
                        };
                        for(response = 0; response < aggregateResponse.results.length; response++){
                            contractCallsResults = aggregateResponse.results[response];
                            originalContractCallContext = contractCallContexts[contractCallsResults.contractContextIndex];
                            returnObjectResult = {
                                originalContractCallContext: (0, $eEduL.Utils).deepClone(originalContractCallContext),
                                callsReturnContext: []
                            };
                            for(method = 0; method < contractCallsResults.methodResults.length; method++){
                                methodContext = contractCallsResults.methodResults[method];
                                originalContractCallMethodContext = originalContractCallContext.calls[methodContext.contractMethodIndex];
                                outputTypes = this.findOutputTypesFromAbi(originalContractCallContext.abi, originalContractCallMethodContext.methodName);
                                if (this._options.tryAggregate && !methodContext.result.success) {
                                    returnObjectResult.callsReturnContext.push((0, $eEduL.Utils).deepClone({
                                        returnValues: [],
                                        decoded: false,
                                        reference: originalContractCallMethodContext.reference,
                                        methodName: originalContractCallMethodContext.methodName,
                                        methodParameters: originalContractCallMethodContext.methodParameters,
                                        success: false
                                    }));
                                    continue;
                                }
                                if (outputTypes && outputTypes.length > 0) try {
                                    decodedReturnValues = (0, $hbWVX.defaultAbiCoder).decode(// tslint:disable-next-line: no-any
                                    outputTypes, this.getReturnDataFromResult(methodContext.result));
                                    returnObjectResult.callsReturnContext.push((0, $eEduL.Utils).deepClone({
                                        returnValues: this.formatReturnValues(decodedReturnValues),
                                        decoded: true,
                                        reference: originalContractCallMethodContext.reference,
                                        methodName: originalContractCallMethodContext.methodName,
                                        methodParameters: originalContractCallMethodContext.methodParameters,
                                        success: true
                                    }));
                                } catch (e) {
                                    if (!this._options.tryAggregate) throw e;
                                    returnObjectResult.callsReturnContext.push((0, $eEduL.Utils).deepClone({
                                        returnValues: [],
                                        decoded: false,
                                        reference: originalContractCallMethodContext.reference,
                                        methodName: originalContractCallMethodContext.methodName,
                                        methodParameters: originalContractCallMethodContext.methodParameters,
                                        success: false
                                    }));
                                }
                                else returnObjectResult.callsReturnContext.push((0, $eEduL.Utils).deepClone({
                                    returnValues: this.getReturnDataFromResult(methodContext.result),
                                    decoded: false,
                                    reference: originalContractCallMethodContext.reference,
                                    methodName: originalContractCallMethodContext.methodName,
                                    methodParameters: originalContractCallMethodContext.methodParameters,
                                    success: true
                                }));
                            }
                            returnObject.results[returnObjectResult.originalContractCallContext.reference] = returnObjectResult;
                        }
                        return [
                            2 /*return*/ ,
                            returnObject
                        ];
                }
            });
        });
    };
    /**
     * Get return data from result
     * @param result The result
     */ // tslint:disable-next-line: no-any
    Multicall.prototype.getReturnDataFromResult = function(result) {
        if (this._options.tryAggregate) return result.returnData;
        return result;
    };
    /**
     * Format return values so its always an array
     * @param decodedReturnValues The decoded return values
     */ // tslint:disable-next-line: no-any
    Multicall.prototype.formatReturnValues = function(decodedReturnValues) {
        var decodedReturnResults = decodedReturnValues;
        if (decodedReturnValues.length === 1) decodedReturnResults = decodedReturnValues[0];
        if (Array.isArray(decodedReturnResults)) return decodedReturnResults;
        return [
            decodedReturnResults
        ];
    };
    /**
     * Build aggregate call context
     * @param contractCallContexts The contract call contexts
     */ Multicall.prototype.buildAggregateCallContext = function(contractCallContexts) {
        var aggregateCallContext = [];
        for(var contract = 0; contract < contractCallContexts.length; contract++){
            var contractContext = contractCallContexts[contract];
            var executingInterface = new (0, $3A3Dv).utils.Interface(JSON.stringify(contractContext.abi));
            for(var method = 0; method < contractContext.calls.length; method++){
                // https://github.com/ethers-io/ethers.js/issues/211
                var methodContext = contractContext.calls[method];
                // tslint:disable-next-line: no-unused-expression
                var encodedData = executingInterface.encodeFunctionData(methodContext.methodName, methodContext.methodParameters);
                aggregateCallContext.push({
                    contractContextIndex: (0, $eEduL.Utils).deepClone(contract),
                    contractMethodIndex: (0, $eEduL.Utils).deepClone(method),
                    target: contractContext.contractAddress,
                    encodedData: encodedData
                });
            }
        }
        return aggregateCallContext;
    };
    /**
     * Find output types from abi
     * @param abi The abi
     * @param methodName The method name
     */ Multicall.prototype.findOutputTypesFromAbi = function(abi, methodName) {
        var _a;
        var contract = new (0, $3A3Dv).Contract((0, $3A3Dv).constants.AddressZero, abi);
        methodName = methodName.trim();
        if (contract.interface.functions[methodName]) return contract.interface.functions[methodName].outputs;
        for(var i = 0; i < abi.length; i++){
            if (((_a = abi[i].name) === null || _a === void 0 ? void 0 : _a.trim()) === methodName) return abi[i].outputs;
        }
        return undefined;
    };
    /**
     * Execute the multicall contract call
     * @param calls The calls
     */ Multicall.prototype.execute = function(calls, options) {
        return $7066e2bed176dc45$var$__awaiter(this, void 0, void 0, function() {
            var _a;
            return $7066e2bed176dc45$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this._executionType;
                        switch(_a){
                            case (0, $fstZD.ExecutionType).web3:
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case (0, $fstZD.ExecutionType).ethers:
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case (0, $fstZD.ExecutionType).customHttp:
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.executeWithWeb3(calls, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            this.executeWithEthersOrCustom(calls, options)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 5:
                        throw new Error(this._executionType + " is not defined");
                }
            });
        });
    };
    /**
     * Execute aggregate with web3 instance
     * @param calls The calls context
     */ Multicall.prototype.executeWithWeb3 = function(calls, options) {
        return $7066e2bed176dc45$var$__awaiter(this, void 0, void 0, function() {
            var web3, networkId, contract, callParams, contractResponse, contractResponse;
            var _a, _b;
            return $7066e2bed176dc45$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        web3 = this.getTypedOptions().web3Instance;
                        return [
                            4 /*yield*/ ,
                            web3.eth.net.getId()
                        ];
                    case 1:
                        networkId = _c.sent();
                        contract = new web3.eth.Contract(Multicall.ABI, this.getContractBasedOnNetwork(networkId));
                        callParams = [];
                        if (options.blockNumber) callParams.push(options.blockNumber);
                        if (!this._options.tryAggregate) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (_a = contract.methods.tryBlockAndAggregate(false, this.mapCallContextToMatchContractFormat(calls))).call.apply(_a, callParams)
                        ];
                    case 2:
                        contractResponse = _c.sent();
                        contractResponse.blockNumber = (0, $gMArf.BigNumber).from(contractResponse.blockNumber);
                        return [
                            2 /*return*/ ,
                            this.buildUpAggregateResponse(contractResponse, calls)
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            (_b = contract.methods.aggregate(this.mapCallContextToMatchContractFormat(calls))).call.apply(_b, callParams)
                        ];
                    case 4:
                        contractResponse = _c.sent();
                        contractResponse.blockNumber = (0, $gMArf.BigNumber).from(contractResponse.blockNumber);
                        return [
                            2 /*return*/ ,
                            this.buildUpAggregateResponse(contractResponse, calls)
                        ];
                }
            });
        });
    };
    /**
     * Execute with ethers using passed in provider context or custom one
     * @param calls The calls
     */ Multicall.prototype.executeWithEthersOrCustom = function(calls, options) {
        return $7066e2bed176dc45$var$__awaiter(this, void 0, void 0, function() {
            var ethersProvider, customProvider, network, contract, overrideOptions, contractResponse, contractResponse;
            return $7066e2bed176dc45$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ethersProvider = this.getTypedOptions().ethersProvider;
                        if (!ethersProvider) {
                            customProvider = this.getTypedOptions();
                            if (customProvider.nodeUrl) ethersProvider = new (0, $3A3Dv).providers.JsonRpcProvider(customProvider.nodeUrl);
                            else ethersProvider = (0, $3A3Dv).getDefaultProvider();
                        }
                        return [
                            4 /*yield*/ ,
                            ethersProvider.getNetwork()
                        ];
                    case 1:
                        network = _a.sent();
                        contract = new (0, $3A3Dv).Contract(this.getContractBasedOnNetwork(network.chainId), Multicall.ABI, ethersProvider);
                        overrideOptions = {};
                        if (options.blockNumber) overrideOptions = $7066e2bed176dc45$var$__assign($7066e2bed176dc45$var$__assign({}, overrideOptions), {
                            blockTag: Number(options.blockNumber)
                        });
                        if (!this._options.tryAggregate) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            contract.callStatic.tryBlockAndAggregate(false, this.mapCallContextToMatchContractFormat(calls), overrideOptions)
                        ];
                    case 2:
                        contractResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            this.buildUpAggregateResponse(contractResponse, calls)
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            contract.callStatic.aggregate(this.mapCallContextToMatchContractFormat(calls), overrideOptions)
                        ];
                    case 4:
                        contractResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            this.buildUpAggregateResponse(contractResponse, calls)
                        ];
                }
            });
        });
    };
    /**
     * Build up the aggregated response from the contract response mapping
     * metadata from the calls
     * @param contractResponse The contract response
     * @param calls The calls
     */ Multicall.prototype.buildUpAggregateResponse = function(contractResponse, calls) {
        var aggregateResponse = {
            blockNumber: contractResponse.blockNumber.toNumber(),
            results: []
        };
        var _loop_1 = function _loop_1(i) {
            var existingResponse = aggregateResponse.results.find(function(c) {
                return c.contractContextIndex === calls[i].contractContextIndex;
            });
            if (existingResponse) existingResponse.methodResults.push({
                result: contractResponse.returnData[i],
                contractMethodIndex: calls[i].contractMethodIndex
            });
            else aggregateResponse.results.push({
                methodResults: [
                    {
                        result: contractResponse.returnData[i],
                        contractMethodIndex: calls[i].contractMethodIndex
                    }
                ],
                contractContextIndex: calls[i].contractContextIndex
            });
        };
        for(var i = 0; i < contractResponse.returnData.length; i++)_loop_1(i);
        return aggregateResponse;
    };
    /**
     * Map call contract to match contract format
     * @param calls The calls context
     */ Multicall.prototype.mapCallContextToMatchContractFormat = function(calls) {
        return calls.map(function(call) {
            return {
                target: call.target,
                callData: call.encodedData
            };
        });
    };
    /**
     * Get typed options
     */ Multicall.prototype.getTypedOptions = function() {
        return this._options;
    };
    /**
     * Get the contract based on the network
     * @param tryAggregate The tryAggregate
     * @param network The network
     */ Multicall.prototype.getContractBasedOnNetwork = function(network) {
        // if they have overriden the multicall custom contract address then use that
        if (this._options.multicallCustomContractAddress) return this._options.multicallCustomContractAddress;
        switch(network){
            case (0, $9S7b8.Networks).mainnet:
            case (0, $9S7b8.Networks).ropsten:
            case (0, $9S7b8.Networks).rinkeby:
            case (0, $9S7b8.Networks).goerli:
            case (0, $9S7b8.Networks).optimism:
            case (0, $9S7b8.Networks).kovan:
            case (0, $9S7b8.Networks).matic:
            case (0, $9S7b8.Networks).kovanOptimism:
            case (0, $9S7b8.Networks).xdai:
            case (0, $9S7b8.Networks).xDaiTestnet:
            case (0, $9S7b8.Networks).goerliOptimism:
            case (0, $9S7b8.Networks).arbitrum:
            case (0, $9S7b8.Networks).rinkebyArbitrum:
            case (0, $9S7b8.Networks).goerliArbitrum:
            case (0, $9S7b8.Networks).mumbai:
            case (0, $9S7b8.Networks).sepolia:
            case (0, $9S7b8.Networks).avalancheMainnet:
            case (0, $9S7b8.Networks).avalancheFuji:
            case (0, $9S7b8.Networks).fantomTestnet:
            case (0, $9S7b8.Networks).fantom:
            case (0, $9S7b8.Networks).bsc:
            case (0, $9S7b8.Networks).bsc_testnet:
            case (0, $9S7b8.Networks).moonbeam:
            case (0, $9S7b8.Networks).moonriver:
            case (0, $9S7b8.Networks).moonbaseAlphaTestnet:
            case (0, $9S7b8.Networks).harmony:
            case (0, $9S7b8.Networks).cronos:
            case (0, $9S7b8.Networks).fuse:
            case (0, $9S7b8.Networks).songbirdCanaryNetwork:
            case (0, $9S7b8.Networks).costonTestnet:
            case (0, $9S7b8.Networks).boba:
            case (0, $9S7b8.Networks).aurora:
            case (0, $9S7b8.Networks).astar:
            case (0, $9S7b8.Networks).okc:
            case (0, $9S7b8.Networks).heco:
            case (0, $9S7b8.Networks).metis:
            case (0, $9S7b8.Networks).rsk:
            case (0, $9S7b8.Networks).rskTestnet:
            case (0, $9S7b8.Networks).evmos:
            case (0, $9S7b8.Networks).evmosTestnet:
            case (0, $9S7b8.Networks).thundercore:
            case (0, $9S7b8.Networks).thundercoreTestnet:
            case (0, $9S7b8.Networks).oasis:
            case (0, $9S7b8.Networks).celo:
            case (0, $9S7b8.Networks).godwoken:
            case (0, $9S7b8.Networks).godwokentestnet:
            case (0, $9S7b8.Networks).klatyn:
            case (0, $9S7b8.Networks).milkomeda:
            case (0, $9S7b8.Networks).kcc:
            case (0, $9S7b8.Networks).lineaTestnet:
            case (0, $9S7b8.Networks).linea:
            case (0, $9S7b8.Networks).mantle:
            case (0, $9S7b8.Networks).mantleTestnet:
            case (0, $9S7b8.Networks).base:
            case (0, $9S7b8.Networks).baseTestnet:
            case (0, $9S7b8.Networks).polygonZkEvm:
            case (0, $9S7b8.Networks).polygonZkEvmTestnet:
            case (0, $9S7b8.Networks).zora:
            case (0, $9S7b8.Networks).zoraTestnet:
                return "0xcA11bde05977b3631167028862bE2a173976CA11";
            case (0, $9S7b8.Networks).etherlite:
                return "0x21681750D7ddCB8d1240eD47338dC984f94AF2aC";
            case (0, $9S7b8.Networks).zkSyncEra:
            case (0, $9S7b8.Networks).zkSyncEraTestnet:
                return "0xF9cda624FBC7e059355ce98a31693d299FACd963";
            case (0, $9S7b8.Networks).scrollAlpha:
                return "0x2117f703867a2B7E6813c7e5Edd96bf9a8d8eC30";
            case (0, $9S7b8.Networks).shibarium:
                return "0xd1727fC8F78aBA7DD6294f6033D74c72Ccd3D3B0";
            default:
                throw new Error("Network - " + network + " doesn't have a multicall contract address defined. Please check your network or deploy your own contract on it.");
        }
    };
    // exposed as public as people can decide to use this outside multicall.call
    Multicall.ABI = [
        {
            constant: false,
            inputs: [
                {
                    components: [
                        {
                            name: "target",
                            type: "address"
                        },
                        {
                            name: "callData",
                            type: "bytes"
                        }
                    ],
                    name: "calls",
                    type: "tuple[]"
                }
            ],
            name: "aggregate",
            outputs: [
                {
                    name: "blockNumber",
                    type: "uint256"
                },
                {
                    name: "returnData",
                    type: "bytes[]"
                }
            ],
            payable: false,
            stateMutability: "nonpayable",
            type: "function"
        },
        {
            inputs: [
                {
                    internalType: "bool",
                    name: "requireSuccess",
                    type: "bool"
                },
                {
                    components: [
                        {
                            internalType: "address",
                            name: "target",
                            type: "address"
                        },
                        {
                            internalType: "bytes",
                            name: "callData",
                            type: "bytes"
                        }
                    ],
                    internalType: "struct Multicall2.Call[]",
                    name: "calls",
                    type: "tuple[]"
                }
            ],
            name: "tryBlockAndAggregate",
            outputs: [
                {
                    internalType: "uint256",
                    name: "blockNumber",
                    type: "uint256"
                },
                {
                    internalType: "bytes32",
                    name: "blockHash",
                    type: "bytes32"
                },
                {
                    components: [
                        {
                            internalType: "bool",
                            name: "success",
                            type: "bool"
                        },
                        {
                            internalType: "bytes",
                            name: "returnData",
                            type: "bytes"
                        }
                    ],
                    internalType: "struct Multicall2.Result[]",
                    name: "returnData",
                    type: "tuple[]"
                }
            ],
            stateMutability: "nonpayable",
            type: "function"
        }
    ];
    return Multicall;
}();

});
parcelRequire.register("9l9I4", function(module, exports) {

$parcel$export(module.exports, "ExecutionType", function () { return (parcelRequire("fstZD")).ExecutionType; });
$parcel$export(module.exports, "Networks", function () { return (parcelRequire("9S7b8")).Networks; });

var $fstZD = parcelRequire("fstZD");

var $9S7b8 = parcelRequire("9S7b8");

});
parcelRequire.register("fstZD", function(module, exports) {

$parcel$export(module.exports, "ExecutionType", function () { return $b410bc8f53e3a0c8$export$b38bf4523dd84ea6; });
var $b410bc8f53e3a0c8$export$b38bf4523dd84ea6;
(function(ExecutionType) {
    ExecutionType["web3"] = "web3";
    ExecutionType["ethers"] = "ethers";
    ExecutionType["customHttp"] = "custom";
})($b410bc8f53e3a0c8$export$b38bf4523dd84ea6 || ($b410bc8f53e3a0c8$export$b38bf4523dd84ea6 = {}));

});

parcelRequire.register("9S7b8", function(module, exports) {

$parcel$export(module.exports, "Networks", function () { return $72feb9bebad7c8e3$export$2e8191f482a38ccd; });
var $72feb9bebad7c8e3$export$2e8191f482a38ccd;
(function(Networks) {
    Networks[Networks["mainnet"] = 1] = "mainnet";
    Networks[Networks["ropsten"] = 3] = "ropsten";
    Networks[Networks["rinkeby"] = 4] = "rinkeby";
    Networks[Networks["goerli"] = 5] = "goerli";
    Networks[Networks["optimism"] = 10] = "optimism";
    Networks[Networks["kovan"] = 42] = "kovan";
    Networks[Networks["matic"] = 137] = "matic";
    Networks[Networks["kovanOptimism"] = 69] = "kovanOptimism";
    Networks[Networks["xdai"] = 100] = "xdai";
    Networks[Networks["xDaiTestnet"] = 10200] = "xDaiTestnet";
    Networks[Networks["goerliOptimism"] = 420] = "goerliOptimism";
    Networks[Networks["arbitrum"] = 42161] = "arbitrum";
    Networks[Networks["rinkebyArbitrum"] = 421611] = "rinkebyArbitrum";
    Networks[Networks["goerliArbitrum"] = 421613] = "goerliArbitrum";
    Networks[Networks["mumbai"] = 80001] = "mumbai";
    Networks[Networks["sepolia"] = 11155111] = "sepolia";
    Networks[Networks["avalancheMainnet"] = 43114] = "avalancheMainnet";
    Networks[Networks["avalancheFuji"] = 43113] = "avalancheFuji";
    Networks[Networks["fantomTestnet"] = 4002] = "fantomTestnet";
    Networks[Networks["fantom"] = 250] = "fantom";
    Networks[Networks["bsc"] = 56] = "bsc";
    Networks[Networks["bsc_testnet"] = 97] = "bsc_testnet";
    Networks[Networks["moonbeam"] = 1284] = "moonbeam";
    Networks[Networks["moonriver"] = 1285] = "moonriver";
    Networks[Networks["moonbaseAlphaTestnet"] = 1287] = "moonbaseAlphaTestnet";
    Networks[Networks["harmony"] = 1666600000] = "harmony";
    Networks[Networks["cronos"] = 25] = "cronos";
    Networks[Networks["fuse"] = 122] = "fuse";
    Networks[Networks["songbirdCanaryNetwork"] = 19] = "songbirdCanaryNetwork";
    Networks[Networks["costonTestnet"] = 16] = "costonTestnet";
    Networks[Networks["boba"] = 288] = "boba";
    Networks[Networks["aurora"] = 1313161554] = "aurora";
    Networks[Networks["astar"] = 592] = "astar";
    Networks[Networks["okc"] = 66] = "okc";
    Networks[Networks["heco"] = 128] = "heco";
    Networks[Networks["metis"] = 1088] = "metis";
    Networks[Networks["rsk"] = 30] = "rsk";
    Networks[Networks["rskTestnet"] = 31] = "rskTestnet";
    Networks[Networks["evmos"] = 9001] = "evmos";
    Networks[Networks["evmosTestnet"] = 9000] = "evmosTestnet";
    Networks[Networks["thundercore"] = 108] = "thundercore";
    Networks[Networks["thundercoreTestnet"] = 18] = "thundercoreTestnet";
    Networks[Networks["oasis"] = 26863] = "oasis";
    Networks[Networks["celo"] = 42220] = "celo";
    Networks[Networks["godwoken"] = 71402] = "godwoken";
    Networks[Networks["godwokentestnet"] = 71401] = "godwokentestnet";
    Networks[Networks["klatyn"] = 8217] = "klatyn";
    Networks[Networks["milkomeda"] = 2001] = "milkomeda";
    Networks[Networks["kcc"] = 321] = "kcc";
    Networks[Networks["etherlite"] = 111] = "etherlite";
    Networks[Networks["lineaTestnet"] = 59140] = "lineaTestnet";
    Networks[Networks["linea"] = 59144] = "linea";
    Networks[Networks["scrollAlpha"] = 534352] = "scrollAlpha";
    Networks[Networks["zkSyncEra"] = 324] = "zkSyncEra";
    Networks[Networks["zkSyncEraTestnet"] = 280] = "zkSyncEraTestnet";
    Networks[Networks["shibarium"] = 109] = "shibarium";
    Networks[Networks["mantle"] = 5000] = "mantle";
    Networks[Networks["mantleTestnet"] = 5001] = "mantleTestnet";
    Networks[Networks["base"] = 8453] = "base";
    Networks[Networks["baseTestnet"] = 84531] = "baseTestnet";
    Networks[Networks["polygonZkEvm"] = 1101] = "polygonZkEvm";
    Networks[Networks["polygonZkEvmTestnet"] = 1442] = "polygonZkEvmTestnet";
    Networks[Networks["zora"] = 7777777] = "zora";
    Networks[Networks["zoraTestnet"] = 999] = "zoraTestnet";
})($72feb9bebad7c8e3$export$2e8191f482a38ccd || ($72feb9bebad7c8e3$export$2e8191f482a38ccd = {}));

});


parcelRequire.register("eEduL", function(module, exports) {

$parcel$export(module.exports, "Utils", function () { return $aa9f44f7888de8eb$export$d2ca453b913dcdea; });
var $aa9f44f7888de8eb$export$d2ca453b913dcdea = /** @class */ function() {
    var Utils = function Utils() {};
    /**
     * Deep clone a object
     * @param object The object
     */ Utils.deepClone = function(object) {
        return JSON.parse(JSON.stringify(object));
    };
    return Utils;
}();

});




parcelRequire.register("bGmSz", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.memoize = void 0;
function $88155d44f513f313$var$memoize(fn, ttl) {
    var cache = {
        promise: undefined,
        lastSet: 0
    };
    return /*#__PURE__*/ (0, $byzP8._)(function() {
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (cache.promise === undefined || Date.now() - cache.lastSet > ttl) {
                        cache.lastSet = Date.now();
                        cache.promise = fn();
                    }
                    return [
                        4,
                        cache.promise
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
}
module.exports.memoize = $88155d44f513f313$var$memoize;

});

parcelRequire.register("avQnq", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $7a756d8f262a2e25$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetchWithFallbacks = void 0;

var $7a756d8f262a2e25$var$axios_1 = $7a756d8f262a2e25$var$__importDefault((parcelRequire("28feZ")));
var $7a756d8f262a2e25$var$fetchWithFallbacks = function() {
    var _ref = (0, $byzP8._)(function(args) {
        var requests, response;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    requests = args.urls.map(function(url) {
                        return $7a756d8f262a2e25$var$axios_1.default.get(url, args.axiosConfig);
                    });
                    return [
                        4,
                        Promise.any(requests)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function fetchWithFallbacks(args) {
        return _ref.apply(this, arguments);
    };
}();
module.exports.fetchWithFallbacks = $7a756d8f262a2e25$var$fetchWithFallbacks;

});
parcelRequire.register("28feZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Axios", function () { return $18d826a12788a23d$export$1c00760e9e5a4e95; });
$parcel$export(module.exports, "AxiosError", function () { return $18d826a12788a23d$export$c1fbed17c2f6a328; });
$parcel$export(module.exports, "CanceledError", function () { return $18d826a12788a23d$export$1ab0c6b20d94fa14; });
$parcel$export(module.exports, "isCancel", function () { return $18d826a12788a23d$export$3b22524397b493c6; });
$parcel$export(module.exports, "CancelToken", function () { return $18d826a12788a23d$export$fd08e3cb425f0d61; });
$parcel$export(module.exports, "VERSION", function () { return $18d826a12788a23d$export$a4ad2735b021c132; });
$parcel$export(module.exports, "all", function () { return $18d826a12788a23d$export$84bf76cd7afc7469; });
$parcel$export(module.exports, "Cancel", function () { return $18d826a12788a23d$export$848c9b7ead0df967; });
$parcel$export(module.exports, "isAxiosError", function () { return $18d826a12788a23d$export$fbafdbe06a5b5a9a; });
$parcel$export(module.exports, "spread", function () { return $18d826a12788a23d$export$3ae0fd4797ed47c8; });
$parcel$export(module.exports, "toFormData", function () { return $18d826a12788a23d$export$10ae0d317ea97f8b; });
$parcel$export(module.exports, "AxiosHeaders", function () { return $18d826a12788a23d$export$4e7d6ff0f3e6520; });
$parcel$export(module.exports, "HttpStatusCode", function () { return $18d826a12788a23d$export$a972f69c851492b3; });
$parcel$export(module.exports, "formToJSON", function () { return $18d826a12788a23d$export$86d7c59254d6a2c9; });
$parcel$export(module.exports, "getAdapter", function () { return $18d826a12788a23d$export$17ddc20a97d669e2; });
$parcel$export(module.exports, "mergeConfig", function () { return $18d826a12788a23d$export$7ec1ebcfa9d8bd6a; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("hjpZr")).default; });

var $hjpZr = parcelRequire("hjpZr");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
var $18d826a12788a23d$export$1c00760e9e5a4e95 = (0, $hjpZr.default).Axios, $18d826a12788a23d$export$c1fbed17c2f6a328 = (0, $hjpZr.default).AxiosError, $18d826a12788a23d$export$1ab0c6b20d94fa14 = (0, $hjpZr.default).CanceledError, $18d826a12788a23d$export$3b22524397b493c6 = (0, $hjpZr.default).isCancel, $18d826a12788a23d$export$fd08e3cb425f0d61 = (0, $hjpZr.default).CancelToken, $18d826a12788a23d$export$a4ad2735b021c132 = (0, $hjpZr.default).VERSION, $18d826a12788a23d$export$84bf76cd7afc7469 = (0, $hjpZr.default).all, $18d826a12788a23d$export$848c9b7ead0df967 = (0, $hjpZr.default).Cancel, $18d826a12788a23d$export$fbafdbe06a5b5a9a = (0, $hjpZr.default).isAxiosError, $18d826a12788a23d$export$3ae0fd4797ed47c8 = (0, $hjpZr.default).spread, $18d826a12788a23d$export$10ae0d317ea97f8b = (0, $hjpZr.default).toFormData, $18d826a12788a23d$export$4e7d6ff0f3e6520 = (0, $hjpZr.default).AxiosHeaders, $18d826a12788a23d$export$a972f69c851492b3 = (0, $hjpZr.default).HttpStatusCode, $18d826a12788a23d$export$86d7c59254d6a2c9 = (0, $hjpZr.default).formToJSON, $18d826a12788a23d$export$17ddc20a97d669e2 = (0, $hjpZr.default).getAdapter, $18d826a12788a23d$export$7ec1ebcfa9d8bd6a = (0, $hjpZr.default).mergeConfig;

});
parcelRequire.register("hjpZr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9a85f19e57c70f8$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $fsZzp = parcelRequire("fsZzp");

var $i7HGk = parcelRequire("i7HGk");

var $1JsgI = parcelRequire("1JsgI");

var $l9ONg = parcelRequire("l9ONg");

var $ewfix = parcelRequire("ewfix");

var $bmfYM = parcelRequire("bmfYM");

var $hku8v = parcelRequire("hku8v");

var $89Krh = parcelRequire("89Krh");

var $14YCA = parcelRequire("14YCA");

var $82Z9B = parcelRequire("82Z9B");

var $knwVc = parcelRequire("knwVc");

var $hvvj9 = parcelRequire("hvvj9");

var $6bEux = parcelRequire("6bEux");

var $d08Yt = parcelRequire("d08Yt");

var $kRQVA = parcelRequire("kRQVA");

var $dGtr4 = parcelRequire("dGtr4");
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $c9a85f19e57c70f8$var$createInstance(defaultConfig) {
    var context = new (0, $i7HGk.default)(defaultConfig);
    var instance = (0, $fsZzp.default)((0, $i7HGk.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $5RN2x.default).extend(instance, (0, $i7HGk.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $5RN2x.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $c9a85f19e57c70f8$var$createInstance((0, $1JsgI.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $c9a85f19e57c70f8$var$axios = $c9a85f19e57c70f8$var$createInstance((0, $l9ONg.default));
// Expose Axios class to allow class inheritance
$c9a85f19e57c70f8$var$axios.Axios = (0, $i7HGk.default);
// Expose Cancel & CancelToken
$c9a85f19e57c70f8$var$axios.CanceledError = (0, $bmfYM.default);
$c9a85f19e57c70f8$var$axios.CancelToken = (0, $hku8v.default);
$c9a85f19e57c70f8$var$axios.isCancel = (0, $89Krh.default);
$c9a85f19e57c70f8$var$axios.VERSION = (0, $14YCA.VERSION);
$c9a85f19e57c70f8$var$axios.toFormData = (0, $82Z9B.default);
// Expose AxiosError class
$c9a85f19e57c70f8$var$axios.AxiosError = (0, $knwVc.default);
// alias for CanceledError for backward compatibility
$c9a85f19e57c70f8$var$axios.Cancel = $c9a85f19e57c70f8$var$axios.CanceledError;
// Expose all/spread
$c9a85f19e57c70f8$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$c9a85f19e57c70f8$var$axios.spread = (0, $hvvj9.default);
// Expose isAxiosError
$c9a85f19e57c70f8$var$axios.isAxiosError = (0, $6bEux.default);
// Expose mergeConfig
$c9a85f19e57c70f8$var$axios.mergeConfig = (0, $1JsgI.default);
$c9a85f19e57c70f8$var$axios.AxiosHeaders = (0, $d08Yt.default);
$c9a85f19e57c70f8$var$axios.formToJSON = function(thing) {
    return (0, $ewfix.default)((0, $5RN2x.default).isHTMLForm(thing) ? new FormData(thing) : thing);
};
$c9a85f19e57c70f8$var$axios.getAdapter = (0, $kRQVA.default).getAdapter;
$c9a85f19e57c70f8$var$axios.HttpStatusCode = (0, $dGtr4.default);
$c9a85f19e57c70f8$var$axios.default = $c9a85f19e57c70f8$var$axios;
var // this module should only have a default export
$c9a85f19e57c70f8$export$2e2bcd8739ae039 = $c9a85f19e57c70f8$var$axios;

});
parcelRequire.register("5RN2x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4457f145f4fd6a49$export$2e2bcd8739ae039; });

var $1ObTH = parcelRequire("1ObTH");

var $fsZzp = parcelRequire("fsZzp");
"use strict";
// utils is a library of generic helper functions non-specific to axios
var $4457f145f4fd6a49$var$toString = Object.prototype.toString;
var $4457f145f4fd6a49$var$getPrototypeOf = Object.getPrototypeOf;
var $4457f145f4fd6a49$var$kindOf = function(cache) {
    return function(thing) {
        var str = $4457f145f4fd6a49$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
var $4457f145f4fd6a49$var$kindOfTest = function(type) {
    type = type.toLowerCase();
    return function(thing) {
        return $4457f145f4fd6a49$var$kindOf(thing) === type;
    };
};
var $4457f145f4fd6a49$var$typeOfTest = function(type) {
    return function(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $1ObTH._)(thing)) === type;
    };
};
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ var $4457f145f4fd6a49$var$isArray = Array.isArray;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ var $4457f145f4fd6a49$var$isUndefined = $4457f145f4fd6a49$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $4457f145f4fd6a49$var$isBuffer(val) {
    return val !== null && !$4457f145f4fd6a49$var$isUndefined(val) && val.constructor !== null && !$4457f145f4fd6a49$var$isUndefined(val.constructor) && $4457f145f4fd6a49$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $4457f145f4fd6a49$var$isArrayBuffer = $4457f145f4fd6a49$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $4457f145f4fd6a49$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $4457f145f4fd6a49$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ var $4457f145f4fd6a49$var$isString = $4457f145f4fd6a49$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ var $4457f145f4fd6a49$var$isFunction = $4457f145f4fd6a49$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ var $4457f145f4fd6a49$var$isNumber = $4457f145f4fd6a49$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ var $4457f145f4fd6a49$var$isObject = function(thing) {
    return thing !== null && typeof thing === "object";
};
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ var $4457f145f4fd6a49$var$isBoolean = function(thing) {
    return thing === true || thing === false;
};
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ var $4457f145f4fd6a49$var$isPlainObject = function(val) {
    if ($4457f145f4fd6a49$var$kindOf(val) !== "object") return false;
    var prototype = $4457f145f4fd6a49$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $4457f145f4fd6a49$var$isDate = $4457f145f4fd6a49$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $4457f145f4fd6a49$var$isFile = $4457f145f4fd6a49$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $4457f145f4fd6a49$var$isBlob = $4457f145f4fd6a49$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $4457f145f4fd6a49$var$isFileList = $4457f145f4fd6a49$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ var $4457f145f4fd6a49$var$isStream = function(val) {
    return $4457f145f4fd6a49$var$isObject(val) && $4457f145f4fd6a49$var$isFunction(val.pipe);
};
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ var $4457f145f4fd6a49$var$isFormData = function(thing) {
    var kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $4457f145f4fd6a49$var$isFunction(thing.append) && ((kind = $4457f145f4fd6a49$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $4457f145f4fd6a49$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $4457f145f4fd6a49$var$isURLSearchParams = $4457f145f4fd6a49$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ var $4457f145f4fd6a49$var$trim = function(str) {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $4457f145f4fd6a49$var$forEach(obj, fn) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_allOwnKeys = _ref.allOwnKeys, allOwnKeys = _ref_allOwnKeys === void 0 ? false : _ref_allOwnKeys;
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    var i;
    var l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($4457f145f4fd6a49$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        var keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        var len = keys.length;
        var key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $4457f145f4fd6a49$var$findKey(obj, key) {
    key = key.toLowerCase();
    var keys = Object.keys(obj);
    var i = keys.length;
    var _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
var $4457f145f4fd6a49$var$_global = function() {
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
}();
var $4457f145f4fd6a49$var$isContextDefined = function(context) {
    return !$4457f145f4fd6a49$var$isUndefined(context) && context !== $4457f145f4fd6a49$var$_global;
};
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $4457f145f4fd6a49$var$merge() {
    var caseless = ($4457f145f4fd6a49$var$isContextDefined(this) && this || {}).caseless;
    var result = {};
    var assignValue = function(val, key) {
        var targetKey = caseless && $4457f145f4fd6a49$var$findKey(result, key) || key;
        if ($4457f145f4fd6a49$var$isPlainObject(result[targetKey]) && $4457f145f4fd6a49$var$isPlainObject(val)) result[targetKey] = $4457f145f4fd6a49$var$merge(result[targetKey], val);
        else if ($4457f145f4fd6a49$var$isPlainObject(val)) result[targetKey] = $4457f145f4fd6a49$var$merge({}, val);
        else if ($4457f145f4fd6a49$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(var i = 0, l = arguments.length; i < l; i++)arguments[i] && $4457f145f4fd6a49$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ var $4457f145f4fd6a49$var$extend = function(a, b, thisArg) {
    var allOwnKeys = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}).allOwnKeys;
    $4457f145f4fd6a49$var$forEach(b, function(val, key) {
        if (thisArg && $4457f145f4fd6a49$var$isFunction(val)) a[key] = (0, $fsZzp.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ var $4457f145f4fd6a49$var$stripBOM = function(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ var $4457f145f4fd6a49$var$inherits = function(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ var $4457f145f4fd6a49$var$toFlatObject = function(sourceObj, destObj, filter, propFilter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $4457f145f4fd6a49$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ var $4457f145f4fd6a49$var$endsWith = function(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ var $4457f145f4fd6a49$var$toArray = function(thing) {
    if (!thing) return null;
    if ($4457f145f4fd6a49$var$isArray(thing)) return thing;
    var i = thing.length;
    if (!$4457f145f4fd6a49$var$isNumber(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
var $4457f145f4fd6a49$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== "undefined" && $4457f145f4fd6a49$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ var $4457f145f4fd6a49$var$forEachEntry = function(obj, fn) {
    var generator = obj && obj[Symbol.iterator];
    var iterator = generator.call(obj);
    var result;
    while((result = iterator.next()) && !result.done){
        var pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ var $4457f145f4fd6a49$var$matchAll = function(regExp, str) {
    var matches;
    var arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ var $4457f145f4fd6a49$var$isHTMLForm = $4457f145f4fd6a49$var$kindOfTest("HTMLFormElement");
var $4457f145f4fd6a49$var$toCamelCase = function(str) {
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ var $4457f145f4fd6a49$var$hasOwnProperty = function(param) {
    var hasOwnProperty = param.hasOwnProperty;
    return function(obj, prop) {
        return hasOwnProperty.call(obj, prop);
    };
}(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ var $4457f145f4fd6a49$var$isRegExp = $4457f145f4fd6a49$var$kindOfTest("RegExp");
var $4457f145f4fd6a49$var$reduceDescriptors = function(obj, reducer) {
    var descriptors = Object.getOwnPropertyDescriptors(obj);
    var reducedDescriptors = {};
    $4457f145f4fd6a49$var$forEach(descriptors, function(descriptor, name) {
        var ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ var $4457f145f4fd6a49$var$freezeMethods = function(obj) {
    $4457f145f4fd6a49$var$reduceDescriptors(obj, function(descriptor, name) {
        // skip restricted props in strict mode
        if ($4457f145f4fd6a49$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        var value = obj[name];
        if (!$4457f145f4fd6a49$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = function() {
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
var $4457f145f4fd6a49$var$toObjectSet = function(arrayOrString, delimiter) {
    var obj = {};
    var define = function(arr) {
        arr.forEach(function(value) {
            obj[value] = true;
        });
    };
    $4457f145f4fd6a49$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
var $4457f145f4fd6a49$var$noop = function() {};
var $4457f145f4fd6a49$var$toFiniteNumber = function(value, defaultValue) {
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
var $4457f145f4fd6a49$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
var $4457f145f4fd6a49$var$DIGIT = "0123456789";
var $4457f145f4fd6a49$var$ALPHABET = {
    DIGIT: $4457f145f4fd6a49$var$DIGIT,
    ALPHA: $4457f145f4fd6a49$var$ALPHA,
    ALPHA_DIGIT: $4457f145f4fd6a49$var$ALPHA + $4457f145f4fd6a49$var$ALPHA.toUpperCase() + $4457f145f4fd6a49$var$DIGIT
};
var $4457f145f4fd6a49$var$generateString = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16, alphabet = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $4457f145f4fd6a49$var$ALPHABET.ALPHA_DIGIT;
    var str = "";
    var length = alphabet.length;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $4457f145f4fd6a49$var$isSpecCompliantForm(thing) {
    return !!(thing && $4457f145f4fd6a49$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
var $4457f145f4fd6a49$var$toJSONObject = function(obj) {
    var stack = new Array(10);
    var visit = function(source, i) {
        if ($4457f145f4fd6a49$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                var target = $4457f145f4fd6a49$var$isArray(source) ? [] : {};
                $4457f145f4fd6a49$var$forEach(source, function(value, key) {
                    var reducedValue = visit(value, i + 1);
                    !$4457f145f4fd6a49$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
var $4457f145f4fd6a49$var$isAsyncFn = $4457f145f4fd6a49$var$kindOfTest("AsyncFunction");
var $4457f145f4fd6a49$var$isThenable = function(thing) {
    return thing && ($4457f145f4fd6a49$var$isObject(thing) || $4457f145f4fd6a49$var$isFunction(thing)) && $4457f145f4fd6a49$var$isFunction(thing.then) && $4457f145f4fd6a49$var$isFunction(thing.catch);
};
var $4457f145f4fd6a49$export$2e2bcd8739ae039 = {
    isArray: $4457f145f4fd6a49$var$isArray,
    isArrayBuffer: $4457f145f4fd6a49$var$isArrayBuffer,
    isBuffer: $4457f145f4fd6a49$var$isBuffer,
    isFormData: $4457f145f4fd6a49$var$isFormData,
    isArrayBufferView: $4457f145f4fd6a49$var$isArrayBufferView,
    isString: $4457f145f4fd6a49$var$isString,
    isNumber: $4457f145f4fd6a49$var$isNumber,
    isBoolean: $4457f145f4fd6a49$var$isBoolean,
    isObject: $4457f145f4fd6a49$var$isObject,
    isPlainObject: $4457f145f4fd6a49$var$isPlainObject,
    isUndefined: $4457f145f4fd6a49$var$isUndefined,
    isDate: $4457f145f4fd6a49$var$isDate,
    isFile: $4457f145f4fd6a49$var$isFile,
    isBlob: $4457f145f4fd6a49$var$isBlob,
    isRegExp: $4457f145f4fd6a49$var$isRegExp,
    isFunction: $4457f145f4fd6a49$var$isFunction,
    isStream: $4457f145f4fd6a49$var$isStream,
    isURLSearchParams: $4457f145f4fd6a49$var$isURLSearchParams,
    isTypedArray: $4457f145f4fd6a49$var$isTypedArray,
    isFileList: $4457f145f4fd6a49$var$isFileList,
    forEach: $4457f145f4fd6a49$var$forEach,
    merge: $4457f145f4fd6a49$var$merge,
    extend: $4457f145f4fd6a49$var$extend,
    trim: $4457f145f4fd6a49$var$trim,
    stripBOM: $4457f145f4fd6a49$var$stripBOM,
    inherits: $4457f145f4fd6a49$var$inherits,
    toFlatObject: $4457f145f4fd6a49$var$toFlatObject,
    kindOf: $4457f145f4fd6a49$var$kindOf,
    kindOfTest: $4457f145f4fd6a49$var$kindOfTest,
    endsWith: $4457f145f4fd6a49$var$endsWith,
    toArray: $4457f145f4fd6a49$var$toArray,
    forEachEntry: $4457f145f4fd6a49$var$forEachEntry,
    matchAll: $4457f145f4fd6a49$var$matchAll,
    isHTMLForm: $4457f145f4fd6a49$var$isHTMLForm,
    hasOwnProperty: $4457f145f4fd6a49$var$hasOwnProperty,
    hasOwnProp: $4457f145f4fd6a49$var$hasOwnProperty,
    reduceDescriptors: $4457f145f4fd6a49$var$reduceDescriptors,
    freezeMethods: $4457f145f4fd6a49$var$freezeMethods,
    toObjectSet: $4457f145f4fd6a49$var$toObjectSet,
    toCamelCase: $4457f145f4fd6a49$var$toCamelCase,
    noop: $4457f145f4fd6a49$var$noop,
    toFiniteNumber: $4457f145f4fd6a49$var$toFiniteNumber,
    findKey: $4457f145f4fd6a49$var$findKey,
    global: $4457f145f4fd6a49$var$_global,
    isContextDefined: $4457f145f4fd6a49$var$isContextDefined,
    ALPHABET: $4457f145f4fd6a49$var$ALPHABET,
    generateString: $4457f145f4fd6a49$var$generateString,
    isSpecCompliantForm: $4457f145f4fd6a49$var$isSpecCompliantForm,
    toJSONObject: $4457f145f4fd6a49$var$toJSONObject,
    isAsyncFn: $4457f145f4fd6a49$var$isAsyncFn,
    isThenable: $4457f145f4fd6a49$var$isThenable
};

});
parcelRequire.register("fsZzp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4293b0eb4c07151$export$2e2bcd8739ae039; });
"use strict";
function $b4293b0eb4c07151$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRequire.register("i7HGk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d31ac3bc8d454bec$export$2e2bcd8739ae039; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $5RN2x = parcelRequire("5RN2x");

var $1BRyf = parcelRequire("1BRyf");

var $hm5Wj = parcelRequire("hm5Wj");

var $2n9mB = parcelRequire("2n9mB");

var $1JsgI = parcelRequire("1JsgI");

var $7lViM = parcelRequire("7lViM");

var $1P3Mn = parcelRequire("1P3Mn");

var $d08Yt = parcelRequire("d08Yt");
"use strict";
var $d31ac3bc8d454bec$var$validators = (0, $1P3Mn.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ var $d31ac3bc8d454bec$var$Axios = /*#__PURE__*/ function() {
    function Axios(instanceConfig) {
        (0, $978gY._)(this, Axios);
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $hm5Wj.default)(),
            response: new (0, $hm5Wj.default)()
        };
    }
    (0, $kry2a._)(Axios, [
        {
            /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ key: "request",
            value: function request(configOrUrl, config) {
                /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
                if (typeof configOrUrl === "string") {
                    config = config || {};
                    config.url = configOrUrl;
                } else config = configOrUrl || {};
                config = (0, $1JsgI.default)(this.defaults, config);
                var transitional = config.transitional, paramsSerializer = config.paramsSerializer, headers = config.headers;
                if (transitional !== undefined) (0, $1P3Mn.default).assertOptions(transitional, {
                    silentJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
                    forcedJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
                    clarifyTimeoutError: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean)
                }, false);
                if (paramsSerializer != null) {
                    if ((0, $5RN2x.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                        serialize: paramsSerializer
                    };
                    else (0, $1P3Mn.default).assertOptions(paramsSerializer, {
                        encode: $d31ac3bc8d454bec$var$validators.function,
                        serialize: $d31ac3bc8d454bec$var$validators.function
                    }, true);
                }
                // Set config.method
                config.method = (config.method || this.defaults.method || "get").toLowerCase();
                // Flatten headers
                var contextHeaders = headers && (0, $5RN2x.default).merge(headers.common, headers[config.method]);
                headers && (0, $5RN2x.default).forEach([
                    "delete",
                    "get",
                    "head",
                    "post",
                    "put",
                    "patch",
                    "common"
                ], function(method) {
                    delete headers[method];
                });
                config.headers = (0, $d08Yt.default).concat(contextHeaders, headers);
                // filter out skipped interceptors
                var requestInterceptorChain = [];
                var synchronousRequestInterceptors = true;
                this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
                    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
                    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
                });
                var responseInterceptorChain = [];
                this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
                });
                var promise;
                var i = 0;
                var len;
                if (!synchronousRequestInterceptors) {
                    var chain = [
                        (0, $2n9mB.default).bind(this),
                        undefined
                    ];
                    chain.unshift.apply(chain, requestInterceptorChain);
                    chain.push.apply(chain, responseInterceptorChain);
                    len = chain.length;
                    promise = Promise.resolve(config);
                    while(i < len)promise = promise.then(chain[i++], chain[i++]);
                    return promise;
                }
                len = requestInterceptorChain.length;
                var newConfig = config;
                i = 0;
                while(i < len){
                    var onFulfilled = requestInterceptorChain[i++];
                    var onRejected = requestInterceptorChain[i++];
                    try {
                        newConfig = onFulfilled(newConfig);
                    } catch (error) {
                        onRejected.call(this, error);
                        break;
                    }
                }
                try {
                    promise = (0, $2n9mB.default).call(this, newConfig);
                } catch (error) {
                    return Promise.reject(error);
                }
                i = 0;
                len = responseInterceptorChain.length;
                while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
                return promise;
            }
        },
        {
            key: "getUri",
            value: function getUri(config) {
                config = (0, $1JsgI.default)(this.defaults, config);
                var fullPath = (0, $7lViM.default)(config.baseURL, config.url);
                return (0, $1BRyf.default)(fullPath, config.params, config.paramsSerializer);
            }
        }
    ]);
    return Axios;
}();
// Provide aliases for supported request methods
(0, $5RN2x.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $d31ac3bc8d454bec$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $1JsgI.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $5RN2x.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    var generateHTTPMethod = /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $1JsgI.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    };
    $d31ac3bc8d454bec$var$Axios.prototype[method] = generateHTTPMethod();
    $d31ac3bc8d454bec$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $d31ac3bc8d454bec$export$2e2bcd8739ae039 = $d31ac3bc8d454bec$var$Axios;

});
parcelRequire.register("1BRyf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12c2c95c1ed3c980$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $33LIl = parcelRequire("33LIl");
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $12c2c95c1ed3c980$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $12c2c95c1ed3c980$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var _encode = options && options.encode || $12c2c95c1ed3c980$var$encode;
    var serializeFn = options && options.serialize;
    var serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $5RN2x.default).isURLSearchParams(params) ? params.toString() : new (0, $33LIl.default)(params, options).toString(_encode);
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

});
parcelRequire.register("33LIl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23a6a9f2f50fe381$export$2e2bcd8739ae039; });

var $82Z9B = parcelRequire("82Z9B");
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $23a6a9f2f50fe381$var$encode(str) {
    var charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $23a6a9f2f50fe381$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $82Z9B.default)(params, this, options);
}
var $23a6a9f2f50fe381$var$prototype = $23a6a9f2f50fe381$var$AxiosURLSearchParams.prototype;
$23a6a9f2f50fe381$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$23a6a9f2f50fe381$var$prototype.toString = function toString(encoder) {
    var _encode = encoder ? function _encode(value) {
        return encoder.call(this, value, $23a6a9f2f50fe381$var$encode);
    } : $23a6a9f2f50fe381$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $23a6a9f2f50fe381$export$2e2bcd8739ae039 = $23a6a9f2f50fe381$var$AxiosURLSearchParams;

});
parcelRequire.register("82Z9B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dbdf283f7ef4044$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $knwVc = parcelRequire("knwVc");

var $2lBR5 = parcelRequire("2lBR5");

var $gzLuY = parcelRequire("gzLuY");
var $5dbdf283f7ef4044$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $5dbdf283f7ef4044$var$isVisitable(thing) {
    return (0, $5RN2x.default).isPlainObject(thing) || (0, $5RN2x.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $5dbdf283f7ef4044$var$removeBrackets(key) {
    return (0, $5RN2x.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $5dbdf283f7ef4044$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $5dbdf283f7ef4044$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $5dbdf283f7ef4044$var$isFlatArray(arr) {
    return (0, $5RN2x.default).isArray(arr) && !arr.some($5dbdf283f7ef4044$var$isVisitable);
}
var $5dbdf283f7ef4044$var$predicates = (0, $5RN2x.default).toFlatObject((0, $5RN2x.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $5dbdf283f7ef4044$var$toFormData(obj, formData, options) {
    var convertValue = function convertValue(value) {
        if (value === null) return "";
        if ((0, $5RN2x.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $5RN2x.default).isBlob(value)) throw new (0, $knwVc.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, $5RN2x.default).isArrayBuffer(value) || (0, $5RN2x.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $5dbdf283f7ef4044$require$Buffer.from(value);
        return value;
    };
    var defaultVisitor = /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        var arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $5RN2x.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $5RN2x.default).isArray(value) && $5dbdf283f7ef4044$var$isFlatArray(value) || ((0, $5RN2x.default).isFileList(value) || (0, $5RN2x.default).endsWith(key, "[]")) && (arr = (0, $5RN2x.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $5dbdf283f7ef4044$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $5RN2x.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $5dbdf283f7ef4044$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($5dbdf283f7ef4044$var$isVisitable(value)) return true;
        formData.append($5dbdf283f7ef4044$var$renderKey(path, key, dots), convertValue(value));
        return false;
    };
    if (!(0, $5RN2x.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $2lBR5.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $5RN2x.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $5RN2x.default).isUndefined(source[option]);
    });
    var metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    var visitor = options.visitor || defaultVisitor;
    var dots = options.dots;
    var indexes = options.indexes;
    var _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    var useBlob = _Blob && (0, $5RN2x.default).isSpecCompliantForm(formData);
    if (!(0, $5RN2x.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    var stack = [];
    var exposedHelpers = Object.assign($5dbdf283f7ef4044$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $5dbdf283f7ef4044$var$isVisitable
    });
    function build(value, path) {
        if ((0, $5RN2x.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $5RN2x.default).forEach(value, function each(el, key) {
            var result = !((0, $5RN2x.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $5RN2x.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $5RN2x.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $5dbdf283f7ef4044$export$2e2bcd8739ae039 = $5dbdf283f7ef4044$var$toFormData;

});
parcelRequire.register("knwVc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed5f7e2522a0b703$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $ed5f7e2522a0b703$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $5RN2x.default).inherits($ed5f7e2522a0b703$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $5RN2x.default).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $ed5f7e2522a0b703$var$prototype = $ed5f7e2522a0b703$var$AxiosError.prototype;
var $ed5f7e2522a0b703$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach(function(code) {
    $ed5f7e2522a0b703$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($ed5f7e2522a0b703$var$AxiosError, $ed5f7e2522a0b703$var$descriptors);
Object.defineProperty($ed5f7e2522a0b703$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$ed5f7e2522a0b703$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($ed5f7e2522a0b703$var$prototype);
    (0, $5RN2x.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, function(prop) {
        return prop !== "isAxiosError";
    });
    $ed5f7e2522a0b703$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $ed5f7e2522a0b703$export$2e2bcd8739ae039 = $ed5f7e2522a0b703$var$AxiosError;

});

parcelRequire.register("2lBR5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b5ae82d1edb0249$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $1b5ae82d1edb0249$export$2e2bcd8739ae039 = null;

});




parcelRequire.register("hm5Wj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca291930ae00924d$export$2e2bcd8739ae039; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $5RN2x = parcelRequire("5RN2x");
"use strict";
var $ca291930ae00924d$var$InterceptorManager = /*#__PURE__*/ function() {
    function InterceptorManager() {
        (0, $978gY._)(this, InterceptorManager);
        this.handlers = [];
    }
    (0, $kry2a._)(InterceptorManager, [
        {
            /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ key: "use",
            value: function use(fulfilled, rejected, options) {
                this.handlers.push({
                    fulfilled: fulfilled,
                    rejected: rejected,
                    synchronous: options ? options.synchronous : false,
                    runWhen: options ? options.runWhen : null
                });
                return this.handlers.length - 1;
            }
        },
        {
            /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ key: "eject",
            value: function eject(id) {
                if (this.handlers[id]) this.handlers[id] = null;
            }
        },
        {
            /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ key: "clear",
            value: function clear() {
                if (this.handlers) this.handlers = [];
            }
        },
        {
            /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ key: "forEach",
            value: function forEach(fn) {
                (0, $5RN2x.default).forEach(this.handlers, function forEachHandler(h) {
                    if (h !== null) fn(h);
                });
            }
        }
    ]);
    return InterceptorManager;
}();
var $ca291930ae00924d$export$2e2bcd8739ae039 = $ca291930ae00924d$var$InterceptorManager;

});

parcelRequire.register("2n9mB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ba4fe270146b4e2$export$2e2bcd8739ae039; });

var $3HPYp = parcelRequire("3HPYp");

var $89Krh = parcelRequire("89Krh");

var $l9ONg = parcelRequire("l9ONg");

var $bmfYM = parcelRequire("bmfYM");

var $d08Yt = parcelRequire("d08Yt");

var $kRQVA = parcelRequire("kRQVA");
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $1ba4fe270146b4e2$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $bmfYM.default)(null, config);
}
function $1ba4fe270146b4e2$export$2e2bcd8739ae039(config) {
    $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
    config.headers = (0, $d08Yt.default).from(config.headers);
    // Transform request data
    config.data = (0, $3HPYp.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    var adapter = (0, $kRQVA.default).getAdapter(config.adapter || (0, $l9ONg.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $3HPYp.default).call(config, config.transformResponse, response);
        response.headers = (0, $d08Yt.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $89Krh.default)(reason)) {
            $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $3HPYp.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $d08Yt.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRequire.register("3HPYp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b2db412c73efddc$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $l9ONg = parcelRequire("l9ONg");

var $d08Yt = parcelRequire("d08Yt");
"use strict";
function $2b2db412c73efddc$export$2e2bcd8739ae039(fns, response) {
    var config = this || (0, $l9ONg.default);
    var context = response || config;
    var headers = (0, $d08Yt.default).from(context.headers);
    var data = context.data;
    (0, $5RN2x.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRequire.register("l9ONg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f671d6c34fc96548$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $knwVc = parcelRequire("knwVc");

var $aqkjV = parcelRequire("aqkjV");

var $82Z9B = parcelRequire("82Z9B");

var $h1Gqs = parcelRequire("h1Gqs");

var $cDuf1 = parcelRequire("cDuf1");

var $ewfix = parcelRequire("ewfix");
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $f671d6c34fc96548$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $5RN2x.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $5RN2x.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $f671d6c34fc96548$var$defaults = {
    transitional: (0, $aqkjV.default),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            var contentType = headers.getContentType() || "";
            var hasJSONContentType = contentType.indexOf("application/json") > -1;
            var isObjectPayload = (0, $5RN2x.default).isObject(data);
            if (isObjectPayload && (0, $5RN2x.default).isHTMLForm(data)) data = new FormData(data);
            var isFormData = (0, $5RN2x.default).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $ewfix.default)(data)) : data;
            }
            if ((0, $5RN2x.default).isArrayBuffer(data) || (0, $5RN2x.default).isBuffer(data) || (0, $5RN2x.default).isStream(data) || (0, $5RN2x.default).isFile(data) || (0, $5RN2x.default).isBlob(data)) return data;
            if ((0, $5RN2x.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $5RN2x.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            var isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $h1Gqs.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $5RN2x.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    var _FormData = this.env && this.env.FormData;
                    return (0, $82Z9B.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $f671d6c34fc96548$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $f671d6c34fc96548$var$defaults.transitional;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var JSONRequested = this.responseType === "json";
            if (data && (0, $5RN2x.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                var silentJSONParsing = transitional && transitional.silentJSONParsing;
                var strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $knwVc.default).from(e, (0, $knwVc.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $cDuf1.default).classes.FormData,
        Blob: (0, $cDuf1.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $5RN2x.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], function(method) {
    $f671d6c34fc96548$var$defaults.headers[method] = {};
});
var $f671d6c34fc96548$export$2e2bcd8739ae039 = $f671d6c34fc96548$var$defaults;

});
parcelRequire.register("aqkjV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $796c18463ea25502$export$2e2bcd8739ae039; });
"use strict";
var $796c18463ea25502$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRequire.register("h1Gqs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6537084d1761b1c$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $82Z9B = parcelRequire("82Z9B");

var $cDuf1 = parcelRequire("cDuf1");
"use strict";
function $c6537084d1761b1c$export$2e2bcd8739ae039(data, options) {
    return (0, $82Z9B.default)(data, new (0, $cDuf1.default).classes.URLSearchParams(), Object.assign({
        visitor: function visitor(value, key, path, helpers) {
            if ((0, $cDuf1.default).isNode && (0, $5RN2x.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRequire.register("cDuf1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $933095d2c2007f0e$export$2e2bcd8739ae039; });

var $dMreV = parcelRequire("dMreV");

var $6BVH8 = parcelRequire("6BVH8");

var $9SPek = parcelRequire("9SPek");
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ var $933095d2c2007f0e$var$isStandardBrowserEnv = function() {
    var product;
    if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}();
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ var $933095d2c2007f0e$var$isStandardBrowserWebWorkerEnv = function() {
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
}();
var $933095d2c2007f0e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, $dMreV.default),
        FormData: (0, $6BVH8.default),
        Blob: (0, $9SPek.default)
    },
    isStandardBrowserEnv: $933095d2c2007f0e$var$isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv: $933095d2c2007f0e$var$isStandardBrowserWebWorkerEnv,
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

});
parcelRequire.register("dMreV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a084e346ccf1414e$export$2e2bcd8739ae039; });

var $33LIl = parcelRequire("33LIl");
"use strict";
var $a084e346ccf1414e$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $33LIl.default);

});

parcelRequire.register("6BVH8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d02f3c5e9d23987$export$2e2bcd8739ae039; });
"use strict";
var $4d02f3c5e9d23987$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;

});

parcelRequire.register("9SPek", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7320e56e0494b653$export$2e2bcd8739ae039; });
"use strict";
var $7320e56e0494b653$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;

});



parcelRequire.register("ewfix", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a91febb88049dece$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $a91febb88049dece$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $5RN2x.default).matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $a91febb88049dece$var$arrayToObject(arr) {
    var obj = {};
    var keys = Object.keys(arr);
    var i;
    var len = keys.length;
    var key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $a91febb88049dece$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        var name = path[index++];
        var isNumericKey = Number.isFinite(+name);
        var isLast = index >= path.length;
        name = !name && (0, $5RN2x.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $5RN2x.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $5RN2x.default).isObject(target[name])) target[name] = [];
        var result = buildPath(path, value, target[name], index);
        if (result && (0, $5RN2x.default).isArray(target[name])) target[name] = $a91febb88049dece$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $5RN2x.default).isFormData(formData) && (0, $5RN2x.default).isFunction(formData.entries)) {
        var obj = {};
        (0, $5RN2x.default).forEachEntry(formData, function(name, value) {
            buildPath($a91febb88049dece$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $a91febb88049dece$export$2e2bcd8739ae039 = $a91febb88049dece$var$formDataToJSON;

});


parcelRequire.register("d08Yt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97723c9940354b38$export$2e2bcd8739ae039; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $5RN2x = parcelRequire("5RN2x");

var $d9FXx = parcelRequire("d9FXx");
"use strict";
var $97723c9940354b38$var$$internals = Symbol("internals");
function $97723c9940354b38$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $97723c9940354b38$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $5RN2x.default).isArray(value) ? value.map($97723c9940354b38$var$normalizeValue) : String(value);
}
function $97723c9940354b38$var$parseTokens(str) {
    var tokens = Object.create(null);
    var tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    var match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
var $97723c9940354b38$var$isValidHeaderName = function(str) {
    return /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
};
function $97723c9940354b38$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $5RN2x.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $5RN2x.default).isString(value)) return;
    if ((0, $5RN2x.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $5RN2x.default).isRegExp(filter)) return filter.test(value);
}
function $97723c9940354b38$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function(w, char, str) {
        return char.toUpperCase() + str;
    });
}
function $97723c9940354b38$var$buildAccessors(obj, header) {
    var accessorName = (0, $5RN2x.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach(function(methodName) {
        Object.defineProperty(obj, methodName + accessorName, {
            value: function value(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
var $97723c9940354b38$var$AxiosHeaders = /*#__PURE__*/ function() {
    function AxiosHeaders(headers) {
        (0, $978gY._)(this, AxiosHeaders);
        headers && this.set(headers);
    }
    (0, $kry2a._)(AxiosHeaders, [
        {
            key: "set",
            value: function set(header, valueOrRewrite, rewrite) {
                var setHeader = function setHeader(_value, _header, _rewrite) {
                    var lHeader = $97723c9940354b38$var$normalizeHeader(_header);
                    if (!lHeader) throw new Error("header name must be a non-empty string");
                    var key = (0, $5RN2x.default).findKey(self, lHeader);
                    if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $97723c9940354b38$var$normalizeValue(_value);
                };
                var self = this;
                var setHeaders = function(headers, _rewrite) {
                    return (0, $5RN2x.default).forEach(headers, function(_value, _header) {
                        return setHeader(_value, _header, _rewrite);
                    });
                };
                if ((0, $5RN2x.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
                else if ((0, $5RN2x.default).isString(header) && (header = header.trim()) && !$97723c9940354b38$var$isValidHeaderName(header)) setHeaders((0, $d9FXx.default)(header), valueOrRewrite);
                else header != null && setHeader(valueOrRewrite, header, rewrite);
                return this;
            }
        },
        {
            key: "get",
            value: function get(header, parser) {
                header = $97723c9940354b38$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $5RN2x.default).findKey(this, header);
                    if (key) {
                        var value = this[key];
                        if (!parser) return value;
                        if (parser === true) return $97723c9940354b38$var$parseTokens(value);
                        if ((0, $5RN2x.default).isFunction(parser)) return parser.call(this, value, key);
                        if ((0, $5RN2x.default).isRegExp(parser)) return parser.exec(value);
                        throw new TypeError("parser must be boolean|regexp|function");
                    }
                }
            }
        },
        {
            key: "has",
            value: function has(header, matcher) {
                header = $97723c9940354b38$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $5RN2x.default).findKey(this, header);
                    return !!(key && this[key] !== undefined && (!matcher || $97723c9940354b38$var$matchHeaderValue(this, this[key], key, matcher)));
                }
                return false;
            }
        },
        {
            key: "delete",
            value: function _delete(header, matcher) {
                var deleteHeader = function deleteHeader(_header) {
                    _header = $97723c9940354b38$var$normalizeHeader(_header);
                    if (_header) {
                        var key = (0, $5RN2x.default).findKey(self, _header);
                        if (key && (!matcher || $97723c9940354b38$var$matchHeaderValue(self, self[key], key, matcher))) {
                            delete self[key];
                            deleted = true;
                        }
                    }
                };
                var self = this;
                var deleted = false;
                if ((0, $5RN2x.default).isArray(header)) header.forEach(deleteHeader);
                else deleteHeader(header);
                return deleted;
            }
        },
        {
            key: "clear",
            value: function clear(matcher) {
                var keys = Object.keys(this);
                var i = keys.length;
                var deleted = false;
                while(i--){
                    var key = keys[i];
                    if (!matcher || $97723c9940354b38$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                        delete this[key];
                        deleted = true;
                    }
                }
                return deleted;
            }
        },
        {
            key: "normalize",
            value: function normalize(format) {
                var self = this;
                var headers = {};
                (0, $5RN2x.default).forEach(this, function(value, header) {
                    var key = (0, $5RN2x.default).findKey(headers, header);
                    if (key) {
                        self[key] = $97723c9940354b38$var$normalizeValue(value);
                        delete self[header];
                        return;
                    }
                    var normalized = format ? $97723c9940354b38$var$formatHeader(header) : String(header).trim();
                    if (normalized !== header) delete self[header];
                    self[normalized] = $97723c9940354b38$var$normalizeValue(value);
                    headers[normalized] = true;
                });
                return this;
            }
        },
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, targets = new Array(_len), _key = 0; _key < _len; _key++){
                    targets[_key] = arguments[_key];
                }
                var _this_constructor;
                return (_this_constructor = this.constructor).concat.apply(_this_constructor, [
                    this
                ].concat((0, $fLnyw._)(targets)));
            }
        },
        {
            key: "toJSON",
            value: function toJSON(asStrings) {
                var obj = Object.create(null);
                (0, $5RN2x.default).forEach(this, function(value, header) {
                    value != null && value !== false && (obj[header] = asStrings && (0, $5RN2x.default).isArray(value) ? value.join(", ") : value);
                });
                return obj;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return Object.entries(this.toJSON())[Symbol.iterator]();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return Object.entries(this.toJSON()).map(function(param) {
                    var _param = (0, $8GFUW._)(param, 2), header = _param[0], value = _param[1];
                    return header + ": " + value;
                }).join("\n");
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "AxiosHeaders";
            }
        }
    ], [
        {
            key: "from",
            value: function from(thing) {
                return thing instanceof this ? thing : new this(thing);
            }
        },
        {
            key: "concat",
            value: function concat(first) {
                for(var _len = arguments.length, targets = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    targets[_key - 1] = arguments[_key];
                }
                var computed = new this(first);
                targets.forEach(function(target) {
                    return computed.set(target);
                });
                return computed;
            }
        },
        {
            key: "accessor",
            value: function accessor(header) {
                var defineAccessor = function defineAccessor(_header) {
                    var lHeader = $97723c9940354b38$var$normalizeHeader(_header);
                    if (!accessors[lHeader]) {
                        $97723c9940354b38$var$buildAccessors(prototype, _header);
                        accessors[lHeader] = true;
                    }
                };
                var internals = this[$97723c9940354b38$var$$internals] = this[$97723c9940354b38$var$$internals] = {
                    accessors: {}
                };
                var accessors = internals.accessors;
                var prototype = this.prototype;
                (0, $5RN2x.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
                return this;
            }
        }
    ]);
    return AxiosHeaders;
}();
$97723c9940354b38$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $5RN2x.default).reduceDescriptors($97723c9940354b38$var$AxiosHeaders.prototype, function(param, key) {
    var value = param.value;
    var mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: function() {
            return value;
        },
        set: function(headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $5RN2x.default).freezeMethods($97723c9940354b38$var$AxiosHeaders);
var $97723c9940354b38$export$2e2bcd8739ae039 = $97723c9940354b38$var$AxiosHeaders;

});
parcelRequire.register("8GFUW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6532c2e6670e28d1$export$fdf2a89c76341bbf; });

var $jbUp2 = parcelRequire("jbUp2");

var $6zrOq = parcelRequire("6zrOq");

var $4Tldu = parcelRequire("4Tldu");

var $imR8K = parcelRequire("imR8K");
function $6532c2e6670e28d1$export$fdf2a89c76341bbf(arr, i) {
    return (0, $jbUp2._array_with_holes)(arr) || (0, $6zrOq._iterable_to_array_limit)(arr, i) || (0, $imR8K._unsupported_iterable_to_array)(arr, i) || (0, $4Tldu._non_iterable_rest)();
}

});
parcelRequire.register("jbUp2", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $df8acbd513f0a551$export$e6256bf45c68d561; });
function $df8acbd513f0a551$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRequire.register("6zrOq", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $4c8b95e34bd7aafb$export$2fd15edff6687200; });
function $4c8b95e34bd7aafb$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRequire.register("4Tldu", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $38fcc1ab263aa6c9$export$60dbc22abd7da546; });
function $38fcc1ab263aa6c9$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRequire.register("d9FXx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $993ca9e2d6767cd4$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $993ca9e2d6767cd4$var$ignoreDuplicateOf = (0, $5RN2x.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $993ca9e2d6767cd4$export$2e2bcd8739ae039 = function(rawHeaders) {
    var parsed = {};
    var key;
    var val;
    var i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $993ca9e2d6767cd4$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

});



parcelRequire.register("89Krh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f032fd5b915e863$export$2e2bcd8739ae039; });
"use strict";
function $5f032fd5b915e863$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRequire.register("bmfYM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $844e24f044f60b67$export$2e2bcd8739ae039; });

var $knwVc = parcelRequire("knwVc");

var $5RN2x = parcelRequire("5RN2x");
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $844e24f044f60b67$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $knwVc.default).call(this, message == null ? "canceled" : message, (0, $knwVc.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $5RN2x.default).inherits($844e24f044f60b67$var$CanceledError, (0, $knwVc.default), {
    __CANCEL__: true
});
var $844e24f044f60b67$export$2e2bcd8739ae039 = $844e24f044f60b67$var$CanceledError;

});

parcelRequire.register("kRQVA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f311d0388b14bc21$export$2e2bcd8739ae039; });

var $8GFUW = parcelRequire("8GFUW");

var $5RN2x = parcelRequire("5RN2x");

var $2lBR5 = parcelRequire("2lBR5");

var $JCH7L = parcelRequire("JCH7L");

var $knwVc = parcelRequire("knwVc");
var $f311d0388b14bc21$var$knownAdapters = {
    http: (0, $2lBR5.default),
    xhr: (0, $JCH7L.default)
};
(0, $5RN2x.default).forEach($f311d0388b14bc21$var$knownAdapters, function(fn, value) {
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
var $f311d0388b14bc21$var$renderReason = function(reason) {
    return "- ".concat(reason);
};
var $f311d0388b14bc21$var$isResolvedHandle = function(adapter) {
    return (0, $5RN2x.default).isFunction(adapter) || adapter === null || adapter === false;
};
var $f311d0388b14bc21$export$2e2bcd8739ae039 = {
    getAdapter: function(adapters) {
        adapters = (0, $5RN2x.default).isArray(adapters) ? adapters : [
            adapters
        ];
        var length = adapters.length;
        var nameOrAdapter;
        var adapter;
        var rejectedReasons = {};
        for(var i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            var id = void 0;
            adapter = nameOrAdapter;
            if (!$f311d0388b14bc21$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $f311d0388b14bc21$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $knwVc.default)("Unknown adapter '".concat(id, "'"));
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            var reasons = Object.entries(rejectedReasons).map(function(param) {
                var _param = (0, $8GFUW._)(param, 2), id = _param[0], state = _param[1];
                return "adapter ".concat(id, " ") + (state === false ? "is not supported by the environment" : "is not available in the build");
            });
            var s = length ? reasons.length > 1 ? "since :\n" + reasons.map($f311d0388b14bc21$var$renderReason).join("\n") : " " + $f311d0388b14bc21$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $knwVc.default)("There is no suitable adapter to dispatch the request " + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $f311d0388b14bc21$var$knownAdapters
};

});
parcelRequire.register("JCH7L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $089238041fc30567$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $fhocg = parcelRequire("fhocg");

var $bd2wb = parcelRequire("bd2wb");

var $1BRyf = parcelRequire("1BRyf");

var $7lViM = parcelRequire("7lViM");

var $3TcEI = parcelRequire("3TcEI");

var $aqkjV = parcelRequire("aqkjV");

var $knwVc = parcelRequire("knwVc");

var $bmfYM = parcelRequire("bmfYM");

var $deXzT = parcelRequire("deXzT");

var $cDuf1 = parcelRequire("cDuf1");

var $d08Yt = parcelRequire("d08Yt");

var $5u3tc = parcelRequire("5u3tc");
"use strict";
function $089238041fc30567$var$progressEventReducer(listener, isDownloadStream) {
    var bytesNotified = 0;
    var _speedometer = (0, $5u3tc.default)(50, 250);
    return function(e) {
        var loaded = e.loaded;
        var total = e.lengthComputable ? e.total : undefined;
        var progressBytes = loaded - bytesNotified;
        var rate = _speedometer(progressBytes);
        var inRange = loaded <= total;
        bytesNotified = loaded;
        var data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
var $089238041fc30567$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $089238041fc30567$export$2e2bcd8739ae039 = $089238041fc30567$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var done = function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        };
        var onloadend = function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = (0, $d08Yt.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $fhocg.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        };
        var requestData = config.data;
        var requestHeaders = (0, $d08Yt.default).from(config.headers).normalize();
        var responseType = config.responseType;
        var onCanceled;
        var contentType;
        if ((0, $5RN2x.default).isFormData(requestData)) {
            if ((0, $cDuf1.default).isStandardBrowserEnv || (0, $cDuf1.default).isStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if (!requestHeaders.getContentType(/^\s*multipart\/form-data/)) requestHeaders.setContentType("multipart/form-data"); // mobile/desktop app frameworks
            else if ((0, $5RN2x.default).isString(contentType = requestHeaders.getContentType())) // fix semicolon duplication issue for ReactNative FormData implementation
            requestHeaders.setContentType(contentType.replace(/^\s*(multipart\/form-data);+/, "$1"));
        }
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        var fullPath = (0, $7lViM.default)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $1BRyf.default)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $knwVc.default)("Request aborted", (0, $knwVc.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $knwVc.default)("Network Error", (0, $knwVc.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || (0, $aqkjV.default);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $knwVc.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $knwVc.default).ETIMEDOUT : (0, $knwVc.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $cDuf1.default).isStandardBrowserEnv) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || (0, $3TcEI.default)(fullPath)) && config.xsrfCookieName && (0, $bd2wb.default).read(config.xsrfCookieName);
            if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $5RN2x.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $5RN2x.default).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $089238041fc30567$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $089238041fc30567$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $bmfYM.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        var protocol = (0, $deXzT.default)(fullPath);
        if (protocol && (0, $cDuf1.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $knwVc.default)("Unsupported protocol " + protocol + ":", (0, $knwVc.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRequire.register("fhocg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1fb368c37c1823a$export$2e2bcd8739ae039; });

var $knwVc = parcelRequire("knwVc");
"use strict";
function $b1fb368c37c1823a$export$2e2bcd8739ae039(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $knwVc.default)("Request failed with status code " + response.status, [
        (0, $knwVc.default).ERR_BAD_REQUEST,
        (0, $knwVc.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRequire.register("bd2wb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8292dca2fe19e2c0$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $cDuf1 = parcelRequire("cDuf1");
"use strict";
var $8292dca2fe19e2c0$export$2e2bcd8739ae039 = (0, $cDuf1.default).isStandardBrowserEnv ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ((0, $5RN2x.default).isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ((0, $5RN2x.default).isString(path)) cookie.push("path=" + path);
            if ((0, $5RN2x.default).isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRequire.register("7lViM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55a6f18683d9f888$export$2e2bcd8739ae039; });

var $j3J1d = parcelRequire("j3J1d");

var $5G723 = parcelRequire("5G723");
"use strict";
function $55a6f18683d9f888$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $j3J1d.default)(requestedURL)) return (0, $5G723.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRequire.register("j3J1d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de0137e96012432b$export$2e2bcd8739ae039; });
"use strict";
function $de0137e96012432b$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRequire.register("5G723", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4226547004fa4063$export$2e2bcd8739ae039; });
"use strict";
function $4226547004fa4063$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

});


parcelRequire.register("3TcEI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d50534f56617a3d$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $cDuf1 = parcelRequire("cDuf1");
"use strict";
var $2d50534f56617a3d$export$2e2bcd8739ae039 = (0, $cDuf1.default).isStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var resolveURL = /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    };
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = (0, $5RN2x.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRequire.register("deXzT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a3acc13c385c3d9$export$2e2bcd8739ae039; });
"use strict";
function $9a3acc13c385c3d9$export$2e2bcd8739ae039(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

});

parcelRequire.register("5u3tc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fe2722b85f27cc8$export$2e2bcd8739ae039; });
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $3fe2722b85f27cc8$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    var bytes = new Array(samplesCount);
    var timestamps = new Array(samplesCount);
    var head = 0;
    var tail = 0;
    var firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        var now = Date.now();
        var startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        var i = tail;
        var bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        var passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $3fe2722b85f27cc8$export$2e2bcd8739ae039 = $3fe2722b85f27cc8$var$speedometer;

});




parcelRequire.register("1JsgI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $142febf2fa493ec7$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $d08Yt = parcelRequire("d08Yt");
"use strict";
var $142febf2fa493ec7$var$headersToObject = function(thing) {
    return thing instanceof (0, $d08Yt.default) ? thing.toJSON() : thing;
};
function $142febf2fa493ec7$export$2e2bcd8739ae039(config1, config2) {
    var getMergedValue = function getMergedValue(target, source, caseless) {
        if ((0, $5RN2x.default).isPlainObject(target) && (0, $5RN2x.default).isPlainObject(source)) return (0, $5RN2x.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $5RN2x.default).isPlainObject(source)) return (0, $5RN2x.default).merge({}, source);
        else if ((0, $5RN2x.default).isArray(source)) return source.slice();
        return source;
    };
    var mergeDeepProperties = // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $5RN2x.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $5RN2x.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    };
    var valueFromConfig2 = // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $5RN2x.default).isUndefined(b)) return getMergedValue(undefined, b);
    };
    var defaultToConfig2 = // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $5RN2x.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $5RN2x.default).isUndefined(a)) return getMergedValue(undefined, a);
    };
    var mergeDirectKeys = // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    };
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: function(a, b) {
            return mergeDeepProperties($142febf2fa493ec7$var$headersToObject(a), $142febf2fa493ec7$var$headersToObject(b), true);
        }
    };
    (0, $5RN2x.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(config1[prop], config2[prop], prop);
        (0, $5RN2x.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});

parcelRequire.register("1P3Mn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $153d7c57f809624c$export$2e2bcd8739ae039; });

var $1ObTH = parcelRequire("1ObTH");

var $14YCA = parcelRequire("14YCA");

var $knwVc = parcelRequire("knwVc");
"use strict";
var $153d7c57f809624c$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $153d7c57f809624c$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $1ObTH._)(thing)) === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $153d7c57f809624c$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $153d7c57f809624c$var$validators.transitional = function transitional(validator, version, message) {
    var formatMessage = function formatMessage(opt, desc) {
        return "[Axios v" + (0, $14YCA.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    };
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new (0, $knwVc.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $knwVc.default).ERR_DEPRECATED);
        if (version && !$153d7c57f809624c$var$deprecatedWarnings[opt]) {
            $153d7c57f809624c$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $153d7c57f809624c$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $knwVc.default)("options must be an object", (0, $knwVc.default).ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $knwVc.default)("option " + opt + " must be " + result, (0, $knwVc.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $knwVc.default)("Unknown option " + opt, (0, $knwVc.default).ERR_BAD_OPTION);
    }
}
var $153d7c57f809624c$export$2e2bcd8739ae039 = {
    assertOptions: $153d7c57f809624c$var$assertOptions,
    validators: $153d7c57f809624c$var$validators
};

});
parcelRequire.register("14YCA", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $0c953052fb93d857$export$a4ad2735b021c132; });
var $0c953052fb93d857$export$a4ad2735b021c132 = "1.5.1";

});



parcelRequire.register("hku8v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9dbae5aa50ec7c7$export$2e2bcd8739ae039; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $bmfYM = parcelRequire("bmfYM");
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ var $c9dbae5aa50ec7c7$var$CancelToken = /*#__PURE__*/ function() {
    function CancelToken(executor) {
        (0, $978gY._)(this, CancelToken);
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        var token = this;
        // eslint-disable-next-line func-names
        this.promise.then(function(cancel) {
            if (!token._listeners) return;
            var i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = function(onfulfilled) {
            var _resolve;
            // eslint-disable-next-line func-names
            var promise = new Promise(function(resolve) {
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $bmfYM.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    (0, $kry2a._)(CancelToken, [
        {
            /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ key: "throwIfRequested",
            value: function throwIfRequested() {
                if (this.reason) throw this.reason;
            }
        },
        {
            /**
   * Subscribe to the cancel signal
   */ key: "subscribe",
            value: function subscribe(listener) {
                if (this.reason) {
                    listener(this.reason);
                    return;
                }
                if (this._listeners) this._listeners.push(listener);
                else this._listeners = [
                    listener
                ];
            }
        },
        {
            /**
   * Unsubscribe from the cancel signal
   */ key: "unsubscribe",
            value: function unsubscribe(listener) {
                if (!this._listeners) return;
                var index = this._listeners.indexOf(listener);
                if (index !== -1) this._listeners.splice(index, 1);
            }
        }
    ], [
        {
            key: "source",
            value: /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ function source() {
                var cancel;
                var token = new CancelToken(function executor(c) {
                    cancel = c;
                });
                return {
                    token: token,
                    cancel: cancel
                };
            }
        }
    ]);
    return CancelToken;
}();
var $c9dbae5aa50ec7c7$export$2e2bcd8739ae039 = $c9dbae5aa50ec7c7$var$CancelToken;

});

parcelRequire.register("hvvj9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbed9dfdab194748$export$2e2bcd8739ae039; });
"use strict";
function $cbed9dfdab194748$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRequire.register("6bEux", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48132dea419dd2c0$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");
"use strict";
function $48132dea419dd2c0$export$2e2bcd8739ae039(payload) {
    return (0, $5RN2x.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRequire.register("dGtr4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f6607e590634381$export$2e2bcd8739ae039; });

var $8GFUW = parcelRequire("8GFUW");
var $9f6607e590634381$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($9f6607e590634381$var$HttpStatusCode).forEach(function(param) {
    var _param = (0, $8GFUW._)(param, 2), key = _param[0], value = _param[1];
    $9f6607e590634381$var$HttpStatusCode[value] = key;
});
var $9f6607e590634381$export$2e2bcd8739ae039 = $9f6607e590634381$var$HttpStatusCode;

});





parcelRequire.register("1knYY", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContractParamsProvider = void 0;

var $ji93N = parcelRequire("ji93N");

var $j2rU8 = parcelRequire("j2rU8");

var $hbWVX = parcelRequire("hbWVX");

var $bRqq8 = parcelRequire("bRqq8");
var $0f7a43191a0f24a0$var$ContractParamsProvider = /*#__PURE__*/ function() {
    function ContractParamsProvider(requestParams) {
        (0, $978gY._)(this, ContractParamsProvider);
        this.requestParams = requestParams;
    }
    (0, $kry2a._)(ContractParamsProvider, [
        {
            key: "getPayloadHex",
            value: function getPayloadHex() {
                var withPrefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = withPrefix ? "0x" : "";
                                return [
                                    4,
                                    _this.requestPayload(_this.requestParams)
                                ];
                            case 1:
                                return [
                                    2,
                                    _ + _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPayloadData",
            value: function getPayloadData() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _, _1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = Array.from;
                                _1 = (0, $hbWVX.arrayify);
                                return [
                                    4,
                                    _this.getPayloadHex(true)
                                ];
                            case 1:
                                return [
                                    2,
                                    _.apply(Array, [
                                        _1.apply(void 0, [
                                            _state.sent()
                                        ])
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getHexlifiedFeedIds",
            value: function getHexlifiedFeedIds() {
                return this.getDataFeedIds().map(function(feed) {
                    return (0, $j2rU8.hexlify)((0, $ji93N.toUtf8Bytes)(feed));
                });
            }
        },
        {
            key: "getDataFeedIds",
            value: function getDataFeedIds() {
                if (!this.requestParams.dataFeeds) throw new Error("That invocation requires non-empty dataFeeds");
                return this.requestParams.dataFeeds;
            }
        },
        {
            key: "requestPayload",
            value: function requestPayload(requestParams) {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $bRqq8.requestRedstonePayload)(requestParams)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ContractParamsProvider;
}();
module.exports.ContractParamsProvider = $0f7a43191a0f24a0$var$ContractParamsProvider;

});
parcelRequire.register("ji93N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toUtf8CodePoints = module.exports.toUtf8String = module.exports._toUtf8String = module.exports._toEscapedUtf8String = module.exports.toUtf8Bytes = module.exports.Utf8ErrorFuncs = module.exports.Utf8ErrorReason = module.exports.UnicodeNormalizationForm = void 0;

var $j2rU8 = parcelRequire("j2rU8");

var $6M65e = parcelRequire("6M65e");

var $3hPAa = parcelRequire("3hPAa");
var $e0b6b9eb661749d3$var$logger = new $6M65e.Logger($3hPAa.version);
///////////////////////////////
var $e0b6b9eb661749d3$var$UnicodeNormalizationForm;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($e0b6b9eb661749d3$var$UnicodeNormalizationForm = module.exports.UnicodeNormalizationForm || (module.exports.UnicodeNormalizationForm = {}));
var $e0b6b9eb661749d3$var$Utf8ErrorReason;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($e0b6b9eb661749d3$var$Utf8ErrorReason = module.exports.Utf8ErrorReason || (module.exports.Utf8ErrorReason = {}));
function $e0b6b9eb661749d3$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $e0b6b9eb661749d3$var$logger.throwArgumentError("invalid codepoint at offset " + offset + "; " + reason, "bytes", bytes);
}
function $e0b6b9eb661749d3$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $e0b6b9eb661749d3$var$Utf8ErrorReason.BAD_PREFIX || reason === $e0b6b9eb661749d3$var$Utf8ErrorReason.UNEXPECTED_CONTINUE) {
        var i = 0;
        for(var o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $e0b6b9eb661749d3$var$Utf8ErrorReason.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $e0b6b9eb661749d3$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $e0b6b9eb661749d3$var$Utf8ErrorReason.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $e0b6b9eb661749d3$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
// Common error handing strategies
module.exports.Utf8ErrorFuncs = Object.freeze({
    error: $e0b6b9eb661749d3$var$errorFunc,
    ignore: $e0b6b9eb661749d3$var$ignoreFunc,
    replace: $e0b6b9eb661749d3$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $e0b6b9eb661749d3$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = module.exports.Utf8ErrorFuncs.error;
    bytes = (0, $j2rU8.arrayify)(bytes);
    var result = [];
    var i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        var c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        var extraLength = null;
        var overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($e0b6b9eb661749d3$var$Utf8ErrorReason.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($e0b6b9eb661749d3$var$Utf8ErrorReason.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($e0b6b9eb661749d3$var$Utf8ErrorReason.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        var res = c & (1 << 8 - extraLength - 1) - 1;
        for(var j = 0; j < extraLength; j++){
            var nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($e0b6b9eb661749d3$var$Utf8ErrorReason.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($e0b6b9eb661749d3$var$Utf8ErrorReason.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($e0b6b9eb661749d3$var$Utf8ErrorReason.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($e0b6b9eb661749d3$var$Utf8ErrorReason.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
// http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
function $e0b6b9eb661749d3$var$toUtf8Bytes(str, form) {
    if (form === void 0) form = $e0b6b9eb661749d3$var$UnicodeNormalizationForm.current;
    if (form != $e0b6b9eb661749d3$var$UnicodeNormalizationForm.current) {
        $e0b6b9eb661749d3$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    var result = [];
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            var c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            var pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $j2rU8.arrayify)(result);
}
module.exports.toUtf8Bytes = $e0b6b9eb661749d3$var$toUtf8Bytes;
function $e0b6b9eb661749d3$var$escapeChar(value) {
    var hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $e0b6b9eb661749d3$var$_toEscapedUtf8String(bytes, onError) {
    return '"' + $e0b6b9eb661749d3$var$getUtf8CodePoints(bytes, onError).map(function(codePoint) {
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $e0b6b9eb661749d3$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $e0b6b9eb661749d3$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $e0b6b9eb661749d3$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
module.exports._toEscapedUtf8String = $e0b6b9eb661749d3$var$_toEscapedUtf8String;
function $e0b6b9eb661749d3$var$_toUtf8String(codePoints) {
    return codePoints.map(function(codePoint) {
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
module.exports._toUtf8String = $e0b6b9eb661749d3$var$_toUtf8String;
function $e0b6b9eb661749d3$var$toUtf8String(bytes, onError) {
    return $e0b6b9eb661749d3$var$_toUtf8String($e0b6b9eb661749d3$var$getUtf8CodePoints(bytes, onError));
}
module.exports.toUtf8String = $e0b6b9eb661749d3$var$toUtf8String;
function $e0b6b9eb661749d3$var$toUtf8CodePoints(str, form) {
    if (form === void 0) form = $e0b6b9eb661749d3$var$UnicodeNormalizationForm.current;
    return $e0b6b9eb661749d3$var$getUtf8CodePoints($e0b6b9eb661749d3$var$toUtf8Bytes(str, form));
}
module.exports.toUtf8CodePoints = $e0b6b9eb661749d3$var$toUtf8CodePoints;

});
parcelRequire.register("3hPAa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
module.exports.version = "strings/5.7.0";

});


parcelRequire.register("bRqq8", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $8a29237e1404abec$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8a29237e1404abec$var$__exportStar = undefined && undefined.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8a29237e1404abec$var$__createBinding(exports1, m, p);
};
var $8a29237e1404abec$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUrlsForDataServiceId = module.exports.requestRedstonePayload = module.exports.requestDataPackages = module.exports.getDecimalsForDataFeedId = module.exports.parseDataPackagesResponse = module.exports.getDataServiceIdForSigner = module.exports.getOracleRegistryState = void 0;

var $8a29237e1404abec$var$axios_1 = $8a29237e1404abec$var$__importDefault((parcelRequire("ilAYG")));

var $e5s6c = parcelRequire("e5s6c");

var $8a29237e1404abec$var$initial_state_json_1 = $8a29237e1404abec$var$__importDefault((parcelRequire("3Yim8")));

var $hyxZy = parcelRequire("hyxZy");


var $f7K4O = parcelRequire("f7K4O");
var $8a29237e1404abec$var$ALL_FEEDS_KEY = "___ALL_FEEDS___";
var $8a29237e1404abec$var$DEFAULT_DECIMALS = 8;
var $8a29237e1404abec$var$getOracleRegistryState = function() {
    var _ref = (0, $byzP8._)(function() {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $8a29237e1404abec$var$initial_state_json_1.default
            ];
        });
    });
    return function getOracleRegistryState() {
        return _ref.apply(this, arguments);
    };
}();
module.exports.getOracleRegistryState = $8a29237e1404abec$var$getOracleRegistryState;
var $8a29237e1404abec$var$getDataServiceIdForSigner = function(oracleState, signerAddress) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(oracleState.nodes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nodeDetails = _step.value;
            if (nodeDetails.evmAddress.toLowerCase() === signerAddress.toLowerCase()) return nodeDetails.dataServiceId;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    throw new Error("Data service not found for ".concat(signerAddress));
};
module.exports.getDataServiceIdForSigner = $8a29237e1404abec$var$getDataServiceIdForSigner;
var $8a29237e1404abec$var$parseDataPackagesResponse = function(dpResponse, reqParams) {
    var _a;
    var parsedResponse = {};
    var requestedDataFeedIds = (_a = reqParams.dataFeeds) !== null && _a !== void 0 ? _a : [
        $8a29237e1404abec$var$ALL_FEEDS_KEY
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = requestedDataFeedIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var dataFeedId = _step.value;
            var dataFeedPackages = dpResponse[dataFeedId];
            if (!dataFeedPackages) throw new Error("Requested data feed id is not included in response: ".concat(dataFeedId));
            if (dataFeedPackages.length < reqParams.uniqueSignersCount) throw new Error("Too few unique signers for the data feed: ".concat(dataFeedId, ". ") + "Expected: ".concat(reqParams.uniqueSignersCount, ". ") + "Received: ".concat(dataFeedPackages.length));
            var dataFeedPackagesSorted = $8a29237e1404abec$var$getDataPackagesSortedByDeviation(dataFeedPackages, reqParams.valuesToCompare, dataFeedId);
            parsedResponse[dataFeedId] = dataFeedPackagesSorted.slice(0, reqParams.uniqueSignersCount).map(function(dataPackage) {
                return $hyxZy.SignedDataPackage.fromObj(dataPackage);
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return parsedResponse;
};
module.exports.parseDataPackagesResponse = $8a29237e1404abec$var$parseDataPackagesResponse;
var $8a29237e1404abec$var$getDataPackagesSortedByDeviation = function(dataFeedPackages, valuesToCompare, dataFeedId) {
    var _a;
    if (!valuesToCompare) return dataFeedPackages;
    if (dataFeedId === $8a29237e1404abec$var$ALL_FEEDS_KEY) throw new Error("Cannot sort data packages by deviation for ".concat($8a29237e1404abec$var$ALL_FEEDS_KEY));
    if (!valuesToCompare[dataFeedId]) return dataFeedPackages;
    var decimals = (_a = (0, module.exports.getDecimalsForDataFeedId)(dataFeedPackages)) !== null && _a !== void 0 ? _a : $8a29237e1404abec$var$DEFAULT_DECIMALS;
    var valueToCompare = Number($e5s6c.formatUnits(valuesToCompare[dataFeedId], decimals));
    return $8a29237e1404abec$var$sortDataPackagesByDeviationDesc(dataFeedPackages, valueToCompare);
};
var $8a29237e1404abec$var$getDecimalsForDataFeedId = function(dataPackages) {
    var firstDecimal = dataPackages[0].dataPoints[0].decimals;
    var areAllDecimalsEqual = dataPackages.every(function(dataPackage) {
        return dataPackage.dataPoints.every(function(dataPoint) {
            return dataPoint.decimals === firstDecimal;
        });
    });
    if (!areAllDecimalsEqual) throw new Error("Decimals from data points in data packages are not equal");
    return firstDecimal;
};
module.exports.getDecimalsForDataFeedId = $8a29237e1404abec$var$getDecimalsForDataFeedId;
var $8a29237e1404abec$var$errToString = function(e) {
    if (e instanceof AggregateError) {
        var stringifiedErrors = e.errors.reduce(function(prev, oneOfErrors, curIndex) {
            return prev += "".concat(curIndex, ": ").concat(oneOfErrors.message, ", ");
        }, "");
        return "".concat(e.message, ": ").concat(stringifiedErrors);
    } else return e.message;
};
var $8a29237e1404abec$var$requestDataPackages = function() {
    var _ref = (0, $byzP8._)(function(reqParams) {
        var promises, e, errMessage;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    promises = $8a29237e1404abec$var$prepareDataPackagePromises(reqParams);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        Promise.any(promises)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    e = _state.sent();
                    errMessage = "Request failed ".concat(JSON.stringify({
                        reqParams: reqParams
                    }), ", Original error: ").concat($8a29237e1404abec$var$errToString(e));
                    throw new Error(errMessage);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function requestDataPackages(reqParams) {
        return _ref.apply(this, arguments);
    };
}();
module.exports.requestDataPackages = $8a29237e1404abec$var$requestDataPackages;
var $8a29237e1404abec$var$prepareDataPackagePromises = function(reqParams) {
    var urls = (0, module.exports.getUrlsForDataServiceId)(reqParams);
    var pathComponents = [
        "data-packages",
        reqParams.historicalTimestamp ? "historical" : "latest",
        reqParams.dataServiceId
    ];
    if (reqParams.historicalTimestamp) pathComponents.push("".concat(reqParams.historicalTimestamp));
    return urls.map(function(url) {
        return $8a29237e1404abec$var$axios_1.default.get([
            url
        ].concat(pathComponents).join("/")).then(function(response) {
            return (0, module.exports.parseDataPackagesResponse)(response.data, reqParams);
        });
    });
};
var $8a29237e1404abec$var$requestRedstonePayload = function() {
    var _ref = (0, $byzP8._)(function(reqParams, unsignedMetadataMsg) {
        var signedDataPackagesResponse, signedDataPackages;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, module.exports.requestDataPackages)(reqParams)
                    ];
                case 1:
                    signedDataPackagesResponse = _state.sent();
                    signedDataPackages = Object.values(signedDataPackagesResponse).flat();
                    return [
                        2,
                        $hyxZy.RedstonePayload.prepare(signedDataPackages, unsignedMetadataMsg || "")
                    ];
            }
        });
    });
    return function requestRedstonePayload(reqParams, unsignedMetadataMsg) {
        return _ref.apply(this, arguments);
    };
}();
module.exports.requestRedstonePayload = $8a29237e1404abec$var$requestRedstonePayload;
var $8a29237e1404abec$var$getUrlsForDataServiceId = function(reqParams) {
    if (reqParams.urls) return reqParams.urls;
    return (0, (parcelRequire("a568B")).resolveDataServiceUrls)(reqParams.dataServiceId);
};
module.exports.getUrlsForDataServiceId = $8a29237e1404abec$var$getUrlsForDataServiceId;
var $8a29237e1404abec$var$sortDataPackagesByDeviationDesc = function(dataPackages, valueToCompare) {
    return dataPackages.sort(function(leftDataPackage, rightDataPackage) {
        var leftValue = $f7K4O.SafeNumber.createSafeNumber(leftDataPackage.dataPoints[0].value);
        var leftValueDeviation = $f7K4O.SafeNumber.calculateDeviationPercent({
            currValue: leftValue,
            prevValue: $f7K4O.SafeNumber.createSafeNumber(valueToCompare)
        });
        var rightValue = $f7K4O.SafeNumber.createSafeNumber(rightDataPackage.dataPoints[0].value);
        var rightValueDeviation = $f7K4O.SafeNumber.calculateDeviationPercent({
            currValue: rightValue,
            prevValue: $f7K4O.SafeNumber.createSafeNumber(valueToCompare)
        });
        return rightValueDeviation.sub(leftValueDeviation).unsafeToNumber();
    });
};
module.exports.default = {
    getOracleRegistryState: module.exports.getOracleRegistryState,
    requestDataPackages: module.exports.requestDataPackages,
    getDataServiceIdForSigner: module.exports.getDataServiceIdForSigner,
    requestRedstonePayload: module.exports.requestRedstonePayload,
    resolveDataServiceUrls: (parcelRequire("a568B")).resolveDataServiceUrls,
    getDecimalsForDataFeedId: module.exports.getDecimalsForDataFeedId
};

$8a29237e1404abec$var$__exportStar((parcelRequire("a568B")), module.exports);

$8a29237e1404abec$var$__exportStar((parcelRequire("1knYY")), module.exports);

$8a29237e1404abec$var$__exportStar((parcelRequire("lE12n")), module.exports);

$8a29237e1404abec$var$__exportStar((parcelRequire("7nHsf")), module.exports);

});
parcelRequire.register("hyxZy", function(module, exports) {
"use strict";
var $cc7ffab7fd727381$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cc7ffab7fd727381$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $cc7ffab7fd727381$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cc7ffab7fd727381$var$__createBinding(exports1, m, p);
};
var $cc7ffab7fd727381$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $cc7ffab7fd727381$var$__createBinding(result, mod, k);
    }
    $cc7ffab7fd727381$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.consts = module.exports.utils = void 0;

$cc7ffab7fd727381$var$__exportStar((parcelRequire("azEtj")), module.exports);

$cc7ffab7fd727381$var$__exportStar((parcelRequire("azEtj")), module.exports);

$cc7ffab7fd727381$var$__exportStar((parcelRequire("43ZHe")), module.exports);

$cc7ffab7fd727381$var$__exportStar((parcelRequire("fhsfN")), module.exports);

$cc7ffab7fd727381$var$__exportStar((parcelRequire("7RTBm")), module.exports);

$cc7ffab7fd727381$var$__exportStar((parcelRequire("jbuKm")), module.exports);

$cc7ffab7fd727381$var$__exportStar((parcelRequire("kfRJk")), module.exports);

$cc7ffab7fd727381$var$__exportStar((parcelRequire("7G1XU")), module.exports);

module.exports.utils = $cc7ffab7fd727381$var$__importStar((parcelRequire("6d3tJ")));

module.exports.consts = $cc7ffab7fd727381$var$__importStar((parcelRequire("fTHW5")));

$cc7ffab7fd727381$var$__exportStar((parcelRequire("lGxEn")), module.exports);

$cc7ffab7fd727381$var$__exportStar((parcelRequire("3GP0A")), module.exports);

});

parcelRequire.register("f7K4O", function(module, exports) {
"use strict";
var $b02b404c1d43fcfb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b02b404c1d43fcfb$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b02b404c1d43fcfb$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b02b404c1d43fcfb$var$__createBinding(result, mod, k);
    }
    $b02b404c1d43fcfb$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RedstoneCommon = module.exports.RedstoneTypes = module.exports.MathUtils = module.exports.SafeNumber = void 0;

module.exports.SafeNumber = $b02b404c1d43fcfb$var$__importStar((parcelRequire("3UmfN")));

module.exports.MathUtils = $b02b404c1d43fcfb$var$__importStar((parcelRequire("fXzVi"))); // to avoid clash with Math global

module.exports.RedstoneTypes = $b02b404c1d43fcfb$var$__importStar((parcelRequire("dINQQ")));

module.exports.RedstoneCommon = $b02b404c1d43fcfb$var$__importStar((parcelRequire("ashcf")));

});

parcelRequire.register("lE12n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("7nHsf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});



parcelRequire.register("kHc9u", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $f1113ff551ce102d$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarknetContractConnector = module.exports.FEE_MULTIPLIER = void 0;

var $f1113ff551ce102d$var$axios_1 = $f1113ff551ce102d$var$__importDefault((parcelRequire("28Dk9")));

var $3GDHM = parcelRequire("3GDHM");
var $f1113ff551ce102d$var$WAIT_FOR_TRANSACTION_TIME_INTERVAL = 30103;
module.exports.FEE_MULTIPLIER = 1000000000000000000;
var $f1113ff551ce102d$var$StarknetContractConnector = /*#__PURE__*/ function() {
    function StarknetContractConnector(account, contractAddress, abi) {
        var network = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "goerli-alpha";
        (0, $978gY._)(this, StarknetContractConnector);
        this.contractAddress = contractAddress;
        this.abi = abi;
        this.network = network;
        this.provider = account || new $3GDHM.Provider({
            sequencer: {
                network: this.network
            }
        });
    }
    (0, $kry2a._)(StarknetContractConnector, [
        {
            key: "waitForTransaction",
            value: function waitForTransaction(txHash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.provider.waitForTransaction(txHash, $f1113ff551ce102d$var$WAIT_FOR_TRANSACTION_TIME_INTERVAL, [
                                        "ACCEPTED_ON_L2",
                                        "REJECTED"
                                    ])
                                ];
                            case 1:
                                result = _state.sent();
                                console.log("Transaction ".concat(txHash, " finished with status: ").concat(result.status, ", fee: ").concat(result.actual_fee != undefined ? parseInt(result.actual_fee) / module.exports.FEE_MULTIPLIER : result.actual_fee, " ETH"));
                                return [
                                    2,
                                    result.status == "ACCEPTED_ON_L2"
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getContract",
            value: function getContract() {
                return new $3GDHM.Contract(this.abi, this.contractAddress, this.provider);
            }
        },
        {
            key: "getBlockNumber",
            value: function getBlockNumber(rpcUrl) {
                return (0, $byzP8._)(function() {
                    var response;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $f1113ff551ce102d$var$axios_1.default.post(rpcUrl, {
                                        jsonrpc: "2.0",
                                        method: "starknet_blockNumber",
                                        params: [],
                                        id: 1
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response.data.result
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return StarknetContractConnector;
}();
module.exports.StarknetContractConnector = $f1113ff551ce102d$var$StarknetContractConnector;

});
parcelRequire.register("28Dk9", function(module, exports) {

module.exports = (parcelRequire("cN2yV"));

});
parcelRequire.register("cN2yV", function(module, exports) {
"use strict";

var $eqwMX = parcelRequire("eqwMX");

var $4WhKn = parcelRequire("4WhKn");

var $1Q7d7 = parcelRequire("1Q7d7");

var $hdqQe = parcelRequire("hdqQe");

var $bwoH5 = parcelRequire("bwoH5");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $94fc0c779e1f7c71$var$createInstance(defaultConfig) {
    var context = new $1Q7d7(defaultConfig);
    var instance = $4WhKn($1Q7d7.prototype.request, context);
    // Copy axios.prototype to instance
    $eqwMX.extend(instance, $1Q7d7.prototype, context);
    // Copy context to instance
    $eqwMX.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $94fc0c779e1f7c71$var$createInstance($hdqQe(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $94fc0c779e1f7c71$var$axios = $94fc0c779e1f7c71$var$createInstance($bwoH5);
// Expose Axios class to allow class inheritance
$94fc0c779e1f7c71$var$axios.Axios = $1Q7d7;

// Expose Cancel & CancelToken
$94fc0c779e1f7c71$var$axios.CanceledError = (parcelRequire("cZ5Ty"));

$94fc0c779e1f7c71$var$axios.CancelToken = (parcelRequire("dAezv"));

$94fc0c779e1f7c71$var$axios.isCancel = (parcelRequire("jS6eH"));

$94fc0c779e1f7c71$var$axios.VERSION = (parcelRequire("kVaJL")).version;

$94fc0c779e1f7c71$var$axios.toFormData = (parcelRequire("c9Q9B"));

// Expose AxiosError class
$94fc0c779e1f7c71$var$axios.AxiosError = (parcelRequire("9W71p"));
// alias for CanceledError for backward compatibility
$94fc0c779e1f7c71$var$axios.Cancel = $94fc0c779e1f7c71$var$axios.CanceledError;
// Expose all/spread
$94fc0c779e1f7c71$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$94fc0c779e1f7c71$var$axios.spread = (parcelRequire("ilH2u"));

// Expose isAxiosError
$94fc0c779e1f7c71$var$axios.isAxiosError = (parcelRequire("9Wi1W"));
module.exports = $94fc0c779e1f7c71$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $94fc0c779e1f7c71$var$axios;

});
parcelRequire.register("eqwMX", function(module, exports) {
"use strict";

var $4WhKn = parcelRequire("4WhKn");
// utils is a library of generic helper functions non-specific to axios
var $a80ced87620e1b4c$var$toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var $a80ced87620e1b4c$var$kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = $a80ced87620e1b4c$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function $a80ced87620e1b4c$var$kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return $a80ced87620e1b4c$var$kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $a80ced87620e1b4c$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $a80ced87620e1b4c$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $a80ced87620e1b4c$var$isBuffer(val) {
    return val !== null && !$a80ced87620e1b4c$var$isUndefined(val) && val.constructor !== null && !$a80ced87620e1b4c$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $a80ced87620e1b4c$var$isArrayBuffer = $a80ced87620e1b4c$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $a80ced87620e1b4c$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $a80ced87620e1b4c$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $a80ced87620e1b4c$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $a80ced87620e1b4c$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $a80ced87620e1b4c$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $a80ced87620e1b4c$var$isPlainObject(val) {
    if ($a80ced87620e1b4c$var$kindOf(val) !== "object") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $a80ced87620e1b4c$var$isDate = $a80ced87620e1b4c$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $a80ced87620e1b4c$var$isFile = $a80ced87620e1b4c$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $a80ced87620e1b4c$var$isBlob = $a80ced87620e1b4c$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $a80ced87620e1b4c$var$isFileList = $a80ced87620e1b4c$var$kindOfTest("FileList");
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $a80ced87620e1b4c$var$isFunction(val) {
    return $a80ced87620e1b4c$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $a80ced87620e1b4c$var$isStream(val) {
    return $a80ced87620e1b4c$var$isObject(val) && $a80ced87620e1b4c$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $a80ced87620e1b4c$var$isFormData(thing) {
    var pattern = "[object FormData]";
    return thing && (typeof FormData === "function" && thing instanceof FormData || $a80ced87620e1b4c$var$toString.call(thing) === pattern || $a80ced87620e1b4c$var$isFunction(thing.toString) && thing.toString() === pattern);
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $a80ced87620e1b4c$var$isURLSearchParams = $a80ced87620e1b4c$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $a80ced87620e1b4c$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $a80ced87620e1b4c$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $a80ced87620e1b4c$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($a80ced87620e1b4c$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $a80ced87620e1b4c$var$merge() {
    var assignValue = function assignValue(val, key) {
        if ($a80ced87620e1b4c$var$isPlainObject(result[key]) && $a80ced87620e1b4c$var$isPlainObject(val)) result[key] = $a80ced87620e1b4c$var$merge(result[key], val);
        else if ($a80ced87620e1b4c$var$isPlainObject(val)) result[key] = $a80ced87620e1b4c$var$merge({}, val);
        else if ($a80ced87620e1b4c$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    };
    var result = {};
    for(var i = 0, l = arguments.length; i < l; i++)$a80ced87620e1b4c$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $a80ced87620e1b4c$var$extend(a, b, thisArg) {
    $a80ced87620e1b4c$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $4WhKn(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $a80ced87620e1b4c$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function $a80ced87620e1b4c$var$inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */ function $a80ced87620e1b4c$var$toFlatObject(sourceObj, destObj, filter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if (!merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function $a80ced87620e1b4c$var$endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */ function $a80ced87620e1b4c$var$toArray(thing) {
    if (!thing) return null;
    var i = thing.length;
    if ($a80ced87620e1b4c$var$isUndefined(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var $a80ced87620e1b4c$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
module.exports = {
    isArray: $a80ced87620e1b4c$var$isArray,
    isArrayBuffer: $a80ced87620e1b4c$var$isArrayBuffer,
    isBuffer: $a80ced87620e1b4c$var$isBuffer,
    isFormData: $a80ced87620e1b4c$var$isFormData,
    isArrayBufferView: $a80ced87620e1b4c$var$isArrayBufferView,
    isString: $a80ced87620e1b4c$var$isString,
    isNumber: $a80ced87620e1b4c$var$isNumber,
    isObject: $a80ced87620e1b4c$var$isObject,
    isPlainObject: $a80ced87620e1b4c$var$isPlainObject,
    isUndefined: $a80ced87620e1b4c$var$isUndefined,
    isDate: $a80ced87620e1b4c$var$isDate,
    isFile: $a80ced87620e1b4c$var$isFile,
    isBlob: $a80ced87620e1b4c$var$isBlob,
    isFunction: $a80ced87620e1b4c$var$isFunction,
    isStream: $a80ced87620e1b4c$var$isStream,
    isURLSearchParams: $a80ced87620e1b4c$var$isURLSearchParams,
    isStandardBrowserEnv: $a80ced87620e1b4c$var$isStandardBrowserEnv,
    forEach: $a80ced87620e1b4c$var$forEach,
    merge: $a80ced87620e1b4c$var$merge,
    extend: $a80ced87620e1b4c$var$extend,
    trim: $a80ced87620e1b4c$var$trim,
    stripBOM: $a80ced87620e1b4c$var$stripBOM,
    inherits: $a80ced87620e1b4c$var$inherits,
    toFlatObject: $a80ced87620e1b4c$var$toFlatObject,
    kindOf: $a80ced87620e1b4c$var$kindOf,
    kindOfTest: $a80ced87620e1b4c$var$kindOfTest,
    endsWith: $a80ced87620e1b4c$var$endsWith,
    toArray: $a80ced87620e1b4c$var$toArray,
    isTypedArray: $a80ced87620e1b4c$var$isTypedArray,
    isFileList: $a80ced87620e1b4c$var$isFileList
};

});
parcelRequire.register("4WhKn", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRequire.register("1Q7d7", function(module, exports) {
"use strict";

var $eqwMX = parcelRequire("eqwMX");

var $hse3x = parcelRequire("hse3x");

var $ani4f = parcelRequire("ani4f");

var $50RjB = parcelRequire("50RjB");

var $hdqQe = parcelRequire("hdqQe");

var $jj57M = parcelRequire("jj57M");

var $aKlel = parcelRequire("aKlel");
var $15703da32cbadb19$var$validators = $aKlel.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $15703da32cbadb19$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $ani4f(),
        response: new $ani4f()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $15703da32cbadb19$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $hdqQe(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $aKlel.assertOptions(transitional, {
        silentJSONParsing: $15703da32cbadb19$var$validators.transitional($15703da32cbadb19$var$validators.boolean),
        forcedJSONParsing: $15703da32cbadb19$var$validators.transitional($15703da32cbadb19$var$validators.boolean),
        clarifyTimeoutError: $15703da32cbadb19$var$validators.transitional($15703da32cbadb19$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $50RjB,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $50RjB(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$15703da32cbadb19$var$Axios.prototype.getUri = function getUri(config) {
    config = $hdqQe(this.defaults, config);
    var fullPath = $jj57M(config.baseURL, config.url);
    return $hse3x(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
$eqwMX.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $15703da32cbadb19$var$Axios.prototype[method] = function(url, config) {
        return this.request($hdqQe(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$eqwMX.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    var generateHTTPMethod = /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($hdqQe(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    };
    $15703da32cbadb19$var$Axios.prototype[method] = generateHTTPMethod();
    $15703da32cbadb19$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
module.exports = $15703da32cbadb19$var$Axios;

});
parcelRequire.register("hse3x", function(module, exports) {
"use strict";

var $eqwMX = parcelRequire("eqwMX");
function $cb4ff46f3ced3e3c$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($eqwMX.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $eqwMX.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($eqwMX.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $eqwMX.forEach(val, function parseValue(v) {
                if ($eqwMX.isDate(v)) v = v.toISOString();
                else if ($eqwMX.isObject(v)) v = JSON.stringify(v);
                parts.push($cb4ff46f3ced3e3c$var$encode(key) + "=" + $cb4ff46f3ced3e3c$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRequire.register("ani4f", function(module, exports) {
"use strict";

var $eqwMX = parcelRequire("eqwMX");
function $78da1137cc45cbd8$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $78da1137cc45cbd8$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $78da1137cc45cbd8$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $78da1137cc45cbd8$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $eqwMX.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $78da1137cc45cbd8$var$InterceptorManager;

});

parcelRequire.register("50RjB", function(module, exports) {
"use strict";

var $eqwMX = parcelRequire("eqwMX");

var $gBUpU = parcelRequire("gBUpU");

var $jS6eH = parcelRequire("jS6eH");

var $bwoH5 = parcelRequire("bwoH5");

var $cZ5Ty = parcelRequire("cZ5Ty");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function $3a664f24a4f7b864$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $cZ5Ty();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $3a664f24a4f7b864$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $gBUpU.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $eqwMX.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $eqwMX.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $bwoH5.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $3a664f24a4f7b864$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $gBUpU.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$jS6eH(reason)) {
            $3a664f24a4f7b864$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $gBUpU.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRequire.register("gBUpU", function(module, exports) {
"use strict";

var $eqwMX = parcelRequire("eqwMX");

var $bwoH5 = parcelRequire("bwoH5");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $bwoH5;
    /*eslint no-param-reassign:0*/ $eqwMX.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRequire.register("bwoH5", function(module, exports) {

var $aqbQf = parcelRequire("aqbQf");
"use strict";

var $eqwMX = parcelRequire("eqwMX");

var $j0VSY = parcelRequire("j0VSY");

var $9W71p = parcelRequire("9W71p");

var $6DsdN = parcelRequire("6DsdN");

var $c9Q9B = parcelRequire("c9Q9B");
var $8635d695f93b8a42$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $8635d695f93b8a42$var$setContentTypeIfUnset(headers, value) {
    if (!$eqwMX.isUndefined(headers) && $eqwMX.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $8635d695f93b8a42$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("84PvH"));
    else if (typeof $aqbQf !== "undefined" && Object.prototype.toString.call($aqbQf) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("84PvH"));
    return adapter;
}
function $8635d695f93b8a42$var$stringifySafely(rawValue, parser, encoder) {
    if ($eqwMX.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $eqwMX.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}

var $8635d695f93b8a42$var$defaults = {
    transitional: $6DsdN,
    adapter: $8635d695f93b8a42$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $j0VSY(headers, "Accept");
            $j0VSY(headers, "Content-Type");
            if ($eqwMX.isFormData(data) || $eqwMX.isArrayBuffer(data) || $eqwMX.isBuffer(data) || $eqwMX.isStream(data) || $eqwMX.isFile(data) || $eqwMX.isBlob(data)) return data;
            if ($eqwMX.isArrayBufferView(data)) return data.buffer;
            if ($eqwMX.isURLSearchParams(data)) {
                $8635d695f93b8a42$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            var isObjectPayload = $eqwMX.isObject(data);
            var contentType = headers && headers["Content-Type"];
            var isFileList;
            if ((isFileList = $eqwMX.isFileList(data)) || isObjectPayload && contentType === "multipart/form-data") {
                var _FormData = this.env && this.env.FormData;
                return $c9Q9B(isFileList ? {
                    "files[]": data
                } : data, _FormData && new _FormData());
            } else if (isObjectPayload || contentType === "application/json") {
                $8635d695f93b8a42$var$setContentTypeIfUnset(headers, "application/json");
                return $8635d695f93b8a42$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $8635d695f93b8a42$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $eqwMX.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $9W71p.from(e, $9W71p.ERR_BAD_RESPONSE, this, null, this.response);
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (parcelRequire("6wh0m"))
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$eqwMX.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $8635d695f93b8a42$var$defaults.headers[method] = {};
});
$eqwMX.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $8635d695f93b8a42$var$defaults.headers[method] = $eqwMX.merge($8635d695f93b8a42$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $8635d695f93b8a42$var$defaults;

});
parcelRequire.register("j0VSY", function(module, exports) {
"use strict";

var $eqwMX = parcelRequire("eqwMX");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $eqwMX.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRequire.register("9W71p", function(module, exports) {
"use strict";

var $eqwMX = parcelRequire("eqwMX");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function $73befa3ac4b922cc$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$eqwMX.inherits($73befa3ac4b922cc$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $73befa3ac4b922cc$var$prototype = $73befa3ac4b922cc$var$AxiosError.prototype;
var $73befa3ac4b922cc$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED"
].forEach(function(code) {
    $73befa3ac4b922cc$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($73befa3ac4b922cc$var$AxiosError, $73befa3ac4b922cc$var$descriptors);
Object.defineProperty($73befa3ac4b922cc$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$73befa3ac4b922cc$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($73befa3ac4b922cc$var$prototype);
    $eqwMX.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    $73befa3ac4b922cc$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = $73befa3ac4b922cc$var$AxiosError;

});

parcelRequire.register("6DsdN", function(module, exports) {
"use strict";
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRequire.register("c9Q9B", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $8d9ec7f6da2647a4$require$Buffer = $gzLuY.Buffer;
"use strict";

var $eqwMX = parcelRequire("eqwMX");
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/ function $8d9ec7f6da2647a4$var$toFormData(obj, formData) {
    var convertValue = function convertValue(value) {
        if (value === null) return "";
        if ($eqwMX.isDate(value)) return value.toISOString();
        if ($eqwMX.isArrayBuffer(value) || $eqwMX.isTypedArray(value)) return typeof Blob === "function" ? new Blob([
            value
        ]) : $8d9ec7f6da2647a4$require$Buffer.from(value);
        return value;
    };
    // eslint-disable-next-line no-param-reassign
    formData = formData || new FormData();
    var stack = [];
    function build(data, parentKey) {
        if ($eqwMX.isPlainObject(data) || $eqwMX.isArray(data)) {
            if (stack.indexOf(data) !== -1) throw Error("Circular reference detected in " + parentKey);
            stack.push(data);
            $eqwMX.forEach(data, function each(value, key) {
                if ($eqwMX.isUndefined(value)) return;
                var fullKey = parentKey ? parentKey + "." + key : key;
                var arr;
                if (value && !parentKey && typeof value === "object") {
                    if ($eqwMX.endsWith(key, "{}")) // eslint-disable-next-line no-param-reassign
                    value = JSON.stringify(value);
                    else if ($eqwMX.endsWith(key, "[]") && (arr = $eqwMX.toArray(value))) {
                        // eslint-disable-next-line func-names
                        arr.forEach(function(el) {
                            !$eqwMX.isUndefined(el) && formData.append(fullKey, convertValue(el));
                        });
                        return;
                    }
                }
                build(value, fullKey);
            });
            stack.pop();
        } else formData.append(parentKey, convertValue(data));
    }
    build(obj);
    return formData;
}
module.exports = $8d9ec7f6da2647a4$var$toFormData;

});

parcelRequire.register("84PvH", function(module, exports) {
"use strict";

var $eqwMX = parcelRequire("eqwMX");

var $cxioo = parcelRequire("cxioo");

var $2u3nm = parcelRequire("2u3nm");

var $hse3x = parcelRequire("hse3x");

var $jj57M = parcelRequire("jj57M");

var $AOJD0 = parcelRequire("AOJD0");

var $cyXEa = parcelRequire("cyXEa");

var $6DsdN = parcelRequire("6DsdN");

var $9W71p = parcelRequire("9W71p");

var $cZ5Ty = parcelRequire("cZ5Ty");

var $e088g = parcelRequire("e088g");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var done = function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        };
        var onloadend = function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $AOJD0(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $cxioo(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        };
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        if ($eqwMX.isFormData(requestData) && $eqwMX.isStandardBrowserEnv()) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $jj57M(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $hse3x(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $9W71p("Request aborted", $9W71p.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $9W71p("Network Error", $9W71p.ERR_NETWORK, config, request, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $6DsdN;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $9W71p(timeoutErrorMessage, transitional.clarifyTimeoutError ? $9W71p.ETIMEDOUT : $9W71p.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($eqwMX.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $cyXEa(fullPath)) && config.xsrfCookieName ? $2u3nm.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $eqwMX.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$eqwMX.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function onCanceled(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $cZ5Ty() : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        var protocol = $e088g(fullPath);
        if (protocol && [
            "http",
            "https",
            "file"
        ].indexOf(protocol) === -1) {
            reject(new $9W71p("Unsupported protocol " + protocol + ":", $9W71p.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

});
parcelRequire.register("cxioo", function(module, exports) {
"use strict";

var $9W71p = parcelRequire("9W71p");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $9W71p("Request failed with status code " + response.status, [
        $9W71p.ERR_BAD_REQUEST,
        $9W71p.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

});

parcelRequire.register("2u3nm", function(module, exports) {
"use strict";

var $eqwMX = parcelRequire("eqwMX");
module.exports = $eqwMX.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($eqwMX.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($eqwMX.isString(path)) cookie.push("path=" + path);
            if ($eqwMX.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRequire.register("jj57M", function(module, exports) {
"use strict";

var $gfXrN = parcelRequire("gfXrN");

var $it6zL = parcelRequire("it6zL");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$gfXrN(requestedURL)) return $it6zL(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRequire.register("gfXrN", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRequire.register("it6zL", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRequire.register("AOJD0", function(module, exports) {
"use strict";

var $eqwMX = parcelRequire("eqwMX");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $06eab7cf2334b04a$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $eqwMX.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $eqwMX.trim(line.substr(0, i)).toLowerCase();
        val = $eqwMX.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $06eab7cf2334b04a$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRequire.register("cyXEa", function(module, exports) {
"use strict";

var $eqwMX = parcelRequire("eqwMX");
module.exports = $eqwMX.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var resolveURL = /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    };
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $eqwMX.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRequire.register("cZ5Ty", function(module, exports) {
"use strict";

var $9W71p = parcelRequire("9W71p");

var $eqwMX = parcelRequire("eqwMX");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $973fc12da1c9fed4$var$CanceledError(message) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $9W71p.call(this, message == null ? "canceled" : message, $9W71p.ERR_CANCELED);
    this.name = "CanceledError";
}
$eqwMX.inherits($973fc12da1c9fed4$var$CanceledError, $9W71p, {
    __CANCEL__: true
});
module.exports = $973fc12da1c9fed4$var$CanceledError;

});

parcelRequire.register("e088g", function(module, exports) {
"use strict";
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
};

});


parcelRequire.register("6wh0m", function(module, exports) {
// eslint-disable-next-line strict
module.exports = null;

});



parcelRequire.register("jS6eH", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRequire.register("hdqQe", function(module, exports) {
"use strict";

var $eqwMX = parcelRequire("eqwMX");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    var getMergedValue = function getMergedValue(target, source) {
        if ($eqwMX.isPlainObject(target) && $eqwMX.isPlainObject(source)) return $eqwMX.merge(target, source);
        else if ($eqwMX.isPlainObject(source)) return $eqwMX.merge({}, source);
        else if ($eqwMX.isArray(source)) return source.slice();
        return source;
    };
    var mergeDeepProperties = // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$eqwMX.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$eqwMX.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    };
    var valueFromConfig2 = // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$eqwMX.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    };
    var defaultToConfig2 = // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$eqwMX.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$eqwMX.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    };
    var mergeDirectKeys = // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    };
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "beforeRedirect": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $eqwMX.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $eqwMX.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRequire.register("aKlel", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
"use strict";

var $kVaJL = parcelRequire("kVaJL");
var $7d2eab302f230103$require$VERSION = $kVaJL.version;

var $9W71p = parcelRequire("9W71p");
var $7d2eab302f230103$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $7d2eab302f230103$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $1ObTH._)(thing)) === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $7d2eab302f230103$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $7d2eab302f230103$var$validators.transitional = function transitional(validator, version, message) {
    var formatMessage = function formatMessage(opt, desc) {
        return "[Axios v" + $7d2eab302f230103$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    };
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new $9W71p(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), $9W71p.ERR_DEPRECATED);
        if (version && !$7d2eab302f230103$var$deprecatedWarnings[opt]) {
            $7d2eab302f230103$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $7d2eab302f230103$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new $9W71p("options must be an object", $9W71p.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $9W71p("option " + opt + " must be " + result, $9W71p.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $9W71p("Unknown option " + opt, $9W71p.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: $7d2eab302f230103$var$assertOptions,
    validators: $7d2eab302f230103$var$validators
};

});
parcelRequire.register("kVaJL", function(module, exports) {
module.exports = {
    "version": "0.27.2"
};

});



parcelRequire.register("dAezv", function(module, exports) {
"use strict";

var $cZ5Ty = parcelRequire("cZ5Ty");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $9e39f0cacd6ceae3$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $cZ5Ty(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ $9e39f0cacd6ceae3$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $9e39f0cacd6ceae3$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $9e39f0cacd6ceae3$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $9e39f0cacd6ceae3$var$CancelToken.source = function source() {
    var cancel;
    var token = new $9e39f0cacd6ceae3$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $9e39f0cacd6ceae3$var$CancelToken;

});

parcelRequire.register("ilH2u", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRequire.register("9Wi1W", function(module, exports) {
"use strict";

var $eqwMX = parcelRequire("eqwMX");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $eqwMX.isObject(payload) && payload.isAxiosError === true;
};

});



parcelRequire.register("3GDHM", function(module, exports) {

$parcel$export(module.exports, "hash", function () { return $facb0cbc5626d02c$export$d6af199866bfb566; });
$parcel$export(module.exports, "constants", function () { return $facb0cbc5626d02c$export$1a988e7317c65621; });
$parcel$export(module.exports, "number", function () { return $facb0cbc5626d02c$export$98e628dec113755e; });
$parcel$export(module.exports, "encode", function () { return $facb0cbc5626d02c$export$c564cdbbe6da493; });
$parcel$export(module.exports, "ec", function () { return $facb0cbc5626d02c$export$6be572eb25b0fc90; });
$parcel$export(module.exports, "json", function () { return $facb0cbc5626d02c$export$7b419323e6ed4f31; });
$parcel$export(module.exports, "stark", function () { return $facb0cbc5626d02c$export$56c09bfdffd6a7c6; });
$parcel$export(module.exports, "LibraryError", function () { return $facb0cbc5626d02c$export$8c05b2dc6219e90a; });
$parcel$export(module.exports, "GatewayError", function () { return $facb0cbc5626d02c$export$8ef93724ecb8bcb7; });
$parcel$export(module.exports, "HttpError", function () { return $facb0cbc5626d02c$export$65bd6083489bd8bb; });
$parcel$export(module.exports, "RpcProvider", function () { return $facb0cbc5626d02c$export$578ebb3f1f89cda2; });
$parcel$export(module.exports, "isUrl", function () { return $facb0cbc5626d02c$export$8304a22d431f958; });
$parcel$export(module.exports, "buildUrl", function () { return $facb0cbc5626d02c$export$b5cd97dee32de81d; });
$parcel$export(module.exports, "SequencerProvider", function () { return $facb0cbc5626d02c$export$257d155889fba954; });
$parcel$export(module.exports, "Provider", function () { return $facb0cbc5626d02c$export$2881499e37b75b9a; });
$parcel$export(module.exports, "ProviderInterface", function () { return $facb0cbc5626d02c$export$8efff2d796cdea69; });
$parcel$export(module.exports, "defaultProvider", function () { return $facb0cbc5626d02c$export$dc63293f8fab0911; });
$parcel$export(module.exports, "Contract", function () { return $facb0cbc5626d02c$export$8517d80acf00e19a; });
$parcel$export(module.exports, "ContractInterface", function () { return $facb0cbc5626d02c$export$c16ebf97b4a8324a; });
$parcel$export(module.exports, "ContractFactory", function () { return $facb0cbc5626d02c$export$505569a6bf584fd9; });
$parcel$export(module.exports, "SignerInterface", function () { return $facb0cbc5626d02c$export$c7f3abef082132e7; });
$parcel$export(module.exports, "transaction", function () { return $facb0cbc5626d02c$export$2d62d2646dd2fb3c; });
$parcel$export(module.exports, "typedData", function () { return $facb0cbc5626d02c$export$2ebe69e89b76b6ec; });
$parcel$export(module.exports, "merkle", function () { return $facb0cbc5626d02c$export$483e047521be7129; });
$parcel$export(module.exports, "shortString", function () { return $facb0cbc5626d02c$export$bcef2cf0ec329fbf; });
$parcel$export(module.exports, "Signer", function () { return $facb0cbc5626d02c$export$fdf54fdde81cc9f0; });
$parcel$export(module.exports, "Account", function () { return $facb0cbc5626d02c$export$1ed4b10e4aba04a7; });
$parcel$export(module.exports, "AccountInterface", function () { return $facb0cbc5626d02c$export$73debe15cf2a7ba5; });
$parcel$export(module.exports, "uint256", function () { return $facb0cbc5626d02c$export$fa66cedfaa3c10f3; });
$parcel$export(module.exports, "addAddressPadding", function () { return $facb0cbc5626d02c$export$74cf7857f9f0313c; });
$parcel$export(module.exports, "validateAndParseAddress", function () { return $facb0cbc5626d02c$export$5049782b602a3e5d; });
$parcel$export(module.exports, "getChecksumAddress", function () { return $facb0cbc5626d02c$export$c696806606bb1429; });
$parcel$export(module.exports, "validateChecksumAddress", function () { return $facb0cbc5626d02c$export$26bc63e5b5463ece; });

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $8GFUW = parcelRequire("8GFUW");

var $jKer9 = parcelRequire("jKer9");

var $fLnyw = parcelRequire("fLnyw");

var $1ObTH = parcelRequire("1ObTH");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $3210N = parcelRequire("3210N");

var $jxHwd = parcelRequire("jxHwd");

var $jxD7z = parcelRequire("jxD7z");

var $kLNKc = parcelRequire("kLNKc");

var $jlWHo = parcelRequire("jlWHo");

var $492wS = parcelRequire("492wS");

var $dMFrt = parcelRequire("dMFrt");

var $7QjXN = parcelRequire("7QjXN");

var $kGJ2Q = parcelRequire("kGJ2Q");

var $aZG1x = parcelRequire("aZG1x");

var $4oIhN = parcelRequire("4oIhN");

var $j2rU8 = parcelRequire("j2rU8");

var $gzLuY = parcelRequire("gzLuY");
var $facb0cbc5626d02c$require$Buffer = $gzLuY.Buffer;
var $facb0cbc5626d02c$var$__defProp = Object.defineProperty;
var $facb0cbc5626d02c$var$__export = function(target, all) {
    for(var name in all)$facb0cbc5626d02c$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $facb0cbc5626d02c$var$fetchPonyfill_default = typeof window !== "undefined" && window.fetch || typeof $parcel$global !== "undefined" && $parcel$global.fetch || (0, (/*@__PURE__*/$parcel$interopDefault($jxHwd)));
// src/utils/hash.ts
var $facb0cbc5626d02c$export$d6af199866bfb566 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$d6af199866bfb566, {
    calculateContractAddressFromHash: function() {
        return $facb0cbc5626d02c$var$calculateContractAddressFromHash;
    },
    calculateDeclareTransactionHash: function() {
        return $facb0cbc5626d02c$var$calculateDeclareTransactionHash;
    },
    calculateDeployAccountTransactionHash: function() {
        return $facb0cbc5626d02c$var$calculateDeployAccountTransactionHash;
    },
    calculateDeployTransactionHash: function() {
        return $facb0cbc5626d02c$var$calculateDeployTransactionHash;
    },
    calculateTransactionHash: function() {
        return $facb0cbc5626d02c$var$calculateTransactionHash;
    },
    calculateTransactionHashCommon: function() {
        return $facb0cbc5626d02c$var$calculateTransactionHashCommon;
    },
    computeHashOnElements: function() {
        return $facb0cbc5626d02c$var$computeHashOnElements;
    },
    feeTransactionVersion: function() {
        return $facb0cbc5626d02c$var$feeTransactionVersion;
    },
    getSelector: function() {
        return $facb0cbc5626d02c$var$getSelector;
    },
    getSelectorFromName: function() {
        return $facb0cbc5626d02c$var$getSelectorFromName;
    },
    keccakBn: function() {
        return $facb0cbc5626d02c$var$keccakBn;
    },
    pedersen: function() {
        return $facb0cbc5626d02c$var$pedersen;
    },
    starknetKeccak: function() {
        return $facb0cbc5626d02c$var$starknetKeccak;
    },
    transactionVersion: function() {
        return $facb0cbc5626d02c$var$transactionVersion;
    }
});
// src/constants.ts
var $facb0cbc5626d02c$export$1a988e7317c65621 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$1a988e7317c65621, {
    ALPHA: function() {
        return $facb0cbc5626d02c$var$ALPHA;
    },
    BETA: function() {
        return $facb0cbc5626d02c$var$BETA;
    },
    CONSTANT_POINTS: function() {
        return $facb0cbc5626d02c$var$CONSTANT_POINTS;
    },
    EC_ORDER: function() {
        return $facb0cbc5626d02c$var$EC_ORDER;
    },
    FIELD_GEN: function() {
        return $facb0cbc5626d02c$var$FIELD_GEN;
    },
    FIELD_PRIME: function() {
        return $facb0cbc5626d02c$var$FIELD_PRIME;
    },
    FIELD_SIZE: function() {
        return $facb0cbc5626d02c$var$FIELD_SIZE;
    },
    IS_BROWSER: function() {
        return $facb0cbc5626d02c$var$IS_BROWSER;
    },
    MASK_250: function() {
        return $facb0cbc5626d02c$var$MASK_250;
    },
    MASK_251: function() {
        return $facb0cbc5626d02c$var$MASK_251;
    },
    MAX_ECDSA_VAL: function() {
        return $facb0cbc5626d02c$var$MAX_ECDSA_VAL;
    },
    ONE: function() {
        return $facb0cbc5626d02c$var$ONE;
    },
    StarknetChainId: function() {
        return $facb0cbc5626d02c$var$StarknetChainId;
    },
    TWO: function() {
        return $facb0cbc5626d02c$var$TWO;
    },
    TransactionHashPrefix: function() {
        return $facb0cbc5626d02c$var$TransactionHashPrefix;
    },
    UDC: function() {
        return $facb0cbc5626d02c$var$UDC;
    },
    ZERO: function() {
        return $facb0cbc5626d02c$var$ZERO;
    }
});
// src/utils/number.ts
var $facb0cbc5626d02c$export$98e628dec113755e = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$98e628dec113755e, {
    assertInRange: function() {
        return $facb0cbc5626d02c$var$assertInRange;
    },
    bigNumberishArrayToDecimalStringArray: function() {
        return $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray;
    },
    bigNumberishArrayToHexadecimalStringArray: function() {
        return $facb0cbc5626d02c$var$bigNumberishArrayToHexadecimalStringArray;
    },
    cleanHex: function() {
        return $facb0cbc5626d02c$var$cleanHex;
    },
    getDecimalString: function() {
        return $facb0cbc5626d02c$var$getDecimalString;
    },
    getHexString: function() {
        return $facb0cbc5626d02c$var$getHexString;
    },
    getHexStringArray: function() {
        return $facb0cbc5626d02c$var$getHexStringArray;
    },
    hexToDecimalString: function() {
        return $facb0cbc5626d02c$var$hexToDecimalString;
    },
    isHex: function() {
        return $facb0cbc5626d02c$var$isHex;
    },
    isStringWholeNumber: function() {
        return $facb0cbc5626d02c$var$isStringWholeNumber;
    },
    toBN: function() {
        return $facb0cbc5626d02c$var$toBN;
    },
    toCairoBool: function() {
        return $facb0cbc5626d02c$var$toCairoBool;
    },
    toFelt: function() {
        return $facb0cbc5626d02c$var$toFelt;
    },
    toHex: function() {
        return $facb0cbc5626d02c$var$toHex;
    },
    toHexString: function() {
        return $facb0cbc5626d02c$var$toHexString;
    }
});
// src/utils/encode.ts
var $facb0cbc5626d02c$export$c564cdbbe6da493 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$c564cdbbe6da493, {
    IS_BROWSER: function() {
        return $facb0cbc5626d02c$var$IS_BROWSER;
    },
    addHexPrefix: function() {
        return $facb0cbc5626d02c$var$addHexPrefix;
    },
    arrayBufferToString: function() {
        return $facb0cbc5626d02c$var$arrayBufferToString;
    },
    btoaUniversal: function() {
        return $facb0cbc5626d02c$var$btoaUniversal;
    },
    buf2hex: function() {
        return $facb0cbc5626d02c$var$buf2hex;
    },
    calcByteLength: function() {
        return $facb0cbc5626d02c$var$calcByteLength;
    },
    padLeft: function() {
        return $facb0cbc5626d02c$var$padLeft;
    },
    removeHexPrefix: function() {
        return $facb0cbc5626d02c$var$removeHexPrefix;
    },
    sanitizeBytes: function() {
        return $facb0cbc5626d02c$var$sanitizeBytes;
    },
    sanitizeHex: function() {
        return $facb0cbc5626d02c$var$sanitizeHex;
    },
    utf8ToArray: function() {
        return $facb0cbc5626d02c$var$utf8ToArray;
    }
});
var $facb0cbc5626d02c$var$IS_BROWSER = typeof window !== "undefined";
var $facb0cbc5626d02c$var$STRING_ZERO = "0";
function $facb0cbc5626d02c$var$arrayBufferToString(array) {
    return new Uint8Array(array).reduce(function(data, byte) {
        return data + String.fromCharCode(byte);
    }, "");
}
function $facb0cbc5626d02c$var$btoaUniversal(b) {
    return $facb0cbc5626d02c$var$IS_BROWSER ? btoa($facb0cbc5626d02c$var$arrayBufferToString(b)) : $facb0cbc5626d02c$require$Buffer.from(b).toString("base64");
}
function $facb0cbc5626d02c$var$buf2hex(buffer) {
    return (0, $fLnyw._)(buffer).map(function(x) {
        return x.toString(16).padStart(2, "0");
    }).join("");
}
function $facb0cbc5626d02c$var$removeHexPrefix(hex) {
    return hex.replace(/^0x/i, "");
}
function $facb0cbc5626d02c$var$addHexPrefix(hex) {
    return "0x".concat($facb0cbc5626d02c$var$removeHexPrefix(hex));
}
function $facb0cbc5626d02c$var$padString(str, length, left) {
    var padding = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $facb0cbc5626d02c$var$STRING_ZERO;
    var diff = length - str.length;
    var result = str;
    if (diff > 0) {
        var pad = padding.repeat(diff);
        result = left ? pad + str : str + pad;
    }
    return result;
}
function $facb0cbc5626d02c$var$padLeft(str, length) {
    var padding = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $facb0cbc5626d02c$var$STRING_ZERO;
    return $facb0cbc5626d02c$var$padString(str, length, true, padding);
}
function $facb0cbc5626d02c$var$calcByteLength(length) {
    var byteSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 8;
    var remainder = length % byteSize;
    return remainder ? (length - remainder) / byteSize * byteSize + byteSize : length;
}
function $facb0cbc5626d02c$var$sanitizeBytes(str) {
    var byteSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 8, padding = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $facb0cbc5626d02c$var$STRING_ZERO;
    return $facb0cbc5626d02c$var$padLeft(str, $facb0cbc5626d02c$var$calcByteLength(str.length, byteSize), padding);
}
function $facb0cbc5626d02c$var$sanitizeHex(hex) {
    hex = $facb0cbc5626d02c$var$removeHexPrefix(hex);
    hex = $facb0cbc5626d02c$var$sanitizeBytes(hex, 2);
    if (hex) hex = $facb0cbc5626d02c$var$addHexPrefix(hex);
    return hex;
}
function $facb0cbc5626d02c$var$utf8ToArray(str) {
    return new TextEncoder().encode(str);
}
// src/utils/number.ts
function $facb0cbc5626d02c$var$isHex(hex) {
    return /^0x[0-9a-f]*$/i.test(hex);
}
function $facb0cbc5626d02c$var$toBN(number, base) {
    if (typeof number === "string") number = number.toLowerCase();
    if (typeof number === "string" && $facb0cbc5626d02c$var$isHex(number) && !base) return new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))($facb0cbc5626d02c$var$removeHexPrefix(number), "hex");
    return new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(number, base);
}
function $facb0cbc5626d02c$var$toHex(number) {
    return $facb0cbc5626d02c$var$addHexPrefix(number.toString("hex"));
}
function $facb0cbc5626d02c$var$hexToDecimalString(hex) {
    return $facb0cbc5626d02c$var$toBN("0x".concat(hex.replace(/^0x/, ""))).toString();
}
function $facb0cbc5626d02c$var$toFelt(num) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($jlWHo))).isBN(num)) return num.toString();
    return $facb0cbc5626d02c$var$toBN(num).toString();
}
var $facb0cbc5626d02c$var$cleanHex = function(hex) {
    return hex.toLowerCase().replace(/^(0x)0+/, "$1");
};
function $facb0cbc5626d02c$var$assertInRange(input, lowerBound, upperBound) {
    var inputName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var messageSuffix = inputName === "" ? "invalid length" : "invalid ".concat(inputName, " length");
    var inputBn = $facb0cbc5626d02c$var$toBN(input);
    (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(inputBn.gte($facb0cbc5626d02c$var$toBN(lowerBound)) && inputBn.lt($facb0cbc5626d02c$var$toBN(upperBound)), "Message not signable, ".concat(messageSuffix, "."));
}
function $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray(rawCalldata) {
    return rawCalldata.map(function(x) {
        return $facb0cbc5626d02c$var$toBN(x).toString(10);
    });
}
function $facb0cbc5626d02c$var$bigNumberishArrayToHexadecimalStringArray(rawCalldata) {
    return rawCalldata.map(function(x) {
        return $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(x));
    });
}
var $facb0cbc5626d02c$var$isStringWholeNumber = function(value) {
    return /^\d+$/.test(value);
};
var $facb0cbc5626d02c$var$toHexString = function(value) {
    return $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(value));
};
function $facb0cbc5626d02c$var$getDecimalString(value) {
    if ($facb0cbc5626d02c$var$isHex(value)) return $facb0cbc5626d02c$var$hexToDecimalString(value);
    if ($facb0cbc5626d02c$var$isStringWholeNumber(value)) return value;
    throw new Error("".concat(value, " need to be hex-string or whole-number-string"));
}
function $facb0cbc5626d02c$var$getHexString(value) {
    if ($facb0cbc5626d02c$var$isHex(value)) return value;
    if ($facb0cbc5626d02c$var$isStringWholeNumber(value)) return $facb0cbc5626d02c$var$toHexString(value);
    throw new Error("".concat(value, " need to be hex-string or whole-number-string"));
}
function $facb0cbc5626d02c$var$getHexStringArray(value) {
    return value.map(function(el) {
        return $facb0cbc5626d02c$var$getHexString(el);
    });
}
var $facb0cbc5626d02c$var$toCairoBool = function(value) {
    return (+value).toString();
};
// src/constants.ts
var $facb0cbc5626d02c$var$ZERO = $facb0cbc5626d02c$var$toBN(0);
var $facb0cbc5626d02c$var$ONE = $facb0cbc5626d02c$var$toBN(1);
var $facb0cbc5626d02c$var$TWO = $facb0cbc5626d02c$var$toBN(2);
var $facb0cbc5626d02c$var$MASK_250 = $facb0cbc5626d02c$var$TWO.pow($facb0cbc5626d02c$var$toBN(250)).sub($facb0cbc5626d02c$var$ONE);
var $facb0cbc5626d02c$var$MASK_251 = $facb0cbc5626d02c$var$TWO.pow($facb0cbc5626d02c$var$toBN(251));
var $facb0cbc5626d02c$var$StarknetChainId = /* @__PURE__ */ function(StarknetChainId3) {
    StarknetChainId3["MAINNET"] = "0x534e5f4d41494e";
    StarknetChainId3["TESTNET"] = "0x534e5f474f45524c49";
    StarknetChainId3["TESTNET2"] = "0x534e5f474f45524c4932";
    return StarknetChainId3;
}($facb0cbc5626d02c$var$StarknetChainId || {});
var $facb0cbc5626d02c$var$TransactionHashPrefix = /* @__PURE__ */ function(TransactionHashPrefix2) {
    TransactionHashPrefix2["DECLARE"] = "0x6465636c617265";
    TransactionHashPrefix2["DEPLOY"] = "0x6465706c6f79";
    TransactionHashPrefix2["DEPLOY_ACCOUNT"] = "0x6465706c6f795f6163636f756e74";
    TransactionHashPrefix2["INVOKE"] = "0x696e766f6b65";
    TransactionHashPrefix2["L1_HANDLER"] = "0x6c315f68616e646c6572";
    return TransactionHashPrefix2;
}($facb0cbc5626d02c$var$TransactionHashPrefix || {});
var $facb0cbc5626d02c$var$UDC = {
    ADDRESS: "0x041a78e741e5af2fec34b695679bc6891742439f7afb8484ecd7766661ad02bf",
    ENTRYPOINT: "deployContract"
};
var $facb0cbc5626d02c$var$FIELD_PRIME = "800000000000011000000000000000000000000000000000000000000000001";
var $facb0cbc5626d02c$var$FIELD_GEN = "3";
var $facb0cbc5626d02c$var$FIELD_SIZE = 251;
var $facb0cbc5626d02c$var$EC_ORDER = "800000000000010FFFFFFFFFFFFFFFFB781126DCAE7B2321E66A241ADC64D2F";
var $facb0cbc5626d02c$var$ALPHA = "1";
var $facb0cbc5626d02c$var$BETA = "6F21413EFBE40DE150E596D72F7A8C5609AD26C15C915C1F4CDFCB99CEE9E89";
var $facb0cbc5626d02c$var$MAX_ECDSA_VAL = "800000000000000000000000000000000000000000000000000000000000000";
var $facb0cbc5626d02c$var$CONSTANT_POINTS = [
    [
        "49ee3eba8c1600700ee1b87eb599f16716b0b1022947733551fde4050ca6804",
        "3ca0cfe4b3bc6ddf346d49d06ea0ed34e621062c0e056c1d0405d266e10268a"
    ],
    [
        "1ef15c18599971b7beced415a40f0c7deacfd9b0d1819e03d723d8bc943cfca",
        "5668060aa49730b7be4801df46ec62de53ecd11abe43a32873000c36e8dc1f"
    ],
    [
        "234287dcbaffe7f969c748655fca9e58fa8120b6d56eb0c1080d17957ebe47b",
        "3b056f100f96fb21e889527d41f4e39940135dd7a6c94cc6ed0268ee89e5615"
    ],
    [
        "3909690e1123c80678a7ba0fde0e8447f6f02b3f6b960034d1e93524f8b476",
        "7122e9063d239d89d4e336753845b76f2b33ca0d7f0c1acd4b9fe974994cc19"
    ],
    [
        "40fd002e38ea01a01b2702eb7c643e9decc2894cbf31765922e281939ab542c",
        "109f720a79e2a41471f054ca885efd90c8cfbbec37991d1b6343991e0a3e740"
    ],
    [
        "2f52066635c139fc2f64eb0bd5e3fd7a705f576854ec4f00aa60361fddb981b",
        "6d78a24d8a5f97fc600318ce16b3c840315979c3273078ec1a285f217ee6a26"
    ],
    [
        "6a0767a1fd60d5b9027a35af1b68e57a1c366ebcde2006cdd07af27043ef674",
        "606b72c0ca0498b8c1817ed7922d550894c324f5efdfc85a19a1ae382411ca2"
    ],
    [
        "7fa463ee2a2d6a585d5c3358918270f6c28c66df1f86803374d1edf3819cc62",
        "a996edf01598832e644e1cae9a37288865ad80e2787f9bf958aceccc99afae"
    ],
    [
        "3d4da70d1540da597dbae1651d28487604a4e66a4a1823b97e8e9639393dbec",
        "45cdef70c35d3b6f0a2273a9886ccb6306d813e8204bdfd30b4efee63c8a3f9"
    ],
    [
        "1e448fdbcd9896c6fbf5f36cb7e7fcb77a751ff2d942593cae023363cc7750e",
        "30c81da0f3a8cb64468eaa491c7ae7b4842b62cb4148820da211afc4caffb3a"
    ],
    [
        "6531acf1a7cb90a4eb27de0b7f915e387a3b0fd063ba6e1289b91f48411be26",
        "31330f5daa091889981a3ea782ae997f5f171336ed0487a03f051551a2cafa2"
    ],
    [
        "54be016394d5662d67d7e82f5e889ed2f97ccf95d911f57dd2362c4040ed4f4",
        "c6cb184053f054d6a59c1bf0986d17090d25089b3fdcdaf185edc87ef113e5"
    ],
    [
        "35b9ecd0499ca1d5d42dcbb0c6b4042b3733c64b607ca711e706e786ef2afc6",
        "5624b476a5b21c3a544f0712d4817b06ad380a5a6529d323bf64da8ef862d8d"
    ],
    [
        "4ce0378e3ee8f77ed58f2ddbd8bb7676c8a38bfb1d3694c275254bd8ca38e23",
        "5a16fcbff0769c9cf2b02c31621878ec819fff4b8231bff82c6183db2746820"
    ],
    [
        "648d5c6f98680a1b926bfeb01c00224c56fdcf751b251c4449c8a94f425cfcf",
        "72c05ac793cd1620a833fbe2214d36900ebe446e095c62fcb740937f98cca8c"
    ],
    [
        "bd09be3e4e1af8a14189977e334f097c18e4a8bf42577ef5aafa0f807bd89b",
        "6e0e72ed7eb65c86cee29c411fb4761122558ee81013344ba8509c49de9f9b6"
    ],
    [
        "35ea4e339b44ae7724419bdfbe07022253137a4afb7cbaffad341ea61249357",
        "3665d676a026a174f367bb4417780e53a7803cb02d0db32eb4545c267c42f14"
    ],
    [
        "36457bc744f42e697b825c2d1afd8f4029d696a4514710f81da52d88e178643",
        "7c93715896735492a68c7969a024b3a8fd538bffc1521538107de1a5f13ce9c"
    ],
    [
        "5b3a08ebcf9c109cc9082f70d9df2b9c11b5428ee23917b4e790c4c10f6e661",
        "9d7b42ab0c20f5510df7ea5e196eec99342739077e9a168198c89da859753"
    ],
    [
        "21883ef8580fc06e59481955d52ece3aca6e82c8c9fc58e216dcf46f96990c6",
        "51a6423543e6e8a43e71da34cd90f5b520b8d33b67c4bf857573ab9e301aa4c"
    ],
    [
        "19e86b77f9b581e81092b305c852faf53940a8f15f0a6990c414f04c0fa7ef9",
        "515630e35d4398c9c79fc4ee08e1023fa47d8e03c6e7819c6d2ccef45398fa"
    ],
    [
        "888ab8eb4c31bb2ac5b54aa320dbe1a69c96b864e8a5f54d89c1d1a6b86c24",
        "730e148467f6a55ce22c5296f5380df88f38de76ef0b2de844cd3094aaaf3ea"
    ],
    [
        "75e79ff13a894e7120dac17b7429c0c32ce7828f726c9973728c0977a5f5977",
        "4960526e59c1c736561a201bc56f7d762641b39f609d273cc996f5d9197cfb8"
    ],
    [
        "640fe009249115d7254f72ecafb3006139e4bed7e9041af51458c737282d1d5",
        "3cc6c978a575246e2ce4f7ef1fcc7f63085db9ff98a1b1f3fe374087c0332c"
    ],
    [
        "6d6fd09ccab7c26de9b3906191235deb5c34685580c488275356a05e209ca96",
        "7157f81a34213dd8f91dea4f6df1bcfabc4ee091a3049eeeb3b7923d39b8645"
    ],
    [
        "5531ca1d00f151d71da820918f74caf2985b24dca20e124721fff507b5a5876",
        "518529643d3f25e47f72c322223ba60a63d6bfe78cf3f612215d9c19bf29200"
    ],
    [
        "6192d454e4f8fe212bdfccd5b15dd5056d7622ffe456c6c67e5a7265aea49c4",
        "2377a45dc630017ae863cb968ddb38333a70c7946d8684e6d7a6213f634b7bc"
    ],
    [
        "542fb44b4ef3640a64fdb22a2560fb26668065c069cf31d1df424819a39ff18",
        "5dbae9b0948e0361aea443503840341c322aa1a1366ce5390e71bf161f78f8c"
    ],
    [
        "299ff3e3412a7eb4cb4a3051b07b1be2e7b1c4b789f39ffb52cba3d048b71de",
        "1951d3175c02761b291d86b6c0a08387ad5e2a2130ccc33c852530572cb3958"
    ],
    [
        "628ce3f5367dadc1411133e55eb25e2e3c2880d6e28754a5cb1c5d109627e73",
        "ae3e9b7d50964e28bd15380400b7659b87affdef5d2586cbefcd9be7d67c0d"
    ],
    [
        "6ea54aff064895eccf9db2283225d62044ae67621192b3346338948382f5933",
        "6431507e51aadacfaf39f102a8ff387756e9b5e1bc8323d44acae55130d93db"
    ],
    [
        "28097d50d175a6235320fe8cfe138dd9e46895d189582e472c38ad7a67d923a",
        "7f9eab4133d7d09a7ff63368d6135c26262b62336eca1b5ca33f2096ce388ba"
    ],
    [
        "619fd09cdd6ff4323973f256c2cbdcb224f7f25b8aef623af2d4a0105e62e02",
        "2c95f0ae11d47eeae1bc7f1350f75f9185c5bc840382ceb38a797cae9c40308"
    ],
    [
        "641c18982ced304512a3f2395942a38add0d6a7156229c2a7c8b8dfbe9beb96",
        "6f6288c9c659b6af5ac975f4180deffe53d516399b2cc62f31732e9d4ba9837"
    ],
    [
        "58ab546e51fe49fc5a382e4064a2bd6cfc268904412f86c26de14f28a71d0f2",
        "124b7217943e7e328408e8afdfa7da00dcbc94a2bb85fd8e01fb162d2c2c0a9"
    ],
    [
        "a82c2fdedbb26c3c762a12f7e86b0e01e65320e0a25a8399d665f6e266bf74",
        "1a1de28e253f3e10f44d0111e8074f882d7f42e5900780ccbdc31da372d3fd8"
    ],
    [
        "744c725a7455a992e3cf5bd007bc234dd4668dba285f553f38350ad94c1615b",
        "7f721a87f48798bdc4a9c0eb88559e2ad7a74112fd901e70ea159e67a9c33f"
    ],
    [
        "434df142ddaa60f7881b6348d91687de40457de7ccfb07f0304b9e820705d0c",
        "7fae425e3b53f97dd1f5b20e49ed9fe24ff1efc341ba5e017ac89cf8df0cc39"
    ],
    [
        "7a1e2b809dff46277021cbc376f79c37e1b683bbd6bca5317014f0dc0e1ae73",
        "56790278a231912c334eff05281e08af1558e85516b4411ef64647c13bea431"
    ],
    [
        "4931b7990348d41cf8907be79f45bb7991fd18f8a57868351c92fa7a34cbcd7",
        "ca35091815cdf0837d396e25aad6052ad32d497a33b123256cffdc008bc50e"
    ],
    [
        "250b815d352fd89f8210b624b147ea7d0a4f47bcac49f3ac9b777840da93ebe",
        "1173f10e9691948b7da7632f328520455aadcba46e017f891e0a1d7da2bef04"
    ],
    [
        "2223b85032fa67292f6e1f822628e6756e5c3cc08fc252ab88d63d624e4dfb2",
        "55619ba96a7dcec77832fcb22cd5c21c7dcebc0280d730cba0002b67e0a8c63"
    ],
    [
        "249b131e04de73af9820d3e22492d9ec51bdc0c4c4f34d95352fa44dd61f245",
        "7576d3b5d136368ff01170a77d8286d0d1c7c40688862fb40813b4af3c6065e"
    ],
    [
        "6777915d9b4769027eb7e04733f8a2d669c84fe06080f55e8a55674dfbf9efb",
        "640d0ff384c9635e1af364760f104e058e3c86209fa9d2320aeac887b2e02d8"
    ],
    [
        "2abe3f237681052f002414399111cf07f8421535af41251edc427a36b5b19c9",
        "636ce4deaf468a503ab20ccb2f7e5bdc98551656ebf53e9c7786b11dd9090be"
    ],
    [
        "4d5cc5414758ea1be55be779bd7da296c7e11f1564d9e8797ceea347c16f8ea",
        "1a680c4c410cf5ddc74e95ff2897c193edaaecce5b2cde4e96bbae5c0054eff"
    ],
    [
        "46c375c684b30adf4d51de81e92afee52b1a3847e177403372c82109373edca",
        "1eaadc5783c90a0261306423d52009e991126b3f620e9cb6cffca41ca096f4f"
    ],
    [
        "2ddfb71f51205888118cbabba8fd07d460a810289bfdeeb7118707e310cb152",
        "1fd905d07b3933be886f2518246bdafa6f33259a174668808223cd7c28183c7"
    ],
    [
        "386f3879960713d41fdb3b1e41bbebf26b1c0e27a9a75bb1adcc1a0d3e8547b",
        "2b21498c0f34ec6f17c720334dc0f36021c2f87afbbbc8847d0bd536eb265e5"
    ],
    [
        "407eae62c6c4de3b942195afec3f45efec71ddb5e6edee3d427631bcdbf9b90",
        "436e7f2d78268ef62c4172d2ff1469028bad1f1d0f97ab007064418e61caa8f"
    ],
    [
        "1b881175e21201d17e095e9b3966b354f47de8c1acee5177f5909e0fd72328f",
        "69954b1a9b8bfccf8ec384d32924518a935758f3d3662ef754bcc88f1f6f3ec"
    ],
    [
        "7d545a82bff003b8115be32a0c437f7c0a98f776bcf7fddb0392822844f3c5e",
        "34b6e53a9565a7daa010711f5bf72254a4e61da3e6a562210a9abc9e8b66d69"
    ],
    [
        "299b9fcd4fadfc4b6141457a3036aaa68501c23df579de26df69d4def89b913",
        "b95bf2c2bb303c38bb396382edc798ca6a4847e573ce19b7b08533d1912675"
    ],
    [
        "551f5a4dae4a341a3e20336a7d2f365ddd45849351ec6dd4fcbedfe4806d5d5",
        "5865c977a0ecf13ce85ae14c5c316872080bd36f0f614f56b6dfc7ece83792e"
    ],
    [
        "7a1d69c08e68c80ad8b310736e6247a53bcba0183b9b8798833bc696a0fb6e2",
        "3ce803a20ebb3b120d5eaf0ad64bed0522fad1a0f2ce39a5c5cbae98c4438f6"
    ],
    [
        "28acacc0bc41d84e83663f02b36981a2c8272ecd72d3901164be2affb09c504",
        "7a5aee0b160eaff5b5968ab1a0304ce58c3d5ae0148d9191c39e87668229e5b"
    ],
    [
        "1f78cfdbcc767b68e69a224a077468cdfcb0afd6952b85bccbdb96d1fb8500b",
        "4772ba173c6b583284eb001cfc2a124104833f464ff9df096443e10ef3e9dd4"
    ],
    [
        "2774108962ca9897e7f22c064d2ccedac4fef5fc9569331c27cdc336c95774b",
        "9e13d79b68e8dc8091c019618f5b07283a710ddf1733dc674a99fc32c12911"
    ],
    [
        "770d116415cd2c4ace0d8b721dd77e4a2ef766591f9ec9fa0b61304548994ed",
        "42165d93c82f687635aa2b68492b3adffd516beb4baa94520efa11467a209fd"
    ],
    [
        "5e6e4ece6621e2275415e1fda1e7c4f496de498b77c0b913073c6a6099394b9",
        "3d92ce044fc77fa227adc31f6fc17ef8b4ec1c5aafc44630c0d9195075bf56d"
    ],
    [
        "6e69c717b5d98807ff1e404a5187a9ceaf0110b83aa15a84f930928b1171825",
        "1ee7cfc3a9744d7fa380ba28604af9df33ac077724374c04588bd71fa16b177"
    ],
    [
        "404318f2d2ceb44f549c80f9d7de9879d8f7da4b81e7350c00e974ebf2daef1",
        "3934831b5af70d17a3f1da9d2931bd757e6acf2893236264fc7e0d92ff1a1cb"
    ],
    [
        "20dcb6f394fea6d549b2e75748f61b7ec03b6e52319cb14163373a9c22bb9dc",
        "106a8c96cfb95a331618b7416d1498554730499e194a58fbf63019890480fc7"
    ],
    [
        "119000f277ccee013e6bb121194ec1ab5460fb6a96eb702a14079865f4170aa",
        "1737a32f5415e8720a5606ec1dd4756f02e7c6817e3723b453d091f2d192773"
    ],
    [
        "45d0fb5cd95db76d05dec3faa12e467a308eabaad363a062353db3cd2d9b749",
        "ae08691b5b0cdd19ec499132421638f470f493320e4003d123ab1da761b965"
    ],
    [
        "1257b3e65cdfb6367c6d0942327e799bc66eb221e70c6573a9862889eb51c38",
        "593309fd45755dd2cc4afd2b9316bc4638b0c5ddb3009694fcb7b250d0c8a2f"
    ],
    [
        "186dcf9950f72e868014a8accf14aa36e82a7a2a29f86ba37f6632da4189db3",
        "55684c9f7a043fc523ed78f756f834b4db823d5e4161bd79602c17d55a5cd8c"
    ],
    [
        "58791d5569f282f5c3b01ecdc9388df7ba3ca223a2dc1eed5edaf2a1d302fb9",
        "6298d7dd51561a045bb4089deda9f40b2865589ed433e56d54554f8b45e79f0"
    ],
    [
        "13fd87144aa5aa4b24d5a7bf907d8280d15937fed262d41084898cb688fc28b",
        "3fa54367770cc4479a857411ddcabe86627b405ce1cd14ad3b2863bde13abe4"
    ],
    [
        "48118139445415f0c1879224e2dee744ed35280ff00537260402a1741ec3676",
        "4dfa39dadaabecfc54ecb7a25319444f8e952782d863790e42a9887064fc0c1"
    ],
    [
        "4ad031bb9eda84f2fe5d354c7948d41558ca657a04508654721810ee72ef158",
        "620ebd5d0086b92c6009a42777b946a351c2c7ba852b57d3c9905fc337459ef"
    ],
    [
        "4a34abb016ad8cb4575ea5bd28385d2348e5bcc0cbba90059f90f9c71f86e8b",
        "4f781829ad83f9ed1e1b6de0e5f4ac60dfdfe7f23cb4411e815817e705e52c8"
    ],
    [
        "7fc632d7512aab5356b7915dca854c8b12b369ab54f524fbce352f00eb9b9f9",
        "2ce80b944fc9158005f630b34385d50c3ad84450a9e1e529925b3211dd2a1de"
    ],
    [
        "65ed10347503cbc0216ca03f7536cca16b6abd18d332a9258685907f2e5c23f",
        "3be1a18c6bfa6f2f4898ebefad5a8e844c74626d5baa04a820d407fe28bbca6"
    ],
    [
        "1a8abba1be2e276cdd1f28c912280833a5ede1ec121738fcca47dc070dcc71d",
        "21b724378bc029a5199799df005922590d4e59cae52976f8e437bf6693eec4a"
    ],
    [
        "3a99c22dafcfe9004ebb674805736a26aeed7ed5d465ae37226dcbe270a972b",
        "5bf67552af08e1e6e2a24bf562c23225e89869cab9bef8becb3669175a3c94f"
    ],
    [
        "4a6a5e4b3501f2b7bbdd8da73ea81ffca347170bdfb6776a037cdd74c560fb4",
        "5af167ebb259c2da88740ec559ee04052bb66480b836cadd0e2590c32d7111b"
    ],
    [
        "6890d95308525f0bac9dc25cc1189eb92d29d4b3fe61bc8aee1c716ac17b1e8",
        "e6f23f78e882026b53ea4fac6950e56e3da461e52339eb43d2fdb2dade7ca9"
    ],
    [
        "748f4cf4f027efdeaed7c7f91ef3730ff2f2bb0bfc2db8f27aadde947f7d4d5",
        "3a1cbc550699411052c76293b8c41a3a8a1ecf12cbbc029a1b2b6ea986fca93"
    ],
    [
        "7321f3f581690922cd0dec40c9c352aae412ec2ccdf718f137f7786ab452cd3",
        "5be5130c9277cdb76d7409452438ec15d246b211dd1e276ee58e82a81c98fd4"
    ],
    [
        "6c4d6cb7e7ae70955224b8a912ff57ca218635a2436b36cee25dce8a5cdf51f",
        "32f8c03c6db3246946e432e4148e69f5628b200c6d7d72449df6eeac0998039"
    ],
    [
        "1dad5f2e795ea6fa5177f110989516eacf8fb37bd6a091c7c93f1d73a2fe309",
        "56b2298c538180e99dea3e171dbb5c6fba0bd0a9ed40537277c0c2373a8e2c4"
    ],
    [
        "1610605baacc9bc62c4cc923dc943347cfece7ae241e746fbe6c2c878221dbd",
        "431a82d657e0d109d00dea88cf3fa9b999845221b7b5590a20c40fc71368c1c"
    ],
    [
        "6a4f5c787fb09a5be2b04d2eafa1e6f3d3c863ee22960eb0b64f6eaf6659162",
        "14dbc3eaea6146ee7eaace5a91ed9430dad3a47e9ca2f68b455171f8fe6a7b3"
    ],
    [
        "738415b73e55412b0e582e45ff0d7bf4b1bf2922db581783fdcc75559f40e",
        "33825aeb3fd8459999eb418d15102ba5864b069c6ea517f0c6e9eab8d9aca47"
    ],
    [
        "2603e72ce53985c70782774057a17944f7b4ce224a809be4e2b5af3606aa1d8",
        "92822921809c42318f42dac4d773325f41c43069e990adac7818a45e2554dc"
    ],
    [
        "181cd967ab4615357cc96c82eae9152ce7598c1a1dfdd91a458bddb016ae9fe",
        "5d562fdaeb0e12647e230e50eaf216bed52fa73c6b7378821a3bfc4cd66d4ff"
    ],
    [
        "1121726069b9ef5954ba6490100b226e0be53fef3e071b7c58a1286174b789a",
        "4b25594cf4e9eb2d14b3f52f2661a9992234fc222c0a0d44517cb77deb9c16f"
    ],
    [
        "e543663969b915337f105f80995a77b356f1a51d8b4a4fb12d44364130e873",
        "34b2e3c009fdab4cb7349a580df2e64c0098a123280078e5da6623a9ec6b44f"
    ],
    [
        "4e2f8909bb62de5ef65600e61bbf969293815296b6e23702875e049b3ce5c45",
        "3cb81f2c21f22a7add26fa38a9ce5d9cce1bb251bd2698f90c34ff0a84f7af"
    ],
    [
        "37b546e403a1ba970c17b67c2f1361ab9c803f8d2b5cd93803014faa08861ed",
        "37079184ea46272f5809b523d060686633f7995167897a153be1772fd6566f6"
    ],
    [
        "27bddca77f7bd7f66b3693567a4238f2e6751d95b0bcb409f6b24d08f84798c",
        "6417a85cbfd6fc02df560d3963a241a986baacdfa423f65d7227ce49a96c57d"
    ],
    [
        "2de71a39aa043057d1bc66e45f804542acddf18f7a6d88c0d7fb0ca240debdf",
        "306c1ce39ab46300f7cca0f3a2fbfa77296a27e24bc66b0b8044968ec0ee413"
    ],
    [
        "307c877154364c0c03534e7327d5a88e1380ceef6481567ade37a14ee7c1a72",
        "3404bc7dbfb33b95d922d0693aaf9358f77888d7d95e773c38d83dbe2e5f995"
    ],
    [
        "79f09ff7c60850e5f5ea020722659a1ed27db4c95dca131f99552f785c8afbc",
        "40429528c099349b426ddbf129497176951a64a53db5f9d8bd2be0252cb22b2"
    ],
    [
        "4027dc6b56d446e5972f35464eeac85c5254ef377c902d9fe37aea841bb5292",
        "7c3ea37689ef679fa2f5c7e031a78e23d484a8317990fd34d44d95cc1db3717"
    ],
    [
        "645dbf78a3c228c4b7151450b5e65edb58e71f37e1e4bc5f471e0f1abd6d9c2",
        "15cfe7850f327b256e23b00627451560c5c6ab60db78d45b7ab286afb6f13ab"
    ],
    [
        "1503ca373757677ad1d911a2b599d01c46eb879d1ce21ae171c7e439846a85f",
        "583eb269b7030da6a0c324026919de3f9489d2ff6ae0e6320c36f05469ad66c"
    ],
    [
        "66e1819ba3ec4ad4ae9f7d7588d23baa004e29d3aad2393d52af204a81626ca",
        "505249980cbe6273b82ad5038fe04a981896f4117345ac1abcc67e2525c0ee4"
    ],
    [
        "5ec20dbb290254545f9292c0a8e4fbbfb80ad9aab0a0e0e9e9923f784d70ed1",
        "bdb1ca3a859227cf5d00eaae1f22584e826ed83b7ccdb65483ed5213dc4323"
    ],
    [
        "a5c1a5011f4b81c5c01ef0b07c0fbf0a166de77280f0ae241f2db6cba15194",
        "4444521fb9b33d7dfeb1247d0ee1a2b854ad166cb663d9dd2e686909362a689"
    ],
    [
        "1f35335de40e00c62642dac2fda8b30f071986ce4f11db849df11bc45ad4e0c",
        "7801a2c761b90fd4477ba0be9a775003d5dfcd959b1ed198b4681f15e7acbf"
    ],
    [
        "48db4798cf6821c1ffb8178b1d3bb6020e04186c96aaf4670972d367f4ed5f",
        "781019494df95b888f1578f1b4a3f8e125ea60eca47ef9207a10630671217a3"
    ],
    [
        "17f653d904210148a8e74d8e719a3061683c164aa6d79c902a19f185ab437bd",
        "6780e97985932c3860d810af1e065d454b1cb4be0e7ffe2d8cea7d52526e223"
    ],
    [
        "5c4d0c7432f9b0070436240f9855adae1467cdc9826952ae01b68cd52a3ad89",
        "1c5747f968ed91261b7ae9bf1023c999da9816e37de602d6a1a50d397752bff"
    ],
    [
        "6fedd7639fdaa2f7bad4ca0b391710f6f8a7e890250ae8ae4252bb8b39a1e58",
        "436a215f655a3fd3778b2335ffdc9aca6b98474e43d764c1f8362830b084f0e"
    ],
    [
        "7fbd45a889c5e9d127bb4f8474d6be7cb9796bbfff923b75e42a1ad4cae37d6",
        "484bd12622a6ba81cd53049c550d9ed682a8e765b656b1cbff9bbea637bd1f4"
    ],
    [
        "17d984d47937263f7966a3e7b1eea04071e678494bd749c9e02b48b3234f06d",
        "7b341ff08722c4e161005d0037204a7a2001fdda7af2cc1a0b04a027f115a0f"
    ],
    [
        "7f1822045db45ea07e1519c3ee1f7705915f35fe4dd8db1e8921b5d1c740edf",
        "33d41e06b93320ad1b3d9580380ec797a05dac3f1cc8008899110ebefde2f78"
    ],
    [
        "7b19453ecb74b7d0e2a66b9890ff73bfbbcd61a266abd6d82dbe665bf32f34d",
        "6dba2355420dac582b1f349609ea1c89b89bba2d1a68a0642f1dd12d86e73cb"
    ],
    [
        "273e82a15f395ddf2489a95685bec8bac62c4b459d1b28987d3cb27e4bc9128",
        "653375b48a4cf5d5b101c9ef533039bedce5dbeef3f59e8f168bdc99b06ca5f"
    ],
    [
        "3006c9e7fc6a553d8eb4e8a47ce9f10d1a39576ac255ae9e0a4ce3869e76212",
        "65fe9e2ef2aae608be309332d464f57e28f1df5de1a6a519751b056971f932e"
    ],
    [
        "5e8f384c8a4607fbe9789fcc52d54249d304d698562597d114c1d81452d3dee",
        "3c8bc78066b5d947dc1e405e326ee55ea606c7988f666748d259850fa259a22"
    ],
    [
        "7841b2102e9aa103fb53a642b3e167b21113ea44751ab38e0b5ef8312654db9",
        "71bf5c8308fcf9c4a7847494cd9bdd946fddf7d3a37e8bb0b201ff2343deb8e"
    ],
    [
        "40f68027420c11e3ade9aae041978dc18081c4f94943463aac92d887f922a62",
        "499c6062594a6c7e21a3cb91ea451813393bff365a27a08f1a515439b83cf42"
    ],
    [
        "6ce77a50d038b222634e87948df0590b79d66087b01e42b9b6d8fa30ebb1465",
        "35f5c46bb1be8555a93f155a174d54ec048c2ac8676e7c743054ddc52709d37"
    ],
    [
        "604f8b9f2dacb13d569262864063c2d4bb2b2cd716db6eeb2b1eeabc57746f6",
        "68c6799e24f3b44eec3049973445174727a66970f1614a782efa2b91ab1e457"
    ],
    [
        "73d620f3bfe77f672943d448d7dc05327adf64b8e7af50039c469d7f7c994c4",
        "4859deb36eaf0c802f0d1514602368143a33ec6ce8fd55248b59025debc6afb"
    ],
    [
        "3fd2bcd1c89d706a3647fbd354097f09c76636e93ae504973f944d8fc3bcc1",
        "677ef842cf5eb2444941f527abec567725e469469192354ad509a26ebb3d0e0"
    ],
    [
        "39222ea924ac17b533c72ffb2c47ffdc11d6a7f7c70fbde3a10fb0b8f35eb2f",
        "20dc4bd1089019bc1d7379b4feb3eae6eb5af59e9f253845da9fd633057e952"
    ],
    [
        "326f58994e1347f62e4102183215b5db956378d2f61f14aba4dec94577f53c",
        "7a03284c296003bbe05178a1d82efdb7b8125511d63e20e50aed789c2e52e1"
    ],
    [
        "53aa8939c74d4ee58f03bc88bace5a45c7bfcf27466201da05dc6723a5f5632",
        "2e32535ca7732904a048183247b04b426ecf9b39fc393a9cebe92fb1dc7a7f1"
    ],
    [
        "6cee1a03145e93b3e826e6067005f09c06099c98198c91c222407ba5c8c132e",
        "beaecad1274e7c6e5476a100c271aa1a6f86ee5a9fa5c2f26124d5886fa63"
    ],
    [
        "3ec659b8175e1be1bd5a252108714776b813e330393f587814f5f1f32a73332",
        "529a5cf9f8c237ae69a94217d173c8d19c156952041f5c980da557990863fa7"
    ],
    [
        "3d66ec5963d0c534d4139c8cef2e1ac48b3e7965fafabf58be26f903318af4e",
        "3d3f2de7a95f59b683725ee6283cbaf31f97c4b600df9a4621413223a468740"
    ],
    [
        "7fb38ace8e0932fac2ea0d3eb676db8d684db1817e2e4d59da7996ce398b4a",
        "68f92bd5768cdd4710249f9d49ef1d5654e497b9a4ba10bd2971366d83fb400"
    ],
    [
        "1c4a49314d6b4969cdd142c76ceb7682bfb868ace7f7568b0fc8635bda5a9fb",
        "5fc0519f1f4cc10b5771312458748c036313b87707ed0540026ac64a5955aa9"
    ],
    [
        "3073c95d08d3b97caea5f0be16b2789bee766f76b7e5499f8ce8f96abb0f344",
        "52a8974b4eb9a1f6a0ae2c83cb4715bf18d73f057255fcb3f63b74f7e78f590"
    ],
    [
        "44485b16d597a5de3604df6f7ed7e00b8aeef9e7e8dea8688255153b8bb16aa",
        "6cccb0ba170123266f24b5d93a744397dc2c44820edc4f8f5b9a0f5c9b3b940"
    ],
    [
        "7618f77b7b32d512688dd62e0b48231d9574c6361e8be353a7dc04f7c3a115e",
        "78ffcd16d80636381ca231aae70d99c9e20298b4f5388fd823ea9fa2b8ddfd9"
    ],
    [
        "7dc82fee1ef95cf5b3720fcc07f63246654bfe39762627839da40e51c75654d",
        "4c0ccdd70955da74558de20c88352df8a02aa97e4d5971c500e884740a8cb62"
    ],
    [
        "7fa5d460dc10cbb418b444d9bde97e92c70a99a222b99f244dccee7e62cc04c",
        "636163901baa5b7576c38c43407af578b8c4607e01e86011ae2dde587a89f84"
    ],
    [
        "758930d46006623a756c89bd0cc378f6a3c1f43c9a0edbb42274c35e75c16d2",
        "1d74dd9f81c2fec811b8cbd6168a745b0a111932b2a345265ef2853b50b6245"
    ],
    [
        "7332ee0626b044d664ef228f8cb84df7c643e52f6a2591ae1c9007ad61ec16e",
        "229bd8e630572cbdee54283234cf3e9f060e6382f99943bf234119d47b54470"
    ],
    [
        "78a16ef803aa20a075bb2f66c61bb2dae5698bebb94a0995fa74c3d53de1614",
        "246d588b68edb6fed96c128349908c42dcd64c46341b205e79f4aed9b5d3675"
    ],
    [
        "6e1933939bd03b67bba753cc0cbe7d2f25bad68c993887ef8c9e2fcd59b0647",
        "599413f7c204a11a5ce315eab11299ab7326603412bb00bc1c59ff75a37d6b4"
    ],
    [
        "4a79957a5a1888ad063b51c69565a2b48e8eb917183e220a1c8d3374526d30e",
        "1f092de0e069bba7fc5386e2e9a114c1618f88c4b95e220cd35ffe96f99fcad"
    ],
    [
        "3148aa3df9ece39aca84f59489f2710522216f14be6055ee0027529d1d55e2d",
        "617e9a52a92975db0ba1977f71116f7058a0d31b869ac7f3ee2fd80b0c5100c"
    ],
    [
        "5c1188e72384160ae39d07328346cda4f6c12d227448e6236f04dc971625287",
        "1643006eb3a3bc6aafd5f685cf054f2a572e6ca58c0118bcec0b833741f116d"
    ],
    [
        "3f72efc93c9b71adc4c51d8fc69d3940b20d08733af2b7d05140fdb1d1c1004",
        "7399259987c8f4ebfab46e522380707e58427d3962ee0c2a91760813f76d232"
    ],
    [
        "3129b34c03c51aa8f611e91d5cfcc9bd3ef108ee66e6d3ee35a0e0e50055bb",
        "563b18b5650085efb4cf179a029e6afff27b1d3091cd28eaa68d24fa1f801c6"
    ],
    [
        "16eac0f9fb4c67cf89a7fa4ee615bbe731d8edcb709a1b9b50c7d873a530f52",
        "7ff8288b6e199ca8f316192881424a37fb080c29daa76b1f0edaccaf580a80e"
    ],
    [
        "75f6b6028c43ce832f65d7e8e620d43b16cba215b4b94df5b60fc24e9655ee4",
        "35e9ccfaed2293a8b94b28de03bcb13eb64a26c831e26cc61a39b97969a2ff0"
    ],
    [
        "3c6152fe093bd6316897917ec56a218640ec1b2148f21db9b14fc7a5ff362e8",
        "6eef2df27ae7d63a28856b07b73e7aad7ca94f317201a1e675ffc6f9a1710dd"
    ],
    [
        "54e01b5fe4fd96052aad55b3f26b1d254dfc7e2525fffb9ae0a77eb8cc5579",
        "7c3d39232ab333675b219abc766ed9b4782c840e6b046614dedb8a619696eb0"
    ],
    [
        "d1e63f8ea8a76429cf254a6d3b668761f0dc572d4bfac4fd56d9eaf58fb6c0",
        "2bd0a84d3908a63085824c9329a0983913006ba155b56a58eb3f9becab29c45"
    ],
    [
        "2d6122f2a702edd4da7385b1580796a71d13bd72be94cfb3fec01149c006c2d",
        "70eb282fae992efa6f5915e578b640653549f23385ef3a29ab29b1b9b8ad63b"
    ],
    [
        "752fec14beaadb5ddbba6b3a17fcb86579fa588ef407fad0ea07dbb22a640d3",
        "3feb6728eca21a1e84e8f9f23010387a53a96a1cb62d86fb37996150a1299ef"
    ],
    [
        "63f94a92f27acde8f5ed949b459506f51d70c85bcc61a34d647264ecc53c65e",
        "37e5dce0646ee66f4fdb93b82d54d83a054948fa7d7fa74ab6b36246fc7383e"
    ],
    [
        "d6aa909287a2f05b9528690c741702c4c5f4d486c19a46c38215f52ef79c7b",
        "5ebe1128dd81093df4aca0df365d58adab848d1be1a94b95eeb649afd66a018"
    ],
    [
        "12866812b3053e2f7a9572bdaf5ef2b48c6fb62a0eed9ff0356df50e7d05557",
        "6785f7eb2cd1c120e4c7167b46861d10117040a2e9f2ca86a71e9d67df90613"
    ],
    [
        "46a730d05330b1b13673cb8a1b8f45460035e4a9f1a1751cfba099c4355c1c",
        "76fb0ec6cd16a8141cdcd875c8b2de9fce42d296072643d148ac7e7fa7472df"
    ],
    [
        "4bd4380a22900bd34835e0a908eacf4b6edb61eda0cf483f9212453b37e7516",
        "5e9551cd20d8d7ddbf4366880b7d5267385afa1966ff30da4baaf273b009d29"
    ],
    [
        "71f1994ad40baa2922424ae222663a64f93d8b67929e9a10f9e4c1ab19f3833",
        "85320fe68ec0d37cc19fdfd03589d66906ffa4046c80e1b094a85f27676346"
    ],
    [
        "5a63b1bf5232f28f808765c6be7ce1f81c52145b39f01c879fae0f4303bee61",
        "3bc5d6df68bb6d0577bf9ae2ae59ec0e9b2dc7dd56ea179fb38a41e853db950"
    ],
    [
        "161ded55ff1087032381e6c1449704f63ad2d88df82dfc44a71890fa09b3941",
        "78a52e0013842037274ea75daaf8eb4afc04ccc4b07bfaf3f5ee47d165e01b"
    ],
    [
        "1bfce5229c5fbff5c0f452a22317fcfcd9262f23df41840f84fe7d44cfba1a1",
        "66b387872c00e63c73006a955d42cf49c46c5708fc9d1579b9ae38341b24a3d"
    ],
    [
        "56d47dadc9cbd1dcb2ee3efcd5d4af5e6aea71df10815c68b54a14e81d11b44",
        "47e966ba54df48e9b612a903685e0060a67e4725402e8cb4cf654e54e813a3e"
    ],
    [
        "4b1c44438afd4ddf20a2cf612df2ee494ce84c7274c5529e857693e73018491",
        "430403bd31d8f0677e06abff7159384560f27b9622943fea1a3192f14bf40d4"
    ],
    [
        "7f7281728fc2214aa1dbf13176a4624b53814734abd570eb6ef7c7e32379606",
        "312da47be347fb3fa2c9089b38df372560dcace2effeeacab4d96ab11567295"
    ],
    [
        "16a28884a1be8183e0d3fc0db84a9afbf47126fd3be548c2a584aaafbfa7dfe",
        "7c3f57b3b895564ba562c1cd80b71fda6d2e611665c6ab87744f5390858fe24"
    ],
    [
        "323339f37b327a731232a9580e79952063c7c232bd1380146d8a83c285f4b8b",
        "4f16be1d983c7232f92cce6b9690695978d42cecc8eeb8c206e125d1098a265"
    ],
    [
        "624d26cbaa197e104eb83cebf2adeed09a5cdad359993fe5e3529d4d0def21d",
        "261b7da3cfb55c788977e0d8d640e3e93ae5a325d962ce85c816d7d32cfc430"
    ],
    [
        "f24ecb7ee83a3e28dab54a330dc93d0429a7aea36412e922dce8fbff40d60d",
        "b043e36a258d1df1d21b0cc7be9c4dcae1bd4ed326c110e668ac23d86805a6"
    ],
    [
        "686cea46b710bde1231483bfdbc700cfa3da6ecd5841c0e0c782f9ea24328ec",
        "7eb7407aa58edd6911c7c7e8d1e03bb52ead4a2415a0c33325872ff3a521dd6"
    ],
    [
        "3866ee1186264549df3dfcdf8705c0380c9372eef6d4081c2454d3aded1720e",
        "634c6d3e8eb8af652a4be73e3b613452c2213104ca875b66b4b15ee5b1716af"
    ],
    [
        "484c687cd2969a1d20a58cdfb9a60f280a473284503b1ecff5de514aaf8206b",
        "34d44d26b7427e51a646d1b924084762f5b461685450f21d6a472de565bebd8"
    ],
    [
        "203561333771fa0fe22c4033349f7b877d15b0542a5598e81e067968768247a",
        "2b6a533aff6e2163a36a2a89cb7415848bef48db40f952ffd380f47676707c2"
    ],
    [
        "2ffa6cca6233695760251206fc5e34c8d3692498589478cdd3d5b09f0b7c05d",
        "6c57d605478fa9626c4ed769554d075daa53e1a1d0bd4d94174d3bfeeb11ad6"
    ],
    [
        "5dccf0fa46a5571f204d0b033b45f299cbb3d9f80fded57253ea4f1c64faaef",
        "30a38e131ee8756ee5ea2a3e16618a5dbc28b5b9311308bf037ecc2039dfc7d"
    ],
    [
        "57b0a2eaebeafd950221facdd24790d7d1ab8883e5c5d55635f0d14a1ee4741",
        "7b41cc478fa6be38417271db8ed12efc0da6982552c1496025d2df0576bf4ad"
    ],
    [
        "611b5725101f611c387ccaa13889ecf3bb5595071a179ce350029bfca4ad7f1",
        "3129755977abc8995fec7eec1123a1561e429fde37ff36af002d3211831ecf4"
    ],
    [
        "1c06bbd0c52fdab9fcaf680c7a93fb821e538a2ed79f00f3c34d5afb9ea6b31",
        "3873d3bdfe0be0157bbc141198dc95497823cc222986d24c594b87bd48dc527"
    ],
    [
        "275cdbabc989c615130d36dabfa55ca9d539ed5f67c187444b0a9a12e5b7234",
        "2b7f723e68e579e551115d56f0ae71a3b787b843cc04a35b9f11084b006521"
    ],
    [
        "6cc702eb20f8b5940c7da71f8b1801f55c8c2d8e2e4a3c6c983f00bc1ffdd95",
        "5d15b3727bc66f3aba6d589acdd139fae115232eb845abe61fbdfc51341352e"
    ],
    [
        "44defb418700cee8c9bd696b872adb005490512d8bba081f8f99a9f15cc981c",
        "3b2072cdb1d919b2b65b5cb3557f0a3381d7ca293c267ca4a38f83e77bcc96e"
    ],
    [
        "fd83ce77b1578b3a9b8c3cbeaddb1504d2fd4a19c901c21ac65961224e4966",
        "110cbe64fc10c6b9c66f15ca406a35f50b723b35d83c5eb9797a57f8395f4f9"
    ],
    [
        "9dc6ff90e341875e113bbfb507724dc7095a280d2f32cb6ba61a1e0c2d2aef",
        "4aeb622896c852c2747454e8f172c9482955a42ecbe522d6ce07ecde79d0a51"
    ],
    [
        "71c58b0e47b9dd9107ebd8a8c8fa9f0534e78231bac612c1ddc7a94edf33eb7",
        "7f90edaf4792bf8334adbaa0f4ee7c654312725af188682d75f34874c4eccb9"
    ],
    [
        "1f6de1f14988778ceb2dfe844f92394f1f1e72fd1581ceb3bf336c95ce50345",
        "4f6007ed4e022d2ee9fe4ca8207c5f6c766c4f3b85260e941fb24ad0dcbf0bc"
    ],
    [
        "3ddc3ac25ede4a67a97547ed27dc920239b585fb3624177e2e8d59eba678115",
        "a9afd8f8bb759cbd1dff2addc63f47da4ba1291ea34229c09c0637dc5c8d24"
    ],
    [
        "c56b0269d8431556e471cab9d70edda3a37b391696f107b2dc370631de51d",
        "729c52f6b134f733eb750c14bd9f95c077f0f6f6ff4005701e5bedc6544599d"
    ],
    [
        "44d32ce19ac6807cb22e4f25fe1486a36a13926f147fbfa054b63ff0446177d",
        "212a21e8c124c9cd37c80d2dd66913ceaa6b6f666522f115c39382b2d5925e8"
    ],
    [
        "35dfc16f3ae6ccc06a267bf6d931601e52f3e45359ffc513570b65b96adc4f",
        "74311d10f4bece01b5ae65a6affe5c931463aa1b73a3320eeb41bbb7bb1ff62"
    ],
    [
        "e0acd9d2d907031b319b80121dc90699d003d220ea785d50e5033cdb3b1a03",
        "3911ba78d6e507485d6374b0f7d2e6198f6462a7d6d3cf046404a07af690357"
    ],
    [
        "3c57918ca254c0cb7dac251ef4e10c7d82327969552eae15d26c4c52660922a",
        "5fd5f5ff3f14e671548074114c72c48409df8a2e71fc8aa3c8acb506e2a88df"
    ],
    [
        "222ad8b61e219ba2b581f606b7c996516850a46a3db72fe1f72b5a9be6c324c",
        "72015a5e2db648112abd284fd867b59fc5606645177d26cf6e9a655c9912d42"
    ],
    [
        "3c86d5d774bc614469768ad38f7be9a53e9a233942c5c553b82e49aae684764",
        "480febea8229e130dedffff89c11f3c43e11724e6bd89d5566d78752859d41c"
    ],
    [
        "adb73bb8352d0c10175df371f7868ef2c9e0c79ac788430c480c0f7d85c187",
        "60b564785248111502e6f39c4994d6293fac22bc25f4d764b2fb1957d3c9bd8"
    ],
    [
        "3836ab8b46cf4f453a22532c886940b982029b29c42adca90ded5bf77e6bcb9",
        "7b15e91d6355f147b171a90b064a9d8b2d7bf3699bbf4987664c61c950d8996"
    ],
    [
        "12ed96af1a97c45ec31f1531e96f6fb28a03ba52ab8484545fbe0dddc97bb32",
        "6d1f522b6c6cad0940cff8e23decc72bb8d4164696af031415508b025aa8be1"
    ],
    [
        "27382994ae5878223ef802e9b4882f481a1b4008f1eec8484483471f7aa742b",
        "c31750d242b3975b0026a0e86ccdd17d0f680a8c6f53f197fc25eb1f777917"
    ],
    [
        "431677eba3715455bc235557518a74f3b111a88844ef13e159ad44bc16de3e6",
        "30000e1eb6a17d9df776981e65c6e500fded1ac12003adc9446b269812c9197"
    ],
    [
        "4b563e6f42589671579eabfa2cda5502b361c46a5ac8d45c8ed44741a925b33",
        "627bdb41678443fdd1aa607709e9699b652308615f4bea760a3b79ee0d9ab5c"
    ],
    [
        "2932fd3f81fc973ca9def6b7f1bb50f980fe589187cfe9e9f52ba4d356cf2c8",
        "1e6bfd00fa976c4770263a227048214c38850fe0f059e7b3d2c7871ef07d68f"
    ],
    [
        "e44e4f3d96d9dec775b996be57e57fdc28e7c68023109b221c414a244a0dbc",
        "58b1e52fa274812e5184e00e9ad812bec2463140adfb4bea3b2d665867dcc9"
    ],
    [
        "7fcb89be1f4bec745887bb891e53fefd665c53d00a9e74de16b8a7e1f7adfb5",
        "74af0b06633f779897e199609c71cc5649bbb65bc2c0abd4c678f0480c198d1"
    ],
    [
        "62a381ffb904ea3ff4d451d4c8459457cdbc3dc2fd2da646a95d8c1e90c0b7b",
        "1ba058658e09db9e319fa73de8ab4a992b71e4efc22c273725bdcab84e2a315"
    ],
    [
        "1b0fbb7a84c67e668450a54449c7a46261a2d355589f8b84ebfbaf9a77ee938",
        "44f8fffa33dd33a6146c35d196595e22cc4a215f61ee9197cd751400970a1b"
    ],
    [
        "78fe920bd96a356d4d95ee34adafe8fecf071d3107c36f047b4024ddc4b3eea",
        "6162f29607fdbec10181fbac6e57d5cb41b922c5791fb24bd28bcdd75d16c41"
    ],
    [
        "5629b849e026e65d119ac11821d7ab7efd9c52226f75c7427505d6818bb0c8d",
        "1539c0f90970ee8b490e45bbe5568170e5708521a0e59f976be680595906feb"
    ],
    [
        "62bc853f349bac8c6e5921d27ba85dbd9ba20a375d70a7bc008928f3e123b04",
        "6acfeb1de05ba43c3ef1a9110a983a320e77b3ca294abbc04aeca19b194f26f"
    ],
    [
        "4cf4bed663464418285cbae359b5d84ec76b5997d24f3640984c7663421190f",
        "941f818e3e3e8fb1568da85217d17f9250ebc948379014d900a7b1a848494"
    ],
    [
        "52ff3d9ffe9a302f6dfaaf74bab57c08027d5cb699a69b30830540c0a2d47a1",
        "987dd8876873778d933fbfed37aab2f7d6f669c37024f926b1edcb2ca55782"
    ],
    [
        "1109ee32f0bc53de6bfa457060b366e909d7c18061ec9845f46ac715496897f",
        "38f36f172bdfd454b9285f86e6bdece8fdffc95182c7d801b03c671cc55139b"
    ],
    [
        "4b4482f1d84efe23dadf3bb10df3dcaa251312dcdd604f616f1eb540e1f3232",
        "7c9c149dcae9135f940fb54482f9c3cd8193721643a6e23157b8020410d439c"
    ],
    [
        "69cb459b9e415b7581ca163611c470d875971d5d7949de732d1f0f200544a73",
        "a7136fa9dd00c0469863b7def3f83a5611ed628810d7e807e7a873da5a9897"
    ],
    [
        "b66a4e32ac9a4baa8f64780acd94ed3628b2b0ea874ba4dece629af65f9e62",
        "24328ba9996a24389658e3467b8b90dc3927ef8419fe28b3f55b1c1aaa51915"
    ],
    [
        "5ecc3080062dd451236de0e4eb91c5c75100733364bc5469f5fa76f79021ecb",
        "6da4abb9031a27b5be94529324fad8026e7d871570780081b0f424d4fe543c9"
    ],
    [
        "1e3146f00880bb22486d5bc73e54367d54251f4002bcf342d0393b05a4b9ce0",
        "23b6fb8e945d3205f633ba724202db5a99305f807137edf942cd60eef867699"
    ],
    [
        "2e1da8013285598b899f026c6974185db12c97b4c63509769d3d4ad1d18a4e5",
        "1e7e7b668674d1593c39d58bc7bccbf568208732b3519bc2cdf93db34366862"
    ],
    [
        "d26c3f389d81709506f184b53871497c8d36c5c9eee8e3737358204c1acba3",
        "34649c3d39f3b825947fedbca215ae30c5a5995e93b1c8efca4944cf85a082a"
    ],
    [
        "91300478a83595d548f32f259033291fc7d083953b0b8bde88c7559660c563",
        "e5d2bff57fc6551e9b80c06ac7314a71907cdcc66ce82f2cce721a670df10a"
    ],
    [
        "1f7abcb9d462c63ffe92aa56619ae8590089cca4d93ee3e5f34a63882452cc7",
        "7e9f85c7b7ca6e9a4f3a026d1048adbeef69ea9d876c6f647c257b879a81bdd"
    ],
    [
        "4d2caa1323012e4c83b0ad387308b8aef5637bc35ddd882e7f5e41cf2ca410f",
        "47150e808c81a540b6f8864e9d6636589cacaa516f82caaa96506edfbd6f0e"
    ],
    [
        "3c10a6083c38351deb3e6d1b386827d0acf48979b66b95249eb8700ec26b069",
        "47e34bfe561d903cffdd1d849b85aa3cbd31cb4a9bbd8cc2e5fd2f95016cabc"
    ],
    [
        "758bd54868eec045d0b4d3d2bc415d24bce13fee47cefdfda46425c109b657",
        "3392a7c66ea3bd7b044680bbe9f78ae86752097404c067e9d2572f55330df83"
    ],
    [
        "19e718e0ca1d2d6fadbc6006ee7dda7a385430e29f5e239cdd4bb7c3fdcb2f8",
        "5c68249b7fe03ea2e13481a63b6cd4bf74ce42009a89fee0b3f8f968b3ec709"
    ],
    [
        "28077f57ea62401806367e6d54fe45d02de5b072db787ffdcc3854e12a3e855",
        "14f3762689072f5fb41d03e94b01808c739f6d42b7b785b0e464100b150efd2"
    ],
    [
        "3b8a8cefd017363ce867265af3293cec081fa589fe561830f0078778cbd338f",
        "69ccf2383cb7b4f9c806d72535812483e7c5e9a1a5928529d64ca7e085e758d"
    ],
    [
        "77878f388d22161a2953e5aca6bac1ea480e102f329574b4b201640d44a296b",
        "7eb35706a90a03aff7c2fecca72659136547cee98038746db5aba16fd7178df"
    ],
    [
        "97332e6da70961f2ef31b7b628f1018d21db8db015922a301fca7d6fc6a8e6",
        "2e37b06f639fc7a82601b744570a2619e543cbfaf60e474107fcaf4686d3223"
    ],
    [
        "a81518d452d3aac48bf0386c3ff170ef4e684a4def242c964e129c64f4d647",
        "37506e44c85908ec7b7adda9547fbdcc2e3605151fefa77fbf127ce3bc938f2"
    ],
    [
        "e80336b2220b1d666074f6b0dac85353d0e4c2e8bd0f37055a2236a6a9fadc",
        "1cae76d73eda7a5964c5d9d3ad6748aff51f5543c56441d2fdb7b444a39846a"
    ],
    [
        "2c01fd8430ecb44e066f352c4f697fc9fda177dbe162f82862d7b9ea8c918de",
        "6e1dfa99640fdf5b30603d34c7c97c1aa6e6b7f3a2c52a21fc64b0fcac7d591"
    ],
    [
        "744e37b511cd0ddcfe15f3581947014c159de81ed055d15a13c7a2d1fa39f0f",
        "685caa8ff6979a6c63640ac638a3f9c75737f2031bd55322a47384357af164d"
    ],
    [
        "40e627ff84e1a7a9068b4368770f5956128a4d9e9e33e9cf5e24d9a242149fd",
        "2465bd6cb20bbdf810e2bc5c3c458cecf4f3aa163a7ac99c2579e5f33417f2e"
    ],
    [
        "5f635af7f554a17bceb6ccb6e637abf89ab6dadd399189b0a0390e87b1896bc",
        "2aa6238a69f89665646c0e3ca2ba5f709cc6e14351cf71e1b00ec45201417a2"
    ],
    [
        "5edad3063c9fa8305978d7e6a4e037c9fa519b8023c7608dfc3b66e5c1e8985",
        "49f405d07d7d01919da51159ecdad1031a5ac208c026fdfc14d38f633d92183"
    ],
    [
        "2fdf2e8a45858c12926a1f25a62255fb2d02d0149a15ef669f859806683e649",
        "61cfb686bb31e2524470d4ad2ae09e3cc91b16305a21d748098feb1d8ce3b3d"
    ],
    [
        "ecdbd7c37f1dffa3943977278da3bb429afdf948b4ea6cdebace3d3be82381",
        "190b67fb34f7f3ad6afd3d6b6427aa327547d8ac0fb4deeb0feeba1f63d6c60"
    ],
    [
        "233021b483f578dfa5222f8cccba5766ceee0ac65f6d4a3b1673b302a21fb3c",
        "7d4b6d44d175d4b593f06f5a6dcba2cdbc4eaa2097abaf613123546866cf4ef"
    ],
    [
        "42db4e953c2a7a743de9fe20c5798f2247f51db4eabc6f40e86c13909a310ce",
        "12c1a0764a0b9f3666e431923ce15e7fcd0ded5ab153f0b48d362cca1604e65"
    ],
    [
        "30d539e2b545fb957e40e2255f6463b52d227c9808472cee6a3d521aa283a44",
        "5f9eccf747fe6313570f99e845db32b40070acee9ce9e34da7f3c29ca53a07a"
    ],
    [
        "4bd64e5ade3e2733580a6116b4af328751198e7128f9acfe3a3496b545efb5a",
        "4d584768900dabfc0dbaa086632b8051bb3905ef79b84d96c01514441d0cc93"
    ],
    [
        "62d6e771f02e591557197d13c3e77dfa2d1794ac1808407bd8227c4be31b466",
        "5c6f5607c1808e899ba36a425911fa8566b7ea9cc80de8a80538c0fceb837c0"
    ],
    [
        "5ce406218cb2852b1d2fe1836b19462f664631785216e87ffbce26030e2101f",
        "5225f107743c255ab50e7be4a090fe39478d1ef4ff558468559d8cfa87bb94"
    ],
    [
        "670286486e8dda3dc66b0ed3149be7697d3e06c8279844079daa7e42d5af728",
        "26becabe7430380c56e320f5ae3329569cae7b0af06fd5327ee23979d200eb0"
    ],
    [
        "3ef448df33a4394c43e93e5850cd0c5a6dcb18ae1cd865d00fe8ede9336a9f5",
        "56711f6ab7e0e4f7365ac34e284ac2879f40208c46f6febcc1dcf7146ecf015"
    ],
    [
        "4b63fc130288e92f2d6ba238caa7a6364804e29829ac037c57df32fbf762bc3",
        "1eb8c80af55278b4113286c038fff2bfad2da62763bb03426506b869139da0e"
    ],
    [
        "4e7e998557b29a95f805a6e2e26efc1e970108272d4755738c04f28572295c0",
        "97cfcc2f447bde61bde71049d8200a74a3028b21703bc139143d81a3623f09"
    ],
    [
        "574b67898f02964c408f68e9470e7b615be037e40b824e6617f89cb56c21219",
        "49392d5f8e6740a1b0b7444f56d7a17363f8656c6e4c628678c86223f2e46c8"
    ],
    [
        "7e8cb50ea5d5c1b09e219e7305bcb601d99b6d7185b1c388aa8e36fe1e56554",
        "47fefa308645455c12ccb5817da338f0c4f423b341aff4a9d158891a4fd69ba"
    ],
    [
        "67266dea9e71b4ed2bf24a597a823dd048cf31e725db511edceac72998c9ef6",
        "39babd65850befde1f7c28e41dbdbb4caf82bbcf3bcb5b33161f1c2960b2d8"
    ],
    [
        "63e99c2cb9c74eb9227d48065e27abb8f606df8fc83b2c44e4ea38b046bad2b",
        "60494a53dd13ecf34e08079d343c88fb655d6d810785af81f08d5aa9bcdcf9"
    ],
    [
        "3cf0600b0f5a2a4eb78c487cd385350e8c7848e3f6983231881d7f1bbe28543",
        "56dee4288528de609976ef6b903b652127c37b0590e91a2fdbebc3f11df2628"
    ],
    [
        "758f09245fa4b8b23d290ee2b3bfcede199b4fdb11f3cf2502a8ceedd61b129",
        "622d9baadfde781e985d9722e0a04715666769a4cc7a9bea0b96d6386be1746"
    ],
    [
        "38e1a45b81492aa95d7abea2b08b8c14dc0b8a41108b036871fb737910ae18c",
        "145c611262656385e5ed6243568cd3f9f59dbfed7a01ba11e22bb8bb272e08e"
    ],
    [
        "206e54ca53a2f155bd4fc45bf2edb77798ae6623defd4cf22f2dd4a7d119dad",
        "6c94e7f0825ad81680e4cdbcaaaf4df806d57a0d1fb2331926c3fe2b79d22e8"
    ],
    [
        "56e98d2862893caebf66180e84badf19ffc8b53041eaaa313ae7286a8fac3d",
        "526306f9c01afd6e0c1198ea5de17630f5a39c4ecd02d8e6f0d613c355995c6"
    ],
    [
        "4fa56f376c83db33f9dab2656558f3399099ec1de5e3018b7a6932dba8aa378",
        "3fa0984c931c9e38113e0c0e47e4401562761f92a7a23b45168f4e80ff5b54d"
    ],
    [
        "450cfaadfecdb8a2fbd4b95c44cb1db723ee5ac9677c9c188b3d7c8eff4ca58",
        "1a552bdfc0c81be734f1f6ca9a6dd3ab4daa61c11fb53ebb7046eee25d617c7"
    ],
    [
        "6fe20e5c8a8004e33eafc84d16ef770f2f0b7bace19adaaa150f987d295a34d",
        "28a35040a2ebe9a14a162d3208d5eabc6e2f3a8310f926bd80be65aa71775e2"
    ],
    [
        "1bd65f45a35bf62ae8f9ffcbd7de2976b90518b6820c219f039c50043bb1edf",
        "fb5f0f8659f9b6ed7cb0ddd7999506d0c20b26bbe69d1915a31842cfac41eb"
    ],
    [
        "4ba4cc166be8dec764910f75b45f74b40c690c74709e90f3aa372f0bd2d6997",
        "40301cf5c1751f4b971e46c4ede85fcac5c59a5ce5ae7c48151f27b24b219c"
    ],
    [
        "21cfbc678f5a279ebb6ed124273c8df37eaf12a2d04180403ae6b5ec0b1e1ef",
        "4478ed6a346d899ad7b0b10350270aad39ddd5b68529297e4c91a54357f0a7f"
    ],
    [
        "350bfefbe3d864eaadac9cc1195c14159bb736be743aed7380d2384cadd2046",
        "5e2a4b3ad0e1d7b9b8ef72b10d68a80e5ee691d7db591fcfbaad6240d41da8b"
    ],
    [
        "529acd569127f73c8d34345f87e96cebfb48ee12a00a3861cda209337ed94e6",
        "3120671a89b705e5bfd99b0e7fd2118b4914a3ac309b3d74527cacb5ad7491"
    ],
    [
        "55d3d7956a97d10e65a4d8ffeba40deaf0db0b57f8e022cdb3df6df613f5c6d",
        "159e59a6f92f48fcf85aa96c1a03749a4c4e2cf9e2bc94dd36796daebd9b8b9"
    ],
    [
        "405f019ee8f2e972a005c549b0884b5051f63d1e78480b73208dc07d8c65a1f",
        "4301a3d0c285ad309ff24a12c100ead7f48ba1368143712f32ac141ab4d9e8d"
    ],
    [
        "376d59b298d982f02dccad0edd5bbd4e5e8fad7898750675ed0856850a7babe",
        "5233b12bbc50564eb61cc098a17d3d97f06ec7a230380e4c5d3b725cc318eba"
    ],
    [
        "2f55624af6109ef04b2ed035a44a904ace8627f55889f011f768aabf4de9a38",
        "7f64209ce7dfb63337ccf3d8c14f4093295f86996cabfee23b1655549aca089"
    ],
    [
        "3b8965e942bed2714bc2e685fb103496e1e3595ac6a343d6df45fb5ef6979ed",
        "5b7cac7a165cb69ae103dd9052fb39c00ed0aad47989005aee53972d82d45b5"
    ],
    [
        "7abfe3accdec1eae1a50049efdd9a8eb7c2921a08e8bf1fe606e9d5a4039ec4",
        "3af178e7e831f8148244d2d2b284a32991852db6212ad0a9d77540ef648a5fe"
    ],
    [
        "4983196df6ad7d6f0a8d76f86af3863ad8611374a03fc0fd00793181dbde9d",
        "204c1f91b70f975a21d24a8face664e496f00f602daaafa69a3b56098a4cf89"
    ],
    [
        "79e2b91c1531a3b16dbd53e72d94e16bf265cbec261658151acfaea3718ea72",
        "3d9bdb47e8b148c1c5e9e694ffbc2cf71aac74ae1a85e8d8c3f77e580f962eb"
    ],
    [
        "297efceec61b3be17565843cae465c52524b4ecd9331a4170f54f7de8c4556c",
        "6ccef1733624cc8b973ac63dd54e7a53604929affe81c3439525ae5ed6af993"
    ],
    [
        "44f04b1966264a23ccdc870c8563ad2efcd4c8087b5469b90e792287a5581c7",
        "1c417f0e9829fa3d3cbb7c3cf4dc7aac04c5bf66ff3f86b833a42c533aed1fc"
    ],
    [
        "6ff83f5d8b51db3be0bda80eed2e2adb7037f2f58f705e88f0f98197431ac26",
        "64f59b8428894c2b7afd740866065ded42e716c7d48accd3f117f22768ed9fd"
    ],
    [
        "14aa8187c9559f77cd1cf96b2dfc949182529936f2b0b4050ea56e134073b24",
        "5f36508c68b1dc586f3fd3f4e2bd29c6d8258491b8a6aa19ede811ce0d3d0a1"
    ],
    [
        "95e8882a68c5000d1c2be7c0b43e7f2a6f8de906485241f0285a5c73a27a83",
        "1e4cb67207ab73bc1e5d19fa2146fde6d03021393b77a55df4ddda1fd28f5b1"
    ],
    [
        "2ae0704dacb3da47d564514b4c3543505b403ba09a248c6e74593cba1867ff5",
        "5a4b5818088dc9ef4066b90a8893ae80fc89584f987ec1928ef9d72cea2bd67"
    ],
    [
        "61a10898a76fb99989e51c0e823cb60b95ec7ccccb917c42b2b28014f5fd94d",
        "23d8ec1de45366d3b86c64c2da05a2ce3d171adf52ca5522e652ffd0eeee795"
    ],
    [
        "79884133c879cf07734976fd64de220c5a972e04c2a3afb74c362d6c3beecbf",
        "2aaa0e6d4891b792b5643fdf09873343cd0e3fbba3cbd0601b481a4083f32b6"
    ],
    [
        "45f73d2fa82be6c5ccd0f62d2237efe8727c479967d27cce28e42b9a44bad5b",
        "2fa4932215f72d56d8be5205c5851c9b3e5f2a14468e4a7acace5437c6b27dd"
    ],
    [
        "37f53f771850f52f9c8f87b53c6bf0c93c2bed76f5fd1d5697356d0b2325007",
        "50f1a052b79b446fbc7b93ffa1a4515f6c3be3a76a2b0bc5eb8ff327549960c"
    ],
    [
        "71bd6d23e0d2f312d47582efa609101f15b9ccc571fca8ac4fe3457c67fbc9b",
        "3b3fdf86bd4c7fc26d60540a6439b4d179dcbf7b91efb0ddc60dfbff9a148c6"
    ],
    [
        "78219ba049438385b829c13a4993874a4a326c4143de0dd581c7b9956f99b06",
        "5505f1268dcdd4ee01b77abac3bfdcbf3f0513ab097c69ff777b4a631aaf256"
    ],
    [
        "b81e924a86536dcf68bc5a2ca2065a61103ba6c9eb0ae4cf8cce9dbe286f15",
        "653a6dfb51acfe8a844fb8362795e5549d424aed88d3a090366a44f840b5b83"
    ],
    [
        "441c0d7b7aa705046dc0e07ba5f33a7d9df23f694a05192ff8c2d7be2aa3fdc",
        "4c06568c0902bb99d428bfa0a946ed0f0ca0a51fbf07cad88e06e9c78e38a59"
    ],
    [
        "2569c8c78b6d6b92533f29f767c95720d377fa63ad5a3b9827ee0a74b0488aa",
        "4b59c81d3cfe08834f946d9d57614f5366e0bcd9349475aaaebe01341196fe0"
    ],
    [
        "3f2fa285a0471647b214eac652bbad9d58a9f2dd2e812aff0210d0d8a6eb32f",
        "4cdb18e1c2848c2b52c1a6557165bd1a8f55c2f7562f5cc0b326f73c25b696c"
    ],
    [
        "5bb5141ab4fcc5290ae9151b8045a2cd8391547ce7b3b33cbbb10f8fb538092",
        "5a36bfd52acc6a83a9913b937ec086cc27fed030b5fa70dbc5d3c12c9515f56"
    ],
    [
        "3f3fed272edf91aa7f8ca5d70005d390fbc67830ffc69c5fa3ae17582d2771",
        "459057e0883c44d8776fa217405f443e5954f08c4a5db68e437becaa664a999"
    ],
    [
        "5237ca6656237a717a739a4509f70db1b9dedbb6cd232f60c9bd8c4563a6b1f",
        "56c7799dd02896dbe7d69dd8bb9718270549592099569d107b7b49c34bf5a49"
    ],
    [
        "1cf6b8499ac881e0b2fc7def9bc1a28937033b2fc52de99e75909a620c7a281",
        "5769cf4f735366fa386b6858043dc99a100f86fbc77b16d57d77766197ba27a"
    ],
    [
        "1b74b8a6b86dbf9638cdb0601e1a332b8d880753423d38c3394902c57f15e40",
        "6bb2dc10d2ecbb913219d0ebdc8d3337d644ed8b6c4e70637ef4c7e50887488"
    ],
    [
        "61e4da415661bba52a4737e2bcde1a837787c4796b2e1854778534f1582c29b",
        "27c43e632cb7652e8508c9c38e3b4ad0d3dd6ba748d42dc84ec2685e64b9aad"
    ],
    [
        "7c460a204d23f20ce86596dae6ac9b36734e4a9f7c5b43262c97a36c6a41c6e",
        "481a11f9300ab4c4bf6924c5ca884728cc361247377065920966785d043fbbf"
    ],
    [
        "124ff5e55e4effa40daa5b9618d75c49c8b6fad95cbe8c0bfdd83cb9bed8316",
        "33a2ea15d0f71f58a00de71acd7f22ccf9002115e49dd1f7631faa0d32f9987"
    ],
    [
        "61c9f8fc86715e95ff43583a865c5a6515f93381839d557ef884a68637eaf4c",
        "5877daaa42bbab9083b571e12648a9d62ced4470d71653092b6546f4a5acceb"
    ],
    [
        "70a6b9a9e5d1fcc07dd9ebef6d8f5fcf04c6cb34932d0fe2335330ac6dc8d3d",
        "3f0cbd332ac56922e886656bee74f6e9bb4bb88f7af7bba9098678af1f38fc"
    ],
    [
        "41db8a0f1ea78443a39e08a54323743c8897eed1ddc28f41aec6f2655040d9f",
        "7d4bf32f8f4719c2e4af8b7889f3b65cfdd033dc2f971798a12170f2b26efce"
    ],
    [
        "62f035e01acdfe841104942d6c8c07f0fbd618cb85998ea24bcc24cfac1f8",
        "1caa886104b7d753fda93645a746989794cd825c62473b526ea34b3d51b5771"
    ],
    [
        "441c6f016d270e86c19843727b83b864cec060cafc813b23d7e41e5abb1a60a",
        "29fece4e40400f3acae0586f4fc8ed535e805e472123ec38d662d8a0b01c086"
    ],
    [
        "2c791ba0fb0b66177815c98191fa6188dba9c795e34a7c3c8a19086215e3cee",
        "11123151389d4b330db6a665a560407e7cd8c3807c749e2b0cffd9c3074ba77"
    ],
    [
        "5292da4ca71ae75ed0554c267747e39c7a129b3b863e1af3ebb3e368439c4ea",
        "63af6a5016deea8cc674c44f16c63c1db31f09af4fb4d2ea7917c28116661fc"
    ],
    [
        "3367388d5d1b7758dc3d92e244f227bb8a54e3d9909e7b7dd62ab5965e3efc7",
        "7ffb4833071e4b03ea755ccb9938487a478248fe9b1158a08f1ac298801c092"
    ],
    [
        "95c863314b7f18090f8eee602403be823a367a1b416d54c32e5f914e67d922",
        "159c2824f899171deee23e0ed520d4825bd667983df0a8d45d3a1f7156d91f9"
    ],
    [
        "621c6e08b3c57404644ad49ac7629832c141273fa1f323781b3395393fe985c",
        "65d1eb0140652958c4371ebec791e03317d6b2e689d90e304666f1b610783dd"
    ],
    [
        "54313129bf13993952cd2b31ed06013aba85e74c1b8a00e062031f32188a84e",
        "680129efc9eb8ec07fc180e8f6877e5f0f9f44e3000a2c586ed4ce49d12a313"
    ],
    [
        "21ea57a1c8286bb45872e78617853c47b89091670ba51c124afa3362e7260d",
        "7087e5c1536df233ec9bfe2f983e8d7622892b9bf64c450c9823898e2cc2fc8"
    ],
    [
        "3793b05b99e7a57d88db4ed0dbc3b771285abcd9052da50f88595354409f3f3",
        "12164105041c056f127e737c7cd63981e05f246bd2b6b65d1f427019c7c3801"
    ],
    [
        "befd345cef5fcae22ac37dacd6b9128cc58cbba3e3fd774e11b421c2ba392",
        "6209d25f24f88f7876ca604db23d05f78e6b3b67fb033f2f1bee221f352b8c8"
    ],
    [
        "15fa536045fda4c65ff74f10b4e669ce88b9996c6772288289d3ad725987fa6",
        "30e0c2124a35e265e931ccc66ce5ac3697d982814beb407144ff6762cb691df"
    ],
    [
        "38b795bd77ac573576dc204857a488cac2cce19809882631ca2069598c577c8",
        "786ba555d55ebef688b068bb9186a34a08cb00bdfef51619bbf911890ae9a13"
    ],
    [
        "6c66853592196c3eb8d9526dc155205e2c64097adf8684bb0e15eb460ce1c72",
        "1bb4ebf654f4250c8dd1061a4e1b464b31a8a9999ac9960446ef8108a66871a"
    ],
    [
        "5b08dfbc87ad9c00b88e78816973ad2f9c10c70f2156908892cc7b7a2a1fd30",
        "1151f407a77e2556073173d8f5c9ff561d8a23742121ca15f7d0ac391af50ea"
    ],
    [
        "309190eba106aa6ead54b5ca5817969aa68b4b4c627700799a49fc6bdd32ba1",
        "505b6a2bc7b0d78ca6ce2abe7dfb7312369918a4599cccf8a615f6701cfd851"
    ],
    [
        "89cc205966af08acc8910d563af7443d5dfbb5d88dae79c013c678c65dcecc",
        "1f8cf955694b246a423ac725791231257b88936e00347ecaa1e17045c0ab540"
    ],
    [
        "480086b61a80c36cf1e1a350baf554e58ee8d9333186b70c9c512fb9e9d5a84",
        "511edfe58f8d36a6170df743731da1ff525cfd5108be20e30ac4183d1281570"
    ],
    [
        "3caf14fb1d2e90a13ad4eb091250fe37133aabf6029633e905e5a93ead41dbb",
        "49122aff6059dfda19e4b973aba5ebe3804c91728936c6381c1ed1ea9380920"
    ],
    [
        "66d1b8fb2cabc46cd79741ce1cb7326077ad8ea3227a6427244bdd3806bdadd",
        "4a52eb74f4d5371ba3265dffd61c844f9e68d4ff0b44dc4936182f9280bb66b"
    ],
    [
        "373330c5afd53c31257fcc9050fef873e15ea9f81d9810f30744309b04e02b3",
        "5889806607b3dc97a9c5b0c8a2f16d1792099a22866b879ca480cb89a11ef5c"
    ],
    [
        "26840d0ec69a22c6818ff64b8b14633b531508c866e21d1dc9239778ae9e8c7",
        "157971f9a6e3a24d3b307be0e7c8cd352e2eb5cad33cf276270c0f309ee63fc"
    ],
    [
        "ebb84848f1c38c19a754d1b5d9460e39624dadbb30800987c9419c0f933b9f",
        "517b297cf32f4064e6d6c8e761ba8db89809604a701c7b3aa1a9c6beb370ea7"
    ],
    [
        "25780380bc0795ed0dca727c55240f1d63593e552d224adb40df2d3721c0f66",
        "10215fb5a893e0275e9f1f66b217dde35addee91ed0e8f7d79531a2ff57b8c8"
    ],
    [
        "243e1581cd1abfbf18c31c19a4c3d1cedfe69a40bb57b607c9af2717eefc742",
        "1296c27929f14535718c3a4ebe045f00afdc60afc74c7d398d8ce1b6609dc0f"
    ],
    [
        "48babb8649e054bc8e0b902c89e6940c265f48464520649502ef1064eb94562",
        "3235be7852b0526d1a16f6969ec0e5b0e09cedaadc65863dea4e47f4f398264"
    ],
    [
        "592db7c27e63489ef4bcef2eafce89f40067cd9a1ba48bc3dc76b5fc62ad9ca",
        "48b7711b570cd9ac65910e75e752f4b751fdbfb4091a28f59b8c046d3d9f8bc"
    ],
    [
        "31d133456222586ae42a9ec7ce8539ee04afbe0b2ed00a2564dab0798d9b55d",
        "a77c52fa1fd718db5c83e7fda6d7d4d9aafef9ad95cad621470f2b753729e5"
    ],
    [
        "4651668379883521e7983aafcb93811b4a72ef2975b3277773746708ef3e3fc",
        "512507f3f544d80ba5d47f73b571881e8d70d7b1d305b9704bdad036b7abc47"
    ],
    [
        "26069e359b2e847affaef604f772f36224608b7642245d0e643889ed231bddc",
        "75ae1ec379f074ebc91270077c74b4d34347ce183b676b4dbe100bfff143b9e"
    ],
    [
        "3196d01d1fa11dc3803b4813c4bbc6326869f61410f2bd14bc0f570d875aebe",
        "20313217cac79875bd2a503db1e86d1e5559911667a02524759344468d9561d"
    ],
    [
        "483256607f75f06fb126addc60cadddd602154cc4782bcc08351a48745d0b97",
        "2950a7e500ebbe9775f08be37cc2e62ccf9030de18948d1bab07a4a9173f75d"
    ],
    [
        "65f07b6050a2fc6eebe2c29ffa62f764060f7f9d3c82d2cb5e4e368aaa442c9",
        "562c9654b646cb84a213b41de203c871b3eae0a05c9c105a66a53c319c06373"
    ],
    [
        "284870f6181c43f3b01d94baa9c5b6ada0deb861145523ad9169580eb7bed35",
        "5e03e6c40c1cfa3cafb01fd0622349871832a9d35499d06408a83edc1b76d02"
    ],
    [
        "32229810a52137f0e6c3d37595c46f6132822d4b05f42674b48d7a7ac3ad85",
        "7babde959a0cf2c53ee59fc52c77c3adf899453f077f441965629f9aead30cd"
    ],
    [
        "1ea8b98a6b85e74e0a2fbc18b206e290f3ed94ce99ca665e8e2351dfade990a",
        "478e93c4724115fb1648c8d5347422adbc1a0bbf962b2312e14aec80e1be742"
    ],
    [
        "270cbaa08c79140c85b864475a0bf569cc03ac785e57f543dc444f37ce746cf",
        "3a9b8d894016680ae9d1bf3deb931d8987d4d8d8bfed45b81ccc595ec79046b"
    ],
    [
        "6943922708b8ae5b40dd7031ef2e487abc4ac39a3591368285e83d6c9c51f4d",
        "5f157c37d09634e8cbfbef90ea50af59815d011e419a691c67ca3402b5efc33"
    ],
    [
        "48ac6a80979fab4912cf0cb557d917a0bd68825d8658ec100496eaae6ff62e1",
        "2b6931350ab183402e39476340eb1177b7006f7a552915581e29a79bd7203a0"
    ],
    [
        "e3adf9517d92ef22d1e2a787740a292ba32d5ca69faa9e8675f63ed816dce5",
        "36bccf69bb12dadd610145a3399213248d193660d8dc90a2e206f23bf2c7997"
    ],
    [
        "5e6c8ae5afb2fa470f767581f3d578cf6a49547e4b78665edfd45776948bef8",
        "6cbfc11953dd7e195d2ce74e52a60df524767b44c4608bdd755be4bc85eb74c"
    ],
    [
        "15a576a1242d39300f0db3ad770983825988da0457718ecd596c63a0a0eb4a6",
        "69a42e5f6f5a63349b57683a4609bba90f556a1680fa1ec3b02ee7d3211f903"
    ],
    [
        "274cd14e4fbf2ed07402e8ad8075b320c5f76b7ea45ea36af523e95ed63ab50",
        "6ca640f9557c5f2d8b27f6ce95b108880ff4e4816b26b70b6506114389ce656"
    ],
    [
        "4d8284e132e2fe81c5f71be1e3c79ab51b229e2c56c323e207cda179999d123",
        "116cfc00e9fbee1cf16af6282123cdf20eed13021c2037ef4c86f94eb6e6cba"
    ],
    [
        "4056194fb5643e97991942ef5b63cadd89080bf57a01489c4398aca03f0980a",
        "2e2cddb434fa6f6da7859c3d518f0ced8795eea043a6c9613fb3e020103339f"
    ],
    [
        "5d119d5c5ce532afc0875e0ee9b026d878c8773d34237f90a0d0670da6f01b3",
        "4a79fc025ce076b6a4742fbcc8cad313d0a8220c58024a41a5a674c0947e64b"
    ],
    [
        "11800ce4061d99b9d53fd4138802335258f7798c5a935c9979f5a949ce1d483",
        "36745a4741a5c7290eaa8f2a3f9ec955ccb7ca323272e5d35d35c2a724ffac8"
    ],
    [
        "4302525bceb97fa642fd5560a4a39fba3d2c06f68e6aff3332ff1854439ebb3",
        "e31edfd081ce82f8177b2d7d96e69851d09e908c2517114ffb37ee12c0ac64"
    ],
    [
        "2f5fcbb96f0a66fd3bdfbcc78bda361cb812570f50e7c476533d56eee01c0e3",
        "527428a34855b5695c479d8fb7e831a299f7897f36682a74169cc60d160df2d"
    ],
    [
        "52167df045ad0dc999b98de3d035aced9da4434211149b8cf4bf20e774580cf",
        "19051d2a1ad3fab190c5dfaf45188b49b4e90cca22aae54f0a785562d3d3f41"
    ],
    [
        "541b5332491dbdb2b6f6bccceb7634970c046963891fae936dd950f4432b961",
        "78fa54da996a51e3a9c06091d58c2405a806649da2bb1f323807c4eec50eda2"
    ],
    [
        "5f11e973da659b7738f87ca5bd4f3bd02207dd3c8d978f0d3e83fe81030febd",
        "137aba7027069f62d25caed416e13537687bb1428e71e5f0a0c52d52f2e65bc"
    ],
    [
        "15ec941ee6c2110b819b5541be52981c09d83484c9dc735c43f39f5778718b4",
        "4561826142dc5b56acfcf605a78a4090472bb61235bcd605a765e05d0a7e549"
    ],
    [
        "68ba398736d659522f484406110b43c68158bf4992094acf797a38979c587a4",
        "7c1d9e1702e28afddf22fed7a7a79df4315c174d0c6c4f4c75bc77d9b56777f"
    ],
    [
        "67889cea31c81a429fbae643a4fce0ecd690a5c32b99397e39ed6d7a08702df",
        "7ea277c80b671146c9e455b98f42f45b941ac95ca2d15c8fa9ea82ee9b45e01"
    ],
    [
        "596f2c68390ac26505d3c2eca5c77d46f8f3acbed192a2649d8c525a58d2334",
        "49f3bd8c62c610d5c19c52d970bde24b270c4ff7ae900453b909e72483974a0"
    ],
    [
        "567779fb8b0afe592cea284629e3621ccfae3c4d7d3dc559c9fed750591a395",
        "6010bdc33f1cdb374facefff537e7910b72a1120502f312a7ce41df0d552ddd"
    ],
    [
        "cebed0233e810aa6a29a8b0829d28f1c92f303d14dd73d6b12da98117dfc7",
        "4bdd51e1192a00df23aa8d0673e4915877ca41ddb8c9eaf21d39dd167fde7b7"
    ],
    [
        "4c7085f066adeb6781596771972b188177e63f2e2b3788d03e033cdd5af1f06",
        "2929ee89f525862b0cedb3ab9b5166e1680cb77fb4668f10a6a3d76b5434566"
    ],
    [
        "760e341bd836899c226176f47685f69438270c150c6fe7744cd723cd1e72359",
        "1bf09f2f1aac1a10ce8bdf20d5d178db747f01a4aa0aa8a5e4bfeef562cd94e"
    ],
    [
        "6016b94c00b54920027ef64902c61478244b1936337d2ad41d9a8d43dd6a4b2",
        "3bf3dd9bce7f6d6f120de87fcbce6219340b59c2c1d75ee0d45105d33aab1cd"
    ],
    [
        "4929e44ff692eb944d1045bee96e750219cda3bda0500029f0df49a1db30b5b",
        "2e138dcbd092242699004b4ce98764ffe4e892841f56830af298581cd1e523f"
    ],
    [
        "5972d0e526311bacb70a04e88969b6c63c7399b578f0dc28bbd00d65ef01da7",
        "76b22bca9ac12d26530e7b0757e646beb3bbc5680d0f3f82fb8ee57ed4b5e39"
    ],
    [
        "2ca0a42a26e26934ca2d48db960b4719113d87c5e57fb437d557c5eb4e03ac7",
        "62778c02561d4ec5d83a132afd7763a8349207c6b5d01fba70b56ba660cba2e"
    ],
    [
        "5137ee53f076e21a2c23da09f63c0d275408c31e4634a6b6373be5cf13e6c00",
        "14fb446c077beb78e04de3282a63bfde12f9af85caaca4ddfab506cee31c0c1"
    ],
    [
        "7d944853d1627b63f560aeda33acf640d35a4ee4d23a744957a2dae9d5b7c6c",
        "bcb411a210710acbcb9ea12680d89e3e4e652228b6786d3886e95f4d9e6970"
    ],
    [
        "37d412c2ffb173a728477446b60b2b702d07a5243cb5fc8963e623a5ee75843",
        "672c79968908f92cd0cb0b4c65ba86e8f359b015623a89441e1bf859bba84cb"
    ],
    [
        "5b37f472aa80398bff12cc74c8ee784c4fc89757292580d3a498bff17e9f114",
        "7d79da1aab9cfef58a5f3d1c9ec466956a45f8d2af0c1da6dd4c93f720fae6e"
    ],
    [
        "25c09b3f1188c562571536202eb0f5fc4b9a7590417b8ea58b4343685d88a63",
        "3d5b817c73b37e9a1d24ca923351359b42ced2f3cafbcac8c2d6322dc767bb"
    ],
    [
        "32e60904e73f9756f71e0a918d302aeca17cad4acacc81bab15702ab5ff78f0",
        "bcf4c0204f8275072f98a65b09ac58b87cdc9c70c4edfe99fe18870a3a5459"
    ],
    [
        "49c35575996c1517d2daed90d2fe4a58e674d6b4aaa7288d0642c8bf59e562f",
        "57eeee00adea4ca80eeabab57852cbf03f1a57e21872cd44221e0550b9193b8"
    ],
    [
        "10e1776b4c2a867bf1b028c6edec224cc6616c747e272f49e69b67b02a893dd",
        "8d45d62ec8e627b56950f2f7622a0438647f9e9f28e723e4a37cebc039a1b0"
    ],
    [
        "79a93a75ecbe943acc964fd39ecfc971dc6555b2bc335e7b53f52f4eb16cd36",
        "146132a68ce2ca8b48363612226771ac547eb3cf52b6eb7981718faac08aa3c"
    ],
    [
        "6b22d32e0590e169504e7f19864fd646d0994e7ed3e578a5b88f6e095913439",
        "68c3b22d859fb85e5c8fa0a8aea932285945b230957e603394333e9ad5acd82"
    ],
    [
        "71ce5ec8286eb8c93b8481c6d19cf0a288ef4da4397e9c80f65023e516bc097",
        "54470babc742780cd8a05499026e738ccbf81d4170d1731734de68a8e5b402c"
    ],
    [
        "27beb13a43bc6a1f6ce046da438b0beac5899ff4d57962dcfb6476b563f74b",
        "14074e9e93ee45394dfbe833998b9d1691961f8ba3166224b36404448c61bb3"
    ],
    [
        "6b1de6c8f161aa6509a1dcacf2c0aa1bcf6ee9d9b40e032a9d72f77a6fa298c",
        "5e9312eb5b59d6cbadd7d3dcbc39f1b5bd9a8346fdcfdf1107bada6f9cc048"
    ],
    [
        "32670fc3fa43bf39974ba72ea51f0d045d92d084a81fe5282dfc8309aa900b9",
        "518fee521bf1af62356aac3b7e53fdbf57121e030c6e9572b3de69912ca4eb4"
    ],
    [
        "4b9ca363eabed9c66091a347375f7065cd28f49f914447de7cc1461f1375f1e",
        "3a1a3a2e5e7e72476befe2571ece708052d740d02cbe6fed58740968ae609c4"
    ],
    [
        "4cc6da42863a3deca62fa218b7a3b50e034eb4bafd393eccba3f4cbe192ef10",
        "20bfa683c884f203713953b26d2821287ecd305fa2cb70570474533fc07f918"
    ],
    [
        "87705353c44a5ccec8de65cf5433be6b3d9bd21eea49b60e6c907cf1a67a6a",
        "112804b13eee56e3b01aff75fa08fa8374c44fc461aed8a30ad54acd09c24eb"
    ],
    [
        "6cf6eeeb9d339c0a05f72fd5af73fc7588e6d957100ee8999109437bc126cae",
        "54fa257cea22032eac272fcd034dadf2e00d602ef9e519cf7072023c130aad1"
    ],
    [
        "19b32925048c5519d929650c833661b452ef7be7963fab0b6b328ab7dd7a28a",
        "1bd0c14a10bf9b88ea61011c0b2e64d07da151c6203800d5a5d12063838a510"
    ],
    [
        "12a5fc5559428bc3b4eff97b21b63668b866e0722807f1db1f19696bacd9b0d",
        "4c2eb07f0c24047a3d73b560144f3fd32c99d6dbd9fc7cd2fd2a72a6e4b24c7"
    ],
    [
        "13662b7a7d390aa76eb86a7c3bff6d9913eb28db6bd1a7c42de5cdad2e35ce2",
        "40626aded7f56f82cc431ae30527b096f57fbfbc04d3e12a5abae3edf301cf1"
    ],
    [
        "255825bd49b8a2cce114360bd9c8fe8c641af64c8e7710107213cfcb006f43d",
        "3619cce4482335232f9e76a1460be9d296f2d468d26e4f95a78c71524fe59cc"
    ],
    [
        "7f83009eeed4f12f54d341bbf06066480cfcdf51dda103ac54d4bcecf6b3b31",
        "4269519d28faafd7fd68bebfd8404d71ba05d62c4bb6d65d24aa6802fb84ab6"
    ],
    [
        "2f325650eb316646b4eec903fe44828fcb11054f1bd42ca3a77f7e734110b35",
        "44f976082271016f9048e22c507d97d628722bb431f8d5cc1890524e6c386bf"
    ],
    [
        "750b166bb6edc0ee80fae39c7c106879036738df2d79fb2294e1c21e9a24d6b",
        "54f8aa297a1afafe2a17a3254f45861167414327e918d17003c6aad01d0b24c"
    ],
    [
        "3aedb10db9cf3285cdeee375879396fac1fb50dd259e1716f8c01e66f67ca72",
        "7feb9400f621f58c21601f23b7ec7c94a9b6b193c1cd74a8a60846aedadd359"
    ],
    [
        "4ab7151702de76faa493e7a0b1ac20ee4d10c33b83fec9477547cb1236973eb",
        "63f1f122e3ef3acc46b0915ac69c3f5772879799cad889a817f55f5853d1235"
    ],
    [
        "1675ead0d20e5bc3a7a7331999a87ac4c916ae29669e54197bb02aa6364520f",
        "4d1122da90d49e491922d9b533a6a668e2f65a2737ebb391ebb29fb7c1f8a9d"
    ],
    [
        "2f7148111ef53c613157aeec12e16a20f13481da4390b6ce18a85d1d8547087",
        "2eeda779ab395597651d2a0b833ccf53b10280750139916ae2baf4ec57c633d"
    ],
    [
        "4439c7810e7b2ba772b701ec3acdca0b80c9df23047710b87f7dc3f13b337d3",
        "5029cfe704c602a8a4662af0a5860ec03fb88f046d0e3400f2ce7638014c621"
    ],
    [
        "2248eec40b5732a6a488b681f093643af7937071bc73118acae295a32b51b05",
        "1577e4aec30a97b648de4d0b19cf8891151b4eb11f8de9c6d7312f091552e19"
    ],
    [
        "4738424e558d4e0d87a3124ca02ea24f0adc6b7a9768b0d3945ed2a6104857c",
        "33576f92aca3f0c8ae689c3c274c2de6b918940d86a6852e02fc99e35d1614"
    ],
    [
        "7829edd8b866ebf7baaf604ed13d19a9797578f44bbc51b1cd67ca53803e96b",
        "5559040a6083f2af1f9133ccaf5bc2ce06e56ddfc7dd410e9635c0116b62722"
    ],
    [
        "7f927b881f2cdc05e1a69e40bb714af47b630d1425f08ab5d574ee698f33d51",
        "26a465288e96572de303203bd38f4a03031e8158da0591cb037c0a5111d1056"
    ],
    [
        "36a65598552f8753580d1655417d645a140966e10a1e1663015f9fdfae44881",
        "33d5bbfaebf59eae72b89b1aea12ab2ba3c9617f8c3baed1ec16bdf668381b5"
    ],
    [
        "403becfa545c826782026ff409cc16c9d4fe428f1b5b6e630c92439d2fa5fd",
        "47bd6f2bf5d74f710ecb479c79b01fb774fbdad590e683a415cdedf33f71dc5"
    ],
    [
        "3a747826d241b877d3d56b16e0b810cf088eda4fd6048da174c9991a942a5eb",
        "2c7ba19b0a3486a2cdb84d4a388d34beb077a0e467ba44590166f93f6a09d2e"
    ],
    [
        "3d60cd375842714b37bda89dd1f13a7e0f3ff133b522209617d031bce05a537",
        "f77f216451ab01ad5226844d2162a7f32744688bcb4325445539e2ce5cec4"
    ],
    [
        "235bf66f67c9100e7f0e22bb299cdfaa603644b240e0770aec7e7fd163e2a65",
        "37110b3fa83ece3990afca2bea8d5ebb3c7aace60a0147f8e6ab733e2f2b4d5"
    ],
    [
        "3b796d4eb69a55471fa86108f787b3604874e92b6887a7667a6c2bfbbd9a42b",
        "4912d6dc0419732ef82cb3278415851d4e2d7ca89e0f4d7128cc9de51b810fe"
    ],
    [
        "48d53516dd51e49faa7ab46c8c10db1befd10f23c6a9d9bc3640a2f0da44518",
        "73a2fb3d064adadf21aa1362c04affc660598f38a9e069b3afb74d0a99ae9ee"
    ],
    [
        "48c32cff161ed145da0d5b73084897647abb777adf65738559ceab6939cf3e0",
        "3d99308978e828f857c382df32b472bda81e8ec8e30c8844077ba6d6d2ba903"
    ],
    [
        "2947ff091a8ec9684affbc9a62e09e598841c4a6dc638088492aa47dea57097",
        "19a2cc97975e547f97a4d02e42f89e6ced6f5a953cfccdec347867d26926541"
    ],
    [
        "1960d85f30475615f82484eba0bdafb7ea7cac3809f0518a757d66f02b01676",
        "36c8f77baabf0cc8805d993bbe62041fcf4e3239cf9d53278a4fbd91e75eeb7"
    ],
    [
        "2765f28074d21d5a055340b6d40092d2bbef807e02009fabfa08ec0b9bdf38b",
        "7fb189e0553d5df52b6843661814824b3f3cbebbd54988f042fb256c6bf30b"
    ],
    [
        "348836cb2aaa00212f4b1a4e2d7fc5417f246bf2fe5c9a16ebabda449e2e08a",
        "3f7276fd7d69e0d55ce5ee1d2d830534a27227fe0b6d8a36c93f9a78b872969"
    ],
    [
        "7afb9d34b6a42ea8c6d870e4b8191c274201dc1f93a1a2219a2392b7e345a31",
        "42bbc20dc7115e0758b364a110227b16b64ec58fc535ce5ff1a9ad8b8a09fdd"
    ],
    [
        "2cae0c2afee1767fd4c66f52e1f176d217e92e89cc19eb36d5a6c1715f641a",
        "5335efe2d9bc3667d25ea88bf76438a4d6ab9ba5c512f9da7d0529b79b62d83"
    ],
    [
        "1cc5fde334707723c3a06f00c106db88664284a2df47bb6b144d9f960aea3e2",
        "dbbf610d100316938bcd8bcd078513512ecb50d4579690dbefaa419c05980d"
    ],
    [
        "54e90cb8f3a2998d2675c5780679e06c0556b1e618f8fdf07f9a4b2466fbf1e",
        "16248676b6f06ec5e34994bc3115f85c8147b54f34d8500928f2fdc051e2089"
    ],
    [
        "525c70a2ba0dbdd68d75640f47f13d0d415ea595f7030f533f4625c2a46523b",
        "58292c8675e5e1a438f49e0c05648d9a7aa997f2f1fd77d5de1944afe5d7eea"
    ],
    [
        "54726d78d099007393348787a03107ab492e59690a46c87fb02ec554f2353bd",
        "53b54b77184ba75a3391e0ebfa6d6974db028f3f8e34bbd5460759a5848dd76"
    ],
    [
        "4ac81a66903537769d3aac6c483ccc08535cb767b6b5e1ec8017a7393ab70ae",
        "2cb22b77a8a05d26f11a4dec80eff292633aa05553a889c5ab16b6ac6e2ab17"
    ],
    [
        "21d0175349e21114988a2930b9a607d43245783cb4a0c984ce27f4c4206708",
        "59f1f49342cc5496213d3329bf4ca7fb0044337449c579bf53147a1dac9e67c"
    ],
    [
        "167f821b381f4c8adcc39789475fb55ba639e5124fe75f26dd61be396dd5e66",
        "22002c87d4cafb47ac9d27286d5cf5ff7a6715d69814118269b0729be9e4b3a"
    ],
    [
        "31010666c6db83a9f9e4db4c48173afd405783ac53852a6e38a8ff925528843",
        "1f466dc9b5d9094107c741dbf380f9fd98d8549cd50f67169901516f8cce74c"
    ],
    [
        "1ad3875769a5053388a86edc85dd80fdffbbda6a456aea497ff81a0f1f6707b",
        "2de7cdec5e2bad56a71bd2f33a4ae4c874e1ad4210a6ac32b443cfa34e85b1b"
    ],
    [
        "c489650fb7f459ce09cd05a456fc5a46b849b38a671298ed645bcdaab168b0",
        "45610d092b8af1c43ceed474cd17f7bbee65120aa6fa4d37f949e7e41f25327"
    ],
    [
        "394256a5ef4d7af5459587a0bd2edb8acaf5ecfef2563c9a04daf34a4abe4c6",
        "1ebee390dae1403c0c53994e1d064fa64e20fcb45392e209b2b99486a559ffd"
    ],
    [
        "410a1511fead6151e9bedb089b9832d0fe01fab76d3f8459929f767525aeb27",
        "361f0a5ffe09fcc3ad4eff3f5e89508ac247af80267100b69de3c59df561cfa"
    ],
    [
        "38cd437c9f659e110a869605c182ee9fdc26de36baf559d9229e258267bb734",
        "624b1128ea7739bf1cbd0e423af92a4884323c868d2ba0ee9d362946edee2d1"
    ],
    [
        "78b126e50b7042d2a019f95cb87a3213c664ca1bafe345999b1e9e2dac1e608",
        "19e398196b22f4488cbe854c614ad8c353839abc5ab3a4f3f5c03c16ba8a198"
    ],
    [
        "6d3a5ce91132f385a91823c5c8046c4b638f5fe63357424410d901457cdb867",
        "7b80bae16d2d487e122495174f7a70992bc5dafbed72bf84127ead7c57302bb"
    ],
    [
        "32d053a904dc4d88fbe7d0b96e0cbeca22a00aa5c79c753d52b0b60abf31602",
        "3af6a02e5cae6d6490354ae51185149e3fdb6d0d9caab90e95ff58aa0c40377"
    ],
    [
        "49b1fbff5bdb0aa6938b066dde0ed772c0d81f9eff52e7fe038b0ccbd78adb5",
        "1c6e57834eb14d507eed8b36c81ddf92fa91c242467061927a742fafa82b43d"
    ],
    [
        "2f28b8994ca6f234d9293d26196b43b9d1d5306844348c4a638102c05de85f5",
        "759cfb172eab065d477248b3569f4ff5791055f01e95fe71b94b8e615d73c96"
    ],
    [
        "3c2ee954ff534f856f59188fa0f29ed8a022aee0cac52d634f6dc58cd514d70",
        "22bd162e74925f0a876bd8a206b8767dfdd7c898576a73a490f138d9a7f99c6"
    ],
    [
        "5763a7cab001e1aaeabf9ab5b9b2fffe6cc2b299ab04ec4933da74d960e1ab",
        "715ee4f8ee93ab5a1dba00f0a6abc4eec47d49b61254cc27fc36a031e32f0f8"
    ],
    [
        "19976ad8d7b7f47c785408243a227401996b36e47c7a78a7bc7d4256233ba9a",
        "896b713c5d7777b0703821a73c1d9a4c3755501042120534ff13990975e1f5"
    ],
    [
        "61674b992c29827186cab5ff454758dbbed8e89bc23d0bd33193afccc3a04bc",
        "38e1020744c13903809ea30a0662fdb5226ae760cdcf10800faabec452e00f8"
    ],
    [
        "2ea2d48bcb83c0c9cda4efe11f07165cfcbc9ccd26526e5fb12556316d4b1df",
        "1d2d68b74ad384c5c4a9c85453104216357bfcdf635680b40215f0f800974cb"
    ],
    [
        "7881212050264c40c336ed3a15dd2cd868ec9a558f5b728869eab66e8b8ed54",
        "21aaefcc8ad8a161b8971d6880321781dbd939570c540da4c330922b8c81e9b"
    ],
    [
        "b6be88ce0461d20f59c5199573cda0170b61decf6e8e69a6d32f1695adc4ed",
        "5536e4808370716f2bb3423a9a49a38ddbfe91faf3b7a35eb53d3519238b6cf"
    ],
    [
        "e5972af1655eb6dde2e8c77cc58044299922441b5ee41ceaf5cafedc765bcc",
        "550282f37a4783dd60801c237045992d6fbe82a5902e7d837ea25f6f98c7b3a"
    ],
    [
        "7efc1aad1f580d8f50274f1c114c40056be19a8c96fa8c4cb5bf85e1e7f3e4",
        "2689f1c3898b114d668be6413643ee9f879913d40c262541fd0316264c60a4f"
    ],
    [
        "7939db98037f59b0113e9d60051f75ac9c3cfd1a3eb535c73e2d945068c6c5c",
        "410914ca8bbf3c65cdf3e9772ca790c19131c50068d34b7346c10260a578a8e"
    ],
    [
        "225b77ad00a2b83d26690190b74867326eca4f55bfbc3a13be036225ca3b1b5",
        "411faafef89042ce6beb64309fdaff70fa53e9d32d79a21e7f82f80e79ff05e"
    ],
    [
        "1501e64c99c8b6658b0479f2c05c9142d246eaabfccf2fcec8dc4399539d8e1",
        "3bab1e3339e42c9ee66c65b0b20236fdd9362d3ce786ad3a9779ab578af50a8"
    ],
    [
        "59b907b941f24fb8ea2458153e55f07534b388e835af7b69f3c9f54392a335",
        "1d5438c4f2f68a417f3d56f916d899a6ffe910f5f2989ca31687f1b10f60db8"
    ],
    [
        "2887d08a26f484546f360e33abbf7a998b7170a5b30070938b84f072c676bf3",
        "62a78e8d00e5d3a59e2fc424ffa08961567ba1ef24c8531cd7bceee6074a535"
    ],
    [
        "6e3cc8076b3d45377929033af35aab0c6d19ae4fd47c0daf844079ca04c46eb",
        "7b90f338e4d848aa8f19d0b5c3bca916a2a9024acbf14bddb278bca2aa39e5f"
    ],
    [
        "34844dacdd3ec54a3af328bb9d67715ab33425e194ac9977ca02ef22e8f7a88",
        "3c1affc6372f32a1634748124f9e1a03c4f0c993971da0dc28888b0801279d"
    ],
    [
        "436b192e03a49796cf9bc5e93c88268b71c9c24f9c3a85322bba634ebea309d",
        "67a8091ef69d62abcb28ce5df4dc7d53f8dc2b9690344f75ecd03a6d9386044"
    ],
    [
        "592d25b68baff87a6d7fd41ff0dadbddc1bd1316683de3b2d677501c0eb14e4",
        "27ad1e1099683f54589010faeefb19e38569ace43653be8787a42b0591e7bc5"
    ],
    [
        "89a5111ae911512ba62e87b97f643c0219702f235c70f62c6678a129302009",
        "557fa3d98e9ce7b83b47545013a4498f3de43787fb66b1a54521222242f7c1b"
    ],
    [
        "1c9b5e53377e72da5066cb08566bbf9ec31ec1877f455d932cd9b1aa375d34e",
        "72f79555a8bc207863f32d482fca54692825449fd8963fcea3de3a8183a739a"
    ],
    [
        "574a6e05eb14591729515be239ea8c1fa9e12d4049d42876f76c8ff37bca03",
        "5f99b3af43ca68c1c73e8190d5f73c8de162ba643d7d5f0cd73cfa8135db6d3"
    ],
    [
        "513fc5c2e16505b2b25a2f284e167d5401194bcac0dc3ecf8b7c9acb560daa1",
        "687ee7a1a8954d08d3856e1a16ded808e419e789736d3f55f79f7693bad69f5"
    ],
    [
        "53d48bd1205274b1c2b0a0ceb3d21c5fcd7c8892a784931603240b288a598b9",
        "35387abd7ea59c9b956de44d36533cad1f6668c438d666651695ff3862159be"
    ],
    [
        "213eb1ea99e08825110dd61094eb6e8145119dc1c507636f068730b1e086d44",
        "744f6853f4f02f4f042468d0739e0c9f64df720b87ed77d1979547084ef7a89"
    ],
    [
        "735ef017d091ca23264ad0aa7bb9b2be3309b4539605e79ed4a652ccb2fbe3c",
        "7f0ccc7a5747c4e921fff97d431169f690763427e2cfd1ad74d7a0308d7faa9"
    ],
    [
        "3f36babc5a30070b610ed97db44997e6d9115c9c0579ad8f75d295a17130001",
        "79047908a2474e32d5c712a07bf5c4ad522590bb5d6cefda410d30528e12ca8"
    ],
    [
        "51c04907ae88a5926b242fb2862cb1f2c651a94e6caad5bff8601c079fded74",
        "10a585a269f460aed43f54c7de13cdf623fc8de5957526997278be939ef32ad"
    ],
    [
        "c1e1bd626a735aa2c065831317217ecce68e377eb1f67e54ce2e97bc2ef2dc",
        "53c5af23a9b482f420be6dfd37b6886154cfd130794098e1f51c1885ac2556a"
    ],
    [
        "5aff3b30775ae4758e604a4a6262803a545f5ef4e7855fa245ac6a6431a9ece",
        "39a4799e5519047f29333bee9c86c99bfa8056d4aa381c396c4a44331fe795f"
    ],
    [
        "3d753e9723701a8e9d99b91bb93dee2eda7ffa5072fb2cd5c5fd99aebcdb299",
        "15798bf5c17d6d5880fed1553af32dd8d8baf2888c715a886575448a24c7975"
    ],
    [
        "6593e5078466b07a4222d2e544da826d2c583c9cc5f2eaea148b129b00d4aa0",
        "11b352b08a0a61d3cd67d1dc08069dec3bde907b3da0f56de5011b956bf8744"
    ],
    [
        "7a6eb353c5be9ff03fe4a06c01fb71aad2b38144179a291ebcbb2c2417cca65",
        "3de3ecb12f2fa699b46a9d399abf77ca17bebc3e491bfb2542dd0fba991e2bb"
    ],
    [
        "2c7ead583d6c32162091034a9eddfa775b4e84b8bdbea939edb2a80dcf64f6",
        "461790ce40d9c276d962b2a1e9a74d66e9d7335962e234e8a2fc6963d31722d"
    ],
    [
        "34285af023d9b4c2c2b88e8704bf2c05a9b553b00b2e70ff05f8c2970cb134f",
        "33fe678e7671760a83836107428dbade68c3593fbe568f3f8f1b2c568099c44"
    ],
    [
        "6222f720a24466263db6a11842f117fc4bb78da6705f140e48869db3e087441",
        "6eff5b9bf3aeedc962bc5a24b66e7bdad2153450ed53a058bf2c8dbf2907693"
    ],
    [
        "17c6ec5ea206eb97cbf53851e37ce391080e0d2bf1e5395610f79ab0503f7ce",
        "3adb71ca3523d88ceb1e365f12dfb24895453c14daf0046b2626cddadfdf5f7"
    ],
    [
        "70859f9771a713e54974ce11cdaf44b0dcc3e9befa0c0834908d877eeaafd27",
        "d18f794bf0cc0623b711e7450030424e52326c45ba9b03341883ae4828a5f8"
    ],
    [
        "2a820cfd0fd4ab0871e7b303cd545a3086caf8fa818c087a4017197da74efbf",
        "5f992683ff37f6c041b84bfc01503d333ac9763505cc8f69473da01812969d1"
    ],
    [
        "5b0526de2c07fe7cd73e3884f642d57a0ac5e13c68590ed03a14e530616e8c1",
        "eec69d0cbd92c9fca31ec967dba848bec368e792d6678797946a5e34fe3487"
    ],
    [
        "6cf6b3efee707210cb3a72f1e885c3d0953aefb43e5e148c740aa1641725c61",
        "911cb630b898e2c1a9115f9e45bafe3b819edfb1eab6e15612d14289939984"
    ],
    [
        "74e913de55f1e46143cb2ecfc580f8d3d3908f200281322b84e21c989cda293",
        "761d2736c9ac7670ba905bc2629c6c0dbe988820a4454ff415ba68710f7df92"
    ],
    [
        "44084305e0c911a40b7cbefe5f13cffe9a99375d1a584c4a2200958050af7a9",
        "249c83877371564708ea525b64b1e7e12785460d83364446531c9adcacba5f0"
    ],
    [
        "2bf71ad4d1bee1a67fb300477029f54bdb0e09f78bf2ac2e8afc7465a7adbcc",
        "6244dd6cad282539049be57487bfd9900bb0d5da805d02b535096368fcb4cd5"
    ],
    [
        "3a62d8f763b62def36e4089458046a49c5ecb91b861549530773e0548ff2bb",
        "6a10a03ba61e6ac657270465c09aa9526cf1ebe96bdecdf0e7000476a47b9eb"
    ],
    [
        "284eed3a17c51e0677d4fe897f056abe9def8af07a4630e6ca5723e2aa6677",
        "516a06ac1d5626ed03d2eee9de6f60f0311eca703a99b0fb31b9c66b01c27c7"
    ],
    [
        "2a2c63b16cccd685f731d06fe93ce2cffb358d34d03dda9a7368185c1eb0c32",
        "7180baca0ba81284809f92eca1654cd76b925a9242e5d5e0f18d0a55d13c6ec"
    ],
    [
        "5f9466017ec09769611389ea5370ad68dda936d3f5816c9e928ff9574abf9a7",
        "6619b5b145bb5f4f29deb7a4cd68ef4da3995312fa6537f0d01684da4267ece"
    ],
    [
        "74f229babe01b4962b3307589c1a13019134b1db6822698388bebb55d21c30f",
        "156ae857ab3279f754facba0db36398dffec8c31e5e160473198f2f891b7531"
    ],
    [
        "334b9fe3a5fd99bc966ddd1309698fd32afd1f235062f2c275b6616a185de45",
        "221a60053583cc0607f6f2e6966b62fc9dac00538bb7eb1148e007a92116d2"
    ],
    [
        "7ad710ba002a67c731efbaba2149d16fec5d2f7aa3d126fd9886172e9f4ea30",
        "3a10f8e902a7a13aec94d66415347e1314f9bac83a7db176096b809b25ffb86"
    ],
    [
        "4306dd0a184a3283c3097ff8f7434cec80912e9dc04b7df21ba73fda9f8e6d8",
        "6d42bd3d1a8dbddafd09e872e2aa3891ae79ec939dc1b382196bc21c4ab749"
    ],
    [
        "1c3f2124e1135c32a426d1d14e471edd9e0f2c7bd703ee123cbbd608e8c4be7",
        "3cc607a3c3f1ab68dd5fa56c65996002721b8ad8ad4b0dd9e5b1467d316583"
    ],
    [
        "294af33272ffcee0b56a436de1b73759cbddebef4c07888b42c2f92b0b68e1",
        "d837164311d5dca8d37b99ef9eb22708643c83d1cbdfe852f63ea07b06fbad"
    ],
    [
        "753bdb5439a19bbffdfa02b1dc24e8368f22d0a8276b109c11e6feb26f56f39",
        "6ed396231af93647633eab467f1a034f38e76823eb85baf97cae56e2dcd9f75"
    ],
    [
        "5674f0cb892b733fc0b50e121d8679afed0a925c32594cc65ffe83bebe7748e",
        "7fbf0325dd38dd94905adab2c52758552292a6a103d9edfcb11938828e828c8"
    ],
    [
        "4a8f053573a0a74251059d0229d89b6660407ba0b491779fd10f87a5117c81f",
        "21b70112485398bf67ec9d733df24a1df30dea718a93b786f41ed04e3ae3c5e"
    ],
    [
        "726c01ec4a08df8fc8de173311f50d4f3b97c5a9cf68c1536146f827db95ae8",
        "15013cafadefa7f1c4e4dfdd70bd4d3979dd18bd7f0332572ce2a3fd8773d12"
    ],
    [
        "38ac0fbfa98937257460db7e6645d7e5112b6fce7234813fc8a704e8ade8da2",
        "73c0109f86048aad08c443f781ae60ad13b99f7b9cfdf3128fe6d6eeb799a7b"
    ],
    [
        "6f6d3a38621582ace092eb50ecfe9eff265df141ebdcab8653299116fcea291",
        "4a1bf3f39bc919c8f1b720a0b1ce952cad17f2ba98308ee6b76dd9b6f3d7b75"
    ],
    [
        "6a307fc28e1df8d9ad01766419e097797d65cb674436fa1c8f012d3de2c2a1f",
        "26911a635ba824db004875d79dd84834a97ac12643e42829015bf88c1fd6f05"
    ],
    [
        "2a74860e3336d6db916555894cc8028f41508812925db1925457afe40257155",
        "5f8da573f4c39816ce2dba8a20224223a7cfec53117ec78973930c0e9b60244"
    ],
    [
        "4d2b49e1ed0799f719b8269f092cb489a466a645bc0ccabafdc678864c176d7",
        "5410083df7d256f18cbf5697ae5e52c31e075d8a3b27e21d6f5177ca882f6c1"
    ],
    [
        "110ecb9fbf6c333d168cee473cc5ad98809b6cb9eb5d1f6cd28ab5fab504fd3",
        "7e3c54d7533d9f8c3310f219dab0cc3ea4d39b418a748eeffd6bae2b8637a43"
    ],
    [
        "5be4d711b80da70e6d3ac493250bbfd16f20b25f31919b3a91cf14ffbac1096",
        "7f55a0919f082e8885f1515e83c5b39b6022404503507498e1b4422d79c43e2"
    ],
    [
        "2605125b95ca4ba93a21cbbba5762898a7cf9e988f07ab9e64cb3868e3b139d",
        "62f0ccf55b9fc0eaf9736fc8ee484e2acdbe259813af9803cf815829a5e9d3b"
    ],
    [
        "1092bbbf206f2a3068167c3dd99a72de31e206f6c504c071c8214d105ff814d",
        "309f489f68a62089f53b96df5d4fbc3ecc5a1a42eb7ece0e49bad17ad490ff4"
    ],
    [
        "2abdee9409d9c92559ca3f4e6bddd649c31aa09b90bfcb4a612af491241e18d",
        "3ffa8eac180a29de3f8a69efca84bac046f921f5725e96a6ff0530be1436aaf"
    ],
    [
        "376313f27d00bb1aae7ec991745efe6ee28c6b50de0c6cd9845cc4bb4f83543",
        "6a8e0a9389ba528b156fa94ac090a895d7b795818d4941c29415d9e2984c547"
    ],
    [
        "a80380c71bd466a696b3f0fbf02817c9459d9798f4f3899cf32edf647fe066",
        "6a09805e814e7cdfc76eba4b79f1df5ae559e0f0aba9f728d3cba4ea5c57471"
    ],
    [
        "223694b921d247d989a79b9b2b2f07496036c40cb043eab074a9d6a2cd2ffed",
        "c247217f1b1df35e30d9e15fdaadf42d6fb0edd3a5a7e265d4cdc426c120aa"
    ],
    [
        "102333620df278c6714bbc880fc087db58c1b9b4d77ed4d61b32a74bfc7c3e2",
        "6a77d37727ccf71c2caeb151faf4404d4b94e9047f9f0a7c3966367f3b53c65"
    ],
    [
        "891626f466536929ee7eadcd18b41925706dedab7528ed5f0f7abf039eb9d2",
        "5f73d11c141c933a35b2d0d06e5cbae614a20d17dc3b439f8bcdc3413c5ea37"
    ],
    [
        "215c23fd3f073f870e5e80303967391bf173f8adcdbeec72d131c557babc203",
        "10634332e9d9439a321597dc5b0fac9ff478834c3d6e281735f21a4a5e13266"
    ],
    [
        "21ea0bdc1332bc36e6aeb43be9071651c27e4ea2eadec636c8d818d4af72a36",
        "3a523d9643dccc6bb9c7c58413312caa3e60ba9c7c7f0177e0f3f469a3241e3"
    ],
    [
        "60deaed1bffb6190beed40caaf2bfab5e43d3707aff7ad3f278d571aa247eae",
        "e41f71ff254c1418e6a66992af307789fe04d6606fb2670900bb1a089fd879"
    ],
    [
        "1e1fac4a1646253fb1332fadc21fbdd3e3a24a840d129400f520ae4116a4cf5",
        "69c406f9f46576afad68808de0ab7e8922b6226af748e721d9097e21f1800f3"
    ],
    [
        "5db0ddcdf79ffe74d6454c12d2bc60b06776db03c75dc413f5be42ea9a91b5e",
        "134c3d6c699841f17306835bb193785228ffe7ab212a01a861c56b086a18cec"
    ],
    [
        "626814e320fb5bea505b248fd1c1389ad586c1cfe04923fe2f83173e915f4f8",
        "7ae407a926e887206a8b85cf485f1f327c9bb8ccbb6897024e2d122877d8ee0"
    ],
    [
        "23186237dc7d3b570cea645282ad4c359731bbfa54e7f036426bf6493812cd",
        "7d1fbab7e61a22d3b00993290d9f4cd5d820061573e787f66c2cff9a18e1eaf"
    ],
    [
        "54302dcb0e6cc1c6e44cca8f61a63bb2ca65048d53fb325d36ff12c49a58202",
        "1b77b3e37d13504b348046268d8ae25ce98ad783c25561a879dcc77e99c2426"
    ],
    [
        "13961b56b9fc0e412e468c385c22bd0680a25624ec211ffbb6bc877b2a6926c",
        "62f7f7792c77cd981fad13cb6863fe099c4d971c1374109185eae99943f16e9"
    ],
    [
        "47abd7308c70659af3f00fafe6837298af3cb530b6c2ba710ffd07a6bc1ae98",
        "75d0c8a7377aa9f0663d0c124a5659750847afabc29e39893fd27534a4a03cb"
    ],
    [
        "2c6276b764fb398fa555857dbe0ce0ec18fab7a233bf23851295739801f0585",
        "5d8f4897ce44007ec5bfcb9aeb78b8f6e1d40a514f72d213c9300d2770d2b8c"
    ]
];
// src/utils/ellipticCurve.ts
var $facb0cbc5626d02c$export$6be572eb25b0fc90 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$6be572eb25b0fc90, {
    ec: function() {
        return $facb0cbc5626d02c$var$ec;
    },
    genKeyPair: function() {
        return $facb0cbc5626d02c$var$genKeyPair;
    },
    getKeyPair: function() {
        return $facb0cbc5626d02c$var$getKeyPair;
    },
    getKeyPairFromPublicKey: function() {
        return $facb0cbc5626d02c$var$getKeyPairFromPublicKey;
    },
    getStarkKey: function() {
        return $facb0cbc5626d02c$var$getStarkKey;
    },
    sign: function() {
        return $facb0cbc5626d02c$var$sign;
    },
    verify: function() {
        return $facb0cbc5626d02c$var$verify;
    }
});
var $facb0cbc5626d02c$var$EC = (0, (/*@__PURE__*/$parcel$interopDefault($492wS))).ec, $facb0cbc5626d02c$var$curves = (0, (/*@__PURE__*/$parcel$interopDefault($492wS))).curves;
var $facb0cbc5626d02c$var$ec = new $facb0cbc5626d02c$var$EC(new $facb0cbc5626d02c$var$curves.PresetCurve({
    type: "short",
    prime: null,
    p: $facb0cbc5626d02c$var$FIELD_PRIME,
    a: "00000000 00000000 00000000 00000000 00000000 00000000 00000000 00000001",
    b: "06f21413 efbe40de 150e596d 72f7a8c5 609ad26c 15c915c1 f4cdfcb9 9cee9e89",
    n: $facb0cbc5626d02c$var$EC_ORDER,
    hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
    gRed: false,
    g: $facb0cbc5626d02c$var$CONSTANT_POINTS[1]
}));
function $facb0cbc5626d02c$var$fixMessage(msg) {
    var pureHex = msg.replace(/^0x0*/, "");
    if (pureHex.length <= 62) return pureHex;
    (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(pureHex.length === 63);
    return "".concat(pureHex, "0");
}
var $facb0cbc5626d02c$var$genKeyPair = $facb0cbc5626d02c$var$ec.genKeyPair.bind($facb0cbc5626d02c$var$ec);
function $facb0cbc5626d02c$var$getKeyPair(pk) {
    var pkBn = $facb0cbc5626d02c$var$toBN(pk);
    return $facb0cbc5626d02c$var$ec.keyFromPrivate($facb0cbc5626d02c$var$removeHexPrefix($facb0cbc5626d02c$var$toHex(pkBn)), "hex");
}
function $facb0cbc5626d02c$var$getStarkKey(keyPair) {
    keyPair.getPublic(true, "hex");
    return $facb0cbc5626d02c$var$addHexPrefix($facb0cbc5626d02c$var$sanitizeBytes(keyPair.pub.getX().toString(16), 2));
}
function $facb0cbc5626d02c$var$getKeyPairFromPublicKey(publicKey) {
    var publicKeyBn = $facb0cbc5626d02c$var$toBN(publicKey);
    return $facb0cbc5626d02c$var$ec.keyFromPublic($facb0cbc5626d02c$var$removeHexPrefix($facb0cbc5626d02c$var$toHex(publicKeyBn)), "hex");
}
function $facb0cbc5626d02c$var$sign(keyPair, msgHash) {
    var msgHashBN = $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$addHexPrefix(msgHash));
    $facb0cbc5626d02c$var$assertInRange(msgHashBN, $facb0cbc5626d02c$var$ZERO, $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$addHexPrefix($facb0cbc5626d02c$var$MAX_ECDSA_VAL)), "msgHash");
    var msgSignature = keyPair.sign($facb0cbc5626d02c$var$fixMessage(msgHash));
    var r = msgSignature.r, s = msgSignature.s;
    var w = s.invm($facb0cbc5626d02c$var$ec.n);
    $facb0cbc5626d02c$var$assertInRange(r, $facb0cbc5626d02c$var$ONE, $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$addHexPrefix($facb0cbc5626d02c$var$MAX_ECDSA_VAL)), "r");
    $facb0cbc5626d02c$var$assertInRange(s, $facb0cbc5626d02c$var$ONE, $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$addHexPrefix($facb0cbc5626d02c$var$EC_ORDER)), "s");
    $facb0cbc5626d02c$var$assertInRange(w, $facb0cbc5626d02c$var$ONE, $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$addHexPrefix($facb0cbc5626d02c$var$MAX_ECDSA_VAL)), "w");
    return [
        r.toString(),
        s.toString()
    ];
}
function $facb0cbc5626d02c$var$chunkArray(arr, n) {
    return Array(Math.ceil(arr.length / n)).fill("").map(function(_, i) {
        return arr.slice(i * n, i * n + n);
    });
}
function $facb0cbc5626d02c$var$verify(keyPair, msgHash, sig) {
    var keyPairArray = Array.isArray(keyPair) ? keyPair : [
        keyPair
    ];
    var msgHashBN = $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$addHexPrefix(msgHash));
    (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(sig.length % 2 === 0, "Signature must be an array of length dividable by 2");
    $facb0cbc5626d02c$var$assertInRange(msgHashBN, $facb0cbc5626d02c$var$ZERO, $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$addHexPrefix($facb0cbc5626d02c$var$MAX_ECDSA_VAL)), "msgHash");
    (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(keyPairArray.length === sig.length / 2, "Signature and keyPair length must be equal");
    return $facb0cbc5626d02c$var$chunkArray(sig, 2).every(function(param, i) {
        var _param = (0, $8GFUW._)(param, 2), r = _param[0], s = _param[1];
        var rBN = $facb0cbc5626d02c$var$toBN(r);
        var sBN = $facb0cbc5626d02c$var$toBN(s);
        var w = sBN.invm($facb0cbc5626d02c$var$ec.n);
        $facb0cbc5626d02c$var$assertInRange(rBN, $facb0cbc5626d02c$var$ONE, $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$addHexPrefix($facb0cbc5626d02c$var$MAX_ECDSA_VAL)), "r");
        $facb0cbc5626d02c$var$assertInRange(sBN, $facb0cbc5626d02c$var$ONE, $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$addHexPrefix($facb0cbc5626d02c$var$EC_ORDER)), "s");
        $facb0cbc5626d02c$var$assertInRange(w, $facb0cbc5626d02c$var$ONE, $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$addHexPrefix($facb0cbc5626d02c$var$MAX_ECDSA_VAL)), "w");
        var _ec_verify;
        return (_ec_verify = $facb0cbc5626d02c$var$ec.verify($facb0cbc5626d02c$var$fixMessage(msgHash), {
            r: rBN,
            s: sBN
        }, keyPairArray[i])) !== null && _ec_verify !== void 0 ? _ec_verify : false;
    });
}
// src/utils/hash.ts
var $facb0cbc5626d02c$var$transactionVersion = 1;
var $facb0cbc5626d02c$var$feeTransactionVersion = $facb0cbc5626d02c$var$toBN(2).pow($facb0cbc5626d02c$var$toBN(128)).add($facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$transactionVersion));
function $facb0cbc5626d02c$var$keccakBn(value) {
    var hexWithoutPrefix = $facb0cbc5626d02c$var$removeHexPrefix($facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(value)));
    var evenHex = hexWithoutPrefix.length % 2 === 0 ? hexWithoutPrefix : "0".concat(hexWithoutPrefix);
    return $facb0cbc5626d02c$var$addHexPrefix($facb0cbc5626d02c$var$buf2hex((0, $jxD7z.keccak256)((0, $kLNKc.hexToBytes)(evenHex))));
}
function $facb0cbc5626d02c$var$keccakHex(value) {
    return $facb0cbc5626d02c$var$addHexPrefix($facb0cbc5626d02c$var$buf2hex((0, $jxD7z.keccak256)($facb0cbc5626d02c$var$utf8ToArray(value))));
}
function $facb0cbc5626d02c$var$starknetKeccak(value) {
    return $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$keccakHex(value)).and($facb0cbc5626d02c$var$MASK_250);
}
function $facb0cbc5626d02c$var$getSelectorFromName(funcName) {
    return $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$starknetKeccak(funcName));
}
function $facb0cbc5626d02c$var$getSelector(value) {
    if ($facb0cbc5626d02c$var$isHex(value)) return value;
    if ($facb0cbc5626d02c$var$isStringWholeNumber(value)) return $facb0cbc5626d02c$var$toHexString(value);
    return $facb0cbc5626d02c$var$getSelectorFromName(value);
}
var $facb0cbc5626d02c$var$constantPoints = $facb0cbc5626d02c$var$CONSTANT_POINTS.map(function(coords) {
    return $facb0cbc5626d02c$var$ec.curve.point(coords[0], coords[1]);
});
function $facb0cbc5626d02c$var$pedersen(input) {
    var point = $facb0cbc5626d02c$var$constantPoints[0];
    for(var i = 0; i < input.length; i += 1){
        var x = $facb0cbc5626d02c$var$toBN(input[i]);
        (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(x.gte($facb0cbc5626d02c$var$ZERO) && x.lt($facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$addHexPrefix($facb0cbc5626d02c$var$FIELD_PRIME))), "Invalid input: ".concat(input[i]));
        if (!x.isZero()) for(var j = 0; j < 252; j += 1){
            var pt = $facb0cbc5626d02c$var$constantPoints[2 + i * 252 + j];
            (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(!point.getX().eq(pt.getX()));
            if (x.and($facb0cbc5626d02c$var$ONE).toNumber() !== 0) point = point.add(pt);
            x = x.shrn(1);
        }
    }
    return $facb0cbc5626d02c$var$addHexPrefix(point.getX().toString(16));
}
function $facb0cbc5626d02c$var$computeHashOnElements(data) {
    return (0, $fLnyw._)(data).concat([
        data.length
    ]).reduce(function(x, y) {
        return $facb0cbc5626d02c$var$pedersen([
            x,
            y
        ]);
    }, 0).toString();
}
function $facb0cbc5626d02c$var$calculateTransactionHashCommon(txHashPrefix, version, contractAddress, entryPointSelector, calldata, maxFee, chainId) {
    var additionalData = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : [];
    var calldataHash = $facb0cbc5626d02c$var$computeHashOnElements(calldata);
    var dataToHash = [
        txHashPrefix,
        version,
        contractAddress,
        entryPointSelector,
        calldataHash,
        maxFee,
        chainId
    ].concat((0, $fLnyw._)(additionalData));
    return $facb0cbc5626d02c$var$computeHashOnElements(dataToHash);
}
function $facb0cbc5626d02c$var$calculateDeployTransactionHash(contractAddress, constructorCalldata, version, chainId) {
    return $facb0cbc5626d02c$var$calculateTransactionHashCommon("0x6465706c6f79" /* DEPLOY */ , version, contractAddress, $facb0cbc5626d02c$var$getSelectorFromName("constructor"), constructorCalldata, $facb0cbc5626d02c$var$ZERO, chainId);
}
function $facb0cbc5626d02c$var$calculateDeclareTransactionHash(classHash, senderAddress, version, maxFee, chainId, nonce) {
    return $facb0cbc5626d02c$var$calculateTransactionHashCommon("0x6465636c617265" /* DECLARE */ , version, senderAddress, 0, [
        classHash
    ], maxFee, chainId, [
        nonce
    ]);
}
function $facb0cbc5626d02c$var$calculateDeployAccountTransactionHash(contractAddress, classHash, constructorCalldata, salt, version, maxFee, chainId, nonce) {
    var calldata = [
        classHash,
        salt
    ].concat((0, $fLnyw._)(constructorCalldata));
    return $facb0cbc5626d02c$var$calculateTransactionHashCommon("0x6465706c6f795f6163636f756e74" /* DEPLOY_ACCOUNT */ , version, contractAddress, 0, calldata, maxFee, chainId, [
        nonce
    ]);
}
function $facb0cbc5626d02c$var$calculateTransactionHash(contractAddress, version, calldata, maxFee, chainId, nonce) {
    return $facb0cbc5626d02c$var$calculateTransactionHashCommon("0x696e766f6b65" /* INVOKE */ , version, contractAddress, 0, calldata, maxFee, chainId, [
        nonce
    ]);
}
function $facb0cbc5626d02c$var$calculateContractAddressFromHash(salt, classHash, constructorCalldata, deployerAddress) {
    var constructorCalldataHash = $facb0cbc5626d02c$var$computeHashOnElements(constructorCalldata);
    var CONTRACT_ADDRESS_PREFIX = $facb0cbc5626d02c$var$toFelt("0x535441524b4e45545f434f4e54524143545f41444452455353");
    var dataToHash = [
        CONTRACT_ADDRESS_PREFIX,
        deployerAddress,
        salt,
        classHash,
        constructorCalldataHash
    ];
    return $facb0cbc5626d02c$var$computeHashOnElements(dataToHash);
}
// src/utils/json.ts
var $facb0cbc5626d02c$export$7b419323e6ed4f31 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$7b419323e6ed4f31, {
    default: function() {
        return $facb0cbc5626d02c$var$json_default;
    },
    parse: function() {
        return $facb0cbc5626d02c$var$parse;
    },
    parseAlwaysAsBig: function() {
        return $facb0cbc5626d02c$var$parseAlwaysAsBig;
    },
    stringify: function() {
        return $facb0cbc5626d02c$var$stringify;
    },
    stringifyAlwaysAsBig: function() {
        return $facb0cbc5626d02c$var$stringifyAlwaysAsBig;
    }
});
var $facb0cbc5626d02c$var$json = function(alwaysParseAsBig) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7QjXN)))({
        alwaysParseAsBig: alwaysParseAsBig,
        useNativeBigInt: true,
        protoAction: "preserve",
        constructorAction: "preserve"
    });
};
var $facb0cbc5626d02c$var$_json = $facb0cbc5626d02c$var$json(false), $facb0cbc5626d02c$var$parse = $facb0cbc5626d02c$var$_json.parse, $facb0cbc5626d02c$var$stringify = $facb0cbc5626d02c$var$_json.stringify;
var $facb0cbc5626d02c$var$_json1 = $facb0cbc5626d02c$var$json(true), $facb0cbc5626d02c$var$parseAlwaysAsBig = $facb0cbc5626d02c$var$_json1.parse, $facb0cbc5626d02c$var$stringifyAlwaysAsBig = $facb0cbc5626d02c$var$_json1.stringify;
var $facb0cbc5626d02c$var$json_default = {
    parse: $facb0cbc5626d02c$var$parse,
    stringify: $facb0cbc5626d02c$var$stringify
};
// src/utils/stark.ts
var $facb0cbc5626d02c$export$56c09bfdffd6a7c6 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$56c09bfdffd6a7c6, {
    compileCalldata: function() {
        return $facb0cbc5626d02c$var$compileCalldata;
    },
    compressProgram: function() {
        return $facb0cbc5626d02c$var$compressProgram;
    },
    estimatedFeeToMaxFee: function() {
        return $facb0cbc5626d02c$var$estimatedFeeToMaxFee;
    },
    formatSignature: function() {
        return $facb0cbc5626d02c$var$formatSignature;
    },
    makeAddress: function() {
        return $facb0cbc5626d02c$var$makeAddress;
    },
    randomAddress: function() {
        return $facb0cbc5626d02c$var$randomAddress;
    }
});
function $facb0cbc5626d02c$var$compressProgram(jsonProgram) {
    var stringified = typeof jsonProgram === "string" ? jsonProgram : $facb0cbc5626d02c$var$stringify(jsonProgram);
    var compressedProgram = (0, $kGJ2Q.gzip)(stringified);
    return $facb0cbc5626d02c$var$btoaUniversal(compressedProgram);
}
function $facb0cbc5626d02c$var$randomAddress() {
    var randomKeyPair = $facb0cbc5626d02c$var$genKeyPair();
    return $facb0cbc5626d02c$var$getStarkKey(randomKeyPair);
}
function $facb0cbc5626d02c$var$makeAddress(input) {
    return $facb0cbc5626d02c$var$addHexPrefix(input).toLowerCase();
}
function $facb0cbc5626d02c$var$formatSignature(sig) {
    if (!sig) return [];
    try {
        return sig.map(function(x) {
            return $facb0cbc5626d02c$var$toBN(x);
        }).map(function(x) {
            return x.toString();
        });
    } catch (e) {
        return [];
    }
}
function $facb0cbc5626d02c$var$compileCalldata(args) {
    return Object.values(args).flatMap(function(value) {
        if (Array.isArray(value)) return [
            $facb0cbc5626d02c$var$toBN(value.length).toString()
        ].concat((0, $fLnyw._)(value.map(function(x) {
            return $facb0cbc5626d02c$var$toBN(x).toString();
        })));
        if (typeof value === "object" && "type" in value) return Object.entries(value).filter(function(param) {
            var _param = (0, $8GFUW._)(param, 1), k = _param[0];
            return k !== "type";
        }).map(function(param) {
            var _param = (0, $8GFUW._)(param, 2), v = _param[1];
            return $facb0cbc5626d02c$var$toBN(v).toString();
        });
        return $facb0cbc5626d02c$var$toBN(value).toString();
    });
}
function $facb0cbc5626d02c$var$estimatedFeeToMaxFee(estimatedFee) {
    var overhead = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.5;
    var overHeadPercent = Math.round((1 + overhead) * 100);
    return $facb0cbc5626d02c$var$toBN(estimatedFee).mul($facb0cbc5626d02c$var$toBN(overHeadPercent)).div($facb0cbc5626d02c$var$toBN(100));
}
// src/utils/provider.ts
function $facb0cbc5626d02c$var$wait(delay) {
    return new Promise(function(res) {
        setTimeout(res, delay);
    });
}
function $facb0cbc5626d02c$var$parseCalldata() {
    var calldata = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return calldata.map(function(data) {
        if (typeof data === "string" && $facb0cbc5626d02c$var$isHex(data)) return data;
        return $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(data));
    });
}
function $facb0cbc5626d02c$var$parseContract(contract) {
    var parsedContract = typeof contract === "string" ? $facb0cbc5626d02c$var$parse(contract) : contract;
    return (0, $8E768._)((0, $8OnJk._)({}, parsedContract), {
        program: $facb0cbc5626d02c$var$compressProgram(parsedContract.program)
    });
}
// src/utils/responseParser/rpc.ts
var $facb0cbc5626d02c$var$RPCResponseParser = /*#__PURE__*/ function() {
    "use strict";
    function RPCResponseParser() {
        (0, $978gY._)(this, RPCResponseParser);
    }
    (0, $kry2a._)(RPCResponseParser, [
        {
            key: "parseGetBlockResponse",
            value: function parseGetBlockResponse(res) {
                return {
                    timestamp: res.timestamp,
                    block_hash: res.block_hash,
                    block_number: res.block_number,
                    new_root: res.new_root,
                    parent_hash: res.parent_hash,
                    status: res.status,
                    transactions: res.transactions
                };
            }
        },
        {
            key: "parseGetTransactionResponse",
            value: function parseGetTransactionResponse(res) {
                return {
                    calldata: res.calldata || [],
                    contract_address: res.contract_address,
                    max_fee: res.max_fee,
                    nonce: res.nonce,
                    signature: res.signature || [],
                    transaction_hash: res.transaction_hash,
                    version: res.version
                };
            }
        },
        {
            key: "parseFeeEstimateResponse",
            value: function parseFeeEstimateResponse(res) {
                return {
                    overall_fee: $facb0cbc5626d02c$var$toBN(res.overall_fee),
                    gas_consumed: $facb0cbc5626d02c$var$toBN(res.gas_consumed),
                    gas_price: $facb0cbc5626d02c$var$toBN(res.gas_price)
                };
            }
        },
        {
            key: "parseCallContractResponse",
            value: function parseCallContractResponse(res) {
                return {
                    result: res
                };
            }
        }
    ]);
    return RPCResponseParser;
}();
var $facb0cbc5626d02c$export$8c05b2dc6219e90a = /*#__PURE__*/ function(CustomError) {
    "use strict";
    (0, $ftJVG._)(LibraryError, CustomError);
    var _super = (0, $6OZAO._)(LibraryError);
    function LibraryError() {
        (0, $978gY._)(this, LibraryError);
        return _super.apply(this, arguments);
    }
    return LibraryError;
}((0, $aZG1x.CustomError));
var $facb0cbc5626d02c$export$8ef93724ecb8bcb7 = /*#__PURE__*/ function(LibraryError) {
    "use strict";
    (0, $ftJVG._)(GatewayError, LibraryError);
    var _super = (0, $6OZAO._)(GatewayError);
    function GatewayError(message, errorCode) {
        (0, $978gY._)(this, GatewayError);
        var _this;
        _this = _super.call(this, message);
        _this.errorCode = errorCode;
        return _this;
    }
    return GatewayError;
}($facb0cbc5626d02c$export$8c05b2dc6219e90a);
var $facb0cbc5626d02c$export$65bd6083489bd8bb = /*#__PURE__*/ function(LibraryError) {
    "use strict";
    (0, $ftJVG._)(HttpError, LibraryError);
    var _super = (0, $6OZAO._)(HttpError);
    function HttpError(message, errorCode) {
        (0, $978gY._)(this, HttpError);
        var _this;
        _this = _super.call(this, message);
        _this.errorCode = errorCode;
        return _this;
    }
    return HttpError;
}($facb0cbc5626d02c$export$8c05b2dc6219e90a);
var $facb0cbc5626d02c$var$basicAlphabet = "abcdefghijklmnopqrstuvwxyz0123456789-";
var $facb0cbc5626d02c$var$basicSizePlusOne = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))($facb0cbc5626d02c$var$basicAlphabet.length + 1);
var $facb0cbc5626d02c$var$bigAlphabet = "这来";
var $facb0cbc5626d02c$var$basicAlphabetSize = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))($facb0cbc5626d02c$var$basicAlphabet.length);
var $facb0cbc5626d02c$var$bigAlphabetSize = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))($facb0cbc5626d02c$var$bigAlphabet.length);
var $facb0cbc5626d02c$var$bigAlphabetSizePlusOne = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))($facb0cbc5626d02c$var$bigAlphabet.length + 1);
function $facb0cbc5626d02c$var$extractStars(str) {
    var k = 0;
    while(str.endsWith($facb0cbc5626d02c$var$bigAlphabet[$facb0cbc5626d02c$var$bigAlphabet.length - 1])){
        str = str.substring(0, str.length - 1);
        k += 1;
    }
    return [
        str,
        k
    ];
}
function $facb0cbc5626d02c$var$useDecoded(encoded) {
    var decoded = "";
    encoded.forEach(function(subdomain) {
        while(!subdomain.isZero()){
            var code = subdomain.mod($facb0cbc5626d02c$var$basicSizePlusOne).toNumber();
            subdomain = subdomain.div($facb0cbc5626d02c$var$basicSizePlusOne);
            if (code === $facb0cbc5626d02c$var$basicAlphabet.length) {
                var nextSubdomain = subdomain.div($facb0cbc5626d02c$var$bigAlphabetSizePlusOne);
                if (nextSubdomain.isZero()) {
                    var code2 = subdomain.mod($facb0cbc5626d02c$var$bigAlphabetSizePlusOne).toNumber();
                    subdomain = nextSubdomain;
                    if (code2 === 0) decoded += $facb0cbc5626d02c$var$basicAlphabet[0];
                    else decoded += $facb0cbc5626d02c$var$bigAlphabet[code2 - 1];
                } else {
                    var code21 = subdomain.mod($facb0cbc5626d02c$var$bigAlphabetSize).toNumber();
                    decoded += $facb0cbc5626d02c$var$bigAlphabet[code21];
                    subdomain = subdomain.div($facb0cbc5626d02c$var$bigAlphabetSize);
                }
            } else decoded += $facb0cbc5626d02c$var$basicAlphabet[code];
        }
        var _extractStars = (0, $8GFUW._)($facb0cbc5626d02c$var$extractStars(decoded), 2), str = _extractStars[0], k = _extractStars[1];
        if (k) decoded = str + (k % 2 === 0 ? $facb0cbc5626d02c$var$bigAlphabet[$facb0cbc5626d02c$var$bigAlphabet.length - 1].repeat(k / 2 - 1) + $facb0cbc5626d02c$var$bigAlphabet[0] + $facb0cbc5626d02c$var$basicAlphabet[1] : $facb0cbc5626d02c$var$bigAlphabet[$facb0cbc5626d02c$var$bigAlphabet.length - 1].repeat((k - 1) / 2 + 1));
        decoded += ".";
    });
    if (!decoded) return decoded;
    return decoded.concat("stark");
}
function $facb0cbc5626d02c$var$useEncoded(decoded) {
    var encoded = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(0);
    var multiplier = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(1);
    if (decoded.endsWith($facb0cbc5626d02c$var$bigAlphabet[0] + $facb0cbc5626d02c$var$basicAlphabet[1])) {
        var _extractStars = (0, $8GFUW._)($facb0cbc5626d02c$var$extractStars(decoded.substring(0, decoded.length - 2)), 2), str = _extractStars[0], k = _extractStars[1];
        decoded = str + $facb0cbc5626d02c$var$bigAlphabet[$facb0cbc5626d02c$var$bigAlphabet.length - 1].repeat(2 * (k + 1));
    } else {
        var _extractStars1 = (0, $8GFUW._)($facb0cbc5626d02c$var$extractStars(decoded), 2), str1 = _extractStars1[0], k1 = _extractStars1[1];
        if (k1) decoded = str1 + $facb0cbc5626d02c$var$bigAlphabet[$facb0cbc5626d02c$var$bigAlphabet.length - 1].repeat(1 + 2 * (k1 - 1));
    }
    for(var i = 0; i < decoded.length; i += 1){
        var char = decoded[i];
        var index = $facb0cbc5626d02c$var$basicAlphabet.indexOf(char);
        var bnIndex = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))($facb0cbc5626d02c$var$basicAlphabet.indexOf(char));
        if (index !== -1) {
            if (i === decoded.length - 1 && decoded[i] === $facb0cbc5626d02c$var$basicAlphabet[0]) {
                encoded = encoded.add(multiplier.mul($facb0cbc5626d02c$var$basicAlphabetSize));
                multiplier = multiplier.mul($facb0cbc5626d02c$var$basicSizePlusOne);
                multiplier = multiplier.mul($facb0cbc5626d02c$var$basicSizePlusOne);
            } else {
                encoded = encoded.add(multiplier.mul(bnIndex));
                multiplier = multiplier.mul($facb0cbc5626d02c$var$basicSizePlusOne);
            }
        } else if ($facb0cbc5626d02c$var$bigAlphabet.indexOf(char) !== -1) {
            encoded = encoded.add(multiplier.mul($facb0cbc5626d02c$var$basicAlphabetSize));
            multiplier = multiplier.mul($facb0cbc5626d02c$var$basicSizePlusOne);
            var newid = (i === decoded.length - 1 ? 1 : 0) + $facb0cbc5626d02c$var$bigAlphabet.indexOf(char);
            encoded = encoded.add(multiplier.mul(new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(newid)));
            multiplier = multiplier.mul($facb0cbc5626d02c$var$bigAlphabetSize);
        }
    }
    return encoded;
}
function $facb0cbc5626d02c$var$getStarknetIdContract(chainId) {
    var starknetIdMainnetContract = "0x6ac597f8116f886fa1c97a23fa4e08299975ecaf6b598873ca6792b9bbfb678";
    var starknetIdTestnetContract = "0x05cf267a0af6101667013fc6bd3f6c11116a14cda9b8c4b1198520d59f900b17";
    switch(chainId){
        case "0x534e5f4d41494e" /* MAINNET */ :
            return starknetIdMainnetContract;
        case "0x534e5f474f45524c49" /* TESTNET */ :
            return starknetIdTestnetContract;
        default:
            throw new Error("Starknet.id is not yet deployed on this network");
    }
}
function $facb0cbc5626d02c$var$getStarkName(provider, address, StarknetIdContract) {
    return $facb0cbc5626d02c$var$_getStarkName.apply(this, arguments);
}
function $facb0cbc5626d02c$var$_getStarkName() {
    $facb0cbc5626d02c$var$_getStarkName = // src/provider/starknetId.ts
    (0, $byzP8._)(function(provider, address, StarknetIdContract) {
        var chainId, contract, hexDomain, decimalDomain, stringDomain, e;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        provider.getChainId()
                    ];
                case 1:
                    chainId = _state.sent();
                    contract = StarknetIdContract !== null && StarknetIdContract !== void 0 ? StarknetIdContract : $facb0cbc5626d02c$var$getStarknetIdContract(chainId);
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        provider.callContract({
                            contractAddress: contract,
                            entrypoint: "address_to_domain",
                            calldata: $facb0cbc5626d02c$var$compileCalldata({
                                address: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(address))
                            })
                        })
                    ];
                case 3:
                    hexDomain = _state.sent();
                    decimalDomain = hexDomain.result.map(function(element) {
                        return new (0, $jlWHo.BN)($facb0cbc5626d02c$var$hexToDecimalString(element));
                    }).slice(1);
                    stringDomain = $facb0cbc5626d02c$var$useDecoded(decimalDomain);
                    if (!stringDomain) throw Error("Starkname not found");
                    return [
                        2,
                        stringDomain
                    ];
                case 4:
                    e = _state.sent();
                    if (e instanceof Error && e.message === "Starkname not found") throw e;
                    throw Error("Could not get stark name");
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $facb0cbc5626d02c$var$_getStarkName.apply(this, arguments);
}
function $facb0cbc5626d02c$var$getAddressFromStarkName(provider, name, StarknetIdContract) {
    return $facb0cbc5626d02c$var$_getAddressFromStarkName.apply(this, arguments);
}
function $facb0cbc5626d02c$var$_getAddressFromStarkName() {
    $facb0cbc5626d02c$var$_getAddressFromStarkName = (0, $byzP8._)(function(provider, name, StarknetIdContract) {
        var chainId, contract, addressData, e;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        provider.getChainId()
                    ];
                case 1:
                    chainId = _state.sent();
                    contract = StarknetIdContract !== null && StarknetIdContract !== void 0 ? StarknetIdContract : $facb0cbc5626d02c$var$getStarknetIdContract(chainId);
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        provider.callContract({
                            contractAddress: contract,
                            entrypoint: "domain_to_address",
                            calldata: $facb0cbc5626d02c$var$compileCalldata({
                                domain: [
                                    $facb0cbc5626d02c$var$useEncoded(name.replace(".stark", "")).toString(10)
                                ]
                            })
                        })
                    ];
                case 3:
                    addressData = _state.sent();
                    return [
                        2,
                        addressData.result[0]
                    ];
                case 4:
                    e = _state.sent();
                    throw Error("Could not get address from stark name");
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $facb0cbc5626d02c$var$_getAddressFromStarkName.apply(this, arguments);
}
var $facb0cbc5626d02c$var$validBlockTags = [
    "latest",
    "pending"
];
var $facb0cbc5626d02c$var$Block = /*#__PURE__*/ function() {
    "use strict";
    function Block(_identifier) {
        var _this = this;
        (0, $978gY._)(this, Block);
        this.hash = null;
        this.number = null;
        this.tag = null;
        this.valueOf = function() {
            return _this.number;
        };
        this.toString = function() {
            return _this.hash;
        };
        this.setIdentifier(_identifier);
    }
    (0, $kry2a._)(Block, [
        {
            key: "setIdentifier",
            value: function setIdentifier(__identifier) {
                if (typeof __identifier === "string" && $facb0cbc5626d02c$var$isHex(__identifier)) this.hash = __identifier;
                else if ((0, $jlWHo.BN).isBN(__identifier)) this.hash = $facb0cbc5626d02c$var$toHex(__identifier);
                else if (typeof __identifier === "number") this.number = __identifier;
                else if (typeof __identifier === "string" && $facb0cbc5626d02c$var$validBlockTags.includes(__identifier)) this.tag = __identifier;
                else this.tag = "pending";
            }
        },
        {
            key: "queryIdentifier",
            get: function get() {
                if (this.number !== null) return "blockNumber=".concat(this.number);
                if (this.hash !== null) return "blockHash=".concat(this.hash);
                return "blockNumber=".concat(this.tag);
            }
        },
        {
            key: "identifier",
            get: function get() {
                if (this.number !== null) return {
                    block_number: this.number
                };
                if (this.hash !== null) return {
                    block_hash: this.hash
                };
                return this.tag;
            },
            set: function set(_identifier) {
                this.setIdentifier(_identifier);
            }
        },
        {
            key: "sequencerIdentifier",
            get: function get() {
                var _this_number;
                return this.hash !== null ? {
                    blockHash: this.hash
                } : {
                    blockNumber: (_this_number = this.number) !== null && _this_number !== void 0 ? _this_number : this.tag
                };
            }
        }
    ]);
    return Block;
}();
// src/provider/rpc.ts
var $facb0cbc5626d02c$var$defaultOptions = {
    headers: {
        "Content-Type": "application/json"
    },
    blockIdentifier: "latest",
    retries: 200
};
var $facb0cbc5626d02c$export$578ebb3f1f89cda2 = /*#__PURE__*/ function() {
    "use strict";
    function RpcProvider(optionsOrProvider) {
        var _this = this;
        (0, $978gY._)(this, RpcProvider);
        this.responseParser = new $facb0cbc5626d02c$var$RPCResponseParser();
        var nodeUrl = optionsOrProvider.nodeUrl, retries = optionsOrProvider.retries, headers = optionsOrProvider.headers, blockIdentifier = optionsOrProvider.blockIdentifier;
        this.nodeUrl = nodeUrl;
        this.retries = retries || $facb0cbc5626d02c$var$defaultOptions.retries;
        this.headers = (0, $8OnJk._)({}, $facb0cbc5626d02c$var$defaultOptions.headers, headers);
        this.blockIdentifier = blockIdentifier || $facb0cbc5626d02c$var$defaultOptions.blockIdentifier;
        this.getChainId().then(function(chainId) {
            _this.chainId = chainId;
        });
    }
    (0, $kry2a._)(RpcProvider, [
        {
            key: "fetch",
            value: function fetch(method, params) {
                return $facb0cbc5626d02c$var$fetchPonyfill_default(this.nodeUrl, {
                    method: "POST",
                    body: $facb0cbc5626d02c$var$stringify({
                        method: method,
                        jsonrpc: "2.0",
                        params: params,
                        id: 0
                    }),
                    headers: this.headers
                });
            }
        },
        {
            key: "errorHandler",
            value: function errorHandler(error) {
                if (error) {
                    var code = error.code, message = error.message;
                    throw new $facb0cbc5626d02c$export$8c05b2dc6219e90a("".concat(code, ": ").concat(message));
                }
            }
        },
        {
            key: "fetchEndpoint",
            value: function fetchEndpoint(method, params) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _a, rawResult, _ref, _$error, result, error;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.fetch(method, params)
                                ];
                            case 1:
                                rawResult = _state.sent();
                                return [
                                    4,
                                    rawResult.json()
                                ];
                            case 2:
                                _ref = _state.sent(), _$error = _ref.error, result = _ref.result;
                                _this.errorHandler(_$error);
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                _this.errorHandler((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.data);
                                throw error;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getChainId",
            value: function getChainId() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("starknet_chainId")
                        ];
                    });
                })();
            }
        },
        {
            key: "getBlock",
            value: function getBlock() {
                var blockIdentifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.getBlockWithTxHashes(blockIdentifier).then(_this.responseParser.parseGetBlockResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "getBlockHashAndNumber",
            value: function getBlockHashAndNumber() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("starknet_blockHashAndNumber")
                        ];
                    });
                })();
            }
        },
        {
            key: "getBlockWithTxHashes",
            value: function getBlockWithTxHashes() {
                var blockIdentifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var block_id;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
                        return [
                            2,
                            _this.fetchEndpoint("starknet_getBlockWithTxHashes", {
                                block_id: block_id
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getBlockWithTxs",
            value: function getBlockWithTxs() {
                var blockIdentifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var block_id;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
                        return [
                            2,
                            _this.fetchEndpoint("starknet_getBlockWithTxs", {
                                block_id: block_id
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getClassHashAt",
            value: function getClassHashAt(contractAddress) {
                var blockIdentifier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var block_id;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
                        return [
                            2,
                            _this.fetchEndpoint("starknet_getClassHashAt", {
                                block_id: block_id,
                                contract_address: contractAddress
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getNonceForAddress",
            value: function getNonceForAddress(contractAddress) {
                var blockIdentifier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var block_id;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
                        return [
                            2,
                            _this.fetchEndpoint("starknet_getNonce", {
                                contract_address: contractAddress,
                                block_id: block_id
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getPendingTransactions",
            value: function getPendingTransactions() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("starknet_pendingTransactions")
                        ];
                    });
                })();
            }
        },
        {
            key: "getProtocolVersion",
            value: function getProtocolVersion() {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        throw new Error("Pathfinder does not implement this rpc 0.1.0 method");
                    });
                })();
            }
        },
        {
            key: "getStateUpdate",
            value: function getStateUpdate() {
                var blockIdentifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var block_id;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
                        return [
                            2,
                            _this.fetchEndpoint("starknet_getStateUpdate", {
                                block_id: block_id
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getStorageAt",
            value: function getStorageAt(contractAddress, key) {
                var blockIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var parsedKey, block_id;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        parsedKey = $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(key));
                        block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
                        return [
                            2,
                            _this.fetchEndpoint("starknet_getStorageAt", {
                                contract_address: contractAddress,
                                key: parsedKey,
                                block_id: block_id
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getTransaction",
            value: function getTransaction(txHash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.getTransactionByHash(txHash).then(_this.responseParser.parseGetTransactionResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "getTransactionByHash",
            value: function getTransactionByHash(txHash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("starknet_getTransactionByHash", {
                                transaction_hash: txHash
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getTransactionByBlockIdAndIndex",
            value: function getTransactionByBlockIdAndIndex(blockIdentifier, index) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var block_id;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
                        return [
                            2,
                            _this.fetchEndpoint("starknet_getTransactionByBlockIdAndIndex", {
                                block_id: block_id,
                                index: index
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getTransactionReceipt",
            value: function getTransactionReceipt(txHash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("starknet_getTransactionReceipt", {
                                transaction_hash: txHash
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getClassByHash",
            value: function getClassByHash(classHash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.getClass(classHash)
                        ];
                    });
                })();
            }
        },
        {
            key: "getClass",
            value: function getClass(classHash) {
                var blockIdentifier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var block_id;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
                        return [
                            2,
                            _this.fetchEndpoint("starknet_getClass", {
                                class_hash: classHash,
                                block_id: block_id
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getClassAt",
            value: function getClassAt(contractAddress) {
                var blockIdentifier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var block_id;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
                        return [
                            2,
                            _this.fetchEndpoint("starknet_getClassAt", {
                                block_id: block_id,
                                contract_address: contractAddress
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getCode",
            value: function getCode(_contractAddress, _blockIdentifier) {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        throw new Error("RPC does not implement getCode function");
                    });
                })();
            }
        },
        {
            key: "getEstimateFee",
            value: function getEstimateFee(invocation, invocationDetails) {
                var blockIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.getInvokeEstimateFee(invocation, invocationDetails, blockIdentifier)
                        ];
                    });
                })();
            }
        },
        {
            key: "getInvokeEstimateFee",
            value: function getInvokeEstimateFee(invocation, invocationDetails) {
                var blockIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var block_id;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
                        return [
                            2,
                            _this.fetchEndpoint("starknet_estimateFee", {
                                request: {
                                    type: "INVOKE",
                                    sender_address: invocation.contractAddress,
                                    calldata: $facb0cbc5626d02c$var$parseCalldata(invocation.calldata),
                                    signature: $facb0cbc5626d02c$var$bigNumberishArrayToHexadecimalStringArray(invocation.signature || []),
                                    version: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN((invocationDetails == null ? void 0 : invocationDetails.version) || 0)),
                                    nonce: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(invocationDetails.nonce)),
                                    max_fee: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN((invocationDetails == null ? void 0 : invocationDetails.maxFee) || 0))
                                },
                                block_id: block_id
                            }).then(_this.responseParser.parseFeeEstimateResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "getDeclareEstimateFee",
            value: function getDeclareEstimateFee(param, details) {
                var senderAddress = param.senderAddress, contractDefinition = param.contractDefinition, signature = param.signature, blockIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var block_id;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
                        return [
                            2,
                            _this.fetchEndpoint("starknet_estimateFee", {
                                request: {
                                    type: "DECLARE",
                                    contract_class: {
                                        program: contractDefinition.program,
                                        entry_points_by_type: contractDefinition.entry_points_by_type,
                                        abi: contractDefinition.abi
                                    },
                                    sender_address: senderAddress,
                                    signature: $facb0cbc5626d02c$var$bigNumberishArrayToHexadecimalStringArray(signature || []),
                                    version: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN((details == null ? void 0 : details.version) || 0)),
                                    nonce: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.nonce)),
                                    max_fee: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN((details == null ? void 0 : details.maxFee) || 0))
                                },
                                block_id: block_id
                            }).then(_this.responseParser.parseFeeEstimateResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "getDeployAccountEstimateFee",
            value: function getDeployAccountEstimateFee(param, details) {
                var classHash = param.classHash, constructorCalldata = param.constructorCalldata, addressSalt = param.addressSalt, signature = param.signature, blockIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var block_id;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
                        return [
                            2,
                            _this.fetchEndpoint("starknet_estimateFee", {
                                request: {
                                    type: "DEPLOY_ACCOUNT",
                                    constructor_calldata: $facb0cbc5626d02c$var$bigNumberishArrayToHexadecimalStringArray(constructorCalldata || []),
                                    class_hash: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(classHash)),
                                    contract_address_salt: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(addressSalt || 0)),
                                    signature: $facb0cbc5626d02c$var$bigNumberishArrayToHexadecimalStringArray(signature || []),
                                    version: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN((details == null ? void 0 : details.version) || 0)),
                                    nonce: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.nonce)),
                                    max_fee: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN((details == null ? void 0 : details.maxFee) || 0))
                                },
                                block_id: block_id
                            }).then(_this.responseParser.parseFeeEstimateResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "getEstimateFeeBulk",
            value: function getEstimateFeeBulk(_invocations) {
                var _blockIdentifier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.blockIdentifier;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        throw new Error("RPC does not implement getInvokeEstimateFeeBulk function");
                    });
                })();
            }
        },
        {
            key: "declareContract",
            value: function declareContract(param, details) {
                var contractDefinition = param.contractDefinition, signature = param.signature, senderAddress = param.senderAddress;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("starknet_addDeclareTransaction", {
                                declare_transaction: {
                                    contract_class: {
                                        program: contractDefinition.program,
                                        entry_points_by_type: contractDefinition.entry_points_by_type,
                                        abi: contractDefinition.abi
                                    },
                                    type: "DECLARE",
                                    version: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.version || 0)),
                                    max_fee: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.maxFee || 0)),
                                    signature: $facb0cbc5626d02c$var$bigNumberishArrayToHexadecimalStringArray(signature || []),
                                    sender_address: senderAddress,
                                    nonce: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.nonce))
                                }
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "deployAccountContract",
            value: function deployAccountContract(param, details) {
                var classHash = param.classHash, constructorCalldata = param.constructorCalldata, addressSalt = param.addressSalt, signature = param.signature;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("starknet_addDeployAccountTransaction", {
                                deploy_account_transaction: {
                                    constructor_calldata: $facb0cbc5626d02c$var$bigNumberishArrayToHexadecimalStringArray(constructorCalldata || []),
                                    class_hash: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(classHash)),
                                    contract_address_salt: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(addressSalt || 0)),
                                    type: "DEPLOY_ACCOUNT",
                                    max_fee: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.maxFee || 0)),
                                    version: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.version || 0)),
                                    signature: $facb0cbc5626d02c$var$bigNumberishArrayToHexadecimalStringArray(signature || []),
                                    nonce: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.nonce))
                                }
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "invokeFunction",
            value: function invokeFunction(functionInvocation, details) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("starknet_addInvokeTransaction", {
                                invoke_transaction: {
                                    sender_address: functionInvocation.contractAddress,
                                    calldata: $facb0cbc5626d02c$var$parseCalldata(functionInvocation.calldata),
                                    type: "INVOKE",
                                    max_fee: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.maxFee || 0)),
                                    version: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.version || 1)),
                                    signature: $facb0cbc5626d02c$var$bigNumberishArrayToHexadecimalStringArray(functionInvocation.signature || []),
                                    nonce: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.nonce))
                                }
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "callContract",
            value: function callContract(call) {
                var blockIdentifier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var block_id, result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
                                return [
                                    4,
                                    _this.fetchEndpoint("starknet_call", {
                                        request: {
                                            contract_address: call.contractAddress,
                                            entry_point_selector: $facb0cbc5626d02c$var$getSelectorFromName(call.entrypoint),
                                            calldata: $facb0cbc5626d02c$var$parseCalldata(call.calldata)
                                        },
                                        block_id: block_id
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    _this.responseParser.parseCallContractResponse(result)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "traceTransaction",
            value: function traceTransaction(transactionHash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("starknet_traceTransaction", {
                                transaction_hash: transactionHash
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "traceBlockTransactions",
            value: function traceBlockTransactions(blockHash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("starknet_traceBlockTransactions", {
                                block_hash: blockHash
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "waitForTransaction",
            value: function waitForTransaction(txHash) {
                var retryInterval = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 8e3, successStates = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
                    "ACCEPTED_ON_L1",
                    "ACCEPTED_ON_L2",
                    "PENDING"
                ];
                var _this = this;
                return (0, $byzP8._)(function() {
                    var errorStates, retries, onchain, txReceipt, _$error, message, _$error1, error;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                errorStates = [
                                    "REJECTED",
                                    "NOT_RECEIVED"
                                ];
                                retries = _this.retries;
                                onchain = false;
                                txReceipt = {};
                                _state.label = 1;
                            case 1:
                                if (!!onchain) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    $facb0cbc5626d02c$var$wait(retryInterval)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    _this.getTransactionReceipt(txHash)
                                ];
                            case 4:
                                txReceipt = _state.sent();
                                if (!("status" in txReceipt)) {
                                    _$error = new Error("pending transaction");
                                    throw _$error;
                                }
                                if (txReceipt.status && successStates.includes(txReceipt.status)) onchain = true;
                                else if (txReceipt.status && errorStates.includes(txReceipt.status)) {
                                    message = txReceipt.status;
                                    _$error1 = new Error(message);
                                    _$error1.response = txReceipt;
                                    throw _$error1;
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                if (error instanceof Error && errorStates.includes(error.message)) throw error;
                                if (retries === 0) throw new Error("waitForTransaction timed-out with retries ".concat(_this.retries));
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                retries -= 1;
                                return [
                                    3,
                                    1
                                ];
                            case 7:
                                return [
                                    4,
                                    $facb0cbc5626d02c$var$wait(retryInterval)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    2,
                                    txReceipt
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTransactionCount",
            value: function getTransactionCount() {
                var blockIdentifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var block_id;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
                        return [
                            2,
                            _this.fetchEndpoint("starknet_getBlockTransactionCount", {
                                block_id: block_id
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getBlockNumber",
            value: function getBlockNumber() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("starknet_blockNumber")
                        ];
                    });
                })();
            }
        },
        {
            key: "getSyncingStats",
            value: function getSyncingStats() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("starknet_syncing")
                        ];
                    });
                })();
            }
        },
        {
            key: "getEvents",
            value: function getEvents(eventFilter) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("starknet_getEvents", {
                                filter: eventFilter
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getSimulateTransaction",
            value: function getSimulateTransaction(_invocation, _invocationDetails, _blockIdentifier) {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        throw new Error("RPC does not implement simulateTransaction function");
                    });
                })();
            }
        },
        {
            key: "getStarkName",
            value: function getStarkName1(address, StarknetIdContract) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            $facb0cbc5626d02c$var$getStarkName(_this, address, StarknetIdContract)
                        ];
                    });
                })();
            }
        },
        {
            key: "getAddressFromStarkName",
            value: function getAddressFromStarkName1(name, StarknetIdContract) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            $facb0cbc5626d02c$var$getAddressFromStarkName(_this, name, StarknetIdContract)
                        ];
                    });
                })();
            }
        }
    ]);
    return RpcProvider;
}();
// src/utils/responseParser/index.ts
var $facb0cbc5626d02c$var$ResponseParser = function ResponseParser() {
    "use strict";
    (0, $978gY._)(this, ResponseParser);
};
// src/utils/responseParser/sequencer.ts
var $facb0cbc5626d02c$var$SequencerAPIResponseParser = /*#__PURE__*/ function(ResponseParser) {
    "use strict";
    (0, $ftJVG._)(SequencerAPIResponseParser, ResponseParser);
    var _super = (0, $6OZAO._)(SequencerAPIResponseParser);
    function SequencerAPIResponseParser() {
        (0, $978gY._)(this, SequencerAPIResponseParser);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(SequencerAPIResponseParser, [
        {
            key: "parseGetBlockResponse",
            value: function parseGetBlockResponse(res) {
                return (0, $8E768._)((0, $8OnJk._)({}, res), {
                    new_root: res.state_root,
                    parent_hash: res.parent_block_hash,
                    transactions: Object.values(res.transactions).map(function(value) {
                        return "transaction_hash" in value && value.transaction_hash;
                    }).filter(Boolean)
                });
            }
        },
        {
            key: "parseGetTransactionResponse",
            value: function parseGetTransactionResponse(res) {
                return (0, $8E768._)((0, $8OnJk._)({}, res), {
                    calldata: "calldata" in res.transaction ? res.transaction.calldata : [],
                    contract_address: "contract_address" in res.transaction ? res.transaction.contract_address : void 0,
                    contract_class: "contract_class" in res.transaction ? res.transaction.contract_class : void 0,
                    entry_point_selector: "entry_point_selector" in res.transaction ? res.transaction.entry_point_selector : void 0,
                    max_fee: "max_fee" in res.transaction ? res.transaction.max_fee : void 0,
                    nonce: res.transaction.nonce,
                    sender_address: "sender_address" in res.transaction ? res.transaction.sender_address : void 0,
                    signature: "signature" in res.transaction ? res.transaction.signature : void 0,
                    transaction_hash: "transaction_hash" in res.transaction ? res.transaction.transaction_hash : void 0,
                    version: "version" in res.transaction ? res.transaction.version : void 0
                });
            }
        },
        {
            key: "parseGetTransactionReceiptResponse",
            value: function parseGetTransactionReceiptResponse(res) {
                return (0, $8OnJk._)({
                    transaction_hash: res.transaction_hash,
                    status: res.status,
                    messages_sent: res.l2_to_l1_messages,
                    events: res.events
                }, "block_hash" in res && {
                    block_hash: res.block_hash
                }, "block_number" in res && {
                    block_number: res.block_number
                }, "actual_fee" in res && {
                    actual_fee: res.actual_fee
                }, "transaction_index" in res && {
                    transaction_index: res.transaction_index
                }, "execution_resources" in res && {
                    execution_resources: res.execution_resources
                }, "l1_to_l2_consumed_message" in res && {
                    l1_to_l2_consumed_message: res["l1_to_l2_consumed_message"]
                }, "transaction_failure_reason" in res && {
                    transaction_failure_reason: res.transaction_failure_reason
                });
            }
        },
        {
            key: "parseFeeEstimateResponse",
            value: function parseFeeEstimateResponse(res) {
                if ("overall_fee" in res) {
                    var gasInfo = {};
                    try {
                        gasInfo = {
                            gas_consumed: $facb0cbc5626d02c$var$toBN(res.gas_usage),
                            gas_price: $facb0cbc5626d02c$var$toBN(res.gas_price)
                        };
                    } catch (e) {}
                    return (0, $8OnJk._)({
                        overall_fee: $facb0cbc5626d02c$var$toBN(res.overall_fee)
                    }, gasInfo);
                }
                return {
                    overall_fee: $facb0cbc5626d02c$var$toBN(res.amount)
                };
            }
        },
        {
            key: "parseFeeEstimateBulkResponse",
            value: function parseFeeEstimateBulkResponse(res) {
                return [].concat(res).map(function(item) {
                    if ("overall_fee" in item) {
                        var gasInfo = {};
                        try {
                            gasInfo = {
                                gas_consumed: $facb0cbc5626d02c$var$toBN(item.gas_usage),
                                gas_price: $facb0cbc5626d02c$var$toBN(item.gas_price)
                            };
                        } catch (e) {}
                        return (0, $8OnJk._)({
                            overall_fee: $facb0cbc5626d02c$var$toBN(item.overall_fee)
                        }, gasInfo);
                    }
                    return {
                        overall_fee: $facb0cbc5626d02c$var$toBN(item.amount)
                    };
                });
            }
        },
        {
            key: "parseFeeSimulateTransactionResponse",
            value: function parseFeeSimulateTransactionResponse(res) {
                if ("overall_fee" in res.fee_estimation) {
                    var gasInfo = {};
                    try {
                        gasInfo = {
                            gas_consumed: $facb0cbc5626d02c$var$toBN(res.fee_estimation.gas_usage),
                            gas_price: $facb0cbc5626d02c$var$toBN(res.fee_estimation.gas_price)
                        };
                    } catch (e) {}
                    return {
                        trace: res.trace,
                        fee_estimation: (0, $8E768._)((0, $8OnJk._)({}, gasInfo), {
                            overall_fee: $facb0cbc5626d02c$var$toBN(res.fee_estimation.overall_fee)
                        })
                    };
                }
                return {
                    trace: res.trace,
                    fee_estimation: {
                        overall_fee: $facb0cbc5626d02c$var$toBN(res.fee_estimation.amount)
                    }
                };
            }
        },
        {
            key: "parseCallContractResponse",
            value: function parseCallContractResponse(res) {
                return {
                    result: res.result
                };
            }
        },
        {
            key: "parseInvokeFunctionResponse",
            value: function parseInvokeFunctionResponse(res) {
                return {
                    transaction_hash: res.transaction_hash
                };
            }
        },
        {
            key: "parseDeployContractResponse",
            value: function parseDeployContractResponse(res) {
                return {
                    transaction_hash: res.transaction_hash,
                    contract_address: res.address
                };
            }
        },
        {
            key: "parseDeclareContractResponse",
            value: function parseDeclareContractResponse(res) {
                return {
                    transaction_hash: res.transaction_hash,
                    class_hash: res.class_hash
                };
            }
        },
        {
            key: "parseGetStateUpdateResponse",
            value: function parseGetStateUpdateResponse(res) {
                var nonces = [].concat(res.state_diff.nonces).map(function(param) {
                    var contract_address = param.contract_address, nonce = param.nonce;
                    return {
                        contract_address: contract_address,
                        nonce: nonce
                    };
                });
                var storage_diffs = [].concat(res.state_diff.storage_diffs).map(function(param) {
                    var address = param.address, storage_entries = param.storage_entries;
                    return {
                        address: address,
                        storage_entries: storage_entries
                    };
                });
                return (0, $8E768._)((0, $8OnJk._)({}, res), {
                    state_diff: {
                        storage_diffs: storage_diffs,
                        declared_contract_hashes: res.state_diff.declared_contract_hashes,
                        deployed_contracts: res.state_diff.deployed_contracts,
                        nonces: nonces
                    }
                });
            }
        }
    ]);
    return SequencerAPIResponseParser;
}($facb0cbc5626d02c$var$ResponseParser);
var $facb0cbc5626d02c$var$protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
var $facb0cbc5626d02c$var$localhostDomainRE = /^localhost[:?\d]*(?:[^:?\d]\S*)?$/;
var $facb0cbc5626d02c$var$nonLocalhostDomainRE = /^[^\s.]+\.\S{2,}$/;
function $facb0cbc5626d02c$export$8304a22d431f958(s) {
    if (!s) return false;
    if (typeof s !== "string") return false;
    var match = s.match($facb0cbc5626d02c$var$protocolAndDomainRE);
    if (!match) return false;
    var everythingAfterProtocol = match[1];
    if (!everythingAfterProtocol) return false;
    if ($facb0cbc5626d02c$var$localhostDomainRE.test(everythingAfterProtocol) || $facb0cbc5626d02c$var$nonLocalhostDomainRE.test(everythingAfterProtocol)) return true;
    return false;
}
function $facb0cbc5626d02c$export$b5cd97dee32de81d(baseUrl, defaultPath, urlOrPath) {
    return $facb0cbc5626d02c$export$8304a22d431f958(urlOrPath) ? urlOrPath : (0, (/*@__PURE__*/$parcel$interopDefault($4oIhN)))(baseUrl, urlOrPath !== null && urlOrPath !== void 0 ? urlOrPath : defaultPath);
}
// src/provider/sequencer.ts
function $facb0cbc5626d02c$var$isEmptyQueryObject(obj) {
    return obj === void 0 || Object.keys(obj).length === 0 || Object.keys(obj).length === 1 && Object.entries(obj).every(function(param) {
        var _param = (0, $8GFUW._)(param, 2), k = _param[0], v = _param[1];
        return k === "blockIdentifier" && v === null;
    });
}
var $facb0cbc5626d02c$var$defaultOptions2 = {
    network: "goerli-alpha-2",
    blockIdentifier: "pending"
};
var $facb0cbc5626d02c$export$257d155889fba954 = /*#__PURE__*/ function() {
    "use strict";
    function SequencerProvider1() {
        var optionsOrProvider = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $facb0cbc5626d02c$var$defaultOptions2;
        (0, $978gY._)(this, SequencerProvider1);
        this.responseParser = new $facb0cbc5626d02c$var$SequencerAPIResponseParser();
        if ("network" in optionsOrProvider) {
            this.baseUrl = $facb0cbc5626d02c$export$257d155889fba954.getNetworkFromName(optionsOrProvider.network);
            this.feederGatewayUrl = $facb0cbc5626d02c$export$b5cd97dee32de81d(this.baseUrl, "feeder_gateway");
            this.gatewayUrl = $facb0cbc5626d02c$export$b5cd97dee32de81d(this.baseUrl, "gateway");
        } else {
            this.baseUrl = optionsOrProvider.baseUrl;
            this.feederGatewayUrl = $facb0cbc5626d02c$export$b5cd97dee32de81d(this.baseUrl, "feeder_gateway", optionsOrProvider.feederGatewayUrl);
            this.gatewayUrl = $facb0cbc5626d02c$export$b5cd97dee32de81d(this.baseUrl, "gateway", optionsOrProvider.gatewayUrl);
        }
        var _ref;
        this.chainId = (_ref = optionsOrProvider == null ? void 0 : optionsOrProvider.chainId) !== null && _ref !== void 0 ? _ref : $facb0cbc5626d02c$export$257d155889fba954.getChainIdFromBaseUrl(this.baseUrl);
        this.headers = optionsOrProvider.headers;
        this.blockIdentifier = (optionsOrProvider == null ? void 0 : optionsOrProvider.blockIdentifier) || $facb0cbc5626d02c$var$defaultOptions2.blockIdentifier;
    }
    (0, $kry2a._)(SequencerProvider1, [
        {
            key: "getFetchUrl",
            value: function getFetchUrl(endpoint) {
                var gatewayUrlEndpoints = [
                    "add_transaction"
                ];
                return gatewayUrlEndpoints.includes(endpoint) ? this.gatewayUrl : this.feederGatewayUrl;
            }
        },
        {
            key: "getFetchMethod",
            value: function getFetchMethod(endpoint) {
                var postMethodEndpoints = [
                    "add_transaction",
                    "call_contract",
                    "estimate_fee",
                    "estimate_message_fee",
                    "estimate_fee_bulk",
                    "simulate_transaction"
                ];
                return postMethodEndpoints.includes(endpoint) ? "POST" : "GET";
            }
        },
        {
            key: "getQueryString",
            value: function getQueryString(query) {
                if ($facb0cbc5626d02c$var$isEmptyQueryObject(query)) return "";
                var queryString = Object.entries(query).map(function(param) {
                    var _param = (0, $8GFUW._)(param, 2), key = _param[0], value = _param[1];
                    if (key === "blockIdentifier") {
                        var block = new $facb0cbc5626d02c$var$Block(value);
                        return "".concat(block.queryIdentifier);
                    }
                    return "".concat(key, "=").concat(value);
                }).join("&");
                return "?".concat(queryString);
            }
        },
        {
            key: "getHeaders",
            value: function getHeaders(method) {
                if (method === "POST") return (0, $8OnJk._)({
                    "Content-Type": "application/json"
                }, this.headers);
                return this.headers;
            }
        },
        {
            key: "fetchEndpoint",
            value: function fetchEndpoint(endpoint) {
                for(var _len = arguments.length, _tmp = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    _tmp[_key - 1] = arguments[_key];
                }
                var _tmp1 = (0, $8GFUW._)(_tmp, 2), query = _tmp1[0], request = _tmp1[1];
                var _this = this;
                return (0, $byzP8._)(function() {
                    var baseUrl, method, queryString, headers, url, res, textResponse, responseBody, errorCode, err;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                baseUrl = _this.getFetchUrl(endpoint);
                                method = _this.getFetchMethod(endpoint);
                                queryString = _this.getQueryString(query);
                                headers = _this.getHeaders(method);
                                url = (0, (/*@__PURE__*/$parcel$interopDefault($4oIhN)))(baseUrl, endpoint, queryString);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    $facb0cbc5626d02c$var$fetchPonyfill_default(url, {
                                        method: method,
                                        body: $facb0cbc5626d02c$var$stringify(request),
                                        headers: headers
                                    })
                                ];
                            case 2:
                                res = _state.sent();
                                return [
                                    4,
                                    res.text()
                                ];
                            case 3:
                                textResponse = _state.sent();
                                if (!res.ok) {
                                    ;
                                    try {
                                        responseBody = $facb0cbc5626d02c$var$parse(textResponse);
                                    } catch (e) {
                                        throw new $facb0cbc5626d02c$export$65bd6083489bd8bb(res.statusText, res.status);
                                    }
                                    errorCode = responseBody.code || (responseBody == null ? void 0 : responseBody.status_code);
                                    throw new $facb0cbc5626d02c$export$8ef93724ecb8bcb7(responseBody.message, errorCode);
                                }
                                if (endpoint === "estimate_fee") return [
                                    2,
                                    $facb0cbc5626d02c$var$parseAlwaysAsBig(textResponse, function(_, v) {
                                        if (v && (typeof v === "undefined" ? "undefined" : (0, $1ObTH._)(v)) === "bigint") return $facb0cbc5626d02c$var$toBN(v.toString());
                                        return v;
                                    })
                                ];
                                return [
                                    2,
                                    $facb0cbc5626d02c$var$parse(textResponse)
                                ];
                            case 4:
                                err = _state.sent();
                                if (err instanceof $facb0cbc5626d02c$export$8ef93724ecb8bcb7 || err instanceof $facb0cbc5626d02c$export$65bd6083489bd8bb) throw err;
                                if (err instanceof Error) throw Error("Could not ".concat(method, " from endpoint `").concat(url, "`: ").concat(err.message));
                                throw err;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getChainId",
            value: function getChainId() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            Promise.resolve(_this.chainId)
                        ];
                    });
                })();
            }
        },
        {
            key: "callContract",
            value: function callContract(param) {
                var contractAddress = param.contractAddress, entryPointSelector = param.entrypoint, _param_calldata = param.calldata, calldata = _param_calldata === void 0 ? [] : _param_calldata, blockIdentifier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("call_contract", {
                                blockIdentifier: blockIdentifier
                            }, {
                                signature: [],
                                contract_address: contractAddress,
                                entry_point_selector: $facb0cbc5626d02c$var$getSelectorFromName(entryPointSelector),
                                calldata: calldata
                            }).then(_this.responseParser.parseCallContractResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "getBlock",
            value: function getBlock() {
                var blockIdentifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("get_block", {
                                blockIdentifier: blockIdentifier
                            }).then(_this.responseParser.parseGetBlockResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "getNonceForAddress",
            value: function getNonceForAddress(contractAddress) {
                var blockIdentifier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("get_nonce", {
                                contractAddress: contractAddress,
                                blockIdentifier: blockIdentifier
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getStorageAt",
            value: function getStorageAt(contractAddress, key) {
                var blockIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var parsedKey;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        parsedKey = $facb0cbc5626d02c$var$toBN(key).toString(10);
                        return [
                            2,
                            _this.fetchEndpoint("get_storage_at", {
                                blockIdentifier: blockIdentifier,
                                contractAddress: contractAddress,
                                key: parsedKey
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getTransaction",
            value: function getTransaction(txHash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var txHashHex;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        txHashHex = $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(txHash));
                        return [
                            2,
                            _this.fetchEndpoint("get_transaction", {
                                transactionHash: txHashHex
                            }).then(function(result) {
                                if (Object.values(result).length === 1) throw new $facb0cbc5626d02c$export$8c05b2dc6219e90a(result.status);
                                return _this.responseParser.parseGetTransactionResponse(result);
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getTransactionReceipt",
            value: function getTransactionReceipt(txHash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var txHashHex;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        txHashHex = $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(txHash));
                        return [
                            2,
                            _this.fetchEndpoint("get_transaction_receipt", {
                                transactionHash: txHashHex
                            }).then(_this.responseParser.parseGetTransactionReceiptResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "getClassAt",
            value: function getClassAt(contractAddress) {
                var blockIdentifier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("get_full_contract", {
                                blockIdentifier: blockIdentifier,
                                contractAddress: contractAddress
                            }).then($facb0cbc5626d02c$var$parseContract)
                        ];
                    });
                })();
            }
        },
        {
            key: "getClassHashAt",
            value: function getClassHashAt(contractAddress) {
                var blockIdentifier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("get_class_hash_at", {
                                blockIdentifier: blockIdentifier,
                                contractAddress: contractAddress
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getClassByHash",
            value: function getClassByHash(classHash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("get_class_by_hash", {
                                classHash: classHash
                            }).then($facb0cbc5626d02c$var$parseContract)
                        ];
                    });
                })();
            }
        },
        {
            key: "invokeFunction",
            value: function invokeFunction(functionInvocation, details) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _functionInvocation_calldata, _functionInvocation_signature;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("add_transaction", void 0, {
                                type: "INVOKE_FUNCTION",
                                contract_address: functionInvocation.contractAddress,
                                calldata: $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray((_functionInvocation_calldata = functionInvocation.calldata) !== null && _functionInvocation_calldata !== void 0 ? _functionInvocation_calldata : []),
                                signature: $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray((_functionInvocation_signature = functionInvocation.signature) !== null && _functionInvocation_signature !== void 0 ? _functionInvocation_signature : []),
                                nonce: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.nonce)),
                                max_fee: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.maxFee || 0)),
                                version: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.version || 1))
                            }).then(_this.responseParser.parseInvokeFunctionResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "deployAccountContract",
            value: function deployAccountContract(param, details) {
                var classHash = param.classHash, constructorCalldata = param.constructorCalldata, addressSalt = param.addressSalt, signature = param.signature;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("add_transaction", void 0, {
                                type: "DEPLOY_ACCOUNT",
                                contract_address_salt: addressSalt !== null && addressSalt !== void 0 ? addressSalt : $facb0cbc5626d02c$var$randomAddress(),
                                constructor_calldata: $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray(constructorCalldata !== null && constructorCalldata !== void 0 ? constructorCalldata : []),
                                class_hash: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(classHash)),
                                max_fee: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.maxFee || 0)),
                                version: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.version || 0)),
                                nonce: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.nonce)),
                                signature: $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray(signature || [])
                            }).then(_this.responseParser.parseDeployContractResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "declareContract",
            value: function declareContract(param, details) {
                var senderAddress = param.senderAddress, contractDefinition = param.contractDefinition, signature = param.signature;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("add_transaction", void 0, {
                                type: "DECLARE",
                                contract_class: contractDefinition,
                                nonce: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.nonce)),
                                signature: $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray(signature || []),
                                sender_address: senderAddress,
                                max_fee: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.maxFee || 0)),
                                version: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.version || 1))
                            }).then(_this.responseParser.parseDeclareContractResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "getEstimateFee",
            value: function getEstimateFee(invocation, invocationDetails) {
                var blockIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.getInvokeEstimateFee(invocation, invocationDetails, blockIdentifier)
                        ];
                    });
                })();
            }
        },
        {
            key: "getInvokeEstimateFee",
            value: function getInvokeEstimateFee(invocation, invocationDetails) {
                var blockIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _invocation_calldata;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("estimate_fee", {
                                blockIdentifier: blockIdentifier
                            }, {
                                type: "INVOKE_FUNCTION",
                                contract_address: invocation.contractAddress,
                                calldata: (_invocation_calldata = invocation.calldata) !== null && _invocation_calldata !== void 0 ? _invocation_calldata : [],
                                signature: $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray(invocation.signature || []),
                                version: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN((invocationDetails == null ? void 0 : invocationDetails.version) || 1)),
                                nonce: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(invocationDetails.nonce))
                            }).then(_this.responseParser.parseFeeEstimateResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "getDeclareEstimateFee",
            value: function getDeclareEstimateFee(param, details) {
                var senderAddress = param.senderAddress, contractDefinition = param.contractDefinition, signature = param.signature, blockIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("estimate_fee", {
                                blockIdentifier: blockIdentifier
                            }, {
                                type: "DECLARE",
                                sender_address: senderAddress,
                                contract_class: contractDefinition,
                                signature: $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray(signature || []),
                                version: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN((details == null ? void 0 : details.version) || 1)),
                                nonce: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.nonce))
                            }).then(_this.responseParser.parseFeeEstimateResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "getDeployAccountEstimateFee",
            value: function getDeployAccountEstimateFee(param, details) {
                var classHash = param.classHash, addressSalt = param.addressSalt, constructorCalldata = param.constructorCalldata, signature = param.signature, blockIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("estimate_fee", {
                                blockIdentifier: blockIdentifier
                            }, {
                                type: "DEPLOY_ACCOUNT",
                                class_hash: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(classHash)),
                                constructor_calldata: $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray(constructorCalldata || []),
                                contract_address_salt: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(addressSalt || 0)),
                                signature: $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray(signature || []),
                                version: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN((details == null ? void 0 : details.version) || 0)),
                                nonce: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(details.nonce))
                            }).then(_this.responseParser.parseFeeEstimateResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "getEstimateFeeBulk",
            value: function getEstimateFeeBulk(invocations) {
                var blockIdentifier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var params;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        params = invocations.map(function(invocation) {
                            var res;
                            var _invocation_calldata;
                            if (invocation.type === "INVOKE_FUNCTION") res = {
                                type: invocation.type,
                                contract_address: invocation.contractAddress,
                                calldata: (_invocation_calldata = invocation.calldata) !== null && _invocation_calldata !== void 0 ? _invocation_calldata : []
                            };
                            else if (invocation.type === "DECLARE") res = {
                                type: invocation.type,
                                sender_address: invocation.senderAddress,
                                contract_class: invocation.contractDefinition
                            };
                            else res = {
                                type: invocation.type,
                                class_hash: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(invocation.classHash)),
                                constructor_calldata: $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray(invocation.constructorCalldata || []),
                                contract_address_salt: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(invocation.addressSalt || 0))
                            };
                            return (0, $8E768._)((0, $8OnJk._)({}, res), {
                                signature: $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray(invocation.signature || []),
                                version: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN((invocation == null ? void 0 : invocation.version) || 1)),
                                nonce: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(invocation.nonce))
                            });
                        });
                        return [
                            2,
                            _this.fetchEndpoint("estimate_fee_bulk", {
                                blockIdentifier: blockIdentifier
                            }, params).then(_this.responseParser.parseFeeEstimateBulkResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "getCode",
            value: function getCode(contractAddress) {
                var blockIdentifier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("get_code", {
                                contractAddress: contractAddress,
                                blockIdentifier: blockIdentifier
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "waitForTransaction",
            value: function waitForTransaction(txHash) {
                var retryInterval = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 8e3, successStates = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
                    "ACCEPTED_ON_L1",
                    "ACCEPTED_ON_L2",
                    "PENDING"
                ];
                var _this = this;
                return (0, $byzP8._)(function() {
                    var errorStates, onchain, res, message, error, txReceipt;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                errorStates = [
                                    "REJECTED",
                                    "NOT_RECEIVED"
                                ];
                                onchain = false;
                                _state.label = 1;
                            case 1:
                                if (!!onchain) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    $facb0cbc5626d02c$var$wait(retryInterval)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    _this.getTransactionStatus(txHash)
                                ];
                            case 3:
                                res = _state.sent();
                                if (successStates.includes(res.tx_status)) onchain = true;
                                else if (errorStates.includes(res.tx_status)) {
                                    message = res.tx_failure_reason ? "".concat(res.tx_status, ": ").concat(res.tx_failure_reason.code, "\n").concat(res.tx_failure_reason.error_message) : res.tx_status;
                                    error = new Error(message);
                                    error.response = res;
                                    throw error;
                                }
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                return [
                                    4,
                                    _this.getTransactionReceipt(txHash)
                                ];
                            case 5:
                                txReceipt = _state.sent();
                                return [
                                    2,
                                    txReceipt
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTransactionStatus",
            value: function getTransactionStatus(txHash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var txHashHex;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        txHashHex = $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(txHash));
                        return [
                            2,
                            _this.fetchEndpoint("get_transaction_status", {
                                transactionHash: txHashHex
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getContractAddresses",
            value: function getContractAddresses() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("get_contract_addresses")
                        ];
                    });
                })();
            }
        },
        {
            key: "getTransactionTrace",
            value: function getTransactionTrace(txHash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var txHashHex;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        txHashHex = $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(txHash));
                        return [
                            2,
                            _this.fetchEndpoint("get_transaction_trace", {
                                transactionHash: txHashHex
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "estimateMessageFee",
            value: function estimateMessageFee(param) {
                var from_address = param.from_address, to_address = param.to_address, entry_point_selector = param.entry_point_selector, payload = param.payload, blockIdentifier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var validCallL1Handler;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        validCallL1Handler = {
                            from_address: $facb0cbc5626d02c$var$getDecimalString(from_address),
                            to_address: $facb0cbc5626d02c$var$getHexString(to_address),
                            entry_point_selector: $facb0cbc5626d02c$var$getSelector(entry_point_selector),
                            payload: $facb0cbc5626d02c$var$getHexStringArray(payload)
                        };
                        return [
                            2,
                            _this.fetchEndpoint("estimate_message_fee", {
                                blockIdentifier: blockIdentifier
                            }, validCallL1Handler)
                        ];
                    });
                })();
            }
        },
        {
            key: "getSimulateTransaction",
            value: function getSimulateTransaction(invocation, invocationDetails) {
                var blockIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _invocation_calldata;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.fetchEndpoint("simulate_transaction", {
                                blockIdentifier: blockIdentifier
                            }, {
                                type: "INVOKE_FUNCTION",
                                contract_address: invocation.contractAddress,
                                calldata: (_invocation_calldata = invocation.calldata) !== null && _invocation_calldata !== void 0 ? _invocation_calldata : [],
                                signature: $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray(invocation.signature || []),
                                version: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN((invocationDetails == null ? void 0 : invocationDetails.version) || 1)),
                                nonce: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(invocationDetails.nonce))
                            }).then(_this.responseParser.parseFeeSimulateTransactionResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "getStateUpdate",
            value: function getStateUpdate() {
                var blockIdentifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var args;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        args = new $facb0cbc5626d02c$var$Block(blockIdentifier).sequencerIdentifier;
                        return [
                            2,
                            _this.fetchEndpoint("get_state_update", (0, $8OnJk._)({}, args)).then(_this.responseParser.parseGetStateUpdateResponse)
                        ];
                    });
                })();
            }
        },
        {
            key: "getBlockTraces",
            value: function getBlockTraces() {
                var blockIdentifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.blockIdentifier;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var args;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        args = new $facb0cbc5626d02c$var$Block(blockIdentifier).sequencerIdentifier;
                        return [
                            2,
                            _this.fetchEndpoint("get_block_traces", (0, $8OnJk._)({}, args))
                        ];
                    });
                })();
            }
        },
        {
            key: "getStarkName",
            value: function getStarkName1(address, StarknetIdContract) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            $facb0cbc5626d02c$var$getStarkName(_this, address, StarknetIdContract)
                        ];
                    });
                })();
            }
        },
        {
            key: "getAddressFromStarkName",
            value: function getAddressFromStarkName1(name, StarknetIdContract) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            $facb0cbc5626d02c$var$getAddressFromStarkName(_this, name, StarknetIdContract)
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "getNetworkFromName",
            value: function getNetworkFromName(name) {
                switch(name){
                    case "mainnet-alpha":
                        return "https://alpha-mainnet.starknet.io";
                    case "goerli-alpha":
                        return "https://alpha4.starknet.io";
                    case "goerli-alpha-2":
                        return "https://alpha4-2.starknet.io";
                    default:
                        return "https://alpha4.starknet.io";
                }
            }
        },
        {
            key: "getChainIdFromBaseUrl",
            value: function getChainIdFromBaseUrl(baseUrl) {
                try {
                    var url = new URL(baseUrl);
                    if (url.host.includes("mainnet.starknet.io")) return "0x534e5f4d41494e" /* MAINNET */ ;
                    if (url.host.includes("alpha4-2.starknet.io")) return "0x534e5f474f45524c4932" /* TESTNET2 */ ;
                } catch (e) {
                    console.error("Could not parse baseUrl: ".concat(baseUrl));
                }
                return "0x534e5f474f45524c49" /* TESTNET */ ;
            }
        }
    ]);
    return SequencerProvider1;
}();
// src/provider/default.ts
var $facb0cbc5626d02c$export$2881499e37b75b9a = /*#__PURE__*/ function() {
    "use strict";
    function Provider1(providerOrOptions) {
        (0, $978gY._)(this, Provider1);
        if (providerOrOptions instanceof $facb0cbc5626d02c$export$2881499e37b75b9a) this.provider = providerOrOptions.provider;
        else if (providerOrOptions instanceof $facb0cbc5626d02c$export$578ebb3f1f89cda2 || providerOrOptions instanceof $facb0cbc5626d02c$export$257d155889fba954) this.provider = providerOrOptions;
        else if (providerOrOptions && "rpc" in providerOrOptions) this.provider = new $facb0cbc5626d02c$export$578ebb3f1f89cda2(providerOrOptions.rpc);
        else if (providerOrOptions && "sequencer" in providerOrOptions) this.provider = new $facb0cbc5626d02c$export$257d155889fba954(providerOrOptions.sequencer);
        else this.provider = new $facb0cbc5626d02c$export$257d155889fba954();
    }
    (0, $kry2a._)(Provider1, [
        {
            key: "chainId",
            get: function get() {
                return this.provider.chainId;
            }
        },
        {
            key: "getChainId",
            value: function getChainId() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.getChainId()
                        ];
                    });
                })();
            }
        },
        {
            key: "getBlock",
            value: function getBlock(blockIdentifier) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.getBlock(blockIdentifier)
                        ];
                    });
                })();
            }
        },
        {
            key: "getClassAt",
            value: function getClassAt(contractAddress, blockIdentifier) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.getClassAt(contractAddress, blockIdentifier)
                        ];
                    });
                })();
            }
        },
        {
            key: "getClassHashAt",
            value: function getClassHashAt(contractAddress, blockIdentifier) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.getClassHashAt(contractAddress, blockIdentifier)
                        ];
                    });
                })();
            }
        },
        {
            key: "getClassByHash",
            value: function getClassByHash(classHash) {
                return this.provider.getClassByHash(classHash);
            }
        },
        {
            key: "getEstimateFee",
            value: function getEstimateFee(invocationWithTxType, invocationDetails, blockIdentifier) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.getEstimateFee(invocationWithTxType, invocationDetails, blockIdentifier)
                        ];
                    });
                })();
            }
        },
        {
            key: "getInvokeEstimateFee",
            value: function getInvokeEstimateFee(invocationWithTxType, invocationDetails, blockIdentifier) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.getInvokeEstimateFee(invocationWithTxType, invocationDetails, blockIdentifier)
                        ];
                    });
                })();
            }
        },
        {
            key: "getEstimateFeeBulk",
            value: function getEstimateFeeBulk(invocations, blockIdentifier) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.getEstimateFeeBulk(invocations, blockIdentifier)
                        ];
                    });
                })();
            }
        },
        {
            key: "getNonceForAddress",
            value: function getNonceForAddress(contractAddress, blockIdentifier) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.getNonceForAddress(contractAddress, blockIdentifier)
                        ];
                    });
                })();
            }
        },
        {
            key: "getStorageAt",
            value: function getStorageAt(contractAddress, key, blockIdentifier) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.getStorageAt(contractAddress, key, blockIdentifier)
                        ];
                    });
                })();
            }
        },
        {
            key: "getTransaction",
            value: function getTransaction(txHash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.getTransaction(txHash)
                        ];
                    });
                })();
            }
        },
        {
            key: "getTransactionReceipt",
            value: function getTransactionReceipt(txHash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.getTransactionReceipt(txHash)
                        ];
                    });
                })();
            }
        },
        {
            key: "callContract",
            value: function callContract(request, blockIdentifier) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.callContract(request, blockIdentifier)
                        ];
                    });
                })();
            }
        },
        {
            key: "invokeFunction",
            value: function invokeFunction(functionInvocation, details) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.invokeFunction(functionInvocation, details)
                        ];
                    });
                })();
            }
        },
        {
            key: "deployAccountContract",
            value: function deployAccountContract(payload, details) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.deployAccountContract(payload, details)
                        ];
                    });
                })();
            }
        },
        {
            key: "declareContract",
            value: function declareContract(transaction, details) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.declareContract(transaction, details)
                        ];
                    });
                })();
            }
        },
        {
            key: "getDeclareEstimateFee",
            value: function getDeclareEstimateFee(transaction, details, blockIdentifier) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.getDeclareEstimateFee(transaction, details, blockIdentifier)
                        ];
                    });
                })();
            }
        },
        {
            key: "getDeployAccountEstimateFee",
            value: function getDeployAccountEstimateFee(transaction, details, blockIdentifier) {
                return this.provider.getDeployAccountEstimateFee(transaction, details, blockIdentifier);
            }
        },
        {
            key: "getCode",
            value: function getCode(contractAddress, blockIdentifier) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.getCode(contractAddress, blockIdentifier)
                        ];
                    });
                })();
            }
        },
        {
            key: "waitForTransaction",
            value: function waitForTransaction(txHash, retryInterval, successStates) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.waitForTransaction(txHash, retryInterval, successStates)
                        ];
                    });
                })();
            }
        },
        {
            key: "getSimulateTransaction",
            value: function getSimulateTransaction(invocation, invocationDetails, blockIdentifier) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.getSimulateTransaction(invocation, invocationDetails, blockIdentifier)
                        ];
                    });
                })();
            }
        },
        {
            key: "getStateUpdate",
            value: function getStateUpdate(blockIdentifier) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.getStateUpdate(blockIdentifier)
                        ];
                    });
                })();
            }
        },
        {
            key: "getStarkName",
            value: function getStarkName1(address, StarknetIdContract) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            $facb0cbc5626d02c$var$getStarkName(_this, address, StarknetIdContract)
                        ];
                    });
                })();
            }
        },
        {
            key: "getAddressFromStarkName",
            value: function getAddressFromStarkName1(name, StarknetIdContract) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            $facb0cbc5626d02c$var$getAddressFromStarkName(_this, name, StarknetIdContract)
                        ];
                    });
                })();
            }
        }
    ]);
    return Provider1;
}();
// src/provider/interface.ts
var $facb0cbc5626d02c$export$8efff2d796cdea69 = function ProviderInterface() {
    "use strict";
    (0, $978gY._)(this, ProviderInterface);
};
// src/provider/index.ts
var $facb0cbc5626d02c$export$dc63293f8fab0911 = new $facb0cbc5626d02c$export$2881499e37b75b9a();
var $facb0cbc5626d02c$var$CheckCallData = /*#__PURE__*/ function() {
    "use strict";
    function CheckCallData(abi) {
        (0, $978gY._)(this, CheckCallData);
        this.abi = abi;
        this.structs = abi.filter(function(abiEntry) {
            return abiEntry.type === "struct";
        }).reduce(function(acc, abiEntry) {
            return (0, $8E768._)((0, $8OnJk._)({}, acc), (0, $dxWQo._)({}, abiEntry.name, abiEntry));
        }, {});
    }
    (0, $kry2a._)(CheckCallData, [
        {
            key: "compileCalldata",
            value: function compileCalldata(args, inputs) {
                var _this = this;
                var argsIterator = args[Symbol.iterator]();
                return inputs.reduce(function(acc, input) {
                    var _acc;
                    if (/_len$/.test(input.name)) return acc;
                    var parsedData = _this.parseCalldataField(argsIterator, input);
                    if (Array.isArray(parsedData)) (_acc = acc).push.apply(_acc, (0, $fLnyw._)(parsedData));
                    else acc.push(parsedData);
                    return acc;
                }, []);
            }
        },
        {
            key: "validateMethodAndArgs",
            value: function validateMethodAndArgs(type, method) {
                var args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                var _this = this;
                if (type !== "DEPLOY") {
                    var invocableFunctionNames = this.abi.filter(function(abi) {
                        if (abi.type !== "function") return false;
                        var isView = abi.stateMutability === "view";
                        return type === "INVOKE" ? !isView : isView;
                    }).map(function(abi) {
                        return abi.name;
                    });
                    (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(invocableFunctionNames.includes(method), "".concat(type === "INVOKE" ? "invocable" : "viewable", " method not found in abi"));
                }
                var methodAbi = this.abi.find(function(abi) {
                    return type === "DEPLOY" ? abi.name === method && abi.type === method : abi.name === method && abi.type === "function";
                });
                var argPosition = 0;
                methodAbi.inputs.forEach(function(input) {
                    if (/_len$/.test(input.name)) return;
                    if (input.type === "felt") {
                        (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(typeof args[argPosition] === "string" || typeof args[argPosition] === "number" || args[argPosition] instanceof (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo))), "arg ".concat(input.name, " should be a felt (string, number, BigNumber)"));
                        argPosition += 1;
                    } else if (input.type in _this.structs && typeof args[argPosition] === "object") {
                        if (Array.isArray(args[argPosition])) {
                            var structMembersLength = _this.calculateStructMembers(input.type);
                            (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(args[argPosition].length === structMembersLength, "arg should be of length ".concat(structMembersLength));
                        } else _this.structs[input.type].members.forEach(function(param) {
                            var name = param.name;
                            (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(Object.keys(args[argPosition]).includes(name), "arg should have a property ".concat(name));
                        });
                        argPosition += 1;
                    } else {
                        (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(Array.isArray(args[argPosition]), "arg ".concat(input.name, " should be an Array"));
                        if (input.type === "felt*") {
                            args[argPosition].forEach(function(felt) {
                                (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(typeof felt === "string" || typeof felt === "number" || felt instanceof (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo))), "arg ".concat(input.name, " should be an array of string, number or BigNumber"));
                            });
                            argPosition += 1;
                        } else if (/\(felt/.test(input.type)) {
                            var tupleLength = input.type.split(",").length;
                            (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(args[argPosition].length === tupleLength, "arg ".concat(input.name, " should have ").concat(tupleLength, " elements in tuple"));
                            args[argPosition].forEach(function(felt) {
                                (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(typeof felt === "string" || typeof felt === "number" || felt instanceof (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo))), "arg ".concat(input.name, " should be an array of string, number or BigNumber"));
                            });
                            argPosition += 1;
                        } else {
                            var arrayType = input.type.replace("*", "");
                            args[argPosition].forEach(function(struct) {
                                _this.structs[arrayType].members.forEach(function(param) {
                                    var name = param.name;
                                    if (Array.isArray(struct)) {
                                        var structMembersLength = _this.calculateStructMembers(arrayType);
                                        (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(struct.length === structMembersLength, "arg should be of length ".concat(structMembersLength));
                                    } else (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(Object.keys(struct).includes(name), "arg ".concat(input.name, " should be an array of ").concat(arrayType));
                                });
                            });
                            argPosition += 1;
                        }
                    }
                });
            }
        },
        {
            key: "parseCalldataField",
            value: function parseCalldataField(argsIterator, input) {
                var _this = this;
                var name = input.name, type = input.type;
                var value = argsIterator.next().value;
                var parsedCalldata = [];
                switch(true){
                    case /\*/.test(type):
                        if (Array.isArray(value)) {
                            parsedCalldata.push($facb0cbc5626d02c$var$toFelt(value.length));
                            return value.reduce(function(acc, el) {
                                var _acc;
                                if (/felt/.test(type)) acc.push($facb0cbc5626d02c$var$toFelt(el));
                                else (_acc = acc).push.apply(_acc, (0, $fLnyw._)(_this.parseCalldataValue(el, type.replace("*", ""))));
                                return acc;
                            }, parsedCalldata);
                        }
                        throw Error("Expected ".concat(name, " to be array"));
                    case type in this.structs:
                        return this.parseCalldataValue(value, type);
                    case /\(felt/.test(type):
                        if (Array.isArray(value)) return value.map(function(el) {
                            return $facb0cbc5626d02c$var$toFelt(el);
                        });
                        throw Error("Expected ".concat(name, " to be array"));
                    default:
                        return $facb0cbc5626d02c$var$toFelt(value);
                }
            }
        },
        {
            key: "parseCalldataValue",
            value: function parseCalldataValue(element, type) {
                var _this = this;
                if (element === void 0) throw Error("Missing element in calldata");
                if (Array.isArray(element)) {
                    var structMemberNum = this.calculateStructMembers(type);
                    if (element.length !== structMemberNum) throw Error("Missing element in calldata");
                    return element.map(function(el) {
                        return $facb0cbc5626d02c$var$toFelt(el);
                    });
                }
                if (this.structs[type] && this.structs[type].members.length) return this.structs[type].members.reduce(function(acc, member) {
                    var _acc;
                    var parsedData = _this.parseCalldataValue(element[member.name], member.type);
                    if (typeof parsedData === "string") acc.push(parsedData);
                    else (_acc = acc).push.apply(_acc, (0, $fLnyw._)(parsedData));
                    return acc;
                }, []);
                return $facb0cbc5626d02c$var$toFelt(element);
            }
        },
        {
            key: "calculateStructMembers",
            value: function calculateStructMembers(struct) {
                var _this = this;
                return this.structs[struct].members.reduce(function(acc, member) {
                    if (member.type === "felt") return acc + 1;
                    return acc + _this.calculateStructMembers(member.type);
                }, 0);
            }
        }
    ]);
    return CheckCallData;
}();
// src/contract/default.ts
function $facb0cbc5626d02c$var$parseFelt(candidate) {
    try {
        return $facb0cbc5626d02c$var$toBN(candidate);
    } catch (e) {
        throw Error("Could not parse felt");
    }
}
function $facb0cbc5626d02c$var$buildCall(contract, functionAbi) {
    return /*#__PURE__*/ (0, $byzP8._)(function() {
        var _len, args, _key, blockIdentifier;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = _arguments[_key];
            }
            blockIdentifier = null;
            args.forEach(function(arg) {
                if (arg.blockIdentifier) blockIdentifier = arg.blockIdentifier;
            });
            return [
                2,
                contract.call(functionAbi.name, args, {
                    blockIdentifier: blockIdentifier
                })
            ];
        });
    });
}
function $facb0cbc5626d02c$var$buildInvoke(contract, functionAbi) {
    return /*#__PURE__*/ (0, $byzP8._)(function() {
        var _len, args, _key, inputs, inputsLength, options;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = _arguments[_key];
            }
            inputs = functionAbi.inputs;
            inputsLength = inputs.reduce(function(acc, input) {
                if (!/_len$/.test(input.name)) return acc + 1;
                return acc;
            }, 0);
            options = {};
            if (inputsLength + 1 === args.length && typeof args[args.length - 1] === "object") Object.assign(options, args.pop());
            return [
                2,
                contract.invoke(functionAbi.name, args, options)
            ];
        });
    });
}
function $facb0cbc5626d02c$var$buildDefault(contract, functionAbi) {
    if (functionAbi.stateMutability === "view") return $facb0cbc5626d02c$var$buildCall(contract, functionAbi);
    return $facb0cbc5626d02c$var$buildInvoke(contract, functionAbi);
}
function $facb0cbc5626d02c$var$buildPopulate(contract, functionAbi) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return contract.populate(functionAbi.name, args);
    };
}
function $facb0cbc5626d02c$var$buildEstimate(contract, functionAbi) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return contract.estimate(functionAbi.name, args);
    };
}
var $facb0cbc5626d02c$export$8517d80acf00e19a = /*#__PURE__*/ function() {
    "use strict";
    function Contract(abi, address) {
        var providerOrAccount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $facb0cbc5626d02c$export$dc63293f8fab0911;
        var _this = this;
        (0, $978gY._)(this, Contract);
        this.address = address && address.toLowerCase();
        this.providerOrAccount = providerOrAccount;
        this.abi = abi;
        this.structs = abi.filter(function(abiEntry) {
            return abiEntry.type === "struct";
        }).reduce(function(acc, abiEntry) {
            return (0, $8E768._)((0, $8OnJk._)({}, acc), (0, $dxWQo._)({}, abiEntry.name, abiEntry));
        }, {});
        this.checkCalldata = new $facb0cbc5626d02c$var$CheckCallData(abi);
        Object.defineProperty(this, "functions", {
            enumerable: true,
            value: {},
            writable: false
        });
        Object.defineProperty(this, "callStatic", {
            enumerable: true,
            value: {},
            writable: false
        });
        Object.defineProperty(this, "populateTransaction", {
            enumerable: true,
            value: {},
            writable: false
        });
        Object.defineProperty(this, "estimateFee", {
            enumerable: true,
            value: {},
            writable: false
        });
        this.abi.forEach(function(abiElement) {
            if (abiElement.type !== "function") return;
            var signature = abiElement.name;
            if (!_this[signature]) Object.defineProperty(_this, signature, {
                enumerable: true,
                value: $facb0cbc5626d02c$var$buildDefault(_this, abiElement),
                writable: false
            });
            if (!_this.functions[signature]) Object.defineProperty(_this.functions, signature, {
                enumerable: true,
                value: $facb0cbc5626d02c$var$buildDefault(_this, abiElement),
                writable: false
            });
            if (!_this.callStatic[signature]) Object.defineProperty(_this.callStatic, signature, {
                enumerable: true,
                value: $facb0cbc5626d02c$var$buildCall(_this, abiElement),
                writable: false
            });
            if (!_this.populateTransaction[signature]) Object.defineProperty(_this.populateTransaction, signature, {
                enumerable: true,
                value: $facb0cbc5626d02c$var$buildPopulate(_this, abiElement),
                writable: false
            });
            if (!_this.estimateFee[signature]) Object.defineProperty(_this.estimateFee, signature, {
                enumerable: true,
                value: $facb0cbc5626d02c$var$buildEstimate(_this, abiElement),
                writable: false
            });
        });
    }
    (0, $kry2a._)(Contract, [
        {
            key: "attach",
            value: function attach(address) {
                this.address = address;
            }
        },
        {
            key: "connect",
            value: function connect(providerOrAccount) {
                this.providerOrAccount = providerOrAccount;
            }
        },
        {
            key: "deployed",
            value: function deployed() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.deployTransactionHash) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.providerOrAccount.waitForTransaction(_this.deployTransactionHash)
                                ];
                            case 1:
                                _state.sent();
                                _this.deployTransactionHash = void 0;
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    _this
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "call",
            value: function call(method) {
                var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return (0, $byzP8._)(function() {
                    var blockIdentifier, inputs, calldata;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        blockIdentifier = (options == null ? void 0 : options.blockIdentifier) || void 0;
                        (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(_this.address !== null, "contract is not connected to an address");
                        _this.checkCalldata.validateMethodAndArgs("CALL", method, args);
                        inputs = _this.abi.find(function(abi) {
                            return abi.name === method;
                        }).inputs;
                        calldata = _this.checkCalldata.compileCalldata(args, inputs);
                        return [
                            2,
                            _this.providerOrAccount.callContract({
                                contractAddress: _this.address,
                                calldata: calldata,
                                entrypoint: method
                            }, blockIdentifier).then(function(x) {
                                return _this.parseResponse(method, x.result);
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "invoke",
            value: function invoke(method) {
                var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(this.address !== null, "contract is not connected to an address");
                this.checkCalldata.validateMethodAndArgs("INVOKE", method, args);
                var inputs = this.abi.find(function(abi) {
                    return abi.name === method;
                }).inputs;
                var inputsLength = inputs.reduce(function(acc, input) {
                    if (!/_len$/.test(input.name)) return acc + 1;
                    return acc;
                }, 0);
                if (args.length !== inputsLength) throw Error("Invalid number of arguments, expected ".concat(inputsLength, " arguments, but got ").concat(args.length));
                var calldata = this.checkCalldata.compileCalldata(args, inputs);
                var invocation = {
                    contractAddress: this.address,
                    calldata: calldata,
                    entrypoint: method
                };
                if ("execute" in this.providerOrAccount) return this.providerOrAccount.execute(invocation, void 0, {
                    maxFee: options.maxFee,
                    nonce: options.nonce
                });
                if (!options.nonce) throw new Error("Nonce is required when invoking a function without an account");
                console.warn("Invoking ".concat(method, " without an account. This will not work on a public node."));
                return this.providerOrAccount.invokeFunction((0, $8E768._)((0, $8OnJk._)({}, invocation), {
                    signature: options.signature || []
                }), {
                    nonce: options.nonce
                });
            }
        },
        {
            key: "estimate",
            value: function estimate(method) {
                var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _this_populateTransaction, invocation;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(_this.address !== null, "contract is not connected to an address");
                        _this.checkCalldata.validateMethodAndArgs("INVOKE", method, args);
                        invocation = (_this_populateTransaction = _this.populateTransaction)[method].apply(_this_populateTransaction, (0, $fLnyw._)(args));
                        if ("estimateInvokeFee" in _this.providerOrAccount) return [
                            2,
                            _this.providerOrAccount.estimateInvokeFee(invocation)
                        ];
                        throw Error("Contract must be connected to the account contract to estimate");
                    });
                })();
            }
        },
        {
            key: "populate",
            value: function populate(method) {
                var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                var inputs = this.abi.find(function(abi) {
                    return abi.name === method;
                }).inputs;
                return {
                    contractAddress: this.address,
                    entrypoint: method,
                    calldata: this.checkCalldata.compileCalldata(args, inputs)
                };
            }
        },
        {
            key: "parseResponseStruct",
            value: function parseResponseStruct(responseIterator, type) {
                var _this = this;
                if (type in this.structs && this.structs[type]) return this.structs[type].members.reduce(function(acc, el) {
                    acc[el.name] = _this.parseResponseStruct(responseIterator, el.type);
                    return acc;
                }, {});
                return $facb0cbc5626d02c$var$parseFelt(responseIterator.next().value);
            }
        },
        {
            key: "parseResponseField",
            value: function parseResponseField(responseIterator, output, parsedResult) {
                var name = output.name, type = output.type;
                var parsedDataArr = [];
                switch(true){
                    case /_len$/.test(name):
                        return $facb0cbc5626d02c$var$parseFelt(responseIterator.next().value).toNumber();
                    case /\(felt/.test(type):
                        return type.split(",").reduce(function(acc) {
                            acc.push($facb0cbc5626d02c$var$parseFelt(responseIterator.next().value));
                            return acc;
                        }, []);
                    case /\*/.test(type):
                        if (parsedResult && parsedResult["".concat(name, "_len")]) {
                            var arrLen = parsedResult["".concat(name, "_len")];
                            while(parsedDataArr.length < arrLen)parsedDataArr.push(this.parseResponseStruct(responseIterator, output.type.replace("*", "")));
                        }
                        return parsedDataArr;
                    case type in this.structs:
                        return this.parseResponseStruct(responseIterator, type);
                    default:
                        return $facb0cbc5626d02c$var$parseFelt(responseIterator.next().value);
                }
            }
        },
        {
            key: "parseResponse",
            value: function parseResponse(method, response) {
                var _this = this;
                var outputs = this.abi.find(function(abi) {
                    return abi.name === method;
                }).outputs;
                var responseIterator = response.flat()[Symbol.iterator]();
                var resultObject = outputs.flat().reduce(function(acc, output) {
                    acc[output.name] = _this.parseResponseField(responseIterator, output, acc);
                    if (acc[output.name] && acc["".concat(output.name, "_len")]) delete acc["".concat(output.name, "_len")];
                    return acc;
                }, {});
                return Object.entries(resultObject).reduce(function(acc, param) {
                    var _param = (0, $8GFUW._)(param, 2), key = _param[0], value = _param[1];
                    acc.push(value);
                    acc[key] = value;
                    return acc;
                }, []);
            }
        }
    ]);
    return Contract;
}();
// src/contract/interface.ts
var $facb0cbc5626d02c$export$c16ebf97b4a8324a = function ContractInterface() {
    "use strict";
    (0, $978gY._)(this, ContractInterface);
};
var $facb0cbc5626d02c$export$505569a6bf584fd9 = /*#__PURE__*/ function() {
    "use strict";
    function ContractFactory(compiledContract, classHash, account) {
        var abi = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : compiledContract.abi;
        (0, $978gY._)(this, ContractFactory);
        this.abi = abi;
        this.compiledContract = compiledContract;
        this.account = account;
        this.classHash = classHash;
        this.checkCalldata = new $facb0cbc5626d02c$var$CheckCallData(abi);
    }
    (0, $kry2a._)(ContractFactory, [
        {
            key: "deploy",
            value: function deploy() {
                var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], addressSalt = arguments.length > 1 ? arguments[1] : void 0;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var inputs, constructorCalldata, _ref, _ref_deploy, contract_address, transaction_hash, contractInstance;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.checkCalldata.validateMethodAndArgs("DEPLOY", "constructor", args);
                                inputs = _this.abi.find(function(abi) {
                                    return abi.type === "constructor";
                                }).inputs;
                                constructorCalldata = _this.checkCalldata.compileCalldata(args, inputs);
                                return [
                                    4,
                                    _this.account.declareDeploy({
                                        contract: _this.compiledContract,
                                        classHash: _this.classHash,
                                        constructorCalldata: constructorCalldata,
                                        salt: addressSalt
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), _ref_deploy = _ref.deploy, contract_address = _ref_deploy.contract_address, transaction_hash = _ref_deploy.transaction_hash;
                                (0, (/*@__PURE__*/$parcel$interopDefault($3210N)))(Boolean(contract_address), "Deployment of the contract failed");
                                contractInstance = new $facb0cbc5626d02c$export$8517d80acf00e19a(_this.compiledContract.abi, contract_address, _this.account);
                                contractInstance.deployTransactionHash = transaction_hash;
                                return [
                                    2,
                                    contractInstance
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "connect",
            value: function connect(account) {
                this.account = account;
                return this;
            }
        },
        {
            key: "attach",
            value: function attach(address) {
                return new $facb0cbc5626d02c$export$8517d80acf00e19a(this.abi, address, this.account);
            }
        }
    ]);
    return ContractFactory;
}();
// src/signer/interface.ts
var $facb0cbc5626d02c$export$c7f3abef082132e7 = function SignerInterface() {
    "use strict";
    (0, $978gY._)(this, SignerInterface);
};
// src/utils/transaction.ts
var $facb0cbc5626d02c$export$2d62d2646dd2fb3c = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$2d62d2646dd2fb3c, {
    fromCallsToExecuteCalldata: function() {
        return $facb0cbc5626d02c$var$fromCallsToExecuteCalldata;
    },
    fromCallsToExecuteCalldataWithNonce: function() {
        return $facb0cbc5626d02c$var$fromCallsToExecuteCalldataWithNonce;
    },
    transformCallsToMulticallArrays: function() {
        return $facb0cbc5626d02c$var$transformCallsToMulticallArrays;
    }
});
var $facb0cbc5626d02c$var$transformCallsToMulticallArrays = function(calls) {
    var callArray = [];
    var calldata = [];
    calls.forEach(function(call) {
        var _calldata;
        var data = call.calldata || [];
        callArray.push({
            to: $facb0cbc5626d02c$var$toBN(call.contractAddress).toString(10),
            selector: $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$getSelectorFromName(call.entrypoint)).toString(10),
            data_offset: calldata.length.toString(),
            data_len: data.length.toString()
        });
        (_calldata = calldata).push.apply(_calldata, (0, $fLnyw._)(data));
    });
    return {
        callArray: callArray,
        calldata: $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray(calldata)
    };
};
var $facb0cbc5626d02c$var$fromCallsToExecuteCalldata = function(calls) {
    var _transformCallsToMulticallArrays = $facb0cbc5626d02c$var$transformCallsToMulticallArrays(calls), callArray = _transformCallsToMulticallArrays.callArray, calldata = _transformCallsToMulticallArrays.calldata;
    return [
        callArray.length.toString()
    ].concat((0, $fLnyw._)(callArray.map(function(param) {
        var to = param.to, selector = param.selector, data_offset = param.data_offset, data_len = param.data_len;
        return [
            to,
            selector,
            data_offset,
            data_len
        ];
    }).flat()), [
        calldata.length.toString()
    ], (0, $fLnyw._)(calldata));
};
var $facb0cbc5626d02c$var$fromCallsToExecuteCalldataWithNonce = function(calls, nonce) {
    return (0, $fLnyw._)($facb0cbc5626d02c$var$fromCallsToExecuteCalldata(calls)).concat([
        $facb0cbc5626d02c$var$toBN(nonce).toString()
    ]);
};
// src/utils/typedData/index.ts
var $facb0cbc5626d02c$export$2ebe69e89b76b6ec = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$2ebe69e89b76b6ec, {
    encodeData: function() {
        return $facb0cbc5626d02c$var$encodeData;
    },
    encodeType: function() {
        return $facb0cbc5626d02c$var$encodeType;
    },
    encodeValue: function() {
        return $facb0cbc5626d02c$var$encodeValue;
    },
    getDependencies: function() {
        return $facb0cbc5626d02c$var$getDependencies;
    },
    getMessageHash: function() {
        return $facb0cbc5626d02c$var$getMessageHash;
    },
    getStructHash: function() {
        return $facb0cbc5626d02c$var$getStructHash;
    },
    getTypeHash: function() {
        return $facb0cbc5626d02c$var$getTypeHash;
    },
    isMerkleTreeType: function() {
        return $facb0cbc5626d02c$var$isMerkleTreeType;
    },
    prepareSelector: function() {
        return $facb0cbc5626d02c$var$prepareSelector;
    }
});
// src/utils/merkle.ts
var $facb0cbc5626d02c$export$483e047521be7129 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$483e047521be7129, {
    MerkleTree: function() {
        return $facb0cbc5626d02c$var$MerkleTree;
    },
    proofMerklePath: function() {
        return $facb0cbc5626d02c$var$proofMerklePath;
    }
});
var $facb0cbc5626d02c$var$MerkleTree = /*#__PURE__*/ function() {
    "use strict";
    function MerkleTree1(leafHashes) {
        (0, $978gY._)(this, MerkleTree1);
        this.branches = [];
        this.leaves = leafHashes;
        this.root = this.build(leafHashes);
    }
    (0, $kry2a._)(MerkleTree1, [
        {
            key: "build",
            value: function build(leaves) {
                if (leaves.length === 1) return leaves[0];
                if (leaves.length !== this.leaves.length) this.branches.push(leaves);
                var newLeaves = [];
                for(var i = 0; i < leaves.length; i += 2)if (i + 1 === leaves.length) newLeaves.push($facb0cbc5626d02c$var$MerkleTree.hash(leaves[i], "0x0"));
                else newLeaves.push($facb0cbc5626d02c$var$MerkleTree.hash(leaves[i], leaves[i + 1]));
                return this.build(newLeaves);
            }
        },
        {
            key: "getProof",
            value: function getProof(leaf) {
                var branch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.leaves, hashPath = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                var index = branch.indexOf(leaf);
                if (index === -1) throw new Error("leaf not found");
                if (branch.length === 1) return hashPath;
                var isLeft = index % 2 === 0;
                var _ref;
                var neededBranch = (_ref = isLeft ? branch[index + 1] : branch[index - 1]) !== null && _ref !== void 0 ? _ref : "0x0";
                var newHashPath = (0, $fLnyw._)(hashPath).concat([
                    neededBranch
                ]);
                var currentBranchLevelIndex = this.leaves.length === branch.length ? -1 : this.branches.findIndex(function(b) {
                    return b.length === branch.length;
                });
                var _this_branches_;
                var nextBranch = (_this_branches_ = this.branches[currentBranchLevelIndex + 1]) !== null && _this_branches_ !== void 0 ? _this_branches_ : [
                    this.root
                ];
                return this.getProof($facb0cbc5626d02c$var$MerkleTree.hash(isLeft ? leaf : neededBranch, isLeft ? neededBranch : leaf), nextBranch, newHashPath);
            }
        }
    ], [
        {
            key: "hash",
            value: function hash(a, b) {
                var _sort = (0, $8GFUW._)([
                    $facb0cbc5626d02c$var$toBN(a),
                    $facb0cbc5626d02c$var$toBN(b)
                ].sort(function(x, y) {
                    return x.gte(y) ? 1 : -1;
                }), 2), aSorted = _sort[0], bSorted = _sort[1];
                return $facb0cbc5626d02c$var$pedersen([
                    aSorted,
                    bSorted
                ]);
            }
        }
    ]);
    return MerkleTree1;
}();
function $facb0cbc5626d02c$var$proofMerklePath(root, leaf, path) {
    if (path.length === 0) return root === leaf;
    var _path = (0, $jKer9._)(path), next = _path[0], rest = _path.slice(1);
    return $facb0cbc5626d02c$var$proofMerklePath(root, $facb0cbc5626d02c$var$MerkleTree.hash(leaf, next), rest);
}
// src/utils/shortString.ts
var $facb0cbc5626d02c$export$bcef2cf0ec329fbf = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$bcef2cf0ec329fbf, {
    decodeShortString: function() {
        return $facb0cbc5626d02c$var$decodeShortString;
    },
    encodeShortString: function() {
        return $facb0cbc5626d02c$var$encodeShortString;
    },
    isASCII: function() {
        return $facb0cbc5626d02c$var$isASCII;
    },
    isDecimalString: function() {
        return $facb0cbc5626d02c$var$isDecimalString;
    },
    isShortString: function() {
        return $facb0cbc5626d02c$var$isShortString;
    }
});
function $facb0cbc5626d02c$var$isASCII(str) {
    return /^[\x00-\x7F]*$/.test(str);
}
function $facb0cbc5626d02c$var$isShortString(str) {
    return str.length <= 31;
}
function $facb0cbc5626d02c$var$isDecimalString(decim) {
    return /^[0-9]*$/i.test(decim);
}
function $facb0cbc5626d02c$var$encodeShortString(str) {
    if (!$facb0cbc5626d02c$var$isASCII(str)) throw new Error("".concat(str, " is not an ASCII string"));
    if (!$facb0cbc5626d02c$var$isShortString(str)) throw new Error("".concat(str, " is too long"));
    return $facb0cbc5626d02c$var$addHexPrefix(str.replace(/./g, function(char) {
        return char.charCodeAt(0).toString(16);
    }));
}
function $facb0cbc5626d02c$var$decodeShortString(str) {
    if (!$facb0cbc5626d02c$var$isASCII(str)) throw new Error("".concat(str, " is not an ASCII string"));
    if ($facb0cbc5626d02c$var$isHex(str)) return $facb0cbc5626d02c$var$removeHexPrefix(str).replace(/.{2}/g, function(hex) {
        return String.fromCharCode(parseInt(hex, 16));
    });
    if ($facb0cbc5626d02c$var$isDecimalString(str)) return $facb0cbc5626d02c$var$decodeShortString("0X".concat(BigInt(str).toString(16)));
    throw new Error("".concat(str, " is not Hex or decimal"));
}
// src/utils/typedData/utils.ts
var $facb0cbc5626d02c$var$validateTypedData = function(data) {
    var typedData = data;
    var valid = Boolean(typedData.types && typedData.primaryType && typedData.message);
    return valid;
};
// src/utils/typedData/index.ts
function $facb0cbc5626d02c$var$getHex(value) {
    try {
        return $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(value));
    } catch (e) {
        if (typeof value === "string") return $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$encodeShortString(value)));
        throw new Error("Invalid BigNumberish: ".concat(value));
    }
}
function $facb0cbc5626d02c$var$prepareSelector(selector) {
    return $facb0cbc5626d02c$var$isHex(selector) ? selector : $facb0cbc5626d02c$var$getSelectorFromName(selector);
}
function $facb0cbc5626d02c$var$isMerkleTreeType(type) {
    return type.type === "merkletree";
}
var $facb0cbc5626d02c$var$getDependencies = function(types, type) {
    var dependencies = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    if (type[type.length - 1] === "*") type = type.slice(0, -1);
    if (dependencies.includes(type)) return dependencies;
    if (!types[type]) return dependencies;
    return [
        type
    ].concat((0, $fLnyw._)(types[type].reduce(function(previous, t) {
        return (0, $fLnyw._)(previous).concat((0, $fLnyw._)($facb0cbc5626d02c$var$getDependencies(types, t.type, previous).filter(function(dependency) {
            return !previous.includes(dependency);
        })));
    }, [])));
};
function $facb0cbc5626d02c$var$getMerkleTreeType(types, ctx) {
    if (ctx.parent && ctx.key) {
        var parentType = types[ctx.parent];
        var merkleType = parentType.find(function(t) {
            return t.name === ctx.key;
        });
        var isMerkleTree = $facb0cbc5626d02c$var$isMerkleTreeType(merkleType);
        if (!isMerkleTree) throw new Error("".concat(ctx.key, " is not a merkle tree"));
        if (merkleType.contains.endsWith("*")) throw new Error("Merkle tree contain property must not be an array but was given ".concat(ctx.key));
        return merkleType.contains;
    }
    return "raw";
}
var $facb0cbc5626d02c$var$encodeType = function(types, type) {
    var _getDependencies = (0, $jKer9._)($facb0cbc5626d02c$var$getDependencies(types, type)), primary = _getDependencies[0], dependencies = _getDependencies.slice(1);
    var newTypes = !primary ? [] : [
        primary
    ].concat((0, $fLnyw._)(dependencies.sort()));
    return newTypes.map(function(dependency) {
        return "".concat(dependency, "(").concat(types[dependency].map(function(t) {
            return "".concat(t.name, ":").concat(t.type);
        }), ")");
    }).join("");
};
var $facb0cbc5626d02c$var$getTypeHash = function(types, type) {
    return $facb0cbc5626d02c$var$getSelectorFromName($facb0cbc5626d02c$var$encodeType(types, type));
};
var $facb0cbc5626d02c$var$encodeValue = function(types, type, data) {
    var ctx = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (types[type]) return [
        type,
        $facb0cbc5626d02c$var$getStructHash(types, type, data)
    ];
    if (Object.keys(types).map(function(x) {
        return "".concat(x, "*");
    }).includes(type)) {
        var structHashes = data.map(function(struct) {
            return $facb0cbc5626d02c$var$getStructHash(types, type.slice(0, -1), struct);
        });
        return [
            type,
            $facb0cbc5626d02c$var$computeHashOnElements(structHashes)
        ];
    }
    if (type === "merkletree") {
        var merkleTreeType = $facb0cbc5626d02c$var$getMerkleTreeType(types, ctx);
        var structHashes1 = data.map(function(struct) {
            return $facb0cbc5626d02c$var$encodeValue(types, merkleTreeType, struct)[1];
        });
        var root = new $facb0cbc5626d02c$var$MerkleTree(structHashes1).root;
        return [
            "felt",
            root
        ];
    }
    if (type === "felt*") return [
        "felt*",
        $facb0cbc5626d02c$var$computeHashOnElements(data)
    ];
    if (type === "selector") return [
        "felt",
        $facb0cbc5626d02c$var$prepareSelector(data)
    ];
    return [
        type,
        $facb0cbc5626d02c$var$getHex(data)
    ];
};
var $facb0cbc5626d02c$var$encodeData = function(types, type, data) {
    var _types_type_reduce = (0, $8GFUW._)(types[type].reduce(function(param, field) {
        var _param = (0, $8GFUW._)(param, 2), ts = _param[0], vs = _param[1];
        if (data[field.name] === void 0 || data[field.name] === null) throw new Error("Cannot encode data: missing data for '".concat(field.name, "'"));
        var value = data[field.name];
        var _encodeValue = (0, $8GFUW._)($facb0cbc5626d02c$var$encodeValue(types, field.type, value, {
            parent: type,
            key: field.name
        }), 2), t = _encodeValue[0], encodedValue = _encodeValue[1];
        return [
            (0, $fLnyw._)(ts).concat([
                t
            ]),
            (0, $fLnyw._)(vs).concat([
                encodedValue
            ])
        ];
    }, [
        [
            "felt"
        ],
        [
            $facb0cbc5626d02c$var$getTypeHash(types, type)
        ]
    ]), 2), returnTypes = _types_type_reduce[0], values = _types_type_reduce[1];
    return [
        returnTypes,
        values
    ];
};
var $facb0cbc5626d02c$var$getStructHash = function(types, type, data) {
    return $facb0cbc5626d02c$var$computeHashOnElements($facb0cbc5626d02c$var$encodeData(types, type, data)[1]);
};
var $facb0cbc5626d02c$var$getMessageHash = function(typedData, account) {
    if (!$facb0cbc5626d02c$var$validateTypedData(typedData)) throw new Error("Typed data does not match JSON schema");
    var message = [
        $facb0cbc5626d02c$var$encodeShortString("StarkNet Message"),
        $facb0cbc5626d02c$var$getStructHash(typedData.types, "StarkNetDomain", typedData.domain),
        account,
        $facb0cbc5626d02c$var$getStructHash(typedData.types, typedData.primaryType, typedData.message)
    ];
    return $facb0cbc5626d02c$var$computeHashOnElements(message);
};
// src/signer/default.ts
var $facb0cbc5626d02c$export$fdf54fdde81cc9f0 = /*#__PURE__*/ function() {
    "use strict";
    function Signer() {
        var keyPair = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $facb0cbc5626d02c$var$genKeyPair();
        (0, $978gY._)(this, Signer);
        this.keyPair = keyPair;
    }
    (0, $kry2a._)(Signer, [
        {
            key: "getPubKey",
            value: function getPubKey() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            $facb0cbc5626d02c$var$getStarkKey(_this.keyPair)
                        ];
                    });
                })();
            }
        },
        {
            key: "signMessage",
            value: function signMessage(typedData, accountAddress) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var msgHash;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        msgHash = $facb0cbc5626d02c$var$getMessageHash(typedData, accountAddress);
                        return [
                            2,
                            $facb0cbc5626d02c$var$sign(_this.keyPair, msgHash)
                        ];
                    });
                })();
            }
        },
        {
            key: "signTransaction",
            value: function signTransaction(transactions, transactionsDetail, abis) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var calldata, msgHash;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        if (abis && abis.length !== transactions.length) throw new Error("ABI must be provided for each transaction or no transaction");
                        calldata = $facb0cbc5626d02c$var$fromCallsToExecuteCalldata(transactions);
                        msgHash = $facb0cbc5626d02c$var$calculateTransactionHash(transactionsDetail.walletAddress, transactionsDetail.version, calldata, transactionsDetail.maxFee, transactionsDetail.chainId, transactionsDetail.nonce);
                        return [
                            2,
                            $facb0cbc5626d02c$var$sign(_this.keyPair, msgHash)
                        ];
                    });
                })();
            }
        },
        {
            key: "signDeployAccountTransaction",
            value: function signDeployAccountTransaction(param) {
                var classHash = param.classHash, contractAddress = param.contractAddress, constructorCalldata = param.constructorCalldata, addressSalt = param.addressSalt, maxFee = param.maxFee, version = param.version, chainId = param.chainId, nonce = param.nonce;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var msgHash;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        msgHash = $facb0cbc5626d02c$var$calculateDeployAccountTransactionHash(contractAddress, classHash, constructorCalldata, addressSalt, version, maxFee, chainId, nonce);
                        return [
                            2,
                            $facb0cbc5626d02c$var$sign(_this.keyPair, msgHash)
                        ];
                    });
                })();
            }
        },
        {
            key: "signDeclareTransaction",
            value: function signDeclareTransaction(param) {
                var classHash = param.classHash, senderAddress = param.senderAddress, chainId = param.chainId, maxFee = param.maxFee, version = param.version, nonce = param.nonce;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var msgHash;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        msgHash = $facb0cbc5626d02c$var$calculateDeclareTransactionHash(classHash, senderAddress, version, maxFee, chainId, nonce);
                        return [
                            2,
                            $facb0cbc5626d02c$var$sign(_this.keyPair, msgHash)
                        ];
                    });
                })();
            }
        }
    ]);
    return Signer;
}();
// src/utils/events.ts
function $facb0cbc5626d02c$var$parseUDCEvent(txReceipt) {
    if (!txReceipt.events) throw new Error("UDC emited event is empty");
    var event = txReceipt.events.find(function(it) {
        return $facb0cbc5626d02c$var$cleanHex(it.from_address) === $facb0cbc5626d02c$var$cleanHex($facb0cbc5626d02c$var$UDC.ADDRESS);
    }) || {
        data: []
    };
    return {
        transaction_hash: txReceipt.transaction_hash,
        contract_address: event.data[0],
        address: event.data[0],
        deployer: event.data[1],
        unique: event.data[2],
        classHash: event.data[3],
        calldata_len: event.data[4],
        calldata: event.data.slice(5, 5 + parseInt(event.data[4], 16)),
        salt: event.data[event.data.length - 1]
    };
}
// src/account/default.ts
var $facb0cbc5626d02c$export$1ed4b10e4aba04a7 = /*#__PURE__*/ function(Provider) {
    "use strict";
    (0, $ftJVG._)(Account, Provider);
    var _super = (0, $6OZAO._)(Account);
    function Account(providerOrOptions, address, keyPairOrSigner) {
        (0, $978gY._)(this, Account);
        var _this;
        _this = _super.call(this, providerOrOptions);
        _this.address = address.toLowerCase();
        _this.signer = "getPubKey" in keyPairOrSigner ? keyPairOrSigner : new $facb0cbc5626d02c$export$fdf54fdde81cc9f0(keyPairOrSigner);
        return _this;
    }
    (0, $kry2a._)(Account, [
        {
            key: "getNonce",
            value: function getNonce(blockIdentifier) {
                var _this = this;
                var _this1 = this, _superprop_get_getNonceForAddress = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(Account.prototype), "getNonceForAddress", _this);
                };
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _superprop_get_getNonceForAddress().call(_this1, _this1.address, blockIdentifier)
                        ];
                    });
                })();
            }
        },
        {
            key: "estimateFee",
            value: function estimateFee(calls, estimateFeeDetails) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.estimateInvokeFee(calls, estimateFeeDetails)
                        ];
                    });
                })();
            }
        },
        {
            key: "estimateInvokeFee",
            value: function estimateInvokeFee(calls) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, providedNonce = _ref.nonce, blockIdentifier = _ref.blockIdentifier;
                var _this = this;
                var _this1 = this, _superprop_get_getInvokeEstimateFee = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(Account.prototype), "getInvokeEstimateFee", _this);
                };
                return (0, $byzP8._)(function() {
                    var transactions, nonce, _tmp, version, chainId, signerDetails, invocation, response, suggestedMaxFee;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                transactions = Array.isArray(calls) ? calls : [
                                    calls
                                ];
                                if (!(providedNonce !== null && providedNonce !== void 0)) return [
                                    3,
                                    1
                                ];
                                _tmp = providedNonce;
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this1.getNonce()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                nonce = $facb0cbc5626d02c$var$toBN.apply(void 0, [
                                    _tmp
                                ]);
                                version = $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$feeTransactionVersion);
                                return [
                                    4,
                                    _this1.getChainId()
                                ];
                            case 4:
                                chainId = _state.sent();
                                signerDetails = {
                                    walletAddress: _this1.address,
                                    nonce: nonce,
                                    maxFee: $facb0cbc5626d02c$var$ZERO,
                                    version: version,
                                    chainId: chainId
                                };
                                return [
                                    4,
                                    _this1.buildInvocation(transactions, signerDetails)
                                ];
                            case 5:
                                invocation = _state.sent();
                                return [
                                    4,
                                    _superprop_get_getInvokeEstimateFee().call(_this1, (0, $8OnJk._)({}, invocation), {
                                        version: version,
                                        nonce: nonce
                                    }, blockIdentifier)
                                ];
                            case 6:
                                response = _state.sent();
                                suggestedMaxFee = $facb0cbc5626d02c$var$estimatedFeeToMaxFee(response.overall_fee);
                                return [
                                    2,
                                    (0, $8E768._)((0, $8OnJk._)({}, response), {
                                        suggestedMaxFee: suggestedMaxFee
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "estimateDeclareFee",
            value: function estimateDeclareFee(param) {
                var classHash = param.classHash, contract = param.contract, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, blockIdentifier = _ref.blockIdentifier, providedNonce = _ref.nonce;
                var _this = this;
                var _this1 = this, _superprop_get_getDeclareEstimateFee = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(Account.prototype), "getDeclareEstimateFee", _this);
                };
                return (0, $byzP8._)(function() {
                    var nonce, _tmp, version, chainId, payload, response, suggestedMaxFee;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(providedNonce !== null && providedNonce !== void 0)) return [
                                    3,
                                    1
                                ];
                                _tmp = providedNonce;
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this1.getNonce()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                nonce = $facb0cbc5626d02c$var$toBN.apply(void 0, [
                                    _tmp
                                ]);
                                version = $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$feeTransactionVersion);
                                return [
                                    4,
                                    _this1.getChainId()
                                ];
                            case 4:
                                chainId = _state.sent();
                                return [
                                    4,
                                    _this1.buildDeclarePayload({
                                        classHash: classHash,
                                        contract: contract
                                    }, {
                                        nonce: nonce,
                                        chainId: chainId,
                                        version: version,
                                        walletAddress: _this1.address,
                                        maxFee: $facb0cbc5626d02c$var$ZERO
                                    })
                                ];
                            case 5:
                                payload = _state.sent();
                                return [
                                    4,
                                    _superprop_get_getDeclareEstimateFee().call(_this1, (0, $8OnJk._)({}, payload), {
                                        version: version,
                                        nonce: nonce
                                    }, blockIdentifier)
                                ];
                            case 6:
                                response = _state.sent();
                                suggestedMaxFee = $facb0cbc5626d02c$var$estimatedFeeToMaxFee(response.overall_fee);
                                return [
                                    2,
                                    (0, $8E768._)((0, $8OnJk._)({}, response), {
                                        suggestedMaxFee: suggestedMaxFee
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "estimateAccountDeployFee",
            value: function estimateAccountDeployFee(param) {
                var classHash = param.classHash, _param_addressSalt = param.addressSalt, addressSalt = _param_addressSalt === void 0 ? 0 : _param_addressSalt, _param_constructorCalldata = param.constructorCalldata, constructorCalldata = _param_constructorCalldata === void 0 ? [] : _param_constructorCalldata, providedContractAddress = param.contractAddress, blockIdentifier = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).blockIdentifier;
                var _this = this;
                var _this1 = this, _superprop_get_getDeployAccountEstimateFee = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(Account.prototype), "getDeployAccountEstimateFee", _this);
                };
                return (0, $byzP8._)(function() {
                    var nonce, version, chainId, payload, response, suggestedMaxFee;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                nonce = "0x0";
                                version = $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$feeTransactionVersion);
                                return [
                                    4,
                                    _this1.getChainId()
                                ];
                            case 1:
                                chainId = _state.sent();
                                return [
                                    4,
                                    _this1.buildAccountDeployPayload({
                                        classHash: classHash,
                                        addressSalt: addressSalt,
                                        constructorCalldata: constructorCalldata,
                                        contractAddress: providedContractAddress
                                    }, {
                                        nonce: nonce,
                                        chainId: chainId,
                                        version: version,
                                        walletAddress: _this1.address,
                                        maxFee: $facb0cbc5626d02c$var$ZERO
                                    })
                                ];
                            case 2:
                                payload = _state.sent();
                                return [
                                    4,
                                    _superprop_get_getDeployAccountEstimateFee().call(_this1, (0, $8OnJk._)({}, payload), {
                                        version: version,
                                        nonce: nonce
                                    }, blockIdentifier)
                                ];
                            case 3:
                                response = _state.sent();
                                suggestedMaxFee = $facb0cbc5626d02c$var$estimatedFeeToMaxFee(response.overall_fee);
                                return [
                                    2,
                                    (0, $8E768._)((0, $8OnJk._)({}, response), {
                                        suggestedMaxFee: suggestedMaxFee
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "estimateDeployFee",
            value: function estimateDeployFee(payload, transactionsDetail) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var calls;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        calls = _this.buildUDCContractPayload(payload);
                        return [
                            2,
                            _this.estimateInvokeFee(calls, transactionsDetail)
                        ];
                    });
                })();
            }
        },
        {
            key: "estimateFeeBulk",
            value: function estimateFeeBulk(transactions) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, providedNonce = _ref.nonce, blockIdentifier = _ref.blockIdentifier;
                var _this = this;
                var _this1 = this, _superprop_get_getEstimateFeeBulk = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(Account.prototype), "getEstimateFeeBulk", _this);
                };
                return (0, $byzP8._)(function() {
                    var nonce, _tmp, version, chainId, params, response;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(providedNonce !== null && providedNonce !== void 0)) return [
                                    3,
                                    1
                                ];
                                _tmp = providedNonce;
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this1.getNonce()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                nonce = $facb0cbc5626d02c$var$toBN.apply(void 0, [
                                    _tmp
                                ]);
                                version = $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$feeTransactionVersion);
                                return [
                                    4,
                                    _this1.getChainId()
                                ];
                            case 4:
                                chainId = _state.sent();
                                return [
                                    4,
                                    Promise.all([].concat(transactions).map(function() {
                                        var _ref = (0, $byzP8._)(function(transaction, index) {
                                            var signerDetails, txPayload, res, invocation, declareContractPayload, payload, calls, invocation1;
                                            return (0, $7UAGh.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        signerDetails = {
                                                            walletAddress: _this1.address,
                                                            nonce: $facb0cbc5626d02c$var$toBN(Number(nonce) + index),
                                                            maxFee: $facb0cbc5626d02c$var$ZERO,
                                                            version: version,
                                                            chainId: chainId
                                                        };
                                                        txPayload = transaction.payload;
                                                        if (!(typeof transaction === "object" && transaction.type === "INVOKE_FUNCTION")) return [
                                                            3,
                                                            2
                                                        ];
                                                        return [
                                                            4,
                                                            _this1.buildInvocation(Array.isArray(txPayload) ? txPayload : [
                                                                txPayload
                                                            ], signerDetails)
                                                        ];
                                                    case 1:
                                                        invocation = _state.sent();
                                                        res = (0, $8E768._)((0, $8OnJk._)({
                                                            type: "INVOKE_FUNCTION"
                                                        }, invocation), {
                                                            version: version,
                                                            nonce: $facb0cbc5626d02c$var$toBN(Number(nonce) + index),
                                                            blockIdentifier: blockIdentifier
                                                        });
                                                        return [
                                                            3,
                                                            8
                                                        ];
                                                    case 2:
                                                        if (!(typeof transaction === "object" && transaction.type === "DECLARE")) return [
                                                            3,
                                                            4
                                                        ];
                                                        return [
                                                            4,
                                                            _this1.buildDeclarePayload(txPayload, signerDetails)
                                                        ];
                                                    case 3:
                                                        declareContractPayload = _state.sent();
                                                        res = (0, $8E768._)((0, $8OnJk._)({
                                                            type: "DECLARE"
                                                        }, declareContractPayload), {
                                                            version: version,
                                                            nonce: $facb0cbc5626d02c$var$toBN(Number(nonce) + index),
                                                            blockIdentifier: blockIdentifier
                                                        });
                                                        return [
                                                            3,
                                                            8
                                                        ];
                                                    case 4:
                                                        if (!(typeof transaction === "object" && transaction.type === "DEPLOY_ACCOUNT")) return [
                                                            3,
                                                            6
                                                        ];
                                                        return [
                                                            4,
                                                            _this1.buildAccountDeployPayload(txPayload, signerDetails)
                                                        ];
                                                    case 5:
                                                        payload = _state.sent();
                                                        res = (0, $8E768._)((0, $8OnJk._)({
                                                            type: "DEPLOY_ACCOUNT"
                                                        }, payload), {
                                                            version: version,
                                                            nonce: nonce,
                                                            blockIdentifier: blockIdentifier
                                                        });
                                                        return [
                                                            3,
                                                            8
                                                        ];
                                                    case 6:
                                                        if (!(typeof transaction === "object" && transaction.type === "DEPLOY")) return [
                                                            3,
                                                            8
                                                        ];
                                                        calls = _this1.buildUDCContractPayload(txPayload);
                                                        return [
                                                            4,
                                                            _this1.buildInvocation(calls, signerDetails)
                                                        ];
                                                    case 7:
                                                        invocation1 = _state.sent();
                                                        res = (0, $8E768._)((0, $8OnJk._)({
                                                            type: "INVOKE_FUNCTION"
                                                        }, invocation1), {
                                                            version: version,
                                                            nonce: $facb0cbc5626d02c$var$toBN(Number(nonce) + index),
                                                            blockIdentifier: blockIdentifier
                                                        });
                                                        _state.label = 8;
                                                    case 8:
                                                        return [
                                                            2,
                                                            res
                                                        ];
                                                }
                                            });
                                        });
                                        return function(transaction, index) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 5:
                                params = _state.sent();
                                return [
                                    4,
                                    _superprop_get_getEstimateFeeBulk().call(_this1, params, blockIdentifier)
                                ];
                            case 6:
                                response = _state.sent();
                                return [
                                    2,
                                    [].concat(response).map(function(elem) {
                                        var suggestedMaxFee = $facb0cbc5626d02c$var$estimatedFeeToMaxFee(elem.overall_fee);
                                        return (0, $8E768._)((0, $8OnJk._)({}, elem), {
                                            suggestedMaxFee: suggestedMaxFee
                                        });
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "buildInvocation",
            value: function buildInvocation(call, signerDetails) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var calldata, signature;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                calldata = $facb0cbc5626d02c$var$fromCallsToExecuteCalldata(call);
                                return [
                                    4,
                                    _this.signer.signTransaction(call, signerDetails)
                                ];
                            case 1:
                                signature = _state.sent();
                                return [
                                    2,
                                    {
                                        contractAddress: _this.address,
                                        calldata: calldata,
                                        signature: signature
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "execute",
            value: function execute(calls, abis) {
                var transactionsDetail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return (0, $byzP8._)(function() {
                    var transactions, _transactionsDetail_nonce, nonce, _tmp, _transactionsDetail_maxFee, maxFee, _tmp1, version, chainId, signerDetails, signature, calldata;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                transactions = Array.isArray(calls) ? calls : [
                                    calls
                                ];
                                if (!((_transactionsDetail_nonce = transactionsDetail.nonce) !== null && _transactionsDetail_nonce !== void 0)) return [
                                    3,
                                    1
                                ];
                                _tmp = _transactionsDetail_nonce;
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.getNonce()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                nonce = $facb0cbc5626d02c$var$toBN.apply(void 0, [
                                    _tmp
                                ]);
                                if (!((_transactionsDetail_maxFee = transactionsDetail.maxFee) !== null && _transactionsDetail_maxFee !== void 0)) return [
                                    3,
                                    4
                                ];
                                _tmp1 = _transactionsDetail_maxFee;
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    _this.getSuggestedMaxFee({
                                        type: "INVOKE",
                                        payload: calls
                                    }, transactionsDetail)
                                ];
                            case 5:
                                _tmp1 = _state.sent();
                                _state.label = 6;
                            case 6:
                                maxFee = _tmp1;
                                version = $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$transactionVersion);
                                return [
                                    4,
                                    _this.getChainId()
                                ];
                            case 7:
                                chainId = _state.sent();
                                signerDetails = {
                                    walletAddress: _this.address,
                                    nonce: nonce,
                                    maxFee: maxFee,
                                    version: version,
                                    chainId: chainId
                                };
                                return [
                                    4,
                                    _this.signer.signTransaction(transactions, signerDetails, abis)
                                ];
                            case 8:
                                signature = _state.sent();
                                calldata = $facb0cbc5626d02c$var$fromCallsToExecuteCalldata(transactions);
                                return [
                                    2,
                                    _this.invokeFunction({
                                        contractAddress: _this.address,
                                        calldata: calldata,
                                        signature: signature
                                    }, {
                                        nonce: nonce,
                                        maxFee: maxFee,
                                        version: version
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "declare",
            value: function declare(param) {
                var classHash = param.classHash, contract = param.contract, transactionsDetail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _transactionsDetail_nonce, nonce, _tmp, _transactionsDetail_maxFee, maxFee, _tmp1, version, chainId, signature, contractDefinition;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!((_transactionsDetail_nonce = transactionsDetail.nonce) !== null && _transactionsDetail_nonce !== void 0)) return [
                                    3,
                                    1
                                ];
                                _tmp = _transactionsDetail_nonce;
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.getNonce()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                nonce = $facb0cbc5626d02c$var$toBN.apply(void 0, [
                                    _tmp
                                ]);
                                if (!((_transactionsDetail_maxFee = transactionsDetail.maxFee) !== null && _transactionsDetail_maxFee !== void 0)) return [
                                    3,
                                    4
                                ];
                                _tmp1 = _transactionsDetail_maxFee;
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    _this.getSuggestedMaxFee({
                                        type: "DECLARE",
                                        payload: {
                                            classHash: classHash,
                                            contract: contract
                                        }
                                    }, transactionsDetail)
                                ];
                            case 5:
                                _tmp1 = _state.sent();
                                _state.label = 6;
                            case 6:
                                maxFee = _tmp1;
                                version = $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$transactionVersion);
                                return [
                                    4,
                                    _this.getChainId()
                                ];
                            case 7:
                                chainId = _state.sent();
                                return [
                                    4,
                                    _this.signer.signDeclareTransaction({
                                        classHash: classHash,
                                        senderAddress: _this.address,
                                        chainId: chainId,
                                        maxFee: maxFee,
                                        version: version,
                                        nonce: nonce
                                    })
                                ];
                            case 8:
                                signature = _state.sent();
                                contractDefinition = $facb0cbc5626d02c$var$parseContract(contract);
                                return [
                                    2,
                                    _this.declareContract({
                                        contractDefinition: contractDefinition,
                                        senderAddress: _this.address,
                                        signature: signature
                                    }, {
                                        nonce: nonce,
                                        maxFee: maxFee,
                                        version: version
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deploy",
            value: function deploy(payload, details) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var params, calls, addresses, invokeResponse;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                params = [].concat(payload).map(function(it) {
                                    var classHash = it.classHash, salt = it.salt, _it_unique = it.unique, unique = _it_unique === void 0 ? true : _it_unique, _it_constructorCalldata = it.constructorCalldata, constructorCalldata = _it_constructorCalldata === void 0 ? [] : _it_constructorCalldata;
                                    var compiledConstructorCallData = $facb0cbc5626d02c$var$compileCalldata(constructorCalldata);
                                    var deploySalt = salt !== null && salt !== void 0 ? salt : $facb0cbc5626d02c$var$randomAddress();
                                    return {
                                        call: {
                                            contractAddress: $facb0cbc5626d02c$var$UDC.ADDRESS,
                                            entrypoint: $facb0cbc5626d02c$var$UDC.ENTRYPOINT,
                                            calldata: [
                                                classHash,
                                                deploySalt,
                                                $facb0cbc5626d02c$var$toCairoBool(unique),
                                                compiledConstructorCallData.length
                                            ].concat((0, $fLnyw._)(compiledConstructorCallData))
                                        },
                                        address: $facb0cbc5626d02c$var$calculateContractAddressFromHash(unique ? $facb0cbc5626d02c$var$pedersen([
                                            _this.address,
                                            deploySalt
                                        ]) : deploySalt, classHash, compiledConstructorCallData, unique ? $facb0cbc5626d02c$var$UDC.ADDRESS : 0)
                                    };
                                });
                                calls = params.map(function(it) {
                                    return it.call;
                                });
                                addresses = params.map(function(it) {
                                    return it.address;
                                });
                                return [
                                    4,
                                    _this.execute(calls, void 0, details)
                                ];
                            case 1:
                                invokeResponse = _state.sent();
                                return [
                                    2,
                                    (0, $8E768._)((0, $8OnJk._)({}, invokeResponse), {
                                        contract_address: addresses
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deployContract",
            value: function deployContract(payload, details) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var deployTx, txReceipt;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.deploy(payload, details)
                                ];
                            case 1:
                                deployTx = _state.sent();
                                return [
                                    4,
                                    _this.waitForTransaction(deployTx.transaction_hash, void 0, [
                                        "ACCEPTED_ON_L2"
                                    ])
                                ];
                            case 2:
                                txReceipt = _state.sent();
                                return [
                                    2,
                                    $facb0cbc5626d02c$var$parseUDCEvent(txReceipt)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "declareDeploy",
            value: function declareDeploy(payload, details) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var classHash, contract, constructorCalldata, salt, unique, transaction_hash, declare, deploy;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                classHash = payload.classHash, contract = payload.contract, constructorCalldata = payload.constructorCalldata, salt = payload.salt, unique = payload.unique;
                                return [
                                    4,
                                    _this.declare({
                                        contract: contract,
                                        classHash: classHash
                                    }, details)
                                ];
                            case 1:
                                transaction_hash = _state.sent().transaction_hash;
                                return [
                                    4,
                                    _this.waitForTransaction(transaction_hash, void 0, [
                                        "ACCEPTED_ON_L2"
                                    ])
                                ];
                            case 2:
                                declare = _state.sent();
                                return [
                                    4,
                                    _this.deployContract({
                                        classHash: classHash,
                                        salt: salt,
                                        unique: unique,
                                        constructorCalldata: constructorCalldata
                                    }, details)
                                ];
                            case 3:
                                deploy = _state.sent();
                                return [
                                    2,
                                    {
                                        declare: (0, $8E768._)((0, $8OnJk._)({}, declare), {
                                            class_hash: classHash
                                        }),
                                        deploy: deploy
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deployAccount",
            value: function deployAccount(param) {
                var classHash = param.classHash, _param_constructorCalldata = param.constructorCalldata, constructorCalldata = _param_constructorCalldata === void 0 ? [] : _param_constructorCalldata, _param_addressSalt = param.addressSalt, addressSalt = _param_addressSalt === void 0 ? 0 : _param_addressSalt, providedContractAddress = param.contractAddress, transactionsDetail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                return (0, $byzP8._)(function() {
                    var nonce, version, chainId, contractAddress, _transactionsDetail_maxFee, maxFee, _tmp, signature;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                nonce = "0x0";
                                version = $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$transactionVersion);
                                return [
                                    4,
                                    _this.getChainId()
                                ];
                            case 1:
                                chainId = _state.sent();
                                contractAddress = providedContractAddress !== null && providedContractAddress !== void 0 ? providedContractAddress : $facb0cbc5626d02c$var$calculateContractAddressFromHash(addressSalt, classHash, constructorCalldata, 0);
                                if (!((_transactionsDetail_maxFee = transactionsDetail.maxFee) !== null && _transactionsDetail_maxFee !== void 0)) return [
                                    3,
                                    2
                                ];
                                _tmp = _transactionsDetail_maxFee;
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.getSuggestedMaxFee({
                                        type: "DEPLOY_ACCOUNT",
                                        payload: {
                                            classHash: classHash,
                                            constructorCalldata: constructorCalldata,
                                            addressSalt: addressSalt,
                                            contractAddress: contractAddress
                                        }
                                    }, transactionsDetail)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                _state.label = 4;
                            case 4:
                                maxFee = _tmp;
                                return [
                                    4,
                                    _this.signer.signDeployAccountTransaction({
                                        classHash: classHash,
                                        constructorCalldata: constructorCalldata,
                                        contractAddress: contractAddress,
                                        addressSalt: addressSalt,
                                        chainId: chainId,
                                        maxFee: maxFee,
                                        version: version,
                                        nonce: nonce
                                    })
                                ];
                            case 5:
                                signature = _state.sent();
                                return [
                                    2,
                                    _this.deployAccountContract({
                                        classHash: classHash,
                                        addressSalt: addressSalt,
                                        constructorCalldata: constructorCalldata,
                                        signature: signature
                                    }, {
                                        nonce: nonce,
                                        maxFee: maxFee,
                                        version: version
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signMessage",
            value: function signMessage(typedData) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.signer.signMessage(typedData, _this.address)
                        ];
                    });
                })();
            }
        },
        {
            key: "hashMessage",
            value: function hashMessage(typedData) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            $facb0cbc5626d02c$var$getMessageHash(typedData, _this.address)
                        ];
                    });
                })();
            }
        },
        {
            key: "verifyMessageHash",
            value: function verifyMessageHash(hash, signature) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.callContract({
                                        contractAddress: _this.address,
                                        entrypoint: "isValidSignature",
                                        calldata: $facb0cbc5626d02c$var$compileCalldata({
                                            hash: $facb0cbc5626d02c$var$toBN(hash).toString(),
                                            signature: signature.map(function(x) {
                                                return $facb0cbc5626d02c$var$toBN(x).toString();
                                            })
                                        })
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    true
                                ];
                            case 2:
                                e = _state.sent();
                                return [
                                    2,
                                    false
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "verifyMessage",
            value: function verifyMessage(typedData, signature) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var hash;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.hashMessage(typedData)
                                ];
                            case 1:
                                hash = _state.sent();
                                return [
                                    2,
                                    _this.verifyMessageHash(hash, signature)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSuggestedMaxFee",
            value: function getSuggestedMaxFee(param, details) {
                var type = param.type, payload = param.payload;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var feeEstimate;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                switch(type){
                                    case "INVOKE":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "DECLARE":
                                        return [
                                            3,
                                            3
                                        ];
                                    case "DEPLOY_ACCOUNT":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "DEPLOY":
                                        return [
                                            3,
                                            7
                                        ];
                                }
                                return [
                                    3,
                                    9
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.estimateInvokeFee(payload, details)
                                ];
                            case 2:
                                feeEstimate = _state.sent();
                                return [
                                    3,
                                    10
                                ];
                            case 3:
                                return [
                                    4,
                                    _this.estimateDeclareFee(payload, details)
                                ];
                            case 4:
                                feeEstimate = _state.sent();
                                return [
                                    3,
                                    10
                                ];
                            case 5:
                                return [
                                    4,
                                    _this.estimateAccountDeployFee(payload, details)
                                ];
                            case 6:
                                feeEstimate = _state.sent();
                                return [
                                    3,
                                    10
                                ];
                            case 7:
                                return [
                                    4,
                                    _this.estimateDeployFee(payload, details)
                                ];
                            case 8:
                                feeEstimate = _state.sent();
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                feeEstimate = {
                                    suggestedMaxFee: $facb0cbc5626d02c$var$ZERO,
                                    overall_fee: $facb0cbc5626d02c$var$ZERO
                                };
                                return [
                                    3,
                                    10
                                ];
                            case 10:
                                return [
                                    2,
                                    feeEstimate.suggestedMaxFee.toString()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "buildDeclarePayload",
            value: function buildDeclarePayload(param, param1) {
                var classHash = param.classHash, contract = param.contract, nonce = param1.nonce, chainId = param1.chainId, version = param1.version, walletAddress = param1.walletAddress, maxFee = param1.maxFee;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var contractDefinition, signature;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                contractDefinition = $facb0cbc5626d02c$var$parseContract(contract);
                                return [
                                    4,
                                    _this.signer.signDeclareTransaction({
                                        classHash: classHash,
                                        senderAddress: walletAddress,
                                        chainId: chainId,
                                        maxFee: maxFee,
                                        version: version,
                                        nonce: nonce
                                    })
                                ];
                            case 1:
                                signature = _state.sent();
                                return [
                                    2,
                                    {
                                        senderAddress: walletAddress,
                                        signature: signature,
                                        contractDefinition: contractDefinition
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "buildAccountDeployPayload",
            value: function buildAccountDeployPayload(param, param1) {
                var classHash = param.classHash, _param_addressSalt = param.addressSalt, addressSalt = _param_addressSalt === void 0 ? 0 : _param_addressSalt, _param_constructorCalldata = param.constructorCalldata, constructorCalldata = _param_constructorCalldata === void 0 ? [] : _param_constructorCalldata, providedContractAddress = param.contractAddress, nonce = param1.nonce, chainId = param1.chainId, version = param1.version, maxFee = param1.maxFee;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var contractAddress, signature;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                contractAddress = providedContractAddress !== null && providedContractAddress !== void 0 ? providedContractAddress : $facb0cbc5626d02c$var$calculateContractAddressFromHash(addressSalt, classHash, constructorCalldata, 0);
                                return [
                                    4,
                                    _this.signer.signDeployAccountTransaction({
                                        classHash: classHash,
                                        contractAddress: contractAddress,
                                        chainId: chainId,
                                        maxFee: maxFee,
                                        version: version,
                                        nonce: nonce,
                                        addressSalt: addressSalt,
                                        constructorCalldata: constructorCalldata
                                    })
                                ];
                            case 1:
                                signature = _state.sent();
                                return [
                                    2,
                                    {
                                        classHash: classHash,
                                        addressSalt: addressSalt,
                                        constructorCalldata: constructorCalldata,
                                        signature: signature
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "buildUDCContractPayload",
            value: function buildUDCContractPayload(payload) {
                var calls = [].concat(payload).map(function(it) {
                    var classHash = it.classHash, _it_salt = it.salt, salt = _it_salt === void 0 ? "0" : _it_salt, _it_unique = it.unique, unique = _it_unique === void 0 ? true : _it_unique, _it_constructorCalldata = it.constructorCalldata, constructorCalldata = _it_constructorCalldata === void 0 ? [] : _it_constructorCalldata;
                    var compiledConstructorCallData = $facb0cbc5626d02c$var$compileCalldata(constructorCalldata);
                    return {
                        contractAddress: $facb0cbc5626d02c$var$UDC.ADDRESS,
                        entrypoint: $facb0cbc5626d02c$var$UDC.ENTRYPOINT,
                        calldata: [
                            classHash,
                            salt,
                            $facb0cbc5626d02c$var$toCairoBool(unique),
                            compiledConstructorCallData.length
                        ].concat((0, $fLnyw._)(compiledConstructorCallData))
                    };
                });
                return calls;
            }
        },
        {
            key: "simulateTransaction",
            value: function simulateTransaction(calls) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, providedNonce = _ref.nonce, blockIdentifier = _ref.blockIdentifier;
                var _this = this;
                var _this1 = this, _superprop_get_getSimulateTransaction = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(Account.prototype), "getSimulateTransaction", _this);
                };
                return (0, $byzP8._)(function() {
                    var transactions, nonce, _tmp, version, chainId, signerDetails, invocation, response, suggestedMaxFee;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                transactions = Array.isArray(calls) ? calls : [
                                    calls
                                ];
                                if (!(providedNonce !== null && providedNonce !== void 0)) return [
                                    3,
                                    1
                                ];
                                _tmp = providedNonce;
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this1.getNonce()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                nonce = $facb0cbc5626d02c$var$toBN.apply(void 0, [
                                    _tmp
                                ]);
                                version = $facb0cbc5626d02c$var$toBN($facb0cbc5626d02c$var$feeTransactionVersion);
                                return [
                                    4,
                                    _this1.getChainId()
                                ];
                            case 4:
                                chainId = _state.sent();
                                signerDetails = {
                                    walletAddress: _this1.address,
                                    nonce: nonce,
                                    maxFee: $facb0cbc5626d02c$var$ZERO,
                                    version: version,
                                    chainId: chainId
                                };
                                return [
                                    4,
                                    _this1.buildInvocation(transactions, signerDetails)
                                ];
                            case 5:
                                invocation = _state.sent();
                                return [
                                    4,
                                    _superprop_get_getSimulateTransaction().call(_this1, invocation, {
                                        version: version,
                                        nonce: nonce
                                    }, blockIdentifier)
                                ];
                            case 6:
                                response = _state.sent();
                                suggestedMaxFee = $facb0cbc5626d02c$var$estimatedFeeToMaxFee(response.fee_estimation.overall_fee);
                                return [
                                    2,
                                    (0, $8E768._)((0, $8OnJk._)({}, response), {
                                        fee_estimation: (0, $8E768._)((0, $8OnJk._)({}, response.fee_estimation), {
                                            suggestedMaxFee: suggestedMaxFee
                                        })
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getStarkName",
            value: function getStarkName() {
                var address = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.address, StarknetIdContract = arguments.length > 1 ? arguments[1] : void 0;
                var _this = this;
                var _this1 = this, _superprop_get_getStarkName = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(Account.prototype), "getStarkName", _this);
                };
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _superprop_get_getStarkName().call(_this1, address, StarknetIdContract)
                        ];
                    });
                })();
            }
        }
    ]);
    return Account;
}($facb0cbc5626d02c$export$2881499e37b75b9a);
// src/account/interface.ts
var $facb0cbc5626d02c$export$73debe15cf2a7ba5 = /*#__PURE__*/ function(ProviderInterface) {
    "use strict";
    (0, $ftJVG._)(AccountInterface, ProviderInterface);
    var _super = (0, $6OZAO._)(AccountInterface);
    function AccountInterface() {
        (0, $978gY._)(this, AccountInterface);
        return _super.apply(this, arguments);
    }
    return AccountInterface;
}($facb0cbc5626d02c$export$8efff2d796cdea69);
// src/utils/uint256.ts
var $facb0cbc5626d02c$export$fa66cedfaa3c10f3 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$fa66cedfaa3c10f3, {
    UINT_128_MAX: function() {
        return $facb0cbc5626d02c$var$UINT_128_MAX;
    },
    UINT_256_MAX: function() {
        return $facb0cbc5626d02c$var$UINT_256_MAX;
    },
    bnToUint256: function() {
        return $facb0cbc5626d02c$var$bnToUint256;
    },
    isUint256: function() {
        return $facb0cbc5626d02c$var$isUint256;
    },
    uint256ToBN: function() {
        return $facb0cbc5626d02c$var$uint256ToBN;
    }
});
function $facb0cbc5626d02c$var$uint256ToBN(uint256) {
    return $facb0cbc5626d02c$var$toBN(uint256.high).shln(128).add($facb0cbc5626d02c$var$toBN(uint256.low));
}
var $facb0cbc5626d02c$var$UINT_128_MAX = $facb0cbc5626d02c$var$toBN(1).shln(128).sub($facb0cbc5626d02c$var$toBN(1));
var $facb0cbc5626d02c$var$UINT_256_MAX = $facb0cbc5626d02c$var$toBN(1).shln(256).sub($facb0cbc5626d02c$var$toBN(1));
function $facb0cbc5626d02c$var$isUint256(bn) {
    return $facb0cbc5626d02c$var$toBN(bn).lte($facb0cbc5626d02c$var$UINT_256_MAX);
}
function $facb0cbc5626d02c$var$bnToUint256(bignumber) {
    var bn = $facb0cbc5626d02c$var$toBN(bignumber);
    if (!$facb0cbc5626d02c$var$isUint256(bn)) throw new Error("Number is too large");
    return {
        low: $facb0cbc5626d02c$var$addHexPrefix(bn.maskn(128).toString(16)),
        high: $facb0cbc5626d02c$var$addHexPrefix(bn.shrn(128).toString(16))
    };
}
function $facb0cbc5626d02c$export$74cf7857f9f0313c(address) {
    return $facb0cbc5626d02c$var$addHexPrefix($facb0cbc5626d02c$var$removeHexPrefix($facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$toBN(address))).padStart(64, "0"));
}
function $facb0cbc5626d02c$export$5049782b602a3e5d(address) {
    $facb0cbc5626d02c$var$assertInRange(address, $facb0cbc5626d02c$var$ZERO, $facb0cbc5626d02c$var$MASK_251, "Starknet Address");
    var result = $facb0cbc5626d02c$export$74cf7857f9f0313c(address);
    if (!result.match(/^(0x)?[0-9a-fA-F]{64}$/)) throw new Error("Invalid Address Format");
    return result;
}
function $facb0cbc5626d02c$export$c696806606bb1429(address) {
    var chars = $facb0cbc5626d02c$var$removeHexPrefix($facb0cbc5626d02c$export$5049782b602a3e5d(address)).toLowerCase().split("");
    var hashed = (0, $j2rU8.arrayify)($facb0cbc5626d02c$var$keccakBn(address), {
        hexPad: "left"
    });
    for(var i = 0; i < chars.length; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 15) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return $facb0cbc5626d02c$var$addHexPrefix(chars.join(""));
}
function $facb0cbc5626d02c$export$26bc63e5b5463ece(address) {
    return $facb0cbc5626d02c$export$c696806606bb1429(address) === address;
}

});
parcelRequire.register("jKer9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e5fd8313026a48a6$export$e62c166da838fa3; });

var $jbUp2 = parcelRequire("jbUp2");

var $2uHzb = parcelRequire("2uHzb");

var $4Tldu = parcelRequire("4Tldu");

var $imR8K = parcelRequire("imR8K");
function $e5fd8313026a48a6$export$e62c166da838fa3(arr) {
    return (0, $jbUp2._array_with_holes)(arr) || (0, $2uHzb._iterable_to_array)(arr) || (0, $imR8K._unsupported_iterable_to_array)(arr) || (0, $4Tldu._non_iterable_rest)();
}

});

parcelRequire.register("jxHwd", function(module, exports) {
// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
parcelRequire("eRv67");
module.exports = self.fetch.bind(self);

});
parcelRequire.register("eRv67", function(module, exports) {
/* eslint-disable no-prototype-builtins */ var $ad1e23473b0550f0$var$g = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== "undefined" && $parcel$global || {};
var $ad1e23473b0550f0$var$support = {
    searchParams: "URLSearchParams" in $ad1e23473b0550f0$var$g,
    iterable: "Symbol" in $ad1e23473b0550f0$var$g && "iterator" in Symbol,
    blob: "FileReader" in $ad1e23473b0550f0$var$g && "Blob" in $ad1e23473b0550f0$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: "FormData" in $ad1e23473b0550f0$var$g,
    arrayBuffer: "ArrayBuffer" in $ad1e23473b0550f0$var$g
};
function $ad1e23473b0550f0$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($ad1e23473b0550f0$var$support.arrayBuffer) {
    var $ad1e23473b0550f0$var$viewClasses = [
        "[object Int8Array]",
        "[object Uint8Array]",
        "[object Uint8ClampedArray]",
        "[object Int16Array]",
        "[object Uint16Array]",
        "[object Int32Array]",
        "[object Uint32Array]",
        "[object Float32Array]",
        "[object Float64Array]"
    ];
    var $ad1e23473b0550f0$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $ad1e23473b0550f0$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $ad1e23473b0550f0$var$normalizeName(name) {
    if (typeof name !== "string") name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $ad1e23473b0550f0$var$normalizeValue(value) {
    if (typeof value !== "string") value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $ad1e23473b0550f0$var$iteratorFor(items) {
    var iterator = {
        next: function next() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($ad1e23473b0550f0$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $ad1e23473b0550f0$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $ad1e23473b0550f0$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $ad1e23473b0550f0$var$normalizeName(name);
    value = $ad1e23473b0550f0$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ", " + value : value;
};
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype["delete"] = function(name) {
    delete this.map[$ad1e23473b0550f0$var$normalizeName(name)];
};
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $ad1e23473b0550f0$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($ad1e23473b0550f0$var$normalizeName(name));
};
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$ad1e23473b0550f0$var$normalizeName(name)] = $ad1e23473b0550f0$var$normalizeValue(value);
};
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $ad1e23473b0550f0$var$iteratorFor(items);
};
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $ad1e23473b0550f0$var$iteratorFor(items);
};
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $ad1e23473b0550f0$var$iteratorFor(items);
};
if ($ad1e23473b0550f0$var$support.iterable) $ad1e23473b0550f0$export$79b704688b15c0f4.prototype[Symbol.iterator] = $ad1e23473b0550f0$export$79b704688b15c0f4.prototype.entries;
function $ad1e23473b0550f0$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
    body.bodyUsed = true;
}
function $ad1e23473b0550f0$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $ad1e23473b0550f0$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $ad1e23473b0550f0$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $ad1e23473b0550f0$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $ad1e23473b0550f0$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : "utf-8";
    reader.readAsText(blob, encoding);
    return promise;
}
function $ad1e23473b0550f0$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join("");
}
function $ad1e23473b0550f0$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $ad1e23473b0550f0$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = "";
        } else if (typeof body === "string") this._bodyText = body;
        else if ($ad1e23473b0550f0$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($ad1e23473b0550f0$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($ad1e23473b0550f0$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($ad1e23473b0550f0$var$support.arrayBuffer && $ad1e23473b0550f0$var$support.blob && $ad1e23473b0550f0$var$isDataView(body)) {
            this._bodyArrayBuffer = $ad1e23473b0550f0$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($ad1e23473b0550f0$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $ad1e23473b0550f0$var$isArrayBufferView(body))) this._bodyArrayBuffer = $ad1e23473b0550f0$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get("content-type")) {
            if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
            else if ($ad1e23473b0550f0$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
        }
    };
    if ($ad1e23473b0550f0$var$support.blob) this.blob = function() {
        var rejected = $ad1e23473b0550f0$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $ad1e23473b0550f0$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($ad1e23473b0550f0$var$support.blob) return this.blob().then($ad1e23473b0550f0$var$readBlobAsArrayBuffer);
        else throw new Error("could not read as ArrayBuffer");
    };
    this.text = function() {
        var rejected = $ad1e23473b0550f0$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $ad1e23473b0550f0$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($ad1e23473b0550f0$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error("could not read FormData body as text");
        else return Promise.resolve(this._bodyText);
    };
    if ($ad1e23473b0550f0$var$support.formData) this.formData = function() {
        return this.text().then($ad1e23473b0550f0$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $ad1e23473b0550f0$var$methods = [
    "CONNECT",
    "DELETE",
    "GET",
    "HEAD",
    "OPTIONS",
    "PATCH",
    "POST",
    "PUT",
    "TRACE"
];
function $ad1e23473b0550f0$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $ad1e23473b0550f0$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $ad1e23473b0550f0$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $ad1e23473b0550f0$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $ad1e23473b0550f0$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError("Already read");
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $ad1e23473b0550f0$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || "same-origin";
    if (options.headers || !this.headers) this.headers = new $ad1e23473b0550f0$export$79b704688b15c0f4(options.headers);
    this.method = $ad1e23473b0550f0$var$normalizeMethod(options.method || this.method || "GET");
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ("AbortController" in $ad1e23473b0550f0$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
    this._initBody(body);
    if (this.method === "GET" || this.method === "HEAD") {
        if (options.cache === "no-store" || options.cache === "no-cache") {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
            }
        }
    }
}
$ad1e23473b0550f0$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $ad1e23473b0550f0$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $ad1e23473b0550f0$var$decode(body) {
    var form = new FormData();
    body.trim().split("&").forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split("=");
            var name = split.shift().replace(/\+/g, " ");
            var value = split.join("=").replace(/\+/g, " ");
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $ad1e23473b0550f0$var$parseHeaders(rawHeaders) {
    var headers = new $ad1e23473b0550f0$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split("\r").map(function(header) {
        return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(":");
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(":").trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn("Response " + error.message);
            }
        }
    });
    return headers;
}
$ad1e23473b0550f0$var$Body.call($ad1e23473b0550f0$export$7fa6c5b6f8193917.prototype);
function $ad1e23473b0550f0$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $ad1e23473b0550f0$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = "default";
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? "" : "" + options.statusText;
    this.headers = new $ad1e23473b0550f0$export$79b704688b15c0f4(options.headers);
    this.url = options.url || "";
    this._initBody(bodyInit);
}
$ad1e23473b0550f0$var$Body.call($ad1e23473b0550f0$export$9f633d56d7ec90d3.prototype);
$ad1e23473b0550f0$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $ad1e23473b0550f0$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $ad1e23473b0550f0$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$ad1e23473b0550f0$export$9f633d56d7ec90d3.error = function() {
    var response = new $ad1e23473b0550f0$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ""
    });
    response.status = 0;
    response.type = "error";
    return response;
};
var $ad1e23473b0550f0$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$ad1e23473b0550f0$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($ad1e23473b0550f0$var$redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
    return new $ad1e23473b0550f0$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $ad1e23473b0550f0$export$fe58bcf938607f6a = $ad1e23473b0550f0$var$g.DOMException;
try {
    new $ad1e23473b0550f0$export$fe58bcf938607f6a();
} catch (err) {
    $ad1e23473b0550f0$export$fe58bcf938607f6a = function DOMException(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $ad1e23473b0550f0$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $ad1e23473b0550f0$export$fe58bcf938607f6a.prototype.constructor = $ad1e23473b0550f0$export$fe58bcf938607f6a;
}
function $ad1e23473b0550f0$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var abortXhr = function abortXhr() {
            xhr.abort();
        };
        var fixUrl = function fixUrl(url) {
            try {
                return url === "" && $ad1e23473b0550f0$var$g.location.href ? $ad1e23473b0550f0$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        };
        var request = new $ad1e23473b0550f0$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $ad1e23473b0550f0$export$fe58bcf938607f6a("Aborted", "AbortError"));
        var xhr = new XMLHttpRequest();
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $ad1e23473b0550f0$var$parseHeaders(xhr.getAllResponseHeaders() || "")
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.startsWith("file://") && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
            var body = "response" in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $ad1e23473b0550f0$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError("Network request failed"));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError("Network request timed out"));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $ad1e23473b0550f0$export$fe58bcf938607f6a("Aborted", "AbortError"));
            }, 0);
        };
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === "include") xhr.withCredentials = true;
        else if (request.credentials === "omit") xhr.withCredentials = false;
        if ("responseType" in xhr) {
            if ($ad1e23473b0550f0$var$support.blob) xhr.responseType = "blob";
            else if ($ad1e23473b0550f0$var$support.arrayBuffer) xhr.responseType = "arraybuffer";
        }
        if (init && typeof init.headers === "object" && !(init.headers instanceof $ad1e23473b0550f0$export$79b704688b15c0f4 || $ad1e23473b0550f0$var$g.Headers && init.headers instanceof $ad1e23473b0550f0$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($ad1e23473b0550f0$var$normalizeName(name));
                xhr.setRequestHeader(name, $ad1e23473b0550f0$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener("abort", abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
    });
}
$ad1e23473b0550f0$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$ad1e23473b0550f0$var$g.fetch) {
    $ad1e23473b0550f0$var$g.fetch = $ad1e23473b0550f0$export$e7aa7bc5c1b3cfb3;
    $ad1e23473b0550f0$var$g.Headers = $ad1e23473b0550f0$export$79b704688b15c0f4;
    $ad1e23473b0550f0$var$g.Request = $ad1e23473b0550f0$export$7fa6c5b6f8193917;
    $ad1e23473b0550f0$var$g.Response = $ad1e23473b0550f0$export$9f633d56d7ec90d3;
}

});


parcelRequire.register("jxD7z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.keccak512 = module.exports.keccak384 = module.exports.keccak256 = module.exports.keccak224 = void 0;

var $dMfPH = parcelRequire("dMfPH");

var $kLNKc = parcelRequire("kLNKc");
module.exports.keccak224 = (0, $kLNKc.wrapHash)($dMfPH.keccak_224);
module.exports.keccak256 = function() {
    var k = (0, $kLNKc.wrapHash)($dMfPH.keccak_256);
    k.create = $dMfPH.keccak_256.create;
    return k;
}();
module.exports.keccak384 = (0, $kLNKc.wrapHash)($dMfPH.keccak_384);
module.exports.keccak512 = (0, $kLNKc.wrapHash)($dMfPH.keccak_512);

});
parcelRequire.register("dMfPH", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $8GFUW = parcelRequire("8GFUW");

var $6OZAO = parcelRequire("6OZAO");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $4hg6I = parcelRequire("4hg6I");

var $4cMch = parcelRequire("4cMch");

var $bdetq = parcelRequire("bdetq");
// Various per round constants calculations
var $a07c0a27998e1113$var$SHA3_PI = [], $a07c0a27998e1113$var$SHA3_ROTL = [], $a07c0a27998e1113$var$_SHA3_IOTA = [];
var $a07c0a27998e1113$var$_0n = BigInt(0);
var $a07c0a27998e1113$var$_1n = BigInt(1);
var $a07c0a27998e1113$var$_2n = BigInt(2);
var $a07c0a27998e1113$var$_7n = BigInt(7);
var $a07c0a27998e1113$var$_256n = BigInt(256);
var $a07c0a27998e1113$var$_0x71n = BigInt(0x71);
for(var $a07c0a27998e1113$var$round = 0, $a07c0a27998e1113$var$R = $a07c0a27998e1113$var$_1n, $a07c0a27998e1113$var$x = 1, $a07c0a27998e1113$var$y = 0; $a07c0a27998e1113$var$round < 24; $a07c0a27998e1113$var$round++){
    var $a07c0a27998e1113$var$ref;
    $a07c0a27998e1113$var$ref = [
        $a07c0a27998e1113$var$y,
        (2 * $a07c0a27998e1113$var$x + 3 * $a07c0a27998e1113$var$y) % 5
    ], $a07c0a27998e1113$var$x = $a07c0a27998e1113$var$ref[0], $a07c0a27998e1113$var$y = $a07c0a27998e1113$var$ref[1], $a07c0a27998e1113$var$ref;
    $a07c0a27998e1113$var$SHA3_PI.push(2 * (5 * $a07c0a27998e1113$var$y + $a07c0a27998e1113$var$x));
    // Rotational
    $a07c0a27998e1113$var$SHA3_ROTL.push(($a07c0a27998e1113$var$round + 1) * ($a07c0a27998e1113$var$round + 2) / 2 % 64);
    // Iota
    var $a07c0a27998e1113$var$t = $a07c0a27998e1113$var$_0n;
    for(var $a07c0a27998e1113$var$j = 0; $a07c0a27998e1113$var$j < 7; $a07c0a27998e1113$var$j++){
        $a07c0a27998e1113$var$R = ($a07c0a27998e1113$var$R << $a07c0a27998e1113$var$_1n ^ ($a07c0a27998e1113$var$R >> $a07c0a27998e1113$var$_7n) * $a07c0a27998e1113$var$_0x71n) % $a07c0a27998e1113$var$_256n;
        if ($a07c0a27998e1113$var$R & $a07c0a27998e1113$var$_2n) $a07c0a27998e1113$var$t ^= $a07c0a27998e1113$var$_1n << ($a07c0a27998e1113$var$_1n << BigInt($a07c0a27998e1113$var$j)) - $a07c0a27998e1113$var$_1n;
    }
    $a07c0a27998e1113$var$_SHA3_IOTA.push($a07c0a27998e1113$var$t);
}
var $a07c0a27998e1113$var$_u64_js_1_default_split = (0, $8GFUW._)($4cMch.default.split($a07c0a27998e1113$var$_SHA3_IOTA, true), 2), $a07c0a27998e1113$var$SHA3_IOTA_H = $a07c0a27998e1113$var$_u64_js_1_default_split[0], $a07c0a27998e1113$var$SHA3_IOTA_L = $a07c0a27998e1113$var$_u64_js_1_default_split[1];
// Left rotation (without 0, 32, 64)
var $a07c0a27998e1113$var$rotlH = function(h, l, s) {
    return s > 32 ? $4cMch.default.rotlBH(h, l, s) : $4cMch.default.rotlSH(h, l, s);
};
var $a07c0a27998e1113$var$rotlL = function(h, l, s) {
    return s > 32 ? $4cMch.default.rotlBL(h, l, s) : $4cMch.default.rotlSL(h, l, s);
};
// Same as keccakf1600, but allows to skip some rounds
function $a07c0a27998e1113$var$keccakP(s) {
    var rounds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 24;
    var B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(var round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(var x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(var x1 = 0; x1 < 10; x1 += 2){
            var idx1 = (x1 + 8) % 10;
            var idx0 = (x1 + 2) % 10;
            var B0 = B[idx0];
            var B1 = B[idx0 + 1];
            var Th = $a07c0a27998e1113$var$rotlH(B0, B1, 1) ^ B[idx1];
            var Tl = $a07c0a27998e1113$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(var y = 0; y < 50; y += 10){
                s[x1 + y] ^= Th;
                s[x1 + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        var curH = s[2];
        var curL = s[3];
        for(var t = 0; t < 24; t++){
            var shift = $a07c0a27998e1113$var$SHA3_ROTL[t];
            var Th1 = $a07c0a27998e1113$var$rotlH(curH, curL, shift);
            var Tl1 = $a07c0a27998e1113$var$rotlL(curH, curL, shift);
            var PI = $a07c0a27998e1113$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th1;
            s[PI + 1] = Tl1;
        }
        // Chi (χ)
        for(var y1 = 0; y1 < 50; y1 += 10){
            for(var x2 = 0; x2 < 10; x2++)B[x2] = s[y1 + x2];
            for(var x3 = 0; x3 < 10; x3++)s[y1 + x3] ^= ~B[(x3 + 2) % 10] & B[(x3 + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $a07c0a27998e1113$var$SHA3_IOTA_H[round];
        s[1] ^= $a07c0a27998e1113$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $a07c0a27998e1113$var$keccakP;
var $a07c0a27998e1113$var$Keccak = /*#__PURE__*/ function(_utils_js_1_Hash) {
    (0, $ftJVG._)(Keccak, _utils_js_1_Hash);
    var _super = (0, $6OZAO._)(Keccak);
    function Keccak(blockLen, suffix, outputLen) {
        var enableXOF = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, rounds = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 24;
        (0, $978gY._)(this, Keccak);
        var _this;
        _this = _super.call(this);
        _this.blockLen = blockLen;
        _this.suffix = suffix;
        _this.outputLen = outputLen;
        _this.enableXOF = enableXOF;
        _this.rounds = rounds;
        _this.pos = 0;
        _this.posOut = 0;
        _this.finished = false;
        _this.destroyed = false;
        // Can be passed from user as dkLen
        $4hg6I.default.number(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= _this.blockLen || _this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        _this.state = new Uint8Array(200);
        _this.state32 = (0, $bdetq.u32)(_this.state);
        return _this;
    }
    (0, $kry2a._)(Keccak, [
        {
            key: "keccak",
            value: function keccak() {
                $a07c0a27998e1113$var$keccakP(this.state32, this.rounds);
                this.posOut = 0;
                this.pos = 0;
            }
        },
        {
            key: "update",
            value: function update(data) {
                $4hg6I.default.exists(this);
                var _this = this, blockLen = _this.blockLen, state = _this.state;
                data = (0, $bdetq.toBytes)(data);
                var len = data.length;
                for(var pos = 0; pos < len;){
                    var take = Math.min(blockLen - this.pos, len - pos);
                    for(var i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
                    if (this.pos === blockLen) this.keccak();
                }
                return this;
            }
        },
        {
            key: "finish",
            value: function finish() {
                if (this.finished) return;
                this.finished = true;
                var _this = this, state = _this.state, suffix = _this.suffix, pos = _this.pos, blockLen = _this.blockLen;
                // Do the padding
                state[pos] ^= suffix;
                if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
                state[blockLen - 1] ^= 0x80;
                this.keccak();
            }
        },
        {
            key: "writeInto",
            value: function writeInto(out) {
                $4hg6I.default.exists(this, false);
                $4hg6I.default.bytes(out);
                this.finish();
                var bufferOut = this.state;
                var blockLen = this.blockLen;
                for(var pos = 0, len = out.length; pos < len;){
                    if (this.posOut >= blockLen) this.keccak();
                    var take = Math.min(blockLen - this.posOut, len - pos);
                    out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
                    this.posOut += take;
                    pos += take;
                }
                return out;
            }
        },
        {
            key: "xofInto",
            value: function xofInto(out) {
                // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
                if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
                return this.writeInto(out);
            }
        },
        {
            key: "xof",
            value: function xof(bytes) {
                $4hg6I.default.number(bytes);
                return this.xofInto(new Uint8Array(bytes));
            }
        },
        {
            key: "digestInto",
            value: function digestInto(out) {
                $4hg6I.default.output(out, this);
                if (this.finished) throw new Error("digest() was already called");
                this.writeInto(out);
                this.destroy();
                return out;
            }
        },
        {
            key: "digest",
            value: function digest() {
                return this.digestInto(new Uint8Array(this.outputLen));
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.destroyed = true;
                this.state.fill(0);
            }
        },
        {
            key: "_cloneInto",
            value: function _cloneInto(to) {
                var _this = this, blockLen = _this.blockLen, suffix = _this.suffix, outputLen = _this.outputLen, rounds = _this.rounds, enableXOF = _this.enableXOF;
                to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
                to.state32.set(this.state32);
                to.pos = this.pos;
                to.posOut = this.posOut;
                to.finished = this.finished;
                to.rounds = rounds;
                // Suffix can change in cSHAKE
                to.suffix = suffix;
                to.outputLen = outputLen;
                to.enableXOF = enableXOF;
                to.destroyed = this.destroyed;
                return to;
            }
        }
    ]);
    return Keccak;
}($bdetq.Hash);
module.exports.Keccak = $a07c0a27998e1113$var$Keccak;
var $a07c0a27998e1113$var$gen = function(suffix, blockLen, outputLen) {
    return (0, $bdetq.wrapConstructor)(function() {
        return new $a07c0a27998e1113$var$Keccak(blockLen, suffix, outputLen);
    });
};
module.exports.sha3_224 = $a07c0a27998e1113$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $a07c0a27998e1113$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $a07c0a27998e1113$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $a07c0a27998e1113$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $a07c0a27998e1113$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $a07c0a27998e1113$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $a07c0a27998e1113$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $a07c0a27998e1113$var$gen(0x01, 72, 64);
var $a07c0a27998e1113$var$genShake = function(suffix, blockLen, outputLen) {
    return (0, $bdetq.wrapConstructorWithOpts)(function() {
        var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return new $a07c0a27998e1113$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true);
    });
};
module.exports.shake128 = $a07c0a27998e1113$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $a07c0a27998e1113$var$genShake(0x1f, 136, 32);

});
parcelRequire.register("4hg6I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $31d53e86a08baf8f$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error("Wrong positive integer: ".concat(n));
}
module.exports.number = $31d53e86a08baf8f$var$number;
function $31d53e86a08baf8f$var$bool(b) {
    if (typeof b !== "boolean") throw new Error("Expected boolean, not ".concat(b));
}
module.exports.bool = $31d53e86a08baf8f$var$bool;
function $31d53e86a08baf8f$var$bytes(b) {
    for(var _len = arguments.length, lengths = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        lengths[_key - 1] = arguments[_key];
    }
    if (!(b instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new TypeError("Expected Uint8Array of length ".concat(lengths, ", not of length=").concat(b.length));
}
module.exports.bytes = $31d53e86a08baf8f$var$bytes;
function $31d53e86a08baf8f$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $31d53e86a08baf8f$var$number(hash.outputLen);
    $31d53e86a08baf8f$var$number(hash.blockLen);
}
module.exports.hash = $31d53e86a08baf8f$var$hash;
function $31d53e86a08baf8f$var$exists(instance) {
    var checkFinished = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $31d53e86a08baf8f$var$exists;
function $31d53e86a08baf8f$var$output(out, instance) {
    $31d53e86a08baf8f$var$bytes(out);
    var min = instance.outputLen;
    if (out.length < min) throw new Error("digestInto() expects output buffer of length at least ".concat(min));
}
module.exports.output = $31d53e86a08baf8f$var$output;
var $31d53e86a08baf8f$var$assert = {
    number: $31d53e86a08baf8f$var$number,
    bool: $31d53e86a08baf8f$var$bool,
    bytes: $31d53e86a08baf8f$var$bytes,
    hash: $31d53e86a08baf8f$var$hash,
    exists: $31d53e86a08baf8f$var$exists,
    output: $31d53e86a08baf8f$var$output
};
module.exports.default = $31d53e86a08baf8f$var$assert;

});

parcelRequire.register("4cMch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
var $30fdab52992ac0ce$var$U32_MASK64 = BigInt(Math.pow(2, 32) - 1);
var $30fdab52992ac0ce$var$_32n = BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $30fdab52992ac0ce$var$fromBig(n) {
    var le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (le) return {
        h: Number(n & $30fdab52992ac0ce$var$U32_MASK64),
        l: Number(n >> $30fdab52992ac0ce$var$_32n & $30fdab52992ac0ce$var$U32_MASK64)
    };
    return {
        h: Number(n >> $30fdab52992ac0ce$var$_32n & $30fdab52992ac0ce$var$U32_MASK64) | 0,
        l: Number(n & $30fdab52992ac0ce$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $30fdab52992ac0ce$var$fromBig;
function $30fdab52992ac0ce$var$split(lst) {
    var le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var Ah = new Uint32Array(lst.length);
    var Al = new Uint32Array(lst.length);
    for(var i = 0; i < lst.length; i++){
        var _fromBig = $30fdab52992ac0ce$var$fromBig(lst[i], le), h = _fromBig.h, l = _fromBig.l;
        var ref;
        ref = [
            h,
            l
        ], Ah[i] = ref[0], Al[i] = ref[1], ref;
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $30fdab52992ac0ce$var$split;
var $30fdab52992ac0ce$var$toBig = function(h, l) {
    return BigInt(h >>> 0) << $30fdab52992ac0ce$var$_32n | BigInt(l >>> 0);
};
module.exports.toBig = $30fdab52992ac0ce$var$toBig;
// for Shift in [0, 32)
var $30fdab52992ac0ce$var$shrSH = function(h, l, s) {
    return h >>> s;
};
var $30fdab52992ac0ce$var$shrSL = function(h, l, s) {
    return h << 32 - s | l >>> s;
};
// Right rotate for Shift in [1, 32)
var $30fdab52992ac0ce$var$rotrSH = function(h, l, s) {
    return h >>> s | l << 32 - s;
};
var $30fdab52992ac0ce$var$rotrSL = function(h, l, s) {
    return h << 32 - s | l >>> s;
};
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
var $30fdab52992ac0ce$var$rotrBH = function(h, l, s) {
    return h << 64 - s | l >>> s - 32;
};
var $30fdab52992ac0ce$var$rotrBL = function(h, l, s) {
    return h >>> s - 32 | l << 64 - s;
};
// Right rotate for shift===32 (just swaps l&h)
var $30fdab52992ac0ce$var$rotr32H = function(h, l) {
    return l;
};
var $30fdab52992ac0ce$var$rotr32L = function(h, l) {
    return h;
};
// Left rotate for Shift in [1, 32)
var $30fdab52992ac0ce$var$rotlSH = function(h, l, s) {
    return h << s | l >>> 32 - s;
};
var $30fdab52992ac0ce$var$rotlSL = function(h, l, s) {
    return l << s | h >>> 32 - s;
};
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
var $30fdab52992ac0ce$var$rotlBH = function(h, l, s) {
    return l << s - 32 | h >>> 64 - s;
};
var $30fdab52992ac0ce$var$rotlBL = function(h, l, s) {
    return h << s - 32 | l >>> 64 - s;
};
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
// Removing "export" has 5% perf penalty -_-
function $30fdab52992ac0ce$var$add(Ah, Al, Bh, Bl) {
    var l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / Math.pow(2, 32) | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $30fdab52992ac0ce$var$add;
// Addition with more than 2 elements
var $30fdab52992ac0ce$var$add3L = function(Al, Bl, Cl) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
};
var $30fdab52992ac0ce$var$add3H = function(low, Ah, Bh, Ch) {
    return Ah + Bh + Ch + (low / Math.pow(2, 32) | 0) | 0;
};
var $30fdab52992ac0ce$var$add4L = function(Al, Bl, Cl, Dl) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
};
var $30fdab52992ac0ce$var$add4H = function(low, Ah, Bh, Ch, Dh) {
    return Ah + Bh + Ch + Dh + (low / Math.pow(2, 32) | 0) | 0;
};
var $30fdab52992ac0ce$var$add5L = function(Al, Bl, Cl, Dl, El) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
};
var $30fdab52992ac0ce$var$add5H = function(low, Ah, Bh, Ch, Dh, Eh) {
    return Ah + Bh + Ch + Dh + Eh + (low / Math.pow(2, 32) | 0) | 0;
};
// prettier-ignore
var $30fdab52992ac0ce$var$u64 = {
    fromBig: $30fdab52992ac0ce$var$fromBig,
    split: $30fdab52992ac0ce$var$split,
    toBig: module.exports.toBig,
    shrSH: $30fdab52992ac0ce$var$shrSH,
    shrSL: $30fdab52992ac0ce$var$shrSL,
    rotrSH: $30fdab52992ac0ce$var$rotrSH,
    rotrSL: $30fdab52992ac0ce$var$rotrSL,
    rotrBH: $30fdab52992ac0ce$var$rotrBH,
    rotrBL: $30fdab52992ac0ce$var$rotrBL,
    rotr32H: $30fdab52992ac0ce$var$rotr32H,
    rotr32L: $30fdab52992ac0ce$var$rotr32L,
    rotlSH: $30fdab52992ac0ce$var$rotlSH,
    rotlSL: $30fdab52992ac0ce$var$rotlSL,
    rotlBH: $30fdab52992ac0ce$var$rotlBH,
    rotlBL: $30fdab52992ac0ce$var$rotlBL,
    add: $30fdab52992ac0ce$var$add,
    add3L: $30fdab52992ac0ce$var$add3L,
    add3H: $30fdab52992ac0ce$var$add3H,
    add4L: $30fdab52992ac0ce$var$add4L,
    add4H: $30fdab52992ac0ce$var$add4H,
    add5H: $30fdab52992ac0ce$var$add5H,
    add5L: $30fdab52992ac0ce$var$add5L
};
module.exports.default = $30fdab52992ac0ce$var$u64;

});

parcelRequire.register("bdetq", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $1ObTH = parcelRequire("1ObTH");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $lSFPc = parcelRequire("lSFPc");
// Cast array to different type
var $829c22c8ec251a06$var$u8 = function(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
};
module.exports.u8 = $829c22c8ec251a06$var$u8;
var $829c22c8ec251a06$var$u32 = function(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
};
module.exports.u32 = $829c22c8ec251a06$var$u32;
// Cast array to view
var $829c22c8ec251a06$var$createView = function(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
};
module.exports.createView = $829c22c8ec251a06$var$createView;
// The rotate right (circular right shift) operation for uint32
var $829c22c8ec251a06$var$rotr = function(word, shift) {
    return word << 32 - shift | word >>> shift;
};
module.exports.rotr = $829c22c8ec251a06$var$rotr;
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
// There is almost no big endian hardware, but js typed arrays uses platform specific endianness.
// So, just to be sure not to corrupt anything.
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
var $829c22c8ec251a06$var$hexes = Array.from({
    length: 256
}, function(v, i) {
    return i.toString(16).padStart(2, "0");
});
/**
 * @example bytesToHex(Uint8Array.from([0xde, 0xad, 0xbe, 0xef]))
 */ function $829c22c8ec251a06$var$bytesToHex(uint8a) {
    // pre-caching improves the speed 6x
    if (!(uint8a instanceof Uint8Array)) throw new Error("Uint8Array expected");
    var hex = "";
    for(var i = 0; i < uint8a.length; i++)hex += $829c22c8ec251a06$var$hexes[uint8a[i]];
    return hex;
}
module.exports.bytesToHex = $829c22c8ec251a06$var$bytesToHex;
/**
 * @example hexToBytes('deadbeef')
 */ function $829c22c8ec251a06$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToBytes: expected string, got " + (typeof hex === "undefined" ? "undefined" : (0, $1ObTH._)(hex)));
    if (hex.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
    var array = new Uint8Array(hex.length / 2);
    for(var i = 0; i < array.length; i++){
        var j = i * 2;
        var hexByte = hex.slice(j, j + 2);
        var byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $829c22c8ec251a06$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow. However, call to async function will return Promise
// which will be fullfiled only on next scheduler queue processing step and this is exactly what we need.
var $829c22c8ec251a06$var$nextTick = function() {
    var _ref = (0, $byzP8._)(function() {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    });
    return function nextTick() {
        return _ref.apply(this, arguments);
    };
}();
module.exports.nextTick = $829c22c8ec251a06$var$nextTick;
function $829c22c8ec251a06$var$asyncLoop(iters, tick, cb) {
    return $829c22c8ec251a06$var$_asyncLoop.apply(this, arguments);
}
function $829c22c8ec251a06$var$_asyncLoop() {
    $829c22c8ec251a06$var$_asyncLoop = // Returns control to thread each 'tick' ms to avoid blocking
    (0, $byzP8._)(function(iters, tick, cb) {
        var ts, i, diff;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ts = Date.now();
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < iters)) return [
                        3,
                        4
                    ];
                    cb(i);
                    diff = Date.now() - ts;
                    if (diff >= 0 && diff < tick) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0, module.exports.nextTick)()
                    ];
                case 2:
                    _state.sent();
                    ts += diff;
                    _state.label = 3;
                case 3:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $829c22c8ec251a06$var$_asyncLoop.apply(this, arguments);
}
module.exports.asyncLoop = $829c22c8ec251a06$var$asyncLoop;
function $829c22c8ec251a06$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new TypeError("utf8ToBytes expected string, got ".concat(typeof str === "undefined" ? "undefined" : (0, $1ObTH._)(str)));
    return new TextEncoder().encode(str);
}
module.exports.utf8ToBytes = $829c22c8ec251a06$var$utf8ToBytes;
function $829c22c8ec251a06$var$toBytes(data) {
    if (typeof data === "string") data = $829c22c8ec251a06$var$utf8ToBytes(data);
    if (!(data instanceof Uint8Array)) throw new TypeError("Expected input type is Uint8Array (got ".concat(typeof data === "undefined" ? "undefined" : (0, $1ObTH._)(data), ")"));
    return data;
}
module.exports.toBytes = $829c22c8ec251a06$var$toBytes;
/**
 * Concats Uint8Array-s into one; like `Buffer.concat([buf1, buf2])`
 * @example concatBytes(buf1, buf2)
 */ function $829c22c8ec251a06$var$concatBytes() {
    for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++){
        arrays[_key] = arguments[_key];
    }
    if (!arrays.every(function(a) {
        return a instanceof Uint8Array;
    })) throw new Error("Uint8Array list expected");
    if (arrays.length === 1) return arrays[0];
    var length = arrays.reduce(function(a, arr) {
        return a + arr.length;
    }, 0);
    var result = new Uint8Array(length);
    for(var i = 0, pad = 0; i < arrays.length; i++){
        var arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
module.exports.concatBytes = $829c22c8ec251a06$var$concatBytes;
// For runtime check if class implements interface
var $829c22c8ec251a06$var$Hash = /*#__PURE__*/ function() {
    function Hash() {
        (0, $978gY._)(this, Hash);
    }
    (0, $kry2a._)(Hash, [
        {
            // Safe version that clones internal state
            key: "clone",
            value: function clone() {
                return this._cloneInto();
            }
        }
    ]);
    return Hash;
}();
module.exports.Hash = $829c22c8ec251a06$var$Hash;
// Check if object doens't have custom constructor (like Uint8Array/Array)
var $829c22c8ec251a06$var$isPlainObject = function(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]" && obj.constructor === Object;
};
function $829c22c8ec251a06$var$checkOpts(defaults, opts) {
    if (opts !== undefined && (typeof opts !== "object" || !$829c22c8ec251a06$var$isPlainObject(opts))) throw new TypeError("Options should be object or undefined");
    var merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $829c22c8ec251a06$var$checkOpts;
function $829c22c8ec251a06$var$wrapConstructor(hashConstructor) {
    var hashC = function(message) {
        return hashConstructor().update($829c22c8ec251a06$var$toBytes(message)).digest();
    };
    var tmp = hashConstructor();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function() {
        return hashConstructor();
    };
    return hashC;
}
module.exports.wrapConstructor = $829c22c8ec251a06$var$wrapConstructor;
function $829c22c8ec251a06$var$wrapConstructorWithOpts(hashCons) {
    var hashC = function(msg, opts) {
        return hashCons(opts).update($829c22c8ec251a06$var$toBytes(msg)).digest();
    };
    var tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function(opts) {
        return hashCons(opts);
    };
    return hashC;
}
module.exports.wrapConstructorWithOpts = $829c22c8ec251a06$var$wrapConstructorWithOpts;
/**
 * Secure PRNG
 */ function $829c22c8ec251a06$var$randomBytes() {
    var bytesLength = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 32;
    if ($lSFPc.crypto.web) return $lSFPc.crypto.web.getRandomValues(new Uint8Array(bytesLength));
    else if ($lSFPc.crypto.node) return new Uint8Array($lSFPc.crypto.node.randomBytes(bytesLength).buffer);
    else throw new Error("The environment doesn't have randomBytes function");
}
module.exports.randomBytes = $829c22c8ec251a06$var$randomBytes;

});
parcelRequire.register("lSFPc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = {
    node: undefined,
    web: typeof self === "object" && "crypto" in self ? self.crypto : undefined
};

});



parcelRequire.register("kLNKc", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
"use strict";
var __importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.crypto = exports.wrapHash = exports.equalsBytes = exports.hexToBytes = exports.bytesToUtf8 = exports.utf8ToBytes = exports.createView = exports.concatBytes = exports.toHex = exports.bytesToHex = exports.assertBytes = exports.assertBool = void 0;

// buf.toString('hex') -> toHex(buf)
var _assert_1 = __importDefault((parcelRequire("4hg6I")));

var $bdetq = parcelRequire("bdetq");
var assertBool = _assert_1.default.bool;
exports.assertBool = assertBool;
var assertBytes = _assert_1.default.bytes;
exports.assertBytes = assertBytes;

var $bdetq = parcelRequire("bdetq");
Object.defineProperty(exports, "bytesToHex", {
    enumerable: true,
    get: function get() {
        return $bdetq.bytesToHex;
    }
});
Object.defineProperty(exports, "toHex", {
    enumerable: true,
    get: function get() {
        return $bdetq.bytesToHex;
    }
});
Object.defineProperty(exports, "concatBytes", {
    enumerable: true,
    get: function get() {
        return $bdetq.concatBytes;
    }
});
Object.defineProperty(exports, "createView", {
    enumerable: true,
    get: function get() {
        return $bdetq.createView;
    }
});
Object.defineProperty(exports, "utf8ToBytes", {
    enumerable: true,
    get: function get() {
        return $bdetq.utf8ToBytes;
    }
});
// buf.toString('utf8') -> bytesToUtf8(buf)
function bytesToUtf8(data) {
    if (!(data instanceof Uint8Array)) throw new TypeError("bytesToUtf8 expected Uint8Array, got ".concat(typeof data === "undefined" ? "undefined" : (0, $1ObTH._)(data)));
    return new TextDecoder().decode(data);
}
exports.bytesToUtf8 = bytesToUtf8;
function hexToBytes(data) {
    var sliced = data.startsWith("0x") ? data.substring(2) : data;
    return (0, $bdetq.hexToBytes)(sliced);
}
exports.hexToBytes = hexToBytes;
// buf.equals(buf2) -> equalsBytes(buf, buf2)
function equalsBytes(a, b) {
    if (a.length !== b.length) return false;
    for(var i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
exports.equalsBytes = equalsBytes;
// Internal utils
function wrapHash(hash) {
    return function(msg) {
        _assert_1.default.bytes(msg);
        return hash(msg);
    };
}
exports.wrapHash = wrapHash;
exports.crypto = function() {
    var webCrypto = typeof self === "object" && "crypto" in self ? self.crypto : undefined;
    var nodeRequire = typeof module.require === "function" && module.require.bind(module);
    return {
        node: nodeRequire && !webCrypto ? nodeRequire("crypto") : undefined,
        web: webCrypto
    };
}();

});


parcelRequire.register("492wS", function(module, exports) {
"use strict";
var $3049f6ef72b5b326$var$elliptic = module.exports;

$3049f6ef72b5b326$var$elliptic.version = (parcelRequire("3tGej")).version;

$3049f6ef72b5b326$var$elliptic.utils = (parcelRequire("boA1w"));

$3049f6ef72b5b326$var$elliptic.rand = (parcelRequire("8v4zB"));

$3049f6ef72b5b326$var$elliptic.curve = (parcelRequire("hbDhv"));

$3049f6ef72b5b326$var$elliptic.curves = (parcelRequire("kKmfE"));

// Protocols
$3049f6ef72b5b326$var$elliptic.ec = (parcelRequire("jA2EE"));

$3049f6ef72b5b326$var$elliptic.eddsa = (parcelRequire("51QPl"));

});
parcelRequire.register("3tGej", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRequire.register("boA1w", function(module, exports) {
"use strict";
var $84bde1233ebed9e4$var$utils = module.exports;

var $h0anJ = parcelRequire("h0anJ");

var $3210N = parcelRequire("3210N");

var $4YHS3 = parcelRequire("4YHS3");
$84bde1233ebed9e4$var$utils.assert = $3210N;
$84bde1233ebed9e4$var$utils.toArray = $4YHS3.toArray;
$84bde1233ebed9e4$var$utils.zero2 = $4YHS3.zero2;
$84bde1233ebed9e4$var$utils.toHex = $4YHS3.toHex;
$84bde1233ebed9e4$var$utils.encode = $4YHS3.encode;
// Represent num in a w-NAF form
function $84bde1233ebed9e4$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$84bde1233ebed9e4$var$utils.getNAF = $84bde1233ebed9e4$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $84bde1233ebed9e4$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$84bde1233ebed9e4$var$utils.getJSF = $84bde1233ebed9e4$var$getJSF;
function $84bde1233ebed9e4$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$84bde1233ebed9e4$var$utils.cachedProperty = $84bde1233ebed9e4$var$cachedProperty;
function $84bde1233ebed9e4$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $84bde1233ebed9e4$var$utils.toArray(bytes, "hex") : bytes;
}
$84bde1233ebed9e4$var$utils.parseBytes = $84bde1233ebed9e4$var$parseBytes;
function $84bde1233ebed9e4$var$intFromLE(bytes) {
    return new $h0anJ(bytes, "hex", "le");
}
$84bde1233ebed9e4$var$utils.intFromLE = $84bde1233ebed9e4$var$intFromLE;

});
parcelRequire.register("h0anJ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    var assert = // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    };
    var inherits = // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    };
    var parseHex4Bits = function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    };
    var parseHexByte = function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    };
    var parseBase = function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    };
    var toBitArray = function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    };
    var smallMulTo = function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    };
    var bigMulTo = function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    };
    var jumboMulTo = function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    };
    var FFTM = // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    };
    var MPrime = // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    };
    var K256 = function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    };
    var P224 = function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    };
    var P192 = function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    };
    var P25519 = function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    };
    var Red = //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    };
    var Mont = function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    };
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    inherits(P224, MPrime);
    inherits(P192, MPrime);
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("4YHS3", function(module, exports) {
"use strict";
var $39fecbdfe326fb6f$var$utils = module.exports;
function $39fecbdfe326fb6f$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$39fecbdfe326fb6f$var$utils.toArray = $39fecbdfe326fb6f$var$toArray;
function $39fecbdfe326fb6f$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$39fecbdfe326fb6f$var$utils.zero2 = $39fecbdfe326fb6f$var$zero2;
function $39fecbdfe326fb6f$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $39fecbdfe326fb6f$var$zero2(msg[i].toString(16));
    return res;
}
$39fecbdfe326fb6f$var$utils.toHex = $39fecbdfe326fb6f$var$toHex;
$39fecbdfe326fb6f$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $39fecbdfe326fb6f$var$toHex(arr);
    else return arr;
};

});


parcelRequire.register("8v4zB", function(module, exports) {
var $6304c41c38b6f174$var$r;
module.exports = function rand(len) {
    if (!$6304c41c38b6f174$var$r) $6304c41c38b6f174$var$r = new $6304c41c38b6f174$var$Rand(null);
    return $6304c41c38b6f174$var$r.generate(len);
};
function $6304c41c38b6f174$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $6304c41c38b6f174$var$Rand;
$6304c41c38b6f174$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$6304c41c38b6f174$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $6304c41c38b6f174$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $6304c41c38b6f174$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $6304c41c38b6f174$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $6304c41c38b6f174$var$crypto = (parcelRequire("aqbQf"));
    if (typeof $6304c41c38b6f174$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $6304c41c38b6f174$var$Rand.prototype._rand = function _rand(n) {
        return $6304c41c38b6f174$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRequire.register("hbDhv", function(module, exports) {
"use strict";
var $c831ef38bf9363e2$var$curve = module.exports;

$c831ef38bf9363e2$var$curve.base = (parcelRequire("3Ild8"));

$c831ef38bf9363e2$var$curve.short = (parcelRequire("l2gH1"));

$c831ef38bf9363e2$var$curve.mont = (parcelRequire("hWmH5"));

$c831ef38bf9363e2$var$curve.edwards = (parcelRequire("8SKTg"));

});
parcelRequire.register("3Ild8", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $boA1w = parcelRequire("boA1w");
var $2b45ef357c32d9df$var$getNAF = $boA1w.getNAF;
var $2b45ef357c32d9df$var$getJSF = $boA1w.getJSF;
var $2b45ef357c32d9df$var$assert = $boA1w.assert;
function $2b45ef357c32d9df$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $h0anJ(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $h0anJ.red(conf.prime) : $h0anJ.mont(this.p);
    // Useful for many curves
    this.zero = new $h0anJ(0).toRed(this.red);
    this.one = new $h0anJ(1).toRed(this.red);
    this.two = new $h0anJ(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $h0anJ(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $2b45ef357c32d9df$var$BaseCurve;
$2b45ef357c32d9df$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$2b45ef357c32d9df$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$2b45ef357c32d9df$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $2b45ef357c32d9df$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $2b45ef357c32d9df$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$2b45ef357c32d9df$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $2b45ef357c32d9df$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $2b45ef357c32d9df$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$2b45ef357c32d9df$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $2b45ef357c32d9df$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $2b45ef357c32d9df$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $2b45ef357c32d9df$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $2b45ef357c32d9df$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$2b45ef357c32d9df$var$BaseCurve.BasePoint = $2b45ef357c32d9df$var$BasePoint;
$2b45ef357c32d9df$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$2b45ef357c32d9df$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$2b45ef357c32d9df$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $boA1w.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $2b45ef357c32d9df$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $2b45ef357c32d9df$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$2b45ef357c32d9df$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$2b45ef357c32d9df$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$2b45ef357c32d9df$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $boA1w.encode(this._encode(compact), enc);
};
$2b45ef357c32d9df$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$2b45ef357c32d9df$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$2b45ef357c32d9df$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$2b45ef357c32d9df$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$2b45ef357c32d9df$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$2b45ef357c32d9df$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRequire.register("l2gH1", function(module, exports) {
"use strict";

var $boA1w = parcelRequire("boA1w");

var $h0anJ = parcelRequire("h0anJ");

var $kvFQ5 = parcelRequire("kvFQ5");

var $3Ild8 = parcelRequire("3Ild8");
var $f506bbbb5a8e71f9$var$assert = $boA1w.assert;
function $f506bbbb5a8e71f9$var$ShortCurve(conf) {
    $3Ild8.call(this, "short", conf);
    this.a = new $h0anJ(conf.a, 16).toRed(this.red);
    this.b = new $h0anJ(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$kvFQ5($f506bbbb5a8e71f9$var$ShortCurve, $3Ild8);
module.exports = $f506bbbb5a8e71f9$var$ShortCurve;
$f506bbbb5a8e71f9$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $h0anJ(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $h0anJ(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $f506bbbb5a8e71f9$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $h0anJ(vec.a, 16),
            b: new $h0anJ(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $h0anJ.mont(num);
    var tinv = new $h0anJ(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $h0anJ(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $h0anJ(1);
    var y1 = new $h0anJ(0);
    var x2 = new $h0anJ(0);
    var y2 = new $h0anJ(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $h0anJ(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $f506bbbb5a8e71f9$var$Point(curve, x, y, isRed) {
    $3Ild8.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $h0anJ(x, 16);
        this.y = new $h0anJ(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$kvFQ5($f506bbbb5a8e71f9$var$Point, $3Ild8.BasePoint);
$f506bbbb5a8e71f9$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $f506bbbb5a8e71f9$var$Point(this, x, y, isRed);
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $f506bbbb5a8e71f9$var$Point.fromJSON(this, obj, red);
};
$f506bbbb5a8e71f9$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function endoMul(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$f506bbbb5a8e71f9$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$f506bbbb5a8e71f9$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    var obj2point = function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    };
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$f506bbbb5a8e71f9$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$f506bbbb5a8e71f9$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$f506bbbb5a8e71f9$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$f506bbbb5a8e71f9$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$f506bbbb5a8e71f9$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$f506bbbb5a8e71f9$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$f506bbbb5a8e71f9$var$Point.prototype.mul = function mul(k) {
    k = new $h0anJ(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$f506bbbb5a8e71f9$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$f506bbbb5a8e71f9$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$f506bbbb5a8e71f9$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$f506bbbb5a8e71f9$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function negate(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$f506bbbb5a8e71f9$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $f506bbbb5a8e71f9$var$JPoint(curve, x, y, z) {
    $3Ild8.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $h0anJ(0);
    } else {
        this.x = new $h0anJ(x, 16);
        this.y = new $h0anJ(y, 16);
        this.z = new $h0anJ(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$kvFQ5($f506bbbb5a8e71f9$var$JPoint, $3Ild8.BasePoint);
$f506bbbb5a8e71f9$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $f506bbbb5a8e71f9$var$JPoint(this, x, y, z);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$f506bbbb5a8e71f9$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $h0anJ(k, kbase);
    return this.curve._wnafMul(this, k);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$f506bbbb5a8e71f9$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$f506bbbb5a8e71f9$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$f506bbbb5a8e71f9$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRequire.register("hWmH5", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $kvFQ5 = parcelRequire("kvFQ5");

var $3Ild8 = parcelRequire("3Ild8");

var $boA1w = parcelRequire("boA1w");
function $d0f97501e3e6b182$var$MontCurve(conf) {
    $3Ild8.call(this, "mont", conf);
    this.a = new $h0anJ(conf.a, 16).toRed(this.red);
    this.b = new $h0anJ(conf.b, 16).toRed(this.red);
    this.i4 = new $h0anJ(4).toRed(this.red).redInvm();
    this.two = new $h0anJ(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$kvFQ5($d0f97501e3e6b182$var$MontCurve, $3Ild8);
module.exports = $d0f97501e3e6b182$var$MontCurve;
$d0f97501e3e6b182$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $d0f97501e3e6b182$var$Point(curve, x, z) {
    $3Ild8.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $h0anJ(x, 16);
        this.z = new $h0anJ(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$kvFQ5($d0f97501e3e6b182$var$Point, $3Ild8.BasePoint);
$d0f97501e3e6b182$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($boA1w.toArray(bytes, enc), 1);
};
$d0f97501e3e6b182$var$MontCurve.prototype.point = function point(x, z) {
    return new $d0f97501e3e6b182$var$Point(this, x, z);
};
$d0f97501e3e6b182$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $d0f97501e3e6b182$var$Point.fromJSON(this, obj);
};
$d0f97501e3e6b182$var$Point.prototype.precompute = function precompute() {
// No-op
};
$d0f97501e3e6b182$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$d0f97501e3e6b182$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $d0f97501e3e6b182$var$Point(curve, obj[0], obj[1] || curve.one);
};
$d0f97501e3e6b182$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$d0f97501e3e6b182$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$d0f97501e3e6b182$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$d0f97501e3e6b182$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$d0f97501e3e6b182$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$d0f97501e3e6b182$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$d0f97501e3e6b182$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$d0f97501e3e6b182$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$d0f97501e3e6b182$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$d0f97501e3e6b182$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$d0f97501e3e6b182$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRequire.register("8SKTg", function(module, exports) {
"use strict";

var $boA1w = parcelRequire("boA1w");

var $h0anJ = parcelRequire("h0anJ");

var $kvFQ5 = parcelRequire("kvFQ5");

var $3Ild8 = parcelRequire("3Ild8");
var $6777bd53b8a6130a$var$assert = $boA1w.assert;
function $6777bd53b8a6130a$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $3Ild8.call(this, "edwards", conf);
    this.a = new $h0anJ(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $h0anJ(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $h0anJ(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $6777bd53b8a6130a$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$kvFQ5($6777bd53b8a6130a$var$EdwardsCurve, $3Ild8);
module.exports = $6777bd53b8a6130a$var$EdwardsCurve;
$6777bd53b8a6130a$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$6777bd53b8a6130a$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$6777bd53b8a6130a$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$6777bd53b8a6130a$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $h0anJ(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$6777bd53b8a6130a$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $h0anJ(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$6777bd53b8a6130a$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $6777bd53b8a6130a$var$Point(curve, x, y, z, t) {
    $3Ild8.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $h0anJ(x, 16);
        this.y = new $h0anJ(y, 16);
        this.z = z ? new $h0anJ(z, 16) : this.curve.one;
        this.t = t && new $h0anJ(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$kvFQ5($6777bd53b8a6130a$var$Point, $3Ild8.BasePoint);
$6777bd53b8a6130a$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $6777bd53b8a6130a$var$Point.fromJSON(this, obj);
};
$6777bd53b8a6130a$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $6777bd53b8a6130a$var$Point(this, x, y, z, t);
};
$6777bd53b8a6130a$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $6777bd53b8a6130a$var$Point(curve, obj[0], obj[1], obj[2]);
};
$6777bd53b8a6130a$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$6777bd53b8a6130a$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$6777bd53b8a6130a$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$6777bd53b8a6130a$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$6777bd53b8a6130a$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$6777bd53b8a6130a$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$6777bd53b8a6130a$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$6777bd53b8a6130a$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$6777bd53b8a6130a$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$6777bd53b8a6130a$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$6777bd53b8a6130a$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$6777bd53b8a6130a$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$6777bd53b8a6130a$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$6777bd53b8a6130a$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$6777bd53b8a6130a$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$6777bd53b8a6130a$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$6777bd53b8a6130a$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$6777bd53b8a6130a$var$Point.prototype.toP = $6777bd53b8a6130a$var$Point.prototype.normalize;
$6777bd53b8a6130a$var$Point.prototype.mixedAdd = $6777bd53b8a6130a$var$Point.prototype.add;

});


parcelRequire.register("kKmfE", function(module, exports) {
"use strict";
var $f1a95d3133313cc8$var$curves = module.exports;

var $dMFrt = parcelRequire("dMFrt");

var $hbDhv = parcelRequire("hbDhv");

var $boA1w = parcelRequire("boA1w");
var $f1a95d3133313cc8$var$assert = $boA1w.assert;
function $f1a95d3133313cc8$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $hbDhv.short(options);
    else if (options.type === "edwards") this.curve = new $hbDhv.edwards(options);
    else this.curve = new $hbDhv.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $f1a95d3133313cc8$var$assert(this.g.validate(), "Invalid curve");
    $f1a95d3133313cc8$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$f1a95d3133313cc8$var$curves.PresetCurve = $f1a95d3133313cc8$var$PresetCurve;
function $f1a95d3133313cc8$var$defineCurve(name, options) {
    Object.defineProperty($f1a95d3133313cc8$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function get() {
            var curve = new $f1a95d3133313cc8$var$PresetCurve(options);
            Object.defineProperty($f1a95d3133313cc8$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$f1a95d3133313cc8$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $dMFrt.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$f1a95d3133313cc8$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $dMFrt.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$f1a95d3133313cc8$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $dMFrt.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$f1a95d3133313cc8$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $dMFrt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$f1a95d3133313cc8$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $dMFrt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$f1a95d3133313cc8$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $dMFrt.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$f1a95d3133313cc8$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $dMFrt.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $f1a95d3133313cc8$var$pre;

try {
    $f1a95d3133313cc8$var$pre = (parcelRequire("cBTAl"));
} catch (e) {
    $f1a95d3133313cc8$var$pre = undefined;
}
$f1a95d3133313cc8$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $dMFrt.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $f1a95d3133313cc8$var$pre
    ]
});

});
parcelRequire.register("cBTAl", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRequire.register("jA2EE", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $kNeip = parcelRequire("kNeip");

var $boA1w = parcelRequire("boA1w");

var $kKmfE = parcelRequire("kKmfE");

var $8v4zB = parcelRequire("8v4zB");
var $03adbb9dfc3c6eed$var$assert = $boA1w.assert;

var $6UxhE = parcelRequire("6UxhE");

var $3VM75 = parcelRequire("3VM75");
function $03adbb9dfc3c6eed$var$EC(options) {
    if (!(this instanceof $03adbb9dfc3c6eed$var$EC)) return new $03adbb9dfc3c6eed$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $03adbb9dfc3c6eed$var$assert(Object.prototype.hasOwnProperty.call($kKmfE, options), "Unknown curve " + options);
        options = $kKmfE[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $kKmfE.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $03adbb9dfc3c6eed$var$EC;
$03adbb9dfc3c6eed$var$EC.prototype.keyPair = function keyPair(options) {
    return new $6UxhE(this, options);
};
$03adbb9dfc3c6eed$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $6UxhE.fromPrivate(this, priv, enc);
};
$03adbb9dfc3c6eed$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $6UxhE.fromPublic(this, pub, enc);
};
$03adbb9dfc3c6eed$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kNeip({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $8v4zB(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $h0anJ(2));
    for(;;){
        var priv = new $h0anJ(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$03adbb9dfc3c6eed$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$03adbb9dfc3c6eed$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $h0anJ(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $kNeip({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $h0anJ(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $h0anJ(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $3VM75({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$03adbb9dfc3c6eed$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $h0anJ(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $3VM75(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$03adbb9dfc3c6eed$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $03adbb9dfc3c6eed$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $3VM75(signature, enc);
    var n = this.n;
    var e = new $h0anJ(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$03adbb9dfc3c6eed$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $3VM75(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRequire.register("kNeip", function(module, exports) {
"use strict";

var $dMFrt = parcelRequire("dMFrt");

var $4YHS3 = parcelRequire("4YHS3");

var $3210N = parcelRequire("3210N");
function $f2337925eb4d650c$var$HmacDRBG(options) {
    if (!(this instanceof $f2337925eb4d650c$var$HmacDRBG)) return new $f2337925eb4d650c$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $4YHS3.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $4YHS3.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $4YHS3.toArray(options.pers, options.persEnc || "hex");
    $3210N(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $f2337925eb4d650c$var$HmacDRBG;
$f2337925eb4d650c$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f2337925eb4d650c$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $dMFrt.hmac(this.hash, this.K);
};
$f2337925eb4d650c$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f2337925eb4d650c$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $4YHS3.toArray(entropy, entropyEnc);
    add = $4YHS3.toArray(add, addEnc);
    $3210N(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f2337925eb4d650c$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $4YHS3.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $4YHS3.encode(res, enc);
};

});

parcelRequire.register("6UxhE", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $boA1w = parcelRequire("boA1w");
var $5081ca7d72751237$var$assert = $boA1w.assert;
function $5081ca7d72751237$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $5081ca7d72751237$var$KeyPair;
$5081ca7d72751237$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $5081ca7d72751237$var$KeyPair) return pub;
    return new $5081ca7d72751237$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$5081ca7d72751237$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $5081ca7d72751237$var$KeyPair) return priv;
    return new $5081ca7d72751237$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$5081ca7d72751237$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$5081ca7d72751237$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$5081ca7d72751237$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$5081ca7d72751237$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $h0anJ(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$5081ca7d72751237$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $5081ca7d72751237$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $5081ca7d72751237$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$5081ca7d72751237$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $5081ca7d72751237$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$5081ca7d72751237$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$5081ca7d72751237$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$5081ca7d72751237$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRequire.register("3VM75", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $boA1w = parcelRequire("boA1w");
var $2dcc0445c1412382$var$assert = $boA1w.assert;
function $2dcc0445c1412382$var$Signature(options, enc) {
    if (options instanceof $2dcc0445c1412382$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $2dcc0445c1412382$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $h0anJ(options.r, 16);
    this.s = new $h0anJ(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $2dcc0445c1412382$var$Signature;
function $2dcc0445c1412382$var$Position() {
    this.place = 0;
}
function $2dcc0445c1412382$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $2dcc0445c1412382$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$2dcc0445c1412382$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $boA1w.toArray(data, enc);
    var p = new $2dcc0445c1412382$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $2dcc0445c1412382$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $2dcc0445c1412382$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $2dcc0445c1412382$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $h0anJ(r);
    this.s = new $h0anJ(s);
    this.recoveryParam = null;
    return true;
};
function $2dcc0445c1412382$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$2dcc0445c1412382$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $2dcc0445c1412382$var$rmPadding(r);
    s = $2dcc0445c1412382$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $2dcc0445c1412382$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $2dcc0445c1412382$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $2dcc0445c1412382$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $boA1w.encode(res, enc);
};

});


parcelRequire.register("51QPl", function(module, exports) {
"use strict";

var $dMFrt = parcelRequire("dMFrt");

var $kKmfE = parcelRequire("kKmfE");

var $boA1w = parcelRequire("boA1w");
var $3a960622930d64ef$var$assert = $boA1w.assert;
var $3a960622930d64ef$var$parseBytes = $boA1w.parseBytes;

var $l7DZZ = parcelRequire("l7DZZ");

var $dfflx = parcelRequire("dfflx");
function $3a960622930d64ef$var$EDDSA(curve) {
    $3a960622930d64ef$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $3a960622930d64ef$var$EDDSA)) return new $3a960622930d64ef$var$EDDSA(curve);
    curve = $kKmfE[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $dMFrt.sha512;
}
module.exports = $3a960622930d64ef$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $3a960622930d64ef$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $3a960622930d64ef$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $3a960622930d64ef$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $3a960622930d64ef$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$3a960622930d64ef$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $boA1w.intFromLE(hash.digest()).umod(this.curve.n);
};
$3a960622930d64ef$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $l7DZZ.fromPublic(this, pub);
};
$3a960622930d64ef$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $l7DZZ.fromSecret(this, secret);
};
$3a960622930d64ef$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $dfflx) return sig;
    return new $dfflx(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $3a960622930d64ef$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$3a960622930d64ef$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $boA1w.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $boA1w.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$3a960622930d64ef$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$3a960622930d64ef$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $boA1w.intFromLE(bytes);
};
$3a960622930d64ef$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRequire.register("l7DZZ", function(module, exports) {
"use strict";

var $boA1w = parcelRequire("boA1w");
var $f609475a1279c31c$var$assert = $boA1w.assert;
var $f609475a1279c31c$var$parseBytes = $boA1w.parseBytes;
var $f609475a1279c31c$var$cachedProperty = $boA1w.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $f609475a1279c31c$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $f609475a1279c31c$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $f609475a1279c31c$var$parseBytes(params.pub);
}
$f609475a1279c31c$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $f609475a1279c31c$var$KeyPair) return pub;
    return new $f609475a1279c31c$var$KeyPair(eddsa, {
        pub: pub
    });
};
$f609475a1279c31c$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $f609475a1279c31c$var$KeyPair) return secret;
    return new $f609475a1279c31c$var$KeyPair(eddsa, {
        secret: secret
    });
};
$f609475a1279c31c$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$f609475a1279c31c$var$KeyPair.prototype.sign = function sign(message) {
    $f609475a1279c31c$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$f609475a1279c31c$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$f609475a1279c31c$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $f609475a1279c31c$var$assert(this._secret, "KeyPair is public only");
    return $boA1w.encode(this.secret(), enc);
};
$f609475a1279c31c$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $boA1w.encode(this.pubBytes(), enc);
};
module.exports = $f609475a1279c31c$var$KeyPair;

});

parcelRequire.register("dfflx", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $boA1w = parcelRequire("boA1w");
var $9a4894875072ae55$var$assert = $boA1w.assert;
var $9a4894875072ae55$var$cachedProperty = $boA1w.cachedProperty;
var $9a4894875072ae55$var$parseBytes = $boA1w.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $9a4894875072ae55$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $9a4894875072ae55$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $9a4894875072ae55$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $h0anJ) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$9a4894875072ae55$var$cachedProperty($9a4894875072ae55$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$9a4894875072ae55$var$cachedProperty($9a4894875072ae55$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$9a4894875072ae55$var$cachedProperty($9a4894875072ae55$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$9a4894875072ae55$var$cachedProperty($9a4894875072ae55$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$9a4894875072ae55$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$9a4894875072ae55$var$Signature.prototype.toHex = function toHex() {
    return $boA1w.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $9a4894875072ae55$var$Signature;

});



parcelRequire.register("7QjXN", function(module, exports) {

var $2icV3 = parcelRequire("2icV3");
var $5b5ce00d2be968cf$require$json_stringify = $2icV3.stringify;

var $gbJCj = parcelRequire("gbJCj");
module.exports = function(options) {
    return {
        parse: $gbJCj(options),
        stringify: $5b5ce00d2be968cf$require$json_stringify
    };
};
//create the default method members with no options applied for backwards compatibility
module.exports.parse = $gbJCj();
module.exports.stringify = $5b5ce00d2be968cf$require$json_stringify;

});
parcelRequire.register("2icV3", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");

var $ivmGH = parcelRequire("ivmGH");
/*
    json2.js
    2013-05-26

    Public Domain.

    NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.

    See http://www.JSON.org/js.html


    This code should be minified before deployment.
    See http://javascript.crockford.com/jsmin.html

    USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
    NOT CONTROL.


    This file creates a global JSON object containing two methods: stringify
    and parse.

        JSON.stringify(value, replacer, space)
            value       any JavaScript value, usually an object or array.

            replacer    an optional parameter that determines how object
                        values are stringified for objects. It can be a
                        function or an array of strings.

            space       an optional parameter that specifies the indentation
                        of nested structures. If it is omitted, the text will
                        be packed without extra whitespace. If it is a number,
                        it will specify the number of spaces to indent at each
                        level. If it is a string (such as '\t' or '&nbsp;'),
                        it contains the characters used to indent at each level.

            This method produces a JSON text from a JavaScript value.

            When an object value is found, if the object contains a toJSON
            method, its toJSON method will be called and the result will be
            stringified. A toJSON method does not serialize: it returns the
            value represented by the name/value pair that should be serialized,
            or undefined if nothing should be serialized. The toJSON method
            will be passed the key associated with the value, and this will be
            bound to the value

            For example, this would serialize Dates as ISO strings.

                Date.prototype.toJSON = function (key) {
                    function f(n) {
                        // Format integers to have at least two digits.
                        return n < 10 ? '0' + n : n;
                    }

                    return this.getUTCFullYear()   + '-' +
                         f(this.getUTCMonth() + 1) + '-' +
                         f(this.getUTCDate())      + 'T' +
                         f(this.getUTCHours())     + ':' +
                         f(this.getUTCMinutes())   + ':' +
                         f(this.getUTCSeconds())   + 'Z';
                };

            You can provide an optional replacer method. It will be passed the
            key and value of each member, with this bound to the containing
            object. The value that is returned from your method will be
            serialized. If your method returns undefined, then the member will
            be excluded from the serialization.

            If the replacer parameter is an array of strings, then it will be
            used to select the members to be serialized. It filters the results
            such that only members with keys listed in the replacer array are
            stringified.

            Values that do not have JSON representations, such as undefined or
            functions, will not be serialized. Such values in objects will be
            dropped; in arrays they will be replaced with null. You can use
            a replacer function to replace those with JSON values.
            JSON.stringify(undefined) returns undefined.

            The optional space parameter produces a stringification of the
            value that is filled with line breaks and indentation to make it
            easier to read.

            If the space parameter is a non-empty string, then that string will
            be used for indentation. If the space parameter is a number, then
            the indentation will be that many spaces.

            Example:

            text = JSON.stringify(['e', {pluribus: 'unum'}]);
            // text is '["e",{"pluribus":"unum"}]'


            text = JSON.stringify(['e', {pluribus: 'unum'}], null, '\t');
            // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'

            text = JSON.stringify([new Date()], function (key, value) {
                return this[key] instanceof Date ?
                    'Date(' + this[key] + ')' : value;
            });
            // text is '["Date(---current time---)"]'


        JSON.parse(text, reviver)
            This method parses a JSON text to produce an object or array.
            It can throw a SyntaxError exception.

            The optional reviver parameter is a function that can filter and
            transform the results. It receives each of the keys and values,
            and its return value is used instead of the original value.
            If it returns what it received, then the structure is not modified.
            If it returns undefined then the member is deleted.

            Example:

            // Parse the text. Values that look like ISO date strings will
            // be converted to Date objects.

            myData = JSON.parse(text, function (key, value) {
                var a;
                if (typeof value === 'string') {
                    a =
/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
                    if (a) {
                        return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
                            +a[5], +a[6]));
                    }
                }
                return value;
            });

            myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
                var d;
                if (typeof value === 'string' &&
                        value.slice(0, 5) === 'Date(' &&
                        value.slice(-1) === ')') {
                    d = new Date(value.slice(5, -1));
                    if (d) {
                        return d;
                    }
                }
                return value;
            });


    This is a reference implementation. You are free to copy, modify, or
    redistribute.
*/ /*jslint evil: true, regexp: true */ /*members "", "\b", "\t", "\n", "\f", "\r", "\"", JSON, "\\", apply,
    call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/ // Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.
var $1ab748b5d36ee8d8$var$JSON = module.exports;
(function() {
    "use strict";
    var f = function f(n) {
        // Format integers to have at least two digits.
        return n < 10 ? "0" + n : n;
    };
    var quote = function quote(string) {
        // If the string contains no control characters, no quote characters, and no
        // backslash characters, then we can safely slap some quotes around it.
        // Otherwise we must also replace the offending characters with safe escape
        // sequences.
        escapable.lastIndex = 0;
        return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
            var c = meta[a];
            return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + string + '"';
    };
    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, gap, indent, meta = {
        "\b": "\\b",
        "	": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
    }, rep;
    function str(key, holder) {
        // Produce a string from holder[key].
        var i, k, v, length, mind = gap, partial, value = holder[key], isBigNumber = value != null && (value instanceof $ivmGH || $ivmGH.isBigNumber(value));
        // If the value has a toJSON method, call it to obtain a replacement value.
        if (value && typeof value === "object" && typeof value.toJSON === "function") value = value.toJSON(key);
        // If we were called with a replacer function, then call the replacer to
        // obtain a replacement value.
        if (typeof rep === "function") value = rep.call(holder, key, value);
        // What happens next depends on the value's type.
        switch(typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value)){
            case "string":
                if (isBigNumber) return value;
                else return quote(value);
            case "number":
                // JSON numbers must be finite. Encode non-finite numbers as null.
                return isFinite(value) ? String(value) : "null";
            case "boolean":
            case "null":
            case "bigint":
                // If the value is a boolean or null, convert it to a string. Note:
                // typeof null does not produce 'null'. The case is included here in
                // the remote chance that this gets fixed someday.
                return String(value);
            // If the type is 'object', we might be dealing with an object or an array or
            // null.
            case "object":
                // Due to a specification blunder in ECMAScript, typeof null is 'object',
                // so watch out for that case.
                if (!value) return "null";
                // Make an array to hold the partial results of stringifying this object value.
                gap += indent;
                partial = [];
                // Is the value an array?
                if (Object.prototype.toString.apply(value) === "[object Array]") {
                    // The value is an array. Stringify every element. Use null as a placeholder
                    // for non-JSON values.
                    length = value.length;
                    for(i = 0; i < length; i += 1)partial[i] = str(i, value) || "null";
                    // Join all of the elements together, separated with commas, and wrap them in
                    // brackets.
                    v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
                    gap = mind;
                    return v;
                }
                // If the replacer is an array, use it to select the members to be stringified.
                if (rep && typeof rep === "object") {
                    length = rep.length;
                    for(i = 0; i < length; i += 1)if (typeof rep[i] === "string") {
                        k = rep[i];
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                } else // Otherwise, iterate through all of the keys in the object.
                Object.keys(value).forEach(function(k) {
                    var v = str(k, value);
                    if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                });
                // Join all of the member texts together, separated with commas,
                // and wrap them in braces.
                v = partial.length === 0 ? "{}" : gap ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}" : "{" + partial.join(",") + "}";
                gap = mind;
                return v;
        }
    }
    // If the JSON object does not yet have a stringify method, give it one.
    if (typeof $1ab748b5d36ee8d8$var$JSON.stringify !== "function") $1ab748b5d36ee8d8$var$JSON.stringify = function(value, replacer, space) {
        // The stringify method takes a value and an optional replacer, and an optional
        // space parameter, and returns a JSON text. The replacer can be a function
        // that can replace values, or an array of strings that will select the keys.
        // A default replacer method can be provided. Use of the space parameter can
        // produce text that is more easily readable.
        var i;
        gap = "";
        indent = "";
        // If the space parameter is a number, make an indent string containing that
        // many spaces.
        if (typeof space === "number") for(i = 0; i < space; i += 1)indent += " ";
        else if (typeof space === "string") indent = space;
        // If there is a replacer, it must be a function or an array.
        // Otherwise, throw an error.
        rep = replacer;
        if (replacer && typeof replacer !== "function" && (typeof replacer !== "object" || typeof replacer.length !== "number")) throw new Error("JSON.stringify");
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str("", {
            "": value
        });
    };
})();

});

parcelRequire.register("gbJCj", function(module, exports) {
var $bc910efc07e4adc3$var$BigNumber = null;
// regexpxs extracted from
// (c) BSD-3-Clause
// https://github.com/fastify/secure-json-parse/graphs/contributors and https://github.com/hapijs/bourne/graphs/contributors
var $bc910efc07e4adc3$var$suspectProtoRx = /(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])/;
var $bc910efc07e4adc3$var$suspectConstructorRx = /(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)/;

/*
    json_parse.js
    2012-06-20

    Public Domain.

    NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.

    This file creates a json_parse function.
    During create you can (optionally) specify some behavioural switches

        require('json-bigint')(options)

            The optional options parameter holds switches that drive certain
            aspects of the parsing process:
            * options.strict = true will warn about duplicate-key usage in the json.
              The default (strict = false) will silently ignore those and overwrite
              values for keys that are in duplicate use.

    The resulting function follows this signature:
        json_parse(text, reviver)
            This method parses a JSON text to produce an object or array.
            It can throw a SyntaxError exception.

            The optional reviver parameter is a function that can filter and
            transform the results. It receives each of the keys and values,
            and its return value is used instead of the original value.
            If it returns what it received, then the structure is not modified.
            If it returns undefined then the member is deleted.

            Example:

            // Parse the text. Values that look like ISO date strings will
            // be converted to Date objects.

            myData = json_parse(text, function (key, value) {
                var a;
                if (typeof value === 'string') {
                    a =
/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
                    if (a) {
                        return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
                            +a[5], +a[6]));
                    }
                }
                return value;
            });

    This is a reference implementation. You are free to copy, modify, or
    redistribute.

    This code should be minified before deployment.
    See http://javascript.crockford.com/jsmin.html

    USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
    NOT CONTROL.
*/ /*members "", "\"", "\/", "\\", at, b, call, charAt, f, fromCharCode,
    hasOwnProperty, message, n, name, prototype, push, r, t, text
*/ var $bc910efc07e4adc3$var$json_parse = function json_parse(options) {
    "use strict";
    // This is a function that can parse a JSON text, producing a JavaScript
    // data structure. It is a simple, recursive descent parser. It does not use
    // eval or regular expressions, so it can be used as a model for implementing
    // a JSON parser in other languages.
    // We are defining the function inside of another function to avoid creating
    // global variables.
    // Default options one can override by passing options to the parse()
    var _options = {
        strict: false,
        storeAsString: false,
        alwaysParseAsBig: false,
        useNativeBigInt: false,
        protoAction: "error",
        constructorAction: "error"
    };
    // If there are options, then use them to override the default _options
    if (options !== undefined && options !== null) {
        if (options.strict === true) _options.strict = true;
        if (options.storeAsString === true) _options.storeAsString = true;
        _options.alwaysParseAsBig = options.alwaysParseAsBig === true ? options.alwaysParseAsBig : false;
        _options.useNativeBigInt = options.useNativeBigInt === true ? options.useNativeBigInt : false;
        if (typeof options.constructorAction !== "undefined") {
            if (options.constructorAction === "error" || options.constructorAction === "ignore" || options.constructorAction === "preserve") _options.constructorAction = options.constructorAction;
            else throw new Error('Incorrect value for constructorAction option, must be "error", "ignore" or undefined but passed '.concat(options.constructorAction));
        }
        if (typeof options.protoAction !== "undefined") {
            if (options.protoAction === "error" || options.protoAction === "ignore" || options.protoAction === "preserve") _options.protoAction = options.protoAction;
            else throw new Error('Incorrect value for protoAction option, must be "error", "ignore" or undefined but passed '.concat(options.protoAction));
        }
    }
    var at, ch, escapee = {
        '"': '"',
        "\\": "\\",
        "/": "/",
        b: "\b",
        f: "\f",
        n: "\n",
        r: "\r",
        t: "	"
    }, text, error = function error(m) {
        // Call error when something is wrong.
        throw {
            name: "SyntaxError",
            message: m,
            at: at,
            text: text
        };
    }, next = function next(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error("Expected '" + c + "' instead of '" + ch + "'");
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function number() {
        // Parse a number value.
        var number, string = "";
        if (ch === "-") {
            string = "-";
            next("-");
        }
        while(ch >= "0" && ch <= "9"){
            string += ch;
            next();
        }
        if (ch === ".") {
            string += ".";
            while(next() && ch >= "0" && ch <= "9")string += ch;
        }
        if (ch === "e" || ch === "E") {
            string += ch;
            next();
            if (ch === "-" || ch === "+") {
                string += ch;
                next();
            }
            while(ch >= "0" && ch <= "9"){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error("Bad number");
        else {
            if ($bc910efc07e4adc3$var$BigNumber == null) $bc910efc07e4adc3$var$BigNumber = (parcelRequire("ivmGH"));
            //if (number > 9007199254740992 || number < -9007199254740992)
            // Bignumber has stricter check: everything with length > 15 digits disallowed
            if (string.length > 15) return _options.storeAsString ? string : _options.useNativeBigInt ? BigInt(string) : new $bc910efc07e4adc3$var$BigNumber(string);
            else return !_options.alwaysParseAsBig ? number : _options.useNativeBigInt ? BigInt(number) : new $bc910efc07e4adc3$var$BigNumber(number);
        }
    }, string = function string() {
        // Parse a string value.
        var hex, i, string = "", uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') {
            var startAt = at;
            while(next()){
                if (ch === '"') {
                    if (at - 1 > startAt) string += text.substring(startAt, at - 1);
                    next();
                    return string;
                }
                if (ch === "\\") {
                    if (at - 1 > startAt) string += text.substring(startAt, at - 1);
                    next();
                    if (ch === "u") {
                        uffff = 0;
                        for(i = 0; i < 4; i += 1){
                            hex = parseInt(next(), 16);
                            if (!isFinite(hex)) break;
                            uffff = uffff * 16 + hex;
                        }
                        string += String.fromCharCode(uffff);
                    } else if (typeof escapee[ch] === "string") string += escapee[ch];
                    else break;
                    startAt = at;
                }
            }
        }
        error("Bad string");
    }, white = function white() {
        // Skip whitespace.
        while(ch && ch <= " ")next();
    }, word = function word() {
        // true, false, or null.
        switch(ch){
            case "t":
                next("t");
                next("r");
                next("u");
                next("e");
                return true;
            case "f":
                next("f");
                next("a");
                next("l");
                next("s");
                next("e");
                return false;
            case "n":
                next("n");
                next("u");
                next("l");
                next("l");
                return null;
        }
        error("Unexpected '" + ch + "'");
    }, value, array = function array() {
        // Parse an array value.
        var array = [];
        if (ch === "[") {
            next("[");
            white();
            if (ch === "]") {
                next("]");
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === "]") {
                    next("]");
                    return array;
                }
                next(",");
                white();
            }
        }
        error("Bad array");
    }, object = function object() {
        // Parse an object value.
        var key, object = Object.create(null);
        if (ch === "{") {
            next("{");
            white();
            if (ch === "}") {
                next("}");
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(":");
                if (_options.strict === true && Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                if ($bc910efc07e4adc3$var$suspectProtoRx.test(key) === true) {
                    if (_options.protoAction === "error") error("Object contains forbidden prototype property");
                    else if (_options.protoAction === "ignore") value();
                    else object[key] = value();
                } else if ($bc910efc07e4adc3$var$suspectConstructorRx.test(key) === true) {
                    if (_options.constructorAction === "error") error("Object contains forbidden constructor property");
                    else if (_options.constructorAction === "ignore") value();
                    else object[key] = value();
                } else object[key] = value();
                white();
                if (ch === "}") {
                    next("}");
                    return object;
                }
                next(",");
                white();
            }
        }
        error("Bad object");
    };
    value = function value() {
        // Parse a JSON value. It could be an object, an array, a string, a number,
        // or a word.
        white();
        switch(ch){
            case "{":
                return object();
            case "[":
                return array();
            case '"':
                return string();
            case "-":
                return number();
            default:
                return ch >= "0" && ch <= "9" ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the above
    // functions and variables.
    return function(source, reviver) {
        var result;
        text = source + "";
        at = 0;
        ch = " ";
        result = value();
        white();
        if (ch) error("Syntax error");
        // If there is a reviver function, we recursively walk the new structure,
        // passing each name/value pair to the reviver function for possible
        // transformation, starting with a temporary root object that holds the result
        // in an empty key. If there is not a reviver function, we simply return the
        // result.
        return typeof reviver === "function" ? function walk(holder, key) {
            var k, v, value = holder[key];
            if (value && typeof value === "object") Object.keys(value).forEach(function(k) {
                v = walk(value, k);
                if (v !== undefined) value[k] = v;
                else delete value[k];
            });
            return reviver.call(holder, key, value);
        }({
            "": result
        }, "") : result;
    };
};
module.exports = $bc910efc07e4adc3$var$json_parse;

});


parcelRequire.register("aZG1x", function(module, exports) {

$parcel$export(module.exports, "CustomError", function () { return $70223773e2d7f5c7$export$f7a70f5f17339408; });
function $70223773e2d7f5c7$var$fixProto(target, prototype) {
    var setPrototypeOf = Object.setPrototypeOf;
    setPrototypeOf ? setPrototypeOf(target, prototype) : target.__proto__ = prototype;
}
function $70223773e2d7f5c7$var$fixStack(target, fn) {
    if (fn === void 0) fn = target.constructor;
    var captureStackTrace = Error.captureStackTrace;
    captureStackTrace && captureStackTrace(target, fn);
}
var $70223773e2d7f5c7$var$__extends = function() {
    var _extendStatics = function extendStatics(d, b) {
        _extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return _extendStatics(d, b);
    };
    return function(d, b) {
        var __ = function __() {
            this.constructor = d;
        };
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        _extendStatics(d, b);
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $70223773e2d7f5c7$export$f7a70f5f17339408 = function(_super) {
    var CustomError = function CustomError(message, options) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message, options) || this;
        Object.defineProperty(_this, "name", {
            value: _newTarget.name,
            enumerable: false,
            configurable: true
        });
        $70223773e2d7f5c7$var$fixProto(_this, _newTarget.prototype);
        $70223773e2d7f5c7$var$fixStack(_this);
        return _this;
    };
    $70223773e2d7f5c7$var$__extends(CustomError, _super);
    return CustomError;
}(Error);
var $70223773e2d7f5c7$var$__spreadArray = function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function $70223773e2d7f5c7$export$aa5f2b9aeca47350(fn, parent) {
    if (parent === void 0) parent = Error;
    function CustomError() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!(this instanceof CustomError)) return new (CustomError.bind.apply(CustomError, $70223773e2d7f5c7$var$__spreadArray([
            void 0
        ], args, false)))();
        parent.apply(this, args);
        Object.defineProperty(this, "name", {
            value: fn.name || parent.name,
            enumerable: false,
            configurable: true
        });
        fn.apply(this, args);
        $70223773e2d7f5c7$var$fixStack(this, CustomError);
    }
    return Object.defineProperties(CustomError, {
        prototype: {
            value: Object.create(parent.prototype, {
                constructor: {
                    value: CustomError,
                    writable: true,
                    configurable: true
                }
            })
        }
    });
}

});

parcelRequire.register("4oIhN", function(module, exports) {
(function(name, context, definition) {
    if (0, module.exports) module.exports = definition();
    else if (typeof define === "function" && define.amd) define(definition);
    else context[name] = definition();
})("urljoin", module.exports, function() {
    var normalize = function normalize(strArray) {
        var resultArray = [];
        if (strArray.length === 0) return "";
        if (typeof strArray[0] !== "string") throw new TypeError("Url must be a string. Received " + strArray[0]);
        // If the first part is a plain protocol, we combine it with the next part.
        if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
            var first = strArray.shift();
            strArray[0] = first + strArray[0];
        }
        // There must be two or three slashes in the file protocol, two slashes in anything else.
        if (strArray[0].match(/^file:\/\/\//)) strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1:///");
        else strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1://");
        for(var i = 0; i < strArray.length; i++){
            var component = strArray[i];
            if (typeof component !== "string") throw new TypeError("Url must be a string. Received " + component);
            if (component === "") continue;
            if (i > 0) // Removing the starting slashes for each component but the first.
            component = component.replace(/^[\/]+/, "");
            if (i < strArray.length - 1) // Removing the ending slashes for each component but the last.
            component = component.replace(/[\/]+$/, "");
            else // For the last component we will combine multiple slashes to a single one.
            component = component.replace(/[\/]+$/, "/");
            resultArray.push(component);
        }
        var str = resultArray.join("/");
        // Each input component is now separated by a single slash except the possible first plain protocol part.
        // remove trailing slash before parameters or hash
        str = str.replace(/\/(\?|&|#[^!])/g, "$1");
        // replace ? in parameters with &
        var parts = str.split("?");
        str = parts.shift() + (parts.length > 0 ? "?" : "") + parts.join("&");
        return str;
    };
    return function() {
        var input;
        if (typeof arguments[0] === "object") input = arguments[0];
        else input = [].slice.call(arguments);
        return normalize(input);
    };
});

});



parcelRequire.register("foE9L", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $8OnJk = parcelRequire("8OnJk");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarknetContractParamsProvider = void 0;

var $18VbH = parcelRequire("18VbH");
var $b3583f20c7cdf8b8$var$StarknetContractParamsProvider = /*#__PURE__*/ function(_redstone_sdk_1_ContractParamsProvider) {
    (0, $ftJVG._)(StarknetContractParamsProvider, _redstone_sdk_1_ContractParamsProvider);
    var _super = (0, $6OZAO._)(StarknetContractParamsProvider);
    function StarknetContractParamsProvider() {
        (0, $978gY._)(this, StarknetContractParamsProvider);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(StarknetContractParamsProvider, [
        {
            key: "requestPayload",
            value: function requestPayload(requestParams) {
                var _this = this;
                var _this1 = this, _superprop_get_requestPayload = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(StarknetContractParamsProvider.prototype), "requestPayload", _this);
                };
                return (0, $byzP8._)(function() {
                    var requestParamsChanged;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                requestParamsChanged = (0, $8OnJk._)({}, requestParams);
                                requestParamsChanged["dataFeeds"] = undefined;
                                return [
                                    4,
                                    _superprop_get_requestPayload().call(_this1, requestParamsChanged)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return StarknetContractParamsProvider;
}($18VbH.ContractParamsProvider);
module.exports.StarknetContractParamsProvider = $b3583f20c7cdf8b8$var$StarknetContractParamsProvider;

});
parcelRequire.register("18VbH", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $0d52e613fea8df9a$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0d52e613fea8df9a$var$__exportStar = undefined && undefined.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0d52e613fea8df9a$var$__createBinding(exports1, m, p);
};
var $0d52e613fea8df9a$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUrlsForDataServiceId = module.exports.requestRedstonePayload = module.exports.requestDataPackages = module.exports.getDecimalsForDataFeedId = module.exports.parseDataPackagesResponse = module.exports.getDataServiceIdForSigner = module.exports.getOracleRegistryState = void 0;

var $0d52e613fea8df9a$var$axios_1 = $0d52e613fea8df9a$var$__importDefault((parcelRequire("28Dk9")));

var $e5s6c = parcelRequire("e5s6c");

var $5Sl4O = parcelRequire("5Sl4O");

var $hyxZy = parcelRequire("hyxZy");

var $f7K4O = parcelRequire("f7K4O");

var $0d52e613fea8df9a$var$DEFAULT_DECIMALS = 8;
var $0d52e613fea8df9a$var$ALL_FEEDS_KEY = "___ALL_FEEDS___";
var $0d52e613fea8df9a$var$getOracleRegistryState = function() {
    var _ref = (0, $byzP8._)(function() {
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.resolve($5Sl4O.redstoneOraclesInitialState)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getOracleRegistryState() {
        return _ref.apply(this, arguments);
    };
}();
module.exports.getOracleRegistryState = $0d52e613fea8df9a$var$getOracleRegistryState;
var $0d52e613fea8df9a$var$getDataServiceIdForSigner = function(oracleState, signerAddress) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(oracleState.nodes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nodeDetails = _step.value;
            if (nodeDetails.evmAddress.toLowerCase() === signerAddress.toLowerCase()) return nodeDetails.dataServiceId;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    throw new Error("Data service not found for ".concat(signerAddress));
};
module.exports.getDataServiceIdForSigner = $0d52e613fea8df9a$var$getDataServiceIdForSigner;
var $0d52e613fea8df9a$var$parseDataPackagesResponse = function(dpResponse, reqParams) {
    var parsedResponse = {};
    var _reqParams_dataFeeds;
    var requestedDataFeedIds = (_reqParams_dataFeeds = reqParams.dataFeeds) !== null && _reqParams_dataFeeds !== void 0 ? _reqParams_dataFeeds : [
        $0d52e613fea8df9a$var$ALL_FEEDS_KEY
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = requestedDataFeedIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var dataFeedId = _step.value;
            var dataFeedPackages = dpResponse[dataFeedId];
            if (!dataFeedPackages) throw new Error("Requested data feed id is not included in response: ".concat(dataFeedId));
            if (dataFeedPackages.length < reqParams.uniqueSignersCount) throw new Error("Too few unique signers for the data feed: ".concat(dataFeedId, ". ") + "Expected: ".concat(reqParams.uniqueSignersCount, ". ") + "Received: ".concat(dataFeedPackages.length));
            var dataFeedPackagesSorted = $0d52e613fea8df9a$var$getDataPackagesSortedByDeviation(dataFeedPackages, reqParams.valuesToCompare, dataFeedId);
            parsedResponse[dataFeedId] = dataFeedPackagesSorted.slice(0, reqParams.uniqueSignersCount).map(function(dataPackage) {
                return $hyxZy.SignedDataPackage.fromObj(dataPackage);
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return parsedResponse;
};
module.exports.parseDataPackagesResponse = $0d52e613fea8df9a$var$parseDataPackagesResponse;
var $0d52e613fea8df9a$var$getDataPackagesSortedByDeviation = function(dataFeedPackages, valuesToCompare, dataFeedId) {
    if (!valuesToCompare) return dataFeedPackages;
    if (dataFeedId === $0d52e613fea8df9a$var$ALL_FEEDS_KEY) throw new Error("Cannot sort data packages by deviation for ".concat($0d52e613fea8df9a$var$ALL_FEEDS_KEY));
    if (!valuesToCompare[dataFeedId]) return dataFeedPackages;
    var _ref;
    var decimals = (_ref = (0, module.exports.getDecimalsForDataFeedId)(dataFeedPackages)) !== null && _ref !== void 0 ? _ref : $0d52e613fea8df9a$var$DEFAULT_DECIMALS;
    var valueToCompare = Number($e5s6c.formatUnits(valuesToCompare[dataFeedId], decimals));
    return $0d52e613fea8df9a$var$sortDataPackagesByDeviationDesc(dataFeedPackages, valueToCompare);
};
var $0d52e613fea8df9a$var$getDecimalsForDataFeedId = function(dataPackages) {
    var firstDecimal = dataPackages[0].dataPoints[0].decimals;
    var areAllDecimalsEqual = dataPackages.every(function(dataPackage) {
        return dataPackage.dataPoints.every(function(dataPoint) {
            return dataPoint.decimals === firstDecimal;
        });
    });
    if (!areAllDecimalsEqual) throw new Error("Decimals from data points in data packages are not equal");
    return firstDecimal;
};
module.exports.getDecimalsForDataFeedId = $0d52e613fea8df9a$var$getDecimalsForDataFeedId;
var $0d52e613fea8df9a$var$errToString = function(err) {
    var e = err;
    if (e instanceof AggregateError) {
        var stringifiedErrors = e.errors.reduce(function(prev, oneOfErrors, curIndex) {
            return prev += "".concat(curIndex, ": ").concat(oneOfErrors.message, ", ");
        }, "");
        return "".concat(e.message, ": ").concat(stringifiedErrors);
    } else return e.message;
};
var $0d52e613fea8df9a$var$requestDataPackages = function() {
    var _ref = (0, $byzP8._)(function(reqParams) {
        var promises, e, errMessage;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    promises = $0d52e613fea8df9a$var$prepareDataPackagePromises(reqParams);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        Promise.any(promises)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    e = _state.sent();
                    errMessage = "Request failed ".concat(JSON.stringify({
                        reqParams: reqParams
                    }), ", Original error: ").concat($0d52e613fea8df9a$var$errToString(e));
                    throw new Error(errMessage);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function requestDataPackages(reqParams) {
        return _ref.apply(this, arguments);
    };
}();
module.exports.requestDataPackages = $0d52e613fea8df9a$var$requestDataPackages;
var $0d52e613fea8df9a$var$prepareDataPackagePromises = function(reqParams) {
    var urls = (0, module.exports.getUrlsForDataServiceId)(reqParams);
    var pathComponents = [
        "data-packages",
        reqParams.historicalTimestamp ? "historical" : "latest",
        reqParams.dataServiceId
    ];
    if (reqParams.historicalTimestamp) pathComponents.push("".concat(reqParams.historicalTimestamp));
    return urls.map(function(url) {
        return $0d52e613fea8df9a$var$axios_1.default.get([
            url
        ].concat(pathComponents).join("/")).then(function(response) {
            return (0, module.exports.parseDataPackagesResponse)(response.data, reqParams);
        });
    });
};
var $0d52e613fea8df9a$var$requestRedstonePayload = function() {
    var _ref = (0, $byzP8._)(function(reqParams, unsignedMetadataMsg) {
        var signedDataPackagesResponse, signedDataPackages;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, module.exports.requestDataPackages)(reqParams)
                    ];
                case 1:
                    signedDataPackagesResponse = _state.sent();
                    signedDataPackages = Object.values(signedDataPackagesResponse).flat();
                    return [
                        2,
                        $hyxZy.RedstonePayload.prepare(signedDataPackages, unsignedMetadataMsg || "")
                    ];
            }
        });
    });
    return function requestRedstonePayload(reqParams, unsignedMetadataMsg) {
        return _ref.apply(this, arguments);
    };
}();
module.exports.requestRedstonePayload = $0d52e613fea8df9a$var$requestRedstonePayload;
var $0d52e613fea8df9a$var$getUrlsForDataServiceId = function(reqParams) {
    if (reqParams.urls) return reqParams.urls;
    return (0, (parcelRequire("grzTa")).resolveDataServiceUrls)(reqParams.dataServiceId);
};
module.exports.getUrlsForDataServiceId = $0d52e613fea8df9a$var$getUrlsForDataServiceId;
var $0d52e613fea8df9a$var$sortDataPackagesByDeviationDesc = function(dataPackages, valueToCompare) {
    return dataPackages.sort(function(leftDataPackage, rightDataPackage) {
        var leftValue = $f7K4O.SafeNumber.createSafeNumber(leftDataPackage.dataPoints[0].value);
        var leftValueDeviation = $f7K4O.SafeNumber.calculateDeviationPercent({
            currValue: leftValue,
            prevValue: $f7K4O.SafeNumber.createSafeNumber(valueToCompare)
        });
        var rightValue = $f7K4O.SafeNumber.createSafeNumber(rightDataPackage.dataPoints[0].value);
        var rightValueDeviation = $f7K4O.SafeNumber.calculateDeviationPercent({
            currValue: rightValue,
            prevValue: $f7K4O.SafeNumber.createSafeNumber(valueToCompare)
        });
        return rightValueDeviation.sub(leftValueDeviation).unsafeToNumber();
    });
};
module.exports.default = {
    getOracleRegistryState: module.exports.getOracleRegistryState,
    requestDataPackages: module.exports.requestDataPackages,
    getDataServiceIdForSigner: module.exports.getDataServiceIdForSigner,
    requestRedstonePayload: module.exports.requestRedstonePayload,
    resolveDataServiceUrls: (parcelRequire("grzTa")).resolveDataServiceUrls,
    getDecimalsForDataFeedId: module.exports.getDecimalsForDataFeedId
};

$0d52e613fea8df9a$var$__exportStar((parcelRequire("grzTa")), module.exports);

$0d52e613fea8df9a$var$__exportStar((parcelRequire("kQU65")), module.exports);

$0d52e613fea8df9a$var$__exportStar((parcelRequire("jfbxu")), module.exports);

$0d52e613fea8df9a$var$__exportStar((parcelRequire("2ptTQ")), module.exports);

$0d52e613fea8df9a$var$__exportStar((parcelRequire("2nhuk")), module.exports);

$0d52e613fea8df9a$var$__exportStar((parcelRequire("krvSi")), module.exports);

$0d52e613fea8df9a$var$__exportStar((parcelRequire("4FcjQ")), module.exports);

$0d52e613fea8df9a$var$__exportStar((parcelRequire("jCh0A")), module.exports);

$0d52e613fea8df9a$var$__exportStar((parcelRequire("9oEZZ")), module.exports);

$0d52e613fea8df9a$var$__exportStar((parcelRequire("c4C7h")), module.exports);

});
parcelRequire.register("5Sl4O", function(module, exports) {
"use strict";
var $447258458eecf49f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $447258458eecf49f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $447258458eecf49f$var$__createBinding(exports1, m, p);
};
var $447258458eecf49f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.redstoneOraclesInitialState = void 0;

var $hOxYX = parcelRequire("hOxYX");
Object.defineProperty(module.exports, "redstoneOraclesInitialState", {
    enumerable: true,
    get: function get() {
        return $447258458eecf49f$var$__importDefault($hOxYX).default;
    }
});

$447258458eecf49f$var$__exportStar((parcelRequire("be7oZ")), module.exports);

});
parcelRequire.register("hOxYX", function(module, exports) {
module.exports = JSON.parse('{"nodes":{"I-5rWUehEv-MjdK9gFw09RxfSLQX9DIHxG614Wf8qo0":{"url":"https://redstone.finance","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"redstone","ipAddress":"0.0.0.0","dataServiceId":"redstone-main-demo","evmAddress":"0x0C39486f770B26F5527BBBf942726537986Cd7eb","description":"Main RedStone Provider with all available tokens.","arweavePublicKey":"xyTvKiCST8bAT6sxrgkLh8UCX2N1eKvawODuxwq4qOHIdDAZFU_3N2m59rkZ0E7m77GsJuf1I8u0oEJEbxAdT7uD2JTwoYEHauXSxyJYvF0RCcZOhl5P1PJwImd44SJYa_9My7L84D5KXB9SKs8_VThe7ZyOb5HSGLNvMIK6A8IJ4Hr_tg9GYm65CRmtcu18S9mhun8vgw2wi7Gw6oR6mc4vU1I-hrU66Fi7YlXwFieP6YSy01JqoLPhU84EunPQzXPouVSbXjgRU5kFVxtdRy4GK2fzEBFYsQwCQgFrySCrFKHV8AInu9jerfof_DxNKiXkBzlB8nc22CrYnvvio_BWyh-gN0hQHZT0gwMR-A7sbXNCQJfReaIZzX_jP6XoB82PnpzmL_j1mJ2lnv2Rn001flBAx9AYxtGXd9s07pA-FggTbEG3Y2UnlWW6l3EJ93E0IfxL0PqGEUlp217mxUHvmTw9fkGDWa8rT9RPmsTyji-kMFSefclw80cBm_iOsIEutGP4S3LDbP-ZVJWDeJOBQQpSgwbisl8qbjl2sMQLQihoG2TQyNbmLwfyq-XSULkXjUi1_6BH36wnDBLWBKF-bS2bLKcGtn3Vjet72lNHxJJilcj8vpauwJG0078S_lO5uGt6oicdGR6eh_NSn6_8za_tXg0G_fohz4Yb1z8","ecdsaPublicKey":"0x04009dd87eb41d96ce8ad94aa22ea8b0ba4ac20c45e42f71726d6b180f93c3f298e333ae7591fe1c9d88234575639be9e81e35ba2fe5ad2c2260f07db49ccb9d0d"},"Yba8IVc_01bFxutKNJAZ7CmTD5AVi2GcWXf1NajPAsc":{"url":"https://redstone.finance","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"redstone-stocks","ipAddress":"0.0.0.0","dataServiceId":"redstone-stocks-demo","evmAddress":"0x926E370fD53c23f8B71ad2B3217b227E41A92b12","description":"Stocks, ETFs, Livestocks, Metals, Energies...","arweavePublicKey":"wOoClMPZ_maAoE6OhCC8svn_9gu8rjuWPi3Grf05zpQnCzeFjzUocJUr0ta-muJDqfiTd4t5KR2qNxn3nkN2_kXsn5AcXnlI4UgnRdcEvsDh6yPMoMlAiAD6c0_CIgdiMFku5OTijNMtFYOybPKrd9Xdf_7_lnRZhU9qQXeBclVjmIzftwNaTFYI1sgApWKMxJ6301CY7VN9SOD9KBrFQJ3QjWqLrLwAyAu_Q6aBeQF_L-cZSFCiTfwyDptiMCdLAjzU9s55LNAg65pZ_OfFsvqylwiXEVIEDLUI3nmcM6OUHfyAG2TxoeXeem9nCpA96MiM8MyTWtOApGA3GW__j3fxutD0wt3_uGnVRZoypPqNuPjb5BraF0owTDYJQNML9Ddx1Hy6gMXjvjxn-MbAV7tI4KnDynrbtXPSZYjRpTpxcH9Rlr-bQAZWGpYF7OWpsZlPuE4MdxpQYhqLj6wfGCxTyzIjyt_t4zR28gWIGT5SfM-etcuXyy_chspsIqisSj781AP7YMTIxzyrY_LAAm-u5gz5VwnD8xDKIrYcsxLpC4V30HFWRc5vYtBQ0cAZYnp9AGGFD-6A7PnqQ1EYSSEHzSAqoYHaqxuAvxJEhG5AECdXBS3-FpgbGgVFEeQxIH7v9Js6-Uk85t23MjRUJFNo2JIlvyolmtkd3mf88qc","ecdsaPublicKey":"0x04a628e8c2ef7d3b768b75404a48adcd667d0d59ae457bf19552ff670d2c95630480752e90b0c9fe8127feeb9e8f9e694919c730327bd368c985f1a5b26c2d60ba"},"zYqPZuALSPa_f5Agvf8g2JHv94cqMn9aBtnH7GFHbuA":{"url":"https://redstone.finance","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"redstone-rapid","ipAddress":"0.0.0.0","dataServiceId":"redstone-rapid-demo","evmAddress":"0xf786a909D559F5Dee2dc6706d8e5A81728a39aE9","description":"Most popular tokens with frequent updates","arweavePublicKey":"tfkkt6lHR3lSEBNvjistpdGb8pR9UJoOVO-IuXRXD9PckAqY7TAVuDVhrcQDM56GZ_EUh6Eg_NRYd-EGW8SEQLHXtY_CM4P8563xUpw0XcZJbpOeScFcN5JdN47gq8vllOheO6-v4nRPLVabRVJqkXEqzdEwxQNYDkmPL-gxE0ziZcQRQZdJUzL5mI9DzwpPC86JBVwsBK71iuRlstABciIu8u77qyArkNu0pPig9OFQvT3Vg4OPuWXd83EhqEuN5gqVufyomkmL8X7agiEjDf-UQIfZrSYqgiJsWiVJ2aKHRhLZN17wdX51L21Cg2Sbyb3B1Roy5EgUUTdJ2MY7LnI-CTbBBJLKUHSvN67MDhj1OSBwUULc8bgVCzmfVQryIFmb4tucKvz7TRAWseXNO2MtMlggXa42Hx0sOTopbFTmT_r9glRLYw3QLzyJVH7Ltqr8QldoU-VMWtpo5cmOGh8jwVknSHqWNURbRCoDfAuwh8lpWXBjL_V8haaY0OKFT9Lpi1VW8o4Kfx7ED1VAnLcpVIoV5CkPs_L0Qy_G7XpgA02OAbJH2KvwxZPeSSymdupmr1KMc8iGz5B4a1HEcKggk5ETFfeGz5r0hDha3dwDj-dOv1jbADcdgk7e2xaLgw1CpS1XEHhAnhBJgAzJDJpcHKrxPkD6cUc7FbnsBCE","ecdsaPublicKey":"0x041d45589c5055c867e857d8437e7d5745027d0a455801bc78cc856840510e76d8ffe578296a11a03e744d7a953e0f1e36c3a93f74268859e480203ab4d2f5718e"},"f1Ipos2fVPbxPVO65GBygkMyW0tkAhp2hdprRPPBBN8":{"url":"https://redstone.finance","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"redstone-avalanche-node-1","ipAddress":"0.0.0.0","dataServiceId":"redstone-avalanche-demo","evmAddress":"0x3a7d971De367FE15D164CDD952F64205F2D9f10c","description":"Most popular tokens from the Avalanche ecosystem - demo node 1","arweavePublicKey":"nehHT9-CMWscteR3COOU455AmDI8VihUPG05kDryVl8wjv4iE_7MttV2rz3MTIicL1BNDQ246EnyIL_4qsqu8a_B3dZT8sVdfOtHqh48pDgA0MJ8ifFVUtyabr3D2ZSc2M4re79wm2SQ_S74ZNHV7zBIBS8pUHB20TfrKhrOWi-W0hfkxrqz4jIngXIPmE1ycYbaj9OHSVRFIB-EZN-1LmLZuy2EAAN0nOqJ-aYoblcGOu4WfZDpTXTfj-6-GRRBgeHen3MYnQuDneEYYrtzoCnimWGYrqRnpM654mJTW7gp_NIqLnXn3yG2aS2pbhn1_I0CavtKuE4PSACoP0UwZaGXEtanIaSuMDkeRdu-zhrr8yXZSW1inWdC0lhWPxAhzTYWQ00_OD6oj2FUtbXbAk_F-aPnT1Teb-LcNn6q-HbHSeZ_VV0ge5nn3zvBCc77z-Qfbgyd_a7dNwfy8sVkQc4-gvDJIftzxVXbUWnc3ipvL-PHfLsajg5Jkhteuvf8bIS0cNFS5u9pu3qnutskQxSymPzhkVmSyMWNe48Xp3ok4mUA9SuWTb6AskyoDVR9APh7JNDgeYINctgduqawzJQFxcVDuoW-1b8Gy79EYXW8yHowpAaDm6eYGTPQjnMpttThZwFiC_81JTXHXmDneKm677F2kO-1f6o4UWTBOEk","ecdsaPublicKey":"0x0455e7c699a153e02de0e6d3c3dcdb34d1e57a9456205b0e124e2cac29b58be83c4faa2081d39b38aa3c41fa3350f50dcf87d40ab695c9c86709040d39d5ba9be3"},"6bZ3yxPYy0LHPqo7MNqw0PHTeIM2PR-RmfTPYLltsfw":{"url":"https://redstone.finance","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"redstone-avalanche-node-2","ipAddress":"0.0.0.0","dataServiceId":"redstone-avalanche-demo","evmAddress":"0x3a7d971De367FE15D164CDD952F64205F2D9f10c","description":"Most popular tokens from the Avalanche ecosystem - demo node 2","arweavePublicKey":"TODO: find and add","ecdsaPublicKey":"TODO: find and add"},"aw9F_2R2ogYPnM66TDsW1qtiiRflRcgZQG6OLySOSZE":{"name":"redstone-twaps-1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"RedStone TWAPs - node 1","dataServiceId":"redstone-twaps-demo","evmAddress":"0xAAb9568f7165E66AcaFF50B705C3f3e964cbD24f","ipAddress":"0.0.0.0","url":"https://redstone.finance","arweavePublicKey":"sa1_cjxXdrIZgZaxY_L_UkZVf7eL1Q9WTTFrvc9FuRES1ZXwZxXO1QTspji_KboxN54Z8-qFAFXqlun-dgYgGEoLOv57RgWchinlmMHb0QVp2WREe71cSOdioaYfmBhW7eQS8YbvrnFB8cUumdZMOI8UJ6qsBrWOFSDuhPXTdUd2hNZ7mQ9PQR2MMPglZAJnwl36mAb-kaa0cK5s6raeR8_MT0aSSPHQrwyIuM4kOBMvLGEH9XE4LVuNB581Y3h0gXEE_Os7rlhl8BpowkjZM-ZIKK-hUuco9VkjfooQC5CgBHAwivm1--PlIpNa7vtk48cEOkvNoEd0ixN80wfQ2YNgpNFIOV6InnRYyrdPuHBRqE9pCQE48e8VWSxlpgjCiT-bveww42RhRsw_cjVBFHHwMljNQ4bNzjPZLvAaADvSF_ViV4EBpCiqrgj71eyTb0xpUMDSNP7Ae3HcUYPEVC9-n3GjJCCz2akc2zBRxS3zVl13bfApg9JCKzS349Dyaeq9bW9f46CN2U87zLDjUUTJFu3904UumkePlUQjAyMO5YIooChmdoujNla3e_EN6j-SwwjnM3LjDJwNCESETZUrkgZ0Arj6qbENCuEbQLDYqwT7pCJMhXIepolfbloLNnTPTbdCpzyh9pmXwAHokF3hxwSdAzBH11vDSp6ZYvc","ecdsaPublicKey":"0x046199ad0bf504566f88ddae9910277a3cd4989284bd0f2e3bd5bb8907faf86c6306773953fed32bc604aaf0cf36df56acaee285c83f242bc149ef5006b5290692"},"5ktkAKcy_tou22r4eijcn_Xue3j6Rn9e8JckXRtHe8o":{"name":"redstone-custom-urls-1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"RedStone custom urls demo - node 1","dataServiceId":"redstone-custom-urls-demo","evmAddress":"0x11fFFc9970c41B9bFB9Aa35Be838d39bce918CfF","ipAddress":"0.0.0.0","url":"https://redstone.finance/","arweavePublicKey":"wgOVFdnHwJVzj7sfoD0F6ndB3Z5HW14LGre-ovDmvAiZtSGcb0y34qbpDZwDMXDV85kxPvTS8xB9gwuJxkkC8e__1wSDZeB63NyMgTYyx4lx4147XSb4dSnMSakgCbFjwD-0SBLFDYBZUusieGGlinx3l-OMAcQOAPiyPgJiVt6ZCBavY7UR4sA8dA4Ghp_m1zrTC7SAYTZlVat_ZLzs9lgTRmJoAlKxjWtGRmtOQz2_ndnxY_5qP59-GdWu_ZOrYBDhv50eeBNbYibiAMZpJ3UiqAt_p77EUJRdLTIHQc6WI5cD5RNzphD3XMRaC9S1iHIUo4fEh5HFbt1V7OLbTMtAtjyXF_gAtCbPIcCMz1bH1Qcw827QO_jOMFgv42m5VzC4YqPf-M0-6KoZ3AM2b9Ifkaeg_rqBCm14jHjPiwGTzdojjNBzG45Jhw8lmybWtp3JdHa37bbKzmazQnD4zTp_hh1aQRvbXYfbaFsVINPdW66uqICKfbRr_krjEyx_Q9FX4nPe4Gg0Or1gn5bgEFgykxCbN9G6ol59pdT_YMyuWPvrR7tH8SqGISLJWI61dSqg4Ook9EdLUmFP1JMOJCWF3o0EqQw61dFcJnawGEkt7ilT3UVmq75uX1cjFQ3nTro6h7ck96PFXQfXMVWV10KVyWpQh9KybZqmY4i6Vxc","ecdsaPublicKey":"0x04c8487327833fd187c99aa2686097f25f97e0e7856e152c8be66a1e13f8fdaac482da9375191ebef1ee5787ee36d8618dc78bdb8504608d1d5cf79aa7e01a33ee"},"0Eu1WDQA61S98CB7XEQ_9SHpy9Ux06rd79u8jFuesjQ":{"name":"redstone-custom-urls-2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Redstone custom URLs demo - node 2","dataServiceId":"redstone-custom-urls-demo","evmAddress":"0xdBcC2C6c892C8d3e3Fe4D325fEc810B7376A5Ed6","ipAddress":"0.0.0.0","url":"https://redstone.finance/","arweavePublicKey":"9sOhBBp6cfHzKoFWzbErLf1s_7VtNVW3MNcKb_9gAwOdBJKplP1pv0VKyQOQw-e2e1Y8kZSN1rTRvs-4lrINJh8a0MrruHRD1lZBhuleykiz8KeDEJux7WQZ6G-2i8MC3RcGjKtUKeGJgwzZFB8GkT8OkXAhqWc3kRdbQzvLR7R1qp4usn5LSoKBO2pChQs-K_ruqh7wwLCr996XXbYIPkGpQaaVf00IXX2ItAvYd4emKKVnKnYOc18TN6T19ur6-KCz-23w1-QuLzK4MbvBeHJ-Y4FkahPRLeAeZmhjdNjMAXRcWkQMETmex0Tvg5qDELo-8BXYbuZgPQO3ea4TjPixHaAdaYach6fwAfG4pDboxkzoNrQdHjuPUnEhlOGRRGPNcqZPxVZQ2nVVnnoLcYq1pcCL6cPM1-licGeG1P2EV8Uo9P85UALn71wSdvdE2C3bWnmI-BCMiN4xkdX7_kcv80D7ZSWQni4d6_7l7JgXTvXs6GISvjpXqUcoUBohabzMixUFG8I3rqsVxuWJXQtmLko3kuP-CoeRyQOZk4dAovhlJ2MM5L6Yi2FjM5we2ApGSaC8v9dhyVWIrN87s8lQdgeOTycFZL9UoAi2uK57pkVlkgkYkD139ERUlRBtZ0XVenQO6lAXhYjxK7AaW08ZfkfS4PrLWzjNQ8BBIZE","ecdsaPublicKey":"0x04feeab427d82702f95c9d1727e47c823c5841ea8b0864607ecb637ff4377604b8213dfd06628d01e624c30dfb20cfa0296be7c1481ce994adb6424d1a391493cf"},"OxQ-vLXcwTZdcdlCziC95duFylo8Aj9xBJ4XsC3xlGk":{"name":"redstone-arbitrum-dev-node-1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Data feeds from arbitrum redstone nodes - dev 1","dataServiceId":"redstone-arbitrum-demo","evmAddress":"0x16883583647260AB2e2BA63c4c38D9807Fd7296e","ipAddress":"0.0.0.0","url":"https://redstone.finance/","ecdsaPublicKey":"0x041aea25f013dee918d88063daca2d0113fa41a95b66440d8d8edf09a3d397045f5b9d391c1e50e6998d3b2f95918899e382f444714e64d9fd689c92d4a2535ea1"},"LtVolyIqpjhCr8fw_ue_-Y9xaH5IURpKZclyJbsu4SE":{"name":"redstone-arbitrum-dev-node-2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Data feeds from arbitrum redstone nodes - dev 2","dataServiceId":"redstone-arbitrum-demo","evmAddress":"0x1053d519Cc8C8cd7e53FecbFb13B6F0ffbD4c8C5","ipAddress":"0.0.0.0","url":"https://redstone.finance/","ecdsaPublicKey":"0x04d0f2bb463dfe89778fc6fe68ed6945bbf13f1391369942d78607cc4eac906aa63d082caf6c81c3c191daf4bbb7cfabbf5fca1ca762e02529cf700a15ac0cd828"},"tTTthGBknPG4MWH5y-zDKO2dEF3Fxo0gPbzV6PLNlNQ":{"name":"redstone-avalanche-prod-node-1","description":"Most popular tokens from the Avalanche ecosystem - prod node 1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-avalanche-prod","evmAddress":"0x1eA62d73EdF8AC05DfceA1A34b9796E937a29EfF","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04ea48ca25db5d352ec62c4f92e8c115068e92a327f3536479a0185ec6e0f8d26db4409bffdc8c6ea898743f908861a47fdb4a52e44d129a56418a1c08008fd425","arweavePublicKey":"26hxzuODmUGbc3c52ZFz1zLeKdasZdcd2EmcLBl1PNGD75S9F5J4a0WDLeklG0YZEIU25besIa5bvinF8vCp_ebdJZUnhvheQBv_0-aoR2DBBoxe5Og942NMLEDzQl9mSP3y4_qGKnf3XQc4tzP5C6HRDI3b8L9Is4sAckEVaR5NXVAoOsg-YST-2g-Uoqkw1-ZavjL30ABSDejQLNRyZ36uzxRe5PzXtG9Oy8-t_Tz5SafMnzb68dbyBTCD2172fjxP8pXsIS-a6fNvMdjIR9BKcGHXh2_xvC0-TeR_48HOw0UHLIRqW6C6XkgWLz_DDJdVuv91f6RA_-BJPmST89tlI2S-Nma4XOZrBAB7A9X6OMoiHZfxKH1b5qs3UuTWBJgx5A9GEJ-urxYAfC41-WvfadlRFOPkgtS-4rwnq1u2pWj2Q2jxyY7O-Pj4pZSNjJe4yNhHR8mbgm58zeI_mZU_Y7RcH8W9IU5RClfuaBSSJ48GfkTU2cXYIr263heAblt8pcRfNbtEw58iWtJ7wFeEgkcsyi7A-1B1o3a61xqbH3wZ42qAMe133AGXrdYHoJpVXuxk8Ei0QUYFdrlkwCCzkALG-GYavaG_0HAg74KIHsNEvmbeLpl-SDqQFk3t4_DAsTEKNbjhGX58SRFgQ15oyp_lEIC6JydNHwDNjq8"},"azkge6PQ_40JzMdcgkpj21jxhl0JaQg1o6yPSCekJ4Q":{"name":"redstone-avalanche-prod-node-2","description":"Most popular tokens from the Avalanche ecosystem - prod node 2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-avalanche-prod","evmAddress":"0x2c59617248994D12816EE1Fa77CE0a64eEB456BF","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04f5f035588502146774d0ccfd62ee5bf1d7f1dbb96aae33a79765c636b8ec75a36f5121931b5cc37215a7d4280c5700ca92daaaf93c32b06ca9f98b1f4ece624e","arweavePublicKey":"uw79mR1O15fps5uWLsvMTiE65cAzRJs1T3uvdmEksGINCsZ1yxJJhu9PYY_OniQEl-Z3JZ1cF42Vpwxaz2JF_lY1kPXO72prefyF4ew-Q2c3WgHg75nODMZ6Xq1xlIYKfEetDvEX-MhIvm454TnHOgbvmZNyi54XT5SNnmjvtQoEfKeJ1RRRXcOubt0NgDDpWbEmvQTSFlUT_m14-H0gM7yHT5C2UjS_wCM41THFs-Aw6Uce8ROKy1rAznAI2eS3O7t3evI4f3qHQxQXuTOOUqGUn6A2Oeys0CJqnb5bJrhk3j30VxBpotDwAyOLfaLB4NEjAkuBxHWIzI-34RmIgTOQEmZ3e4cOu7ymYSx2R92z-59bOleIpfzzmagTYw7nMxbvEyb75U1B3Mz3iK-YjY7EHOb953l_QcQwqhlSqFNTXjbZgchDD1GrMULolGh1DFeUflTHg-s6XGi273Ri4hhTyLDFQTUw18J39ON6D5IAg9z6PoyTOW1MjvdLoeY3zVXH7NGq-bmwFup_9v3gd-h7ZCnnu0qWQzxDepBySA7fIo5FFAwL7KoUOC1wnc62rocwlFJ3J9vp1mvFUpkSJxCOtYR7xLEZhcMBxnrewcbx5iImdPx8N3M_94D6osrKxxmH8GwE5RScsW2ws2jfruNhIxgQkY00d_q5HZ4XLws"},"WMUjPDhwoYvDqw5BNAaCt6-iLs8fhzwC0L_rT4lTxFg":{"name":"redstone-avalanche-prod-node-3","description":"Most popular tokens from the Avalanche ecosystem - prod node 3","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-avalanche-prod","evmAddress":"0x12470f7aBA85c8b81D63137DD5925D6EE114952b","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04626f2ad2cfb0b41a24276d78de8959bcf45fc5e80804416e660aab2089d15e98206526e639ee19d17c8f9ae0ce3a6ff1a8ea4ab773d0fb4214e08aad7ba978c8","arweavePublicKey":"5f6on6vYsq3Qgp-c-yuV0SRzfjKHaRTcfKNCsXnB1dkfKHCncr5gFTIT7244Nco413xRMtKxmU7-05Z4cRhVgq-zlzdRFj-7VedtH0WlJpxILSevGILdAcklt6K6q2DDZWmvNlbCIXfXYum_ajNo41toc1FXq-f5AXc3FJEU1sWLxwAfDjrPvEdj67QlFAIvviM_uwATmjWyVTk48CLec-53_nsf-cGA3euLkhozLswTSEs_Mn9T7RSRVZ3VlpwGFhvzwidKclRsoSTUJGV_c3AsRfu_zRsURxMz_p6UDF1MaSo7RP-NgupW9EQ2itGVTMcNHKalT3dKeMUHiCjnxldAkZCjOzfL9t053R_Zi6pXJ_fCD2I9ysZgp1yL3yJyfbGg6uxgNIAeSo8epMZQzXJpFxKB-VEVWEFic4loMX-wCYpulMp--azq7NBAt5UPcFtqs688Ox9CmeCNrMuo82w-1qZCUtwU_orLo8K7QSwPOmitd1pUVuCZMyFL05zRmJB3cxu-PCncpiqVN0g9v3MOpGa5WVCNHNKAXtuM_y-6s3XmraBsV21o0Dpc_sxX2BU-4WHmkToH9jfHGVozMiNCM26F9cEdFy4ptz8eOIuYgqhfksgfw0zB3jJwBwPJuDqhH6n-5SqysyzOkzWAzm3reVAEXuj1MAUx3C5qScc"},"POU2msUaCzhDq32_hSsKrCH37hHlUvbqfK0-Wjuz3Is":{"name":"redstone-avalanche-prod-node-4","description":"Most popular tokens from the Avalanche ecosystem - prod node 4","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-avalanche-prod","evmAddress":"0x109B4a318A4F5ddcbCA6349B45f881B4137deaFB","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x047cea60b650ac5e72ca9991cd3c365c17db58cc6c0f385af0b05056a2d6068480093b603efcb47410e8092d60c5b85d27a3e43dc6ddc4077994e6eabd9a8ab9cb","arweavePublicKey":"2IQy3vmXQDDGJRXK7Pock02VBxtoVR7HNXMAv7QugQkZJhEYqIq4n4TANbSo0JsMVDg0NsqtPjaRSbStr-guSlvi9behNVOj6HEzcri6YMXq80MIOw8FrCWTp9M3co1mcZS8nGE82MCK9PYa8JAlVQTnZ8ahovGT39Qc3K0q5hgyR0a6auliDMAALtaPYfH60Kt2IwDlYv67UkTjarKdbQG7LZDMwdG_0PIFpfbgzW41cxcLymPmnHO1UY14UD-HuyeMclx215MhtH9RcfCIaTZZAxpGcTU06nCxyqNiff7EufaahBg5e1D4tl_3nBzUOs4OOvfk6nDts1t4_lDO_KtdxeLSp0ADLBTMZ68TKqx53Z5Rlo8PZzO85CEAQVsKb3JX-dMl0BvoRzq7lvkxo0916YQUJQgbl7ryO6m5kuekk3j6xu3ccLDdfeHmLbnfacHBoRnPbJRXM1Yx11ovsywdixyAqLCf_Gr_gGP_Sb4TunN_-_M2JVvXKsK70TtO0AUWp6nXUiN_I9dCNS3f2Asu4yWxw61dXpAiBnJEHBEKY4ctflsg1JhV1abLOuAW7xd4v7mt_XBkEmz9zNodRQux23aj_m_79wucbxkq04s3WsL6NmkoRPJ02vDdUKYUHZ7x4JkkLFmdC5kI0P9NzOMkl1s5dKAF-TD_PFVT6R8"},"9QvwJVg8PapGD6VaGPffcYajExbnJWG3HH5hG76-5xM":{"name":"redstone-avalanche-prod-node-5","description":"Most popular tokens from the Avalanche ecosystem - prod node 5","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-avalanche-prod","evmAddress":"0x83cbA8c619fb629b81A65C2e67fE15cf3E3C9747","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04a66e3eb25f4110aa9f9cae8864b39b249568c094123737541e897d924253c84279bfd0f500e85f75a0943c41ca03c95fe0c3c7339e0499b5d6993a3f580aef85","arweavePublicKey":"7RqQRi3ft2uHow196B23oBCy8og5BEe_I-VEJ3vb21hTHy_ayICIrc3FOcrjJ32i9ExWlLy9EuqsqWCczk2G34OS-N6mn9U7TlxE9BiqNydGCC7nEZ_fYj8DHPCwr6IEEWe-47uY5wHQZPstzIoAN4_zEKQT5douEctfZCaT_SN5-I9soj5Qe7iirpijQmSMfRVLvFQtVNqM_GxJWE48uYzZ9owUrYwUUvxgGFB9EfQi1dVjxThpuImughyB7KWc_Qv226TSMCLPLD3nbtAmWBxIM5SCF2nWSScB_-rGNiugXil3QZKa2CJ6zgXgdigGlufdJkOfN7DT9DocfutUtjN4Z3Z_FeliiWs-6klhYUP5RdEAZrF7Kf7E2fvpijEfsDbeFK2ZjpNrNND1F6gLIzfC7kT-bBpRqpkRQuP2Bu7O3fgnsYG5EF94KwCBeCwB3MYVW5v0S26SGRtvN_qU6knkIxiOBMsTDJaFeEKfRtW7tnLdMCyM5xIJ3Lzk566TeiOq4ivmtMRs6PT_8cN6B1crqYstuRhoYPTggIiO0WJdIKfbOMHRXbfSwgyXsvADfoEu7SywQtWnKAG7K8tOwIdEl4GJb-6yZD__Z_jpO-oLFLSszDxz_Fbba_gU7U93MwEbtMfq9Sekfqq9Syl98D4KR8ZtJdgkQTatUCc4Oj0"},"HebMpM4xI07ev3jbEWamFNmRxu2ojflQfh0b2lpjFoM":{"name":"redstone-primary-demo-node-1","description":"Data feeds from primary redstone nodes - demo node 1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-demo","evmAddress":"0xdE13FdEE7a9B483129a81794d02FCB4021069f0C","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x041c320fdaca2d381101d85f2e0fcf9c6d6ebb88f2a3b71a20ecf229c1cd0e81b541d6960b58666fce5abba84a460590c72f4e871d87b451f0b7823f98d0c41970","arweavePublicKey":"sfTEXB9ljPagrv7XodJlTs0fM1pQdsCZ5iHC6mWsFpYgNUIPX6vkA4yoEjGh3naoLz5qKYtML3RIyI6z-syI2JV7TFUyEGunSDyzWg7ZZDxeG16RwpUhsPSJ7z7eSA91YAVAYJOqzgcOI_RsdgAHrtH64apLp_8uJcndJ_oXpEuoKRO2SjE2wSnwkHodHK6F-koov8rNY6edBLfmfjtKzzS-8X8g0oKSVzNdiov_WZ0UlUelsVhd-KoC6S65QT1yg7TbVRQP0ZBhfMvtpoZh8y8ftj9VaTsIaZcu77LR1tc6zCLThZAbclGYPM1EWxJ8vUDp5XYSxF6AvTFAj2NpvHDW94Mln3ZYTv2a4UobOruO9rA4npduHlo-5klgFxJGVjGsK-w18pk13KozmW5P_DZPwK_5rcKwvUakUYY2OCF_lismG7UiIPRGtQkoWffaZDfuMI2ONidtGskqFBjgySFsdMt07Wt10h5WbLI5xmUoBpdrxQarfzECCyQ4QT--GOmtaS8G7PUbYMtpgGk4nxZnqqzNidRez_0bQLQbsIMMej9HTNvkiwW9w5e374Ek8JjiCw77yUcE2e1vUAr-IqrHD5LFSmB-H5JM_GoIGhTEjYU_-v3RkeiklwmuWBPzLdyL2mMZPANacW6cOWt4g6DyXTjRKSLY0UiPuGsJT1c"},"-qrcZLkqrgS9cNhLvy0c7gzpkGlAgwbZ6C3_hk2vvJQ":{"name":"redstone-primary-demo-node-2","description":"Data feeds from primary redstone nodes - demo node 2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-demo","evmAddress":"0xad05Ce43E0bCD11345f08a28995951DEc30D5226","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04440a1d2f497db99d7282bf6ccaf133995ed05f992c177c1eaf7b861a9e64261d1da123bcefa6bed232755197fc5082d42696e72aaf42b45771eba336d693b9b3","arweavePublicKey":"1OgIYqYOFlYr-Yo_cFdnWisxRv8B-2x2zroc0Kcn6_f8yiD7yZBVFQOBOh-kVfcmVrCuBYPywvJevmMgIkg2t4xOsoG0y_liTYAYKjhT2tiV8xta1ykq0xvLiOVOQY4g7GCzcCV-ZPE9xc4bI9ozYnpS4NRjJM8_mOnS9I1lrefx7pjHsrTyrB3YGmmW2WJm9o1MS225PFzDmPSEghw3jlVsf-KtDXqxCCpRZGTI1kKZJ-Snm9k_19tK9MHGfVGsmT8pZJjsJmLJXHrLl1KVgDXsjxxcU2f6ZycSj5imP024Dc5w65aV1JXEey9a0wLz4y1DpxPbrUN617zL1-6xA3PyQBbbI2tpM808UILlYAYWZPBeS9-87j9Abn7wDtBuqGGribdYH-KT61lF14xozCWj8SwKk9ZiMsuk8XhTlmzWa2_xwMpDFX_GVwyueZWR4lx1PK3AMWOVfITj8xU9iPHA2msL9AZ9Hj1R12k0DXGn7pjHwUgSNXCe46nIBbjEoUVtihDGAddwXAyhBVSFriDsfqWDftYEigGbNccQh8JVfRJraP20saJLlwnFL5rYhd1nSFzEwi3yIFA2X-PjudxWHa2mTGwZYCtTMkOa2E5ucQUp8eA-N-fQJF1YNNeznv5IA-yN4e35zuVUC7dNq364bUogDAqTMojRFMzhpas"},"R4ih95AvybIzz3uKuEmpBee17J73CGkSk4bvzU_IZ_I":{"name":"redstone-primary-prod-node-1","description":"Data feeds from primary redstone nodes - prod node 1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-prod","evmAddress":"0x8BB8F32Df04c8b654987DAaeD53D6B6091e3B774","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x049a0e6cada7938a0fc616578aff2b11337d90ec4e99e9fee95e57e9d8371562b31698225fb73c666ba586842b913e67ad289f374f7a46fc873342f805a8683d4e","arweavePublicKey":"nLzSke0nHxv_kp-NVMrjlXQtVZpNlFyUybEIVZx17IAwIBRrqNJBJ5pR0_nbgtJTwXg32YiLs_1ETBaazj1HL22au_kSxa5zkHsomEi7wmioAYGN2LGcaeUWlrPq8zwDk5IniSHkGdJ7wuCLig2OyVoYpINGvRchy9NOpWylAyJjHdcOkEDTAFHKeKWAs0SeAo-VSr_V53yyRSQ-ecOpcSAMWtx-jOkxgNoMPHAX-79arV206Q-sFjGNobceNl-NhCKOEOy4BjHCQm0XVUApXQx_hVrej_j-DE3QbCGCcgskrvpYFrB7ZGfCVYToH3GDe-orbCH_Qa9Q88uIR9-hIRWnTcES3RDdb-72bvVdJVyvMqKWXdtjB-3aYS6Klyx6H7l2hYdesQzEv4IqOFctoyUqq3ECZkW5ZTZzo-vg2QatwquY12kkOB7PAkZRYjc6HEoWnZy2qv4M4RnpMiYpgjww4kcryXBBZqy4X-xAkJAjWt-XDTpIWmLBtgu9plZiOhmqgARyMtuF0NspFZCu7g5PfeQVo5lzv16CPXimXpPLhxiVoOxjSKHTeuv0xIPA9cNO_6K0XTSdUYlzkDdcnQIg5SKI3b9kE3JSkiVjjk0EfhZdrBaWolS__NNEBzqjMU5TR4bk9BQ5CTOaqXDIbCEK2_GMaJ6pzjGPfRZaMu0"},"WM9CHZ6CKf95z47krdOFFKX6kuOusBlyIVSJmcjdrEQ":{"name":"redstone-primary-prod-node-2","description":"Data feeds from primary redstone nodes - prod node 2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-prod","evmAddress":"0xdEB22f54738d54976C4c0fe5ce6d408E40d88499","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04683f7100d67fbaccae68db4d146f7bc3090c5cbcb1351e333efd58d42f609ceeada12b0af28a6e789d6edfe25fe784dd1e86798240d4cee9f60e56848cb55965","arweavePublicKey":"yE4SZn6OcwBG0Zb4Awm9bS6rqJMcy3ldVosxCiI7bwCYsRjA_fArgtuDG9b-B6xxEC1pY0TBAJSN3HKo8XIDGJNh_xHoA__Yi_Q4OGmtFqGWbQmP78piaJ3vn9nR-vwFGPnZPLzKinzKxHKNGH16gkhblszX59oUlUQP1o2slFmD6UsJX-K3LqWSN5u_1snW4eNpyPY0UbtuNvVvSNJeaT4D7zPYhZhpt5WrYZBzmTq8HoK290wb1L-Okik072aw9XMrFNBiyyQd0thAAobferTm8Ch-lcfigwkaHDEtwD2GoJIJZ69oTX810OFz-m4JomEBck4B1dSou3aPJhjK_bnsgLztiG6N7DHps7XOyD6vVo2rJpYWMPmxLtWeXIgmNSDjypUuDH4hJOT_kp3FO5YvHBhL__RY__wNBvJ5XizilD6Rrom3PQMKmu4QWY84JDE7L1QHrwsEo7UKYpT3aNF-rrFiYYTn77fLN6iKkzouLf21etNoTqRAo-ftzTiiUtJ9ubBnYd4ne7AKRzZTS-dEOImA8w6MGjN0rkqaI78ihgIO9Zu_BClOZdWqRg3j-nwyzGcOcQeKjOU3HAWiotuioLBy603utiC7lRl8g-0VprAZfWOpJhfTX1EHyoI3AAY92joj4U_Cig8-9tCRh06BN3HaNobdQgkLeEk5KpU"},"9syjTFZp0__CsqnMjKEo6sjl6_yRWYm7TQjcD0hFEN8":{"name":"redstone-primary-prod-node-3","description":"Data feeds from primary redstone nodes - prod node 3","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-prod","evmAddress":"0x51Ce04Be4b3E32572C4Ec9135221d0691Ba7d202","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04490f08821dea02d23683f170459aa6317dd65b544aac1df514f2e657f87ac00b81757edce3e78785e00dcd92e2dc8ddd9a680dc929a0c91062d87ae000a217ce","arweavePublicKey":"uFmwr5_2RAokGbqABO6edwcbsVhctDmKWG-velfxBvqjGU9YUc3QIentdWPBEaA4xcXlQC1fz8-woXEqqUjTjYyDpZ_1FEaftIVgQFyxzT2OW--8Mnox7uwqvmtAZLejxRibj4YYyqxO81tF4m5MVpgewoBBep0p_nCsBtN50iV4VtG6oPOOiFa9p1Hk-h2ja8K57qfn3Pxh6g2jmk2FVCo9JAgHCoSat8IT_QQ9BRw4pOTyZbTzM-7K28FjKHJqaQ8fRK0bZkMmzt8LhXUZVQCqHWeaLaMoNFikDTWZ_ia-SEr6_T_QlybPoj07TIwkMpVNDMAFcmltHBoLtNDfXG3fyDAQe9fZPp4H4ER5VLi_MoEB0UM2feLZNIpiwSCWEtOUvamBaCbtRBObdQZPphbP3Iof2VZvavnwHRE5FHnLFuXpnwMPmJADDwIdetUxNKW42QGl5nG43IC18ufYBH-hV6rEdlxd5hHPqw7wknGQ9fW_686Z_qE2U7Lc37OO0a1tT6877IuOYpO8GGm5YOS0lc0A7jP5RBO5EWsS_8xZyKKo2aUP5f39-WZid6lRAtwseSvr9oJbRLS5jfCGb9WTJ0VzQEgCpcp1eVaMSDBvXb-4p6lOr1Z7OD0loSHiAsNZWUdAqmRLAZROZsXI6r_z5J_vrW82ZkFTRIeNdeE"},"4dRTLZeJPaDMhGE2jUndt-3KIOQxO6Y_BCV-3KIiPhI":{"name":"redstone-primary-prod-node-4","description":"Data feeds from primary redstone nodes - prod node 4","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-prod","evmAddress":"0xDD682daEC5A90dD295d14DA4b0bec9281017b5bE","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04a221496ff2436da121796c11f888cc4e2155da7e36bd1148c9466fb54627f15e42d4cfed06b1570b7ebe0c589acf91fd314cfd95303c9894c0be43432aba619f","arweavePublicKey":"3gACwmU3yQTUU4eHYWvWYzXh96royDi3Uce7shiBk0TeK2aaKGqR0pswjbWLUF1A22JmfuD-ItrkKKAfX5Mhj7GgFrDcPA0D2soA0hRQGh5qkLi4iSxXb8BdD4suG-dN2y2_Zn1zMmcoWHHxgxmr-mtD5t4H1CrIxFF4dLQWJ44ydFwTmIxvVaZzSYA8sC5z2Q_hIzr90Z1DdEJUcJomXbKPeymeuVeKxCfPab93czr5-wm11I_sNx9dTTzRW90_jiZ99aSbSVY_R6jWQ2vAfbCqoHIqsHEk7Yc4WNjXlh7aZMBi5hPW3zrnN-ZnDDLXgBu4KrBqAFH-8jL4sfwe51ifKkosRu0DLx0kItpp3mgkKVUcsR513kQE49bxmFhhy3dbyUoJktetrWqg6iMPHMMB4ybXHsoqOHXou1vPtLTCxtNvTZJvUes3v47fs-04ThebpyAPPEDrVqt4mNCYzapvDE-RgWrnQrKLAIbXJspcggro5u_rdNl4hSDGgmFJhXTu2AIVoAjNTk9ARXtgo4K8RWcQKjZ8qotq30NNwqNE9GVk2EEJDnj-Jj_1_Dtkd0jozE0VyjaA9eT5NyZ2s1tfVS2pbNCC18sezte0PGeAwD7EqoJoYxgbmX6MPQhfyanSc3KSYi9fi_YYYmHT0n_uCUy9QR2Zvz5895QETB0"},"wZv_gFZgozLm2xjUaMZPzvgr6E4VcUlRZMXZOILfBXw":{"name":"redstone-primary-prod-node-5","description":"Data feeds from primary redstone nodes - prod node 5","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-prod","evmAddress":"0x9c5AE89C4Af6aA32cE58588DBaF90d18a855B6de","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04f23aa199aeda6e55628e0ec88194c47713ba260898aae4483fb2f166c7e29b1664f817922059736358de71bdf374b3354db58d15f928a6fac9d1f61e284019b7","arweavePublicKey":"2p14sG942MfNwRQnPPF78vdxXovnz0hSTUYiSmCvPlQHojPQyDdfX2fbML09kbkeq8TNQel7BzShDVDpfhM21lXDQhvW8kQTSk6I2qilZIbYRi4i0omgHLw6QnUOGPBdxUdbRSq63gH5A0aR_ATPgzKNwSZpViG3CODgOVRUWtzWlaHKGx3D5oloKnS9nnJJlZSh2sbDfq7MIOlZEHDpunERLByLlsxi33oj1YsrcV2rP_tUUDbuDNLWhwHorAjZqDKmPP0FEy38oABrB-NbDNihPs06V2wMNb4U6tlLiEcsfNTagWpQ8re6K3WpK5XKBOcaOhVqcmo2axP1go35pjV6RuISCQWGGqvnyeAsKdGjDANtSk5RYqjqy6cQTJfEKrHZbv2MaiLr5EUsnzP_9u4ZCo8vcVXj4BLLDIYNvm4b_Ik2j8ZoA432u2hAMtQYZNqfencj9kiKzBRoeDQF4nsJOQ5YUHkyS_a1Vnq0KPslPbACApJZntCz3LR2Te_ZxJePM_v9O6jtX2bTsRgkjGF5dWD4OFda89mFSKn9ZBzgysMTWiJsLYnnqPVW8zIP2PjG7VgfkpEIDzWFbCJiX2aevGT94P5pTuI9AF1cyKMX0kxeDibbqg6m9LixPqY0Kdm6pOwGa1RWP2tprPoQuS9uepP1vyzJEzk6jAyaQqU"},"ckah_Yc4ZhzQbx27Lgo1Ad1yePneQdkusER_c49KVK0":{"name":"redstone-arbitrum-prod-node-1","description":"Data feeds from arbitrum redstone nodes - prod 1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-arbitrum-prod","evmAddress":"0x345Efd26098e173F811e3B9Af1B0e0a11872B38b","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x0437026448b1a69e4be9bcee0789199c50e93446c75eb697efbeb732fa3b51d130f92d6597de811106511ba39f712f8cf025b82e0003a611b9f78804e66caf46d8"},"3HHevuTyFGYJJ-nBPonvDaB5oGIZbCbZtF0CAeFB13s":{"name":"redstone-arbitrum-prod-node-2","description":"Data feeds from arbitrum redstone nodes - prod 2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-arbitrum-prod","evmAddress":"0xbD0c5ccd85D5831B10E3e49527B8Cd67e2EFAf39","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x046ecbc2bcca15fb4a44b88e85e1433b22ad09b7960370c9dba379e09f37ebea0cbc3fb9a60f39df2c4b7cd8b885717ca1dafeac35e9edc5b550d0b61c4a7e581f"},"AkT1al4MbVqV8w9LXIvdsE-2xm_moP1ARaImUlqgDZA":{"name":"redstone-arbitrum-prod-node-3","description":"Data feeds from arbitrum redstone nodes - prod 3","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-arbitrum-prod","evmAddress":"0x2F3E8EC88C01593d10ca9461c807660fF2D8DB28","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x047f0ac528b5b5f306b6488965bcd86cce263487320caaab7703171c8cf461eb692cd35837ff91d243d2972fc4c4598d08d8e1f5795ecbb1cb974087970a5783d8"},"k9ke_oPBAy4bt-Vu0_kwRcSx4HwcQl3Jd8h7dmomfrc":{"name":"redstone-arbitrum-prod-node-4","description":"Data feeds from arbitrum redstone nodes - prod 4","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-arbitrum-prod","evmAddress":"0xb7f154bB5491565D215F4EB1c3fe3e84960627aF","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04e051f36116b6bc953f2a94825a4931f6fe6e3a3f218e1dab2712a2a31fff450d1e8f82dcb3cba9dce6dd382d6b0e259d2a896f8a10947a234c08e6f424d272c9"},"7zqOor2CATpcOq_DduEAsJ_8us4FJ0BTZbMjLAH4MsU":{"name":"redstone-arbitrum-prod-node-5","description":"Data feeds from arbitrum redstone nodes - prod 5","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-arbitrum-prod","evmAddress":"0xE6b0De8F4B31F137d3c59b5a0A71e66e7D504Ef9","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04b41ed2eaf2b8b15232ab7d25458d1b2cc1ef02200ab50f912307cf832f619aadf89800ac17b1c3e40c4bebc7b4305bbec558ca5e60acb034dbb6c09273e29fbe"}},"evolve":null,"canEvolve":true,"dataServices":{"redstone-main-demo":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Main Demo","admin":"I-5rWUehEv-MjdK9gFw09RxfSLQX9DIHxG614Wf8qo0","description":"Main RedStone Provider with all available tokens.","manifestTxId":"kXYM3AezlROPoEDCt_802-k9ZxeceAWzHtrERmR2zEg"},"redstone-rapid-demo":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Rapid Demo","admin":"zYqPZuALSPa_f5Agvf8g2JHv94cqMn9aBtnH7GFHbuA","description":"Most popular tokens with frequent updates","manifestTxId":"5iQ5tPebRcdB4OjLZvaCMftREpP_P-V-F0J0WAgyLFI"},"redstone-stocks-demo":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Stocks Demo","admin":"Yba8IVc_01bFxutKNJAZ7CmTD5AVi2GcWXf1NajPAsc","description":"Stocks, ETFs, Livestocks, Metals, Energies...","manifestTxId":"MmWSoOPdKoyRlJ7Qhrvp3odBu0881Ou379e19SxDxKg"},"redstone-avalanche-demo":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Avalanche Demo","admin":"f1Ipos2fVPbxPVO65GBygkMyW0tkAhp2hdprRPPBBN8","description":"Most popular tokens from the Avalanche ecosystem - demo","manifestTxId":"erTjNqoLYB9Jw9zZXJPYxmijE5ElEhDM_52quvK83ws"},"redstone-avalanche-prod":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Avalanche Prod","admin":"TEHhCDWy-vGmPSZsYJyM0aP_MM4xESgyIZdf5mVODzg","description":"Most popular tokens from the Avalanche ecosystem - prod","manifestTxId":"y7ppr6m9MuP65Fiivd9CX84qcPLoYBMifUrFK3jXw2k"},"redstone-primary-demo":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Primary Demo","admin":"TEHhCDWy-vGmPSZsYJyM0aP_MM4xESgyIZdf5mVODzg","description":"Data feeds from primary RedStone nodes - demo","manifestTxId":""},"redstone-primary-prod":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Primary Prod","admin":"TEHhCDWy-vGmPSZsYJyM0aP_MM4xESgyIZdf5mVODzg","description":"Data feeds from primary RedStone nodes - prod","manifestTxId":""},"redstone-custom-urls-demo":{"name":"Redstone custom URLs demo","manifestTxId":"vcxshh2A0m4SF16Y4_Xv0B-NHfdeEyn-9XbkHvmxckc","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Redstone custom URLs demo","admin":"BitVOfTwSSod-tUSla4nM77sUuHC4XFcT0Zlg-RZ-tI"},"redstone-twaps-demo":{"name":"RedStone TWAPs demo","manifestTxId":"ETNFHbaIXCIXSb2mvkY6QWbfcITsFsSDd4h48PhuHYs","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Time-weighted average prices for most popular tokens","admin":"aw9F_2R2ogYPnM66TDsW1qtiiRflRcgZQG6OLySOSZE"},"redstone-arbitrum-demo":{"name":"Redstone arbitrum demo","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Data feeds from dev arbitrum redstone nodes"},"redstone-arbitrum-prod":{"name":"Redstone arbitrum prod","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Data feeds from arbitrum prod redstone nodes"}},"contractAdmins":["I-5rWUehEv-MjdK9gFw09RxfSLQX9DIHxG614Wf8qo0","zYqPZuALSPa_f5Agvf8g2JHv94cqMn9aBtnH7GFHbuA","Yba8IVc_01bFxutKNJAZ7CmTD5AVi2GcWXf1NajPAsc","33F0QHcb22W7LwWR1iRC8Az1ntZG09XQ03YWuw2ABqA","BitVOfTwSSod-tUSla4nM77sUuHC4XFcT0Zlg-RZ-tI"]}');

});

parcelRequire.register("be7oZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRequire.register("grzTa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveDataServiceUrls = module.exports.REDSTONE_DATA_SERVICES_URLS = void 0;
var $bf8b01b936a34131$var$DEMO_URL = "https://d33trozg86ya9x.cloudfront.net";
module.exports.REDSTONE_DATA_SERVICES_URLS = {
    "redstone-primary-prod": [
        "https://oracle-gateway-1.a.redstone.finance",
        "https://oracle-gateway-2.a.redstone.finance"
    ],
    "redstone-primary-demo": [
        $bf8b01b936a34131$var$DEMO_URL
    ],
    "redstone-avalanche-prod": [
        "https://oracle-gateway-1.a.redstone.finance",
        "https://oracle-gateway-2.a.redstone.finance"
    ],
    "redstone-arbitrum-prod": [
        "https://oracle-gateway-1.a.redstone.finance",
        "https://oracle-gateway-2.a.redstone.finance"
    ],
    "redstone-custom-urls-demo": [
        "https://d1zm8lxy9v2ddd.cloudfront.net"
    ],
    "redstone-main-demo": [
        $bf8b01b936a34131$var$DEMO_URL
    ],
    "redstone-rapid-demo": [
        $bf8b01b936a34131$var$DEMO_URL
    ],
    "redstone-stocks-demo": [
        $bf8b01b936a34131$var$DEMO_URL
    ],
    "redstone-twaps-demo": [
        $bf8b01b936a34131$var$DEMO_URL
    ],
    "redstone-arbitrum-demo": [
        $bf8b01b936a34131$var$DEMO_URL
    ],
    "mock-data-service": [
        "http://localhost:3000"
    ],
    "mock-data-service-tests": [
        "http://valid-cache.com"
    ]
};
var $bf8b01b936a34131$var$resolveDataServiceUrls = function(dataServiceId) {
    var urls = module.exports.REDSTONE_DATA_SERVICES_URLS[dataServiceId];
    if (!urls) throw Error("Data service ".concat(dataServiceId, " is not configured by Redstone protocol"));
    return urls;
};
module.exports.resolveDataServiceUrls = $bf8b01b936a34131$var$resolveDataServiceUrls;

});

parcelRequire.register("kQU65", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContractParamsProvider = void 0;

var $ji93N = parcelRequire("ji93N");

var $j2rU8 = parcelRequire("j2rU8");

var $hbWVX = parcelRequire("hbWVX");

var $18VbH = parcelRequire("18VbH");
var $f2e42db9876dbad2$var$ContractParamsProvider = /*#__PURE__*/ function() {
    function ContractParamsProvider(requestParams) {
        (0, $978gY._)(this, ContractParamsProvider);
        this.requestParams = requestParams;
    }
    (0, $kry2a._)(ContractParamsProvider, [
        {
            key: "getPayloadHex",
            value: function getPayloadHex() {
                var withPrefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = withPrefix ? "0x" : "";
                                return [
                                    4,
                                    _this.requestPayload(_this.requestParams)
                                ];
                            case 1:
                                return [
                                    2,
                                    _ + _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPayloadData",
            value: function getPayloadData() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _, _1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = Array.from;
                                _1 = (0, $hbWVX.arrayify);
                                return [
                                    4,
                                    _this.getPayloadHex(true)
                                ];
                            case 1:
                                return [
                                    2,
                                    _.apply(Array, [
                                        _1.apply(void 0, [
                                            _state.sent()
                                        ])
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getHexlifiedFeedIds",
            value: function getHexlifiedFeedIds() {
                return this.getDataFeedIds().map(function(feed) {
                    return (0, $j2rU8.hexlify)((0, $ji93N.toUtf8Bytes)(feed));
                });
            }
        },
        {
            key: "getDataFeedIds",
            value: function getDataFeedIds() {
                if (!this.requestParams.dataFeeds) throw new Error("That invocation requires non-empty dataFeeds");
                return this.requestParams.dataFeeds;
            }
        },
        {
            key: "requestPayload",
            value: function requestPayload(requestParams) {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $18VbH.requestRedstonePayload)(requestParams)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ContractParamsProvider;
}();
module.exports.ContractParamsProvider = $f2e42db9876dbad2$var$ContractParamsProvider;

});

parcelRequire.register("jfbxu", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContractParamsProviderMock = void 0;

var $j2rU8 = parcelRequire("j2rU8");

var $ji93N = parcelRequire("ji93N");

var $kQU65 = parcelRequire("kQU65");
var $e0285e7c86676796$var$ContractParamsProviderMock = /*#__PURE__*/ function(_ContractParamsProvider_1_ContractParamsProvider) {
    (0, $ftJVG._)(ContractParamsProviderMock, _ContractParamsProvider_1_ContractParamsProvider);
    var _super = (0, $6OZAO._)(ContractParamsProviderMock);
    function ContractParamsProviderMock(dataFeeds, filePath, fileReader) {
        (0, $978gY._)(this, ContractParamsProviderMock);
        var _this;
        _this = _super.call(this, {
            uniqueSignersCount: 0,
            dataServiceId: "",
            dataFeeds: dataFeeds
        });
        _this.filePath = filePath;
        _this.fileReader = fileReader;
        return _this;
    }
    (0, $kry2a._)(ContractParamsProviderMock, [
        {
            key: "requestPayload",
            value: function requestPayload(_) {
                return Promise.resolve(this.fileReader(this.filePath).toString());
            }
        },
        {
            key: "getHexlifiedFeedIds",
            value: function getHexlifiedFeedIds() {
                var _this_overriddenFeedIds;
                return ((_this_overriddenFeedIds = this.overriddenFeedIds) === null || _this_overriddenFeedIds === void 0 ? void 0 : _this_overriddenFeedIds.map(function(feed) {
                    return (0, $j2rU8.hexlify)((0, $ji93N.toUtf8Bytes)(feed));
                })) || (0, $3cct3._)((0, $g3d7z._)(ContractParamsProviderMock.prototype), "getHexlifiedFeedIds", this).call(this);
            }
        }
    ]);
    return ContractParamsProviderMock;
}($kQU65.ContractParamsProvider);
module.exports.ContractParamsProviderMock = $e0285e7c86676796$var$ContractParamsProviderMock;

});

parcelRequire.register("2ptTQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("2nhuk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("krvSi", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $ee1f0deefe9c685a$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.aggregateValues = module.exports.getDataFeedValues = void 0;

var $ee1f0deefe9c685a$var$axios_1 = $ee1f0deefe9c685a$var$__importDefault((parcelRequire("28Dk9")));

var $grzTa = parcelRequire("grzTa");

var $f7K4O = parcelRequire("f7K4O");
var $ee1f0deefe9c685a$var$DEFAULT_DATA_SERVICE_ID = "redstone-main-demo";
var $ee1f0deefe9c685a$var$DEFAULT_AGGREGATION_ALGORITHM = "median";
var $ee1f0deefe9c685a$var$getDataFeedValues = function() {
    var _ref = (0, $byzP8._)(function() {
        var args, _args_dataServiceId, dataServiceId, _args_aggregationAlgorithm, aggregationAlgorithm, _args_gatewayUrls, gatewayUrls, dataPackagesPerFeed, result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, dataFeedId, dataPackages, plainValues;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    args = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    dataServiceId = (_args_dataServiceId = args.dataServiceId) !== null && _args_dataServiceId !== void 0 ? _args_dataServiceId : $ee1f0deefe9c685a$var$DEFAULT_DATA_SERVICE_ID;
                    aggregationAlgorithm = (_args_aggregationAlgorithm = args.aggregationAlgorithm) !== null && _args_aggregationAlgorithm !== void 0 ? _args_aggregationAlgorithm : $ee1f0deefe9c685a$var$DEFAULT_AGGREGATION_ALGORITHM;
                    gatewayUrls = (_args_gatewayUrls = args.gatewayUrls) !== null && _args_gatewayUrls !== void 0 ? _args_gatewayUrls : (0, $grzTa.resolveDataServiceUrls)(dataServiceId);
                    return [
                        4,
                        Promise.any(gatewayUrls.map(function(url) {
                            return $ee1f0deefe9c685a$var$getDataPackagesFromGateway(url, dataServiceId);
                        }))
                    ];
                case 1:
                    dataPackagesPerFeed = _state.sent();
                    result = {};
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = Object.entries(dataPackagesPerFeed)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            _step_value = (0, $8GFUW._)(_step.value, 2), dataFeedId = _step_value[0], dataPackages = _step_value[1];
                            plainValues = dataPackages.filter(function(dp) {
                                return dp.dataPoints.length === 1;
                            }).map(function(dp) {
                                return Number(dp.dataPoints[0].value);
                            });
                            if (plainValues.length === 0) continue;
                            result[dataFeedId] = (0, module.exports.aggregateValues)(plainValues, aggregationAlgorithm);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function getDataFeedValues() {
        return _ref.apply(this, arguments);
    };
}();
module.exports.getDataFeedValues = $ee1f0deefe9c685a$var$getDataFeedValues;
var $ee1f0deefe9c685a$var$getDataPackagesFromGateway = function() {
    var _ref = (0, $byzP8._)(function(url, dataServiceId) {
        var response;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $ee1f0deefe9c685a$var$axios_1.default.get("".concat(url, "/data-packages/latest/").concat(dataServiceId))
                    ];
                case 1:
                    response = _state.sent();
                    if (typeof response.data === "string") throw new Error("Failed to fetch data package from ".concat(url, ". Data service ID responded with: ").concat(String(response.data)));
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function getDataPackagesFromGateway(url, dataServiceId) {
        return _ref.apply(this, arguments);
    };
}();
var $ee1f0deefe9c685a$var$aggregateValues = function(plainValues, aggregationAlgorithm) {
    switch(aggregationAlgorithm){
        case "max":
            var _Math;
            return (_Math = Math).max.apply(_Math, (0, $fLnyw._)(plainValues));
        case "min":
            var _Math1;
            return (_Math1 = Math).min.apply(_Math1, (0, $fLnyw._)(plainValues));
        case "median":
            return $f7K4O.MathUtils.getMedian(plainValues);
        default:
            throw new Error("Unsupported aggregationAlgorithm ".concat(String(aggregationAlgorithm)));
    }
};
module.exports.aggregateValues = $ee1f0deefe9c685a$var$aggregateValues;

});

parcelRequire.register("4FcjQ", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetchDataPackages = void 0;

var $grzTa = parcelRequire("grzTa");

var $f7K4O = parcelRequire("f7K4O");
var $36548c0eb8b629bd$var$fetchDataPackages = function() {
    var _ref = (0, $byzP8._)(function(param) {
        var dataServiceId, gatewayUrls, resolvedGatewayUrls, urls, responseFromGateway;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    dataServiceId = param.dataServiceId, gatewayUrls = param.gatewayUrls;
                    resolvedGatewayUrls = gatewayUrls !== null && gatewayUrls !== void 0 ? gatewayUrls : (0, $grzTa.resolveDataServiceUrls)(dataServiceId);
                    urls = resolvedGatewayUrls.map(function(baseUrl) {
                        return "".concat(baseUrl, "/data-packages/latest/").concat(dataServiceId);
                    });
                    return [
                        4,
                        $f7K4O.RedstoneCommon.fetchWithFallbacks({
                            urls: urls
                        })
                    ];
                case 1:
                    responseFromGateway = _state.sent();
                    return [
                        2,
                        responseFromGateway.data
                    ];
            }
        });
    });
    return function fetchDataPackages(_) {
        return _ref.apply(this, arguments);
    };
}();
module.exports.fetchDataPackages = $36548c0eb8b629bd$var$fetchDataPackages;

});

parcelRequire.register("jCh0A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("9oEZZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("c4C7h", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.startSimpleRelayer = void 0;
function $8ca36cde90b780e0$var$startSimpleRelayer(config, connector) {
    return $8ca36cde90b780e0$var$_startSimpleRelayer.apply(this, arguments);
}
function $8ca36cde90b780e0$var$_startSimpleRelayer() {
    $8ca36cde90b780e0$var$_startSimpleRelayer = (0, $byzP8._)(function(config, connector) {
        var relayerIterationInterval, updatePriceInterval, adapter, pendingTransactionHash;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    relayerIterationInterval = Number(config.relayerIterationInterval);
                    updatePriceInterval = Number(config.updatePriceInterval);
                    return [
                        4,
                        connector.getAdapter()
                    ];
                case 1:
                    adapter = _state.sent();
                    console.log("Starting contract prices updater with interval ".concat(relayerIterationInterval / 1000, " s."));
                    setInterval(/*#__PURE__*/ (0, $byzP8._)(function() {
                        var txHash, timestampAndRound, currentTimestamp, timestampDelta, isEnoughTimeElapsedSinceLastUpdate, _timestampAndRound_round, round, error;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        4,
                                        5,
                                        6
                                    ]);
                                    if (pendingTransactionHash != undefined) return [
                                        2,
                                        console.log("Skipping, because there exists a pending transaction: ".concat(pendingTransactionHash))
                                    ];
                                    return [
                                        4,
                                        adapter.readTimestampAndRound()
                                    ];
                                case 1:
                                    timestampAndRound = _state.sent();
                                    currentTimestamp = Date.now();
                                    timestampDelta = currentTimestamp - timestampAndRound.payload_timestamp;
                                    isEnoughTimeElapsedSinceLastUpdate = timestampDelta >= updatePriceInterval;
                                    if (!isEnoughTimeElapsedSinceLastUpdate) return [
                                        2,
                                        console.log("Skipping, because not enough time has passed to update prices (".concat(timestampDelta / 1000, " s. of ").concat(updatePriceInterval / 1000, " s.)"))
                                    ];
                                    round = (_timestampAndRound_round = timestampAndRound.round) !== null && _timestampAndRound_round !== void 0 ? _timestampAndRound_round : -1;
                                    pendingTransactionHash = "...";
                                    return [
                                        4,
                                        adapter.writePrices(round + 1)
                                    ];
                                case 2:
                                    txHash = _state.sent();
                                    console.log("Started updating prices (round: ".concat(round + 1, ") with transaction: ").concat(txHash));
                                    pendingTransactionHash = txHash;
                                    console.log("Waiting for the transaction's status changes...");
                                    return [
                                        4,
                                        connector.waitForTransaction(txHash)
                                    ];
                                case 3:
                                    _state.sent();
                                    return [
                                        3,
                                        6
                                    ];
                                case 4:
                                    error = _state.sent();
                                    console.error(error.stack || error);
                                    return [
                                        3,
                                        6
                                    ];
                                case 5:
                                    if (pendingTransactionHash === txHash || pendingTransactionHash === "...") pendingTransactionHash = undefined;
                                    return [
                                        7
                                    ];
                                case 6:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }), relayerIterationInterval);
                    return [
                        2
                    ];
            }
        });
    });
    return $8ca36cde90b780e0$var$_startSimpleRelayer.apply(this, arguments);
}
module.exports.startSimpleRelayer = $8ca36cde90b780e0$var$startSimpleRelayer;

});



parcelRequire.register("aUowN", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $7f12291a145ace3b$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarknetPricesContractConnector = void 0;

var $7f12291a145ace3b$var$prices_abi_json_1 = $7f12291a145ace3b$var$__importDefault((parcelRequire("3BqLy")));

var $493BH = parcelRequire("493BH");

var $kHc9u = parcelRequire("kHc9u");
var $7f12291a145ace3b$var$StarknetPricesContractConnector = /*#__PURE__*/ function(_StarknetContractConnector_1_StarknetContractConnector) {
    (0, $ftJVG._)(StarknetPricesContractConnector, _StarknetContractConnector_1_StarknetContractConnector);
    var _super = (0, $6OZAO._)(StarknetPricesContractConnector);
    function StarknetPricesContractConnector(account, contractAddress) {
        var network = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "goerli-alpha";
        (0, $978gY._)(this, StarknetPricesContractConnector);
        return _super.call(this, account, contractAddress, $7f12291a145ace3b$var$prices_abi_json_1.default, network);
    }
    (0, $kry2a._)(StarknetPricesContractConnector, [
        {
            key: "getAdapter",
            value: function getAdapter() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _, _1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _1 = (_ = $493BH.StarknetPricesContractAdapter).bind;
                                return [
                                    4,
                                    _this.getContract()
                                ];
                            case 1:
                                return [
                                    2,
                                    new (_1.apply(_, [
                                        void 0,
                                        _state.sent()
                                    ]))
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return StarknetPricesContractConnector;
}($kHc9u.StarknetContractConnector);
module.exports.StarknetPricesContractConnector = $7f12291a145ace3b$var$StarknetPricesContractConnector;

});
parcelRequire.register("3BqLy", function(module, exports) {
module.exports = JSON.parse('[{"inputs":[{"name":"signer_count_treshold","type":"felt"},{"name":"addresses_len","type":"felt"},{"name":"addresses","type":"felt*"}],"name":"constructor","outputs":[],"type":"constructor"},{"inputs":[{"name":"feed_ids_len","type":"felt"},{"name":"feed_ids","type":"felt*"},{"name":"payload_data_len","type":"felt"},{"name":"payload_data","type":"felt*"}],"name":"get_prices","outputs":[{"name":"values_len","type":"felt"},{"name":"values","type":"felt*"}],"stateMutability":"view","type":"function"},{"inputs":[{"name":"feed_id","type":"felt"},{"name":"payload_data_len","type":"felt"},{"name":"payload_data","type":"felt*"}],"name":"get_price","outputs":[{"name":"value","type":"felt"}],"stateMutability":"view","type":"function"},{"inputs":[{"name":"feed_id","type":"felt"}],"name":"get_saved_price","outputs":[{"name":"value","type":"felt"}],"stateMutability":"view","type":"function"},{"inputs":[{"name":"feed_ids_len","type":"felt"},{"name":"feed_ids","type":"felt*"}],"name":"get_saved_prices","outputs":[{"name":"res_len","type":"felt"},{"name":"res","type":"felt*"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"get_saved_timestamp","outputs":[{"name":"res","type":"felt"}],"stateMutability":"view","type":"function"},{"inputs":[{"name":"feed_ids_len","type":"felt"},{"name":"feed_ids","type":"felt*"},{"name":"payload_data_len","type":"felt"},{"name":"payload_data","type":"felt*"}],"name":"save_prices","outputs":[],"type":"function"}]');

});

parcelRequire.register("493BH", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarknetPricesContractAdapter = void 0;

var $kHc9u = parcelRequire("kHc9u");
var $304accf620452c56$var$StarknetPricesContractAdapter = /*#__PURE__*/ function() {
    function StarknetPricesContractAdapter(contract) {
        (0, $978gY._)(this, StarknetPricesContractAdapter);
        this.contract = contract;
    }
    (0, $kry2a._)(StarknetPricesContractAdapter, [
        {
            key: "getPricesFromPayload",
            value: function getPricesFromPayload(paramsProvider) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _, _1, _2, _tmp, _tmp1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = _this.extractNumbers;
                                _2 = (_1 = _this.contract).call;
                                _tmp = [
                                    "get_prices"
                                ];
                                _tmp1 = [
                                    paramsProvider.getHexlifiedFeedIds()
                                ];
                                return [
                                    4,
                                    paramsProvider.getPayloadData()
                                ];
                            case 1:
                                return [
                                    4,
                                    _2.apply(_1, _tmp.concat([
                                        _tmp1.concat([
                                            _state.sent()
                                        ])
                                    ]))
                                ];
                            case 2:
                                return [
                                    2,
                                    _.apply(_this, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "writePricesFromPayloadToContract",
            value: function writePricesFromPayloadToContract(paramsProvider) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _, _1, _tmp, _tmp1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _1 = (_ = _this.contract).invoke;
                                _tmp = [
                                    "save_prices"
                                ];
                                _tmp1 = [
                                    paramsProvider.getHexlifiedFeedIds()
                                ];
                                return [
                                    4,
                                    paramsProvider.getPayloadData()
                                ];
                            case 1:
                                return [
                                    4,
                                    _1.apply(_, _tmp.concat([
                                        _tmp1.concat([
                                            _state.sent()
                                        ]),
                                        {
                                            maxFee: 0.004 * $kHc9u.FEE_MULTIPLIER
                                        }
                                    ]))
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent().transaction_hash
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "readPricesFromContract",
            value: function readPricesFromContract(paramsProvider) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = _this.extractNumbers;
                                return [
                                    4,
                                    _this.contract.call("get_saved_prices", [
                                        paramsProvider.getHexlifiedFeedIds()
                                    ])
                                ];
                            case 1:
                                return [
                                    2,
                                    _.apply(_this, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "readTimestampFromContract",
            value: function readTimestampFromContract() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.contract.call("get_saved_timestamp")
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()[0].toNumber()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "extractNumbers",
            value: function extractNumbers(response) {
                return response[0].map(function(value) {
                    return value.toNumber();
                });
            }
        }
    ]);
    return StarknetPricesContractAdapter;
}();
module.exports.StarknetPricesContractAdapter = $304accf620452c56$var$StarknetPricesContractAdapter;

});


parcelRequire.register("aVedK", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    var F = function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    };
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var isDataView = function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        };
        var normalizeName = function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        };
        var normalizeValue = function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        };
        var iteratorFor = // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function next() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        };
        var consumed = function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        };
        var fileReaderReady = function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        };
        var readBlobAsArrayBuffer = function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        };
        var readBlobAsText = function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        };
        var readArrayBufferAsText = function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        };
        var bufferClone = function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        };
        var Body = function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        };
        var normalizeMethod = function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        };
        var decode = function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        };
        var parseHeaders = function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        };
        var Response = function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        };
        var fetch = function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        };
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        Body.call(Request.prototype);
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRequire.register("5XYFy", function(module, exports) {
"use strict";
var $458186102674610e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aybhQ = parcelRequire("aybhQ");

var $458186102674610e$var$form_data_1 = $458186102674610e$var$__importDefault((parcelRequire("i8I3e")));

var $7tsMA = parcelRequire("7tsMA");
/**
 * Duck type if NodeJS stream
 * https://github.com/sindresorhus/is-stream/blob/3750505b0727f6df54324784fe369365ef78841e/index.js#L3
 */ var $458186102674610e$var$isExtractableFileEnhanced = function isExtractableFileEnhanced(value) {
    return (0, $aybhQ.isExtractableFile)(value) || value !== null && typeof value === "object" && typeof value.pipe === "function";
};
/**
 * Returns Multipart Form if body contains files
 * (https://github.com/jaydenseric/graphql-multipart-request-spec)
 * Otherwise returns JSON
 */ function $458186102674610e$var$createRequestBody(query, variables, operationName, jsonSerializer) {
    if (jsonSerializer === void 0) jsonSerializer = $7tsMA.defaultJsonSerializer;
    var _a = (0, $aybhQ.extractFiles)({
        query: query,
        variables: variables,
        operationName: operationName
    }, "", $458186102674610e$var$isExtractableFileEnhanced), clone = _a.clone, files = _a.files;
    if (files.size === 0) {
        if (!Array.isArray(query)) return jsonSerializer.stringify(clone);
        if (typeof variables !== "undefined" && !Array.isArray(variables)) throw new Error("Cannot create request body with given variable type, array expected");
        // Batch support
        var payload = query.reduce(function(accu, currentQuery, index) {
            accu.push({
                query: currentQuery,
                variables: variables ? variables[index] : undefined
            });
            return accu;
        }, []);
        return jsonSerializer.stringify(payload);
    }
    var Form = typeof FormData === "undefined" ? $458186102674610e$var$form_data_1.default : FormData;
    var form = new Form();
    form.append("operations", jsonSerializer.stringify(clone));
    var map = {};
    var i = 0;
    files.forEach(function(paths) {
        map[++i] = paths;
    });
    form.append("map", jsonSerializer.stringify(map));
    i = 0;
    files.forEach(function(paths, file) {
        form.append("".concat(++i), file);
    });
    return form;
}
module.exports.default = $458186102674610e$var$createRequestBody;

});
parcelRequire.register("aybhQ", function(module, exports) {

$parcel$export(module.exports, "extractFiles", function () { return $7ae5d5af4aa98b1f$export$f5544efc2684376b; }, function (v) { return $7ae5d5af4aa98b1f$export$f5544efc2684376b = v; });
$parcel$export(module.exports, "isExtractableFile", function () { return $7ae5d5af4aa98b1f$export$f892d0f8e65523c3; }, function (v) { return $7ae5d5af4aa98b1f$export$f892d0f8e65523c3 = v; });
var $7ae5d5af4aa98b1f$export$5fcafa2ee375e60a;
var $7ae5d5af4aa98b1f$export$f5544efc2684376b;
var $7ae5d5af4aa98b1f$export$f892d0f8e65523c3;
"use strict";

$7ae5d5af4aa98b1f$export$5fcafa2ee375e60a = (parcelRequire("gQ8rw"));

$7ae5d5af4aa98b1f$export$f5544efc2684376b = (parcelRequire("2jFwP"));

$7ae5d5af4aa98b1f$export$f892d0f8e65523c3 = (parcelRequire("4LaSY"));

});
parcelRequire.register("gQ8rw", function(module, exports) {
"use strict";
module.exports = function ReactNativeFile(_ref) {
    var uri = _ref.uri, name = _ref.name, type = _ref.type;
    this.uri = uri;
    this.name = name;
    this.type = type;
};

});

parcelRequire.register("2jFwP", function(module, exports) {
"use strict";

var $4LaSY = parcelRequire("4LaSY");
module.exports = function extractFiles(value, path, isExtractableFile) {
    var addFile = function addFile(paths, file) {
        var storedPaths = files.get(file);
        if (storedPaths) storedPaths.push.apply(storedPaths, paths);
        else files.set(file, paths);
    };
    if (path === void 0) path = "";
    if (isExtractableFile === void 0) isExtractableFile = $4LaSY;
    var clone;
    var files = new Map();
    if (isExtractableFile(value)) {
        clone = null;
        addFile([
            path
        ], value);
    } else {
        var prefix = path ? path + "." : "";
        if (typeof FileList !== "undefined" && value instanceof FileList) clone = Array.prototype.map.call(value, function(file, i) {
            addFile([
                "" + prefix + i
            ], file);
            return null;
        });
        else if (Array.isArray(value)) clone = value.map(function(child, i) {
            var result = extractFiles(child, "" + prefix + i, isExtractableFile);
            result.files.forEach(addFile);
            return result.clone;
        });
        else if (value && value.constructor === Object) {
            clone = {};
            for(var i in value){
                var result = extractFiles(value[i], "" + prefix + i, isExtractableFile);
                result.files.forEach(addFile);
                clone[i] = result.clone;
            }
        } else clone = value;
    }
    return {
        clone: clone,
        files: files
    };
};

});
parcelRequire.register("4LaSY", function(module, exports) {
"use strict";

var $gQ8rw = parcelRequire("gQ8rw");
module.exports = function isExtractableFile(value) {
    return typeof File !== "undefined" && value instanceof File || typeof Blob !== "undefined" && value instanceof Blob || value instanceof $gQ8rw;
};

});



parcelRequire.register("i8I3e", function(module, exports) {
/* eslint-env browser */ module.exports = typeof self == "object" ? self.FormData : window.FormData;

});

parcelRequire.register("7tsMA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultJsonSerializer = void 0;
module.exports.defaultJsonSerializer = {
    parse: JSON.parse,
    stringify: JSON.stringify
};

});


parcelRequire.register("51Bw9", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ 
var $1ObTH = parcelRequire("1ObTH");
var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value);
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value);
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRequire.register("bWEWP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $6b76310efa2f0758$export$2e2bcd8739ae039; });
/**
 * A JavaScript implementation of the SHA family of hashes - defined in FIPS PUB 180-4, FIPS PUB 202,
 * and SP 800-185 - as well as the corresponding HMAC implementation as defined in FIPS PUB 198-1.
 *
 * Copyright 2008-2020 Brian Turek, 1998-2009 Paul Johnston & Contributors
 * Distributed under the BSD License
 * See http://caligatio.github.com/jsSHA/ for more information
 */ 
var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");
var $6b76310efa2f0758$var$t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
function $6b76310efa2f0758$var$n(t, n, e, r) {
    var i, s, o;
    var h = n || [
        0
    ], u = (e = e || 0) >>> 3, w = -1 === r ? 3 : 0;
    for(i = 0; i < t.length; i += 1)o = i + u, s = o >>> 2, h.length <= s && h.push(0), h[s] |= t[i] << 8 * (w + r * (o % 4));
    return {
        value: h,
        binLen: 8 * t.length + e
    };
}
function $6b76310efa2f0758$var$e(e, r, i) {
    switch(r){
        case "UTF8":
        case "UTF16BE":
        case "UTF16LE":
            break;
        default:
            throw new Error("encoding must be UTF8, UTF16BE, or UTF16LE");
    }
    switch(e){
        case "HEX":
            return function(t, n, e) {
                return function(t, n, e, r) {
                    var _$i, s, o, h;
                    if (0 != t.length % 2) throw new Error("String of HEX type must be in byte increments");
                    var u = n || [
                        0
                    ], w = (e = e || 0) >>> 3, c = -1 === r ? 3 : 0;
                    for(_$i = 0; _$i < t.length; _$i += 2){
                        if (s = parseInt(t.substr(_$i, 2), 16), isNaN(s)) throw new Error("String of HEX type contains invalid characters");
                        for(h = (_$i >>> 1) + w, o = h >>> 2; u.length <= o;)u.push(0);
                        u[o] |= s << 8 * (c + r * (h % 4));
                    }
                    return {
                        value: u,
                        binLen: 4 * t.length + e
                    };
                }(t, n, e, i);
            };
        case "TEXT":
            return function(t, n, e) {
                return function(t, n, e, r, i) {
                    var s, o, h, u, w, c, f, a, l = 0;
                    var A = e || [
                        0
                    ], E = (r = r || 0) >>> 3;
                    if ("UTF8" === n) for(f = -1 === i ? 3 : 0, h = 0; h < t.length; h += 1)for(s = t.charCodeAt(h), o = [], 128 > s ? o.push(s) : 2048 > s ? (o.push(192 | s >>> 6), o.push(128 | 63 & s)) : 55296 > s || 57344 <= s ? o.push(224 | s >>> 12, 128 | s >>> 6 & 63, 128 | 63 & s) : (h += 1, s = 65536 + ((1023 & s) << 10 | 1023 & t.charCodeAt(h)), o.push(240 | s >>> 18, 128 | s >>> 12 & 63, 128 | s >>> 6 & 63, 128 | 63 & s)), u = 0; u < o.length; u += 1){
                        for(c = l + E, w = c >>> 2; A.length <= w;)A.push(0);
                        A[w] |= o[u] << 8 * (f + i * (c % 4)), l += 1;
                    }
                    else for(f = -1 === i ? 2 : 0, a = "UTF16LE" === n && 1 !== i || "UTF16LE" !== n && 1 === i, h = 0; h < t.length; h += 1){
                        for(s = t.charCodeAt(h), !0 === a && (u = 255 & s, s = u << 8 | s >>> 8), c = l + E, w = c >>> 2; A.length <= w;)A.push(0);
                        A[w] |= s << 8 * (f + i * (c % 4)), l += 2;
                    }
                    return {
                        value: A,
                        binLen: 8 * l + r
                    };
                }(t, r, n, e, i);
            };
        case "B64":
            return function(n, e, r) {
                return function(n, e, r, i) {
                    var s, o, h, u, w, c, f, a = 0;
                    var l = e || [
                        0
                    ], A = (r = r || 0) >>> 3, E = -1 === i ? 3 : 0, H = n.indexOf("=");
                    if (-1 === n.search(/^[a-zA-Z0-9=+/]+$/)) throw new Error("Invalid character in base-64 string");
                    if (n = n.replace(/=/g, ""), -1 !== H && H < n.length) throw new Error("Invalid '=' found in base-64 string");
                    for(o = 0; o < n.length; o += 4){
                        for(w = n.substr(o, 4), u = 0, h = 0; h < w.length; h += 1)s = $6b76310efa2f0758$var$t.indexOf(w.charAt(h)), u |= s << 18 - 6 * h;
                        for(h = 0; h < w.length - 1; h += 1){
                            for(f = a + A, c = f >>> 2; l.length <= c;)l.push(0);
                            l[c] |= (u >>> 16 - 8 * h & 255) << 8 * (E + i * (f % 4)), a += 1;
                        }
                    }
                    return {
                        value: l,
                        binLen: 8 * a + r
                    };
                }(n, e, r, i);
            };
        case "BYTES":
            return function(t, n, e) {
                return function(t, n, e, r) {
                    var _$i, s, o, h;
                    var u = n || [
                        0
                    ], w = (e = e || 0) >>> 3, c = -1 === r ? 3 : 0;
                    for(s = 0; s < t.length; s += 1)_$i = t.charCodeAt(s), h = s + w, o = h >>> 2, u.length <= o && u.push(0), u[o] |= _$i << 8 * (c + r * (h % 4));
                    return {
                        value: u,
                        binLen: 8 * t.length + e
                    };
                }(t, n, e, i);
            };
        case "ARRAYBUFFER":
            try {
                new ArrayBuffer(0);
            } catch (t) {
                throw new Error("ARRAYBUFFER not supported by this environment");
            }
            return function(t, e, r) {
                return function(t, e, r, i) {
                    return $6b76310efa2f0758$var$n(new Uint8Array(t), e, r, i);
                }(t, e, r, i);
            };
        case "UINT8ARRAY":
            try {
                new Uint8Array(0);
            } catch (t) {
                throw new Error("UINT8ARRAY not supported by this environment");
            }
            return function(t, e, r) {
                return $6b76310efa2f0758$var$n(t, e, r, i);
            };
        default:
            throw new Error("format must be HEX, TEXT, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");
    }
}
function $6b76310efa2f0758$var$r(n, e, r, i) {
    switch(n){
        case "HEX":
            return function(t) {
                return function(t, n, e, r) {
                    var _$i, s, o = "";
                    var h = n / 8, u = -1 === e ? 3 : 0;
                    for(_$i = 0; _$i < h; _$i += 1)s = t[_$i >>> 2] >>> 8 * (u + e * (_$i % 4)), o += "0123456789abcdef".charAt(s >>> 4 & 15) + "0123456789abcdef".charAt(15 & s);
                    return r.outputUpper ? o.toUpperCase() : o;
                }(t, e, r, i);
            };
        case "B64":
            return function(n) {
                return function(n, e, r, i) {
                    var s, o, h, u, w, c = "";
                    var f = e / 8, a = -1 === r ? 3 : 0;
                    for(s = 0; s < f; s += 3)for(u = s + 1 < f ? n[s + 1 >>> 2] : 0, w = s + 2 < f ? n[s + 2 >>> 2] : 0, h = (n[s >>> 2] >>> 8 * (a + r * (s % 4)) & 255) << 16 | (u >>> 8 * (a + r * ((s + 1) % 4)) & 255) << 8 | w >>> 8 * (a + r * ((s + 2) % 4)) & 255, o = 0; o < 4; o += 1)c += 8 * s + 6 * o <= e ? $6b76310efa2f0758$var$t.charAt(h >>> 6 * (3 - o) & 63) : i.b64Pad;
                    return c;
                }(n, e, r, i);
            };
        case "BYTES":
            return function(t) {
                return function(t, n, e) {
                    var _$r, i, s = "";
                    var o = n / 8, h = -1 === e ? 3 : 0;
                    for(_$r = 0; _$r < o; _$r += 1)i = t[_$r >>> 2] >>> 8 * (h + e * (_$r % 4)) & 255, s += String.fromCharCode(i);
                    return s;
                }(t, e, r);
            };
        case "ARRAYBUFFER":
            try {
                new ArrayBuffer(0);
            } catch (t) {
                throw new Error("ARRAYBUFFER not supported by this environment");
            }
            return function(t) {
                return function(t, n, e) {
                    var _$r;
                    var i = n / 8, s = new ArrayBuffer(i), o = new Uint8Array(s), h = -1 === e ? 3 : 0;
                    for(_$r = 0; _$r < i; _$r += 1)o[_$r] = t[_$r >>> 2] >>> 8 * (h + e * (_$r % 4)) & 255;
                    return s;
                }(t, e, r);
            };
        case "UINT8ARRAY":
            try {
                new Uint8Array(0);
            } catch (t) {
                throw new Error("UINT8ARRAY not supported by this environment");
            }
            return function(t) {
                return function(t, n, e) {
                    var _$r;
                    var i = n / 8, s = -1 === e ? 3 : 0, o = new Uint8Array(i);
                    for(_$r = 0; _$r < i; _$r += 1)o[_$r] = t[_$r >>> 2] >>> 8 * (s + e * (_$r % 4)) & 255;
                    return o;
                }(t, e, r);
            };
        default:
            throw new Error("format must be HEX, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");
    }
}
var $6b76310efa2f0758$var$i = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
], $6b76310efa2f0758$var$s = [
    3238371032,
    914150663,
    812702999,
    4144912697,
    4290775857,
    1750603025,
    1694076839,
    3204075428
], $6b76310efa2f0758$var$o = [
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
], $6b76310efa2f0758$var$h = "Chosen SHA variant is not supported";
function $6b76310efa2f0758$var$u(t, n) {
    var e, r;
    var i = t.binLen >>> 3, s = n.binLen >>> 3, o = i << 3, h = 4 - i << 3;
    if (i % 4 != 0) {
        for(e = 0; e < s; e += 4)r = i + e >>> 2, t.value[r] |= n.value[e >>> 2] << o, t.value.push(0), t.value[r + 1] |= n.value[e >>> 2] >>> h;
        return (t.value.length << 2) - 4 >= s + i && t.value.pop(), {
            value: t.value,
            binLen: t.binLen + n.binLen
        };
    }
    return {
        value: t.value.concat(n.value),
        binLen: t.binLen + n.binLen
    };
}
function $6b76310efa2f0758$var$w(t) {
    var n = {
        outputUpper: !1,
        b64Pad: "=",
        outputLen: -1
    }, e = t || {}, r = "Output length must be a multiple of 8";
    if (n.outputUpper = e.outputUpper || !1, e.b64Pad && (n.b64Pad = e.b64Pad), e.outputLen) {
        if (e.outputLen % 8 != 0) throw new Error(r);
        n.outputLen = e.outputLen;
    } else if (e.shakeLen) {
        if (e.shakeLen % 8 != 0) throw new Error(r);
        n.outputLen = e.shakeLen;
    }
    if ("boolean" != typeof n.outputUpper) throw new Error("Invalid outputUpper formatting option");
    if ("string" != typeof n.b64Pad) throw new Error("Invalid b64Pad formatting option");
    return n;
}
function $6b76310efa2f0758$var$c(t, n, r, i) {
    var s = t + " must include a value and format";
    if (!n) {
        if (!i) throw new Error(s);
        return i;
    }
    if (void 0 === n.value || !n.format) throw new Error(s);
    return $6b76310efa2f0758$var$e(n.format, n.encoding || "UTF8", r)(n.value);
}
var $6b76310efa2f0758$var$f = /*#__PURE__*/ function() {
    "use strict";
    function f(t, n, e) {
        (0, $978gY._)(this, f);
        var r = e || {};
        if (this.t = n, this.i = r.encoding || "UTF8", this.numRounds = r.numRounds || 1, isNaN(this.numRounds) || this.numRounds !== parseInt(this.numRounds, 10) || 1 > this.numRounds) throw new Error("numRounds must a integer >= 1");
        this.s = t, this.o = [], this.h = 0, this.u = !1, this.l = 0, this.A = !1, this.H = [], this.S = [];
    }
    (0, $kry2a._)(f, [
        {
            key: "update",
            value: function update(t) {
                var n, e = 0;
                var r = this.p >>> 5, i = this.m(t, this.o, this.h), s = i.binLen, o = i.value, h = s >>> 5;
                for(n = 0; n < h; n += r)e + this.p <= s && (this.C = this.R(o.slice(n, n + r), this.C), e += this.p);
                this.l += e, this.o = o.slice(e >>> 5), this.h = s % this.p, this.u = !0;
            }
        },
        {
            key: "getHash",
            value: function getHash(t, n) {
                var e, i, s = this.U;
                var o = $6b76310efa2f0758$var$w(n);
                if (this.v) {
                    if (-1 === o.outputLen) throw new Error("Output length must be specified in options");
                    s = o.outputLen;
                }
                var h = $6b76310efa2f0758$var$r(t, s, this.K, o);
                if (this.A && this.T) return h(this.T(o));
                for(i = this.F(this.o.slice(), this.h, this.l, this.g(this.C), s), e = 1; e < this.numRounds; e += 1)this.v && s % 32 != 0 && (i[i.length - 1] &= 16777215 >>> 24 - s % 32), i = this.F(i, s, 0, this.B(this.s), s);
                return h(i);
            }
        },
        {
            key: "setHMACKey",
            value: function setHMACKey(t, n, r) {
                if (!this.L) throw new Error("Variant does not support HMAC");
                if (this.u) throw new Error("Cannot set MAC key after calling update");
                var i = $6b76310efa2f0758$var$e(n, (r || {}).encoding || "UTF8", this.K);
                this.M(i(t));
            }
        },
        {
            key: "M",
            value: function M(t) {
                var n = this.p >>> 3, e = n / 4 - 1;
                var r;
                if (1 !== this.numRounds) throw new Error("Cannot set numRounds with MAC");
                if (this.A) throw new Error("MAC key already set");
                for(n < t.binLen / 8 && (t.value = this.F(t.value, t.binLen, 0, this.B(this.s), this.U)); t.value.length <= e;)t.value.push(0);
                for(r = 0; r <= e; r += 1)this.H[r] = 909522486 ^ t.value[r], this.S[r] = 1549556828 ^ t.value[r];
                this.C = this.R(this.H, this.C), this.l = this.p, this.A = !0;
            }
        },
        {
            key: "getHMAC",
            value: function getHMAC(t, n) {
                var e = $6b76310efa2f0758$var$w(n);
                return $6b76310efa2f0758$var$r(t, this.U, this.K, e)(this.k());
            }
        },
        {
            key: "k",
            value: function k() {
                var t;
                if (!this.A) throw new Error("Cannot call getHMAC without first setting MAC key");
                var n = this.F(this.o.slice(), this.h, this.l, this.g(this.C), this.U);
                return t = this.R(this.S, this.B(this.s)), t = this.F(n, this.U, this.p, t, this.U), t;
            }
        }
    ]);
    return f;
}();
function $6b76310efa2f0758$var$a(t, n) {
    return t << n | t >>> 32 - n;
}
function $6b76310efa2f0758$var$l(t, n) {
    return t >>> n | t << 32 - n;
}
function $6b76310efa2f0758$var$A(t, n) {
    return t >>> n;
}
function $6b76310efa2f0758$var$E(t, n, e) {
    return t ^ n ^ e;
}
function $6b76310efa2f0758$var$H(t, n, e) {
    return t & n ^ ~t & e;
}
function $6b76310efa2f0758$var$S(t, n, e) {
    return t & n ^ t & e ^ n & e;
}
function $6b76310efa2f0758$var$b(t) {
    return $6b76310efa2f0758$var$l(t, 2) ^ $6b76310efa2f0758$var$l(t, 13) ^ $6b76310efa2f0758$var$l(t, 22);
}
function $6b76310efa2f0758$var$p(t, n) {
    var e = (65535 & t) + (65535 & n);
    return (65535 & (t >>> 16) + (n >>> 16) + (e >>> 16)) << 16 | 65535 & e;
}
function $6b76310efa2f0758$var$d(t, n, e, r) {
    var i = (65535 & t) + (65535 & n) + (65535 & e) + (65535 & r);
    return (65535 & (t >>> 16) + (n >>> 16) + (e >>> 16) + (r >>> 16) + (i >>> 16)) << 16 | 65535 & i;
}
function $6b76310efa2f0758$var$m(t, n, e, r, i) {
    var s = (65535 & t) + (65535 & n) + (65535 & e) + (65535 & r) + (65535 & i);
    return (65535 & (t >>> 16) + (n >>> 16) + (e >>> 16) + (r >>> 16) + (i >>> 16) + (s >>> 16)) << 16 | 65535 & s;
}
function $6b76310efa2f0758$var$C(t) {
    return $6b76310efa2f0758$var$l(t, 7) ^ $6b76310efa2f0758$var$l(t, 18) ^ $6b76310efa2f0758$var$A(t, 3);
}
function $6b76310efa2f0758$var$y(t) {
    return $6b76310efa2f0758$var$l(t, 6) ^ $6b76310efa2f0758$var$l(t, 11) ^ $6b76310efa2f0758$var$l(t, 25);
}
function $6b76310efa2f0758$var$R(t) {
    return [
        1732584193,
        4023233417,
        2562383102,
        271733878,
        3285377520
    ];
}
function $6b76310efa2f0758$var$U(t, n) {
    var e, r, i, s, o, h, u;
    var w = [];
    for(e = n[0], r = n[1], i = n[2], s = n[3], o = n[4], u = 0; u < 80; u += 1)w[u] = u < 16 ? t[u] : $6b76310efa2f0758$var$a(w[u - 3] ^ w[u - 8] ^ w[u - 14] ^ w[u - 16], 1), h = u < 20 ? $6b76310efa2f0758$var$m($6b76310efa2f0758$var$a(e, 5), $6b76310efa2f0758$var$H(r, i, s), o, 1518500249, w[u]) : u < 40 ? $6b76310efa2f0758$var$m($6b76310efa2f0758$var$a(e, 5), $6b76310efa2f0758$var$E(r, i, s), o, 1859775393, w[u]) : u < 60 ? $6b76310efa2f0758$var$m($6b76310efa2f0758$var$a(e, 5), $6b76310efa2f0758$var$S(r, i, s), o, 2400959708, w[u]) : $6b76310efa2f0758$var$m($6b76310efa2f0758$var$a(e, 5), $6b76310efa2f0758$var$E(r, i, s), o, 3395469782, w[u]), o = s, s = i, i = $6b76310efa2f0758$var$a(r, 30), r = e, e = h;
    return n[0] = $6b76310efa2f0758$var$p(e, n[0]), n[1] = $6b76310efa2f0758$var$p(r, n[1]), n[2] = $6b76310efa2f0758$var$p(i, n[2]), n[3] = $6b76310efa2f0758$var$p(s, n[3]), n[4] = $6b76310efa2f0758$var$p(o, n[4]), n;
}
function $6b76310efa2f0758$var$v(t, n, e, r) {
    var i;
    var s = 15 + (n + 65 >>> 9 << 4), o = n + e;
    for(; t.length <= s;)t.push(0);
    for(t[n >>> 5] |= 128 << 24 - n % 32, t[s] = 4294967295 & o, t[s - 1] = o / 4294967296 | 0, i = 0; i < t.length; i += 16)r = $6b76310efa2f0758$var$U(t.slice(i, i + 16), r);
    return r;
}
var $6b76310efa2f0758$var$K = /*#__PURE__*/ function(f) {
    "use strict";
    (0, $ftJVG._)(K, f);
    var _super = (0, $6OZAO._)(K);
    function K(t, n, r) {
        (0, $978gY._)(this, K);
        var _this;
        if ("SHA-1" !== t) throw new Error($6b76310efa2f0758$var$h);
        _this = _super.call(this, t, n, r);
        var i = r || {};
        _this.L = !0, _this.T = _this.k, _this.K = -1, _this.m = $6b76310efa2f0758$var$e(_this.t, _this.i, _this.K), _this.R = $6b76310efa2f0758$var$U, _this.g = function(t) {
            return t.slice();
        }, _this.B = $6b76310efa2f0758$var$R, _this.F = $6b76310efa2f0758$var$v, _this.C = [
            1732584193,
            4023233417,
            2562383102,
            271733878,
            3285377520
        ], _this.p = 512, _this.U = 160, _this.v = !1, i.hmacKey && _this.M($6b76310efa2f0758$var$c("hmacKey", i.hmacKey, _this.K));
        return _this;
    }
    return K;
}($6b76310efa2f0758$var$f);
function $6b76310efa2f0758$var$T(t) {
    var n;
    return n = "SHA-224" == t ? $6b76310efa2f0758$var$s.slice() : $6b76310efa2f0758$var$o.slice(), n;
}
function $6b76310efa2f0758$var$F(t, n) {
    var e, r, s, o, h, u, w, c, f, a, E;
    var R = [];
    for(e = n[0], r = n[1], s = n[2], o = n[3], h = n[4], u = n[5], w = n[6], c = n[7], E = 0; E < 64; E += 1)R[E] = E < 16 ? t[E] : $6b76310efa2f0758$var$d($6b76310efa2f0758$var$l(U = R[E - 2], 17) ^ $6b76310efa2f0758$var$l(U, 19) ^ $6b76310efa2f0758$var$A(U, 10), R[E - 7], $6b76310efa2f0758$var$C(R[E - 15]), R[E - 16]), f = $6b76310efa2f0758$var$m(c, $6b76310efa2f0758$var$y(h), $6b76310efa2f0758$var$H(h, u, w), $6b76310efa2f0758$var$i[E], R[E]), a = $6b76310efa2f0758$var$p($6b76310efa2f0758$var$b(e), $6b76310efa2f0758$var$S(e, r, s)), c = w, w = u, u = h, h = $6b76310efa2f0758$var$p(o, f), o = s, s = r, r = e, e = $6b76310efa2f0758$var$p(f, a);
    var U;
    return n[0] = $6b76310efa2f0758$var$p(e, n[0]), n[1] = $6b76310efa2f0758$var$p(r, n[1]), n[2] = $6b76310efa2f0758$var$p(s, n[2]), n[3] = $6b76310efa2f0758$var$p(o, n[3]), n[4] = $6b76310efa2f0758$var$p(h, n[4]), n[5] = $6b76310efa2f0758$var$p(u, n[5]), n[6] = $6b76310efa2f0758$var$p(w, n[6]), n[7] = $6b76310efa2f0758$var$p(c, n[7]), n;
}
var $6b76310efa2f0758$var$g = /*#__PURE__*/ function(f) {
    "use strict";
    (0, $ftJVG._)(g, f);
    var _super = (0, $6OZAO._)(g);
    function g(t, n, r) {
        (0, $978gY._)(this, g);
        var _this;
        if ("SHA-224" !== t && "SHA-256" !== t) throw new Error($6b76310efa2f0758$var$h);
        _this = _super.call(this, t, n, r);
        var i = r || {};
        _this.T = _this.k, _this.L = !0, _this.K = -1, _this.m = $6b76310efa2f0758$var$e(_this.t, _this.i, _this.K), _this.R = $6b76310efa2f0758$var$F, _this.g = function(t) {
            return t.slice();
        }, _this.B = $6b76310efa2f0758$var$T, _this.F = function(n, e, r, i) {
            return function(t, n, e, r, i) {
                var s, o;
                var h = 15 + (n + 65 >>> 9 << 4), u = n + e;
                for(; t.length <= h;)t.push(0);
                for(t[n >>> 5] |= 128 << 24 - n % 32, t[h] = 4294967295 & u, t[h - 1] = u / 4294967296 | 0, s = 0; s < t.length; s += 16)r = $6b76310efa2f0758$var$F(t.slice(s, s + 16), r);
                return o = "SHA-224" === i ? [
                    r[0],
                    r[1],
                    r[2],
                    r[3],
                    r[4],
                    r[5],
                    r[6]
                ] : r, o;
            }(n, e, r, i, t);
        }, _this.C = $6b76310efa2f0758$var$T(t), _this.p = 512, _this.U = "SHA-224" === t ? 224 : 256, _this.v = !1, i.hmacKey && _this.M($6b76310efa2f0758$var$c("hmacKey", i.hmacKey, _this.K));
        return _this;
    }
    return g;
}($6b76310efa2f0758$var$f);
var $6b76310efa2f0758$var$B = function B(t, n) {
    "use strict";
    (0, $978gY._)(this, B);
    this.Y = t, this.N = n;
};
function $6b76310efa2f0758$var$L(t, n) {
    var e;
    return n > 32 ? (e = 64 - n, new $6b76310efa2f0758$var$B(t.N << n | t.Y >>> e, t.Y << n | t.N >>> e)) : 0 !== n ? (e = 32 - n, new $6b76310efa2f0758$var$B(t.Y << n | t.N >>> e, t.N << n | t.Y >>> e)) : t;
}
function $6b76310efa2f0758$var$M(t, n) {
    var e;
    return n < 32 ? (e = 32 - n, new $6b76310efa2f0758$var$B(t.Y >>> n | t.N << e, t.N >>> n | t.Y << e)) : (e = 64 - n, new $6b76310efa2f0758$var$B(t.N >>> n | t.Y << e, t.Y >>> n | t.N << e));
}
function $6b76310efa2f0758$var$k(t, n) {
    return new $6b76310efa2f0758$var$B(t.Y >>> n, t.N >>> n | t.Y << 32 - n);
}
function $6b76310efa2f0758$var$Y(t, n, e) {
    return new $6b76310efa2f0758$var$B(t.Y & n.Y ^ t.Y & e.Y ^ n.Y & e.Y, t.N & n.N ^ t.N & e.N ^ n.N & e.N);
}
function $6b76310efa2f0758$var$N(t) {
    var n = $6b76310efa2f0758$var$M(t, 28), e = $6b76310efa2f0758$var$M(t, 34), r = $6b76310efa2f0758$var$M(t, 39);
    return new $6b76310efa2f0758$var$B(n.Y ^ e.Y ^ r.Y, n.N ^ e.N ^ r.N);
}
function $6b76310efa2f0758$var$I(t, n) {
    var e, r;
    e = (65535 & t.N) + (65535 & n.N), r = (t.N >>> 16) + (n.N >>> 16) + (e >>> 16);
    var i = (65535 & r) << 16 | 65535 & e;
    e = (65535 & t.Y) + (65535 & n.Y) + (r >>> 16), r = (t.Y >>> 16) + (n.Y >>> 16) + (e >>> 16);
    return new $6b76310efa2f0758$var$B((65535 & r) << 16 | 65535 & e, i);
}
function $6b76310efa2f0758$var$X(t, n, e, r) {
    var i, s;
    i = (65535 & t.N) + (65535 & n.N) + (65535 & e.N) + (65535 & r.N), s = (t.N >>> 16) + (n.N >>> 16) + (e.N >>> 16) + (r.N >>> 16) + (i >>> 16);
    var o = (65535 & s) << 16 | 65535 & i;
    i = (65535 & t.Y) + (65535 & n.Y) + (65535 & e.Y) + (65535 & r.Y) + (s >>> 16), s = (t.Y >>> 16) + (n.Y >>> 16) + (e.Y >>> 16) + (r.Y >>> 16) + (i >>> 16);
    return new $6b76310efa2f0758$var$B((65535 & s) << 16 | 65535 & i, o);
}
function $6b76310efa2f0758$var$z(t, n, e, r, i) {
    var s, o;
    s = (65535 & t.N) + (65535 & n.N) + (65535 & e.N) + (65535 & r.N) + (65535 & i.N), o = (t.N >>> 16) + (n.N >>> 16) + (e.N >>> 16) + (r.N >>> 16) + (i.N >>> 16) + (s >>> 16);
    var h = (65535 & o) << 16 | 65535 & s;
    s = (65535 & t.Y) + (65535 & n.Y) + (65535 & e.Y) + (65535 & r.Y) + (65535 & i.Y) + (o >>> 16), o = (t.Y >>> 16) + (n.Y >>> 16) + (e.Y >>> 16) + (r.Y >>> 16) + (i.Y >>> 16) + (s >>> 16);
    return new $6b76310efa2f0758$var$B((65535 & o) << 16 | 65535 & s, h);
}
function $6b76310efa2f0758$var$x(t, n) {
    return new $6b76310efa2f0758$var$B(t.Y ^ n.Y, t.N ^ n.N);
}
function $6b76310efa2f0758$var$_(t) {
    var n = $6b76310efa2f0758$var$M(t, 19), e = $6b76310efa2f0758$var$M(t, 61), r = $6b76310efa2f0758$var$k(t, 6);
    return new $6b76310efa2f0758$var$B(n.Y ^ e.Y ^ r.Y, n.N ^ e.N ^ r.N);
}
function $6b76310efa2f0758$var$O(t) {
    var n = $6b76310efa2f0758$var$M(t, 1), e = $6b76310efa2f0758$var$M(t, 8), r = $6b76310efa2f0758$var$k(t, 7);
    return new $6b76310efa2f0758$var$B(n.Y ^ e.Y ^ r.Y, n.N ^ e.N ^ r.N);
}
function $6b76310efa2f0758$var$P(t) {
    var n = $6b76310efa2f0758$var$M(t, 14), e = $6b76310efa2f0758$var$M(t, 18), r = $6b76310efa2f0758$var$M(t, 41);
    return new $6b76310efa2f0758$var$B(n.Y ^ e.Y ^ r.Y, n.N ^ e.N ^ r.N);
}
var $6b76310efa2f0758$var$V = [
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[0], 3609767458),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[1], 602891725),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[2], 3964484399),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[3], 2173295548),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[4], 4081628472),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[5], 3053834265),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[6], 2937671579),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[7], 3664609560),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[8], 2734883394),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[9], 1164996542),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[10], 1323610764),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[11], 3590304994),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[12], 4068182383),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[13], 991336113),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[14], 633803317),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[15], 3479774868),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[16], 2666613458),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[17], 944711139),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[18], 2341262773),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[19], 2007800933),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[20], 1495990901),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[21], 1856431235),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[22], 3175218132),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[23], 2198950837),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[24], 3999719339),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[25], 766784016),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[26], 2566594879),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[27], 3203337956),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[28], 1034457026),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[29], 2466948901),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[30], 3758326383),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[31], 168717936),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[32], 1188179964),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[33], 1546045734),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[34], 1522805485),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[35], 2643833823),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[36], 2343527390),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[37], 1014477480),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[38], 1206759142),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[39], 344077627),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[40], 1290863460),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[41], 3158454273),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[42], 3505952657),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[43], 106217008),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[44], 3606008344),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[45], 1432725776),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[46], 1467031594),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[47], 851169720),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[48], 3100823752),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[49], 1363258195),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[50], 3750685593),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[51], 3785050280),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[52], 3318307427),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[53], 3812723403),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[54], 2003034995),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[55], 3602036899),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[56], 1575990012),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[57], 1125592928),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[58], 2716904306),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[59], 442776044),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[60], 593698344),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[61], 3733110249),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[62], 2999351573),
    new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$i[63], 3815920427),
    new $6b76310efa2f0758$var$B(3391569614, 3928383900),
    new $6b76310efa2f0758$var$B(3515267271, 566280711),
    new $6b76310efa2f0758$var$B(3940187606, 3454069534),
    new $6b76310efa2f0758$var$B(4118630271, 4000239992),
    new $6b76310efa2f0758$var$B(116418474, 1914138554),
    new $6b76310efa2f0758$var$B(174292421, 2731055270),
    new $6b76310efa2f0758$var$B(289380356, 3203993006),
    new $6b76310efa2f0758$var$B(460393269, 320620315),
    new $6b76310efa2f0758$var$B(685471733, 587496836),
    new $6b76310efa2f0758$var$B(852142971, 1086792851),
    new $6b76310efa2f0758$var$B(1017036298, 365543100),
    new $6b76310efa2f0758$var$B(1126000580, 2618297676),
    new $6b76310efa2f0758$var$B(1288033470, 3409855158),
    new $6b76310efa2f0758$var$B(1501505948, 4234509866),
    new $6b76310efa2f0758$var$B(1607167915, 987167468),
    new $6b76310efa2f0758$var$B(1816402316, 1246189591)
];
function $6b76310efa2f0758$var$Z(t) {
    return "SHA-384" === t ? [
        new $6b76310efa2f0758$var$B(3418070365, $6b76310efa2f0758$var$s[0]),
        new $6b76310efa2f0758$var$B(1654270250, $6b76310efa2f0758$var$s[1]),
        new $6b76310efa2f0758$var$B(2438529370, $6b76310efa2f0758$var$s[2]),
        new $6b76310efa2f0758$var$B(355462360, $6b76310efa2f0758$var$s[3]),
        new $6b76310efa2f0758$var$B(1731405415, $6b76310efa2f0758$var$s[4]),
        new $6b76310efa2f0758$var$B(41048885895, $6b76310efa2f0758$var$s[5]),
        new $6b76310efa2f0758$var$B(3675008525, $6b76310efa2f0758$var$s[6]),
        new $6b76310efa2f0758$var$B(1203062813, $6b76310efa2f0758$var$s[7])
    ] : [
        new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$o[0], 4089235720),
        new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$o[1], 2227873595),
        new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$o[2], 4271175723),
        new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$o[3], 1595750129),
        new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$o[4], 2917565137),
        new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$o[5], 725511199),
        new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$o[6], 4215389547),
        new $6b76310efa2f0758$var$B($6b76310efa2f0758$var$o[7], 327033209)
    ];
}
function $6b76310efa2f0758$var$j(t, n) {
    var e, r, i, s, o, h, u, w, c, f, a, l;
    var A = [];
    for(e = n[0], r = n[1], i = n[2], s = n[3], o = n[4], h = n[5], u = n[6], w = n[7], a = 0; a < 80; a += 1)a < 16 ? (l = 2 * a, A[a] = new $6b76310efa2f0758$var$B(t[l], t[l + 1])) : A[a] = $6b76310efa2f0758$var$X($6b76310efa2f0758$var$_(A[a - 2]), A[a - 7], $6b76310efa2f0758$var$O(A[a - 15]), A[a - 16]), c = $6b76310efa2f0758$var$z(w, $6b76310efa2f0758$var$P(o), (H = h, S = u, new $6b76310efa2f0758$var$B((E = o).Y & H.Y ^ ~E.Y & S.Y, E.N & H.N ^ ~E.N & S.N)), $6b76310efa2f0758$var$V[a], A[a]), f = $6b76310efa2f0758$var$I($6b76310efa2f0758$var$N(e), $6b76310efa2f0758$var$Y(e, r, i)), w = u, u = h, h = o, o = $6b76310efa2f0758$var$I(s, c), s = i, i = r, r = e, e = $6b76310efa2f0758$var$I(c, f);
    var E, H, S;
    return n[0] = $6b76310efa2f0758$var$I(e, n[0]), n[1] = $6b76310efa2f0758$var$I(r, n[1]), n[2] = $6b76310efa2f0758$var$I(i, n[2]), n[3] = $6b76310efa2f0758$var$I(s, n[3]), n[4] = $6b76310efa2f0758$var$I(o, n[4]), n[5] = $6b76310efa2f0758$var$I(h, n[5]), n[6] = $6b76310efa2f0758$var$I(u, n[6]), n[7] = $6b76310efa2f0758$var$I(w, n[7]), n;
}
var $6b76310efa2f0758$var$q = /*#__PURE__*/ function(f) {
    "use strict";
    (0, $ftJVG._)(q, f);
    var _super = (0, $6OZAO._)(q);
    function q(t, n, r) {
        (0, $978gY._)(this, q);
        var _this;
        if ("SHA-384" !== t && "SHA-512" !== t) throw new Error($6b76310efa2f0758$var$h);
        _this = _super.call(this, t, n, r);
        var i = r || {};
        _this.T = _this.k, _this.L = !0, _this.K = -1, _this.m = $6b76310efa2f0758$var$e(_this.t, _this.i, _this.K), _this.R = $6b76310efa2f0758$var$j, _this.g = function(t) {
            return t.slice();
        }, _this.B = $6b76310efa2f0758$var$Z, _this.F = function(n, e, r, i) {
            return function(t, n, e, r, i) {
                var s, o;
                var h = 31 + (n + 129 >>> 10 << 5), u = n + e;
                for(; t.length <= h;)t.push(0);
                for(t[n >>> 5] |= 128 << 24 - n % 32, t[h] = 4294967295 & u, t[h - 1] = u / 4294967296 | 0, s = 0; s < t.length; s += 32)r = $6b76310efa2f0758$var$j(t.slice(s, s + 32), r);
                return o = "SHA-384" === i ? [
                    r[0].Y,
                    r[0].N,
                    r[1].Y,
                    r[1].N,
                    r[2].Y,
                    r[2].N,
                    r[3].Y,
                    r[3].N,
                    r[4].Y,
                    r[4].N,
                    r[5].Y,
                    r[5].N
                ] : [
                    r[0].Y,
                    r[0].N,
                    r[1].Y,
                    r[1].N,
                    r[2].Y,
                    r[2].N,
                    r[3].Y,
                    r[3].N,
                    r[4].Y,
                    r[4].N,
                    r[5].Y,
                    r[5].N,
                    r[6].Y,
                    r[6].N,
                    r[7].Y,
                    r[7].N
                ], o;
            }(n, e, r, i, t);
        }, _this.C = $6b76310efa2f0758$var$Z(t), _this.p = 1024, _this.U = "SHA-384" === t ? 384 : 512, _this.v = !1, i.hmacKey && _this.M($6b76310efa2f0758$var$c("hmacKey", i.hmacKey, _this.K));
        return _this;
    }
    return q;
}($6b76310efa2f0758$var$f);
var $6b76310efa2f0758$var$D = [
    new $6b76310efa2f0758$var$B(0, 1),
    new $6b76310efa2f0758$var$B(0, 32898),
    new $6b76310efa2f0758$var$B(2147483648, 32906),
    new $6b76310efa2f0758$var$B(2147483648, 2147516416),
    new $6b76310efa2f0758$var$B(0, 32907),
    new $6b76310efa2f0758$var$B(0, 2147483649),
    new $6b76310efa2f0758$var$B(2147483648, 2147516545),
    new $6b76310efa2f0758$var$B(2147483648, 32777),
    new $6b76310efa2f0758$var$B(0, 138),
    new $6b76310efa2f0758$var$B(0, 136),
    new $6b76310efa2f0758$var$B(0, 2147516425),
    new $6b76310efa2f0758$var$B(0, 2147483658),
    new $6b76310efa2f0758$var$B(0, 2147516555),
    new $6b76310efa2f0758$var$B(2147483648, 139),
    new $6b76310efa2f0758$var$B(2147483648, 32905),
    new $6b76310efa2f0758$var$B(2147483648, 32771),
    new $6b76310efa2f0758$var$B(2147483648, 32770),
    new $6b76310efa2f0758$var$B(2147483648, 128),
    new $6b76310efa2f0758$var$B(0, 32778),
    new $6b76310efa2f0758$var$B(2147483648, 2147483658),
    new $6b76310efa2f0758$var$B(2147483648, 2147516545),
    new $6b76310efa2f0758$var$B(2147483648, 32896),
    new $6b76310efa2f0758$var$B(0, 2147483649),
    new $6b76310efa2f0758$var$B(2147483648, 2147516424)
], $6b76310efa2f0758$var$G = [
    [
        0,
        36,
        3,
        41,
        18
    ],
    [
        1,
        44,
        10,
        45,
        2
    ],
    [
        62,
        6,
        43,
        15,
        61
    ],
    [
        28,
        55,
        25,
        21,
        56
    ],
    [
        27,
        20,
        39,
        8,
        14
    ]
];
function $6b76310efa2f0758$var$J(t) {
    var n;
    var e = [];
    for(n = 0; n < 5; n += 1)e[n] = [
        new $6b76310efa2f0758$var$B(0, 0),
        new $6b76310efa2f0758$var$B(0, 0),
        new $6b76310efa2f0758$var$B(0, 0),
        new $6b76310efa2f0758$var$B(0, 0),
        new $6b76310efa2f0758$var$B(0, 0)
    ];
    return e;
}
function $6b76310efa2f0758$var$Q(t) {
    var n;
    var e = [];
    for(n = 0; n < 5; n += 1)e[n] = t[n].slice();
    return e;
}
function $6b76310efa2f0758$var$W(t, n) {
    var e, r, i, s;
    var o = [], h = [];
    if (null !== t) for(r = 0; r < t.length; r += 2)n[(r >>> 1) % 5][(r >>> 1) / 5 | 0] = $6b76310efa2f0758$var$x(n[(r >>> 1) % 5][(r >>> 1) / 5 | 0], new $6b76310efa2f0758$var$B(t[r + 1], t[r]));
    for(e = 0; e < 24; e += 1){
        for(s = $6b76310efa2f0758$var$J(), r = 0; r < 5; r += 1)o[r] = (u = n[r][0], w = n[r][1], c = n[r][2], f = n[r][3], a = n[r][4], new $6b76310efa2f0758$var$B(u.Y ^ w.Y ^ c.Y ^ f.Y ^ a.Y, u.N ^ w.N ^ c.N ^ f.N ^ a.N));
        for(r = 0; r < 5; r += 1)h[r] = $6b76310efa2f0758$var$x(o[(r + 4) % 5], $6b76310efa2f0758$var$L(o[(r + 1) % 5], 1));
        for(r = 0; r < 5; r += 1)for(i = 0; i < 5; i += 1)n[r][i] = $6b76310efa2f0758$var$x(n[r][i], h[r]);
        for(r = 0; r < 5; r += 1)for(i = 0; i < 5; i += 1)s[i][(2 * r + 3 * i) % 5] = $6b76310efa2f0758$var$L(n[r][i], $6b76310efa2f0758$var$G[r][i]);
        for(r = 0; r < 5; r += 1)for(i = 0; i < 5; i += 1)n[r][i] = $6b76310efa2f0758$var$x(s[r][i], new $6b76310efa2f0758$var$B(~s[(r + 1) % 5][i].Y & s[(r + 2) % 5][i].Y, ~s[(r + 1) % 5][i].N & s[(r + 2) % 5][i].N));
        n[0][0] = $6b76310efa2f0758$var$x(n[0][0], $6b76310efa2f0758$var$D[e]);
    }
    var u, w, c, f, a;
    return n;
}
function $6b76310efa2f0758$var$$(t) {
    var n, e, r = 0;
    var i = [
        0,
        0
    ], s = [
        4294967295 & t,
        t / 4294967296 & 2097151
    ];
    for(n = 6; n >= 0; n--)e = s[n >> 2] >>> 8 * n & 255, 0 === e && 0 === r || (i[r + 1 >> 2] |= e << 8 * (r + 1), r += 1);
    return r = 0 !== r ? r : 1, i[0] |= r, {
        value: r + 1 > 4 ? i : [
            i[0]
        ],
        binLen: 8 + 8 * r
    };
}
function $6b76310efa2f0758$var$tt(t) {
    return $6b76310efa2f0758$var$u($6b76310efa2f0758$var$$(t.binLen), t);
}
function $6b76310efa2f0758$var$nt(t, n) {
    var e, r = $6b76310efa2f0758$var$$(n);
    r = $6b76310efa2f0758$var$u(r, t);
    var i = n >>> 2, s = (i - r.value.length % i) % i;
    for(e = 0; e < s; e++)r.value.push(0);
    return r.value;
}
var $6b76310efa2f0758$var$et = /*#__PURE__*/ function(f) {
    "use strict";
    (0, $ftJVG._)(et, f);
    var _super = (0, $6OZAO._)(et);
    function et(t, n, r) {
        (0, $978gY._)(this, et);
        var _this;
        var i = 6, s = 0;
        _this = _super.call(this, t, n, r);
        var o = r || {};
        if (1 !== _this.numRounds) {
            if (o.kmacKey || o.hmacKey) throw new Error("Cannot set numRounds with MAC");
            if ("CSHAKE128" === _this.s || "CSHAKE256" === _this.s) throw new Error("Cannot set numRounds for CSHAKE variants");
        }
        switch(_this.K = 1, _this.m = $6b76310efa2f0758$var$e(_this.t, _this.i, _this.K), _this.R = $6b76310efa2f0758$var$W, _this.g = $6b76310efa2f0758$var$Q, _this.B = $6b76310efa2f0758$var$J, _this.C = $6b76310efa2f0758$var$J(), _this.v = !1, t){
            case "SHA3-224":
                _this.p = s = 1152, _this.U = 224, _this.L = !0, _this.T = _this.k;
                break;
            case "SHA3-256":
                _this.p = s = 1088, _this.U = 256, _this.L = !0, _this.T = _this.k;
                break;
            case "SHA3-384":
                _this.p = s = 832, _this.U = 384, _this.L = !0, _this.T = _this.k;
                break;
            case "SHA3-512":
                _this.p = s = 576, _this.U = 512, _this.L = !0, _this.T = _this.k;
                break;
            case "SHAKE128":
                i = 31, _this.p = s = 1344, _this.U = -1, _this.v = !0, _this.L = !1, _this.T = null;
                break;
            case "SHAKE256":
                i = 31, _this.p = s = 1088, _this.U = -1, _this.v = !0, _this.L = !1, _this.T = null;
                break;
            case "KMAC128":
                i = 4, _this.p = s = 1344, _this.I(r), _this.U = -1, _this.v = !0, _this.L = !1, _this.T = _this.X;
                break;
            case "KMAC256":
                i = 4, _this.p = s = 1088, _this.I(r), _this.U = -1, _this.v = !0, _this.L = !1, _this.T = _this.X;
                break;
            case "CSHAKE128":
                _this.p = s = 1344, i = _this._(r), _this.U = -1, _this.v = !0, _this.L = !1, _this.T = null;
                break;
            case "CSHAKE256":
                _this.p = s = 1088, i = _this._(r), _this.U = -1, _this.v = !0, _this.L = !1, _this.T = null;
                break;
            default:
                throw new Error($6b76310efa2f0758$var$h);
        }
        _this.F = function(t, n, e, r, o) {
            return function(t, n, e, r, i, s, o) {
                var h, u, w = 0;
                var _$c = [], _$f = i >>> 5, a = n >>> 5;
                for(h = 0; h < a && n >= i; h += _$f)r = $6b76310efa2f0758$var$W(t.slice(h, h + _$f), r), n -= i;
                for(t = t.slice(h), n %= i; t.length < _$f;)t.push(0);
                for(h = n >>> 3, t[h >> 2] ^= s << h % 4 * 8, t[_$f - 1] ^= 2147483648, r = $6b76310efa2f0758$var$W(t, r); 32 * _$c.length < o && (u = r[w % 5][w / 5 | 0], _$c.push(u.N), !(32 * _$c.length >= o));)_$c.push(u.Y), w += 1, 0 == 64 * w % i && ($6b76310efa2f0758$var$W(null, r), w = 0);
                return _$c;
            }(t, n, 0, r, s, i, o);
        }, o.hmacKey && _this.M($6b76310efa2f0758$var$c("hmacKey", o.hmacKey, _this.K));
        return _this;
    }
    (0, $kry2a._)(et, [
        {
            key: "_",
            value: function _(t, n) {
                var e = function(t) {
                    var _$n = t || {};
                    return {
                        funcName: $6b76310efa2f0758$var$c("funcName", _$n.funcName, 1, {
                            value: [],
                            binLen: 0
                        }),
                        customization: $6b76310efa2f0758$var$c("Customization", _$n.customization, 1, {
                            value: [],
                            binLen: 0
                        })
                    };
                }(t || {});
                n && (e.funcName = n);
                var r = $6b76310efa2f0758$var$u($6b76310efa2f0758$var$tt(e.funcName), $6b76310efa2f0758$var$tt(e.customization));
                if (0 !== e.customization.binLen || 0 !== e.funcName.binLen) {
                    var _$t = $6b76310efa2f0758$var$nt(r, this.p >>> 3);
                    for(var _$n = 0; _$n < _$t.length; _$n += this.p >>> 5)this.C = this.R(_$t.slice(_$n, _$n + (this.p >>> 5)), this.C), this.l += this.p;
                    return 4;
                }
                return 31;
            }
        },
        {
            key: "I",
            value: function I(t) {
                var n = function(t) {
                    var n = t || {};
                    return {
                        kmacKey: $6b76310efa2f0758$var$c("kmacKey", n.kmacKey, 1),
                        funcName: {
                            value: [
                                1128353099
                            ],
                            binLen: 32
                        },
                        customization: $6b76310efa2f0758$var$c("Customization", n.customization, 1, {
                            value: [],
                            binLen: 0
                        })
                    };
                }(t || {});
                this._(t, n.funcName);
                var e = $6b76310efa2f0758$var$nt($6b76310efa2f0758$var$tt(n.kmacKey), this.p >>> 3);
                for(var _$t = 0; _$t < e.length; _$t += this.p >>> 5)this.C = this.R(e.slice(_$t, _$t + (this.p >>> 5)), this.C), this.l += this.p;
                this.A = !0;
            }
        },
        {
            key: "X",
            value: function X(t) {
                var n = $6b76310efa2f0758$var$u({
                    value: this.o.slice(),
                    binLen: this.h
                }, function(t) {
                    var n, e, r = 0;
                    var i = [
                        0,
                        0
                    ], s = [
                        4294967295 & t,
                        t / 4294967296 & 2097151
                    ];
                    for(n = 6; n >= 0; n--)e = s[n >> 2] >>> 8 * n & 255, 0 === e && 0 === r || (i[r >> 2] |= e << 8 * r, r += 1);
                    return r = 0 !== r ? r : 1, i[r >> 2] |= r << 8 * r, {
                        value: r + 1 > 4 ? i : [
                            i[0]
                        ],
                        binLen: 8 + 8 * r
                    };
                }(t.outputLen));
                return this.F(n.value, n.binLen, this.l, this.g(this.C), t.outputLen);
            }
        }
    ]);
    return et;
}($6b76310efa2f0758$var$f);
var $6b76310efa2f0758$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function _class(t, n, e) {
        (0, $978gY._)(this, _class);
        if ("SHA-1" == t) this.O = new $6b76310efa2f0758$var$K(t, n, e);
        else if ("SHA-224" == t || "SHA-256" == t) this.O = new $6b76310efa2f0758$var$g(t, n, e);
        else if ("SHA-384" == t || "SHA-512" == t) this.O = new $6b76310efa2f0758$var$q(t, n, e);
        else {
            if ("SHA3-224" != t && "SHA3-256" != t && "SHA3-384" != t && "SHA3-512" != t && "SHAKE128" != t && "SHAKE256" != t && "CSHAKE128" != t && "CSHAKE256" != t && "KMAC128" != t && "KMAC256" != t) throw new Error($6b76310efa2f0758$var$h);
            this.O = new $6b76310efa2f0758$var$et(t, n, e);
        }
    }
    (0, $kry2a._)(_class, [
        {
            key: "update",
            value: function update(t) {
                this.O.update(t);
            }
        },
        {
            key: "getHash",
            value: function getHash(t, n) {
                return this.O.getHash(t, n);
            }
        },
        {
            key: "setHMACKey",
            value: function setHMACKey(t, n, e) {
                this.O.setHMACKey(t, n, e);
            }
        },
        {
            key: "getHMAC",
            value: function getHMAC(t, n) {
                return this.O.getHMAC(t, n);
            }
        }
    ]);
    return _class;
}();

});

parcelRequire.register("44JIq", function(module, exports) {

(function(nacl) {
    "use strict";
    var ts64 = function ts64(x, i, h, l) {
        x[i] = h >> 24 & 0xff;
        x[i + 1] = h >> 16 & 0xff;
        x[i + 2] = h >> 8 & 0xff;
        x[i + 3] = h & 0xff;
        x[i + 4] = l >> 24 & 0xff;
        x[i + 5] = l >> 16 & 0xff;
        x[i + 6] = l >> 8 & 0xff;
        x[i + 7] = l & 0xff;
    };
    var vn = function vn(x, xi, y, yi, n) {
        var i, d = 0;
        for(i = 0; i < n; i++)d |= x[xi + i] ^ y[yi + i];
        return (1 & d - 1 >>> 8) - 1;
    };
    var crypto_verify_16 = function crypto_verify_16(x, xi, y, yi) {
        return vn(x, xi, y, yi, 16);
    };
    var crypto_verify_32 = function crypto_verify_32(x, xi, y, yi) {
        return vn(x, xi, y, yi, 32);
    };
    var core_salsa20 = function core_salsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        x0 = x0 + j0 | 0;
        x1 = x1 + j1 | 0;
        x2 = x2 + j2 | 0;
        x3 = x3 + j3 | 0;
        x4 = x4 + j4 | 0;
        x5 = x5 + j5 | 0;
        x6 = x6 + j6 | 0;
        x7 = x7 + j7 | 0;
        x8 = x8 + j8 | 0;
        x9 = x9 + j9 | 0;
        x10 = x10 + j10 | 0;
        x11 = x11 + j11 | 0;
        x12 = x12 + j12 | 0;
        x13 = x13 + j13 | 0;
        x14 = x14 + j14 | 0;
        x15 = x15 + j15 | 0;
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x1 >>> 0 & 0xff;
        o[5] = x1 >>> 8 & 0xff;
        o[6] = x1 >>> 16 & 0xff;
        o[7] = x1 >>> 24 & 0xff;
        o[8] = x2 >>> 0 & 0xff;
        o[9] = x2 >>> 8 & 0xff;
        o[10] = x2 >>> 16 & 0xff;
        o[11] = x2 >>> 24 & 0xff;
        o[12] = x3 >>> 0 & 0xff;
        o[13] = x3 >>> 8 & 0xff;
        o[14] = x3 >>> 16 & 0xff;
        o[15] = x3 >>> 24 & 0xff;
        o[16] = x4 >>> 0 & 0xff;
        o[17] = x4 >>> 8 & 0xff;
        o[18] = x4 >>> 16 & 0xff;
        o[19] = x4 >>> 24 & 0xff;
        o[20] = x5 >>> 0 & 0xff;
        o[21] = x5 >>> 8 & 0xff;
        o[22] = x5 >>> 16 & 0xff;
        o[23] = x5 >>> 24 & 0xff;
        o[24] = x6 >>> 0 & 0xff;
        o[25] = x6 >>> 8 & 0xff;
        o[26] = x6 >>> 16 & 0xff;
        o[27] = x6 >>> 24 & 0xff;
        o[28] = x7 >>> 0 & 0xff;
        o[29] = x7 >>> 8 & 0xff;
        o[30] = x7 >>> 16 & 0xff;
        o[31] = x7 >>> 24 & 0xff;
        o[32] = x8 >>> 0 & 0xff;
        o[33] = x8 >>> 8 & 0xff;
        o[34] = x8 >>> 16 & 0xff;
        o[35] = x8 >>> 24 & 0xff;
        o[36] = x9 >>> 0 & 0xff;
        o[37] = x9 >>> 8 & 0xff;
        o[38] = x9 >>> 16 & 0xff;
        o[39] = x9 >>> 24 & 0xff;
        o[40] = x10 >>> 0 & 0xff;
        o[41] = x10 >>> 8 & 0xff;
        o[42] = x10 >>> 16 & 0xff;
        o[43] = x10 >>> 24 & 0xff;
        o[44] = x11 >>> 0 & 0xff;
        o[45] = x11 >>> 8 & 0xff;
        o[46] = x11 >>> 16 & 0xff;
        o[47] = x11 >>> 24 & 0xff;
        o[48] = x12 >>> 0 & 0xff;
        o[49] = x12 >>> 8 & 0xff;
        o[50] = x12 >>> 16 & 0xff;
        o[51] = x12 >>> 24 & 0xff;
        o[52] = x13 >>> 0 & 0xff;
        o[53] = x13 >>> 8 & 0xff;
        o[54] = x13 >>> 16 & 0xff;
        o[55] = x13 >>> 24 & 0xff;
        o[56] = x14 >>> 0 & 0xff;
        o[57] = x14 >>> 8 & 0xff;
        o[58] = x14 >>> 16 & 0xff;
        o[59] = x14 >>> 24 & 0xff;
        o[60] = x15 >>> 0 & 0xff;
        o[61] = x15 >>> 8 & 0xff;
        o[62] = x15 >>> 16 & 0xff;
        o[63] = x15 >>> 24 & 0xff;
    };
    var core_hsalsa20 = function core_hsalsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x5 >>> 0 & 0xff;
        o[5] = x5 >>> 8 & 0xff;
        o[6] = x5 >>> 16 & 0xff;
        o[7] = x5 >>> 24 & 0xff;
        o[8] = x10 >>> 0 & 0xff;
        o[9] = x10 >>> 8 & 0xff;
        o[10] = x10 >>> 16 & 0xff;
        o[11] = x10 >>> 24 & 0xff;
        o[12] = x15 >>> 0 & 0xff;
        o[13] = x15 >>> 8 & 0xff;
        o[14] = x15 >>> 16 & 0xff;
        o[15] = x15 >>> 24 & 0xff;
        o[16] = x6 >>> 0 & 0xff;
        o[17] = x6 >>> 8 & 0xff;
        o[18] = x6 >>> 16 & 0xff;
        o[19] = x6 >>> 24 & 0xff;
        o[20] = x7 >>> 0 & 0xff;
        o[21] = x7 >>> 8 & 0xff;
        o[22] = x7 >>> 16 & 0xff;
        o[23] = x7 >>> 24 & 0xff;
        o[24] = x8 >>> 0 & 0xff;
        o[25] = x8 >>> 8 & 0xff;
        o[26] = x8 >>> 16 & 0xff;
        o[27] = x8 >>> 24 & 0xff;
        o[28] = x9 >>> 0 & 0xff;
        o[29] = x9 >>> 8 & 0xff;
        o[30] = x9 >>> 16 & 0xff;
        o[31] = x9 >>> 24 & 0xff;
    };
    var crypto_core_salsa20 = function crypto_core_salsa20(out, inp, k, c) {
        core_salsa20(out, inp, k, c);
    };
    var crypto_core_hsalsa20 = function crypto_core_hsalsa20(out, inp, k, c) {
        core_hsalsa20(out, inp, k, c);
    };
    var crypto_stream_salsa20_xor = // "expand 32-byte k"
    function crypto_stream_salsa20_xor(c, cpos, m, mpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = m[mpos + i] ^ x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
            mpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = m[mpos + i] ^ x[i];
        }
        return 0;
    };
    var crypto_stream_salsa20 = function crypto_stream_salsa20(c, cpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = x[i];
        }
        return 0;
    };
    var crypto_stream = function crypto_stream(c, cpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20(c, cpos, d, sn, s);
    };
    var crypto_stream_xor = function crypto_stream_xor(c, cpos, m, mpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20_xor(c, cpos, m, mpos, d, sn, s);
    };
    var crypto_onetimeauth = function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
        var s = new poly1305(k);
        s.update(m, mpos, n);
        s.finish(out, outpos);
        return 0;
    };
    var crypto_onetimeauth_verify = function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
        var x = new Uint8Array(16);
        crypto_onetimeauth(x, 0, m, mpos, n, k);
        return crypto_verify_16(h, hpos, x, 0);
    };
    var crypto_secretbox = function crypto_secretbox(c, m, d, n, k) {
        var i;
        if (d < 32) return -1;
        crypto_stream_xor(c, 0, m, 0, d, n, k);
        crypto_onetimeauth(c, 16, c, 32, d - 32, c);
        for(i = 0; i < 16; i++)c[i] = 0;
        return 0;
    };
    var crypto_secretbox_open = function crypto_secretbox_open(m, c, d, n, k) {
        var i;
        var x = new Uint8Array(32);
        if (d < 32) return -1;
        crypto_stream(x, 0, 32, n, k);
        if (crypto_onetimeauth_verify(c, 16, c, 32, d - 32, x) !== 0) return -1;
        crypto_stream_xor(m, 0, c, 0, d, n, k);
        for(i = 0; i < 32; i++)m[i] = 0;
        return 0;
    };
    var set25519 = function set25519(r, a) {
        var i;
        for(i = 0; i < 16; i++)r[i] = a[i] | 0;
    };
    var car25519 = function car25519(o) {
        var i, v, c = 1;
        for(i = 0; i < 16; i++){
            v = o[i] + c + 65535;
            c = Math.floor(v / 65536);
            o[i] = v - c * 65536;
        }
        o[0] += c - 1 + 37 * (c - 1);
    };
    var sel25519 = function sel25519(p, q, b) {
        var t, c = ~(b - 1);
        for(var i = 0; i < 16; i++){
            t = c & (p[i] ^ q[i]);
            p[i] ^= t;
            q[i] ^= t;
        }
    };
    var pack25519 = function pack25519(o, n) {
        var i, j, b;
        var m = gf(), t = gf();
        for(i = 0; i < 16; i++)t[i] = n[i];
        car25519(t);
        car25519(t);
        car25519(t);
        for(j = 0; j < 2; j++){
            m[0] = t[0] - 0xffed;
            for(i = 1; i < 15; i++){
                m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
                m[i - 1] &= 0xffff;
            }
            m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
            b = m[15] >> 16 & 1;
            m[14] &= 0xffff;
            sel25519(t, m, 1 - b);
        }
        for(i = 0; i < 16; i++){
            o[2 * i] = t[i] & 0xff;
            o[2 * i + 1] = t[i] >> 8;
        }
    };
    var neq25519 = function neq25519(a, b) {
        var c = new Uint8Array(32), d = new Uint8Array(32);
        pack25519(c, a);
        pack25519(d, b);
        return crypto_verify_32(c, 0, d, 0);
    };
    var par25519 = function par25519(a) {
        var d = new Uint8Array(32);
        pack25519(d, a);
        return d[0] & 1;
    };
    var unpack25519 = function unpack25519(o, n) {
        var i;
        for(i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
        o[15] &= 0x7fff;
    };
    var A = function A(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] + b[i];
    };
    var Z = function Z(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] - b[i];
    };
    var M = function M(o, a, b) {
        var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
        v = a[0];
        t0 += v * b0;
        t1 += v * b1;
        t2 += v * b2;
        t3 += v * b3;
        t4 += v * b4;
        t5 += v * b5;
        t6 += v * b6;
        t7 += v * b7;
        t8 += v * b8;
        t9 += v * b9;
        t10 += v * b10;
        t11 += v * b11;
        t12 += v * b12;
        t13 += v * b13;
        t14 += v * b14;
        t15 += v * b15;
        v = a[1];
        t1 += v * b0;
        t2 += v * b1;
        t3 += v * b2;
        t4 += v * b3;
        t5 += v * b4;
        t6 += v * b5;
        t7 += v * b6;
        t8 += v * b7;
        t9 += v * b8;
        t10 += v * b9;
        t11 += v * b10;
        t12 += v * b11;
        t13 += v * b12;
        t14 += v * b13;
        t15 += v * b14;
        t16 += v * b15;
        v = a[2];
        t2 += v * b0;
        t3 += v * b1;
        t4 += v * b2;
        t5 += v * b3;
        t6 += v * b4;
        t7 += v * b5;
        t8 += v * b6;
        t9 += v * b7;
        t10 += v * b8;
        t11 += v * b9;
        t12 += v * b10;
        t13 += v * b11;
        t14 += v * b12;
        t15 += v * b13;
        t16 += v * b14;
        t17 += v * b15;
        v = a[3];
        t3 += v * b0;
        t4 += v * b1;
        t5 += v * b2;
        t6 += v * b3;
        t7 += v * b4;
        t8 += v * b5;
        t9 += v * b6;
        t10 += v * b7;
        t11 += v * b8;
        t12 += v * b9;
        t13 += v * b10;
        t14 += v * b11;
        t15 += v * b12;
        t16 += v * b13;
        t17 += v * b14;
        t18 += v * b15;
        v = a[4];
        t4 += v * b0;
        t5 += v * b1;
        t6 += v * b2;
        t7 += v * b3;
        t8 += v * b4;
        t9 += v * b5;
        t10 += v * b6;
        t11 += v * b7;
        t12 += v * b8;
        t13 += v * b9;
        t14 += v * b10;
        t15 += v * b11;
        t16 += v * b12;
        t17 += v * b13;
        t18 += v * b14;
        t19 += v * b15;
        v = a[5];
        t5 += v * b0;
        t6 += v * b1;
        t7 += v * b2;
        t8 += v * b3;
        t9 += v * b4;
        t10 += v * b5;
        t11 += v * b6;
        t12 += v * b7;
        t13 += v * b8;
        t14 += v * b9;
        t15 += v * b10;
        t16 += v * b11;
        t17 += v * b12;
        t18 += v * b13;
        t19 += v * b14;
        t20 += v * b15;
        v = a[6];
        t6 += v * b0;
        t7 += v * b1;
        t8 += v * b2;
        t9 += v * b3;
        t10 += v * b4;
        t11 += v * b5;
        t12 += v * b6;
        t13 += v * b7;
        t14 += v * b8;
        t15 += v * b9;
        t16 += v * b10;
        t17 += v * b11;
        t18 += v * b12;
        t19 += v * b13;
        t20 += v * b14;
        t21 += v * b15;
        v = a[7];
        t7 += v * b0;
        t8 += v * b1;
        t9 += v * b2;
        t10 += v * b3;
        t11 += v * b4;
        t12 += v * b5;
        t13 += v * b6;
        t14 += v * b7;
        t15 += v * b8;
        t16 += v * b9;
        t17 += v * b10;
        t18 += v * b11;
        t19 += v * b12;
        t20 += v * b13;
        t21 += v * b14;
        t22 += v * b15;
        v = a[8];
        t8 += v * b0;
        t9 += v * b1;
        t10 += v * b2;
        t11 += v * b3;
        t12 += v * b4;
        t13 += v * b5;
        t14 += v * b6;
        t15 += v * b7;
        t16 += v * b8;
        t17 += v * b9;
        t18 += v * b10;
        t19 += v * b11;
        t20 += v * b12;
        t21 += v * b13;
        t22 += v * b14;
        t23 += v * b15;
        v = a[9];
        t9 += v * b0;
        t10 += v * b1;
        t11 += v * b2;
        t12 += v * b3;
        t13 += v * b4;
        t14 += v * b5;
        t15 += v * b6;
        t16 += v * b7;
        t17 += v * b8;
        t18 += v * b9;
        t19 += v * b10;
        t20 += v * b11;
        t21 += v * b12;
        t22 += v * b13;
        t23 += v * b14;
        t24 += v * b15;
        v = a[10];
        t10 += v * b0;
        t11 += v * b1;
        t12 += v * b2;
        t13 += v * b3;
        t14 += v * b4;
        t15 += v * b5;
        t16 += v * b6;
        t17 += v * b7;
        t18 += v * b8;
        t19 += v * b9;
        t20 += v * b10;
        t21 += v * b11;
        t22 += v * b12;
        t23 += v * b13;
        t24 += v * b14;
        t25 += v * b15;
        v = a[11];
        t11 += v * b0;
        t12 += v * b1;
        t13 += v * b2;
        t14 += v * b3;
        t15 += v * b4;
        t16 += v * b5;
        t17 += v * b6;
        t18 += v * b7;
        t19 += v * b8;
        t20 += v * b9;
        t21 += v * b10;
        t22 += v * b11;
        t23 += v * b12;
        t24 += v * b13;
        t25 += v * b14;
        t26 += v * b15;
        v = a[12];
        t12 += v * b0;
        t13 += v * b1;
        t14 += v * b2;
        t15 += v * b3;
        t16 += v * b4;
        t17 += v * b5;
        t18 += v * b6;
        t19 += v * b7;
        t20 += v * b8;
        t21 += v * b9;
        t22 += v * b10;
        t23 += v * b11;
        t24 += v * b12;
        t25 += v * b13;
        t26 += v * b14;
        t27 += v * b15;
        v = a[13];
        t13 += v * b0;
        t14 += v * b1;
        t15 += v * b2;
        t16 += v * b3;
        t17 += v * b4;
        t18 += v * b5;
        t19 += v * b6;
        t20 += v * b7;
        t21 += v * b8;
        t22 += v * b9;
        t23 += v * b10;
        t24 += v * b11;
        t25 += v * b12;
        t26 += v * b13;
        t27 += v * b14;
        t28 += v * b15;
        v = a[14];
        t14 += v * b0;
        t15 += v * b1;
        t16 += v * b2;
        t17 += v * b3;
        t18 += v * b4;
        t19 += v * b5;
        t20 += v * b6;
        t21 += v * b7;
        t22 += v * b8;
        t23 += v * b9;
        t24 += v * b10;
        t25 += v * b11;
        t26 += v * b12;
        t27 += v * b13;
        t28 += v * b14;
        t29 += v * b15;
        v = a[15];
        t15 += v * b0;
        t16 += v * b1;
        t17 += v * b2;
        t18 += v * b3;
        t19 += v * b4;
        t20 += v * b5;
        t21 += v * b6;
        t22 += v * b7;
        t23 += v * b8;
        t24 += v * b9;
        t25 += v * b10;
        t26 += v * b11;
        t27 += v * b12;
        t28 += v * b13;
        t29 += v * b14;
        t30 += v * b15;
        t0 += 38 * t16;
        t1 += 38 * t17;
        t2 += 38 * t18;
        t3 += 38 * t19;
        t4 += 38 * t20;
        t5 += 38 * t21;
        t6 += 38 * t22;
        t7 += 38 * t23;
        t8 += 38 * t24;
        t9 += 38 * t25;
        t10 += 38 * t26;
        t11 += 38 * t27;
        t12 += 38 * t28;
        t13 += 38 * t29;
        t14 += 38 * t30;
        // t15 left as is
        // first car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        // second car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        o[0] = t0;
        o[1] = t1;
        o[2] = t2;
        o[3] = t3;
        o[4] = t4;
        o[5] = t5;
        o[6] = t6;
        o[7] = t7;
        o[8] = t8;
        o[9] = t9;
        o[10] = t10;
        o[11] = t11;
        o[12] = t12;
        o[13] = t13;
        o[14] = t14;
        o[15] = t15;
    };
    var S = function S(o, a) {
        M(o, a, a);
    };
    var inv25519 = function inv25519(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 253; a >= 0; a--){
            S(c, c);
            if (a !== 2 && a !== 4) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    };
    var pow2523 = function pow2523(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 250; a >= 0; a--){
            S(c, c);
            if (a !== 1) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    };
    var crypto_scalarmult = function crypto_scalarmult(q, n, p) {
        var z = new Uint8Array(32);
        var x = new Float64Array(80), r, i;
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf();
        for(i = 0; i < 31; i++)z[i] = n[i];
        z[31] = n[31] & 127 | 64;
        z[0] &= 248;
        unpack25519(x, p);
        for(i = 0; i < 16; i++){
            b[i] = x[i];
            d[i] = a[i] = c[i] = 0;
        }
        a[0] = d[0] = 1;
        for(i = 254; i >= 0; --i){
            r = z[i >>> 3] >>> (i & 7) & 1;
            sel25519(a, b, r);
            sel25519(c, d, r);
            A(e, a, c);
            Z(a, a, c);
            A(c, b, d);
            Z(b, b, d);
            S(d, e);
            S(f, a);
            M(a, c, a);
            M(c, b, e);
            A(e, a, c);
            Z(a, a, c);
            S(b, a);
            Z(c, d, f);
            M(a, c, _121665);
            A(a, a, d);
            M(c, c, a);
            M(a, d, f);
            M(d, b, x);
            S(b, e);
            sel25519(a, b, r);
            sel25519(c, d, r);
        }
        for(i = 0; i < 16; i++){
            x[i + 16] = a[i];
            x[i + 32] = c[i];
            x[i + 48] = b[i];
            x[i + 64] = d[i];
        }
        var x32 = x.subarray(32);
        var x16 = x.subarray(16);
        inv25519(x32, x32);
        M(x16, x16, x32);
        pack25519(q, x16);
        return 0;
    };
    var crypto_scalarmult_base = function crypto_scalarmult_base(q, n) {
        return crypto_scalarmult(q, n, _9);
    };
    var crypto_box_keypair = function crypto_box_keypair(y, x) {
        randombytes(x, 32);
        return crypto_scalarmult_base(y, x);
    };
    var crypto_box_beforenm = function crypto_box_beforenm(k, y, x) {
        var s = new Uint8Array(32);
        crypto_scalarmult(s, x, y);
        return crypto_core_hsalsa20(k, _0, s, sigma);
    };
    var crypto_box = function crypto_box(c, m, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_afternm(c, m, d, n, k);
    };
    var crypto_box_open = function crypto_box_open(m, c, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_open_afternm(m, c, d, n, k);
    };
    var crypto_hashblocks_hl = function crypto_hashblocks_hl(hh, hl, m, n) {
        var wh = new Int32Array(16), wl = new Int32Array(16), bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7, bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7, th, tl, i, j, h, l, a, b, c, d;
        var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
        var pos = 0;
        while(n >= 128){
            for(i = 0; i < 16; i++){
                j = 8 * i + pos;
                wh[i] = m[j + 0] << 24 | m[j + 1] << 16 | m[j + 2] << 8 | m[j + 3];
                wl[i] = m[j + 4] << 24 | m[j + 5] << 16 | m[j + 6] << 8 | m[j + 7];
            }
            for(i = 0; i < 80; i++){
                bh0 = ah0;
                bh1 = ah1;
                bh2 = ah2;
                bh3 = ah3;
                bh4 = ah4;
                bh5 = ah5;
                bh6 = ah6;
                bh7 = ah7;
                bl0 = al0;
                bl1 = al1;
                bl2 = al2;
                bl3 = al3;
                bl4 = al4;
                bl5 = al5;
                bl6 = al6;
                bl7 = al7;
                // add
                h = ah7;
                l = al7;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma1
                h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
                l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Ch
                h = ah4 & ah5 ^ ~ah4 & ah6;
                l = al4 & al5 ^ ~al4 & al6;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // K
                h = K[i * 2];
                l = K[i * 2 + 1];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // w
                h = wh[i % 16];
                l = wl[i % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                th = c & 0xffff | d << 16;
                tl = a & 0xffff | b << 16;
                // add
                h = th;
                l = tl;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma0
                h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
                l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Maj
                h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
                l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh7 = c & 0xffff | d << 16;
                bl7 = a & 0xffff | b << 16;
                // add
                h = bh3;
                l = bl3;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = th;
                l = tl;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh3 = c & 0xffff | d << 16;
                bl3 = a & 0xffff | b << 16;
                ah1 = bh0;
                ah2 = bh1;
                ah3 = bh2;
                ah4 = bh3;
                ah5 = bh4;
                ah6 = bh5;
                ah7 = bh6;
                ah0 = bh7;
                al1 = bl0;
                al2 = bl1;
                al3 = bl2;
                al4 = bl3;
                al5 = bl4;
                al6 = bl5;
                al7 = bl6;
                al0 = bl7;
                if (i % 16 === 15) for(j = 0; j < 16; j++){
                    // add
                    h = wh[j];
                    l = wl[j];
                    a = l & 0xffff;
                    b = l >>> 16;
                    c = h & 0xffff;
                    d = h >>> 16;
                    h = wh[(j + 9) % 16];
                    l = wl[(j + 9) % 16];
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma0
                    th = wh[(j + 1) % 16];
                    tl = wl[(j + 1) % 16];
                    h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                    l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma1
                    th = wh[(j + 14) % 16];
                    tl = wl[(j + 14) % 16];
                    h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                    l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    b += a >>> 16;
                    c += b >>> 16;
                    d += c >>> 16;
                    wh[j] = c & 0xffff | d << 16;
                    wl[j] = a & 0xffff | b << 16;
                }
            }
            // add
            h = ah0;
            l = al0;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[0];
            l = hl[0];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[0] = ah0 = c & 0xffff | d << 16;
            hl[0] = al0 = a & 0xffff | b << 16;
            h = ah1;
            l = al1;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[1];
            l = hl[1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[1] = ah1 = c & 0xffff | d << 16;
            hl[1] = al1 = a & 0xffff | b << 16;
            h = ah2;
            l = al2;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[2];
            l = hl[2];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[2] = ah2 = c & 0xffff | d << 16;
            hl[2] = al2 = a & 0xffff | b << 16;
            h = ah3;
            l = al3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[3];
            l = hl[3];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[3] = ah3 = c & 0xffff | d << 16;
            hl[3] = al3 = a & 0xffff | b << 16;
            h = ah4;
            l = al4;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[4];
            l = hl[4];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[4] = ah4 = c & 0xffff | d << 16;
            hl[4] = al4 = a & 0xffff | b << 16;
            h = ah5;
            l = al5;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[5];
            l = hl[5];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[5] = ah5 = c & 0xffff | d << 16;
            hl[5] = al5 = a & 0xffff | b << 16;
            h = ah6;
            l = al6;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[6];
            l = hl[6];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[6] = ah6 = c & 0xffff | d << 16;
            hl[6] = al6 = a & 0xffff | b << 16;
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[7];
            l = hl[7];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[7] = ah7 = c & 0xffff | d << 16;
            hl[7] = al7 = a & 0xffff | b << 16;
            pos += 128;
            n -= 128;
        }
        return n;
    };
    var crypto_hash = function crypto_hash(out, m, n) {
        var hh = new Int32Array(8), hl = new Int32Array(8), x = new Uint8Array(256), i, b = n;
        hh[0] = 0x6a09e667;
        hh[1] = 0xbb67ae85;
        hh[2] = 0x3c6ef372;
        hh[3] = 0xa54ff53a;
        hh[4] = 0x510e527f;
        hh[5] = 0x9b05688c;
        hh[6] = 0x1f83d9ab;
        hh[7] = 0x5be0cd19;
        hl[0] = 0xf3bcc908;
        hl[1] = 0x84caa73b;
        hl[2] = 0xfe94f82b;
        hl[3] = 0x5f1d36f1;
        hl[4] = 0xade682d1;
        hl[5] = 0x2b3e6c1f;
        hl[6] = 0xfb41bd6b;
        hl[7] = 0x137e2179;
        crypto_hashblocks_hl(hh, hl, m, n);
        n %= 128;
        for(i = 0; i < n; i++)x[i] = m[b - n + i];
        x[n] = 128;
        n = 256 - 128 * (n < 112 ? 1 : 0);
        x[n - 9] = 0;
        ts64(x, n - 8, b / 0x20000000 | 0, b << 3);
        crypto_hashblocks_hl(hh, hl, x, n);
        for(i = 0; i < 8; i++)ts64(out, 8 * i, hh[i], hl[i]);
        return 0;
    };
    var add = function add(p, q) {
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf(), g = gf(), h = gf(), t = gf();
        Z(a, p[1], p[0]);
        Z(t, q[1], q[0]);
        M(a, a, t);
        A(b, p[0], p[1]);
        A(t, q[0], q[1]);
        M(b, b, t);
        M(c, p[3], q[3]);
        M(c, c, D2);
        M(d, p[2], q[2]);
        A(d, d, d);
        Z(e, b, a);
        Z(f, d, c);
        A(g, d, c);
        A(h, b, a);
        M(p[0], e, f);
        M(p[1], h, g);
        M(p[2], g, f);
        M(p[3], e, h);
    };
    var cswap = function cswap(p, q, b) {
        var i;
        for(i = 0; i < 4; i++)sel25519(p[i], q[i], b);
    };
    var pack = function pack(r, p) {
        var tx = gf(), ty = gf(), zi = gf();
        inv25519(zi, p[2]);
        M(tx, p[0], zi);
        M(ty, p[1], zi);
        pack25519(r, ty);
        r[31] ^= par25519(tx) << 7;
    };
    var scalarmult = function scalarmult(p, q, s) {
        var b, i;
        set25519(p[0], gf0);
        set25519(p[1], gf1);
        set25519(p[2], gf1);
        set25519(p[3], gf0);
        for(i = 255; i >= 0; --i){
            b = s[i / 8 | 0] >> (i & 7) & 1;
            cswap(p, q, b);
            add(q, p);
            add(p, p);
            cswap(p, q, b);
        }
    };
    var scalarbase = function scalarbase(p, s) {
        var q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        set25519(q[0], X);
        set25519(q[1], Y);
        set25519(q[2], gf1);
        M(q[3], X, Y);
        scalarmult(p, q, s);
    };
    var crypto_sign_keypair = function crypto_sign_keypair(pk, sk, seeded) {
        var d = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        var i;
        if (!seeded) randombytes(sk, 32);
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        scalarbase(p, d);
        pack(pk, p);
        for(i = 0; i < 32; i++)sk[i + 32] = pk[i];
        return 0;
    };
    var modL = function modL(r, x) {
        var carry, i, j, k;
        for(i = 63; i >= 32; --i){
            carry = 0;
            for(j = i - 32, k = i - 12; j < k; ++j){
                x[j] += carry - 16 * x[i] * L[j - (i - 32)];
                carry = Math.floor((x[j] + 128) / 256);
                x[j] -= carry * 256;
            }
            x[j] += carry;
            x[i] = 0;
        }
        carry = 0;
        for(j = 0; j < 32; j++){
            x[j] += carry - (x[31] >> 4) * L[j];
            carry = x[j] >> 8;
            x[j] &= 255;
        }
        for(j = 0; j < 32; j++)x[j] -= carry * L[j];
        for(i = 0; i < 32; i++){
            x[i + 1] += x[i] >> 8;
            r[i] = x[i] & 255;
        }
    };
    var reduce = function reduce(r) {
        var x = new Float64Array(64), i;
        for(i = 0; i < 64; i++)x[i] = r[i];
        for(i = 0; i < 64; i++)r[i] = 0;
        modL(r, x);
    };
    var crypto_sign = // Note: difference from C - smlen returned, not passed as argument.
    function crypto_sign(sm, m, n, sk) {
        var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
        var i, j, x = new Float64Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        var smlen = n + 64;
        for(i = 0; i < n; i++)sm[64 + i] = m[i];
        for(i = 0; i < 32; i++)sm[32 + i] = d[32 + i];
        crypto_hash(r, sm.subarray(32), n + 32);
        reduce(r);
        scalarbase(p, r);
        pack(sm, p);
        for(i = 32; i < 64; i++)sm[i] = sk[i];
        crypto_hash(h, sm, n + 64);
        reduce(h);
        for(i = 0; i < 64; i++)x[i] = 0;
        for(i = 0; i < 32; i++)x[i] = r[i];
        for(i = 0; i < 32; i++)for(j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
        modL(sm.subarray(32), x);
        return smlen;
    };
    var unpackneg = function unpackneg(r, p) {
        var t = gf(), chk = gf(), num = gf(), den = gf(), den2 = gf(), den4 = gf(), den6 = gf();
        set25519(r[2], gf1);
        unpack25519(r[1], p);
        S(num, r[1]);
        M(den, num, D);
        Z(num, num, r[2]);
        A(den, r[2], den);
        S(den2, den);
        S(den4, den2);
        M(den6, den4, den2);
        M(t, den6, num);
        M(t, t, den);
        pow2523(t, t);
        M(t, t, num);
        M(t, t, den);
        M(t, t, den);
        M(r[0], t, den);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) M(r[0], r[0], I);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) return -1;
        if (par25519(r[0]) === p[31] >> 7) Z(r[0], gf0, r[0]);
        M(r[3], r[0], r[1]);
        return 0;
    };
    var crypto_sign_open = function crypto_sign_open(m, sm, n, pk) {
        var i;
        var t = new Uint8Array(32), h = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ], q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        if (n < 64) return -1;
        if (unpackneg(q, pk)) return -1;
        for(i = 0; i < n; i++)m[i] = sm[i];
        for(i = 0; i < 32; i++)m[i + 32] = pk[i];
        crypto_hash(h, m, n);
        reduce(h);
        scalarmult(p, q, h);
        scalarbase(q, sm.subarray(32));
        add(p, q);
        pack(t, p);
        n -= 64;
        if (crypto_verify_32(sm, 0, t, 0)) {
            for(i = 0; i < n; i++)m[i] = 0;
            return -1;
        }
        for(i = 0; i < n; i++)m[i] = sm[i + 64];
        return n;
    };
    var checkLengths = /* High-level API */ function checkLengths(k, n) {
        if (k.length !== crypto_secretbox_KEYBYTES) throw new Error("bad key size");
        if (n.length !== crypto_secretbox_NONCEBYTES) throw new Error("bad nonce size");
    };
    var checkBoxLengths = function checkBoxLengths(pk, sk) {
        if (pk.length !== crypto_box_PUBLICKEYBYTES) throw new Error("bad public key size");
        if (sk.length !== crypto_box_SECRETKEYBYTES) throw new Error("bad secret key size");
    };
    var checkArrayTypes = function checkArrayTypes() {
        for(var i = 0; i < arguments.length; i++){
            if (!(arguments[i] instanceof Uint8Array)) throw new TypeError("unexpected type, use Uint8Array");
        }
    };
    var cleanup = function cleanup(arr) {
        for(var i = 0; i < arr.length; i++)arr[i] = 0;
    };
    // Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
    // Public domain.
    //
    // Implementation derived from TweetNaCl version 20140427.
    // See for details: http://tweetnacl.cr.yp.to/
    var gf = function gf(init) {
        var i, r = new Float64Array(16);
        if (init) for(i = 0; i < init.length; i++)r[i] = init[i];
        return r;
    };
    //  Pluggable, initialized in high-level API below.
    var randombytes = function randombytes() {
        throw new Error("no PRNG");
    };
    var _0 = new Uint8Array(16);
    var _9 = new Uint8Array(32);
    _9[0] = 9;
    var gf0 = gf(), gf1 = gf([
        1
    ]), _121665 = gf([
        0xdb41,
        1
    ]), D = gf([
        0x78a3,
        0x1359,
        0x4dca,
        0x75eb,
        0xd8ab,
        0x4141,
        0x0a4d,
        0x0070,
        0xe898,
        0x7779,
        0x4079,
        0x8cc7,
        0xfe73,
        0x2b6f,
        0x6cee,
        0x5203
    ]), D2 = gf([
        0xf159,
        0x26b2,
        0x9b94,
        0xebd6,
        0xb156,
        0x8283,
        0x149a,
        0x00e0,
        0xd130,
        0xeef3,
        0x80f2,
        0x198e,
        0xfce7,
        0x56df,
        0xd9dc,
        0x2406
    ]), X = gf([
        0xd51a,
        0x8f25,
        0x2d60,
        0xc956,
        0xa7b2,
        0x9525,
        0xc760,
        0x692c,
        0xdc5c,
        0xfdd6,
        0xe231,
        0xc0a4,
        0x53fe,
        0xcd6e,
        0x36d3,
        0x2169
    ]), Y = gf([
        0x6658,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666
    ]), I = gf([
        0xa0b0,
        0x4a0e,
        0x1b27,
        0xc4ee,
        0xe478,
        0xad2f,
        0x1806,
        0x2f43,
        0xd7a7,
        0x3dfb,
        0x0099,
        0x2b4d,
        0xdf0b,
        0x4fc1,
        0x2480,
        0x2b83
    ]);
    var sigma = new Uint8Array([
        101,
        120,
        112,
        97,
        110,
        100,
        32,
        51,
        50,
        45,
        98,
        121,
        116,
        101,
        32,
        107
    ]);
    /*
* Port of Andrew Moon's Poly1305-donna-16. Public domain.
* https://github.com/floodyberry/poly1305-donna
*/ var poly1305 = function poly1305(key) {
        this.buffer = new Uint8Array(16);
        this.r = new Uint16Array(10);
        this.h = new Uint16Array(10);
        this.pad = new Uint16Array(8);
        this.leftover = 0;
        this.fin = 0;
        var t0, t1, t2, t3, t4, t5, t6, t7;
        t0 = key[0] & 0xff | (key[1] & 0xff) << 8;
        this.r[0] = t0 & 0x1fff;
        t1 = key[2] & 0xff | (key[3] & 0xff) << 8;
        this.r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        t2 = key[4] & 0xff | (key[5] & 0xff) << 8;
        this.r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        t3 = key[6] & 0xff | (key[7] & 0xff) << 8;
        this.r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        t4 = key[8] & 0xff | (key[9] & 0xff) << 8;
        this.r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this.r[5] = t4 >>> 1 & 0x1ffe;
        t5 = key[10] & 0xff | (key[11] & 0xff) << 8;
        this.r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        t6 = key[12] & 0xff | (key[13] & 0xff) << 8;
        this.r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        t7 = key[14] & 0xff | (key[15] & 0xff) << 8;
        this.r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this.r[9] = t7 >>> 5 & 0x007f;
        this.pad[0] = key[16] & 0xff | (key[17] & 0xff) << 8;
        this.pad[1] = key[18] & 0xff | (key[19] & 0xff) << 8;
        this.pad[2] = key[20] & 0xff | (key[21] & 0xff) << 8;
        this.pad[3] = key[22] & 0xff | (key[23] & 0xff) << 8;
        this.pad[4] = key[24] & 0xff | (key[25] & 0xff) << 8;
        this.pad[5] = key[26] & 0xff | (key[27] & 0xff) << 8;
        this.pad[6] = key[28] & 0xff | (key[29] & 0xff) << 8;
        this.pad[7] = key[30] & 0xff | (key[31] & 0xff) << 8;
    };
    poly1305.prototype.blocks = function(m, mpos, bytes) {
        var hibit = this.fin ? 0 : 2048;
        var t0, t1, t2, t3, t4, t5, t6, t7, c;
        var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;
        var h0 = this.h[0], h1 = this.h[1], h2 = this.h[2], h3 = this.h[3], h4 = this.h[4], h5 = this.h[5], h6 = this.h[6], h7 = this.h[7], h8 = this.h[8], h9 = this.h[9];
        var r0 = this.r[0], r1 = this.r[1], r2 = this.r[2], r3 = this.r[3], r4 = this.r[4], r5 = this.r[5], r6 = this.r[6], r7 = this.r[7], r8 = this.r[8], r9 = this.r[9];
        while(bytes >= 16){
            t0 = m[mpos + 0] & 0xff | (m[mpos + 1] & 0xff) << 8;
            h0 += t0 & 0x1fff;
            t1 = m[mpos + 2] & 0xff | (m[mpos + 3] & 0xff) << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            t2 = m[mpos + 4] & 0xff | (m[mpos + 5] & 0xff) << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            t3 = m[mpos + 6] & 0xff | (m[mpos + 7] & 0xff) << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            t4 = m[mpos + 8] & 0xff | (m[mpos + 9] & 0xff) << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            t5 = m[mpos + 10] & 0xff | (m[mpos + 11] & 0xff) << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            t6 = m[mpos + 12] & 0xff | (m[mpos + 13] & 0xff) << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            t7 = m[mpos + 14] & 0xff | (m[mpos + 15] & 0xff) << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            c = 0;
            d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this.h[0] = h0;
        this.h[1] = h1;
        this.h[2] = h2;
        this.h[3] = h3;
        this.h[4] = h4;
        this.h[5] = h5;
        this.h[6] = h6;
        this.h[7] = h7;
        this.h[8] = h8;
        this.h[9] = h9;
    };
    poly1305.prototype.finish = function(mac, macpos) {
        var g = new Uint16Array(10);
        var c, mask, f, i;
        if (this.leftover) {
            i = this.leftover;
            this.buffer[i++] = 1;
            for(; i < 16; i++)this.buffer[i] = 0;
            this.fin = 1;
            this.blocks(this.buffer, 0, 16);
        }
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this.h[i] += c;
            c = this.h[i] >>> 13;
            this.h[i] &= 0x1fff;
        }
        this.h[0] += c * 5;
        c = this.h[0] >>> 13;
        this.h[0] &= 0x1fff;
        this.h[1] += c;
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        this.h[2] += c;
        g[0] = this.h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this.h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this.h[i] = this.h[i] & mask | g[i];
        this.h[0] = (this.h[0] | this.h[1] << 13) & 0xffff;
        this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 0xffff;
        this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 0xffff;
        this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 0xffff;
        this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 0xffff;
        this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 0xffff;
        this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 0xffff;
        this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 0xffff;
        f = this.h[0] + this.pad[0];
        this.h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this.h[i] + this.pad[i] | 0) + (f >>> 16) | 0;
            this.h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this.h[0] >>> 0 & 0xff;
        mac[macpos + 1] = this.h[0] >>> 8 & 0xff;
        mac[macpos + 2] = this.h[1] >>> 0 & 0xff;
        mac[macpos + 3] = this.h[1] >>> 8 & 0xff;
        mac[macpos + 4] = this.h[2] >>> 0 & 0xff;
        mac[macpos + 5] = this.h[2] >>> 8 & 0xff;
        mac[macpos + 6] = this.h[3] >>> 0 & 0xff;
        mac[macpos + 7] = this.h[3] >>> 8 & 0xff;
        mac[macpos + 8] = this.h[4] >>> 0 & 0xff;
        mac[macpos + 9] = this.h[4] >>> 8 & 0xff;
        mac[macpos + 10] = this.h[5] >>> 0 & 0xff;
        mac[macpos + 11] = this.h[5] >>> 8 & 0xff;
        mac[macpos + 12] = this.h[6] >>> 0 & 0xff;
        mac[macpos + 13] = this.h[6] >>> 8 & 0xff;
        mac[macpos + 14] = this.h[7] >>> 0 & 0xff;
        mac[macpos + 15] = this.h[7] >>> 8 & 0xff;
    };
    poly1305.prototype.update = function(m, mpos, bytes) {
        var i, want;
        if (this.leftover) {
            want = 16 - this.leftover;
            if (want > bytes) want = bytes;
            for(i = 0; i < want; i++)this.buffer[this.leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this.leftover += want;
            if (this.leftover < 16) return;
            this.blocks(this.buffer, 0, 16);
            this.leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this.blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(i = 0; i < bytes; i++)this.buffer[this.leftover + i] = m[mpos + i];
            this.leftover += bytes;
        }
    };
    var crypto_box_afternm = crypto_secretbox;
    var crypto_box_open_afternm = crypto_secretbox_open;
    var K = [
        0x428a2f98,
        0xd728ae22,
        0x71374491,
        0x23ef65cd,
        0xb5c0fbcf,
        0xec4d3b2f,
        0xe9b5dba5,
        0x8189dbbc,
        0x3956c25b,
        0xf348b538,
        0x59f111f1,
        0xb605d019,
        0x923f82a4,
        0xaf194f9b,
        0xab1c5ed5,
        0xda6d8118,
        0xd807aa98,
        0xa3030242,
        0x12835b01,
        0x45706fbe,
        0x243185be,
        0x4ee4b28c,
        0x550c7dc3,
        0xd5ffb4e2,
        0x72be5d74,
        0xf27b896f,
        0x80deb1fe,
        0x3b1696b1,
        0x9bdc06a7,
        0x25c71235,
        0xc19bf174,
        0xcf692694,
        0xe49b69c1,
        0x9ef14ad2,
        0xefbe4786,
        0x384f25e3,
        0x0fc19dc6,
        0x8b8cd5b5,
        0x240ca1cc,
        0x77ac9c65,
        0x2de92c6f,
        0x592b0275,
        0x4a7484aa,
        0x6ea6e483,
        0x5cb0a9dc,
        0xbd41fbd4,
        0x76f988da,
        0x831153b5,
        0x983e5152,
        0xee66dfab,
        0xa831c66d,
        0x2db43210,
        0xb00327c8,
        0x98fb213f,
        0xbf597fc7,
        0xbeef0ee4,
        0xc6e00bf3,
        0x3da88fc2,
        0xd5a79147,
        0x930aa725,
        0x06ca6351,
        0xe003826f,
        0x14292967,
        0x0a0e6e70,
        0x27b70a85,
        0x46d22ffc,
        0x2e1b2138,
        0x5c26c926,
        0x4d2c6dfc,
        0x5ac42aed,
        0x53380d13,
        0x9d95b3df,
        0x650a7354,
        0x8baf63de,
        0x766a0abb,
        0x3c77b2a8,
        0x81c2c92e,
        0x47edaee6,
        0x92722c85,
        0x1482353b,
        0xa2bfe8a1,
        0x4cf10364,
        0xa81a664b,
        0xbc423001,
        0xc24b8b70,
        0xd0f89791,
        0xc76c51a3,
        0x0654be30,
        0xd192e819,
        0xd6ef5218,
        0xd6990624,
        0x5565a910,
        0xf40e3585,
        0x5771202a,
        0x106aa070,
        0x32bbd1b8,
        0x19a4c116,
        0xb8d2d0c8,
        0x1e376c08,
        0x5141ab53,
        0x2748774c,
        0xdf8eeb99,
        0x34b0bcb5,
        0xe19b48a8,
        0x391c0cb3,
        0xc5c95a63,
        0x4ed8aa4a,
        0xe3418acb,
        0x5b9cca4f,
        0x7763e373,
        0x682e6ff3,
        0xd6b2b8a3,
        0x748f82ee,
        0x5defb2fc,
        0x78a5636f,
        0x43172f60,
        0x84c87814,
        0xa1f0ab72,
        0x8cc70208,
        0x1a6439ec,
        0x90befffa,
        0x23631e28,
        0xa4506ceb,
        0xde82bde9,
        0xbef9a3f7,
        0xb2c67915,
        0xc67178f2,
        0xe372532b,
        0xca273ece,
        0xea26619c,
        0xd186b8c7,
        0x21c0c207,
        0xeada7dd6,
        0xcde0eb1e,
        0xf57d4f7f,
        0xee6ed178,
        0x06f067aa,
        0x72176fba,
        0x0a637dc5,
        0xa2c898a6,
        0x113f9804,
        0xbef90dae,
        0x1b710b35,
        0x131c471b,
        0x28db77f5,
        0x23047d84,
        0x32caab7b,
        0x40c72493,
        0x3c9ebe0a,
        0x15c9bebc,
        0x431d67c4,
        0x9c100d4c,
        0x4cc5d4be,
        0xcb3e42b6,
        0x597f299c,
        0xfc657e2a,
        0x5fcb6fab,
        0x3ad6faec,
        0x6c44198c,
        0x4a475817
    ];
    var L = new Float64Array([
        0xed,
        0xd3,
        0xf5,
        0x5c,
        0x1a,
        0x63,
        0x12,
        0x58,
        0xd6,
        0x9c,
        0xf7,
        0xa2,
        0xde,
        0xf9,
        0xde,
        0x14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0x10
    ]);
    var crypto_secretbox_KEYBYTES = 32, crypto_secretbox_NONCEBYTES = 24, crypto_secretbox_ZEROBYTES = 32, crypto_secretbox_BOXZEROBYTES = 16, crypto_scalarmult_BYTES = 32, crypto_scalarmult_SCALARBYTES = 32, crypto_box_PUBLICKEYBYTES = 32, crypto_box_SECRETKEYBYTES = 32, crypto_box_BEFORENMBYTES = 32, crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES, crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES, crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES, crypto_sign_BYTES = 64, crypto_sign_PUBLICKEYBYTES = 32, crypto_sign_SECRETKEYBYTES = 64, crypto_sign_SEEDBYTES = 32, crypto_hash_BYTES = 64;
    nacl.lowlevel = {
        crypto_core_hsalsa20: crypto_core_hsalsa20,
        crypto_stream_xor: crypto_stream_xor,
        crypto_stream: crypto_stream,
        crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
        crypto_stream_salsa20: crypto_stream_salsa20,
        crypto_onetimeauth: crypto_onetimeauth,
        crypto_onetimeauth_verify: crypto_onetimeauth_verify,
        crypto_verify_16: crypto_verify_16,
        crypto_verify_32: crypto_verify_32,
        crypto_secretbox: crypto_secretbox,
        crypto_secretbox_open: crypto_secretbox_open,
        crypto_scalarmult: crypto_scalarmult,
        crypto_scalarmult_base: crypto_scalarmult_base,
        crypto_box_beforenm: crypto_box_beforenm,
        crypto_box_afternm: crypto_box_afternm,
        crypto_box: crypto_box,
        crypto_box_open: crypto_box_open,
        crypto_box_keypair: crypto_box_keypair,
        crypto_hash: crypto_hash,
        crypto_sign: crypto_sign,
        crypto_sign_keypair: crypto_sign_keypair,
        crypto_sign_open: crypto_sign_open,
        crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
        crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
        crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
        crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
        crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
        crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
        crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
        crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
        crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
        crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
        crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
        crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
        crypto_sign_BYTES: crypto_sign_BYTES,
        crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
        crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
        crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
        crypto_hash_BYTES: crypto_hash_BYTES,
        gf: gf,
        D: D,
        L: L,
        pack25519: pack25519,
        unpack25519: unpack25519,
        M: M,
        A: A,
        S: S,
        Z: Z,
        pow2523: pow2523,
        add: add,
        set25519: set25519,
        modL: modL,
        scalarmult: scalarmult,
        scalarbase: scalarbase
    };
    nacl.randomBytes = function(n) {
        var b = new Uint8Array(n);
        randombytes(b, n);
        return b;
    };
    nacl.secretbox = function(msg, nonce, key) {
        checkArrayTypes(msg, nonce, key);
        checkLengths(key, nonce);
        var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
        var c = new Uint8Array(m.length);
        for(var i = 0; i < msg.length; i++)m[i + crypto_secretbox_ZEROBYTES] = msg[i];
        crypto_secretbox(c, m, m.length, nonce, key);
        return c.subarray(crypto_secretbox_BOXZEROBYTES);
    };
    nacl.secretbox.open = function(box, nonce, key) {
        checkArrayTypes(box, nonce, key);
        checkLengths(key, nonce);
        var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
        var m = new Uint8Array(c.length);
        for(var i = 0; i < box.length; i++)c[i + crypto_secretbox_BOXZEROBYTES] = box[i];
        if (c.length < 32) return null;
        if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0) return null;
        return m.subarray(crypto_secretbox_ZEROBYTES);
    };
    nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
    nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
    nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;
    nacl.scalarMult = function(n, p) {
        checkArrayTypes(n, p);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error("bad n size");
        if (p.length !== crypto_scalarmult_BYTES) throw new Error("bad p size");
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult(q, n, p);
        return q;
    };
    nacl.scalarMult.base = function(n) {
        checkArrayTypes(n);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error("bad n size");
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult_base(q, n);
        return q;
    };
    nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
    nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;
    nacl.box = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox(msg, nonce, k);
    };
    nacl.box.before = function(publicKey, secretKey) {
        checkArrayTypes(publicKey, secretKey);
        checkBoxLengths(publicKey, secretKey);
        var k = new Uint8Array(crypto_box_BEFORENMBYTES);
        crypto_box_beforenm(k, publicKey, secretKey);
        return k;
    };
    nacl.box.after = nacl.secretbox;
    nacl.box.open = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox.open(msg, nonce, k);
    };
    nacl.box.open.after = nacl.secretbox.open;
    nacl.box.keyPair = function() {
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
        crypto_box_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.box.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_box_SECRETKEYBYTES) throw new Error("bad secret key size");
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        crypto_scalarmult_base(pk, secretKey);
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
    nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
    nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
    nacl.box.nonceLength = crypto_box_NONCEBYTES;
    nacl.box.overheadLength = nacl.secretbox.overheadLength;
    nacl.sign = function(msg, secretKey) {
        checkArrayTypes(msg, secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error("bad secret key size");
        var signedMsg = new Uint8Array(crypto_sign_BYTES + msg.length);
        crypto_sign(signedMsg, msg, msg.length, secretKey);
        return signedMsg;
    };
    nacl.sign.open = function(signedMsg, publicKey) {
        checkArrayTypes(signedMsg, publicKey);
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error("bad public key size");
        var tmp = new Uint8Array(signedMsg.length);
        var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
        if (mlen < 0) return null;
        var m = new Uint8Array(mlen);
        for(var i = 0; i < m.length; i++)m[i] = tmp[i];
        return m;
    };
    nacl.sign.detached = function(msg, secretKey) {
        var signedMsg = nacl.sign(msg, secretKey);
        var sig = new Uint8Array(crypto_sign_BYTES);
        for(var i = 0; i < sig.length; i++)sig[i] = signedMsg[i];
        return sig;
    };
    nacl.sign.detached.verify = function(msg, sig, publicKey) {
        checkArrayTypes(msg, sig, publicKey);
        if (sig.length !== crypto_sign_BYTES) throw new Error("bad signature size");
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error("bad public key size");
        var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
        var m = new Uint8Array(crypto_sign_BYTES + msg.length);
        var i;
        for(i = 0; i < crypto_sign_BYTES; i++)sm[i] = sig[i];
        for(i = 0; i < msg.length; i++)sm[i + crypto_sign_BYTES] = msg[i];
        return crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
    };
    nacl.sign.keyPair = function() {
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        crypto_sign_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error("bad secret key size");
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        for(var i = 0; i < pk.length; i++)pk[i] = secretKey[32 + i];
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.sign.keyPair.fromSeed = function(seed) {
        checkArrayTypes(seed);
        if (seed.length !== crypto_sign_SEEDBYTES) throw new Error("bad seed size");
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        for(var i = 0; i < 32; i++)sk[i] = seed[i];
        crypto_sign_keypair(pk, sk, true);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
    nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
    nacl.sign.seedLength = crypto_sign_SEEDBYTES;
    nacl.sign.signatureLength = crypto_sign_BYTES;
    nacl.hash = function(msg) {
        checkArrayTypes(msg);
        var h = new Uint8Array(crypto_hash_BYTES);
        crypto_hash(h, msg, msg.length);
        return h;
    };
    nacl.hash.hashLength = crypto_hash_BYTES;
    nacl.verify = function(x, y) {
        checkArrayTypes(x, y);
        // Zero length arguments are considered not equal.
        if (x.length === 0 || y.length === 0) return false;
        if (x.length !== y.length) return false;
        return vn(x, 0, y, 0, x.length) === 0 ? true : false;
    };
    nacl.setPRNG = function(fn) {
        randombytes = fn;
    };
    (function() {
        // Initialize PRNG if environment provides CSPRNG.
        // If not, methods calling randombytes will throw.
        var crypto = typeof self !== "undefined" ? self.crypto || self.msCrypto : null;
        if (crypto && crypto.getRandomValues) {
            // Browsers.
            var QUOTA = 65536;
            nacl.setPRNG(function(x, n) {
                var i, v = new Uint8Array(n);
                for(i = 0; i < n; i += QUOTA)crypto.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        } else {
            // Node.js.
            crypto = (parcelRequire("aqbQf"));
            if (crypto && crypto.randomBytes) nacl.setPRNG(function(x, n) {
                var i, v = crypto.randomBytes(n);
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        }
    })();
})((0, module.exports) ? module.exports : self.nacl = self.nacl || {});

});

parcelRequire.register("fIBDJ", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WrapperBuilder = void 0;

var $eqe9p = parcelRequire("eqe9p");

var $cp01f = parcelRequire("cp01f");

var $cwzTA = parcelRequire("cwzTA");

var $efDrj = parcelRequire("efDrj");
var $b71829935a79d4a5$var$WrapperBuilder = /*#__PURE__*/ function() {
    function WrapperBuilder(baseContract) {
        (0, $978gY._)(this, WrapperBuilder);
        this.baseContract = baseContract;
    }
    (0, $kry2a._)(WrapperBuilder, [
        {
            key: "usingDataService",
            value: function usingDataService(dataPackagesRequestParams, urls) {
                return new $cp01f.DataServiceWrapper(dataPackagesRequestParams, urls).overwriteEthersContract(this.baseContract);
            }
        },
        {
            key: "usingMockDataPackages",
            value: function usingMockDataPackages(mockDataPackages) {
                return new $eqe9p.MockWrapper(mockDataPackages).overwriteEthersContract(this.baseContract);
            }
        },
        {
            key: "usingSimpleNumericMock",
            value: function usingSimpleNumericMock(simpleNumericMockConfig) {
                return new $cwzTA.SimpleNumericMockWrapper(simpleNumericMockConfig).overwriteEthersContract(this.baseContract);
            }
        },
        {
            key: "usingOnDemandRequest",
            value: function usingOnDemandRequest(nodeUrls, scoreType) {
                return new $efDrj.OnDemandRequestWrapper({
                    signer: this.baseContract.signer,
                    scoreType: scoreType
                }, nodeUrls).overwriteEthersContract(this.baseContract);
            }
        }
    ], [
        {
            key: "wrap",
            value: function wrap(contract) {
                return new WrapperBuilder(contract);
            }
        }
    ]);
    return WrapperBuilder;
}();
module.exports.WrapperBuilder = $b71829935a79d4a5$var$WrapperBuilder;

});
parcelRequire.register("eqe9p", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MockWrapper = void 0;

var $hyxZy = parcelRequire("hyxZy");

var $8pMIN = parcelRequire("8pMIN");

var $fsQXA = parcelRequire("fsQXA");

var $b3J9M = parcelRequire("b3J9M");
var $a7fe7873ae2a5566$var$MockWrapper = /*#__PURE__*/ function(_BaseWrapper_1_BaseWrapper) {
    (0, $ftJVG._)(MockWrapper, _BaseWrapper_1_BaseWrapper);
    var _super = (0, $6OZAO._)(MockWrapper);
    function MockWrapper(mockDataPackages) {
        (0, $978gY._)(this, MockWrapper);
        var _this;
        _this = _super.call(this);
        _this.mockDataPackages = mockDataPackages;
        return _this;
    }
    (0, $kry2a._)(MockWrapper, [
        {
            key: "getUnsignedMetadata",
            value: function getUnsignedMetadata() {
                return "".concat($b3J9M.version, "#mock");
            }
        },
        {
            key: "dryRunToVerifyPayload",
            value: function dryRunToVerifyPayload(payloads) {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            payloads[0]
                        ];
                    });
                })();
            }
        },
        {
            key: "getBytesDataForAppending",
            value: function getBytesDataForAppending() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var signedDataPackages, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, mockDataPackage, privateKey, signedDataPackage, unsignedMetadata;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        signedDataPackages = [];
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = _this.mockDataPackages[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                mockDataPackage = _step.value;
                                privateKey = (0, $8pMIN.getMockSignerPrivateKey)(mockDataPackage.signer);
                                signedDataPackage = mockDataPackage.dataPackage.sign(privateKey);
                                signedDataPackages.push(signedDataPackage);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        unsignedMetadata = _this.getUnsignedMetadata();
                        return [
                            2,
                            $hyxZy.RedstonePayload.prepare(signedDataPackages, unsignedMetadata)
                        ];
                    });
                })();
            }
        }
    ]);
    return MockWrapper;
}($fsQXA.BaseWrapper);
module.exports.MockWrapper = $a7fe7873ae2a5566$var$MockWrapper;

});
parcelRequire.register("8pMIN", function(module, exports) {

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $fLnyw = parcelRequire("fLnyw");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRange = module.exports.getMockPackageWithOneBytesDataPoint = module.exports.getMockPackageWithOneNumericDataPoint = module.exports.getMockStringPackage = module.exports.getMockNumericPackage = module.exports.getMockSignedDataPackageObj = module.exports.getMockPackage = module.exports.getMockSignerAddress = module.exports.getMockSignerPrivateKey = module.exports.MOCK_SIGNERS = module.exports.MOCK_PRIVATE_KEYS = module.exports.DEFAULT_DATA_FEED_ID_BYTES_32 = module.exports.DEFAULT_DATA_FEED_ID = module.exports.DEFAULT_TIMESTAMP_FOR_TESTS = module.exports.MAX_MOCK_SIGNERS_COUNT = void 0;

var $j2rU8 = parcelRequire("j2rU8");
parcelRequire("blIpd");
var $3A3Dv = parcelRequire("3A3Dv");

var $hyxZy = parcelRequire("hyxZy");
module.exports.MAX_MOCK_SIGNERS_COUNT = 19;
// We lock the timestamp to have deterministic gas consumption
// for being able to compare gas costs of different implementations
module.exports.DEFAULT_TIMESTAMP_FOR_TESTS = 1654353400000;
// Default data feed id
// Used in mock data packages with one data point
module.exports.DEFAULT_DATA_FEED_ID = "SOME LONG STRING FOR DATA FEED ID TO TRIGGER SYMBOL HASHING";
module.exports.DEFAULT_DATA_FEED_ID_BYTES_32 = $hyxZy.utils.convertStringToBytes32(module.exports.DEFAULT_DATA_FEED_ID);
// Well-known private keys, which are used by
// default in hardhat testing environment
module.exports.MOCK_PRIVATE_KEYS = [];
// Address: 0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266
module.exports.MOCK_PRIVATE_KEYS[0] = "0xac0974bec39a17e36ba4a6b4d238ff944bacb478cbed5efcae784d7bf4f2ff80";
// Address: 0x70997970C51812dc3A010C7d01b50e0d17dc79C8
module.exports.MOCK_PRIVATE_KEYS[1] = "0x59c6995e998f97a5a0044966f0945389dc9e86dae88c7a8412f4603b6b78690d";
// Address: 0x3C44CdDdB6a900fa2b585dd299e03d12FA4293BC
module.exports.MOCK_PRIVATE_KEYS[2] = "0x5de4111afa1a4b94908f83103eb1f1706367c2e68ca870fc3fb9a804cdab365a";
// Address: 0x90F79bf6EB2c4f870365E785982E1f101E93b906
module.exports.MOCK_PRIVATE_KEYS[3] = "0x7c852118294e51e653712a81e05800f419141751be58f605c371e15141b007a6";
// Address: 0x15d34AAf54267DB7D7c367839AAf71A00a2C6A65
module.exports.MOCK_PRIVATE_KEYS[4] = "0x47e179ec197488593b187f80a00eb0da91f1b9d0b13f8733639f19c30a34926a";
// Address: 0x9965507D1a55bcC2695C58ba16FB37d819B0A4dc
module.exports.MOCK_PRIVATE_KEYS[5] = "0x8b3a350cf5c34c9194ca85829a2df0ec3153be0318b5e2d3348e872092edffba";
// Address: 0x976EA74026E726554dB657fA54763abd0C3a0aa9
module.exports.MOCK_PRIVATE_KEYS[6] = "0x92db14e403b83dfe3df233f83dfa3a0d7096f21ca9b0d6d6b8d88b2b4ec1564e";
// Address: 0x14dC79964da2C08b23698B3D3cc7Ca32193d9955
module.exports.MOCK_PRIVATE_KEYS[7] = "0x4bbbf85ce3377467afe5d46f804f221813b2bb87f24d81f60f1fcdbf7cbf4356";
// Address: 0x23618e81E3f5cdF7f54C3d65f7FBc0aBf5B21E8f
module.exports.MOCK_PRIVATE_KEYS[8] = "0xdbda1821b80551c9d65939329250298aa3472ba22feea921c0cf5d620ea67b97";
// Address: 0xa0Ee7A142d267C1f36714E4a8F75612F20a79720
module.exports.MOCK_PRIVATE_KEYS[9] = "0x2a871d0798f97d79848a013d4936a73bf4cc922c825d33c1cf7073dff6d409c6";
// Address: 0xBcd4042DE499D14e55001CcbB24a551F3b954096
module.exports.MOCK_PRIVATE_KEYS[10] = "0xf214f2b2cd398c806f84e317254e0f0b801d0643303237d97a22a48e01628897";
// Address: 0x71bE63f3384f5fb98995898A86B02Fb2426c5788
module.exports.MOCK_PRIVATE_KEYS[11] = "0x701b615bbdfb9de65240bc28bd21bbc0d996645a3dd57e7b12bc2bdf6f192c82";
// Address: 0xFABB0ac9d68B0B445fB7357272Ff202C5651694a
module.exports.MOCK_PRIVATE_KEYS[12] = "0xa267530f49f8280200edf313ee7af6b827f2a8bce2897751d06a843f644967b1";
// Address: 0x1CBd3b2770909D4e10f157cABC84C7264073C9Ec
module.exports.MOCK_PRIVATE_KEYS[13] = "0x47c99abed3324a2707c28affff1267e45918ec8c3f20b8aa892e8b065d2942dd";
// Address: 0xdF3e18d64BC6A983f673Ab319CCaE4f1a57C7097
module.exports.MOCK_PRIVATE_KEYS[14] = "0xc526ee95bf44d8fc405a158bb884d9d1238d99f0612e9f33d006bb0789009aaa";
// Address: 0xcd3B766CCDd6AE721141F452C550Ca635964ce71
module.exports.MOCK_PRIVATE_KEYS[15] = "0x8166f546bab6da521a8369cab06c5d2b9e46670292d85c875ee9ec20e84ffb61";
// Address: 0x2546BcD3c84621e976D8185a91A922aE77ECEc30
module.exports.MOCK_PRIVATE_KEYS[16] = "0xea6c44ac03bff858b476bba40716402b03e41b8e97e276d1baec7c37d42484a0";
// Address: 0xbDA5747bFD65F08deb54cb465eB87D40e51B197E
module.exports.MOCK_PRIVATE_KEYS[17] = "0x689af8efa8c651a91ad287602527f3af2fe9f6501a7ac4b061667b5a93e037fd";
// Address: 0xdD2FD4581271e230360230F9337D5c0430Bf44C0
module.exports.MOCK_PRIVATE_KEYS[18] = "0xde9be858da4a475276426320d5e9262ecfc3ba460bfac56360bfa6c4c28b4ee0";
// Address: 0x8626f6940E2eb28930eFb4CeF49B2d1F2C9C1199
module.exports.MOCK_PRIVATE_KEYS[19] = "0xdf57089febbacf7ba0bc227dafbffa9fc08a93fdc68e1e42411a14efcf23656e";
module.exports.MOCK_SIGNERS = module.exports.MOCK_PRIVATE_KEYS.map(function(privateKey) {
    return new $3A3Dv.Wallet(privateKey);
});
var $620673a217d323be$var$getMockSignerPrivateKey = function(mockSignerAddress) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = module.exports.MOCK_PRIVATE_KEYS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var privateKey = _step.value;
            var address = new $3A3Dv.Wallet(privateKey).address;
            if (address === mockSignerAddress) return privateKey;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    throw new Error("Invalid mock signer address: ".concat(mockSignerAddress));
};
module.exports.getMockSignerPrivateKey = $620673a217d323be$var$getMockSignerPrivateKey;
var $620673a217d323be$var$getMockSignerAddress = function(signerIndex) {
    var address = new $3A3Dv.Wallet(module.exports.MOCK_PRIVATE_KEYS[signerIndex]).address;
    return address;
};
module.exports.getMockSignerAddress = $620673a217d323be$var$getMockSignerAddress;
var $620673a217d323be$var$getMockPackage = function(opts, dataPoints) {
    var timestampMilliseconds = opts.timestampMilliseconds || module.exports.DEFAULT_TIMESTAMP_FOR_TESTS;
    return {
        signer: module.exports.MOCK_SIGNERS[opts.mockSignerIndex].address,
        dataPackage: new $hyxZy.DataPackage(dataPoints, timestampMilliseconds)
    };
};
module.exports.getMockPackage = $620673a217d323be$var$getMockPackage;
var $620673a217d323be$var$getMockSignedDataPackageObj = function(args) {
    var numericDataPoints = args.dataPoints.map(function(dp) {
        return new $hyxZy.NumericDataPoint(dp);
    });
    var mockPackage = (0, module.exports.getMockPackage)(args, numericDataPoints);
    return (0, $8OnJk._)({}, mockPackage.dataPackage.sign(module.exports.MOCK_SIGNERS[args.mockSignerIndex].privateKey).toObj());
};
module.exports.getMockSignedDataPackageObj = $620673a217d323be$var$getMockSignedDataPackageObj;
var $620673a217d323be$var$getMockNumericPackage = function(args) {
    var numericDataPoints = args.dataPoints.map(function(dp) {
        return new $hyxZy.NumericDataPoint(dp);
    });
    return (0, module.exports.getMockPackage)(args, numericDataPoints);
};
module.exports.getMockNumericPackage = $620673a217d323be$var$getMockNumericPackage;
var $620673a217d323be$var$getMockStringPackage = function(args) {
    var stringDataPoints = args.dataPoints.map(function(dp) {
        return new $hyxZy.StringDataPoint(dp);
    });
    return (0, module.exports.getMockPackage)(args, stringDataPoints);
};
module.exports.getMockStringPackage = $620673a217d323be$var$getMockStringPackage;
var $620673a217d323be$var$getMockPackageWithOneNumericDataPoint = function(args) {
    var numericDataPoint = new $hyxZy.NumericDataPoint((0, $8E768._)((0, $8OnJk._)({}, args), {
        dataFeedId: args.dataFeedId || module.exports.DEFAULT_DATA_FEED_ID
    }));
    return (0, module.exports.getMockPackage)(args, [
        numericDataPoint
    ]);
};
module.exports.getMockPackageWithOneNumericDataPoint = $620673a217d323be$var$getMockPackageWithOneNumericDataPoint;
var $620673a217d323be$var$getMockPackageWithOneBytesDataPoint = function(args) {
    var dataPoint = new $hyxZy.DataPoint(args.dataFeedId || module.exports.DEFAULT_DATA_FEED_ID, (0, $j2rU8.arrayify)(args.hexValue));
    return (0, module.exports.getMockPackage)(args, [
        dataPoint
    ]);
};
module.exports.getMockPackageWithOneBytesDataPoint = $620673a217d323be$var$getMockPackageWithOneBytesDataPoint;
// Prepares an array with sequential numbers
var $620673a217d323be$var$getRange = function(rangeArgs) {
    return (0, $fLnyw._)(Array(rangeArgs.length).keys()).map(function(i) {
        return i += rangeArgs.start;
    });
};
module.exports.getRange = $620673a217d323be$var$getRange;

});

parcelRequire.register("fsQXA", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseWrapper = void 0;

var $7cve4 = parcelRequire("7cve4");
var $b4228d52b46737ae$var$BaseWrapper = /*#__PURE__*/ function() {
    function BaseWrapper() {
        (0, $978gY._)(this, BaseWrapper);
    }
    (0, $kry2a._)(BaseWrapper, [
        {
            key: "overwriteEthersContract",
            value: function overwriteEthersContract(contract) {
                var wrapper = this;
                var contractPrototype = Object.getPrototypeOf(contract);
                var wrappedContract = Object.assign(Object.create(contractPrototype), contract);
                var functionNames = Object.keys(contract.functions);
                functionNames.forEach(function(functionName) {
                    if (functionName.indexOf("(") == -1) {
                        var isCall = contract.interface.getFunction(functionName).constant;
                        wrappedContract[functionName] = /*#__PURE__*/ (0, $byzP8._)(function() {
                            var _len, args, _key, _contract_populateTransaction, tx, dataToAppend, result, decoded, sentTx;
                            var _arguments = arguments;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                            args[_key] = _arguments[_key];
                                        }
                                        return [
                                            4,
                                            (_contract_populateTransaction = contract.populateTransaction)[functionName].apply(_contract_populateTransaction, (0, $fLnyw._)(args))
                                        ];
                                    case 1:
                                        tx = _state.sent();
                                        return [
                                            4,
                                            wrapper.getBytesDataForAppending({
                                                functionName: functionName,
                                                contract: contract,
                                                transaction: tx
                                            })
                                        ];
                                    case 2:
                                        dataToAppend = _state.sent();
                                        tx.data = tx.data + dataToAppend;
                                        if (!isCall) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            contract.signer.call(tx)
                                        ];
                                    case 3:
                                        result = _state.sent();
                                        decoded = contract.interface.decodeFunctionResult(functionName, result);
                                        return [
                                            2,
                                            decoded.length == 1 ? decoded[0] : decoded
                                        ];
                                    case 4:
                                        return [
                                            4,
                                            contract.signer.sendTransaction(tx)
                                        ];
                                    case 5:
                                        sentTx = _state.sent();
                                        // Tweak the tx.wait so the receipt has extra properties
                                        (0, $7cve4.addContractWait)(contract, sentTx);
                                        return [
                                            2,
                                            sentTx
                                        ];
                                    case 6:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                });
                return wrappedContract;
            }
        }
    ]);
    return BaseWrapper;
}();
module.exports.BaseWrapper = $b4228d52b46737ae$var$BaseWrapper;

});
parcelRequire.register("7cve4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addContractWait = void 0;

var $hbWVX = parcelRequire("hbWVX");
// Copied from ethers.js source code
var $53e1e0328263279c$var$addContractWait = function(contract, tx) {
    var wait = tx.wait.bind(tx);
    tx.wait = function(confirmations) {
        return wait(confirmations).then(function(receipt) {
            receipt.events = receipt.logs.map(function(log) {
                var event = (0, $hbWVX.deepCopy)(log);
                // let parsed: LogDescription = null;
                var parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                } catch (e) {}
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = function(data, topics) {
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = function() {
                    return contract.provider;
                };
                event.getBlock = function() {
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = function() {
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = function() {
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
};
module.exports.addContractWait = $53e1e0328263279c$var$addContractWait;

});


parcelRequire.register("b3J9M", function(module, exports) {
module.exports = JSON.parse('{"name":"@redstone-finance/evm-connector","version":"0.0.18","description":"A tool to inject RedStone data into EVM compatible smart contracts","main":"dist/src/index.js","license":"MIT","scripts":{"test":"hardhat test","build":"rm -rf dist && tsc -build","benchmark":"hardhat test benchmarks/run-benchmarks.ts","compile":"hardhat compile","postversion":"yarn build && git commit -a -m \\"build: $npm_package_name@$npm_package_version\\" && git push"},"dependencies":{"@openzeppelin/contracts":"^4.7.3","axios":"^1.1.3","ethers":"^5.6.8","redstone-protocol":"1.0.5","redstone-sdk":"1.0.7"},"devDependencies":{"@ethersproject/abi":"^5.6.3","@ethersproject/bytes":"^5.6.1","@ethersproject/providers":"^5.6.8","@nomiclabs/hardhat-ethers":"^2.0.6","@nomiclabs/hardhat-waffle":"^2.0.3","@openzeppelin/contracts-upgradeable":"^4.6.0","@typechain/ethers-v5":"^10.0.0","@typechain/hardhat":"^6.0.0","@types/chai":"^4.3.1","@types/chai-as-promised":"^7.1.5","@types/mocha":"^9.1.1","@types/node":"^17.0.37","chai":"^4.3.6","chai-as-promised":"^7.1.1","ethereum-waffle":"^3.4.4","hardhat":"^2.9.7","hardhat-gas-reporter":"^1.0.8","msw":"^0.47.4","prettier-plugin-solidity":"^1.0.0-beta.19","ts-node":"^10.8.0","typechain":"^8.0.0"},"files":["dist/**/*","contracts/**/*"]}');

});


parcelRequire.register("cp01f", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataServiceWrapper = void 0;

var $jCJsd = parcelRequire("jCJsd");

var $fsQXA = parcelRequire("fsQXA");

var $b3J9M = parcelRequire("b3J9M");

var $5QkXC = parcelRequire("5QkXC");
var $9077d5a5e87b769c$var$DataServiceWrapper = /*#__PURE__*/ function(_BaseWrapper_1_BaseWrapper) {
    (0, $ftJVG._)(DataServiceWrapper, _BaseWrapper_1_BaseWrapper);
    var _super = (0, $6OZAO._)(DataServiceWrapper);
    function DataServiceWrapper(dataPackagesRequestParams, urls) {
        (0, $978gY._)(this, DataServiceWrapper);
        var _this;
        _this = _super.call(this);
        _this.dataPackagesRequestParams = dataPackagesRequestParams;
        _this.urls = urls;
        return _this;
    }
    (0, $kry2a._)(DataServiceWrapper, [
        {
            key: "getUnsignedMetadata",
            value: function getUnsignedMetadata() {
                return "".concat($b3J9M.version, "#").concat(this.dataPackagesRequestParams.dataServiceId);
            }
        },
        {
            key: "getBytesDataForAppending",
            value: function getBytesDataForAppending(params) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var unsignedMetadataMsg, disablePayloadsDryRun;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        unsignedMetadataMsg = _this.getUnsignedMetadata();
                        disablePayloadsDryRun = Boolean(_this.dataPackagesRequestParams.disablePayloadsDryRun);
                        if (disablePayloadsDryRun) return [
                            2,
                            _this.requestPayloadWithoutDryRun(_this.urls, unsignedMetadataMsg)
                        ];
                        return [
                            2,
                            _this.requestPayloadWithDryRun((0, $8E768._)((0, $8OnJk._)({}, params), {
                                unsignedMetadataMsg: unsignedMetadataMsg
                            }))
                        ];
                    });
                })();
            }
        },
        {
            key: "requestPayloadWithDryRun",
            value: /*
      Call function on provider always returns some result and doesn't throw an error.
      Later we need to decode the result from the call (decodeFunctionResult) and
      this function will throw an error if the call was reverted.
    */ function requestPayloadWithDryRun(param) {
                var functionName = param.functionName, contract = param.contract, transaction = param.transaction, unsignedMetadataMsg = param.unsignedMetadataMsg;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var promises;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        promises = _this.urls.map(function() {
                            var _ref = (0, $byzP8._)(function(url) {
                                var transactionToTest, redstonePayload, result;
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            transactionToTest = Object.assign({}, transaction);
                                            return [
                                                4,
                                                _this.requestPayloadWithoutDryRun([
                                                    url
                                                ], unsignedMetadataMsg)
                                            ];
                                        case 1:
                                            redstonePayload = _state.sent();
                                            transactionToTest.data = transactionToTest.data + redstonePayload;
                                            return [
                                                4,
                                                contract.provider.call(transactionToTest)
                                            ];
                                        case 2:
                                            result = _state.sent();
                                            contract.interface.decodeFunctionResult(functionName, result);
                                            return [
                                                2,
                                                redstonePayload
                                            ];
                                    }
                                });
                            });
                            return function(url) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            2,
                            Promise.any(promises).catch(function(error) {
                                var parsedErrors = (0, $5QkXC.parseAggregatedErrors)(error);
                                throw new Error("All redstone payloads do not pass dry run verification, aggregated errors: ".concat(parsedErrors));
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "requestPayloadWithoutDryRun",
            value: function requestPayloadWithoutDryRun(urls, unsignedMetadataMsg) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $jCJsd.requestRedstonePayload)(_this.dataPackagesRequestParams, urls, unsignedMetadataMsg)
                        ];
                    });
                })();
            }
        }
    ]);
    return DataServiceWrapper;
}($fsQXA.BaseWrapper);
module.exports.DataServiceWrapper = $9077d5a5e87b769c$var$DataServiceWrapper;

});
parcelRequire.register("jCJsd", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $e494d330b6b532a6$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.requestRedstonePayload = module.exports.requestDataPackages = module.exports.getDataServiceIdForSigner = module.exports.getOracleRegistryState = module.exports.DEFAULT_CACHE_SERVICE_URLS = void 0;

var $e494d330b6b532a6$var$axios_1 = $e494d330b6b532a6$var$__importDefault((parcelRequire("i42zi")));

var $e494d330b6b532a6$var$initial_state_json_1 = $e494d330b6b532a6$var$__importDefault((parcelRequire("3Yim8")));

var $hyxZy = parcelRequire("hyxZy");
module.exports.DEFAULT_CACHE_SERVICE_URLS = [
    "https://oracle-gateway-1.a.redstone.finance",
    "https://oracle-gateway-2.a.redstone.finance"
];
var $e494d330b6b532a6$var$ALL_FEEDS_KEY = "___ALL_FEEDS___";
var $e494d330b6b532a6$var$getOracleRegistryState = function() {
    var _ref = (0, $byzP8._)(function() {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $e494d330b6b532a6$var$initial_state_json_1.default
            ];
        });
    });
    return function getOracleRegistryState() {
        return _ref.apply(this, arguments);
    };
}();
module.exports.getOracleRegistryState = $e494d330b6b532a6$var$getOracleRegistryState;
var $e494d330b6b532a6$var$getDataServiceIdForSigner = function(oracleState, signerAddress) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(oracleState.nodes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nodeDetails = _step.value;
            if (nodeDetails.evmAddress.toLowerCase() === signerAddress.toLowerCase()) return nodeDetails.dataServiceId;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    throw new Error("Data service not found for ".concat(signerAddress));
};
module.exports.getDataServiceIdForSigner = $e494d330b6b532a6$var$getDataServiceIdForSigner;
var $e494d330b6b532a6$var$parseDataPackagesResponse = function(dpResponse, reqParams) {
    var _a;
    var parsedResponse = {};
    var requestedDataFeedIds = (_a = reqParams.dataFeeds) !== null && _a !== void 0 ? _a : [
        $e494d330b6b532a6$var$ALL_FEEDS_KEY
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = requestedDataFeedIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var dataFeedId = _step.value;
            var dataFeedPackages = dpResponse[dataFeedId];
            if (!dataFeedPackages) throw new Error("Requested data feed id is not included in response: ".concat(dataFeedId));
            if (dataFeedPackages.length < reqParams.uniqueSignersCount) throw new Error("Too few unique signers for the data feed: ".concat(dataFeedId, ". ") + "Expected: ".concat(reqParams.uniqueSignersCount, ". ") + "Received: ".concat(dataFeedPackages.length));
            parsedResponse[dataFeedId] = dataFeedPackages.sort(function(a, b) {
                return b.timestampMilliseconds - a.timestampMilliseconds;
            }) // we prefer newer data packages in the first order
            .slice(0, reqParams.uniqueSignersCount).map(function(dataPackage) {
                return $hyxZy.SignedDataPackage.fromObj(dataPackage);
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return parsedResponse;
};
var $e494d330b6b532a6$var$errToString = function(e) {
    if (e instanceof AggregateError) {
        var stringifiedErrors = e.errors.reduce(function(prev, oneOfErrors, curIndex) {
            return prev += "".concat(curIndex, ": ").concat(oneOfErrors.message, ", ");
        }, "");
        return "".concat(e.message, ": ").concat(stringifiedErrors);
    } else return e.message;
};
var $e494d330b6b532a6$var$requestDataPackages = function() {
    var _ref = (0, $byzP8._)(function(reqParams) {
        var urls, promises, e, errMessage;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    urls = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : module.exports.DEFAULT_CACHE_SERVICE_URLS;
                    promises = $e494d330b6b532a6$var$prepareDataPackagePromises(reqParams, urls);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        Promise.any(promises)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    e = _state.sent();
                    errMessage = "Request failed ".concat(JSON.stringify({
                        reqParams: reqParams,
                        urls: urls
                    }), ", Original error: ").concat($e494d330b6b532a6$var$errToString(e));
                    throw new Error(errMessage);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function requestDataPackages(reqParams) {
        return _ref.apply(this, arguments);
    };
}();
module.exports.requestDataPackages = $e494d330b6b532a6$var$requestDataPackages;
var $e494d330b6b532a6$var$prepareDataPackagePromises = function(reqParams, urls) {
    return urls.map(function(url) {
        return $e494d330b6b532a6$var$axios_1.default.get("".concat(url, "/data-packages/latest/").concat(reqParams.dataServiceId)).then(function(response) {
            return $e494d330b6b532a6$var$parseDataPackagesResponse(response.data, reqParams);
        });
    });
};
var $e494d330b6b532a6$var$requestRedstonePayload = function() {
    var _ref = (0, $byzP8._)(function(reqParams) {
        var urls, unsignedMetadataMsg, signedDataPackagesResponse, signedDataPackages;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    urls = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : module.exports.DEFAULT_CACHE_SERVICE_URLS, unsignedMetadataMsg = _arguments.length > 2 ? _arguments[2] : void 0;
                    return [
                        4,
                        (0, module.exports.requestDataPackages)(reqParams, urls)
                    ];
                case 1:
                    signedDataPackagesResponse = _state.sent();
                    signedDataPackages = Object.values(signedDataPackagesResponse).flat();
                    return [
                        2,
                        $hyxZy.RedstonePayload.prepare(signedDataPackages, unsignedMetadataMsg || "")
                    ];
            }
        });
    });
    return function requestRedstonePayload(reqParams) {
        return _ref.apply(this, arguments);
    };
}();
module.exports.requestRedstonePayload = $e494d330b6b532a6$var$requestRedstonePayload;
module.exports.default = {
    getOracleRegistryState: module.exports.getOracleRegistryState,
    requestDataPackages: module.exports.requestDataPackages,
    getDataServiceIdForSigner: module.exports.getDataServiceIdForSigner,
    requestRedstonePayload: module.exports.requestRedstonePayload
};

});
parcelRequire.register("i42zi", function(module, exports) {

module.exports = (parcelRequire("cvqtC"));

});
parcelRequire.register("cvqtC", function(module, exports) {
"use strict";

var $8vnOT = parcelRequire("8vnOT");

var $fJi5E = parcelRequire("fJi5E");

var $4j1qQ = parcelRequire("4j1qQ");

var $kVWgn = parcelRequire("kVWgn");

var $cIRU8 = parcelRequire("cIRU8");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $91aceafe497c37a7$var$createInstance(defaultConfig) {
    var context = new $4j1qQ(defaultConfig);
    var instance = $fJi5E($4j1qQ.prototype.request, context);
    // Copy axios.prototype to instance
    $8vnOT.extend(instance, $4j1qQ.prototype, context);
    // Copy context to instance
    $8vnOT.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $91aceafe497c37a7$var$createInstance($kVWgn(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $91aceafe497c37a7$var$axios = $91aceafe497c37a7$var$createInstance($cIRU8);
// Expose Axios class to allow class inheritance
$91aceafe497c37a7$var$axios.Axios = $4j1qQ;

// Expose Cancel & CancelToken
$91aceafe497c37a7$var$axios.CanceledError = (parcelRequire("52XDh"));

$91aceafe497c37a7$var$axios.CancelToken = (parcelRequire("lCm0E"));

$91aceafe497c37a7$var$axios.isCancel = (parcelRequire("7Ol21"));

$91aceafe497c37a7$var$axios.VERSION = (parcelRequire("bHc9w")).version;

$91aceafe497c37a7$var$axios.toFormData = (parcelRequire("31Kgs"));

// Expose AxiosError class
$91aceafe497c37a7$var$axios.AxiosError = (parcelRequire("aEswY"));
// alias for CanceledError for backward compatibility
$91aceafe497c37a7$var$axios.Cancel = $91aceafe497c37a7$var$axios.CanceledError;
// Expose all/spread
$91aceafe497c37a7$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$91aceafe497c37a7$var$axios.spread = (parcelRequire("XVNGL"));

// Expose isAxiosError
$91aceafe497c37a7$var$axios.isAxiosError = (parcelRequire("aYx8J"));
module.exports = $91aceafe497c37a7$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $91aceafe497c37a7$var$axios;

});
parcelRequire.register("8vnOT", function(module, exports) {
"use strict";

var $fJi5E = parcelRequire("fJi5E");
// utils is a library of generic helper functions non-specific to axios
var $6313b2205a115c0a$var$toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var $6313b2205a115c0a$var$kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = $6313b2205a115c0a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function $6313b2205a115c0a$var$kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return $6313b2205a115c0a$var$kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $6313b2205a115c0a$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $6313b2205a115c0a$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $6313b2205a115c0a$var$isBuffer(val) {
    return val !== null && !$6313b2205a115c0a$var$isUndefined(val) && val.constructor !== null && !$6313b2205a115c0a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $6313b2205a115c0a$var$isArrayBuffer = $6313b2205a115c0a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $6313b2205a115c0a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $6313b2205a115c0a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $6313b2205a115c0a$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $6313b2205a115c0a$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $6313b2205a115c0a$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $6313b2205a115c0a$var$isPlainObject(val) {
    if ($6313b2205a115c0a$var$kindOf(val) !== "object") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $6313b2205a115c0a$var$isDate = $6313b2205a115c0a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $6313b2205a115c0a$var$isFile = $6313b2205a115c0a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $6313b2205a115c0a$var$isBlob = $6313b2205a115c0a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $6313b2205a115c0a$var$isFileList = $6313b2205a115c0a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $6313b2205a115c0a$var$isFunction(val) {
    return $6313b2205a115c0a$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $6313b2205a115c0a$var$isStream(val) {
    return $6313b2205a115c0a$var$isObject(val) && $6313b2205a115c0a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $6313b2205a115c0a$var$isFormData(thing) {
    var pattern = "[object FormData]";
    return thing && (typeof FormData === "function" && thing instanceof FormData || $6313b2205a115c0a$var$toString.call(thing) === pattern || $6313b2205a115c0a$var$isFunction(thing.toString) && thing.toString() === pattern);
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $6313b2205a115c0a$var$isURLSearchParams = $6313b2205a115c0a$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $6313b2205a115c0a$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $6313b2205a115c0a$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $6313b2205a115c0a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($6313b2205a115c0a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $6313b2205a115c0a$var$merge() {
    var assignValue = function assignValue(val, key) {
        if ($6313b2205a115c0a$var$isPlainObject(result[key]) && $6313b2205a115c0a$var$isPlainObject(val)) result[key] = $6313b2205a115c0a$var$merge(result[key], val);
        else if ($6313b2205a115c0a$var$isPlainObject(val)) result[key] = $6313b2205a115c0a$var$merge({}, val);
        else if ($6313b2205a115c0a$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    };
    var result = {};
    for(var i = 0, l = arguments.length; i < l; i++)$6313b2205a115c0a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $6313b2205a115c0a$var$extend(a, b, thisArg) {
    $6313b2205a115c0a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $fJi5E(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $6313b2205a115c0a$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function $6313b2205a115c0a$var$inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */ function $6313b2205a115c0a$var$toFlatObject(sourceObj, destObj, filter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if (!merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function $6313b2205a115c0a$var$endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */ function $6313b2205a115c0a$var$toArray(thing) {
    if (!thing) return null;
    var i = thing.length;
    if ($6313b2205a115c0a$var$isUndefined(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var $6313b2205a115c0a$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
module.exports = {
    isArray: $6313b2205a115c0a$var$isArray,
    isArrayBuffer: $6313b2205a115c0a$var$isArrayBuffer,
    isBuffer: $6313b2205a115c0a$var$isBuffer,
    isFormData: $6313b2205a115c0a$var$isFormData,
    isArrayBufferView: $6313b2205a115c0a$var$isArrayBufferView,
    isString: $6313b2205a115c0a$var$isString,
    isNumber: $6313b2205a115c0a$var$isNumber,
    isObject: $6313b2205a115c0a$var$isObject,
    isPlainObject: $6313b2205a115c0a$var$isPlainObject,
    isUndefined: $6313b2205a115c0a$var$isUndefined,
    isDate: $6313b2205a115c0a$var$isDate,
    isFile: $6313b2205a115c0a$var$isFile,
    isBlob: $6313b2205a115c0a$var$isBlob,
    isFunction: $6313b2205a115c0a$var$isFunction,
    isStream: $6313b2205a115c0a$var$isStream,
    isURLSearchParams: $6313b2205a115c0a$var$isURLSearchParams,
    isStandardBrowserEnv: $6313b2205a115c0a$var$isStandardBrowserEnv,
    forEach: $6313b2205a115c0a$var$forEach,
    merge: $6313b2205a115c0a$var$merge,
    extend: $6313b2205a115c0a$var$extend,
    trim: $6313b2205a115c0a$var$trim,
    stripBOM: $6313b2205a115c0a$var$stripBOM,
    inherits: $6313b2205a115c0a$var$inherits,
    toFlatObject: $6313b2205a115c0a$var$toFlatObject,
    kindOf: $6313b2205a115c0a$var$kindOf,
    kindOfTest: $6313b2205a115c0a$var$kindOfTest,
    endsWith: $6313b2205a115c0a$var$endsWith,
    toArray: $6313b2205a115c0a$var$toArray,
    isTypedArray: $6313b2205a115c0a$var$isTypedArray,
    isFileList: $6313b2205a115c0a$var$isFileList
};

});
parcelRequire.register("fJi5E", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRequire.register("4j1qQ", function(module, exports) {
"use strict";

var $8vnOT = parcelRequire("8vnOT");

var $jlJFz = parcelRequire("jlJFz");

var $iDxLB = parcelRequire("iDxLB");

var $j0XEc = parcelRequire("j0XEc");

var $kVWgn = parcelRequire("kVWgn");

var $8HehI = parcelRequire("8HehI");

var $h5PnR = parcelRequire("h5PnR");
var $322a0c2423cdb67e$var$validators = $h5PnR.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $322a0c2423cdb67e$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $iDxLB(),
        response: new $iDxLB()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $322a0c2423cdb67e$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $kVWgn(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $h5PnR.assertOptions(transitional, {
        silentJSONParsing: $322a0c2423cdb67e$var$validators.transitional($322a0c2423cdb67e$var$validators.boolean),
        forcedJSONParsing: $322a0c2423cdb67e$var$validators.transitional($322a0c2423cdb67e$var$validators.boolean),
        clarifyTimeoutError: $322a0c2423cdb67e$var$validators.transitional($322a0c2423cdb67e$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $j0XEc,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $j0XEc(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$322a0c2423cdb67e$var$Axios.prototype.getUri = function getUri(config) {
    config = $kVWgn(this.defaults, config);
    var fullPath = $8HehI(config.baseURL, config.url);
    return $jlJFz(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
$8vnOT.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $322a0c2423cdb67e$var$Axios.prototype[method] = function(url, config) {
        return this.request($kVWgn(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$8vnOT.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    var generateHTTPMethod = /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($kVWgn(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    };
    $322a0c2423cdb67e$var$Axios.prototype[method] = generateHTTPMethod();
    $322a0c2423cdb67e$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
module.exports = $322a0c2423cdb67e$var$Axios;

});
parcelRequire.register("jlJFz", function(module, exports) {
"use strict";

var $8vnOT = parcelRequire("8vnOT");
function $e16367828fb88c2c$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($8vnOT.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $8vnOT.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($8vnOT.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $8vnOT.forEach(val, function parseValue(v) {
                if ($8vnOT.isDate(v)) v = v.toISOString();
                else if ($8vnOT.isObject(v)) v = JSON.stringify(v);
                parts.push($e16367828fb88c2c$var$encode(key) + "=" + $e16367828fb88c2c$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRequire.register("iDxLB", function(module, exports) {
"use strict";

var $8vnOT = parcelRequire("8vnOT");
function $d9160fe2e8519945$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $d9160fe2e8519945$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $d9160fe2e8519945$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $d9160fe2e8519945$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $8vnOT.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $d9160fe2e8519945$var$InterceptorManager;

});

parcelRequire.register("j0XEc", function(module, exports) {
"use strict";

var $8vnOT = parcelRequire("8vnOT");

var $4fkqQ = parcelRequire("4fkqQ");

var $7Ol21 = parcelRequire("7Ol21");

var $cIRU8 = parcelRequire("cIRU8");

var $52XDh = parcelRequire("52XDh");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function $dd7c492659371026$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $52XDh();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $dd7c492659371026$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $4fkqQ.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $8vnOT.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $8vnOT.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $cIRU8.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $dd7c492659371026$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $4fkqQ.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$7Ol21(reason)) {
            $dd7c492659371026$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $4fkqQ.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRequire.register("4fkqQ", function(module, exports) {
"use strict";

var $8vnOT = parcelRequire("8vnOT");

var $cIRU8 = parcelRequire("cIRU8");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $cIRU8;
    /*eslint no-param-reassign:0*/ $8vnOT.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRequire.register("cIRU8", function(module, exports) {

var $aqbQf = parcelRequire("aqbQf");
"use strict";

var $8vnOT = parcelRequire("8vnOT");

var $2H0L2 = parcelRequire("2H0L2");

var $aEswY = parcelRequire("aEswY");

var $dibGw = parcelRequire("dibGw");

var $31Kgs = parcelRequire("31Kgs");
var $943368646425a4e3$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $943368646425a4e3$var$setContentTypeIfUnset(headers, value) {
    if (!$8vnOT.isUndefined(headers) && $8vnOT.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $943368646425a4e3$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("lIA2X"));
    else if (typeof $aqbQf !== "undefined" && Object.prototype.toString.call($aqbQf) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("lIA2X"));
    return adapter;
}
function $943368646425a4e3$var$stringifySafely(rawValue, parser, encoder) {
    if ($8vnOT.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $8vnOT.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}

var $943368646425a4e3$var$defaults = {
    transitional: $dibGw,
    adapter: $943368646425a4e3$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $2H0L2(headers, "Accept");
            $2H0L2(headers, "Content-Type");
            if ($8vnOT.isFormData(data) || $8vnOT.isArrayBuffer(data) || $8vnOT.isBuffer(data) || $8vnOT.isStream(data) || $8vnOT.isFile(data) || $8vnOT.isBlob(data)) return data;
            if ($8vnOT.isArrayBufferView(data)) return data.buffer;
            if ($8vnOT.isURLSearchParams(data)) {
                $943368646425a4e3$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            var isObjectPayload = $8vnOT.isObject(data);
            var contentType = headers && headers["Content-Type"];
            var isFileList;
            if ((isFileList = $8vnOT.isFileList(data)) || isObjectPayload && contentType === "multipart/form-data") {
                var _FormData = this.env && this.env.FormData;
                return $31Kgs(isFileList ? {
                    "files[]": data
                } : data, _FormData && new _FormData());
            } else if (isObjectPayload || contentType === "application/json") {
                $943368646425a4e3$var$setContentTypeIfUnset(headers, "application/json");
                return $943368646425a4e3$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $943368646425a4e3$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $8vnOT.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $aEswY.from(e, $aEswY.ERR_BAD_RESPONSE, this, null, this.response);
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (parcelRequire("bPCP4"))
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$8vnOT.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $943368646425a4e3$var$defaults.headers[method] = {};
});
$8vnOT.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $943368646425a4e3$var$defaults.headers[method] = $8vnOT.merge($943368646425a4e3$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $943368646425a4e3$var$defaults;

});
parcelRequire.register("2H0L2", function(module, exports) {
"use strict";

var $8vnOT = parcelRequire("8vnOT");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $8vnOT.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRequire.register("aEswY", function(module, exports) {
"use strict";

var $8vnOT = parcelRequire("8vnOT");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function $7c13c56affcf128b$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$8vnOT.inherits($7c13c56affcf128b$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $7c13c56affcf128b$var$prototype = $7c13c56affcf128b$var$AxiosError.prototype;
var $7c13c56affcf128b$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED"
].forEach(function(code) {
    $7c13c56affcf128b$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($7c13c56affcf128b$var$AxiosError, $7c13c56affcf128b$var$descriptors);
Object.defineProperty($7c13c56affcf128b$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$7c13c56affcf128b$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($7c13c56affcf128b$var$prototype);
    $8vnOT.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    $7c13c56affcf128b$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = $7c13c56affcf128b$var$AxiosError;

});

parcelRequire.register("dibGw", function(module, exports) {
"use strict";
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRequire.register("31Kgs", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $23455a3ef7cc8c8d$require$Buffer = $gzLuY.Buffer;
"use strict";

var $8vnOT = parcelRequire("8vnOT");
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/ function $23455a3ef7cc8c8d$var$toFormData(obj, formData) {
    var convertValue = function convertValue(value) {
        if (value === null) return "";
        if ($8vnOT.isDate(value)) return value.toISOString();
        if ($8vnOT.isArrayBuffer(value) || $8vnOT.isTypedArray(value)) return typeof Blob === "function" ? new Blob([
            value
        ]) : $23455a3ef7cc8c8d$require$Buffer.from(value);
        return value;
    };
    // eslint-disable-next-line no-param-reassign
    formData = formData || new FormData();
    var stack = [];
    function build(data, parentKey) {
        if ($8vnOT.isPlainObject(data) || $8vnOT.isArray(data)) {
            if (stack.indexOf(data) !== -1) throw Error("Circular reference detected in " + parentKey);
            stack.push(data);
            $8vnOT.forEach(data, function each(value, key) {
                if ($8vnOT.isUndefined(value)) return;
                var fullKey = parentKey ? parentKey + "." + key : key;
                var arr;
                if (value && !parentKey && typeof value === "object") {
                    if ($8vnOT.endsWith(key, "{}")) // eslint-disable-next-line no-param-reassign
                    value = JSON.stringify(value);
                    else if ($8vnOT.endsWith(key, "[]") && (arr = $8vnOT.toArray(value))) {
                        // eslint-disable-next-line func-names
                        arr.forEach(function(el) {
                            !$8vnOT.isUndefined(el) && formData.append(fullKey, convertValue(el));
                        });
                        return;
                    }
                }
                build(value, fullKey);
            });
            stack.pop();
        } else formData.append(parentKey, convertValue(data));
    }
    build(obj);
    return formData;
}
module.exports = $23455a3ef7cc8c8d$var$toFormData;

});

parcelRequire.register("lIA2X", function(module, exports) {
"use strict";

var $8vnOT = parcelRequire("8vnOT");

var $fkleC = parcelRequire("fkleC");

var $dlkkk = parcelRequire("dlkkk");

var $jlJFz = parcelRequire("jlJFz");

var $8HehI = parcelRequire("8HehI");

var $lyzHO = parcelRequire("lyzHO");

var $cb7pd = parcelRequire("cb7pd");

var $dibGw = parcelRequire("dibGw");

var $aEswY = parcelRequire("aEswY");

var $52XDh = parcelRequire("52XDh");

var $6nCGH = parcelRequire("6nCGH");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var done = function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        };
        var onloadend = function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $lyzHO(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $fkleC(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        };
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        if ($8vnOT.isFormData(requestData) && $8vnOT.isStandardBrowserEnv()) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $8HehI(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $jlJFz(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $aEswY("Request aborted", $aEswY.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $aEswY("Network Error", $aEswY.ERR_NETWORK, config, request, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $dibGw;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $aEswY(timeoutErrorMessage, transitional.clarifyTimeoutError ? $aEswY.ETIMEDOUT : $aEswY.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($8vnOT.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $cb7pd(fullPath)) && config.xsrfCookieName ? $dlkkk.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $8vnOT.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$8vnOT.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function onCanceled(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $52XDh() : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        var protocol = $6nCGH(fullPath);
        if (protocol && [
            "http",
            "https",
            "file"
        ].indexOf(protocol) === -1) {
            reject(new $aEswY("Unsupported protocol " + protocol + ":", $aEswY.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

});
parcelRequire.register("fkleC", function(module, exports) {
"use strict";

var $aEswY = parcelRequire("aEswY");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $aEswY("Request failed with status code " + response.status, [
        $aEswY.ERR_BAD_REQUEST,
        $aEswY.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

});

parcelRequire.register("dlkkk", function(module, exports) {
"use strict";

var $8vnOT = parcelRequire("8vnOT");
module.exports = $8vnOT.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($8vnOT.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($8vnOT.isString(path)) cookie.push("path=" + path);
            if ($8vnOT.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRequire.register("8HehI", function(module, exports) {
"use strict";

var $jG82I = parcelRequire("jG82I");

var $8LS2M = parcelRequire("8LS2M");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$jG82I(requestedURL)) return $8LS2M(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRequire.register("jG82I", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRequire.register("8LS2M", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRequire.register("lyzHO", function(module, exports) {
"use strict";

var $8vnOT = parcelRequire("8vnOT");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fb187858142bea5a$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $8vnOT.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $8vnOT.trim(line.substr(0, i)).toLowerCase();
        val = $8vnOT.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $fb187858142bea5a$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRequire.register("cb7pd", function(module, exports) {
"use strict";

var $8vnOT = parcelRequire("8vnOT");
module.exports = $8vnOT.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var resolveURL = /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    };
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $8vnOT.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRequire.register("52XDh", function(module, exports) {
"use strict";

var $aEswY = parcelRequire("aEswY");

var $8vnOT = parcelRequire("8vnOT");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $3acb656d98a22f78$var$CanceledError(message) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $aEswY.call(this, message == null ? "canceled" : message, $aEswY.ERR_CANCELED);
    this.name = "CanceledError";
}
$8vnOT.inherits($3acb656d98a22f78$var$CanceledError, $aEswY, {
    __CANCEL__: true
});
module.exports = $3acb656d98a22f78$var$CanceledError;

});

parcelRequire.register("6nCGH", function(module, exports) {
"use strict";
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
};

});


parcelRequire.register("bPCP4", function(module, exports) {
// eslint-disable-next-line strict
module.exports = null;

});



parcelRequire.register("7Ol21", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRequire.register("kVWgn", function(module, exports) {
"use strict";

var $8vnOT = parcelRequire("8vnOT");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    var getMergedValue = function getMergedValue(target, source) {
        if ($8vnOT.isPlainObject(target) && $8vnOT.isPlainObject(source)) return $8vnOT.merge(target, source);
        else if ($8vnOT.isPlainObject(source)) return $8vnOT.merge({}, source);
        else if ($8vnOT.isArray(source)) return source.slice();
        return source;
    };
    var mergeDeepProperties = // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$8vnOT.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$8vnOT.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    };
    var valueFromConfig2 = // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$8vnOT.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    };
    var defaultToConfig2 = // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$8vnOT.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$8vnOT.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    };
    var mergeDirectKeys = // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    };
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "beforeRedirect": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $8vnOT.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $8vnOT.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRequire.register("h5PnR", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
"use strict";

var $bHc9w = parcelRequire("bHc9w");
var $c71ac30fd5ef5d9b$require$VERSION = $bHc9w.version;

var $aEswY = parcelRequire("aEswY");
var $c71ac30fd5ef5d9b$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $c71ac30fd5ef5d9b$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $1ObTH._)(thing)) === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $c71ac30fd5ef5d9b$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $c71ac30fd5ef5d9b$var$validators.transitional = function transitional(validator, version, message) {
    var formatMessage = function formatMessage(opt, desc) {
        return "[Axios v" + $c71ac30fd5ef5d9b$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    };
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new $aEswY(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), $aEswY.ERR_DEPRECATED);
        if (version && !$c71ac30fd5ef5d9b$var$deprecatedWarnings[opt]) {
            $c71ac30fd5ef5d9b$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $c71ac30fd5ef5d9b$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new $aEswY("options must be an object", $aEswY.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $aEswY("option " + opt + " must be " + result, $aEswY.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $aEswY("Unknown option " + opt, $aEswY.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: $c71ac30fd5ef5d9b$var$assertOptions,
    validators: $c71ac30fd5ef5d9b$var$validators
};

});
parcelRequire.register("bHc9w", function(module, exports) {
module.exports = {
    "version": "0.27.2"
};

});



parcelRequire.register("lCm0E", function(module, exports) {
"use strict";

var $52XDh = parcelRequire("52XDh");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $fbce38363979d4cb$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $52XDh(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ $fbce38363979d4cb$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $fbce38363979d4cb$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $fbce38363979d4cb$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $fbce38363979d4cb$var$CancelToken.source = function source() {
    var cancel;
    var token = new $fbce38363979d4cb$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $fbce38363979d4cb$var$CancelToken;

});

parcelRequire.register("XVNGL", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRequire.register("aYx8J", function(module, exports) {
"use strict";

var $8vnOT = parcelRequire("8vnOT");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $8vnOT.isObject(payload) && payload.isAxiosError === true;
};

});




parcelRequire.register("5QkXC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseAggregatedErrors = void 0;
var $441211665f2bf557$var$parseAggregatedErrors = function(error) {
    return error.errors.map(function(error) {
        var errorStringified = JSON.stringify(error, null, 2);
        return errorStringified !== "{}" ? errorStringified : error.message;
    });
};
module.exports.parseAggregatedErrors = $441211665f2bf557$var$parseAggregatedErrors;

});


parcelRequire.register("cwzTA", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleNumericMockWrapper = void 0;

var $hyxZy = parcelRequire("hyxZy");

var $8pMIN = parcelRequire("8pMIN");

var $b3J9M = parcelRequire("b3J9M");

var $eqe9p = parcelRequire("eqe9p");
var $91e4514b1894a4a1$var$SimpleNumericMockWrapper = /*#__PURE__*/ function(_MockWrapper_1_MockWrapper) {
    (0, $ftJVG._)(SimpleNumericMockWrapper, _MockWrapper_1_MockWrapper);
    var _super = (0, $6OZAO._)(SimpleNumericMockWrapper);
    function SimpleNumericMockWrapper(simpleNumericMockConfig) {
        (0, $978gY._)(this, SimpleNumericMockWrapper);
        if (simpleNumericMockConfig.mockSignersCount > $8pMIN.MAX_MOCK_SIGNERS_COUNT) throw new Error("mockSignersCount should be <= ".concat($8pMIN.MAX_MOCK_SIGNERS_COUNT));
        // Prepare mock data packages configs
        var mockDataPackages = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        for(var signerIndex = 0; signerIndex < simpleNumericMockConfig.mockSignersCount; signerIndex++)try {
            for(var _iterator = simpleNumericMockConfig.dataPoints[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var dataPointObj = _step.value;
                var dataPoint = new $hyxZy.NumericDataPoint(dataPointObj);
                var timestampMilliseconds = simpleNumericMockConfig.timestampMilliseconds || $8pMIN.DEFAULT_TIMESTAMP_FOR_TESTS;
                var mockDataPackage = {
                    signer: (0, $8pMIN.getMockSignerAddress)(signerIndex),
                    dataPackage: new $hyxZy.DataPackage([
                        dataPoint
                    ], timestampMilliseconds)
                };
                mockDataPackages.push(mockDataPackage);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _super.call(this, mockDataPackages);
    }
    (0, $kry2a._)(SimpleNumericMockWrapper, [
        {
            key: "getUnsignedMetadata",
            value: function getUnsignedMetadata() {
                return "".concat($b3J9M.version, "#simple-numeric-mock");
            }
        }
    ]);
    return SimpleNumericMockWrapper;
}($eqe9p.MockWrapper);
module.exports.SimpleNumericMockWrapper = $91e4514b1894a4a1$var$SimpleNumericMockWrapper;

});

parcelRequire.register("efDrj", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $a6010f49d9913fe8$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OnDemandRequestWrapper = void 0;

var $a6010f49d9913fe8$var$axios_1 = $a6010f49d9913fe8$var$__importDefault((parcelRequire("28feZ")));

var $hyxZy = parcelRequire("hyxZy");

var $fsQXA = parcelRequire("fsQXA");

var $b3J9M = parcelRequire("b3J9M");
var $a6010f49d9913fe8$var$OnDemandRequestWrapper = /*#__PURE__*/ function(_BaseWrapper_1_BaseWrapper) {
    (0, $ftJVG._)(OnDemandRequestWrapper, _BaseWrapper_1_BaseWrapper);
    var _super = (0, $6OZAO._)(OnDemandRequestWrapper);
    function OnDemandRequestWrapper(requestParams, nodeUrls) {
        (0, $978gY._)(this, OnDemandRequestWrapper);
        var _this;
        _this = _super.call(this);
        _this.requestParams = requestParams;
        _this.nodeUrls = nodeUrls;
        return _this;
    }
    (0, $kry2a._)(OnDemandRequestWrapper, [
        {
            key: "getUnsignedMetadata",
            value: function getUnsignedMetadata() {
                return "".concat($b3J9M.version, "#on-demand-request");
            }
        },
        {
            key: "dryRunToVerifyPayload",
            value: function dryRunToVerifyPayload(payloads) {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            payloads[0]
                        ];
                    });
                })();
            }
        },
        {
            key: "getBytesDataForAppending",
            value: function getBytesDataForAppending() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var timestamp, message, _this_requestParams, signer, scoreType, signature, promises, responses, signedDataPackages, unsignedMetadata;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                timestamp = Date.now();
                                message = (0, $hyxZy.prepareMessageToSign)(timestamp);
                                _this_requestParams = _this.requestParams, signer = _this_requestParams.signer, scoreType = _this_requestParams.scoreType;
                                return [
                                    4,
                                    $hyxZy.UniversalSigner.signWithEthereumHashMessage(signer, message)
                                ];
                            case 1:
                                signature = _state.sent();
                                promises = _this.nodeUrls.map(function(url) {
                                    return $a6010f49d9913fe8$var$axios_1.default.get(url, {
                                        params: {
                                            timestamp: timestamp,
                                            signature: signature,
                                            scoreType: scoreType
                                        }
                                    });
                                });
                                return [
                                    4,
                                    Promise.all(promises)
                                ];
                            case 2:
                                responses = _state.sent();
                                signedDataPackages = responses.map(function(response) {
                                    return $hyxZy.SignedDataPackage.fromObj(response.data);
                                });
                                unsignedMetadata = _this.getUnsignedMetadata();
                                return [
                                    2,
                                    $hyxZy.RedstonePayload.prepare(signedDataPackages, unsignedMetadata)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return OnDemandRequestWrapper;
}($fsQXA.BaseWrapper);
module.exports.OnDemandRequestWrapper = $a6010f49d9913fe8$var$OnDemandRequestWrapper;

});


parcelRequire.register("cPXxj", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $95886e1e1848ab3c$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FuelConnector = module.exports.FUEL_BASE_GAS_LIMIT = void 0;

var $95886e1e1848ab3c$var$axios_1 = $95886e1e1848ab3c$var$__importDefault((parcelRequire("28feZ")));
module.exports.FUEL_BASE_GAS_LIMIT = 500000000;
var $95886e1e1848ab3c$var$FuelConnector = /*#__PURE__*/ function() {
    function FuelConnector(providerUrl) {
        (0, $978gY._)(this, FuelConnector);
        this.providerUrl = providerUrl;
    }
    (0, $kry2a._)(FuelConnector, [
        {
            key: "getGasLimit",
            value: function getGasLimit() {
                var _a;
                return !!((_a = this.providerUrl) === null || _a === void 0 ? void 0 : _a.indexOf("127.0.0.1")) ? 0 : module.exports.FUEL_BASE_GAS_LIMIT;
            }
        },
        {
            key: "getBlockNumber",
            value: function getBlockNumber() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getLatestBlock()
                                ];
                            case 1:
                                return [
                                    2,
                                    Number.apply(void 0, [
                                        _state.sent().height
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLatestBlock",
            value: function getLatestBlock() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var LATEST_BLOCK_QUERY, response;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                LATEST_BLOCK_QUERY = "query LatestBlockHeight { chain { latestBlock {  header { height, time } } } }";
                                return [
                                    4,
                                    (0, $95886e1e1848ab3c$var$axios_1.default)({
                                        url: _this.providerUrl,
                                        method: "POST",
                                        data: {
                                            query: LATEST_BLOCK_QUERY
                                        }
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response.data.data.chain.latestBlock.header
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return FuelConnector;
}();
module.exports.FuelConnector = $95886e1e1848ab3c$var$FuelConnector;

});

parcelRequire.register("hjAGN", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FuelContractConnector = void 0;

var $cPXxj = parcelRequire("cPXxj");
var $c9b0abbea920bcfb$var$FuelContractConnector = /*#__PURE__*/ function(_FuelConnector_1_FuelConnector) {
    (0, $ftJVG._)(FuelContractConnector, _FuelConnector_1_FuelConnector);
    var _super = (0, $6OZAO._)(FuelContractConnector);
    function FuelContractConnector(wallet) {
        (0, $978gY._)(this, FuelContractConnector);
        var _this;
        _this = _super.call(this, wallet === null || wallet === void 0 ? void 0 : wallet.provider.url);
        _this.wallet = wallet;
        return _this;
    }
    return FuelContractConnector;
}($cPXxj.FuelConnector);
module.exports.FuelContractConnector = $c9b0abbea920bcfb$var$FuelContractConnector;

});

parcelRequire.register("2TLZk", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FuelPricesContractAdapter = void 0;

var $jZ8k0 = parcelRequire("jZ8k0");
var $21c5f146e1a30326$var$FuelPricesContractAdapter = /*#__PURE__*/ function() {
    function FuelPricesContractAdapter(contract, gasLimit) {
        (0, $978gY._)(this, FuelPricesContractAdapter);
        this.contract = contract;
        this.gasLimit = gasLimit;
    }
    (0, $kry2a._)(FuelPricesContractAdapter, [
        {
            key: "getPricesFromPayload",
            value: function getPricesFromPayload(paramsProvider) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _, _1, _2, _tmp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = _this.extractNumbers;
                                _2 = (_1 = _this.contract.functions).get_prices;
                                _tmp = [
                                    paramsProvider.getHexlifiedFeedIds().map($jZ8k0.u256)
                                ];
                                return [
                                    4,
                                    paramsProvider.getPayloadData()
                                ];
                            case 1:
                                return [
                                    4,
                                    _2.apply(_1, _tmp.concat([
                                        _state.sent()
                                    ])).get()
                                ];
                            case 2:
                                return [
                                    2,
                                    _.apply(_this, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "writePricesFromPayloadToContract",
            value: function writePricesFromPayloadToContract(paramsProvider) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _, _1, _2, _tmp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = _this.extractNumbers;
                                _2 = (_1 = _this.contract.functions).write_prices;
                                _tmp = [
                                    paramsProvider.getHexlifiedFeedIds().map($jZ8k0.u256)
                                ];
                                return [
                                    4,
                                    paramsProvider.getPayloadData()
                                ];
                            case 1:
                                return [
                                    4,
                                    _2.apply(_1, _tmp.concat([
                                        _state.sent()
                                    ])).txParams({
                                        gasLimit: _this.gasLimit,
                                        gasPrice: 1
                                    }).call()
                                ];
                            case 2:
                                return [
                                    2,
                                    _.apply(_this, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "readPricesFromContract",
            value: function readPricesFromContract(paramsProvider) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = _this.extractNumbers;
                                return [
                                    4,
                                    _this.contract.functions.read_prices(paramsProvider.getHexlifiedFeedIds().map($jZ8k0.u256)).get()
                                ];
                            case 1:
                                return [
                                    2,
                                    _.apply(_this, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "readTimestampFromContract",
            value: function readTimestampFromContract() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.contract.functions.read_timestamp().get()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().value.toNumber()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "extractNumbers",
            value: function extractNumbers(result) {
                return result.value.map($jZ8k0.num);
            }
        }
    ]);
    return FuelPricesContractAdapter;
}();
module.exports.FuelPricesContractAdapter = $21c5f146e1a30326$var$FuelPricesContractAdapter;

});
parcelRequire.register("jZ8k0", function(module, exports) {
"use strict";
var $e8ca2b5521983394$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.num = module.exports.u256 = void 0;

var $e8ca2b5521983394$var$assert_1 = $e8ca2b5521983394$var$__importDefault((parcelRequire("2rjjG")));
function $e8ca2b5521983394$var$u256(value) {
    return {
        a: 0,
        b: 0,
        c: 0,
        d: value
    };
}
module.exports.u256 = $e8ca2b5521983394$var$u256;
function $e8ca2b5521983394$var$num(value) {
    (0, $e8ca2b5521983394$var$assert_1.default)(value.c.toNumber() + value.b.toNumber() + value.a.toNumber() == 0, "The returned value must be number-convertible");
    return value.d.toNumber();
}
module.exports.num = $e8ca2b5521983394$var$num;

});
parcelRequire.register("2rjjG", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $aqbQf = parcelRequire("aqbQf");
"use strict";
function $1c6d1638c987b4f3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1c6d1638c987b4f3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1c6d1638c987b4f3$var$_typeof(o);
}
function $1c6d1638c987b4f3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1c6d1638c987b4f3$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1c6d1638c987b4f3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1c6d1638c987b4f3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1c6d1638c987b4f3$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1c6d1638c987b4f3$var$_toPropertyKey(arg) {
    var key = $1c6d1638c987b4f3$var$_toPrimitive(arg, "string");
    return $1c6d1638c987b4f3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1c6d1638c987b4f3$var$_toPrimitive(input, hint) {
    if ($1c6d1638c987b4f3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1c6d1638c987b4f3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1c6d1638c987b4f3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $j3n0m = parcelRequire("j3n0m");
var $1c6d1638c987b4f3$var$_require$codes = $j3n0m.codes, $1c6d1638c987b4f3$var$ERR_AMBIGUOUS_ARGUMENT = $1c6d1638c987b4f3$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $1c6d1638c987b4f3$var$ERR_INVALID_ARG_TYPE = $1c6d1638c987b4f3$var$_require$codes.ERR_INVALID_ARG_TYPE, $1c6d1638c987b4f3$var$ERR_INVALID_ARG_VALUE = $1c6d1638c987b4f3$var$_require$codes.ERR_INVALID_ARG_VALUE, $1c6d1638c987b4f3$var$ERR_INVALID_RETURN_VALUE = $1c6d1638c987b4f3$var$_require$codes.ERR_INVALID_RETURN_VALUE, $1c6d1638c987b4f3$var$ERR_MISSING_ARGS = $1c6d1638c987b4f3$var$_require$codes.ERR_MISSING_ARGS;

var $2OkWu = parcelRequire("2OkWu");

var $lQXBK = parcelRequire("lQXBK");
var $1c6d1638c987b4f3$var$inspect = $lQXBK.inspect;

var $lQXBK = parcelRequire("lQXBK");
var $1c6d1638c987b4f3$require$_require$types = $lQXBK.types;
var $1c6d1638c987b4f3$var$isPromise = $1c6d1638c987b4f3$require$_require$types.isPromise, $1c6d1638c987b4f3$var$isRegExp = $1c6d1638c987b4f3$require$_require$types.isRegExp;

var $1c6d1638c987b4f3$var$objectAssign = (parcelRequire("936qY"))();

var $1c6d1638c987b4f3$var$objectIs = (parcelRequire("kayvN"))();

var $1c6d1638c987b4f3$var$RegExpPrototypeTest = (parcelRequire("a990d"))("RegExp.prototype.test");
var $1c6d1638c987b4f3$var$errorCache = new Map();
var $1c6d1638c987b4f3$var$isDeepEqual;
var $1c6d1638c987b4f3$var$isDeepStrictEqual;
var $1c6d1638c987b4f3$var$parseExpressionAt;
var $1c6d1638c987b4f3$var$findNodeAround;
var $1c6d1638c987b4f3$var$decoder;

function $1c6d1638c987b4f3$var$lazyLoadComparison() {
    var comparison = (parcelRequire("gwhuf"));
    $1c6d1638c987b4f3$var$isDeepEqual = comparison.isDeepEqual;
    $1c6d1638c987b4f3$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $1c6d1638c987b4f3$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $1c6d1638c987b4f3$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "",
    "",
    "\\u000b",
    "\\f",
    "",
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $1c6d1638c987b4f3$var$escapeFn = function escapeFn(str) {
    return $1c6d1638c987b4f3$var$meta[str.charCodeAt(0)];
};
var $1c6d1638c987b4f3$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $1c6d1638c987b4f3$var$assert = module.exports = $1c6d1638c987b4f3$var$ok;
var $1c6d1638c987b4f3$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $1c6d1638c987b4f3$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $2OkWu(obj);
}
function $1c6d1638c987b4f3$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = "Failed";
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($1c6d1638c987b4f3$var$warned === false) {
            $1c6d1638c987b4f3$var$warned = true;
            var warn = $aqbQf.emitWarning ? $aqbQf.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
        }
        if (argsLen === 2) operator = "!=";
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? "fail" : operator,
        stackStartFn: stackStartFn || $1c6d1638c987b4f3$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $2OkWu(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$1c6d1638c987b4f3$var$assert.fail = $1c6d1638c987b4f3$var$fail;
// The AssertionError is defined in internal/error.
$1c6d1638c987b4f3$var$assert.AssertionError = $2OkWu;
function $1c6d1638c987b4f3$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = "No value argument passed to `assert.ok()`";
        } else if (message instanceof Error) throw message;
        var err = new $2OkWu({
            actual: value,
            expected: true,
            message: message,
            operator: "==",
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $1c6d1638c987b4f3$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $1c6d1638c987b4f3$var$innerOk.apply(void 0, [
        $1c6d1638c987b4f3$var$ok,
        args.length
    ].concat(args));
}
$1c6d1638c987b4f3$var$assert.ok = $1c6d1638c987b4f3$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $1c6d1638c987b4f3$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $1c6d1638c987b4f3$var$ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $1c6d1638c987b4f3$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "==",
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$1c6d1638c987b4f3$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $1c6d1638c987b4f3$var$ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $1c6d1638c987b4f3$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "!=",
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$1c6d1638c987b4f3$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $1c6d1638c987b4f3$var$ERR_MISSING_ARGS("actual", "expected");
    if ($1c6d1638c987b4f3$var$isDeepEqual === undefined) $1c6d1638c987b4f3$var$lazyLoadComparison();
    if (!$1c6d1638c987b4f3$var$isDeepEqual(actual, expected)) $1c6d1638c987b4f3$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepEqual",
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$1c6d1638c987b4f3$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $1c6d1638c987b4f3$var$ERR_MISSING_ARGS("actual", "expected");
    if ($1c6d1638c987b4f3$var$isDeepEqual === undefined) $1c6d1638c987b4f3$var$lazyLoadComparison();
    if ($1c6d1638c987b4f3$var$isDeepEqual(actual, expected)) $1c6d1638c987b4f3$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepEqual",
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $1c6d1638c987b4f3$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $1c6d1638c987b4f3$var$ERR_MISSING_ARGS("actual", "expected");
    if ($1c6d1638c987b4f3$var$isDeepEqual === undefined) $1c6d1638c987b4f3$var$lazyLoadComparison();
    if (!$1c6d1638c987b4f3$var$isDeepStrictEqual(actual, expected)) $1c6d1638c987b4f3$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepStrictEqual",
        stackStartFn: deepStrictEqual
    });
};
$1c6d1638c987b4f3$var$assert.notDeepStrictEqual = $1c6d1638c987b4f3$var$notDeepStrictEqual;
function $1c6d1638c987b4f3$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $1c6d1638c987b4f3$var$ERR_MISSING_ARGS("actual", "expected");
    if ($1c6d1638c987b4f3$var$isDeepEqual === undefined) $1c6d1638c987b4f3$var$lazyLoadComparison();
    if ($1c6d1638c987b4f3$var$isDeepStrictEqual(actual, expected)) $1c6d1638c987b4f3$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepStrictEqual",
        stackStartFn: $1c6d1638c987b4f3$var$notDeepStrictEqual
    });
}
$1c6d1638c987b4f3$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $1c6d1638c987b4f3$var$ERR_MISSING_ARGS("actual", "expected");
    if (!$1c6d1638c987b4f3$var$objectIs(actual, expected)) $1c6d1638c987b4f3$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "strictEqual",
        stackStartFn: strictEqual
    });
};
$1c6d1638c987b4f3$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $1c6d1638c987b4f3$var$ERR_MISSING_ARGS("actual", "expected");
    if ($1c6d1638c987b4f3$var$objectIs(actual, expected)) $1c6d1638c987b4f3$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notStrictEqual",
        stackStartFn: notStrictEqual
    });
};
var $1c6d1638c987b4f3$var$Comparison = /*#__PURE__*/ $1c6d1638c987b4f3$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $1c6d1638c987b4f3$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === "string" && $1c6d1638c987b4f3$var$isRegExp(obj[key]) && $1c6d1638c987b4f3$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $1c6d1638c987b4f3$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$1c6d1638c987b4f3$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $1c6d1638c987b4f3$var$Comparison(actual, keys);
            var b = new $1c6d1638c987b4f3$var$Comparison(expected, keys, actual);
            var err = new $2OkWu({
                actual: a,
                expected: b,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $1c6d1638c987b4f3$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $1c6d1638c987b4f3$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== "function") {
        if ($1c6d1638c987b4f3$var$isRegExp(expected)) return $1c6d1638c987b4f3$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $1c6d1638c987b4f3$var$ERR_INVALID_ARG_TYPE("expected", [
            "Function",
            "RegExp"
        ], expected);
        // Handle primitives properly.
        if ($1c6d1638c987b4f3$var$_typeof(actual) !== "object" || actual === null) {
            var err = new $2OkWu({
                actual: actual,
                expected: expected,
                message: msg,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push("name", "message");
        else if (keys.length === 0) throw new $1c6d1638c987b4f3$var$ERR_INVALID_ARG_VALUE("error", expected, "may not be an empty object");
        if ($1c6d1638c987b4f3$var$isDeepEqual === undefined) $1c6d1638c987b4f3$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === "string" && $1c6d1638c987b4f3$var$isRegExp(expected[key]) && $1c6d1638c987b4f3$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $1c6d1638c987b4f3$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $1c6d1638c987b4f3$var$getActual(fn) {
    if (typeof fn !== "function") throw new $1c6d1638c987b4f3$var$ERR_INVALID_ARG_TYPE("fn", "Function", fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $1c6d1638c987b4f3$var$NO_EXCEPTION_SENTINEL;
}
function $1c6d1638c987b4f3$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $1c6d1638c987b4f3$var$isPromise(obj) || obj !== null && $1c6d1638c987b4f3$var$_typeof(obj) === "object" && typeof obj.then === "function" && typeof obj.catch === "function";
}
function $1c6d1638c987b4f3$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === "function") {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$1c6d1638c987b4f3$var$checkIsPromise(resultPromise)) throw new $1c6d1638c987b4f3$var$ERR_INVALID_RETURN_VALUE("instance of Promise", "promiseFn", resultPromise);
        } else if ($1c6d1638c987b4f3$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $1c6d1638c987b4f3$var$ERR_INVALID_ARG_TYPE("promiseFn", [
            "Function",
            "Promise"
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $1c6d1638c987b4f3$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $1c6d1638c987b4f3$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === "string") {
        if (arguments.length === 4) throw new $1c6d1638c987b4f3$var$ERR_INVALID_ARG_TYPE("error", [
            "Object",
            "Error",
            "Function",
            "RegExp"
        ], error);
        if ($1c6d1638c987b4f3$var$_typeof(actual) === "object" && actual !== null) {
            if (actual.message === error) throw new $1c6d1638c987b4f3$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error message "'.concat(actual.message, '" is identical to the message.'));
        } else if (actual === error) throw new $1c6d1638c987b4f3$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error "'.concat(actual, '" is identical to the message.'));
        message = error;
        error = undefined;
    } else if (error != null && $1c6d1638c987b4f3$var$_typeof(error) !== "object" && typeof error !== "function") throw new $1c6d1638c987b4f3$var$ERR_INVALID_ARG_TYPE("error", [
        "Object",
        "Error",
        "Function",
        "RegExp"
    ], error);
    if (actual === $1c6d1638c987b4f3$var$NO_EXCEPTION_SENTINEL) {
        var details = "";
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "rejects" ? "rejection" : "exception";
        $1c6d1638c987b4f3$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$1c6d1638c987b4f3$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $1c6d1638c987b4f3$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $1c6d1638c987b4f3$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === "string") {
        message = error;
        error = undefined;
    }
    if (!error || $1c6d1638c987b4f3$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
        $1c6d1638c987b4f3$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + 'Actual message: "'.concat(actual && actual.message, '"'),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$1c6d1638c987b4f3$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $1c6d1638c987b4f3$var$expectsError.apply(void 0, [
        throws,
        $1c6d1638c987b4f3$var$getActual(promiseFn)
    ].concat(args));
};
$1c6d1638c987b4f3$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $1c6d1638c987b4f3$var$waitForActual(promiseFn).then(function(result) {
        return $1c6d1638c987b4f3$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$1c6d1638c987b4f3$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $1c6d1638c987b4f3$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $1c6d1638c987b4f3$var$getActual(fn)
    ].concat(args));
};
$1c6d1638c987b4f3$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $1c6d1638c987b4f3$var$waitForActual(fn).then(function(result) {
        return $1c6d1638c987b4f3$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$1c6d1638c987b4f3$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = "ifError got unwanted exception: ";
        if ($1c6d1638c987b4f3$var$_typeof(err) === "object" && typeof err.message === "string") {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $1c6d1638c987b4f3$var$inspect(err);
        var newErr = new $2OkWu({
            actual: err,
            expected: null,
            operator: "ifError",
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === "string") {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split("\n");
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split("\n");
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join("\n"), "\n").concat(tmp2.join("\n"));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $1c6d1638c987b4f3$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$1c6d1638c987b4f3$var$isRegExp(regexp)) throw new $1c6d1638c987b4f3$var$ERR_INVALID_ARG_TYPE("regexp", "RegExp", regexp);
    var match = fnName === "match";
    if (typeof string !== "string" || $1c6d1638c987b4f3$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== "string" ? 'The "string" argument must be of type string. Received type ' + "".concat($1c6d1638c987b4f3$var$_typeof(string), " (").concat($1c6d1638c987b4f3$var$inspect(string), ")") : (match ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat($1c6d1638c987b4f3$var$inspect(regexp), ". Input:\n\n").concat($1c6d1638c987b4f3$var$inspect(string), "\n"));
        var err = new $2OkWu({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$1c6d1638c987b4f3$var$assert.match = function match(string, regexp, message) {
    $1c6d1638c987b4f3$var$internalMatch(string, regexp, message, match, "match");
};
$1c6d1638c987b4f3$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $1c6d1638c987b4f3$var$internalMatch(string, regexp, message, doesNotMatch, "doesNotMatch");
};
// Expose a strict only variant of assert
function $1c6d1638c987b4f3$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $1c6d1638c987b4f3$var$innerOk.apply(void 0, [
        $1c6d1638c987b4f3$var$strict,
        args.length
    ].concat(args));
}
$1c6d1638c987b4f3$var$assert.strict = $1c6d1638c987b4f3$var$objectAssign($1c6d1638c987b4f3$var$strict, $1c6d1638c987b4f3$var$assert, {
    equal: $1c6d1638c987b4f3$var$assert.strictEqual,
    deepEqual: $1c6d1638c987b4f3$var$assert.deepStrictEqual,
    notEqual: $1c6d1638c987b4f3$var$assert.notStrictEqual,
    notDeepEqual: $1c6d1638c987b4f3$var$assert.notDeepStrictEqual
});
$1c6d1638c987b4f3$var$assert.strict.strict = $1c6d1638c987b4f3$var$assert.strict;

});
parcelRequire.register("j3n0m", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $ddf02469ea608166$export$e45cb6485273080e; }, function (v) { return $ddf02469ea608166$export$e45cb6485273080e = v; });
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $ddf02469ea608166$export$e45cb6485273080e;
"use strict";
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $ddf02469ea608166$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ddf02469ea608166$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ddf02469ea608166$var$_typeof(o);
}
function $ddf02469ea608166$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ddf02469ea608166$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ddf02469ea608166$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ddf02469ea608166$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ddf02469ea608166$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ddf02469ea608166$var$_toPropertyKey(arg) {
    var key = $ddf02469ea608166$var$_toPrimitive(arg, "string");
    return $ddf02469ea608166$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ddf02469ea608166$var$_toPrimitive(input, hint) {
    if ($ddf02469ea608166$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ddf02469ea608166$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ddf02469ea608166$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ddf02469ea608166$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ddf02469ea608166$var$_setPrototypeOf(subClass, superClass);
}
function $ddf02469ea608166$var$_setPrototypeOf(o, p) {
    $ddf02469ea608166$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ddf02469ea608166$var$_setPrototypeOf(o, p);
}
function $ddf02469ea608166$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ddf02469ea608166$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ddf02469ea608166$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ddf02469ea608166$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ddf02469ea608166$var$_possibleConstructorReturn(this, result);
    };
}
function $ddf02469ea608166$var$_possibleConstructorReturn(self, call) {
    if (call && ($ddf02469ea608166$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ddf02469ea608166$var$_assertThisInitialized(self);
}
function $ddf02469ea608166$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ddf02469ea608166$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ddf02469ea608166$var$_getPrototypeOf(o) {
    $ddf02469ea608166$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ddf02469ea608166$var$_getPrototypeOf(o);
}
var $ddf02469ea608166$var$codes = {};
// Lazy loaded
var $ddf02469ea608166$var$assert;
var $ddf02469ea608166$var$util;
function $ddf02469ea608166$var$createErrorType(code, message, Base) {
    var getMessage = function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    };
    if (!Base) Base = Error;
    var NodeError = /*#__PURE__*/ function(_Base) {
        $ddf02469ea608166$var$_inherits(NodeError, _Base);
        var _super = $ddf02469ea608166$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $ddf02469ea608166$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $ddf02469ea608166$var$_createClass(NodeError);
    }(Base);
    $ddf02469ea608166$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $ddf02469ea608166$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $ddf02469ea608166$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $ddf02469ea608166$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $ddf02469ea608166$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$ddf02469ea608166$var$createErrorType("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);

$ddf02469ea608166$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    if ($ddf02469ea608166$var$assert === undefined) $ddf02469ea608166$var$assert = (parcelRequire("2rjjG"));
    $ddf02469ea608166$var$assert(typeof name === "string", "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $ddf02469ea608166$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($ddf02469ea608166$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($ddf02469ea608166$var$oneOf(expected, "type"));
    else {
        var type = $ddf02469ea608166$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($ddf02469ea608166$var$oneOf(expected, "type"));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($ddf02469ea608166$var$_typeof(actual));
    return msg;
}, TypeError);

$ddf02469ea608166$var$createErrorType("ERR_INVALID_ARG_VALUE", function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "is invalid";
    if ($ddf02469ea608166$var$util === undefined) $ddf02469ea608166$var$util = (parcelRequire("lQXBK"));
    var inspected = $ddf02469ea608166$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$ddf02469ea608166$var$createErrorType("ERR_INVALID_RETURN_VALUE", function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($ddf02469ea608166$var$_typeof(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);

$ddf02469ea608166$var$createErrorType("ERR_MISSING_ARGS", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($ddf02469ea608166$var$assert === undefined) $ddf02469ea608166$var$assert = (parcelRequire("2rjjG"));
    $ddf02469ea608166$var$assert(args.length > 0, "At least one arg needs to be specified");
    var msg = "The ";
    var len = args.length;
    args = args.map(function(a) {
        return '"'.concat(a, '"');
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(", ");
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$ddf02469ea608166$export$e45cb6485273080e = $ddf02469ea608166$var$codes;

});
parcelRequire.register("lQXBK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $1ObTH = parcelRequire("1ObTH");

var $aqbQf = parcelRequire("aqbQf");
var $fe8cb12fb33ef0bb$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $fe8cb12fb33ef0bb$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$fe8cb12fb33ef0bb$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($fe8cb12fb33ef0bb$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($fe8cb12fb33ef0bb$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($fe8cb12fb33ef0bb$var$isNull(x) || !$fe8cb12fb33ef0bb$var$isObject(x)) str += " " + x;
    else str += " " + $fe8cb12fb33ef0bb$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var deprecated = function deprecated() {
        if (!warned) {
            if ($aqbQf.throwDeprecation) throw new Error(msg);
            else if ($aqbQf.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    };
    if (typeof $aqbQf !== "undefined" && $aqbQf.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $aqbQf === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    return deprecated;
};
var $fe8cb12fb33ef0bb$var$debugs = {};
var $fe8cb12fb33ef0bb$var$debugEnvRegex = /^$/;
var $fe8cb12fb33ef0bb$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$fe8cb12fb33ef0bb$var$debugs[set]) {
        if ($fe8cb12fb33ef0bb$var$debugEnvRegex.test(set)) {
            var pid = $aqbQf.pid;
            $fe8cb12fb33ef0bb$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $fe8cb12fb33ef0bb$var$debugs[set] = function() {};
    }
    return $fe8cb12fb33ef0bb$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $fe8cb12fb33ef0bb$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $fe8cb12fb33ef0bb$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($fe8cb12fb33ef0bb$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($fe8cb12fb33ef0bb$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($fe8cb12fb33ef0bb$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($fe8cb12fb33ef0bb$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($fe8cb12fb33ef0bb$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $fe8cb12fb33ef0bb$var$stylizeWithColor;
    return $fe8cb12fb33ef0bb$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $fe8cb12fb33ef0bb$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$fe8cb12fb33ef0bb$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$fe8cb12fb33ef0bb$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $fe8cb12fb33ef0bb$var$stylizeWithColor(str, styleType) {
    var style = $fe8cb12fb33ef0bb$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $fe8cb12fb33ef0bb$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $fe8cb12fb33ef0bb$var$inspect.colors[style][1] + "m";
    else return str;
}
function $fe8cb12fb33ef0bb$var$stylizeNoColor(str, styleType) {
    return str;
}
function $fe8cb12fb33ef0bb$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $fe8cb12fb33ef0bb$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $fe8cb12fb33ef0bb$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$fe8cb12fb33ef0bb$var$isString(ret)) ret = $fe8cb12fb33ef0bb$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $fe8cb12fb33ef0bb$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $fe8cb12fb33ef0bb$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($fe8cb12fb33ef0bb$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $fe8cb12fb33ef0bb$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($fe8cb12fb33ef0bb$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($fe8cb12fb33ef0bb$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($fe8cb12fb33ef0bb$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($fe8cb12fb33ef0bb$var$isError(value)) return $fe8cb12fb33ef0bb$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($fe8cb12fb33ef0bb$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($fe8cb12fb33ef0bb$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($fe8cb12fb33ef0bb$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($fe8cb12fb33ef0bb$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($fe8cb12fb33ef0bb$var$isError(value)) base = " " + $fe8cb12fb33ef0bb$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($fe8cb12fb33ef0bb$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $fe8cb12fb33ef0bb$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $fe8cb12fb33ef0bb$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $fe8cb12fb33ef0bb$var$reduceToSingleString(output, base, braces);
}
function $fe8cb12fb33ef0bb$var$formatPrimitive(ctx, value) {
    if ($fe8cb12fb33ef0bb$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($fe8cb12fb33ef0bb$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($fe8cb12fb33ef0bb$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($fe8cb12fb33ef0bb$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($fe8cb12fb33ef0bb$var$isNull(value)) return ctx.stylize("null", "null");
}
function $fe8cb12fb33ef0bb$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $fe8cb12fb33ef0bb$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($fe8cb12fb33ef0bb$var$hasOwnProperty(value, String(i))) output.push($fe8cb12fb33ef0bb$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($fe8cb12fb33ef0bb$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $fe8cb12fb33ef0bb$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$fe8cb12fb33ef0bb$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($fe8cb12fb33ef0bb$var$isNull(recurseTimes)) str = $fe8cb12fb33ef0bb$var$formatValue(ctx, desc.value, null);
            else str = $fe8cb12fb33ef0bb$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($fe8cb12fb33ef0bb$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $fe8cb12fb33ef0bb$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("bpIwW"));
function $fe8cb12fb33ef0bb$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $fe8cb12fb33ef0bb$var$isArray;
function $fe8cb12fb33ef0bb$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $fe8cb12fb33ef0bb$var$isBoolean;
function $fe8cb12fb33ef0bb$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $fe8cb12fb33ef0bb$var$isNull;
function $fe8cb12fb33ef0bb$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $fe8cb12fb33ef0bb$var$isNullOrUndefined;
function $fe8cb12fb33ef0bb$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $fe8cb12fb33ef0bb$var$isNumber;
function $fe8cb12fb33ef0bb$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $fe8cb12fb33ef0bb$var$isString;
function $fe8cb12fb33ef0bb$var$isSymbol(arg) {
    return (typeof arg === "undefined" ? "undefined" : (0, $1ObTH._)(arg)) === "symbol";
}
module.exports.isSymbol = $fe8cb12fb33ef0bb$var$isSymbol;
function $fe8cb12fb33ef0bb$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $fe8cb12fb33ef0bb$var$isUndefined;
function $fe8cb12fb33ef0bb$var$isRegExp(re) {
    return $fe8cb12fb33ef0bb$var$isObject(re) && $fe8cb12fb33ef0bb$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $fe8cb12fb33ef0bb$var$isRegExp;
module.exports.types.isRegExp = $fe8cb12fb33ef0bb$var$isRegExp;
function $fe8cb12fb33ef0bb$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $fe8cb12fb33ef0bb$var$isObject;
function $fe8cb12fb33ef0bb$var$isDate(d) {
    return $fe8cb12fb33ef0bb$var$isObject(d) && $fe8cb12fb33ef0bb$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $fe8cb12fb33ef0bb$var$isDate;
module.exports.types.isDate = $fe8cb12fb33ef0bb$var$isDate;
function $fe8cb12fb33ef0bb$var$isError(e) {
    return $fe8cb12fb33ef0bb$var$isObject(e) && ($fe8cb12fb33ef0bb$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $fe8cb12fb33ef0bb$var$isError;
module.exports.types.isNativeError = $fe8cb12fb33ef0bb$var$isError;
function $fe8cb12fb33ef0bb$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $fe8cb12fb33ef0bb$var$isFunction;
function $fe8cb12fb33ef0bb$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || (typeof arg === "undefined" ? "undefined" : (0, $1ObTH._)(arg)) === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $fe8cb12fb33ef0bb$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("jIG8S"));
function $fe8cb12fb33ef0bb$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $fe8cb12fb33ef0bb$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $fe8cb12fb33ef0bb$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $fe8cb12fb33ef0bb$var$timestamp() {
    var d = new Date();
    var time = [
        $fe8cb12fb33ef0bb$var$pad(d.getHours()),
        $fe8cb12fb33ef0bb$var$pad(d.getMinutes()),
        $fe8cb12fb33ef0bb$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $fe8cb12fb33ef0bb$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $fe8cb12fb33ef0bb$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("kvFQ5"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$fe8cb12fb33ef0bb$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $fe8cb12fb33ef0bb$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $fe8cb12fb33ef0bb$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    var fn = function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    };
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($fe8cb12fb33ef0bb$var$kCustomPromisifiedSymbol && original[$fe8cb12fb33ef0bb$var$kCustomPromisifiedSymbol]) {
        var fn = original[$fe8cb12fb33ef0bb$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $fe8cb12fb33ef0bb$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($fe8cb12fb33ef0bb$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $fe8cb12fb33ef0bb$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $fe8cb12fb33ef0bb$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $fe8cb12fb33ef0bb$var$kCustomPromisifiedSymbol;
function $fe8cb12fb33ef0bb$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $fe8cb12fb33ef0bb$var$callbackify(original) {
    var callbackified = // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function cb() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $aqbQf.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $aqbQf.nextTick($fe8cb12fb33ef0bb$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    };
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $fe8cb12fb33ef0bb$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $fe8cb12fb33ef0bb$var$callbackify;

});
parcelRequire.register("bpIwW", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $kulAv = parcelRequire("kulAv");

var $iTOcq = parcelRequire("iTOcq");

var $fsbZZ = parcelRequire("fsbZZ");

var $duG8W = parcelRequire("duG8W");
function $84f49246fe02cd5c$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $84f49246fe02cd5c$var$BigIntSupported = typeof BigInt !== "undefined";
var $84f49246fe02cd5c$var$SymbolSupported = typeof Symbol !== "undefined";
var $84f49246fe02cd5c$var$ObjectToString = $84f49246fe02cd5c$var$uncurryThis(Object.prototype.toString);
var $84f49246fe02cd5c$var$numberValue = $84f49246fe02cd5c$var$uncurryThis(Number.prototype.valueOf);
var $84f49246fe02cd5c$var$stringValue = $84f49246fe02cd5c$var$uncurryThis(String.prototype.valueOf);
var $84f49246fe02cd5c$var$booleanValue = $84f49246fe02cd5c$var$uncurryThis(Boolean.prototype.valueOf);
if ($84f49246fe02cd5c$var$BigIntSupported) var $84f49246fe02cd5c$var$bigIntValue = $84f49246fe02cd5c$var$uncurryThis(BigInt.prototype.valueOf);
if ($84f49246fe02cd5c$var$SymbolSupported) var $84f49246fe02cd5c$var$symbolValue = $84f49246fe02cd5c$var$uncurryThis(Symbol.prototype.valueOf);
function $84f49246fe02cd5c$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $kulAv;
module.exports.isGeneratorFunction = $iTOcq;
module.exports.isTypedArray = $duG8W;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $84f49246fe02cd5c$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $84f49246fe02cd5c$var$isPromise;
function $84f49246fe02cd5c$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $duG8W(value) || $84f49246fe02cd5c$var$isDataView(value);
}
module.exports.isArrayBufferView = $84f49246fe02cd5c$var$isArrayBufferView;
function $84f49246fe02cd5c$var$isUint8Array(value) {
    return $fsbZZ(value) === "Uint8Array";
}
module.exports.isUint8Array = $84f49246fe02cd5c$var$isUint8Array;
function $84f49246fe02cd5c$var$isUint8ClampedArray(value) {
    return $fsbZZ(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $84f49246fe02cd5c$var$isUint8ClampedArray;
function $84f49246fe02cd5c$var$isUint16Array(value) {
    return $fsbZZ(value) === "Uint16Array";
}
module.exports.isUint16Array = $84f49246fe02cd5c$var$isUint16Array;
function $84f49246fe02cd5c$var$isUint32Array(value) {
    return $fsbZZ(value) === "Uint32Array";
}
module.exports.isUint32Array = $84f49246fe02cd5c$var$isUint32Array;
function $84f49246fe02cd5c$var$isInt8Array(value) {
    return $fsbZZ(value) === "Int8Array";
}
module.exports.isInt8Array = $84f49246fe02cd5c$var$isInt8Array;
function $84f49246fe02cd5c$var$isInt16Array(value) {
    return $fsbZZ(value) === "Int16Array";
}
module.exports.isInt16Array = $84f49246fe02cd5c$var$isInt16Array;
function $84f49246fe02cd5c$var$isInt32Array(value) {
    return $fsbZZ(value) === "Int32Array";
}
module.exports.isInt32Array = $84f49246fe02cd5c$var$isInt32Array;
function $84f49246fe02cd5c$var$isFloat32Array(value) {
    return $fsbZZ(value) === "Float32Array";
}
module.exports.isFloat32Array = $84f49246fe02cd5c$var$isFloat32Array;
function $84f49246fe02cd5c$var$isFloat64Array(value) {
    return $fsbZZ(value) === "Float64Array";
}
module.exports.isFloat64Array = $84f49246fe02cd5c$var$isFloat64Array;
function $84f49246fe02cd5c$var$isBigInt64Array(value) {
    return $fsbZZ(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $84f49246fe02cd5c$var$isBigInt64Array;
function $84f49246fe02cd5c$var$isBigUint64Array(value) {
    return $fsbZZ(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $84f49246fe02cd5c$var$isBigUint64Array;
function $84f49246fe02cd5c$var$isMapToString(value) {
    return $84f49246fe02cd5c$var$ObjectToString(value) === "[object Map]";
}
$84f49246fe02cd5c$var$isMapToString.working = typeof Map !== "undefined" && $84f49246fe02cd5c$var$isMapToString(new Map());
function $84f49246fe02cd5c$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $84f49246fe02cd5c$var$isMapToString.working ? $84f49246fe02cd5c$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $84f49246fe02cd5c$var$isMap;
function $84f49246fe02cd5c$var$isSetToString(value) {
    return $84f49246fe02cd5c$var$ObjectToString(value) === "[object Set]";
}
$84f49246fe02cd5c$var$isSetToString.working = typeof Set !== "undefined" && $84f49246fe02cd5c$var$isSetToString(new Set());
function $84f49246fe02cd5c$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $84f49246fe02cd5c$var$isSetToString.working ? $84f49246fe02cd5c$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $84f49246fe02cd5c$var$isSet;
function $84f49246fe02cd5c$var$isWeakMapToString(value) {
    return $84f49246fe02cd5c$var$ObjectToString(value) === "[object WeakMap]";
}
$84f49246fe02cd5c$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $84f49246fe02cd5c$var$isWeakMapToString(new WeakMap());
function $84f49246fe02cd5c$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $84f49246fe02cd5c$var$isWeakMapToString.working ? $84f49246fe02cd5c$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $84f49246fe02cd5c$var$isWeakMap;
function $84f49246fe02cd5c$var$isWeakSetToString(value) {
    return $84f49246fe02cd5c$var$ObjectToString(value) === "[object WeakSet]";
}
$84f49246fe02cd5c$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $84f49246fe02cd5c$var$isWeakSetToString(new WeakSet());
function $84f49246fe02cd5c$var$isWeakSet(value) {
    return $84f49246fe02cd5c$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $84f49246fe02cd5c$var$isWeakSet;
function $84f49246fe02cd5c$var$isArrayBufferToString(value) {
    return $84f49246fe02cd5c$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$84f49246fe02cd5c$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $84f49246fe02cd5c$var$isArrayBufferToString(new ArrayBuffer());
function $84f49246fe02cd5c$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $84f49246fe02cd5c$var$isArrayBufferToString.working ? $84f49246fe02cd5c$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $84f49246fe02cd5c$var$isArrayBuffer;
function $84f49246fe02cd5c$var$isDataViewToString(value) {
    return $84f49246fe02cd5c$var$ObjectToString(value) === "[object DataView]";
}
$84f49246fe02cd5c$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $84f49246fe02cd5c$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $84f49246fe02cd5c$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $84f49246fe02cd5c$var$isDataViewToString.working ? $84f49246fe02cd5c$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $84f49246fe02cd5c$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $84f49246fe02cd5c$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $84f49246fe02cd5c$var$isSharedArrayBufferToString(value) {
    return $84f49246fe02cd5c$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $84f49246fe02cd5c$var$isSharedArrayBuffer(value) {
    if (typeof $84f49246fe02cd5c$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $84f49246fe02cd5c$var$isSharedArrayBufferToString.working === "undefined") $84f49246fe02cd5c$var$isSharedArrayBufferToString.working = $84f49246fe02cd5c$var$isSharedArrayBufferToString(new $84f49246fe02cd5c$var$SharedArrayBufferCopy());
    return $84f49246fe02cd5c$var$isSharedArrayBufferToString.working ? $84f49246fe02cd5c$var$isSharedArrayBufferToString(value) : value instanceof $84f49246fe02cd5c$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $84f49246fe02cd5c$var$isSharedArrayBuffer;
function $84f49246fe02cd5c$var$isAsyncFunction(value) {
    return $84f49246fe02cd5c$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $84f49246fe02cd5c$var$isAsyncFunction;
function $84f49246fe02cd5c$var$isMapIterator(value) {
    return $84f49246fe02cd5c$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $84f49246fe02cd5c$var$isMapIterator;
function $84f49246fe02cd5c$var$isSetIterator(value) {
    return $84f49246fe02cd5c$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $84f49246fe02cd5c$var$isSetIterator;
function $84f49246fe02cd5c$var$isGeneratorObject(value) {
    return $84f49246fe02cd5c$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $84f49246fe02cd5c$var$isGeneratorObject;
function $84f49246fe02cd5c$var$isWebAssemblyCompiledModule(value) {
    return $84f49246fe02cd5c$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $84f49246fe02cd5c$var$isWebAssemblyCompiledModule;
function $84f49246fe02cd5c$var$isNumberObject(value) {
    return $84f49246fe02cd5c$var$checkBoxedPrimitive(value, $84f49246fe02cd5c$var$numberValue);
}
module.exports.isNumberObject = $84f49246fe02cd5c$var$isNumberObject;
function $84f49246fe02cd5c$var$isStringObject(value) {
    return $84f49246fe02cd5c$var$checkBoxedPrimitive(value, $84f49246fe02cd5c$var$stringValue);
}
module.exports.isStringObject = $84f49246fe02cd5c$var$isStringObject;
function $84f49246fe02cd5c$var$isBooleanObject(value) {
    return $84f49246fe02cd5c$var$checkBoxedPrimitive(value, $84f49246fe02cd5c$var$booleanValue);
}
module.exports.isBooleanObject = $84f49246fe02cd5c$var$isBooleanObject;
function $84f49246fe02cd5c$var$isBigIntObject(value) {
    return $84f49246fe02cd5c$var$BigIntSupported && $84f49246fe02cd5c$var$checkBoxedPrimitive(value, $84f49246fe02cd5c$var$bigIntValue);
}
module.exports.isBigIntObject = $84f49246fe02cd5c$var$isBigIntObject;
function $84f49246fe02cd5c$var$isSymbolObject(value) {
    return $84f49246fe02cd5c$var$SymbolSupported && $84f49246fe02cd5c$var$checkBoxedPrimitive(value, $84f49246fe02cd5c$var$symbolValue);
}
module.exports.isSymbolObject = $84f49246fe02cd5c$var$isSymbolObject;
function $84f49246fe02cd5c$var$isBoxedPrimitive(value) {
    return $84f49246fe02cd5c$var$isNumberObject(value) || $84f49246fe02cd5c$var$isStringObject(value) || $84f49246fe02cd5c$var$isBooleanObject(value) || $84f49246fe02cd5c$var$isBigIntObject(value) || $84f49246fe02cd5c$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $84f49246fe02cd5c$var$isBoxedPrimitive;
function $84f49246fe02cd5c$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($84f49246fe02cd5c$var$isArrayBuffer(value) || $84f49246fe02cd5c$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $84f49246fe02cd5c$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function value() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRequire.register("kulAv", function(module, exports) {
"use strict";

var $eea75add41f5e397$var$hasToStringTag = (parcelRequire("eOUta"))();

var $a990d = parcelRequire("a990d");
var $eea75add41f5e397$var$$toString = $a990d("Object.prototype.toString");
var $eea75add41f5e397$var$isStandardArguments = function isArguments(value) {
    if ($eea75add41f5e397$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $eea75add41f5e397$var$$toString(value) === "[object Arguments]";
};
var $eea75add41f5e397$var$isLegacyArguments = function isArguments(value) {
    if ($eea75add41f5e397$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $eea75add41f5e397$var$$toString(value) !== "[object Array]" && $eea75add41f5e397$var$$toString(value.callee) === "[object Function]";
};
var $eea75add41f5e397$var$supportsStandardArguments = function() {
    return $eea75add41f5e397$var$isStandardArguments(arguments);
}();
$eea75add41f5e397$var$isStandardArguments.isLegacyArguments = $eea75add41f5e397$var$isLegacyArguments; // for tests
module.exports = $eea75add41f5e397$var$supportsStandardArguments ? $eea75add41f5e397$var$isStandardArguments : $eea75add41f5e397$var$isLegacyArguments;

});
parcelRequire.register("eOUta", function(module, exports) {
"use strict";

var $c2gQh = parcelRequire("c2gQh");
module.exports = function hasToStringTagShams() {
    return $c2gQh() && !!Symbol.toStringTag;
};

});
parcelRequire.register("c2gQh", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if ((0, $1ObTH._)(Symbol.iterator) === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRequire.register("a990d", function(module, exports) {
"use strict";

var $5KFGy = parcelRequire("5KFGy");

var $4bBQu = parcelRequire("4bBQu");
var $7631ba58148dda97$var$$indexOf = $4bBQu($5KFGy("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $5KFGy(name, !!allowMissing);
    if (typeof intrinsic === "function" && $7631ba58148dda97$var$$indexOf(name, ".prototype.") > -1) return $4bBQu(intrinsic);
    return intrinsic;
};

});
parcelRequire.register("5KFGy", function(module, exports) {
"use strict";
var $43019574e681d1e0$var$undefined;
var $43019574e681d1e0$var$$SyntaxError = SyntaxError;
var $43019574e681d1e0$var$$Function = Function;
var $43019574e681d1e0$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $43019574e681d1e0$var$getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
    try {
        return $43019574e681d1e0$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $43019574e681d1e0$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($43019574e681d1e0$var$$gOPD) try {
    $43019574e681d1e0$var$$gOPD({}, "");
} catch (e) {
    $43019574e681d1e0$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $43019574e681d1e0$var$throwTypeError = function throwTypeError() {
    throw new $43019574e681d1e0$var$$TypeError();
};
var $43019574e681d1e0$var$ThrowTypeError = $43019574e681d1e0$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $43019574e681d1e0$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $43019574e681d1e0$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $43019574e681d1e0$var$throwTypeError;
        }
    }
}() : $43019574e681d1e0$var$throwTypeError;

var $43019574e681d1e0$var$hasSymbols = (parcelRequire("5r0Q9"))();

var $43019574e681d1e0$var$hasProto = (parcelRequire("bLAfM"))();
var $43019574e681d1e0$var$getProto = Object.getPrototypeOf || ($43019574e681d1e0$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $43019574e681d1e0$var$needsEval = {};
var $43019574e681d1e0$var$TypedArray = typeof Uint8Array === "undefined" || !$43019574e681d1e0$var$getProto ? $43019574e681d1e0$var$undefined : $43019574e681d1e0$var$getProto(Uint8Array);
var $43019574e681d1e0$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? $43019574e681d1e0$var$undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? $43019574e681d1e0$var$undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $43019574e681d1e0$var$hasSymbols && $43019574e681d1e0$var$getProto ? $43019574e681d1e0$var$getProto([][Symbol.iterator]()) : $43019574e681d1e0$var$undefined,
    "%AsyncFromSyncIteratorPrototype%": $43019574e681d1e0$var$undefined,
    "%AsyncFunction%": $43019574e681d1e0$var$needsEval,
    "%AsyncGenerator%": $43019574e681d1e0$var$needsEval,
    "%AsyncGeneratorFunction%": $43019574e681d1e0$var$needsEval,
    "%AsyncIteratorPrototype%": $43019574e681d1e0$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? $43019574e681d1e0$var$undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? $43019574e681d1e0$var$undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? $43019574e681d1e0$var$undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? $43019574e681d1e0$var$undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? $43019574e681d1e0$var$undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? $43019574e681d1e0$var$undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? $43019574e681d1e0$var$undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? $43019574e681d1e0$var$undefined : FinalizationRegistry,
    "%Function%": $43019574e681d1e0$var$$Function,
    "%GeneratorFunction%": $43019574e681d1e0$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? $43019574e681d1e0$var$undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? $43019574e681d1e0$var$undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? $43019574e681d1e0$var$undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $43019574e681d1e0$var$hasSymbols && $43019574e681d1e0$var$getProto ? $43019574e681d1e0$var$getProto($43019574e681d1e0$var$getProto([][Symbol.iterator]())) : $43019574e681d1e0$var$undefined,
    "%JSON%": typeof JSON === "object" ? JSON : $43019574e681d1e0$var$undefined,
    "%Map%": typeof Map === "undefined" ? $43019574e681d1e0$var$undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$43019574e681d1e0$var$hasSymbols || !$43019574e681d1e0$var$getProto ? $43019574e681d1e0$var$undefined : $43019574e681d1e0$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? $43019574e681d1e0$var$undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? $43019574e681d1e0$var$undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? $43019574e681d1e0$var$undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? $43019574e681d1e0$var$undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$43019574e681d1e0$var$hasSymbols || !$43019574e681d1e0$var$getProto ? $43019574e681d1e0$var$undefined : $43019574e681d1e0$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? $43019574e681d1e0$var$undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $43019574e681d1e0$var$hasSymbols && $43019574e681d1e0$var$getProto ? $43019574e681d1e0$var$getProto(""[Symbol.iterator]()) : $43019574e681d1e0$var$undefined,
    "%Symbol%": $43019574e681d1e0$var$hasSymbols ? Symbol : $43019574e681d1e0$var$undefined,
    "%SyntaxError%": $43019574e681d1e0$var$$SyntaxError,
    "%ThrowTypeError%": $43019574e681d1e0$var$ThrowTypeError,
    "%TypedArray%": $43019574e681d1e0$var$TypedArray,
    "%TypeError%": $43019574e681d1e0$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? $43019574e681d1e0$var$undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? $43019574e681d1e0$var$undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? $43019574e681d1e0$var$undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? $43019574e681d1e0$var$undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? $43019574e681d1e0$var$undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? $43019574e681d1e0$var$undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? $43019574e681d1e0$var$undefined : WeakSet
};
if ($43019574e681d1e0$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $43019574e681d1e0$var$errorProto = $43019574e681d1e0$var$getProto($43019574e681d1e0$var$getProto(e));
    $43019574e681d1e0$var$INTRINSICS["%Error.prototype%"] = $43019574e681d1e0$var$errorProto;
}
var $43019574e681d1e0$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $43019574e681d1e0$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $43019574e681d1e0$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $43019574e681d1e0$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $43019574e681d1e0$var$getProto) value = $43019574e681d1e0$var$getProto(gen.prototype);
    }
    $43019574e681d1e0$var$INTRINSICS[name] = value;
    return value;
};
var $43019574e681d1e0$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $1F3qt = parcelRequire("1F3qt");

var $kVmrv = parcelRequire("kVmrv");
var $43019574e681d1e0$var$$concat = $1F3qt.call(Function.call, Array.prototype.concat);
var $43019574e681d1e0$var$$spliceApply = $1F3qt.call(Function.apply, Array.prototype.splice);
var $43019574e681d1e0$var$$replace = $1F3qt.call(Function.call, String.prototype.replace);
var $43019574e681d1e0$var$$strSlice = $1F3qt.call(Function.call, String.prototype.slice);
var $43019574e681d1e0$var$$exec = $1F3qt.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $43019574e681d1e0$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $43019574e681d1e0$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $43019574e681d1e0$var$stringToPath = function stringToPath(string) {
    var first = $43019574e681d1e0$var$$strSlice(string, 0, 1);
    var last = $43019574e681d1e0$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $43019574e681d1e0$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $43019574e681d1e0$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $43019574e681d1e0$var$$replace(string, $43019574e681d1e0$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $43019574e681d1e0$var$$replace(subString, $43019574e681d1e0$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $43019574e681d1e0$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($kVmrv($43019574e681d1e0$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $43019574e681d1e0$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($kVmrv($43019574e681d1e0$var$INTRINSICS, intrinsicName)) {
        var value = $43019574e681d1e0$var$INTRINSICS[intrinsicName];
        if (value === $43019574e681d1e0$var$needsEval) value = $43019574e681d1e0$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $43019574e681d1e0$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $43019574e681d1e0$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $43019574e681d1e0$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $43019574e681d1e0$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($43019574e681d1e0$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $43019574e681d1e0$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $43019574e681d1e0$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $43019574e681d1e0$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $43019574e681d1e0$var$$spliceApply(parts, $43019574e681d1e0$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $43019574e681d1e0$var$$strSlice(part, 0, 1);
        var last = $43019574e681d1e0$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $43019574e681d1e0$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($kVmrv($43019574e681d1e0$var$INTRINSICS, intrinsicRealName)) value = $43019574e681d1e0$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $43019574e681d1e0$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($43019574e681d1e0$var$$gOPD && i + 1 >= parts.length) {
                var desc = $43019574e681d1e0$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $kVmrv(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $43019574e681d1e0$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRequire.register("5r0Q9", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
"use strict";
var $3f50203680890d74$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $c2gQh = parcelRequire("c2gQh");
module.exports = function hasNativeSymbols() {
    if (typeof $3f50203680890d74$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if ((0, $1ObTH._)($3f50203680890d74$var$origSymbol("foo")) !== "symbol") return false;
    if ((0, $1ObTH._)(Symbol("bar")) !== "symbol") return false;
    return $c2gQh();
};

});

parcelRequire.register("bLAfM", function(module, exports) {
"use strict";
var $891034b66877f2be$var$test = {
    foo: {}
};
var $891034b66877f2be$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $891034b66877f2be$var$test
    }).foo === $891034b66877f2be$var$test.foo && !(({
        __proto__: null
    }) instanceof $891034b66877f2be$var$$Object);
};

});

parcelRequire.register("1F3qt", function(module, exports) {
"use strict";

var $eovtQ = parcelRequire("eovtQ");
module.exports = Function.prototype.bind || $eovtQ;

});
parcelRequire.register("eovtQ", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $a7abb9ee5a94438d$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $a7abb9ee5a94438d$var$slice = Array.prototype.slice;
var $a7abb9ee5a94438d$var$toStr = Object.prototype.toString;
var $a7abb9ee5a94438d$var$funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $a7abb9ee5a94438d$var$toStr.call(target) !== $a7abb9ee5a94438d$var$funcType) throw new TypeError($a7abb9ee5a94438d$var$ERROR_MESSAGE + target);
    var args = $a7abb9ee5a94438d$var$slice.call(arguments, 1);
    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($a7abb9ee5a94438d$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($a7abb9ee5a94438d$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRequire.register("kVmrv", function(module, exports) {
"use strict";
var $f3ba8a27f2ac7413$var$hasOwnProperty = {}.hasOwnProperty;
var $f3ba8a27f2ac7413$var$call = Function.prototype.call;
module.exports = $f3ba8a27f2ac7413$var$call.bind ? $f3ba8a27f2ac7413$var$call.bind($f3ba8a27f2ac7413$var$hasOwnProperty) : function(O, P) {
    return $f3ba8a27f2ac7413$var$call.call($f3ba8a27f2ac7413$var$hasOwnProperty, O, P);
};

});


parcelRequire.register("4bBQu", function(module, exports) {
"use strict";

var $1F3qt = parcelRequire("1F3qt");

var $5KFGy = parcelRequire("5KFGy");
var $30c58bd5d30def94$var$$apply = $5KFGy("%Function.prototype.apply%");
var $30c58bd5d30def94$var$$call = $5KFGy("%Function.prototype.call%");
var $30c58bd5d30def94$var$$reflectApply = $5KFGy("%Reflect.apply%", true) || $1F3qt.call($30c58bd5d30def94$var$$call, $30c58bd5d30def94$var$$apply);
var $30c58bd5d30def94$var$$gOPD = $5KFGy("%Object.getOwnPropertyDescriptor%", true);
var $30c58bd5d30def94$var$$defineProperty = $5KFGy("%Object.defineProperty%", true);
var $30c58bd5d30def94$var$$max = $5KFGy("%Math.max%");
if ($30c58bd5d30def94$var$$defineProperty) try {
    $30c58bd5d30def94$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $30c58bd5d30def94$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $30c58bd5d30def94$var$$reflectApply($1F3qt, $30c58bd5d30def94$var$$call, arguments);
    if ($30c58bd5d30def94$var$$gOPD && $30c58bd5d30def94$var$$defineProperty) {
        var desc = $30c58bd5d30def94$var$$gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $30c58bd5d30def94$var$$defineProperty(func, "length", {
            value: 1 + $30c58bd5d30def94$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $30c58bd5d30def94$var$applyBind = function applyBind() {
    return $30c58bd5d30def94$var$$reflectApply($1F3qt, $30c58bd5d30def94$var$$apply, arguments);
};
if ($30c58bd5d30def94$var$$defineProperty) $30c58bd5d30def94$var$$defineProperty(module.exports, "apply", {
    value: $30c58bd5d30def94$var$applyBind
});
else module.exports.apply = $30c58bd5d30def94$var$applyBind;

});



parcelRequire.register("iTOcq", function(module, exports) {
"use strict";
var $dc244d9f91d60579$var$toStr = Object.prototype.toString;
var $dc244d9f91d60579$var$fnToStr = Function.prototype.toString;
var $dc244d9f91d60579$var$isFnRegex = /^\s*(?:function)?\*/;

var $dc244d9f91d60579$var$hasToStringTag = (parcelRequire("eOUta"))();
var $dc244d9f91d60579$var$getProto = Object.getPrototypeOf;
var $dc244d9f91d60579$var$getGeneratorFunc = function getGeneratorFunc() {
    if (!$dc244d9f91d60579$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $dc244d9f91d60579$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($dc244d9f91d60579$var$isFnRegex.test($dc244d9f91d60579$var$fnToStr.call(fn))) return true;
    if (!$dc244d9f91d60579$var$hasToStringTag) {
        var str = $dc244d9f91d60579$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$dc244d9f91d60579$var$getProto) return false;
    if (typeof $dc244d9f91d60579$var$GeneratorFunction === "undefined") {
        var generatorFunc = $dc244d9f91d60579$var$getGeneratorFunc();
        $dc244d9f91d60579$var$GeneratorFunction = generatorFunc ? $dc244d9f91d60579$var$getProto(generatorFunc) : false;
    }
    return $dc244d9f91d60579$var$getProto(fn) === $dc244d9f91d60579$var$GeneratorFunction;
};

});

parcelRequire.register("fsbZZ", function(module, exports) {
"use strict";

var $456sA = parcelRequire("456sA");

var $falZY = parcelRequire("falZY");

var $4bBQu = parcelRequire("4bBQu");

var $a990d = parcelRequire("a990d");

var $lre78 = parcelRequire("lre78");
var $b402c741c5ab99e0$var$$toString = $a990d("Object.prototype.toString");

var $b402c741c5ab99e0$var$hasToStringTag = (parcelRequire("eOUta"))();
var $b402c741c5ab99e0$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $b402c741c5ab99e0$var$typedArrays = $falZY();
var $b402c741c5ab99e0$var$$slice = $a990d("String.prototype.slice");
var $b402c741c5ab99e0$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
var $b402c741c5ab99e0$var$$indexOf = $a990d("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $b402c741c5ab99e0$var$cache = {
    __proto__: null
};
if ($b402c741c5ab99e0$var$hasToStringTag && $lre78 && $b402c741c5ab99e0$var$getPrototypeOf) $456sA($b402c741c5ab99e0$var$typedArrays, function(typedArray) {
    var arr = new $b402c741c5ab99e0$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $b402c741c5ab99e0$var$getPrototypeOf(arr);
        var descriptor = $lre78(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $b402c741c5ab99e0$var$getPrototypeOf(proto);
            descriptor = $lre78(superProto, Symbol.toStringTag);
        }
        $b402c741c5ab99e0$var$cache["$" + typedArray] = $4bBQu(descriptor.get);
    }
});
else $456sA($b402c741c5ab99e0$var$typedArrays, function(typedArray) {
    var arr = new $b402c741c5ab99e0$var$g[typedArray]();
    $b402c741c5ab99e0$var$cache["$" + typedArray] = $4bBQu(arr.slice);
});
var $b402c741c5ab99e0$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var found = false;
    $456sA($b402c741c5ab99e0$var$cache, function(getter, typedArray) {
        if (!found) try {
            if ("$" + getter(value) === typedArray) found = $b402c741c5ab99e0$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
var $b402c741c5ab99e0$var$trySlices = function tryAllSlices(value) {
    var found = false;
    $456sA($b402c741c5ab99e0$var$cache, function(getter, name) {
        if (!found) try {
            getter(value);
            found = $b402c741c5ab99e0$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$b402c741c5ab99e0$var$hasToStringTag) {
        var tag = $b402c741c5ab99e0$var$$slice($b402c741c5ab99e0$var$$toString(value), 8, -1);
        if ($b402c741c5ab99e0$var$$indexOf($b402c741c5ab99e0$var$typedArrays, tag) > -1) return tag;
        if (tag !== "Object") return false;
        // node < 0.6 hits here on real Typed Arrays
        return $b402c741c5ab99e0$var$trySlices(value);
    }
    if (!$lre78) return null;
     // unknown engine
    return $b402c741c5ab99e0$var$tryTypedArrays(value);
};

});
parcelRequire.register("456sA", function(module, exports) {
"use strict";

var $aIYUX = parcelRequire("aIYUX");
var $2f8ca3e92eb9deff$var$toStr = Object.prototype.toString;
var $2f8ca3e92eb9deff$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $2f8ca3e92eb9deff$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($2f8ca3e92eb9deff$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $2f8ca3e92eb9deff$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $2f8ca3e92eb9deff$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($2f8ca3e92eb9deff$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $2f8ca3e92eb9deff$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$aIYUX(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($2f8ca3e92eb9deff$var$toStr.call(list) === "[object Array]") $2f8ca3e92eb9deff$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $2f8ca3e92eb9deff$var$forEachString(list, iterator, receiver);
    else $2f8ca3e92eb9deff$var$forEachObject(list, iterator, receiver);
};
module.exports = $2f8ca3e92eb9deff$var$forEach;

});
parcelRequire.register("aIYUX", function(module, exports) {
"use strict";
var $7ced446c48607a21$var$fnToStr = Function.prototype.toString;
var $7ced446c48607a21$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $7ced446c48607a21$var$badArrayLike;
var $7ced446c48607a21$var$isCallableMarker;
if (typeof $7ced446c48607a21$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $7ced446c48607a21$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function get() {
            throw $7ced446c48607a21$var$isCallableMarker;
        }
    });
    $7ced446c48607a21$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $7ced446c48607a21$var$reflectApply(function() {
        throw 42;
    }, null, $7ced446c48607a21$var$badArrayLike);
} catch (_) {
    if (_ !== $7ced446c48607a21$var$isCallableMarker) $7ced446c48607a21$var$reflectApply = null;
}
else $7ced446c48607a21$var$reflectApply = null;
var $7ced446c48607a21$var$constructorRegex = /^\s*class\b/;
var $7ced446c48607a21$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $7ced446c48607a21$var$fnToStr.call(value);
        return $7ced446c48607a21$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $7ced446c48607a21$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($7ced446c48607a21$var$isES6ClassFn(value)) return false;
        $7ced446c48607a21$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $7ced446c48607a21$var$toStr = Object.prototype.toString;
var $7ced446c48607a21$var$objectClass = "[object Object]";
var $7ced446c48607a21$var$fnClass = "[object Function]";
var $7ced446c48607a21$var$genClass = "[object GeneratorFunction]";
var $7ced446c48607a21$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $7ced446c48607a21$var$ddaClass2 = "[object HTML document.all class]";
var $7ced446c48607a21$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $7ced446c48607a21$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $7ced446c48607a21$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $7ced446c48607a21$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $7ced446c48607a21$var$all = document.all;
    if ($7ced446c48607a21$var$toStr.call($7ced446c48607a21$var$all) === $7ced446c48607a21$var$toStr.call(document.all)) $7ced446c48607a21$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($7ced446c48607a21$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $7ced446c48607a21$var$toStr.call(value);
            return (str === $7ced446c48607a21$var$ddaClass || str === $7ced446c48607a21$var$ddaClass2 || str === $7ced446c48607a21$var$ddaClass3 // opera 12.16
             || str === $7ced446c48607a21$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $7ced446c48607a21$var$reflectApply ? function isCallable(value) {
    if ($7ced446c48607a21$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $7ced446c48607a21$var$reflectApply(value, null, $7ced446c48607a21$var$badArrayLike);
    } catch (e) {
        if (e !== $7ced446c48607a21$var$isCallableMarker) return false;
    }
    return !$7ced446c48607a21$var$isES6ClassFn(value) && $7ced446c48607a21$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($7ced446c48607a21$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($7ced446c48607a21$var$hasToStringTag) return $7ced446c48607a21$var$tryFunctionObject(value);
    if ($7ced446c48607a21$var$isES6ClassFn(value)) return false;
    var strClass = $7ced446c48607a21$var$toStr.call(value);
    if (strClass !== $7ced446c48607a21$var$fnClass && strClass !== $7ced446c48607a21$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $7ced446c48607a21$var$tryFunctionObject(value);
};

});


parcelRequire.register("falZY", function(module, exports) {
"use strict";
var $b0a8daa8a4e4a1a3$var$possibleNames = [
    "BigInt64Array",
    "BigUint64Array",
    "Float32Array",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Uint8Array",
    "Uint8ClampedArray"
];
var $b0a8daa8a4e4a1a3$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
module.exports = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < $b0a8daa8a4e4a1a3$var$possibleNames.length; i++)if (typeof $b0a8daa8a4e4a1a3$var$g[$b0a8daa8a4e4a1a3$var$possibleNames[i]] === "function") out[out.length] = $b0a8daa8a4e4a1a3$var$possibleNames[i];
    return out;
};

});

parcelRequire.register("lre78", function(module, exports) {
"use strict";

var $5KFGy = parcelRequire("5KFGy");
var $f9b71159b329fd73$var$$gOPD = $5KFGy("%Object.getOwnPropertyDescriptor%", true);
if ($f9b71159b329fd73$var$$gOPD) try {
    $f9b71159b329fd73$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $f9b71159b329fd73$var$$gOPD = null;
}
module.exports = $f9b71159b329fd73$var$$gOPD;

});


parcelRequire.register("duG8W", function(module, exports) {
"use strict";

var $fsbZZ = parcelRequire("fsbZZ");
module.exports = function isTypedArray(value) {
    return !!$fsbZZ(value);
};

});


parcelRequire.register("jIG8S", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});



parcelRequire.register("2OkWu", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $aqbQf = parcelRequire("aqbQf");
"use strict";
function $20c07f047b1729e1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $20c07f047b1729e1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $20c07f047b1729e1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $20c07f047b1729e1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $20c07f047b1729e1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $20c07f047b1729e1$var$_defineProperty(obj, key, value) {
    key = $20c07f047b1729e1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $20c07f047b1729e1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $20c07f047b1729e1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $20c07f047b1729e1$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $20c07f047b1729e1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $20c07f047b1729e1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $20c07f047b1729e1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $20c07f047b1729e1$var$_toPropertyKey(arg) {
    var key = $20c07f047b1729e1$var$_toPrimitive(arg, "string");
    return $20c07f047b1729e1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $20c07f047b1729e1$var$_toPrimitive(input, hint) {
    if ($20c07f047b1729e1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($20c07f047b1729e1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $20c07f047b1729e1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $20c07f047b1729e1$var$_setPrototypeOf(subClass, superClass);
}
function $20c07f047b1729e1$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $20c07f047b1729e1$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $20c07f047b1729e1$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $20c07f047b1729e1$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $20c07f047b1729e1$var$_possibleConstructorReturn(this, result);
    };
}
function $20c07f047b1729e1$var$_possibleConstructorReturn(self, call) {
    if (call && ($20c07f047b1729e1$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $20c07f047b1729e1$var$_assertThisInitialized(self);
}
function $20c07f047b1729e1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $20c07f047b1729e1$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $20c07f047b1729e1$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        var Wrapper = function Wrapper() {
            return $20c07f047b1729e1$var$_construct(Class, arguments, $20c07f047b1729e1$var$_getPrototypeOf(this).constructor);
        };
        if (Class === null || !$20c07f047b1729e1$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $20c07f047b1729e1$var$_setPrototypeOf(Wrapper, Class);
    };
    return $20c07f047b1729e1$var$_wrapNativeSuper(Class);
}
function $20c07f047b1729e1$var$_construct(Parent, args, Class) {
    if ($20c07f047b1729e1$var$_isNativeReflectConstruct()) $20c07f047b1729e1$var$_construct = Reflect.construct.bind();
    else $20c07f047b1729e1$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $20c07f047b1729e1$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $20c07f047b1729e1$var$_construct.apply(null, arguments);
}
function $20c07f047b1729e1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $20c07f047b1729e1$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $20c07f047b1729e1$var$_setPrototypeOf(o, p) {
    $20c07f047b1729e1$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $20c07f047b1729e1$var$_setPrototypeOf(o, p);
}
function $20c07f047b1729e1$var$_getPrototypeOf(o) {
    $20c07f047b1729e1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $20c07f047b1729e1$var$_getPrototypeOf(o);
}
function $20c07f047b1729e1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $20c07f047b1729e1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $20c07f047b1729e1$var$_typeof(o);
}

var $lQXBK = parcelRequire("lQXBK");
var $20c07f047b1729e1$var$inspect = $lQXBK.inspect;

var $j3n0m = parcelRequire("j3n0m");
var $20c07f047b1729e1$var$ERR_INVALID_ARG_TYPE = $j3n0m.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $20c07f047b1729e1$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $20c07f047b1729e1$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return "";
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $20c07f047b1729e1$var$blue = "";
var $20c07f047b1729e1$var$green = "";
var $20c07f047b1729e1$var$red = "";
var $20c07f047b1729e1$var$white = "";
var $20c07f047b1729e1$var$kReadableOperator = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $20c07f047b1729e1$var$kMaxShortLength = 10;
function $20c07f047b1729e1$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, "message", {
        value: source.message
    });
    return target;
}
function $20c07f047b1729e1$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $20c07f047b1729e1$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $20c07f047b1729e1$var$createErrDiff(actual, expected, operator) {
    var other = "";
    var res = "";
    var lastPos = 0;
    var end = "";
    var skipped = false;
    var actualInspected = $20c07f047b1729e1$var$inspectValue(actual);
    var actualLines = actualInspected.split("\n");
    var expectedLines = $20c07f047b1729e1$var$inspectValue(expected).split("\n");
    var i = 0;
    var indicator = "";
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === "strictEqual" && $20c07f047b1729e1$var$_typeof(actual) === "object" && $20c07f047b1729e1$var$_typeof(expected) === "object" && actual !== null && expected !== null) operator = "strictEqualObject";
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $20c07f047b1729e1$var$kMaxShortLength) {
            if (($20c07f047b1729e1$var$_typeof(actual) !== "object" || actual === null) && ($20c07f047b1729e1$var$_typeof(expected) !== "object" || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($20c07f047b1729e1$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== "strictEqualObject") {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $aqbQf.stderr && $aqbQf.stderr.isTTY ? $aqbQf.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($20c07f047b1729e1$var$repeat(" ", i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split("\n");
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($20c07f047b1729e1$var$blue, "...").concat($20c07f047b1729e1$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($20c07f047b1729e1$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join("\n"), "\n");
    }
    if (i > 3) {
        end = "\n".concat($20c07f047b1729e1$var$blue, "...").concat($20c07f047b1729e1$var$white).concat(end);
        skipped = true;
    }
    if (other !== "") {
        end = "\n  ".concat(other).concat(end);
        other = "";
    }
    var printedLines = 0;
    var msg = $20c07f047b1729e1$var$kReadableOperator[operator] + "\n".concat($20c07f047b1729e1$var$green, "+ actual").concat($20c07f047b1729e1$var$white, " ").concat($20c07f047b1729e1$var$red, "- expected").concat($20c07f047b1729e1$var$white);
    var skippedMsg = " ".concat($20c07f047b1729e1$var$blue, "...").concat($20c07f047b1729e1$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($20c07f047b1729e1$var$blue, "...").concat($20c07f047b1729e1$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($20c07f047b1729e1$var$red, "-").concat($20c07f047b1729e1$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($20c07f047b1729e1$var$blue, "...").concat($20c07f047b1729e1$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($20c07f047b1729e1$var$green, "+").concat($20c07f047b1729e1$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$20c07f047b1729e1$var$endsWith(actualLine, ",") || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $20c07f047b1729e1$var$endsWith(expectedLine, ",") && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ",";
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($20c07f047b1729e1$var$blue, "...").concat($20c07f047b1729e1$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($20c07f047b1729e1$var$green, "+").concat($20c07f047b1729e1$var$white, " ").concat(actualLine);
                other += "\n".concat($20c07f047b1729e1$var$red, "-").concat($20c07f047b1729e1$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = "";
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($20c07f047b1729e1$var$blue, "...").concat($20c07f047b1729e1$var$white).concat(other, "\n") + "".concat($20c07f047b1729e1$var$blue, "...").concat($20c07f047b1729e1$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : "", "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $20c07f047b1729e1$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $20c07f047b1729e1$var$_inherits(AssertionError, _Error);
    var _super = $20c07f047b1729e1$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $20c07f047b1729e1$var$_classCallCheck(this, AssertionError);
        if ($20c07f047b1729e1$var$_typeof(options) !== "object" || options === null) throw new $20c07f047b1729e1$var$ERR_INVALID_ARG_TYPE("options", "Object", options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($aqbQf.stderr && $aqbQf.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($aqbQf.stderr && $aqbQf.stderr.getColorDepth && $aqbQf.stderr.getColorDepth() !== 1) {
                    $20c07f047b1729e1$var$blue = "\x1b[34m";
                    $20c07f047b1729e1$var$green = "\x1b[32m";
                    $20c07f047b1729e1$var$white = "\x1b[39m";
                    $20c07f047b1729e1$var$red = "\x1b[31m";
                } else {
                    $20c07f047b1729e1$var$blue = "";
                    $20c07f047b1729e1$var$green = "";
                    $20c07f047b1729e1$var$white = "";
                    $20c07f047b1729e1$var$red = "";
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($20c07f047b1729e1$var$_typeof(actual) === "object" && actual !== null && $20c07f047b1729e1$var$_typeof(expected) === "object" && expected !== null && "stack" in actual && actual instanceof Error && "stack" in expected && expected instanceof Error) {
                actual = $20c07f047b1729e1$var$copyError(actual);
                expected = $20c07f047b1729e1$var$copyError(expected);
            }
            if (operator === "deepStrictEqual" || operator === "strictEqual") _this = _super.call(this, $20c07f047b1729e1$var$createErrDiff(actual, expected, operator));
            else if (operator === "notDeepStrictEqual" || operator === "notStrictEqual") {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $20c07f047b1729e1$var$kReadableOperator[operator];
                var res = $20c07f047b1729e1$var$inspectValue(actual).split("\n");
                // In case "actual" is an object, it should not be reference equal.
                if (operator === "notStrictEqual" && $20c07f047b1729e1$var$_typeof(actual) === "object" && actual !== null) base = $20c07f047b1729e1$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($20c07f047b1729e1$var$blue, "...").concat($20c07f047b1729e1$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join("\n"), "\n"));
            } else {
                var _res = $20c07f047b1729e1$var$inspectValue(actual);
                var other = "";
                var knownOperators = $20c07f047b1729e1$var$kReadableOperator[operator];
                if (operator === "notDeepEqual" || operator === "notEqual") {
                    _res = "".concat($20c07f047b1729e1$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($20c07f047b1729e1$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === "deepEqual" || operator === "equal") _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($20c07f047b1729e1$var$_assertThisInitialized(_this), "name", {
            value: "AssertionError [ERR_ASSERTION]",
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = "ERR_ASSERTION";
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($20c07f047b1729e1$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = "AssertionError";
        return $20c07f047b1729e1$var$_possibleConstructorReturn(_this);
    }
    $20c07f047b1729e1$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $20c07f047b1729e1$var$inspect(this, $20c07f047b1729e1$var$_objectSpread($20c07f047b1729e1$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $20c07f047b1729e1$var$_wrapNativeSuper(Error), $20c07f047b1729e1$var$inspect.custom);
module.exports = $20c07f047b1729e1$var$AssertionError;

});

parcelRequire.register("936qY", function(module, exports) {
"use strict";

var $8kIyy = parcelRequire("8kIyy");
var $6969628f1b0ff412$var$lacksProperEnumerationOrder = function lacksProperEnumerationOrder() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = "abcdefghijklmnopqrst";
    var letters = str.split("");
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = "";
    for(var k in obj)actual += k;
    return str !== actual;
};
var $6969628f1b0ff412$var$assignHasPendingExceptions = function assignHasPendingExceptions() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, "xy");
    } catch (e) {
        return thrower[1] === "y";
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $8kIyy;
    if ($6969628f1b0ff412$var$lacksProperEnumerationOrder()) return $8kIyy;
    if ($6969628f1b0ff412$var$assignHasPendingExceptions()) return $8kIyy;
    return Object.assign;
};

});
parcelRequire.register("8kIyy", function(module, exports) {
"use strict";

var $h8j4e = parcelRequire("h8j4e");

var $6112c0eb887a3cc4$var$hasSymbols = (parcelRequire("c2gQh"))();

var $a990d = parcelRequire("a990d");
var $6112c0eb887a3cc4$var$toObject = Object;
var $6112c0eb887a3cc4$var$$push = $a990d("Array.prototype.push");
var $6112c0eb887a3cc4$var$$propIsEnumerable = $a990d("Object.prototype.propertyIsEnumerable");
var $6112c0eb887a3cc4$var$originalGetSymbols = $6112c0eb887a3cc4$var$hasSymbols ? Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError("target must be an object");
    var to = $6112c0eb887a3cc4$var$toObject(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $6112c0eb887a3cc4$var$toObject(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $h8j4e(from);
        var getSymbols = $6112c0eb887a3cc4$var$hasSymbols && (Object.getOwnPropertySymbols || $6112c0eb887a3cc4$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($6112c0eb887a3cc4$var$$propIsEnumerable(from, key)) $6112c0eb887a3cc4$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($6112c0eb887a3cc4$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRequire.register("h8j4e", function(module, exports) {
"use strict";
var $c791f9679a992e5c$var$slice = Array.prototype.slice;

var $2Z5w1 = parcelRequire("2Z5w1");
var $c791f9679a992e5c$var$origKeys = Object.keys;

var $c791f9679a992e5c$var$keysShim = $c791f9679a992e5c$var$origKeys ? function keys(o) {
    return $c791f9679a992e5c$var$origKeys(o);
} : (parcelRequire("3zxP0"));
var $c791f9679a992e5c$var$originalKeys = Object.keys;
$c791f9679a992e5c$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($2Z5w1(object)) return $c791f9679a992e5c$var$originalKeys($c791f9679a992e5c$var$slice.call(object));
            return $c791f9679a992e5c$var$originalKeys(object);
        };
    } else Object.keys = $c791f9679a992e5c$var$keysShim;
    return Object.keys || $c791f9679a992e5c$var$keysShim;
};
module.exports = $c791f9679a992e5c$var$keysShim;

});
parcelRequire.register("2Z5w1", function(module, exports) {
"use strict";
var $22c58e8ec6c9864c$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $22c58e8ec6c9864c$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $22c58e8ec6c9864c$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRequire.register("3zxP0", function(module, exports) {
"use strict";
var $299ee041f06a3f7f$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $299ee041f06a3f7f$var$has = Object.prototype.hasOwnProperty;
    var $299ee041f06a3f7f$var$toStr = Object.prototype.toString;
    var $299ee041f06a3f7f$var$isArgs = (parcelRequire("2Z5w1")); // eslint-disable-line global-require
    var $299ee041f06a3f7f$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $299ee041f06a3f7f$var$hasDontEnumBug = !$299ee041f06a3f7f$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $299ee041f06a3f7f$var$hasProtoEnumBug = $299ee041f06a3f7f$var$isEnumerable.call(function() {}, "prototype");
    var $299ee041f06a3f7f$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $299ee041f06a3f7f$var$equalsConstructorPrototype = function equalsConstructorPrototype(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $299ee041f06a3f7f$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $299ee041f06a3f7f$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$299ee041f06a3f7f$var$excludedKeys["$" + k] && $299ee041f06a3f7f$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $299ee041f06a3f7f$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $299ee041f06a3f7f$var$equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
        /* global window */ if (typeof window === "undefined" || !$299ee041f06a3f7f$var$hasAutomationEqualityBug) return $299ee041f06a3f7f$var$equalsConstructorPrototype(o);
        try {
            return $299ee041f06a3f7f$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $299ee041f06a3f7f$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $299ee041f06a3f7f$var$toStr.call(object) === "[object Function]";
        var isArguments = $299ee041f06a3f7f$var$isArgs(object);
        var isString = isObject && $299ee041f06a3f7f$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $299ee041f06a3f7f$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$299ee041f06a3f7f$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $299ee041f06a3f7f$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($299ee041f06a3f7f$var$hasDontEnumBug) {
            var skipConstructor = $299ee041f06a3f7f$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $299ee041f06a3f7f$var$dontEnums.length; ++k)if (!(skipConstructor && $299ee041f06a3f7f$var$dontEnums[k] === "constructor") && $299ee041f06a3f7f$var$has.call(object, $299ee041f06a3f7f$var$dontEnums[k])) theKeys.push($299ee041f06a3f7f$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $299ee041f06a3f7f$var$keysShim;

});




parcelRequire.register("kayvN", function(module, exports) {
"use strict";

var $9K0on = parcelRequire("9K0on");
module.exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : $9K0on;
};

});
parcelRequire.register("9K0on", function(module, exports) {
"use strict";
var $7178b6ca45d53d5a$var$numberIsNaN = function numberIsNaN(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($7178b6ca45d53d5a$var$numberIsNaN(a) && $7178b6ca45d53d5a$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRequire.register("gwhuf", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";
function $c06d330824372a40$var$_slicedToArray(arr, i) {
    return $c06d330824372a40$var$_arrayWithHoles(arr) || $c06d330824372a40$var$_iterableToArrayLimit(arr, i) || $c06d330824372a40$var$_unsupportedIterableToArray(arr, i) || $c06d330824372a40$var$_nonIterableRest();
}
function $c06d330824372a40$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c06d330824372a40$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c06d330824372a40$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c06d330824372a40$var$_arrayLikeToArray(o, minLen);
}
function $c06d330824372a40$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c06d330824372a40$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c06d330824372a40$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c06d330824372a40$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c06d330824372a40$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c06d330824372a40$var$_typeof(o);
}
var $c06d330824372a40$var$regexFlagsSupported = /a/g.flags !== undefined;
var $c06d330824372a40$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $c06d330824372a40$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $c06d330824372a40$var$objectIs = Object.is ? Object.is : (parcelRequire("bh7uw"));
var $c06d330824372a40$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function objectGetOwnPropertySymbols() {
    return [];
};

var $c06d330824372a40$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("e11h5"));
function $c06d330824372a40$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $c06d330824372a40$var$hasOwnProperty = $c06d330824372a40$var$uncurryThis(Object.prototype.hasOwnProperty);
var $c06d330824372a40$var$propertyIsEnumerable = $c06d330824372a40$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $c06d330824372a40$var$objectToString = $c06d330824372a40$var$uncurryThis(Object.prototype.toString);

var $lQXBK = parcelRequire("lQXBK");
var $c06d330824372a40$require$_require$types = $lQXBK.types;
var $c06d330824372a40$var$isAnyArrayBuffer = $c06d330824372a40$require$_require$types.isAnyArrayBuffer, $c06d330824372a40$var$isArrayBufferView = $c06d330824372a40$require$_require$types.isArrayBufferView, $c06d330824372a40$var$isDate = $c06d330824372a40$require$_require$types.isDate, $c06d330824372a40$var$isMap = $c06d330824372a40$require$_require$types.isMap, $c06d330824372a40$var$isRegExp = $c06d330824372a40$require$_require$types.isRegExp, $c06d330824372a40$var$isSet = $c06d330824372a40$require$_require$types.isSet, $c06d330824372a40$var$isNativeError = $c06d330824372a40$require$_require$types.isNativeError, $c06d330824372a40$var$isBoxedPrimitive = $c06d330824372a40$require$_require$types.isBoxedPrimitive, $c06d330824372a40$var$isNumberObject = $c06d330824372a40$require$_require$types.isNumberObject, $c06d330824372a40$var$isStringObject = $c06d330824372a40$require$_require$types.isStringObject, $c06d330824372a40$var$isBooleanObject = $c06d330824372a40$require$_require$types.isBooleanObject, $c06d330824372a40$var$isBigIntObject = $c06d330824372a40$require$_require$types.isBigIntObject, $c06d330824372a40$var$isSymbolObject = $c06d330824372a40$require$_require$types.isSymbolObject, $c06d330824372a40$var$isFloat32Array = $c06d330824372a40$require$_require$types.isFloat32Array, $c06d330824372a40$var$isFloat64Array = $c06d330824372a40$require$_require$types.isFloat64Array;
function $c06d330824372a40$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $c06d330824372a40$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($c06d330824372a40$var$isNonIndex).concat($c06d330824372a40$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $c06d330824372a40$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $c06d330824372a40$var$ONLY_ENUMERABLE = undefined;
var $c06d330824372a40$var$kStrict = true;
var $c06d330824372a40$var$kLoose = false;
var $c06d330824372a40$var$kNoIterator = 0;
var $c06d330824372a40$var$kIsArray = 1;
var $c06d330824372a40$var$kIsSet = 2;
var $c06d330824372a40$var$kIsMap = 3;
// Check if they have the same source and flags
function $c06d330824372a40$var$areSimilarRegExps(a, b) {
    return $c06d330824372a40$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $c06d330824372a40$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $c06d330824372a40$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $c06d330824372a40$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $c06d330824372a40$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $c06d330824372a40$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $c06d330824372a40$var$isEqualBoxedPrimitive(val1, val2) {
    if ($c06d330824372a40$var$isNumberObject(val1)) return $c06d330824372a40$var$isNumberObject(val2) && $c06d330824372a40$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($c06d330824372a40$var$isStringObject(val1)) return $c06d330824372a40$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($c06d330824372a40$var$isBooleanObject(val1)) return $c06d330824372a40$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($c06d330824372a40$var$isBigIntObject(val1)) return $c06d330824372a40$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $c06d330824372a40$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $c06d330824372a40$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $c06d330824372a40$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($c06d330824372a40$var$_typeof(val1) !== "object") return typeof val1 === "number" && $c06d330824372a40$var$numberIsNaN(val1) && $c06d330824372a40$var$numberIsNaN(val2);
        if ($c06d330824372a40$var$_typeof(val2) !== "object" || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $c06d330824372a40$var$_typeof(val1) !== "object") {
            if (val2 === null || $c06d330824372a40$var$_typeof(val2) !== "object") // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $c06d330824372a40$var$_typeof(val2) !== "object") return false;
    }
    var val1Tag = $c06d330824372a40$var$objectToString(val1);
    var val2Tag = $c06d330824372a40$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $c06d330824372a40$var$getOwnNonIndexProperties(val1, $c06d330824372a40$var$ONLY_ENUMERABLE);
        var keys2 = $c06d330824372a40$var$getOwnNonIndexProperties(val2, $c06d330824372a40$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $c06d330824372a40$var$keyCheck(val1, val2, strict, memos, $c06d330824372a40$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === "[object Object]") {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$c06d330824372a40$var$isMap(val1) && $c06d330824372a40$var$isMap(val2) || !$c06d330824372a40$var$isSet(val1) && $c06d330824372a40$var$isSet(val2)) return false;
    }
    if ($c06d330824372a40$var$isDate(val1)) {
        if (!$c06d330824372a40$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($c06d330824372a40$var$isRegExp(val1)) {
        if (!$c06d330824372a40$var$isRegExp(val2) || !$c06d330824372a40$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($c06d330824372a40$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($c06d330824372a40$var$isArrayBufferView(val1)) {
        if (!strict && ($c06d330824372a40$var$isFloat32Array(val1) || $c06d330824372a40$var$isFloat64Array(val1))) {
            if (!$c06d330824372a40$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$c06d330824372a40$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $c06d330824372a40$var$getOwnNonIndexProperties(val1, $c06d330824372a40$var$ONLY_ENUMERABLE);
        var _keys2 = $c06d330824372a40$var$getOwnNonIndexProperties(val2, $c06d330824372a40$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $c06d330824372a40$var$keyCheck(val1, val2, strict, memos, $c06d330824372a40$var$kNoIterator, _keys);
    } else if ($c06d330824372a40$var$isSet(val1)) {
        if (!$c06d330824372a40$var$isSet(val2) || val1.size !== val2.size) return false;
        return $c06d330824372a40$var$keyCheck(val1, val2, strict, memos, $c06d330824372a40$var$kIsSet);
    } else if ($c06d330824372a40$var$isMap(val1)) {
        if (!$c06d330824372a40$var$isMap(val2) || val1.size !== val2.size) return false;
        return $c06d330824372a40$var$keyCheck(val1, val2, strict, memos, $c06d330824372a40$var$kIsMap);
    } else if ($c06d330824372a40$var$isAnyArrayBuffer(val1)) {
        if (!$c06d330824372a40$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($c06d330824372a40$var$isBoxedPrimitive(val1) && !$c06d330824372a40$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $c06d330824372a40$var$keyCheck(val1, val2, strict, memos, $c06d330824372a40$var$kNoIterator);
}
function $c06d330824372a40$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $c06d330824372a40$var$propertyIsEnumerable(val, k);
    });
}
function $c06d330824372a40$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$c06d330824372a40$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $c06d330824372a40$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($c06d330824372a40$var$propertyIsEnumerable(val1, key)) {
                    if (!$c06d330824372a40$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($c06d330824372a40$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $c06d330824372a40$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $c06d330824372a40$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $c06d330824372a40$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $c06d330824372a40$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $c06d330824372a40$var$kNoIterator || iterationType === $c06d330824372a40$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $c06d330824372a40$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $c06d330824372a40$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $c06d330824372a40$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($c06d330824372a40$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $c06d330824372a40$var$findLooseMatchingPrimitives(prim) {
    switch($c06d330824372a40$var$_typeof(prim)){
        case "undefined":
            return null;
        case "object":
            // Only pass in null as object!
            return undefined;
        case "symbol":
            return false;
        case "string":
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case "number":
            if ($c06d330824372a40$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $c06d330824372a40$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $c06d330824372a40$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $c06d330824372a40$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $c06d330824372a40$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$c06d330824372a40$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $c06d330824372a40$var$innerDeepEqual(item, curB, false, memo);
}
function $c06d330824372a40$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $c06d330824372a40$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($c06d330824372a40$var$_typeof(val) === "object" && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$c06d330824372a40$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $c06d330824372a40$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($c06d330824372a40$var$_typeof(_val) === "object" && _val !== null) {
                if (!$c06d330824372a40$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$c06d330824372a40$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $c06d330824372a40$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $c06d330824372a40$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($c06d330824372a40$var$innerDeepEqual(key1, key2, strict, memo) && $c06d330824372a40$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $c06d330824372a40$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $c06d330824372a40$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $c06d330824372a40$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($c06d330824372a40$var$_typeof(key) === "object" && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$c06d330824372a40$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$c06d330824372a40$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $c06d330824372a40$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $c06d330824372a40$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($c06d330824372a40$var$_typeof(_key) === "object" && _key !== null) {
                if (!$c06d330824372a40$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$c06d330824372a40$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$c06d330824372a40$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $c06d330824372a40$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $c06d330824372a40$var$kIsSet) {
        if (!$c06d330824372a40$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $c06d330824372a40$var$kIsMap) {
        if (!$c06d330824372a40$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $c06d330824372a40$var$kIsArray) for(; i < a.length; i++){
        if ($c06d330824372a40$var$hasOwnProperty(a, i)) {
            if (!$c06d330824372a40$var$hasOwnProperty(b, i) || !$c06d330824372a40$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($c06d330824372a40$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$c06d330824372a40$var$hasOwnProperty(b, key) || !$c06d330824372a40$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$c06d330824372a40$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $c06d330824372a40$var$isDeepEqual(val1, val2) {
    return $c06d330824372a40$var$innerDeepEqual(val1, val2, $c06d330824372a40$var$kLoose);
}
function $c06d330824372a40$var$isDeepStrictEqual(val1, val2) {
    return $c06d330824372a40$var$innerDeepEqual(val1, val2, $c06d330824372a40$var$kStrict);
}
module.exports = {
    isDeepEqual: $c06d330824372a40$var$isDeepEqual,
    isDeepStrictEqual: $c06d330824372a40$var$isDeepStrictEqual
};

});
parcelRequire.register("bh7uw", function(module, exports) {
"use strict";

var $g6Lkv = parcelRequire("g6Lkv");

var $4bBQu = parcelRequire("4bBQu");

var $9K0on = parcelRequire("9K0on");

var $kayvN = parcelRequire("kayvN");

var $gMpxg = parcelRequire("gMpxg");
var $835717d68bca1972$var$polyfill = $4bBQu($kayvN(), Object);
$g6Lkv($835717d68bca1972$var$polyfill, {
    getPolyfill: $kayvN,
    implementation: $9K0on,
    shim: $gMpxg
});
module.exports = $835717d68bca1972$var$polyfill;

});
parcelRequire.register("g6Lkv", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
"use strict";

var $h8j4e = parcelRequire("h8j4e");
var $bba1eb99e9d8db09$var$hasSymbols = typeof Symbol === "function" && (0, $1ObTH._)(Symbol("foo")) === "symbol";
var $bba1eb99e9d8db09$var$toStr = Object.prototype.toString;
var $bba1eb99e9d8db09$var$concat = Array.prototype.concat;

var $jTQbZ = parcelRequire("jTQbZ");
var $bba1eb99e9d8db09$var$isFunction = function isFunction(fn) {
    return typeof fn === "function" && $bba1eb99e9d8db09$var$toStr.call(fn) === "[object Function]";
};

var $bba1eb99e9d8db09$var$supportsDescriptors = (parcelRequire("jvnto"))();
var $bba1eb99e9d8db09$var$defineProperty = function defineProperty(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$bba1eb99e9d8db09$var$isFunction(predicate) || !predicate()) return;
    }
    if ($bba1eb99e9d8db09$var$supportsDescriptors) $jTQbZ(object, name, value, true);
    else $jTQbZ(object, name, value);
};
var $bba1eb99e9d8db09$var$defineProperties = function defineProperties(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $h8j4e(map);
    if ($bba1eb99e9d8db09$var$hasSymbols) props = $bba1eb99e9d8db09$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$bba1eb99e9d8db09$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$bba1eb99e9d8db09$var$defineProperties.supportsDescriptors = !!$bba1eb99e9d8db09$var$supportsDescriptors;
module.exports = $bba1eb99e9d8db09$var$defineProperties;

});
parcelRequire.register("jTQbZ", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
"use strict";

var $e7cba3b2c896467f$var$hasPropertyDescriptors = (parcelRequire("jvnto"))();

var $5KFGy = parcelRequire("5KFGy");
var $e7cba3b2c896467f$var$$defineProperty = $e7cba3b2c896467f$var$hasPropertyDescriptors && $5KFGy("%Object.defineProperty%", true);
var $e7cba3b2c896467f$var$$SyntaxError = $5KFGy("%SyntaxError%");
var $e7cba3b2c896467f$var$$TypeError = $5KFGy("%TypeError%");

var $lre78 = parcelRequire("lre78");
/** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $e7cba3b2c896467f$var$$TypeError("`obj` must be an object or a function`");
    if (typeof property !== "string" && (typeof property === "undefined" ? "undefined" : (0, $1ObTH._)(property)) !== "symbol") throw new $e7cba3b2c896467f$var$$TypeError("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $e7cba3b2c896467f$var$$TypeError("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $e7cba3b2c896467f$var$$TypeError("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $e7cba3b2c896467f$var$$TypeError("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $e7cba3b2c896467f$var$$TypeError("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$lre78 && $lre78(obj, property);
    if ($e7cba3b2c896467f$var$$defineProperty) $e7cba3b2c896467f$var$$defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $e7cba3b2c896467f$var$$SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRequire.register("jvnto", function(module, exports) {
"use strict";

var $5KFGy = parcelRequire("5KFGy");
var $e3331ed231f0d5e2$var$$defineProperty = $5KFGy("%Object.defineProperty%", true);
var $e3331ed231f0d5e2$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($e3331ed231f0d5e2$var$$defineProperty) try {
        $e3331ed231f0d5e2$var$$defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
$e3331ed231f0d5e2$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$e3331ed231f0d5e2$var$hasPropertyDescriptors()) return null;
    try {
        return $e3331ed231f0d5e2$var$$defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $e3331ed231f0d5e2$var$hasPropertyDescriptors;

});



parcelRequire.register("gMpxg", function(module, exports) {
"use strict";

var $kayvN = parcelRequire("kayvN");

var $g6Lkv = parcelRequire("g6Lkv");
module.exports = function shimObjectIs() {
    var polyfill = $kayvN();
    $g6Lkv(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRequire.register("e11h5", function(module, exports) {
"use strict";

var $4bBQu = parcelRequire("4bBQu");

var $g6Lkv = parcelRequire("g6Lkv");

var $16rov = parcelRequire("16rov");

var $ik0mf = parcelRequire("ik0mf");

var $6GSWd = parcelRequire("6GSWd");
var $a34225cd107f453c$var$polyfill = $4bBQu($ik0mf(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $g6Lkv($a34225cd107f453c$var$polyfill, {
    getPolyfill: $ik0mf,
    implementation: $16rov,
    shim: $6GSWd
});
module.exports = $a34225cd107f453c$var$polyfill;

});
parcelRequire.register("16rov", function(module, exports) {
"use strict";
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRequire.register("ik0mf", function(module, exports) {
"use strict";

var $16rov = parcelRequire("16rov");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) return Number.isNaN;
    return $16rov;
};

});

parcelRequire.register("6GSWd", function(module, exports) {
"use strict";

var $g6Lkv = parcelRequire("g6Lkv");

var $ik0mf = parcelRequire("ik0mf");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $ik0mf();
    $g6Lkv(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});






parcelRequire.register("ldLos", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FuelPricesContractConnector = void 0;

var $hlNxg = parcelRequire("hlNxg");

var $hjAGN = parcelRequire("hjAGN");

var $2TLZk = parcelRequire("2TLZk");
var $f72f933c154d67de$var$FuelPricesContractConnector = /*#__PURE__*/ function(_FuelContractConnector_1_FuelContractConnector) {
    (0, $ftJVG._)(FuelPricesContractConnector, _FuelContractConnector_1_FuelContractConnector);
    var _super = (0, $6OZAO._)(FuelPricesContractConnector);
    function FuelPricesContractConnector(wallet, contractId) {
        (0, $978gY._)(this, FuelPricesContractConnector);
        var _this;
        _this = _super.call(this, wallet);
        _this.contractId = contractId;
        return _this;
    }
    (0, $kry2a._)(FuelPricesContractConnector, [
        {
            key: "getContract",
            value: function getContract() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            $hlNxg.PricesAbi__factory.connect(_this.contractId, _this.wallet)
                        ];
                    });
                })();
            }
        },
        {
            key: "getAdapter",
            value: function getAdapter() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _, _1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _1 = (_ = $2TLZk.FuelPricesContractAdapter).bind;
                                return [
                                    4,
                                    _this.getContract()
                                ];
                            case 1:
                                return [
                                    2,
                                    new (_1.apply(_, [
                                        void 0,
                                        _state.sent(),
                                        _this.getGasLimit()
                                    ]))
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return FuelPricesContractConnector;
}($hjAGN.FuelContractConnector);
module.exports.FuelPricesContractConnector = $f72f933c154d67de$var$FuelPricesContractConnector;

});
parcelRequire.register("hlNxg", function(module, exports) {
"use strict";
/* Autogenerated file. Do not edit manually. */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PricesAbi__factory = void 0;

var $3iphI = parcelRequire("3iphI");
Object.defineProperty(module.exports, "PricesAbi__factory", {
    enumerable: true,
    get: function get() {
        return $3iphI.PricesAbi__factory;
    }
});

});
parcelRequire.register("3iphI", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");
"use strict";
/* Autogenerated file. Do not edit manually. */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PricesAbi__factory = void 0;
parcelRequire("kmZ00");
var $2cJiB = parcelRequire("2cJiB");
var $5u9Jw = parcelRequire("5u9Jw");
var $2666aa8ba5f81850$var$_abi = {
    "types": [
        {
            "typeId": 0,
            "type": "()",
            "components": [],
            "typeParameters": null
        },
        {
            "typeId": 1,
            "type": "[_; 50]",
            "components": [
                {
                    "name": "__array_element",
                    "type": 6,
                    "typeArguments": null
                }
            ],
            "typeParameters": null
        },
        {
            "typeId": 2,
            "type": "b256",
            "components": null,
            "typeParameters": null
        },
        {
            "typeId": 3,
            "type": "generic T",
            "components": null,
            "typeParameters": null
        },
        {
            "typeId": 4,
            "type": "raw untyped ptr",
            "components": null,
            "typeParameters": null
        },
        {
            "typeId": 5,
            "type": "struct RawVec",
            "components": [
                {
                    "name": "ptr",
                    "type": 4,
                    "typeArguments": null
                },
                {
                    "name": "cap",
                    "type": 8,
                    "typeArguments": null
                }
            ],
            "typeParameters": [
                3
            ]
        },
        {
            "typeId": 6,
            "type": "struct U256",
            "components": [
                {
                    "name": "a",
                    "type": 8,
                    "typeArguments": null
                },
                {
                    "name": "b",
                    "type": 8,
                    "typeArguments": null
                },
                {
                    "name": "c",
                    "type": 8,
                    "typeArguments": null
                },
                {
                    "name": "d",
                    "type": 8,
                    "typeArguments": null
                }
            ],
            "typeParameters": null
        },
        {
            "typeId": 7,
            "type": "struct Vec",
            "components": [
                {
                    "name": "buf",
                    "type": 5,
                    "typeArguments": [
                        {
                            "name": "",
                            "type": 3,
                            "typeArguments": null
                        }
                    ]
                },
                {
                    "name": "len",
                    "type": 8,
                    "typeArguments": null
                }
            ],
            "typeParameters": [
                3
            ]
        },
        {
            "typeId": 8,
            "type": "u64",
            "components": null,
            "typeParameters": null
        }
    ],
    "functions": [
        {
            "inputs": [
                {
                    "name": "feed_ids",
                    "type": 7,
                    "typeArguments": [
                        {
                            "name": "",
                            "type": 6,
                            "typeArguments": null
                        }
                    ]
                },
                {
                    "name": "payload",
                    "type": 7,
                    "typeArguments": [
                        {
                            "name": "",
                            "type": 8,
                            "typeArguments": null
                        }
                    ]
                }
            ],
            "name": "get_prices",
            "output": {
                "name": "",
                "type": 1,
                "typeArguments": null
            },
            "attributes": [
                {
                    "name": "storage",
                    "arguments": [
                        "read"
                    ]
                }
            ]
        },
        {
            "inputs": [
                {
                    "name": "signers",
                    "type": 7,
                    "typeArguments": [
                        {
                            "name": "",
                            "type": 2,
                            "typeArguments": null
                        }
                    ]
                },
                {
                    "name": "signer_count_threshold",
                    "type": 8,
                    "typeArguments": null
                },
                {
                    "name": "skip_setting_owner",
                    "type": 8,
                    "typeArguments": null
                }
            ],
            "name": "init",
            "output": {
                "name": "",
                "type": 0,
                "typeArguments": null
            },
            "attributes": [
                {
                    "name": "storage",
                    "arguments": [
                        "read",
                        "write"
                    ]
                }
            ]
        },
        {
            "inputs": [
                {
                    "name": "feed_ids",
                    "type": 7,
                    "typeArguments": [
                        {
                            "name": "",
                            "type": 6,
                            "typeArguments": null
                        }
                    ]
                }
            ],
            "name": "read_prices",
            "output": {
                "name": "",
                "type": 1,
                "typeArguments": null
            },
            "attributes": [
                {
                    "name": "storage",
                    "arguments": [
                        "read"
                    ]
                }
            ]
        },
        {
            "inputs": [],
            "name": "read_timestamp",
            "output": {
                "name": "",
                "type": 8,
                "typeArguments": null
            },
            "attributes": [
                {
                    "name": "storage",
                    "arguments": [
                        "read"
                    ]
                }
            ]
        },
        {
            "inputs": [
                {
                    "name": "feed_ids",
                    "type": 7,
                    "typeArguments": [
                        {
                            "name": "",
                            "type": 6,
                            "typeArguments": null
                        }
                    ]
                },
                {
                    "name": "payload",
                    "type": 7,
                    "typeArguments": [
                        {
                            "name": "",
                            "type": 8,
                            "typeArguments": null
                        }
                    ]
                }
            ],
            "name": "write_prices",
            "output": {
                "name": "",
                "type": 1,
                "typeArguments": null
            },
            "attributes": [
                {
                    "name": "storage",
                    "arguments": [
                        "read",
                        "write"
                    ]
                }
            ]
        }
    ],
    "loggedTypes": [
        {
            "logId": 0,
            "loggedType": {
                "name": "",
                "type": 8,
                "typeArguments": null
            }
        },
        {
            "logId": 1,
            "loggedType": {
                "name": "",
                "type": 8,
                "typeArguments": null
            }
        },
        {
            "logId": 2,
            "loggedType": {
                "name": "",
                "type": 8,
                "typeArguments": null
            }
        },
        {
            "logId": 3,
            "loggedType": {
                "name": "",
                "type": 8,
                "typeArguments": null
            }
        },
        {
            "logId": 4,
            "loggedType": {
                "name": "",
                "type": 2,
                "typeArguments": null
            }
        },
        {
            "logId": 5,
            "loggedType": {
                "name": "",
                "type": 8,
                "typeArguments": null
            }
        },
        {
            "logId": 6,
            "loggedType": {
                "name": "",
                "type": 2,
                "typeArguments": null
            }
        },
        {
            "logId": 7,
            "loggedType": {
                "name": "",
                "type": 8,
                "typeArguments": null
            }
        },
        {
            "logId": 8,
            "loggedType": {
                "name": "",
                "type": 8,
                "typeArguments": null
            }
        },
        {
            "logId": 9,
            "loggedType": {
                "name": "",
                "type": 8,
                "typeArguments": null
            }
        },
        {
            "logId": 10,
            "loggedType": {
                "name": "",
                "type": 8,
                "typeArguments": null
            }
        },
        {
            "logId": 11,
            "loggedType": {
                "name": "",
                "type": 2,
                "typeArguments": null
            }
        },
        {
            "logId": 12,
            "loggedType": {
                "name": "",
                "type": 8,
                "typeArguments": null
            }
        }
    ],
    "messagesTypes": [],
    "configurables": []
};
var $2666aa8ba5f81850$var$PricesAbi__factory = /*#__PURE__*/ function() {
    function PricesAbi__factory() {
        (0, $978gY._)(this, PricesAbi__factory);
    }
    (0, $kry2a._)(PricesAbi__factory, null, [
        {
            key: "createInterface",
            value: function createInterface() {
                return new $2cJiB.Interface($2666aa8ba5f81850$var$_abi);
            }
        },
        {
            key: "connect",
            value: function connect(id, accountOrProvider) {
                return new $5u9Jw.Contract(id, $2666aa8ba5f81850$var$_abi, accountOrProvider);
            }
        }
    ]);
    return PricesAbi__factory;
}();
module.exports.PricesAbi__factory = $2666aa8ba5f81850$var$PricesAbi__factory;
$2666aa8ba5f81850$var$PricesAbi__factory.abi = $2666aa8ba5f81850$var$_abi;

});
parcelRequire.register("kmZ00", function(module, exports) {
$parcel$export(module.exports, "hexlify", function () { return (parcelRequire("j2rU8")).hexlify; });
$parcel$export(module.exports, "hexZeroPad", function () { return (parcelRequire("j2rU8")).hexZeroPad; });
$parcel$export(module.exports, "Interface", function () { return (parcelRequire("2cJiB")).Interface; });
$parcel$export(module.exports, "ContractFactory", function () { return (parcelRequire("9vmss")).ContractFactory; });
$parcel$export(module.exports, "BN", function () { return (parcelRequire("4x96T")).BN; });
$parcel$export(module.exports, "Contract", function () { return (parcelRequire("5u9Jw")).Contract; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("aMiMS")).Provider; });
$parcel$export(module.exports, "Wallet", function () { return (parcelRequire("7XMRS")).Wallet; });
parcelRequire("j2rU8");
parcelRequire("2cJiB");
parcelRequire("1nhBg");
parcelRequire("9vmss");
parcelRequire("g3UKu");
parcelRequire("5f5W0");
parcelRequire("dktpY");
parcelRequire("2URXt");
parcelRequire("4x96T");
parcelRequire("8WFjQ");
parcelRequire("5u9Jw");
parcelRequire("aMiMS");
parcelRequire("1JpXs");
parcelRequire("lcJUd");
parcelRequire("7XMRS");

var $hjyqB = parcelRequire("hjyqB");
parcelRequire("9aGYB");
parcelRequire("autKP");
parcelRequire("bNbBi");
parcelRequire("90LKV");
parcelRequire("jt0st");

});
parcelRequire.register("2cJiB", function(module, exports) {

$parcel$export(module.exports, "Coder", function () { return $99596fd457f2b6db$export$2c0c39526f8bad46; });
$parcel$export(module.exports, "ArrayCoder", function () { return $99596fd457f2b6db$export$88bc419d2df11f54; });
$parcel$export(module.exports, "B256Coder", function () { return $99596fd457f2b6db$export$77ea01d3b03a250c; });
$parcel$export(module.exports, "U64Coder", function () { return $99596fd457f2b6db$export$53960a2ba5cf2c18; });
$parcel$export(module.exports, "NumberCoder", function () { return $99596fd457f2b6db$export$b934dc8cfe13938c; });
$parcel$export(module.exports, "StructCoder", function () { return $99596fd457f2b6db$export$bbe9816ecfd07067; });
$parcel$export(module.exports, "WORD_SIZE", function () { return $99596fd457f2b6db$export$824fe97aa0577f7b; });
$parcel$export(module.exports, "ASSET_ID_LEN", function () { return $99596fd457f2b6db$export$d25c7a55c38444e8; });
$parcel$export(module.exports, "CONTRACT_ID_LEN", function () { return $99596fd457f2b6db$export$daa422f9744b2480; });
$parcel$export(module.exports, "VM_TX_MEMORY", function () { return $99596fd457f2b6db$export$90b3ac72f57de0c1; });
$parcel$export(module.exports, "TRANSACTION_SCRIPT_FIXED_SIZE", function () { return $99596fd457f2b6db$export$608025854858e845; });
$parcel$export(module.exports, "AbiCoder", function () { return $99596fd457f2b6db$export$fe041e1a83d3efc6; });
$parcel$export(module.exports, "Interface", function () { return $99596fd457f2b6db$export$48cefb51a4e315b2; });

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $ho5gk = parcelRequire("ho5gk");

var $8GFUW = parcelRequire("8GFUW");

var $jKer9 = parcelRequire("jKer9");

var $1ObTH = parcelRequire("1ObTH");

var $6OZAO = parcelRequire("6OZAO");

var $6M65e = parcelRequire("6M65e");

var $4jkfR = parcelRequire("4jkfR");

var $j2rU8 = parcelRequire("j2rU8");

var $4x96T = parcelRequire("4x96T");

var $1Wmc7 = parcelRequire("1Wmc7");

var $7WUQV = parcelRequire("7WUQV");

var $2URXt = parcelRequire("2URXt");

var $2ax4w = parcelRequire("2ax4w");
var $99596fd457f2b6db$var$Fe = Object.defineProperty;
var $99596fd457f2b6db$var$Oe = function(o, e, r) {
    return e in o ? $99596fd457f2b6db$var$Fe(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : o[e] = r;
};
var $99596fd457f2b6db$var$$ = function(o, e, r) {
    return $99596fd457f2b6db$var$Oe(o, (typeof e === "undefined" ? "undefined" : (0, $1ObTH._)(e)) != "symbol" ? e + "" : e, r), r;
}, $99596fd457f2b6db$var$G = function(o, e, r) {
    if (!e.has(o)) throw TypeError("Cannot " + r);
};
var $99596fd457f2b6db$var$T = function(o, e, r) {
    return $99596fd457f2b6db$var$G(o, e, "read from private field"), r ? r.call(o) : e.get(o);
}, $99596fd457f2b6db$var$E = function(o, e, r) {
    if (e.has(o)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(o) : e.set(o, r);
}, $99596fd457f2b6db$var$N = function(o, e, r, t) {
    return $99596fd457f2b6db$var$G(o, e, "write to private field"), t ? t.call(o, r) : e.set(o, r), r;
};
var $99596fd457f2b6db$var$Q = function(o, e, r) {
    return $99596fd457f2b6db$var$G(o, e, "access private method"), r;
};
var $99596fd457f2b6db$var$Ie = new (0, $6M65e.Logger)((0, $4jkfR.versions).FUELS), $99596fd457f2b6db$export$2c0c39526f8bad46 = /*#__PURE__*/ function() {
    "use strict";
    function d(e, r, t) {
        (0, $978gY._)(this, d);
        (0, $dxWQo._)(this, "name", void 0);
        (0, $dxWQo._)(this, "type", void 0);
        (0, $dxWQo._)(this, "encodedLength", void 0);
        (0, $dxWQo._)(this, "offset", void 0);
        this.name = e, this.type = r, this.encodedLength = t;
    }
    (0, $kry2a._)(d, [
        {
            key: "throwError",
            value: function throwError(e, r) {
                throw $99596fd457f2b6db$var$Ie.throwArgumentError(e, this.name, r), new Error("unreachable");
            }
        },
        {
            key: "setOffset",
            value: function setOffset(e) {
                this.offset = e;
            }
        }
    ]);
    return d;
}();
var $99596fd457f2b6db$export$88bc419d2df11f54 = /*#__PURE__*/ function(d) {
    "use strict";
    (0, $ftJVG._)(w, d);
    var _super = (0, $6OZAO._)(w);
    function w(e, r) {
        (0, $978gY._)(this, w);
        var _this;
        var _temp;
        _temp = _this = _super.call(this, "array", "[".concat(e.type, "; ").concat(r, "]"), r * e.encodedLength), (0, $dxWQo._)((0, $3vWwE._)(_this), "coder", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "length", void 0), _temp, _this.coder = e, _this.length = r;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(w, [
        {
            key: "encode",
            value: function encode(e) {
                var _this = this;
                return Array.isArray(e) || this.throwError("expected array value", e), this.length !== e.length && this.throwError("Types/values length mismatch", e), (0, $j2rU8.concat)(Array.from(e).map(function(r) {
                    return _this.coder.encode(r);
                }));
            }
        },
        {
            key: "decode",
            value: function decode(e, r) {
                var _this = this;
                var t = r;
                return [
                    Array(this.length).fill(0).map(function() {
                        var s;
                        var ref;
                        return ref = (0, $8GFUW._)(_this.coder.decode(e, t), 2), s = ref[0], t = ref[1], ref, s;
                    }),
                    t
                ];
            }
        }
    ]);
    return w;
}($99596fd457f2b6db$export$2c0c39526f8bad46);
var $99596fd457f2b6db$export$77ea01d3b03a250c = /*#__PURE__*/ function(d) {
    "use strict";
    (0, $ftJVG._)(P, d);
    var _super = (0, $6OZAO._)(P);
    function P() {
        (0, $978gY._)(this, P);
        return _super.call(this, "b256", "b256", 32);
    }
    (0, $kry2a._)(P, [
        {
            key: "encode",
            value: function encode(e) {
                var r;
                try {
                    r = (0, $j2rU8.arrayify)(e);
                } catch (e1) {
                    this.throwError("Invalid ".concat(this.type), e);
                }
                return r.length !== 32 && this.throwError("Invalid ".concat(this.type), e), r;
            }
        },
        {
            key: "decode",
            value: function decode(e, r) {
                var t = e.slice(r, r + 32);
                return (0, $4x96T.bn)(t).isZero() && (t = new Uint8Array(32)), t.length !== 32 && this.throwError("Invalid size for b256", t), [
                    (0, $4x96T.toHex)(t, 32),
                    r + 32
                ];
            }
        }
    ]);
    return P;
}($99596fd457f2b6db$export$2c0c39526f8bad46);
var $99596fd457f2b6db$export$91df7292016ad4c5 = /*#__PURE__*/ function(d) {
    "use strict";
    (0, $ftJVG._)(J, d);
    var _super = (0, $6OZAO._)(J);
    function J() {
        (0, $978gY._)(this, J);
        return _super.call(this, "b512", "struct B512", 64);
    }
    (0, $kry2a._)(J, [
        {
            key: "encode",
            value: function encode(e) {
                var r;
                try {
                    r = (0, $j2rU8.arrayify)(e);
                } catch (e1) {
                    this.throwError("Invalid ".concat(this.type), e);
                }
                return r.length !== 64 && this.throwError("Invalid ".concat(this.type), e), r;
            }
        },
        {
            key: "decode",
            value: function decode(e, r) {
                var t = e.slice(r, r + 64);
                return (0, $4x96T.bn)(t).isZero() && (t = new Uint8Array(64)), t.length !== 64 && this.throwError("Invalid size for b512", t), [
                    (0, $4x96T.toHex)(t, 64),
                    r + 64
                ];
            }
        }
    ]);
    return J;
}($99596fd457f2b6db$export$2c0c39526f8bad46);
var $99596fd457f2b6db$export$fe9118d6c093150c = /*#__PURE__*/ function(d) {
    "use strict";
    (0, $ftJVG._)(D, d);
    var _super = (0, $6OZAO._)(D);
    function D() {
        (0, $978gY._)(this, D);
        return _super.call(this, "boolean", "boolean", 8);
    }
    (0, $kry2a._)(D, [
        {
            key: "encode",
            value: function encode(e) {
                var r;
                try {
                    r = (0, $4x96T.toBytes)(e ? 1 : 0);
                } catch (e1) {
                    this.throwError("Invalid bool", e);
                }
                return r.length > 1 && this.throwError("Invalid bool", e), (0, $4x96T.toBytes)(r, 8);
            }
        },
        {
            key: "decode",
            value: function decode(e, r) {
                var t = (0, $4x96T.bn)(e.slice(r, r + 8));
                return t.isZero() ? [
                    !1,
                    r + 8
                ] : (t.eq((0, $4x96T.bn)(1)) || this.throwError("Invalid boolean value", t), [
                    !0,
                    r + 8
                ]);
            }
        }
    ]);
    return D;
}($99596fd457f2b6db$export$2c0c39526f8bad46);
var $99596fd457f2b6db$export$898870db6be4d918 = /*#__PURE__*/ function(d) {
    "use strict";
    (0, $ftJVG._)(L, d);
    var _super = (0, $6OZAO._)(L);
    function L() {
        (0, $978gY._)(this, L);
        return _super.call(this, "byte", "byte", 8);
    }
    (0, $kry2a._)(L, [
        {
            key: "encode",
            value: function encode(e) {
                var r;
                try {
                    r = (0, $4x96T.toBytes)(e, 1);
                } catch (e1) {
                    this.throwError("Invalid Byte", e);
                }
                return (0, $4x96T.toBytes)(r, 8);
            }
        },
        {
            key: "decode",
            value: function decode(e, r) {
                var t = e.slice(r, r + 8), n = (0, $4x96T.bn)(t);
                return n.gt((0, $4x96T.bn)(255)) && this.throwError("Invalid Byte", n), [
                    Number(n),
                    r + 8
                ];
            }
        }
    ]);
    return L;
}($99596fd457f2b6db$export$2c0c39526f8bad46);
var $99596fd457f2b6db$export$53960a2ba5cf2c18 = /*#__PURE__*/ function(d) {
    "use strict";
    (0, $ftJVG._)(l, d);
    var _super = (0, $6OZAO._)(l);
    function l() {
        (0, $978gY._)(this, l);
        return _super.call(this, "u64", "u64", 8);
    }
    (0, $kry2a._)(l, [
        {
            key: "encode",
            value: function encode(e) {
                var r;
                try {
                    r = (0, $4x96T.toBytes)(e, 8);
                } catch (e1) {
                    this.throwError("Invalid ".concat(this.type), e);
                }
                return r;
            }
        },
        {
            key: "decode",
            value: function decode(e, r) {
                var t = e.slice(r, r + 8);
                return t = t.slice(0, 8), [
                    (0, $4x96T.bn)(t),
                    r + 8
                ];
            }
        }
    ]);
    return l;
}($99596fd457f2b6db$export$2c0c39526f8bad46);
var $99596fd457f2b6db$var$_e = function(o) {
    return Object.values(o).every(function(param) {
        var e = param.type, r = param.coders;
        return e === "()" && JSON.stringify(r) === JSON.stringify([]);
    });
}, $99596fd457f2b6db$var$S, $99596fd457f2b6db$var$I, $99596fd457f2b6db$var$v, $99596fd457f2b6db$var$pe, $99596fd457f2b6db$var$Z, $99596fd457f2b6db$var$ue, $99596fd457f2b6db$export$36373497af15670 = /*#__PURE__*/ function(d) {
    "use strict";
    (0, $ftJVG._)(x, d);
    var _super = (0, $6OZAO._)(x);
    function x(r, t) {
        (0, $978gY._)(this, x);
        var _this;
        var n = new $99596fd457f2b6db$export$53960a2ba5cf2c18, s = Object.values(t).reduce(function(a, i) {
            return Math.max(a, i.encodedLength);
        }, 0);
        _this = _super.call(this, "enum", "enum ".concat(r), n.encodedLength + s);
        $99596fd457f2b6db$var$E((0, $3vWwE._)(_this), $99596fd457f2b6db$var$v);
        $99596fd457f2b6db$var$E((0, $3vWwE._)(_this), $99596fd457f2b6db$var$Z);
        $99596fd457f2b6db$var$$((0, $3vWwE._)(_this), "name");
        $99596fd457f2b6db$var$$((0, $3vWwE._)(_this), "coders");
        $99596fd457f2b6db$var$E((0, $3vWwE._)(_this), $99596fd457f2b6db$var$S, void 0);
        $99596fd457f2b6db$var$E((0, $3vWwE._)(_this), $99596fd457f2b6db$var$I, void 0);
        _this.name = r, _this.coders = t, $99596fd457f2b6db$var$N((0, $3vWwE._)(_this), $99596fd457f2b6db$var$S, n), $99596fd457f2b6db$var$N((0, $3vWwE._)(_this), $99596fd457f2b6db$var$I, s);
        return _this;
    }
    (0, $kry2a._)(x, [
        {
            key: "encode",
            value: function encode(r) {
                if (typeof r == "string" && this.coders[r]) return $99596fd457f2b6db$var$Q(this, $99596fd457f2b6db$var$v, $99596fd457f2b6db$var$pe).call(this, r);
                var _Object_keys = (0, $jKer9._)(Object.keys(r)), t = _Object_keys[0], n = _Object_keys.slice(1);
                if (!t) throw new Error("A field for the case must be provided");
                if (n.length !== 0) throw new Error("Only one field must be provided");
                var s = this.coders[t], a = Object.keys(this.coders).indexOf(t), i = s.encode(r[t]), c = new Uint8Array($99596fd457f2b6db$var$T(this, $99596fd457f2b6db$var$I) - s.encodedLength);
                return (0, $j2rU8.concat)([
                    $99596fd457f2b6db$var$T(this, $99596fd457f2b6db$var$S).encode(a),
                    c,
                    i
                ]);
            }
        },
        {
            key: "decode",
            value: function decode(r, t) {
                var n = t, s;
                var ref;
                ref = (0, $8GFUW._)(new $99596fd457f2b6db$export$53960a2ba5cf2c18().decode(r, n), 2), s = ref[0], n = ref[1], ref;
                var a = (0, $4x96T.toNumber)(s), i = Object.keys(this.coders)[a];
                if (!i) throw new Error('Invalid caseIndex "'.concat(a, '". Valid cases: ').concat(Object.keys(this.coders)));
                var c = this.coders[i];
                var ref1;
                return n += $99596fd457f2b6db$var$T(this, $99596fd457f2b6db$var$I) - c.encodedLength, ref1 = (0, $8GFUW._)(c.decode(r, n), 2), s = ref1[0], n = ref1[1], ref1, $99596fd457f2b6db$var$_e(this.coders) ? $99596fd457f2b6db$var$Q(this, $99596fd457f2b6db$var$Z, $99596fd457f2b6db$var$ue).call(this, i, n) : [
                    (0, $dxWQo._)({}, i, s),
                    n
                ];
            }
        }
    ]);
    return x;
}($99596fd457f2b6db$export$2c0c39526f8bad46);
$99596fd457f2b6db$var$S = new WeakMap, $99596fd457f2b6db$var$I = new WeakMap, $99596fd457f2b6db$var$v = new WeakSet, $99596fd457f2b6db$var$pe = function pe(r) {
    var t = this.coders[r], n = t.encode([]), s = Object.keys(this.coders).indexOf(r), a = new Uint8Array($99596fd457f2b6db$var$T(this, $99596fd457f2b6db$var$I) - t.encodedLength);
    return (0, $j2rU8.concat)([
        $99596fd457f2b6db$var$T(this, $99596fd457f2b6db$var$S).encode(s),
        a,
        n
    ]);
}, $99596fd457f2b6db$var$Z = new WeakSet, $99596fd457f2b6db$var$ue = function ue(r, t) {
    return [
        r,
        t
    ];
};
var $99596fd457f2b6db$export$b934dc8cfe13938c = /*#__PURE__*/ function(d) {
    "use strict";
    (0, $ftJVG._)(U, d);
    var _super = (0, $6OZAO._)(U);
    function U(e) {
        (0, $978gY._)(this, U);
        var _this;
        var _temp;
        switch(_temp = _this = _super.call(this, "number", e, 8), (0, $dxWQo._)((0, $3vWwE._)(_this), "length", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "baseType", void 0), _temp, _this.baseType = e, e){
            case "u8":
                _this.length = 1;
                break;
            case "u16":
                _this.length = 2;
                break;
            case "u32":
            default:
                _this.length = 4;
                break;
        }
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(U, [
        {
            key: "encode",
            value: function encode(e) {
                var r;
                try {
                    r = (0, $4x96T.toBytes)(e);
                } catch (e1) {
                    this.throwError("Invalid ".concat(this.baseType), e);
                }
                return r.length > this.length && this.throwError("Invalid ".concat(this.baseType, ". Too many bytes."), e), (0, $4x96T.toBytes)(r, 8);
            }
        },
        {
            key: "decode",
            value: function decode(e, r) {
                var t = e.slice(r, r + 8);
                return t = t.slice(8 - this.length, 8), [
                    (0, $4x96T.toNumber)(t),
                    r + 8
                ];
            }
        }
    ]);
    return U;
}($99596fd457f2b6db$export$2c0c39526f8bad46);
var $99596fd457f2b6db$var$k, $99596fd457f2b6db$export$2d1b854518731426 = /*#__PURE__*/ function(d) {
    "use strict";
    (0, $ftJVG._)(B, d);
    var _super = (0, $6OZAO._)(B);
    function B(r) {
        (0, $978gY._)(this, B);
        var _this;
        var t = (8 - r) % 8;
        t = t < 0 ? t + 8 : t;
        _this = _super.call(this, "string", "str[".concat(r, "]"), r + t);
        $99596fd457f2b6db$var$$((0, $3vWwE._)(_this), "length");
        $99596fd457f2b6db$var$E((0, $3vWwE._)(_this), $99596fd457f2b6db$var$k, void 0);
        _this.length = r, $99596fd457f2b6db$var$N((0, $3vWwE._)(_this), $99596fd457f2b6db$var$k, t);
        return _this;
    }
    (0, $kry2a._)(B, [
        {
            key: "encode",
            value: function encode(r) {
                var t = (0, $1Wmc7.toUtf8Bytes)(r.slice(0, this.length)), n = new Uint8Array($99596fd457f2b6db$var$T(this, $99596fd457f2b6db$var$k));
                return (0, $j2rU8.concat)([
                    t,
                    n
                ]);
            }
        },
        {
            key: "decode",
            value: function decode(r, t) {
                var n = r.slice(t, t + this.length), s = (0, $1Wmc7.toUtf8String)(n), a = $99596fd457f2b6db$var$T(this, $99596fd457f2b6db$var$k);
                return [
                    s,
                    t + this.length + a
                ];
            }
        }
    ]);
    return B;
}($99596fd457f2b6db$export$2c0c39526f8bad46);
$99596fd457f2b6db$var$k = new WeakMap;
var $99596fd457f2b6db$var$R = /*#__PURE__*/ function(x) {
    "use strict";
    (0, $ftJVG._)(R, x);
    var _super = (0, $6OZAO._)(R);
    function R() {
        (0, $978gY._)(this, R);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(R, [
        {
            key: "encode",
            value: function encode(e) {
                return (0, $3cct3._)((0, $g3d7z._)(R.prototype), "encode", this).call(this, this.toSwayOption(e));
            }
        },
        {
            key: "toSwayOption",
            value: function toSwayOption(e) {
                return e !== void 0 ? {
                    Some: e
                } : {
                    None: []
                };
            }
        },
        {
            key: "decode",
            value: function decode(e, r) {
                var _get_call = (0, $8GFUW._)((0, $3cct3._)((0, $g3d7z._)(R.prototype), "decode", this).call(this, e, r), 2), t = _get_call[0], n = _get_call[1];
                return [
                    this.toOption(t),
                    n
                ];
            }
        },
        {
            key: "toOption",
            value: function toOption(e) {
                if (e && "Some" in e) return e.Some;
            }
        }
    ]);
    return R;
}($99596fd457f2b6db$export$36373497af15670);
var $99596fd457f2b6db$export$bbe9816ecfd07067 = /*#__PURE__*/ function(d) {
    "use strict";
    (0, $ftJVG._)(_, d);
    var _super = (0, $6OZAO._)(_);
    function _(e, r) {
        (0, $978gY._)(this, _);
        var _this;
        var t = Object.values(r).reduce(function(n, s) {
            return n + s.encodedLength;
        }, 0);
        var _temp;
        _temp = _this = _super.call(this, "struct", "struct ".concat(e), t), (0, $dxWQo._)((0, $3vWwE._)(_this), "name", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "coders", void 0), _temp, _this.name = e, _this.coders = r;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(_, [
        {
            key: "encode",
            value: function encode(e) {
                var _this = this;
                var r = Object.keys(this.coders).map(function(t) {
                    var n = _this.coders[t], s = e[t];
                    return !(n instanceof $99596fd457f2b6db$var$R) && s == null && _this.throwError("Invalid ".concat(_this.type, '. Field "').concat(t, '" not present.'), e), n.encode(s);
                });
                return (0, $j2rU8.concat)(r);
            }
        },
        {
            key: "decode",
            value: function decode(e, r) {
                var _this = this;
                var t = r;
                return [
                    Object.keys(this.coders).reduce(function(s, a) {
                        var i = _this.coders[a], c;
                        var ref;
                        return ref = (0, $8GFUW._)(i.decode(e, t), 2), c = ref[0], t = ref[1], ref, s[a] = c, s;
                    }, {}),
                    t
                ];
            }
        }
    ]);
    return _;
}($99596fd457f2b6db$export$2c0c39526f8bad46);
var $99596fd457f2b6db$export$e9fceba8f110fea6 = /*#__PURE__*/ function(d) {
    "use strict";
    (0, $ftJVG._)(F, d);
    var _super = (0, $6OZAO._)(F);
    function F(e) {
        (0, $978gY._)(this, F);
        var _this;
        var r = e.reduce(function(t, n) {
            return t + n.encodedLength;
        }, 0);
        var _temp;
        _temp = _this = _super.call(this, "tuple", "(".concat(e.map(function(t) {
            return t.type;
        }).join(", "), ")"), r), (0, $dxWQo._)((0, $3vWwE._)(_this), "coders", void 0), _temp, _this.coders = e;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(F, [
        {
            key: "encode",
            value: function encode(e) {
                return this.coders.length !== e.length && this.throwError("Types/values length mismatch", {
                    value: e
                }), (0, $j2rU8.concat)(this.coders.map(function(r, t) {
                    return r.encode(e[t]);
                }));
            }
        },
        {
            key: "decode",
            value: function decode(e, r) {
                var t = r;
                return [
                    this.coders.map(function(s) {
                        var a;
                        var ref;
                        return ref = (0, $8GFUW._)(s.decode(e, t), 2), a = ref[0], t = ref[1], ref, a;
                    }),
                    t
                ];
            }
        }
    ]);
    return F;
}($99596fd457f2b6db$export$2c0c39526f8bad46);
var $99596fd457f2b6db$export$22395e4fd816f742 = "enum Option", $99596fd457f2b6db$export$309ba2df1ea42ba0 = "struct Vec", $99596fd457f2b6db$export$f1af60f9e172e363 = RegExp("str\\[(?<length>[0-9]+)\\]"), $99596fd457f2b6db$export$593793b5e0f1608b = RegExp("\\[(?<item>[\\w\\s\\\\[\\]]+);\\s*(?<length>[0-9]+)\\]"), $99596fd457f2b6db$export$c9dc96ea68bf6bc1 = RegExp("^struct (?<name>\\w+)$"), $99596fd457f2b6db$export$eb6eea7070b62fe0 = RegExp("^enum (?<name>\\w+)$"), $99596fd457f2b6db$export$b342316fd33cbe88 = RegExp("^\\((?<items>.*)\\)$"), $99596fd457f2b6db$export$eef9e5f9f68a0191 = RegExp("^generic (?<name>\\w+)$"), $99596fd457f2b6db$export$824fe97aa0577f7b = 8, $99596fd457f2b6db$export$c827acb7935e004f = 32, $99596fd457f2b6db$export$bab507e3fd7a54c4 = 255, $99596fd457f2b6db$export$d25c7a55c38444e8 = 32, $99596fd457f2b6db$export$daa422f9744b2480 = 32, $99596fd457f2b6db$export$90b3ac72f57de0c1 = 10240, $99596fd457f2b6db$export$608025854858e845 = 104;
var $99596fd457f2b6db$var$We = 3, $99596fd457f2b6db$export$3baeb16366696f40 = /*#__PURE__*/ function(d) {
    "use strict";
    (0, $ftJVG._)(b, d);
    var _super = (0, $6OZAO._)(b);
    function b(e) {
        (0, $978gY._)(this, b);
        var _this;
        var _temp;
        _temp = _this = _super.call(this, "struct", "struct Vec", 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "coder", void 0), _temp, _this.coder = e;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(b, [
        {
            key: "getEncodedVectorData",
            value: function getEncodedVectorData(e) {
                var _this = this;
                Array.isArray(e) || this.throwError("expected array value", e);
                var r = Array.from(e).map(function(t) {
                    return _this.coder.encode(t);
                });
                return (0, $j2rU8.concat)(r);
            }
        },
        {
            key: "encode",
            value: function encode(e) {
                Array.isArray(e) || this.throwError("expected array value", e);
                var r = [], t = this.offset || 0;
                return r.push(new $99596fd457f2b6db$export$53960a2ba5cf2c18().encode(t)), r.push(new $99596fd457f2b6db$export$53960a2ba5cf2c18().encode(e.length)), r.push(new $99596fd457f2b6db$export$53960a2ba5cf2c18().encode(e.length)), (0, $j2rU8.concat)(r);
            }
        },
        {
            key: "decode",
            value: function decode(e, r) {
                this.throwError("unexpected Vec decode", "not implemented");
            }
        }
    ], [
        {
            key: "getBaseOffset",
            value: function getBaseOffset() {
                return $99596fd457f2b6db$var$We * 8;
            }
        }
    ]);
    return b;
}($99596fd457f2b6db$export$2c0c39526f8bad46);
function $99596fd457f2b6db$export$352b17fe8fd08d41(o) {
    return o.filter(function(e) {
        return (e == null ? void 0 : e.type) !== "()" && e !== "()";
    });
}
function $99596fd457f2b6db$export$94c2c2e7f1b091e8(o) {
    return o.some(function(e) {
        return (e == null ? void 0 : e.type) === $99596fd457f2b6db$export$22395e4fd816f742;
    });
}
function $99596fd457f2b6db$export$b0ff4af5ace7d63a(o, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var t = [], n = o.map(function(i, c) {
        if (!(i instanceof $99596fd457f2b6db$export$3baeb16366696f40)) return {
            byteLength: i.encodedLength
        };
        var y = i.getEncodedVectorData(e[c]);
        return t.push(y), {
            vecByteLength: y.byteLength
        };
    });
    if (!t.length) return t;
    var s = t.length * $99596fd457f2b6db$export$3baeb16366696f40.getBaseOffset() + r, a = o.map(function(i, c) {
        return i instanceof $99596fd457f2b6db$export$3baeb16366696f40 ? n.reduce(function(y, C, j) {
            return "byteLength" in C ? y + C.byteLength : j < c ? y + C.vecByteLength : y;
        }, s) : 0;
    });
    return o.forEach(function(i, c) {
        return i.setOffset(a[c]);
    }), t;
}
var $99596fd457f2b6db$export$ffb0004e005737fa = function X(e) {
    "use strict";
    (0, $978gY._)(this, X);
    (0, $dxWQo._)(this, "type", void 0);
    (0, $dxWQo._)(this, "name", void 0);
    (0, $dxWQo._)(this, "inputs", []);
    (0, $dxWQo._)(this, "outputs", []);
    (0, $dxWQo._)(this, "attributes", []);
    this.type = e.type, this.name = e.name, this.inputs = e.inputs, this.outputs = e.outputs, this.attributes = e.attributes;
};
var $99596fd457f2b6db$var$H = new (0, $6M65e.Logger)((0, $4jkfR.versions).FUELS), $99596fd457f2b6db$export$fe041e1a83d3efc6 = /*#__PURE__*/ function _target() {
    "use strict";
    function h1() {
        (0, $978gY._)(this, h1);
        $99596fd457f2b6db$var$H.checkNew(this instanceof h1 ? this.constructor : void 0, $99596fd457f2b6db$export$fe041e1a83d3efc6);
    }
    (0, $kry2a._)(h1, [
        {
            key: "getCoder",
            value: function getCoder(e) {
                var _this = this;
                var i, c, y, C, j, ne;
                switch(e.type){
                    case "u8":
                    case "u16":
                    case "u32":
                        return new $99596fd457f2b6db$export$b934dc8cfe13938c(e.type);
                    case "u64":
                    case "raw untyped ptr":
                        return new $99596fd457f2b6db$export$53960a2ba5cf2c18;
                    case "bool":
                        return new $99596fd457f2b6db$export$fe9118d6c093150c;
                    case "byte":
                        return new $99596fd457f2b6db$export$898870db6be4d918;
                    case "b256":
                        return new $99596fd457f2b6db$export$77ea01d3b03a250c;
                    case "struct B512":
                        return new $99596fd457f2b6db$export$91df7292016ad4c5;
                    default:
                }
                var r = (i = $99596fd457f2b6db$export$593793b5e0f1608b.exec(e.type)) == null ? void 0 : i.groups;
                if (r) {
                    var m = parseInt(r.length, 10), g = (c = e.components) == null ? void 0 : c[0];
                    if (!g) throw new Error("Expected array type to have an item component");
                    var O = this.getCoder(g);
                    return new $99596fd457f2b6db$export$88bc419d2df11f54(O, m);
                }
                if ([
                    "raw untyped slice"
                ].includes(e.type)) {
                    var g1 = this.getCoder({
                        type: "u64"
                    });
                    return new $99596fd457f2b6db$export$88bc419d2df11f54(g1, 0);
                }
                var t = (y = $99596fd457f2b6db$export$f1af60f9e172e363.exec(e.type)) == null ? void 0 : y.groups;
                if (t) {
                    var m1 = parseInt(t.length, 10);
                    return new $99596fd457f2b6db$export$2d1b854518731426(m1);
                }
                if (e.type === $99596fd457f2b6db$export$309ba2df1ea42ba0 && Array.isArray(e.typeArguments)) {
                    var m2 = e.typeArguments[0];
                    if (!m2) throw new Error("Expected Vec type to have a type argument");
                    var g2 = this.getCoder(m2);
                    return new $99596fd457f2b6db$export$3baeb16366696f40(g2);
                }
                var n = (C = $99596fd457f2b6db$export$c9dc96ea68bf6bc1.exec(e.type)) == null ? void 0 : C.groups;
                if (n && Array.isArray(e.components)) {
                    var m3 = e.components.reduce(function(g, O) {
                        return g[O.name] = _this.getCoder(O), g;
                    }, {});
                    return new $99596fd457f2b6db$export$bbe9816ecfd07067(n.name, m3);
                }
                var s = (j = $99596fd457f2b6db$export$eb6eea7070b62fe0.exec(e.type)) == null ? void 0 : j.groups;
                if (s && Array.isArray(e.components)) {
                    var m4 = e.components.reduce(function(O, oe) {
                        return O[oe.name] = _this.getCoder(oe), O;
                    }, {});
                    return e.type === $99596fd457f2b6db$export$22395e4fd816f742 ? new $99596fd457f2b6db$var$R(s.name, m4) : new $99596fd457f2b6db$export$36373497af15670(s.name, m4);
                }
                if (((ne = $99596fd457f2b6db$export$b342316fd33cbe88.exec(e.type)) == null ? void 0 : ne.groups) && Array.isArray(e.components)) {
                    var m5 = e.components.map(function(g) {
                        return _this.getCoder(g);
                    });
                    return new $99596fd457f2b6db$export$e9fceba8f110fea6(m5);
                }
                return $99596fd457f2b6db$var$H.throwArgumentError("Invalid type", "type", e.type);
            }
        },
        {
            key: "encode",
            value: function encode(e, r) {
                var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var _this = this;
                var n = $99596fd457f2b6db$export$352b17fe8fd08d41(e), s = r.slice();
                Array.isArray(r) && n.length !== r.length && ($99596fd457f2b6db$export$94c2c2e7f1b091e8(e) ? (s.length = e.length, s.fill(void 0, r.length)) : $99596fd457f2b6db$var$H.throwError("Types/values length mismatch during encode", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                    count: {
                        types: e.length,
                        nonEmptyTypes: n.length,
                        values: r.length
                    },
                    value: {
                        types: e,
                        nonEmptyTypes: n,
                        values: r
                    }
                }));
                var a = n.map(function(C) {
                    return _this.getCoder(C);
                }), i = $99596fd457f2b6db$export$b0ff4af5ace7d63a(a, s, t), y = new $99596fd457f2b6db$export$e9fceba8f110fea6(a).encode(s);
                return (0, $j2rU8.concat)([
                    y,
                    (0, $j2rU8.concat)(i)
                ]);
            }
        },
        {
            key: "decode",
            value: function decode(e, r) {
                var _this = this;
                var t = (0, $j2rU8.arrayify)(r), n = $99596fd457f2b6db$export$352b17fe8fd08d41(e), s = function(y) {
                    y !== t.length && $99596fd457f2b6db$var$H.throwError("Types/values length mismatch during decode", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                        count: {
                            types: e.length,
                            nonEmptyTypes: n.length,
                            values: t.length,
                            newOffset: y
                        },
                        value: {
                            types: e,
                            nonEmptyTypes: n,
                            values: t
                        }
                    });
                };
                if (e.length === 0 || n.length === 0) {
                    s(t.length ? 8 : 0);
                    return;
                }
                var a = n.map(function(y) {
                    return _this.getCoder(y);
                });
                n[0] && n[0].type === "raw untyped slice" && (a[0].length = t.length / 8);
                var i = new $99596fd457f2b6db$export$e9fceba8f110fea6(a), _i_decode = (0, $8GFUW._)(i.decode(t, 0), 1), c = _i_decode[0];
                return c;
            }
        }
    ]);
    return h1;
}();
function $99596fd457f2b6db$var$Xe(o, e) {
    Object.keys(e).forEach(function(r) {
        var t = r, n = e[t];
        (0, $2ax4w.defineReadOnly)(o, t, n);
    });
}
var $99596fd457f2b6db$var$f = /*#__PURE__*/ function() {
    "use strict";
    function f1(e) {
        (0, $978gY._)(this, f1);
        (0, $dxWQo._)(this, "name", void 0);
        (0, $dxWQo._)(this, "type", void 0);
        (0, $dxWQo._)(this, "indexed", void 0);
        (0, $dxWQo._)(this, "components", void 0);
        (0, $dxWQo._)(this, "typeArguments", void 0);
        (0, $dxWQo._)(this, "isParamType", void 0);
        $99596fd457f2b6db$var$Xe(this, e), this.isParamType = !0, Object.freeze(this);
    }
    (0, $kry2a._)(f1, [
        {
            key: "getSignaturePrefix",
            value: function getSignaturePrefix() {
                if (this.type) {
                    if ($99596fd457f2b6db$export$c9dc96ea68bf6bc1.test(this.type)) return "s";
                    if ($99596fd457f2b6db$export$593793b5e0f1608b.test(this.type)) return "a";
                    if ($99596fd457f2b6db$export$eb6eea7070b62fe0.test(this.type)) return "e";
                }
                return "";
            }
        },
        {
            key: "getSignatureContent",
            value: function getSignatureContent() {
                var n, s;
                var e = this.type || "";
                if (e === "raw untyped ptr") return "rawptr";
                var r = (n = $99596fd457f2b6db$export$593793b5e0f1608b.exec(e)) == null ? void 0 : n.groups;
                if (r) return "[".concat(this.components ? this.components[0].getSignature() : r.item, ";").concat(r.length, "]");
                var t = (s = $99596fd457f2b6db$export$f1af60f9e172e363.exec(e)) == null ? void 0 : s.groups;
                if (t) return "str[".concat(t.length, "]");
                if (Array.isArray(this.components)) {
                    var a = Array.isArray(this.typeArguments) ? "<".concat(this.typeArguments.map(function(c) {
                        return c.getSignature();
                    }).join(","), ">") : "", i = "(".concat(this.components.map(function(c) {
                        return c.getSignature();
                    }).join(","), ")");
                    return "".concat(a).concat(i);
                }
                return e;
            }
        },
        {
            key: "getSignature",
            value: function getSignature() {
                var e = this.getSignaturePrefix(), r = this.getSignatureContent();
                return "".concat(e).concat(r);
            }
        }
    ], [
        {
            key: "fromObject",
            value: function fromObject(e) {
                return $99596fd457f2b6db$var$f.isParamType(e) ? e : new $99596fd457f2b6db$var$f({
                    name: e.name,
                    type: e.type,
                    components: e.components ? e.components.map($99596fd457f2b6db$var$f.fromObject) : void 0,
                    typeArguments: e.typeArguments ? e.typeArguments.map($99596fd457f2b6db$var$f.fromObject) : void 0
                });
            }
        },
        {
            key: "isParamType",
            value: function isParamType(e) {
                return Boolean(e == null ? void 0 : e.isParamType);
            }
        }
    ]);
    return f1;
}();
var $99596fd457f2b6db$export$6256c2c90721b6f4 = function(o) {
    return !Array.isArray(o);
}, $99596fd457f2b6db$export$dfd5f25e380dc247 = /*#__PURE__*/ function() {
    "use strict";
    function V1(e) {
        (0, $978gY._)(this, V1);
        (0, $dxWQo._)(this, "types", void 0);
        (0, $dxWQo._)(this, "functions", void 0);
        (0, $dxWQo._)(this, "loggedTypes", void 0);
        (0, $dxWQo._)(this, "configurables", void 0);
        this.types = e.types, this.functions = e.functions, this.loggedTypes = e.loggedTypes, this.configurables = e.configurables;
    }
    (0, $kry2a._)(V1, [
        {
            key: "parseLoggedType",
            value: function parseLoggedType(e) {
                return $99596fd457f2b6db$var$f.fromObject(this.parseInput(e.loggedType));
            }
        },
        {
            key: "parseInput",
            value: function parseInput(e) {
                var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Map;
                var _this = this;
                var t = this.types[e.type], n, s;
                if (!t) throw new Error("".concat(e.type, " not found"));
                if (Array.isArray(e.typeArguments) && (s = e.typeArguments.map(function(a) {
                    return _this.parseInput(a, r);
                })), Array.isArray(t.typeParameters) && Array.isArray(s) && t.typeParameters.forEach(function(a, i) {
                    s != null && s[i] && r.set(a, s[i]);
                }), Array.isArray(t.components) && (n = t.components.map(function(a) {
                    return _this.parseInput(a, r);
                })), $99596fd457f2b6db$export$eef9e5f9f68a0191.test(t.type)) {
                    var a = r.get(t.typeId);
                    if (a) return (0, $8E768._)((0, $8OnJk._)({}, a), {
                        name: e.name
                    });
                }
                return {
                    type: t.type,
                    name: e.name,
                    typeArguments: s,
                    components: n
                };
            }
        },
        {
            key: "unflattenLoggedTypes",
            value: function unflattenLoggedTypes() {
                var _this = this;
                return this.loggedTypes.map(function(e) {
                    return (0, $8E768._)((0, $8OnJk._)({}, e), {
                        abiFragmentType: [
                            _this.parseLoggedType(e)
                        ]
                    });
                });
            }
        },
        {
            key: "unflattenConfigurables",
            value: function unflattenConfigurables() {
                var _this = this;
                return this.configurables.map(function(e) {
                    return (0, $8E768._)((0, $8OnJk._)({}, e), {
                        fragmentType: _this.parseInput(e.configurableType)
                    });
                });
            }
        },
        {
            key: "unflatten",
            value: function unflatten() {
                var _this = this;
                return this.functions.map(function(e) {
                    return {
                        type: "function",
                        name: e.name,
                        inputs: (e.inputs || []).map(function(r) {
                            return _this.parseInput(r);
                        }),
                        outputs: e.output ? [
                            _this.parseInput(e.output)
                        ] : [],
                        attributes: e.attributes || []
                    };
                });
            }
        }
    ], [
        {
            key: "unflatten",
            value: function unflatten(e) {
                return $99596fd457f2b6db$export$6256c2c90721b6f4(e) ? new $99596fd457f2b6db$export$dfd5f25e380dc247(e).unflatten() : e;
            }
        }
    ]);
    return V1;
}(), $99596fd457f2b6db$export$10d94691d13ae529 = function(o) {
    switch(o){
        case "u8":
        case "u16":
        case "u32":
        case "u64":
        case "bool":
            return !1;
        default:
            return !0;
    }
};
function $99596fd457f2b6db$var$er(o) {
    var e = (0, $7WUQV.sha256)((0, $2URXt.bufferFromString)(o, "utf-8"));
    return (0, $4x96T.bn)(e.slice(0, 10)).toHex(8);
}
var $99596fd457f2b6db$export$8d576c928b93668f = /*#__PURE__*/ function(X) {
    "use strict";
    (0, $ftJVG._)(A1, X);
    var _super = (0, $6OZAO._)(A1);
    function A1() {
        (0, $978gY._)(this, A1);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(A1, [
        {
            key: "getSignature",
            value: function getSignature() {
                var e = this.inputs.map(function(r) {
                    return r.getSignature();
                });
                return "".concat(this.name, "(").concat(e.join(","), ")");
            }
        },
        {
            key: "getSelector",
            value: function getSelector() {
                return $99596fd457f2b6db$var$er(this.getSignature());
            }
        },
        {
            key: "isInputDataPointer",
            value: function isInputDataPointer() {
                var e;
                return this.inputs.length > 1 || $99596fd457f2b6db$export$10d94691d13ae529(((e = this.inputs[0]) == null ? void 0 : e.type) || "");
            }
        },
        {
            key: "encodeArguments",
            value: function encodeArguments(e) {
                var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return new $99596fd457f2b6db$export$fe041e1a83d3efc6().encode(this.inputs, e, r);
            }
        },
        {
            key: "decodeArguments",
            value: function decodeArguments(e) {
                return new $99596fd457f2b6db$export$fe041e1a83d3efc6().decode(this.inputs, (0, $j2rU8.arrayify)(e));
            }
        }
    ], [
        {
            key: "fromObject",
            value: function fromObject(e) {
                var tmp = e.inputs, r = tmp === void 0 ? [] : tmp, tmp1 = e.outputs, t = tmp1 === void 0 ? [] : tmp1, tmp2 = e.attributes, n = tmp2 === void 0 ? [] : tmp2, s = {
                    type: "function",
                    name: e.name,
                    inputs: r.map($99596fd457f2b6db$var$f.fromObject),
                    outputs: t.map($99596fd457f2b6db$var$f.fromObject),
                    attributes: n
                };
                return new $99596fd457f2b6db$export$8d576c928b93668f(s);
            }
        }
    ]);
    return A1;
}($99596fd457f2b6db$export$ffb0004e005737fa);
var $99596fd457f2b6db$var$xe = new (0, $6M65e.Logger)((0, $4jkfR.versions).FUELS), $99596fd457f2b6db$var$or = function(o) {
    var e = [];
    return o.forEach(function(r) {
        r.type === "function" && e.push($99596fd457f2b6db$export$8d576c928b93668f.fromObject(r));
    }), e;
}, $99596fd457f2b6db$var$sr = function(o) {
    var e = {};
    return o.forEach(function(r) {
        e[r.name] = (0, $8OnJk._)({}, r);
    }), e;
}, $99596fd457f2b6db$export$48cefb51a4e315b2 = /*#__PURE__*/ function() {
    "use strict";
    function K(e) {
        var _this = this;
        (0, $978gY._)(this, K);
        (0, $dxWQo._)(this, "fragments", void 0);
        (0, $dxWQo._)(this, "functions", void 0);
        (0, $dxWQo._)(this, "configurables", void 0);
        (0, $dxWQo._)(this, "abiCoder", void 0);
        (0, $dxWQo._)(this, "abi", void 0);
        (0, $dxWQo._)(this, "types", void 0);
        (0, $dxWQo._)(this, "loggedTypes", void 0);
        (0, $dxWQo._)(this, "externalLoggedTypes", void 0);
        var r;
        this.abi = $99596fd457f2b6db$export$6256c2c90721b6f4(e) ? new $99596fd457f2b6db$export$dfd5f25e380dc247(e) : null, this.fragments = $99596fd457f2b6db$var$or($99596fd457f2b6db$export$dfd5f25e380dc247.unflatten(e)), this.types = this.abi ? this.abi.types : [], this.loggedTypes = this.abi ? this.abi.unflattenLoggedTypes() : [], this.externalLoggedTypes = {}, this.abiCoder = new $99596fd457f2b6db$export$fe041e1a83d3efc6, this.functions = {}, this.configurables = $99596fd457f2b6db$var$sr(((r = this.abi) == null ? void 0 : r.unflattenConfigurables()) || []), this.fragments.forEach(function(t) {
            if (t instanceof $99596fd457f2b6db$export$8d576c928b93668f) {
                var n = t.getSignature();
                if (_this.functions[n]) {
                    $99596fd457f2b6db$var$xe.warn("duplicate definition - ".concat(n));
                    return;
                }
                _this.functions[n] = t;
            }
        });
    }
    (0, $kry2a._)(K, [
        {
            key: "getFunction",
            value: function getFunction(e) {
                if (this.functions[e]) return this.functions[e];
                var r = Object.values(this.functions).find(function(t) {
                    return t.getSelector() === e || t.name === e;
                });
                return r || $99596fd457f2b6db$var$xe.throwArgumentError("function ".concat(e, " not found."), "data", r);
            }
        },
        {
            key: "decodeFunctionData",
            value: function decodeFunctionData(e, r) {
                var t = typeof e == "string" ? this.getFunction(e) : e;
                if (!t) throw new Error("Fragment not found");
                return t.decodeArguments(r);
            }
        },
        {
            key: "encodeFunctionData",
            value: function encodeFunctionData(e, r) {
                var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var n = typeof e == "string" ? this.getFunction(e) : e;
                if (!n) throw new Error("Fragment not found");
                return n.encodeArguments(r, t);
            }
        },
        {
            key: "decodeFunctionResult",
            value: function decodeFunctionResult(e, r) {
                var t = typeof e == "string" ? this.getFunction(e) : e, n = (0, $j2rU8.arrayify)(r);
                return this.abiCoder.decode(t.outputs, n);
            }
        },
        {
            key: "decodeLog",
            value: function decodeLog(e, r, t) {
                var s = (this.externalLoggedTypes[t] || this.loggedTypes).find(function(a) {
                    return a.logId === r;
                });
                if (!(s != null && s.abiFragmentType)) throw new Error("Log ID - ".concat(r, " unknown"));
                return this.abiCoder.decode(s.abiFragmentType, e);
            }
        },
        {
            key: "encodeFunctionResult",
            value: function encodeFunctionResult(e, r) {
                var t = typeof e == "string" ? this.getFunction(e) : e;
                if (!t) throw new Error("Fragment not found");
                return this.abiCoder.encode(t.outputs, r);
            }
        },
        {
            key: "updateExternalLoggedTypes",
            value: function updateExternalLoggedTypes(e, r) {
                this.externalLoggedTypes[e] = r;
            }
        }
    ]);
    return K;
}();

});
parcelRequire.register("4jkfR", function(module, exports) {

$parcel$export(module.exports, "versions", function () { return $2ed51b05ca2e610b$export$3acacdf112fc9c85; });
function $2ed51b05ca2e610b$var$o() {
    return {
        FORC: "0.35.5",
        FUEL_CORE: "0.17.3",
        FUELS: "0.42.0"
    };
}
var $2ed51b05ca2e610b$export$3acacdf112fc9c85 = $2ed51b05ca2e610b$var$o();

});

parcelRequire.register("4x96T", function(module, exports) {

$parcel$export(module.exports, "BN", function () { return $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe; });
$parcel$export(module.exports, "bn", function () { return $a19e4ce12c6d3bfd$export$acf3ba20e47771d; });
$parcel$export(module.exports, "toNumber", function () { return $a19e4ce12c6d3bfd$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "toHex", function () { return $a19e4ce12c6d3bfd$export$7ea66e3774a60b67; });
$parcel$export(module.exports, "toBytes", function () { return $a19e4ce12c6d3bfd$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "max", function () { return $a19e4ce12c6d3bfd$export$8960430cfd85939f; });
$parcel$export(module.exports, "multiply", function () { return $a19e4ce12c6d3bfd$export$2060d2db72cce88f; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $ho5gk = parcelRequire("ho5gk");

var $8GFUW = parcelRequire("8GFUW");

var $6OZAO = parcelRequire("6OZAO");

var $jlWHo = parcelRequire("jlWHo");
function $a19e4ce12c6d3bfd$export$a81f732198733497(o, t) {
    var _ref = t || {}, tmp = _ref.precision, r = tmp === void 0 ? 9 : tmp, tmp1 = _ref.minPrecision, e = tmp1 === void 0 ? 3 : tmp1, _String_split = (0, $8GFUW._)(String(o || "0.0").split("."), 2), tmp2 = _String_split[0], s = tmp2 === void 0 ? "0" : tmp2, tmp3 = _String_split[1], u = tmp3 === void 0 ? "0" : tmp3, p = /(\d)(?=(\d{3})+\b)/g, l = s.replace(p, "$1,"), a = u.slice(0, r);
    if (e < r) {
        var f = a.match(/.*[1-9]{1}/), h = (f == null ? void 0 : f[0].length) || 0, y = Math.max(e, h);
        a = a.slice(0, y);
    }
    var B = a ? ".".concat(a) : "";
    return "".concat(l).concat(B);
}
var $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe = /*#__PURE__*/ function(c1) {
    "use strict";
    (0, $ftJVG._)(n1, c1);
    var _super = (0, $6OZAO._)(n1);
    function n1(t, r, e) {
        (0, $978gY._)(this, n1);
        var _this;
        if ($a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe.isBN(t)) {
            _this = _super.call(this, t.toArray(), r, e);
            return (0, $ho5gk._)(_this);
        }
        if (typeof t == "string" && t.slice(0, 2) === "0x") {
            _this = _super.call(this, t.substring(2), r || "hex", e);
            return (0, $ho5gk._)(_this);
        }
        var s = t == null ? 0 : t;
        _this = _super.call(this, s, r, e);
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(n1, [
        {
            key: "toString",
            value: function toString(t, r) {
                var e = (0, $3cct3._)((0, $g3d7z._)(n1.prototype), "toString", this).call(this, t, r);
                return t === 16 || t === "hex" ? "0x".concat(e) : e;
            }
        },
        {
            key: "toHex",
            value: function toHex(t) {
                var e = (t || 0) * 2;
                if (this.isNeg()) throw new Error("cannot convert negative value to hex");
                if (t && this.byteLength() > t) throw new Error("value ".concat(this, " exceeds bytes ").concat(t));
                return this.toString(16, e);
            }
        },
        {
            key: "toBytes",
            value: function toBytes(t) {
                if (this.isNeg()) throw new Error("cannot convert negative value to Bytes");
                return Uint8Array.from(this.toArray(void 0, t));
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.toString(16);
            }
        },
        {
            key: "valueOf",
            value: function valueOf() {
                return this.toString();
            }
        },
        {
            key: "format",
            value: function format(t) {
                var _ref = t || {}, tmp = _ref.units, r = tmp === void 0 ? 9 : tmp, tmp1 = _ref.precision, e = tmp1 === void 0 ? 9 : tmp1, tmp2 = _ref.minPrecision, s = tmp2 === void 0 ? 3 : tmp2, u = this.formatUnits(r), p = $a19e4ce12c6d3bfd$export$a81f732198733497(u, {
                    precision: e,
                    minPrecision: s
                });
                if (!parseFloat(p)) {
                    var _u_split = (0, $8GFUW._)(u.split("."), 2), tmp3 = _u_split[1], l = tmp3 === void 0 ? "0" : tmp3, a = l.match(/[1-9]/);
                    if (a && a.index && a.index + 1 > e) {
                        var _p_split = (0, $8GFUW._)(p.split("."), 1), tmp4 = _p_split[0], B = tmp4 === void 0 ? "0" : tmp4;
                        return "".concat(B, ".").concat(l.slice(0, a.index + 1));
                    }
                }
                return p;
            }
        },
        {
            key: "formatUnits",
            value: function formatUnits() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 9;
                var r = this.toString().slice(0, t * -1), e = this.toString().slice(t * -1), s = e.length, u = Array.from({
                    length: t - s
                }).fill("0").join("");
                return "".concat(r ? "".concat(r, ".") : "0.").concat(u).concat(e);
            }
        },
        {
            key: "add",
            value: function add(t) {
                return this.caller(t, "add");
            }
        },
        {
            key: "pow",
            value: function pow(t) {
                return this.caller(t, "pow");
            }
        },
        {
            key: "sub",
            value: function sub(t) {
                return this.caller(t, "sub");
            }
        },
        {
            key: "div",
            value: function div(t) {
                return this.caller(t, "div");
            }
        },
        {
            key: "mul",
            value: function mul(t) {
                return this.caller(t, "mul");
            }
        },
        {
            key: "mod",
            value: function mod(t) {
                return this.caller(t, "mod");
            }
        },
        {
            key: "divRound",
            value: function divRound(t) {
                return this.caller(t, "divRound");
            }
        },
        {
            key: "lt",
            value: function lt(t) {
                return this.caller(t, "lt");
            }
        },
        {
            key: "lte",
            value: function lte(t) {
                return this.caller(t, "lte");
            }
        },
        {
            key: "gt",
            value: function gt(t) {
                return this.caller(t, "gt");
            }
        },
        {
            key: "gte",
            value: function gte(t) {
                return this.caller(t, "gte");
            }
        },
        {
            key: "eq",
            value: function eq(t) {
                return this.caller(t, "eq");
            }
        },
        {
            key: "cmp",
            value: function cmp(t) {
                return this.caller(t, "cmp");
            }
        },
        {
            key: "sqr",
            value: function sqr() {
                return new $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe((0, $3cct3._)((0, $g3d7z._)(n1.prototype), "sqr", this).call(this).toArray());
            }
        },
        {
            key: "neg",
            value: function neg() {
                return new $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe((0, $3cct3._)((0, $g3d7z._)(n1.prototype), "neg", this).call(this).toArray());
            }
        },
        {
            key: "abs",
            value: function abs() {
                return new $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe((0, $3cct3._)((0, $g3d7z._)(n1.prototype), "abs", this).call(this).toArray());
            }
        },
        {
            key: "toTwos",
            value: function toTwos(t) {
                return new $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe((0, $3cct3._)((0, $g3d7z._)(n1.prototype), "toTwos", this).call(this, t).toArray());
            }
        },
        {
            key: "fromTwos",
            value: function fromTwos(t) {
                return new $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe((0, $3cct3._)((0, $g3d7z._)(n1.prototype), "fromTwos", this).call(this, t).toArray());
            }
        },
        {
            key: "caller",
            value: function caller(t, r) {
                var e = (0, $3cct3._)((0, $g3d7z._)(n1.prototype), r, this).call(this, new $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe(t));
                return $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe.isBN(e) ? new $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe(e.toArray()) : e;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe(this.toArray());
            }
        },
        {
            key: "mulTo",
            value: function mulTo(t, r) {
                var e = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(this.toArray()).mulTo(t, r);
                return new $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe(e.toArray());
            }
        },
        {
            key: "egcd",
            value: function egcd(t) {
                var _egcd = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(this.toArray()).egcd(t), r = _egcd.a, e = _egcd.b, s = _egcd.gcd;
                return {
                    a: new $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe(r.toArray()),
                    b: new $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe(e.toArray()),
                    gcd: new $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe(s.toArray())
                };
            }
        },
        {
            key: "divmod",
            value: function divmod(t, r, e) {
                var _divmod = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(this.toArray()).divmod(new $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe(t), r, e), s = _divmod.div, u = _divmod.mod;
                return {
                    div: new $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe(s == null ? void 0 : s.toArray()),
                    mod: new $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe(u == null ? void 0 : u.toArray())
                };
            }
        }
    ]);
    return n1;
}((0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))), $a19e4ce12c6d3bfd$export$acf3ba20e47771d = function(o, t, r) {
    return new $a19e4ce12c6d3bfd$export$ed16643e9b9e3dfe(o, t, r);
};
$a19e4ce12c6d3bfd$export$acf3ba20e47771d.parseUnits = function(o) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 9;
    var r = o === "." ? "0." : o, _r_split = (0, $8GFUW._)(r.split("."), 2), tmp = _r_split[0], e = tmp === void 0 ? "0" : tmp, tmp1 = _r_split[1], s = tmp1 === void 0 ? "0" : tmp1, u = s.length;
    if (u > t) throw new Error("Decimal can't be bigger than the units");
    var p = Array.from({
        length: t
    }).fill("0");
    p.splice(0, u, s);
    var l = "".concat(e.replaceAll(",", "")).concat(p.join(""));
    return $a19e4ce12c6d3bfd$export$acf3ba20e47771d(l);
};
function $a19e4ce12c6d3bfd$export$a0a81dc3380ce7d3(o) {
    return $a19e4ce12c6d3bfd$export$acf3ba20e47771d(o).toNumber();
}
function $a19e4ce12c6d3bfd$export$7ea66e3774a60b67(o, t) {
    return $a19e4ce12c6d3bfd$export$acf3ba20e47771d(o).toHex(t);
}
function $a19e4ce12c6d3bfd$export$30a71edf0753ed6b(o, t) {
    return $a19e4ce12c6d3bfd$export$acf3ba20e47771d(o).toBytes(t);
}
function $a19e4ce12c6d3bfd$export$bd39b96f71da1885(o, t) {
    return $a19e4ce12c6d3bfd$export$acf3ba20e47771d(o).formatUnits(t);
}
function $a19e4ce12c6d3bfd$export$d9468344d3651243(o, t) {
    return $a19e4ce12c6d3bfd$export$acf3ba20e47771d(o).format(t);
}
function $a19e4ce12c6d3bfd$export$8960430cfd85939f() {
    for(var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++){
        o[_key] = arguments[_key];
    }
    return o.reduce(function(t, r) {
        return $a19e4ce12c6d3bfd$export$acf3ba20e47771d(r).gt(t) ? $a19e4ce12c6d3bfd$export$acf3ba20e47771d(r) : t;
    }, $a19e4ce12c6d3bfd$export$acf3ba20e47771d(0));
}
function $a19e4ce12c6d3bfd$export$2060d2db72cce88f() {
    for(var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++){
        o[_key] = arguments[_key];
    }
    return $a19e4ce12c6d3bfd$export$acf3ba20e47771d(Math.ceil(o.reduce(function(t, r) {
        return $a19e4ce12c6d3bfd$export$acf3ba20e47771d(t).mul(r);
    }, $a19e4ce12c6d3bfd$export$acf3ba20e47771d(1)).toNumber()));
}

});

parcelRequire.register("2URXt", function(module, exports) {

$parcel$export(module.exports, "bufferFromString", function () { return $3bdf4d83cb0f0aba$export$6f62445eba2edf62; });
$parcel$export(module.exports, "randomBytes", function () { return $3bdf4d83cb0f0aba$export$5f828d93ff035aa8; });

var $byzP8 = parcelRequire("byzP8");

var $1ObTH = parcelRequire("1ObTH");

var $7UAGh = parcelRequire("7UAGh");

var $j2rU8 = parcelRequire("j2rU8");

var $eIQbV = parcelRequire("eIQbV");

var $gzLuY = parcelRequire("gzLuY");
var $3bdf4d83cb0f0aba$require$Buffer = $gzLuY.Buffer;
var $3bdf4d83cb0f0aba$var$h = function(r) {
    return undefined;
}(function(r) {
    return undefined(this, arguments);
});
var $3bdf4d83cb0f0aba$var$T, $3bdf4d83cb0f0aba$var$v = "Node";
(typeof globalThis === "undefined" ? "undefined" : (0, $1ObTH._)(globalThis)) < "u" && globalThis.crypto && ($3bdf4d83cb0f0aba$var$T = globalThis.crypto, $3bdf4d83cb0f0aba$var$v = "Web");
if (!$3bdf4d83cb0f0aba$var$T && typeof $3bdf4d83cb0f0aba$var$h == "function") try {
    $3bdf4d83cb0f0aba$var$T = $3bdf4d83cb0f0aba$var$h("crypto"), $3bdf4d83cb0f0aba$var$v = "Node";
} catch (r) {
    console.error("keystore expects a standard Web browser or Node environment.", r);
}
var $3bdf4d83cb0f0aba$var$n = $3bdf4d83cb0f0aba$var$T, $3bdf4d83cb0f0aba$var$f = $3bdf4d83cb0f0aba$var$v;
function $3bdf4d83cb0f0aba$export$6f62445eba2edf62(r) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "base64";
    return $3bdf4d83cb0f0aba$var$f === "Node" ? $3bdf4d83cb0f0aba$require$Buffer.from(r, t) : t === "utf-8" ? new TextEncoder().encode(r) : new Uint8Array(atob(r).split("").map(function(e) {
        return e.charCodeAt(0);
    }));
}
function $3bdf4d83cb0f0aba$export$164d48b0f2f1870f(r) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "base64";
    return $3bdf4d83cb0f0aba$var$f === "Node" ? $3bdf4d83cb0f0aba$require$Buffer.from(r).toString(t) : btoa(String.fromCharCode.apply(null, new Uint8Array(r)));
}
function $3bdf4d83cb0f0aba$export$d894c84c4ff6c591(r, t) {
    var e = $3bdf4d83cb0f0aba$export$6f62445eba2edf62(String(r).normalize("NFKC"), "utf-8"), o = (0, $eIQbV.pbkdf2)(e, t, 1e5, 32, "sha256");
    return (0, $j2rU8.arrayify)(o);
}
var $3bdf4d83cb0f0aba$export$5f828d93ff035aa8 = function(r) {
    return $3bdf4d83cb0f0aba$var$f === "Node" ? $3bdf4d83cb0f0aba$var$n.randomBytes(r) : $3bdf4d83cb0f0aba$var$n.getRandomValues(new Uint8Array(r));
};
var $3bdf4d83cb0f0aba$var$w = "aes-256-ctr";
function $3bdf4d83cb0f0aba$var$x(r, t) {
    return $3bdf4d83cb0f0aba$var$_x.apply(this, arguments);
}
function $3bdf4d83cb0f0aba$var$_x() {
    $3bdf4d83cb0f0aba$var$_x = (0, $byzP8._)(function(r, t) {
        var e, o, p, y, a, c;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e = $3bdf4d83cb0f0aba$export$5f828d93ff035aa8(16), o = $3bdf4d83cb0f0aba$export$5f828d93ff035aa8(32), p = $3bdf4d83cb0f0aba$export$d894c84c4ff6c591(r, o), y = Uint8Array.from($3bdf4d83cb0f0aba$require$Buffer.from(JSON.stringify(t), "utf-8"));
                    return [
                        4,
                        $3bdf4d83cb0f0aba$var$n.createCipheriv($3bdf4d83cb0f0aba$var$w, p, e)
                    ];
                case 1:
                    a = _state.sent(), c = a.update(y);
                    return [
                        2,
                        (c = $3bdf4d83cb0f0aba$require$Buffer.concat([
                            c,
                            a.final()
                        ]), {
                            data: $3bdf4d83cb0f0aba$export$164d48b0f2f1870f(c),
                            iv: $3bdf4d83cb0f0aba$export$164d48b0f2f1870f(e),
                            salt: $3bdf4d83cb0f0aba$export$164d48b0f2f1870f(o)
                        })
                    ];
            }
        });
    });
    return $3bdf4d83cb0f0aba$var$_x.apply(this, arguments);
}
function $3bdf4d83cb0f0aba$var$B(r, t) {
    return $3bdf4d83cb0f0aba$var$_B.apply(this, arguments);
}
function $3bdf4d83cb0f0aba$var$_B() {
    $3bdf4d83cb0f0aba$var$_B = (0, $byzP8._)(function(r, t) {
        var e, o, p, y, a, c, g, b;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e = $3bdf4d83cb0f0aba$export$6f62445eba2edf62(t.iv), o = $3bdf4d83cb0f0aba$export$6f62445eba2edf62(t.salt), p = $3bdf4d83cb0f0aba$export$d894c84c4ff6c591(r, o), y = $3bdf4d83cb0f0aba$export$6f62445eba2edf62(t.data);
                    return [
                        4,
                        $3bdf4d83cb0f0aba$var$n.createDecipheriv($3bdf4d83cb0f0aba$var$w, p, e)
                    ];
                case 1:
                    a = _state.sent(), c = a.update(y), g = $3bdf4d83cb0f0aba$require$Buffer.concat([
                        c,
                        a.final()
                    ]), b = $3bdf4d83cb0f0aba$require$Buffer.from(g).toString("utf-8");
                    try {
                        return [
                            2,
                            JSON.parse(b)
                        ];
                    } catch (e) {
                        throw new Error("Invalid credentials");
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return $3bdf4d83cb0f0aba$var$_B.apply(this, arguments);
}
var $3bdf4d83cb0f0aba$var$N = "AES-CTR";
function $3bdf4d83cb0f0aba$var$S(r, t) {
    return $3bdf4d83cb0f0aba$var$_S.apply(this, arguments);
}
function $3bdf4d83cb0f0aba$var$_S() {
    $3bdf4d83cb0f0aba$var$_S = (0, $byzP8._)(function(r, t) {
        var e, o, p, y, a, c, g, b;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e = $3bdf4d83cb0f0aba$export$5f828d93ff035aa8(16), o = $3bdf4d83cb0f0aba$export$5f828d93ff035aa8(32), p = $3bdf4d83cb0f0aba$export$d894c84c4ff6c591(r, o), y = JSON.stringify(t), a = $3bdf4d83cb0f0aba$export$6f62445eba2edf62(y, "utf-8"), c = {
                        name: $3bdf4d83cb0f0aba$var$N,
                        counter: e,
                        length: 64
                    };
                    return [
                        4,
                        $3bdf4d83cb0f0aba$var$n.subtle.importKey("raw", p, c, !1, [
                            "encrypt"
                        ])
                    ];
                case 1:
                    g = _state.sent();
                    return [
                        4,
                        $3bdf4d83cb0f0aba$var$n.subtle.encrypt(c, g, a)
                    ];
                case 2:
                    b = _state.sent();
                    return [
                        2,
                        {
                            data: $3bdf4d83cb0f0aba$export$164d48b0f2f1870f(b),
                            iv: $3bdf4d83cb0f0aba$export$164d48b0f2f1870f(e),
                            salt: $3bdf4d83cb0f0aba$export$164d48b0f2f1870f(o)
                        }
                    ];
            }
        });
    });
    return $3bdf4d83cb0f0aba$var$_S.apply(this, arguments);
}
function $3bdf4d83cb0f0aba$var$A(r, t) {
    return $3bdf4d83cb0f0aba$var$_A.apply(this, arguments);
}
function $3bdf4d83cb0f0aba$var$_A() {
    $3bdf4d83cb0f0aba$var$_A = (0, $byzP8._)(function(r, t) {
        var e, o, p, y, a, c, g, b;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e = $3bdf4d83cb0f0aba$export$6f62445eba2edf62(t.iv), o = $3bdf4d83cb0f0aba$export$6f62445eba2edf62(t.salt), p = $3bdf4d83cb0f0aba$export$d894c84c4ff6c591(r, o), y = $3bdf4d83cb0f0aba$export$6f62445eba2edf62(t.data), a = {
                        name: $3bdf4d83cb0f0aba$var$N,
                        counter: e,
                        length: 64
                    };
                    return [
                        4,
                        $3bdf4d83cb0f0aba$var$n.subtle.importKey("raw", p, a, !1, [
                            "decrypt"
                        ])
                    ];
                case 1:
                    c = _state.sent();
                    return [
                        4,
                        $3bdf4d83cb0f0aba$var$n.subtle.decrypt(a, c, y)
                    ];
                case 2:
                    g = _state.sent(), b = new TextDecoder().decode(g);
                    try {
                        return [
                            2,
                            JSON.parse(b)
                        ];
                    } catch (e) {
                        throw new Error("Invalid credentials");
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return $3bdf4d83cb0f0aba$var$_A.apply(this, arguments);
}
function $3bdf4d83cb0f0aba$export$5b0f6292f11d1d18(r, t) {
    return $3bdf4d83cb0f0aba$var$_Q.apply(this, arguments);
}
function $3bdf4d83cb0f0aba$var$_Q() {
    $3bdf4d83cb0f0aba$var$_Q = (0, $byzP8._)(function(r, t) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $3bdf4d83cb0f0aba$var$f === "Node" ? $3bdf4d83cb0f0aba$var$x(r, t) : $3bdf4d83cb0f0aba$var$S(r, t)
            ];
        });
    });
    return $3bdf4d83cb0f0aba$var$_Q.apply(this, arguments);
}
function $3bdf4d83cb0f0aba$export$e85a0c9a1067c5d3(r, t) {
    return $3bdf4d83cb0f0aba$var$_X.apply(this, arguments);
}
function $3bdf4d83cb0f0aba$var$_X() {
    $3bdf4d83cb0f0aba$var$_X = (0, $byzP8._)(function(r, t) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $3bdf4d83cb0f0aba$var$f === "Node" ? $3bdf4d83cb0f0aba$var$B(r, t) : $3bdf4d83cb0f0aba$var$A(r, t)
            ];
        });
    });
    return $3bdf4d83cb0f0aba$var$_X.apply(this, arguments);
}

});


parcelRequire.register("1nhBg", function(module, exports) {

$parcel$export(module.exports, "addressify", function () { return $494a9ea619e2b821$export$dbb7d3295d721851; });
$parcel$export(module.exports, "Address", function () { return $494a9ea619e2b821$export$73974d1f547d9d48; });

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $ftJVG = parcelRequire("ftJVG");

var $ho5gk = parcelRequire("ho5gk");

var $6OZAO = parcelRequire("6OZAO");

var $j2rU8 = parcelRequire("j2rU8");

var $6M65e = parcelRequire("6M65e");

var $dktpY = parcelRequire("dktpY");

var $2URXt = parcelRequire("2URXt");

var $4jkfR = parcelRequire("4jkfR");

var $5qruh = parcelRequire("5qruh");

var $7WUQV = parcelRequire("7WUQV");
var $494a9ea619e2b821$var$L = new (0, $6M65e.Logger)((0, $4jkfR.versions).FUELS), $494a9ea619e2b821$export$fd34f2a6d059ed75 = "fuel";
function $494a9ea619e2b821$export$cf9278114d1aafea(r) {
    return (0, $5qruh.bech32m).decode(r);
}
function $494a9ea619e2b821$export$6ca020745d7ad2d4(r) {
    return (0, $5qruh.bech32m).encode($494a9ea619e2b821$export$fd34f2a6d059ed75, (0, $5qruh.bech32m).toWords((0, $j2rU8.arrayify)((0, $j2rU8.hexlify)(r))));
}
function $494a9ea619e2b821$export$82d17b1fbc69cb9c(r) {
    return typeof r == "string" && r.indexOf($494a9ea619e2b821$export$fd34f2a6d059ed75 + 1) === 0 && $494a9ea619e2b821$export$cf9278114d1aafea(r).prefix === $494a9ea619e2b821$export$fd34f2a6d059ed75;
}
function $494a9ea619e2b821$export$968f081d2e99f915(r) {
    return (r.length === 66 || r.length === 64) && /(0x)?[0-9a-f]{64}$/i.test(r);
}
function $494a9ea619e2b821$export$992faade6aae4117(r) {
    return (r.length === 130 || r.length === 128) && /(0x)?[0-9a-f]{128}$/i.test(r);
}
function $494a9ea619e2b821$export$b85e095c1ca2cb8e(r) {
    return new Uint8Array((0, $5qruh.bech32m).fromWords($494a9ea619e2b821$export$cf9278114d1aafea(r).words));
}
function $494a9ea619e2b821$export$cbe2a4f03e6317db(r) {
    return $494a9ea619e2b821$export$82d17b1fbc69cb9c(r) || $494a9ea619e2b821$var$L.throwArgumentError("Invalid Bech32 Address", "address", r), (0, $j2rU8.hexlify)($494a9ea619e2b821$export$b85e095c1ca2cb8e(r));
}
function $494a9ea619e2b821$export$ccd56f82e8d18a37(r) {
    var _c = $494a9ea619e2b821$export$cf9278114d1aafea(r), t = _c.words;
    return (0, $5qruh.bech32m).encode($494a9ea619e2b821$export$fd34f2a6d059ed75, t);
}
var $494a9ea619e2b821$export$dbb7d3295d721851 = function(r) {
    return r instanceof (0, $dktpY.AbstractAccount) ? r.address : r instanceof (0, $dktpY.AbstractContract) ? r.id : r;
}, $494a9ea619e2b821$export$a6be567628c5c293 = function() {
    return (0, $j2rU8.hexlify)((0, $2URXt.randomBytes)(32));
};
var $494a9ea619e2b821$var$a = new (0, $6M65e.Logger)((0, $4jkfR.versions).FUELS), $494a9ea619e2b821$export$73974d1f547d9d48 = /*#__PURE__*/ function _target(F) {
    "use strict";
    (0, $ftJVG._)(e1, F);
    var _super = (0, $6OZAO._)(e1);
    function e1(t) {
        (0, $978gY._)(this, e1);
        var _this;
        var _temp;
        _temp = _this = _super.call(this), (0, $dxWQo._)((0, $3vWwE._)(_this), "bech32Address", void 0), _temp, $494a9ea619e2b821$var$a.checkNew(this instanceof e1 ? this.constructor : void 0, $494a9ea619e2b821$export$73974d1f547d9d48), _this.bech32Address = $494a9ea619e2b821$export$ccd56f82e8d18a37(t), $494a9ea619e2b821$export$82d17b1fbc69cb9c(_this.bech32Address) || $494a9ea619e2b821$var$a.throwArgumentError("Invalid Bech32 Address", "address", t);
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(e1, [
        {
            key: "toAddress",
            value: function toAddress() {
                return this.bech32Address;
            }
        },
        {
            key: "toB256",
            value: function toB256() {
                return $494a9ea619e2b821$export$cbe2a4f03e6317db(this.bech32Address);
            }
        },
        {
            key: "toBytes",
            value: function toBytes() {
                return $494a9ea619e2b821$export$b85e095c1ca2cb8e(this.bech32Address);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this.toB256();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.bech32Address;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.toString();
            }
        },
        {
            key: "valueOf",
            value: function valueOf() {
                return this.toString();
            }
        },
        {
            key: "equals",
            value: function equals(t) {
                return this.bech32Address === t.bech32Address;
            }
        }
    ], [
        {
            key: "fromPublicKey",
            value: function fromPublicKey(t) {
                var b = (0, $7WUQV.sha256)(t);
                return new $494a9ea619e2b821$export$73974d1f547d9d48($494a9ea619e2b821$export$6ca020745d7ad2d4(b));
            }
        },
        {
            key: "fromB256",
            value: function fromB256(t) {
                return new $494a9ea619e2b821$export$73974d1f547d9d48($494a9ea619e2b821$export$6ca020745d7ad2d4(t));
            }
        },
        {
            key: "fromRandom",
            value: function fromRandom() {
                return this.fromB256($494a9ea619e2b821$export$a6be567628c5c293());
            }
        },
        {
            key: "fromString",
            value: function fromString(t) {
                return $494a9ea619e2b821$export$82d17b1fbc69cb9c(t) ? new $494a9ea619e2b821$export$73974d1f547d9d48(t) : this.fromB256(t);
            }
        },
        {
            key: "fromAddressOrString",
            value: function fromAddressOrString(t) {
                return typeof t == "string" ? this.fromString(t) : t;
            }
        },
        {
            key: "fromDynamicInput",
            value: function fromDynamicInput(t) {
                if (typeof t != "string" && "toB256" in t) return $494a9ea619e2b821$export$73974d1f547d9d48.fromB256(t.toB256());
                if ($494a9ea619e2b821$export$992faade6aae4117(t)) return $494a9ea619e2b821$export$73974d1f547d9d48.fromPublicKey(t);
                if ($494a9ea619e2b821$export$82d17b1fbc69cb9c(t)) return new $494a9ea619e2b821$export$73974d1f547d9d48(t);
                if ($494a9ea619e2b821$export$968f081d2e99f915(t)) return $494a9ea619e2b821$export$73974d1f547d9d48.fromB256(t);
                throw new Error("Unknown address format: only Bech32, B256, or Public Key (512) supported");
            }
        }
    ]);
    return e1;
}((0, $dktpY.AbstractAddress));

});
parcelRequire.register("dktpY", function(module, exports) {

$parcel$export(module.exports, "AbstractAddress", function () { return $d6650fdefa59faf4$export$1536044ca35f9e41; });
$parcel$export(module.exports, "AbstractAccount", function () { return $d6650fdefa59faf4$export$6b0b40fb69d75628; });
$parcel$export(module.exports, "AbstractContract", function () { return $d6650fdefa59faf4$export$3afd5d8b0792b80e; });
$parcel$export(module.exports, "AbstractScript", function () { return $d6650fdefa59faf4$export$188f967ad542c90a; });

var $978gY = parcelRequire("978gY");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");
var $d6650fdefa59faf4$export$d9aa12a19c6f18f3 = function s() {
    "use strict";
    (0, $978gY._)(this, s);
}, $d6650fdefa59faf4$export$1536044ca35f9e41 = function r() {
    "use strict";
    (0, $978gY._)(this, r);
}, $d6650fdefa59faf4$export$6b0b40fb69d75628 = function e() {
    "use strict";
    (0, $978gY._)(this, e);
}, $d6650fdefa59faf4$export$44ad41dfeb4e808d = function a() {
    "use strict";
    (0, $978gY._)(this, a);
}, $d6650fdefa59faf4$export$3afd5d8b0792b80e = /*#__PURE__*/ function(a) {
    "use strict";
    (0, $ftJVG._)(n, a);
    var _super = (0, $6OZAO._)(n);
    function n() {
        (0, $978gY._)(this, n);
        return _super.apply(this, arguments);
    }
    return n;
}($d6650fdefa59faf4$export$44ad41dfeb4e808d), $d6650fdefa59faf4$export$188f967ad542c90a = /*#__PURE__*/ function(a) {
    "use strict";
    (0, $ftJVG._)(c, a);
    var _super = (0, $6OZAO._)(c);
    function c() {
        (0, $978gY._)(this, c);
        return _super.apply(this, arguments);
    }
    return c;
}($d6650fdefa59faf4$export$44ad41dfeb4e808d), $d6650fdefa59faf4$export$1198423ac9a9d25d = function d() {
    "use strict";
    (0, $978gY._)(this, d);
};

});

parcelRequire.register("5qruh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bech32m = module.exports.bech32 = void 0;
var $3f34b3e0e081182c$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
var $3f34b3e0e081182c$var$ALPHABET_MAP = {};
for(var $3f34b3e0e081182c$var$z = 0; $3f34b3e0e081182c$var$z < $3f34b3e0e081182c$var$ALPHABET.length; $3f34b3e0e081182c$var$z++){
    var $3f34b3e0e081182c$var$x = $3f34b3e0e081182c$var$ALPHABET.charAt($3f34b3e0e081182c$var$z);
    $3f34b3e0e081182c$var$ALPHABET_MAP[$3f34b3e0e081182c$var$x] = $3f34b3e0e081182c$var$z;
}
function $3f34b3e0e081182c$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1ffffff) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $3f34b3e0e081182c$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $3f34b3e0e081182c$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $3f34b3e0e081182c$var$polymodStep(chk);
    for(var i1 = 0; i1 < prefix.length; ++i1){
        var v = prefix.charCodeAt(i1);
        chk = $3f34b3e0e081182c$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $3f34b3e0e081182c$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $3f34b3e0e081182c$var$toWords(bytes) {
    return $3f34b3e0e081182c$var$convert(bytes, 8, 5, true);
}
function $3f34b3e0e081182c$var$fromWordsUnsafe(words) {
    var res = $3f34b3e0e081182c$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $3f34b3e0e081182c$var$fromWords(words) {
    var res = $3f34b3e0e081182c$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $3f34b3e0e081182c$var$getLibraryFromEncoding(encoding) {
    var encode = function encode(prefix, words, LIMIT) {
        LIMIT = LIMIT || 90;
        if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
        prefix = prefix.toLowerCase();
        // determine chk mod
        var chk = $3f34b3e0e081182c$var$prefixChk(prefix);
        if (typeof chk === "string") throw new Error(chk);
        var result = prefix + "1";
        for(var i = 0; i < words.length; ++i){
            var x = words[i];
            if (x >> 5 !== 0) throw new Error("Non 5-bit word");
            chk = $3f34b3e0e081182c$var$polymodStep(chk) ^ x;
            result += $3f34b3e0e081182c$var$ALPHABET.charAt(x);
        }
        for(var i1 = 0; i1 < 6; ++i1)chk = $3f34b3e0e081182c$var$polymodStep(chk);
        chk ^= ENCODING_CONST;
        for(var i2 = 0; i2 < 6; ++i2){
            var v = chk >> (5 - i2) * 5 & 0x1f;
            result += $3f34b3e0e081182c$var$ALPHABET.charAt(v);
        }
        return result;
    };
    var __decode = function __decode(str, LIMIT) {
        LIMIT = LIMIT || 90;
        if (str.length < 8) return str + " too short";
        if (str.length > LIMIT) return "Exceeds length limit";
        // don't allow mixed case
        var lowered = str.toLowerCase();
        var uppered = str.toUpperCase();
        if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
        str = lowered;
        var split = str.lastIndexOf("1");
        if (split === -1) return "No separator character for " + str;
        if (split === 0) return "Missing prefix for " + str;
        var prefix = str.slice(0, split);
        var wordChars = str.slice(split + 1);
        if (wordChars.length < 6) return "Data too short";
        var chk = $3f34b3e0e081182c$var$prefixChk(prefix);
        if (typeof chk === "string") return chk;
        var words = [];
        for(var i = 0; i < wordChars.length; ++i){
            var c = wordChars.charAt(i);
            var v = $3f34b3e0e081182c$var$ALPHABET_MAP[c];
            if (v === undefined) return "Unknown character " + c;
            chk = $3f34b3e0e081182c$var$polymodStep(chk) ^ v;
            // not in the checksum?
            if (i + 6 >= wordChars.length) continue;
            words.push(v);
        }
        if (chk !== ENCODING_CONST) return "Invalid checksum for " + str;
        return {
            prefix: prefix,
            words: words
        };
    };
    var decodeUnsafe = function decodeUnsafe(str, LIMIT) {
        var res = __decode(str, LIMIT);
        if (typeof res === "object") return res;
    };
    var decode = function decode(str, LIMIT) {
        var res = __decode(str, LIMIT);
        if (typeof res === "object") return res;
        throw new Error(res);
    };
    var ENCODING_CONST;
    if (encoding === "bech32") ENCODING_CONST = 1;
    else ENCODING_CONST = 0x2bc830a3;
    return {
        decodeUnsafe: decodeUnsafe,
        decode: decode,
        encode: encode,
        toWords: $3f34b3e0e081182c$var$toWords,
        fromWordsUnsafe: $3f34b3e0e081182c$var$fromWordsUnsafe,
        fromWords: $3f34b3e0e081182c$var$fromWords
    };
}
module.exports.bech32 = $3f34b3e0e081182c$var$getLibraryFromEncoding("bech32");
module.exports.bech32m = $3f34b3e0e081182c$var$getLibraryFromEncoding("bech32m");

});


parcelRequire.register("9vmss", function(module, exports) {

$parcel$export(module.exports, "ContractFactory", function () { return $f5f45021a7f54dd9$export$505569a6bf584fd9; });

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");

var $j2rU8 = parcelRequire("j2rU8");

var $6M65e = parcelRequire("6M65e");

var $2cJiB = parcelRequire("2cJiB");

var $2URXt = parcelRequire("2URXt");

var $5u9Jw = parcelRequire("5u9Jw");

var $aMiMS = parcelRequire("aMiMS");

var $9aGYB = parcelRequire("9aGYB");

var $4jkfR = parcelRequire("4jkfR");

var $7WUQV = parcelRequire("7WUQV");

var $haENf = parcelRequire("haENf");

var $bGb89 = parcelRequire("bGb89");
var $f5f45021a7f54dd9$var$R = Object.defineProperty;
var $f5f45021a7f54dd9$var$x = function(n, t) {
    for(var o in t)$f5f45021a7f54dd9$var$R(n, o, {
        get: t[o],
        enumerable: !0
    });
};
var $f5f45021a7f54dd9$export$3363a51ad6d1c40d = {};
$f5f45021a7f54dd9$var$x($f5f45021a7f54dd9$export$3363a51ad6d1c40d, {
    getContractId: function() {
        return $f5f45021a7f54dd9$var$p;
    },
    getContractRoot: function() {
        return $f5f45021a7f54dd9$var$b;
    },
    getContractStorageRoot: function() {
        return $f5f45021a7f54dd9$var$m;
    },
    includeHexPrefix: function() {
        return $f5f45021a7f54dd9$var$u;
    }
});
var $f5f45021a7f54dd9$var$b = function(n) {
    var o = [], e = (0, $j2rU8.arrayify)(n);
    for(var r = 0; r < e.length; r += 8){
        var s = new Uint8Array(8);
        s.set(e.slice(r, r + 8)), o.push(s);
    }
    return (0, $haENf.calcRoot)(o.map(function(r) {
        return (0, $j2rU8.hexlify)(r);
    }));
}, $f5f45021a7f54dd9$var$m = function(n) {
    var t = new (0, $bGb89.default);
    return n.forEach(function(param) {
        var o = param.key, e = param.value;
        return t.update(o, e);
    }), t.root;
}, $f5f45021a7f54dd9$var$p = function(n, t, o) {
    var e = $f5f45021a7f54dd9$var$b((0, $j2rU8.arrayify)(n));
    return (0, $7WUQV.sha256)((0, $j2rU8.concat)([
        "0x4655454C",
        t,
        e,
        o
    ]));
}, $f5f45021a7f54dd9$var$u = function(n, t) {
    return (0, $j2rU8.hexlify)(n, (0, $8E768._)((0, $8OnJk._)({}, t), {
        allowMissingPrefix: !0
    }));
};
var $f5f45021a7f54dd9$var$S = new (0, $6M65e.Logger)((0, $4jkfR.versions).FUELS), $f5f45021a7f54dd9$export$505569a6bf584fd9 = /*#__PURE__*/ function() {
    "use strict";
    function a1(t, o) {
        var e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        (0, $978gY._)(this, a1);
        (0, $dxWQo._)(this, "bytecode", void 0);
        (0, $dxWQo._)(this, "interface", void 0);
        (0, $dxWQo._)(this, "provider", void 0);
        (0, $dxWQo._)(this, "account", void 0);
        this.bytecode = (0, $j2rU8.arrayify)(t), o instanceof (0, $2cJiB.Interface) ? this.interface = o : this.interface = new (0, $2cJiB.Interface)(o), e && "provider" in e ? (this.provider = e.provider, this.account = e) : (this.provider = e, this.account = null);
    }
    (0, $kry2a._)(a1, [
        {
            key: "connect",
            value: function connect(t) {
                return new $f5f45021a7f54dd9$export$505569a6bf584fd9(this.bytecode, this.interface, t);
            }
        },
        {
            key: "createTransactionRequest",
            value: function createTransactionRequest(t) {
                var l;
                var o = (l = t == null ? void 0 : t.storageSlots) == null ? void 0 : l.map(function(param) {
                    var c = param.key, i = param.value;
                    return {
                        key: $f5f45021a7f54dd9$var$u(c),
                        value: $f5f45021a7f54dd9$var$u(i)
                    };
                }).sort(function(param, param1) {
                    var c = param.key, i = param1.key;
                    return c.localeCompare(i);
                }), e = (0, $8E768._)((0, $8OnJk._)({
                    salt: (0, $2URXt.randomBytes)(32)
                }, t), {
                    storageSlots: o || []
                }), r = e.stateRoot || $f5f45021a7f54dd9$var$m(e.storageSlots), s = $f5f45021a7f54dd9$var$p(this.bytecode, e.salt, r), f = new (0, $aMiMS.CreateTransactionRequest)((0, $8OnJk._)({
                    gasPrice: 0,
                    gasLimit: (0, $9aGYB.MAX_GAS_PER_TX),
                    bytecodeWitnessIndex: 0,
                    witnesses: [
                        this.bytecode
                    ]
                }, e));
                return f.addContractCreatedOutput(s, r), {
                    contractId: s,
                    transactionRequest: f
                };
            }
        },
        {
            key: "deployContract",
            value: function deployContract() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return (0, $byzP8._)(function() {
                    var o, _this_createTransactionRequest, e, r;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.account) return [
                                    2,
                                    $f5f45021a7f54dd9$var$S.throwArgumentError("Cannot deploy Contract without account", "account", _this.account)
                                ];
                                o = t.configurableConstants;
                                o && _this.setConfigurableConstants(o);
                                _this_createTransactionRequest = _this.createTransactionRequest(t), e = _this_createTransactionRequest.contractId, r = _this_createTransactionRequest.transactionRequest;
                                return [
                                    4,
                                    _this.account.fund(r)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.account.sendTransaction(r)
                                ];
                            case 2:
                                return [
                                    4,
                                    _state.sent().wait()
                                ];
                            case 3:
                                return [
                                    2,
                                    (_state.sent(), new (0, $5u9Jw.Contract)(e, _this.interface, _this.account))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setConfigurableConstants",
            value: function setConfigurableConstants(t) {
                var _this = this;
                try {
                    if (!Object.keys(this.interface.configurables).length) throw new Error("Contract has no configurables to be set");
                    Object.entries(t).forEach(function(param) {
                        var _param = (0, $8GFUW._)(param, 2), e = _param[0], r = _param[1];
                        if (!_this.interface.configurables[e]) throw new Error("Contract has no configurable named: ".concat(e));
                        var _this_interface_configurables_e = _this.interface.configurables[e], s = _this_interface_configurables_e.offset, f = _this_interface_configurables_e.fragmentType, c = _this.interface.abiCoder.getCoder(f).encode(r, s), i = (0, $j2rU8.arrayify)(_this.bytecode);
                        i.set(c, s), _this.bytecode = i;
                    });
                } catch (o) {
                    $f5f45021a7f54dd9$var$S.throwError("Error setting configurables", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                        error: o,
                        configurableConstants: t
                    });
                }
            }
        }
    ]);
    return a1;
}();

});
parcelRequire.register("5u9Jw", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $6c7d4e42ec377c87$export$a7a9523472993e97; });
$parcel$export(module.exports, "ScriptRequest", function () { return $6c7d4e42ec377c87$export$23f136f47bf22736; });
$parcel$export(module.exports, "FunctionInvocationResult", function () { return $6c7d4e42ec377c87$export$aa753d325ed758db; });
$parcel$export(module.exports, "FunctionInvocationScope", function () { return $6c7d4e42ec377c87$export$c6f1b9a4072240a2; });
$parcel$export(module.exports, "Contract", function () { return $6c7d4e42ec377c87$export$8517d80acf00e19a; });

var $3vWwE = parcelRequire("3vWwE");

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $8OnJk = parcelRequire("8OnJk");

var $gPjjc = parcelRequire("gPjjc");

var $ho5gk = parcelRequire("ho5gk");

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $1ObTH = parcelRequire("1ObTH");

var $2TMdq = parcelRequire("2TMdq");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $lcJUd = parcelRequire("lcJUd");

var $6M65e = parcelRequire("6M65e");

var $4jkfR = parcelRequire("4jkfR");

var $9aGYB = parcelRequire("9aGYB");

var $aMiMS = parcelRequire("aMiMS");

var $4x96T = parcelRequire("4x96T");

var $j2rU8 = parcelRequire("j2rU8");

var $2cJiB = parcelRequire("2cJiB");

var $1nhBg = parcelRequire("1nhBg");
var $6c7d4e42ec377c87$var$U = [
    "Success",
    "Revert",
    "OutOfGas",
    "TransactionValidity",
    "MemoryOverflow",
    "ArithmeticOverflow",
    "ContractNotFound",
    "MemoryOwnership",
    "NotEnoughBalance",
    "ExpectedInternalContext",
    "AssetIdNotFound",
    "InputNotFound",
    "OutputNotFound",
    "WitnessNotFound",
    "TransactionMaturity",
    "InvalidMetadataIdentifier",
    "MalformedCallStructure",
    "ReservedRegisterNotWritable",
    "ErrorFlag",
    "InvalidImmediateValue",
    "ExpectedCoinInput",
    "MaxMemoryAccess",
    "MemoryWriteOverlap",
    "ContractNotInInputs",
    "InternalBalanceOverflow",
    "ContractMaxSize",
    "ExpectedUnallocatedStack",
    "MaxStaticContractsReached",
    "TransferAmountCannotBeZero",
    "ExpectedOutputVariable",
    "ExpectedParentInternalContext",
    "IllegalJump",
    "NonZeroMessageOutputRecipient",
    "ZeroedMessageOutputRecipient"
], $6c7d4e42ec377c87$var$x = "https://docs.rs/fuel-asm/latest/fuel_asm/enum.PanicReason.html";
var $6c7d4e42ec377c87$var$e0 = function(r) {
    return $6c7d4e42ec377c87$var$U.includes(r) ? r : "unknown";
}, $6c7d4e42ec377c87$export$81d3477bd73c86ef = function(r) {
    if ((r == null ? void 0 : r.type) === "failure") {
        var t = $6c7d4e42ec377c87$var$e0(r.reason);
        return {
            doc: t !== "unknown" ? "".concat($6c7d4e42ec377c87$var$x, "#variant.").concat(t) : $6c7d4e42ec377c87$var$x,
            reason: t
        };
    }
    return {
        doc: $6c7d4e42ec377c87$var$x,
        reason: "unknown"
    };
};
function $6c7d4e42ec377c87$export$a7a9523472993e97(r, t) {
    if (!r) throw new Error(t);
}
var $6c7d4e42ec377c87$var$_obj;
var $6c7d4e42ec377c87$var$$ = ($6c7d4e42ec377c87$var$_obj = {}, (0, $dxWQo._)($6c7d4e42ec377c87$var$_obj, (0, $9aGYB.FAILED_REQUIRE_SIGNAL), "RequireFailed"), (0, $dxWQo._)($6c7d4e42ec377c87$var$_obj, (0, $9aGYB.FAILED_TRANSFER_TO_ADDRESS_SIGNAL), "TransferToAddressFailed"), (0, $dxWQo._)($6c7d4e42ec377c87$var$_obj, (0, $9aGYB.FAILED_SEND_MESSAGE_SIGNAL), "SendMessageFailed"), (0, $dxWQo._)($6c7d4e42ec377c87$var$_obj, (0, $9aGYB.FAILED_ASSERT_EQ_SIGNAL), "AssertEqFailed"), (0, $dxWQo._)($6c7d4e42ec377c87$var$_obj, (0, $9aGYB.FAILED_ASSERT_SIGNAL), "AssertFailed"), (0, $dxWQo._)($6c7d4e42ec377c87$var$_obj, (0, $9aGYB.FAILED_UNKNOWN_SIGNAL), "Unknown"), $6c7d4e42ec377c87$var$_obj), $6c7d4e42ec377c87$var$c0 = function(r) {
    var t = r.val.toHex();
    return $6c7d4e42ec377c87$var$$[t] ? $6c7d4e42ec377c87$var$$[t] : void 0;
}, $6c7d4e42ec377c87$export$899cedf0f6338d44 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $ftJVG._)(y, Error1);
    var _super = (0, $6OZAO._)(y);
    function y(t, e) {
        (0, $978gY._)(this, y);
        var _this;
        var _temp;
        _temp = _this = _super.call(this, "The script reverted with reason ".concat(e)), (0, $dxWQo._)((0, $3vWwE._)(_this), "receipt", void 0), _temp, _this.name = "RevertError", _this.receipt = t;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(y, [
        {
            key: "toString",
            value: function toString() {
                var _this_receipt = this.receipt, t = _this_receipt.id, e = (0, $gPjjc._)(_this_receipt, [
                    "id"
                ]);
                return "".concat(this.name, ": ").concat(this.message, "\n    ").concat(t, ": ").concat(JSON.stringify(e));
            }
        }
    ]);
    return y;
}((0, $2TMdq._)(Error)), $6c7d4e42ec377c87$export$e7e8ecbfbf8cfe23 = /*#__PURE__*/ function(y) {
    "use strict";
    (0, $ftJVG._)(O, y);
    var _super = (0, $6OZAO._)(O);
    function O(t, e) {
        (0, $978gY._)(this, O);
        var _this;
        _this = _super.call(this, t, e), _this.name = "RequireRevertError";
        return (0, $ho5gk._)(_this);
    }
    return O;
}($6c7d4e42ec377c87$export$899cedf0f6338d44), $6c7d4e42ec377c87$export$4d25f00b28a4dc40 = /*#__PURE__*/ function(y) {
    "use strict";
    (0, $ftJVG._)(D, y);
    var _super = (0, $6OZAO._)(D);
    function D(t, e) {
        (0, $978gY._)(this, D);
        var _this;
        _this = _super.call(this, t, e), _this.name = "TransferToAddressRevertError";
        return (0, $ho5gk._)(_this);
    }
    return D;
}($6c7d4e42ec377c87$export$899cedf0f6338d44), $6c7d4e42ec377c87$export$ea5d3a314491e1f5 = /*#__PURE__*/ function(y) {
    "use strict";
    (0, $ftJVG._)(P, y);
    var _super = (0, $6OZAO._)(P);
    function P(t, e) {
        (0, $978gY._)(this, P);
        var _this;
        _this = _super.call(this, t, e), _this.name = "SendMessageRevertError";
        return (0, $ho5gk._)(_this);
    }
    return P;
}($6c7d4e42ec377c87$export$899cedf0f6338d44), $6c7d4e42ec377c87$export$ebc82e7782871fd0 = /*#__PURE__*/ function(y) {
    "use strict";
    (0, $ftJVG._)(N, y);
    var _super = (0, $6OZAO._)(N);
    function N(t, e) {
        (0, $978gY._)(this, N);
        var _this;
        _this = _super.call(this, t, e), _this.name = "AssertFailedRevertError";
        return (0, $ho5gk._)(_this);
    }
    return N;
}($6c7d4e42ec377c87$export$899cedf0f6338d44), $6c7d4e42ec377c87$export$ebdf888b68348b6 = function(r) {
    var t = $6c7d4e42ec377c87$var$c0(r);
    if (!!t) switch(t){
        case "RequireFailed":
            return new $6c7d4e42ec377c87$export$e7e8ecbfbf8cfe23(r, t);
        case "TransferToAddressFailed":
            return new $6c7d4e42ec377c87$export$4d25f00b28a4dc40(r, t);
        case "SendMessageFailed":
            return new $6c7d4e42ec377c87$export$ea5d3a314491e1f5(r, t);
        case "AssertFailed":
            return new $6c7d4e42ec377c87$export$ebc82e7782871fd0(r, t);
        default:
            return new $6c7d4e42ec377c87$export$899cedf0f6338d44(r, t);
    }
};
var $6c7d4e42ec377c87$var$d0 = new (0, $6M65e.Logger)((0, $4jkfR.versions).FUELS), $6c7d4e42ec377c87$var$m0 = function(r) {
    return r.filter(function(t) {
        return t.type === (0, $lcJUd.ReceiptType).Revert;
    });
}, $6c7d4e42ec377c87$var$w = /*#__PURE__*/ function() {
    "use strict";
    function w(t) {
        (0, $978gY._)(this, w);
        (0, $dxWQo._)(this, "revertReceipts", void 0);
        this.revertReceipts = $6c7d4e42ec377c87$var$m0(t);
    }
    (0, $kry2a._)(w, [
        {
            key: "assert",
            value: function assert(t) {
                var e = this.getError();
                if (e) throw e.cause = t, e;
            }
        },
        {
            key: "getError",
            value: function getError() {
                if (!!this.revertReceipts.length) return this.revertReceipts.length !== 1 && $6c7d4e42ec377c87$var$d0.warn("Multiple revert receipts found, expected one. Receipts:", JSON.stringify(this.revertReceipts)), $6c7d4e42ec377c87$export$ebdf888b68348b6(this.revertReceipts[0]);
            }
        }
    ]);
    return w;
}();
var $6c7d4e42ec377c87$var$y0 = function(r, t) {
    return (typeof t === "undefined" ? "undefined" : (0, $1ObTH._)(t)) == "bigint" ? t.toString() : t;
}, $6c7d4e42ec377c87$export$9fcf075caf165082 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $ftJVG._)(_, Error1);
    var _super = (0, $6OZAO._)(_);
    function _(t, e, n) {
        (0, $978gY._)(this, _);
        var _this;
        var o = JSON.stringify($6c7d4e42ec377c87$export$81d3477bd73c86ef(t.status), null, 2), a = n.length ? "Logs:\n".concat(JSON.stringify(n, null, 2)) : null, p = "Receipts:\n".concat(JSON.stringify(t.receipts.map(function(_param) {
            var s = _param.type, l = (0, $gPjjc._)(_param, [
                "type"
            ]);
            return (0, $8OnJk._)({
                type: (0, $lcJUd.ReceiptType)[s]
            }, l);
        }), $6c7d4e42ec377c87$var$y0, 2));
        var _temp;
        _temp = _this = _super.call(this, "".concat(e, "\n\n").concat(o, "\n\n").concat(a ? "".concat(a, "\n\n") : "").concat(p)), (0, $dxWQo._)((0, $3vWwE._)(_this), "logs", void 0), _temp, _this.logs = n, new $6c7d4e42ec377c87$var$w(t.receipts).assert((0, $3vWwE._)(_this));
        return (0, $ho5gk._)(_this);
    }
    return _;
}((0, $2TMdq._)(Error));
var $6c7d4e42ec377c87$var$q = [
    {
        type: "function",
        inputs: [
            {
                name: "script_data",
                type: "struct ScriptData",
                components: [
                    {
                        name: "calls",
                        type: "[enum Option; 5]",
                        components: [
                            {
                                name: "__array_element",
                                type: "enum Option",
                                components: [
                                    {
                                        name: "None",
                                        type: "()",
                                        components: [],
                                        typeArguments: null
                                    },
                                    {
                                        name: "Some",
                                        type: "struct MulticallCall",
                                        components: [
                                            {
                                                name: "contract_id",
                                                type: "struct ContractId",
                                                components: [
                                                    {
                                                        name: "value",
                                                        type: "b256",
                                                        components: null,
                                                        typeArguments: null
                                                    }
                                                ],
                                                typeArguments: null
                                            },
                                            {
                                                name: "fn_selector",
                                                type: "u64",
                                                components: null,
                                                typeArguments: null
                                            },
                                            {
                                                name: "fn_arg",
                                                type: "enum CallValue",
                                                components: [
                                                    {
                                                        name: "Value",
                                                        type: "u64",
                                                        components: null,
                                                        typeArguments: null
                                                    },
                                                    {
                                                        name: "Data",
                                                        type: "(u64, u64)",
                                                        components: [
                                                            {
                                                                name: "__tuple_element",
                                                                type: "u64",
                                                                components: null,
                                                                typeArguments: null
                                                            },
                                                            {
                                                                name: "__tuple_element",
                                                                type: "u64",
                                                                components: null,
                                                                typeArguments: null
                                                            }
                                                        ],
                                                        typeArguments: null
                                                    }
                                                ],
                                                typeArguments: null
                                            },
                                            {
                                                name: "parameters",
                                                type: "struct CallParameters",
                                                components: [
                                                    {
                                                        name: "amount",
                                                        type: "enum Option",
                                                        components: [
                                                            {
                                                                name: "None",
                                                                type: "()",
                                                                components: [],
                                                                typeArguments: null
                                                            },
                                                            {
                                                                name: "Some",
                                                                type: "u64",
                                                                components: null,
                                                                typeArguments: null
                                                            }
                                                        ],
                                                        typeArguments: [
                                                            {
                                                                name: "T",
                                                                type: "u64",
                                                                components: null,
                                                                typeArguments: null
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        name: "asset_id",
                                                        type: "enum Option",
                                                        components: [
                                                            {
                                                                name: "None",
                                                                type: "()",
                                                                components: [],
                                                                typeArguments: null
                                                            },
                                                            {
                                                                name: "Some",
                                                                type: "struct ContractId",
                                                                components: [
                                                                    {
                                                                        name: "value",
                                                                        type: "b256",
                                                                        components: null,
                                                                        typeArguments: null
                                                                    }
                                                                ],
                                                                typeArguments: null
                                                            }
                                                        ],
                                                        typeArguments: [
                                                            {
                                                                name: "T",
                                                                type: "struct ContractId",
                                                                components: [
                                                                    {
                                                                        name: "value",
                                                                        type: "b256",
                                                                        components: null,
                                                                        typeArguments: null
                                                                    }
                                                                ],
                                                                typeArguments: null
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        name: "gas",
                                                        type: "enum Option",
                                                        components: [
                                                            {
                                                                name: "None",
                                                                type: "()",
                                                                components: [],
                                                                typeArguments: null
                                                            },
                                                            {
                                                                name: "Some",
                                                                type: "u64",
                                                                components: null,
                                                                typeArguments: null
                                                            }
                                                        ],
                                                        typeArguments: [
                                                            {
                                                                name: "T",
                                                                type: "u64",
                                                                components: null,
                                                                typeArguments: null
                                                            }
                                                        ]
                                                    }
                                                ],
                                                typeArguments: null
                                            }
                                        ],
                                        typeArguments: null
                                    }
                                ],
                                typeArguments: [
                                    {
                                        name: "T",
                                        type: "struct MulticallCall",
                                        components: [
                                            {
                                                name: "contract_id",
                                                type: "struct ContractId",
                                                components: [
                                                    {
                                                        name: "value",
                                                        type: "b256",
                                                        components: null,
                                                        typeArguments: null
                                                    }
                                                ],
                                                typeArguments: null
                                            },
                                            {
                                                name: "fn_selector",
                                                type: "u64",
                                                components: null,
                                                typeArguments: null
                                            },
                                            {
                                                name: "fn_arg",
                                                type: "enum CallValue",
                                                components: [
                                                    {
                                                        name: "Value",
                                                        type: "u64",
                                                        components: null,
                                                        typeArguments: null
                                                    },
                                                    {
                                                        name: "Data",
                                                        type: "(u64, u64)",
                                                        components: [
                                                            {
                                                                name: "__tuple_element",
                                                                type: "u64",
                                                                components: null,
                                                                typeArguments: null
                                                            },
                                                            {
                                                                name: "__tuple_element",
                                                                type: "u64",
                                                                components: null,
                                                                typeArguments: null
                                                            }
                                                        ],
                                                        typeArguments: null
                                                    }
                                                ],
                                                typeArguments: null
                                            },
                                            {
                                                name: "parameters",
                                                type: "struct CallParameters",
                                                components: [
                                                    {
                                                        name: "amount",
                                                        type: "enum Option",
                                                        components: [
                                                            {
                                                                name: "None",
                                                                type: "()",
                                                                components: [],
                                                                typeArguments: null
                                                            },
                                                            {
                                                                name: "Some",
                                                                type: "u64",
                                                                components: null,
                                                                typeArguments: null
                                                            }
                                                        ],
                                                        typeArguments: [
                                                            {
                                                                name: "T",
                                                                type: "u64",
                                                                components: null,
                                                                typeArguments: null
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        name: "asset_id",
                                                        type: "enum Option",
                                                        components: [
                                                            {
                                                                name: "None",
                                                                type: "()",
                                                                components: [],
                                                                typeArguments: null
                                                            },
                                                            {
                                                                name: "Some",
                                                                type: "struct ContractId",
                                                                components: [
                                                                    {
                                                                        name: "value",
                                                                        type: "b256",
                                                                        components: null,
                                                                        typeArguments: null
                                                                    }
                                                                ],
                                                                typeArguments: null
                                                            }
                                                        ],
                                                        typeArguments: [
                                                            {
                                                                name: "T",
                                                                type: "struct ContractId",
                                                                components: [
                                                                    {
                                                                        name: "value",
                                                                        type: "b256",
                                                                        components: null,
                                                                        typeArguments: null
                                                                    }
                                                                ],
                                                                typeArguments: null
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        name: "gas",
                                                        type: "enum Option",
                                                        components: [
                                                            {
                                                                name: "None",
                                                                type: "()",
                                                                components: [],
                                                                typeArguments: null
                                                            },
                                                            {
                                                                name: "Some",
                                                                type: "u64",
                                                                components: null,
                                                                typeArguments: null
                                                            }
                                                        ],
                                                        typeArguments: [
                                                            {
                                                                name: "T",
                                                                type: "u64",
                                                                components: null,
                                                                typeArguments: null
                                                            }
                                                        ]
                                                    }
                                                ],
                                                typeArguments: null
                                            }
                                        ],
                                        typeArguments: null
                                    }
                                ]
                            }
                        ],
                        typeArguments: null
                    }
                ],
                typeArguments: null
            }
        ],
        name: "main",
        outputs: [
            {
                name: "",
                type: "struct ScriptReturn",
                components: [
                    {
                        name: "call_returns",
                        type: "[enum Option; 5]",
                        components: [
                            {
                                name: "__array_element",
                                type: "enum Option",
                                components: [
                                    {
                                        name: "None",
                                        type: "()",
                                        components: [],
                                        typeArguments: null
                                    },
                                    {
                                        name: "Some",
                                        type: "enum CallValue",
                                        components: [
                                            {
                                                name: "Value",
                                                type: "u64",
                                                components: null,
                                                typeArguments: null
                                            },
                                            {
                                                name: "Data",
                                                type: "(u64, u64)",
                                                components: [
                                                    {
                                                        name: "__tuple_element",
                                                        type: "u64",
                                                        components: null,
                                                        typeArguments: null
                                                    },
                                                    {
                                                        name: "__tuple_element",
                                                        type: "u64",
                                                        components: null,
                                                        typeArguments: null
                                                    }
                                                ],
                                                typeArguments: null
                                            }
                                        ],
                                        typeArguments: null
                                    }
                                ],
                                typeArguments: [
                                    {
                                        name: "T",
                                        type: "enum CallValue",
                                        components: [
                                            {
                                                name: "Value",
                                                type: "u64",
                                                components: null,
                                                typeArguments: null
                                            },
                                            {
                                                name: "Data",
                                                type: "(u64, u64)",
                                                components: [
                                                    {
                                                        name: "__tuple_element",
                                                        type: "u64",
                                                        components: null,
                                                        typeArguments: null
                                                    },
                                                    {
                                                        name: "__tuple_element",
                                                        type: "u64",
                                                        components: null,
                                                        typeArguments: null
                                                    }
                                                ],
                                                typeArguments: null
                                            }
                                        ],
                                        typeArguments: null
                                    }
                                ]
                            }
                        ],
                        typeArguments: null
                    }
                ],
                typeArguments: null
            }
        ]
    }
];
var $6c7d4e42ec377c87$var$G = "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";
var $6c7d4e42ec377c87$var$W = new (0, $6M65e.Logger)((0, $4jkfR.versions).FUELS);
function $6c7d4e42ec377c87$var$b0(r) {
    var t = (0, $fLnyw._)(r.receipts), e, n;
    if (t.forEach(function(a) {
        a.type === (0, $lcJUd.ReceiptType).ScriptResult ? e = a : (a.type === (0, $lcJUd.ReceiptType).Return || a.type === (0, $lcJUd.ReceiptType).ReturnData || a.type === (0, $lcJUd.ReceiptType).Revert) && (n = a);
    }), !e) throw new Error("Expected scriptResultReceipt");
    if (!n) throw new Error("Expected returnReceipt");
    return {
        code: e.result,
        gasUsed: e.gasUsed,
        receipts: t,
        scriptResultReceipt: e,
        returnReceipt: n,
        callResult: r
    };
}
function $6c7d4e42ec377c87$var$J(r, t) {
    var e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    try {
        var _$n = $6c7d4e42ec377c87$var$b0(r);
        return t(_$n);
    } catch (n) {
        throw new $6c7d4e42ec377c87$export$9fcf075caf165082(r, n.message, e);
    }
}
function $6c7d4e42ec377c87$var$X(r, t, e) {
    return $6c7d4e42ec377c87$var$J(r, function(n) {
        n.returnReceipt.type === (0, $lcJUd.ReceiptType).Revert && $6c7d4e42ec377c87$var$W.throwError("Script Reverted", (0, $6M65e.Logger).errors.CALL_EXCEPTION, e), n.returnReceipt.type !== (0, $lcJUd.ReceiptType).Return && n.returnReceipt.type !== (0, $lcJUd.ReceiptType).ReturnData && $6c7d4e42ec377c87$var$W.throwError("Script Return Type [".concat(n.returnReceipt.type, "] Invalid"), (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
            logs: e,
            receipt: n.returnReceipt
        });
        var o;
        return n.returnReceipt.type === (0, $lcJUd.ReceiptType).Return && (o = n.returnReceipt.val), n.returnReceipt.type === (0, $lcJUd.ReceiptType).ReturnData && (o = t.program.interface.decodeFunctionResult(t.func, n.returnReceipt.data)[0]), o;
    }, e);
}
var $6c7d4e42ec377c87$export$23f136f47bf22736 = /*#__PURE__*/ function() {
    "use strict";
    function T(t, e, n) {
        (0, $978gY._)(this, T);
        (0, $dxWQo._)(this, "bytes", void 0);
        (0, $dxWQo._)(this, "scriptDataEncoder", void 0);
        (0, $dxWQo._)(this, "scriptResultDecoder", void 0);
        this.bytes = (0, $j2rU8.arrayify)(t), this.scriptDataEncoder = e, this.scriptResultDecoder = n;
    }
    (0, $kry2a._)(T, [
        {
            key: "getScriptDataOffset",
            value: function getScriptDataOffset() {
                return (0, $2cJiB.VM_TX_MEMORY) + (0, $2cJiB.TRANSACTION_SCRIPT_FIXED_SIZE) + new (0, $lcJUd.ByteArrayCoder)(this.bytes.length).encodedLength;
            }
        },
        {
            key: "getArgOffset",
            value: function getArgOffset() {
                return this.getScriptDataOffset() + (0, $2cJiB.ASSET_ID_LEN) + (0, $2cJiB.WORD_SIZE) + (0, $2cJiB.CONTRACT_ID_LEN) + (0, $2cJiB.WORD_SIZE) + (0, $2cJiB.WORD_SIZE);
            }
        },
        {
            key: "encodeScriptData",
            value: function encodeScriptData(t) {
                return this.scriptDataEncoder(t);
            }
        },
        {
            key: "decodeCallResult",
            value: function decodeCallResult(t) {
                var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                return $6c7d4e42ec377c87$var$J(t, this.scriptResultDecoder, e);
            }
        }
    ]);
    return T;
}();
var $6c7d4e42ec377c87$var$v = new $6c7d4e42ec377c87$export$23f136f47bf22736($6c7d4e42ec377c87$var$G, function(r) {
    var t = $6c7d4e42ec377c87$var$q[0].inputs, e = new (0, $2cJiB.AbiCoder)().getCoder(t[0]), n = e.coders.calls.length;
    if (r.length > n) throw new Error("At most ".concat(n, " calls are supported"));
    var o = new Uint8Array, a = [];
    for(var l = 0; l < n; l += 1){
        var i = r[l], d = void 0;
        if (i) {
            var A = (0, $j2rU8.arrayify)(i.data), L = void 0;
            i.isDataPointer ? (L = {
                Data: [
                    o.length,
                    A.length
                ]
            }, o = (0, $j2rU8.concat)([
                o,
                A
            ])) : L = {
                Value: new (0, $2cJiB.U64Coder)().decode(A, 0)[0]
            }, d = {
                contract_id: {
                    value: i.contractId
                },
                fn_selector: (0, $4x96T.bn)(i.fnSelector),
                fn_arg: L,
                parameters: {
                    amount: i.amount ? (0, $4x96T.bn)(i.amount) : void 0,
                    asset_id: i.assetId ? {
                        value: i.assetId
                    } : void 0,
                    gas: i.gas ? (0, $4x96T.bn)(i.gas) : void 0
                }
            };
        } else d = void 0;
        a.push(d);
    }
    var p = {
        calls: a
    }, s = e.encode(p);
    return (0, $j2rU8.concat)([
        s,
        o
    ]);
}, function(r) {
    if ((0, $4x96T.toNumber)(r.code) !== 0) throw new Error("Script returned non-zero result: ".concat(r.code));
    if (r.returnReceipt.type !== (0, $lcJUd.ReceiptType).ReturnData) throw new Error("Expected returnReceipt to be a ReturnDataReceipt");
    var t = (0, $j2rU8.arrayify)(r.returnReceipt.data), e = $6c7d4e42ec377c87$var$q[0].outputs, n = new (0, $2cJiB.AbiCoder)().getCoder(e[0]), _n_decode = (0, $8GFUW._)(n.decode(t, 0), 2), o = _n_decode[0], a = _n_decode[1], p = t.slice(a), s = [];
    return o.call_returns.forEach(function(l, i) {
        if (l) {
            if (l.Data) {
                var _l_Data = (0, $8GFUW._)(l.Data, 2), d = _l_Data[0], A = _l_Data[1];
                s[i] = p.slice((0, $4x96T.toNumber)(d), (0, $4x96T.toNumber)(d) + (0, $4x96T.toNumber)(A));
            } else s[i] = new (0, $2cJiB.U64Coder)().encode(l.Value);
        }
    }), s;
});
function $6c7d4e42ec377c87$var$E0(r) {
    var t = r.receipts.find(function(e) {
        return e.type === (0, $lcJUd.ReceiptType).ScriptResult;
    });
    return (t == null ? void 0 : t.gasUsed) || (0, $4x96T.bn)(0);
}
var $6c7d4e42ec377c87$export$eb2407482e74476e = /*#__PURE__*/ function() {
    "use strict";
    function S(t, e, n) {
        (0, $978gY._)(this, S);
        (0, $dxWQo._)(this, "functionScopes", void 0);
        (0, $dxWQo._)(this, "isMultiCall", void 0);
        (0, $dxWQo._)(this, "gasUsed", void 0);
        (0, $dxWQo._)(this, "value", void 0);
        this.functionScopes = Array.isArray(t) ? t : [
            t
        ], this.isMultiCall = n, this.value = this.getDecodedValue(e), this.gasUsed = $6c7d4e42ec377c87$var$E0(e);
    }
    (0, $kry2a._)(S, [
        {
            key: "getFirstCallConfig",
            value: function getFirstCallConfig() {
                if (!!this.functionScopes[0]) return this.functionScopes[0].getCallConfig();
            }
        },
        {
            key: "getDecodedValue",
            value: function getDecodedValue(t) {
                var _this = this;
                var e = this.getDecodedLogs(t.receipts), n = this.getFirstCallConfig();
                if (this.functionScopes.length === 1 && n && "bytes" in n.program) return $6c7d4e42ec377c87$var$X(t, n, e);
                var a = $6c7d4e42ec377c87$var$v.decodeCallResult(t, e).map(function(p, s) {
                    var d;
                    var _this_functionScopes_s_getCallConfig = _this.functionScopes[s].getCallConfig(), l = _this_functionScopes_s_getCallConfig.program, i = _this_functionScopes_s_getCallConfig.func;
                    return (d = l.interface.decodeFunctionResult(i, p)) == null ? void 0 : d[0];
                });
                return this.isMultiCall ? a : a == null ? void 0 : a[0];
            }
        },
        {
            key: "getDecodedLogs",
            value: function getDecodedLogs(t) {
                var e = this.getFirstCallConfig();
                if (!e) return [];
                var n = e.program;
                return (0, $aMiMS.getDecodedLogs)(t, n.interface);
            }
        }
    ]);
    return S;
}(), $6c7d4e42ec377c87$export$aa753d325ed758db = /*#__PURE__*/ function(S) {
    "use strict";
    (0, $ftJVG._)(R1, S);
    var _super = (0, $6OZAO._)(R1);
    function R1(t, e, n, o, a) {
        (0, $978gY._)(this, R1);
        var _this;
        var _temp;
        _temp = _this = _super.call(this, t, n, a), (0, $dxWQo._)((0, $3vWwE._)(_this), "transactionId", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "transactionResponse", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "transactionResult", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "program", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "logs", void 0), _temp, _this.transactionResponse = e, _this.transactionResult = n, _this.transactionId = _this.transactionResponse.id, _this.program = o, _this.logs = _this.getDecodedLogs(n.receipts);
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(R1, null, [
        {
            key: "build",
            value: function build(t, e, n, o) {
                return (0, $byzP8._)(function() {
                    var a;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    e.waitForResult()
                                ];
                            case 1:
                                a = _state.sent();
                                return [
                                    2,
                                    new $6c7d4e42ec377c87$export$aa753d325ed758db(t, e, a, o, n)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return R1;
}($6c7d4e42ec377c87$export$eb2407482e74476e), $6c7d4e42ec377c87$var$g = /*#__PURE__*/ function(S) {
    "use strict";
    (0, $ftJVG._)(g1, S);
    var _super = (0, $6OZAO._)(g1);
    function g1(t, e, n) {
        (0, $978gY._)(this, g1);
        var _this;
        var _temp;
        _temp = _this = _super.call(this, t, e, n), (0, $dxWQo._)((0, $3vWwE._)(_this), "callResult", void 0), _temp, _this.callResult = e;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(g1, null, [
        {
            key: "build",
            value: function build(t, e, n) {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    new $6c7d4e42ec377c87$var$g(t, e, n)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return g1;
}($6c7d4e42ec377c87$export$eb2407482e74476e);
function $6c7d4e42ec377c87$var$D0(r) {
    var _r_getCallConfig = r.getCallConfig(), t = _r_getCallConfig.program, e = _r_getCallConfig.args, n = _r_getCallConfig.forward, o = _r_getCallConfig.func, a = _r_getCallConfig.callParameters, p = _r_getCallConfig.bytesOffset, s = o.encodeArguments(e, $6c7d4e42ec377c87$var$v.getScriptDataOffset() + p);
    return {
        contractId: t.id,
        fnSelector: o.getSelector(),
        data: s,
        isDataPointer: o.isInputDataPointer(),
        assetId: n == null ? void 0 : n.assetId,
        amount: n == null ? void 0 : n.amount,
        gas: a == null ? void 0 : a.gasLimit
    };
}
var $6c7d4e42ec377c87$var$f = /*#__PURE__*/ function() {
    "use strict";
    function f1(t, e) {
        (0, $978gY._)(this, f1);
        (0, $dxWQo._)(this, "transactionRequest", void 0);
        (0, $dxWQo._)(this, "program", void 0);
        (0, $dxWQo._)(this, "functionInvocationScopes", []);
        (0, $dxWQo._)(this, "txParameters", void 0);
        (0, $dxWQo._)(this, "requiredCoins", []);
        (0, $dxWQo._)(this, "isMultiCall", !1);
        this.program = t, this.isMultiCall = e, this.transactionRequest = new (0, $aMiMS.ScriptTransactionRequest)({
            gasLimit: (0, $9aGYB.MAX_GAS_PER_TX)
        });
    }
    (0, $kry2a._)(f1, [
        {
            key: "calls",
            get: function get() {
                return this.functionInvocationScopes.map(function(t) {
                    return $6c7d4e42ec377c87$var$D0(t);
                });
            }
        },
        {
            key: "updateScriptRequest",
            value: function updateScriptRequest() {
                var _this = this;
                var t = this.calls;
                t.forEach(function(e) {
                    _this.transactionRequest.addContract(e.contractId);
                }), this.transactionRequest.setScript($6c7d4e42ec377c87$var$v, t);
            }
        },
        {
            key: "getRequiredCoins",
            value: function getRequiredCoins() {
                return this.calls.map(function(e) {
                    return {
                        assetId: String(e.assetId),
                        amount: (0, $4x96T.bn)(e.amount || 0)
                    };
                }).concat(this.transactionRequest.calculateFee()).filter(function(param) {
                    var e = param.assetId, n = param.amount;
                    return e && !(0, $4x96T.bn)(n).isZero();
                });
            }
        },
        {
            key: "updateRequiredCoins",
            value: function updateRequiredCoins() {
                var t = this.getRequiredCoins(), e = function(n, param) {
                    var o = param.assetId, a = param.amount;
                    var s;
                    var p = ((s = n.get(o)) == null ? void 0 : s.amount) || (0, $4x96T.bn)(0);
                    return n.set(o, {
                        assetId: String(o),
                        amount: p.add(a)
                    });
                };
                this.requiredCoins = Array.from(t.reduce(e, new Map).values());
            }
        },
        {
            key: "addCall",
            value: function addCall(t) {
                return this.addCalls([
                    t
                ]), this;
            }
        },
        {
            key: "addCalls",
            value: function addCalls(t) {
                var _this_functionInvocationScopes;
                return (_this_functionInvocationScopes = this.functionInvocationScopes).push.apply(_this_functionInvocationScopes, (0, $fLnyw._)(t)), this.updateScriptRequest(), this.updateRequiredCoins(), this;
            }
        },
        {
            key: "prepareTransaction",
            value: function prepareTransaction(t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _tmp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.updateScriptRequest(), _this.updateRequiredCoins(), _this.checkGasLimitTotal();
                                _tmp = $6c7d4e42ec377c87$var$f.getCallOptions(t).fundTransaction && _this.program.account;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.fundWithRequiredCoins()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkGasLimitTotal",
            value: function checkGasLimitTotal() {
                if (this.calls.reduce(function(e, n) {
                    return e.add(n.gas || 0);
                }, (0, $4x96T.bn)(0)).gt(this.transactionRequest.gasLimit)) throw new Error("Transaction gasLimit can't be lower than the sum of the forwarded gas of each call");
            }
        },
        {
            key: "getTransactionCost",
            value: function getTransactionCost(t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var a, e, n;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = ((a = _this.program.account) == null ? void 0 : a.provider) || _this.program.provider;
                                $6c7d4e42ec377c87$export$a7a9523472993e97(e, "Wallet or Provider is required!");
                                return [
                                    4,
                                    _this.prepareTransaction(t)
                                ];
                            case 1:
                                _state.sent();
                                n = (0, $aMiMS.transactionRequestify)(_this.transactionRequest);
                                n.gasPrice = (0, $4x96T.bn)((0, $4x96T.toNumber)(n.gasPrice) || (0, $4x96T.toNumber)((t == null ? void 0 : t.gasPrice) || 0));
                                return [
                                    4,
                                    e.getTransactionCost(n, t == null ? void 0 : t.tolerance)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fundWithRequiredCoins",
            value: function fundWithRequiredCoins() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var e, t;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.transactionRequest.inputs = _this.transactionRequest.inputs.filter(function(n) {
                                    return n.type !== (0, $lcJUd.InputType).Coin;
                                });
                                return [
                                    4,
                                    (e = _this.program.account) == null ? void 0 : e.getResourcesToSpend(_this.requiredCoins)
                                ];
                            case 1:
                                t = _state.sent();
                                return [
                                    2,
                                    (_this.transactionRequest.addResources(t || []), _this)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "txParams",
            value: function txParams(t) {
                var n;
                this.txParameters = t;
                var e = this.transactionRequest;
                return e.gasLimit = (0, $4x96T.bn)(t.gasLimit || e.gasLimit), e.gasPrice = (0, $4x96T.bn)(t.gasPrice || e.gasPrice), e.addVariableOutputs(((n = this.txParameters) == null ? void 0 : n.variableOutputs) || 0), this;
            }
        },
        {
            key: "addContracts",
            value: function addContracts(t) {
                var _this = this;
                return t.forEach(function(e) {
                    _this.transactionRequest.addContract(e.id), _this.program.interface.updateExternalLoggedTypes(e.id.toB256(), (0, $fLnyw._)(e.interface.loggedTypes));
                }), this;
            }
        },
        {
            key: "getTransactionRequest",
            value: function getTransactionRequest(t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.prepareTransaction(t)
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), _this.transactionRequest)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "call",
            value: function call(t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var e, n;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $6c7d4e42ec377c87$export$a7a9523472993e97(_this.program.account, "Wallet is required!");
                                return [
                                    4,
                                    _this.getTransactionRequest(t)
                                ];
                            case 1:
                                e = _state.sent();
                                return [
                                    4,
                                    _this.program.account.sendTransaction(e)
                                ];
                            case 2:
                                n = _state.sent();
                                return [
                                    2,
                                    $6c7d4e42ec377c87$export$aa753d325ed758db.build(_this.functionInvocationScopes, n, _this.isMultiCall, _this.program)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "simulate",
            value: function simulate(t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var e, n;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $6c7d4e42ec377c87$export$a7a9523472993e97(_this.program.account, "Wallet is required!");
                                return [
                                    4,
                                    _this.getTransactionRequest(t)
                                ];
                            case 1:
                                e = _state.sent();
                                return [
                                    4,
                                    _this.program.account.simulateTransaction(e)
                                ];
                            case 2:
                                n = _state.sent();
                                return [
                                    2,
                                    $6c7d4e42ec377c87$var$g.build(_this.functionInvocationScopes, n, _this.isMultiCall)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "dryRun",
            value: function dryRun(t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var s, e, n, o, a;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = ((s = _this.program.account) == null ? void 0 : s.provider) || _this.program.provider;
                                $6c7d4e42ec377c87$export$a7a9523472993e97(e, "Wallet or Provider is required!");
                                return [
                                    4,
                                    _this.getTransactionRequest(t)
                                ];
                            case 1:
                                n = _state.sent(), o = (0, $aMiMS.transactionRequestify)(n);
                                return [
                                    4,
                                    e.call(o, {
                                        utxoValidation: !1
                                    })
                                ];
                            case 2:
                                a = _state.sent();
                                return [
                                    4,
                                    $6c7d4e42ec377c87$var$g.build(_this.functionInvocationScopes, a, _this.isMultiCall)
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "get",
            value: function get(t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.dryRun((0, $8OnJk._)({
                                fundTransaction: !1
                            }, t))
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "getCallOptions",
            value: function getCallOptions(t) {
                return (0, $8OnJk._)({
                    fundTransaction: !0
                }, t);
            }
        }
    ]);
    return f1;
}();
var $6c7d4e42ec377c87$export$c6f1b9a4072240a2 = /*#__PURE__*/ function(f) {
    "use strict";
    (0, $ftJVG._)(b, f);
    var _super = (0, $6OZAO._)(b);
    function b(t, e, n) {
        (0, $978gY._)(this, b);
        var _this;
        var _temp;
        _temp = _this = _super.call(this, t, !1), (0, $dxWQo._)((0, $3vWwE._)(_this), "func", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "callParameters", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "forward", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "args", void 0), _temp, _this.func = e, _this.args = n || [], _this.setArguments.apply(_this, (0, $fLnyw._)(n)), (0, $3cct3._)(((0, $3vWwE._)(_this), (0, $g3d7z._)(b.prototype)), "addCall", _this).call(_this, (0, $3vWwE._)(_this));
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(b, [
        {
            key: "getCallConfig",
            value: function getCallConfig() {
                return {
                    func: this.func,
                    program: this.program,
                    callParameters: this.callParameters,
                    txParameters: this.txParameters,
                    forward: this.forward,
                    args: this.args,
                    bytesOffset: this.transactionRequest.bytesOffset || 0
                };
            }
        },
        {
            key: "setArguments",
            value: function setArguments() {
                for(var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++){
                    t[_key] = arguments[_key];
                }
                return this.args = t || [], this.updateScriptRequest(), this;
            }
        },
        {
            key: "callParams",
            value: function callParams(t) {
                if (this.callParameters = t, t != null && t.forward) {
                    if (!this.func.attributes.find(function(e) {
                        return e.name === "payable";
                    })) throw new Error("Function is not payable.");
                    this.forward = (0, $aMiMS.coinQuantityfy)(t.forward);
                }
                return this.setArguments.apply(this, (0, $fLnyw._)(this.args)), this.updateRequiredCoins(), this;
            }
        }
    ]);
    return b;
}($6c7d4e42ec377c87$var$f);
var $6c7d4e42ec377c87$export$5e250d3cb9452943 = /*#__PURE__*/ function(f) {
    "use strict";
    (0, $ftJVG._)(I, f);
    var _super = (0, $6OZAO._)(I);
    function I(t, e) {
        (0, $978gY._)(this, I);
        var _this;
        _this = _super.call(this, t, !0), _this.addCalls(e);
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(I, [
        {
            key: "addCall",
            value: function addCall(t) {
                return (0, $3cct3._)((0, $g3d7z._)(I.prototype), "addCalls", this).call(this, [
                    t
                ]);
            }
        },
        {
            key: "addCalls",
            value: function addCalls(t) {
                return (0, $3cct3._)((0, $g3d7z._)(I.prototype), "addCalls", this).call(this, t);
            }
        }
    ]);
    return I;
}($6c7d4e42ec377c87$var$f);
var $6c7d4e42ec377c87$export$8517d80acf00e19a = /*#__PURE__*/ function() {
    "use strict";
    function F(t, e, n) {
        var _this = this;
        (0, $978gY._)(this, F);
        (0, $dxWQo._)(this, "id", void 0);
        (0, $dxWQo._)(this, "provider", void 0);
        (0, $dxWQo._)(this, "interface", void 0);
        (0, $dxWQo._)(this, "account", void 0);
        (0, $dxWQo._)(this, "functions", {});
        this.interface = e instanceof (0, $2cJiB.Interface) ? e : new (0, $2cJiB.Interface)(e), this.id = (0, $1nhBg.Address).fromAddressOrString(t), n && "provider" in n ? (this.provider = n.provider, this.account = n) : (this.provider = n, this.account = null), Object.keys(this.interface.functions).forEach(function(o) {
            var a = _this.interface.getFunction(o);
            Object.defineProperty(_this.functions, a.name, {
                value: _this.buildFunction(a),
                writable: !1
            });
        });
    }
    (0, $kry2a._)(F, [
        {
            key: "buildFunction",
            value: function buildFunction(t) {
                var _this = this;
                return function() {
                    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
                        e[_key] = arguments[_key];
                    }
                    return new $6c7d4e42ec377c87$export$c6f1b9a4072240a2(_this, t, e);
                };
            }
        },
        {
            key: "multiCall",
            value: function multiCall(t) {
                return new $6c7d4e42ec377c87$export$5e250d3cb9452943(this, t);
            }
        },
        {
            key: "getBalance",
            value: function getBalance(t) {
                return this.provider.getContractBalance(this.id, t);
            }
        }
    ]);
    return F;
}();

});
parcelRequire.register("lcJUd", function(module, exports) {

$parcel$export(module.exports, "ByteArrayCoder", function () { return $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7; });
$parcel$export(module.exports, "InputType", function () { return $3ddb905e95ba55ee$export$476dfc2401bc286b; });
$parcel$export(module.exports, "InputMessageCoder", function () { return $3ddb905e95ba55ee$export$5e1e52e239612cee; });
$parcel$export(module.exports, "OutputType", function () { return $3ddb905e95ba55ee$export$be94d7b677b041dd; });
$parcel$export(module.exports, "ReceiptType", function () { return $3ddb905e95ba55ee$export$c49c54eaac29b59a; });
$parcel$export(module.exports, "ReceiptCoder", function () { return $3ddb905e95ba55ee$export$95506f9dff97f8bb; });
$parcel$export(module.exports, "TransactionType", function () { return $3ddb905e95ba55ee$export$d513b00599f845d4; });
$parcel$export(module.exports, "TransactionCoder", function () { return $3ddb905e95ba55ee$export$af003d88cba46f8c; });

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $8GFUW = parcelRequire("8GFUW");

var $1ObTH = parcelRequire("1ObTH");

var $6OZAO = parcelRequire("6OZAO");

var $j2rU8 = parcelRequire("j2rU8");

var $7WUQV = parcelRequire("7WUQV");

var $2cJiB = parcelRequire("2cJiB");
var $3ddb905e95ba55ee$var$Ne = Object.defineProperty;
var $3ddb905e95ba55ee$var$De = function(p, e, o) {
    return e in p ? $3ddb905e95ba55ee$var$Ne(p, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }) : p[e] = o;
};
var $3ddb905e95ba55ee$var$be = function(p, e, o) {
    return $3ddb905e95ba55ee$var$De(p, (typeof e === "undefined" ? "undefined" : (0, $1ObTH._)(e)) != "symbol" ? e + "" : e, o), o;
}, $3ddb905e95ba55ee$var$Ce = function(p, e, o) {
    if (!e.has(p)) throw TypeError("Cannot " + o);
};
var $3ddb905e95ba55ee$var$j = function(p, e, o) {
    return $3ddb905e95ba55ee$var$Ce(p, e, "read from private field"), o ? o.call(p) : e.get(p);
}, $3ddb905e95ba55ee$var$Te = function(p, e, o) {
    if (e.has(p)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(p) : e.set(p, o);
}, $3ddb905e95ba55ee$var$Ie = function(p, e, o, n) {
    return $3ddb905e95ba55ee$var$Ce(p, e, "write to private field"), n ? n.call(p, o) : e.set(p, o), o;
};
var $3ddb905e95ba55ee$var$B, $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7 = /*#__PURE__*/ function(ke) {
    "use strict";
    (0, $ftJVG._)(a, ke);
    var _super = (0, $6OZAO._)(a);
    function a(o) {
        (0, $978gY._)(this, a);
        var _this;
        var n = (8 - o % 8) % 8, t = o + n;
        _this = _super.call(this, "ByteArray", "[u64; ".concat(t / 4, "]"), t);
        $3ddb905e95ba55ee$var$be((0, $3vWwE._)(_this), "length");
        $3ddb905e95ba55ee$var$Te((0, $3vWwE._)(_this), $3ddb905e95ba55ee$var$B, void 0);
        _this.length = o, $3ddb905e95ba55ee$var$Ie((0, $3vWwE._)(_this), $3ddb905e95ba55ee$var$B, n);
        return _this;
    }
    (0, $kry2a._)(a, [
        {
            key: "encode",
            value: function encode(o) {
                var n = [], t = (0, $j2rU8.arrayify)(o);
                return n.push(t), $3ddb905e95ba55ee$var$j(this, $3ddb905e95ba55ee$var$B) && n.push(new Uint8Array($3ddb905e95ba55ee$var$j(this, $3ddb905e95ba55ee$var$B))), (0, $j2rU8.concat)(n);
            }
        },
        {
            key: "decode",
            value: function decode(o, n) {
                var t, s = n;
                var ref;
                ref = [
                    (0, $j2rU8.hexlify)(o.slice(s, s + this.length)),
                    s + this.length
                ], t = ref[0], s = ref[1], ref;
                var c = t;
                var ref1;
                return $3ddb905e95ba55ee$var$j(this, $3ddb905e95ba55ee$var$B) && (ref1 = [
                    null,
                    s + $3ddb905e95ba55ee$var$j(this, $3ddb905e95ba55ee$var$B)
                ], t = ref1[0], s = ref1[1], ref1), [
                    c,
                    s
                ];
            }
        }
    ]);
    return a;
}((0, $2cJiB.Coder));
$3ddb905e95ba55ee$var$B = new WeakMap;
var $3ddb905e95ba55ee$export$820db62f9f041f63 = /*#__PURE__*/ function(Ve) {
    "use strict";
    (0, $ftJVG._)(f, Ve);
    var _super = (0, $6OZAO._)(f);
    function f() {
        (0, $978gY._)(this, f);
        return _super.call(this, "TxPointer", {
            blockHeight: new (0, $2cJiB.NumberCoder)("u32"),
            txIndex: new (0, $2cJiB.NumberCoder)("u16")
        });
    }
    return f;
}((0, $2cJiB.StructCoder));
var $3ddb905e95ba55ee$export$32a255cb7ca4cdb5 = /*#__PURE__*/ function(He) {
    "use strict";
    (0, $ftJVG._)(S, He);
    var _super = (0, $6OZAO._)(S);
    function S() {
        (0, $978gY._)(this, S);
        return _super.call(this, "UtxoId", {
            transactionId: new (0, $2cJiB.B256Coder),
            outputIndex: new (0, $2cJiB.NumberCoder)("u8")
        });
    }
    return S;
}((0, $2cJiB.StructCoder));
var $3ddb905e95ba55ee$export$476dfc2401bc286b = function(n) {
    return n[n.Coin = 0] = "Coin", n[n.Contract = 1] = "Contract", n[n.Message = 2] = "Message", n;
}($3ddb905e95ba55ee$export$476dfc2401bc286b || {}), $3ddb905e95ba55ee$export$f1576a4c2eed7906 = /*#__PURE__*/ function(G) {
    "use strict";
    (0, $ftJVG._)(z, G);
    var _super = (0, $6OZAO._)(z);
    function z() {
        (0, $978gY._)(this, z);
        return _super.call(this, "InputCoin", "struct InputCoin", 0);
    }
    (0, $kry2a._)(z, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new $3ddb905e95ba55ee$export$32a255cb7ca4cdb5().encode(e.utxoID)), o.push(new (0, $2cJiB.B256Coder)().encode(e.owner)), o.push(new (0, $2cJiB.U64Coder)().encode(e.amount)), o.push(new (0, $2cJiB.B256Coder)().encode(e.assetId)), o.push(new $3ddb905e95ba55ee$export$820db62f9f041f63().encode(e.txPointer)), o.push(new (0, $2cJiB.NumberCoder)("u8").encode(e.witnessIndex)), o.push(new (0, $2cJiB.NumberCoder)("u32").encode(e.maturity)), o.push(new (0, $2cJiB.NumberCoder)("u16").encode(e.predicateLength)), o.push(new (0, $2cJiB.NumberCoder)("u16").encode(e.predicateDataLength)), o.push(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(e.predicateLength).encode(e.predicate)), o.push(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(e.predicateDataLength).encode(e.predicateData)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$32a255cb7ca4cdb5().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                ref2 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2;
                var i = n;
                var ref3;
                ref3 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3;
                var y = n;
                var ref4;
                ref4 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$820db62f9f041f63().decode(e, t), 2), n = ref4[0], t = ref4[1], ref4;
                var h = n;
                var ref5;
                ref5 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u8").decode(e, t), 2), n = ref5[0], t = ref5[1], ref5;
                var g = Number(n);
                var ref6;
                ref6 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u32").decode(e, t), 2), n = ref6[0], t = ref6[1], ref6;
                var u = n;
                var ref7;
                ref7 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u16").decode(e, t), 2), n = ref7[0], t = ref7[1], ref7;
                var x = n;
                var ref8;
                ref8 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u16").decode(e, t), 2), n = ref8[0], t = ref8[1], ref8;
                var U = n;
                var ref9;
                ref9 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(x).decode(e, t), 2), n = ref9[0], t = ref9[1], ref9;
                var M = n;
                var ref10;
                return ref10 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(U).decode(e, t), 2), n = ref10[0], t = ref10[1], ref10, [
                    {
                        type: 0,
                        utxoID: s,
                        owner: c,
                        amount: i,
                        assetId: y,
                        txPointer: h,
                        witnessIndex: g,
                        maturity: u,
                        predicateLength: x,
                        predicateDataLength: U,
                        predicate: M,
                        predicateData: n
                    },
                    t
                ];
            }
        }
    ]);
    return z;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$34f9b8a1f3d8cfd7 = /*#__PURE__*/ function(G) {
    "use strict";
    (0, $ftJVG._)(F, G);
    var _super = (0, $6OZAO._)(F);
    function F() {
        (0, $978gY._)(this, F);
        return _super.call(this, "InputContract", "struct InputContract", 0);
    }
    (0, $kry2a._)(F, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new $3ddb905e95ba55ee$export$32a255cb7ca4cdb5().encode(e.utxoID)), o.push(new (0, $2cJiB.B256Coder)().encode(e.balanceRoot)), o.push(new (0, $2cJiB.B256Coder)().encode(e.stateRoot)), o.push(new $3ddb905e95ba55ee$export$820db62f9f041f63().encode(e.txPointer)), o.push(new (0, $2cJiB.B256Coder)().encode(e.contractID)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$32a255cb7ca4cdb5().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                ref2 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2;
                var i = n;
                var ref3;
                ref3 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$820db62f9f041f63().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3;
                var y = n;
                var ref4;
                return ref4 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref4[0], t = ref4[1], ref4, [
                    {
                        type: 1,
                        utxoID: s,
                        balanceRoot: c,
                        stateRoot: i,
                        txPointer: y,
                        contractID: n
                    },
                    t
                ];
            }
        }
    ]);
    return F;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$5e1e52e239612cee = /*#__PURE__*/ function(G) {
    "use strict";
    (0, $ftJVG._)(E1, G);
    var _super = (0, $6OZAO._)(E1);
    function E1() {
        (0, $978gY._)(this, E1);
        return _super.call(this, "InputMessage", "struct InputMessage", 0);
    }
    (0, $kry2a._)(E1, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [], n = new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(e.dataLength).encode(e.data), t = $3ddb905e95ba55ee$export$5e1e52e239612cee.getMessageId(e);
                return o.push(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(32).encode(t)), o.push(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(32).encode(e.sender)), o.push(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(32).encode(e.recipient)), o.push(new (0, $2cJiB.U64Coder)().encode(e.amount)), o.push(new (0, $2cJiB.U64Coder)().encode(e.nonce)), o.push(new (0, $2cJiB.NumberCoder)("u8").encode(e.witnessIndex)), o.push(new (0, $2cJiB.NumberCoder)("u16").encode(n.length)), o.push(new (0, $2cJiB.NumberCoder)("u16").encode(e.predicateLength)), o.push(new (0, $2cJiB.NumberCoder)("u16").encode(e.predicateDataLength)), o.push(n), o.push(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(e.predicateLength).encode(e.predicate)), o.push(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(e.predicateDataLength).encode(e.predicateData)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                ref2 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2;
                var i = n;
                var ref3;
                ref3 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3;
                var y = n;
                var ref4;
                ref4 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u8").decode(e, t), 2), n = ref4[0], t = ref4[1], ref4;
                var h = Number(n);
                var ref5;
                ref5 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u16").decode(e, t), 2), n = ref5[0], t = ref5[1], ref5;
                var g = n;
                var ref6;
                ref6 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u16").decode(e, t), 2), n = ref6[0], t = ref6[1], ref6;
                var u = n;
                var ref7;
                ref7 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u16").decode(e, t), 2), n = ref7[0], t = ref7[1], ref7;
                var x = n;
                var ref8;
                ref8 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(g).decode(e, t), 2), n = ref8[0], t = ref8[1], ref8;
                var U = n;
                var ref9;
                ref9 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(u).decode(e, t), 2), n = ref9[0], t = ref9[1], ref9;
                var M = n;
                var ref10;
                return ref10 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(x).decode(e, t), 2), n = ref10[0], t = ref10[1], ref10, [
                    {
                        type: 2,
                        sender: s,
                        recipient: c,
                        amount: i,
                        witnessIndex: h,
                        nonce: y,
                        data: U,
                        dataLength: g,
                        predicateLength: u,
                        predicateDataLength: x,
                        predicate: M,
                        predicateData: n
                    },
                    t
                ];
            }
        }
    ], [
        {
            key: "getMessageId",
            value: function getMessageId(e) {
                var o = [];
                return o.push(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(32).encode(e.sender)), o.push(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(32).encode(e.recipient)), o.push(new (0, $2cJiB.U64Coder)().encode(e.nonce)), o.push(new (0, $2cJiB.U64Coder)().encode(e.amount)), o.push(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(e.dataLength).encode(e.data)), (0, $7WUQV.sha256)((0, $j2rU8.concat)(o));
            }
        },
        {
            key: "decodeData",
            value: function decodeData(e) {
                var o = (0, $j2rU8.arrayify)(e), n = o.length, _decode = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(n).decode(o, 0), 1), t = _decode[0];
                return (0, $j2rU8.arrayify)(t);
            }
        }
    ]);
    return E1;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$7739f7d8d6218f9 = /*#__PURE__*/ function(G) {
    "use strict";
    (0, $ftJVG._)(P, G);
    var _super = (0, $6OZAO._)(P);
    function P() {
        (0, $978gY._)(this, P);
        return _super.call(this, "Input", "struct Input", 0);
    }
    (0, $kry2a._)(P, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                switch(o.push(new (0, $2cJiB.NumberCoder)("u8").encode(e.type)), e.type){
                    case 0:
                        o.push(new $3ddb905e95ba55ee$export$f1576a4c2eed7906().encode(e));
                        break;
                    case 1:
                        o.push(new $3ddb905e95ba55ee$export$34f9b8a1f3d8cfd7().encode(e));
                        break;
                    case 2:
                        o.push(new $3ddb905e95ba55ee$export$5e1e52e239612cee().encode(e));
                        break;
                    default:
                        throw new Error("Invalid Input type");
                }
                return (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                switch(ref = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u8").decode(e, t), 2), n = ref[0], t = ref[1], ref, n){
                    case 0:
                        var ref1;
                        return ref1 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$f1576a4c2eed7906().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1, [
                            n,
                            t
                        ];
                    case 1:
                        var ref2;
                        return ref2 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$34f9b8a1f3d8cfd7().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2, [
                            n,
                            t
                        ];
                    case 2:
                        var ref3;
                        return ref3 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$5e1e52e239612cee().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3, [
                            n,
                            t
                        ];
                    default:
                        throw new Error("Invalid Input type");
                }
            }
        }
    ]);
    return P;
}((0, $2cJiB.Coder));
var $3ddb905e95ba55ee$export$be94d7b677b041dd = function(c) {
    return c[c.Coin = 0] = "Coin", c[c.Contract = 1] = "Contract", c[c.Message = 2] = "Message", c[c.Change = 3] = "Change", c[c.Variable = 4] = "Variable", c[c.ContractCreated = 5] = "ContractCreated", c;
}($3ddb905e95ba55ee$export$be94d7b677b041dd || {}), $3ddb905e95ba55ee$export$a39f34bf56095b48 = /*#__PURE__*/ function(V) {
    "use strict";
    (0, $ftJVG._)(K, V);
    var _super = (0, $6OZAO._)(K);
    function K() {
        (0, $978gY._)(this, K);
        return _super.call(this, "OutputCoin", "struct OutputCoin", 0);
    }
    (0, $kry2a._)(K, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.B256Coder)().encode(e.to)), o.push(new (0, $2cJiB.U64Coder)().encode(e.amount)), o.push(new (0, $2cJiB.B256Coder)().encode(e.assetId)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                return ref2 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2, [
                    {
                        type: 0,
                        to: s,
                        amount: c,
                        assetId: n
                    },
                    t
                ];
            }
        }
    ]);
    return K;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$971ec119729e6f40 = /*#__PURE__*/ function(V) {
    "use strict";
    (0, $ftJVG._)(Q, V);
    var _super = (0, $6OZAO._)(Q);
    function Q() {
        (0, $978gY._)(this, Q);
        return _super.call(this, "OutputContract", "struct OutputContract", 0);
    }
    (0, $kry2a._)(Q, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.NumberCoder)("u8").encode(e.inputIndex)), o.push(new (0, $2cJiB.B256Coder)().encode(e.balanceRoot)), o.push(new (0, $2cJiB.B256Coder)().encode(e.stateRoot)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u8").decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                return ref2 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2, [
                    {
                        type: 1,
                        inputIndex: s,
                        balanceRoot: c,
                        stateRoot: n
                    },
                    t
                ];
            }
        }
    ]);
    return Q;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$b5b684494a636557 = /*#__PURE__*/ function(V) {
    "use strict";
    (0, $ftJVG._)(X, V);
    var _super = (0, $6OZAO._)(X);
    function X() {
        (0, $978gY._)(this, X);
        return _super.call(this, "OutputMessage", "struct OutputMessage", 0);
    }
    (0, $kry2a._)(X, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.B256Coder)().encode(e.recipient)), o.push(new (0, $2cJiB.U64Coder)().encode(e.amount)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                return ref1 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1, [
                    {
                        type: 2,
                        recipient: s,
                        amount: n
                    },
                    t
                ];
            }
        }
    ]);
    return X;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$d0f1aba486117ff3 = /*#__PURE__*/ function(V) {
    "use strict";
    (0, $ftJVG._)(Y, V);
    var _super = (0, $6OZAO._)(Y);
    function Y() {
        (0, $978gY._)(this, Y);
        return _super.call(this, "OutputChange", "struct OutputChange", 0);
    }
    (0, $kry2a._)(Y, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.B256Coder)().encode(e.to)), o.push(new (0, $2cJiB.U64Coder)().encode(e.amount)), o.push(new (0, $2cJiB.B256Coder)().encode(e.assetId)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                return ref2 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2, [
                    {
                        type: 3,
                        to: s,
                        amount: c,
                        assetId: n
                    },
                    t
                ];
            }
        }
    ]);
    return Y;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$7d30205aaeb2032f = /*#__PURE__*/ function(V) {
    "use strict";
    (0, $ftJVG._)(Z, V);
    var _super = (0, $6OZAO._)(Z);
    function Z() {
        (0, $978gY._)(this, Z);
        return _super.call(this, "OutputVariable", "struct OutputVariable", 0);
    }
    (0, $kry2a._)(Z, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.B256Coder)().encode(e.to)), o.push(new (0, $2cJiB.U64Coder)().encode(e.amount)), o.push(new (0, $2cJiB.B256Coder)().encode(e.assetId)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                return ref2 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2, [
                    {
                        type: 4,
                        to: s,
                        amount: c,
                        assetId: n
                    },
                    t
                ];
            }
        }
    ]);
    return Z;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$a745902dc9dc7324 = /*#__PURE__*/ function(V) {
    "use strict";
    (0, $ftJVG._)(_, V);
    var _super = (0, $6OZAO._)(_);
    function _() {
        (0, $978gY._)(this, _);
        return _super.call(this, "OutputContractCreated", "struct OutputContractCreated", 0);
    }
    (0, $kry2a._)(_, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.B256Coder)().encode(e.contractId)), o.push(new (0, $2cJiB.B256Coder)().encode(e.stateRoot)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                return ref1 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1, [
                    {
                        type: 5,
                        contractId: s,
                        stateRoot: n
                    },
                    t
                ];
            }
        }
    ]);
    return _;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$fc1634d0be8612df = /*#__PURE__*/ function(V) {
    "use strict";
    (0, $ftJVG._)(L, V);
    var _super = (0, $6OZAO._)(L);
    function L() {
        (0, $978gY._)(this, L);
        return _super.call(this, "Output", " struct Output", 0);
    }
    (0, $kry2a._)(L, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                switch(o.push(new (0, $2cJiB.NumberCoder)("u8").encode(e.type)), e.type){
                    case 0:
                        o.push(new $3ddb905e95ba55ee$export$a39f34bf56095b48().encode(e));
                        break;
                    case 1:
                        o.push(new $3ddb905e95ba55ee$export$971ec119729e6f40().encode(e));
                        break;
                    case 2:
                        o.push(new $3ddb905e95ba55ee$export$b5b684494a636557().encode(e));
                        break;
                    case 3:
                        o.push(new $3ddb905e95ba55ee$export$d0f1aba486117ff3().encode(e));
                        break;
                    case 4:
                        o.push(new $3ddb905e95ba55ee$export$7d30205aaeb2032f().encode(e));
                        break;
                    case 5:
                        o.push(new $3ddb905e95ba55ee$export$a745902dc9dc7324().encode(e));
                        break;
                    default:
                        throw new Error("Invalid Output type");
                }
                return (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                switch(ref = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u8").decode(e, t), 2), n = ref[0], t = ref[1], ref, n){
                    case 0:
                        var ref1;
                        return ref1 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$a39f34bf56095b48().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1, [
                            n,
                            t
                        ];
                    case 1:
                        var ref2;
                        return ref2 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$971ec119729e6f40().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2, [
                            n,
                            t
                        ];
                    case 2:
                        var ref3;
                        return ref3 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$b5b684494a636557().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3, [
                            n,
                            t
                        ];
                    case 3:
                        var ref4;
                        return ref4 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$d0f1aba486117ff3().decode(e, t), 2), n = ref4[0], t = ref4[1], ref4, [
                            n,
                            t
                        ];
                    case 4:
                        var ref5;
                        return ref5 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$7d30205aaeb2032f().decode(e, t), 2), n = ref5[0], t = ref5[1], ref5, [
                            n,
                            t
                        ];
                    case 5:
                        var ref6;
                        return ref6 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$a745902dc9dc7324().decode(e, t), 2), n = ref6[0], t = ref6[1], ref6, [
                            n,
                            t
                        ];
                    default:
                        throw new Error("Invalid Output type");
                }
            }
        }
    ]);
    return L;
}((0, $2cJiB.Coder));
var $3ddb905e95ba55ee$export$c49c54eaac29b59a = function(u) {
    return u[u.Call = 0] = "Call", u[u.Return = 1] = "Return", u[u.ReturnData = 2] = "ReturnData", u[u.Panic = 3] = "Panic", u[u.Revert = 4] = "Revert", u[u.Log = 5] = "Log", u[u.LogData = 6] = "LogData", u[u.Transfer = 7] = "Transfer", u[u.TransferOut = 8] = "TransferOut", u[u.ScriptResult = 9] = "ScriptResult", u[u.MessageOut = 10] = "MessageOut", u;
}($3ddb905e95ba55ee$export$c49c54eaac29b59a || {}), $3ddb905e95ba55ee$export$fc08aa7cc46cb844 = /*#__PURE__*/ function(I) {
    "use strict";
    (0, $ftJVG._)(ee, I);
    var _super = (0, $6OZAO._)(ee);
    function ee() {
        (0, $978gY._)(this, ee);
        return _super.call(this, "ReceiptCall", "struct ReceiptCall", 0);
    }
    (0, $kry2a._)(ee, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.B256Coder)().encode(e.from)), o.push(new (0, $2cJiB.B256Coder)().encode(e.to)), o.push(new (0, $2cJiB.U64Coder)().encode(e.amount)), o.push(new (0, $2cJiB.B256Coder)().encode(e.assetId)), o.push(new (0, $2cJiB.U64Coder)().encode(e.gas)), o.push(new (0, $2cJiB.U64Coder)().encode(e.param1)), o.push(new (0, $2cJiB.U64Coder)().encode(e.param2)), o.push(new (0, $2cJiB.U64Coder)().encode(e.pc)), o.push(new (0, $2cJiB.U64Coder)().encode(e.is)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                ref2 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2;
                var i = n;
                var ref3;
                ref3 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3;
                var y = n;
                var ref4;
                ref4 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref4[0], t = ref4[1], ref4;
                var h = n;
                var ref5;
                ref5 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref5[0], t = ref5[1], ref5;
                var g = n;
                var ref6;
                ref6 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref6[0], t = ref6[1], ref6;
                var u = n;
                var ref7;
                ref7 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref7[0], t = ref7[1], ref7;
                var x = n;
                var ref8;
                return ref8 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref8[0], t = ref8[1], ref8, [
                    {
                        type: 0,
                        from: s,
                        to: c,
                        amount: i,
                        assetId: y,
                        gas: h,
                        param1: g,
                        param2: u,
                        pc: x,
                        is: n
                    },
                    t
                ];
            }
        }
    ]);
    return ee;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$30774111b3db0692 = /*#__PURE__*/ function(I) {
    "use strict";
    (0, $ftJVG._)(te, I);
    var _super = (0, $6OZAO._)(te);
    function te() {
        (0, $978gY._)(this, te);
        return _super.call(this, "ReceiptReturn", "struct ReceiptReturn", 0);
    }
    (0, $kry2a._)(te, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.B256Coder)().encode(e.id)), o.push(new (0, $2cJiB.U64Coder)().encode(e.val)), o.push(new (0, $2cJiB.U64Coder)().encode(e.pc)), o.push(new (0, $2cJiB.U64Coder)().encode(e.is)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                ref2 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2;
                var i = n;
                var ref3;
                return ref3 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3, [
                    {
                        type: 1,
                        id: s,
                        val: c,
                        pc: i,
                        is: n
                    },
                    t
                ];
            }
        }
    ]);
    return te;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$47b8b3e37d0f8d07 = /*#__PURE__*/ function(I) {
    "use strict";
    (0, $ftJVG._)(ne, I);
    var _super = (0, $6OZAO._)(ne);
    function ne() {
        (0, $978gY._)(this, ne);
        return _super.call(this, "ReceiptReturnData", "struct ReceiptReturnData", 0);
    }
    (0, $kry2a._)(ne, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.B256Coder)().encode(e.id)), o.push(new (0, $2cJiB.U64Coder)().encode(e.ptr)), o.push(new (0, $2cJiB.U64Coder)().encode(e.len)), o.push(new (0, $2cJiB.B256Coder)().encode(e.digest)), o.push(new (0, $2cJiB.U64Coder)().encode(e.pc)), o.push(new (0, $2cJiB.U64Coder)().encode(e.is)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                ref2 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2;
                var i = n;
                var ref3;
                ref3 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3;
                var y = n;
                var ref4;
                ref4 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref4[0], t = ref4[1], ref4;
                var h = n;
                var ref5;
                return ref5 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref5[0], t = ref5[1], ref5, [
                    {
                        type: 2,
                        id: s,
                        ptr: c,
                        len: i,
                        digest: y,
                        pc: h,
                        is: n
                    },
                    t
                ];
            }
        }
    ]);
    return ne;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$991358d62090b6b = /*#__PURE__*/ function(I) {
    "use strict";
    (0, $ftJVG._)(oe, I);
    var _super = (0, $6OZAO._)(oe);
    function oe() {
        (0, $978gY._)(this, oe);
        return _super.call(this, "ReceiptPanic", "struct ReceiptPanic", 0);
    }
    (0, $kry2a._)(oe, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.B256Coder)().encode(e.id)), o.push(new (0, $2cJiB.U64Coder)().encode(e.reason)), o.push(new (0, $2cJiB.U64Coder)().encode(e.pc)), o.push(new (0, $2cJiB.U64Coder)().encode(e.is)), o.push(new (0, $2cJiB.B256Coder)().encode(e.contractId)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                ref2 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2;
                var i = n;
                var ref3;
                ref3 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3;
                var y = n;
                var ref4;
                return ref4 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref4[0], t = ref4[1], ref4, [
                    {
                        type: 3,
                        id: s,
                        reason: c,
                        pc: i,
                        is: y,
                        contractId: n
                    },
                    t
                ];
            }
        }
    ]);
    return oe;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$c01221e3ef2055f9 = /*#__PURE__*/ function(I) {
    "use strict";
    (0, $ftJVG._)(re, I);
    var _super = (0, $6OZAO._)(re);
    function re() {
        (0, $978gY._)(this, re);
        return _super.call(this, "ReceiptRevert", "struct ReceiptRevert", 0);
    }
    (0, $kry2a._)(re, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.B256Coder)().encode(e.id)), o.push(new (0, $2cJiB.U64Coder)().encode(e.val)), o.push(new (0, $2cJiB.U64Coder)().encode(e.pc)), o.push(new (0, $2cJiB.U64Coder)().encode(e.is)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                ref2 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2;
                var i = n;
                var ref3;
                return ref3 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3, [
                    {
                        type: 4,
                        id: s,
                        val: c,
                        pc: i,
                        is: n
                    },
                    t
                ];
            }
        }
    ]);
    return re;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$1b658e6a5426bbf2 = /*#__PURE__*/ function(I) {
    "use strict";
    (0, $ftJVG._)(se, I);
    var _super = (0, $6OZAO._)(se);
    function se() {
        (0, $978gY._)(this, se);
        return _super.call(this, "ReceiptLog", "struct ReceiptLog", 0);
    }
    (0, $kry2a._)(se, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.B256Coder)().encode(e.id)), o.push(new (0, $2cJiB.U64Coder)().encode(e.val0)), o.push(new (0, $2cJiB.U64Coder)().encode(e.val1)), o.push(new (0, $2cJiB.U64Coder)().encode(e.val2)), o.push(new (0, $2cJiB.U64Coder)().encode(e.val3)), o.push(new (0, $2cJiB.U64Coder)().encode(e.pc)), o.push(new (0, $2cJiB.U64Coder)().encode(e.is)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                ref2 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2;
                var i = n;
                var ref3;
                ref3 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3;
                var y = n;
                var ref4;
                ref4 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref4[0], t = ref4[1], ref4;
                var h = n;
                var ref5;
                ref5 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref5[0], t = ref5[1], ref5;
                var g = n;
                var ref6;
                return ref6 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref6[0], t = ref6[1], ref6, [
                    {
                        type: 5,
                        id: s,
                        val0: c,
                        val1: i,
                        val2: y,
                        val3: h,
                        pc: g,
                        is: n
                    },
                    t
                ];
            }
        }
    ]);
    return se;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$c0727ed30e4cba11 = /*#__PURE__*/ function(I) {
    "use strict";
    (0, $ftJVG._)(ce, I);
    var _super = (0, $6OZAO._)(ce);
    function ce() {
        (0, $978gY._)(this, ce);
        return _super.call(this, "ReceiptLogData", "struct ReceiptLogData", 0);
    }
    (0, $kry2a._)(ce, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.B256Coder)().encode(e.id)), o.push(new (0, $2cJiB.U64Coder)().encode(e.val0)), o.push(new (0, $2cJiB.U64Coder)().encode(e.val1)), o.push(new (0, $2cJiB.U64Coder)().encode(e.ptr)), o.push(new (0, $2cJiB.U64Coder)().encode(e.len)), o.push(new (0, $2cJiB.B256Coder)().encode(e.digest)), o.push(new (0, $2cJiB.U64Coder)().encode(e.pc)), o.push(new (0, $2cJiB.U64Coder)().encode(e.is)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                ref2 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2;
                var i = n;
                var ref3;
                ref3 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3;
                var y = n;
                var ref4;
                ref4 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref4[0], t = ref4[1], ref4;
                var h = n;
                var ref5;
                ref5 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref5[0], t = ref5[1], ref5;
                var g = n;
                var ref6;
                ref6 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref6[0], t = ref6[1], ref6;
                var u = n;
                var ref7;
                return ref7 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref7[0], t = ref7[1], ref7, [
                    {
                        type: 6,
                        id: s,
                        val0: c,
                        val1: i,
                        ptr: y,
                        len: h,
                        digest: g,
                        pc: u,
                        is: n
                    },
                    t
                ];
            }
        }
    ]);
    return ce;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$7a2ca335b4d625be = /*#__PURE__*/ function(I) {
    "use strict";
    (0, $ftJVG._)(pe, I);
    var _super = (0, $6OZAO._)(pe);
    function pe() {
        (0, $978gY._)(this, pe);
        return _super.call(this, "ReceiptTransfer", "struct ReceiptTransfer", 0);
    }
    (0, $kry2a._)(pe, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.B256Coder)().encode(e.from)), o.push(new (0, $2cJiB.B256Coder)().encode(e.to)), o.push(new (0, $2cJiB.U64Coder)().encode(e.amount)), o.push(new (0, $2cJiB.B256Coder)().encode(e.assetId)), o.push(new (0, $2cJiB.U64Coder)().encode(e.pc)), o.push(new (0, $2cJiB.U64Coder)().encode(e.is)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                ref2 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2;
                var i = n;
                var ref3;
                ref3 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3;
                var y = n;
                var ref4;
                ref4 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref4[0], t = ref4[1], ref4;
                var h = n;
                var ref5;
                return ref5 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref5[0], t = ref5[1], ref5, [
                    {
                        type: 7,
                        from: s,
                        to: c,
                        amount: i,
                        assetId: y,
                        pc: h,
                        is: n
                    },
                    t
                ];
            }
        }
    ]);
    return pe;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$60d36b87c7f548d8 = /*#__PURE__*/ function(I) {
    "use strict";
    (0, $ftJVG._)(de, I);
    var _super = (0, $6OZAO._)(de);
    function de() {
        (0, $978gY._)(this, de);
        return _super.call(this, "ReceiptTransferOut", "struct ReceiptTransferOut", 0);
    }
    (0, $kry2a._)(de, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.B256Coder)().encode(e.from)), o.push(new (0, $2cJiB.B256Coder)().encode(e.to)), o.push(new (0, $2cJiB.U64Coder)().encode(e.amount)), o.push(new (0, $2cJiB.B256Coder)().encode(e.assetId)), o.push(new (0, $2cJiB.U64Coder)().encode(e.pc)), o.push(new (0, $2cJiB.U64Coder)().encode(e.is)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                ref2 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2;
                var i = n;
                var ref3;
                ref3 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3;
                var y = n;
                var ref4;
                ref4 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref4[0], t = ref4[1], ref4;
                var h = n;
                var ref5;
                return ref5 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref5[0], t = ref5[1], ref5, [
                    {
                        type: 8,
                        from: s,
                        to: c,
                        amount: i,
                        assetId: y,
                        pc: h,
                        is: n
                    },
                    t
                ];
            }
        }
    ]);
    return de;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$78ce7a92c84e0593 = /*#__PURE__*/ function(I) {
    "use strict";
    (0, $ftJVG._)(ue, I);
    var _super = (0, $6OZAO._)(ue);
    function ue() {
        (0, $978gY._)(this, ue);
        return _super.call(this, "ReceiptScriptResult", "struct ReceiptScriptResult", 0);
    }
    (0, $kry2a._)(ue, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.U64Coder)().encode(e.result)), o.push(new (0, $2cJiB.U64Coder)().encode(e.gasUsed)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                return ref1 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1, [
                    {
                        type: 9,
                        result: s,
                        gasUsed: n
                    },
                    t
                ];
            }
        }
    ]);
    return ue;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$1cbb33f2ecb54583 = /*#__PURE__*/ function(I) {
    "use strict";
    (0, $ftJVG._)(ie, I);
    var _super = (0, $6OZAO._)(ie);
    function ie() {
        (0, $978gY._)(this, ie);
        return _super.call(this, "ReceiptMessageOut", "struct ReceiptMessageOut", 0);
    }
    (0, $kry2a._)(ie, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.B256Coder)().encode(e.messageID)), o.push(new (0, $2cJiB.B256Coder)().encode(e.sender)), o.push(new (0, $2cJiB.B256Coder)().encode(e.recipient)), o.push(new (0, $2cJiB.U64Coder)().encode(e.amount)), o.push(new (0, $2cJiB.B256Coder)().encode(e.nonce)), o.push(new (0, $2cJiB.NumberCoder)("u16").encode(e.data.length)), o.push(new (0, $2cJiB.B256Coder)().encode(e.digest)), o.push(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(e.data.length).encode(e.data)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                ref2 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2;
                var i = n;
                var ref3;
                ref3 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3;
                var y = n;
                var ref4;
                ref4 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref4[0], t = ref4[1], ref4;
                var h = n;
                var ref5;
                ref5 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u16").decode(e, t), 2), n = ref5[0], t = ref5[1], ref5;
                var g = n;
                var ref6;
                ref6 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref6[0], t = ref6[1], ref6;
                var u = n;
                var ref7;
                ref7 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(g).decode(e, t), 2), n = ref7[0], t = ref7[1], ref7;
                var x = (0, $j2rU8.arrayify)(n);
                return [
                    {
                        type: 10,
                        messageID: s,
                        sender: c,
                        recipient: i,
                        amount: y,
                        nonce: h,
                        digest: u,
                        data: x
                    },
                    t
                ];
            }
        }
    ]);
    return ie;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$95506f9dff97f8bb = /*#__PURE__*/ function(I) {
    "use strict";
    (0, $ftJVG._)(Ae, I);
    var _super = (0, $6OZAO._)(Ae);
    function Ae() {
        (0, $978gY._)(this, Ae);
        return _super.call(this, "Receipt", "struct Receipt", 0);
    }
    (0, $kry2a._)(Ae, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                switch(o.push(new (0, $2cJiB.NumberCoder)("u8").encode(e.type)), e.type){
                    case 0:
                        o.push(new $3ddb905e95ba55ee$export$fc08aa7cc46cb844().encode(e));
                        break;
                    case 1:
                        o.push(new $3ddb905e95ba55ee$export$30774111b3db0692().encode(e));
                        break;
                    case 2:
                        o.push(new $3ddb905e95ba55ee$export$47b8b3e37d0f8d07().encode(e));
                        break;
                    case 3:
                        o.push(new $3ddb905e95ba55ee$export$991358d62090b6b().encode(e));
                        break;
                    case 4:
                        o.push(new $3ddb905e95ba55ee$export$c01221e3ef2055f9().encode(e));
                        break;
                    case 5:
                        o.push(new $3ddb905e95ba55ee$export$1b658e6a5426bbf2().encode(e));
                        break;
                    case 6:
                        o.push(new $3ddb905e95ba55ee$export$c0727ed30e4cba11().encode(e));
                        break;
                    case 7:
                        o.push(new $3ddb905e95ba55ee$export$7a2ca335b4d625be().encode(e));
                        break;
                    case 8:
                        o.push(new $3ddb905e95ba55ee$export$60d36b87c7f548d8().encode(e));
                        break;
                    case 9:
                        o.push(new $3ddb905e95ba55ee$export$78ce7a92c84e0593().encode(e));
                        break;
                    case 10:
                        o.push(new $3ddb905e95ba55ee$export$1cbb33f2ecb54583().encode(e));
                        break;
                    default:
                        throw new Error("Invalid Receipt type");
                }
                return (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                switch(ref = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u8").decode(e, t), 2), n = ref[0], t = ref[1], ref, n){
                    case 0:
                        var ref1;
                        return ref1 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$fc08aa7cc46cb844().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1, [
                            n,
                            t
                        ];
                    case 1:
                        var ref2;
                        return ref2 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$30774111b3db0692().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2, [
                            n,
                            t
                        ];
                    case 2:
                        var ref3;
                        return ref3 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$47b8b3e37d0f8d07().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3, [
                            n,
                            t
                        ];
                    case 3:
                        var ref4;
                        return ref4 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$991358d62090b6b().decode(e, t), 2), n = ref4[0], t = ref4[1], ref4, [
                            n,
                            t
                        ];
                    case 4:
                        var ref5;
                        return ref5 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$c01221e3ef2055f9().decode(e, t), 2), n = ref5[0], t = ref5[1], ref5, [
                            n,
                            t
                        ];
                    case 5:
                        var ref6;
                        return ref6 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$1b658e6a5426bbf2().decode(e, t), 2), n = ref6[0], t = ref6[1], ref6, [
                            n,
                            t
                        ];
                    case 6:
                        var ref7;
                        return ref7 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$c0727ed30e4cba11().decode(e, t), 2), n = ref7[0], t = ref7[1], ref7, [
                            n,
                            t
                        ];
                    case 7:
                        var ref8;
                        return ref8 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$7a2ca335b4d625be().decode(e, t), 2), n = ref8[0], t = ref8[1], ref8, [
                            n,
                            t
                        ];
                    case 8:
                        var ref9;
                        return ref9 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$60d36b87c7f548d8().decode(e, t), 2), n = ref9[0], t = ref9[1], ref9, [
                            n,
                            t
                        ];
                    case 9:
                        var ref10;
                        return ref10 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$78ce7a92c84e0593().decode(e, t), 2), n = ref10[0], t = ref10[1], ref10, [
                            n,
                            t
                        ];
                    case 10:
                        var ref11;
                        return ref11 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$1cbb33f2ecb54583().decode(e, t), 2), n = ref11[0], t = ref11[1], ref11, [
                            n,
                            t
                        ];
                    default:
                        throw new Error("Invalid Receipt type");
                }
            }
        }
    ]);
    return Ae;
}((0, $2cJiB.Coder));
var $3ddb905e95ba55ee$export$a1c5b1cca91e84ca = /*#__PURE__*/ function(Ge) {
    "use strict";
    (0, $ftJVG._)(q, Ge);
    var _super = (0, $6OZAO._)(q);
    function q() {
        (0, $978gY._)(this, q);
        return _super.call(this, "StorageSlot", {
            key: new (0, $2cJiB.B256Coder),
            value: new (0, $2cJiB.B256Coder)
        });
    }
    return q;
}((0, $2cJiB.StructCoder));
var $3ddb905e95ba55ee$export$bb65a7609b522cec = /*#__PURE__*/ function(Ke) {
    "use strict";
    (0, $ftJVG._)(W, Ke);
    var _super = (0, $6OZAO._)(W);
    function W() {
        (0, $978gY._)(this, W);
        return _super.call(this, "Witness", "unknown", 0);
    }
    (0, $kry2a._)(W, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.NumberCoder)("u32").encode(e.dataLength)), o.push(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(e.dataLength).encode(e.data)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u32").decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                return ref1 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(s).decode(e, t), 2), n = ref1[0], t = ref1[1], ref1, [
                    {
                        dataLength: s,
                        data: n
                    },
                    t
                ];
            }
        }
    ]);
    return W;
}((0, $2cJiB.Coder));
var $3ddb905e95ba55ee$export$d513b00599f845d4 = function(n) {
    return n[n.Script = 0] = "Script", n[n.Create = 1] = "Create", n[n.Mint = 2] = "Mint", n;
}($3ddb905e95ba55ee$export$d513b00599f845d4 || {}), $3ddb905e95ba55ee$export$75004a9f23a253ee = /*#__PURE__*/ function(ge) {
    "use strict";
    (0, $ftJVG._)(we, ge);
    var _super = (0, $6OZAO._)(we);
    function we() {
        (0, $978gY._)(this, we);
        return _super.call(this, "TransactionScript", "struct TransactionScript", 0);
    }
    (0, $kry2a._)(we, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.U64Coder)().encode(e.gasPrice)), o.push(new (0, $2cJiB.U64Coder)().encode(e.gasLimit)), o.push(new (0, $2cJiB.NumberCoder)("u32").encode(e.maturity)), o.push(new (0, $2cJiB.NumberCoder)("u16").encode(e.scriptLength)), o.push(new (0, $2cJiB.NumberCoder)("u16").encode(e.scriptDataLength)), o.push(new (0, $2cJiB.NumberCoder)("u8").encode(e.inputsCount)), o.push(new (0, $2cJiB.NumberCoder)("u8").encode(e.outputsCount)), o.push(new (0, $2cJiB.NumberCoder)("u8").encode(e.witnessesCount)), o.push(new (0, $2cJiB.B256Coder)().encode(e.receiptsRoot)), o.push(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(e.scriptLength).encode(e.script)), o.push(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(e.scriptDataLength).encode(e.scriptData)), o.push(new (0, $2cJiB.ArrayCoder)(new $3ddb905e95ba55ee$export$7739f7d8d6218f9, e.inputsCount).encode(e.inputs)), o.push(new (0, $2cJiB.ArrayCoder)(new $3ddb905e95ba55ee$export$fc1634d0be8612df, e.outputsCount).encode(e.outputs)), o.push(new (0, $2cJiB.ArrayCoder)(new $3ddb905e95ba55ee$export$bb65a7609b522cec, e.witnessesCount).encode(e.witnesses)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                ref2 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u32").decode(e, t), 2), n = ref2[0], t = ref2[1], ref2;
                var i = n;
                var ref3;
                ref3 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u16").decode(e, t), 2), n = ref3[0], t = ref3[1], ref3;
                var y = n;
                var ref4;
                ref4 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u16").decode(e, t), 2), n = ref4[0], t = ref4[1], ref4;
                var h = n;
                var ref5;
                ref5 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u8").decode(e, t), 2), n = ref5[0], t = ref5[1], ref5;
                var g = n;
                var ref6;
                ref6 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u8").decode(e, t), 2), n = ref6[0], t = ref6[1], ref6;
                var u = n;
                var ref7;
                ref7 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u8").decode(e, t), 2), n = ref7[0], t = ref7[1], ref7;
                var x = n;
                var ref8;
                ref8 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref8[0], t = ref8[1], ref8;
                var U = n;
                var ref9;
                ref9 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(y).decode(e, t), 2), n = ref9[0], t = ref9[1], ref9;
                var M = n;
                var ref10;
                ref10 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$4d41ef2e0fecc2a7(h).decode(e, t), 2), n = ref10[0], t = ref10[1], ref10;
                var H = n;
                var ref11;
                ref11 = (0, $8GFUW._)(new (0, $2cJiB.ArrayCoder)(new $3ddb905e95ba55ee$export$7739f7d8d6218f9, g).decode(e, t), 2), n = ref11[0], t = ref11[1], ref11;
                var Re = n;
                var ref12;
                ref12 = (0, $8GFUW._)(new (0, $2cJiB.ArrayCoder)(new $3ddb905e95ba55ee$export$fc1634d0be8612df, u).decode(e, t), 2), n = ref12[0], t = ref12[1], ref12;
                var xe = n;
                var ref13;
                return ref13 = (0, $8GFUW._)(new (0, $2cJiB.ArrayCoder)(new $3ddb905e95ba55ee$export$bb65a7609b522cec, x).decode(e, t), 2), n = ref13[0], t = ref13[1], ref13, [
                    {
                        type: 0,
                        gasPrice: s,
                        gasLimit: c,
                        maturity: i,
                        scriptLength: y,
                        scriptDataLength: h,
                        inputsCount: g,
                        outputsCount: u,
                        witnessesCount: x,
                        receiptsRoot: U,
                        script: M,
                        scriptData: H,
                        inputs: Re,
                        outputs: xe,
                        witnesses: n
                    },
                    t
                ];
            }
        }
    ]);
    return we;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$8ad8d50ba64eb3bd = /*#__PURE__*/ function(ge) {
    "use strict";
    (0, $ftJVG._)(ye, ge);
    var _super = (0, $6OZAO._)(ye);
    function ye() {
        (0, $978gY._)(this, ye);
        return _super.call(this, "TransactionCreate", "struct TransactionCreate", 0);
    }
    (0, $kry2a._)(ye, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new (0, $2cJiB.U64Coder)().encode(e.gasPrice)), o.push(new (0, $2cJiB.U64Coder)().encode(e.gasLimit)), o.push(new (0, $2cJiB.NumberCoder)("u32").encode(e.maturity)), o.push(new (0, $2cJiB.NumberCoder)("u16").encode(e.bytecodeLength)), o.push(new (0, $2cJiB.NumberCoder)("u8").encode(e.bytecodeWitnessIndex)), o.push(new (0, $2cJiB.NumberCoder)("u16").encode(e.storageSlotsCount)), o.push(new (0, $2cJiB.NumberCoder)("u8").encode(e.inputsCount)), o.push(new (0, $2cJiB.NumberCoder)("u8").encode(e.outputsCount)), o.push(new (0, $2cJiB.NumberCoder)("u8").encode(e.witnessesCount)), o.push(new (0, $2cJiB.B256Coder)().encode(e.salt)), o.push(new (0, $2cJiB.ArrayCoder)(new $3ddb905e95ba55ee$export$a1c5b1cca91e84ca, e.storageSlotsCount).encode(e.storageSlots)), o.push(new (0, $2cJiB.ArrayCoder)(new $3ddb905e95ba55ee$export$7739f7d8d6218f9, e.inputsCount).encode(e.inputs)), o.push(new (0, $2cJiB.ArrayCoder)(new $3ddb905e95ba55ee$export$fc1634d0be8612df, e.outputsCount).encode(e.outputs)), o.push(new (0, $2cJiB.ArrayCoder)(new $3ddb905e95ba55ee$export$bb65a7609b522cec, e.witnessesCount).encode(e.witnesses)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.U64Coder)().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                ref2 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u32").decode(e, t), 2), n = ref2[0], t = ref2[1], ref2;
                var i = n;
                var ref3;
                ref3 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u16").decode(e, t), 2), n = ref3[0], t = ref3[1], ref3;
                var y = n;
                var ref4;
                ref4 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u8").decode(e, t), 2), n = ref4[0], t = ref4[1], ref4;
                var h = n;
                var ref5;
                ref5 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u16").decode(e, t), 2), n = ref5[0], t = ref5[1], ref5;
                var g = n;
                var ref6;
                ref6 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u8").decode(e, t), 2), n = ref6[0], t = ref6[1], ref6;
                var u = n;
                var ref7;
                ref7 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u8").decode(e, t), 2), n = ref7[0], t = ref7[1], ref7;
                var x = n;
                var ref8;
                ref8 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u8").decode(e, t), 2), n = ref8[0], t = ref8[1], ref8;
                var U = n;
                var ref9;
                ref9 = (0, $8GFUW._)(new (0, $2cJiB.B256Coder)().decode(e, t), 2), n = ref9[0], t = ref9[1], ref9;
                var M = n;
                var ref10;
                ref10 = (0, $8GFUW._)(new (0, $2cJiB.ArrayCoder)(new $3ddb905e95ba55ee$export$a1c5b1cca91e84ca, g).decode(e, t), 2), n = ref10[0], t = ref10[1], ref10;
                var H = n;
                var ref11;
                ref11 = (0, $8GFUW._)(new (0, $2cJiB.ArrayCoder)(new $3ddb905e95ba55ee$export$7739f7d8d6218f9, u).decode(e, t), 2), n = ref11[0], t = ref11[1], ref11;
                var Re = n;
                var ref12;
                ref12 = (0, $8GFUW._)(new (0, $2cJiB.ArrayCoder)(new $3ddb905e95ba55ee$export$fc1634d0be8612df, x).decode(e, t), 2), n = ref12[0], t = ref12[1], ref12;
                var xe = n;
                var ref13;
                return ref13 = (0, $8GFUW._)(new (0, $2cJiB.ArrayCoder)(new $3ddb905e95ba55ee$export$bb65a7609b522cec, U).decode(e, t), 2), n = ref13[0], t = ref13[1], ref13, [
                    {
                        type: 1,
                        gasPrice: s,
                        gasLimit: c,
                        maturity: i,
                        bytecodeLength: y,
                        bytecodeWitnessIndex: h,
                        storageSlotsCount: g,
                        inputsCount: u,
                        outputsCount: x,
                        witnessesCount: U,
                        salt: M,
                        storageSlots: H,
                        inputs: Re,
                        outputs: xe,
                        witnesses: n
                    },
                    t
                ];
            }
        }
    ]);
    return ye;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$ae6abb231cb27953 = /*#__PURE__*/ function(ge) {
    "use strict";
    (0, $ftJVG._)(he, ge);
    var _super = (0, $6OZAO._)(he);
    function he() {
        (0, $978gY._)(this, he);
        return _super.call(this, "TransactionMint", "struct TransactionMint", 0);
    }
    (0, $kry2a._)(he, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                return o.push(new $3ddb905e95ba55ee$export$820db62f9f041f63().encode(e.txPointer)), o.push(new (0, $2cJiB.NumberCoder)("u8").encode(e.outputsCount)), o.push(new (0, $2cJiB.ArrayCoder)(new $3ddb905e95ba55ee$export$fc1634d0be8612df, e.outputsCount).encode(e.outputs)), (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                ref = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$820db62f9f041f63().decode(e, t), 2), n = ref[0], t = ref[1], ref;
                var s = n;
                var ref1;
                ref1 = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u8").decode(e, t), 2), n = ref1[0], t = ref1[1], ref1;
                var c = n;
                var ref2;
                return ref2 = (0, $8GFUW._)(new (0, $2cJiB.ArrayCoder)(new $3ddb905e95ba55ee$export$fc1634d0be8612df, c).decode(e, t), 2), n = ref2[0], t = ref2[1], ref2, [
                    {
                        type: 2,
                        outputsCount: c,
                        outputs: n,
                        txPointer: s
                    },
                    t
                ];
            }
        }
    ]);
    return he;
}((0, $2cJiB.Coder)), $3ddb905e95ba55ee$export$af003d88cba46f8c = /*#__PURE__*/ function(ge) {
    "use strict";
    (0, $ftJVG._)(Be, ge);
    var _super = (0, $6OZAO._)(Be);
    function Be() {
        (0, $978gY._)(this, Be);
        return _super.call(this, "Transaction", "struct Transaction", 0);
    }
    (0, $kry2a._)(Be, [
        {
            key: "encode",
            value: function encode(e) {
                var o = [];
                switch(o.push(new (0, $2cJiB.NumberCoder)("u8").encode(e.type)), e.type){
                    case 0:
                        o.push(new $3ddb905e95ba55ee$export$75004a9f23a253ee().encode(e));
                        break;
                    case 1:
                        o.push(new $3ddb905e95ba55ee$export$8ad8d50ba64eb3bd().encode(e));
                        break;
                    case 2:
                        o.push(new $3ddb905e95ba55ee$export$ae6abb231cb27953().encode(e));
                        break;
                    default:
                        throw new Error("Invalid Transaction type");
                }
                return (0, $j2rU8.concat)(o);
            }
        },
        {
            key: "decode",
            value: function decode(e, o) {
                var n, t = o;
                var ref;
                switch(ref = (0, $8GFUW._)(new (0, $2cJiB.NumberCoder)("u8").decode(e, t), 2), n = ref[0], t = ref[1], ref, n){
                    case 0:
                        var ref1;
                        return ref1 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$75004a9f23a253ee().decode(e, t), 2), n = ref1[0], t = ref1[1], ref1, [
                            n,
                            t
                        ];
                    case 1:
                        var ref2;
                        return ref2 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$8ad8d50ba64eb3bd().decode(e, t), 2), n = ref2[0], t = ref2[1], ref2, [
                            n,
                            t
                        ];
                    case 2:
                        var ref3;
                        return ref3 = (0, $8GFUW._)(new $3ddb905e95ba55ee$export$ae6abb231cb27953().decode(e, t), 2), n = ref3[0], t = ref3[1], ref3, [
                            n,
                            t
                        ];
                    default:
                        throw new Error("Invalid Transaction type");
                }
            }
        }
    ]);
    return Be;
}((0, $2cJiB.Coder));

});

parcelRequire.register("9aGYB", function(module, exports) {

$parcel$export(module.exports, "MAX_GAS_PER_TX", function () { return $bb39ac9b68c85f69$export$203f0f916e8bb760; });
$parcel$export(module.exports, "GAS_PRICE_FACTOR", function () { return $bb39ac9b68c85f69$export$a50b4a7a87353e2f; });
$parcel$export(module.exports, "FAILED_REQUIRE_SIGNAL", function () { return $bb39ac9b68c85f69$export$df36db089e965aed; });
$parcel$export(module.exports, "FAILED_TRANSFER_TO_ADDRESS_SIGNAL", function () { return $bb39ac9b68c85f69$export$35c999274b8952ea; });
$parcel$export(module.exports, "FAILED_SEND_MESSAGE_SIGNAL", function () { return $bb39ac9b68c85f69$export$3f1eb4d637f08834; });
$parcel$export(module.exports, "FAILED_ASSERT_EQ_SIGNAL", function () { return $bb39ac9b68c85f69$export$8ec22fe14f5d061c; });
$parcel$export(module.exports, "FAILED_ASSERT_SIGNAL", function () { return $bb39ac9b68c85f69$export$59921c43316de236; });
$parcel$export(module.exports, "FAILED_UNKNOWN_SIGNAL", function () { return $bb39ac9b68c85f69$export$2df71c376f78c2c5; });

var $4x96T = parcelRequire("4x96T");
var $bb39ac9b68c85f69$export$19d449db502ba9a = 16384, $bb39ac9b68c85f69$export$fadadc6a80733e14 = 16, $bb39ac9b68c85f69$export$203f0f916e8bb760 = (0, $4x96T.bn)(1e8), $bb39ac9b68c85f69$export$a50b4a7a87353e2f = (0, $4x96T.bn)(1e9), $bb39ac9b68c85f69$export$1a162be368da37d5 = (0, $4x96T.bn)(4), $bb39ac9b68c85f69$export$1c74d3faa6b4d6ff = 1073741824, $bb39ac9b68c85f69$export$940d35b49fcc3439 = 1073741824, $bb39ac9b68c85f69$export$630fbff50102e57b = 255, $bb39ac9b68c85f69$export$c426f16e7c4cf36f = 1048576, $bb39ac9b68c85f69$export$656e10f08a956434 = 1048576, $bb39ac9b68c85f69$export$df36db089e965aed = "0xffffffffffff0000", $bb39ac9b68c85f69$export$35c999274b8952ea = "0xffffffffffff0001", $bb39ac9b68c85f69$export$3f1eb4d637f08834 = "0xffffffffffff0002", $bb39ac9b68c85f69$export$8ec22fe14f5d061c = "0xffffffffffff0003", $bb39ac9b68c85f69$export$59921c43316de236 = "0xffffffffffff0004", $bb39ac9b68c85f69$export$2df71c376f78c2c5 = "0x0";

});

parcelRequire.register("aMiMS", function(module, exports) {

$parcel$export(module.exports, "coinQuantityfy", function () { return $40b8fd6d72165de4$export$6cb165a1d7cc3467; });
$parcel$export(module.exports, "withdrawScript", function () { return $40b8fd6d72165de4$export$28b2ae312daf6d32; });
$parcel$export(module.exports, "ScriptTransactionRequest", function () { return $40b8fd6d72165de4$export$868178e040d1351; });
$parcel$export(module.exports, "CreateTransactionRequest", function () { return $40b8fd6d72165de4$export$7f43d937bb96a8c9; });
$parcel$export(module.exports, "transactionRequestify", function () { return $40b8fd6d72165de4$export$422bec23dd9c4031; });
$parcel$export(module.exports, "Provider", function () { return $40b8fd6d72165de4$export$2881499e37b75b9a; });
$parcel$export(module.exports, "getDecodedLogs", function () { return $40b8fd6d72165de4$export$d01f8bb64d304ad0; });
$parcel$export(module.exports, "TransactionType", function () { return (parcelRequire("lcJUd")).TransactionType; });

var $3vWwE = parcelRequire("3vWwE");

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $gPjjc = parcelRequire("gPjjc");

var $ho5gk = parcelRequire("ho5gk");

var $11fbC = parcelRequire("11fbC");

var $fLnyw = parcelRequire("fLnyw");

var $1ObTH = parcelRequire("1ObTH");

var $2TMdq = parcelRequire("2TMdq");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $j2rU8 = parcelRequire("j2rU8");

var $jt0st = parcelRequire("jt0st");

var $4x96T = parcelRequire("4x96T");

var $k1BEe = parcelRequire("k1BEe");

var $1nhBg = parcelRequire("1nhBg");

var $lcJUd = parcelRequire("lcJUd");

var $9aGYB = parcelRequire("9aGYB");

var $gkqPm = parcelRequire("gkqPm");

var $51Bw9 = parcelRequire("51Bw9");

var $2cJiB = parcelRequire("2cJiB");
function $40b8fd6d72165de4$var$_templateObject() {
    var data = (0, $11fbC._)([
        "\n    fragment transactionFragment on Transaction {\n  id\n  rawPayload\n  gasPrice\n  status {\n    type: __typename\n    ... on SubmittedStatus {\n      time\n    }\n    ... on SuccessStatus {\n      block {\n        id\n      }\n      time\n      programState {\n        returnType\n        data\n      }\n    }\n    ... on FailureStatus {\n      block {\n        id\n      }\n      time\n      reason\n    }\n  }\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject1() {
    var data = (0, $11fbC._)([
        "\n    fragment receiptFragment on Receipt {\n  data\n  rawPayload\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject2() {
    var data = (0, $11fbC._)([
        "\n    fragment coinFragment on Coin {\n  utxoId\n  owner\n  amount\n  assetId\n  maturity\n  coinStatus: status\n  blockCreated\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject3() {
    var data = (0, $11fbC._)([
        "\n    fragment messageFragment on Message {\n  amount\n  sender\n  recipient\n  data\n  nonce\n  messageStatus: status\n  daHeight\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject4() {
    var data = (0, $11fbC._)([
        "\n    fragment messageProofFragment on MessageProof {\n  proofSet\n  proofIndex\n  sender\n  recipient\n  nonce\n  amount\n  data\n  signature\n  header {\n    id\n    daHeight\n    transactionsCount\n    outputMessagesCount\n    transactionsRoot\n    outputMessagesRoot\n    height\n    prevRoot\n    time\n    applicationHash\n  }\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject5() {
    var data = (0, $11fbC._)([
        "\n    fragment balanceFragment on Balance {\n  owner\n  amount\n  assetId\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject6() {
    var data = (0, $11fbC._)([
        "\n    fragment consensusParametersFragment on ConsensusParameters {\n  contractMaxSize\n  maxInputs\n  maxOutputs\n  maxWitnesses\n  maxGasPerTx\n  maxScriptLength\n  maxScriptDataLength\n  maxStorageSlots\n  maxPredicateLength\n  maxPredicateDataLength\n  gasPriceFactor\n  gasPerByte\n  maxMessageDataLength\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject7() {
    var data = (0, $11fbC._)([
        "\n    fragment blockFragment on Block {\n  id\n  header {\n    height\n    time\n  }\n  transactions {\n    id\n  }\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject8() {
    var data = (0, $11fbC._)([
        "\n    fragment chainInfoFragment on ChainInfo {\n  name\n  baseChainHeight\n  peerCount\n  consensusParameters {\n    ...consensusParametersFragment\n  }\n  latestBlock {\n    ...blockFragment\n  }\n}\n    ",
        "\n",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject9() {
    var data = (0, $11fbC._)([
        "\n    fragment contractBalanceFragment on ContractBalance {\n  contract\n  amount\n  assetId\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject10() {
    var data = (0, $11fbC._)([
        "\n    query getVersion {\n  nodeInfo {\n    nodeVersion\n  }\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject11() {
    var data = (0, $11fbC._)([
        "\n    query getInfo {\n  nodeInfo {\n    nodeVersion\n    minGasPrice\n  }\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject12() {
    var data = (0, $11fbC._)([
        "\n    query getChain {\n  chain {\n    ...chainInfoFragment\n  }\n}\n    ",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject13() {
    var data = (0, $11fbC._)([
        "\n    query getTransaction($transactionId: TransactionId!) {\n  transaction(id: $transactionId) {\n    ...transactionFragment\n  }\n}\n    ",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject14() {
    var data = (0, $11fbC._)([
        "\n    query getTransactionWithReceipts($transactionId: TransactionId!) {\n  transaction(id: $transactionId) {\n    ...transactionFragment\n    receipts {\n      ...receiptFragment\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject15() {
    var data = (0, $11fbC._)([
        "\n    query getTransactions($after: String, $before: String, $first: Int, $last: Int) {\n  transactions(after: $after, before: $before, first: $first, last: $last) {\n    edges {\n      node {\n        ...transactionFragment\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject16() {
    var data = (0, $11fbC._)([
        "\n    query getTransactionsByOwner($owner: Address!, $after: String, $before: String, $first: Int, $last: Int) {\n  transactionsByOwner(\n    owner: $owner\n    after: $after\n    before: $before\n    first: $first\n    last: $last\n  ) {\n    edges {\n      node {\n        ...transactionFragment\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject17() {
    var data = (0, $11fbC._)([
        "\n    query getBlock($blockId: BlockId, $blockHeight: U64) {\n  block(id: $blockId, height: $blockHeight) {\n    ...blockFragment\n  }\n}\n    ",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject18() {
    var data = (0, $11fbC._)([
        "\n    query getBlockWithTransactions($blockId: BlockId, $blockHeight: U64) {\n  block(id: $blockId, height: $blockHeight) {\n    ...blockFragment\n    transactions {\n      ...transactionFragment\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject19() {
    var data = (0, $11fbC._)([
        "\n    query getBlocks($after: String, $before: String, $first: Int, $last: Int) {\n  blocks(after: $after, before: $before, first: $first, last: $last) {\n    edges {\n      node {\n        ...blockFragment\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject20() {
    var data = (0, $11fbC._)([
        "\n    query getCoin($coinId: UtxoId!) {\n  coin(utxoId: $coinId) {\n    ...coinFragment\n  }\n}\n    ",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject21() {
    var data = (0, $11fbC._)([
        "\n    query getCoins($filter: CoinFilterInput!, $after: String, $before: String, $first: Int, $last: Int) {\n  coins(\n    filter: $filter\n    after: $after\n    before: $before\n    first: $first\n    last: $last\n  ) {\n    edges {\n      node {\n        ...coinFragment\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject22() {
    var data = (0, $11fbC._)([
        "\n    query getResourcesToSpend($owner: Address!, $queryPerAsset: [SpendQueryElementInput!]!, $excludedIds: ExcludeInput) {\n  resourcesToSpend(\n    owner: $owner\n    queryPerAsset: $queryPerAsset\n    excludedIds: $excludedIds\n  ) {\n    ...coinFragment\n    ...messageFragment\n  }\n}\n    ",
        "\n",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject23() {
    var data = (0, $11fbC._)([
        "\n    query getContract($contractId: ContractId!) {\n  contract(id: $contractId) {\n    bytecode\n    id\n  }\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject24() {
    var data = (0, $11fbC._)([
        "\n    query getContractBalance($contract: ContractId!, $asset: AssetId!) {\n  contractBalance(contract: $contract, asset: $asset) {\n    ...contractBalanceFragment\n  }\n}\n    ",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject25() {
    var data = (0, $11fbC._)([
        "\n    query getBalance($owner: Address!, $assetId: AssetId!) {\n  balance(owner: $owner, assetId: $assetId) {\n    ...balanceFragment\n  }\n}\n    ",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject26() {
    var data = (0, $11fbC._)([
        "\n    query getBalances($filter: BalanceFilterInput!, $after: String, $before: String, $first: Int, $last: Int) {\n  balances(\n    filter: $filter\n    after: $after\n    before: $before\n    first: $first\n    last: $last\n  ) {\n    edges {\n      node {\n        ...balanceFragment\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject27() {
    var data = (0, $11fbC._)([
        "\n    query getMessages($owner: Address!, $after: String, $before: String, $first: Int, $last: Int) {\n  messages(\n    owner: $owner\n    after: $after\n    before: $before\n    first: $first\n    last: $last\n  ) {\n    edges {\n      node {\n        ...messageFragment\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject28() {
    var data = (0, $11fbC._)([
        "\n    query getMessageProof($transactionId: TransactionId!, $messageId: MessageId!) {\n  messageProof(transactionId: $transactionId, messageId: $messageId) {\n    ...messageProofFragment\n  }\n}\n    ",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject29() {
    var data = (0, $11fbC._)([
        "\n    mutation dryRun($encodedTransaction: HexString!, $utxoValidation: Boolean) {\n  dryRun(tx: $encodedTransaction, utxoValidation: $utxoValidation) {\n    ...receiptFragment\n  }\n}\n    ",
        ""
    ]);
    $40b8fd6d72165de4$var$_templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject30() {
    var data = (0, $11fbC._)([
        "\n    mutation submit($encodedTransaction: HexString!) {\n  submit(tx: $encodedTransaction) {\n    id\n  }\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject31() {
    var data = (0, $11fbC._)([
        "\n    mutation startSession {\n  startSession\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject32() {
    var data = (0, $11fbC._)([
        "\n    mutation endSession($sessionId: ID!) {\n  endSession(id: $sessionId)\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject33() {
    var data = (0, $11fbC._)([
        "\n    mutation execute($sessionId: ID!, $op: String!) {\n  execute(id: $sessionId, op: $op)\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject34() {
    var data = (0, $11fbC._)([
        "\n    mutation reset($sessionId: ID!) {\n  reset(id: $sessionId)\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function $40b8fd6d72165de4$var$_templateObject35() {
    var data = (0, $11fbC._)([
        "\n    mutation produceBlocks($blocksToProduce: U64!, $time: TimeParameters) {\n  produceBlocks(blocksToProduce: $blocksToProduce, time: $time)\n}\n    "
    ]);
    $40b8fd6d72165de4$var$_templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
var $40b8fd6d72165de4$var$Kt = Object.defineProperty;
var $40b8fd6d72165de4$var$Xt = function(r, t, e) {
    return t in r ? $40b8fd6d72165de4$var$Kt(r, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : r[t] = e;
};
var $40b8fd6d72165de4$var$J = function(r, t, e) {
    return $40b8fd6d72165de4$var$Xt(r, (typeof t === "undefined" ? "undefined" : (0, $1ObTH._)(t)) != "symbol" ? t + "" : t, e), e;
}, $40b8fd6d72165de4$var$Zt = function(r, t, e) {
    if (!t.has(r)) throw TypeError("Cannot " + e);
};
var $40b8fd6d72165de4$var$gt = function(r, t, e) {
    if (t.has(r)) throw TypeError("Cannot add the same private member more than once");
    t instanceof WeakSet ? t.add(r) : t.set(r, e);
};
var $40b8fd6d72165de4$var$dt = function(r, t, e) {
    return $40b8fd6d72165de4$var$Zt(r, t, "access private method"), e;
};
var $40b8fd6d72165de4$export$6cb165a1d7cc3467 = function(r) {
    var s, n, i, p;
    var t, e, a;
    return Array.isArray(r) ? (e = r[0], t = (s = r[1]) != null ? s : (0, $jt0st.NativeAssetId), a = (n = r[2]) != null ? n : void 0) : (e = r.amount, t = (i = r.assetId) != null ? i : (0, $jt0st.NativeAssetId), a = (p = r.max) != null ? p : void 0), {
        assetId: (0, $j2rU8.hexlify)(t),
        amount: (0, $4x96T.bn)(e),
        max: a ? (0, $4x96T.bn)(a) : void 0
    };
};
var $40b8fd6d72165de4$export$76802e3d2d0c5eea = function(e) {
    return e.Spent = "SPENT", e.Unspent = "UNSPENT", e;
}($40b8fd6d72165de4$export$76802e3d2d0c5eea || {}), $40b8fd6d72165de4$export$4963a2999b5870bb = function(e) {
    return e.Spent = "SPENT", e.Unspent = "UNSPENT", e;
}($40b8fd6d72165de4$export$4963a2999b5870bb || {});
var $40b8fd6d72165de4$var$M = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject()), $40b8fd6d72165de4$var$It = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject1()), $40b8fd6d72165de4$var$Y = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject2()), $40b8fd6d72165de4$var$qt = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject3()), $40b8fd6d72165de4$var$Yt = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject4()), $40b8fd6d72165de4$var$bt = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject5()), $40b8fd6d72165de4$var$jt = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject6()), $40b8fd6d72165de4$var$Q = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject7()), $40b8fd6d72165de4$var$te = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject8(), $40b8fd6d72165de4$var$jt, $40b8fd6d72165de4$var$Q), $40b8fd6d72165de4$var$ee = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject9()), $40b8fd6d72165de4$var$ae = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject10()), $40b8fd6d72165de4$var$re = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject11()), $40b8fd6d72165de4$var$se = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject12(), $40b8fd6d72165de4$var$te), $40b8fd6d72165de4$var$ne = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject13(), $40b8fd6d72165de4$var$M), $40b8fd6d72165de4$var$oe = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject14(), $40b8fd6d72165de4$var$M, $40b8fd6d72165de4$var$It), $40b8fd6d72165de4$var$ie = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject15(), $40b8fd6d72165de4$var$M), $40b8fd6d72165de4$var$ce = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject16(), $40b8fd6d72165de4$var$M), $40b8fd6d72165de4$var$ue = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject17(), $40b8fd6d72165de4$var$Q), $40b8fd6d72165de4$var$pe = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject18(), $40b8fd6d72165de4$var$Q, $40b8fd6d72165de4$var$M), $40b8fd6d72165de4$var$le = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject19(), $40b8fd6d72165de4$var$Q), $40b8fd6d72165de4$var$ye = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject20(), $40b8fd6d72165de4$var$Y), $40b8fd6d72165de4$var$me = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject21(), $40b8fd6d72165de4$var$Y), $40b8fd6d72165de4$var$ge = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject22(), $40b8fd6d72165de4$var$Y, $40b8fd6d72165de4$var$qt), $40b8fd6d72165de4$var$de = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject23()), $40b8fd6d72165de4$var$Se = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject24(), $40b8fd6d72165de4$var$ee), $40b8fd6d72165de4$var$xe = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject25(), $40b8fd6d72165de4$var$bt), $40b8fd6d72165de4$var$fe = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject26(), $40b8fd6d72165de4$var$bt), $40b8fd6d72165de4$var$he = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject27(), $40b8fd6d72165de4$var$qt), $40b8fd6d72165de4$var$Ie = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject28(), $40b8fd6d72165de4$var$Yt), $40b8fd6d72165de4$var$qe = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject29(), $40b8fd6d72165de4$var$It), $40b8fd6d72165de4$var$be = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject30()), $40b8fd6d72165de4$var$Te = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject31()), $40b8fd6d72165de4$var$Ge = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject32()), $40b8fd6d72165de4$var$Be = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject33()), $40b8fd6d72165de4$var$Re = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject34()), $40b8fd6d72165de4$var$Ce = (0, $k1BEe.default)($40b8fd6d72165de4$var$_templateObject35()), $40b8fd6d72165de4$var$_e = function(r, t, e) {
    return r();
};
function $40b8fd6d72165de4$var$Tt(r) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $40b8fd6d72165de4$var$_e;
    return {
        getVersion: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$ae, e, (0, $8OnJk._)({}, a, s));
            }, "getVersion", "query");
        },
        getInfo: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$re, e, (0, $8OnJk._)({}, a, s));
            }, "getInfo", "query");
        },
        getChain: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$se, e, (0, $8OnJk._)({}, a, s));
            }, "getChain", "query");
        },
        getTransaction: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$ne, e, (0, $8OnJk._)({}, a, s));
            }, "getTransaction", "query");
        },
        getTransactionWithReceipts: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$oe, e, (0, $8OnJk._)({}, a, s));
            }, "getTransactionWithReceipts", "query");
        },
        getTransactions: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$ie, e, (0, $8OnJk._)({}, a, s));
            }, "getTransactions", "query");
        },
        getTransactionsByOwner: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$ce, e, (0, $8OnJk._)({}, a, s));
            }, "getTransactionsByOwner", "query");
        },
        getBlock: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$ue, e, (0, $8OnJk._)({}, a, s));
            }, "getBlock", "query");
        },
        getBlockWithTransactions: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$pe, e, (0, $8OnJk._)({}, a, s));
            }, "getBlockWithTransactions", "query");
        },
        getBlocks: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$le, e, (0, $8OnJk._)({}, a, s));
            }, "getBlocks", "query");
        },
        getCoin: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$ye, e, (0, $8OnJk._)({}, a, s));
            }, "getCoin", "query");
        },
        getCoins: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$me, e, (0, $8OnJk._)({}, a, s));
            }, "getCoins", "query");
        },
        getResourcesToSpend: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$ge, e, (0, $8OnJk._)({}, a, s));
            }, "getResourcesToSpend", "query");
        },
        getContract: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$de, e, (0, $8OnJk._)({}, a, s));
            }, "getContract", "query");
        },
        getContractBalance: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$Se, e, (0, $8OnJk._)({}, a, s));
            }, "getContractBalance", "query");
        },
        getBalance: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$xe, e, (0, $8OnJk._)({}, a, s));
            }, "getBalance", "query");
        },
        getBalances: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$fe, e, (0, $8OnJk._)({}, a, s));
            }, "getBalances", "query");
        },
        getMessages: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$he, e, (0, $8OnJk._)({}, a, s));
            }, "getMessages", "query");
        },
        getMessageProof: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$Ie, e, (0, $8OnJk._)({}, a, s));
            }, "getMessageProof", "query");
        },
        dryRun: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$qe, e, (0, $8OnJk._)({}, a, s));
            }, "dryRun", "mutation");
        },
        submit: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$be, e, (0, $8OnJk._)({}, a, s));
            }, "submit", "mutation");
        },
        startSession: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$Te, e, (0, $8OnJk._)({}, a, s));
            }, "startSession", "mutation");
        },
        endSession: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$Ge, e, (0, $8OnJk._)({}, a, s));
            }, "endSession", "mutation");
        },
        execute: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$Be, e, (0, $8OnJk._)({}, a, s));
            }, "execute", "mutation");
        },
        reset: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$Re, e, (0, $8OnJk._)({}, a, s));
            }, "reset", "mutation");
        },
        produceBlocks: function(e, a) {
            return t(function(s) {
                return r.request($40b8fd6d72165de4$var$Ce, e, (0, $8OnJk._)({}, a, s));
            }, "produceBlocks", "mutation");
        }
    };
}
var $40b8fd6d72165de4$var$T = {}, $40b8fd6d72165de4$var$ke = 30000, $40b8fd6d72165de4$var$$ = /*#__PURE__*/ function() {
    "use strict";
    function $() {
        var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $40b8fd6d72165de4$var$ke;
        (0, $978gY._)(this, $);
        (0, $dxWQo._)(this, "ttl", void 0);
        if (this.ttl = t, typeof t != "number" || this.ttl <= 0) throw new Error("Invalid TTL: ".concat(this.ttl, ". Use a value greater than zero."));
    }
    (0, $kry2a._)($, [
        {
            key: "get",
            value: function get(t) {
                var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                var a = (0, $j2rU8.hexlify)(t);
                if ($40b8fd6d72165de4$var$T[a]) {
                    if (!e || $40b8fd6d72165de4$var$T[a].expires > Date.now()) return $40b8fd6d72165de4$var$T[a].value;
                    this.del(t);
                }
            }
        },
        {
            key: "set",
            value: function set(t) {
                var e = Date.now() + this.ttl, a = (0, $j2rU8.hexlify)(t);
                return $40b8fd6d72165de4$var$T[a] = {
                    expires: e,
                    value: t
                }, e;
            }
        },
        {
            key: "getAllData",
            value: function getAllData() {
                var _this = this;
                return Object.keys($40b8fd6d72165de4$var$T).reduce(function(t, e) {
                    var a = _this.get(e, !1);
                    return a && t.push(a), t;
                }, []);
            }
        },
        {
            key: "getActiveData",
            value: function getActiveData() {
                var _this = this;
                return Object.keys($40b8fd6d72165de4$var$T).reduce(function(t, e) {
                    var a = _this.get(e);
                    return a && t.push(a), t;
                }, []);
            }
        },
        {
            key: "del",
            value: function del(t) {
                var e = (0, $j2rU8.hexlify)(t);
                delete $40b8fd6d72165de4$var$T[e];
            }
        }
    ]);
    return $;
}();
var $40b8fd6d72165de4$export$a1898ba9a0c55d56 = function(r) {
    return "utxoId" in r;
}, $40b8fd6d72165de4$export$dd84ffb770953615 = function(r) {
    return "recipient" in r;
}, $40b8fd6d72165de4$export$212a4cae42b33101 = function(r) {
    return "id" in r;
}, $40b8fd6d72165de4$export$9e0e49e75fa7d548 = function(r) {
    return "recipient" in r;
};
var $40b8fd6d72165de4$export$43aab34a9c1ab39c = function(r) {
    var t, e, a, s, n;
    switch(r.type){
        case (0, $lcJUd.InputType).Coin:
            {
                var i = (0, $j2rU8.arrayify)((t = r.predicate) != null ? t : "0x"), p = (0, $j2rU8.arrayify)((e = r.predicateData) != null ? e : "0x");
                return {
                    type: (0, $lcJUd.InputType).Coin,
                    utxoID: {
                        transactionId: (0, $j2rU8.hexlify)((0, $j2rU8.arrayify)(r.id).slice(0, 32)),
                        outputIndex: (0, $j2rU8.arrayify)(r.id)[32]
                    },
                    owner: (0, $j2rU8.hexlify)(r.owner),
                    amount: (0, $4x96T.bn)(r.amount),
                    assetId: (0, $j2rU8.hexlify)(r.assetId),
                    txPointer: {
                        blockHeight: (0, $4x96T.toNumber)((0, $j2rU8.arrayify)(r.txPointer).slice(0, 8)),
                        txIndex: (0, $4x96T.toNumber)((0, $j2rU8.arrayify)(r.txPointer).slice(8, 16))
                    },
                    witnessIndex: r.witnessIndex,
                    maturity: (a = r.maturity) != null ? a : 0,
                    predicateLength: i.length,
                    predicateDataLength: p.length,
                    predicate: (0, $j2rU8.hexlify)(i),
                    predicateData: (0, $j2rU8.hexlify)(p)
                };
            }
        case (0, $lcJUd.InputType).Contract:
            return {
                type: (0, $lcJUd.InputType).Contract,
                utxoID: {
                    transactionId: (0, $jt0st.ZeroBytes32),
                    outputIndex: 0
                },
                balanceRoot: (0, $jt0st.ZeroBytes32),
                stateRoot: (0, $jt0st.ZeroBytes32),
                txPointer: {
                    blockHeight: (0, $4x96T.toNumber)((0, $j2rU8.arrayify)(r.txPointer).slice(0, 8)),
                    txIndex: (0, $4x96T.toNumber)((0, $j2rU8.arrayify)(r.txPointer).slice(8, 16))
                },
                contractID: (0, $j2rU8.hexlify)(r.contractId)
            };
        case (0, $lcJUd.InputType).Message:
            {
                var i1 = (0, $j2rU8.arrayify)((s = r.predicate) != null ? s : "0x"), p1 = (0, $j2rU8.arrayify)((n = r.predicateData) != null ? n : "0x");
                return {
                    type: (0, $lcJUd.InputType).Message,
                    sender: (0, $j2rU8.hexlify)(r.sender),
                    recipient: (0, $j2rU8.hexlify)(r.recipient),
                    amount: (0, $4x96T.bn)(r.amount),
                    nonce: (0, $4x96T.bn)(r.nonce),
                    witnessIndex: r.witnessIndex,
                    dataLength: r.data.length,
                    predicateLength: i1.length,
                    predicateDataLength: p1.length,
                    data: (0, $j2rU8.hexlify)(r.data),
                    predicate: (0, $j2rU8.hexlify)(i1),
                    predicateData: (0, $j2rU8.hexlify)(p1)
                };
            }
        default:
            throw new Error("Invalid Input type");
    }
};
var $40b8fd6d72165de4$export$6e5ca75ddfee84fb = function(r) {
    switch(r.type){
        case (0, $lcJUd.OutputType).Coin:
            return {
                type: (0, $lcJUd.OutputType).Coin,
                to: (0, $j2rU8.hexlify)(r.to),
                amount: (0, $4x96T.bn)(r.amount),
                assetId: (0, $j2rU8.hexlify)(r.assetId)
            };
        case (0, $lcJUd.OutputType).Contract:
            return {
                type: (0, $lcJUd.OutputType).Contract,
                inputIndex: r.inputIndex,
                balanceRoot: (0, $jt0st.ZeroBytes32),
                stateRoot: (0, $jt0st.ZeroBytes32)
            };
        case (0, $lcJUd.OutputType).Message:
            return {
                type: (0, $lcJUd.OutputType).Message,
                recipient: (0, $j2rU8.hexlify)(r.recipient),
                amount: (0, $4x96T.bn)(r.amount)
            };
        case (0, $lcJUd.OutputType).Change:
            return {
                type: (0, $lcJUd.OutputType).Change,
                to: (0, $j2rU8.hexlify)(r.to),
                amount: (0, $4x96T.bn)(0),
                assetId: (0, $j2rU8.hexlify)(r.assetId)
            };
        case (0, $lcJUd.OutputType).Variable:
            return {
                type: (0, $lcJUd.OutputType).Variable,
                to: (0, $jt0st.ZeroBytes32),
                amount: (0, $4x96T.bn)(0),
                assetId: (0, $jt0st.ZeroBytes32)
            };
        case (0, $lcJUd.OutputType).ContractCreated:
            return {
                type: (0, $lcJUd.OutputType).ContractCreated,
                contractId: (0, $j2rU8.hexlify)(r.contractId),
                stateRoot: (0, $j2rU8.hexlify)(r.stateRoot)
            };
        default:
            throw new Error("Invalid Output type");
    }
};
var $40b8fd6d72165de4$var$Pe = function(r) {
    return r.type === (0, $lcJUd.ReceiptType).Revert && r.val.toString("hex") === (0, $9aGYB.FAILED_TRANSFER_TO_ADDRESS_SIGNAL);
}, $40b8fd6d72165de4$var$Ae = function(r) {
    return r.type === (0, $lcJUd.ReceiptType).Panic && r.contractId !== "0x0000000000000000000000000000000000000000000000000000000000000000";
}, $40b8fd6d72165de4$export$9ac47654207eadfd = function(r) {
    return r.reduce(function(t, e) {
        return $40b8fd6d72165de4$var$Pe(e) && t.missingOutputVariables.push(e), $40b8fd6d72165de4$var$Ae(e) && t.missingOutputContractIds.push(e), t;
    }, {
        missingOutputVariables: [],
        missingOutputContractIds: []
    });
};
var $40b8fd6d72165de4$export$ea8158c2fc323594 = function(r, t, e) {
    return (0, $4x96T.bn)(Math.ceil(r.toNumber() / e.toNumber()) * t.toNumber());
}, $40b8fd6d72165de4$export$5cb0cdf1749235fb = function(r) {
    var t = r.find(function(e) {
        return e.type === (0, $lcJUd.ReceiptType).ScriptResult;
    });
    return t && t.type === (0, $lcJUd.ReceiptType).ScriptResult ? t.gasUsed : (0, $4x96T.bn)(0);
}, $40b8fd6d72165de4$export$4a3b6cfdf61e19ee = function(param) {
    var r = param.receipts, t = param.gasPrice, e = param.margin;
    var a = (0, $4x96T.multiply)($40b8fd6d72165de4$export$5cb0cdf1749235fb(r), e || 1), s = $40b8fd6d72165de4$export$ea8158c2fc323594(a, t, (0, $9aGYB.GAS_PRICE_FACTOR));
    return {
        gasUsed: a,
        fee: s
    };
};
var $40b8fd6d72165de4$var$De = "https://fuellabs.github.io/block-explorer-v2", $40b8fd6d72165de4$var$Qe = function(r, t) {
    return "".concat({
        address: "address",
        txId: "transaction",
        blockNumber: "block"
    }[r] || r, "/").concat(t);
}, $40b8fd6d72165de4$export$1a648dafcf933c42 = function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var t = r.blockExplorerUrl, e = r.path, a = r.providerUrl, s = r.address, n = r.txId, i = r.blockNumber, p = t || $40b8fd6d72165de4$var$De, m = [
        {
            key: "address",
            value: s
        },
        {
            key: "txId",
            value: n
        },
        {
            key: "blockNumber",
            value: i
        }
    ], c = m.filter(function(b) {
        return !!b.value;
    }).map(function(param) {
        var b = param.key, Z = param.value;
        return {
            key: b,
            value: Z
        };
    }), q = c.length > 0;
    if (c.length > 1) throw new Error("Only one of the following can be passed in to buildBlockExplorerUrl: ".concat(m.map(function(b) {
        return b.key;
    }).join(", ")));
    if (e && c.length > 0) {
        var b = m.map(function(param) {
            var Z = param.key;
            return Z;
        }).join(", ");
        throw new Error("You cannot pass in a path to buildBlockExplorerUrl along with any of the following: ".concat(b));
    }
    var L = q ? $40b8fd6d72165de4$var$Qe(c[0].key, c[0].value) : "", X = /^\/|\/$/gm, vt = e ? e.replace(X, "") : L, yt = p.replace(X, ""), k = a == null ? void 0 : a.replace(X, ""), mt = k ? encodeURIComponent(k) : void 0, Wt = yt.match(/^https?:\/\//) ? "" : "https://", zt = k != null && k.match(/^https?:\/\//) ? "" : "https://";
    return "".concat(Wt).concat(yt, "/").concat(vt).concat(mt ? "?providerUrl=".concat(zt).concat(mt) : "");
};
function $40b8fd6d72165de4$var$rt(r) {
    return Object.keys(r).forEach(function(t) {
        var e;
        switch((e = r[t]) == null ? void 0 : e.constructor.name){
            case "Uint8Array":
                r[t] = (0, $j2rU8.hexlify)(r[t]);
                break;
            case "Array":
                r[t] = $40b8fd6d72165de4$var$rt(r[t]);
                break;
            case "BN":
                r[t] = r[t].toHex();
                break;
            case "Address":
                r[t] = r[t].toB256();
                break;
            case "Object":
                r[t] = $40b8fd6d72165de4$var$rt(r[t]);
                break;
            default:
                break;
        }
    }), r;
}
function $40b8fd6d72165de4$export$d820d5a7ece8be35(r) {
    return $40b8fd6d72165de4$var$rt((0, (/*@__PURE__*/$parcel$interopDefault($51Bw9)))(r));
}
function $40b8fd6d72165de4$export$e772c8ff12451969(r) {
    return new Promise(function(t) {
        setTimeout(function() {
            t(!0);
        }, r);
    });
}
var $40b8fd6d72165de4$export$26d424e4acff131b = function(r) {
    return Number(BigInt(r) - BigInt(4611686018427388e3) - BigInt(10));
}, $40b8fd6d72165de4$export$2d0bd8e90d83c508 = function(r) {
    return (BigInt(r) + BigInt(4611686018427388e3) + BigInt(10)).toString();
};
var $40b8fd6d72165de4$var$Ee = function(r) {
    var t = new Uint8Array(32);
    return t.set((0, $j2rU8.arrayify)(r)), t;
}, $40b8fd6d72165de4$var$Ot = function(r) {
    var t, e;
    return Array.isArray(r) ? (t = r[0], e = r[1]) : (t = r.key, e = r.value), {
        key: (0, $j2rU8.hexlify)(t),
        value: (0, $j2rU8.hexlify)($40b8fd6d72165de4$var$Ee(e))
    };
};
var $40b8fd6d72165de4$var$Lt = function(r) {
    var t = (0, $j2rU8.arrayify)(r);
    return {
        data: (0, $j2rU8.hexlify)(t),
        dataLength: t.length
    };
};
var $40b8fd6d72165de4$export$640d343391073bbc = {
    bytes: (0, $j2rU8.arrayify)("0x24000000"),
    encodeScriptData: function() {
        return new Uint8Array(0);
    }
}, $40b8fd6d72165de4$export$28b2ae312daf6d32 = {
    bytes: (0, $j2rU8.arrayify)("0x5040C0105D44C0064C40001124000000"),
    encodeScriptData: function() {
        return new Uint8Array(0);
    }
}, $40b8fd6d72165de4$export$9ba234089e16d7a0 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $ftJVG._)(ot, Error1);
    var _super = (0, $6OZAO._)(ot);
    function ot() {
        (0, $978gY._)(this, ot);
        var _this;
        _this = _super.apply(this, arguments);
        (0, $dxWQo._)((0, $3vWwE._)(_this), "name", "ChangeOutputCollisionError");
        (0, $dxWQo._)((0, $3vWwE._)(_this), "message", 'A ChangeOutput with the same "assetId" already exists for a different "to" address');
        return _this;
    }
    return ot;
}((0, $2TMdq._)(Error)), $40b8fd6d72165de4$export$1569427d86ecc9d6 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $ftJVG._)(it, Error1);
    var _super = (0, $6OZAO._)(it);
    function it(e) {
        (0, $978gY._)(this, it);
        var _this;
        _this = _super.call(this);
        (0, $dxWQo._)((0, $3vWwE._)(_this), "name", "NoWitnessAtIndexError");
        _this.index = e;
        _this.message = 'Witness at index "'.concat(e, '" was not found');
        return _this;
    }
    return it;
}((0, $2TMdq._)(Error)), $40b8fd6d72165de4$export$5bcc04ca4e49f428 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $ftJVG._)(ct, Error1);
    var _super = (0, $6OZAO._)(ct);
    function ct(e) {
        (0, $978gY._)(this, ct);
        var _this;
        _this = _super.call(this);
        (0, $dxWQo._)((0, $3vWwE._)(_this), "name", "NoWitnessByOwnerError");
        _this.owner = e;
        _this.message = 'A witness for the given owner "'.concat(e, '" was not found');
        return _this;
    }
    return ct;
}((0, $2TMdq._)(Error)), $40b8fd6d72165de4$var$V = /*#__PURE__*/ function() {
    "use strict";
    function V() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = _ref.gasPrice, e = _ref.gasLimit, a = _ref.maturity, s = _ref.inputs, n = _ref.outputs, i = _ref.witnesses;
        (0, $978gY._)(this, V);
        (0, $dxWQo._)(this, "gasPrice", void 0);
        (0, $dxWQo._)(this, "gasLimit", void 0);
        (0, $dxWQo._)(this, "maturity", void 0);
        (0, $dxWQo._)(this, "inputs", []);
        (0, $dxWQo._)(this, "outputs", []);
        (0, $dxWQo._)(this, "witnesses", []);
        this.gasPrice = (0, $4x96T.bn)(t != null ? t : 0), this.gasLimit = (0, $4x96T.bn)(e != null ? e : 0), this.maturity = a != null ? a : 0, this.inputs = (0, $fLnyw._)(s != null ? s : []), this.outputs = (0, $fLnyw._)(n != null ? n : []), this.witnesses = (0, $fLnyw._)(i != null ? i : []);
    }
    (0, $kry2a._)(V, [
        {
            key: "getBaseTransaction",
            value: function getBaseTransaction() {
                var s, n, i, p, m, c;
                var t = (n = (s = this.inputs) == null ? void 0 : s.map($40b8fd6d72165de4$export$43aab34a9c1ab39c)) != null ? n : [], e = (p = (i = this.outputs) == null ? void 0 : i.map($40b8fd6d72165de4$export$6e5ca75ddfee84fb)) != null ? p : [], a = (c = (m = this.witnesses) == null ? void 0 : m.map($40b8fd6d72165de4$var$Lt)) != null ? c : [];
                return {
                    gasPrice: this.gasPrice,
                    gasLimit: this.gasLimit,
                    maturity: this.maturity,
                    inputs: t,
                    outputs: e,
                    witnesses: a,
                    inputsCount: t.length,
                    outputsCount: e.length,
                    witnessesCount: a.length
                };
            }
        },
        {
            key: "toTransactionBytes",
            value: function toTransactionBytes() {
                return new (0, $lcJUd.TransactionCoder)().encode(this.toTransaction());
            }
        },
        {
            key: "pushInput",
            value: function pushInput(t) {
                return this.inputs.push(t), this.inputs.length - 1;
            }
        },
        {
            key: "pushOutput",
            value: function pushOutput(t) {
                return this.outputs.push(t), this.outputs.length - 1;
            }
        },
        {
            key: "createWitness",
            value: function createWitness() {
                return this.witnesses.push("0x"), this.witnesses.length - 1;
            }
        },
        {
            key: "updateWitnessByOwner",
            value: function updateWitnessByOwner(t, e) {
                var a = this.getCoinInputWitnessIndexByOwner(t);
                typeof a == "number" && this.updateWitness(a, e);
            }
        },
        {
            key: "updateWitness",
            value: function updateWitness(t, e) {
                if (!this.witnesses[t]) throw new $40b8fd6d72165de4$export$1569427d86ecc9d6(t);
                this.witnesses[t] = e;
            }
        },
        {
            key: "getCoinInputs",
            value: function getCoinInputs() {
                return this.inputs.filter(function(t) {
                    return t.type === (0, $lcJUd.InputType).Coin;
                });
            }
        },
        {
            key: "getCoinOutputs",
            value: function getCoinOutputs() {
                return this.outputs.filter(function(t) {
                    return t.type === (0, $lcJUd.OutputType).Coin;
                });
            }
        },
        {
            key: "getChangeOutputs",
            value: function getChangeOutputs() {
                return this.outputs.filter(function(t) {
                    return t.type === (0, $lcJUd.OutputType).Change;
                });
            }
        },
        {
            key: "getCoinInputWitnessIndexByOwner",
            value: function getCoinInputWitnessIndexByOwner(t) {
                var a, s, n, i;
                var e = (0, $1nhBg.addressify)(t);
                return (i = (n = (a = this.inputs.find(function(p) {
                    return p.type === (0, $lcJUd.InputType).Coin && (0, $j2rU8.hexlify)(p.owner) === e.toB256();
                })) == null ? void 0 : a.witnessIndex) != null ? n : (s = this.inputs.find(function(p) {
                    return p.type === (0, $lcJUd.InputType).Message && (0, $j2rU8.hexlify)(p.recipient) === e.toB256();
                })) == null ? void 0 : s.witnessIndex) != null ? i : null;
            }
        },
        {
            key: "updateWitnessByCoinInputOwner",
            value: function updateWitnessByCoinInputOwner(t, e) {
                var a = this.getCoinInputWitnessIndexByOwner(t);
                if (!a) throw new $40b8fd6d72165de4$export$5bcc04ca4e49f428((0, $1nhBg.addressify)(t));
                this.updateWitness(a, e);
            }
        },
        {
            key: "addResource",
            value: function addResource(t) {
                var e = $40b8fd6d72165de4$export$212a4cae42b33101(t) ? t.owner : t.recipient, a = $40b8fd6d72165de4$export$212a4cae42b33101(t) ? t.assetId : (0, $jt0st.NativeAssetId), s = $40b8fd6d72165de4$export$212a4cae42b33101(t) ? (0, $lcJUd.InputType).Coin : (0, $lcJUd.InputType).Message, n = this.getCoinInputWitnessIndexByOwner(e);
                typeof n != "number" && (n = this.createWitness()), this.pushInput($40b8fd6d72165de4$export$212a4cae42b33101(t) ? (0, $8E768._)((0, $8OnJk._)({
                    type: s
                }, t), {
                    owner: t.owner.toB256(),
                    witnessIndex: n,
                    txPointer: "0x00000000000000000000000000000000"
                }) : (0, $8E768._)((0, $8OnJk._)({
                    type: s
                }, t), {
                    sender: t.sender.toB256(),
                    recipient: t.recipient.toB256(),
                    witnessIndex: n,
                    txPointer: "0x00000000000000000000000000000000"
                }));
                var i = this.getChangeOutputs().find(function(p) {
                    return (0, $j2rU8.hexlify)(p.assetId) === a;
                });
                if (i && (0, $j2rU8.hexlify)(i.to) !== e.toB256()) throw new $40b8fd6d72165de4$export$9ba234089e16d7a0;
                i || this.pushOutput({
                    type: (0, $lcJUd.OutputType).Change,
                    to: e.toB256(),
                    assetId: a
                });
            }
        },
        {
            key: "addResources",
            value: function addResources(t) {
                var _this = this;
                t.forEach(function(e) {
                    return _this.addResource(e);
                });
            }
        },
        {
            key: "addCoinOutput",
            value: function addCoinOutput(t, e) {
                var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $jt0st.NativeAssetId);
                this.pushOutput({
                    type: (0, $lcJUd.OutputType).Coin,
                    to: (0, $1nhBg.addressify)(t).toB256(),
                    amount: e,
                    assetId: a
                });
            }
        },
        {
            key: "addCoinOutputs",
            value: function addCoinOutputs(t, e) {
                var _this = this;
                e.map($40b8fd6d72165de4$export$6cb165a1d7cc3467).forEach(function(a) {
                    _this.pushOutput({
                        type: (0, $lcJUd.OutputType).Coin,
                        to: (0, $1nhBg.addressify)(t).toB256(),
                        amount: a.amount,
                        assetId: a.assetId
                    });
                });
            }
        },
        {
            key: "byteSize",
            value: function byteSize() {
                return this.toTransactionBytes().length;
            }
        },
        {
            key: "chargeableByteSize",
            value: function chargeableByteSize() {
                var t = this.witnesses.reduce(function(e, a) {
                    return e + (0, $j2rU8.arrayify)(a).length;
                }, 0);
                return (0, $4x96T.bn)(this.toTransactionBytes().length - t);
            }
        },
        {
            key: "calculateFee",
            value: function calculateFee() {
                var t = $40b8fd6d72165de4$export$ea8158c2fc323594(this.gasLimit, this.gasPrice, (0, $9aGYB.GAS_PRICE_FACTOR));
                return {
                    assetId: (0, $jt0st.NativeAssetId),
                    amount: t.isZero() ? (0, $4x96T.bn)(1) : t
                };
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $40b8fd6d72165de4$export$d820d5a7ece8be35(this);
            }
        }
    ]);
    return V;
}(), $40b8fd6d72165de4$export$868178e040d1351 = /*#__PURE__*/ function(V) {
    "use strict";
    (0, $ftJVG._)(H, V);
    var _super = (0, $6OZAO._)(H);
    function H() {
        var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $978gY._)(this, H);
        var _this;
        var t = _param.script, e = _param.scriptData, a = _param.bytesOffset, s = (0, $gPjjc._)(_param, [
            "script",
            "scriptData",
            "bytesOffset"
        ]);
        var _temp;
        _temp = _this = _super.call(this, s), (0, $dxWQo._)((0, $3vWwE._)(_this), "type", (0, $lcJUd.TransactionType).Script), (0, $dxWQo._)((0, $3vWwE._)(_this), "script", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "scriptData", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "bytesOffset", void 0), _temp, _this.script = (0, $j2rU8.arrayify)(t != null ? t : $40b8fd6d72165de4$export$640d343391073bbc.bytes), _this.scriptData = (0, $j2rU8.arrayify)(e != null ? e : $40b8fd6d72165de4$export$640d343391073bbc.encodeScriptData()), _this.bytesOffset = a;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(H, [
        {
            key: "toTransaction",
            value: function toTransaction() {
                var a, s;
                var t = (0, $j2rU8.arrayify)((a = this.script) != null ? a : "0x"), e = (0, $j2rU8.arrayify)((s = this.scriptData) != null ? s : "0x");
                return (0, $8E768._)((0, $8OnJk._)({
                    type: (0, $lcJUd.TransactionType).Script
                }, (0, $3cct3._)((0, $g3d7z._)(H.prototype), "getBaseTransaction", this).call(this)), {
                    scriptLength: t.length,
                    scriptDataLength: e.length,
                    receiptsRoot: (0, $jt0st.ZeroBytes32),
                    script: (0, $j2rU8.hexlify)(t),
                    scriptData: (0, $j2rU8.hexlify)(e)
                });
            }
        },
        {
            key: "getContractInputs",
            value: function getContractInputs() {
                return this.inputs.filter(function(t) {
                    return t.type === (0, $lcJUd.InputType).Contract;
                });
            }
        },
        {
            key: "getContractOutputs",
            value: function getContractOutputs() {
                return this.outputs.filter(function(t) {
                    return t.type === (0, $lcJUd.OutputType).Contract;
                });
            }
        },
        {
            key: "getVariableOutputs",
            value: function getVariableOutputs() {
                return this.outputs.filter(function(t) {
                    return t.type === (0, $lcJUd.OutputType).Variable;
                });
            }
        },
        {
            key: "setScript",
            value: function setScript(t, e) {
                this.script = t.bytes, this.scriptData = t.encodeScriptData(e), this.bytesOffset === void 0 && (this.bytesOffset = this.scriptData.byteLength);
            }
        },
        {
            key: "addVariableOutputs",
            value: function addVariableOutputs() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                var e = t;
                for(; e;)this.pushOutput({
                    type: (0, $lcJUd.OutputType).Variable
                }), e -= 1;
                return this.outputs.length - 1;
            }
        },
        {
            key: "addMessageOutputs",
            value: function addMessageOutputs() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                var e = t;
                for(; e;)this.pushOutput({
                    type: (0, $lcJUd.OutputType).Message,
                    recipient: "0x0000000000000000000000000000000000000000000000000000000000000000",
                    amount: 0
                }), e -= 1;
                return this.outputs.length - 1;
            }
        },
        {
            key: "addContract",
            value: function addContract(t) {
                var e = (0, $1nhBg.addressify)(t);
                if (this.getContractInputs().find(function(s) {
                    return s.contractId === e.toB256();
                })) return;
                var a = (0, $3cct3._)((0, $g3d7z._)(H.prototype), "pushInput", this).call(this, {
                    type: (0, $lcJUd.InputType).Contract,
                    contractId: e.toB256(),
                    txPointer: "0x00000000000000000000000000000000"
                });
                this.pushOutput({
                    type: (0, $lcJUd.OutputType).Contract,
                    inputIndex: a
                });
            }
        }
    ], [
        {
            key: "from",
            value: function from(t) {
                return t instanceof this ? t : new this(t);
            }
        }
    ]);
    return H;
}($40b8fd6d72165de4$var$V), $40b8fd6d72165de4$export$7f43d937bb96a8c9 = /*#__PURE__*/ function(V) {
    "use strict";
    (0, $ftJVG._)(v, V);
    var _super = (0, $6OZAO._)(v);
    function v() {
        var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $978gY._)(this, v);
        var _this;
        var t = _param.bytecodeWitnessIndex, e = _param.salt, a = _param.storageSlots, s = (0, $gPjjc._)(_param, [
            "bytecodeWitnessIndex",
            "salt",
            "storageSlots"
        ]);
        var _temp;
        _temp = _this = _super.call(this, s), (0, $dxWQo._)((0, $3vWwE._)(_this), "type", (0, $lcJUd.TransactionType).Create), (0, $dxWQo._)((0, $3vWwE._)(_this), "bytecodeWitnessIndex", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "salt", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "storageSlots", void 0), _temp, _this.bytecodeWitnessIndex = t != null ? t : 0, _this.salt = (0, $j2rU8.hexlify)(e != null ? e : (0, $jt0st.ZeroBytes32)), _this.storageSlots = (0, $fLnyw._)(a != null ? a : []);
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(v, [
        {
            key: "toTransaction",
            value: function toTransaction() {
                var s, n;
                var t = this.getBaseTransaction(), e = this.bytecodeWitnessIndex, a = (n = (s = this.storageSlots) == null ? void 0 : s.map($40b8fd6d72165de4$var$Ot)) != null ? n : [];
                return (0, $8E768._)((0, $8OnJk._)({
                    type: (0, $lcJUd.TransactionType).Create
                }, t), {
                    bytecodeLength: t.witnesses[e].dataLength / 4,
                    bytecodeWitnessIndex: e,
                    storageSlotsCount: a.length,
                    salt: this.salt ? (0, $j2rU8.hexlify)(this.salt) : (0, $jt0st.ZeroBytes32),
                    storageSlots: a
                });
            }
        },
        {
            key: "getContractCreatedOutputs",
            value: function getContractCreatedOutputs() {
                return this.outputs.filter(function(t) {
                    return t.type === (0, $lcJUd.OutputType).ContractCreated;
                });
            }
        },
        {
            key: "addContractCreatedOutput",
            value: function addContractCreatedOutput(t, e) {
                this.pushOutput({
                    type: (0, $lcJUd.OutputType).ContractCreated,
                    contractId: t,
                    stateRoot: e
                });
            }
        }
    ], [
        {
            key: "from",
            value: function from(t) {
                return t instanceof this ? t : new this(t);
            }
        }
    ]);
    return v;
}($40b8fd6d72165de4$var$V), $40b8fd6d72165de4$export$422bec23dd9c4031 = function(r) {
    if (r instanceof $40b8fd6d72165de4$export$868178e040d1351 || r instanceof $40b8fd6d72165de4$export$7f43d937bb96a8c9) return r;
    switch(r.type){
        case (0, $lcJUd.TransactionType).Script:
            return $40b8fd6d72165de4$export$868178e040d1351.from(r);
        case (0, $lcJUd.TransactionType).Create:
            return $40b8fd6d72165de4$export$7f43d937bb96a8c9.from(r);
        default:
            throw new Error("Unknown transaction type: ".concat(r.type));
    }
};
var $40b8fd6d72165de4$var$Ke = 5e3, $40b8fd6d72165de4$var$Xe = 1e3, $40b8fd6d72165de4$var$$t = function(r) {
    var t = new (0, $lcJUd.ReceiptCoder)().decode((0, $j2rU8.arrayify)(r.rawPayload), 0)[0];
    switch(t.type){
        case (0, $lcJUd.ReceiptType).ReturnData:
            return (0, $8E768._)((0, $8OnJk._)({}, t), {
                data: r.data
            });
        case (0, $lcJUd.ReceiptType).LogData:
            return (0, $8E768._)((0, $8OnJk._)({}, t), {
                data: r.data
            });
        default:
            return t;
    }
}, $40b8fd6d72165de4$export$70966cdb3bfc0785 = /*#__PURE__*/ function() {
    "use strict";
    function W(t, e) {
        (0, $978gY._)(this, W);
        (0, $dxWQo._)(this, "id", void 0);
        (0, $dxWQo._)(this, "provider", void 0);
        (0, $dxWQo._)(this, "gasUsed", (0, $4x96T.bn)(0));
        (0, $dxWQo._)(this, "attempts", 0);
        this.id = t, this.provider = e;
    }
    (0, $kry2a._)(W, [
        {
            key: "fetch",
            value: function fetch() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _ref, t;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.provider.operations.getTransactionWithReceipts({
                                        transactionId: _this.id
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), t = _ref.transaction;
                                return [
                                    2,
                                    t
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "decodeTransaction",
            value: function decodeTransaction(t) {
                var e;
                return (e = new (0, $lcJUd.TransactionCoder)().decode((0, $j2rU8.arrayify)(t.rawPayload), 0)) == null ? void 0 : e[0];
            }
        },
        {
            key: "waitForResult",
            value: function waitForResult() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var e, a, t, _, s, _A, n, i, s1, _A1, n1, i1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.fetch()
                                ];
                            case 1:
                                t = _state.sent();
                                _ = (e = t == null ? void 0 : t.status) == null ? void 0 : e.type;
                                switch(_){
                                    case void 0:
                                        return [
                                            3,
                                            2
                                        ];
                                    case "SubmittedStatus":
                                        return [
                                            3,
                                            2
                                        ];
                                    case "FailureStatus":
                                        return [
                                            3,
                                            4
                                        ];
                                    case "SuccessStatus":
                                        return [
                                            3,
                                            5
                                        ];
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 2:
                                _this.attempts += 1;
                                return [
                                    4,
                                    $40b8fd6d72165de4$export$e772c8ff12451969(Math.min($40b8fd6d72165de4$var$Xe * _this.attempts, $40b8fd6d72165de4$var$Ke))
                                ];
                            case 3:
                                return [
                                    2,
                                    (_state.sent(), _this.waitForResult())
                                ];
                            case 4:
                                {
                                    s = t.receipts.map($40b8fd6d72165de4$var$$t), _A = $40b8fd6d72165de4$export$4a3b6cfdf61e19ee({
                                        receipts: s,
                                        gasPrice: (0, $4x96T.bn)(t == null ? void 0 : t.gasPrice)
                                    }), n = _A.gasUsed, i = _A.fee;
                                    return [
                                        2,
                                        (_this.gasUsed = n, {
                                            status: {
                                                type: "failure",
                                                reason: t.status.reason
                                            },
                                            receipts: s,
                                            transactionId: _this.id,
                                            blockId: t.status.block.id,
                                            time: t.status.time,
                                            gasUsed: n,
                                            fee: i,
                                            transaction: _this.decodeTransaction(t)
                                        })
                                    ];
                                }
                                _state.label = 5;
                            case 5:
                                {
                                    s1 = ((a = t.receipts) == null ? void 0 : a.map($40b8fd6d72165de4$var$$t)) || [], _A1 = $40b8fd6d72165de4$export$4a3b6cfdf61e19ee({
                                        receipts: s1,
                                        gasPrice: (0, $4x96T.bn)(t == null ? void 0 : t.gasPrice)
                                    }), n1 = _A1.gasUsed, i1 = _A1.fee;
                                    return [
                                        2,
                                        {
                                            status: {
                                                type: "success",
                                                programState: t.status.programState
                                            },
                                            receipts: s1,
                                            transactionId: _this.id,
                                            blockId: t.status.block.id,
                                            time: t.status.time,
                                            gasUsed: n1,
                                            fee: i1,
                                            transaction: _this.decodeTransaction(t)
                                        }
                                    ];
                                }
                                _state.label = 6;
                            case 6:
                                throw new Error("Invalid Transaction status");
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "wait",
            value: function wait() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var t;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.waitForResult()
                                ];
                            case 1:
                                t = _state.sent();
                                if (t.status.type === "failure") throw new Error("Transaction failed: ".concat(t.status.reason));
                                return [
                                    2,
                                    t
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return W;
}();
var $40b8fd6d72165de4$var$ra = 10, $40b8fd6d72165de4$var$pt = function(r) {
    var t = new (0, $lcJUd.ReceiptCoder)().decode((0, $j2rU8.arrayify)(r.rawPayload), 0)[0];
    switch(t.type){
        case (0, $lcJUd.ReceiptType).ReturnData:
            return (0, $8E768._)((0, $8OnJk._)({}, t), {
                data: r.data
            });
        case (0, $lcJUd.ReceiptType).LogData:
            return (0, $8E768._)((0, $8OnJk._)({}, t), {
                data: r.data
            });
        default:
            return t;
    }
}, $40b8fd6d72165de4$var$sa = function(r) {
    var t = r.name, e = r.baseChainHeight, a = r.peerCount, s = r.consensusParameters, n = r.latestBlock;
    return {
        name: t,
        baseChainHeight: (0, $4x96T.bn)(e),
        peerCount: a,
        consensusParameters: {
            contractMaxSize: (0, $4x96T.bn)(s.contractMaxSize),
            maxInputs: (0, $4x96T.bn)(s.maxInputs),
            maxOutputs: (0, $4x96T.bn)(s.maxOutputs),
            maxWitnesses: (0, $4x96T.bn)(s.maxWitnesses),
            maxGasPerTx: (0, $4x96T.bn)(s.maxGasPerTx),
            maxScriptLength: (0, $4x96T.bn)(s.maxScriptLength),
            maxScriptDataLength: (0, $4x96T.bn)(s.maxScriptDataLength),
            maxStorageSlots: (0, $4x96T.bn)(s.maxStorageSlots),
            maxPredicateLength: (0, $4x96T.bn)(s.maxPredicateLength),
            maxPredicateDataLength: (0, $4x96T.bn)(s.maxPredicateDataLength),
            gasPriceFactor: (0, $4x96T.bn)(s.gasPriceFactor),
            gasPerByte: (0, $4x96T.bn)(s.gasPerByte),
            maxMessageDataLength: (0, $4x96T.bn)(s.maxMessageDataLength)
        },
        latestBlock: {
            id: n.id,
            height: (0, $4x96T.bn)(n.header.height),
            time: n.header.time,
            transactions: n.transactions.map(function(i) {
                return {
                    id: i.id
                };
            })
        }
    };
}, $40b8fd6d72165de4$var$na = function(r) {
    return {
        minGasPrice: (0, $4x96T.bn)(r.minGasPrice),
        nodeVersion: r.nodeVersion
    };
}, $40b8fd6d72165de4$var$K, $40b8fd6d72165de4$var$Vt, $40b8fd6d72165de4$export$2881499e37b75b9a = /*#__PURE__*/ function() {
    "use strict";
    function z(t) {
        var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $978gY._)(this, z);
        this.url = t;
        this.options = e;
        $40b8fd6d72165de4$var$gt(this, $40b8fd6d72165de4$var$K);
        $40b8fd6d72165de4$var$J(this, "operations");
        $40b8fd6d72165de4$var$J(this, "cache");
        this.operations = this.createOperations(t, e), this.cache = e.cacheUtxo ? new $40b8fd6d72165de4$var$$(e.cacheUtxo) : void 0;
    }
    (0, $kry2a._)(z, [
        {
            key: "createOperations",
            value: function createOperations(t) {
                var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.url = t;
                var a = new (0, $gkqPm.GraphQLClient)(t, e.fetch ? {
                    fetch: e.fetch
                } : void 0);
                return $40b8fd6d72165de4$var$Tt(a);
            }
        },
        {
            key: "connect",
            value: function connect(t) {
                this.operations = this.createOperations(t);
            }
        },
        {
            key: "getVersion",
            value: function getVersion() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _ref, _ref_nodeInfo, t;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.operations.getVersion()
                                ];
                            case 1:
                                _ref = _state.sent(), _ref_nodeInfo = _ref.nodeInfo, t = _ref_nodeInfo.nodeVersion;
                                return [
                                    2,
                                    t
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getNetwork",
            value: function getNetwork() {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            Promise.resolve({
                                name: "fuelv2",
                                chainId: 3735928559
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getBlockNumber",
            value: function getBlockNumber() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _ref, t;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.operations.getChain()
                                ];
                            case 1:
                                _ref = _state.sent(), t = _ref.chain;
                                return [
                                    2,
                                    (0, $4x96T.bn)(t.latestBlock.header.height, 10)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getNodeInfo",
            value: function getNodeInfo() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _ref, t;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.operations.getInfo()
                                ];
                            case 1:
                                _ref = _state.sent(), t = _ref.nodeInfo;
                                return [
                                    2,
                                    $40b8fd6d72165de4$var$na(t)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getChain",
            value: function getChain() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _ref, t;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.operations.getChain()
                                ];
                            case 1:
                                _ref = _state.sent(), t = _ref.chain;
                                return [
                                    2,
                                    $40b8fd6d72165de4$var$sa(t)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTransaction",
            value: function sendTransaction(t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var e, a, _ref, s, n, _ref1, _ref_submit, i;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = $40b8fd6d72165de4$export$422bec23dd9c4031(t);
                                $40b8fd6d72165de4$var$dt(_this, $40b8fd6d72165de4$var$K, $40b8fd6d72165de4$var$Vt).call(_this, e.inputs);
                                return [
                                    4,
                                    _this.estimateTxDependencies(e)
                                ];
                            case 1:
                                _state.sent();
                                a = (0, $j2rU8.hexlify)(e.toTransactionBytes());
                                return [
                                    4,
                                    _this.getTransactionCost(e, 0)
                                ];
                            case 2:
                                _ref = _state.sent(), s = _ref.gasUsed, n = _ref.minGasPrice;
                                if ((0, $4x96T.bn)(s).gt((0, $4x96T.bn)(e.gasLimit))) throw new Error("gasLimit(".concat(e.gasLimit, ") is lower than the required (").concat(s, ")"));
                                if ((0, $4x96T.bn)(n).gt((0, $4x96T.bn)(e.gasPrice))) throw new Error("gasPrice(".concat(e.gasPrice, ") is lower than the required ").concat(n));
                                return [
                                    4,
                                    _this.operations.submit({
                                        encodedTransaction: a
                                    })
                                ];
                            case 3:
                                _ref1 = _state.sent(), _ref_submit = _ref1.submit, i = _ref_submit.id;
                                return [
                                    2,
                                    new $40b8fd6d72165de4$export$70966cdb3bfc0785(i, _this)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "call",
            value: function call(t) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = _ref.utxoValidation;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var a, s, _ref, n;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                a = $40b8fd6d72165de4$export$422bec23dd9c4031(t);
                                return [
                                    4,
                                    _this.estimateTxDependencies(a)
                                ];
                            case 1:
                                _state.sent();
                                s = (0, $j2rU8.hexlify)(a.toTransactionBytes());
                                return [
                                    4,
                                    _this.operations.dryRun({
                                        encodedTransaction: s,
                                        utxoValidation: e || !1
                                    })
                                ];
                            case 2:
                                _ref = _state.sent(), n = _ref.dryRun;
                                return [
                                    2,
                                    {
                                        receipts: n.map($40b8fd6d72165de4$var$pt)
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "estimateTxDependencies",
            value: function estimateTxDependencies(t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var e, a, s, n, _ref, i, p, _t1, m, c;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = 0, a = 0, s = 0;
                                if (!(t.type !== (0, $lcJUd.TransactionType).Create)) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                n = (0, $j2rU8.hexlify)(t.toTransactionBytes());
                                return [
                                    4,
                                    _this.operations.dryRun({
                                        encodedTransaction: n,
                                        utxoValidation: !1
                                    })
                                ];
                            case 2:
                                _ref = _state.sent(), i = _ref.dryRun, p = i.map($40b8fd6d72165de4$var$pt), _t1 = $40b8fd6d72165de4$export$9ac47654207eadfd(p), m = _t1.missingOutputVariables, c = _t1.missingOutputContractIds;
                                if (e = m.length, a = c.length, e === 0 && a === 0) return [
                                    2
                                ];
                                t.addVariableOutputs(e), c.forEach(function(param) {
                                    var q = param.contractId;
                                    return t.addContract((0, $1nhBg.Address).fromString(q));
                                }), s += 1;
                                _state.label = 3;
                            case 3:
                                if (s < $40b8fd6d72165de4$var$ra) return [
                                    3,
                                    1
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "simulate",
            value: function simulate(t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var e, a, _ref, s;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = $40b8fd6d72165de4$export$422bec23dd9c4031(t);
                                return [
                                    4,
                                    _this.estimateTxDependencies(e)
                                ];
                            case 1:
                                _state.sent();
                                a = (0, $j2rU8.hexlify)(e.toTransactionBytes());
                                return [
                                    4,
                                    _this.operations.dryRun({
                                        encodedTransaction: a,
                                        utxoValidation: !0
                                    })
                                ];
                            case 2:
                                _ref = _state.sent(), s = _ref.dryRun;
                                return [
                                    2,
                                    {
                                        receipts: s.map($40b8fd6d72165de4$var$pt)
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTransactionCost",
            value: function getTransactionCost(t) {
                var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : .2;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var a, _ref, s, n, i, _ref1, p, _A, m, c;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                a = $40b8fd6d72165de4$export$422bec23dd9c4031((0, (/*@__PURE__*/$parcel$interopDefault($51Bw9)))(t));
                                return [
                                    4,
                                    _this.getNodeInfo()
                                ];
                            case 1:
                                _ref = _state.sent(), s = _ref.minGasPrice, n = (0, $4x96T.max)(a.gasPrice, s), i = 1 + e;
                                a.gasLimit = (0, $9aGYB.MAX_GAS_PER_TX), a.gasPrice = (0, $4x96T.bn)(0);
                                return [
                                    4,
                                    _this.call(a)
                                ];
                            case 2:
                                _ref1 = _state.sent(), p = _ref1.receipts, _A = $40b8fd6d72165de4$export$4a3b6cfdf61e19ee({
                                    gasPrice: n,
                                    receipts: p,
                                    margin: i
                                }), m = _A.gasUsed, c = _A.fee;
                                return [
                                    2,
                                    {
                                        minGasPrice: s,
                                        gasPrice: n,
                                        gasUsed: m,
                                        fee: c
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCoins",
            value: function getCoins(t, e, a) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.operations.getCoins((0, $8E768._)((0, $8OnJk._)({
                                        first: 10
                                    }, a), {
                                        filter: {
                                            owner: t.toB256(),
                                            assetId: e && (0, $j2rU8.hexlify)(e)
                                        }
                                    }))
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().coins.edges.map(function(i) {
                                        return i.node;
                                    }).map(function(i) {
                                        return {
                                            id: i.utxoId,
                                            assetId: i.assetId,
                                            amount: (0, $4x96T.bn)(i.amount),
                                            owner: (0, $1nhBg.Address).fromAddressOrString(i.owner),
                                            status: i.coinStatus,
                                            maturity: (0, $4x96T.bn)(i.maturity).toNumber(),
                                            blockCreated: (0, $4x96T.bn)(i.blockCreated)
                                        };
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getResourcesToSpend",
            value: function getResourcesToSpend(t, e, a) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var i, p, m, s, c;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                s = {
                                    messages: ((i = a == null ? void 0 : a.messages) == null ? void 0 : i.map(function(c) {
                                        return (0, $j2rU8.hexlify)(c);
                                    })) || [],
                                    utxos: ((p = a == null ? void 0 : a.utxos) == null ? void 0 : p.map(function(c) {
                                        return (0, $j2rU8.hexlify)(c);
                                    })) || []
                                };
                                if (_this.cache) {
                                    c = new Set(s.utxos.concat((m = _this.cache) == null ? void 0 : m.getActiveData().map(function(q) {
                                        return (0, $j2rU8.hexlify)(q);
                                    })));
                                    s.utxos = Array.from(c);
                                }
                                return [
                                    4,
                                    _this.operations.getResourcesToSpend({
                                        owner: t.toB256(),
                                        queryPerAsset: e.map($40b8fd6d72165de4$export$6cb165a1d7cc3467).map(function(param) {
                                            var c = param.assetId, q = param.amount, L = param.max;
                                            return {
                                                assetId: (0, $j2rU8.hexlify)(c),
                                                amount: q.toString(10),
                                                max: L ? L.toString(10) : void 0
                                            };
                                        }),
                                        excludedIds: s
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().resourcesToSpend.flat().map(function(c) {
                                        return $40b8fd6d72165de4$export$a1898ba9a0c55d56(c) ? {
                                            id: c.utxoId,
                                            amount: (0, $4x96T.bn)(c.amount),
                                            status: c.coinStatus,
                                            assetId: c.assetId,
                                            owner: (0, $1nhBg.Address).fromAddressOrString(c.owner),
                                            maturity: (0, $4x96T.bn)(c.maturity).toNumber(),
                                            blockCreated: (0, $4x96T.bn)(c.blockCreated)
                                        } : {
                                            sender: (0, $1nhBg.Address).fromAddressOrString(c.sender),
                                            recipient: (0, $1nhBg.Address).fromAddressOrString(c.recipient),
                                            nonce: (0, $4x96T.bn)(c.nonce),
                                            amount: (0, $4x96T.bn)(c.amount),
                                            data: (0, $lcJUd.InputMessageCoder).decodeData(c.data),
                                            status: c.messageStatus,
                                            daHeight: (0, $4x96T.bn)(c.daHeight)
                                        };
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlock",
            value: function getBlock(t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var e, _tmp, _tmp1, _tmp2, _ref, a;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(typeof t == "number")) return [
                                    3,
                                    1
                                ];
                                _tmp = e = {
                                    blockHeight: (0, $4x96T.bn)(t).toString(10)
                                };
                                return [
                                    3,
                                    5
                                ];
                            case 1:
                                if (!(t === "latest")) return [
                                    3,
                                    3
                                ];
                                _tmp2 = {};
                                return [
                                    4,
                                    _this.getBlockNumber()
                                ];
                            case 2:
                                _tmp1 = e = (_tmp2.blockHeight = _state.sent().toString(10), _tmp2);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _tmp1 = e = {
                                    blockId: (0, $4x96T.bn)(t).toString(10)
                                };
                                _state.label = 4;
                            case 4:
                                _tmp = _tmp1;
                                _state.label = 5;
                            case 5:
                                _tmp;
                                return [
                                    4,
                                    _this.operations.getBlock(e)
                                ];
                            case 6:
                                _ref = _state.sent(), a = _ref.block;
                                return [
                                    2,
                                    a ? {
                                        id: a.id,
                                        height: (0, $4x96T.bn)(a.header.height),
                                        time: a.header.time,
                                        transactionIds: a.transactions.map(function(s) {
                                            return s.id;
                                        })
                                    } : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlocks",
            value: function getBlocks(t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _ref, e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.operations.getBlocks(t)
                                ];
                            case 1:
                                _ref = _state.sent(), e = _ref.blocks;
                                return [
                                    2,
                                    e.edges.map(function(param) {
                                        var s = param.node;
                                        return {
                                            id: s.id,
                                            height: (0, $4x96T.bn)(s.header.height),
                                            time: s.header.time,
                                            transactionIds: s.transactions.map(function(n) {
                                                return n.id;
                                            })
                                        };
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlockWithTransactions",
            value: function getBlockWithTransactions(t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var e, _tmp, _tmp1, _tmp2, _ref, a;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(typeof t == "number")) return [
                                    3,
                                    1
                                ];
                                _tmp = e = {
                                    blockHeight: (0, $4x96T.bn)(t).toString(10)
                                };
                                return [
                                    3,
                                    5
                                ];
                            case 1:
                                if (!(t === "latest")) return [
                                    3,
                                    3
                                ];
                                _tmp2 = {};
                                return [
                                    4,
                                    _this.getBlockNumber()
                                ];
                            case 2:
                                _tmp1 = e = (_tmp2.blockHeight = _state.sent().toString(), _tmp2);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _tmp1 = e = {
                                    blockId: t
                                };
                                _state.label = 4;
                            case 4:
                                _tmp = _tmp1;
                                _state.label = 5;
                            case 5:
                                _tmp;
                                return [
                                    4,
                                    _this.operations.getBlockWithTransactions(e)
                                ];
                            case 6:
                                _ref = _state.sent(), a = _ref.block;
                                return [
                                    2,
                                    a ? {
                                        id: a.id,
                                        height: (0, $4x96T.bn)(a.header.height, 10),
                                        time: a.header.time,
                                        transactionIds: a.transactions.map(function(s) {
                                            return s.id;
                                        }),
                                        transactions: a.transactions.map(function(s) {
                                            var n;
                                            return (n = new (0, $lcJUd.TransactionCoder)().decode((0, $j2rU8.arrayify)(s.rawPayload), 0)) == null ? void 0 : n[0];
                                        })
                                    } : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTransaction",
            value: function getTransaction(t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var a, _ref, e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.operations.getTransaction({
                                        transactionId: t
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), e = _ref.transaction;
                                return [
                                    2,
                                    e ? (a = new (0, $lcJUd.TransactionCoder)().decode((0, $j2rU8.arrayify)(e.rawPayload), 0)) == null ? void 0 : a[0] : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getContract",
            value: function getContract(t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _ref, e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.operations.getContract({
                                        contractId: t
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), e = _ref.contract;
                                return [
                                    2,
                                    e || null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getContractBalance",
            value: function getContractBalance(t, e) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _ref, a;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.operations.getContractBalance({
                                        contract: t.toB256(),
                                        asset: (0, $j2rU8.hexlify)(e)
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), a = _ref.contractBalance;
                                return [
                                    2,
                                    (0, $4x96T.bn)(a.amount, 10)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBalance",
            value: function getBalance(t, e) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _ref, a;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.operations.getBalance({
                                        owner: t.toB256(),
                                        assetId: (0, $j2rU8.hexlify)(e)
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), a = _ref.balance;
                                return [
                                    2,
                                    (0, $4x96T.bn)(a.amount, 10)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBalances",
            value: function getBalances(t, e) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.operations.getBalances((0, $8E768._)((0, $8OnJk._)({
                                        first: 10
                                    }, e), {
                                        filter: {
                                            owner: t.toB256()
                                        }
                                    }))
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().balances.edges.map(function(n) {
                                        return n.node;
                                    }).map(function(n) {
                                        return {
                                            assetId: n.assetId,
                                            amount: (0, $4x96T.bn)(n.amount)
                                        };
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMessages",
            value: function getMessages(t, e) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.operations.getMessages((0, $8E768._)((0, $8OnJk._)({
                                        first: 10
                                    }, e), {
                                        owner: t.toB256()
                                    }))
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().messages.edges.map(function(n) {
                                        return n.node;
                                    }).map(function(n) {
                                        return {
                                            sender: (0, $1nhBg.Address).fromAddressOrString(n.sender),
                                            recipient: (0, $1nhBg.Address).fromAddressOrString(n.recipient),
                                            nonce: (0, $4x96T.bn)(n.nonce),
                                            amount: (0, $4x96T.bn)(n.amount),
                                            data: (0, $lcJUd.InputMessageCoder).decodeData(n.data),
                                            status: n.messageStatus,
                                            daHeight: (0, $4x96T.bn)(n.daHeight)
                                        };
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMessageProof",
            value: function getMessageProof(t, e) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var a;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.operations.getMessageProof({
                                        transactionId: t,
                                        messageId: e
                                    })
                                ];
                            case 1:
                                a = _state.sent();
                                return [
                                    2,
                                    a.messageProof ? {
                                        proofSet: a.messageProof.proofSet,
                                        proofIndex: (0, $4x96T.bn)(a.messageProof.proofIndex),
                                        sender: (0, $1nhBg.Address).fromAddressOrString(a.messageProof.sender),
                                        recipient: (0, $1nhBg.Address).fromAddressOrString(a.messageProof.recipient),
                                        nonce: a.messageProof.nonce,
                                        amount: (0, $4x96T.bn)(a.messageProof.amount),
                                        data: a.messageProof.data,
                                        signature: a.messageProof.signature,
                                        header: {
                                            id: a.messageProof.header.id,
                                            daHeight: (0, $4x96T.bn)(a.messageProof.header.daHeight),
                                            transactionsCount: (0, $4x96T.bn)(a.messageProof.header.transactionsCount),
                                            outputMessagesCount: (0, $4x96T.bn)(a.messageProof.header.outputMessagesCount),
                                            transactionsRoot: a.messageProof.header.transactionsRoot,
                                            outputMessagesRoot: a.messageProof.header.outputMessagesRoot,
                                            height: (0, $4x96T.bn)(a.messageProof.header.height),
                                            prevRoot: a.messageProof.header.prevRoot,
                                            time: a.messageProof.header.time,
                                            applicationHash: a.messageProof.header.applicationHash
                                        }
                                    } : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "produceBlocks",
            value: function produceBlocks(t, e) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _ref, a;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.operations.produceBlocks({
                                        blocksToProduce: (0, $4x96T.bn)(t).toString(10),
                                        time: e
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), a = _ref.produceBlocks;
                                return [
                                    2,
                                    (0, $4x96T.bn)(a)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return z;
}();
$40b8fd6d72165de4$var$K = new WeakSet, $40b8fd6d72165de4$var$Vt = function Vt(t) {
    var _this = this;
    !this.cache || t.forEach(function(e) {
        var a;
        e.type === (0, $lcJUd.InputType).Coin && ((a = _this.cache) == null || a.set(e.id));
    });
};
function $40b8fd6d72165de4$export$d01f8bb64d304ad0(r, t) {
    var _e, _e1;
    return r.reduce(function(e, a) {
        return a.type === (0, $lcJUd.ReceiptType).LogData ? (_e = e).concat.apply(_e, (0, $fLnyw._)(t.decodeLog(a.data, a.val1.toNumber(), a.id))) : a.type === (0, $lcJUd.ReceiptType).Log ? (_e1 = e).concat.apply(_e1, (0, $fLnyw._)(t.decodeLog(new (0, $2cJiB.U64Coder)().encode(a.val0), a.val1.toNumber(), a.id))) : e;
    }, []);
}

});
parcelRequire.register("11fbC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0be1aa28b7886b31$export$263b15b19e6ed8f; });
function $0be1aa28b7886b31$export$263b15b19e6ed8f(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});

parcelRequire.register("jt0st", function(module, exports) {

$parcel$export(module.exports, "ZeroBytes32", function () { return $da1a44ae5406b763$export$98a6222b3b5e5766; });
$parcel$export(module.exports, "NativeAssetId", function () { return $da1a44ae5406b763$export$6a78890d33b25b4; });
var $da1a44ae5406b763$export$98a6222b3b5e5766 = "0x0000000000000000000000000000000000000000000000000000000000000000", $da1a44ae5406b763$export$6a78890d33b25b4 = $da1a44ae5406b763$export$98a6222b3b5e5766, $da1a44ae5406b763$export$d659ae2cc9341813 = "0xe3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";

});

parcelRequire.register("k1BEe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9411abec25bc1dd$export$2e2bcd8739ae039; });

var $7UAGh = parcelRequire("7UAGh");

var $jcfFg = parcelRequire("jcfFg");
var $e9411abec25bc1dd$var$docCache = new Map();
var $e9411abec25bc1dd$var$fragmentSourceMap = new Map();
var $e9411abec25bc1dd$var$printFragmentWarnings = true;
var $e9411abec25bc1dd$var$experimentalFragmentVariables = false;
function $e9411abec25bc1dd$var$normalize(string) {
    return string.replace(/[\s,]+/g, " ").trim();
}
function $e9411abec25bc1dd$var$cacheKeyFromLoc(loc) {
    return $e9411abec25bc1dd$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $e9411abec25bc1dd$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === "FragmentDefinition") {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $e9411abec25bc1dd$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $e9411abec25bc1dd$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($e9411abec25bc1dd$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $e9411abec25bc1dd$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $7UAGh.__assign)((0, $7UAGh.__assign)({}, ast), {
        definitions: definitions
    });
}
function $e9411abec25bc1dd$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === "object") workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $e9411abec25bc1dd$var$parseDocument(source) {
    var cacheKey = $e9411abec25bc1dd$var$normalize(source);
    if (!$e9411abec25bc1dd$var$docCache.has(cacheKey)) {
        var parsed = (0, $jcfFg.parse)(source, {
            experimentalFragmentVariables: $e9411abec25bc1dd$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $e9411abec25bc1dd$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== "Document") throw new Error("Not a valid GraphQL document.");
        $e9411abec25bc1dd$var$docCache.set(cacheKey, $e9411abec25bc1dd$var$stripLoc($e9411abec25bc1dd$var$processFragments(parsed)));
    }
    return $e9411abec25bc1dd$var$docCache.get(cacheKey);
}
function $e9411abec25bc1dd$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === "string") literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === "Document") result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $e9411abec25bc1dd$var$parseDocument(result);
}
function $e9411abec25bc1dd$export$657554ef4dc7ac2d() {
    $e9411abec25bc1dd$var$docCache.clear();
    $e9411abec25bc1dd$var$fragmentSourceMap.clear();
}
function $e9411abec25bc1dd$export$e4294e638636c6ab() {
    $e9411abec25bc1dd$var$printFragmentWarnings = false;
}
function $e9411abec25bc1dd$export$78cf889af350c840() {
    $e9411abec25bc1dd$var$experimentalFragmentVariables = true;
}
function $e9411abec25bc1dd$export$5290df9bbbd3cfa() {
    $e9411abec25bc1dd$var$experimentalFragmentVariables = false;
}
var $e9411abec25bc1dd$var$extras = {
    gql: $e9411abec25bc1dd$export$72e4926bf8358653,
    resetCaches: $e9411abec25bc1dd$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $e9411abec25bc1dd$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $e9411abec25bc1dd$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $e9411abec25bc1dd$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $e9411abec25bc1dd$var$extras.gql, gql_1.resetCaches = $e9411abec25bc1dd$var$extras.resetCaches, gql_1.disableFragmentWarnings = $e9411abec25bc1dd$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $e9411abec25bc1dd$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $e9411abec25bc1dd$var$extras.disableExperimentalFragmentVariables;
})($e9411abec25bc1dd$export$72e4926bf8358653 || ($e9411abec25bc1dd$export$72e4926bf8358653 = {}));
$e9411abec25bc1dd$export$72e4926bf8358653["default"] = $e9411abec25bc1dd$export$72e4926bf8358653;
var $e9411abec25bc1dd$export$2e2bcd8739ae039 = $e9411abec25bc1dd$export$72e4926bf8358653;

});
parcelRequire.register("jcfFg", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $7fa84f489267ce10$export$98e6a39c04603d36; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $52WCf = parcelRequire("52WCf");

var $cvgER = parcelRequire("cvgER");

var $kBjkj = parcelRequire("kBjkj");

var $dqOmk = parcelRequire("dqOmk");

var $fe01d = parcelRequire("fe01d");

var $1XEWr = parcelRequire("1XEWr");

var $5Qncb = parcelRequire("5Qncb");
function $7fa84f489267ce10$export$98e6a39c04603d36(source, options) {
    var parser = new $7fa84f489267ce10$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $7fa84f489267ce10$export$5303528d1070ff6f(source, options) {
    var parser = new $7fa84f489267ce10$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $5Qncb.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $5Qncb.TokenKind).EOF);
    return value;
}
function $7fa84f489267ce10$export$e14c466bd0916f7a(source, options) {
    var parser = new $7fa84f489267ce10$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $5Qncb.TokenKind).SOF);
    var value = parser.parseConstValueLiteral();
    parser.expectToken((0, $5Qncb.TokenKind).EOF);
    return value;
}
function $7fa84f489267ce10$export$28b8f402ccc88182(source, options) {
    var parser = new $7fa84f489267ce10$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $5Qncb.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $5Qncb.TokenKind).EOF);
    return type;
}
var $7fa84f489267ce10$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    "use strict";
    function Parser(source) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $978gY._)(this, Parser);
        var sourceObj = (0, $1XEWr.isSource)(source) ? source : new (0, $1XEWr.Source)(source);
        this._lexer = new (0, $fe01d.Lexer)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
    (0, $kry2a._)(Parser, [
        {
            /**
   * Converts a name lex token into a name parse node.
   */ key: "parseName",
            value: function parseName() {
                var token = this.expectToken((0, $5Qncb.TokenKind).NAME);
                return this.node(token, {
                    kind: (0, $dqOmk.Kind).NAME,
                    value: token.value
                });
            } // Implements the parsing rules in the Document section.
        },
        {
            /**
   * Document : Definition+
   */ key: "parseDocument",
            value: function parseDocument() {
                return this.node(this._lexer.token, {
                    kind: (0, $dqOmk.Kind).DOCUMENT,
                    definitions: this.many((0, $5Qncb.TokenKind).SOF, this.parseDefinition, (0, $5Qncb.TokenKind).EOF)
                });
            }
        },
        {
            /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ key: "parseDefinition",
            value: function parseDefinition() {
                if (this.peek((0, $5Qncb.TokenKind).BRACE_L)) return this.parseOperationDefinition();
                 // Many definitions begin with a description and require a lookahead.
                var hasDescription = this.peekDescription();
                var keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
                if (keywordToken.kind === (0, $5Qncb.TokenKind).NAME) {
                    switch(keywordToken.value){
                        case "schema":
                            return this.parseSchemaDefinition();
                        case "scalar":
                            return this.parseScalarTypeDefinition();
                        case "type":
                            return this.parseObjectTypeDefinition();
                        case "interface":
                            return this.parseInterfaceTypeDefinition();
                        case "union":
                            return this.parseUnionTypeDefinition();
                        case "enum":
                            return this.parseEnumTypeDefinition();
                        case "input":
                            return this.parseInputObjectTypeDefinition();
                        case "directive":
                            return this.parseDirectiveDefinition();
                    }
                    if (hasDescription) throw (0, $52WCf.syntaxError)(this._lexer.source, this._lexer.token.start, "Unexpected description, descriptions are supported only on type definitions.");
                    switch(keywordToken.value){
                        case "query":
                        case "mutation":
                        case "subscription":
                            return this.parseOperationDefinition();
                        case "fragment":
                            return this.parseFragmentDefinition();
                        case "extend":
                            return this.parseTypeSystemExtension();
                    }
                }
                throw this.unexpected(keywordToken);
            } // Implements the parsing rules in the Operations section.
        },
        {
            /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ key: "parseOperationDefinition",
            value: function parseOperationDefinition() {
                var start = this._lexer.token;
                if (this.peek((0, $5Qncb.TokenKind).BRACE_L)) return this.node(start, {
                    kind: (0, $dqOmk.Kind).OPERATION_DEFINITION,
                    operation: (0, $cvgER.OperationTypeNode).QUERY,
                    name: undefined,
                    variableDefinitions: [],
                    directives: [],
                    selectionSet: this.parseSelectionSet()
                });
                var operation = this.parseOperationType();
                var name;
                if (this.peek((0, $5Qncb.TokenKind).NAME)) name = this.parseName();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).OPERATION_DEFINITION,
                    operation: operation,
                    name: name,
                    variableDefinitions: this.parseVariableDefinitions(),
                    directives: this.parseDirectives(false),
                    selectionSet: this.parseSelectionSet()
                });
            }
        },
        {
            /**
   * OperationType : one of query mutation subscription
   */ key: "parseOperationType",
            value: function parseOperationType() {
                var operationToken = this.expectToken((0, $5Qncb.TokenKind).NAME);
                switch(operationToken.value){
                    case "query":
                        return (0, $cvgER.OperationTypeNode).QUERY;
                    case "mutation":
                        return (0, $cvgER.OperationTypeNode).MUTATION;
                    case "subscription":
                        return (0, $cvgER.OperationTypeNode).SUBSCRIPTION;
                }
                throw this.unexpected(operationToken);
            }
        },
        {
            /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ key: "parseVariableDefinitions",
            value: function parseVariableDefinitions() {
                return this.optionalMany((0, $5Qncb.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $5Qncb.TokenKind).PAREN_R);
            }
        },
        {
            /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ key: "parseVariableDefinition",
            value: function parseVariableDefinition() {
                return this.node(this._lexer.token, {
                    kind: (0, $dqOmk.Kind).VARIABLE_DEFINITION,
                    variable: this.parseVariable(),
                    type: (this.expectToken((0, $5Qncb.TokenKind).COLON), this.parseTypeReference()),
                    defaultValue: this.expectOptionalToken((0, $5Qncb.TokenKind).EQUALS) ? this.parseConstValueLiteral() : undefined,
                    directives: this.parseConstDirectives()
                });
            }
        },
        {
            /**
   * Variable : $ Name
   */ key: "parseVariable",
            value: function parseVariable() {
                var start = this._lexer.token;
                this.expectToken((0, $5Qncb.TokenKind).DOLLAR);
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).VARIABLE,
                    name: this.parseName()
                });
            }
        },
        {
            /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ key: "parseSelectionSet",
            value: function parseSelectionSet() {
                return this.node(this._lexer.token, {
                    kind: (0, $dqOmk.Kind).SELECTION_SET,
                    selections: this.many((0, $5Qncb.TokenKind).BRACE_L, this.parseSelection, (0, $5Qncb.TokenKind).BRACE_R)
                });
            }
        },
        {
            /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ key: "parseSelection",
            value: function parseSelection() {
                return this.peek((0, $5Qncb.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
            }
        },
        {
            /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ key: "parseField",
            value: function parseField() {
                var start = this._lexer.token;
                var nameOrAlias = this.parseName();
                var alias;
                var name;
                if (this.expectOptionalToken((0, $5Qncb.TokenKind).COLON)) {
                    alias = nameOrAlias;
                    name = this.parseName();
                } else name = nameOrAlias;
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).FIELD,
                    alias: alias,
                    name: name,
                    arguments: this.parseArguments(false),
                    directives: this.parseDirectives(false),
                    selectionSet: this.peek((0, $5Qncb.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined
                });
            }
        },
        {
            /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ key: "parseArguments",
            value: function parseArguments(isConst) {
                var item = isConst ? this.parseConstArgument : this.parseArgument;
                return this.optionalMany((0, $5Qncb.TokenKind).PAREN_L, item, (0, $5Qncb.TokenKind).PAREN_R);
            }
        },
        {
            /**
   * Argument[Const] : Name : Value[?Const]
   */ key: "parseArgument",
            value: function parseArgument() {
                var isConst = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var start = this._lexer.token;
                var name = this.parseName();
                this.expectToken((0, $5Qncb.TokenKind).COLON);
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).ARGUMENT,
                    name: name,
                    value: this.parseValueLiteral(isConst)
                });
            }
        },
        {
            key: "parseConstArgument",
            value: function parseConstArgument() {
                return this.parseArgument(true);
            } // Implements the parsing rules in the Fragments section.
        },
        {
            /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ key: "parseFragment",
            value: function parseFragment() {
                var start = this._lexer.token;
                this.expectToken((0, $5Qncb.TokenKind).SPREAD);
                var hasTypeCondition = this.expectOptionalKeyword("on");
                if (!hasTypeCondition && this.peek((0, $5Qncb.TokenKind).NAME)) return this.node(start, {
                    kind: (0, $dqOmk.Kind).FRAGMENT_SPREAD,
                    name: this.parseFragmentName(),
                    directives: this.parseDirectives(false)
                });
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).INLINE_FRAGMENT,
                    typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
                    directives: this.parseDirectives(false),
                    selectionSet: this.parseSelectionSet()
                });
            }
        },
        {
            /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ key: "parseFragmentDefinition",
            value: function parseFragmentDefinition() {
                var start = this._lexer.token;
                this.expectKeyword("fragment"); // Legacy support for defining variables within fragments changes
                // the grammar of FragmentDefinition:
                //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
                if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
                    kind: (0, $dqOmk.Kind).FRAGMENT_DEFINITION,
                    name: this.parseFragmentName(),
                    variableDefinitions: this.parseVariableDefinitions(),
                    typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
                    directives: this.parseDirectives(false),
                    selectionSet: this.parseSelectionSet()
                });
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).FRAGMENT_DEFINITION,
                    name: this.parseFragmentName(),
                    typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
                    directives: this.parseDirectives(false),
                    selectionSet: this.parseSelectionSet()
                });
            }
        },
        {
            /**
   * FragmentName : Name but not `on`
   */ key: "parseFragmentName",
            value: function parseFragmentName() {
                if (this._lexer.token.value === "on") throw this.unexpected();
                return this.parseName();
            } // Implements the parsing rules in the Values section.
        },
        {
            /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ key: "parseValueLiteral",
            value: function parseValueLiteral(isConst) {
                var token = this._lexer.token;
                switch(token.kind){
                    case (0, $5Qncb.TokenKind).BRACKET_L:
                        return this.parseList(isConst);
                    case (0, $5Qncb.TokenKind).BRACE_L:
                        return this.parseObject(isConst);
                    case (0, $5Qncb.TokenKind).INT:
                        this.advanceLexer();
                        return this.node(token, {
                            kind: (0, $dqOmk.Kind).INT,
                            value: token.value
                        });
                    case (0, $5Qncb.TokenKind).FLOAT:
                        this.advanceLexer();
                        return this.node(token, {
                            kind: (0, $dqOmk.Kind).FLOAT,
                            value: token.value
                        });
                    case (0, $5Qncb.TokenKind).STRING:
                    case (0, $5Qncb.TokenKind).BLOCK_STRING:
                        return this.parseStringLiteral();
                    case (0, $5Qncb.TokenKind).NAME:
                        this.advanceLexer();
                        switch(token.value){
                            case "true":
                                return this.node(token, {
                                    kind: (0, $dqOmk.Kind).BOOLEAN,
                                    value: true
                                });
                            case "false":
                                return this.node(token, {
                                    kind: (0, $dqOmk.Kind).BOOLEAN,
                                    value: false
                                });
                            case "null":
                                return this.node(token, {
                                    kind: (0, $dqOmk.Kind).NULL
                                });
                            default:
                                return this.node(token, {
                                    kind: (0, $dqOmk.Kind).ENUM,
                                    value: token.value
                                });
                        }
                    case (0, $5Qncb.TokenKind).DOLLAR:
                        if (isConst) {
                            this.expectToken((0, $5Qncb.TokenKind).DOLLAR);
                            if (this._lexer.token.kind === (0, $5Qncb.TokenKind).NAME) {
                                var varName = this._lexer.token.value;
                                throw (0, $52WCf.syntaxError)(this._lexer.source, token.start, 'Unexpected variable "$'.concat(varName, '" in constant value.'));
                            } else throw this.unexpected(token);
                        }
                        return this.parseVariable();
                    default:
                        throw this.unexpected();
                }
            }
        },
        {
            key: "parseConstValueLiteral",
            value: function parseConstValueLiteral() {
                return this.parseValueLiteral(true);
            }
        },
        {
            key: "parseStringLiteral",
            value: function parseStringLiteral() {
                var token = this._lexer.token;
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $dqOmk.Kind).STRING,
                    value: token.value,
                    block: token.kind === (0, $5Qncb.TokenKind).BLOCK_STRING
                });
            }
        },
        {
            /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ key: "parseList",
            value: function parseList(isConst) {
                var _this = this;
                var item = function() {
                    return _this.parseValueLiteral(isConst);
                };
                return this.node(this._lexer.token, {
                    kind: (0, $dqOmk.Kind).LIST,
                    values: this.any((0, $5Qncb.TokenKind).BRACKET_L, item, (0, $5Qncb.TokenKind).BRACKET_R)
                });
            }
        },
        {
            /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ key: "parseObject",
            value: function parseObject(isConst) {
                var _this = this;
                var item = function() {
                    return _this.parseObjectField(isConst);
                };
                return this.node(this._lexer.token, {
                    kind: (0, $dqOmk.Kind).OBJECT,
                    fields: this.any((0, $5Qncb.TokenKind).BRACE_L, item, (0, $5Qncb.TokenKind).BRACE_R)
                });
            }
        },
        {
            /**
   * ObjectField[Const] : Name : Value[?Const]
   */ key: "parseObjectField",
            value: function parseObjectField(isConst) {
                var start = this._lexer.token;
                var name = this.parseName();
                this.expectToken((0, $5Qncb.TokenKind).COLON);
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).OBJECT_FIELD,
                    name: name,
                    value: this.parseValueLiteral(isConst)
                });
            } // Implements the parsing rules in the Directives section.
        },
        {
            /**
   * Directives[Const] : Directive[?Const]+
   */ key: "parseDirectives",
            value: function parseDirectives(isConst) {
                var directives = [];
                while(this.peek((0, $5Qncb.TokenKind).AT))directives.push(this.parseDirective(isConst));
                return directives;
            }
        },
        {
            key: "parseConstDirectives",
            value: function parseConstDirectives() {
                return this.parseDirectives(true);
            }
        },
        {
            /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ key: "parseDirective",
            value: function parseDirective(isConst) {
                var start = this._lexer.token;
                this.expectToken((0, $5Qncb.TokenKind).AT);
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).DIRECTIVE,
                    name: this.parseName(),
                    arguments: this.parseArguments(isConst)
                });
            } // Implements the parsing rules in the Types section.
        },
        {
            /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ key: "parseTypeReference",
            value: function parseTypeReference() {
                var start = this._lexer.token;
                var type;
                if (this.expectOptionalToken((0, $5Qncb.TokenKind).BRACKET_L)) {
                    var innerType = this.parseTypeReference();
                    this.expectToken((0, $5Qncb.TokenKind).BRACKET_R);
                    type = this.node(start, {
                        kind: (0, $dqOmk.Kind).LIST_TYPE,
                        type: innerType
                    });
                } else type = this.parseNamedType();
                if (this.expectOptionalToken((0, $5Qncb.TokenKind).BANG)) return this.node(start, {
                    kind: (0, $dqOmk.Kind).NON_NULL_TYPE,
                    type: type
                });
                return type;
            }
        },
        {
            /**
   * NamedType : Name
   */ key: "parseNamedType",
            value: function parseNamedType() {
                return this.node(this._lexer.token, {
                    kind: (0, $dqOmk.Kind).NAMED_TYPE,
                    name: this.parseName()
                });
            } // Implements the parsing rules in the Type Definition section.
        },
        {
            key: "peekDescription",
            value: function peekDescription() {
                return this.peek((0, $5Qncb.TokenKind).STRING) || this.peek((0, $5Qncb.TokenKind).BLOCK_STRING);
            }
        },
        {
            /**
   * Description : StringValue
   */ key: "parseDescription",
            value: function parseDescription() {
                if (this.peekDescription()) return this.parseStringLiteral();
            }
        },
        {
            /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ key: "parseSchemaDefinition",
            value: function parseSchemaDefinition() {
                var start = this._lexer.token;
                var description = this.parseDescription();
                this.expectKeyword("schema");
                var directives = this.parseConstDirectives();
                var operationTypes = this.many((0, $5Qncb.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $5Qncb.TokenKind).BRACE_R);
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).SCHEMA_DEFINITION,
                    description: description,
                    directives: directives,
                    operationTypes: operationTypes
                });
            }
        },
        {
            /**
   * OperationTypeDefinition : OperationType : NamedType
   */ key: "parseOperationTypeDefinition",
            value: function parseOperationTypeDefinition() {
                var start = this._lexer.token;
                var operation = this.parseOperationType();
                this.expectToken((0, $5Qncb.TokenKind).COLON);
                var type = this.parseNamedType();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).OPERATION_TYPE_DEFINITION,
                    operation: operation,
                    type: type
                });
            }
        },
        {
            /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ key: "parseScalarTypeDefinition",
            value: function parseScalarTypeDefinition() {
                var start = this._lexer.token;
                var description = this.parseDescription();
                this.expectKeyword("scalar");
                var name = this.parseName();
                var directives = this.parseConstDirectives();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).SCALAR_TYPE_DEFINITION,
                    description: description,
                    name: name,
                    directives: directives
                });
            }
        },
        {
            /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ key: "parseObjectTypeDefinition",
            value: function parseObjectTypeDefinition() {
                var start = this._lexer.token;
                var description = this.parseDescription();
                this.expectKeyword("type");
                var name = this.parseName();
                var interfaces = this.parseImplementsInterfaces();
                var directives = this.parseConstDirectives();
                var fields = this.parseFieldsDefinition();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).OBJECT_TYPE_DEFINITION,
                    description: description,
                    name: name,
                    interfaces: interfaces,
                    directives: directives,
                    fields: fields
                });
            }
        },
        {
            /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ key: "parseImplementsInterfaces",
            value: function parseImplementsInterfaces() {
                return this.expectOptionalKeyword("implements") ? this.delimitedMany((0, $5Qncb.TokenKind).AMP, this.parseNamedType) : [];
            }
        },
        {
            /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ key: "parseFieldsDefinition",
            value: function parseFieldsDefinition() {
                return this.optionalMany((0, $5Qncb.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $5Qncb.TokenKind).BRACE_R);
            }
        },
        {
            /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ key: "parseFieldDefinition",
            value: function parseFieldDefinition() {
                var start = this._lexer.token;
                var description = this.parseDescription();
                var name = this.parseName();
                var args = this.parseArgumentDefs();
                this.expectToken((0, $5Qncb.TokenKind).COLON);
                var type = this.parseTypeReference();
                var directives = this.parseConstDirectives();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).FIELD_DEFINITION,
                    description: description,
                    name: name,
                    arguments: args,
                    type: type,
                    directives: directives
                });
            }
        },
        {
            /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ key: "parseArgumentDefs",
            value: function parseArgumentDefs() {
                return this.optionalMany((0, $5Qncb.TokenKind).PAREN_L, this.parseInputValueDef, (0, $5Qncb.TokenKind).PAREN_R);
            }
        },
        {
            /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ key: "parseInputValueDef",
            value: function parseInputValueDef() {
                var start = this._lexer.token;
                var description = this.parseDescription();
                var name = this.parseName();
                this.expectToken((0, $5Qncb.TokenKind).COLON);
                var type = this.parseTypeReference();
                var defaultValue;
                if (this.expectOptionalToken((0, $5Qncb.TokenKind).EQUALS)) defaultValue = this.parseConstValueLiteral();
                var directives = this.parseConstDirectives();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).INPUT_VALUE_DEFINITION,
                    description: description,
                    name: name,
                    type: type,
                    defaultValue: defaultValue,
                    directives: directives
                });
            }
        },
        {
            /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ key: "parseInterfaceTypeDefinition",
            value: function parseInterfaceTypeDefinition() {
                var start = this._lexer.token;
                var description = this.parseDescription();
                this.expectKeyword("interface");
                var name = this.parseName();
                var interfaces = this.parseImplementsInterfaces();
                var directives = this.parseConstDirectives();
                var fields = this.parseFieldsDefinition();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).INTERFACE_TYPE_DEFINITION,
                    description: description,
                    name: name,
                    interfaces: interfaces,
                    directives: directives,
                    fields: fields
                });
            }
        },
        {
            /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ key: "parseUnionTypeDefinition",
            value: function parseUnionTypeDefinition() {
                var start = this._lexer.token;
                var description = this.parseDescription();
                this.expectKeyword("union");
                var name = this.parseName();
                var directives = this.parseConstDirectives();
                var types = this.parseUnionMemberTypes();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).UNION_TYPE_DEFINITION,
                    description: description,
                    name: name,
                    directives: directives,
                    types: types
                });
            }
        },
        {
            /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ key: "parseUnionMemberTypes",
            value: function parseUnionMemberTypes() {
                return this.expectOptionalToken((0, $5Qncb.TokenKind).EQUALS) ? this.delimitedMany((0, $5Qncb.TokenKind).PIPE, this.parseNamedType) : [];
            }
        },
        {
            /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ key: "parseEnumTypeDefinition",
            value: function parseEnumTypeDefinition() {
                var start = this._lexer.token;
                var description = this.parseDescription();
                this.expectKeyword("enum");
                var name = this.parseName();
                var directives = this.parseConstDirectives();
                var values = this.parseEnumValuesDefinition();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).ENUM_TYPE_DEFINITION,
                    description: description,
                    name: name,
                    directives: directives,
                    values: values
                });
            }
        },
        {
            /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ key: "parseEnumValuesDefinition",
            value: function parseEnumValuesDefinition() {
                return this.optionalMany((0, $5Qncb.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $5Qncb.TokenKind).BRACE_R);
            }
        },
        {
            /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ key: "parseEnumValueDefinition",
            value: function parseEnumValueDefinition() {
                var start = this._lexer.token;
                var description = this.parseDescription();
                var name = this.parseEnumValueName();
                var directives = this.parseConstDirectives();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).ENUM_VALUE_DEFINITION,
                    description: description,
                    name: name,
                    directives: directives
                });
            }
        },
        {
            /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ key: "parseEnumValueName",
            value: function parseEnumValueName() {
                if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null") throw (0, $52WCf.syntaxError)(this._lexer.source, this._lexer.token.start, "".concat($7fa84f489267ce10$var$getTokenDesc(this._lexer.token), " is reserved and cannot be used for an enum value."));
                return this.parseName();
            }
        },
        {
            /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ key: "parseInputObjectTypeDefinition",
            value: function parseInputObjectTypeDefinition() {
                var start = this._lexer.token;
                var description = this.parseDescription();
                this.expectKeyword("input");
                var name = this.parseName();
                var directives = this.parseConstDirectives();
                var fields = this.parseInputFieldsDefinition();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).INPUT_OBJECT_TYPE_DEFINITION,
                    description: description,
                    name: name,
                    directives: directives,
                    fields: fields
                });
            }
        },
        {
            /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ key: "parseInputFieldsDefinition",
            value: function parseInputFieldsDefinition() {
                return this.optionalMany((0, $5Qncb.TokenKind).BRACE_L, this.parseInputValueDef, (0, $5Qncb.TokenKind).BRACE_R);
            }
        },
        {
            /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ key: "parseTypeSystemExtension",
            value: function parseTypeSystemExtension() {
                var keywordToken = this._lexer.lookahead();
                if (keywordToken.kind === (0, $5Qncb.TokenKind).NAME) switch(keywordToken.value){
                    case "schema":
                        return this.parseSchemaExtension();
                    case "scalar":
                        return this.parseScalarTypeExtension();
                    case "type":
                        return this.parseObjectTypeExtension();
                    case "interface":
                        return this.parseInterfaceTypeExtension();
                    case "union":
                        return this.parseUnionTypeExtension();
                    case "enum":
                        return this.parseEnumTypeExtension();
                    case "input":
                        return this.parseInputObjectTypeExtension();
                }
                throw this.unexpected(keywordToken);
            }
        },
        {
            /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ key: "parseSchemaExtension",
            value: function parseSchemaExtension() {
                var start = this._lexer.token;
                this.expectKeyword("extend");
                this.expectKeyword("schema");
                var directives = this.parseConstDirectives();
                var operationTypes = this.optionalMany((0, $5Qncb.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $5Qncb.TokenKind).BRACE_R);
                if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).SCHEMA_EXTENSION,
                    directives: directives,
                    operationTypes: operationTypes
                });
            }
        },
        {
            /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ key: "parseScalarTypeExtension",
            value: function parseScalarTypeExtension() {
                var start = this._lexer.token;
                this.expectKeyword("extend");
                this.expectKeyword("scalar");
                var name = this.parseName();
                var directives = this.parseConstDirectives();
                if (directives.length === 0) throw this.unexpected();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).SCALAR_TYPE_EXTENSION,
                    name: name,
                    directives: directives
                });
            }
        },
        {
            /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ key: "parseObjectTypeExtension",
            value: function parseObjectTypeExtension() {
                var start = this._lexer.token;
                this.expectKeyword("extend");
                this.expectKeyword("type");
                var name = this.parseName();
                var interfaces = this.parseImplementsInterfaces();
                var directives = this.parseConstDirectives();
                var fields = this.parseFieldsDefinition();
                if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).OBJECT_TYPE_EXTENSION,
                    name: name,
                    interfaces: interfaces,
                    directives: directives,
                    fields: fields
                });
            }
        },
        {
            /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ key: "parseInterfaceTypeExtension",
            value: function parseInterfaceTypeExtension() {
                var start = this._lexer.token;
                this.expectKeyword("extend");
                this.expectKeyword("interface");
                var name = this.parseName();
                var interfaces = this.parseImplementsInterfaces();
                var directives = this.parseConstDirectives();
                var fields = this.parseFieldsDefinition();
                if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).INTERFACE_TYPE_EXTENSION,
                    name: name,
                    interfaces: interfaces,
                    directives: directives,
                    fields: fields
                });
            }
        },
        {
            /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ key: "parseUnionTypeExtension",
            value: function parseUnionTypeExtension() {
                var start = this._lexer.token;
                this.expectKeyword("extend");
                this.expectKeyword("union");
                var name = this.parseName();
                var directives = this.parseConstDirectives();
                var types = this.parseUnionMemberTypes();
                if (directives.length === 0 && types.length === 0) throw this.unexpected();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).UNION_TYPE_EXTENSION,
                    name: name,
                    directives: directives,
                    types: types
                });
            }
        },
        {
            /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ key: "parseEnumTypeExtension",
            value: function parseEnumTypeExtension() {
                var start = this._lexer.token;
                this.expectKeyword("extend");
                this.expectKeyword("enum");
                var name = this.parseName();
                var directives = this.parseConstDirectives();
                var values = this.parseEnumValuesDefinition();
                if (directives.length === 0 && values.length === 0) throw this.unexpected();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).ENUM_TYPE_EXTENSION,
                    name: name,
                    directives: directives,
                    values: values
                });
            }
        },
        {
            /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ key: "parseInputObjectTypeExtension",
            value: function parseInputObjectTypeExtension() {
                var start = this._lexer.token;
                this.expectKeyword("extend");
                this.expectKeyword("input");
                var name = this.parseName();
                var directives = this.parseConstDirectives();
                var fields = this.parseInputFieldsDefinition();
                if (directives.length === 0 && fields.length === 0) throw this.unexpected();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).INPUT_OBJECT_TYPE_EXTENSION,
                    name: name,
                    directives: directives,
                    fields: fields
                });
            }
        },
        {
            /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ key: "parseDirectiveDefinition",
            value: function parseDirectiveDefinition() {
                var start = this._lexer.token;
                var description = this.parseDescription();
                this.expectKeyword("directive");
                this.expectToken((0, $5Qncb.TokenKind).AT);
                var name = this.parseName();
                var args = this.parseArgumentDefs();
                var repeatable = this.expectOptionalKeyword("repeatable");
                this.expectKeyword("on");
                var locations = this.parseDirectiveLocations();
                return this.node(start, {
                    kind: (0, $dqOmk.Kind).DIRECTIVE_DEFINITION,
                    description: description,
                    name: name,
                    arguments: args,
                    repeatable: repeatable,
                    locations: locations
                });
            }
        },
        {
            /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ key: "parseDirectiveLocations",
            value: function parseDirectiveLocations() {
                return this.delimitedMany((0, $5Qncb.TokenKind).PIPE, this.parseDirectiveLocation);
            }
        },
        {
            /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ key: "parseDirectiveLocation",
            value: function parseDirectiveLocation() {
                var start = this._lexer.token;
                var name = this.parseName();
                if (Object.prototype.hasOwnProperty.call((0, $kBjkj.DirectiveLocation), name.value)) return name;
                throw this.unexpected(start);
            } // Core parsing utility functions
        },
        {
            /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ key: "node",
            value: function node(startToken, node) {
                if (this._options.noLocation !== true) node.loc = new (0, $cvgER.Location)(startToken, this._lexer.lastToken, this._lexer.source);
                return node;
            }
        },
        {
            /**
   * Determines if the next token is of a given kind
   */ key: "peek",
            value: function peek(kind) {
                return this._lexer.token.kind === kind;
            }
        },
        {
            /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ key: "expectToken",
            value: function expectToken(kind) {
                var token = this._lexer.token;
                if (token.kind === kind) {
                    this.advanceLexer();
                    return token;
                }
                throw (0, $52WCf.syntaxError)(this._lexer.source, token.start, "Expected ".concat($7fa84f489267ce10$var$getTokenKindDesc(kind), ", found ").concat($7fa84f489267ce10$var$getTokenDesc(token), "."));
            }
        },
        {
            /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ key: "expectOptionalToken",
            value: function expectOptionalToken(kind) {
                var token = this._lexer.token;
                if (token.kind === kind) {
                    this.advanceLexer();
                    return true;
                }
                return false;
            }
        },
        {
            /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ key: "expectKeyword",
            value: function expectKeyword(value) {
                var token = this._lexer.token;
                if (token.kind === (0, $5Qncb.TokenKind).NAME && token.value === value) this.advanceLexer();
                else throw (0, $52WCf.syntaxError)(this._lexer.source, token.start, 'Expected "'.concat(value, '", found ').concat($7fa84f489267ce10$var$getTokenDesc(token), "."));
            }
        },
        {
            /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ key: "expectOptionalKeyword",
            value: function expectOptionalKeyword(value) {
                var token = this._lexer.token;
                if (token.kind === (0, $5Qncb.TokenKind).NAME && token.value === value) {
                    this.advanceLexer();
                    return true;
                }
                return false;
            }
        },
        {
            /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ key: "unexpected",
            value: function unexpected(atToken) {
                var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
                return (0, $52WCf.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($7fa84f489267ce10$var$getTokenDesc(token), "."));
            }
        },
        {
            /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ key: "any",
            value: function any(openKind, parseFn, closeKind) {
                this.expectToken(openKind);
                var nodes = [];
                while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
                return nodes;
            }
        },
        {
            /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ key: "optionalMany",
            value: function optionalMany(openKind, parseFn, closeKind) {
                if (this.expectOptionalToken(openKind)) {
                    var nodes = [];
                    do nodes.push(parseFn.call(this));
                    while (!this.expectOptionalToken(closeKind));
                    return nodes;
                }
                return [];
            }
        },
        {
            /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ key: "many",
            value: function many(openKind, parseFn, closeKind) {
                this.expectToken(openKind);
                var nodes = [];
                do nodes.push(parseFn.call(this));
                while (!this.expectOptionalToken(closeKind));
                return nodes;
            }
        },
        {
            /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ key: "delimitedMany",
            value: function delimitedMany(delimiterKind, parseFn) {
                this.expectOptionalToken(delimiterKind);
                var nodes = [];
                do nodes.push(parseFn.call(this));
                while (this.expectOptionalToken(delimiterKind));
                return nodes;
            }
        },
        {
            key: "advanceLexer",
            value: function advanceLexer() {
                var maxTokens = this._options.maxTokens;
                var token = this._lexer.advance();
                if (maxTokens !== undefined && token.kind !== (0, $5Qncb.TokenKind).EOF) {
                    ++this._tokenCounter;
                    if (this._tokenCounter > maxTokens) throw (0, $52WCf.syntaxError)(this._lexer.source, token.start, "Document contains more that ".concat(maxTokens, " tokens. Parsing aborted."));
                }
            }
        }
    ]);
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $7fa84f489267ce10$var$getTokenDesc(token) {
    var value = token.value;
    return $7fa84f489267ce10$var$getTokenKindDesc(token.kind) + (value != null ? ' "'.concat(value, '"') : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $7fa84f489267ce10$var$getTokenKindDesc(kind) {
    return (0, $fe01d.isPunctuatorTokenKind)(kind) ? '"'.concat(kind, '"') : kind;
}

});
parcelRequire.register("52WCf", function(module, exports) {

$parcel$export(module.exports, "syntaxError", function () { return $4d890eccfef9dd1a$export$bbee0c6176c019d4; });

var $gyfr9 = parcelRequire("gyfr9");
function $4d890eccfef9dd1a$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $gyfr9.GraphQLError)("Syntax Error: ".concat(description), {
        source: source,
        positions: [
            position
        ]
    });
}

});
parcelRequire.register("gyfr9", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", function () { return $339a7c3b6d83d0f3$export$92d6ed0888e7cb7f; });

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $2TMdq = parcelRequire("2TMdq");

var $6OZAO = parcelRequire("6OZAO");

var $aqMrr = parcelRequire("aqMrr");

var $kBwpp = parcelRequire("kBwpp");

var $04gJG = parcelRequire("04gJG");
function $339a7c3b6d83d0f3$var$toNormalizedOptions(args) {
    var firstArg = args[0];
    if (firstArg == null || "kind" in firstArg || "length" in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
var $339a7c3b6d83d0f3$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $ftJVG._)(GraphQLError, Error1);
    var _super = (0, $6OZAO._)(GraphQLError);
    function GraphQLError(message) {
        for(var _len = arguments.length, rawArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            rawArgs[_key - 1] = arguments[_key];
        }
        (0, $978gY._)(this, GraphQLError);
        var _this;
        var _this$nodes, _nodeLocations$, _ref;
        var _toNormalizedOptions = $339a7c3b6d83d0f3$var$toNormalizedOptions(rawArgs), nodes = _toNormalizedOptions.nodes, source = _toNormalizedOptions.source, positions = _toNormalizedOptions.positions, path = _toNormalizedOptions.path, originalError = _toNormalizedOptions.originalError, extensions = _toNormalizedOptions.extensions;
        _this = _super.call(this, message);
        _this.name = "GraphQLError";
        _this.path = path !== null && path !== void 0 ? path : undefined;
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $339a7c3b6d83d0f3$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = $339a7c3b6d83d0f3$var$undefinedIfEmpty((_this$nodes = _this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map(function(node) {
            return node.loc;
        }).filter(function(loc) {
            return loc != null;
        })); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        _this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $kBwpp.getLocation)(source, pos);
        }) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map(function(loc) {
            return (0, $kBwpp.getLocation)(loc.source, loc.start);
        });
        var originalExtensions = (0, $aqMrr.isObjectLike)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        _this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties((0, $3vWwE._)(_this), {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty((0, $3vWwE._)(_this), "stack", {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace((0, $3vWwE._)(_this), GraphQLError);
        else Object.defineProperty((0, $3vWwE._)(_this), "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    (0, $kry2a._)(GraphQLError, [
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "GraphQLError";
            }
        },
        {
            key: "toString",
            value: function toString() {
                var output = this.message;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (this.nodes) {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator = this.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                            var node = _step.value;
                            if (node.loc) output += "\n\n" + (0, $04gJG.printLocation)(node.loc);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } else if (this.source && this.locations) try {
                    for(var _iterator1 = this.locations[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var location = _step1.value;
                        output += "\n\n" + (0, $04gJG.printSourceLocation)(this.source, location);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return output;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var formattedError = {
                    message: this.message
                };
                if (this.locations != null) formattedError.locations = this.locations;
                if (this.path != null) formattedError.path = this.path;
                if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
                return formattedError;
            }
        }
    ]);
    return GraphQLError;
}((0, $2TMdq._)(Error));
function $339a7c3b6d83d0f3$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $339a7c3b6d83d0f3$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $339a7c3b6d83d0f3$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}

});
parcelRequire.register("aqMrr", function(module, exports) {

$parcel$export(module.exports, "isObjectLike", function () { return $2ab261425b002006$export$c10d0b04eaa80a43; });
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $2ab261425b002006$export$c10d0b04eaa80a43(value) {
    return typeof value == "object" && value !== null;
}

});

parcelRequire.register("kBwpp", function(module, exports) {

$parcel$export(module.exports, "getLocation", function () { return $091870419ef55d0f$export$e7fd20fad3cf4b5f; });

var $3BgKu = parcelRequire("3BgKu");
var $091870419ef55d0f$var$LineRegExp = /\r\n|[\n\r]/g;
function $091870419ef55d0f$export$e7fd20fad3cf4b5f(source, position) {
    var lastLineStart = 0;
    var line = 1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = source.body.matchAll($091870419ef55d0f$var$LineRegExp)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            typeof match.index === "number" || (0, $3BgKu.invariant)(false);
            if (match.index >= position) break;
            lastLineStart = match.index + match[0].length;
            line += 1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}

});
parcelRequire.register("3BgKu", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $71bf1b6dca09c0e4$export$f5708dca728d7177; });
function $71bf1b6dca09c0e4$export$f5708dca728d7177(condition, message) {
    var booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}

});


parcelRequire.register("04gJG", function(module, exports) {

$parcel$export(module.exports, "printLocation", function () { return $1cf8a0e4e191436b$export$96a9681e539deed; });
$parcel$export(module.exports, "printSourceLocation", function () { return $1cf8a0e4e191436b$export$867940333fd9f869; });

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $kBwpp = parcelRequire("kBwpp");
function $1cf8a0e4e191436b$export$96a9681e539deed(location) {
    return $1cf8a0e4e191436b$export$867940333fd9f869(location.source, (0, $kBwpp.getLocation)(location.source, location.start));
}
function $1cf8a0e4e191436b$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = "".padStart(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $1cf8a0e4e191436b$var$printPrefixedLines([
            [
                "".concat(lineNum, " |"),
                subLines[0]
            ]
        ].concat((0, $fLnyw._)(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                "|",
                subLine
            ];
        })), [
            [
                "|",
                "^".padStart(subLineColumnNum)
            ],
            [
                "|",
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $1cf8a0e4e191436b$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            "".concat(lineNum - 1, " |"),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum, " |"),
            locationLine
        ],
        [
            "|",
            "^".padStart(columnNum)
        ],
        [
            "".concat(lineNum + 1, " |"),
            lines[lineIndex + 1]
        ]
    ]);
}
function $1cf8a0e4e191436b$var$printPrefixedLines(lines) {
    var _Math;
    var existingLines = lines.filter(function(param) {
        var _param = (0, $8GFUW._)(param, 2), _ = _param[0], line = _param[1];
        return line !== undefined;
    });
    var padLen = (_Math = Math).max.apply(_Math, (0, $fLnyw._)(existingLines.map(function(param) {
        var _param = (0, $8GFUW._)(param, 1), prefix = _param[0];
        return prefix.length;
    })));
    return existingLines.map(function(param) {
        var _param = (0, $8GFUW._)(param, 2), prefix = _param[0], line = _param[1];
        return prefix.padStart(padLen) + (line ? " " + line : "");
    }).join("\n");
}

});



parcelRequire.register("cvgER", function(module, exports) {

$parcel$export(module.exports, "Location", function () { return $da9fa5e591be44e0$export$18a2be9195644f38; });
$parcel$export(module.exports, "Token", function () { return $da9fa5e591be44e0$export$50792b0e93539fde; });
$parcel$export(module.exports, "QueryDocumentKeys", function () { return $da9fa5e591be44e0$export$4fcd777a40ccf407; });
$parcel$export(module.exports, "isNode", function () { return $da9fa5e591be44e0$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "OperationTypeNode", function () { return $da9fa5e591be44e0$export$f58c50edb4aef9d4; });
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ 
var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");
var $da9fa5e591be44e0$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    "use strict";
    function Location(startToken, endToken, source) {
        (0, $978gY._)(this, Location);
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    (0, $kry2a._)(Location, [
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Location";
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    start: this.start,
                    end: this.end
                };
            }
        }
    ]);
    return Location;
}();
var $da9fa5e591be44e0$export$50792b0e93539fde = /*#__PURE__*/ function() {
    "use strict";
    function Token(kind, start, end, line, column, value) {
        (0, $978gY._)(this, Token);
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    (0, $kry2a._)(Token, [
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Token";
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind,
                    value: this.value,
                    line: this.line,
                    column: this.column
                };
            }
        }
    ]);
    return Token;
}();
var $da9fa5e591be44e0$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
var $da9fa5e591be44e0$var$kindValues = new Set(Object.keys($da9fa5e591be44e0$export$4fcd777a40ccf407));
function $da9fa5e591be44e0$export$8ee0fc9ee280b4ee(maybeNode) {
    var maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && $da9fa5e591be44e0$var$kindValues.has(maybeKind);
}
/** Name */ var $da9fa5e591be44e0$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($da9fa5e591be44e0$export$f58c50edb4aef9d4 || ($da9fa5e591be44e0$export$f58c50edb4aef9d4 = {}));

});

parcelRequire.register("kBjkj", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", function () { return $a7a51d5bf97093a0$export$b45ffd2948484c41; });
/**
 * The set of allowed directive location values.
 */ var $a7a51d5bf97093a0$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation["QUERY"] = "QUERY";
    DirectiveLocation["MUTATION"] = "MUTATION";
    DirectiveLocation["SUBSCRIPTION"] = "SUBSCRIPTION";
    DirectiveLocation["FIELD"] = "FIELD";
    DirectiveLocation["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
    DirectiveLocation["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
    DirectiveLocation["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
    DirectiveLocation["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
    DirectiveLocation["SCHEMA"] = "SCHEMA";
    DirectiveLocation["SCALAR"] = "SCALAR";
    DirectiveLocation["OBJECT"] = "OBJECT";
    DirectiveLocation["FIELD_DEFINITION"] = "FIELD_DEFINITION";
    DirectiveLocation["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
    DirectiveLocation["INTERFACE"] = "INTERFACE";
    DirectiveLocation["UNION"] = "UNION";
    DirectiveLocation["ENUM"] = "ENUM";
    DirectiveLocation["ENUM_VALUE"] = "ENUM_VALUE";
    DirectiveLocation["INPUT_OBJECT"] = "INPUT_OBJECT";
    DirectiveLocation["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
})($a7a51d5bf97093a0$export$b45ffd2948484c41 || ($a7a51d5bf97093a0$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 
});

parcelRequire.register("dqOmk", function(module, exports) {

$parcel$export(module.exports, "Kind", function () { return $753e21ebe0b0b700$export$a84bdc57c5122798; });
/**
 * The set of allowed kind values for AST nodes.
 */ var $753e21ebe0b0b700$export$a84bdc57c5122798;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($753e21ebe0b0b700$export$a84bdc57c5122798 || ($753e21ebe0b0b700$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 
});

parcelRequire.register("fe01d", function(module, exports) {

$parcel$export(module.exports, "Lexer", function () { return $a7343cf7f0dab484$export$6168dc8908a6c652; });
$parcel$export(module.exports, "isPunctuatorTokenKind", function () { return $a7343cf7f0dab484$export$59ac0f4da287406a; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $52WCf = parcelRequire("52WCf");

var $cvgER = parcelRequire("cvgER");

var $KQqF6 = parcelRequire("KQqF6");

var $lKTZY = parcelRequire("lKTZY");

var $5Qncb = parcelRequire("5Qncb");
var $a7343cf7f0dab484$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    "use strict";
    function Lexer(source) {
        (0, $978gY._)(this, Lexer);
        var startOfFileToken = new (0, $cvgER.Token)((0, $5Qncb.TokenKind).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    (0, $kry2a._)(Lexer, [
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Lexer";
            }
        },
        {
            /**
   * Advances the token stream to the next non-ignored token.
   */ key: "advance",
            value: function advance() {
                this.lastToken = this.token;
                var token = this.token = this.lookahead();
                return token;
            }
        },
        {
            /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ key: "lookahead",
            value: function lookahead() {
                var token = this.token;
                if (token.kind !== (0, $5Qncb.TokenKind).EOF) {
                    do if (token.next) token = token.next;
                    else {
                        // Read the next token and form a link in the token linked-list.
                        var nextToken = $a7343cf7f0dab484$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                        token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                        nextToken.prev = token;
                        token = nextToken;
                    }
                    while (token.kind === (0, $5Qncb.TokenKind).COMMENT);
                }
                return token;
            }
        }
    ]);
    return Lexer;
}();
function $a7343cf7f0dab484$export$59ac0f4da287406a(kind) {
    return kind === (0, $5Qncb.TokenKind).BANG || kind === (0, $5Qncb.TokenKind).DOLLAR || kind === (0, $5Qncb.TokenKind).AMP || kind === (0, $5Qncb.TokenKind).PAREN_L || kind === (0, $5Qncb.TokenKind).PAREN_R || kind === (0, $5Qncb.TokenKind).SPREAD || kind === (0, $5Qncb.TokenKind).COLON || kind === (0, $5Qncb.TokenKind).EQUALS || kind === (0, $5Qncb.TokenKind).AT || kind === (0, $5Qncb.TokenKind).BRACKET_L || kind === (0, $5Qncb.TokenKind).BRACKET_R || kind === (0, $5Qncb.TokenKind).BRACE_L || kind === (0, $5Qncb.TokenKind).PIPE || kind === (0, $5Qncb.TokenKind).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $a7343cf7f0dab484$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $a7343cf7f0dab484$var$isSupplementaryCodePoint(body, location) {
    return $a7343cf7f0dab484$var$isLeadingSurrogate(body.charCodeAt(location)) && $a7343cf7f0dab484$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $a7343cf7f0dab484$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $a7343cf7f0dab484$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $a7343cf7f0dab484$var$printCodePointAt(lexer, location) {
    var code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $5Qncb.TokenKind).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        var char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : '"'.concat(char, '"');
    } // Unicode code point
    return "U+" + code.toString(16).toUpperCase().padStart(4, "0");
}
/**
 * Create a token with line and column location information.
 */ function $a7343cf7f0dab484$var$createToken(lexer, kind, start, end, value) {
    var line = lexer.line;
    var col = 1 + start - lexer.lineStart;
    return new (0, $cvgER.Token)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $a7343cf7f0dab484$var$readNextToken(lexer, start) {
    var body = lexer.source.body;
    var bodyLength = body.length;
    var position = start;
    while(position < bodyLength){
        var code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $a7343cf7f0dab484$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).BANG, position, position + 1);
            case 0x0024:
                // $
                return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).AMP, position, position + 1);
            case 0x0028:
                // (
                return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).COLON, position, position + 1);
            case 0x003d:
                // =
                return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).AT, position, position + 1);
            case 0x005b:
                // [
                return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $a7343cf7f0dab484$var$readBlockString(lexer, position);
                return $a7343cf7f0dab484$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $lKTZY.isDigit)(code) || code === 0x002d) return $a7343cf7f0dab484$var$readNumber(lexer, position, code);
         // Name
        if ((0, $lKTZY.isNameStart)(code)) return $a7343cf7f0dab484$var$readName(lexer, position);
        throw (0, $52WCf.syntaxError)(lexer.source, position, code === 0x0027 ? "Unexpected single quote character ('), did you mean to use a double quote (\")?" : $a7343cf7f0dab484$var$isUnicodeScalarValue(code) || $a7343cf7f0dab484$var$isSupplementaryCodePoint(body, position) ? "Unexpected character: ".concat($a7343cf7f0dab484$var$printCodePointAt(lexer, position), ".") : "Invalid character: ".concat($a7343cf7f0dab484$var$printCodePointAt(lexer, position), "."));
    }
    return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $a7343cf7f0dab484$var$readComment(lexer, start) {
    var body = lexer.source.body;
    var bodyLength = body.length;
    var position = start + 1;
    while(position < bodyLength){
        var code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($a7343cf7f0dab484$var$isUnicodeScalarValue(code)) ++position;
        else if ($a7343cf7f0dab484$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $a7343cf7f0dab484$var$readNumber(lexer, start, firstCode) {
    var body = lexer.source.body;
    var position = start;
    var code = firstCode;
    var isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $lKTZY.isDigit)(code)) throw (0, $52WCf.syntaxError)(lexer.source, position, "Invalid number, unexpected digit after 0: ".concat($a7343cf7f0dab484$var$printCodePointAt(lexer, position), "."));
    } else {
        position = $a7343cf7f0dab484$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $a7343cf7f0dab484$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $a7343cf7f0dab484$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $lKTZY.isNameStart)(code)) throw (0, $52WCf.syntaxError)(lexer.source, position, "Invalid number, expected digit but got: ".concat($a7343cf7f0dab484$var$printCodePointAt(lexer, position), "."));
    return $a7343cf7f0dab484$var$createToken(lexer, isFloat ? (0, $5Qncb.TokenKind).FLOAT : (0, $5Qncb.TokenKind).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $a7343cf7f0dab484$var$readDigits(lexer, start, firstCode) {
    if (!(0, $lKTZY.isDigit)(firstCode)) throw (0, $52WCf.syntaxError)(lexer.source, start, "Invalid number, expected digit but got: ".concat($a7343cf7f0dab484$var$printCodePointAt(lexer, start), "."));
    var body = lexer.source.body;
    var position = start + 1; // +1 to skip first firstCode
    while((0, $lKTZY.isDigit)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $a7343cf7f0dab484$var$readString(lexer, start) {
    var body = lexer.source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var chunkStart = position;
    var value = "";
    while(position < bodyLength){
        var code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            var escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $a7343cf7f0dab484$var$readEscapedUnicodeVariableWidth(lexer, position) : $a7343cf7f0dab484$var$readEscapedUnicodeFixedWidth(lexer, position) : $a7343cf7f0dab484$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($a7343cf7f0dab484$var$isUnicodeScalarValue(code)) ++position;
        else if ($a7343cf7f0dab484$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $52WCf.syntaxError)(lexer.source, position, "Invalid character within String: ".concat($a7343cf7f0dab484$var$printCodePointAt(lexer, position), "."));
    }
    throw (0, $52WCf.syntaxError)(lexer.source, position, "Unterminated string.");
} // The string value and lexed size of an escape sequence.
function $a7343cf7f0dab484$var$readEscapedUnicodeVariableWidth(lexer, position) {
    var body = lexer.source.body;
    var point = 0;
    var size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        var code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$a7343cf7f0dab484$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $a7343cf7f0dab484$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $52WCf.syntaxError)(lexer.source, position, 'Invalid Unicode escape sequence: "'.concat(body.slice(position, position + size), '".'));
}
function $a7343cf7f0dab484$var$readEscapedUnicodeFixedWidth(lexer, position) {
    var body = lexer.source.body;
    var code = $a7343cf7f0dab484$var$read16BitHexCode(body, position + 2);
    if ($a7343cf7f0dab484$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($a7343cf7f0dab484$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            var trailingCode = $a7343cf7f0dab484$var$read16BitHexCode(body, position + 8);
            if ($a7343cf7f0dab484$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $52WCf.syntaxError)(lexer.source, position, 'Invalid Unicode escape sequence: "'.concat(body.slice(position, position + 6), '".'));
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $a7343cf7f0dab484$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $a7343cf7f0dab484$var$readHexDigit(body.charCodeAt(position)) << 12 | $a7343cf7f0dab484$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $a7343cf7f0dab484$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $a7343cf7f0dab484$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $a7343cf7f0dab484$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $a7343cf7f0dab484$var$readEscapedCharacter(lexer, position) {
    var body = lexer.source.body;
    var code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '"',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: "\\",
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: "/",
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: "\b",
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: "\f",
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: "\n",
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: "\r",
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: "	",
                size: 2
            };
    }
    throw (0, $52WCf.syntaxError)(lexer.source, position, 'Invalid character escape sequence: "'.concat(body.slice(position, position + 2), '".'));
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $a7343cf7f0dab484$var$readBlockString(lexer, start) {
    var body = lexer.source.body;
    var bodyLength = body.length;
    var lineStart = lexer.lineStart;
    var position = start + 3;
    var chunkStart = position;
    var currentLine = "";
    var blockLines = [];
    while(position < bodyLength){
        var code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            var token = $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).BLOCK_STRING, start, position + 3, (0, $KQqF6.dedentBlockStringLines)(blockLines).join("\n"));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = "";
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($a7343cf7f0dab484$var$isUnicodeScalarValue(code)) ++position;
        else if ($a7343cf7f0dab484$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $52WCf.syntaxError)(lexer.source, position, "Invalid character within String: ".concat($a7343cf7f0dab484$var$printCodePointAt(lexer, position), "."));
    }
    throw (0, $52WCf.syntaxError)(lexer.source, position, "Unterminated string.");
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $a7343cf7f0dab484$var$readName(lexer, start) {
    var body = lexer.source.body;
    var bodyLength = body.length;
    var position = start + 1;
    while(position < bodyLength){
        var code = body.charCodeAt(position);
        if ((0, $lKTZY.isNameContinue)(code)) ++position;
        else break;
    }
    return $a7343cf7f0dab484$var$createToken(lexer, (0, $5Qncb.TokenKind).NAME, start, position, body.slice(start, position));
}

});
parcelRequire.register("KQqF6", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringLines", function () { return $d24bcac2e4a322c7$export$d5ee19b441e8d2ae; });
$parcel$export(module.exports, "printBlockString", function () { return $d24bcac2e4a322c7$export$adb6ca997eeb1f45; });

var $lKTZY = parcelRequire("lKTZY");
function $d24bcac2e4a322c7$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    var commonIndent = Number.MAX_SAFE_INTEGER;
    var firstNonEmptyLine = null;
    var lastNonEmptyLine = -1;
    for(var i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        var line = lines[i];
        var indent = $d24bcac2e4a322c7$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map(function(line, i) {
        return i === 0 ? line : line.slice(commonIndent);
    }) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $d24bcac2e4a322c7$var$leadingWhitespace(str) {
    var i = 0;
    while(i < str.length && (0, $lKTZY.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
function $d24bcac2e4a322c7$export$40862a63ef85e395(value) {
    if (value === "") return true; // empty string is printable
    var isEmptyLine = true;
    var hasIndent = false;
    var hasCommonIndent = true;
    var seenNonEmptyLine = false;
    for(var i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $d24bcac2e4a322c7$export$adb6ca997eeb1f45(value, options) {
    var escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    var lines = escapedValue.split(/\r\n|[\n\r]/g);
    var isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    var forceLeadingNewLine = lines.length > 1 && lines.slice(1).every(function(line) {
        return line.length === 0 || (0, $lKTZY.isWhiteSpace)(line.charCodeAt(0));
    }); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    var hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    var hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    var hasTrailingSlash = value.endsWith("\\");
    var forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    var printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    var result = ""; // Format a multi-line block quote to account for leading space.
    var skipLeadingNewLine = isSingleLine && (0, $lKTZY.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}

});
parcelRequire.register("lKTZY", function(module, exports) {

$parcel$export(module.exports, "isWhiteSpace", function () { return $17f85b64b3eb9a60$export$3c52dd84024ae72c; });
$parcel$export(module.exports, "isDigit", function () { return $17f85b64b3eb9a60$export$727d9dbc4fbb948f; });
$parcel$export(module.exports, "isNameStart", function () { return $17f85b64b3eb9a60$export$45a677ea7cb6d5c8; });
$parcel$export(module.exports, "isNameContinue", function () { return $17f85b64b3eb9a60$export$d3f406ff46035894; });
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $17f85b64b3eb9a60$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $17f85b64b3eb9a60$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $17f85b64b3eb9a60$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $17f85b64b3eb9a60$export$45a677ea7cb6d5c8(code) {
    return $17f85b64b3eb9a60$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $17f85b64b3eb9a60$export$d3f406ff46035894(code) {
    return $17f85b64b3eb9a60$export$79c5d5217943d6a7(code) || $17f85b64b3eb9a60$export$727d9dbc4fbb948f(code) || code === 0x005f;
}

});


parcelRequire.register("5Qncb", function(module, exports) {

$parcel$export(module.exports, "TokenKind", function () { return $fcbb8345ecfb3152$export$8b9d26ab11394711; });
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $fcbb8345ecfb3152$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind["SOF"] = "<SOF>";
    TokenKind["EOF"] = "<EOF>";
    TokenKind["BANG"] = "!";
    TokenKind["DOLLAR"] = "$";
    TokenKind["AMP"] = "&";
    TokenKind["PAREN_L"] = "(";
    TokenKind["PAREN_R"] = ")";
    TokenKind["SPREAD"] = "...";
    TokenKind["COLON"] = ":";
    TokenKind["EQUALS"] = "=";
    TokenKind["AT"] = "@";
    TokenKind["BRACKET_L"] = "[";
    TokenKind["BRACKET_R"] = "]";
    TokenKind["BRACE_L"] = "{";
    TokenKind["PIPE"] = "|";
    TokenKind["BRACE_R"] = "}";
    TokenKind["NAME"] = "Name";
    TokenKind["INT"] = "Int";
    TokenKind["FLOAT"] = "Float";
    TokenKind["STRING"] = "String";
    TokenKind["BLOCK_STRING"] = "BlockString";
    TokenKind["COMMENT"] = "Comment";
})($fcbb8345ecfb3152$export$8b9d26ab11394711 || ($fcbb8345ecfb3152$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 
});


parcelRequire.register("1XEWr", function(module, exports) {

$parcel$export(module.exports, "Source", function () { return $f20fc8528b9efcb7$export$1d2df86270c81ecb; });
$parcel$export(module.exports, "isSource", function () { return $f20fc8528b9efcb7$export$75135ee9ed6e435b; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $8gyJp = parcelRequire("8gyJp");

var $9cdcQ = parcelRequire("9cdcQ");

var $ijqCD = parcelRequire("ijqCD");
var $f20fc8528b9efcb7$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    "use strict";
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "GraphQL request", locationOffset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
            line: 1,
            column: 1
        };
        (0, $978gY._)(this, Source);
        typeof body === "string" || (0, $8gyJp.devAssert)(false, "Body must be a string. Received: ".concat((0, $9cdcQ.inspect)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $8gyJp.devAssert)(false, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $8gyJp.devAssert)(false, "column in locationOffset is 1-indexed and must be positive.");
    }
    (0, $kry2a._)(Source, [
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Source";
            }
        }
    ]);
    return Source;
}();
function $f20fc8528b9efcb7$export$75135ee9ed6e435b(source) {
    return (0, $ijqCD.instanceOf)(source, $f20fc8528b9efcb7$export$1d2df86270c81ecb);
}

});
parcelRequire.register("8gyJp", function(module, exports) {

$parcel$export(module.exports, "devAssert", function () { return $459105d9452f06b2$export$b6cb5906f04696c8; });
function $459105d9452f06b2$export$b6cb5906f04696c8(condition, message) {
    var booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}

});

parcelRequire.register("9cdcQ", function(module, exports) {

$parcel$export(module.exports, "inspect", function () { return $b2c739a511a84f33$export$9dec5d1b3b6a130d; });

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $1ObTH = parcelRequire("1ObTH");
var $b2c739a511a84f33$var$MAX_ARRAY_LENGTH = 10;
var $b2c739a511a84f33$var$MAX_RECURSIVE_DEPTH = 2;
function $b2c739a511a84f33$export$9dec5d1b3b6a130d(value) {
    return $b2c739a511a84f33$var$formatValue(value, []);
}
function $b2c739a511a84f33$var$formatValue(value, seenValues) {
    switch(typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value)){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? "[function ".concat(value.name, "]") : "[function]";
        case "object":
            return $b2c739a511a84f33$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $b2c739a511a84f33$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    var seenValues = (0, $fLnyw._)(previouslySeenValues).concat([
        value
    ]);
    if ($b2c739a511a84f33$var$isJSONable(value)) {
        var jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $b2c739a511a84f33$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $b2c739a511a84f33$var$formatArray(value, seenValues);
    return $b2c739a511a84f33$var$formatObject(value, seenValues);
}
function $b2c739a511a84f33$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $b2c739a511a84f33$var$formatObject(object, seenValues) {
    var entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $b2c739a511a84f33$var$MAX_RECURSIVE_DEPTH) return "[" + $b2c739a511a84f33$var$getObjectTag(object) + "]";
    var properties = entries.map(function(param) {
        var _param = (0, $8GFUW._)(param, 2), key = _param[0], value = _param[1];
        return key + ": " + $b2c739a511a84f33$var$formatValue(value, seenValues);
    });
    return "{ " + properties.join(", ") + " }";
}
function $b2c739a511a84f33$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $b2c739a511a84f33$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    var len = Math.min($b2c739a511a84f33$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($b2c739a511a84f33$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return "[" + items.join(", ") + "]";
}
function $b2c739a511a84f33$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        var name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}

});

parcelRequire.register("ijqCD", function(module, exports) {

$parcel$export(module.exports, "instanceOf", function () { return $c538906ff539dd48$export$ca03416d6c9e029e; });

var $9cdcQ = parcelRequire("9cdcQ");
var $c538906ff539dd48$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === "object" && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        var className = constructor.prototype[Symbol.toStringTag];
        var valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            var stringifiedValue = (0, $9cdcQ.inspect)(value);
            throw new Error("Cannot use ".concat(className, ' "').concat(stringifiedValue, '" from another module or realm.\n\nEnsure that there is only one instance of "graphql" in the node_modules\ndirectory. If different versions of "graphql" are the dependencies of other\nrelied on modules, use "resolutions" to ensure only one version is installed.\n\nhttps://yarnpkg.com/en/docs/selective-version-resolutions\n\nDuplicate "graphql" modules cannot be used at the same time since different\nversions may have different capabilities and behavior. The data from one\nversion used in the function from another could produce confusing and\nspurious results.'));
        }
    }
    return false;
};

});




parcelRequire.register("gkqPm", function(module, exports) {
"use strict";
var $be3352f059436fa6$var$__assign = module.exports && module.exports.__assign || function() {
    $be3352f059436fa6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $be3352f059436fa6$var$__assign.apply(this, arguments);
};
var $be3352f059436fa6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $be3352f059436fa6$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $be3352f059436fa6$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $be3352f059436fa6$var$__createBinding(result, mod, k);
    }
    $be3352f059436fa6$var$__setModuleDefault(result, mod);
    return result;
};
var $be3352f059436fa6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $be3352f059436fa6$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};
var $be3352f059436fa6$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $be3352f059436fa6$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $be3352f059436fa6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveRequestDocument = module.exports.GraphQLWebSocketClient = module.exports.gql = module.exports.batchRequests = module.exports.request = module.exports.rawRequest = module.exports.GraphQLClient = module.exports.ClientError = void 0;

var $be3352f059436fa6$var$cross_fetch_1 = $be3352f059436fa6$var$__importStar((parcelRequire("aVedK"))), $be3352f059436fa6$var$CrossFetch = $be3352f059436fa6$var$cross_fetch_1;

var $be3352f059436fa6$var$createRequestBody_1 = $be3352f059436fa6$var$__importDefault((parcelRequire("5XYFy")));

var $7tsMA = parcelRequire("7tsMA");

var $bhLHC = parcelRequire("bhLHC");

var $kiIDl = parcelRequire("kiIDl");
Object.defineProperty(module.exports, "ClientError", {
    enumerable: true,
    get: function get() {
        return $kiIDl.ClientError;
    }
});

var $l3E1J = parcelRequire("l3E1J");
/**
 * Convert the given headers configuration into a plain object.
 */ var $be3352f059436fa6$var$resolveHeaders = function resolveHeaders(headers) {
    var oHeaders = {};
    if (headers) {
        if (typeof Headers !== "undefined" && headers instanceof Headers || $be3352f059436fa6$var$CrossFetch && $be3352f059436fa6$var$CrossFetch.Headers && headers instanceof $be3352f059436fa6$var$CrossFetch.Headers) oHeaders = $be3352f059436fa6$var$HeadersInstanceToPlainObject(headers);
        else if (Array.isArray(headers)) headers.forEach(function(_a) {
            var name = _a[0], value = _a[1];
            oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 *
 * @param {string} str GraphQL query
 * @returns {string} Cleaned query
 */ var $be3352f059436fa6$var$queryCleanner = function queryCleanner(str) {
    return str.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim();
};
/**
 * Create query string for GraphQL request
 *
 * @param {object} param0 -
 *
 * @param {string|string[]} param0.query the GraphQL document or array of document if it's a batch request
 * @param {string|undefined} param0.operationName the GraphQL operation name
 * @param {any|any[]} param0.variables the GraphQL variables to use
 */ var $be3352f059436fa6$var$buildGetQueryParams = function buildGetQueryParams(_a) {
    var query = _a.query, variables = _a.variables, operationName = _a.operationName, jsonSerializer = _a.jsonSerializer;
    if (!Array.isArray(query)) {
        var search = [
            "query=".concat(encodeURIComponent($be3352f059436fa6$var$queryCleanner(query)))
        ];
        if (variables) search.push("variables=".concat(encodeURIComponent(jsonSerializer.stringify(variables))));
        if (operationName) search.push("operationName=".concat(encodeURIComponent(operationName)));
        return search.join("&");
    }
    if (typeof variables !== "undefined" && !Array.isArray(variables)) throw new Error("Cannot create query with given variable type, array expected");
    // Batch support
    var payload = query.reduce(function(accu, currentQuery, index) {
        accu.push({
            query: $be3352f059436fa6$var$queryCleanner(currentQuery),
            variables: variables ? jsonSerializer.stringify(variables[index]) : undefined
        });
        return accu;
    }, []);
    return "query=".concat(encodeURIComponent(jsonSerializer.stringify(payload)));
};
/**
 * Fetch data using POST method
 */ var $be3352f059436fa6$var$post = function post(_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, operationName = _a.operationName, headers = _a.headers, fetch = _a.fetch, fetchOptions = _a.fetchOptions, middleware = _a.middleware;
    return $be3352f059436fa6$var$__awaiter(void 0, void 0, void 0, function() {
        var body, init;
        var _b;
        return $be3352f059436fa6$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    body = (0, $be3352f059436fa6$var$createRequestBody_1.default)(query, variables, operationName, fetchOptions.jsonSerializer);
                    init = $be3352f059436fa6$var$__assign({
                        method: "POST",
                        headers: $be3352f059436fa6$var$__assign($be3352f059436fa6$var$__assign({}, typeof body === "string" ? {
                            "Content-Type": "application/json"
                        } : {}), headers),
                        body: body
                    }, fetchOptions);
                    if (!middleware) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.resolve(middleware($be3352f059436fa6$var$__assign($be3352f059436fa6$var$__assign({}, init), {
                            url: url,
                            operationName: operationName,
                            variables: variables
                        })))
                    ];
                case 1:
                    _b = _c.sent(), url = _b.url, init = $be3352f059436fa6$var$__rest(_b, [
                        "url"
                    ]);
                    _c.label = 2;
                case 2:
                    return [
                        4 /*yield*/ ,
                        fetch(url, init)
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        _c.sent()
                    ];
            }
        });
    });
};
/**
 * Fetch data using GET method
 */ var $be3352f059436fa6$var$get = function get(_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, operationName = _a.operationName, headers = _a.headers, fetch = _a.fetch, fetchOptions = _a.fetchOptions, middleware = _a.middleware;
    return $be3352f059436fa6$var$__awaiter(void 0, void 0, void 0, function() {
        var queryParams, init;
        var _b;
        return $be3352f059436fa6$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    queryParams = $be3352f059436fa6$var$buildGetQueryParams({
                        query: query,
                        variables: variables,
                        operationName: operationName,
                        jsonSerializer: fetchOptions.jsonSerializer
                    });
                    init = $be3352f059436fa6$var$__assign({
                        method: "GET",
                        headers: headers
                    }, fetchOptions);
                    if (!middleware) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.resolve(middleware($be3352f059436fa6$var$__assign($be3352f059436fa6$var$__assign({}, init), {
                            url: url,
                            operationName: operationName,
                            variables: variables
                        })))
                    ];
                case 1:
                    _b = _c.sent(), url = _b.url, init = $be3352f059436fa6$var$__rest(_b, [
                        "url"
                    ]);
                    _c.label = 2;
                case 2:
                    return [
                        4 /*yield*/ ,
                        fetch("".concat(url, "?").concat(queryParams), init)
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        _c.sent()
                    ];
            }
        });
    });
};
/**
 * GraphQL Client.
 */ var $be3352f059436fa6$var$GraphQLClient = /** @class */ function() {
    var GraphQLClient = function GraphQLClient(url, options) {
        if (options === void 0) options = {};
        this.url = url;
        this.options = options;
    };
    GraphQLClient.prototype.rawRequest = function(queryOrOptions, variables, requestHeaders) {
        return $be3352f059436fa6$var$__awaiter(this, void 0, void 0, function() {
            var rawRequestOptions, _a, headers, _b, fetch, _c, method, requestMiddleware, responseMiddleware, fetchOptions, url, operationName;
            return $be3352f059436fa6$var$__generator(this, function(_d) {
                rawRequestOptions = (0, $bhLHC.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
                _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? $be3352f059436fa6$var$cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? "POST" : _c, requestMiddleware = _a.requestMiddleware, responseMiddleware = _a.responseMiddleware, fetchOptions = $be3352f059436fa6$var$__rest(_a, [
                    "headers",
                    "fetch",
                    "method",
                    "requestMiddleware",
                    "responseMiddleware"
                ]);
                url = this.url;
                if (rawRequestOptions.signal !== undefined) fetchOptions.signal = rawRequestOptions.signal;
                operationName = (0, $l3E1J.resolveRequestDocument)(rawRequestOptions.query).operationName;
                return [
                    2 /*return*/ ,
                    $be3352f059436fa6$var$makeRequest({
                        url: url,
                        query: rawRequestOptions.query,
                        variables: rawRequestOptions.variables,
                        headers: $be3352f059436fa6$var$__assign($be3352f059436fa6$var$__assign({}, $be3352f059436fa6$var$resolveHeaders($be3352f059436fa6$var$callOrIdentity(headers))), $be3352f059436fa6$var$resolveHeaders(rawRequestOptions.requestHeaders)),
                        operationName: operationName,
                        fetch: fetch,
                        method: method,
                        fetchOptions: fetchOptions,
                        middleware: requestMiddleware
                    }).then(function(response) {
                        if (responseMiddleware) responseMiddleware(response);
                        return response;
                    }).catch(function(error) {
                        if (responseMiddleware) responseMiddleware(error);
                        throw error;
                    })
                ];
            });
        });
    };
    GraphQLClient.prototype.request = function(documentOrOptions) {
        var variablesAndRequestHeaders = [];
        for(var _i = 1; _i < arguments.length; _i++)variablesAndRequestHeaders[_i - 1] = arguments[_i];
        return $be3352f059436fa6$var$__awaiter(this, void 0, void 0, function() {
            var variables, requestHeaders, requestOptions, _a, headers, _b, fetch, _c, method, requestMiddleware, responseMiddleware, fetchOptions, url, _d, query, operationName;
            return $be3352f059436fa6$var$__generator(this, function(_e) {
                variables = variablesAndRequestHeaders[0], requestHeaders = variablesAndRequestHeaders[1];
                requestOptions = (0, $bhLHC.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
                _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? $be3352f059436fa6$var$cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? "POST" : _c, requestMiddleware = _a.requestMiddleware, responseMiddleware = _a.responseMiddleware, fetchOptions = $be3352f059436fa6$var$__rest(_a, [
                    "headers",
                    "fetch",
                    "method",
                    "requestMiddleware",
                    "responseMiddleware"
                ]);
                url = this.url;
                if (requestOptions.signal !== undefined) fetchOptions.signal = requestOptions.signal;
                _d = (0, $l3E1J.resolveRequestDocument)(requestOptions.document), query = _d.query, operationName = _d.operationName;
                return [
                    2 /*return*/ ,
                    $be3352f059436fa6$var$makeRequest({
                        url: url,
                        query: query,
                        variables: requestOptions.variables,
                        headers: $be3352f059436fa6$var$__assign($be3352f059436fa6$var$__assign({}, $be3352f059436fa6$var$resolveHeaders($be3352f059436fa6$var$callOrIdentity(headers))), $be3352f059436fa6$var$resolveHeaders(requestOptions.requestHeaders)),
                        operationName: operationName,
                        fetch: fetch,
                        method: method,
                        fetchOptions: fetchOptions,
                        middleware: requestMiddleware
                    }).then(function(response) {
                        if (responseMiddleware) responseMiddleware(response);
                        return response.data;
                    }).catch(function(error) {
                        if (responseMiddleware) responseMiddleware(error);
                        throw error;
                    })
                ];
            });
        });
    };
    GraphQLClient.prototype.batchRequests = function(documentsOrOptions, requestHeaders) {
        var batchRequestOptions = (0, $bhLHC.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        var _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? $be3352f059436fa6$var$cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? "POST" : _c, requestMiddleware = _a.requestMiddleware, responseMiddleware = _a.responseMiddleware, fetchOptions = $be3352f059436fa6$var$__rest(_a, [
            "headers",
            "fetch",
            "method",
            "requestMiddleware",
            "responseMiddleware"
        ]);
        var url = this.url;
        if (batchRequestOptions.signal !== undefined) fetchOptions.signal = batchRequestOptions.signal;
        var queries = batchRequestOptions.documents.map(function(_a) {
            var document = _a.document;
            return (0, $l3E1J.resolveRequestDocument)(document).query;
        });
        var variables = batchRequestOptions.documents.map(function(_a) {
            var variables = _a.variables;
            return variables;
        });
        return $be3352f059436fa6$var$makeRequest({
            url: url,
            query: queries,
            variables: variables,
            headers: $be3352f059436fa6$var$__assign($be3352f059436fa6$var$__assign({}, $be3352f059436fa6$var$resolveHeaders($be3352f059436fa6$var$callOrIdentity(headers))), $be3352f059436fa6$var$resolveHeaders(batchRequestOptions.requestHeaders)),
            operationName: undefined,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
            middleware: requestMiddleware
        }).then(function(response) {
            if (responseMiddleware) responseMiddleware(response);
            return response.data;
        }).catch(function(error) {
            if (responseMiddleware) responseMiddleware(error);
            throw error;
        });
    };
    GraphQLClient.prototype.setHeaders = function(headers) {
        this.options.headers = headers;
        return this;
    };
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ GraphQLClient.prototype.setHeader = function(key, value) {
        var _a;
        var headers = this.options.headers;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-ignore
        headers[key] = value;
        else this.options.headers = (_a = {}, _a[key] = value, _a);
        return this;
    };
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ GraphQLClient.prototype.setEndpoint = function(value) {
        this.url = value;
        return this;
    };
    return GraphQLClient;
}();
module.exports.GraphQLClient = $be3352f059436fa6$var$GraphQLClient;
function $be3352f059436fa6$var$makeRequest(_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, headers = _a.headers, operationName = _a.operationName, fetch = _a.fetch, _b = _a.method, method = _b === void 0 ? "POST" : _b, fetchOptions = _a.fetchOptions, middleware = _a.middleware;
    return $be3352f059436fa6$var$__awaiter(this, void 0, void 0, function() {
        var fetcher, isBathchingQuery, response, result, successfullyReceivedData, successfullyPassedErrorPolicy, headers_1, status_1, errors, rest, data, errorResult;
        return $be3352f059436fa6$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    fetcher = method.toUpperCase() === "POST" ? $be3352f059436fa6$var$post : $be3352f059436fa6$var$get;
                    isBathchingQuery = Array.isArray(query);
                    return [
                        4 /*yield*/ ,
                        fetcher({
                            url: url,
                            query: query,
                            variables: variables,
                            operationName: operationName,
                            headers: headers,
                            fetch: fetch,
                            fetchOptions: fetchOptions,
                            middleware: middleware
                        })
                    ];
                case 1:
                    response = _c.sent();
                    return [
                        4 /*yield*/ ,
                        $be3352f059436fa6$var$getResult(response, fetchOptions.jsonSerializer)
                    ];
                case 2:
                    result = _c.sent();
                    successfullyReceivedData = isBathchingQuery && Array.isArray(result) ? !result.some(function(_a) {
                        var data = _a.data;
                        return !data;
                    }) : !!result.data;
                    successfullyPassedErrorPolicy = !result.errors || fetchOptions.errorPolicy === "all" || fetchOptions.errorPolicy === "ignore";
                    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
                        headers_1 = response.headers, status_1 = response.status;
                        errors = result.errors, rest = $be3352f059436fa6$var$__rest(result, [
                            "errors"
                        ]);
                        data = fetchOptions.errorPolicy === "ignore" ? rest : result;
                        return [
                            2 /*return*/ ,
                            $be3352f059436fa6$var$__assign($be3352f059436fa6$var$__assign({}, isBathchingQuery ? {
                                data: data
                            } : data), {
                                headers: headers_1,
                                status: status_1
                            })
                        ];
                    } else {
                        errorResult = typeof result === "string" ? {
                            error: result
                        } : result;
                        throw new $kiIDl.ClientError($be3352f059436fa6$var$__assign($be3352f059436fa6$var$__assign({}, errorResult), {
                            status: response.status,
                            headers: response.headers
                        }), {
                            query: query,
                            variables: variables
                        });
                    }
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $be3352f059436fa6$var$rawRequest(urlOrOptions, query) {
    var variablesAndRequestHeaders = [];
    for(var _i = 2; _i < arguments.length; _i++)variablesAndRequestHeaders[_i - 2] = arguments[_i];
    return $be3352f059436fa6$var$__awaiter(this, void 0, void 0, function() {
        var requestOptions, client;
        return $be3352f059436fa6$var$__generator(this, function(_a) {
            requestOptions = $bhLHC.parseRawRequestExtendedArgs.apply(void 0, $be3352f059436fa6$var$__spreadArray([
                urlOrOptions,
                query
            ], variablesAndRequestHeaders, false));
            client = new $be3352f059436fa6$var$GraphQLClient(requestOptions.url);
            return [
                2 /*return*/ ,
                client.rawRequest($be3352f059436fa6$var$__assign({}, requestOptions))
            ];
        });
    });
}
module.exports.rawRequest = $be3352f059436fa6$var$rawRequest;
function $be3352f059436fa6$var$request(urlOrOptions, document) {
    var variablesAndRequestHeaders = [];
    for(var _i = 2; _i < arguments.length; _i++)variablesAndRequestHeaders[_i - 2] = arguments[_i];
    return $be3352f059436fa6$var$__awaiter(this, void 0, void 0, function() {
        var requestOptions, client;
        return $be3352f059436fa6$var$__generator(this, function(_a) {
            requestOptions = $bhLHC.parseRequestExtendedArgs.apply(void 0, $be3352f059436fa6$var$__spreadArray([
                urlOrOptions,
                document
            ], variablesAndRequestHeaders, false));
            client = new $be3352f059436fa6$var$GraphQLClient(requestOptions.url);
            return [
                2 /*return*/ ,
                client.request($be3352f059436fa6$var$__assign({}, requestOptions))
            ];
        });
    });
}
module.exports.request = $be3352f059436fa6$var$request;
function $be3352f059436fa6$var$batchRequests(urlOrOptions, documents, requestHeaders) {
    return $be3352f059436fa6$var$__awaiter(this, void 0, void 0, function() {
        var requestOptions, client;
        return $be3352f059436fa6$var$__generator(this, function(_a) {
            requestOptions = (0, $bhLHC.parseBatchRequestsExtendedArgs)(urlOrOptions, documents, requestHeaders);
            client = new $be3352f059436fa6$var$GraphQLClient(requestOptions.url);
            return [
                2 /*return*/ ,
                client.batchRequests($be3352f059436fa6$var$__assign({}, requestOptions))
            ];
        });
    });
}
module.exports.batchRequests = $be3352f059436fa6$var$batchRequests;
module.exports.default = $be3352f059436fa6$var$request;
/**
 * todo
 */ function $be3352f059436fa6$var$getResult(response, jsonSerializer) {
    if (jsonSerializer === void 0) jsonSerializer = $7tsMA.defaultJsonSerializer;
    return $be3352f059436fa6$var$__awaiter(this, void 0, void 0, function() {
        var contentType, _a, _b;
        return $be3352f059436fa6$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    response.headers.forEach(function(value, key) {
                        if (key.toLowerCase() === "content-type") contentType = value;
                    });
                    if (!(contentType && (contentType.toLowerCase().startsWith("application/json") || contentType.toLowerCase().startsWith("application/graphql+json") || contentType.toLowerCase().startsWith("application/graphql-response+json")))) return [
                        3 /*break*/ ,
                        2
                    ];
                    _b = (_a = jsonSerializer).parse;
                    return [
                        4 /*yield*/ ,
                        response.text()
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _b.apply(_a, [
                            _c.sent()
                        ])
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        response.text()
                    ];
            }
        });
    });
}
function $be3352f059436fa6$var$callOrIdentity(value) {
    return typeof value === "function" ? value() : value;
}
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 *
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */ function $be3352f059436fa6$var$gql(chunks) {
    var variables = [];
    for(var _i = 1; _i < arguments.length; _i++)variables[_i - 1] = arguments[_i];
    return chunks.reduce(function(accumulator, chunk, index) {
        return "".concat(accumulator).concat(chunk).concat(index in variables ? variables[index] : "");
    }, "");
}
module.exports.gql = $be3352f059436fa6$var$gql;
/**
 * Convert Headers instance into regular object
 */ function $be3352f059436fa6$var$HeadersInstanceToPlainObject(headers) {
    var o = {};
    headers.forEach(function(v, k) {
        o[k] = v;
    });
    return o;
}

var $kay5I = parcelRequire("kay5I");
Object.defineProperty(module.exports, "GraphQLWebSocketClient", {
    enumerable: true,
    get: function get() {
        return $kay5I.GraphQLWebSocketClient;
    }
});

var $l3E1J = parcelRequire("l3E1J");
Object.defineProperty(module.exports, "resolveRequestDocument", {
    enumerable: true,
    get: function get() {
        return $l3E1J.resolveRequestDocument;
    }
});

});
parcelRequire.register("bhLHC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseBatchRequestsExtendedArgs = module.exports.parseRawRequestExtendedArgs = module.exports.parseRequestExtendedArgs = module.exports.parseBatchRequestArgs = module.exports.parseRawRequestArgs = module.exports.parseRequestArgs = void 0;
function $837648f8e42a6963$var$parseRequestArgs(documentOrOptions, variables, requestHeaders) {
    return documentOrOptions.document ? documentOrOptions : {
        document: documentOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseRequestArgs = $837648f8e42a6963$var$parseRequestArgs;
function $837648f8e42a6963$var$parseRawRequestArgs(queryOrOptions, variables, requestHeaders) {
    return queryOrOptions.query ? queryOrOptions : {
        query: queryOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseRawRequestArgs = $837648f8e42a6963$var$parseRawRequestArgs;
function $837648f8e42a6963$var$parseBatchRequestArgs(documentsOrOptions, requestHeaders) {
    return documentsOrOptions.documents ? documentsOrOptions : {
        documents: documentsOrOptions,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseBatchRequestArgs = $837648f8e42a6963$var$parseBatchRequestArgs;
function $837648f8e42a6963$var$parseRequestExtendedArgs(urlOrOptions, document) {
    var variablesAndRequestHeaders = [];
    for(var _i = 2; _i < arguments.length; _i++)variablesAndRequestHeaders[_i - 2] = arguments[_i];
    var variables = variablesAndRequestHeaders[0], requestHeaders = variablesAndRequestHeaders[1];
    return urlOrOptions.document ? urlOrOptions : {
        url: urlOrOptions,
        document: document,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseRequestExtendedArgs = $837648f8e42a6963$var$parseRequestExtendedArgs;
function $837648f8e42a6963$var$parseRawRequestExtendedArgs(urlOrOptions, query) {
    var variablesAndRequestHeaders = [];
    for(var _i = 2; _i < arguments.length; _i++)variablesAndRequestHeaders[_i - 2] = arguments[_i];
    var variables = variablesAndRequestHeaders[0], requestHeaders = variablesAndRequestHeaders[1];
    return urlOrOptions.query ? urlOrOptions : {
        url: urlOrOptions,
        query: query,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseRawRequestExtendedArgs = $837648f8e42a6963$var$parseRawRequestExtendedArgs;
function $837648f8e42a6963$var$parseBatchRequestsExtendedArgs(urlOrOptions, documents, requestHeaders) {
    return urlOrOptions.documents ? urlOrOptions : {
        url: urlOrOptions,
        documents: documents,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseBatchRequestsExtendedArgs = $837648f8e42a6963$var$parseBatchRequestsExtendedArgs;

});

parcelRequire.register("kiIDl", function(module, exports) {
"use strict";
var $ec781c62169538a6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        var __ = function __() {
            this.constructor = d;
        };
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientError = void 0;
var $ec781c62169538a6$var$ClientError = /** @class */ function(_super) {
    $ec781c62169538a6$var$__extends(ClientError, _super);
    function ClientError(response, request) {
        var _this = this;
        var message = "".concat(ClientError.extractMessage(response), ": ").concat(JSON.stringify({
            response: response,
            request: request
        }));
        _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ClientError.prototype);
        _this.response = response;
        _this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(_this, ClientError);
        return _this;
    }
    ClientError.extractMessage = function(response) {
        try {
            return response.errors[0].message;
        } catch (e) {
            return "GraphQL Error (Code: ".concat(response.status, ")");
        }
    };
    return ClientError;
}(Error);
module.exports.ClientError = $ec781c62169538a6$var$ClientError;

});

parcelRequire.register("l3E1J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveRequestDocument = void 0;

var $jcfFg = parcelRequire("jcfFg");
var $haKzF = parcelRequire("haKzF");
/**
 * helpers
 */ function $f548ed4eedb41474$var$extractOperationName(document) {
    var _a;
    var operationName = undefined;
    var operationDefinitions = document.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    });
    if (operationDefinitions.length === 1) operationName = (_a = operationDefinitions[0].name) === null || _a === void 0 ? void 0 : _a.value;
    return operationName;
}
function $f548ed4eedb41474$var$resolveRequestDocument(document) {
    if (typeof document === "string") {
        var operationName_1 = undefined;
        try {
            var parsedDocument = (0, $jcfFg.parse)(document);
            operationName_1 = $f548ed4eedb41474$var$extractOperationName(parsedDocument);
        } catch (err) {
        // Failed parsing the document, the operationName will be undefined
        }
        return {
            query: document,
            operationName: operationName_1
        };
    }
    var operationName = $f548ed4eedb41474$var$extractOperationName(document);
    return {
        query: (0, $haKzF.print)(document),
        operationName: operationName
    };
}
module.exports.resolveRequestDocument = $f548ed4eedb41474$var$resolveRequestDocument;

});
parcelRequire.register("haKzF", function(module, exports) {

$parcel$export(module.exports, "print", function () { return $334563673236d995$export$c2d084dc44961371; });

var $KQqF6 = parcelRequire("KQqF6");

var $L6U39 = parcelRequire("L6U39");

var $5qAaw = parcelRequire("5qAaw");
function $334563673236d995$export$c2d084dc44961371(ast) {
    return (0, $5qAaw.visit)(ast, $334563673236d995$var$printDocASTReducer);
}
var $334563673236d995$var$MAX_LINE_LENGTH = 80;
var $334563673236d995$var$printDocASTReducer = {
    Name: {
        leave: function(node) {
            return node.value;
        }
    },
    Variable: {
        leave: function(node) {
            return "$" + node.name;
        }
    },
    // Document
    Document: {
        leave: function(node) {
            return $334563673236d995$var$join(node.definitions, "\n\n");
        }
    },
    OperationDefinition: {
        leave: function(node) {
            var varDefs = $334563673236d995$var$wrap("(", $334563673236d995$var$join(node.variableDefinitions, ", "), ")");
            var prefix = $334563673236d995$var$join([
                node.operation,
                $334563673236d995$var$join([
                    node.name,
                    varDefs
                ]),
                $334563673236d995$var$join(node.directives, " ")
            ], " "); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: function(param) {
            var variable = param.variable, type = param.type, defaultValue = param.defaultValue, directives = param.directives;
            return variable + ": " + type + $334563673236d995$var$wrap(" = ", defaultValue) + $334563673236d995$var$wrap(" ", $334563673236d995$var$join(directives, " "));
        }
    },
    SelectionSet: {
        leave: function(param) {
            var selections = param.selections;
            return $334563673236d995$var$block(selections);
        }
    },
    Field: {
        leave: function(param) {
            var alias = param.alias, name = param.name, args = param.arguments, directives = param.directives, selectionSet = param.selectionSet;
            var prefix = $334563673236d995$var$wrap("", alias, ": ") + name;
            var argsLine = prefix + $334563673236d995$var$wrap("(", $334563673236d995$var$join(args, ", "), ")");
            if (argsLine.length > $334563673236d995$var$MAX_LINE_LENGTH) argsLine = prefix + $334563673236d995$var$wrap("(\n", $334563673236d995$var$indent($334563673236d995$var$join(args, "\n")), "\n)");
            return $334563673236d995$var$join([
                argsLine,
                $334563673236d995$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    Argument: {
        leave: function(param) {
            var name = param.name, value = param.value;
            return name + ": " + value;
        }
    },
    // Fragments
    FragmentSpread: {
        leave: function(param) {
            var name = param.name, directives = param.directives;
            return "..." + name + $334563673236d995$var$wrap(" ", $334563673236d995$var$join(directives, " "));
        }
    },
    InlineFragment: {
        leave: function(param) {
            var typeCondition = param.typeCondition, directives = param.directives, selectionSet = param.selectionSet;
            return $334563673236d995$var$join([
                "...",
                $334563673236d995$var$wrap("on ", typeCondition),
                $334563673236d995$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    FragmentDefinition: {
        leave: function(param) {
            var name = param.name, typeCondition = param.typeCondition, variableDefinitions = param.variableDefinitions, directives = param.directives, selectionSet = param.selectionSet;
            return(// or removed in the future.
            "fragment ".concat(name).concat($334563673236d995$var$wrap("(", $334563673236d995$var$join(variableDefinitions, ", "), ")"), " ") + "on ".concat(typeCondition, " ").concat($334563673236d995$var$wrap("", $334563673236d995$var$join(directives, " "), " ")) + selectionSet);
        }
    },
    // Value
    IntValue: {
        leave: function(param) {
            var value = param.value;
            return value;
        }
    },
    FloatValue: {
        leave: function(param) {
            var value = param.value;
            return value;
        }
    },
    StringValue: {
        leave: function(param) {
            var value = param.value, isBlockString = param.block;
            return isBlockString ? (0, $KQqF6.printBlockString)(value) : (0, $L6U39.printString)(value);
        }
    },
    BooleanValue: {
        leave: function(param) {
            var value = param.value;
            return value ? "true" : "false";
        }
    },
    NullValue: {
        leave: function() {
            return "null";
        }
    },
    EnumValue: {
        leave: function(param) {
            var value = param.value;
            return value;
        }
    },
    ListValue: {
        leave: function(param) {
            var values = param.values;
            return "[" + $334563673236d995$var$join(values, ", ") + "]";
        }
    },
    ObjectValue: {
        leave: function(param) {
            var fields = param.fields;
            return "{" + $334563673236d995$var$join(fields, ", ") + "}";
        }
    },
    ObjectField: {
        leave: function(param) {
            var name = param.name, value = param.value;
            return name + ": " + value;
        }
    },
    // Directive
    Directive: {
        leave: function(param) {
            var name = param.name, args = param.arguments;
            return "@" + name + $334563673236d995$var$wrap("(", $334563673236d995$var$join(args, ", "), ")");
        }
    },
    // Type
    NamedType: {
        leave: function(param) {
            var name = param.name;
            return name;
        }
    },
    ListType: {
        leave: function(param) {
            var type = param.type;
            return "[" + type + "]";
        }
    },
    NonNullType: {
        leave: function(param) {
            var type = param.type;
            return type + "!";
        }
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: function(param) {
            var description = param.description, directives = param.directives, operationTypes = param.operationTypes;
            return $334563673236d995$var$wrap("", description, "\n") + $334563673236d995$var$join([
                "schema",
                $334563673236d995$var$join(directives, " "),
                $334563673236d995$var$block(operationTypes)
            ], " ");
        }
    },
    OperationTypeDefinition: {
        leave: function(param) {
            var operation = param.operation, type = param.type;
            return operation + ": " + type;
        }
    },
    ScalarTypeDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, directives = param.directives;
            return $334563673236d995$var$wrap("", description, "\n") + $334563673236d995$var$join([
                "scalar",
                name,
                $334563673236d995$var$join(directives, " ")
            ], " ");
        }
    },
    ObjectTypeDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, interfaces = param.interfaces, directives = param.directives, fields = param.fields;
            return $334563673236d995$var$wrap("", description, "\n") + $334563673236d995$var$join([
                "type",
                name,
                $334563673236d995$var$wrap("implements ", $334563673236d995$var$join(interfaces, " & ")),
                $334563673236d995$var$join(directives, " "),
                $334563673236d995$var$block(fields)
            ], " ");
        }
    },
    FieldDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, args = param.arguments, type = param.type, directives = param.directives;
            return $334563673236d995$var$wrap("", description, "\n") + name + ($334563673236d995$var$hasMultilineItems(args) ? $334563673236d995$var$wrap("(\n", $334563673236d995$var$indent($334563673236d995$var$join(args, "\n")), "\n)") : $334563673236d995$var$wrap("(", $334563673236d995$var$join(args, ", "), ")")) + ": " + type + $334563673236d995$var$wrap(" ", $334563673236d995$var$join(directives, " "));
        }
    },
    InputValueDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, type = param.type, defaultValue = param.defaultValue, directives = param.directives;
            return $334563673236d995$var$wrap("", description, "\n") + $334563673236d995$var$join([
                name + ": " + type,
                $334563673236d995$var$wrap("= ", defaultValue),
                $334563673236d995$var$join(directives, " ")
            ], " ");
        }
    },
    InterfaceTypeDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, interfaces = param.interfaces, directives = param.directives, fields = param.fields;
            return $334563673236d995$var$wrap("", description, "\n") + $334563673236d995$var$join([
                "interface",
                name,
                $334563673236d995$var$wrap("implements ", $334563673236d995$var$join(interfaces, " & ")),
                $334563673236d995$var$join(directives, " "),
                $334563673236d995$var$block(fields)
            ], " ");
        }
    },
    UnionTypeDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, directives = param.directives, types = param.types;
            return $334563673236d995$var$wrap("", description, "\n") + $334563673236d995$var$join([
                "union",
                name,
                $334563673236d995$var$join(directives, " "),
                $334563673236d995$var$wrap("= ", $334563673236d995$var$join(types, " | "))
            ], " ");
        }
    },
    EnumTypeDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, directives = param.directives, values = param.values;
            return $334563673236d995$var$wrap("", description, "\n") + $334563673236d995$var$join([
                "enum",
                name,
                $334563673236d995$var$join(directives, " "),
                $334563673236d995$var$block(values)
            ], " ");
        }
    },
    EnumValueDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, directives = param.directives;
            return $334563673236d995$var$wrap("", description, "\n") + $334563673236d995$var$join([
                name,
                $334563673236d995$var$join(directives, " ")
            ], " ");
        }
    },
    InputObjectTypeDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, directives = param.directives, fields = param.fields;
            return $334563673236d995$var$wrap("", description, "\n") + $334563673236d995$var$join([
                "input",
                name,
                $334563673236d995$var$join(directives, " "),
                $334563673236d995$var$block(fields)
            ], " ");
        }
    },
    DirectiveDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, args = param.arguments, repeatable = param.repeatable, locations = param.locations;
            return $334563673236d995$var$wrap("", description, "\n") + "directive @" + name + ($334563673236d995$var$hasMultilineItems(args) ? $334563673236d995$var$wrap("(\n", $334563673236d995$var$indent($334563673236d995$var$join(args, "\n")), "\n)") : $334563673236d995$var$wrap("(", $334563673236d995$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $334563673236d995$var$join(locations, " | ");
        }
    },
    SchemaExtension: {
        leave: function(param) {
            var directives = param.directives, operationTypes = param.operationTypes;
            return $334563673236d995$var$join([
                "extend schema",
                $334563673236d995$var$join(directives, " "),
                $334563673236d995$var$block(operationTypes)
            ], " ");
        }
    },
    ScalarTypeExtension: {
        leave: function(param) {
            var name = param.name, directives = param.directives;
            return $334563673236d995$var$join([
                "extend scalar",
                name,
                $334563673236d995$var$join(directives, " ")
            ], " ");
        }
    },
    ObjectTypeExtension: {
        leave: function(param) {
            var name = param.name, interfaces = param.interfaces, directives = param.directives, fields = param.fields;
            return $334563673236d995$var$join([
                "extend type",
                name,
                $334563673236d995$var$wrap("implements ", $334563673236d995$var$join(interfaces, " & ")),
                $334563673236d995$var$join(directives, " "),
                $334563673236d995$var$block(fields)
            ], " ");
        }
    },
    InterfaceTypeExtension: {
        leave: function(param) {
            var name = param.name, interfaces = param.interfaces, directives = param.directives, fields = param.fields;
            return $334563673236d995$var$join([
                "extend interface",
                name,
                $334563673236d995$var$wrap("implements ", $334563673236d995$var$join(interfaces, " & ")),
                $334563673236d995$var$join(directives, " "),
                $334563673236d995$var$block(fields)
            ], " ");
        }
    },
    UnionTypeExtension: {
        leave: function(param) {
            var name = param.name, directives = param.directives, types = param.types;
            return $334563673236d995$var$join([
                "extend union",
                name,
                $334563673236d995$var$join(directives, " "),
                $334563673236d995$var$wrap("= ", $334563673236d995$var$join(types, " | "))
            ], " ");
        }
    },
    EnumTypeExtension: {
        leave: function(param) {
            var name = param.name, directives = param.directives, values = param.values;
            return $334563673236d995$var$join([
                "extend enum",
                name,
                $334563673236d995$var$join(directives, " "),
                $334563673236d995$var$block(values)
            ], " ");
        }
    },
    InputObjectTypeExtension: {
        leave: function(param) {
            var name = param.name, directives = param.directives, fields = param.fields;
            return $334563673236d995$var$join([
                "extend input",
                name,
                $334563673236d995$var$join(directives, " "),
                $334563673236d995$var$block(fields)
            ], " ");
        }
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $334563673236d995$var$join(maybeArray) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $334563673236d995$var$block(array) {
    return $334563673236d995$var$wrap("{\n", $334563673236d995$var$indent($334563673236d995$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $334563673236d995$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $334563673236d995$var$indent(str) {
    return $334563673236d995$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $334563673236d995$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some(function(str) {
        return str.includes("\n");
    })) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}

});
parcelRequire.register("L6U39", function(module, exports) {

$parcel$export(module.exports, "printString", function () { return $dcb75688508c5702$export$3cdec7cf614a0ecc; });
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $dcb75688508c5702$export$3cdec7cf614a0ecc(str) {
    return '"'.concat(str.replace($dcb75688508c5702$var$escapedRegExp, $dcb75688508c5702$var$escapedReplacer), '"');
} // eslint-disable-next-line no-control-regex
var $dcb75688508c5702$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $dcb75688508c5702$var$escapedReplacer(str) {
    return $dcb75688508c5702$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
var $dcb75688508c5702$var$escapeSequences = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
];

});

parcelRequire.register("5qAaw", function(module, exports) {

$parcel$export(module.exports, "visit", function () { return $eae79035baa6cc4b$export$bf638b60ea8b89b7; });

var $8GFUW = parcelRequire("8GFUW");

var $8gyJp = parcelRequire("8gyJp");

var $9cdcQ = parcelRequire("9cdcQ");

var $cvgER = parcelRequire("cvgER");

var $dqOmk = parcelRequire("dqOmk");
var $eae79035baa6cc4b$export$a89c95c098ac2a58 = Object.freeze({});
function $eae79035baa6cc4b$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $cvgER.QueryDocumentKeys);
    var enterLeaveMap = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values((0, $dqOmk.Kind))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var kind = _step.value;
            enterLeaveMap.set(kind, $eae79035baa6cc4b$export$736de8489257458(visitor, kind));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = root;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    var editOffset = 0;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = edits[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var _step_value = (0, $8GFUW._)(_step1.value, 2), editKey = _step_value[0], editValue = _step_value[1];
                            var arrayKey = editKey - editOffset;
                            if (editValue === null) {
                                node.splice(arrayKey, 1);
                                editOffset++;
                            } else node[arrayKey] = editValue;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = edits[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var _step_value1 = (0, $8GFUW._)(_step2.value, 2), editKey1 = _step_value1[0], editValue1 = _step_value1[1];
                            node[editKey1] = editValue1;
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $cvgER.isNode)(node) || (0, $8gyJp.devAssert)(false, "Invalid AST Node: ".concat((0, $9cdcQ.inspect)(node), "."));
            var visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $eae79035baa6cc4b$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $cvgER.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $eae79035baa6cc4b$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length).fill(null);
    var mergedVisitor = Object.create(null);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var kind = _step.value;
            var hasVisitor = false;
            var enterList = new Array(visitors.length).fill(undefined);
            var leaveList = new Array(visitors.length).fill(undefined);
            for(var i = 0; i < visitors.length; ++i){
                var _getEnterLeaveForKind = $eae79035baa6cc4b$export$736de8489257458(visitors[i], kind), enter = _getEnterLeaveForKind.enter, leave = _getEnterLeaveForKind.leave;
                hasVisitor || (hasVisitor = enter != null || leave != null);
                enterList[i] = enter;
                leaveList[i] = leave;
            }
            if (!hasVisitor) return "continue";
            var mergedEnterLeave = {
                enter: function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var node = args[0];
                    for(var i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                        var _enterList$i;
                        var result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                        if (result === false) skipping[i] = node;
                        else if (result === $eae79035baa6cc4b$export$a89c95c098ac2a58) skipping[i] = $eae79035baa6cc4b$export$a89c95c098ac2a58;
                        else if (result !== undefined) return result;
                    }
                },
                leave: function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var node = args[0];
                    for(var i = 0; i < visitors.length; i++){
                        if (skipping[i] === null) {
                            var _leaveList$i;
                            var result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                            if (result === $eae79035baa6cc4b$export$a89c95c098ac2a58) skipping[i] = $eae79035baa6cc4b$export$a89c95c098ac2a58;
                            else if (result !== undefined && result !== false) return result;
                        } else if (skipping[i] === node) skipping[i] = null;
                    }
                }
            };
            mergedVisitor[kind] = mergedEnterLeave;
        };
        for(var _iterator = Object.values((0, $dqOmk.Kind))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedVisitor;
}
function $eae79035baa6cc4b$export$736de8489257458(visitor, kind) {
    var kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $eae79035baa6cc4b$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var _getEnterLeaveForKind = $eae79035baa6cc4b$export$736de8489257458(visitor, kind), enter = _getEnterLeaveForKind.enter, leave = _getEnterLeaveForKind.leave;
    return isLeaving ? leave : enter;
}

});



parcelRequire.register("kay5I", function(module, exports) {
"use strict";
var $eaef2fa463d6259e$var$__assign = module.exports && module.exports.__assign || function() {
    $eaef2fa463d6259e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $eaef2fa463d6259e$var$__assign.apply(this, arguments);
};
var $eaef2fa463d6259e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $eaef2fa463d6259e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GraphQLWebSocketClient = void 0;

var $kiIDl = parcelRequire("kiIDl");

var $l3E1J = parcelRequire("l3E1J");
var $eaef2fa463d6259e$var$CONNECTION_INIT = "connection_init";
var $eaef2fa463d6259e$var$CONNECTION_ACK = "connection_ack";
var $eaef2fa463d6259e$var$PING = "ping";
var $eaef2fa463d6259e$var$PONG = "pong";
var $eaef2fa463d6259e$var$SUBSCRIBE = "subscribe";
var $eaef2fa463d6259e$var$NEXT = "next";
var $eaef2fa463d6259e$var$ERROR = "error";
var $eaef2fa463d6259e$var$COMPLETE = "complete";
var $eaef2fa463d6259e$var$GraphQLWebSocketMessage = /** @class */ function() {
    var GraphQLWebSocketMessage = function GraphQLWebSocketMessage(type, payload, id) {
        this._type = type;
        this._payload = payload;
        this._id = id;
    };
    Object.defineProperty(GraphQLWebSocketMessage.prototype, "type", {
        get: function get() {
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GraphQLWebSocketMessage.prototype, "id", {
        get: function get() {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GraphQLWebSocketMessage.prototype, "payload", {
        get: function get() {
            return this._payload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GraphQLWebSocketMessage.prototype, "text", {
        get: function get() {
            var result = {
                type: this.type
            };
            if (this.id != null && this.id != undefined) result.id = this.id;
            if (this.payload != null && this.payload != undefined) result.payload = this.payload;
            return JSON.stringify(result);
        },
        enumerable: false,
        configurable: true
    });
    GraphQLWebSocketMessage.parse = function(data, f) {
        var _a = JSON.parse(data), type = _a.type, payload = _a.payload, id = _a.id;
        return new GraphQLWebSocketMessage(type, f(payload), id);
    };
    return GraphQLWebSocketMessage;
}();
var $eaef2fa463d6259e$var$GraphQLWebSocketClient = /** @class */ function() {
    var GraphQLWebSocketClient = function GraphQLWebSocketClient(socket, _a) {
        var onInit = _a.onInit, onAcknowledged = _a.onAcknowledged, onPing = _a.onPing, onPong = _a.onPong;
        var _this = this;
        this.socketState = {
            acknowledged: false,
            lastRequestId: 0,
            subscriptions: {}
        };
        this.socket = socket;
        socket.onopen = function(e) {
            return $eaef2fa463d6259e$var$__awaiter(_this, void 0, void 0, function() {
                var _$_a, _b, _c, _d;
                return $eaef2fa463d6259e$var$__generator(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            this.socketState.acknowledged = false;
                            this.socketState.subscriptions = {};
                            _b = (_$_a = socket).send;
                            _c = $eaef2fa463d6259e$var$ConnectionInit;
                            if (!onInit) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                onInit()
                            ];
                        case 1:
                            _d = _e.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            _d = null;
                            _e.label = 3;
                        case 3:
                            _b.apply(_$_a, [
                                _c.apply(void 0, [
                                    _d
                                ]).text
                            ]);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        socket.onclose = function(e) {
            _this.socketState.acknowledged = false;
            _this.socketState.subscriptions = {};
        };
        socket.onerror = function(e) {
            console.error(e);
        };
        socket.onmessage = function(e) {
            try {
                var message = $eaef2fa463d6259e$var$parseMessage(e.data);
                switch(message.type){
                    case $eaef2fa463d6259e$var$CONNECTION_ACK:
                        if (_this.socketState.acknowledged) console.warn("Duplicate CONNECTION_ACK message ignored");
                        else {
                            _this.socketState.acknowledged = true;
                            if (onAcknowledged) onAcknowledged(message.payload);
                        }
                        return;
                    case $eaef2fa463d6259e$var$PING:
                        if (onPing) onPing(message.payload).then(function(r) {
                            return socket.send($eaef2fa463d6259e$var$Pong(r).text);
                        });
                        else socket.send($eaef2fa463d6259e$var$Pong(null).text);
                        return;
                    case $eaef2fa463d6259e$var$PONG:
                        if (onPong) onPong(message.payload);
                        return;
                }
                if (!_this.socketState.acknowledged) // Web-socket connection not acknowledged
                return;
                if (message.id === undefined || message.id === null || !_this.socketState.subscriptions[message.id]) // No subscription identifer or subscription indentifier is not found
                return;
                var _$_a = _this.socketState.subscriptions[message.id], query = _$_a.query, variables = _$_a.variables, subscriber = _$_a.subscriber;
                switch(message.type){
                    case $eaef2fa463d6259e$var$NEXT:
                        if (!message.payload.errors && message.payload.data) subscriber.next && subscriber.next(message.payload.data);
                        if (message.payload.errors) subscriber.error && subscriber.error(new $kiIDl.ClientError($eaef2fa463d6259e$var$__assign($eaef2fa463d6259e$var$__assign({}, message.payload), {
                            status: 200
                        }), {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $eaef2fa463d6259e$var$ERROR:
                        subscriber.error && subscriber.error(new $kiIDl.ClientError({
                            errors: message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $eaef2fa463d6259e$var$COMPLETE:
                        subscriber.complete && subscriber.complete();
                        delete _this.socketState.subscriptions[message.id];
                        return;
                }
            } catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, "Unknown graphql-ws message.");
        };
    };
    GraphQLWebSocketClient.prototype.makeSubscribe = function(query, operationName, subscriber, variables) {
        var _this = this;
        var subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = {
            query: query,
            variables: variables,
            subscriber: subscriber
        };
        this.socket.send($eaef2fa463d6259e$var$Subscribe(subscriptionId, {
            query: query,
            operationName: operationName,
            variables: variables
        }).text);
        return function() {
            _this.socket.send($eaef2fa463d6259e$var$Complete(subscriptionId).text);
            delete _this.socketState.subscriptions[subscriptionId];
        };
    };
    GraphQLWebSocketClient.prototype.rawRequest = function(query, variables) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var result;
            _this.rawSubscribe(query, {
                next: function next(data, extensions) {
                    return result = {
                        data: data,
                        extensions: extensions
                    };
                },
                error: reject,
                complete: function complete() {
                    return resolve(result);
                }
            }, variables);
        });
    };
    GraphQLWebSocketClient.prototype.request = function(document, variables) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var result;
            _this.subscribe(document, {
                next: function next(data) {
                    return result = data;
                },
                error: reject,
                complete: function complete() {
                    return resolve(result);
                }
            }, variables);
        });
    };
    GraphQLWebSocketClient.prototype.subscribe = function(document, subscriber, variables) {
        var _a = (0, $l3E1J.resolveRequestDocument)(document), query = _a.query, operationName = _a.operationName;
        return this.makeSubscribe(query, operationName, subscriber, variables);
    };
    GraphQLWebSocketClient.prototype.rawSubscribe = function(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    };
    GraphQLWebSocketClient.prototype.ping = function(payload) {
        this.socket.send($eaef2fa463d6259e$var$Ping(payload).text);
    };
    GraphQLWebSocketClient.prototype.close = function() {
        this.socket.close(1000);
    };
    GraphQLWebSocketClient.PROTOCOL = "graphql-transport-ws";
    return GraphQLWebSocketClient;
}();
module.exports.GraphQLWebSocketClient = $eaef2fa463d6259e$var$GraphQLWebSocketClient;
// Helper functions
function $eaef2fa463d6259e$var$parseMessage(data, f) {
    if (f === void 0) f = function f(a) {
        return a;
    };
    var m = $eaef2fa463d6259e$var$GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function $eaef2fa463d6259e$var$ConnectionInit(payload) {
    return new $eaef2fa463d6259e$var$GraphQLWebSocketMessage($eaef2fa463d6259e$var$CONNECTION_INIT, payload);
}
function $eaef2fa463d6259e$var$Ping(payload) {
    return new $eaef2fa463d6259e$var$GraphQLWebSocketMessage($eaef2fa463d6259e$var$PING, payload, undefined);
}
function $eaef2fa463d6259e$var$Pong(payload) {
    return new $eaef2fa463d6259e$var$GraphQLWebSocketMessage($eaef2fa463d6259e$var$PONG, payload, undefined);
}
function $eaef2fa463d6259e$var$Subscribe(id, payload) {
    return new $eaef2fa463d6259e$var$GraphQLWebSocketMessage($eaef2fa463d6259e$var$SUBSCRIBE, payload, id);
}
function $eaef2fa463d6259e$var$Complete(id) {
    return new $eaef2fa463d6259e$var$GraphQLWebSocketMessage($eaef2fa463d6259e$var$COMPLETE, undefined, id);
}

});




parcelRequire.register("haENf", function(module, exports) {

$parcel$export(module.exports, "calcRoot", function () { return $39fe7955fc266b53$export$a9e46a92ebf9b632; });

var $978gY = parcelRequire("978gY");

var $dxWQo = parcelRequire("dxWQo");

var $fLnyw = parcelRequire("fLnyw");

var $daciJ = parcelRequire("daciJ");
var $39fe7955fc266b53$var$f = function f(t, i, r, s, h) {
    "use strict";
    var e = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
    (0, $978gY._)(this, f);
    (0, $dxWQo._)(this, "left", void 0);
    (0, $dxWQo._)(this, "right", void 0);
    (0, $dxWQo._)(this, "parent", void 0);
    (0, $dxWQo._)(this, "hash", void 0);
    (0, $dxWQo._)(this, "data", void 0);
    (0, $dxWQo._)(this, "index", void 0);
    this.left = t, this.right = i, this.parent = r, this.hash = s, this.data = h, this.index = e;
}, $39fe7955fc266b53$var$c = $39fe7955fc266b53$var$f;
function $39fe7955fc266b53$export$bc68c1df7778232a(n) {
    return (0, $daciJ.hash)("0x00".concat(n.slice(2)));
}
function $39fe7955fc266b53$export$5ddef1f39ba79de1(n, t) {
    return (0, $daciJ.hash)("0x01".concat(n.slice(2)).concat(t.slice(2)));
}
function $39fe7955fc266b53$export$99578c1b02d34684(n) {
    var t = [];
    for(var e = 0; e < n.length; e += 1){
        var o = $39fe7955fc266b53$export$bc68c1df7778232a(n[e]), l = new $39fe7955fc266b53$var$c(-1, -1, -1, o, n[e]);
        l.index = e, t.push(l);
    }
    var i = (0, $fLnyw._)(t), r = (0, $fLnyw._)(t), s = t.length + 1 >> 1, h = t.length & 1;
    for(;;){
        var e1 = 0;
        for(; e1 < s - h; e1 += 1){
            var o1 = e1 << 1, l1 = $39fe7955fc266b53$export$5ddef1f39ba79de1(r[o1].hash, r[o1 + 1].hash);
            t[e1] = new $39fe7955fc266b53$var$c(r[o1].index, r[o1 + 1].index, -1, l1, "");
            var u = i.length;
            t[e1].index = u, i[r[o1].index].parent = u, i[r[o1 + 1].index].parent = u, i.push(t[e1]);
        }
        if (s === 1) break;
        h === 1 && (t[e1] = r[e1 << 1]), h = s & 1, s = s + 1 >> 1, r = (0, $fLnyw._)(t);
    }
    return i;
}
function $39fe7955fc266b53$export$a9e46a92ebf9b632(n) {
    if (!n.length) return 0, $daciJ.EMPTY;
    var t = [];
    for(var h = 0; h < n.length; h += 1){
        var e = $39fe7955fc266b53$export$bc68c1df7778232a(n[h]);
        t.push(new $39fe7955fc266b53$var$c(-1, -1, -1, e, n[h]));
    }
    var i = t, r = t.length + 1 >> 1, s = t.length & 1;
    for(;;){
        var h1 = 0;
        for(; h1 < r - s; h1 += 1){
            var e1 = h1 << 1, o = $39fe7955fc266b53$export$5ddef1f39ba79de1(i[e1].hash, i[e1 + 1].hash);
            t[h1] = new $39fe7955fc266b53$var$c(i[e1].index, i[e1 + 1].index, -1, o, "");
        }
        if (s === 1 && (t[h1] = i[h1 << 1]), r === 1) break;
        s = r & 1, r = r + 1 >> 1, i = t;
    }
    return t[0].hash;
}
function $39fe7955fc266b53$export$4a314c097411dc17(n, t) {
    var i = [];
    for(var r = t, s = n[t].parent; s !== -1; r = s, s = n[s].parent)n[s].left === r ? i.push(n[n[s].right].hash) : i.push(n[n[s].left].hash);
    return i;
}

});
parcelRequire.register("daciJ", function(module, exports) {

$parcel$export(module.exports, "EMPTY", function () { return $41255508253395ab$export$ccb33e29d92c9a58; });
$parcel$export(module.exports, "hash", function () { return $41255508253395ab$export$d6af199866bfb566; });

var $7WUQV = parcelRequire("7WUQV");
var $41255508253395ab$export$ccb33e29d92c9a58 = "0xe3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855", $41255508253395ab$export$2a1795c9359f92b9 = "0x0000000000000000000000000000000000000000000000000000000000000000", $41255508253395ab$export$daa2496be4772440 = 256;
function $41255508253395ab$export$d6af199866bfb566(o) {
    return (0, $7WUQV.sha256)(o);
}

});


parcelRequire.register("bGb89", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb20ad49f10f7301$export$2e2bcd8739ae039; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $8GFUW = parcelRequire("8GFUW");

var $daciJ = parcelRequire("daciJ");
var $eb20ad49f10f7301$var$A = "0x00", $eb20ad49f10f7301$var$R = "0x01";
function $eb20ad49f10f7301$var$M(o, t) {
    var e = "0x00".concat(o.slice(2)).concat((0, $daciJ.hash)(t).slice(2));
    return [
        (0, $daciJ.hash)(e),
        e
    ];
}
function $eb20ad49f10f7301$var$d(o, t) {
    var e = "0x01".concat(o.slice(2)).concat(t.slice(2));
    return [
        (0, $daciJ.hash)(e),
        e
    ];
}
function $eb20ad49f10f7301$var$S(o) {
    var t = $eb20ad49f10f7301$var$R.length;
    return [
        "0x".concat(o.slice(t, t + 64)),
        "0x".concat(o.slice(t + 64))
    ];
}
function $eb20ad49f10f7301$var$B(o) {
    var t = $eb20ad49f10f7301$var$R.length;
    return [
        "0x".concat(o.slice(t, t + 64)),
        "0x".concat(o.slice(t + 64))
    ];
}
function $eb20ad49f10f7301$var$b(o) {
    return o.slice(0, 4) === $eb20ad49f10f7301$var$A;
}
var $eb20ad49f10f7301$var$P = function P(t, e, r, n, f) {
    "use strict";
    (0, $978gY._)(this, P);
    (0, $dxWQo._)(this, "SideNodes", void 0);
    (0, $dxWQo._)(this, "NonMembershipLeafData", void 0);
    (0, $dxWQo._)(this, "BitMask", void 0);
    (0, $dxWQo._)(this, "NumSideNodes", void 0);
    (0, $dxWQo._)(this, "SiblingData", void 0);
    this.SideNodes = t, this.NonMembershipLeafData = e, this.BitMask = r, this.NumSideNodes = n, this.SiblingData = f;
}, $eb20ad49f10f7301$var$C = $eb20ad49f10f7301$var$P;
var $eb20ad49f10f7301$var$D = function D(t, e, r) {
    "use strict";
    (0, $978gY._)(this, D);
    (0, $dxWQo._)(this, "SideNodes", void 0);
    (0, $dxWQo._)(this, "NonMembershipLeafData", void 0);
    (0, $dxWQo._)(this, "SiblingData", void 0);
    this.SideNodes = t, this.NonMembershipLeafData = e, this.SiblingData = r;
}, $eb20ad49f10f7301$var$L = $eb20ad49f10f7301$var$D;
var $eb20ad49f10f7301$var$l = "0x0000000000000000000000000000000000000000000000000000000000000000";
function $eb20ad49f10f7301$var$p(o, t) {
    var e = o.slice(2), r = "0x".concat(e.slice(Math.floor(t / 8) * 2, Math.floor(t / 8) * 2 + 2));
    return (Number(r) & 1 << 7 - t % 8) > 0 ? 1 : 0;
}
function $eb20ad49f10f7301$var$k(o) {
    var t = 0, e = o.length - 1, r = o;
    var ref;
    for(; t < e;)ref = [
        r[e],
        r[t]
    ], r[t] = ref[0], r[e] = ref[1], ref, t += 1, e -= 1;
    return r;
}
function $eb20ad49f10f7301$var$v(o, t) {
    var e = 0;
    for(var r = 0; r < 256 && $eb20ad49f10f7301$var$p(o, r) === $eb20ad49f10f7301$var$p(t, r); r += 1)e += 1;
    return e;
}
function $eb20ad49f10f7301$var$E(o) {
    var t = [], e = [], r;
    for(var f = 0; f < o.SideNodes.length; f += 1)r = o.SideNodes[f], r === $eb20ad49f10f7301$var$l ? t.push(0) : (e.push(r), t.push(1));
    return new $eb20ad49f10f7301$var$C(e, o.NonMembershipLeafData, t, o.SideNodes.length, o.SiblingData);
}
var $eb20ad49f10f7301$var$H = /*#__PURE__*/ function() {
    "use strict";
    function H() {
        (0, $978gY._)(this, H);
        (0, $dxWQo._)(this, "ms", void 0);
        (0, $dxWQo._)(this, "root", void 0);
        var t = {};
        this.ms = t, this.root = $eb20ad49f10f7301$var$l, this.ms[this.root] = $eb20ad49f10f7301$var$l;
    }
    (0, $kry2a._)(H, [
        {
            key: "get",
            value: function get(t) {
                return this.ms[t];
            }
        },
        {
            key: "set",
            value: function set(t, e) {
                this.ms[t] = e;
            }
        },
        {
            key: "setRoot",
            value: function setRoot(t) {
                this.root = t;
            }
        },
        {
            key: "sideNodesForRoot",
            value: function sideNodesForRoot(t, e) {
                var r = [];
                if (e === $eb20ad49f10f7301$var$l) return [
                    r,
                    $eb20ad49f10f7301$var$l,
                    "",
                    ""
                ];
                var n = this.get(e);
                if ($eb20ad49f10f7301$var$b(n)) return [
                    r,
                    e,
                    n,
                    ""
                ];
                var f, i, s = "", c = "";
                for(var h = 0; h < 256; h += 1){
                    var ref;
                    if (ref = (0, $8GFUW._)($eb20ad49f10f7301$var$B(n), 2), f = ref[0], i = ref[1], ref, $eb20ad49f10f7301$var$p(t, h) === 1 ? (c = f, s = i) : (c = i, s = f), r.push(c), s === $eb20ad49f10f7301$var$l) {
                        n = "";
                        break;
                    }
                    if (n = this.get(s), $eb20ad49f10f7301$var$b(n)) break;
                }
                var a = this.get(c);
                return [
                    $eb20ad49f10f7301$var$k(r),
                    s,
                    n,
                    a
                ];
            }
        },
        {
            key: "deleteWithSideNodes",
            value: function deleteWithSideNodes(t, e, r, n) {
                if (r === $eb20ad49f10f7301$var$l) return this.root;
                var _S = (0, $8GFUW._)($eb20ad49f10f7301$var$S(n), 1), f = _S[0];
                if (f !== t) return this.root;
                var i = "", s = "", c = "", a = "", h = !1;
                for(var g = 0; g < e.length; g += 1)if (e[g] !== "") {
                    if (c = e[g], s === "") {
                        if (a = this.get(c), $eb20ad49f10f7301$var$b(a)) {
                            i = c, s = c;
                            continue;
                        } else s = $eb20ad49f10f7301$var$l, h = !0;
                    }
                    var ref, ref1;
                    !h && c === $eb20ad49f10f7301$var$l || (h || (h = !0), $eb20ad49f10f7301$var$p(t, e.length - 1 - g) === 1 ? (ref = (0, $8GFUW._)($eb20ad49f10f7301$var$d(c, s), 2), i = ref[0], s = ref[1], ref) : (ref1 = (0, $8GFUW._)($eb20ad49f10f7301$var$d(s, c), 2), i = ref1[0], s = ref1[1], ref1), this.set(i, s), s = i);
                }
                return i === "" && (i = $eb20ad49f10f7301$var$l), i;
            }
        },
        {
            key: "updateWithSideNodes",
            value: function updateWithSideNodes(t, e, r, n, f) {
                var i, s;
                var ref;
                this.set((0, $daciJ.hash)(e), e), ref = (0, $8GFUW._)($eb20ad49f10f7301$var$M(t, e), 2), i = ref[0], s = ref[1], ref, this.set(i, s), s = i;
                var c;
                if (n === $eb20ad49f10f7301$var$l) c = 256;
                else {
                    var _S = (0, $8GFUW._)($eb20ad49f10f7301$var$S(f), 1), a = _S[0];
                    c = $eb20ad49f10f7301$var$v(t, a);
                }
                var ref1, ref2;
                c !== 256 && ($eb20ad49f10f7301$var$p(t, c) === 1 ? (ref1 = (0, $8GFUW._)($eb20ad49f10f7301$var$d(n, s), 2), i = ref1[0], s = ref1[1], ref1) : (ref2 = (0, $8GFUW._)($eb20ad49f10f7301$var$d(s, n), 2), i = ref2[0], s = ref2[1], ref2), this.set(i, s), s = i);
                for(var a1 = 0; a1 < 256; a1 += 1){
                    var h = void 0, g = 256 - r.length;
                    if (a1 - g < 0 || r[a1 - g] === "") {
                        if (c !== 256 && c > 255 - a1) h = $eb20ad49f10f7301$var$l;
                        else continue;
                    } else h = r[a1 - g];
                    var ref3, ref4;
                    $eb20ad49f10f7301$var$p(t, 255 - a1) === 1 ? (ref3 = (0, $8GFUW._)($eb20ad49f10f7301$var$d(h, s), 2), i = ref3[0], s = ref3[1], ref3) : (ref4 = (0, $8GFUW._)($eb20ad49f10f7301$var$d(s, h), 2), i = ref4[0], s = ref4[1], ref4), this.set(i, s), s = i;
                }
                return i;
            }
        },
        {
            key: "update",
            value: function update(t, e) {
                var _this_sideNodesForRoot = (0, $8GFUW._)(this.sideNodesForRoot(t, this.root), 3), r = _this_sideNodesForRoot[0], n = _this_sideNodesForRoot[1], f = _this_sideNodesForRoot[2], i;
                e === $eb20ad49f10f7301$var$l ? i = this.deleteWithSideNodes(t, r, n, f) : i = this.updateWithSideNodes(t, e, r, n, f), this.setRoot(i);
            }
        },
        {
            key: "delete",
            value: function _delete(t) {
                this.update(t, $eb20ad49f10f7301$var$l);
            }
        },
        {
            key: "prove",
            value: function prove(t) {
                var _this_sideNodesForRoot = (0, $8GFUW._)(this.sideNodesForRoot(t, this.root), 4), e = _this_sideNodesForRoot[0], r = _this_sideNodesForRoot[1], n = _this_sideNodesForRoot[2], f = _this_sideNodesForRoot[3], i = [];
                for(var a = 0; a < e.length; a += 1)e[a] !== "" && i.push(e[a]);
                var s = "";
                if (r !== $eb20ad49f10f7301$var$l) {
                    var _S = (0, $8GFUW._)($eb20ad49f10f7301$var$S(n), 1), a1 = _S[0];
                    a1 !== t && (s = n);
                }
                return new $eb20ad49f10f7301$var$L(i, s, f);
            }
        },
        {
            key: "proveCompacted",
            value: function proveCompacted(t) {
                var e = this.prove(t);
                return $eb20ad49f10f7301$var$E(e);
            }
        }
    ]);
    return H;
}(), $eb20ad49f10f7301$export$2e2bcd8739ae039 = $eb20ad49f10f7301$var$H;

});


parcelRequire.register("g3UKu", function(module, exports) {

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $ho5gk = parcelRequire("ho5gk");

var $8GFUW = parcelRequire("8GFUW");

var $6OZAO = parcelRequire("6OZAO");

var $j2rU8 = parcelRequire("j2rU8");

var $6M65e = parcelRequire("6M65e");

var $2cJiB = parcelRequire("2cJiB");

var $1nhBg = parcelRequire("1nhBg");

var $aMiMS = parcelRequire("aMiMS");

var $lcJUd = parcelRequire("lcJUd");

var $4jkfR = parcelRequire("4jkfR");

var $7XMRS = parcelRequire("7XMRS");

var $haENf = parcelRequire("haENf");
var $b9f038c000a1bad8$var$f = function(d) {
    var r = [], e = (0, $j2rU8.arrayify)(d);
    for(var t = 0; t < e.length; t += 8){
        var o = new Uint8Array(8);
        o.set(e.slice(t, t + 8)), r.push(o);
    }
    return (0, $haENf.calcRoot)(r.map(function(t) {
        return (0, $j2rU8.hexlify)(t);
    }));
};
var $b9f038c000a1bad8$var$D = new (0, $6M65e.Logger)((0, $4jkfR.versions).FUELS), $b9f038c000a1bad8$export$7ce636318c5a9f17 = /*#__PURE__*/ function(C) {
    "use strict";
    (0, $ftJVG._)(c1, C);
    var _super = (0, $6OZAO._)(c1);
    function c1(n, r, e, t) {
        (0, $978gY._)(this, c1);
        var _this;
        var _c_processPredicateData = $b9f038c000a1bad8$export$7ce636318c5a9f17.processPredicateData(n, r, t), o = _c_processPredicateData.predicateBytes, s = _c_processPredicateData.predicateTypes, i = _c_processPredicateData.predicateInterface, a = (0, $1nhBg.Address).fromB256($b9f038c000a1bad8$var$f(o));
        var _temp;
        _temp = _this = _super.call(this, a, e), (0, $dxWQo._)((0, $3vWwE._)(_this), "bytes", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "jsonAbi", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "predicateData", Uint8Array.from([])), (0, $dxWQo._)((0, $3vWwE._)(_this), "interface", void 0), _temp, _this.bytes = o, _this.jsonAbi = s, _this.interface = i;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(c1, [
        {
            key: "populateTransactionPredicateData",
            value: function populateTransactionPredicateData(n) {
                var _this = this;
                var e;
                var r = (0, $aMiMS.transactionRequestify)(n);
                return (e = r.inputs) == null || e.forEach(function(t) {
                    t.type === (0, $lcJUd.InputType).Coin && (0, $j2rU8.hexlify)(t.owner) === _this.address.toB256() && (t.predicate = _this.bytes, t.predicateData = _this.predicateData);
                }), r;
            }
        },
        {
            key: "sendTransaction",
            value: function sendTransaction(n) {
                var r = this.populateTransactionPredicateData(n);
                return (0, $3cct3._)((0, $g3d7z._)(c1.prototype), "sendTransaction", this).call(this, r);
            }
        },
        {
            key: "simulateTransaction",
            value: function simulateTransaction(n) {
                var r = this.populateTransactionPredicateData(n);
                return (0, $3cct3._)((0, $g3d7z._)(c1.prototype), "simulateTransaction", this).call(this, r);
            }
        },
        {
            key: "setData",
            value: function setData() {
                for(var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++){
                    n[_key] = arguments[_key];
                }
                var e = new (0, $2cJiB.AbiCoder)().encode(this.jsonAbi || [], n);
                return this.predicateData = e, this;
            }
        }
    ], [
        {
            key: "processPredicateData",
            value: function processPredicateData(n, r, e) {
                var t = (0, $j2rU8.arrayify)(n), o, s;
                if (r) {
                    s = new (0, $2cJiB.Interface)(r);
                    var i = s.fragments.find(function(param) {
                        var a = param.name;
                        return a === "main";
                    });
                    i !== void 0 ? o = i.inputs : $b9f038c000a1bad8$var$D.throwArgumentError('Cannot use ABI without "main" function', "Function fragments", s.fragments);
                }
                return e && Object.keys(e).length && (t = $b9f038c000a1bad8$export$7ce636318c5a9f17.setConfigurables(t, e, s)), {
                    predicateBytes: t,
                    predicateTypes: o,
                    predicateInterface: s
                };
            }
        },
        {
            key: "setConfigurables",
            value: function setConfigurables(n, r, e) {
                var t = n;
                try {
                    if (!e) throw new Error("Unable to validate configurable constants, Predicate instantiated without json ABI");
                    if (!Object.keys(e.configurables).length) throw new Error("Predicate has no configurable constants to be set");
                    Object.entries(r).forEach(function(param) {
                        var _param = (0, $8GFUW._)(param, 2), _$o = _param[0], s = _param[1];
                        if (!(e != null && e.configurables[_$o])) throw new Error("Predicate has no configurable constant named: ".concat(_$o));
                        var _e_configurables_o = e.configurables[_$o], i = _e_configurables_o.fragmentType, a = _e_configurables_o.offset, y = new (0, $2cJiB.AbiCoder)().getCoder(i).encode(s);
                        t.set(y, a);
                    });
                } catch (o) {
                    throw new Error("Error setting configurable constants: ".concat(o));
                }
                return t;
            }
        }
    ]);
    return c1;
}((0, $7XMRS.Account));

});
parcelRequire.register("7XMRS", function(module, exports) {

$parcel$export(module.exports, "Account", function () { return $74761ecf8ce5637e$export$1ed4b10e4aba04a7; });
$parcel$export(module.exports, "Wallet", function () { return $74761ecf8ce5637e$export$bcca3ea514774656; });

var $3vWwE = parcelRequire("3vWwE");

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $ftJVG = parcelRequire("ftJVG");

var $8OnJk = parcelRequire("8OnJk");

var $ho5gk = parcelRequire("ho5gk");

var $fLnyw = parcelRequire("fLnyw");

var $1ObTH = parcelRequire("1ObTH");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $5f5W0 = parcelRequire("5f5W0");

var $aMiMS = parcelRequire("aMiMS");

var $1JpXs = parcelRequire("1JpXs");

var $j2rU8 = parcelRequire("j2rU8");

var $1nhBg = parcelRequire("1nhBg");

var $jt0st = parcelRequire("jt0st");

var $dktpY = parcelRequire("dktpY");

var $4x96T = parcelRequire("4x96T");

var $9aGYB = parcelRequire("9aGYB");

var $7rPuq = parcelRequire("7rPuq");

var $8WFjQ = parcelRequire("8WFjQ");
var $74761ecf8ce5637e$var$A = Object.defineProperty;
var $74761ecf8ce5637e$var$B = function(a, e, t) {
    return e in a ? $74761ecf8ce5637e$var$A(a, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : a[e] = t;
};
var $74761ecf8ce5637e$var$p = function(a, e, t) {
    return $74761ecf8ce5637e$var$B(a, (typeof e === "undefined" ? "undefined" : (0, $1ObTH._)(e)) != "symbol" ? e + "" : e, t), t;
};
var $74761ecf8ce5637e$var$u = "http://127.0.0.1:4000/graphql";
var $74761ecf8ce5637e$export$1ed4b10e4aba04a7 = /*#__PURE__*/ function(C) {
    "use strict";
    (0, $ftJVG._)(m, C);
    var _super = (0, $6OZAO._)(m);
    function m(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $74761ecf8ce5637e$var$u;
        (0, $978gY._)(this, m);
        var _this;
        var _temp;
        _temp = _this = _super.call(this), (0, $dxWQo._)((0, $3vWwE._)(_this), "address", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "provider", void 0), _temp, _this.provider = _this.connect(t), _this.address = (0, $1nhBg.Address).fromDynamicInput(e);
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(m, [
        {
            key: "connect",
            value: function connect(e) {
                return typeof e == "string" ? this.provider ? this.provider.connect(e) : this.provider = new (0, $aMiMS.Provider)(e) : this.provider = e, this.provider;
            }
        },
        {
            key: "getResourcesToSpend",
            value: function getResourcesToSpend(e, t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.provider.getResourcesToSpend(_this.address, e, t)
                        ];
                    });
                })();
            }
        },
        {
            key: "getCoins",
            value: function getCoins(e) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var t, i, _t, n;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = [];
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    _this.provider.getCoins(_this.address, e, {
                                        first: 9999,
                                        after: i
                                    })
                                ];
                            case 2:
                                n = _state.sent();
                                if ((_t = t).push.apply(_t, (0, $fLnyw._)(n)), !(n.length >= 9999)) return [
                                    3,
                                    4
                                ];
                                throw new Error("Wallets with more than ".concat(9999, " coins are not yet supported"));
                            case 3:
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                return [
                                    2,
                                    t
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMessages",
            value: function getMessages() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var e, s, _e, i;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = [];
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    _this.provider.getMessages(_this.address, {
                                        first: 9999,
                                        after: s
                                    })
                                ];
                            case 2:
                                i = _state.sent();
                                if ((_e = e).push.apply(_e, (0, $fLnyw._)(i)), !(i.length >= 9999)) return [
                                    3,
                                    4
                                ];
                                throw new Error("Wallets with more than ".concat(9999, " messages are not yet supported"));
                            case 3:
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBalance",
            value: function getBalance() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $jt0st.NativeAssetId);
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.provider.getBalance(_this.address, e)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBalances",
            value: function getBalances() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var e, s, _e, i;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = [];
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    _this.provider.getBalances(_this.address, {
                                        first: 9999,
                                        after: s
                                    })
                                ];
                            case 2:
                                i = _state.sent();
                                if ((_e = e).push.apply(_e, (0, $fLnyw._)(i)), !(i.length >= 9999)) return [
                                    3,
                                    4
                                ];
                                throw new Error("Wallets with more than ".concat(9999, " balances are not yet supported"));
                            case 3:
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fund",
            value: function fund(e) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var t, s;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = e.calculateFee();
                                return [
                                    4,
                                    _this.getResourcesToSpend([
                                        t
                                    ])
                                ];
                            case 1:
                                s = _state.sent();
                                e.addResources(s);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "transfer",
            value: function transfer(e, t) {
                var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $jt0st.NativeAssetId), i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var _this = this;
                return (0, $byzP8._)(function() {
                    var n, d, o, c, h;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                n = (0, $8OnJk._)({
                                    gasLimit: (0, $9aGYB.MAX_GAS_PER_TX)
                                }, i), d = new (0, $aMiMS.ScriptTransactionRequest)(n);
                                d.addCoinOutput(e, t, s);
                                o = d.calculateFee(), c = [];
                                o.assetId === (0, $j2rU8.hexlify)(s) ? (o.amount = o.amount.add(t), c = [
                                    o
                                ]) : c = [
                                    [
                                        t,
                                        s
                                    ],
                                    o
                                ];
                                return [
                                    4,
                                    _this.getResourcesToSpend(c)
                                ];
                            case 1:
                                h = _state.sent();
                                return [
                                    2,
                                    (d.addResources(h), _this.sendTransaction(d))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "withdrawToBaseLayer",
            value: function withdrawToBaseLayer(e, t) {
                var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return (0, $byzP8._)(function() {
                    var i, n, o, c, h, w, q;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                i = (0, $j2rU8.arrayify)("0x".concat(e.toHexString().substring(2).padStart(64, "0"))), n = (0, $j2rU8.arrayify)("0x".concat((0, $4x96T.bn)(t).toHex().substring(2).padStart(16, "0"))), o = (0, $8OnJk._)({
                                    script: new Uint8Array((0, $fLnyw._)((0, $j2rU8.arrayify)((0, $aMiMS.withdrawScript).bytes)).concat((0, $fLnyw._)(i), (0, $fLnyw._)(n))),
                                    gasLimit: (0, $9aGYB.MAX_GAS_PER_TX)
                                }, s), c = new (0, $aMiMS.ScriptTransactionRequest)(o);
                                c.addMessageOutputs();
                                h = c.calculateFee(), w = [];
                                h.amount = h.amount.add(t), w = [
                                    h
                                ];
                                return [
                                    4,
                                    _this.getResourcesToSpend(w)
                                ];
                            case 1:
                                q = _state.sent();
                                return [
                                    2,
                                    (c.addResources(q), _this.sendTransaction(c))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTransaction",
            value: function sendTransaction(e) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var t;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = (0, $aMiMS.transactionRequestify)(e);
                                return [
                                    4,
                                    _this.provider.estimateTxDependencies(t)
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), _this.provider.sendTransaction(t))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "simulateTransaction",
            value: function simulateTransaction(e) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var t;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = (0, $aMiMS.transactionRequestify)(e);
                                return [
                                    4,
                                    _this.provider.estimateTxDependencies(t)
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), _this.provider.simulate(t))
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return m;
}((0, $dktpY.AbstractAccount));
var $74761ecf8ce5637e$export$329776f085b7caa7 = /*#__PURE__*/ function(m) {
    "use strict";
    (0, $ftJVG._)(l, m);
    var _super = (0, $6OZAO._)(l);
    function l(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $74761ecf8ce5637e$var$u;
        (0, $978gY._)(this, l);
        var _this;
        var s = new (0, $1JpXs.Signer)(e);
        var _temp;
        _temp = _this = _super.call(this, s.address, t), (0, $dxWQo._)((0, $3vWwE._)(_this), "provider", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "signer", void 0), _temp, _this.signer = function() {
            return s;
        }, _this.provider = _this.connect(t);
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(l, [
        {
            key: "privateKey",
            get: function get() {
                return this.signer().privateKey;
            }
        },
        {
            key: "publicKey",
            get: function get() {
                return this.signer().publicKey;
            }
        },
        {
            key: "signMessage",
            value: function signMessage(e) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.signer().sign((0, $5f5W0.hashMessage)(e))
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signTransaction",
            value: function signTransaction(e) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var t, s;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = (0, $aMiMS.transactionRequestify)(e), s = (0, $5f5W0.hashTransaction)(t);
                                return [
                                    4,
                                    _this.signer().sign(s)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "populateTransactionWitnessesSignature",
            value: function populateTransactionWitnessesSignature(e) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var t, s;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = (0, $aMiMS.transactionRequestify)(e);
                                return [
                                    4,
                                    _this.signTransaction(t)
                                ];
                            case 1:
                                s = _state.sent();
                                return [
                                    2,
                                    (t.updateWitnessByOwner(_this.address, s), t)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTransaction",
            value: function sendTransaction(e) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var t, _, _1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = (0, $aMiMS.transactionRequestify)(e);
                                return [
                                    4,
                                    _this.provider.estimateTxDependencies(t)
                                ];
                            case 1:
                                _state.sent();
                                _1 = (_ = _this.provider).sendTransaction;
                                return [
                                    4,
                                    _this.populateTransactionWitnessesSignature(t)
                                ];
                            case 2:
                                return [
                                    2,
                                    _1.apply(_, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "simulateTransaction",
            value: function simulateTransaction(e) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var t, _, _1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = (0, $aMiMS.transactionRequestify)(e);
                                return [
                                    4,
                                    _this.provider.estimateTxDependencies(t)
                                ];
                            case 1:
                                _state.sent();
                                _1 = (_ = _this.provider).call;
                                return [
                                    4,
                                    _this.populateTransactionWitnessesSignature(t)
                                ];
                            case 2:
                                return [
                                    2,
                                    _1.apply(_, [
                                        _state.sent(),
                                        {
                                            utxoValidation: !0
                                        }
                                    ])
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return l;
}($74761ecf8ce5637e$export$1ed4b10e4aba04a7);
$74761ecf8ce5637e$var$p($74761ecf8ce5637e$export$329776f085b7caa7, "defaultPath", "m/44'/1179993420'/0'/0/0");
var $74761ecf8ce5637e$export$e8b77fbda03085dd = /*#__PURE__*/ function(m) {
    "use strict";
    (0, $ftJVG._)(T, m);
    var _super = (0, $6OZAO._)(T);
    function T() {
        (0, $978gY._)(this, T);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(T, [
        {
            key: "unlock",
            value: function unlock(e) {
                return new $74761ecf8ce5637e$export$6d3a173fc99a471c(e, this.provider);
            }
        }
    ]);
    return T;
}($74761ecf8ce5637e$export$1ed4b10e4aba04a7), $74761ecf8ce5637e$export$6d3a173fc99a471c = /*#__PURE__*/ function(l) {
    "use strict";
    (0, $ftJVG._)(r1, l);
    var _super = (0, $6OZAO._)(r1);
    function r1() {
        (0, $978gY._)(this, r1);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(r1, [
        {
            key: "lock",
            value: function lock() {
                return this.signer = function() {
                    return new (0, $1JpXs.Signer)("0x00");
                }, new $74761ecf8ce5637e$export$e8b77fbda03085dd(this.address, this.provider);
            }
        }
    ], [
        {
            key: "generate",
            value: function generate(e) {
                var t = (0, $1JpXs.Signer).generatePrivateKey(e == null ? void 0 : e.entropy);
                return new $74761ecf8ce5637e$export$6d3a173fc99a471c(t, e == null ? void 0 : e.provider);
            }
        },
        {
            key: "fromSeed",
            value: function fromSeed(e, t, s) {
                var n = (0, $7rPuq.HDWallet).fromSeed(e).derivePath(t || $74761ecf8ce5637e$export$6d3a173fc99a471c.defaultPath);
                return new $74761ecf8ce5637e$export$6d3a173fc99a471c(n.privateKey, s);
            }
        },
        {
            key: "fromMnemonic",
            value: function fromMnemonic(e, t, s, i) {
                var n = (0, $8WFjQ.Mnemonic).mnemonicToSeed(e, s), o = (0, $7rPuq.HDWallet).fromSeed(n).derivePath(t || $74761ecf8ce5637e$export$6d3a173fc99a471c.defaultPath);
                return new $74761ecf8ce5637e$export$6d3a173fc99a471c(o.privateKey, i);
            }
        },
        {
            key: "fromExtendedKey",
            value: function fromExtendedKey(e, t) {
                var s = (0, $7rPuq.HDWallet).fromExtendedKey(e);
                return new $74761ecf8ce5637e$export$6d3a173fc99a471c(s.privateKey, t);
            }
        }
    ]);
    return r1;
}($74761ecf8ce5637e$export$329776f085b7caa7);
var $74761ecf8ce5637e$export$bcca3ea514774656 = /*#__PURE__*/ function() {
    "use strict";
    function g() {
        (0, $978gY._)(this, g);
    }
    (0, $kry2a._)(g, null, [
        {
            key: "fromAddress",
            value: function fromAddress(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $74761ecf8ce5637e$var$u;
                return new $74761ecf8ce5637e$export$e8b77fbda03085dd(e, t);
            }
        },
        {
            key: "fromPrivateKey",
            value: function fromPrivateKey(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $74761ecf8ce5637e$var$u;
                return new $74761ecf8ce5637e$export$6d3a173fc99a471c(e, t);
            }
        }
    ]);
    return g;
}();
$74761ecf8ce5637e$var$p($74761ecf8ce5637e$export$bcca3ea514774656, "generate", $74761ecf8ce5637e$export$6d3a173fc99a471c.generate), $74761ecf8ce5637e$var$p($74761ecf8ce5637e$export$bcca3ea514774656, "fromSeed", $74761ecf8ce5637e$export$6d3a173fc99a471c.fromSeed), $74761ecf8ce5637e$var$p($74761ecf8ce5637e$export$bcca3ea514774656, "fromMnemonic", $74761ecf8ce5637e$export$6d3a173fc99a471c.fromMnemonic), $74761ecf8ce5637e$var$p($74761ecf8ce5637e$export$bcca3ea514774656, "fromExtendedKey", $74761ecf8ce5637e$export$6d3a173fc99a471c.fromExtendedKey);

});
parcelRequire.register("5f5W0", function(module, exports) {

$parcel$export(module.exports, "hashMessage", function () { return $5c441d705907a13e$export$d4c241cec96564c1; });
$parcel$export(module.exports, "hashTransaction", function () { return $5c441d705907a13e$export$4a993679581f66b0; });
$parcel$export(module.exports, "hash", function () { return $5c441d705907a13e$export$d6af199866bfb566; });

var $7WUQV = parcelRequire("7WUQV");

var $jt0st = parcelRequire("jt0st");

var $2URXt = parcelRequire("2URXt");

var $4x96T = parcelRequire("4x96T");

var $aMiMS = parcelRequire("aMiMS");
var $lcJUd = parcelRequire("lcJUd");

var $lcJUd = parcelRequire("lcJUd");

var $51Bw9 = parcelRequire("51Bw9");
function $5c441d705907a13e$export$d4c241cec96564c1(r) {
    return (0, $7WUQV.sha256)((0, $2URXt.bufferFromString)(r, "utf-8"));
}
function $5c441d705907a13e$export$4a993679581f66b0(r) {
    var e = (0, $aMiMS.transactionRequestify)(r).toTransaction();
    return e.type === (0, $lcJUd.TransactionType).Script && (e.receiptsRoot = (0, $jt0st.ZeroBytes32)), e.inputs = e.inputs.map(function(n) {
        var t = (0, (/*@__PURE__*/$parcel$interopDefault($51Bw9)))(n);
        switch(t.type){
            case (0, $lcJUd.InputType).Coin:
                return t;
            case (0, $lcJUd.InputType).Contract:
                return t.utxoID = {
                    transactionId: (0, $jt0st.ZeroBytes32),
                    outputIndex: 0
                }, t.balanceRoot = (0, $jt0st.ZeroBytes32), t.stateRoot = (0, $jt0st.ZeroBytes32), t;
            default:
                return t;
        }
    }), e.outputs = e.outputs.map(function(n) {
        var t = (0, (/*@__PURE__*/$parcel$interopDefault($51Bw9)))(n);
        switch(t.type){
            case (0, $lcJUd.OutputType).Contract:
                return t.balanceRoot = (0, $jt0st.ZeroBytes32), t.stateRoot = (0, $jt0st.ZeroBytes32), t;
            case (0, $lcJUd.OutputType).Change:
                return t.amount = (0, $4x96T.bn)(0), t;
            case (0, $lcJUd.OutputType).Variable:
                return t.to = (0, $jt0st.ZeroBytes32), t.amount = (0, $4x96T.bn)(0), t.assetId = (0, $jt0st.ZeroBytes32), t;
            default:
                return t;
        }
    }), e.witnessesCount = 0, e.witnesses = [], (0, $7WUQV.sha256)(new (0, $lcJUd.TransactionCoder)().encode(e));
}
function $5c441d705907a13e$export$d6af199866bfb566(r) {
    return (0, $7WUQV.sha256)(r);
}

});

parcelRequire.register("1JpXs", function(module, exports) {

$parcel$export(module.exports, "Signer", function () { return $15ed84ec37baaddd$export$fdf54fdde81cc9f0; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $j2rU8 = parcelRequire("j2rU8");

var $1nhBg = parcelRequire("1nhBg");

var $5f5W0 = parcelRequire("5f5W0");

var $2URXt = parcelRequire("2URXt");

var $4x96T = parcelRequire("4x96T");

var $492wS = parcelRequire("492wS");
var $15ed84ec37baaddd$var$k = $492wS.ec;
function $15ed84ec37baaddd$export$2ed0ba18b91344cd() {
    return new $15ed84ec37baaddd$var$k("secp256k1");
}
var $15ed84ec37baaddd$var$a = /*#__PURE__*/ function() {
    "use strict";
    function a1(e) {
        (0, $978gY._)(this, a1);
        (0, $dxWQo._)(this, "address", void 0);
        (0, $dxWQo._)(this, "publicKey", void 0);
        (0, $dxWQo._)(this, "compressedPublicKey", void 0);
        (0, $dxWQo._)(this, "privateKey", void 0);
        typeof e == "string" && e.match(/^[0-9a-f]*$/i) && e.length === 64 && (e = "0x".concat(e));
        var r = (0, $j2rU8.arrayify)(e), t = $15ed84ec37baaddd$export$2ed0ba18b91344cd().keyFromPrivate(r, "hex");
        this.compressedPublicKey = (0, $j2rU8.hexlify)(t.getPublic(!0, "array")), this.publicKey = (0, $j2rU8.hexlify)(t.getPublic(!1, "array").slice(1)), this.privateKey = (0, $j2rU8.hexlify)(r), this.address = (0, $1nhBg.Address).fromPublicKey(this.publicKey);
    }
    (0, $kry2a._)(a1, [
        {
            key: "sign",
            value: function sign(e) {
                var t = $15ed84ec37baaddd$export$2ed0ba18b91344cd().keyFromPrivate((0, $j2rU8.arrayify)(this.privateKey), "hex").sign((0, $j2rU8.arrayify)(e), {
                    canonical: !0
                }), y = (0, $4x96T.toBytes)(t.r, 32), i = (0, $4x96T.toBytes)(t.s, 32);
                return i[0] |= (t.recoveryParam || 0) << 7, (0, $j2rU8.hexlify)((0, $j2rU8.concat)([
                    y,
                    i
                ]));
            }
        },
        {
            key: "addPoint",
            value: function addPoint(e) {
                var r = $15ed84ec37baaddd$export$2ed0ba18b91344cd().keyFromPublic((0, $j2rU8.arrayify)(this.compressedPublicKey)), t = $15ed84ec37baaddd$export$2ed0ba18b91344cd().keyFromPublic((0, $j2rU8.arrayify)(e)), y = r.getPublic().add(t.getPublic());
                return (0, $j2rU8.hexlify)(y.encode("array", !0));
            }
        }
    ], [
        {
            key: "recoverPublicKey",
            value: function recoverPublicKey(e, r) {
                var t = (0, $j2rU8.arrayify)(r), y = t.slice(0, 32), i = t.slice(32, 64), m = (i[0] & 128) >> 7;
                return i[0] &= 127, $15ed84ec37baaddd$export$2ed0ba18b91344cd().recoverPubKey((0, $j2rU8.arrayify)(e), {
                    r: y,
                    s: i
                }, m).encode("array", !1).slice(1);
            }
        },
        {
            key: "recoverAddress",
            value: function recoverAddress(e, r) {
                return (0, $1nhBg.Address).fromPublicKey($15ed84ec37baaddd$var$a.recoverPublicKey(e, r));
            }
        },
        {
            key: "generatePrivateKey",
            value: function generatePrivateKey(e) {
                return e ? (0, $5f5W0.hash)((0, $j2rU8.concat)([
                    (0, $2URXt.randomBytes)(32),
                    (0, $j2rU8.arrayify)(e)
                ])) : (0, $2URXt.randomBytes)(32);
            }
        },
        {
            key: "extendPublicKey",
            value: function extendPublicKey(e) {
                var r = $15ed84ec37baaddd$export$2ed0ba18b91344cd().keyFromPublic((0, $j2rU8.arrayify)(e));
                return (0, $j2rU8.hexlify)(r.getPublic(!1, "array").slice(1));
            }
        }
    ]);
    return a1;
}(), $15ed84ec37baaddd$export$fdf54fdde81cc9f0 = $15ed84ec37baaddd$var$a;

});

parcelRequire.register("7rPuq", function(module, exports) {

$parcel$export(module.exports, "HDWallet", function () { return $2b34244bce305d7f$export$61f79a304b3775c8; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $ebtr5 = parcelRequire("ebtr5");

var $j2rU8 = parcelRequire("j2rU8");

var $7WUQV = parcelRequire("7WUQV");
var $aCF4U = parcelRequire("aCF4U");

var $4x96T = parcelRequire("4x96T");

var $8WFjQ = parcelRequire("8WFjQ");

var $1JpXs = parcelRequire("1JpXs");
var $2b34244bce305d7f$var$v = 2147483648, $2b34244bce305d7f$var$w = (0, $j2rU8.hexlify)("0x0488ade4"), $2b34244bce305d7f$var$l = (0, $j2rU8.hexlify)("0x0488b21e"), $2b34244bce305d7f$var$E = (0, $j2rU8.hexlify)("0x04358394"), $2b34244bce305d7f$var$u = (0, $j2rU8.hexlify)("0x043587cf");
function $2b34244bce305d7f$var$b(n) {
    return (0, $ebtr5.Base58).encode((0, $j2rU8.concat)([
        n,
        (0, $j2rU8.hexDataSlice)((0, $7WUQV.sha256)((0, $7WUQV.sha256)(n)), 0, 4)
    ]));
}
function $2b34244bce305d7f$var$M() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return n ? e ? $2b34244bce305d7f$var$u : $2b34244bce305d7f$var$l : e ? $2b34244bce305d7f$var$E : $2b34244bce305d7f$var$w;
}
function $2b34244bce305d7f$var$N(n) {
    return [
        $2b34244bce305d7f$var$l,
        $2b34244bce305d7f$var$u
    ].includes((0, $j2rU8.hexlify)(n.slice(0, 4)));
}
function $2b34244bce305d7f$var$V(n) {
    return [
        $2b34244bce305d7f$var$w,
        $2b34244bce305d7f$var$E,
        $2b34244bce305d7f$var$l,
        $2b34244bce305d7f$var$u
    ].includes((0, $j2rU8.hexlify)(n.slice(0, 4)));
}
function $2b34244bce305d7f$var$T(n) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var t = n.split("/");
    if (t.length === 0 || t[0] === "m" && e !== 0) throw new Error("invalid path - ".concat(n));
    return t[0] === "m" && t.shift(), t.map(function(r) {
        return ~r.indexOf("'") ? parseInt(r, 10) + $2b34244bce305d7f$var$v : parseInt(r, 10);
    });
}
var $2b34244bce305d7f$var$c = /*#__PURE__*/ function() {
    "use strict";
    function c1(e) {
        (0, $978gY._)(this, c1);
        (0, $dxWQo._)(this, "depth", 0);
        (0, $dxWQo._)(this, "index", 0);
        (0, $dxWQo._)(this, "fingerprint", (0, $j2rU8.hexlify)("0x00000000"));
        (0, $dxWQo._)(this, "parentFingerprint", (0, $j2rU8.hexlify)("0x00000000"));
        (0, $dxWQo._)(this, "privateKey", void 0);
        (0, $dxWQo._)(this, "publicKey", void 0);
        (0, $dxWQo._)(this, "chainCode", void 0);
        if (e.privateKey) {
            var t = new (0, $1JpXs.Signer)(e.privateKey);
            this.publicKey = (0, $j2rU8.hexlify)(t.compressedPublicKey), this.privateKey = (0, $j2rU8.hexlify)(e.privateKey);
        } else {
            if (!e.publicKey) throw new Error("Public and Private Key are missing!");
            this.publicKey = (0, $j2rU8.hexlify)(e.publicKey);
        }
        this.parentFingerprint = e.parentFingerprint || this.parentFingerprint, this.fingerprint = (0, $j2rU8.hexDataSlice)((0, $7WUQV.ripemd160)((0, $7WUQV.sha256)(this.publicKey)), 0, 4), this.depth = e.depth || this.depth, this.index = e.index || this.index, this.chainCode = e.chainCode;
    }
    (0, $kry2a._)(c1, [
        {
            key: "extendedKey",
            get: function get() {
                return this.toExtendedKey();
            }
        },
        {
            key: "deriveIndex",
            value: function deriveIndex(e) {
                var t = this.privateKey && (0, $j2rU8.arrayify)(this.privateKey), r = (0, $j2rU8.arrayify)(this.publicKey), s = (0, $j2rU8.arrayify)(this.chainCode), o = new Uint8Array(37);
                if (e & $2b34244bce305d7f$var$v) {
                    if (!t) throw new Error("Derive hardened requires privateKey");
                    o.set(t, 1);
                } else o.set((0, $j2rU8.arrayify)(this.publicKey));
                o.set((0, $4x96T.toBytes)(e, 4), 33);
                var p = (0, $j2rU8.arrayify)((0, $7WUQV.computeHmac)((0, $aCF4U.SupportedAlgorithm).sha512, s, o)), d = p.slice(0, 32), a = p.slice(32);
                if (t) {
                    var C = "0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", I = (0, $4x96T.bn)(d).add(t).mod(C).toBytes(32);
                    return new $2b34244bce305d7f$var$c({
                        privateKey: I,
                        chainCode: a,
                        index: e,
                        depth: this.depth + 1,
                        parentFingerprint: this.fingerprint
                    });
                }
                var k = new (0, $1JpXs.Signer)((0, $j2rU8.hexlify)(d)).addPoint(r);
                return new $2b34244bce305d7f$var$c({
                    publicKey: k,
                    chainCode: a,
                    index: e,
                    depth: this.depth + 1,
                    parentFingerprint: this.fingerprint
                });
            }
        },
        {
            key: "derivePath",
            value: function derivePath(e) {
                return $2b34244bce305d7f$var$T(e, this.depth).reduce(function(r, s) {
                    return r.deriveIndex(s);
                }, this);
            }
        },
        {
            key: "toExtendedKey",
            value: function toExtendedKey() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                if (this.depth >= 256) throw new Error("Depth too large!");
                var r = $2b34244bce305d7f$var$M(this.privateKey == null || e, t), s = (0, $j2rU8.hexlify)(this.depth), o = this.parentFingerprint, p = (0, $4x96T.toHex)(this.index, 4), d = this.chainCode, a = this.privateKey != null && !e ? (0, $j2rU8.concat)([
                    "0x00",
                    this.privateKey
                ]) : this.publicKey, K = (0, $j2rU8.concat)([
                    r,
                    s,
                    o,
                    p,
                    d,
                    a
                ]);
                return $2b34244bce305d7f$var$b(K);
            }
        }
    ], [
        {
            key: "fromSeed",
            value: function fromSeed(e) {
                var t = (0, $8WFjQ.Mnemonic).masterKeysFromSeed(e);
                return new $2b34244bce305d7f$var$c({
                    chainCode: (0, $j2rU8.arrayify)(t.slice(32)),
                    privateKey: (0, $j2rU8.arrayify)(t.slice(0, 32))
                });
            }
        },
        {
            key: "fromExtendedKey",
            value: function fromExtendedKey(e) {
                var t = (0, $ebtr5.Base58).decode(e), r = $2b34244bce305d7f$var$b(t.slice(0, 78)) === e;
                if (t.length !== 82 || !$2b34244bce305d7f$var$V(t)) throw new Error("Invalid extended key");
                if (!r) throw new Error("Invalid checksum key");
                var s = t[4], o = (0, $j2rU8.hexlify)(t.slice(5, 9)), p = parseInt((0, $j2rU8.hexlify)(t.slice(9, 13)).substring(2), 16), d = (0, $j2rU8.hexlify)(t.slice(13, 45)), a = t.slice(45, 78);
                if (s === 0 && o !== "0x00000000" || s === 0 && p !== 0) throw new Error("Invalid depth");
                if ($2b34244bce305d7f$var$N(t)) {
                    if (a[0] !== 3) throw new Error("Invalid public extended key");
                    return new $2b34244bce305d7f$var$c({
                        publicKey: a,
                        chainCode: d,
                        index: p,
                        depth: s,
                        parentFingerprint: o
                    });
                }
                if (a[0] !== 0) throw new Error("Invalid private extended key");
                return new $2b34244bce305d7f$var$c({
                    privateKey: a.slice(1),
                    chainCode: d,
                    index: p,
                    depth: s,
                    parentFingerprint: o
                });
            }
        }
    ]);
    return c1;
}(), $2b34244bce305d7f$export$61f79a304b3775c8 = $2b34244bce305d7f$var$c;

});
parcelRequire.register("8WFjQ", function(module, exports) {

$parcel$export(module.exports, "Mnemonic", function () { return $c94d5c73a827ca9b$export$93018d515d60db37; });

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $ebtr5 = parcelRequire("ebtr5");

var $j2rU8 = parcelRequire("j2rU8");

var $eIQbV = parcelRequire("eIQbV");

var $7WUQV = parcelRequire("7WUQV");
var $aCF4U = parcelRequire("aCF4U");

var $2URXt = parcelRequire("2URXt");

var $sPv0i = parcelRequire("sPv0i");
function $c94d5c73a827ca9b$var$y(n) {
    var e = n.normalize("NFKD"), t = [];
    for(var r = 0; r < e.length; r += 1){
        var s = e.charCodeAt(r);
        if (s < 128) t.push(s);
        else if (s < 2048) t.push(s >> 6 | 192), t.push(s & 63 | 128);
        else if ((s & 64512) === 55296) {
            r += 1;
            var o = e.charCodeAt(r);
            if (r >= e.length || (o & 64512) !== 56320) throw new Error("invalid utf-8 string");
            var c = 65536 + ((s & 1023) << 10) + (o & 1023);
            t.push(c >> 18 | 240), t.push(c >> 12 & 63 | 128), t.push(c >> 6 & 63 | 128), t.push(c & 63 | 128);
        } else t.push(s >> 12 | 224), t.push(s >> 6 & 63 | 128), t.push(s & 63 | 128);
    }
    return (0, $j2rU8.arrayify)(t);
}
function $c94d5c73a827ca9b$var$v(n) {
    return (1 << n) - 1;
}
function $c94d5c73a827ca9b$var$b(n) {
    return (1 << n) - 1 << 8 - n;
}
function $c94d5c73a827ca9b$var$p(n) {
    return Array.isArray(n) ? n : n.split(/\s+/);
}
function $c94d5c73a827ca9b$var$E(n) {
    return Array.isArray(n) ? n.join(" ") : n;
}
function $c94d5c73a827ca9b$var$T(n) {
    var e = [
        0
    ], t = 11;
    for(var o = 0; o < n.length; o += 1)t > 8 ? (e[e.length - 1] <<= 8, e[e.length - 1] |= n[o], t -= 8) : (e[e.length - 1] <<= t, e[e.length - 1] |= n[o] >> 8 - t, e.push(n[o] & $c94d5c73a827ca9b$var$v(8 - t)), t += 3);
    var r = n.length / 4, s = (0, $j2rU8.arrayify)((0, $7WUQV.sha256)(n))[0] & $c94d5c73a827ca9b$var$b(r);
    return e[e.length - 1] <<= r, e[e.length - 1] |= s >> 8 - r, e;
}
function $c94d5c73a827ca9b$var$P(n, e) {
    var t = Math.ceil(11 * n.length / 8), r = (0, $j2rU8.arrayify)(new Uint8Array(t)), s = 0;
    for(var a = 0; a < n.length; a += 1){
        var h = e.indexOf(n[a].normalize("NFKD"));
        if (h === -1) throw new Error("invalid mnemonic");
        for(var l = 0; l < 11; l += 1)h & 1 << 10 - l && (r[s >> 3] |= 1 << 7 - s % 8), s += 1;
    }
    var o = 32 * n.length / 3, c = n.length / 3, f = $c94d5c73a827ca9b$var$b(c);
    if (((0, $j2rU8.arrayify)((0, $7WUQV.sha256)(r.slice(0, o / 8)))[0] & f) !== (r[r.length - 1] & f)) throw new Error("invalid checksum");
    return r.slice(0, o / 8);
}
var $c94d5c73a827ca9b$var$j = $c94d5c73a827ca9b$var$y("Bitcoin seed"), $c94d5c73a827ca9b$var$z = 76066276, $c94d5c73a827ca9b$var$D = 70615956, $c94d5c73a827ca9b$export$5c84cae5d130478 = [
    12,
    15,
    18,
    21,
    24
];
function $c94d5c73a827ca9b$var$L(n) {
    if (n.length !== 2048) throw new Error("Invalid word list length");
}
function $c94d5c73a827ca9b$var$O(n) {
    if (n.length % 4 !== 0 || n.length < 16 || n.length > 32) throw new Error("invalid entropy");
}
function $c94d5c73a827ca9b$var$A(n) {
    if (!$c94d5c73a827ca9b$export$5c84cae5d130478.includes(n.length)) throw new Error("invalid mnemonic size");
}
var $c94d5c73a827ca9b$var$i = /*#__PURE__*/ function() {
    "use strict";
    function i1() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $sPv0i.english);
        (0, $978gY._)(this, i1);
        (0, $dxWQo._)(this, "wordlist", void 0);
        this.wordlist = e, $c94d5c73a827ca9b$var$L(this.wordlist);
    }
    (0, $kry2a._)(i1, [
        {
            key: "mnemonicToEntropy",
            value: function mnemonicToEntropy(e) {
                return $c94d5c73a827ca9b$var$i.mnemonicToEntropy(e, this.wordlist);
            }
        },
        {
            key: "entropyToMnemonic",
            value: function entropyToMnemonic(e) {
                return $c94d5c73a827ca9b$var$i.entropyToMnemonic(e, this.wordlist);
            }
        }
    ], [
        {
            key: "mnemonicToEntropy",
            value: function mnemonicToEntropy(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $sPv0i.english);
                var r = $c94d5c73a827ca9b$var$p(e);
                return $c94d5c73a827ca9b$var$A(r), (0, $j2rU8.hexlify)($c94d5c73a827ca9b$var$P(r, t));
            }
        },
        {
            key: "entropyToMnemonic",
            value: function entropyToMnemonic(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $sPv0i.english);
                var r = (0, $j2rU8.arrayify)(e, {
                    allowMissingPrefix: !0
                });
                return $c94d5c73a827ca9b$var$L(t), $c94d5c73a827ca9b$var$O(r), $c94d5c73a827ca9b$var$T(r).map(function(s) {
                    return t[s];
                }).join(" ");
            }
        },
        {
            key: "mnemonicToSeed",
            value: function mnemonicToSeed(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                $c94d5c73a827ca9b$var$A($c94d5c73a827ca9b$var$p(e));
                var r = $c94d5c73a827ca9b$var$y($c94d5c73a827ca9b$var$E(e)), s = $c94d5c73a827ca9b$var$y("mnemonic".concat(t));
                return (0, $eIQbV.pbkdf2)(r, s, 2048, 64, "sha512");
            }
        },
        {
            key: "mnemonicToMasterKeys",
            value: function mnemonicToMasterKeys(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                var r = $c94d5c73a827ca9b$var$i.mnemonicToSeed(e, t);
                return $c94d5c73a827ca9b$var$i.masterKeysFromSeed(r);
            }
        },
        {
            key: "isMnemonicValid",
            value: function isMnemonicValid(e) {
                var t = $c94d5c73a827ca9b$var$p(e), r = 0;
                try {
                    $c94d5c73a827ca9b$var$A(t);
                } catch (e) {
                    return !1;
                }
                for(; r < t.length;){
                    if ($c94d5c73a827ca9b$var$i.binarySearch(t[r]) === !1) return !1;
                    r += 1;
                }
                return !0;
            }
        },
        {
            key: "binarySearch",
            value: function binarySearch(e) {
                var t = (0, $sPv0i.english), r = 0, s = t.length - 1;
                for(; r <= s;){
                    var o = Math.floor((r + s) / 2);
                    if (t[o] === e) return !0;
                    e < t[o] ? s = o - 1 : r = o + 1;
                }
                return !1;
            }
        },
        {
            key: "masterKeysFromSeed",
            value: function masterKeysFromSeed(e) {
                var t = (0, $j2rU8.arrayify)(e);
                if (t.length < 16 || t.length > 64) throw new Error("invalid seed");
                return (0, $j2rU8.arrayify)((0, $7WUQV.computeHmac)((0, $aCF4U.SupportedAlgorithm).sha512, $c94d5c73a827ca9b$var$j, t));
            }
        },
        {
            key: "seedToExtendedKey",
            value: function seedToExtendedKey(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                var r = $c94d5c73a827ca9b$var$i.masterKeysFromSeed(e), s = (0, $j2rU8.arrayify)(t ? $c94d5c73a827ca9b$var$D : $c94d5c73a827ca9b$var$z), o = "0x00", c = "0x00000000", f = "0x00000000", w = r.slice(32), a = r.slice(0, 32), h = (0, $j2rU8.concat)([
                    s,
                    o,
                    c,
                    f,
                    w,
                    (0, $j2rU8.concat)([
                        "0x00",
                        a
                    ])
                ]), l = (0, $j2rU8.hexDataSlice)((0, $7WUQV.sha256)((0, $7WUQV.sha256)(h)), 0, 4);
                return (0, $ebtr5.Base58).encode((0, $j2rU8.concat)([
                    h,
                    l
                ]));
            }
        },
        {
            key: "generate",
            value: function generate() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 32, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                var r = t ? (0, $7WUQV.sha256)((0, $j2rU8.concat)([
                    (0, $2URXt.randomBytes)(e),
                    (0, $j2rU8.arrayify)(t)
                ])) : (0, $2URXt.randomBytes)(e);
                return $c94d5c73a827ca9b$var$i.entropyToMnemonic(r);
            }
        }
    ]);
    return i1;
}(), $c94d5c73a827ca9b$export$93018d515d60db37 = $c94d5c73a827ca9b$var$i;

});
parcelRequire.register("sPv0i", function(module, exports) {

$parcel$export(module.exports, "english", function () { return $dff4d4a01007fc5a$export$33e6c23ebe2ee669; });
var $dff4d4a01007fc5a$export$33e6c23ebe2ee669 = [
    "abandon",
    "ability",
    "able",
    "about",
    "above",
    "absent",
    "absorb",
    "abstract",
    "absurd",
    "abuse",
    "access",
    "accident",
    "account",
    "accuse",
    "achieve",
    "acid",
    "acoustic",
    "acquire",
    "across",
    "act",
    "action",
    "actor",
    "actress",
    "actual",
    "adapt",
    "add",
    "addict",
    "address",
    "adjust",
    "admit",
    "adult",
    "advance",
    "advice",
    "aerobic",
    "affair",
    "afford",
    "afraid",
    "again",
    "age",
    "agent",
    "agree",
    "ahead",
    "aim",
    "air",
    "airport",
    "aisle",
    "alarm",
    "album",
    "alcohol",
    "alert",
    "alien",
    "all",
    "alley",
    "allow",
    "almost",
    "alone",
    "alpha",
    "already",
    "also",
    "alter",
    "always",
    "amateur",
    "amazing",
    "among",
    "amount",
    "amused",
    "analyst",
    "anchor",
    "ancient",
    "anger",
    "angle",
    "angry",
    "animal",
    "ankle",
    "announce",
    "annual",
    "another",
    "answer",
    "antenna",
    "antique",
    "anxiety",
    "any",
    "apart",
    "apology",
    "appear",
    "apple",
    "approve",
    "april",
    "arch",
    "arctic",
    "area",
    "arena",
    "argue",
    "arm",
    "armed",
    "armor",
    "army",
    "around",
    "arrange",
    "arrest",
    "arrive",
    "arrow",
    "art",
    "artefact",
    "artist",
    "artwork",
    "ask",
    "aspect",
    "assault",
    "asset",
    "assist",
    "assume",
    "asthma",
    "athlete",
    "atom",
    "attack",
    "attend",
    "attitude",
    "attract",
    "auction",
    "audit",
    "august",
    "aunt",
    "author",
    "auto",
    "autumn",
    "average",
    "avocado",
    "avoid",
    "awake",
    "aware",
    "away",
    "awesome",
    "awful",
    "awkward",
    "axis",
    "baby",
    "bachelor",
    "bacon",
    "badge",
    "bag",
    "balance",
    "balcony",
    "ball",
    "bamboo",
    "banana",
    "banner",
    "bar",
    "barely",
    "bargain",
    "barrel",
    "base",
    "basic",
    "basket",
    "battle",
    "beach",
    "bean",
    "beauty",
    "because",
    "become",
    "beef",
    "before",
    "begin",
    "behave",
    "behind",
    "believe",
    "below",
    "belt",
    "bench",
    "benefit",
    "best",
    "betray",
    "better",
    "between",
    "beyond",
    "bicycle",
    "bid",
    "bike",
    "bind",
    "biology",
    "bird",
    "birth",
    "bitter",
    "black",
    "blade",
    "blame",
    "blanket",
    "blast",
    "bleak",
    "bless",
    "blind",
    "blood",
    "blossom",
    "blouse",
    "blue",
    "blur",
    "blush",
    "board",
    "boat",
    "body",
    "boil",
    "bomb",
    "bone",
    "bonus",
    "book",
    "boost",
    "border",
    "boring",
    "borrow",
    "boss",
    "bottom",
    "bounce",
    "box",
    "boy",
    "bracket",
    "brain",
    "brand",
    "brass",
    "brave",
    "bread",
    "breeze",
    "brick",
    "bridge",
    "brief",
    "bright",
    "bring",
    "brisk",
    "broccoli",
    "broken",
    "bronze",
    "broom",
    "brother",
    "brown",
    "brush",
    "bubble",
    "buddy",
    "budget",
    "buffalo",
    "build",
    "bulb",
    "bulk",
    "bullet",
    "bundle",
    "bunker",
    "burden",
    "burger",
    "burst",
    "bus",
    "business",
    "busy",
    "butter",
    "buyer",
    "buzz",
    "cabbage",
    "cabin",
    "cable",
    "cactus",
    "cage",
    "cake",
    "call",
    "calm",
    "camera",
    "camp",
    "can",
    "canal",
    "cancel",
    "candy",
    "cannon",
    "canoe",
    "canvas",
    "canyon",
    "capable",
    "capital",
    "captain",
    "car",
    "carbon",
    "card",
    "cargo",
    "carpet",
    "carry",
    "cart",
    "case",
    "cash",
    "casino",
    "castle",
    "casual",
    "cat",
    "catalog",
    "catch",
    "category",
    "cattle",
    "caught",
    "cause",
    "caution",
    "cave",
    "ceiling",
    "celery",
    "cement",
    "census",
    "century",
    "cereal",
    "certain",
    "chair",
    "chalk",
    "champion",
    "change",
    "chaos",
    "chapter",
    "charge",
    "chase",
    "chat",
    "cheap",
    "check",
    "cheese",
    "chef",
    "cherry",
    "chest",
    "chicken",
    "chief",
    "child",
    "chimney",
    "choice",
    "choose",
    "chronic",
    "chuckle",
    "chunk",
    "churn",
    "cigar",
    "cinnamon",
    "circle",
    "citizen",
    "city",
    "civil",
    "claim",
    "clap",
    "clarify",
    "claw",
    "clay",
    "clean",
    "clerk",
    "clever",
    "click",
    "client",
    "cliff",
    "climb",
    "clinic",
    "clip",
    "clock",
    "clog",
    "close",
    "cloth",
    "cloud",
    "clown",
    "club",
    "clump",
    "cluster",
    "clutch",
    "coach",
    "coast",
    "coconut",
    "code",
    "coffee",
    "coil",
    "coin",
    "collect",
    "color",
    "column",
    "combine",
    "come",
    "comfort",
    "comic",
    "common",
    "company",
    "concert",
    "conduct",
    "confirm",
    "congress",
    "connect",
    "consider",
    "control",
    "convince",
    "cook",
    "cool",
    "copper",
    "copy",
    "coral",
    "core",
    "corn",
    "correct",
    "cost",
    "cotton",
    "couch",
    "country",
    "couple",
    "course",
    "cousin",
    "cover",
    "coyote",
    "crack",
    "cradle",
    "craft",
    "cram",
    "crane",
    "crash",
    "crater",
    "crawl",
    "crazy",
    "cream",
    "credit",
    "creek",
    "crew",
    "cricket",
    "crime",
    "crisp",
    "critic",
    "crop",
    "cross",
    "crouch",
    "crowd",
    "crucial",
    "cruel",
    "cruise",
    "crumble",
    "crunch",
    "crush",
    "cry",
    "crystal",
    "cube",
    "culture",
    "cup",
    "cupboard",
    "curious",
    "current",
    "curtain",
    "curve",
    "cushion",
    "custom",
    "cute",
    "cycle",
    "dad",
    "damage",
    "damp",
    "dance",
    "danger",
    "daring",
    "dash",
    "daughter",
    "dawn",
    "day",
    "deal",
    "debate",
    "debris",
    "decade",
    "december",
    "decide",
    "decline",
    "decorate",
    "decrease",
    "deer",
    "defense",
    "define",
    "defy",
    "degree",
    "delay",
    "deliver",
    "demand",
    "demise",
    "denial",
    "dentist",
    "deny",
    "depart",
    "depend",
    "deposit",
    "depth",
    "deputy",
    "derive",
    "describe",
    "desert",
    "design",
    "desk",
    "despair",
    "destroy",
    "detail",
    "detect",
    "develop",
    "device",
    "devote",
    "diagram",
    "dial",
    "diamond",
    "diary",
    "dice",
    "diesel",
    "diet",
    "differ",
    "digital",
    "dignity",
    "dilemma",
    "dinner",
    "dinosaur",
    "direct",
    "dirt",
    "disagree",
    "discover",
    "disease",
    "dish",
    "dismiss",
    "disorder",
    "display",
    "distance",
    "divert",
    "divide",
    "divorce",
    "dizzy",
    "doctor",
    "document",
    "dog",
    "doll",
    "dolphin",
    "domain",
    "donate",
    "donkey",
    "donor",
    "door",
    "dose",
    "double",
    "dove",
    "draft",
    "dragon",
    "drama",
    "drastic",
    "draw",
    "dream",
    "dress",
    "drift",
    "drill",
    "drink",
    "drip",
    "drive",
    "drop",
    "drum",
    "dry",
    "duck",
    "dumb",
    "dune",
    "during",
    "dust",
    "dutch",
    "duty",
    "dwarf",
    "dynamic",
    "eager",
    "eagle",
    "early",
    "earn",
    "earth",
    "easily",
    "east",
    "easy",
    "echo",
    "ecology",
    "economy",
    "edge",
    "edit",
    "educate",
    "effort",
    "egg",
    "eight",
    "either",
    "elbow",
    "elder",
    "electric",
    "elegant",
    "element",
    "elephant",
    "elevator",
    "elite",
    "else",
    "embark",
    "embody",
    "embrace",
    "emerge",
    "emotion",
    "employ",
    "empower",
    "empty",
    "enable",
    "enact",
    "end",
    "endless",
    "endorse",
    "enemy",
    "energy",
    "enforce",
    "engage",
    "engine",
    "enhance",
    "enjoy",
    "enlist",
    "enough",
    "enrich",
    "enroll",
    "ensure",
    "enter",
    "entire",
    "entry",
    "envelope",
    "episode",
    "equal",
    "equip",
    "era",
    "erase",
    "erode",
    "erosion",
    "error",
    "erupt",
    "escape",
    "essay",
    "essence",
    "estate",
    "eternal",
    "ethics",
    "evidence",
    "evil",
    "evoke",
    "evolve",
    "exact",
    "example",
    "excess",
    "exchange",
    "excite",
    "exclude",
    "excuse",
    "execute",
    "exercise",
    "exhaust",
    "exhibit",
    "exile",
    "exist",
    "exit",
    "exotic",
    "expand",
    "expect",
    "expire",
    "explain",
    "expose",
    "express",
    "extend",
    "extra",
    "eye",
    "eyebrow",
    "fabric",
    "face",
    "faculty",
    "fade",
    "faint",
    "faith",
    "fall",
    "false",
    "fame",
    "family",
    "famous",
    "fan",
    "fancy",
    "fantasy",
    "farm",
    "fashion",
    "fat",
    "fatal",
    "father",
    "fatigue",
    "fault",
    "favorite",
    "feature",
    "february",
    "federal",
    "fee",
    "feed",
    "feel",
    "female",
    "fence",
    "festival",
    "fetch",
    "fever",
    "few",
    "fiber",
    "fiction",
    "field",
    "figure",
    "file",
    "film",
    "filter",
    "final",
    "find",
    "fine",
    "finger",
    "finish",
    "fire",
    "firm",
    "first",
    "fiscal",
    "fish",
    "fit",
    "fitness",
    "fix",
    "flag",
    "flame",
    "flash",
    "flat",
    "flavor",
    "flee",
    "flight",
    "flip",
    "float",
    "flock",
    "floor",
    "flower",
    "fluid",
    "flush",
    "fly",
    "foam",
    "focus",
    "fog",
    "foil",
    "fold",
    "follow",
    "food",
    "foot",
    "force",
    "forest",
    "forget",
    "fork",
    "fortune",
    "forum",
    "forward",
    "fossil",
    "foster",
    "found",
    "fox",
    "fragile",
    "frame",
    "frequent",
    "fresh",
    "friend",
    "fringe",
    "frog",
    "front",
    "frost",
    "frown",
    "frozen",
    "fruit",
    "fuel",
    "fun",
    "funny",
    "furnace",
    "fury",
    "future",
    "gadget",
    "gain",
    "galaxy",
    "gallery",
    "game",
    "gap",
    "garage",
    "garbage",
    "garden",
    "garlic",
    "garment",
    "gas",
    "gasp",
    "gate",
    "gather",
    "gauge",
    "gaze",
    "general",
    "genius",
    "genre",
    "gentle",
    "genuine",
    "gesture",
    "ghost",
    "giant",
    "gift",
    "giggle",
    "ginger",
    "giraffe",
    "girl",
    "give",
    "glad",
    "glance",
    "glare",
    "glass",
    "glide",
    "glimpse",
    "globe",
    "gloom",
    "glory",
    "glove",
    "glow",
    "glue",
    "goat",
    "goddess",
    "gold",
    "good",
    "goose",
    "gorilla",
    "gospel",
    "gossip",
    "govern",
    "gown",
    "grab",
    "grace",
    "grain",
    "grant",
    "grape",
    "grass",
    "gravity",
    "great",
    "green",
    "grid",
    "grief",
    "grit",
    "grocery",
    "group",
    "grow",
    "grunt",
    "guard",
    "guess",
    "guide",
    "guilt",
    "guitar",
    "gun",
    "gym",
    "habit",
    "hair",
    "half",
    "hammer",
    "hamster",
    "hand",
    "happy",
    "harbor",
    "hard",
    "harsh",
    "harvest",
    "hat",
    "have",
    "hawk",
    "hazard",
    "head",
    "health",
    "heart",
    "heavy",
    "hedgehog",
    "height",
    "hello",
    "helmet",
    "help",
    "hen",
    "hero",
    "hidden",
    "high",
    "hill",
    "hint",
    "hip",
    "hire",
    "history",
    "hobby",
    "hockey",
    "hold",
    "hole",
    "holiday",
    "hollow",
    "home",
    "honey",
    "hood",
    "hope",
    "horn",
    "horror",
    "horse",
    "hospital",
    "host",
    "hotel",
    "hour",
    "hover",
    "hub",
    "huge",
    "human",
    "humble",
    "humor",
    "hundred",
    "hungry",
    "hunt",
    "hurdle",
    "hurry",
    "hurt",
    "husband",
    "hybrid",
    "ice",
    "icon",
    "idea",
    "identify",
    "idle",
    "ignore",
    "ill",
    "illegal",
    "illness",
    "image",
    "imitate",
    "immense",
    "immune",
    "impact",
    "impose",
    "improve",
    "impulse",
    "inch",
    "include",
    "income",
    "increase",
    "index",
    "indicate",
    "indoor",
    "industry",
    "infant",
    "inflict",
    "inform",
    "inhale",
    "inherit",
    "initial",
    "inject",
    "injury",
    "inmate",
    "inner",
    "innocent",
    "input",
    "inquiry",
    "insane",
    "insect",
    "inside",
    "inspire",
    "install",
    "intact",
    "interest",
    "into",
    "invest",
    "invite",
    "involve",
    "iron",
    "island",
    "isolate",
    "issue",
    "item",
    "ivory",
    "jacket",
    "jaguar",
    "jar",
    "jazz",
    "jealous",
    "jeans",
    "jelly",
    "jewel",
    "job",
    "join",
    "joke",
    "journey",
    "joy",
    "judge",
    "juice",
    "jump",
    "jungle",
    "junior",
    "junk",
    "just",
    "kangaroo",
    "keen",
    "keep",
    "ketchup",
    "key",
    "kick",
    "kid",
    "kidney",
    "kind",
    "kingdom",
    "kiss",
    "kit",
    "kitchen",
    "kite",
    "kitten",
    "kiwi",
    "knee",
    "knife",
    "knock",
    "know",
    "lab",
    "label",
    "labor",
    "ladder",
    "lady",
    "lake",
    "lamp",
    "language",
    "laptop",
    "large",
    "later",
    "latin",
    "laugh",
    "laundry",
    "lava",
    "law",
    "lawn",
    "lawsuit",
    "layer",
    "lazy",
    "leader",
    "leaf",
    "learn",
    "leave",
    "lecture",
    "left",
    "leg",
    "legal",
    "legend",
    "leisure",
    "lemon",
    "lend",
    "length",
    "lens",
    "leopard",
    "lesson",
    "letter",
    "level",
    "liar",
    "liberty",
    "library",
    "license",
    "life",
    "lift",
    "light",
    "like",
    "limb",
    "limit",
    "link",
    "lion",
    "liquid",
    "list",
    "little",
    "live",
    "lizard",
    "load",
    "loan",
    "lobster",
    "local",
    "lock",
    "logic",
    "lonely",
    "long",
    "loop",
    "lottery",
    "loud",
    "lounge",
    "love",
    "loyal",
    "lucky",
    "luggage",
    "lumber",
    "lunar",
    "lunch",
    "luxury",
    "lyrics",
    "machine",
    "mad",
    "magic",
    "magnet",
    "maid",
    "mail",
    "main",
    "major",
    "make",
    "mammal",
    "man",
    "manage",
    "mandate",
    "mango",
    "mansion",
    "manual",
    "maple",
    "marble",
    "march",
    "margin",
    "marine",
    "market",
    "marriage",
    "mask",
    "mass",
    "master",
    "match",
    "material",
    "math",
    "matrix",
    "matter",
    "maximum",
    "maze",
    "meadow",
    "mean",
    "measure",
    "meat",
    "mechanic",
    "medal",
    "media",
    "melody",
    "melt",
    "member",
    "memory",
    "mention",
    "menu",
    "mercy",
    "merge",
    "merit",
    "merry",
    "mesh",
    "message",
    "metal",
    "method",
    "middle",
    "midnight",
    "milk",
    "million",
    "mimic",
    "mind",
    "minimum",
    "minor",
    "minute",
    "miracle",
    "mirror",
    "misery",
    "miss",
    "mistake",
    "mix",
    "mixed",
    "mixture",
    "mobile",
    "model",
    "modify",
    "mom",
    "moment",
    "monitor",
    "monkey",
    "monster",
    "month",
    "moon",
    "moral",
    "more",
    "morning",
    "mosquito",
    "mother",
    "motion",
    "motor",
    "mountain",
    "mouse",
    "move",
    "movie",
    "much",
    "muffin",
    "mule",
    "multiply",
    "muscle",
    "museum",
    "mushroom",
    "music",
    "must",
    "mutual",
    "myself",
    "mystery",
    "myth",
    "naive",
    "name",
    "napkin",
    "narrow",
    "nasty",
    "nation",
    "nature",
    "near",
    "neck",
    "need",
    "negative",
    "neglect",
    "neither",
    "nephew",
    "nerve",
    "nest",
    "net",
    "network",
    "neutral",
    "never",
    "news",
    "next",
    "nice",
    "night",
    "noble",
    "noise",
    "nominee",
    "noodle",
    "normal",
    "north",
    "nose",
    "notable",
    "note",
    "nothing",
    "notice",
    "novel",
    "now",
    "nuclear",
    "number",
    "nurse",
    "nut",
    "oak",
    "obey",
    "object",
    "oblige",
    "obscure",
    "observe",
    "obtain",
    "obvious",
    "occur",
    "ocean",
    "october",
    "odor",
    "off",
    "offer",
    "office",
    "often",
    "oil",
    "okay",
    "old",
    "olive",
    "olympic",
    "omit",
    "once",
    "one",
    "onion",
    "online",
    "only",
    "open",
    "opera",
    "opinion",
    "oppose",
    "option",
    "orange",
    "orbit",
    "orchard",
    "order",
    "ordinary",
    "organ",
    "orient",
    "original",
    "orphan",
    "ostrich",
    "other",
    "outdoor",
    "outer",
    "output",
    "outside",
    "oval",
    "oven",
    "over",
    "own",
    "owner",
    "oxygen",
    "oyster",
    "ozone",
    "pact",
    "paddle",
    "page",
    "pair",
    "palace",
    "palm",
    "panda",
    "panel",
    "panic",
    "panther",
    "paper",
    "parade",
    "parent",
    "park",
    "parrot",
    "party",
    "pass",
    "patch",
    "path",
    "patient",
    "patrol",
    "pattern",
    "pause",
    "pave",
    "payment",
    "peace",
    "peanut",
    "pear",
    "peasant",
    "pelican",
    "pen",
    "penalty",
    "pencil",
    "people",
    "pepper",
    "perfect",
    "permit",
    "person",
    "pet",
    "phone",
    "photo",
    "phrase",
    "physical",
    "piano",
    "picnic",
    "picture",
    "piece",
    "pig",
    "pigeon",
    "pill",
    "pilot",
    "pink",
    "pioneer",
    "pipe",
    "pistol",
    "pitch",
    "pizza",
    "place",
    "planet",
    "plastic",
    "plate",
    "play",
    "please",
    "pledge",
    "pluck",
    "plug",
    "plunge",
    "poem",
    "poet",
    "point",
    "polar",
    "pole",
    "police",
    "pond",
    "pony",
    "pool",
    "popular",
    "portion",
    "position",
    "possible",
    "post",
    "potato",
    "pottery",
    "poverty",
    "powder",
    "power",
    "practice",
    "praise",
    "predict",
    "prefer",
    "prepare",
    "present",
    "pretty",
    "prevent",
    "price",
    "pride",
    "primary",
    "print",
    "priority",
    "prison",
    "private",
    "prize",
    "problem",
    "process",
    "produce",
    "profit",
    "program",
    "project",
    "promote",
    "proof",
    "property",
    "prosper",
    "protect",
    "proud",
    "provide",
    "public",
    "pudding",
    "pull",
    "pulp",
    "pulse",
    "pumpkin",
    "punch",
    "pupil",
    "puppy",
    "purchase",
    "purity",
    "purpose",
    "purse",
    "push",
    "put",
    "puzzle",
    "pyramid",
    "quality",
    "quantum",
    "quarter",
    "question",
    "quick",
    "quit",
    "quiz",
    "quote",
    "rabbit",
    "raccoon",
    "race",
    "rack",
    "radar",
    "radio",
    "rail",
    "rain",
    "raise",
    "rally",
    "ramp",
    "ranch",
    "random",
    "range",
    "rapid",
    "rare",
    "rate",
    "rather",
    "raven",
    "raw",
    "razor",
    "ready",
    "real",
    "reason",
    "rebel",
    "rebuild",
    "recall",
    "receive",
    "recipe",
    "record",
    "recycle",
    "reduce",
    "reflect",
    "reform",
    "refuse",
    "region",
    "regret",
    "regular",
    "reject",
    "relax",
    "release",
    "relief",
    "rely",
    "remain",
    "remember",
    "remind",
    "remove",
    "render",
    "renew",
    "rent",
    "reopen",
    "repair",
    "repeat",
    "replace",
    "report",
    "require",
    "rescue",
    "resemble",
    "resist",
    "resource",
    "response",
    "result",
    "retire",
    "retreat",
    "return",
    "reunion",
    "reveal",
    "review",
    "reward",
    "rhythm",
    "rib",
    "ribbon",
    "rice",
    "rich",
    "ride",
    "ridge",
    "rifle",
    "right",
    "rigid",
    "ring",
    "riot",
    "ripple",
    "risk",
    "ritual",
    "rival",
    "river",
    "road",
    "roast",
    "robot",
    "robust",
    "rocket",
    "romance",
    "roof",
    "rookie",
    "room",
    "rose",
    "rotate",
    "rough",
    "round",
    "route",
    "royal",
    "rubber",
    "rude",
    "rug",
    "rule",
    "run",
    "runway",
    "rural",
    "sad",
    "saddle",
    "sadness",
    "safe",
    "sail",
    "salad",
    "salmon",
    "salon",
    "salt",
    "salute",
    "same",
    "sample",
    "sand",
    "satisfy",
    "satoshi",
    "sauce",
    "sausage",
    "save",
    "say",
    "scale",
    "scan",
    "scare",
    "scatter",
    "scene",
    "scheme",
    "school",
    "science",
    "scissors",
    "scorpion",
    "scout",
    "scrap",
    "screen",
    "script",
    "scrub",
    "sea",
    "search",
    "season",
    "seat",
    "second",
    "secret",
    "section",
    "security",
    "seed",
    "seek",
    "segment",
    "select",
    "sell",
    "seminar",
    "senior",
    "sense",
    "sentence",
    "series",
    "service",
    "session",
    "settle",
    "setup",
    "seven",
    "shadow",
    "shaft",
    "shallow",
    "share",
    "shed",
    "shell",
    "sheriff",
    "shield",
    "shift",
    "shine",
    "ship",
    "shiver",
    "shock",
    "shoe",
    "shoot",
    "shop",
    "short",
    "shoulder",
    "shove",
    "shrimp",
    "shrug",
    "shuffle",
    "shy",
    "sibling",
    "sick",
    "side",
    "siege",
    "sight",
    "sign",
    "silent",
    "silk",
    "silly",
    "silver",
    "similar",
    "simple",
    "since",
    "sing",
    "siren",
    "sister",
    "situate",
    "six",
    "size",
    "skate",
    "sketch",
    "ski",
    "skill",
    "skin",
    "skirt",
    "skull",
    "slab",
    "slam",
    "sleep",
    "slender",
    "slice",
    "slide",
    "slight",
    "slim",
    "slogan",
    "slot",
    "slow",
    "slush",
    "small",
    "smart",
    "smile",
    "smoke",
    "smooth",
    "snack",
    "snake",
    "snap",
    "sniff",
    "snow",
    "soap",
    "soccer",
    "social",
    "sock",
    "soda",
    "soft",
    "solar",
    "soldier",
    "solid",
    "solution",
    "solve",
    "someone",
    "song",
    "soon",
    "sorry",
    "sort",
    "soul",
    "sound",
    "soup",
    "source",
    "south",
    "space",
    "spare",
    "spatial",
    "spawn",
    "speak",
    "special",
    "speed",
    "spell",
    "spend",
    "sphere",
    "spice",
    "spider",
    "spike",
    "spin",
    "spirit",
    "split",
    "spoil",
    "sponsor",
    "spoon",
    "sport",
    "spot",
    "spray",
    "spread",
    "spring",
    "spy",
    "square",
    "squeeze",
    "squirrel",
    "stable",
    "stadium",
    "staff",
    "stage",
    "stairs",
    "stamp",
    "stand",
    "start",
    "state",
    "stay",
    "steak",
    "steel",
    "stem",
    "step",
    "stereo",
    "stick",
    "still",
    "sting",
    "stock",
    "stomach",
    "stone",
    "stool",
    "story",
    "stove",
    "strategy",
    "street",
    "strike",
    "strong",
    "struggle",
    "student",
    "stuff",
    "stumble",
    "style",
    "subject",
    "submit",
    "subway",
    "success",
    "such",
    "sudden",
    "suffer",
    "sugar",
    "suggest",
    "suit",
    "summer",
    "sun",
    "sunny",
    "sunset",
    "super",
    "supply",
    "supreme",
    "sure",
    "surface",
    "surge",
    "surprise",
    "surround",
    "survey",
    "suspect",
    "sustain",
    "swallow",
    "swamp",
    "swap",
    "swarm",
    "swear",
    "sweet",
    "swift",
    "swim",
    "swing",
    "switch",
    "sword",
    "symbol",
    "symptom",
    "syrup",
    "system",
    "table",
    "tackle",
    "tag",
    "tail",
    "talent",
    "talk",
    "tank",
    "tape",
    "target",
    "task",
    "taste",
    "tattoo",
    "taxi",
    "teach",
    "team",
    "tell",
    "ten",
    "tenant",
    "tennis",
    "tent",
    "term",
    "test",
    "text",
    "thank",
    "that",
    "theme",
    "then",
    "theory",
    "there",
    "they",
    "thing",
    "this",
    "thought",
    "three",
    "thrive",
    "throw",
    "thumb",
    "thunder",
    "ticket",
    "tide",
    "tiger",
    "tilt",
    "timber",
    "time",
    "tiny",
    "tip",
    "tired",
    "tissue",
    "title",
    "toast",
    "tobacco",
    "today",
    "toddler",
    "toe",
    "together",
    "toilet",
    "token",
    "tomato",
    "tomorrow",
    "tone",
    "tongue",
    "tonight",
    "tool",
    "tooth",
    "top",
    "topic",
    "topple",
    "torch",
    "tornado",
    "tortoise",
    "toss",
    "total",
    "tourist",
    "toward",
    "tower",
    "town",
    "toy",
    "track",
    "trade",
    "traffic",
    "tragic",
    "train",
    "transfer",
    "trap",
    "trash",
    "travel",
    "tray",
    "treat",
    "tree",
    "trend",
    "trial",
    "tribe",
    "trick",
    "trigger",
    "trim",
    "trip",
    "trophy",
    "trouble",
    "truck",
    "true",
    "truly",
    "trumpet",
    "trust",
    "truth",
    "try",
    "tube",
    "tuition",
    "tumble",
    "tuna",
    "tunnel",
    "turkey",
    "turn",
    "turtle",
    "twelve",
    "twenty",
    "twice",
    "twin",
    "twist",
    "two",
    "type",
    "typical",
    "ugly",
    "umbrella",
    "unable",
    "unaware",
    "uncle",
    "uncover",
    "under",
    "undo",
    "unfair",
    "unfold",
    "unhappy",
    "uniform",
    "unique",
    "unit",
    "universe",
    "unknown",
    "unlock",
    "until",
    "unusual",
    "unveil",
    "update",
    "upgrade",
    "uphold",
    "upon",
    "upper",
    "upset",
    "urban",
    "urge",
    "usage",
    "use",
    "used",
    "useful",
    "useless",
    "usual",
    "utility",
    "vacant",
    "vacuum",
    "vague",
    "valid",
    "valley",
    "valve",
    "van",
    "vanish",
    "vapor",
    "various",
    "vast",
    "vault",
    "vehicle",
    "velvet",
    "vendor",
    "venture",
    "venue",
    "verb",
    "verify",
    "version",
    "very",
    "vessel",
    "veteran",
    "viable",
    "vibrant",
    "vicious",
    "victory",
    "video",
    "view",
    "village",
    "vintage",
    "violin",
    "virtual",
    "virus",
    "visa",
    "visit",
    "visual",
    "vital",
    "vivid",
    "vocal",
    "voice",
    "void",
    "volcano",
    "volume",
    "vote",
    "voyage",
    "wage",
    "wagon",
    "wait",
    "walk",
    "wall",
    "walnut",
    "want",
    "warfare",
    "warm",
    "warrior",
    "wash",
    "wasp",
    "waste",
    "water",
    "wave",
    "way",
    "wealth",
    "weapon",
    "wear",
    "weasel",
    "weather",
    "web",
    "wedding",
    "weekend",
    "weird",
    "welcome",
    "west",
    "wet",
    "whale",
    "what",
    "wheat",
    "wheel",
    "when",
    "where",
    "whip",
    "whisper",
    "wide",
    "width",
    "wife",
    "wild",
    "will",
    "win",
    "window",
    "wine",
    "wing",
    "wink",
    "winner",
    "winter",
    "wire",
    "wisdom",
    "wise",
    "wish",
    "witness",
    "wolf",
    "woman",
    "wonder",
    "wood",
    "wool",
    "word",
    "work",
    "world",
    "worry",
    "worth",
    "wrap",
    "wreck",
    "wrestle",
    "wrist",
    "write",
    "wrong",
    "yard",
    "year",
    "yellow",
    "you",
    "young",
    "youth",
    "zebra",
    "zero",
    "zone",
    "zoo"
];
var $dff4d4a01007fc5a$export$ce4fe1c9e6520c1a = function(e) {
    return e.english = "english", e;
}($dff4d4a01007fc5a$export$ce4fe1c9e6520c1a || {});

});





parcelRequire.register("hjyqB", function(module, exports) {

var $3vWwE = parcelRequire("3vWwE");

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $ftJVG = parcelRequire("ftJVG");

var $ho5gk = parcelRequire("ho5gk");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $j2rU8 = parcelRequire("j2rU8");

var $2cJiB = parcelRequire("2cJiB");

var $dktpY = parcelRequire("dktpY");

var $5u9Jw = parcelRequire("5u9Jw");
var $56d68f4b4a3d890b$var$r = /*#__PURE__*/ function(m) {
    "use strict";
    (0, $ftJVG._)(r, m);
    var _super = (0, $6OZAO._)(r);
    function r() {
        (0, $978gY._)(this, r);
        var _this;
        _this = _super.apply(this, arguments);
        (0, $dxWQo._)((0, $3vWwE._)(_this), "scriptRequest", void 0);
        return _this;
    }
    (0, $kry2a._)(r, [
        {
            key: "updateScriptRequest",
            value: function updateScriptRequest() {
                this.scriptRequest || this.buildScriptRequest(), this.transactionRequest.setScript(this.scriptRequest, this.args);
            }
        },
        {
            key: "buildScriptRequest",
            value: function buildScriptRequest() {
                var _this = this;
                this.scriptRequest = new (0, $5u9Jw.ScriptRequest)(this.program.bytes, function(t) {
                    return _this.func.encodeArguments(t);
                }, function() {
                    return [];
                });
            }
        },
        {
            key: "call",
            value: function call(t) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var s, e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $5u9Jw.assert)(_this.program.account, "Provider is required!");
                                return [
                                    4,
                                    _this.getTransactionRequest(t)
                                ];
                            case 1:
                                s = _state.sent();
                                return [
                                    4,
                                    _this.program.account.sendTransaction(s)
                                ];
                            case 2:
                                e = _state.sent();
                                return [
                                    2,
                                    (0, $5u9Jw.FunctionInvocationResult).build(_this, e, !1, _this.program)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return r;
}((0, $5u9Jw.FunctionInvocationScope));
var $56d68f4b4a3d890b$export$2f8b47a141e57afc = /*#__PURE__*/ function(T) {
    "use strict";
    (0, $ftJVG._)(o, T);
    var _super = (0, $6OZAO._)(o);
    function o(t, s, e) {
        (0, $978gY._)(this, o);
        var _this;
        var _temp;
        _temp = _this = _super.call(this), (0, $dxWQo._)((0, $3vWwE._)(_this), "bytes", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "interface", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "account", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "script", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "provider", void 0), (0, $dxWQo._)((0, $3vWwE._)(_this), "functions", void 0), _temp, _this.bytes = (0, $j2rU8.arrayify)(t), _this.interface = new (0, $2cJiB.Interface)(s), _this.provider = e.provider, _this.account = e, _this.functions = {
            main: function() {
                for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++){
                    p[_key] = arguments[_key];
                }
                return new $56d68f4b4a3d890b$var$r((0, $3vWwE._)(_this), _this.interface.getFunction("main"), p);
            }
        };
        return (0, $ho5gk._)(_this);
    }
    return o;
}((0, $dktpY.AbstractScript));
var $56d68f4b4a3d890b$export$640d343391073bbc = new (0, $5u9Jw.ScriptRequest)("0x24000000", function() {
    return new Uint8Array(0);
}, function() {});

});

parcelRequire.register("autKP", function(module, exports) {
var $4e71ba082cf14e95$export$25dad884da3f641e = 9, $4e71ba082cf14e95$export$504c8e20470f686b = 3, $4e71ba082cf14e95$export$a8188e50d333804c = 9;

});

parcelRequire.register("bNbBi", function(module, exports) {
var $9c8e3097c3183e8c$export$da47e94c878b69a1 = [
    "Success",
    "Revert",
    "OutOfGas",
    "TransactionValidity",
    "MemoryOverflow",
    "ArithmeticOverflow",
    "ContractNotFound",
    "MemoryOwnership",
    "NotEnoughBalance",
    "ExpectedInternalContext",
    "AssetIdNotFound",
    "InputNotFound",
    "OutputNotFound",
    "WitnessNotFound",
    "TransactionMaturity",
    "InvalidMetadataIdentifier",
    "MalformedCallStructure",
    "ReservedRegisterNotWritable",
    "ErrorFlag",
    "InvalidImmediateValue",
    "ExpectedCoinInput",
    "MaxMemoryAccess",
    "MemoryWriteOverlap",
    "ContractNotInInputs",
    "InternalBalanceOverflow",
    "ContractMaxSize",
    "ExpectedUnallocatedStack",
    "MaxStaticContractsReached",
    "TransferAmountCannotBeZero",
    "ExpectedOutputVariable",
    "ExpectedParentInternalContext",
    "IllegalJump",
    "NonZeroMessageOutputRecipient",
    "ZeroedMessageOutputRecipient"
], $9c8e3097c3183e8c$export$1fc4ce27a4eb20ea = "https://docs.rs/fuel-asm/latest/fuel_asm/enum.PanicReason.html";

});

parcelRequire.register("90LKV", function(module, exports) {
var $d09f85f47b09ec62$export$cdb75a303862019f = "http://127.0.0.1:4000/graphql";

});





parcelRequire.register("2WH9F", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
var $2252793b2f3a2298$var$__dirname = "node_modules/@redstone-finance/fuel-connector/dist/src/prices";
"use strict";
var $2252793b2f3a2298$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FuelPricesContractDeployer = void 0;

var $hlNxg = parcelRequire("hlNxg");

var $aqbQf = parcelRequire("aqbQf");

var $2252793b2f3a2298$var$path_1 = $2252793b2f3a2298$var$__importDefault((parcelRequire("eRvdF")));
parcelRequire("kmZ00");
var $j2rU8 = parcelRequire("j2rU8");
var $4x96T = parcelRequire("4x96T");
var $9vmss = parcelRequire("9vmss");

var $2TLZk = parcelRequire("2TLZk");

var $hjAGN = parcelRequire("hjAGN");
var $2252793b2f3a2298$var$PRICES_CONTRACT_BINARY = "../autogenerated/prices.bin";
var $2252793b2f3a2298$var$FuelPricesContractDeployer = /*#__PURE__*/ function(_FuelContractConnector_1_FuelContractConnector) {
    "use strict";
    (0, $ftJVG._)(FuelPricesContractDeployer, _FuelContractConnector_1_FuelContractConnector);
    var _super = (0, $6OZAO._)(FuelPricesContractDeployer);
    function FuelPricesContractDeployer(wallet, parameters) {
        (0, $978gY._)(this, FuelPricesContractDeployer);
        var _this;
        _this = _super.call(this, wallet);
        _this.parameters = parameters;
        return _this;
    }
    (0, $kry2a._)(FuelPricesContractDeployer, [
        {
            key: "getContract",
            value: function getContract() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.contract) return [
                                    2,
                                    _this.contract
                                ];
                                return [
                                    4,
                                    _this.deployPricesContract()
                                ];
                            case 1:
                                _this.contract = _state.sent();
                                return [
                                    2,
                                    _this.contract
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAdapter",
            value: function getAdapter() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _, _1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _1 = (_ = $2TLZk.FuelPricesContractAdapter).bind;
                                return [
                                    4,
                                    _this.getContract()
                                ];
                            case 1:
                                return [
                                    2,
                                    new (_1.apply(_, [
                                        void 0,
                                        _state.sent(),
                                        _this.getGasLimit()
                                    ]))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deployPricesContract",
            value: function deployPricesContract() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var bytecode, pricesPath, factory, storageSlots, options, contract;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.parameters.contractBinary
                                ];
                            case 1:
                                bytecode = _state.sent();
                                if (!bytecode) {
                                    pricesPath = $2252793b2f3a2298$var$path_1.default.join($2252793b2f3a2298$var$__dirname, $2252793b2f3a2298$var$PRICES_CONTRACT_BINARY);
                                    bytecode = (0, $aqbQf.readFileSync)(pricesPath);
                                }
                                factory = new $2252793b2f3a2298$var$PricesContractFactory(bytecode, $hlNxg.PricesAbi__factory.abi, _this.wallet, _this.getGasLimit());
                                storageSlots = _this.getStorageSlots();
                                options = {
                                    storageSlots: storageSlots
                                };
                                if (_this.parameters.salt) options["salt"] = _this.parameters.salt;
                                return [
                                    4,
                                    factory.deployContract(options)
                                ];
                            case 2:
                                contract = _state.sent();
                                return [
                                    4,
                                    contract.functions.init(_this.parameters.signers.map(function(signer) {
                                        return (0, $j2rU8.hexZeroPad)(signer, 32);
                                    }), _this.parameters.signerCountThreshold, 0).txParams({
                                        gasPrice: 1,
                                        gasLimit: _this.getGasLimit()
                                    }).call()
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    contract
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getStorageSlots",
            value: function getStorageSlots() {
                var FAKE_TIMESTAMP_KEY = "0x66616b655f74696d657374616d70"; // fake_timestamp
                var storageSlots = [];
                if (this.parameters != null) {
                    if (this.parameters.fakeTimestamp != null) storageSlots.push({
                        key: FAKE_TIMESTAMP_KEY,
                        value: (0, $j2rU8.hexlify)(this.parameters.fakeTimestamp)
                    });
                }
                return storageSlots.map(function(param) {
                    var key = param.key, value = param.value;
                    return {
                        key: (0, $j2rU8.hexZeroPad)(key, 32),
                        value: (0, $j2rU8.hexZeroPad)(value, 32)
                    };
                });
            }
        }
    ]);
    return FuelPricesContractDeployer;
}($hjAGN.FuelContractConnector);
module.exports.FuelPricesContractDeployer = $2252793b2f3a2298$var$FuelPricesContractDeployer;
var $2252793b2f3a2298$var$PricesContractFactory = /*#__PURE__*/ function(_fuels_1_ContractFactory) {
    "use strict";
    (0, $ftJVG._)(PricesContractFactory, _fuels_1_ContractFactory);
    var _super = (0, $6OZAO._)(PricesContractFactory);
    function PricesContractFactory(bytecode, abi, walletOrProvider, gasLimit) {
        (0, $978gY._)(this, PricesContractFactory);
        var _this;
        _this = _super.call(this, bytecode, abi, walletOrProvider);
        _this.gasLimit = gasLimit;
        return _this;
    }
    (0, $kry2a._)(PricesContractFactory, [
        {
            key: "createTransactionRequest",
            value: function createTransactionRequest(deployContractOptions) {
                var _get_call = (0, $3cct3._)((0, $g3d7z._)(PricesContractFactory.prototype), "createTransactionRequest", this).call(this, deployContractOptions), contractId = _get_call.contractId, transactionRequest = _get_call.transactionRequest;
                transactionRequest.gasLimit = new $4x96T.BN(this.gasLimit);
                transactionRequest.gasPrice = new $4x96T.BN(1);
                return {
                    contractId: contractId,
                    transactionRequest: transactionRequest
                };
            }
        }
    ]);
    return PricesContractFactory;
}($9vmss.ContractFactory);

});
parcelRequire.register("eRvdF", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $1ObTH = parcelRequire("1ObTH");

var $aqbQf = parcelRequire("aqbQf");
"use strict";
function $ad1e3b7171b5b1ff$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $ad1e3b7171b5b1ff$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $ad1e3b7171b5b1ff$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $ad1e3b7171b5b1ff$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $aqbQf.cwd();
                path = cwd;
            }
            $ad1e3b7171b5b1ff$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $ad1e3b7171b5b1ff$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $ad1e3b7171b5b1ff$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $ad1e3b7171b5b1ff$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $ad1e3b7171b5b1ff$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $ad1e3b7171b5b1ff$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $ad1e3b7171b5b1ff$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $ad1e3b7171b5b1ff$var$assertPath(from);
        $ad1e3b7171b5b1ff$var$assertPath(to);
        if (from === to) return "";
        from = $ad1e3b7171b5b1ff$var$posix.resolve(from);
        to = $ad1e3b7171b5b1ff$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $ad1e3b7171b5b1ff$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $ad1e3b7171b5b1ff$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $ad1e3b7171b5b1ff$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + (typeof pathObject === "undefined" ? "undefined" : (0, $1ObTH._)(pathObject)));
        return $ad1e3b7171b5b1ff$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $ad1e3b7171b5b1ff$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$ad1e3b7171b5b1ff$var$posix.posix = $ad1e3b7171b5b1ff$var$posix;
module.exports = $ad1e3b7171b5b1ff$var$posix;

});


parcelRequire.register("jWi6z", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e8417a5b9a2c7b50$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e8417a5b9a2c7b50$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e8417a5b9a2c7b50$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.safeSignVerify = module.exports.safeSign = module.exports.getMethodId = module.exports.base32Encode = module.exports.base32Decode = module.exports.crc32c = module.exports.crc16 = module.exports.fromNano = module.exports.toNano = module.exports.ComputeError = module.exports.openContract = module.exports.TupleBuilder = module.exports.TupleReader = module.exports.serializeTuple = module.exports.parseTuple = module.exports.exoticPruned = module.exports.exoticMerkleUpdate = module.exports.exoticMerkleProof = module.exports.Dictionary = module.exports.Cell = module.exports.CellType = module.exports.Slice = module.exports.beginCell = module.exports.Builder = module.exports.BitBuilder = module.exports.BitReader = module.exports.BitString = module.exports.contractAddress = module.exports.ADNLAddress = module.exports.ExternalAddress = module.exports.address = module.exports.Address = void 0;

var $gUPfK = parcelRequire("gUPfK");
Object.defineProperty(module.exports, "Address", {
    enumerable: true,
    get: function get() {
        return $gUPfK.Address;
    }
});
Object.defineProperty(module.exports, "address", {
    enumerable: true,
    get: function get() {
        return $gUPfK.address;
    }
});

var $jEXEj = parcelRequire("jEXEj");
Object.defineProperty(module.exports, "ExternalAddress", {
    enumerable: true,
    get: function get() {
        return $jEXEj.ExternalAddress;
    }
});

var $lb9hZ = parcelRequire("lb9hZ");
Object.defineProperty(module.exports, "ADNLAddress", {
    enumerable: true,
    get: function get() {
        return $lb9hZ.ADNLAddress;
    }
});

var $11EnC = parcelRequire("11EnC");
Object.defineProperty(module.exports, "contractAddress", {
    enumerable: true,
    get: function get() {
        return $11EnC.contractAddress;
    }
});

var $iSKta = parcelRequire("iSKta");
Object.defineProperty(module.exports, "BitString", {
    enumerable: true,
    get: function get() {
        return $iSKta.BitString;
    }
});

var $6RnAU = parcelRequire("6RnAU");
Object.defineProperty(module.exports, "BitReader", {
    enumerable: true,
    get: function get() {
        return $6RnAU.BitReader;
    }
});

var $iCiAY = parcelRequire("iCiAY");
Object.defineProperty(module.exports, "BitBuilder", {
    enumerable: true,
    get: function get() {
        return $iCiAY.BitBuilder;
    }
});

var $hARf4 = parcelRequire("hARf4");
Object.defineProperty(module.exports, "Builder", {
    enumerable: true,
    get: function get() {
        return $hARf4.Builder;
    }
});
Object.defineProperty(module.exports, "beginCell", {
    enumerable: true,
    get: function get() {
        return $hARf4.beginCell;
    }
});

var $aQ0oy = parcelRequire("aQ0oy");
Object.defineProperty(module.exports, "Slice", {
    enumerable: true,
    get: function get() {
        return $aQ0oy.Slice;
    }
});

var $d57eA = parcelRequire("d57eA");
Object.defineProperty(module.exports, "CellType", {
    enumerable: true,
    get: function get() {
        return $d57eA.CellType;
    }
});

var $KH51V = parcelRequire("KH51V");
Object.defineProperty(module.exports, "Cell", {
    enumerable: true,
    get: function get() {
        return $KH51V.Cell;
    }
});

var $ihDv0 = parcelRequire("ihDv0");
Object.defineProperty(module.exports, "Dictionary", {
    enumerable: true,
    get: function get() {
        return $ihDv0.Dictionary;
    }
});

var $1gFCA = parcelRequire("1gFCA");
Object.defineProperty(module.exports, "exoticMerkleProof", {
    enumerable: true,
    get: function get() {
        return $1gFCA.exoticMerkleProof;
    }
});

var $4VD0f = parcelRequire("4VD0f");
Object.defineProperty(module.exports, "exoticMerkleUpdate", {
    enumerable: true,
    get: function get() {
        return $4VD0f.exoticMerkleUpdate;
    }
});

var $ba2C3 = parcelRequire("ba2C3");
Object.defineProperty(module.exports, "exoticPruned", {
    enumerable: true,
    get: function get() {
        return $ba2C3.exoticPruned;
    }
});

var $a2rnx = parcelRequire("a2rnx");
Object.defineProperty(module.exports, "parseTuple", {
    enumerable: true,
    get: function get() {
        return $a2rnx.parseTuple;
    }
});
Object.defineProperty(module.exports, "serializeTuple", {
    enumerable: true,
    get: function get() {
        return $a2rnx.serializeTuple;
    }
});

var $hkXnX = parcelRequire("hkXnX");
Object.defineProperty(module.exports, "TupleReader", {
    enumerable: true,
    get: function get() {
        return $hkXnX.TupleReader;
    }
});

var $ghBQq = parcelRequire("ghBQq");
Object.defineProperty(module.exports, "TupleBuilder", {
    enumerable: true,
    get: function get() {
        return $ghBQq.TupleBuilder;
    }
});

// Types
$e8417a5b9a2c7b50$var$__exportStar((parcelRequire("1NjXW")), module.exports);

var $cPCMn = parcelRequire("cPCMn");
Object.defineProperty(module.exports, "openContract", {
    enumerable: true,
    get: function get() {
        return $cPCMn.openContract;
    }
});

var $fRaup = parcelRequire("fRaup");
Object.defineProperty(module.exports, "ComputeError", {
    enumerable: true,
    get: function get() {
        return $fRaup.ComputeError;
    }
});

var $inRmI = parcelRequire("inRmI");
Object.defineProperty(module.exports, "toNano", {
    enumerable: true,
    get: function get() {
        return $inRmI.toNano;
    }
});
Object.defineProperty(module.exports, "fromNano", {
    enumerable: true,
    get: function get() {
        return $inRmI.fromNano;
    }
});

var $edEE1 = parcelRequire("edEE1");
Object.defineProperty(module.exports, "crc16", {
    enumerable: true,
    get: function get() {
        return $edEE1.crc16;
    }
});

var $PYs4s = parcelRequire("PYs4s");
Object.defineProperty(module.exports, "crc32c", {
    enumerable: true,
    get: function get() {
        return $PYs4s.crc32c;
    }
});

var $atYB4 = parcelRequire("atYB4");
Object.defineProperty(module.exports, "base32Decode", {
    enumerable: true,
    get: function get() {
        return $atYB4.base32Decode;
    }
});
Object.defineProperty(module.exports, "base32Encode", {
    enumerable: true,
    get: function get() {
        return $atYB4.base32Encode;
    }
});

var $6LDD9 = parcelRequire("6LDD9");
Object.defineProperty(module.exports, "getMethodId", {
    enumerable: true,
    get: function get() {
        return $6LDD9.getMethodId;
    }
});

var $9qmBE = parcelRequire("9qmBE");
Object.defineProperty(module.exports, "safeSign", {
    enumerable: true,
    get: function get() {
        return $9qmBE.safeSign;
    }
});
Object.defineProperty(module.exports, "safeSignVerify", {
    enumerable: true,
    get: function get() {
        return $9qmBE.safeSignVerify;
    }
});

});
parcelRequire.register("gUPfK", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $gzLuY = parcelRequire("gzLuY");
var $c509a212d5c08318$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c509a212d5c08318$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $c509a212d5c08318$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.address = module.exports.Address = void 0;

var $c509a212d5c08318$var$symbol_inspect_1 = $c509a212d5c08318$var$__importDefault((parcelRequire("2LPl1")));

var $edEE1 = parcelRequire("edEE1");
var $c509a212d5c08318$var$bounceable_tag = 0x11;
var $c509a212d5c08318$var$non_bounceable_tag = 0x51;
var $c509a212d5c08318$var$test_flag = 0x80;
function $c509a212d5c08318$var$parseFriendlyAddress(src) {
    var data = $c509a212d5c08318$require$Buffer.isBuffer(src) ? src : $c509a212d5c08318$require$Buffer.from(src, "base64");
    // 1byte tag + 1byte workchain + 32 bytes hash + 2 byte crc
    if (data.length !== 36) throw new Error("Unknown address type: byte length is not equal to 36");
    // Prepare data
    var addr = data.subarray(0, 34);
    var crc = data.subarray(34, 36);
    var calcedCrc = (0, $edEE1.crc16)(addr);
    if (!(calcedCrc[0] === crc[0] && calcedCrc[1] === crc[1])) throw new Error("Invalid checksum: " + src);
    // Parse tag
    var tag = addr[0];
    var isTestOnly = false;
    var isBounceable = false;
    if (tag & $c509a212d5c08318$var$test_flag) {
        isTestOnly = true;
        tag = tag ^ $c509a212d5c08318$var$test_flag;
    }
    if (tag !== $c509a212d5c08318$var$bounceable_tag && tag !== $c509a212d5c08318$var$non_bounceable_tag) throw "Unknown address tag";
    isBounceable = tag === $c509a212d5c08318$var$bounceable_tag;
    var workchain = null;
    if (addr[1] === 0xff) workchain = -1;
    else workchain = addr[1];
    var hashPart = addr.subarray(2, 34);
    return {
        isTestOnly: isTestOnly,
        isBounceable: isBounceable,
        workchain: workchain,
        hashPart: hashPart
    };
}
var $c509a212d5c08318$var$Address = /*#__PURE__*/ function() {
    "use strict";
    function Address(workChain, hash) {
        var _this = this;
        (0, $978gY._)(this, Address);
        this.toRawString = function() {
            return _this.workChain + ":" + _this.hash.toString("hex");
        };
        this.toRaw = function() {
            var addressWithChecksum = $c509a212d5c08318$require$Buffer.alloc(36);
            addressWithChecksum.set(_this.hash);
            addressWithChecksum.set([
                _this.workChain,
                _this.workChain,
                _this.workChain,
                _this.workChain
            ], 32);
            return addressWithChecksum;
        };
        this.toStringBuffer = function(args) {
            var testOnly = args && args.testOnly !== undefined ? args.testOnly : false;
            var bounceable = args && args.bounceable !== undefined ? args.bounceable : true;
            var tag = bounceable ? $c509a212d5c08318$var$bounceable_tag : $c509a212d5c08318$var$non_bounceable_tag;
            if (testOnly) tag |= $c509a212d5c08318$var$test_flag;
            var addr = $c509a212d5c08318$require$Buffer.alloc(34);
            addr[0] = tag;
            addr[1] = _this.workChain;
            addr.set(_this.hash, 2);
            var addressWithChecksum = $c509a212d5c08318$require$Buffer.alloc(36);
            addressWithChecksum.set(addr);
            addressWithChecksum.set((0, $edEE1.crc16)(addr), 34);
            return addressWithChecksum;
        };
        this.toString = function(args) {
            var urlSafe = args && args.urlSafe !== undefined ? args.urlSafe : true;
            var buffer = _this.toStringBuffer(args);
            if (urlSafe) return buffer.toString("base64").replace(/\+/g, "-").replace(/\//g, "_");
            else return buffer.toString("base64");
        };
        this[$c509a212d5c08318$var$_a] = function() {
            return _this.toString();
        };
        this.workChain = workChain;
        this.hash = hash;
        Object.freeze(this);
    }
    (0, $kry2a._)(Address, [
        {
            key: "equals",
            value: function equals(src) {
                if (src.workChain !== this.workChain) return false;
                return src.hash.equals(this.hash);
            }
        }
    ], [
        {
            key: "isAddress",
            value: function isAddress(src) {
                return src instanceof Address;
            }
        },
        {
            key: "isFriendly",
            value: function isFriendly(source) {
                return source.indexOf(":") < 0;
            }
        },
        {
            key: "normalize",
            value: function normalize(source) {
                if (typeof source === "string") return Address.parse(source).toString();
                else return source.toString();
            }
        },
        {
            key: "parse",
            value: function parse(source) {
                if (Address.isFriendly(source)) return this.parseFriendly(source).address;
                else return this.parseRaw(source);
            }
        },
        {
            key: "parseRaw",
            value: function parseRaw(source) {
                var workChain = parseInt(source.split(":")[0]);
                var hash = $c509a212d5c08318$require$Buffer.from(source.split(":")[1], "hex");
                return new Address(workChain, hash);
            }
        },
        {
            key: "parseFriendly",
            value: function parseFriendly(source) {
                if ($c509a212d5c08318$require$Buffer.isBuffer(source)) {
                    var r = $c509a212d5c08318$var$parseFriendlyAddress(source);
                    return {
                        isBounceable: r.isBounceable,
                        isTestOnly: r.isTestOnly,
                        address: new Address(r.workchain, r.hashPart)
                    };
                } else {
                    var addr = source.replace(/\-/g, "+").replace(/_/g, "/"); // Convert from url-friendly to true base64
                    var r1 = $c509a212d5c08318$var$parseFriendlyAddress(addr);
                    return {
                        isBounceable: r1.isBounceable,
                        isTestOnly: r1.isTestOnly,
                        address: new Address(r1.workchain, r1.hashPart)
                    };
                }
            }
        }
    ]);
    return Address;
}();
module.exports.Address = $c509a212d5c08318$var$Address;
$c509a212d5c08318$var$_a = $c509a212d5c08318$var$symbol_inspect_1.default;
function $c509a212d5c08318$var$address(src) {
    return $c509a212d5c08318$var$Address.parse(src);
}
module.exports.address = $c509a212d5c08318$var$address;

});
parcelRequire.register("2LPl1", function(module, exports) {
"use strict";
/**
 * <symbol> that can be used to declare custom inspect functions.
 *
 * same as Symbol.for('nodejs.util.inspect.custom')
 * same as util.inspect.custom
 */ var $2047cb36c717eee8$var$SymbolInspect = Symbol.for("nodejs.util.inspect.custom");
module.exports = $2047cb36c717eee8$var$SymbolInspect;

});

parcelRequire.register("edEE1", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $a5a1cebe39739e41$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crc16 = void 0;
function $a5a1cebe39739e41$var$crc16(data) {
    var poly = 0x1021;
    var reg = 0;
    var message = $a5a1cebe39739e41$require$Buffer.alloc(data.length + 2);
    message.set(data);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = message[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var byte = _step.value;
            var mask = 0x80;
            while(mask > 0){
                reg <<= 1;
                if (byte & mask) reg += 1;
                mask >>= 1;
                if (reg > 0xffff) {
                    reg &= 0xffff;
                    reg ^= poly;
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $a5a1cebe39739e41$require$Buffer.from([
        Math.floor(reg / 256),
        reg % 256
    ]);
}
module.exports.crc16 = $a5a1cebe39739e41$var$crc16;

});


parcelRequire.register("jEXEj", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e50005d0773e0a59$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $e50005d0773e0a59$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExternalAddress = void 0;

var $e50005d0773e0a59$var$symbol_inspect_1 = $e50005d0773e0a59$var$__importDefault((parcelRequire("2LPl1")));
var $e50005d0773e0a59$var$ExternalAddress = /*#__PURE__*/ function() {
    function ExternalAddress(value, bits) {
        var _this = this;
        (0, $978gY._)(this, ExternalAddress);
        this[$e50005d0773e0a59$var$_a] = function() {
            return _this.toString();
        };
        this.value = value;
        this.bits = bits;
    }
    (0, $kry2a._)(ExternalAddress, [
        {
            key: "toString",
            value: function toString() {
                return "External<".concat(this.bits, ":").concat(this.value, ">");
            }
        }
    ], [
        {
            key: "isAddress",
            value: function isAddress(src) {
                return src instanceof ExternalAddress;
            }
        }
    ]);
    return ExternalAddress;
}();
module.exports.ExternalAddress = $e50005d0773e0a59$var$ExternalAddress;
$e50005d0773e0a59$var$_a = $e50005d0773e0a59$var$symbol_inspect_1.default;

});

parcelRequire.register("lb9hZ", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $gzLuY = parcelRequire("gzLuY");
var $f6b1d4b0b0662604$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f6b1d4b0b0662604$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $f6b1d4b0b0662604$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ADNLAddress = void 0;

var $f6b1d4b0b0662604$var$symbol_inspect_1 = $f6b1d4b0b0662604$var$__importDefault((parcelRequire("2LPl1")));

var $atYB4 = parcelRequire("atYB4");

var $edEE1 = parcelRequire("edEE1");
var $f6b1d4b0b0662604$var$ADNLAddress = /*#__PURE__*/ function() {
    "use strict";
    function ADNLAddress(address) {
        var _this = this;
        (0, $978gY._)(this, ADNLAddress);
        this.toRaw = function() {
            return _this.address.toString("hex").toUpperCase();
        };
        this.toString = function() {
            var data = $f6b1d4b0b0662604$require$Buffer.concat([
                $f6b1d4b0b0662604$require$Buffer.from([
                    0x2D
                ]),
                _this.address
            ]);
            var hash = (0, $edEE1.crc16)(data);
            data = $f6b1d4b0b0662604$require$Buffer.concat([
                data,
                hash
            ]);
            return (0, $atYB4.base32Encode)(data).slice(1);
        };
        this[$f6b1d4b0b0662604$var$_a] = function() {
            return _this.toString();
        };
        if (address.length !== 32) throw Error("Invalid address");
        this.address = address;
    }
    (0, $kry2a._)(ADNLAddress, [
        {
            key: "equals",
            value: function equals(b) {
                return this.address.equals(b.address);
            }
        }
    ], [
        {
            key: "parseFriendly",
            value: function parseFriendly(src) {
                if (src.length !== 55) throw Error("Invalid address");
                // Decoding
                src = "f" + src;
                var decoded = (0, $atYB4.base32Decode)(src);
                if (decoded[0] !== 0x2d) throw Error("Invalid address");
                var gotHash = decoded.slice(33);
                var hash = (0, $edEE1.crc16)(decoded.slice(0, 33));
                if (!hash.equals(gotHash)) throw Error("Invalid address");
                return new ADNLAddress(decoded.slice(1, 33));
            }
        },
        {
            key: "parseRaw",
            value: function parseRaw(src) {
                var data = $f6b1d4b0b0662604$require$Buffer.from(src, "base64");
                return new ADNLAddress(data);
            }
        }
    ]);
    return ADNLAddress;
}();
module.exports.ADNLAddress = $f6b1d4b0b0662604$var$ADNLAddress;
$f6b1d4b0b0662604$var$_a = $f6b1d4b0b0662604$var$symbol_inspect_1.default;

});
parcelRequire.register("atYB4", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $7a1b9e1376ec93ca$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.base32Decode = module.exports.base32Encode = void 0;
var $7a1b9e1376ec93ca$var$alphabet = "abcdefghijklmnopqrstuvwxyz234567";
function $7a1b9e1376ec93ca$var$base32Encode(buffer) {
    var length = buffer.byteLength;
    var bits = 0;
    var value = 0;
    var output = "";
    for(var i = 0; i < length; i++){
        value = value << 8 | buffer[i];
        bits += 8;
        while(bits >= 5){
            output += $7a1b9e1376ec93ca$var$alphabet[value >>> bits - 5 & 31];
            bits -= 5;
        }
    }
    if (bits > 0) output += $7a1b9e1376ec93ca$var$alphabet[value << 5 - bits & 31];
    return output;
}
module.exports.base32Encode = $7a1b9e1376ec93ca$var$base32Encode;
function $7a1b9e1376ec93ca$var$readChar(alphabet, char) {
    var idx = alphabet.indexOf(char);
    if (idx === -1) throw new Error("Invalid character found: " + char);
    return idx;
}
function $7a1b9e1376ec93ca$var$base32Decode(input) {
    var cleanedInput;
    cleanedInput = input.toLowerCase();
    var length = cleanedInput.length;
    var bits = 0;
    var value = 0;
    var index = 0;
    var output = $7a1b9e1376ec93ca$require$Buffer.alloc(length * 5 / 8 | 0);
    for(var i = 0; i < length; i++){
        value = value << 5 | $7a1b9e1376ec93ca$var$readChar($7a1b9e1376ec93ca$var$alphabet, cleanedInput[i]);
        bits += 5;
        if (bits >= 8) {
            output[index++] = value >>> bits - 8 & 255;
            bits -= 8;
        }
    }
    return output;
}
module.exports.base32Decode = $7a1b9e1376ec93ca$var$base32Decode;

});


parcelRequire.register("11EnC", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.contractAddress = void 0;

var $hARf4 = parcelRequire("hARf4");

var $49zOn = parcelRequire("49zOn");

var $gUPfK = parcelRequire("gUPfK");
function $0bf5350993a2f0ea$var$contractAddress(workchain, init) {
    var hash = (0, $hARf4.beginCell)().store((0, $49zOn.storeStateInit)(init)).endCell().hash();
    return new $gUPfK.Address(workchain, hash);
}
module.exports.contractAddress = $0bf5350993a2f0ea$var$contractAddress;

});
parcelRequire.register("hARf4", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Builder = module.exports.beginCell = void 0;

var $iCiAY = parcelRequire("iCiAY");

var $KH51V = parcelRequire("KH51V");

var $9zpaq = parcelRequire("9zpaq");
/**
 * Start building a cell
 * @returns a new builder
 */ function $ccef19392870f33d$var$beginCell() {
    return new $ccef19392870f33d$var$Builder();
}
module.exports.beginCell = $ccef19392870f33d$var$beginCell;
/**
 * Builder for Cells
 */ var $ccef19392870f33d$var$Builder = /*#__PURE__*/ function() {
    function Builder() {
        (0, $978gY._)(this, Builder);
        this._bits = new $iCiAY.BitBuilder();
        this._refs = [];
    }
    (0, $kry2a._)(Builder, [
        {
            key: "bits",
            get: /**
     * Bits written so far
     */ function get() {
                return this._bits.length;
            }
        },
        {
            key: "refs",
            get: /**
     * References written so far
     */ function get() {
                return this._refs.length;
            }
        },
        {
            key: "availableBits",
            get: /**
     * Available bits
     */ function get() {
                return 1023 - this.bits;
            }
        },
        {
            key: "availableRefs",
            get: /**
     * Available references
     */ function get() {
                return 4 - this.refs;
            }
        },
        {
            /**
     * Write a single bit
     * @param value bit to write, true or positive number for 1, false or zero or negative for 0
     * @returns this builder
     */ key: "storeBit",
            value: function storeBit(value) {
                this._bits.writeBit(value);
                return this;
            }
        },
        {
            /**
     * Write bits from BitString
     * @param src source bits
     * @returns this builder
     */ key: "storeBits",
            value: function storeBits(src) {
                this._bits.writeBits(src);
                return this;
            }
        },
        {
            /**
     * Store Buffer
     * @param src source buffer
     * @param bytes optional number of bytes to write
     * @returns this builder
     */ key: "storeBuffer",
            value: function storeBuffer(src, bytes) {
                if (bytes !== undefined && bytes !== null) {
                    if (src.length !== bytes) throw Error("Buffer length ".concat(src.length, " is not equal to ").concat(bytes));
                }
                this._bits.writeBuffer(src);
                return this;
            }
        },
        {
            /**
     * Store Maybe Buffer
     * @param src source buffer or null
     * @param bytes optional number of bytes to write
     * @returns this builder
     */ key: "storeMaybeBuffer",
            value: function storeMaybeBuffer(src, bytes) {
                if (src !== null) {
                    this.storeBit(1);
                    this.storeBuffer(src, bytes);
                } else this.storeBit(0);
                return this;
            }
        },
        {
            /**
     * Store uint value
     * @param value value as bigint or number
     * @param bits number of bits to write
     * @returns this builder
     */ key: "storeUint",
            value: function storeUint(value, bits) {
                this._bits.writeUint(value, bits);
                return this;
            }
        },
        {
            /**
     * Store maybe uint value
     * @param value value as bigint or number, null or undefined
     * @param bits number of bits to write
     * @returns this builder
     */ key: "storeMaybeUint",
            value: function storeMaybeUint(value, bits) {
                if (value !== null && value !== undefined) {
                    this.storeBit(1);
                    this.storeUint(value, bits);
                } else this.storeBit(0);
                return this;
            }
        },
        {
            /**
     * Store int value
     * @param value value as bigint or number
     * @param bits number of bits to write
     * @returns this builder
     */ key: "storeInt",
            value: function storeInt(value, bits) {
                this._bits.writeInt(value, bits);
                return this;
            }
        },
        {
            /**
     * Store maybe int value
     * @param value value as bigint or number, null or undefined
     * @param bits number of bits to write
     * @returns this builder
     */ key: "storeMaybeInt",
            value: function storeMaybeInt(value, bits) {
                if (value !== null && value !== undefined) {
                    this.storeBit(1);
                    this.storeInt(value, bits);
                } else this.storeBit(0);
                return this;
            }
        },
        {
            /**
     * Store varuint value
     * @param value value as bigint or number
     * @param bits number of bits to write to header
     * @returns this builder
     */ key: "storeVarUint",
            value: function storeVarUint(value, bits) {
                this._bits.writeVarUint(value, bits);
                return this;
            }
        },
        {
            /**
     * Store maybe varuint value
     * @param value value as bigint or number, null or undefined
     * @param bits number of bits to write to header
     * @returns this builder
     */ key: "storeMaybeVarUint",
            value: function storeMaybeVarUint(value, bits) {
                if (value !== null && value !== undefined) {
                    this.storeBit(1);
                    this.storeVarUint(value, bits);
                } else this.storeBit(0);
                return this;
            }
        },
        {
            /**
     * Store varint value
     * @param value value as bigint or number
     * @param bits number of bits to write to header
     * @returns this builder
     */ key: "storeVarInt",
            value: function storeVarInt(value, bits) {
                this._bits.writeVarInt(value, bits);
                return this;
            }
        },
        {
            /**
     * Store maybe varint value
     * @param value value as bigint or number, null or undefined
     * @param bits number of bits to write to header
     * @returns this builder
     */ key: "storeMaybeVarInt",
            value: function storeMaybeVarInt(value, bits) {
                if (value !== null && value !== undefined) {
                    this.storeBit(1);
                    this.storeVarInt(value, bits);
                } else this.storeBit(0);
                return this;
            }
        },
        {
            /**
     * Store coins value
     * @param amount amount of coins
     * @returns this builder
     */ key: "storeCoins",
            value: function storeCoins(amount) {
                this._bits.writeCoins(amount);
                return this;
            }
        },
        {
            /**
     * Store maybe coins value
     * @param amount amount of coins, null or undefined
     * @returns this builder
     */ key: "storeMaybeCoins",
            value: function storeMaybeCoins(amount) {
                if (amount !== null && amount !== undefined) {
                    this.storeBit(1);
                    this.storeCoins(amount);
                } else this.storeBit(0);
                return this;
            }
        },
        {
            /**
     * Store address
     * @param addres address to store
     * @returns this builder
     */ key: "storeAddress",
            value: function storeAddress(address) {
                this._bits.writeAddress(address);
                return this;
            }
        },
        {
            /**
     * Store reference
     * @param cell cell or builder to store
     * @returns this builder
     */ key: "storeRef",
            value: function storeRef(cell) {
                // Check refs
                if (this._refs.length >= 4) throw new Error("Too many references");
                // Store reference
                if (cell instanceof $KH51V.Cell) this._refs.push(cell);
                else if (cell instanceof Builder) this._refs.push(cell.endCell());
                else throw new Error("Invalid argument");
                return this;
            }
        },
        {
            /**
     * Store reference if not null
     * @param cell cell or builder to store
     * @returns this builder
     */ key: "storeMaybeRef",
            value: function storeMaybeRef(cell) {
                if (cell) {
                    this.storeBit(1);
                    this.storeRef(cell);
                } else this.storeBit(0);
                return this;
            }
        },
        {
            /**
     * Store slice it in this builder
     * @param src source slice
     */ key: "storeSlice",
            value: function storeSlice(src) {
                var c = src.clone();
                if (c.remainingBits > 0) this.storeBits(c.loadBits(c.remainingBits));
                while(c.remainingRefs > 0)this.storeRef(c.loadRef());
                return this;
            }
        },
        {
            /**
     * Store slice in this builder if not null
     * @param src source slice
     */ key: "storeMaybeSlice",
            value: function storeMaybeSlice(src) {
                if (src) {
                    this.storeBit(1);
                    this.storeSlice(src);
                } else this.storeBit(0);
                return this;
            }
        },
        {
            /**
     * Store builder
     * @param src builder to store
     * @returns this builder
     */ key: "storeBuilder",
            value: function storeBuilder(src) {
                return this.storeSlice(src.endCell().beginParse());
            }
        },
        {
            /**
     * Store builder if not null
     * @param src builder to store
     * @returns this builder
     */ key: "storeMaybeBuilder",
            value: function storeMaybeBuilder(src) {
                if (src) {
                    this.storeBit(1);
                    this.storeBuilder(src);
                } else this.storeBit(0);
                return this;
            }
        },
        {
            /**
     * Store writer or builder
     * @param writer writer or builder to store
     * @returns this builder
     */ key: "storeWritable",
            value: function storeWritable(writer) {
                if (typeof writer === "object") writer.writeTo(this);
                else writer(this);
                return this;
            }
        },
        {
            /**
     * Store writer or builder if not null
     * @param writer writer or builder to store
     * @returns this builder
     */ key: "storeMaybeWritable",
            value: function storeMaybeWritable(writer) {
                if (writer) {
                    this.storeBit(1);
                    this.storeWritable(writer);
                } else this.storeBit(0);
                return this;
            }
        },
        {
            /**
     * Store object in this builder
     * @param writer Writable or writer functuin
     */ key: "store",
            value: function store(writer) {
                this.storeWritable(writer);
                return this;
            }
        },
        {
            /**
     * Store string tail
     * @param src source string
     * @returns this builder
     */ key: "storeStringTail",
            value: function storeStringTail(src) {
                (0, $9zpaq.writeString)(src, this);
                return this;
            }
        },
        {
            /**
     * Store string tail
     * @param src source string
     * @returns this builder
     */ key: "storeMaybeStringTail",
            value: function storeMaybeStringTail(src) {
                if (src !== null && src !== undefined) {
                    this.storeBit(1);
                    (0, $9zpaq.writeString)(src, this);
                } else this.storeBit(0);
                return this;
            }
        },
        {
            /**
     * Store string tail in ref
     * @param src source string
     * @returns this builder
     */ key: "storeStringRefTail",
            value: function storeStringRefTail(src) {
                this.storeRef($ccef19392870f33d$var$beginCell().storeStringTail(src));
                return this;
            }
        },
        {
            /**
     * Store maybe string tail in ref
     * @param src source string
     * @returns this builder
     */ key: "storeMaybeStringRefTail",
            value: function storeMaybeStringRefTail(src) {
                if (src !== null && src !== undefined) {
                    this.storeBit(1);
                    this.storeStringRefTail(src);
                } else this.storeBit(0);
                return this;
            }
        },
        {
            /**
     * Store dictionary in this builder
     * @param dict dictionary to store
     * @returns this builder
     */ key: "storeDict",
            value: function storeDict(dict, key, value) {
                if (dict) dict.store(this, key, value);
                else this.storeBit(0);
                return this;
            }
        },
        {
            /**
     * Store dictionary in this builder directly
     * @param dict dictionary to store
     * @returns this builder
     */ key: "storeDictDirect",
            value: function storeDictDirect(dict, key, value) {
                dict.storeDirect(this, key, value);
                return this;
            }
        },
        {
            /**
     * Complete cell
     * @returns cell
     */ key: "endCell",
            value: function endCell() {
                return new $KH51V.Cell({
                    bits: this._bits.build(),
                    refs: this._refs
                });
            }
        },
        {
            /**
     * Convert to cell
     * @returns cell
     */ key: "asCell",
            value: function asCell() {
                return this.endCell();
            }
        },
        {
            /**
     * Convert to slice
     * @returns slice
     */ key: "asSlice",
            value: function asSlice() {
                return this.endCell().beginParse();
            }
        }
    ]);
    return Builder;
}();
module.exports.Builder = $ccef19392870f33d$var$Builder;

});
parcelRequire.register("iCiAY", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $gzLuY = parcelRequire("gzLuY");
var $d8da3345750999c5$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BitBuilder = void 0;

var $gUPfK = parcelRequire("gUPfK");

var $jEXEj = parcelRequire("jEXEj");

var $iSKta = parcelRequire("iSKta");
/**
 * Class for building bit strings
 */ var $d8da3345750999c5$var$BitBuilder = /*#__PURE__*/ function() {
    "use strict";
    function BitBuilder() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1023;
        (0, $978gY._)(this, BitBuilder);
        this._buffer = $d8da3345750999c5$require$Buffer.alloc(Math.ceil(size / 8));
        this._length = 0;
    }
    (0, $kry2a._)(BitBuilder, [
        {
            key: "length",
            get: /**
     * Current number of bits written
     */ function get() {
                return this._length;
            }
        },
        {
            /**
     * Write a single bit
     * @param value bit to write, true or positive number for 1, false or zero or negative for 0
     */ key: "writeBit",
            value: function writeBit(value) {
                // Check overflow
                var n = this._length;
                if (n > this._buffer.length * 8) throw new Error("BitBuilder overflow");
                // Set bit
                if (value === true || value > 0) this._buffer[n / 8 | 0] |= 1 << 7 - n % 8;
                // Advance
                this._length++;
            }
        },
        {
            /**
     * Copy bits from BitString
     * @param src source bits
     */ key: "writeBits",
            value: function writeBits(src) {
                for(var i = 0; i < src.length; i++)this.writeBit(src.at(i));
            }
        },
        {
            /**
     * Write bits from buffer
     * @param src source buffer
     */ key: "writeBuffer",
            value: function writeBuffer(src) {
                // Special case for aligned offsets
                if (this._length % 8 === 0) {
                    if (this._length + src.length * 8 > this._buffer.length * 8) throw new Error("BitBuilder overflow");
                    src.copy(this._buffer, this._length / 8);
                    this._length += src.length * 8;
                } else for(var i = 0; i < src.length; i++)this.writeUint(src[i], 8);
            }
        },
        {
            /**
     * Write uint value
     * @param value value as bigint or number
     * @param bits number of bits to write
     */ key: "writeUint",
            value: function writeUint(value, bits) {
                // Special case for 8 bits
                if (bits === 8 && this._length % 8 === 0) {
                    var v = Number(value);
                    if (v < 0 || v > 255 || !Number.isSafeInteger(v)) throw Error("value is out of range for ".concat(bits, " bits. Got ").concat(value));
                    this._buffer[this._length / 8] = Number(value);
                    this._length += 8;
                    return;
                }
                // Special case for 16 bits
                if (bits === 16 && this._length % 8 === 0) {
                    var v1 = Number(value);
                    if (v1 < 0 || v1 > 65536 || !Number.isSafeInteger(v1)) throw Error("value is out of range for ".concat(bits, " bits. Got ").concat(value));
                    this._buffer[this._length / 8] = v1 >> 8;
                    this._buffer[this._length / 8 + 1] = v1 & 0xff;
                    this._length += 16;
                    return;
                }
                // Generic case
                var v2 = BigInt(value);
                if (bits < 0 || !Number.isSafeInteger(bits)) throw Error("invalid bit length. Got ".concat(bits));
                // Corner case for zero bits
                if (bits === 0) {
                    if (value !== 0n) throw Error("value is not zero for ".concat(bits, " bits. Got ").concat(value));
                    else return;
                }
                // Check input
                var vBits = 1n << BigInt(bits);
                if (v2 < 0 || v2 >= vBits) throw Error("bitLength is too small for a value ".concat(value, ". Got ").concat(bits));
                // Convert number to bits
                var b = [];
                while(v2 > 0){
                    b.push(v2 % 2n === 1n);
                    v2 /= 2n;
                }
                // Write bits
                for(var i = 0; i < bits; i++){
                    var off = bits - i - 1;
                    if (off < b.length) this.writeBit(b[off]);
                    else this.writeBit(false);
                }
            }
        },
        {
            /**
     * Write int value
     * @param value value as bigint or number
     * @param bits number of bits to write
     */ key: "writeInt",
            value: function writeInt(value, bits) {
                var v = BigInt(value);
                if (bits < 0 || !Number.isSafeInteger(bits)) throw Error("invalid bit length. Got ".concat(bits));
                // Corner case for zero bits
                if (bits === 0) {
                    if (value !== 0n) throw Error("value is not zero for ".concat(bits, " bits. Got ").concat(value));
                    else return;
                }
                // Corner case for one bit
                if (bits === 1) {
                    if (value !== -1n && value !== 0n) throw Error("value is not zero or -1 for ".concat(bits, " bits. Got ").concat(value));
                    else {
                        this.writeBit(value === -1n);
                        return;
                    }
                }
                // Check input
                var vBits = 1n << BigInt(bits) - 1n;
                if (v < -vBits || v >= vBits) throw Error("value is out of range for ".concat(bits, " bits. Got ").concat(value));
                // Write sign
                if (v < 0) {
                    this.writeBit(true);
                    v = vBits + v;
                } else this.writeBit(false);
                // Write value
                this.writeUint(v, bits - 1);
            }
        },
        {
            /**
     * Wrtie var uint value, used for serializing coins
     * @param value value to write as bigint or number
     * @param bits header bits to write size
     */ key: "writeVarUint",
            value: function writeVarUint(value, bits) {
                var v = BigInt(value);
                if (bits < 0 || !Number.isSafeInteger(bits)) throw Error("invalid bit length. Got ".concat(bits));
                if (v < 0) throw Error("value is negative. Got ".concat(value));
                // Corner case for zero
                if (v === 0n) {
                    // Write zero size
                    this.writeUint(0, bits);
                    return;
                }
                // Calculate size
                var sizeBytes = Math.ceil(v.toString(2).length / 8); // Fastest way in most environments
                var sizeBits = sizeBytes * 8;
                // Write size
                this.writeUint(sizeBytes, bits);
                // Write number
                this.writeUint(v, sizeBits);
            }
        },
        {
            /**
     * Wrtie var int value, used for serializing coins
     * @param value value to write as bigint or number
     * @param bits header bits to write size
     */ key: "writeVarInt",
            value: function writeVarInt(value, bits) {
                var v = BigInt(value);
                if (bits < 0 || !Number.isSafeInteger(bits)) throw Error("invalid bit length. Got ".concat(bits));
                // Corner case for zero
                if (v === 0n) {
                    // Write zero size
                    this.writeUint(0, bits);
                    return;
                }
                // Calculate size
                var v2 = v > 0 ? v : -v;
                var sizeBytes = 1 + Math.ceil(v2.toString(2).length / 8); // Fastest way in most environments
                var sizeBits = sizeBytes * 8;
                // Write size
                this.writeUint(sizeBytes, bits);
                // Write number
                this.writeInt(v, sizeBits);
            }
        },
        {
            /**
     * Write coins in var uint format
     * @param amount amount to write
     */ key: "writeCoins",
            value: function writeCoins(amount) {
                this.writeVarUint(amount, 4);
            }
        },
        {
            /**
     * Write address
     * @param address write address or address external
     */ key: "writeAddress",
            value: function writeAddress(address) {
                // Is empty address
                if (address === null || address === undefined) {
                    this.writeUint(0, 2); // Empty address
                    return;
                }
                // Is Internal Address
                if ($gUPfK.Address.isAddress(address)) {
                    this.writeUint(2, 2); // Internal address
                    this.writeUint(0, 1); // No anycast
                    this.writeInt(address.workChain, 8);
                    this.writeBuffer(address.hash);
                    return;
                }
                // Is External Address
                if ($jEXEj.ExternalAddress.isAddress(address)) {
                    this.writeUint(1, 2); // External address
                    this.writeUint(address.bits, 9);
                    this.writeUint(address.value, address.bits);
                    return;
                }
                // Invalid address
                throw Error("Invalid address. Got ".concat(address));
            }
        },
        {
            /**
     * Build BitString
     * @returns result bit string
     */ key: "build",
            value: function build() {
                return new $iSKta.BitString(this._buffer, 0, this._length);
            }
        },
        {
            /**
     * Build into Buffer
     * @returns result buffer
     */ key: "buffer",
            value: function buffer() {
                if (this._length % 8 !== 0) throw new Error("BitBuilder buffer is not byte aligned");
                return this._buffer.subarray(0, this._length / 8);
            }
        }
    ]);
    return BitBuilder;
}();
module.exports.BitBuilder = $d8da3345750999c5$var$BitBuilder;

});
parcelRequire.register("iSKta", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $gzLuY = parcelRequire("gzLuY");
var $dbf15100923ad19c$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dbf15100923ad19c$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $dbf15100923ad19c$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BitString = void 0;

var $hm8RK = parcelRequire("hm8RK");

var $dbf15100923ad19c$var$symbol_inspect_1 = $dbf15100923ad19c$var$__importDefault((parcelRequire("2LPl1")));
/**
 * BitString is a class that represents a bitstring in a buffer with a specified offset and length
 */ var $dbf15100923ad19c$var$BitString = /*#__PURE__*/ function() {
    "use strict";
    function BitString(data, offset, length) {
        var _this = this;
        (0, $978gY._)(this, BitString);
        this[$dbf15100923ad19c$var$_a] = function() {
            return _this.toString();
        };
        // Check bounds
        if (length < 0) throw new Error("Length ".concat(length, " is out of bounds"));
        this._length = length;
        this._data = data;
        this._offset = offset;
    }
    (0, $kry2a._)(BitString, [
        {
            key: "length",
            get: /**
     * Returns the length of the bitstring
     */ function get() {
                return this._length;
            }
        },
        {
            /**
     * Returns the bit at the specified index
     * @param index index of the bit
     * @throws Error if index is out of bounds
     * @returns true if the bit is set, false otherwise
     */ key: "at",
            value: function at(index) {
                // Check bounds
                if (index >= this._length) throw new Error("Index ".concat(index, " > ").concat(this._length, " is out of bounds"));
                if (index < 0) throw new Error("Index ".concat(index, " < 0 is out of bounds"));
                // Calculcate offsets
                var byteIndex = this._offset + index >> 3;
                var bitIndex = 7 - (this._offset + index) % 8; // NOTE: We are using big endian
                // Return the bit
                return (this._data[byteIndex] & 1 << bitIndex) !== 0;
            }
        },
        {
            /**
     * Get a subscring of the bitstring
     * @param offset
     * @param length
     * @returns
     */ key: "substring",
            value: function substring(offset, length) {
                // Check offset
                if (offset >= this._length) throw new Error("Offset(".concat(offset, ") > ").concat(this._length, " is out of bounds"));
                if (offset < 0) throw new Error("Offset(".concat(offset, ") < 0 is out of bounds"));
                // Corner case of empty string
                if (length === 0) return BitString.EMPTY;
                if (offset + length > this._length) throw new Error("Offset ".concat(offset, " + Length ").concat(length, " > ").concat(this._length, " is out of bounds"));
                // Create substring
                return new BitString(this._data, this._offset + offset, length);
            }
        },
        {
            /**
     * Try to get a buffer from the bitstring without allocations
     * @param offset offset in bits
     * @param length length in bits
     * @returns buffer if the bitstring is aligned to bytes, null otherwise
     */ key: "subbuffer",
            value: function subbuffer(offset, length) {
                // Check offset
                if (offset >= this._length) throw new Error("Offset ".concat(offset, " is out of bounds"));
                if (offset < 0) throw new Error("Offset ".concat(offset, " is out of bounds"));
                if (offset + length > this._length) throw new Error("Offset + Lenght = ".concat(offset + length, " is out of bounds"));
                // Check alignment
                if (length % 8 !== 0) return null;
                if ((this._offset + offset) % 8 !== 0) return null;
                // Create substring
                var start = this._offset + offset >> 3;
                var end = start + (length >> 3);
                return this._data.subarray(start, end);
            }
        },
        {
            /**
     * Checks for equality
     * @param b other bitstring
     * @returns true if the bitstrings are equal, false otherwise
     */ key: "equals",
            value: function equals(b) {
                if (this._length !== b._length) return false;
                for(var i = 0; i < this._length; i++){
                    if (this.at(i) !== b.at(i)) return false;
                }
                return true;
            }
        },
        {
            /**
     * Format to canonical string
     * @returns formatted bits as a string
     */ key: "toString",
            value: function toString() {
                var padded = (0, $hm8RK.bitsToPaddedBuffer)(this);
                if (this._length % 4 === 0) {
                    var s = padded.subarray(0, Math.ceil(this._length / 8)).toString("hex").toUpperCase();
                    if (this._length % 8 === 0) return s;
                    else return s.substring(0, s.length - 1);
                } else {
                    var hex = padded.toString("hex").toUpperCase();
                    if (this._length % 8 <= 4) return hex.substring(0, hex.length - 1) + "_";
                    else return hex + "_";
                }
            }
        }
    ]);
    return BitString;
}();
module.exports.BitString = $dbf15100923ad19c$var$BitString;
$dbf15100923ad19c$var$_a = $dbf15100923ad19c$var$symbol_inspect_1.default;
$dbf15100923ad19c$var$BitString.EMPTY = new $dbf15100923ad19c$var$BitString($dbf15100923ad19c$require$Buffer.alloc(0), 0, 0);

});
parcelRequire.register("hm8RK", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bitsToPaddedBuffer = void 0;

var $iCiAY = parcelRequire("iCiAY");
function $ca2b5e55564f96f5$var$bitsToPaddedBuffer(bits) {
    // Create builder
    var builder = new $iCiAY.BitBuilder(Math.ceil(bits.length / 8) * 8);
    builder.writeBits(bits);
    // Apply padding
    var padding = Math.ceil(bits.length / 8) * 8 - bits.length;
    for(var i = 0; i < padding; i++)if (i === 0) builder.writeBit(1);
    else builder.writeBit(0);
    return builder.buffer();
}
module.exports.bitsToPaddedBuffer = $ca2b5e55564f96f5$var$bitsToPaddedBuffer;

});



parcelRequire.register("KH51V", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $fLnyw = parcelRequire("fLnyw");

var $gzLuY = parcelRequire("gzLuY");
var $08c5b6cf031536fa$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $08c5b6cf031536fa$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $08c5b6cf031536fa$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cell = void 0;

var $08c5b6cf031536fa$var$symbol_inspect_1 = $08c5b6cf031536fa$var$__importDefault((parcelRequire("2LPl1")));

var $iSKta = parcelRequire("iSKta");

var $d57eA = parcelRequire("d57eA");

var $aQ0oy = parcelRequire("aQ0oy");

var $fJkBI = parcelRequire("fJkBI");

var $4XP5P = parcelRequire("4XP5P");

var $95cTD = parcelRequire("95cTD");

var $6RnAU = parcelRequire("6RnAU");

var $hARf4 = parcelRequire("hARf4");
/**
 * Cell as described in TVM spec
 */ var $08c5b6cf031536fa$var$Cell = /*#__PURE__*/ function() {
    "use strict";
    function Cell(opts) {
        var _this = this;
        (0, $978gY._)(this, Cell);
        // Level and depth information
        this._hashes = [];
        this._depths = [];
        /**
         * Beging cell parsing
         * @returns a new slice
         */ this.beginParse = function() {
            var allowExotic = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            if (_this.isExotic && !allowExotic) throw new Error("Exotic cells cannot be parsed");
            return new $aQ0oy.Slice(new $6RnAU.BitReader(_this.bits), _this.refs);
        };
        /**
         * Get cell hash
         * @param level level
         * @returns cell hash
         */ this.hash = function() {
            var level = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 3;
            return _this._hashes[Math.min(_this._hashes.length - 1, level)];
        };
        /**
         * Get cell depth
         * @param level level
         * @returns cell depth
         */ this.depth = function() {
            var level = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 3;
            return _this._depths[Math.min(_this._depths.length - 1, level)];
        };
        /**
         * Get cell level
         * @returns cell level
         */ this.level = function() {
            return _this.mask.level;
        };
        /**
         * Checks cell to be euqal to another cell
         * @param other other cell
         * @returns true if cells are equal
         */ this.equals = function(other) {
            return _this.hash().equals(other.hash());
        };
        this[$08c5b6cf031536fa$var$_a] = function() {
            return _this.toString();
        };
        // Resolve bits
        var bits = $iSKta.BitString.EMPTY;
        if (opts && opts.bits) bits = opts.bits;
        // Resolve refs
        var refs = [];
        if (opts && opts.refs) refs = (0, $fLnyw._)(opts.refs);
        // Resolve type
        var hashes;
        var depths;
        var mask;
        var type = $d57eA.CellType.Ordinary;
        if (opts && opts.exotic) {
            // Resolve exotic cell
            var resolved = (0, $fJkBI.resolveExotic)(bits, refs);
            // Perform wonders
            var wonders = (0, $4XP5P.wonderCalculator)(resolved.type, bits, refs);
            // Copy results
            mask = wonders.mask;
            depths = wonders.depths;
            hashes = wonders.hashes;
            type = resolved.type;
        } else {
            // Check correctness
            if (refs.length > 4) throw new Error("Invalid number of references");
            if (bits.length > 1023) throw new Error("Bits overflow: ".concat(bits.length, " > 1023"));
            // Perform wonders
            var wonders1 = (0, $4XP5P.wonderCalculator)($d57eA.CellType.Ordinary, bits, refs);
            // Copy results
            mask = wonders1.mask;
            depths = wonders1.depths;
            hashes = wonders1.hashes;
            type = $d57eA.CellType.Ordinary;
        }
        // Set fields
        this.type = type;
        this.bits = bits;
        this.refs = refs;
        this.mask = mask;
        this._depths = depths;
        this._hashes = hashes;
        Object.freeze(this);
        Object.freeze(this.refs);
        Object.freeze(this.bits);
        Object.freeze(this.mask);
        Object.freeze(this._depths);
        Object.freeze(this._hashes);
    }
    (0, $kry2a._)(Cell, [
        {
            key: "isExotic",
            get: /**
     * Check if cell is exotic
     */ function get() {
                return this.type !== $d57eA.CellType.Ordinary;
            }
        },
        {
            /**
     * Serializes cell to BOC
     * @param opts options
     */ key: "toBoc",
            value: function toBoc(opts) {
                var idx = opts && opts.idx !== null && opts.idx !== undefined ? opts.idx : false;
                var crc32 = opts && opts.crc32 !== null && opts.crc32 !== undefined ? opts.crc32 : true;
                return (0, $95cTD.serializeBoc)(this, {
                    idx: idx,
                    crc32: crc32
                });
            }
        },
        {
            /**
     * Format cell to string
     * @param indent indentation
     * @returns string representation
     */ key: "toString",
            value: function toString(indent) {
                var id = indent || "";
                var t = "x";
                if (this.isExotic) {
                    if (this.type === $d57eA.CellType.MerkleProof) t = "p";
                    else if (this.type === $d57eA.CellType.MerkleUpdate) t = "u";
                    else if (this.type === $d57eA.CellType.PrunedBranch) t = "p";
                }
                var s = id + (this.isExotic ? t : "x") + "{" + this.bits.toString() + "}";
                for(var k in this.refs){
                    var i = this.refs[k];
                    s += "\n" + i.toString(id + " ");
                }
                return s;
            }
        },
        {
            /**
     * Covnert cell to slice
     * @returns slice
     */ key: "asSlice",
            value: function asSlice() {
                return this.beginParse();
            }
        },
        {
            /**
     * Convert cell to a builder that has this cell stored
     * @returns builder
     */ key: "asBuilder",
            value: function asBuilder() {
                return (0, $hARf4.beginCell)().storeSlice(this.asSlice());
            }
        }
    ], [
        {
            key: "fromBoc",
            value: /**
     * Deserialize cells from BOC
     * @param src source buffer
     * @returns array of cells
     */ function fromBoc(src) {
                return (0, $95cTD.deserializeBoc)(src);
            }
        },
        {
            key: "fromBase64",
            value: /**
     * Helper class that deserializes a single cell from BOC in base64
     * @param src source string
     */ function fromBase64(src) {
                var parsed = Cell.fromBoc($08c5b6cf031536fa$require$Buffer.from(src, "base64"));
                if (parsed.length !== 1) throw new Error("Deserialized more than one cell");
                return parsed[0];
            }
        }
    ]);
    return Cell;
}();
module.exports.Cell = $08c5b6cf031536fa$var$Cell;
$08c5b6cf031536fa$var$_a = $08c5b6cf031536fa$var$symbol_inspect_1.default;
$08c5b6cf031536fa$var$Cell.EMPTY = new $08c5b6cf031536fa$var$Cell();

});
parcelRequire.register("d57eA", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CellType = void 0;
var $98615a947cbda9ed$var$CellType;
(function(CellType) {
    CellType[CellType["Ordinary"] = -1] = "Ordinary";
    CellType[CellType["PrunedBranch"] = 1] = "PrunedBranch";
    CellType[CellType["Library"] = 2] = "Library";
    CellType[CellType["MerkleProof"] = 3] = "MerkleProof";
    CellType[CellType["MerkleUpdate"] = 4] = "MerkleUpdate";
})($98615a947cbda9ed$var$CellType = module.exports.CellType || (module.exports.CellType = {}));

});

parcelRequire.register("aQ0oy", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $fLnyw = parcelRequire("fLnyw");
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7e3f1124b40b1cd1$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $7e3f1124b40b1cd1$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Slice = void 0;

var $7e3f1124b40b1cd1$var$symbol_inspect_1 = $7e3f1124b40b1cd1$var$__importDefault((parcelRequire("2LPl1")));

var $ihDv0 = parcelRequire("ihDv0");

var $hARf4 = parcelRequire("hARf4");

var $9zpaq = parcelRequire("9zpaq");
/**
 * Slice is a class that allows to read cell data
 */ var $7e3f1124b40b1cd1$var$Slice = /*#__PURE__*/ function() {
    function Slice(reader, refs) {
        var _this = this;
        (0, $978gY._)(this, Slice);
        this[$7e3f1124b40b1cd1$var$_a] = function() {
            return _this.toString();
        };
        this._reader = reader.clone();
        this._refs = (0, $fLnyw._)(refs);
        this._refsOffset = 0;
    }
    (0, $kry2a._)(Slice, [
        {
            key: "remainingBits",
            get: /**
     * Get remaining bits
     */ function get() {
                return this._reader.remaining;
            }
        },
        {
            key: "offsetBits",
            get: /**
     * Get offset bits
     */ function get() {
                return this._reader.offset;
            }
        },
        {
            key: "remainingRefs",
            get: /**
     * Get remaining refs
     */ function get() {
                return this._refs.length - this._refsOffset;
            }
        },
        {
            key: "offsetRefs",
            get: /**
     * Get offset refs
     */ function get() {
                return this._refsOffset;
            }
        },
        {
            /**
     * Skip bits
     * @param bits
     */ key: "skip",
            value: function skip(bits) {
                this._reader.skip(bits);
                return this;
            }
        },
        {
            /**
     * Load a single bit
     * @returns true or false depending on the bit value
     */ key: "loadBit",
            value: function loadBit() {
                return this._reader.loadBit();
            }
        },
        {
            /**
     * Preload a signle bit
     * @returns true or false depending on the bit value
     */ key: "preloadBit",
            value: function preloadBit() {
                return this._reader.preloadBit();
            }
        },
        {
            /**
     * Load a boolean
     * @returns true or false depending on the bit value
     */ key: "loadBoolean",
            value: function loadBoolean() {
                return this.loadBit();
            }
        },
        {
            /**
     * Load maybe boolean
     * @returns true or false depending on the bit value or null
     */ key: "loadMaybeBoolean",
            value: function loadMaybeBoolean() {
                if (this.loadBit()) return this.loadBoolean();
                else return null;
            }
        },
        {
            /**
     * Load bits as a new BitString
     * @param bits number of bits to read
     * @returns new BitString
     */ key: "loadBits",
            value: function loadBits(bits) {
                return this._reader.loadBits(bits);
            }
        },
        {
            /**
     * Preload bits as a new BitString
     * @param bits number of bits to read
     * @returns new BitString
     */ key: "preloadBits",
            value: function preloadBits(bits) {
                return this._reader.preloadBits(bits);
            }
        },
        {
            /**
     * Load uint
     * @param bits number of bits to read
     * @returns uint value
     */ key: "loadUint",
            value: function loadUint(bits) {
                return this._reader.loadUint(bits);
            }
        },
        {
            /**
     * Load uint
     * @param bits number of bits to read
     * @returns uint value
     */ key: "loadUintBig",
            value: function loadUintBig(bits) {
                return this._reader.loadUintBig(bits);
            }
        },
        {
            /**
     * Preload uint
     * @param bits number of bits to read
     * @returns uint value
     */ key: "preloadUint",
            value: function preloadUint(bits) {
                return this._reader.preloadUint(bits);
            }
        },
        {
            /**
     * Preload uint
     * @param bits number of bits to read
     * @returns uint value
     */ key: "preloadUintBig",
            value: function preloadUintBig(bits) {
                return this._reader.preloadUintBig(bits);
            }
        },
        {
            /**
     * Load maybe uint
     * @param bits number of bits to read
     * @returns uint value or null
     */ key: "loadMaybeUint",
            value: function loadMaybeUint(bits) {
                if (this.loadBit()) return this.loadUint(bits);
                else return null;
            }
        },
        {
            /**
     * Load maybe uint
     * @param bits number of bits to read
     * @returns uint value or null
     */ key: "loadMaybeUintBig",
            value: function loadMaybeUintBig(bits) {
                if (this.loadBit()) return this.loadUintBig(bits);
                else return null;
            }
        },
        {
            /**
     * Load int
     * @param bits number of bits to read
     * @returns int value
     */ key: "loadInt",
            value: function loadInt(bits) {
                return this._reader.loadInt(bits);
            }
        },
        {
            /**
     * Load int
     * @param bits number of bits to read
     * @returns int value
     */ key: "loadIntBig",
            value: function loadIntBig(bits) {
                return this._reader.loadIntBig(bits);
            }
        },
        {
            /**
     * Preload int
     * @param bits number of bits to read
     * @returns int value
     */ key: "preloadInt",
            value: function preloadInt(bits) {
                return this._reader.preloadInt(bits);
            }
        },
        {
            /**
     * Preload int
     * @param bits number of bits to read
     * @returns int value
     */ key: "preloadIntBig",
            value: function preloadIntBig(bits) {
                return this._reader.preloadIntBig(bits);
            }
        },
        {
            /**
     * Load maybe uint
     * @param bits number of bits to read
     * @returns uint value or null
     */ key: "loadMaybeInt",
            value: function loadMaybeInt(bits) {
                if (this.loadBit()) return this.loadInt(bits);
                else return null;
            }
        },
        {
            /**
     * Load maybe uint
     * @param bits number of bits to read
     * @returns uint value or null
     */ key: "loadMaybeIntBig",
            value: function loadMaybeIntBig(bits) {
                if (this.loadBit()) return this.loadIntBig(bits);
                else return null;
            }
        },
        {
            /**
     * Load varuint
     * @param bits number of bits to read in header
     * @returns varuint value
     */ key: "loadVarUint",
            value: function loadVarUint(bits) {
                return this._reader.loadVarUint(bits);
            }
        },
        {
            /**
     * Load varuint
     * @param bits number of bits to read in header
     * @returns varuint value
     */ key: "loadVarUintBig",
            value: function loadVarUintBig(bits) {
                return this._reader.loadVarUintBig(bits);
            }
        },
        {
            /**
     * Preload varuint
     * @param bits number of bits to read in header
     * @returns varuint value
     */ key: "preloadVarUint",
            value: function preloadVarUint(bits) {
                return this._reader.preloadVarUint(bits);
            }
        },
        {
            /**
     * Preload varuint
     * @param bits number of bits to read in header
     * @returns varuint value
     */ key: "preloadVarUintBig",
            value: function preloadVarUintBig(bits) {
                return this._reader.preloadVarUintBig(bits);
            }
        },
        {
            /**
     * Load varint
     * @param bits number of bits to read in header
     * @returns varint value
     */ key: "loadVarInt",
            value: function loadVarInt(bits) {
                return this._reader.loadVarInt(bits);
            }
        },
        {
            /**
     * Load varint
     * @param bits number of bits to read in header
     * @returns varint value
     */ key: "loadVarIntBig",
            value: function loadVarIntBig(bits) {
                return this._reader.loadVarIntBig(bits);
            }
        },
        {
            /**
     * Preload varint
     * @param bits number of bits to read in header
     * @returns varint value
     */ key: "preloadVarInt",
            value: function preloadVarInt(bits) {
                return this._reader.preloadVarInt(bits);
            }
        },
        {
            /**
     * Preload varint
     * @param bits number of bits to read in header
     * @returns varint value
     */ key: "preloadVarIntBig",
            value: function preloadVarIntBig(bits) {
                return this._reader.preloadVarIntBig(bits);
            }
        },
        {
            /**
     * Load coins
     * @returns coins value
     */ key: "loadCoins",
            value: function loadCoins() {
                return this._reader.loadCoins();
            }
        },
        {
            /**
     * Preload coins
     * @returns coins value
     */ key: "preloadCoins",
            value: function preloadCoins() {
                return this._reader.preloadCoins();
            }
        },
        {
            /**
     * Load maybe coins
     * @returns coins value or null
     */ key: "loadMaybeCoins",
            value: function loadMaybeCoins() {
                if (this._reader.loadBit()) return this._reader.loadCoins();
                else return null;
            }
        },
        {
            /**
     * Load internal Address
     * @returns Address
     */ key: "loadAddress",
            value: function loadAddress() {
                return this._reader.loadAddress();
            }
        },
        {
            /**
     * Load optional internal Address
     * @returns Address or null
     */ key: "loadMaybeAddress",
            value: function loadMaybeAddress() {
                return this._reader.loadMaybeAddress();
            }
        },
        {
            /**
     * Load external address
     * @returns ExternalAddress
     */ key: "loadExternalAddress",
            value: function loadExternalAddress() {
                return this._reader.loadExternalAddress();
            }
        },
        {
            /**
     * Load optional external address
     * @returns ExternalAddress or null
     */ key: "loadMaybeExternalAddress",
            value: function loadMaybeExternalAddress() {
                return this._reader.loadMaybeExternalAddress();
            }
        },
        {
            /**
     * Load address
     * @returns Address, ExternalAddress or null
     */ key: "loadAddressAny",
            value: function loadAddressAny() {
                return this._reader.loadAddressAny();
            }
        },
        {
            /**
     * Load reference
     * @returns Cell
     */ key: "loadRef",
            value: function loadRef() {
                if (this._refsOffset >= this._refs.length) throw new Error("No more references");
                return this._refs[this._refsOffset++];
            }
        },
        {
            /**
     * Preload reference
     * @returns Cell
     */ key: "preloadRef",
            value: function preloadRef() {
                if (this._refsOffset >= this._refs.length) throw new Error("No more references");
                return this._refs[this._refsOffset];
            }
        },
        {
            /**
     * Load optional reference
     * @returns Cell or null
     */ key: "loadMaybeRef",
            value: function loadMaybeRef() {
                if (this.loadBit()) return this.loadRef();
                else return null;
            }
        },
        {
            /**
     * Preload optional reference
     * @returns Cell or null
     */ key: "preloadMaybeRef",
            value: function preloadMaybeRef() {
                if (this.preloadBit()) return this.preloadRef();
                else return null;
            }
        },
        {
            /**
     * Load byte buffer
     * @param bytes number of bytes to load
     * @returns Buffer
     */ key: "loadBuffer",
            value: function loadBuffer(bytes) {
                return this._reader.loadBuffer(bytes);
            }
        },
        {
            /**
     * Load byte buffer
     * @param bytes number of bytes to load
     * @returns Buffer
     */ key: "preloadBuffer",
            value: function preloadBuffer(bytes) {
                return this._reader.preloadBuffer(bytes);
            }
        },
        {
            /**
     * Load string tail
     */ key: "loadStringTail",
            value: function loadStringTail() {
                return (0, $9zpaq.readString)(this);
            }
        },
        {
            /**
     * Load maybe string tail
     * @returns string or null
     */ key: "loadMaybeStringTail",
            value: function loadMaybeStringTail() {
                if (this.loadBit()) return (0, $9zpaq.readString)(this);
                else return null;
            }
        },
        {
            /**
     * Load string tail from ref
     * @returns string
     */ key: "loadStringRefTail",
            value: function loadStringRefTail() {
                return (0, $9zpaq.readString)(this.loadRef().beginParse());
            }
        },
        {
            /**
     * Load maybe string tail from ref
     * @returns string or null
     */ key: "loadMaybeStringRefTail",
            value: function loadMaybeStringRefTail() {
                var ref = this.loadMaybeRef();
                if (ref) return (0, $9zpaq.readString)(ref.beginParse());
                else return null;
            }
        },
        {
            /**
     * Loads dictionary
     * @param key key description
     * @param value value description
     * @returns Dictionary<K, V>
     */ key: "loadDict",
            value: function loadDict(key, value) {
                return $ihDv0.Dictionary.load(key, value, this);
            }
        },
        {
            /**
     * Loads dictionary directly from current slice
     * @param key key description
     * @param value value description
     * @returns Dictionary<K, V>
     */ key: "loadDictDirect",
            value: function loadDictDirect(key, value) {
                return $ihDv0.Dictionary.loadDirect(key, value, this);
            }
        },
        {
            /**
     * Checks if slice is empty
     */ key: "endParse",
            value: function endParse() {
                if (this.remainingBits > 0 || this.remainingRefs > 0) throw new Error("Slice is not empty");
            }
        },
        {
            /**
     * Convert slice to cell
     */ key: "asCell",
            value: function asCell() {
                return (0, $hARf4.beginCell)().storeSlice(this).endCell();
            }
        },
        {
            /**
     *
     * @returns
     */ key: "asBuilder",
            value: function asBuilder() {
                return (0, $hARf4.beginCell)().storeSlice(this);
            }
        },
        {
            /**
     * Clone slice
     * @returns cloned slice
     */ key: "clone",
            value: function clone() {
                var fromStart = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (fromStart) {
                    var reader = this._reader.clone();
                    reader.reset();
                    return new Slice(reader, this._refs);
                } else {
                    var res = new Slice(this._reader, this._refs);
                    res._refsOffset = this._refsOffset;
                    return res;
                }
            }
        },
        {
            /**
     * Print slice as string by converting it to cell
     * @returns string
     */ key: "toString",
            value: function toString() {
                return this.asCell().toString();
            }
        }
    ]);
    return Slice;
}();
module.exports.Slice = $7e3f1124b40b1cd1$var$Slice;
$7e3f1124b40b1cd1$var$_a = $7e3f1124b40b1cd1$var$symbol_inspect_1.default;

});
parcelRequire.register("ihDv0", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $8GFUW = parcelRequire("8GFUW");

var $1ObTH = parcelRequire("1ObTH");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $d4f8743e2b1cb6af$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dictionary = void 0;

var $gUPfK = parcelRequire("gUPfK");

var $hARf4 = parcelRequire("hARf4");

var $KH51V = parcelRequire("KH51V");

var $2RBGo = parcelRequire("2RBGo");

var $cMgGQ = parcelRequire("cMgGQ");

var $85rOZ = parcelRequire("85rOZ");
var $d4f8743e2b1cb6af$var$Dictionary = /*#__PURE__*/ function() {
    "use strict";
    function Dictionary(values, key, value) {
        (0, $978gY._)(this, Dictionary);
        this._key = key;
        this._value = value;
        this._map = values;
    }
    (0, $kry2a._)(Dictionary, [
        {
            key: "size",
            get: function get() {
                return this._map.size;
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this._map.get((0, $85rOZ.serializeInternalKey)(key));
            }
        },
        {
            key: "has",
            value: function has(key) {
                return this._map.has((0, $85rOZ.serializeInternalKey)(key));
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                this._map.set((0, $85rOZ.serializeInternalKey)(key), value);
                return this;
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                var k = (0, $85rOZ.serializeInternalKey)(key);
                return this._map.delete(k);
            }
        },
        {
            key: "clear",
            value: function clear() {
                this._map.clear();
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, k, v, key, err;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this._map[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            _step_value = (0, $8GFUW._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                            key = (0, $85rOZ.deserializeInternalKey)(k);
                            return [
                                4,
                                [
                                    key,
                                    v
                                ]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "keys",
            value: function keys() {
                return Array.from(this._map.keys()).map(function(v) {
                    return (0, $85rOZ.deserializeInternalKey)(v);
                });
            }
        },
        {
            key: "values",
            value: function values() {
                return Array.from(this._map.values());
            }
        },
        {
            key: "store",
            value: function store(builder, key, value) {
                if (this._map.size === 0) builder.storeBit(0);
                else {
                    // Resolve serializer
                    var resolvedKey = this._key;
                    if (key !== null && key !== undefined) resolvedKey = key;
                    var resolvedValue = this._value;
                    if (value !== null && value !== undefined) resolvedValue = value;
                    if (!resolvedKey) throw Error("Key serializer is not defined");
                    if (!resolvedValue) throw Error("Value serializer is not defined");
                    // Prepare map
                    var prepared = new Map();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this._map[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $8GFUW._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                            prepared.set(resolvedKey.serialize((0, $85rOZ.deserializeInternalKey)(k)), v);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // Store
                    builder.storeBit(1);
                    var dd = (0, $hARf4.beginCell)();
                    (0, $cMgGQ.serializeDict)(prepared, resolvedKey.bits, resolvedValue.serialize, dd);
                    builder.storeRef(dd.endCell());
                }
            }
        },
        {
            key: "storeDirect",
            value: function storeDirect(builder, key, value) {
                if (this._map.size === 0) throw Error("Cannot store empty dictionary directly");
                // Resolve serializer
                var resolvedKey = this._key;
                if (key !== null && key !== undefined) resolvedKey = key;
                var resolvedValue = this._value;
                if (value !== null && value !== undefined) resolvedValue = value;
                if (!resolvedKey) throw Error("Key serializer is not defined");
                if (!resolvedValue) throw Error("Value serializer is not defined");
                // Prepare map
                var prepared = new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._map[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $8GFUW._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                        prepared.set(resolvedKey.serialize((0, $85rOZ.deserializeInternalKey)(k)), v);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // Store
                (0, $cMgGQ.serializeDict)(prepared, resolvedKey.bits, resolvedValue.serialize, builder);
            }
        }
    ], [
        {
            key: "empty",
            value: /**
     * Create an empty map
     * @param key key type
     * @param value value type
     * @returns Dictionary<K, V>
     */ function empty(key, value) {
                if (key && value) return new Dictionary(new Map(), key, value);
                else return new Dictionary(new Map(), null, null);
            }
        },
        {
            key: "load",
            value: /**
     * Load dictionary from slice
     * @param key key description
     * @param value value description
     * @param src slice
     * @returns Dictionary<K, V>
     */ function load(key, value, sc) {
                var slice;
                if (sc instanceof $KH51V.Cell) {
                    if (sc.isExotic) return Dictionary.empty(key, value);
                    slice = sc.beginParse();
                } else slice = sc;
                var cell = slice.loadMaybeRef();
                if (cell && !cell.isExotic) return Dictionary.loadDirect(key, value, cell.beginParse());
                else return Dictionary.empty(key, value);
            }
        },
        {
            key: "loadDirect",
            value: /**
     * Low level method for rare dictionaries from system contracts.
     * Loads dictionary from slice directly without going to the ref.
     *
     * @param key key description
     * @param value value description
     * @param sc slice
     * @returns Dictionary<K, V>
     */ function loadDirect(key, value, sc) {
                if (!sc) return Dictionary.empty(key, value);
                var slice;
                if (sc instanceof $KH51V.Cell) slice = sc.beginParse();
                else slice = sc;
                var values = (0, $2RBGo.parseDict)(slice, key.bits, value.parse);
                var prepare = new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $8GFUW._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                        prepare.set((0, $85rOZ.serializeInternalKey)(key.parse(k)), v);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new Dictionary(prepare, key, value);
            }
        }
    ]);
    return Dictionary;
}();
module.exports.Dictionary = $d4f8743e2b1cb6af$var$Dictionary;
$d4f8743e2b1cb6af$var$Dictionary.Keys = {
    /**
     * Standard address key
     * @returns DictionaryKey<Address>
     */ Address: function() {
        return $d4f8743e2b1cb6af$var$createAddressKey();
    },
    /**
     * Create standard big integer key
     * @param bits number of bits
     * @returns DictionaryKey<bigint>
     */ BigInt: function(bits) {
        return $d4f8743e2b1cb6af$var$createBigIntKey(bits);
    },
    /**
     * Create integer key
     * @param bits bits of integer
     * @returns DictionaryKey<number>
     */ Int: function(bits) {
        return $d4f8743e2b1cb6af$var$createIntKey(bits);
    },
    /**
     * Create standard unsigned big integer key
     * @param bits number of bits
     * @returns DictionaryKey<bigint>
     */ BigUint: function(bits) {
        return $d4f8743e2b1cb6af$var$createBigUintKey(bits);
    },
    /**
     * Create standard unsigned integer key
     * @param bits number of bits
     * @returns DictionaryKey<number>
     */ Uint: function(bits) {
        return $d4f8743e2b1cb6af$var$createUintKey(bits);
    },
    /**
     * Create standard buffer key
     * @param bytes number of bytes of a buffer
     * @returns DictionaryKey<Buffer>
     */ Buffer: function(bytes) {
        return $d4f8743e2b1cb6af$var$createBufferKey(bytes);
    }
};
$d4f8743e2b1cb6af$var$Dictionary.Values = {
    /**
     * Create standard integer value
     * @returns DictionaryValue<bigint>
     */ BigInt: function(bits) {
        return $d4f8743e2b1cb6af$var$createBigIntValue(bits);
    },
    /**
     * Create standard integer value
     * @returns DictionaryValue<number>
     */ Int: function(bits) {
        return $d4f8743e2b1cb6af$var$createIntValue(bits);
    },
    /**
     * Create big var int
     * @param bits nubmer of header bits
     * @returns DictionaryValue<bigint>
     */ BigVarInt: function(bits) {
        return $d4f8743e2b1cb6af$var$createBigVarIntValue(bits);
    },
    /**
     * Create standard unsigned integer value
     * @param bits number of bits
     * @returns DictionaryValue<bigint>
     */ BigUint: function(bits) {
        return $d4f8743e2b1cb6af$var$createBigUintValue(bits);
    },
    /**
     * Create standard unsigned integer value
     * @param bits number of bits
     * @returns DictionaryValue<bigint>
     */ Uint: function(bits) {
        return $d4f8743e2b1cb6af$var$createUintValue(bits);
    },
    /**
     * Create big var int
     * @param bits nubmer of header bits
     * @returns DictionaryValue<bigint>
     */ BigVarUint: function(bits) {
        return $d4f8743e2b1cb6af$var$createBigVarUintValue(bits);
    },
    /**
     * Create standard boolean value
     * @returns DictionaryValue<boolean>
     */ Bool: function() {
        return $d4f8743e2b1cb6af$var$createBooleanValue();
    },
    /**
     * Create standard address value
     * @returns DictionaryValue<Address>
     */ Address: function() {
        return $d4f8743e2b1cb6af$var$createAddressValue();
    },
    /**
     * Create standard cell value
     * @returns DictionaryValue<Cell>
     */ Cell: function() {
        return $d4f8743e2b1cb6af$var$createCellValue();
    },
    /**
     * Create Builder value
     * @param bytes number of bytes of a buffer
     * @returns DictionaryValue<Builder>
     */ Buffer: function(bytes) {
        return $d4f8743e2b1cb6af$var$createBufferValue(bytes);
    },
    /**
     * Create dictionary value
     * @param key
     * @param value
     */ Dictionary: function(key, value) {
        return $d4f8743e2b1cb6af$var$createDictionaryValue(key, value);
    }
};
//
// Keys and Values
//
function $d4f8743e2b1cb6af$var$createAddressKey() {
    return {
        bits: 267,
        serialize: function(src) {
            if (!$gUPfK.Address.isAddress(src)) throw Error("Key is not an address");
            return (0, $hARf4.beginCell)().storeAddress(src).endCell().beginParse().preloadUintBig(267);
        },
        parse: function(src) {
            return (0, $hARf4.beginCell)().storeUint(src, 267).endCell().beginParse().loadAddress();
        }
    };
}
function $d4f8743e2b1cb6af$var$createBigIntKey(bits) {
    return {
        bits: bits,
        serialize: function(src) {
            if ((typeof src === "undefined" ? "undefined" : (0, $1ObTH._)(src)) !== "bigint") throw Error("Key is not a bigint");
            return (0, $hARf4.beginCell)().storeInt(src, bits).endCell().beginParse().loadUintBig(bits);
        },
        parse: function(src) {
            return (0, $hARf4.beginCell)().storeUint(src, bits).endCell().beginParse().loadIntBig(bits);
        }
    };
}
function $d4f8743e2b1cb6af$var$createIntKey(bits) {
    return {
        bits: bits,
        serialize: function(src) {
            if (typeof src !== "number") throw Error("Key is not a number");
            if (!Number.isSafeInteger(src)) throw Error("Key is not a safe integer: " + src);
            return (0, $hARf4.beginCell)().storeInt(src, bits).endCell().beginParse().loadUintBig(bits);
        },
        parse: function(src) {
            return (0, $hARf4.beginCell)().storeUint(src, bits).endCell().beginParse().loadInt(bits);
        }
    };
}
function $d4f8743e2b1cb6af$var$createBigUintKey(bits) {
    return {
        bits: bits,
        serialize: function(src) {
            if ((typeof src === "undefined" ? "undefined" : (0, $1ObTH._)(src)) !== "bigint") throw Error("Key is not a bigint");
            if (src < 0) throw Error("Key is negative: " + src);
            return (0, $hARf4.beginCell)().storeUint(src, bits).endCell().beginParse().loadUintBig(bits);
        },
        parse: function(src) {
            return (0, $hARf4.beginCell)().storeUint(src, bits).endCell().beginParse().loadUintBig(bits);
        }
    };
}
function $d4f8743e2b1cb6af$var$createUintKey(bits) {
    return {
        bits: bits,
        serialize: function(src) {
            if (typeof src !== "number") throw Error("Key is not a number");
            if (!Number.isSafeInteger(src)) throw Error("Key is not a safe integer: " + src);
            if (src < 0) throw Error("Key is negative: " + src);
            return (0, $hARf4.beginCell)().storeUint(src, bits).endCell().beginParse().loadUintBig(bits);
        },
        parse: function(src) {
            return Number((0, $hARf4.beginCell)().storeUint(src, bits).endCell().beginParse().loadUint(bits));
        }
    };
}
function $d4f8743e2b1cb6af$var$createBufferKey(bytes) {
    return {
        bits: bytes * 8,
        serialize: function(src) {
            if (!$d4f8743e2b1cb6af$require$Buffer.isBuffer(src)) throw Error("Key is not a buffer");
            return (0, $hARf4.beginCell)().storeBuffer(src).endCell().beginParse().loadUintBig(bytes * 8);
        },
        parse: function(src) {
            return (0, $hARf4.beginCell)().storeUint(src, bytes * 8).endCell().beginParse().loadBuffer(bytes);
        }
    };
}
function $d4f8743e2b1cb6af$var$createIntValue(bits) {
    return {
        serialize: function(src, buidler) {
            buidler.storeInt(src, bits);
        },
        parse: function(src) {
            return src.loadInt(bits);
        }
    };
}
function $d4f8743e2b1cb6af$var$createBigIntValue(bits) {
    return {
        serialize: function(src, buidler) {
            buidler.storeInt(src, bits);
        },
        parse: function(src) {
            return src.loadIntBig(bits);
        }
    };
}
function $d4f8743e2b1cb6af$var$createBigVarIntValue(bits) {
    return {
        serialize: function(src, buidler) {
            buidler.storeVarInt(src, bits);
        },
        parse: function(src) {
            return src.loadVarIntBig(bits);
        }
    };
}
function $d4f8743e2b1cb6af$var$createBigVarUintValue(bits) {
    return {
        serialize: function(src, buidler) {
            buidler.storeVarUint(src, bits);
        },
        parse: function(src) {
            return src.loadVarUintBig(bits);
        }
    };
}
function $d4f8743e2b1cb6af$var$createUintValue(bits) {
    return {
        serialize: function(src, buidler) {
            buidler.storeUint(src, bits);
        },
        parse: function(src) {
            return src.loadUint(bits);
        }
    };
}
function $d4f8743e2b1cb6af$var$createBigUintValue(bits) {
    return {
        serialize: function(src, buidler) {
            buidler.storeUint(src, bits);
        },
        parse: function(src) {
            return src.loadUintBig(bits);
        }
    };
}
function $d4f8743e2b1cb6af$var$createBooleanValue() {
    return {
        serialize: function(src, buidler) {
            buidler.storeBit(src);
        },
        parse: function(src) {
            return src.loadBit();
        }
    };
}
function $d4f8743e2b1cb6af$var$createAddressValue() {
    return {
        serialize: function(src, buidler) {
            buidler.storeAddress(src);
        },
        parse: function(src) {
            return src.loadAddress();
        }
    };
}
function $d4f8743e2b1cb6af$var$createCellValue() {
    return {
        serialize: function(src, buidler) {
            buidler.storeRef(src);
        },
        parse: function(src) {
            return src.loadRef();
        }
    };
}
function $d4f8743e2b1cb6af$var$createDictionaryValue(key, value) {
    return {
        serialize: function(src, buidler) {
            src.store(buidler);
        },
        parse: function(src) {
            return $d4f8743e2b1cb6af$var$Dictionary.load(key, value, src);
        }
    };
}
function $d4f8743e2b1cb6af$var$createBufferValue(size) {
    return {
        serialize: function(src, buidler) {
            if (src.length !== size) throw Error("Invalid buffer size");
            buidler.storeBuffer(src);
        },
        parse: function(src) {
            return src.loadBuffer(size);
        }
    };
}

});
parcelRequire.register("2RBGo", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseDict = void 0;
function $215dc30a00e6fa9e$var$readUnaryLength(slice) {
    var res = 0;
    while(slice.loadBit())res++;
    return res;
}
function $215dc30a00e6fa9e$var$doParse(prefix, slice, n, res, extractor) {
    // Reading label
    var lb0 = slice.loadBit() ? 1 : 0;
    var prefixLength = 0;
    var pp = prefix;
    if (lb0 === 0) {
        // Short label detected
        // Read 
        prefixLength = $215dc30a00e6fa9e$var$readUnaryLength(slice);
        // Read prefix
        for(var i = 0; i < prefixLength; i++)pp += slice.loadBit() ? "1" : "0";
    } else {
        var lb1 = slice.loadBit() ? 1 : 0;
        if (lb1 === 0) {
            // Long label detected
            prefixLength = slice.loadUint(Math.ceil(Math.log2(n + 1)));
            for(var i1 = 0; i1 < prefixLength; i1++)pp += slice.loadBit() ? "1" : "0";
        } else {
            // Same label detected
            var bit = slice.loadBit() ? "1" : "0";
            prefixLength = slice.loadUint(Math.ceil(Math.log2(n + 1)));
            for(var i2 = 0; i2 < prefixLength; i2++)pp += bit;
        }
    }
    if (n - prefixLength === 0) res.set(BigInt("0b" + pp), extractor(slice));
    else {
        var left = slice.loadRef();
        var right = slice.loadRef();
        // NOTE: Left and right branches are implicitly contain prefixes '0' and '1'
        if (!left.isExotic) $215dc30a00e6fa9e$var$doParse(pp + "0", left.beginParse(), n - prefixLength - 1, res, extractor);
        if (!right.isExotic) $215dc30a00e6fa9e$var$doParse(pp + "1", right.beginParse(), n - prefixLength - 1, res, extractor);
    }
}
function $215dc30a00e6fa9e$var$parseDict(sc, keySize, extractor) {
    var res = new Map();
    if (sc) $215dc30a00e6fa9e$var$doParse("", sc, keySize, res, extractor);
    return res;
}
module.exports.parseDict = $215dc30a00e6fa9e$var$parseDict;

});

parcelRequire.register("cMgGQ", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serializeDict = module.exports.detectLabelType = module.exports.writeLabelSame = module.exports.writeLabelLong = module.exports.writeLabelShort = module.exports.buildTree = void 0;

var $hARf4 = parcelRequire("hARf4");

var $11brX = parcelRequire("11brX");
//
// Tree Build
//
function $94d6ea04b6b2da2d$var$pad(src, size) {
    while(src.length < size)src = "0" + src;
    return src;
}
function $94d6ea04b6b2da2d$var$removePrefixMap(src, length) {
    if (length === 0) return src;
    else {
        var res = new Map();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = src.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var k = _step.value;
                var d = src.get(k);
                res.set(k.slice(length), d);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return res;
    }
}
function $94d6ea04b6b2da2d$var$forkMap(src) {
    if (src.size === 0) throw Error("Internal inconsistency");
    var left = new Map();
    var right = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = src.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var k = _step.value;
            var d = src.get(k);
            if (k.startsWith("0")) left.set(k.substr(1), d);
            else right.set(k.substr(1), d);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (left.size === 0) throw Error("Internal inconsistency. Left emtpy.");
    if (right.size === 0) throw Error("Internal inconsistency. Right emtpy.");
    return {
        left: left,
        right: right
    };
}
function $94d6ea04b6b2da2d$var$buildNode(src) {
    if (src.size === 0) throw Error("Internal inconsistency");
    if (src.size === 1) return {
        type: "leaf",
        value: Array.from(src.values())[0]
    };
    var _forkMap = $94d6ea04b6b2da2d$var$forkMap(src), left = _forkMap.left, right = _forkMap.right;
    return {
        type: "fork",
        left: $94d6ea04b6b2da2d$var$buildEdge(left),
        right: $94d6ea04b6b2da2d$var$buildEdge(right)
    };
}
function $94d6ea04b6b2da2d$var$buildEdge(src) {
    if (src.size === 0) throw Error("Internal inconsistency");
    var label = (0, $11brX.findCommonPrefix)(Array.from(src.keys()));
    return {
        label: label,
        node: $94d6ea04b6b2da2d$var$buildNode($94d6ea04b6b2da2d$var$removePrefixMap(src, label.length))
    };
}
function $94d6ea04b6b2da2d$var$buildTree(src, keyLength) {
    // Convert map keys
    var converted = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Array.from(src.keys())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var k = _step.value;
            var padded = $94d6ea04b6b2da2d$var$pad(k.toString(2), keyLength);
            converted.set(padded, src.get(k));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Calculate root label
    return $94d6ea04b6b2da2d$var$buildEdge(converted);
}
module.exports.buildTree = $94d6ea04b6b2da2d$var$buildTree;
//
// Serialization
//
function $94d6ea04b6b2da2d$var$writeLabelShort(src, to) {
    // Header
    to.storeBit(0);
    // Unary length
    for(var i = 0; i < src.length; i++)to.storeBit(1);
    to.storeBit(0);
    // Value
    for(var i1 = 0; i1 < src.length; i1++)to.storeBit(src[i1] === "1");
    return to;
}
module.exports.writeLabelShort = $94d6ea04b6b2da2d$var$writeLabelShort;
function $94d6ea04b6b2da2d$var$labelShortLength(src) {
    return 1 + src.length + 1 + src.length;
}
function $94d6ea04b6b2da2d$var$writeLabelLong(src, keyLength, to) {
    // Header
    to.storeBit(1);
    to.storeBit(0);
    // Length
    var length = Math.ceil(Math.log2(keyLength + 1));
    to.storeUint(src.length, length);
    // Value
    for(var i = 0; i < src.length; i++)to.storeBit(src[i] === "1");
    return to;
}
module.exports.writeLabelLong = $94d6ea04b6b2da2d$var$writeLabelLong;
function $94d6ea04b6b2da2d$var$labelLongLength(src, keyLength) {
    return 2 + Math.ceil(Math.log2(keyLength + 1)) + src.length;
}
function $94d6ea04b6b2da2d$var$writeLabelSame(value, length, keyLength, to) {
    // Header
    to.storeBit(1);
    to.storeBit(1);
    // Value
    to.storeBit(value);
    // Length
    var lenLen = Math.ceil(Math.log2(keyLength + 1));
    to.storeUint(length, lenLen);
}
module.exports.writeLabelSame = $94d6ea04b6b2da2d$var$writeLabelSame;
function $94d6ea04b6b2da2d$var$labelSameLength(keyLength) {
    return 3 + Math.ceil(Math.log2(keyLength + 1));
}
function $94d6ea04b6b2da2d$var$isSame(src) {
    if (src.length === 0 || src.length === 1) return true;
    for(var i = 1; i < src.length; i++){
        if (src[i] !== src[0]) return false;
    }
    return true;
}
function $94d6ea04b6b2da2d$var$detectLabelType(src, keyLength) {
    var kind = "short";
    var kindLength = $94d6ea04b6b2da2d$var$labelShortLength(src);
    var longLength = $94d6ea04b6b2da2d$var$labelLongLength(src, keyLength);
    if (longLength < kindLength) {
        kindLength = longLength;
        kind = "long";
    }
    if ($94d6ea04b6b2da2d$var$isSame(src)) {
        var sameLength = $94d6ea04b6b2da2d$var$labelSameLength(keyLength);
        if (sameLength < kindLength) {
            kindLength = sameLength;
            kind = "same";
        }
    }
    return kind;
}
module.exports.detectLabelType = $94d6ea04b6b2da2d$var$detectLabelType;
function $94d6ea04b6b2da2d$var$writeLabel(src, keyLength, to) {
    var type = $94d6ea04b6b2da2d$var$detectLabelType(src, keyLength);
    if (type === "short") $94d6ea04b6b2da2d$var$writeLabelShort(src, to);
    if (type === "long") $94d6ea04b6b2da2d$var$writeLabelLong(src, keyLength, to);
    if (type === "same") $94d6ea04b6b2da2d$var$writeLabelSame(src[0] === "1", src.length, keyLength, to);
}
function $94d6ea04b6b2da2d$var$writeNode(src, keyLength, serializer, to) {
    if (src.type === "leaf") serializer(src.value, to);
    if (src.type === "fork") {
        var leftCell = (0, $hARf4.beginCell)();
        var rightCell = (0, $hARf4.beginCell)();
        $94d6ea04b6b2da2d$var$writeEdge(src.left, keyLength - 1, serializer, leftCell);
        $94d6ea04b6b2da2d$var$writeEdge(src.right, keyLength - 1, serializer, rightCell);
        to.storeRef(leftCell);
        to.storeRef(rightCell);
    }
}
function $94d6ea04b6b2da2d$var$writeEdge(src, keyLength, serializer, to) {
    $94d6ea04b6b2da2d$var$writeLabel(src.label, keyLength, to);
    $94d6ea04b6b2da2d$var$writeNode(src.node, keyLength - src.label.length, serializer, to);
}
function $94d6ea04b6b2da2d$var$serializeDict(src, keyLength, serializer, to) {
    var tree = $94d6ea04b6b2da2d$var$buildTree(src, keyLength);
    $94d6ea04b6b2da2d$var$writeEdge(tree, keyLength, serializer, to);
}
module.exports.serializeDict = $94d6ea04b6b2da2d$var$serializeDict;

});
parcelRequire.register("11brX", function(module, exports) {

var $fLnyw = parcelRequire("fLnyw");
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findCommonPrefix = void 0;
function $0bdec424de99a3dc$var$findCommonPrefix(src) {
    // Corner cases
    if (src.length === 0) return "";
    if (src.length === 1) return src[0];
    // Searching for prefix
    var sorted = (0, $fLnyw._)(src).sort();
    var size = 0;
    for(var i = 0; i < sorted[0].length; i++){
        if (sorted[0][i] !== sorted[sorted.length - 1][i]) break;
        size++;
    }
    return src[0].slice(0, size);
}
module.exports.findCommonPrefix = $0bdec424de99a3dc$var$findCommonPrefix;

});


parcelRequire.register("85rOZ", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");

var $gzLuY = parcelRequire("gzLuY");
var $5e345f1caa1c494d$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deserializeInternalKey = module.exports.serializeInternalKey = void 0;

var $gUPfK = parcelRequire("gUPfK");
function $5e345f1caa1c494d$var$serializeInternalKey(value) {
    if (typeof value === "number") {
        if (!Number.isSafeInteger(value)) throw Error("Invalid key type: not a safe integer: " + value);
        return "n:" + value.toString(10);
    } else if ((typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value)) === "bigint") return "b:" + value.toString(10);
    else if ($gUPfK.Address.isAddress(value)) return "a:" + value.toString();
    else if ($5e345f1caa1c494d$require$Buffer.isBuffer(value)) return "f:" + value.toString("hex");
    else throw Error("Invalid key type");
}
module.exports.serializeInternalKey = $5e345f1caa1c494d$var$serializeInternalKey;
function $5e345f1caa1c494d$var$deserializeInternalKey(value) {
    var k = value.slice(0, 2);
    var v = value.slice(2);
    if (k === "n:") return parseInt(v, 10);
    else if (k === "b:") return BigInt(v);
    else if (k === "a:") return $gUPfK.Address.parse(v);
    else if (k === "f:") return $5e345f1caa1c494d$require$Buffer.from(v, "hex");
    throw Error("Invalid key type: " + k);
}
module.exports.deserializeInternalKey = $5e345f1caa1c494d$var$deserializeInternalKey;

});


parcelRequire.register("9zpaq", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $6f7ae79ff1ee28ab$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.writeString = module.exports.stringToCell = module.exports.readString = void 0;

var $hARf4 = parcelRequire("hARf4");
function $6f7ae79ff1ee28ab$var$readBuffer(slice) {
    // Check consistency
    if (slice.remainingBits % 8 !== 0) throw new Error("Invalid string length: ".concat(slice.remainingBits));
    if (slice.remainingRefs !== 0 && slice.remainingRefs !== 1) throw new Error("invalid number of refs: ".concat(slice.remainingRefs));
    if (slice.remainingRefs === 1 && 1023 - slice.remainingBits > 7) throw new Error("invalid string length: ".concat(slice.remainingBits / 8));
    // Read string
    var res;
    if (slice.remainingBits === 0) res = $6f7ae79ff1ee28ab$require$Buffer.alloc(0);
    else res = slice.loadBuffer(slice.remainingBits / 8);
    // Read tail
    if (slice.remainingRefs === 1) res = $6f7ae79ff1ee28ab$require$Buffer.concat([
        res,
        $6f7ae79ff1ee28ab$var$readBuffer(slice.loadRef().beginParse())
    ]);
    return res;
}
function $6f7ae79ff1ee28ab$var$readString(slice) {
    return $6f7ae79ff1ee28ab$var$readBuffer(slice).toString();
}
module.exports.readString = $6f7ae79ff1ee28ab$var$readString;
function $6f7ae79ff1ee28ab$var$writeBuffer(src, builder) {
    if (src.length > 0) {
        var bytes = Math.floor(builder.availableBits / 8);
        if (src.length > bytes) {
            var a = src.subarray(0, bytes);
            var t = src.subarray(bytes);
            builder = builder.storeBuffer(a);
            var bb = (0, $hARf4.beginCell)();
            $6f7ae79ff1ee28ab$var$writeBuffer(t, bb);
            builder = builder.storeRef(bb.endCell());
        } else builder = builder.storeBuffer(src);
    }
}
function $6f7ae79ff1ee28ab$var$stringToCell(src) {
    var builder = (0, $hARf4.beginCell)();
    $6f7ae79ff1ee28ab$var$writeBuffer($6f7ae79ff1ee28ab$require$Buffer.from(src), builder);
    return builder.endCell();
}
module.exports.stringToCell = $6f7ae79ff1ee28ab$var$stringToCell;
function $6f7ae79ff1ee28ab$var$writeString(src, builder) {
    $6f7ae79ff1ee28ab$var$writeBuffer($6f7ae79ff1ee28ab$require$Buffer.from(src), builder);
}
module.exports.writeString = $6f7ae79ff1ee28ab$var$writeString;

});


parcelRequire.register("fJkBI", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveExotic = void 0;

var $6RnAU = parcelRequire("6RnAU");

var $d57eA = parcelRequire("d57eA");

var $kIWna = parcelRequire("kIWna");

var $1gFCA = parcelRequire("1gFCA");

var $4VD0f = parcelRequire("4VD0f");

var $ba2C3 = parcelRequire("ba2C3");

var $kw2z6 = parcelRequire("kw2z6");
function $b73b0b2ffc0a38d0$var$resolvePruned(bits, refs) {
    // Parse pruned cell
    var pruned = (0, $ba2C3.exoticPruned)(bits, refs);
    // Calculate parameters
    var depths = [];
    var hashes = [];
    var mask = new $kw2z6.LevelMask(pruned.mask);
    for(var i = 0; i < pruned.pruned.length; i++){
        depths.push(pruned.pruned[i].depth);
        hashes.push(pruned.pruned[i].hash);
    }
    return {
        type: $d57eA.CellType.PrunedBranch,
        depths: depths,
        hashes: hashes,
        mask: mask
    };
}
function $b73b0b2ffc0a38d0$var$resolveLibrary(bits, refs) {
    // Parse library cell
    var pruned = (0, $kIWna.exoticLibrary)(bits, refs);
    // Calculate parameters
    var depths = [];
    var hashes = [];
    var mask = new $kw2z6.LevelMask();
    return {
        type: $d57eA.CellType.Library,
        depths: depths,
        hashes: hashes,
        mask: mask
    };
}
function $b73b0b2ffc0a38d0$var$resolveMerkleProof(bits, refs) {
    // Parse merkle proof cell
    var merkleProof = (0, $1gFCA.exoticMerkleProof)(bits, refs);
    // Calculate parameters
    var depths = [];
    var hashes = [];
    var mask = new $kw2z6.LevelMask(refs[0].level() >> 1);
    return {
        type: $d57eA.CellType.MerkleProof,
        depths: depths,
        hashes: hashes,
        mask: mask
    };
}
function $b73b0b2ffc0a38d0$var$resolveMerkleUpdate(bits, refs) {
    // Parse merkle proof cell
    var merkleUpdate = (0, $4VD0f.exoticMerkleUpdate)(bits, refs);
    // Calculate parameters
    var depths = [];
    var hashes = [];
    var mask = new $kw2z6.LevelMask((refs[0].level() | refs[1].level()) >> 1);
    return {
        type: $d57eA.CellType.MerkleUpdate,
        depths: depths,
        hashes: hashes,
        mask: mask
    };
}
function $b73b0b2ffc0a38d0$var$resolveExotic(bits, refs) {
    var reader = new $6RnAU.BitReader(bits);
    var type = reader.preloadUint(8);
    if (type === 1) return $b73b0b2ffc0a38d0$var$resolvePruned(bits, refs);
    if (type === 2) return $b73b0b2ffc0a38d0$var$resolveLibrary(bits, refs);
    if (type === 3) return $b73b0b2ffc0a38d0$var$resolveMerkleProof(bits, refs);
    if (type === 4) return $b73b0b2ffc0a38d0$var$resolveMerkleUpdate(bits, refs);
    throw Error("Invalid exotic cell type: " + type);
}
module.exports.resolveExotic = $b73b0b2ffc0a38d0$var$resolveExotic;

});
parcelRequire.register("6RnAU", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $gzLuY = parcelRequire("gzLuY");
var $4fe9fea1482a3da3$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BitReader = void 0;

var $gUPfK = parcelRequire("gUPfK");

var $jEXEj = parcelRequire("jEXEj");
/**
 * Class for reading bit strings
 */ var $4fe9fea1482a3da3$var$BitReader = /*#__PURE__*/ function() {
    "use strict";
    function BitReader(bits) {
        var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $978gY._)(this, BitReader);
        this._checkpoints = [];
        this._bits = bits;
        this._offset = offset;
    }
    (0, $kry2a._)(BitReader, [
        {
            key: "offset",
            get: /**
     * Offset in source bit string
     */ function get() {
                return this._offset;
            }
        },
        {
            key: "remaining",
            get: /**
     * Number of bits remaining
     */ function get() {
                return this._bits.length - this._offset;
            }
        },
        {
            /**
     * Skip bits
     * @param bits number of bits to skip
     */ key: "skip",
            value: function skip(bits) {
                if (bits < 0 || this._offset + bits > this._bits.length) throw new Error("Index ".concat(this._offset + bits, " is out of bounds"));
                this._offset += bits;
            }
        },
        {
            /**
     * Reset to the beginning or latest checkpoint
     */ key: "reset",
            value: function reset() {
                if (this._checkpoints.length > 0) this._offset = this._checkpoints.pop();
                else this._offset = 0;
            }
        },
        {
            /**
     * Save checkpoint
     */ key: "save",
            value: function save() {
                this._checkpoints.push(this._offset);
            }
        },
        {
            /**
     * Load a single bit
     * @returns true if the bit is set, false otherwise
     */ key: "loadBit",
            value: function loadBit() {
                var r = this._bits.at(this._offset);
                this._offset++;
                return r;
            }
        },
        {
            /**
     * Preload bit
     * @returns true if the bit is set, false otherwise
     */ key: "preloadBit",
            value: function preloadBit() {
                return this._bits.at(this._offset);
            }
        },
        {
            /**
     * Load bit string
     * @param bits number of bits to read
     * @returns new bitstring
     */ key: "loadBits",
            value: function loadBits(bits) {
                var r = this._bits.substring(this._offset, bits);
                this._offset += bits;
                return r;
            }
        },
        {
            /**
     * Preload bit string
     * @param bits number of bits to read
     * @returns new bitstring
     */ key: "preloadBits",
            value: function preloadBits(bits) {
                return this._bits.substring(this._offset, bits);
            }
        },
        {
            /**
     * Load buffer
     * @param bytes number of bytes
     * @returns new buffer
     */ key: "loadBuffer",
            value: function loadBuffer(bytes) {
                var buf = this._preloadBuffer(bytes, this._offset);
                this._offset += bytes * 8;
                return buf;
            }
        },
        {
            /**
     * Preload buffer
     * @param bytes number of bytes
     * @returns new buffer
     */ key: "preloadBuffer",
            value: function preloadBuffer(bytes) {
                return this._preloadBuffer(bytes, this._offset);
            }
        },
        {
            /**
     * Load uint value
     * @param bits uint bits
     * @returns read value as number
     */ key: "loadUint",
            value: function loadUint(bits) {
                return Number(this.loadUintBig(bits));
            }
        },
        {
            /**
     * Load uint value as bigint
     * @param bits uint bits
     * @returns read value as bigint
     */ key: "loadUintBig",
            value: function loadUintBig(bits) {
                var loaded = this.preloadUintBig(bits);
                this._offset += bits;
                return loaded;
            }
        },
        {
            /**
     * Preload uint value
     * @param bits uint bits
     * @returns read value as number
     */ key: "preloadUint",
            value: function preloadUint(bits) {
                return Number(this._preloadUint(bits, this._offset));
            }
        },
        {
            /**
     * Preload uint value as bigint
     * @param bits uint bits
     * @returns read value as bigint
     */ key: "preloadUintBig",
            value: function preloadUintBig(bits) {
                return this._preloadUint(bits, this._offset);
            }
        },
        {
            /**
     * Load int value
     * @param bits int bits
     * @returns read value as bigint
     */ key: "loadInt",
            value: function loadInt(bits) {
                var res = this._preloadInt(bits, this._offset);
                this._offset += bits;
                return Number(res);
            }
        },
        {
            /**
     * Load int value as bigint
     * @param bits int bits
     * @returns read value as bigint
     */ key: "loadIntBig",
            value: function loadIntBig(bits) {
                var res = this._preloadInt(bits, this._offset);
                this._offset += bits;
                return res;
            }
        },
        {
            /**
     * Preload int value
     * @param bits int bits
     * @returns read value as bigint
     */ key: "preloadInt",
            value: function preloadInt(bits) {
                return Number(this._preloadInt(bits, this._offset));
            }
        },
        {
            /**
     * Preload int value
     * @param bits int bits
     * @returns read value as bigint
     */ key: "preloadIntBig",
            value: function preloadIntBig(bits) {
                return this._preloadInt(bits, this._offset);
            }
        },
        {
            /**
     * Load varuint value
     * @param bits number of bits to read the size
     * @returns read value as bigint
     */ key: "loadVarUint",
            value: function loadVarUint(bits) {
                var size = Number(this.loadUint(bits));
                return Number(this.loadUintBig(size * 8));
            }
        },
        {
            /**
     * Load varuint value
     * @param bits number of bits to read the size
     * @returns read value as bigint
     */ key: "loadVarUintBig",
            value: function loadVarUintBig(bits) {
                var size = Number(this.loadUint(bits));
                return this.loadUintBig(size * 8);
            }
        },
        {
            /**
     * Preload varuint value
     * @param bits number of bits to read the size
     * @returns read value as bigint
     */ key: "preloadVarUint",
            value: function preloadVarUint(bits) {
                var size = Number(this._preloadUint(bits, this._offset));
                return Number(this._preloadUint(size * 8, this._offset + bits));
            }
        },
        {
            /**
     * Preload varuint value
     * @param bits number of bits to read the size
     * @returns read value as bigint
     */ key: "preloadVarUintBig",
            value: function preloadVarUintBig(bits) {
                var size = Number(this._preloadUint(bits, this._offset));
                return this._preloadUint(size * 8, this._offset + bits);
            }
        },
        {
            /**
     * Load varint value
     * @param bits number of bits to read the size
     * @returns read value as bigint
     */ key: "loadVarInt",
            value: function loadVarInt(bits) {
                var size = Number(this.loadUint(bits));
                return Number(this.loadIntBig(size * 8));
            }
        },
        {
            /**
     * Load varint value
     * @param bits number of bits to read the size
     * @returns read value as bigint
     */ key: "loadVarIntBig",
            value: function loadVarIntBig(bits) {
                var size = Number(this.loadUint(bits));
                return this.loadIntBig(size * 8);
            }
        },
        {
            /**
     * Preload varint value
     * @param bits number of bits to read the size
     * @returns read value as bigint
     */ key: "preloadVarInt",
            value: function preloadVarInt(bits) {
                var size = Number(this._preloadUint(bits, this._offset));
                return Number(this._preloadInt(size * 8, this._offset + bits));
            }
        },
        {
            /**
     * Preload varint value
     * @param bits number of bits to read the size
     * @returns read value as bigint
     */ key: "preloadVarIntBig",
            value: function preloadVarIntBig(bits) {
                var size = Number(this._preloadUint(bits, this._offset));
                return this._preloadInt(size * 8, this._offset + bits);
            }
        },
        {
            /**
     * Load coins value
     * @returns read value as bigint
     */ key: "loadCoins",
            value: function loadCoins() {
                return this.loadVarUintBig(4);
            }
        },
        {
            /**
     * Preload coins value
     * @returns read value as bigint
     */ key: "preloadCoins",
            value: function preloadCoins() {
                return this.preloadVarUintBig(4);
            }
        },
        {
            /**
     * Load Address
     * @returns Address
     */ key: "loadAddress",
            value: function loadAddress() {
                var type = Number(this._preloadUint(2, this._offset));
                if (type === 2) return this._loadInternalAddress();
                else throw new Error("Invalid address: " + type);
            }
        },
        {
            /**
     * Load internal address
     * @returns Address or null
     */ key: "loadMaybeAddress",
            value: function loadMaybeAddress() {
                var type = Number(this._preloadUint(2, this._offset));
                if (type === 0) {
                    this._offset += 2;
                    return null;
                } else if (type === 2) return this._loadInternalAddress();
                else throw new Error("Invalid address");
            }
        },
        {
            /**
     * Load external address
     * @returns ExternalAddress
     */ key: "loadExternalAddress",
            value: function loadExternalAddress() {
                var type = Number(this._preloadUint(2, this._offset));
                if (type === 1) return this._loadExternalAddress();
                else throw new Error("Invalid address");
            }
        },
        {
            /**
     * Load external address
     * @returns ExternalAddress or null
     */ key: "loadMaybeExternalAddress",
            value: function loadMaybeExternalAddress() {
                var type = Number(this._preloadUint(2, this._offset));
                if (type === 0) {
                    this._offset += 2;
                    return null;
                } else if (type === 1) return this._loadExternalAddress();
                else throw new Error("Invalid address");
            }
        },
        {
            /**
     * Read address of any type
     * @returns Address or ExternalAddress or null
     */ key: "loadAddressAny",
            value: function loadAddressAny() {
                var type = Number(this._preloadUint(2, this._offset));
                if (type === 0) {
                    this._offset += 2;
                    return null;
                } else if (type === 2) return this._loadInternalAddress();
                else if (type === 1) return this._loadExternalAddress();
                else if (type === 3) throw Error("Unsupported");
                else throw Error("Unreachable");
            }
        },
        {
            /**
     * Load bit string that was padded to make it byte alligned. Used in BOC serialization
     * @param bytes number of bytes to read
     */ key: "loadPaddedBits",
            value: function loadPaddedBits(bits) {
                // Check that number of bits is byte alligned
                if (bits % 8 !== 0) throw new Error("Invalid number of bits");
                // Skip padding
                var length = bits;
                while(true)if (this._bits.at(this._offset + length - 1)) {
                    length--;
                    break;
                } else length--;
                // Read substring
                var r = this._bits.substring(this._offset, length);
                this._offset += bits;
                return r;
            }
        },
        {
            /**
     * Clone BitReader
     */ key: "clone",
            value: function clone() {
                return new BitReader(this._bits, this._offset);
            }
        },
        {
            /**
     * Preload int from specific offset
     * @param bits bits to preload
     * @param offset offset to start from
     * @returns read value as bigint
     */ key: "_preloadInt",
            value: function _preloadInt(bits, offset) {
                if (bits == 0) return 0n;
                var sign = this._bits.at(offset);
                var res = 0n;
                for(var i = 0; i < bits - 1; i++)if (this._bits.at(offset + 1 + i)) res += 1n << BigInt(bits - i - 1 - 1);
                if (sign) res = res - (1n << BigInt(bits - 1));
                return res;
            }
        },
        {
            /**
     * Preload uint from specific offset
     * @param bits bits to preload
     * @param offset offset to start from
     * @returns read value as bigint
     */ key: "_preloadUint",
            value: function _preloadUint(bits, offset) {
                if (bits == 0) return 0n;
                var res = 0n;
                for(var i = 0; i < bits; i++)if (this._bits.at(offset + i)) res += 1n << BigInt(bits - i - 1);
                return res;
            }
        },
        {
            key: "_preloadBuffer",
            value: function _preloadBuffer(bytes, offset) {
                // Try to load fast
                var fastBuffer = this._bits.subbuffer(offset, bytes * 8);
                if (fastBuffer) return fastBuffer;
                // Load slow
                var buf = $4fe9fea1482a3da3$require$Buffer.alloc(bytes);
                for(var i = 0; i < bytes; i++)buf[i] = Number(this._preloadUint(8, offset + i * 8));
                return buf;
            }
        },
        {
            key: "_loadInternalAddress",
            value: function _loadInternalAddress() {
                var type = Number(this._preloadUint(2, this._offset));
                if (type !== 2) throw Error("Invalid address");
                // No Anycast supported
                if (this._preloadUint(1, this._offset + 2) !== 0n) throw Error("Invalid address");
                // Read address
                var wc = Number(this._preloadInt(8, this._offset + 3));
                var hash = this._preloadBuffer(32, this._offset + 11);
                // Update offset
                this._offset += 267;
                return new $gUPfK.Address(wc, hash);
            }
        },
        {
            key: "_loadExternalAddress",
            value: function _loadExternalAddress() {
                var type = Number(this._preloadUint(2, this._offset));
                if (type !== 1) throw Error("Invalid address");
                // Load length
                var bits = Number(this._preloadUint(9, this._offset + 2));
                // Load address
                var value = this._preloadUint(bits, this._offset + 11);
                // Update offset
                this._offset += 11 + bits;
                return new $jEXEj.ExternalAddress(value, bits);
            }
        }
    ]);
    return BitReader;
}();
module.exports.BitReader = $4fe9fea1482a3da3$var$BitReader;

});

parcelRequire.register("kIWna", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.exoticLibrary = void 0;

var $6RnAU = parcelRequire("6RnAU");
function $f165324fbf1c5e90$var$exoticLibrary(bits, refs) {
    var reader = new $6RnAU.BitReader(bits);
    // type + hash
    var size = 264;
    if (bits.length !== size) throw new Error('Library cell must have exactly (8 + 256) bits, got "'.concat(bits.length, '"'));
    // Check type
    var type = reader.loadUint(8);
    if (type !== 2) throw new Error('Library cell must have type 2, got "'.concat(type, '"'));
    return {};
}
module.exports.exoticLibrary = $f165324fbf1c5e90$var$exoticLibrary;

});

parcelRequire.register("1gFCA", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.exoticMerkleProof = void 0;

var $6RnAU = parcelRequire("6RnAU");
function $0ec7923625d3ae0c$var$exoticMerkleProof(bits, refs) {
    var reader = new $6RnAU.BitReader(bits);
    // type + hash + depth
    var size = 280;
    if (bits.length !== size) throw new Error('Merkle Proof cell must have exactly (8 + 256 + 16) bits, got "'.concat(bits.length, '"'));
    if (refs.length !== 1) throw new Error('Merkle Proof cell must have exactly 1 ref, got "'.concat(refs.length, '"'));
    // Check type
    var type = reader.loadUint(8);
    if (type !== 3) throw new Error('Merkle Proof cell must have type 3, got "'.concat(type, '"'));
    // Check data
    var proofHash = reader.loadBuffer(32);
    var proofDepth = reader.loadUint(16);
    var refHash = refs[0].hash(0);
    var refDepth = refs[0].depth(0);
    if (proofDepth !== refDepth) throw new Error('Merkle Proof cell ref depth must be exactly "'.concat(proofDepth, '", got "').concat(refDepth, '"'));
    if (!proofHash.equals(refHash)) throw new Error('Merkle Proof cell ref hash must be exactly "'.concat(proofHash.toString("hex"), '", got "').concat(refHash.toString("hex"), '"'));
    return {
        proofDepth: proofDepth,
        proofHash: proofHash
    };
}
module.exports.exoticMerkleProof = $0ec7923625d3ae0c$var$exoticMerkleProof;

});

parcelRequire.register("4VD0f", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.exoticMerkleUpdate = void 0;

var $6RnAU = parcelRequire("6RnAU");
function $396abd74e2dddae0$var$exoticMerkleUpdate(bits, refs) {
    var reader = new $6RnAU.BitReader(bits);
    // type + hash + hash + depth + depth
    var size = 552;
    if (bits.length !== size) throw new Error('Merkle Update cell must have exactly (8 + (2 * (256 + 16))) bits, got "'.concat(bits.length, '"'));
    if (refs.length !== 2) throw new Error('Merkle Update cell must have exactly 2 refs, got "'.concat(refs.length, '"'));
    var type = reader.loadUint(8);
    if (type !== 4) throw new Error('Merkle Update cell type must be exactly 4, got "'.concat(type, '"'));
    var proofHash1 = reader.loadBuffer(32);
    var proofHash2 = reader.loadBuffer(32);
    var proofDepth1 = reader.loadUint(16);
    var proofDepth2 = reader.loadUint(16);
    if (proofDepth1 !== refs[0].depth(0)) throw new Error('Merkle Update cell ref depth must be exactly "'.concat(proofDepth1, '", got "').concat(refs[0].depth(0), '"'));
    if (!proofHash1.equals(refs[0].hash(0))) throw new Error('Merkle Update cell ref hash must be exactly "'.concat(proofHash1.toString("hex"), '", got "').concat(refs[0].hash(0).toString("hex"), '"'));
    if (proofDepth2 !== refs[1].depth(0)) throw new Error('Merkle Update cell ref depth must be exactly "'.concat(proofDepth2, '", got "').concat(refs[1].depth(0), '"'));
    if (!proofHash2.equals(refs[1].hash(0))) throw new Error('Merkle Update cell ref hash must be exactly "'.concat(proofHash2.toString("hex"), '", got "').concat(refs[1].hash(0).toString("hex"), '"'));
    return {
        proofDepth1: proofDepth1,
        proofDepth2: proofDepth2,
        proofHash1: proofHash1,
        proofHash2: proofHash2
    };
}
module.exports.exoticMerkleUpdate = $396abd74e2dddae0$var$exoticMerkleUpdate;

});

parcelRequire.register("ba2C3", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.exoticPruned = void 0;

var $6RnAU = parcelRequire("6RnAU");

var $kw2z6 = parcelRequire("kw2z6");
function $8202a7b86771b6cf$var$exoticPruned(bits, refs) {
    var reader = new $6RnAU.BitReader(bits);
    // Check type
    var type = reader.loadUint(8);
    if (type !== 1) throw new Error('Pruned branch cell must have type 1, got "'.concat(type, '"'));
    // Check refs
    if (refs.length !== 0) throw new Error("Pruned Branch cell can't has refs, got \"".concat(refs.length, '"'));
    // Resolve cell
    var mask;
    if (bits.length === 280) // Special case for config proof
    // This test proof is generated in the moment of voting for a slashing
    // it seems that tools generate it incorrectly and therefore doesn't have mask in it
    // so we need to hardcode it equal to 1
    mask = new $kw2z6.LevelMask(1);
    else {
        // Check level
        mask = new $kw2z6.LevelMask(reader.loadUint(8));
        if (mask.level < 1 || mask.level > 3) throw new Error('Pruned Branch cell level must be >= 1 and <= 3, got "'.concat(mask.level, "/").concat(mask.value, '"'));
        // Read pruned
        var size = 16 + mask.apply(mask.level - 1).hashCount * 272 /* Depth */ ;
        if (bits.length !== size) throw new Error("Pruned branch cell must have exactly ".concat(size, ' bits, got "').concat(bits.length, '"'));
    }
    // Read pruned
    var pruned = [];
    var hashes = [];
    var depths = [];
    for(var i = 0; i < mask.level; i++)hashes.push(reader.loadBuffer(32));
    for(var i1 = 0; i1 < mask.level; i1++)depths.push(reader.loadUint(16));
    for(var i2 = 0; i2 < mask.level; i2++)pruned.push({
        depth: depths[i2],
        hash: hashes[i2]
    });
    return {
        mask: mask.value,
        pruned: pruned
    };
}
module.exports.exoticPruned = $8202a7b86771b6cf$var$exoticPruned;

});
parcelRequire.register("kw2z6", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LevelMask = void 0;
var $eef8c935f56f9b9f$var$LevelMask = /*#__PURE__*/ function() {
    function LevelMask() {
        var mask = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        (0, $978gY._)(this, LevelMask);
        this._mask = 0;
        this._mask = mask;
        this._hashIndex = $eef8c935f56f9b9f$var$countSetBits(this._mask);
        this._hashCount = this._hashIndex + 1;
    }
    (0, $kry2a._)(LevelMask, [
        {
            key: "value",
            get: function get() {
                return this._mask;
            }
        },
        {
            key: "level",
            get: function get() {
                return 32 - Math.clz32(this._mask);
            }
        },
        {
            key: "hashIndex",
            get: function get() {
                return this._hashIndex;
            }
        },
        {
            key: "hashCount",
            get: function get() {
                return this._hashCount;
            }
        },
        {
            key: "apply",
            value: function apply(level) {
                return new LevelMask(this._mask & (1 << level) - 1);
            }
        },
        {
            key: "isSignificant",
            value: function isSignificant(level) {
                var res = level === 0 || (this._mask >> level - 1) % 2 !== 0;
                return res;
            // bool res = level == 0 | | ( (mask_ >> (level -1)) % 2 != 0);
            }
        }
    ]);
    return LevelMask;
}();
module.exports.LevelMask = $eef8c935f56f9b9f$var$LevelMask;
function $eef8c935f56f9b9f$var$countSetBits(n) {
    n = n - (n >> 1 & 0x55555555);
    n = (n & 0x33333333) + (n >> 2 & 0x33333333);
    return (n + (n >> 4) & 0xF0F0F0F) * 0x1010101 >> 24;
}

});



parcelRequire.register("4XP5P", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wonderCalculator = void 0;

var $iSKta = parcelRequire("iSKta");

var $d57eA = parcelRequire("d57eA");

var $kw2z6 = parcelRequire("kw2z6");

var $ba2C3 = parcelRequire("ba2C3");

var $1gFCA = parcelRequire("1gFCA");

var $2Orby = parcelRequire("2Orby");

var $lusx3 = parcelRequire("lusx3");

var $4VD0f = parcelRequire("4VD0f");

var $kIWna = parcelRequire("kIWna");
//
// This function replicates unknown logic of resolving cell data
// https://github.com/ton-blockchain/ton/blob/24dc184a2ea67f9c47042b4104bbb4d82289fac1/crypto/vm/cells/DataCell.cpp#L214
//
function $39d44e199334200c$var$wonderCalculator(type, bits, refs) {
    //
    // Resolving level mask
    //
    var levelMask;
    var pruned = null;
    if (type === $d57eA.CellType.Ordinary) {
        var mask = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = refs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                mask = mask | r.mask.value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        levelMask = new $kw2z6.LevelMask(mask);
    } else if (type === $d57eA.CellType.PrunedBranch) {
        // Parse pruned
        pruned = (0, $ba2C3.exoticPruned)(bits, refs);
        // Load level
        levelMask = new $kw2z6.LevelMask(pruned.mask);
    } else if (type === $d57eA.CellType.MerkleProof) {
        // Parse proof
        var loaded = (0, $1gFCA.exoticMerkleProof)(bits, refs);
        // Load level
        levelMask = new $kw2z6.LevelMask(refs[0].mask.value >> 1);
    } else if (type === $d57eA.CellType.MerkleUpdate) {
        // Parse update
        var loaded1 = (0, $4VD0f.exoticMerkleUpdate)(bits, refs);
        // Load level
        levelMask = new $kw2z6.LevelMask((refs[0].mask.value | refs[1].mask.value) >> 1);
    } else if (type === $d57eA.CellType.Library) {
        // Parse library
        var loaded2 = (0, $kIWna.exoticLibrary)(bits, refs);
        // Load level
        levelMask = new $kw2z6.LevelMask();
    } else throw new Error("Unsupported exotic type");
    //
    // Calculate hashes and depths
    // NOTE: https://github.com/ton-blockchain/ton/blob/24dc184a2ea67f9c47042b4104bbb4d82289fac1/crypto/vm/cells/DataCell.cpp#L214
    //
    var depths = [];
    var hashes = [];
    var hashCount = type === $d57eA.CellType.PrunedBranch ? 1 : levelMask.hashCount;
    var totalHashCount = levelMask.hashCount;
    var hashIOffset = totalHashCount - hashCount;
    for(var levelI = 0, hashI = 0; levelI <= levelMask.level; levelI++){
        if (!levelMask.isSignificant(levelI)) continue;
        if (hashI < hashIOffset) {
            hashI++;
            continue;
        }
        //
        // Bits
        //
        var currentBits = void 0;
        if (hashI === hashIOffset) {
            if (!(levelI === 0 || type === $d57eA.CellType.PrunedBranch)) throw Error("Invalid");
            currentBits = bits;
        } else {
            if (!(levelI !== 0 && type !== $d57eA.CellType.PrunedBranch)) throw Error("Invalid: " + levelI + ", " + type);
            currentBits = new $iSKta.BitString(hashes[hashI - hashIOffset - 1], 0, 256);
        }
        //
        // Depth
        //
        var currentDepth = 0;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = refs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var c = _step1.value;
                var childDepth = void 0;
                if (type == $d57eA.CellType.MerkleProof || type == $d57eA.CellType.MerkleUpdate) childDepth = c.depth(levelI + 1);
                else childDepth = c.depth(levelI);
                currentDepth = Math.max(currentDepth, childDepth);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (refs.length > 0) currentDepth++;
        //
        // Hash
        //
        var repr = (0, $2Orby.getRepr)(bits, currentBits, refs, levelI, type);
        var hash = (0, $lusx3.sha256_sync)(repr);
        //
        // Persist next
        //
        var destI = hashI - hashIOffset;
        depths[destI] = currentDepth;
        hashes[destI] = hash;
        //
        // Next
        //
        hashI++;
    }
    //
    // Calculate hash and depth for all levels
    //
    var resolvedHashes = [];
    var resolvedDepths = [];
    if (pruned) for(var i = 0; i < 4; i++){
        var hashIndex = levelMask.apply(i).hashIndex;
        var thisHashIndex = levelMask.hashIndex;
        if (hashIndex !== thisHashIndex) {
            resolvedHashes.push(pruned.pruned[hashIndex].hash);
            resolvedDepths.push(pruned.pruned[hashIndex].depth);
        } else {
            resolvedHashes.push(hashes[0]);
            resolvedDepths.push(depths[0]);
        }
    }
    else for(var i1 = 0; i1 < 4; i1++){
        resolvedHashes.push(hashes[levelMask.apply(i1).hashIndex]);
        resolvedDepths.push(depths[levelMask.apply(i1).hashIndex]);
    }
    //
    // Result
    //
    return {
        mask: levelMask,
        hashes: resolvedHashes,
        depths: resolvedDepths
    };
}
module.exports.wonderCalculator = $39d44e199334200c$var$wonderCalculator;

});
parcelRequire.register("2Orby", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $20c556b53446f431$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRepr = module.exports.getBitsDescriptor = module.exports.getRefsDescriptor = void 0;

var $d57eA = parcelRequire("d57eA");

var $hm8RK = parcelRequire("hm8RK");
function $20c556b53446f431$var$getRefsDescriptor(refs, level, type) {
    return refs.length + (type !== $d57eA.CellType.Ordinary ? 1 : 0) * 8 + level * 32;
}
module.exports.getRefsDescriptor = $20c556b53446f431$var$getRefsDescriptor;
function $20c556b53446f431$var$getBitsDescriptor(bits) {
    var len = bits.length;
    return Math.ceil(len / 8) + Math.floor(len / 8);
}
module.exports.getBitsDescriptor = $20c556b53446f431$var$getBitsDescriptor;
function $20c556b53446f431$var$getRepr(originalBits, bits, refs, level, type) {
    // Allocate
    var bitsLen = Math.ceil(bits.length / 8);
    var repr = $20c556b53446f431$require$Buffer.alloc(2 + bitsLen + 34 * refs.length);
    // Write descriptors
    var reprCursor = 0;
    repr[reprCursor++] = $20c556b53446f431$var$getRefsDescriptor(refs, level, type);
    repr[reprCursor++] = $20c556b53446f431$var$getBitsDescriptor(originalBits);
    // Write bits
    (0, $hm8RK.bitsToPaddedBuffer)(bits).copy(repr, reprCursor);
    reprCursor += bitsLen;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Write refs
        for(var _iterator = refs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var c = _step.value;
            var childDepth = void 0;
            if (type == $d57eA.CellType.MerkleProof || type == $d57eA.CellType.MerkleUpdate) childDepth = c.depth(level + 1);
            else childDepth = c.depth(level);
            repr[reprCursor++] = Math.floor(childDepth / 256);
            repr[reprCursor++] = childDepth % 256;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = refs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var c1 = _step1.value;
            var childHash = void 0;
            if (type == $d57eA.CellType.MerkleProof || type == $d57eA.CellType.MerkleUpdate) childHash = c1.hash(level + 1);
            else childHash = c1.hash(level);
            childHash.copy(repr, reprCursor);
            reprCursor += 32;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    // Result
    return repr;
}
module.exports.getRepr = $20c556b53446f431$var$getRepr;

});

parcelRequire.register("lusx3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMnemonicsMasterKeyFromSeed = module.exports.deriveMnemonicHardenedKey = module.exports.deriveMnemonicsPath = module.exports.deriveSymmetricPath = module.exports.deriveSymmetricHardenedKey = module.exports.getSymmetricMasterKeyFromSeed = module.exports.deriveEd25519Path = module.exports.deriveED25519HardenedKey = module.exports.getED25519MasterKeyFromSeed = module.exports.signVerify = module.exports.sign = module.exports.keyPairFromSecretKey = module.exports.keyPairFromSeed = module.exports.openBox = module.exports.sealBox = module.exports.mnemonicWordList = module.exports.mnemonicToHDSeed = module.exports.mnemonicToSeed = module.exports.mnemonicToWalletKey = module.exports.mnemonicToPrivateKey = module.exports.mnemonicValidate = module.exports.mnemonicNew = module.exports.newSecurePassphrase = module.exports.newSecureWords = module.exports.getSecureRandomNumber = module.exports.getSecureRandomWords = module.exports.getSecureRandomBytes = module.exports.hmac_sha512 = module.exports.pbkdf2_sha512 = module.exports.sha512_sync = module.exports.sha512 = module.exports.sha256_sync = module.exports.sha256 = void 0;

var $4GnQ6 = parcelRequire("4GnQ6");
Object.defineProperty(module.exports, "sha256", {
    enumerable: true,
    get: function get() {
        return $4GnQ6.sha256;
    }
});
Object.defineProperty(module.exports, "sha256_sync", {
    enumerable: true,
    get: function get() {
        return $4GnQ6.sha256_sync;
    }
});

var $fVK8f = parcelRequire("fVK8f");
Object.defineProperty(module.exports, "sha512", {
    enumerable: true,
    get: function get() {
        return $fVK8f.sha512;
    }
});
Object.defineProperty(module.exports, "sha512_sync", {
    enumerable: true,
    get: function get() {
        return $fVK8f.sha512_sync;
    }
});

var $9zWqD = parcelRequire("9zWqD");
Object.defineProperty(module.exports, "pbkdf2_sha512", {
    enumerable: true,
    get: function get() {
        return $9zWqD.pbkdf2_sha512;
    }
});

var $6C3Y6 = parcelRequire("6C3Y6");
Object.defineProperty(module.exports, "hmac_sha512", {
    enumerable: true,
    get: function get() {
        return $6C3Y6.hmac_sha512;
    }
});

var $eCOtR = parcelRequire("eCOtR");
Object.defineProperty(module.exports, "getSecureRandomBytes", {
    enumerable: true,
    get: function get() {
        return $eCOtR.getSecureRandomBytes;
    }
});
Object.defineProperty(module.exports, "getSecureRandomWords", {
    enumerable: true,
    get: function get() {
        return $eCOtR.getSecureRandomWords;
    }
});
Object.defineProperty(module.exports, "getSecureRandomNumber", {
    enumerable: true,
    get: function get() {
        return $eCOtR.getSecureRandomNumber;
    }
});

var $alT6g = parcelRequire("alT6g");
Object.defineProperty(module.exports, "newSecureWords", {
    enumerable: true,
    get: function get() {
        return $alT6g.newSecureWords;
    }
});

var $hNtXf = parcelRequire("hNtXf");
Object.defineProperty(module.exports, "newSecurePassphrase", {
    enumerable: true,
    get: function get() {
        return $hNtXf.newSecurePassphrase;
    }
});

var $hObSB = parcelRequire("hObSB");
Object.defineProperty(module.exports, "mnemonicNew", {
    enumerable: true,
    get: function get() {
        return $hObSB.mnemonicNew;
    }
});
Object.defineProperty(module.exports, "mnemonicValidate", {
    enumerable: true,
    get: function get() {
        return $hObSB.mnemonicValidate;
    }
});
Object.defineProperty(module.exports, "mnemonicToPrivateKey", {
    enumerable: true,
    get: function get() {
        return $hObSB.mnemonicToPrivateKey;
    }
});
Object.defineProperty(module.exports, "mnemonicToWalletKey", {
    enumerable: true,
    get: function get() {
        return $hObSB.mnemonicToWalletKey;
    }
});
Object.defineProperty(module.exports, "mnemonicToSeed", {
    enumerable: true,
    get: function get() {
        return $hObSB.mnemonicToSeed;
    }
});
Object.defineProperty(module.exports, "mnemonicToHDSeed", {
    enumerable: true,
    get: function get() {
        return $hObSB.mnemonicToHDSeed;
    }
});

var $a75QT = parcelRequire("a75QT");
Object.defineProperty(module.exports, "mnemonicWordList", {
    enumerable: true,
    get: function get() {
        return $a75QT.wordlist;
    }
});

var $lRPkH = parcelRequire("lRPkH");
Object.defineProperty(module.exports, "sealBox", {
    enumerable: true,
    get: function get() {
        return $lRPkH.sealBox;
    }
});
Object.defineProperty(module.exports, "openBox", {
    enumerable: true,
    get: function get() {
        return $lRPkH.openBox;
    }
});

var $lRPkH = parcelRequire("lRPkH");
Object.defineProperty(module.exports, "keyPairFromSeed", {
    enumerable: true,
    get: function get() {
        return $lRPkH.keyPairFromSeed;
    }
});
Object.defineProperty(module.exports, "keyPairFromSecretKey", {
    enumerable: true,
    get: function get() {
        return $lRPkH.keyPairFromSecretKey;
    }
});
Object.defineProperty(module.exports, "sign", {
    enumerable: true,
    get: function get() {
        return $lRPkH.sign;
    }
});
Object.defineProperty(module.exports, "signVerify", {
    enumerable: true,
    get: function get() {
        return $lRPkH.signVerify;
    }
});

var $3kBUi = parcelRequire("3kBUi");
Object.defineProperty(module.exports, "getED25519MasterKeyFromSeed", {
    enumerable: true,
    get: function get() {
        return $3kBUi.getED25519MasterKeyFromSeed;
    }
});
Object.defineProperty(module.exports, "deriveED25519HardenedKey", {
    enumerable: true,
    get: function get() {
        return $3kBUi.deriveED25519HardenedKey;
    }
});
Object.defineProperty(module.exports, "deriveEd25519Path", {
    enumerable: true,
    get: function get() {
        return $3kBUi.deriveEd25519Path;
    }
});

var $gK3Ew = parcelRequire("gK3Ew");
Object.defineProperty(module.exports, "getSymmetricMasterKeyFromSeed", {
    enumerable: true,
    get: function get() {
        return $gK3Ew.getSymmetricMasterKeyFromSeed;
    }
});
Object.defineProperty(module.exports, "deriveSymmetricHardenedKey", {
    enumerable: true,
    get: function get() {
        return $gK3Ew.deriveSymmetricHardenedKey;
    }
});
Object.defineProperty(module.exports, "deriveSymmetricPath", {
    enumerable: true,
    get: function get() {
        return $gK3Ew.deriveSymmetricPath;
    }
});

var $3hYtT = parcelRequire("3hYtT");
Object.defineProperty(module.exports, "deriveMnemonicsPath", {
    enumerable: true,
    get: function get() {
        return $3hYtT.deriveMnemonicsPath;
    }
});
Object.defineProperty(module.exports, "deriveMnemonicHardenedKey", {
    enumerable: true,
    get: function get() {
        return $3hYtT.deriveMnemonicHardenedKey;
    }
});
Object.defineProperty(module.exports, "getMnemonicsMasterKeyFromSeed", {
    enumerable: true,
    get: function get() {
        return $3hYtT.getMnemonicsMasterKeyFromSeed;
    }
});

});
parcelRequire.register("4GnQ6", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $368d93aad73ff1bf$require$Buffer = $gzLuY.Buffer;
"use strict";
var $368d93aad73ff1bf$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha256 = module.exports.sha256_fallback = module.exports.sha256_sync = void 0;

var $368d93aad73ff1bf$var$jssha_1 = $368d93aad73ff1bf$var$__importDefault((parcelRequire("bWEWP")));

var $dnZ53 = parcelRequire("dnZ53");
function $368d93aad73ff1bf$var$sha256_sync(source) {
    var src;
    if (typeof source === "string") src = $368d93aad73ff1bf$require$Buffer.from(source, "utf-8").toString("hex");
    else src = source.toString("hex");
    var hasher = new $368d93aad73ff1bf$var$jssha_1.default("SHA-256", "HEX");
    hasher.update(src);
    var res = hasher.getHash("HEX");
    return $368d93aad73ff1bf$require$Buffer.from(res, "hex");
}
module.exports.sha256_sync = $368d93aad73ff1bf$var$sha256_sync;
function $368d93aad73ff1bf$var$sha256_fallback(source) {
    return $368d93aad73ff1bf$var$_sha256_fallback.apply(this, arguments);
}
function $368d93aad73ff1bf$var$_sha256_fallback() {
    $368d93aad73ff1bf$var$_sha256_fallback = (0, $byzP8._)(function(source) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $368d93aad73ff1bf$var$sha256_sync(source)
            ];
        });
    });
    return $368d93aad73ff1bf$var$_sha256_fallback.apply(this, arguments);
}
module.exports.sha256_fallback = $368d93aad73ff1bf$var$sha256_fallback;
function $368d93aad73ff1bf$var$sha256(source) {
    return (0, $dnZ53.sha256)(source);
}
module.exports.sha256 = $368d93aad73ff1bf$var$sha256;

});
parcelRequire.register("dnZ53", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha512 = module.exports.sha256 = module.exports.pbkdf2_sha512 = module.exports.hmac_sha512 = module.exports.getSecureRandomWords = module.exports.getSecureRandomBytes = void 0;

var $cmYgJ = parcelRequire("cmYgJ");
Object.defineProperty(module.exports, "getSecureRandomBytes", {
    enumerable: true,
    get: function get() {
        return $cmYgJ.getSecureRandomBytes;
    }
});
Object.defineProperty(module.exports, "getSecureRandomWords", {
    enumerable: true,
    get: function get() {
        return $cmYgJ.getSecureRandomWords;
    }
});

var $g0Gl8 = parcelRequire("g0Gl8");
Object.defineProperty(module.exports, "hmac_sha512", {
    enumerable: true,
    get: function get() {
        return $g0Gl8.hmac_sha512;
    }
});

var $dZfqj = parcelRequire("dZfqj");
Object.defineProperty(module.exports, "pbkdf2_sha512", {
    enumerable: true,
    get: function get() {
        return $dZfqj.pbkdf2_sha512;
    }
});

var $g0nx1 = parcelRequire("g0nx1");
Object.defineProperty(module.exports, "sha256", {
    enumerable: true,
    get: function get() {
        return $g0nx1.sha256;
    }
});

var $7vEMn = parcelRequire("7vEMn");
Object.defineProperty(module.exports, "sha512", {
    enumerable: true,
    get: function get() {
        return $7vEMn.sha512;
    }
});

});
parcelRequire.register("cmYgJ", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $90164a43204097a5$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSecureRandomWords = module.exports.getSecureRandomBytes = void 0;
function $90164a43204097a5$var$getSecureRandomBytes(size) {
    return $90164a43204097a5$require$Buffer.from(window.crypto.getRandomValues(new Uint8Array(size)));
}
module.exports.getSecureRandomBytes = $90164a43204097a5$var$getSecureRandomBytes;
function $90164a43204097a5$var$getSecureRandomWords(size) {
    return window.crypto.getRandomValues(new Uint16Array(size));
}
module.exports.getSecureRandomWords = $90164a43204097a5$var$getSecureRandomWords;

});

parcelRequire.register("g0Gl8", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $ba7d7d3e5f0d98d2$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac_sha512 = void 0;
function $ba7d7d3e5f0d98d2$var$hmac_sha512(key, data) {
    return $ba7d7d3e5f0d98d2$var$_hmac_sha512.apply(this, arguments);
}
function $ba7d7d3e5f0d98d2$var$_hmac_sha512() {
    $ba7d7d3e5f0d98d2$var$_hmac_sha512 = (0, $byzP8._)(function(key, data) {
        var keyBuffer, dataBuffer, hmacAlgo, hmacKey, _;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    keyBuffer = typeof key === "string" ? $ba7d7d3e5f0d98d2$require$Buffer.from(key, "utf-8") : key;
                    dataBuffer = typeof data === "string" ? $ba7d7d3e5f0d98d2$require$Buffer.from(data, "utf-8") : data;
                    hmacAlgo = {
                        name: "HMAC",
                        hash: "SHA-512"
                    };
                    return [
                        4,
                        window.crypto.subtle.importKey("raw", keyBuffer, hmacAlgo, false, [
                            "sign"
                        ])
                    ];
                case 1:
                    hmacKey = _state.sent();
                    _ = $ba7d7d3e5f0d98d2$require$Buffer.from;
                    return [
                        4,
                        crypto.subtle.sign(hmacAlgo, hmacKey, dataBuffer)
                    ];
                case 2:
                    return [
                        2,
                        _.apply($ba7d7d3e5f0d98d2$require$Buffer, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return $ba7d7d3e5f0d98d2$var$_hmac_sha512.apply(this, arguments);
}
module.exports.hmac_sha512 = $ba7d7d3e5f0d98d2$var$hmac_sha512;

});

parcelRequire.register("dZfqj", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $a2ecef9cd3c0d53f$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pbkdf2_sha512 = void 0;
function $a2ecef9cd3c0d53f$var$pbkdf2_sha512(key, salt, iterations, keyLen) {
    return $a2ecef9cd3c0d53f$var$_pbkdf2_sha512.apply(this, arguments);
}
function $a2ecef9cd3c0d53f$var$_pbkdf2_sha512() {
    $a2ecef9cd3c0d53f$var$_pbkdf2_sha512 = (0, $byzP8._)(function(key, salt, iterations, keyLen) {
        var keyBuffer, saltBuffer, pbkdf2_key, derivedBits;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    keyBuffer = typeof key === "string" ? $a2ecef9cd3c0d53f$require$Buffer.from(key, "utf-8") : key;
                    saltBuffer = typeof salt === "string" ? $a2ecef9cd3c0d53f$require$Buffer.from(salt, "utf-8") : salt;
                    return [
                        4,
                        window.crypto.subtle.importKey("raw", keyBuffer, {
                            name: "PBKDF2"
                        }, false, [
                            "deriveBits"
                        ])
                    ];
                case 1:
                    pbkdf2_key = _state.sent();
                    return [
                        4,
                        window.crypto.subtle.deriveBits({
                            name: "PBKDF2",
                            hash: "SHA-512",
                            salt: saltBuffer,
                            iterations: iterations
                        }, pbkdf2_key, keyLen * 8)
                    ];
                case 2:
                    derivedBits = _state.sent();
                    return [
                        2,
                        $a2ecef9cd3c0d53f$require$Buffer.from(derivedBits)
                    ];
            }
        });
    });
    return $a2ecef9cd3c0d53f$var$_pbkdf2_sha512.apply(this, arguments);
}
module.exports.pbkdf2_sha512 = $a2ecef9cd3c0d53f$var$pbkdf2_sha512;

});

parcelRequire.register("g0nx1", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $ba6ee64ba4887fe5$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha256 = void 0;
function $ba6ee64ba4887fe5$var$sha256(source) {
    return $ba6ee64ba4887fe5$var$_sha256.apply(this, arguments);
}
function $ba6ee64ba4887fe5$var$_sha256() {
    $ba6ee64ba4887fe5$var$_sha256 = (0, $byzP8._)(function(source) {
        var _, _1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(typeof source === "string")) return [
                        3,
                        2
                    ];
                    _ = $ba6ee64ba4887fe5$require$Buffer.from;
                    return [
                        4,
                        crypto.subtle.digest("SHA-256", $ba6ee64ba4887fe5$require$Buffer.from(source, "utf-8"))
                    ];
                case 1:
                    return [
                        2,
                        _.apply($ba6ee64ba4887fe5$require$Buffer, [
                            _state.sent()
                        ])
                    ];
                case 2:
                    _1 = $ba6ee64ba4887fe5$require$Buffer.from;
                    return [
                        4,
                        crypto.subtle.digest("SHA-256", source)
                    ];
                case 3:
                    return [
                        2,
                        _1.apply($ba6ee64ba4887fe5$require$Buffer, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return $ba6ee64ba4887fe5$var$_sha256.apply(this, arguments);
}
module.exports.sha256 = $ba6ee64ba4887fe5$var$sha256;

});

parcelRequire.register("7vEMn", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $577b0f90f963126b$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha512 = void 0;
function $577b0f90f963126b$var$sha512(source) {
    return $577b0f90f963126b$var$_sha512.apply(this, arguments);
}
function $577b0f90f963126b$var$_sha512() {
    $577b0f90f963126b$var$_sha512 = (0, $byzP8._)(function(source) {
        var _, _1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(typeof source === "string")) return [
                        3,
                        2
                    ];
                    _ = $577b0f90f963126b$require$Buffer.from;
                    return [
                        4,
                        crypto.subtle.digest("SHA-512", $577b0f90f963126b$require$Buffer.from(source, "utf-8"))
                    ];
                case 1:
                    return [
                        2,
                        _.apply($577b0f90f963126b$require$Buffer, [
                            _state.sent()
                        ])
                    ];
                case 2:
                    _1 = $577b0f90f963126b$require$Buffer.from;
                    return [
                        4,
                        crypto.subtle.digest("SHA-512", source)
                    ];
                case 3:
                    return [
                        2,
                        _1.apply($577b0f90f963126b$require$Buffer, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return $577b0f90f963126b$var$_sha512.apply(this, arguments);
}
module.exports.sha512 = $577b0f90f963126b$var$sha512;

});



parcelRequire.register("fVK8f", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $b98ff6bee5852c15$require$Buffer = $gzLuY.Buffer;
"use strict";
var $b98ff6bee5852c15$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha512 = module.exports.sha512_fallback = module.exports.sha512_sync = void 0;

var $b98ff6bee5852c15$var$jssha_1 = $b98ff6bee5852c15$var$__importDefault((parcelRequire("bWEWP")));

var $dnZ53 = parcelRequire("dnZ53");
function $b98ff6bee5852c15$var$sha512_sync(source) {
    var src;
    if (typeof source === "string") src = $b98ff6bee5852c15$require$Buffer.from(source, "utf-8").toString("hex");
    else src = source.toString("hex");
    var hasher = new $b98ff6bee5852c15$var$jssha_1.default("SHA-512", "HEX");
    hasher.update(src);
    var res = hasher.getHash("HEX");
    return $b98ff6bee5852c15$require$Buffer.from(res, "hex");
}
module.exports.sha512_sync = $b98ff6bee5852c15$var$sha512_sync;
function $b98ff6bee5852c15$var$sha512_fallback(source) {
    return $b98ff6bee5852c15$var$_sha512_fallback.apply(this, arguments);
}
function $b98ff6bee5852c15$var$_sha512_fallback() {
    $b98ff6bee5852c15$var$_sha512_fallback = (0, $byzP8._)(function(source) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $b98ff6bee5852c15$var$sha512_sync(source)
            ];
        });
    });
    return $b98ff6bee5852c15$var$_sha512_fallback.apply(this, arguments);
}
module.exports.sha512_fallback = $b98ff6bee5852c15$var$sha512_fallback;
function $b98ff6bee5852c15$var$sha512(source) {
    return $b98ff6bee5852c15$var$_sha512.apply(this, arguments);
}
function $b98ff6bee5852c15$var$_sha512() {
    $b98ff6bee5852c15$var$_sha512 = (0, $byzP8._)(function(source) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                (0, $dnZ53.sha512)(source)
            ];
        });
    });
    return $b98ff6bee5852c15$var$_sha512.apply(this, arguments);
}
module.exports.sha512 = $b98ff6bee5852c15$var$sha512;

});

parcelRequire.register("9zWqD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pbkdf2_sha512 = void 0;

var $dnZ53 = parcelRequire("dnZ53");
function $6f94b4a7edf307c3$var$pbkdf2_sha512(key, salt, iterations, keyLen) {
    return (0, $dnZ53.pbkdf2_sha512)(key, salt, iterations, keyLen);
}
module.exports.pbkdf2_sha512 = $6f94b4a7edf307c3$var$pbkdf2_sha512;

});

parcelRequire.register("6C3Y6", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $4d095ebb388a9208$require$Buffer = $gzLuY.Buffer;
"use strict";
var $4d095ebb388a9208$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac_sha512 = module.exports.hmac_sha512_fallback = void 0;

var $4d095ebb388a9208$var$jssha_1 = $4d095ebb388a9208$var$__importDefault((parcelRequire("bWEWP")));

var $dnZ53 = parcelRequire("dnZ53");
function $4d095ebb388a9208$var$hmac_sha512_fallback(key, data) {
    return $4d095ebb388a9208$var$_hmac_sha512_fallback.apply(this, arguments);
}
function $4d095ebb388a9208$var$_hmac_sha512_fallback() {
    $4d095ebb388a9208$var$_hmac_sha512_fallback = (0, $byzP8._)(function(key, data) {
        var keyBuffer, dataBuffer, shaObj, hmac;
        return (0, $7UAGh.__generator)(this, function(_state) {
            keyBuffer = typeof key === "string" ? $4d095ebb388a9208$require$Buffer.from(key, "utf-8") : key;
            dataBuffer = typeof data === "string" ? $4d095ebb388a9208$require$Buffer.from(data, "utf-8") : data;
            shaObj = new $4d095ebb388a9208$var$jssha_1.default("SHA-512", "HEX", {
                hmacKey: {
                    value: keyBuffer.toString("hex"),
                    format: "HEX"
                }
            });
            shaObj.update(dataBuffer.toString("hex"));
            hmac = shaObj.getHash("HEX");
            return [
                2,
                $4d095ebb388a9208$require$Buffer.from(hmac, "hex")
            ];
        });
    });
    return $4d095ebb388a9208$var$_hmac_sha512_fallback.apply(this, arguments);
}
module.exports.hmac_sha512_fallback = $4d095ebb388a9208$var$hmac_sha512_fallback;
function $4d095ebb388a9208$var$hmac_sha512(key, data) {
    return (0, $dnZ53.hmac_sha512)(key, data);
}
module.exports.hmac_sha512 = $4d095ebb388a9208$var$hmac_sha512;

});

parcelRequire.register("eCOtR", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSecureRandomNumber = module.exports.getSecureRandomWords = module.exports.getSecureRandomBytes = void 0;

var $dnZ53 = parcelRequire("dnZ53");
function $aa5bc5b55a645401$var$getSecureRandomBytes(size) {
    return $aa5bc5b55a645401$var$_getSecureRandomBytes.apply(this, arguments);
}
function $aa5bc5b55a645401$var$_getSecureRandomBytes() {
    $aa5bc5b55a645401$var$_getSecureRandomBytes = (0, $byzP8._)(function(size) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                (0, $dnZ53.getSecureRandomBytes)(size)
            ];
        });
    });
    return $aa5bc5b55a645401$var$_getSecureRandomBytes.apply(this, arguments);
}
module.exports.getSecureRandomBytes = $aa5bc5b55a645401$var$getSecureRandomBytes;
function $aa5bc5b55a645401$var$getSecureRandomWords(size) {
    return $aa5bc5b55a645401$var$_getSecureRandomWords.apply(this, arguments);
}
function $aa5bc5b55a645401$var$_getSecureRandomWords() {
    $aa5bc5b55a645401$var$_getSecureRandomWords = (0, $byzP8._)(function(size) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $aa5bc5b55a645401$var$getSecureRandomWords(size)
            ];
        });
    });
    return $aa5bc5b55a645401$var$_getSecureRandomWords.apply(this, arguments);
}
module.exports.getSecureRandomWords = $aa5bc5b55a645401$var$getSecureRandomWords;
function $aa5bc5b55a645401$var$getSecureRandomNumber(min, max) {
    return $aa5bc5b55a645401$var$_getSecureRandomNumber.apply(this, arguments);
}
function $aa5bc5b55a645401$var$_getSecureRandomNumber() {
    $aa5bc5b55a645401$var$_getSecureRandomNumber = (0, $byzP8._)(function(min, max) {
        var range, bitsNeeded, bytesNeeded, mask, res, power, numberValue, i;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    range = max - min;
                    bitsNeeded = Math.ceil(Math.log2(range));
                    if (bitsNeeded > 53) throw new Error("Range is too large");
                    bytesNeeded = Math.ceil(bitsNeeded / 8);
                    mask = Math.pow(2, bitsNeeded) - 1;
                    _state.label = 1;
                case 1:
                    if (!true) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $aa5bc5b55a645401$var$getSecureRandomBytes(bitsNeeded)
                    ];
                case 2:
                    res = _state.sent();
                    power = (bytesNeeded - 1) * 8;
                    numberValue = 0;
                    for(i = 0; i < bytesNeeded; i++){
                        numberValue += res[i] * Math.pow(2, power);
                        power -= 8;
                    }
                    numberValue = numberValue & mask; // Truncate
                    if (numberValue >= range) return [
                        3,
                        1
                    ];
                    return [
                        2,
                        min + numberValue
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $aa5bc5b55a645401$var$_getSecureRandomNumber.apply(this, arguments);
}
module.exports.getSecureRandomNumber = $aa5bc5b55a645401$var$getSecureRandomNumber;

});

parcelRequire.register("alT6g", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.newSecureWords = void 0;

var $eCOtR = parcelRequire("eCOtR");

var $i0BPV = parcelRequire("i0BPV");
function $78969b452c0150d5$var$newSecureWords() {
    return $78969b452c0150d5$var$_newSecureWords.apply(this, arguments);
}
function $78969b452c0150d5$var$_newSecureWords() {
    $78969b452c0150d5$var$_newSecureWords = (0, $byzP8._)(function() {
        var size, words, i, _, _1;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    size = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 6;
                    words = [];
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < size)) return [
                        3,
                        4
                    ];
                    _ = words.push;
                    _1 = $i0BPV.wordlist;
                    return [
                        4,
                        (0, $eCOtR.getSecureRandomNumber)(0, $i0BPV.wordlist.length)
                    ];
                case 2:
                    _.apply(words, [
                        _1[_state.sent()]
                    ]);
                    _state.label = 3;
                case 3:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2,
                        words
                    ];
            }
        });
    });
    return $78969b452c0150d5$var$_newSecureWords.apply(this, arguments);
}
module.exports.newSecureWords = $78969b452c0150d5$var$newSecureWords;

});
parcelRequire.register("i0BPV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wordlist = void 0;
// Source https://www.eff.org/dice
module.exports.wordlist = [
    "abacus",
    "abdomen",
    "abdominal",
    "abide",
    "abiding",
    "ability",
    "ablaze",
    "able",
    "abnormal",
    "abrasion",
    "abrasive",
    "abreast",
    "abridge",
    "abroad",
    "abruptly",
    "absence",
    "absentee",
    "absently",
    "absinthe",
    "absolute",
    "absolve",
    "abstain",
    "abstract",
    "absurd",
    "accent",
    "acclaim",
    "acclimate",
    "accompany",
    "account",
    "accuracy",
    "accurate",
    "accustom",
    "acetone",
    "achiness",
    "aching",
    "acid",
    "acorn",
    "acquaint",
    "acquire",
    "acre",
    "acrobat",
    "acronym",
    "acting",
    "action",
    "activate",
    "activator",
    "active",
    "activism",
    "activist",
    "activity",
    "actress",
    "acts",
    "acutely",
    "acuteness",
    "aeration",
    "aerobics",
    "aerosol",
    "aerospace",
    "afar",
    "affair",
    "affected",
    "affecting",
    "affection",
    "affidavit",
    "affiliate",
    "affirm",
    "affix",
    "afflicted",
    "affluent",
    "afford",
    "affront",
    "aflame",
    "afloat",
    "aflutter",
    "afoot",
    "afraid",
    "afterglow",
    "afterlife",
    "aftermath",
    "aftermost",
    "afternoon",
    "aged",
    "ageless",
    "agency",
    "agenda",
    "agent",
    "aggregate",
    "aghast",
    "agile",
    "agility",
    "aging",
    "agnostic",
    "agonize",
    "agonizing",
    "agony",
    "agreeable",
    "agreeably",
    "agreed",
    "agreeing",
    "agreement",
    "aground",
    "ahead",
    "ahoy",
    "aide",
    "aids",
    "aim",
    "ajar",
    "alabaster",
    "alarm",
    "albatross",
    "album",
    "alfalfa",
    "algebra",
    "algorithm",
    "alias",
    "alibi",
    "alienable",
    "alienate",
    "aliens",
    "alike",
    "alive",
    "alkaline",
    "alkalize",
    "almanac",
    "almighty",
    "almost",
    "aloe",
    "aloft",
    "aloha",
    "alone",
    "alongside",
    "aloof",
    "alphabet",
    "alright",
    "although",
    "altitude",
    "alto",
    "aluminum",
    "alumni",
    "always",
    "amaretto",
    "amaze",
    "amazingly",
    "amber",
    "ambiance",
    "ambiguity",
    "ambiguous",
    "ambition",
    "ambitious",
    "ambulance",
    "ambush",
    "amendable",
    "amendment",
    "amends",
    "amenity",
    "amiable",
    "amicably",
    "amid",
    "amigo",
    "amino",
    "amiss",
    "ammonia",
    "ammonium",
    "amnesty",
    "amniotic",
    "among",
    "amount",
    "amperage",
    "ample",
    "amplifier",
    "amplify",
    "amply",
    "amuck",
    "amulet",
    "amusable",
    "amused",
    "amusement",
    "amuser",
    "amusing",
    "anaconda",
    "anaerobic",
    "anagram",
    "anatomist",
    "anatomy",
    "anchor",
    "anchovy",
    "ancient",
    "android",
    "anemia",
    "anemic",
    "aneurism",
    "anew",
    "angelfish",
    "angelic",
    "anger",
    "angled",
    "angler",
    "angles",
    "angling",
    "angrily",
    "angriness",
    "anguished",
    "angular",
    "animal",
    "animate",
    "animating",
    "animation",
    "animator",
    "anime",
    "animosity",
    "ankle",
    "annex",
    "annotate",
    "announcer",
    "annoying",
    "annually",
    "annuity",
    "anointer",
    "another",
    "answering",
    "antacid",
    "antarctic",
    "anteater",
    "antelope",
    "antennae",
    "anthem",
    "anthill",
    "anthology",
    "antibody",
    "antics",
    "antidote",
    "antihero",
    "antiquely",
    "antiques",
    "antiquity",
    "antirust",
    "antitoxic",
    "antitrust",
    "antiviral",
    "antivirus",
    "antler",
    "antonym",
    "antsy",
    "anvil",
    "anybody",
    "anyhow",
    "anymore",
    "anyone",
    "anyplace",
    "anything",
    "anytime",
    "anyway",
    "anywhere",
    "aorta",
    "apache",
    "apostle",
    "appealing",
    "appear",
    "appease",
    "appeasing",
    "appendage",
    "appendix",
    "appetite",
    "appetizer",
    "applaud",
    "applause",
    "apple",
    "appliance",
    "applicant",
    "applied",
    "apply",
    "appointee",
    "appraisal",
    "appraiser",
    "apprehend",
    "approach",
    "approval",
    "approve",
    "apricot",
    "april",
    "apron",
    "aptitude",
    "aptly",
    "aqua",
    "aqueduct",
    "arbitrary",
    "arbitrate",
    "ardently",
    "area",
    "arena",
    "arguable",
    "arguably",
    "argue",
    "arise",
    "armadillo",
    "armband",
    "armchair",
    "armed",
    "armful",
    "armhole",
    "arming",
    "armless",
    "armoire",
    "armored",
    "armory",
    "armrest",
    "army",
    "aroma",
    "arose",
    "around",
    "arousal",
    "arrange",
    "array",
    "arrest",
    "arrival",
    "arrive",
    "arrogance",
    "arrogant",
    "arson",
    "art",
    "ascend",
    "ascension",
    "ascent",
    "ascertain",
    "ashamed",
    "ashen",
    "ashes",
    "ashy",
    "aside",
    "askew",
    "asleep",
    "asparagus",
    "aspect",
    "aspirate",
    "aspire",
    "aspirin",
    "astonish",
    "astound",
    "astride",
    "astrology",
    "astronaut",
    "astronomy",
    "astute",
    "atlantic",
    "atlas",
    "atom",
    "atonable",
    "atop",
    "atrium",
    "atrocious",
    "atrophy",
    "attach",
    "attain",
    "attempt",
    "attendant",
    "attendee",
    "attention",
    "attentive",
    "attest",
    "attic",
    "attire",
    "attitude",
    "attractor",
    "attribute",
    "atypical",
    "auction",
    "audacious",
    "audacity",
    "audible",
    "audibly",
    "audience",
    "audio",
    "audition",
    "augmented",
    "august",
    "authentic",
    "author",
    "autism",
    "autistic",
    "autograph",
    "automaker",
    "automated",
    "automatic",
    "autopilot",
    "available",
    "avalanche",
    "avatar",
    "avenge",
    "avenging",
    "avenue",
    "average",
    "aversion",
    "avert",
    "aviation",
    "aviator",
    "avid",
    "avoid",
    "await",
    "awaken",
    "award",
    "aware",
    "awhile",
    "awkward",
    "awning",
    "awoke",
    "awry",
    "axis",
    "babble",
    "babbling",
    "babied",
    "baboon",
    "backache",
    "backboard",
    "backboned",
    "backdrop",
    "backed",
    "backer",
    "backfield",
    "backfire",
    "backhand",
    "backing",
    "backlands",
    "backlash",
    "backless",
    "backlight",
    "backlit",
    "backlog",
    "backpack",
    "backpedal",
    "backrest",
    "backroom",
    "backshift",
    "backside",
    "backslid",
    "backspace",
    "backspin",
    "backstab",
    "backstage",
    "backtalk",
    "backtrack",
    "backup",
    "backward",
    "backwash",
    "backwater",
    "backyard",
    "bacon",
    "bacteria",
    "bacterium",
    "badass",
    "badge",
    "badland",
    "badly",
    "badness",
    "baffle",
    "baffling",
    "bagel",
    "bagful",
    "baggage",
    "bagged",
    "baggie",
    "bagginess",
    "bagging",
    "baggy",
    "bagpipe",
    "baguette",
    "baked",
    "bakery",
    "bakeshop",
    "baking",
    "balance",
    "balancing",
    "balcony",
    "balmy",
    "balsamic",
    "bamboo",
    "banana",
    "banish",
    "banister",
    "banjo",
    "bankable",
    "bankbook",
    "banked",
    "banker",
    "banking",
    "banknote",
    "bankroll",
    "banner",
    "bannister",
    "banshee",
    "banter",
    "barbecue",
    "barbed",
    "barbell",
    "barber",
    "barcode",
    "barge",
    "bargraph",
    "barista",
    "baritone",
    "barley",
    "barmaid",
    "barman",
    "barn",
    "barometer",
    "barrack",
    "barracuda",
    "barrel",
    "barrette",
    "barricade",
    "barrier",
    "barstool",
    "bartender",
    "barterer",
    "bash",
    "basically",
    "basics",
    "basil",
    "basin",
    "basis",
    "basket",
    "batboy",
    "batch",
    "bath",
    "baton",
    "bats",
    "battalion",
    "battered",
    "battering",
    "battery",
    "batting",
    "battle",
    "bauble",
    "bazooka",
    "blabber",
    "bladder",
    "blade",
    "blah",
    "blame",
    "blaming",
    "blanching",
    "blandness",
    "blank",
    "blaspheme",
    "blasphemy",
    "blast",
    "blatancy",
    "blatantly",
    "blazer",
    "blazing",
    "bleach",
    "bleak",
    "bleep",
    "blemish",
    "blend",
    "bless",
    "blighted",
    "blimp",
    "bling",
    "blinked",
    "blinker",
    "blinking",
    "blinks",
    "blip",
    "blissful",
    "blitz",
    "blizzard",
    "bloated",
    "bloating",
    "blob",
    "blog",
    "bloomers",
    "blooming",
    "blooper",
    "blot",
    "blouse",
    "blubber",
    "bluff",
    "bluish",
    "blunderer",
    "blunt",
    "blurb",
    "blurred",
    "blurry",
    "blurt",
    "blush",
    "blustery",
    "boaster",
    "boastful",
    "boasting",
    "boat",
    "bobbed",
    "bobbing",
    "bobble",
    "bobcat",
    "bobsled",
    "bobtail",
    "bodacious",
    "body",
    "bogged",
    "boggle",
    "bogus",
    "boil",
    "bok",
    "bolster",
    "bolt",
    "bonanza",
    "bonded",
    "bonding",
    "bondless",
    "boned",
    "bonehead",
    "boneless",
    "bonelike",
    "boney",
    "bonfire",
    "bonnet",
    "bonsai",
    "bonus",
    "bony",
    "boogeyman",
    "boogieman",
    "book",
    "boondocks",
    "booted",
    "booth",
    "bootie",
    "booting",
    "bootlace",
    "bootleg",
    "boots",
    "boozy",
    "borax",
    "boring",
    "borough",
    "borrower",
    "borrowing",
    "boss",
    "botanical",
    "botanist",
    "botany",
    "botch",
    "both",
    "bottle",
    "bottling",
    "bottom",
    "bounce",
    "bouncing",
    "bouncy",
    "bounding",
    "boundless",
    "bountiful",
    "bovine",
    "boxcar",
    "boxer",
    "boxing",
    "boxlike",
    "boxy",
    "breach",
    "breath",
    "breeches",
    "breeching",
    "breeder",
    "breeding",
    "breeze",
    "breezy",
    "brethren",
    "brewery",
    "brewing",
    "briar",
    "bribe",
    "brick",
    "bride",
    "bridged",
    "brigade",
    "bright",
    "brilliant",
    "brim",
    "bring",
    "brink",
    "brisket",
    "briskly",
    "briskness",
    "bristle",
    "brittle",
    "broadband",
    "broadcast",
    "broaden",
    "broadly",
    "broadness",
    "broadside",
    "broadways",
    "broiler",
    "broiling",
    "broken",
    "broker",
    "bronchial",
    "bronco",
    "bronze",
    "bronzing",
    "brook",
    "broom",
    "brought",
    "browbeat",
    "brownnose",
    "browse",
    "browsing",
    "bruising",
    "brunch",
    "brunette",
    "brunt",
    "brush",
    "brussels",
    "brute",
    "brutishly",
    "bubble",
    "bubbling",
    "bubbly",
    "buccaneer",
    "bucked",
    "bucket",
    "buckle",
    "buckshot",
    "buckskin",
    "bucktooth",
    "buckwheat",
    "buddhism",
    "buddhist",
    "budding",
    "buddy",
    "budget",
    "buffalo",
    "buffed",
    "buffer",
    "buffing",
    "buffoon",
    "buggy",
    "bulb",
    "bulge",
    "bulginess",
    "bulgur",
    "bulk",
    "bulldog",
    "bulldozer",
    "bullfight",
    "bullfrog",
    "bullhorn",
    "bullion",
    "bullish",
    "bullpen",
    "bullring",
    "bullseye",
    "bullwhip",
    "bully",
    "bunch",
    "bundle",
    "bungee",
    "bunion",
    "bunkbed",
    "bunkhouse",
    "bunkmate",
    "bunny",
    "bunt",
    "busboy",
    "bush",
    "busily",
    "busload",
    "bust",
    "busybody",
    "buzz",
    "cabana",
    "cabbage",
    "cabbie",
    "cabdriver",
    "cable",
    "caboose",
    "cache",
    "cackle",
    "cacti",
    "cactus",
    "caddie",
    "caddy",
    "cadet",
    "cadillac",
    "cadmium",
    "cage",
    "cahoots",
    "cake",
    "calamari",
    "calamity",
    "calcium",
    "calculate",
    "calculus",
    "caliber",
    "calibrate",
    "calm",
    "caloric",
    "calorie",
    "calzone",
    "camcorder",
    "cameo",
    "camera",
    "camisole",
    "camper",
    "campfire",
    "camping",
    "campsite",
    "campus",
    "canal",
    "canary",
    "cancel",
    "candied",
    "candle",
    "candy",
    "cane",
    "canine",
    "canister",
    "cannabis",
    "canned",
    "canning",
    "cannon",
    "cannot",
    "canola",
    "canon",
    "canopener",
    "canopy",
    "canteen",
    "canyon",
    "capable",
    "capably",
    "capacity",
    "cape",
    "capillary",
    "capital",
    "capitol",
    "capped",
    "capricorn",
    "capsize",
    "capsule",
    "caption",
    "captivate",
    "captive",
    "captivity",
    "capture",
    "caramel",
    "carat",
    "caravan",
    "carbon",
    "cardboard",
    "carded",
    "cardiac",
    "cardigan",
    "cardinal",
    "cardstock",
    "carefully",
    "caregiver",
    "careless",
    "caress",
    "caretaker",
    "cargo",
    "caring",
    "carless",
    "carload",
    "carmaker",
    "carnage",
    "carnation",
    "carnival",
    "carnivore",
    "carol",
    "carpenter",
    "carpentry",
    "carpool",
    "carport",
    "carried",
    "carrot",
    "carrousel",
    "carry",
    "cartel",
    "cartload",
    "carton",
    "cartoon",
    "cartridge",
    "cartwheel",
    "carve",
    "carving",
    "carwash",
    "cascade",
    "case",
    "cash",
    "casing",
    "casino",
    "casket",
    "cassette",
    "casually",
    "casualty",
    "catacomb",
    "catalog",
    "catalyst",
    "catalyze",
    "catapult",
    "cataract",
    "catatonic",
    "catcall",
    "catchable",
    "catcher",
    "catching",
    "catchy",
    "caterer",
    "catering",
    "catfight",
    "catfish",
    "cathedral",
    "cathouse",
    "catlike",
    "catnap",
    "catnip",
    "catsup",
    "cattail",
    "cattishly",
    "cattle",
    "catty",
    "catwalk",
    "caucasian",
    "caucus",
    "causal",
    "causation",
    "cause",
    "causing",
    "cauterize",
    "caution",
    "cautious",
    "cavalier",
    "cavalry",
    "caviar",
    "cavity",
    "cedar",
    "celery",
    "celestial",
    "celibacy",
    "celibate",
    "celtic",
    "cement",
    "census",
    "ceramics",
    "ceremony",
    "certainly",
    "certainty",
    "certified",
    "certify",
    "cesarean",
    "cesspool",
    "chafe",
    "chaffing",
    "chain",
    "chair",
    "chalice",
    "challenge",
    "chamber",
    "chamomile",
    "champion",
    "chance",
    "change",
    "channel",
    "chant",
    "chaos",
    "chaperone",
    "chaplain",
    "chapped",
    "chaps",
    "chapter",
    "character",
    "charbroil",
    "charcoal",
    "charger",
    "charging",
    "chariot",
    "charity",
    "charm",
    "charred",
    "charter",
    "charting",
    "chase",
    "chasing",
    "chaste",
    "chastise",
    "chastity",
    "chatroom",
    "chatter",
    "chatting",
    "chatty",
    "cheating",
    "cheddar",
    "cheek",
    "cheer",
    "cheese",
    "cheesy",
    "chef",
    "chemicals",
    "chemist",
    "chemo",
    "cherisher",
    "cherub",
    "chess",
    "chest",
    "chevron",
    "chevy",
    "chewable",
    "chewer",
    "chewing",
    "chewy",
    "chief",
    "chihuahua",
    "childcare",
    "childhood",
    "childish",
    "childless",
    "childlike",
    "chili",
    "chill",
    "chimp",
    "chip",
    "chirping",
    "chirpy",
    "chitchat",
    "chivalry",
    "chive",
    "chloride",
    "chlorine",
    "choice",
    "chokehold",
    "choking",
    "chomp",
    "chooser",
    "choosing",
    "choosy",
    "chop",
    "chosen",
    "chowder",
    "chowtime",
    "chrome",
    "chubby",
    "chuck",
    "chug",
    "chummy",
    "chump",
    "chunk",
    "churn",
    "chute",
    "cider",
    "cilantro",
    "cinch",
    "cinema",
    "cinnamon",
    "circle",
    "circling",
    "circular",
    "circulate",
    "circus",
    "citable",
    "citadel",
    "citation",
    "citizen",
    "citric",
    "citrus",
    "city",
    "civic",
    "civil",
    "clad",
    "claim",
    "clambake",
    "clammy",
    "clamor",
    "clamp",
    "clamshell",
    "clang",
    "clanking",
    "clapped",
    "clapper",
    "clapping",
    "clarify",
    "clarinet",
    "clarity",
    "clash",
    "clasp",
    "class",
    "clatter",
    "clause",
    "clavicle",
    "claw",
    "clay",
    "clean",
    "clear",
    "cleat",
    "cleaver",
    "cleft",
    "clench",
    "clergyman",
    "clerical",
    "clerk",
    "clever",
    "clicker",
    "client",
    "climate",
    "climatic",
    "cling",
    "clinic",
    "clinking",
    "clip",
    "clique",
    "cloak",
    "clobber",
    "clock",
    "clone",
    "cloning",
    "closable",
    "closure",
    "clothes",
    "clothing",
    "cloud",
    "clover",
    "clubbed",
    "clubbing",
    "clubhouse",
    "clump",
    "clumsily",
    "clumsy",
    "clunky",
    "clustered",
    "clutch",
    "clutter",
    "coach",
    "coagulant",
    "coastal",
    "coaster",
    "coasting",
    "coastland",
    "coastline",
    "coat",
    "coauthor",
    "cobalt",
    "cobbler",
    "cobweb",
    "cocoa",
    "coconut",
    "cod",
    "coeditor",
    "coerce",
    "coexist",
    "coffee",
    "cofounder",
    "cognition",
    "cognitive",
    "cogwheel",
    "coherence",
    "coherent",
    "cohesive",
    "coil",
    "coke",
    "cola",
    "cold",
    "coleslaw",
    "coliseum",
    "collage",
    "collapse",
    "collar",
    "collected",
    "collector",
    "collide",
    "collie",
    "collision",
    "colonial",
    "colonist",
    "colonize",
    "colony",
    "colossal",
    "colt",
    "coma",
    "come",
    "comfort",
    "comfy",
    "comic",
    "coming",
    "comma",
    "commence",
    "commend",
    "comment",
    "commerce",
    "commode",
    "commodity",
    "commodore",
    "common",
    "commotion",
    "commute",
    "commuting",
    "compacted",
    "compacter",
    "compactly",
    "compactor",
    "companion",
    "company",
    "compare",
    "compel",
    "compile",
    "comply",
    "component",
    "composed",
    "composer",
    "composite",
    "compost",
    "composure",
    "compound",
    "compress",
    "comprised",
    "computer",
    "computing",
    "comrade",
    "concave",
    "conceal",
    "conceded",
    "concept",
    "concerned",
    "concert",
    "conch",
    "concierge",
    "concise",
    "conclude",
    "concrete",
    "concur",
    "condense",
    "condiment",
    "condition",
    "condone",
    "conducive",
    "conductor",
    "conduit",
    "cone",
    "confess",
    "confetti",
    "confidant",
    "confident",
    "confider",
    "confiding",
    "configure",
    "confined",
    "confining",
    "confirm",
    "conflict",
    "conform",
    "confound",
    "confront",
    "confused",
    "confusing",
    "confusion",
    "congenial",
    "congested",
    "congrats",
    "congress",
    "conical",
    "conjoined",
    "conjure",
    "conjuror",
    "connected",
    "connector",
    "consensus",
    "consent",
    "console",
    "consoling",
    "consonant",
    "constable",
    "constant",
    "constrain",
    "constrict",
    "construct",
    "consult",
    "consumer",
    "consuming",
    "contact",
    "container",
    "contempt",
    "contend",
    "contented",
    "contently",
    "contents",
    "contest",
    "context",
    "contort",
    "contour",
    "contrite",
    "control",
    "contusion",
    "convene",
    "convent",
    "copartner",
    "cope",
    "copied",
    "copier",
    "copilot",
    "coping",
    "copious",
    "copper",
    "copy",
    "coral",
    "cork",
    "cornball",
    "cornbread",
    "corncob",
    "cornea",
    "corned",
    "corner",
    "cornfield",
    "cornflake",
    "cornhusk",
    "cornmeal",
    "cornstalk",
    "corny",
    "coronary",
    "coroner",
    "corporal",
    "corporate",
    "corral",
    "correct",
    "corridor",
    "corrode",
    "corroding",
    "corrosive",
    "corsage",
    "corset",
    "cortex",
    "cosigner",
    "cosmetics",
    "cosmic",
    "cosmos",
    "cosponsor",
    "cost",
    "cottage",
    "cotton",
    "couch",
    "cough",
    "could",
    "countable",
    "countdown",
    "counting",
    "countless",
    "country",
    "county",
    "courier",
    "covenant",
    "cover",
    "coveted",
    "coveting",
    "coyness",
    "cozily",
    "coziness",
    "cozy",
    "crabbing",
    "crabgrass",
    "crablike",
    "crabmeat",
    "cradle",
    "cradling",
    "crafter",
    "craftily",
    "craftsman",
    "craftwork",
    "crafty",
    "cramp",
    "cranberry",
    "crane",
    "cranial",
    "cranium",
    "crank",
    "crate",
    "crave",
    "craving",
    "crawfish",
    "crawlers",
    "crawling",
    "crayfish",
    "crayon",
    "crazed",
    "crazily",
    "craziness",
    "crazy",
    "creamed",
    "creamer",
    "creamlike",
    "crease",
    "creasing",
    "creatable",
    "create",
    "creation",
    "creative",
    "creature",
    "credible",
    "credibly",
    "credit",
    "creed",
    "creme",
    "creole",
    "crepe",
    "crept",
    "crescent",
    "crested",
    "cresting",
    "crestless",
    "crevice",
    "crewless",
    "crewman",
    "crewmate",
    "crib",
    "cricket",
    "cried",
    "crier",
    "crimp",
    "crimson",
    "cringe",
    "cringing",
    "crinkle",
    "crinkly",
    "crisped",
    "crisping",
    "crisply",
    "crispness",
    "crispy",
    "criteria",
    "critter",
    "croak",
    "crock",
    "crook",
    "croon",
    "crop",
    "cross",
    "crouch",
    "crouton",
    "crowbar",
    "crowd",
    "crown",
    "crucial",
    "crudely",
    "crudeness",
    "cruelly",
    "cruelness",
    "cruelty",
    "crumb",
    "crummiest",
    "crummy",
    "crumpet",
    "crumpled",
    "cruncher",
    "crunching",
    "crunchy",
    "crusader",
    "crushable",
    "crushed",
    "crusher",
    "crushing",
    "crust",
    "crux",
    "crying",
    "cryptic",
    "crystal",
    "cubbyhole",
    "cube",
    "cubical",
    "cubicle",
    "cucumber",
    "cuddle",
    "cuddly",
    "cufflink",
    "culinary",
    "culminate",
    "culpable",
    "culprit",
    "cultivate",
    "cultural",
    "culture",
    "cupbearer",
    "cupcake",
    "cupid",
    "cupped",
    "cupping",
    "curable",
    "curator",
    "curdle",
    "cure",
    "curfew",
    "curing",
    "curled",
    "curler",
    "curliness",
    "curling",
    "curly",
    "curry",
    "curse",
    "cursive",
    "cursor",
    "curtain",
    "curtly",
    "curtsy",
    "curvature",
    "curve",
    "curvy",
    "cushy",
    "cusp",
    "cussed",
    "custard",
    "custodian",
    "custody",
    "customary",
    "customer",
    "customize",
    "customs",
    "cut",
    "cycle",
    "cyclic",
    "cycling",
    "cyclist",
    "cylinder",
    "cymbal",
    "cytoplasm",
    "cytoplast",
    "dab",
    "dad",
    "daffodil",
    "dagger",
    "daily",
    "daintily",
    "dainty",
    "dairy",
    "daisy",
    "dallying",
    "dance",
    "dancing",
    "dandelion",
    "dander",
    "dandruff",
    "dandy",
    "danger",
    "dangle",
    "dangling",
    "daredevil",
    "dares",
    "daringly",
    "darkened",
    "darkening",
    "darkish",
    "darkness",
    "darkroom",
    "darling",
    "darn",
    "dart",
    "darwinism",
    "dash",
    "dastardly",
    "data",
    "datebook",
    "dating",
    "daughter",
    "daunting",
    "dawdler",
    "dawn",
    "daybed",
    "daybreak",
    "daycare",
    "daydream",
    "daylight",
    "daylong",
    "dayroom",
    "daytime",
    "dazzler",
    "dazzling",
    "deacon",
    "deafening",
    "deafness",
    "dealer",
    "dealing",
    "dealmaker",
    "dealt",
    "dean",
    "debatable",
    "debate",
    "debating",
    "debit",
    "debrief",
    "debtless",
    "debtor",
    "debug",
    "debunk",
    "decade",
    "decaf",
    "decal",
    "decathlon",
    "decay",
    "deceased",
    "deceit",
    "deceiver",
    "deceiving",
    "december",
    "decency",
    "decent",
    "deception",
    "deceptive",
    "decibel",
    "decidable",
    "decimal",
    "decimeter",
    "decipher",
    "deck",
    "declared",
    "decline",
    "decode",
    "decompose",
    "decorated",
    "decorator",
    "decoy",
    "decrease",
    "decree",
    "dedicate",
    "dedicator",
    "deduce",
    "deduct",
    "deed",
    "deem",
    "deepen",
    "deeply",
    "deepness",
    "deface",
    "defacing",
    "defame",
    "default",
    "defeat",
    "defection",
    "defective",
    "defendant",
    "defender",
    "defense",
    "defensive",
    "deferral",
    "deferred",
    "defiance",
    "defiant",
    "defile",
    "defiling",
    "define",
    "definite",
    "deflate",
    "deflation",
    "deflator",
    "deflected",
    "deflector",
    "defog",
    "deforest",
    "defraud",
    "defrost",
    "deftly",
    "defuse",
    "defy",
    "degraded",
    "degrading",
    "degrease",
    "degree",
    "dehydrate",
    "deity",
    "dejected",
    "delay",
    "delegate",
    "delegator",
    "delete",
    "deletion",
    "delicacy",
    "delicate",
    "delicious",
    "delighted",
    "delirious",
    "delirium",
    "deliverer",
    "delivery",
    "delouse",
    "delta",
    "deluge",
    "delusion",
    "deluxe",
    "demanding",
    "demeaning",
    "demeanor",
    "demise",
    "democracy",
    "democrat",
    "demote",
    "demotion",
    "demystify",
    "denatured",
    "deniable",
    "denial",
    "denim",
    "denote",
    "dense",
    "density",
    "dental",
    "dentist",
    "denture",
    "deny",
    "deodorant",
    "deodorize",
    "departed",
    "departure",
    "depict",
    "deplete",
    "depletion",
    "deplored",
    "deploy",
    "deport",
    "depose",
    "depraved",
    "depravity",
    "deprecate",
    "depress",
    "deprive",
    "depth",
    "deputize",
    "deputy",
    "derail",
    "deranged",
    "derby",
    "derived",
    "desecrate",
    "deserve",
    "deserving",
    "designate",
    "designed",
    "designer",
    "designing",
    "deskbound",
    "desktop",
    "deskwork",
    "desolate",
    "despair",
    "despise",
    "despite",
    "destiny",
    "destitute",
    "destruct",
    "detached",
    "detail",
    "detection",
    "detective",
    "detector",
    "detention",
    "detergent",
    "detest",
    "detonate",
    "detonator",
    "detoxify",
    "detract",
    "deuce",
    "devalue",
    "deviancy",
    "deviant",
    "deviate",
    "deviation",
    "deviator",
    "device",
    "devious",
    "devotedly",
    "devotee",
    "devotion",
    "devourer",
    "devouring",
    "devoutly",
    "dexterity",
    "dexterous",
    "diabetes",
    "diabetic",
    "diabolic",
    "diagnoses",
    "diagnosis",
    "diagram",
    "dial",
    "diameter",
    "diaper",
    "diaphragm",
    "diary",
    "dice",
    "dicing",
    "dictate",
    "dictation",
    "dictator",
    "difficult",
    "diffused",
    "diffuser",
    "diffusion",
    "diffusive",
    "dig",
    "dilation",
    "diligence",
    "diligent",
    "dill",
    "dilute",
    "dime",
    "diminish",
    "dimly",
    "dimmed",
    "dimmer",
    "dimness",
    "dimple",
    "diner",
    "dingbat",
    "dinghy",
    "dinginess",
    "dingo",
    "dingy",
    "dining",
    "dinner",
    "diocese",
    "dioxide",
    "diploma",
    "dipped",
    "dipper",
    "dipping",
    "directed",
    "direction",
    "directive",
    "directly",
    "directory",
    "direness",
    "dirtiness",
    "disabled",
    "disagree",
    "disallow",
    "disarm",
    "disarray",
    "disaster",
    "disband",
    "disbelief",
    "disburse",
    "discard",
    "discern",
    "discharge",
    "disclose",
    "discolor",
    "discount",
    "discourse",
    "discover",
    "discuss",
    "disdain",
    "disengage",
    "disfigure",
    "disgrace",
    "dish",
    "disinfect",
    "disjoin",
    "disk",
    "dislike",
    "disliking",
    "dislocate",
    "dislodge",
    "disloyal",
    "dismantle",
    "dismay",
    "dismiss",
    "dismount",
    "disobey",
    "disorder",
    "disown",
    "disparate",
    "disparity",
    "dispatch",
    "dispense",
    "dispersal",
    "dispersed",
    "disperser",
    "displace",
    "display",
    "displease",
    "disposal",
    "dispose",
    "disprove",
    "dispute",
    "disregard",
    "disrupt",
    "dissuade",
    "distance",
    "distant",
    "distaste",
    "distill",
    "distinct",
    "distort",
    "distract",
    "distress",
    "district",
    "distrust",
    "ditch",
    "ditto",
    "ditzy",
    "dividable",
    "divided",
    "dividend",
    "dividers",
    "dividing",
    "divinely",
    "diving",
    "divinity",
    "divisible",
    "divisibly",
    "division",
    "divisive",
    "divorcee",
    "dizziness",
    "dizzy",
    "doable",
    "docile",
    "dock",
    "doctrine",
    "document",
    "dodge",
    "dodgy",
    "doily",
    "doing",
    "dole",
    "dollar",
    "dollhouse",
    "dollop",
    "dolly",
    "dolphin",
    "domain",
    "domelike",
    "domestic",
    "dominion",
    "dominoes",
    "donated",
    "donation",
    "donator",
    "donor",
    "donut",
    "doodle",
    "doorbell",
    "doorframe",
    "doorknob",
    "doorman",
    "doormat",
    "doornail",
    "doorpost",
    "doorstep",
    "doorstop",
    "doorway",
    "doozy",
    "dork",
    "dormitory",
    "dorsal",
    "dosage",
    "dose",
    "dotted",
    "doubling",
    "douche",
    "dove",
    "down",
    "dowry",
    "doze",
    "drab",
    "dragging",
    "dragonfly",
    "dragonish",
    "dragster",
    "drainable",
    "drainage",
    "drained",
    "drainer",
    "drainpipe",
    "dramatic",
    "dramatize",
    "drank",
    "drapery",
    "drastic",
    "draw",
    "dreaded",
    "dreadful",
    "dreadlock",
    "dreamboat",
    "dreamily",
    "dreamland",
    "dreamless",
    "dreamlike",
    "dreamt",
    "dreamy",
    "drearily",
    "dreary",
    "drench",
    "dress",
    "drew",
    "dribble",
    "dried",
    "drier",
    "drift",
    "driller",
    "drilling",
    "drinkable",
    "drinking",
    "dripping",
    "drippy",
    "drivable",
    "driven",
    "driver",
    "driveway",
    "driving",
    "drizzle",
    "drizzly",
    "drone",
    "drool",
    "droop",
    "drop-down",
    "dropbox",
    "dropkick",
    "droplet",
    "dropout",
    "dropper",
    "drove",
    "drown",
    "drowsily",
    "drudge",
    "drum",
    "dry",
    "dubbed",
    "dubiously",
    "duchess",
    "duckbill",
    "ducking",
    "duckling",
    "ducktail",
    "ducky",
    "duct",
    "dude",
    "duffel",
    "dugout",
    "duh",
    "duke",
    "duller",
    "dullness",
    "duly",
    "dumping",
    "dumpling",
    "dumpster",
    "duo",
    "dupe",
    "duplex",
    "duplicate",
    "duplicity",
    "durable",
    "durably",
    "duration",
    "duress",
    "during",
    "dusk",
    "dust",
    "dutiful",
    "duty",
    "duvet",
    "dwarf",
    "dweeb",
    "dwelled",
    "dweller",
    "dwelling",
    "dwindle",
    "dwindling",
    "dynamic",
    "dynamite",
    "dynasty",
    "dyslexia",
    "dyslexic",
    "each",
    "eagle",
    "earache",
    "eardrum",
    "earflap",
    "earful",
    "earlobe",
    "early",
    "earmark",
    "earmuff",
    "earphone",
    "earpiece",
    "earplugs",
    "earring",
    "earshot",
    "earthen",
    "earthlike",
    "earthling",
    "earthly",
    "earthworm",
    "earthy",
    "earwig",
    "easeful",
    "easel",
    "easiest",
    "easily",
    "easiness",
    "easing",
    "eastbound",
    "eastcoast",
    "easter",
    "eastward",
    "eatable",
    "eaten",
    "eatery",
    "eating",
    "eats",
    "ebay",
    "ebony",
    "ebook",
    "ecard",
    "eccentric",
    "echo",
    "eclair",
    "eclipse",
    "ecologist",
    "ecology",
    "economic",
    "economist",
    "economy",
    "ecosphere",
    "ecosystem",
    "edge",
    "edginess",
    "edging",
    "edgy",
    "edition",
    "editor",
    "educated",
    "education",
    "educator",
    "eel",
    "effective",
    "effects",
    "efficient",
    "effort",
    "eggbeater",
    "egging",
    "eggnog",
    "eggplant",
    "eggshell",
    "egomaniac",
    "egotism",
    "egotistic",
    "either",
    "eject",
    "elaborate",
    "elastic",
    "elated",
    "elbow",
    "eldercare",
    "elderly",
    "eldest",
    "electable",
    "election",
    "elective",
    "elephant",
    "elevate",
    "elevating",
    "elevation",
    "elevator",
    "eleven",
    "elf",
    "eligible",
    "eligibly",
    "eliminate",
    "elite",
    "elitism",
    "elixir",
    "elk",
    "ellipse",
    "elliptic",
    "elm",
    "elongated",
    "elope",
    "eloquence",
    "eloquent",
    "elsewhere",
    "elude",
    "elusive",
    "elves",
    "email",
    "embargo",
    "embark",
    "embassy",
    "embattled",
    "embellish",
    "ember",
    "embezzle",
    "emblaze",
    "emblem",
    "embody",
    "embolism",
    "emboss",
    "embroider",
    "emcee",
    "emerald",
    "emergency",
    "emission",
    "emit",
    "emote",
    "emoticon",
    "emotion",
    "empathic",
    "empathy",
    "emperor",
    "emphases",
    "emphasis",
    "emphasize",
    "emphatic",
    "empirical",
    "employed",
    "employee",
    "employer",
    "emporium",
    "empower",
    "emptier",
    "emptiness",
    "empty",
    "emu",
    "enable",
    "enactment",
    "enamel",
    "enchanted",
    "enchilada",
    "encircle",
    "enclose",
    "enclosure",
    "encode",
    "encore",
    "encounter",
    "encourage",
    "encroach",
    "encrust",
    "encrypt",
    "endanger",
    "endeared",
    "endearing",
    "ended",
    "ending",
    "endless",
    "endnote",
    "endocrine",
    "endorphin",
    "endorse",
    "endowment",
    "endpoint",
    "endurable",
    "endurance",
    "enduring",
    "energetic",
    "energize",
    "energy",
    "enforced",
    "enforcer",
    "engaged",
    "engaging",
    "engine",
    "engorge",
    "engraved",
    "engraver",
    "engraving",
    "engross",
    "engulf",
    "enhance",
    "enigmatic",
    "enjoyable",
    "enjoyably",
    "enjoyer",
    "enjoying",
    "enjoyment",
    "enlarged",
    "enlarging",
    "enlighten",
    "enlisted",
    "enquirer",
    "enrage",
    "enrich",
    "enroll",
    "enslave",
    "ensnare",
    "ensure",
    "entail",
    "entangled",
    "entering",
    "entertain",
    "enticing",
    "entire",
    "entitle",
    "entity",
    "entomb",
    "entourage",
    "entrap",
    "entree",
    "entrench",
    "entrust",
    "entryway",
    "entwine",
    "enunciate",
    "envelope",
    "enviable",
    "enviably",
    "envious",
    "envision",
    "envoy",
    "envy",
    "enzyme",
    "epic",
    "epidemic",
    "epidermal",
    "epidermis",
    "epidural",
    "epilepsy",
    "epileptic",
    "epilogue",
    "epiphany",
    "episode",
    "equal",
    "equate",
    "equation",
    "equator",
    "equinox",
    "equipment",
    "equity",
    "equivocal",
    "eradicate",
    "erasable",
    "erased",
    "eraser",
    "erasure",
    "ergonomic",
    "errand",
    "errant",
    "erratic",
    "error",
    "erupt",
    "escalate",
    "escalator",
    "escapable",
    "escapade",
    "escapist",
    "escargot",
    "eskimo",
    "esophagus",
    "espionage",
    "espresso",
    "esquire",
    "essay",
    "essence",
    "essential",
    "establish",
    "estate",
    "esteemed",
    "estimate",
    "estimator",
    "estranged",
    "estrogen",
    "etching",
    "eternal",
    "eternity",
    "ethanol",
    "ether",
    "ethically",
    "ethics",
    "euphemism",
    "evacuate",
    "evacuee",
    "evade",
    "evaluate",
    "evaluator",
    "evaporate",
    "evasion",
    "evasive",
    "even",
    "everglade",
    "evergreen",
    "everybody",
    "everyday",
    "everyone",
    "evict",
    "evidence",
    "evident",
    "evil",
    "evoke",
    "evolution",
    "evolve",
    "exact",
    "exalted",
    "example",
    "excavate",
    "excavator",
    "exceeding",
    "exception",
    "excess",
    "exchange",
    "excitable",
    "exciting",
    "exclaim",
    "exclude",
    "excluding",
    "exclusion",
    "exclusive",
    "excretion",
    "excretory",
    "excursion",
    "excusable",
    "excusably",
    "excuse",
    "exemplary",
    "exemplify",
    "exemption",
    "exerciser",
    "exert",
    "exes",
    "exfoliate",
    "exhale",
    "exhaust",
    "exhume",
    "exile",
    "existing",
    "exit",
    "exodus",
    "exonerate",
    "exorcism",
    "exorcist",
    "expand",
    "expanse",
    "expansion",
    "expansive",
    "expectant",
    "expedited",
    "expediter",
    "expel",
    "expend",
    "expenses",
    "expensive",
    "expert",
    "expire",
    "expiring",
    "explain",
    "expletive",
    "explicit",
    "explode",
    "exploit",
    "explore",
    "exploring",
    "exponent",
    "exporter",
    "exposable",
    "expose",
    "exposure",
    "express",
    "expulsion",
    "exquisite",
    "extended",
    "extending",
    "extent",
    "extenuate",
    "exterior",
    "external",
    "extinct",
    "extortion",
    "extradite",
    "extras",
    "extrovert",
    "extrude",
    "extruding",
    "exuberant",
    "fable",
    "fabric",
    "fabulous",
    "facebook",
    "facecloth",
    "facedown",
    "faceless",
    "facelift",
    "faceplate",
    "faceted",
    "facial",
    "facility",
    "facing",
    "facsimile",
    "faction",
    "factoid",
    "factor",
    "factsheet",
    "factual",
    "faculty",
    "fade",
    "fading",
    "failing",
    "falcon",
    "fall",
    "false",
    "falsify",
    "fame",
    "familiar",
    "family",
    "famine",
    "famished",
    "fanatic",
    "fancied",
    "fanciness",
    "fancy",
    "fanfare",
    "fang",
    "fanning",
    "fantasize",
    "fantastic",
    "fantasy",
    "fascism",
    "fastball",
    "faster",
    "fasting",
    "fastness",
    "faucet",
    "favorable",
    "favorably",
    "favored",
    "favoring",
    "favorite",
    "fax",
    "feast",
    "federal",
    "fedora",
    "feeble",
    "feed",
    "feel",
    "feisty",
    "feline",
    "felt-tip",
    "feminine",
    "feminism",
    "feminist",
    "feminize",
    "femur",
    "fence",
    "fencing",
    "fender",
    "ferment",
    "fernlike",
    "ferocious",
    "ferocity",
    "ferret",
    "ferris",
    "ferry",
    "fervor",
    "fester",
    "festival",
    "festive",
    "festivity",
    "fetal",
    "fetch",
    "fever",
    "fiber",
    "fiction",
    "fiddle",
    "fiddling",
    "fidelity",
    "fidgeting",
    "fidgety",
    "fifteen",
    "fifth",
    "fiftieth",
    "fifty",
    "figment",
    "figure",
    "figurine",
    "filing",
    "filled",
    "filler",
    "filling",
    "film",
    "filter",
    "filth",
    "filtrate",
    "finale",
    "finalist",
    "finalize",
    "finally",
    "finance",
    "financial",
    "finch",
    "fineness",
    "finer",
    "finicky",
    "finished",
    "finisher",
    "finishing",
    "finite",
    "finless",
    "finlike",
    "fiscally",
    "fit",
    "five",
    "flaccid",
    "flagman",
    "flagpole",
    "flagship",
    "flagstick",
    "flagstone",
    "flail",
    "flakily",
    "flaky",
    "flame",
    "flammable",
    "flanked",
    "flanking",
    "flannels",
    "flap",
    "flaring",
    "flashback",
    "flashbulb",
    "flashcard",
    "flashily",
    "flashing",
    "flashy",
    "flask",
    "flatbed",
    "flatfoot",
    "flatly",
    "flatness",
    "flatten",
    "flattered",
    "flatterer",
    "flattery",
    "flattop",
    "flatware",
    "flatworm",
    "flavored",
    "flavorful",
    "flavoring",
    "flaxseed",
    "fled",
    "fleshed",
    "fleshy",
    "flick",
    "flier",
    "flight",
    "flinch",
    "fling",
    "flint",
    "flip",
    "flirt",
    "float",
    "flock",
    "flogging",
    "flop",
    "floral",
    "florist",
    "floss",
    "flounder",
    "flyable",
    "flyaway",
    "flyer",
    "flying",
    "flyover",
    "flypaper",
    "foam",
    "foe",
    "fog",
    "foil",
    "folic",
    "folk",
    "follicle",
    "follow",
    "fondling",
    "fondly",
    "fondness",
    "fondue",
    "font",
    "food",
    "fool",
    "footage",
    "football",
    "footbath",
    "footboard",
    "footer",
    "footgear",
    "foothill",
    "foothold",
    "footing",
    "footless",
    "footman",
    "footnote",
    "footpad",
    "footpath",
    "footprint",
    "footrest",
    "footsie",
    "footsore",
    "footwear",
    "footwork",
    "fossil",
    "foster",
    "founder",
    "founding",
    "fountain",
    "fox",
    "foyer",
    "fraction",
    "fracture",
    "fragile",
    "fragility",
    "fragment",
    "fragrance",
    "fragrant",
    "frail",
    "frame",
    "framing",
    "frantic",
    "fraternal",
    "frayed",
    "fraying",
    "frays",
    "freckled",
    "freckles",
    "freebase",
    "freebee",
    "freebie",
    "freedom",
    "freefall",
    "freehand",
    "freeing",
    "freeload",
    "freely",
    "freemason",
    "freeness",
    "freestyle",
    "freeware",
    "freeway",
    "freewill",
    "freezable",
    "freezing",
    "freight",
    "french",
    "frenzied",
    "frenzy",
    "frequency",
    "frequent",
    "fresh",
    "fretful",
    "fretted",
    "friction",
    "friday",
    "fridge",
    "fried",
    "friend",
    "frighten",
    "frightful",
    "frigidity",
    "frigidly",
    "frill",
    "fringe",
    "frisbee",
    "frisk",
    "fritter",
    "frivolous",
    "frolic",
    "from",
    "front",
    "frostbite",
    "frosted",
    "frostily",
    "frosting",
    "frostlike",
    "frosty",
    "froth",
    "frown",
    "frozen",
    "fructose",
    "frugality",
    "frugally",
    "fruit",
    "frustrate",
    "frying",
    "gab",
    "gaffe",
    "gag",
    "gainfully",
    "gaining",
    "gains",
    "gala",
    "gallantly",
    "galleria",
    "gallery",
    "galley",
    "gallon",
    "gallows",
    "gallstone",
    "galore",
    "galvanize",
    "gambling",
    "game",
    "gaming",
    "gamma",
    "gander",
    "gangly",
    "gangrene",
    "gangway",
    "gap",
    "garage",
    "garbage",
    "garden",
    "gargle",
    "garland",
    "garlic",
    "garment",
    "garnet",
    "garnish",
    "garter",
    "gas",
    "gatherer",
    "gathering",
    "gating",
    "gauging",
    "gauntlet",
    "gauze",
    "gave",
    "gawk",
    "gazing",
    "gear",
    "gecko",
    "geek",
    "geiger",
    "gem",
    "gender",
    "generic",
    "generous",
    "genetics",
    "genre",
    "gentile",
    "gentleman",
    "gently",
    "gents",
    "geography",
    "geologic",
    "geologist",
    "geology",
    "geometric",
    "geometry",
    "geranium",
    "gerbil",
    "geriatric",
    "germicide",
    "germinate",
    "germless",
    "germproof",
    "gestate",
    "gestation",
    "gesture",
    "getaway",
    "getting",
    "getup",
    "giant",
    "gibberish",
    "giblet",
    "giddily",
    "giddiness",
    "giddy",
    "gift",
    "gigabyte",
    "gigahertz",
    "gigantic",
    "giggle",
    "giggling",
    "giggly",
    "gigolo",
    "gilled",
    "gills",
    "gimmick",
    "girdle",
    "giveaway",
    "given",
    "giver",
    "giving",
    "gizmo",
    "gizzard",
    "glacial",
    "glacier",
    "glade",
    "gladiator",
    "gladly",
    "glamorous",
    "glamour",
    "glance",
    "glancing",
    "glandular",
    "glare",
    "glaring",
    "glass",
    "glaucoma",
    "glazing",
    "gleaming",
    "gleeful",
    "glider",
    "gliding",
    "glimmer",
    "glimpse",
    "glisten",
    "glitch",
    "glitter",
    "glitzy",
    "gloater",
    "gloating",
    "gloomily",
    "gloomy",
    "glorified",
    "glorifier",
    "glorify",
    "glorious",
    "glory",
    "gloss",
    "glove",
    "glowing",
    "glowworm",
    "glucose",
    "glue",
    "gluten",
    "glutinous",
    "glutton",
    "gnarly",
    "gnat",
    "goal",
    "goatskin",
    "goes",
    "goggles",
    "going",
    "goldfish",
    "goldmine",
    "goldsmith",
    "golf",
    "goliath",
    "gonad",
    "gondola",
    "gone",
    "gong",
    "good",
    "gooey",
    "goofball",
    "goofiness",
    "goofy",
    "google",
    "goon",
    "gopher",
    "gore",
    "gorged",
    "gorgeous",
    "gory",
    "gosling",
    "gossip",
    "gothic",
    "gotten",
    "gout",
    "gown",
    "grab",
    "graceful",
    "graceless",
    "gracious",
    "gradation",
    "graded",
    "grader",
    "gradient",
    "grading",
    "gradually",
    "graduate",
    "graffiti",
    "grafted",
    "grafting",
    "grain",
    "granddad",
    "grandkid",
    "grandly",
    "grandma",
    "grandpa",
    "grandson",
    "granite",
    "granny",
    "granola",
    "grant",
    "granular",
    "grape",
    "graph",
    "grapple",
    "grappling",
    "grasp",
    "grass",
    "gratified",
    "gratify",
    "grating",
    "gratitude",
    "gratuity",
    "gravel",
    "graveness",
    "graves",
    "graveyard",
    "gravitate",
    "gravity",
    "gravy",
    "gray",
    "grazing",
    "greasily",
    "greedily",
    "greedless",
    "greedy",
    "green",
    "greeter",
    "greeting",
    "grew",
    "greyhound",
    "grid",
    "grief",
    "grievance",
    "grieving",
    "grievous",
    "grill",
    "grimace",
    "grimacing",
    "grime",
    "griminess",
    "grimy",
    "grinch",
    "grinning",
    "grip",
    "gristle",
    "grit",
    "groggily",
    "groggy",
    "groin",
    "groom",
    "groove",
    "grooving",
    "groovy",
    "grope",
    "ground",
    "grouped",
    "grout",
    "grove",
    "grower",
    "growing",
    "growl",
    "grub",
    "grudge",
    "grudging",
    "grueling",
    "gruffly",
    "grumble",
    "grumbling",
    "grumbly",
    "grumpily",
    "grunge",
    "grunt",
    "guacamole",
    "guidable",
    "guidance",
    "guide",
    "guiding",
    "guileless",
    "guise",
    "gulf",
    "gullible",
    "gully",
    "gulp",
    "gumball",
    "gumdrop",
    "gumminess",
    "gumming",
    "gummy",
    "gurgle",
    "gurgling",
    "guru",
    "gush",
    "gusto",
    "gusty",
    "gutless",
    "guts",
    "gutter",
    "guy",
    "guzzler",
    "gyration",
    "habitable",
    "habitant",
    "habitat",
    "habitual",
    "hacked",
    "hacker",
    "hacking",
    "hacksaw",
    "had",
    "haggler",
    "haiku",
    "half",
    "halogen",
    "halt",
    "halved",
    "halves",
    "hamburger",
    "hamlet",
    "hammock",
    "hamper",
    "hamster",
    "hamstring",
    "handbag",
    "handball",
    "handbook",
    "handbrake",
    "handcart",
    "handclap",
    "handclasp",
    "handcraft",
    "handcuff",
    "handed",
    "handful",
    "handgrip",
    "handgun",
    "handheld",
    "handiness",
    "handiwork",
    "handlebar",
    "handled",
    "handler",
    "handling",
    "handmade",
    "handoff",
    "handpick",
    "handprint",
    "handrail",
    "handsaw",
    "handset",
    "handsfree",
    "handshake",
    "handstand",
    "handwash",
    "handwork",
    "handwoven",
    "handwrite",
    "handyman",
    "hangnail",
    "hangout",
    "hangover",
    "hangup",
    "hankering",
    "hankie",
    "hanky",
    "haphazard",
    "happening",
    "happier",
    "happiest",
    "happily",
    "happiness",
    "happy",
    "harbor",
    "hardcopy",
    "hardcore",
    "hardcover",
    "harddisk",
    "hardened",
    "hardener",
    "hardening",
    "hardhat",
    "hardhead",
    "hardiness",
    "hardly",
    "hardness",
    "hardship",
    "hardware",
    "hardwired",
    "hardwood",
    "hardy",
    "harmful",
    "harmless",
    "harmonica",
    "harmonics",
    "harmonize",
    "harmony",
    "harness",
    "harpist",
    "harsh",
    "harvest",
    "hash",
    "hassle",
    "haste",
    "hastily",
    "hastiness",
    "hasty",
    "hatbox",
    "hatchback",
    "hatchery",
    "hatchet",
    "hatching",
    "hatchling",
    "hate",
    "hatless",
    "hatred",
    "haunt",
    "haven",
    "hazard",
    "hazelnut",
    "hazily",
    "haziness",
    "hazing",
    "hazy",
    "headache",
    "headband",
    "headboard",
    "headcount",
    "headdress",
    "headed",
    "header",
    "headfirst",
    "headgear",
    "heading",
    "headlamp",
    "headless",
    "headlock",
    "headphone",
    "headpiece",
    "headrest",
    "headroom",
    "headscarf",
    "headset",
    "headsman",
    "headstand",
    "headstone",
    "headway",
    "headwear",
    "heap",
    "heat",
    "heave",
    "heavily",
    "heaviness",
    "heaving",
    "hedge",
    "hedging",
    "heftiness",
    "hefty",
    "helium",
    "helmet",
    "helper",
    "helpful",
    "helping",
    "helpless",
    "helpline",
    "hemlock",
    "hemstitch",
    "hence",
    "henchman",
    "henna",
    "herald",
    "herbal",
    "herbicide",
    "herbs",
    "heritage",
    "hermit",
    "heroics",
    "heroism",
    "herring",
    "herself",
    "hertz",
    "hesitancy",
    "hesitant",
    "hesitate",
    "hexagon",
    "hexagram",
    "hubcap",
    "huddle",
    "huddling",
    "huff",
    "hug",
    "hula",
    "hulk",
    "hull",
    "human",
    "humble",
    "humbling",
    "humbly",
    "humid",
    "humiliate",
    "humility",
    "humming",
    "hummus",
    "humongous",
    "humorist",
    "humorless",
    "humorous",
    "humpback",
    "humped",
    "humvee",
    "hunchback",
    "hundredth",
    "hunger",
    "hungrily",
    "hungry",
    "hunk",
    "hunter",
    "hunting",
    "huntress",
    "huntsman",
    "hurdle",
    "hurled",
    "hurler",
    "hurling",
    "hurray",
    "hurricane",
    "hurried",
    "hurry",
    "hurt",
    "husband",
    "hush",
    "husked",
    "huskiness",
    "hut",
    "hybrid",
    "hydrant",
    "hydrated",
    "hydration",
    "hydrogen",
    "hydroxide",
    "hyperlink",
    "hypertext",
    "hyphen",
    "hypnoses",
    "hypnosis",
    "hypnotic",
    "hypnotism",
    "hypnotist",
    "hypnotize",
    "hypocrisy",
    "hypocrite",
    "ibuprofen",
    "ice",
    "iciness",
    "icing",
    "icky",
    "icon",
    "icy",
    "idealism",
    "idealist",
    "idealize",
    "ideally",
    "idealness",
    "identical",
    "identify",
    "identity",
    "ideology",
    "idiocy",
    "idiom",
    "idly",
    "igloo",
    "ignition",
    "ignore",
    "iguana",
    "illicitly",
    "illusion",
    "illusive",
    "image",
    "imaginary",
    "imagines",
    "imaging",
    "imbecile",
    "imitate",
    "imitation",
    "immature",
    "immerse",
    "immersion",
    "imminent",
    "immobile",
    "immodest",
    "immorally",
    "immortal",
    "immovable",
    "immovably",
    "immunity",
    "immunize",
    "impaired",
    "impale",
    "impart",
    "impatient",
    "impeach",
    "impeding",
    "impending",
    "imperfect",
    "imperial",
    "impish",
    "implant",
    "implement",
    "implicate",
    "implicit",
    "implode",
    "implosion",
    "implosive",
    "imply",
    "impolite",
    "important",
    "importer",
    "impose",
    "imposing",
    "impotence",
    "impotency",
    "impotent",
    "impound",
    "imprecise",
    "imprint",
    "imprison",
    "impromptu",
    "improper",
    "improve",
    "improving",
    "improvise",
    "imprudent",
    "impulse",
    "impulsive",
    "impure",
    "impurity",
    "iodine",
    "iodize",
    "ion",
    "ipad",
    "iphone",
    "ipod",
    "irate",
    "irk",
    "iron",
    "irregular",
    "irrigate",
    "irritable",
    "irritably",
    "irritant",
    "irritate",
    "islamic",
    "islamist",
    "isolated",
    "isolating",
    "isolation",
    "isotope",
    "issue",
    "issuing",
    "italicize",
    "italics",
    "item",
    "itinerary",
    "itunes",
    "ivory",
    "ivy",
    "jab",
    "jackal",
    "jacket",
    "jackknife",
    "jackpot",
    "jailbird",
    "jailbreak",
    "jailer",
    "jailhouse",
    "jalapeno",
    "jam",
    "janitor",
    "january",
    "jargon",
    "jarring",
    "jasmine",
    "jaundice",
    "jaunt",
    "java",
    "jawed",
    "jawless",
    "jawline",
    "jaws",
    "jaybird",
    "jaywalker",
    "jazz",
    "jeep",
    "jeeringly",
    "jellied",
    "jelly",
    "jersey",
    "jester",
    "jet",
    "jiffy",
    "jigsaw",
    "jimmy",
    "jingle",
    "jingling",
    "jinx",
    "jitters",
    "jittery",
    "job",
    "jockey",
    "jockstrap",
    "jogger",
    "jogging",
    "john",
    "joining",
    "jokester",
    "jokingly",
    "jolliness",
    "jolly",
    "jolt",
    "jot",
    "jovial",
    "joyfully",
    "joylessly",
    "joyous",
    "joyride",
    "joystick",
    "jubilance",
    "jubilant",
    "judge",
    "judgingly",
    "judicial",
    "judiciary",
    "judo",
    "juggle",
    "juggling",
    "jugular",
    "juice",
    "juiciness",
    "juicy",
    "jujitsu",
    "jukebox",
    "july",
    "jumble",
    "jumbo",
    "jump",
    "junction",
    "juncture",
    "june",
    "junior",
    "juniper",
    "junkie",
    "junkman",
    "junkyard",
    "jurist",
    "juror",
    "jury",
    "justice",
    "justifier",
    "justify",
    "justly",
    "justness",
    "juvenile",
    "kabob",
    "kangaroo",
    "karaoke",
    "karate",
    "karma",
    "kebab",
    "keenly",
    "keenness",
    "keep",
    "keg",
    "kelp",
    "kennel",
    "kept",
    "kerchief",
    "kerosene",
    "kettle",
    "kick",
    "kiln",
    "kilobyte",
    "kilogram",
    "kilometer",
    "kilowatt",
    "kilt",
    "kimono",
    "kindle",
    "kindling",
    "kindly",
    "kindness",
    "kindred",
    "kinetic",
    "kinfolk",
    "king",
    "kinship",
    "kinsman",
    "kinswoman",
    "kissable",
    "kisser",
    "kissing",
    "kitchen",
    "kite",
    "kitten",
    "kitty",
    "kiwi",
    "kleenex",
    "knapsack",
    "knee",
    "knelt",
    "knickers",
    "knoll",
    "koala",
    "kooky",
    "kosher",
    "krypton",
    "kudos",
    "kung",
    "labored",
    "laborer",
    "laboring",
    "laborious",
    "labrador",
    "ladder",
    "ladies",
    "ladle",
    "ladybug",
    "ladylike",
    "lagged",
    "lagging",
    "lagoon",
    "lair",
    "lake",
    "lance",
    "landed",
    "landfall",
    "landfill",
    "landing",
    "landlady",
    "landless",
    "landline",
    "landlord",
    "landmark",
    "landmass",
    "landmine",
    "landowner",
    "landscape",
    "landside",
    "landslide",
    "language",
    "lankiness",
    "lanky",
    "lantern",
    "lapdog",
    "lapel",
    "lapped",
    "lapping",
    "laptop",
    "lard",
    "large",
    "lark",
    "lash",
    "lasso",
    "last",
    "latch",
    "late",
    "lather",
    "latitude",
    "latrine",
    "latter",
    "latticed",
    "launch",
    "launder",
    "laundry",
    "laurel",
    "lavender",
    "lavish",
    "laxative",
    "lazily",
    "laziness",
    "lazy",
    "lecturer",
    "left",
    "legacy",
    "legal",
    "legend",
    "legged",
    "leggings",
    "legible",
    "legibly",
    "legislate",
    "lego",
    "legroom",
    "legume",
    "legwarmer",
    "legwork",
    "lemon",
    "lend",
    "length",
    "lens",
    "lent",
    "leotard",
    "lesser",
    "letdown",
    "lethargic",
    "lethargy",
    "letter",
    "lettuce",
    "level",
    "leverage",
    "levers",
    "levitate",
    "levitator",
    "liability",
    "liable",
    "liberty",
    "librarian",
    "library",
    "licking",
    "licorice",
    "lid",
    "life",
    "lifter",
    "lifting",
    "liftoff",
    "ligament",
    "likely",
    "likeness",
    "likewise",
    "liking",
    "lilac",
    "lilly",
    "lily",
    "limb",
    "limeade",
    "limelight",
    "limes",
    "limit",
    "limping",
    "limpness",
    "line",
    "lingo",
    "linguini",
    "linguist",
    "lining",
    "linked",
    "linoleum",
    "linseed",
    "lint",
    "lion",
    "lip",
    "liquefy",
    "liqueur",
    "liquid",
    "lisp",
    "list",
    "litigate",
    "litigator",
    "litmus",
    "litter",
    "little",
    "livable",
    "lived",
    "lively",
    "liver",
    "livestock",
    "lividly",
    "living",
    "lizard",
    "lubricant",
    "lubricate",
    "lucid",
    "luckily",
    "luckiness",
    "luckless",
    "lucrative",
    "ludicrous",
    "lugged",
    "lukewarm",
    "lullaby",
    "lumber",
    "luminance",
    "luminous",
    "lumpiness",
    "lumping",
    "lumpish",
    "lunacy",
    "lunar",
    "lunchbox",
    "luncheon",
    "lunchroom",
    "lunchtime",
    "lung",
    "lurch",
    "lure",
    "luridness",
    "lurk",
    "lushly",
    "lushness",
    "luster",
    "lustfully",
    "lustily",
    "lustiness",
    "lustrous",
    "lusty",
    "luxurious",
    "luxury",
    "lying",
    "lyrically",
    "lyricism",
    "lyricist",
    "lyrics",
    "macarena",
    "macaroni",
    "macaw",
    "mace",
    "machine",
    "machinist",
    "magazine",
    "magenta",
    "maggot",
    "magical",
    "magician",
    "magma",
    "magnesium",
    "magnetic",
    "magnetism",
    "magnetize",
    "magnifier",
    "magnify",
    "magnitude",
    "magnolia",
    "mahogany",
    "maimed",
    "majestic",
    "majesty",
    "majorette",
    "majority",
    "makeover",
    "maker",
    "makeshift",
    "making",
    "malformed",
    "malt",
    "mama",
    "mammal",
    "mammary",
    "mammogram",
    "manager",
    "managing",
    "manatee",
    "mandarin",
    "mandate",
    "mandatory",
    "mandolin",
    "manger",
    "mangle",
    "mango",
    "mangy",
    "manhandle",
    "manhole",
    "manhood",
    "manhunt",
    "manicotti",
    "manicure",
    "manifesto",
    "manila",
    "mankind",
    "manlike",
    "manliness",
    "manly",
    "manmade",
    "manned",
    "mannish",
    "manor",
    "manpower",
    "mantis",
    "mantra",
    "manual",
    "many",
    "map",
    "marathon",
    "marauding",
    "marbled",
    "marbles",
    "marbling",
    "march",
    "mardi",
    "margarine",
    "margarita",
    "margin",
    "marigold",
    "marina",
    "marine",
    "marital",
    "maritime",
    "marlin",
    "marmalade",
    "maroon",
    "married",
    "marrow",
    "marry",
    "marshland",
    "marshy",
    "marsupial",
    "marvelous",
    "marxism",
    "mascot",
    "masculine",
    "mashed",
    "mashing",
    "massager",
    "masses",
    "massive",
    "mastiff",
    "matador",
    "matchbook",
    "matchbox",
    "matcher",
    "matching",
    "matchless",
    "material",
    "maternal",
    "maternity",
    "math",
    "mating",
    "matriarch",
    "matrimony",
    "matrix",
    "matron",
    "matted",
    "matter",
    "maturely",
    "maturing",
    "maturity",
    "mauve",
    "maverick",
    "maximize",
    "maximum",
    "maybe",
    "mayday",
    "mayflower",
    "moaner",
    "moaning",
    "mobile",
    "mobility",
    "mobilize",
    "mobster",
    "mocha",
    "mocker",
    "mockup",
    "modified",
    "modify",
    "modular",
    "modulator",
    "module",
    "moisten",
    "moistness",
    "moisture",
    "molar",
    "molasses",
    "mold",
    "molecular",
    "molecule",
    "molehill",
    "mollusk",
    "mom",
    "monastery",
    "monday",
    "monetary",
    "monetize",
    "moneybags",
    "moneyless",
    "moneywise",
    "mongoose",
    "mongrel",
    "monitor",
    "monkhood",
    "monogamy",
    "monogram",
    "monologue",
    "monopoly",
    "monorail",
    "monotone",
    "monotype",
    "monoxide",
    "monsieur",
    "monsoon",
    "monstrous",
    "monthly",
    "monument",
    "moocher",
    "moodiness",
    "moody",
    "mooing",
    "moonbeam",
    "mooned",
    "moonlight",
    "moonlike",
    "moonlit",
    "moonrise",
    "moonscape",
    "moonshine",
    "moonstone",
    "moonwalk",
    "mop",
    "morale",
    "morality",
    "morally",
    "morbidity",
    "morbidly",
    "morphine",
    "morphing",
    "morse",
    "mortality",
    "mortally",
    "mortician",
    "mortified",
    "mortify",
    "mortuary",
    "mosaic",
    "mossy",
    "most",
    "mothball",
    "mothproof",
    "motion",
    "motivate",
    "motivator",
    "motive",
    "motocross",
    "motor",
    "motto",
    "mountable",
    "mountain",
    "mounted",
    "mounting",
    "mourner",
    "mournful",
    "mouse",
    "mousiness",
    "moustache",
    "mousy",
    "mouth",
    "movable",
    "move",
    "movie",
    "moving",
    "mower",
    "mowing",
    "much",
    "muck",
    "mud",
    "mug",
    "mulberry",
    "mulch",
    "mule",
    "mulled",
    "mullets",
    "multiple",
    "multiply",
    "multitask",
    "multitude",
    "mumble",
    "mumbling",
    "mumbo",
    "mummified",
    "mummify",
    "mummy",
    "mumps",
    "munchkin",
    "mundane",
    "municipal",
    "muppet",
    "mural",
    "murkiness",
    "murky",
    "murmuring",
    "muscular",
    "museum",
    "mushily",
    "mushiness",
    "mushroom",
    "mushy",
    "music",
    "musket",
    "muskiness",
    "musky",
    "mustang",
    "mustard",
    "muster",
    "mustiness",
    "musty",
    "mutable",
    "mutate",
    "mutation",
    "mute",
    "mutilated",
    "mutilator",
    "mutiny",
    "mutt",
    "mutual",
    "muzzle",
    "myself",
    "myspace",
    "mystified",
    "mystify",
    "myth",
    "nacho",
    "nag",
    "nail",
    "name",
    "naming",
    "nanny",
    "nanometer",
    "nape",
    "napkin",
    "napped",
    "napping",
    "nappy",
    "narrow",
    "nastily",
    "nastiness",
    "national",
    "native",
    "nativity",
    "natural",
    "nature",
    "naturist",
    "nautical",
    "navigate",
    "navigator",
    "navy",
    "nearby",
    "nearest",
    "nearly",
    "nearness",
    "neatly",
    "neatness",
    "nebula",
    "nebulizer",
    "nectar",
    "negate",
    "negation",
    "negative",
    "neglector",
    "negligee",
    "negligent",
    "negotiate",
    "nemeses",
    "nemesis",
    "neon",
    "nephew",
    "nerd",
    "nervous",
    "nervy",
    "nest",
    "net",
    "neurology",
    "neuron",
    "neurosis",
    "neurotic",
    "neuter",
    "neutron",
    "never",
    "next",
    "nibble",
    "nickname",
    "nicotine",
    "niece",
    "nifty",
    "nimble",
    "nimbly",
    "nineteen",
    "ninetieth",
    "ninja",
    "nintendo",
    "ninth",
    "nuclear",
    "nuclei",
    "nucleus",
    "nugget",
    "nullify",
    "number",
    "numbing",
    "numbly",
    "numbness",
    "numeral",
    "numerate",
    "numerator",
    "numeric",
    "numerous",
    "nuptials",
    "nursery",
    "nursing",
    "nurture",
    "nutcase",
    "nutlike",
    "nutmeg",
    "nutrient",
    "nutshell",
    "nuttiness",
    "nutty",
    "nuzzle",
    "nylon",
    "oaf",
    "oak",
    "oasis",
    "oat",
    "obedience",
    "obedient",
    "obituary",
    "object",
    "obligate",
    "obliged",
    "oblivion",
    "oblivious",
    "oblong",
    "obnoxious",
    "oboe",
    "obscure",
    "obscurity",
    "observant",
    "observer",
    "observing",
    "obsessed",
    "obsession",
    "obsessive",
    "obsolete",
    "obstacle",
    "obstinate",
    "obstruct",
    "obtain",
    "obtrusive",
    "obtuse",
    "obvious",
    "occultist",
    "occupancy",
    "occupant",
    "occupier",
    "occupy",
    "ocean",
    "ocelot",
    "octagon",
    "octane",
    "october",
    "octopus",
    "ogle",
    "oil",
    "oink",
    "ointment",
    "okay",
    "old",
    "olive",
    "olympics",
    "omega",
    "omen",
    "ominous",
    "omission",
    "omit",
    "omnivore",
    "onboard",
    "oncoming",
    "ongoing",
    "onion",
    "online",
    "onlooker",
    "only",
    "onscreen",
    "onset",
    "onshore",
    "onslaught",
    "onstage",
    "onto",
    "onward",
    "onyx",
    "oops",
    "ooze",
    "oozy",
    "opacity",
    "opal",
    "open",
    "operable",
    "operate",
    "operating",
    "operation",
    "operative",
    "operator",
    "opium",
    "opossum",
    "opponent",
    "oppose",
    "opposing",
    "opposite",
    "oppressed",
    "oppressor",
    "opt",
    "opulently",
    "osmosis",
    "other",
    "otter",
    "ouch",
    "ought",
    "ounce",
    "outage",
    "outback",
    "outbid",
    "outboard",
    "outbound",
    "outbreak",
    "outburst",
    "outcast",
    "outclass",
    "outcome",
    "outdated",
    "outdoors",
    "outer",
    "outfield",
    "outfit",
    "outflank",
    "outgoing",
    "outgrow",
    "outhouse",
    "outing",
    "outlast",
    "outlet",
    "outline",
    "outlook",
    "outlying",
    "outmatch",
    "outmost",
    "outnumber",
    "outplayed",
    "outpost",
    "outpour",
    "output",
    "outrage",
    "outrank",
    "outreach",
    "outright",
    "outscore",
    "outsell",
    "outshine",
    "outshoot",
    "outsider",
    "outskirts",
    "outsmart",
    "outsource",
    "outspoken",
    "outtakes",
    "outthink",
    "outward",
    "outweigh",
    "outwit",
    "oval",
    "ovary",
    "oven",
    "overact",
    "overall",
    "overarch",
    "overbid",
    "overbill",
    "overbite",
    "overblown",
    "overboard",
    "overbook",
    "overbuilt",
    "overcast",
    "overcoat",
    "overcome",
    "overcook",
    "overcrowd",
    "overdraft",
    "overdrawn",
    "overdress",
    "overdrive",
    "overdue",
    "overeager",
    "overeater",
    "overexert",
    "overfed",
    "overfeed",
    "overfill",
    "overflow",
    "overfull",
    "overgrown",
    "overhand",
    "overhang",
    "overhaul",
    "overhead",
    "overhear",
    "overheat",
    "overhung",
    "overjoyed",
    "overkill",
    "overlabor",
    "overlaid",
    "overlap",
    "overlay",
    "overload",
    "overlook",
    "overlord",
    "overlying",
    "overnight",
    "overpass",
    "overpay",
    "overplant",
    "overplay",
    "overpower",
    "overprice",
    "overrate",
    "overreach",
    "overreact",
    "override",
    "overripe",
    "overrule",
    "overrun",
    "overshoot",
    "overshot",
    "oversight",
    "oversized",
    "oversleep",
    "oversold",
    "overspend",
    "overstate",
    "overstay",
    "overstep",
    "overstock",
    "overstuff",
    "oversweet",
    "overtake",
    "overthrow",
    "overtime",
    "overtly",
    "overtone",
    "overture",
    "overturn",
    "overuse",
    "overvalue",
    "overview",
    "overwrite",
    "owl",
    "oxford",
    "oxidant",
    "oxidation",
    "oxidize",
    "oxidizing",
    "oxygen",
    "oxymoron",
    "oyster",
    "ozone",
    "paced",
    "pacemaker",
    "pacific",
    "pacifier",
    "pacifism",
    "pacifist",
    "pacify",
    "padded",
    "padding",
    "paddle",
    "paddling",
    "padlock",
    "pagan",
    "pager",
    "paging",
    "pajamas",
    "palace",
    "palatable",
    "palm",
    "palpable",
    "palpitate",
    "paltry",
    "pampered",
    "pamperer",
    "pampers",
    "pamphlet",
    "panama",
    "pancake",
    "pancreas",
    "panda",
    "pandemic",
    "pang",
    "panhandle",
    "panic",
    "panning",
    "panorama",
    "panoramic",
    "panther",
    "pantomime",
    "pantry",
    "pants",
    "pantyhose",
    "paparazzi",
    "papaya",
    "paper",
    "paprika",
    "papyrus",
    "parabola",
    "parachute",
    "parade",
    "paradox",
    "paragraph",
    "parakeet",
    "paralegal",
    "paralyses",
    "paralysis",
    "paralyze",
    "paramedic",
    "parameter",
    "paramount",
    "parasail",
    "parasite",
    "parasitic",
    "parcel",
    "parched",
    "parchment",
    "pardon",
    "parish",
    "parka",
    "parking",
    "parkway",
    "parlor",
    "parmesan",
    "parole",
    "parrot",
    "parsley",
    "parsnip",
    "partake",
    "parted",
    "parting",
    "partition",
    "partly",
    "partner",
    "partridge",
    "party",
    "passable",
    "passably",
    "passage",
    "passcode",
    "passenger",
    "passerby",
    "passing",
    "passion",
    "passive",
    "passivism",
    "passover",
    "passport",
    "password",
    "pasta",
    "pasted",
    "pastel",
    "pastime",
    "pastor",
    "pastrami",
    "pasture",
    "pasty",
    "patchwork",
    "patchy",
    "paternal",
    "paternity",
    "path",
    "patience",
    "patient",
    "patio",
    "patriarch",
    "patriot",
    "patrol",
    "patronage",
    "patronize",
    "pauper",
    "pavement",
    "paver",
    "pavestone",
    "pavilion",
    "paving",
    "pawing",
    "payable",
    "payback",
    "paycheck",
    "payday",
    "payee",
    "payer",
    "paying",
    "payment",
    "payphone",
    "payroll",
    "pebble",
    "pebbly",
    "pecan",
    "pectin",
    "peculiar",
    "peddling",
    "pediatric",
    "pedicure",
    "pedigree",
    "pedometer",
    "pegboard",
    "pelican",
    "pellet",
    "pelt",
    "pelvis",
    "penalize",
    "penalty",
    "pencil",
    "pendant",
    "pending",
    "penholder",
    "penknife",
    "pennant",
    "penniless",
    "penny",
    "penpal",
    "pension",
    "pentagon",
    "pentagram",
    "pep",
    "perceive",
    "percent",
    "perch",
    "percolate",
    "perennial",
    "perfected",
    "perfectly",
    "perfume",
    "periscope",
    "perish",
    "perjurer",
    "perjury",
    "perkiness",
    "perky",
    "perm",
    "peroxide",
    "perpetual",
    "perplexed",
    "persecute",
    "persevere",
    "persuaded",
    "persuader",
    "pesky",
    "peso",
    "pessimism",
    "pessimist",
    "pester",
    "pesticide",
    "petal",
    "petite",
    "petition",
    "petri",
    "petroleum",
    "petted",
    "petticoat",
    "pettiness",
    "petty",
    "petunia",
    "phantom",
    "phobia",
    "phoenix",
    "phonebook",
    "phoney",
    "phonics",
    "phoniness",
    "phony",
    "phosphate",
    "photo",
    "phrase",
    "phrasing",
    "placard",
    "placate",
    "placidly",
    "plank",
    "planner",
    "plant",
    "plasma",
    "plaster",
    "plastic",
    "plated",
    "platform",
    "plating",
    "platinum",
    "platonic",
    "platter",
    "platypus",
    "plausible",
    "plausibly",
    "playable",
    "playback",
    "player",
    "playful",
    "playgroup",
    "playhouse",
    "playing",
    "playlist",
    "playmaker",
    "playmate",
    "playoff",
    "playpen",
    "playroom",
    "playset",
    "plaything",
    "playtime",
    "plaza",
    "pleading",
    "pleat",
    "pledge",
    "plentiful",
    "plenty",
    "plethora",
    "plexiglas",
    "pliable",
    "plod",
    "plop",
    "plot",
    "plow",
    "ploy",
    "pluck",
    "plug",
    "plunder",
    "plunging",
    "plural",
    "plus",
    "plutonium",
    "plywood",
    "poach",
    "pod",
    "poem",
    "poet",
    "pogo",
    "pointed",
    "pointer",
    "pointing",
    "pointless",
    "pointy",
    "poise",
    "poison",
    "poker",
    "poking",
    "polar",
    "police",
    "policy",
    "polio",
    "polish",
    "politely",
    "polka",
    "polo",
    "polyester",
    "polygon",
    "polygraph",
    "polymer",
    "poncho",
    "pond",
    "pony",
    "popcorn",
    "pope",
    "poplar",
    "popper",
    "poppy",
    "popsicle",
    "populace",
    "popular",
    "populate",
    "porcupine",
    "pork",
    "porous",
    "porridge",
    "portable",
    "portal",
    "portfolio",
    "porthole",
    "portion",
    "portly",
    "portside",
    "poser",
    "posh",
    "posing",
    "possible",
    "possibly",
    "possum",
    "postage",
    "postal",
    "postbox",
    "postcard",
    "posted",
    "poster",
    "posting",
    "postnasal",
    "posture",
    "postwar",
    "pouch",
    "pounce",
    "pouncing",
    "pound",
    "pouring",
    "pout",
    "powdered",
    "powdering",
    "powdery",
    "power",
    "powwow",
    "pox",
    "praising",
    "prance",
    "prancing",
    "pranker",
    "prankish",
    "prankster",
    "prayer",
    "praying",
    "preacher",
    "preaching",
    "preachy",
    "preamble",
    "precinct",
    "precise",
    "precision",
    "precook",
    "precut",
    "predator",
    "predefine",
    "predict",
    "preface",
    "prefix",
    "preflight",
    "preformed",
    "pregame",
    "pregnancy",
    "pregnant",
    "preheated",
    "prelaunch",
    "prelaw",
    "prelude",
    "premiere",
    "premises",
    "premium",
    "prenatal",
    "preoccupy",
    "preorder",
    "prepaid",
    "prepay",
    "preplan",
    "preppy",
    "preschool",
    "prescribe",
    "preseason",
    "preset",
    "preshow",
    "president",
    "presoak",
    "press",
    "presume",
    "presuming",
    "preteen",
    "pretended",
    "pretender",
    "pretense",
    "pretext",
    "pretty",
    "pretzel",
    "prevail",
    "prevalent",
    "prevent",
    "preview",
    "previous",
    "prewar",
    "prewashed",
    "prideful",
    "pried",
    "primal",
    "primarily",
    "primary",
    "primate",
    "primer",
    "primp",
    "princess",
    "print",
    "prior",
    "prism",
    "prison",
    "prissy",
    "pristine",
    "privacy",
    "private",
    "privatize",
    "prize",
    "proactive",
    "probable",
    "probably",
    "probation",
    "probe",
    "probing",
    "probiotic",
    "problem",
    "procedure",
    "process",
    "proclaim",
    "procreate",
    "procurer",
    "prodigal",
    "prodigy",
    "produce",
    "product",
    "profane",
    "profanity",
    "professed",
    "professor",
    "profile",
    "profound",
    "profusely",
    "progeny",
    "prognosis",
    "program",
    "progress",
    "projector",
    "prologue",
    "prolonged",
    "promenade",
    "prominent",
    "promoter",
    "promotion",
    "prompter",
    "promptly",
    "prone",
    "prong",
    "pronounce",
    "pronto",
    "proofing",
    "proofread",
    "proofs",
    "propeller",
    "properly",
    "property",
    "proponent",
    "proposal",
    "propose",
    "props",
    "prorate",
    "protector",
    "protegee",
    "proton",
    "prototype",
    "protozoan",
    "protract",
    "protrude",
    "proud",
    "provable",
    "proved",
    "proven",
    "provided",
    "provider",
    "providing",
    "province",
    "proving",
    "provoke",
    "provoking",
    "provolone",
    "prowess",
    "prowler",
    "prowling",
    "proximity",
    "proxy",
    "prozac",
    "prude",
    "prudishly",
    "prune",
    "pruning",
    "pry",
    "psychic",
    "public",
    "publisher",
    "pucker",
    "pueblo",
    "pug",
    "pull",
    "pulmonary",
    "pulp",
    "pulsate",
    "pulse",
    "pulverize",
    "puma",
    "pumice",
    "pummel",
    "punch",
    "punctual",
    "punctuate",
    "punctured",
    "pungent",
    "punisher",
    "punk",
    "pupil",
    "puppet",
    "puppy",
    "purchase",
    "pureblood",
    "purebred",
    "purely",
    "pureness",
    "purgatory",
    "purge",
    "purging",
    "purifier",
    "purify",
    "purist",
    "puritan",
    "purity",
    "purple",
    "purplish",
    "purposely",
    "purr",
    "purse",
    "pursuable",
    "pursuant",
    "pursuit",
    "purveyor",
    "pushcart",
    "pushchair",
    "pusher",
    "pushiness",
    "pushing",
    "pushover",
    "pushpin",
    "pushup",
    "pushy",
    "putdown",
    "putt",
    "puzzle",
    "puzzling",
    "pyramid",
    "pyromania",
    "python",
    "quack",
    "quadrant",
    "quail",
    "quaintly",
    "quake",
    "quaking",
    "qualified",
    "qualifier",
    "qualify",
    "quality",
    "qualm",
    "quantum",
    "quarrel",
    "quarry",
    "quartered",
    "quarterly",
    "quarters",
    "quartet",
    "quench",
    "query",
    "quicken",
    "quickly",
    "quickness",
    "quicksand",
    "quickstep",
    "quiet",
    "quill",
    "quilt",
    "quintet",
    "quintuple",
    "quirk",
    "quit",
    "quiver",
    "quizzical",
    "quotable",
    "quotation",
    "quote",
    "rabid",
    "race",
    "racing",
    "racism",
    "rack",
    "racoon",
    "radar",
    "radial",
    "radiance",
    "radiantly",
    "radiated",
    "radiation",
    "radiator",
    "radio",
    "radish",
    "raffle",
    "raft",
    "rage",
    "ragged",
    "raging",
    "ragweed",
    "raider",
    "railcar",
    "railing",
    "railroad",
    "railway",
    "raisin",
    "rake",
    "raking",
    "rally",
    "ramble",
    "rambling",
    "ramp",
    "ramrod",
    "ranch",
    "rancidity",
    "random",
    "ranged",
    "ranger",
    "ranging",
    "ranked",
    "ranking",
    "ransack",
    "ranting",
    "rants",
    "rare",
    "rarity",
    "rascal",
    "rash",
    "rasping",
    "ravage",
    "raven",
    "ravine",
    "raving",
    "ravioli",
    "ravishing",
    "reabsorb",
    "reach",
    "reacquire",
    "reaction",
    "reactive",
    "reactor",
    "reaffirm",
    "ream",
    "reanalyze",
    "reappear",
    "reapply",
    "reappoint",
    "reapprove",
    "rearrange",
    "rearview",
    "reason",
    "reassign",
    "reassure",
    "reattach",
    "reawake",
    "rebalance",
    "rebate",
    "rebel",
    "rebirth",
    "reboot",
    "reborn",
    "rebound",
    "rebuff",
    "rebuild",
    "rebuilt",
    "reburial",
    "rebuttal",
    "recall",
    "recant",
    "recapture",
    "recast",
    "recede",
    "recent",
    "recess",
    "recharger",
    "recipient",
    "recital",
    "recite",
    "reckless",
    "reclaim",
    "recliner",
    "reclining",
    "recluse",
    "reclusive",
    "recognize",
    "recoil",
    "recollect",
    "recolor",
    "reconcile",
    "reconfirm",
    "reconvene",
    "recopy",
    "record",
    "recount",
    "recoup",
    "recovery",
    "recreate",
    "rectal",
    "rectangle",
    "rectified",
    "rectify",
    "recycled",
    "recycler",
    "recycling",
    "reemerge",
    "reenact",
    "reenter",
    "reentry",
    "reexamine",
    "referable",
    "referee",
    "reference",
    "refill",
    "refinance",
    "refined",
    "refinery",
    "refining",
    "refinish",
    "reflected",
    "reflector",
    "reflex",
    "reflux",
    "refocus",
    "refold",
    "reforest",
    "reformat",
    "reformed",
    "reformer",
    "reformist",
    "refract",
    "refrain",
    "refreeze",
    "refresh",
    "refried",
    "refueling",
    "refund",
    "refurbish",
    "refurnish",
    "refusal",
    "refuse",
    "refusing",
    "refutable",
    "refute",
    "regain",
    "regalia",
    "regally",
    "reggae",
    "regime",
    "region",
    "register",
    "registrar",
    "registry",
    "regress",
    "regretful",
    "regroup",
    "regular",
    "regulate",
    "regulator",
    "rehab",
    "reheat",
    "rehire",
    "rehydrate",
    "reimburse",
    "reissue",
    "reiterate",
    "rejoice",
    "rejoicing",
    "rejoin",
    "rekindle",
    "relapse",
    "relapsing",
    "relatable",
    "related",
    "relation",
    "relative",
    "relax",
    "relay",
    "relearn",
    "release",
    "relenting",
    "reliable",
    "reliably",
    "reliance",
    "reliant",
    "relic",
    "relieve",
    "relieving",
    "relight",
    "relish",
    "relive",
    "reload",
    "relocate",
    "relock",
    "reluctant",
    "rely",
    "remake",
    "remark",
    "remarry",
    "rematch",
    "remedial",
    "remedy",
    "remember",
    "reminder",
    "remindful",
    "remission",
    "remix",
    "remnant",
    "remodeler",
    "remold",
    "remorse",
    "remote",
    "removable",
    "removal",
    "removed",
    "remover",
    "removing",
    "rename",
    "renderer",
    "rendering",
    "rendition",
    "renegade",
    "renewable",
    "renewably",
    "renewal",
    "renewed",
    "renounce",
    "renovate",
    "renovator",
    "rentable",
    "rental",
    "rented",
    "renter",
    "reoccupy",
    "reoccur",
    "reopen",
    "reorder",
    "repackage",
    "repacking",
    "repaint",
    "repair",
    "repave",
    "repaying",
    "repayment",
    "repeal",
    "repeated",
    "repeater",
    "repent",
    "rephrase",
    "replace",
    "replay",
    "replica",
    "reply",
    "reporter",
    "repose",
    "repossess",
    "repost",
    "repressed",
    "reprimand",
    "reprint",
    "reprise",
    "reproach",
    "reprocess",
    "reproduce",
    "reprogram",
    "reps",
    "reptile",
    "reptilian",
    "repugnant",
    "repulsion",
    "repulsive",
    "repurpose",
    "reputable",
    "reputably",
    "request",
    "require",
    "requisite",
    "reroute",
    "rerun",
    "resale",
    "resample",
    "rescuer",
    "reseal",
    "research",
    "reselect",
    "reseller",
    "resemble",
    "resend",
    "resent",
    "reset",
    "reshape",
    "reshoot",
    "reshuffle",
    "residence",
    "residency",
    "resident",
    "residual",
    "residue",
    "resigned",
    "resilient",
    "resistant",
    "resisting",
    "resize",
    "resolute",
    "resolved",
    "resonant",
    "resonate",
    "resort",
    "resource",
    "respect",
    "resubmit",
    "result",
    "resume",
    "resupply",
    "resurface",
    "resurrect",
    "retail",
    "retainer",
    "retaining",
    "retake",
    "retaliate",
    "retention",
    "rethink",
    "retinal",
    "retired",
    "retiree",
    "retiring",
    "retold",
    "retool",
    "retorted",
    "retouch",
    "retrace",
    "retract",
    "retrain",
    "retread",
    "retreat",
    "retrial",
    "retrieval",
    "retriever",
    "retry",
    "return",
    "retying",
    "retype",
    "reunion",
    "reunite",
    "reusable",
    "reuse",
    "reveal",
    "reveler",
    "revenge",
    "revenue",
    "reverb",
    "revered",
    "reverence",
    "reverend",
    "reversal",
    "reverse",
    "reversing",
    "reversion",
    "revert",
    "revisable",
    "revise",
    "revision",
    "revisit",
    "revivable",
    "revival",
    "reviver",
    "reviving",
    "revocable",
    "revoke",
    "revolt",
    "revolver",
    "revolving",
    "reward",
    "rewash",
    "rewind",
    "rewire",
    "reword",
    "rework",
    "rewrap",
    "rewrite",
    "rhyme",
    "ribbon",
    "ribcage",
    "rice",
    "riches",
    "richly",
    "richness",
    "rickety",
    "ricotta",
    "riddance",
    "ridden",
    "ride",
    "riding",
    "rifling",
    "rift",
    "rigging",
    "rigid",
    "rigor",
    "rimless",
    "rimmed",
    "rind",
    "rink",
    "rinse",
    "rinsing",
    "riot",
    "ripcord",
    "ripeness",
    "ripening",
    "ripping",
    "ripple",
    "rippling",
    "riptide",
    "rise",
    "rising",
    "risk",
    "risotto",
    "ritalin",
    "ritzy",
    "rival",
    "riverbank",
    "riverbed",
    "riverboat",
    "riverside",
    "riveter",
    "riveting",
    "roamer",
    "roaming",
    "roast",
    "robbing",
    "robe",
    "robin",
    "robotics",
    "robust",
    "rockband",
    "rocker",
    "rocket",
    "rockfish",
    "rockiness",
    "rocking",
    "rocklike",
    "rockslide",
    "rockstar",
    "rocky",
    "rogue",
    "roman",
    "romp",
    "rope",
    "roping",
    "roster",
    "rosy",
    "rotten",
    "rotting",
    "rotunda",
    "roulette",
    "rounding",
    "roundish",
    "roundness",
    "roundup",
    "roundworm",
    "routine",
    "routing",
    "rover",
    "roving",
    "royal",
    "rubbed",
    "rubber",
    "rubbing",
    "rubble",
    "rubdown",
    "ruby",
    "ruckus",
    "rudder",
    "rug",
    "ruined",
    "rule",
    "rumble",
    "rumbling",
    "rummage",
    "rumor",
    "runaround",
    "rundown",
    "runner",
    "running",
    "runny",
    "runt",
    "runway",
    "rupture",
    "rural",
    "ruse",
    "rush",
    "rust",
    "rut",
    "sabbath",
    "sabotage",
    "sacrament",
    "sacred",
    "sacrifice",
    "sadden",
    "saddlebag",
    "saddled",
    "saddling",
    "sadly",
    "sadness",
    "safari",
    "safeguard",
    "safehouse",
    "safely",
    "safeness",
    "saffron",
    "saga",
    "sage",
    "sagging",
    "saggy",
    "said",
    "saint",
    "sake",
    "salad",
    "salami",
    "salaried",
    "salary",
    "saline",
    "salon",
    "saloon",
    "salsa",
    "salt",
    "salutary",
    "salute",
    "salvage",
    "salvaging",
    "salvation",
    "same",
    "sample",
    "sampling",
    "sanction",
    "sanctity",
    "sanctuary",
    "sandal",
    "sandbag",
    "sandbank",
    "sandbar",
    "sandblast",
    "sandbox",
    "sanded",
    "sandfish",
    "sanding",
    "sandlot",
    "sandpaper",
    "sandpit",
    "sandstone",
    "sandstorm",
    "sandworm",
    "sandy",
    "sanitary",
    "sanitizer",
    "sank",
    "santa",
    "sapling",
    "sappiness",
    "sappy",
    "sarcasm",
    "sarcastic",
    "sardine",
    "sash",
    "sasquatch",
    "sassy",
    "satchel",
    "satiable",
    "satin",
    "satirical",
    "satisfied",
    "satisfy",
    "saturate",
    "saturday",
    "sauciness",
    "saucy",
    "sauna",
    "savage",
    "savanna",
    "saved",
    "savings",
    "savior",
    "savor",
    "saxophone",
    "say",
    "scabbed",
    "scabby",
    "scalded",
    "scalding",
    "scale",
    "scaling",
    "scallion",
    "scallop",
    "scalping",
    "scam",
    "scandal",
    "scanner",
    "scanning",
    "scant",
    "scapegoat",
    "scarce",
    "scarcity",
    "scarecrow",
    "scared",
    "scarf",
    "scarily",
    "scariness",
    "scarring",
    "scary",
    "scavenger",
    "scenic",
    "schedule",
    "schematic",
    "scheme",
    "scheming",
    "schilling",
    "schnapps",
    "scholar",
    "science",
    "scientist",
    "scion",
    "scoff",
    "scolding",
    "scone",
    "scoop",
    "scooter",
    "scope",
    "scorch",
    "scorebook",
    "scorecard",
    "scored",
    "scoreless",
    "scorer",
    "scoring",
    "scorn",
    "scorpion",
    "scotch",
    "scoundrel",
    "scoured",
    "scouring",
    "scouting",
    "scouts",
    "scowling",
    "scrabble",
    "scraggly",
    "scrambled",
    "scrambler",
    "scrap",
    "scratch",
    "scrawny",
    "screen",
    "scribble",
    "scribe",
    "scribing",
    "scrimmage",
    "script",
    "scroll",
    "scrooge",
    "scrounger",
    "scrubbed",
    "scrubber",
    "scruffy",
    "scrunch",
    "scrutiny",
    "scuba",
    "scuff",
    "sculptor",
    "sculpture",
    "scurvy",
    "scuttle",
    "secluded",
    "secluding",
    "seclusion",
    "second",
    "secrecy",
    "secret",
    "sectional",
    "sector",
    "secular",
    "securely",
    "security",
    "sedan",
    "sedate",
    "sedation",
    "sedative",
    "sediment",
    "seduce",
    "seducing",
    "segment",
    "seismic",
    "seizing",
    "seldom",
    "selected",
    "selection",
    "selective",
    "selector",
    "self",
    "seltzer",
    "semantic",
    "semester",
    "semicolon",
    "semifinal",
    "seminar",
    "semisoft",
    "semisweet",
    "senate",
    "senator",
    "send",
    "senior",
    "senorita",
    "sensation",
    "sensitive",
    "sensitize",
    "sensually",
    "sensuous",
    "sepia",
    "september",
    "septic",
    "septum",
    "sequel",
    "sequence",
    "sequester",
    "series",
    "sermon",
    "serotonin",
    "serpent",
    "serrated",
    "serve",
    "service",
    "serving",
    "sesame",
    "sessions",
    "setback",
    "setting",
    "settle",
    "settling",
    "setup",
    "sevenfold",
    "seventeen",
    "seventh",
    "seventy",
    "severity",
    "shabby",
    "shack",
    "shaded",
    "shadily",
    "shadiness",
    "shading",
    "shadow",
    "shady",
    "shaft",
    "shakable",
    "shakily",
    "shakiness",
    "shaking",
    "shaky",
    "shale",
    "shallot",
    "shallow",
    "shame",
    "shampoo",
    "shamrock",
    "shank",
    "shanty",
    "shape",
    "shaping",
    "share",
    "sharpener",
    "sharper",
    "sharpie",
    "sharply",
    "sharpness",
    "shawl",
    "sheath",
    "shed",
    "sheep",
    "sheet",
    "shelf",
    "shell",
    "shelter",
    "shelve",
    "shelving",
    "sherry",
    "shield",
    "shifter",
    "shifting",
    "shiftless",
    "shifty",
    "shimmer",
    "shimmy",
    "shindig",
    "shine",
    "shingle",
    "shininess",
    "shining",
    "shiny",
    "ship",
    "shirt",
    "shivering",
    "shock",
    "shone",
    "shoplift",
    "shopper",
    "shopping",
    "shoptalk",
    "shore",
    "shortage",
    "shortcake",
    "shortcut",
    "shorten",
    "shorter",
    "shorthand",
    "shortlist",
    "shortly",
    "shortness",
    "shorts",
    "shortwave",
    "shorty",
    "shout",
    "shove",
    "showbiz",
    "showcase",
    "showdown",
    "shower",
    "showgirl",
    "showing",
    "showman",
    "shown",
    "showoff",
    "showpiece",
    "showplace",
    "showroom",
    "showy",
    "shrank",
    "shrapnel",
    "shredder",
    "shredding",
    "shrewdly",
    "shriek",
    "shrill",
    "shrimp",
    "shrine",
    "shrink",
    "shrivel",
    "shrouded",
    "shrubbery",
    "shrubs",
    "shrug",
    "shrunk",
    "shucking",
    "shudder",
    "shuffle",
    "shuffling",
    "shun",
    "shush",
    "shut",
    "shy",
    "siamese",
    "siberian",
    "sibling",
    "siding",
    "sierra",
    "siesta",
    "sift",
    "sighing",
    "silenced",
    "silencer",
    "silent",
    "silica",
    "silicon",
    "silk",
    "silliness",
    "silly",
    "silo",
    "silt",
    "silver",
    "similarly",
    "simile",
    "simmering",
    "simple",
    "simplify",
    "simply",
    "sincere",
    "sincerity",
    "singer",
    "singing",
    "single",
    "singular",
    "sinister",
    "sinless",
    "sinner",
    "sinuous",
    "sip",
    "siren",
    "sister",
    "sitcom",
    "sitter",
    "sitting",
    "situated",
    "situation",
    "sixfold",
    "sixteen",
    "sixth",
    "sixties",
    "sixtieth",
    "sixtyfold",
    "sizable",
    "sizably",
    "size",
    "sizing",
    "sizzle",
    "sizzling",
    "skater",
    "skating",
    "skedaddle",
    "skeletal",
    "skeleton",
    "skeptic",
    "sketch",
    "skewed",
    "skewer",
    "skid",
    "skied",
    "skier",
    "skies",
    "skiing",
    "skilled",
    "skillet",
    "skillful",
    "skimmed",
    "skimmer",
    "skimming",
    "skimpily",
    "skincare",
    "skinhead",
    "skinless",
    "skinning",
    "skinny",
    "skintight",
    "skipper",
    "skipping",
    "skirmish",
    "skirt",
    "skittle",
    "skydiver",
    "skylight",
    "skyline",
    "skype",
    "skyrocket",
    "skyward",
    "slab",
    "slacked",
    "slacker",
    "slacking",
    "slackness",
    "slacks",
    "slain",
    "slam",
    "slander",
    "slang",
    "slapping",
    "slapstick",
    "slashed",
    "slashing",
    "slate",
    "slather",
    "slaw",
    "sled",
    "sleek",
    "sleep",
    "sleet",
    "sleeve",
    "slept",
    "sliceable",
    "sliced",
    "slicer",
    "slicing",
    "slick",
    "slider",
    "slideshow",
    "sliding",
    "slighted",
    "slighting",
    "slightly",
    "slimness",
    "slimy",
    "slinging",
    "slingshot",
    "slinky",
    "slip",
    "slit",
    "sliver",
    "slobbery",
    "slogan",
    "sloped",
    "sloping",
    "sloppily",
    "sloppy",
    "slot",
    "slouching",
    "slouchy",
    "sludge",
    "slug",
    "slum",
    "slurp",
    "slush",
    "sly",
    "small",
    "smartly",
    "smartness",
    "smasher",
    "smashing",
    "smashup",
    "smell",
    "smelting",
    "smile",
    "smilingly",
    "smirk",
    "smite",
    "smith",
    "smitten",
    "smock",
    "smog",
    "smoked",
    "smokeless",
    "smokiness",
    "smoking",
    "smoky",
    "smolder",
    "smooth",
    "smother",
    "smudge",
    "smudgy",
    "smuggler",
    "smuggling",
    "smugly",
    "smugness",
    "snack",
    "snagged",
    "snaking",
    "snap",
    "snare",
    "snarl",
    "snazzy",
    "sneak",
    "sneer",
    "sneeze",
    "sneezing",
    "snide",
    "sniff",
    "snippet",
    "snipping",
    "snitch",
    "snooper",
    "snooze",
    "snore",
    "snoring",
    "snorkel",
    "snort",
    "snout",
    "snowbird",
    "snowboard",
    "snowbound",
    "snowcap",
    "snowdrift",
    "snowdrop",
    "snowfall",
    "snowfield",
    "snowflake",
    "snowiness",
    "snowless",
    "snowman",
    "snowplow",
    "snowshoe",
    "snowstorm",
    "snowsuit",
    "snowy",
    "snub",
    "snuff",
    "snuggle",
    "snugly",
    "snugness",
    "speak",
    "spearfish",
    "spearhead",
    "spearman",
    "spearmint",
    "species",
    "specimen",
    "specked",
    "speckled",
    "specks",
    "spectacle",
    "spectator",
    "spectrum",
    "speculate",
    "speech",
    "speed",
    "spellbind",
    "speller",
    "spelling",
    "spendable",
    "spender",
    "spending",
    "spent",
    "spew",
    "sphere",
    "spherical",
    "sphinx",
    "spider",
    "spied",
    "spiffy",
    "spill",
    "spilt",
    "spinach",
    "spinal",
    "spindle",
    "spinner",
    "spinning",
    "spinout",
    "spinster",
    "spiny",
    "spiral",
    "spirited",
    "spiritism",
    "spirits",
    "spiritual",
    "splashed",
    "splashing",
    "splashy",
    "splatter",
    "spleen",
    "splendid",
    "splendor",
    "splice",
    "splicing",
    "splinter",
    "splotchy",
    "splurge",
    "spoilage",
    "spoiled",
    "spoiler",
    "spoiling",
    "spoils",
    "spoken",
    "spokesman",
    "sponge",
    "spongy",
    "sponsor",
    "spoof",
    "spookily",
    "spooky",
    "spool",
    "spoon",
    "spore",
    "sporting",
    "sports",
    "sporty",
    "spotless",
    "spotlight",
    "spotted",
    "spotter",
    "spotting",
    "spotty",
    "spousal",
    "spouse",
    "spout",
    "sprain",
    "sprang",
    "sprawl",
    "spray",
    "spree",
    "sprig",
    "spring",
    "sprinkled",
    "sprinkler",
    "sprint",
    "sprite",
    "sprout",
    "spruce",
    "sprung",
    "spry",
    "spud",
    "spur",
    "sputter",
    "spyglass",
    "squabble",
    "squad",
    "squall",
    "squander",
    "squash",
    "squatted",
    "squatter",
    "squatting",
    "squeak",
    "squealer",
    "squealing",
    "squeamish",
    "squeegee",
    "squeeze",
    "squeezing",
    "squid",
    "squiggle",
    "squiggly",
    "squint",
    "squire",
    "squirt",
    "squishier",
    "squishy",
    "stability",
    "stabilize",
    "stable",
    "stack",
    "stadium",
    "staff",
    "stage",
    "staging",
    "stagnant",
    "stagnate",
    "stainable",
    "stained",
    "staining",
    "stainless",
    "stalemate",
    "staleness",
    "stalling",
    "stallion",
    "stamina",
    "stammer",
    "stamp",
    "stand",
    "stank",
    "staple",
    "stapling",
    "starboard",
    "starch",
    "stardom",
    "stardust",
    "starfish",
    "stargazer",
    "staring",
    "stark",
    "starless",
    "starlet",
    "starlight",
    "starlit",
    "starring",
    "starry",
    "starship",
    "starter",
    "starting",
    "startle",
    "startling",
    "startup",
    "starved",
    "starving",
    "stash",
    "state",
    "static",
    "statistic",
    "statue",
    "stature",
    "status",
    "statute",
    "statutory",
    "staunch",
    "stays",
    "steadfast",
    "steadier",
    "steadily",
    "steadying",
    "steam",
    "steed",
    "steep",
    "steerable",
    "steering",
    "steersman",
    "stegosaur",
    "stellar",
    "stem",
    "stench",
    "stencil",
    "step",
    "stereo",
    "sterile",
    "sterility",
    "sterilize",
    "sterling",
    "sternness",
    "sternum",
    "stew",
    "stick",
    "stiffen",
    "stiffly",
    "stiffness",
    "stifle",
    "stifling",
    "stillness",
    "stilt",
    "stimulant",
    "stimulate",
    "stimuli",
    "stimulus",
    "stinger",
    "stingily",
    "stinging",
    "stingray",
    "stingy",
    "stinking",
    "stinky",
    "stipend",
    "stipulate",
    "stir",
    "stitch",
    "stock",
    "stoic",
    "stoke",
    "stole",
    "stomp",
    "stonewall",
    "stoneware",
    "stonework",
    "stoning",
    "stony",
    "stood",
    "stooge",
    "stool",
    "stoop",
    "stoplight",
    "stoppable",
    "stoppage",
    "stopped",
    "stopper",
    "stopping",
    "stopwatch",
    "storable",
    "storage",
    "storeroom",
    "storewide",
    "storm",
    "stout",
    "stove",
    "stowaway",
    "stowing",
    "straddle",
    "straggler",
    "strained",
    "strainer",
    "straining",
    "strangely",
    "stranger",
    "strangle",
    "strategic",
    "strategy",
    "stratus",
    "straw",
    "stray",
    "streak",
    "stream",
    "street",
    "strength",
    "strenuous",
    "strep",
    "stress",
    "stretch",
    "strewn",
    "stricken",
    "strict",
    "stride",
    "strife",
    "strike",
    "striking",
    "strive",
    "striving",
    "strobe",
    "strode",
    "stroller",
    "strongbox",
    "strongly",
    "strongman",
    "struck",
    "structure",
    "strudel",
    "struggle",
    "strum",
    "strung",
    "strut",
    "stubbed",
    "stubble",
    "stubbly",
    "stubborn",
    "stucco",
    "stuck",
    "student",
    "studied",
    "studio",
    "study",
    "stuffed",
    "stuffing",
    "stuffy",
    "stumble",
    "stumbling",
    "stump",
    "stung",
    "stunned",
    "stunner",
    "stunning",
    "stunt",
    "stupor",
    "sturdily",
    "sturdy",
    "styling",
    "stylishly",
    "stylist",
    "stylized",
    "stylus",
    "suave",
    "subarctic",
    "subatomic",
    "subdivide",
    "subdued",
    "subduing",
    "subfloor",
    "subgroup",
    "subheader",
    "subject",
    "sublease",
    "sublet",
    "sublevel",
    "sublime",
    "submarine",
    "submerge",
    "submersed",
    "submitter",
    "subpanel",
    "subpar",
    "subplot",
    "subprime",
    "subscribe",
    "subscript",
    "subsector",
    "subside",
    "subsiding",
    "subsidize",
    "subsidy",
    "subsoil",
    "subsonic",
    "substance",
    "subsystem",
    "subtext",
    "subtitle",
    "subtly",
    "subtotal",
    "subtract",
    "subtype",
    "suburb",
    "subway",
    "subwoofer",
    "subzero",
    "succulent",
    "such",
    "suction",
    "sudden",
    "sudoku",
    "suds",
    "sufferer",
    "suffering",
    "suffice",
    "suffix",
    "suffocate",
    "suffrage",
    "sugar",
    "suggest",
    "suing",
    "suitable",
    "suitably",
    "suitcase",
    "suitor",
    "sulfate",
    "sulfide",
    "sulfite",
    "sulfur",
    "sulk",
    "sullen",
    "sulphate",
    "sulphuric",
    "sultry",
    "superbowl",
    "superglue",
    "superhero",
    "superior",
    "superjet",
    "superman",
    "supermom",
    "supernova",
    "supervise",
    "supper",
    "supplier",
    "supply",
    "support",
    "supremacy",
    "supreme",
    "surcharge",
    "surely",
    "sureness",
    "surface",
    "surfacing",
    "surfboard",
    "surfer",
    "surgery",
    "surgical",
    "surging",
    "surname",
    "surpass",
    "surplus",
    "surprise",
    "surreal",
    "surrender",
    "surrogate",
    "surround",
    "survey",
    "survival",
    "survive",
    "surviving",
    "survivor",
    "sushi",
    "suspect",
    "suspend",
    "suspense",
    "sustained",
    "sustainer",
    "swab",
    "swaddling",
    "swagger",
    "swampland",
    "swan",
    "swapping",
    "swarm",
    "sway",
    "swear",
    "sweat",
    "sweep",
    "swell",
    "swept",
    "swerve",
    "swifter",
    "swiftly",
    "swiftness",
    "swimmable",
    "swimmer",
    "swimming",
    "swimsuit",
    "swimwear",
    "swinger",
    "swinging",
    "swipe",
    "swirl",
    "switch",
    "swivel",
    "swizzle",
    "swooned",
    "swoop",
    "swoosh",
    "swore",
    "sworn",
    "swung",
    "sycamore",
    "sympathy",
    "symphonic",
    "symphony",
    "symptom",
    "synapse",
    "syndrome",
    "synergy",
    "synopses",
    "synopsis",
    "synthesis",
    "synthetic",
    "syrup",
    "system",
    "t-shirt",
    "tabasco",
    "tabby",
    "tableful",
    "tables",
    "tablet",
    "tableware",
    "tabloid",
    "tackiness",
    "tacking",
    "tackle",
    "tackling",
    "tacky",
    "taco",
    "tactful",
    "tactical",
    "tactics",
    "tactile",
    "tactless",
    "tadpole",
    "taekwondo",
    "tag",
    "tainted",
    "take",
    "taking",
    "talcum",
    "talisman",
    "tall",
    "talon",
    "tamale",
    "tameness",
    "tamer",
    "tamper",
    "tank",
    "tanned",
    "tannery",
    "tanning",
    "tantrum",
    "tapeless",
    "tapered",
    "tapering",
    "tapestry",
    "tapioca",
    "tapping",
    "taps",
    "tarantula",
    "target",
    "tarmac",
    "tarnish",
    "tarot",
    "tartar",
    "tartly",
    "tartness",
    "task",
    "tassel",
    "taste",
    "tastiness",
    "tasting",
    "tasty",
    "tattered",
    "tattle",
    "tattling",
    "tattoo",
    "taunt",
    "tavern",
    "thank",
    "that",
    "thaw",
    "theater",
    "theatrics",
    "thee",
    "theft",
    "theme",
    "theology",
    "theorize",
    "thermal",
    "thermos",
    "thesaurus",
    "these",
    "thesis",
    "thespian",
    "thicken",
    "thicket",
    "thickness",
    "thieving",
    "thievish",
    "thigh",
    "thimble",
    "thing",
    "think",
    "thinly",
    "thinner",
    "thinness",
    "thinning",
    "thirstily",
    "thirsting",
    "thirsty",
    "thirteen",
    "thirty",
    "thong",
    "thorn",
    "those",
    "thousand",
    "thrash",
    "thread",
    "threaten",
    "threefold",
    "thrift",
    "thrill",
    "thrive",
    "thriving",
    "throat",
    "throbbing",
    "throng",
    "throttle",
    "throwaway",
    "throwback",
    "thrower",
    "throwing",
    "thud",
    "thumb",
    "thumping",
    "thursday",
    "thus",
    "thwarting",
    "thyself",
    "tiara",
    "tibia",
    "tidal",
    "tidbit",
    "tidiness",
    "tidings",
    "tidy",
    "tiger",
    "tighten",
    "tightly",
    "tightness",
    "tightrope",
    "tightwad",
    "tigress",
    "tile",
    "tiling",
    "till",
    "tilt",
    "timid",
    "timing",
    "timothy",
    "tinderbox",
    "tinfoil",
    "tingle",
    "tingling",
    "tingly",
    "tinker",
    "tinkling",
    "tinsel",
    "tinsmith",
    "tint",
    "tinwork",
    "tiny",
    "tipoff",
    "tipped",
    "tipper",
    "tipping",
    "tiptoeing",
    "tiptop",
    "tiring",
    "tissue",
    "trace",
    "tracing",
    "track",
    "traction",
    "tractor",
    "trade",
    "trading",
    "tradition",
    "traffic",
    "tragedy",
    "trailing",
    "trailside",
    "train",
    "traitor",
    "trance",
    "tranquil",
    "transfer",
    "transform",
    "translate",
    "transpire",
    "transport",
    "transpose",
    "trapdoor",
    "trapeze",
    "trapezoid",
    "trapped",
    "trapper",
    "trapping",
    "traps",
    "trash",
    "travel",
    "traverse",
    "travesty",
    "tray",
    "treachery",
    "treading",
    "treadmill",
    "treason",
    "treat",
    "treble",
    "tree",
    "trekker",
    "tremble",
    "trembling",
    "tremor",
    "trench",
    "trend",
    "trespass",
    "triage",
    "trial",
    "triangle",
    "tribesman",
    "tribunal",
    "tribune",
    "tributary",
    "tribute",
    "triceps",
    "trickery",
    "trickily",
    "tricking",
    "trickle",
    "trickster",
    "tricky",
    "tricolor",
    "tricycle",
    "trident",
    "tried",
    "trifle",
    "trifocals",
    "trillion",
    "trilogy",
    "trimester",
    "trimmer",
    "trimming",
    "trimness",
    "trinity",
    "trio",
    "tripod",
    "tripping",
    "triumph",
    "trivial",
    "trodden",
    "trolling",
    "trombone",
    "trophy",
    "tropical",
    "tropics",
    "trouble",
    "troubling",
    "trough",
    "trousers",
    "trout",
    "trowel",
    "truce",
    "truck",
    "truffle",
    "trump",
    "trunks",
    "trustable",
    "trustee",
    "trustful",
    "trusting",
    "trustless",
    "truth",
    "try",
    "tubby",
    "tubeless",
    "tubular",
    "tucking",
    "tuesday",
    "tug",
    "tuition",
    "tulip",
    "tumble",
    "tumbling",
    "tummy",
    "turban",
    "turbine",
    "turbofan",
    "turbojet",
    "turbulent",
    "turf",
    "turkey",
    "turmoil",
    "turret",
    "turtle",
    "tusk",
    "tutor",
    "tutu",
    "tux",
    "tweak",
    "tweed",
    "tweet",
    "tweezers",
    "twelve",
    "twentieth",
    "twenty",
    "twerp",
    "twice",
    "twiddle",
    "twiddling",
    "twig",
    "twilight",
    "twine",
    "twins",
    "twirl",
    "twistable",
    "twisted",
    "twister",
    "twisting",
    "twisty",
    "twitch",
    "twitter",
    "tycoon",
    "tying",
    "tyke",
    "udder",
    "ultimate",
    "ultimatum",
    "ultra",
    "umbilical",
    "umbrella",
    "umpire",
    "unabashed",
    "unable",
    "unadorned",
    "unadvised",
    "unafraid",
    "unaired",
    "unaligned",
    "unaltered",
    "unarmored",
    "unashamed",
    "unaudited",
    "unawake",
    "unaware",
    "unbaked",
    "unbalance",
    "unbeaten",
    "unbend",
    "unbent",
    "unbiased",
    "unbitten",
    "unblended",
    "unblessed",
    "unblock",
    "unbolted",
    "unbounded",
    "unboxed",
    "unbraided",
    "unbridle",
    "unbroken",
    "unbuckled",
    "unbundle",
    "unburned",
    "unbutton",
    "uncanny",
    "uncapped",
    "uncaring",
    "uncertain",
    "unchain",
    "unchanged",
    "uncharted",
    "uncheck",
    "uncivil",
    "unclad",
    "unclaimed",
    "unclamped",
    "unclasp",
    "uncle",
    "unclip",
    "uncloak",
    "unclog",
    "unclothed",
    "uncoated",
    "uncoiled",
    "uncolored",
    "uncombed",
    "uncommon",
    "uncooked",
    "uncork",
    "uncorrupt",
    "uncounted",
    "uncouple",
    "uncouth",
    "uncover",
    "uncross",
    "uncrown",
    "uncrushed",
    "uncured",
    "uncurious",
    "uncurled",
    "uncut",
    "undamaged",
    "undated",
    "undaunted",
    "undead",
    "undecided",
    "undefined",
    "underage",
    "underarm",
    "undercoat",
    "undercook",
    "undercut",
    "underdog",
    "underdone",
    "underfed",
    "underfeed",
    "underfoot",
    "undergo",
    "undergrad",
    "underhand",
    "underline",
    "underling",
    "undermine",
    "undermost",
    "underpaid",
    "underpass",
    "underpay",
    "underrate",
    "undertake",
    "undertone",
    "undertook",
    "undertow",
    "underuse",
    "underwear",
    "underwent",
    "underwire",
    "undesired",
    "undiluted",
    "undivided",
    "undocked",
    "undoing",
    "undone",
    "undrafted",
    "undress",
    "undrilled",
    "undusted",
    "undying",
    "unearned",
    "unearth",
    "unease",
    "uneasily",
    "uneasy",
    "uneatable",
    "uneaten",
    "unedited",
    "unelected",
    "unending",
    "unengaged",
    "unenvied",
    "unequal",
    "unethical",
    "uneven",
    "unexpired",
    "unexposed",
    "unfailing",
    "unfair",
    "unfasten",
    "unfazed",
    "unfeeling",
    "unfiled",
    "unfilled",
    "unfitted",
    "unfitting",
    "unfixable",
    "unfixed",
    "unflawed",
    "unfocused",
    "unfold",
    "unfounded",
    "unframed",
    "unfreeze",
    "unfrosted",
    "unfrozen",
    "unfunded",
    "unglazed",
    "ungloved",
    "unglue",
    "ungodly",
    "ungraded",
    "ungreased",
    "unguarded",
    "unguided",
    "unhappily",
    "unhappy",
    "unharmed",
    "unhealthy",
    "unheard",
    "unhearing",
    "unheated",
    "unhelpful",
    "unhidden",
    "unhinge",
    "unhitched",
    "unholy",
    "unhook",
    "unicorn",
    "unicycle",
    "unified",
    "unifier",
    "uniformed",
    "uniformly",
    "unify",
    "unimpeded",
    "uninjured",
    "uninstall",
    "uninsured",
    "uninvited",
    "union",
    "uniquely",
    "unisexual",
    "unison",
    "unissued",
    "unit",
    "universal",
    "universe",
    "unjustly",
    "unkempt",
    "unkind",
    "unknotted",
    "unknowing",
    "unknown",
    "unlaced",
    "unlatch",
    "unlawful",
    "unleaded",
    "unlearned",
    "unleash",
    "unless",
    "unleveled",
    "unlighted",
    "unlikable",
    "unlimited",
    "unlined",
    "unlinked",
    "unlisted",
    "unlit",
    "unlivable",
    "unloaded",
    "unloader",
    "unlocked",
    "unlocking",
    "unlovable",
    "unloved",
    "unlovely",
    "unloving",
    "unluckily",
    "unlucky",
    "unmade",
    "unmanaged",
    "unmanned",
    "unmapped",
    "unmarked",
    "unmasked",
    "unmasking",
    "unmatched",
    "unmindful",
    "unmixable",
    "unmixed",
    "unmolded",
    "unmoral",
    "unmovable",
    "unmoved",
    "unmoving",
    "unnamable",
    "unnamed",
    "unnatural",
    "unneeded",
    "unnerve",
    "unnerving",
    "unnoticed",
    "unopened",
    "unopposed",
    "unpack",
    "unpadded",
    "unpaid",
    "unpainted",
    "unpaired",
    "unpaved",
    "unpeeled",
    "unpicked",
    "unpiloted",
    "unpinned",
    "unplanned",
    "unplanted",
    "unpleased",
    "unpledged",
    "unplowed",
    "unplug",
    "unpopular",
    "unproven",
    "unquote",
    "unranked",
    "unrated",
    "unraveled",
    "unreached",
    "unread",
    "unreal",
    "unreeling",
    "unrefined",
    "unrelated",
    "unrented",
    "unrest",
    "unretired",
    "unrevised",
    "unrigged",
    "unripe",
    "unrivaled",
    "unroasted",
    "unrobed",
    "unroll",
    "unruffled",
    "unruly",
    "unrushed",
    "unsaddle",
    "unsafe",
    "unsaid",
    "unsalted",
    "unsaved",
    "unsavory",
    "unscathed",
    "unscented",
    "unscrew",
    "unsealed",
    "unseated",
    "unsecured",
    "unseeing",
    "unseemly",
    "unseen",
    "unselect",
    "unselfish",
    "unsent",
    "unsettled",
    "unshackle",
    "unshaken",
    "unshaved",
    "unshaven",
    "unsheathe",
    "unshipped",
    "unsightly",
    "unsigned",
    "unskilled",
    "unsliced",
    "unsmooth",
    "unsnap",
    "unsocial",
    "unsoiled",
    "unsold",
    "unsolved",
    "unsorted",
    "unspoiled",
    "unspoken",
    "unstable",
    "unstaffed",
    "unstamped",
    "unsteady",
    "unsterile",
    "unstirred",
    "unstitch",
    "unstopped",
    "unstuck",
    "unstuffed",
    "unstylish",
    "unsubtle",
    "unsubtly",
    "unsuited",
    "unsure",
    "unsworn",
    "untagged",
    "untainted",
    "untaken",
    "untamed",
    "untangled",
    "untapped",
    "untaxed",
    "unthawed",
    "unthread",
    "untidy",
    "untie",
    "until",
    "untimed",
    "untimely",
    "untitled",
    "untoasted",
    "untold",
    "untouched",
    "untracked",
    "untrained",
    "untreated",
    "untried",
    "untrimmed",
    "untrue",
    "untruth",
    "unturned",
    "untwist",
    "untying",
    "unusable",
    "unused",
    "unusual",
    "unvalued",
    "unvaried",
    "unvarying",
    "unveiled",
    "unveiling",
    "unvented",
    "unviable",
    "unvisited",
    "unvocal",
    "unwanted",
    "unwarlike",
    "unwary",
    "unwashed",
    "unwatched",
    "unweave",
    "unwed",
    "unwelcome",
    "unwell",
    "unwieldy",
    "unwilling",
    "unwind",
    "unwired",
    "unwitting",
    "unwomanly",
    "unworldly",
    "unworn",
    "unworried",
    "unworthy",
    "unwound",
    "unwoven",
    "unwrapped",
    "unwritten",
    "unzip",
    "upbeat",
    "upchuck",
    "upcoming",
    "upcountry",
    "update",
    "upfront",
    "upgrade",
    "upheaval",
    "upheld",
    "uphill",
    "uphold",
    "uplifted",
    "uplifting",
    "upload",
    "upon",
    "upper",
    "upright",
    "uprising",
    "upriver",
    "uproar",
    "uproot",
    "upscale",
    "upside",
    "upstage",
    "upstairs",
    "upstart",
    "upstate",
    "upstream",
    "upstroke",
    "upswing",
    "uptake",
    "uptight",
    "uptown",
    "upturned",
    "upward",
    "upwind",
    "uranium",
    "urban",
    "urchin",
    "urethane",
    "urgency",
    "urgent",
    "urging",
    "urologist",
    "urology",
    "usable",
    "usage",
    "useable",
    "used",
    "uselessly",
    "user",
    "usher",
    "usual",
    "utensil",
    "utility",
    "utilize",
    "utmost",
    "utopia",
    "utter",
    "vacancy",
    "vacant",
    "vacate",
    "vacation",
    "vagabond",
    "vagrancy",
    "vagrantly",
    "vaguely",
    "vagueness",
    "valiant",
    "valid",
    "valium",
    "valley",
    "valuables",
    "value",
    "vanilla",
    "vanish",
    "vanity",
    "vanquish",
    "vantage",
    "vaporizer",
    "variable",
    "variably",
    "varied",
    "variety",
    "various",
    "varmint",
    "varnish",
    "varsity",
    "varying",
    "vascular",
    "vaseline",
    "vastly",
    "vastness",
    "veal",
    "vegan",
    "veggie",
    "vehicular",
    "velcro",
    "velocity",
    "velvet",
    "vendetta",
    "vending",
    "vendor",
    "veneering",
    "vengeful",
    "venomous",
    "ventricle",
    "venture",
    "venue",
    "venus",
    "verbalize",
    "verbally",
    "verbose",
    "verdict",
    "verify",
    "verse",
    "version",
    "versus",
    "vertebrae",
    "vertical",
    "vertigo",
    "very",
    "vessel",
    "vest",
    "veteran",
    "veto",
    "vexingly",
    "viability",
    "viable",
    "vibes",
    "vice",
    "vicinity",
    "victory",
    "video",
    "viewable",
    "viewer",
    "viewing",
    "viewless",
    "viewpoint",
    "vigorous",
    "village",
    "villain",
    "vindicate",
    "vineyard",
    "vintage",
    "violate",
    "violation",
    "violator",
    "violet",
    "violin",
    "viper",
    "viral",
    "virtual",
    "virtuous",
    "virus",
    "visa",
    "viscosity",
    "viscous",
    "viselike",
    "visible",
    "visibly",
    "vision",
    "visiting",
    "visitor",
    "visor",
    "vista",
    "vitality",
    "vitalize",
    "vitally",
    "vitamins",
    "vivacious",
    "vividly",
    "vividness",
    "vixen",
    "vocalist",
    "vocalize",
    "vocally",
    "vocation",
    "voice",
    "voicing",
    "void",
    "volatile",
    "volley",
    "voltage",
    "volumes",
    "voter",
    "voting",
    "voucher",
    "vowed",
    "vowel",
    "voyage",
    "wackiness",
    "wad",
    "wafer",
    "waffle",
    "waged",
    "wager",
    "wages",
    "waggle",
    "wagon",
    "wake",
    "waking",
    "walk",
    "walmart",
    "walnut",
    "walrus",
    "waltz",
    "wand",
    "wannabe",
    "wanted",
    "wanting",
    "wasabi",
    "washable",
    "washbasin",
    "washboard",
    "washbowl",
    "washcloth",
    "washday",
    "washed",
    "washer",
    "washhouse",
    "washing",
    "washout",
    "washroom",
    "washstand",
    "washtub",
    "wasp",
    "wasting",
    "watch",
    "water",
    "waviness",
    "waving",
    "wavy",
    "whacking",
    "whacky",
    "wham",
    "wharf",
    "wheat",
    "whenever",
    "whiff",
    "whimsical",
    "whinny",
    "whiny",
    "whisking",
    "whoever",
    "whole",
    "whomever",
    "whoopee",
    "whooping",
    "whoops",
    "why",
    "wick",
    "widely",
    "widen",
    "widget",
    "widow",
    "width",
    "wieldable",
    "wielder",
    "wife",
    "wifi",
    "wikipedia",
    "wildcard",
    "wildcat",
    "wilder",
    "wildfire",
    "wildfowl",
    "wildland",
    "wildlife",
    "wildly",
    "wildness",
    "willed",
    "willfully",
    "willing",
    "willow",
    "willpower",
    "wilt",
    "wimp",
    "wince",
    "wincing",
    "wind",
    "wing",
    "winking",
    "winner",
    "winnings",
    "winter",
    "wipe",
    "wired",
    "wireless",
    "wiring",
    "wiry",
    "wisdom",
    "wise",
    "wish",
    "wisplike",
    "wispy",
    "wistful",
    "wizard",
    "wobble",
    "wobbling",
    "wobbly",
    "wok",
    "wolf",
    "wolverine",
    "womanhood",
    "womankind",
    "womanless",
    "womanlike",
    "womanly",
    "womb",
    "woof",
    "wooing",
    "wool",
    "woozy",
    "word",
    "work",
    "worried",
    "worrier",
    "worrisome",
    "worry",
    "worsening",
    "worshiper",
    "worst",
    "wound",
    "woven",
    "wow",
    "wrangle",
    "wrath",
    "wreath",
    "wreckage",
    "wrecker",
    "wrecking",
    "wrench",
    "wriggle",
    "wriggly",
    "wrinkle",
    "wrinkly",
    "wrist",
    "writing",
    "written",
    "wrongdoer",
    "wronged",
    "wrongful",
    "wrongly",
    "wrongness",
    "wrought",
    "xbox",
    "xerox",
    "yahoo",
    "yam",
    "yanking",
    "yapping",
    "yard",
    "yarn",
    "yeah",
    "yearbook",
    "yearling",
    "yearly",
    "yearning",
    "yeast",
    "yelling",
    "yelp",
    "yen",
    "yesterday",
    "yiddish",
    "yield",
    "yin",
    "yippee",
    "yo-yo",
    "yodel",
    "yoga",
    "yogurt",
    "yonder",
    "yoyo",
    "yummy",
    "zap",
    "zealous",
    "zebra",
    "zen",
    "zeppelin",
    "zero",
    "zestfully",
    "zesty",
    "zigzagged",
    "zipfile",
    "zipping",
    "zippy",
    "zips",
    "zit",
    "zodiac",
    "zombie",
    "zone",
    "zoning",
    "zookeeper",
    "zoologist",
    "zoology",
    "zoom"
];

});


parcelRequire.register("hNtXf", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.newSecurePassphrase = void 0;

var $lusx3 = parcelRequire("lusx3");
function $cf4e3f9fb401fa93$var$newSecurePassphrase() {
    return $cf4e3f9fb401fa93$var$_newSecurePassphrase.apply(this, arguments);
}
function $cf4e3f9fb401fa93$var$_newSecurePassphrase() {
    $cf4e3f9fb401fa93$var$_newSecurePassphrase = (0, $byzP8._)(function() {
        var size;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    size = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 6;
                    return [
                        4,
                        (0, $lusx3.newSecureWords)(size)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().join("-")
                    ];
            }
        });
    });
    return $cf4e3f9fb401fa93$var$_newSecurePassphrase.apply(this, arguments);
}
module.exports.newSecurePassphrase = $cf4e3f9fb401fa93$var$newSecurePassphrase;

});

parcelRequire.register("hObSB", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $cf70523cccadf0d5$require$Buffer = $gzLuY.Buffer;
"use strict";
var $cf70523cccadf0d5$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mnemonicFromRandomSeed = module.exports.mnemonicIndexesToBytes = module.exports.bytesToMnemonics = module.exports.bytesToMnemonicIndexes = module.exports.mnemonicNew = module.exports.mnemonicValidate = module.exports.mnemonicToHDSeed = module.exports.mnemonicToWalletKey = module.exports.mnemonicToPrivateKey = module.exports.mnemonicToSeed = module.exports.mnemonicToEntropy = void 0;

var $cf70523cccadf0d5$var$tweetnacl_1 = $cf70523cccadf0d5$var$__importDefault((parcelRequire("44JIq")));

var $eCOtR = parcelRequire("eCOtR");

var $6C3Y6 = parcelRequire("6C3Y6");

var $9zWqD = parcelRequire("9zWqD");

var $2jvE6 = parcelRequire("2jvE6");

var $a75QT = parcelRequire("a75QT");
var $cf70523cccadf0d5$var$PBKDF_ITERATIONS = 100000;
function $cf70523cccadf0d5$var$isPasswordNeeded(mnemonicArray) {
    return $cf70523cccadf0d5$var$_isPasswordNeeded.apply(this, arguments);
}
function $cf70523cccadf0d5$var$_isPasswordNeeded() {
    $cf70523cccadf0d5$var$_isPasswordNeeded = (0, $byzP8._)(function(mnemonicArray) {
        var passlessEntropy, _tmp;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $cf70523cccadf0d5$var$mnemonicToEntropy(mnemonicArray)
                    ];
                case 1:
                    passlessEntropy = _state.sent();
                    return [
                        4,
                        $cf70523cccadf0d5$var$isPasswordSeed(passlessEntropy)
                    ];
                case 2:
                    _tmp = _state.sent();
                    if (!_tmp) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $cf70523cccadf0d5$var$isBasicSeed(passlessEntropy)
                    ];
                case 3:
                    _tmp = !_state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        _tmp
                    ];
            }
        });
    });
    return $cf70523cccadf0d5$var$_isPasswordNeeded.apply(this, arguments);
}
function $cf70523cccadf0d5$var$normalizeMnemonic(src) {
    return src.map(function(v) {
        return v.toLowerCase().trim();
    });
}
function $cf70523cccadf0d5$var$isBasicSeed(entropy) {
    return $cf70523cccadf0d5$var$_isBasicSeed.apply(this, arguments);
}
function $cf70523cccadf0d5$var$_isBasicSeed() {
    $cf70523cccadf0d5$var$_isBasicSeed = (0, $byzP8._)(function(entropy) {
        var seed;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $9zWqD.pbkdf2_sha512)(entropy, "TON seed version", Math.max(1, Math.floor($cf70523cccadf0d5$var$PBKDF_ITERATIONS / 256)), 64)
                    ];
                case 1:
                    seed = _state.sent();
                    return [
                        2,
                        seed[0] == 0
                    ];
            }
        });
    });
    return $cf70523cccadf0d5$var$_isBasicSeed.apply(this, arguments);
}
function $cf70523cccadf0d5$var$isPasswordSeed(entropy) {
    return $cf70523cccadf0d5$var$_isPasswordSeed.apply(this, arguments);
}
function $cf70523cccadf0d5$var$_isPasswordSeed() {
    $cf70523cccadf0d5$var$_isPasswordSeed = (0, $byzP8._)(function(entropy) {
        var seed;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $9zWqD.pbkdf2_sha512)(entropy, "TON fast seed version", 1, 64)
                    ];
                case 1:
                    seed = _state.sent();
                    return [
                        2,
                        seed[0] == 1
                    ];
            }
        });
    });
    return $cf70523cccadf0d5$var$_isPasswordSeed.apply(this, arguments);
}
function $cf70523cccadf0d5$var$mnemonicToEntropy(mnemonicArray, password) {
    return $cf70523cccadf0d5$var$_mnemonicToEntropy.apply(this, arguments);
}
function $cf70523cccadf0d5$var$_mnemonicToEntropy() {
    $cf70523cccadf0d5$var$_mnemonicToEntropy = (0, $byzP8._)(function(mnemonicArray, password) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $6C3Y6.hmac_sha512)(mnemonicArray.join(" "), password && password.length > 0 ? password : "")
                    ];
                case 1:
                    // https://github.com/ton-blockchain/ton/blob/24dc184a2ea67f9c47042b4104bbb4d82289fac1/tonlib/tonlib/keys/Mnemonic.cpp#L52
                    // td::SecureString Mnemonic::to_entropy() const {
                    //   td::SecureString res(64);
                    //   td::hmac_sha512(join(words_), password_, res.as_mutable_slice());
                    //   return res;
                    // }
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $cf70523cccadf0d5$var$_mnemonicToEntropy.apply(this, arguments);
}
module.exports.mnemonicToEntropy = $cf70523cccadf0d5$var$mnemonicToEntropy;
function $cf70523cccadf0d5$var$mnemonicToSeed(mnemonicArray, seed, password) {
    return $cf70523cccadf0d5$var$_mnemonicToSeed.apply(this, arguments);
}
function $cf70523cccadf0d5$var$_mnemonicToSeed() {
    $cf70523cccadf0d5$var$_mnemonicToSeed = (0, $byzP8._)(function(mnemonicArray, seed, password) {
        var entropy;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $cf70523cccadf0d5$var$mnemonicToEntropy(mnemonicArray, password)
                    ];
                case 1:
                    entropy = _state.sent();
                    return [
                        4,
                        (0, $9zWqD.pbkdf2_sha512)(entropy, seed, $cf70523cccadf0d5$var$PBKDF_ITERATIONS, 64)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $cf70523cccadf0d5$var$_mnemonicToSeed.apply(this, arguments);
}
module.exports.mnemonicToSeed = $cf70523cccadf0d5$var$mnemonicToSeed;
function $cf70523cccadf0d5$var$mnemonicToPrivateKey(mnemonicArray, password) {
    return $cf70523cccadf0d5$var$_mnemonicToPrivateKey.apply(this, arguments);
}
function $cf70523cccadf0d5$var$_mnemonicToPrivateKey() {
    $cf70523cccadf0d5$var$_mnemonicToPrivateKey = /**
 * Extract private key from mnemonic
 * @param mnemonicArray mnemonic array
 * @param password mnemonic password
 * @returns Key Pair
 */ (0, $byzP8._)(function(mnemonicArray, password) {
        var seed, keyPair;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // https://github.com/ton-blockchain/ton/blob/24dc184a2ea67f9c47042b4104bbb4d82289fac1/tonlib/tonlib/keys/Mnemonic.cpp#L64
                    // td::Ed25519::PrivateKey Mnemonic::to_private_key() const {
                    //   return td::Ed25519::PrivateKey(td::SecureString(as_slice(to_seed()).substr(0, td::Ed25519::PrivateKey::LENGTH)));
                    // }
                    mnemonicArray = $cf70523cccadf0d5$var$normalizeMnemonic(mnemonicArray);
                    return [
                        4,
                        $cf70523cccadf0d5$var$mnemonicToSeed(mnemonicArray, "TON default seed", password)
                    ];
                case 1:
                    seed = _state.sent();
                    keyPair = $cf70523cccadf0d5$var$tweetnacl_1.default.sign.keyPair.fromSeed(seed.slice(0, 32));
                    return [
                        2,
                        {
                            publicKey: $cf70523cccadf0d5$require$Buffer.from(keyPair.publicKey),
                            secretKey: $cf70523cccadf0d5$require$Buffer.from(keyPair.secretKey)
                        }
                    ];
            }
        });
    });
    return $cf70523cccadf0d5$var$_mnemonicToPrivateKey.apply(this, arguments);
}
module.exports.mnemonicToPrivateKey = $cf70523cccadf0d5$var$mnemonicToPrivateKey;
function $cf70523cccadf0d5$var$mnemonicToWalletKey(mnemonicArray, password) {
    return $cf70523cccadf0d5$var$_mnemonicToWalletKey.apply(this, arguments);
}
function $cf70523cccadf0d5$var$_mnemonicToWalletKey() {
    $cf70523cccadf0d5$var$_mnemonicToWalletKey = /**
 * Convert mnemonic to wallet key pair
 * @param mnemonicArray mnemonic array
 * @param password mnemonic password
 * @returns Key Pair
 */ (0, $byzP8._)(function(mnemonicArray, password) {
        var seedPk, seedSecret, keyPair;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $cf70523cccadf0d5$var$mnemonicToPrivateKey(mnemonicArray, password)
                    ];
                case 1:
                    seedPk = _state.sent();
                    seedSecret = seedPk.secretKey.slice(0, 32);
                    keyPair = $cf70523cccadf0d5$var$tweetnacl_1.default.sign.keyPair.fromSeed(seedSecret);
                    return [
                        2,
                        {
                            publicKey: $cf70523cccadf0d5$require$Buffer.from(keyPair.publicKey),
                            secretKey: $cf70523cccadf0d5$require$Buffer.from(keyPair.secretKey)
                        }
                    ];
            }
        });
    });
    return $cf70523cccadf0d5$var$_mnemonicToWalletKey.apply(this, arguments);
}
module.exports.mnemonicToWalletKey = $cf70523cccadf0d5$var$mnemonicToWalletKey;
function $cf70523cccadf0d5$var$mnemonicToHDSeed(mnemonicArray, password) {
    return $cf70523cccadf0d5$var$_mnemonicToHDSeed.apply(this, arguments);
}
function $cf70523cccadf0d5$var$_mnemonicToHDSeed() {
    $cf70523cccadf0d5$var$_mnemonicToHDSeed = /**
 * Convert mnemonics to HD seed
 * @param mnemonicArray mnemonic array
 * @param password mnemonic password
 * @returns 64 byte seed
 */ (0, $byzP8._)(function(mnemonicArray, password) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    mnemonicArray = $cf70523cccadf0d5$var$normalizeMnemonic(mnemonicArray);
                    return [
                        4,
                        $cf70523cccadf0d5$var$mnemonicToSeed(mnemonicArray, "TON HD Keys seed", password)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $cf70523cccadf0d5$var$_mnemonicToHDSeed.apply(this, arguments);
}
module.exports.mnemonicToHDSeed = $cf70523cccadf0d5$var$mnemonicToHDSeed;
function $cf70523cccadf0d5$var$mnemonicValidate(mnemonicArray, password) {
    return $cf70523cccadf0d5$var$_mnemonicValidate.apply(this, arguments);
}
function $cf70523cccadf0d5$var$_mnemonicValidate() {
    $cf70523cccadf0d5$var$_mnemonicValidate = /**
 * Validate Mnemonic
 * @param mnemonicArray mnemonic array
 * @param password mnemonic password
 * @returns true for valid mnemonic
 */ (0, $byzP8._)(function(mnemonicArray, password) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, word;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Normalize
                    mnemonicArray = $cf70523cccadf0d5$var$normalizeMnemonic(mnemonicArray);
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // Validate mnemonic words
                        for(_iterator = mnemonicArray[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            word = _step.value;
                            if ($a75QT.wordlist.indexOf(word) < 0) return [
                                2,
                                false
                            ];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (!(password && password.length > 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $cf70523cccadf0d5$var$isPasswordNeeded(mnemonicArray)
                    ];
                case 1:
                    if (!_state.sent()) return [
                        2,
                        false
                    ];
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        $cf70523cccadf0d5$var$mnemonicToEntropy(mnemonicArray, password)
                    ];
                case 3:
                    return [
                        4,
                        $cf70523cccadf0d5$var$isBasicSeed.apply(void 0, [
                            _state.sent()
                        ])
                    ];
                case 4:
                    // Validate seed
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $cf70523cccadf0d5$var$_mnemonicValidate.apply(this, arguments);
}
module.exports.mnemonicValidate = $cf70523cccadf0d5$var$mnemonicValidate;
function $cf70523cccadf0d5$var$mnemonicNew() {
    return $cf70523cccadf0d5$var$_mnemonicNew.apply(this, arguments);
}
function $cf70523cccadf0d5$var$_mnemonicNew() {
    $cf70523cccadf0d5$var$_mnemonicNew = /**
 * Generate new Mnemonic
 * @param wordsCount number of words to generate
 * @param password mnemonic password
 * @returns
 */ (0, $byzP8._)(function() {
        var wordsCount, password, mnemonicArray, i, ind;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    wordsCount = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 24, password = _arguments.length > 1 ? _arguments[1] : void 0;
                    mnemonicArray = [];
                    _state.label = 1;
                case 1:
                    if (!true) return [
                        3,
                        10
                    ];
                    // Regenerate new mnemonics
                    mnemonicArray = [];
                    i = 0;
                    _state.label = 2;
                case 2:
                    if (!(i < wordsCount)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $eCOtR.getSecureRandomNumber)(0, $a75QT.wordlist.length)
                    ];
                case 3:
                    ind = _state.sent();
                    mnemonicArray.push($a75QT.wordlist[ind]);
                    _state.label = 4;
                case 4:
                    i++;
                    return [
                        3,
                        2
                    ];
                case 5:
                    if (!(password && password.length > 0)) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        $cf70523cccadf0d5$var$isPasswordNeeded(mnemonicArray)
                    ];
                case 6:
                    if (!_state.sent()) return [
                        3,
                        1
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        4,
                        $cf70523cccadf0d5$var$mnemonicToEntropy(mnemonicArray, password)
                    ];
                case 8:
                    return [
                        4,
                        $cf70523cccadf0d5$var$isBasicSeed.apply(void 0, [
                            _state.sent()
                        ])
                    ];
                case 9:
                    // Check if basic seed correct
                    if (!_state.sent()) return [
                        3,
                        1
                    ];
                    return [
                        3,
                        10
                    ];
                case 10:
                    return [
                        2,
                        mnemonicArray
                    ];
            }
        });
    });
    return $cf70523cccadf0d5$var$_mnemonicNew.apply(this, arguments);
}
module.exports.mnemonicNew = $cf70523cccadf0d5$var$mnemonicNew;
/**
 * Converts bytes to mnemonics array (could be invalid for TON)
 * @param src source buffer
 * @param wordsCount number of words
 */ function $cf70523cccadf0d5$var$bytesToMnemonicIndexes(src, wordsCount) {
    var bits = (0, $2jvE6.bytesToBits)(src);
    var indexes = [];
    for(var i = 0; i < wordsCount; i++){
        var sl = bits.slice(i * 11, i * 11 + 11);
        indexes.push(parseInt(sl, 2));
    }
    return indexes;
}
module.exports.bytesToMnemonicIndexes = $cf70523cccadf0d5$var$bytesToMnemonicIndexes;
function $cf70523cccadf0d5$var$bytesToMnemonics(src, wordsCount) {
    var mnemonics = $cf70523cccadf0d5$var$bytesToMnemonicIndexes(src, wordsCount);
    var res = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = mnemonics[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var m = _step.value;
            res.push($a75QT.wordlist[m]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return res;
}
module.exports.bytesToMnemonics = $cf70523cccadf0d5$var$bytesToMnemonics;
/**
 * Converts mnemonics indexes to buffer with zero padding in the end
 * @param src source indexes
 * @returns Buffer
 */ function $cf70523cccadf0d5$var$mnemonicIndexesToBytes(src) {
    var res = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = src[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            if (!Number.isSafeInteger(s)) throw Error("Invalid input");
            if (s < 0 || s >= 2028) throw Error("Invalid input");
            res += (0, $2jvE6.lpad)(s.toString(2), "0", 11);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    while(res.length % 8 !== 0)res = res + "0";
    return (0, $2jvE6.bitsToBytes)(res);
}
module.exports.mnemonicIndexesToBytes = $cf70523cccadf0d5$var$mnemonicIndexesToBytes;
function $cf70523cccadf0d5$var$mnemonicFromRandomSeed(seed) {
    return $cf70523cccadf0d5$var$_mnemonicFromRandomSeed.apply(this, arguments);
}
function $cf70523cccadf0d5$var$_mnemonicFromRandomSeed() {
    $cf70523cccadf0d5$var$_mnemonicFromRandomSeed = /**
 * Generates deterministically mnemonics
 * @param seed
 * @param wordsCount
 * @param password
 */ (0, $byzP8._)(function(seed) {
        var wordsCount, password, bytesLength, currentSeed, entropy, mnemonics;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    wordsCount = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 24, password = _arguments.length > 2 ? _arguments[2] : void 0;
                    bytesLength = Math.ceil(wordsCount * 11 / 8);
                    currentSeed = seed;
                    _state.label = 1;
                case 1:
                    if (!true) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        (0, $9zWqD.pbkdf2_sha512)(currentSeed, "TON mnemonic seed", Math.max(1, Math.floor($cf70523cccadf0d5$var$PBKDF_ITERATIONS / 256)), bytesLength)
                    ];
                case 2:
                    entropy = _state.sent();
                    mnemonics = $cf70523cccadf0d5$var$bytesToMnemonics(entropy, wordsCount);
                    return [
                        4,
                        $cf70523cccadf0d5$var$mnemonicValidate(mnemonics, password)
                    ];
                case 3:
                    // Check if mnemonics are valid
                    if (_state.sent()) return [
                        2,
                        mnemonics
                    ];
                    currentSeed = entropy;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $cf70523cccadf0d5$var$_mnemonicFromRandomSeed.apply(this, arguments);
}
module.exports.mnemonicFromRandomSeed = $cf70523cccadf0d5$var$mnemonicFromRandomSeed;

});
parcelRequire.register("2jvE6", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $1af5e753ed04b09d$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bitsToBytes = module.exports.bytesToBits = module.exports.lpad = void 0;
function $1af5e753ed04b09d$var$lpad(str, padString, length) {
    while(str.length < length)str = padString + str;
    return str;
}
module.exports.lpad = $1af5e753ed04b09d$var$lpad;
function $1af5e753ed04b09d$var$bytesToBits(bytes) {
    var res = "";
    for(var i = 0; i < bytes.length; i++){
        var x = bytes.at(i);
        res += $1af5e753ed04b09d$var$lpad(x.toString(2), "0", 8);
    }
    return res;
}
module.exports.bytesToBits = $1af5e753ed04b09d$var$bytesToBits;
function $1af5e753ed04b09d$var$bitsToBytes(src) {
    if (src.length % 8 !== 0) throw Error("Uneven bits");
    var res = [];
    while(src.length > 0){
        res.push(parseInt(src.slice(0, 8), 2));
        src = src.slice(8);
    }
    return $1af5e753ed04b09d$require$Buffer.from(res);
}
module.exports.bitsToBytes = $1af5e753ed04b09d$var$bitsToBytes;

});

parcelRequire.register("a75QT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wordlist = void 0;
var $75cf18eca1f28516$var$EN = [
    "abandon",
    "ability",
    "able",
    "about",
    "above",
    "absent",
    "absorb",
    "abstract",
    "absurd",
    "abuse",
    "access",
    "accident",
    "account",
    "accuse",
    "achieve",
    "acid",
    "acoustic",
    "acquire",
    "across",
    "act",
    "action",
    "actor",
    "actress",
    "actual",
    "adapt",
    "add",
    "addict",
    "address",
    "adjust",
    "admit",
    "adult",
    "advance",
    "advice",
    "aerobic",
    "affair",
    "afford",
    "afraid",
    "again",
    "age",
    "agent",
    "agree",
    "ahead",
    "aim",
    "air",
    "airport",
    "aisle",
    "alarm",
    "album",
    "alcohol",
    "alert",
    "alien",
    "all",
    "alley",
    "allow",
    "almost",
    "alone",
    "alpha",
    "already",
    "also",
    "alter",
    "always",
    "amateur",
    "amazing",
    "among",
    "amount",
    "amused",
    "analyst",
    "anchor",
    "ancient",
    "anger",
    "angle",
    "angry",
    "animal",
    "ankle",
    "announce",
    "annual",
    "another",
    "answer",
    "antenna",
    "antique",
    "anxiety",
    "any",
    "apart",
    "apology",
    "appear",
    "apple",
    "approve",
    "april",
    "arch",
    "arctic",
    "area",
    "arena",
    "argue",
    "arm",
    "armed",
    "armor",
    "army",
    "around",
    "arrange",
    "arrest",
    "arrive",
    "arrow",
    "art",
    "artefact",
    "artist",
    "artwork",
    "ask",
    "aspect",
    "assault",
    "asset",
    "assist",
    "assume",
    "asthma",
    "athlete",
    "atom",
    "attack",
    "attend",
    "attitude",
    "attract",
    "auction",
    "audit",
    "august",
    "aunt",
    "author",
    "auto",
    "autumn",
    "average",
    "avocado",
    "avoid",
    "awake",
    "aware",
    "away",
    "awesome",
    "awful",
    "awkward",
    "axis",
    "baby",
    "bachelor",
    "bacon",
    "badge",
    "bag",
    "balance",
    "balcony",
    "ball",
    "bamboo",
    "banana",
    "banner",
    "bar",
    "barely",
    "bargain",
    "barrel",
    "base",
    "basic",
    "basket",
    "battle",
    "beach",
    "bean",
    "beauty",
    "because",
    "become",
    "beef",
    "before",
    "begin",
    "behave",
    "behind",
    "believe",
    "below",
    "belt",
    "bench",
    "benefit",
    "best",
    "betray",
    "better",
    "between",
    "beyond",
    "bicycle",
    "bid",
    "bike",
    "bind",
    "biology",
    "bird",
    "birth",
    "bitter",
    "black",
    "blade",
    "blame",
    "blanket",
    "blast",
    "bleak",
    "bless",
    "blind",
    "blood",
    "blossom",
    "blouse",
    "blue",
    "blur",
    "blush",
    "board",
    "boat",
    "body",
    "boil",
    "bomb",
    "bone",
    "bonus",
    "book",
    "boost",
    "border",
    "boring",
    "borrow",
    "boss",
    "bottom",
    "bounce",
    "box",
    "boy",
    "bracket",
    "brain",
    "brand",
    "brass",
    "brave",
    "bread",
    "breeze",
    "brick",
    "bridge",
    "brief",
    "bright",
    "bring",
    "brisk",
    "broccoli",
    "broken",
    "bronze",
    "broom",
    "brother",
    "brown",
    "brush",
    "bubble",
    "buddy",
    "budget",
    "buffalo",
    "build",
    "bulb",
    "bulk",
    "bullet",
    "bundle",
    "bunker",
    "burden",
    "burger",
    "burst",
    "bus",
    "business",
    "busy",
    "butter",
    "buyer",
    "buzz",
    "cabbage",
    "cabin",
    "cable",
    "cactus",
    "cage",
    "cake",
    "call",
    "calm",
    "camera",
    "camp",
    "can",
    "canal",
    "cancel",
    "candy",
    "cannon",
    "canoe",
    "canvas",
    "canyon",
    "capable",
    "capital",
    "captain",
    "car",
    "carbon",
    "card",
    "cargo",
    "carpet",
    "carry",
    "cart",
    "case",
    "cash",
    "casino",
    "castle",
    "casual",
    "cat",
    "catalog",
    "catch",
    "category",
    "cattle",
    "caught",
    "cause",
    "caution",
    "cave",
    "ceiling",
    "celery",
    "cement",
    "census",
    "century",
    "cereal",
    "certain",
    "chair",
    "chalk",
    "champion",
    "change",
    "chaos",
    "chapter",
    "charge",
    "chase",
    "chat",
    "cheap",
    "check",
    "cheese",
    "chef",
    "cherry",
    "chest",
    "chicken",
    "chief",
    "child",
    "chimney",
    "choice",
    "choose",
    "chronic",
    "chuckle",
    "chunk",
    "churn",
    "cigar",
    "cinnamon",
    "circle",
    "citizen",
    "city",
    "civil",
    "claim",
    "clap",
    "clarify",
    "claw",
    "clay",
    "clean",
    "clerk",
    "clever",
    "click",
    "client",
    "cliff",
    "climb",
    "clinic",
    "clip",
    "clock",
    "clog",
    "close",
    "cloth",
    "cloud",
    "clown",
    "club",
    "clump",
    "cluster",
    "clutch",
    "coach",
    "coast",
    "coconut",
    "code",
    "coffee",
    "coil",
    "coin",
    "collect",
    "color",
    "column",
    "combine",
    "come",
    "comfort",
    "comic",
    "common",
    "company",
    "concert",
    "conduct",
    "confirm",
    "congress",
    "connect",
    "consider",
    "control",
    "convince",
    "cook",
    "cool",
    "copper",
    "copy",
    "coral",
    "core",
    "corn",
    "correct",
    "cost",
    "cotton",
    "couch",
    "country",
    "couple",
    "course",
    "cousin",
    "cover",
    "coyote",
    "crack",
    "cradle",
    "craft",
    "cram",
    "crane",
    "crash",
    "crater",
    "crawl",
    "crazy",
    "cream",
    "credit",
    "creek",
    "crew",
    "cricket",
    "crime",
    "crisp",
    "critic",
    "crop",
    "cross",
    "crouch",
    "crowd",
    "crucial",
    "cruel",
    "cruise",
    "crumble",
    "crunch",
    "crush",
    "cry",
    "crystal",
    "cube",
    "culture",
    "cup",
    "cupboard",
    "curious",
    "current",
    "curtain",
    "curve",
    "cushion",
    "custom",
    "cute",
    "cycle",
    "dad",
    "damage",
    "damp",
    "dance",
    "danger",
    "daring",
    "dash",
    "daughter",
    "dawn",
    "day",
    "deal",
    "debate",
    "debris",
    "decade",
    "december",
    "decide",
    "decline",
    "decorate",
    "decrease",
    "deer",
    "defense",
    "define",
    "defy",
    "degree",
    "delay",
    "deliver",
    "demand",
    "demise",
    "denial",
    "dentist",
    "deny",
    "depart",
    "depend",
    "deposit",
    "depth",
    "deputy",
    "derive",
    "describe",
    "desert",
    "design",
    "desk",
    "despair",
    "destroy",
    "detail",
    "detect",
    "develop",
    "device",
    "devote",
    "diagram",
    "dial",
    "diamond",
    "diary",
    "dice",
    "diesel",
    "diet",
    "differ",
    "digital",
    "dignity",
    "dilemma",
    "dinner",
    "dinosaur",
    "direct",
    "dirt",
    "disagree",
    "discover",
    "disease",
    "dish",
    "dismiss",
    "disorder",
    "display",
    "distance",
    "divert",
    "divide",
    "divorce",
    "dizzy",
    "doctor",
    "document",
    "dog",
    "doll",
    "dolphin",
    "domain",
    "donate",
    "donkey",
    "donor",
    "door",
    "dose",
    "double",
    "dove",
    "draft",
    "dragon",
    "drama",
    "drastic",
    "draw",
    "dream",
    "dress",
    "drift",
    "drill",
    "drink",
    "drip",
    "drive",
    "drop",
    "drum",
    "dry",
    "duck",
    "dumb",
    "dune",
    "during",
    "dust",
    "dutch",
    "duty",
    "dwarf",
    "dynamic",
    "eager",
    "eagle",
    "early",
    "earn",
    "earth",
    "easily",
    "east",
    "easy",
    "echo",
    "ecology",
    "economy",
    "edge",
    "edit",
    "educate",
    "effort",
    "egg",
    "eight",
    "either",
    "elbow",
    "elder",
    "electric",
    "elegant",
    "element",
    "elephant",
    "elevator",
    "elite",
    "else",
    "embark",
    "embody",
    "embrace",
    "emerge",
    "emotion",
    "employ",
    "empower",
    "empty",
    "enable",
    "enact",
    "end",
    "endless",
    "endorse",
    "enemy",
    "energy",
    "enforce",
    "engage",
    "engine",
    "enhance",
    "enjoy",
    "enlist",
    "enough",
    "enrich",
    "enroll",
    "ensure",
    "enter",
    "entire",
    "entry",
    "envelope",
    "episode",
    "equal",
    "equip",
    "era",
    "erase",
    "erode",
    "erosion",
    "error",
    "erupt",
    "escape",
    "essay",
    "essence",
    "estate",
    "eternal",
    "ethics",
    "evidence",
    "evil",
    "evoke",
    "evolve",
    "exact",
    "example",
    "excess",
    "exchange",
    "excite",
    "exclude",
    "excuse",
    "execute",
    "exercise",
    "exhaust",
    "exhibit",
    "exile",
    "exist",
    "exit",
    "exotic",
    "expand",
    "expect",
    "expire",
    "explain",
    "expose",
    "express",
    "extend",
    "extra",
    "eye",
    "eyebrow",
    "fabric",
    "face",
    "faculty",
    "fade",
    "faint",
    "faith",
    "fall",
    "false",
    "fame",
    "family",
    "famous",
    "fan",
    "fancy",
    "fantasy",
    "farm",
    "fashion",
    "fat",
    "fatal",
    "father",
    "fatigue",
    "fault",
    "favorite",
    "feature",
    "february",
    "federal",
    "fee",
    "feed",
    "feel",
    "female",
    "fence",
    "festival",
    "fetch",
    "fever",
    "few",
    "fiber",
    "fiction",
    "field",
    "figure",
    "file",
    "film",
    "filter",
    "final",
    "find",
    "fine",
    "finger",
    "finish",
    "fire",
    "firm",
    "first",
    "fiscal",
    "fish",
    "fit",
    "fitness",
    "fix",
    "flag",
    "flame",
    "flash",
    "flat",
    "flavor",
    "flee",
    "flight",
    "flip",
    "float",
    "flock",
    "floor",
    "flower",
    "fluid",
    "flush",
    "fly",
    "foam",
    "focus",
    "fog",
    "foil",
    "fold",
    "follow",
    "food",
    "foot",
    "force",
    "forest",
    "forget",
    "fork",
    "fortune",
    "forum",
    "forward",
    "fossil",
    "foster",
    "found",
    "fox",
    "fragile",
    "frame",
    "frequent",
    "fresh",
    "friend",
    "fringe",
    "frog",
    "front",
    "frost",
    "frown",
    "frozen",
    "fruit",
    "fuel",
    "fun",
    "funny",
    "furnace",
    "fury",
    "future",
    "gadget",
    "gain",
    "galaxy",
    "gallery",
    "game",
    "gap",
    "garage",
    "garbage",
    "garden",
    "garlic",
    "garment",
    "gas",
    "gasp",
    "gate",
    "gather",
    "gauge",
    "gaze",
    "general",
    "genius",
    "genre",
    "gentle",
    "genuine",
    "gesture",
    "ghost",
    "giant",
    "gift",
    "giggle",
    "ginger",
    "giraffe",
    "girl",
    "give",
    "glad",
    "glance",
    "glare",
    "glass",
    "glide",
    "glimpse",
    "globe",
    "gloom",
    "glory",
    "glove",
    "glow",
    "glue",
    "goat",
    "goddess",
    "gold",
    "good",
    "goose",
    "gorilla",
    "gospel",
    "gossip",
    "govern",
    "gown",
    "grab",
    "grace",
    "grain",
    "grant",
    "grape",
    "grass",
    "gravity",
    "great",
    "green",
    "grid",
    "grief",
    "grit",
    "grocery",
    "group",
    "grow",
    "grunt",
    "guard",
    "guess",
    "guide",
    "guilt",
    "guitar",
    "gun",
    "gym",
    "habit",
    "hair",
    "half",
    "hammer",
    "hamster",
    "hand",
    "happy",
    "harbor",
    "hard",
    "harsh",
    "harvest",
    "hat",
    "have",
    "hawk",
    "hazard",
    "head",
    "health",
    "heart",
    "heavy",
    "hedgehog",
    "height",
    "hello",
    "helmet",
    "help",
    "hen",
    "hero",
    "hidden",
    "high",
    "hill",
    "hint",
    "hip",
    "hire",
    "history",
    "hobby",
    "hockey",
    "hold",
    "hole",
    "holiday",
    "hollow",
    "home",
    "honey",
    "hood",
    "hope",
    "horn",
    "horror",
    "horse",
    "hospital",
    "host",
    "hotel",
    "hour",
    "hover",
    "hub",
    "huge",
    "human",
    "humble",
    "humor",
    "hundred",
    "hungry",
    "hunt",
    "hurdle",
    "hurry",
    "hurt",
    "husband",
    "hybrid",
    "ice",
    "icon",
    "idea",
    "identify",
    "idle",
    "ignore",
    "ill",
    "illegal",
    "illness",
    "image",
    "imitate",
    "immense",
    "immune",
    "impact",
    "impose",
    "improve",
    "impulse",
    "inch",
    "include",
    "income",
    "increase",
    "index",
    "indicate",
    "indoor",
    "industry",
    "infant",
    "inflict",
    "inform",
    "inhale",
    "inherit",
    "initial",
    "inject",
    "injury",
    "inmate",
    "inner",
    "innocent",
    "input",
    "inquiry",
    "insane",
    "insect",
    "inside",
    "inspire",
    "install",
    "intact",
    "interest",
    "into",
    "invest",
    "invite",
    "involve",
    "iron",
    "island",
    "isolate",
    "issue",
    "item",
    "ivory",
    "jacket",
    "jaguar",
    "jar",
    "jazz",
    "jealous",
    "jeans",
    "jelly",
    "jewel",
    "job",
    "join",
    "joke",
    "journey",
    "joy",
    "judge",
    "juice",
    "jump",
    "jungle",
    "junior",
    "junk",
    "just",
    "kangaroo",
    "keen",
    "keep",
    "ketchup",
    "key",
    "kick",
    "kid",
    "kidney",
    "kind",
    "kingdom",
    "kiss",
    "kit",
    "kitchen",
    "kite",
    "kitten",
    "kiwi",
    "knee",
    "knife",
    "knock",
    "know",
    "lab",
    "label",
    "labor",
    "ladder",
    "lady",
    "lake",
    "lamp",
    "language",
    "laptop",
    "large",
    "later",
    "latin",
    "laugh",
    "laundry",
    "lava",
    "law",
    "lawn",
    "lawsuit",
    "layer",
    "lazy",
    "leader",
    "leaf",
    "learn",
    "leave",
    "lecture",
    "left",
    "leg",
    "legal",
    "legend",
    "leisure",
    "lemon",
    "lend",
    "length",
    "lens",
    "leopard",
    "lesson",
    "letter",
    "level",
    "liar",
    "liberty",
    "library",
    "license",
    "life",
    "lift",
    "light",
    "like",
    "limb",
    "limit",
    "link",
    "lion",
    "liquid",
    "list",
    "little",
    "live",
    "lizard",
    "load",
    "loan",
    "lobster",
    "local",
    "lock",
    "logic",
    "lonely",
    "long",
    "loop",
    "lottery",
    "loud",
    "lounge",
    "love",
    "loyal",
    "lucky",
    "luggage",
    "lumber",
    "lunar",
    "lunch",
    "luxury",
    "lyrics",
    "machine",
    "mad",
    "magic",
    "magnet",
    "maid",
    "mail",
    "main",
    "major",
    "make",
    "mammal",
    "man",
    "manage",
    "mandate",
    "mango",
    "mansion",
    "manual",
    "maple",
    "marble",
    "march",
    "margin",
    "marine",
    "market",
    "marriage",
    "mask",
    "mass",
    "master",
    "match",
    "material",
    "math",
    "matrix",
    "matter",
    "maximum",
    "maze",
    "meadow",
    "mean",
    "measure",
    "meat",
    "mechanic",
    "medal",
    "media",
    "melody",
    "melt",
    "member",
    "memory",
    "mention",
    "menu",
    "mercy",
    "merge",
    "merit",
    "merry",
    "mesh",
    "message",
    "metal",
    "method",
    "middle",
    "midnight",
    "milk",
    "million",
    "mimic",
    "mind",
    "minimum",
    "minor",
    "minute",
    "miracle",
    "mirror",
    "misery",
    "miss",
    "mistake",
    "mix",
    "mixed",
    "mixture",
    "mobile",
    "model",
    "modify",
    "mom",
    "moment",
    "monitor",
    "monkey",
    "monster",
    "month",
    "moon",
    "moral",
    "more",
    "morning",
    "mosquito",
    "mother",
    "motion",
    "motor",
    "mountain",
    "mouse",
    "move",
    "movie",
    "much",
    "muffin",
    "mule",
    "multiply",
    "muscle",
    "museum",
    "mushroom",
    "music",
    "must",
    "mutual",
    "myself",
    "mystery",
    "myth",
    "naive",
    "name",
    "napkin",
    "narrow",
    "nasty",
    "nation",
    "nature",
    "near",
    "neck",
    "need",
    "negative",
    "neglect",
    "neither",
    "nephew",
    "nerve",
    "nest",
    "net",
    "network",
    "neutral",
    "never",
    "news",
    "next",
    "nice",
    "night",
    "noble",
    "noise",
    "nominee",
    "noodle",
    "normal",
    "north",
    "nose",
    "notable",
    "note",
    "nothing",
    "notice",
    "novel",
    "now",
    "nuclear",
    "number",
    "nurse",
    "nut",
    "oak",
    "obey",
    "object",
    "oblige",
    "obscure",
    "observe",
    "obtain",
    "obvious",
    "occur",
    "ocean",
    "october",
    "odor",
    "off",
    "offer",
    "office",
    "often",
    "oil",
    "okay",
    "old",
    "olive",
    "olympic",
    "omit",
    "once",
    "one",
    "onion",
    "online",
    "only",
    "open",
    "opera",
    "opinion",
    "oppose",
    "option",
    "orange",
    "orbit",
    "orchard",
    "order",
    "ordinary",
    "organ",
    "orient",
    "original",
    "orphan",
    "ostrich",
    "other",
    "outdoor",
    "outer",
    "output",
    "outside",
    "oval",
    "oven",
    "over",
    "own",
    "owner",
    "oxygen",
    "oyster",
    "ozone",
    "pact",
    "paddle",
    "page",
    "pair",
    "palace",
    "palm",
    "panda",
    "panel",
    "panic",
    "panther",
    "paper",
    "parade",
    "parent",
    "park",
    "parrot",
    "party",
    "pass",
    "patch",
    "path",
    "patient",
    "patrol",
    "pattern",
    "pause",
    "pave",
    "payment",
    "peace",
    "peanut",
    "pear",
    "peasant",
    "pelican",
    "pen",
    "penalty",
    "pencil",
    "people",
    "pepper",
    "perfect",
    "permit",
    "person",
    "pet",
    "phone",
    "photo",
    "phrase",
    "physical",
    "piano",
    "picnic",
    "picture",
    "piece",
    "pig",
    "pigeon",
    "pill",
    "pilot",
    "pink",
    "pioneer",
    "pipe",
    "pistol",
    "pitch",
    "pizza",
    "place",
    "planet",
    "plastic",
    "plate",
    "play",
    "please",
    "pledge",
    "pluck",
    "plug",
    "plunge",
    "poem",
    "poet",
    "point",
    "polar",
    "pole",
    "police",
    "pond",
    "pony",
    "pool",
    "popular",
    "portion",
    "position",
    "possible",
    "post",
    "potato",
    "pottery",
    "poverty",
    "powder",
    "power",
    "practice",
    "praise",
    "predict",
    "prefer",
    "prepare",
    "present",
    "pretty",
    "prevent",
    "price",
    "pride",
    "primary",
    "print",
    "priority",
    "prison",
    "private",
    "prize",
    "problem",
    "process",
    "produce",
    "profit",
    "program",
    "project",
    "promote",
    "proof",
    "property",
    "prosper",
    "protect",
    "proud",
    "provide",
    "public",
    "pudding",
    "pull",
    "pulp",
    "pulse",
    "pumpkin",
    "punch",
    "pupil",
    "puppy",
    "purchase",
    "purity",
    "purpose",
    "purse",
    "push",
    "put",
    "puzzle",
    "pyramid",
    "quality",
    "quantum",
    "quarter",
    "question",
    "quick",
    "quit",
    "quiz",
    "quote",
    "rabbit",
    "raccoon",
    "race",
    "rack",
    "radar",
    "radio",
    "rail",
    "rain",
    "raise",
    "rally",
    "ramp",
    "ranch",
    "random",
    "range",
    "rapid",
    "rare",
    "rate",
    "rather",
    "raven",
    "raw",
    "razor",
    "ready",
    "real",
    "reason",
    "rebel",
    "rebuild",
    "recall",
    "receive",
    "recipe",
    "record",
    "recycle",
    "reduce",
    "reflect",
    "reform",
    "refuse",
    "region",
    "regret",
    "regular",
    "reject",
    "relax",
    "release",
    "relief",
    "rely",
    "remain",
    "remember",
    "remind",
    "remove",
    "render",
    "renew",
    "rent",
    "reopen",
    "repair",
    "repeat",
    "replace",
    "report",
    "require",
    "rescue",
    "resemble",
    "resist",
    "resource",
    "response",
    "result",
    "retire",
    "retreat",
    "return",
    "reunion",
    "reveal",
    "review",
    "reward",
    "rhythm",
    "rib",
    "ribbon",
    "rice",
    "rich",
    "ride",
    "ridge",
    "rifle",
    "right",
    "rigid",
    "ring",
    "riot",
    "ripple",
    "risk",
    "ritual",
    "rival",
    "river",
    "road",
    "roast",
    "robot",
    "robust",
    "rocket",
    "romance",
    "roof",
    "rookie",
    "room",
    "rose",
    "rotate",
    "rough",
    "round",
    "route",
    "royal",
    "rubber",
    "rude",
    "rug",
    "rule",
    "run",
    "runway",
    "rural",
    "sad",
    "saddle",
    "sadness",
    "safe",
    "sail",
    "salad",
    "salmon",
    "salon",
    "salt",
    "salute",
    "same",
    "sample",
    "sand",
    "satisfy",
    "satoshi",
    "sauce",
    "sausage",
    "save",
    "say",
    "scale",
    "scan",
    "scare",
    "scatter",
    "scene",
    "scheme",
    "school",
    "science",
    "scissors",
    "scorpion",
    "scout",
    "scrap",
    "screen",
    "script",
    "scrub",
    "sea",
    "search",
    "season",
    "seat",
    "second",
    "secret",
    "section",
    "security",
    "seed",
    "seek",
    "segment",
    "select",
    "sell",
    "seminar",
    "senior",
    "sense",
    "sentence",
    "series",
    "service",
    "session",
    "settle",
    "setup",
    "seven",
    "shadow",
    "shaft",
    "shallow",
    "share",
    "shed",
    "shell",
    "sheriff",
    "shield",
    "shift",
    "shine",
    "ship",
    "shiver",
    "shock",
    "shoe",
    "shoot",
    "shop",
    "short",
    "shoulder",
    "shove",
    "shrimp",
    "shrug",
    "shuffle",
    "shy",
    "sibling",
    "sick",
    "side",
    "siege",
    "sight",
    "sign",
    "silent",
    "silk",
    "silly",
    "silver",
    "similar",
    "simple",
    "since",
    "sing",
    "siren",
    "sister",
    "situate",
    "six",
    "size",
    "skate",
    "sketch",
    "ski",
    "skill",
    "skin",
    "skirt",
    "skull",
    "slab",
    "slam",
    "sleep",
    "slender",
    "slice",
    "slide",
    "slight",
    "slim",
    "slogan",
    "slot",
    "slow",
    "slush",
    "small",
    "smart",
    "smile",
    "smoke",
    "smooth",
    "snack",
    "snake",
    "snap",
    "sniff",
    "snow",
    "soap",
    "soccer",
    "social",
    "sock",
    "soda",
    "soft",
    "solar",
    "soldier",
    "solid",
    "solution",
    "solve",
    "someone",
    "song",
    "soon",
    "sorry",
    "sort",
    "soul",
    "sound",
    "soup",
    "source",
    "south",
    "space",
    "spare",
    "spatial",
    "spawn",
    "speak",
    "special",
    "speed",
    "spell",
    "spend",
    "sphere",
    "spice",
    "spider",
    "spike",
    "spin",
    "spirit",
    "split",
    "spoil",
    "sponsor",
    "spoon",
    "sport",
    "spot",
    "spray",
    "spread",
    "spring",
    "spy",
    "square",
    "squeeze",
    "squirrel",
    "stable",
    "stadium",
    "staff",
    "stage",
    "stairs",
    "stamp",
    "stand",
    "start",
    "state",
    "stay",
    "steak",
    "steel",
    "stem",
    "step",
    "stereo",
    "stick",
    "still",
    "sting",
    "stock",
    "stomach",
    "stone",
    "stool",
    "story",
    "stove",
    "strategy",
    "street",
    "strike",
    "strong",
    "struggle",
    "student",
    "stuff",
    "stumble",
    "style",
    "subject",
    "submit",
    "subway",
    "success",
    "such",
    "sudden",
    "suffer",
    "sugar",
    "suggest",
    "suit",
    "summer",
    "sun",
    "sunny",
    "sunset",
    "super",
    "supply",
    "supreme",
    "sure",
    "surface",
    "surge",
    "surprise",
    "surround",
    "survey",
    "suspect",
    "sustain",
    "swallow",
    "swamp",
    "swap",
    "swarm",
    "swear",
    "sweet",
    "swift",
    "swim",
    "swing",
    "switch",
    "sword",
    "symbol",
    "symptom",
    "syrup",
    "system",
    "table",
    "tackle",
    "tag",
    "tail",
    "talent",
    "talk",
    "tank",
    "tape",
    "target",
    "task",
    "taste",
    "tattoo",
    "taxi",
    "teach",
    "team",
    "tell",
    "ten",
    "tenant",
    "tennis",
    "tent",
    "term",
    "test",
    "text",
    "thank",
    "that",
    "theme",
    "then",
    "theory",
    "there",
    "they",
    "thing",
    "this",
    "thought",
    "three",
    "thrive",
    "throw",
    "thumb",
    "thunder",
    "ticket",
    "tide",
    "tiger",
    "tilt",
    "timber",
    "time",
    "tiny",
    "tip",
    "tired",
    "tissue",
    "title",
    "toast",
    "tobacco",
    "today",
    "toddler",
    "toe",
    "together",
    "toilet",
    "token",
    "tomato",
    "tomorrow",
    "tone",
    "tongue",
    "tonight",
    "tool",
    "tooth",
    "top",
    "topic",
    "topple",
    "torch",
    "tornado",
    "tortoise",
    "toss",
    "total",
    "tourist",
    "toward",
    "tower",
    "town",
    "toy",
    "track",
    "trade",
    "traffic",
    "tragic",
    "train",
    "transfer",
    "trap",
    "trash",
    "travel",
    "tray",
    "treat",
    "tree",
    "trend",
    "trial",
    "tribe",
    "trick",
    "trigger",
    "trim",
    "trip",
    "trophy",
    "trouble",
    "truck",
    "true",
    "truly",
    "trumpet",
    "trust",
    "truth",
    "try",
    "tube",
    "tuition",
    "tumble",
    "tuna",
    "tunnel",
    "turkey",
    "turn",
    "turtle",
    "twelve",
    "twenty",
    "twice",
    "twin",
    "twist",
    "two",
    "type",
    "typical",
    "ugly",
    "umbrella",
    "unable",
    "unaware",
    "uncle",
    "uncover",
    "under",
    "undo",
    "unfair",
    "unfold",
    "unhappy",
    "uniform",
    "unique",
    "unit",
    "universe",
    "unknown",
    "unlock",
    "until",
    "unusual",
    "unveil",
    "update",
    "upgrade",
    "uphold",
    "upon",
    "upper",
    "upset",
    "urban",
    "urge",
    "usage",
    "use",
    "used",
    "useful",
    "useless",
    "usual",
    "utility",
    "vacant",
    "vacuum",
    "vague",
    "valid",
    "valley",
    "valve",
    "van",
    "vanish",
    "vapor",
    "various",
    "vast",
    "vault",
    "vehicle",
    "velvet",
    "vendor",
    "venture",
    "venue",
    "verb",
    "verify",
    "version",
    "very",
    "vessel",
    "veteran",
    "viable",
    "vibrant",
    "vicious",
    "victory",
    "video",
    "view",
    "village",
    "vintage",
    "violin",
    "virtual",
    "virus",
    "visa",
    "visit",
    "visual",
    "vital",
    "vivid",
    "vocal",
    "voice",
    "void",
    "volcano",
    "volume",
    "vote",
    "voyage",
    "wage",
    "wagon",
    "wait",
    "walk",
    "wall",
    "walnut",
    "want",
    "warfare",
    "warm",
    "warrior",
    "wash",
    "wasp",
    "waste",
    "water",
    "wave",
    "way",
    "wealth",
    "weapon",
    "wear",
    "weasel",
    "weather",
    "web",
    "wedding",
    "weekend",
    "weird",
    "welcome",
    "west",
    "wet",
    "whale",
    "what",
    "wheat",
    "wheel",
    "when",
    "where",
    "whip",
    "whisper",
    "wide",
    "width",
    "wife",
    "wild",
    "will",
    "win",
    "window",
    "wine",
    "wing",
    "wink",
    "winner",
    "winter",
    "wire",
    "wisdom",
    "wise",
    "wish",
    "witness",
    "wolf",
    "woman",
    "wonder",
    "wood",
    "wool",
    "word",
    "work",
    "world",
    "worry",
    "worth",
    "wrap",
    "wreck",
    "wrestle",
    "wrist",
    "write",
    "wrong",
    "yard",
    "year",
    "yellow",
    "you",
    "young",
    "youth",
    "zebra",
    "zero",
    "zone",
    "zoo"
];
module.exports.wordlist = $75cf18eca1f28516$var$EN;

});


parcelRequire.register("lRPkH", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $feb65ddcb3c1252d$require$Buffer = $gzLuY.Buffer;
"use strict";
var $feb65ddcb3c1252d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.openBox = module.exports.sealBox = module.exports.signVerify = module.exports.sign = module.exports.keyPairFromSeed = module.exports.keyPairFromSecretKey = void 0;

var $feb65ddcb3c1252d$var$tweetnacl_1 = $feb65ddcb3c1252d$var$__importDefault((parcelRequire("44JIq")));
function $feb65ddcb3c1252d$var$keyPairFromSecretKey(secretKey) {
    var res = $feb65ddcb3c1252d$var$tweetnacl_1.default.sign.keyPair.fromSecretKey(new Uint8Array(secretKey));
    return {
        publicKey: $feb65ddcb3c1252d$require$Buffer.from(res.publicKey),
        secretKey: $feb65ddcb3c1252d$require$Buffer.from(res.secretKey)
    };
}
module.exports.keyPairFromSecretKey = $feb65ddcb3c1252d$var$keyPairFromSecretKey;
function $feb65ddcb3c1252d$var$keyPairFromSeed(secretKey) {
    var res = $feb65ddcb3c1252d$var$tweetnacl_1.default.sign.keyPair.fromSeed(new Uint8Array(secretKey));
    return {
        publicKey: $feb65ddcb3c1252d$require$Buffer.from(res.publicKey),
        secretKey: $feb65ddcb3c1252d$require$Buffer.from(res.secretKey)
    };
}
module.exports.keyPairFromSeed = $feb65ddcb3c1252d$var$keyPairFromSeed;
function $feb65ddcb3c1252d$var$sign(data, secretKey) {
    return $feb65ddcb3c1252d$require$Buffer.from($feb65ddcb3c1252d$var$tweetnacl_1.default.sign.detached(new Uint8Array(data), new Uint8Array(secretKey)));
}
module.exports.sign = $feb65ddcb3c1252d$var$sign;
function $feb65ddcb3c1252d$var$signVerify(data, signature, publicKey) {
    return $feb65ddcb3c1252d$var$tweetnacl_1.default.sign.detached.verify(new Uint8Array(data), new Uint8Array(signature), new Uint8Array(publicKey));
}
module.exports.signVerify = $feb65ddcb3c1252d$var$signVerify;
function $feb65ddcb3c1252d$var$sealBox(data, nonce, key) {
    return $feb65ddcb3c1252d$require$Buffer.from($feb65ddcb3c1252d$var$tweetnacl_1.default.secretbox(data, nonce, key));
}
module.exports.sealBox = $feb65ddcb3c1252d$var$sealBox;
function $feb65ddcb3c1252d$var$openBox(data, nonce, key) {
    var res = $feb65ddcb3c1252d$var$tweetnacl_1.default.secretbox.open(data, nonce, key);
    if (!res) return null;
    return $feb65ddcb3c1252d$require$Buffer.from(res);
}
module.exports.openBox = $feb65ddcb3c1252d$var$openBox;

});

parcelRequire.register("3kBUi", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $26d0a4dfb9e5f18d$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deriveEd25519Path = module.exports.deriveED25519HardenedKey = module.exports.getED25519MasterKeyFromSeed = void 0;

var $6C3Y6 = parcelRequire("6C3Y6");
var $26d0a4dfb9e5f18d$var$ED25519_CURVE = "ed25519 seed";
var $26d0a4dfb9e5f18d$var$HARDENED_OFFSET = 0x80000000;
function $26d0a4dfb9e5f18d$var$getED25519MasterKeyFromSeed(seed) {
    return $26d0a4dfb9e5f18d$var$_getED25519MasterKeyFromSeed.apply(this, arguments);
}
function $26d0a4dfb9e5f18d$var$_getED25519MasterKeyFromSeed() {
    $26d0a4dfb9e5f18d$var$_getED25519MasterKeyFromSeed = (0, $byzP8._)(function(seed) {
        var I, IL, IR;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $6C3Y6.hmac_sha512)($26d0a4dfb9e5f18d$var$ED25519_CURVE, seed)
                    ];
                case 1:
                    I = _state.sent();
                    IL = I.slice(0, 32);
                    IR = I.slice(32);
                    return [
                        2,
                        {
                            key: IL,
                            chainCode: IR
                        }
                    ];
            }
        });
    });
    return $26d0a4dfb9e5f18d$var$_getED25519MasterKeyFromSeed.apply(this, arguments);
}
module.exports.getED25519MasterKeyFromSeed = $26d0a4dfb9e5f18d$var$getED25519MasterKeyFromSeed;
function $26d0a4dfb9e5f18d$var$deriveED25519HardenedKey(parent, index) {
    return $26d0a4dfb9e5f18d$var$_deriveED25519HardenedKey.apply(this, arguments);
}
function $26d0a4dfb9e5f18d$var$_deriveED25519HardenedKey() {
    $26d0a4dfb9e5f18d$var$_deriveED25519HardenedKey = (0, $byzP8._)(function(parent, index) {
        var indexBuffer, data, I, IL, IR;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (index >= $26d0a4dfb9e5f18d$var$HARDENED_OFFSET) throw Error("Key index must be less than offset");
                    indexBuffer = $26d0a4dfb9e5f18d$require$Buffer.alloc(4);
                    indexBuffer.writeUInt32BE(index + $26d0a4dfb9e5f18d$var$HARDENED_OFFSET, 0);
                    data = $26d0a4dfb9e5f18d$require$Buffer.concat([
                        $26d0a4dfb9e5f18d$require$Buffer.alloc(1, 0),
                        parent.key,
                        indexBuffer
                    ]);
                    return [
                        4,
                        (0, $6C3Y6.hmac_sha512)(parent.chainCode, data)
                    ];
                case 1:
                    I = _state.sent();
                    IL = I.slice(0, 32);
                    IR = I.slice(32);
                    return [
                        2,
                        {
                            key: IL,
                            chainCode: IR
                        }
                    ];
            }
        });
    });
    return $26d0a4dfb9e5f18d$var$_deriveED25519HardenedKey.apply(this, arguments);
}
module.exports.deriveED25519HardenedKey = $26d0a4dfb9e5f18d$var$deriveED25519HardenedKey;
function $26d0a4dfb9e5f18d$var$deriveEd25519Path(seed, path) {
    return $26d0a4dfb9e5f18d$var$_deriveEd25519Path.apply(this, arguments);
}
function $26d0a4dfb9e5f18d$var$_deriveEd25519Path() {
    $26d0a4dfb9e5f18d$var$_deriveEd25519Path = (0, $byzP8._)(function(seed, path) {
        var state, remaining, index;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $26d0a4dfb9e5f18d$var$getED25519MasterKeyFromSeed(seed)
                    ];
                case 1:
                    state = _state.sent();
                    remaining = (0, $fLnyw._)(path);
                    _state.label = 2;
                case 2:
                    if (!(remaining.length > 0)) return [
                        3,
                        4
                    ];
                    index = remaining[0];
                    remaining = remaining.slice(1);
                    return [
                        4,
                        $26d0a4dfb9e5f18d$var$deriveED25519HardenedKey(state, index)
                    ];
                case 3:
                    state = _state.sent();
                    return [
                        3,
                        2
                    ];
                case 4:
                    return [
                        2,
                        state.key
                    ];
            }
        });
    });
    return $26d0a4dfb9e5f18d$var$_deriveEd25519Path.apply(this, arguments);
}
module.exports.deriveEd25519Path = $26d0a4dfb9e5f18d$var$deriveEd25519Path;

});

parcelRequire.register("gK3Ew", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $c303c68e49302030$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deriveSymmetricPath = module.exports.deriveSymmetricHardenedKey = module.exports.getSymmetricMasterKeyFromSeed = void 0;

var $6C3Y6 = parcelRequire("6C3Y6");
var $c303c68e49302030$var$SYMMETRIC_SEED = "Symmetric key seed";
function $c303c68e49302030$var$getSymmetricMasterKeyFromSeed(seed) {
    return $c303c68e49302030$var$_getSymmetricMasterKeyFromSeed.apply(this, arguments);
}
function $c303c68e49302030$var$_getSymmetricMasterKeyFromSeed() {
    $c303c68e49302030$var$_getSymmetricMasterKeyFromSeed = (0, $byzP8._)(function(seed) {
        var I, IL, IR;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $6C3Y6.hmac_sha512)($c303c68e49302030$var$SYMMETRIC_SEED, seed)
                    ];
                case 1:
                    I = _state.sent();
                    IL = I.slice(32);
                    IR = I.slice(0, 32);
                    return [
                        2,
                        {
                            key: IL,
                            chainCode: IR
                        }
                    ];
            }
        });
    });
    return $c303c68e49302030$var$_getSymmetricMasterKeyFromSeed.apply(this, arguments);
}
module.exports.getSymmetricMasterKeyFromSeed = $c303c68e49302030$var$getSymmetricMasterKeyFromSeed;
function $c303c68e49302030$var$deriveSymmetricHardenedKey(parent, offset) {
    return $c303c68e49302030$var$_deriveSymmetricHardenedKey.apply(this, arguments);
}
function $c303c68e49302030$var$_deriveSymmetricHardenedKey() {
    $c303c68e49302030$var$_deriveSymmetricHardenedKey = (0, $byzP8._)(function(parent, offset) {
        var data, I, IL, IR;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = $c303c68e49302030$require$Buffer.concat([
                        $c303c68e49302030$require$Buffer.alloc(1, 0),
                        $c303c68e49302030$require$Buffer.from(offset)
                    ]);
                    return [
                        4,
                        (0, $6C3Y6.hmac_sha512)(parent.chainCode, data)
                    ];
                case 1:
                    I = _state.sent();
                    IL = I.slice(32);
                    IR = I.slice(0, 32);
                    return [
                        2,
                        {
                            key: IL,
                            chainCode: IR
                        }
                    ];
            }
        });
    });
    return $c303c68e49302030$var$_deriveSymmetricHardenedKey.apply(this, arguments);
}
module.exports.deriveSymmetricHardenedKey = $c303c68e49302030$var$deriveSymmetricHardenedKey;
function $c303c68e49302030$var$deriveSymmetricPath(seed, path) {
    return $c303c68e49302030$var$_deriveSymmetricPath.apply(this, arguments);
}
function $c303c68e49302030$var$_deriveSymmetricPath() {
    $c303c68e49302030$var$_deriveSymmetricPath = (0, $byzP8._)(function(seed, path) {
        var state, remaining, index;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $c303c68e49302030$var$getSymmetricMasterKeyFromSeed(seed)
                    ];
                case 1:
                    state = _state.sent();
                    remaining = (0, $fLnyw._)(path);
                    _state.label = 2;
                case 2:
                    if (!(remaining.length > 0)) return [
                        3,
                        4
                    ];
                    index = remaining[0];
                    remaining = remaining.slice(1);
                    return [
                        4,
                        $c303c68e49302030$var$deriveSymmetricHardenedKey(state, index)
                    ];
                case 3:
                    state = _state.sent();
                    return [
                        3,
                        2
                    ];
                case 4:
                    return [
                        2,
                        state.key
                    ];
            }
        });
    });
    return $c303c68e49302030$var$_deriveSymmetricPath.apply(this, arguments);
}
module.exports.deriveSymmetricPath = $c303c68e49302030$var$deriveSymmetricPath;

});

parcelRequire.register("3hYtT", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $2651dfe6a82c1ee8$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deriveMnemonicsPath = module.exports.deriveMnemonicHardenedKey = module.exports.getMnemonicsMasterKeyFromSeed = void 0;

var $hObSB = parcelRequire("hObSB");

var $6C3Y6 = parcelRequire("6C3Y6");
var $2651dfe6a82c1ee8$var$HARDENED_OFFSET = 0x80000000;
var $2651dfe6a82c1ee8$var$MNEMONICS_SEED = "TON Mnemonics HD seed";
function $2651dfe6a82c1ee8$var$getMnemonicsMasterKeyFromSeed(seed) {
    return $2651dfe6a82c1ee8$var$_getMnemonicsMasterKeyFromSeed.apply(this, arguments);
}
function $2651dfe6a82c1ee8$var$_getMnemonicsMasterKeyFromSeed() {
    $2651dfe6a82c1ee8$var$_getMnemonicsMasterKeyFromSeed = (0, $byzP8._)(function(seed) {
        var I, IL, IR;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $6C3Y6.hmac_sha512)($2651dfe6a82c1ee8$var$MNEMONICS_SEED, seed)
                    ];
                case 1:
                    I = _state.sent();
                    IL = I.slice(0, 32);
                    IR = I.slice(32);
                    return [
                        2,
                        {
                            key: IL,
                            chainCode: IR
                        }
                    ];
            }
        });
    });
    return $2651dfe6a82c1ee8$var$_getMnemonicsMasterKeyFromSeed.apply(this, arguments);
}
module.exports.getMnemonicsMasterKeyFromSeed = $2651dfe6a82c1ee8$var$getMnemonicsMasterKeyFromSeed;
function $2651dfe6a82c1ee8$var$deriveMnemonicHardenedKey(parent, index) {
    return $2651dfe6a82c1ee8$var$_deriveMnemonicHardenedKey.apply(this, arguments);
}
function $2651dfe6a82c1ee8$var$_deriveMnemonicHardenedKey() {
    $2651dfe6a82c1ee8$var$_deriveMnemonicHardenedKey = (0, $byzP8._)(function(parent, index) {
        var indexBuffer, data, I, IL, IR;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (index >= $2651dfe6a82c1ee8$var$HARDENED_OFFSET) throw Error("Key index must be less than offset");
                    indexBuffer = $2651dfe6a82c1ee8$require$Buffer.alloc(4);
                    indexBuffer.writeUInt32BE(index + $2651dfe6a82c1ee8$var$HARDENED_OFFSET, 0);
                    data = $2651dfe6a82c1ee8$require$Buffer.concat([
                        $2651dfe6a82c1ee8$require$Buffer.alloc(1, 0),
                        parent.key,
                        indexBuffer
                    ]);
                    return [
                        4,
                        (0, $6C3Y6.hmac_sha512)(parent.chainCode, data)
                    ];
                case 1:
                    I = _state.sent();
                    IL = I.slice(0, 32);
                    IR = I.slice(32);
                    return [
                        2,
                        {
                            key: IL,
                            chainCode: IR
                        }
                    ];
            }
        });
    });
    return $2651dfe6a82c1ee8$var$_deriveMnemonicHardenedKey.apply(this, arguments);
}
module.exports.deriveMnemonicHardenedKey = $2651dfe6a82c1ee8$var$deriveMnemonicHardenedKey;
function $2651dfe6a82c1ee8$var$deriveMnemonicsPath(seed, path) {
    return $2651dfe6a82c1ee8$var$_deriveMnemonicsPath.apply(this, arguments);
}
function $2651dfe6a82c1ee8$var$_deriveMnemonicsPath() {
    $2651dfe6a82c1ee8$var$_deriveMnemonicsPath = (0, $byzP8._)(function(seed, path) {
        var wordsCount, password, state, remaining, index;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    wordsCount = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 24, password = _arguments.length > 3 ? _arguments[3] : void 0;
                    return [
                        4,
                        $2651dfe6a82c1ee8$var$getMnemonicsMasterKeyFromSeed(seed)
                    ];
                case 1:
                    state = _state.sent();
                    remaining = (0, $fLnyw._)(path);
                    _state.label = 2;
                case 2:
                    if (!(remaining.length > 0)) return [
                        3,
                        4
                    ];
                    index = remaining[0];
                    remaining = remaining.slice(1);
                    return [
                        4,
                        $2651dfe6a82c1ee8$var$deriveMnemonicHardenedKey(state, index)
                    ];
                case 3:
                    state = _state.sent();
                    return [
                        3,
                        2
                    ];
                case 4:
                    return [
                        4,
                        (0, $hObSB.mnemonicFromRandomSeed)(state.key, wordsCount, password)
                    ];
                case 5:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $2651dfe6a82c1ee8$var$_deriveMnemonicsPath.apply(this, arguments);
}
module.exports.deriveMnemonicsPath = $2651dfe6a82c1ee8$var$deriveMnemonicsPath;

});



parcelRequire.register("95cTD", function(module, exports) {

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serializeBoc = module.exports.deserializeBoc = module.exports.parseBoc = void 0;

var $6RnAU = parcelRequire("6RnAU");

var $iSKta = parcelRequire("iSKta");

var $KH51V = parcelRequire("KH51V");

var $4UvWU = parcelRequire("4UvWU");

var $bJ23F = parcelRequire("bJ23F");

var $iCiAY = parcelRequire("iCiAY");

var $2Orby = parcelRequire("2Orby");

var $hm8RK = parcelRequire("hm8RK");

var $PYs4s = parcelRequire("PYs4s");
function $69ce95a46c8c9952$var$getHashesCount(levelMask) {
    return $69ce95a46c8c9952$var$getHashesCountFromMask(levelMask & 7);
}
function $69ce95a46c8c9952$var$getHashesCountFromMask(mask) {
    var n = 0;
    for(var i = 0; i < 3; i++){
        n += mask & 1;
        mask = mask >> 1;
    }
    return n + 1; // 1 repr + up to 3 higher hashes
}
function $69ce95a46c8c9952$var$readCell(reader, sizeBytes) {
    // D1
    var d1 = reader.loadUint(8);
    var refsCount = d1 % 8;
    var exotic = !!(d1 & 8);
    // D2
    var d2 = reader.loadUint(8);
    var dataBytesize = Math.ceil(d2 / 2);
    var paddingAdded = !!(d2 % 2);
    var levelMask = d1 >> 5;
    var hasHashes = (d1 & 16) != 0;
    var hash_bytes = 32;
    var hashesSize = hasHashes ? $69ce95a46c8c9952$var$getHashesCount(levelMask) * hash_bytes : 0;
    var depthSize = hasHashes ? $69ce95a46c8c9952$var$getHashesCount(levelMask) * 2 : 0;
    reader.skip(hashesSize * 8);
    reader.skip(depthSize * 8);
    // Bits
    var bits = $iSKta.BitString.EMPTY;
    if (dataBytesize > 0) {
        if (paddingAdded) bits = reader.loadPaddedBits(dataBytesize * 8);
        else bits = reader.loadBits(dataBytesize * 8);
    }
    // Refs
    var refs = [];
    for(var i = 0; i < refsCount; i++)refs.push(reader.loadUint(sizeBytes * 8));
    // Result
    return {
        bits: bits,
        refs: refs,
        exotic: exotic
    };
}
function $69ce95a46c8c9952$var$calcCellSize(cell, sizeBytes) {
    return 2 /* D1+D2 */  + Math.ceil(cell.bits.length / 8) + cell.refs.length * sizeBytes;
}
function $69ce95a46c8c9952$var$parseBoc(src) {
    var reader = new $6RnAU.BitReader(new $iSKta.BitString(src, 0, src.length * 8));
    var magic = reader.loadUint(32);
    if (magic === 0x68ff65f3) {
        var size = reader.loadUint(8);
        var offBytes = reader.loadUint(8);
        var cells = reader.loadUint(size * 8);
        var roots = reader.loadUint(size * 8); // Must be 1
        var absent = reader.loadUint(size * 8);
        var totalCellSize = reader.loadUint(offBytes * 8);
        var index = reader.loadBuffer(cells * offBytes);
        var cellData = reader.loadBuffer(totalCellSize);
        return {
            size: size,
            offBytes: offBytes,
            cells: cells,
            roots: roots,
            absent: absent,
            totalCellSize: totalCellSize,
            index: index,
            cellData: cellData,
            root: [
                0
            ]
        };
    } else if (magic === 0xacc3a728) {
        var size1 = reader.loadUint(8);
        var offBytes1 = reader.loadUint(8);
        var cells1 = reader.loadUint(size1 * 8);
        var roots1 = reader.loadUint(size1 * 8); // Must be 1
        var absent1 = reader.loadUint(size1 * 8);
        var totalCellSize1 = reader.loadUint(offBytes1 * 8);
        var index1 = reader.loadBuffer(cells1 * offBytes1);
        var cellData1 = reader.loadBuffer(totalCellSize1);
        var crc32 = reader.loadBuffer(4);
        if (!(0, $PYs4s.crc32c)(src.subarray(0, src.length - 4)).equals(crc32)) throw Error("Invalid CRC32C");
        return {
            size: size1,
            offBytes: offBytes1,
            cells: cells1,
            roots: roots1,
            absent: absent1,
            totalCellSize: totalCellSize1,
            index: index1,
            cellData: cellData1,
            root: [
                0
            ]
        };
    } else if (magic === 0xb5ee9c72) {
        var hasIdx = reader.loadUint(1);
        var hasCrc32c = reader.loadUint(1);
        var hasCacheBits = reader.loadUint(1);
        var flags = reader.loadUint(2); // Must be 0
        var size2 = reader.loadUint(3);
        var offBytes2 = reader.loadUint(8);
        var cells2 = reader.loadUint(size2 * 8);
        var roots2 = reader.loadUint(size2 * 8);
        var absent2 = reader.loadUint(size2 * 8);
        var totalCellSize2 = reader.loadUint(offBytes2 * 8);
        var root = [];
        for(var i = 0; i < roots2; i++)root.push(reader.loadUint(size2 * 8));
        var index2 = null;
        if (hasIdx) index2 = reader.loadBuffer(cells2 * offBytes2);
        var cellData2 = reader.loadBuffer(totalCellSize2);
        if (hasCrc32c) {
            var crc321 = reader.loadBuffer(4);
            if (!(0, $PYs4s.crc32c)(src.subarray(0, src.length - 4)).equals(crc321)) throw Error("Invalid CRC32C");
        }
        return {
            size: size2,
            offBytes: offBytes2,
            cells: cells2,
            roots: roots2,
            absent: absent2,
            totalCellSize: totalCellSize2,
            index: index2,
            cellData: cellData2,
            root: root
        };
    } else throw Error("Invalid magic");
}
module.exports.parseBoc = $69ce95a46c8c9952$var$parseBoc;
function $69ce95a46c8c9952$var$deserializeBoc(src) {
    //
    // Parse BOC
    //
    var boc = $69ce95a46c8c9952$var$parseBoc(src);
    var reader = new $6RnAU.BitReader(new $iSKta.BitString(boc.cellData, 0, boc.cellData.length * 8));
    //
    // Load cells
    //
    var cells = [];
    for(var i = 0; i < boc.cells; i++){
        var cll = $69ce95a46c8c9952$var$readCell(reader, boc.size);
        cells.push((0, $8E768._)((0, $8OnJk._)({}, cll), {
            result: null
        }));
    }
    //
    // Build cells
    //
    for(var i1 = cells.length - 1; i1 >= 0; i1--){
        if (cells[i1].result) throw Error("Impossible");
        var refs = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = cells[i1].refs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                if (!cells[r].result) throw Error("Invalid BOC file");
                refs.push(cells[r].result);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        cells[i1].result = new $KH51V.Cell({
            bits: cells[i1].bits,
            refs: refs,
            exotic: cells[i1].exotic
        });
    }
    //
    // Load roots
    //
    var roots = [];
    for(var i2 = 0; i2 < boc.root.length; i2++)roots.push(cells[boc.root[i2]].result);
    //
    // Return
    //
    return roots;
}
module.exports.deserializeBoc = $69ce95a46c8c9952$var$deserializeBoc;
function $69ce95a46c8c9952$var$writeCellToBuilder(cell, refs, sizeBytes, to) {
    var d1 = (0, $2Orby.getRefsDescriptor)(cell.refs, cell.level(), cell.type);
    var d2 = (0, $2Orby.getBitsDescriptor)(cell.bits);
    to.writeUint(d1, 8);
    to.writeUint(d2, 8);
    to.writeBuffer((0, $hm8RK.bitsToPaddedBuffer)(cell.bits));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = refs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            to.writeUint(r, sizeBytes * 8);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $69ce95a46c8c9952$var$serializeBoc(root, opts) {
    // Sort cells
    var allCells = (0, $4UvWU.topologicalSort)(root);
    // Calculcate parameters
    var cellsNum = allCells.length;
    var has_idx = opts.idx;
    var has_crc32c = opts.crc32;
    var has_cache_bits = false;
    var flags = 0;
    var sizeBytes = Math.max(Math.ceil((0, $bJ23F.bitsForNumber)(cellsNum, "uint") / 8), 1);
    var totalCellSize = 0;
    var index = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = allCells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var c = _step.value;
            var sz = $69ce95a46c8c9952$var$calcCellSize(c.cell, sizeBytes);
            index.push(totalCellSize);
            totalCellSize += sz;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var offsetBytes = Math.max(Math.ceil((0, $bJ23F.bitsForNumber)(totalCellSize, "uint") / 8), 1);
    var totalSize = (6 + // offset_bytes
    3 * sizeBytes + // cells_num, roots, complete
    offsetBytes + // full_size
    1 * sizeBytes + // root_idx
    (has_idx ? cellsNum * offsetBytes : 0) + totalCellSize + (has_crc32c ? 4 : 0)) * 8;
    // Serialize
    var builder = new $iCiAY.BitBuilder(totalSize);
    builder.writeUint(0xb5ee9c72, 32); // Magic
    builder.writeBit(has_idx); // Has index
    builder.writeBit(has_crc32c); // Has crc32c
    builder.writeBit(has_cache_bits); // Has cache bits
    builder.writeUint(flags, 2); // Flags
    builder.writeUint(sizeBytes, 3); // Size bytes
    builder.writeUint(offsetBytes, 8); // Offset bytes
    builder.writeUint(cellsNum, sizeBytes * 8); // Cells num
    builder.writeUint(1, sizeBytes * 8); // Roots num
    builder.writeUint(0, sizeBytes * 8); // Absent num
    builder.writeUint(totalCellSize, offsetBytes * 8); // Total cell size
    builder.writeUint(0, sizeBytes * 8); // Root id == 0
    if (has_idx) for(var i = 0; i < cellsNum; i++)builder.writeUint(index[i], offsetBytes * 8);
    for(var i1 = 0; i1 < cellsNum; i1++)$69ce95a46c8c9952$var$writeCellToBuilder(allCells[i1].cell, allCells[i1].refs, sizeBytes, builder);
    if (has_crc32c) {
        var crc32 = (0, $PYs4s.crc32c)(builder.buffer()); // builder.buffer() is fast since it doesn't allocate new memory
        builder.writeBuffer(crc32);
    }
    // Sanity Check
    var res = builder.buffer();
    if (res.length !== totalSize / 8) throw Error("Internal error");
    return res;
}
module.exports.serializeBoc = $69ce95a46c8c9952$var$serializeBoc;

});
parcelRequire.register("4UvWU", function(module, exports) {

var $fLnyw = parcelRequire("fLnyw");
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.topologicalSort = void 0;
function $39352cd07e51b5dd$var$topologicalSort(src) {
    var pending = [
        src
    ];
    var allCells = new Map();
    var notPermCells = new Set();
    var sorted = [];
    while(pending.length > 0){
        var cells = (0, $fLnyw._)(pending);
        pending = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = cells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var cell = _step.value;
                var hash = cell.hash().toString("hex");
                if (allCells.has(hash)) continue;
                notPermCells.add(hash);
                allCells.set(hash, {
                    cell: cell,
                    refs: cell.refs.map(function(v) {
                        return v.hash().toString("hex");
                    })
                });
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = cell.refs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var r = _step1.value;
                        pending.push(r);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    var tempMark = new Set();
    function visit(hash) {
        if (!notPermCells.has(hash)) return;
        if (tempMark.has(hash)) throw Error("Not a DAG");
        tempMark.add(hash);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = allCells.get(hash).refs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var c = _step.value;
                visit(c);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        sorted.unshift(hash);
        tempMark.delete(hash);
        notPermCells.delete(hash);
    }
    while(notPermCells.size > 0){
        var id = Array.from(notPermCells)[0];
        visit(id);
    }
    var indexes = new Map();
    for(var i = 0; i < sorted.length; i++)indexes.set(sorted[i], i);
    var result = [];
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = sorted[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var ent = _step2.value;
            var rrr = allCells.get(ent);
            result.push({
                cell: rrr.cell,
                refs: rrr.refs.map(function(v) {
                    return indexes.get(v);
                })
            });
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    return result;
}
module.exports.topologicalSort = $39352cd07e51b5dd$var$topologicalSort;

});

parcelRequire.register("bJ23F", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bitsForNumber = void 0;
function $88957e6240bf26d4$var$bitsForNumber(src, mode) {
    var v = BigInt(src);
    // Handle negative values
    if (mode === "int") {
        // Corner case for zero or -1 value
        if (v === 0n || v === -1n) return 1;
        var v2 = v > 0 ? v : -v;
        return v2.toString(2).length + 1 /* Sign bit */ ;
    } else if (mode === "uint") {
        if (v < 0) throw Error("value is negative. Got ".concat(src));
        return v.toString(2).length;
    } else throw Error("invalid mode. Got ".concat(mode));
}
module.exports.bitsForNumber = $88957e6240bf26d4$var$bitsForNumber;

});

parcelRequire.register("PYs4s", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $09c3a7fea6a24f88$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crc32c = void 0;
var $09c3a7fea6a24f88$var$POLY = 0x82f63b78;
function $09c3a7fea6a24f88$var$crc32c(source) {
    var crc = -1;
    for(var n = 0; n < source.length; n++){
        crc ^= source[n];
        crc = crc & 1 ? crc >>> 1 ^ $09c3a7fea6a24f88$var$POLY : crc >>> 1;
        crc = crc & 1 ? crc >>> 1 ^ $09c3a7fea6a24f88$var$POLY : crc >>> 1;
        crc = crc & 1 ? crc >>> 1 ^ $09c3a7fea6a24f88$var$POLY : crc >>> 1;
        crc = crc & 1 ? crc >>> 1 ^ $09c3a7fea6a24f88$var$POLY : crc >>> 1;
        crc = crc & 1 ? crc >>> 1 ^ $09c3a7fea6a24f88$var$POLY : crc >>> 1;
        crc = crc & 1 ? crc >>> 1 ^ $09c3a7fea6a24f88$var$POLY : crc >>> 1;
        crc = crc & 1 ? crc >>> 1 ^ $09c3a7fea6a24f88$var$POLY : crc >>> 1;
        crc = crc & 1 ? crc >>> 1 ^ $09c3a7fea6a24f88$var$POLY : crc >>> 1;
    }
    crc = crc ^ 0xffffffff;
    // Convert endianness
    var res = $09c3a7fea6a24f88$require$Buffer.alloc(4);
    res.writeInt32LE(crc);
    return res;
}
module.exports.crc32c = $09c3a7fea6a24f88$var$crc32c;

});




parcelRequire.register("49zOn", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeStateInit = module.exports.loadStateInit = void 0;

var $ihDv0 = parcelRequire("ihDv0");

var $bxtCm = parcelRequire("bxtCm");

var $kAHnR = parcelRequire("kAHnR");
function $3063c820836f9205$var$loadStateInit(slice) {
    // Split Depth
    var splitDepth;
    if (slice.loadBit()) splitDepth = slice.loadUint(5);
    // TickTock
    var special;
    if (slice.loadBit()) special = (0, $kAHnR.loadTickTock)(slice);
    // Code and Data
    var code = slice.loadMaybeRef();
    var data = slice.loadMaybeRef();
    // Libs
    var libraries = slice.loadDict($ihDv0.Dictionary.Keys.BigUint(256), $bxtCm.SimpleLibraryValue);
    if (libraries.size === 0) libraries = undefined;
    return {
        splitDepth: splitDepth,
        special: special,
        code: code,
        data: data,
        libraries: libraries
    };
}
module.exports.loadStateInit = $3063c820836f9205$var$loadStateInit;
function $3063c820836f9205$var$storeStateInit(src) {
    return function(builder) {
        if (src.splitDepth !== null && src.splitDepth !== undefined) {
            builder.storeBit(true);
            builder.storeUint(src.splitDepth, 5);
        } else builder.storeBit(false);
        if (src.special !== null && src.special !== undefined) {
            builder.storeBit(true);
            builder.store((0, $kAHnR.storeTickTock)(src.special));
        } else builder.storeBit(false);
        builder.storeMaybeRef(src.code);
        builder.storeMaybeRef(src.data);
        builder.storeDict(src.libraries);
    };
}
module.exports.storeStateInit = $3063c820836f9205$var$storeStateInit;

});
parcelRequire.register("bxtCm", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleLibraryValue = module.exports.storeSimpleLibrary = module.exports.loadSimpleLibrary = void 0;
function $8669c036ca0f03e4$var$loadSimpleLibrary(slice) {
    return {
        public: slice.loadBit(),
        root: slice.loadRef()
    };
}
module.exports.loadSimpleLibrary = $8669c036ca0f03e4$var$loadSimpleLibrary;
function $8669c036ca0f03e4$var$storeSimpleLibrary(src) {
    return function(builder) {
        builder.storeBit(src.public);
        builder.storeRef(src.root);
    };
}
module.exports.storeSimpleLibrary = $8669c036ca0f03e4$var$storeSimpleLibrary;
module.exports.SimpleLibraryValue = {
    serialize: function(src, builder) {
        $8669c036ca0f03e4$var$storeSimpleLibrary(src)(builder);
    },
    parse: function(src) {
        return $8669c036ca0f03e4$var$loadSimpleLibrary(src);
    }
};

});

parcelRequire.register("kAHnR", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeTickTock = module.exports.loadTickTock = void 0;
function $efd8d28d18ac4d3b$var$loadTickTock(slice) {
    return {
        tick: slice.loadBit(),
        tock: slice.loadBit()
    };
}
module.exports.loadTickTock = $efd8d28d18ac4d3b$var$loadTickTock;
function $efd8d28d18ac4d3b$var$storeTickTock(src) {
    return function(builder) {
        builder.storeBit(src.tick);
        builder.storeBit(src.tock);
    };
}
module.exports.storeTickTock = $efd8d28d18ac4d3b$var$storeTickTock;

});



parcelRequire.register("a2rnx", function(module, exports) {

var $fLnyw = parcelRequire("fLnyw");
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseTuple = module.exports.serializeTuple = void 0;

var $hARf4 = parcelRequire("hARf4");
var $74ef5417feb55b02$var$INT64_MIN = BigInt("-9223372036854775808");
var $74ef5417feb55b02$var$INT64_MAX = BigInt("9223372036854775807");
// vm_stk_null#00 = VmStackValue;
// vm_stk_tinyint#01 value:int64 = VmStackValue;
// vm_stk_int#0201_ value:int257 = VmStackValue;
// vm_stk_nan#02ff = VmStackValue;
// vm_stk_cell#03 cell:^Cell = VmStackValue;
//_ cell:^Cell st_bits:(## 10) end_bits:(## 10) { st_bits <= end_bits }
//   st_ref:(#<= 4) end_ref:(#<= 4) { st_ref <= end_ref } = VmCellSlice;
// vm_stk_slice#04 _:VmCellSlice = VmStackValue;
// vm_stk_builder#05 cell:^Cell = VmStackValue;
// vm_stk_cont#06 cont:VmCont = VmStackValue;
// vm_tupref_nil$_ = VmTupleRef 0;
// vm_tupref_single$_ entry:^VmStackValue = VmTupleRef 1;
// vm_tupref_any$_ {n:#} ref:^(VmTuple (n + 2)) = VmTupleRef (n + 2);
// vm_tuple_nil$_ = VmTuple 0;
// vm_tuple_tcons$_ {n:#} head:(VmTupleRef n) tail:^VmStackValue = VmTuple (n + 1);
// vm_stk_tuple#07 len:(## 16) data:(VmTuple len) = VmStackValue;
function $74ef5417feb55b02$var$serializeTupleItem(src, builder) {
    if (src.type === "null") builder.storeUint(0x00, 8);
    else if (src.type === "int") {
        if (src.value <= $74ef5417feb55b02$var$INT64_MAX && src.value >= $74ef5417feb55b02$var$INT64_MIN) {
            builder.storeUint(0x01, 8);
            builder.storeInt(src.value, 64);
        } else {
            builder.storeUint(0x0100, 15);
            builder.storeInt(src.value, 257);
        }
    } else if (src.type === "nan") builder.storeInt(0x02ff, 16);
    else if (src.type === "cell") {
        builder.storeUint(0x03, 8);
        builder.storeRef(src.cell);
    } else if (src.type === "slice") {
        builder.storeUint(0x04, 8);
        builder.storeUint(0, 10);
        builder.storeUint(src.cell.bits.length, 10);
        builder.storeUint(0, 3);
        builder.storeUint(src.cell.refs.length, 3);
        builder.storeRef(src.cell);
    } else if (src.type === "builder") {
        builder.storeUint(0x05, 8);
        builder.storeRef(src.cell);
    } else if (src.type === "tuple") {
        var head = null;
        var tail = null;
        for(var i = 0; i < src.items.length; i++){
            // Swap
            var s = head;
            head = tail;
            tail = s;
            if (i > 1) head = (0, $hARf4.beginCell)().storeRef(tail).storeRef(head).endCell();
            var bc = (0, $hARf4.beginCell)();
            $74ef5417feb55b02$var$serializeTupleItem(src.items[i], bc);
            tail = bc.endCell();
        }
        builder.storeUint(0x07, 8);
        builder.storeUint(src.items.length, 16);
        if (head) builder.storeRef(head);
        if (tail) builder.storeRef(tail);
    } else throw Error("Invalid value");
}
function $74ef5417feb55b02$var$parseStackItem(cs) {
    var kind = cs.loadUint(8);
    if (kind === 0) return {
        type: "null"
    };
    else if (kind === 1) return {
        type: "int",
        value: cs.loadIntBig(64)
    };
    else if (kind === 2) {
        if (cs.loadUint(7) === 0) return {
            type: "int",
            value: cs.loadIntBig(257)
        };
        else {
            cs.loadBit(); // must eq 1
            return {
                type: "nan"
            };
        }
    } else if (kind === 3) return {
        type: "cell",
        cell: cs.loadRef()
    };
    else if (kind === 4) {
        var startBits = cs.loadUint(10);
        var endBits = cs.loadUint(10);
        var startRefs = cs.loadUint(3);
        var endRefs = cs.loadUint(3);
        // Copy to new cell
        var rs = cs.loadRef().beginParse();
        rs.skip(startBits);
        var dt = rs.loadBits(endBits - startBits);
        var builder = (0, $hARf4.beginCell)().storeBits(dt);
        // Copy refs if exist
        if (startRefs < endRefs) {
            for(var i = 0; i < startRefs; i++)rs.loadRef();
            for(var i1 = 0; i1 < endRefs - startRefs; i1++)builder.storeRef(rs.loadRef());
        }
        return {
            type: "slice",
            cell: builder.endCell()
        };
    } else if (kind === 5) return {
        type: "builder",
        cell: cs.loadRef()
    };
    else if (kind === 7) {
        var length = cs.loadUint(16);
        var items = [];
        if (length > 1) {
            var head = cs.loadRef().beginParse();
            var tail = cs.loadRef().beginParse();
            items.unshift($74ef5417feb55b02$var$parseStackItem(tail));
            for(var i2 = 0; i2 < length - 2; i2++){
                var ohead = head;
                head = ohead.loadRef().beginParse();
                tail = ohead.loadRef().beginParse();
                items.unshift($74ef5417feb55b02$var$parseStackItem(tail));
            }
            items.unshift($74ef5417feb55b02$var$parseStackItem(head));
        } else if (length === 1) items.push($74ef5417feb55b02$var$parseStackItem(cs.loadRef().beginParse()));
        return {
            type: "tuple",
            items: items
        };
    } else throw Error("Unsupported stack item");
}
//
// Stack parsing
// Source: https://github.com/ton-foundation/ton/blob/ae5c0720143e231c32c3d2034cfe4e533a16d969/crypto/block/block.tlb#L783
//
// vm_stack#_ depth:(## 24) stack:(VmStackList depth) = VmStack;
// vm_stk_cons#_ {n:#} rest:^(VmStackList n) tos:VmStackValue = VmStackList (n + 1);
// vm_stk_nil#_ = VmStackList 0;
//
function $74ef5417feb55b02$var$serializeTupleTail(src, builder) {
    if (src.length > 0) {
        // rest:^(VmStackList n)
        var tail = (0, $hARf4.beginCell)();
        $74ef5417feb55b02$var$serializeTupleTail(src.slice(0, src.length - 1), tail);
        builder.storeRef(tail.endCell());
        // tos
        $74ef5417feb55b02$var$serializeTupleItem(src[src.length - 1], builder);
    }
}
function $74ef5417feb55b02$var$serializeTuple(src) {
    var builder = (0, $hARf4.beginCell)();
    builder.storeUint(src.length, 24);
    var r = (0, $fLnyw._)(src);
    $74ef5417feb55b02$var$serializeTupleTail(r, builder);
    return builder.endCell();
}
module.exports.serializeTuple = $74ef5417feb55b02$var$serializeTuple;
function $74ef5417feb55b02$var$parseTuple(src) {
    var res = [];
    var cs = src.beginParse();
    var size = cs.loadUint(24);
    for(var i = 0; i < size; i++){
        var next = cs.loadRef();
        res.unshift($74ef5417feb55b02$var$parseStackItem(cs));
        cs = next.beginParse();
    }
    return res;
}
module.exports.parseTuple = $74ef5417feb55b02$var$parseTuple;

});

parcelRequire.register("hkXnX", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $fLnyw = parcelRequire("fLnyw");
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TupleReader = void 0;
var $c9f25ea670711570$var$TupleReader = /*#__PURE__*/ function() {
    function TupleReader(items) {
        (0, $978gY._)(this, TupleReader);
        this.items = (0, $fLnyw._)(items);
    }
    (0, $kry2a._)(TupleReader, [
        {
            key: "remaining",
            get: function get() {
                return this.items.length;
            }
        },
        {
            key: "peek",
            value: function peek() {
                if (this.items.length === 0) throw Error("EOF");
                return this.items[0];
            }
        },
        {
            key: "pop",
            value: function pop() {
                if (this.items.length === 0) throw Error("EOF");
                var res = this.items[0];
                this.items.splice(0, 1);
                return res;
            }
        },
        {
            key: "skip",
            value: function skip() {
                var num = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                for(var i = 0; i < num; i++)this.pop();
                return this;
            }
        },
        {
            key: "readBigNumber",
            value: function readBigNumber() {
                var popped = this.pop();
                if (popped.type !== "int") throw Error("Not a number");
                return popped.value;
            }
        },
        {
            key: "readBigNumberOpt",
            value: function readBigNumberOpt() {
                var popped = this.pop();
                if (popped.type === "null") return null;
                if (popped.type !== "int") throw Error("Not a number");
                return popped.value;
            }
        },
        {
            key: "readNumber",
            value: function readNumber() {
                return Number(this.readBigNumber());
            }
        },
        {
            key: "readNumberOpt",
            value: function readNumberOpt() {
                var r = this.readBigNumberOpt();
                if (r !== null) return Number(r);
                else return null;
            }
        },
        {
            key: "readBoolean",
            value: function readBoolean() {
                var res = this.readNumber();
                return res === 0 ? false : true;
            }
        },
        {
            key: "readBooleanOpt",
            value: function readBooleanOpt() {
                var res = this.readNumberOpt();
                if (res !== null) return res === 0 ? false : true;
                else return null;
            }
        },
        {
            key: "readAddress",
            value: function readAddress() {
                var r = this.readCell().beginParse().loadAddress();
                if (r !== null) return r;
                else throw Error("Not an address");
            }
        },
        {
            key: "readAddressOpt",
            value: function readAddressOpt() {
                var r = this.readCellOpt();
                if (r !== null) return r.beginParse().loadMaybeAddress();
                else return null;
            }
        },
        {
            key: "readCell",
            value: function readCell() {
                var popped = this.pop();
                if (popped.type !== "cell" && popped.type !== "slice" && popped.type !== "builder") throw Error("Not a cell: " + popped.type);
                return popped.cell;
            }
        },
        {
            key: "readCellOpt",
            value: function readCellOpt() {
                var popped = this.pop();
                if (popped.type === "null") return null;
                if (popped.type !== "cell" && popped.type !== "slice" && popped.type !== "builder") throw Error("Not a cell");
                return popped.cell;
            }
        },
        {
            key: "readTuple",
            value: function readTuple() {
                var popped = this.pop();
                if (popped.type !== "tuple") throw Error("Not a number");
                return new TupleReader(popped.items);
            }
        },
        {
            key: "readTupleOpt",
            value: function readTupleOpt() {
                var popped = this.pop();
                if (popped.type === "null") return null;
                if (popped.type !== "tuple") throw Error("Not a number");
                return new TupleReader(popped.items);
            }
        },
        {
            key: "readBuffer",
            value: function readBuffer() {
                var s = this.readCell().beginParse();
                if (s.remainingRefs !== 0) throw Error("Not a buffer");
                if (s.remainingBits % 8 !== 0) throw Error("Not a buffer");
                return s.loadBuffer(s.remainingBits / 8);
            }
        },
        {
            key: "readBufferOpt",
            value: function readBufferOpt() {
                var popped = this.peek();
                if (popped.type === "null") return null;
                var s = this.readCell().beginParse();
                if (s.remainingRefs !== 0) throw Error("Not a buffer");
                if (s.remainingBits % 8 !== 0) throw Error("Not a buffer");
                return s.loadBuffer(s.remainingBits / 8);
            }
        },
        {
            key: "readString",
            value: function readString() {
                var s = this.readCell().beginParse();
                return s.loadStringTail();
            }
        },
        {
            key: "readStringOpt",
            value: function readStringOpt() {
                var popped = this.peek();
                if (popped.type === "null") return null;
                var s = this.readCell().beginParse();
                return s.loadStringTail();
            }
        }
    ]);
    return TupleReader;
}();
module.exports.TupleReader = $c9f25ea670711570$var$TupleReader;

});

parcelRequire.register("ghBQq", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $fLnyw = parcelRequire("fLnyw");
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TupleBuilder = void 0;

var $hARf4 = parcelRequire("hARf4");

var $KH51V = parcelRequire("KH51V");

var $aQ0oy = parcelRequire("aQ0oy");
var $bdab9702b107f0e7$var$TupleBuilder = /*#__PURE__*/ function() {
    function TupleBuilder() {
        (0, $978gY._)(this, TupleBuilder);
        this._tuple = [];
    }
    (0, $kry2a._)(TupleBuilder, [
        {
            key: "writeNumber",
            value: function writeNumber(v) {
                if (v === null || v === undefined) this._tuple.push({
                    type: "null"
                });
                else this._tuple.push({
                    type: "int",
                    value: BigInt(v)
                });
            }
        },
        {
            key: "writeBoolean",
            value: function writeBoolean(v) {
                if (v === null || v === undefined) this._tuple.push({
                    type: "null"
                });
                else this._tuple.push({
                    type: "int",
                    value: v ? -1n : 0n
                });
            }
        },
        {
            key: "writeBuffer",
            value: function writeBuffer(v) {
                if (v === null || v === undefined) this._tuple.push({
                    type: "null"
                });
                else this._tuple.push({
                    type: "slice",
                    cell: (0, $hARf4.beginCell)().storeBuffer(v).endCell()
                });
            }
        },
        {
            key: "writeString",
            value: function writeString(v) {
                if (v === null || v === undefined) this._tuple.push({
                    type: "null"
                });
                else this._tuple.push({
                    type: "slice",
                    cell: (0, $hARf4.beginCell)().storeStringTail(v).endCell()
                });
            }
        },
        {
            key: "writeCell",
            value: function writeCell(v) {
                if (v === null || v === undefined) this._tuple.push({
                    type: "null"
                });
                else {
                    if (v instanceof $KH51V.Cell) this._tuple.push({
                        type: "cell",
                        cell: v
                    });
                    else if (v instanceof $aQ0oy.Slice) this._tuple.push({
                        type: "cell",
                        cell: v.asCell()
                    });
                }
            }
        },
        {
            key: "writeSlice",
            value: function writeSlice(v) {
                if (v === null || v === undefined) this._tuple.push({
                    type: "null"
                });
                else {
                    if (v instanceof $KH51V.Cell) this._tuple.push({
                        type: "slice",
                        cell: v
                    });
                    else if (v instanceof $aQ0oy.Slice) this._tuple.push({
                        type: "slice",
                        cell: v.asCell()
                    });
                }
            }
        },
        {
            key: "writeBuilder",
            value: function writeBuilder(v) {
                if (v === null || v === undefined) this._tuple.push({
                    type: "null"
                });
                else {
                    if (v instanceof $KH51V.Cell) this._tuple.push({
                        type: "builder",
                        cell: v
                    });
                    else if (v instanceof $aQ0oy.Slice) this._tuple.push({
                        type: "builder",
                        cell: v.asCell()
                    });
                }
            }
        },
        {
            key: "writeTuple",
            value: function writeTuple(v) {
                if (v === null || v === undefined) this._tuple.push({
                    type: "null"
                });
                else this._tuple.push({
                    type: "tuple",
                    items: v
                });
            }
        },
        {
            key: "writeAddress",
            value: function writeAddress(v) {
                if (v === null || v === undefined) this._tuple.push({
                    type: "null"
                });
                else this._tuple.push({
                    type: "slice",
                    cell: (0, $hARf4.beginCell)().storeAddress(v).endCell()
                });
            }
        },
        {
            key: "build",
            value: function build() {
                return (0, $fLnyw._)(this._tuple);
            }
        }
    ]);
    return TupleBuilder;
}();
module.exports.TupleBuilder = $bdab9702b107f0e7$var$TupleBuilder;

});

parcelRequire.register("1NjXW", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.loadStorageUsedShort = module.exports.storeStorageUsed = module.exports.loadStorageUsed = module.exports.storeStorageInfo = module.exports.loadStorageInfo = module.exports.storeStateInit = module.exports.loadStateInit = module.exports.storeSplitMergeInfo = module.exports.loadSplitMergeInfo = module.exports.storeSimpleLibrary = module.exports.loadSimpleLibrary = module.exports.loadShardStateUnsplit = module.exports.storeShardIdent = module.exports.loadShardIdent = module.exports.storeShardAccounts = module.exports.loadShardAccounts = module.exports.ShardAccountRefValue = module.exports.storeShardAccount = module.exports.loadShardAccount = module.exports.SendMode = module.exports.storeMessageRelaxed = module.exports.loadMessageRelaxed = module.exports.storeMessage = module.exports.loadMessage = module.exports.loadMasterchainStateExtra = module.exports.storeHashUpdate = module.exports.loadHashUpdate = module.exports.storeDepthBalanceInfo = module.exports.loadDepthBalanceInfo = module.exports.storeCurrencyCollection = module.exports.loadCurrencyCollection = module.exports.storeComputeSkipReason = module.exports.loadComputeSkipReason = module.exports.storeCommonMessageInfoRelaxed = module.exports.loadCommonMessageInfoRelaxed = module.exports.storeCommonMessageInfo = module.exports.loadCommonMessageInfo = module.exports.storeAccountStorage = module.exports.loadAccountStorage = module.exports.storeAccountStatusChange = module.exports.loadAccountStatusChange = module.exports.storeAccountStatus = module.exports.loadAccountStatus = module.exports.storeAccountState = module.exports.loadAccountState = module.exports.storeAccount = module.exports.loadAccount = module.exports.comment = module.exports.external = module.exports.internal = void 0;
module.exports.storeTransactionsStoragePhase = module.exports.loadTransactionStoragePhase = module.exports.storeTransactionDescription = module.exports.loadTransactionDescription = module.exports.storeTransactionCreditPhase = module.exports.loadTransactionCreditPhase = module.exports.storeTransactionComputePhase = module.exports.loadTransactionComputePhase = module.exports.storeTransactionBouncePhase = module.exports.loadTransactionBouncePhase = module.exports.storeTransactionActionPhase = module.exports.loadTransactionActionPhase = module.exports.storeTransaction = module.exports.loadTransaction = module.exports.storeTickTock = module.exports.loadTickTock = module.exports.storeStorageUsedShort = void 0;

var $9MNXi = parcelRequire("9MNXi");
Object.defineProperty(module.exports, "internal", {
    enumerable: true,
    get: function get() {
        return $9MNXi.internal;
    }
});
Object.defineProperty(module.exports, "external", {
    enumerable: true,
    get: function get() {
        return $9MNXi.external;
    }
});
Object.defineProperty(module.exports, "comment", {
    enumerable: true,
    get: function get() {
        return $9MNXi.comment;
    }
});

var $cpgYB = parcelRequire("cpgYB");
Object.defineProperty(module.exports, "loadAccount", {
    enumerable: true,
    get: function get() {
        return $cpgYB.loadAccount;
    }
});
Object.defineProperty(module.exports, "storeAccount", {
    enumerable: true,
    get: function get() {
        return $cpgYB.storeAccount;
    }
});

var $jAHrB = parcelRequire("jAHrB");
Object.defineProperty(module.exports, "loadAccountState", {
    enumerable: true,
    get: function get() {
        return $jAHrB.loadAccountState;
    }
});
Object.defineProperty(module.exports, "storeAccountState", {
    enumerable: true,
    get: function get() {
        return $jAHrB.storeAccountState;
    }
});

var $14T4l = parcelRequire("14T4l");
Object.defineProperty(module.exports, "loadAccountStatus", {
    enumerable: true,
    get: function get() {
        return $14T4l.loadAccountStatus;
    }
});
Object.defineProperty(module.exports, "storeAccountStatus", {
    enumerable: true,
    get: function get() {
        return $14T4l.storeAccountStatus;
    }
});

var $8iN6S = parcelRequire("8iN6S");
Object.defineProperty(module.exports, "loadAccountStatusChange", {
    enumerable: true,
    get: function get() {
        return $8iN6S.loadAccountStatusChange;
    }
});
Object.defineProperty(module.exports, "storeAccountStatusChange", {
    enumerable: true,
    get: function get() {
        return $8iN6S.storeAccountStatusChange;
    }
});

var $cOXNK = parcelRequire("cOXNK");
Object.defineProperty(module.exports, "loadAccountStorage", {
    enumerable: true,
    get: function get() {
        return $cOXNK.loadAccountStorage;
    }
});
Object.defineProperty(module.exports, "storeAccountStorage", {
    enumerable: true,
    get: function get() {
        return $cOXNK.storeAccountStorage;
    }
});

var $fsBYg = parcelRequire("fsBYg");
Object.defineProperty(module.exports, "loadCommonMessageInfo", {
    enumerable: true,
    get: function get() {
        return $fsBYg.loadCommonMessageInfo;
    }
});
Object.defineProperty(module.exports, "storeCommonMessageInfo", {
    enumerable: true,
    get: function get() {
        return $fsBYg.storeCommonMessageInfo;
    }
});

var $wzT6b = parcelRequire("wzT6b");
Object.defineProperty(module.exports, "loadCommonMessageInfoRelaxed", {
    enumerable: true,
    get: function get() {
        return $wzT6b.loadCommonMessageInfoRelaxed;
    }
});
Object.defineProperty(module.exports, "storeCommonMessageInfoRelaxed", {
    enumerable: true,
    get: function get() {
        return $wzT6b.storeCommonMessageInfoRelaxed;
    }
});

var $7IZQv = parcelRequire("7IZQv");
Object.defineProperty(module.exports, "loadComputeSkipReason", {
    enumerable: true,
    get: function get() {
        return $7IZQv.loadComputeSkipReason;
    }
});
Object.defineProperty(module.exports, "storeComputeSkipReason", {
    enumerable: true,
    get: function get() {
        return $7IZQv.storeComputeSkipReason;
    }
});

var $92Q5k = parcelRequire("92Q5k");
Object.defineProperty(module.exports, "loadCurrencyCollection", {
    enumerable: true,
    get: function get() {
        return $92Q5k.loadCurrencyCollection;
    }
});
Object.defineProperty(module.exports, "storeCurrencyCollection", {
    enumerable: true,
    get: function get() {
        return $92Q5k.storeCurrencyCollection;
    }
});

var $kOigB = parcelRequire("kOigB");
Object.defineProperty(module.exports, "loadDepthBalanceInfo", {
    enumerable: true,
    get: function get() {
        return $kOigB.loadDepthBalanceInfo;
    }
});
Object.defineProperty(module.exports, "storeDepthBalanceInfo", {
    enumerable: true,
    get: function get() {
        return $kOigB.storeDepthBalanceInfo;
    }
});

var $dp6Tk = parcelRequire("dp6Tk");
Object.defineProperty(module.exports, "loadHashUpdate", {
    enumerable: true,
    get: function get() {
        return $dp6Tk.loadHashUpdate;
    }
});
Object.defineProperty(module.exports, "storeHashUpdate", {
    enumerable: true,
    get: function get() {
        return $dp6Tk.storeHashUpdate;
    }
});

var $f8Y57 = parcelRequire("f8Y57");
Object.defineProperty(module.exports, "loadMasterchainStateExtra", {
    enumerable: true,
    get: function get() {
        return $f8Y57.loadMasterchainStateExtra;
    }
});

var $kxaGd = parcelRequire("kxaGd");
Object.defineProperty(module.exports, "loadMessage", {
    enumerable: true,
    get: function get() {
        return $kxaGd.loadMessage;
    }
});
Object.defineProperty(module.exports, "storeMessage", {
    enumerable: true,
    get: function get() {
        return $kxaGd.storeMessage;
    }
});

var $8WR6r = parcelRequire("8WR6r");
Object.defineProperty(module.exports, "loadMessageRelaxed", {
    enumerable: true,
    get: function get() {
        return $8WR6r.loadMessageRelaxed;
    }
});
Object.defineProperty(module.exports, "storeMessageRelaxed", {
    enumerable: true,
    get: function get() {
        return $8WR6r.storeMessageRelaxed;
    }
});

var $atLYE = parcelRequire("atLYE");
Object.defineProperty(module.exports, "SendMode", {
    enumerable: true,
    get: function get() {
        return $atLYE.SendMode;
    }
});

var $6kUP7 = parcelRequire("6kUP7");
Object.defineProperty(module.exports, "loadShardAccount", {
    enumerable: true,
    get: function get() {
        return $6kUP7.loadShardAccount;
    }
});
Object.defineProperty(module.exports, "storeShardAccount", {
    enumerable: true,
    get: function get() {
        return $6kUP7.storeShardAccount;
    }
});

var $4a9uP = parcelRequire("4a9uP");
Object.defineProperty(module.exports, "ShardAccountRefValue", {
    enumerable: true,
    get: function get() {
        return $4a9uP.ShardAccountRefValue;
    }
});
Object.defineProperty(module.exports, "loadShardAccounts", {
    enumerable: true,
    get: function get() {
        return $4a9uP.loadShardAccounts;
    }
});
Object.defineProperty(module.exports, "storeShardAccounts", {
    enumerable: true,
    get: function get() {
        return $4a9uP.storeShardAccounts;
    }
});

var $iYFiW = parcelRequire("iYFiW");
Object.defineProperty(module.exports, "loadShardIdent", {
    enumerable: true,
    get: function get() {
        return $iYFiW.loadShardIdent;
    }
});
Object.defineProperty(module.exports, "storeShardIdent", {
    enumerable: true,
    get: function get() {
        return $iYFiW.storeShardIdent;
    }
});

var $e2MUM = parcelRequire("e2MUM");
Object.defineProperty(module.exports, "loadShardStateUnsplit", {
    enumerable: true,
    get: function get() {
        return $e2MUM.loadShardStateUnsplit;
    }
});

var $bxtCm = parcelRequire("bxtCm");
Object.defineProperty(module.exports, "loadSimpleLibrary", {
    enumerable: true,
    get: function get() {
        return $bxtCm.loadSimpleLibrary;
    }
});
Object.defineProperty(module.exports, "storeSimpleLibrary", {
    enumerable: true,
    get: function get() {
        return $bxtCm.storeSimpleLibrary;
    }
});

var $aXgYN = parcelRequire("aXgYN");
Object.defineProperty(module.exports, "loadSplitMergeInfo", {
    enumerable: true,
    get: function get() {
        return $aXgYN.loadSplitMergeInfo;
    }
});
Object.defineProperty(module.exports, "storeSplitMergeInfo", {
    enumerable: true,
    get: function get() {
        return $aXgYN.storeSplitMergeInfo;
    }
});

var $49zOn = parcelRequire("49zOn");
Object.defineProperty(module.exports, "loadStateInit", {
    enumerable: true,
    get: function get() {
        return $49zOn.loadStateInit;
    }
});
Object.defineProperty(module.exports, "storeStateInit", {
    enumerable: true,
    get: function get() {
        return $49zOn.storeStateInit;
    }
});

var $2OrrY = parcelRequire("2OrrY");
Object.defineProperty(module.exports, "loadStorageInfo", {
    enumerable: true,
    get: function get() {
        return $2OrrY.loadStorageInfo;
    }
});
Object.defineProperty(module.exports, "storeStorageInfo", {
    enumerable: true,
    get: function get() {
        return $2OrrY.storeStorageInfo;
    }
});

var $djAa8 = parcelRequire("djAa8");
Object.defineProperty(module.exports, "loadStorageUsed", {
    enumerable: true,
    get: function get() {
        return $djAa8.loadStorageUsed;
    }
});
Object.defineProperty(module.exports, "storeStorageUsed", {
    enumerable: true,
    get: function get() {
        return $djAa8.storeStorageUsed;
    }
});

var $5upht = parcelRequire("5upht");
Object.defineProperty(module.exports, "loadStorageUsedShort", {
    enumerable: true,
    get: function get() {
        return $5upht.loadStorageUsedShort;
    }
});
Object.defineProperty(module.exports, "storeStorageUsedShort", {
    enumerable: true,
    get: function get() {
        return $5upht.storeStorageUsedShort;
    }
});

var $kAHnR = parcelRequire("kAHnR");
Object.defineProperty(module.exports, "loadTickTock", {
    enumerable: true,
    get: function get() {
        return $kAHnR.loadTickTock;
    }
});
Object.defineProperty(module.exports, "storeTickTock", {
    enumerable: true,
    get: function get() {
        return $kAHnR.storeTickTock;
    }
});

var $5mIUV = parcelRequire("5mIUV");
Object.defineProperty(module.exports, "loadTransaction", {
    enumerable: true,
    get: function get() {
        return $5mIUV.loadTransaction;
    }
});
Object.defineProperty(module.exports, "storeTransaction", {
    enumerable: true,
    get: function get() {
        return $5mIUV.storeTransaction;
    }
});

var $ebLPz = parcelRequire("ebLPz");
Object.defineProperty(module.exports, "loadTransactionActionPhase", {
    enumerable: true,
    get: function get() {
        return $ebLPz.loadTransactionActionPhase;
    }
});
Object.defineProperty(module.exports, "storeTransactionActionPhase", {
    enumerable: true,
    get: function get() {
        return $ebLPz.storeTransactionActionPhase;
    }
});

var $4oz91 = parcelRequire("4oz91");
Object.defineProperty(module.exports, "loadTransactionBouncePhase", {
    enumerable: true,
    get: function get() {
        return $4oz91.loadTransactionBouncePhase;
    }
});
Object.defineProperty(module.exports, "storeTransactionBouncePhase", {
    enumerable: true,
    get: function get() {
        return $4oz91.storeTransactionBouncePhase;
    }
});

var $3GHC2 = parcelRequire("3GHC2");
Object.defineProperty(module.exports, "loadTransactionComputePhase", {
    enumerable: true,
    get: function get() {
        return $3GHC2.loadTransactionComputePhase;
    }
});
Object.defineProperty(module.exports, "storeTransactionComputePhase", {
    enumerable: true,
    get: function get() {
        return $3GHC2.storeTransactionComputePhase;
    }
});

var $bD890 = parcelRequire("bD890");
Object.defineProperty(module.exports, "loadTransactionCreditPhase", {
    enumerable: true,
    get: function get() {
        return $bD890.loadTransactionCreditPhase;
    }
});
Object.defineProperty(module.exports, "storeTransactionCreditPhase", {
    enumerable: true,
    get: function get() {
        return $bD890.storeTransactionCreditPhase;
    }
});

var $cFywm = parcelRequire("cFywm");
Object.defineProperty(module.exports, "loadTransactionDescription", {
    enumerable: true,
    get: function get() {
        return $cFywm.loadTransactionDescription;
    }
});
Object.defineProperty(module.exports, "storeTransactionDescription", {
    enumerable: true,
    get: function get() {
        return $cFywm.storeTransactionDescription;
    }
});

var $fBSvD = parcelRequire("fBSvD");
Object.defineProperty(module.exports, "loadTransactionStoragePhase", {
    enumerable: true,
    get: function get() {
        return $fBSvD.loadTransactionStoragePhase;
    }
});
Object.defineProperty(module.exports, "storeTransactionsStoragePhase", {
    enumerable: true,
    get: function get() {
        return $fBSvD.storeTransactionsStoragePhase;
    }
});

});
parcelRequire.register("9MNXi", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.comment = module.exports.external = module.exports.internal = void 0;

var $gUPfK = parcelRequire("gUPfK");

var $KH51V = parcelRequire("KH51V");

var $hARf4 = parcelRequire("hARf4");

var $inRmI = parcelRequire("inRmI");
function $71ff58d98cfa5f1a$var$internal(src) {
    // Resolve bounce
    var bounce = true;
    if (src.bounce !== null && src.bounce !== undefined) bounce = src.bounce;
    // Resolve address
    var to;
    if (typeof src.to === "string") to = $gUPfK.Address.parse(src.to);
    else if ($gUPfK.Address.isAddress(src.to)) to = src.to;
    else throw new Error("Invalid address ".concat(src.to));
    // Resolve value
    var value;
    if (typeof src.value === "string") value = (0, $inRmI.toNano)(src.value);
    else value = src.value;
    // Resolve body
    var body = $KH51V.Cell.EMPTY;
    if (typeof src.body === "string") body = (0, $hARf4.beginCell)().storeUint(0, 32).storeStringTail(src.body).endCell();
    else if (src.body) body = src.body;
    // Create message
    return {
        info: {
            type: "internal",
            dest: to,
            value: {
                coins: value
            },
            bounce: bounce,
            ihrDisabled: true,
            bounced: false,
            ihrFee: 0n,
            forwardFee: 0n,
            createdAt: 0,
            createdLt: 0n
        },
        init: src.init ? {
            code: src.init.code,
            data: src.init.data
        } : undefined,
        body: body
    };
}
module.exports.internal = $71ff58d98cfa5f1a$var$internal;
function $71ff58d98cfa5f1a$var$external(src) {
    // Resolve address
    var to;
    if (typeof src.to === "string") to = $gUPfK.Address.parse(src.to);
    else if ($gUPfK.Address.isAddress(src.to)) to = src.to;
    else throw new Error("Invalid address ".concat(src.to));
    return {
        info: {
            type: "external-in",
            dest: to,
            importFee: 0n
        },
        init: src.init ? {
            code: src.init.code,
            data: src.init.data
        } : undefined,
        body: src.body || $KH51V.Cell.EMPTY
    };
}
module.exports.external = $71ff58d98cfa5f1a$var$external;
function $71ff58d98cfa5f1a$var$comment(src) {
    return (0, $hARf4.beginCell)().storeUint(0, 32).storeStringTail(src).endCell();
}
module.exports.comment = $71ff58d98cfa5f1a$var$comment;

});
parcelRequire.register("inRmI", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromNano = module.exports.toNano = void 0;
function $d623c53b2fde309d$var$toNano(src) {
    if ((typeof src === "undefined" ? "undefined" : (0, $1ObTH._)(src)) === "bigint") return src * 1000000000n;
    else if (typeof src === "number") return BigInt(src) * 1000000000n;
    else {
        // Check sign
        var neg = false;
        while(src.startsWith("-")){
            neg = !neg;
            src = src.slice(1);
        }
        // Split string
        if (src === ".") throw Error("Invalid number");
        var parts = src.split(".");
        if (parts.length > 2) throw Error("Invalid number");
        // Prepare parts
        var whole = parts[0];
        var frac = parts[1];
        if (!whole) whole = "0";
        if (!frac) frac = "0";
        if (frac.length > 9) throw Error("Invalid number");
        while(frac.length < 9)frac += "0";
        // Convert
        var r = BigInt(whole) * 1000000000n + BigInt(frac);
        if (neg) r = -r;
        return r;
    }
}
module.exports.toNano = $d623c53b2fde309d$var$toNano;
function $d623c53b2fde309d$var$fromNano(src) {
    var v = BigInt(src);
    var neg = false;
    if (v < 0) {
        neg = true;
        v = -v;
    }
    // Convert fraction
    var frac = v % 1000000000n;
    var facStr = frac.toString();
    while(facStr.length < 9)facStr = "0" + facStr;
    facStr = facStr.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    // Convert whole
    var whole = v / 1000000000n;
    var wholeStr = whole.toString();
    // Value
    var value = "".concat(wholeStr).concat(facStr === "0" ? "" : ".".concat(facStr));
    if (neg) value = "-" + value;
    return value;
}
module.exports.fromNano = $d623c53b2fde309d$var$fromNano;

});


parcelRequire.register("cpgYB", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeAccount = module.exports.loadAccount = void 0;

var $cOXNK = parcelRequire("cOXNK");

var $2OrrY = parcelRequire("2OrrY");
function $9084fd06fbf7757a$var$loadAccount(slice) {
    return {
        addr: slice.loadAddress(),
        storageStats: (0, $2OrrY.loadStorageInfo)(slice),
        storage: (0, $cOXNK.loadAccountStorage)(slice)
    };
}
module.exports.loadAccount = $9084fd06fbf7757a$var$loadAccount;
function $9084fd06fbf7757a$var$storeAccount(src) {
    return function(builder) {
        builder.storeAddress(src.addr);
        builder.store((0, $2OrrY.storeStorageInfo)(src.storageStats));
        builder.store((0, $cOXNK.storeAccountStorage)(src.storage));
    };
}
module.exports.storeAccount = $9084fd06fbf7757a$var$storeAccount;

});
parcelRequire.register("cOXNK", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeAccountStorage = module.exports.loadAccountStorage = void 0;

var $jAHrB = parcelRequire("jAHrB");

var $92Q5k = parcelRequire("92Q5k");
function $95588ad63eab53ff$var$loadAccountStorage(slice) {
    return {
        lastTransLt: slice.loadUintBig(64),
        balance: (0, $92Q5k.loadCurrencyCollection)(slice),
        state: (0, $jAHrB.loadAccountState)(slice)
    };
}
module.exports.loadAccountStorage = $95588ad63eab53ff$var$loadAccountStorage;
function $95588ad63eab53ff$var$storeAccountStorage(src) {
    return function(builder) {
        builder.storeUint(src.lastTransLt, 64);
        builder.store((0, $92Q5k.storeCurrencyCollection)(src.balance));
        builder.store((0, $jAHrB.storeAccountState)(src.state));
    };
}
module.exports.storeAccountStorage = $95588ad63eab53ff$var$storeAccountStorage;

});
parcelRequire.register("jAHrB", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeAccountState = module.exports.loadAccountState = void 0;

var $49zOn = parcelRequire("49zOn");
function $e433143983590f10$var$loadAccountState(cs) {
    if (cs.loadBit()) return {
        type: "active",
        state: (0, $49zOn.loadStateInit)(cs)
    };
    else if (cs.loadBit()) return {
        type: "frozen",
        stateHash: cs.loadUintBig(256)
    };
    else return {
        type: "uninit"
    };
}
module.exports.loadAccountState = $e433143983590f10$var$loadAccountState;
function $e433143983590f10$var$storeAccountState(src) {
    return function(builder) {
        if (src.type === "active") {
            builder.storeBit(true);
            builder.store((0, $49zOn.storeStateInit)(src.state));
        } else if (src.type === "frozen") {
            builder.storeBit(false);
            builder.storeBit(true);
            builder.storeUint(src.stateHash, 256);
        } else if (src.type === "uninit") {
            builder.storeBit(false);
            builder.storeBit(false);
        }
    };
}
module.exports.storeAccountState = $e433143983590f10$var$storeAccountState;

});

parcelRequire.register("92Q5k", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeCurrencyCollection = module.exports.loadCurrencyCollection = void 0;

var $ihDv0 = parcelRequire("ihDv0");
function $695cb3f4a4f7df3a$var$loadCurrencyCollection(slice) {
    var coins = slice.loadCoins();
    var other = slice.loadDict($ihDv0.Dictionary.Keys.Uint(32), $ihDv0.Dictionary.Values.BigVarUint(5 /* log2(32) */ ));
    if (other.size === 0) return {
        coins: coins
    };
    else return {
        other: other,
        coins: coins
    };
}
module.exports.loadCurrencyCollection = $695cb3f4a4f7df3a$var$loadCurrencyCollection;
function $695cb3f4a4f7df3a$var$storeCurrencyCollection(collection) {
    return function(builder) {
        builder.storeCoins(collection.coins);
        if (collection.other) builder.storeDict(collection.other);
        else builder.storeBit(0);
    };
}
module.exports.storeCurrencyCollection = $695cb3f4a4f7df3a$var$storeCurrencyCollection;

});


parcelRequire.register("2OrrY", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeStorageInfo = module.exports.loadStorageInfo = void 0;

var $djAa8 = parcelRequire("djAa8");
function $20c58b5666d090e9$var$loadStorageInfo(slice) {
    return {
        used: (0, $djAa8.loadStorageUsed)(slice),
        lastPaid: slice.loadUint(32),
        duePayment: slice.loadMaybeCoins()
    };
}
module.exports.loadStorageInfo = $20c58b5666d090e9$var$loadStorageInfo;
function $20c58b5666d090e9$var$storeStorageInfo(src) {
    return function(builder) {
        builder.store((0, $djAa8.storeStorageUsed)(src.used));
        builder.storeUint(src.lastPaid, 32);
        builder.storeMaybeCoins(src.duePayment);
    };
}
module.exports.storeStorageInfo = $20c58b5666d090e9$var$storeStorageInfo;

});
parcelRequire.register("djAa8", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeStorageUsed = module.exports.loadStorageUsed = void 0;
function $9b1919d06d9c433c$var$loadStorageUsed(cs) {
    return {
        cells: cs.loadVarUintBig(3),
        bits: cs.loadVarUintBig(3),
        publicCells: cs.loadVarUintBig(3)
    };
}
module.exports.loadStorageUsed = $9b1919d06d9c433c$var$loadStorageUsed;
function $9b1919d06d9c433c$var$storeStorageUsed(src) {
    return function(builder) {
        builder.storeVarUint(src.cells, 3);
        builder.storeVarUint(src.bits, 3);
        builder.storeVarUint(src.publicCells, 3);
    };
}
module.exports.storeStorageUsed = $9b1919d06d9c433c$var$storeStorageUsed;

});



parcelRequire.register("14T4l", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeAccountStatus = module.exports.loadAccountStatus = void 0;
/**
 * Load account state from slice
 * @param slice
 * @returns AccountState
 */ function $0c90e1bc3d6287b1$var$loadAccountStatus(slice) {
    var status = slice.loadUint(2);
    if (status === 0x00) return "uninitialized";
    if (status === 0x01) return "frozen";
    if (status === 0x02) return "active";
    if (status === 0x03) return "non-existing";
    throw Error("Invalid data");
}
module.exports.loadAccountStatus = $0c90e1bc3d6287b1$var$loadAccountStatus;
/**
 * Store account state to builder
 * @param src account state
 * @param builder buidler
 */ function $0c90e1bc3d6287b1$var$storeAccountStatus(src) {
    return function(builder) {
        if (src === "uninitialized") builder.storeUint(0x00, 2);
        else if (src === "frozen") builder.storeUint(0x01, 2);
        else if (src === "active") builder.storeUint(0x02, 2);
        else if (src === "non-existing") builder.storeUint(0x03, 2);
        else throw Error("Invalid data");
        return builder;
    };
}
module.exports.storeAccountStatus = $0c90e1bc3d6287b1$var$storeAccountStatus;

});

parcelRequire.register("8iN6S", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeAccountStatusChange = module.exports.loadAccountStatusChange = void 0;
function $60b6196138dcf945$var$loadAccountStatusChange(slice) {
    if (!slice.loadBit()) return "unchanged";
    if (slice.loadBit()) return "frozen";
    else return "deleted";
}
module.exports.loadAccountStatusChange = $60b6196138dcf945$var$loadAccountStatusChange;
function $60b6196138dcf945$var$storeAccountStatusChange(src) {
    return function(builder) {
        if (src == "unchanged") builder.storeBit(0);
        else if (src === "frozen") {
            builder.storeBit(1);
            builder.storeBit(0);
        } else if (src === "deleted") {
            builder.storeBit(1);
            builder.storeBit(1);
        } else throw Error("Invalid account status change");
    };
}
module.exports.storeAccountStatusChange = $60b6196138dcf945$var$storeAccountStatusChange;

});

parcelRequire.register("fsBYg", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeCommonMessageInfo = module.exports.loadCommonMessageInfo = void 0;

var $92Q5k = parcelRequire("92Q5k");
function $b416eccdfea3c331$var$loadCommonMessageInfo(slice) {
    // Internal message
    if (!slice.loadBit()) {
        var ihrDisabled = slice.loadBit();
        var bounce = slice.loadBit();
        var bounced = slice.loadBit();
        var src = slice.loadAddress();
        var dest = slice.loadAddress();
        var value = (0, $92Q5k.loadCurrencyCollection)(slice);
        var ihrFee = slice.loadCoins();
        var forwardFee = slice.loadCoins();
        var createdLt = slice.loadUintBig(64);
        var createdAt = slice.loadUint(32);
        return {
            type: "internal",
            ihrDisabled: ihrDisabled,
            bounce: bounce,
            bounced: bounced,
            src: src,
            dest: dest,
            value: value,
            ihrFee: ihrFee,
            forwardFee: forwardFee,
            createdLt: createdLt,
            createdAt: createdAt
        };
    }
    // External In mesage
    if (!slice.loadBit()) {
        var src1 = slice.loadMaybeExternalAddress();
        var dest1 = slice.loadAddress();
        var importFee = slice.loadCoins();
        return {
            type: "external-in",
            src: src1,
            dest: dest1,
            importFee: importFee
        };
    }
    // External Out message
    var src2 = slice.loadAddress();
    var dest2 = slice.loadMaybeExternalAddress();
    var createdLt1 = slice.loadUintBig(64);
    var createdAt1 = slice.loadUint(32);
    return {
        type: "external-out",
        src: src2,
        dest: dest2,
        createdLt: createdLt1,
        createdAt: createdAt1
    };
}
module.exports.loadCommonMessageInfo = $b416eccdfea3c331$var$loadCommonMessageInfo;
function $b416eccdfea3c331$var$storeCommonMessageInfo(source) {
    return function(builder) {
        if (source.type === "internal") {
            builder.storeBit(0);
            builder.storeBit(source.ihrDisabled);
            builder.storeBit(source.bounce);
            builder.storeBit(source.bounced);
            builder.storeAddress(source.src);
            builder.storeAddress(source.dest);
            builder.store((0, $92Q5k.storeCurrencyCollection)(source.value));
            builder.storeCoins(source.ihrFee);
            builder.storeCoins(source.forwardFee);
            builder.storeUint(source.createdLt, 64);
            builder.storeUint(source.createdAt, 32);
        } else if (source.type === "external-in") {
            builder.storeBit(1);
            builder.storeBit(0);
            builder.storeAddress(source.src);
            builder.storeAddress(source.dest);
            builder.storeCoins(source.importFee);
        } else if (source.type === "external-out") {
            builder.storeBit(1);
            builder.storeBit(1);
            builder.storeAddress(source.src);
            builder.storeAddress(source.dest);
            builder.storeUint(source.createdLt, 64);
            builder.storeUint(source.createdAt, 32);
        } else throw new Error("Unknown CommonMessageInfo type");
    };
}
module.exports.storeCommonMessageInfo = $b416eccdfea3c331$var$storeCommonMessageInfo;

});

parcelRequire.register("wzT6b", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeCommonMessageInfoRelaxed = module.exports.loadCommonMessageInfoRelaxed = void 0;

var $92Q5k = parcelRequire("92Q5k");
function $061ed3d248867c48$var$loadCommonMessageInfoRelaxed(slice) {
    // Internal message
    if (!slice.loadBit()) {
        var ihrDisabled = slice.loadBit();
        var bounce = slice.loadBit();
        var bounced = slice.loadBit();
        var src = slice.loadMaybeAddress();
        var dest = slice.loadAddress();
        var value = (0, $92Q5k.loadCurrencyCollection)(slice);
        var ihrFee = slice.loadCoins();
        var forwardFee = slice.loadCoins();
        var createdLt = slice.loadUintBig(64);
        var createdAt = slice.loadUint(32);
        return {
            type: "internal",
            ihrDisabled: ihrDisabled,
            bounce: bounce,
            bounced: bounced,
            src: src,
            dest: dest,
            value: value,
            ihrFee: ihrFee,
            forwardFee: forwardFee,
            createdLt: createdLt,
            createdAt: createdAt
        };
    }
    // External In mesage
    if (!slice.loadBit()) throw Error("External In message is not possible for CommonMessageInfoRelaxed");
    // External Out message
    var src1 = slice.loadMaybeAddress();
    var dest1 = slice.loadMaybeExternalAddress();
    var createdLt1 = slice.loadUintBig(64);
    var createdAt1 = slice.loadUint(32);
    return {
        type: "external-out",
        src: src1,
        dest: dest1,
        createdLt: createdLt1,
        createdAt: createdAt1
    };
}
module.exports.loadCommonMessageInfoRelaxed = $061ed3d248867c48$var$loadCommonMessageInfoRelaxed;
function $061ed3d248867c48$var$storeCommonMessageInfoRelaxed(source) {
    return function(builder) {
        if (source.type === "internal") {
            builder.storeBit(0);
            builder.storeBit(source.ihrDisabled);
            builder.storeBit(source.bounce);
            builder.storeBit(source.bounced);
            builder.storeAddress(source.src);
            builder.storeAddress(source.dest);
            builder.store((0, $92Q5k.storeCurrencyCollection)(source.value));
            builder.storeCoins(source.ihrFee);
            builder.storeCoins(source.forwardFee);
            builder.storeUint(source.createdLt, 64);
            builder.storeUint(source.createdAt, 32);
        } else if (source.type === "external-out") {
            builder.storeBit(1);
            builder.storeBit(1);
            builder.storeAddress(source.src);
            builder.storeAddress(source.dest);
            builder.storeUint(source.createdLt, 64);
            builder.storeUint(source.createdAt, 32);
        } else throw new Error("Unknown CommonMessageInfo type");
    };
}
module.exports.storeCommonMessageInfoRelaxed = $061ed3d248867c48$var$storeCommonMessageInfoRelaxed;

});

parcelRequire.register("7IZQv", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeComputeSkipReason = module.exports.loadComputeSkipReason = void 0;
function $59fc9dc179383136$var$loadComputeSkipReason(slice) {
    var reason = slice.loadUint(2);
    if (reason === 0x00) return "no-state";
    else if (reason === 0x01) return "bad-state";
    else if (reason === 0x02) return "no-gas";
    throw new Error("Unknown ComputeSkipReason: ".concat(reason));
}
module.exports.loadComputeSkipReason = $59fc9dc179383136$var$loadComputeSkipReason;
function $59fc9dc179383136$var$storeComputeSkipReason(src) {
    return function(builder) {
        if (src === "no-state") builder.storeUint(0x00, 2);
        else if (src === "bad-state") builder.storeUint(0x01, 2);
        else if (src === "no-gas") builder.storeUint(0x02, 2);
        else throw new Error("Unknown ComputeSkipReason: ".concat(src));
    };
}
module.exports.storeComputeSkipReason = $59fc9dc179383136$var$storeComputeSkipReason;

});

parcelRequire.register("kOigB", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeDepthBalanceInfo = module.exports.loadDepthBalanceInfo = void 0;

var $92Q5k = parcelRequire("92Q5k");
function $f266a5905b7b1903$var$loadDepthBalanceInfo(slice) {
    var splitDepth = slice.loadUint(5);
    return {
        splitDepth: splitDepth,
        balance: (0, $92Q5k.loadCurrencyCollection)(slice)
    };
}
module.exports.loadDepthBalanceInfo = $f266a5905b7b1903$var$loadDepthBalanceInfo;
function $f266a5905b7b1903$var$storeDepthBalanceInfo(src) {
    return function(builder) {
        builder.storeUint(src.splitDepth, 5);
        builder.store((0, $92Q5k.storeCurrencyCollection)(src.balance));
    };
}
module.exports.storeDepthBalanceInfo = $f266a5905b7b1903$var$storeDepthBalanceInfo;

});

parcelRequire.register("dp6Tk", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeHashUpdate = module.exports.loadHashUpdate = void 0;
function $9c22f4ab423eacfb$var$loadHashUpdate(slice) {
    if (slice.loadUint(8) !== 0x72) throw Error("Invalid data");
    var oldHash = slice.loadBuffer(32);
    var newHash = slice.loadBuffer(32);
    return {
        oldHash: oldHash,
        newHash: newHash
    };
}
module.exports.loadHashUpdate = $9c22f4ab423eacfb$var$loadHashUpdate;
function $9c22f4ab423eacfb$var$storeHashUpdate(src) {
    return function(builder) {
        builder.storeUint(0x72, 8);
        builder.storeBuffer(src.oldHash);
        builder.storeBuffer(src.newHash);
    };
}
module.exports.storeHashUpdate = $9c22f4ab423eacfb$var$storeHashUpdate;

});

parcelRequire.register("f8Y57", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.loadMasterchainStateExtra = void 0;

var $ihDv0 = parcelRequire("ihDv0");

var $92Q5k = parcelRequire("92Q5k");
function $b06635573d969871$var$loadMasterchainStateExtra(cs) {
    // Check magic
    if (cs.loadUint(16) !== 0xcc26) throw Error("Invalid data");
    // Skip shard_hashes
    if (cs.loadBit()) cs.loadRef();
    // Read config
    var configAddress = cs.loadUintBig(256);
    var config = $ihDv0.Dictionary.load($ihDv0.Dictionary.Keys.Int(32), $ihDv0.Dictionary.Values.Cell(), cs);
    // Rad global balance
    var globalBalance = (0, $92Q5k.loadCurrencyCollection)(cs);
    return {
        config: config,
        configAddress: configAddress,
        globalBalance: globalBalance
    };
}
module.exports.loadMasterchainStateExtra = $b06635573d969871$var$loadMasterchainStateExtra;

});

parcelRequire.register("kxaGd", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MessageValue = module.exports.storeMessage = module.exports.loadMessage = void 0;

var $hARf4 = parcelRequire("hARf4");

var $fsBYg = parcelRequire("fsBYg");

var $49zOn = parcelRequire("49zOn");
function $ef2f2c84b243bae0$var$loadMessage(slice) {
    var info = (0, $fsBYg.loadCommonMessageInfo)(slice);
    var init = null;
    if (slice.loadBit()) {
        if (!slice.loadBit()) init = (0, $49zOn.loadStateInit)(slice);
        else init = (0, $49zOn.loadStateInit)(slice.loadRef().beginParse());
    }
    var body = slice.loadBit() ? slice.loadRef() : slice.asCell();
    return {
        info: info,
        init: init,
        body: body
    };
}
module.exports.loadMessage = $ef2f2c84b243bae0$var$loadMessage;
function $ef2f2c84b243bae0$var$storeMessage(message, opts) {
    return function(builder) {
        // Store CommonMsgInfo
        builder.store((0, $fsBYg.storeCommonMessageInfo)(message.info));
        // Store init
        if (message.init) {
            builder.storeBit(true);
            var initCell = (0, $hARf4.beginCell)().store((0, $49zOn.storeStateInit)(message.init));
            // Check if need to store it in ref
            var needRef = false;
            if (opts && opts.forceRef) needRef = true;
            else if (builder.availableBits - 2 /* At least on byte for ref flag */  >= initCell.bits) needRef = false;
            else needRef = true;
            // Persist init
            if (needRef) {
                builder.storeBit(true);
                builder.storeRef(initCell);
            } else {
                builder.storeBit(false);
                builder.storeBuilder(initCell);
            }
        } else builder.storeBit(false);
        // Store body
        var needRef1 = false;
        if (opts && opts.forceRef) needRef1 = true;
        else if (builder.availableBits - 1 /* At least on byte for ref flag */  >= message.body.bits.length && builder.refs + message.body.refs.length <= 4) needRef1 = false;
        else needRef1 = true;
        if (needRef1) {
            builder.storeBit(true);
            builder.storeRef(message.body);
        } else {
            builder.storeBit(false);
            builder.storeBuilder(message.body.asBuilder());
        }
    };
}
module.exports.storeMessage = $ef2f2c84b243bae0$var$storeMessage;
module.exports.MessageValue = {
    serialize: function(src, builder) {
        builder.storeRef((0, $hARf4.beginCell)().store($ef2f2c84b243bae0$var$storeMessage(src)));
    },
    parse: function(slice) {
        return $ef2f2c84b243bae0$var$loadMessage(slice.loadRef().beginParse());
    }
};

});

parcelRequire.register("8WR6r", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeMessageRelaxed = module.exports.loadMessageRelaxed = void 0;

var $hARf4 = parcelRequire("hARf4");

var $wzT6b = parcelRequire("wzT6b");

var $49zOn = parcelRequire("49zOn");
function $683ceea1babe855f$var$loadMessageRelaxed(slice) {
    var info = (0, $wzT6b.loadCommonMessageInfoRelaxed)(slice);
    var init = null;
    if (slice.loadBit()) {
        if (!slice.loadBit()) init = (0, $49zOn.loadStateInit)(slice);
        else init = (0, $49zOn.loadStateInit)(slice.loadRef().beginParse());
    }
    var body = slice.loadBit() ? slice.loadRef() : slice.asCell();
    return {
        info: info,
        init: init,
        body: body
    };
}
module.exports.loadMessageRelaxed = $683ceea1babe855f$var$loadMessageRelaxed;
function $683ceea1babe855f$var$storeMessageRelaxed(message, opts) {
    return function(builder) {
        // Store CommonMsgInfo
        builder.store((0, $wzT6b.storeCommonMessageInfoRelaxed)(message.info));
        // Store init
        if (message.init) {
            builder.storeBit(true);
            var initCell = (0, $hARf4.beginCell)().store((0, $49zOn.storeStateInit)(message.init));
            // Check if ref is needed
            var needRef = false;
            if (opts && opts.forceRef) needRef = true;
            else if (builder.availableBits - 2 /* At least on byte for ref flag */  >= initCell.bits) needRef = false;
            else needRef = true;
            // Store ref
            if (needRef) {
                builder.storeBit(true);
                builder.storeRef(initCell);
            } else {
                builder.storeBit(false);
                builder.storeBuilder(initCell);
            }
        } else builder.storeBit(false);
        // Store body
        var needRef1 = false;
        if (opts && opts.forceRef) needRef1 = true;
        else if (builder.availableBits - 1 /* At least on byte for ref flag */  >= message.body.bits.length && builder.refs + message.body.refs.length <= 4) needRef1 = false;
        else needRef1 = true;
        if (needRef1) {
            builder.storeBit(true);
            builder.storeRef(message.body);
        } else {
            builder.storeBit(false);
            builder.storeBuilder(message.body.asBuilder());
        }
    };
}
module.exports.storeMessageRelaxed = $683ceea1babe855f$var$storeMessageRelaxed;

});

parcelRequire.register("atLYE", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SendMode = void 0;
var $7a11d413c558cd17$var$SendMode;
(function(SendMode) {
    SendMode[SendMode["CARRY_ALL_REMAINING_BALANCE"] = 128] = "CARRY_ALL_REMAINING_BALANCE";
    SendMode[SendMode["CARRY_ALL_REMAINING_INCOMING_VALUE"] = 64] = "CARRY_ALL_REMAINING_INCOMING_VALUE";
    SendMode[SendMode["DESTROY_ACCOUNT_IF_ZERO"] = 32] = "DESTROY_ACCOUNT_IF_ZERO";
    SendMode[SendMode["PAY_GAS_SEPARATELY"] = 1] = "PAY_GAS_SEPARATELY";
    SendMode[SendMode["IGNORE_ERRORS"] = 2] = "IGNORE_ERRORS";
    SendMode[SendMode["NONE"] = 0] = "NONE";
})($7a11d413c558cd17$var$SendMode = module.exports.SendMode || (module.exports.SendMode = {}));

});

parcelRequire.register("6kUP7", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeShardAccount = module.exports.loadShardAccount = void 0;

var $hARf4 = parcelRequire("hARf4");

var $cpgYB = parcelRequire("cpgYB");
function $49d0b0499329b189$var$loadShardAccount(slice) {
    var accountRef = slice.loadRef();
    var account = undefined;
    if (!accountRef.isExotic) {
        var accountSlice = accountRef.beginParse();
        if (accountSlice.loadBit()) account = (0, $cpgYB.loadAccount)(accountSlice);
    }
    return {
        account: account,
        lastTransactionHash: slice.loadUintBig(256),
        lastTransactionLt: slice.loadUintBig(64)
    };
}
module.exports.loadShardAccount = $49d0b0499329b189$var$loadShardAccount;
function $49d0b0499329b189$var$storeShardAccount(src) {
    return function(builder) {
        if (src.account) builder.storeRef((0, $hARf4.beginCell)().storeBit(true).store((0, $cpgYB.storeAccount)(src.account)));
        else builder.storeRef((0, $hARf4.beginCell)().storeBit(false));
        builder.storeUint(src.lastTransactionHash, 256);
        builder.storeUint(src.lastTransactionLt, 64);
    };
}
module.exports.storeShardAccount = $49d0b0499329b189$var$storeShardAccount;

});

parcelRequire.register("4a9uP", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeShardAccounts = module.exports.loadShardAccounts = module.exports.ShardAccountRefValue = void 0;

var $ihDv0 = parcelRequire("ihDv0");

var $kOigB = parcelRequire("kOigB");

var $6kUP7 = parcelRequire("6kUP7");
module.exports.ShardAccountRefValue = {
    parse: function(cs) {
        var depthBalanceInfo = (0, $kOigB.loadDepthBalanceInfo)(cs);
        var shardAccount = (0, $6kUP7.loadShardAccount)(cs);
        return {
            depthBalanceInfo: depthBalanceInfo,
            shardAccount: shardAccount
        };
    },
    serialize: function(src, builder) {
        builder.store((0, $kOigB.storeDepthBalanceInfo)(src.depthBalanceInfo));
        builder.store((0, $6kUP7.storeShardAccount)(src.shardAccount));
    }
};
function $307f765ad20023ea$var$loadShardAccounts(cs) {
    return $ihDv0.Dictionary.load($ihDv0.Dictionary.Keys.BigUint(256), module.exports.ShardAccountRefValue, cs);
}
module.exports.loadShardAccounts = $307f765ad20023ea$var$loadShardAccounts;
function $307f765ad20023ea$var$storeShardAccounts(src) {
    return function(Builder) {
        Builder.storeDict(src);
    };
}
module.exports.storeShardAccounts = $307f765ad20023ea$var$storeShardAccounts;

});

parcelRequire.register("iYFiW", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeShardIdent = module.exports.loadShardIdent = void 0;
function $dd0dded0b8410737$var$loadShardIdent(slice) {
    if (slice.loadUint(2) !== 0) throw Error("Invalid data");
    return {
        shardPrefixBits: slice.loadUint(6),
        workchainId: slice.loadInt(32),
        shardPrefix: slice.loadUintBig(64)
    };
}
module.exports.loadShardIdent = $dd0dded0b8410737$var$loadShardIdent;
function $dd0dded0b8410737$var$storeShardIdent(src) {
    return function(builder) {
        builder.storeUint(0, 2);
        builder.storeUint(src.shardPrefixBits, 6);
        builder.storeInt(src.workchainId, 32);
        builder.storeUint(src.shardPrefix, 64);
    };
}
module.exports.storeShardIdent = $dd0dded0b8410737$var$storeShardIdent;

});

parcelRequire.register("e2MUM", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.loadShardStateUnsplit = void 0;

var $f8Y57 = parcelRequire("f8Y57");

var $4a9uP = parcelRequire("4a9uP");

var $iYFiW = parcelRequire("iYFiW");
function $a39732106b5ca1da$var$loadShardStateUnsplit(cs) {
    if (cs.loadUint(32) !== 0x9023afe2) throw Error("Invalid data");
    var globalId = cs.loadInt(32);
    var shardId = (0, $iYFiW.loadShardIdent)(cs);
    var seqno = cs.loadUint(32);
    var vertSeqNo = cs.loadUint(32);
    var genUtime = cs.loadUint(32);
    var genLt = cs.loadUintBig(64);
    var minRefMcSeqno = cs.loadUint(32);
    // Skip OutMsgQueueInfo: usually exotic
    cs.loadRef();
    var beforeSplit = cs.loadBit();
    // Parse accounts
    var shardAccountsRef = cs.loadRef();
    var accounts = undefined;
    if (!shardAccountsRef.isExotic) accounts = (0, $4a9uP.loadShardAccounts)(shardAccountsRef.beginParse());
    // Skip (not used by apps)
    cs.loadRef();
    // Parse extras
    var mcStateExtra = cs.loadBit();
    var extras = null;
    if (mcStateExtra) {
        var cell = cs.loadRef();
        if (!cell.isExotic) extras = (0, $f8Y57.loadMasterchainStateExtra)(cell.beginParse());
    }
    return {
        globalId: globalId,
        shardId: shardId,
        seqno: seqno,
        vertSeqNo: vertSeqNo,
        genUtime: genUtime,
        genLt: genLt,
        minRefMcSeqno: minRefMcSeqno,
        beforeSplit: beforeSplit,
        accounts: accounts,
        extras: extras
    };
}
module.exports.loadShardStateUnsplit = $a39732106b5ca1da$var$loadShardStateUnsplit;

});

parcelRequire.register("aXgYN", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeSplitMergeInfo = module.exports.loadSplitMergeInfo = void 0;
function $7f9c95e027bba0f6$var$loadSplitMergeInfo(slice) {
    var currentShardPrefixLength = slice.loadUint(6);
    var accountSplitDepth = slice.loadUint(6);
    var thisAddress = slice.loadUintBig(256);
    var siblingAddress = slice.loadUintBig(256);
    return {
        currentShardPrefixLength: currentShardPrefixLength,
        accountSplitDepth: accountSplitDepth,
        thisAddress: thisAddress,
        siblingAddress: siblingAddress
    };
}
module.exports.loadSplitMergeInfo = $7f9c95e027bba0f6$var$loadSplitMergeInfo;
function $7f9c95e027bba0f6$var$storeSplitMergeInfo(src) {
    return function(builder) {
        builder.storeUint(src.currentShardPrefixLength, 6);
        builder.storeUint(src.accountSplitDepth, 6);
        builder.storeUint(src.thisAddress, 256);
        builder.storeUint(src.siblingAddress, 256);
    };
}
module.exports.storeSplitMergeInfo = $7f9c95e027bba0f6$var$storeSplitMergeInfo;

});

parcelRequire.register("5upht", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeStorageUsedShort = module.exports.loadStorageUsedShort = void 0;
function $3ff35d5c86418dff$var$loadStorageUsedShort(slice) {
    var cells = slice.loadVarUintBig(3);
    var bits = slice.loadVarUintBig(3);
    return {
        cells: cells,
        bits: bits
    };
}
module.exports.loadStorageUsedShort = $3ff35d5c86418dff$var$loadStorageUsedShort;
function $3ff35d5c86418dff$var$storeStorageUsedShort(src) {
    return function(builder) {
        builder.storeVarUint(src.cells, 3);
        builder.storeVarUint(src.bits, 3);
    };
}
module.exports.storeStorageUsedShort = $3ff35d5c86418dff$var$storeStorageUsedShort;

});

parcelRequire.register("5mIUV", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeTransaction = module.exports.loadTransaction = void 0;

var $hARf4 = parcelRequire("hARf4");

var $ihDv0 = parcelRequire("ihDv0");

var $14T4l = parcelRequire("14T4l");

var $92Q5k = parcelRequire("92Q5k");

var $dp6Tk = parcelRequire("dp6Tk");

var $kxaGd = parcelRequire("kxaGd");

var $cFywm = parcelRequire("cFywm");
function $3e81d975c798ae0a$var$loadTransaction(slice) {
    if (slice.loadUint(4) !== 0x07) throw Error("Invalid data");
    var address = slice.loadUintBig(256);
    var lt = slice.loadUintBig(64);
    var prevTransactionHash = slice.loadUintBig(256);
    var prevTransactionLt = slice.loadUintBig(64);
    var now = slice.loadUint(32);
    var outMessagesCount = slice.loadUint(15);
    var oldStatus = (0, $14T4l.loadAccountStatus)(slice);
    var endStatus = (0, $14T4l.loadAccountStatus)(slice);
    var msgRef = slice.loadRef();
    var msgSlice = msgRef.beginParse();
    var inMessage = msgSlice.loadBit() ? (0, $kxaGd.loadMessage)(msgSlice.loadRef().beginParse()) : undefined;
    var outMessages = msgSlice.loadDict($ihDv0.Dictionary.Keys.Uint(15), $kxaGd.MessageValue);
    msgSlice.endParse();
    var totalFees = (0, $92Q5k.loadCurrencyCollection)(slice);
    var stateUpdate = (0, $dp6Tk.loadHashUpdate)(slice.loadRef().beginParse());
    var description = (0, $cFywm.loadTransactionDescription)(slice.loadRef().beginParse());
    return {
        address: address,
        lt: lt,
        prevTransactionHash: prevTransactionHash,
        prevTransactionLt: prevTransactionLt,
        now: now,
        outMessagesCount: outMessagesCount,
        oldStatus: oldStatus,
        endStatus: endStatus,
        inMessage: inMessage,
        outMessages: outMessages,
        totalFees: totalFees,
        stateUpdate: stateUpdate,
        description: description
    };
}
module.exports.loadTransaction = $3e81d975c798ae0a$var$loadTransaction;
function $3e81d975c798ae0a$var$storeTransaction(src) {
    return function(builder) {
        builder.storeUint(0x07, 4);
        builder.storeUint(src.address, 256);
        builder.storeUint(src.lt, 64);
        builder.storeUint(src.prevTransactionHash, 256);
        builder.storeUint(src.prevTransactionLt, 64);
        builder.storeUint(src.now, 32);
        builder.storeUint(src.outMessagesCount, 15);
        builder.store((0, $14T4l.storeAccountStatus)(src.oldStatus));
        builder.store((0, $14T4l.storeAccountStatus)(src.endStatus));
        var msgBuilder = (0, $hARf4.beginCell)();
        if (src.inMessage) {
            msgBuilder.storeBit(true);
            msgBuilder.storeRef((0, $hARf4.beginCell)().store((0, $kxaGd.storeMessage)(src.inMessage)));
        } else msgBuilder.storeBit(false);
        msgBuilder.storeDict(src.outMessages);
        builder.storeRef(msgBuilder);
        builder.store((0, $92Q5k.storeCurrencyCollection)(src.totalFees));
        builder.storeRef((0, $hARf4.beginCell)().store((0, $dp6Tk.storeHashUpdate)(src.stateUpdate)));
        builder.storeRef((0, $hARf4.beginCell)().store((0, $cFywm.storeTransactionDescription)(src.description)));
    };
}
module.exports.storeTransaction = $3e81d975c798ae0a$var$storeTransaction;

});
parcelRequire.register("cFywm", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeTransactionDescription = module.exports.loadTransactionDescription = void 0;

var $hARf4 = parcelRequire("hARf4");

var $aXgYN = parcelRequire("aXgYN");

var $5mIUV = parcelRequire("5mIUV");

var $ebLPz = parcelRequire("ebLPz");

var $4oz91 = parcelRequire("4oz91");

var $3GHC2 = parcelRequire("3GHC2");

var $bD890 = parcelRequire("bD890");

var $fBSvD = parcelRequire("fBSvD");
function $9394177f4463adaa$var$loadTransactionDescription(slice) {
    var type = slice.loadUint(4);
    if (type === 0x00) {
        var creditFirst = slice.loadBit();
        var storagePhase = undefined;
        if (slice.loadBit()) storagePhase = (0, $fBSvD.loadTransactionStoragePhase)(slice);
        var creditPhase = undefined;
        if (slice.loadBit()) creditPhase = (0, $bD890.loadTransactionCreditPhase)(slice);
        var computePhase = (0, $3GHC2.loadTransactionComputePhase)(slice);
        var actionPhase = undefined;
        if (slice.loadBit()) actionPhase = (0, $ebLPz.loadTransactionActionPhase)(slice.loadRef().beginParse());
        var aborted = slice.loadBit();
        var bouncePhase = undefined;
        if (slice.loadBit()) bouncePhase = (0, $4oz91.loadTransactionBouncePhase)(slice);
        var destroyed = slice.loadBit();
        return {
            type: "generic",
            creditFirst: creditFirst,
            storagePhase: storagePhase,
            creditPhase: creditPhase,
            computePhase: computePhase,
            actionPhase: actionPhase,
            bouncePhase: bouncePhase,
            aborted: aborted,
            destroyed: destroyed
        };
    }
    if (type === 0x01) return {
        type: "storage",
        storagePhase: (0, $fBSvD.loadTransactionStoragePhase)(slice)
    };
    if (type === 0x2 || type === 0x03) {
        var isTock = type === 0x03;
        var storagePhase1 = (0, $fBSvD.loadTransactionStoragePhase)(slice);
        var computePhase1 = (0, $3GHC2.loadTransactionComputePhase)(slice);
        var actionPhase1 = undefined;
        if (slice.loadBit()) actionPhase1 = (0, $ebLPz.loadTransactionActionPhase)(slice.loadRef().beginParse());
        var aborted1 = slice.loadBit();
        var destroyed1 = slice.loadBit();
        return {
            type: "tick-tock",
            isTock: isTock,
            storagePhase: storagePhase1,
            computePhase: computePhase1,
            actionPhase: actionPhase1,
            aborted: aborted1,
            destroyed: destroyed1
        };
    }
    if (type === 0x04) {
        var splitInfo = (0, $aXgYN.loadSplitMergeInfo)(slice);
        var storagePhase2 = undefined;
        if (slice.loadBit()) storagePhase2 = (0, $fBSvD.loadTransactionStoragePhase)(slice);
        var computePhase2 = (0, $3GHC2.loadTransactionComputePhase)(slice);
        var actionPhase2 = undefined;
        if (slice.loadBit()) actionPhase2 = (0, $ebLPz.loadTransactionActionPhase)(slice.loadRef().beginParse());
        var aborted2 = slice.loadBit();
        var destroyed2 = slice.loadBit();
        return {
            type: "split-prepare",
            splitInfo: splitInfo,
            storagePhase: storagePhase2,
            computePhase: computePhase2,
            actionPhase: actionPhase2,
            aborted: aborted2,
            destroyed: destroyed2
        };
    }
    if (type === 0x05) {
        var splitInfo1 = (0, $aXgYN.loadSplitMergeInfo)(slice);
        var prepareTransaction = (0, $5mIUV.loadTransaction)(slice.loadRef().beginParse());
        var installed = slice.loadBit();
        return {
            type: "split-install",
            splitInfo: splitInfo1,
            prepareTransaction: prepareTransaction,
            installed: installed
        };
    }
    throw Error("Unsupported transaction description type ".concat(type));
}
module.exports.loadTransactionDescription = $9394177f4463adaa$var$loadTransactionDescription;
function $9394177f4463adaa$var$storeTransactionDescription(src) {
    return function(builder) {
        if (src.type === "generic") {
            builder.storeUint(0x00, 4);
            builder.storeBit(src.creditFirst);
            if (src.storagePhase) {
                builder.storeBit(true);
                builder.store((0, $fBSvD.storeTransactionsStoragePhase)(src.storagePhase));
            } else builder.storeBit(false);
            if (src.creditPhase) {
                builder.storeBit(true);
                builder.store((0, $bD890.storeTransactionCreditPhase)(src.creditPhase));
            } else builder.storeBit(false);
            builder.store((0, $3GHC2.storeTransactionComputePhase)(src.computePhase));
            if (src.actionPhase) {
                builder.storeBit(true);
                builder.storeRef((0, $hARf4.beginCell)().store((0, $ebLPz.storeTransactionActionPhase)(src.actionPhase)));
            } else builder.storeBit(false);
            builder.storeBit(src.aborted);
            if (src.bouncePhase) {
                builder.storeBit(true);
                builder.store((0, $4oz91.storeTransactionBouncePhase)(src.bouncePhase));
            } else builder.storeBit(false);
            builder.storeBit(src.destroyed);
        } else if (src.type === "storage") {
            builder.storeUint(0x01, 4);
            builder.store((0, $fBSvD.storeTransactionsStoragePhase)(src.storagePhase));
        } else if (src.type === "tick-tock") {
            builder.storeUint(src.isTock ? 0x03 : 0x02, 4);
            builder.store((0, $fBSvD.storeTransactionsStoragePhase)(src.storagePhase));
            builder.store((0, $3GHC2.storeTransactionComputePhase)(src.computePhase));
            if (src.actionPhase) {
                builder.storeBit(true);
                builder.storeRef((0, $hARf4.beginCell)().store((0, $ebLPz.storeTransactionActionPhase)(src.actionPhase)));
            } else builder.storeBit(false);
            builder.storeBit(src.aborted);
            builder.storeBit(src.destroyed);
        } else if (src.type === "split-prepare") {
            builder.storeUint(0x04, 4);
            builder.store((0, $aXgYN.storeSplitMergeInfo)(src.splitInfo));
            if (src.storagePhase) {
                builder.storeBit(true);
                builder.store((0, $fBSvD.storeTransactionsStoragePhase)(src.storagePhase));
            } else builder.storeBit(false);
            builder.store((0, $3GHC2.storeTransactionComputePhase)(src.computePhase));
            if (src.actionPhase) {
                builder.storeBit(true);
                builder.store((0, $ebLPz.storeTransactionActionPhase)(src.actionPhase));
            } else builder.storeBit(false);
            builder.storeBit(src.aborted);
            builder.storeBit(src.destroyed);
        } else if (src.type === "split-install") {
            builder.storeUint(0x05, 4);
            builder.store((0, $aXgYN.storeSplitMergeInfo)(src.splitInfo));
            builder.storeRef((0, $hARf4.beginCell)().store((0, $5mIUV.storeTransaction)(src.prepareTransaction)));
            builder.storeBit(src.installed);
        } else throw Error("Unsupported transaction description type ".concat(src.type));
    };
}
module.exports.storeTransactionDescription = $9394177f4463adaa$var$storeTransactionDescription;

});
parcelRequire.register("ebLPz", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeTransactionActionPhase = module.exports.loadTransactionActionPhase = void 0;

var $8iN6S = parcelRequire("8iN6S");

var $5upht = parcelRequire("5upht");
function $a54731f93fb4a8e8$var$loadTransactionActionPhase(slice) {
    var success = slice.loadBit();
    var valid = slice.loadBit();
    var noFunds = slice.loadBit();
    var statusChange = (0, $8iN6S.loadAccountStatusChange)(slice);
    var totalFwdFees = slice.loadBit() ? slice.loadCoins() : undefined;
    var totalActionFees = slice.loadBit() ? slice.loadCoins() : undefined;
    var resultCode = slice.loadInt(32);
    var resultArg = slice.loadBit() ? slice.loadInt(32) : undefined;
    var totalActions = slice.loadUint(16);
    var specActions = slice.loadUint(16);
    var skippedActions = slice.loadUint(16);
    var messagesCreated = slice.loadUint(16);
    var actionListHash = slice.loadUintBig(256);
    var totalMessageSize = (0, $5upht.loadStorageUsedShort)(slice);
    return {
        success: success,
        valid: valid,
        noFunds: noFunds,
        statusChange: statusChange,
        totalFwdFees: totalFwdFees,
        totalActionFees: totalActionFees,
        resultCode: resultCode,
        resultArg: resultArg,
        totalActions: totalActions,
        specActions: specActions,
        skippedActions: skippedActions,
        messagesCreated: messagesCreated,
        actionListHash: actionListHash,
        totalMessageSize: totalMessageSize
    };
}
module.exports.loadTransactionActionPhase = $a54731f93fb4a8e8$var$loadTransactionActionPhase;
function $a54731f93fb4a8e8$var$storeTransactionActionPhase(src) {
    return function(builder) {
        builder.storeBit(src.success);
        builder.storeBit(src.valid);
        builder.storeBit(src.noFunds);
        builder.store((0, $8iN6S.storeAccountStatusChange)(src.statusChange));
        builder.storeMaybeCoins(src.totalFwdFees);
        builder.storeMaybeCoins(src.totalActionFees);
        builder.storeInt(src.resultCode, 32);
        builder.storeMaybeInt(src.resultArg, 32);
        builder.storeUint(src.totalActions, 16);
        builder.storeUint(src.specActions, 16);
        builder.storeUint(src.skippedActions, 16);
        builder.storeUint(src.messagesCreated, 16);
        builder.storeUint(src.actionListHash, 256);
        builder.store((0, $5upht.storeStorageUsedShort)(src.totalMessageSize));
    };
}
module.exports.storeTransactionActionPhase = $a54731f93fb4a8e8$var$storeTransactionActionPhase;

});

parcelRequire.register("4oz91", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeTransactionBouncePhase = module.exports.loadTransactionBouncePhase = void 0;

var $5upht = parcelRequire("5upht");
function $3334aa429c231deb$var$loadTransactionBouncePhase(slice) {
    // Ok
    if (slice.loadBit()) {
        var messageSize = (0, $5upht.loadStorageUsedShort)(slice);
        var messageFees = slice.loadCoins();
        var forwardFees = slice.loadCoins();
        return {
            type: "ok",
            messageSize: messageSize,
            messageFees: messageFees,
            forwardFees: forwardFees
        };
    }
    // No funds
    if (slice.loadBit()) {
        var messageSize1 = (0, $5upht.loadStorageUsedShort)(slice);
        var requiredForwardFees = slice.loadCoins();
        return {
            type: "no-funds",
            messageSize: messageSize1,
            requiredForwardFees: requiredForwardFees
        };
    }
    // Negative funds
    return {
        type: "negative-funds"
    };
}
module.exports.loadTransactionBouncePhase = $3334aa429c231deb$var$loadTransactionBouncePhase;
function $3334aa429c231deb$var$storeTransactionBouncePhase(src) {
    return function(builder) {
        if (src.type === "ok") {
            builder.storeBit(true);
            builder.store((0, $5upht.storeStorageUsedShort)(src.messageSize));
            builder.storeCoins(src.messageFees);
            builder.storeCoins(src.forwardFees);
        } else if (src.type === "negative-funds") {
            builder.storeBit(false);
            builder.storeBit(false);
        } else if (src.type === "no-funds") {
            builder.storeBit(false);
            builder.storeBit(true);
            builder.store((0, $5upht.storeStorageUsedShort)(src.messageSize));
            builder.storeCoins(src.requiredForwardFees);
        } else throw new Error("Invalid TransactionBouncePhase type");
    };
}
module.exports.storeTransactionBouncePhase = $3334aa429c231deb$var$storeTransactionBouncePhase;

});

parcelRequire.register("3GHC2", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeTransactionComputePhase = module.exports.loadTransactionComputePhase = void 0;

var $hARf4 = parcelRequire("hARf4");

var $7IZQv = parcelRequire("7IZQv");
function $2af71fdf9cb6defb$var$loadTransactionComputePhase(slice) {
    // Skipped
    if (!slice.loadBit()) {
        var reason = (0, $7IZQv.loadComputeSkipReason)(slice);
        return {
            type: "skipped",
            reason: reason
        };
    }
    var success = slice.loadBit();
    var messageStateUsed = slice.loadBit();
    var accountActivated = slice.loadBit();
    var gasFees = slice.loadCoins();
    var vmState = slice.loadRef().beginParse();
    var gasUsed = vmState.loadVarUintBig(3);
    var gasLimit = vmState.loadVarUintBig(3);
    var gasCredit = vmState.loadBit() ? vmState.loadVarUintBig(2) : undefined;
    var mode = vmState.loadUint(8);
    var exitCode = vmState.loadUint(32);
    var exitArg = vmState.loadBit() ? vmState.loadInt(32) : undefined;
    var vmSteps = vmState.loadUint(32);
    var vmInitStateHash = vmState.loadUintBig(256);
    var vmFinalStateHash = vmState.loadUintBig(256);
    return {
        type: "vm",
        success: success,
        messageStateUsed: messageStateUsed,
        accountActivated: accountActivated,
        gasFees: gasFees,
        gasUsed: gasUsed,
        gasLimit: gasLimit,
        gasCredit: gasCredit,
        mode: mode,
        exitCode: exitCode,
        exitArg: exitArg,
        vmSteps: vmSteps,
        vmInitStateHash: vmInitStateHash,
        vmFinalStateHash: vmFinalStateHash
    };
}
module.exports.loadTransactionComputePhase = $2af71fdf9cb6defb$var$loadTransactionComputePhase;
function $2af71fdf9cb6defb$var$storeTransactionComputePhase(src) {
    return function(builder) {
        if (src.type === "skipped") {
            builder.storeBit(0);
            builder.store((0, $7IZQv.storeComputeSkipReason)(src.reason));
            return;
        }
        builder.storeBit(1);
        builder.storeBit(src.success);
        builder.storeBit(src.messageStateUsed);
        builder.storeBit(src.accountActivated);
        builder.storeCoins(src.gasFees);
        builder.storeRef((0, $hARf4.beginCell)().storeVarUint(src.gasUsed, 3).storeVarUint(src.gasLimit, 3).store(function(b) {
            return src.gasCredit !== undefined && src.gasCredit !== null ? b.storeBit(1).storeVarUint(src.gasCredit, 2) : b.storeBit(0);
        }).storeUint(src.mode, 8).storeUint(src.exitCode, 32).store(function(b) {
            return src.exitArg !== undefined && src.exitArg !== null ? b.storeBit(1).storeInt(src.exitArg, 32) : b.storeBit(0);
        }).storeUint(src.vmSteps, 32).storeUint(src.vmInitStateHash, 256).storeUint(src.vmFinalStateHash, 256).endCell());
    };
}
module.exports.storeTransactionComputePhase = $2af71fdf9cb6defb$var$storeTransactionComputePhase;

});

parcelRequire.register("bD890", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeTransactionCreditPhase = module.exports.loadTransactionCreditPhase = void 0;

var $92Q5k = parcelRequire("92Q5k");
function $8779a77bafffc52a$var$loadTransactionCreditPhase(slice) {
    var dueFeesColelcted = slice.loadBit() ? slice.loadCoins() : undefined;
    var credit = (0, $92Q5k.loadCurrencyCollection)(slice);
    return {
        dueFeesColelcted: dueFeesColelcted,
        credit: credit
    };
}
module.exports.loadTransactionCreditPhase = $8779a77bafffc52a$var$loadTransactionCreditPhase;
function $8779a77bafffc52a$var$storeTransactionCreditPhase(src) {
    return function(builder) {
        if (src.dueFeesColelcted === null || src.dueFeesColelcted === undefined) builder.storeBit(false);
        else {
            builder.storeBit(true);
            builder.storeCoins(src.dueFeesColelcted);
        }
        builder.store((0, $92Q5k.storeCurrencyCollection)(src.credit));
    };
}
module.exports.storeTransactionCreditPhase = $8779a77bafffc52a$var$storeTransactionCreditPhase;

});

parcelRequire.register("fBSvD", function(module, exports) {
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeTransactionsStoragePhase = module.exports.loadTransactionStoragePhase = void 0;

var $8iN6S = parcelRequire("8iN6S");
function $b5d498229788e9c2$var$loadTransactionStoragePhase(slice) {
    var storageFeesCollected = slice.loadCoins();
    var storageFeesDue = undefined;
    if (slice.loadBit()) storageFeesDue = slice.loadCoins();
    var statusChange = (0, $8iN6S.loadAccountStatusChange)(slice);
    return {
        storageFeesCollected: storageFeesCollected,
        storageFeesDue: storageFeesDue,
        statusChange: statusChange
    };
}
module.exports.loadTransactionStoragePhase = $b5d498229788e9c2$var$loadTransactionStoragePhase;
function $b5d498229788e9c2$var$storeTransactionsStoragePhase(src) {
    return function(builder) {
        builder.storeCoins(src.storageFeesCollected);
        if (src.storageFeesDue === null || src.storageFeesDue === undefined) builder.storeBit(false);
        else {
            builder.storeBit(true);
            builder.storeCoins(src.storageFeesDue);
        }
        builder.store((0, $8iN6S.storeAccountStatusChange)(src.statusChange));
    };
}
module.exports.storeTransactionsStoragePhase = $b5d498229788e9c2$var$storeTransactionsStoragePhase;

});




parcelRequire.register("cPCMn", function(module, exports) {

var $fLnyw = parcelRequire("fLnyw");
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.openContract = void 0;

var $gUPfK = parcelRequire("gUPfK");

var $KH51V = parcelRequire("KH51V");
function $02692aa5f586b992$var$openContract(src, factory) {
    // Resolve parameters
    var address;
    var init = null;
    if (!$gUPfK.Address.isAddress(src.address)) throw Error("Invalid address");
    address = src.address;
    if (src.init) {
        if (!(src.init.code instanceof $KH51V.Cell)) throw Error("Invalid init.code");
        if (!(src.init.data instanceof $KH51V.Cell)) throw Error("Invalid init.data");
        init = src.init;
    }
    // Create executor
    var executor = factory({
        address: address,
        init: init
    });
    // Create proxy
    return new Proxy(src, {
        get: function(target, prop) {
            var value = target[prop];
            if (typeof prop === "string" && (prop.startsWith("get") || prop.startsWith("send"))) {
                if (typeof value === "function") return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return value.apply(target, [
                        executor
                    ].concat((0, $fLnyw._)(args)));
                };
            }
            return value;
        }
    });
}
module.exports.openContract = $02692aa5f586b992$var$openContract;

});

parcelRequire.register("fRaup", function(module, exports) {

var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $ftJVG = parcelRequire("ftJVG");

var $2TMdq = parcelRequire("2TMdq");

var $6OZAO = parcelRequire("6OZAO");
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComputeError = void 0;
var $b8b3f1410ef8dfc9$var$ComputeError = /*#__PURE__*/ function(Error1) {
    (0, $ftJVG._)(ComputeError, Error1);
    var _super = (0, $6OZAO._)(ComputeError);
    function ComputeError(message, exitCode, opts) {
        (0, $978gY._)(this, ComputeError);
        var _this;
        _this = _super.call(this, message);
        _this.exitCode = exitCode;
        _this.debugLogs = opts && opts.debugLogs ? opts.debugLogs : null;
        _this.logs = opts && opts.logs ? opts.logs : null;
        Object.setPrototypeOf((0, $3vWwE._)(_this), ComputeError.prototype);
        return _this;
    }
    return ComputeError;
}((0, $2TMdq._)(Error));
module.exports.ComputeError = $b8b3f1410ef8dfc9$var$ComputeError;

});

parcelRequire.register("6LDD9", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $4ed5dfa7752cc8b8$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMethodId = void 0;
var $4ed5dfa7752cc8b8$var$TABLE = new Int16Array([
    0x0000,
    0x1021,
    0x2042,
    0x3063,
    0x4084,
    0x50a5,
    0x60c6,
    0x70e7,
    0x8108,
    0x9129,
    0xa14a,
    0xb16b,
    0xc18c,
    0xd1ad,
    0xe1ce,
    0xf1ef,
    0x1231,
    0x0210,
    0x3273,
    0x2252,
    0x52b5,
    0x4294,
    0x72f7,
    0x62d6,
    0x9339,
    0x8318,
    0xb37b,
    0xa35a,
    0xd3bd,
    0xc39c,
    0xf3ff,
    0xe3de,
    0x2462,
    0x3443,
    0x0420,
    0x1401,
    0x64e6,
    0x74c7,
    0x44a4,
    0x5485,
    0xa56a,
    0xb54b,
    0x8528,
    0x9509,
    0xe5ee,
    0xf5cf,
    0xc5ac,
    0xd58d,
    0x3653,
    0x2672,
    0x1611,
    0x0630,
    0x76d7,
    0x66f6,
    0x5695,
    0x46b4,
    0xb75b,
    0xa77a,
    0x9719,
    0x8738,
    0xf7df,
    0xe7fe,
    0xd79d,
    0xc7bc,
    0x48c4,
    0x58e5,
    0x6886,
    0x78a7,
    0x0840,
    0x1861,
    0x2802,
    0x3823,
    0xc9cc,
    0xd9ed,
    0xe98e,
    0xf9af,
    0x8948,
    0x9969,
    0xa90a,
    0xb92b,
    0x5af5,
    0x4ad4,
    0x7ab7,
    0x6a96,
    0x1a71,
    0x0a50,
    0x3a33,
    0x2a12,
    0xdbfd,
    0xcbdc,
    0xfbbf,
    0xeb9e,
    0x9b79,
    0x8b58,
    0xbb3b,
    0xab1a,
    0x6ca6,
    0x7c87,
    0x4ce4,
    0x5cc5,
    0x2c22,
    0x3c03,
    0x0c60,
    0x1c41,
    0xedae,
    0xfd8f,
    0xcdec,
    0xddcd,
    0xad2a,
    0xbd0b,
    0x8d68,
    0x9d49,
    0x7e97,
    0x6eb6,
    0x5ed5,
    0x4ef4,
    0x3e13,
    0x2e32,
    0x1e51,
    0x0e70,
    0xff9f,
    0xefbe,
    0xdfdd,
    0xcffc,
    0xbf1b,
    0xaf3a,
    0x9f59,
    0x8f78,
    0x9188,
    0x81a9,
    0xb1ca,
    0xa1eb,
    0xd10c,
    0xc12d,
    0xf14e,
    0xe16f,
    0x1080,
    0x00a1,
    0x30c2,
    0x20e3,
    0x5004,
    0x4025,
    0x7046,
    0x6067,
    0x83b9,
    0x9398,
    0xa3fb,
    0xb3da,
    0xc33d,
    0xd31c,
    0xe37f,
    0xf35e,
    0x02b1,
    0x1290,
    0x22f3,
    0x32d2,
    0x4235,
    0x5214,
    0x6277,
    0x7256,
    0xb5ea,
    0xa5cb,
    0x95a8,
    0x8589,
    0xf56e,
    0xe54f,
    0xd52c,
    0xc50d,
    0x34e2,
    0x24c3,
    0x14a0,
    0x0481,
    0x7466,
    0x6447,
    0x5424,
    0x4405,
    0xa7db,
    0xb7fa,
    0x8799,
    0x97b8,
    0xe75f,
    0xf77e,
    0xc71d,
    0xd73c,
    0x26d3,
    0x36f2,
    0x0691,
    0x16b0,
    0x6657,
    0x7676,
    0x4615,
    0x5634,
    0xd94c,
    0xc96d,
    0xf90e,
    0xe92f,
    0x99c8,
    0x89e9,
    0xb98a,
    0xa9ab,
    0x5844,
    0x4865,
    0x7806,
    0x6827,
    0x18c0,
    0x08e1,
    0x3882,
    0x28a3,
    0xcb7d,
    0xdb5c,
    0xeb3f,
    0xfb1e,
    0x8bf9,
    0x9bd8,
    0xabbb,
    0xbb9a,
    0x4a75,
    0x5a54,
    0x6a37,
    0x7a16,
    0x0af1,
    0x1ad0,
    0x2ab3,
    0x3a92,
    0xfd2e,
    0xed0f,
    0xdd6c,
    0xcd4d,
    0xbdaa,
    0xad8b,
    0x9de8,
    0x8dc9,
    0x7c26,
    0x6c07,
    0x5c64,
    0x4c45,
    0x3ca2,
    0x2c83,
    0x1ce0,
    0x0cc1,
    0xef1f,
    0xff3e,
    0xcf5d,
    0xdf7c,
    0xaf9b,
    0xbfba,
    0x8fd9,
    0x9ff8,
    0x6e17,
    0x7e36,
    0x4e55,
    0x5e74,
    0x2e93,
    0x3eb2,
    0x0ed1,
    0x1ef0
]);
function $4ed5dfa7752cc8b8$var$crc16(data) {
    if (!(data instanceof $4ed5dfa7752cc8b8$require$Buffer)) data = $4ed5dfa7752cc8b8$require$Buffer.from(data);
    var crc = 0;
    for(var index = 0; index < data.length; index++){
        var byte = data[index];
        crc = ($4ed5dfa7752cc8b8$var$TABLE[(crc >> 8 ^ byte) & 0xff] ^ crc << 8) & 0xffff;
    }
    return crc;
}
function $4ed5dfa7752cc8b8$var$getMethodId(name) {
    return $4ed5dfa7752cc8b8$var$crc16(name) & 0xffff | 0x10000;
}
module.exports.getMethodId = $4ed5dfa7752cc8b8$var$getMethodId;

});

parcelRequire.register("9qmBE", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $6dc813e9787c83e9$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.safeSignVerify = module.exports.safeSign = void 0;

var $lusx3 = parcelRequire("lusx3");
var $6dc813e9787c83e9$var$MIN_SEED_LENGTH = 8;
var $6dc813e9787c83e9$var$MAX_SEED_LENGTH = 64;
function $6dc813e9787c83e9$var$createSafeSignHash(cell, seed) {
    var seedData = $6dc813e9787c83e9$require$Buffer.from(seed);
    if (seedData.length > $6dc813e9787c83e9$var$MAX_SEED_LENGTH) throw Error("Seed can	 be longer than 64 bytes");
    if (seedData.length < $6dc813e9787c83e9$var$MIN_SEED_LENGTH) throw Error("Seed must be at least 8 bytes");
    return (0, $lusx3.sha256_sync)($6dc813e9787c83e9$require$Buffer.concat([
        $6dc813e9787c83e9$require$Buffer.from([
            0xff,
            0xff
        ]),
        seedData,
        cell.hash()
    ]));
}
function $6dc813e9787c83e9$var$safeSign(cell, secretKey) {
    var seed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "ton-safe-sign-magic";
    return (0, $lusx3.sign)($6dc813e9787c83e9$var$createSafeSignHash(cell, seed), secretKey);
}
module.exports.safeSign = $6dc813e9787c83e9$var$safeSign;
function $6dc813e9787c83e9$var$safeSignVerify(cell, signature, publicKey) {
    var seed = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "ton-safe-sign-magic";
    return (0, $lusx3.signVerify)($6dc813e9787c83e9$var$createSafeSignHash(cell, seed), signature, publicKey);
}
module.exports.safeSignVerify = $6dc813e9787c83e9$var$safeSignVerify;

});


parcelRequire.register("hFGzs", function(module, exports) {

var $aqbQf = parcelRequire("aqbQf");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $cdd749b5e5c61fb0$var$DataLoader = /*#__PURE__*/ function() {
    var DataLoader = function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== "function") throw new TypeError("DataLoader must be constructed with a function which accepts " + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $cdd749b5e5c61fb0$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $cdd749b5e5c61fb0$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $cdd749b5e5c61fb0$var$getValidCacheKeyFn(options);
        this._cacheMap = $cdd749b5e5c61fb0$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $cdd749b5e5c61fb0$var$getValidName(options);
    } // Private
    ;
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError("The loader.load() function must be called with a value, " + ("but got: " + String(key) + "."));
        var batch = $cdd749b5e5c61fb0$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$cdd749b5e5c61fb0$var$isArrayLike(keys)) throw new TypeError("The loader.loadMany() function must be called with Array<key> " + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $cdd749b5e5c61fb0$var$enqueuePostPromiseJob = typeof $aqbQf === "object" && typeof $aqbQf.nextTick === "function" ? function enqueuePostPromiseJob(fn) {
    if (!$cdd749b5e5c61fb0$var$resolvedPromise) $cdd749b5e5c61fb0$var$resolvedPromise = Promise.resolve();
    $cdd749b5e5c61fb0$var$resolvedPromise.then(function() {
        $aqbQf.nextTick(fn);
    });
} : typeof setImmediate === "function" ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $cdd749b5e5c61fb0$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $cdd749b5e5c61fb0$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $cdd749b5e5c61fb0$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $cdd749b5e5c61fb0$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $cdd749b5e5c61fb0$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $cdd749b5e5c61fb0$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== "function") return $cdd749b5e5c61fb0$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$cdd749b5e5c61fb0$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $cdd749b5e5c61fb0$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $cdd749b5e5c61fb0$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $cdd749b5e5c61fb0$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $cdd749b5e5c61fb0$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $cdd749b5e5c61fb0$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $cdd749b5e5c61fb0$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== "number" || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $cdd749b5e5c61fb0$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $cdd749b5e5c61fb0$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== "function") throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $cdd749b5e5c61fb0$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== "function") throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $cdd749b5e5c61fb0$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            "get",
            "set",
            "delete",
            "clear"
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== "function";
        });
        if (missingFunctions.length !== 0) throw new TypeError("Custom cacheMap missing methods: " + missingFunctions.join(", "));
    }
    return cacheMap;
}
function $cdd749b5e5c61fb0$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $cdd749b5e5c61fb0$var$isArrayLike(x) {
    return typeof x === "object" && x !== null && typeof x.length === "number" && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $cdd749b5e5c61fb0$var$DataLoader;

});

parcelRequire.register("12URZ", function(module, exports) {

module.exports = (parcelRequire("2D9Cv"));

});
parcelRequire.register("2D9Cv", function(module, exports) {
"use strict";

var $bqHqy = parcelRequire("bqHqy");

var $328zL = parcelRequire("328zL");

var $ssgUa = parcelRequire("ssgUa");

var $cxWM7 = parcelRequire("cxWM7");

var $b3kg1 = parcelRequire("b3kg1");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $1ea6af9d30a24017$var$createInstance(defaultConfig) {
    var context = new $ssgUa(defaultConfig);
    var instance = $328zL($ssgUa.prototype.request, context);
    // Copy axios.prototype to instance
    $bqHqy.extend(instance, $ssgUa.prototype, context);
    // Copy context to instance
    $bqHqy.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $1ea6af9d30a24017$var$createInstance($cxWM7(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $1ea6af9d30a24017$var$axios = $1ea6af9d30a24017$var$createInstance($b3kg1);
// Expose Axios class to allow class inheritance
$1ea6af9d30a24017$var$axios.Axios = $ssgUa;

// Expose Cancel & CancelToken
$1ea6af9d30a24017$var$axios.Cancel = (parcelRequire("9GdAt"));

$1ea6af9d30a24017$var$axios.CancelToken = (parcelRequire("cGFhJ"));

$1ea6af9d30a24017$var$axios.isCancel = (parcelRequire("aaTwD"));

$1ea6af9d30a24017$var$axios.VERSION = (parcelRequire("exWX2")).version;
// Expose all/spread
$1ea6af9d30a24017$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$1ea6af9d30a24017$var$axios.spread = (parcelRequire("dvT58"));

// Expose isAxiosError
$1ea6af9d30a24017$var$axios.isAxiosError = (parcelRequire("4xqmh"));
module.exports = $1ea6af9d30a24017$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $1ea6af9d30a24017$var$axios;

});
parcelRequire.register("bqHqy", function(module, exports) {
"use strict";

var $328zL = parcelRequire("328zL");
// utils is a library of generic helper functions non-specific to axios
var $8523cf32ac6b87ad$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $8523cf32ac6b87ad$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $8523cf32ac6b87ad$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $8523cf32ac6b87ad$var$isBuffer(val) {
    return val !== null && !$8523cf32ac6b87ad$var$isUndefined(val) && val.constructor !== null && !$8523cf32ac6b87ad$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $8523cf32ac6b87ad$var$isArrayBuffer(val) {
    return $8523cf32ac6b87ad$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $8523cf32ac6b87ad$var$isFormData(val) {
    return $8523cf32ac6b87ad$var$toString.call(val) === "[object FormData]";
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $8523cf32ac6b87ad$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $8523cf32ac6b87ad$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $8523cf32ac6b87ad$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $8523cf32ac6b87ad$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $8523cf32ac6b87ad$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $8523cf32ac6b87ad$var$isPlainObject(val) {
    if ($8523cf32ac6b87ad$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $8523cf32ac6b87ad$var$isDate(val) {
    return $8523cf32ac6b87ad$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $8523cf32ac6b87ad$var$isFile(val) {
    return $8523cf32ac6b87ad$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $8523cf32ac6b87ad$var$isBlob(val) {
    return $8523cf32ac6b87ad$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $8523cf32ac6b87ad$var$isFunction(val) {
    return $8523cf32ac6b87ad$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $8523cf32ac6b87ad$var$isStream(val) {
    return $8523cf32ac6b87ad$var$isObject(val) && $8523cf32ac6b87ad$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $8523cf32ac6b87ad$var$isURLSearchParams(val) {
    return $8523cf32ac6b87ad$var$toString.call(val) === "[object URLSearchParams]";
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $8523cf32ac6b87ad$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $8523cf32ac6b87ad$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $8523cf32ac6b87ad$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($8523cf32ac6b87ad$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $8523cf32ac6b87ad$var$merge() {
    var assignValue = function assignValue(val, key) {
        if ($8523cf32ac6b87ad$var$isPlainObject(result[key]) && $8523cf32ac6b87ad$var$isPlainObject(val)) result[key] = $8523cf32ac6b87ad$var$merge(result[key], val);
        else if ($8523cf32ac6b87ad$var$isPlainObject(val)) result[key] = $8523cf32ac6b87ad$var$merge({}, val);
        else if ($8523cf32ac6b87ad$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    };
    var result = {};
    for(var i = 0, l = arguments.length; i < l; i++)$8523cf32ac6b87ad$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $8523cf32ac6b87ad$var$extend(a, b, thisArg) {
    $8523cf32ac6b87ad$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $328zL(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $8523cf32ac6b87ad$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $8523cf32ac6b87ad$var$isArray,
    isArrayBuffer: $8523cf32ac6b87ad$var$isArrayBuffer,
    isBuffer: $8523cf32ac6b87ad$var$isBuffer,
    isFormData: $8523cf32ac6b87ad$var$isFormData,
    isArrayBufferView: $8523cf32ac6b87ad$var$isArrayBufferView,
    isString: $8523cf32ac6b87ad$var$isString,
    isNumber: $8523cf32ac6b87ad$var$isNumber,
    isObject: $8523cf32ac6b87ad$var$isObject,
    isPlainObject: $8523cf32ac6b87ad$var$isPlainObject,
    isUndefined: $8523cf32ac6b87ad$var$isUndefined,
    isDate: $8523cf32ac6b87ad$var$isDate,
    isFile: $8523cf32ac6b87ad$var$isFile,
    isBlob: $8523cf32ac6b87ad$var$isBlob,
    isFunction: $8523cf32ac6b87ad$var$isFunction,
    isStream: $8523cf32ac6b87ad$var$isStream,
    isURLSearchParams: $8523cf32ac6b87ad$var$isURLSearchParams,
    isStandardBrowserEnv: $8523cf32ac6b87ad$var$isStandardBrowserEnv,
    forEach: $8523cf32ac6b87ad$var$forEach,
    merge: $8523cf32ac6b87ad$var$merge,
    extend: $8523cf32ac6b87ad$var$extend,
    trim: $8523cf32ac6b87ad$var$trim,
    stripBOM: $8523cf32ac6b87ad$var$stripBOM
};

});
parcelRequire.register("328zL", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRequire.register("ssgUa", function(module, exports) {
"use strict";

var $bqHqy = parcelRequire("bqHqy");

var $8Bcrh = parcelRequire("8Bcrh");

var $d1Wac = parcelRequire("d1Wac");

var $hXA9J = parcelRequire("hXA9J");

var $cxWM7 = parcelRequire("cxWM7");

var $xtD9d = parcelRequire("xtD9d");
var $05588bcd5902a377$var$validators = $xtD9d.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $05588bcd5902a377$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $d1Wac(),
        response: new $d1Wac()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $05588bcd5902a377$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    if (!config.url) throw new Error("Provided config url is not valid");
    config = $cxWM7(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $xtD9d.assertOptions(transitional, {
        silentJSONParsing: $05588bcd5902a377$var$validators.transitional($05588bcd5902a377$var$validators.boolean),
        forcedJSONParsing: $05588bcd5902a377$var$validators.transitional($05588bcd5902a377$var$validators.boolean),
        clarifyTimeoutError: $05588bcd5902a377$var$validators.transitional($05588bcd5902a377$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $hXA9J,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $hXA9J(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$05588bcd5902a377$var$Axios.prototype.getUri = function getUri(config) {
    if (!config.url) throw new Error("Provided config url is not valid");
    config = $cxWM7(this.defaults, config);
    return $8Bcrh(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$bqHqy.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $05588bcd5902a377$var$Axios.prototype[method] = function(url, config) {
        return this.request($cxWM7(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$bqHqy.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $05588bcd5902a377$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($cxWM7(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $05588bcd5902a377$var$Axios;

});
parcelRequire.register("8Bcrh", function(module, exports) {
"use strict";

var $bqHqy = parcelRequire("bqHqy");
function $019d9a8a8e7b8732$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($bqHqy.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $bqHqy.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($bqHqy.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $bqHqy.forEach(val, function parseValue(v) {
                if ($bqHqy.isDate(v)) v = v.toISOString();
                else if ($bqHqy.isObject(v)) v = JSON.stringify(v);
                parts.push($019d9a8a8e7b8732$var$encode(key) + "=" + $019d9a8a8e7b8732$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRequire.register("d1Wac", function(module, exports) {
"use strict";

var $bqHqy = parcelRequire("bqHqy");
function $97c87c6f2ed7dbf9$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $97c87c6f2ed7dbf9$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $97c87c6f2ed7dbf9$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $97c87c6f2ed7dbf9$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $bqHqy.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $97c87c6f2ed7dbf9$var$InterceptorManager;

});

parcelRequire.register("hXA9J", function(module, exports) {
"use strict";

var $bqHqy = parcelRequire("bqHqy");

var $fRE7m = parcelRequire("fRE7m");

var $aaTwD = parcelRequire("aaTwD");

var $b3kg1 = parcelRequire("b3kg1");

var $9GdAt = parcelRequire("9GdAt");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $d133fe32bb7a1b7f$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $9GdAt("canceled");
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $d133fe32bb7a1b7f$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $fRE7m.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $bqHqy.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $bqHqy.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $b3kg1.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $d133fe32bb7a1b7f$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $fRE7m.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$aaTwD(reason)) {
            $d133fe32bb7a1b7f$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $fRE7m.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRequire.register("fRE7m", function(module, exports) {
"use strict";

var $bqHqy = parcelRequire("bqHqy");

var $b3kg1 = parcelRequire("b3kg1");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $b3kg1;
    /*eslint no-param-reassign:0*/ $bqHqy.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRequire.register("b3kg1", function(module, exports) {

var $aqbQf = parcelRequire("aqbQf");
"use strict";

var $bqHqy = parcelRequire("bqHqy");

var $iQiQZ = parcelRequire("iQiQZ");

var $4OgOw = parcelRequire("4OgOw");
var $80bfb0344c0c2806$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $80bfb0344c0c2806$var$setContentTypeIfUnset(headers, value) {
    if (!$bqHqy.isUndefined(headers) && $bqHqy.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $80bfb0344c0c2806$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("ev6Fg"));
    else if (typeof $aqbQf !== "undefined" && Object.prototype.toString.call($aqbQf) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("ev6Fg"));
    return adapter;
}
function $80bfb0344c0c2806$var$stringifySafely(rawValue, parser, encoder) {
    if ($bqHqy.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $bqHqy.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $80bfb0344c0c2806$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $80bfb0344c0c2806$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $iQiQZ(headers, "Accept");
            $iQiQZ(headers, "Content-Type");
            if ($bqHqy.isFormData(data) || $bqHqy.isArrayBuffer(data) || $bqHqy.isBuffer(data) || $bqHqy.isStream(data) || $bqHqy.isFile(data) || $bqHqy.isBlob(data)) return data;
            if ($bqHqy.isArrayBufferView(data)) return data.buffer;
            if ($bqHqy.isURLSearchParams(data)) {
                $80bfb0344c0c2806$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($bqHqy.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $80bfb0344c0c2806$var$setContentTypeIfUnset(headers, "application/json");
                return $80bfb0344c0c2806$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $80bfb0344c0c2806$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $bqHqy.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $4OgOw(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$bqHqy.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $80bfb0344c0c2806$var$defaults.headers[method] = {};
});
$bqHqy.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $80bfb0344c0c2806$var$defaults.headers[method] = $bqHqy.merge($80bfb0344c0c2806$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $80bfb0344c0c2806$var$defaults;

});
parcelRequire.register("iQiQZ", function(module, exports) {
"use strict";

var $bqHqy = parcelRequire("bqHqy");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $bqHqy.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRequire.register("4OgOw", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRequire.register("ev6Fg", function(module, exports) {
"use strict";

var $bqHqy = parcelRequire("bqHqy");

var $1x9S4 = parcelRequire("1x9S4");

var $2yJGk = parcelRequire("2yJGk");

var $8Bcrh = parcelRequire("8Bcrh");

var $8GFbK = parcelRequire("8GFbK");

var $35vRD = parcelRequire("35vRD");

var $hechV = parcelRequire("hechV");

var $hJUSO = parcelRequire("hJUSO");

var $b3kg1 = parcelRequire("b3kg1");

var $9GdAt = parcelRequire("9GdAt");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var done = function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        };
        var onloadend = function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $35vRD(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $1x9S4(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        };
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        if ($bqHqy.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $8GFbK(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $8Bcrh(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($hJUSO("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($hJUSO("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $b3kg1.transitional;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($hJUSO(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($bqHqy.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $hechV(fullPath)) && config.xsrfCookieName ? $2yJGk.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $bqHqy.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$bqHqy.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function onCanceled(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $9GdAt("canceled") : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRequire.register("1x9S4", function(module, exports) {
"use strict";

var $hJUSO = parcelRequire("hJUSO");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($hJUSO("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRequire.register("hJUSO", function(module, exports) {
"use strict";

var $4OgOw = parcelRequire("4OgOw");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $4OgOw(error, config, code, request, response);
};

});


parcelRequire.register("2yJGk", function(module, exports) {
"use strict";

var $bqHqy = parcelRequire("bqHqy");
module.exports = $bqHqy.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($bqHqy.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($bqHqy.isString(path)) cookie.push("path=" + path);
            if ($bqHqy.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRequire.register("8GFbK", function(module, exports) {
"use strict";

var $5PTgH = parcelRequire("5PTgH");

var $6OBBx = parcelRequire("6OBBx");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$5PTgH(requestedURL)) return $6OBBx(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRequire.register("5PTgH", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRequire.register("6OBBx", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRequire.register("35vRD", function(module, exports) {
"use strict";

var $bqHqy = parcelRequire("bqHqy");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $23fa8e4962133e08$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $bqHqy.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $bqHqy.trim(line.substr(0, i)).toLowerCase();
        val = $bqHqy.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $23fa8e4962133e08$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRequire.register("hechV", function(module, exports) {
"use strict";

var $bqHqy = parcelRequire("bqHqy");
module.exports = $bqHqy.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var resolveURL = /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    };
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $bqHqy.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRequire.register("9GdAt", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $70c2936da052bd2b$var$Cancel(message) {
    this.message = message;
}
$70c2936da052bd2b$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$70c2936da052bd2b$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $70c2936da052bd2b$var$Cancel;

});




parcelRequire.register("aaTwD", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRequire.register("cxWM7", function(module, exports) {
"use strict";

var $bqHqy = parcelRequire("bqHqy");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    var getMergedValue = function getMergedValue(target, source) {
        if ($bqHqy.isPlainObject(target) && $bqHqy.isPlainObject(source)) return $bqHqy.merge(target, source);
        else if ($bqHqy.isPlainObject(source)) return $bqHqy.merge({}, source);
        else if ($bqHqy.isArray(source)) return source.slice();
        return source;
    };
    var mergeDeepProperties = // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$bqHqy.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$bqHqy.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    };
    var valueFromConfig2 = // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$bqHqy.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    };
    var defaultToConfig2 = // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$bqHqy.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$bqHqy.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    };
    var mergeDirectKeys = // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    };
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $bqHqy.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $bqHqy.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRequire.register("xtD9d", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
"use strict";

var $exWX2 = parcelRequire("exWX2");
var $064a112a4be9a980$require$VERSION = $exWX2.version;
var $064a112a4be9a980$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $064a112a4be9a980$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $1ObTH._)(thing)) === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $064a112a4be9a980$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $064a112a4be9a980$var$validators.transitional = function transitional(validator, version, message) {
    var formatMessage = function formatMessage(opt, desc) {
        return "[Axios v" + $064a112a4be9a980$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    };
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        if (version && !$064a112a4be9a980$var$deprecatedWarnings[opt]) {
            $064a112a4be9a980$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $064a112a4be9a980$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    assertOptions: $064a112a4be9a980$var$assertOptions,
    validators: $064a112a4be9a980$var$validators
};

});
parcelRequire.register("exWX2", function(module, exports) {
module.exports = {
    "version": "0.25.0"
};

});



parcelRequire.register("cGFhJ", function(module, exports) {
"use strict";

var $9GdAt = parcelRequire("9GdAt");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $93c96e9c293c71cc$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $9GdAt(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $93c96e9c293c71cc$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $93c96e9c293c71cc$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $93c96e9c293c71cc$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $93c96e9c293c71cc$var$CancelToken.source = function source() {
    var cancel;
    var token = new $93c96e9c293c71cc$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $93c96e9c293c71cc$var$CancelToken;

});

parcelRequire.register("dvT58", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRequire.register("4xqmh", function(module, exports) {
"use strict";

var $bqHqy = parcelRequire("bqHqy");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $bqHqy.isObject(payload) && payload.isAxiosError === true;
};

});



parcelRequire.register("gTjEX", function(module, exports) {
module.exports = JSON.parse('{"name":"@orbs-network/ton-access","version":"2.3.3","description":"Unthrottled anonymous RPC access to TON blockchain via a robust decentralized network","source":"lib/index.js","main":"lib/index.js","types":"lib/index.d.ts","files":["lib/**/*"],"scripts":{"test":"env mocha -r ts-node/register test/**/*.ts","test:v2":"env mocha -r ts-node/register test/ton-v2.ts","test:v4":"env mocha -r ts-node/register test/ton-v4.ts","cleanup":"rimraf ./lib","build:web:reg":"esbuild ./lib/web.js --bundle  --sourcemap --target=es2015 --outfile=./dist/index.js","build:web:min":"esbuild ./lib/web.js --bundle  --minify    --target=es2015 --outfile=./dist/index.min.js","build:web":"rimraf ./dist && npm run build:web:reg && npm run build:web:min","build":"npm run lint && rimraf ./lib && tsc && npm run build:web","format":"prettier --write \\"src/**/*.ts\\"","lint":"tslint -p tsconfig.json","prepare":"npm run build","prepublishOnly":"npm test && npm run lint","preversion":"npm run lint","version":"npm run format && git add -A src","postversion":"git push && git push --tags"},"repository":{"type":"git","url":"git+https://github.com/orbs-network/ton-access.git"},"author":"yuval@orbs.com","license":"MIT","bugs":{"url":"https://github.com/orbs-network/ton-access/issues"},"homepage":"https://github.com/orbs-network/ton-access#readme","dependencies":{"isomorphic-fetch":"^3.0.0"},"devDependencies":{"@types/bn.js":"^5.1.1","@types/chai":"^4.3.4","@types/isomorphic-fetch":"^0.0.36","@types/mocha":"^10.0.0","buffer":"^6.0.3","chai":"^4.3.7","esbuild":"^0.15.14","mocha":"^10.1.0","prettier":"^2.7.1","rimraf":"^3.0.2","ton":"^12.1.3","ton-lite-client":"npm:@truecarry/ton-lite-client@^1.6.1","tonweb":"^0.0.58","ts-node":"^10.9.1","tslib":"^2.4.0","tslint":"^6.1.3","tslint-config-prettier":"^1.18.0"}}');

});

var $fba0f23e9e6a11bb$exports = {};
"use strict";

$fba0f23e9e6a11bb$exports = (parcelRequire("a58XM"));



var $6cds3 = parcelRequire("6cds3");
var $64d0b1ebdd6bcffe$exports = {};

$parcel$export($64d0b1ebdd6bcffe$exports, "createRoot", function () { return $64d0b1ebdd6bcffe$export$882461b6382ed46c; }, function (v) { return $64d0b1ebdd6bcffe$export$882461b6382ed46c = v; });
$parcel$export($64d0b1ebdd6bcffe$exports, "hydrateRoot", function () { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e; }, function (v) { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e = v; });
var $64d0b1ebdd6bcffe$export$882461b6382ed46c;
var $64d0b1ebdd6bcffe$export$757ceba2d55c277e;
"use strict";
var $6d4849ee44552f5f$exports = {};
"use strict";
function $6d4849ee44552f5f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6d4849ee44552f5f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6d4849ee44552f5f$var$checkDCE();

$6d4849ee44552f5f$exports = (parcelRequire("jZA9I"));


var $64d0b1ebdd6bcffe$var$i;
$64d0b1ebdd6bcffe$export$882461b6382ed46c = $6d4849ee44552f5f$exports.createRoot;
$64d0b1ebdd6bcffe$export$757ceba2d55c277e = $6d4849ee44552f5f$exports.hydrateRoot;




var $22b0248484642385$exports = {};


$22b0248484642385$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + (parcelRequire("lGKbD")).resolve("kFvGy");


var $ca9b163af4bfc596$export$8b251419efc915eb = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("nav", {
        className: "flex items-center justify-between gap-16 p-3",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "flex items-center align-center gap-16",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                    href: "/",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                        className: "cursor-pointer",
                        width: "180",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($22b0248484642385$exports))),
                        alt: "RedStone logo"
                    })
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                className: "bg-white hover:opacity-75 text-redstone py-2 px-4 rounded-full border border-redstone",
                href: "https://discord.com/invite/PVxBZKFr46",
                target: "_blank",
                children: "Contact us"
            })
        ]
    });
};



var $891cf22c6858c6d0$exports = {};


$891cf22c6858c6d0$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + (parcelRequire("lGKbD")).resolve("a1UWI");


var $816946cae08bbf36$exports = {};


$816946cae08bbf36$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + (parcelRequire("lGKbD")).resolve("9hRdi");


var $e6b8fa2f7ac44a5c$exports = {};


$e6b8fa2f7ac44a5c$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + (parcelRequire("lGKbD")).resolve("h7Wh4");


var $ee949654561f43e0$exports = {};


$ee949654561f43e0$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + (parcelRequire("lGKbD")).resolve("1DY7j");


var $1d10e2dedeefcec7$export$a06f1c675e846f6f = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("footer", {
        className: "flex mt-auto mb-5 w-full justify-center gap-6",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                    className: "flex text-sm text-gray-500",
                    children: "\xa9 RedStone 2022"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "flex gap-3",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                        href: "https://discord.com/invite/PVxBZKFr46",
                        target: "_blank",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ee949654561f43e0$exports))),
                            alt: "Discord logo"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                        href: "https://twitter.com/redstone_defi",
                        target: "_blank",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($816946cae08bbf36$exports))),
                            alt: "Twitter logo"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                        href: "mailto:hello@redstone.finance",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($891cf22c6858c6d0$exports))),
                            alt: "Mail logo"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                        href: "https://github.com/redstone-finance",
                        target: "_blank",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e6b8fa2f7ac44a5c$exports))),
                            alt: "Github logo"
                        })
                    })
                ]
            })
        ]
    });
};



var $byzP8 = parcelRequire("byzP8");

var $8OnJk = parcelRequire("8OnJk");

var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");


var $byzP8 = parcelRequire("byzP8");

var $gPjjc = parcelRequire("gPjjc");

var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");

var $6cds3 = parcelRequire("6cds3");

var $ldxXU = parcelRequire("ldxXU");
var $5f6146cb2a3d4ecb$exports = {};

var $1ObTH = parcelRequire("1ObTH");
!function(e, t) {
    $5f6146cb2a3d4ecb$exports = t();
}(undefined, function() {
    return function(e) {
        var t = {};
        function n(i) {
            if (t[i]) return t[i].exports;
            var r = t[i] = {
                i: i,
                l: !1,
                exports: {}
            };
            return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
        }
        return n.m = e, n.c = t, n.d = function(e, t, i) {
            n.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: i
            });
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, n.t = function(e, t) {
            if (1 & t && (e = n(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var i = Object.create(null);
            if (n.r(i), Object.defineProperty(i, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var r in e)n.d(i, r, (function(t) {
                return e[t];
            }).bind(null, r));
            return i;
        }, n.n = function(e) {
            var t = e && e.__esModule ? function t() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, "a", t), t;
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 25);
    }([
        function(e, t, n) {
            "use strict";
            var r = function r(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                function n() {
                    this.constructor = e;
                }
                i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
            };
            var u = function u(e, t) {
                var _$n = {};
                for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (_$n[i] = e[i]);
                if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                    var r = 0;
                    for(i = Object.getOwnPropertySymbols(e); r < i.length; r++)t.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[r]) && (_$n[i[r]] = e[i[r]]);
                }
                return _$n;
            };
            var o = function o(e, t, n, i) {
                var r, M = arguments.length, u = M < 3 ? t : null === i ? i = Object.getOwnPropertyDescriptor(t, n) : i;
                if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) u = Reflect.decorate(e, t, n, i);
                else for(var o = e.length - 1; o >= 0; o--)(r = e[o]) && (u = (M < 3 ? r(u) : M > 3 ? r(t, n, u) : r(t, n)) || u);
                return M > 3 && u && Object.defineProperty(t, n, u), u;
            };
            var c = function c(e, t) {
                return function(n, i) {
                    t(n, i, e);
                };
            };
            var a = function a(e, t) {
                if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
            };
            var I = function I(e, t, n, i) {
                return new (n || (n = Promise))(function(r, M) {
                    function u(e) {
                        try {
                            c(i.next(e));
                        } catch (e) {
                            M(e);
                        }
                    }
                    function o(e) {
                        try {
                            c(i.throw(e));
                        } catch (e) {
                            M(e);
                        }
                    }
                    function c(e) {
                        var _$t;
                        e.done ? r(e.value) : (_$t = e.value, _$t instanceof n ? _$t : new n(function(e) {
                            e(_$t);
                        })).then(u, o);
                    }
                    c((i = i.apply(e, t || [])).next());
                });
            };
            var l = function l(e, t) {
                var _$n, i, r, M, u = {
                    label: 0,
                    sent: function sent() {
                        if (1 & r[0]) throw r[1];
                        return r[1];
                    },
                    trys: [],
                    ops: []
                };
                return M = {
                    next: o(0),
                    throw: o(1),
                    return: o(2)
                }, "function" == typeof Symbol && (M[Symbol.iterator] = function() {
                    return this;
                }), M;
                function o(M) {
                    return function(o) {
                        return function(M) {
                            if (_$n) throw new TypeError("Generator is already executing.");
                            for(; u;)try {
                                if (_$n = 1, i && (r = 2 & M[0] ? i.return : M[0] ? i.throw || ((r = i.return) && r.call(i), 0) : i.next) && !(r = r.call(i, M[1])).done) return r;
                                switch(i = 0, r && (M = [
                                    2 & M[0],
                                    r.value
                                ]), M[0]){
                                    case 0:
                                    case 1:
                                        r = M;
                                        break;
                                    case 4:
                                        return u.label++, {
                                            value: M[1],
                                            done: !1
                                        };
                                    case 5:
                                        u.label++, i = M[1], M = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        M = u.ops.pop(), u.trys.pop();
                                        continue;
                                    default:
                                        if (!(r = u.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== M[0] && 2 !== M[0])) {
                                            u = 0;
                                            continue;
                                        }
                                        if (3 === M[0] && (!r || M[1] > r[0] && M[1] < r[3])) {
                                            u.label = M[1];
                                            break;
                                        }
                                        if (6 === M[0] && u.label < r[1]) {
                                            u.label = r[1], r = M;
                                            break;
                                        }
                                        if (r && u.label < r[2]) {
                                            u.label = r[2], u.ops.push(M);
                                            break;
                                        }
                                        r[2] && u.ops.pop(), u.trys.pop();
                                        continue;
                                }
                                M = t.call(e, u);
                            } catch (e) {
                                M = [
                                    6,
                                    e
                                ], i = 0;
                            } finally{
                                _$n = r = 0;
                            }
                            if (5 & M[0]) throw M[1];
                            return {
                                value: M[0] ? M[1] : void 0,
                                done: !0
                            };
                        }([
                            M,
                            o
                        ]);
                    };
                }
            };
            var j = function j(e, t) {
                for(var _$n in e)"default" === _$n || Object.prototype.hasOwnProperty.call(t, _$n) || N(t, e, _$n);
            };
            var g = function g(e) {
                var _$t = "function" == typeof Symbol && Symbol.iterator, _$n = _$t && e[_$t], i = 0;
                if (_$n) return _$n.call(e);
                if (e && "number" == typeof e.length) return {
                    next: function next() {
                        return e && i >= e.length && (e = void 0), {
                            value: e && e[i++],
                            done: !e
                        };
                    }
                };
                throw new TypeError(_$t ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            var s = function s(e, t) {
                var _$n = "function" == typeof Symbol && e[Symbol.iterator];
                if (!_$n) return e;
                var i, r, M = _$n.call(e), u = [];
                try {
                    for(; (void 0 === t || t-- > 0) && !(i = M.next()).done;)u.push(i.value);
                } catch (e) {
                    r = {
                        error: e
                    };
                } finally{
                    try {
                        i && !i.done && (_$n = M.return) && _$n.call(M);
                    } finally{
                        if (r) throw r.error;
                    }
                }
                return u;
            };
            var A = function A() {
                for(var e = [], _$t = 0; _$t < arguments.length; _$t++)e = e.concat(s(arguments[_$t]));
                return e;
            };
            var D = function D() {
                for(var e = 0, _$t = 0, _$n = arguments.length; _$t < _$n; _$t++)e += arguments[_$t].length;
                var i = Array(e), r = 0;
                for(_$t = 0; _$t < _$n; _$t++)for(var M = arguments[_$t], u = 0, o = M.length; u < o; u++, r++)i[r] = M[u];
                return i;
            };
            var d = function d(e, t, n) {
                if (n || 2 === arguments.length) for(var i, r = 0, M = t.length; r < M; r++)!i && r in t || (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
                return e.concat(i || Array.prototype.slice.call(t));
            };
            var y = function y(e, t, n) {
                if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                var i, r = n.apply(e, t || []), M = [];
                return i = {}, u("next"), u("throw"), u("return"), i[Symbol.asyncIterator] = function() {
                    return this;
                }, i;
                function u(e) {
                    r[e] && (i[e] = function(t) {
                        return new Promise(function(n, i) {
                            M.push([
                                e,
                                t,
                                n,
                                i
                            ]) > 1 || o(e, t);
                        });
                    });
                }
                function o(e, t) {
                    try {
                        (_$n = r[e](t)).value instanceof T ? Promise.resolve(_$n.value.v).then(c, a) : I(M[0][2], _$n);
                    } catch (e) {
                        I(M[0][3], e);
                    }
                    var _$n;
                }
                function c(e) {
                    o("next", e);
                }
                function a(e) {
                    o("throw", e);
                }
                function I(e, t) {
                    e(t), M.shift(), M.length && o(M[0][0], M[0][1]);
                }
            };
            var z = function z(e) {
                var _$t, _$n;
                return _$t = {}, i("next"), i("throw", function(e) {
                    throw e;
                }), i("return"), _$t[Symbol.iterator] = function() {
                    return this;
                }, _$t;
                function i(i, r) {
                    _$t[i] = e[i] ? function(t) {
                        return (_$n = !_$n) ? {
                            value: T(e[i](t)),
                            done: "return" === i
                        } : r ? r(t) : t;
                    } : r;
                }
            };
            var w = function w(e) {
                if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                var _$t, _$n = e[Symbol.asyncIterator];
                return _$n ? _$n.call(e) : (e = g(e), _$t = {}, i("next"), i("throw"), i("return"), _$t[Symbol.asyncIterator] = function() {
                    return this;
                }, _$t);
                function i(n) {
                    _$t[n] = e[n] && function(t) {
                        return new Promise(function(i, r) {
                            (function(e, t, n, i) {
                                Promise.resolve(i).then(function(t) {
                                    e({
                                        value: t,
                                        done: n
                                    });
                                }, t);
                            })(i, r, (t = e[n](t)).done, t.value);
                        });
                    };
                }
            };
            var f = function f(e, t) {
                return Object.defineProperty ? Object.defineProperty(e, "raw", {
                    value: t
                }) : e.raw = t, e;
            };
            var E = function E(e) {
                if (e && e.__esModule) return e;
                var _$t = {};
                if (null != e) for(var _$n in e)"default" !== _$n && Object.prototype.hasOwnProperty.call(e, _$n) && N(_$t, e, _$n);
                return L(_$t, e), _$t;
            };
            var C = function C(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            };
            var x = function x(e, t, n, i) {
                if ("a" === n && !i) throw new TypeError("Private accessor was defined without a getter");
                if ("function" == typeof t ? e !== t || !i : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
                return "m" === n ? i : "a" === n ? i.call(e) : i ? i.value : t.get(e);
            };
            var p = function p(e, t, n, i, r) {
                if ("m" === i) throw new TypeError("Private method is not writable");
                if ("a" === i && !r) throw new TypeError("Private accessor was defined without a setter");
                if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
                return "a" === i ? r.call(e, n) : r ? r.value = n : t.set(e, n), n;
            };
            n.r(t), n.d(t, "__extends", function() {
                return r;
            }), n.d(t, "__assign", function() {
                return M;
            }), n.d(t, "__rest", function() {
                return u;
            }), n.d(t, "__decorate", function() {
                return o;
            }), n.d(t, "__param", function() {
                return c;
            }), n.d(t, "__metadata", function() {
                return a;
            }), n.d(t, "__awaiter", function() {
                return I;
            }), n.d(t, "__generator", function() {
                return l;
            }), n.d(t, "__createBinding", function() {
                return N;
            }), n.d(t, "__exportStar", function() {
                return j;
            }), n.d(t, "__values", function() {
                return g;
            }), n.d(t, "__read", function() {
                return s;
            }), n.d(t, "__spread", function() {
                return A;
            }), n.d(t, "__spreadArrays", function() {
                return D;
            }), n.d(t, "__spreadArray", function() {
                return d;
            }), n.d(t, "__await", function() {
                return T;
            }), n.d(t, "__asyncGenerator", function() {
                return y;
            }), n.d(t, "__asyncDelegator", function() {
                return z;
            }), n.d(t, "__asyncValues", function() {
                return w;
            }), n.d(t, "__makeTemplateObject", function() {
                return f;
            }), n.d(t, "__importStar", function() {
                return E;
            }), n.d(t, "__importDefault", function() {
                return C;
            }), n.d(t, "__classPrivateFieldGet", function() {
                return x;
            }), n.d(t, "__classPrivateFieldSet", function() {
                return p;
            });
            /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var i = function i1(e, t) {
                return (i = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var _$n in t)Object.prototype.hasOwnProperty.call(t, _$n) && (e[_$n] = t[_$n]);
                })(e, t);
            };
            var M = function M1() {
                return (M = Object.assign || function(e) {
                    for(var _$t, _$n = 1, i = arguments.length; _$n < i; _$n++)for(var r in _$t = arguments[_$n])Object.prototype.hasOwnProperty.call(_$t, r) && (e[r] = _$t[r]);
                    return e;
                }).apply(this, arguments);
            };
            var N = Object.create ? function N(e, t, n, i) {
                void 0 === i && (i = n), Object.defineProperty(e, i, {
                    enumerable: !0,
                    get: function get() {
                        return t[n];
                    }
                });
            } : function(e, t, n, i) {
                void 0 === i && (i = n), e[i] = t[n];
            };
            function T(e) {
                return this instanceof T ? (this.v = e, this) : new T(e);
            }
            var L = Object.create ? function L(e, t) {
                Object.defineProperty(e, "default", {
                    enumerable: !0,
                    value: t
                });
            } : function(e, t) {
                e.default = t;
            };
        },
        function(e, t, n) {
            "use strict";
            e.exports = n(27);
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            i.__exportStar(n(34), t), i.__exportStar(n(35), t), i.__exportStar(n(36), t), i.__exportStar(n(37), t);
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            i.__exportStar(n(32), t), i.__exportStar(n(110), t), i.__exportStar(n(10), t);
        },
        function(e, t, n) {
            "use strict";
            var i;
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.themesList = void 0;
            var r = n(0), M = r.__importDefault(n(38)), u = r.__importDefault(n(39));
            t.themesList = ((i = {
                default: M.default
            })[M.default.name] = M.default, i[u.default.name] = u.default, i);
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.providers = t.injected = t.connectors = void 0;
            var i = n(0), r = i.__importStar(n(40));
            t.connectors = r;
            var M = i.__importStar(n(12));
            t.injected = M;
            var u = i.__importStar(n(94));
            t.providers = u;
        },
        function(e, t, n) {
            "use strict";
            e.exports = n(115);
        },
        function(e, t, n) {
            "use strict";
            var c = function c(e) {
                return i.isMemo(e) ? u : o[e.$$typeof] || r;
            };
            var i = n(116), r = {
                childContextTypes: !0,
                contextType: !0,
                contextTypes: !0,
                defaultProps: !0,
                displayName: !0,
                getDefaultProps: !0,
                getDerivedStateFromError: !0,
                getDerivedStateFromProps: !0,
                mixins: !0,
                propTypes: !0,
                type: !0
            }, M = {
                name: !0,
                length: !0,
                prototype: !0,
                caller: !0,
                callee: !0,
                arguments: !0,
                arity: !0
            }, u = {
                $$typeof: !0,
                compare: !0,
                defaultProps: !0,
                displayName: !0,
                propTypes: !0,
                type: !0
            }, o = {};
            o[i.ForwardRef] = {
                $$typeof: !0,
                render: !0,
                defaultProps: !0,
                displayName: !0,
                propTypes: !0
            }, o[i.Memo] = u;
            var a = Object.defineProperty, I = Object.getOwnPropertyNames, l = Object.getOwnPropertySymbols, N = Object.getOwnPropertyDescriptor, j = Object.getPrototypeOf, g = Object.prototype;
            e.exports = function e(t, n, i) {
                if ("string" != typeof n) {
                    if (g) {
                        var r = j(n);
                        r && r !== g && e(t, r, i);
                    }
                    var u = I(n);
                    l && (u = u.concat(l(n)));
                    for(var o = c(t), s = c(n), A = 0; A < u.length; ++A){
                        var D = u[A];
                        if (!(M[D] || i && i[D] || s && s[D] || o && o[D])) {
                            var d = N(n, D);
                            try {
                                a(t, D, d);
                            } catch (e) {}
                        }
                    }
                }
                return t;
            };
        },
        function(e, t, n) {
            "use strict";
            var i = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, r = function(e) {
                var _$t = {};
                return function(n) {
                    return void 0 === _$t[n] && (_$t[n] = e(n)), _$t[n];
                };
            }(function(e) {
                return i.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
            });
            t.a = r;
        },
        function(e, t, n) {
            "use strict";
            var u = function u(e) {
                if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
                return Object(e);
            };
            /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ var i = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, M = Object.prototype.propertyIsEnumerable;
            e.exports = function() {
                try {
                    if (!Object.assign) return !1;
                    var _$e = new String("abc");
                    if (_$e[5] = "de", "5" === Object.getOwnPropertyNames(_$e)[0]) return !1;
                    for(var t = {}, n = 0; n < 10; n++)t["_" + String.fromCharCode(n)] = n;
                    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function(e) {
                        return t[e];
                    }).join("")) return !1;
                    var i = {};
                    return "abcdefghijklmnopqrst".split("").forEach(function(e) {
                        i[e] = e;
                    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, i)).join("");
                } catch (e) {
                    return !1;
                }
            }() ? Object.assign : function(e, t) {
                for(var n, o, c = u(e), a = 1; a < arguments.length; a++){
                    for(var I in n = Object(arguments[a]))r.call(n, I) && (c[I] = n[I]);
                    if (i) {
                        o = i(n);
                        for(var l = 0; l < o.length; l++)M.call(n, o[l]) && (c[o[l]] = n[o[l]]);
                    }
                }
                return c;
            };
        },
        function(e, t, n) {
            "use strict";
            var o = function o() {
                var e = {
                    injectedAvailable: !!window.ethereum || !!window.web3
                };
                if (e.injectedAvailable) {
                    var _$t = !0;
                    Object.values(u.injected).forEach(function(n) {
                        c(n.check) && (e[n.check] = !0, _$t = !1);
                    });
                    var _$n = i.detect();
                    _$n && "opera" === _$n.name && (e[u.injected.OPERA.check] = !0, _$t = !1), _$t && (e[u.injected.FALLBACK.check] = !0);
                }
                return e;
            };
            var c = function c(e) {
                return window.ethereum ? window.ethereum[e] : window.web3 && window.web3.currentProvider && window.web3.currentProvider[e];
            };
            var a = function a() {
                var e = null, _$t = o();
                _$t.injectedAvailable && (delete _$t.injectedAvailable, e = I(Object.keys(_$t)));
                return e;
            };
            var I = function I(e) {
                return N("check", j(e));
            };
            var l = function l(e, t, n) {
                var i = n, r = e.filter(t);
                return r && r.length && (i = r[0]), i;
            };
            var N = function N(e, t) {
                return t && l(Object.values(u.providers), function(n) {
                    return n[e] === t;
                }, u.providers.FALLBACK) || u.providers.FALLBACK;
            };
            var j = function j(e) {
                return e && e.length ? e.length > 1 && (e[0] === u.injected.METAMASK.check || e[0] === u.injected.CIPHER.check) ? e[1] : e[0] : u.providers.FALLBACK.check;
            };
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.isLocalStorageAvailable = t.findMatchingRequiredOptions = t.getThemeColors = t.getChainId = t.filterProviderChecks = t.filterProviders = t.filterMatches = t.getProviderDescription = t.isMobile = t.getProviderInfoByCheck = t.getProviderInfoById = t.getProviderInfoByName = t.getProviderInfoFromChecksArray = t.getProviderInfo = t.getInjectedProviderName = t.getInjectedProvider = t.verifyInjectedProvider = t.checkInjectedProviders = void 0;
            var i = n(0).__importStar(n(33)), r = n(2), M = n(4), u = n(5);
            t.checkInjectedProviders = o, t.verifyInjectedProvider = c, t.getInjectedProvider = a, t.getInjectedProviderName = function() {
                var e = a();
                return e ? e.name : null;
            }, t.getProviderInfo = function(e) {
                return e ? I(Object.values(u.providers).filter(function(t) {
                    return e[t.check];
                }).map(function(e) {
                    return e.check;
                })) : u.providers.FALLBACK;
            }, t.getProviderInfoFromChecksArray = I, t.getProviderInfoByName = function(e) {
                return N("name", e);
            }, t.getProviderInfoById = function(e) {
                return N("id", e);
            }, t.getProviderInfoByCheck = function(e) {
                return N("check", e);
            }, t.isMobile = function() {
                return !(!/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) && !/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(navigator.userAgent.substr(0, 4)) && !function() {
                    try {
                        return document.createEvent("TouchEvent"), !0;
                    } catch (e) {
                        return !1;
                    }
                }());
            }, t.getProviderDescription = function(e) {
                if (e.description) return e.description;
                var _$t = "";
                switch(e.type){
                    case "injected":
                        _$t = "Connect to your " + e.name + " Wallet";
                        break;
                    case "web":
                        _$t = "Connect with your " + e.name + " account";
                        break;
                    case "qrcode":
                        _$t = "Scan with " + e.name + " to connect";
                        break;
                    case "hardware":
                        _$t = "Connect to your " + e.name + " Hardware Wallet";
                }
                return _$t;
            }, t.filterMatches = l, t.filterProviders = N, t.filterProviderChecks = j, t.getChainId = function(e) {
                var _$t = l(Object.values(r.CHAIN_DATA_LIST), function(t) {
                    return t.network === e;
                }, void 0);
                if (!_$t) throw new Error("No chainId found match " + e);
                return _$t.chainId;
            }, t.getThemeColors = function(e) {
                return "string" == typeof e ? M.themesList[e].colors : e;
            }, t.findMatchingRequiredOptions = function e(t, n) {
                return t.filter(function(t) {
                    if ("string" == typeof t) return t in n;
                    var i = e(t, n);
                    return i && i.length;
                });
            }, t.isLocalStorageAvailable = function() {
                try {
                    return localStorage.setItem("test", "test"), localStorage.removeItem("test"), !0;
                } catch (e) {
                    return !1;
                }
            };
        },
        function(e, t) {
            var M = function M() {
                throw new Error("setTimeout has not been defined");
            };
            var u = function u() {
                throw new Error("clearTimeout has not been defined");
            };
            var o = function o(e) {
                if (n === setTimeout) return setTimeout(e, 0);
                if ((n === M || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);
                try {
                    return n(e, 0);
                } catch (t) {
                    try {
                        return n.call(null, e, 0);
                    } catch (t) {
                        return n.call(this, e, 0);
                    }
                }
            };
            var N = function N() {
                I && c && (I = !1, c.length ? a = c.concat(a) : l = -1, a.length && j());
            };
            var j = function j() {
                if (!I) {
                    var _$e = o(N);
                    I = !0;
                    for(var t = a.length; t;){
                        for(c = a, a = []; ++l < t;)c && c[l].run();
                        l = -1, t = a.length;
                    }
                    c = null, I = !1, function(e) {
                        if (i === clearTimeout) return clearTimeout(e);
                        if ((i === u || !i) && clearTimeout) return i = clearTimeout, clearTimeout(e);
                        try {
                            i(e);
                        } catch (t) {
                            try {
                                return i.call(null, e);
                            } catch (t) {
                                return i.call(this, e);
                            }
                        }
                    }(_$e);
                }
            };
            var g = function g(e, t) {
                this.fun = e, this.array = t;
            };
            var s = function s() {};
            var n, i, r = e.exports = {};
            !function() {
                try {
                    n = "function" == typeof setTimeout ? setTimeout : M;
                } catch (e) {
                    n = M;
                }
                try {
                    i = "function" == typeof clearTimeout ? clearTimeout : u;
                } catch (e) {
                    i = u;
                }
            }();
            var c, a = [], I = !1, l = -1;
            r.nextTick = function(e) {
                var t = new Array(arguments.length - 1);
                if (arguments.length > 1) for(var n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                a.push(new g(e, t)), 1 !== a.length || I || o(j);
            }, g.prototype.run = function() {
                this.fun.apply(null, this.array);
            }, r.title = "browser", r.browser = !0, r.env = {}, r.argv = [], r.version = "", r.versions = {}, r.on = s, r.addListener = s, r.once = s, r.off = s, r.removeListener = s, r.removeAllListeners = s, r.emit = s, r.prependListener = s, r.prependOnceListener = s, r.listeners = function(e) {
                return [];
            }, r.binding = function(e) {
                throw new Error("process.binding is not supported");
            }, r.cwd = function() {
                return "/";
            }, r.chdir = function(e) {
                throw new Error("process.chdir is not supported");
            }, r.umask = function() {
                return 0;
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.RAINBOW = t.PHANTOM = t.ZERION = t.GAMESTOP = t.TOKENPOCKET = t.CORE = t.BITKEEPWALLET = t.CLV = t.BRAVE = t.RABBY = t.SEQUENCEINJECTED = t.PORTAL = t.TALLYINJECTED = t.BLOCKWALLET = t.CELOINJECTED = t.BITPIE = t.XDEFI = t.RWALLET = t.MATHWALLET = t.BOLTX = t.LIQUALITY = t.FRAMEINJECTED = t.TOKENARY = t.STATUS = t.IMTOKEN = t.CIPHER = t.COINBASE = t.TRUST = t.OPERA = t.DAPPER = t.NIFTY = t.SAFE = t.METAMASK = t.FALLBACK = void 0;
            var i = n(0), r = i.__importDefault(n(64)), M = i.__importDefault(n(65)), u = i.__importDefault(n(66)), o = i.__importDefault(n(67)), c = i.__importDefault(n(68)), a = i.__importDefault(n(69)), I = i.__importDefault(n(70)), l = i.__importDefault(n(71)), N = i.__importDefault(n(72)), j = i.__importDefault(n(73)), g = i.__importDefault(n(74)), s = i.__importDefault(n(13)), A = i.__importDefault(n(14)), D = i.__importDefault(n(75)), d = i.__importDefault(n(76)), T = i.__importDefault(n(77)), y = i.__importDefault(n(78)), z = i.__importDefault(n(79)), w = i.__importDefault(n(80)), f = i.__importDefault(n(81)), L = i.__importDefault(n(82)), E = i.__importDefault(n(83)), C = i.__importDefault(n(84)), x = i.__importDefault(n(15)), p = i.__importDefault(n(85)), S = i.__importDefault(n(86)), m = i.__importDefault(n(16)), O = i.__importDefault(n(87)), v = i.__importDefault(n(88)), b = i.__importDefault(n(89)), h = i.__importDefault(n(90)), k = i.__importDefault(n(91)), Q = i.__importDefault(n(92)), Y = i.__importDefault(n(93));
            t.FALLBACK = {
                id: "injected",
                name: "Web3",
                logo: r.default,
                type: "injected",
                check: "isWeb3"
            }, t.METAMASK = {
                id: "injected",
                name: "MetaMask",
                logo: M.default,
                type: "injected",
                check: "isMetaMask"
            }, t.SAFE = {
                id: "injected",
                name: "Safe",
                logo: u.default,
                type: "injected",
                check: "isSafe"
            }, t.NIFTY = {
                id: "injected",
                name: "Nifty",
                logo: o.default,
                type: "injected",
                check: "isNiftyWallet"
            }, t.DAPPER = {
                id: "injected",
                name: "Dapper",
                logo: a.default,
                type: "injected",
                check: "isDapper"
            }, t.OPERA = {
                id: "injected",
                name: "Opera",
                logo: s.default,
                type: "injected",
                check: "isOpera"
            }, t.TRUST = {
                id: "injected",
                name: "Trust",
                logo: c.default,
                type: "injected",
                check: "isTrust"
            }, t.COINBASE = {
                id: "injected",
                name: "Coinbase",
                logo: I.default,
                type: "injected",
                check: "isCoinbaseWallet"
            }, t.CIPHER = {
                id: "injected",
                name: "Cipher",
                logo: l.default,
                type: "injected",
                check: "isCipher"
            }, t.IMTOKEN = {
                id: "injected",
                name: "imToken",
                logo: N.default,
                type: "injected",
                check: "isImToken"
            }, t.STATUS = {
                id: "injected",
                name: "Status",
                logo: j.default,
                type: "injected",
                check: "isStatus"
            }, t.TOKENARY = {
                id: "injected",
                name: "Tokenary",
                logo: g.default,
                type: "injected",
                check: "isTokenary"
            }, t.FRAMEINJECTED = {
                id: "injected",
                name: "Frame",
                logo: A.default,
                type: "injected",
                check: "isFrame"
            }, t.LIQUALITY = {
                id: "injected",
                name: "Liquality",
                logo: D.default,
                type: "injected",
                check: "isLiquality"
            }, t.BOLTX = {
                id: "boltx",
                name: "Bolt-X",
                logo: d.default,
                type: "injected",
                check: "isBoltX"
            }, t.MATHWALLET = {
                id: "injected",
                name: "Math Wallet",
                logo: T.default,
                type: "injected",
                check: "isMathWallet"
            }, t.RWALLET = {
                id: "injected",
                name: "rWallet",
                logo: y.default,
                type: "injected",
                check: "isRWallet"
            }, t.XDEFI = {
                id: "injected",
                name: "XDEFI",
                logo: w.default,
                type: "injected",
                check: "__XDEFI"
            }, t.BITPIE = {
                id: "injected",
                name: "Bitpie",
                logo: z.default,
                type: "injected",
                check: "isBitpie"
            }, t.CELOINJECTED = {
                id: "injected",
                name: "Celo extension wallet",
                logo: f.default,
                type: "injected",
                check: "isCelo"
            }, t.BLOCKWALLET = {
                id: "injected",
                name: "BlockWallet",
                logo: L.default,
                type: "injected",
                check: "isBlockWallet"
            }, t.TALLYINJECTED = {
                id: "injected",
                name: "Tally",
                logo: E.default,
                type: "injected",
                check: "isTally"
            }, t.PORTAL = {
                id: "injected",
                name: "Ripio Portal",
                logo: C.default,
                type: "injected",
                check: "isPortal"
            }, t.SEQUENCEINJECTED = {
                id: "injected",
                name: "Sequence",
                logo: x.default,
                type: "injected",
                check: "isSequence"
            }, t.RABBY = {
                id: "injected",
                name: "Rabby",
                logo: S.default,
                type: "injected",
                check: "isRabby"
            }, t.BRAVE = {
                id: "injected",
                name: "Brave",
                logo: p.default,
                type: "injected",
                check: "isBraveWallet"
            }, t.CLV = {
                id: "injected",
                name: "CLV",
                logo: O.default,
                type: "injected",
                check: "isCloverWallet"
            }, t.BITKEEPWALLET = {
                id: "injected",
                name: "Bitkeep Wallet",
                logo: m.default,
                type: "injected",
                check: "isBitKeep"
            }, t.CORE = {
                id: "injected",
                name: "Core",
                logo: b.default,
                type: "injected",
                check: "isAvalanche"
            }, t.TOKENPOCKET = {
                id: "injected",
                name: "TokenPocket Wallet",
                logo: v.default,
                type: "injected",
                check: "isTokenPocket"
            }, t.GAMESTOP = {
                id: "injected",
                name: "GameStop Wallet",
                logo: h.default,
                type: "injected",
                check: "isGamestop"
            }, t.ZERION = {
                id: "injected",
                name: "Zerion Wallet",
                logo: k.default,
                type: "injected",
                check: "isZerion"
            }, t.PHANTOM = {
                id: "phantom",
                name: "Phantom",
                logo: Q.default,
                type: "injected",
                check: "isPhantom",
                package: {
                    required: [
                        "networkType"
                    ]
                }
            }, t.RAINBOW = {
                id: "injected",
                name: "Rainbow",
                logo: Y.default,
                type: "injected",
                check: "isRainbow"
            };
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDE1My40IDE1Mi45Ij48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9InBoYXNlIiBncmFkaWVudFRyYW5zZm9ybT0icm90YXRlKDQ1KSI+PHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6ICMyYjI1NGYiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiAjMTkyZjQ1Ii8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHBhdGggZmlsbD0idXJsKCcjcGhhc2UnKSIgZD0iTTE0NS4xLDc1LjZ2LTU4YzAtNS4xLTQuMi05LjMtOS4zLTkuM2gwSDc3LjdjLTAuNiwwLTEuMS0wLjItMS42LTAuNmwtNy03Yy0wLjQtMC40LTEtMC43LTEuNi0wLjdIOS4zIEM0LjIsMCwwLDQuMSwwLDkuM2MwLDAsMCwwLDAsMGwwLDB2NThjMCwwLjYsMC4yLDEuMSwwLjYsMS42bDcsN2MwLjQsMC40LDAuNywxLDAuNywxLjZ2NThjMCw1LjEsNC4yLDkuMyw5LjMsOS4zYzAsMCwwLDAsMCwwaDU4LjIgYzAuNiwwLDEuMSwwLjIsMS42LDAuNmw3LDdjMC40LDAuNCwxLDAuNiwxLjYsMC42aDU4LjJjNS4xLDAsOS4zLTQuMSw5LjMtOS4zYzAsMCwwLDAsMCwwbDAsMHYtNThjMC0wLjYtMC4yLTEuMS0wLjYtMS42bC03LTcgQzE0NS40LDc2LjcsMTQ1LjEsNzYuMiwxNDUuMSw3NS42eiBNMTA1LjYsMTA2LjZINDcuOWMtMC43LDAtMS4zLTAuNi0xLjMtMS4zVjQ3LjdjMC0wLjcsMC42LTEuMywxLjMtMS4zaDU3LjcgYzAuNywwLDEuMywwLjYsMS4zLDEuM3Y1Ny42QzEwNywxMDYsMTA2LjQsMTA2LjYsMTA1LjYsMTA2LjZ6Ii8+PC9zdmc+Cg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            i.__exportStar(n(111), t), i.__exportStar(n(19), t);
        },
        function(e, t, n) {
            "use strict";
            n.r(t), (function(e) {
                var d = function d(e) {
                    return "function" == typeof e;
                };
                var T = function T(e) {
                    return e.displayName || e.name || "Component";
                };
                var y = function y(e) {
                    return e && "string" == typeof e.styledComponentId;
                };
                var C = function C(e) {
                    for(var _$t = arguments.length, _$n = new Array(_$t > 1 ? _$t - 1 : 0), i = 1; i < _$t; i++)_$n[i - 1] = arguments[i];
                    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (_$n.length > 0 ? " Args: " + _$n.join(", ") : ""));
                };
                var F = function F(e) {
                    var _$t, _$n = "";
                    for(_$t = Math.abs(e); _$t > 52; _$t = _$t / 52 | 0)_$n = J(_$t % 52) + _$n;
                    return (J(_$t % 52) + _$n).replace(V, "$1-$2");
                };
                var q = function q(e) {
                    for(var _$t = 0; _$t < e.length; _$t += 1){
                        var _$n = e[_$t];
                        if (d(_$n) && !y(_$n)) return !1;
                    }
                    return !0;
                };
                var ne = function ne(e) {
                    var _$t, _$n, i, r, M = void 0 === e ? D : e, u = M.options, o = void 0 === u ? D : u, a = M.plugins, I = void 0 === a ? A : a, l = new c.a(o), N = [], j = function(e) {
                        function t(t) {
                            if (t) try {
                                e(t + "}");
                            } catch (e) {}
                        }
                        return function(n, i, r, M, u, o, c, a, I, l) {
                            switch(n){
                                case 1:
                                    if (0 === I && 64 === i.charCodeAt(0)) return e(i + ";"), "";
                                    break;
                                case 2:
                                    if (0 === a) return i + "/*|*/";
                                    break;
                                case 3:
                                    switch(a){
                                        case 102:
                                        case 112:
                                            return e(r[0] + i), "";
                                        default:
                                            return i + (0 === l ? "/*|*/" : "");
                                    }
                                case -2:
                                    i.split("/*|*/}").forEach(t);
                            }
                        };
                    }(function(e) {
                        N.push(e);
                    }), g = function g(e, i, M) {
                        return 0 === i && -1 !== te.indexOf(M[_$n.length]) || M.match(r) ? e : "." + _$t;
                    };
                    function s(e, M, u, o) {
                        void 0 === o && (o = "&");
                        var c = e.replace(ee, ""), a = M && u ? u + " " + M + " { " + c + " }" : c;
                        return _$t = o, _$n = M, i = new RegExp("\\" + _$n + "\\b", "g"), r = new RegExp("(\\" + _$n + "\\b){2,}"), l(u || !M ? "" : M, a);
                    }
                    return l.use([].concat(I, [
                        function(e, t, r) {
                            2 === e && r.length && r[0].lastIndexOf(_$n) > 0 && (r[0] = r[0].replace(i, g));
                        },
                        j,
                        function(e) {
                            if (-2 === e) {
                                var _$t = N;
                                return N = [], _$t;
                            }
                        }
                    ])), s.hash = I.length ? I.reduce(function(e, t) {
                        return t.name || C(15), X(e, t.name);
                    }, 5381).toString() : "", s;
                };
                var ce = function ce() {
                    return Object(r.useContext)(ie) || ue;
                };
                var ae = function ae() {
                    return Object(r.useContext)(Me) || oe;
                };
                var Ie = function Ie(e) {
                    var _$t = Object(r.useState)(e.stylisPlugins), _$n = _$t[0], i = _$t[1], u = ce(), c = Object(r.useMemo)(function() {
                        var _$t = u;
                        return e.sheet ? _$t = e.sheet : e.target && (_$t = _$t.reconstructWithOptions({
                            target: e.target
                        }, !1)), e.disableCSSOMInjection && (_$t = _$t.reconstructWithOptions({
                            useCSSOMInjection: !1
                        })), _$t;
                    }, [
                        e.disableCSSOMInjection,
                        e.sheet,
                        e.target
                    ]), a = Object(r.useMemo)(function() {
                        return ne({
                            options: {
                                prefix: !e.disableVendorPrefixes
                            },
                            plugins: _$n
                        });
                    }, [
                        e.disableVendorPrefixes,
                        _$n
                    ]);
                    return Object(r.useEffect)(function() {
                        o()(_$n, e.stylisPlugins) || i(e.stylisPlugins);
                    }, [
                        e.stylisPlugins
                    ]), M.a.createElement(ie.Provider, {
                        value: c
                    }, M.a.createElement(Me.Provider, {
                        value: a
                    }, e.children));
                };
                var Ae = function Ae(e) {
                    return Ne.test(e) ? e.replace(je, se).replace(ge, "-ms-") : e;
                };
                var ye = function ye(e) {
                    for(var _$t = arguments.length, _$n = new Array(_$t > 1 ? _$t - 1 : 0), i = 1; i < _$t; i++)_$n[i - 1] = arguments[i];
                    return d(e) || s(e) ? Te(de(g(A, [
                        e
                    ].concat(_$n)))) : 0 === _$n.length && 1 === e.length && "string" == typeof e[0] ? e : Te(de(g(e, _$n)));
                };
                var Le = function Le(e) {
                    return e.replace(we, "-").replace(fe, "");
                };
                var Ce = function Ce(e) {
                    return "string" == typeof e && !0;
                };
                var Se = function Se(e, t, n) {
                    var i = e[n];
                    xe(t) && xe(i) ? me(i, t) : e[n] = t;
                };
                var me = function me(e) {
                    for(var _$t = arguments.length, _$n = new Array(_$t > 1 ? _$t - 1 : 0), i = 1; i < _$t; i++)_$n[i - 1] = arguments[i];
                    for(var r = 0, M = _$n; r < M.length; r++){
                        var u = M[r];
                        if (xe(u)) for(var o in u)pe(o) && Se(e, u[o], o);
                    }
                    return e;
                };
                var be = function be(e) {
                    var _$t = Object(r.useContext)(Oe), _$n = Object(r.useMemo)(function() {
                        return function(e, t) {
                            return e ? d(e) ? e(t) : Array.isArray(e) || "object" != typeof e ? C(8) : t ? j({}, t, {}, e) : e : C(14);
                        }(e.theme, _$t);
                    }, [
                        e.theme,
                        _$t
                    ]);
                    return e.children ? M.a.createElement(Oe.Provider, {
                        value: _$n
                    }, e.children) : null;
                };
                var Pe = function Pe(e) {
                    for(var _$t = arguments.length, _$n = new Array(_$t > 1 ? _$t - 1 : 0), i = 1; i < _$t; i++)_$n[i - 1] = arguments[i];
                    var u = ye.apply(void 0, [
                        e
                    ].concat(_$n)), o = "sc-global-" + Ee(JSON.stringify(u)), c = new Ye(u, o);
                    function a(e) {
                        var _$t = ce(), _$n = ae(), i = Object(r.useContext)(Oe), M = Object(r.useRef)(_$t.allocateGSInstance(o)).current;
                        return _$t.server && I(M, e, _$t, i, _$n), Object(r.useLayoutEffect)(function() {
                            if (!_$t.server) return I(M, e, _$t, i, _$n), function() {
                                return c.removeStyles(M, _$t);
                            };
                        }, [
                            M,
                            e,
                            _$t,
                            i,
                            _$n
                        ]), null;
                    }
                    function I(e, t, n, i, r) {
                        if (c.isStatic) c.renderStyles(e, E, n, r);
                        else {
                            var M = j({}, t, {
                                theme: ze(t, i, a.defaultProps)
                            });
                            c.renderStyles(e, M, n, r);
                        }
                    }
                    return M.a.memo(a);
                };
                var Ue = function Ue(e) {
                    for(var _$t = arguments.length, _$n = new Array(_$t > 1 ? _$t - 1 : 0), i = 1; i < _$t; i++)_$n[i - 1] = arguments[i];
                    var r = ye.apply(void 0, [
                        e
                    ].concat(_$n)).join(""), M = Ee(r);
                    return new le(M, r);
                };
                n.d(t, "ServerStyleSheet", function() {
                    return Ze;
                }), n.d(t, "StyleSheetConsumer", function() {
                    return re;
                }), n.d(t, "StyleSheetContext", function() {
                    return ie;
                }), n.d(t, "StyleSheetManager", function() {
                    return Ie;
                }), n.d(t, "ThemeConsumer", function() {
                    return ve;
                }), n.d(t, "ThemeContext", function() {
                    return Oe;
                }), n.d(t, "ThemeProvider", function() {
                    return be;
                }), n.d(t, "__PRIVATE__", function() {
                    return Re;
                }), n.d(t, "createGlobalStyle", function() {
                    return Pe;
                }), n.d(t, "css", function() {
                    return ye;
                }), n.d(t, "isStyledComponent", function() {
                    return y;
                }), n.d(t, "keyframes", function() {
                    return Ue;
                }), n.d(t, "useTheme", function() {
                    return Be;
                }), n.d(t, "version", function() {
                    return w;
                }), n.d(t, "withTheme", function() {
                    return Ge;
                });
                var i = n(6), r = n(1), M = n.n(r), u = n(22), o = n.n(u), c = n(23), a = n(24), I = n(8), l = n(7), N = n.n(l);
                function j() {
                    return (j = Object.assign || function(e) {
                        for(var _$t = 1; _$t < arguments.length; _$t++){
                            var _$n = arguments[_$t];
                            for(var i in _$n)Object.prototype.hasOwnProperty.call(_$n, i) && (e[i] = _$n[i]);
                        }
                        return e;
                    }).apply(this, arguments);
                }
                var g = function g(e, t) {
                    for(var _$n = [
                        e[0]
                    ], i = 0, r = t.length; i < r; i += 1)_$n.push(t[i], e[i + 1]);
                    return _$n;
                }, s = function s(e) {
                    return null !== e && "object" == typeof e && "[object Object]" === (e.toString ? e.toString() : Object.prototype.toString.call(e)) && !Object(i.typeOf)(e);
                }, A = Object.freeze([]), D = Object.freeze({});
                var z = void 0 !== e && (e.env.REACT_APP_SC_ATTR || e.env.SC_ATTR) || "data-styled", w = "5.3.3", f = "undefined" != typeof window && "HTMLElement" in window, L = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : void 0 !== e && void 0 !== e.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== e.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== e.env.REACT_APP_SC_DISABLE_SPEEDY && e.env.REACT_APP_SC_DISABLE_SPEEDY : void 0 !== e && void 0 !== e.env.SC_DISABLE_SPEEDY && "" !== e.env.SC_DISABLE_SPEEDY && "false" !== e.env.SC_DISABLE_SPEEDY && e.env.SC_DISABLE_SPEEDY), E = {};
                var x = function() {
                    var _$e = function _$e(e) {
                        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
                    };
                    var _$t = _$e.prototype;
                    return _$t.indexOfGroup = function(e) {
                        for(var _$t = 0, _$n = 0; _$n < e; _$n++)_$t += this.groupSizes[_$n];
                        return _$t;
                    }, _$t.insertRules = function(e, t) {
                        if (e >= this.groupSizes.length) {
                            for(var _$n = this.groupSizes, i = _$n.length, r = i; e >= r;)(r <<= 1) < 0 && C(16, "" + e);
                            this.groupSizes = new Uint32Array(r), this.groupSizes.set(_$n), this.length = r;
                            for(var M = i; M < r; M++)this.groupSizes[M] = 0;
                        }
                        for(var u = this.indexOfGroup(e + 1), o = 0, c = t.length; o < c; o++)this.tag.insertRule(u, t[o]) && (this.groupSizes[e]++, u++);
                    }, _$t.clearGroup = function(e) {
                        if (e < this.length) {
                            var _$t = this.groupSizes[e], _$n = this.indexOfGroup(e), i = _$n + _$t;
                            this.groupSizes[e] = 0;
                            for(var r = _$n; r < i; r++)this.tag.deleteRule(_$n);
                        }
                    }, _$t.getGroup = function(e) {
                        var _$t = "";
                        if (e >= this.length || 0 === this.groupSizes[e]) return _$t;
                        for(var _$n = this.groupSizes[e], i = this.indexOfGroup(e), r = i + _$n, M = i; M < r; M++)_$t += this.tag.getRule(M) + "/*!sc*/\n";
                        return _$t;
                    }, _$e;
                }(), p = new Map, S = new Map, m = 1, O = function O(e) {
                    if (p.has(e)) return p.get(e);
                    for(; S.has(m);)m++;
                    var _$t = m++;
                    return p.set(e, _$t), S.set(_$t, e), _$t;
                }, v = function v(e) {
                    return S.get(e);
                }, b = function b(e, t) {
                    t >= m && (m = t + 1), p.set(e, t), S.set(t, e);
                }, h = "style[" + z + '][data-styled-version="5.3.3"]', k = new RegExp("^" + z + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), Q = function Q(e, t, n) {
                    for(var i, r = n.split(","), M = 0, u = r.length; M < u; M++)(i = r[M]) && e.registerName(t, i);
                }, Y = function Y(e, t) {
                    for(var _$n = (t.textContent || "").split("/*!sc*/\n"), i = [], r = 0, M = _$n.length; r < M; r++){
                        var u = _$n[r].trim();
                        if (u) {
                            var o = u.match(k);
                            if (o) {
                                var c = 0 | parseInt(o[1], 10), a = o[2];
                                0 !== c && (b(a, c), Q(e, a, o[3]), e.getTag().insertRules(c, i)), i.length = 0;
                            } else i.push(u);
                        }
                    }
                }, P = function P() {
                    return "undefined" != typeof window && void 0 !== window.__webpack_nonce__ ? window.__webpack_nonce__ : null;
                }, U = function U(e) {
                    var _$t = document.head, _$n = e || _$t, i = document.createElement("style"), r = function(e) {
                        for(var _$t = e.childNodes, _$n = _$t.length; _$n >= 0; _$n--){
                            var i = _$t[_$n];
                            if (i && 1 === i.nodeType && i.hasAttribute(z)) return i;
                        }
                    }(_$n), M = void 0 !== r ? r.nextSibling : null;
                    i.setAttribute(z, "active"), i.setAttribute("data-styled-version", "5.3.3");
                    var u = P();
                    return u && i.setAttribute("nonce", u), _$n.insertBefore(i, M), i;
                }, Z = function() {
                    var _$e = function _$e(e) {
                        var _$t = this.element = U(e);
                        _$t.appendChild(document.createTextNode("")), this.sheet = function(e) {
                            if (e.sheet) return e.sheet;
                            for(var _$t = document.styleSheets, _$n = 0, i = _$t.length; _$n < i; _$n++){
                                var r = _$t[_$n];
                                if (r.ownerNode === e) return r;
                            }
                            C(17);
                        }(_$t), this.length = 0;
                    };
                    var _$t = _$e.prototype;
                    return _$t.insertRule = function(e, t) {
                        try {
                            return this.sheet.insertRule(t, e), this.length++, !0;
                        } catch (e) {
                            return !1;
                        }
                    }, _$t.deleteRule = function(e) {
                        this.sheet.deleteRule(e), this.length--;
                    }, _$t.getRule = function(e) {
                        var _$t = this.sheet.cssRules[e];
                        return void 0 !== _$t && "string" == typeof _$t.cssText ? _$t.cssText : "";
                    }, _$e;
                }(), G = function() {
                    var _$e = function _$e(e) {
                        var _$t = this.element = U(e);
                        this.nodes = _$t.childNodes, this.length = 0;
                    };
                    var _$t = _$e.prototype;
                    return _$t.insertRule = function(e, t) {
                        if (e <= this.length && e >= 0) {
                            var _$n = document.createTextNode(t), i = this.nodes[e];
                            return this.element.insertBefore(_$n, i || null), this.length++, !0;
                        }
                        return !1;
                    }, _$t.deleteRule = function(e) {
                        this.element.removeChild(this.nodes[e]), this.length--;
                    }, _$t.getRule = function(e) {
                        return e < this.length ? this.nodes[e].textContent : "";
                    }, _$e;
                }(), B = function() {
                    var _$e = function _$e(e) {
                        this.rules = [], this.length = 0;
                    };
                    var _$t = _$e.prototype;
                    return _$t.insertRule = function(e, t) {
                        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
                    }, _$t.deleteRule = function(e) {
                        this.rules.splice(e, 1), this.length--;
                    }, _$t.getRule = function(e) {
                        return e < this.length ? this.rules[e] : "";
                    }, _$e;
                }(), R = f, W = {
                    isServer: !f,
                    useCSSOMInjection: !L
                }, H = function() {
                    var _$e = function _$e(e, t, n) {
                        void 0 === e && (e = D), void 0 === t && (t = {}), this.options = j({}, W, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && f && R && (R = !1, function(e) {
                            for(var _$t = document.querySelectorAll(h), _$n = 0, i = _$t.length; _$n < i; _$n++){
                                var r = _$t[_$n];
                                r && "active" !== r.getAttribute(z) && (Y(e, r), r.parentNode && r.parentNode.removeChild(r));
                            }
                        }(this));
                    };
                    _$e.registerId = function(e) {
                        return O(e);
                    };
                    var _$t = _$e.prototype;
                    return _$t.reconstructWithOptions = function(t, n) {
                        return void 0 === n && (n = !0), new _$e(j({}, this.options, {}, t), this.gs, n && this.names || void 0);
                    }, _$t.allocateGSInstance = function(e) {
                        return this.gs[e] = (this.gs[e] || 0) + 1;
                    }, _$t.getTag = function() {
                        var _$e, _$t, _$n, i, r;
                        return this.tag || (this.tag = (_$n = (_$t = this.options).isServer, i = _$t.useCSSOMInjection, r = _$t.target, _$e = _$n ? new B(r) : i ? new Z(r) : new G(r), new x(_$e)));
                    }, _$t.hasNameForId = function(e, t) {
                        return this.names.has(e) && this.names.get(e).has(t);
                    }, _$t.registerName = function(e, t) {
                        if (O(e), this.names.has(e)) this.names.get(e).add(t);
                        else {
                            var _$n = new Set;
                            _$n.add(t), this.names.set(e, _$n);
                        }
                    }, _$t.insertRules = function(e, t, n) {
                        this.registerName(e, t), this.getTag().insertRules(O(e), n);
                    }, _$t.clearNames = function(e) {
                        this.names.has(e) && this.names.get(e).clear();
                    }, _$t.clearRules = function(e) {
                        this.getTag().clearGroup(O(e)), this.clearNames(e);
                    }, _$t.clearTag = function() {
                        this.tag = void 0;
                    }, _$t.toString = function() {
                        return function(e) {
                            for(var _$t = e.getTag(), _$n = _$t.length, i = "", r = 0; r < _$n; r++){
                                var M = v(r);
                                if (void 0 !== M) {
                                    var u = e.names.get(M), o = _$t.getGroup(r);
                                    if (u && o && u.size) {
                                        var c = z + ".g" + r + '[id="' + M + '"]', a = "";
                                        void 0 !== u && u.forEach(function(e) {
                                            e.length > 0 && (a += e + ",");
                                        }), i += "" + o + c + '{content:"' + a + '"}/*!sc*/\n';
                                    }
                                }
                            }
                            return i;
                        }(this);
                    }, _$e;
                }(), V = /(a)(d)/gi, J = function J(e) {
                    return String.fromCharCode(e + (e > 25 ? 39 : 97));
                };
                var X = function X(e, t) {
                    for(var _$n = t.length; _$n;)e = 33 * e ^ t.charCodeAt(--_$n);
                    return e;
                }, K = function K(e) {
                    return X(5381, e);
                };
                var _ = K("5.3.3"), $ = function() {
                    var _$e = function _$e(e, t, n) {
                        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && q(e), this.componentId = t, this.baseHash = X(_, t), this.baseStyle = n, H.registerId(t);
                    };
                    return _$e.prototype.generateAndInjectStyles = function(e, t, n) {
                        var i = this.componentId, r = [];
                        if (this.baseStyle && r.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
                            if (this.staticRulesId && t.hasNameForId(i, this.staticRulesId)) r.push(this.staticRulesId);
                            else {
                                var M = de(this.rules, e, t, n).join(""), u = F(X(this.baseHash, M) >>> 0);
                                if (!t.hasNameForId(i, u)) {
                                    var o = n(M, "." + u, void 0, i);
                                    t.insertRules(i, u, o);
                                }
                                r.push(u), this.staticRulesId = u;
                            }
                        } else {
                            for(var c = this.rules.length, a = X(this.baseHash, n.hash), I = "", l = 0; l < c; l++){
                                var N = this.rules[l];
                                if ("string" == typeof N) I += N;
                                else if (N) {
                                    var j = de(N, e, t, n), g = Array.isArray(j) ? j.join("") : j;
                                    a = X(a, g + l), I += g;
                                }
                            }
                            if (I) {
                                var s = F(a >>> 0);
                                if (!t.hasNameForId(i, s)) {
                                    var A = n(I, "." + s, void 0, i);
                                    t.insertRules(i, s, A);
                                }
                                r.push(s);
                            }
                        }
                        return r.join(" ");
                    }, _$e;
                }(), ee = /^\s*\/\/.*$/gm, te = [
                    ":",
                    "[",
                    ".",
                    "#"
                ];
                var ie = M.a.createContext(), re = ie.Consumer, Me = M.a.createContext(), ue = (Me.Consumer, new H), oe = ne();
                var le = function() {
                    var _$e = function _$e(e, t) {
                        var _$n = this;
                        this.inject = function(e, t) {
                            void 0 === t && (t = oe);
                            var i = _$n.name + t.hash;
                            e.hasNameForId(_$n.id, i) || e.insertRules(_$n.id, i, t(_$n.rules, i, "@keyframes"));
                        }, this.toString = function() {
                            return C(12, String(_$n.name));
                        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
                    };
                    return _$e.prototype.getName = function(e) {
                        return void 0 === e && (e = oe), this.name + e.hash;
                    }, _$e;
                }(), Ne = /([A-Z])/, je = /([A-Z])/g, ge = /^ms-/, se = function se(e) {
                    return "-" + e.toLowerCase();
                };
                var De = function De(e) {
                    return null == e || !1 === e || "" === e;
                };
                function de(e, t, n, i) {
                    if (Array.isArray(e)) {
                        for(var r, M = [], u = 0, o = e.length; u < o; u += 1)"" !== (r = de(e[u], t, n, i)) && (Array.isArray(r) ? M.push.apply(M, r) : M.push(r));
                        return M;
                    }
                    var c;
                    return De(e) ? "" : y(e) ? "." + e.styledComponentId : d(e) ? "function" != typeof (c = e) || c.prototype && c.prototype.isReactComponent || !t ? e : de(e(t), t, n, i) : e instanceof le ? n ? (e.inject(n, i), e.getName(i)) : e : s(e) ? function e(t, n) {
                        var _$i, r, M = [];
                        for(var u in t)t.hasOwnProperty(u) && !De(t[u]) && (Array.isArray(t[u]) && t[u].isCss || d(t[u]) ? M.push(Ae(u) + ":", t[u], ";") : s(t[u]) ? M.push.apply(M, e(t[u], u)) : M.push(Ae(u) + ": " + (_$i = u, (null == (r = t[u]) || "boolean" == typeof r || "" === r ? "" : "number" != typeof r || 0 === r || _$i in a.a ? String(r).trim() : r + "px") + ";")));
                        return n ? [
                            n + " {"
                        ].concat(M, [
                            "}"
                        ]) : M;
                    }(e) : e.toString();
                }
                var Te = function Te(e) {
                    return Array.isArray(e) && (e.isCss = !0), e;
                };
                new Set;
                var ze = function ze(e, t, n) {
                    return void 0 === n && (n = D), e.theme !== n.theme && e.theme || t || n.theme;
                }, we = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, fe = /(^-|-$)/g;
                var Ee = function Ee(e) {
                    return F(K(e) >>> 0);
                };
                var xe = function xe(e) {
                    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
                }, pe = function pe(e) {
                    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
                };
                var Oe = M.a.createContext(), ve = Oe.Consumer;
                var he = {};
                function ke(e, t, n) {
                    var i = y(e), u = !Ce(e), o = t.attrs, c = void 0 === o ? A : o, a = t.componentId, l = void 0 === a ? function(e, t) {
                        var _$n = "string" != typeof e ? "sc" : Le(e);
                        he[_$n] = (he[_$n] || 0) + 1;
                        var i = _$n + "-" + Ee("5.3.3" + _$n + he[_$n]);
                        return t ? t + "-" + i : i;
                    }(t.displayName, t.parentComponentId) : a, g = t.displayName, s = void 0 === g ? function(e) {
                        return Ce(e) ? "styled." + e : "Styled(" + T(e) + ")";
                    }(e) : g, z = t.displayName && t.componentId ? Le(t.displayName) + "-" + t.componentId : t.componentId || l, w = i && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, f = t.shouldForwardProp;
                    i && e.shouldForwardProp && (f = t.shouldForwardProp ? function f(n, i, r) {
                        return e.shouldForwardProp(n, i, r) && t.shouldForwardProp(n, i, r);
                    } : e.shouldForwardProp);
                    var L, E = new $(n, z, i ? e.componentStyle : void 0), C = E.isStatic && 0 === c.length, x = function x(e, t) {
                        return function(e, t, n, i) {
                            var M = e.attrs, u = e.componentStyle, o = e.defaultProps, c = e.foldedComponentIds, a = e.shouldForwardProp, l = e.styledComponentId, N = e.target, g = function(e, t, n) {
                                void 0 === e && (e = D);
                                var _$i = j({}, t, {
                                    theme: e
                                }), r = {};
                                return n.forEach(function(e) {
                                    var _$t, _$n, M, u = e;
                                    for(_$t in d(u) && (u = u(_$i)), u)_$i[_$t] = r[_$t] = "className" === _$t ? (_$n = r[_$t], M = u[_$t], _$n && M ? _$n + " " + M : _$n || M) : u[_$t];
                                }), [
                                    _$i,
                                    r
                                ];
                            }(ze(t, Object(r.useContext)(Oe), o) || D, t, M), s = g[0], A = g[1], T = function(e, t, n, i) {
                                var r = ce(), M = ae();
                                return t ? e.generateAndInjectStyles(D, r, M) : e.generateAndInjectStyles(n, r, M);
                            }(u, i, s), y = n, z = A.$as || t.$as || A.as || t.as || N, w = Ce(z), f = A !== t ? j({}, t, {}, A) : t, L = {};
                            for(var E in f)"$" !== E[0] && "as" !== E && ("forwardedAs" === E ? L.as = f[E] : (a ? a(E, I.a, z) : !w || Object(I.a)(E)) && (L[E] = f[E]));
                            return t.style && A.style !== t.style && (L.style = j({}, t.style, {}, A.style)), L.className = Array.prototype.concat(c, l, T !== l ? T : null, t.className, A.className).filter(Boolean).join(" "), L.ref = y, Object(r.createElement)(z, L);
                        }(L, e, t, C);
                    };
                    return x.displayName = s, (L = M.a.forwardRef(x)).attrs = w, L.componentStyle = E, L.displayName = s, L.shouldForwardProp = f, L.foldedComponentIds = i ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : A, L.styledComponentId = z, L.target = i ? e.target : e, L.withComponent = function(e) {
                        var i = t.componentId, r = function(e, t) {
                            if (null == e) return {};
                            var _$n, i, r = {}, M = Object.keys(e);
                            for(i = 0; i < M.length; i++)_$n = M[i], t.indexOf(_$n) >= 0 || (r[_$n] = e[_$n]);
                            return r;
                        }(t, [
                            "componentId"
                        ]), M = i && i + "-" + (Ce(e) ? e : Le(T(e)));
                        return ke(e, j({}, r, {
                            attrs: w,
                            componentId: M
                        }), n);
                    }, Object.defineProperty(L, "defaultProps", {
                        get: function get() {
                            return this._foldedDefaultProps;
                        },
                        set: function set(t) {
                            this._foldedDefaultProps = i ? me({}, e.defaultProps, t) : t;
                        }
                    }), L.toString = function() {
                        return "." + L.styledComponentId;
                    }, u && N()(L, e, {
                        attrs: !0,
                        componentStyle: !0,
                        displayName: !0,
                        foldedComponentIds: !0,
                        shouldForwardProp: !0,
                        styledComponentId: !0,
                        target: !0,
                        withComponent: !0
                    }), L;
                }
                var Qe = function Qe(e) {
                    return function e(t, n, r) {
                        if (void 0 === r && (r = D), !Object(i.isValidElementType)(n)) return C(1, String(n));
                        var M = function M() {
                            return t(n, r, ye.apply(void 0, arguments));
                        };
                        return M.withConfig = function(i) {
                            return e(t, n, j({}, r, {}, i));
                        }, M.attrs = function(i) {
                            return e(t, n, j({}, r, {
                                attrs: Array.prototype.concat(r.attrs, i).filter(Boolean)
                            }));
                        }, M;
                    }(ke, e);
                };
                [
                    "a",
                    "abbr",
                    "address",
                    "area",
                    "article",
                    "aside",
                    "audio",
                    "b",
                    "base",
                    "bdi",
                    "bdo",
                    "big",
                    "blockquote",
                    "body",
                    "br",
                    "button",
                    "canvas",
                    "caption",
                    "cite",
                    "code",
                    "col",
                    "colgroup",
                    "data",
                    "datalist",
                    "dd",
                    "del",
                    "details",
                    "dfn",
                    "dialog",
                    "div",
                    "dl",
                    "dt",
                    "em",
                    "embed",
                    "fieldset",
                    "figcaption",
                    "figure",
                    "footer",
                    "form",
                    "h1",
                    "h2",
                    "h3",
                    "h4",
                    "h5",
                    "h6",
                    "head",
                    "header",
                    "hgroup",
                    "hr",
                    "html",
                    "i",
                    "iframe",
                    "img",
                    "input",
                    "ins",
                    "kbd",
                    "keygen",
                    "label",
                    "legend",
                    "li",
                    "link",
                    "main",
                    "map",
                    "mark",
                    "marquee",
                    "menu",
                    "menuitem",
                    "meta",
                    "meter",
                    "nav",
                    "noscript",
                    "object",
                    "ol",
                    "optgroup",
                    "option",
                    "output",
                    "p",
                    "param",
                    "picture",
                    "pre",
                    "progress",
                    "q",
                    "rp",
                    "rt",
                    "ruby",
                    "s",
                    "samp",
                    "script",
                    "section",
                    "select",
                    "small",
                    "source",
                    "span",
                    "strong",
                    "style",
                    "sub",
                    "summary",
                    "sup",
                    "table",
                    "tbody",
                    "td",
                    "textarea",
                    "tfoot",
                    "th",
                    "thead",
                    "time",
                    "title",
                    "tr",
                    "track",
                    "u",
                    "ul",
                    "var",
                    "video",
                    "wbr",
                    "circle",
                    "clipPath",
                    "defs",
                    "ellipse",
                    "foreignObject",
                    "g",
                    "image",
                    "line",
                    "linearGradient",
                    "marker",
                    "mask",
                    "path",
                    "pattern",
                    "polygon",
                    "polyline",
                    "radialGradient",
                    "rect",
                    "stop",
                    "svg",
                    "text",
                    "textPath",
                    "tspan"
                ].forEach(function(e) {
                    Qe[e] = Qe(e);
                });
                var Ye = function() {
                    var _$e = function _$e(e, t) {
                        this.rules = e, this.componentId = t, this.isStatic = q(e), H.registerId(this.componentId + 1);
                    };
                    var _$t = _$e.prototype;
                    return _$t.createStyles = function(e, t, n, i) {
                        var r = i(de(this.rules, t, n, i).join(""), ""), M = this.componentId + e;
                        n.insertRules(M, M, r);
                    }, _$t.removeStyles = function(e, t) {
                        t.clearRules(this.componentId + e);
                    }, _$t.renderStyles = function(e, t, n, i) {
                        e > 2 && H.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, i);
                    }, _$e;
                }();
                var Ze = function() {
                    var _$e = function _$e() {
                        var _$e = this;
                        this._emitSheetCSS = function() {
                            var _$t = _$e.instance.toString();
                            if (!_$t) return "";
                            var _$n = P();
                            return "<style " + [
                                _$n && 'nonce="' + _$n + '"',
                                z + '="true"',
                                'data-styled-version="5.3.3"'
                            ].filter(Boolean).join(" ") + ">" + _$t + "</style>";
                        }, this.getStyleTags = function() {
                            return _$e.sealed ? C(2) : _$e._emitSheetCSS();
                        }, this.getStyleElement = function() {
                            var _$t;
                            if (_$e.sealed) return C(2);
                            var _$n = ((_$t = {})[z] = "", _$t["data-styled-version"] = "5.3.3", _$t.dangerouslySetInnerHTML = {
                                __html: _$e.instance.toString()
                            }, _$t), i = P();
                            return i && (_$n.nonce = i), [
                                M.a.createElement("style", j({}, _$n, {
                                    key: "sc-0-0"
                                }))
                            ];
                        }, this.seal = function() {
                            _$e.sealed = !0;
                        }, this.instance = new H({
                            isServer: !0
                        }), this.sealed = !1;
                    };
                    var _$t = _$e.prototype;
                    return _$t.collectStyles = function(e) {
                        return this.sealed ? C(2) : M.a.createElement(Ie, {
                            sheet: this.instance
                        }, e);
                    }, _$t.interleaveWithNodeStream = function(e) {
                        return C(3);
                    }, _$e;
                }(), Ge = function Ge(e) {
                    var _$t = M.a.forwardRef(function(t, n) {
                        var i = Object(r.useContext)(Oe), u = e.defaultProps, o = ze(t, i, u);
                        return M.a.createElement(e, j({}, t, {
                            theme: o,
                            ref: n
                        }));
                    });
                    return N()(_$t, e), _$t.displayName = "WithTheme(" + T(e) + ")", _$t;
                }, Be = function Be() {
                    return Object(r.useContext)(Oe);
                }, Re = {
                    StyleSheet: H,
                    masterSheet: ue
                };
                t.default = Qe;
            }).call(this, n(11));
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Provider = void 0;
            var i, r, M, u, o, c = n(0), a = c.__importStar(n(1)), I = c.__importDefault(n(18)), l = n(2), N = I.default.div(i || (i = c.__makeTemplateObject([
                "\n  width: 45px;\n  height: 45px;\n  display: flex;\n  border-radius: 50%;\n  overflow: visible;\n  box-shadow: none;\n  justify-content: center;\n  align-items: center;\n  & img {\n    width: 100%;\n    height: 100%;\n  }\n\n  @media screen and (max-width: 768px) {\n    width: 8.5vw;\n    height: 8.5vw;\n  }\n"
            ], [
                "\n  width: 45px;\n  height: 45px;\n  display: flex;\n  border-radius: 50%;\n  overflow: visible;\n  box-shadow: none;\n  justify-content: center;\n  align-items: center;\n  & img {\n    width: 100%;\n    height: 100%;\n  }\n\n  @media screen and (max-width: 768px) {\n    width: 8.5vw;\n    height: 8.5vw;\n  }\n"
            ]))), j = I.default.div(r || (r = c.__makeTemplateObject([
                "\n  width: 100%;\n  font-size: 24px;\n  font-weight: 700;\n  margin-top: 0.5em;\n  color: ",
                ";\n  @media screen and (max-width: 768px) {\n    font-size: 5vw;\n  }\n"
            ], [
                "\n  width: 100%;\n  font-size: 24px;\n  font-weight: 700;\n  margin-top: 0.5em;\n  color: ",
                ";\n  @media screen and (max-width: 768px) {\n    font-size: 5vw;\n  }\n"
            ])), function(e) {
                return e.themeColors.main;
            }), g = I.default.div(M || (M = c.__makeTemplateObject([
                "\n  width: 100%;\n  font-size: 18px;\n  margin: 0.333em 0;\n  color: ",
                ";\n  @media screen and (max-width: 768px) {\n    font-size: 4vw;\n  }\n"
            ], [
                "\n  width: 100%;\n  font-size: 18px;\n  margin: 0.333em 0;\n  color: ",
                ";\n  @media screen and (max-width: 768px) {\n    font-size: 4vw;\n  }\n"
            ])), function(e) {
                return e.themeColors.secondary;
            }), s = I.default.div(u || (u = c.__makeTemplateObject([
                "\n  transition: background-color 0.2s ease-in-out;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
                ";\n  border-radius: 12px;\n  padding: 24px 16px;\n  @media screen and (max-width: 768px) {\n    padding: 1vw;\n  }\n"
            ], [
                "\n  transition: background-color 0.2s ease-in-out;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
                ";\n  border-radius: 12px;\n  padding: 24px 16px;\n  @media screen and (max-width: 768px) {\n    padding: 1vw;\n  }\n"
            ])), function(e) {
                return e.themeColors.background;
            }), A = I.default.div(o || (o = c.__makeTemplateObject([
                "\n  width: 100%;\n  padding: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  cursor: pointer;\n  border-radius: 0;\n  border: ",
                ";\n  @media (hover: hover) {\n    &:hover ",
                " {\n      background-color: ",
                ";\n    }\n  }\n"
            ], [
                "\n  width: 100%;\n  padding: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  cursor: pointer;\n  border-radius: 0;\n  border: ",
                ";\n  @media (hover: hover) {\n    &:hover ",
                " {\n      background-color: ",
                ";\n    }\n  }\n"
            ])), function(e) {
                return "1px solid " + e.themeColors.border;
            }, s, function(e) {
                return e.themeColors.hover;
            });
            t.Provider = function(e) {
                var _$t = e.name, _$n = e.logo, i = e.description, r = e.themeColors, M = e.onClick, u = c.__rest(e, [
                    "name",
                    "logo",
                    "description",
                    "themeColors",
                    "onClick"
                ]);
                return a.createElement(A, c.__assign({
                    themeColors: r,
                    className: l.PROVIDER_WRAPPER_CLASSNAME,
                    onClick: M
                }, u), a.createElement(s, {
                    themeColors: r,
                    className: l.PROVIDER_CONTAINER_CLASSNAME
                }, a.createElement(N, {
                    className: l.PROVIDER_ICON_CLASSNAME
                }, a.createElement("img", {
                    src: _$n,
                    alt: _$t
                })), a.createElement(j, {
                    themeColors: r,
                    className: l.PROVIDER_NAME_CLASSNAME
                }, _$t), a.createElement(g, {
                    themeColors: r,
                    className: l.PROVIDER_DESCRIPTION_CLASSNAME
                }, i)));
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            i.__exportStar(n(21), t), i.__exportStar(n(118), t);
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.EventController = void 0;
            var i = function() {
                var e = function e() {
                    this._eventCallbacks = [];
                };
                return e.prototype.on = function(e) {
                    this._eventCallbacks.push(e);
                }, e.prototype.off = function(e) {
                    e ? e.callback ? this._eventCallbacks = this._eventCallbacks.filter(function(t) {
                        return t.event !== e.event || t.callback !== e.callback;
                    }) : this._eventCallbacks = this._eventCallbacks.filter(function(t) {
                        return t.event !== e.event;
                    }) : this._eventCallbacks = [];
                }, e.prototype.trigger = function(e, t) {
                    var n = this._eventCallbacks.filter(function(t) {
                        return t.event === e;
                    });
                    n && n.length && n.forEach(function(e) {
                        e.callback(t);
                    });
                }, e;
            }();
            t.EventController = i;
        },
        function(e, t) {
            e.exports = function(e, t, n, i) {
                var r = n ? n.call(i, e, t) : void 0;
                if (void 0 !== r) return !!r;
                if (e === t) return !0;
                if ("object" != typeof e || !e || "object" != typeof t || !t) return !1;
                var M = Object.keys(e), u = Object.keys(t);
                if (M.length !== u.length) return !1;
                for(var o = Object.prototype.hasOwnProperty.bind(t), c = 0; c < M.length; c++){
                    var a = M[c];
                    if (!o(a)) return !1;
                    var I = e[a], l = t[a];
                    if (!1 === (r = n ? n.call(i, I, l, a) : void 0) || void 0 === r && I !== l) return !1;
                }
                return !0;
            };
        },
        function(e, t, n) {
            "use strict";
            t.a = function(e) {
                var _$t = function _$t(e, t, i) {
                    var r = t.trim().split(g);
                    t = r;
                    var M = r.length, u = e.length;
                    switch(u){
                        case 0:
                        case 1:
                            var _$o = 0;
                            for(e = 0 === u ? "" : e[0] + " "; _$o < M; ++_$o)t[_$o] = n(e, t[_$o], i).trim();
                            break;
                        default:
                            var c = _$o = 0;
                            for(t = []; _$o < M; ++_$o)for(var a = 0; a < u; ++a)t[c++] = n(e[a] + " ", r[_$o], i).trim();
                    }
                    return t;
                };
                var n = function n(e, t, n) {
                    var i = t.charCodeAt(0);
                    switch(33 > i && (i = (t = t.trim()).charCodeAt(0)), i){
                        case 38:
                            return t.replace(s, "$1" + e.trim());
                        case 58:
                            return e.trim() + t.replace(s, "$1" + e.trim());
                        default:
                            if (0 < 1 * n && 0 < t.indexOf("\f")) return t.replace(s, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
                    }
                    return e + t;
                };
                var r = function r(e, t) {
                    var n = e.indexOf(1 === t ? ":" : "{"), i = e.substring(0, 3 !== t ? n : 10);
                    return n = e.substring(n + 1, e.length - 1), b(2 !== t ? i : i.replace(f, "$1"), n, t);
                };
                var M = function M(e, t) {
                    var n = i(t, t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2));
                    return n !== t + ";" ? n.replace(z, " or ($1)").substring(4) : "(" + t + ")";
                };
                var u = function u(e, t, n, i, r, M, u, o, a, I) {
                    for(var l, N = 0, j = t; N < v; ++N)switch(l = O[N].call(c, e, j, n, i, r, M, u, o, a, I)){
                        case void 0:
                        case !1:
                        case !0:
                        case null:
                            break;
                        default:
                            j = l;
                    }
                    if (j !== t) return j;
                };
                var c = function c(e, n) {
                    var _$o = e;
                    if (33 > _$o.charCodeAt(0) && (_$o = _$o.trim()), _$o = [
                        _$o
                    ], 0 < v) {
                        var c = u(-1, n, _$o, _$o, x, C, 0, 0, 0, 0);
                        void 0 !== c && "string" == typeof c && (n = c);
                    }
                    var l = function e(n, o, c, l, N) {
                        for(var j, g, s, T, z, w = 0, f = 0, L = 0, E = 0, O = 0, b = 0, k = s = j = 0, Q = 0, Y = 0, P = 0, U = 0, Z = c.length, G = Z - 1, B = "", R = "", W = "", H = ""; Q < Z;){
                            if (g = c.charCodeAt(Q), Q === G && 0 !== f + E + L + w && (0 !== f && (g = 47 === f ? 10 : 47), E = L = w = 0, Z++, G++), 0 === f + E + L + w) {
                                if (Q === G && (0 < Y && (B = B.replace(I, "")), 0 < B.trim().length)) {
                                    switch(g){
                                        case 32:
                                        case 9:
                                        case 59:
                                        case 13:
                                        case 10:
                                            break;
                                        default:
                                            B += c.charAt(Q);
                                    }
                                    g = 59;
                                }
                                switch(g){
                                    case 123:
                                        for(j = (B = B.trim()).charCodeAt(0), s = 1, U = ++Q; Q < Z;){
                                            switch(g = c.charCodeAt(Q)){
                                                case 123:
                                                    s++;
                                                    break;
                                                case 125:
                                                    s--;
                                                    break;
                                                case 47:
                                                    switch(g = c.charCodeAt(Q + 1)){
                                                        case 42:
                                                        case 47:
                                                            e: {
                                                                for(k = Q + 1; k < G; ++k)switch(c.charCodeAt(k)){
                                                                    case 47:
                                                                        if (42 === g && 42 === c.charCodeAt(k - 1) && Q + 2 !== k) {
                                                                            Q = k + 1;
                                                                            break e;
                                                                        }
                                                                        break;
                                                                    case 10:
                                                                        if (47 === g) {
                                                                            Q = k + 1;
                                                                            break e;
                                                                        }
                                                                }
                                                                Q = k;
                                                            }
                                                    }
                                                    break;
                                                case 91:
                                                    g++;
                                                case 40:
                                                    g++;
                                                case 34:
                                                case 39:
                                                    for(; Q++ < G && c.charCodeAt(Q) !== g;);
                                            }
                                            if (0 === s) break;
                                            Q++;
                                        }
                                        switch(s = c.substring(U, Q), 0 === j && (j = (B = B.replace(a, "").trim()).charCodeAt(0)), j){
                                            case 64:
                                                switch(0 < Y && (B = B.replace(I, "")), g = B.charCodeAt(1)){
                                                    case 100:
                                                    case 109:
                                                    case 115:
                                                    case 45:
                                                        Y = o;
                                                        break;
                                                    default:
                                                        Y = m;
                                                }
                                                if (U = (s = e(o, Y, s, g, N + 1)).length, 0 < v && (z = u(3, s, Y = _$t(m, B, P), o, x, C, U, g, N, l), B = Y.join(""), void 0 !== z && 0 === (U = (s = z.trim()).length) && (g = 0, s = "")), 0 < U) switch(g){
                                                    case 115:
                                                        B = B.replace(y, M);
                                                    case 100:
                                                    case 109:
                                                    case 45:
                                                        s = B + "{" + s + "}";
                                                        break;
                                                    case 107:
                                                        s = (B = B.replace(A, "$1 $2")) + "{" + s + "}", s = 1 === S || 2 === S && r("@" + s, 3) ? "@-webkit-" + s + "@" + s : "@" + s;
                                                        break;
                                                    default:
                                                        s = B + s, 112 === l && (R += s, s = "");
                                                }
                                                else s = "";
                                                break;
                                            default:
                                                s = e(o, _$t(o, B, P), s, l, N + 1);
                                        }
                                        W += s, s = P = Y = k = j = 0, B = "", g = c.charCodeAt(++Q);
                                        break;
                                    case 125:
                                    case 59:
                                        if (1 < (U = (B = (0 < Y ? B.replace(I, "") : B).trim()).length)) switch(0 === k && (j = B.charCodeAt(0), 45 === j || 96 < j && 123 > j) && (U = (B = B.replace(" ", ":")).length), 0 < v && void 0 !== (z = u(1, B, o, n, x, C, R.length, l, N, l)) && 0 === (U = (B = z.trim()).length) && (B = "\x00\x00"), j = B.charCodeAt(0), g = B.charCodeAt(1), j){
                                            case 0:
                                                break;
                                            case 64:
                                                if (105 === g || 99 === g) {
                                                    H += B + c.charAt(Q);
                                                    break;
                                                }
                                            default:
                                                58 !== B.charCodeAt(U - 1) && (R += i(B, j, g, B.charCodeAt(2)));
                                        }
                                        P = Y = k = j = 0, B = "", g = c.charCodeAt(++Q);
                                }
                            }
                            switch(g){
                                case 13:
                                case 10:
                                    47 === f ? f = 0 : 0 === 1 + j && 107 !== l && 0 < B.length && (Y = 1, B += "\x00"), 0 < v * h && u(0, B, o, n, x, C, R.length, l, N, l), C = 1, x++;
                                    break;
                                case 59:
                                case 125:
                                    if (0 === f + E + L + w) {
                                        C++;
                                        break;
                                    }
                                default:
                                    switch(C++, T = c.charAt(Q), g){
                                        case 9:
                                        case 32:
                                            if (0 === E + w + f) switch(O){
                                                case 44:
                                                case 58:
                                                case 9:
                                                case 32:
                                                    T = "";
                                                    break;
                                                default:
                                                    32 !== g && (T = " ");
                                            }
                                            break;
                                        case 0:
                                            T = "\\0";
                                            break;
                                        case 12:
                                            T = "\\f";
                                            break;
                                        case 11:
                                            T = "\\v";
                                            break;
                                        case 38:
                                            0 === E + f + w && (Y = P = 1, T = "\f" + T);
                                            break;
                                        case 108:
                                            if (0 === E + f + w + p && 0 < k) switch(Q - k){
                                                case 2:
                                                    112 === O && 58 === c.charCodeAt(Q - 3) && (p = O);
                                                case 8:
                                                    111 === b && (p = b);
                                            }
                                            break;
                                        case 58:
                                            0 === E + f + w && (k = Q);
                                            break;
                                        case 44:
                                            0 === f + L + E + w && (Y = 1, T += "\r");
                                            break;
                                        case 34:
                                        case 39:
                                            0 === f && (E = E === g ? 0 : 0 === E ? g : E);
                                            break;
                                        case 91:
                                            0 === E + f + L && w++;
                                            break;
                                        case 93:
                                            0 === E + f + L && w--;
                                            break;
                                        case 41:
                                            0 === E + f + w && L--;
                                            break;
                                        case 40:
                                            if (0 === E + f + w) {
                                                if (0 === j) switch(2 * O + 3 * b){
                                                    case 533:
                                                        break;
                                                    default:
                                                        j = 1;
                                                }
                                                L++;
                                            }
                                            break;
                                        case 64:
                                            0 === f + L + E + w + k + s && (s = 1);
                                            break;
                                        case 42:
                                        case 47:
                                            if (!(0 < E + w + L)) switch(f){
                                                case 0:
                                                    switch(2 * g + 3 * c.charCodeAt(Q + 1)){
                                                        case 235:
                                                            f = 47;
                                                            break;
                                                        case 220:
                                                            U = Q, f = 42;
                                                    }
                                                    break;
                                                case 42:
                                                    47 === g && 42 === O && U + 2 !== Q && (33 === c.charCodeAt(U + 2) && (R += c.substring(U, Q + 1)), T = "", f = 0);
                                            }
                                    }
                                    0 === f && (B += T);
                            }
                            b = O, O = g, Q++;
                        }
                        if (0 < (U = R.length)) {
                            if (Y = o, 0 < v && void 0 !== (z = u(2, R, Y, n, x, C, U, l, N, l)) && 0 === (R = z).length) return H + R + W;
                            if (R = Y.join(",") + "{" + R + "}", 0 != S * p) {
                                switch(2 !== S || r(R, 2) || (p = 0), p){
                                    case 111:
                                        R = R.replace(d, ":-moz-$1") + R;
                                        break;
                                    case 112:
                                        R = R.replace(D, "::-webkit-input-$1") + R.replace(D, "::-moz-$1") + R.replace(D, ":-ms-input-$1") + R;
                                }
                                p = 0;
                            }
                        }
                        return H + R + W;
                    }(m, _$o, n, 0, 0);
                    return 0 < v && void 0 !== (c = u(-2, l, _$o, _$o, x, C, l.length, 0, 0, 0)) && (l = c), p = 0, C = x = 1, l;
                };
                function i(e, t, n, M) {
                    var u = e + ";", _$o = 2 * t + 3 * n + 4 * M;
                    if (944 === _$o) {
                        e = u.indexOf(":", 9) + 1;
                        var c = u.substring(e, u.length - 1).trim();
                        return c = u.substring(0, e).trim() + c + ";", 1 === S || 2 === S && r(c, 1) ? "-webkit-" + c + c : c;
                    }
                    if (0 === S || 2 === S && !r(u, 1)) return u;
                    switch(_$o){
                        case 1015:
                            return 97 === u.charCodeAt(10) ? "-webkit-" + u + u : u;
                        case 951:
                            return 116 === u.charCodeAt(3) ? "-webkit-" + u + u : u;
                        case 963:
                            return 110 === u.charCodeAt(5) ? "-webkit-" + u + u : u;
                        case 1009:
                            if (100 !== u.charCodeAt(4)) break;
                        case 969:
                        case 942:
                            return "-webkit-" + u + u;
                        case 978:
                            return "-webkit-" + u + "-moz-" + u + u;
                        case 1019:
                        case 983:
                            return "-webkit-" + u + "-moz-" + u + "-ms-" + u + u;
                        case 883:
                            if (45 === u.charCodeAt(8)) return "-webkit-" + u + u;
                            if (0 < u.indexOf("image-set(", 11)) return u.replace(E, "$1-webkit-$2") + u;
                            break;
                        case 932:
                            if (45 === u.charCodeAt(4)) switch(u.charCodeAt(5)){
                                case 103:
                                    return "-webkit-box-" + u.replace("-grow", "") + "-webkit-" + u + "-ms-" + u.replace("grow", "positive") + u;
                                case 115:
                                    return "-webkit-" + u + "-ms-" + u.replace("shrink", "negative") + u;
                                case 98:
                                    return "-webkit-" + u + "-ms-" + u.replace("basis", "preferred-size") + u;
                            }
                            return "-webkit-" + u + "-ms-" + u + u;
                        case 964:
                            return "-webkit-" + u + "-ms-flex-" + u + u;
                        case 1023:
                            if (99 !== u.charCodeAt(8)) break;
                            return "-webkit-box-pack" + (c = u.substring(u.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + u + "-ms-flex-pack" + c + u;
                        case 1005:
                            return N.test(u) ? u.replace(l, ":-webkit-") + u.replace(l, ":-moz-") + u : u;
                        case 1e3:
                            switch(t = (c = u.substring(13).trim()).indexOf("-") + 1, c.charCodeAt(0) + c.charCodeAt(t)){
                                case 226:
                                    c = u.replace(T, "tb");
                                    break;
                                case 232:
                                    c = u.replace(T, "tb-rl");
                                    break;
                                case 220:
                                    c = u.replace(T, "lr");
                                    break;
                                default:
                                    return u;
                            }
                            return "-webkit-" + u + "-ms-" + c + u;
                        case 1017:
                            if (-1 === u.indexOf("sticky", 9)) break;
                        case 975:
                            switch(t = (u = e).length - 10, _$o = (c = (33 === u.charCodeAt(t) ? u.substring(0, t) : u).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | c.charCodeAt(7))){
                                case 203:
                                    if (111 > c.charCodeAt(8)) break;
                                case 115:
                                    u = u.replace(c, "-webkit-" + c) + ";" + u;
                                    break;
                                case 207:
                                case 102:
                                    u = u.replace(c, "-webkit-" + (102 < _$o ? "inline-" : "") + "box") + ";" + u.replace(c, "-webkit-" + c) + ";" + u.replace(c, "-ms-" + c + "box") + ";" + u;
                            }
                            return u + ";";
                        case 938:
                            if (45 === u.charCodeAt(5)) switch(u.charCodeAt(6)){
                                case 105:
                                    return c = u.replace("-items", ""), "-webkit-" + u + "-webkit-box-" + c + "-ms-flex-" + c + u;
                                case 115:
                                    return "-webkit-" + u + "-ms-flex-item-" + u.replace(w, "") + u;
                                default:
                                    return "-webkit-" + u + "-ms-flex-line-pack" + u.replace("align-content", "").replace(w, "") + u;
                            }
                            break;
                        case 973:
                        case 989:
                            if (45 !== u.charCodeAt(3) || 122 === u.charCodeAt(4)) break;
                        case 931:
                        case 953:
                            if (!0 === L.test(e)) return 115 === (c = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? i(e.replace("stretch", "fill-available"), t, n, M).replace(":fill-available", ":stretch") : u.replace(c, "-webkit-" + c) + u.replace(c, "-moz-" + c.replace("fill-", "")) + u;
                            break;
                        case 962:
                            if (u = "-webkit-" + u + (102 === u.charCodeAt(5) ? "-ms-" + u : "") + u, 211 === n + M && 105 === u.charCodeAt(13) && 0 < u.indexOf("transform", 10)) return u.substring(0, u.indexOf(";", 27) + 1).replace(j, "$1-webkit-$2") + u;
                    }
                    return u;
                }
                function o(e) {
                    return void 0 !== (e = e.prefix) && (b = null, e ? "function" != typeof e ? S = 1 : (S = 2, b = e) : S = 0), o;
                }
                var a = /^\0+/g, I = /[\0\r\f]/g, l = /: */g, N = /zoo|gra/, j = /([,: ])(transform)/g, g = /,\r+?/g, s = /([\t\r\n ])*\f?&/g, A = /@(k\w+)\s*(\S*)\s*/, D = /::(place)/g, d = /:(read-only)/g, T = /[svh]\w+-[tblr]{2}/, y = /\(\s*(.*)\s*\)/g, z = /([\s\S]*?);/g, w = /-self|flex-/g, f = /[^]*?(:[rp][el]a[\w-]+)[^]*/, L = /stretch|:\s*\w+\-(?:conte|avail)/, E = /([^-])(image-set\()/, C = 1, x = 1, p = 0, S = 1, m = [], O = [], v = 0, b = null, h = 0;
                return c.use = function e(t) {
                    switch(t){
                        case void 0:
                        case null:
                            v = O.length = 0;
                            break;
                        default:
                            if ("function" == typeof t) O[v++] = t;
                            else if ("object" == typeof t) for(var n = 0, i = t.length; n < i; ++n)e(t[n]);
                            else h = 0 | !!t;
                    }
                    return e;
                }, c.set = o, void 0 !== e && o(e), c;
            };
        },
        function(e, t, n) {
            "use strict";
            t.a = {
                animationIterationCount: 1,
                borderImageOutset: 1,
                borderImageSlice: 1,
                borderImageWidth: 1,
                boxFlex: 1,
                boxFlexGroup: 1,
                boxOrdinalGroup: 1,
                columnCount: 1,
                columns: 1,
                flex: 1,
                flexGrow: 1,
                flexPositive: 1,
                flexShrink: 1,
                flexNegative: 1,
                flexOrder: 1,
                gridRow: 1,
                gridRowEnd: 1,
                gridRowSpan: 1,
                gridRowStart: 1,
                gridColumn: 1,
                gridColumnEnd: 1,
                gridColumnSpan: 1,
                gridColumnStart: 1,
                msGridRow: 1,
                msGridRowSpan: 1,
                msGridColumn: 1,
                msGridColumnSpan: 1,
                fontWeight: 1,
                lineHeight: 1,
                opacity: 1,
                order: 1,
                orphans: 1,
                tabSize: 1,
                widows: 1,
                zIndex: 1,
                zoom: 1,
                WebkitLineClamp: 1,
                fillOpacity: 1,
                floodOpacity: 1,
                stopOpacity: 1,
                strokeDasharray: 1,
                strokeDashoffset: 1,
                strokeMiterlimit: 1,
                strokeOpacity: 1,
                strokeWidth: 1
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0), r = n(26);
            i.__exportStar(n(17), t), i.__exportStar(n(2), t), i.__exportStar(n(20), t), i.__exportStar(n(5), t), i.__exportStar(n(3), t), i.__exportStar(n(4), t), t.default = r.Core;
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Core = void 0;
            var i = n(0), r = i.__importStar(n(1)), M = i.__importStar(n(28)), u = n(3), o = n(2), c = n(4), a = n(17), I = n(20), l = {
                show: !1
            }, N = {
                lightboxOpacity: .4,
                theme: c.themesList.default.name,
                cacheProvider: !1,
                disableInjectedProvider: !1,
                providerOptions: {},
                network: ""
            }, j = function() {
                var e = function e(e) {
                    var _$t = this;
                    this.show = l.show, this.eventController = new I.EventController, this.connect = function() {
                        return new Promise(function(e, n) {
                            return i.__awaiter(_$t, void 0, void 0, function() {
                                return i.__generator(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            return this.on(o.CONNECT_EVENT, function(t) {
                                                return e(t);
                                            }), this.on(o.ERROR_EVENT, function(e) {
                                                return n(e);
                                            }), this.on(o.CLOSE_EVENT, function() {
                                                return n("Modal closed by user");
                                            }), [
                                                4,
                                                this.toggleModal()
                                            ];
                                        case 1:
                                            return t.sent(), [
                                                2
                                            ];
                                    }
                                });
                            });
                        });
                    }, this.connectTo = function(e) {
                        return new Promise(function(n, r) {
                            return i.__awaiter(_$t, void 0, void 0, function() {
                                var _$t;
                                return i.__generator(this, function(i) {
                                    switch(i.label){
                                        case 0:
                                            return this.on(o.CONNECT_EVENT, function(e) {
                                                return n(e);
                                            }), this.on(o.ERROR_EVENT, function(e) {
                                                return r(e);
                                            }), this.on(o.CLOSE_EVENT, function() {
                                                return r("Modal closed by user");
                                            }), (_$t = this.providerController.getProvider(e)) ? [
                                                4,
                                                this.providerController.connectTo(_$t.id, _$t.connector)
                                            ] : [
                                                2,
                                                r(new Error("Cannot connect to provider (" + e + "), check provider options"))
                                            ];
                                        case 1:
                                            return i.sent(), [
                                                2
                                            ];
                                    }
                                });
                            });
                        });
                    }, this._toggleModal = function() {
                        return i.__awaiter(_$t, void 0, void 0, function() {
                            var _$e, _$t;
                            return i.__generator(this, function(n) {
                                switch(n.label){
                                    case 0:
                                        return _$e = "undefined" != typeof window ? document : "", (_$t = _$e ? _$e.body || _$e.getElementsByTagName("body")[0] : "") && (this.show ? _$t.style.overflow = "" : _$t.style.overflow = "hidden"), [
                                            4,
                                            this.updateState({
                                                show: !this.show
                                            })
                                        ];
                                    case 1:
                                        return n.sent(), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.onError = function(e) {
                        return i.__awaiter(_$t, void 0, void 0, function() {
                            return i.__generator(this, function(t) {
                                switch(t.label){
                                    case 0:
                                        return this.show ? [
                                            4,
                                            this._toggleModal()
                                        ] : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        t.sent(), t.label = 2;
                                    case 2:
                                        return this.eventController.trigger(o.ERROR_EVENT, e), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.onProviderSelect = function(e) {
                        _$t.eventController.trigger(o.SELECT_EVENT, e);
                    }, this.onConnect = function(e) {
                        return i.__awaiter(_$t, void 0, void 0, function() {
                            return i.__generator(this, function(t) {
                                switch(t.label){
                                    case 0:
                                        return this.show ? [
                                            4,
                                            this._toggleModal()
                                        ] : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        t.sent(), t.label = 2;
                                    case 2:
                                        return this.eventController.trigger(o.CONNECT_EVENT, e), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.onClose = function() {
                        return i.__awaiter(_$t, void 0, void 0, function() {
                            return i.__generator(this, function(e) {
                                switch(e.label){
                                    case 0:
                                        return this.show ? [
                                            4,
                                            this._toggleModal()
                                        ] : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        e.sent(), e.label = 2;
                                    case 2:
                                        return this.eventController.trigger(o.CLOSE_EVENT), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.updateState = function(e) {
                        return i.__awaiter(_$t, void 0, void 0, function() {
                            var _$t = this;
                            return i.__generator(this, function(n) {
                                switch(n.label){
                                    case 0:
                                        return Object.keys(e).forEach(function(n) {
                                            _$t[n] = e[n];
                                        }), [
                                            4,
                                            window.updateWeb3Modal(e)
                                        ];
                                    case 1:
                                        return n.sent(), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.resetState = function() {
                        return _$t.updateState(i.__assign({}, l));
                    };
                    var _$n = i.__assign(i.__assign({}, N), e);
                    this.lightboxOpacity = _$n.lightboxOpacity, this.themeColors = u.getThemeColors(_$n.theme), this.providerController = new I.ProviderController({
                        disableInjectedProvider: _$n.disableInjectedProvider,
                        cacheProvider: _$n.cacheProvider,
                        providerOptions: _$n.providerOptions,
                        network: _$n.network
                    }), this.providerController.on(o.CONNECT_EVENT, function(e) {
                        return _$t.onConnect(e);
                    }), this.providerController.on(o.ERROR_EVENT, function(e) {
                        return _$t.onError(e);
                    }), this.providerController.on(o.SELECT_EVENT, this.onProviderSelect), this.userOptions = this.providerController.getUserOptions(), this.renderModal();
                };
                return Object.defineProperty(e.prototype, "cachedProvider", {
                    get: function get() {
                        return this.providerController.cachedProvider;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e.prototype.toggleModal = function() {
                    return i.__awaiter(this, void 0, void 0, function() {
                        return i.__generator(this, function(e) {
                            switch(e.label){
                                case 0:
                                    return this.cachedProvider ? [
                                        4,
                                        this.providerController.connectToCachedProvider()
                                    ] : [
                                        3,
                                        2
                                    ];
                                case 1:
                                    return e.sent(), [
                                        2
                                    ];
                                case 2:
                                    return this.userOptions && 1 === this.userOptions.length && this.userOptions[0].name ? [
                                        4,
                                        this.userOptions[0].onClick()
                                    ] : [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return e.sent(), [
                                        2
                                    ];
                                case 4:
                                    return [
                                        4,
                                        this._toggleModal()
                                    ];
                                case 5:
                                    return e.sent(), [
                                        2
                                    ];
                            }
                        });
                    });
                }, e.prototype.on = function(e, t) {
                    var _$n = this;
                    return this.eventController.on({
                        event: e,
                        callback: t
                    }), function() {
                        return _$n.eventController.off({
                            event: e,
                            callback: t
                        });
                    };
                }, e.prototype.off = function(e, t) {
                    this.eventController.off({
                        event: e,
                        callback: t
                    });
                }, e.prototype.getUserOptions = function() {
                    return this.userOptions;
                }, e.prototype.clearCachedProvider = function() {
                    this.providerController.clearCachedProvider();
                }, e.prototype.setCachedProvider = function(e) {
                    this.providerController.setCachedProvider(e);
                }, e.prototype.updateTheme = function(e) {
                    return i.__awaiter(this, void 0, void 0, function() {
                        return i.__generator(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return this.themeColors = u.getThemeColors(e), [
                                        4,
                                        this.updateState({
                                            themeColors: this.themeColors
                                        })
                                    ];
                                case 1:
                                    return t.sent(), [
                                        2
                                    ];
                            }
                        });
                    });
                }, e.prototype.renderModal = function() {
                    var e = document.createElement("div");
                    e.id = o.WEB3_CONNECT_MODAL_ID, document.body.appendChild(e), M.render(r.createElement(a.Modal, {
                        themeColors: this.themeColors,
                        userOptions: this.userOptions,
                        onClose: this.onClose,
                        resetState: this.resetState,
                        lightboxOpacity: this.lightboxOpacity
                    }), document.getElementById(o.WEB3_CONNECT_MODAL_ID));
                }, e;
            }();
            t.Core = j;
        },
        function(e, t, n) {
            "use strict";
            var D = function D(e) {
                for(var _$t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, _$n = 1; _$n < arguments.length; _$n++)_$t += "&args[]=" + encodeURIComponent(arguments[_$n]);
                return "Minified React error #" + e + "; visit " + _$t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            };
            var y = function y(e, t, n) {
                this.props = e, this.context = t, this.refs = T, this.updater = n || d;
            };
            var z = function z() {};
            var w = function w(e, t, n) {
                this.props = e, this.context = t, this.refs = T, this.updater = n || d;
            };
            var x = function x(e, t, n) {
                var i, r = {}, u = null, o = null;
                if (null != t) for(i in void 0 !== t.ref && (o = t.ref), void 0 !== t.key && (u = "" + t.key), t)E.call(t, i) && !C.hasOwnProperty(i) && (r[i] = t[i]);
                var c = arguments.length - 2;
                if (1 === c) r.children = n;
                else if (1 < c) {
                    for(var a = Array(c), I = 0; I < c; I++)a[I] = arguments[I + 2];
                    r.children = a;
                }
                if (e && e.defaultProps) for(i in c = e.defaultProps)void 0 === r[i] && (r[i] = c[i]);
                return {
                    $$typeof: M,
                    type: e,
                    key: u,
                    ref: o,
                    props: r,
                    _owner: L.current
                };
            };
            var p = function p(e) {
                return "object" == typeof e && null !== e && e.$$typeof === M;
            };
            var O = function O(e, t, n, i) {
                if (m.length) {
                    var r = m.pop();
                    return r.result = e, r.keyPrefix = t, r.func = n, r.context = i, r.count = 0, r;
                }
                return {
                    result: e,
                    keyPrefix: t,
                    func: n,
                    context: i,
                    count: 0
                };
            };
            var v = function v(e) {
                e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > m.length && m.push(e);
            };
            var b = function b(e, t, n) {
                return null == e ? 0 : function e(t, n, i, r) {
                    var o = typeof t === "undefined" ? "undefined" : (0, $1ObTH._)(t);
                    "undefined" !== o && "boolean" !== o || (t = null);
                    var c = !1;
                    if (null === t) c = !0;
                    else switch(o){
                        case "string":
                        case "number":
                            c = !0;
                            break;
                        case "object":
                            switch(t.$$typeof){
                                case M:
                                case u:
                                    c = !0;
                            }
                    }
                    if (c) return i(r, t, "" === n ? "." + h(t, 0) : n), 1;
                    if (c = 0, n = "" === n ? "." : n + ":", Array.isArray(t)) for(var a = 0; a < t.length; a++){
                        var I = n + h(o = t[a], a);
                        c += e(o, I, i, r);
                    }
                    else if (null === t || "object" != typeof t ? I = null : I = "function" == typeof (I = A && t[A] || t["@@iterator"]) ? I : null, "function" == typeof I) for(t = I.call(t), a = 0; !(o = t.next()).done;)c += e(o = o.value, I = n + h(o, a++), i, r);
                    else if ("object" === o) throw i = "" + t, Error(D(31, "[object Object]" === i ? "object with keys {" + Object.keys(t).join(", ") + "}" : i, ""));
                    return c;
                }(e, "", t, n);
            };
            var h = function h(e, t) {
                return "object" == typeof e && null !== e && null != e.key ? function(e) {
                    var _$t = {
                        "=": "=0",
                        ":": "=2"
                    };
                    return "$" + ("" + e).replace(/[=:]/g, function(e) {
                        return _$t[e];
                    });
                }(e.key) : t.toString(36);
            };
            var k = function k(e, t) {
                e.func.call(e.context, t, e.count++);
            };
            var Q = function Q(e, t, n) {
                var i = e.result, r = e.keyPrefix;
                e = e.func.call(e.context, t, e.count++), Array.isArray(e) ? Y(e, i, n, function(e) {
                    return e;
                }) : null != e && (p(e) && (e = function(e, t) {
                    return {
                        $$typeof: M,
                        type: e.type,
                        key: t,
                        ref: e.ref,
                        props: e.props,
                        _owner: e._owner
                    };
                }(e, r + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(S, "$&/") + "/") + n)), i.push(e));
            };
            var Y = function Y(e, t, n, i, r) {
                var M = "";
                null != n && (M = ("" + n).replace(S, "$&/") + "/"), b(e, Q, t = O(t, M, i, r)), v(t);
            };
            var U = function U() {
                var e = P.current;
                if (null === e) throw Error(D(321));
                return e;
            };
            /** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var i = n(9), r = "function" == typeof Symbol && Symbol.for, M = r ? Symbol.for("react.element") : 60103, u = r ? Symbol.for("react.portal") : 60106, o = r ? Symbol.for("react.fragment") : 60107, c = r ? Symbol.for("react.strict_mode") : 60108, a = r ? Symbol.for("react.profiler") : 60114, I = r ? Symbol.for("react.provider") : 60109, l = r ? Symbol.for("react.context") : 60110, N = r ? Symbol.for("react.forward_ref") : 60112, j = r ? Symbol.for("react.suspense") : 60113, g = r ? Symbol.for("react.memo") : 60115, s = r ? Symbol.for("react.lazy") : 60116, A = "function" == typeof Symbol && Symbol.iterator;
            var d = {
                isMounted: function isMounted() {
                    return !1;
                },
                enqueueForceUpdate: function enqueueForceUpdate() {},
                enqueueReplaceState: function enqueueReplaceState() {},
                enqueueSetState: function enqueueSetState() {}
            }, T = {};
            y.prototype.isReactComponent = {}, y.prototype.setState = function(e, t) {
                if ("object" != typeof e && "function" != typeof e && null != e) throw Error(D(85));
                this.updater.enqueueSetState(this, e, t, "setState");
            }, y.prototype.forceUpdate = function(e) {
                this.updater.enqueueForceUpdate(this, e, "forceUpdate");
            }, z.prototype = y.prototype;
            var f = w.prototype = new z;
            f.constructor = w, i(f, y.prototype), f.isPureReactComponent = !0;
            var L = {
                current: null
            }, E = Object.prototype.hasOwnProperty, C = {
                key: !0,
                ref: !0,
                __self: !0,
                __source: !0
            };
            var S = /\/+/g, m = [];
            var P = {
                current: null
            };
            var Z = {
                ReactCurrentDispatcher: P,
                ReactCurrentBatchConfig: {
                    suspense: null
                },
                ReactCurrentOwner: L,
                IsSomeRendererActing: {
                    current: !1
                },
                assign: i
            };
            t.Children = {
                map: function map(e, t, n) {
                    if (null == e) return e;
                    var i = [];
                    return Y(e, i, null, t, n), i;
                },
                forEach: function forEach(e, t, n) {
                    if (null == e) return e;
                    b(e, k, t = O(null, null, t, n)), v(t);
                },
                count: function count(e) {
                    return b(e, function() {
                        return null;
                    }, null);
                },
                toArray: function toArray(e) {
                    var _$t = [];
                    return Y(e, _$t, null, function(e) {
                        return e;
                    }), _$t;
                },
                only: function only(e) {
                    if (!p(e)) throw Error(D(143));
                    return e;
                }
            }, t.Component = y, t.Fragment = o, t.Profiler = a, t.PureComponent = w, t.StrictMode = c, t.Suspense = j, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Z, t.cloneElement = function(e, t, n) {
                if (null == e) throw Error(D(267, e));
                var r = i({}, e.props), u = e.key, o = e.ref, c = e._owner;
                if (null != t) {
                    if (void 0 !== t.ref && (o = t.ref, c = L.current), void 0 !== t.key && (u = "" + t.key), e.type && e.type.defaultProps) var a = e.type.defaultProps;
                    for(I in t)E.call(t, I) && !C.hasOwnProperty(I) && (r[I] = void 0 === t[I] && void 0 !== a ? a[I] : t[I]);
                }
                var I = arguments.length - 2;
                if (1 === I) r.children = n;
                else if (1 < I) {
                    a = Array(I);
                    for(var l = 0; l < I; l++)a[l] = arguments[l + 2];
                    r.children = a;
                }
                return {
                    $$typeof: M,
                    type: e.type,
                    key: u,
                    ref: o,
                    props: r,
                    _owner: c
                };
            }, t.createContext = function(e, t) {
                return void 0 === t && (t = null), (e = {
                    $$typeof: l,
                    _calculateChangedBits: t,
                    _currentValue: e,
                    _currentValue2: e,
                    _threadCount: 0,
                    Provider: null,
                    Consumer: null
                }).Provider = {
                    $$typeof: I,
                    _context: e
                }, e.Consumer = e;
            }, t.createElement = x, t.createFactory = function(e) {
                var _$t = x.bind(null, e);
                return _$t.type = e, _$t;
            }, t.createRef = function() {
                return {
                    current: null
                };
            }, t.forwardRef = function(e) {
                return {
                    $$typeof: N,
                    render: e
                };
            }, t.isValidElement = p, t.lazy = function(e) {
                return {
                    $$typeof: s,
                    _ctor: e,
                    _status: -1,
                    _result: null
                };
            }, t.memo = function(e, t) {
                return {
                    $$typeof: g,
                    type: e,
                    compare: void 0 === t ? null : t
                };
            }, t.useCallback = function(e, t) {
                return U().useCallback(e, t);
            }, t.useContext = function(e, t) {
                return U().useContext(e, t);
            }, t.useDebugValue = function() {}, t.useEffect = function(e, t) {
                return U().useEffect(e, t);
            }, t.useImperativeHandle = function(e, t, n) {
                return U().useImperativeHandle(e, t, n);
            }, t.useLayoutEffect = function(e, t) {
                return U().useLayoutEffect(e, t);
            }, t.useMemo = function(e, t) {
                return U().useMemo(e, t);
            }, t.useReducer = function(e, t, n) {
                return U().useReducer(e, t, n);
            }, t.useRef = function(e) {
                return U().useRef(e);
            }, t.useState = function(e) {
                return U().useState(e);
            }, t.version = "16.14.0";
        },
        function(e, t, n) {
            "use strict";
            !function e() {
                if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
                } catch (e) {
                    console.error(e);
                }
            }(), e.exports = n(29);
        },
        function(e, t, n) {
            "use strict";
            var u = function u(e) {
                for(var _$t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, _$n = 1; _$n < arguments.length; _$n++)_$t += "&args[]=" + encodeURIComponent(arguments[_$n]);
                return "Minified React error #" + e + "; visit " + _$t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            };
            var o = function o(e, t, n, i, r, M, u, o, c) {
                var a = Array.prototype.slice.call(arguments, 3);
                try {
                    t.apply(n, a);
                } catch (e) {
                    this.onError(e);
                }
            };
            var j = function j(e, t, n, i, r, M, u, I, l) {
                c = !1, a = null, o.apply(N, arguments);
            };
            var D = function D(e, t, n) {
                var i = e.type || "unknown-event";
                e.currentTarget = A(n), function(e, t, n, i, r, M, o, N, g) {
                    if (j.apply(this, arguments), c) {
                        if (!c) throw Error(u(198));
                        var s = a;
                        c = !1, a = null, I || (I = !0, l = s);
                    }
                }(i, t, void 0, e), e.currentTarget = null;
            };
            var y = function y() {
                if (d) for(var e in T){
                    var _$t = T[e], _$n = d.indexOf(e);
                    if (!(-1 < _$n)) throw Error(u(96, e));
                    if (!w[_$n]) {
                        if (!_$t.extractEvents) throw Error(u(97, e));
                        for(var i in w[_$n] = _$t, _$n = _$t.eventTypes){
                            var r = void 0, M = _$n[i], o = _$t, c = i;
                            if (f.hasOwnProperty(c)) throw Error(u(99, c));
                            f[c] = M;
                            var a = M.phasedRegistrationNames;
                            if (a) {
                                for(r in a)a.hasOwnProperty(r) && z(a[r], o, c);
                                r = !0;
                            } else M.registrationName ? (z(M.registrationName, o, c), r = !0) : r = !1;
                            if (!r) throw Error(u(98, i, e));
                        }
                    }
                }
            };
            var z = function z(e, t, n) {
                if (L[e]) throw Error(u(100, e));
                L[e] = t, E[e] = t.eventTypes[n].dependencies;
            };
            var C = function C(e) {
                var _$t, _$n = !1;
                for(_$t in e)if (e.hasOwnProperty(_$t)) {
                    var i = e[_$t];
                    if (!T.hasOwnProperty(_$t) || T[_$t] !== i) {
                        if (T[_$t]) throw Error(u(102, _$t));
                        T[_$t] = i, _$n = !0;
                    }
                }
                _$n && y();
            };
            var O = function O(e) {
                if (e = s(e)) {
                    if ("function" != typeof p) throw Error(u(280));
                    var _$t = e.stateNode;
                    _$t && (_$t = g(_$t), p(e.stateNode, e.type, _$t));
                }
            };
            var v = function v(e) {
                S ? m ? m.push(e) : m = [
                    e
                ] : S = e;
            };
            var b = function b() {
                if (S) {
                    var e = S, _$t = m;
                    if (m = S = null, O(e), _$t) for(e = 0; e < _$t.length; e++)O(_$t[e]);
                }
            };
            var h = function h(e, t) {
                return e(t);
            };
            var k = function k(e, t, n, i, r) {
                return e(t, n, i, r);
            };
            var Q = function Q() {};
            var Z = function Z() {
                null === S && null === m || (Q(), b());
            };
            var G = function G(e, t, n) {
                if (U) return e(t, n);
                U = !0;
                try {
                    return Y(e, t, n);
                } finally{
                    U = !1, Z();
                }
            };
            var V = function V(e, t, n, i, r, M) {
                this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = i, this.attributeNamespace = r, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = M;
            };
            var X = function X(e) {
                return e[1].toUpperCase();
            };
            var q = function q(e, t, n, i) {
                var r = J.hasOwnProperty(t) ? J[t] : null;
                (null !== r ? 0 === r.type : !i && 2 < t.length && ("o" === t[0] || "O" === t[0]) && ("n" === t[1] || "N" === t[1])) || (function(e, t, n, i) {
                    if (null == t || function(e, t, n, i) {
                        if (null !== n && 0 === n.type) return !1;
                        switch(typeof t === "undefined" ? "undefined" : (0, $1ObTH._)(t)){
                            case "function":
                            case "symbol":
                                return !0;
                            case "boolean":
                                return !i && (null !== n ? !n.acceptsBooleans : "data-" !== (e = e.toLowerCase().slice(0, 5)) && "aria-" !== e);
                            default:
                                return !1;
                        }
                    }(e, t, n, i)) return !0;
                    if (i) return !1;
                    if (null !== n) switch(n.type){
                        case 3:
                            return !t;
                        case 4:
                            return !1 === t;
                        case 5:
                            return isNaN(t);
                        case 6:
                            return isNaN(t) || 1 > t;
                    }
                    return !1;
                }(t, n, r, i) && (n = null), i || null === r ? function(e) {
                    return !!R.call(H, e) || !R.call(W, e) && (B.test(e) ? H[e] = !0 : (W[e] = !0, !1));
                }(t) && (null === n ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : r.mustUseProperty ? e[r.propertyName] = null === n ? 3 !== r.type && "" : n : (t = r.attributeName, i = r.attributeNamespace, null === n ? e.removeAttribute(t) : (n = 3 === (r = r.type) || 4 === r && !0 === n ? "" : "" + n, i ? e.setAttributeNS(i, t, n) : e.setAttribute(t, n))));
            };
            var se = function se(e) {
                return null === e || "object" != typeof e ? null : "function" == typeof (e = ge && e[ge] || e["@@iterator"]) ? e : null;
            };
            var De = function De(e) {
                var _$t = "";
                do {
                    e: switch(e.tag){
                        case 3:
                        case 4:
                        case 6:
                        case 7:
                        case 10:
                        case 9:
                            var _$n = "";
                            break e;
                        default:
                            var i = e._debugOwner, r = e._debugSource, M = Ae(e.type);
                            _$n = null, i && (_$n = Ae(i.type)), i = M, M = "", r ? M = " (at " + r.fileName.replace(_, "") + ":" + r.lineNumber + ")" : _$n && (M = " (created by " + _$n + ")"), _$n = "\n    in " + (i || "Unknown") + M;
                    }
                    _$t += _$n, e = e.return;
                }while (e);
                return _$t;
            };
            var de = function de(e) {
                switch(typeof e === "undefined" ? "undefined" : (0, $1ObTH._)(e)){
                    case "boolean":
                    case "number":
                    case "object":
                    case "string":
                    case "undefined":
                        return e;
                    default:
                        return "";
                }
            };
            var Te = function Te(e) {
                var _$t = e.type;
                return (e = e.nodeName) && "input" === e.toLowerCase() && ("checkbox" === _$t || "radio" === _$t);
            };
            var ye = function ye(e) {
                e._valueTracker || (e._valueTracker = function(e) {
                    var _$t = Te(e) ? "checked" : "value", _$n = Object.getOwnPropertyDescriptor(e.constructor.prototype, _$t), i = "" + e[_$t];
                    if (!e.hasOwnProperty(_$t) && void 0 !== _$n && "function" == typeof _$n.get && "function" == typeof _$n.set) {
                        var r = _$n.get, M = _$n.set;
                        return Object.defineProperty(e, _$t, {
                            configurable: !0,
                            get: function get() {
                                return r.call(this);
                            },
                            set: function set(e) {
                                i = "" + e, M.call(this, e);
                            }
                        }), Object.defineProperty(e, _$t, {
                            enumerable: _$n.enumerable
                        }), {
                            getValue: function getValue() {
                                return i;
                            },
                            setValue: function setValue(e) {
                                i = "" + e;
                            },
                            stopTracking: function stopTracking() {
                                e._valueTracker = null, delete e[_$t];
                            }
                        };
                    }
                }(e));
            };
            var ze = function ze(e) {
                if (!e) return !1;
                var _$t = e._valueTracker;
                if (!_$t) return !0;
                var _$n = _$t.getValue(), i = "";
                return e && (i = Te(e) ? e.checked ? "true" : "false" : e.value), (e = i) !== _$n && (_$t.setValue(e), !0);
            };
            var we = function we(e, t) {
                var _$n = t.checked;
                return r({}, t, {
                    defaultChecked: void 0,
                    defaultValue: void 0,
                    value: void 0,
                    checked: null != _$n ? _$n : e._wrapperState.initialChecked
                });
            };
            var fe = function fe(e, t) {
                var _$n = null == t.defaultValue ? "" : t.defaultValue, i = null != t.checked ? t.checked : t.defaultChecked;
                _$n = de(null != t.value ? t.value : _$n), e._wrapperState = {
                    initialChecked: i,
                    initialValue: _$n,
                    controlled: "checkbox" === t.type || "radio" === t.type ? null != t.checked : null != t.value
                };
            };
            var Le = function Le(e, t) {
                null != (t = t.checked) && q(e, "checked", t, !1);
            };
            var Ee = function Ee(e, t) {
                Le(e, t);
                var _$n = de(t.value), i = t.type;
                if (null != _$n) "number" === i ? (0 === _$n && "" === e.value || e.value != _$n) && (e.value = "" + _$n) : e.value !== "" + _$n && (e.value = "" + _$n);
                else if ("submit" === i || "reset" === i) return void e.removeAttribute("value");
                t.hasOwnProperty("value") ? xe(e, t.type, _$n) : t.hasOwnProperty("defaultValue") && xe(e, t.type, de(t.defaultValue)), null == t.checked && null != t.defaultChecked && (e.defaultChecked = !!t.defaultChecked);
            };
            var Ce = function Ce(e, t, n) {
                if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
                    var i = t.type;
                    if (!("submit" !== i && "reset" !== i || void 0 !== t.value && null !== t.value)) return;
                    t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
                }
                "" !== (n = e.name) && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, "" !== n && (e.name = n);
            };
            var xe = function xe(e, t, n) {
                "number" === t && e.ownerDocument.activeElement === e || (null == n ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
            };
            var pe = function pe(e, t) {
                return e = r({
                    children: void 0
                }, t), (t = function(e) {
                    var _$t = "";
                    return i.Children.forEach(e, function(e) {
                        null != e && (_$t += e);
                    }), _$t;
                }(t.children)) && (e.children = t), e;
            };
            var Se = function Se(e, t, n, i) {
                if (e = e.options, t) {
                    t = {};
                    for(var r = 0; r < n.length; r++)t["$" + n[r]] = !0;
                    for(n = 0; n < e.length; n++)r = t.hasOwnProperty("$" + e[n].value), e[n].selected !== r && (e[n].selected = r), r && i && (e[n].defaultSelected = !0);
                } else {
                    for(n = "" + de(n), t = null, r = 0; r < e.length; r++){
                        if (e[r].value === n) return e[r].selected = !0, void (i && (e[r].defaultSelected = !0));
                        null !== t || e[r].disabled || (t = e[r]);
                    }
                    null !== t && (t.selected = !0);
                }
            };
            var me = function me(e, t) {
                if (null != t.dangerouslySetInnerHTML) throw Error(u(91));
                return r({}, t, {
                    value: void 0,
                    defaultValue: void 0,
                    children: "" + e._wrapperState.initialValue
                });
            };
            var Oe = function Oe(e, t) {
                var _$n = t.value;
                if (null == _$n) {
                    if (_$n = t.children, t = t.defaultValue, null != _$n) {
                        if (null != t) throw Error(u(92));
                        if (Array.isArray(_$n)) {
                            if (!(1 >= _$n.length)) throw Error(u(93));
                            _$n = _$n[0];
                        }
                        t = _$n;
                    }
                    null == t && (t = ""), _$n = t;
                }
                e._wrapperState = {
                    initialValue: de(_$n)
                };
            };
            var ve = function ve(e, t) {
                var _$n = de(t.value), i = de(t.defaultValue);
                null != _$n && ((_$n = "" + _$n) !== e.value && (e.value = _$n), null == t.defaultValue && e.defaultValue !== _$n && (e.defaultValue = _$n)), null != i && (e.defaultValue = "" + i);
            };
            var be = function be(e) {
                var _$t = e.textContent;
                _$t === e._wrapperState.initialValue && "" !== _$t && null !== _$t && (e.value = _$t);
            };
            var Qe = function Qe(e) {
                switch(e){
                    case "svg":
                        return "http://www.w3.org/2000/svg";
                    case "math":
                        return "http://www.w3.org/1998/Math/MathML";
                    default:
                        return "http://www.w3.org/1999/xhtml";
                }
            };
            var Ye = function Ye(e, t) {
                return null == e || "http://www.w3.org/1999/xhtml" === e ? Qe(t) : "http://www.w3.org/2000/svg" === e && "foreignObject" === t ? "http://www.w3.org/1999/xhtml" : e;
            };
            var Ze = function Ze(e, t) {
                if (t) {
                    var _$n = e.firstChild;
                    if (_$n && _$n === e.lastChild && 3 === _$n.nodeType) return void (_$n.nodeValue = t);
                }
                e.textContent = t;
            };
            var Ge = function Ge(e, t) {
                var _$n = {};
                return _$n[e.toLowerCase()] = t.toLowerCase(), _$n["Webkit" + e] = "webkit" + t, _$n["Moz" + e] = "moz" + t, _$n;
            };
            var He = function He(e) {
                if (Re[e]) return Re[e];
                if (!Be[e]) return e;
                var _$t, _$n = Be[e];
                for(_$t in _$n)if (_$n.hasOwnProperty(_$t) && _$t in We) return Re[e] = _$n[_$t];
                return e;
            };
            var _e = function _e(e) {
                var _$t = qe.get(e);
                return void 0 === _$t && (_$t = new Map, qe.set(e, _$t)), _$t;
            };
            var $e = function $e(e) {
                var _$t = e, _$n = e;
                if (e.alternate) for(; _$t.return;)_$t = _$t.return;
                else {
                    e = _$t;
                    do 0 != (1026 & (_$t = e).effectTag) && (_$n = _$t.return), e = _$t.return;
                    while (e);
                }
                return 3 === _$t.tag ? _$n : null;
            };
            var et = function et(e) {
                if (13 === e.tag) {
                    var _$t = e.memoizedState;
                    if (null === _$t && null !== (e = e.alternate) && (_$t = e.memoizedState), null !== _$t) return _$t.dehydrated;
                }
                return null;
            };
            var tt = function tt(e) {
                if ($e(e) !== e) throw Error(u(188));
            };
            var nt = function nt(e) {
                if (!(e = function(e) {
                    var _$t = e.alternate;
                    if (!_$t) {
                        if (null === (_$t = $e(e))) throw Error(u(188));
                        return _$t !== e ? null : e;
                    }
                    for(var _$n = e, i = _$t;;){
                        var r = _$n.return;
                        if (null === r) break;
                        var M = r.alternate;
                        if (null === M) {
                            if (null !== (i = r.return)) {
                                _$n = i;
                                continue;
                            }
                            break;
                        }
                        if (r.child === M.child) {
                            for(M = r.child; M;){
                                if (M === _$n) return tt(r), e;
                                if (M === i) return tt(r), _$t;
                                M = M.sibling;
                            }
                            throw Error(u(188));
                        }
                        if (_$n.return !== i.return) _$n = r, i = M;
                        else {
                            for(var o = !1, c = r.child; c;){
                                if (c === _$n) {
                                    o = !0, _$n = r, i = M;
                                    break;
                                }
                                if (c === i) {
                                    o = !0, i = r, _$n = M;
                                    break;
                                }
                                c = c.sibling;
                            }
                            if (!o) {
                                for(c = M.child; c;){
                                    if (c === _$n) {
                                        o = !0, _$n = M, i = r;
                                        break;
                                    }
                                    if (c === i) {
                                        o = !0, i = M, _$n = r;
                                        break;
                                    }
                                    c = c.sibling;
                                }
                                if (!o) throw Error(u(189));
                            }
                        }
                        if (_$n.alternate !== i) throw Error(u(190));
                    }
                    if (3 !== _$n.tag) throw Error(u(188));
                    return _$n.stateNode.current === _$n ? e : _$t;
                }(e))) return null;
                for(var _$t = e;;){
                    if (5 === _$t.tag || 6 === _$t.tag) return _$t;
                    if (_$t.child) _$t.child.return = _$t, _$t = _$t.child;
                    else {
                        if (_$t === e) break;
                        for(; !_$t.sibling;){
                            if (!_$t.return || _$t.return === e) return null;
                            _$t = _$t.return;
                        }
                        _$t.sibling.return = _$t.return, _$t = _$t.sibling;
                    }
                }
                return null;
            };
            var it = function it(e, t) {
                if (null == t) throw Error(u(30));
                return null == e ? t : Array.isArray(e) ? Array.isArray(t) ? (e.push.apply(e, t), e) : (e.push(t), e) : Array.isArray(t) ? [
                    e
                ].concat(t) : [
                    e,
                    t
                ];
            };
            var rt = function rt(e, t, n) {
                Array.isArray(e) ? e.forEach(t, n) : e && t.call(n, e);
            };
            var ut = function ut(e) {
                if (e) {
                    var _$t = e._dispatchListeners, _$n = e._dispatchInstances;
                    if (Array.isArray(_$t)) for(var i = 0; i < _$t.length && !e.isPropagationStopped(); i++)D(e, _$t[i], _$n[i]);
                    else _$t && D(e, _$t, _$n);
                    e._dispatchListeners = null, e._dispatchInstances = null, e.isPersistent() || e.constructor.release(e);
                }
            };
            var ot = function ot(e) {
                if (null !== e && (Mt = it(Mt, e)), e = Mt, Mt = null, e) {
                    if (rt(e, ut), Mt) throw Error(u(95));
                    if (I) throw e = l, I = !1, l = null, e;
                }
            };
            var ct = function ct(e) {
                return (e = e.target || e.srcElement || window).correspondingUseElement && (e = e.correspondingUseElement), 3 === e.nodeType ? e.parentNode : e;
            };
            var at = function at(e) {
                if (!x) return !1;
                var _$t = (e = "on" + e) in document;
                return _$t || ((_$t = document.createElement("div")).setAttribute(e, "return;"), _$t = "function" == typeof _$t[e]), _$t;
            };
            var lt = function lt(e) {
                e.topLevelType = null, e.nativeEvent = null, e.targetInst = null, e.ancestors.length = 0, 10 > It.length && It.push(e);
            };
            var Nt = function Nt(e, t, n, i) {
                if (It.length) {
                    var r = It.pop();
                    return r.topLevelType = e, r.eventSystemFlags = i, r.nativeEvent = t, r.targetInst = n, r;
                }
                return {
                    topLevelType: e,
                    eventSystemFlags: i,
                    nativeEvent: t,
                    targetInst: n,
                    ancestors: []
                };
            };
            var jt = function jt(e) {
                var _$t = e.targetInst, _$n = _$t;
                do {
                    if (!_$n) {
                        e.ancestors.push(_$n);
                        break;
                    }
                    var i = _$n;
                    if (3 === i.tag) i = i.stateNode.containerInfo;
                    else {
                        for(; i.return;)i = i.return;
                        i = 3 !== i.tag ? null : i.stateNode.containerInfo;
                    }
                    if (!i) break;
                    5 !== (_$t = _$n.tag) && 6 !== _$t || e.ancestors.push(_$n), _$n = xn(i);
                }while (_$n);
                for(_$n = 0; _$n < e.ancestors.length; _$n++){
                    _$t = e.ancestors[_$n];
                    var r = ct(e.nativeEvent);
                    i = e.topLevelType;
                    var M = e.nativeEvent, u = e.eventSystemFlags;
                    0 === _$n && (u |= 64);
                    for(var o = null, c = 0; c < w.length; c++){
                        var a = w[c];
                        a && (a = a.extractEvents(i, _$t, M, r, u)) && (o = it(o, a));
                    }
                    ot(o);
                }
            };
            var gt = function gt(e, t, n) {
                if (!n.has(e)) {
                    switch(e){
                        case "scroll":
                            Ft(t, "scroll", !0);
                            break;
                        case "focus":
                        case "blur":
                            Ft(t, "focus", !0), Ft(t, "blur", !0), n.set("blur", null), n.set("focus", null);
                            break;
                        case "cancel":
                        case "close":
                            at(e) && Ft(t, e, !0);
                            break;
                        case "invalid":
                        case "submit":
                        case "reset":
                            break;
                        default:
                            -1 === Ke.indexOf(e) && Jt(e, t);
                    }
                    n.set(e, null);
                }
            };
            var pt = function pt(e, t, n, i, r) {
                return {
                    blockedOn: e,
                    topLevelType: t,
                    eventSystemFlags: 32 | n,
                    nativeEvent: r,
                    container: i
                };
            };
            var St = function St(e, t) {
                switch(e){
                    case "focus":
                    case "blur":
                        yt = null;
                        break;
                    case "dragenter":
                    case "dragleave":
                        zt = null;
                        break;
                    case "mouseover":
                    case "mouseout":
                        wt = null;
                        break;
                    case "pointerover":
                    case "pointerout":
                        ft.delete(t.pointerId);
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                        Lt.delete(t.pointerId);
                }
            };
            var mt = function mt(e, t, n, i, r, M) {
                return null === e || e.nativeEvent !== M ? (e = pt(t, n, i, r, M), null !== t && null !== (t = pn(t)) && At(t), e) : (e.eventSystemFlags |= i, e);
            };
            var Ot = function Ot(e) {
                var _$t = xn(e.target);
                if (null !== _$t) {
                    var _$n = $e(_$t);
                    if (null !== _$n) {
                        if (13 === (_$t = _$n.tag)) {
                            if (null !== (_$t = et(_$n))) return e.blockedOn = _$t, void M.unstable_runWithPriority(e.priority, function() {
                                Dt(_$n);
                            });
                        } else if (3 === _$t && _$n.stateNode.hydrate) return void (e.blockedOn = 3 === _$n.tag ? _$n.stateNode.containerInfo : null);
                    }
                }
                e.blockedOn = null;
            };
            var vt = function vt(e) {
                if (null !== e.blockedOn) return !1;
                var _$t = _t(e.topLevelType, e.eventSystemFlags, e.container, e.nativeEvent);
                if (null !== _$t) {
                    var _$n = pn(_$t);
                    return null !== _$n && At(_$n), e.blockedOn = _$t, !1;
                }
                return !0;
            };
            var bt = function bt(e, t, n) {
                vt(e) && n.delete(t);
            };
            var ht = function ht() {
                for(dt = !1; 0 < Tt.length;){
                    var e = Tt[0];
                    if (null !== e.blockedOn) {
                        null !== (e = pn(e.blockedOn)) && st(e);
                        break;
                    }
                    var _$t = _t(e.topLevelType, e.eventSystemFlags, e.container, e.nativeEvent);
                    null !== _$t ? e.blockedOn = _$t : Tt.shift();
                }
                null !== yt && vt(yt) && (yt = null), null !== zt && vt(zt) && (zt = null), null !== wt && vt(wt) && (wt = null), ft.forEach(bt), Lt.forEach(bt);
            };
            var kt = function kt(e, t) {
                e.blockedOn === t && (e.blockedOn = null, dt || (dt = !0, M.unstable_scheduleCallback(M.unstable_NormalPriority, ht)));
            };
            var Qt = function Qt(e) {
                function t(t) {
                    return kt(t, e);
                }
                if (0 < Tt.length) {
                    kt(Tt[0], e);
                    for(var _$n = 1; _$n < Tt.length; _$n++){
                        var i = Tt[_$n];
                        i.blockedOn === e && (i.blockedOn = null);
                    }
                }
                for(null !== yt && kt(yt, e), null !== zt && kt(zt, e), null !== wt && kt(wt, e), ft.forEach(t), Lt.forEach(t), _$n = 0; _$n < Et.length; _$n++)(i = Et[_$n]).blockedOn === e && (i.blockedOn = null);
                for(; 0 < Et.length && null === (_$n = Et[0]).blockedOn;)Ot(_$n), null === _$n.blockedOn && Et.shift();
            };
            var Gt = function Gt(e, t) {
                for(var _$n = 0; _$n < e.length; _$n += 2){
                    var i = e[_$n], r = e[_$n + 1], M = "on" + (r[0].toUpperCase() + r.slice(1));
                    M = {
                        phasedRegistrationNames: {
                            bubbled: M,
                            captured: M + "Capture"
                        },
                        dependencies: [
                            i
                        ],
                        eventPriority: t
                    }, Ut.set(i, t), Pt.set(i, M), Yt[r] = M;
                }
            };
            var Jt = function Jt(e, t) {
                Ft(t, e, !1);
            };
            var Ft = function Ft(e, t, n) {
                var i = Ut.get(t);
                switch(void 0 === i ? 2 : i){
                    case 0:
                        i = Xt.bind(null, t, 1, e);
                        break;
                    case 1:
                        i = Kt.bind(null, t, 1, e);
                        break;
                    default:
                        i = qt.bind(null, t, 1, e);
                }
                n ? e.addEventListener(t, i, !0) : e.addEventListener(t, i, !1);
            };
            var Xt = function Xt(e, t, n, i) {
                P || Q();
                var r = qt, M = P;
                P = !0;
                try {
                    k(r, e, t, n, i);
                } finally{
                    (P = M) || Z();
                }
            };
            var Kt = function Kt(e, t, n, i) {
                Ht(Wt, qt.bind(null, e, t, n, i));
            };
            var qt = function qt(e, t, n, i) {
                if (Vt) {
                    if (0 < Tt.length && -1 < Ct.indexOf(e)) e = pt(null, e, t, n, i), Tt.push(e);
                    else {
                        var r = _t(e, t, n, i);
                        if (null === r) St(e, i);
                        else if (-1 < Ct.indexOf(e)) e = pt(r, e, t, n, i), Tt.push(e);
                        else if (!function(e, t, n, i, r) {
                            switch(t){
                                case "focus":
                                    return yt = mt(yt, e, t, n, i, r), !0;
                                case "dragenter":
                                    return zt = mt(zt, e, t, n, i, r), !0;
                                case "mouseover":
                                    return wt = mt(wt, e, t, n, i, r), !0;
                                case "pointerover":
                                    var M = r.pointerId;
                                    return ft.set(M, mt(ft.get(M) || null, e, t, n, i, r)), !0;
                                case "gotpointercapture":
                                    return M = r.pointerId, Lt.set(M, mt(Lt.get(M) || null, e, t, n, i, r)), !0;
                            }
                            return !1;
                        }(r, e, t, n, i)) {
                            St(e, i), e = Nt(e, i, null, t);
                            try {
                                G(jt, e);
                            } finally{
                                lt(e);
                            }
                        }
                    }
                }
            };
            var _t = function _t(e, t, n, i) {
                if (null !== (n = xn(n = ct(i)))) {
                    var r = $e(n);
                    if (null === r) n = null;
                    else {
                        var M = r.tag;
                        if (13 === M) {
                            if (null !== (n = et(r))) return n;
                            n = null;
                        } else if (3 === M) {
                            if (r.stateNode.hydrate) return 3 === r.tag ? r.stateNode.containerInfo : null;
                            n = null;
                        } else r !== n && (n = null);
                    }
                }
                e = Nt(e, i, n, t);
                try {
                    G(jt, e);
                } finally{
                    lt(e);
                }
                return null;
            };
            var tn = function tn(e, t, n) {
                return null == t || "boolean" == typeof t || "" === t ? "" : n || "number" != typeof t || 0 === t || $t.hasOwnProperty(e) && $t[e] ? ("" + t).trim() : t + "px";
            };
            var nn = function nn(e, t) {
                for(var _$n in e = e.style, t)if (t.hasOwnProperty(_$n)) {
                    var i = 0 === _$n.indexOf("--"), r = tn(_$n, t[_$n], i);
                    "float" === _$n && (_$n = "cssFloat"), i ? e.setProperty(_$n, r) : e[_$n] = r;
                }
            };
            var Mn = function Mn(e, t) {
                if (t) {
                    if (rn[e] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw Error(u(137, e, ""));
                    if (null != t.dangerouslySetInnerHTML) {
                        if (null != t.children) throw Error(u(60));
                        if ("object" != typeof t.dangerouslySetInnerHTML || !("__html" in t.dangerouslySetInnerHTML)) throw Error(u(61));
                    }
                    if (null != t.style && "object" != typeof t.style) throw Error(u(62, ""));
                }
            };
            var un = function un(e, t) {
                if (-1 === e.indexOf("-")) return "string" == typeof t.is;
                switch(e){
                    case "annotation-xml":
                    case "color-profile":
                    case "font-face":
                    case "font-face-src":
                    case "font-face-uri":
                    case "font-face-format":
                    case "font-face-name":
                    case "missing-glyph":
                        return !1;
                    default:
                        return !0;
                }
            };
            var cn = function cn(e, t) {
                var _$n = _e(e = 9 === e.nodeType || 11 === e.nodeType ? e : e.ownerDocument);
                t = E[t];
                for(var i = 0; i < t.length; i++)gt(t[i], e, _$n);
            };
            var an = function an() {};
            var In = function In(e) {
                if (void 0 === (e = e || ("undefined" != typeof document ? document : void 0))) return null;
                try {
                    return e.activeElement || e.body;
                } catch (t) {
                    return e.body;
                }
            };
            var ln = function ln(e) {
                for(; e && e.firstChild;)e = e.firstChild;
                return e;
            };
            var Nn = function Nn(e, t) {
                var _$n, i = ln(e);
                for(e = 0; i;){
                    if (3 === i.nodeType) {
                        if (_$n = e + i.textContent.length, e <= t && _$n >= t) return {
                            node: i,
                            offset: t - e
                        };
                        e = _$n;
                    }
                    e: {
                        for(; i;){
                            if (i.nextSibling) {
                                i = i.nextSibling;
                                break e;
                            }
                            i = i.parentNode;
                        }
                        i = void 0;
                    }
                    i = ln(i);
                }
            };
            var jn = function jn() {
                for(var e = window, _$t = In(); _$t instanceof e.HTMLIFrameElement;){
                    try {
                        var _$n = "string" == typeof _$t.contentWindow.location.href;
                    } catch (e) {
                        _$n = !1;
                    }
                    if (!_$n) break;
                    _$t = In((e = _$t.contentWindow).document);
                }
                return _$t;
            };
            var gn = function gn(e) {
                var _$t = e && e.nodeName && e.nodeName.toLowerCase();
                return _$t && ("input" === _$t && ("text" === e.type || "search" === e.type || "tel" === e.type || "url" === e.type || "password" === e.type) || "textarea" === _$t || "true" === e.contentEditable);
            };
            var Dn = function Dn(e, t) {
                switch(e){
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                        return !!t.autoFocus;
                }
                return !1;
            };
            var dn = function dn(e, t) {
                return "textarea" === e || "option" === e || "noscript" === e || "string" == typeof t.children || "number" == typeof t.children || "object" == typeof t.dangerouslySetInnerHTML && null !== t.dangerouslySetInnerHTML && null != t.dangerouslySetInnerHTML.__html;
            };
            var zn = function zn(e) {
                for(; null != e; e = e.nextSibling){
                    var _$t = e.nodeType;
                    if (1 === _$t || 3 === _$t) break;
                }
                return e;
            };
            var wn = function wn(e) {
                e = e.previousSibling;
                for(var _$t = 0; e;){
                    if (8 === e.nodeType) {
                        var _$n = e.data;
                        if ("$" === _$n || "$!" === _$n || "$?" === _$n) {
                            if (0 === _$t) return e;
                            _$t--;
                        } else "/$" === _$n && _$t++;
                    }
                    e = e.previousSibling;
                }
                return null;
            };
            var xn = function xn(e) {
                var _$t = e[Ln];
                if (_$t) return _$t;
                for(var _$n = e.parentNode; _$n;){
                    if (_$t = _$n[Cn] || _$n[Ln]) {
                        if (_$n = _$t.alternate, null !== _$t.child || null !== _$n && null !== _$n.child) for(e = wn(e); null !== e;){
                            if (_$n = e[Ln]) return _$n;
                            e = wn(e);
                        }
                        return _$t;
                    }
                    _$n = (e = _$n).parentNode;
                }
                return null;
            };
            var pn = function pn(e) {
                return !(e = e[Ln] || e[Cn]) || 5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag ? null : e;
            };
            var Sn = function Sn(e) {
                if (5 === e.tag || 6 === e.tag) return e.stateNode;
                throw Error(u(33));
            };
            var mn = function mn(e) {
                return e[En] || null;
            };
            var On = function On(e) {
                do e = e.return;
                while (e && 5 !== e.tag);
                return e || null;
            };
            var vn = function vn(e, t) {
                var _$n = e.stateNode;
                if (!_$n) return null;
                var i = g(_$n);
                if (!i) return null;
                _$n = i[t];
                e: switch(t){
                    case "onClick":
                    case "onClickCapture":
                    case "onDoubleClick":
                    case "onDoubleClickCapture":
                    case "onMouseDown":
                    case "onMouseDownCapture":
                    case "onMouseMove":
                    case "onMouseMoveCapture":
                    case "onMouseUp":
                    case "onMouseUpCapture":
                    case "onMouseEnter":
                        (i = !i.disabled) || (i = !("button" === (e = e.type) || "input" === e || "select" === e || "textarea" === e)), e = !i;
                        break e;
                    default:
                        e = !1;
                }
                if (e) return null;
                if (_$n && "function" != typeof _$n) throw Error(u(231, t, typeof _$n === "undefined" ? "undefined" : (0, $1ObTH._)(_$n)));
                return _$n;
            };
            var bn = function bn(e, t, n) {
                (t = vn(e, n.dispatchConfig.phasedRegistrationNames[t])) && (n._dispatchListeners = it(n._dispatchListeners, t), n._dispatchInstances = it(n._dispatchInstances, e));
            };
            var hn = function hn(e) {
                if (e && e.dispatchConfig.phasedRegistrationNames) {
                    for(var _$t = e._targetInst, _$n = []; _$t;)_$n.push(_$t), _$t = On(_$t);
                    for(_$t = _$n.length; 0 < _$t--;)bn(_$n[_$t], "captured", e);
                    for(_$t = 0; _$t < _$n.length; _$t++)bn(_$n[_$t], "bubbled", e);
                }
            };
            var kn = function kn(e, t, n) {
                e && n && n.dispatchConfig.registrationName && (t = vn(e, n.dispatchConfig.registrationName)) && (n._dispatchListeners = it(n._dispatchListeners, t), n._dispatchInstances = it(n._dispatchInstances, e));
            };
            var Qn = function Qn(e) {
                e && e.dispatchConfig.registrationName && kn(e._targetInst, null, e);
            };
            var Yn = function Yn(e) {
                rt(e, hn);
            };
            var Gn = function Gn() {
                if (Zn) return Zn;
                var e, _$t, _$n = Un, i = _$n.length, r = "value" in Pn ? Pn.value : Pn.textContent, M = r.length;
                for(e = 0; e < i && _$n[e] === r[e]; e++);
                var u = i - e;
                for(_$t = 1; _$t <= u && _$n[i - _$t] === r[M - _$t]; _$t++);
                return Zn = r.slice(e, 1 < _$t ? 1 - _$t : void 0);
            };
            var Bn = function Bn() {
                return !0;
            };
            var Rn = function Rn() {
                return !1;
            };
            var Wn = function Wn(e, t, n, i) {
                for(var r in this.dispatchConfig = e, this._targetInst = t, this.nativeEvent = n, e = this.constructor.Interface)e.hasOwnProperty(r) && ((t = e[r]) ? this[r] = t(n) : "target" === r ? this.target = i : this[r] = n[r]);
                return this.isDefaultPrevented = (null != n.defaultPrevented ? n.defaultPrevented : !1 === n.returnValue) ? Bn : Rn, this.isPropagationStopped = Rn, this;
            };
            var Hn = function Hn(e, t, n, i) {
                if (this.eventPool.length) {
                    var r = this.eventPool.pop();
                    return this.call(r, e, t, n, i), r;
                }
                return new this(e, t, n, i);
            };
            var Vn = function Vn(e) {
                if (!(e instanceof this)) throw Error(u(279));
                e.destructor(), 10 > this.eventPool.length && this.eventPool.push(e);
            };
            var Jn = function Jn(e) {
                e.eventPool = [], e.getPooled = Hn, e.release = Vn;
            };
            var ri = function ri(e, t) {
                switch(e){
                    case "keyup":
                        return -1 !== Kn.indexOf(t.keyCode);
                    case "keydown":
                        return 229 !== t.keyCode;
                    case "keypress":
                    case "mousedown":
                    case "blur":
                        return !0;
                    default:
                        return !1;
                }
            };
            var Mi = function Mi(e) {
                return "object" == typeof (e = e.detail) && "data" in e ? e.data : null;
            };
            var ai = function ai(e) {
                var _$t = e && e.nodeName && e.nodeName.toLowerCase();
                return "input" === _$t ? !!ci[e.type] : "textarea" === _$t;
            };
            var li = function li(e, t, n) {
                return (e = Wn.getPooled(Ii.change, e, t, n)).type = "change", v(n), Yn(e), e;
            };
            var gi = function gi(e) {
                ot(e);
            };
            var si = function si(e) {
                if (ze(Sn(e))) return e;
            };
            var Ai = function Ai(e, t) {
                if ("change" === e) return t;
            };
            var di = function di() {
                Ni && (Ni.detachEvent("onpropertychange", Ti), ji = Ni = null);
            };
            var Ti = function Ti(e) {
                if ("value" === e.propertyName && si(ji)) {
                    if (e = li(ji, e, ct(e)), P) ot(e);
                    else {
                        P = !0;
                        try {
                            h(gi, e);
                        } finally{
                            P = !1, Z();
                        }
                    }
                }
            };
            var yi = function yi(e, t, n) {
                "focus" === e ? (di(), ji = n, (Ni = t).attachEvent("onpropertychange", Ti)) : "blur" === e && di();
            };
            var zi = function zi(e) {
                if ("selectionchange" === e || "keyup" === e || "keydown" === e) return si(ji);
            };
            var wi = function wi(e, t) {
                if ("click" === e) return si(t);
            };
            var fi = function fi(e, t) {
                if ("input" === e || "change" === e) return si(t);
            };
            var xi = function xi(e) {
                var _$t = this.nativeEvent;
                return _$t.getModifierState ? _$t.getModifierState(e) : !!(e = Ci[e]) && !!_$t[e];
            };
            var pi = function pi() {
                return xi;
            };
            var Ui = function Ui(e, t) {
                if (Yi(e, t)) return !0;
                if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
                var _$n = Object.keys(e), i = Object.keys(t);
                if (_$n.length !== i.length) return !1;
                for(i = 0; i < _$n.length; i++)if (!Pi.call(t, _$n[i]) || !Yi(e[_$n[i]], t[_$n[i]])) return !1;
                return !0;
            };
            var Vi = function Vi(e, t) {
                var _$n = t.window === t ? t.document : 9 === t.nodeType ? t : t.ownerDocument;
                return Hi || null == Bi || Bi !== In(_$n) ? null : ("selectionStart" in (_$n = Bi) && gn(_$n) ? _$n = {
                    start: _$n.selectionStart,
                    end: _$n.selectionEnd
                } : _$n = {
                    anchorNode: (_$n = (_$n.ownerDocument && _$n.ownerDocument.defaultView || window).getSelection()).anchorNode,
                    anchorOffset: _$n.anchorOffset,
                    focusNode: _$n.focusNode,
                    focusOffset: _$n.focusOffset
                }, Wi && Ui(Wi, _$n) ? null : (Wi = _$n, (e = Wn.getPooled(Gi.select, Ri, e, t)).type = "select", e.target = Bi, Yn(e), e));
            };
            var qi = function qi(e) {
                var _$t = e.keyCode;
                return "charCode" in e ? 0 === (e = e.charCode) && 13 === _$t && (e = 13) : e = _$t, 10 === e && (e = 13), 32 <= e || 13 === e ? e : 0;
            };
            var cr = function cr(e) {
                0 > or || (e.current = ur[or], ur[or] = null, or--);
            };
            var ar = function ar(e, t) {
                or++, ur[or] = e.current, e.current = t;
            };
            var gr = function gr(e, t) {
                var _$n = e.type.contextTypes;
                if (!_$n) return Ir;
                var i = e.stateNode;
                if (i && i.__reactInternalMemoizedUnmaskedChildContext === t) return i.__reactInternalMemoizedMaskedChildContext;
                var r, M = {};
                for(r in _$n)M[r] = t[r];
                return i && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = M), M;
            };
            var sr = function sr(e) {
                return null != (e = e.childContextTypes);
            };
            var Ar = function Ar() {
                cr(Nr), cr(lr);
            };
            var Dr = function Dr(e, t, n) {
                if (lr.current !== Ir) throw Error(u(168));
                ar(lr, t), ar(Nr, n);
            };
            var dr = function dr(e, t, n) {
                var i = e.stateNode;
                if (e = t.childContextTypes, "function" != typeof i.getChildContext) return n;
                for(var M in i = i.getChildContext())if (!(M in e)) throw Error(u(108, Ae(t) || "Unknown", M));
                return r({}, n, {}, i);
            };
            var Tr = function Tr(e) {
                return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || Ir, jr = lr.current, ar(lr, e), ar(Nr, Nr.current), !0;
            };
            var yr = function yr(e, t, n) {
                var i = e.stateNode;
                if (!i) throw Error(u(169));
                n ? (e = dr(e, t, jr), i.__reactInternalMemoizedMergedChildContext = e, cr(Nr), cr(lr), ar(lr, e)) : cr(Nr), ar(Nr, n);
            };
            var Zr = function Zr() {
                switch(Cr()){
                    case xr:
                        return 99;
                    case pr:
                        return 98;
                    case Sr:
                        return 97;
                    case mr:
                        return 96;
                    case Or:
                        return 95;
                    default:
                        throw Error(u(332));
                }
            };
            var Gr = function Gr(e) {
                switch(e){
                    case 99:
                        return xr;
                    case 98:
                        return pr;
                    case 97:
                        return Sr;
                    case 96:
                        return mr;
                    case 95:
                        return Or;
                    default:
                        throw Error(u(332));
                }
            };
            var Br = function Br(e, t) {
                return e = Gr(e), zr(e, t);
            };
            var Rr = function Rr(e, t, n) {
                return e = Gr(e), wr(e, t, n);
            };
            var Wr = function Wr(e) {
                return null === kr ? (kr = [
                    e
                ], Qr = wr(xr, Vr)) : kr.push(e), vr;
            };
            var Hr = function Hr() {
                if (null !== Qr) {
                    var e = Qr;
                    Qr = null, fr(e);
                }
                Vr();
            };
            var Vr = function Vr() {
                if (!Yr && null !== kr) {
                    Yr = !0;
                    var e = 0;
                    try {
                        var _$t = kr;
                        Br(99, function() {
                            for(; e < _$t.length; e++){
                                var _$n = _$t[e];
                                do _$n = _$n(!0);
                                while (null !== _$n);
                            }
                        }), kr = null;
                    } catch (t) {
                        throw null !== kr && (kr = kr.slice(e + 1)), wr(xr, Hr), t;
                    } finally{
                        Yr = !1;
                    }
                }
            };
            var Jr = function Jr(e, t, n) {
                return 1073741821 - (1 + ((1073741821 - e + t / 10) / (n /= 10) | 0)) * n;
            };
            var Fr = function Fr(e, t) {
                if (e && e.defaultProps) for(var _$n in t = r({}, t), e = e.defaultProps)void 0 === t[_$n] && (t[_$n] = e[_$n]);
                return t;
            };
            var $r = function $r() {
                _r = qr = Kr = null;
            };
            var eM = function eM(e) {
                var _$t = Xr.current;
                cr(Xr), e.type._context._currentValue = _$t;
            };
            var tM = function tM(e, t) {
                for(; null !== e;){
                    var _$n = e.alternate;
                    if (e.childExpirationTime < t) e.childExpirationTime = t, null !== _$n && _$n.childExpirationTime < t && (_$n.childExpirationTime = t);
                    else {
                        if (!(null !== _$n && _$n.childExpirationTime < t)) break;
                        _$n.childExpirationTime = t;
                    }
                    e = e.return;
                }
            };
            var nM = function nM(e, t) {
                Kr = e, _r = qr = null, null !== (e = e.dependencies) && null !== e.firstContext && (e.expirationTime >= t && (Su = !0), e.firstContext = null);
            };
            var iM = function iM(e, t) {
                if (_r !== e && !1 !== t && 0 !== t) {
                    if ("number" == typeof t && 1073741823 !== t || (_r = e, t = 1073741823), t = {
                        context: e,
                        observedBits: t,
                        next: null
                    }, null === qr) {
                        if (null === Kr) throw Error(u(308));
                        qr = t, Kr.dependencies = {
                            expirationTime: 0,
                            firstContext: t,
                            responders: null
                        };
                    } else qr = qr.next = t;
                }
                return e._currentValue;
            };
            var MM = function MM(e) {
                e.updateQueue = {
                    baseState: e.memoizedState,
                    baseQueue: null,
                    shared: {
                        pending: null
                    },
                    effects: null
                };
            };
            var uM = function uM(e, t) {
                e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
                    baseState: e.baseState,
                    baseQueue: e.baseQueue,
                    shared: e.shared,
                    effects: e.effects
                });
            };
            var oM = function oM(e, t) {
                return (e = {
                    expirationTime: e,
                    suspenseConfig: t,
                    tag: 0,
                    payload: null,
                    callback: null,
                    next: null
                }).next = e;
            };
            var cM = function cM(e, t) {
                if (null !== (e = e.updateQueue)) {
                    var _$n = (e = e.shared).pending;
                    null === _$n ? t.next = t : (t.next = _$n.next, _$n.next = t), e.pending = t;
                }
            };
            var aM = function aM(e, t) {
                var _$n = e.alternate;
                null !== _$n && uM(_$n, e), null === (_$n = (e = e.updateQueue).baseQueue) ? (e.baseQueue = t.next = t, t.next = t) : (t.next = _$n.next, _$n.next = t);
            };
            var IM = function IM(e, t, n, i) {
                var M = e.updateQueue;
                rM = !1;
                var u = M.baseQueue, o = M.shared.pending;
                if (null !== o) {
                    if (null !== u) {
                        var c = u.next;
                        u.next = o.next, o.next = c;
                    }
                    u = o, M.shared.pending = null, null !== (c = e.alternate) && null !== (c = c.updateQueue) && (c.baseQueue = o);
                }
                if (null !== u) {
                    c = u.next;
                    var a = M.baseState, I = 0, l = null, N = null, j = null;
                    if (null !== c) for(var g = c;;){
                        if ((o = g.expirationTime) < i) {
                            var s = {
                                expirationTime: g.expirationTime,
                                suspenseConfig: g.suspenseConfig,
                                tag: g.tag,
                                payload: g.payload,
                                callback: g.callback,
                                next: null
                            };
                            null === j ? (N = j = s, l = a) : j = j.next = s, o > I && (I = o);
                        } else {
                            null !== j && (j = j.next = {
                                expirationTime: 1073741823,
                                suspenseConfig: g.suspenseConfig,
                                tag: g.tag,
                                payload: g.payload,
                                callback: g.callback,
                                next: null
                            }), Mc(o, g.suspenseConfig);
                            e: {
                                var A = e, D = g;
                                switch(o = t, s = n, D.tag){
                                    case 1:
                                        if ("function" == typeof (A = D.payload)) {
                                            a = A.call(s, a, o);
                                            break e;
                                        }
                                        a = A;
                                        break e;
                                    case 3:
                                        A.effectTag = -4097 & A.effectTag | 64;
                                    case 0:
                                        if (null == (o = "function" == typeof (A = D.payload) ? A.call(s, a, o) : A)) break e;
                                        a = r({}, a, o);
                                        break e;
                                    case 2:
                                        rM = !0;
                                }
                            }
                            null !== g.callback && (e.effectTag |= 32, null === (o = M.effects) ? M.effects = [
                                g
                            ] : o.push(g));
                        }
                        if (null === (g = g.next) || g === c) {
                            if (null === (o = M.shared.pending)) break;
                            g = u.next = o.next, o.next = c, M.baseQueue = u = o, M.shared.pending = null;
                        }
                    }
                    null === j ? l = a : j.next = N, M.baseState = l, M.baseQueue = j, uc(I), e.expirationTime = I, e.memoizedState = a;
                }
            };
            var lM = function lM(e, t, n) {
                if (e = t.effects, t.effects = null, null !== e) for(t = 0; t < e.length; t++){
                    var i = e[t], r = i.callback;
                    if (null !== r) {
                        if (i.callback = null, i = r, r = n, "function" != typeof i) throw Error(u(191, i));
                        i.call(r);
                    }
                }
            };
            var gM = function gM(e, t, n, i) {
                n = null == (n = n(i, t = e.memoizedState)) ? t : r({}, t, n), e.memoizedState = n, 0 === e.expirationTime && (e.updateQueue.baseState = n);
            };
            var AM = function AM(e, t, n, i, r, M, u) {
                return "function" == typeof (e = e.stateNode).shouldComponentUpdate ? e.shouldComponentUpdate(i, M, u) : !t.prototype || !t.prototype.isPureReactComponent || !Ui(n, i) || !Ui(r, M);
            };
            var DM = function DM(e, t, n) {
                var i = !1, r = Ir, M = t.contextType;
                return "object" == typeof M && null !== M ? M = iM(M) : (r = sr(t) ? jr : lr.current, M = (i = null != (i = t.contextTypes)) ? gr(e, r) : Ir), t = new t(n, M), e.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, t.updater = sM, e.stateNode = t, t._reactInternalFiber = e, i && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = r, e.__reactInternalMemoizedMaskedChildContext = M), t;
            };
            var dM = function dM(e, t, n, i) {
                e = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, i), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, i), t.state !== e && sM.enqueueReplaceState(t, t.state, null);
            };
            var TM = function TM(e, t, n, i) {
                var r = e.stateNode;
                r.props = n, r.state = e.memoizedState, r.refs = jM, MM(e);
                var M = t.contextType;
                "object" == typeof M && null !== M ? r.context = iM(M) : (M = sr(t) ? jr : lr.current, r.context = gr(e, M)), IM(e, n, r, i), r.state = e.memoizedState, "function" == typeof (M = t.getDerivedStateFromProps) && (gM(e, t, M, n), r.state = e.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof r.getSnapshotBeforeUpdate || "function" != typeof r.UNSAFE_componentWillMount && "function" != typeof r.componentWillMount || (t = r.state, "function" == typeof r.componentWillMount && r.componentWillMount(), "function" == typeof r.UNSAFE_componentWillMount && r.UNSAFE_componentWillMount(), t !== r.state && sM.enqueueReplaceState(r, r.state, null), IM(e, n, r, i), r.state = e.memoizedState), "function" == typeof r.componentDidMount && (e.effectTag |= 4);
            };
            var zM = function zM(e, t, n) {
                if (null !== (e = n.ref) && "function" != typeof e && "object" != typeof e) {
                    if (n._owner) {
                        if (n = n._owner) {
                            if (1 !== n.tag) throw Error(u(309));
                            var i = n.stateNode;
                        }
                        if (!i) throw Error(u(147, e));
                        var r = "" + e;
                        return null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === r ? t.ref : ((t = function t(e) {
                            var _$t = i.refs;
                            _$t === jM && (_$t = i.refs = {}), null === e ? delete _$t[r] : _$t[r] = e;
                        })._stringRef = r, t);
                    }
                    if ("string" != typeof e) throw Error(u(284));
                    if (!n._owner) throw Error(u(290, e));
                }
                return e;
            };
            var wM = function wM(e, t) {
                if ("textarea" !== e.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(t) ? "object with keys {" + Object.keys(t).join(", ") + "}" : t, ""));
            };
            var fM = function fM(e) {
                function t(t, n) {
                    if (e) {
                        var i = t.lastEffect;
                        null !== i ? (i.nextEffect = n, t.lastEffect = n) : t.firstEffect = t.lastEffect = n, n.nextEffect = null, n.effectTag = 8;
                    }
                }
                function n(n, i) {
                    if (!e) return null;
                    for(; null !== i;)t(n, i), i = i.sibling;
                    return null;
                }
                function i(e, t) {
                    for(e = new Map; null !== t;)null !== t.key ? e.set(t.key, t) : e.set(t.index, t), t = t.sibling;
                    return e;
                }
                function r(e, t) {
                    return (e = Cc(e, t)).index = 0, e.sibling = null, e;
                }
                function M(t, n, i) {
                    return t.index = i, e ? null !== (i = t.alternate) ? (i = i.index) < n ? (t.effectTag = 2, n) : i : (t.effectTag = 2, n) : n;
                }
                function o(t) {
                    return e && null === t.alternate && (t.effectTag = 2), t;
                }
                function c(e, t, n, i) {
                    return null === t || 6 !== t.tag ? ((t = Sc(n, e.mode, i)).return = e, t) : ((t = r(t, n)).return = e, t);
                }
                function a(e, t, n, i) {
                    return null !== t && t.elementType === n.type ? ((i = r(t, n.props)).ref = zM(e, t, n), i.return = e, i) : ((i = xc(n.type, n.key, n.props, null, e.mode, i)).ref = zM(e, t, n), i.return = e, i);
                }
                function I(e, t, n, i) {
                    return null === t || 4 !== t.tag || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = mc(n, e.mode, i)).return = e, t) : ((t = r(t, n.children || [])).return = e, t);
                }
                function l(e, t, n, i, M) {
                    return null === t || 7 !== t.tag ? ((t = pc(n, e.mode, i, M)).return = e, t) : ((t = r(t, n)).return = e, t);
                }
                function N(e, t, n) {
                    if ("string" == typeof t || "number" == typeof t) return (t = Sc("" + t, e.mode, n)).return = e, t;
                    if ("object" == typeof t && null !== t) {
                        switch(t.$$typeof){
                            case ee:
                                return (n = xc(t.type, t.key, t.props, null, e.mode, n)).ref = zM(e, null, t), n.return = e, n;
                            case te:
                                return (t = mc(t, e.mode, n)).return = e, t;
                        }
                        if (yM(t) || se(t)) return (t = pc(t, e.mode, n, null)).return = e, t;
                        wM(e, t);
                    }
                    return null;
                }
                function j(e, t, n, i) {
                    var r = null !== t ? t.key : null;
                    if ("string" == typeof n || "number" == typeof n) return null !== r ? null : c(e, t, "" + n, i);
                    if ("object" == typeof n && null !== n) {
                        switch(n.$$typeof){
                            case ee:
                                return n.key === r ? n.type === ne ? l(e, t, n.props.children, i, r) : a(e, t, n, i) : null;
                            case te:
                                return n.key === r ? I(e, t, n, i) : null;
                        }
                        if (yM(n) || se(n)) return null !== r ? null : l(e, t, n, i, null);
                        wM(e, n);
                    }
                    return null;
                }
                function g(e, t, n, i, r) {
                    if ("string" == typeof i || "number" == typeof i) return c(t, e = e.get(n) || null, "" + i, r);
                    if ("object" == typeof i && null !== i) {
                        switch(i.$$typeof){
                            case ee:
                                return e = e.get(null === i.key ? n : i.key) || null, i.type === ne ? l(t, e, i.props.children, r, i.key) : a(t, e, i, r);
                            case te:
                                return I(t, e = e.get(null === i.key ? n : i.key) || null, i, r);
                        }
                        if (yM(i) || se(i)) return l(t, e = e.get(n) || null, i, r, null);
                        wM(t, i);
                    }
                    return null;
                }
                function s(r, u, o, c) {
                    for(var a = null, I = null, l = u, s = u = 0, A = null; null !== l && s < o.length; s++){
                        l.index > s ? (A = l, l = null) : A = l.sibling;
                        var D = j(r, l, o[s], c);
                        if (null === D) {
                            null === l && (l = A);
                            break;
                        }
                        e && l && null === D.alternate && t(r, l), u = M(D, u, s), null === I ? a = D : I.sibling = D, I = D, l = A;
                    }
                    if (s === o.length) return n(r, l), a;
                    if (null === l) {
                        for(; s < o.length; s++)null !== (l = N(r, o[s], c)) && (u = M(l, u, s), null === I ? a = l : I.sibling = l, I = l);
                        return a;
                    }
                    for(l = i(r, l); s < o.length; s++)null !== (A = g(l, r, s, o[s], c)) && (e && null !== A.alternate && l.delete(null === A.key ? s : A.key), u = M(A, u, s), null === I ? a = A : I.sibling = A, I = A);
                    return e && l.forEach(function(e) {
                        return t(r, e);
                    }), a;
                }
                function A(r, o, c, a) {
                    var I = se(c);
                    if ("function" != typeof I) throw Error(u(150));
                    if (null == (c = I.call(c))) throw Error(u(151));
                    for(var l = I = null, s = o, A = o = 0, D = null, d = c.next(); null !== s && !d.done; A++, d = c.next()){
                        s.index > A ? (D = s, s = null) : D = s.sibling;
                        var T = j(r, s, d.value, a);
                        if (null === T) {
                            null === s && (s = D);
                            break;
                        }
                        e && s && null === T.alternate && t(r, s), o = M(T, o, A), null === l ? I = T : l.sibling = T, l = T, s = D;
                    }
                    if (d.done) return n(r, s), I;
                    if (null === s) {
                        for(; !d.done; A++, d = c.next())null !== (d = N(r, d.value, a)) && (o = M(d, o, A), null === l ? I = d : l.sibling = d, l = d);
                        return I;
                    }
                    for(s = i(r, s); !d.done; A++, d = c.next())null !== (d = g(s, r, A, d.value, a)) && (e && null !== d.alternate && s.delete(null === d.key ? A : d.key), o = M(d, o, A), null === l ? I = d : l.sibling = d, l = d);
                    return e && s.forEach(function(e) {
                        return t(r, e);
                    }), I;
                }
                return function(e, i, M, c) {
                    var a = "object" == typeof M && null !== M && M.type === ne && null === M.key;
                    a && (M = M.props.children);
                    var I = "object" == typeof M && null !== M;
                    if (I) switch(M.$$typeof){
                        case ee:
                            e: {
                                for(I = M.key, a = i; null !== a;){
                                    if (a.key === I) {
                                        switch(a.tag){
                                            case 7:
                                                if (M.type === ne) {
                                                    n(e, a.sibling), (i = r(a, M.props.children)).return = e, e = i;
                                                    break e;
                                                }
                                                break;
                                            default:
                                                if (a.elementType === M.type) {
                                                    n(e, a.sibling), (i = r(a, M.props)).ref = zM(e, a, M), i.return = e, e = i;
                                                    break e;
                                                }
                                        }
                                        n(e, a);
                                        break;
                                    }
                                    t(e, a), a = a.sibling;
                                }
                                M.type === ne ? ((i = pc(M.props.children, e.mode, c, M.key)).return = e, e = i) : ((c = xc(M.type, M.key, M.props, null, e.mode, c)).ref = zM(e, i, M), c.return = e, e = c);
                            }
                            return o(e);
                        case te:
                            e: {
                                for(a = M.key; null !== i;){
                                    if (i.key === a) {
                                        if (4 === i.tag && i.stateNode.containerInfo === M.containerInfo && i.stateNode.implementation === M.implementation) {
                                            n(e, i.sibling), (i = r(i, M.children || [])).return = e, e = i;
                                            break e;
                                        }
                                        n(e, i);
                                        break;
                                    }
                                    t(e, i), i = i.sibling;
                                }
                                (i = mc(M, e.mode, c)).return = e, e = i;
                            }
                            return o(e);
                    }
                    if ("string" == typeof M || "number" == typeof M) return M = "" + M, null !== i && 6 === i.tag ? (n(e, i.sibling), (i = r(i, M)).return = e, e = i) : (n(e, i), (i = Sc(M, e.mode, c)).return = e, e = i), o(e);
                    if (yM(M)) return s(e, i, M, c);
                    if (se(M)) return A(e, i, M, c);
                    if (I && wM(e, M), void 0 === M && !a) switch(e.tag){
                        case 1:
                        case 0:
                            throw e = e.type, Error(u(152, e.displayName || e.name || "Component"));
                    }
                    return n(e, i);
                };
            };
            var mM = function mM(e) {
                if (e === CM) throw Error(u(174));
                return e;
            };
            var OM = function OM(e, t) {
                switch(ar(SM, t), ar(pM, e), ar(xM, CM), e = t.nodeType){
                    case 9:
                    case 11:
                        t = (t = t.documentElement) ? t.namespaceURI : Ye(null, "");
                        break;
                    default:
                        t = Ye(t = (e = 8 === e ? t.parentNode : t).namespaceURI || null, e = e.tagName);
                }
                cr(xM), ar(xM, t);
            };
            var vM = function vM() {
                cr(xM), cr(pM), cr(SM);
            };
            var bM = function bM(e) {
                mM(SM.current);
                var _$t = mM(xM.current), _$n = Ye(_$t, e.type);
                _$t !== _$n && (ar(pM, e), ar(xM, _$n));
            };
            var hM = function hM(e) {
                pM.current === e && (cr(xM), cr(pM));
            };
            var QM = function QM(e) {
                for(var _$t = e; null !== _$t;){
                    if (13 === _$t.tag) {
                        var _$n = _$t.memoizedState;
                        if (null !== _$n && (null === (_$n = _$n.dehydrated) || "$?" === _$n.data || "$!" === _$n.data)) return _$t;
                    } else if (19 === _$t.tag && void 0 !== _$t.memoizedProps.revealOrder) {
                        if (0 != (64 & _$t.effectTag)) return _$t;
                    } else if (null !== _$t.child) {
                        _$t.child.return = _$t, _$t = _$t.child;
                        continue;
                    }
                    if (_$t === e) break;
                    for(; null === _$t.sibling;){
                        if (null === _$t.return || _$t.return === e) return null;
                        _$t = _$t.return;
                    }
                    _$t.sibling.return = _$t.return, _$t = _$t.sibling;
                }
                return null;
            };
            var YM = function YM(e, t) {
                return {
                    responder: e,
                    props: t
                };
            };
            var HM = function HM() {
                throw Error(u(321));
            };
            var VM = function VM(e, t) {
                if (null === t) return !1;
                for(var _$n = 0; _$n < t.length && _$n < e.length; _$n++)if (!Yi(e[_$n], t[_$n])) return !1;
                return !0;
            };
            var JM = function JM(e, t, n, i, r, M) {
                if (ZM = M, GM = t, t.memoizedState = null, t.updateQueue = null, t.expirationTime = 0, PM.current = null === e || null === e.memoizedState ? Au : Du, e = n(i, r), t.expirationTime === ZM) {
                    M = 0;
                    do {
                        if (t.expirationTime = 0, !(25 > M)) throw Error(u(301));
                        M += 1, RM = BM = null, t.updateQueue = null, PM.current = du, e = n(i, r);
                    }while (t.expirationTime === ZM);
                }
                if (PM.current = su, t = null !== BM && null !== BM.next, ZM = 0, RM = BM = GM = null, WM = !1, t) throw Error(u(300));
                return e;
            };
            var FM = function FM() {
                var e = {
                    memoizedState: null,
                    baseState: null,
                    baseQueue: null,
                    queue: null,
                    next: null
                };
                return null === RM ? GM.memoizedState = RM = e : RM = RM.next = e, RM;
            };
            var XM = function XM() {
                if (null === BM) {
                    var e = GM.alternate;
                    e = null !== e ? e.memoizedState : null;
                } else e = BM.next;
                var _$t = null === RM ? GM.memoizedState : RM.next;
                if (null !== _$t) RM = _$t, BM = e;
                else {
                    if (null === e) throw Error(u(310));
                    e = {
                        memoizedState: (BM = e).memoizedState,
                        baseState: BM.baseState,
                        baseQueue: BM.baseQueue,
                        queue: BM.queue,
                        next: null
                    }, null === RM ? GM.memoizedState = RM = e : RM = RM.next = e;
                }
                return RM;
            };
            var KM = function KM(e, t) {
                return "function" == typeof t ? t(e) : t;
            };
            var qM = function qM(e) {
                var _$t = XM(), _$n = _$t.queue;
                if (null === _$n) throw Error(u(311));
                _$n.lastRenderedReducer = e;
                var i = BM, r = i.baseQueue, M = _$n.pending;
                if (null !== M) {
                    if (null !== r) {
                        var o = r.next;
                        r.next = M.next, M.next = o;
                    }
                    i.baseQueue = r = M, _$n.pending = null;
                }
                if (null !== r) {
                    r = r.next, i = i.baseState;
                    var c = o = M = null, a = r;
                    do {
                        var I = a.expirationTime;
                        if (I < ZM) {
                            var l = {
                                expirationTime: a.expirationTime,
                                suspenseConfig: a.suspenseConfig,
                                action: a.action,
                                eagerReducer: a.eagerReducer,
                                eagerState: a.eagerState,
                                next: null
                            };
                            null === c ? (o = c = l, M = i) : c = c.next = l, I > GM.expirationTime && (GM.expirationTime = I, uc(I));
                        } else null !== c && (c = c.next = {
                            expirationTime: 1073741823,
                            suspenseConfig: a.suspenseConfig,
                            action: a.action,
                            eagerReducer: a.eagerReducer,
                            eagerState: a.eagerState,
                            next: null
                        }), Mc(I, a.suspenseConfig), i = a.eagerReducer === e ? a.eagerState : e(i, a.action);
                        a = a.next;
                    }while (null !== a && a !== r);
                    null === c ? M = i : c.next = o, Yi(i, _$t.memoizedState) || (Su = !0), _$t.memoizedState = i, _$t.baseState = M, _$t.baseQueue = c, _$n.lastRenderedState = i;
                }
                return [
                    _$t.memoizedState,
                    _$n.dispatch
                ];
            };
            var _M = function _M(e) {
                var _$t = XM(), _$n = _$t.queue;
                if (null === _$n) throw Error(u(311));
                _$n.lastRenderedReducer = e;
                var i = _$n.dispatch, r = _$n.pending, M = _$t.memoizedState;
                if (null !== r) {
                    _$n.pending = null;
                    var o = r = r.next;
                    do M = e(M, o.action), o = o.next;
                    while (o !== r);
                    Yi(M, _$t.memoizedState) || (Su = !0), _$t.memoizedState = M, null === _$t.baseQueue && (_$t.baseState = M), _$n.lastRenderedState = M;
                }
                return [
                    M,
                    i
                ];
            };
            var $M = function $M(e) {
                var _$t = FM();
                return "function" == typeof e && (e = e()), _$t.memoizedState = _$t.baseState = e, e = (e = _$t.queue = {
                    pending: null,
                    dispatch: null,
                    lastRenderedReducer: KM,
                    lastRenderedState: e
                }).dispatch = gu.bind(null, GM, e), [
                    _$t.memoizedState,
                    e
                ];
            };
            var eu = function eu(e, t, n, i) {
                return e = {
                    tag: e,
                    create: t,
                    destroy: n,
                    deps: i,
                    next: null
                }, null === (t = GM.updateQueue) ? (t = {
                    lastEffect: null
                }, GM.updateQueue = t, t.lastEffect = e.next = e) : null === (n = t.lastEffect) ? t.lastEffect = e.next = e : (i = n.next, n.next = e, e.next = i, t.lastEffect = e), e;
            };
            var tu = function tu() {
                return XM().memoizedState;
            };
            var nu = function nu(e, t, n, i) {
                var r = FM();
                GM.effectTag |= e, r.memoizedState = eu(1 | t, n, void 0, void 0 === i ? null : i);
            };
            var iu = function iu(e, t, n, i) {
                var r = XM();
                i = void 0 === i ? null : i;
                var M = void 0;
                if (null !== BM) {
                    var u = BM.memoizedState;
                    if (M = u.destroy, null !== i && VM(i, u.deps)) return void eu(t, n, M, i);
                }
                GM.effectTag |= e, r.memoizedState = eu(1 | t, n, M, i);
            };
            var ru = function ru(e, t) {
                return nu(516, 4, e, t);
            };
            var Mu = function Mu(e, t) {
                return iu(516, 4, e, t);
            };
            var uu = function uu(e, t) {
                return iu(4, 2, e, t);
            };
            var ou = function ou(e, t) {
                return "function" == typeof t ? (e = e(), t(e), function() {
                    t(null);
                }) : null != t ? (e = e(), t.current = e, function() {
                    t.current = null;
                }) : void 0;
            };
            var cu = function cu(e, t, n) {
                return n = null != n ? n.concat([
                    e
                ]) : null, iu(4, 2, ou.bind(null, t, e), n);
            };
            var au = function au() {};
            var Iu = function Iu(e, t) {
                return FM().memoizedState = [
                    e,
                    void 0 === t ? null : t
                ], e;
            };
            var lu = function lu(e, t) {
                var _$n = XM();
                t = void 0 === t ? null : t;
                var i = _$n.memoizedState;
                return null !== i && null !== t && VM(t, i[1]) ? i[0] : (_$n.memoizedState = [
                    e,
                    t
                ], e);
            };
            var Nu = function Nu(e, t) {
                var _$n = XM();
                t = void 0 === t ? null : t;
                var i = _$n.memoizedState;
                return null !== i && null !== t && VM(t, i[1]) ? i[0] : (e = e(), _$n.memoizedState = [
                    e,
                    t
                ], e);
            };
            var ju = function ju(e, t, n) {
                var i = Zr();
                Br(98 > i ? 98 : i, function() {
                    e(!0);
                }), Br(97 < i ? 97 : i, function() {
                    var i = UM.suspense;
                    UM.suspense = void 0 === t ? null : t;
                    try {
                        e(!1), n();
                    } finally{
                        UM.suspense = i;
                    }
                });
            };
            var gu = function gu(e, t, n) {
                var i = Vo(), r = NM.suspense;
                r = {
                    expirationTime: i = Jo(i, e, r),
                    suspenseConfig: r,
                    action: n,
                    eagerReducer: null,
                    eagerState: null,
                    next: null
                };
                var M = t.pending;
                if (null === M ? r.next = r : (r.next = M.next, M.next = r), t.pending = r, M = e.alternate, e === GM || null !== M && M === GM) WM = !0, r.expirationTime = ZM, GM.expirationTime = ZM;
                else {
                    if (0 === e.expirationTime && (null === M || 0 === M.expirationTime) && null !== (M = t.lastRenderedReducer)) try {
                        var u = t.lastRenderedState, o = M(u, n);
                        if (r.eagerReducer = M, r.eagerState = o, Yi(o, u)) return;
                    } catch (e) {}
                    Fo(e, i);
                }
            };
            var wu = function wu(e, t) {
                var _$n = Lc(5, null, null, 0);
                _$n.elementType = "DELETED", _$n.type = "DELETED", _$n.stateNode = t, _$n.return = e, _$n.effectTag = 8, null !== e.lastEffect ? (e.lastEffect.nextEffect = _$n, e.lastEffect = _$n) : e.firstEffect = e.lastEffect = _$n;
            };
            var fu = function fu(e, t) {
                switch(e.tag){
                    case 5:
                        var _$n = e.type;
                        return null !== (t = 1 !== t.nodeType || _$n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t) && (e.stateNode = t, !0);
                    case 6:
                        return null !== (t = "" === e.pendingProps || 3 !== t.nodeType ? null : t) && (e.stateNode = t, !0);
                    case 13:
                    default:
                        return !1;
                }
            };
            var Lu = function Lu(e) {
                if (zu) {
                    var _$t = yu;
                    if (_$t) {
                        var _$n = _$t;
                        if (!fu(e, _$t)) {
                            if (!(_$t = zn(_$n.nextSibling)) || !fu(e, _$t)) return e.effectTag = -1025 & e.effectTag | 2, zu = !1, void (Tu = e);
                            wu(Tu, _$n);
                        }
                        Tu = e, yu = zn(_$t.firstChild);
                    } else e.effectTag = -1025 & e.effectTag | 2, zu = !1, Tu = e;
                }
            };
            var Eu = function Eu(e) {
                for(e = e.return; null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;)e = e.return;
                Tu = e;
            };
            var Cu = function Cu(e) {
                if (e !== Tu) return !1;
                if (!zu) return Eu(e), zu = !0, !1;
                var _$t = e.type;
                if (5 !== e.tag || "head" !== _$t && "body" !== _$t && !dn(_$t, e.memoizedProps)) for(_$t = yu; _$t;)wu(e, _$t), _$t = zn(_$t.nextSibling);
                if (Eu(e), 13 === e.tag) {
                    if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null)) throw Error(u(317));
                    e: {
                        for(e = e.nextSibling, _$t = 0; e;){
                            if (8 === e.nodeType) {
                                var _$n = e.data;
                                if ("/$" === _$n) {
                                    if (0 === _$t) {
                                        yu = zn(e.nextSibling);
                                        break e;
                                    }
                                    _$t--;
                                } else "$" !== _$n && "$!" !== _$n && "$?" !== _$n || _$t++;
                            }
                            e = e.nextSibling;
                        }
                        yu = null;
                    }
                } else yu = Tu ? zn(e.stateNode.nextSibling) : null;
                return !0;
            };
            var xu = function xu() {
                yu = Tu = null, zu = !1;
            };
            var mu = function mu(e, t, n, i) {
                t.child = null === e ? EM(t, null, n, i) : LM(t, e.child, n, i);
            };
            var Ou = function Ou(e, t, n, i, r) {
                n = n.render;
                var M = t.ref;
                return nM(t, r), i = JM(e, t, n, i, M, r), null === e || Su ? (t.effectTag |= 1, mu(e, t, i, r), t.child) : (t.updateQueue = e.updateQueue, t.effectTag &= -517, e.expirationTime <= r && (e.expirationTime = 0), Ju(e, t, r));
            };
            var vu = function vu(e, t, n, i, r, M) {
                if (null === e) {
                    var u = n.type;
                    return "function" != typeof u || Ec(u) || void 0 !== u.defaultProps || null !== n.compare || void 0 !== n.defaultProps ? ((e = xc(n.type, null, i, null, t.mode, M)).ref = t.ref, e.return = t, t.child = e) : (t.tag = 15, t.type = u, bu(e, t, u, i, r, M));
                }
                return u = e.child, r < M && (r = u.memoizedProps, (n = null !== (n = n.compare) ? n : Ui)(r, i) && e.ref === t.ref) ? Ju(e, t, M) : (t.effectTag |= 1, (e = Cc(u, i)).ref = t.ref, e.return = t, t.child = e);
            };
            var bu = function bu(e, t, n, i, r, M) {
                return null !== e && Ui(e.memoizedProps, i) && e.ref === t.ref && (Su = !1, r < M) ? (t.expirationTime = e.expirationTime, Ju(e, t, M)) : ku(e, t, n, i, M);
            };
            var hu = function hu(e, t) {
                var _$n = t.ref;
                (null === e && null !== _$n || null !== e && e.ref !== _$n) && (t.effectTag |= 128);
            };
            var ku = function ku(e, t, n, i, r) {
                var M = sr(n) ? jr : lr.current;
                return M = gr(t, M), nM(t, r), n = JM(e, t, n, i, M, r), null === e || Su ? (t.effectTag |= 1, mu(e, t, n, r), t.child) : (t.updateQueue = e.updateQueue, t.effectTag &= -517, e.expirationTime <= r && (e.expirationTime = 0), Ju(e, t, r));
            };
            var Qu = function Qu(e, t, n, i, r) {
                if (sr(n)) {
                    var M = !0;
                    Tr(t);
                } else M = !1;
                if (nM(t, r), null === t.stateNode) null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), DM(t, n, i), TM(t, n, i, r), i = !0;
                else if (null === e) {
                    var u = t.stateNode, o = t.memoizedProps;
                    u.props = o;
                    var c = u.context, a = n.contextType;
                    "object" == typeof a && null !== a ? a = iM(a) : a = gr(t, a = sr(n) ? jr : lr.current);
                    var I = n.getDerivedStateFromProps, l = "function" == typeof I || "function" == typeof u.getSnapshotBeforeUpdate;
                    l || "function" != typeof u.UNSAFE_componentWillReceiveProps && "function" != typeof u.componentWillReceiveProps || (o !== i || c !== a) && dM(t, u, i, a), rM = !1;
                    var N = t.memoizedState;
                    u.state = N, IM(t, i, u, r), c = t.memoizedState, o !== i || N !== c || Nr.current || rM ? ("function" == typeof I && (gM(t, n, I, i), c = t.memoizedState), (o = rM || AM(t, n, o, i, N, c, a)) ? (l || "function" != typeof u.UNSAFE_componentWillMount && "function" != typeof u.componentWillMount || ("function" == typeof u.componentWillMount && u.componentWillMount(), "function" == typeof u.UNSAFE_componentWillMount && u.UNSAFE_componentWillMount()), "function" == typeof u.componentDidMount && (t.effectTag |= 4)) : ("function" == typeof u.componentDidMount && (t.effectTag |= 4), t.memoizedProps = i, t.memoizedState = c), u.props = i, u.state = c, u.context = a, i = o) : ("function" == typeof u.componentDidMount && (t.effectTag |= 4), i = !1);
                } else u = t.stateNode, uM(e, t), o = t.memoizedProps, u.props = t.type === t.elementType ? o : Fr(t.type, o), c = u.context, "object" == typeof (a = n.contextType) && null !== a ? a = iM(a) : a = gr(t, a = sr(n) ? jr : lr.current), (l = "function" == typeof (I = n.getDerivedStateFromProps) || "function" == typeof u.getSnapshotBeforeUpdate) || "function" != typeof u.UNSAFE_componentWillReceiveProps && "function" != typeof u.componentWillReceiveProps || (o !== i || c !== a) && dM(t, u, i, a), rM = !1, c = t.memoizedState, u.state = c, IM(t, i, u, r), N = t.memoizedState, o !== i || c !== N || Nr.current || rM ? ("function" == typeof I && (gM(t, n, I, i), N = t.memoizedState), (I = rM || AM(t, n, o, i, c, N, a)) ? (l || "function" != typeof u.UNSAFE_componentWillUpdate && "function" != typeof u.componentWillUpdate || ("function" == typeof u.componentWillUpdate && u.componentWillUpdate(i, N, a), "function" == typeof u.UNSAFE_componentWillUpdate && u.UNSAFE_componentWillUpdate(i, N, a)), "function" == typeof u.componentDidUpdate && (t.effectTag |= 4), "function" == typeof u.getSnapshotBeforeUpdate && (t.effectTag |= 256)) : ("function" != typeof u.componentDidUpdate || o === e.memoizedProps && c === e.memoizedState || (t.effectTag |= 4), "function" != typeof u.getSnapshotBeforeUpdate || o === e.memoizedProps && c === e.memoizedState || (t.effectTag |= 256), t.memoizedProps = i, t.memoizedState = N), u.props = i, u.state = N, u.context = a, i = I) : ("function" != typeof u.componentDidUpdate || o === e.memoizedProps && c === e.memoizedState || (t.effectTag |= 4), "function" != typeof u.getSnapshotBeforeUpdate || o === e.memoizedProps && c === e.memoizedState || (t.effectTag |= 256), i = !1);
                return Yu(e, t, n, i, M, r);
            };
            var Yu = function Yu(e, t, n, i, r, M) {
                hu(e, t);
                var u = 0 != (64 & t.effectTag);
                if (!i && !u) return r && yr(t, n, !1), Ju(e, t, M);
                i = t.stateNode, pu.current = t;
                var o = u && "function" != typeof n.getDerivedStateFromError ? null : i.render();
                return t.effectTag |= 1, null !== e && u ? (t.child = LM(t, e.child, null, M), t.child = LM(t, null, o, M)) : mu(e, t, o, M), t.memoizedState = i.state, r && yr(t, n, !0), t.child;
            };
            var Pu = function Pu(e) {
                var _$t = e.stateNode;
                _$t.pendingContext ? Dr(0, _$t.pendingContext, _$t.pendingContext !== _$t.context) : _$t.context && Dr(0, _$t.context, !1), OM(e, _$t.containerInfo);
            };
            var Ru = function Ru(e, t, n) {
                var i, r = t.mode, M = t.pendingProps, u = kM.current, o = !1;
                if ((i = 0 != (64 & t.effectTag)) || (i = 0 != (2 & u) && (null === e || null !== e.memoizedState)), i ? (o = !0, t.effectTag &= -65) : null !== e && null === e.memoizedState || void 0 === M.fallback || !0 === M.unstable_avoidThisFallback || (u |= 1), ar(kM, 1 & u), null === e) {
                    if (void 0 !== M.fallback && Lu(t), o) {
                        if (o = M.fallback, (M = pc(null, r, 0, null)).return = t, 0 == (2 & t.mode)) for(e = null !== t.memoizedState ? t.child.child : t.child, M.child = e; null !== e;)e.return = M, e = e.sibling;
                        return (n = pc(o, r, n, null)).return = t, M.sibling = n, t.memoizedState = Bu, t.child = M, n;
                    }
                    return r = M.children, t.memoizedState = null, t.child = EM(t, null, r, n);
                }
                if (null !== e.memoizedState) {
                    if (r = (e = e.child).sibling, o) {
                        if (M = M.fallback, (n = Cc(e, e.pendingProps)).return = t, 0 == (2 & t.mode) && (o = null !== t.memoizedState ? t.child.child : t.child) !== e.child) for(n.child = o; null !== o;)o.return = n, o = o.sibling;
                        return (r = Cc(r, M)).return = t, n.sibling = r, n.childExpirationTime = 0, t.memoizedState = Bu, t.child = n, r;
                    }
                    return n = LM(t, e.child, M.children, n), t.memoizedState = null, t.child = n;
                }
                if (e = e.child, o) {
                    if (o = M.fallback, (M = pc(null, r, 0, null)).return = t, M.child = e, null !== e && (e.return = M), 0 == (2 & t.mode)) for(e = null !== t.memoizedState ? t.child.child : t.child, M.child = e; null !== e;)e.return = M, e = e.sibling;
                    return (n = pc(o, r, n, null)).return = t, M.sibling = n, n.effectTag |= 2, M.childExpirationTime = 0, t.memoizedState = Bu, t.child = M, n;
                }
                return t.memoizedState = null, t.child = LM(t, e, M.children, n);
            };
            var Wu = function Wu(e, t) {
                e.expirationTime < t && (e.expirationTime = t);
                var _$n = e.alternate;
                null !== _$n && _$n.expirationTime < t && (_$n.expirationTime = t), tM(e.return, t);
            };
            var Hu = function Hu(e, t, n, i, r, M) {
                var u = e.memoizedState;
                null === u ? e.memoizedState = {
                    isBackwards: t,
                    rendering: null,
                    renderingStartTime: 0,
                    last: i,
                    tail: n,
                    tailExpiration: 0,
                    tailMode: r,
                    lastEffect: M
                } : (u.isBackwards = t, u.rendering = null, u.renderingStartTime = 0, u.last = i, u.tail = n, u.tailExpiration = 0, u.tailMode = r, u.lastEffect = M);
            };
            var Vu = function Vu(e, t, n) {
                var i = t.pendingProps, r = i.revealOrder, M = i.tail;
                if (mu(e, t, i.children, n), 0 != (2 & (i = kM.current))) i = 1 & i | 2, t.effectTag |= 64;
                else {
                    if (null !== e && 0 != (64 & e.effectTag)) e: for(e = t.child; null !== e;){
                        if (13 === e.tag) null !== e.memoizedState && Wu(e, n);
                        else if (19 === e.tag) Wu(e, n);
                        else if (null !== e.child) {
                            e.child.return = e, e = e.child;
                            continue;
                        }
                        if (e === t) break e;
                        for(; null === e.sibling;){
                            if (null === e.return || e.return === t) break e;
                            e = e.return;
                        }
                        e.sibling.return = e.return, e = e.sibling;
                    }
                    i &= 1;
                }
                if (ar(kM, i), 0 == (2 & t.mode)) t.memoizedState = null;
                else switch(r){
                    case "forwards":
                        for(n = t.child, r = null; null !== n;)null !== (e = n.alternate) && null === QM(e) && (r = n), n = n.sibling;
                        null === (n = r) ? (r = t.child, t.child = null) : (r = n.sibling, n.sibling = null), Hu(t, !1, r, n, M, t.lastEffect);
                        break;
                    case "backwards":
                        for(n = null, r = t.child, t.child = null; null !== r;){
                            if (null !== (e = r.alternate) && null === QM(e)) {
                                t.child = r;
                                break;
                            }
                            e = r.sibling, r.sibling = n, n = r, r = e;
                        }
                        Hu(t, !0, n, null, M, t.lastEffect);
                        break;
                    case "together":
                        Hu(t, !1, null, null, void 0, t.lastEffect);
                        break;
                    default:
                        t.memoizedState = null;
                }
                return t.child;
            };
            var Ju = function Ju(e, t, n) {
                null !== e && (t.dependencies = e.dependencies);
                var i = t.expirationTime;
                if (0 !== i && uc(i), t.childExpirationTime < n) return null;
                if (null !== e && t.child !== e.child) throw Error(u(153));
                if (null !== t.child) {
                    for(n = Cc(e = t.child, e.pendingProps), t.child = n, n.return = t; null !== e.sibling;)e = e.sibling, (n = n.sibling = Cc(e, e.pendingProps)).return = t;
                    n.sibling = null;
                }
                return t.child;
            };
            var Fu = function Fu(e, t) {
                switch(e.tailMode){
                    case "hidden":
                        t = e.tail;
                        for(var _$n = null; null !== t;)null !== t.alternate && (_$n = t), t = t.sibling;
                        null === _$n ? e.tail = null : _$n.sibling = null;
                        break;
                    case "collapsed":
                        _$n = e.tail;
                        for(var i = null; null !== _$n;)null !== _$n.alternate && (i = _$n), _$n = _$n.sibling;
                        null === i ? t || null === e.tail ? e.tail = null : e.tail.sibling = null : i.sibling = null;
                }
            };
            var Xu = function Xu(e, t, n) {
                var i = t.pendingProps;
                switch(t.tag){
                    case 2:
                    case 16:
                    case 15:
                    case 0:
                    case 11:
                    case 7:
                    case 8:
                    case 12:
                    case 9:
                    case 14:
                        return null;
                    case 1:
                        return sr(t.type) && Ar(), null;
                    case 3:
                        return vM(), cr(Nr), cr(lr), (n = t.stateNode).pendingContext && (n.context = n.pendingContext, n.pendingContext = null), null !== e && null !== e.child || !Cu(t) || (t.effectTag |= 4), null;
                    case 5:
                        hM(t), n = mM(SM.current);
                        var M = t.type;
                        if (null !== e && null != t.stateNode) Zu(e, t, M, i, n), e.ref !== t.ref && (t.effectTag |= 128);
                        else {
                            if (!i) {
                                if (null === t.stateNode) throw Error(u(166));
                                return null;
                            }
                            if (e = mM(xM.current), Cu(t)) {
                                i = t.stateNode, M = t.type;
                                var o = t.memoizedProps;
                                switch(i[Ln] = t, i[En] = o, M){
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        Jt("load", i);
                                        break;
                                    case "video":
                                    case "audio":
                                        for(e = 0; e < Ke.length; e++)Jt(Ke[e], i);
                                        break;
                                    case "source":
                                        Jt("error", i);
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        Jt("error", i), Jt("load", i);
                                        break;
                                    case "form":
                                        Jt("reset", i), Jt("submit", i);
                                        break;
                                    case "details":
                                        Jt("toggle", i);
                                        break;
                                    case "input":
                                        fe(i, o), Jt("invalid", i), cn(n, "onChange");
                                        break;
                                    case "select":
                                        i._wrapperState = {
                                            wasMultiple: !!o.multiple
                                        }, Jt("invalid", i), cn(n, "onChange");
                                        break;
                                    case "textarea":
                                        Oe(i, o), Jt("invalid", i), cn(n, "onChange");
                                }
                                for(var c in Mn(M, o), e = null, o)if (o.hasOwnProperty(c)) {
                                    var a = o[c];
                                    "children" === c ? "string" == typeof a ? i.textContent !== a && (e = [
                                        "children",
                                        a
                                    ]) : "number" == typeof a && i.textContent !== "" + a && (e = [
                                        "children",
                                        "" + a
                                    ]) : L.hasOwnProperty(c) && null != a && cn(n, c);
                                }
                                switch(M){
                                    case "input":
                                        ye(i), Ce(i, o, !0);
                                        break;
                                    case "textarea":
                                        ye(i), be(i);
                                        break;
                                    case "select":
                                    case "option":
                                        break;
                                    default:
                                        "function" == typeof o.onClick && (i.onclick = an);
                                }
                                n = e, t.updateQueue = n, null !== n && (t.effectTag |= 4);
                            } else {
                                switch(c = 9 === n.nodeType ? n : n.ownerDocument, e === on && (e = Qe(M)), e === on ? "script" === M ? ((e = c.createElement("div")).innerHTML = "<script></script>", e = e.removeChild(e.firstChild)) : "string" == typeof i.is ? e = c.createElement(M, {
                                    is: i.is
                                }) : (e = c.createElement(M), "select" === M && (c = e, i.multiple ? c.multiple = !0 : i.size && (c.size = i.size))) : e = c.createElementNS(e, M), e[Ln] = t, e[En] = i, Uu(e, t), t.stateNode = e, c = un(M, i), M){
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        Jt("load", e), a = i;
                                        break;
                                    case "video":
                                    case "audio":
                                        for(a = 0; a < Ke.length; a++)Jt(Ke[a], e);
                                        a = i;
                                        break;
                                    case "source":
                                        Jt("error", e), a = i;
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        Jt("error", e), Jt("load", e), a = i;
                                        break;
                                    case "form":
                                        Jt("reset", e), Jt("submit", e), a = i;
                                        break;
                                    case "details":
                                        Jt("toggle", e), a = i;
                                        break;
                                    case "input":
                                        fe(e, i), a = we(e, i), Jt("invalid", e), cn(n, "onChange");
                                        break;
                                    case "option":
                                        a = pe(e, i);
                                        break;
                                    case "select":
                                        e._wrapperState = {
                                            wasMultiple: !!i.multiple
                                        }, a = r({}, i, {
                                            value: void 0
                                        }), Jt("invalid", e), cn(n, "onChange");
                                        break;
                                    case "textarea":
                                        Oe(e, i), a = me(e, i), Jt("invalid", e), cn(n, "onChange");
                                        break;
                                    default:
                                        a = i;
                                }
                                Mn(M, a);
                                var I = a;
                                for(o in I)if (I.hasOwnProperty(o)) {
                                    var l = I[o];
                                    "style" === o ? nn(e, l) : "dangerouslySetInnerHTML" === o ? null != (l = l ? l.__html : void 0) && Ue(e, l) : "children" === o ? "string" == typeof l ? ("textarea" !== M || "" !== l) && Ze(e, l) : "number" == typeof l && Ze(e, "" + l) : "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && "autoFocus" !== o && (L.hasOwnProperty(o) ? null != l && cn(n, o) : null != l && q(e, o, l, c));
                                }
                                switch(M){
                                    case "input":
                                        ye(e), Ce(e, i, !1);
                                        break;
                                    case "textarea":
                                        ye(e), be(e);
                                        break;
                                    case "option":
                                        null != i.value && e.setAttribute("value", "" + de(i.value));
                                        break;
                                    case "select":
                                        e.multiple = !!i.multiple, null != (n = i.value) ? Se(e, !!i.multiple, n, !1) : null != i.defaultValue && Se(e, !!i.multiple, i.defaultValue, !0);
                                        break;
                                    default:
                                        "function" == typeof a.onClick && (e.onclick = an);
                                }
                                Dn(M, i) && (t.effectTag |= 4);
                            }
                            null !== t.ref && (t.effectTag |= 128);
                        }
                        return null;
                    case 6:
                        if (e && null != t.stateNode) Gu(0, t, e.memoizedProps, i);
                        else {
                            if ("string" != typeof i && null === t.stateNode) throw Error(u(166));
                            n = mM(SM.current), mM(xM.current), Cu(t) ? (n = t.stateNode, i = t.memoizedProps, n[Ln] = t, n.nodeValue !== i && (t.effectTag |= 4)) : ((n = (9 === n.nodeType ? n : n.ownerDocument).createTextNode(i))[Ln] = t, t.stateNode = n);
                        }
                        return null;
                    case 13:
                        return cr(kM), i = t.memoizedState, 0 != (64 & t.effectTag) ? (t.expirationTime = n, t) : (n = null !== i, i = !1, null === e ? void 0 !== t.memoizedProps.fallback && Cu(t) : (i = null !== (M = e.memoizedState), n || null === M || null !== (M = e.child.sibling) && (null !== (o = t.firstEffect) ? (t.firstEffect = M, M.nextEffect = o) : (t.firstEffect = t.lastEffect = M, M.nextEffect = null), M.effectTag = 8)), n && !i && 0 != (2 & t.mode) && (null === e && !0 !== t.memoizedProps.unstable_avoidThisFallback || 0 != (1 & kM.current) ? xo === yo && (xo = zo) : (xo !== yo && xo !== zo || (xo = wo), 0 !== vo && null !== Lo && (bc(Lo, Co), hc(Lo, vo)))), (n || i) && (t.effectTag |= 4), null);
                    case 4:
                        return vM(), null;
                    case 10:
                        return eM(t), null;
                    case 17:
                        return sr(t.type) && Ar(), null;
                    case 19:
                        if (cr(kM), null === (i = t.memoizedState)) return null;
                        if (M = 0 != (64 & t.effectTag), null === (o = i.rendering)) {
                            if (M) Fu(i, !1);
                            else if (xo !== yo || null !== e && 0 != (64 & e.effectTag)) for(o = t.child; null !== o;){
                                if (null !== (e = QM(o))) {
                                    for(t.effectTag |= 64, Fu(i, !1), null !== (M = e.updateQueue) && (t.updateQueue = M, t.effectTag |= 4), null === i.lastEffect && (t.firstEffect = null), t.lastEffect = i.lastEffect, i = t.child; null !== i;)o = n, (M = i).effectTag &= 2, M.nextEffect = null, M.firstEffect = null, M.lastEffect = null, null === (e = M.alternate) ? (M.childExpirationTime = 0, M.expirationTime = o, M.child = null, M.memoizedProps = null, M.memoizedState = null, M.updateQueue = null, M.dependencies = null) : (M.childExpirationTime = e.childExpirationTime, M.expirationTime = e.expirationTime, M.child = e.child, M.memoizedProps = e.memoizedProps, M.memoizedState = e.memoizedState, M.updateQueue = e.updateQueue, o = e.dependencies, M.dependencies = null === o ? null : {
                                        expirationTime: o.expirationTime,
                                        firstContext: o.firstContext,
                                        responders: o.responders
                                    }), i = i.sibling;
                                    return ar(kM, 1 & kM.current | 2), t.child;
                                }
                                o = o.sibling;
                            }
                        } else {
                            if (!M) {
                                if (null !== (e = QM(o))) {
                                    if (t.effectTag |= 64, M = !0, null !== (n = e.updateQueue) && (t.updateQueue = n, t.effectTag |= 4), Fu(i, !0), null === i.tail && "hidden" === i.tailMode && !o.alternate) return null !== (t = t.lastEffect = i.lastEffect) && (t.nextEffect = null), null;
                                } else 2 * Ur() - i.renderingStartTime > i.tailExpiration && 1 < n && (t.effectTag |= 64, M = !0, Fu(i, !1), t.expirationTime = t.childExpirationTime = n - 1);
                            }
                            i.isBackwards ? (o.sibling = t.child, t.child = o) : (null !== (n = i.last) ? n.sibling = o : t.child = o, i.last = o);
                        }
                        return null !== i.tail ? (0 === i.tailExpiration && (i.tailExpiration = Ur() + 500), n = i.tail, i.rendering = n, i.tail = n.sibling, i.lastEffect = t.lastEffect, i.renderingStartTime = Ur(), n.sibling = null, t = kM.current, ar(kM, M ? 1 & t | 2 : 1 & t), n) : null;
                }
                throw Error(u(156, t.tag));
            };
            var Ku = function Ku(e) {
                switch(e.tag){
                    case 1:
                        sr(e.type) && Ar();
                        var _$t = e.effectTag;
                        return 4096 & _$t ? (e.effectTag = -4097 & _$t | 64, e) : null;
                    case 3:
                        if (vM(), cr(Nr), cr(lr), 0 != (64 & (_$t = e.effectTag))) throw Error(u(285));
                        return e.effectTag = -4097 & _$t | 64, e;
                    case 5:
                        return hM(e), null;
                    case 13:
                        return cr(kM), 4096 & (_$t = e.effectTag) ? (e.effectTag = -4097 & _$t | 64, e) : null;
                    case 19:
                        return cr(kM), null;
                    case 4:
                        return vM(), null;
                    case 10:
                        return eM(e), null;
                    default:
                        return null;
                }
            };
            var qu = function qu(e, t) {
                return {
                    value: e,
                    source: t,
                    stack: De(t)
                };
            };
            var $u = function $u(e, t) {
                var _$n = t.source, i = t.stack;
                null === i && null !== _$n && (i = De(_$n)), null !== _$n && Ae(_$n.type), t = t.value, null !== e && 1 === e.tag && Ae(e.type);
                try {
                    console.error(t);
                } catch (e) {
                    setTimeout(function() {
                        throw e;
                    });
                }
            };
            var eo = function eo(e) {
                var _$t = e.ref;
                if (null !== _$t) {
                    if ("function" == typeof _$t) try {
                        _$t(null);
                    } catch (t) {
                        dc(e, t);
                    }
                    else _$t.current = null;
                }
            };
            var to = function to(e, t) {
                switch(t.tag){
                    case 0:
                    case 11:
                    case 15:
                    case 22:
                        return;
                    case 1:
                        if (256 & t.effectTag && null !== e) {
                            var _$n = e.memoizedProps, i = e.memoizedState;
                            t = (e = t.stateNode).getSnapshotBeforeUpdate(t.elementType === t.type ? _$n : Fr(t.type, _$n), i), e.__reactInternalSnapshotBeforeUpdate = t;
                        }
                        return;
                    case 3:
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        return;
                }
                throw Error(u(163));
            };
            var no = function no(e, t) {
                if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
                    var _$n = t = t.next;
                    do {
                        if ((_$n.tag & e) === e) {
                            var i = _$n.destroy;
                            _$n.destroy = void 0, void 0 !== i && i();
                        }
                        _$n = _$n.next;
                    }while (_$n !== t);
                }
            };
            var io = function io(e, t) {
                if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
                    var _$n = t = t.next;
                    do {
                        if ((_$n.tag & e) === e) {
                            var i = _$n.create;
                            _$n.destroy = i();
                        }
                        _$n = _$n.next;
                    }while (_$n !== t);
                }
            };
            var ro = function ro(e, t, n) {
                switch(n.tag){
                    case 0:
                    case 11:
                    case 15:
                    case 22:
                        return void io(3, n);
                    case 1:
                        if (e = n.stateNode, 4 & n.effectTag) {
                            if (null === t) e.componentDidMount();
                            else {
                                var i = n.elementType === n.type ? t.memoizedProps : Fr(n.type, t.memoizedProps);
                                e.componentDidUpdate(i, t.memoizedState, e.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        return void (null !== (t = n.updateQueue) && lM(n, t, e));
                    case 3:
                        if (null !== (t = n.updateQueue)) {
                            if (e = null, null !== n.child) switch(n.child.tag){
                                case 5:
                                    e = n.child.stateNode;
                                    break;
                                case 1:
                                    e = n.child.stateNode;
                            }
                            lM(n, t, e);
                        }
                        return;
                    case 5:
                        return e = n.stateNode, void (null === t && 4 & n.effectTag && Dn(n.type, n.memoizedProps) && e.focus());
                    case 6:
                    case 4:
                    case 12:
                        return;
                    case 13:
                        return void (null === n.memoizedState && (n = n.alternate, null !== n && (n = n.memoizedState, null !== n && (n = n.dehydrated, null !== n && Qt(n)))));
                    case 19:
                    case 17:
                    case 20:
                    case 21:
                        return;
                }
                throw Error(u(163));
            };
            var Mo = function Mo(e, t, n) {
                switch("function" == typeof wc && wc(t), t.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                    case 22:
                        if (null !== (e = t.updateQueue) && null !== (e = e.lastEffect)) {
                            var i = e.next;
                            Br(97 < n ? 97 : n, function() {
                                var _$e = i;
                                do {
                                    var _$n = _$e.destroy;
                                    if (void 0 !== _$n) {
                                        var r = t;
                                        try {
                                            _$n();
                                        } catch (e) {
                                            dc(r, e);
                                        }
                                    }
                                    _$e = _$e.next;
                                }while (_$e !== i);
                            });
                        }
                        break;
                    case 1:
                        eo(t), "function" == typeof (n = t.stateNode).componentWillUnmount && function(e, t) {
                            try {
                                t.props = e.memoizedProps, t.state = e.memoizedState, t.componentWillUnmount();
                            } catch (t) {
                                dc(e, t);
                            }
                        }(t, n);
                        break;
                    case 5:
                        eo(t);
                        break;
                    case 4:
                        ao(e, t, n);
                }
            };
            var oo = function oo(e) {
                return 5 === e.tag || 3 === e.tag || 4 === e.tag;
            };
            var co = function co(e) {
                e: {
                    for(var _$t = e.return; null !== _$t;){
                        if (oo(_$t)) {
                            var _$n = _$t;
                            break e;
                        }
                        _$t = _$t.return;
                    }
                    throw Error(u(160));
                }
                switch(_$t = _$n.stateNode, _$n.tag){
                    case 5:
                        var i = !1;
                        break;
                    case 3:
                    case 4:
                        _$t = _$t.containerInfo, i = !0;
                        break;
                    default:
                        throw Error(u(161));
                }
                16 & _$n.effectTag && (Ze(_$t, ""), _$n.effectTag &= -17);
                e: t: for(_$n = e;;){
                    for(; null === _$n.sibling;){
                        if (null === _$n.return || oo(_$n.return)) {
                            _$n = null;
                            break e;
                        }
                        _$n = _$n.return;
                    }
                    for(_$n.sibling.return = _$n.return, _$n = _$n.sibling; 5 !== _$n.tag && 6 !== _$n.tag && 18 !== _$n.tag;){
                        if (2 & _$n.effectTag) continue t;
                        if (null === _$n.child || 4 === _$n.tag) continue t;
                        _$n.child.return = _$n, _$n = _$n.child;
                    }
                    if (!(2 & _$n.effectTag)) {
                        _$n = _$n.stateNode;
                        break e;
                    }
                }
                i ? function e(t, n, i) {
                    var r = t.tag, M = 5 === r || 6 === r;
                    if (M) t = M ? t.stateNode : t.stateNode.instance, n ? 8 === i.nodeType ? i.parentNode.insertBefore(t, n) : i.insertBefore(t, n) : (8 === i.nodeType ? (n = i.parentNode).insertBefore(t, i) : (n = i).appendChild(t), null !== (i = i._reactRootContainer) && void 0 !== i || null !== n.onclick || (n.onclick = an));
                    else if (4 !== r && null !== (t = t.child)) for(e(t, n, i), t = t.sibling; null !== t;)e(t, n, i), t = t.sibling;
                }(e, _$n, _$t) : function e(t, n, i) {
                    var r = t.tag, M = 5 === r || 6 === r;
                    if (M) t = M ? t.stateNode : t.stateNode.instance, n ? i.insertBefore(t, n) : i.appendChild(t);
                    else if (4 !== r && null !== (t = t.child)) for(e(t, n, i), t = t.sibling; null !== t;)e(t, n, i), t = t.sibling;
                }(e, _$n, _$t);
            };
            var ao = function ao(e, t, n) {
                for(var i, r, M = t, o = !1;;){
                    if (!o) {
                        o = M.return;
                        e: for(;;){
                            if (null === o) throw Error(u(160));
                            switch(i = o.stateNode, o.tag){
                                case 5:
                                    r = !1;
                                    break e;
                                case 3:
                                case 4:
                                    i = i.containerInfo, r = !0;
                                    break e;
                            }
                            o = o.return;
                        }
                        o = !0;
                    }
                    if (5 === M.tag || 6 === M.tag) {
                        e: for(var c = e, a = M, I = n, l = a;;)if (Mo(c, l, I), null !== l.child && 4 !== l.tag) l.child.return = l, l = l.child;
                        else {
                            if (l === a) break e;
                            for(; null === l.sibling;){
                                if (null === l.return || l.return === a) break e;
                                l = l.return;
                            }
                            l.sibling.return = l.return, l = l.sibling;
                        }
                        r ? (c = i, a = M.stateNode, 8 === c.nodeType ? c.parentNode.removeChild(a) : c.removeChild(a)) : i.removeChild(M.stateNode);
                    } else if (4 === M.tag) {
                        if (null !== M.child) {
                            i = M.stateNode.containerInfo, r = !0, M.child.return = M, M = M.child;
                            continue;
                        }
                    } else if (Mo(e, M, n), null !== M.child) {
                        M.child.return = M, M = M.child;
                        continue;
                    }
                    if (M === t) break;
                    for(; null === M.sibling;){
                        if (null === M.return || M.return === t) return;
                        4 === (M = M.return).tag && (o = !1);
                    }
                    M.sibling.return = M.return, M = M.sibling;
                }
            };
            var Io = function Io(e, t) {
                switch(t.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                    case 22:
                        return void no(3, t);
                    case 1:
                        return;
                    case 5:
                        var _$n = t.stateNode;
                        if (null != _$n) {
                            var i = t.memoizedProps, r = null !== e ? e.memoizedProps : i;
                            e = t.type;
                            var M = t.updateQueue;
                            if (t.updateQueue = null, null !== M) {
                                for(_$n[En] = i, "input" === e && "radio" === i.type && null != i.name && Le(_$n, i), un(e, r), t = un(e, i), r = 0; r < M.length; r += 2){
                                    var o = M[r], c = M[r + 1];
                                    "style" === o ? nn(_$n, c) : "dangerouslySetInnerHTML" === o ? Ue(_$n, c) : "children" === o ? Ze(_$n, c) : q(_$n, o, c, t);
                                }
                                switch(e){
                                    case "input":
                                        Ee(_$n, i);
                                        break;
                                    case "textarea":
                                        ve(_$n, i);
                                        break;
                                    case "select":
                                        t = _$n._wrapperState.wasMultiple, _$n._wrapperState.wasMultiple = !!i.multiple, null != (e = i.value) ? Se(_$n, !!i.multiple, e, !1) : t !== !!i.multiple && (null != i.defaultValue ? Se(_$n, !!i.multiple, i.defaultValue, !0) : Se(_$n, !!i.multiple, i.multiple ? [] : "", !1));
                                }
                            }
                        }
                        return;
                    case 6:
                        if (null === t.stateNode) throw Error(u(162));
                        return void (t.stateNode.nodeValue = t.memoizedProps);
                    case 3:
                        return void ((t = t.stateNode).hydrate && (t.hydrate = !1, Qt(t.containerInfo)));
                    case 12:
                        return;
                    case 13:
                        if (_$n = t, null === t.memoizedState ? i = !1 : (i = !0, _$n = t.child, ho = Ur()), null !== _$n) e: for(e = _$n;;){
                            if (5 === e.tag) M = e.stateNode, i ? "function" == typeof (M = M.style).setProperty ? M.setProperty("display", "none", "important") : M.display = "none" : (M = e.stateNode, r = null != (r = e.memoizedProps.style) && r.hasOwnProperty("display") ? r.display : null, M.style.display = tn("display", r));
                            else if (6 === e.tag) e.stateNode.nodeValue = i ? "" : e.memoizedProps;
                            else {
                                if (13 === e.tag && null !== e.memoizedState && null === e.memoizedState.dehydrated) {
                                    (M = e.child.sibling).return = e, e = M;
                                    continue;
                                }
                                if (null !== e.child) {
                                    e.child.return = e, e = e.child;
                                    continue;
                                }
                            }
                            if (e === _$n) break;
                            for(; null === e.sibling;){
                                if (null === e.return || e.return === _$n) break e;
                                e = e.return;
                            }
                            e.sibling.return = e.return, e = e.sibling;
                        }
                        return void lo(t);
                    case 19:
                        return void lo(t);
                    case 17:
                        return;
                }
                throw Error(u(163));
            };
            var lo = function lo(e) {
                var _$t = e.updateQueue;
                if (null !== _$t) {
                    e.updateQueue = null;
                    var _$n = e.stateNode;
                    null === _$n && (_$n = e.stateNode = new _u), _$t.forEach(function(t) {
                        var i = yc.bind(null, e, t);
                        _$n.has(t) || (_$n.add(t), t.then(i, i));
                    });
                }
            };
            var jo = function jo(e, t, n) {
                (n = oM(n, null)).tag = 3, n.payload = {
                    element: null
                };
                var i = t.value;
                return n.callback = function() {
                    Qo || (Qo = !0, Yo = i), $u(e, t);
                }, n;
            };
            var go = function go(e, t, n) {
                (n = oM(n, null)).tag = 3;
                var i = e.type.getDerivedStateFromError;
                if ("function" == typeof i) {
                    var r = t.value;
                    n.payload = function() {
                        return $u(e, t), i(r);
                    };
                }
                var M = e.stateNode;
                return null !== M && "function" == typeof M.componentDidCatch && (n.callback = function() {
                    "function" != typeof i && (null === Po ? Po = new Set([
                        this
                    ]) : Po.add(this), $u(e, t));
                    var _$n = t.stack;
                    this.componentDidCatch(t.value, {
                        componentStack: null !== _$n ? _$n : ""
                    });
                }), n;
            };
            var Vo = function Vo() {
                return 0 != (48 & fo) ? 1073741821 - (Ur() / 10 | 0) : 0 !== Ho ? Ho : Ho = 1073741821 - (Ur() / 10 | 0);
            };
            var Jo = function Jo(e, t, n) {
                if (0 == (2 & (t = t.mode))) return 1073741823;
                var i = Zr();
                if (0 == (4 & t)) return 99 === i ? 1073741823 : 1073741822;
                if (0 != (16 & fo)) return Co;
                if (null !== n) e = Jr(e, 0 | n.timeoutMs || 5e3, 250);
                else switch(i){
                    case 99:
                        e = 1073741823;
                        break;
                    case 98:
                        e = Jr(e, 150, 100);
                        break;
                    case 97:
                    case 96:
                        e = Jr(e, 5e3, 250);
                        break;
                    case 95:
                        e = 2;
                        break;
                    default:
                        throw Error(u(326));
                }
                return null !== Lo && e === Co && --e, e;
            };
            var Fo = function Fo(e, t) {
                if (50 < Ro) throw Ro = 0, Wo = null, Error(u(185));
                if (null !== (e = Xo(e, t))) {
                    var _$n = Zr();
                    1073741823 === t ? 0 != (8 & fo) && 0 == (48 & fo) ? $o(e) : (qo(e), 0 === fo && Hr()) : qo(e), 0 == (4 & fo) || 98 !== _$n && 99 !== _$n || (null === Bo ? Bo = new Map([
                        [
                            e,
                            t
                        ]
                    ]) : (void 0 === (_$n = Bo.get(e)) || _$n > t) && Bo.set(e, t));
                }
            };
            var Xo = function Xo(e, t) {
                e.expirationTime < t && (e.expirationTime = t);
                var _$n = e.alternate;
                null !== _$n && _$n.expirationTime < t && (_$n.expirationTime = t);
                var i = e.return, r = null;
                if (null === i && 3 === e.tag) r = e.stateNode;
                else for(; null !== i;){
                    if (_$n = i.alternate, i.childExpirationTime < t && (i.childExpirationTime = t), null !== _$n && _$n.childExpirationTime < t && (_$n.childExpirationTime = t), null === i.return && 3 === i.tag) {
                        r = i.stateNode;
                        break;
                    }
                    i = i.return;
                }
                return null !== r && (Lo === r && (uc(t), xo === wo && bc(r, Co)), hc(r, t)), r;
            };
            var Ko = function Ko(e) {
                var _$t = e.lastExpiredTime;
                if (0 !== _$t) return _$t;
                if (!vc(e, _$t = e.firstPendingTime)) return _$t;
                var _$n = e.lastPingedTime;
                return 2 >= (e = _$n > (e = e.nextKnownPendingLevel) ? _$n : e) && _$t !== e ? 0 : e;
            };
            var qo = function qo(e) {
                if (0 !== e.lastExpiredTime) e.callbackExpirationTime = 1073741823, e.callbackPriority = 99, e.callbackNode = Wr($o.bind(null, e));
                else {
                    var _$t = Ko(e), _$n = e.callbackNode;
                    if (0 === _$t) null !== _$n && (e.callbackNode = null, e.callbackExpirationTime = 0, e.callbackPriority = 90);
                    else {
                        var i = Vo();
                        if (1073741823 === _$t ? i = 99 : 1 === _$t || 2 === _$t ? i = 95 : i = 0 >= (i = 10 * (1073741821 - _$t) - 10 * (1073741821 - i)) ? 99 : 250 >= i ? 98 : 5250 >= i ? 97 : 95, null !== _$n) {
                            var r = e.callbackPriority;
                            if (e.callbackExpirationTime === _$t && r >= i) return;
                            _$n !== vr && fr(_$n);
                        }
                        e.callbackExpirationTime = _$t, e.callbackPriority = i, _$t = 1073741823 === _$t ? Wr($o.bind(null, e)) : Rr(i, _o.bind(null, e), {
                            timeout: 10 * (1073741821 - _$t) - Ur()
                        }), e.callbackNode = _$t;
                    }
                }
            };
            var $o = function $o(e) {
                var _$t = e.lastExpiredTime;
                if (_$t = 0 !== _$t ? _$t : 1073741823, 0 != (48 & fo)) throw Error(u(327));
                if (sc(), e === Lo && _$t === Co || nc(e, _$t), null !== Eo) {
                    var _$n = fo;
                    fo |= 16;
                    for(var i = rc();;)try {
                        oc();
                        break;
                    } catch (t) {
                        ic(e, t);
                    }
                    if ($r(), fo = _$n, Do.current = i, 1 === xo) throw _$n = po, nc(e, _$t), bc(e, _$t), qo(e), _$n;
                    if (null !== Eo) throw Error(u(261));
                    e.finishedWork = e.current.alternate, e.finishedExpirationTime = _$t, Lo = null, Nc(e), qo(e);
                }
                return null;
            };
            var ec = function ec(e, t) {
                var _$n = fo;
                fo |= 1;
                try {
                    return e(t);
                } finally{
                    0 === (fo = _$n) && Hr();
                }
            };
            var tc = function tc(e, t) {
                var _$n = fo;
                fo &= -2, fo |= 8;
                try {
                    return e(t);
                } finally{
                    0 === (fo = _$n) && Hr();
                }
            };
            var nc = function nc(e, t) {
                e.finishedWork = null, e.finishedExpirationTime = 0;
                var _$n = e.timeoutHandle;
                if (-1 !== _$n && (e.timeoutHandle = -1, yn(_$n)), null !== Eo) for(_$n = Eo.return; null !== _$n;){
                    var i = _$n;
                    switch(i.tag){
                        case 1:
                            null != (i = i.type.childContextTypes) && Ar();
                            break;
                        case 3:
                            vM(), cr(Nr), cr(lr);
                            break;
                        case 5:
                            hM(i);
                            break;
                        case 4:
                            vM();
                            break;
                        case 13:
                        case 19:
                            cr(kM);
                            break;
                        case 10:
                            eM(i);
                    }
                    _$n = _$n.return;
                }
                Lo = e, Eo = Cc(e.current, null), Co = t, xo = yo, po = null, mo = So = 1073741823, Oo = null, vo = 0, bo = !1;
            };
            var ic = function ic(e, t) {
                for(;;){
                    try {
                        if ($r(), PM.current = su, WM) for(var _$n = GM.memoizedState; null !== _$n;){
                            var i = _$n.queue;
                            null !== i && (i.pending = null), _$n = _$n.next;
                        }
                        if (ZM = 0, RM = BM = GM = null, WM = !1, null === Eo || null === Eo.return) return xo = 1, po = t, Eo = null;
                        e: {
                            var r = e, M = Eo.return, u = Eo, o = t;
                            if (t = Co, u.effectTag |= 2048, u.firstEffect = u.lastEffect = null, null !== o && "object" == typeof o && "function" == typeof o.then) {
                                var c = o;
                                if (0 == (2 & u.mode)) {
                                    var a = u.alternate;
                                    a ? (u.updateQueue = a.updateQueue, u.memoizedState = a.memoizedState, u.expirationTime = a.expirationTime) : (u.updateQueue = null, u.memoizedState = null);
                                }
                                var I = 0 != (1 & kM.current), l = M;
                                do {
                                    var N;
                                    if (N = 13 === l.tag) {
                                        var j = l.memoizedState;
                                        if (null !== j) N = null !== j.dehydrated;
                                        else {
                                            var g = l.memoizedProps;
                                            N = void 0 !== g.fallback && (!0 !== g.unstable_avoidThisFallback || !I);
                                        }
                                    }
                                    if (N) {
                                        var s = l.updateQueue;
                                        if (null === s) {
                                            var A = new Set;
                                            A.add(c), l.updateQueue = A;
                                        } else s.add(c);
                                        if (0 == (2 & l.mode)) {
                                            if (l.effectTag |= 64, u.effectTag &= -2981, 1 === u.tag) {
                                                if (null === u.alternate) u.tag = 17;
                                                else {
                                                    var D = oM(1073741823, null);
                                                    D.tag = 2, cM(u, D);
                                                }
                                            }
                                            u.expirationTime = 1073741823;
                                            break e;
                                        }
                                        o = void 0, u = t;
                                        var d = r.pingCache;
                                        if (null === d ? (d = r.pingCache = new No, o = new Set, d.set(c, o)) : void 0 === (o = d.get(c)) && (o = new Set, d.set(c, o)), !o.has(u)) {
                                            o.add(u);
                                            var T = Tc.bind(null, r, c, u);
                                            c.then(T, T);
                                        }
                                        l.effectTag |= 4096, l.expirationTime = t;
                                        break e;
                                    }
                                    l = l.return;
                                }while (null !== l);
                                o = Error((Ae(u.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + De(u));
                            }
                            5 !== xo && (xo = 2), o = qu(o, u), l = M;
                            do {
                                switch(l.tag){
                                    case 3:
                                        c = o, l.effectTag |= 4096, l.expirationTime = t, aM(l, jo(l, c, t));
                                        break e;
                                    case 1:
                                        c = o;
                                        var y = l.type, z = l.stateNode;
                                        if (0 == (64 & l.effectTag) && ("function" == typeof y.getDerivedStateFromError || null !== z && "function" == typeof z.componentDidCatch && (null === Po || !Po.has(z)))) {
                                            l.effectTag |= 4096, l.expirationTime = t, aM(l, go(l, c, t));
                                            break e;
                                        }
                                }
                                l = l.return;
                            }while (null !== l);
                        }
                        Eo = Ic(Eo);
                    } catch (e) {
                        t = e;
                        continue;
                    }
                    break;
                }
            };
            var rc = function rc() {
                var e = Do.current;
                return Do.current = su, null === e ? su : e;
            };
            var Mc = function Mc(e, t) {
                e < So && 2 < e && (So = e), null !== t && e < mo && 2 < e && (mo = e, Oo = t);
            };
            var uc = function uc(e) {
                e > vo && (vo = e);
            };
            var oc = function oc() {
                for(; null !== Eo;)Eo = ac(Eo);
            };
            var cc = function cc() {
                for(; null !== Eo && !br();)Eo = ac(Eo);
            };
            var ac = function ac(e) {
                var _$t = so(e.alternate, e, Co);
                return e.memoizedProps = e.pendingProps, null === _$t && (_$t = Ic(e)), To.current = null, _$t;
            };
            var Ic = function Ic(e) {
                Eo = e;
                do {
                    var _$t = Eo.alternate;
                    if (e = Eo.return, 0 == (2048 & Eo.effectTag)) {
                        if (_$t = Xu(_$t, Eo, Co), 1 === Co || 1 !== Eo.childExpirationTime) {
                            for(var _$n = 0, i = Eo.child; null !== i;){
                                var r = i.expirationTime, M = i.childExpirationTime;
                                r > _$n && (_$n = r), M > _$n && (_$n = M), i = i.sibling;
                            }
                            Eo.childExpirationTime = _$n;
                        }
                        if (null !== _$t) return _$t;
                        null !== e && 0 == (2048 & e.effectTag) && (null === e.firstEffect && (e.firstEffect = Eo.firstEffect), null !== Eo.lastEffect && (null !== e.lastEffect && (e.lastEffect.nextEffect = Eo.firstEffect), e.lastEffect = Eo.lastEffect), 1 < Eo.effectTag && (null !== e.lastEffect ? e.lastEffect.nextEffect = Eo : e.firstEffect = Eo, e.lastEffect = Eo));
                    } else {
                        if (null !== (_$t = Ku(Eo))) return _$t.effectTag &= 2047, _$t;
                        null !== e && (e.firstEffect = e.lastEffect = null, e.effectTag |= 2048);
                    }
                    if (null !== (_$t = Eo.sibling)) return _$t;
                    Eo = e;
                }while (null !== Eo);
                return xo === yo && (xo = 5), null;
            };
            var lc = function lc(e) {
                var _$t = e.expirationTime;
                return _$t > (e = e.childExpirationTime) ? _$t : e;
            };
            var Nc = function Nc(e) {
                var _$t = Zr();
                return Br(99, jc.bind(null, e, _$t)), null;
            };
            var jc = function jc(e, t) {
                do sc();
                while (null !== Zo);
                if (0 != (48 & fo)) throw Error(u(327));
                var _$n = e.finishedWork, i = e.finishedExpirationTime;
                if (null === _$n) return null;
                if (e.finishedWork = null, e.finishedExpirationTime = 0, _$n === e.current) throw Error(u(177));
                e.callbackNode = null, e.callbackExpirationTime = 0, e.callbackPriority = 90, e.nextKnownPendingLevel = 0;
                var r = lc(_$n);
                if (e.firstPendingTime = r, i <= e.lastSuspendedTime ? e.firstSuspendedTime = e.lastSuspendedTime = e.nextKnownPendingLevel = 0 : i <= e.firstSuspendedTime && (e.firstSuspendedTime = i - 1), i <= e.lastPingedTime && (e.lastPingedTime = 0), i <= e.lastExpiredTime && (e.lastExpiredTime = 0), e === Lo && (Eo = Lo = null, Co = 0), 1 < _$n.effectTag ? null !== _$n.lastEffect ? (_$n.lastEffect.nextEffect = _$n, r = _$n.firstEffect) : r = _$n : r = _$n.firstEffect, null !== r) {
                    var M = fo;
                    fo |= 32, To.current = null, sn = Vt;
                    var o = jn();
                    if (gn(o)) {
                        if ("selectionStart" in o) var c = {
                            start: o.selectionStart,
                            end: o.selectionEnd
                        };
                        else e: {
                            var a = (c = (c = o.ownerDocument) && c.defaultView || window).getSelection && c.getSelection();
                            if (a && 0 !== a.rangeCount) {
                                c = a.anchorNode;
                                var I = a.anchorOffset, l = a.focusNode;
                                a = a.focusOffset;
                                try {
                                    c.nodeType, l.nodeType;
                                } catch (e) {
                                    c = null;
                                    break e;
                                }
                                var N = 0, j = -1, g = -1, s = 0, A = 0, D = o, d = null;
                                t: for(;;){
                                    for(var T; D !== c || 0 !== I && 3 !== D.nodeType || (j = N + I), D !== l || 0 !== a && 3 !== D.nodeType || (g = N + a), 3 === D.nodeType && (N += D.nodeValue.length), null !== (T = D.firstChild);)d = D, D = T;
                                    for(;;){
                                        if (D === o) break t;
                                        if (d === c && ++s === I && (j = N), d === l && ++A === a && (g = N), null !== (T = D.nextSibling)) break;
                                        d = (D = d).parentNode;
                                    }
                                    D = T;
                                }
                                c = -1 === j || -1 === g ? null : {
                                    start: j,
                                    end: g
                                };
                            } else c = null;
                        }
                        c = c || {
                            start: 0,
                            end: 0
                        };
                    } else c = null;
                    An = {
                        activeElementDetached: null,
                        focusedElem: o,
                        selectionRange: c
                    }, Vt = !1, ko = r;
                    do try {
                        gc();
                    } catch (e) {
                        if (null === ko) throw Error(u(330));
                        dc(ko, e), ko = ko.nextEffect;
                    }
                    while (null !== ko);
                    ko = r;
                    do try {
                        for(o = e, c = t; null !== ko;){
                            var y = ko.effectTag;
                            if (16 & y && Ze(ko.stateNode, ""), 128 & y) {
                                var z = ko.alternate;
                                if (null !== z) {
                                    var w = z.ref;
                                    null !== w && ("function" == typeof w ? w(null) : w.current = null);
                                }
                            }
                            switch(1038 & y){
                                case 2:
                                    co(ko), ko.effectTag &= -3;
                                    break;
                                case 6:
                                    co(ko), ko.effectTag &= -3, Io(ko.alternate, ko);
                                    break;
                                case 1024:
                                    ko.effectTag &= -1025;
                                    break;
                                case 1028:
                                    ko.effectTag &= -1025, Io(ko.alternate, ko);
                                    break;
                                case 4:
                                    Io(ko.alternate, ko);
                                    break;
                                case 8:
                                    ao(o, I = ko, c), uo(I);
                            }
                            ko = ko.nextEffect;
                        }
                    } catch (e) {
                        if (null === ko) throw Error(u(330));
                        dc(ko, e), ko = ko.nextEffect;
                    }
                    while (null !== ko);
                    if (w = An, z = jn(), y = w.focusedElem, c = w.selectionRange, z !== y && y && y.ownerDocument && function e(t, n) {
                        return !(!t || !n) && (t === n || (!t || 3 !== t.nodeType) && (n && 3 === n.nodeType ? e(t, n.parentNode) : "contains" in t ? t.contains(n) : !!t.compareDocumentPosition && !!(16 & t.compareDocumentPosition(n))));
                    }(y.ownerDocument.documentElement, y)) {
                        null !== c && gn(y) && (z = c.start, void 0 === (w = c.end) && (w = z), "selectionStart" in y ? (y.selectionStart = z, y.selectionEnd = Math.min(w, y.value.length)) : (w = (z = y.ownerDocument || document) && z.defaultView || window).getSelection && (w = w.getSelection(), I = y.textContent.length, o = Math.min(c.start, I), c = void 0 === c.end ? o : Math.min(c.end, I), !w.extend && o > c && (I = c, c = o, o = I), I = Nn(y, o), l = Nn(y, c), I && l && (1 !== w.rangeCount || w.anchorNode !== I.node || w.anchorOffset !== I.offset || w.focusNode !== l.node || w.focusOffset !== l.offset) && ((z = z.createRange()).setStart(I.node, I.offset), w.removeAllRanges(), o > c ? (w.addRange(z), w.extend(l.node, l.offset)) : (z.setEnd(l.node, l.offset), w.addRange(z))))), z = [];
                        for(w = y; w = w.parentNode;)1 === w.nodeType && z.push({
                            element: w,
                            left: w.scrollLeft,
                            top: w.scrollTop
                        });
                        for("function" == typeof y.focus && y.focus(), y = 0; y < z.length; y++)(w = z[y]).element.scrollLeft = w.left, w.element.scrollTop = w.top;
                    }
                    Vt = !!sn, An = sn = null, e.current = _$n, ko = r;
                    do try {
                        for(y = e; null !== ko;){
                            var f = ko.effectTag;
                            if (36 & f && ro(y, ko.alternate, ko), 128 & f) {
                                z = void 0;
                                var L = ko.ref;
                                if (null !== L) {
                                    var E = ko.stateNode;
                                    switch(ko.tag){
                                        case 5:
                                            z = E;
                                            break;
                                        default:
                                            z = E;
                                    }
                                    "function" == typeof L ? L(z) : L.current = z;
                                }
                            }
                            ko = ko.nextEffect;
                        }
                    } catch (e) {
                        if (null === ko) throw Error(u(330));
                        dc(ko, e), ko = ko.nextEffect;
                    }
                    while (null !== ko);
                    ko = null, hr(), fo = M;
                } else e.current = _$n;
                if (Uo) Uo = !1, Zo = e, Go = t;
                else for(ko = r; null !== ko;)t = ko.nextEffect, ko.nextEffect = null, ko = t;
                if (0 === (t = e.firstPendingTime) && (Po = null), 1073741823 === t ? e === Wo ? Ro++ : (Ro = 0, Wo = e) : Ro = 0, "function" == typeof zc && zc(_$n.stateNode, i), qo(e), Qo) throw Qo = !1, e = Yo, Yo = null, e;
                return 0 != (8 & fo) || Hr(), null;
            };
            var gc = function gc() {
                for(; null !== ko;){
                    var e = ko.effectTag;
                    0 != (256 & e) && to(ko.alternate, ko), 0 == (512 & e) || Uo || (Uo = !0, Rr(97, function() {
                        return sc(), null;
                    })), ko = ko.nextEffect;
                }
            };
            var sc = function sc() {
                if (90 !== Go) {
                    var e = 97 < Go ? 97 : Go;
                    return Go = 90, Br(e, Ac);
                }
            };
            var Ac = function Ac() {
                if (null === Zo) return !1;
                var e = Zo;
                if (Zo = null, 0 != (48 & fo)) throw Error(u(331));
                var _$t = fo;
                for(fo |= 32, e = e.current.firstEffect; null !== e;){
                    try {
                        var _$n = e;
                        if (0 != (512 & _$n.effectTag)) switch(_$n.tag){
                            case 0:
                            case 11:
                            case 15:
                            case 22:
                                no(5, _$n), io(5, _$n);
                        }
                    } catch (t) {
                        if (null === e) throw Error(u(330));
                        dc(e, t);
                    }
                    _$n = e.nextEffect, e.nextEffect = null, e = _$n;
                }
                return fo = _$t, Hr(), !0;
            };
            var Dc = function Dc(e, t, n) {
                cM(e, t = jo(e, t = qu(n, t), 1073741823)), null !== (e = Xo(e, 1073741823)) && qo(e);
            };
            var dc = function dc(e, t) {
                if (3 === e.tag) Dc(e, e, t);
                else for(var _$n = e.return; null !== _$n;){
                    if (3 === _$n.tag) {
                        Dc(_$n, e, t);
                        break;
                    }
                    if (1 === _$n.tag) {
                        var i = _$n.stateNode;
                        if ("function" == typeof _$n.type.getDerivedStateFromError || "function" == typeof i.componentDidCatch && (null === Po || !Po.has(i))) {
                            cM(_$n, e = go(_$n, e = qu(t, e), 1073741823)), null !== (_$n = Xo(_$n, 1073741823)) && qo(_$n);
                            break;
                        }
                    }
                    _$n = _$n.return;
                }
            };
            var Tc = function Tc(e, t, n) {
                var i = e.pingCache;
                null !== i && i.delete(t), Lo === e && Co === n ? xo === wo || xo === zo && 1073741823 === So && Ur() - ho < 500 ? nc(e, Co) : bo = !0 : vc(e, n) && (0 !== (t = e.lastPingedTime) && t < n || (e.lastPingedTime = n, qo(e)));
            };
            var yc = function yc(e, t) {
                var _$n = e.stateNode;
                null !== _$n && _$n.delete(t), 0 === (t = 0) && (t = Jo(t = Vo(), e, null)), null !== (e = Xo(e, t)) && qo(e);
            };
            var fc = function fc(e, t, n, i) {
                this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = i, this.effectTag = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childExpirationTime = this.expirationTime = 0, this.alternate = null;
            };
            var Lc = function Lc(e, t, n, i) {
                return new fc(e, t, n, i);
            };
            var Ec = function Ec(e) {
                return !(!(e = e.prototype) || !e.isReactComponent);
            };
            var Cc = function Cc(e, t) {
                var _$n = e.alternate;
                return null === _$n ? ((_$n = Lc(e.tag, t, e.key, e.mode)).elementType = e.elementType, _$n.type = e.type, _$n.stateNode = e.stateNode, _$n.alternate = e, e.alternate = _$n) : (_$n.pendingProps = t, _$n.effectTag = 0, _$n.nextEffect = null, _$n.firstEffect = null, _$n.lastEffect = null), _$n.childExpirationTime = e.childExpirationTime, _$n.expirationTime = e.expirationTime, _$n.child = e.child, _$n.memoizedProps = e.memoizedProps, _$n.memoizedState = e.memoizedState, _$n.updateQueue = e.updateQueue, t = e.dependencies, _$n.dependencies = null === t ? null : {
                    expirationTime: t.expirationTime,
                    firstContext: t.firstContext,
                    responders: t.responders
                }, _$n.sibling = e.sibling, _$n.index = e.index, _$n.ref = e.ref, _$n;
            };
            var xc = function xc(e, t, n, i, r, M) {
                var o = 2;
                if (i = e, "function" == typeof e) Ec(e) && (o = 1);
                else if ("string" == typeof e) o = 5;
                else e: switch(e){
                    case ne:
                        return pc(n.children, r, M, t);
                    case oe:
                        o = 8, r |= 7;
                        break;
                    case ie:
                        o = 8, r |= 1;
                        break;
                    case re:
                        return (e = Lc(12, n, t, 8 | r)).elementType = re, e.type = re, e.expirationTime = M, e;
                    case ae:
                        return (e = Lc(13, n, t, r)).type = ae, e.elementType = ae, e.expirationTime = M, e;
                    case Ie:
                        return (e = Lc(19, n, t, r)).elementType = Ie, e.expirationTime = M, e;
                    default:
                        if ("object" == typeof e && null !== e) switch(e.$$typeof){
                            case Me:
                                o = 10;
                                break e;
                            case ue:
                                o = 9;
                                break e;
                            case ce:
                                o = 11;
                                break e;
                            case le:
                                o = 14;
                                break e;
                            case Ne:
                                o = 16, i = null;
                                break e;
                            case je:
                                o = 22;
                                break e;
                        }
                        throw Error(u(130, null == e ? e : typeof e === "undefined" ? "undefined" : (0, $1ObTH._)(e), ""));
                }
                return (t = Lc(o, n, t, r)).elementType = e, t.type = i, t.expirationTime = M, t;
            };
            var pc = function pc(e, t, n, i) {
                return (e = Lc(7, e, i, t)).expirationTime = n, e;
            };
            var Sc = function Sc(e, t, n) {
                return (e = Lc(6, e, null, t)).expirationTime = n, e;
            };
            var mc = function mc(e, t, n) {
                return (t = Lc(4, null !== e.children ? e.children : [], e.key, t)).expirationTime = n, t.stateNode = {
                    containerInfo: e.containerInfo,
                    pendingChildren: null,
                    implementation: e.implementation
                }, t;
            };
            var Oc = function Oc(e, t, n) {
                this.tag = t, this.current = null, this.containerInfo = e, this.pingCache = this.pendingChildren = null, this.finishedExpirationTime = 0, this.finishedWork = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = n, this.callbackNode = null, this.callbackPriority = 90, this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
            };
            var vc = function vc(e, t) {
                var _$n = e.firstSuspendedTime;
                return e = e.lastSuspendedTime, 0 !== _$n && _$n >= t && e <= t;
            };
            var bc = function bc(e, t) {
                var _$n = e.firstSuspendedTime, i = e.lastSuspendedTime;
                _$n < t && (e.firstSuspendedTime = t), (i > t || 0 === _$n) && (e.lastSuspendedTime = t), t <= e.lastPingedTime && (e.lastPingedTime = 0), t <= e.lastExpiredTime && (e.lastExpiredTime = 0);
            };
            var hc = function hc(e, t) {
                t > e.firstPendingTime && (e.firstPendingTime = t);
                var _$n = e.firstSuspendedTime;
                0 !== _$n && (t >= _$n ? e.firstSuspendedTime = e.lastSuspendedTime = e.nextKnownPendingLevel = 0 : t >= e.lastSuspendedTime && (e.lastSuspendedTime = t + 1), t > e.nextKnownPendingLevel && (e.nextKnownPendingLevel = t));
            };
            var kc = function kc(e, t) {
                var _$n = e.lastExpiredTime;
                (0 === _$n || _$n > t) && (e.lastExpiredTime = t);
            };
            var Qc = function Qc(e, t, n, i) {
                var r = t.current, M = Vo(), o = NM.suspense;
                M = Jo(M, r, o);
                e: if (n) {
                    t: {
                        if ($e(n = n._reactInternalFiber) !== n || 1 !== n.tag) throw Error(u(170));
                        var c = n;
                        do {
                            switch(c.tag){
                                case 3:
                                    c = c.stateNode.context;
                                    break t;
                                case 1:
                                    if (sr(c.type)) {
                                        c = c.stateNode.__reactInternalMemoizedMergedChildContext;
                                        break t;
                                    }
                            }
                            c = c.return;
                        }while (null !== c);
                        throw Error(u(171));
                    }
                    if (1 === n.tag) {
                        var a = n.type;
                        if (sr(a)) {
                            n = dr(n, a, c);
                            break e;
                        }
                    }
                    n = c;
                } else n = Ir;
                return null === t.context ? t.context = n : t.pendingContext = n, (t = oM(M, o)).payload = {
                    element: e
                }, null !== (i = void 0 === i ? null : i) && (t.callback = i), cM(r, t), Fo(r, M), M;
            };
            var Yc = function Yc(e) {
                if (!(e = e.current).child) return null;
                e.child.tag;
                return e.child.stateNode;
            };
            var Pc = function Pc(e, t) {
                null !== (e = e.memoizedState) && null !== e.dehydrated && e.retryTime < t && (e.retryTime = t);
            };
            var Uc = function Uc(e, t) {
                Pc(e, t), (e = e.alternate) && Pc(e, t);
            };
            var Zc = function Zc(e, t, n) {
                var i = new Oc(e, t, n = null != n && !0 === n.hydrate), r = Lc(3, null, null, 2 === t ? 7 : 1 === t ? 3 : 0);
                i.current = r, r.stateNode = i, MM(r), e[Cn] = i.current, n && 0 !== t && function(e, t) {
                    var _$n = _e(t);
                    Ct.forEach(function(e) {
                        gt(e, t, _$n);
                    }), xt.forEach(function(e) {
                        gt(e, t, _$n);
                    });
                }(0, 9 === e.nodeType ? e : e.ownerDocument), this._internalRoot = i;
            };
            var Gc = function Gc(e) {
                return !(!e || 1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType && (8 !== e.nodeType || " react-mount-point-unstable " !== e.nodeValue));
            };
            var Bc = function Bc(e, t, n, i, r) {
                var M = n._reactRootContainer;
                if (M) {
                    var u = M._internalRoot;
                    if ("function" == typeof r) {
                        var o = r;
                        r = function r() {
                            var _$e = Yc(u);
                            o.call(_$e);
                        };
                    }
                    Qc(t, u, e, r);
                } else {
                    if (M = n._reactRootContainer = function(e, t) {
                        if (t || (t = !(!(t = e ? 9 === e.nodeType ? e.documentElement : e.firstChild : null) || 1 !== t.nodeType || !t.hasAttribute("data-reactroot"))), !t) for(var _$n; _$n = e.lastChild;)e.removeChild(_$n);
                        return new Zc(e, 0, t ? {
                            hydrate: !0
                        } : void 0);
                    }(n, i), u = M._internalRoot, "function" == typeof r) {
                        var c = r;
                        r = function r() {
                            var _$e = Yc(u);
                            c.call(_$e);
                        };
                    }
                    tc(function() {
                        Qc(t, u, e, r);
                    });
                }
                return Yc(u);
            };
            var Rc = function Rc(e, t, n) {
                var i = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
                return {
                    $$typeof: te,
                    key: null == i ? null : "" + i,
                    children: e,
                    containerInfo: t,
                    implementation: n
                };
            };
            var Wc = function Wc(e, t) {
                var _$n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
                if (!Gc(t)) throw Error(u(200));
                return Rc(e, t, null, _$n);
            };
            /** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var i = n(1), r = n(9), M = n(30);
            if (!i) throw Error(u(227));
            var c = !1, a = null, I = !1, l = null, N = {
                onError: function onError(e) {
                    c = !0, a = e;
                }
            };
            var g = null, s = null, A = null;
            var d = null, T = {};
            var w = [], f = {}, L = {}, E = {};
            var x = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement), p = null, S = null, m = null;
            var Y = h, P = !1, U = !1;
            var B = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, R = Object.prototype.hasOwnProperty, W = {}, H = {};
            var J = {};
            "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
                J[e] = new V(e, 0, !1, e, null, !1);
            }), [
                [
                    "acceptCharset",
                    "accept-charset"
                ],
                [
                    "className",
                    "class"
                ],
                [
                    "htmlFor",
                    "for"
                ],
                [
                    "httpEquiv",
                    "http-equiv"
                ]
            ].forEach(function(e) {
                var _$t = e[0];
                J[_$t] = new V(_$t, 1, !1, e[1], null, !1);
            }), [
                "contentEditable",
                "draggable",
                "spellCheck",
                "value"
            ].forEach(function(e) {
                J[e] = new V(e, 2, !1, e.toLowerCase(), null, !1);
            }), [
                "autoReverse",
                "externalResourcesRequired",
                "focusable",
                "preserveAlpha"
            ].forEach(function(e) {
                J[e] = new V(e, 2, !1, e, null, !1);
            }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
                J[e] = new V(e, 3, !1, e.toLowerCase(), null, !1);
            }), [
                "checked",
                "multiple",
                "muted",
                "selected"
            ].forEach(function(e) {
                J[e] = new V(e, 3, !0, e, null, !1);
            }), [
                "capture",
                "download"
            ].forEach(function(e) {
                J[e] = new V(e, 4, !1, e, null, !1);
            }), [
                "cols",
                "rows",
                "size",
                "span"
            ].forEach(function(e) {
                J[e] = new V(e, 6, !1, e, null, !1);
            }), [
                "rowSpan",
                "start"
            ].forEach(function(e) {
                J[e] = new V(e, 5, !1, e.toLowerCase(), null, !1);
            });
            var F = /[\-:]([a-z])/g;
            "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
                var _$t = e.replace(F, X);
                J[_$t] = new V(_$t, 1, !1, e, null, !1);
            }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
                var _$t = e.replace(F, X);
                J[_$t] = new V(_$t, 1, !1, e, "http://www.w3.org/1999/xlink", !1);
            }), [
                "xml:base",
                "xml:lang",
                "xml:space"
            ].forEach(function(e) {
                var _$t = e.replace(F, X);
                J[_$t] = new V(_$t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1);
            }), [
                "tabIndex",
                "crossOrigin"
            ].forEach(function(e) {
                J[e] = new V(e, 1, !1, e.toLowerCase(), null, !1);
            }), J.xlinkHref = new V("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0), [
                "src",
                "href",
                "action",
                "formAction"
            ].forEach(function(e) {
                J[e] = new V(e, 1, !1, e.toLowerCase(), null, !0);
            });
            var K = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
            K.hasOwnProperty("ReactCurrentDispatcher") || (K.ReactCurrentDispatcher = {
                current: null
            }), K.hasOwnProperty("ReactCurrentBatchConfig") || (K.ReactCurrentBatchConfig = {
                suspense: null
            });
            var _ = /^(.*)[\\\/]/, $ = "function" == typeof Symbol && Symbol.for, ee = $ ? Symbol.for("react.element") : 60103, te = $ ? Symbol.for("react.portal") : 60106, ne = $ ? Symbol.for("react.fragment") : 60107, ie = $ ? Symbol.for("react.strict_mode") : 60108, re = $ ? Symbol.for("react.profiler") : 60114, Me = $ ? Symbol.for("react.provider") : 60109, ue = $ ? Symbol.for("react.context") : 60110, oe = $ ? Symbol.for("react.concurrent_mode") : 60111, ce = $ ? Symbol.for("react.forward_ref") : 60112, ae = $ ? Symbol.for("react.suspense") : 60113, Ie = $ ? Symbol.for("react.suspense_list") : 60120, le = $ ? Symbol.for("react.memo") : 60115, Ne = $ ? Symbol.for("react.lazy") : 60116, je = $ ? Symbol.for("react.block") : 60121, ge = "function" == typeof Symbol && Symbol.iterator;
            function Ae(e) {
                if (null == e) return null;
                if ("function" == typeof e) return e.displayName || e.name || null;
                if ("string" == typeof e) return e;
                switch(e){
                    case ne:
                        return "Fragment";
                    case te:
                        return "Portal";
                    case re:
                        return "Profiler";
                    case ie:
                        return "StrictMode";
                    case ae:
                        return "Suspense";
                    case Ie:
                        return "SuspenseList";
                }
                if ("object" == typeof e) switch(e.$$typeof){
                    case ue:
                        return "Context.Consumer";
                    case Me:
                        return "Context.Provider";
                    case ce:
                        var _$t = e.render;
                        return _$t = _$t.displayName || _$t.name || "", e.displayName || ("" !== _$t ? "ForwardRef(" + _$t + ")" : "ForwardRef");
                    case le:
                        return Ae(e.type);
                    case je:
                        return Ae(e.render);
                    case Ne:
                        if (e = 1 === e._status ? e._result : null) return Ae(e);
                }
                return null;
            }
            var he = "http://www.w3.org/1999/xhtml", ke = "http://www.w3.org/2000/svg";
            var Pe, Ue = function(e) {
                return "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function(t, n, i, r) {
                    MSApp.execUnsafeLocalFunction(function() {
                        return e(t, n);
                    });
                } : e;
            }(function(e, t) {
                if (e.namespaceURI !== ke || "innerHTML" in e) e.innerHTML = t;
                else {
                    for((Pe = Pe || document.createElement("div")).innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = Pe.firstChild; e.firstChild;)e.removeChild(e.firstChild);
                    for(; t.firstChild;)e.appendChild(t.firstChild);
                }
            });
            var Be = {
                animationend: Ge("Animation", "AnimationEnd"),
                animationiteration: Ge("Animation", "AnimationIteration"),
                animationstart: Ge("Animation", "AnimationStart"),
                transitionend: Ge("Transition", "TransitionEnd")
            }, Re = {}, We = {};
            x && (We = document.createElement("div").style, "AnimationEvent" in window || (delete Be.animationend.animation, delete Be.animationiteration.animation, delete Be.animationstart.animation), "TransitionEvent" in window || delete Be.transitionend.transition);
            var Ve = He("animationend"), Je = He("animationiteration"), Fe = He("animationstart"), Xe = He("transitionend"), Ke = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), qe = new ("function" == typeof WeakMap ? WeakMap : Map);
            var Mt = null;
            var It = [];
            var st, At, Dt, dt = !1, Tt = [], yt = null, zt = null, wt = null, ft = new Map, Lt = new Map, Et = [], Ct = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), xt = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
            var Yt = {}, Pt = new Map, Ut = new Map, Zt = [
                "abort",
                "abort",
                Ve,
                "animationEnd",
                Je,
                "animationIteration",
                Fe,
                "animationStart",
                "canplay",
                "canPlay",
                "canplaythrough",
                "canPlayThrough",
                "durationchange",
                "durationChange",
                "emptied",
                "emptied",
                "encrypted",
                "encrypted",
                "ended",
                "ended",
                "error",
                "error",
                "gotpointercapture",
                "gotPointerCapture",
                "load",
                "load",
                "loadeddata",
                "loadedData",
                "loadedmetadata",
                "loadedMetadata",
                "loadstart",
                "loadStart",
                "lostpointercapture",
                "lostPointerCapture",
                "playing",
                "playing",
                "progress",
                "progress",
                "seeking",
                "seeking",
                "stalled",
                "stalled",
                "suspend",
                "suspend",
                "timeupdate",
                "timeUpdate",
                Xe,
                "transitionEnd",
                "waiting",
                "waiting"
            ];
            Gt("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0), Gt("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1), Gt(Zt, 2);
            for(var Bt = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), Rt = 0; Rt < Bt.length; Rt++)Ut.set(Bt[Rt], 0);
            var Wt = M.unstable_UserBlockingPriority, Ht = M.unstable_runWithPriority, Vt = !0;
            var $t = {
                animationIterationCount: !0,
                borderImageOutset: !0,
                borderImageSlice: !0,
                borderImageWidth: !0,
                boxFlex: !0,
                boxFlexGroup: !0,
                boxOrdinalGroup: !0,
                columnCount: !0,
                columns: !0,
                flex: !0,
                flexGrow: !0,
                flexPositive: !0,
                flexShrink: !0,
                flexNegative: !0,
                flexOrder: !0,
                gridArea: !0,
                gridRow: !0,
                gridRowEnd: !0,
                gridRowSpan: !0,
                gridRowStart: !0,
                gridColumn: !0,
                gridColumnEnd: !0,
                gridColumnSpan: !0,
                gridColumnStart: !0,
                fontWeight: !0,
                lineClamp: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                tabSize: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0,
                fillOpacity: !0,
                floodOpacity: !0,
                stopOpacity: !0,
                strokeDasharray: !0,
                strokeDashoffset: !0,
                strokeMiterlimit: !0,
                strokeOpacity: !0,
                strokeWidth: !0
            }, en = [
                "Webkit",
                "ms",
                "Moz",
                "O"
            ];
            Object.keys($t).forEach(function(e) {
                en.forEach(function(t) {
                    t = t + e.charAt(0).toUpperCase() + e.substring(1), $t[t] = $t[e];
                });
            });
            var rn = r({
                menuitem: !0
            }, {
                area: !0,
                base: !0,
                br: !0,
                col: !0,
                embed: !0,
                hr: !0,
                img: !0,
                input: !0,
                keygen: !0,
                link: !0,
                meta: !0,
                param: !0,
                source: !0,
                track: !0,
                wbr: !0
            });
            var on = he;
            var sn = null, An = null;
            var Tn = "function" == typeof setTimeout ? setTimeout : void 0, yn = "function" == typeof clearTimeout ? clearTimeout : void 0;
            var fn = Math.random().toString(36).slice(2), Ln = "__reactInternalInstance$" + fn, En = "__reactEventHandlers$" + fn, Cn = "__reactContainere$" + fn;
            var Pn = null, Un = null, Zn = null;
            r(Wn.prototype, {
                preventDefault: function preventDefault() {
                    this.defaultPrevented = !0;
                    var e = this.nativeEvent;
                    e && (e.preventDefault ? e.preventDefault() : "unknown" != (0, $1ObTH._)(e.returnValue) && (e.returnValue = !1), this.isDefaultPrevented = Bn);
                },
                stopPropagation: function stopPropagation() {
                    var e = this.nativeEvent;
                    e && (e.stopPropagation ? e.stopPropagation() : "unknown" != (0, $1ObTH._)(e.cancelBubble) && (e.cancelBubble = !0), this.isPropagationStopped = Bn);
                },
                persist: function persist() {
                    this.isPersistent = Bn;
                },
                isPersistent: Rn,
                destructor: function destructor() {
                    var e, _$t = this.constructor.Interface;
                    for(e in _$t)this[e] = null;
                    this.nativeEvent = this._targetInst = this.dispatchConfig = null, this.isPropagationStopped = this.isDefaultPrevented = Rn, this._dispatchInstances = this._dispatchListeners = null;
                }
            }), Wn.Interface = {
                type: null,
                target: null,
                currentTarget: function currentTarget() {
                    return null;
                },
                eventPhase: null,
                bubbles: null,
                cancelable: null,
                timeStamp: function timeStamp(e) {
                    return e.timeStamp || Date.now();
                },
                defaultPrevented: null,
                isTrusted: null
            }, Wn.extend = function(e) {
                var _$t = function _$t() {};
                var _$n = function _$n() {
                    return i.apply(this, arguments);
                };
                var i = this;
                _$t.prototype = i.prototype;
                var M = new _$t;
                return r(M, _$n.prototype), _$n.prototype = M, _$n.prototype.constructor = _$n, _$n.Interface = r({}, i.Interface, e), _$n.extend = i.extend, Jn(_$n), _$n;
            }, Jn(Wn);
            var Fn = Wn.extend({
                data: null
            }), Xn = Wn.extend({
                data: null
            }), Kn = [
                9,
                13,
                27,
                32
            ], qn = x && "CompositionEvent" in window, _n = null;
            x && "documentMode" in document && (_n = document.documentMode);
            var $n = x && "TextEvent" in window && !_n, ei = x && (!qn || _n && 8 < _n && 11 >= _n), ti = String.fromCharCode(32), ni = {
                beforeInput: {
                    phasedRegistrationNames: {
                        bubbled: "onBeforeInput",
                        captured: "onBeforeInputCapture"
                    },
                    dependencies: [
                        "compositionend",
                        "keypress",
                        "textInput",
                        "paste"
                    ]
                },
                compositionEnd: {
                    phasedRegistrationNames: {
                        bubbled: "onCompositionEnd",
                        captured: "onCompositionEndCapture"
                    },
                    dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
                },
                compositionStart: {
                    phasedRegistrationNames: {
                        bubbled: "onCompositionStart",
                        captured: "onCompositionStartCapture"
                    },
                    dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
                },
                compositionUpdate: {
                    phasedRegistrationNames: {
                        bubbled: "onCompositionUpdate",
                        captured: "onCompositionUpdateCapture"
                    },
                    dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
                }
            }, ii = !1;
            var ui = !1;
            var oi = {
                eventTypes: ni,
                extractEvents: function extractEvents(e, t, n, i) {
                    var r;
                    if (qn) e: {
                        switch(e){
                            case "compositionstart":
                                var M = ni.compositionStart;
                                break e;
                            case "compositionend":
                                M = ni.compositionEnd;
                                break e;
                            case "compositionupdate":
                                M = ni.compositionUpdate;
                                break e;
                        }
                        M = void 0;
                    }
                    else ui ? ri(e, n) && (M = ni.compositionEnd) : "keydown" === e && 229 === n.keyCode && (M = ni.compositionStart);
                    return M ? (ei && "ko" !== n.locale && (ui || M !== ni.compositionStart ? M === ni.compositionEnd && ui && (r = Gn()) : (Un = "value" in (Pn = i) ? Pn.value : Pn.textContent, ui = !0)), M = Fn.getPooled(M, t, n, i), r ? M.data = r : null !== (r = Mi(n)) && (M.data = r), Yn(M), r = M) : r = null, (e = $n ? function(e, t) {
                        switch(e){
                            case "compositionend":
                                return Mi(t);
                            case "keypress":
                                return 32 !== t.which ? null : (ii = !0, ti);
                            case "textInput":
                                return (e = t.data) === ti && ii ? null : e;
                            default:
                                return null;
                        }
                    }(e, n) : function(e, t) {
                        if (ui) return "compositionend" === e || !qn && ri(e, t) ? (e = Gn(), Zn = Un = Pn = null, ui = !1, e) : null;
                        switch(e){
                            case "paste":
                                return null;
                            case "keypress":
                                if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
                                    if (t.char && 1 < t.char.length) return t.char;
                                    if (t.which) return String.fromCharCode(t.which);
                                }
                                return null;
                            case "compositionend":
                                return ei && "ko" !== t.locale ? null : t.data;
                            default:
                                return null;
                        }
                    }(e, n)) ? ((t = Xn.getPooled(ni.beforeInput, t, n, i)).data = e, Yn(t)) : t = null, null === r ? t : null === t ? r : [
                        r,
                        t
                    ];
                }
            }, ci = {
                color: !0,
                date: !0,
                datetime: !0,
                "datetime-local": !0,
                email: !0,
                month: !0,
                number: !0,
                password: !0,
                range: !0,
                search: !0,
                tel: !0,
                text: !0,
                time: !0,
                url: !0,
                week: !0
            };
            var Ii = {
                change: {
                    phasedRegistrationNames: {
                        bubbled: "onChange",
                        captured: "onChangeCapture"
                    },
                    dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
                }
            };
            var Ni = null, ji = null;
            var Di = !1;
            x && (Di = at("input") && (!document.documentMode || 9 < document.documentMode));
            var Li = {
                eventTypes: Ii,
                _isInputEventSupported: Di,
                extractEvents: function extractEvents(e, t, n, i) {
                    var r = t ? Sn(t) : window, M = r.nodeName && r.nodeName.toLowerCase();
                    if ("select" === M || "input" === M && "file" === r.type) var u = Ai;
                    else if (ai(r)) {
                        if (Di) u = fi;
                        else {
                            u = zi;
                            var o = yi;
                        }
                    } else (M = r.nodeName) && "input" === M.toLowerCase() && ("checkbox" === r.type || "radio" === r.type) && (u = wi);
                    if (u && (u = u(e, t))) return li(u, n, i);
                    o && o(e, r, t), "blur" === e && (e = r._wrapperState) && e.controlled && "number" === r.type && xe(r, "number", r.value);
                }
            }, Ei = Wn.extend({
                view: null,
                detail: null
            }), Ci = {
                Alt: "altKey",
                Control: "ctrlKey",
                Meta: "metaKey",
                Shift: "shiftKey"
            };
            var Si = 0, mi = 0, Oi = !1, vi = !1, bi = Ei.extend({
                screenX: null,
                screenY: null,
                clientX: null,
                clientY: null,
                pageX: null,
                pageY: null,
                ctrlKey: null,
                shiftKey: null,
                altKey: null,
                metaKey: null,
                getModifierState: pi,
                button: null,
                buttons: null,
                relatedTarget: function relatedTarget(e) {
                    return e.relatedTarget || (e.fromElement === e.srcElement ? e.toElement : e.fromElement);
                },
                movementX: function movementX(e) {
                    if ("movementX" in e) return e.movementX;
                    var _$t = Si;
                    return Si = e.screenX, Oi ? "mousemove" === e.type ? e.screenX - _$t : 0 : (Oi = !0, 0);
                },
                movementY: function movementY(e) {
                    if ("movementY" in e) return e.movementY;
                    var _$t = mi;
                    return mi = e.screenY, vi ? "mousemove" === e.type ? e.screenY - _$t : 0 : (vi = !0, 0);
                }
            }), hi = bi.extend({
                pointerId: null,
                width: null,
                height: null,
                pressure: null,
                tangentialPressure: null,
                tiltX: null,
                tiltY: null,
                twist: null,
                pointerType: null,
                isPrimary: null
            }), ki = {
                mouseEnter: {
                    registrationName: "onMouseEnter",
                    dependencies: [
                        "mouseout",
                        "mouseover"
                    ]
                },
                mouseLeave: {
                    registrationName: "onMouseLeave",
                    dependencies: [
                        "mouseout",
                        "mouseover"
                    ]
                },
                pointerEnter: {
                    registrationName: "onPointerEnter",
                    dependencies: [
                        "pointerout",
                        "pointerover"
                    ]
                },
                pointerLeave: {
                    registrationName: "onPointerLeave",
                    dependencies: [
                        "pointerout",
                        "pointerover"
                    ]
                }
            }, Qi = {
                eventTypes: ki,
                extractEvents: function extractEvents(e, t, n, i, r) {
                    var M = "mouseover" === e || "pointerover" === e, u = "mouseout" === e || "pointerout" === e;
                    if (M && 0 == (32 & r) && (n.relatedTarget || n.fromElement) || !u && !M) return null;
                    (M = i.window === i ? i : (M = i.ownerDocument) ? M.defaultView || M.parentWindow : window, u) ? (u = t, null !== (t = (t = n.relatedTarget || n.toElement) ? xn(t) : null) && (t !== $e(t) || 5 !== t.tag && 6 !== t.tag) && (t = null)) : u = null;
                    if (u === t) return null;
                    if ("mouseout" === e || "mouseover" === e) var o = bi, c = ki.mouseLeave, a = ki.mouseEnter, I = "mouse";
                    else "pointerout" !== e && "pointerover" !== e || (o = hi, c = ki.pointerLeave, a = ki.pointerEnter, I = "pointer");
                    if (e = null == u ? M : Sn(u), M = null == t ? M : Sn(t), (c = o.getPooled(c, u, n, i)).type = I + "leave", c.target = e, c.relatedTarget = M, (n = o.getPooled(a, t, n, i)).type = I + "enter", n.target = M, n.relatedTarget = e, I = t, (i = u) && I) e: {
                        for(a = I, u = 0, e = o = i; e; e = On(e))u++;
                        for(e = 0, t = a; t; t = On(t))e++;
                        for(; 0 < u - e;)o = On(o), u--;
                        for(; 0 < e - u;)a = On(a), e--;
                        for(; u--;){
                            if (o === a || o === a.alternate) break e;
                            o = On(o), a = On(a);
                        }
                        o = null;
                    }
                    else o = null;
                    for(a = o, o = []; i && i !== a && (null === (u = i.alternate) || u !== a);)o.push(i), i = On(i);
                    for(i = []; I && I !== a && (null === (u = I.alternate) || u !== a);)i.push(I), I = On(I);
                    for(I = 0; I < o.length; I++)kn(o[I], "bubbled", c);
                    for(I = i.length; 0 < I--;)kn(i[I], "captured", n);
                    return 0 == (64 & r) ? [
                        c
                    ] : [
                        c,
                        n
                    ];
                }
            };
            var Yi = "function" == typeof Object.is ? Object.is : function Yi(e, t) {
                return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
            }, Pi = Object.prototype.hasOwnProperty;
            var Zi = x && "documentMode" in document && 11 >= document.documentMode, Gi = {
                select: {
                    phasedRegistrationNames: {
                        bubbled: "onSelect",
                        captured: "onSelectCapture"
                    },
                    dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
                }
            }, Bi = null, Ri = null, Wi = null, Hi = !1;
            var Ji = {
                eventTypes: Gi,
                extractEvents: function extractEvents(e, t, n, i, r, M) {
                    if (!(M = !(r = M || (i.window === i ? i.document : 9 === i.nodeType ? i : i.ownerDocument)))) {
                        e: {
                            r = _e(r), M = E.onSelect;
                            for(var u = 0; u < M.length; u++)if (!r.has(M[u])) {
                                r = !1;
                                break e;
                            }
                            r = !0;
                        }
                        M = !r;
                    }
                    if (M) return null;
                    switch(r = t ? Sn(t) : window, e){
                        case "focus":
                            (ai(r) || "true" === r.contentEditable) && (Bi = r, Ri = t, Wi = null);
                            break;
                        case "blur":
                            Wi = Ri = Bi = null;
                            break;
                        case "mousedown":
                            Hi = !0;
                            break;
                        case "contextmenu":
                        case "mouseup":
                        case "dragend":
                            return Hi = !1, Vi(n, i);
                        case "selectionchange":
                            if (Zi) break;
                        case "keydown":
                        case "keyup":
                            return Vi(n, i);
                    }
                    return null;
                }
            }, Fi = Wn.extend({
                animationName: null,
                elapsedTime: null,
                pseudoElement: null
            }), Xi = Wn.extend({
                clipboardData: function clipboardData(e) {
                    return "clipboardData" in e ? e.clipboardData : window.clipboardData;
                }
            }), Ki = Ei.extend({
                relatedTarget: null
            });
            var _i = {
                Esc: "Escape",
                Spacebar: " ",
                Left: "ArrowLeft",
                Up: "ArrowUp",
                Right: "ArrowRight",
                Down: "ArrowDown",
                Del: "Delete",
                Win: "OS",
                Menu: "ContextMenu",
                Apps: "ContextMenu",
                Scroll: "ScrollLock",
                MozPrintableKey: "Unidentified"
            }, $i = {
                8: "Backspace",
                9: "Tab",
                12: "Clear",
                13: "Enter",
                16: "Shift",
                17: "Control",
                18: "Alt",
                19: "Pause",
                20: "CapsLock",
                27: "Escape",
                32: " ",
                33: "PageUp",
                34: "PageDown",
                35: "End",
                36: "Home",
                37: "ArrowLeft",
                38: "ArrowUp",
                39: "ArrowRight",
                40: "ArrowDown",
                45: "Insert",
                46: "Delete",
                112: "F1",
                113: "F2",
                114: "F3",
                115: "F4",
                116: "F5",
                117: "F6",
                118: "F7",
                119: "F8",
                120: "F9",
                121: "F10",
                122: "F11",
                123: "F12",
                144: "NumLock",
                145: "ScrollLock",
                224: "Meta"
            }, er = Ei.extend({
                key: function key(e) {
                    if (e.key) {
                        var _$t = _i[e.key] || e.key;
                        if ("Unidentified" !== _$t) return _$t;
                    }
                    return "keypress" === e.type ? 13 === (e = qi(e)) ? "Enter" : String.fromCharCode(e) : "keydown" === e.type || "keyup" === e.type ? $i[e.keyCode] || "Unidentified" : "";
                },
                location: null,
                ctrlKey: null,
                shiftKey: null,
                altKey: null,
                metaKey: null,
                repeat: null,
                locale: null,
                getModifierState: pi,
                charCode: function charCode(e) {
                    return "keypress" === e.type ? qi(e) : 0;
                },
                keyCode: function keyCode(e) {
                    return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
                },
                which: function which(e) {
                    return "keypress" === e.type ? qi(e) : "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
                }
            }), tr = bi.extend({
                dataTransfer: null
            }), nr = Ei.extend({
                touches: null,
                targetTouches: null,
                changedTouches: null,
                altKey: null,
                metaKey: null,
                ctrlKey: null,
                shiftKey: null,
                getModifierState: pi
            }), ir = Wn.extend({
                propertyName: null,
                elapsedTime: null,
                pseudoElement: null
            }), rr = bi.extend({
                deltaX: function deltaX(e) {
                    return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
                },
                deltaY: function deltaY(e) {
                    return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
                },
                deltaZ: null,
                deltaMode: null
            }), Mr = {
                eventTypes: Yt,
                extractEvents: function extractEvents(e, t, n, i) {
                    var r = Pt.get(e);
                    if (!r) return null;
                    switch(e){
                        case "keypress":
                            if (0 === qi(n)) return null;
                        case "keydown":
                        case "keyup":
                            e = er;
                            break;
                        case "blur":
                        case "focus":
                            e = Ki;
                            break;
                        case "click":
                            if (2 === n.button) return null;
                        case "auxclick":
                        case "dblclick":
                        case "mousedown":
                        case "mousemove":
                        case "mouseup":
                        case "mouseout":
                        case "mouseover":
                        case "contextmenu":
                            e = bi;
                            break;
                        case "drag":
                        case "dragend":
                        case "dragenter":
                        case "dragexit":
                        case "dragleave":
                        case "dragover":
                        case "dragstart":
                        case "drop":
                            e = tr;
                            break;
                        case "touchcancel":
                        case "touchend":
                        case "touchmove":
                        case "touchstart":
                            e = nr;
                            break;
                        case Ve:
                        case Je:
                        case Fe:
                            e = Fi;
                            break;
                        case Xe:
                            e = ir;
                            break;
                        case "scroll":
                            e = Ei;
                            break;
                        case "wheel":
                            e = rr;
                            break;
                        case "copy":
                        case "cut":
                        case "paste":
                            e = Xi;
                            break;
                        case "gotpointercapture":
                        case "lostpointercapture":
                        case "pointercancel":
                        case "pointerdown":
                        case "pointermove":
                        case "pointerout":
                        case "pointerover":
                        case "pointerup":
                            e = hi;
                            break;
                        default:
                            e = Wn;
                    }
                    return Yn(t = e.getPooled(r, t, n, i)), t;
                }
            };
            if (d) throw Error(u(101));
            d = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" ")), y(), g = mn, s = pn, A = Sn, C({
                SimpleEventPlugin: Mr,
                EnterLeaveEventPlugin: Qi,
                ChangeEventPlugin: Li,
                SelectEventPlugin: Ji,
                BeforeInputEventPlugin: oi
            });
            var ur = [], or = -1;
            var Ir = {}, lr = {
                current: Ir
            }, Nr = {
                current: !1
            }, jr = Ir;
            var zr = M.unstable_runWithPriority, wr = M.unstable_scheduleCallback, fr = M.unstable_cancelCallback, Lr = M.unstable_requestPaint, Er = M.unstable_now, Cr = M.unstable_getCurrentPriorityLevel, xr = M.unstable_ImmediatePriority, pr = M.unstable_UserBlockingPriority, Sr = M.unstable_NormalPriority, mr = M.unstable_LowPriority, Or = M.unstable_IdlePriority, vr = {}, br = M.unstable_shouldYield, hr = void 0 !== Lr ? Lr : function hr() {}, kr = null, Qr = null, Yr = !1, Pr = Er(), Ur = 1e4 > Pr ? Er : function Ur() {
                return Er() - Pr;
            };
            var Xr = {
                current: null
            }, Kr = null, qr = null, _r = null;
            var rM = !1;
            var NM = K.ReactCurrentBatchConfig, jM = (new i.Component).refs;
            var sM = {
                isMounted: function isMounted(e) {
                    return !!(e = e._reactInternalFiber) && $e(e) === e;
                },
                enqueueSetState: function enqueueSetState(e, t, n) {
                    e = e._reactInternalFiber;
                    var i = Vo(), r = NM.suspense;
                    (r = oM(i = Jo(i, e, r), r)).payload = t, null != n && (r.callback = n), cM(e, r), Fo(e, i);
                },
                enqueueReplaceState: function enqueueReplaceState(e, t, n) {
                    e = e._reactInternalFiber;
                    var i = Vo(), r = NM.suspense;
                    (r = oM(i = Jo(i, e, r), r)).tag = 1, r.payload = t, null != n && (r.callback = n), cM(e, r), Fo(e, i);
                },
                enqueueForceUpdate: function enqueueForceUpdate(e, t) {
                    e = e._reactInternalFiber;
                    var _$n = Vo(), i = NM.suspense;
                    (i = oM(_$n = Jo(_$n, e, i), i)).tag = 2, null != t && (i.callback = t), cM(e, i), Fo(e, _$n);
                }
            };
            var yM = Array.isArray;
            var LM = fM(!0), EM = fM(!1), CM = {}, xM = {
                current: CM
            }, pM = {
                current: CM
            }, SM = {
                current: CM
            };
            var kM = {
                current: 0
            };
            var PM = K.ReactCurrentDispatcher, UM = K.ReactCurrentBatchConfig, ZM = 0, GM = null, BM = null, RM = null, WM = !1;
            var su = {
                readContext: iM,
                useCallback: HM,
                useContext: HM,
                useEffect: HM,
                useImperativeHandle: HM,
                useLayoutEffect: HM,
                useMemo: HM,
                useReducer: HM,
                useRef: HM,
                useState: HM,
                useDebugValue: HM,
                useResponder: HM,
                useDeferredValue: HM,
                useTransition: HM
            }, Au = {
                readContext: iM,
                useCallback: Iu,
                useContext: iM,
                useEffect: ru,
                useImperativeHandle: function useImperativeHandle(e, t, n) {
                    return n = null != n ? n.concat([
                        e
                    ]) : null, nu(4, 2, ou.bind(null, t, e), n);
                },
                useLayoutEffect: function useLayoutEffect(e, t) {
                    return nu(4, 2, e, t);
                },
                useMemo: function useMemo(e, t) {
                    var _$n = FM();
                    return t = void 0 === t ? null : t, e = e(), _$n.memoizedState = [
                        e,
                        t
                    ], e;
                },
                useReducer: function useReducer(e, t, n) {
                    var i = FM();
                    return t = void 0 !== n ? n(t) : t, i.memoizedState = i.baseState = t, e = (e = i.queue = {
                        pending: null,
                        dispatch: null,
                        lastRenderedReducer: e,
                        lastRenderedState: t
                    }).dispatch = gu.bind(null, GM, e), [
                        i.memoizedState,
                        e
                    ];
                },
                useRef: function useRef(e) {
                    return e = {
                        current: e
                    }, FM().memoizedState = e;
                },
                useState: $M,
                useDebugValue: au,
                useResponder: YM,
                useDeferredValue: function useDeferredValue(e, t) {
                    var _$n = $M(e), i = _$n[0], r = _$n[1];
                    return ru(function() {
                        var _$n = UM.suspense;
                        UM.suspense = void 0 === t ? null : t;
                        try {
                            r(e);
                        } finally{
                            UM.suspense = _$n;
                        }
                    }, [
                        e,
                        t
                    ]), i;
                },
                useTransition: function useTransition(e) {
                    var _$t = $M(!1), _$n = _$t[0];
                    return _$t = _$t[1], [
                        Iu(ju.bind(null, _$t, e), [
                            _$t,
                            e
                        ]),
                        _$n
                    ];
                }
            }, Du = {
                readContext: iM,
                useCallback: lu,
                useContext: iM,
                useEffect: Mu,
                useImperativeHandle: cu,
                useLayoutEffect: uu,
                useMemo: Nu,
                useReducer: qM,
                useRef: tu,
                useState: function useState() {
                    return qM(KM);
                },
                useDebugValue: au,
                useResponder: YM,
                useDeferredValue: function useDeferredValue(e, t) {
                    var _$n = qM(KM), i = _$n[0], r = _$n[1];
                    return Mu(function() {
                        var _$n = UM.suspense;
                        UM.suspense = void 0 === t ? null : t;
                        try {
                            r(e);
                        } finally{
                            UM.suspense = _$n;
                        }
                    }, [
                        e,
                        t
                    ]), i;
                },
                useTransition: function useTransition(e) {
                    var _$t = qM(KM), _$n = _$t[0];
                    return _$t = _$t[1], [
                        lu(ju.bind(null, _$t, e), [
                            _$t,
                            e
                        ]),
                        _$n
                    ];
                }
            }, du = {
                readContext: iM,
                useCallback: lu,
                useContext: iM,
                useEffect: Mu,
                useImperativeHandle: cu,
                useLayoutEffect: uu,
                useMemo: Nu,
                useReducer: _M,
                useRef: tu,
                useState: function useState() {
                    return _M(KM);
                },
                useDebugValue: au,
                useResponder: YM,
                useDeferredValue: function useDeferredValue(e, t) {
                    var _$n = _M(KM), i = _$n[0], r = _$n[1];
                    return Mu(function() {
                        var _$n = UM.suspense;
                        UM.suspense = void 0 === t ? null : t;
                        try {
                            r(e);
                        } finally{
                            UM.suspense = _$n;
                        }
                    }, [
                        e,
                        t
                    ]), i;
                },
                useTransition: function useTransition(e) {
                    var _$t = _M(KM), _$n = _$t[0];
                    return _$t = _$t[1], [
                        lu(ju.bind(null, _$t, e), [
                            _$t,
                            e
                        ]),
                        _$n
                    ];
                }
            }, Tu = null, yu = null, zu = !1;
            var pu = K.ReactCurrentOwner, Su = !1;
            var Uu, Zu, Gu, Bu = {
                dehydrated: null,
                retryTime: 0
            };
            Uu = function Uu(e, t) {
                for(var _$n = t.child; null !== _$n;){
                    if (5 === _$n.tag || 6 === _$n.tag) e.appendChild(_$n.stateNode);
                    else if (4 !== _$n.tag && null !== _$n.child) {
                        _$n.child.return = _$n, _$n = _$n.child;
                        continue;
                    }
                    if (_$n === t) break;
                    for(; null === _$n.sibling;){
                        if (null === _$n.return || _$n.return === t) return;
                        _$n = _$n.return;
                    }
                    _$n.sibling.return = _$n.return, _$n = _$n.sibling;
                }
            }, Zu = function Zu(e, t, n, i, M) {
                var u = e.memoizedProps;
                if (u !== i) {
                    var o, c, a = t.stateNode;
                    switch(mM(xM.current), e = null, n){
                        case "input":
                            u = we(a, u), i = we(a, i), e = [];
                            break;
                        case "option":
                            u = pe(a, u), i = pe(a, i), e = [];
                            break;
                        case "select":
                            u = r({}, u, {
                                value: void 0
                            }), i = r({}, i, {
                                value: void 0
                            }), e = [];
                            break;
                        case "textarea":
                            u = me(a, u), i = me(a, i), e = [];
                            break;
                        default:
                            "function" != typeof u.onClick && "function" == typeof i.onClick && (a.onclick = an);
                    }
                    for(o in Mn(n, i), n = null, u)if (!i.hasOwnProperty(o) && u.hasOwnProperty(o) && null != u[o]) {
                        if ("style" === o) for(c in a = u[o])a.hasOwnProperty(c) && (n || (n = {}), n[c] = "");
                        else "dangerouslySetInnerHTML" !== o && "children" !== o && "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && "autoFocus" !== o && (L.hasOwnProperty(o) ? e || (e = []) : (e = e || []).push(o, null));
                    }
                    for(o in i){
                        var I = i[o];
                        if (a = null != u ? u[o] : void 0, i.hasOwnProperty(o) && I !== a && (null != I || null != a)) {
                            if ("style" === o) {
                                if (a) {
                                    for(c in a)!a.hasOwnProperty(c) || I && I.hasOwnProperty(c) || (n || (n = {}), n[c] = "");
                                    for(c in I)I.hasOwnProperty(c) && a[c] !== I[c] && (n || (n = {}), n[c] = I[c]);
                                } else n || (e || (e = []), e.push(o, n)), n = I;
                            } else "dangerouslySetInnerHTML" === o ? (I = I ? I.__html : void 0, a = a ? a.__html : void 0, null != I && a !== I && (e = e || []).push(o, I)) : "children" === o ? a === I || "string" != typeof I && "number" != typeof I || (e = e || []).push(o, "" + I) : "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && (L.hasOwnProperty(o) ? (null != I && cn(M, o), e || a === I || (e = [])) : (e = e || []).push(o, I));
                        }
                    }
                    n && (e = e || []).push("style", n), M = e, (t.updateQueue = M) && (t.effectTag |= 4);
                }
            }, Gu = function Gu(e, t, n, i) {
                n !== i && (t.effectTag |= 4);
            };
            var _u = "function" == typeof WeakSet ? WeakSet : Set;
            function uo(e) {
                var _$t = e.alternate;
                e.return = null, e.child = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.alternate = null, e.firstEffect = null, e.lastEffect = null, e.pendingProps = null, e.memoizedProps = null, e.stateNode = null, null !== _$t && uo(_$t);
            }
            var No = "function" == typeof WeakMap ? WeakMap : Map;
            var so, Ao = Math.ceil, Do = K.ReactCurrentDispatcher, To = K.ReactCurrentOwner, yo = 0, zo = 3, wo = 4, fo = 0, Lo = null, Eo = null, Co = 0, xo = yo, po = null, So = 1073741823, mo = 1073741823, Oo = null, vo = 0, bo = !1, ho = 0, ko = null, Qo = !1, Yo = null, Po = null, Uo = !1, Zo = null, Go = 90, Bo = null, Ro = 0, Wo = null, Ho = 0;
            function _o(e, t) {
                if (Ho = 0, t) return kc(e, t = Vo()), qo(e), null;
                var _$n = Ko(e);
                if (0 !== _$n) {
                    if (t = e.callbackNode, 0 != (48 & fo)) throw Error(u(327));
                    if (sc(), e === Lo && _$n === Co || nc(e, _$n), null !== Eo) {
                        var i = fo;
                        fo |= 16;
                        for(var r = rc();;)try {
                            cc();
                            break;
                        } catch (t) {
                            ic(e, t);
                        }
                        if ($r(), fo = i, Do.current = r, 1 === xo) throw t = po, nc(e, _$n), bc(e, _$n), qo(e), t;
                        if (null === Eo) switch(r = e.finishedWork = e.current.alternate, e.finishedExpirationTime = _$n, i = xo, Lo = null, i){
                            case yo:
                            case 1:
                                throw Error(u(345));
                            case 2:
                                kc(e, 2 < _$n ? 2 : _$n);
                                break;
                            case zo:
                                if (bc(e, _$n), _$n === (i = e.lastSuspendedTime) && (e.nextKnownPendingLevel = lc(r)), 1073741823 === So && 10 < (r = ho + 500 - Ur())) {
                                    if (bo) {
                                        var M = e.lastPingedTime;
                                        if (0 === M || M >= _$n) {
                                            e.lastPingedTime = _$n, nc(e, _$n);
                                            break;
                                        }
                                    }
                                    if (0 !== (M = Ko(e)) && M !== _$n) break;
                                    if (0 !== i && i !== _$n) {
                                        e.lastPingedTime = i;
                                        break;
                                    }
                                    e.timeoutHandle = Tn(Nc.bind(null, e), r);
                                    break;
                                }
                                Nc(e);
                                break;
                            case wo:
                                if (bc(e, _$n), _$n === (i = e.lastSuspendedTime) && (e.nextKnownPendingLevel = lc(r)), bo && (0 === (r = e.lastPingedTime) || r >= _$n)) {
                                    e.lastPingedTime = _$n, nc(e, _$n);
                                    break;
                                }
                                if (0 !== (r = Ko(e)) && r !== _$n) break;
                                if (0 !== i && i !== _$n) {
                                    e.lastPingedTime = i;
                                    break;
                                }
                                if (1073741823 !== mo ? i = 10 * (1073741821 - mo) - Ur() : 1073741823 === So ? i = 0 : (i = 10 * (1073741821 - So) - 5e3, 0 > (i = (r = Ur()) - i) && (i = 0), (_$n = 10 * (1073741821 - _$n) - r) < (i = (120 > i ? 120 : 480 > i ? 480 : 1080 > i ? 1080 : 1920 > i ? 1920 : 3e3 > i ? 3e3 : 4320 > i ? 4320 : 1960 * Ao(i / 1960)) - i) && (i = _$n)), 10 < i) {
                                    e.timeoutHandle = Tn(Nc.bind(null, e), i);
                                    break;
                                }
                                Nc(e);
                                break;
                            case 5:
                                if (1073741823 !== So && null !== Oo) {
                                    M = So;
                                    var o = Oo;
                                    if (0 >= (i = 0 | o.busyMinDurationMs) ? i = 0 : (r = 0 | o.busyDelayMs, i = (M = Ur() - (10 * (1073741821 - M) - (0 | o.timeoutMs || 5e3))) <= r ? 0 : r + i - M), 10 < i) {
                                        bc(e, _$n), e.timeoutHandle = Tn(Nc.bind(null, e), i);
                                        break;
                                    }
                                }
                                Nc(e);
                                break;
                            default:
                                throw Error(u(329));
                        }
                        if (qo(e), e.callbackNode === t) return _o.bind(null, e);
                    }
                }
                return null;
            }
            so = function so(e, t, n) {
                var i = t.expirationTime;
                if (null !== e) {
                    var r = t.pendingProps;
                    if (e.memoizedProps !== r || Nr.current) Su = !0;
                    else {
                        if (i < n) {
                            switch(Su = !1, t.tag){
                                case 3:
                                    Pu(t), xu();
                                    break;
                                case 5:
                                    if (bM(t), 4 & t.mode && 1 !== n && r.hidden) return t.expirationTime = t.childExpirationTime = 1, null;
                                    break;
                                case 1:
                                    sr(t.type) && Tr(t);
                                    break;
                                case 4:
                                    OM(t, t.stateNode.containerInfo);
                                    break;
                                case 10:
                                    i = t.memoizedProps.value, r = t.type._context, ar(Xr, r._currentValue), r._currentValue = i;
                                    break;
                                case 13:
                                    if (null !== t.memoizedState) return 0 !== (i = t.child.childExpirationTime) && i >= n ? Ru(e, t, n) : (ar(kM, 1 & kM.current), null !== (t = Ju(e, t, n)) ? t.sibling : null);
                                    ar(kM, 1 & kM.current);
                                    break;
                                case 19:
                                    if (i = t.childExpirationTime >= n, 0 != (64 & e.effectTag)) {
                                        if (i) return Vu(e, t, n);
                                        t.effectTag |= 64;
                                    }
                                    if (null !== (r = t.memoizedState) && (r.rendering = null, r.tail = null), ar(kM, kM.current), !i) return null;
                            }
                            return Ju(e, t, n);
                        }
                        Su = !1;
                    }
                } else Su = !1;
                switch(t.expirationTime = 0, t.tag){
                    case 2:
                        if (i = t.type, null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps, r = gr(t, lr.current), nM(t, n), r = JM(null, t, i, e, r, n), t.effectTag |= 1, "object" == typeof r && null !== r && "function" == typeof r.render && void 0 === r.$$typeof) {
                            if (t.tag = 1, t.memoizedState = null, t.updateQueue = null, sr(i)) {
                                var M = !0;
                                Tr(t);
                            } else M = !1;
                            t.memoizedState = null !== r.state && void 0 !== r.state ? r.state : null, MM(t);
                            var o = i.getDerivedStateFromProps;
                            "function" == typeof o && gM(t, i, o, e), r.updater = sM, t.stateNode = r, r._reactInternalFiber = t, TM(t, i, e, n), t = Yu(null, t, i, !0, M, n);
                        } else t.tag = 0, mu(null, t, r, n), t = t.child;
                        return t;
                    case 16:
                        e: {
                            if (r = t.elementType, null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps, function(e) {
                                if (-1 === e._status) {
                                    e._status = 0;
                                    var _$t = e._ctor;
                                    _$t = _$t(), e._result = _$t, _$t.then(function(t) {
                                        0 === e._status && (t = t.default, e._status = 1, e._result = t);
                                    }, function(t) {
                                        0 === e._status && (e._status = 2, e._result = t);
                                    });
                                }
                            }(r), 1 !== r._status) throw r._result;
                            switch(r = r._result, t.type = r, M = t.tag = function(e) {
                                if ("function" == typeof e) return Ec(e) ? 1 : 0;
                                if (null != e) {
                                    if ((e = e.$$typeof) === ce) return 11;
                                    if (e === le) return 14;
                                }
                                return 2;
                            }(r), e = Fr(r, e), M){
                                case 0:
                                    t = ku(null, t, r, e, n);
                                    break e;
                                case 1:
                                    t = Qu(null, t, r, e, n);
                                    break e;
                                case 11:
                                    t = Ou(null, t, r, e, n);
                                    break e;
                                case 14:
                                    t = vu(null, t, r, Fr(r.type, e), i, n);
                                    break e;
                            }
                            throw Error(u(306, r, ""));
                        }
                        return t;
                    case 0:
                        return i = t.type, r = t.pendingProps, ku(e, t, i, r = t.elementType === i ? r : Fr(i, r), n);
                    case 1:
                        return i = t.type, r = t.pendingProps, Qu(e, t, i, r = t.elementType === i ? r : Fr(i, r), n);
                    case 3:
                        if (Pu(t), i = t.updateQueue, null === e || null === i) throw Error(u(282));
                        if (i = t.pendingProps, r = null !== (r = t.memoizedState) ? r.element : null, uM(e, t), IM(t, i, null, n), (i = t.memoizedState.element) === r) xu(), t = Ju(e, t, n);
                        else {
                            if ((r = t.stateNode.hydrate) && (yu = zn(t.stateNode.containerInfo.firstChild), Tu = t, r = zu = !0), r) for(n = EM(t, null, i, n), t.child = n; n;)n.effectTag = -3 & n.effectTag | 1024, n = n.sibling;
                            else mu(e, t, i, n), xu();
                            t = t.child;
                        }
                        return t;
                    case 5:
                        return bM(t), null === e && Lu(t), i = t.type, r = t.pendingProps, M = null !== e ? e.memoizedProps : null, o = r.children, dn(i, r) ? o = null : null !== M && dn(i, M) && (t.effectTag |= 16), hu(e, t), 4 & t.mode && 1 !== n && r.hidden ? (t.expirationTime = t.childExpirationTime = 1, t = null) : (mu(e, t, o, n), t = t.child), t;
                    case 6:
                        return null === e && Lu(t), null;
                    case 13:
                        return Ru(e, t, n);
                    case 4:
                        return OM(t, t.stateNode.containerInfo), i = t.pendingProps, null === e ? t.child = LM(t, null, i, n) : mu(e, t, i, n), t.child;
                    case 11:
                        return i = t.type, r = t.pendingProps, Ou(e, t, i, r = t.elementType === i ? r : Fr(i, r), n);
                    case 7:
                        return mu(e, t, t.pendingProps, n), t.child;
                    case 8:
                    case 12:
                        return mu(e, t, t.pendingProps.children, n), t.child;
                    case 10:
                        e: {
                            i = t.type._context, r = t.pendingProps, o = t.memoizedProps, M = r.value;
                            var c = t.type._context;
                            if (ar(Xr, c._currentValue), c._currentValue = M, null !== o) {
                                if (c = o.value, 0 === (M = Yi(c, M) ? 0 : 0 | ("function" == typeof i._calculateChangedBits ? i._calculateChangedBits(c, M) : 1073741823))) {
                                    if (o.children === r.children && !Nr.current) {
                                        t = Ju(e, t, n);
                                        break e;
                                    }
                                } else for(null !== (c = t.child) && (c.return = t); null !== c;){
                                    var a = c.dependencies;
                                    if (null !== a) {
                                        o = c.child;
                                        for(var I = a.firstContext; null !== I;){
                                            if (I.context === i && 0 != (I.observedBits & M)) {
                                                1 === c.tag && ((I = oM(n, null)).tag = 2, cM(c, I)), c.expirationTime < n && (c.expirationTime = n), null !== (I = c.alternate) && I.expirationTime < n && (I.expirationTime = n), tM(c.return, n), a.expirationTime < n && (a.expirationTime = n);
                                                break;
                                            }
                                            I = I.next;
                                        }
                                    } else o = 10 === c.tag && c.type === t.type ? null : c.child;
                                    if (null !== o) o.return = c;
                                    else for(o = c; null !== o;){
                                        if (o === t) {
                                            o = null;
                                            break;
                                        }
                                        if (null !== (c = o.sibling)) {
                                            c.return = o.return, o = c;
                                            break;
                                        }
                                        o = o.return;
                                    }
                                    c = o;
                                }
                            }
                            mu(e, t, r.children, n), t = t.child;
                        }
                        return t;
                    case 9:
                        return r = t.type, i = (M = t.pendingProps).children, nM(t, n), i = i(r = iM(r, M.unstable_observedBits)), t.effectTag |= 1, mu(e, t, i, n), t.child;
                    case 14:
                        return M = Fr(r = t.type, t.pendingProps), vu(e, t, r, M = Fr(r.type, M), i, n);
                    case 15:
                        return bu(e, t, t.type, t.pendingProps, i, n);
                    case 17:
                        return i = t.type, r = t.pendingProps, r = t.elementType === i ? r : Fr(i, r), null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), t.tag = 1, sr(i) ? (e = !0, Tr(t)) : e = !1, nM(t, n), DM(t, i, r), TM(t, i, r, n), Yu(null, t, i, !0, e, n);
                    case 19:
                        return Vu(e, t, n);
                }
                throw Error(u(156, t.tag));
            };
            var zc = null, wc = null;
            Zc.prototype.render = function(e) {
                Qc(e, this._internalRoot, null, null);
            }, Zc.prototype.unmount = function() {
                var e = this._internalRoot, _$t = e.containerInfo;
                Qc(null, e, null, function() {
                    _$t[Cn] = null;
                });
            }, st = function st(e) {
                if (13 === e.tag) {
                    var _$t = Jr(Vo(), 150, 100);
                    Fo(e, _$t), Uc(e, _$t);
                }
            }, At = function At(e) {
                13 === e.tag && (Fo(e, 3), Uc(e, 3));
            }, Dt = function Dt(e) {
                if (13 === e.tag) {
                    var _$t = Vo();
                    Fo(e, _$t = Jo(_$t, e, null)), Uc(e, _$t);
                }
            }, p = function p(e, t, n) {
                switch(t){
                    case "input":
                        if (Ee(e, n), t = n.name, "radio" === n.type && null != t) {
                            for(n = e; n.parentNode;)n = n.parentNode;
                            for(n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++){
                                var i = n[t];
                                if (i !== e && i.form === e.form) {
                                    var r = mn(i);
                                    if (!r) throw Error(u(90));
                                    ze(i), Ee(i, r);
                                }
                            }
                        }
                        break;
                    case "textarea":
                        ve(e, n);
                        break;
                    case "select":
                        null != (t = n.value) && Se(e, !!n.multiple, t, !1);
                }
            }, h = ec, k = function k(e, t, n, i, r) {
                var M = fo;
                fo |= 4;
                try {
                    return Br(98, e.bind(null, t, n, i, r));
                } finally{
                    0 === (fo = M) && Hr();
                }
            }, Q = function Q() {
                0 == (49 & fo) && (function() {
                    if (null !== Bo) {
                        var e = Bo;
                        Bo = null, e.forEach(function(e, t) {
                            kc(t, e), qo(t);
                        }), Hr();
                    }
                }(), sc());
            }, Y = function Y(e, t) {
                var _$n = fo;
                fo |= 2;
                try {
                    return e(t);
                } finally{
                    0 === (fo = _$n) && Hr();
                }
            };
            var Hc, Vc, Jc = {
                Events: [
                    pn,
                    Sn,
                    mn,
                    C,
                    f,
                    Yn,
                    function(e) {
                        rt(e, Qn);
                    },
                    v,
                    b,
                    qt,
                    ot,
                    sc,
                    {
                        current: !1
                    }
                ]
            };
            Vc = (Hc = {
                findFiberByHostInstance: xn,
                bundleType: 0,
                version: "16.14.0",
                rendererPackageName: "react-dom"
            }).findFiberByHostInstance, function(e) {
                if ("undefined" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
                var _$t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                if (_$t.isDisabled || !_$t.supportsFiber) return !0;
                try {
                    var _$n = _$t.inject(e);
                    zc = function zc(e) {
                        try {
                            _$t.onCommitFiberRoot(_$n, e, void 0, 64 == (64 & e.current.effectTag));
                        } catch (e) {}
                    }, wc = function wc(e) {
                        try {
                            _$t.onCommitFiberUnmount(_$n, e);
                        } catch (e) {}
                    };
                } catch (e) {}
            }(r({}, Hc, {
                overrideHookState: null,
                overrideProps: null,
                setSuspenseHandler: null,
                scheduleUpdate: null,
                currentDispatcherRef: K.ReactCurrentDispatcher,
                findHostInstanceByFiber: function findHostInstanceByFiber(e) {
                    return null === (e = nt(e)) ? null : e.stateNode;
                },
                findFiberByHostInstance: function findFiberByHostInstance(e) {
                    return Vc ? Vc(e) : null;
                },
                findHostInstancesForRefresh: null,
                scheduleRefresh: null,
                scheduleRoot: null,
                setRefreshHandler: null,
                getCurrentFiber: null
            })), t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Jc, t.createPortal = Wc, t.findDOMNode = function(e) {
                if (null == e) return null;
                if (1 === e.nodeType) return e;
                var _$t = e._reactInternalFiber;
                if (void 0 === _$t) {
                    if ("function" == typeof e.render) throw Error(u(188));
                    throw Error(u(268, Object.keys(e)));
                }
                return e = null === (e = nt(_$t)) ? null : e.stateNode;
            }, t.flushSync = function(e, t) {
                if (0 != (48 & fo)) throw Error(u(187));
                var _$n = fo;
                fo |= 1;
                try {
                    return Br(99, e.bind(null, t));
                } finally{
                    fo = _$n, Hr();
                }
            }, t.hydrate = function(e, t, n) {
                if (!Gc(t)) throw Error(u(200));
                return Bc(null, e, t, !0, n);
            }, t.render = function(e, t, n) {
                if (!Gc(t)) throw Error(u(200));
                return Bc(null, e, t, !1, n);
            }, t.unmountComponentAtNode = function(e) {
                if (!Gc(e)) throw Error(u(40));
                return !!e._reactRootContainer && (tc(function() {
                    Bc(null, null, e, !1, function() {
                        e._reactRootContainer = null, e[Cn] = null;
                    });
                }), !0);
            }, t.unstable_batchedUpdates = ec, t.unstable_createPortal = function(e, t) {
                return Wc(e, t, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
            }, t.unstable_renderSubtreeIntoContainer = function(e, t, n, i) {
                if (!Gc(n)) throw Error(u(200));
                if (null == e || void 0 === e._reactInternalFiber) throw Error(u(38));
                return Bc(e, t, n, !1, i);
            }, t.version = "16.14.0";
        },
        function(e, t, n) {
            "use strict";
            e.exports = n(31);
        },
        function(e, t, n) {
            "use strict";
            var E = function E(e, t) {
                var n = e.length;
                e.push(t);
                e: for(;;){
                    var i = n - 1 >>> 1, r = e[i];
                    if (!(void 0 !== r && 0 < p(r, t))) break e;
                    e[i] = t, e[n] = r, n = i;
                }
            };
            var C = function C(e) {
                return void 0 === (e = e[0]) ? null : e;
            };
            var x = function x(e) {
                var _$t = e[0];
                if (void 0 !== _$t) {
                    var n = e.pop();
                    if (n !== _$t) {
                        e[0] = n;
                        e: for(var i = 0, r = e.length; i < r;){
                            var M = 2 * (i + 1) - 1, u = e[M], o = M + 1, c = e[o];
                            if (void 0 !== u && 0 > p(u, n)) void 0 !== c && 0 > p(c, u) ? (e[i] = c, e[o] = n, i = o) : (e[i] = u, e[M] = n, i = M);
                            else {
                                if (!(void 0 !== c && 0 > p(c, n))) break e;
                                e[i] = c, e[o] = n, i = o;
                            }
                        }
                    }
                    return _$t;
                }
                return null;
            };
            var p = function p(e, t) {
                var n = e.sortIndex - t.sortIndex;
                return 0 !== n ? n : e.id - t.id;
            };
            var Y = function Y(e) {
                for(var _$t = C(m); null !== _$t;){
                    if (null === _$t.callback) x(m);
                    else {
                        if (!(_$t.startTime <= e)) break;
                        x(m), _$t.sortIndex = _$t.expirationTime, E(S, _$t);
                    }
                    _$t = C(m);
                }
            };
            var U = function U(e, n) {
                k = !1, Q && (Q = !1, M()), h = !0;
                var i = b;
                try {
                    for(Y(n), v = C(S); null !== v && (!(v.expirationTime > n) || e && !u());){
                        var o = v.callback;
                        if (null !== o) {
                            v.callback = null, b = v.priorityLevel;
                            var c = o(v.expirationTime <= n);
                            n = t.unstable_now(), "function" == typeof c ? v.callback = c : v === C(S) && x(S), Y(n);
                        } else x(S);
                        v = C(S);
                    }
                    if (null !== v) var a = !0;
                    else {
                        var I = C(m);
                        null !== I && r(P, I.startTime - n), a = !1;
                    }
                    return a;
                } finally{
                    v = null, b = i, h = !1;
                }
            };
            var Z = function Z(e) {
                switch(e){
                    case 1:
                        return -1;
                    case 2:
                        return 250;
                    case 5:
                        return 1073741823;
                    case 4:
                        return 1e4;
                    default:
                        return 5e3;
                }
            };
            /** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var i, r, M, u, o;
            if ("undefined" == typeof window || "function" != typeof MessageChannel) {
                var c = null, a = null, I = function I1() {
                    if (null !== c) try {
                        var _$e = t.unstable_now();
                        c(!0, _$e), c = null;
                    } catch (e) {
                        throw setTimeout(I, 0), e;
                    }
                }, l = Date.now();
                t.unstable_now = function() {
                    return Date.now() - l;
                }, i = function(e) {
                    null !== c ? setTimeout(i, 0, e) : (c = e, setTimeout(I, 0));
                }, r = function r(e, t) {
                    a = setTimeout(e, t);
                }, M = function M() {
                    clearTimeout(a);
                }, u = function u() {
                    return !1;
                }, o = t.unstable_forceFrameRate = function o() {};
            } else {
                var N = window.performance, j = window.Date, g = window.setTimeout, s = window.clearTimeout;
                if ("undefined" != typeof console) {
                    var A = window.cancelAnimationFrame;
                    "function" != typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" != typeof A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
                }
                if ("object" == typeof N && "function" == typeof N.now) t.unstable_now = function() {
                    return N.now();
                };
                else {
                    var D = j.now();
                    t.unstable_now = function() {
                        return j.now() - D;
                    };
                }
                var d = !1, T = null, y = -1, z = 5, w = 0;
                u = function u() {
                    return t.unstable_now() >= w;
                }, o = function o() {}, t.unstable_forceFrameRate = function(e) {
                    0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : z = 0 < e ? Math.floor(1e3 / e) : 5;
                };
                var f = new MessageChannel, L = f.port2;
                f.port1.onmessage = function() {
                    if (null !== T) {
                        var _$e = t.unstable_now();
                        w = _$e + z;
                        try {
                            T(!0, _$e) ? L.postMessage(null) : (d = !1, T = null);
                        } catch (e) {
                            throw L.postMessage(null), e;
                        }
                    } else d = !1;
                }, i = function i(e) {
                    T = e, d || (d = !0, L.postMessage(null));
                }, r = function r(e, n) {
                    y = g(function() {
                        e(t.unstable_now());
                    }, n);
                }, M = function M() {
                    s(y), y = -1;
                };
            }
            var S = [], m = [], O = 1, v = null, b = 3, h = !1, k = !1, Q = !1;
            function P(e) {
                if (Q = !1, Y(e), !k) {
                    if (null !== C(S)) k = !0, i(U);
                    else {
                        var _$t = C(m);
                        null !== _$t && r(P, _$t.startTime - e);
                    }
                }
            }
            var G = o;
            t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function(e) {
                e.callback = null;
            }, t.unstable_continueExecution = function() {
                k || h || (k = !0, i(U));
            }, t.unstable_getCurrentPriorityLevel = function() {
                return b;
            }, t.unstable_getFirstCallbackNode = function() {
                return C(S);
            }, t.unstable_next = function(e) {
                switch(b){
                    case 1:
                    case 2:
                    case 3:
                        var _$t = 3;
                        break;
                    default:
                        _$t = b;
                }
                var n = b;
                b = _$t;
                try {
                    return e();
                } finally{
                    b = n;
                }
            }, t.unstable_pauseExecution = function() {}, t.unstable_requestPaint = G, t.unstable_runWithPriority = function(e, t) {
                switch(e){
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    default:
                        e = 3;
                }
                var n = b;
                b = e;
                try {
                    return t();
                } finally{
                    b = n;
                }
            }, t.unstable_scheduleCallback = function(e, n, u) {
                var o = t.unstable_now();
                if ("object" == typeof u && null !== u) {
                    var c = u.delay;
                    c = "number" == typeof c && 0 < c ? o + c : o, u = "number" == typeof u.timeout ? u.timeout : Z(e);
                } else u = Z(e), c = o;
                return e = {
                    id: O++,
                    callback: n,
                    priorityLevel: e,
                    startTime: c,
                    expirationTime: u = c + u,
                    sortIndex: -1
                }, c > o ? (e.sortIndex = c, E(m, e), null === C(S) && e === C(m) && (Q ? M() : Q = !0, r(P, c - o))) : (e.sortIndex = u, E(S, e), k || h || (k = !0, i(U))), e;
            }, t.unstable_shouldYield = function() {
                var e = t.unstable_now();
                Y(e);
                var n = C(S);
                return n !== v && null !== v && null !== n && null !== n.callback && n.startTime <= e && n.expirationTime < v.expirationTime || u();
            }, t.unstable_wrapCallback = function(e) {
                var _$t = b;
                return function() {
                    var n = b;
                    b = _$t;
                    try {
                        return e.apply(this, arguments);
                    } finally{
                        b = n;
                    }
                };
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.updateLocal = t.removeLocal = t.getLocal = t.setLocal = t.local = void 0;
            var i = n(0);
            n(10).isLocalStorageAvailable() && (t.local = window.localStorage), t.setLocal = function(e, n) {
                var i = JSON.stringify(n);
                t.local && t.local.setItem(e, i);
            }, t.getLocal = function(e) {
                var _$n = null, i = null;
                if (t.local && (i = t.local.getItem(e)), i && "string" == typeof i) try {
                    _$n = JSON.parse(i);
                } catch (e) {
                    return null;
                }
                return _$n;
            }, t.removeLocal = function(e) {
                t.local && t.local.removeItem(e);
            }, t.updateLocal = function(e, n) {
                var r = t.getLocal(e) || {}, M = i.__assign(i.__assign({}, r), n);
                t.setLocal(e, M);
            };
        },
        function(e, t, n) {
            "use strict";
            n.r(t), (function(e) {
                var N = function N(e) {
                    return e ? s(e) : "undefined" == typeof document && "undefined" != typeof navigator && "ReactNative" === navigator.product ? new c : "undefined" != typeof navigator ? s(navigator.userAgent) : D();
                };
                var j = function j(e) {
                    return "" !== e && I.reduce(function(t, n) {
                        var i = n[0], r = n[1];
                        if (t) return t;
                        var M = r.exec(e);
                        return !!M && [
                            i,
                            M
                        ];
                    }, !1);
                };
                var g = function g(e) {
                    var _$t = j(e);
                    return _$t ? _$t[0] : null;
                };
                var s = function s(e) {
                    var _$t = j(e);
                    if (!_$t) return null;
                    var _$n = _$t[0], M = _$t[1];
                    if ("searchbot" === _$n) return new o;
                    var c = M[1] && M[1].split(".").join("_").split("_").slice(0, 3);
                    c ? c.length < 3 && (c = i(i([], c, !0), function(e) {
                        for(var _$t = [], _$n = 0; _$n < e; _$n++)_$t.push("0");
                        return _$t;
                    }(3 - c.length), !0)) : c = [];
                    var I = c.join("."), l = A(e), N = a.exec(e);
                    return N && N[1] ? new u(_$n, I, l, N[1]) : new r(_$n, I, l);
                };
                var A = function A(e) {
                    for(var _$t = 0, _$n = l.length; _$t < _$n; _$t++){
                        var i = l[_$t], r = i[0];
                        if (i[1].exec(e)) return r;
                    }
                    return null;
                };
                var D = function D() {
                    return void 0 !== e && e.version ? new M(e.version.slice(1)) : null;
                };
                n.d(t, "BrowserInfo", function() {
                    return r;
                }), n.d(t, "NodeInfo", function() {
                    return M;
                }), n.d(t, "SearchBotDeviceInfo", function() {
                    return u;
                }), n.d(t, "BotInfo", function() {
                    return o;
                }), n.d(t, "ReactNativeInfo", function() {
                    return c;
                }), n.d(t, "detect", function() {
                    return N;
                }), n.d(t, "browserName", function() {
                    return g;
                }), n.d(t, "parseUserAgent", function() {
                    return s;
                }), n.d(t, "detectOS", function() {
                    return A;
                }), n.d(t, "getNodeVersion", function() {
                    return D;
                });
                var i = function i(e, t, n) {
                    if (n || 2 === arguments.length) for(var i, r = 0, M = t.length; r < M; r++)!i && r in t || (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
                    return e.concat(i || Array.prototype.slice.call(t));
                }, r = function r(e, t, n) {
                    this.name = e, this.version = t, this.os = n, this.type = "browser";
                }, M = function M(t) {
                    this.version = t, this.type = "node", this.name = "node", this.os = e.platform;
                }, u = function u(e, t, n, i) {
                    this.name = e, this.version = t, this.os = n, this.bot = i, this.type = "bot-device";
                }, o = function o() {
                    this.type = "bot", this.bot = !0, this.name = "bot", this.version = null, this.os = null;
                }, c = function c() {
                    this.type = "react-native", this.name = "react-native", this.version = null, this.os = null;
                }, a = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/, I = [
                    [
                        "aol",
                        /AOLShield\/([0-9\._]+)/
                    ],
                    [
                        "edge",
                        /Edge\/([0-9\._]+)/
                    ],
                    [
                        "edge-ios",
                        /EdgiOS\/([0-9\._]+)/
                    ],
                    [
                        "yandexbrowser",
                        /YaBrowser\/([0-9\._]+)/
                    ],
                    [
                        "kakaotalk",
                        /KAKAOTALK\s([0-9\.]+)/
                    ],
                    [
                        "samsung",
                        /SamsungBrowser\/([0-9\.]+)/
                    ],
                    [
                        "silk",
                        /\bSilk\/([0-9._-]+)\b/
                    ],
                    [
                        "miui",
                        /MiuiBrowser\/([0-9\.]+)$/
                    ],
                    [
                        "beaker",
                        /BeakerBrowser\/([0-9\.]+)/
                    ],
                    [
                        "edge-chromium",
                        /EdgA?\/([0-9\.]+)/
                    ],
                    [
                        "chromium-webview",
                        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
                    ],
                    [
                        "chrome",
                        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
                    ],
                    [
                        "phantomjs",
                        /PhantomJS\/([0-9\.]+)(:?\s|$)/
                    ],
                    [
                        "crios",
                        /CriOS\/([0-9\.]+)(:?\s|$)/
                    ],
                    [
                        "firefox",
                        /Firefox\/([0-9\.]+)(?:\s|$)/
                    ],
                    [
                        "fxios",
                        /FxiOS\/([0-9\.]+)/
                    ],
                    [
                        "opera-mini",
                        /Opera Mini.*Version\/([0-9\.]+)/
                    ],
                    [
                        "opera",
                        /Opera\/([0-9\.]+)(?:\s|$)/
                    ],
                    [
                        "opera",
                        /OPR\/([0-9\.]+)(:?\s|$)/
                    ],
                    [
                        "pie",
                        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
                    ],
                    [
                        "pie",
                        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
                    ],
                    [
                        "netfront",
                        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
                    ],
                    [
                        "ie",
                        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
                    ],
                    [
                        "ie",
                        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
                    ],
                    [
                        "ie",
                        /MSIE\s(7\.0)/
                    ],
                    [
                        "bb10",
                        /BB10;\sTouch.*Version\/([0-9\.]+)/
                    ],
                    [
                        "android",
                        /Android\s([0-9\.]+)/
                    ],
                    [
                        "ios",
                        /Version\/([0-9\._]+).*Mobile.*Safari.*/
                    ],
                    [
                        "safari",
                        /Version\/([0-9\._]+).*Safari/
                    ],
                    [
                        "facebook",
                        /FB[AS]V\/([0-9\.]+)/
                    ],
                    [
                        "instagram",
                        /Instagram\s([0-9\.]+)/
                    ],
                    [
                        "ios-webview",
                        /AppleWebKit\/([0-9\.]+).*Mobile/
                    ],
                    [
                        "ios-webview",
                        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
                    ],
                    [
                        "curl",
                        /^curl\/([0-9\.]+)$/
                    ],
                    [
                        "searchbot",
                        /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/
                    ]
                ], l = [
                    [
                        "iOS",
                        /iP(hone|od|ad)/
                    ],
                    [
                        "Android OS",
                        /Android/
                    ],
                    [
                        "BlackBerry OS",
                        /BlackBerry|BB10/
                    ],
                    [
                        "Windows Mobile",
                        /IEMobile/
                    ],
                    [
                        "Amazon OS",
                        /Kindle/
                    ],
                    [
                        "Windows 3.11",
                        /Win16/
                    ],
                    [
                        "Windows 95",
                        /(Windows 95)|(Win95)|(Windows_95)/
                    ],
                    [
                        "Windows 98",
                        /(Windows 98)|(Win98)/
                    ],
                    [
                        "Windows 2000",
                        /(Windows NT 5.0)|(Windows 2000)/
                    ],
                    [
                        "Windows XP",
                        /(Windows NT 5.1)|(Windows XP)/
                    ],
                    [
                        "Windows Server 2003",
                        /(Windows NT 5.2)/
                    ],
                    [
                        "Windows Vista",
                        /(Windows NT 6.0)/
                    ],
                    [
                        "Windows 7",
                        /(Windows NT 6.1)/
                    ],
                    [
                        "Windows 8",
                        /(Windows NT 6.2)/
                    ],
                    [
                        "Windows 8.1",
                        /(Windows NT 6.3)/
                    ],
                    [
                        "Windows 10",
                        /(Windows NT 10.0)/
                    ],
                    [
                        "Windows ME",
                        /Windows ME/
                    ],
                    [
                        "Windows CE",
                        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
                    ],
                    [
                        "Open BSD",
                        /OpenBSD/
                    ],
                    [
                        "Sun OS",
                        /SunOS/
                    ],
                    [
                        "Chrome OS",
                        /CrOS/
                    ],
                    [
                        "Linux",
                        /(Linux)|(X11)/
                    ],
                    [
                        "Mac OS",
                        /(Mac_PowerPC)|(Macintosh)/
                    ],
                    [
                        "QNX",
                        /QNX/
                    ],
                    [
                        "BeOS",
                        /BeOS/
                    ],
                    [
                        "OS/2",
                        /OS\/2/
                    ]
                ];
            }).call(this, n(11));
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.CHAIN_DATA_LIST = void 0, t.CHAIN_DATA_LIST = {
                1: {
                    chainId: 1,
                    chain: "ETH",
                    network: "mainnet",
                    networkId: 1
                },
                2: {
                    chainId: 2,
                    chain: "EXP",
                    network: "expanse",
                    networkId: 1
                },
                3: {
                    chainId: 3,
                    chain: "ETH",
                    network: "ropsten",
                    networkId: 3
                },
                4: {
                    chainId: 4,
                    chain: "ETH",
                    network: "rinkeby",
                    networkId: 4
                },
                5: {
                    chainId: 5,
                    chain: "ETH",
                    network: "goerli",
                    networkId: 5
                },
                6: {
                    chainId: 6,
                    chain: "ETC",
                    network: "kotti",
                    networkId: 6
                },
                8: {
                    chainId: 8,
                    chain: "UBQ",
                    network: "ubiq",
                    networkId: 88
                },
                9: {
                    chainId: 9,
                    chain: "UBQ",
                    network: "ubiq-testnet",
                    networkId: 2
                },
                10: {
                    chainId: 10,
                    chain: "ETH",
                    network: "optimism",
                    networkId: 10
                },
                11: {
                    chainId: 11,
                    chain: "META",
                    network: "metadium",
                    networkId: 11
                },
                12: {
                    chainId: 12,
                    chain: "META",
                    network: "metadium-testnet",
                    networkId: 12
                },
                18: {
                    chainId: 18,
                    chain: "TST",
                    network: "thundercore-testnet",
                    networkId: 18
                },
                22: {
                    chainId: 22,
                    chain: "LYX",
                    network: "lukso-l14-testnet",
                    networkId: 22
                },
                23: {
                    chainId: 23,
                    chain: "LYX",
                    network: "lukso-l15-testnet",
                    networkId: 23
                },
                25: {
                    chainId: 25,
                    chain: "CRO",
                    network: "cronos",
                    networkId: 25
                },
                30: {
                    chainId: 30,
                    chain: "RSK",
                    network: "rsk",
                    networkId: 30
                },
                31: {
                    chainId: 31,
                    chain: "RSK",
                    network: "rsk-testnet",
                    networkId: 31
                },
                42: {
                    chainId: 42,
                    chain: "ETH",
                    network: "kovan",
                    networkId: 42
                },
                56: {
                    chainId: 56,
                    chain: "BSC",
                    network: "binance",
                    networkId: 56
                },
                60: {
                    chainId: 60,
                    chain: "GO",
                    network: "gochain",
                    networkId: 60
                },
                61: {
                    chainId: 61,
                    chain: "ETC",
                    network: "etc",
                    networkId: 1
                },
                62: {
                    chainId: 62,
                    chain: "ETC",
                    network: "etc-morden",
                    networkId: 2
                },
                63: {
                    chainId: 63,
                    chain: "ETC",
                    network: "etc-testnet",
                    networkId: 7
                },
                64: {
                    chainId: 64,
                    chain: "ELLA",
                    network: "ellaism",
                    networkId: 64
                },
                69: {
                    chainId: 69,
                    chain: "ETH",
                    network: "optimism-kovan",
                    networkId: 69
                },
                76: {
                    chainId: 76,
                    chain: "MIX",
                    network: "mix",
                    networkId: 76
                },
                77: {
                    chainId: 77,
                    chain: "POA",
                    network: "poa-sokol",
                    networkId: 77
                },
                88: {
                    chainId: 88,
                    chain: "TOMO",
                    network: "tomochain",
                    networkId: 88
                },
                97: {
                    chainId: 97,
                    chain: "BSC",
                    network: "binance-testnet",
                    networkId: 97
                },
                99: {
                    chainId: 99,
                    chain: "POA",
                    network: "poa-core",
                    networkId: 99
                },
                100: {
                    chainId: 100,
                    chain: "XDAI",
                    network: "xdai",
                    networkId: 100
                },
                101: {
                    chainId: 101,
                    chain: "ETI",
                    network: "etherinc",
                    networkId: 1
                },
                108: {
                    chainId: 108,
                    chain: "TT",
                    network: "thundercore",
                    networkId: 108
                },
                162: {
                    chainId: 162,
                    chain: "PHT",
                    network: "sirius",
                    networkId: 162
                },
                163: {
                    chainId: 163,
                    chain: "PHT",
                    network: "lightstreams",
                    networkId: 163
                },
                180: {
                    chainId: 180,
                    chain: "AME",
                    network: "ame",
                    networkId: 180
                },
                211: {
                    chainId: 211,
                    chain: "FTN",
                    network: "freight",
                    networkId: 0
                },
                250: {
                    chainId: 250,
                    chain: "FTM",
                    network: "fantom",
                    networkId: 250
                },
                269: {
                    chainId: 269,
                    chain: "HPB",
                    network: "hpb",
                    networkId: 100
                },
                338: {
                    chainId: 338,
                    chain: "CRO",
                    network: "cronos-testnet",
                    networkId: 338
                },
                385: {
                    chainId: 385,
                    chain: "CRO",
                    network: "lisinski",
                    networkId: 385
                },
                534: {
                    chainId: 534,
                    chain: "CNDL",
                    network: "candle",
                    networkId: 534
                },
                820: {
                    chainId: 820,
                    chain: "CLO",
                    network: "callisto",
                    networkId: 1
                },
                821: {
                    chainId: 821,
                    chain: "CLO",
                    network: "callisto-testnet",
                    networkId: 2
                },
                137: {
                    chainId: 137,
                    chain: "MATIC",
                    network: "matic",
                    networkId: 137
                },
                1284: {
                    chainId: 1284,
                    chain: "GLMR",
                    network: "moonbeam",
                    networkId: 1284
                },
                1285: {
                    chainId: 1285,
                    chain: "MOVR",
                    network: "moonriver",
                    networkId: 1285
                },
                42161: {
                    chainId: 42161,
                    chain: "ETH",
                    network: "arbitrum",
                    networkId: 42161
                },
                42220: {
                    chainId: 42220,
                    chain: "CELO",
                    network: "celo",
                    networkId: 42220
                },
                44787: {
                    chainId: 44787,
                    chain: "CELO",
                    network: "celo-alfajores",
                    networkId: 44787
                },
                62320: {
                    chainId: 62320,
                    chain: "CELO",
                    network: "celo-baklava",
                    networkId: 62320
                },
                80001: {
                    chainId: 80001,
                    chain: "MUMBAI",
                    network: "mumbai",
                    networkId: 80001
                },
                43113: {
                    chainId: 43113,
                    chain: "AVAX",
                    network: "avalanche-fuji-testnet",
                    networkId: 43113
                },
                43114: {
                    chainId: 43114,
                    chain: "AVAX",
                    network: "avalanche-mainnet",
                    networkId: 43114
                },
                246529: {
                    chainId: 246529,
                    chain: "ARTIS sigma1",
                    network: "artis-s1",
                    networkId: 246529
                },
                246785: {
                    chainId: 246785,
                    chain: "ARTIS tau1",
                    network: "artis-t1",
                    networkId: 246785
                },
                1007: {
                    chainId: 1007,
                    chain: "NewChain TestNet",
                    network: "newchain-testnet",
                    networkId: 1007
                },
                1012: {
                    chainId: 1012,
                    chain: "NewChain MainNet",
                    network: "newchain-mainnet",
                    networkId: 1012
                },
                421611: {
                    chainId: 421611,
                    chain: "ETH",
                    network: "arbitrum-rinkeby",
                    networkId: 421611
                },
                16666e5: {
                    chainId: 16666e5,
                    chain: "ONE",
                    network: "harmony-shard1",
                    networkId: 16666e5
                },
                1313161554: {
                    chainId: 1313161554,
                    chain: "AETH",
                    network: "aurora",
                    networkId: 1313161554
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.CONNECT_BUTTON_CLASSNAME = t.PROVIDER_DESCRIPTION_CLASSNAME = t.PROVIDER_NAME_CLASSNAME = t.PROVIDER_ICON_CLASSNAME = t.PROVIDER_CONTAINER_CLASSNAME = t.PROVIDER_WRAPPER_CLASSNAME = t.MODAL_CARD_CLASSNAME = t.MODAL_HITBOX_CLASSNAME = t.MODAL_CONTAINER_CLASSNAME = t.MODAL_LIGHTBOX_CLASSNAME = void 0, t.MODAL_LIGHTBOX_CLASSNAME = "web3modal-modal-lightbox", t.MODAL_CONTAINER_CLASSNAME = "web3modal-modal-container", t.MODAL_HITBOX_CLASSNAME = "web3modal-modal-hitbox", t.MODAL_CARD_CLASSNAME = "web3modal-modal-card", t.PROVIDER_WRAPPER_CLASSNAME = "web3modal-provider-wrapper", t.PROVIDER_CONTAINER_CLASSNAME = "web3modal-provider-container", t.PROVIDER_ICON_CLASSNAME = "web3modal-provider-icon", t.PROVIDER_NAME_CLASSNAME = "web3modal-provider-name", t.PROVIDER_DESCRIPTION_CLASSNAME = "web3modal-provider-description", t.CONNECT_BUTTON_CLASSNAME = "web3modal-connect-button";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.SELECT_EVENT = t.CLOSE_EVENT = t.ERROR_EVENT = t.CONNECT_EVENT = void 0, t.CONNECT_EVENT = "connect", t.ERROR_EVENT = "error", t.CLOSE_EVENT = "close", t.SELECT_EVENT = "select";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.CACHED_PROVIDER_KEY = t.INJECTED_PROVIDER_ID = t.WEB3_CONNECT_MODAL_ID = void 0, t.WEB3_CONNECT_MODAL_ID = "WEB3_CONNECT_MODAL_ID", t.INJECTED_PROVIDER_ID = "injected", t.CACHED_PROVIDER_KEY = "WEB3_CONNECT_CACHED_PROVIDER";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            t.default = {
                name: "light",
                colors: {
                    background: "rgb(255, 255, 255)",
                    main: "rgb(12, 12, 13)",
                    secondary: "rgb(169, 169, 188)",
                    border: "rgba(195, 195, 195, 0.14)",
                    hover: "rgba(195, 195, 195, 0.14)"
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            t.default = {
                name: "dark",
                colors: {
                    background: "rgb(39, 49, 56)",
                    main: "rgb(199, 199, 199)",
                    secondary: "rgb(136, 136, 136)",
                    border: "rgba(195, 195, 195, 0.14)",
                    hover: "rgb(16, 26, 32)"
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.phantom = t.ledger = t.web3auth = t.starzwallet = t.bitkeep = t.opera = t.clvwallet = t.sequence = t.walletlink = t.coinbasewallet = t.binancechainwallet = t.frame = t.bitski = t.dcentwallet = t.mewconnect = t.burnerconnect = t.authereum = t.venly = t.fortmatic = t.torus = t.portis = t.boltx = t.walletconnect = t.injected = void 0;
            var i = n(0), r = i.__importDefault(n(41));
            t.injected = r.default;
            var M = i.__importDefault(n(42));
            t.boltx = M.default;
            var u = i.__importDefault(n(43));
            t.walletconnect = u.default;
            var o = i.__importDefault(n(44));
            t.portis = o.default;
            var c = i.__importDefault(n(45));
            t.fortmatic = c.default;
            var a = i.__importDefault(n(46));
            t.torus = a.default;
            var I = i.__importDefault(n(47));
            t.venly = I.default;
            var l = i.__importDefault(n(48));
            t.authereum = l.default;
            var N = i.__importDefault(n(49));
            t.burnerconnect = N.default;
            var j = i.__importDefault(n(50));
            t.mewconnect = j.default;
            var g = i.__importDefault(n(51));
            t.dcentwallet = g.default;
            var s = i.__importDefault(n(52));
            t.bitski = s.default;
            var A = i.__importDefault(n(53));
            t.frame = A.default;
            var D = i.__importDefault(n(54));
            t.binancechainwallet = D.default;
            var d = i.__importStar(n(55));
            t.coinbasewallet = d.default, Object.defineProperty(t, "walletlink", {
                enumerable: !0,
                get: function get() {
                    return d.walletlink;
                }
            });
            var T = i.__importDefault(n(56));
            t.sequence = T.default;
            var y = i.__importDefault(n(57));
            t.clvwallet = y.default;
            var z = i.__importDefault(n(58));
            t.opera = z.default;
            var w = i.__importDefault(n(59));
            t.web3auth = w.default;
            var f = i.__importDefault(n(60));
            t.bitkeep = f.default;
            var L = i.__importDefault(n(61));
            t.starzwallet = L.default;
            var E = i.__importDefault(n(62));
            t.ledger = E.default;
            var C = i.__importDefault(n(63));
            t.phantom = C.default;
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e;
                    return i.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                if (e = null, void 0 === window.ethereum) return [
                                    3,
                                    5
                                ];
                                e = window.ethereum, t.label = 1;
                            case 1:
                                return t.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return t.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw t.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (window.web3) e = window.web3.currentProvider;
                                else {
                                    if (!window.celo) throw new Error("No Web3 Provider found");
                                    e = window.celo;
                                }
                                t.label = 6;
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e;
                    return i.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                if (e = null, void 0 === window.boltX) return [
                                    3,
                                    5
                                ];
                                e = window.boltX.ethereum, t.label = 1;
                            case 1:
                                return t.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return t.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw t.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error("BoltX not found");
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0), r = n(3);
            t.default = function(e, t) {
                return new Promise(function(n, M) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var u, o, c, a, I, l, N, j;
                        return i.__generator(this, function(i) {
                            switch(i.label){
                                case 0:
                                    u = "https://bridge.walletconnect.org", o = !0, c = "", a = void 0, I = 1, l = void 0, t && (u = t.bridge || u, o = void 0 !== t.qrcode ? t.qrcode : o, c = t.infuraId || "", a = t.rpc || void 0, I = t.network && r.getChainId(t.network) ? r.getChainId(t.network) : 1, l = t.qrcodeModalOptions || void 0), N = new e({
                                        bridge: u,
                                        qrcode: o,
                                        infuraId: c,
                                        rpc: a,
                                        chainId: I,
                                        qrcodeModalOptions: l
                                    }), i.label = 1;
                                case 1:
                                    return i.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), [
                                        4,
                                        N.enable()
                                    ];
                                case 2:
                                    return i.sent(), n(N), [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return j = i.sent(), M(j), [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return new Promise(function(n, r) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var M, u, o, c, a;
                        return i.__generator(this, function(i) {
                            switch(i.label){
                                case 0:
                                    if (!t || !t.id) return [
                                        3,
                                        5
                                    ];
                                    i.label = 1;
                                case 1:
                                    return i.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), M = t.id, u = t.network || "mainnet", o = t.config, [
                                        4,
                                        (c = new e(M, u, o)).provider.enable()
                                    ];
                                case 2:
                                    return i.sent(), c.provider._portis = c, n(c.provider), [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return a = i.sent(), [
                                        2,
                                        r(a)
                                    ];
                                case 4:
                                    return [
                                        3,
                                        6
                                    ];
                                case 5:
                                    return [
                                        2,
                                        r(new Error("Missing Portis Id"))
                                    ];
                                case 6:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var _$n, r, M;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                if (!t || !t.key) return [
                                    3,
                                    7
                                ];
                                i.label = 1;
                            case 1:
                                return i.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]), _$n = t.key, [
                                    4,
                                    (r = new e(_$n, t.network)).getProvider()
                                ];
                            case 2:
                                return (M = i.sent()).fm = r, [
                                    4,
                                    r.user.login()
                                ];
                            case 3:
                                return i.sent(), [
                                    4,
                                    r.user.isLoggedIn()
                                ];
                            case 4:
                                if (i.sent()) return [
                                    2,
                                    M
                                ];
                                throw new Error("Failed to login to Fortmatic");
                            case 5:
                                throw i.sent();
                            case 6:
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                throw new Error("Missing Fortmatic key");
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    return i.__generator(this, function(n) {
                        return [
                            2,
                            new Promise(function(n, r) {
                                return i.__awaiter(void 0, void 0, void 0, function() {
                                    var M, u, o, c, a, I, l, N;
                                    return i.__generator(this, function(j) {
                                        switch(j.label){
                                            case 0:
                                                return j.trys.push([
                                                    0,
                                                    3,
                                                    ,
                                                    4
                                                ]), M = {
                                                    host: "mainnet"
                                                }, u = void 0, M = t.networkParams || t.network ? i.__assign({
                                                    host: t.network
                                                }, t.networkParams) : M, [
                                                    4,
                                                    (o = new e({
                                                        buttonPosition: (null === (I = t.config) || void 0 === I ? void 0 : I.buttonPosition) || "bottom-left",
                                                        apiKey: (null === (l = t.config) || void 0 === l ? void 0 : l.apiKey) || "torus-default",
                                                        modalZIndex: (null === (N = t.config) || void 0 === N ? void 0 : N.modalZIndex) || 99999
                                                    })).init(i.__assign(i.__assign({
                                                        showTorusButton: !1
                                                    }, t.config), {
                                                        network: M
                                                    }))
                                                ];
                                            case 1:
                                                return j.sent(), t.loginParams && (u = t.loginParams.verifier), [
                                                    4,
                                                    o.login({
                                                        verifier: u
                                                    })
                                                ];
                                            case 2:
                                                return j.sent(), (c = o.provider).torus = o, n(c), [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                return a = j.sent(), r(a), [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return new Promise(function(e, n) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var r, M, u;
                        return i.__generator(this, function(i) {
                            switch(i.label){
                                case 0:
                                    if (!t || !t.clientId) return [
                                        3,
                                        5
                                    ];
                                    i.label = 1;
                                case 1:
                                    return i.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), r = {
                                        clientId: t.clientId,
                                        secretType: t.secretType || "ETHEREUM",
                                        environment: t.environment,
                                        authenticationOptions: t.authenticationOptions,
                                        signMethod: "POPUP"
                                    }, [
                                        4,
                                        window.Venly.createProviderEngine(r)
                                    ];
                                case 2:
                                    return M = i.sent(), [
                                        2,
                                        e(M)
                                    ];
                                case 3:
                                    return u = i.sent(), console.error(u), [
                                        2,
                                        n(new Error("Failed to login to Venly"))
                                    ];
                                case 4:
                                    return [
                                        3,
                                        6
                                    ];
                                case 5:
                                    return [
                                        2,
                                        n(new Error("Please provide an Venly client id"))
                                    ];
                                case 6:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return void 0 === t && (t = {}), new Promise(function(n, r) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var M, u, o;
                        return i.__generator(this, function(c) {
                            switch(c.label){
                                case 0:
                                    return c.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]), M = new e(i.__assign(i.__assign({}, t), {
                                        networkName: t.networkName || t.network
                                    })), (u = M.getProvider()).authereum = M, [
                                        4,
                                        u.enable()
                                    ];
                                case 1:
                                    return c.sent(), n(u), [
                                        3,
                                        3
                                    ];
                                case 2:
                                    return o = c.sent(), [
                                        2,
                                        r(o)
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var _$n;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                return t.defaultNetwork = t.defaultNetwork || t.network, [
                                    4,
                                    (_$n = new e(t)).enable()
                                ];
                            case 1:
                                return i.sent(), [
                                    2,
                                    _$n
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0), r = n(3);
            t.default = function(e, t) {
                return new Promise(function(n, M) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var u, o, c, a, I, l, N;
                        return i.__generator(this, function(i) {
                            switch(i.label){
                                case 0:
                                    if (u = "", o = void 0, c = 1, t && (u = t.infuraId || "", o = t.rpc || void 0, t.infuraId && !o && (o = "wss://mainnet.infura.io/ws/v3/" + u), c = t.network && r.getChainId(t.network) ? r.getChainId(t.network) : 1), e.Provider.isConnected) return [
                                        3,
                                        4
                                    ];
                                    a = new e.Provider, I = a.makeWeb3Provider(c, o, !0), a.on("disconnected", function() {}), i.label = 1;
                                case 1:
                                    return i.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), [
                                        4,
                                        a.enable()
                                    ];
                                case 2:
                                    return l = i.sent(), console.log(l), n(I), [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return N = i.sent(), M(N), [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var _$n;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                return [
                                    4,
                                    (_$n = new e(t)).enable()
                                ];
                            case 1:
                                return i.sent(), [
                                    2,
                                    _$n
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var _$n;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                return [
                                    4,
                                    (_$n = new e(t.clientId, t.callbackUrl, t.extraBitskiOptions)).signIn()
                                ];
                            case 1:
                                return i.sent(), [
                                    2,
                                    _$n.getProvider(t.extraProviderOptions)
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var _$t;
                    return i.__generator(this, function(n) {
                        try {
                            return (_$t = e("frame")).isFrameNative = !0, [
                                2,
                                _$t
                            ];
                        } catch (e) {
                            throw e;
                        }
                        return [
                            2
                        ];
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e;
                    return i.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                if (e = null, void 0 === window.BinanceChain) return [
                                    3,
                                    5
                                ];
                                e = window.BinanceChain, t.label = 1;
                            case 1:
                                return t.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return t.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw t.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error("No Binance Chain Wallet found");
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.walletlink = void 0;
            var i = n(0), r = function r(e, t) {
                return new Promise(function(n, r) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var M, u, o, c, a, I, l, N, j, g;
                        return i.__generator(this, function(i) {
                            switch(i.label){
                                case 0:
                                    u = (M = t || {}).infuraId || "", o = M.chainId || 1, c = M.appName || "", a = M.appLogoUrl, I = M.darkMode || !1, l = M.rpc || void 0, M.infuraId && !M.rpc && (l = "https://mainnet.infura.io/v3/" + u), N = new e({
                                        appName: c,
                                        appLogoUrl: a,
                                        darkMode: I
                                    }), i.label = 1;
                                case 1:
                                    return i.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), [
                                        4,
                                        (j = N.makeWeb3Provider(l, o)).send("eth_requestAccounts")
                                    ];
                                case 2:
                                    return i.sent(), n(j), [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return g = i.sent(), r(g), [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
            t.walletlink = r, t.default = r;
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var _$n, r, M, u, o;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                if (!(null === (o = null === window || void 0 === window ? void 0 : window.ethereum) || void 0 === o ? void 0 : o.isSequence)) return [
                                    3,
                                    4
                                ];
                                _$n = window.ethereum, i.label = 1;
                            case 1:
                                return i.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    _$n.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return i.sent(), [
                                    2,
                                    _$n
                                ];
                            case 3:
                                throw i.sent(), new Error("User Rejected");
                            case 4:
                                return i.trys.push([
                                    4,
                                    5,
                                    ,
                                    7
                                ]), r = e.getWallet(), [
                                    3,
                                    7
                                ];
                            case 5:
                                return i.sent(), M = {}, (null == t ? void 0 : t.networkRpcUrl) && (M = {
                                    networkRpcUrl: t.networkRpcUrl
                                }), [
                                    4,
                                    e.initWallet((null == t ? void 0 : t.defaultNetwork) || "mainnet", M)
                                ];
                            case 6:
                                return r = i.sent(), [
                                    3,
                                    7
                                ];
                            case 7:
                                return r.isConnected() ? [
                                    3,
                                    9
                                ] : [
                                    4,
                                    r.connect({
                                        app: null == t ? void 0 : t.appName,
                                        authorize: (null == t ? void 0 : t.authorize) || !1,
                                        keepWalletOpeneed: (null == t ? void 0 : t.keepWalletOpened) || !1
                                    })
                                ];
                            case 8:
                                if (!(u = i.sent()).connected) throw new Error("Failed to connect");
                                (null == t ? void 0 : t.onConnect) && t.onConnect(u), i.label = 9;
                            case 9:
                                return (_$n = r.getProvider()).sequence = r, (null == t ? void 0 : t.getSequenceWallet) && t.getSequenceWallet(r), [
                                    2,
                                    _$n
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e;
                    return i.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                if (e = null, void 0 === window.clover) return [
                                    3,
                                    5
                                ];
                                e = window.clover, t.label = 1;
                            case 1:
                                return t.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return t.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw t.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error("No CLV Wallet found");
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e, _$t;
                    return i.__generator(this, function(n) {
                        switch(n.label){
                            case 0:
                                if (e = null, void 0 === (null === (_$t = window.ethereum) || void 0 === _$t ? void 0 : _$t.isOpera)) return [
                                    3,
                                    5
                                ];
                                e = window.ethereum, n.label = 1;
                            case 1:
                                return n.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return n.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw n.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error("Opera not found");
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    return i.__generator(this, function(n) {
                        return [
                            2,
                            new Promise(function(n, r) {
                                return i.__awaiter(void 0, void 0, void 0, function() {
                                    var M, u, o, c, a, I, l;
                                    return i.__generator(this, function(i) {
                                        switch(i.label){
                                            case 0:
                                                return i.trys.push([
                                                    0,
                                                    3,
                                                    ,
                                                    4
                                                ]), u = (M = t || {}).chainId || "0x1", o = M.clientId || "localhostid", c = M.infuraId, a = new e({
                                                    chainConfig: {
                                                        chainNamespace: "eip155",
                                                        chainId: u,
                                                        rpcTarget: "https://mainnet.infura.io/v3/" + c
                                                    },
                                                    clientId: o
                                                }), console.log(a), [
                                                    4,
                                                    a.initModal()
                                                ];
                                            case 1:
                                                return i.sent(), [
                                                    4,
                                                    a.connect()
                                                ];
                                            case 2:
                                                return i.sent(), (I = a.provider).web3auth = a, n(I), [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                return l = i.sent(), console.log(l), r(l), [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e, _$t, _$n;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                if (e = null, void 0 === (null === (_$t = null === window || void 0 === window ? void 0 : window.bitkeep) || void 0 === _$t ? void 0 : _$t.ethereum)) return [
                                    3,
                                    5
                                ];
                                e = null === (_$n = null === window || void 0 === window ? void 0 : window.bitkeep) || void 0 === _$n ? void 0 : _$n.ethereum, i.label = 1;
                            case 1:
                                return i.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), console.log("ConnectToBitkeep"), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return i.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw i.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (!window.web3) throw new Error("No Web3 Provider found");
                                e = window.web3.currentProvider, i.label = 6;
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e;
                    return i.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                return e = null, [
                                    4,
                                    new Promise(function(e) {
                                        return setTimeout(e, 1e3);
                                    })
                                ];
                            case 1:
                                if (t.sent(), void 0 === window.starzwallet) return [
                                    3,
                                    6
                                ];
                                e = window.starzwallet, t.label = 2;
                            case 2:
                                return t.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 3:
                                return t.sent(), [
                                    3,
                                    5
                                ];
                            case 4:
                                throw t.sent(), new Error("User Rejected");
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                throw new Error("No 99Starz Wallet found");
                            case 7:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    return i.__generator(this, function(n) {
                        return [
                            2,
                            new Promise(function(n, r) {
                                return i.__awaiter(void 0, void 0, void 0, function() {
                                    var M, u, o;
                                    return i.__generator(this, function(c) {
                                        switch(c.label){
                                            case 0:
                                                return c.trys.push([
                                                    0,
                                                    3,
                                                    ,
                                                    4
                                                ]), [
                                                    4,
                                                    e()
                                                ];
                                            case 1:
                                                return (M = c.sent()).checkSupport(i.__assign({
                                                    providerType: "Ethereum"
                                                }, t)), [
                                                    4,
                                                    M.getProvider()
                                                ];
                                            case 2:
                                                return (u = c.sent()).request({
                                                    method: "eth_requestAccounts"
                                                }), [
                                                    2,
                                                    n(u)
                                                ];
                                            case 3:
                                                return o = c.sent(), [
                                                    2,
                                                    r(o)
                                                ];
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e, _$n, r;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                if (e = null, void 0 === (null === (_$n = window.phantom) || void 0 === _$n ? void 0 : _$n[t.networkType])) return [
                                    3,
                                    5
                                ];
                                e = null === (r = window.phantom) || void 0 === r ? void 0 : r[t.networkType], i.label = 1;
                            case 1:
                                return i.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return i.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw i.sent();
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error("phantom wallet not found");
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDAgNDQwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzAwOGM3Mzt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPnNhbnNfd2hpdGUgY29weTwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjIwLDkuODJDMTAzLjkyLDkuODIsOS44MiwxMDMuOTIsOS44MiwyMjBTMTAzLjkyLDQzMC4xOCwyMjAsNDMwLjE4LDQzMC4xOCwzMzYuMDgsNDMwLjE4LDIyMCwzMzYuMDgsOS44MiwyMjAsOS44MlpNMzczLjgzLDIzMS40N0gyNzYuM2E1OS40MSw1OS40MSwwLDEsMSwuNDUtMjAuNjdoOTcuMDhhMTAuMzQsMTAuMzQsMCwxLDEsMCwyMC42N1oiLz48L3N2Zz4=";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxNTguOCAxODQiIHZpZXdCb3g9IjAgMCAxNTguOCAxODQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzU0IDM1MSkiPjxwYXRoIGQ9Im0tMjc0LjYtMzQzLjdjMjkuMyAyMi43IDYyLjkgMjEuMyA3Mi41IDIxLjMtMi4xIDEyOS4xLTE4LjEgMTExLjktNzIuNSAxNDguMS01NC40LTM2LjItNzAuMy0xOS03Mi40LTE0OC4xIDkuNSAwIDQzIDEuNCA3Mi40LTIxLjN6IiBmaWxsPSIjZmZmIi8+PHBhdGggZD0ibS0yNzQuNi0zNDMuNyA0LjItNS41Yy0yLjUtMS45LTYtMS45LTguNSAwem03Mi41IDIxLjMgNi45LjFjMC0xLjktLjctMy42LTItNS0xLjMtMS4zLTMuMS0yLjEtNC45LTIuMXptLTcyLjUgMTQ4LjEtMy44IDUuOGMyLjMgMS41IDUuMyAxLjUgNy43IDB6bS03Mi40LTE0OC4xdi02LjljLTEuOSAwLTMuNi43LTQuOSAyLjEtMS4zIDEuMy0yIDMuMS0yIDV6bTY4LjEtMTUuOGMzMS40IDI0LjMgNjcuMyAyMi43IDc2LjcgMjIuN3YtMTMuOGMtOS44IDAtNDEuMSAxLjItNjguMy0xOS45em02OS44IDE1LjdjLS41IDMyLjEtMS45IDU0LjgtNC41IDcxLjYtMi42IDE2LjYtNi4yIDI2LjYtMTEgMzMuNi00LjggNy4zLTEwLjggMTEuNi0xOS43IDE2LjktOSA1LjQtMjAuMyAxMS4yLTM0LjMgMjAuNGw3LjcgMTEuNWMxMy4zLTguOCAyNC4zLTE0LjUgMzMuNy0yMC4xIDkuNS01LjcgMTcuOC0xMS45IDI0LjEtMjEgNi4zLTkuNCAxMC41LTIxLjYgMTMuMi0zOS4yIDIuNy0xNy40IDQuMS00MSA0LjYtNzMuNXptLTYxLjcgMTQyLjRjLTEzLjktOS4zLTI1LjMtMTUuMS0zNC4yLTIwLjRzLTE0LjktOS42LTE5LjctMTYuOWMtNC43LTctOC40LTE2LjktMTAuOS0zMy42LTIuNi0xNi44LTMuOS0zOS40LTQuNS03MS42bC0xMy45LjNjLjUgMzIuNCAyIDU2IDQuNiA3My41IDIuNyAxNy42IDYuOCAyOS44IDEzLjEgMzkuMiA2LjMgOS4xIDE0LjYgMTUuMyAyNCAyMSA5LjQgNS42IDIwLjQgMTEuMiAzMy43IDIwLjF6bS03Ni4yLTEzNS40YzkuMyAwIDQ1LjMgMS42IDc2LjYtMjIuN2wtOC40LTExYy0yNy4yIDIxLjEtNTguNSAxOS45LTY4LjIgMTkuOXoiIGZpbGw9IiMzMzc1YmIiLz48L2c+PC9zdmc+";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTI4IDEyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PGNpcmNsZSBpZD0iYSIgY3g9IjU5LjkyOCIgY3k9IjU5LjkyOCIgcj0iNTkuOTI4Ii8+PGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIwJSIgeDI9IjUwJSIgeTI9IjEwMCUiIGlkPSJjIj48c3RvcCBzdG9wLWNvbG9yPSIjMkU2NkY4IiBvZmZzZXQ9IjAlIi8+PHN0b3Agc3RvcC1jb2xvcj0iIzEyNEFEQiIgb2Zmc2V0PSIxMDAlIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTAgMGgxMjh2MTI4SDB6Ii8+PHBhdGggZD0iTTAgMGgxMjh2MTI4SDB6Ii8+PHBhdGggZD0iTTE5IDY0YzAgMjQuODUzIDIwLjE0NyA0NSA0NSA0NXM0NS0yMC4xNDcgNDUtNDUtMjAuMTQ3LTQ1LTQ1LTQ1LTQ1IDIwLjE0Ny00NSA0NXptMzMuNS0xNC41YTMgMyAwIDAgMC0zIDN2MjNhMyAzIDAgMCAwIDMgM2gyM2EzIDMgMCAwIDAgMy0zdi0yM2EzIDMgMCAwIDAtMy0zaC0yM3oiIGZpbGw9IiNGRkYiLz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0IDQpIj48bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+PHVzZSB4bGluazpocmVmPSIjYSIvPjwvbWFzaz48ZyBtYXNrPSJ1cmwoI2IpIj48cGF0aCBkPSJNMCAwaDExOS44NTZ2MTE5Ljg1NkgweiIvPjxyZWN0IGZpbGw9InVybCgjYykiIGZpbGwtcnVsZT0ibm9uemVybyIgd2lkdGg9IjExOS44NTYiIGhlaWdodD0iMTE5Ljg1NiIgcng9IjQ4Ii8+PHBhdGggZD0iTTI0Ljk3IDU5LjkyOGMwIDE5LjMwNyAxNS42NTEgMzQuOTU4IDM0Ljk1OCAzNC45NThzMzQuOTU4LTE1LjY1MSAzNC45NTgtMzQuOTU4Uzc5LjIzNSAyNC45NyA1OS45MjggMjQuOTcgMjQuOTcgNDAuNjIgMjQuOTcgNTkuOTI4em0yNi4wMjQtMTEuMjY0YTIuMzMgMi4zMyAwIDAgMC0yLjMzIDIuMzN2MTcuODY4YTIuMzMgMi4zMyAwIDAgMCAyLjMzIDIuMzNoMTcuODY4YTIuMzMgMi4zMyAwIDAgMCAyLjMzLTIuMzNWNTAuOTk0YTIuMzMgMi4zMyAwIDAgMC0yLjMzLTIuMzNINTAuOTk0eiIgZmlsbD0iI0ZGRiIvPjwvZz48L2c+PC9nPjwvc3ZnPg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA2NCA2NCIgdmlld0JveD0iMCAwIDY0IDY0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48bGluZWFyR3JhZGllbnQgaWQ9ImEiIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoMjMuOTg2NiAwIDAgLTE2Ljk0NiA2NTk3LjEzNTMgNTY5NS40OTA3KSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSItMjcyLjUyNzIiIHgyPSItMjc1LjEyMDciIHkxPSIzMzUuNTUzMiIgeTI9IjMzMi45NTk3Ij48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMxMWM0ZDEiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwMDYyYWQiLz48L2xpbmVhckdyYWRpZW50PjxwYXRoIGQ9Im02My44IDEwLjljMi4xIDI4LjYtMTYuMiA0Mi4xLTMyLjcgNDMuNi0xNS4zIDEuMy0yOS43LTguMS0zMS0yMi41LTEtMTEuOSA2LjMtMTcgMTIuMS0xNy41IDYtLjUgMTEgMy42IDExLjQgOC42LjQgNC44LTIuNiA3LTQuNiA3LjItMS42LjEtMy43LS45LTMuOS0zLS4yLTEuOC41LTIuMS40LTQtLjMtMy41LTMuMy0zLjktNS0zLjctMiAuMi01LjcgMi41LTUuMSA4LjQuNSA1LjkgNi4yIDEwLjYgMTMuNiA5LjkgOC0uNyAxMy42LTYuOSAxNC0xNS43IDAtLjUuMS0uOS4zLTEuMy4xLS4yLjItLjQuMy0uNS4yLS4zLjQtLjUuNy0uOC4yLS4yLjUtLjUuNy0uOCAzLjUtMy4zIDE2LjEtMTEuMSAyOC04LjYuNC0uMi44LjIuOC43IiBmaWxsPSJ1cmwoI2EpIi8+PC9zdmc+";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMDAwIiBoZWlnaHQ9IjIwMDAiPjxjaXJjbGUgY3g9IjEwMDAiIGN5PSIxMDAwIiByPSIxMDAwIiBmaWxsPSIjNWI2ZGVlIi8+PHBhdGggZD0iTTgzMS4yNyA5MzguNzlhNTcxLjUgNTcxLjUgMCAwIDAtMTA0IDguOTVjMjguMjUtMjYxLjI4IDI0Ni00NTkuMTIgNTA1LjI0LTQ1OS4xIDE1OC43MyAwIDI2Ny40OSA3Ny43MiAyNjcuNDkgMjM4LjY0cy0xMzAuNTQgMjM4LjY0LTMyMSAyMzguNjRjLTE0MC41OC0uMDEtMjA3LjEzLTI3LjEzLTM0Ny43My0yNy4xM20tMTAuMjcgOTUuM2MtMTkwLjQ1IDAtMzIxIDc3LjcyLTMyMSAyMzguNjRzMTA4Ljc2IDIzOC42NCAyNjcuNDkgMjM4LjY0YzI1OS4yNyAwIDQ3Ny0xOTcuODIgNTA1LjI0LTQ1OS4xYTU3MS41IDU3MS41IDAgMCAxLTEwNCA4Ljk1Yy0xNDAuNi0uMDEtMjA3LjE1LTI3LjEzLTM0Ny43My0yNy4xMyIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2Vsb19SaW5ncyIgZGF0YS1uYW1lPSJDZWxvIFJpbmdzIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5NTAgOTUwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZiY2M1Yzt9LmNscy0ye2ZpbGw6IzM1ZDA3Zjt9LmNscy0ze2ZpbGw6IzVlYTMzYjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFydGJvYXJkIDE8L3RpdGxlPjxwYXRoIGlkPSJCb3R0b21fUmluZyIgZGF0YS1uYW1lPSJCb3R0b20gUmluZyIgY2xhc3M9ImNscy0xIiBkPSJNMzc1LDg1MGMxNTEuODgsMCwyNzUtMTIzLjEyLDI3NS0yNzVTNTI2Ljg4LDMwMCwzNzUsMzAwLDEwMCw0MjMuMTIsMTAwLDU3NSwyMjMuMTIsODUwLDM3NSw4NTBabTAsMTAwQzE2Ny45LDk1MCwwLDc4Mi4xLDAsNTc1UzE2Ny45LDIwMCwzNzUsMjAwLDc1MCwzNjcuOSw3NTAsNTc1LDU4Mi4xLDk1MCwzNzUsOTUwWiIvPjxwYXRoIGlkPSJUb3BfUmluZyIgZGF0YS1uYW1lPSJUb3AgUmluZyIgY2xhc3M9ImNscy0yIiBkPSJNNTc1LDY1MGMxNTEuODgsMCwyNzUtMTIzLjEyLDI3NS0yNzVTNzI2Ljg4LDEwMCw1NzUsMTAwLDMwMCwyMjMuMTIsMzAwLDM3NSw0MjMuMTIsNjUwLDU3NSw2NTBabTAsMTAwYy0yMDcuMSwwLTM3NS0xNjcuOS0zNzUtMzc1UzM2Ny45LDAsNTc1LDAsOTUwLDE2Ny45LDk1MCwzNzUsNzgyLjEsNzUwLDU3NSw3NTBaIi8+PHBhdGggaWQ9IlJpbmdzX092ZXJsYXAiIGRhdGEtbmFtZT0iUmluZ3MgT3ZlcmxhcCIgY2xhc3M9ImNscy0zIiBkPSJNNTg3LjM5LDc1MGEyNzQuMzgsMjc0LjM4LDAsMCwwLDU0LjU1LTEwOC4wNkEyNzQuMzYsMjc0LjM2LDAsMCwwLDc1MCw1ODcuNGEzNzMuNjMsMzczLjYzLDAsMCwxLTI5LjE2LDEzMy40NUEzNzMuNjIsMzczLjYyLDAsMCwxLDU4Ny4zOSw3NTBaTTMwOC4wNiwzMDguMDZBMjc0LjM2LDI3NC4zNiwwLDAsMCwyMDAsMzYyLjZhMzczLjYzLDM3My42MywwLDAsMSwyOS4xNi0xMzMuNDVBMzczLjYyLDM3My42MiwwLDAsMSwzNjIuNjEsMjAwLDI3NC4zOCwyNzQuMzgsMCwwLDAsMzA4LjA2LDMwOC4wNloiLz48L3N2Zz4=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDg2IiBoZWlnaHQ9IjQ4NiIgdmlld0JveD0iMCAwIDQ4NiA0ODYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0ODYiIGhlaWdodD0iNDg2IiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI0MyA0ODZDMzc3LjIwNSA0ODYgNDg2IDM3Ny4yMDUgNDg2IDI0M0M0ODYgMTA4Ljc5NSAzNzcuMjA1IDAgMjQzIDBDMTA4Ljc5NSAwIDAgMTA4Ljc5NSAwIDI0M0MwIDM3Ny4yMDUgMTA4Ljc5NSA0ODYgMjQzIDQ4NlpNMzc4IDEwOEgxMDhWMzc4SDM3OFYxMDhaIiBmaWxsPSIjMEExMjFFIi8+Cjwvc3ZnPgo=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0ibG9nby1yaXBpby1wb3J0YWwiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPgogIDxwYXRoIGlkPSJjb250YWluZXIiIGQ9Ik0zMiwxNkExNiwxNiwwLDEsMSwxNiwwLDE2LDE2LDAsMCwxLDMyLDE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIiBmaWxsPSIjNjRmZmI1Ii8+CiAgPHBhdGggaWQ9ImlzbyIgZD0iTTc0LjA4LDYwLjA1NmwtMTIuMTY4LDQuOVY1My4zNjVsMTIuMTg4LTQuOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01Mi4wMDYgLTQwLjcxMSkiIGZpbGw9IiMyNjI2M2YiLz4KPC9zdmc+Cg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl82MTU3XzEzMDQ5MykiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMS43NDkyIDYuNzVIMTQuMjQ5M1YxNC4zMjgzSDYuNzVWMjEuOTA3MkgxNC4yNDkzVjI5LjI1MDZIMjEuNzQ5MlYyMS42NzE3SDE0LjI1VjE0LjMyODlIMjEuNzQ5MlY2Ljc1Wk0yOS4yNTAyIDE0LjMyODNIMjEuNzUwMlYyMS45MDcySDI5LjI1MDJWMTQuMzI4M1oiIGZpbGw9ImJsYWNrIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNjE1N18xMzA0OTMiIHgxPSIzNiIgeTE9Ii0yLjE0NTc3ZS0wNiIgeDI9IjIuMTQ1NzdlLTA2IiB5Mj0iMzYiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjM5NTgzMyIgc3RvcC1jb2xvcj0iI0E5RkZFMCIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM4NkQ1RkYiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzQwOF8yMjUpIj4KPHBhdGggZD0iTTEwNDEuNTIgMEgtMjdWMTAyNEgxMDQxLjUyVjBaIiBmaWxsPSIjMjk4MEZFIi8+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF80MDhfMjI1KSI+CjxwYXRoIGQ9Ik00MDYuNzk2IDQzOC42NDNINDA2LjkyN0M0MDYuNzk2IDQzNy44NTcgNDA2Ljc5NiA0MzYuOTQgNDA2Ljc5NiA0MzYuMTU0VjQzOC42NDNaIiBmaWxsPSIjMjlBRUZGIi8+CjxwYXRoIGQ9Ik02NjcuNjAyIDQ2My41MzNINTIzLjI0OVY3MjQuMDc2QzUyMy4yNDkgNzM2LjM4OSA1MzMuMjA0IDc0Ni4zNDUgNTQ1LjUxNyA3NDYuMzQ1SDY0NS4zMzNDNjU3LjY0NyA3NDYuMzQ1IDY2Ny42MDIgNzM2LjM4OSA2NjcuNjAyIDcyNC4wNzZWNDYzLjUzM1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik00NTMuNTYzIDI3N0g0NDguNzE2SDE5MC4yNjlDMTc3Ljk1NSAyNzcgMTY4IDI4Ni45NTUgMTY4IDI5OS4yNjlWMzg5LjY1M0MxNjggNDAxLjk2NyAxNzcuOTU1IDQxMS45MjIgMTkwLjI2OSA0MTEuOTIySDI1MC45MThIMjc1LjAyMVY0MzguNjQ0VjcyNC43MzFDMjc1LjAyMSA3MzcuMDQ1IDI4NC45NzYgNzQ3IDI5Ny4yODkgNzQ3SDM5Mi4xMjhDNDA0LjQ0MSA3NDcgNDE0LjM5NiA3MzcuMDQ1IDQxNC4zOTYgNzI0LjczMVY0MzguNjQ0VjQzNi4xNTZWNDExLjkyMkg0MzguNDk5SDQ0OC4zMjNINDUzLjE3QzQ5MC4zNzIgNDExLjkyMiA1MjAuNjMxIDM4MS42NjMgNTIwLjYzMSAzNDQuNDYxQzUyMS4wMjQgMzA3LjI1OSA0OTAuNzY1IDI3NyA0NTMuNTYzIDI3N1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik02NjcuNzM1IDQ2My41MzNWNjQ1LjM1QzY3Mi43MTMgNjQ2LjUyOSA2NzcuODIxIDY0Ny40NDYgNjgzLjA2MSA2NDguMjMyQzY5MC4zOTcgNjQ5LjI4IDY5Ny45OTQgNjQ5LjkzNSA3MDUuNTkyIDY1MC4wNjZDNzA1Ljk4NSA2NTAuMDY2IDcwNi4zNzggNjUwLjA2NiA3MDYuOTAyIDY1MC4wNjZWNTA1LjQ1QzY4NS4wMjYgNTA0LjAwOSA2NjcuNzM1IDQ4NS44MDEgNjY3LjczNSA0NjMuNTMzWiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzQwOF8yMjUpIi8+CjxwYXRoIGQ9Ik03MDkuNzgxIDI3N0M2MDYuODIyIDI3NyA1MjMuMjQ5IDM2MC41NzMgNTIzLjI0OSA0NjMuNTMzQzUyMy4yNDkgNTUyLjA4NCA1ODQuOTQ2IDYyNi4yMjUgNjY3LjczMyA2NDUuMzVWNDYzLjUzM0M2NjcuNzMzIDQ0MC4zNDcgNjg2LjU5NiA0MjEuNDg0IDcwOS43ODEgNDIxLjQ4NEM3MzIuOTY3IDQyMS40ODQgNzUxLjgzIDQ0MC4zNDcgNzUxLjgzIDQ2My41MzNDNzUxLjgzIDQ4My4wNTEgNzM4LjYgNDk5LjQyNSA3MjAuNTIzIDUwNC4xNEM3MTcuMTE3IDUwNS4wNTcgNzEzLjQ0OSA1MDUuNTgxIDcwOS43ODEgNTA1LjU4MVY2NTAuMDY2QzcxMy40NDkgNjUwLjA2NiA3MTYuOTg2IDY0OS45MzUgNzIwLjUyMyA2NDkuODA0QzgxOC41MDUgNjQ0LjE3MSA4OTYuMzE0IDU2Mi45NTYgODk2LjMxNCA0NjMuNTMzQzg5Ni40NDUgMzYwLjU3MyA4MTIuODcyIDI3NyA3MDkuNzgxIDI3N1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik03MDkuNzggNjUwLjA2NlY1MDUuNTgxQzcwOC43MzMgNTA1LjU4MSA3MDcuODE2IDUwNS41ODEgNzA2Ljc2OCA1MDUuNDVWNjUwLjA2NkM3MDcuODE2IDY1MC4wNjYgNzA4Ljg2NCA2NTAuMDY2IDcwOS43OCA2NTAuMDY2WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8L2c+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNDA4XzIyNSIgeDE9IjcwOS44NDQiIHkxPSI1NTYuODI3IiB4Mj0iNjY3Ljc1MyIgeTI9IjU1Ni44MjciIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0id2hpdGUiLz4KPHN0b3Agb2Zmc2V0PSIwLjk2NjciIHN0b3AtY29sb3I9IndoaXRlIiBzdG9wLW9wYWNpdHk9IjAuMzIzMyIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IndoaXRlIiBzdG9wLW9wYWNpdHk9IjAuMyIvPgo8L2xpbmVhckdyYWRpZW50Pgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzQwOF8yMjUiPgo8cmVjdCB3aWR0aD0iNzI4LjQ0OCIgaGVpZ2h0PSI0NzAiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjggMjc3KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNy41Mjg2MiA5Ljc1VjE1Ljk2NDZDNy41Mjg2MiAxNi40NzA2IDcuOTE5NjUgMTYuODU2NSA4LjQyNTQgMTYuODU2NUgxNS43NjIxQzE2LjI2NzkgMTYuODU2NSAxNi42NTg5IDE2LjQ3MDYgMTYuNjU4OSAxNS45NjQ2VjEwLjc1MjRIMTcuNjI1VjE1Ljk2NDZDMTcuNjI1IDE2Ljk5NTYgMTYuODA0NSAxNy44MTI1IDE1Ljc2MjEgMTcuODEyNUg4LjQyNTRDNy4zODMwNCAxNy44MTI1IDYuNTYyNSAxNi45OTU2IDYuNTYyNSAxNS45NjQ2VjkuNzVINy41Mjg2MloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi41NjI1IDguMjIyNTFDNi41NjI1IDcuMTkxNzYgNy4zODMwNCA2LjM3NSA4LjQyNTQgNi4zNzVIMTUuOTA4NlY4LjY0NjU3SDE2LjEzMjNDMTYuOTcyNyA4LjY0NjU3IDE3LjYyNSA5LjI5NjMxIDE3LjYyNSAxMC4xMjY2VjEwLjg5NDlDMTcuNjI1IDExLjcyNTMgMTYuOTcyNyAxMi4zNzUgMTYuMTMyMyAxMi4zNzVIOC40MjU0QzcuMzgzMDQgMTIuMzc1IDYuNTYyNSAxMS41NTgyIDYuNTYyNSAxMC41Mjc1VjguMjIyNTFaTTE0Ljk0MjUgOC42NDY1N1Y3LjMzMDc3SDguNDI1NEM3LjkxOTY1IDcuMzMwNzcgNy41Mjg2MiA3LjcxNjYxIDcuNTI4NjIgOC4yMjI1MVYxMC41Mjc1QzcuNTI4NjIgMTEuMDMzNCA3LjkxOTY1IDExLjQxOTIgOC40MjU0IDExLjQxOTJIMTEuNjEwN1Y4LjY0NjU3SDE0Ljk0MjVaTTEyLjU3NjggMTEuNDE5MkgxNi4xMzIzQzE2LjQzNjEgMTEuNDE5MiAxNi42NTg5IDExLjIwMDQgMTYuNjU4OSAxMC44OTQ5VjEwLjEyNjZDMTYuNjU4OSA5LjgyMTE1IDE2LjQzNjEgOS42MDIzNSAxNi4xMzIzIDkuNjAyMzVIMTIuNTc2OFYxMS40MTkyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMTQwLjhDMCA5MS41MTU0IDAgNjYuODczMSA5LjU5MTQzIDQ4LjA0ODhDMTguMDI4MyAzMS40OTA2IDMxLjQ5MDYgMTguMDI4MyA0OC4wNDg4IDkuNTkxNDNDNjYuODczMSAwIDkxLjUxNTQgMCAxNDAuOCAwSDM3MS4yQzQyMC40ODUgMCA0NDUuMTI3IDAgNDYzLjk1MSA5LjU5MTQzQzQ4MC41MDkgMTguMDI4MyA0OTMuOTcyIDMxLjQ5MDYgNTAyLjQwOSA0OC4wNDg4QzUxMiA2Ni44NzMxIDUxMiA5MS41MTU0IDUxMiAxNDAuOFYzNzEuMkM1MTIgNDIwLjQ4NSA1MTIgNDQ1LjEyNyA1MDIuNDA5IDQ2My45NTFDNDkzLjk3MiA0ODAuNTA5IDQ4MC41MDkgNDkzLjk3MiA0NjMuOTUxIDUwMi40MDlDNDQ1LjEyNyA1MTIgNDIwLjQ4NSA1MTIgMzcxLjIgNTEySDE0MC44QzkxLjUxNTQgNTEyIDY2Ljg3MzEgNTEyIDQ4LjA0ODggNTAyLjQwOUMzMS40OTA2IDQ5My45NzIgMTguMDI4MyA0ODAuNTA5IDkuNTkxNDMgNDYzLjk1MUMwIDQ0NS4xMjcgMCA0MjAuNDg1IDAgMzcxLjJWMTQwLjhaIiBmaWxsPSIjMjk2MkVGIi8+CjxwYXRoIGQ9Ik0xMTEuMDQ4IDEyOEMxMDIuMjc0IDEyOCA5OC44OTMxIDEzOC44NSAxMDYuMjU2IDE0My4zODJMMjkwLjQ0MyAyNTQuNDQxQzI5NS4wMzQgMjU3LjI2NyAzMDEuMTU3IDI1Ni4xNSAzMDQuMzE5IDI1MS45MDlMMzg1LjMwMSAxNDUuNTk0QzM5MC44MDcgMTM4LjIwOCAzODUuMjQ0IDEyOCAzNzUuNzEzIDEyOEgxMTEuMDQ4WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTQwMC41MzggMzg0QzQwOS4zMTEgMzg0IDQxMi43OCAzNzMuMDkyIDQwNS40MTkgMzY4LjU2MUwyMjEuMTc4IDI1Ny41MTZDMjE2LjU4NyAyNTQuNjkgMjEwLjYxMiAyNTUuOTQ4IDIwNy40NTIgMjYwLjE4OEwxMjYuMzEyIDM2Ni40ODJDMTIwLjgwOCAzNzMuODY2IDEyNi41NDUgMzg0IDEzNi4wNzQgMzg0SDQwMC41MzhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgdmlld0JveD0iMCAwIDEyOCAxMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjY0IiBjeT0iNjQiIHI9IjY0IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CjxwYXRoIGQ9Ik0xMTAuNTg0IDY0LjkxNDJIOTkuMTQyQzk5LjE0MiA0MS43NjUxIDgwLjE3MyAyMyA1Ni43NzI0IDIzQzMzLjY2MTIgMjMgMTQuODcxNiA0MS4zMDU3IDE0LjQxMTggNjQuMDU4M0MxMy45MzYgODcuNTc3IDM2LjI0MSAxMDggNjAuMDE4NiAxMDhINjMuMDA5NEM4My45NzIzIDEwOCAxMTIuMDY5IDkxLjc2NjcgMTE2LjQ1OSA3MS45ODc0QzExNy4yNyA2OC4zNDEzIDExNC4zNTggNjQuOTE0MiAxMTAuNTg0IDY0LjkxNDJaTTM5Ljc2ODkgNjUuOTQ1NEMzOS43Njg5IDY5LjA0MTEgMzcuMjA5NSA3MS41NzI5IDM0LjA4MDIgNzEuNTcyOUMzMC45NTA5IDcxLjU3MjkgMjguMzkxNiA2OS4wMzk5IDI4LjM5MTYgNjUuOTQ1NFY1Ni44NDE0QzI4LjM5MTYgNTMuNzQ1NyAzMC45NTA5IDUxLjIxMzkgMzQuMDgwMiA1MS4yMTM5QzM3LjIwOTUgNTEuMjEzOSAzOS43Njg5IDUzLjc0NTcgMzkuNzY4OSA1Ni44NDE0VjY1Ljk0NTRaTTU5LjUyMjQgNjUuOTQ1NEM1OS41MjI0IDY5LjA0MTEgNTYuOTYzMSA3MS41NzI5IDUzLjgzMzggNzEuNTcyOUM1MC43MDQ1IDcxLjU3MjkgNDguMTQ1MSA2OS4wMzk5IDQ4LjE0NTEgNjUuOTQ1NFY1Ni44NDE0QzQ4LjE0NTEgNTMuNzQ1NyA1MC43MDU2IDUxLjIxMzkgNTMuODMzOCA1MS4yMTM5QzU2Ljk2MzEgNTEuMjEzOSA1OS41MjI0IDUzLjc0NTcgNTkuNTIyNCA1Ni44NDE0VjY1Ljk0NTRaIiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXIpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSI2NCIgeTE9IjAiIHgyPSI2NCIgeTI9IjEyOCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNTM0QkIxIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzU1MUJGOSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXIiIHgxPSI2NS40OTk4IiB5MT0iMjMiIHgyPSI2NS40OTk4IiB5Mj0iMTA4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IndoaXRlIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0id2hpdGUiIHN0b3Atb3BhY2l0eT0iMC44MiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.STARZWALLET = t.BITKEEPWALLET = t.WEB3AUTH = t.OPERA = t.SEQUENCE = t.COINBASEWALLET = t.WALLETLINK = t.BINANCECHAINWALLET = t.FRAME = t.BITSKI = t.LEDGER = t.DCENT = t.MEWCONNECT = t.BURNERCONNECT = t.AUTHEREUM = t.VENLY = t.TORUS = t.FORTMATIC = t.PORTIS = t.WALLETCONNECT = void 0;
            var i = n(0), r = i.__importDefault(n(95)), M = i.__importDefault(n(96)), u = i.__importDefault(n(97)), o = i.__importDefault(n(98)), c = i.__importDefault(n(99)), a = i.__importDefault(n(100)), I = i.__importDefault(n(101)), l = i.__importDefault(n(102)), N = i.__importDefault(n(103)), j = i.__importDefault(n(104)), g = i.__importDefault(n(105)), s = i.__importDefault(n(13)), A = i.__importDefault(n(14)), D = i.__importDefault(n(106)), d = i.__importDefault(n(107)), T = i.__importDefault(n(108)), y = i.__importDefault(n(15)), z = i.__importDefault(n(16)), w = i.__importDefault(n(109));
            i.__exportStar(n(12), t), t.WALLETCONNECT = {
                id: "walletconnect",
                name: "WalletConnect",
                logo: r.default,
                type: "qrcode",
                check: "isWalletConnect",
                package: {
                    required: [
                        [
                            "infuraId",
                            "rpc"
                        ]
                    ]
                }
            }, t.PORTIS = {
                id: "portis",
                name: "Portis",
                logo: M.default,
                type: "web",
                check: "isPortis",
                package: {
                    required: [
                        "id"
                    ]
                }
            }, t.FORTMATIC = {
                id: "fortmatic",
                name: "Fortmatic",
                logo: u.default,
                type: "web",
                check: "isFortmatic",
                package: {
                    required: [
                        "key"
                    ]
                }
            }, t.TORUS = {
                id: "torus",
                name: "Torus",
                logo: c.default,
                type: "web",
                check: "isTorus"
            }, t.VENLY = {
                id: "venly",
                name: "Venly",
                logo: o.default,
                type: "web",
                check: "isVenly",
                package: {
                    required: [
                        "clientId"
                    ]
                }
            }, t.AUTHEREUM = {
                id: "authereum",
                name: "Authereum",
                logo: a.default,
                type: "web",
                check: "isAuthereum"
            }, t.BURNERCONNECT = {
                id: "burnerconnect",
                name: "Burner Connect",
                logo: I.default,
                type: "web",
                check: "isBurnerProvider"
            }, t.MEWCONNECT = {
                id: "mewconnect",
                name: "MEW wallet",
                logo: l.default,
                type: "qrcode",
                check: "isMEWconnect",
                package: {
                    required: [
                        [
                            "infuraId",
                            "rpc"
                        ]
                    ]
                }
            }, t.DCENT = {
                id: "dcentwallet",
                name: "D'CENT",
                logo: N.default,
                type: "hardware",
                check: "isDcentWallet",
                package: {
                    required: [
                        "rpcUrl"
                    ]
                }
            }, t.LEDGER = {
                id: "ledger",
                name: "Ledger",
                logo: j.default,
                type: "hardware",
                check: "isLedgerConnect"
            }, t.BITSKI = {
                id: "bitski",
                name: "Bitski",
                logo: g.default,
                type: "web",
                check: "isBitski",
                package: {
                    required: [
                        "clientId",
                        "callbackUrl"
                    ]
                }
            }, t.FRAME = {
                id: "frame",
                name: "Frame",
                logo: A.default,
                type: "web",
                check: "isFrameNative"
            }, t.BINANCECHAINWALLET = {
                id: "binancechainwallet",
                name: "Binance Chain",
                logo: D.default,
                type: "injected",
                check: "isBinanceChainWallet"
            }, t.WALLETLINK = {
                id: "walletlink",
                name: "Coinbase Wallet",
                logo: d.default,
                type: "qrcode",
                check: "isWalletLink",
                package: {
                    required: [
                        [
                            "appName",
                            "infuraId",
                            "rpc"
                        ]
                    ]
                }
            }, t.COINBASEWALLET = {
                id: "coinbasewallet",
                name: "Coinbase",
                logo: d.default,
                type: "injected",
                check: "isWalletLink",
                package: {
                    required: [
                        [
                            "appName",
                            "infuraId",
                            "rpc"
                        ]
                    ]
                }
            }, t.SEQUENCE = {
                id: "sequence",
                name: "Sequence",
                logo: y.default,
                type: "web",
                check: "isSequenceWeb"
            }, t.OPERA = {
                id: "opera",
                name: "Opera",
                logo: s.default,
                type: "injected",
                check: "isOpera"
            }, t.WEB3AUTH = {
                id: "web3auth",
                name: "Web3Auth",
                logo: T.default,
                type: "injected",
                check: "isWeb3Auth"
            }, t.BITKEEPWALLET = {
                id: "bitkeep",
                name: "Bitkeep Wallet",
                logo: z.default,
                type: "injected",
                check: "isBitKeep"
            }, t.STARZWALLET = {
                id: "starzwallet",
                name: "99Starz",
                logo: w.default,
                type: "injected",
                check: "isStarzWallet"
            };
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjYzIiB2aWV3Qm94PSIwIDAgNjMgNjMiIHdpZHRoPSI2MyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im0zMS42MzkzLjk4NDM3NWgxNS4zMjc0IDE1LjMyNzV2MTUuMjk5MDI1aC0xNS4zMjc1LTE1LjMyNzQtMTUuMzI3NXYxNS4yOTg5Ljk4MSAxNC4yMjg5LjA4OTEgMTUuMjA5OWgtMTUuMzI3NDI1di0xNS4yMDk5LS4wODkxLTE0LjIyODktLjk4MS0xNS4yOTg5LTE1LjI5OTAyNWgxNS4zMjc0MjV6bTE1LjMyNzQgNDUuODA4MzI1aC0xNS4yMzgxdi0xNS4yMDk4aDMwLjU1NjZ2MTUuNzQ0OWMwIDMuOTE0LTEuNTU3MSA3LjY2OC00LjMyOTEgMTAuNDM2NXMtNi41MzE5IDQuMzI1LTEwLjQ1MzMgNC4zMjc0aC0uNTM2MXoiIGZpbGw9IiM2MTdiZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYwIiBoZWlnaHQ9IjUxNyIgdmlld0JveD0iMCAwIDU2MCA1MTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01NTQuNTU1IDE2OS4yNzZMNDg1Ljg2NyAxOTUuMzY1QzQ4Mi45NzkgMTk2LjQxNSA0ODAuMTc5IDE5My42MTQgNDgxLjQwNCAxOTAuNzI1TDU1Ny45NjggNC44NjA4M0M1NTkuMTA1IDIuMDU5MyA1NTYuMzkzIC0wLjgyOTc3OCA1NTMuNTkzIDAuMjIwNzk1TDQwOC4wNzggNTEuMTczNkM0MDUuMjc4IDUyLjEzNjYgNDAzLjAwMyA1NC4zMjUzIDQwMS44NjYgNTcuMTI2OEwzMDMuMjUyIDMwNi4wMjVDMzAyLjAyNyAzMDkuMTc3IDMwNS4wODkgMzEyLjMyOSAzMDguMjM5IDMxMS4xOUwzNjkuODQgMjg4LjYwM0MzNzMuMjUzIDI4Ny4zNzcgMzc2LjQwMyAyOTEuMDU0IDM3NC41NjUgMjk0LjI5NEwyODQuMDg5IDQ0Ny45NEMyODIuMTY0IDQ1MS4yNjcgMjc3LjI2NCA0NTEuMjY3IDI3NS4zMzkgNDQ3Ljk0TDE4NC44NjMgMjk0LjIwNkMxODMuMDI1IDI5MS4wNTQgMTg2LjA4OCAyODcuMjkgMTg5LjU4OCAyODguNTE2TDI1MS4xODkgMzExLjEwM0MyNTQuMzM5IDMxMi4yNDEgMjU3LjQwMSAzMDkuMDg5IDI1Ni4xNzYgMzA1LjkzOEwxNTcuNDc1IDU3LjEyNjhDMTU2LjMzNyA1NC4zMjUzIDE1NC4xNSA1Mi4yMjQyIDE1MS4yNjIgNTEuMTczNkw1LjkyMjY3IDAuMjIwNzk1QzMuMDM1MTMgLTAuNzQyMjMgMC40MTAwOTIgMi4wNTkzIDEuNTQ3NjEgNC44NjA4M0w3OC4wMjM3IDE5MC43MjVDNzkuMTYxMiAxOTMuNTI2IDc2LjM2MTIgMTk2LjQxNSA3My41NjExIDE5NS4zNjVMNS4zMTAxNiAxNjkuMjc2QzEuODEwMTEgMTY3Ljk2MiAtMS4zMzk5MyAxNzEuNzI3IDAuNTg1MDk1IDE3NC45NjZMMjAzLjc2MyA1MTEuNUMyMDUuNzc1IDUxNC44MjYgMjA5LjM2MyA1MTYuODQgMjEzLjMwMSA1MTYuODRIMzQ2LjQ3N0MzNTAuMzI4IDUxNi44NCAzNTQuMDAzIDUxNC44MjYgMzU2LjAxNSA1MTEuNUw1NTkuNTQzIDE3NC45NjZDNTYxLjIwNSAxNzEuNzI3IDU1OC4wNTUgMTY3Ljk2MiA1NTQuNTU1IDE2OS4yNzZaIiBmaWxsPSIjNzkyN0ZGIi8+Cjwvc3ZnPgo=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjU3IiBoZWlnaHQ9IjI3NyIgdmlld0JveD0iMCAwIDI1NyAyNzciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cmVjdCB3aWR0aD0iMTUzLjg4OSIgaGVpZ2h0PSI4Mi4wNzQxIiBmaWxsPSIjMDM2NEZGIiAvPgogICAgPHJlY3QgeD0iNzEuODEzNSIgd2lkdGg9IjgyLjA3NDEiIGhlaWdodD0iMjc3IiBmaWxsPSIjMDM2NEZGIiAvPgogICAgPHBhdGggZD0iTTIxNS40NDMgODIuMDc0MUMyMzguMTA3IDgyLjA3NDEgMjU2LjQ4IDYzLjcwMTIgMjU2LjQ4IDQxLjAzN0MyNTYuNDggMTguMzcyOSAyMzguMTA3IDAgMjE1LjQ0MyAwQzE5Mi43NzkgMCAxNzQuNDA2IDE4LjM3MjkgMTc0LjQwNiA0MS4wMzdDMTc0LjQwNiA2My43MDEyIDE5Mi43NzkgODIuMDc0MSAyMTUuNDQzIDgyLjA3NDFaIiBmaWxsPSIjMDM2NEZGIiAvPgo8L3N2Zz4=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGcgZmlsbD0iI2YwYjkwYiI+PHBhdGggZD0iTTIwLjI0NSAwTDkuNjM0IDYuMTI1bDMuOTAxIDIuMjYyIDYuNzEtMy44NjIgNi43MSAzLjg2MiAzLjkwMi0yLjI2MkwyMC4yNDUgMHptNi43MTEgMTEuNTg2bDMuOSAyLjI2M3Y0LjUyNmwtNi43MSAzLjg2MnY3LjcyNGwtMy45IDIuMjYzLTMuOTAyLTIuMjYzdi03LjcyNGwtNi43MS0zLjg2MnYtNC41MjZsMy45MDEtMi4yNjMgNi43MSAzLjg2MyA2LjcxLTMuODYzaC4wMDF6Ii8+PHBhdGggZD0iTTMwLjg1NyAyMS41NzNWMjYuMWwtMy45MDEgMi4yNjJ2LTQuNTI1bDMuOS0yLjI2My4wMDEtLjAwMXoiLz48cGF0aCBkPSJNMjYuOTE2IDMxLjU2bDYuNzEtMy44NjJ2LTcuNzI0bDMuOTAyLTIuMjYzdjEyLjI1bC0xMC42MTEgNi4xMjVWMzEuNTZoLS4wMDF6bTYuNzExLTE5LjMxbC0zLjkwMi0yLjI2MyAzLjkwMi0yLjI2MyAzLjkgMi4yNjN2NC41MjVsLTMuOSAyLjI2M1YxMi4yNXpNMTYuMzQ0IDM3LjcyNFYzMy4ybDMuOTAxIDIuMjYzIDMuOTAyLTIuMjYzdjQuNTI1bC0zLjkwMiAyLjI2My0zLjktMi4yNjMtLjAwMS0uMDAxem0tMi44MDktOS4zNjNMOS42MzQgMjYuMXYtNC41MjZsMy45MDEgMi4yNjN2NC41MjUtLjAwMXptNi43MS0xNi4xMTFsLTMuOS0yLjI2MyAzLjktMi4yNjMgMy45MDIgMi4yNjMtMy45MDIgMi4yNjN6bS05LjQ4LTIuMjYzbC0zLjkgMi4yNjN2NC41MjVsLTMuOTAyLTIuMjYzVjkuOTg3bDMuOTAxLTIuMjYzIDMuOTAxIDIuMjYzeiIvPjxwYXRoIGQ9Ik0yLjk2MyAxNy43MTFsMy45MDEgMi4yNjN2Ny43MjRsNi43MSAzLjg2MnY0LjUyNkwyLjk2MyAyOS45NlYxNy43MXYuMDAxeiIvPjwvZz48L3N2Zz4=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgdmlld0JveD0iMCAwIDEyOCAxMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjY0LjY4ODciIGN5PSI2NC42ODgyIiByPSI1OS4xODI4IiBmaWxsPSIjMDM2NEZGIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNODguODc0NiA4NS41NjEyQzg4LjQ3NCA4Ny4wNTYgODYuMzUzIDg3LjA1NiA4NS45NTI0IDg1LjU2MTJMODEuMjg3MyA2OC4xNTA2QzgxLjE5NzEgNjcuODEzOSA4MS4xOTcxIDY3LjQ1OTUgODEuMjg3MyA2Ny4xMjI5TDg1LjQyMTQgNTEuNjk0Qzg1Ljc4NjkgNTAuMzMwMSA4Ny4wMjI5IDQ5LjM4MTcgODguNDM0OSA0OS4zODE3SDk0LjUwMzFDOTYuNTU0NCA0OS4zODE3IDk4LjA0NzUgNTEuMzI3NSA5Ny41MTY1IDUzLjMwOUw4OC44NzQ2IDg1LjU2MTJaTTQ4Ljg0ODEgNjguMTIxNUM0OC45MzgzIDY3Ljc4NDkgNDguOTM4MyA2Ny40MzA1IDQ4Ljg0ODEgNjcuMDkzOEw0NC43MjE3IDUxLjY5NEM0NC4zNTYyIDUwLjMzMDEgNDMuMTIwMyA0OS4zODE3IDQxLjcwODIgNDkuMzgxN0gzNS42NDAxQzMzLjU4ODcgNDkuMzgxNyAzMi4wOTU2IDUxLjMyNzUgMzIuNjI2NiA1My4zMDlMNDEuMjYwNyA4NS41MzIxQzQxLjY2MTMgODcuMDI2OSA0My43ODI0IDg3LjAyNjkgNDQuMTgyOSA4NS41MzIxTDQ4Ljg0ODEgNjguMTIxNVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNjEuOTkwNyA4OS4wNjlDNjEuODU0IDg5LjU3OTMgNjIuMjM4NSA5MC4wODA1IDYyLjc2NjkgOTAuMDgwNUg2Ny4zOTQ3QzY3LjkyMzEgOTAuMDgwNSA2OC4zMDc3IDg5LjU3OTMgNjguMTcwOSA4OS4wNjlMNjUuODU3IDgwLjQzMzRDNjUuNjQ0MiA3OS42MzkyIDY0LjUxNzQgNzkuNjM5MiA2NC4zMDQ2IDgwLjQzMzRMNjEuOTkwNyA4OS4wNjlaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTU3LjM4MjkgOTQuNTk3OUM1Ny4wMjg1IDk1LjkyMDUgNTUuODMgOTYuODQwMiA1NC40NjA3IDk2Ljg0MDJINDguMTk2OEM0Ni4yMDc2IDk2Ljg0MDIgNDQuNzU5OCA5NC45NTMzIDQ1LjI3NDcgOTMuMDMxOUw1OC4xMjQ4IDQ1LjA3NDdDNTguNTEyNCA0My42MjgxIDU5LjgyMzMgNDIuNjIyMiA2MS4zMjA5IDQyLjYyMjJINjguNzc1N0M3MC4yNzMzIDQyLjYyMjIgNzEuNTg0MiA0My42MjgxIDcxLjk3MTggNDUuMDc0N0w4NC44MjIgOTMuMDMxOUM4NS4zMzY4IDk0Ljk1MzMgODMuODg5IDk2Ljg0MDIgODEuODk5OCA5Ni44NDAySDc1LjYzNTlDNzQuMjY2NiA5Ni44NDAyIDczLjA2ODEgOTUuOTIwNSA3Mi43MTM3IDk0LjU5NzlMNjYuNDYzNyA3MS4yNzI2QzY2LjA3NTcgNjkuODI0NSA2NC4wMjA5IDY5LjgyNDUgNjMuNjMyOSA3MS4yNzI2TDU3LjM4MjkgOTQuNTk3OVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNODguODkwOSA4NS41NjEyQzg4LjQ5MDMgODcuMDU2IDg2LjM2OTIgODcuMDU2IDg1Ljk2ODcgODUuNTYxMkw4MS4zMDM1IDY4LjE1MDZDODEuMjEzMyA2Ny44MTM5IDgxLjIxMzMgNjcuNDU5NSA4MS4zMDM1IDY3LjEyMjlMODcuMjQ4OSA0NC45MzQ1Qzg3LjYxNDQgNDMuNTcwNiA4OC44NTAzIDQyLjYyMjIgOTAuMjYyNCA0Mi42MjIySDk2LjMzMDVDOTguMzgxOSA0Mi42MjIyIDk5Ljg3NDkgNDQuNTY4IDk5LjM0NCA0Ni41NDk0TDg4Ljg5MDkgODUuNTYxMlpNNDguODY0MyA2OC4xMjE1QzQ4Ljk1NDUgNjcuNzg0OSA0OC45NTQ1IDY3LjQzMDUgNDguODY0MyA2Ny4wOTM4TDQyLjkyNjggNDQuOTM0NUM0Mi41NjEzIDQzLjU3MDYgNDEuMzI1MyA0Mi42MjIyIDM5LjkxMzMgNDIuNjIyMkgzMy44NDUxQzMxLjc5MzggNDIuNjIyMiAzMC4zMDA3IDQ0LjU2OCAzMC44MzE3IDQ2LjU0OTRMNDEuMjc3IDg1LjUzMjFDNDEuNjc3NiA4Ny4wMjY5IDQzLjc5ODYgODcuMDI2OSA0NC4xOTkyIDg1LjUzMjFMNDguODY0MyA2OC4xMjE1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Modal = void 0;
            var i, r, M, u, o = n(0), c = o.__importStar(n(1)), a = o.__importStar(n(112)), I = o.__importDefault(n(18)), l = n(19), N = n(2), j = I.default.div(i || (i = o.__makeTemplateObject([
                "\n  transition: opacity 0.1s ease-in-out;\n  text-align: center;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  margin-left: -50vw;\n  top: ",
                ";\n  left: 50%;\n  z-index: 2;\n  will-change: opacity;\n  background-color: ",
                ";\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & * {\n    box-sizing: border-box !important;\n  }\n"
            ], [
                "\n  transition: opacity 0.1s ease-in-out;\n  text-align: center;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  margin-left: -50vw;\n  top: ",
                ";\n  left: 50%;\n  z-index: 2;\n  will-change: opacity;\n  background-color: ",
                ";\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & * {\n    box-sizing: border-box !important;\n  }\n"
            ])), function(e) {
                var _$t = e.offset;
                return _$t ? "-" + _$t + "px" : 0;
            }, function(e) {
                var _$t = e.opacity, _$n = .4;
                return "number" == typeof _$t && (_$n = _$t), "rgba(0, 0, 0, " + _$n + ")";
            }, function(e) {
                return e.show ? 1 : 0;
            }, function(e) {
                return e.show ? "visible" : "hidden";
            }, function(e) {
                return e.show ? "auto" : "none";
            }), g = I.default.div(r || (r = o.__makeTemplateObject([
                "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n"
            ], [
                "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n"
            ])), function(e) {
                return e.show ? 1 : 0;
            }, function(e) {
                return e.show ? "visible" : "hidden";
            }, function(e) {
                return e.show ? "auto" : "none";
            }), s = I.default.div(M || (M = o.__makeTemplateObject([
                "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"
            ], [
                "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"
            ]))), A = I.default.div(u || (u = o.__makeTemplateObject([
                "\n  position: relative;\n  width: 100%;\n  background-color: ",
                ";\n  border-radius: 12px;\n  margin: 10px;\n  padding: 0;\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  max-width: ",
                ";\n  min-width: fit-content;\n  max-height: 100%;\n  overflow: auto;\n\n  @media screen and (max-width: 768px) {\n    max-width: ",
                ";\n    grid-template-columns: 1fr;\n  }\n"
            ], [
                "\n  position: relative;\n  width: 100%;\n  background-color: ",
                ";\n  border-radius: 12px;\n  margin: 10px;\n  padding: 0;\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  max-width: ",
                ";\n  min-width: fit-content;\n  max-height: 100%;\n  overflow: auto;\n\n  @media screen and (max-width: 768px) {\n    max-width: ",
                ";\n    grid-template-columns: 1fr;\n  }\n"
            ])), function(e) {
                return e.themeColors.background;
            }, function(e) {
                return e.show ? 1 : 0;
            }, function(e) {
                return e.show ? "visible" : "hidden";
            }, function(e) {
                return e.show ? "auto" : "none";
            }, function(e) {
                var _$t = e.maxWidth;
                return _$t ? _$t + "px" : "800px";
            }, function(e) {
                var _$t = e.maxWidth;
                return _$t ? _$t + "px" : "500px";
            }), D = {
                show: !1,
                lightboxOffset: 0
            }, d = function(e) {
                var _$t = function _$t(t) {
                    var _$n = e.call(this, t) || this;
                    return _$n.state = o.__assign({}, D), _$n.render = function() {
                        var _$e = _$n.state, _$t = _$e.show, i = _$e.lightboxOffset, r = _$n.props, M = r.onClose, u = r.lightboxOpacity, o = r.userOptions, a = r.themeColors;
                        return c.createElement(j, {
                            className: N.MODAL_LIGHTBOX_CLASSNAME,
                            offset: i,
                            opacity: u,
                            ref: function ref(e) {
                                return _$n.lightboxRef = e;
                            },
                            show: _$t
                        }, c.createElement(g, {
                            className: N.MODAL_CONTAINER_CLASSNAME,
                            show: _$t
                        }, c.createElement(s, {
                            className: N.MODAL_HITBOX_CLASSNAME,
                            onClick: M
                        }), c.createElement(A, {
                            className: N.MODAL_CARD_CLASSNAME,
                            show: _$t,
                            themeColors: a,
                            maxWidth: o.length < 3 ? 500 : 800,
                            ref: function ref(e) {
                                return _$n.mainModalCard = e;
                            }
                        }, o.map(function(e) {
                            return e ? c.createElement(l.Provider, {
                                name: e.name,
                                logo: e.logo,
                                description: e.description,
                                themeColors: a,
                                onClick: e.onClick
                            }) : null;
                        }))));
                    }, window.updateWeb3Modal = function(e) {
                        return o.__awaiter(_$n, void 0, void 0, function() {
                            return o.__generator(this, function(t) {
                                return this.setState(e), [
                                    2
                                ];
                            });
                        });
                    }, _$n;
                };
                return o.__extends(_$t, e), _$t.prototype.componentDidUpdate = function(e, t) {
                    if (t.show && !this.state.show && this.props.resetState(), this.lightboxRef) {
                        var _$n = this.lightboxRef.getBoundingClientRect(), i = _$n.top > 0 ? _$n.top : 0;
                        i !== D.lightboxOffset && i !== this.state.lightboxOffset && this.setState({
                            lightboxOffset: i
                        });
                    }
                }, _$t.propTypes = {
                    userOptions: a.object.isRequired,
                    onClose: a.func.isRequired,
                    resetState: a.func.isRequired,
                    lightboxOpacity: a.number.isRequired
                }, _$t;
            }(c.Component);
            t.Modal = d;
        },
        function(e, t, n) {
            e.exports = n(113)();
        },
        function(e, t, n) {
            "use strict";
            var r = function r() {};
            var M = function M() {};
            var i = n(114);
            M.resetWarningCache = r, e.exports = function() {
                var _$e = function _$e(e, t, n, r, M, u) {
                    if (u !== i) {
                        var o = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                        throw o.name = "Invariant Violation", o;
                    }
                };
                var t = function t() {
                    return _$e;
                };
                _$e.isRequired = _$e;
                var _$n = {
                    array: _$e,
                    bigint: _$e,
                    bool: _$e,
                    func: _$e,
                    number: _$e,
                    object: _$e,
                    string: _$e,
                    symbol: _$e,
                    any: _$e,
                    arrayOf: t,
                    element: _$e,
                    elementType: _$e,
                    instanceOf: t,
                    node: _$e,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t,
                    checkPropTypes: M,
                    resetWarningCache: r
                };
                return _$n.PropTypes = _$n, _$n;
            };
        },
        function(e, t, n) {
            "use strict";
            e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        },
        function(e, t, n) {
            "use strict";
            var z = function z(e) {
                if ("object" == typeof e && null !== e) {
                    var _$t = e.$$typeof;
                    switch(_$t){
                        case i:
                            switch(e = e.type){
                                case M:
                                case o:
                                case u:
                                case l:
                                case N:
                                    return e;
                                default:
                                    switch(e = e && e.$$typeof){
                                        case a:
                                        case I:
                                        case g:
                                        case j:
                                        case c:
                                            return e;
                                        default:
                                            return _$t;
                                    }
                            }
                        case r:
                            return _$t;
                    }
                }
            };
            /** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var i = 60103, r = 60106, M = 60107, u = 60108, o = 60114, c = 60109, a = 60110, I = 60112, l = 60113, N = 60120, j = 60115, g = 60116, s = 60121, A = 60122, D = 60117, d = 60129, T = 60131;
            if ("function" == typeof Symbol && Symbol.for) {
                var y = Symbol.for;
                i = y("react.element"), r = y("react.portal"), M = y("react.fragment"), u = y("react.strict_mode"), o = y("react.profiler"), c = y("react.provider"), a = y("react.context"), I = y("react.forward_ref"), l = y("react.suspense"), N = y("react.suspense_list"), j = y("react.memo"), g = y("react.lazy"), s = y("react.block"), A = y("react.server.block"), D = y("react.fundamental"), d = y("react.debug_trace_mode"), T = y("react.legacy_hidden");
            }
            var w = c, f = i, L = I, E = M, C = g, x = j, p = r, S = o, m = u, O = l;
            t.ContextConsumer = a, t.ContextProvider = w, t.Element = f, t.ForwardRef = L, t.Fragment = E, t.Lazy = C, t.Memo = x, t.Portal = p, t.Profiler = S, t.StrictMode = m, t.Suspense = O, t.isAsyncMode = function() {
                return !1;
            }, t.isConcurrentMode = function() {
                return !1;
            }, t.isContextConsumer = function(e) {
                return z(e) === a;
            }, t.isContextProvider = function(e) {
                return z(e) === c;
            }, t.isElement = function(e) {
                return "object" == typeof e && null !== e && e.$$typeof === i;
            }, t.isForwardRef = function(e) {
                return z(e) === I;
            }, t.isFragment = function(e) {
                return z(e) === M;
            }, t.isLazy = function(e) {
                return z(e) === g;
            }, t.isMemo = function(e) {
                return z(e) === j;
            }, t.isPortal = function(e) {
                return z(e) === r;
            }, t.isProfiler = function(e) {
                return z(e) === o;
            }, t.isStrictMode = function(e) {
                return z(e) === u;
            }, t.isSuspense = function(e) {
                return z(e) === l;
            }, t.isValidElementType = function(e) {
                return "string" == typeof e || "function" == typeof e || e === M || e === o || e === d || e === u || e === l || e === N || e === T || "object" == typeof e && null !== e && (e.$$typeof === g || e.$$typeof === j || e.$$typeof === c || e.$$typeof === a || e.$$typeof === I || e.$$typeof === D || e.$$typeof === s || e[0] === A);
            }, t.typeOf = z;
        },
        function(e, t, n) {
            "use strict";
            e.exports = n(117);
        },
        function(e, t, n) {
            "use strict";
            var w = function w(e) {
                if ("object" == typeof e && null !== e) {
                    var _$t = e.$$typeof;
                    switch(_$t){
                        case r:
                            switch(e = e.type){
                                case l:
                                case N:
                                case u:
                                case c:
                                case o:
                                case g:
                                    return e;
                                default:
                                    switch(e = e && e.$$typeof){
                                        case I:
                                        case j:
                                        case D:
                                        case A:
                                        case a:
                                            return e;
                                        default:
                                            return _$t;
                                    }
                            }
                        case M:
                            return _$t;
                    }
                }
            };
            var f = function f(e) {
                return w(e) === N;
            };
            /** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var i = "function" == typeof Symbol && Symbol.for, r = i ? Symbol.for("react.element") : 60103, M = i ? Symbol.for("react.portal") : 60106, u = i ? Symbol.for("react.fragment") : 60107, o = i ? Symbol.for("react.strict_mode") : 60108, c = i ? Symbol.for("react.profiler") : 60114, a = i ? Symbol.for("react.provider") : 60109, I = i ? Symbol.for("react.context") : 60110, l = i ? Symbol.for("react.async_mode") : 60111, N = i ? Symbol.for("react.concurrent_mode") : 60111, j = i ? Symbol.for("react.forward_ref") : 60112, g = i ? Symbol.for("react.suspense") : 60113, s = i ? Symbol.for("react.suspense_list") : 60120, A = i ? Symbol.for("react.memo") : 60115, D = i ? Symbol.for("react.lazy") : 60116, d = i ? Symbol.for("react.block") : 60121, T = i ? Symbol.for("react.fundamental") : 60117, y = i ? Symbol.for("react.responder") : 60118, z = i ? Symbol.for("react.scope") : 60119;
            t.AsyncMode = l, t.ConcurrentMode = N, t.ContextConsumer = I, t.ContextProvider = a, t.Element = r, t.ForwardRef = j, t.Fragment = u, t.Lazy = D, t.Memo = A, t.Portal = M, t.Profiler = c, t.StrictMode = o, t.Suspense = g, t.isAsyncMode = function(e) {
                return f(e) || w(e) === l;
            }, t.isConcurrentMode = f, t.isContextConsumer = function(e) {
                return w(e) === I;
            }, t.isContextProvider = function(e) {
                return w(e) === a;
            }, t.isElement = function(e) {
                return "object" == typeof e && null !== e && e.$$typeof === r;
            }, t.isForwardRef = function(e) {
                return w(e) === j;
            }, t.isFragment = function(e) {
                return w(e) === u;
            }, t.isLazy = function(e) {
                return w(e) === D;
            }, t.isMemo = function(e) {
                return w(e) === A;
            }, t.isPortal = function(e) {
                return w(e) === M;
            }, t.isProfiler = function(e) {
                return w(e) === c;
            }, t.isStrictMode = function(e) {
                return w(e) === o;
            }, t.isSuspense = function(e) {
                return w(e) === g;
            }, t.isValidElementType = function(e) {
                return "string" == typeof e || "function" == typeof e || e === u || e === N || e === c || e === o || e === g || e === s || "object" == typeof e && null !== e && (e.$$typeof === D || e.$$typeof === A || e.$$typeof === a || e.$$typeof === I || e.$$typeof === j || e.$$typeof === T || e.$$typeof === y || e.$$typeof === z || e.$$typeof === d);
            }, t.typeOf = w;
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.ProviderController = void 0;
            var i = n(0), r = i.__importStar(n(5)), M = n(2), u = n(3), o = n(21), c = function() {
                var e = function e(e) {
                    var _$t = this;
                    this.cachedProvider = "", this.shouldCacheProvider = !1, this.disableInjectedProvider = !1, this.eventController = new o.EventController, this.injectedProvider = null, this.providers = [], this.network = "", this.getUserOptions = function() {
                        var _$e = u.isMobile(), _$n = _$t.providers.map(function(e) {
                            return e.id;
                        }), i = !!_$t.injectedProvider && !_$t.disableInjectedProvider, r = [];
                        i && _$e ? r.push(M.INJECTED_PROVIDER_ID) : (i && r.push(M.INJECTED_PROVIDER_ID), _$n.forEach(function(e) {
                            e !== M.INJECTED_PROVIDER_ID && _$t.shouldDisplayProvider(e) && r.push(e);
                        }));
                        var o = [];
                        return r.forEach(function(e) {
                            var _$n = _$t.getProvider(e);
                            if (void 0 !== _$n) {
                                var i = _$n.id, r = _$n.name, M = _$n.logo, c = _$n.connector;
                                o.push({
                                    id: i,
                                    name: r,
                                    logo: M,
                                    description: u.getProviderDescription(_$n),
                                    onClick: function onClick() {
                                        return _$t.connectTo(i, c);
                                    }
                                });
                            }
                        }), o;
                    }, this.connectTo = function(e, n) {
                        return i.__awaiter(_$t, void 0, void 0, function() {
                            var _$t, r, u, o, c;
                            return i.__generator(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        return a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]), this.eventController.trigger(M.SELECT_EVENT, e), _$t = this.getProviderOption(e, "package"), r = this.getProviderOption(e, "options"), u = i.__assign({
                                            network: this.network || void 0
                                        }, r), [
                                            4,
                                            n(_$t, u)
                                        ];
                                    case 1:
                                        return o = a.sent(), this.eventController.trigger(M.CONNECT_EVENT, o), this.shouldCacheProvider && this.cachedProvider !== e && this.setCachedProvider(e), [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        return c = a.sent(), this.eventController.trigger(M.ERROR_EVENT, c), [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.cachedProvider = u.getLocal(M.CACHED_PROVIDER_KEY) || "", this.disableInjectedProvider = e.disableInjectedProvider, this.shouldCacheProvider = e.cacheProvider, this.providerOptions = e.providerOptions, this.network = e.network, this.injectedProvider = u.getInjectedProvider(), this.providers = Object.keys(r.connectors).map(function(e) {
                        var _$n;
                        (_$n = e === M.INJECTED_PROVIDER_ID ? _$t.injectedProvider || r.providers.FALLBACK : u.getProviderInfoById(e), _$t.providerOptions[e]) && void 0 !== _$t.providerOptions[e].display && (_$n = i.__assign(i.__assign({}, _$n), _$t.providerOptions[e].display));
                        return i.__assign(i.__assign({}, _$n), {
                            connector: r.connectors[e],
                            package: _$n.package
                        });
                    }), Object.keys(this.providerOptions).filter(function(e) {
                        return e.startsWith("custom-");
                    }).map(function(e) {
                        if (e && _$t.providerOptions[e]) {
                            var _$n = _$t.providerOptions[e];
                            void 0 !== _$n.display && void 0 !== _$n.connector && _$t.providers.push(i.__assign(i.__assign(i.__assign(i.__assign({}, r.providers.FALLBACK), {
                                id: e
                            }), _$n.display), {
                                connector: _$n.connector
                            }));
                        }
                    });
                };
                return e.prototype.shouldDisplayProvider = function(e) {
                    var _$t = this.getProvider(e);
                    if (void 0 !== _$t) {
                        var _$n = this.providerOptions[e];
                        if (_$n) {
                            if (!!_$n.package) {
                                var i = _$t.package ? _$t.package.required : void 0;
                                if (!i || !i.length) return !0;
                                var r = _$n.options;
                                if (r && Object.keys(r).length) {
                                    var M = u.findMatchingRequiredOptions(i, r);
                                    if (i.length === M.length) return !0;
                                }
                            }
                        }
                    }
                    return !1;
                }, e.prototype.getProvider = function(e) {
                    return u.filterMatches(this.providers, function(t) {
                        return t.id === e;
                    }, void 0);
                }, e.prototype.getProviderOption = function(e, t) {
                    return this.providerOptions && this.providerOptions[e] && this.providerOptions[e][t] ? this.providerOptions[e][t] : {};
                }, e.prototype.clearCachedProvider = function() {
                    this.cachedProvider = "", u.removeLocal(M.CACHED_PROVIDER_KEY);
                }, e.prototype.setCachedProvider = function(e) {
                    this.cachedProvider = e, u.setLocal(M.CACHED_PROVIDER_KEY, e);
                }, e.prototype.connectToCachedProvider = function() {
                    return i.__awaiter(this, void 0, void 0, function() {
                        var e;
                        return i.__generator(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return void 0 === (e = this.getProvider(this.cachedProvider)) ? [
                                        3,
                                        2
                                    ] : [
                                        4,
                                        this.connectTo(e.id, e.connector)
                                    ];
                                case 1:
                                    t.sent(), t.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }, e.prototype.on = function(e, t) {
                    var _$n = this;
                    return this.eventController.on({
                        event: e,
                        callback: t
                    }), function() {
                        return _$n.eventController.off({
                            event: e,
                            callback: t
                        });
                    };
                }, e.prototype.off = function(e, t) {
                    this.eventController.off({
                        event: e,
                        callback: t
                    });
                }, e;
            }();
            t.ProviderController = c;
        }
    ]);
});



var $dxWQo = parcelRequire("dxWQo");

var $e5s6c = parcelRequire("e5s6c");
var $860fb9ddc3f456cc$exports = {};


$860fb9ddc3f456cc$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + (parcelRequire("lGKbD")).resolve("5z3Jv");


var $050990180fbd2df8$export$af1c0561ce3e4019 = // [9001]: {
//   chainId: utils.hexValue(9001),
//   rpcUrls: ["https://eth.bd.evmos.org:8545"],
//   chainName: "Evmos Mainnet",
//   label: "Evmos",
//   nativeCurrency: {
//     name: "EVMOS",
//     symbol: "EVMOS",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://evm.evmos.org/"],
//   exampleContractAddress: "0x2e441adc345daeb11ff9c2cae7efd461e5525850",
//   contractExplorerUrl:
//     "https://evm.evmos.org/address/0x2e441adc345daeb11ff9c2cae7efd461e5525850",
//   logo: EvmosLogo,
// },
// [137]: {
//   chainId: utils.hexValue(137),
//   rpcUrls: ["https://polygon-rpc.com"],
//   chainName: "Polygon",
//   label: "Polygon",
//   nativeCurrency: {
//     name: "MATIC",
//     symbol: "MATIC",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://polygonscan.com/"],
//   exampleContractAddress: "0x0721b16dDC4931472b69855A5C149443C232205F",
//   contractExplorerUrl:
//     "https://polygonscan.com/address/0x0721b16dDC4931472b69855A5C149443C232205F",
//   logo: PolygonLogo,
// },
// [42161]: {
//   chainId: utils.hexValue(42161),
//   rpcUrls: ["https://arb1.arbitrum.io/rpc"],
//   chainName: "Arbitrum One",
//   label: "Arbitrum",
//   nativeCurrency: {
//     name: "ETH",
//     symbol: "ETH",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://arbiscan.io/"],
//   exampleContractAddress: "0x2e441adc345daeb11ff9c2cae7efd461e5525850",
//   contractExplorerUrl:
//     "https://arbiscan.io/address/0x2e441adc345daeb11ff9c2cae7efd461e5525850",
//   logo: ArbitrumLogo,
// },
// [10]: {
//   chainId: utils.hexValue(10),
//   rpcUrls: ["https://mainnet.optimism.io"],
//   chainName: "Optimism",
//   label: "Optimism",
//   nativeCurrency: {
//     name: "ETH",
//     symbol: "ETH",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://optimistic.etherscan.io/"],
//   exampleContractAddress: "0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
//   contractExplorerUrl:
//     "https://optimistic.etherscan.io/address/0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
//   logo: OptimismLogo,
// },
// [5]: {
//   chainId: utils.hexValue(5),
//   rpcUrls: ["https://goerli.infura.io/v3/"],
//   chainName: "Goerli Test Network",
//   label: "Goerli",
//   nativeCurrency: {
//     name: "GoerliETH",
//     symbol: "GoerliETH",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://goerli.etherscan.io/"],
//   exampleContractAddress: "0xC9BE33f28520B1D94614039Ed06D5e8ed2cee048",
//   contractExplorerUrl:
//     "https://goerli.etherscan.io/address/0xC9BE33f28520B1D94614039Ed06D5e8ed2cee048",
//   logo: EthereumLogo,
// },
// [43114]: {
//   chainId: utils.hexValue(43114),
//   rpcUrls: ["https://api.avax.network/ext/bc/C/rpc"],
//   chainName: "Avalanche Network",
//   label: "Avalanche",
//   nativeCurrency: {
//     name: "AVAX",
//     symbol: "AVAX",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://snowtrace.io/"],
//   exampleContractAddress: "0x4d58dbF4a921FdD964Ece0732B1577cC25662587",
//   contractExplorerUrl:
//     "https://snowtrace.io/address/0x4d58dbF4a921FdD964Ece0732B1577cC25662587",
//   logo: AvalancheLogo,
// },
// [42220]: {
//   chainId: utils.hexValue(42220),
//   rpcUrls: ["https://forno.celo.org"],
//   chainName: "Celo",
//   label: "Celo",
//   nativeCurrency: {
//     name: "Celo",
//     symbol: "CELO",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://explorer.celo.org/"],
//   exampleContractAddress: "0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
//   contractExplorerUrl:
//     "https://explorer.celo.org/address/0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
//   logo: CeloLogo,
// },
// [56]: {
//   chainId: utils.hexValue(56),
//   rpcUrls: ["https://bsc-dataseed.binance.org/"],
//   chainName: "Smart Chain",
//   label: "BNB",
//   nativeCurrency: {
//     name: "BNB",
//     symbol: "BNB",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://bscscan.com/"],
//   exampleContractAddress: "0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
//   contractExplorerUrl:
//     "https://bscscan.com/address/0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
//   logo: BnbLogo,
// },
// [250]: {
//   chainId: utils.hexValue(250),
//   rpcUrls: ["https://rpc.ankr.com/fantom/"],
//   chainName: "Fantom",
//   label: "Fantom",
//   nativeCurrency: {
//     name: "FTM",
//     symbol: "FTM",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://ftmscan.com/"],
//   exampleContractAddress: "0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
//   contractExplorerUrl:
//     "https://ftmscan.com/address/0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
//   logo: FantomLogo,
// },
// [8217]: {
//   chainId: utils.hexValue(8217),
//   rpcUrls: ["https://public-node-api.klaytnapi.com/v1/cypress"],
//   chainName: "Klaytn Mainnet",
//   label: "Klaytn",
//   nativeCurrency: {
//     name: "KLAY",
//     symbol: "KLAY",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://scope.klaytn.com/"],
//   exampleContractAddress: "0x2e441adc345daeb11ff9c2cae7efd461e5525850",
//   contractExplorerUrl:
//     "https://scope.klaytn.com/address/0x2e441adc345daeb11ff9c2cae7efd461e5525850",
//   logo: KlaytnLogo,
// },
// [1284]: {
//   chainId: utils.hexValue(1284),
//   rpcUrls: ["https://rpc.api.moonbeam.network"],
//   chainName: "Moonbeam",
//   label: "Moonbeam",
//   nativeCurrency: {
//     name: "GLMR",
//     symbol: "GLMR",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://moonscan.io/"],
//   exampleContractAddress: "0xd75F4B5AA9480E6956f2570Dd258ca716784f6E1",
//   contractExplorerUrl:
//     "https://moonscan.io/address/0xd75F4B5AA9480E6956f2570Dd258ca716784f6E1",
//   logo: MoonbeamLogo,
// },
// [280]: {
//   chainId: utils.hexValue(280),
//   rpcUrls: ["https://zksync2-testnet.zksync.dev"],
//   chainName: "zkSync Era Testnet",
//   label: "zkSync Era Testnet",
//   nativeCurrency: {
//     name: "ETH",
//     symbol: "ETH",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://goerli.explorer.zksync.io/"],
//   exampleContractAddress: "0xfC751219f2d99f9fE01e777625352Fe22D37433A",
//   contractExplorerUrl:
//     "https://goerli.explorer.zksync.io/address/0xfC751219f2d99f9fE01e777625352Fe22D37433A",
//   logo: zkSyncLogo,
// },
// [324]: {
//   chainId: utils.hexValue(324),
//   rpcUrls: ["https://mainnet.era.zksync.io"],
//   chainName: "zkSync Era Mainnet",
//   label: "zkSync Era Mainnet",
//   nativeCurrency: {
//     name: "ETH",
//     symbol: "ETH",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://explorer.zksync.io/"],
//   exampleContractAddress: "0xB6cA02A43EF32504876799B6c3Af12482f29a836",
//   contractExplorerUrl:
//     "https://explorer.zksync.io/address/0xB6cA02A43EF32504876799B6c3Af12482f29a836",
//   logo: zkSyncLogo,
// },
// [1313161554]: {
//   chainId: utils.hexValue(1313161554),
//   rpcUrls: ["https://mainnet.aurora.dev"],
//   chainName: "Aurora",
//   label: "Aurora",
//   nativeCurrency: {
//     name: "ETH",
//     symbol: "ETH",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://aurorascan.dev/"],
//   exampleContractAddress: "0x1a6bbc6Ff8BEeE20B4177Ac87580F4e2aF3Abf71",
//   contractExplorerUrl:
//     "https://aurorascan.dev/address/0x1a6bbc6Ff8BEeE20B4177Ac87580F4e2aF3Abf71",
//   logo: AuroraLogo,
// },
// [534353]: {
//   chainId: utils.hexValue(534353),
//   rpcUrls: ["https://alpha-rpc.scroll.io/l2"],
//   chainName: "Scroll Alpha Testnet",
//   label: "Scroll",
//   nativeCurrency: {
//     name: "ETH",
//     symbol: "ETH",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://blockscout.scroll.io/"],
//   exampleContractAddress: "0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
//   contractExplorerUrl:
//     "https://blockscout.scroll.io/address/0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
//   logo: ScrollLogo,
// },
// [2000]: {
//   chainId: utils.hexValue(2000),
//   rpcUrls: ["https://rpc.dogechain.dog"],
//   chainName: "Dogechain",
//   label: "Dogechain",
//   nativeCurrency: {
//     name: "DOGE",
//     symbol: "DOGE",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://explorer.dogechain.dog/"],
//   exampleContractAddress: "0xaCf97fb2f2c336c45b799DAB925ad10ADC70fCAC",
//   contractExplorerUrl:
//     "https://explorer.dogechain.dog/address/0xaCf97fb2f2c336c45b799DAB925ad10ADC70fCAC",
//   logo: DogechainLogo,
// },
// [5001]: {
//   chainId: utils.hexValue(5001),
//   rpcUrls: ["​​https://rpc.testnet.mantle.xyz/"],
//   chainName: "Mantle Testnet",
//   label: "Mantle",
//   nativeCurrency: {
//     name: "BIT",
//     symbol: "BIT",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://explorer.testnet.mantle.xyz/"],
//   exampleContractAddress: "0xaCf97fb2f2c336c45b799DAB925ad10ADC70fCAC",
//   contractExplorerUrl:
//     "https://explorer.testnet.mantle.xyz/address/0xaCf97fb2f2c336c45b799DAB925ad10ADC70fCAC",
//   logo: MantleLogo,
// },
// [11111]: {
//   chainId: utils.hexValue(11111),
//   rpcUrls: ["https://subnets.avax.network/wagmi/wagmi-chain-testnet/rpc"],
//   chainName: "WAGMI",
//   label: "WAGMI Testnet",
//   nativeCurrency: {
//     name: "WGM",
//     symbol: "WGM",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://subnets-test.avax.network/wagmi/"],
//   exampleContractAddress: "0xd75F4B5AA9480E6956f2570Dd258ca716784f6E1",
//   contractExplorerUrl:
//     "https://subnets-test.avax.network/wagmi/address/0xd75F4B5AA9480E6956f2570Dd258ca716784f6E1",
//   logo: WagmiLogo,
// },
// [1442]: {
//   chainId: utils.hexValue(1442),
//   rpcUrls: ["https://rpc.public.zkevm-test.net"],
//   chainName: "Polygon zkEVM Testnet",
//   label: "Polygon zkEVM Testnet",
//   nativeCurrency: {
//     name: "ETH",
//     symbol: "ETH",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://explorer.public.zkevm-test.net/"],
//   exampleContractAddress: "0xaCf97fb2f2c336c45b799DAB925ad10ADC70fCAC",
//   contractExplorerUrl:
//     "https://explorer.public.zkevm-test.net/address/0xaCf97fb2f2c336c45b799DAB925ad10ADC70fCAC",
//   logo: PolygonZkEVMLogo,
// },
// [1101]: {
//   chainId: utils.hexValue(1101),
//   rpcUrls: ["https://zkevm-rpc.com"],
//   chainName: "Polygon zkEVM",
//   label: "Polygon zkEVM",
//   nativeCurrency: {
//     name: "ETH",
//     symbol: "ETH",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://zkevm.polygonscan.com/"],
//   exampleContractAddress: "0x2e441adc345daeb11ff9c2cae7efd461e5525850",
//   contractExplorerUrl:
//     "https://zkevm.polygonscan.com/address/0x2e441adc345daeb11ff9c2cae7efd461e5525850",
//   logo: PolygonZkEVMLogo,
// },
// [7700]: {
//   chainId: utils.hexValue(7700),
//   rpcUrls: ["https://canto.slingshot.finance"],
//   chainName: "Canto",
//   label: "Canto",
//   nativeCurrency: {
//     name: "CANTO",
//     symbol: "CANTO",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://evm.explorer.canto.io/"],
//   exampleContractAddress: "0xf16dA7ABcac966B3ba9c1DFa17D8A9626237bcf8",
//   contractExplorerUrl:
//     "https://evm.explorer.canto.io/address/0xf16dA7ABcac966B3ba9c1DFa17D8A9626237bcf8",
//   logo: CantoLogo,
// },
// [84531]: {
//   chainId: utils.hexValue(84531),
//   rpcUrls: ["https://goerli.base.org"],
//   chainName: "Base Goerli",
//   label: "Base Goerli",
//   nativeCurrency: {
//     name: "ETH",
//     symbol: "ETH",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://goerli.basescan.org/"],
//   exampleContractAddress: "0xd75F4B5AA9480E6956f2570Dd258ca716784f6E1",
//   contractExplorerUrl:
//     "https://goerli.basescan.org/address/0xd75f4b5aa9480e6956f2570dd258ca716784f6e1",
//   logo: BaseLogo,
// },
// [9999999997]: {
//   chainId: utils.hexValue(9999999997),
//   rpcUrls: [
//     "https://starknet-goerli.infura.io/v3/0d9bfc9a170947ce8c4f2e15dae7c62a",
//   ],
//   chainName: "Starknet Test Network",
//   label: "Starknet",
//   nativeCurrency: {
//     name: "GoerliETH",
//     symbol: "GoerliETH",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://testnet.starkscan.co/"],
//   exampleContractAddress:
//     "0x03a4732136f974a250bf7d95683af13b05a4d605d3f3390469f6178448a73ae1",
//   contractExplorerUrl:
//     "https://testnet.starkscan.co/contract/0x03a4732136f974a250bf7d95683af13b05a4d605d3f3390469f6178448a73ae1",
//   txExplorerUrl: "https://testnet.starkscan.co/tx/",
//   logo: StarknetLogo,
//   type: "starknet",
// },
// [9999999998]: {
//   chainId: utils.hexValue(9999999998),
//   rpcUrls: ["https://beta-3.fuel.network/graphql"],
//   chainName: "Fuel Beta-3 Network",
//   label: "Fuel",
//   nativeCurrency: {
//     name: "ETH",
//     symbol: "ETH",
//     decimals: 18,
//   },
//   blockExplorerUrls: ["https://fuellabs.github.io/block-explorer-v2/block/"],
//   exampleContractAddress:
//     "0x8fdae6cb766121b5382977e98dc948dbdc95812a3e60c2cf2c0dfff06e877989",
//   contractExplorerUrl:
//     "https://fuellabs.github.io/block-explorer-v2/beta-3/#/address/{walletAddress}",
//   txExplorerUrl:
//     "https://fuellabs.github.io/block-explorer-v2/beta-3/#/transaction/",
//   logo: FuelLogo,
//   type: "fuel",
// },
(0, $dxWQo._)({}, 9999999999, {
    chainId: (0, $e5s6c).hexValue(9999999999),
    rpcUrls: [
        "https://testnet.toncenter.com/api/v2/jsonRPC"
    ],
    chainName: "TON Test Network",
    label: "TON",
    nativeCurrency: {
        name: "GoerliETH",
        symbol: "GoerliETH",
        decimals: 18
    },
    blockExplorerUrls: [
        "https://testnet.starkscan.co/"
    ],
    exampleContractAddress: "EQCMxfukwpP3BI_6Pn3lmOXgxlp3dPabVGOM0UvJCjsDhkdD",
    contractExplorerUrl: "https://testnet.tonviewer.com/EQCMxfukwpP3BI_6Pn3lmOXgxlp3dPabVGOM0UvJCjsDhkdD",
    txExplorerUrl: "https://testnet.starkscan.co/tx/",
    logo: (0, (/*@__PURE__*/$parcel$interopDefault($860fb9ddc3f456cc$exports))),
    type: "ton"
});


var $429f470a166ef670$export$83e74882c5df8fe1 = function(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
};
var $429f470a166ef670$export$19d7d19559261303 = {
    btc: "",
    eth: "",
    bnb: "",
    ar: "",
    avax: "",
    celo: ""
};
var $429f470a166ef670$export$c86caf1be068fb8d = function(price) {
    var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
    });
    return formatter.format(price);
};


var $6d74eea438614f0e$export$69804ca079d47f29 = function(setNetwork) {
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)((0, $429f470a166ef670$export$19d7d19559261303)), 2), prices = _useState[0], setPrices = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)(null), 2), web3Modal = _useState1[0], setWeb3Modal = _useState1[1];
    var _useState2 = (0, $8GFUW._)((0, $6cds3.useState)(null), 2), signer = _useState2[0], setSigner = _useState2[1];
    var _useState3 = (0, $8GFUW._)((0, $6cds3.useState)(""), 2), walletAddress = _useState3[0], setWalletAddress = _useState3[1];
    var _useState4 = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), isChangingNetwork = _useState4[0], setIsChangingNetwork = _useState4[1];
    var _useState5 = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), isConnecting = _useState5[0], setIsConnecting = _useState5[1];
    (0, $6cds3.useEffect)(function() {
        var web3Modal = new (0, (/*@__PURE__*/$parcel$interopDefault($5f6146cb2a3d4ecb$exports)))({
            cacheProvider: true
        });
        setWeb3Modal(web3Modal);
    }, []);
    var changeNetwork = function() {
        var _ref = (0, $byzP8._)(function(network) {
            var exampleContractAddress, contractExplorerUrl, logo, label, restNetworkParams, switchError;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(network && (network.type || "eth") === "eth")) return [
                            3,
                            7
                        ];
                        setIsChangingNetwork(true);
                        exampleContractAddress = network.exampleContractAddress, contractExplorerUrl = network.contractExplorerUrl, logo = network.logo, label = network.label, restNetworkParams = (0, $gPjjc._)(network, [
                            "exampleContractAddress",
                            "contractExplorerUrl",
                            "logo",
                            "label"
                        ]);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            6,
                            7
                        ]);
                        return [
                            4,
                            window.ethereum.request({
                                method: "wallet_switchEthereumChain",
                                params: [
                                    {
                                        chainId: restNetworkParams.chainId
                                    }
                                ]
                            })
                        ];
                    case 2:
                        _state.sent();
                        setIsChangingNetwork(false);
                        return [
                            3,
                            7
                        ];
                    case 3:
                        switchError = _state.sent();
                        if (!(switchError.code === 4902)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            addNewNetwork(restNetworkParams)
                        ];
                    case 4:
                        _state.sent();
                        setIsChangingNetwork(false);
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        setPrices((0, $429f470a166ef670$export$19d7d19559261303));
                        return [
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function changeNetwork(network) {
            return _ref.apply(this, arguments);
        };
    }();
    var addNewNetwork = function() {
        var _ref = (0, $byzP8._)(function(networkParams) {
            var error;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            window.ethereum.request({
                                method: "wallet_addEthereumChain",
                                params: [
                                    networkParams
                                ]
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        setPrices((0, $429f470a166ef670$export$19d7d19559261303));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function addNewNetwork(networkParams) {
            return _ref.apply(this, arguments);
        };
    }();
    var connectWallet = function() {
        var _ref = (0, $byzP8._)(function(network) {
            var instance, provider, signer, walletAddress, error;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!web3Modal) return [
                            3,
                            7
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            6,
                            7
                        ]);
                        return [
                            4,
                            changeNetwork(network)
                        ];
                    case 2:
                        _state.sent();
                        setIsConnecting(true);
                        return [
                            4,
                            web3Modal.connect()
                        ];
                    case 3:
                        instance = _state.sent();
                        addListeners(instance);
                        provider = new (0, $ldxXU).Web3Provider(instance);
                        signer = provider.getSigner();
                        setSigner(signer);
                        return [
                            4,
                            signer.getAddress()
                        ];
                    case 4:
                        walletAddress = _state.sent();
                        setWalletAddress(walletAddress);
                        return [
                            3,
                            7
                        ];
                    case 5:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        setIsConnecting(false);
                        setPrices((0, $429f470a166ef670$export$19d7d19559261303));
                        return [
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function connectWallet(network) {
            return _ref.apply(this, arguments);
        };
    }();
    var reconnectWallet = function() {
        var _ref = (0, $byzP8._)(function() {
            var instance, provider, signer, walletAddress;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!web3Modal) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            web3Modal.connect()
                        ];
                    case 1:
                        instance = _state.sent();
                        provider = new (0, $ldxXU).Web3Provider(instance);
                        signer = provider.getSigner();
                        setSigner(signer);
                        return [
                            4,
                            signer.getAddress()
                        ];
                    case 2:
                        walletAddress = _state.sent();
                        setWalletAddress(walletAddress);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function reconnectWallet() {
            return _ref.apply(this, arguments);
        };
    }();
    var addListeners = function(web3ModalProvider) {
        web3ModalProvider.on("accountsChanged", function() {
            window.location.reload();
        });
        web3ModalProvider.on("chainChanged", function() {
            var _ref = (0, $byzP8._)(function(chainId) {
                var chainIdAsNumber, chainFromConfig;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            chainIdAsNumber = Number(chainId.toString());
                            chainFromConfig = (0, $050990180fbd2df8$export$af1c0561ce3e4019)[chainIdAsNumber];
                            if (!!chainFromConfig) return [
                                3,
                                1
                            ];
                            setNetwork(null);
                            return [
                                3,
                                3
                            ];
                        case 1:
                            setNetwork(chainFromConfig);
                            return [
                                4,
                                reconnectWallet()
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(chainId) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    return {
        prices: prices,
        setPrices: setPrices,
        signer: signer,
        connectWallet: connectWallet,
        walletAddress: walletAddress,
        isChangingNetwork: isChangingNetwork,
        isConnecting: isConnecting
    };
};



var $894a8d90f8ca8f9d$export$179a2d4534d0f37d = function(param) {
    var chain = param.chain, network = param.network, onChainClick = param.onChainClick, disabled = param.disabled;
    /*#__PURE__*/ return (0, $fba0f23e9e6a11bb$exports.jsxs)("button", {
        className: "flex align-center gap-2 border py-2 px-2 rounded ".concat(chain.chainId === (network === null || network === void 0 ? void 0 : network.chainId) && "border-redstone", " disabled:opacity-30 hover:scale-110	ease-in-out duration-300"),
        onClick: function() {
            return onChainClick(chain);
        },
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                style: {
                    height: 24,
                    width: 24
                },
                src: chain.logo,
                alt: "".concat(chain.label, " logo")
            }),
            chain.label
        ]
    });
};





var $aa3dfd0ff19cb695$exports = {};


$aa3dfd0ff19cb695$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + (parcelRequire("lGKbD")).resolve("skziC");


var $5ed925a4b75f3134$exports = {};


$5ed925a4b75f3134$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + (parcelRequire("lGKbD")).resolve("c2BNu");


var $d0adf8410d59fd78$export$f34f01f5ad9bfa8 = function(param) {
    var walletAddress = param.walletAddress, network = param.network;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("table", {
        className: "w-3/5 table-auto border mb-8",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tbody", {
            className: "text-md",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("td", {
                            className: "flex items-center gap-3 py-3 px-3",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    className: "object-scale-down w-6 h-6",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($aa3dfd0ff19cb695$exports))),
                                    alt: "Wallet icon"
                                }),
                                "Your wallet"
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                            className: "py-3 px-3 text-right",
                            children: walletAddress
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("td", {
                            className: "flex items-center gap-3 py-3 px-3",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    className: "object-scale-down w-6 h-6",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5ed925a4b75f3134$exports))),
                                    alt: "Contract icon"
                                }),
                                "Integrated Contract"
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                            className: "py-3 px-3 text-right underline",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                href: network.contractExplorerUrl.replace("{walletAddress}", walletAddress),
                                target: "blank",
                                referrerPolicy: "no-referrer",
                                children: network.exampleContractAddress
                            })
                        })
                    ]
                })
            ]
        })
    });
};




var $c9c9a28c2efa9cdd$export$7f7cbe89f1eacd2 = function(param) {
    var _param_size = param.size, size = _param_size === void 0 ? 10 : _param_size;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        role: "status",
        className: "inline w-".concat(size, " h-").concat(size, " text-gray-200 animate-spin dark:text-gray-300 fill-redstone"),
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                fill: "currentFill"
            })
        ]
    });
};
var $c9c9a28c2efa9cdd$export$3b0d6d7590275603 = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "flex items-center justify-center",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            className: "w-[45px]",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($c9c9a28c2efa9cdd$export$7f7cbe89f1eacd2, {})
        })
    });
};


var $400629623ad58cec$export$f39eb86f0e5c1a78 = function(param) {
    var text = param.text;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex justify-center items-center flex-col",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c9c9a28c2efa9cdd$export$3b0d6d7590275603), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: "text-md font-semibold mt-4",
                children: text
            })
        ]
    });
};



var $8GFUW = parcelRequire("8GFUW");


var $29fbb8d85bb99ed5$export$d877cf1ea46d4d85 = function(param) {
    var blockNumber = param.blockNumber, timestamp = param.timestamp, prices = param.prices;
    var pricesArray = Object.entries(prices).map(function(param) {
        var _param = (0, $8GFUW._)(param, 2), key = _param[0], price = _param[1];
        return {
            label: key.toUpperCase(),
            value: price
        };
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("table", {
        className: "w-3/5 table-auto border mb-5",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tbody", {
            className: "text-md",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                            className: "py-3 px-6",
                            children: "Block number"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                            className: "py-3 px-6 font-bold text-right",
                            children: blockNumber
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                            className: "py-3 px-6",
                            children: "Timestamp"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                            className: "py-3 px-6 font-bold text-right",
                            children: new Date(timestamp).toLocaleString()
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("tr", {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                        colSpan: 2,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("hr", {})
                    })
                }),
                pricesArray.map(function(price) {
                    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                className: "py-3 px-6",
                                children: price.label
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                className: "py-3 px-6 font-bold text-right",
                                children: (0, $429f470a166ef670$export$c86caf1be068fb8d)(price.value)
                            })
                        ]
                    }, price.label);
                })
            ]
        })
    });
};



var $1f09082810955268$export$a6bbb1b7f40755b9 = function(param) {
    var writePricesToContract = param.writePricesToContract;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
        className: "bg-gray-400 hover:opacity-75 text-white py-3 px-8 rounded-full text-xl",
        onClick: writePricesToContract,
        children: "Write prices"
    });
};



var $291736910945f543$export$30ee6dea872700fe = function(param) {
    var readPricesFromContract = param.readPricesFromContract;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
        className: "bg-redstone bg-opacity-60 hover:opacity-75 text-white py-3 px-8 rounded-full text-xl",
        onClick: readPricesFromContract,
        children: "Read prices"
    });
};



var $f1a9f66f6ca0bed1$export$d38cca4e3d3fe8c0 = function(param) {
    var getPriceFromContract = param.getPriceFromContract;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
        className: "bg-redstone hover:opacity-75 text-white py-3 px-8 rounded-full text-xl",
        onClick: getPriceFromContract,
        children: "Get prices"
    });
};



var $a3bbf3a18d3bb0b3$exports = {};


$a3bbf3a18d3bb0b3$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + (parcelRequire("lGKbD")).resolve("d7Bv1");


var $72f10b3fcf20060f$export$d22914518d6cfe65 = function(param) {
    var txHash = param.txHash, network = param.network;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("table", {
        className: "w-3/5 table-auto border mt-8",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tbody", {
            className: "text-md",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("td", {
                            className: "flex items-center gap-3 py-3 px-3",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    className: "object-scale-down w-6 h-6",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a3bbf3a18d3bb0b3$exports))),
                                    alt: "Contract icon"
                                }),
                                "Last transaction:"
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                            className: "py-3 px-3 text-right underline",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                href: network.txExplorerUrl + txHash,
                                target: "blank",
                                referrerPolicy: "no-referrer",
                                children: txHash
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("tr", {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                        colSpan: 2,
                        className: "text-sm px-3 text-gray-500",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("i", {
                            children: "This transaction writes a snapshot of current prices to the contract's storage."
                        })
                    })
                })
            ]
        })
    });
};



var $byzP8 = parcelRequire("byzP8");

var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");

var $6cds3 = parcelRequire("6cds3");

var $ae7f937efe139789$var$loaderTexts = [
    "Fetching price data",
    "Sending transaction with fetched price data",
    "Receiving data from smart contract"
];
var $ae7f937efe139789$export$3ca8f5b83ba7703a = function() {
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), isMockLoading = _useState[0], setIsMockLoading = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)($ae7f937efe139789$var$loaderTexts[0]), 2), text = _useState1[0], setText = _useState1[1];
    var handleTextChange = function() {
        var _ref = (0, $byzP8._)(function() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, text, err;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = $ae7f937efe139789$var$loaderTexts[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        text = _step.value;
                        setText(text);
                        return [
                            4,
                            (0, $429f470a166ef670$export$83e74882c5df8fe1)(500)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleTextChange() {
            return _ref.apply(this, arguments);
        };
    }();
    var startMockLoader = function() {
        setIsMockLoading(true);
        handleTextChange();
    };
    return {
        text: text,
        isMockLoading: isMockLoading,
        setIsMockLoading: setIsMockLoading,
        startMockLoader: startMockLoader
    };
};



var $byzP8 = parcelRequire("byzP8");

var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");

var $6cds3 = parcelRequire("6cds3");


var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");
var $8e66c6c0557f6291$exports = {};
"use strict";
var $8e66c6c0557f6291$var$__extends = $8e66c6c0557f6291$exports && $8e66c6c0557f6291$exports.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        var __ = function __() {
            this.constructor = d;
        };
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8e66c6c0557f6291$var$__importDefault = $8e66c6c0557f6291$exports && $8e66c6c0557f6291$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};

var $8e66c6c0557f6291$var$api_1 = $8e66c6c0557f6291$var$__importDefault((parcelRequire("98ZRp")));

var $8e66c6c0557f6291$var$query_1 = $8e66c6c0557f6291$var$__importDefault((parcelRequire("9bWqa")));
var $8e66c6c0557f6291$var$Redstone = /** @class */ function(_super) {
    var Redstone = function Redstone(opts) {
        var _this = _super.call(this, opts) || this;
        _this.query = $8e66c6c0557f6291$var$query_1.default;
        _this.Api = $8e66c6c0557f6291$var$api_1.default;
        return _this;
    };
    $8e66c6c0557f6291$var$__extends(Redstone, _super);
    return Redstone;
}($8e66c6c0557f6291$var$api_1.default);
$8e66c6c0557f6291$exports = new $8e66c6c0557f6291$var$Redstone();


var $cac0522f2cadd058$export$b87f2cac0597d124 = function() {
    var getPricesTimestamp = function() {
        var _ref = (0, $byzP8._)(function() {
            var pricesData;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, (/*@__PURE__*/$parcel$interopDefault($8e66c6c0557f6291$exports))).getPrice([
                                "BTC"
                            ])
                        ];
                    case 1:
                        pricesData = _state.sent();
                        return [
                            2,
                            pricesData.BTC.timestamp
                        ];
                }
            });
        });
        return function getPricesTimestamp() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        getPricesTimestamp: getPricesTimestamp
    };
};



var $e5s6c = parcelRequire("e5s6c");

var $bRqq8 = parcelRequire("bRqq8");
var $753cc36948ba3c23$var$dataPackageRequestParams = {
    dataServiceId: "redstone-rapid-demo",
    uniqueSignersCount: 1,
    dataFeeds: [
        "BTC",
        "ETH",
        "BNB",
        "AR",
        "AVAX",
        "CELO"
    ]
};
var $753cc36948ba3c23$export$37ebad50d75f51b = function(network, connector, startMockLoader, setPrices, setIsMockLoading) {
    var paramsProviderClass = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : (0, $bRqq8.ContractParamsProvider);
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)(0), 2), blockNumber = _useState[0], setBlockNumber = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)(""), 2), txHash = _useState1[0], setTxHash = _useState1[1];
    var _useState2 = (0, $8GFUW._)((0, $6cds3.useState)(0), 2), timestamp = _useState2[0], setTimestamp = _useState2[1];
    var _useState3 = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), isLoading = _useState3[0], setIsLoading = _useState3[1];
    var _useState4 = (0, $8GFUW._)((0, $6cds3.useState)(""), 2), errorMessage = _useState4[0], setErrorMessage = _useState4[1];
    var getPricesTimestamp = (0, $cac0522f2cadd058$export$b87f2cac0597d124)().getPricesTimestamp;
    var paramsProvider = new paramsProviderClass($753cc36948ba3c23$var$dataPackageRequestParams);
    var readPricesFromContract = function() {
        var _ref = (0, $byzP8._)(function() {
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getPrices(true)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function readPricesFromContract() {
            return _ref.apply(this, arguments);
        };
    }();
    var getPricesFromPayload = function() {
        var _ref = (0, $byzP8._)(function() {
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getPrices(false)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function getPricesFromPayload() {
            return _ref.apply(this, arguments);
        };
    }();
    var getPrices = function() {
        var _ref = (0, $byzP8._)(function(fromContract) {
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            performContractAction(function() {
                                var _ref = (0, $byzP8._)(function(adapter) {
                                    var date, _ref, prices, blockNumber, timestamp;
                                    return (0, $7UAGh.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                date = new Date().getTime();
                                                console.log("START ".concat(new Date().getTime() - date));
                                                return [
                                                    4,
                                                    Promise.all([
                                                        fromContract ? adapter.readPricesFromContract(paramsProvider) : adapter.getPricesFromPayload(paramsProvider),
                                                        connector.getBlockNumber(network.rpcUrls[0]),
                                                        fromContract ? adapter.readTimestampFromContract() : getPricesTimestamp()
                                                    ])
                                                ];
                                            case 1:
                                                _ref = (0, $8GFUW._).apply(void 0, [
                                                    _state.sent(),
                                                    3
                                                ]), prices = _ref[0], blockNumber = _ref[1], timestamp = _ref[2];
                                                handlePrices(setPrices, prices);
                                                setBlockNumber(blockNumber);
                                                setTimestamp(timestamp < 1000000000000 ? timestamp * 1000 : timestamp);
                                                console.log("END ".concat(new Date().getTime() - date));
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(adapter) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function getPrices(fromContract) {
            return _ref.apply(this, arguments);
        };
    }();
    var writePricesToContract = function() {
        var _ref = (0, $byzP8._)(function() {
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setPrices((0, $429f470a166ef670$export$19d7d19559261303));
                        return [
                            4,
                            performContractAction(function() {
                                var _ref = (0, $byzP8._)(function(adapter) {
                                    var txHashOrPrices, _ref, timestamp, blockNumber;
                                    return (0, $7UAGh.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    adapter.writePricesFromPayloadToContract(paramsProvider)
                                                ];
                                            case 1:
                                                txHashOrPrices = _state.sent();
                                                if (!(typeof txHashOrPrices === "string")) return [
                                                    3,
                                                    2
                                                ];
                                                setTxHash(txHashOrPrices);
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 2:
                                                handlePrices(setPrices, txHashOrPrices);
                                                return [
                                                    4,
                                                    Promise.all([
                                                        adapter.readTimestampFromContract(),
                                                        connector.getBlockNumber(network.rpcUrls[0])
                                                    ])
                                                ];
                                            case 3:
                                                _ref = (0, $8GFUW._).apply(void 0, [
                                                    _state.sent(),
                                                    2
                                                ]), timestamp = _ref[0], blockNumber = _ref[1];
                                                setBlockNumber(blockNumber);
                                                setTimestamp(timestamp);
                                                _state.label = 4;
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(adapter) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function writePricesToContract() {
            return _ref.apply(this, arguments);
        };
    }();
    var performContractAction = function() {
        var _ref = (0, $byzP8._)(function(callback) {
            var adapter, error;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!network) return [
                            3,
                            7
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        startMockLoader();
                        setIsLoading(true);
                        return [
                            4,
                            connector.getAdapter()
                        ];
                    case 2:
                        adapter = _state.sent();
                        if (!adapter) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            callback(adapter)
                        ];
                    case 3:
                        _state.sent();
                        setIsMockLoading(false);
                        setIsLoading(false);
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        console.error(error);
                        handleError();
                        setIsMockLoading(false);
                        setIsLoading(false);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            3,
                            8
                        ];
                    case 7:
                        handleError();
                        _state.label = 8;
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function performContractAction(callback) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleError = function() {
        setIsLoading(false);
        setPrices((0, $429f470a166ef670$export$19d7d19559261303));
        setIsMockLoading(false);
        setErrorMessage("There was problem with fetching data from smart adapter. Please try again or contact RedStone team");
    };
    var handlePrices = function(setPrices, prices) {
        setPrices({
            btc: (0, $e5s6c).formatUnits(prices[0], 8),
            eth: (0, $e5s6c).formatUnits(prices[1], 8),
            bnb: (0, $e5s6c).formatUnits(prices[2], 8),
            ar: (0, $e5s6c).formatUnits(prices[3], 8),
            avax: (0, $e5s6c).formatUnits(prices[4], 8),
            celo: (0, $e5s6c).formatUnits(prices[5], 8)
        });
    };
    return {
        blockNumber: blockNumber,
        txHash: txHash,
        timestamp: timestamp,
        isLoading: isLoading,
        errorMessage: errorMessage,
        setErrorMessage: setErrorMessage,
        getPricesFromPayload: getPricesFromPayload,
        readPricesFromContract: readPricesFromContract,
        writePricesToContract: writePricesToContract
    };
};



var $b76a4ff75d0d9de2$var$Modal = function(param) {
    var closeModal = param.closeModal, title = param.title, text = param.text;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "fixed top-0 left-0 z-50 w-screen h-screen bg-gray-400 bg-opacity-60",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            className: "relative mx-auto w-full max-w-xl mt-24",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "relative bg-white rounded-xl shadow bg-white p-4",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "flex justify-between items-start mb-5 rounded-t",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h3", {
                                className: "text-xl font-semibold",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                type: "button",
                                className: "text-gray-400 bg-transparent rounded-xl text-sm p-1.5 ml-auto inline-flex items-center",
                                onClick: function() {
                                    return closeModal();
                                },
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
                                    className: "w-5 h-5",
                                    fill: "currentColor",
                                    viewBox: "0 0 20 20",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                        fillRule: "evenodd",
                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                        clipRule: "evenodd"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "mb-6",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: "leading-relaxed",
                            children: text
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "flex items-center rounded-b",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                            type: "button",
                            className: "bg-redstone hover:opacity-75 text-white py-2 px-4 rounded-full",
                            onClick: function() {
                                return closeModal();
                            },
                            children: "Close"
                        })
                    })
                ]
            })
        })
    });
};
var $b76a4ff75d0d9de2$export$2e2bcd8739ae039 = $b76a4ff75d0d9de2$var$Modal;


var $1e464729fed94ea8$exports = {};
"use strict";
var $1e464729fed94ea8$var$__createBinding = $1e464729fed94ea8$exports && $1e464729fed94ea8$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1e464729fed94ea8$var$__exportStar = $1e464729fed94ea8$exports && $1e464729fed94ea8$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1e464729fed94ea8$var$__createBinding(exports1, m, p);
};
Object.defineProperty($1e464729fed94ea8$exports, "__esModule", {
    value: true
});

$1e464729fed94ea8$var$__exportStar((parcelRequire("kHc9u")), $1e464729fed94ea8$exports);

$1e464729fed94ea8$var$__exportStar((parcelRequire("foE9L")), $1e464729fed94ea8$exports);

$1e464729fed94ea8$var$__exportStar((parcelRequire("aUowN")), $1e464729fed94ea8$exports);


var $aca49255d66f39fc$export$6d4e842c29c48185 = function(param) {
    var props = param.props, network = param.network;
    var prices = props.prices, setPrices = props.setPrices, walletAddress = props.walletAddress, starknet = props.starknet;
    var _useMockLoader = (0, $ae7f937efe139789$export$3ca8f5b83ba7703a)(), text = _useMockLoader.text, isMockLoading = _useMockLoader.isMockLoading, setIsMockLoading = _useMockLoader.setIsMockLoading, startMockLoader = _useMockLoader.startMockLoader;
    var connector = new (0, $1e464729fed94ea8$exports.StarknetPricesContractConnector)(starknet === null || starknet === void 0 ? void 0 : starknet.account, network === null || network === void 0 ? void 0 : network.exampleContractAddress);
    var _usePricesContract = (0, $753cc36948ba3c23$export$37ebad50d75f51b)(network, connector, startMockLoader, setPrices, setIsMockLoading, (0, $1e464729fed94ea8$exports.StarknetContractParamsProvider)), blockNumber = _usePricesContract.blockNumber, txHash = _usePricesContract.txHash, timestamp = _usePricesContract.timestamp, isLoading = _usePricesContract.isLoading, getPricesFromPayload = _usePricesContract.getPricesFromPayload, readPricesFromContract = _usePricesContract.readPricesFromContract, writePricesToContract = _usePricesContract.writePricesToContract, errorMessage = _usePricesContract.errorMessage, setErrorMessage = _usePricesContract.setErrorMessage;
    var arePrices = Object.values(prices).every(function(price) {
        return !!price;
    });
    return !starknet ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
        className: "mt-10 mb-0 text-lg font-bold",
        children: "Please sign in to Starknet"
    }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex w-full justify-center items-center mt-8 flex-col",
        children: [
            network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d0adf8410d59fd78$export$f34f01f5ad9bfa8), {
                walletAddress: walletAddress,
                network: network
            }),
            isMockLoading || isLoading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $400629623ad58cec$export$f39eb86f0e5c1a78), {
                text: isMockLoading ? text : ""
            }) : [
                arePrices && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $29fbb8d85bb99ed5$export$d877cf1ea46d4d85), {
                    blockNumber: blockNumber,
                    timestamp: timestamp,
                    prices: prices
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "flex gap-3",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1f09082810955268$export$a6bbb1b7f40755b9), {
                            writePricesToContract: writePricesToContract
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $291736910945f543$export$30ee6dea872700fe), {
                            readPricesFromContract: readPricesFromContract
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1a9f66f6ca0bed1$export$d38cca4e3d3fe8c0), {
                            getPriceFromContract: getPricesFromPayload
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: "px-6 py-3 text-sm w-3/5 text-center text-gray-500",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("i", {
                        children: [
                            "To ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                children: "write"
                            }),
                            " a snapshot of current ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                children: "prices"
                            }),
                            " to the contract's storage you should have ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                children: "testnet ETH"
                            }),
                            " be added to the wallet by using:\xa0",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                target: "blank",
                                href: "https://faucet.goerli.starknet.io/",
                                referrerPolicy: "no-referrer",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("u", {
                                    children: "https://faucet.goerli.starknet.io/"
                                })
                            })
                        ]
                    })
                }),
                network && txHash && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $72f10b3fcf20060f$export$d22914518d6cfe65), {
                    txHash: txHash,
                    network: network
                })
            ],
            !!errorMessage && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b76a4ff75d0d9de2$export$2e2bcd8739ae039), {
                closeModal: function() {
                    return setErrorMessage("");
                },
                title: "Problem with contract interaction",
                text: errorMessage
            })
        ]
    });
};



var $byzP8 = parcelRequire("byzP8");

var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");

var $6cds3 = parcelRequire("6cds3");


var $3vWwE = parcelRequire("3vWwE");

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $ho5gk = parcelRequire("ho5gk");

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $1ObTH = parcelRequire("1ObTH");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
var $37abfb837d2dd31d$export$37dfea93db2e14ed;
var $37abfb837d2dd31d$export$64605811ab45167f;
var $37abfb837d2dd31d$export$b5c0cdb6e6d5b23c;
"use strict";

var $3GDHM = parcelRequire("3GDHM");
var $37abfb837d2dd31d$var$It = {}, $37abfb837d2dd31d$var$ue;
$37abfb837d2dd31d$export$37dfea93db2e14ed = void 0;
var $37abfb837d2dd31d$var$fe;
Object.defineProperty($37abfb837d2dd31d$var$It, "__esModule", {
    value: !0
});
var $37abfb837d2dd31d$var$Ht = $3GDHM;
function $37abfb837d2dd31d$var$Nt(e, t, i, s) {
    return new (i || (i = Promise))(function(r, a) {
        var l = function l(c) {
            try {
                o(s.next(c));
            } catch (g) {
                a(g);
            }
        };
        var n = function n(c) {
            try {
                o(s.throw(c));
            } catch (g) {
                a(g);
            }
        };
        var o = function o(c) {
            var g;
            c.done ? r(c.value) : (g = c.value, g instanceof i ? g : new i(function(u) {
                u(g);
            })).then(l, n);
        };
        o((s = s.apply(e, t || [])).next());
    });
}
function $37abfb837d2dd31d$var$I(e, t, i, s) {
    if (i === "a" && !s) throw new TypeError("Private accessor was defined without a getter");
    if (typeof t == "function" ? e !== t || !s : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return i === "m" ? s : i === "a" ? s.call(e) : s ? s.value : t.get(e);
}
function $37abfb837d2dd31d$var$At(e, t, i, s, r) {
    if (s === "m") throw new TypeError("Private method is not writable");
    if (s === "a" && !r) throw new TypeError("Private accessor was defined without a setter");
    if (typeof t == "function" ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return s === "a" ? r.call(e, i) : r ? r.value = i : t.set(e, i), i;
}
var $37abfb837d2dd31d$var$pe = Array.from([
    {
        id: "braavos",
        name: "Braavos",
        icon: "data:image/svg+xml;base64,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",
        downloads: {
            chrome: "https://chrome.google.com/webstore/detail/braavos-wallet/jnlgamecbpmbajjfhmmmlhejkemejdma",
            firefox: "https://addons.mozilla.org/en-US/firefox/addon/braavos-wallet",
            edge: "https://microsoftedge.microsoft.com/addons/detail/braavos-wallet/hkkpjehhcnhgefhbdcgfkeegglpjchdc"
        }
    },
    {
        id: "argentX",
        name: "Argent X",
        icon: "data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjQwIiBoZWlnaHQ9IjM2IiB2aWV3Qm94PSIwIDAgNDAgMzYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yNC43NTgyIC0zLjk3MzY0ZS0wN0gxNC42MjM4QzE0LjI4NTEgLTMuOTczNjRlLTA3IDE0LjAxMzggMC4yODExNzggMTQuMDA2NCAwLjYzMDY4M0MxMy44MDE3IDEwLjQ1NDkgOC44MjIzNCAxOS43NzkyIDAuMjUxODkzIDI2LjM4MzdDLTAuMDIwMjA0NiAyNi41OTMzIC0wLjA4MjE5NDYgMjYuOTg3MiAwLjExNjczNCAyNy4yNzA5TDYuMDQ2MjMgMzUuNzM0QzYuMjQ3OTYgMzYuMDIyIDYuNjQwOTkgMzYuMDg3IDYuOTE3NjYgMzUuODc1NEMxMi4yNzY1IDMxLjc3MjggMTYuNTg2OSAyNi44MjM2IDE5LjY5MSAyMS4zMzhDMjIuNzk1MSAyNi44MjM2IDI3LjEwNTcgMzEuNzcyOCAzMi40NjQ2IDM1Ljg3NTRDMzIuNzQxIDM2LjA4NyAzMy4xMzQxIDM2LjAyMiAzMy4zMzYxIDM1LjczNEwzOS4yNjU2IDI3LjI3MDlDMzkuNDY0MiAyNi45ODcyIDM5LjQwMjIgMjYuNTkzMyAzOS4xMzA0IDI2LjM4MzdDMzAuNTU5NyAxOS43NzkyIDI1LjU4MDQgMTAuNDU0OSAyNS4zNzU5IDAuNjMwNjgzQzI1LjM2ODUgMC4yODExNzggMjUuMDk2OSAtMy45NzM2NGUtMDcgMjQuNzU4MiAtMy45NzM2NGUtMDdaIiBmaWxsPSIjRkY4NzVCIi8+Cjwvc3ZnPgo=",
        downloads: {
            chrome: "https://chrome.google.com/webstore/detail/argent-x-starknet-wallet/dlcobpjiigpikoobohmabehhmhfoodbb",
            firefox: "https://addons.mozilla.org/en-US/firefox/addon/argent-x"
        }
    }
]);
var $37abfb837d2dd31d$var$Jt = function(e) {
    for(var t = e.length - 1; t > 0; t--){
        var i = Math.floor(Math.random() * (t + 1));
        var ref;
        ref = [
            e[i],
            e[t]
        ], e[t] = ref[0], e[i] = ref[1], ref;
    }
    return e;
}, $37abfb837d2dd31d$var$ge = function(e, t) {
    if (t && Array.isArray(t)) {
        e.sort(function(s, r) {
            return t.indexOf(s.id) - t.indexOf(r.id);
        });
        var i = e.length - t.length;
        return (0, $fLnyw._)(e.slice(i)).concat((0, $fLnyw._)($37abfb837d2dd31d$var$Jt(e.slice(0, i))));
    }
    return t && t !== "random" ? e : $37abfb837d2dd31d$var$Jt(e);
};
function $37abfb837d2dd31d$var$he(e, t) {
    var i, s;
    if (!((i = t === null || t === void 0 ? void 0 : t.include) === null || i === void 0) && i.length) {
        var r = new Set(t.include);
        return e.filter(function(a) {
            return r.has(a.id);
        });
    }
    if (!((s = t === null || t === void 0 ? void 0 : t.exclude) === null || s === void 0) && s.length) {
        var r1 = new Set(t.exclude);
        return e.filter(function(a) {
            return !r1.has(a.id);
        });
    }
    return e;
}
var $37abfb837d2dd31d$var$ht, $37abfb837d2dd31d$var$at, $37abfb837d2dd31d$var$nt, $37abfb837d2dd31d$var$jt, $37abfb837d2dd31d$var$me, $37abfb837d2dd31d$var$Lt;
var $37abfb837d2dd31d$var$Me = /*#__PURE__*/ function() {
    function Me(t) {
        (0, $978gY._)(this, Me);
        $37abfb837d2dd31d$var$ht.add(this), $37abfb837d2dd31d$var$at.set(this, !1), $37abfb837d2dd31d$var$nt.set(this, void 0), $37abfb837d2dd31d$var$jt.set(this, void 0), this.value = void 0, $37abfb837d2dd31d$var$At(this, $37abfb837d2dd31d$var$jt, t, "f"), $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$ht, "m", $37abfb837d2dd31d$var$Lt).call(this);
    }
    (0, $kry2a._)(Me, [
        {
            key: "set",
            value: function set(t) {
                return !(!$37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$at, "f") && !$37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$ht, "m", $37abfb837d2dd31d$var$Lt).call(this)) && (this.delete(), this.value = t, t && ($37abfb837d2dd31d$var$At(this, $37abfb837d2dd31d$var$nt, "".concat($37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$jt, "f"), "-").concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), "f"), localStorage.setItem($37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$nt, "f"), t)), !0);
            }
        },
        {
            key: "get",
            value: function get() {
                return $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$ht, "m", $37abfb837d2dd31d$var$me).call(this), this.value;
            }
        },
        {
            key: "delete",
            value: function _delete() {
                return !(!$37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$at, "f") && !$37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$ht, "m", $37abfb837d2dd31d$var$Lt).call(this)) && (this.value = null, $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$nt, "f") && localStorage.removeItem($37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$nt, "f")), !0);
            }
        }
    ]);
    return Me;
}();
$37abfb837d2dd31d$var$at = new WeakMap, $37abfb837d2dd31d$var$nt = new WeakMap, $37abfb837d2dd31d$var$jt = new WeakMap, $37abfb837d2dd31d$var$ht = new WeakSet, $37abfb837d2dd31d$var$me = function me() {
    this.value && this.set(this.value);
}, $37abfb837d2dd31d$var$Lt = function Lt() {
    var _this = this;
    try {
        $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$at, "f") || (typeof window === "undefined" ? "undefined" : (0, $1ObTH._)(window)) > "u" || ($37abfb837d2dd31d$var$At(this, $37abfb837d2dd31d$var$nt, Object.keys(localStorage).find(function(e) {
            return e.startsWith($37abfb837d2dd31d$var$I(_this, $37abfb837d2dd31d$var$jt, "f"));
        }), "f"), $37abfb837d2dd31d$var$At(this, $37abfb837d2dd31d$var$at, !0, "f"), $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$nt, "f") && this.set(localStorage.getItem($37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$nt, "f"))));
    } catch (e) {}
    return $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$at, "f");
};
var $37abfb837d2dd31d$var$Xt = new $37abfb837d2dd31d$var$Me("gsw-default"), $37abfb837d2dd31d$var$_t = new $37abfb837d2dd31d$var$Me("gsw-last");
function $37abfb837d2dd31d$var$E() {}
var $37abfb837d2dd31d$var$Tt = function(e) {
    return e;
};
function $37abfb837d2dd31d$var$Dt(e, t) {
    for(var i in t)e[i] = t[i];
    return e;
}
function $37abfb837d2dd31d$var$ve(e) {
    return e();
}
function $37abfb837d2dd31d$var$be() {
    return Object.create(null);
}
function $37abfb837d2dd31d$var$U(e) {
    e.forEach($37abfb837d2dd31d$var$ve);
}
function $37abfb837d2dd31d$var$F(e) {
    return typeof e == "function";
}
function $37abfb837d2dd31d$var$H(e, t) {
    return e != e ? t == t : e !== t || e && typeof e == "object" || typeof e == "function";
}
var $37abfb837d2dd31d$var$Pt;
function $37abfb837d2dd31d$var$lt(e, t) {
    return $37abfb837d2dd31d$var$Pt || ($37abfb837d2dd31d$var$Pt = document.createElement("a")), $37abfb837d2dd31d$var$Pt.href = t, e === $37abfb837d2dd31d$var$Pt.href;
}
function $37abfb837d2dd31d$var$B(e, t, i, s) {
    if (e) {
        var r = $37abfb837d2dd31d$var$ye(e, t, i, s);
        return e[0](r);
    }
}
function $37abfb837d2dd31d$var$ye(e, t, i, s) {
    return e[1] && s ? $37abfb837d2dd31d$var$Dt(i.ctx.slice(), e[1](s(t))) : i.ctx;
}
function $37abfb837d2dd31d$var$R(e, t, i, s) {
    if (e[2] && s) {
        var r = e[2](s(i));
        if (t.dirty === void 0) return r;
        if (typeof r == "object") {
            var a = [], l = Math.max(t.dirty.length, r.length);
            for(var n = 0; n < l; n += 1)a[n] = t.dirty[n] | r[n];
            return a;
        }
        return t.dirty | r;
    }
    return t.dirty;
}
function $37abfb837d2dd31d$var$W(e, t, i, s, r, a) {
    if (r) {
        var l = $37abfb837d2dd31d$var$ye(t, i, s, a);
        e.p(l, r);
    }
}
function $37abfb837d2dd31d$var$Q(e) {
    if (e.ctx.length > 32) {
        var t = [], i = e.ctx.length / 32;
        for(var s = 0; s < i; s++)t[s] = -1;
        return t;
    }
    return -1;
}
function $37abfb837d2dd31d$var$we(e, t) {
    var i = {};
    t = new Set(t);
    for(var s in e)t.has(s) || s[0] === "$" || (i[s] = e[s]);
    return i;
}
function $37abfb837d2dd31d$var$it(e) {
    return e && $37abfb837d2dd31d$var$F(e.destroy) ? e.destroy : $37abfb837d2dd31d$var$E;
}
var $37abfb837d2dd31d$var$xe = (typeof window === "undefined" ? "undefined" : (0, $1ObTH._)(window)) < "u";
var $37abfb837d2dd31d$var$qt = $37abfb837d2dd31d$var$xe ? function() {
    return window.performance.now();
} : function() {
    return Date.now();
}, $37abfb837d2dd31d$var$Kt = $37abfb837d2dd31d$var$xe ? function(e) {
    return requestAnimationFrame(e);
} : $37abfb837d2dd31d$var$E;
var $37abfb837d2dd31d$var$mt = new Set;
function $37abfb837d2dd31d$var$Ie(e) {
    $37abfb837d2dd31d$var$mt.forEach(function(t) {
        t.c(e) || ($37abfb837d2dd31d$var$mt.delete(t), t.f());
    }), $37abfb837d2dd31d$var$mt.size !== 0 && $37abfb837d2dd31d$var$Kt($37abfb837d2dd31d$var$Ie);
}
function $37abfb837d2dd31d$var$te(e) {
    var t;
    return $37abfb837d2dd31d$var$mt.size === 0 && $37abfb837d2dd31d$var$Kt($37abfb837d2dd31d$var$Ie), {
        promise: new Promise(function(i) {
            $37abfb837d2dd31d$var$mt.add(t = {
                c: e,
                f: i
            });
        }),
        abort: function() {
            $37abfb837d2dd31d$var$mt.delete(t);
        }
    };
}
function $37abfb837d2dd31d$var$L(e, t) {
    e.appendChild(t);
}
function $37abfb837d2dd31d$var$K(e, t, i) {
    var s = $37abfb837d2dd31d$var$ee(e);
    if (!s.getElementById(t)) {
        var r = $37abfb837d2dd31d$var$S("style");
        r.id = t, r.textContent = i, $37abfb837d2dd31d$var$Ne(s, r);
    }
}
function $37abfb837d2dd31d$var$ee(e) {
    if (!e) return document;
    var t = e.getRootNode ? e.getRootNode() : e.ownerDocument;
    return t && t.host ? t : e.ownerDocument;
}
function $37abfb837d2dd31d$var$qe(e) {
    var t = $37abfb837d2dd31d$var$S("style");
    return $37abfb837d2dd31d$var$Ne($37abfb837d2dd31d$var$ee(e), t), t.sheet;
}
function $37abfb837d2dd31d$var$Ne(e, t) {
    $37abfb837d2dd31d$var$L(e.head || e, t);
}
function $37abfb837d2dd31d$var$$(e, t, i) {
    e.insertBefore(t, i || null);
}
function $37abfb837d2dd31d$var$z(e) {
    e.parentNode.removeChild(e);
}
function $37abfb837d2dd31d$var$S(e) {
    return document.createElement(e);
}
function $37abfb837d2dd31d$var$st(e) {
    return document.createTextNode(e);
}
function $37abfb837d2dd31d$var$_() {
    return $37abfb837d2dd31d$var$st(" ");
}
function $37abfb837d2dd31d$var$ne() {
    return $37abfb837d2dd31d$var$st("");
}
function $37abfb837d2dd31d$var$Y(e, t, i, s) {
    return e.addEventListener(t, i, s), function() {
        return e.removeEventListener(t, i, s);
    };
}
function $37abfb837d2dd31d$var$b(e, t, i) {
    i == null ? e.removeAttribute(t) : e.getAttribute(t) !== i && e.setAttribute(t, i);
}
function $37abfb837d2dd31d$var$Ae(e, t) {
    var i = Object.getOwnPropertyDescriptors(e.__proto__);
    for(var s in t)t[s] == null ? e.removeAttribute(s) : s === "style" ? e.style.cssText = t[s] : s === "__value" ? e.value = e[s] = t[s] : i[s] && i[s].set ? e[s] = t[s] : $37abfb837d2dd31d$var$b(e, s, t[s]);
}
function $37abfb837d2dd31d$var$je(e, t) {
    t = "" + t, e.wholeText !== t && (e.data = t);
}
function $37abfb837d2dd31d$var$T(e, t, i, s) {
    i === null ? e.style.removeProperty(t) : e.style.setProperty(t, i, s ? "important" : "");
}
function $37abfb837d2dd31d$var$y(e, t, i) {
    e.classList[i ? "add" : "remove"](t);
}
var $37abfb837d2dd31d$var$Et = new Map;
var $37abfb837d2dd31d$var$zt, $37abfb837d2dd31d$var$Ft = 0;
function $37abfb837d2dd31d$var$Bt(e, t, i, s, r, a, l) {
    var n = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : 0;
    var o = 16.666 / s;
    var c = "{\n";
    for(var h = 0; h <= 1; h += o){
        var x = t + (i - t) * a(h);
        c += 100 * h + "%{".concat(l(x, 1 - x), "}\n");
    }
    var g = c + "100% {".concat(l(i, 1 - i), "}\n}"), u = "__svelte_".concat(function(h) {
        var x = 5381, N = h.length;
        for(; N--;)x = (x << 5) - x ^ h.charCodeAt(N);
        return x >>> 0;
    }(g), "_").concat(n), d = $37abfb837d2dd31d$var$ee(e), _ref = $37abfb837d2dd31d$var$Et.get(d) || function(h, x) {
        var N = {
            stylesheet: $37abfb837d2dd31d$var$qe(x),
            rules: {}
        };
        return $37abfb837d2dd31d$var$Et.set(h, N), N;
    }(d, e), f = _ref.stylesheet, p = _ref.rules;
    p[u] || (p[u] = !0, f.insertRule("@keyframes ".concat(u, " ").concat(g), f.cssRules.length));
    var m = e.style.animation || "";
    return e.style.animation = "".concat(m ? "".concat(m, ", ") : "").concat(u, " ").concat(s, "ms linear ").concat(r, "ms 1 both"), $37abfb837d2dd31d$var$Ft += 1, u;
}
function $37abfb837d2dd31d$var$Rt(e, t) {
    var i = (e.style.animation || "").split(", "), s = i.filter(t ? function(a) {
        return a.indexOf(t) < 0;
    } : function(a) {
        return a.indexOf("__svelte") === -1;
    }), r = i.length - s.length;
    r && (e.style.animation = s.join(", "), $37abfb837d2dd31d$var$Ft -= r, $37abfb837d2dd31d$var$Ft || $37abfb837d2dd31d$var$Kt(function() {
        $37abfb837d2dd31d$var$Ft || ($37abfb837d2dd31d$var$Et.forEach(function(a) {
            var l = a.stylesheet;
            var n = l.cssRules.length;
            for(; n--;)l.deleteRule(n);
            a.rules = {};
        }), $37abfb837d2dd31d$var$Et.clear());
    }));
}
function $37abfb837d2dd31d$var$$t(e) {
    $37abfb837d2dd31d$var$zt = e;
}
function $37abfb837d2dd31d$var$De() {
    if (!$37abfb837d2dd31d$var$zt) throw new Error("Function called outside component initialization");
    return $37abfb837d2dd31d$var$zt;
}
function $37abfb837d2dd31d$var$kt(e) {
    return $37abfb837d2dd31d$var$De().$$.context.get(e);
}
function $37abfb837d2dd31d$var$rt(e, t) {
    var _this = this;
    var i = e.$$.callbacks[t.type];
    i && i.slice().forEach(function(s) {
        return s.call(_this, t);
    });
}
var $37abfb837d2dd31d$var$St = [], $37abfb837d2dd31d$var$Wt = [], $37abfb837d2dd31d$var$Qt = [], $37abfb837d2dd31d$var$ie = [], $37abfb837d2dd31d$var$Ke = Promise.resolve();
var $37abfb837d2dd31d$var$se = !1;
function $37abfb837d2dd31d$var$ot(e) {
    $37abfb837d2dd31d$var$Qt.push(e);
}
var $37abfb837d2dd31d$var$re = new Set;
var $37abfb837d2dd31d$var$Ot, $37abfb837d2dd31d$var$Ut = 0;
function $37abfb837d2dd31d$var$ze() {
    var e = $37abfb837d2dd31d$var$zt;
    do {
        for(; $37abfb837d2dd31d$var$Ut < $37abfb837d2dd31d$var$St.length;){
            var t = $37abfb837d2dd31d$var$St[$37abfb837d2dd31d$var$Ut];
            $37abfb837d2dd31d$var$Ut++, $37abfb837d2dd31d$var$$t(t), $37abfb837d2dd31d$var$tn(t.$$);
        }
        for($37abfb837d2dd31d$var$$t(null), $37abfb837d2dd31d$var$St.length = 0, $37abfb837d2dd31d$var$Ut = 0; $37abfb837d2dd31d$var$Wt.length;)$37abfb837d2dd31d$var$Wt.pop()();
        for(var t1 = 0; t1 < $37abfb837d2dd31d$var$Qt.length; t1 += 1){
            var i = $37abfb837d2dd31d$var$Qt[t1];
            $37abfb837d2dd31d$var$re.has(i) || ($37abfb837d2dd31d$var$re.add(i), i());
        }
        $37abfb837d2dd31d$var$Qt.length = 0;
    }while ($37abfb837d2dd31d$var$St.length);
    for(; $37abfb837d2dd31d$var$ie.length;)$37abfb837d2dd31d$var$ie.pop()();
    $37abfb837d2dd31d$var$se = !1, $37abfb837d2dd31d$var$re.clear(), $37abfb837d2dd31d$var$$t(e);
}
function $37abfb837d2dd31d$var$tn(e) {
    if (e.fragment !== null) {
        e.update(), $37abfb837d2dd31d$var$U(e.before_update);
        var t = e.dirty;
        e.dirty = [
            -1
        ], e.fragment && e.fragment.p(e.ctx, t), e.after_update.forEach($37abfb837d2dd31d$var$ot);
    }
}
function $37abfb837d2dd31d$var$oe() {
    return $37abfb837d2dd31d$var$Ot || ($37abfb837d2dd31d$var$Ot = Promise.resolve(), $37abfb837d2dd31d$var$Ot.then(function() {
        $37abfb837d2dd31d$var$Ot = null;
    })), $37abfb837d2dd31d$var$Ot;
}
function $37abfb837d2dd31d$var$ct(e, t, i) {
    e.dispatchEvent(function(s, r) {
        var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, tmp = _ref.bubbles, a = tmp === void 0 ? !1 : tmp, tmp1 = _ref.cancelable, l = tmp1 === void 0 ? !1 : tmp1;
        var n = document.createEvent("CustomEvent");
        return n.initCustomEvent(s, a, l, r), n;
    }("".concat(t ? "intro" : "outro").concat(i)));
}
var $37abfb837d2dd31d$var$Yt = new Set;
var $37abfb837d2dd31d$var$tt;
function $37abfb837d2dd31d$var$Mt() {
    $37abfb837d2dd31d$var$tt = {
        r: 0,
        c: [],
        p: $37abfb837d2dd31d$var$tt
    };
}
function $37abfb837d2dd31d$var$vt() {
    $37abfb837d2dd31d$var$tt.r || $37abfb837d2dd31d$var$U($37abfb837d2dd31d$var$tt.c), $37abfb837d2dd31d$var$tt = $37abfb837d2dd31d$var$tt.p;
}
function $37abfb837d2dd31d$var$j(e, t) {
    e && e.i && ($37abfb837d2dd31d$var$Yt.delete(e), e.i(t));
}
function $37abfb837d2dd31d$var$k(e, t, i, s) {
    if (e && e.o) {
        if ($37abfb837d2dd31d$var$Yt.has(e)) return;
        $37abfb837d2dd31d$var$Yt.add(e), $37abfb837d2dd31d$var$tt.c.push(function() {
            $37abfb837d2dd31d$var$Yt.delete(e), s && (i && e.d(1), s());
        }), e.o(t);
    } else s && s();
}
var $37abfb837d2dd31d$var$ae = {
    duration: 0
};
function $37abfb837d2dd31d$var$$e(e, t, i, s) {
    var c = function c() {
        o && $37abfb837d2dd31d$var$Rt(e, o);
    };
    var g = function g(d, f) {
        var p = d.b - a;
        return f *= Math.abs(p), {
            a: a,
            b: d.b,
            d: p,
            duration: f,
            start: d.start,
            end: d.start + f,
            group: d.group
        };
    };
    var u = function u(d) {
        var _ref = r || $37abfb837d2dd31d$var$ae, tmp = _ref.delay, f = tmp === void 0 ? 0 : tmp, tmp1 = _ref.duration, p = tmp1 === void 0 ? 300 : tmp1, tmp2 = _ref.easing, m = tmp2 === void 0 ? $37abfb837d2dd31d$var$Tt : tmp2, tmp3 = _ref.tick, h = tmp3 === void 0 ? $37abfb837d2dd31d$var$E : tmp3, x = _ref.css, N = {
            start: $37abfb837d2dd31d$var$qt() + f,
            b: d
        };
        d || (N.group = $37abfb837d2dd31d$var$tt, $37abfb837d2dd31d$var$tt.r += 1), l || n ? n = N : (x && (c(), o = $37abfb837d2dd31d$var$Bt(e, a, d, p, f, m, x)), d && h(0, 1), l = g(N, p), $37abfb837d2dd31d$var$ot(function() {
            return $37abfb837d2dd31d$var$ct(e, d, "start");
        }), $37abfb837d2dd31d$var$te(function(M) {
            if (n && M > n.start && (l = g(n, p), n = null, $37abfb837d2dd31d$var$ct(e, l.b, "start"), x && (c(), o = $37abfb837d2dd31d$var$Bt(e, a, l.b, l.duration, 0, m, r.css))), l) {
                if (M >= l.end) h(a = l.b, 1 - a), $37abfb837d2dd31d$var$ct(e, l.b, "end"), n || (l.b ? c() : --l.group.r || $37abfb837d2dd31d$var$U(l.group.c)), l = null;
                else if (M >= l.start) {
                    var w = M - l.start;
                    a = l.a + l.d * m(w / l.duration), h(a, 1 - a);
                }
            }
            return !(!l && !n);
        }));
    };
    var r = t(e, i), a = s ? 0 : 1, l = null, n = null, o = null;
    return {
        run: function(d) {
            $37abfb837d2dd31d$var$F(r) ? $37abfb837d2dd31d$var$oe().then(function() {
                r = r(), u(d);
            }) : u(d);
        },
        end: function() {
            c(), l = n = null;
        }
    };
}
function $37abfb837d2dd31d$var$ke(e, t) {
    var i = {}, s = {}, r = {
        $$scope: 1
    };
    var a = e.length;
    for(; a--;){
        var l = e[a], n = t[a];
        if (n) {
            for(var o in l)o in n || (s[o] = 1);
            for(var o1 in n)r[o1] || (i[o1] = n[o1], r[o1] = 1);
            e[a] = n;
        } else for(var o2 in l)r[o2] = 1;
    }
    for(var l1 in s)l1 in i || (i[l1] = void 0);
    return i;
}
function $37abfb837d2dd31d$var$J(e) {
    e && e.c();
}
function $37abfb837d2dd31d$var$G(e, t, i, s) {
    var _e_$$ = e.$$, r = _e_$$.fragment, a = _e_$$.on_mount, l = _e_$$.on_destroy, n = _e_$$.after_update;
    r && r.m(t, i), s || $37abfb837d2dd31d$var$ot(function() {
        var _l;
        var o = a.map($37abfb837d2dd31d$var$ve).filter($37abfb837d2dd31d$var$F);
        l ? (_l = l).push.apply(_l, (0, $fLnyw._)(o)) : $37abfb837d2dd31d$var$U(o), e.$$.on_mount = [];
    }), n.forEach($37abfb837d2dd31d$var$ot);
}
function $37abfb837d2dd31d$var$Z(e, t) {
    var i = e.$$;
    i.fragment !== null && ($37abfb837d2dd31d$var$U(i.on_destroy), i.fragment && i.fragment.d(t), i.on_destroy = i.fragment = null, i.ctx = []);
}
function $37abfb837d2dd31d$var$en(e, t) {
    e.$$.dirty[0] === -1 && ($37abfb837d2dd31d$var$St.push(e), $37abfb837d2dd31d$var$se || ($37abfb837d2dd31d$var$se = !0, $37abfb837d2dd31d$var$Ke.then($37abfb837d2dd31d$var$ze)), e.$$.dirty.fill(0)), e.$$.dirty[t / 31 | 0] |= 1 << t % 31;
}
function $37abfb837d2dd31d$var$X(e, t, i, s, r, a, l) {
    var n = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : [
        -1
    ];
    var o = $37abfb837d2dd31d$var$zt;
    $37abfb837d2dd31d$var$$t(e);
    var c = e.$$ = {
        fragment: null,
        ctx: null,
        props: a,
        update: $37abfb837d2dd31d$var$E,
        not_equal: r,
        bound: $37abfb837d2dd31d$var$be(),
        on_mount: [],
        on_destroy: [],
        on_disconnect: [],
        before_update: [],
        after_update: [],
        context: new Map(t.context || (o ? o.$$.context : [])),
        callbacks: $37abfb837d2dd31d$var$be(),
        dirty: n,
        skip_bound: !1,
        root: t.target || o.$$.root
    };
    l && l(c.root);
    var g = !1;
    if (c.ctx = i ? i(e, t.props || {}, function(u, d) {
        for(var _len = arguments.length, f = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            f[_key - 2] = arguments[_key];
        }
        var p = f.length ? f[0] : d;
        return c.ctx && r(c.ctx[u], c.ctx[u] = p) && (!c.skip_bound && c.bound[u] && c.bound[u](p), g && $37abfb837d2dd31d$var$en(e, u)), d;
    }) : [], c.update(), g = !0, $37abfb837d2dd31d$var$U(c.before_update), c.fragment = !!s && s(c.ctx), t.target) {
        if (t.hydrate) {
            var u = function(d) {
                return Array.from(d.childNodes);
            }(t.target);
            c.fragment && c.fragment.l(u), u.forEach($37abfb837d2dd31d$var$z);
        } else c.fragment && c.fragment.c();
        t.intro && $37abfb837d2dd31d$var$j(e.$$.fragment), $37abfb837d2dd31d$var$G(e, t.target, t.anchor, t.customElement), $37abfb837d2dd31d$var$ze();
    }
    $37abfb837d2dd31d$var$$t(o);
}
var $37abfb837d2dd31d$var$q = /*#__PURE__*/ function() {
    function q() {
        (0, $978gY._)(this, q);
    }
    (0, $kry2a._)(q, [
        {
            key: "$destroy",
            value: function $destroy() {
                $37abfb837d2dd31d$var$Z(this, 1), this.$destroy = $37abfb837d2dd31d$var$E;
            }
        },
        {
            key: "$on",
            value: function $on(t, i) {
                var s = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
                return s.push(i), function() {
                    var r = s.indexOf(i);
                    r !== -1 && s.splice(r, 1);
                };
            }
        },
        {
            key: "$set",
            value: function $set(t) {
                var i;
                this.$$set && (i = t, Object.keys(i).length !== 0) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
            }
        }
    ]);
    return q;
}();
var $37abfb837d2dd31d$var$nn = {
    color: "currentColor",
    class: "",
    opacity: .1,
    centered: !1,
    spreadingDuration: ".4s",
    spreadingDelay: "0s",
    spreadingTimingFunction: "linear",
    clearingDuration: "1s",
    clearingDelay: "0s",
    clearingTimingFunction: "ease-in-out"
};
function $37abfb837d2dd31d$var$Se(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    e.stopImmediatePropagation();
    var i = (0, $8OnJk._)({}, $37abfb837d2dd31d$var$nn, t), s = !!e.touches && !!e.touches[0], r = s ? e.touches[0].currentTarget : e.currentTarget, a = document.createElement("div"), l = a.style;
    a.className = "material-ripple ".concat(i.class), l.position = "absolute", l.color = "inherit", l.borderRadius = "50%", l.pointerEvents = "none", l.width = "100px", l.height = "100px", l.marginTop = "-50px", l.marginLeft = "-50px", r.appendChild(a), l.opacity = i.opacity, l.transition = "transform ".concat(i.spreadingDuration, " ").concat(i.spreadingTimingFunction, " ").concat(i.spreadingDelay, ",opacity ").concat(i.clearingDuration, " ").concat(i.clearingTimingFunction, " ").concat(i.clearingDelay), l.transform = "scale(0) translate(0,0)", l.background = i.color;
    var n = r.getBoundingClientRect();
    if (i.centered) l.top = n.height / 2 + "px", l.left = n.width / 2 + "px";
    else {
        var o = s ? e.touches[0].clientY : e.clientY, c = s ? e.touches[0].clientX : e.clientX;
        l.top = o - n.top + "px", l.left = c - n.left + "px";
    }
    return l.transform = "scale(".concat(.02 * Math.max(n.width, n.height), ") translate(0,0)"), a;
}
var $37abfb837d2dd31d$var$Oe = function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var g = function g() {
        e.classList.add("s-ripple-container"), e.addEventListener("pointerdown", l), e.addEventListener("pointerup", n), e.addEventListener("pointerleave", n), e.addEventListener("keydown", o), e.addEventListener("keyup", c), r = !1;
    };
    var u = function u() {
        e.classList.remove("s-ripple-container"), e.removeEventListener("pointerdown", l), e.removeEventListener("pointerup", n), e.removeEventListener("pointerleave", n), e.removeEventListener("keydown", o), e.removeEventListener("keyup", c), r = !0;
    };
    var i, s = t, r = !1, a = !1;
    var l = function(d) {
        i = $37abfb837d2dd31d$var$Se(d, s);
    }, n = function() {
        return function(d) {
            d && (d.addEventListener("transitionend", function(f) {
                f.propertyName === "opacity" && d.remove();
            }), d.style.opacity = 0);
        }(i);
    }, o = function(d) {
        a || d.keyCode !== 13 && d.keyCode !== 32 || (i = $37abfb837d2dd31d$var$Se(d, (0, $8E768._)((0, $8OnJk._)({}, s), {
            centered: !0
        })), a = !0);
    }, c = function() {
        a = !1, n();
    };
    return s && g(), {
        update: function(d) {
            s = d, s && r ? g() : s || r || u();
        },
        destroy: u
    };
};
function $37abfb837d2dd31d$var$Ce(e) {
    return typeof e == "number" ? "".concat(e, "px") : e;
}
var $37abfb837d2dd31d$var$sn = function(e, t) {
    var i = t;
    return Object.entries(i).forEach(function(param) {
        var _param = (0, $8GFUW._)(param, 2), s = _param[0], r = _param[1];
        r && e.style.setProperty("--s-".concat(s), $37abfb837d2dd31d$var$Ce(r));
    }), {
        update: function(s) {
            Object.entries(s).forEach(function(param) {
                var _param = (0, $8GFUW._)(param, 2), r = _param[0], a = _param[1];
                a && (e.style.setProperty("--s-".concat(r), $37abfb837d2dd31d$var$Ce(a)), delete i[r]);
            }), Object.keys(i).forEach(function(r) {
                return e.style.removeProperty("--s-".concat(r));
            }), i = s;
        }
    };
};
var $37abfb837d2dd31d$var$le = function(e) {
    return e.split(" ").filter(function(t) {
        return !!t;
    });
};
var $37abfb837d2dd31d$var$Le = function(e, t) {
    var _e_classList;
    var i = t;
    return (_e_classList = e.classList).add.apply(_e_classList, (0, $fLnyw._)($37abfb837d2dd31d$var$le((function(s) {
        return s.filter(function(r) {
            return !!r;
        });
    })(i).join(" ")))), {
        update: function(s) {
            var r = s;
            r.forEach(function(a, l) {
                var _e_classList, _e_classList1;
                a ? (_e_classList = e.classList).add.apply(_e_classList, (0, $fLnyw._)($37abfb837d2dd31d$var$le(a))) : i[l] && (_e_classList1 = e.classList).remove.apply(_e_classList1, (0, $fLnyw._)($37abfb837d2dd31d$var$le(i[l])));
            }), i = r;
        }
    };
};
function $37abfb837d2dd31d$var$rn(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-1is7e95", '.s-btn{align-items:center;border-radius:4px;display:inline-flex;flex:0 0 auto;overflow:hidden;position:relative;outline:0;justify-content:center;user-select:none;vertical-align:middle;white-space:nowrap;text-decoration:none;transition-duration:0.28s;transition-property:box-shadow, transform, opacity;background-color:var(--theme-app-bar);box-shadow:0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)}.s-btn .s-icon,.s-btn a{color:inherit}.s-btn .s-btn__content{display:flex;align-items:center;flex:1 0 auto;color:inherit;justify-content:inherit;line-height:normal;position:relative;font-size:inherit;font-weight:500;letter-spacing:0.0892857143em;text-transform:uppercase}.s-btn:before{border-radius:inherit;bottom:0;color:inherit;content:"";left:0;opacity:0;pointer-events:none;position:absolute;right:0;top:0;transition:opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);background-color:currentColor}.s-btn.size-x-small{font-size:0.625rem}.s-btn.size-small{font-size:0.75rem}.s-btn.size-default,.s-btn.size-large{font-size:0.875rem}.s-btn.size-x-large{font-size:1rem}.s-btn:not(.disabled):hover:before{opacity:0.08}.s-btn:not(.disabled).active:before{opacity:0.18}.s-btn:not(.disabled).focus-visible:before{opacity:0.24}.s-btn:not(.outlined).error-color,.s-btn:not(.outlined).info-color,.s-btn:not(.outlined).primary-color,.s-btn:not(.outlined).secondary-color,.s-btn:not(.outlined).success-color,.s-btn:not(.outlined).warning-color{color:#fff}.s-btn:not(.icon):not(.s-btn--fab).size-x-small{height:20px;min-width:36px;padding:0 8.8888888889px}.s-btn:not(.icon):not(.s-btn--fab).size-small{height:28px;min-width:50px;padding:0 12.4444444444px}.s-btn:not(.icon):not(.s-btn--fab).size-default{height:36px;min-width:64px;padding:0 16px}.s-btn:not(.icon):not(.s-btn--fab).size-large{height:44px;min-width:78px;padding:0 19.5555555556px}.s-btn:not(.icon):not(.s-btn--fab).size-x-large{height:52px;min-width:92px;padding:0 23.1111111111px}.s-btn:not(.disabled):not(.depressed){will-change:box-shadow}.s-btn.block{display:flex;flex:1 0 auto;min-width:100% !important;max-width:auto}.s-btn.tile{border-radius:0}.s-btn.text{background-color:transparent}.s-btn.depressed{box-shadow:none}.s-btn.outlined{border:1px solid;background-color:transparent !important}.s-btn.rounded{border-radius:9999px}.s-btn.disabled{pointer-events:none;color:var(--theme-buttons-disabled)}.s-btn.disabled:not(.flat):not(.text):not(.outlined){background-color:var(--theme-buttons-disabled)}.s-btn.icon.size-x-small{height:20px;width:20px}.s-btn.icon.size-small{height:28px;width:28px}.s-btn.icon.size-default{height:36px;width:36px}.s-btn.icon.size-large{height:44px;width:44px}.s-btn.icon.size-x-large{height:52px;width:52px}.s-btn.icon,.s-btn.s-btn--fab{border-radius:50%;min-width:0;min-height:0;padding:0}.s-btn.icon.size-x-small .s-icon,.s-btn.s-btn--fab.size-x-small .s-icon{font-size:18px}.s-btn.icon.size-default .s-icon,.s-btn.icon.size-small .s-icon,.s-btn.s-btn--fab.size-default .s-icon,.s-btn.s-btn--fab.size-small .s-icon{font-size:24px}.s-btn.icon.size-large .s-icon,.s-btn.s-btn--fab.size-large .s-icon{font-size:28px}.s-btn.icon.size-x-large .s-icon,.s-btn.s-btn--fab.size-x-large .s-icon{font-size:32px}.s-btn.s-btn--fab.size-x-small{height:32px;width:32px}.s-btn.s-btn--fab.size-small{height:40px;width:40px}.s-btn.s-btn--fab.size-default{height:56px;width:56px}.s-btn.s-btn--fab.size-large{height:64px;width:64px}.s-btn.s-btn--fab.size-x-large{height:72px;width:72px}');
}
function $37abfb837d2dd31d$var$on(e) {
    var t, i, s, r, a, l, n, o;
    var c = e[19].default, g = $37abfb837d2dd31d$var$B(c, e, e[18], null);
    var u = [
        {
            class: s = "s-btn size-" + e[5] + " " + e[1]
        },
        {
            type: e[14]
        },
        {
            style: e[16]
        },
        {
            disabled: e[11]
        },
        {
            "aria-disabled": e[11]
        },
        e[17]
    ], d = {};
    for(var f = 0; f < u.length; f += 1)d = $37abfb837d2dd31d$var$Dt(d, u[f]);
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("button"), i = $37abfb837d2dd31d$var$S("span"), g && g.c(), $37abfb837d2dd31d$var$b(i, "class", "s-btn__content"), $37abfb837d2dd31d$var$Ae(t, d), $37abfb837d2dd31d$var$y(t, "s-btn--fab", e[2]), $37abfb837d2dd31d$var$y(t, "icon", e[3]), $37abfb837d2dd31d$var$y(t, "block", e[4]), $37abfb837d2dd31d$var$y(t, "tile", e[6]), $37abfb837d2dd31d$var$y(t, "text", e[7] || e[3]), $37abfb837d2dd31d$var$y(t, "depressed", e[8] || e[7] || e[11] || e[9] || e[3]), $37abfb837d2dd31d$var$y(t, "outlined", e[9]), $37abfb837d2dd31d$var$y(t, "rounded", e[10]), $37abfb837d2dd31d$var$y(t, "disabled", e[11]);
        },
        m: function(f, p) {
            $37abfb837d2dd31d$var$$(f, t, p), $37abfb837d2dd31d$var$L(t, i), g && g.m(i, null), t.autofocus && t.focus(), e[21](t), l = !0, n || (o = [
                $37abfb837d2dd31d$var$it(r = $37abfb837d2dd31d$var$Le.call(null, t, [
                    e[12] && e[13]
                ])),
                $37abfb837d2dd31d$var$it(a = $37abfb837d2dd31d$var$Oe.call(null, t, e[15])),
                $37abfb837d2dd31d$var$Y(t, "click", e[20])
            ], n = !0);
        },
        p: function(f, param) {
            var _param = (0, $8GFUW._)(param, 1), p = _param[0];
            g && g.p && (!l || 262144 & p) && $37abfb837d2dd31d$var$W(g, c, f, f[18], l ? $37abfb837d2dd31d$var$R(c, f[18], p, null) : $37abfb837d2dd31d$var$Q(f[18]), null), $37abfb837d2dd31d$var$Ae(t, d = $37abfb837d2dd31d$var$ke(u, [
                (!l || 34 & p && s !== (s = "s-btn size-" + f[5] + " " + f[1])) && {
                    class: s
                },
                (!l || 16384 & p) && {
                    type: f[14]
                },
                (!l || 65536 & p) && {
                    style: f[16]
                },
                (!l || 2048 & p) && {
                    disabled: f[11]
                },
                (!l || 2048 & p) && {
                    "aria-disabled": f[11]
                },
                131072 & p && f[17]
            ])), r && $37abfb837d2dd31d$var$F(r.update) && 12288 & p && r.update.call(null, [
                f[12] && f[13]
            ]), a && $37abfb837d2dd31d$var$F(a.update) && 32768 & p && a.update.call(null, f[15]), $37abfb837d2dd31d$var$y(t, "s-btn--fab", f[2]), $37abfb837d2dd31d$var$y(t, "icon", f[3]), $37abfb837d2dd31d$var$y(t, "block", f[4]), $37abfb837d2dd31d$var$y(t, "tile", f[6]), $37abfb837d2dd31d$var$y(t, "text", f[7] || f[3]), $37abfb837d2dd31d$var$y(t, "depressed", f[8] || f[7] || f[11] || f[9] || f[3]), $37abfb837d2dd31d$var$y(t, "outlined", f[9]), $37abfb837d2dd31d$var$y(t, "rounded", f[10]), $37abfb837d2dd31d$var$y(t, "disabled", f[11]);
        },
        i: function(f) {
            l || ($37abfb837d2dd31d$var$j(g, f), l = !0);
        },
        o: function(f) {
            $37abfb837d2dd31d$var$k(g, f), l = !1;
        },
        d: function(f) {
            f && $37abfb837d2dd31d$var$z(t), g && g.d(f), e[21](null), n = !1, $37abfb837d2dd31d$var$U(o);
        }
    };
}
function $37abfb837d2dd31d$var$an(e, t, i) {
    var s = [
        "class",
        "fab",
        "icon",
        "block",
        "size",
        "tile",
        "text",
        "depressed",
        "outlined",
        "rounded",
        "disabled",
        "active",
        "activeClass",
        "type",
        "ripple",
        "style",
        "button"
    ];
    var r = $37abfb837d2dd31d$var$we(t, s), tmp = t.$$slots, a = tmp === void 0 ? {} : tmp, l = t.$$scope, tmp1 = t.class, n = tmp1 === void 0 ? "" : tmp1, tmp2 = t.fab, o = tmp2 === void 0 ? !1 : tmp2, tmp3 = t.icon, c = tmp3 === void 0 ? !1 : tmp3, tmp4 = t.block, g = tmp4 === void 0 ? !1 : tmp4, tmp5 = t.size, u = tmp5 === void 0 ? "default" : tmp5, tmp6 = t.tile, d = tmp6 === void 0 ? !1 : tmp6, tmp7 = t.text, f = tmp7 === void 0 ? !1 : tmp7, tmp8 = t.depressed, p = tmp8 === void 0 ? !1 : tmp8, tmp9 = t.outlined, m = tmp9 === void 0 ? !1 : tmp9, tmp10 = t.rounded, h = tmp10 === void 0 ? !1 : tmp10, tmp11 = t.disabled, x = tmp11 === void 0 ? null : tmp11, tmp12 = t.active, N = tmp12 === void 0 ? !1 : tmp12, tmp13 = t.activeClass, M = tmp13 === void 0 ? "active" : tmp13, tmp14 = t.type, w = tmp14 === void 0 ? "button" : tmp14, tmp15 = t.ripple, A = tmp15 === void 0 ? {} : tmp15, tmp16 = t.style, C = tmp16 === void 0 ? null : tmp16, tmp17 = t.button, O = tmp17 === void 0 ? null : tmp17;
    return e.$$set = function(v) {
        t = $37abfb837d2dd31d$var$Dt($37abfb837d2dd31d$var$Dt({}, t), function(D) {
            var P = {};
            for(var et in D)et[0] !== "$" && (P[et] = D[et]);
            return P;
        }(v)), i(17, r = $37abfb837d2dd31d$var$we(t, s)), "class" in v && i(1, n = v.class), "fab" in v && i(2, o = v.fab), "icon" in v && i(3, c = v.icon), "block" in v && i(4, g = v.block), "size" in v && i(5, u = v.size), "tile" in v && i(6, d = v.tile), "text" in v && i(7, f = v.text), "depressed" in v && i(8, p = v.depressed), "outlined" in v && i(9, m = v.outlined), "rounded" in v && i(10, h = v.rounded), "disabled" in v && i(11, x = v.disabled), "active" in v && i(12, N = v.active), "activeClass" in v && i(13, M = v.activeClass), "type" in v && i(14, w = v.type), "ripple" in v && i(15, A = v.ripple), "style" in v && i(16, C = v.style), "button" in v && i(0, O = v.button), "$$scope" in v && i(18, l = v.$$scope);
    }, [
        O,
        n,
        o,
        c,
        g,
        u,
        d,
        f,
        p,
        m,
        h,
        x,
        N,
        M,
        w,
        A,
        C,
        r,
        l,
        a,
        function(v) {
            $37abfb837d2dd31d$var$rt.call(this, e, v);
        },
        function(v) {
            $37abfb837d2dd31d$var$Wt[v ? "unshift" : "push"](function() {
                O = v, i(0, O);
            });
        }
    ];
}
var $37abfb837d2dd31d$var$ln = /*#__PURE__*/ function(q) {
    (0, $ftJVG._)(ln, q);
    var _super = (0, $6OZAO._)(ln);
    function ln(t) {
        (0, $978gY._)(this, ln);
        var _this;
        _this = _super.call(this), $37abfb837d2dd31d$var$X((0, $3vWwE._)(_this), t, $37abfb837d2dd31d$var$an, $37abfb837d2dd31d$var$on, $37abfb837d2dd31d$var$H, {
            class: 1,
            fab: 2,
            icon: 3,
            block: 4,
            size: 5,
            tile: 6,
            text: 7,
            depressed: 8,
            outlined: 9,
            rounded: 10,
            disabled: 11,
            active: 12,
            activeClass: 13,
            type: 14,
            ripple: 15,
            style: 16,
            button: 0
        }, $37abfb837d2dd31d$var$rn);
        return (0, $ho5gk._)(_this);
    }
    return ln;
}($37abfb837d2dd31d$var$q);
var $37abfb837d2dd31d$var$_e = 36, $37abfb837d2dd31d$var$cn = "";
for(; $37abfb837d2dd31d$var$_e--;)$37abfb837d2dd31d$var$cn += $37abfb837d2dd31d$var$_e.toString(36);
function $37abfb837d2dd31d$var$dn(e) {
    var t = e - 1;
    return t * t * t + 1;
}
function $37abfb837d2dd31d$var$un(e) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.delay, t = tmp === void 0 ? 0 : tmp, tmp1 = _ref.duration, i = tmp1 === void 0 ? 400 : tmp1, tmp2 = _ref.easing, s = tmp2 === void 0 ? $37abfb837d2dd31d$var$Tt : tmp2;
    var r = +getComputedStyle(e).opacity;
    return {
        delay: t,
        duration: i,
        easing: s,
        css: function(a) {
            return "opacity: " + a * r;
        }
    };
}
function $37abfb837d2dd31d$var$fn(e) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.delay, t = tmp === void 0 ? 0 : tmp, tmp1 = _ref.duration, i = tmp1 === void 0 ? 400 : tmp1, tmp2 = _ref.easing, s = tmp2 === void 0 ? $37abfb837d2dd31d$var$dn : tmp2, tmp3 = _ref.start, r = tmp3 === void 0 ? 0 : tmp3, tmp4 = _ref.opacity, a = tmp4 === void 0 ? 0 : tmp4;
    var l = getComputedStyle(e), n = +l.opacity, o = l.transform === "none" ? "" : l.transform, c = 1 - r, g = n * (1 - a);
    return {
        delay: t,
        duration: i,
        easing: s,
        css: function(u, d) {
            return "\n			transform: ".concat(o, " scale(").concat(1 - c * d, ");\n			opacity: ").concat(n - g * d, "\n		");
        }
    };
}
function $37abfb837d2dd31d$var$pn(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-1qc2404", ".s-list{color:var(--theme-text-primary);display:block;padding:8px 0;position:static}.s-list .s-subheader{padding-top:0}.s-list .s-list-item.active{color:inherit}.s-list.disabled{pointer-events:none}.s-list.dense .s-subheader{font-size:0.75rem;height:40px;padding:0 8px}.s-list.rounded{padding:8px}.s-list.rounded .s-list-item{border-radius:32px !important}.s-list.nav{padding-left:8px;padding-right:8px}.s-list.nav .s-list-item{padding:0 8px;border-radius:4px}.s-list.nav .s-list-item:before{border-radius:4px}.s-list.nav .s-list-item:not(:last-child):not(:only-child),.s-list.rounded .s-list-item:not(:last-child):not(:only-child){margin-bottom:8px}.s-list.nav .s-list-item.dense:not(:last-child):not(:only-child),.s-list.rounded .s-list-item.dense:not(:last-child):not(:only-child){margin-bottom:4px}.s-list.outlined{border:thin solid var(--theme-dividers)}.s-list.flat .s-list-item:before{display:none}");
}
function $37abfb837d2dd31d$var$gn(e) {
    var t, i, s;
    var r = e[10].default, a = $37abfb837d2dd31d$var$B(r, e, e[9], null);
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("div"), a && a.c(), $37abfb837d2dd31d$var$b(t, "role", e[8]), $37abfb837d2dd31d$var$b(t, "class", i = "s-list " + e[0]), $37abfb837d2dd31d$var$b(t, "aria-disabled", e[2]), $37abfb837d2dd31d$var$b(t, "style", e[7]), $37abfb837d2dd31d$var$y(t, "dense", e[1]), $37abfb837d2dd31d$var$y(t, "disabled", e[2]), $37abfb837d2dd31d$var$y(t, "flat", e[3]), $37abfb837d2dd31d$var$y(t, "nav", e[5]), $37abfb837d2dd31d$var$y(t, "outlined", e[6]), $37abfb837d2dd31d$var$y(t, "rounded", e[4]);
        },
        m: function(l, n) {
            $37abfb837d2dd31d$var$$(l, t, n), a && a.m(t, null), s = !0;
        },
        p: function(l, param) {
            var _param = (0, $8GFUW._)(param, 1), n = _param[0];
            a && a.p && (!s || 512 & n) && $37abfb837d2dd31d$var$W(a, r, l, l[9], s ? $37abfb837d2dd31d$var$R(r, l[9], n, null) : $37abfb837d2dd31d$var$Q(l[9]), null), (!s || 256 & n) && $37abfb837d2dd31d$var$b(t, "role", l[8]), (!s || 1 & n && i !== (i = "s-list " + l[0])) && $37abfb837d2dd31d$var$b(t, "class", i), (!s || 4 & n) && $37abfb837d2dd31d$var$b(t, "aria-disabled", l[2]), (!s || 128 & n) && $37abfb837d2dd31d$var$b(t, "style", l[7]), 3 & n && $37abfb837d2dd31d$var$y(t, "dense", l[1]), 5 & n && $37abfb837d2dd31d$var$y(t, "disabled", l[2]), 9 & n && $37abfb837d2dd31d$var$y(t, "flat", l[3]), 33 & n && $37abfb837d2dd31d$var$y(t, "nav", l[5]), 65 & n && $37abfb837d2dd31d$var$y(t, "outlined", l[6]), 17 & n && $37abfb837d2dd31d$var$y(t, "rounded", l[4]);
        },
        i: function(l) {
            s || ($37abfb837d2dd31d$var$j(a, l), s = !0);
        },
        o: function(l) {
            $37abfb837d2dd31d$var$k(a, l), s = !1;
        },
        d: function(l) {
            l && $37abfb837d2dd31d$var$z(t), a && a.d(l);
        }
    };
}
function $37abfb837d2dd31d$var$hn(e, t, i) {
    var tmp = t.$$slots, s = tmp === void 0 ? {} : tmp, r = t.$$scope, tmp1 = t.class, a = tmp1 === void 0 ? "" : tmp1, tmp2 = t.dense, l = tmp2 === void 0 ? null : tmp2, tmp3 = t.disabled, n = tmp3 === void 0 ? null : tmp3, tmp4 = t.flat, o = tmp4 === void 0 ? !1 : tmp4, tmp5 = t.rounded, c = tmp5 === void 0 ? !1 : tmp5, tmp6 = t.nav, g = tmp6 === void 0 ? !1 : tmp6, tmp7 = t.outlined, u = tmp7 === void 0 ? !1 : tmp7, tmp8 = t.style, d = tmp8 === void 0 ? null : tmp8, f = null;
    var p, m;
    return $37abfb837d2dd31d$var$kt("S_ListItemRole") || (p = "S_ListItemRole", m = "listitem", $37abfb837d2dd31d$var$De().$$.context.set(p, m), f = "list"), e.$$set = function(h) {
        "class" in h && i(0, a = h.class), "dense" in h && i(1, l = h.dense), "disabled" in h && i(2, n = h.disabled), "flat" in h && i(3, o = h.flat), "rounded" in h && i(4, c = h.rounded), "nav" in h && i(5, g = h.nav), "outlined" in h && i(6, u = h.outlined), "style" in h && i(7, d = h.style), "$$scope" in h && i(9, r = h.$$scope);
    }, [
        a,
        l,
        n,
        o,
        c,
        g,
        u,
        d,
        f,
        r,
        s
    ];
}
var $37abfb837d2dd31d$var$mn = /*#__PURE__*/ function(q) {
    (0, $ftJVG._)(mn, q);
    var _super = (0, $6OZAO._)(mn);
    function mn(t) {
        (0, $978gY._)(this, mn);
        var _this;
        _this = _super.call(this), $37abfb837d2dd31d$var$X((0, $3vWwE._)(_this), t, $37abfb837d2dd31d$var$hn, $37abfb837d2dd31d$var$gn, $37abfb837d2dd31d$var$H, {
            class: 0,
            dense: 1,
            disabled: 2,
            flat: 3,
            rounded: 4,
            nav: 5,
            outlined: 6,
            style: 7
        }, $37abfb837d2dd31d$var$pn);
        return (0, $ho5gk._)(_this);
    }
    return mn;
}($37abfb837d2dd31d$var$q);
function $37abfb837d2dd31d$var$Mn(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-1lt8zv0", '.s-list-item__content{align-items:center;align-self:center;display:flex;flex-wrap:wrap;flex:1 1;overflow:hidden;padding:12px 0}.s-list-item__content>*{line-height:1.1;flex:1 0 100%}.s-list-item__content>:not(:last-child){margin-bottom:2px}.s-list-item__subtitle,.s-list-item__title{flex:1 1 100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;line-height:1.2}.s-list-item__title{align-self:center;font-size:1rem}.s-list-item__subtitle{font-size:0.875rem;color:var(--theme-text-secondary)}.s-list-item{align-items:center;display:flex;flex:1 1 100%;letter-spacing:normal;min-height:48px;outline:none;padding:0 16px;position:relative;text-decoration:none}.s-list-item .s-avatar{align-self:center;margin-top:8px;margin-bottom:8px}.s-list-item .s-icon{align-self:flex-start;margin-top:16px;margin-bottom:16px}.s-list-item .s-avatar,.s-list-item .s-icon{display:inline-flex;min-width:24px}.s-list-item [slot=prepend] .s-avatar{margin-right:16px}.s-list-item [slot=prepend] .s-checkbox,.s-list-item [slot=prepend] .s-icon,.s-list-item [slot=prepend] .s-radio{margin-right:32px}.s-list-item.link{cursor:pointer;user-select:none}.s-list-item.link:before{background-color:currentColor;bottom:0;top:0;left:0;right:0;content:"";pointer-events:none;position:absolute;opacity:0;transition:0.3s cubic-bezier(0.25, 0.8, 0.5, 1)}.s-list-item.link:not(.active):hover:before{opacity:0.04}.s-list-item.selectable{user-select:auto}.s-list-item.multiline .s-list-item__subtitle,.s-list-item.multiline .s-list-item__title{white-space:normal}.s-list-item:not(.disabled).focus-visible:before{opacity:0.12}.s-list-item.disabled{pointer-events:none;color:var(--theme-text-disabled)}.s-list-item.flat:before{display:none}.s-list-item.active:before{opacity:0.12}.s-list-item.active .s-icon{color:inherit}.s-list-item:after{content:"";min-height:inherit;font-size:0}.s-list-item:not(.active){color:var(--theme-text-primary)}.s-list-item.dense,.s-list.dense .s-list-item{min-height:32px}.s-list-item.dense .s-icon,.s-list.dense .s-list-item .s-icon{margin-top:8px;margin-bottom:8px}.s-list-item.dense [slot=prepend] .s-checkbox,.s-list-item.dense [slot=prepend] .s-icon,.s-list-item.dense [slot=prepend] .s-radio,.s-list.dense .s-list-item [slot=prepend] .s-checkbox,.s-list.dense .s-list-item [slot=prepend] .s-icon,.s-list.dense .s-list-item [slot=prepend] .s-radio{margin-right:24px}.s-list-item.dense .s-list-item__content,.s-list.dense .s-list-item .s-list-item__content{padding:8px 0}.s-list-item.dense .s-list-item__subtitle,.s-list-item.dense .s-list-item__title,.s-list.dense .s-list-item .s-list-item__subtitle,.s-list.dense .s-list-item .s-list-item__title{font-size:0.8125rem;font-weight:500;line-height:1rem}');
}
var $37abfb837d2dd31d$var$vn = function(e) {
    return {};
}, $37abfb837d2dd31d$var$Te = function(e) {
    return {};
}, $37abfb837d2dd31d$var$bn = function(e) {
    return {};
}, $37abfb837d2dd31d$var$Pe = function(e) {
    return {};
}, $37abfb837d2dd31d$var$yn = function(e) {
    return {};
}, $37abfb837d2dd31d$var$Ee = function(e) {
    return {};
};
function $37abfb837d2dd31d$var$wn(e) {
    var t, i, s, r, a, l, n, o, c, g, u, d, f, p, m;
    var h = e[14].prepend, x = $37abfb837d2dd31d$var$B(h, e, e[13], $37abfb837d2dd31d$var$Ee), N = e[14].default, M = $37abfb837d2dd31d$var$B(N, e, e[13], null), w = e[14].subtitle, A = $37abfb837d2dd31d$var$B(w, e, e[13], $37abfb837d2dd31d$var$Pe), C = e[14].append, O = $37abfb837d2dd31d$var$B(C, e, e[13], $37abfb837d2dd31d$var$Te);
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("div"), x && x.c(), i = $37abfb837d2dd31d$var$_(), s = $37abfb837d2dd31d$var$S("div"), r = $37abfb837d2dd31d$var$S("div"), M && M.c(), a = $37abfb837d2dd31d$var$_(), l = $37abfb837d2dd31d$var$S("div"), A && A.c(), n = $37abfb837d2dd31d$var$_(), O && O.c(), $37abfb837d2dd31d$var$b(r, "class", "s-list-item__title"), $37abfb837d2dd31d$var$b(l, "class", "s-list-item__subtitle"), $37abfb837d2dd31d$var$b(s, "class", "s-list-item__content"), $37abfb837d2dd31d$var$b(t, "class", o = "s-list-item " + e[1]), $37abfb837d2dd31d$var$b(t, "role", e[10]), $37abfb837d2dd31d$var$b(t, "tabindex", c = e[6] ? 0 : -1), $37abfb837d2dd31d$var$b(t, "aria-selected", g = e[10] === "option" ? e[0] : null), $37abfb837d2dd31d$var$b(t, "style", e[9]), $37abfb837d2dd31d$var$y(t, "dense", e[3]), $37abfb837d2dd31d$var$y(t, "disabled", e[4]), $37abfb837d2dd31d$var$y(t, "multiline", e[5]), $37abfb837d2dd31d$var$y(t, "link", e[6]), $37abfb837d2dd31d$var$y(t, "selectable", e[7]);
        },
        m: function(v, D) {
            $37abfb837d2dd31d$var$$(v, t, D), x && x.m(t, null), $37abfb837d2dd31d$var$L(t, i), $37abfb837d2dd31d$var$L(t, s), $37abfb837d2dd31d$var$L(s, r), M && M.m(r, null), $37abfb837d2dd31d$var$L(s, a), $37abfb837d2dd31d$var$L(s, l), A && A.m(l, null), $37abfb837d2dd31d$var$L(t, n), O && O.m(t, null), f = !0, p || (m = [
                $37abfb837d2dd31d$var$it(u = $37abfb837d2dd31d$var$Le.call(null, t, [
                    e[0] && e[2]
                ])),
                $37abfb837d2dd31d$var$it(d = $37abfb837d2dd31d$var$Oe.call(null, t, e[8])),
                $37abfb837d2dd31d$var$Y(t, "click", e[11]),
                $37abfb837d2dd31d$var$Y(t, "click", e[15]),
                $37abfb837d2dd31d$var$Y(t, "dblclick", e[16])
            ], p = !0);
        },
        p: function(v, param) {
            var _param = (0, $8GFUW._)(param, 1), D = _param[0];
            x && x.p && (!f || 8192 & D) && $37abfb837d2dd31d$var$W(x, h, v, v[13], f ? $37abfb837d2dd31d$var$R(h, v[13], D, $37abfb837d2dd31d$var$yn) : $37abfb837d2dd31d$var$Q(v[13]), $37abfb837d2dd31d$var$Ee), M && M.p && (!f || 8192 & D) && $37abfb837d2dd31d$var$W(M, N, v, v[13], f ? $37abfb837d2dd31d$var$R(N, v[13], D, null) : $37abfb837d2dd31d$var$Q(v[13]), null), A && A.p && (!f || 8192 & D) && $37abfb837d2dd31d$var$W(A, w, v, v[13], f ? $37abfb837d2dd31d$var$R(w, v[13], D, $37abfb837d2dd31d$var$bn) : $37abfb837d2dd31d$var$Q(v[13]), $37abfb837d2dd31d$var$Pe), O && O.p && (!f || 8192 & D) && $37abfb837d2dd31d$var$W(O, C, v, v[13], f ? $37abfb837d2dd31d$var$R(C, v[13], D, $37abfb837d2dd31d$var$vn) : $37abfb837d2dd31d$var$Q(v[13]), $37abfb837d2dd31d$var$Te), (!f || 2 & D && o !== (o = "s-list-item " + v[1])) && $37abfb837d2dd31d$var$b(t, "class", o), (!f || 64 & D && c !== (c = v[6] ? 0 : -1)) && $37abfb837d2dd31d$var$b(t, "tabindex", c), (!f || 1 & D && g !== (g = v[10] === "option" ? v[0] : null)) && $37abfb837d2dd31d$var$b(t, "aria-selected", g), (!f || 512 & D) && $37abfb837d2dd31d$var$b(t, "style", v[9]), u && $37abfb837d2dd31d$var$F(u.update) && 5 & D && u.update.call(null, [
                v[0] && v[2]
            ]), d && $37abfb837d2dd31d$var$F(d.update) && 256 & D && d.update.call(null, v[8]), 10 & D && $37abfb837d2dd31d$var$y(t, "dense", v[3]), 18 & D && $37abfb837d2dd31d$var$y(t, "disabled", v[4]), 34 & D && $37abfb837d2dd31d$var$y(t, "multiline", v[5]), 66 & D && $37abfb837d2dd31d$var$y(t, "link", v[6]), 130 & D && $37abfb837d2dd31d$var$y(t, "selectable", v[7]);
        },
        i: function(v) {
            f || ($37abfb837d2dd31d$var$j(x, v), $37abfb837d2dd31d$var$j(M, v), $37abfb837d2dd31d$var$j(A, v), $37abfb837d2dd31d$var$j(O, v), f = !0);
        },
        o: function(v) {
            $37abfb837d2dd31d$var$k(x, v), $37abfb837d2dd31d$var$k(M, v), $37abfb837d2dd31d$var$k(A, v), $37abfb837d2dd31d$var$k(O, v), f = !1;
        },
        d: function(v) {
            v && $37abfb837d2dd31d$var$z(t), x && x.d(v), M && M.d(v), A && A.d(v), O && O.d(v), p = !1, $37abfb837d2dd31d$var$U(m);
        }
    };
}
function $37abfb837d2dd31d$var$xn(e, t, i) {
    var tmp = t.$$slots, s = tmp === void 0 ? {} : tmp, r = t.$$scope;
    var a = $37abfb837d2dd31d$var$kt("S_ListItemRole"), l = $37abfb837d2dd31d$var$kt("S_ListItemGroup"), n = l ? $37abfb837d2dd31d$var$kt(l) : {
        select: function() {
            return null;
        },
        register: function() {
            return null;
        },
        index: function() {
            return null;
        },
        activeClass: "active"
    };
    var tmp1 = t.class, o = tmp1 === void 0 ? "" : tmp1, tmp2 = t.activeClass, c = tmp2 === void 0 ? n.activeClass : tmp2, tmp3 = t.value, g = tmp3 === void 0 ? n.index() : tmp3, tmp4 = t.active, u = tmp4 === void 0 ? !1 : tmp4, tmp5 = t.dense, d = tmp5 === void 0 ? !1 : tmp5, tmp6 = t.disabled, f = tmp6 === void 0 ? null : tmp6, tmp7 = t.multiline, p = tmp7 === void 0 ? !1 : tmp7, tmp8 = t.link, m = tmp8 === void 0 ? a : tmp8, tmp9 = t.selectable, h = tmp9 === void 0 ? !m : tmp9, tmp10 = t.ripple, x = tmp10 === void 0 ? $37abfb837d2dd31d$var$kt("S_ListItemRipple") || a || !1 : tmp10, tmp11 = t.style, N = tmp11 === void 0 ? null : tmp11;
    return n.register(function(M) {
        i(0, u = M.includes(g));
    }), e.$$set = function(M) {
        "class" in M && i(1, o = M.class), "activeClass" in M && i(2, c = M.activeClass), "value" in M && i(12, g = M.value), "active" in M && i(0, u = M.active), "dense" in M && i(3, d = M.dense), "disabled" in M && i(4, f = M.disabled), "multiline" in M && i(5, p = M.multiline), "link" in M && i(6, m = M.link), "selectable" in M && i(7, h = M.selectable), "ripple" in M && i(8, x = M.ripple), "style" in M && i(9, N = M.style), "$$scope" in M && i(13, r = M.$$scope);
    }, [
        u,
        o,
        c,
        d,
        f,
        p,
        m,
        h,
        x,
        N,
        a,
        function() {
            f || n.select(g);
        },
        g,
        r,
        s,
        function(M) {
            $37abfb837d2dd31d$var$rt.call(this, e, M);
        },
        function(M) {
            $37abfb837d2dd31d$var$rt.call(this, e, M);
        }
    ];
}
var $37abfb837d2dd31d$var$In = /*#__PURE__*/ function(q) {
    (0, $ftJVG._)(In, q);
    var _super = (0, $6OZAO._)(In);
    function In(t) {
        (0, $978gY._)(this, In);
        var _this;
        _this = _super.call(this), $37abfb837d2dd31d$var$X((0, $3vWwE._)(_this), t, $37abfb837d2dd31d$var$xn, $37abfb837d2dd31d$var$wn, $37abfb837d2dd31d$var$H, {
            class: 1,
            activeClass: 2,
            value: 12,
            active: 0,
            dense: 3,
            disabled: 4,
            multiline: 5,
            link: 6,
            selectable: 7,
            ripple: 8,
            style: 9
        }, $37abfb837d2dd31d$var$Mn);
        return (0, $ho5gk._)(_this);
    }
    return In;
}($37abfb837d2dd31d$var$q);
var $37abfb837d2dd31d$var$Nn = [
    "primary",
    "secondary",
    "success",
    "info",
    "warning",
    "error"
];
function $37abfb837d2dd31d$var$Fe(e, t) {
    var _e_classList;
    if (/^(#|rgb|hsl|currentColor)/.test(t)) return e.style.backgroundColor = t, !1;
    if (t.startsWith("--")) return e.style.backgroundColor = "var(".concat(t, ")"), !1;
    var i = function(s) {
        return s.split(" ").map(function(r) {
            return $37abfb837d2dd31d$var$Nn.includes(r) ? "".concat(r, "-color") : r;
        });
    }(t);
    return (_e_classList = e.classList).add.apply(_e_classList, (0, $fLnyw._)(i)), i;
}
var $37abfb837d2dd31d$var$Gt = function(e, t) {
    var i;
    return typeof t == "string" && (i = $37abfb837d2dd31d$var$Fe(e, t)), {
        update: function(s) {
            var _e_classList;
            i ? (_e_classList = e.classList).remove.apply(_e_classList, (0, $fLnyw._)(i)) : e.style.backgroundColor = null, typeof s == "string" && (i = $37abfb837d2dd31d$var$Fe(e, s));
        }
    };
};
function $37abfb837d2dd31d$var$An(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-x5kbih", ".s-overlay.svelte-x5kbih{align-items:center;border-radius:inherit;display:flex;justify-content:center;position:fixed;top:0;left:0;right:0;bottom:0;pointer-events:auto}.s-overlay.absolute.svelte-x5kbih{position:absolute}.s-overlay__scrim.svelte-x5kbih{border-radius:inherit;bottom:0;height:100%;left:0;position:absolute;right:0;top:0;transition:inherit;width:100%;will-change:opacity}.s-overlay__content.svelte-x5kbih{position:relative}");
}
function $37abfb837d2dd31d$var$Be(e) {
    var t, i, s, r, a, l, n, o, c, g, u, d;
    var f = e[11].default, p = $37abfb837d2dd31d$var$B(f, e, e[10], null);
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("div"), i = $37abfb837d2dd31d$var$S("div"), r = $37abfb837d2dd31d$var$_(), a = $37abfb837d2dd31d$var$S("div"), p && p.c(), $37abfb837d2dd31d$var$b(i, "class", "s-overlay__scrim svelte-x5kbih"), $37abfb837d2dd31d$var$T(i, "opacity", e[5]), $37abfb837d2dd31d$var$b(a, "class", "s-overlay__content svelte-x5kbih"), $37abfb837d2dd31d$var$b(t, "class", l = "s-overlay " + e[0] + " svelte-x5kbih"), $37abfb837d2dd31d$var$b(t, "style", n = "z-index:" + e[7] + ";" + e[9]), $37abfb837d2dd31d$var$y(t, "absolute", e[8]);
        },
        m: function(m, h) {
            $37abfb837d2dd31d$var$$(m, t, h), $37abfb837d2dd31d$var$L(t, i), $37abfb837d2dd31d$var$L(t, r), $37abfb837d2dd31d$var$L(t, a), p && p.m(a, null), g = !0, u || (d = [
                $37abfb837d2dd31d$var$it(s = $37abfb837d2dd31d$var$Gt.call(null, i, e[6])),
                $37abfb837d2dd31d$var$Y(t, "click", e[12])
            ], u = !0);
        },
        p: function(m, h) {
            e = m, (!g || 32 & h) && $37abfb837d2dd31d$var$T(i, "opacity", e[5]), s && $37abfb837d2dd31d$var$F(s.update) && 64 & h && s.update.call(null, e[6]), p && p.p && (!g || 1024 & h) && $37abfb837d2dd31d$var$W(p, f, e, e[10], g ? $37abfb837d2dd31d$var$R(f, e[10], h, null) : $37abfb837d2dd31d$var$Q(e[10]), null), (!g || 1 & h && l !== (l = "s-overlay " + e[0] + " svelte-x5kbih")) && $37abfb837d2dd31d$var$b(t, "class", l), (!g || 640 & h && n !== (n = "z-index:" + e[7] + ";" + e[9])) && $37abfb837d2dd31d$var$b(t, "style", n), 257 & h && $37abfb837d2dd31d$var$y(t, "absolute", e[8]);
        },
        i: function(m) {
            g || ($37abfb837d2dd31d$var$j(p, m), $37abfb837d2dd31d$var$ot(function() {
                c && c.end(1), o = function(h, x, N) {
                    var v = function v() {
                        M && $37abfb837d2dd31d$var$Rt(h, M);
                    };
                    var D = function D() {
                        var _ref = A || $37abfb837d2dd31d$var$ae, tmp = _ref.delay, et = tmp === void 0 ? 0 : tmp, tmp1 = _ref.duration, ut = tmp1 === void 0 ? 300 : tmp1, tmp2 = _ref.easing, ft = tmp2 === void 0 ? $37abfb837d2dd31d$var$Tt : tmp2, tmp3 = _ref.tick, xt = tmp3 === void 0 ? $37abfb837d2dd31d$var$E : tmp3, pt = _ref.css;
                        pt && (M = $37abfb837d2dd31d$var$Bt(h, 0, 1, ut, et, ft, pt, O++)), xt(0, 1);
                        var gt = $37abfb837d2dd31d$var$qt() + et, Je = gt + ut;
                        w && w.abort(), C = !0, $37abfb837d2dd31d$var$ot(function() {
                            return $37abfb837d2dd31d$var$ct(h, !0, "start");
                        }), w = $37abfb837d2dd31d$var$te(function(Vt) {
                            if (C) {
                                if (Vt >= Je) return xt(1, 0), $37abfb837d2dd31d$var$ct(h, !0, "end"), v(), C = !1;
                                if (Vt >= gt) {
                                    var de = ft((Vt - gt) / ut);
                                    xt(de, 1 - de);
                                }
                            }
                            return C;
                        });
                    };
                    var M, w, A = x(h, N), C = !1, O = 0;
                    var P = !1;
                    return {
                        start: function() {
                            P || (P = !0, $37abfb837d2dd31d$var$Rt(h), $37abfb837d2dd31d$var$F(A) ? (A = A(), $37abfb837d2dd31d$var$oe().then(D)) : D());
                        },
                        invalidate: function() {
                            P = !1;
                        },
                        end: function() {
                            C && (v(), C = !1);
                        }
                    };
                }(t, e[1], e[2]), o.start();
            }), g = !0);
        },
        o: function(m) {
            $37abfb837d2dd31d$var$k(p, m), o && o.invalidate(), c = function(h, x, N) {
                var O = function O() {
                    var _ref = w || $37abfb837d2dd31d$var$ae, tmp = _ref.delay, v = tmp === void 0 ? 0 : tmp, tmp1 = _ref.duration, D = tmp1 === void 0 ? 300 : tmp1, tmp2 = _ref.easing, P = tmp2 === void 0 ? $37abfb837d2dd31d$var$Tt : tmp2, tmp3 = _ref.tick, et = tmp3 === void 0 ? $37abfb837d2dd31d$var$E : tmp3, ut = _ref.css;
                    ut && (M = $37abfb837d2dd31d$var$Bt(h, 1, 0, D, v, P, ut));
                    var ft = $37abfb837d2dd31d$var$qt() + v, xt = ft + D;
                    $37abfb837d2dd31d$var$ot(function() {
                        return $37abfb837d2dd31d$var$ct(h, !1, "start");
                    }), $37abfb837d2dd31d$var$te(function(pt) {
                        if (A) {
                            if (pt >= xt) return et(0, 1), $37abfb837d2dd31d$var$ct(h, !1, "end"), --C.r || $37abfb837d2dd31d$var$U(C.c), !1;
                            if (pt >= ft) {
                                var gt = P((pt - ft) / D);
                                et(1 - gt, gt);
                            }
                        }
                        return A;
                    });
                };
                var M, w = x(h, N), A = !0;
                var C = $37abfb837d2dd31d$var$tt;
                return C.r += 1, $37abfb837d2dd31d$var$F(w) ? $37abfb837d2dd31d$var$oe().then(function() {
                    w = w(), O();
                }) : O(), {
                    end: function(v) {
                        v && w.tick && w.tick(1, 0), A && (M && $37abfb837d2dd31d$var$Rt(h, M), A = !1);
                    }
                };
            }(t, e[1], e[3]), g = !1;
        },
        d: function(m) {
            m && $37abfb837d2dd31d$var$z(t), p && p.d(m), m && c && c.end(), u = !1, $37abfb837d2dd31d$var$U(d);
        }
    };
}
function $37abfb837d2dd31d$var$jn(e) {
    var t, i, s = e[4] && $37abfb837d2dd31d$var$Be(e);
    return {
        c: function() {
            s && s.c(), t = $37abfb837d2dd31d$var$ne();
        },
        m: function(r, a) {
            s && s.m(r, a), $37abfb837d2dd31d$var$$(r, t, a), i = !0;
        },
        p: function(r, param) {
            var _param = (0, $8GFUW._)(param, 1), a = _param[0];
            r[4] ? s ? (s.p(r, a), 16 & a && $37abfb837d2dd31d$var$j(s, 1)) : (s = $37abfb837d2dd31d$var$Be(r), s.c(), $37abfb837d2dd31d$var$j(s, 1), s.m(t.parentNode, t)) : s && ($37abfb837d2dd31d$var$Mt(), $37abfb837d2dd31d$var$k(s, 1, 1, function() {
                s = null;
            }), $37abfb837d2dd31d$var$vt());
        },
        i: function(r) {
            i || ($37abfb837d2dd31d$var$j(s), i = !0);
        },
        o: function(r) {
            $37abfb837d2dd31d$var$k(s), i = !1;
        },
        d: function(r) {
            s && s.d(r), r && $37abfb837d2dd31d$var$z(t);
        }
    };
}
function $37abfb837d2dd31d$var$Dn(e, t, i) {
    var tmp = t.$$slots, s = tmp === void 0 ? {} : tmp, r = t.$$scope, tmp1 = t.class, a = tmp1 === void 0 ? "" : tmp1, tmp2 = t.transition, l = tmp2 === void 0 ? $37abfb837d2dd31d$var$un : tmp2, tmp3 = t.inOpts, n = tmp3 === void 0 ? {
        duration: 250
    } : tmp3, tmp4 = t.outOpts, o = tmp4 === void 0 ? {
        duration: 250
    } : tmp4, tmp5 = t.active, c = tmp5 === void 0 ? !0 : tmp5, tmp6 = t.opacity, g = tmp6 === void 0 ? .46 : tmp6, tmp7 = t.color, u = tmp7 === void 0 ? "rgb(33, 33, 33)" : tmp7, tmp8 = t.index, d = tmp8 === void 0 ? 5 : tmp8, tmp9 = t.absolute, f = tmp9 === void 0 ? !1 : tmp9, tmp10 = t.style, p = tmp10 === void 0 ? "" : tmp10;
    return e.$$set = function(m) {
        "class" in m && i(0, a = m.class), "transition" in m && i(1, l = m.transition), "inOpts" in m && i(2, n = m.inOpts), "outOpts" in m && i(3, o = m.outOpts), "active" in m && i(4, c = m.active), "opacity" in m && i(5, g = m.opacity), "color" in m && i(6, u = m.color), "index" in m && i(7, d = m.index), "absolute" in m && i(8, f = m.absolute), "style" in m && i(9, p = m.style), "$$scope" in m && i(10, r = m.$$scope);
    }, [
        a,
        l,
        n,
        o,
        c,
        g,
        u,
        d,
        f,
        p,
        r,
        s,
        function(m) {
            $37abfb837d2dd31d$var$rt.call(this, e, m);
        }
    ];
}
var $37abfb837d2dd31d$var$zn = /*#__PURE__*/ function(q) {
    (0, $ftJVG._)(zn, q);
    var _super = (0, $6OZAO._)(zn);
    function zn(t) {
        (0, $978gY._)(this, zn);
        var _this;
        _this = _super.call(this), $37abfb837d2dd31d$var$X((0, $3vWwE._)(_this), t, $37abfb837d2dd31d$var$Dn, $37abfb837d2dd31d$var$jn, $37abfb837d2dd31d$var$H, {
            class: 0,
            transition: 1,
            inOpts: 2,
            outOpts: 3,
            active: 4,
            opacity: 5,
            color: 6,
            index: 7,
            absolute: 8,
            style: 9
        }, $37abfb837d2dd31d$var$An);
        return (0, $ho5gk._)(_this);
    }
    return zn;
}($37abfb837d2dd31d$var$q);
function $37abfb837d2dd31d$var$$n(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-47jzcv", ".s-dialog{align-items:center;display:flex;height:100%;justify-content:center;left:0;pointer-events:none;position:fixed;top:0;transition:0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;width:100%;z-index:6;outline:none}.s-dialog__content{background-color:var(--theme-surface);border-radius:4px;margin:24px;overflow-y:auto;pointer-events:auto;z-index:inherit;box-shadow:0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12)}.s-dialog__content:not(.fullscreen){max-height:90%;width:var(--s-dialog-width)}.s-dialog__content.fullscreen{border-radius:0;margin:0;height:100%;width:100%;position:fixed;overflow-y:auto;top:0;left:0}.s-dialog__content>.s-card>.s-card-title{font-size:1.25rem;font-weight:500;letter-spacing:0.0125em;padding:16px 24px 10px}.s-dialog__content>.s-card>.s-card-subtitle,.s-dialog__content>.s-card>.s-card-text{padding:0 24px 20px}.fullscreen{border-radius:0;margin:0;height:100%;position:fixed;overflow-y:auto;top:0;left:0}.fullscreen>.s-card{min-height:100%;min-width:100%;margin:0 !important;padding:0 !important}");
}
function $37abfb837d2dd31d$var$Re(e) {
    var t, i, s, r, a, l, n, o;
    var c = e[11].default, g = $37abfb837d2dd31d$var$B(c, e, e[10], null);
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("div"), i = $37abfb837d2dd31d$var$S("div"), g && g.c(), $37abfb837d2dd31d$var$b(i, "class", s = "s-dialog__content " + e[0]), $37abfb837d2dd31d$var$y(i, "fullscreen", e[2]), $37abfb837d2dd31d$var$b(t, "role", "document"), $37abfb837d2dd31d$var$b(t, "class", "s-dialog");
        },
        m: function(u, d) {
            $37abfb837d2dd31d$var$$(u, t, d), $37abfb837d2dd31d$var$L(t, i), g && g.m(i, null), l = !0, n || (o = [
                $37abfb837d2dd31d$var$Y(i, "introstart", e[12]),
                $37abfb837d2dd31d$var$Y(i, "outrostart", e[13]),
                $37abfb837d2dd31d$var$Y(i, "introend", e[14]),
                $37abfb837d2dd31d$var$Y(i, "outroend", e[15]),
                $37abfb837d2dd31d$var$it(a = $37abfb837d2dd31d$var$sn.call(null, t, {
                    "dialog-width": e[1]
                }))
            ], n = !0);
        },
        p: function(u, d) {
            g && g.p && (!l || 1024 & d) && $37abfb837d2dd31d$var$W(g, c, u, u[10], l ? $37abfb837d2dd31d$var$R(c, u[10], d, null) : $37abfb837d2dd31d$var$Q(u[10]), null), (!l || 1 & d && s !== (s = "s-dialog__content " + u[0])) && $37abfb837d2dd31d$var$b(i, "class", s), 5 & d && $37abfb837d2dd31d$var$y(i, "fullscreen", u[2]), a && $37abfb837d2dd31d$var$F(a.update) && 2 & d && a.update.call(null, {
                "dialog-width": u[1]
            });
        },
        i: function(u) {
            l || ($37abfb837d2dd31d$var$j(g, u), $37abfb837d2dd31d$var$ot(function() {
                r || (r = $37abfb837d2dd31d$var$$e(i, e[3], {
                    duration: 300,
                    start: .1
                }, !0)), r.run(1);
            }), l = !0);
        },
        o: function(u) {
            $37abfb837d2dd31d$var$k(g, u), r || (r = $37abfb837d2dd31d$var$$e(i, e[3], {
                duration: 300,
                start: .1
            }, !1)), r.run(0), l = !1;
        },
        d: function(u) {
            u && $37abfb837d2dd31d$var$z(t), g && g.d(u), u && r && r.end(), n = !1, $37abfb837d2dd31d$var$U(o);
        }
    };
}
function $37abfb837d2dd31d$var$kn(e) {
    var t, i, s, r = e[5] && $37abfb837d2dd31d$var$Re(e);
    var a = [
        e[4],
        {
            active: e[5]
        }
    ];
    var l = {};
    for(var n = 0; n < a.length; n += 1)l = $37abfb837d2dd31d$var$Dt(l, a[n]);
    return i = new $37abfb837d2dd31d$var$zn({
        props: l
    }), i.$on("click", e[6]), {
        c: function() {
            r && r.c(), t = $37abfb837d2dd31d$var$_(), $37abfb837d2dd31d$var$J(i.$$.fragment);
        },
        m: function(n, o) {
            r && r.m(n, o), $37abfb837d2dd31d$var$$(n, t, o), $37abfb837d2dd31d$var$G(i, n, o), s = !0;
        },
        p: function(n, param) {
            var _param = (0, $8GFUW._)(param, 1), o = _param[0];
            n[5] ? r ? (r.p(n, o), 32 & o && $37abfb837d2dd31d$var$j(r, 1)) : (r = $37abfb837d2dd31d$var$Re(n), r.c(), $37abfb837d2dd31d$var$j(r, 1), r.m(t.parentNode, t)) : r && ($37abfb837d2dd31d$var$Mt(), $37abfb837d2dd31d$var$k(r, 1, 1, function() {
                r = null;
            }), $37abfb837d2dd31d$var$vt());
            var c = 48 & o ? $37abfb837d2dd31d$var$ke(a, [
                16 & o && (g = n[4], typeof g == "object" && g !== null ? g : {}),
                32 & o && {
                    active: n[5]
                }
            ]) : {};
            var g;
            i.$set(c);
        },
        i: function(n) {
            s || ($37abfb837d2dd31d$var$j(r), $37abfb837d2dd31d$var$j(i.$$.fragment, n), s = !0);
        },
        o: function(n) {
            $37abfb837d2dd31d$var$k(r), $37abfb837d2dd31d$var$k(i.$$.fragment, n), s = !1;
        },
        d: function(n) {
            r && r.d(n), n && $37abfb837d2dd31d$var$z(t), $37abfb837d2dd31d$var$Z(i, n);
        }
    };
}
function $37abfb837d2dd31d$var$Sn(e, t, i) {
    var s, tmp = t.$$slots, r = tmp === void 0 ? {} : tmp, a = t.$$scope, tmp1 = t.class, l = tmp1 === void 0 ? "" : tmp1, tmp2 = t.active, n = tmp2 === void 0 ? !1 : tmp2, tmp3 = t.persistent, o = tmp3 === void 0 ? !1 : tmp3, tmp4 = t.disabled, c = tmp4 === void 0 ? !1 : tmp4, tmp5 = t.width, g = tmp5 === void 0 ? 500 : tmp5, tmp6 = t.fullscreen, u = tmp6 === void 0 ? !1 : tmp6, tmp7 = t.transition, d = tmp7 === void 0 ? $37abfb837d2dd31d$var$fn : tmp7, tmp8 = t.overlay, f = tmp8 === void 0 ? {} : tmp8;
    return e.$$set = function(p) {
        "class" in p && i(0, l = p.class), "active" in p && i(7, n = p.active), "persistent" in p && i(8, o = p.persistent), "disabled" in p && i(9, c = p.disabled), "width" in p && i(1, g = p.width), "fullscreen" in p && i(2, u = p.fullscreen), "transition" in p && i(3, d = p.transition), "overlay" in p && i(4, f = p.overlay), "$$scope" in p && i(10, a = p.$$scope);
    }, e.$$.update = function() {
        640 & e.$$.dirty && i(5, s = n && !c);
    }, [
        l,
        g,
        u,
        d,
        f,
        s,
        function() {
            o || i(7, n = !1);
        },
        n,
        o,
        c,
        a,
        r,
        function(p) {
            $37abfb837d2dd31d$var$rt.call(this, e, p);
        },
        function(p) {
            $37abfb837d2dd31d$var$rt.call(this, e, p);
        },
        function(p) {
            $37abfb837d2dd31d$var$rt.call(this, e, p);
        },
        function(p) {
            $37abfb837d2dd31d$var$rt.call(this, e, p);
        }
    ];
}
var $37abfb837d2dd31d$var$On = /*#__PURE__*/ function(q) {
    (0, $ftJVG._)(On, q);
    var _super = (0, $6OZAO._)(On);
    function On(t) {
        (0, $978gY._)(this, On);
        var _this;
        _this = _super.call(this), $37abfb837d2dd31d$var$X((0, $3vWwE._)(_this), t, $37abfb837d2dd31d$var$Sn, $37abfb837d2dd31d$var$kn, $37abfb837d2dd31d$var$H, {
            class: 0,
            active: 7,
            persistent: 8,
            disabled: 9,
            width: 1,
            fullscreen: 2,
            transition: 3,
            overlay: 4
        }, $37abfb837d2dd31d$var$$n);
        return (0, $ho5gk._)(_this);
    }
    return On;
}($37abfb837d2dd31d$var$q);
function $37abfb837d2dd31d$var$Cn(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-18svewl", ".s-progress-linear.svelte-18svewl.svelte-18svewl{background:transparent;overflow:hidden;position:relative;transition:0.2s cubic-bezier(0.4, 0, 0.6, 1);width:100%;color:var(--theme-text-primary)}.s-progress-linear.inactive.svelte-18svewl.svelte-18svewl{height:0 !important}.s-progress-linear.rounded.svelte-18svewl.svelte-18svewl{border-radius:4px}.s-progress-linear.svelte-18svewl .background.svelte-18svewl,.s-progress-linear.svelte-18svewl .determinate.svelte-18svewl,.s-progress-linear.svelte-18svewl .indeterminate.svelte-18svewl{top:0;bottom:0;position:absolute;transition:inherit}.s-progress-linear.svelte-18svewl .determinate.striped.svelte-18svewl{background-image:linear-gradient(135deg, hsla(0deg, 0%, 100%, 0.25) 25%, transparent 0, transparent 50%, hsla(0deg, 0%, 100%, 0.25) 0, hsla(0deg, 0%, 100%, 0.25) 75%, transparent 0, transparent);background-size:40px 40px;background-repeat:repeat}.s-progress-linear.svelte-18svewl .indeterminate.svelte-18svewl{right:auto;width:auto;will-change:left, right;background-color:inherit;animation-duration:2.2s;animation-iteration-count:infinite}.s-progress-linear.svelte-18svewl .indeterminate.long.svelte-18svewl{animation-name:svelte-18svewl-indeterminate}.s-progress-linear.svelte-18svewl .indeterminate.short.svelte-18svewl{animation-name:svelte-18svewl-indeterminate-short}.s-progress-linear.svelte-18svewl .stream.svelte-18svewl{background:transparent !important;animation:svelte-18svewl-stream 0.25s linear infinite;bottom:0;opacity:0.3;pointer-events:none;position:absolute;border-top:4px dotted;top:calc(50% - 2px);transition:inherit}.s-progress-linear.reversed.svelte-18svewl .background.svelte-18svewl,.s-progress-linear.reversed.svelte-18svewl .determinate.svelte-18svewl,.s-progress-linear.reversed.svelte-18svewl .indeterminate.svelte-18svewl{right:0}.s-progress-linear.reversed.svelte-18svewl .indeterminate.svelte-18svewl{animation-direction:reverse}.s-progress-linear.reversed.svelte-18svewl .stream.svelte-18svewl{right:auto;animation-direction:reverse}.s-progress-linear.svelte-18svewl:not(.reversed) .background.svelte-18svewl,.s-progress-linear.svelte-18svewl:not(.reversed) .determinate.svelte-18svewl,.s-progress-linear.svelte-18svewl:not(.reversed) .indeterminate.svelte-18svewl{left:0}.s-progress-linear.svelte-18svewl:not(.reversed) .stream.svelte-18svewl{left:auto;right:-8px}.s-progress-linear__content.svelte-18svewl.svelte-18svewl{align-items:center;display:flex;height:100%;left:0;justify-content:center;position:absolute;top:0;width:100%;z-index:2;pointer-events:none}@keyframes svelte-18svewl-indeterminate{0%{left:-90%;right:100%}60%{left:-90%;right:100%}to{left:100%;right:-35%}}@keyframes svelte-18svewl-indeterminate-short{0%{left:-200%;right:100%}60%{left:107%;right:-8%}to{left:107%;right:-8%}}@keyframes svelte-18svewl-stream{to{transform:translateX(-8px)}}");
}
function $37abfb837d2dd31d$var$Ln(e) {
    var t, i, s, r;
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("div"), $37abfb837d2dd31d$var$b(t, "class", "determinate svelte-18svewl"), $37abfb837d2dd31d$var$T(t, "width", e[1] + "%"), $37abfb837d2dd31d$var$y(t, "striped", e[12]);
        },
        m: function(a, l) {
            $37abfb837d2dd31d$var$$(a, t, l), s || (r = $37abfb837d2dd31d$var$it(i = $37abfb837d2dd31d$var$Gt.call(null, t, e[7])), s = !0);
        },
        p: function(a, l) {
            2 & l && $37abfb837d2dd31d$var$T(t, "width", a[1] + "%"), i && $37abfb837d2dd31d$var$F(i.update) && 128 & l && i.update.call(null, a[7]), 4096 & l && $37abfb837d2dd31d$var$y(t, "striped", a[12]);
        },
        d: function(a) {
            a && $37abfb837d2dd31d$var$z(t), s = !1, r();
        }
    };
}
function $37abfb837d2dd31d$var$_n(e) {
    var t, i, s, r;
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("div"), t.innerHTML = '<div class="indeterminate long svelte-18svewl"></div> \n      <div class="indeterminate short svelte-18svewl"></div>';
        },
        m: function(a, l) {
            $37abfb837d2dd31d$var$$(a, t, l), s || (r = $37abfb837d2dd31d$var$it(i = $37abfb837d2dd31d$var$Gt.call(null, t, e[7])), s = !0);
        },
        p: function(a, l) {
            i && $37abfb837d2dd31d$var$F(i.update) && 128 & l && i.update.call(null, a[7]);
        },
        d: function(a) {
            a && $37abfb837d2dd31d$var$z(t), s = !1, r();
        }
    };
}
function $37abfb837d2dd31d$var$We(e) {
    var t, i;
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("div"), $37abfb837d2dd31d$var$b(t, "class", i = "stream " + e[7] + " svelte-18svewl"), $37abfb837d2dd31d$var$T(t, "width", 100 - e[8] + "%");
        },
        m: function(s, r) {
            $37abfb837d2dd31d$var$$(s, t, r);
        },
        p: function(s, r) {
            128 & r && i !== (i = "stream " + s[7] + " svelte-18svewl") && $37abfb837d2dd31d$var$b(t, "class", i), 256 & r && $37abfb837d2dd31d$var$T(t, "width", 100 - s[8] + "%");
        },
        d: function(s) {
            s && $37abfb837d2dd31d$var$z(t);
        }
    };
}
function $37abfb837d2dd31d$var$Tn(e) {
    var p = function p(w, A) {
        return w[3] ? $37abfb837d2dd31d$var$_n : $37abfb837d2dd31d$var$Ln;
    };
    var t, i, s, r, a, l, n, o, c, g, u, d, f;
    var m = p(e), h = m(e);
    var x = e[15].default, N = $37abfb837d2dd31d$var$B(x, e, e[14], null);
    var M = e[10] && $37abfb837d2dd31d$var$We(e);
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("div"), i = $37abfb837d2dd31d$var$S("div"), a = $37abfb837d2dd31d$var$_(), h.c(), l = $37abfb837d2dd31d$var$_(), n = $37abfb837d2dd31d$var$S("div"), N && N.c(), o = $37abfb837d2dd31d$var$_(), M && M.c(), $37abfb837d2dd31d$var$b(i, "class", "background svelte-18svewl"), $37abfb837d2dd31d$var$b(i, "style", s = "opacity:" + e[6] + ";" + (e[9] ? "right" : "left") + ":" + e[1] + "%;width:" + (e[8] - e[1]) + "%"), $37abfb837d2dd31d$var$b(n, "class", "s-progress-linear__content svelte-18svewl"), $37abfb837d2dd31d$var$b(t, "role", "progressbar"), $37abfb837d2dd31d$var$b(t, "aria-valuemin", "0"), $37abfb837d2dd31d$var$b(t, "aria-valuemax", "100"), $37abfb837d2dd31d$var$b(t, "aria-valuenow", e[1]), $37abfb837d2dd31d$var$b(t, "class", c = "s-progress-linear " + e[0] + " svelte-18svewl"), $37abfb837d2dd31d$var$b(t, "style", g = "height:" + e[4] + ";" + e[13]), $37abfb837d2dd31d$var$y(t, "inactive", !e[2]), $37abfb837d2dd31d$var$y(t, "reversed", e[9]), $37abfb837d2dd31d$var$y(t, "rounded", e[11]);
        },
        m: function(w, A) {
            $37abfb837d2dd31d$var$$(w, t, A), $37abfb837d2dd31d$var$L(t, i), $37abfb837d2dd31d$var$L(t, a), h.m(t, null), $37abfb837d2dd31d$var$L(t, l), $37abfb837d2dd31d$var$L(t, n), N && N.m(n, null), $37abfb837d2dd31d$var$L(t, o), M && M.m(t, null), u = !0, d || (f = $37abfb837d2dd31d$var$it(r = $37abfb837d2dd31d$var$Gt.call(null, i, e[5])), d = !0);
        },
        p: function(w, param) {
            var _param = (0, $8GFUW._)(param, 1), A = _param[0];
            (!u || 834 & A && s !== (s = "opacity:" + w[6] + ";" + (w[9] ? "right" : "left") + ":" + w[1] + "%;width:" + (w[8] - w[1]) + "%")) && $37abfb837d2dd31d$var$b(i, "style", s), r && $37abfb837d2dd31d$var$F(r.update) && 32 & A && r.update.call(null, w[5]), m === (m = p(w)) && h ? h.p(w, A) : (h.d(1), h = m(w), h && (h.c(), h.m(t, l))), N && N.p && (!u || 16384 & A) && $37abfb837d2dd31d$var$W(N, x, w, w[14], u ? $37abfb837d2dd31d$var$R(x, w[14], A, null) : $37abfb837d2dd31d$var$Q(w[14]), null), w[10] ? M ? M.p(w, A) : (M = $37abfb837d2dd31d$var$We(w), M.c(), M.m(t, null)) : M && (M.d(1), M = null), (!u || 2 & A) && $37abfb837d2dd31d$var$b(t, "aria-valuenow", w[1]), (!u || 1 & A && c !== (c = "s-progress-linear " + w[0] + " svelte-18svewl")) && $37abfb837d2dd31d$var$b(t, "class", c), (!u || 8208 & A && g !== (g = "height:" + w[4] + ";" + w[13])) && $37abfb837d2dd31d$var$b(t, "style", g), 5 & A && $37abfb837d2dd31d$var$y(t, "inactive", !w[2]), 513 & A && $37abfb837d2dd31d$var$y(t, "reversed", w[9]), 2049 & A && $37abfb837d2dd31d$var$y(t, "rounded", w[11]);
        },
        i: function(w) {
            u || ($37abfb837d2dd31d$var$j(N, w), u = !0);
        },
        o: function(w) {
            $37abfb837d2dd31d$var$k(N, w), u = !1;
        },
        d: function(w) {
            w && $37abfb837d2dd31d$var$z(t), h.d(), N && N.d(w), M && M.d(), d = !1, f();
        }
    };
}
function $37abfb837d2dd31d$var$Pn(e, t, i) {
    var tmp = t.$$slots, s = tmp === void 0 ? {} : tmp, r = t.$$scope, tmp1 = t.class, a = tmp1 === void 0 ? "" : tmp1, tmp2 = t.value, l = tmp2 === void 0 ? 0 : tmp2, tmp3 = t.active, n = tmp3 === void 0 ? !0 : tmp3, tmp4 = t.indeterminate, o = tmp4 === void 0 ? !1 : tmp4, tmp5 = t.height, c = tmp5 === void 0 ? "4px" : tmp5, tmp6 = t.backgroundColor, g = tmp6 === void 0 ? "primary" : tmp6, tmp7 = t.backgroundOpacity, u = tmp7 === void 0 ? .3 : tmp7, tmp8 = t.color, d = tmp8 === void 0 ? g : tmp8, tmp9 = t.buffer, f = tmp9 === void 0 ? 100 : tmp9, tmp10 = t.reversed, p = tmp10 === void 0 ? !1 : tmp10, tmp11 = t.stream, m = tmp11 === void 0 ? !1 : tmp11, tmp12 = t.rounded, h = tmp12 === void 0 ? !1 : tmp12, tmp13 = t.striped, x = tmp13 === void 0 ? !1 : tmp13, tmp14 = t.style, N = tmp14 === void 0 ? "" : tmp14;
    return e.$$set = function(M) {
        "class" in M && i(0, a = M.class), "value" in M && i(1, l = M.value), "active" in M && i(2, n = M.active), "indeterminate" in M && i(3, o = M.indeterminate), "height" in M && i(4, c = M.height), "backgroundColor" in M && i(5, g = M.backgroundColor), "backgroundOpacity" in M && i(6, u = M.backgroundOpacity), "color" in M && i(7, d = M.color), "buffer" in M && i(8, f = M.buffer), "reversed" in M && i(9, p = M.reversed), "stream" in M && i(10, m = M.stream), "rounded" in M && i(11, h = M.rounded), "striped" in M && i(12, x = M.striped), "style" in M && i(13, N = M.style), "$$scope" in M && i(14, r = M.$$scope);
    }, [
        a,
        l,
        n,
        o,
        c,
        g,
        u,
        d,
        f,
        p,
        m,
        h,
        x,
        N,
        r,
        s
    ];
}
var $37abfb837d2dd31d$var$En = /*#__PURE__*/ function(q) {
    (0, $ftJVG._)(En, q);
    var _super = (0, $6OZAO._)(En);
    function En(t) {
        (0, $978gY._)(this, En);
        var _this;
        _this = _super.call(this), $37abfb837d2dd31d$var$X((0, $3vWwE._)(_this), t, $37abfb837d2dd31d$var$Pn, $37abfb837d2dd31d$var$Tn, $37abfb837d2dd31d$var$H, {
            class: 0,
            value: 1,
            active: 2,
            indeterminate: 3,
            height: 4,
            backgroundColor: 5,
            backgroundOpacity: 6,
            color: 7,
            buffer: 8,
            reversed: 9,
            stream: 10,
            rounded: 11,
            striped: 12,
            style: 13
        }, $37abfb837d2dd31d$var$Cn);
        return (0, $ho5gk._)(_this);
    }
    return En;
}($37abfb837d2dd31d$var$q);
function $37abfb837d2dd31d$var$Fn(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-14lzzdw", '.s-card{background-color:var(--theme-cards);color:var(--theme-text-primary);display:block;max-width:100%;outline:none;text-decoration:none;transition-property:box-shadow, opacity;overflow-wrap:break-word;position:relative;white-space:normal}.s-card:not(.flat){box-shadow:0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)}.s-card:not(.tile){border-radius:4px}.s-card.outlined{border:thin solid rgba(0, 0, 0, 0.12);box-shadow:0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14), 0 0 0 0 rgba(0, 0, 0, 0.12)}.s-card.raised{box-shadow:0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12)}.s-card.shaped{border-radius:24px 4px}.s-card.hover{cursor:pointer;transition:box-shadow 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)}.s-card.hover:focus,.s-card.hover:hover{box-shadow:0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12)}.s-card.link,.s-card.link .s-chip{cursor:pointer}.s-card.link:before{background:currentColor;bottom:0;content:"";left:0;opacity:0;pointer-events:none;position:absolute;right:0;top:0;transition:opacity 0.2s}.s-card.link:focus:before{opacity:0.08}.s-card.disabled{pointer-events:none;user-select:none}.s-card.disabled>:not(.s-progress-linear){opacity:0.6;transition:inherit}.s-card>:first-child:not(.s-btn):not(.s-chip),.s-card>[slot=progress]+:not(.s-btn):not(.s-chip){border-top-left-radius:inherit;border-top-right-radius:inherit}.s-card>:last-child:not(.s-btn):not(.s-chip){border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}');
}
var $37abfb837d2dd31d$var$Bn = function(e) {
    return {};
}, $37abfb837d2dd31d$var$Qe = function(e) {
    return {};
};
function $37abfb837d2dd31d$var$Ue(e) {
    var t;
    var i = e[12].progress, s = $37abfb837d2dd31d$var$B(i, e, e[11], $37abfb837d2dd31d$var$Qe), r = s || function(a) {
        var l, n;
        return l = new $37abfb837d2dd31d$var$En({
            props: {
                indeterminate: !0
            }
        }), {
            c: function() {
                $37abfb837d2dd31d$var$J(l.$$.fragment);
            },
            m: function(o, c) {
                $37abfb837d2dd31d$var$G(l, o, c), n = !0;
            },
            p: $37abfb837d2dd31d$var$E,
            i: function(o) {
                n || ($37abfb837d2dd31d$var$j(l.$$.fragment, o), n = !0);
            },
            o: function(o) {
                $37abfb837d2dd31d$var$k(l.$$.fragment, o), n = !1;
            },
            d: function(o) {
                $37abfb837d2dd31d$var$Z(l, o);
            }
        };
    }();
    return {
        c: function() {
            r && r.c();
        },
        m: function(a, l) {
            r && r.m(a, l), t = !0;
        },
        p: function(a, l) {
            s && s.p && (!t || 2048 & l) && $37abfb837d2dd31d$var$W(s, i, a, a[11], t ? $37abfb837d2dd31d$var$R(i, a[11], l, $37abfb837d2dd31d$var$Bn) : $37abfb837d2dd31d$var$Q(a[11]), $37abfb837d2dd31d$var$Qe);
        },
        i: function(a) {
            t || ($37abfb837d2dd31d$var$j(r, a), t = !0);
        },
        o: function(a) {
            $37abfb837d2dd31d$var$k(r, a), t = !1;
        },
        d: function(a) {
            r && r.d(a);
        }
    };
}
function $37abfb837d2dd31d$var$Rn(e) {
    var t, i, s, r, a = e[8] && $37abfb837d2dd31d$var$Ue(e);
    var l = e[12].default, n = $37abfb837d2dd31d$var$B(l, e, e[11], null);
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("div"), a && a.c(), i = $37abfb837d2dd31d$var$_(), n && n.c(), $37abfb837d2dd31d$var$b(t, "class", s = "s-card " + e[0]), $37abfb837d2dd31d$var$b(t, "style", e[10]), $37abfb837d2dd31d$var$y(t, "flat", e[1]), $37abfb837d2dd31d$var$y(t, "tile", e[2]), $37abfb837d2dd31d$var$y(t, "outlined", e[3]), $37abfb837d2dd31d$var$y(t, "raised", e[4]), $37abfb837d2dd31d$var$y(t, "shaped", e[5]), $37abfb837d2dd31d$var$y(t, "hover", e[6]), $37abfb837d2dd31d$var$y(t, "link", e[7]), $37abfb837d2dd31d$var$y(t, "disabled", e[9]);
        },
        m: function(o, c) {
            $37abfb837d2dd31d$var$$(o, t, c), a && a.m(t, null), $37abfb837d2dd31d$var$L(t, i), n && n.m(t, null), r = !0;
        },
        p: function(o, param) {
            var _param = (0, $8GFUW._)(param, 1), c = _param[0];
            o[8] ? a ? (a.p(o, c), 256 & c && $37abfb837d2dd31d$var$j(a, 1)) : (a = $37abfb837d2dd31d$var$Ue(o), a.c(), $37abfb837d2dd31d$var$j(a, 1), a.m(t, i)) : a && ($37abfb837d2dd31d$var$Mt(), $37abfb837d2dd31d$var$k(a, 1, 1, function() {
                a = null;
            }), $37abfb837d2dd31d$var$vt()), n && n.p && (!r || 2048 & c) && $37abfb837d2dd31d$var$W(n, l, o, o[11], r ? $37abfb837d2dd31d$var$R(l, o[11], c, null) : $37abfb837d2dd31d$var$Q(o[11]), null), (!r || 1 & c && s !== (s = "s-card " + o[0])) && $37abfb837d2dd31d$var$b(t, "class", s), (!r || 1024 & c) && $37abfb837d2dd31d$var$b(t, "style", o[10]), 3 & c && $37abfb837d2dd31d$var$y(t, "flat", o[1]), 5 & c && $37abfb837d2dd31d$var$y(t, "tile", o[2]), 9 & c && $37abfb837d2dd31d$var$y(t, "outlined", o[3]), 17 & c && $37abfb837d2dd31d$var$y(t, "raised", o[4]), 33 & c && $37abfb837d2dd31d$var$y(t, "shaped", o[5]), 65 & c && $37abfb837d2dd31d$var$y(t, "hover", o[6]), 129 & c && $37abfb837d2dd31d$var$y(t, "link", o[7]), 513 & c && $37abfb837d2dd31d$var$y(t, "disabled", o[9]);
        },
        i: function(o) {
            r || ($37abfb837d2dd31d$var$j(a), $37abfb837d2dd31d$var$j(n, o), r = !0);
        },
        o: function(o) {
            $37abfb837d2dd31d$var$k(a), $37abfb837d2dd31d$var$k(n, o), r = !1;
        },
        d: function(o) {
            o && $37abfb837d2dd31d$var$z(t), a && a.d(), n && n.d(o);
        }
    };
}
function $37abfb837d2dd31d$var$Wn(e, t, i) {
    var tmp = t.$$slots, s = tmp === void 0 ? {} : tmp, r = t.$$scope, tmp1 = t.class, a = tmp1 === void 0 ? "" : tmp1, tmp2 = t.flat, l = tmp2 === void 0 ? !1 : tmp2, tmp3 = t.tile, n = tmp3 === void 0 ? !1 : tmp3, tmp4 = t.outlined, o = tmp4 === void 0 ? !1 : tmp4, tmp5 = t.raised, c = tmp5 === void 0 ? !1 : tmp5, tmp6 = t.shaped, g = tmp6 === void 0 ? !1 : tmp6, tmp7 = t.hover, u = tmp7 === void 0 ? !1 : tmp7, tmp8 = t.link, d = tmp8 === void 0 ? !1 : tmp8, tmp9 = t.loading, f = tmp9 === void 0 ? !1 : tmp9, tmp10 = t.disabled, p = tmp10 === void 0 ? !1 : tmp10, tmp11 = t.style, m = tmp11 === void 0 ? null : tmp11;
    return e.$$set = function(h) {
        "class" in h && i(0, a = h.class), "flat" in h && i(1, l = h.flat), "tile" in h && i(2, n = h.tile), "outlined" in h && i(3, o = h.outlined), "raised" in h && i(4, c = h.raised), "shaped" in h && i(5, g = h.shaped), "hover" in h && i(6, u = h.hover), "link" in h && i(7, d = h.link), "loading" in h && i(8, f = h.loading), "disabled" in h && i(9, p = h.disabled), "style" in h && i(10, m = h.style), "$$scope" in h && i(11, r = h.$$scope);
    }, [
        a,
        l,
        n,
        o,
        c,
        g,
        u,
        d,
        f,
        p,
        m,
        r,
        s
    ];
}
var $37abfb837d2dd31d$var$Qn = /*#__PURE__*/ function(q) {
    (0, $ftJVG._)(Qn, q);
    var _super = (0, $6OZAO._)(Qn);
    function Qn(t) {
        (0, $978gY._)(this, Qn);
        var _this;
        _this = _super.call(this), $37abfb837d2dd31d$var$X((0, $3vWwE._)(_this), t, $37abfb837d2dd31d$var$Wn, $37abfb837d2dd31d$var$Rn, $37abfb837d2dd31d$var$H, {
            class: 0,
            flat: 1,
            tile: 2,
            outlined: 3,
            raised: 4,
            shaped: 5,
            hover: 6,
            link: 7,
            loading: 8,
            disabled: 9,
            style: 10
        }, $37abfb837d2dd31d$var$Fn);
        return (0, $ho5gk._)(_this);
    }
    return Qn;
}($37abfb837d2dd31d$var$q);
function $37abfb837d2dd31d$var$Un(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-eawucv", ".s-card-actions{align-items:center;display:flex;padding:8px}");
}
function $37abfb837d2dd31d$var$Yn(e) {
    var t, i, s;
    var r = e[3].default, a = $37abfb837d2dd31d$var$B(r, e, e[2], null);
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("div"), a && a.c(), $37abfb837d2dd31d$var$b(t, "class", i = "s-card-actions " + e[0]), $37abfb837d2dd31d$var$b(t, "style", e[1]);
        },
        m: function(l, n) {
            $37abfb837d2dd31d$var$$(l, t, n), a && a.m(t, null), s = !0;
        },
        p: function(l, param) {
            var _param = (0, $8GFUW._)(param, 1), n = _param[0];
            a && a.p && (!s || 4 & n) && $37abfb837d2dd31d$var$W(a, r, l, l[2], s ? $37abfb837d2dd31d$var$R(r, l[2], n, null) : $37abfb837d2dd31d$var$Q(l[2]), null), (!s || 1 & n && i !== (i = "s-card-actions " + l[0])) && $37abfb837d2dd31d$var$b(t, "class", i), (!s || 2 & n) && $37abfb837d2dd31d$var$b(t, "style", l[1]);
        },
        i: function(l) {
            s || ($37abfb837d2dd31d$var$j(a, l), s = !0);
        },
        o: function(l) {
            $37abfb837d2dd31d$var$k(a, l), s = !1;
        },
        d: function(l) {
            l && $37abfb837d2dd31d$var$z(t), a && a.d(l);
        }
    };
}
function $37abfb837d2dd31d$var$Gn(e, t, i) {
    var tmp = t.$$slots, s = tmp === void 0 ? {} : tmp, r = t.$$scope, tmp1 = t.class, a = tmp1 === void 0 ? "" : tmp1, tmp2 = t.style, l = tmp2 === void 0 ? null : tmp2;
    return e.$$set = function(n) {
        "class" in n && i(0, a = n.class), "style" in n && i(1, l = n.style), "$$scope" in n && i(2, r = n.$$scope);
    }, [
        a,
        l,
        r,
        s
    ];
}
var $37abfb837d2dd31d$var$Zn = /*#__PURE__*/ function(q) {
    (0, $ftJVG._)(Zn, q);
    var _super = (0, $6OZAO._)(Zn);
    function Zn(t) {
        (0, $978gY._)(this, Zn);
        var _this;
        _this = _super.call(this), $37abfb837d2dd31d$var$X((0, $3vWwE._)(_this), t, $37abfb837d2dd31d$var$Gn, $37abfb837d2dd31d$var$Yn, $37abfb837d2dd31d$var$H, {
            class: 0,
            style: 1
        }, $37abfb837d2dd31d$var$Un);
        return (0, $ho5gk._)(_this);
    }
    return Zn;
}($37abfb837d2dd31d$var$q);
function $37abfb837d2dd31d$var$Vn(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-2cbqpn", ".s-card-text{width:100%;color:var(--theme-text-secondary);font-size:0.875rem;font-weight:400;line-height:1.375rem;letter-spacing:0.0071428571em;padding:16px}");
}
function $37abfb837d2dd31d$var$Hn(e) {
    var t, i, s;
    var r = e[3].default, a = $37abfb837d2dd31d$var$B(r, e, e[2], null);
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("div"), a && a.c(), $37abfb837d2dd31d$var$b(t, "class", i = "s-card-text " + e[0]), $37abfb837d2dd31d$var$b(t, "style", e[1]);
        },
        m: function(l, n) {
            $37abfb837d2dd31d$var$$(l, t, n), a && a.m(t, null), s = !0;
        },
        p: function(l, param) {
            var _param = (0, $8GFUW._)(param, 1), n = _param[0];
            a && a.p && (!s || 4 & n) && $37abfb837d2dd31d$var$W(a, r, l, l[2], s ? $37abfb837d2dd31d$var$R(r, l[2], n, null) : $37abfb837d2dd31d$var$Q(l[2]), null), (!s || 1 & n && i !== (i = "s-card-text " + l[0])) && $37abfb837d2dd31d$var$b(t, "class", i), (!s || 2 & n) && $37abfb837d2dd31d$var$b(t, "style", l[1]);
        },
        i: function(l) {
            s || ($37abfb837d2dd31d$var$j(a, l), s = !0);
        },
        o: function(l) {
            $37abfb837d2dd31d$var$k(a, l), s = !1;
        },
        d: function(l) {
            l && $37abfb837d2dd31d$var$z(t), a && a.d(l);
        }
    };
}
function $37abfb837d2dd31d$var$Jn(e, t, i) {
    var tmp = t.$$slots, s = tmp === void 0 ? {} : tmp, r = t.$$scope, tmp1 = t.class, a = tmp1 === void 0 ? "" : tmp1, tmp2 = t.style, l = tmp2 === void 0 ? null : tmp2;
    return e.$$set = function(n) {
        "class" in n && i(0, a = n.class), "style" in n && i(1, l = n.style), "$$scope" in n && i(2, r = n.$$scope);
    }, [
        a,
        l,
        r,
        s
    ];
}
var $37abfb837d2dd31d$var$Xn = /*#__PURE__*/ function(q) {
    (0, $ftJVG._)(Xn, q);
    var _super = (0, $6OZAO._)(Xn);
    function Xn(t) {
        (0, $978gY._)(this, Xn);
        var _this;
        _this = _super.call(this), $37abfb837d2dd31d$var$X((0, $3vWwE._)(_this), t, $37abfb837d2dd31d$var$Jn, $37abfb837d2dd31d$var$Hn, $37abfb837d2dd31d$var$H, {
            class: 0,
            style: 1
        }, $37abfb837d2dd31d$var$Vn);
        return (0, $ho5gk._)(_this);
    }
    return Xn;
}($37abfb837d2dd31d$var$q);
function $37abfb837d2dd31d$var$qn(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-1jn8jdl", ".s-card-title{align-items:center;display:flex;flex-wrap:wrap;font-size:1.25rem;font-weight:500;letter-spacing:0.0125em;line-height:2rem;word-break:break-all;padding:16px}.s-card-title+.s-card-subtitle,.s-card-title+.s-card-title{padding-top:0;margin-top:-16px}.s-card-title+.s-card-subtitle{margin-top:-16px}");
}
function $37abfb837d2dd31d$var$Kn(e) {
    var t, i, s;
    var r = e[3].default, a = $37abfb837d2dd31d$var$B(r, e, e[2], null);
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("div"), a && a.c(), $37abfb837d2dd31d$var$b(t, "class", i = "s-card-title " + e[0]), $37abfb837d2dd31d$var$b(t, "style", e[1]);
        },
        m: function(l, n) {
            $37abfb837d2dd31d$var$$(l, t, n), a && a.m(t, null), s = !0;
        },
        p: function(l, param) {
            var _param = (0, $8GFUW._)(param, 1), n = _param[0];
            a && a.p && (!s || 4 & n) && $37abfb837d2dd31d$var$W(a, r, l, l[2], s ? $37abfb837d2dd31d$var$R(r, l[2], n, null) : $37abfb837d2dd31d$var$Q(l[2]), null), (!s || 1 & n && i !== (i = "s-card-title " + l[0])) && $37abfb837d2dd31d$var$b(t, "class", i), (!s || 2 & n) && $37abfb837d2dd31d$var$b(t, "style", l[1]);
        },
        i: function(l) {
            s || ($37abfb837d2dd31d$var$j(a, l), s = !0);
        },
        o: function(l) {
            $37abfb837d2dd31d$var$k(a, l), s = !1;
        },
        d: function(l) {
            l && $37abfb837d2dd31d$var$z(t), a && a.d(l);
        }
    };
}
function $37abfb837d2dd31d$var$ti(e, t, i) {
    var tmp = t.$$slots, s = tmp === void 0 ? {} : tmp, r = t.$$scope, tmp1 = t.class, a = tmp1 === void 0 ? "" : tmp1, tmp2 = t.style, l = tmp2 === void 0 ? null : tmp2;
    return e.$$set = function(n) {
        "class" in n && i(0, a = n.class), "style" in n && i(1, l = n.style), "$$scope" in n && i(2, r = n.$$scope);
    }, [
        a,
        l,
        r,
        s
    ];
}
var $37abfb837d2dd31d$var$Ye = /*#__PURE__*/ function(q) {
    (0, $ftJVG._)(Ye, q);
    var _super = (0, $6OZAO._)(Ye);
    function Ye(t) {
        (0, $978gY._)(this, Ye);
        var _this;
        _this = _super.call(this), $37abfb837d2dd31d$var$X((0, $3vWwE._)(_this), t, $37abfb837d2dd31d$var$ti, $37abfb837d2dd31d$var$Kn, $37abfb837d2dd31d$var$H, {
            class: 0,
            style: 1
        }, $37abfb837d2dd31d$var$qn);
        return (0, $ho5gk._)(_this);
    }
    return Ye;
}($37abfb837d2dd31d$var$q);
function $37abfb837d2dd31d$var$ei(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $37abfb837d2dd31d$var$ni = $37abfb837d2dd31d$var$ei(function(e) {
    var t = {};
    function i(s) {
        if (t[s]) return t[s].exports;
        var r = t[s] = {
            i: s,
            l: !1,
            exports: {}
        };
        return e[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
    }
    return i.m = e, i.c = t, i.d = function(s, r, a) {
        i.o(s, r) || Object.defineProperty(s, r, {
            enumerable: !0,
            get: a
        });
    }, i.r = function(s) {
        (typeof Symbol === "undefined" ? "undefined" : (0, $1ObTH._)(Symbol)) < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(s, "__esModule", {
            value: !0
        });
    }, i.t = function(s, r) {
        if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
        var a = Object.create(null);
        if (i.r(a), Object.defineProperty(a, "default", {
            enumerable: !0,
            value: s
        }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(n) {
            return s[n];
        }).bind(null, l));
        return a;
    }, i.n = function(s) {
        var r = s && s.__esModule ? function r() {
            return s.default;
        } : function() {
            return s;
        };
        return i.d(r, "a", r), r;
    }, i.o = function(s, r) {
        return Object.prototype.hasOwnProperty.call(s, r);
    }, i.p = "", i(i.s = 90);
}({
    17: function(e, t, i) {
        t.__esModule = !0, t.default = void 0;
        var s = i(18), r = function() {
            var a = function a() {};
            return a.getFirstMatch = function(l, n) {
                var o = n.match(l);
                return o && o.length > 0 && o[1] || "";
            }, a.getSecondMatch = function(l, n) {
                var o = n.match(l);
                return o && o.length > 1 && o[2] || "";
            }, a.matchAndReturnConst = function(l, n, o) {
                if (l.test(n)) return o;
            }, a.getWindowsVersionName = function(l) {
                switch(l){
                    case "NT":
                        return "NT";
                    case "XP":
                    case "NT 5.1":
                        return "XP";
                    case "NT 5.0":
                        return "2000";
                    case "NT 5.2":
                        return "2003";
                    case "NT 6.0":
                        return "Vista";
                    case "NT 6.1":
                        return "7";
                    case "NT 6.2":
                        return "8";
                    case "NT 6.3":
                        return "8.1";
                    case "NT 10.0":
                        return "10";
                    default:
                        return;
                }
            }, a.getMacOSVersionName = function(l) {
                var n = l.split(".").splice(0, 2).map(function(o) {
                    return parseInt(o, 10) || 0;
                });
                if (n.push(0), n[0] === 10) switch(n[1]){
                    case 5:
                        return "Leopard";
                    case 6:
                        return "Snow Leopard";
                    case 7:
                        return "Lion";
                    case 8:
                        return "Mountain Lion";
                    case 9:
                        return "Mavericks";
                    case 10:
                        return "Yosemite";
                    case 11:
                        return "El Capitan";
                    case 12:
                        return "Sierra";
                    case 13:
                        return "High Sierra";
                    case 14:
                        return "Mojave";
                    case 15:
                        return "Catalina";
                    default:
                        return;
                }
            }, a.getAndroidVersionName = function(l) {
                var n = l.split(".").splice(0, 2).map(function(o) {
                    return parseInt(o, 10) || 0;
                });
                if (n.push(0), !(n[0] === 1 && n[1] < 5)) return n[0] === 1 && n[1] < 6 ? "Cupcake" : n[0] === 1 && n[1] >= 6 ? "Donut" : n[0] === 2 && n[1] < 2 ? "Eclair" : n[0] === 2 && n[1] === 2 ? "Froyo" : n[0] === 2 && n[1] > 2 ? "Gingerbread" : n[0] === 3 ? "Honeycomb" : n[0] === 4 && n[1] < 1 ? "Ice Cream Sandwich" : n[0] === 4 && n[1] < 4 ? "Jelly Bean" : n[0] === 4 && n[1] >= 4 ? "KitKat" : n[0] === 5 ? "Lollipop" : n[0] === 6 ? "Marshmallow" : n[0] === 7 ? "Nougat" : n[0] === 8 ? "Oreo" : n[0] === 9 ? "Pie" : void 0;
            }, a.getVersionPrecision = function(l) {
                return l.split(".").length;
            }, a.compareVersions = function(l, n, o) {
                o === void 0 && (o = !1);
                var c = a.getVersionPrecision(l), g = a.getVersionPrecision(n), u = Math.max(c, g), d = 0, f = a.map([
                    l,
                    n
                ], function(p) {
                    var m = u - a.getVersionPrecision(p), h = p + new Array(m + 1).join(".0");
                    return a.map(h.split("."), function(x) {
                        return new Array(20 - x.length).join("0") + x;
                    }).reverse();
                });
                for(o && (d = u - Math.min(c, g)), u -= 1; u >= d;){
                    if (f[0][u] > f[1][u]) return 1;
                    if (f[0][u] === f[1][u]) {
                        if (u === d) return 0;
                        u -= 1;
                    } else if (f[0][u] < f[1][u]) return -1;
                }
            }, a.map = function(l, n) {
                var o, c = [];
                if (Array.prototype.map) return Array.prototype.map.call(l, n);
                for(o = 0; o < l.length; o += 1)c.push(n(l[o]));
                return c;
            }, a.find = function(l, n) {
                var o, c;
                if (Array.prototype.find) return Array.prototype.find.call(l, n);
                for(o = 0, c = l.length; o < c; o += 1){
                    var g = l[o];
                    if (n(g, o)) return g;
                }
            }, a.assign = function(l) {
                for(var n, o, c = l, g = arguments.length, u = new Array(g > 1 ? g - 1 : 0), d = 1; d < g; d++)u[d - 1] = arguments[d];
                if (Object.assign) return Object.assign.apply(Object, [
                    l
                ].concat(u));
                var f = function f() {
                    var p = u[n];
                    typeof p == "object" && p !== null && Object.keys(p).forEach(function(m) {
                        c[m] = p[m];
                    });
                };
                for(n = 0, o = u.length; n < o; n += 1)f();
                return l;
            }, a.getBrowserAlias = function(l) {
                return s.BROWSER_ALIASES_MAP[l];
            }, a.getBrowserTypeByAlias = function(l) {
                return s.BROWSER_MAP[l] || "";
            }, a;
        }();
        t.default = r, e.exports = t.default;
    },
    18: function(e, t, i) {
        t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0, t.BROWSER_ALIASES_MAP = {
            "Amazon Silk": "amazon_silk",
            "Android Browser": "android",
            Bada: "bada",
            BlackBerry: "blackberry",
            Chrome: "chrome",
            Chromium: "chromium",
            Electron: "electron",
            Epiphany: "epiphany",
            Firefox: "firefox",
            Focus: "focus",
            Generic: "generic",
            "Google Search": "google_search",
            Googlebot: "googlebot",
            "Internet Explorer": "ie",
            "K-Meleon": "k_meleon",
            Maxthon: "maxthon",
            "Microsoft Edge": "edge",
            "MZ Browser": "mz",
            "NAVER Whale Browser": "naver",
            Opera: "opera",
            "Opera Coast": "opera_coast",
            PhantomJS: "phantomjs",
            Puffin: "puffin",
            QupZilla: "qupzilla",
            QQ: "qq",
            QQLite: "qqlite",
            Safari: "safari",
            Sailfish: "sailfish",
            "Samsung Internet for Android": "samsung_internet",
            SeaMonkey: "seamonkey",
            Sleipnir: "sleipnir",
            Swing: "swing",
            Tizen: "tizen",
            "UC Browser": "uc",
            Vivaldi: "vivaldi",
            "WebOS Browser": "webos",
            WeChat: "wechat",
            "Yandex Browser": "yandex",
            Roku: "roku"
        }, t.BROWSER_MAP = {
            amazon_silk: "Amazon Silk",
            android: "Android Browser",
            bada: "Bada",
            blackberry: "BlackBerry",
            chrome: "Chrome",
            chromium: "Chromium",
            electron: "Electron",
            epiphany: "Epiphany",
            firefox: "Firefox",
            focus: "Focus",
            generic: "Generic",
            googlebot: "Googlebot",
            google_search: "Google Search",
            ie: "Internet Explorer",
            k_meleon: "K-Meleon",
            maxthon: "Maxthon",
            edge: "Microsoft Edge",
            mz: "MZ Browser",
            naver: "NAVER Whale Browser",
            opera: "Opera",
            opera_coast: "Opera Coast",
            phantomjs: "PhantomJS",
            puffin: "Puffin",
            qupzilla: "QupZilla",
            qq: "QQ Browser",
            qqlite: "QQ Browser Lite",
            safari: "Safari",
            sailfish: "Sailfish",
            samsung_internet: "Samsung Internet for Android",
            seamonkey: "SeaMonkey",
            sleipnir: "Sleipnir",
            swing: "Swing",
            tizen: "Tizen",
            uc: "UC Browser",
            vivaldi: "Vivaldi",
            webos: "WebOS Browser",
            wechat: "WeChat",
            yandex: "Yandex Browser"
        }, t.PLATFORMS_MAP = {
            tablet: "tablet",
            mobile: "mobile",
            desktop: "desktop",
            tv: "tv"
        }, t.OS_MAP = {
            WindowsPhone: "Windows Phone",
            Windows: "Windows",
            MacOS: "macOS",
            iOS: "iOS",
            Android: "Android",
            WebOS: "WebOS",
            BlackBerry: "BlackBerry",
            Bada: "Bada",
            Tizen: "Tizen",
            Linux: "Linux",
            ChromeOS: "Chrome OS",
            PlayStation4: "PlayStation 4",
            Roku: "Roku"
        }, t.ENGINE_MAP = {
            EdgeHTML: "EdgeHTML",
            Blink: "Blink",
            Trident: "Trident",
            Presto: "Presto",
            Gecko: "Gecko",
            WebKit: "WebKit"
        };
    },
    90: function(e, t, i) {
        var l = function l(o, c) {
            for(var g = 0; g < c.length; g++){
                var u = c[g];
                u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(o, u.key, u);
            }
        };
        t.__esModule = !0, t.default = void 0;
        var s, r = (s = i(91)) && s.__esModule ? s : {
            default: s
        }, a = i(18);
        var n = function() {
            var o = function o() {};
            var c, g, u;
            return o.getParser = function(d, f) {
                if (f === void 0 && (f = !1), typeof d != "string") throw new Error("UserAgent should be a string");
                return new r.default(d, f);
            }, o.parse = function(d) {
                return new r.default(d).getResult();
            }, c = o, u = [
                {
                    key: "BROWSER_MAP",
                    get: function get() {
                        return a.BROWSER_MAP;
                    }
                },
                {
                    key: "ENGINE_MAP",
                    get: function get() {
                        return a.ENGINE_MAP;
                    }
                },
                {
                    key: "OS_MAP",
                    get: function get() {
                        return a.OS_MAP;
                    }
                },
                {
                    key: "PLATFORMS_MAP",
                    get: function get() {
                        return a.PLATFORMS_MAP;
                    }
                }
            ], g = null, u && l(c, u), o;
        }();
        t.default = n, e.exports = t.default;
    },
    91: function(e, t, i) {
        var o = function o(g) {
            return g && g.__esModule ? g : {
                default: g
            };
        };
        t.__esModule = !0, t.default = void 0;
        var s = o(i(92)), r = o(i(93)), a = o(i(94)), l = o(i(95)), n = o(i(17));
        var c = function() {
            var g = function g(d, f) {
                if (f === void 0 && (f = !1), d == null || d === "") throw new Error("UserAgent parameter can't be empty");
                this._ua = d, this.parsedResult = {}, f !== !0 && this.parse();
            };
            var u = g.prototype;
            return u.getUA = function() {
                return this._ua;
            }, u.test = function(d) {
                return d.test(this._ua);
            }, u.parseBrowser = function() {
                var d = this;
                this.parsedResult.browser = {};
                var f = n.default.find(s.default, function(p) {
                    if (typeof p.test == "function") return p.test(d);
                    if (p.test instanceof Array) return p.test.some(function(m) {
                        return d.test(m);
                    });
                    throw new Error("Browser's test function is not valid");
                });
                return f && (this.parsedResult.browser = f.describe(this.getUA())), this.parsedResult.browser;
            }, u.getBrowser = function() {
                return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
            }, u.getBrowserName = function(d) {
                return d ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
            }, u.getBrowserVersion = function() {
                return this.getBrowser().version;
            }, u.getOS = function() {
                return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
            }, u.parseOS = function() {
                var d = this;
                this.parsedResult.os = {};
                var f = n.default.find(r.default, function(p) {
                    if (typeof p.test == "function") return p.test(d);
                    if (p.test instanceof Array) return p.test.some(function(m) {
                        return d.test(m);
                    });
                    throw new Error("Browser's test function is not valid");
                });
                return f && (this.parsedResult.os = f.describe(this.getUA())), this.parsedResult.os;
            }, u.getOSName = function(d) {
                var f = this.getOS().name;
                return d ? String(f).toLowerCase() || "" : f || "";
            }, u.getOSVersion = function() {
                return this.getOS().version;
            }, u.getPlatform = function() {
                return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
            }, u.getPlatformType = function(d) {
                d === void 0 && (d = !1);
                var f = this.getPlatform().type;
                return d ? String(f).toLowerCase() || "" : f || "";
            }, u.parsePlatform = function() {
                var d = this;
                this.parsedResult.platform = {};
                var f = n.default.find(a.default, function(p) {
                    if (typeof p.test == "function") return p.test(d);
                    if (p.test instanceof Array) return p.test.some(function(m) {
                        return d.test(m);
                    });
                    throw new Error("Browser's test function is not valid");
                });
                return f && (this.parsedResult.platform = f.describe(this.getUA())), this.parsedResult.platform;
            }, u.getEngine = function() {
                return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
            }, u.getEngineName = function(d) {
                return d ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
            }, u.parseEngine = function() {
                var d = this;
                this.parsedResult.engine = {};
                var f = n.default.find(l.default, function(p) {
                    if (typeof p.test == "function") return p.test(d);
                    if (p.test instanceof Array) return p.test.some(function(m) {
                        return d.test(m);
                    });
                    throw new Error("Browser's test function is not valid");
                });
                return f && (this.parsedResult.engine = f.describe(this.getUA())), this.parsedResult.engine;
            }, u.parse = function() {
                return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
            }, u.getResult = function() {
                return n.default.assign({}, this.parsedResult);
            }, u.satisfies = function(d) {
                var f = this, p = {}, m = 0, h = {}, x = 0;
                if (Object.keys(d).forEach(function(D) {
                    var P = d[D];
                    typeof P == "string" ? (h[D] = P, x += 1) : typeof P == "object" && (p[D] = P, m += 1);
                }), m > 0) {
                    var N = Object.keys(p), M = n.default.find(N, function(D) {
                        return f.isOS(D);
                    });
                    if (M) {
                        var w = this.satisfies(p[M]);
                        if (w !== void 0) return w;
                    }
                    var A = n.default.find(N, function(D) {
                        return f.isPlatform(D);
                    });
                    if (A) {
                        var C = this.satisfies(p[A]);
                        if (C !== void 0) return C;
                    }
                }
                if (x > 0) {
                    var O = Object.keys(h), v = n.default.find(O, function(D) {
                        return f.isBrowser(D, !0);
                    });
                    if (v !== void 0) return this.compareVersion(h[v]);
                }
            }, u.isBrowser = function(d, f) {
                f === void 0 && (f = !1);
                var p = this.getBrowserName().toLowerCase(), m = d.toLowerCase(), h = n.default.getBrowserTypeByAlias(m);
                return f && h && (m = h.toLowerCase()), m === p;
            }, u.compareVersion = function(d) {
                var f = [
                    0
                ], p = d, m = !1, h = this.getBrowserVersion();
                if (typeof h == "string") return d[0] === ">" || d[0] === "<" ? (p = d.substr(1), d[1] === "=" ? (m = !0, p = d.substr(2)) : f = [], d[0] === ">" ? f.push(1) : f.push(-1)) : d[0] === "=" ? p = d.substr(1) : d[0] === "~" && (m = !0, p = d.substr(1)), f.indexOf(n.default.compareVersions(h, p, m)) > -1;
            }, u.isOS = function(d) {
                return this.getOSName(!0) === String(d).toLowerCase();
            }, u.isPlatform = function(d) {
                return this.getPlatformType(!0) === String(d).toLowerCase();
            }, u.isEngine = function(d) {
                return this.getEngineName(!0) === String(d).toLowerCase();
            }, u.is = function(d, f) {
                return f === void 0 && (f = !1), this.isBrowser(d, f) || this.isOS(d) || this.isPlatform(d);
            }, u.some = function(d) {
                var f = this;
                return d === void 0 && (d = []), d.some(function(p) {
                    return f.is(p);
                });
            }, g;
        }();
        t.default = c, e.exports = t.default;
    },
    92: function(e, t, i) {
        t.__esModule = !0, t.default = void 0;
        var s, r = (s = i(17)) && s.__esModule ? s : {
            default: s
        }, a = /version\/(\d+(\.?_?\d+)+)/i, l = [
            {
                test: [
                    /googlebot/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Googlebot"
                    }, c = r.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /opera/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Opera"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /opr\/|opios/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Opera"
                    }, c = r.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /SamsungBrowser/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Samsung Internet for Android"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /Whale/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "NAVER Whale Browser"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /MZBrowser/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "MZ Browser"
                    }, c = r.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /focus/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Focus"
                    }, c = r.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /swing/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Swing"
                    }, c = r.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /coast/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Opera Coast"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /opt\/\d+(?:.?_?\d+)+/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Opera Touch"
                    }, c = r.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /yabrowser/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Yandex Browser"
                    }, c = r.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /ucbrowser/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "UC Browser"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /Maxthon|mxios/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Maxthon"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /epiphany/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Epiphany"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /puffin/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Puffin"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /sleipnir/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Sleipnir"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /k-meleon/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "K-Meleon"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /micromessenger/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "WeChat"
                    }, c = r.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /qqbrowser/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: /qqbrowserlite/i.test(n) ? "QQ Browser Lite" : "QQ Browser"
                    }, c = r.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /msie|trident/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Internet Explorer"
                    }, c = r.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /\sedg\//i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Microsoft Edge"
                    }, c = r.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /edg([ea]|ios)/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Microsoft Edge"
                    }, c = r.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /vivaldi/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Vivaldi"
                    }, c = r.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /seamonkey/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "SeaMonkey"
                    }, c = r.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /sailfish/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Sailfish"
                    }, c = r.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /silk/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Amazon Silk"
                    }, c = r.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /phantom/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "PhantomJS"
                    }, c = r.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /slimerjs/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "SlimerJS"
                    }, c = r.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /blackberry|\bbb\d+/i,
                    /rim\stablet/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "BlackBerry"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /(web|hpw)[o0]s/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "WebOS Browser"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /bada/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Bada"
                    }, c = r.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /tizen/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Tizen"
                    }, c = r.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /qupzilla/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "QupZilla"
                    }, c = r.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /firefox|iceweasel|fxios/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Firefox"
                    }, c = r.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /electron/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Electron"
                    }, c = r.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /MiuiBrowser/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Miui"
                    }, c = r.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /chromium/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Chromium"
                    }, c = r.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /chrome|crios|crmo/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Chrome"
                    }, c = r.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /GSA/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Google Search"
                    }, c = r.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: function test(n) {
                    var o = !n.test(/like android/i), c = n.test(/android/i);
                    return o && c;
                },
                describe: function describe(n) {
                    var o = {
                        name: "Android Browser"
                    }, c = r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /playstation 4/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "PlayStation 4"
                    }, c = r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /safari|applewebkit/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: "Safari"
                    }, c = r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /.*/i
                ],
                describe: function describe(n) {
                    var o = n.search("\\(") !== -1 ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                    return {
                        name: r.default.getFirstMatch(o, n),
                        version: r.default.getSecondMatch(o, n)
                    };
                }
            }
        ];
        t.default = l, e.exports = t.default;
    },
    93: function(e, t, i) {
        t.__esModule = !0, t.default = void 0;
        var s, r = (s = i(17)) && s.__esModule ? s : {
            default: s
        }, a = i(18), l = [
            {
                test: [
                    /Roku\/DVP/
                ],
                describe: function describe(n) {
                    var o = r.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, n);
                    return {
                        name: a.OS_MAP.Roku,
                        version: o
                    };
                }
            },
            {
                test: [
                    /windows phone/i
                ],
                describe: function describe(n) {
                    var o = r.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, n);
                    return {
                        name: a.OS_MAP.WindowsPhone,
                        version: o
                    };
                }
            },
            {
                test: [
                    /windows /i
                ],
                describe: function describe(n) {
                    var o = r.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, n), c = r.default.getWindowsVersionName(o);
                    return {
                        name: a.OS_MAP.Windows,
                        version: o,
                        versionName: c
                    };
                }
            },
            {
                test: [
                    /Macintosh(.*?) FxiOS(.*?)\//
                ],
                describe: function describe(n) {
                    var o = {
                        name: a.OS_MAP.iOS
                    }, c = r.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /macintosh/i
                ],
                describe: function describe(n) {
                    var o = r.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, n).replace(/[_\s]/g, "."), c = r.default.getMacOSVersionName(o), g = {
                        name: a.OS_MAP.MacOS,
                        version: o
                    };
                    return c && (g.versionName = c), g;
                }
            },
            {
                test: [
                    /(ipod|iphone|ipad)/i
                ],
                describe: function describe(n) {
                    var o = r.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, n).replace(/[_\s]/g, ".");
                    return {
                        name: a.OS_MAP.iOS,
                        version: o
                    };
                }
            },
            {
                test: function test(n) {
                    var o = !n.test(/like android/i), c = n.test(/android/i);
                    return o && c;
                },
                describe: function describe(n) {
                    var o = r.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, n), c = r.default.getAndroidVersionName(o), g = {
                        name: a.OS_MAP.Android,
                        version: o
                    };
                    return c && (g.versionName = c), g;
                }
            },
            {
                test: [
                    /(web|hpw)[o0]s/i
                ],
                describe: function describe(n) {
                    var o = r.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, n), c = {
                        name: a.OS_MAP.WebOS
                    };
                    return o && o.length && (c.version = o), c;
                }
            },
            {
                test: [
                    /blackberry|\bbb\d+/i,
                    /rim\stablet/i
                ],
                describe: function describe(n) {
                    var o = r.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, n) || r.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, n) || r.default.getFirstMatch(/\bbb(\d+)/i, n);
                    return {
                        name: a.OS_MAP.BlackBerry,
                        version: o
                    };
                }
            },
            {
                test: [
                    /bada/i
                ],
                describe: function describe(n) {
                    var o = r.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, n);
                    return {
                        name: a.OS_MAP.Bada,
                        version: o
                    };
                }
            },
            {
                test: [
                    /tizen/i
                ],
                describe: function describe(n) {
                    var o = r.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, n);
                    return {
                        name: a.OS_MAP.Tizen,
                        version: o
                    };
                }
            },
            {
                test: [
                    /linux/i
                ],
                describe: function describe() {
                    return {
                        name: a.OS_MAP.Linux
                    };
                }
            },
            {
                test: [
                    /CrOS/
                ],
                describe: function describe() {
                    return {
                        name: a.OS_MAP.ChromeOS
                    };
                }
            },
            {
                test: [
                    /PlayStation 4/
                ],
                describe: function describe(n) {
                    var o = r.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, n);
                    return {
                        name: a.OS_MAP.PlayStation4,
                        version: o
                    };
                }
            }
        ];
        t.default = l, e.exports = t.default;
    },
    94: function(e, t, i) {
        t.__esModule = !0, t.default = void 0;
        var s, r = (s = i(17)) && s.__esModule ? s : {
            default: s
        }, a = i(18), l = [
            {
                test: [
                    /googlebot/i
                ],
                describe: function describe() {
                    return {
                        type: "bot",
                        vendor: "Google"
                    };
                }
            },
            {
                test: [
                    /huawei/i
                ],
                describe: function describe(n) {
                    var o = r.default.getFirstMatch(/(can-l01)/i, n) && "Nova", c = {
                        type: a.PLATFORMS_MAP.mobile,
                        vendor: "Huawei"
                    };
                    return o && (c.model = o), c;
                }
            },
            {
                test: [
                    /nexus\s*(?:7|8|9|10).*/i
                ],
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.tablet,
                        vendor: "Nexus"
                    };
                }
            },
            {
                test: [
                    /ipad/i
                ],
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.tablet,
                        vendor: "Apple",
                        model: "iPad"
                    };
                }
            },
            {
                test: [
                    /Macintosh(.*?) FxiOS(.*?)\//
                ],
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.tablet,
                        vendor: "Apple",
                        model: "iPad"
                    };
                }
            },
            {
                test: [
                    /kftt build/i
                ],
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.tablet,
                        vendor: "Amazon",
                        model: "Kindle Fire HD 7"
                    };
                }
            },
            {
                test: [
                    /silk/i
                ],
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.tablet,
                        vendor: "Amazon"
                    };
                }
            },
            {
                test: [
                    /tablet(?! pc)/i
                ],
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.tablet
                    };
                }
            },
            {
                test: function test(n) {
                    var o = n.test(/ipod|iphone/i), c = n.test(/like (ipod|iphone)/i);
                    return o && !c;
                },
                describe: function describe(n) {
                    var o = r.default.getFirstMatch(/(ipod|iphone)/i, n);
                    return {
                        type: a.PLATFORMS_MAP.mobile,
                        vendor: "Apple",
                        model: o
                    };
                }
            },
            {
                test: [
                    /nexus\s*[0-6].*/i,
                    /galaxy nexus/i
                ],
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.mobile,
                        vendor: "Nexus"
                    };
                }
            },
            {
                test: [
                    /[^-]mobi/i
                ],
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.mobile
                    };
                }
            },
            {
                test: function test(n) {
                    return n.getBrowserName(!0) === "blackberry";
                },
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.mobile,
                        vendor: "BlackBerry"
                    };
                }
            },
            {
                test: function test(n) {
                    return n.getBrowserName(!0) === "bada";
                },
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.mobile
                    };
                }
            },
            {
                test: function test(n) {
                    return n.getBrowserName() === "windows phone";
                },
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.mobile,
                        vendor: "Microsoft"
                    };
                }
            },
            {
                test: function test(n) {
                    var o = Number(String(n.getOSVersion()).split(".")[0]);
                    return n.getOSName(!0) === "android" && o >= 3;
                },
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.tablet
                    };
                }
            },
            {
                test: function test(n) {
                    return n.getOSName(!0) === "android";
                },
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.mobile
                    };
                }
            },
            {
                test: function test(n) {
                    return n.getOSName(!0) === "macos";
                },
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.desktop,
                        vendor: "Apple"
                    };
                }
            },
            {
                test: function test(n) {
                    return n.getOSName(!0) === "windows";
                },
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.desktop
                    };
                }
            },
            {
                test: function test(n) {
                    return n.getOSName(!0) === "linux";
                },
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.desktop
                    };
                }
            },
            {
                test: function test(n) {
                    return n.getOSName(!0) === "playstation 4";
                },
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.tv
                    };
                }
            },
            {
                test: function test(n) {
                    return n.getOSName(!0) === "roku";
                },
                describe: function describe() {
                    return {
                        type: a.PLATFORMS_MAP.tv
                    };
                }
            }
        ];
        t.default = l, e.exports = t.default;
    },
    95: function(e, t, i) {
        t.__esModule = !0, t.default = void 0;
        var s, r = (s = i(17)) && s.__esModule ? s : {
            default: s
        }, a = i(18), l = [
            {
                test: function test(n) {
                    return n.getBrowserName(!0) === "microsoft edge";
                },
                describe: function describe(n) {
                    if (/\sedg\//i.test(n)) return {
                        name: a.ENGINE_MAP.Blink
                    };
                    var o = r.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, n);
                    return {
                        name: a.ENGINE_MAP.EdgeHTML,
                        version: o
                    };
                }
            },
            {
                test: [
                    /trident/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: a.ENGINE_MAP.Trident
                    }, c = r.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: function test(n) {
                    return n.test(/presto/i);
                },
                describe: function describe(n) {
                    var o = {
                        name: a.ENGINE_MAP.Presto
                    }, c = r.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: function test(n) {
                    var o = n.test(/gecko/i), c = n.test(/like gecko/i);
                    return o && !c;
                },
                describe: function describe(n) {
                    var o = {
                        name: a.ENGINE_MAP.Gecko
                    }, c = r.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /(apple)?webkit\/537\.36/i
                ],
                describe: function describe() {
                    return {
                        name: a.ENGINE_MAP.Blink
                    };
                }
            },
            {
                test: [
                    /(apple)?webkit/i
                ],
                describe: function describe(n) {
                    var o = {
                        name: a.ENGINE_MAP.WebKit
                    }, c = r.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            }
        ];
        t.default = l, e.exports = t.default;
    }
}));
function $37abfb837d2dd31d$var$Ge(e, t, i) {
    var s = e.slice();
    return s[22] = t[i], s[24] = i, s;
}
function $37abfb837d2dd31d$var$ii(e) {
    var t, i;
    return t = new $37abfb837d2dd31d$var$Ye({
        props: {
            style: "display: flex; justify-content: space-between; align-items: center; color: " + e[7],
            $$slots: {
                default: [
                    $37abfb837d2dd31d$var$ri
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), {
        c: function() {
            $37abfb837d2dd31d$var$J(t.$$.fragment);
        },
        m: function(s, r) {
            $37abfb837d2dd31d$var$G(t, s, r), i = !0;
        },
        p: function(s, r) {
            var a = {};
            33554441 & r && (a.$$scope = {
                dirty: r,
                ctx: s
            }), t.$set(a);
        },
        i: function(s) {
            i || ($37abfb837d2dd31d$var$j(t.$$.fragment, s), i = !0);
        },
        o: function(s) {
            $37abfb837d2dd31d$var$k(t.$$.fragment, s), i = !1;
        },
        d: function(s) {
            $37abfb837d2dd31d$var$Z(t, s);
        }
    };
}
function $37abfb837d2dd31d$var$si(e) {
    var t, i;
    return t = new $37abfb837d2dd31d$var$Ye({
        props: {
            style: "display: flex; justify-content: flex-start; align-items: center; color: " + e[7],
            $$slots: {
                default: [
                    $37abfb837d2dd31d$var$oi
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), {
        c: function() {
            $37abfb837d2dd31d$var$J(t.$$.fragment);
        },
        m: function(s, r) {
            $37abfb837d2dd31d$var$G(t, s, r), i = !0;
        },
        p: function(s, r) {
            var a = {};
            33554457 & r && (a.$$scope = {
                dirty: r,
                ctx: s
            }), t.$set(a);
        },
        i: function(s) {
            i || ($37abfb837d2dd31d$var$j(t.$$.fragment, s), i = !0);
        },
        o: function(s) {
            $37abfb837d2dd31d$var$k(t.$$.fragment, s), i = !1;
        },
        d: function(s) {
            $37abfb837d2dd31d$var$Z(t, s);
        }
    };
}
function $37abfb837d2dd31d$var$ri(e) {
    var t, i, s, r, a, l;
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$st($37abfb837d2dd31d$var$wi), i = $37abfb837d2dd31d$var$_(), s = $37abfb837d2dd31d$var$S("img"), $37abfb837d2dd31d$var$b(s, "alt", "Close"), $37abfb837d2dd31d$var$T(s, "cursor", "pointer"), $37abfb837d2dd31d$var$T(s, "filter", e[9]), $37abfb837d2dd31d$var$lt(s.src, r = $37abfb837d2dd31d$var$Ve) || $37abfb837d2dd31d$var$b(s, "src", r);
        },
        m: function(n, o) {
            $37abfb837d2dd31d$var$$(n, t, o), $37abfb837d2dd31d$var$$(n, i, o), $37abfb837d2dd31d$var$$(n, s, o), a || (l = $37abfb837d2dd31d$var$Y(s, "click", e[16]), a = !0);
        },
        p: $37abfb837d2dd31d$var$E,
        d: function(n) {
            n && $37abfb837d2dd31d$var$z(t), n && $37abfb837d2dd31d$var$z(i), n && $37abfb837d2dd31d$var$z(s), a = !1, l();
        }
    };
}
function $37abfb837d2dd31d$var$oi(e) {
    var t, i, s, r, a, l, n, o, c, g, u, d, f, p = e[4].name + "";
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("img"), i = $37abfb837d2dd31d$var$_(), s = $37abfb837d2dd31d$var$S("img"), l = $37abfb837d2dd31d$var$_(), n = $37abfb837d2dd31d$var$S("div"), o = $37abfb837d2dd31d$var$st(p), c = $37abfb837d2dd31d$var$_(), g = $37abfb837d2dd31d$var$S("img"), $37abfb837d2dd31d$var$b(t, "alt", "Back"), $37abfb837d2dd31d$var$T(t, "cursor", "pointer"), $37abfb837d2dd31d$var$T(t, "filter", e[9]), $37abfb837d2dd31d$var$lt(t.src, "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTIwIDExSDcuODNsNS41OS01LjU5TDEyIDRsLTggOCA4IDggMS40MS0xLjQxTDcuODMgMTNIMjB2LTJ6Ii8+PC9zdmc+") || $37abfb837d2dd31d$var$b(t, "src", "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTIwIDExSDcuODNsNS41OS01LjU5TDEyIDRsLTggOCA4IDggMS40MS0xLjQxTDcuODMgMTNIMjB2LTJ6Ii8+PC9zdmc+"), $37abfb837d2dd31d$var$T(s, "margin-inline-start", "10px"), $37abfb837d2dd31d$var$b(s, "width", "24px"), $37abfb837d2dd31d$var$lt(s.src, r = e[4].icon) || $37abfb837d2dd31d$var$b(s, "src", r), $37abfb837d2dd31d$var$b(s, "alt", a = e[4].name + " logo"), $37abfb837d2dd31d$var$T(n, "flex-grow", "1"), $37abfb837d2dd31d$var$T(n, "margin-inline-start", "4px"), $37abfb837d2dd31d$var$b(g, "alt", "Close"), $37abfb837d2dd31d$var$T(g, "cursor", "pointer"), $37abfb837d2dd31d$var$T(g, "filter", e[9]), $37abfb837d2dd31d$var$lt(g.src, u = $37abfb837d2dd31d$var$Ve) || $37abfb837d2dd31d$var$b(g, "src", u);
        },
        m: function(m, h) {
            $37abfb837d2dd31d$var$$(m, t, h), $37abfb837d2dd31d$var$$(m, i, h), $37abfb837d2dd31d$var$$(m, s, h), $37abfb837d2dd31d$var$$(m, l, h), $37abfb837d2dd31d$var$$(m, n, h), $37abfb837d2dd31d$var$L(n, o), $37abfb837d2dd31d$var$$(m, c, h), $37abfb837d2dd31d$var$$(m, g, h), d || (f = [
                $37abfb837d2dd31d$var$Y(t, "click", e[14]),
                $37abfb837d2dd31d$var$Y(g, "click", e[15])
            ], d = !0);
        },
        p: function(m, h) {
            16 & h && !$37abfb837d2dd31d$var$lt(s.src, r = m[4].icon) && $37abfb837d2dd31d$var$b(s, "src", r), 16 & h && a !== (a = m[4].name + " logo") && $37abfb837d2dd31d$var$b(s, "alt", a), 16 & h && p !== (p = m[4].name + "") && $37abfb837d2dd31d$var$je(o, p);
        },
        d: function(m) {
            m && $37abfb837d2dd31d$var$z(t), m && $37abfb837d2dd31d$var$z(i), m && $37abfb837d2dd31d$var$z(s), m && $37abfb837d2dd31d$var$z(l), m && $37abfb837d2dd31d$var$z(n), m && $37abfb837d2dd31d$var$z(c), m && $37abfb837d2dd31d$var$z(g), d = !1, $37abfb837d2dd31d$var$U(f);
        }
    };
}
function $37abfb837d2dd31d$var$ai(e) {
    var t;
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("div"), t.textContent = "No compatible wallets found for ".concat(e[10]);
        },
        m: function(i, s) {
            $37abfb837d2dd31d$var$$(i, t, s);
        },
        p: $37abfb837d2dd31d$var$E,
        i: $37abfb837d2dd31d$var$E,
        o: $37abfb837d2dd31d$var$E,
        d: function(i) {
            i && $37abfb837d2dd31d$var$z(t);
        }
    };
}
function $37abfb837d2dd31d$var$li(e) {
    var t, i;
    return t = new $37abfb837d2dd31d$var$mn({
        props: {
            style: "margin-inline-start: 24px; margin-inline-end: 24px",
            $$slots: {
                default: [
                    $37abfb837d2dd31d$var$gi
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), {
        c: function() {
            $37abfb837d2dd31d$var$J(t.$$.fragment);
        },
        m: function(s, r) {
            $37abfb837d2dd31d$var$G(t, s, r), i = !0;
        },
        p: function(s, r) {
            var a = {};
            33554463 & r && (a.$$scope = {
                dirty: r,
                ctx: s
            }), t.$set(a);
        },
        i: function(s) {
            i || ($37abfb837d2dd31d$var$j(t.$$.fragment, s), i = !0);
        },
        o: function(s) {
            $37abfb837d2dd31d$var$k(t.$$.fragment, s), i = !1;
        },
        d: function(s) {
            $37abfb837d2dd31d$var$Z(t, s);
        }
    };
}
function $37abfb837d2dd31d$var$ci(e) {
    var t, i, s, r;
    return t = new $37abfb837d2dd31d$var$Xn({
        props: {
            style: "margin-top: 12px; font-size: 0.92rem; color: " + e[7] + "; width: auto",
            $$slots: {
                default: [
                    $37abfb837d2dd31d$var$hi
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), s = new $37abfb837d2dd31d$var$Zn({
        props: {
            style: "justify-content: flex-end; margin-inline-end: 16px",
            $$slots: {
                default: [
                    $37abfb837d2dd31d$var$Mi
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), {
        c: function() {
            $37abfb837d2dd31d$var$J(t.$$.fragment), i = $37abfb837d2dd31d$var$_(), $37abfb837d2dd31d$var$J(s.$$.fragment);
        },
        m: function(a, l) {
            $37abfb837d2dd31d$var$G(t, a, l), $37abfb837d2dd31d$var$$(a, i, l), $37abfb837d2dd31d$var$G(s, a, l), r = !0;
        },
        p: function(a, l) {
            var n = {};
            33554432 & l && (n.$$scope = {
                dirty: l,
                ctx: a
            }), t.$set(n);
            var o = {};
            33554457 & l && (o.$$scope = {
                dirty: l,
                ctx: a
            }), s.$set(o);
        },
        i: function(a) {
            r || ($37abfb837d2dd31d$var$j(t.$$.fragment, a), $37abfb837d2dd31d$var$j(s.$$.fragment, a), r = !0);
        },
        o: function(a) {
            $37abfb837d2dd31d$var$k(t.$$.fragment, a), $37abfb837d2dd31d$var$k(s.$$.fragment, a), r = !1;
        },
        d: function(a) {
            $37abfb837d2dd31d$var$Z(t, a), a && $37abfb837d2dd31d$var$z(i), $37abfb837d2dd31d$var$Z(s, a);
        }
    };
}
function $37abfb837d2dd31d$var$di(e) {
    var t, i, s, r = e[24] >= e[1].length ? "Install " : "", a = (e[22].name || "Injected") + "";
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$st(r), i = $37abfb837d2dd31d$var$st(a), s = $37abfb837d2dd31d$var$_();
        },
        m: function(l, n) {
            $37abfb837d2dd31d$var$$(l, t, n), $37abfb837d2dd31d$var$$(l, i, n), $37abfb837d2dd31d$var$$(l, s, n);
        },
        p: function(l, n) {
            2 & n && r !== (r = l[24] >= l[1].length ? "Install " : "") && $37abfb837d2dd31d$var$je(t, r);
        },
        d: function(l) {
            l && $37abfb837d2dd31d$var$z(t), l && $37abfb837d2dd31d$var$z(i), l && $37abfb837d2dd31d$var$z(s);
        }
    };
}
function $37abfb837d2dd31d$var$ui(e) {
    var t;
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("img"), $37abfb837d2dd31d$var$b(t, "alt", (e[22].name || "Injected") + " logo"), $37abfb837d2dd31d$var$T(t, "filter", e[9]), $37abfb837d2dd31d$var$lt(t.src, "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDI0IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0cHgiIGZpbGw9IiMwMDAwMDAiPjxnPjxyZWN0IGZpbGw9Im5vbmUiIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIvPjwvZz48Zz48cGF0aCBkPSJNMTEuMDcsMTIuODVjMC43Ny0xLjM5LDIuMjUtMi4yMSwzLjExLTMuNDRjMC45MS0xLjI5LDAuNC0zLjctMi4xOC0zLjdjLTEuNjksMC0yLjUyLDEuMjgtMi44NywyLjM0TDYuNTQsNi45NiBDNy4yNSw0LjgzLDkuMTgsMywxMS45OSwzYzIuMzUsMCwzLjk2LDEuMDcsNC43OCwyLjQxYzAuNywxLjE1LDEuMTEsMy4zLDAuMDMsNC45Yy0xLjIsMS43Ny0yLjM1LDIuMzEtMi45NywzLjQ1IGMtMC4yNSwwLjQ2LTAuMzUsMC43Ni0wLjM1LDIuMjRoLTIuODlDMTAuNTgsMTUuMjIsMTAuNDYsMTMuOTUsMTEuMDcsMTIuODV6IE0xNCwyMGMwLDEuMS0wLjksMi0yLDJzLTItMC45LTItMmMwLTEuMSwwLjktMiwyLTIgUzE0LDE4LjksMTQsMjB6Ii8+PC9nPjwvc3ZnPg==") || $37abfb837d2dd31d$var$b(t, "src", "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDI0IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0cHgiIGZpbGw9IiMwMDAwMDAiPjxnPjxyZWN0IGZpbGw9Im5vbmUiIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIvPjwvZz48Zz48cGF0aCBkPSJNMTEuMDcsMTIuODVjMC43Ny0xLjM5LDIuMjUtMi4yMSwzLjExLTMuNDRjMC45MS0xLjI5LDAuNC0zLjctMi4xOC0zLjdjLTEuNjksMC0yLjUyLDEuMjgtMi44NywyLjM0TDYuNTQsNi45NiBDNy4yNSw0LjgzLDkuMTgsMywxMS45OSwzYzIuMzUsMCwzLjk2LDEuMDcsNC43OCwyLjQxYzAuNywxLjE1LDEuMTEsMy4zLDAuMDMsNC45Yy0xLjIsMS43Ny0yLjM1LDIuMzEtMi45NywzLjQ1IGMtMC4yNSwwLjQ2LTAuMzUsMC43Ni0wLjM1LDIuMjRoLTIuODlDMTAuNTgsMTUuMjIsMTAuNDYsMTMuOTUsMTEuMDcsMTIuODV6IE0xNCwyMGMwLDEuMS0wLjksMi0yLDJzLTItMC45LTItMmMwLTEuMSwwLjktMiwyLTIgUzE0LDE4LjksMTQsMjB6Ii8+PC9nPjwvc3ZnPg==");
        },
        m: function(i, s) {
            $37abfb837d2dd31d$var$$(i, t, s);
        },
        p: $37abfb837d2dd31d$var$E,
        d: function(i) {
            i && $37abfb837d2dd31d$var$z(t);
        }
    };
}
function $37abfb837d2dd31d$var$fi(e) {
    var t, i;
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("img"), $37abfb837d2dd31d$var$b(t, "width", "32px"), $37abfb837d2dd31d$var$lt(t.src, i = e[22].icon) || $37abfb837d2dd31d$var$b(t, "src", i), $37abfb837d2dd31d$var$b(t, "alt", e[22].name + " logo");
        },
        m: function(s, r) {
            $37abfb837d2dd31d$var$$(s, t, r);
        },
        p: $37abfb837d2dd31d$var$E,
        d: function(s) {
            s && $37abfb837d2dd31d$var$z(t);
        }
    };
}
function $37abfb837d2dd31d$var$pi(e) {
    var t, i, s = function(a, l) {
        return a[22].icon ? $37abfb837d2dd31d$var$fi : $37abfb837d2dd31d$var$ui;
    }(e), r = s(e);
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$S("span"), r.c(), i = $37abfb837d2dd31d$var$_(), $37abfb837d2dd31d$var$b(t, "slot", "append");
        },
        m: function(a, l) {
            $37abfb837d2dd31d$var$$(a, t, l), r.m(t, null), $37abfb837d2dd31d$var$L(t, i);
        },
        p: function(a, l) {
            r.p(a, l);
        },
        d: function(a) {
            a && $37abfb837d2dd31d$var$z(t), r.d();
        }
    };
}
function $37abfb837d2dd31d$var$Ze(e) {
    var t, i;
    return t = new $37abfb837d2dd31d$var$In({
        props: {
            style: "\n                            border: 1px solid " + e[8] + ";\n                            /* use same border-radius as dialog's */\n                            border-radius: 4px;\n                            height: 58px;\n                            background: " + e[6] + ";\n                            margin-bottom: 10px;\n                            color: " + e[7] + ";\n                        ",
            $$slots: {
                append: [
                    $37abfb837d2dd31d$var$pi
                ],
                default: [
                    $37abfb837d2dd31d$var$di
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), t.$on("click", function() {
        return e[18](e[24], e[22]);
    }), {
        c: function() {
            $37abfb837d2dd31d$var$J(t.$$.fragment);
        },
        m: function(s, r) {
            $37abfb837d2dd31d$var$G(t, s, r), i = !0;
        },
        p: function(s, r) {
            e = s;
            var a = {};
            33554434 & r && (a.$$scope = {
                dirty: r,
                ctx: e
            }), t.$set(a);
        },
        i: function(s) {
            i || ($37abfb837d2dd31d$var$j(t.$$.fragment, s), i = !0);
        },
        o: function(s) {
            $37abfb837d2dd31d$var$k(t.$$.fragment, s), i = !1;
        },
        d: function(s) {
            $37abfb837d2dd31d$var$Z(t, s);
        }
    };
}
function $37abfb837d2dd31d$var$gi(e) {
    var t, i, s = e[11], r = [];
    for(var l = 0; l < s.length; l += 1)r[l] = $37abfb837d2dd31d$var$Ze($37abfb837d2dd31d$var$Ge(e, s, l));
    var a = function(l) {
        return $37abfb837d2dd31d$var$k(r[l], 1, 1, function() {
            r[l] = null;
        });
    };
    return {
        c: function() {
            for(var l = 0; l < r.length; l += 1)r[l].c();
            t = $37abfb837d2dd31d$var$ne();
        },
        m: function(l, n) {
            for(var o = 0; o < r.length; o += 1)r[o].m(l, n);
            $37abfb837d2dd31d$var$$(l, t, n), i = !0;
        },
        p: function(l, n) {
            if (3039 & n) {
                var o;
                for(s = l[11], o = 0; o < s.length; o += 1){
                    var c = $37abfb837d2dd31d$var$Ge(l, s, o);
                    r[o] ? (r[o].p(c, n), $37abfb837d2dd31d$var$j(r[o], 1)) : (r[o] = $37abfb837d2dd31d$var$Ze(c), r[o].c(), $37abfb837d2dd31d$var$j(r[o], 1), r[o].m(t.parentNode, t));
                }
                for($37abfb837d2dd31d$var$Mt(), o = s.length; o < r.length; o += 1)a(o);
                $37abfb837d2dd31d$var$vt();
            }
        },
        i: function(l) {
            if (!i) {
                for(var n = 0; n < s.length; n += 1)$37abfb837d2dd31d$var$j(r[n]);
                i = !0;
            }
        },
        o: function(l) {
            r = r.filter(Boolean);
            for(var n = 0; n < r.length; n += 1)$37abfb837d2dd31d$var$k(r[n]);
            i = !1;
        },
        d: function(l) {
            (function(n, o) {
                for(var c = 0; c < n.length; c += 1)n[c] && n[c].d(o);
            })(r, l), l && $37abfb837d2dd31d$var$z(t);
        }
    };
}
function $37abfb837d2dd31d$var$hi(e) {
    var t;
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$st("Click the REFRESH button after installing and setting up the new wallet.");
        },
        m: function(i, s) {
            $37abfb837d2dd31d$var$$(i, t, s);
        },
        d: function(i) {
            i && $37abfb837d2dd31d$var$z(t);
        }
    };
}
function $37abfb837d2dd31d$var$mi(e) {
    var t;
    return {
        c: function() {
            t = $37abfb837d2dd31d$var$st("Refresh");
        },
        m: function(i, s) {
            $37abfb837d2dd31d$var$$(i, t, s);
        },
        d: function(i) {
            i && $37abfb837d2dd31d$var$z(t);
        }
    };
}
function $37abfb837d2dd31d$var$Mi(e) {
    var t, i;
    return t = new $37abfb837d2dd31d$var$ln({
        props: {
            style: "margin-bottom: 12px; border: 1px solid " + e[7] + "; color: " + e[7] + ";",
            outlined: !0,
            $$slots: {
                default: [
                    $37abfb837d2dd31d$var$mi
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), t.$on("click", e[17]), {
        c: function() {
            $37abfb837d2dd31d$var$J(t.$$.fragment);
        },
        m: function(s, r) {
            $37abfb837d2dd31d$var$G(t, s, r), i = !0;
        },
        p: function(s, r) {
            var a = {};
            33554432 & r && (a.$$scope = {
                dirty: r,
                ctx: s
            }), t.$set(a);
        },
        i: function(s) {
            i || ($37abfb837d2dd31d$var$j(t.$$.fragment, s), i = !0);
        },
        o: function(s) {
            $37abfb837d2dd31d$var$k(t.$$.fragment, s), i = !1;
        },
        d: function(s) {
            $37abfb837d2dd31d$var$Z(t, s);
        }
    };
}
function $37abfb837d2dd31d$var$vi(e) {
    var g = function g(p, m) {
        return p[4] ? 0 : 1;
    };
    var f = function f(p, m) {
        return p[4] ? 0 : p[11].length ? 1 : 2;
    };
    var t, i, s, r, a, l, n;
    var o = [
        $37abfb837d2dd31d$var$si,
        $37abfb837d2dd31d$var$ii
    ], c = [];
    t = g(e), i = c[t] = o[t](e);
    var u = [
        $37abfb837d2dd31d$var$ci,
        $37abfb837d2dd31d$var$li,
        $37abfb837d2dd31d$var$ai
    ], d = [];
    return r = f(e), a = d[r] = u[r](e), {
        c: function() {
            i.c(), s = $37abfb837d2dd31d$var$_(), a.c(), l = $37abfb837d2dd31d$var$ne();
        },
        m: function(p, m) {
            c[t].m(p, m), $37abfb837d2dd31d$var$$(p, s, m), d[r].m(p, m), $37abfb837d2dd31d$var$$(p, l, m), n = !0;
        },
        p: function(p, m) {
            var h = t;
            t = g(p), t === h ? c[t].p(p, m) : ($37abfb837d2dd31d$var$Mt(), $37abfb837d2dd31d$var$k(c[h], 1, 1, function() {
                c[h] = null;
            }), $37abfb837d2dd31d$var$vt(), i = c[t], i ? i.p(p, m) : (i = c[t] = o[t](p), i.c()), $37abfb837d2dd31d$var$j(i, 1), i.m(s.parentNode, s));
            var x = r;
            r = f(p), r === x ? d[r].p(p, m) : ($37abfb837d2dd31d$var$Mt(), $37abfb837d2dd31d$var$k(d[x], 1, 1, function() {
                d[x] = null;
            }), $37abfb837d2dd31d$var$vt(), a = d[r], a ? a.p(p, m) : (a = d[r] = u[r](p), a.c()), $37abfb837d2dd31d$var$j(a, 1), a.m(l.parentNode, l));
        },
        i: function(p) {
            n || ($37abfb837d2dd31d$var$j(i), $37abfb837d2dd31d$var$j(a), n = !0);
        },
        o: function(p) {
            $37abfb837d2dd31d$var$k(i), $37abfb837d2dd31d$var$k(a), n = !1;
        },
        d: function(p) {
            c[t].d(p), p && $37abfb837d2dd31d$var$z(s), d[r].d(p), p && $37abfb837d2dd31d$var$z(l);
        }
    };
}
function $37abfb837d2dd31d$var$bi(e) {
    var t, i;
    return t = new $37abfb837d2dd31d$var$Qn({
        props: {
            style: "background: " + e[5],
            $$slots: {
                default: [
                    $37abfb837d2dd31d$var$vi
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), {
        c: function() {
            $37abfb837d2dd31d$var$J(t.$$.fragment);
        },
        m: function(s, r) {
            $37abfb837d2dd31d$var$G(t, s, r), i = !0;
        },
        p: function(s, r) {
            var a = {};
            33554463 & r && (a.$$scope = {
                dirty: r,
                ctx: s
            }), t.$set(a);
        },
        i: function(s) {
            i || ($37abfb837d2dd31d$var$j(t.$$.fragment, s), i = !0);
        },
        o: function(s) {
            $37abfb837d2dd31d$var$k(t.$$.fragment, s), i = !1;
        },
        d: function(s) {
            $37abfb837d2dd31d$var$Z(t, s);
        }
    };
}
function $37abfb837d2dd31d$var$yi(e) {
    var r = function r(l) {
        e[19](l);
    };
    var t, i, s;
    var a = {
        persistent: !0,
        $$slots: {
            default: [
                $37abfb837d2dd31d$var$bi
            ]
        },
        $$scope: {
            ctx: e
        }
    };
    return e[3] !== void 0 && (a.active = e[3]), t = new $37abfb837d2dd31d$var$On({
        props: a
    }), $37abfb837d2dd31d$var$Wt.push(function() {
        return function(l, n, o) {
            var c = l.$$.props[n];
            c !== void 0 && (l.$$.bound[c] = o, o(l.$$.ctx[c]));
        }(t, "active", r);
    }), {
        c: function() {
            $37abfb837d2dd31d$var$J(t.$$.fragment);
        },
        m: function(l, n) {
            $37abfb837d2dd31d$var$G(t, l, n), s = !0;
        },
        p: function(l, param) {
            var _param = (0, $8GFUW._)(param, 1), n = _param[0];
            var o = {};
            var c;
            33554463 & n && (o.$$scope = {
                dirty: n,
                ctx: l
            }), !i && 8 & n && (i = !0, o.active = l[3], c = function() {
                return i = !1;
            }, $37abfb837d2dd31d$var$ie.push(c)), t.$set(o);
        },
        i: function(l) {
            s || ($37abfb837d2dd31d$var$j(t.$$.fragment, l), s = !0);
        },
        o: function(l) {
            $37abfb837d2dd31d$var$k(t.$$.fragment, l), s = !1;
        },
        d: function(l) {
            $37abfb837d2dd31d$var$Z(t, l);
        }
    };
}
var $37abfb837d2dd31d$var$wi = "Connect a wallet", $37abfb837d2dd31d$var$Ve = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTE5IDYuNDFMMTcuNTkgNSAxMiAxMC41OSA2LjQxIDUgNSA2LjQxIDEwLjU5IDEyIDUgMTcuNTkgNi40MSAxOSAxMiAxMy40MSAxNy41OSAxOSAxOSAxNy41OSAxMy40MSAxMiAxOSA2LjQxeiIvPjwvc3ZnPg==";
function $37abfb837d2dd31d$var$xi(e, t, i) {
    var s;
    var tmp = t.callback, r = tmp === void 0 ? function() {} : tmp, tmp1 = t.installed, a = tmp1 === void 0 ? [] : tmp1, tmp2 = t.discovery, l = tmp2 === void 0 ? [] : tmp2, tmp3 = t.options, n = tmp3 === void 0 ? {} : tmp3;
    var o = (n === null || n === void 0 ? void 0 : n.theme) || "light", c = o === "light" ? "#fff" : "#333", g = o === "light" ? "#e9e9e9" : "#555", u = o === "light" ? "#000" : "#f7f7f7", d = o === "light" ? "#99999950" : "#aaaaaa30", f = o === "light" ? "unset" : "invert(1)", p = (s = $37abfb837d2dd31d$var$ni.getParser(window.navigator.userAgent).getBrowser().name) === null || s === void 0 ? void 0 : s.toLowerCase();
    var m;
    switch(p){
        case "chrome":
        case "chromium":
        case "electron":
            m = "chrome";
            break;
        case "firefox":
            m = "firefox";
            break;
        case "microsoft edge":
            m = "edge";
    }
    var h = m ? (0, $fLnyw._)(a).concat((0, $fLnyw._)(l.filter(function(M) {
        return !!M.downloads[m] || m === "edge" && !!M.downloads.chrome;
    }))) : a;
    var x, N = !0;
    return e.$$set = function(M) {
        "callback" in M && i(0, r = M.callback), "installed" in M && i(1, a = M.installed), "discovery" in M && i(12, l = M.discovery), "options" in M && i(13, n = M.options);
    }, [
        r,
        a,
        m,
        N,
        x,
        c,
        g,
        u,
        d,
        f,
        p,
        h,
        l,
        n,
        function() {
            return i(4, x = void 0);
        },
        function() {
            r(x), i(3, N = !1);
        },
        function() {
            r(void 0), i(3, N = !1);
        },
        function() {
            r(x), i(3, N = !1), window.location.reload();
        },
        function(M, w) {
            if (M < a.length) r(w), i(3, N = !1);
            else {
                var A = w.downloads[m] || m === "edge" && w.downloads.chrome;
                if (!A) return;
                window.open(A, "_blank"), i(4, x = h[M]);
            }
        },
        function(M) {
            N = M, i(3, N);
        }
    ];
}
var $37abfb837d2dd31d$var$Ii = /*#__PURE__*/ function(q) {
    (0, $ftJVG._)(Ii, q);
    var _super = (0, $6OZAO._)(Ii);
    function Ii(t) {
        (0, $978gY._)(this, Ii);
        var _this;
        _this = _super.call(this), $37abfb837d2dd31d$var$X((0, $3vWwE._)(_this), t, $37abfb837d2dd31d$var$xi, $37abfb837d2dd31d$var$yi, $37abfb837d2dd31d$var$H, {
            callback: 0,
            installed: 1,
            discovery: 12,
            options: 13
        });
        return (0, $ho5gk._)(_this);
    }
    return Ii;
}($37abfb837d2dd31d$var$q);
var $37abfb837d2dd31d$var$dt, $37abfb837d2dd31d$var$V, $37abfb837d2dd31d$var$bt, $37abfb837d2dd31d$var$yt, $37abfb837d2dd31d$var$Ct, $37abfb837d2dd31d$var$ce, $37abfb837d2dd31d$var$wt;
$37abfb837d2dd31d$var$V = new WeakMap, $37abfb837d2dd31d$var$yt = new WeakMap, $37abfb837d2dd31d$var$Ct = new WeakMap, $37abfb837d2dd31d$var$ce = new WeakMap, $37abfb837d2dd31d$var$wt = new WeakMap, $37abfb837d2dd31d$var$dt = new WeakSet, $37abfb837d2dd31d$var$bt = function bt() {
    return !!$37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$V, "f").current;
};
var $37abfb837d2dd31d$var$Zt = new function _class() {
    var _this = this;
    (0, $978gY._)(this, _class);
    $37abfb837d2dd31d$var$dt.add(this), $37abfb837d2dd31d$var$V.set(this, {}), this.connect = function(e) {
        return $37abfb837d2dd31d$var$Nt(_this, void 0, void 0, function() {
            var t, _ref, i, s, r, a, n, _i, _iter, n1, l, e1;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$wt, "f").call(this);
                        t = $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$dt, "m", $37abfb837d2dd31d$var$bt).call(this);
                        return [
                            4,
                            $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$Ct, "f").call(this, e)
                        ];
                    case 1:
                        _ref = _state.sent(), i = _ref.installed, s = _ref.preAuthorized, r = _ref.defaultWallet, a = _ref.lastWallet;
                        if ((e === null || e === void 0 ? void 0 : e.showList) === !1) {
                            n = s[0];
                            return [
                                2,
                                n ? $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$yt, "f").call(this, n) : void 0
                            ];
                        }
                        if (!(t || (e === null || e === void 0 ? void 0 : e.showList) || !a)) {
                            for(_i = 0, _iter = [
                                r,
                                a
                            ]; _i < _iter.length; _i++){
                                n1 = _iter[_i];
                                if (n1) return [
                                    2,
                                    $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$yt, "f").call(this, n1)
                                ];
                            }
                            if (i.length === 1) return [
                                2,
                                $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$yt, "f").call(this, i[0])
                            ];
                        }
                        return [
                            4,
                            function(n, o) {
                                return $37abfb837d2dd31d$var$Nt(this, void 0, void 0, function() {
                                    var c, g;
                                    return (0, $7UAGh.__generator)(this, function(_state) {
                                        c = new Set(n.map(function(u) {
                                            return u.id;
                                        }));
                                        g = $37abfb837d2dd31d$var$pe.filter(function(u) {
                                            return !c.has(u.id);
                                        });
                                        return [
                                            2,
                                            (g = $37abfb837d2dd31d$var$he(g, o), g = $37abfb837d2dd31d$var$ge(g, o === null || o === void 0 ? void 0 : o.order), new Promise(function(u) {
                                                var d = new $37abfb837d2dd31d$var$Ii({
                                                    target: document.body,
                                                    props: {
                                                        callback: function(f) {
                                                            d.$destroy(), u(f);
                                                        },
                                                        installed: n,
                                                        discovery: g,
                                                        options: o === null || o === void 0 ? void 0 : o.modalOptions
                                                    }
                                                });
                                            }))
                                        ];
                                    });
                                });
                            }(i, e)
                        ];
                    case 2:
                        l = _state.sent();
                        return [
                            2,
                            $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$yt, "f").call(this, l)
                        ];
                    case 3:
                        e1 = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, this.disconnect = function(e) {
        $37abfb837d2dd31d$var$I(_this, $37abfb837d2dd31d$var$wt, "f").call(_this);
        var t = $37abfb837d2dd31d$var$I(_this, $37abfb837d2dd31d$var$dt, "m", $37abfb837d2dd31d$var$bt).call(_this);
        return $37abfb837d2dd31d$var$I(_this, $37abfb837d2dd31d$var$V, "f").current = void 0, (e === null || e === void 0 ? void 0 : e.clearLastWallet) && $37abfb837d2dd31d$var$_t.delete(), (e === null || e === void 0 ? void 0 : e.clearDefaultWallet) && $37abfb837d2dd31d$var$Xt.delete(), t;
    }, this.getStarknet = function() {
        var e, t, i, s, r;
        $37abfb837d2dd31d$var$I(_this, $37abfb837d2dd31d$var$wt, "f").call(_this);
        var a = _this;
        return (e = $37abfb837d2dd31d$var$I(_this, $37abfb837d2dd31d$var$V, "f").current) !== null && e !== void 0 ? e : new (r = function r() {
            var _this = this;
            (0, $978gY._)(this, r);
            this.id = "disconnected", this.name = "Disconnected", this.icon = "", this.selectedAddress = void 0, this.provider = $37abfb837d2dd31d$var$Ht.defaultProvider, this.isConnected = !1, this.account = new $37abfb837d2dd31d$var$Ht.Account($37abfb837d2dd31d$var$Ht.defaultProvider, "", {}), this.version = "", this.signer = void 0, t.set(this, {}), this.enable = function(l) {
                return $37abfb837d2dd31d$var$Nt(_this, void 0, void 0, function() {
                    var n, o, e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    $37abfb837d2dd31d$var$I(this, i, "f").call(this, {
                                        showList: l === null || l === void 0 ? void 0 : l.showModal
                                    })
                                ];
                            case 1:
                                n = _state.sent();
                                if (!n) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    n.enable()
                                ];
                            case 2:
                                o = _state.sent();
                                return [
                                    2,
                                    ($37abfb837d2dd31d$var$I(this, s, "f").call(this, n), o)
                                ];
                            case 3:
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    []
                                ];
                        }
                    });
                });
            }, this.isPreauthorized = function() {
                return $37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$dt, "m", $37abfb837d2dd31d$var$bt).call(a) ? $37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$V, "f").current.isPreauthorized() : $37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$Ct, "f").call(a).then(function(l) {
                    return !!l.preAuthorized.length;
                });
            }, this.off = function(l, n) {
                var o;
                $37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$dt, "m", $37abfb837d2dd31d$var$bt).call(a) ? (o = $37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$V, "f").current) === null || o === void 0 || o.off(l, n) : $37abfb837d2dd31d$var$I(_this, t, "f")[l] && ($37abfb837d2dd31d$var$I(_this, t, "f")[l] = $37abfb837d2dd31d$var$I(_this, t, "f")[l].filter(function(c) {
                    return c !== n;
                }));
            }, this.on = function(l, n) {
                var o, c;
                if ($37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$dt, "m", $37abfb837d2dd31d$var$bt).call(a)) (o = $37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$V, "f").current) === null || o === void 0 || o.on(l, n);
                else {
                    var g = (c = $37abfb837d2dd31d$var$I(_this, t, "f")[l]) !== null && c !== void 0 ? c : $37abfb837d2dd31d$var$I(_this, t, "f")[l] = [];
                    g.includes(n) || g.push(n);
                }
            }, this.request = function(l) {
                return $37abfb837d2dd31d$var$Nt(_this, void 0, void 0, function() {
                    var n;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        n = $37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$V, "f").current;
                        if (!n) throw new Error("can't request a disconnected wallet");
                        return [
                            2,
                            n.request(l)
                        ];
                    });
                });
            }, i.set(this, function(l) {
                return ($37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$V, "f").current ? Promise.resolve($37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$V, "f").current) : a.connect(l)).then(function(n) {
                    return n && (_this.id = n.id, _this.name = n.name, _this.icon = n.icon, _this.version = n.version, $37abfb837d2dd31d$var$I(_this, s, "f").call(_this, n), Object.entries($37abfb837d2dd31d$var$I(_this, t, "f")).forEach(function(param) {
                        var _param = (0, $8GFUW._)(param, 2), o = _param[0], c = _param[1];
                        return c.forEach(function(g) {
                            return n.on(o, g);
                        });
                    }), $37abfb837d2dd31d$var$At(_this, t, {}, "f")), n;
                });
            }), s.set(this, function(l) {
                l && (_this.selectedAddress = l.selectedAddress, _this.provider = l.provider, _this.isConnected = l.isConnected, _this.account = l.account, _this.signer = l.signer);
            });
        }, t = new WeakMap, i = new WeakMap, s = new WeakMap, r);
    }, this.getInstalledWallets = function(e) {
        return $37abfb837d2dd31d$var$I(_this, $37abfb837d2dd31d$var$Ct, "f").call(_this, e).then(function(t) {
            return t.installed;
        });
    }, $37abfb837d2dd31d$var$yt.set(this, function(e) {
        return $37abfb837d2dd31d$var$I(_this, $37abfb837d2dd31d$var$V, "f").current = e, e && $37abfb837d2dd31d$var$_t.set(e.id), e;
    }), $37abfb837d2dd31d$var$Ct.set(this, function(e) {
        return $37abfb837d2dd31d$var$Nt(_this, void 0, void 0, function() {
            var t, i, s, r, a, l, n;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$ce, "f").call(this)
                        ];
                    case 1:
                        _state.sent();
                        t = Object.values(Object.getOwnPropertyNames(window).reduce(function(n, o) {
                            if (o.startsWith("starknet")) {
                                var c = window[o];
                                (function(g, u) {
                                    try {
                                        if (u && [
                                            "request",
                                            "isConnected",
                                            "provider",
                                            "enable",
                                            "isPreauthorized",
                                            "on",
                                            "off",
                                            "version"
                                        ].every(function(d) {
                                            return d in u;
                                        })) {
                                            if (!(g !== "starknet" || u.id && u.name && u.icon)) try {
                                                var d = $37abfb837d2dd31d$var$pe.find(function(f) {
                                                    return f.id === "argentX";
                                                });
                                                d && (u.id = d.id, u.name = d.name, u.icon = d.icon);
                                            } catch (e) {}
                                            return [
                                                "id",
                                                "name",
                                                "icon"
                                            ].every(function(d) {
                                                return d in u;
                                            });
                                        }
                                    } catch (e) {}
                                    return !1;
                                })(o, c) && !n[c.id] && (n[c.id] = c);
                            }
                            return n;
                        }, {})), i = t.find(function(n) {
                            return n.id === $37abfb837d2dd31d$var$Xt.get();
                        });
                        i || $37abfb837d2dd31d$var$Xt.delete();
                        s = t.find(function(n) {
                            return n.id === $37abfb837d2dd31d$var$_t.get();
                        });
                        s || $37abfb837d2dd31d$var$_t.delete();
                        return [
                            4,
                            function(n) {
                                return Promise.all(n.map(function(o) {
                                    return o.isPreauthorized().then(function(c) {
                                        return c ? o : void 0;
                                    }).catch(function() {});
                                })).then(function(o) {
                                    return o.filter(function(c) {
                                        return !!c;
                                    });
                                });
                            }(t)
                        ];
                    case 2:
                        r = $37abfb837d2dd31d$var$Jt.apply(void 0, [
                            _state.sent()
                        ]), a = function(n) {
                            return [
                                s,
                                i
                            ].forEach(function(o) {
                                if (o) {
                                    var c = n.filter(function(g) {
                                        return g.id !== o.id;
                                    });
                                    c.length !== n.length && (n = [
                                        o
                                    ].concat((0, $fLnyw._)(c)));
                                }
                            }), n;
                        }, l = {
                            installed: a(t),
                            preAuthorized: a(r),
                            defaultWallet: i,
                            lastWallet: s
                        };
                        if (l.installed = $37abfb837d2dd31d$var$he(l.installed, e), l.installed = $37abfb837d2dd31d$var$ge(l.installed, e === null || e === void 0 ? void 0 : e.order), !(e && Array.isArray(e.order))) {
                            n = new Set(r.map(function(o) {
                                return o.id;
                            }));
                            l.installed = l.installed.filter(function(o) {
                                return !n.has(o.id);
                            }), l.installed = (0, $fLnyw._)(r).concat((0, $fLnyw._)(l.installed)), l.installed = a(l.installed);
                        }
                        return [
                            2,
                            l
                        ];
                }
            });
        });
    }), $37abfb837d2dd31d$var$ce.set(this, function() {
        var e = function() {
            return document.readyState === "complete";
        };
        return new Promise(function(t) {
            if (e()) t();
            else {
                var i = setInterval(function() {
                    e() && (clearInterval(i), t());
                }, 50);
            }
        });
    }), $37abfb837d2dd31d$var$wt.set(this, function() {
        (typeof window === "undefined" ? "undefined" : (0, $1ObTH._)(window)) < "u" && (window.gsw = !0);
    }), $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$wt, "f").call(this);
}, $37abfb837d2dd31d$var$Ni = $37abfb837d2dd31d$var$Zt.getStarknet, $37abfb837d2dd31d$var$Ai = $37abfb837d2dd31d$var$Zt.connect, $37abfb837d2dd31d$var$ji = $37abfb837d2dd31d$var$Zt.disconnect, $37abfb837d2dd31d$var$Di = $37abfb837d2dd31d$var$Zt.getInstalledWallets;
$37abfb837d2dd31d$var$fe = $37abfb837d2dd31d$var$It.connect = $37abfb837d2dd31d$var$Ai, $37abfb837d2dd31d$export$37dfea93db2e14ed = $37abfb837d2dd31d$var$It.disconnect = $37abfb837d2dd31d$var$ji, $37abfb837d2dd31d$var$It.getInstalledWallets = $37abfb837d2dd31d$var$Di, $37abfb837d2dd31d$var$ue = $37abfb837d2dd31d$var$It.getStarknet = $37abfb837d2dd31d$var$Ni;
var $37abfb837d2dd31d$var$zi = function() {
    var e = $37abfb837d2dd31d$var$ue();
    return e.enable = function() {
        var _ref = (0, $byzP8._)(function(t) {
            var _ref;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $37abfb837d2dd31d$var$He({
                                showList: t === null || t === void 0 ? void 0 : t.showModal
                            })
                        ];
                    case 1:
                        return [
                            2,
                            ((_ref = _state.sent()) === null || _ref === void 0 ? void 0 : _ref.enable(t)) || []
                        ];
                }
            });
        });
        return function(t) {
            return _ref.apply(this, arguments);
        };
    }(), e;
}, $37abfb837d2dd31d$var$He = function(e) {
    return $37abfb837d2dd31d$var$fe((0, $8OnJk._)({
        order: [
            "argentX"
        ]
    }, e));
};
$37abfb837d2dd31d$export$64605811ab45167f = $37abfb837d2dd31d$var$He, $37abfb837d2dd31d$export$b5c0cdb6e6d5b23c = $37abfb837d2dd31d$var$zi;


var $855eec528252b37a$export$5359a20ca62641f = function() {
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)((0, $429f470a166ef670$export$19d7d19559261303)), 2), prices = _useState[0], setPrices = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)(undefined), 2), starknet = _useState1[0], setStarknet = _useState1[1];
    var _useState2 = (0, $8GFUW._)((0, $6cds3.useState)(""), 2), walletAddress = _useState2[0], setWalletAddress = _useState2[1];
    var _useState3 = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), _ = _useState3[0], setIsConnecting = _useState3[1];
    var connectWallet = function() {
        var _ref = (0, $byzP8._)(function() {
            var newStarknet, _ref, address, error;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setPrices((0, $429f470a166ef670$export$19d7d19559261303));
                        if (starknet) return [
                            2
                        ];
                        setIsConnecting(true);
                        setStarknet(undefined);
                        return [
                            4,
                            (0, $37abfb837d2dd31d$export$64605811ab45167f)()
                        ];
                    case 1:
                        newStarknet = _state.sent();
                        if (!newStarknet) return [
                            2,
                            setIsConnecting(false)
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            newStarknet.enable()
                        ];
                    case 3:
                        _ref = (0, $8GFUW._).apply(void 0, [
                            _state.sent(),
                            1
                        ]), address = _ref[0];
                        if (!newStarknet.isConnected) return [
                            2,
                            setIsConnecting(false)
                        ];
                        setWalletAddress(address);
                        setIsConnecting(false);
                        addListeners(newStarknet);
                        return [
                            2,
                            setStarknet(newStarknet)
                        ];
                    case 4:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setIsConnecting(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function connectWallet() {
            return _ref.apply(this, arguments);
        };
    }();
    var addListeners = function(starknet) {
        starknet.on("accountsChanged", function() {
            window.location.reload();
        });
        starknet.on("networkChanged", function() {
            window.location.reload();
        });
    };
    return {
        prices: prices,
        setPrices: setPrices,
        starknet: starknet,
        connectWallet: connectWallet,
        walletAddress: walletAddress
    };
};



var $byzP8 = parcelRequire("byzP8");

var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");

var $6cds3 = parcelRequire("6cds3");

parcelRequire("kmZ00");
var $aMiMS = parcelRequire("aMiMS");
var $7XMRS = parcelRequire("7XMRS");
var $b14ef06c18b39435$export$df32fb2fcf7bb0ad = function() {
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)((0, $429f470a166ef670$export$19d7d19559261303)), 2), prices = _useState[0], setPrices = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)(), 2), fuel = _useState1[0], setFuel = _useState1[1];
    var _useState2 = (0, $8GFUW._)((0, $6cds3.useState)(undefined), 2), wallet = _useState2[0], setWallet = _useState2[1];
    var _useState3 = (0, $8GFUW._)((0, $6cds3.useState)(""), 2), walletAddress = _useState3[0], setWalletAddress = _useState3[1];
    var _useState4 = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), _ = _useState4[0], setIsConnecting = _useState4[1];
    (0, $6cds3.useEffect)(function() {
        var onFuelLoaded = function() {
            setFuel(window.fuel);
        };
        if (window.fuel) onFuelLoaded();
        document.addEventListener("FuelLoaded", onFuelLoaded);
        return function() {
            document.removeEventListener("FuelLoaded", onFuelLoaded);
        };
    }, []);
    var changePrivateKey = function() {
        var _ref = (0, $byzP8._)(function(e) {
            var provider, newWallet, e1;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        provider = new (0, $aMiMS.Provider)("https://beta-3.fuel.network/graphql");
                        newWallet = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, $7XMRS.Wallet).fromPrivateKey(e.target.value, provider)
                        ];
                    case 2:
                        newWallet = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e1 = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        if (newWallet && newWallet.address) setWalletAddress(newWallet.address.toString());
                        setWallet(newWallet);
                        return [
                            2
                        ];
                }
            });
        });
        return function changePrivateKey(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var connectWallet = function() {
        var _ref = (0, $byzP8._)(function() {
            var isConnected, newWallet, account, error;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setPrices((0, $429f470a166ef670$export$19d7d19559261303));
                        if (wallet) return [
                            2
                        ];
                        setIsConnecting(true);
                        setWallet(undefined);
                        if (!fuel) return [
                            2
                        ];
                        return [
                            4,
                            fuel.connect()
                        ];
                    case 1:
                        isConnected = _state.sent();
                        if (!isConnected) return [
                            2,
                            setIsConnecting(false)
                        ];
                        newWallet = undefined;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            5,
                            ,
                            8
                        ]);
                        return [
                            4,
                            fuel.currentAccount()
                        ];
                    case 3:
                        account = _state.sent();
                        return [
                            4,
                            fuel.getWallet(account)
                        ];
                    case 4:
                        newWallet = _state.sent();
                        return [
                            3,
                            8
                        ];
                    case 5:
                        error = _state.sent();
                        console.log(error); // Mostly in case when the only one of the accounts is connected.
                        return [
                            4,
                            fuel.disconnect()
                        ];
                    case 6:
                        _state.sent();
                        return [
                            4,
                            connectWallet()
                        ];
                    case 7:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 8:
                        if (!newWallet) return [
                            2,
                            setIsConnecting(false)
                        ];
                        try {
                            setWalletAddress(newWallet.address.toString());
                            setIsConnecting(false);
                            return [
                                2,
                                setWallet(newWallet)
                            ];
                        } catch (error) {} finally{
                            setIsConnecting(false);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function connectWallet() {
            return _ref.apply(this, arguments);
        };
    }();
    (0, $6cds3.useEffect)(function() {
        var reload = function reload() {
            window.location.reload();
        };
        fuel === null || fuel === void 0 ? void 0 : fuel.on(fuel.events.accounts, reload);
        fuel === null || fuel === void 0 ? void 0 : fuel.on(fuel.events.currentAccount, function(account) {
            if (account == (wallet === null || wallet === void 0 ? void 0 : wallet.address.toString())) return;
            reload();
        });
        fuel === null || fuel === void 0 ? void 0 : fuel.on(fuel.events.network, reload);
    }, [
        fuel,
        wallet,
        walletAddress
    ]);
    return {
        prices: prices,
        setPrices: setPrices,
        wallet: wallet,
        connectWallet: connectWallet,
        walletAddress: walletAddress,
        changePrivateKey: changePrivateKey
    };
};



var $byzP8 = parcelRequire("byzP8");

var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");

var $lusx3 = parcelRequire("lusx3");

var $6cds3 = parcelRequire("6cds3");

var $21d44163128ce59b$export$5d23921e368fe5ce = function() {
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)((0, $429f470a166ef670$export$19d7d19559261303)), 2), prices = _useState[0], setPrices = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)(undefined), 2), walletKey = _useState1[0], setWalletKey = _useState1[1];
    var _useState2 = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), _ = _useState2[0], setIsConnecting = _useState2[1];
    var connectWallet = function() {
        var _ref = (0, $byzP8._)(function() {
            var key;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setPrices((0, $429f470a166ef670$export$19d7d19559261303));
                        if (walletKey) return [
                            2
                        ];
                        setIsConnecting(true);
                        return [
                            4,
                            (0, $lusx3.mnemonicToWalletKey)("play like swing peace eye interest bridge garden group tomorrow stamp visit vibrant sign mad burst happy napkin proof object panda bean island evolve".split(" "))
                        ];
                    case 1:
                        key = _state.sent();
                        setWalletKey(key);
                        setIsConnecting(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function connectWallet() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        prices: prices,
        setPrices: setPrices,
        walletKey: walletKey,
        connectWallet: connectWallet
    };
};









var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $7UAGh = parcelRequire("7UAGh");

var $lHP19 = parcelRequire("lHP19");

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $7UAGh = parcelRequire("7UAGh");
var $207f10d2a89dedd1$exports = {};
"use strict";
var $207f10d2a89dedd1$var$__createBinding = $207f10d2a89dedd1$exports && $207f10d2a89dedd1$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $207f10d2a89dedd1$var$__exportStar = $207f10d2a89dedd1$exports && $207f10d2a89dedd1$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $207f10d2a89dedd1$var$__createBinding(exports1, m, p);
};
Object.defineProperty($207f10d2a89dedd1$exports, "__esModule", {
    value: true
});

$207f10d2a89dedd1$var$__exportStar((parcelRequire("fIBDJ")), $207f10d2a89dedd1$exports);


var $d1c26202b1637768$export$733bdbce7393a3c2 = /*#__PURE__*/ function() {
    "use strict";
    function EvmPricesContractAdapter(contract) {
        (0, $978gY._)(this, EvmPricesContractAdapter);
        (0, $dxWQo._)(this, "contract", void 0);
        this.contract = contract;
    }
    (0, $kry2a._)(EvmPricesContractAdapter, [
        {
            key: "getPricesFromPayload",
            value: function getPricesFromPayload(paramsProvider) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $207f10d2a89dedd1$exports.WrapperBuilder).wrap(_this.contract).usingDataService(paramsProvider.requestParams, paramsProvider.urls).getPrices()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "readPricesFromContract",
            value: function readPricesFromContract(paramsProvider) {
                throw "Method not supported";
            }
        },
        {
            key: "readTimestampFromContract",
            value: function readTimestampFromContract() {
                throw "Method not supported";
            }
        },
        {
            key: "writePricesFromPayloadToContract",
            value: function writePricesFromPayloadToContract(paramsProvider) {
                throw "Method not supported";
            }
        }
    ]);
    return EvmPricesContractAdapter;
}();


var $992631f770fd1e09$exports = {};
$992631f770fd1e09$exports = JSON.parse('{"abi":[{"inputs":[],"name":"CalldataMustHaveValidPayload","type":"error"},{"inputs":[],"name":"CalldataOverOrUnderFlow","type":"error"},{"inputs":[],"name":"CanNotPickMedianOfEmptyArray","type":"error"},{"inputs":[],"name":"EachSignerMustProvideTheSameValue","type":"error"},{"inputs":[],"name":"EmptyCalldataPointersArr","type":"error"},{"inputs":[],"name":"IncorrectUnsignedMetadataSize","type":"error"},{"inputs":[{"internalType":"uint256","name":"receviedSignersCount","type":"uint256"},{"internalType":"uint256","name":"requiredSignersCount","type":"uint256"}],"name":"InsufficientNumberOfUniqueSigners","type":"error"},{"inputs":[],"name":"InvalidCalldataPointer","type":"error"},{"inputs":[{"internalType":"address","name":"receivedSigner","type":"address"}],"name":"SignerNotAuthorised","type":"error"},{"inputs":[{"internalType":"uint256","name":"receivedTimestampSeconds","type":"uint256"},{"internalType":"uint256","name":"blockTimestamp","type":"uint256"}],"name":"TimestampFromTooLongFuture","type":"error"},{"inputs":[{"internalType":"uint256","name":"receivedTimestampSeconds","type":"uint256"},{"internalType":"uint256","name":"blockTimestamp","type":"uint256"}],"name":"TimestampIsTooOld","type":"error"},{"inputs":[{"internalType":"uint256[]","name":"values","type":"uint256[]"}],"name":"aggregateValues","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"signerAddress","type":"address"}],"name":"getAuthorisedSignerIndex","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getPrices","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getUniqueSignersThreshold","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"receivedTimestampMilliseconds","type":"uint256"}],"name":"validateTimestamp","outputs":[],"stateMutability":"view","type":"function"}]}');


var $3b1d864c6009b95d$export$40adee5c66c8f092 = /*#__PURE__*/ function() {
    "use strict";
    function EvmPricesContractConnector(contractAddress, signer) {
        (0, $978gY._)(this, EvmPricesContractConnector);
        (0, $dxWQo._)(this, "contractAddress", void 0);
        (0, $dxWQo._)(this, "signer", void 0);
        this.contractAddress = contractAddress;
        this.signer = signer;
    }
    (0, $kry2a._)(EvmPricesContractConnector, [
        {
            key: "getBlockNumber",
            value: function getBlockNumber(rpcUrl) {
                return this.signer.provider.getBlockNumber();
            }
        },
        {
            key: "getAdapter",
            value: function getAdapter() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            new (0, $d1c26202b1637768$export$733bdbce7393a3c2)(new (0, $lHP19.Contract)(_this.contractAddress, (0, $992631f770fd1e09$exports.abi), _this.signer))
                        ];
                    });
                })();
            }
        }
    ]);
    return EvmPricesContractConnector;
}();




var $bd9f40d2e954ba14$export$79fa1f4c2d188e01 = function(param) {
    var props = param.props, network = param.network;
    var signer = props.signer, walletAddress = props.walletAddress, isChangingNetwork = props.isChangingNetwork, isConnecting = props.isConnecting, prices = props.prices, setPrices = props.setPrices;
    var _useMockLoader = (0, $ae7f937efe139789$export$3ca8f5b83ba7703a)(), text = _useMockLoader.text, isMockLoading = _useMockLoader.isMockLoading, setIsMockLoading = _useMockLoader.setIsMockLoading, startMockLoader = _useMockLoader.startMockLoader;
    var connector = new (0, $3b1d864c6009b95d$export$40adee5c66c8f092)(network === null || network === void 0 ? void 0 : network.exampleContractAddress, signer);
    var _usePricesContract = (0, $753cc36948ba3c23$export$37ebad50d75f51b)(network, connector, startMockLoader, setPrices, setIsMockLoading), blockNumber = _usePricesContract.blockNumber, timestamp = _usePricesContract.timestamp, isLoading = _usePricesContract.isLoading, getPricesFromPayload = _usePricesContract.getPricesFromPayload, errorMessage = _usePricesContract.errorMessage, setErrorMessage = _usePricesContract.setErrorMessage;
    var arePrices = Object.values(prices).every(function(price) {
        return !!price;
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex w-full justify-center items-center mt-8 flex-col",
        children: [
            isConnecting && ((network === null || network === void 0 ? void 0 : network.type) || "eth") === "eth" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: "mt-0 mb-10 text-lg font-bold",
                children: "Please sign in to MetaMask"
            }),
            isChangingNetwork && signer && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: "mt-0 mb-10 text-lg font-bold",
                children: "Please change network in MetaMask"
            }),
            !isChangingNetwork && network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d0adf8410d59fd78$export$f34f01f5ad9bfa8), {
                walletAddress: walletAddress,
                network: network
            }),
            isMockLoading || isLoading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $400629623ad58cec$export$f39eb86f0e5c1a78), {
                text: isMockLoading ? text : ""
            }) : arePrices ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $29fbb8d85bb99ed5$export$d877cf1ea46d4d85), {
                blockNumber: blockNumber,
                timestamp: timestamp,
                prices: prices
            }) : !isChangingNetwork && network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1a9f66f6ca0bed1$export$d38cca4e3d3fe8c0), {
                getPriceFromContract: getPricesFromPayload
            }),
            !!errorMessage && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b76a4ff75d0d9de2$export$2e2bcd8739ae039), {
                closeModal: function() {
                    return setErrorMessage("");
                },
                title: "Problem with contract interaction",
                text: errorMessage
            })
        ]
    });
};













var $78ff95bc91a822b6$exports = {};
"use strict";
var $78ff95bc91a822b6$var$__createBinding = $78ff95bc91a822b6$exports && $78ff95bc91a822b6$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $78ff95bc91a822b6$var$__exportStar = $78ff95bc91a822b6$exports && $78ff95bc91a822b6$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $78ff95bc91a822b6$var$__createBinding(exports1, m, p);
};
Object.defineProperty($78ff95bc91a822b6$exports, "__esModule", {
    value: true
});

$78ff95bc91a822b6$var$__exportStar((parcelRequire("cPXxj")), $78ff95bc91a822b6$exports);

$78ff95bc91a822b6$var$__exportStar((parcelRequire("hjAGN")), $78ff95bc91a822b6$exports);

$78ff95bc91a822b6$var$__exportStar((parcelRequire("2TLZk")), $78ff95bc91a822b6$exports);

$78ff95bc91a822b6$var$__exportStar((parcelRequire("ldLos")), $78ff95bc91a822b6$exports);

$78ff95bc91a822b6$var$__exportStar((parcelRequire("2WH9F")), $78ff95bc91a822b6$exports);

$78ff95bc91a822b6$var$__exportStar((parcelRequire("jZ8k0")), $78ff95bc91a822b6$exports);


var $a7ed98d96e18cc00$export$7719fe4539765461 = function(param) {
    var props = param.props, network = param.network;
    var prices = props.prices, setPrices = props.setPrices, walletAddress = props.walletAddress, wallet = props.wallet, changePrivateKey = props.changePrivateKey;
    var _useMockLoader = (0, $ae7f937efe139789$export$3ca8f5b83ba7703a)(), text = _useMockLoader.text, isMockLoading = _useMockLoader.isMockLoading, setIsMockLoading = _useMockLoader.setIsMockLoading, startMockLoader = _useMockLoader.startMockLoader;
    var connector = new (0, $78ff95bc91a822b6$exports.FuelPricesContractConnector)(wallet, network === null || network === void 0 ? void 0 : network.exampleContractAddress);
    var _usePricesContract = (0, $753cc36948ba3c23$export$37ebad50d75f51b)(network, connector, startMockLoader, setPrices, setIsMockLoading), blockNumber = _usePricesContract.blockNumber, txHash = _usePricesContract.txHash, timestamp = _usePricesContract.timestamp, isLoading = _usePricesContract.isLoading, getPricesFromPayload = _usePricesContract.getPricesFromPayload, readPricesFromContract = _usePricesContract.readPricesFromContract, writePricesToContract = _usePricesContract.writePricesToContract, errorMessage = _usePricesContract.errorMessage, setErrorMessage = _usePricesContract.setErrorMessage;
    var arePrices = Object.values(prices).every(function(price) {
        return !!price;
    });
    return !wallet ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
        className: "mt-10 mb-0 text-lg text-center",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                children: "Please sign in to Fuel"
            }),
            !window.fuel && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "px-6 py-3 text-sm w-full text-center text-gray-500 mt-8 border",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "w-full mb-2",
                        children: [
                            "The Fuel Wallet extension you can install from here:",
                            " ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                    target: "_blank",
                                    href: "https://wallet.fuel.network/docs/install/",
                                    children: "https://wallet.fuel.network/docs/install/"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "w-full mt-2",
                        children: [
                            "or pass your fuel-wallet's ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                children: "PRIVATE KEY"
                            }),
                            " below: ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                className: "text-sm w-full align-center gap-2 border mt-1 py-2 px-2 rounded",
                                type: "password",
                                name: "private_key",
                                id: "private_key",
                                onChange: changePrivateKey
                            })
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex w-full justify-center items-center mt-8 flex-col",
        children: [
            network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d0adf8410d59fd78$export$f34f01f5ad9bfa8), {
                walletAddress: walletAddress,
                network: network
            }),
            isMockLoading || isLoading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $400629623ad58cec$export$f39eb86f0e5c1a78), {
                text: isMockLoading ? text : ""
            }) : [
                arePrices && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $29fbb8d85bb99ed5$export$d877cf1ea46d4d85), {
                    blockNumber: blockNumber,
                    timestamp: timestamp,
                    prices: prices
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "flex gap-3",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1f09082810955268$export$a6bbb1b7f40755b9), {
                            writePricesToContract: writePricesToContract
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $291736910945f543$export$30ee6dea872700fe), {
                            readPricesFromContract: readPricesFromContract
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1a9f66f6ca0bed1$export$d38cca4e3d3fe8c0), {
                            getPriceFromContract: getPricesFromPayload
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: "px-6 py-3 text-sm w-3/5 text-center text-gray-500",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("i", {
                        children: [
                            "To ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                children: "interact with the contract"
                            }),
                            " you should have ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                children: "ETH"
                            }),
                            " be added to the wallet ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                            " by using",
                            " ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                    target: "_blank",
                                    href: "https://faucet-beta-3.fuel.network/",
                                    children: "https://faucet-beta-3.fuel.network/"
                                })
                            })
                        ]
                    })
                }),
                network && txHash && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $72f10b3fcf20060f$export$d22914518d6cfe65), {
                    txHash: txHash,
                    network: network
                })
            ],
            !!errorMessage && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b76a4ff75d0d9de2$export$2e2bcd8739ae039), {
                closeModal: function() {
                    return setErrorMessage("");
                },
                title: "Problem with contract interaction",
                text: errorMessage
            })
        ]
    });
};













var $264417ac072da6c0$exports = {};
"use strict";
Object.defineProperty($264417ac072da6c0$exports, "__esModule", {
    value: true
});
$264417ac072da6c0$exports.BlueprintTonNetwork = $264417ac072da6c0$exports.CustomTonNetwork = $264417ac072da6c0$exports.TonPricesContractConnector = $264417ac072da6c0$exports.TonPricesContractAdapter = void 0;
var $5772d12adefbd6b5$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty($5772d12adefbd6b5$exports, "__esModule", {
    value: true
});
$5772d12adefbd6b5$exports.TonPriceManagerContractAdapter = void 0;
var $5772d12adefbd6b5$var$TonPriceManagerContractAdapter = /*#__PURE__*/ function() {
    function TonPriceManagerContractAdapter(contract) {
        (0, $978gY._)(this, TonPriceManagerContractAdapter);
        this.contract = contract;
    }
    (0, $kry2a._)(TonPriceManagerContractAdapter, [
        {
            key: "sendDeploy",
            value: function sendDeploy() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.contract.sendDeploy()
                        ];
                    });
                })();
            }
        },
        {
            key: "getPricesFromPayload",
            value: function getPricesFromPayload(paramsProvider) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.contract.getPrices(paramsProvider)
                        ];
                    });
                })();
            }
        },
        {
            key: "writePricesFromPayloadToContract",
            value: function writePricesFromPayloadToContract(paramsProvider) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.contract.sendWritePrices(paramsProvider)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    ""
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "readPricesFromContract",
            value: function readPricesFromContract(paramsProvider) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.contract.getReadPrices(paramsProvider)
                        ];
                    });
                })();
            }
        },
        {
            key: "readTimestampFromContract",
            value: function readTimestampFromContract() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.contract.getReadTimestamp()
                        ];
                    });
                })();
            }
        }
    ]);
    return TonPriceManagerContractAdapter;
}();
$5772d12adefbd6b5$exports.TonPriceManagerContractAdapter = $5772d12adefbd6b5$var$TonPriceManagerContractAdapter;


Object.defineProperty($264417ac072da6c0$exports, "TonPricesContractAdapter", {
    enumerable: true,
    get: function get() {
        return $5772d12adefbd6b5$exports.TonPriceManagerContractAdapter;
    }
});
var $5981c521794dfb1e$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty($5981c521794dfb1e$exports, "__esModule", {
    value: true
});
$5981c521794dfb1e$exports.TonPriceManagerContractConnector = void 0;

var $9ffb18f831604ec0$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty($9ffb18f831604ec0$exports, "__esModule", {
    value: true
});
$9ffb18f831604ec0$exports.TonPriceManager = void 0;

var $jWi6z = parcelRequire("jWi6z");
var $0b7691397734f359$exports = {};

var $gzLuY = parcelRequire("gzLuY");
var $0b7691397734f359$require$Buffer = $gzLuY.Buffer;
"use strict";
var $0b7691397734f359$var$__importDefault = $0b7691397734f359$exports && $0b7691397734f359$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($0b7691397734f359$exports, "__esModule", {
    value: true
});
$0b7691397734f359$exports.createDataPackageCell = $0b7691397734f359$exports.createPayloadCell = void 0;
// Abbreviations:
// * BS = Byte size
// Number of bytes reserved to store timestamp
var $1a97ff8bd14aa50d$export$4d81e73754b9380d = 6;
var $1a97ff8bd14aa50d$export$6b4370076ae50fb8 = 3;
var $1a97ff8bd14aa50d$export$6f85257b24e87db8 = 4;
var $1a97ff8bd14aa50d$export$1ec4dc697f56278b = 32;
var $1a97ff8bd14aa50d$export$87d66abbabc3f986 = 8;
var $1a97ff8bd14aa50d$export$7ead028d5a3e8bf = 2;
var $1a97ff8bd14aa50d$export$a5639f61eadc636b = 3;
var $1a97ff8bd14aa50d$export$15dd1ef80961e01b = "0x000002ed57011e0000";
var $1a97ff8bd14aa50d$export$475b0dca8ce8402 = $1a97ff8bd14aa50d$export$15dd1ef80961e01b.length / 2 - 1;
var $1a97ff8bd14aa50d$export$ba3b0c74090cebc7 = 65;
var $1a97ff8bd14aa50d$export$54c15319508b0d5b = 32;



var $jWi6z = parcelRequire("jWi6z");

var $hbWVX = parcelRequire("hbWVX");

var $0b7691397734f359$var$assert_1 = $0b7691397734f359$var$__importDefault((parcelRequire("2rjjG")));
var $54e84b13ade52798$exports = {};
"use strict";
Object.defineProperty($54e84b13ade52798$exports, "__esModule", {
    value: true
});
$54e84b13ade52798$exports.splitPayloadHex = void 0;


var $gMArf = parcelRequire("gMArf");

var $2rjjG = parcelRequire("2rjjG");
var $54e84b13ade52798$var$UNSIGNED_METADATA_BYTE_SIZE_BS = 3;
function $54e84b13ade52798$var$splitPayloadHex(payloadHex) {
    //TODO: assert value size == 32;
    var DATA_PACKAGE_BS = $1a97ff8bd14aa50d$export$54c15319508b0d5b + $1a97ff8bd14aa50d$export$1ec4dc697f56278b + $1a97ff8bd14aa50d$export$4d81e73754b9380d + $1a97ff8bd14aa50d$export$6b4370076ae50fb8 + $1a97ff8bd14aa50d$export$6f85257b24e87db8 + $1a97ff8bd14aa50d$export$ba3b0c74090cebc7;
    var unsignedMetadataBS = $gMArf.BigNumber.from("0x" + payloadHex.substring(payloadHex.length - 2 * ($1a97ff8bd14aa50d$export$475b0dca8ce8402 + $54e84b13ade52798$var$UNSIGNED_METADATA_BYTE_SIZE_BS), payloadHex.length - 2 * $1a97ff8bd14aa50d$export$475b0dca8ce8402)).toNumber();
    var metadataBS = $1a97ff8bd14aa50d$export$475b0dca8ce8402 + $54e84b13ade52798$var$UNSIGNED_METADATA_BYTE_SIZE_BS + unsignedMetadataBS + $1a97ff8bd14aa50d$export$7ead028d5a3e8bf;
    var metadata = payloadHex.substring(payloadHex.length - 2 * metadataBS, payloadHex.length);
    var dataPackageCount = $gMArf.BigNumber.from("0x" + metadata.substring(0, $1a97ff8bd14aa50d$export$7ead028d5a3e8bf * 2)).toNumber();
    (0, $2rjjG.equal)(payloadHex.length - 2 * metadataBS, 2 * DATA_PACKAGE_BS * dataPackageCount, "Must be implemented for multi-datapoint packages");
    var dataPackageChunks = [];
    for(var i = 0; i < dataPackageCount; i++)dataPackageChunks.push(payloadHex.substring(i * 2 * DATA_PACKAGE_BS, (i + 1) * 2 * DATA_PACKAGE_BS));
    return {
        dataPackageChunks: dataPackageChunks,
        metadata: metadata
    };
}
$54e84b13ade52798$exports.splitPayloadHex = $54e84b13ade52798$var$splitPayloadHex;


function $0b7691397734f359$var$createPayloadCell(payloadHex) {
    var _ref = (0, $54e84b13ade52798$exports.splitPayloadHex)(payloadHex), dataPackageChunks = _ref.dataPackageChunks, metadata = _ref.metadata;
    (0, $0b7691397734f359$var$assert_1.default)(dataPackageChunks.length <= 16, "Must be implemented for larger data (".concat(dataPackageChunks.length, " > 16)"));
    var lastCellIndex = -1;
    var payloadCell = (0, $jWi6z.beginCell)().storeBuffer($0b7691397734f359$require$Buffer.from((0, $hbWVX.arrayify)("0x" + metadata)));
    var cell = (0, $jWi6z.beginCell)();
    for(var i = 0; i <= dataPackageChunks.length; i++){
        var payloadCellIndex = Math.floor(i / 4);
        if (payloadCellIndex !== lastCellIndex && i !== 0 || i === dataPackageChunks.length) {
            payloadCell.storeRef(cell);
            if (i === dataPackageChunks.length) break;
            cell = (0, $jWi6z.beginCell)();
        }
        lastCellIndex = payloadCellIndex;
        var dataPackageCell = $0b7691397734f359$var$createDataPackageCell(dataPackageChunks[i]);
        cell.storeRef(dataPackageCell);
    }
    return payloadCell.endCell();
}
$0b7691397734f359$exports.createPayloadCell = $0b7691397734f359$var$createPayloadCell;
function $0b7691397734f359$var$createDataPackageCell(dataPackageHex) {
    var data = dataPackageHex.substring(0, dataPackageHex.length - 2 * $1a97ff8bd14aa50d$export$ba3b0c74090cebc7);
    var signature = dataPackageHex.substring(dataPackageHex.length - 2 * $1a97ff8bd14aa50d$export$ba3b0c74090cebc7, dataPackageHex.length);
    var v = BigInt("0x" + signature.substring(128, 130));
    (0, $0b7691397734f359$var$assert_1.default)([
        27,
        28
    ].map(BigInt).includes(v), "Wrong signature 'v' value (".concat(v, ")"));
    var signatureCell = (0, $jWi6z.beginCell)().storeUint(BigInt("0x" + signature.substring(0, 64)), 256).storeUint(BigInt("0x" + signature.substring(64, 128)), 256).storeUint(v, 8).endCell();
    console.assert(data.length / 2 <= 127, "Must be implemented for larger data");
    var dataCell = (0, $jWi6z.beginCell)().storeBuffer($0b7691397734f359$require$Buffer.from((0, $hbWVX.arrayify)("0x" + data))).endCell();
    return (0, $jWi6z.beginCell)().storeSlice(signatureCell.beginParse()).storeRef(dataCell).endCell();
}
$0b7691397734f359$exports.createDataPackageCell = $0b7691397734f359$var$createDataPackageCell;


var $b9ff8b8ac71d3cee$exports = {};

var $1ObTH = parcelRequire("1ObTH");
"use strict";
Object.defineProperty($b9ff8b8ac71d3cee$exports, "__esModule", {
    value: true
});
$b9ff8b8ac71d3cee$exports.createArrayFromTuple = $b9ff8b8ac71d3cee$exports.messageBuilder = $b9ff8b8ac71d3cee$exports.createArrayFromSerializedTuple = $b9ff8b8ac71d3cee$exports.createTupleItems = void 0;

var $jWi6z = parcelRequire("jWi6z");
var $97f1e1493c5dbacd$exports = {};
"use strict";
Object.defineProperty($97f1e1493c5dbacd$exports, "__esModule", {
    value: true
});
$97f1e1493c5dbacd$exports.OP_REDSTONE_FETCH_DATA = $97f1e1493c5dbacd$exports.OP_REDSTONE_WRITE_PRICES = $97f1e1493c5dbacd$exports.OP_NUMBER_BITS = void 0;
$97f1e1493c5dbacd$exports.OP_NUMBER_BITS = 256;
$97f1e1493c5dbacd$exports.OP_REDSTONE_WRITE_PRICES = BigInt("0x479227d578c45748b6c76eac834302019001b3ee2362a2921a367b76dee3760e"); // keccak(RedStone_Write_Prices)
$97f1e1493c5dbacd$exports.OP_REDSTONE_FETCH_DATA = BigInt("0x31a4a6560a71d9b83d4e2fe08cf460dc0163a78ca5cb069320b889323e60271f"); //keccak(RedStone_Fetch_Data)



function $b9ff8b8ac71d3cee$var$createTupleItems(items) {
    var tuple = new $jWi6z.TupleBuilder();
    items.forEach(function(value) {
        switch(typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value)){
            case "number":
                tuple.writeNumber(value);
                break;
            case "string":
                tuple.writeNumber(BigInt(value));
                break;
        }
    });
    return tuple.build();
}
$b9ff8b8ac71d3cee$exports.createTupleItems = $b9ff8b8ac71d3cee$var$createTupleItems;
function $b9ff8b8ac71d3cee$var$createArrayFromSerializedTuple(cell) {
    var value_size_bits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1a97ff8bd14aa50d$export$1ec4dc697f56278b * 8;
    // TODO: change it to bigint and in other places too.
    var values = [];
    var slice = cell.beginParse();
    while(slice.remainingBits > 0){
        var value = slice.loadInt(value_size_bits);
        values.push(value);
    }
    while(slice.remainingRefs > 0){
        var c = slice.loadRef();
        values = values.concat($b9ff8b8ac71d3cee$var$createArrayFromSerializedTuple(c));
    }
    return values;
}
$b9ff8b8ac71d3cee$exports.createArrayFromSerializedTuple = $b9ff8b8ac71d3cee$var$createArrayFromSerializedTuple;
function $b9ff8b8ac71d3cee$var$messageBuilder(opNumber) {
    return (0, $jWi6z.beginCell)().storeUint(opNumber, $97f1e1493c5dbacd$exports.OP_NUMBER_BITS);
}
$b9ff8b8ac71d3cee$exports.messageBuilder = $b9ff8b8ac71d3cee$var$messageBuilder;
function $b9ff8b8ac71d3cee$var$createArrayFromTuple(result) {
    var values = [];
    while(result.remaining)values.push(result.readNumber());
    return values;
}
$b9ff8b8ac71d3cee$exports.createArrayFromTuple = $b9ff8b8ac71d3cee$var$createArrayFromTuple;



var $b30b638438aa1abc$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty($b30b638438aa1abc$exports, "__esModule", {
    value: true
});
$b30b638438aa1abc$exports.TonContract = void 0;

var $jWi6z = parcelRequire("jWi6z");
var $aa9c67c837210e90$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty($aa9c67c837210e90$exports, "__esModule", {
    value: true
});
$aa9c67c837210e90$exports.Ton = $aa9c67c837210e90$exports.sleep = void 0;
var $89095f30c08601be$exports = {};
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $89095f30c08601be$var$__createBinding = $89095f30c08601be$exports && $89095f30c08601be$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $89095f30c08601be$var$__exportStar = $89095f30c08601be$exports && $89095f30c08601be$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $89095f30c08601be$var$__createBinding(exports1, m, p);
};
Object.defineProperty($89095f30c08601be$exports, "__esModule", {
    value: true
});
$89095f30c08601be$exports.loadConfigParamsAsSlice = $89095f30c08601be$exports.loadConfigParamById = $89095f30c08601be$exports.parseFullConfig = $89095f30c08601be$exports.parseVotingSetup = $89095f30c08601be$exports.parseValidatorSet = $89095f30c08601be$exports.parseProposalSetup = $89095f30c08601be$exports.parseBridge = $89095f30c08601be$exports.configParseWorkchainDescriptor = $89095f30c08601be$exports.configParseValidatorSet = $89095f30c08601be$exports.configParseMsgPrices = $89095f30c08601be$exports.configParseMasterAddressRequired = $89095f30c08601be$exports.configParseMasterAddress = $89095f30c08601be$exports.configParseGasLimitsPrices = $89095f30c08601be$exports.configParseBridge = $89095f30c08601be$exports.configParse40 = $89095f30c08601be$exports.configParse29 = $89095f30c08601be$exports.configParse28 = $89095f30c08601be$exports.configParse18 = $89095f30c08601be$exports.configParse17 = $89095f30c08601be$exports.configParse16 = $89095f30c08601be$exports.configParse15 = $89095f30c08601be$exports.configParse13 = $89095f30c08601be$exports.configParse12 = $89095f30c08601be$exports.configParse8 = $89095f30c08601be$exports.configParse5 = $89095f30c08601be$exports.ElectorContract = $89095f30c08601be$exports.MultisigWallet = $89095f30c08601be$exports.MultisigOrderBuilder = $89095f30c08601be$exports.MultisigOrder = $89095f30c08601be$exports.JettonWallet = $89095f30c08601be$exports.JettonMaster = $89095f30c08601be$exports.WalletContractV4 = $89095f30c08601be$exports.WalletContractV3R2 = $89095f30c08601be$exports.WalletContractV3R1 = $89095f30c08601be$exports.WalletContractV2R2 = $89095f30c08601be$exports.WalletContractV2R1 = $89095f30c08601be$exports.WalletContractV1R3 = $89095f30c08601be$exports.WalletContractV1R2 = $89095f30c08601be$exports.WalletContractV1R1 = $89095f30c08601be$exports.TonClient4 = $89095f30c08601be$exports.TonClient = $89095f30c08601be$exports.HttpApi = void 0;

$89095f30c08601be$var$__exportStar((parcelRequire("jWi6z")), $89095f30c08601be$exports);
var $f2beac447e676249$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $f2beac447e676249$require$Buffer = $gzLuY.Buffer;
"use strict";
var $f2beac447e676249$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f2beac447e676249$exports, "__esModule", {
    value: true
});
$f2beac447e676249$exports.HttpApi = void 0;
var $53789ddcf95e0621$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty($53789ddcf95e0621$exports, "__esModule", {
    value: true
});
$53789ddcf95e0621$exports.InMemoryCache = void 0;
var $53789ddcf95e0621$var$InMemoryCache = function InMemoryCache() {
    (0, $978gY._)(this, InMemoryCache);
    this.cache = new Map();
    var _this = this;
    this.set = function() {
        var _ref = (0, $byzP8._)(function(namespace, key, value) {
            return (0, $7UAGh.__generator)(this, function(_state) {
                if (value !== null) _this.cache.set(namespace + "$$" + key, value);
                else _this.cache.delete(namespace + "$$" + key);
                return [
                    2
                ];
            });
        });
        return function(namespace, key, value) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this1 = this;
    this.get = function() {
        var _ref = (0, $byzP8._)(function(namespace, key) {
            var res;
            return (0, $7UAGh.__generator)(this, function(_state) {
                res = _this1.cache.get(namespace + "$$" + key);
                if (res !== undefined) return [
                    2,
                    res
                ];
                else return [
                    2,
                    null
                ];
                return [
                    2
                ];
            });
        });
        return function(namespace, key) {
            return _ref.apply(this, arguments);
        };
    }();
};
$53789ddcf95e0621$exports.InMemoryCache = $53789ddcf95e0621$var$InMemoryCache;



var $f2beac447e676249$var$dataloader_1 = $f2beac447e676249$var$__importDefault((parcelRequire("hFGzs")));

var $f2beac447e676249$var$axios_1 = $f2beac447e676249$var$__importDefault((parcelRequire("12URZ")));

var $3vWwE = parcelRequire("3vWwE");

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $ftJVG = parcelRequire("ftJVG");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $1ObTH = parcelRequire("1ObTH");

var $2TMdq = parcelRequire("2TMdq");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
var $bc80ebcf21bfccd0$export$7debb50ef11d5e0b;
(function(util) {
    var assertIs = function assertIs(_arg) {};
    var assertNever = function assertNever(_x) {
        throw new Error();
    };
    var joinValues = function joinValues(array) {
        var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " | ";
        return array.map(function(val) {
            return typeof val === "string" ? "'".concat(val, "'") : val;
        }).join(separator);
    };
    util.assertEqual = function(val) {
        return val;
    };
    util.assertIs = assertIs;
    util.assertNever = assertNever;
    util.arrayToEnum = function(items) {
        var obj = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                obj[item] = item;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return obj;
    };
    util.getValidEnumValues = function(obj) {
        var validKeys = util.objectKeys(obj).filter(function(k) {
            return typeof obj[obj[k]] !== "number";
        });
        var filtered = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = validKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var k = _step.value;
                filtered[k] = obj[k];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return util.objectValues(filtered);
    };
    util.objectValues = function(obj) {
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? function(obj) {
        return Object.keys(obj) // eslint-disable-line ban/ban
        ;
    } : function(object) {
        var keys = [];
        for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = function(arr, checker) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (checker(item)) return item;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? function(val) {
        return Number.isInteger(val) // eslint-disable-line ban/ban
        ;
    } : function(val) {
        return typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    };
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = function(_, value) {
        if ((typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value)) === "bigint") return value.toString();
        return value;
    };
})($bc80ebcf21bfccd0$export$7debb50ef11d5e0b || ($bc80ebcf21bfccd0$export$7debb50ef11d5e0b = {}));
var $bc80ebcf21bfccd0$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = function(first, second) {
        return (0, $8OnJk._)({}, first, second);
    };
})($bc80ebcf21bfccd0$export$4aa2142c225fd5c7 || ($bc80ebcf21bfccd0$export$4aa2142c225fd5c7 = {}));
var $bc80ebcf21bfccd0$export$5716da67bfaa244d = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
var $bc80ebcf21bfccd0$export$3e9057828ebd5c7a = function(data) {
    var t = typeof data === "undefined" ? "undefined" : (0, $1ObTH._)(data);
    switch(t){
        case "undefined":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined;
        case "string":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $bc80ebcf21bfccd0$export$5716da67bfaa244d.nan : $bc80ebcf21bfccd0$export$5716da67bfaa244d.number;
        case "boolean":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.boolean;
        case "function":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.function;
        case "bigint":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $bc80ebcf21bfccd0$export$5716da67bfaa244d.array;
            if (data === null) return $bc80ebcf21bfccd0$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $bc80ebcf21bfccd0$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $bc80ebcf21bfccd0$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $bc80ebcf21bfccd0$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $bc80ebcf21bfccd0$export$5716da67bfaa244d.date;
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.object;
        default:
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.unknown;
    }
};
var $bc80ebcf21bfccd0$export$5ba560653e4a1035 = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
var $bc80ebcf21bfccd0$export$913eddeaf297cfea = function(obj) {
    var json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
var $bc80ebcf21bfccd0$export$f98dac4b251ab333 = /*#__PURE__*/ function _target(Error1) {
    "use strict";
    (0, $ftJVG._)(ZodError, Error1);
    var _super = (0, $6OZAO._)(ZodError);
    function ZodError(issues) {
        (0, $978gY._)(this, ZodError);
        var _this;
        _this = _super.call(this);
        _this.issues = [];
        _this.addIssue = function(sub) {
            _this.issues = (0, $fLnyw._)(_this.issues).concat([
                sub
            ]);
        };
        _this.addIssues = function() {
            var subs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
            _this.issues = (0, $fLnyw._)(_this.issues).concat((0, $fLnyw._)(subs));
        };
        var actualProto = (this instanceof ZodError ? this.constructor : void 0).prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf((0, $3vWwE._)(_this), actualProto);
        else _this.__proto__ = actualProto;
        _this.name = "ZodError";
        _this.issues = issues;
        return _this;
    }
    (0, $kry2a._)(ZodError, [
        {
            key: "errors",
            get: function get() {
                return this.issues;
            }
        },
        {
            key: "format",
            value: function format(_mapper) {
                var mapper = _mapper || function(issue) {
                    return issue.message;
                };
                var fieldErrors = {
                    _errors: []
                };
                var processError = function(error) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = error.issues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var issue = _step.value;
                            if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                            else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                            else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                            else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                            else {
                                var curr = fieldErrors;
                                var i = 0;
                                while(i < issue.path.length){
                                    var el = issue.path[i];
                                    var terminal = i === issue.path.length - 1;
                                    if (!terminal) curr[el] = curr[el] || {
                                        _errors: []
                                    };
                                    else {
                                        curr[el] = curr[el] || {
                                            _errors: []
                                        };
                                        curr[el]._errors.push(mapper(issue));
                                    }
                                    curr = curr[el];
                                    i++;
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                };
                processError(this);
                return fieldErrors;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.message;
            }
        },
        {
            key: "message",
            get: function get() {
                return JSON.stringify(this.issues, $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
            }
        },
        {
            key: "isEmpty",
            get: function get() {
                return this.issues.length === 0;
            }
        },
        {
            key: "flatten",
            value: function flatten() {
                var mapper = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(issue) {
                    return issue.message;
                };
                var fieldErrors = {};
                var formErrors = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.issues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sub = _step.value;
                        if (sub.path.length > 0) {
                            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                            fieldErrors[sub.path[0]].push(mapper(sub));
                        } else formErrors.push(mapper(sub));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    formErrors: formErrors,
                    fieldErrors: fieldErrors
                };
            }
        },
        {
            key: "formErrors",
            get: function get() {
                return this.flatten();
            }
        }
    ]);
    return ZodError;
}((0, $2TMdq._)(Error));
$bc80ebcf21bfccd0$export$f98dac4b251ab333.create = function(issues) {
    var error = new $bc80ebcf21bfccd0$export$f98dac4b251ab333(issues);
    return error;
};
var $bc80ebcf21bfccd0$export$341b0b6e0a6f5099 = function(issue, _ctx) {
    var message;
    switch(issue.code){
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined) message = "Required";
            else message = "Expected ".concat(issue.expected, ", received ").concat(issue.received);
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_literal:
            message = "Invalid literal value, expected ".concat(JSON.stringify(issue.expected, $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.jsonStringifyReplacer));
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.unrecognized_keys:
            message = "Unrecognized key(s) in object: ".concat($bc80ebcf21bfccd0$export$7debb50ef11d5e0b.joinValues(issue.keys, ", "));
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_union:
            message = "Invalid input";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_union_discriminator:
            message = "Invalid discriminator value. Expected ".concat($bc80ebcf21bfccd0$export$7debb50ef11d5e0b.joinValues(issue.options));
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_enum_value:
            message = "Invalid enum value. Expected ".concat($bc80ebcf21bfccd0$export$7debb50ef11d5e0b.joinValues(issue.options), ", received '").concat(issue.received, "'");
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_arguments:
            message = "Invalid function arguments";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_return_type:
            message = "Invalid function return type";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_date:
            message = "Invalid date";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = 'Invalid input: must include "'.concat(issue.validation.includes, '"');
                    if (typeof issue.validation.position === "number") message = "".concat(message, " at one or more positions greater than or equal to ").concat(issue.validation.position);
                } else if ("startsWith" in issue.validation) message = 'Invalid input: must start with "'.concat(issue.validation.startsWith, '"');
                else if ("endsWith" in issue.validation) message = 'Invalid input: must end with "'.concat(issue.validation.endsWith, '"');
                else $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = "Invalid ".concat(issue.validation);
            else message = "Invalid";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = "Array must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at least" : "more than", " ").concat(issue.minimum, " element(s)");
            else if (issue.type === "string") message = "String must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at least" : "over", " ").concat(issue.minimum, " character(s)");
            else if (issue.type === "number") message = "Number must be ".concat(issue.exact ? "exactly equal to " : issue.inclusive ? "greater than or equal to " : "greater than ").concat(issue.minimum);
            else if (issue.type === "date") message = "Date must be ".concat(issue.exact ? "exactly equal to " : issue.inclusive ? "greater than or equal to " : "greater than ").concat(new Date(Number(issue.minimum)));
            else message = "Invalid input";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = "Array must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at most" : "less than", " ").concat(issue.maximum, " element(s)");
            else if (issue.type === "string") message = "String must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at most" : "under", " ").concat(issue.maximum, " character(s)");
            else if (issue.type === "number") message = "Number must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "less than or equal to" : "less than", " ").concat(issue.maximum);
            else if (issue.type === "bigint") message = "BigInt must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "less than or equal to" : "less than", " ").concat(issue.maximum);
            else if (issue.type === "date") message = "Date must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "smaller than or equal to" : "smaller than", " ").concat(new Date(Number(issue.maximum)));
            else message = "Invalid input";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.custom:
            message = "Invalid input";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_intersection_types:
            message = "Intersection results could not be merged";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.not_multiple_of:
            message = "Number must be a multiple of ".concat(issue.multipleOf);
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
var $bc80ebcf21bfccd0$var$overrideErrorMap = $bc80ebcf21bfccd0$export$341b0b6e0a6f5099;
function $bc80ebcf21bfccd0$export$1097a8289cfd22d7(map) {
    $bc80ebcf21bfccd0$var$overrideErrorMap = map;
}
function $bc80ebcf21bfccd0$export$32f27c719778d4c4() {
    return $bc80ebcf21bfccd0$var$overrideErrorMap;
}
var $bc80ebcf21bfccd0$export$244a85fde9c419ed = function(params) {
    var data = params.data, path = params.path, errorMaps = params.errorMaps, issueData = params.issueData;
    var fullPath = (0, $fLnyw._)(path).concat((0, $fLnyw._)(issueData.path || []));
    var fullIssue = (0, $8E768._)((0, $8OnJk._)({}, issueData), {
        path: fullPath
    });
    var errorMessage = "";
    var maps = errorMaps.filter(function(m) {
        return !!m;
    }).slice().reverse();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = maps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var map = _step.value;
            errorMessage = map(fullIssue, {
                data: data,
                defaultError: errorMessage
            }).message;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, $8E768._)((0, $8OnJk._)({}, issueData), {
        path: fullPath,
        message: issueData.message || errorMessage
    });
};
var $bc80ebcf21bfccd0$export$1526d2e05f74572 = [];
function $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, issueData) {
    var issue = $bc80ebcf21bfccd0$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $bc80ebcf21bfccd0$export$32f27c719778d4c4(),
            $bc80ebcf21bfccd0$export$341b0b6e0a6f5099
        ].filter(function(x) {
            return !!x;
        })
    });
    ctx.common.issues.push(issue);
}
var $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f = /*#__PURE__*/ function() {
    "use strict";
    function ParseStatus() {
        (0, $978gY._)(this, ParseStatus);
        this.value = "valid";
    }
    (0, $kry2a._)(ParseStatus, [
        {
            key: "dirty",
            value: function dirty() {
                if (this.value === "valid") this.value = "dirty";
            }
        },
        {
            key: "abort",
            value: function abort() {
                if (this.value !== "aborted") this.value = "aborted";
            }
        }
    ], [
        {
            key: "mergeArray",
            value: function mergeArray(status, results) {
                var arrayValue = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var s = _step.value;
                        if (s.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                        if (s.status === "dirty") status.dirty();
                        arrayValue.push(s.value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: arrayValue
                };
            }
        },
        {
            key: "mergeObjectAsync",
            value: function mergeObjectAsync(status, pairs) {
                return (0, $byzP8._)(function() {
                    var syncPairs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, _, _tmp, err;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                syncPairs = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = pairs[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                pair = _step.value;
                                _ = syncPairs.push;
                                _tmp = {};
                                return [
                                    4,
                                    pair.key
                                ];
                            case 3:
                                _tmp.key = _state.sent();
                                return [
                                    4,
                                    pair.value
                                ];
                            case 4:
                                _.apply(syncPairs, [
                                    (_tmp.value = _state.sent(), _tmp)
                                ]);
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    ParseStatus.mergeObjectSync(status, syncPairs)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "mergeObjectSync",
            value: function mergeObjectSync(status, pairs) {
                var finalObject = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var pair = _step.value;
                        var key = pair.key, value = pair.value;
                        if (key.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                        if (value.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                        if (key.status === "dirty") status.dirty();
                        if (value.status === "dirty") status.dirty();
                        if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: finalObject
                };
            }
        }
    ]);
    return ParseStatus;
}();
var $bc80ebcf21bfccd0$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
var $bc80ebcf21bfccd0$export$325a211da9693fcf = function(value) {
    return {
        status: "dirty",
        value: value
    };
};
var $bc80ebcf21bfccd0$export$c6813a8d51f77eaf = function(value) {
    return {
        status: "valid",
        value: value
    };
};
var $bc80ebcf21bfccd0$export$afa861e3c5730743 = function(x) {
    return x.status === "aborted";
};
var $bc80ebcf21bfccd0$export$910b6cdd390341b3 = function(x) {
    return x.status === "dirty";
};
var $bc80ebcf21bfccd0$export$1ea939691cdc45b8 = function(x) {
    return x.status === "valid";
};
var $bc80ebcf21bfccd0$export$aefee5ebe1dcfd9e = function(x) {
    return typeof Promise !== "undefined" && x instanceof Promise;
};
var $bc80ebcf21bfccd0$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = function(message) {
        return typeof message === "string" ? {
            message: message
        } : message || {};
    };
    errorUtil.toString = function(message) {
        return typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
    };
})($bc80ebcf21bfccd0$var$errorUtil || ($bc80ebcf21bfccd0$var$errorUtil = {}));
var $bc80ebcf21bfccd0$var$ParseInputLazyPath = /*#__PURE__*/ function() {
    "use strict";
    function ParseInputLazyPath(parent, value, path, key) {
        (0, $978gY._)(this, ParseInputLazyPath);
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    (0, $kry2a._)(ParseInputLazyPath, [
        {
            key: "path",
            get: function get() {
                if (!this._cachedPath.length) {
                    var _this__cachedPath, _this__cachedPath1;
                    if (this._key instanceof Array) (_this__cachedPath = this._cachedPath).push.apply(_this__cachedPath, (0, $fLnyw._)(this._path).concat((0, $fLnyw._)(this._key)));
                    else (_this__cachedPath1 = this._cachedPath).push.apply(_this__cachedPath1, (0, $fLnyw._)(this._path).concat([
                        this._key
                    ]));
                }
                return this._cachedPath;
            }
        }
    ]);
    return ParseInputLazyPath;
}();
var $bc80ebcf21bfccd0$var$handleResult = function(ctx, result) {
    if ($bc80ebcf21bfccd0$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                var error = new $bc80ebcf21bfccd0$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $bc80ebcf21bfccd0$var$processCreateParams(params) {
    if (!params) return {};
    var errorMap = params.errorMap, invalid_type_error = params.invalid_type_error, required_error = params.required_error, description = params.description;
    if (errorMap && (invalid_type_error || required_error)) throw new Error('Can\'t use "invalid_type_error" or "required_error" in conjunction with custom error map.');
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    var customMap = function(iss, ctx) {
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
var $bc80ebcf21bfccd0$export$19342e026b58ebb7 = /*#__PURE__*/ function() {
    "use strict";
    function ZodType(def) {
        (0, $978gY._)(this, ZodType);
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    (0, $kry2a._)(ZodType, [
        {
            key: "description",
            get: function get() {
                return this._def.description;
            }
        },
        {
            key: "_getType",
            value: function _getType(input) {
                return $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(input.data);
            }
        },
        {
            key: "_getOrReturnCtx",
            value: function _getOrReturnCtx(input, ctx) {
                return ctx || {
                    common: input.parent.common,
                    data: input.data,
                    parsedType: $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(input.data),
                    schemaErrorMap: this._def.errorMap,
                    path: input.path,
                    parent: input.parent
                };
            }
        },
        {
            key: "_processInputParams",
            value: function _processInputParams(input) {
                return {
                    status: new $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f(),
                    ctx: {
                        common: input.parent.common,
                        data: input.data,
                        parsedType: $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(input.data),
                        schemaErrorMap: this._def.errorMap,
                        path: input.path,
                        parent: input.parent
                    }
                };
            }
        },
        {
            key: "_parseSync",
            value: function _parseSync(input) {
                var result = this._parse(input);
                if ($bc80ebcf21bfccd0$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
                return result;
            }
        },
        {
            key: "_parseAsync",
            value: function _parseAsync(input) {
                var result = this._parse(input);
                return Promise.resolve(result);
            }
        },
        {
            key: "parse",
            value: function parse(data, params) {
                var result = this.safeParse(data, params);
                if (result.success) return result.data;
                throw result.error;
            }
        },
        {
            key: "safeParse",
            value: function safeParse(data, params) {
                var _a;
                var ctx = {
                    common: {
                        issues: [],
                        async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
                    },
                    path: (params === null || params === void 0 ? void 0 : params.path) || [],
                    schemaErrorMap: this._def.errorMap,
                    parent: null,
                    data: data,
                    parsedType: $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(data)
                };
                var result = this._parseSync({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
                return $bc80ebcf21bfccd0$var$handleResult(ctx, result);
            }
        },
        {
            key: "parseAsync",
            value: function parseAsync(data, params) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.safeParseAsync(data, params)
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.success) return [
                                    2,
                                    result.data
                                ];
                                throw result.error;
                        }
                    });
                })();
            }
        },
        {
            key: "safeParseAsync",
            value: function safeParseAsync(data, params) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var ctx, maybeAsyncResult, result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ctx = {
                                    common: {
                                        issues: [],
                                        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                                        async: true
                                    },
                                    path: (params === null || params === void 0 ? void 0 : params.path) || [],
                                    schemaErrorMap: _this._def.errorMap,
                                    parent: null,
                                    data: data,
                                    parsedType: $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(data)
                                };
                                maybeAsyncResult = _this._parse({
                                    data: data,
                                    path: ctx.path,
                                    parent: ctx
                                });
                                return [
                                    4,
                                    $bc80ebcf21bfccd0$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    $bc80ebcf21bfccd0$var$handleResult(ctx, result)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "refine",
            value: function refine(check, message) {
                var getIssueProperties = function(val) {
                    if (typeof message === "string" || typeof message === "undefined") return {
                        message: message
                    };
                    else if (typeof message === "function") return message(val);
                    else return message;
                };
                return this._refinement(function(val, ctx) {
                    var result = check(val);
                    var setError = function() {
                        return ctx.addIssue((0, $8OnJk._)({
                            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.custom
                        }, getIssueProperties(val)));
                    };
                    if (typeof Promise !== "undefined" && result instanceof Promise) return result.then(function(data) {
                        if (!data) {
                            setError();
                            return false;
                        } else return true;
                    });
                    if (!result) {
                        setError();
                        return false;
                    } else return true;
                });
            }
        },
        {
            key: "refinement",
            value: function refinement(check, refinementData) {
                return this._refinement(function(val, ctx) {
                    if (!check(val)) {
                        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                        return false;
                    } else return true;
                });
            }
        },
        {
            key: "_refinement",
            value: function _refinement(refinement) {
                return new $bc80ebcf21bfccd0$export$a60af00cc0ce2582({
                    schema: this,
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEffects,
                    effect: {
                        type: "refinement",
                        refinement: refinement
                    }
                });
            }
        },
        {
            key: "superRefine",
            value: function superRefine(refinement) {
                return this._refinement(refinement);
            }
        },
        {
            key: "optional",
            value: function optional() {
                return $bc80ebcf21bfccd0$export$aa56fec1e9d629b8.create(this, this._def);
            }
        },
        {
            key: "nullable",
            value: function nullable() {
                return $bc80ebcf21bfccd0$export$aaac0b8b429cef5.create(this, this._def);
            }
        },
        {
            key: "nullish",
            value: function nullish() {
                return this.nullable().optional();
            }
        },
        {
            key: "array",
            value: function array() {
                return $bc80ebcf21bfccd0$export$7acfc3e64785411.create(this, this._def);
            }
        },
        {
            key: "promise",
            value: function promise() {
                return $bc80ebcf21bfccd0$export$3f196b0127d6e50a.create(this, this._def);
            }
        },
        {
            key: "or",
            value: function or(option) {
                return $bc80ebcf21bfccd0$export$a8b236cb5070a311.create([
                    this,
                    option
                ], this._def);
            }
        },
        {
            key: "and",
            value: function and(incoming) {
                return $bc80ebcf21bfccd0$export$c02deaf0bb5203d4.create(this, incoming, this._def);
            }
        },
        {
            key: "transform",
            value: function transform(transform) {
                return new $bc80ebcf21bfccd0$export$a60af00cc0ce2582((0, $8E768._)((0, $8OnJk._)({}, $bc80ebcf21bfccd0$var$processCreateParams(this._def)), {
                    schema: this,
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEffects,
                    effect: {
                        type: "transform",
                        transform: transform
                    }
                }));
            }
        },
        {
            key: "default",
            value: function _default(def) {
                var defaultValueFunc = typeof def === "function" ? def : function() {
                    return def;
                };
                return new $bc80ebcf21bfccd0$export$bb19b37874861e7e((0, $8E768._)((0, $8OnJk._)({}, $bc80ebcf21bfccd0$var$processCreateParams(this._def)), {
                    innerType: this,
                    defaultValue: defaultValueFunc,
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodDefault
                }));
            }
        },
        {
            key: "brand",
            value: function brand() {
                return new $bc80ebcf21bfccd0$export$66b0c798a395271f((0, $8OnJk._)({
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodBranded,
                    type: this
                }, $bc80ebcf21bfccd0$var$processCreateParams(this._def)));
            }
        },
        {
            key: "catch",
            value: function _catch(def) {
                var catchValueFunc = typeof def === "function" ? def : function() {
                    return def;
                };
                return new $bc80ebcf21bfccd0$export$75a44ec6249ac76b((0, $8E768._)((0, $8OnJk._)({}, $bc80ebcf21bfccd0$var$processCreateParams(this._def)), {
                    innerType: this,
                    catchValue: catchValueFunc,
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodCatch
                }));
            }
        },
        {
            key: "describe",
            value: function describe(description) {
                var This = this.constructor;
                return new This((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    description: description
                }));
            }
        },
        {
            key: "pipe",
            value: function pipe(target) {
                return $bc80ebcf21bfccd0$export$a3c3ef8a0e95c6da.create(this, target);
            }
        },
        {
            key: "readonly",
            value: function readonly() {
                return $bc80ebcf21bfccd0$export$5d1f7ef05c4e493a.create(this);
            }
        },
        {
            key: "isOptional",
            value: function isOptional() {
                return this.safeParse(undefined).success;
            }
        },
        {
            key: "isNullable",
            value: function isNullable() {
                return this.safeParse(null).success;
            }
        }
    ]);
    return ZodType;
}();
var $bc80ebcf21bfccd0$var$cuidRegex = /^c[^\s-]{8,}$/i;
var $bc80ebcf21bfccd0$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
var $bc80ebcf21bfccd0$var$ulidRegex = /[0-9A-HJKMNP-TV-Z]{26}/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
var $bc80ebcf21bfccd0$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
var $bc80ebcf21bfccd0$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
var $bc80ebcf21bfccd0$var$emojiRegex = RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u");
var $bc80ebcf21bfccd0$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
var $bc80ebcf21bfccd0$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
var $bc80ebcf21bfccd0$var$datetimeRegex = function(args) {
    if (args.precision) {
        if (args.offset) return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{".concat(args.precision, "}(([+-]\\d{2}(:?\\d{2})?)|Z)$"));
        else return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{".concat(args.precision, "}Z$"));
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$");
        else return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$");
    } else {
        if (args.offset) return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$");
        else return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
    }
};
function $bc80ebcf21bfccd0$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $bc80ebcf21bfccd0$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $bc80ebcf21bfccd0$var$ipv6Regex.test(ip)) return true;
    return false;
}
var $bc80ebcf21bfccd0$export$1230eb29b8d3b502 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodString, ZodType);
    var _super = (0, $6OZAO._)(ZodString);
    function ZodString() {
        (0, $978gY._)(this, ZodString);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this._regex = function(regex, validation, message) {
            return _this.refinement(function(data) {
                return regex.test(data);
            }, (0, $8OnJk._)({
                validation: validation,
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string
            }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
        };
        /**
         * @deprecated Use z.string().min(1) instead.
         * @see {@link ZodString.min}
         */ _this.nonempty = function(message) {
            return _this.min(1, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message));
        };
        _this.trim = function() {
            return new ZodString((0, $8E768._)((0, $8OnJk._)({}, _this._def), {
                checks: (0, $fLnyw._)(_this._def.checks).concat([
                    {
                        kind: "trim"
                    }
                ])
            }));
        };
        _this.toLowerCase = function() {
            return new ZodString((0, $8E768._)((0, $8OnJk._)({}, _this._def), {
                checks: (0, $fLnyw._)(_this._def.checks).concat([
                    {
                        kind: "toLowerCase"
                    }
                ])
            }));
        };
        _this.toUpperCase = function() {
            return new ZodString((0, $8E768._)((0, $8OnJk._)({}, _this._def), {
                checks: (0, $fLnyw._)(_this._def.checks).concat([
                    {
                        kind: "toUpperCase"
                    }
                ])
            }));
        };
        return _this;
    }
    (0, $kry2a._)(ZodString, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = String(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.string) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.string,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var status = new $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f();
                var ctx1 = undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            if (input.data.length < check.value) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                                    minimum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            if (input.data.length > check.value) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                                    maximum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "length") {
                            var tooBig = input.data.length > check.value;
                            var tooSmall = input.data.length < check.value;
                            if (tooBig || tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                if (tooBig) $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                                    maximum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: true,
                                    message: check.message
                                });
                                else if (tooSmall) $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                                    minimum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: true,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "email") {
                            if (!$bc80ebcf21bfccd0$var$emailRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    validation: "email",
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "emoji") {
                            if (!$bc80ebcf21bfccd0$var$emojiRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    validation: "emoji",
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "uuid") {
                            if (!$bc80ebcf21bfccd0$var$uuidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    validation: "uuid",
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "cuid") {
                            if (!$bc80ebcf21bfccd0$var$cuidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    validation: "cuid",
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "cuid2") {
                            if (!$bc80ebcf21bfccd0$var$cuid2Regex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    validation: "cuid2",
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "ulid") {
                            if (!$bc80ebcf21bfccd0$var$ulidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    validation: "ulid",
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "url") try {
                            new URL(input.data);
                        } catch (_a) {
                            ctx1 = this._getOrReturnCtx(input, ctx1);
                            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                validation: "url",
                                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                message: check.message
                            });
                            status.dirty();
                        }
                        else if (check.kind === "regex") {
                            check.regex.lastIndex = 0;
                            var testResult = check.regex.test(input.data);
                            if (!testResult) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    validation: "regex",
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "trim") input.data = input.data.trim();
                        else if (check.kind === "includes") {
                            if (!input.data.includes(check.value, check.position)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    validation: {
                                        includes: check.value,
                                        position: check.position
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
                        else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
                        else if (check.kind === "startsWith") {
                            if (!input.data.startsWith(check.value)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    validation: {
                                        startsWith: check.value
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "endsWith") {
                            if (!input.data.endsWith(check.value)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    validation: {
                                        endsWith: check.value
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "datetime") {
                            var regex = $bc80ebcf21bfccd0$var$datetimeRegex(check);
                            if (!regex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    validation: "datetime",
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "ip") {
                            if (!$bc80ebcf21bfccd0$var$isValidIP(input.data, check.version)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    validation: "ip",
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodString((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    checks: (0, $fLnyw._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "email",
            value: function email(message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "email"
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "url",
            value: function url(message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "url"
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "emoji",
            value: function emoji(message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "emoji"
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "uuid",
            value: function uuid(message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "uuid"
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "cuid",
            value: function cuid(message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "cuid"
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "cuid2",
            value: function cuid2(message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "cuid2"
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "ulid",
            value: function ulid(message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "ulid"
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "ip",
            value: function ip(options) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "ip"
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(options)));
            }
        },
        {
            key: "datetime",
            value: function datetime(options) {
                var _a;
                if (typeof options === "string") return this._addCheck({
                    kind: "datetime",
                    precision: null,
                    offset: false,
                    message: options
                });
                return this._addCheck((0, $8OnJk._)({
                    kind: "datetime",
                    precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
                    offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
            }
        },
        {
            key: "regex",
            value: function regex(regex, message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "regex",
                    regex: regex
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "includes",
            value: function includes(value, options) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "includes",
                    value: value,
                    position: options === null || options === void 0 ? void 0 : options.position
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
            }
        },
        {
            key: "startsWith",
            value: function startsWith(value, message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "startsWith",
                    value: value
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "endsWith",
            value: function endsWith(value, message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "endsWith",
                    value: value
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "min",
            value: function min(minLength, message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "min",
                    value: minLength
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "max",
            value: function max(maxLength, message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "max",
                    value: maxLength
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "length",
            value: function length(len, message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "length",
                    value: len
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "isDatetime",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "datetime";
                });
            }
        },
        {
            key: "isEmail",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "email";
                });
            }
        },
        {
            key: "isURL",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "url";
                });
            }
        },
        {
            key: "isEmoji",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "emoji";
                });
            }
        },
        {
            key: "isUUID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "uuid";
                });
            }
        },
        {
            key: "isCUID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "cuid";
                });
            }
        },
        {
            key: "isCUID2",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "cuid2";
                });
            }
        },
        {
            key: "isULID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "ulid";
                });
            }
        },
        {
            key: "isIP",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "ip";
                });
            }
        },
        {
            key: "minLength",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxLength",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        }
    ]);
    return ZodString;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$1230eb29b8d3b502.create = function(params) {
    var _a;
    return new $bc80ebcf21bfccd0$export$1230eb29b8d3b502((0, $8OnJk._)({
        checks: [],
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $bc80ebcf21bfccd0$var$floatSafeRemainder(val, step) {
    var valDecCount = (val.toString().split(".")[1] || "").length;
    var stepDecCount = (step.toString().split(".")[1] || "").length;
    var decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    var valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    var stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
var $bc80ebcf21bfccd0$export$5b070a55c0c43e09 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodNumber, ZodType);
    var _super = (0, $6OZAO._)(ZodNumber);
    function ZodNumber() {
        (0, $978gY._)(this, ZodNumber);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.min = _this.gte;
        _this.max = _this.lte;
        _this.step = _this.multipleOf;
        return _this;
    }
    (0, $kry2a._)(ZodNumber, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = Number(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.number) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.number,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var ctx1 = undefined;
                var status = new $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "int") {
                            if (!$bc80ebcf21bfccd0$export$7debb50ef11d5e0b.isInteger(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                                    expected: "integer",
                                    received: "float",
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "min") {
                            var tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                            if (tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                                    minimum: check.value,
                                    type: "number",
                                    inclusive: check.inclusive,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            var tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                            if (tooBig) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                                    maximum: check.value,
                                    type: "number",
                                    inclusive: check.inclusive,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "multipleOf") {
                            if ($bc80ebcf21bfccd0$var$floatSafeRemainder(input.data, check.value) !== 0) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.not_multiple_of,
                                    multipleOf: check.value,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "finite") {
                            if (!Number.isFinite(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.not_finite,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "gte",
            value: function gte(value, message) {
                return this.setLimit("min", value, true, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
            }
        },
        {
            key: "gt",
            value: function gt(value, message) {
                return this.setLimit("min", value, false, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
            }
        },
        {
            key: "lte",
            value: function lte(value, message) {
                return this.setLimit("max", value, true, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
            }
        },
        {
            key: "lt",
            value: function lt(value, message) {
                return this.setLimit("max", value, false, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
            }
        },
        {
            key: "setLimit",
            value: function setLimit(kind, value, inclusive, message) {
                return new ZodNumber((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    checks: (0, $fLnyw._)(this._def.checks).concat([
                        {
                            kind: kind,
                            value: value,
                            inclusive: inclusive,
                            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                        }
                    ])
                }));
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodNumber((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    checks: (0, $fLnyw._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "int",
            value: function int(message) {
                return this._addCheck({
                    kind: "int",
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "positive",
            value: function positive(message) {
                return this._addCheck({
                    kind: "min",
                    value: 0,
                    inclusive: false,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "negative",
            value: function negative(message) {
                return this._addCheck({
                    kind: "max",
                    value: 0,
                    inclusive: false,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonpositive",
            value: function nonpositive(message) {
                return this._addCheck({
                    kind: "max",
                    value: 0,
                    inclusive: true,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonnegative",
            value: function nonnegative(message) {
                return this._addCheck({
                    kind: "min",
                    value: 0,
                    inclusive: true,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "multipleOf",
            value: function multipleOf(value, message) {
                return this._addCheck({
                    kind: "multipleOf",
                    value: value,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "finite",
            value: function finite(message) {
                return this._addCheck({
                    kind: "finite",
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "safe",
            value: function safe(message) {
                return this._addCheck({
                    kind: "min",
                    inclusive: true,
                    value: Number.MIN_SAFE_INTEGER,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                })._addCheck({
                    kind: "max",
                    inclusive: true,
                    value: Number.MAX_SAFE_INTEGER,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "minValue",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxValue",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        },
        {
            key: "isInt",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "int" || ch.kind === "multipleOf" && $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.isInteger(ch.value);
                });
            }
        },
        {
            key: "isFinite",
            get: function get() {
                var max = null, min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
                        else if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        } else if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return Number.isFinite(min) && Number.isFinite(max);
            }
        }
    ]);
    return ZodNumber;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$5b070a55c0c43e09.create = function(params) {
    return new $bc80ebcf21bfccd0$export$5b070a55c0c43e09((0, $8OnJk._)({
        checks: [],
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$67d741fd70ff98f4 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodBigInt, ZodType);
    var _super = (0, $6OZAO._)(ZodBigInt);
    function ZodBigInt() {
        (0, $978gY._)(this, ZodBigInt);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.min = _this.gte;
        _this.max = _this.lte;
        return _this;
    }
    (0, $kry2a._)(ZodBigInt, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = BigInt(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.bigint) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.bigint,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var ctx1 = undefined;
                var status = new $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            var tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                            if (tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                                    type: "bigint",
                                    minimum: check.value,
                                    inclusive: check.inclusive,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            var tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                            if (tooBig) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                                    type: "bigint",
                                    maximum: check.value,
                                    inclusive: check.inclusive,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "multipleOf") {
                            if (input.data % check.value !== BigInt(0)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.not_multiple_of,
                                    multipleOf: check.value,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "gte",
            value: function gte(value, message) {
                return this.setLimit("min", value, true, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
            }
        },
        {
            key: "gt",
            value: function gt(value, message) {
                return this.setLimit("min", value, false, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
            }
        },
        {
            key: "lte",
            value: function lte(value, message) {
                return this.setLimit("max", value, true, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
            }
        },
        {
            key: "lt",
            value: function lt(value, message) {
                return this.setLimit("max", value, false, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
            }
        },
        {
            key: "setLimit",
            value: function setLimit(kind, value, inclusive, message) {
                return new ZodBigInt((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    checks: (0, $fLnyw._)(this._def.checks).concat([
                        {
                            kind: kind,
                            value: value,
                            inclusive: inclusive,
                            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                        }
                    ])
                }));
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodBigInt((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    checks: (0, $fLnyw._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "positive",
            value: function positive(message) {
                return this._addCheck({
                    kind: "min",
                    value: BigInt(0),
                    inclusive: false,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "negative",
            value: function negative(message) {
                return this._addCheck({
                    kind: "max",
                    value: BigInt(0),
                    inclusive: false,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonpositive",
            value: function nonpositive(message) {
                return this._addCheck({
                    kind: "max",
                    value: BigInt(0),
                    inclusive: true,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonnegative",
            value: function nonnegative(message) {
                return this._addCheck({
                    kind: "min",
                    value: BigInt(0),
                    inclusive: true,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "multipleOf",
            value: function multipleOf(value, message) {
                return this._addCheck({
                    kind: "multipleOf",
                    value: value,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "minValue",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxValue",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        }
    ]);
    return ZodBigInt;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$67d741fd70ff98f4.create = function(params) {
    var _a;
    return new $bc80ebcf21bfccd0$export$67d741fd70ff98f4((0, $8OnJk._)({
        checks: [],
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$723d146f80596191 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodBoolean, ZodType);
    var _super = (0, $6OZAO._)(ZodBoolean);
    function ZodBoolean() {
        (0, $978gY._)(this, ZodBoolean);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodBoolean, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = Boolean(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.boolean) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.boolean,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodBoolean;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$723d146f80596191.create = function(params) {
    return new $bc80ebcf21bfccd0$export$723d146f80596191((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$e974be33bdc55521 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodDate, ZodType);
    var _super = (0, $6OZAO._)(ZodDate);
    function ZodDate() {
        (0, $978gY._)(this, ZodDate);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodDate, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = new Date(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.date) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.date,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                if (isNaN(input.data.getTime())) {
                    var ctx1 = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_date
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var status = new $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f();
                var ctx2 = undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            if (input.data.getTime() < check.value) {
                                ctx2 = this._getOrReturnCtx(input, ctx2);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx2, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                                    message: check.message,
                                    inclusive: true,
                                    exact: false,
                                    minimum: check.value,
                                    type: "date"
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            if (input.data.getTime() > check.value) {
                                ctx2 = this._getOrReturnCtx(input, ctx2);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx2, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                                    message: check.message,
                                    inclusive: true,
                                    exact: false,
                                    maximum: check.value,
                                    type: "date"
                                });
                                status.dirty();
                            }
                        } else $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: new Date(input.data.getTime())
                };
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodDate((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    checks: (0, $fLnyw._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "min",
            value: function min(minDate, message) {
                return this._addCheck({
                    kind: "min",
                    value: minDate.getTime(),
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "max",
            value: function max(maxDate, message) {
                return this._addCheck({
                    kind: "max",
                    value: maxDate.getTime(),
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "minDate",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min != null ? new Date(min) : null;
            }
        },
        {
            key: "maxDate",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max != null ? new Date(max) : null;
            }
        }
    ]);
    return ZodDate;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$e974be33bdc55521.create = function(params) {
    return new $bc80ebcf21bfccd0$export$e974be33bdc55521((0, $8OnJk._)({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodDate
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$bcc3b40f6b638044 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodSymbol, ZodType);
    var _super = (0, $6OZAO._)(ZodSymbol);
    function ZodSymbol() {
        (0, $978gY._)(this, ZodSymbol);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodSymbol, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.symbol) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.symbol,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodSymbol;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$bcc3b40f6b638044.create = function(params) {
    return new $bc80ebcf21bfccd0$export$bcc3b40f6b638044((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodSymbol
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$4e780e961c30340d = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodUndefined, ZodType);
    var _super = (0, $6OZAO._)(ZodUndefined);
    function ZodUndefined() {
        (0, $978gY._)(this, ZodUndefined);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodUndefined, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodUndefined;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$4e780e961c30340d.create = function(params) {
    return new $bc80ebcf21bfccd0$export$4e780e961c30340d((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodUndefined
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$a96281f914484f2d = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodNull, ZodType);
    var _super = (0, $6OZAO._)(ZodNull);
    function ZodNull() {
        (0, $978gY._)(this, ZodNull);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodNull, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.null) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.null,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodNull;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$a96281f914484f2d.create = function(params) {
    return new $bc80ebcf21bfccd0$export$a96281f914484f2d((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNull
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodAny, ZodType);
    var _super = (0, $6OZAO._)(ZodAny);
    function ZodAny() {
        (0, $978gY._)(this, ZodAny);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        _this._any = true;
        return _this;
    }
    (0, $kry2a._)(ZodAny, [
        {
            key: "_parse",
            value: function _parse(input) {
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodAny;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$b9d1edb536b4e4eb.create = function(params) {
    return new $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodAny
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$ef3b1bb1630977ae = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodUnknown, ZodType);
    var _super = (0, $6OZAO._)(ZodUnknown);
    function ZodUnknown() {
        (0, $978gY._)(this, ZodUnknown);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        // required
        _this._unknown = true;
        return _this;
    }
    (0, $kry2a._)(ZodUnknown, [
        {
            key: "_parse",
            value: function _parse(input) {
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodUnknown;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$ef3b1bb1630977ae.create = function(params) {
    return new $bc80ebcf21bfccd0$export$ef3b1bb1630977ae((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodUnknown
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodNever, ZodType);
    var _super = (0, $6OZAO._)(ZodNever);
    function ZodNever() {
        (0, $978gY._)(this, ZodNever);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodNever, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._getOrReturnCtx(input);
                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                    expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.never,
                    received: ctx.parsedType
                });
                return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
            }
        }
    ]);
    return ZodNever;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$1e576a20c3ce9fb5.create = function(params) {
    return new $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNever
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$7d39f5df85f21031 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodVoid, ZodType);
    var _super = (0, $6OZAO._)(ZodVoid);
    function ZodVoid() {
        (0, $978gY._)(this, ZodVoid);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodVoid, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.void,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodVoid;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$7d39f5df85f21031.create = function(params) {
    return new $bc80ebcf21bfccd0$export$7d39f5df85f21031((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodVoid
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$7acfc3e64785411 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodArray, ZodType);
    var _super = (0, $6OZAO._)(ZodArray);
    function ZodArray() {
        (0, $978gY._)(this, ZodArray);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodArray, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), ctx = _this__processInputParams.ctx, status = _this__processInputParams.status;
                var def = this._def;
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.array) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.array,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                if (def.exactLength !== null) {
                    var tooBig = ctx.data.length > def.exactLength.value;
                    var tooSmall = ctx.data.length < def.exactLength.value;
                    if (tooBig || tooSmall) {
                        $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                            code: tooBig ? $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big : $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                            minimum: tooSmall ? def.exactLength.value : undefined,
                            maximum: tooBig ? def.exactLength.value : undefined,
                            type: "array",
                            inclusive: true,
                            exact: true,
                            message: def.exactLength.message
                        });
                        status.dirty();
                    }
                }
                if (def.minLength !== null) {
                    if (ctx.data.length < def.minLength.value) {
                        $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                            minimum: def.minLength.value,
                            type: "array",
                            inclusive: true,
                            exact: false,
                            message: def.minLength.message
                        });
                        status.dirty();
                    }
                }
                if (def.maxLength !== null) {
                    if (ctx.data.length > def.maxLength.value) {
                        $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                            maximum: def.maxLength.value,
                            type: "array",
                            inclusive: true,
                            exact: false,
                            message: def.maxLength.message
                        });
                        status.dirty();
                    }
                }
                if (ctx.common.async) return Promise.all((0, $fLnyw._)(ctx.data).map(function(item, i) {
                    return def.type._parseAsync(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, item, ctx.path, i));
                })).then(function(result) {
                    return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeArray(status, result);
                });
                var result = (0, $fLnyw._)(ctx.data).map(function(item, i) {
                    return def.type._parseSync(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, item, ctx.path, i));
                });
                return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeArray(status, result);
            }
        },
        {
            key: "element",
            get: function get() {
                return this._def.type;
            }
        },
        {
            key: "min",
            value: function min(minLength, message) {
                return new ZodArray((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    minLength: {
                        value: minLength,
                        message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "max",
            value: function max(maxLength, message) {
                return new ZodArray((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    maxLength: {
                        value: maxLength,
                        message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "length",
            value: function length(len, message) {
                return new ZodArray((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    exactLength: {
                        value: len,
                        message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "nonempty",
            value: function nonempty(message) {
                return this.min(1, message);
            }
        }
    ]);
    return ZodArray;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$7acfc3e64785411.create = function(schema, params) {
    return new $bc80ebcf21bfccd0$export$7acfc3e64785411((0, $8OnJk._)({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodArray
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
function $bc80ebcf21bfccd0$var$deepPartialify(schema) {
    if (schema instanceof $bc80ebcf21bfccd0$export$736315c5b55efbad) {
        var newShape = {};
        for(var key in schema.shape){
            var fieldSchema = schema.shape[key];
            newShape[key] = $bc80ebcf21bfccd0$export$aa56fec1e9d629b8.create($bc80ebcf21bfccd0$var$deepPartialify(fieldSchema));
        }
        return new $bc80ebcf21bfccd0$export$736315c5b55efbad((0, $8E768._)((0, $8OnJk._)({}, schema._def), {
            shape: function() {
                return newShape;
            }
        }));
    } else if (schema instanceof $bc80ebcf21bfccd0$export$7acfc3e64785411) return new $bc80ebcf21bfccd0$export$7acfc3e64785411((0, $8E768._)((0, $8OnJk._)({}, schema._def), {
        type: $bc80ebcf21bfccd0$var$deepPartialify(schema.element)
    }));
    else if (schema instanceof $bc80ebcf21bfccd0$export$aa56fec1e9d629b8) return $bc80ebcf21bfccd0$export$aa56fec1e9d629b8.create($bc80ebcf21bfccd0$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $bc80ebcf21bfccd0$export$aaac0b8b429cef5) return $bc80ebcf21bfccd0$export$aaac0b8b429cef5.create($bc80ebcf21bfccd0$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3) return $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3.create(schema.items.map(function(item) {
        return $bc80ebcf21bfccd0$var$deepPartialify(item);
    }));
    else return schema;
}
var $bc80ebcf21bfccd0$export$736315c5b55efbad = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodObject, ZodType);
    var _super = (0, $6OZAO._)(ZodObject);
    function ZodObject() {
        (0, $978gY._)(this, ZodObject);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ _this.nonstrict = _this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ _this.augment = _this.extend;
        return _this;
    }
    (0, $kry2a._)(ZodObject, [
        {
            key: "_getCached",
            value: function _getCached() {
                if (this._cached !== null) return this._cached;
                var shape = this._def.shape();
                var keys = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(shape);
                return this._cached = {
                    shape: shape,
                    keys: keys
                };
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.object) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.object,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx1 = _this__processInputParams.ctx;
                var _this__getCached = this._getCached(), shape = _this__getCached.shape, shapeKeys = _this__getCached.keys;
                var extraKeys = [];
                if (!(this._def.catchall instanceof $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
                    for(var key in ctx1.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
                }
                var pairs = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = shapeKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key1 = _step.value;
                        var keyValidator = shape[key1];
                        var value = ctx1.data[key1];
                        pairs.push({
                            key: {
                                status: "valid",
                                value: key1
                            },
                            value: keyValidator._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx1, value, ctx1.path, key1)),
                            alwaysSet: key1 in ctx1.data
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this._def.catchall instanceof $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5) {
                    var unknownKeys = this._def.unknownKeys;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (unknownKeys === "passthrough") try {
                        for(var _iterator1 = extraKeys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var key2 = _step1.value;
                            pairs.push({
                                key: {
                                    status: "valid",
                                    value: key2
                                },
                                value: {
                                    status: "valid",
                                    value: ctx1.data[key2]
                                }
                            });
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    else if (unknownKeys === "strict") {
                        if (extraKeys.length > 0) {
                            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.unrecognized_keys,
                                keys: extraKeys
                            });
                            status.dirty();
                        }
                    } else if (unknownKeys === "strip") ;
                    else throw new Error("Internal ZodObject error: invalid unknownKeys value.");
                } else {
                    // run catchall validation
                    var catchall = this._def.catchall;
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = extraKeys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var key3 = _step2.value;
                            var value1 = ctx1.data[key3];
                            pairs.push({
                                key: {
                                    status: "valid",
                                    value: key3
                                },
                                value: catchall._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx1, value1, ctx1.path, key3) //, ctx.child(key), value, getParsedType(value)
                                ),
                                alwaysSet: key3 in ctx1.data
                            });
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
                if (ctx1.common.async) return Promise.resolve().then(/*#__PURE__*/ (0, $byzP8._)(function() {
                    var syncPairs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, key, _, _tmp, err;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                syncPairs = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = pairs[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                pair = _step.value;
                                return [
                                    4,
                                    pair.key
                                ];
                            case 3:
                                key = _state.sent();
                                _ = syncPairs.push;
                                _tmp = {
                                    key: key
                                };
                                return [
                                    4,
                                    pair.value
                                ];
                            case 4:
                                _.apply(syncPairs, [
                                    (_tmp.value = _state.sent(), _tmp.alwaysSet = pair.alwaysSet, _tmp)
                                ]);
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    syncPairs
                                ];
                        }
                    });
                })).then(function(syncPairs) {
                    return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
                });
                else return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
            }
        },
        {
            key: "shape",
            get: function get() {
                return this._def.shape();
            }
        },
        {
            key: "strict",
            value: function strict(message) {
                var _this = this;
                $bc80ebcf21bfccd0$var$errorUtil.errToObj;
                return new ZodObject((0, $8OnJk._)((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    unknownKeys: "strict"
                }), message !== undefined ? {
                    errorMap: function(issue, ctx) {
                        var _a, _b, _c, _d;
                        var defaultError = (_c = (_b = (_a = _this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys") return {
                            message: (_d = $bc80ebcf21bfccd0$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                        };
                        return {
                            message: defaultError
                        };
                    }
                } : {}));
            }
        },
        {
            key: "strip",
            value: function strip() {
                return new ZodObject((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    unknownKeys: "strip"
                }));
            }
        },
        {
            key: "passthrough",
            value: function passthrough() {
                return new ZodObject((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    unknownKeys: "passthrough"
                }));
            }
        },
        {
            // const AugmentFactory =
            //   <Def extends ZodObjectDef>(def: Def) =>
            //   <Augmentation extends ZodRawShape>(
            //     augmentation: Augmentation
            //   ): ZodObject<
            //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
            //     Def["unknownKeys"],
            //     Def["catchall"]
            //   > => {
            //     return new ZodObject({
            //       ...def,
            //       shape: () => ({
            //         ...def.shape(),
            //         ...augmentation,
            //       }),
            //     }) as any;
            //   };
            key: "extend",
            value: function extend(augmentation) {
                var _this = this;
                return new ZodObject((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    shape: function() {
                        return (0, $8OnJk._)({}, _this._def.shape(), augmentation);
                    }
                }));
            }
        },
        {
            /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ key: "merge",
            value: function merge(merging) {
                var _this = this;
                var merged = new ZodObject({
                    unknownKeys: merging._def.unknownKeys,
                    catchall: merging._def.catchall,
                    shape: function() {
                        return (0, $8OnJk._)({}, _this._def.shape(), merging._def.shape());
                    },
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodObject
                });
                return merged;
            }
        },
        {
            // merge<
            //   Incoming extends AnyZodObject,
            //   Augmentation extends Incoming["shape"],
            //   NewOutput extends {
            //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
            //       ? Augmentation[k]["_output"]
            //       : k extends keyof Output
            //       ? Output[k]
            //       : never;
            //   },
            //   NewInput extends {
            //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
            //       ? Augmentation[k]["_input"]
            //       : k extends keyof Input
            //       ? Input[k]
            //       : never;
            //   }
            // >(
            //   merging: Incoming
            // ): ZodObject<
            //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
            //   Incoming["_def"]["unknownKeys"],
            //   Incoming["_def"]["catchall"],
            //   NewOutput,
            //   NewInput
            // > {
            //   const merged: any = new ZodObject({
            //     unknownKeys: merging._def.unknownKeys,
            //     catchall: merging._def.catchall,
            //     shape: () =>
            //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
            //     typeName: ZodFirstPartyTypeKind.ZodObject,
            //   }) as any;
            //   return merged;
            // }
            key: "setKey",
            value: function setKey(key, schema) {
                return this.augment((0, $dxWQo._)({}, key, schema));
            }
        },
        {
            // merge<Incoming extends AnyZodObject>(
            //   merging: Incoming
            // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
            // ZodObject<
            //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
            //   Incoming["_def"]["unknownKeys"],
            //   Incoming["_def"]["catchall"]
            // > {
            //   // const mergedShape = objectUtil.mergeShapes(
            //   //   this._def.shape(),
            //   //   merging._def.shape()
            //   // );
            //   const merged: any = new ZodObject({
            //     unknownKeys: merging._def.unknownKeys,
            //     catchall: merging._def.catchall,
            //     shape: () =>
            //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
            //     typeName: ZodFirstPartyTypeKind.ZodObject,
            //   }) as any;
            //   return merged;
            // }
            key: "catchall",
            value: function catchall(index) {
                return new ZodObject((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    catchall: index
                }));
            }
        },
        {
            key: "pick",
            value: function pick(mask) {
                var _this = this;
                var shape = {};
                $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(mask).forEach(function(key) {
                    if (mask[key] && _this.shape[key]) shape[key] = _this.shape[key];
                });
                return new ZodObject((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    shape: function() {
                        return shape;
                    }
                }));
            }
        },
        {
            key: "omit",
            value: function omit(mask) {
                var _this = this;
                var shape = {};
                $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach(function(key) {
                    if (!mask[key]) shape[key] = _this.shape[key];
                });
                return new ZodObject((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    shape: function() {
                        return shape;
                    }
                }));
            }
        },
        {
            /**
     * @deprecated
     */ key: "deepPartial",
            value: function deepPartial() {
                return $bc80ebcf21bfccd0$var$deepPartialify(this);
            }
        },
        {
            key: "partial",
            value: function partial(mask) {
                var _this = this;
                var newShape = {};
                $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach(function(key) {
                    var fieldSchema = _this.shape[key];
                    if (mask && !mask[key]) newShape[key] = fieldSchema;
                    else newShape[key] = fieldSchema.optional();
                });
                return new ZodObject((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    shape: function() {
                        return newShape;
                    }
                }));
            }
        },
        {
            key: "required",
            value: function required(mask) {
                var _this = this;
                var newShape = {};
                $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach(function(key) {
                    if (mask && !mask[key]) newShape[key] = _this.shape[key];
                    else {
                        var fieldSchema = _this.shape[key];
                        var newField = fieldSchema;
                        while(newField instanceof $bc80ebcf21bfccd0$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                        newShape[key] = newField;
                    }
                });
                return new ZodObject((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    shape: function() {
                        return newShape;
                    }
                }));
            }
        },
        {
            key: "keyof",
            value: function keyof() {
                return $bc80ebcf21bfccd0$var$createZodEnum($bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(this.shape));
            }
        }
    ]);
    return ZodObject;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$736315c5b55efbad.create = function(shape, params) {
    return new $bc80ebcf21bfccd0$export$736315c5b55efbad((0, $8OnJk._)({
        shape: function() {
            return shape;
        },
        unknownKeys: "strip",
        catchall: $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5.create(),
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodObject
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
$bc80ebcf21bfccd0$export$736315c5b55efbad.strictCreate = function(shape, params) {
    return new $bc80ebcf21bfccd0$export$736315c5b55efbad((0, $8OnJk._)({
        shape: function() {
            return shape;
        },
        unknownKeys: "strict",
        catchall: $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5.create(),
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodObject
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
$bc80ebcf21bfccd0$export$736315c5b55efbad.lazycreate = function(shape, params) {
    return new $bc80ebcf21bfccd0$export$736315c5b55efbad((0, $8OnJk._)({
        shape: shape,
        unknownKeys: "strip",
        catchall: $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5.create(),
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodObject
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$a8b236cb5070a311 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodUnion, ZodType);
    var _super = (0, $6OZAO._)(ZodUnion);
    function ZodUnion() {
        (0, $978gY._)(this, ZodUnion);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodUnion, [
        {
            key: "_parse",
            value: function _parse(input) {
                var handleResults = function handleResults(results) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // return first issue-free validation if it exists
                        for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var result = _step.value;
                            if (result.result.status === "valid") return result.result;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = results[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var result1 = _step1.value;
                            if (result1.result.status === "dirty") {
                                var // add issues from dirty option
                                _ctx_common_issues;
                                (_ctx_common_issues = ctx.common.issues).push.apply(_ctx_common_issues, (0, $fLnyw._)(result1.ctx.common.issues));
                                return result1.result;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    // return invalid
                    var unionErrors = results.map(function(result) {
                        return new $bc80ebcf21bfccd0$export$f98dac4b251ab333(result.ctx.common.issues);
                    });
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_union,
                        unionErrors: unionErrors
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                };
                var ctx = this._processInputParams(input).ctx;
                var options = this._def.options;
                if (ctx.common.async) return Promise.all(options.map(function() {
                    var _ref = (0, $byzP8._)(function(option) {
                        var childCtx, _tmp;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    childCtx = (0, $8E768._)((0, $8OnJk._)({}, ctx), {
                                        common: (0, $8E768._)((0, $8OnJk._)({}, ctx.common), {
                                            issues: []
                                        }),
                                        parent: null
                                    });
                                    _tmp = {};
                                    return [
                                        4,
                                        option._parseAsync({
                                            data: ctx.data,
                                            path: ctx.path,
                                            parent: childCtx
                                        })
                                    ];
                                case 1:
                                    return [
                                        2,
                                        (_tmp.result = _state.sent(), _tmp.ctx = childCtx, _tmp)
                                    ];
                            }
                        });
                    });
                    return function(option) {
                        return _ref.apply(this, arguments);
                    };
                }())).then(handleResults);
                else {
                    var dirty = undefined;
                    var issues = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var option = _step.value;
                            var childCtx = (0, $8E768._)((0, $8OnJk._)({}, ctx), {
                                common: (0, $8E768._)((0, $8OnJk._)({}, ctx.common), {
                                    issues: []
                                }),
                                parent: null
                            });
                            var result = option._parseSync({
                                data: ctx.data,
                                path: ctx.path,
                                parent: childCtx
                            });
                            if (result.status === "valid") return result;
                            else if (result.status === "dirty" && !dirty) dirty = {
                                result: result,
                                ctx: childCtx
                            };
                            if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (dirty) {
                        var _ctx_common_issues;
                        (_ctx_common_issues = ctx.common.issues).push.apply(_ctx_common_issues, (0, $fLnyw._)(dirty.ctx.common.issues));
                        return dirty.result;
                    }
                    var unionErrors = issues.map(function(issues) {
                        return new $bc80ebcf21bfccd0$export$f98dac4b251ab333(issues);
                    });
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_union,
                        unionErrors: unionErrors
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.options;
            }
        }
    ]);
    return ZodUnion;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$a8b236cb5070a311.create = function(types, params) {
    return new $bc80ebcf21bfccd0$export$a8b236cb5070a311((0, $8OnJk._)({
        options: types,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodUnion
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
var $bc80ebcf21bfccd0$var$getDiscriminator = function(type) {
    if (type instanceof $bc80ebcf21bfccd0$export$378d0cfce37406e6) return $bc80ebcf21bfccd0$var$getDiscriminator(type.schema);
    else if (type instanceof $bc80ebcf21bfccd0$export$a60af00cc0ce2582) return $bc80ebcf21bfccd0$var$getDiscriminator(type.innerType());
    else if (type instanceof $bc80ebcf21bfccd0$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $bc80ebcf21bfccd0$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $bc80ebcf21bfccd0$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $bc80ebcf21bfccd0$export$bb19b37874861e7e) return $bc80ebcf21bfccd0$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $bc80ebcf21bfccd0$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $bc80ebcf21bfccd0$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
var $bc80ebcf21bfccd0$export$5ef2424805ac76a3 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodDiscriminatedUnion, ZodType);
    var _super = (0, $6OZAO._)(ZodDiscriminatedUnion);
    function ZodDiscriminatedUnion() {
        (0, $978gY._)(this, ZodDiscriminatedUnion);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodDiscriminatedUnion, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.object) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.object,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var discriminator = this.discriminator;
                var discriminatorValue = ctx.data[discriminator];
                var option = this.optionsMap.get(discriminatorValue);
                if (!option) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_union_discriminator,
                        options: Array.from(this.optionsMap.keys()),
                        path: [
                            discriminator
                        ]
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                if (ctx.common.async) return option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                else return option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "discriminator",
            get: function get() {
                return this._def.discriminator;
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.options;
            }
        },
        {
            key: "optionsMap",
            get: function get() {
                return this._def.optionsMap;
            }
        }
    ], [
        {
            key: "create",
            value: /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ function create(discriminator, options, params) {
                // Get all the valid discriminator values
                var optionsMap = new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // try {
                    for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var type = _step.value;
                        var discriminatorValues = $bc80ebcf21bfccd0$var$getDiscriminator(type.shape[discriminator]);
                        if (!discriminatorValues) throw new Error("A discriminator value for key `".concat(discriminator, "` could not be extracted from all schema options"));
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = discriminatorValues[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var value = _step1.value;
                                if (optionsMap.has(value)) throw new Error("Discriminator property ".concat(String(discriminator), " has duplicate value ").concat(String(value)));
                                optionsMap.set(value, type);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new ZodDiscriminatedUnion((0, $8OnJk._)({
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodDiscriminatedUnion,
                    discriminator: discriminator,
                    options: options,
                    optionsMap: optionsMap
                }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
            }
        }
    ]);
    return ZodDiscriminatedUnion;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
function $bc80ebcf21bfccd0$var$mergeValues(a, b) {
    var aType = $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(a);
    var bType = $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.object && bType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.object) {
        var bKeys = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(b);
        var sharedKeys = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(a).filter(function(key) {
            return bKeys.indexOf(key) !== -1;
        });
        var newObj = (0, $8OnJk._)({}, a, b);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = sharedKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var sharedValue = $bc80ebcf21bfccd0$var$mergeValues(a[key], b[key]);
                if (!sharedValue.valid) return {
                    valid: false
                };
                newObj[key] = sharedValue.data;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.array && bType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        var newArray = [];
        for(var index = 0; index < a.length; index++){
            var itemA = a[index];
            var itemB = b[index];
            var sharedValue1 = $bc80ebcf21bfccd0$var$mergeValues(itemA, itemB);
            if (!sharedValue1.valid) return {
                valid: false
            };
            newArray.push(sharedValue1.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.date && bType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
var $bc80ebcf21bfccd0$export$c02deaf0bb5203d4 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodIntersection, ZodType);
    var _super = (0, $6OZAO._)(ZodIntersection);
    function ZodIntersection() {
        (0, $978gY._)(this, ZodIntersection);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodIntersection, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                var handleParsed = function(parsedLeft, parsedRight) {
                    if ($bc80ebcf21bfccd0$export$afa861e3c5730743(parsedLeft) || $bc80ebcf21bfccd0$export$afa861e3c5730743(parsedRight)) return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                    var merged = $bc80ebcf21bfccd0$var$mergeValues(parsedLeft.value, parsedRight.value);
                    if (!merged.valid) {
                        $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_intersection_types
                        });
                        return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                    }
                    if ($bc80ebcf21bfccd0$export$910b6cdd390341b3(parsedLeft) || $bc80ebcf21bfccd0$export$910b6cdd390341b3(parsedRight)) status.dirty();
                    return {
                        status: status.value,
                        value: merged.data
                    };
                };
                if (ctx.common.async) return Promise.all([
                    this._def.left._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }),
                    this._def.right._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    })
                ]).then(function(param) {
                    var _param = (0, $8GFUW._)(param, 2), left = _param[0], right = _param[1];
                    return handleParsed(left, right);
                });
                else return handleParsed(this._def.left._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                }), this._def.right._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                }));
            }
        }
    ]);
    return ZodIntersection;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$c02deaf0bb5203d4.create = function(left, right, params) {
    return new $bc80ebcf21bfccd0$export$c02deaf0bb5203d4((0, $8OnJk._)({
        left: left,
        right: right,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodIntersection
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodTuple, ZodType);
    var _super = (0, $6OZAO._)(ZodTuple);
    function ZodTuple() {
        (0, $978gY._)(this, ZodTuple);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodTuple, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.array) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.array,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                if (ctx.data.length < this._def.items.length) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                        minimum: this._def.items.length,
                        inclusive: true,
                        exact: false,
                        type: "array"
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var rest = this._def.rest;
                if (!rest && ctx.data.length > this._def.items.length) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                        maximum: this._def.items.length,
                        inclusive: true,
                        exact: false,
                        type: "array"
                    });
                    status.dirty();
                }
                var items = (0, $fLnyw._)(ctx.data).map(function(item, itemIndex) {
                    var schema = _this._def.items[itemIndex] || _this._def.rest;
                    if (!schema) return null;
                    return schema._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
                }).filter(function(x) {
                    return !!x;
                }); // filter nulls
                if (ctx.common.async) return Promise.all(items).then(function(results) {
                    return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeArray(status, results);
                });
                else return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeArray(status, items);
            }
        },
        {
            key: "items",
            get: function get() {
                return this._def.items;
            }
        },
        {
            key: "rest",
            value: function rest(rest) {
                return new ZodTuple((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    rest: rest
                }));
            }
        }
    ]);
    return ZodTuple;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$e2a18bb771d8e6a3.create = function(schemas, params) {
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3((0, $8OnJk._)({
        items: schemas,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodTuple,
        rest: null
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$a2acc09968cb4b7f = /*#__PURE__*/ function(ZodType1) {
    "use strict";
    (0, $ftJVG._)(ZodRecord, ZodType1);
    var _super = (0, $6OZAO._)(ZodRecord);
    function ZodRecord() {
        (0, $978gY._)(this, ZodRecord);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodRecord, [
        {
            key: "keySchema",
            get: function get() {
                return this._def.keyType;
            }
        },
        {
            key: "valueSchema",
            get: function get() {
                return this._def.valueType;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.object) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.object,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var pairs = [];
                var keyType = this._def.keyType;
                var valueType = this._def.valueType;
                for(var key in ctx.data)pairs.push({
                    key: keyType._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
                    value: valueType._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
                });
                if (ctx.common.async) return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
                else return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
            }
        },
        {
            key: "element",
            get: function get() {
                return this._def.valueType;
            }
        }
    ], [
        {
            key: "create",
            value: function create(first, second, third) {
                if (second instanceof $bc80ebcf21bfccd0$export$19342e026b58ebb7) return new ZodRecord((0, $8OnJk._)({
                    keyType: first,
                    valueType: second,
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodRecord
                }, $bc80ebcf21bfccd0$var$processCreateParams(third)));
                return new ZodRecord((0, $8OnJk._)({
                    keyType: $bc80ebcf21bfccd0$export$1230eb29b8d3b502.create(),
                    valueType: first,
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodRecord
                }, $bc80ebcf21bfccd0$var$processCreateParams(second)));
            }
        }
    ]);
    return ZodRecord;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
var $bc80ebcf21bfccd0$export$163b6a2b712d9542 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodMap, ZodType);
    var _super = (0, $6OZAO._)(ZodMap);
    function ZodMap() {
        (0, $978gY._)(this, ZodMap);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodMap, [
        {
            key: "keySchema",
            get: function get() {
                return this._def.keyType;
            }
        },
        {
            key: "valueSchema",
            get: function get() {
                return this._def.valueType;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.map) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.map,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var keyType = this._def.keyType;
                var valueType = this._def.valueType;
                var pairs = (0, $fLnyw._)(ctx.data.entries()).map(function(param, index) {
                    var _param = (0, $8GFUW._)(param, 2), key = _param[0], value = _param[1];
                    return {
                        key: keyType._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, key, ctx.path, [
                            index,
                            "key"
                        ])),
                        value: valueType._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, value, ctx.path, [
                            index,
                            "value"
                        ]))
                    };
                });
                if (ctx.common.async) {
                    var finalMap = new Map();
                    return Promise.resolve().then(/*#__PURE__*/ (0, $byzP8._)(function() {
                        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, key, value, err;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        7,
                                        8,
                                        9
                                    ]);
                                    _iterator = pairs[Symbol.iterator]();
                                    _state.label = 2;
                                case 2:
                                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                        3,
                                        6
                                    ];
                                    pair = _step.value;
                                    return [
                                        4,
                                        pair.key
                                    ];
                                case 3:
                                    key = _state.sent();
                                    return [
                                        4,
                                        pair.value
                                    ];
                                case 4:
                                    value = _state.sent();
                                    if (key.status === "aborted" || value.status === "aborted") return [
                                        2,
                                        $bc80ebcf21bfccd0$export$9a105a556e65c2c0
                                    ];
                                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                                    finalMap.set(key.value, value.value);
                                    _state.label = 5;
                                case 5:
                                    _iteratorNormalCompletion = true;
                                    return [
                                        3,
                                        2
                                    ];
                                case 6:
                                    return [
                                        3,
                                        9
                                    ];
                                case 7:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        9
                                    ];
                                case 8:
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 9:
                                    return [
                                        2,
                                        {
                                            status: status.value,
                                            value: finalMap
                                        }
                                    ];
                            }
                        });
                    }));
                } else {
                    var finalMap1 = new Map();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var pair = _step.value;
                            var key = pair.key;
                            var value = pair.value;
                            if (key.status === "aborted" || value.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                            if (key.status === "dirty" || value.status === "dirty") status.dirty();
                            finalMap1.set(key.value, value.value);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return {
                        status: status.value,
                        value: finalMap1
                    };
                }
            }
        }
    ]);
    return ZodMap;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$163b6a2b712d9542.create = function(keyType, valueType, params) {
    return new $bc80ebcf21bfccd0$export$163b6a2b712d9542((0, $8OnJk._)({
        valueType: valueType,
        keyType: keyType,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodMap
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$977057706f816712 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodSet, ZodType);
    var _super = (0, $6OZAO._)(ZodSet);
    function ZodSet() {
        (0, $978gY._)(this, ZodSet);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodSet, [
        {
            key: "_parse",
            value: function _parse(input) {
                var finalizeSet = function finalizeSet(elements) {
                    var parsedSet = new Set();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            if (element.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                            if (element.status === "dirty") status.dirty();
                            parsedSet.add(element.value);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return {
                        status: status.value,
                        value: parsedSet
                    };
                };
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.set) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.set,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var def = this._def;
                if (def.minSize !== null) {
                    if (ctx.data.size < def.minSize.value) {
                        $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                            minimum: def.minSize.value,
                            type: "set",
                            inclusive: true,
                            exact: false,
                            message: def.minSize.message
                        });
                        status.dirty();
                    }
                }
                if (def.maxSize !== null) {
                    if (ctx.data.size > def.maxSize.value) {
                        $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                            maximum: def.maxSize.value,
                            type: "set",
                            inclusive: true,
                            exact: false,
                            message: def.maxSize.message
                        });
                        status.dirty();
                    }
                }
                var valueType = this._def.valueType;
                var elements = (0, $fLnyw._)(ctx.data.values()).map(function(item, i) {
                    return valueType._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, item, ctx.path, i));
                });
                if (ctx.common.async) return Promise.all(elements).then(function(elements) {
                    return finalizeSet(elements);
                });
                else return finalizeSet(elements);
            }
        },
        {
            key: "min",
            value: function min(minSize, message) {
                return new ZodSet((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    minSize: {
                        value: minSize,
                        message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "max",
            value: function max(maxSize, message) {
                return new ZodSet((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    maxSize: {
                        value: maxSize,
                        message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "size",
            value: function size(size, message) {
                return this.min(size, message).max(size, message);
            }
        },
        {
            key: "nonempty",
            value: function nonempty(message) {
                return this.min(1, message);
            }
        }
    ]);
    return ZodSet;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$977057706f816712.create = function(valueType, params) {
    return new $bc80ebcf21bfccd0$export$977057706f816712((0, $8OnJk._)({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodSet
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$d4602ba55673f53c = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodFunction, ZodType);
    var _super = (0, $6OZAO._)(ZodFunction);
    function ZodFunction() {
        (0, $978gY._)(this, ZodFunction);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.validate = _this.implement;
        return _this;
    }
    (0, $kry2a._)(ZodFunction, [
        {
            key: "_parse",
            value: function _parse(input) {
                var makeArgsIssue = function makeArgsIssue(args, error) {
                    return $bc80ebcf21bfccd0$export$244a85fde9c419ed({
                        data: args,
                        path: ctx.path,
                        errorMaps: [
                            ctx.common.contextualErrorMap,
                            ctx.schemaErrorMap,
                            $bc80ebcf21bfccd0$export$32f27c719778d4c4(),
                            $bc80ebcf21bfccd0$export$341b0b6e0a6f5099
                        ].filter(function(x) {
                            return !!x;
                        }),
                        issueData: {
                            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_arguments,
                            argumentsError: error
                        }
                    });
                };
                var makeReturnsIssue = function makeReturnsIssue(returns, error) {
                    return $bc80ebcf21bfccd0$export$244a85fde9c419ed({
                        data: returns,
                        path: ctx.path,
                        errorMaps: [
                            ctx.common.contextualErrorMap,
                            ctx.schemaErrorMap,
                            $bc80ebcf21bfccd0$export$32f27c719778d4c4(),
                            $bc80ebcf21bfccd0$export$341b0b6e0a6f5099
                        ].filter(function(x) {
                            return !!x;
                        }),
                        issueData: {
                            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_return_type,
                            returnTypeError: error
                        }
                    });
                };
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.function) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.function,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var params = {
                    errorMap: ctx.common.contextualErrorMap
                };
                var fn = ctx.data;
                if (this._def.returns instanceof $bc80ebcf21bfccd0$export$3f196b0127d6e50a) {
                    // Would love a way to avoid disabling this rule, but we need
                    // an alias (using an arrow function was what caused 2651).
                    // eslint-disable-next-line @typescript-eslint/no-this-alias
                    var me = this;
                    return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(/*#__PURE__*/ (0, $byzP8._)(function() {
                        var _len, args, _key, error, parsedArgs, result, parsedReturns;
                        var _arguments = arguments;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                        args[_key] = _arguments[_key];
                                    }
                                    error = new $bc80ebcf21bfccd0$export$f98dac4b251ab333([]);
                                    return [
                                        4,
                                        me._def.args.parseAsync(args, params).catch(function(e) {
                                            error.addIssue(makeArgsIssue(args, e));
                                            throw error;
                                        })
                                    ];
                                case 1:
                                    parsedArgs = _state.sent();
                                    return [
                                        4,
                                        Reflect.apply(fn, this, parsedArgs)
                                    ];
                                case 2:
                                    result = _state.sent();
                                    return [
                                        4,
                                        me._def.returns._def.type.parseAsync(result, params).catch(function(e) {
                                            error.addIssue(makeReturnsIssue(result, e));
                                            throw error;
                                        })
                                    ];
                                case 3:
                                    parsedReturns = _state.sent();
                                    return [
                                        2,
                                        parsedReturns
                                    ];
                            }
                        });
                    }));
                } else {
                    // Would love a way to avoid disabling this rule, but we need
                    // an alias (using an arrow function was what caused 2651).
                    // eslint-disable-next-line @typescript-eslint/no-this-alias
                    var me1 = this;
                    return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var parsedArgs = me1._def.args.safeParse(args, params);
                        if (!parsedArgs.success) throw new $bc80ebcf21bfccd0$export$f98dac4b251ab333([
                            makeArgsIssue(args, parsedArgs.error)
                        ]);
                        var result = Reflect.apply(fn, this, parsedArgs.data);
                        var parsedReturns = me1._def.returns.safeParse(result, params);
                        if (!parsedReturns.success) throw new $bc80ebcf21bfccd0$export$f98dac4b251ab333([
                            makeReturnsIssue(result, parsedReturns.error)
                        ]);
                        return parsedReturns.data;
                    });
                }
            }
        },
        {
            key: "parameters",
            value: function parameters() {
                return this._def.args;
            }
        },
        {
            key: "returnType",
            value: function returnType() {
                return this._def.returns;
            }
        },
        {
            key: "args",
            value: function args() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                return new ZodFunction((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    args: $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3.create(items).rest($bc80ebcf21bfccd0$export$ef3b1bb1630977ae.create())
                }));
            }
        },
        {
            key: "returns",
            value: function returns(returnType) {
                return new ZodFunction((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    returns: returnType
                }));
            }
        },
        {
            key: "implement",
            value: function implement(func) {
                var validatedFunc = this.parse(func);
                return validatedFunc;
            }
        },
        {
            key: "strictImplement",
            value: function strictImplement(func) {
                var validatedFunc = this.parse(func);
                return validatedFunc;
            }
        }
    ], [
        {
            key: "create",
            value: function create(args, returns, params) {
                return new ZodFunction((0, $8OnJk._)({
                    args: args ? args : $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3.create([]).rest($bc80ebcf21bfccd0$export$ef3b1bb1630977ae.create()),
                    returns: returns || $bc80ebcf21bfccd0$export$ef3b1bb1630977ae.create(),
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodFunction
                }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
            }
        }
    ]);
    return ZodFunction;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
var $bc80ebcf21bfccd0$export$378d0cfce37406e6 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodLazy, ZodType);
    var _super = (0, $6OZAO._)(ZodLazy);
    function ZodLazy() {
        (0, $978gY._)(this, ZodLazy);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodLazy, [
        {
            key: "schema",
            get: function get() {
                return this._def.getter();
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var lazySchema = this._def.getter();
                return lazySchema._parse({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        }
    ]);
    return ZodLazy;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$378d0cfce37406e6.create = function(getter, params) {
    return new $bc80ebcf21bfccd0$export$378d0cfce37406e6((0, $8OnJk._)({
        getter: getter,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodLazy
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$7e44096782a165d3 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodLiteral, ZodType);
    var _super = (0, $6OZAO._)(ZodLiteral);
    function ZodLiteral() {
        (0, $978gY._)(this, ZodLiteral);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodLiteral, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (input.data !== this._def.value) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        received: ctx.data,
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_literal,
                        expected: this._def.value
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return {
                    status: "valid",
                    value: input.data
                };
            }
        },
        {
            key: "value",
            get: function get() {
                return this._def.value;
            }
        }
    ]);
    return ZodLiteral;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$7e44096782a165d3.create = function(value, params) {
    return new $bc80ebcf21bfccd0$export$7e44096782a165d3((0, $8OnJk._)({
        value: value,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodLiteral
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
function $bc80ebcf21bfccd0$var$createZodEnum(values, params) {
    return new $bc80ebcf21bfccd0$export$d325d1f0e1c20179((0, $8OnJk._)({
        values: values,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEnum
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
}
var $bc80ebcf21bfccd0$export$d325d1f0e1c20179 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodEnum, ZodType);
    var _super = (0, $6OZAO._)(ZodEnum);
    function ZodEnum() {
        (0, $978gY._)(this, ZodEnum);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodEnum, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (typeof input.data !== "string") {
                    var ctx = this._getOrReturnCtx(input);
                    var expectedValues = this._def.values;
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        expected: $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.joinValues(expectedValues),
                        received: ctx.parsedType,
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                if (this._def.values.indexOf(input.data) === -1) {
                    var ctx1 = this._getOrReturnCtx(input);
                    var expectedValues1 = this._def.values;
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                        received: ctx1.data,
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_enum_value,
                        options: expectedValues1
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.values;
            }
        },
        {
            key: "enum",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "Values",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "Enum",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "extract",
            value: function extract(values) {
                return ZodEnum.create(values);
            }
        },
        {
            key: "exclude",
            value: function exclude(values) {
                return ZodEnum.create(this.options.filter(function(opt) {
                    return !values.includes(opt);
                }));
            }
        }
    ]);
    return ZodEnum;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$d325d1f0e1c20179.create = $bc80ebcf21bfccd0$var$createZodEnum;
var $bc80ebcf21bfccd0$export$370b2e8d6d6f5c56 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodNativeEnum, ZodType);
    var _super = (0, $6OZAO._)(ZodNativeEnum);
    function ZodNativeEnum() {
        (0, $978gY._)(this, ZodNativeEnum);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodNativeEnum, [
        {
            key: "_parse",
            value: function _parse(input) {
                var nativeEnumValues = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
                var ctx = this._getOrReturnCtx(input);
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.string && ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.number) {
                    var expectedValues = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        expected: $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.joinValues(expectedValues),
                        received: ctx.parsedType,
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                if (nativeEnumValues.indexOf(input.data) === -1) {
                    var expectedValues1 = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        received: ctx.data,
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_enum_value,
                        options: expectedValues1
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        },
        {
            key: "enum",
            get: function get() {
                return this._def.values;
            }
        }
    ]);
    return ZodNativeEnum;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$370b2e8d6d6f5c56.create = function(values, params) {
    return new $bc80ebcf21bfccd0$export$370b2e8d6d6f5c56((0, $8OnJk._)({
        values: values,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNativeEnum
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$3f196b0127d6e50a = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodPromise, ZodType);
    var _super = (0, $6OZAO._)(ZodPromise);
    function ZodPromise() {
        (0, $978gY._)(this, ZodPromise);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodPromise, [
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.type;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.promise && ctx.common.async === false) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.promise,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var promisified = ctx.parsedType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(promisified.then(function(data) {
                    return _this._def.type.parseAsync(data, {
                        path: ctx.path,
                        errorMap: ctx.common.contextualErrorMap
                    });
                }));
            }
        }
    ]);
    return ZodPromise;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$3f196b0127d6e50a.create = function(schema, params) {
    return new $bc80ebcf21bfccd0$export$3f196b0127d6e50a((0, $8OnJk._)({
        type: schema,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodPromise
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$a60af00cc0ce2582 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodEffects, ZodType);
    var _super = (0, $6OZAO._)(ZodEffects);
    function ZodEffects() {
        (0, $978gY._)(this, ZodEffects);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodEffects, [
        {
            key: "innerType",
            value: function innerType() {
                return this._def.schema;
            }
        },
        {
            key: "sourceType",
            value: function sourceType() {
                return this._def.schema._def.typeName === $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                var effect = this._def.effect || null;
                var checkCtx = {
                    addIssue: function(arg) {
                        $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, arg);
                        if (arg.fatal) status.abort();
                        else status.dirty();
                    },
                    get path () {
                        return ctx.path;
                    }
                };
                checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
                if (effect.type === "preprocess") {
                    var processed = effect.transform(ctx.data, checkCtx);
                    if (ctx.common.issues.length) return {
                        status: "dirty",
                        value: ctx.data
                    };
                    if (ctx.common.async) return Promise.resolve(processed).then(function(processed) {
                        return _this._def.schema._parseAsync({
                            data: processed,
                            path: ctx.path,
                            parent: ctx
                        });
                    });
                    else return this._def.schema._parseSync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx
                    });
                }
                if (effect.type === "refinement") {
                    var executeRefinement = function(acc) {
                        var result = effect.refinement(acc, checkCtx);
                        if (ctx.common.async) return Promise.resolve(result);
                        if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                        return acc;
                    };
                    if (ctx.common.async === false) {
                        var inner = this._def.schema._parseSync({
                            data: ctx.data,
                            path: ctx.path,
                            parent: ctx
                        });
                        if (inner.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                        if (inner.status === "dirty") status.dirty();
                        // return value is ignored
                        executeRefinement(inner.value);
                        return {
                            status: status.value,
                            value: inner.value
                        };
                    } else return this._def.schema._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }).then(function(inner) {
                        if (inner.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                        if (inner.status === "dirty") status.dirty();
                        return executeRefinement(inner.value).then(function() {
                            return {
                                status: status.value,
                                value: inner.value
                            };
                        });
                    });
                }
                if (effect.type === "transform") {
                    if (ctx.common.async === false) {
                        var base = this._def.schema._parseSync({
                            data: ctx.data,
                            path: ctx.path,
                            parent: ctx
                        });
                        if (!$bc80ebcf21bfccd0$export$1ea939691cdc45b8(base)) return base;
                        var result = effect.transform(base.value, checkCtx);
                        if (result instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
                        return {
                            status: status.value,
                            value: result
                        };
                    } else return this._def.schema._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }).then(function(base) {
                        if (!$bc80ebcf21bfccd0$export$1ea939691cdc45b8(base)) return base;
                        return Promise.resolve(effect.transform(base.value, checkCtx)).then(function(result) {
                            return {
                                status: status.value,
                                value: result
                            };
                        });
                    });
                }
                $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(effect);
            }
        }
    ]);
    return ZodEffects;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$a60af00cc0ce2582.create = function(schema, effect, params) {
    return new $bc80ebcf21bfccd0$export$a60af00cc0ce2582((0, $8OnJk._)({
        schema: schema,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEffects,
        effect: effect
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
$bc80ebcf21bfccd0$export$a60af00cc0ce2582.createWithPreprocess = function(preprocess, schema, params) {
    return new $bc80ebcf21bfccd0$export$a60af00cc0ce2582((0, $8OnJk._)({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEffects
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$aa56fec1e9d629b8 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodOptional, ZodType);
    var _super = (0, $6OZAO._)(ZodOptional);
    function ZodOptional() {
        (0, $978gY._)(this, ZodOptional);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodOptional, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined) return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(undefined);
                return this._def.innerType._parse(input);
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodOptional;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$aa56fec1e9d629b8.create = function(type, params) {
    return new $bc80ebcf21bfccd0$export$aa56fec1e9d629b8((0, $8OnJk._)({
        innerType: type,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodOptional
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$aaac0b8b429cef5 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodNullable, ZodType);
    var _super = (0, $6OZAO._)(ZodNullable);
    function ZodNullable() {
        (0, $978gY._)(this, ZodNullable);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodNullable, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.null) return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(null);
                return this._def.innerType._parse(input);
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodNullable;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$aaac0b8b429cef5.create = function(type, params) {
    return new $bc80ebcf21bfccd0$export$aaac0b8b429cef5((0, $8OnJk._)({
        innerType: type,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNullable
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$bb19b37874861e7e = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodDefault, ZodType);
    var _super = (0, $6OZAO._)(ZodDefault);
    function ZodDefault() {
        (0, $978gY._)(this, ZodDefault);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodDefault, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var data = ctx.data;
                if (ctx.parsedType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
                return this._def.innerType._parse({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "removeDefault",
            value: function removeDefault() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodDefault;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$bb19b37874861e7e.create = function(type, params) {
    return new $bc80ebcf21bfccd0$export$bb19b37874861e7e((0, $8OnJk._)({
        innerType: type,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : function() {
            return params.default;
        }
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$75a44ec6249ac76b = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodCatch, ZodType);
    var _super = (0, $6OZAO._)(ZodCatch);
    function ZodCatch() {
        (0, $978gY._)(this, ZodCatch);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodCatch, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var ctx = this._processInputParams(input).ctx;
                // newCtx is used to not collect issues from inner types in ctx
                var newCtx = (0, $8E768._)((0, $8OnJk._)({}, ctx), {
                    common: (0, $8E768._)((0, $8OnJk._)({}, ctx.common), {
                        issues: []
                    })
                });
                var result = this._def.innerType._parse({
                    data: newCtx.data,
                    path: newCtx.path,
                    parent: (0, $8OnJk._)({}, newCtx)
                });
                if ($bc80ebcf21bfccd0$export$aefee5ebe1dcfd9e(result)) return result.then(function(result) {
                    return {
                        status: "valid",
                        value: result.status === "valid" ? result.value : _this._def.catchValue({
                            get error () {
                                return new $bc80ebcf21bfccd0$export$f98dac4b251ab333(newCtx.common.issues);
                            },
                            input: newCtx.data
                        })
                    };
                });
                else return {
                    status: "valid",
                    value: result.status === "valid" ? result.value : this._def.catchValue({
                        get error () {
                            return new $bc80ebcf21bfccd0$export$f98dac4b251ab333(newCtx.common.issues);
                        },
                        input: newCtx.data
                    })
                };
            }
        },
        {
            key: "removeCatch",
            value: function removeCatch() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodCatch;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$75a44ec6249ac76b.create = function(type, params) {
    return new $bc80ebcf21bfccd0$export$75a44ec6249ac76b((0, $8OnJk._)({
        innerType: type,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : function() {
            return params.catch;
        }
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$26ccfa0145e8511f = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodNaN, ZodType);
    var _super = (0, $6OZAO._)(ZodNaN);
    function ZodNaN() {
        (0, $978gY._)(this, ZodNaN);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodNaN, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.nan) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.nan,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return {
                    status: "valid",
                    value: input.data
                };
            }
        }
    ]);
    return ZodNaN;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$26ccfa0145e8511f.create = function(params) {
    return new $bc80ebcf21bfccd0$export$26ccfa0145e8511f((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNaN
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$cf2deea74cde46b4 = Symbol("zod_brand");
var $bc80ebcf21bfccd0$export$66b0c798a395271f = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodBranded, ZodType);
    var _super = (0, $6OZAO._)(ZodBranded);
    function ZodBranded() {
        (0, $978gY._)(this, ZodBranded);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodBranded, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var data = ctx.data;
                return this._def.type._parse({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.type;
            }
        }
    ]);
    return ZodBranded;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
var $bc80ebcf21bfccd0$export$a3c3ef8a0e95c6da = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodPipeline, ZodType);
    var _super = (0, $6OZAO._)(ZodPipeline);
    function ZodPipeline() {
        (0, $978gY._)(this, ZodPipeline);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodPipeline, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.common.async) {
                    var _this = this;
                    var handleAsync = function() {
                        var _ref = (0, $byzP8._)(function() {
                            var inResult;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this._def.in._parseAsync({
                                                data: ctx.data,
                                                path: ctx.path,
                                                parent: ctx
                                            })
                                        ];
                                    case 1:
                                        inResult = _state.sent();
                                        if (inResult.status === "aborted") return [
                                            2,
                                            $bc80ebcf21bfccd0$export$9a105a556e65c2c0
                                        ];
                                        if (inResult.status === "dirty") {
                                            status.dirty();
                                            return [
                                                2,
                                                $bc80ebcf21bfccd0$export$325a211da9693fcf(inResult.value)
                                            ];
                                        } else return [
                                            2,
                                            _this._def.out._parseAsync({
                                                data: inResult.value,
                                                path: ctx.path,
                                                parent: ctx
                                            })
                                        ];
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function handleAsync() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    return handleAsync();
                } else {
                    var inResult = this._def.in._parseSync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    });
                    if (inResult.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                    if (inResult.status === "dirty") {
                        status.dirty();
                        return {
                            status: "dirty",
                            value: inResult.value
                        };
                    } else return this._def.out._parseSync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx
                    });
                }
            }
        }
    ], [
        {
            key: "create",
            value: function create(a, b) {
                return new ZodPipeline({
                    in: a,
                    out: b,
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodPipeline
                });
            }
        }
    ]);
    return ZodPipeline;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
var $bc80ebcf21bfccd0$export$5d1f7ef05c4e493a = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodReadonly, ZodType);
    var _super = (0, $6OZAO._)(ZodReadonly);
    function ZodReadonly() {
        (0, $978gY._)(this, ZodReadonly);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodReadonly, [
        {
            key: "_parse",
            value: function _parse(input) {
                var result = this._def.innerType._parse(input);
                if ($bc80ebcf21bfccd0$export$1ea939691cdc45b8(result)) result.value = Object.freeze(result.value);
                return result;
            }
        }
    ]);
    return ZodReadonly;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$5d1f7ef05c4e493a.create = function(type, params) {
    return new $bc80ebcf21bfccd0$export$5d1f7ef05c4e493a((0, $8OnJk._)({
        innerType: type,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodReadonly
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$4c00f665f0d4b443 = function(check) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, /*
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal = arguments.length > 2 ? arguments[2] : void 0;
    if (check) return $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb.create().superRefine(function(data, ctx) {
        var _a, _b;
        if (!check(data)) {
            var p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            var _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            var p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue((0, $8E768._)((0, $8OnJk._)({
                code: "custom"
            }, p2), {
                fatal: _fatal
            }));
        }
    });
    return $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb.create();
};
var $bc80ebcf21bfccd0$export$1ee8ee30835eab8b = {
    object: $bc80ebcf21bfccd0$export$736315c5b55efbad.lazycreate
};
var $bc80ebcf21bfccd0$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($bc80ebcf21bfccd0$export$558106ce543bd011 || ($bc80ebcf21bfccd0$export$558106ce543bd011 = {}));
var $bc80ebcf21bfccd0$export$3d916e7c22dbd8b5 = function(// const instanceOfType = <T extends new (...args: any[]) => any>(
cls) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        message: "Input not instance of ".concat(cls.name)
    };
    return $bc80ebcf21bfccd0$export$4c00f665f0d4b443(function(data) {
        return data instanceof cls;
    }, params);
};
var $bc80ebcf21bfccd0$export$22b082955e083ec3 = $bc80ebcf21bfccd0$export$1230eb29b8d3b502.create;
var $bc80ebcf21bfccd0$export$98e628dec113755e = $bc80ebcf21bfccd0$export$5b070a55c0c43e09.create;
var $bc80ebcf21bfccd0$export$9e06de0973666692 = $bc80ebcf21bfccd0$export$26ccfa0145e8511f.create;
var $bc80ebcf21bfccd0$export$a0f65b52274bcc00 = $bc80ebcf21bfccd0$export$67d741fd70ff98f4.create;
var $bc80ebcf21bfccd0$export$4a21f16c33752377 = $bc80ebcf21bfccd0$export$723d146f80596191.create;
var $bc80ebcf21bfccd0$export$324d90190a8b822a = $bc80ebcf21bfccd0$export$e974be33bdc55521.create;
var $bc80ebcf21bfccd0$export$8f701197936bc2a6 = $bc80ebcf21bfccd0$export$bcc3b40f6b638044.create;
var $bc80ebcf21bfccd0$export$1db45310990710a5 = $bc80ebcf21bfccd0$export$4e780e961c30340d.create;
var $bc80ebcf21bfccd0$export$7b1b591b262c240 = $bc80ebcf21bfccd0$export$a96281f914484f2d.create;
var $bc80ebcf21bfccd0$export$4154a199d7d90455 = $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb.create;
var $bc80ebcf21bfccd0$export$19282c40b967aec6 = $bc80ebcf21bfccd0$export$ef3b1bb1630977ae.create;
var $bc80ebcf21bfccd0$export$b3e22bcfd64c1022 = $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5.create;
var $bc80ebcf21bfccd0$export$490e536ee7389aeb = $bc80ebcf21bfccd0$export$7d39f5df85f21031.create;
var $bc80ebcf21bfccd0$export$2f23118c22fb2630 = $bc80ebcf21bfccd0$export$7acfc3e64785411.create;
var $bc80ebcf21bfccd0$export$be5493f9613cbbe = $bc80ebcf21bfccd0$export$736315c5b55efbad.create;
var $bc80ebcf21bfccd0$export$8fb0df5f40d0b477 = $bc80ebcf21bfccd0$export$736315c5b55efbad.strictCreate;
var $bc80ebcf21bfccd0$export$971dd5b0dfd021b6 = $bc80ebcf21bfccd0$export$a8b236cb5070a311.create;
var $bc80ebcf21bfccd0$export$4b888e40c4ee26dd = $bc80ebcf21bfccd0$export$5ef2424805ac76a3.create;
var $bc80ebcf21bfccd0$export$bc86dfbf7795668c = $bc80ebcf21bfccd0$export$c02deaf0bb5203d4.create;
var $bc80ebcf21bfccd0$export$65e3907585753458 = $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3.create;
var $bc80ebcf21bfccd0$export$e5185e241753e543 = $bc80ebcf21bfccd0$export$a2acc09968cb4b7f.create;
var $bc80ebcf21bfccd0$export$871de8747c9eaa88 = $bc80ebcf21bfccd0$export$163b6a2b712d9542.create;
var $bc80ebcf21bfccd0$export$adaa4cf7ef1b65be = $bc80ebcf21bfccd0$export$977057706f816712.create;
var $bc80ebcf21bfccd0$export$44e51c8aac7c2deb = $bc80ebcf21bfccd0$export$d4602ba55673f53c.create;
var $bc80ebcf21bfccd0$export$488013bae63b21da = $bc80ebcf21bfccd0$export$378d0cfce37406e6.create;
var $bc80ebcf21bfccd0$export$c8ec6e1ec9fefcb0 = $bc80ebcf21bfccd0$export$7e44096782a165d3.create;
var $bc80ebcf21bfccd0$export$78a99c8d44d72635 = $bc80ebcf21bfccd0$export$d325d1f0e1c20179.create;
var $bc80ebcf21bfccd0$export$6fe7eca19ebe5199 = $bc80ebcf21bfccd0$export$370b2e8d6d6f5c56.create;
var $bc80ebcf21bfccd0$export$c957ef27a0ebfd4 = $bc80ebcf21bfccd0$export$3f196b0127d6e50a.create;
var $bc80ebcf21bfccd0$export$dc573d8a6576cdb3 = $bc80ebcf21bfccd0$export$a60af00cc0ce2582.create;
var $bc80ebcf21bfccd0$export$516e28dec6a4b6d4 = $bc80ebcf21bfccd0$export$aa56fec1e9d629b8.create;
var $bc80ebcf21bfccd0$export$133fc36489ac9add = $bc80ebcf21bfccd0$export$aaac0b8b429cef5.create;
var $bc80ebcf21bfccd0$export$fc37fe19dfda43ee = $bc80ebcf21bfccd0$export$a60af00cc0ce2582.createWithPreprocess;
var $bc80ebcf21bfccd0$export$43f28b24e1eb8181 = $bc80ebcf21bfccd0$export$a3c3ef8a0e95c6da.create;
var $bc80ebcf21bfccd0$export$3b3d07727c5b702c = function() {
    return $bc80ebcf21bfccd0$export$22b082955e083ec3().optional();
};
var $bc80ebcf21bfccd0$export$eb150471a61fced6 = function() {
    return $bc80ebcf21bfccd0$export$98e628dec113755e().optional();
};
var $bc80ebcf21bfccd0$export$269251733cdcbbf1 = function() {
    return $bc80ebcf21bfccd0$export$4a21f16c33752377().optional();
};
var $bc80ebcf21bfccd0$export$8c14e57e778d3873 = {
    string: function(arg) {
        return $bc80ebcf21bfccd0$export$1230eb29b8d3b502.create((0, $8E768._)((0, $8OnJk._)({}, arg), {
            coerce: true
        }));
    },
    number: function(arg) {
        return $bc80ebcf21bfccd0$export$5b070a55c0c43e09.create((0, $8E768._)((0, $8OnJk._)({}, arg), {
            coerce: true
        }));
    },
    boolean: function(arg) {
        return $bc80ebcf21bfccd0$export$723d146f80596191.create((0, $8E768._)((0, $8OnJk._)({}, arg), {
            coerce: true
        }));
    },
    bigint: function(arg) {
        return $bc80ebcf21bfccd0$export$67d741fd70ff98f4.create((0, $8E768._)((0, $8OnJk._)({}, arg), {
            coerce: true
        }));
    },
    date: function(arg) {
        return $bc80ebcf21bfccd0$export$e974be33bdc55521.create((0, $8E768._)((0, $8OnJk._)({}, arg), {
            coerce: true
        }));
    }
};
var $bc80ebcf21bfccd0$export$96c94437c95d7862 = $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
var $bc80ebcf21bfccd0$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $bc80ebcf21bfccd0$export$341b0b6e0a6f5099,
    setErrorMap: $bc80ebcf21bfccd0$export$1097a8289cfd22d7,
    getErrorMap: $bc80ebcf21bfccd0$export$32f27c719778d4c4,
    makeIssue: $bc80ebcf21bfccd0$export$244a85fde9c419ed,
    EMPTY_PATH: $bc80ebcf21bfccd0$export$1526d2e05f74572,
    addIssueToContext: $bc80ebcf21bfccd0$export$db7caee60e5d514d,
    ParseStatus: $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f,
    INVALID: $bc80ebcf21bfccd0$export$9a105a556e65c2c0,
    DIRTY: $bc80ebcf21bfccd0$export$325a211da9693fcf,
    OK: $bc80ebcf21bfccd0$export$c6813a8d51f77eaf,
    isAborted: $bc80ebcf21bfccd0$export$afa861e3c5730743,
    isDirty: $bc80ebcf21bfccd0$export$910b6cdd390341b3,
    isValid: $bc80ebcf21bfccd0$export$1ea939691cdc45b8,
    isAsync: $bc80ebcf21bfccd0$export$aefee5ebe1dcfd9e,
    get util () {
        return $bc80ebcf21bfccd0$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $bc80ebcf21bfccd0$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $bc80ebcf21bfccd0$export$5716da67bfaa244d,
    getParsedType: $bc80ebcf21bfccd0$export$3e9057828ebd5c7a,
    ZodType: $bc80ebcf21bfccd0$export$19342e026b58ebb7,
    ZodString: $bc80ebcf21bfccd0$export$1230eb29b8d3b502,
    ZodNumber: $bc80ebcf21bfccd0$export$5b070a55c0c43e09,
    ZodBigInt: $bc80ebcf21bfccd0$export$67d741fd70ff98f4,
    ZodBoolean: $bc80ebcf21bfccd0$export$723d146f80596191,
    ZodDate: $bc80ebcf21bfccd0$export$e974be33bdc55521,
    ZodSymbol: $bc80ebcf21bfccd0$export$bcc3b40f6b638044,
    ZodUndefined: $bc80ebcf21bfccd0$export$4e780e961c30340d,
    ZodNull: $bc80ebcf21bfccd0$export$a96281f914484f2d,
    ZodAny: $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb,
    ZodUnknown: $bc80ebcf21bfccd0$export$ef3b1bb1630977ae,
    ZodNever: $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5,
    ZodVoid: $bc80ebcf21bfccd0$export$7d39f5df85f21031,
    ZodArray: $bc80ebcf21bfccd0$export$7acfc3e64785411,
    ZodObject: $bc80ebcf21bfccd0$export$736315c5b55efbad,
    ZodUnion: $bc80ebcf21bfccd0$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $bc80ebcf21bfccd0$export$5ef2424805ac76a3,
    ZodIntersection: $bc80ebcf21bfccd0$export$c02deaf0bb5203d4,
    ZodTuple: $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3,
    ZodRecord: $bc80ebcf21bfccd0$export$a2acc09968cb4b7f,
    ZodMap: $bc80ebcf21bfccd0$export$163b6a2b712d9542,
    ZodSet: $bc80ebcf21bfccd0$export$977057706f816712,
    ZodFunction: $bc80ebcf21bfccd0$export$d4602ba55673f53c,
    ZodLazy: $bc80ebcf21bfccd0$export$378d0cfce37406e6,
    ZodLiteral: $bc80ebcf21bfccd0$export$7e44096782a165d3,
    ZodEnum: $bc80ebcf21bfccd0$export$d325d1f0e1c20179,
    ZodNativeEnum: $bc80ebcf21bfccd0$export$370b2e8d6d6f5c56,
    ZodPromise: $bc80ebcf21bfccd0$export$3f196b0127d6e50a,
    ZodEffects: $bc80ebcf21bfccd0$export$a60af00cc0ce2582,
    ZodTransformer: $bc80ebcf21bfccd0$export$a60af00cc0ce2582,
    ZodOptional: $bc80ebcf21bfccd0$export$aa56fec1e9d629b8,
    ZodNullable: $bc80ebcf21bfccd0$export$aaac0b8b429cef5,
    ZodDefault: $bc80ebcf21bfccd0$export$bb19b37874861e7e,
    ZodCatch: $bc80ebcf21bfccd0$export$75a44ec6249ac76b,
    ZodNaN: $bc80ebcf21bfccd0$export$26ccfa0145e8511f,
    BRAND: $bc80ebcf21bfccd0$export$cf2deea74cde46b4,
    ZodBranded: $bc80ebcf21bfccd0$export$66b0c798a395271f,
    ZodPipeline: $bc80ebcf21bfccd0$export$a3c3ef8a0e95c6da,
    ZodReadonly: $bc80ebcf21bfccd0$export$5d1f7ef05c4e493a,
    custom: $bc80ebcf21bfccd0$export$4c00f665f0d4b443,
    Schema: $bc80ebcf21bfccd0$export$19342e026b58ebb7,
    ZodSchema: $bc80ebcf21bfccd0$export$19342e026b58ebb7,
    late: $bc80ebcf21bfccd0$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $bc80ebcf21bfccd0$export$558106ce543bd011;
    },
    coerce: $bc80ebcf21bfccd0$export$8c14e57e778d3873,
    any: $bc80ebcf21bfccd0$export$4154a199d7d90455,
    array: $bc80ebcf21bfccd0$export$2f23118c22fb2630,
    bigint: $bc80ebcf21bfccd0$export$a0f65b52274bcc00,
    boolean: $bc80ebcf21bfccd0$export$4a21f16c33752377,
    date: $bc80ebcf21bfccd0$export$324d90190a8b822a,
    discriminatedUnion: $bc80ebcf21bfccd0$export$4b888e40c4ee26dd,
    effect: $bc80ebcf21bfccd0$export$dc573d8a6576cdb3,
    "enum": $bc80ebcf21bfccd0$export$78a99c8d44d72635,
    "function": $bc80ebcf21bfccd0$export$44e51c8aac7c2deb,
    "instanceof": $bc80ebcf21bfccd0$export$3d916e7c22dbd8b5,
    intersection: $bc80ebcf21bfccd0$export$bc86dfbf7795668c,
    lazy: $bc80ebcf21bfccd0$export$488013bae63b21da,
    literal: $bc80ebcf21bfccd0$export$c8ec6e1ec9fefcb0,
    map: $bc80ebcf21bfccd0$export$871de8747c9eaa88,
    nan: $bc80ebcf21bfccd0$export$9e06de0973666692,
    nativeEnum: $bc80ebcf21bfccd0$export$6fe7eca19ebe5199,
    never: $bc80ebcf21bfccd0$export$b3e22bcfd64c1022,
    "null": $bc80ebcf21bfccd0$export$7b1b591b262c240,
    nullable: $bc80ebcf21bfccd0$export$133fc36489ac9add,
    number: $bc80ebcf21bfccd0$export$98e628dec113755e,
    object: $bc80ebcf21bfccd0$export$be5493f9613cbbe,
    oboolean: $bc80ebcf21bfccd0$export$269251733cdcbbf1,
    onumber: $bc80ebcf21bfccd0$export$eb150471a61fced6,
    optional: $bc80ebcf21bfccd0$export$516e28dec6a4b6d4,
    ostring: $bc80ebcf21bfccd0$export$3b3d07727c5b702c,
    pipeline: $bc80ebcf21bfccd0$export$43f28b24e1eb8181,
    preprocess: $bc80ebcf21bfccd0$export$fc37fe19dfda43ee,
    promise: $bc80ebcf21bfccd0$export$c957ef27a0ebfd4,
    record: $bc80ebcf21bfccd0$export$e5185e241753e543,
    set: $bc80ebcf21bfccd0$export$adaa4cf7ef1b65be,
    strictObject: $bc80ebcf21bfccd0$export$8fb0df5f40d0b477,
    string: $bc80ebcf21bfccd0$export$22b082955e083ec3,
    symbol: $bc80ebcf21bfccd0$export$8f701197936bc2a6,
    transformer: $bc80ebcf21bfccd0$export$dc573d8a6576cdb3,
    tuple: $bc80ebcf21bfccd0$export$65e3907585753458,
    "undefined": $bc80ebcf21bfccd0$export$1db45310990710a5,
    union: $bc80ebcf21bfccd0$export$971dd5b0dfd021b6,
    unknown: $bc80ebcf21bfccd0$export$19282c40b967aec6,
    "void": $bc80ebcf21bfccd0$export$490e536ee7389aeb,
    NEVER: $bc80ebcf21bfccd0$export$96c94437c95d7862,
    ZodIssueCode: $bc80ebcf21bfccd0$export$5ba560653e4a1035,
    quotelessJson: $bc80ebcf21bfccd0$export$913eddeaf297cfea,
    ZodError: $bc80ebcf21bfccd0$export$f98dac4b251ab333
});


var $7168d745f61c5ec2$exports = {};
$7168d745f61c5ec2$exports = JSON.parse('{"name":"ton","version":"13.6.1","repository":"https://github.com/ton-core/ton.git","author":"Whales Corp. <developers@whalescorp.com>","license":"MIT","main":"dist/index.js","files":["dist"],"scripts":{"docs":"rm -fr docs && typedoc src/index.ts","build":"rm -fr dist && tsc --declaration","test":"jest --verbose --runInBand","release":"yarn build && yarn release-it --npm.yarn1"},"devDependencies":{"@release-it/keep-a-changelog":"^3.1.0","@types/jest":"^27.0.1","@types/node":"^16.7.10","buffer":"^6.0.3","expect":"^27.1.0","jest":"^27.1.0","jest-mock":"^27.1.0","karma":"^6.3.4","karma-chrome-launcher":"^3.1.0","karma-jasmine":"^4.0.1","karma-typescript":"^5.5.2","karma-webpack":"^5.0.0","prando":"^6.0.1","release-it":"^15.5.1","ton-core":"^0.52.0","ton-crypto":"3.2.0","ton-emulator":"^2.1.1","ts-jest":"^27.0.5","ts-loader":"^9.2.5","ts-node":"^10.7.0","typedoc":"^0.23.24","typescript":"^4.4.2","webpack":"^5.51.2"},"dependencies":{"axios":"^0.25.0","dataloader":"^2.0.0","symbol.inspect":"1.0.1","teslabot":"^1.3.0","zod":"^3.21.4"},"peerDependencies":{"ton-core":">=0.51.0","ton-crypto":">=3.2.0"},"publishConfig":{"access":"public","registry":"https://registry.npmjs.org/"},"release-it":{"github":{"release":true},"plugins":{"@release-it/keep-a-changelog":{"filename":"CHANGELOG.md"}}},"packageManager":"yarn@3.4.1"}');


var $f2beac447e676249$require$version = $7168d745f61c5ec2$exports.version;
var $f2beac447e676249$var$blockIdExt = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    "@type": $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("ton.blockIdExt"),
    workchain: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
    shard: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    seqno: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
    root_hash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    file_hash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
});
var $f2beac447e676249$var$addressInformation = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    balance: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.union([
        $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
    ]),
    state: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.union([
        $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("active"),
        $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("uninitialized"),
        $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("frozen")
    ]),
    data: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    code: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    last_transaction_id: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        "@type": $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("internal.transactionId"),
        lt: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        hash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
    }),
    block_id: $f2beac447e676249$var$blockIdExt,
    sync_utime: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number()
});
var $f2beac447e676249$var$bocResponse = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    "@type": $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("ok")
});
var $f2beac447e676249$var$feeResponse = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    "@type": $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("query.fees"),
    source_fees: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        "@type": $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("fees"),
        in_fwd_fee: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        storage_fee: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        gas_fee: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        fwd_fee: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number()
    })
});
var $f2beac447e676249$var$callGetMethod = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    gas_used: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
    exit_code: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
    stack: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.array($bc80ebcf21bfccd0$export$2e2bcd8739ae039.unknown())
});
var $f2beac447e676249$var$messageData = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.union([
    $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        "@type": $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("msg.dataRaw"),
        "body": $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
    }),
    $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        "@type": $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("msg.dataText"),
        "text": $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
    }),
    $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        "@type": $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("msg.dataDecryptedText"),
        "text": $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
    }),
    $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        "@type": $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("msg.dataEncryptedText"),
        "text": $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
    })
]);
var $f2beac447e676249$var$message = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    source: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    destination: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    value: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    fwd_fee: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    ihr_fee: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    created_lt: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    body_hash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    msg_data: $f2beac447e676249$var$messageData
});
var $f2beac447e676249$var$transaction = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    data: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    utime: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
    transaction_id: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        lt: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        hash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
    }),
    fee: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    storage_fee: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    other_fee: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    in_msg: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.union([
        $bc80ebcf21bfccd0$export$2e2bcd8739ae039.undefined(),
        $f2beac447e676249$var$message
    ]),
    out_msgs: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.array($f2beac447e676249$var$message)
});
var $f2beac447e676249$var$getTransactions = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.array($f2beac447e676249$var$transaction);
var $f2beac447e676249$var$getMasterchain = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    state_root_hash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    last: $f2beac447e676249$var$blockIdExt,
    init: $f2beac447e676249$var$blockIdExt
});
var $f2beac447e676249$var$getShards = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    shards: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.array($f2beac447e676249$var$blockIdExt)
});
var $f2beac447e676249$var$blockShortTxt = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    "@type": $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("blocks.shortTxId"),
    mode: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
    account: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    lt: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    hash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
});
var $f2beac447e676249$var$getBlockTransactions = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    id: $f2beac447e676249$var$blockIdExt,
    req_count: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
    incomplete: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.boolean(),
    transactions: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.array($f2beac447e676249$var$blockShortTxt)
});
var $f2beac447e676249$var$TypedCache = /*#__PURE__*/ function() {
    "use strict";
    function TypedCache(namespace, cache, codec, keyEncoder) {
        (0, $978gY._)(this, TypedCache);
        this.namespace = namespace;
        this.cache = cache;
        this.codec = codec;
        this.keyEncoder = keyEncoder;
    }
    (0, $kry2a._)(TypedCache, [
        {
            key: "get",
            value: function get(key) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var ex, decoded;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.cache.get(_this.namespace, _this.keyEncoder(key))
                                ];
                            case 1:
                                ex = _state.sent();
                                if (ex) {
                                    decoded = _this.codec.safeParse(JSON.parse(ex));
                                    if (decoded.success) return [
                                        2,
                                        decoded.data
                                    ];
                                }
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(value !== null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.cache.set(_this.namespace, _this.keyEncoder(key), JSON.stringify(value))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.cache.set(_this.namespace, _this.keyEncoder(key), null)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return TypedCache;
}();
var $f2beac447e676249$var$HttpApi = /*#__PURE__*/ function() {
    "use strict";
    function HttpApi(endpoint, parameters) {
        (0, $978gY._)(this, HttpApi);
        this.endpoint = endpoint;
        this.cache = new $53789ddcf95e0621$exports.InMemoryCache();
        this.parameters = {
            timeout: (parameters === null || parameters === void 0 ? void 0 : parameters.timeout) || 30000,
            apiKey: parameters === null || parameters === void 0 ? void 0 : parameters.apiKey,
            adapter: parameters === null || parameters === void 0 ? void 0 : parameters.adapter
        };
        // Shard
        this.shardCache = new $f2beac447e676249$var$TypedCache("ton-shard", this.cache, $bc80ebcf21bfccd0$export$2e2bcd8739ae039.array($f2beac447e676249$var$blockIdExt), function(src) {
            return src + "";
        });
        var _this = this;
        this.shardLoader = new $f2beac447e676249$var$dataloader_1.default(function() {
            var _ref = (0, $byzP8._)(function(src) {
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                Promise.all(src.map(function() {
                                    var _ref = (0, $byzP8._)(function(v) {
                                        var cached, loaded;
                                        return (0, $7UAGh.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this.shardCache.get(v)
                                                    ];
                                                case 1:
                                                    cached = _state.sent();
                                                    if (cached) return [
                                                        2,
                                                        cached
                                                    ];
                                                    return [
                                                        4,
                                                        _this.doCall("shards", {
                                                            seqno: v
                                                        }, $f2beac447e676249$var$getShards)
                                                    ];
                                                case 2:
                                                    loaded = _state.sent().shards;
                                                    return [
                                                        4,
                                                        _this.shardCache.set(v, loaded)
                                                    ];
                                                case 3:
                                                    _state.sent();
                                                    return [
                                                        2,
                                                        loaded
                                                    ];
                                            }
                                        });
                                    });
                                    return function(v) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(src) {
                return _ref.apply(this, arguments);
            };
        }());
        // Shard Transactions
        this.shardTransactionsCache = new $f2beac447e676249$var$TypedCache("ton-shard-tx", this.cache, $f2beac447e676249$var$getBlockTransactions, function(src) {
            return src.workchain + ":" + src.shard + ":" + src.seqno;
        });
        var _this1 = this;
        this.shardTransactionsLoader = new $f2beac447e676249$var$dataloader_1.default(function() {
            var _ref = (0, $byzP8._)(function(src) {
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                Promise.all(src.map(function() {
                                    var _ref = (0, $byzP8._)(function(v) {
                                        var cached, loaded;
                                        return (0, $7UAGh.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this1.shardTransactionsCache.get(v)
                                                    ];
                                                case 1:
                                                    cached = _state.sent();
                                                    if (cached) return [
                                                        2,
                                                        cached
                                                    ];
                                                    return [
                                                        4,
                                                        _this1.doCall("getBlockTransactions", {
                                                            workchain: v.workchain,
                                                            seqno: v.seqno,
                                                            shard: v.shard
                                                        }, $f2beac447e676249$var$getBlockTransactions)
                                                    ];
                                                case 2:
                                                    loaded = _state.sent();
                                                    return [
                                                        4,
                                                        _this1.shardTransactionsCache.set(v, loaded)
                                                    ];
                                                case 3:
                                                    _state.sent();
                                                    return [
                                                        2,
                                                        loaded
                                                    ];
                                            }
                                        });
                                    });
                                    return function(v) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(src) {
                return _ref.apply(this, arguments);
            };
        }(), {
            cacheKeyFn: function(src) {
                return src.workchain + ":" + src.shard + ":" + src.seqno;
            }
        });
    }
    (0, $kry2a._)(HttpApi, [
        {
            key: "getAddressInformation",
            value: function getAddressInformation(address) {
                return this.doCall("getAddressInformation", {
                    address: address.toString()
                }, $f2beac447e676249$var$addressInformation);
            }
        },
        {
            key: "getTransactions",
            value: function getTransactions1(address, opts) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var inclusive, hash, limit, res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                inclusive = opts.inclusive;
                                delete opts.inclusive;
                                hash = undefined;
                                if (opts.hash) hash = $f2beac447e676249$require$Buffer.from(opts.hash, "base64").toString("hex");
                                limit = opts.limit;
                                if (opts.hash && opts.lt && inclusive !== true) limit++;
                                return [
                                    4,
                                    _this.doCall("getTransactions", (0, $8E768._)((0, $8OnJk._)({
                                        address: address.toString()
                                    }, opts), {
                                        limit: limit,
                                        hash: hash
                                    }), $f2beac447e676249$var$getTransactions)
                                ];
                            case 1:
                                res = _state.sent();
                                if (res.length > limit) res = res.slice(0, limit);
                                // Adjust result
                                if (opts.hash && opts.lt && inclusive !== true) {
                                    res.shift();
                                    return [
                                        2,
                                        res
                                    ];
                                } else return [
                                    2,
                                    res
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMasterchainInfo",
            value: function getMasterchainInfo() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.doCall("getMasterchainInfo", {}, $f2beac447e676249$var$getMasterchain)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getShards",
            value: function getShards(seqno) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.shardLoader.load(seqno)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlockTransactions",
            value: function getBlockTransactions(workchain, seqno, shard) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.shardTransactionsLoader.load({
                                        workchain: workchain,
                                        seqno: seqno,
                                        shard: shard
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTransaction",
            value: function getTransaction(address, lt, hash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var convHash, res, ex;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                convHash = $f2beac447e676249$require$Buffer.from(hash, "base64").toString("hex");
                                return [
                                    4,
                                    _this.doCall("getTransactions", {
                                        address: address.toString(),
                                        lt: lt,
                                        hash: convHash,
                                        limit: 1
                                    }, $f2beac447e676249$var$getTransactions)
                                ];
                            case 1:
                                res = _state.sent();
                                ex = res.find(function(v) {
                                    return v.transaction_id.lt === lt && v.transaction_id.hash === hash;
                                });
                                if (ex) return [
                                    2,
                                    ex
                                ];
                                else return [
                                    2,
                                    null
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "callGetMethod",
            value: function callGetMethod1(address, method, stack) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.doCall("runGetMethod", {
                                        address: address.toString(),
                                        method: method,
                                        stack: $f2beac447e676249$var$serializeStack(stack)
                                    }, $f2beac447e676249$var$callGetMethod)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendBoc",
            value: function sendBoc(body) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.doCall("sendBoc", {
                                        boc: body.toString("base64")
                                    }, $f2beac447e676249$var$bocResponse)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "estimateFee",
            value: function estimateFee(address, args) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.doCall("estimateFee", {
                                        address: address.toString(),
                                        body: args.body.toBoc().toString("base64"),
                                        "init_data": args.initData ? args.initData.toBoc().toString("base64") : "",
                                        "init_code": args.initCode ? args.initCode.toBoc().toString("base64") : "",
                                        ignore_chksig: args.ignoreSignature
                                    }, $f2beac447e676249$var$feeResponse)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "doCall",
            value: function doCall(method, body, codec) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var headers, res, decoded;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = {
                                    "Content-Type": "application/json",
                                    "X-Ton-Client-Version": $f2beac447e676249$require$version
                                };
                                if (_this.parameters.apiKey) headers["X-API-Key"] = _this.parameters.apiKey;
                                return [
                                    4,
                                    $f2beac447e676249$var$axios_1.default.post(_this.endpoint, JSON.stringify({
                                        id: "1",
                                        jsonrpc: "2.0",
                                        method: method,
                                        params: body
                                    }), {
                                        headers: headers,
                                        timeout: _this.parameters.timeout,
                                        adapter: _this.parameters.adapter
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                if (res.status !== 200 || !res.data.ok) throw Error("Received error: " + JSON.stringify(res.data));
                                decoded = codec.safeParse(res.data.result);
                                if (decoded.success) return [
                                    2,
                                    decoded.data
                                ];
                                else throw Error("Malformed response: " + decoded.error.format()._errors.join(", "));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return HttpApi;
}();
$f2beac447e676249$exports.HttpApi = $f2beac447e676249$var$HttpApi;
function $f2beac447e676249$var$serializeStack(src) {
    var stack = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = src[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            if (s.type === "int") stack.push([
                "num",
                s.value.toString()
            ]);
            else if (s.type === "cell") stack.push([
                "tvm.Cell",
                s.cell.toBoc().toString("base64")
            ]);
            else if (s.type === "slice") stack.push([
                "tvm.Slice",
                s.cell.toBoc().toString("base64")
            ]);
            else if (s.type === "builder") stack.push([
                "tvm.Builder",
                s.cell.toBoc().toString("base64")
            ]);
            else throw Error("Unsupported stack item type: " + s.type);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return stack;
}


Object.defineProperty($89095f30c08601be$exports, "HttpApi", {
    enumerable: true,
    get: function get() {
        return $f2beac447e676249$exports.HttpApi;
    }
});
var $9bc4690133f17cf9$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $9bc4690133f17cf9$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9bc4690133f17cf9$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $9bc4690133f17cf9$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $9bc4690133f17cf9$var$_TonClient_api;
Object.defineProperty($9bc4690133f17cf9$exports, "__esModule", {
    value: true
});
$9bc4690133f17cf9$exports.TonClient = void 0;


var $jWi6z = parcelRequire("jWi6z");
var $9bc4690133f17cf9$var$TonClient = /*#__PURE__*/ function() {
    "use strict";
    function TonClient(parameters) {
        (0, $978gY._)(this, TonClient);
        $9bc4690133f17cf9$var$_TonClient_api.set(this, void 0);
        this.parameters = {
            endpoint: parameters.endpoint
        };
        $9bc4690133f17cf9$var$__classPrivateFieldSet(this, $9bc4690133f17cf9$var$_TonClient_api, new $f2beac447e676249$exports.HttpApi(this.parameters.endpoint, {
            timeout: parameters.timeout,
            apiKey: parameters.apiKey,
            adapter: parameters.httpAdapter
        }), "f");
    }
    (0, $kry2a._)(TonClient, [
        {
            key: "getBalance",
            value: /**
     * Get Address Balance
     * @param address address for balance check
     * @returns balance
     */ function getBalance(address) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getContractState(address)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().balance
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "runMethod",
            value: /**
     * Invoke get method
     * @param address contract address
     * @param name name of method
     * @param params optional parameters
     * @returns stack and gas_used field
     */ function runMethod(address, name) {
                var stack = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                var _this = this;
                return (0, $byzP8._)(function() {
                    var res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $9bc4690133f17cf9$var$__classPrivateFieldGet(_this, $9bc4690133f17cf9$var$_TonClient_api, "f").callGetMethod(address, name, stack)
                                ];
                            case 1:
                                res = _state.sent();
                                if (res.exit_code !== 0) throw Error("Unable to execute get method. Got exit_code: " + res.exit_code);
                                return [
                                    2,
                                    {
                                        gas_used: res.gas_used,
                                        stack: $9bc4690133f17cf9$var$parseStack(res.stack)
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "callGetMethod",
            value: /**
     * Invoke get method
     * @param address contract address
     * @param name name of method
     * @param params optional parameters
     * @returns stack and gas_used field
     * @deprecated use runMethod instead
     */ function callGetMethod(address, name) {
                var stack = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.runMethod(address, name, stack)
                        ];
                    });
                })();
            }
        },
        {
            key: "runMethodWithError",
            value: /**
     * Invoke get method that returns error code instead of throwing error
     * @param address contract address
     * @param name name of method
     * @param params optional parameters
     * @returns stack and gas_used field
    */ function runMethodWithError(address, name) {
                var params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                var _this = this;
                return (0, $byzP8._)(function() {
                    var res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $9bc4690133f17cf9$var$__classPrivateFieldGet(_this, $9bc4690133f17cf9$var$_TonClient_api, "f").callGetMethod(address, name, params)
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    2,
                                    {
                                        gas_used: res.gas_used,
                                        stack: $9bc4690133f17cf9$var$parseStack(res.stack),
                                        exit_code: res.exit_code
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "callGetMethodWithError",
            value: /**
     * Invoke get method that returns error code instead of throwing error
     * @param address contract address
     * @param name name of method
     * @param params optional parameters
     * @returns stack and gas_used field
     * @deprecated use runMethodWithError instead
     */ function callGetMethodWithError(address, name) {
                var stack = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.runMethodWithError(address, name, stack)
                        ];
                    });
                })();
            }
        },
        {
            key: "getTransactions",
            value: /**
     * Get transactions
     * @param address address
     */ function getTransactions(address, opts) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var tx, res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, r;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $9bc4690133f17cf9$var$__classPrivateFieldGet(_this, $9bc4690133f17cf9$var$_TonClient_api, "f").getTransactions(address, opts)
                                ];
                            case 1:
                                tx = _state.sent();
                                res = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = tx[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        r = _step.value;
                                        res.push((0, $jWi6z.loadTransaction)($jWi6z.Cell.fromBoc($9bc4690133f17cf9$require$Buffer.from(r.data, "base64"))[0].beginParse()));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return [
                                    2,
                                    res
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTransaction",
            value: /**
     * Get transaction by it's id
     * @param address address
     * @param lt logical time
     * @param hash transaction hash
     * @returns transaction or null if not exist
     */ function getTransaction(address, lt, hash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $9bc4690133f17cf9$var$__classPrivateFieldGet(_this, $9bc4690133f17cf9$var$_TonClient_api, "f").getTransaction(address, lt, hash)
                                ];
                            case 1:
                                res = _state.sent();
                                if (res) return [
                                    2,
                                    (0, $jWi6z.loadTransaction)($jWi6z.Cell.fromBoc($9bc4690133f17cf9$require$Buffer.from(res.data, "base64"))[0].beginParse())
                                ];
                                else return [
                                    2,
                                    null
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMasterchainInfo",
            value: /**
     * Fetch latest masterchain info
     * @returns masterchain info
     */ function getMasterchainInfo() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var r;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $9bc4690133f17cf9$var$__classPrivateFieldGet(_this, $9bc4690133f17cf9$var$_TonClient_api, "f").getMasterchainInfo()
                                ];
                            case 1:
                                r = _state.sent();
                                return [
                                    2,
                                    {
                                        workchain: r.init.workchain,
                                        shard: r.last.shard,
                                        initSeqno: r.init.seqno,
                                        latestSeqno: r.last.seqno
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getWorkchainShards",
            value: /**
     * Fetch latest workchain shards
     * @param seqno masterchain seqno
     */ function getWorkchainShards(seqno) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var r;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $9bc4690133f17cf9$var$__classPrivateFieldGet(_this, $9bc4690133f17cf9$var$_TonClient_api, "f").getShards(seqno)
                                ];
                            case 1:
                                r = _state.sent();
                                return [
                                    2,
                                    r.map(function(m) {
                                        return {
                                            workchain: m.workchain,
                                            shard: m.shard,
                                            seqno: m.seqno
                                        };
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getShardTransactions",
            value: /**
     * Fetch transactions inf shards
     * @param workchain
     * @param seqno
     * @param shard
     */ function getShardTransactions(workchain, seqno, shard) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var tx;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $9bc4690133f17cf9$var$__classPrivateFieldGet(_this, $9bc4690133f17cf9$var$_TonClient_api, "f").getBlockTransactions(workchain, seqno, shard)
                                ];
                            case 1:
                                tx = _state.sent();
                                if (tx.incomplete) throw Error("Unsupported");
                                return [
                                    2,
                                    tx.transactions.map(function(v) {
                                        return {
                                            account: $jWi6z.Address.parseRaw(v.account),
                                            lt: v.lt,
                                            hash: v.hash
                                        };
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendMessage",
            value: /**
     * Send message to a network
     * @param src source message
     */ function sendMessage(src) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var boc;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                boc = (0, $jWi6z.beginCell)().store((0, $jWi6z.storeMessage)(src)).endCell().toBoc();
                                return [
                                    4,
                                    $9bc4690133f17cf9$var$__classPrivateFieldGet(_this, $9bc4690133f17cf9$var$_TonClient_api, "f").sendBoc(boc)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendFile",
            value: /**
     * Send file to a network
     * @param src source file
     */ function sendFile(src) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $9bc4690133f17cf9$var$__classPrivateFieldGet(_this, $9bc4690133f17cf9$var$_TonClient_api, "f").sendBoc(src)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "estimateExternalMessageFee",
            value: /**
     * Estimate fees for external message
     * @param address target address
     * @returns
     */ function estimateExternalMessageFee(address, args) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $9bc4690133f17cf9$var$__classPrivateFieldGet(_this, $9bc4690133f17cf9$var$_TonClient_api, "f").estimateFee(address, {
                                        body: args.body,
                                        initCode: args.initCode,
                                        initData: args.initData,
                                        ignoreSignature: args.ignoreSignature
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendExternalMessage",
            value: /**
     * Send external message to contract
     * @param contract contract to send message
     * @param src message body
     */ function sendExternalMessage(contract, src) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var message, message1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.isContractDeployed(contract.address)
                                ];
                            case 1:
                                if (!(_state.sent() || !contract.init)) return [
                                    3,
                                    3
                                ];
                                message = (0, $jWi6z.external)({
                                    to: contract.address,
                                    body: src
                                });
                                return [
                                    4,
                                    _this.sendMessage(message)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                message1 = (0, $jWi6z.external)({
                                    to: contract.address,
                                    init: {
                                        code: contract.init.code,
                                        data: contract.init.data
                                    },
                                    body: src
                                });
                                return [
                                    4,
                                    _this.sendMessage(message1)
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isContractDeployed",
            value: /**
     * Check if contract is deployed
     * @param address addres to check
     * @returns true if contract is in active state
     */ function isContractDeployed(address) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getContractState(address)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().state === "active"
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getContractState",
            value: /**
     * Resolves contract state
     * @param address contract address
     */ function getContractState(address) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var info, balance, state;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $9bc4690133f17cf9$var$__classPrivateFieldGet(_this, $9bc4690133f17cf9$var$_TonClient_api, "f").getAddressInformation(address)
                                ];
                            case 1:
                                info = _state.sent();
                                balance = BigInt(info.balance);
                                state = info.state;
                                return [
                                    2,
                                    {
                                        balance: balance,
                                        state: state,
                                        code: info.code !== "" ? $9bc4690133f17cf9$require$Buffer.from(info.code, "base64") : null,
                                        data: info.data !== "" ? $9bc4690133f17cf9$require$Buffer.from(info.data, "base64") : null,
                                        lastTransaction: info.last_transaction_id.lt !== "0" ? {
                                            lt: info.last_transaction_id.lt,
                                            hash: info.last_transaction_id.hash
                                        } : null,
                                        blockId: {
                                            workchain: info.block_id.workchain,
                                            shard: info.block_id.shard,
                                            seqno: info.block_id.seqno
                                        },
                                        timestampt: info.sync_utime
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Open contract
     * @param src source contract
     * @returns contract
     */ key: "open",
            value: function open(src) {
                var _this = this;
                return (0, $jWi6z.openContract)(src, function(args) {
                    return $9bc4690133f17cf9$var$createProvider(_this, args.address, args.init);
                });
            }
        },
        {
            /**
     * Create a provider
     * @param address address
     * @param init optional init
     * @returns provider
     */ key: "provider",
            value: function provider(address, init) {
                return $9bc4690133f17cf9$var$createProvider(this, address, init);
            }
        }
    ]);
    return TonClient;
}();
$9bc4690133f17cf9$exports.TonClient = $9bc4690133f17cf9$var$TonClient;
$9bc4690133f17cf9$var$_TonClient_api = new WeakMap();
function $9bc4690133f17cf9$var$parseStack(src) {
    var stack = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = src[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            if (s[0] === "num") {
                var val = s[1];
                if (val.startsWith("-")) stack.push({
                    type: "int",
                    value: -BigInt(val.slice(1))
                });
                else stack.push({
                    type: "int",
                    value: BigInt(val)
                });
            } else if (s[0] === "null") stack.push({
                type: "null"
            });
            else if (s[0] === "cell") stack.push({
                type: "cell",
                cell: $jWi6z.Cell.fromBoc($9bc4690133f17cf9$require$Buffer.from(s[1].bytes, "base64"))[0]
            });
            else if (s[0] === "slice") stack.push({
                type: "slice",
                cell: $jWi6z.Cell.fromBoc($9bc4690133f17cf9$require$Buffer.from(s[1].bytes, "base64"))[0]
            });
            else if (s[0] === "builder") stack.push({
                type: "builder",
                cell: $jWi6z.Cell.fromBoc($9bc4690133f17cf9$require$Buffer.from(s[1].bytes, "base64"))[0]
            });
            else throw Error("Unsupported stack item type: " + s[0]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return new $jWi6z.TupleReader(stack);
}
function $9bc4690133f17cf9$var$createProvider(client, address, init) {
    return {
        getState: function() {
            return (0, $byzP8._)(function() {
                var state, balance, last, storage;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                client.getContractState(address)
                            ];
                        case 1:
                            state = _state.sent();
                            balance = state.balance;
                            last = state.lastTransaction ? {
                                lt: BigInt(state.lastTransaction.lt),
                                hash: $9bc4690133f17cf9$require$Buffer.from(state.lastTransaction.hash, "base64")
                            } : null;
                            if (state.state === "active") storage = {
                                type: "active",
                                code: state.code ? state.code : null,
                                data: state.data ? state.data : null
                            };
                            else if (state.state === "uninitialized") storage = {
                                type: "uninit"
                            };
                            else if (state.state === "frozen") storage = {
                                type: "frozen",
                                stateHash: $9bc4690133f17cf9$require$Buffer.alloc(0)
                            };
                            else throw Error("Unsupported state");
                            return [
                                2,
                                {
                                    balance: balance,
                                    last: last,
                                    state: storage
                                }
                            ];
                    }
                });
            })();
        },
        get: function(name, args) {
            return (0, $byzP8._)(function() {
                var method;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                client.callGetMethod(address, name, args)
                            ];
                        case 1:
                            method = _state.sent();
                            return [
                                2,
                                {
                                    stack: method.stack
                                }
                            ];
                    }
                });
            })();
        },
        external: function(message) {
            return (0, $byzP8._)(function() {
                var neededInit, _tmp, ext, boc;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            neededInit = null;
                            _tmp = init;
                            if (!_tmp) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                client.isContractDeployed(address)
                            ];
                        case 1:
                            _tmp = !_state.sent();
                            _state.label = 2;
                        case 2:
                            if (_tmp) neededInit = init;
                            ext = (0, $jWi6z.external)({
                                to: address,
                                init: neededInit ? {
                                    code: neededInit.code,
                                    data: neededInit.data
                                } : null,
                                body: message
                            });
                            boc = (0, $jWi6z.beginCell)().store((0, $jWi6z.storeMessage)(ext)).endCell().toBoc();
                            return [
                                4,
                                client.sendFile(boc)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        internal: function(via, message) {
            return (0, $byzP8._)(function() {
                var neededInit, _tmp, bounce, value, body;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            neededInit = null;
                            _tmp = init;
                            if (!_tmp) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                client.isContractDeployed(address)
                            ];
                        case 1:
                            _tmp = !_state.sent();
                            _state.label = 2;
                        case 2:
                            if (_tmp) neededInit = init;
                            bounce = true;
                            if (message.bounce !== null && message.bounce !== undefined) bounce = message.bounce;
                            if (typeof message.value === "string") value = (0, $jWi6z.toNano)(message.value);
                            else value = message.value;
                            body = null;
                            if (typeof message.body === "string") body = (0, $jWi6z.comment)(message.body);
                            else if (message.body) body = message.body;
                            // Send internal message
                            return [
                                4,
                                via.send({
                                    to: address,
                                    value: value,
                                    bounce: bounce,
                                    sendMode: message.sendMode,
                                    init: neededInit,
                                    body: body
                                })
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
}


Object.defineProperty($89095f30c08601be$exports, "TonClient", {
    enumerable: true,
    get: function get() {
        return $9bc4690133f17cf9$exports.TonClient;
    }
});
var $c85fad076312f554$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $c85fad076312f554$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c85fad076312f554$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $c85fad076312f554$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $c85fad076312f554$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $c85fad076312f554$var$_TonClient4_endpoint, $c85fad076312f554$var$_TonClient4_timeout, $c85fad076312f554$var$_TonClient4_adapter;
Object.defineProperty($c85fad076312f554$exports, "__esModule", {
    value: true
});
$c85fad076312f554$exports.TonClient4 = void 0;

var $c85fad076312f554$var$axios_1 = $c85fad076312f554$var$__importDefault((parcelRequire("12URZ")));

var $jWi6z = parcelRequire("jWi6z");
var $ef235f89698ae45a$exports = {};
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty($ef235f89698ae45a$exports, "__esModule", {
    value: true
});
$ef235f89698ae45a$exports.toUrlSafe = void 0;
function $ef235f89698ae45a$var$toUrlSafe(src) {
    while(src.indexOf("/") >= 0)src = src.replace("/", "_");
    while(src.indexOf("+") >= 0)src = src.replace("+", "-");
    while(src.indexOf("=") >= 0)src = src.replace("=", "");
    return src;
}
$ef235f89698ae45a$exports.toUrlSafe = $ef235f89698ae45a$var$toUrlSafe;



var $c85fad076312f554$var$TonClient4 = /*#__PURE__*/ function() {
    "use strict";
    function TonClient4(args) {
        (0, $978gY._)(this, TonClient4);
        $c85fad076312f554$var$_TonClient4_endpoint.set(this, void 0);
        $c85fad076312f554$var$_TonClient4_timeout.set(this, void 0);
        $c85fad076312f554$var$_TonClient4_adapter.set(this, void 0);
        $c85fad076312f554$var$__classPrivateFieldSet(this, $c85fad076312f554$var$_TonClient4_endpoint, args.endpoint, "f");
        $c85fad076312f554$var$__classPrivateFieldSet(this, $c85fad076312f554$var$_TonClient4_timeout, args.timeout || 5000, "f");
        $c85fad076312f554$var$__classPrivateFieldSet(this, $c85fad076312f554$var$_TonClient4_adapter, args.httpAdapter, "f");
    }
    (0, $kry2a._)(TonClient4, [
        {
            key: "getLastBlock",
            value: /**
     * Get Last Block
     * @returns last block info
     */ function getLastBlock() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var res, lastBlock;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $c85fad076312f554$var$axios_1.default.get($c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_endpoint, "f") + "/block/latest", {
                                        adapter: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_adapter, "f"),
                                        timeout: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_timeout, "f")
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                lastBlock = $c85fad076312f554$var$lastBlockCodec.safeParse(res.data);
                                if (!lastBlock.success) throw Error("Mailformed response: " + lastBlock.error.format()._errors.join(", "));
                                return [
                                    2,
                                    lastBlock.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlock",
            value: /**
     * Get block info
     * @param seqno block sequence number
     * @returns block info
     */ function getBlock(seqno) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var res, block;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $c85fad076312f554$var$axios_1.default.get($c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_endpoint, "f") + "/block/" + seqno, {
                                        adapter: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_adapter, "f"),
                                        timeout: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_timeout, "f")
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                block = $c85fad076312f554$var$blockCodec.safeParse(res.data);
                                if (!block.success) throw Error("Mailformed response");
                                if (!block.data.exist) throw Error("Block is out of scope");
                                return [
                                    2,
                                    block.data.block
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlockByUtime",
            value: /**
     * Get block info by unix timestamp
     * @param ts unix timestamp
     * @returns block info
     */ function getBlockByUtime(ts) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var res, block;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $c85fad076312f554$var$axios_1.default.get($c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_endpoint, "f") + "/block/utime/" + ts, {
                                        adapter: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_adapter, "f"),
                                        timeout: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_timeout, "f")
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                block = $c85fad076312f554$var$blockCodec.safeParse(res.data);
                                if (!block.success) throw Error("Mailformed response");
                                if (!block.data.exist) throw Error("Block is out of scope");
                                return [
                                    2,
                                    block.data.block
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccount",
            value: /**
     * Get block info by unix timestamp
     * @param seqno block sequence number
     * @param address account address
     * @returns account info
     */ function getAccount(seqno, address) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var res, account;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $c85fad076312f554$var$axios_1.default.get($c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_endpoint, "f") + "/block/" + seqno + "/" + address.toString({
                                        urlSafe: true
                                    }), {
                                        adapter: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_adapter, "f"),
                                        timeout: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_timeout, "f")
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                account = $c85fad076312f554$var$accountCodec.safeParse(res.data);
                                if (!account.success) throw Error("Mailformed response");
                                return [
                                    2,
                                    account.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccountLite",
            value: /**
     * Get account lite info (without code and data)
     * @param seqno block sequence number
     * @param address account address
     * @returns account lite info
     */ function getAccountLite(seqno, address) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var res, account;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $c85fad076312f554$var$axios_1.default.get($c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_endpoint, "f") + "/block/" + seqno + "/" + address.toString({
                                        urlSafe: true
                                    }) + "/lite", {
                                        adapter: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_adapter, "f"),
                                        timeout: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_timeout, "f")
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                account = $c85fad076312f554$var$accountLiteCodec.safeParse(res.data);
                                if (!account.success) throw Error("Mailformed response");
                                return [
                                    2,
                                    account.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isContractDeployed",
            value: /**
     * Check if contract is deployed
     * @param address addres to check
     * @returns true if contract is in active state
     */ function isContractDeployed(seqno, address) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var account;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getAccountLite(seqno, address)
                                ];
                            case 1:
                                account = _state.sent();
                                return [
                                    2,
                                    account.account.state.type === "active"
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isAccountChanged",
            value: /**
     * Check if account was updated since
     * @param seqno block sequence number
     * @param address account address
     * @param lt account last transaction lt
     * @returns account change info
     */ function isAccountChanged(seqno, address, lt) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var res, changed;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $c85fad076312f554$var$axios_1.default.get($c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_endpoint, "f") + "/block/" + seqno + "/" + address.toString({
                                        urlSafe: true
                                    }) + "/changed/" + lt.toString(10), {
                                        adapter: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_adapter, "f"),
                                        timeout: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_timeout, "f")
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                changed = $c85fad076312f554$var$changedCodec.safeParse(res.data);
                                if (!changed.success) throw Error("Mailformed response");
                                return [
                                    2,
                                    changed.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccountTransactions",
            value: /**
     * Load unparsed account transactions
     * @param address address
     * @param lt last transaction lt
     * @param hash last transaction hash
     * @returns unparsed transactions
     */ function getAccountTransactions(address, lt, hash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var res, transactions, data, tx, cells, i;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $c85fad076312f554$var$axios_1.default.get($c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_endpoint, "f") + "/account/" + address.toString({
                                        urlSafe: true
                                    }) + "/tx/" + lt.toString(10) + "/" + (0, $ef235f89698ae45a$exports.toUrlSafe)(hash.toString("base64")), {
                                        adapter: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_adapter, "f"),
                                        timeout: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_timeout, "f")
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                transactions = $c85fad076312f554$var$transactionsCodec.safeParse(res.data);
                                if (!transactions.success) throw Error("Mailformed response");
                                data = transactions.data;
                                tx = [];
                                cells = $jWi6z.Cell.fromBoc($c85fad076312f554$require$Buffer.from(data.boc, "base64"));
                                for(i = 0; i < data.blocks.length; i++)tx.push({
                                    block: data.blocks[i],
                                    tx: (0, $jWi6z.loadTransaction)(cells[i].beginParse())
                                });
                                return [
                                    2,
                                    tx
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getConfig",
            value: /**
     * Get network config
     * @param seqno block sequence number
     * @param ids optional config ids
     * @returns network config
     */ function getConfig(seqno, ids) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var tail, res, config;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                tail = "";
                                if (ids && ids.length > 0) tail = "/" + (0, $fLnyw._)(ids).sort().join(",");
                                return [
                                    4,
                                    $c85fad076312f554$var$axios_1.default.get($c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_endpoint, "f") + "/block/" + seqno + "/config" + tail, {
                                        adapter: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_adapter, "f"),
                                        timeout: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_timeout, "f")
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                config = $c85fad076312f554$var$configCodec.safeParse(res.data);
                                if (!config.success) throw Error("Mailformed response");
                                return [
                                    2,
                                    config.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "runMethod",
            value: /**
     * Execute run method
     * @param seqno block sequence number
     * @param address account address
     * @param name method name
     * @param args method arguments
     * @returns method result
     */ function runMethod(seqno, address, name, args) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var tail, url, res, runMethod, resultTuple;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                tail = args && args.length > 0 ? "/" + (0, $ef235f89698ae45a$exports.toUrlSafe)((0, $jWi6z.serializeTuple)(args).toBoc({
                                    idx: false,
                                    crc32: false
                                }).toString("base64")) : "";
                                url = $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_endpoint, "f") + "/block/" + seqno + "/" + address.toString({
                                    urlSafe: true
                                }) + "/run/" + name + tail;
                                return [
                                    4,
                                    $c85fad076312f554$var$axios_1.default.get(url, {
                                        adapter: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_adapter, "f"),
                                        timeout: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_timeout, "f")
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                runMethod = $c85fad076312f554$var$runMethodCodec.safeParse(res.data);
                                if (!runMethod.success) throw Error("Mailformed response");
                                resultTuple = runMethod.data.resultRaw ? (0, $jWi6z.parseTuple)($jWi6z.Cell.fromBoc($c85fad076312f554$require$Buffer.from(runMethod.data.resultRaw, "base64"))[0]) : [];
                                return [
                                    2,
                                    {
                                        exitCode: runMethod.data.exitCode,
                                        result: resultTuple,
                                        resultRaw: runMethod.data.resultRaw,
                                        block: runMethod.data.block,
                                        shardBlock: runMethod.data.shardBlock,
                                        reader: new $jWi6z.TupleReader(resultTuple)
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendMessage",
            value: /**
     * Send external message
     * @param message message boc
     * @returns message status
     */ function sendMessage(message) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var res, send;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $c85fad076312f554$var$axios_1.default.post($c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_endpoint, "f") + "/send", {
                                        boc: message.toString("base64")
                                    }, {
                                        adapter: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_adapter, "f"),
                                        timeout: $c85fad076312f554$var$__classPrivateFieldGet(_this, $c85fad076312f554$var$_TonClient4_timeout, "f")
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                send = $c85fad076312f554$var$sendCodec.safeParse(res.data);
                                if (!send.success) throw Error("Mailformed response");
                                return [
                                    2,
                                    {
                                        status: res.data.status
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Open smart contract
     * @param contract contract
     * @returns opened contract
     */ key: "open",
            value: function open(contract) {
                var _this = this;
                return (0, $jWi6z.openContract)(contract, function(args) {
                    return $c85fad076312f554$var$createProvider(_this, null, args.address, args.init);
                });
            }
        },
        {
            /**
     * Open smart contract
     * @param block block number
     * @param contract contract
     * @returns opened contract
     */ key: "openAt",
            value: function openAt(block, contract) {
                var _this = this;
                return (0, $jWi6z.openContract)(contract, function(args) {
                    return $c85fad076312f554$var$createProvider(_this, block, args.address, args.init);
                });
            }
        },
        {
            /**
     * Create provider
     * @param address address
     * @param init optional init data
     * @returns provider
     */ key: "provider",
            value: function provider(address, init) {
                return $c85fad076312f554$var$createProvider(this, null, address, init ? init : null);
            }
        },
        {
            /**
     * Create provider at specified block number
     * @param block block number
     * @param address address
     * @param init optional init data
     * @returns provider
     */ key: "providerAt",
            value: function providerAt(block, address, init) {
                return $c85fad076312f554$var$createProvider(this, block, address, init ? init : null);
            }
        }
    ]);
    return TonClient4;
}();
$c85fad076312f554$exports.TonClient4 = $c85fad076312f554$var$TonClient4;
$c85fad076312f554$var$_TonClient4_endpoint = new WeakMap(), $c85fad076312f554$var$_TonClient4_timeout = new WeakMap(), $c85fad076312f554$var$_TonClient4_adapter = new WeakMap();
function $c85fad076312f554$var$createProvider(client, block, address, init) {
    return {
        getState: function() {
            return (0, $byzP8._)(function() {
                var sq, res, state, last, storage;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            sq = block;
                            if (!(sq === null)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                client.getLastBlock()
                            ];
                        case 1:
                            res = _state.sent();
                            sq = res.last.seqno;
                            _state.label = 2;
                        case 2:
                            return [
                                4,
                                client.getAccount(sq, address)
                            ];
                        case 3:
                            state = _state.sent();
                            last = state.account.last ? {
                                lt: BigInt(state.account.last.lt),
                                hash: $c85fad076312f554$require$Buffer.from(state.account.last.hash, "base64")
                            } : null;
                            if (state.account.state.type === "active") storage = {
                                type: "active",
                                code: state.account.state.code ? $c85fad076312f554$require$Buffer.from(state.account.state.code, "base64") : null,
                                data: state.account.state.data ? $c85fad076312f554$require$Buffer.from(state.account.state.data, "base64") : null
                            };
                            else if (state.account.state.type === "uninit") storage = {
                                type: "uninit"
                            };
                            else if (state.account.state.type === "frozen") storage = {
                                type: "frozen",
                                stateHash: $c85fad076312f554$require$Buffer.from(state.account.state.stateHash, "base64")
                            };
                            else throw Error("Unsupported state");
                            return [
                                2,
                                {
                                    balance: BigInt(state.account.balance.coins),
                                    last: last,
                                    state: storage
                                }
                            ];
                    }
                });
            })();
        },
        get: function(name, args) {
            return (0, $byzP8._)(function() {
                var sq, res, method;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            sq = block;
                            if (!(sq === null)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                client.getLastBlock()
                            ];
                        case 1:
                            res = _state.sent();
                            sq = res.last.seqno;
                            _state.label = 2;
                        case 2:
                            return [
                                4,
                                client.runMethod(sq, address, name, args)
                            ];
                        case 3:
                            method = _state.sent();
                            if (method.exitCode !== 0 && method.exitCode !== 1) throw Error("Exit code: " + method.exitCode);
                            return [
                                2,
                                {
                                    stack: new $jWi6z.TupleReader(method.result)
                                }
                            ];
                    }
                });
            })();
        },
        external: function(message) {
            return (0, $byzP8._)(function() {
                var last, neededInit, _tmp, ext, pkg;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                client.getLastBlock()
                            ];
                        case 1:
                            last = _state.sent();
                            neededInit = null;
                            _tmp = init;
                            if (!_tmp) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                client.getAccountLite(last.last.seqno, address)
                            ];
                        case 2:
                            _tmp = _state.sent().account.state.type !== "active";
                            _state.label = 3;
                        case 3:
                            if (_tmp) neededInit = init;
                            ext = (0, $jWi6z.external)({
                                to: address,
                                init: neededInit ? {
                                    code: neededInit.code,
                                    data: neededInit.data
                                } : null,
                                body: message
                            });
                            pkg = (0, $jWi6z.beginCell)().store((0, $jWi6z.storeMessage)(ext)).endCell().toBoc();
                            return [
                                4,
                                client.sendMessage(pkg)
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        internal: function(via, message) {
            return (0, $byzP8._)(function() {
                var last, neededInit, _tmp, bounce, value, body;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                client.getLastBlock()
                            ];
                        case 1:
                            last = _state.sent();
                            neededInit = null;
                            _tmp = init;
                            if (!_tmp) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                client.getAccountLite(last.last.seqno, address)
                            ];
                        case 2:
                            _tmp = _state.sent().account.state.type !== "active";
                            _state.label = 3;
                        case 3:
                            if (_tmp) neededInit = init;
                            bounce = true;
                            if (message.bounce !== null && message.bounce !== undefined) bounce = message.bounce;
                            if (typeof message.value === "string") value = (0, $jWi6z.toNano)(message.value);
                            else value = message.value;
                            body = null;
                            if (typeof message.body === "string") body = (0, $jWi6z.comment)(message.body);
                            else if (message.body) body = message.body;
                            // Send internal message
                            return [
                                4,
                                via.send({
                                    to: address,
                                    value: value,
                                    bounce: bounce,
                                    sendMode: message.sendMode,
                                    init: neededInit,
                                    body: body
                                })
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
}
//
// Codecs
//
var $c85fad076312f554$var$lastBlockCodec = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    last: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        seqno: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        shard: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        workchain: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        fileHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        rootHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
    }),
    init: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        fileHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        rootHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
    }),
    stateRootHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
    now: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number()
});
var $c85fad076312f554$var$blockCodec = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.union([
    $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        exist: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal(false)
    }),
    $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        exist: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal(true),
        block: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
            shards: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.array($bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
                workchain: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
                seqno: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
                shard: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
                rootHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
                fileHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
                transactions: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.array($bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
                    account: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
                    hash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
                    lt: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
                }))
            }))
        })
    })
]);
// {"lastPaid":1653099243,"duePayment":null,"used":{"bits":119,"cells":1,"publicCells":0}}
var $c85fad076312f554$var$storageStatCodec = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    lastPaid: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
    duePayment: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.union([
        $bc80ebcf21bfccd0$export$2e2bcd8739ae039.null(),
        $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
    ]),
    used: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        bits: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        cells: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        publicCells: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number()
    })
});
var $c85fad076312f554$var$accountCodec = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    account: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        state: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.union([
            $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
                type: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("uninit")
            }),
            $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
                type: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("active"),
                code: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.union([
                    $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
                    $bc80ebcf21bfccd0$export$2e2bcd8739ae039.null()
                ]),
                data: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.union([
                    $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
                    $bc80ebcf21bfccd0$export$2e2bcd8739ae039.null()
                ])
            }),
            $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
                type: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("frozen"),
                stateHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
            })
        ]),
        balance: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
            coins: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
        }),
        last: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.union([
            $bc80ebcf21bfccd0$export$2e2bcd8739ae039.null(),
            $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
                lt: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
                hash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
            })
        ]),
        storageStat: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.union([
            $bc80ebcf21bfccd0$export$2e2bcd8739ae039.null(),
            $c85fad076312f554$var$storageStatCodec
        ])
    }),
    block: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        workchain: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        seqno: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        shard: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        rootHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        fileHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
    })
});
var $c85fad076312f554$var$accountLiteCodec = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    account: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        state: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.union([
            $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
                type: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("uninit")
            }),
            $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
                type: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("active"),
                codeHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
                dataHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
            }),
            $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
                type: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.literal("frozen"),
                stateHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
            })
        ]),
        balance: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
            coins: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
        }),
        last: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.union([
            $bc80ebcf21bfccd0$export$2e2bcd8739ae039.null(),
            $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
                lt: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
                hash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
            })
        ]),
        storageStat: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.union([
            $bc80ebcf21bfccd0$export$2e2bcd8739ae039.null(),
            $c85fad076312f554$var$storageStatCodec
        ])
    })
});
var $c85fad076312f554$var$changedCodec = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    changed: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.boolean(),
    block: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        workchain: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        seqno: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        shard: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        rootHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        fileHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
    })
});
var $c85fad076312f554$var$runMethodCodec = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    exitCode: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
    resultRaw: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.union([
        $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        $bc80ebcf21bfccd0$export$2e2bcd8739ae039.null()
    ]),
    block: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        workchain: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        seqno: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        shard: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        rootHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        fileHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
    }),
    shardBlock: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        workchain: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        seqno: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        shard: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        rootHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        fileHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
    })
});
var $c85fad076312f554$var$configCodec = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    config: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        cell: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        address: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        globalBalance: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
            coins: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
        })
    })
});
var $c85fad076312f554$var$sendCodec = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    status: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number()
});
var $c85fad076312f554$var$transactionsCodec = $bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
    blocks: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.array($bc80ebcf21bfccd0$export$2e2bcd8739ae039.object({
        workchain: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        seqno: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.number(),
        shard: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        rootHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string(),
        fileHash: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
    })),
    boc: $bc80ebcf21bfccd0$export$2e2bcd8739ae039.string()
});


Object.defineProperty($89095f30c08601be$exports, "TonClient4", {
    enumerable: true,
    get: function get() {
        return $c85fad076312f554$exports.TonClient4;
    }
});
var $fdba46e4509bc411$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $fdba46e4509bc411$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty($fdba46e4509bc411$exports, "__esModule", {
    value: true
});
$fdba46e4509bc411$exports.WalletContractV1R1 = void 0;

var $jWi6z = parcelRequire("jWi6z");
var $636e33f1c2bad335$exports = {};
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty($636e33f1c2bad335$exports, "__esModule", {
    value: true
});
$636e33f1c2bad335$exports.createWalletTransferV4 = $636e33f1c2bad335$exports.createWalletTransferV3 = $636e33f1c2bad335$exports.createWalletTransferV2 = $636e33f1c2bad335$exports.createWalletTransferV1 = void 0;

var $jWi6z = parcelRequire("jWi6z");

var $lusx3 = parcelRequire("lusx3");
function $636e33f1c2bad335$var$createWalletTransferV1(args) {
    // Create message
    var signingMessage = (0, $jWi6z.beginCell)().storeUint(args.seqno, 32);
    if (args.message) {
        signingMessage.storeUint(args.sendMode, 8);
        signingMessage.storeRef((0, $jWi6z.beginCell)().store((0, $jWi6z.storeMessageRelaxed)(args.message)));
    }
    // Sign message
    var signature = (0, $lusx3.sign)(signingMessage.endCell().hash(), args.secretKey);
    // Body
    var body = (0, $jWi6z.beginCell)().storeBuffer(signature).storeBuilder(signingMessage).endCell();
    return body;
}
$636e33f1c2bad335$exports.createWalletTransferV1 = $636e33f1c2bad335$var$createWalletTransferV1;
function $636e33f1c2bad335$var$createWalletTransferV2(args) {
    // Check number of messages
    if (args.messages.length > 4) throw Error("Maximum number of messages in a single transfer is 4");
    // Create message
    var signingMessage = (0, $jWi6z.beginCell)().storeUint(args.seqno, 32);
    if (args.seqno === 0) for(var i = 0; i < 32; i++)signingMessage.storeBit(1);
    else signingMessage.storeUint(args.timeout || Math.floor(Date.now() / 1e3) + 60, 32); // Default timeout: 60 seconds
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = args.messages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var m = _step.value;
            signingMessage.storeUint(args.sendMode, 8);
            signingMessage.storeRef((0, $jWi6z.beginCell)().store((0, $jWi6z.storeMessageRelaxed)(m)));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Sign message
    var signature = (0, $lusx3.sign)(signingMessage.endCell().hash(), args.secretKey);
    // Body
    var body = (0, $jWi6z.beginCell)().storeBuffer(signature).storeBuilder(signingMessage).endCell();
    return body;
}
$636e33f1c2bad335$exports.createWalletTransferV2 = $636e33f1c2bad335$var$createWalletTransferV2;
function $636e33f1c2bad335$var$createWalletTransferV3(args) {
    // Check number of messages
    if (args.messages.length > 4) throw Error("Maximum number of messages in a single transfer is 4");
    // Create message to sign
    var signingMessage = (0, $jWi6z.beginCell)().storeUint(args.walletId, 32);
    if (args.seqno === 0) for(var i = 0; i < 32; i++)signingMessage.storeBit(1);
    else signingMessage.storeUint(args.timeout || Math.floor(Date.now() / 1e3) + 60, 32); // Default timeout: 60 seconds
    signingMessage.storeUint(args.seqno, 32);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = args.messages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var m = _step.value;
            signingMessage.storeUint(args.sendMode, 8);
            signingMessage.storeRef((0, $jWi6z.beginCell)().store((0, $jWi6z.storeMessageRelaxed)(m)));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Sign message
    var signature = (0, $lusx3.sign)(signingMessage.endCell().hash(), args.secretKey);
    // Body
    var body = (0, $jWi6z.beginCell)().storeBuffer(signature).storeBuilder(signingMessage).endCell();
    return body;
}
$636e33f1c2bad335$exports.createWalletTransferV3 = $636e33f1c2bad335$var$createWalletTransferV3;
function $636e33f1c2bad335$var$createWalletTransferV4(args) {
    // Check number of messages
    if (args.messages.length > 4) throw Error("Maximum number of messages in a single transfer is 4");
    var signingMessage = (0, $jWi6z.beginCell)().storeUint(args.walletId, 32);
    if (args.seqno === 0) for(var i = 0; i < 32; i++)signingMessage.storeBit(1);
    else signingMessage.storeUint(args.timeout || Math.floor(Date.now() / 1e3) + 60, 32); // Default timeout: 60 seconds
    signingMessage.storeUint(args.seqno, 32);
    signingMessage.storeUint(0, 8); // Simple order
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = args.messages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var m = _step.value;
            signingMessage.storeUint(args.sendMode, 8);
            signingMessage.storeRef((0, $jWi6z.beginCell)().store((0, $jWi6z.storeMessageRelaxed)(m)));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Sign message
    var signature = (0, $lusx3.sign)(signingMessage.endCell().hash(), args.secretKey);
    // Body
    var body = (0, $jWi6z.beginCell)().storeBuffer(signature).storeBuilder(signingMessage).endCell();
    return body;
}
$636e33f1c2bad335$exports.createWalletTransferV4 = $636e33f1c2bad335$var$createWalletTransferV4;


var $fdba46e4509bc411$var$WalletContractV1R1 = /*#__PURE__*/ function() {
    "use strict";
    function WalletContractV1R1(workchain, publicKey) {
        (0, $978gY._)(this, WalletContractV1R1);
        this.workchain = workchain;
        this.publicKey = publicKey;
        // Build initial code and data
        var code = $jWi6z.Cell.fromBoc($fdba46e4509bc411$require$Buffer.from("te6cckEBAQEARAAAhP8AIN2k8mCBAgDXGCDXCx/tRNDTH9P/0VESuvKhIvkBVBBE+RDyovgAAdMfMSDXSpbTB9QC+wDe0aTIyx/L/8ntVEH98Ik=", "base64"))[0];
        var data = (0, $jWi6z.beginCell)().storeUint(0, 32) // Seqno
        .storeBuffer(publicKey).endCell();
        this.init = {
            code: code,
            data: data
        };
        this.address = (0, $jWi6z.contractAddress)(workchain, {
            code: code,
            data: data
        });
    }
    (0, $kry2a._)(WalletContractV1R1, [
        {
            key: "getBalance",
            value: /**
     * Get Wallet Balance
     */ function getBalance(provider) {
                return (0, $byzP8._)(function() {
                    var state;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                return [
                                    2,
                                    state.balance
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSeqno",
            value: /**
     * Get Wallet Seqno
     */ function getSeqno(provider) {
                return (0, $byzP8._)(function() {
                    var state;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                if (state.state.type === "active") return [
                                    2,
                                    $jWi6z.Cell.fromBoc(state.state.data)[0].beginParse().loadUint(32)
                                ];
                                else return [
                                    2,
                                    0
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "send",
            value: /**
     * Send signed transfer
     */ function send(provider, message) {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.external(message)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTransfer",
            value: /**
     * Sign and send transfer
     */ function sendTransfer(provider, args) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var transfer;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                transfer = _this.createTransfer(args);
                                return [
                                    4,
                                    _this.send(provider, transfer)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Create signed transfer
     */ key: "createTransfer",
            value: function createTransfer(args) {
                var sendMode = $jWi6z.SendMode.PAY_GAS_SEPARATELY;
                if (args.sendMode !== null && args.sendMode !== undefined) sendMode = args.sendMode;
                return (0, $636e33f1c2bad335$exports.createWalletTransferV1)({
                    seqno: args.seqno,
                    sendMode: sendMode,
                    secretKey: args.secretKey,
                    message: args.message
                });
            }
        },
        {
            /**
     * Create sender
     */ key: "sender",
            value: function sender(provider, secretKey) {
                var _this = this;
                return {
                    send: function() {
                        var _ref = (0, $byzP8._)(function(args) {
                            var seqno, transfer;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this.getSeqno(provider)
                                        ];
                                    case 1:
                                        seqno = _state.sent();
                                        transfer = _this.createTransfer({
                                            seqno: seqno,
                                            secretKey: secretKey,
                                            sendMode: args.sendMode,
                                            message: (0, $jWi6z.internal)({
                                                to: args.to,
                                                value: args.value,
                                                init: args.init,
                                                body: args.body,
                                                bounce: args.bounce
                                            })
                                        });
                                        return [
                                            4,
                                            _this.send(provider, transfer)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(args) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                };
            }
        }
    ], [
        {
            key: "create",
            value: function create(args) {
                return new WalletContractV1R1(args.workchain, args.publicKey);
            }
        }
    ]);
    return WalletContractV1R1;
}();
$fdba46e4509bc411$exports.WalletContractV1R1 = $fdba46e4509bc411$var$WalletContractV1R1;


Object.defineProperty($89095f30c08601be$exports, "WalletContractV1R1", {
    enumerable: true,
    get: function get() {
        return $fdba46e4509bc411$exports.WalletContractV1R1;
    }
});
var $006cf3cecda15f42$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $006cf3cecda15f42$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty($006cf3cecda15f42$exports, "__esModule", {
    value: true
});
$006cf3cecda15f42$exports.WalletContractV1R2 = void 0;

var $jWi6z = parcelRequire("jWi6z");

var $006cf3cecda15f42$var$WalletContractV1R2 = /*#__PURE__*/ function() {
    "use strict";
    function WalletContractV1R2(workchain, publicKey) {
        (0, $978gY._)(this, WalletContractV1R2);
        this.workchain = workchain;
        this.publicKey = publicKey;
        // Build initial code and data
        var code = $jWi6z.Cell.fromBoc($006cf3cecda15f42$require$Buffer.from("te6cckEBAQEAUwAAov8AIN0gggFMl7qXMO1E0NcLH+Ck8mCBAgDXGCDXCx/tRNDTH9P/0VESuvKhIvkBVBBE+RDyovgAAdMfMSDXSpbTB9QC+wDe0aTIyx/L/8ntVNDieG8=", "base64"))[0];
        var data = (0, $jWi6z.beginCell)().storeUint(0, 32) // Seqno
        .storeBuffer(publicKey).endCell();
        this.init = {
            code: code,
            data: data
        };
        this.address = (0, $jWi6z.contractAddress)(workchain, {
            code: code,
            data: data
        });
    }
    (0, $kry2a._)(WalletContractV1R2, [
        {
            key: "getBalance",
            value: /**
     * Get Wallet Balance
     */ function getBalance(provider) {
                return (0, $byzP8._)(function() {
                    var state;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                return [
                                    2,
                                    state.balance
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSeqno",
            value: /**
     * Get Wallet Seqno
     */ function getSeqno(provider) {
                return (0, $byzP8._)(function() {
                    var state, res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                if (!(state.state.type === "active")) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    provider.get("seqno", [])
                                ];
                            case 2:
                                res = _state.sent();
                                return [
                                    2,
                                    res.stack.readNumber()
                                ];
                            case 3:
                                return [
                                    2,
                                    0
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "send",
            value: /**
     * Send signed transfer
     */ function send(provider, message) {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.external(message)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTransfer",
            value: /**
     * Sign and send transfer
     */ function sendTransfer(provider, args) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var transfer;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                transfer = _this.createTransfer(args);
                                return [
                                    4,
                                    _this.send(provider, transfer)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Create signed transfer
     */ key: "createTransfer",
            value: function createTransfer(args) {
                var sendMode = $jWi6z.SendMode.PAY_GAS_SEPARATELY;
                if (args.sendMode !== null && args.sendMode !== undefined) sendMode = args.sendMode;
                return (0, $636e33f1c2bad335$exports.createWalletTransferV1)({
                    seqno: args.seqno,
                    sendMode: sendMode,
                    secretKey: args.secretKey,
                    message: args.message
                });
            }
        },
        {
            /**
     * Create sender
     */ key: "sender",
            value: function sender(provider, secretKey) {
                var _this = this;
                return {
                    send: function() {
                        var _ref = (0, $byzP8._)(function(args) {
                            var seqno, transfer;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this.getSeqno(provider)
                                        ];
                                    case 1:
                                        seqno = _state.sent();
                                        transfer = _this.createTransfer({
                                            seqno: seqno,
                                            secretKey: secretKey,
                                            sendMode: args.sendMode,
                                            message: (0, $jWi6z.internal)({
                                                to: args.to,
                                                value: args.value,
                                                init: args.init,
                                                body: args.body,
                                                bounce: args.bounce
                                            })
                                        });
                                        return [
                                            4,
                                            _this.send(provider, transfer)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(args) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                };
            }
        }
    ], [
        {
            key: "create",
            value: function create(args) {
                return new WalletContractV1R2(args.workchain, args.publicKey);
            }
        }
    ]);
    return WalletContractV1R2;
}();
$006cf3cecda15f42$exports.WalletContractV1R2 = $006cf3cecda15f42$var$WalletContractV1R2;


Object.defineProperty($89095f30c08601be$exports, "WalletContractV1R2", {
    enumerable: true,
    get: function get() {
        return $006cf3cecda15f42$exports.WalletContractV1R2;
    }
});
var $9fe0ba937b7cc8ea$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $9fe0ba937b7cc8ea$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty($9fe0ba937b7cc8ea$exports, "__esModule", {
    value: true
});
$9fe0ba937b7cc8ea$exports.WalletContractV1R3 = void 0;

var $jWi6z = parcelRequire("jWi6z");

var $9fe0ba937b7cc8ea$var$WalletContractV1R3 = /*#__PURE__*/ function() {
    "use strict";
    function WalletContractV1R3(workchain, publicKey) {
        (0, $978gY._)(this, WalletContractV1R3);
        this.workchain = workchain;
        this.publicKey = publicKey;
        // Build initial code and data
        var code = $jWi6z.Cell.fromBoc($9fe0ba937b7cc8ea$require$Buffer.from("te6cckEBAQEAXwAAuv8AIN0gggFMl7ohggEznLqxnHGw7UTQ0x/XC//jBOCk8mCBAgDXGCDXCx/tRNDTH9P/0VESuvKhIvkBVBBE+RDyovgAAdMfMSDXSpbTB9QC+wDe0aTIyx/L/8ntVLW4bkI=", "base64"))[0];
        var data = (0, $jWi6z.beginCell)().storeUint(0, 32) // Seqno
        .storeBuffer(publicKey).endCell();
        this.init = {
            code: code,
            data: data
        };
        this.address = (0, $jWi6z.contractAddress)(workchain, {
            code: code,
            data: data
        });
    }
    (0, $kry2a._)(WalletContractV1R3, [
        {
            key: "getBalance",
            value: /**
     * Get Wallet Balance
     */ function getBalance(provider) {
                return (0, $byzP8._)(function() {
                    var state;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                return [
                                    2,
                                    state.balance
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSeqno",
            value: /**
     * Get Wallet Seqno
     */ function getSeqno(provider) {
                return (0, $byzP8._)(function() {
                    var state, res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                if (!(state.state.type === "active")) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    provider.get("seqno", [])
                                ];
                            case 2:
                                res = _state.sent();
                                return [
                                    2,
                                    res.stack.readNumber()
                                ];
                            case 3:
                                return [
                                    2,
                                    0
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "send",
            value: /**
     * Send signed transfer
     */ function send(executor, message) {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    executor.external(message)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTransfer",
            value: /**
     * Sign and send transfer
     */ function sendTransfer(provider, args) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var transfer;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                transfer = _this.createTransfer(args);
                                return [
                                    4,
                                    _this.send(provider, transfer)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Create signed transfer
     */ key: "createTransfer",
            value: function createTransfer(args) {
                var sendMode = $jWi6z.SendMode.PAY_GAS_SEPARATELY;
                if (args.sendMode !== null && args.sendMode !== undefined) sendMode = args.sendMode;
                return (0, $636e33f1c2bad335$exports.createWalletTransferV1)({
                    seqno: args.seqno,
                    sendMode: sendMode,
                    secretKey: args.secretKey,
                    message: args.message
                });
            }
        },
        {
            /**
     * Create sender
     */ key: "sender",
            value: function sender(provider, secretKey) {
                var _this = this;
                return {
                    send: function() {
                        var _ref = (0, $byzP8._)(function(args) {
                            var seqno, transfer;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this.getSeqno(provider)
                                        ];
                                    case 1:
                                        seqno = _state.sent();
                                        transfer = _this.createTransfer({
                                            seqno: seqno,
                                            secretKey: secretKey,
                                            sendMode: args.sendMode,
                                            message: (0, $jWi6z.internal)({
                                                to: args.to,
                                                value: args.value,
                                                init: args.init,
                                                body: args.body,
                                                bounce: args.bounce
                                            })
                                        });
                                        return [
                                            4,
                                            _this.send(provider, transfer)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(args) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                };
            }
        }
    ], [
        {
            key: "create",
            value: function create(args) {
                return new WalletContractV1R3(args.workchain, args.publicKey);
            }
        }
    ]);
    return WalletContractV1R3;
}();
$9fe0ba937b7cc8ea$exports.WalletContractV1R3 = $9fe0ba937b7cc8ea$var$WalletContractV1R3;


Object.defineProperty($89095f30c08601be$exports, "WalletContractV1R3", {
    enumerable: true,
    get: function get() {
        return $9fe0ba937b7cc8ea$exports.WalletContractV1R3;
    }
});
var $6300069e29e07ed9$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $6300069e29e07ed9$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty($6300069e29e07ed9$exports, "__esModule", {
    value: true
});
$6300069e29e07ed9$exports.WalletContractV2R1 = void 0;

var $jWi6z = parcelRequire("jWi6z");

var $6300069e29e07ed9$var$WalletContractV2R1 = /*#__PURE__*/ function() {
    "use strict";
    function WalletContractV2R1(workchain, publicKey) {
        (0, $978gY._)(this, WalletContractV2R1);
        this.workchain = workchain;
        this.publicKey = publicKey;
        // Build initial code and data
        var code = $jWi6z.Cell.fromBoc($6300069e29e07ed9$require$Buffer.from("te6cckEBAQEAVwAAqv8AIN0gggFMl7qXMO1E0NcLH+Ck8mCDCNcYINMf0x8B+CO78mPtRNDTH9P/0VExuvKhA/kBVBBC+RDyovgAApMg10qW0wfUAvsA6NGkyMsfy//J7VShNwu2", "base64"))[0];
        var data = (0, $jWi6z.beginCell)().storeUint(0, 32) // Seqno
        .storeBuffer(publicKey).endCell();
        this.init = {
            code: code,
            data: data
        };
        this.address = (0, $jWi6z.contractAddress)(workchain, {
            code: code,
            data: data
        });
    }
    (0, $kry2a._)(WalletContractV2R1, [
        {
            key: "getBalance",
            value: /**
     * Get Wallet Balance
     */ function getBalance(provider) {
                return (0, $byzP8._)(function() {
                    var state;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                return [
                                    2,
                                    state.balance
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSeqno",
            value: /**
     * Get Wallet Seqno
     */ function getSeqno(provider) {
                return (0, $byzP8._)(function() {
                    var state, res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                if (!(state.state.type === "active")) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    provider.get("seqno", [])
                                ];
                            case 2:
                                res = _state.sent();
                                return [
                                    2,
                                    res.stack.readNumber()
                                ];
                            case 3:
                                return [
                                    2,
                                    0
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "send",
            value: /**
     * Send signed transfer
     */ function send(provider, message) {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.external(message)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTransfer",
            value: /**
     * Sign and send transfer
     */ function sendTransfer(provider, args) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var transfer;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                transfer = _this.createTransfer(args);
                                return [
                                    4,
                                    _this.send(provider, transfer)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Create signed transfer
     */ key: "createTransfer",
            value: function createTransfer(args) {
                var sendMode = $jWi6z.SendMode.PAY_GAS_SEPARATELY;
                if (args.sendMode !== null && args.sendMode !== undefined) sendMode = args.sendMode;
                return (0, $636e33f1c2bad335$exports.createWalletTransferV2)({
                    seqno: args.seqno,
                    sendMode: sendMode,
                    secretKey: args.secretKey,
                    messages: args.messages,
                    timeout: args.timeout
                });
            }
        },
        {
            /**
     * Create sender
     */ key: "sender",
            value: function sender(provider, secretKey) {
                var _this = this;
                return {
                    send: function() {
                        var _ref = (0, $byzP8._)(function(args) {
                            var seqno, transfer;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this.getSeqno(provider)
                                        ];
                                    case 1:
                                        seqno = _state.sent();
                                        transfer = _this.createTransfer({
                                            seqno: seqno,
                                            secretKey: secretKey,
                                            sendMode: args.sendMode,
                                            messages: [
                                                (0, $jWi6z.internal)({
                                                    to: args.to,
                                                    value: args.value,
                                                    init: args.init,
                                                    body: args.body,
                                                    bounce: args.bounce
                                                })
                                            ]
                                        });
                                        return [
                                            4,
                                            _this.send(provider, transfer)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(args) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                };
            }
        }
    ], [
        {
            key: "create",
            value: function create(args) {
                return new WalletContractV2R1(args.workchain, args.publicKey);
            }
        }
    ]);
    return WalletContractV2R1;
}();
$6300069e29e07ed9$exports.WalletContractV2R1 = $6300069e29e07ed9$var$WalletContractV2R1;


Object.defineProperty($89095f30c08601be$exports, "WalletContractV2R1", {
    enumerable: true,
    get: function get() {
        return $6300069e29e07ed9$exports.WalletContractV2R1;
    }
});
var $cf6e033c69d3bf8b$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $cf6e033c69d3bf8b$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty($cf6e033c69d3bf8b$exports, "__esModule", {
    value: true
});
$cf6e033c69d3bf8b$exports.WalletContractV2R2 = void 0;

var $jWi6z = parcelRequire("jWi6z");

var $cf6e033c69d3bf8b$var$WalletContractV2R2 = /*#__PURE__*/ function() {
    "use strict";
    function WalletContractV2R2(workchain, publicKey) {
        (0, $978gY._)(this, WalletContractV2R2);
        this.workchain = workchain;
        this.publicKey = publicKey;
        // Build initial code and data
        var code = $jWi6z.Cell.fromBoc($cf6e033c69d3bf8b$require$Buffer.from("te6cckEBAQEAYwAAwv8AIN0gggFMl7ohggEznLqxnHGw7UTQ0x/XC//jBOCk8mCDCNcYINMf0x8B+CO78mPtRNDTH9P/0VExuvKhA/kBVBBC+RDyovgAApMg10qW0wfUAvsA6NGkyMsfy//J7VQETNeh", "base64"))[0];
        var data = (0, $jWi6z.beginCell)().storeUint(0, 32) // Seqno
        .storeBuffer(publicKey).endCell();
        this.init = {
            code: code,
            data: data
        };
        this.address = (0, $jWi6z.contractAddress)(workchain, {
            code: code,
            data: data
        });
    }
    (0, $kry2a._)(WalletContractV2R2, [
        {
            key: "getBalance",
            value: /**
     * Get Wallet Balance
     */ function getBalance(provider) {
                return (0, $byzP8._)(function() {
                    var state;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                return [
                                    2,
                                    state.balance
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSeqno",
            value: /**
     * Get Wallet Seqno
     */ function getSeqno(provider) {
                return (0, $byzP8._)(function() {
                    var state, res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                if (!(state.state.type === "active")) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    provider.get("seqno", [])
                                ];
                            case 2:
                                res = _state.sent();
                                return [
                                    2,
                                    res.stack.readNumber()
                                ];
                            case 3:
                                return [
                                    2,
                                    0
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "send",
            value: /**
     * Send signed transfer
     */ function send(provider, message) {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.external(message)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTransfer",
            value: /**
     * Sign and send transfer
     */ function sendTransfer(provider, args) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var transfer;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                transfer = _this.createTransfer(args);
                                return [
                                    4,
                                    _this.send(provider, transfer)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Create signed transfer
     */ key: "createTransfer",
            value: function createTransfer(args) {
                var sendMode = $jWi6z.SendMode.PAY_GAS_SEPARATELY;
                if (args.sendMode !== null && args.sendMode !== undefined) sendMode = args.sendMode;
                return (0, $636e33f1c2bad335$exports.createWalletTransferV2)({
                    seqno: args.seqno,
                    sendMode: sendMode,
                    secretKey: args.secretKey,
                    messages: args.messages,
                    timeout: args.timeout
                });
            }
        },
        {
            /**
     * Create sender
     */ key: "sender",
            value: function sender(provider, secretKey) {
                var _this = this;
                return {
                    send: function() {
                        var _ref = (0, $byzP8._)(function(args) {
                            var seqno, transfer;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this.getSeqno(provider)
                                        ];
                                    case 1:
                                        seqno = _state.sent();
                                        transfer = _this.createTransfer({
                                            seqno: seqno,
                                            secretKey: secretKey,
                                            sendMode: args.sendMode,
                                            messages: [
                                                (0, $jWi6z.internal)({
                                                    to: args.to,
                                                    value: args.value,
                                                    init: args.init,
                                                    body: args.body,
                                                    bounce: args.bounce
                                                })
                                            ]
                                        });
                                        return [
                                            4,
                                            _this.send(provider, transfer)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(args) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                };
            }
        }
    ], [
        {
            key: "create",
            value: function create(args) {
                return new WalletContractV2R2(args.workchain, args.publicKey);
            }
        }
    ]);
    return WalletContractV2R2;
}();
$cf6e033c69d3bf8b$exports.WalletContractV2R2 = $cf6e033c69d3bf8b$var$WalletContractV2R2;


Object.defineProperty($89095f30c08601be$exports, "WalletContractV2R2", {
    enumerable: true,
    get: function get() {
        return $cf6e033c69d3bf8b$exports.WalletContractV2R2;
    }
});
var $fd1e20099f94b460$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $fd1e20099f94b460$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty($fd1e20099f94b460$exports, "__esModule", {
    value: true
});
$fd1e20099f94b460$exports.WalletContractV3R1 = void 0;

var $jWi6z = parcelRequire("jWi6z");

var $fd1e20099f94b460$var$WalletContractV3R1 = /*#__PURE__*/ function() {
    "use strict";
    function WalletContractV3R1(workchain, publicKey, walletId) {
        (0, $978gY._)(this, WalletContractV3R1);
        // Resolve parameters
        this.workchain = workchain;
        this.publicKey = publicKey;
        if (walletId !== null && walletId !== undefined) this.walletId = walletId;
        else this.walletId = 698983191 + workchain;
        // Build initial code and data
        var code = $jWi6z.Cell.fromBoc($fd1e20099f94b460$require$Buffer.from("te6cckEBAQEAYgAAwP8AIN0gggFMl7qXMO1E0NcLH+Ck8mCDCNcYINMf0x/TH/gjE7vyY+1E0NMf0x/T/9FRMrryoVFEuvKiBPkBVBBV+RDyo/gAkyDXSpbTB9QC+wDo0QGkyMsfyx/L/8ntVD++buA=", "base64"))[0];
        var data = (0, $jWi6z.beginCell)().storeUint(0, 32) // Seqno
        .storeUint(this.walletId, 32).storeBuffer(publicKey).endCell();
        this.init = {
            code: code,
            data: data
        };
        this.address = (0, $jWi6z.contractAddress)(workchain, {
            code: code,
            data: data
        });
    }
    (0, $kry2a._)(WalletContractV3R1, [
        {
            key: "getBalance",
            value: /**
     * Get wallet balance
     */ function getBalance(provider) {
                return (0, $byzP8._)(function() {
                    var state;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                return [
                                    2,
                                    state.balance
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSeqno",
            value: /**
     * Get Wallet Seqno
     */ function getSeqno(provider) {
                return (0, $byzP8._)(function() {
                    var state, res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                if (!(state.state.type === "active")) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    provider.get("seqno", [])
                                ];
                            case 2:
                                res = _state.sent();
                                return [
                                    2,
                                    res.stack.readNumber()
                                ];
                            case 3:
                                return [
                                    2,
                                    0
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "send",
            value: /**
     * Send signed transfer
     */ function send(provider, message) {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.external(message)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTransfer",
            value: /**
     * Sign and send transfer
     */ function sendTransfer(provider, args) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var transfer;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                transfer = _this.createTransfer(args);
                                return [
                                    4,
                                    _this.send(provider, transfer)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Create transfer
     */ key: "createTransfer",
            value: function createTransfer(args) {
                var sendMode = $jWi6z.SendMode.PAY_GAS_SEPARATELY;
                if (args.sendMode !== null && args.sendMode !== undefined) sendMode = args.sendMode;
                return (0, $636e33f1c2bad335$exports.createWalletTransferV3)({
                    seqno: args.seqno,
                    sendMode: sendMode,
                    secretKey: args.secretKey,
                    messages: args.messages,
                    timeout: args.timeout,
                    walletId: this.walletId
                });
            }
        },
        {
            /**
     * Create sender
     */ key: "sender",
            value: function sender(provider, secretKey) {
                var _this = this;
                return {
                    send: function() {
                        var _ref = (0, $byzP8._)(function(args) {
                            var seqno, transfer;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this.getSeqno(provider)
                                        ];
                                    case 1:
                                        seqno = _state.sent();
                                        transfer = _this.createTransfer({
                                            seqno: seqno,
                                            secretKey: secretKey,
                                            sendMode: args.sendMode,
                                            messages: [
                                                (0, $jWi6z.internal)({
                                                    to: args.to,
                                                    value: args.value,
                                                    init: args.init,
                                                    body: args.body,
                                                    bounce: args.bounce
                                                })
                                            ]
                                        });
                                        return [
                                            4,
                                            _this.send(provider, transfer)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(args) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                };
            }
        }
    ], [
        {
            key: "create",
            value: function create(args) {
                return new WalletContractV3R1(args.workchain, args.publicKey, args.walletId);
            }
        }
    ]);
    return WalletContractV3R1;
}();
$fd1e20099f94b460$exports.WalletContractV3R1 = $fd1e20099f94b460$var$WalletContractV3R1;


Object.defineProperty($89095f30c08601be$exports, "WalletContractV3R1", {
    enumerable: true,
    get: function get() {
        return $fd1e20099f94b460$exports.WalletContractV3R1;
    }
});
var $ed87e88a845a862a$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $ed87e88a845a862a$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty($ed87e88a845a862a$exports, "__esModule", {
    value: true
});
$ed87e88a845a862a$exports.WalletContractV3R2 = void 0;

var $jWi6z = parcelRequire("jWi6z");

var $ed87e88a845a862a$var$WalletContractV3R2 = /*#__PURE__*/ function() {
    "use strict";
    function WalletContractV3R2(workchain, publicKey, walletId) {
        (0, $978gY._)(this, WalletContractV3R2);
        // Resolve parameters
        this.workchain = workchain;
        this.publicKey = publicKey;
        if (walletId !== null && walletId !== undefined) this.walletId = walletId;
        else this.walletId = 698983191 + workchain;
        // Build initial code and data
        var code = $jWi6z.Cell.fromBoc($ed87e88a845a862a$require$Buffer.from("te6cckEBAQEAcQAA3v8AIN0gggFMl7ohggEznLqxn3Gw7UTQ0x/THzHXC//jBOCk8mCDCNcYINMf0x/TH/gjE7vyY+1E0NMf0x/T/9FRMrryoVFEuvKiBPkBVBBV+RDyo/gAkyDXSpbTB9QC+wDo0QGkyMsfyx/L/8ntVBC9ba0=", "base64"))[0];
        var data = (0, $jWi6z.beginCell)().storeUint(0, 32) // Seqno
        .storeUint(this.walletId, 32).storeBuffer(publicKey).endCell();
        this.init = {
            code: code,
            data: data
        };
        this.address = (0, $jWi6z.contractAddress)(workchain, {
            code: code,
            data: data
        });
    }
    (0, $kry2a._)(WalletContractV3R2, [
        {
            key: "getBalance",
            value: /**
     * Get wallet balance
     */ function getBalance(provider) {
                return (0, $byzP8._)(function() {
                    var state;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                return [
                                    2,
                                    state.balance
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSeqno",
            value: /**
     * Get Wallet Seqno
     */ function getSeqno(provider) {
                return (0, $byzP8._)(function() {
                    var state, res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                if (!(state.state.type === "active")) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    provider.get("seqno", [])
                                ];
                            case 2:
                                res = _state.sent();
                                return [
                                    2,
                                    res.stack.readNumber()
                                ];
                            case 3:
                                return [
                                    2,
                                    0
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "send",
            value: /**
     * Send signed transfer
     */ function send(provider, message) {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.external(message)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTransfer",
            value: /**
     * Sign and send transfer
     */ function sendTransfer(provider, args) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var transfer;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                transfer = _this.createTransfer(args);
                                return [
                                    4,
                                    _this.send(provider, transfer)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Create transfer
     */ key: "createTransfer",
            value: function createTransfer(args) {
                var sendMode = $jWi6z.SendMode.PAY_GAS_SEPARATELY;
                if (args.sendMode !== null && args.sendMode !== undefined) sendMode = args.sendMode;
                return (0, $636e33f1c2bad335$exports.createWalletTransferV3)({
                    seqno: args.seqno,
                    sendMode: sendMode,
                    secretKey: args.secretKey,
                    messages: args.messages,
                    timeout: args.timeout,
                    walletId: this.walletId
                });
            }
        },
        {
            /**
     * Create sender
     */ key: "sender",
            value: function sender(provider, secretKey) {
                var _this = this;
                return {
                    send: function() {
                        var _ref = (0, $byzP8._)(function(args) {
                            var seqno, transfer;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this.getSeqno(provider)
                                        ];
                                    case 1:
                                        seqno = _state.sent();
                                        transfer = _this.createTransfer({
                                            seqno: seqno,
                                            secretKey: secretKey,
                                            sendMode: args.sendMode,
                                            messages: [
                                                (0, $jWi6z.internal)({
                                                    to: args.to,
                                                    value: args.value,
                                                    init: args.init,
                                                    body: args.body,
                                                    bounce: args.bounce
                                                })
                                            ]
                                        });
                                        return [
                                            4,
                                            _this.send(provider, transfer)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(args) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                };
            }
        }
    ], [
        {
            key: "create",
            value: function create(args) {
                return new WalletContractV3R2(args.workchain, args.publicKey, args.walletId);
            }
        }
    ]);
    return WalletContractV3R2;
}();
$ed87e88a845a862a$exports.WalletContractV3R2 = $ed87e88a845a862a$var$WalletContractV3R2;


Object.defineProperty($89095f30c08601be$exports, "WalletContractV3R2", {
    enumerable: true,
    get: function get() {
        return $ed87e88a845a862a$exports.WalletContractV3R2;
    }
});
var $7dcae9c97e49f765$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $7dcae9c97e49f765$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty($7dcae9c97e49f765$exports, "__esModule", {
    value: true
});
$7dcae9c97e49f765$exports.WalletContractV4 = void 0;

var $jWi6z = parcelRequire("jWi6z");

var $7dcae9c97e49f765$var$WalletContractV4 = /*#__PURE__*/ function() {
    "use strict";
    function WalletContractV4(workchain, publicKey, walletId) {
        (0, $978gY._)(this, WalletContractV4);
        // Resolve parameters
        this.workchain = workchain;
        this.publicKey = publicKey;
        if (walletId !== null && walletId !== undefined) this.walletId = walletId;
        else this.walletId = 698983191 + workchain;
        // Build initial code and data
        var code = $jWi6z.Cell.fromBoc($7dcae9c97e49f765$require$Buffer.from("te6ccgECFAEAAtQAART/APSkE/S88sgLAQIBIAIDAgFIBAUE+PKDCNcYINMf0x/THwL4I7vyZO1E0NMf0x/T//QE0VFDuvKhUVG68qIF+QFUEGT5EPKj+AAkpMjLH1JAyx9SMMv/UhD0AMntVPgPAdMHIcAAn2xRkyDXSpbTB9QC+wDoMOAhwAHjACHAAuMAAcADkTDjDQOkyMsfEssfy/8QERITAubQAdDTAyFxsJJfBOAi10nBIJJfBOAC0x8hghBwbHVnvSKCEGRzdHK9sJJfBeAD+kAwIPpEAcjKB8v/ydDtRNCBAUDXIfQEMFyBAQj0Cm+hMbOSXwfgBdM/yCWCEHBsdWe6kjgw4w0DghBkc3RyupJfBuMNBgcCASAICQB4AfoA9AQw+CdvIjBQCqEhvvLgUIIQcGx1Z4MesXCAGFAEywUmzxZY+gIZ9ADLaRfLH1Jgyz8gyYBA+wAGAIpQBIEBCPRZMO1E0IEBQNcgyAHPFvQAye1UAXKwjiOCEGRzdHKDHrFwgBhQBcsFUAPPFiP6AhPLassfyz/JgED7AJJfA+ICASAKCwBZvSQrb2omhAgKBrkPoCGEcNQICEekk30pkQzmkD6f+YN4EoAbeBAUiYcVnzGEAgFYDA0AEbjJftRNDXCx+AA9sp37UTQgQFA1yH0BDACyMoHy//J0AGBAQj0Cm+hMYAIBIA4PABmtznaiaEAga5Drhf/AABmvHfaiaEAQa5DrhY/AAG7SB/oA1NQi+QAFyMoHFcv/ydB3dIAYyMsFywIizxZQBfoCFMtrEszMyXP7AMhAFIEBCPRR8qcCAHCBAQjXGPoA0z/IVCBHgQEI9FHyp4IQbm90ZXB0gBjIywXLAlAGzxZQBPoCFMtqEssfyz/Jc/sAAgBsgQEI1xj6ANM/MFIkgQEI9Fnyp4IQZHN0cnB0gBjIywXLAlAFzxZQA/oCE8tqyx8Syz/Jc/sAAAr0AMntVA==", "base64"))[0];
        var data = (0, $jWi6z.beginCell)().storeUint(0, 32) // Seqno
        .storeUint(this.walletId, 32).storeBuffer(this.publicKey).storeBit(0) // Empty plugins dict
        .endCell();
        this.init = {
            code: code,
            data: data
        };
        this.address = (0, $jWi6z.contractAddress)(workchain, {
            code: code,
            data: data
        });
    }
    (0, $kry2a._)(WalletContractV4, [
        {
            key: "getBalance",
            value: /**
     * Get Wallet Balance
     */ function getBalance(provider) {
                return (0, $byzP8._)(function() {
                    var state;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                return [
                                    2,
                                    state.balance
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSeqno",
            value: /**
     * Get Wallet Seqno
     */ function getSeqno(provider) {
                return (0, $byzP8._)(function() {
                    var state, res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                if (!(state.state.type === "active")) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    provider.get("seqno", [])
                                ];
                            case 2:
                                res = _state.sent();
                                return [
                                    2,
                                    res.stack.readNumber()
                                ];
                            case 3:
                                return [
                                    2,
                                    0
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "send",
            value: /**
     * Send signed transfer
     */ function send(provider, message) {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.external(message)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTransfer",
            value: /**
     * Sign and send transfer
     */ function sendTransfer(provider, args) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var transfer;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                transfer = _this.createTransfer(args);
                                return [
                                    4,
                                    _this.send(provider, transfer)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Create signed transfer
     */ key: "createTransfer",
            value: function createTransfer(args) {
                var sendMode = $jWi6z.SendMode.PAY_GAS_SEPARATELY;
                if (args.sendMode !== null && args.sendMode !== undefined) sendMode = args.sendMode;
                return (0, $636e33f1c2bad335$exports.createWalletTransferV4)({
                    seqno: args.seqno,
                    sendMode: sendMode,
                    secretKey: args.secretKey,
                    messages: args.messages,
                    timeout: args.timeout,
                    walletId: this.walletId
                });
            }
        },
        {
            /**
     * Create sender
     */ key: "sender",
            value: function sender(provider, secretKey) {
                var _this = this;
                return {
                    send: function() {
                        var _ref = (0, $byzP8._)(function(args) {
                            var seqno, transfer;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this.getSeqno(provider)
                                        ];
                                    case 1:
                                        seqno = _state.sent();
                                        transfer = _this.createTransfer({
                                            seqno: seqno,
                                            secretKey: secretKey,
                                            sendMode: args.sendMode,
                                            messages: [
                                                (0, $jWi6z.internal)({
                                                    to: args.to,
                                                    value: args.value,
                                                    init: args.init,
                                                    body: args.body,
                                                    bounce: args.bounce
                                                })
                                            ]
                                        });
                                        return [
                                            4,
                                            _this.send(provider, transfer)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(args) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                };
            }
        }
    ], [
        {
            key: "create",
            value: function create(args) {
                return new WalletContractV4(args.workchain, args.publicKey, args.walletId);
            }
        }
    ]);
    return WalletContractV4;
}();
$7dcae9c97e49f765$exports.WalletContractV4 = $7dcae9c97e49f765$var$WalletContractV4;


Object.defineProperty($89095f30c08601be$exports, "WalletContractV4", {
    enumerable: true,
    get: function get() {
        return $7dcae9c97e49f765$exports.WalletContractV4;
    }
});
var $27d8b6c1849938de$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty($27d8b6c1849938de$exports, "__esModule", {
    value: true
});
$27d8b6c1849938de$exports.JettonMaster = void 0;

var $jWi6z = parcelRequire("jWi6z");
var $27d8b6c1849938de$var$JettonMaster = /*#__PURE__*/ function() {
    function JettonMaster(address) {
        (0, $978gY._)(this, JettonMaster);
        this.address = address;
    }
    (0, $kry2a._)(JettonMaster, [
        {
            key: "getWalletAddress",
            value: function getWalletAddress(provider, owner) {
                return (0, $byzP8._)(function() {
                    var res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.get("get_wallet_address", [
                                        {
                                            type: "slice",
                                            cell: (0, $jWi6z.beginCell)().storeAddress(owner).endCell()
                                        }
                                    ])
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    2,
                                    res.stack.readAddress()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getJettonData",
            value: function getJettonData(provider) {
                return (0, $byzP8._)(function() {
                    var res, totalSupply, mintable, adminAddress, content, walletCode;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.get("get_jetton_data", [])
                                ];
                            case 1:
                                res = _state.sent();
                                totalSupply = res.stack.readBigNumber();
                                mintable = res.stack.readBoolean();
                                adminAddress = res.stack.readAddress();
                                content = res.stack.readCell();
                                walletCode = res.stack.readCell();
                                return [
                                    2,
                                    {
                                        totalSupply: totalSupply,
                                        mintable: mintable,
                                        adminAddress: adminAddress,
                                        content: content,
                                        walletCode: walletCode
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "create",
            value: function create(address) {
                return new JettonMaster(address);
            }
        }
    ]);
    return JettonMaster;
}();
$27d8b6c1849938de$exports.JettonMaster = $27d8b6c1849938de$var$JettonMaster;


Object.defineProperty($89095f30c08601be$exports, "JettonMaster", {
    enumerable: true,
    get: function get() {
        return $27d8b6c1849938de$exports.JettonMaster;
    }
});
var $434adae7b4135750$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
/**
 * Copyright (c) Whales Corp.
 * All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty($434adae7b4135750$exports, "__esModule", {
    value: true
});
$434adae7b4135750$exports.JettonWallet = void 0;
var $434adae7b4135750$var$JettonWallet = /*#__PURE__*/ function() {
    function JettonWallet(address) {
        (0, $978gY._)(this, JettonWallet);
        this.address = address;
    }
    (0, $kry2a._)(JettonWallet, [
        {
            key: "getBalance",
            value: function getBalance(provider) {
                return (0, $byzP8._)(function() {
                    var state, res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                state = _state.sent();
                                if (state.state.type !== "active") return [
                                    2,
                                    0n
                                ];
                                return [
                                    4,
                                    provider.get("get_wallet_data", [])
                                ];
                            case 2:
                                res = _state.sent();
                                return [
                                    2,
                                    res.stack.readBigNumber()
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "create",
            value: function create(address) {
                return new JettonWallet(address);
            }
        }
    ]);
    return JettonWallet;
}();
$434adae7b4135750$exports.JettonWallet = $434adae7b4135750$var$JettonWallet;


Object.defineProperty($89095f30c08601be$exports, "JettonWallet", {
    enumerable: true,
    get: function get() {
        return $434adae7b4135750$exports.JettonWallet;
    }
});
var $81e2a3090bda96c9$exports = {};

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");
"use strict";
/* Made by @Gusarich and @Miandic */ Object.defineProperty($81e2a3090bda96c9$exports, "__esModule", {
    value: true
});
$81e2a3090bda96c9$exports.MultisigOrder = void 0;

var $lusx3 = parcelRequire("lusx3");

var $jWi6z = parcelRequire("jWi6z");
var $81e2a3090bda96c9$var$MultisigOrder = /*#__PURE__*/ function() {
    function MultisigOrder(payload) {
        (0, $978gY._)(this, MultisigOrder);
        this.signatures = {};
        this.payload = payload;
    }
    (0, $kry2a._)(MultisigOrder, [
        {
            key: "addSignature",
            value: function addSignature(ownerId, signature, multisig) {
                var signingHash = this.payload.hash();
                if (!(0, $lusx3.signVerify)(signingHash, signature, multisig.owners.get(ownerId).slice(0, -1))) throw Error("invalid signature");
                this.signatures[ownerId] = signature;
            }
        },
        {
            key: "sign",
            value: function sign(ownerId, secretKey) {
                var signingHash = this.payload.hash();
                this.signatures[ownerId] = (0, $lusx3.sign)(signingHash, secretKey);
                return signingHash;
            }
        },
        {
            key: "unionSignatures",
            value: function unionSignatures(other) {
                this.signatures = Object.assign({}, this.signatures, other.signatures);
            }
        },
        {
            key: "clearSignatures",
            value: function clearSignatures() {
                this.signatures = {};
            }
        },
        {
            key: "toCell",
            value: function toCell(ownerId) {
                var b = (0, $jWi6z.beginCell)().storeBit(0);
                for(var _$ownerId in this.signatures){
                    var signature = this.signatures[_$ownerId];
                    b = (0, $jWi6z.beginCell)().storeBit(1).storeRef((0, $jWi6z.beginCell)().storeBuffer(signature).storeUint(parseInt(_$ownerId), 8).storeBuilder(b).endCell());
                }
                return (0, $jWi6z.beginCell)().storeUint(ownerId, 8).storeBuilder(b).storeBuilder(this.payload.asBuilder()).endCell();
            }
        }
    ], [
        {
            key: "fromCell",
            value: function fromCell(cell) {
                var _s_loadMaybeRef;
                var s = cell.beginParse();
                var signatures = (_s_loadMaybeRef = s.loadMaybeRef()) === null || _s_loadMaybeRef === void 0 ? void 0 : _s_loadMaybeRef.beginParse();
                var messagesCell = s.asCell();
                var order = new MultisigOrder(messagesCell);
                if (signatures) {
                    while(signatures.remainingBits > 0){
                        var signature = signatures.loadBuffer(64);
                        var ownerId = signatures.loadUint(8);
                        order.signatures[ownerId] = signature;
                        if (signatures.remainingRefs > 0) signatures = signatures.loadRef().asSlice();
                        else signatures.skip(1);
                    }
                    signatures.endParse();
                }
                return order;
            }
        },
        {
            key: "fromPayload",
            value: function fromPayload(payload) {
                return new MultisigOrder(payload);
            }
        }
    ]);
    return MultisigOrder;
}();
$81e2a3090bda96c9$exports.MultisigOrder = $81e2a3090bda96c9$var$MultisigOrder;


Object.defineProperty($89095f30c08601be$exports, "MultisigOrder", {
    enumerable: true,
    get: function get() {
        return $81e2a3090bda96c9$exports.MultisigOrder;
    }
});
var $ac0dd72044852a5b$exports = {};

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");
"use strict";
/* Made by @Gusarich and @Miandic */ Object.defineProperty($ac0dd72044852a5b$exports, "__esModule", {
    value: true
});
$ac0dd72044852a5b$exports.MultisigOrderBuilder = void 0;

var $jWi6z = parcelRequire("jWi6z");

var $ac0dd72044852a5b$var$MultisigOrderBuilder = /*#__PURE__*/ function() {
    function MultisigOrderBuilder(walletId, offset) {
        (0, $978gY._)(this, MultisigOrderBuilder);
        this.messages = (0, $jWi6z.beginCell)();
        this.queryId = 0n;
        this.walletId = walletId;
        this.queryOffset = offset || 7200;
    }
    (0, $kry2a._)(MultisigOrderBuilder, [
        {
            key: "addMessage",
            value: function addMessage(message, mode) {
                if (this.messages.refs >= 4) throw Error("only 4 refs are allowed");
                this.updateQueryId();
                this.messages.storeUint(mode, 8);
                this.messages.storeRef((0, $jWi6z.beginCell)().store((0, $jWi6z.storeMessageRelaxed)(message)).endCell());
            }
        },
        {
            key: "clearMessages",
            value: function clearMessages() {
                this.messages = (0, $jWi6z.beginCell)();
            }
        },
        {
            key: "build",
            value: function build() {
                return $81e2a3090bda96c9$exports.MultisigOrder.fromPayload((0, $jWi6z.beginCell)().storeUint(this.walletId, 32).storeUint(this.queryId, 64).storeBuilder(this.messages).endCell());
            }
        },
        {
            key: "updateQueryId",
            value: function updateQueryId() {
                var time = BigInt(Math.floor(Date.now() / 1000 + this.queryOffset));
                this.queryId = time << 32n;
            }
        }
    ]);
    return MultisigOrderBuilder;
}();
$ac0dd72044852a5b$exports.MultisigOrderBuilder = $ac0dd72044852a5b$var$MultisigOrderBuilder;


Object.defineProperty($89095f30c08601be$exports, "MultisigOrderBuilder", {
    enumerable: true,
    get: function get() {
        return $ac0dd72044852a5b$exports.MultisigOrderBuilder;
    }
});
var $1ea809c06f7a4ba4$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $1ea809c06f7a4ba4$require$Buffer = $gzLuY.Buffer;
"use strict";
/* Made by @Gusarich and @Miandic */ Object.defineProperty($1ea809c06f7a4ba4$exports, "__esModule", {
    value: true
});
$1ea809c06f7a4ba4$exports.MultisigWallet = void 0;

var $lusx3 = parcelRequire("lusx3");

var $jWi6z = parcelRequire("jWi6z");
var $1ea809c06f7a4ba4$var$MULTISIG_CODE = $jWi6z.Cell.fromBase64("te6ccgECKwEABBgAART/APSkE/S88sgLAQIBIAIDAgFIBAUE2vIgxwCOgzDbPOCDCNcYIPkBAdMH2zwiwAAToVNxePQOb6Hyn9s8VBq6+RDyoAb0BCD5AQHTH1EYuvKq0z9wUwHwCgHCCAGDCryx8mhTFYBA9A5voSCYDqQgwgryZw7f+COqH1NAufJhVCOjU04gIyEiAgLMBgcCASAMDQIBIAgJAgFmCgsAA9GEAiPymAvHoHN9CYbZ5S7Z4BPHohwhJQAtAKkItdJEqCTItdKlwLUAdAT8ArobBKAATwhbpEx4CBukTDgAdAg10rDAJrUAvALyFjPFszJ4HHXI8gBzxb0AMmACASAODwIBIBQVARW77ZbVA0cFUg2zyCoCAUgQEQIBIBITAXOxHXQgwjXGCD5AQHTB4IB1MTtQ9hTIHj0Dm+h8p/XC/9eMfkQ8qCuAfQEIW6TW3Ey4PkBWNs8AaQBgJwA9rtqA6ADoAPoCAXoCEfyAgPyA3XlP+AXkegAA54tkwAAXrhlXP8EA1WZ2oexAAgEgFhcCASAYGQFRtyVbZ4YmRmpGEAgegc30McJNhFpAADMaYeYuAFrgJhwLb+4cC3d0bhAjAYm1WZtnhqvgb+2xxsoicAgej430pBHEoFpAADHDhBACGuQkuuBk9kUWE5kAOeLKhACQCB6IYFImHFImHFImXEA2YlzNijAjAgEgGhsAF7UGtc4QQDVZnah7EAIBIBwdAgOZOB4fARGsGm2eL4G2CUAjABWt+UEAzJV2oewYQAENqTbPBVfBYCMAFa3f3CCAarM7UPYgAiDbPALyZfgAUENxQxPbPO1UIyoACtP/0wcwBKDbPC+uUyCw8mISsQKkJbNTHLmwJYEA4aojoCi8sPJpggGGoPgBBZcCERACPj4wjo0REB/bPEDXePRDEL0F4lQWW1Rz51YQU9zbPFRxClR6vCQlKCYAIO1E0NMf0wfTB9M/9AT0BNEAXgGOGjDSAAHyo9MH0wdQA9cBIPkBBfkBFbrypFAD4GwhIddKqgIi10m68qtwVCATAAwByMv/ywcE1ts87VT4D3AlblOJvrGYEG4QLVDHXwePGzBUJANQTds8UFWgRlAQSRA6SwlTuds8UFQWf+L4AAeDJaGOLCaAQPSWb6UglDBTA7neII4WODk5CNIAAZfTBzAW8AcFkTDifwgHBZJsMeKz5jAGKicoKQBgcI4pA9CDCNcY0wf0BDBTFnj0Dm+h8qXXC/9URUT5EPKmrlIgsVIDvRShI27mbCIyAH5SML6OIF8D+ACTItdKmALTB9QC+wAC6DJwyMoAQBSAQPRDAvAHjhdxyMsAFMsHEssHWM8BWM8WQBOAQPRDAeIBII6KEEUQNEMA2zztVJJfBuIqABzIyx/LB8sHyz/0APQAyQ==");
var $1ea809c06f7a4ba4$var$MultisigWallet = /*#__PURE__*/ function() {
    "use strict";
    function MultisigWallet(publicKeys, workchain, walletId, k, opts) {
        (0, $978gY._)(this, MultisigWallet);
        this.provider = null;
        this.owners = $jWi6z.Dictionary.empty();
        this.workchain = workchain;
        this.walletId = walletId;
        this.k = k;
        for(var i = 0; i < publicKeys.length; i += 1)this.owners.set(i, $1ea809c06f7a4ba4$require$Buffer.concat([
            publicKeys[i],
            $1ea809c06f7a4ba4$require$Buffer.alloc(1)
        ]));
        this.init = {
            code: $1ea809c06f7a4ba4$var$MULTISIG_CODE,
            data: (0, $jWi6z.beginCell)().storeUint(this.walletId, 32).storeUint(this.owners.size, 8).storeUint(this.k, 8).storeUint(0, 64).storeDict(this.owners, $jWi6z.Dictionary.Keys.Uint(8), $jWi6z.Dictionary.Values.Buffer(33)).storeBit(0).endCell()
        };
        this.address = (opts === null || opts === void 0 ? void 0 : opts.address) || (0, $jWi6z.contractAddress)(workchain, this.init);
        if (opts === null || opts === void 0 ? void 0 : opts.provider) this.provider = opts.provider;
        else if (opts === null || opts === void 0 ? void 0 : opts.client) this.provider = opts.client.provider(this.address, {
            code: this.init.code,
            data: this.init.data
        });
    }
    (0, $kry2a._)(MultisigWallet, [
        {
            key: "deployExternal",
            value: function deployExternal(provider) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!provider && !_this.provider) throw Error("you must specify provider if there is no such property in MultisigWallet instance");
                                if (!provider) provider = _this.provider;
                                return [
                                    4,
                                    provider.external($jWi6z.Cell.EMPTY)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deployInternal",
            value: function deployInternal(sender) {
                var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1000000000n;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    sender.send({
                                        sendMode: 3,
                                        to: _this.address,
                                        value: value,
                                        init: _this.init,
                                        body: $jWi6z.Cell.EMPTY,
                                        bounce: true
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendOrder",
            value: function sendOrder(order, secretKey, provider) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var publicKey, ownerId, cell, signature;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!provider && !_this.provider) throw Error("you must specify provider if there is no such property in MultisigWallet instance");
                                if (!provider) provider = _this.provider;
                                publicKey = (0, $lusx3.keyPairFromSecretKey)(secretKey).publicKey;
                                ownerId = _this.getOwnerIdByPubkey(publicKey);
                                cell = order.toCell(ownerId);
                                signature = (0, $lusx3.sign)(cell.hash(), secretKey);
                                cell = (0, $jWi6z.beginCell)().storeBuffer(signature).storeSlice(cell.asSlice()).endCell();
                                return [
                                    4,
                                    provider.external(cell)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getOwnerIdByPubkey",
            value: function getOwnerIdByPubkey(publicKey) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.owners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $8GFUW._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        if (value.subarray(0, 32).equals(publicKey)) return key;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                throw Error("public key is not an owner");
            }
        }
    ], [
        {
            key: "fromAddress",
            value: function fromAddress(address, opts) {
                return (0, $byzP8._)(function() {
                    var provider, contractState, data, walletId, k, owners, publicKeys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, key, value, publicKey;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (opts.provider) provider = opts.provider;
                                else {
                                    if (!opts.client) throw Error("Either provider or client must be specified");
                                    provider = opts.client.provider(address, {
                                        code: null,
                                        data: null
                                    });
                                }
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                contractState = _state.sent().state;
                                if (contractState.type !== "active") throw Error("Contract must be active");
                                data = $jWi6z.Cell.fromBoc(contractState.data)[0].beginParse();
                                walletId = data.loadUint(32);
                                data.skip(8);
                                k = data.loadUint(8);
                                data.skip(64);
                                owners = data.loadDict($jWi6z.Dictionary.Keys.Uint(8), $jWi6z.Dictionary.Values.Buffer(33));
                                publicKeys = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = owners[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        _step_value = (0, $8GFUW._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                                        publicKey = value.subarray(0, 32);
                                        publicKeys.push(publicKey);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return [
                                    2,
                                    new MultisigWallet(publicKeys, address.workChain, walletId, k, {
                                        address: address,
                                        provider: provider,
                                        client: opts.client
                                    })
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return MultisigWallet;
}();
$1ea809c06f7a4ba4$exports.MultisigWallet = $1ea809c06f7a4ba4$var$MultisigWallet;


Object.defineProperty($89095f30c08601be$exports, "MultisigWallet", {
    enumerable: true,
    get: function get() {
        return $1ea809c06f7a4ba4$exports.MultisigWallet;
    }
});
var $977766be7db54a77$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $977766be7db54a77$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty($977766be7db54a77$exports, "__esModule", {
    value: true
});
$977766be7db54a77$exports.ElectorContract = void 0;

var $jWi6z = parcelRequire("jWi6z");
var $977766be7db54a77$var$FrozenDictValue = {
    serialize: function(src, builder) {
        throw Error("not implemented");
    },
    parse: function(src) {
        var address = new $jWi6z.Address(-1, src.loadBuffer(32));
        var weight = src.loadUintBig(64);
        var stake = src.loadCoins();
        return {
            address: address,
            weight: weight,
            stake: stake
        };
    }
};
var $977766be7db54a77$var$EntitiesDictValue = {
    serialize: function(src, builder) {
        throw Error("not implemented");
    },
    parse: function(src) {
        var stake = src.loadCoins();
        // skip time and maxFactor
        src.skip(64);
        var address = new $jWi6z.Address(-1, src.loadBuffer(32));
        var adnl = src.loadBuffer(32);
        return {
            stake: stake,
            address: address,
            adnl: adnl
        };
    }
};
var $977766be7db54a77$var$ElectorContract = /*#__PURE__*/ function() {
    "use strict";
    function ElectorContract() {
        (0, $978gY._)(this, ElectorContract);
        // Please note that we are NOT loading address from config to avoid mistake and send validator money to a wrong contract
        this.address = $jWi6z.Address.parseRaw("-1:3333333333333333333333333333333333333333333333333333333333333333");
    }
    (0, $kry2a._)(ElectorContract, [
        {
            key: "getReturnedStake",
            value: function getReturnedStake(provider, address) {
                return (0, $byzP8._)(function() {
                    var res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (address.workChain !== -1) throw Error("Only masterchain addresses could have stake");
                                return [
                                    4,
                                    provider.get("compute_returned_stake", [
                                        {
                                            type: "int",
                                            value: BigInt("0x" + address.hash.toString("hex"))
                                        }
                                    ])
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    2,
                                    res.stack.readBigNumber()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPastElectionsList",
            value: function getPastElectionsList(provider) {
                return (0, $byzP8._)(function() {
                    var res, electionsListRaw, elections;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.get("past_elections_list", [])
                                ];
                            case 1:
                                res = _state.sent();
                                electionsListRaw = new $jWi6z.TupleReader(res.stack.readLispList());
                                elections = [];
                                while(electionsListRaw.remaining > 0){
                                    var electionsListEntry = electionsListRaw.readTuple();
                                    var id = electionsListEntry.readNumber();
                                    var unfreezeAt = electionsListEntry.readNumber();
                                    electionsListEntry.pop(); // Ignore vset_hash
                                    var stakeHeld = electionsListEntry.readNumber();
                                    elections.push({
                                        id: id,
                                        unfreezeAt: unfreezeAt,
                                        stakeHeld: stakeHeld
                                    });
                                }
                                return [
                                    2,
                                    elections
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPastElections",
            value: function getPastElections(provider) {
                return (0, $byzP8._)(function() {
                    var res, electionsRaw, elections;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.get("past_elections", [])
                                ];
                            case 1:
                                res = _state.sent();
                                electionsRaw = new $jWi6z.TupleReader(res.stack.readLispList());
                                elections = [];
                                while(electionsRaw.remaining > 0){
                                    var electionsEntry = electionsRaw.readTuple();
                                    var id = electionsEntry.readNumber();
                                    var unfreezeAt = electionsEntry.readNumber();
                                    var stakeHeld = electionsEntry.readNumber();
                                    electionsEntry.pop(); // Ignore vset_hash
                                    var frozenDict = electionsEntry.readCell();
                                    var totalStake = electionsEntry.readBigNumber();
                                    var bonuses = electionsEntry.readBigNumber();
                                    var frozen = new Map();
                                    var frozenData = frozenDict.beginParse().loadDictDirect($jWi6z.Dictionary.Keys.Buffer(32), $977766be7db54a77$var$FrozenDictValue);
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = frozenData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var _step_value = (0, $8GFUW._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                                            frozen.set(BigInt("0x" + key.toString("hex")).toString(10), {
                                                address: value["address"],
                                                weight: value["weight"],
                                                stake: value["stake"]
                                            });
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    elections.push({
                                        id: id,
                                        unfreezeAt: unfreezeAt,
                                        stakeHeld: stakeHeld,
                                        totalStake: totalStake,
                                        bonuses: bonuses,
                                        frozen: frozen
                                    });
                                }
                                return [
                                    2,
                                    elections
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getElectionEntities",
            value: function getElectionEntities(provider) {
                return (0, $byzP8._)(function() {
                    var account, cell, cs, sc, startWorkTime, endElectionsTime, minStake, allStakes, entitiesData, entities, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, key, value;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.getState()
                                ];
                            case 1:
                                account = _state.sent();
                                if (account.state.type !== "active") throw Error("Unexpected error");
                                cell = $jWi6z.Cell.fromBoc(account.state.data)[0];
                                cs = cell.beginParse();
                                if (!cs.loadBit()) return [
                                    2,
                                    null
                                ];
                                sc = cs.loadRef().beginParse();
                                startWorkTime = sc.loadUint(32);
                                endElectionsTime = sc.loadUint(32);
                                minStake = sc.loadCoins();
                                allStakes = sc.loadCoins();
                                entitiesData = sc.loadDict($jWi6z.Dictionary.Keys.Buffer(32), $977766be7db54a77$var$EntitiesDictValue);
                                entities = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                // const failed = sc.loadBit();
                                // const finished = sc.loadBit();
                                if (entitiesData) try {
                                    for(_iterator = entitiesData[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        _step_value = (0, $8GFUW._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                                        entities.push({
                                            pubkey: key,
                                            stake: value["stake"],
                                            address: value["address"],
                                            adnl: value["adnl"]
                                        });
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return [
                                    2,
                                    {
                                        minStake: minStake,
                                        allStakes: allStakes,
                                        endElectionsTime: endElectionsTime,
                                        startWorkTime: startWorkTime,
                                        entities: entities
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getActiveElectionId",
            value: // possible code for fetching data via get method if it is possible to set gas limit by request
            // async getElectionEntities(block: number) {
            //     const res = await this.client.runMethod(block, this.address, 'participant_list_extended');
            //     if (res.exitCode !== 0 && res.exitCode !== 1) {
            //         throw Error('Exit code: ' + res.exitCode);
            //     }
            //     let tuple = new TupleReader(res.result);
            //     const startWorkTime = tuple.readNumber();
            //     const endElectionsTime = tuple.readNumber();
            //     const minStake = tuple.readBigNumber();
            //     const allStakes = tuple.readBigNumber();
            //     let entriesTuple = tuple.readTuple();
            //     const entriesRaw = new TupleReader(entriesTuple.readLispList());
            //     let entities: { pubkey: Buffer, stake: bigint, address: Address, adnl: Buffer }[] = [];
            //     while (entriesRaw.remaining > 0) {
            //         const electionsEntry = entriesRaw.readTuple();
            //         const pubkey = electionsEntry.readBuffer();
            //         const stake = electionsEntry.readBigNumber();
            //         const address = electionsEntry.readAddress();
            //         const adnl = electionsEntry.readBuffer();
            //         entities.push({ pubkey, stake, address, adnl });
            //     }
            //     return { minStake, allStakes, endElectionsTime, startWorkTime, entities };
            // }
            function getActiveElectionId(provider) {
                return (0, $byzP8._)(function() {
                    var res, electionId;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.get("active_election_id", [])
                                ];
                            case 1:
                                res = _state.sent();
                                electionId = res.stack.readNumber();
                                return [
                                    2,
                                    electionId > 0 ? electionId : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getComplaints",
            value: function getComplaints(provider, electionId) {
                return (0, $byzP8._)(function() {
                    var b, res, complaintsRaw, results;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                b = new $jWi6z.TupleBuilder();
                                b.writeNumber(electionId);
                                return [
                                    4,
                                    provider.get("list_complaints", b.build())
                                ];
                            case 1:
                                res = _state.sent();
                                if (res.stack.peek().type === "null") return [
                                    2,
                                    []
                                ];
                                complaintsRaw = new $jWi6z.TupleReader(res.stack.readLispList());
                                results = [];
                                while(complaintsRaw.remaining > 0){
                                    var complaintsEntry = complaintsRaw.readTuple();
                                    var id = complaintsEntry.readBigNumber();
                                    var completeUnpackedComplaint = complaintsEntry.readTuple();
                                    var unpackedComplaints = completeUnpackedComplaint.readTuple();
                                    var publicKey = $977766be7db54a77$require$Buffer.from(unpackedComplaints.readBigNumber().toString(16), "hex");
                                    // prod_info#34 utime:uint32 mc_blk_ref:ExtBlkRef state_proof:^(MERKLE_PROOF Block)
                                    // prod_proof:^(MERKLE_PROOF ShardState) = ProducerInfo;
                                    // no_blk_gen from_utime:uint32 prod_info:^ProducerInfo = ComplaintDescr;
                                    // no_blk_gen_diff prod_info_old:^ProducerInfo prod_info_new:^ProducerInfo = ComplaintDescr;
                                    var description = unpackedComplaints.readCell();
                                    var createdAt = unpackedComplaints.readNumber();
                                    var severity = unpackedComplaints.readNumber();
                                    var rewardAddress = new $jWi6z.Address(-1, $977766be7db54a77$require$Buffer.from(unpackedComplaints.readBigNumber().toString(16), "hex"));
                                    var paid = unpackedComplaints.readBigNumber();
                                    var suggestedFine = unpackedComplaints.readBigNumber();
                                    var suggestedFinePart = unpackedComplaints.readBigNumber();
                                    var votes = [];
                                    var votersListRaw = new $jWi6z.TupleReader(completeUnpackedComplaint.readLispList());
                                    while(votersListRaw.remaining > 0)votes.push(votersListRaw.readNumber());
                                    var vsetId = completeUnpackedComplaint.readBigNumber();
                                    var remainingWeight = completeUnpackedComplaint.readBigNumber();
                                    results.push({
                                        id: id,
                                        publicKey: publicKey,
                                        createdAt: createdAt,
                                        severity: severity,
                                        paid: paid,
                                        suggestedFine: suggestedFine,
                                        suggestedFinePart: suggestedFinePart,
                                        rewardAddress: rewardAddress,
                                        votes: votes,
                                        remainingWeight: remainingWeight,
                                        vsetId: vsetId
                                    });
                                }
                                return [
                                    2,
                                    results
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "create",
            value: //readonly source: ContractSource = new UnknownContractSource('org.ton.elector', -1, 'Elector Contract');
            function create() {
                return new ElectorContract();
            }
        }
    ]);
    return ElectorContract;
}();
$977766be7db54a77$exports.ElectorContract = $977766be7db54a77$var$ElectorContract;


Object.defineProperty($89095f30c08601be$exports, "ElectorContract", {
    enumerable: true,
    get: function get() {
        return $977766be7db54a77$exports.ElectorContract;
    }
});
var $4fd2d310e274d623$exports = {};

var $8OnJk = parcelRequire("8OnJk");

var $8GFUW = parcelRequire("8GFUW");
"use strict";
Object.defineProperty($4fd2d310e274d623$exports, "__esModule", {
    value: true
});
$4fd2d310e274d623$exports.parseFullConfig = $4fd2d310e274d623$exports.loadConfigParamsAsSlice = $4fd2d310e274d623$exports.loadConfigParamById = $4fd2d310e274d623$exports.parseVotingSetup = $4fd2d310e274d623$exports.parseProposalSetup = $4fd2d310e274d623$exports.configParse29 = $4fd2d310e274d623$exports.configParse28 = $4fd2d310e274d623$exports.configParseMsgPrices = $4fd2d310e274d623$exports.configParseGasLimitsPrices = $4fd2d310e274d623$exports.configParseBridge = $4fd2d310e274d623$exports.configParseValidatorSet = $4fd2d310e274d623$exports.configParse12 = $4fd2d310e274d623$exports.configParseWorkchainDescriptor = $4fd2d310e274d623$exports.configParse40 = $4fd2d310e274d623$exports.configParse8 = $4fd2d310e274d623$exports.configParse18 = $4fd2d310e274d623$exports.configParse17 = $4fd2d310e274d623$exports.configParse16 = $4fd2d310e274d623$exports.configParse15 = $4fd2d310e274d623$exports.configParse13 = $4fd2d310e274d623$exports.configParse5 = $4fd2d310e274d623$exports.configParseMasterAddressRequired = $4fd2d310e274d623$exports.parseBridge = $4fd2d310e274d623$exports.parseValidatorSet = $4fd2d310e274d623$exports.configParseMasterAddress = void 0;

var $jWi6z = parcelRequire("jWi6z");
function $4fd2d310e274d623$var$configParseMasterAddress(slice) {
    if (slice) return new $jWi6z.Address(-1, slice.loadBuffer(32));
    else return null;
}
$4fd2d310e274d623$exports.configParseMasterAddress = $4fd2d310e274d623$var$configParseMasterAddress;
function $4fd2d310e274d623$var$readPublicKey(slice) {
    // 8e81278a
    if (slice.loadUint(32) !== 0x8e81278a) throw Error("Invalid config");
    return slice.loadBuffer(32);
}
var $4fd2d310e274d623$var$ValidatorDescriptionDictValue = {
    serialize: function(src, builder) {
        throw Error("not implemented");
    },
    parse: function(src) {
        var header = src.loadUint(8);
        if (header === 0x53) return {
            publicKey: $4fd2d310e274d623$var$readPublicKey(src),
            weight: src.loadUintBig(64),
            adnlAddress: null
        };
        else if (header === 0x73) return {
            publicKey: $4fd2d310e274d623$var$readPublicKey(src),
            weight: src.loadUintBig(64),
            adnlAddress: src.loadBuffer(32)
        };
        else throw Error("Invalid config");
    }
};
function $4fd2d310e274d623$var$parseValidatorSet(slice) {
    var header = slice.loadUint(8);
    if (header === 0x11) {
        var timeSince = slice.loadUint(32);
        var timeUntil = slice.loadUint(32);
        var total = slice.loadUint(16);
        var main = slice.loadUint(16);
        var list = slice.loadDictDirect($jWi6z.Dictionary.Keys.Uint(16), $4fd2d310e274d623$var$ValidatorDescriptionDictValue);
        return {
            timeSince: timeSince,
            timeUntil: timeUntil,
            total: total,
            main: main,
            totalWeight: null,
            list: list
        };
    } else if (header === 0x12) {
        var timeSince1 = slice.loadUint(32);
        var timeUntil1 = slice.loadUint(32);
        var total1 = slice.loadUint(16);
        var main1 = slice.loadUint(16);
        var totalWeight = slice.loadUintBig(64);
        var list1 = slice.loadDict($jWi6z.Dictionary.Keys.Uint(16), $4fd2d310e274d623$var$ValidatorDescriptionDictValue);
        return {
            timeSince: timeSince1,
            timeUntil: timeUntil1,
            total: total1,
            main: main1,
            totalWeight: totalWeight,
            list: list1
        };
    }
}
$4fd2d310e274d623$exports.parseValidatorSet = $4fd2d310e274d623$var$parseValidatorSet;
function $4fd2d310e274d623$var$parseBridge(slice) {
    var bridgeAddress = new $jWi6z.Address(-1, slice.loadBuffer(32));
    var oracleMultisigAddress = new $jWi6z.Address(-1, slice.loadBuffer(32));
    var oraclesDict = slice.loadDict($jWi6z.Dictionary.Keys.Buffer(32), $jWi6z.Dictionary.Values.Buffer(32));
    var oracles = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = oraclesDict[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $8GFUW._)(_step.value, 2), local = _step_value[0], remote = _step_value[1];
            oracles.set(new $jWi6z.Address(-1, local).toString(), remote);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var externalChainAddress = slice.loadBuffer(32);
    return {
        bridgeAddress: bridgeAddress,
        oracleMultisigAddress: oracleMultisigAddress,
        oracles: oracles,
        externalChainAddress: externalChainAddress
    };
}
$4fd2d310e274d623$exports.parseBridge = $4fd2d310e274d623$var$parseBridge;
function $4fd2d310e274d623$var$configParseMasterAddressRequired(slice) {
    if (!slice) throw Error("Invalid config");
    return $4fd2d310e274d623$var$configParseMasterAddress(slice);
}
$4fd2d310e274d623$exports.configParseMasterAddressRequired = $4fd2d310e274d623$var$configParseMasterAddressRequired;
function $4fd2d310e274d623$var$configParse5(slice) {
    if (!slice) throw Error("Invalid config");
    var magic = slice.loadUint(8);
    if (magic === 0x01) {
        var blackholeAddr = slice.loadBit() ? new $jWi6z.Address(-1, slice.loadBuffer(32)) : null;
        var feeBurnNominator = slice.loadUint(32);
        var feeBurnDenominator = slice.loadUint(32);
        return {
            blackholeAddr: blackholeAddr,
            feeBurnNominator: feeBurnNominator,
            feeBurnDenominator: feeBurnDenominator
        };
    }
    throw new Error("Invalid config");
}
$4fd2d310e274d623$exports.configParse5 = $4fd2d310e274d623$var$configParse5;
function $4fd2d310e274d623$var$configParse13(slice) {
    if (!slice) throw Error("Invalid config");
    var magic = slice.loadUint(8);
    if (magic === 0x1a) {
        var deposit = slice.loadCoins();
        var bitPrice = slice.loadCoins();
        var cellPrice = slice.loadCoins();
        return {
            deposit: deposit,
            bitPrice: bitPrice,
            cellPrice: cellPrice
        };
    }
    throw new Error("Invalid config");
}
$4fd2d310e274d623$exports.configParse13 = $4fd2d310e274d623$var$configParse13;
function $4fd2d310e274d623$var$configParse15(slice) {
    if (!slice) throw Error("Invalid config");
    var validatorsElectedFor = slice.loadUint(32);
    var electorsStartBefore = slice.loadUint(32);
    var electorsEndBefore = slice.loadUint(32);
    var stakeHeldFor = slice.loadUint(32);
    return {
        validatorsElectedFor: validatorsElectedFor,
        electorsStartBefore: electorsStartBefore,
        electorsEndBefore: electorsEndBefore,
        stakeHeldFor: stakeHeldFor
    };
}
$4fd2d310e274d623$exports.configParse15 = $4fd2d310e274d623$var$configParse15;
function $4fd2d310e274d623$var$configParse16(slice) {
    if (!slice) throw Error("Invalid config");
    var maxValidators = slice.loadUint(16);
    var maxMainValidators = slice.loadUint(16);
    var minValidators = slice.loadUint(16);
    return {
        maxValidators: maxValidators,
        maxMainValidators: maxMainValidators,
        minValidators: minValidators
    };
}
$4fd2d310e274d623$exports.configParse16 = $4fd2d310e274d623$var$configParse16;
function $4fd2d310e274d623$var$configParse17(slice) {
    if (!slice) throw Error("Invalid config");
    var minStake = slice.loadCoins();
    var maxStake = slice.loadCoins();
    var minTotalStake = slice.loadCoins();
    var maxStakeFactor = slice.loadUint(32);
    return {
        minStake: minStake,
        maxStake: maxStake,
        minTotalStake: minTotalStake,
        maxStakeFactor: maxStakeFactor
    };
}
$4fd2d310e274d623$exports.configParse17 = $4fd2d310e274d623$var$configParse17;
var $4fd2d310e274d623$var$StoragePricesDictValue = {
    serialize: function(src, builder) {
        throw Error("not implemented");
    },
    parse: function(src) {
        var header = src.loadUint(8);
        if (header !== 0xcc) throw Error("Invalid config");
        var utime_since = src.loadUint(32);
        var bit_price_ps = src.loadUintBig(64);
        var cell_price_ps = src.loadUintBig(64);
        var mc_bit_price_ps = src.loadUintBig(64);
        var mc_cell_price_ps = src.loadUintBig(64);
        return {
            utime_since: utime_since,
            bit_price_ps: bit_price_ps,
            cell_price_ps: cell_price_ps,
            mc_bit_price_ps: mc_bit_price_ps,
            mc_cell_price_ps: mc_cell_price_ps
        };
    }
};
function $4fd2d310e274d623$var$configParse18(slice) {
    if (!slice) throw Error("Invalid config");
    return slice.loadDictDirect($jWi6z.Dictionary.Keys.Buffer(4), $4fd2d310e274d623$var$StoragePricesDictValue).values();
}
$4fd2d310e274d623$exports.configParse18 = $4fd2d310e274d623$var$configParse18;
function $4fd2d310e274d623$var$configParse8(slice) {
    if (!slice) return {
        version: 0,
        capabilities: 0n
    };
    var version = slice.loadUint(32);
    var capabilities = slice.loadUintBig(64);
    return {
        version: version,
        capabilities: capabilities
    };
}
$4fd2d310e274d623$exports.configParse8 = $4fd2d310e274d623$var$configParse8;
function $4fd2d310e274d623$var$configParse40(slice) {
    if (!slice) return null;
    var header = slice.loadUint(8);
    if (header !== 1) throw Error("Invalid config");
    var defaultFlatFine = slice.loadCoins();
    var defaultProportionaFine = slice.loadCoins();
    var severityFlatMult = slice.loadUint(16);
    var severityProportionalMult = slice.loadUint(16);
    var unfunishableInterval = slice.loadUint(16);
    var longInterval = slice.loadUint(16);
    var longFlatMult = slice.loadUint(16);
    var longProportionalMult = slice.loadUint(16);
    var mediumInterval = slice.loadUint(16);
    var mediumFlatMult = slice.loadUint(16);
    var mediumProportionalMult = slice.loadUint(16);
    return {
        defaultFlatFine: defaultFlatFine,
        defaultProportionaFine: defaultProportionaFine,
        severityFlatMult: severityFlatMult,
        severityProportionalMult: severityProportionalMult,
        unfunishableInterval: unfunishableInterval,
        longInterval: longInterval,
        longFlatMult: longFlatMult,
        longProportionalMult: longProportionalMult,
        mediumInterval: mediumInterval,
        mediumFlatMult: mediumFlatMult,
        mediumProportionalMult: mediumProportionalMult
    };
}
$4fd2d310e274d623$exports.configParse40 = $4fd2d310e274d623$var$configParse40;
function $4fd2d310e274d623$var$configParseWorkchainDescriptor(slice) {
    if (slice.loadUint(8) !== 0xA6) throw Error("Invalid config");
    var enabledSince = slice.loadUint(32);
    var actialMinSplit = slice.loadUint(8);
    var min_split = slice.loadUint(8);
    var max_split = slice.loadUint(8);
    var basic = slice.loadBit();
    var active = slice.loadBit();
    var accept_msgs = slice.loadBit();
    var flags = slice.loadUint(13);
    var zerostateRootHash = slice.loadBuffer(32);
    var zerostateFileHash = slice.loadBuffer(32);
    var version = slice.loadUint(32);
    // Only basic format supported
    if (slice.loadBit()) throw Error("Invalid config");
    var vmVersion = slice.loadUint(32);
    var vmMode = slice.loadUintBig(64);
    return {
        enabledSince: enabledSince,
        actialMinSplit: actialMinSplit,
        min_split: min_split,
        max_split: max_split,
        basic: basic,
        active: active,
        accept_msgs: accept_msgs,
        flags: flags,
        zerostateRootHash: zerostateRootHash,
        zerostateFileHash: zerostateFileHash,
        version: version,
        format: {
            vmVersion: vmVersion,
            vmMode: vmMode
        }
    };
}
$4fd2d310e274d623$exports.configParseWorkchainDescriptor = $4fd2d310e274d623$var$configParseWorkchainDescriptor;
var $4fd2d310e274d623$var$WorkchainDescriptorDictValue = {
    serialize: function(src, builder) {
        throw Error("not implemented");
    },
    parse: function(src) {
        if (src.loadUint(8) !== 0xA6) throw Error("Invalid config");
        var enabledSince = src.loadUint(32);
        var actialMinSplit = src.loadUint(8);
        var min_split = src.loadUint(8);
        var max_split = src.loadUint(8);
        var basic = src.loadBit();
        var active = src.loadBit();
        var accept_msgs = src.loadBit();
        var flags = src.loadUint(13);
        var zerostateRootHash = src.loadBuffer(32);
        var zerostateFileHash = src.loadBuffer(32);
        var version = src.loadUint(32);
        // Only basic format supported
        if (src.loadBit()) throw Error("Invalid config");
        var vmVersion = src.loadUint(32);
        var vmMode = src.loadUintBig(64);
        return {
            enabledSince: enabledSince,
            actialMinSplit: actialMinSplit,
            min_split: min_split,
            max_split: max_split,
            basic: basic,
            active: active,
            accept_msgs: accept_msgs,
            flags: flags,
            zerostateRootHash: zerostateRootHash,
            zerostateFileHash: zerostateFileHash,
            version: version,
            format: {
                vmVersion: vmVersion,
                vmMode: vmMode
            }
        };
    }
};
function $4fd2d310e274d623$var$configParse12(slice) {
    if (!slice) throw Error("Invalid config");
    var wd = slice.loadDict($jWi6z.Dictionary.Keys.Uint(32), $4fd2d310e274d623$var$WorkchainDescriptorDictValue);
    if (wd) return wd;
    throw Error("No workchains exist");
}
$4fd2d310e274d623$exports.configParse12 = $4fd2d310e274d623$var$configParse12;
function $4fd2d310e274d623$var$configParseValidatorSet(slice) {
    if (!slice) return null;
    return $4fd2d310e274d623$var$parseValidatorSet(slice);
}
$4fd2d310e274d623$exports.configParseValidatorSet = $4fd2d310e274d623$var$configParseValidatorSet;
function $4fd2d310e274d623$var$configParseBridge(slice) {
    if (!slice) return null;
    return $4fd2d310e274d623$var$parseBridge(slice);
}
$4fd2d310e274d623$exports.configParseBridge = $4fd2d310e274d623$var$configParseBridge;
function $4fd2d310e274d623$var$parseGasLimitsInternal(slice) {
    var tag = slice.loadUint(8);
    if (tag === 0xde) {
        var gasPrice = slice.loadUintBig(64);
        var gasLimit = slice.loadUintBig(64);
        var specialGasLimit = slice.loadUintBig(64);
        var gasCredit = slice.loadUintBig(64);
        var blockGasLimit = slice.loadUintBig(64);
        var freezeDueLimit = slice.loadUintBig(64);
        var deleteDueLimit = slice.loadUintBig(64);
        return {
            gasPrice: gasPrice,
            gasLimit: gasLimit,
            specialGasLimit: specialGasLimit,
            gasCredit: gasCredit,
            blockGasLimit: blockGasLimit,
            freezeDueLimit: freezeDueLimit,
            deleteDueLimit: deleteDueLimit
        };
    } else if (tag === 0xdd) {
        var gasPrice1 = slice.loadUintBig(64);
        var gasLimit1 = slice.loadUintBig(64);
        var gasCredit1 = slice.loadUintBig(64);
        var blockGasLimit1 = slice.loadUintBig(64);
        var freezeDueLimit1 = slice.loadUintBig(64);
        var deleteDueLimit1 = slice.loadUintBig(64);
        return {
            gasPrice: gasPrice1,
            gasLimit: gasLimit1,
            gasCredit: gasCredit1,
            blockGasLimit: blockGasLimit1,
            freezeDueLimit: freezeDueLimit1,
            deleteDueLimit: deleteDueLimit1
        };
    } else throw Error("Invalid config");
}
function $4fd2d310e274d623$var$configParseGasLimitsPrices(slice) {
    if (!slice) throw Error("Invalid config");
    var tag = slice.loadUint(8);
    if (tag === 0xd1) {
        var flatLimit = slice.loadUintBig(64);
        var flatGasPrice = slice.loadUintBig(64);
        var other = $4fd2d310e274d623$var$parseGasLimitsInternal(slice);
        return {
            flatLimit: flatLimit,
            flatGasPrice: flatGasPrice,
            other: other
        };
    } else throw Error("Invalid config");
}
$4fd2d310e274d623$exports.configParseGasLimitsPrices = $4fd2d310e274d623$var$configParseGasLimitsPrices;
function $4fd2d310e274d623$var$configParseMsgPrices(slice) {
    if (!slice) throw new Error("Invalid config");
    var magic = slice.loadUint(8);
    if (magic !== 0xea) throw new Error("Invalid msg prices param");
    return {
        lumpPrice: slice.loadUintBig(64),
        bitPrice: slice.loadUintBig(64),
        cellPrice: slice.loadUintBig(64),
        ihrPriceFactor: slice.loadUint(32),
        firstFrac: slice.loadUint(16),
        nextFrac: slice.loadUint(16)
    };
}
$4fd2d310e274d623$exports.configParseMsgPrices = $4fd2d310e274d623$var$configParseMsgPrices;
// catchain_config#c1 mc_catchain_lifetime:uint32 shard_catchain_lifetime:uint32 
//   shard_validators_lifetime:uint32 shard_validators_num:uint32 = CatchainConfig;
// catchain_config_new#c2 flags:(## 7) { flags = 0 } shuffle_mc_validators:Bool
//   mc_catchain_lifetime:uint32 shard_catchain_lifetime:uint32
//   shard_validators_lifetime:uint32 shard_validators_num:uint32 = CatchainConfig;
function $4fd2d310e274d623$var$configParse28(slice) {
    if (!slice) throw new Error("Invalid config");
    var magic = slice.loadUint(8);
    if (magic === 0xc1) {
        var masterCatchainLifetime = slice.loadUint(32);
        var shardCatchainLifetime = slice.loadUint(32);
        var shardValidatorsLifetime = slice.loadUint(32);
        var shardValidatorsCount = slice.loadUint(32);
        return {
            masterCatchainLifetime: masterCatchainLifetime,
            shardCatchainLifetime: shardCatchainLifetime,
            shardValidatorsLifetime: shardValidatorsLifetime,
            shardValidatorsCount: shardValidatorsCount
        };
    }
    if (magic === 0xc2) {
        var flags = slice.loadUint(7);
        var suffleMasterValidators = slice.loadBit();
        var masterCatchainLifetime1 = slice.loadUint(32);
        var shardCatchainLifetime1 = slice.loadUint(32);
        var shardValidatorsLifetime1 = slice.loadUint(32);
        var shardValidatorsCount1 = slice.loadUint(32);
        return {
            flags: flags,
            suffleMasterValidators: suffleMasterValidators,
            masterCatchainLifetime: masterCatchainLifetime1,
            shardCatchainLifetime: shardCatchainLifetime1,
            shardValidatorsLifetime: shardValidatorsLifetime1,
            shardValidatorsCount: shardValidatorsCount1
        };
    }
    throw new Error("Invalid config");
}
$4fd2d310e274d623$exports.configParse28 = $4fd2d310e274d623$var$configParse28;
// consensus_config#d6 round_candidates:# { round_candidates >= 1 }
//   next_candidate_delay_ms:uint32 consensus_timeout_ms:uint32
//   fast_attempts:uint32 attempt_duration:uint32 catchain_max_deps:uint32
//   max_block_bytes:uint32 max_collated_bytes:uint32 = ConsensusConfig;
// consensus_config_new#d7 flags:(## 7) { flags = 0 } new_catchain_ids:Bool
//   round_candidates:(## 8) { round_candidates >= 1 }
//   next_candidate_delay_ms:uint32 consensus_timeout_ms:uint32
//   fast_attempts:uint32 attempt_duration:uint32 catchain_max_deps:uint32
//   max_block_bytes:uint32 max_collated_bytes:uint32 = ConsensusConfig;
// consensus_config_v3#d8 flags:(## 7) { flags = 0 } new_catchain_ids:Bool
//   round_candidates:(## 8) { round_candidates >= 1 }
//   next_candidate_delay_ms:uint32 consensus_timeout_ms:uint32
//   fast_attempts:uint32 attempt_duration:uint32 catchain_max_deps:uint32
//   max_block_bytes:uint32 max_collated_bytes:uint32 
//   proto_version:uint16 = ConsensusConfig;
function $4fd2d310e274d623$var$configParse29(slice) {
    if (!slice) throw new Error("Invalid config");
    var magic = slice.loadUint(8);
    if (magic === 0xd6) {
        var roundCandidates = slice.loadUint(32);
        var nextCandidateDelay = slice.loadUint(32);
        var consensusTimeout = slice.loadUint(32);
        var fastAttempts = slice.loadUint(32);
        var attemptDuration = slice.loadUint(32);
        var catchainMaxDeps = slice.loadUint(32);
        var maxBlockBytes = slice.loadUint(32);
        var maxColaltedBytes = slice.loadUint(32);
        return {
            roundCandidates: roundCandidates,
            nextCandidateDelay: nextCandidateDelay,
            consensusTimeout: consensusTimeout,
            fastAttempts: fastAttempts,
            attemptDuration: attemptDuration,
            catchainMaxDeps: catchainMaxDeps,
            maxBlockBytes: maxBlockBytes,
            maxColaltedBytes: maxColaltedBytes
        };
    } else if (magic === 0xd7) {
        var flags = slice.loadUint(7);
        var newCatchainIds = slice.loadBit();
        var roundCandidates1 = slice.loadUint(8);
        var nextCandidateDelay1 = slice.loadUint(32);
        var consensusTimeout1 = slice.loadUint(32);
        var fastAttempts1 = slice.loadUint(32);
        var attemptDuration1 = slice.loadUint(32);
        var catchainMaxDeps1 = slice.loadUint(32);
        var maxBlockBytes1 = slice.loadUint(32);
        var maxColaltedBytes1 = slice.loadUint(32);
        return {
            flags: flags,
            newCatchainIds: newCatchainIds,
            roundCandidates: roundCandidates1,
            nextCandidateDelay: nextCandidateDelay1,
            consensusTimeout: consensusTimeout1,
            fastAttempts: fastAttempts1,
            attemptDuration: attemptDuration1,
            catchainMaxDeps: catchainMaxDeps1,
            maxBlockBytes: maxBlockBytes1,
            maxColaltedBytes: maxColaltedBytes1
        };
    } else if (magic === 0xd8) {
        var flags1 = slice.loadUint(7);
        var newCatchainIds1 = slice.loadBit();
        var roundCandidates2 = slice.loadUint(8);
        var nextCandidateDelay2 = slice.loadUint(32);
        var consensusTimeout2 = slice.loadUint(32);
        var fastAttempts2 = slice.loadUint(32);
        var attemptDuration2 = slice.loadUint(32);
        var catchainMaxDeps2 = slice.loadUint(32);
        var maxBlockBytes2 = slice.loadUint(32);
        var maxColaltedBytes2 = slice.loadUint(32);
        var protoVersion = slice.loadUint(16);
        return {
            flags: flags1,
            newCatchainIds: newCatchainIds1,
            roundCandidates: roundCandidates2,
            nextCandidateDelay: nextCandidateDelay2,
            consensusTimeout: consensusTimeout2,
            fastAttempts: fastAttempts2,
            attemptDuration: attemptDuration2,
            catchainMaxDeps: catchainMaxDeps2,
            maxBlockBytes: maxBlockBytes2,
            maxColaltedBytes: maxColaltedBytes2,
            protoVersion: protoVersion
        };
    } else if (magic === 0xd9) {
        var flags2 = slice.loadUint(7);
        var newCatchainIds2 = slice.loadBit();
        var roundCandidates3 = slice.loadUint(8);
        var nextCandidateDelay3 = slice.loadUint(32);
        var consensusTimeout3 = slice.loadUint(32);
        var fastAttempts3 = slice.loadUint(32);
        var attemptDuration3 = slice.loadUint(32);
        var catchainMaxDeps3 = slice.loadUint(32);
        var maxBlockBytes3 = slice.loadUint(32);
        var maxColaltedBytes3 = slice.loadUint(32);
        var protoVersion1 = slice.loadUint(16);
        var catchainMaxBlocksCoeff = slice.loadUint(32);
        return {
            flags: flags2,
            newCatchainIds: newCatchainIds2,
            roundCandidates: roundCandidates3,
            nextCandidateDelay: nextCandidateDelay3,
            consensusTimeout: consensusTimeout3,
            fastAttempts: fastAttempts3,
            attemptDuration: attemptDuration3,
            catchainMaxDeps: catchainMaxDeps3,
            maxBlockBytes: maxBlockBytes3,
            maxColaltedBytes: maxColaltedBytes3,
            protoVersion: protoVersion1,
            catchainMaxBlocksCoeff: catchainMaxBlocksCoeff
        };
    }
    throw new Error("Invalid config");
}
$4fd2d310e274d623$exports.configParse29 = $4fd2d310e274d623$var$configParse29;
// cfg_vote_cfg#36 min_tot_rounds:uint8 max_tot_rounds:uint8 min_wins:uint8 max_losses:uint8 min_store_sec:uint32 max_store_sec:uint32 bit_price:uint32 cell_price:uint32 = ConfigProposalSetup;
function $4fd2d310e274d623$var$parseProposalSetup(slice) {
    var magic = slice.loadUint(8);
    if (magic !== 0x36) throw new Error("Invalid config");
    var minTotalRounds = slice.loadUint(8);
    var maxTotalRounds = slice.loadUint(8);
    var minWins = slice.loadUint(8);
    var maxLoses = slice.loadUint(8);
    var minStoreSec = slice.loadUint(32);
    var maxStoreSec = slice.loadUint(32);
    var bitPrice = slice.loadUint(32);
    var cellPrice = slice.loadUint(32);
    return {
        minTotalRounds: minTotalRounds,
        maxTotalRounds: maxTotalRounds,
        minWins: minWins,
        maxLoses: maxLoses,
        minStoreSec: minStoreSec,
        maxStoreSec: maxStoreSec,
        bitPrice: bitPrice,
        cellPrice: cellPrice
    };
}
$4fd2d310e274d623$exports.parseProposalSetup = $4fd2d310e274d623$var$parseProposalSetup;
// cfg_vote_setup#91 normal_params:^ConfigProposalSetup critical_params:^ConfigProposalSetup = ConfigVotingSetup;
function $4fd2d310e274d623$var$parseVotingSetup(slice) {
    if (!slice) throw new Error("Invalid config");
    var magic = slice.loadUint(8);
    if (magic !== 0x91) throw new Error("Invalid config");
    var normalParams = $4fd2d310e274d623$var$parseProposalSetup(slice.loadRef().beginParse());
    var criticalParams = $4fd2d310e274d623$var$parseProposalSetup(slice.loadRef().beginParse());
    return {
        normalParams: normalParams,
        criticalParams: criticalParams
    };
}
$4fd2d310e274d623$exports.parseVotingSetup = $4fd2d310e274d623$var$parseVotingSetup;
function $4fd2d310e274d623$var$loadConfigParams(configBase64) {
    var comfigMap = $jWi6z.Cell.fromBase64(configBase64).beginParse().loadDictDirect($jWi6z.Dictionary.Keys.Int(32), $jWi6z.Dictionary.Values.Cell());
    return comfigMap;
}
function $4fd2d310e274d623$var$loadConfigParamById(configBase64, id) {
    return $4fd2d310e274d623$var$loadConfigParams(configBase64).get(id);
}
$4fd2d310e274d623$exports.loadConfigParamById = $4fd2d310e274d623$var$loadConfigParamById;
function $4fd2d310e274d623$var$loadConfigParamsAsSlice(configBase64) {
    var pramsAsCells = $4fd2d310e274d623$var$loadConfigParams(configBase64);
    var params = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = pramsAsCells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $8GFUW._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            params.set(key, value.beginParse());
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return params;
}
$4fd2d310e274d623$exports.loadConfigParamsAsSlice = $4fd2d310e274d623$var$loadConfigParamsAsSlice;
function $4fd2d310e274d623$var$parseFullConfig(configs) {
    return {
        configAddress: $4fd2d310e274d623$var$configParseMasterAddressRequired(configs.get(0)),
        electorAddress: $4fd2d310e274d623$var$configParseMasterAddressRequired(configs.get(1)),
        minterAddress: $4fd2d310e274d623$var$configParseMasterAddress(configs.get(2)),
        feeCollectorAddress: $4fd2d310e274d623$var$configParseMasterAddress(configs.get(3)),
        dnsRootAddress: $4fd2d310e274d623$var$configParseMasterAddress(configs.get(4)),
        burningConfig: $4fd2d310e274d623$var$configParse5(configs.get(5)),
        globalVersion: $4fd2d310e274d623$var$configParse8(configs.get(8)),
        workchains: $4fd2d310e274d623$var$configParse12(configs.get(12)),
        voting: $4fd2d310e274d623$var$parseVotingSetup(configs.get(11)),
        validators: (0, $8OnJk._)({}, $4fd2d310e274d623$var$configParse15(configs.get(15)), $4fd2d310e274d623$var$configParse16(configs.get(16)), $4fd2d310e274d623$var$configParse17(configs.get(17))),
        storagePrices: $4fd2d310e274d623$var$configParse18(configs.get(18)),
        gasPrices: {
            masterchain: $4fd2d310e274d623$var$configParseGasLimitsPrices(configs.get(20)),
            workchain: $4fd2d310e274d623$var$configParseGasLimitsPrices(configs.get(21))
        },
        msgPrices: {
            masterchain: $4fd2d310e274d623$var$configParseMsgPrices(configs.get(24)),
            workchain: $4fd2d310e274d623$var$configParseMsgPrices(configs.get(25))
        },
        validatorSets: {
            prevValidators: $4fd2d310e274d623$var$configParseValidatorSet(configs.get(32)),
            prevTempValidators: $4fd2d310e274d623$var$configParseValidatorSet(configs.get(33)),
            currentValidators: $4fd2d310e274d623$var$configParseValidatorSet(configs.get(34)),
            currentTempValidators: $4fd2d310e274d623$var$configParseValidatorSet(configs.get(35)),
            nextValidators: $4fd2d310e274d623$var$configParseValidatorSet(configs.get(36)),
            nextTempValidators: $4fd2d310e274d623$var$configParseValidatorSet(configs.get(37))
        },
        validatorsPunish: $4fd2d310e274d623$var$configParse40(configs.get(40)),
        bridges: {
            ethereum: $4fd2d310e274d623$var$configParseBridge(configs.get(71)),
            binance: $4fd2d310e274d623$var$configParseBridge(configs.get(72)),
            polygon: $4fd2d310e274d623$var$configParseBridge(configs.get(73))
        },
        catchain: $4fd2d310e274d623$var$configParse28(configs.get(28)),
        consensus: $4fd2d310e274d623$var$configParse29(configs.get(29))
    };
}
$4fd2d310e274d623$exports.parseFullConfig = $4fd2d310e274d623$var$parseFullConfig;


Object.defineProperty($89095f30c08601be$exports, "configParse5", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParse5;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParse8", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParse8;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParse12", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParse12;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParse13", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParse13;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParse15", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParse15;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParse16", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParse16;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParse17", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParse17;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParse18", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParse18;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParse28", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParse28;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParse29", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParse29;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParse40", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParse40;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParseBridge", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParseBridge;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParseGasLimitsPrices", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParseGasLimitsPrices;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParseMasterAddress", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParseMasterAddress;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParseMasterAddressRequired", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParseMasterAddressRequired;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParseMsgPrices", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParseMsgPrices;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParseValidatorSet", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParseValidatorSet;
    }
});
Object.defineProperty($89095f30c08601be$exports, "configParseWorkchainDescriptor", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.configParseWorkchainDescriptor;
    }
});
Object.defineProperty($89095f30c08601be$exports, "parseBridge", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.parseBridge;
    }
});
Object.defineProperty($89095f30c08601be$exports, "parseProposalSetup", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.parseProposalSetup;
    }
});
Object.defineProperty($89095f30c08601be$exports, "parseValidatorSet", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.parseValidatorSet;
    }
});
Object.defineProperty($89095f30c08601be$exports, "parseVotingSetup", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.parseVotingSetup;
    }
});
Object.defineProperty($89095f30c08601be$exports, "parseFullConfig", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.parseFullConfig;
    }
});
Object.defineProperty($89095f30c08601be$exports, "loadConfigParamById", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.loadConfigParamById;
    }
});
Object.defineProperty($89095f30c08601be$exports, "loadConfigParamsAsSlice", {
    enumerable: true,
    get: function get() {
        return $4fd2d310e274d623$exports.loadConfigParamsAsSlice;
    }
});


function $aa9c67c837210e90$var$sleep(ms) {
    return $aa9c67c837210e90$var$_sleep.apply(this, arguments);
}
function $aa9c67c837210e90$var$_sleep() {
    $aa9c67c837210e90$var$_sleep = (0, $byzP8._)(function(ms) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    return setTimeout(resolve, ms);
                })
            ];
        });
    });
    return $aa9c67c837210e90$var$_sleep.apply(this, arguments);
}
$aa9c67c837210e90$exports.sleep = $aa9c67c837210e90$var$sleep;
var $aa9c67c837210e90$var$Ton = /*#__PURE__*/ function() {
    function Ton() {
        (0, $978gY._)(this, Ton);
    }
    (0, $kry2a._)(Ton, [
        {
            key: "connect",
            value: function connect(network) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var walletAddress;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    network.setUp()
                                ];
                            case 1:
                                _state.sent();
                                _this.sender = network.sender;
                                _this.api = network.api;
                                _this.oldApi = network.oldApi;
                                walletAddress = _this.sender.address;
                                return [
                                    4,
                                    network.isContractDeployed(walletAddress)
                                ];
                            case 2:
                                if (!_state.sent()) throw "wallet is not deployed";
                                return [
                                    2,
                                    _this
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "internalMessage",
            value: function internalMessage(provider, coins, body) {
                var sendMode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $89095f30c08601be$exports.SendMode.PAY_GAS_SEPARATELY;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.wait(/*#__PURE__*/ (0, $byzP8._)(function() {
                                        return (0, $7UAGh.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        provider.internal(_this.sender, {
                                                            value: "".concat(coins.toFixed(2)),
                                                            body: body,
                                                            sendMode: sendMode
                                                        })
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "wait",
            value: function wait(callback) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var seqno, result, currentSeqno;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.api) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    callback()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.api.getLastBlock()
                                ];
                            case 3:
                                seqno = _state.sent().last.seqno;
                                return [
                                    4,
                                    callback()
                                ];
                            case 4:
                                result = _state.sent();
                                currentSeqno = seqno;
                                _state.label = 5;
                            case 5:
                                if (!(currentSeqno == seqno)) return [
                                    3,
                                    8
                                ];
                                console.log("waiting for transaction to confirm...");
                                return [
                                    4,
                                    $aa9c67c837210e90$var$sleep(1500)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    4,
                                    _this.api.getLastBlock()
                                ];
                            case 7:
                                currentSeqno = _state.sent().last.seqno;
                                return [
                                    3,
                                    5
                                ];
                            case 8:
                                console.log("transaction confirmed!");
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Ton;
}();
$aa9c67c837210e90$exports.Ton = $aa9c67c837210e90$var$Ton;


var $b30b638438aa1abc$var$TonContract = /*#__PURE__*/ function(_Ton_1_Ton) {
    (0, $ftJVG._)(TonContract, _Ton_1_Ton);
    var _super = (0, $6OZAO._)(TonContract);
    function TonContract(address, init) {
        (0, $978gY._)(this, TonContract);
        var _this;
        _this = _super.call(this);
        _this.address = address;
        _this.init = init;
        return _this;
    }
    (0, $kry2a._)(TonContract, [
        {
            key: "sendDeploy",
            value: function sendDeploy(provider) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.log("contract address:", _this.address.toString());
                                return [
                                    4,
                                    _this.internalMessage(provider, 0.05, (0, $jWi6z.beginCell)().endCell())
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "getName",
            value: function getName() {
                throw "Must be overridden; Return the contract-filename here;";
            }
        }
    ]);
    return TonContract;
}($aa9c67c837210e90$exports.Ton);
$b30b638438aa1abc$exports.TonContract = $b30b638438aa1abc$var$TonContract;



var $9ffb18f831604ec0$var$TonPriceManager = /*#__PURE__*/ function(_TonContract_1_TonContract) {
    (0, $ftJVG._)(TonPriceManager, _TonContract_1_TonContract);
    var _super = (0, $6OZAO._)(TonPriceManager);
    function TonPriceManager() {
        (0, $978gY._)(this, TonPriceManager);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(TonPriceManager, [
        {
            key: "sendWritePrices",
            value: function sendWritePrices(provider, paramsProvider) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var builder, payloadCell, _, dataFeedsIdsCell, body;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                builder = (0, $b9ff8b8ac71d3cee$exports.messageBuilder)($97f1e1493c5dbacd$exports.OP_REDSTONE_WRITE_PRICES);
                                _ = (0, $0b7691397734f359$exports.createPayloadCell);
                                return [
                                    4,
                                    paramsProvider.getPayloadHex(false)
                                ];
                            case 1:
                                payloadCell = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                dataFeedsIdsCell = (0, $jWi6z.serializeTuple)((0, $b9ff8b8ac71d3cee$exports.createTupleItems)(paramsProvider.getHexlifiedFeedIds()));
                                builder.storeRef(dataFeedsIdsCell);
                                builder.storeRef(payloadCell);
                                body = builder.endCell();
                                return [
                                    4,
                                    _this.internalMessage(provider, paramsProvider.requestParams.dataFeeds.length * paramsProvider.requestParams.uniqueSignersCount * 0.05, body)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getReadPrices",
            value: function getReadPrices(provider, paramsProvider) {
                return (0, $byzP8._)(function() {
                    var stack;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.get("read_prices", [
                                        {
                                            type: "tuple",
                                            items: (0, $b9ff8b8ac71d3cee$exports.createTupleItems)(paramsProvider.getHexlifiedFeedIds())
                                        }
                                    ])
                                ];
                            case 1:
                                stack = _state.sent().stack;
                                return [
                                    2,
                                    (0, $b9ff8b8ac71d3cee$exports.createArrayFromTuple)(stack.readTuple())
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getReadTimestamp",
            value: function getReadTimestamp(provider) {
                return (0, $byzP8._)(function() {
                    var stack;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.get("read_timestamp", [])
                                ];
                            case 1:
                                stack = _state.sent().stack;
                                return [
                                    2,
                                    stack.readNumber()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPrices",
            value: function getPrices(provider, paramsProvider) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var payloadCell, _, dataFeedIds, shouldUseOldApi, _tmp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = (0, $0b7691397734f359$exports.createPayloadCell);
                                return [
                                    4,
                                    paramsProvider.getPayloadHex(false)
                                ];
                            case 1:
                                payloadCell = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                dataFeedIds = (0, $b9ff8b8ac71d3cee$exports.createTupleItems)(paramsProvider.getHexlifiedFeedIds());
                                shouldUseOldApi = true; // !!this.oldApi;
                                if (!shouldUseOldApi) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.getPricesV2(provider, dataFeedIds, payloadCell)
                                ];
                            case 2:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                return [
                                    4,
                                    _this.getPricesV4(provider, dataFeedIds, payloadCell)
                                ];
                            case 4:
                                _tmp = _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    _tmp
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPricesV2",
            value: function getPricesV2(provider, dataFeedIds, payloadCell) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _this_oldApi, _this_oldApi_provider, getProvider, stack;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                getProvider = (_this_oldApi_provider = (_this_oldApi = _this.oldApi) === null || _this_oldApi === void 0 ? void 0 : _this_oldApi.provider(_this.address, null)) !== null && _this_oldApi_provider !== void 0 ? _this_oldApi_provider : provider;
                                return [
                                    4,
                                    getProvider.get("get_prices_v2", [
                                        {
                                            type: "cell",
                                            cell: (0, $jWi6z.serializeTuple)(dataFeedIds)
                                        },
                                        {
                                            type: "cell",
                                            cell: payloadCell
                                        }
                                    ])
                                ];
                            case 1:
                                stack = _state.sent().stack;
                                return [
                                    2,
                                    (0, $b9ff8b8ac71d3cee$exports.createArrayFromSerializedTuple)(stack.readCell(), $1a97ff8bd14aa50d$export$1ec4dc697f56278b * 8)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPricesV4",
            value: function getPricesV4(provider, dataFeedIds, payloadCell) {
                return (0, $byzP8._)(function() {
                    var stack;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    provider.get("get_prices", [
                                        {
                                            type: "tuple",
                                            items: dataFeedIds
                                        },
                                        {
                                            type: "cell",
                                            cell: payloadCell
                                        }
                                    ])
                                ];
                            case 1:
                                stack = _state.sent().stack;
                                return [
                                    2,
                                    (0, $b9ff8b8ac71d3cee$exports.createArrayFromTuple)(stack.readTuple())
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "getName",
            value: function getName() {
                return "price_manager";
            }
        }
    ]);
    return TonPriceManager;
}($b30b638438aa1abc$exports.TonContract);
$9ffb18f831604ec0$exports.TonPriceManager = $9ffb18f831604ec0$var$TonPriceManager;


var $77f8b550f2ac3b04$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty($77f8b550f2ac3b04$exports, "__esModule", {
    value: true
});
$77f8b550f2ac3b04$exports.TonContractConnector = void 0;
var $c7f39cd119ca6e7c$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty($c7f39cd119ca6e7c$exports, "__esModule", {
    value: true
});
$c7f39cd119ca6e7c$exports.TonContractFactory = void 0;

var $jWi6z = parcelRequire("jWi6z");
var $25a8067d6bebdc0a$exports = {};

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");
"use strict";
Object.defineProperty($25a8067d6bebdc0a$exports, "__esModule", {
    value: true
});
$25a8067d6bebdc0a$exports.TonInitData = void 0;

var $jWi6z = parcelRequire("jWi6z");
var $25a8067d6bebdc0a$var$TonInitData = /*#__PURE__*/ function() {
    function TonInitData() {
        (0, $978gY._)(this, TonInitData);
    }
    (0, $kry2a._)(TonInitData, [
        {
            key: "toCell",
            value: function toCell() {
                return (0, $jWi6z.beginCell)().endCell();
            }
        }
    ]);
    return TonInitData;
}();
$25a8067d6bebdc0a$exports.TonInitData = $25a8067d6bebdc0a$var$TonInitData;


var $c7f39cd119ca6e7c$var$TonContractFactory = /*#__PURE__*/ function() {
    function TonContractFactory(contractType) {
        (0, $978gY._)(this, TonContractFactory);
        this.contractType = contractType;
    }
    (0, $kry2a._)(TonContractFactory, [
        {
            key: "makeForExecute",
            value: function makeForExecute(network, address) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var contract;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                contract = new _this.contractType($jWi6z.Address.parse(address));
                                return [
                                    4,
                                    contract.connect(network)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    contract
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "makeForDeploy",
            value: function makeForDeploy(code, network, initData) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _this_openContractCode, address, contract;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_openContractCode = _this.openContractCode(code, network.workchain, initData !== null && initData !== void 0 ? initData : new $25a8067d6bebdc0a$exports.TonInitData()), address = _this_openContractCode.address, contract = _this_openContractCode.contract;
                                return [
                                    4,
                                    network.isContractDeployed(address)
                                ];
                            case 1:
                                if (_state.sent()) throw "Contract already deployed";
                                return [
                                    4,
                                    contract.connect(network)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2,
                                    contract
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "openContractCode",
            value: function openContractCode(code, workchain, initData) {
                var data = initData.toCell();
                var address = (0, $jWi6z.contractAddress)(workchain, {
                    code: code,
                    data: data
                });
                var contract = new this.contractType(address, {
                    code: code,
                    data: data
                });
                return {
                    address: address,
                    contract: contract
                };
            }
        }
    ]);
    return TonContractFactory;
}();
$c7f39cd119ca6e7c$exports.TonContractFactory = $c7f39cd119ca6e7c$var$TonContractFactory;


var $77f8b550f2ac3b04$var$TonContractConnector = /*#__PURE__*/ function() {
    function TonContractConnector(contractType, network, address) {
        (0, $978gY._)(this, TonContractConnector);
        this.contractType = contractType;
        this.network = network;
        this.address = address;
    }
    (0, $kry2a._)(TonContractConnector, [
        {
            key: "makeContract",
            value: function makeContract(contractFactory) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    contractFactory.makeForExecute(_this.network, _this.address)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getContract",
            value: function getContract() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var contractFactory, contract;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                contractFactory = new $c7f39cd119ca6e7c$exports.TonContractFactory(_this.contractType);
                                return [
                                    4,
                                    _this.makeContract(contractFactory)
                                ];
                            case 1:
                                contract = _state.sent();
                                return [
                                    2,
                                    _this.network.open(contract)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlockNumber",
            value: function getBlockNumber(rpcUrl) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.network.api.getLastBlock()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().last.seqno
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return TonContractConnector;
}();
$77f8b550f2ac3b04$exports.TonContractConnector = $77f8b550f2ac3b04$var$TonContractConnector;


var $5981c521794dfb1e$var$TonPriceManagerContractConnector = /*#__PURE__*/ function(_TonContractConnector_1_TonContractConnector) {
    (0, $ftJVG._)(TonPriceManagerContractConnector, _TonContractConnector_1_TonContractConnector);
    var _super = (0, $6OZAO._)(TonPriceManagerContractConnector);
    function TonPriceManagerContractConnector(network, address) {
        (0, $978gY._)(this, TonPriceManagerContractConnector);
        return _super.call(this, $9ffb18f831604ec0$exports.TonPriceManager, network, address);
    }
    (0, $kry2a._)(TonPriceManagerContractConnector, [
        {
            key: "getAdapter",
            value: function getAdapter() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _, _1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _1 = (_ = $5772d12adefbd6b5$exports.TonPriceManagerContractAdapter).bind;
                                return [
                                    4,
                                    _this.getContract()
                                ];
                            case 1:
                                return [
                                    2,
                                    new (_1.apply(_, [
                                        void 0,
                                        _state.sent()
                                    ]))
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return TonPriceManagerContractConnector;
}($77f8b550f2ac3b04$exports.TonContractConnector);
$5981c521794dfb1e$exports.TonPriceManagerContractConnector = $5981c521794dfb1e$var$TonPriceManagerContractConnector;


Object.defineProperty($264417ac072da6c0$exports, "TonPricesContractConnector", {
    enumerable: true,
    get: function get() {
        return $5981c521794dfb1e$exports.TonPriceManagerContractConnector;
    }
});
var $85ce7c9ef04f45be$exports = {};

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $85ce7c9ef04f45be$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($85ce7c9ef04f45be$exports, "__esModule", {
    value: true
});
$85ce7c9ef04f45be$exports.CustomTonNetwork = void 0;


var $85ce7c9ef04f45be$var$assert_1 = $85ce7c9ef04f45be$var$__importDefault((parcelRequire("2rjjG")));
var $bc7712f15555af47$exports = {};

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $bc7712f15555af47$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty($bc7712f15555af47$exports, "__esModule", {
    value: true
});
$bc7712f15555af47$exports.getHttpV4Endpoint = $bc7712f15555af47$exports.getHttpV4Endpoints = $bc7712f15555af47$exports.getHttpEndpoint = $bc7712f15555af47$exports.getHttpEndpoints = $bc7712f15555af47$exports.Access = void 0;
var $8a95125edaa7cb5d$exports = {};

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $8a95125edaa7cb5d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty($8a95125edaa7cb5d$exports, "__esModule", {
    value: true
});
$8a95125edaa7cb5d$exports.Nodes = void 0;
parcelRequire("jxHwd");
///////////////////////////////////
var $8a95125edaa7cb5d$var$Nodes = /*#__PURE__*/ function() {
    function Nodes() {
        (0, $978gY._)(this, Nodes);
        this.nodeIndex = -1;
        this.committee = new Set();
        this.topology = [];
        this.initTime = 0;
    }
    (0, $kry2a._)(Nodes, [
        {
            ///////////////////////////////////
            key: "init",
            value: function init(nodesUrl) {
                return $8a95125edaa7cb5d$var$__awaiter(this, void 0, void 0, function() {
                    var topology, response, data, e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, node;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // cleanup
                                this.nodeIndex = -1;
                                this.committee.clear();
                                this.topology = [];
                                this.initTime = Date.now();
                                topology = [];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch(nodesUrl)
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                topology = data;
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e = _state.sent();
                                throw new Error("exception in fetch(".concat(nodesUrl, "): ").concat(e));
                            case 5:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    // remove unhealthy nodes
                                    for(_iterator = topology[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        node = _step.value;
                                        if (node.Healthy === "1") this.topology.push(node);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (this.topology.length === 0) throw new Error("no healthy nodes in ".concat(nodesUrl));
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getHealthyFor",
            value: function getHealthyFor(protonet) {
                var _a;
                var res = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.topology[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        // not stale (10 min)
                        if (node.Weight > 0 && ((_a = node.Mngr) === null || _a === void 0 ? void 0 : _a.health[protonet])) res.push(node);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return res;
            }
        }
    ]);
    return Nodes;
}();
$8a95125edaa7cb5d$exports.Nodes = $8a95125edaa7cb5d$var$Nodes;



var $bc7712f15555af47$var$Access = /*#__PURE__*/ function() {
    function Access() {
        (0, $978gY._)(this, Access);
        // default
        this.host = "ton.access.orbs.network";
        this.urlVersion = 1;
        this.nodes = new $8a95125edaa7cb5d$exports.Nodes();
    }
    (0, $kry2a._)(Access, [
        {
            //////////////////////////////////
            key: "init",
            value: function init() {
                return $bc7712f15555af47$var$__awaiter(this, void 0, void 0, function() {
                    var pjson;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                pjson = (parcelRequire("gTjEX"));
                                return [
                                    4,
                                    this.nodes.init("https://".concat(this.host, "/mngr/nodes?npm_version=").concat(pjson.version))
                                ];
                            case 1:
                                _state.sent(); // pass host when backend endpoint is ready
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            //////////////////////////////////
            key: "makeProtonet",
            value: function makeProtonet(edgeProtocol, network) {
                var res = "";
                switch(edgeProtocol){
                    case "toncenter-api-v2":
                        res += "v2-";
                        break;
                    case "ton-api-v4":
                        res += "v4-";
                        break;
                }
                res += network;
                return res;
            }
        },
        {
            //////////////////////////////////
            key: "weightedRandom",
            value: function weightedRandom(nodes) {
                var sumWeights = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        sumWeights += node.Weight;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var rnd = Math.floor(Math.random() * sumWeights);
                var cur = 0;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = nodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var node1 = _step1.value;
                        if (rnd >= cur && rnd < cur + node1.Weight) return node1;
                        cur += node1.Weight;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            //////////////////////////////////
            key: "buildUrls",
            value: function buildUrls(network, edgeProtocol, suffix, single) {
                // default params
                if (!suffix) suffix = "";
                if (!edgeProtocol) edgeProtocol = "toncenter-api-v2";
                if (!network) network = "mainnet";
                // remove leading slash
                if (suffix.length) suffix = suffix.replace(/^\/+/, "");
                var res = [];
                var protonet = this.makeProtonet(edgeProtocol, network);
                var healthyNodes = this.nodes.getHealthyFor(protonet);
                if (!(healthyNodes === null || healthyNodes === void 0 ? void 0 : healthyNodes.length)) throw new Error("no healthy nodes for ".concat(protonet));
                // if count < healthNodes length - weighted random
                if (single && healthyNodes.length) {
                    var chosen = this.weightedRandom(healthyNodes);
                    if (chosen) healthyNodes = [
                        chosen
                    ];
                    else throw new Error("weightedRandom return empty");
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = healthyNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        var url = "https://".concat(this.host, "/").concat(node.NodeId, "/").concat(this.urlVersion, "/").concat(network, "/").concat(edgeProtocol);
                        // append /suffix only if needed
                        if (suffix.length) url += "/".concat(suffix);
                        res.push(url);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return res;
            }
        }
    ]);
    return Access;
}();
$bc7712f15555af47$exports.Access = $bc7712f15555af47$var$Access;
//////////////////////////////
// private get multi endpoints
function $bc7712f15555af47$var$getEndpoints(network, edgeProtocol, suffix, single) {
    return $bc7712f15555af47$var$__awaiter(this, void 0, void 0, function() {
        var access, res;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    access = new $bc7712f15555af47$var$Access();
                    return [
                        4,
                        access.init()
                    ];
                case 1:
                    _state.sent();
                    res = access.buildUrls(network, edgeProtocol, suffix, single);
                    return [
                        2,
                        res
                    ];
            }
        });
    });
}
/////////////////////////////////////
// global exported explicit functions
// toncenter multi
function $bc7712f15555af47$var$getHttpEndpoints(config, single) {
    return $bc7712f15555af47$var$__awaiter(this, void 0, void 0, function() {
        var network, suffix;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    network = (config === null || config === void 0 ? void 0 : config.network) ? config.network : "mainnet";
                    suffix = "jsonRPC";
                    if ((config === null || config === void 0 ? void 0 : config.protocol) === "rest") suffix = "";
                    return [
                        4,
                        $bc7712f15555af47$var$getEndpoints(network, "toncenter-api-v2", suffix, single)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
}
$bc7712f15555af47$exports.getHttpEndpoints = $bc7712f15555af47$var$getHttpEndpoints;
// toncenter single
function $bc7712f15555af47$var$getHttpEndpoint(config) {
    return $bc7712f15555af47$var$__awaiter(this, void 0, void 0, function() {
        var endpoints;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $bc7712f15555af47$var$getHttpEndpoints(config, true)
                    ];
                case 1:
                    endpoints = _state.sent();
                    return [
                        2,
                        endpoints[0]
                    ];
            }
        });
    });
}
$bc7712f15555af47$exports.getHttpEndpoint = $bc7712f15555af47$var$getHttpEndpoint;
// // API V4 - multi
function $bc7712f15555af47$var$getHttpV4Endpoints(config, single) {
    return $bc7712f15555af47$var$__awaiter(this, void 0, void 0, function() {
        var network, suffix;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    network = (config === null || config === void 0 ? void 0 : config.network) ? config.network : "mainnet";
                    if ((config === null || config === void 0 ? void 0 : config.protocol) === "json-rpc") throw Error("config.protocol json-rpc is not supported for getTonApiV4Endpoints");
                    suffix = ""; // this is like rest - default
                    return [
                        4,
                        $bc7712f15555af47$var$getEndpoints(network, "ton-api-v4", suffix, single)
                    ];
                case 1:
                    // other networks than mainnet are not supported
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
}
$bc7712f15555af47$exports.getHttpV4Endpoints = $bc7712f15555af47$var$getHttpV4Endpoints;
// API V4 - single
function $bc7712f15555af47$var$getHttpV4Endpoint(config) {
    return $bc7712f15555af47$var$__awaiter(this, void 0, void 0, function() {
        var endpoints;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $bc7712f15555af47$var$getHttpV4Endpoints(config, true)
                    ];
                case 1:
                    endpoints = _state.sent();
                    return [
                        2,
                        endpoints[0]
                    ];
            }
        });
    });
}
$bc7712f15555af47$exports.getHttpV4Endpoint = $bc7712f15555af47$var$getHttpV4Endpoint; // // WS ADNL PROXY
 // export async function getAdnlProxyEndpoints(): Promise<string[]> {
 //   return [
 //     //"ws://ton-http-2:30001"
 //     "ws://18.221.31.187:30001",
 //     //"ws://3.140.253.61:30001",
 //   ];
 // }
 // export async function getAdnlProxyEndpoint(): Promise<string> {
 //   const endpoints = await getAdnlProxyEndpoints();
 //   const index = Math.floor(Math.random() * endpoints.length);
 //   return endpoints[index];
 // }
 // import { initLiteClient } from "./debug";
 // async function dbg() {
 //   // const eps = await getHttpEndpoint();
 //   // console.log(eps);
 //   const SUM = 100;
 //   const config: Config = {
 //     network: 'mainnet'
 //   }
 //   const counter: any = {};
 //   for (let i = 0; i < SUM; ++i) {
 //     const res = await getHttpEndpoint(config);
 //     if (!counter[res])
 //       counter[res] = 0;
 //     counter[res] += 1;
 //   }
 // }


var $85ce7c9ef04f45be$var$CustomTonNetwork = /*#__PURE__*/ function() {
    function CustomTonNetwork(walletKeyProvider, apiV2Config) {
        (0, $978gY._)(this, CustomTonNetwork);
        this.walletKeyProvider = walletKeyProvider;
        this.apiV2Config = apiV2Config;
        this.workchain = 0;
    }
    (0, $kry2a._)(CustomTonNetwork, [
        {
            key: "setUp",
            value: function setUp() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var walletKey, endpoint, wallet;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                walletKey = _this.walletKeyProvider();
                                (0, $85ce7c9ef04f45be$var$assert_1.default)(walletKey, "Wallet key is undefined!");
                                return [
                                    4,
                                    (0, $bc7712f15555af47$exports.getHttpV4Endpoint)({
                                        network: "testnet"
                                    })
                                ];
                            case 1:
                                endpoint = _state.sent();
                                wallet = $89095f30c08601be$exports.WalletContractV4.create({
                                    publicKey: walletKey.publicKey,
                                    workchain: 0
                                });
                                _this.api = new $89095f30c08601be$exports.TonClient4({
                                    endpoint: endpoint
                                });
                                _this.oldApi = new $89095f30c08601be$exports.TonClient({
                                    endpoint: _this.apiV2Config.apiEndpoint,
                                    apiKey: _this.apiV2Config.apiKey
                                });
                                _this.walletContract = _this.oldApi.open(wallet);
                                _this.sender = _this.walletContract.sender(walletKey.secretKey);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isContractDeployed",
            value: function isContractDeployed(address) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var seqno;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.walletContract.getSeqno()
                                ];
                            case 1:
                                seqno = _state.sent();
                                return [
                                    2,
                                    address == undefined || _this.api.isContractDeployed(seqno, address)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "open",
            value: function open(contract) {
                return this.api.open(contract);
            }
        }
    ]);
    return CustomTonNetwork;
}();
$85ce7c9ef04f45be$exports.CustomTonNetwork = $85ce7c9ef04f45be$var$CustomTonNetwork;


Object.defineProperty($264417ac072da6c0$exports, "CustomTonNetwork", {
    enumerable: true,
    get: function get() {
        return $85ce7c9ef04f45be$exports.CustomTonNetwork;
    }
});
var $3392b70b537a1859$exports = {};

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");
"use strict";
Object.defineProperty($3392b70b537a1859$exports, "__esModule", {
    value: true
});
$3392b70b537a1859$exports.BlueprintTonNetwork = void 0;

var $3392b70b537a1859$var$BlueprintTonNetwork = /*#__PURE__*/ function() {
    function BlueprintTonNetwork(networkProvider, apiV2Config) {
        (0, $978gY._)(this, BlueprintTonNetwork);
        this.networkProvider = networkProvider;
        this.oldApi = new $89095f30c08601be$exports.TonClient({
            endpoint: apiV2Config.apiEndpoint,
            apiKey: apiV2Config.apiKey
        });
        this.sender = networkProvider.sender();
        this.api = networkProvider.api();
        this.workchain = networkProvider.network() == "testnet" ? 0 : -1;
    }
    (0, $kry2a._)(BlueprintTonNetwork, [
        {
            key: "open",
            value: function open(contract) {
                return this.networkProvider.open(contract);
            }
        },
        {
            key: "isContractDeployed",
            value: function isContractDeployed(address) {
                return this.networkProvider.isContractDeployed(address);
            }
        },
        {
            key: "setUp",
            value: function setUp() {
            // nop;
            }
        }
    ]);
    return BlueprintTonNetwork;
}();
$3392b70b537a1859$exports.BlueprintTonNetwork = $3392b70b537a1859$var$BlueprintTonNetwork;


Object.defineProperty($264417ac072da6c0$exports, "BlueprintTonNetwork", {
    enumerable: true,
    get: function get() {
        return $3392b70b537a1859$exports.BlueprintTonNetwork;
    }
});


var $54a124268115b59d$export$5b1ba13b9c7543b3 = function(param) {
    var props = param.props, network = param.network;
    var _tonNetwork_walletContract, _tonNetwork_walletContract_address;
    var prices = props.prices, setPrices = props.setPrices, walletKey = props.walletKey;
    var _useMockLoader = (0, $ae7f937efe139789$export$3ca8f5b83ba7703a)(), text = _useMockLoader.text, isMockLoading = _useMockLoader.isMockLoading, setIsMockLoading = _useMockLoader.setIsMockLoading, startMockLoader = _useMockLoader.startMockLoader;
    var tonNetwork = new (0, $264417ac072da6c0$exports.CustomTonNetwork)(function() {
        return walletKey;
    }, {
        apiEndpoint: network.rpcUrls[0],
        apiKey: "77ba5e98180cc611874f81863522518a961fa1bd38b846648cfd90935b28b6b6"
    });
    var connector = new (0, $264417ac072da6c0$exports.TonPricesContractConnector)(tonNetwork, network.exampleContractAddress);
    var _usePricesContract = (0, $753cc36948ba3c23$export$37ebad50d75f51b)(network, connector, startMockLoader, setPrices, setIsMockLoading), blockNumber = _usePricesContract.blockNumber, txHash = _usePricesContract.txHash, timestamp = _usePricesContract.timestamp, isLoading = _usePricesContract.isLoading, getPricesFromPayload = _usePricesContract.getPricesFromPayload, readPricesFromContract = _usePricesContract.readPricesFromContract, writePricesToContract = _usePricesContract.writePricesToContract, errorMessage = _usePricesContract.errorMessage, setErrorMessage = _usePricesContract.setErrorMessage;
    var arePrices = Object.values(prices).every(function(price) {
        return !!price;
    });
    var _tonNetwork_walletContract_address_toString;
    return !walletKey ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
        className: "mt-10 mb-0 text-lg text-center",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                children: "Please sign in to TON"
            }),
            false
        ]
    }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex w-full justify-center items-center mt-8 flex-col",
        children: [
            network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d0adf8410d59fd78$export$f34f01f5ad9bfa8), {
                walletAddress: (_tonNetwork_walletContract_address_toString = (_tonNetwork_walletContract = tonNetwork.walletContract) === null || _tonNetwork_walletContract === void 0 ? void 0 : (_tonNetwork_walletContract_address = _tonNetwork_walletContract.address) === null || _tonNetwork_walletContract_address === void 0 ? void 0 : _tonNetwork_walletContract_address.toString()) !== null && _tonNetwork_walletContract_address_toString !== void 0 ? _tonNetwork_walletContract_address_toString : "",
                network: network
            }),
            isMockLoading || isLoading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $400629623ad58cec$export$f39eb86f0e5c1a78), {
                text: isMockLoading ? text : ""
            }) : [
                arePrices && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $29fbb8d85bb99ed5$export$d877cf1ea46d4d85), {
                    blockNumber: blockNumber,
                    timestamp: timestamp,
                    prices: prices
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "flex gap-3",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1f09082810955268$export$a6bbb1b7f40755b9), {
                            writePricesToContract: writePricesToContract
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $291736910945f543$export$30ee6dea872700fe), {
                            readPricesFromContract: readPricesFromContract
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1a9f66f6ca0bed1$export$d38cca4e3d3fe8c0), {
                            getPriceFromContract: getPricesFromPayload
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: "px-6 py-3 text-sm w-3/5 text-center text-gray-500",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("i", {
                        children: [
                            "To ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                children: "interact with the contract"
                            }),
                            " you should have ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                children: "TON"
                            }),
                            " be added to the wallet ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                            " by using",
                            " ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                    target: "_blank",
                                    href: "https://t.me/testgiver_ton_bot",
                                    children: "https://t.me/testgiver_ton_bot"
                                })
                            })
                        ]
                    })
                }),
                network && txHash && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $72f10b3fcf20060f$export$d22914518d6cfe65), {
                    txHash: txHash,
                    network: network
                })
            ],
            !!errorMessage && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b76a4ff75d0d9de2$export$2e2bcd8739ae039), {
                closeModal: function() {
                    return setErrorMessage("");
                },
                title: "Problem with contract interaction",
                text: errorMessage
            })
        ]
    });
};



var $6cds3 = parcelRequire("6cds3");
var $05f234adb52dd49e$var$chainsArray = Object.values((0, $050990180fbd2df8$export$af1c0561ce3e4019));
var $05f234adb52dd49e$export$9d4b6b226bc0829 = function() {
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)(null), 2), network = _useState[0], setNetwork = _useState[1];
    var evm = (0, $6d74eea438614f0e$export$69804ca079d47f29)(setNetwork);
    var starknet = (0, $855eec528252b37a$export$5359a20ca62641f)();
    var fuel = (0, $b14ef06c18b39435$export$df32fb2fcf7bb0ad)();
    var ton = (0, $21d44163128ce59b$export$5d23921e368fe5ce)();
    var onChainClick = function() {
        var _ref = (0, $byzP8._)(function(chain) {
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setNetwork(chain);
                        if (!(((chain === null || chain === void 0 ? void 0 : chain.type) || "eth") === "eth")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            evm.connectWallet(chain)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        if (!((chain === null || chain === void 0 ? void 0 : chain.type) === "starknet")) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            starknet.connectWallet()
                        ];
                    case 3:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 4:
                        if (!((chain === null || chain === void 0 ? void 0 : chain.type) === "fuel")) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            fuel.connectWallet()
                        ];
                    case 5:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 6:
                        if (!(chain.type === "ton")) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            ton.connectWallet()
                        ];
                    case 7:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function onChainClick(chain) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex justify-center items-center flex-col",
        children: [
            !network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: "mb-10 text-lg font-bold",
                children: "Please select a chain-button to integrate your wallet:"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "w-3/5 flex flex-wrap justify-center gap-3 px-10",
                children: $05f234adb52dd49e$var$chainsArray.map(function(ch) {
                    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $894a8d90f8ca8f9d$export$179a2d4534d0f37d), {
                        chain: ch,
                        network: network,
                        onChainClick: onChainClick,
                        disabled: false
                    }, ch.chainId);
                })
            }),
            ((network === null || network === void 0 ? void 0 : network.type) || "eth") === "eth" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $bd9f40d2e954ba14$export$79fa1f4c2d188e01), {
                props: (0, $8OnJk._)({}, evm),
                network: network
            }),
            (network === null || network === void 0 ? void 0 : network.type) === "starknet" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $aca49255d66f39fc$export$6d4e842c29c48185), {
                props: (0, $8OnJk._)({}, starknet),
                network: network
            }),
            (network === null || network === void 0 ? void 0 : network.type) === "fuel" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a7ed98d96e18cc00$export$7719fe4539765461), {
                props: (0, $8OnJk._)({}, fuel),
                network: network
            }),
            (network === null || network === void 0 ? void 0 : network.type) === "ton" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $54a124268115b59d$export$5b1ba13b9c7543b3), {
                props: (0, $8OnJk._)({}, ton),
                network: network
            })
        ]
    });
};


var $18cb66d1e7a58135$var$App = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex flex-col h-full bg-neutral-100 overflow-auto",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ca9b163af4bfc596$export$8b251419efc915eb), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "mb-5",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $05f234adb52dd49e$export$9d4b6b226bc0829), {})
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1d10e2dedeefcec7$export$a06f1c675e846f6f), {})
        ]
    });
};
var $18cb66d1e7a58135$export$2e2bcd8739ae039 = $18cb66d1e7a58135$var$App;



(0, (/*@__PURE__*/$parcel$interopDefault($64d0b1ebdd6bcffe$exports))).createRoot(document.getElementById("root")).render(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).StrictMode, {
    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $18cb66d1e7a58135$export$2e2bcd8739ae039), {})
}));

})();
//# sourceMappingURL=index.2ba9adf8.js.map
